webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var platform_browser_dynamic_1 = __webpack_require__(244);
	var app_module_1 = __webpack_require__(248);
	__webpack_require__(2604);
	if (true) {
	    core_1.enableProdMode();
	}
	/*
	 * Bootstrap Angular app with a top level component `App` and inject
	 * Services and Providers into Angular's dependency injection
	 */
	function main() {
	    return platform_browser_dynamic_1.platformBrowserDynamic()
	        .bootstrapModule(app_module_1.AppModule)
	        .then(function () { return console.info('Client app stated.'); })
	        .catch(function (err) { return console.error(err); });
	}
	exports.main = main;
	// bootstrap when document is ready
	document.addEventListener('DOMContentLoaded', function () { return main(); });


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var platform_browser_1 = __webpack_require__(247);
	var animations_1 = __webpack_require__(249);
	var core_2 = __webpack_require__(252);
	var notification_1 = __webpack_require__(264);
	var app_component_1 = __webpack_require__(299);
	var app_router_1 = __webpack_require__(735);
	var error_1 = __webpack_require__(2599);
	var http_1 = __webpack_require__(900);
	var security_1 = __webpack_require__(736);
	var translate_1 = __webpack_require__(300);
	var menu_1 = __webpack_require__(878);
	var menu_resizer_component_1 = __webpack_require__(2602);
	var shared_1 = __webpack_require__(918);
	var capitalize_pipe_1 = __webpack_require__(1250);
	var shared_2 = __webpack_require__(1469);
	var form_field_1 = __webpack_require__(1305);
	var select_1 = __webpack_require__(1311);
	var input_1 = __webpack_require__(1312);
	var chips_1 = __webpack_require__(1303);
	var icon_1 = __webpack_require__(1306);
	var autocomplete_1 = __webpack_require__(1307);
	var roles_guard_1 = __webpack_require__(856);
	var AppModule = (function () {
	    function AppModule() {
	    }
	    AppModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                platform_browser_1.BrowserModule,
	                core_2.TranslateModule.forRoot(translate_1.TRANSLATE_LOADER_PROVIDER),
	                http_1.DashboardHttpModule,
	                animations_1.BrowserAnimationsModule,
	                animations_1.NoopAnimationsModule,
	                shared_1.SharedModule.forRoot(),
	                app_router_1.ROUTER,
	                http_1.BOHttpModule,
	                shared_2.CustomerProfilesSharedModule,
	                form_field_1.MatFormFieldModule,
	                select_1.MatSelectModule,
	                input_1.MatInputModule,
	                chips_1.MatChipsModule,
	                icon_1.MatIconModule,
	                autocomplete_1.MatAutocompleteModule
	            ],
	            providers: [
	                notification_1.NotificationManager,
	                translate_1.TranslateManager
	            ].concat(error_1.ERROR_PROVIDERS, security_1.SESSION_SECURITY_PROVIDERS, [
	                roles_guard_1.RolesGuard
	            ], roles_guard_1.RolesGuard.guards, [
	                capitalize_pipe_1.CapitalizePipe
	            ]),
	            declarations: app_router_1.ROUTER_COMPONENTS.concat([
	                app_component_1.AppComponent,
	                menu_resizer_component_1.MenuResizer,
	                menu_1.MenuIcon
	            ]),
	            bootstrap: [app_component_1.AppComponent]
	        })
	    ], AppModule);
	    return AppModule;
	}());
	exports.AppModule = AppModule;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(247), __webpack_require__(250), __webpack_require__(251)) :
		typeof define === 'function' && define.amd ? define('@angular/platform-browser/animations', ['exports', '@angular/core', '@angular/platform-browser', '@angular/animations', '@angular/animations/browser'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.platformBrowser = global.ng.platformBrowser || {}, global.ng.platformBrowser.animations = {}),global.ng.core,global.ng.platformBrowser,global.ng.animations,global.ng.animations.browser));
	}(this, (function (exports,_angular_core,_angular_platformBrowser,_angular_animations,_angular_animations_browser) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var BrowserAnimationBuilder = /** @class */ (function (_super) {
	    __extends(BrowserAnimationBuilder, _super);
	    function BrowserAnimationBuilder(rootRenderer, doc) {
	        var _this = _super.call(this) || this;
	        _this._nextAnimationId = 0;
	        var /** @type {?} */ typeData = /** @type {?} */ ({
	            id: '0',
	            encapsulation: _angular_core.ViewEncapsulation.None,
	            styles: [],
	            data: { animation: [] }
	        });
	        _this._renderer = /** @type {?} */ (rootRenderer.createRenderer(doc.body, typeData));
	        return _this;
	    }
	    /**
	     * @param {?} animation
	     * @return {?}
	     */
	    BrowserAnimationBuilder.prototype.build = /**
	     * @param {?} animation
	     * @return {?}
	     */
	    function (animation) {
	        var /** @type {?} */ id = this._nextAnimationId.toString();
	        this._nextAnimationId++;
	        var /** @type {?} */ entry = Array.isArray(animation) ? _angular_animations.sequence(animation) : animation;
	        issueAnimationCommand(this._renderer, null, id, 'register', [entry]);
	        return new BrowserAnimationFactory(id, this._renderer);
	    };
	    BrowserAnimationBuilder.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    BrowserAnimationBuilder.ctorParameters = function () { return [
	        { type: _angular_core.RendererFactory2, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_platformBrowser.DOCUMENT,] },] },
	    ]; };
	    return BrowserAnimationBuilder;
	}(_angular_animations.AnimationBuilder));
	var BrowserAnimationFactory = /** @class */ (function (_super) {
	    __extends(BrowserAnimationFactory, _super);
	    function BrowserAnimationFactory(_id, _renderer) {
	        var _this = _super.call(this) || this;
	        _this._id = _id;
	        _this._renderer = _renderer;
	        return _this;
	    }
	    /**
	     * @param {?} element
	     * @param {?=} options
	     * @return {?}
	     */
	    BrowserAnimationFactory.prototype.create = /**
	     * @param {?} element
	     * @param {?=} options
	     * @return {?}
	     */
	    function (element, options) {
	        return new RendererAnimationPlayer(this._id, element, options || {}, this._renderer);
	    };
	    return BrowserAnimationFactory;
	}(_angular_animations.AnimationFactory));
	var RendererAnimationPlayer = /** @class */ (function () {
	    function RendererAnimationPlayer(id, element, options, _renderer) {
	        this.id = id;
	        this.element = element;
	        this._renderer = _renderer;
	        this.parentPlayer = null;
	        this._started = false;
	        this.totalTime = 0;
	        this._command('create', options);
	    }
	    /**
	     * @param {?} eventName
	     * @param {?} callback
	     * @return {?}
	     */
	    RendererAnimationPlayer.prototype._listen = /**
	     * @param {?} eventName
	     * @param {?} callback
	     * @return {?}
	     */
	    function (eventName, callback) {
	        return this._renderer.listen(this.element, "@@" + this.id + ":" + eventName, callback);
	    };
	    /**
	     * @param {?} command
	     * @param {...?} args
	     * @return {?}
	     */
	    RendererAnimationPlayer.prototype._command = /**
	     * @param {?} command
	     * @param {...?} args
	     * @return {?}
	     */
	    function (command) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        return issueAnimationCommand(this._renderer, this.element, this.id, command, args);
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    RendererAnimationPlayer.prototype.onDone = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this._listen('done', fn); };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    RendererAnimationPlayer.prototype.onStart = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this._listen('start', fn); };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    RendererAnimationPlayer.prototype.onDestroy = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this._listen('destroy', fn); };
	    /**
	     * @return {?}
	     */
	    RendererAnimationPlayer.prototype.init = /**
	     * @return {?}
	     */
	    function () { this._command('init'); };
	    /**
	     * @return {?}
	     */
	    RendererAnimationPlayer.prototype.hasStarted = /**
	     * @return {?}
	     */
	    function () { return this._started; };
	    /**
	     * @return {?}
	     */
	    RendererAnimationPlayer.prototype.play = /**
	     * @return {?}
	     */
	    function () {
	        this._command('play');
	        this._started = true;
	    };
	    /**
	     * @return {?}
	     */
	    RendererAnimationPlayer.prototype.pause = /**
	     * @return {?}
	     */
	    function () { this._command('pause'); };
	    /**
	     * @return {?}
	     */
	    RendererAnimationPlayer.prototype.restart = /**
	     * @return {?}
	     */
	    function () { this._command('restart'); };
	    /**
	     * @return {?}
	     */
	    RendererAnimationPlayer.prototype.finish = /**
	     * @return {?}
	     */
	    function () { this._command('finish'); };
	    /**
	     * @return {?}
	     */
	    RendererAnimationPlayer.prototype.destroy = /**
	     * @return {?}
	     */
	    function () { this._command('destroy'); };
	    /**
	     * @return {?}
	     */
	    RendererAnimationPlayer.prototype.reset = /**
	     * @return {?}
	     */
	    function () { this._command('reset'); };
	    /**
	     * @param {?} p
	     * @return {?}
	     */
	    RendererAnimationPlayer.prototype.setPosition = /**
	     * @param {?} p
	     * @return {?}
	     */
	    function (p) { this._command('setPosition', p); };
	    /**
	     * @return {?}
	     */
	    RendererAnimationPlayer.prototype.getPosition = /**
	     * @return {?}
	     */
	    function () { return 0; };
	    return RendererAnimationPlayer;
	}());
	/**
	 * @param {?} renderer
	 * @param {?} element
	 * @param {?} id
	 * @param {?} command
	 * @param {?} args
	 * @return {?}
	 */
	function issueAnimationCommand(renderer, element, id, command, args) {
	    return renderer.setProperty(element, "@@" + id + ":" + command, args);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var ANIMATION_PREFIX = '@';
	var DISABLE_ANIMATIONS_FLAG = '@.disabled';
	var AnimationRendererFactory = /** @class */ (function () {
	    function AnimationRendererFactory(delegate, engine, _zone) {
	        this.delegate = delegate;
	        this.engine = engine;
	        this._zone = _zone;
	        this._currentId = 0;
	        this._microtaskId = 1;
	        this._animationCallbacksBuffer = [];
	        this._rendererCache = new Map();
	        this._cdRecurDepth = 0;
	        this.promise = Promise.resolve(0);
	        engine.onRemovalComplete = function (element, delegate) {
	            // Note: if an component element has a leave animation, and the component
	            // a host leave animation, the view engine will call `removeChild` for the parent
	            // component renderer as well as for the child component renderer.
	            // Therefore, we need to check if we already removed the element.
	            if (delegate && delegate.parentNode(element)) {
	                delegate.removeChild(element.parentNode, element);
	            }
	        };
	    }
	    /**
	     * @param {?} hostElement
	     * @param {?} type
	     * @return {?}
	     */
	    AnimationRendererFactory.prototype.createRenderer = /**
	     * @param {?} hostElement
	     * @param {?} type
	     * @return {?}
	     */
	    function (hostElement, type) {
	        var _this = this;
	        var /** @type {?} */ EMPTY_NAMESPACE_ID = '';
	        // cache the delegates to find out which cached delegate can
	        // be used by which cached renderer
	        var /** @type {?} */ delegate = this.delegate.createRenderer(hostElement, type);
	        if (!hostElement || !type || !type.data || !type.data['animation']) {
	            var /** @type {?} */ renderer = this._rendererCache.get(delegate);
	            if (!renderer) {
	                renderer = new BaseAnimationRenderer(EMPTY_NAMESPACE_ID, delegate, this.engine);
	                // only cache this result when the base renderer is used
	                this._rendererCache.set(delegate, renderer);
	            }
	            return renderer;
	        }
	        var /** @type {?} */ componentId = type.id;
	        var /** @type {?} */ namespaceId = type.id + '-' + this._currentId;
	        this._currentId++;
	        this.engine.register(namespaceId, hostElement);
	        var /** @type {?} */ animationTriggers = /** @type {?} */ (type.data['animation']);
	        animationTriggers.forEach(function (trigger) {
	            return _this.engine.registerTrigger(componentId, namespaceId, hostElement, trigger.name, trigger);
	        });
	        return new AnimationRenderer(this, namespaceId, delegate, this.engine);
	    };
	    /**
	     * @return {?}
	     */
	    AnimationRendererFactory.prototype.begin = /**
	     * @return {?}
	     */
	    function () {
	        this._cdRecurDepth++;
	        if (this.delegate.begin) {
	            this.delegate.begin();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    AnimationRendererFactory.prototype._scheduleCountTask = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        // always use promise to schedule microtask instead of use Zone
	        this.promise.then(function () { _this._microtaskId++; });
	    };
	    /* @internal */
	    /**
	     * @param {?} count
	     * @param {?} fn
	     * @param {?} data
	     * @return {?}
	     */
	    AnimationRendererFactory.prototype.scheduleListenerCallback = /**
	     * @param {?} count
	     * @param {?} fn
	     * @param {?} data
	     * @return {?}
	     */
	    function (count, fn, data) {
	        var _this = this;
	        if (count >= 0 && count < this._microtaskId) {
	            this._zone.run(function () { return fn(data); });
	            return;
	        }
	        if (this._animationCallbacksBuffer.length == 0) {
	            Promise.resolve(null).then(function () {
	                _this._zone.run(function () {
	                    _this._animationCallbacksBuffer.forEach(function (tuple) {
	                        var fn = tuple[0], data = tuple[1];
	                        fn(data);
	                    });
	                    _this._animationCallbacksBuffer = [];
	                });
	            });
	        }
	        this._animationCallbacksBuffer.push([fn, data]);
	    };
	    /**
	     * @return {?}
	     */
	    AnimationRendererFactory.prototype.end = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._cdRecurDepth--;
	        // this is to prevent animations from running twice when an inner
	        // component does CD when a parent component insted has inserted it
	        if (this._cdRecurDepth == 0) {
	            this._zone.runOutsideAngular(function () {
	                _this._scheduleCountTask();
	                _this.engine.flush(_this._microtaskId);
	            });
	        }
	        if (this.delegate.end) {
	            this.delegate.end();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    AnimationRendererFactory.prototype.whenRenderingDone = /**
	     * @return {?}
	     */
	    function () { return this.engine.whenRenderingDone(); };
	    AnimationRendererFactory.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    AnimationRendererFactory.ctorParameters = function () { return [
	        { type: _angular_core.RendererFactory2, },
	        { type: _angular_animations_browser.ɵAnimationEngine, },
	        { type: _angular_core.NgZone, },
	    ]; };
	    return AnimationRendererFactory;
	}());
	var BaseAnimationRenderer = /** @class */ (function () {
	    function BaseAnimationRenderer(namespaceId, delegate, engine) {
	        this.namespaceId = namespaceId;
	        this.delegate = delegate;
	        this.engine = engine;
	        this.destroyNode = this.delegate.destroyNode ? function (n) { return ((delegate.destroyNode))(n); } : null;
	    }
	    Object.defineProperty(BaseAnimationRenderer.prototype, "data", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.delegate.data; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    BaseAnimationRenderer.prototype.destroy = /**
	     * @return {?}
	     */
	    function () {
	        this.engine.destroy(this.namespaceId, this.delegate);
	        this.delegate.destroy();
	    };
	    /**
	     * @param {?} name
	     * @param {?=} namespace
	     * @return {?}
	     */
	    BaseAnimationRenderer.prototype.createElement = /**
	     * @param {?} name
	     * @param {?=} namespace
	     * @return {?}
	     */
	    function (name, namespace) {
	        return this.delegate.createElement(name, namespace);
	    };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    BaseAnimationRenderer.prototype.createComment = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) { return this.delegate.createComment(value); };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    BaseAnimationRenderer.prototype.createText = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) { return this.delegate.createText(value); };
	    /**
	     * @param {?} parent
	     * @param {?} newChild
	     * @return {?}
	     */
	    BaseAnimationRenderer.prototype.appendChild = /**
	     * @param {?} parent
	     * @param {?} newChild
	     * @return {?}
	     */
	    function (parent, newChild) {
	        this.delegate.appendChild(parent, newChild);
	        this.engine.onInsert(this.namespaceId, newChild, parent, false);
	    };
	    /**
	     * @param {?} parent
	     * @param {?} newChild
	     * @param {?} refChild
	     * @return {?}
	     */
	    BaseAnimationRenderer.prototype.insertBefore = /**
	     * @param {?} parent
	     * @param {?} newChild
	     * @param {?} refChild
	     * @return {?}
	     */
	    function (parent, newChild, refChild) {
	        this.delegate.insertBefore(parent, newChild, refChild);
	        this.engine.onInsert(this.namespaceId, newChild, parent, true);
	    };
	    /**
	     * @param {?} parent
	     * @param {?} oldChild
	     * @return {?}
	     */
	    BaseAnimationRenderer.prototype.removeChild = /**
	     * @param {?} parent
	     * @param {?} oldChild
	     * @return {?}
	     */
	    function (parent, oldChild) {
	        this.engine.onRemove(this.namespaceId, oldChild, this.delegate);
	    };
	    /**
	     * @param {?} selectorOrNode
	     * @return {?}
	     */
	    BaseAnimationRenderer.prototype.selectRootElement = /**
	     * @param {?} selectorOrNode
	     * @return {?}
	     */
	    function (selectorOrNode) { return this.delegate.selectRootElement(selectorOrNode); };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    BaseAnimationRenderer.prototype.parentNode = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) { return this.delegate.parentNode(node); };
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    BaseAnimationRenderer.prototype.nextSibling = /**
	     * @param {?} node
	     * @return {?}
	     */
	    function (node) { return this.delegate.nextSibling(node); };
	    /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?} value
	     * @param {?=} namespace
	     * @return {?}
	     */
	    BaseAnimationRenderer.prototype.setAttribute = /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?} value
	     * @param {?=} namespace
	     * @return {?}
	     */
	    function (el, name, value, namespace) {
	        this.delegate.setAttribute(el, name, value, namespace);
	    };
	    /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?=} namespace
	     * @return {?}
	     */
	    BaseAnimationRenderer.prototype.removeAttribute = /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?=} namespace
	     * @return {?}
	     */
	    function (el, name, namespace) {
	        this.delegate.removeAttribute(el, name, namespace);
	    };
	    /**
	     * @param {?} el
	     * @param {?} name
	     * @return {?}
	     */
	    BaseAnimationRenderer.prototype.addClass = /**
	     * @param {?} el
	     * @param {?} name
	     * @return {?}
	     */
	    function (el, name) { this.delegate.addClass(el, name); };
	    /**
	     * @param {?} el
	     * @param {?} name
	     * @return {?}
	     */
	    BaseAnimationRenderer.prototype.removeClass = /**
	     * @param {?} el
	     * @param {?} name
	     * @return {?}
	     */
	    function (el, name) { this.delegate.removeClass(el, name); };
	    /**
	     * @param {?} el
	     * @param {?} style
	     * @param {?} value
	     * @param {?=} flags
	     * @return {?}
	     */
	    BaseAnimationRenderer.prototype.setStyle = /**
	     * @param {?} el
	     * @param {?} style
	     * @param {?} value
	     * @param {?=} flags
	     * @return {?}
	     */
	    function (el, style, value, flags) {
	        this.delegate.setStyle(el, style, value, flags);
	    };
	    /**
	     * @param {?} el
	     * @param {?} style
	     * @param {?=} flags
	     * @return {?}
	     */
	    BaseAnimationRenderer.prototype.removeStyle = /**
	     * @param {?} el
	     * @param {?} style
	     * @param {?=} flags
	     * @return {?}
	     */
	    function (el, style, flags) {
	        this.delegate.removeStyle(el, style, flags);
	    };
	    /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    BaseAnimationRenderer.prototype.setProperty = /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    function (el, name, value) {
	        if (name.charAt(0) == ANIMATION_PREFIX && name == DISABLE_ANIMATIONS_FLAG) {
	            this.disableAnimations(el, !!value);
	        }
	        else {
	            this.delegate.setProperty(el, name, value);
	        }
	    };
	    /**
	     * @param {?} node
	     * @param {?} value
	     * @return {?}
	     */
	    BaseAnimationRenderer.prototype.setValue = /**
	     * @param {?} node
	     * @param {?} value
	     * @return {?}
	     */
	    function (node, value) { this.delegate.setValue(node, value); };
	    /**
	     * @param {?} target
	     * @param {?} eventName
	     * @param {?} callback
	     * @return {?}
	     */
	    BaseAnimationRenderer.prototype.listen = /**
	     * @param {?} target
	     * @param {?} eventName
	     * @param {?} callback
	     * @return {?}
	     */
	    function (target, eventName, callback) {
	        return this.delegate.listen(target, eventName, callback);
	    };
	    /**
	     * @param {?} element
	     * @param {?} value
	     * @return {?}
	     */
	    BaseAnimationRenderer.prototype.disableAnimations = /**
	     * @param {?} element
	     * @param {?} value
	     * @return {?}
	     */
	    function (element, value) {
	        this.engine.disableAnimations(element, value);
	    };
	    return BaseAnimationRenderer;
	}());
	var AnimationRenderer = /** @class */ (function (_super) {
	    __extends(AnimationRenderer, _super);
	    function AnimationRenderer(factory, namespaceId, delegate, engine) {
	        var _this = _super.call(this, namespaceId, delegate, engine) || this;
	        _this.factory = factory;
	        _this.namespaceId = namespaceId;
	        return _this;
	    }
	    /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    AnimationRenderer.prototype.setProperty = /**
	     * @param {?} el
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    function (el, name, value) {
	        if (name.charAt(0) == ANIMATION_PREFIX) {
	            if (name.charAt(1) == '.' && name == DISABLE_ANIMATIONS_FLAG) {
	                value = value === undefined ? true : !!value;
	                this.disableAnimations(el, /** @type {?} */ (value));
	            }
	            else {
	                this.engine.process(this.namespaceId, el, name.substr(1), value);
	            }
	        }
	        else {
	            this.delegate.setProperty(el, name, value);
	        }
	    };
	    /**
	     * @param {?} target
	     * @param {?} eventName
	     * @param {?} callback
	     * @return {?}
	     */
	    AnimationRenderer.prototype.listen = /**
	     * @param {?} target
	     * @param {?} eventName
	     * @param {?} callback
	     * @return {?}
	     */
	    function (target, eventName, callback) {
	        var _this = this;
	        if (eventName.charAt(0) == ANIMATION_PREFIX) {
	            var /** @type {?} */ element = resolveElementFromTarget(target);
	            var /** @type {?} */ name_1 = eventName.substr(1);
	            var /** @type {?} */ phase = '';
	            // @listener.phase is for trigger animation callbacks
	            // @@listener is for animation builder callbacks
	            if (name_1.charAt(0) != ANIMATION_PREFIX) {
	                _a = parseTriggerCallbackName(name_1), name_1 = _a[0], phase = _a[1];
	            }
	            return this.engine.listen(this.namespaceId, element, name_1, phase, function (event) {
	                var /** @type {?} */ countId = (/** @type {?} */ (event))['_data'] || -1;
	                _this.factory.scheduleListenerCallback(countId, callback, event);
	            });
	        }
	        return this.delegate.listen(target, eventName, callback);
	        var _a;
	    };
	    return AnimationRenderer;
	}(BaseAnimationRenderer));
	/**
	 * @param {?} target
	 * @return {?}
	 */
	function resolveElementFromTarget(target) {
	    switch (target) {
	        case 'body':
	            return document.body;
	        case 'document':
	            return document;
	        case 'window':
	            return window;
	        default:
	            return target;
	    }
	}
	/**
	 * @param {?} triggerName
	 * @return {?}
	 */
	function parseTriggerCallbackName(triggerName) {
	    var /** @type {?} */ dotIndex = triggerName.indexOf('.');
	    var /** @type {?} */ trigger = triggerName.substring(0, dotIndex);
	    var /** @type {?} */ phase = triggerName.substr(dotIndex + 1);
	    return [trigger, phase];
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var InjectableAnimationEngine = /** @class */ (function (_super) {
	    __extends(InjectableAnimationEngine, _super);
	    function InjectableAnimationEngine(driver, normalizer) {
	        return _super.call(this, driver, normalizer) || this;
	    }
	    InjectableAnimationEngine.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    InjectableAnimationEngine.ctorParameters = function () { return [
	        { type: _angular_animations_browser.AnimationDriver, },
	        { type: _angular_animations_browser.ɵAnimationStyleNormalizer, },
	    ]; };
	    return InjectableAnimationEngine;
	}(_angular_animations_browser.ɵAnimationEngine));
	/**
	 * @return {?}
	 */
	function instantiateSupportedAnimationDriver() {
	    if (_angular_animations_browser.ɵsupportsWebAnimations()) {
	        return new _angular_animations_browser.ɵWebAnimationsDriver();
	    }
	    return new _angular_animations_browser.ɵNoopAnimationDriver();
	}
	/**
	 * @return {?}
	 */
	function instantiateDefaultStyleNormalizer() {
	    return new _angular_animations_browser.ɵWebAnimationsStyleNormalizer();
	}
	/**
	 * @param {?} renderer
	 * @param {?} engine
	 * @param {?} zone
	 * @return {?}
	 */
	function instantiateRendererFactory(renderer, engine, zone) {
	    return new AnimationRendererFactory(renderer, engine, zone);
	}
	var SHARED_ANIMATION_PROVIDERS = [
	    { provide: _angular_animations.AnimationBuilder, useClass: BrowserAnimationBuilder },
	    { provide: _angular_animations_browser.ɵAnimationStyleNormalizer, useFactory: instantiateDefaultStyleNormalizer },
	    { provide: _angular_animations_browser.ɵAnimationEngine, useClass: InjectableAnimationEngine }, {
	        provide: _angular_core.RendererFactory2,
	        useFactory: instantiateRendererFactory,
	        deps: [_angular_platformBrowser.ɵDomRendererFactory2, _angular_animations_browser.ɵAnimationEngine, _angular_core.NgZone]
	    }
	];
	/**
	 * Separate providers from the actual module so that we can do a local modification in Google3 to
	 * include them in the BrowserModule.
	 */
	var BROWSER_ANIMATIONS_PROVIDERS = [
	    { provide: _angular_animations_browser.AnimationDriver, useFactory: instantiateSupportedAnimationDriver }
	].concat(SHARED_ANIMATION_PROVIDERS);
	/**
	 * Separate providers from the actual module so that we can do a local modification in Google3 to
	 * include them in the BrowserTestingModule.
	 */
	var BROWSER_NOOP_ANIMATIONS_PROVIDERS = [{ provide: _angular_animations_browser.AnimationDriver, useClass: _angular_animations_browser.ɵNoopAnimationDriver }].concat(SHARED_ANIMATION_PROVIDERS);
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * \@experimental Animation support is experimental.
	 */
	var BrowserAnimationsModule = /** @class */ (function () {
	    function BrowserAnimationsModule() {
	    }
	    BrowserAnimationsModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    exports: [_angular_platformBrowser.BrowserModule],
	                    providers: BROWSER_ANIMATIONS_PROVIDERS,
	                },] },
	    ];
	    /** @nocollapse */
	    BrowserAnimationsModule.ctorParameters = function () { return []; };
	    return BrowserAnimationsModule;
	}());
	/**
	 * \@experimental Animation support is experimental.
	 */
	var NoopAnimationsModule = /** @class */ (function () {
	    function NoopAnimationsModule() {
	    }
	    NoopAnimationsModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    exports: [_angular_platformBrowser.BrowserModule],
	                    providers: BROWSER_NOOP_ANIMATIONS_PROVIDERS,
	                },] },
	    ];
	    /** @nocollapse */
	    NoopAnimationsModule.ctorParameters = function () { return []; };
	    return NoopAnimationsModule;
	}());
	
	exports.BrowserAnimationsModule = BrowserAnimationsModule;
	exports.NoopAnimationsModule = NoopAnimationsModule;
	exports.ɵBrowserAnimationBuilder = BrowserAnimationBuilder;
	exports.ɵBrowserAnimationFactory = BrowserAnimationFactory;
	exports.ɵAnimationRenderer = AnimationRenderer;
	exports.ɵAnimationRendererFactory = AnimationRendererFactory;
	exports.ɵa = BaseAnimationRenderer;
	exports.ɵf = BROWSER_ANIMATIONS_PROVIDERS;
	exports.ɵg = BROWSER_NOOP_ANIMATIONS_PROVIDERS;
	exports.ɵb = InjectableAnimationEngine;
	exports.ɵd = instantiateDefaultStyleNormalizer;
	exports.ɵe = instantiateRendererFactory;
	exports.ɵc = instantiateSupportedAnimationDriver;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=platform-browser-animations.umd.js.map


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define('@angular/animations', ['exports'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.animations = {})));
	}(this, (function (exports) { 'use strict';
	
	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * AnimationBuilder is an injectable service that is available when the {\@link
	 * BrowserAnimationsModule BrowserAnimationsModule} or {\@link NoopAnimationsModule
	 * NoopAnimationsModule} modules are used within an application.
	 *
	 * The purpose if this service is to produce an animation sequence programmatically within an
	 * angular component or directive.
	 *
	 * Programmatic animations are first built and then a player is created when the build animation is
	 * attached to an element.
	 *
	 * ```ts
	 * // remember to include the BrowserAnimationsModule module for this to work...
	 * import {AnimationBuilder} from '\@angular/animations';
	 *
	 * class MyCmp {
	 *   constructor(private _builder: AnimationBuilder) {}
	 *
	 *   makeAnimation(element: any) {
	 *     // first build the animation
	 *     const myAnimation = this._builder.build([
	 *       style({ width: 0 }),
	 *       animate(1000, style({ width: '100px' }))
	 *     ]);
	 *
	 *     // then create a player from it
	 *     const player = myAnimation.create(element);
	 *
	 *     player.play();
	 *   }
	 * }
	 * ```
	 *
	 * When an animation is built an instance of {\@link AnimationFactory AnimationFactory} will be
	 * returned. Using that an {\@link AnimationPlayer AnimationPlayer} can be created which can then be
	 * used to start the animation.
	 *
	 * \@experimental Animation support is experimental.
	 * @abstract
	 */
	var AnimationBuilder = /** @class */ (function () {
	    function AnimationBuilder() {
	    }
	    return AnimationBuilder;
	}());
	/**
	 * An instance of `AnimationFactory` is returned from {\@link AnimationBuilder#build
	 * AnimationBuilder.build}.
	 *
	 * \@experimental Animation support is experimental.
	 * @abstract
	 */
	var AnimationFactory = /** @class */ (function () {
	    function AnimationFactory() {
	    }
	    return AnimationFactory;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 * @record
	 */
	
	/**
	 * \@experimental Animation support is experimental.
	 */
	var AUTO_STYLE = '*';
	/**
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link trigger trigger animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link state state animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link transition transition animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link keyframes keyframes animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link style style animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link animate animate animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link animateChild animateChild animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link useAnimation useAnimation animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link sequence sequence animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link group group animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * Metadata representing the entry of animations. Instances of this interface are provided via the
	 * animation DSL when the {\@link stagger stagger animation function} is called.
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * `trigger` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. If this information is new, please navigate to the
	 * {\@link Component#animations component animations metadata page} to gain a better
	 * understanding of how animations in Angular are used.
	 *
	 * `trigger` Creates an animation trigger which will a list of {\@link state state} and
	 * {\@link transition transition} entries that will be evaluated when the expression
	 * bound to the trigger changes.
	 *
	 * Triggers are registered within the component annotation data under the
	 * {\@link Component#animations animations section}. An animation trigger can be placed on an element
	 * within a template by referencing the name of the trigger followed by the expression value that
	 * the
	 * trigger is bound to (in the form of `[\@triggerName]="expression"`.
	 *
	 * Animation trigger bindings strigify values and then match the previous and current values against
	 * any linked transitions. If a boolean value is provided into the trigger binding then it will both
	 * be represented as `1` or `true` and `0` or `false` for a true and false boolean values
	 * respectively.
	 *
	 * ### Usage
	 *
	 * `trigger` will create an animation trigger reference based on the provided `name` value. The
	 * provided `animation` value is expected to be an array consisting of {\@link state state} and
	 * {\@link transition transition} declarations.
	 *
	 * ```typescript
	 * \@Component({
	 *   selector: 'my-component',
	 *   templateUrl: 'my-component-tpl.html',
	 *   animations: [
	 *     trigger("myAnimationTrigger", [
	 *       state(...),
	 *       state(...),
	 *       transition(...),
	 *       transition(...)
	 *     ])
	 *   ]
	 * })
	 * class MyComponent {
	 *   myStatusExp = "something";
	 * }
	 * ```
	 *
	 * The template associated with this component will make use of the `myAnimationTrigger` animation
	 * trigger by binding to an element within its template code.
	 *
	 * ```html
	 * <!-- somewhere inside of my-component-tpl.html -->
	 * <div [\@myAnimationTrigger]="myStatusExp">...</div>
	 * ```
	 *
	 * ## Disable Animations
	 * A special animation control binding called `\@.disabled` can be placed on an element which will
	 * then disable animations for any inner animation triggers situated within the element as well as
	 * any animations on the element itself.
	 *
	 * When true, the `\@.disabled` binding will prevent all animations from rendering. The example
	 * below shows how to use this feature:
	 *
	 * ```ts
	 * \@Component({
	 *   selector: 'my-component',
	 *   template: `
	 *     <div [\@.disabled]="isDisabled">
	 *       <div [\@childAnimation]="exp"></div>
	 *     </div>
	 *   `,
	 *   animations: [
	 *     trigger("childAnimation", [
	 *       // ...
	 *     ])
	 *   ]
	 * })
	 * class MyComponent {
	 *   isDisabled = true;
	 *   exp = '...';
	 * }
	 * ```
	 *
	 * The `\@childAnimation` trigger will not animate because `\@.disabled` prevents it from happening
	 * (when true).
	 *
	 * Note that `\@.disabled` will only disable all animations (this means any animations running on
	 * the same element will also be disabled).
	 *
	 * ### Disabling Animations Application-wide
	 * When an area of the template is set to have animations disabled, **all** inner components will
	 * also have their animations disabled as well. This means that all animations for an angular
	 * application can be disabled by placing a host binding set on `\@.disabled` on the topmost Angular
	 * component.
	 *
	 * ```ts
	 * import {Component, HostBinding} from '\@angular/core';
	 *
	 * \@Component({
	 *   selector: 'app-component',
	 *   templateUrl: 'app.component.html',
	 * })
	 * class AppComponent {
	 *   \@HostBinding('\@.disabled')
	 *   public animationsDisabled = true;
	 * }
	 * ```
	 *
	 * ### What about animations that us `query()` and `animateChild()`?
	 * Despite inner animations being disabled, a parent animation can {\@link query query} for inner
	 * elements located in disabled areas of the template and still animate them as it sees fit. This is
	 * also the case for when a sub animation is queried by a parent and then later animated using {\@link
	 * animateChild animateChild}.
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} name
	 * @param {?} definitions
	 * @return {?}
	 */
	function trigger(name, definitions) {
	    return { type: 7 /* Trigger */, name: name, definitions: definitions, options: {} };
	}
	/**
	 * `animate` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. If this information is new, please navigate to the {\@link
	 * Component#animations component animations metadata page} to gain a better understanding of
	 * how animations in Angular are used.
	 *
	 * `animate` specifies an animation step that will apply the provided `styles` data for a given
	 * amount of time based on the provided `timing` expression value. Calls to `animate` are expected
	 * to be used within {\@link sequence an animation sequence}, {\@link group group}, or {\@link
	 * transition transition}.
	 *
	 * ### Usage
	 *
	 * The `animate` function accepts two input parameters: `timing` and `styles`:
	 *
	 * - `timing` is a string based value that can be a combination of a duration with optional delay
	 * and easing values. The format for the expression breaks down to `duration delay easing`
	 * (therefore a value such as `1s 100ms ease-out` will be parse itself into `duration=1000,
	 * delay=100, easing=ease-out`. If a numeric value is provided then that will be used as the
	 * `duration` value in millisecond form.
	 * - `styles` is the style input data which can either be a call to {\@link style style} or {\@link
	 * keyframes keyframes}. If left empty then the styles from the destination state will be collected
	 * and used (this is useful when describing an animation step that will complete an animation by
	 * {\@link transition#the-final-animate-call animating to the final state}).
	 *
	 * ```typescript
	 * // various functions for specifying timing data
	 * animate(500, style(...))
	 * animate("1s", style(...))
	 * animate("100ms 0.5s", style(...))
	 * animate("5s ease", style(...))
	 * animate("5s 10ms cubic-bezier(.17,.67,.88,.1)", style(...))
	 *
	 * // either style() of keyframes() can be used
	 * animate(500, style({ background: "red" }))
	 * animate(500, keyframes([
	 *   style({ background: "blue" })),
	 *   style({ background: "red" }))
	 * ])
	 * ```
	 *
	 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} timings
	 * @param {?=} styles
	 * @return {?}
	 */
	function animate(timings, styles) {
	    if (styles === void 0) { styles = null; }
	    return { type: 4 /* Animate */, styles: styles, timings: timings };
	}
	/**
	 * `group` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. If this information is new, please navigate to the {\@link
	 * Component#animations component animations metadata page} to gain a better understanding of
	 * how animations in Angular are used.
	 *
	 * `group` specifies a list of animation steps that are all run in parallel. Grouped animations are
	 * useful when a series of styles must be animated/closed off at different starting/ending times.
	 *
	 * The `group` function can either be used within a {\@link sequence sequence} or a {\@link transition
	 * transition} and it will only continue to the next instruction once all of the inner animation
	 * steps have completed.
	 *
	 * ### Usage
	 *
	 * The `steps` data that is passed into the `group` animation function can either consist of {\@link
	 * style style} or {\@link animate animate} function calls. Each call to `style()` or `animate()`
	 * within a group will be executed instantly (use {\@link keyframes keyframes} or a {\@link
	 * animate#usage animate() with a delay value} to offset styles to be applied at a later time).
	 *
	 * ```typescript
	 * group([
	 *   animate("1s", { background: "black" }))
	 *   animate("2s", { color: "white" }))
	 * ])
	 * ```
	 *
	 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} steps
	 * @param {?=} options
	 * @return {?}
	 */
	function group(steps, options) {
	    if (options === void 0) { options = null; }
	    return { type: 3 /* Group */, steps: steps, options: options };
	}
	/**
	 * `sequence` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. If this information is new, please navigate to the {\@link
	 * Component#animations component animations metadata page} to gain a better understanding of
	 * how animations in Angular are used.
	 *
	 * `sequence` Specifies a list of animation steps that are run one by one. (`sequence` is used by
	 * default when an array is passed as animation data into {\@link transition transition}.)
	 *
	 * The `sequence` function can either be used within a {\@link group group} or a {\@link transition
	 * transition} and it will only continue to the next instruction once each of the inner animation
	 * steps have completed.
	 *
	 * To perform animation styling in parallel with other animation steps then have a look at the
	 * {\@link group group} animation function.
	 *
	 * ### Usage
	 *
	 * The `steps` data that is passed into the `sequence` animation function can either consist of
	 * {\@link style style} or {\@link animate animate} function calls. A call to `style()` will apply the
	 * provided styling data immediately while a call to `animate()` will apply its styling data over a
	 * given time depending on its timing data.
	 *
	 * ```typescript
	 * sequence([
	 *   style({ opacity: 0 })),
	 *   animate("1s", { opacity: 1 }))
	 * ])
	 * ```
	 *
	 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} steps
	 * @param {?=} options
	 * @return {?}
	 */
	function sequence(steps, options) {
	    if (options === void 0) { options = null; }
	    return { type: 2 /* Sequence */, steps: steps, options: options };
	}
	/**
	 * `style` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. If this information is new, please navigate to the {\@link
	 * Component#animations component animations metadata page} to gain a better understanding of
	 * how animations in Angular are used.
	 *
	 * `style` declares a key/value object containing CSS properties/styles that can then be used for
	 * {\@link state animation states}, within an {\@link sequence animation sequence}, or as styling data
	 * for both {\@link animate animate} and {\@link keyframes keyframes}.
	 *
	 * ### Usage
	 *
	 * `style` takes in a key/value string map as data and expects one or more CSS property/value pairs
	 * to be defined.
	 *
	 * ```typescript
	 * // string values are used for css properties
	 * style({ background: "red", color: "blue" })
	 *
	 * // numerical (pixel) values are also supported
	 * style({ width: 100, height: 0 })
	 * ```
	 *
	 * #### Auto-styles (using `*`)
	 *
	 * When an asterix (`*`) character is used as a value then it will be detected from the element
	 * being animated and applied as animation data when the animation starts.
	 *
	 * This feature proves useful for a state depending on layout and/or environment factors; in such
	 * cases the styles are calculated just before the animation starts.
	 *
	 * ```typescript
	 * // the steps below will animate from 0 to the
	 * // actual height of the element
	 * style({ height: 0 }),
	 * animate("1s", style({ height: "*" }))
	 * ```
	 *
	 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} tokens
	 * @return {?}
	 */
	function style(tokens) {
	    return { type: 6 /* Style */, styles: tokens, offset: null };
	}
	/**
	 * `state` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. If this information is new, please navigate to the {\@link
	 * Component#animations component animations metadata page} to gain a better understanding of
	 * how animations in Angular are used.
	 *
	 * `state` declares an animation state within the given trigger. When a state is active within a
	 * component then its associated styles will persist on the element that the trigger is attached to
	 * (even when the animation ends).
	 *
	 * To animate between states, have a look at the animation {\@link transition transition} DSL
	 * function. To register states to an animation trigger please have a look at the {\@link trigger
	 * trigger} function.
	 *
	 * #### The `void` state
	 *
	 * The `void` state value is a reserved word that angular uses to determine when the element is not
	 * apart of the application anymore (e.g. when an `ngIf` evaluates to false then the state of the
	 * associated element is void).
	 *
	 * #### The `*` (default) state
	 *
	 * The `*` state (when styled) is a fallback state that will be used if the state that is being
	 * animated is not declared within the trigger.
	 *
	 * ### Usage
	 *
	 * `state` will declare an animation state with its associated styles
	 * within the given trigger.
	 *
	 * - `stateNameExpr` can be one or more state names separated by commas.
	 * - `styles` refers to the {\@link style styling data} that will be persisted on the element once
	 * the state has been reached.
	 *
	 * ```typescript
	 * // "void" is a reserved name for a state and is used to represent
	 * // the state in which an element is detached from from the application.
	 * state("void", style({ height: 0 }))
	 *
	 * // user-defined states
	 * state("closed", style({ height: 0 }))
	 * state("open, visible", style({ height: "*" }))
	 * ```
	 *
	 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} name
	 * @param {?} styles
	 * @param {?=} options
	 * @return {?}
	 */
	function state(name, styles, options) {
	    return { type: 0 /* State */, name: name, styles: styles, options: options };
	}
	/**
	 * `keyframes` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. If this information is new, please navigate to the {\@link
	 * Component#animations component animations metadata page} to gain a better understanding of
	 * how animations in Angular are used.
	 *
	 * `keyframes` specifies a collection of {\@link style style} entries each optionally characterized
	 * by an `offset` value.
	 *
	 * ### Usage
	 *
	 * The `keyframes` animation function is designed to be used alongside the {\@link animate animate}
	 * animation function. Instead of applying animations from where they are currently to their
	 * destination, keyframes can describe how each style entry is applied and at what point within the
	 * animation arc (much like CSS Keyframe Animations do).
	 *
	 * For each `style()` entry an `offset` value can be set. Doing so allows to specifiy at what
	 * percentage of the animate time the styles will be applied.
	 *
	 * ```typescript
	 * // the provided offset values describe when each backgroundColor value is applied.
	 * animate("5s", keyframes([
	 *   style({ backgroundColor: "red", offset: 0 }),
	 *   style({ backgroundColor: "blue", offset: 0.2 }),
	 *   style({ backgroundColor: "orange", offset: 0.3 }),
	 *   style({ backgroundColor: "black", offset: 1 })
	 * ]))
	 * ```
	 *
	 * Alternatively, if there are no `offset` values used within the style entries then the offsets
	 * will be calculated automatically.
	 *
	 * ```typescript
	 * animate("5s", keyframes([
	 *   style({ backgroundColor: "red" }) // offset = 0
	 *   style({ backgroundColor: "blue" }) // offset = 0.33
	 *   style({ backgroundColor: "orange" }) // offset = 0.66
	 *   style({ backgroundColor: "black" }) // offset = 1
	 * ]))
	 * ```
	 *
	 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} steps
	 * @return {?}
	 */
	function keyframes(steps) {
	    return { type: 5 /* Keyframes */, steps: steps };
	}
	/**
	 * `transition` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. If this information is new, please navigate to the {\@link
	 * Component#animations component animations metadata page} to gain a better understanding of
	 * how animations in Angular are used.
	 *
	 * `transition` declares the {\@link sequence sequence of animation steps} that will be run when the
	 * provided `stateChangeExpr` value is satisfied. The `stateChangeExpr` consists of a `state1 =>
	 * state2` which consists of two known states (use an asterix (`*`) to refer to a dynamic starting
	 * and/or ending state).
	 *
	 * A function can also be provided as the `stateChangeExpr` argument for a transition and this
	 * function will be executed each time a state change occurs. If the value returned within the
	 * function is true then the associated animation will be run.
	 *
	 * Animation transitions are placed within an {\@link trigger animation trigger}. For an transition
	 * to animate to a state value and persist its styles then one or more {\@link state animation
	 * states} is expected to be defined.
	 *
	 * ### Usage
	 *
	 * An animation transition is kicked off the `stateChangeExpr` predicate evaluates to true based on
	 * what the previous state is and what the current state has become. In other words, if a transition
	 * is defined that matches the old/current state criteria then the associated animation will be
	 * triggered.
	 *
	 * ```typescript
	 * // all transition/state changes are defined within an animation trigger
	 * trigger("myAnimationTrigger", [
	 *   // if a state is defined then its styles will be persisted when the
	 *   // animation has fully completed itself
	 *   state("on", style({ background: "green" })),
	 *   state("off", style({ background: "grey" })),
	 *
	 *   // a transition animation that will be kicked off when the state value
	 *   // bound to "myAnimationTrigger" changes from "on" to "off"
	 *   transition("on => off", animate(500)),
	 *
	 *   // it is also possible to do run the same animation for both directions
	 *   transition("on <=> off", animate(500)),
	 *
	 *   // or to define multiple states pairs separated by commas
	 *   transition("on => off, off => void", animate(500)),
	 *
	 *   // this is a catch-all state change for when an element is inserted into
	 *   // the page and the destination state is unknown
	 *   transition("void => *", [
	 *     style({ opacity: 0 }),
	 *     animate(500)
	 *   ]),
	 *
	 *   // this will capture a state change between any states
	 *   transition("* => *", animate("1s 0s")),
	 *
	 *   // you can also go full out and include a function
	 *   transition((fromState, toState) => {
	 *     // when `true` then it will allow the animation below to be invoked
	 *     return fromState == "off" && toState == "on";
	 *   }, animate("1s 0s"))
	 * ])
	 * ```
	 *
	 * The template associated with this component will make use of the `myAnimationTrigger` animation
	 * trigger by binding to an element within its template code.
	 *
	 * ```html
	 * <!-- somewhere inside of my-component-tpl.html -->
	 * <div [\@myAnimationTrigger]="myStatusExp">...</div>
	 * ```
	 *
	 * #### The final `animate` call
	 *
	 * If the final step within the transition steps is a call to `animate()` that **only** uses a
	 * timing value with **no style data** then it will be automatically used as the final animation arc
	 * for the element to animate itself to the final state. This involves an automatic mix of
	 * adding/removing CSS styles so that the element will be in the exact state it should be for the
	 * applied state to be presented correctly.
	 *
	 * ```
	 * // start off by hiding the element, but make sure that it animates properly to whatever state
	 * // is currently active for "myAnimationTrigger"
	 * transition("void => *", [
	 *   style({ opacity: 0 }),
	 *   animate(500)
	 * ])
	 * ```
	 *
	 * ### Using :enter and :leave
	 *
	 * Given that enter (insertion) and leave (removal) animations are so common, the `transition`
	 * function accepts both `:enter` and `:leave` values which are aliases for the `void => *` and `*
	 * => void` state changes.
	 *
	 * ```
	 * transition(":enter", [
	 *   style({ opacity: 0 }),
	 *   animate(500, style({ opacity: 1 }))
	 * ]),
	 * transition(":leave", [
	 *   animate(500, style({ opacity: 0 }))
	 * ])
	 * ```
	 *
	 * ### Boolean values
	 * if a trigger binding value is a boolean value then it can be matched using a transition
	 * expression that compares `true` and `false` or `1` and `0`.
	 *
	 * ```
	 * // in the template
	 * <div [\@openClose]="open ? true : false">...</div>
	 *
	 * // in the component metadata
	 * trigger('openClose', [
	 *   state('true', style({ height: '*' })),
	 *   state('false', style({ height: '0px' })),
	 *   transition('false <=> true', animate(500))
	 * ])
	 * ```
	 *
	 * ### Using :increment and :decrement
	 * In addition to the :enter and :leave transition aliases, the :increment and :decrement aliases
	 * can be used to kick off a transition when a numeric value has increased or decreased in value.
	 *
	 * ```
	 * import {group, animate, query, transition, style, trigger} from '\@angular/animations';
	 * import {Component} from '\@angular/core';
	 *
	 * \@Component({
	 *   selector: 'banner-carousel-component',
	 *   styles: [`
	 *     .banner-container {
	 *        position:relative;
	 *        height:500px;
	 *        overflow:hidden;
	 *      }
	 *     .banner-container > .banner {
	 *        position:absolute;
	 *        left:0;
	 *        top:0;
	 *        font-size:200px;
	 *        line-height:500px;
	 *        font-weight:bold;
	 *        text-align:center;
	 *        width:100%;
	 *      }
	 *   `],
	 *   template: `
	 *     <button (click)="previous()">Previous</button>
	 *     <button (click)="next()">Next</button>
	 *     <hr>
	 *     <div [\@bannerAnimation]="selectedIndex" class="banner-container">
	 *       <div class="banner" *ngFor="let banner of banners"> {{ banner }} </div>
	 *     </div>
	 *   `,
	 *   animations: [
	 *     trigger('bannerAnimation', [
	 *       transition(":increment", group([
	 *         query(':enter', [
	 *           style({ left: '100%' }),
	 *           animate('0.5s ease-out', style('*'))
	 *         ]),
	 *         query(':leave', [
	 *           animate('0.5s ease-out', style({ left: '-100%' }))
	 *         ])
	 *       ])),
	 *       transition(":decrement", group([
	 *         query(':enter', [
	 *           style({ left: '-100%' }),
	 *           animate('0.5s ease-out', style('*'))
	 *         ]),
	 *         query(':leave', [
	 *           animate('0.5s ease-out', style({ left: '100%' }))
	 *         ])
	 *       ]))
	 *     ])
	 *   ]
	 * })
	 * class BannerCarouselComponent {
	 *   allBanners: string[] = ['1', '2', '3', '4'];
	 *   selectedIndex: number = 0;
	 *
	 *   get banners() {
	 *      return [this.allBanners[this.selectedIndex]];
	 *   }
	 *
	 *   previous() {
	 *     this.selectedIndex = Math.max(this.selectedIndex - 1, 0);
	 *   }
	 *
	 *   next() {
	 *     this.selectedIndex = Math.min(this.selectedIndex + 1, this.allBanners.length - 1);
	 *   }
	 * }
	 * ```
	 *
	 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} stateChangeExpr
	 * @param {?} steps
	 * @param {?=} options
	 * @return {?}
	 */
	function transition(stateChangeExpr, steps, options) {
	    if (options === void 0) { options = null; }
	    return { type: 1 /* Transition */, expr: stateChangeExpr, animation: steps, options: options };
	}
	/**
	 * `animation` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language.
	 *
	 * `var myAnimation = animation(...)` is designed to produce a reusable animation that can be later
	 * invoked in another animation or sequence. Reusable animations are designed to make use of
	 * animation parameters and the produced animation can be used via the `useAnimation` method.
	 *
	 * ```
	 * var fadeAnimation = animation([
	 *   style({ opacity: '{{ start }}' }),
	 *   animate('{{ time }}',
	 *     style({ opacity: '{{ end }}'}))
	 * ], { params: { time: '1000ms', start: 0, end: 1 }});
	 * ```
	 *
	 * If parameters are attached to an animation then they act as **default parameter values**. When an
	 * animation is invoked via `useAnimation` then parameter values are allowed to be passed in
	 * directly. If any of the passed in parameter values are missing then the default values will be
	 * used.
	 *
	 * ```
	 * useAnimation(fadeAnimation, {
	 *   params: {
	 *     time: '2s',
	 *     start: 1,
	 *     end: 0
	 *   }
	 * })
	 * ```
	 *
	 * If one or more parameter values are missing before animated then an error will be thrown.
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} steps
	 * @param {?=} options
	 * @return {?}
	 */
	function animation(steps, options) {
	    if (options === void 0) { options = null; }
	    return { type: 8 /* Reference */, animation: steps, options: options };
	}
	/**
	 * `animateChild` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. It works by allowing a queried element to execute its own
	 * animation within the animation sequence.
	 *
	 * Each time an animation is triggered in angular, the parent animation
	 * will always get priority and any child animations will be blocked. In order
	 * for a child animation to run, the parent animation must query each of the elements
	 * containing child animations and then allow the animations to run using `animateChild`.
	 *
	 * The example HTML code below shows both parent and child elements that have animation
	 * triggers that will execute at the same time.
	 *
	 * ```html
	 * <!-- parent-child.component.html -->
	 * <button (click)="exp =! exp">Toggle</button>
	 * <hr>
	 *
	 * <div [\@parentAnimation]="exp">
	 *   <header>Hello</header>
	 *   <div [\@childAnimation]="exp">
	 *       one
	 *   </div>
	 *   <div [\@childAnimation]="exp">
	 *       two
	 *   </div>
	 *   <div [\@childAnimation]="exp">
	 *       three
	 *   </div>
	 * </div>
	 * ```
	 *
	 * Now when the `exp` value changes to true, only the `parentAnimation` animation will animate
	 * because it has priority. However, using `query` and `animateChild` each of the inner animations
	 * can also fire:
	 *
	 * ```ts
	 * // parent-child.component.ts
	 * import {trigger, transition, animate, style, query, animateChild} from '\@angular/animations';
	 * \@Component({
	 *   selector: 'parent-child-component',
	 *   animations: [
	 *     trigger('parentAnimation', [
	 *       transition('false => true', [
	 *         query('header', [
	 *           style({ opacity: 0 }),
	 *           animate(500, style({ opacity: 1 }))
	 *         ]),
	 *         query('\@childAnimation', [
	 *           animateChild()
	 *         ])
	 *       ])
	 *     ]),
	 *     trigger('childAnimation', [
	 *       transition('false => true', [
	 *         style({ opacity: 0 }),
	 *         animate(500, style({ opacity: 1 }))
	 *       ])
	 *     ])
	 *   ]
	 * })
	 * class ParentChildCmp {
	 *   exp: boolean = false;
	 * }
	 * ```
	 *
	 * In the animation code above, when the `parentAnimation` transition kicks off it first queries to
	 * find the header element and fades it in. It then finds each of the sub elements that contain the
	 * `\@childAnimation` trigger and then allows for their animations to fire.
	 *
	 * This example can be further extended by using stagger:
	 *
	 * ```ts
	 * query('\@childAnimation', stagger(100, [
	 *   animateChild()
	 * ]))
	 * ```
	 *
	 * Now each of the sub animations start off with respect to the `100ms` staggering step.
	 *
	 * ## The first frame of child animations
	 * When sub animations are executed using `animateChild` the animation engine will always apply the
	 * first frame of every sub animation immediately at the start of the animation sequence. This way
	 * the parent animation does not need to set any initial styling data on the sub elements before the
	 * sub animations kick off.
	 *
	 * In the example above the first frame of the `childAnimation`'s `false => true` transition
	 * consists of a style of `opacity: 0`. This is applied immediately when the `parentAnimation`
	 * animation transition sequence starts. Only then when the `\@childAnimation` is queried and called
	 * with `animateChild` will it then animate to its destination of `opacity: 1`.
	 *
	 * Note that this feature designed to be used alongside {\@link query query()} and it will only work
	 * with animations that are assigned using the Angular animation DSL (this means that CSS keyframes
	 * and transitions are not handled by this API).
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?=} options
	 * @return {?}
	 */
	function animateChild(options) {
	    if (options === void 0) { options = null; }
	    return { type: 9 /* AnimateChild */, options: options };
	}
	/**
	 * `useAnimation` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. It is used to kick off a reusable animation that is created using {\@link
	 * animation animation()}.
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} animation
	 * @param {?=} options
	 * @return {?}
	 */
	function useAnimation(animation, options) {
	    if (options === void 0) { options = null; }
	    return { type: 10 /* AnimateRef */, animation: animation, options: options };
	}
	/**
	 * `query` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language.
	 *
	 * query() is used to find one or more inner elements within the current element that is
	 * being animated within the sequence. The provided animation steps are applied
	 * to the queried element (by default, an array is provided, then this will be
	 * treated as an animation sequence).
	 *
	 * ### Usage
	 *
	 * query() is designed to collect mutiple elements and works internally by using
	 * `element.querySelectorAll`. An additional options object can be provided which
	 * can be used to limit the total amount of items to be collected.
	 *
	 * ```js
	 * query('div', [
	 *   animate(...),
	 *   animate(...)
	 * ], { limit: 1 })
	 * ```
	 *
	 * query(), by default, will throw an error when zero items are found. If a query
	 * has the `optional` flag set to true then this error will be ignored.
	 *
	 * ```js
	 * query('.some-element-that-may-not-be-there', [
	 *   animate(...),
	 *   animate(...)
	 * ], { optional: true })
	 * ```
	 *
	 * ### Special Selector Values
	 *
	 * The selector value within a query can collect elements that contain angular-specific
	 * characteristics
	 * using special pseudo-selectors tokens.
	 *
	 * These include:
	 *
	 *  - Querying for newly inserted/removed elements using `query(":enter")`/`query(":leave")`
	 *  - Querying all currently animating elements using `query(":animating")`
	 *  - Querying elements that contain an animation trigger using `query("\@triggerName")`
	 *  - Querying all elements that contain an animation triggers using `query("\@*")`
	 *  - Including the current element into the animation sequence using `query(":self")`
	 *
	 *
	 *  Each of these pseudo-selector tokens can be merged together into a combined query selector
	 * string:
	 *
	 *  ```
	 *  query(':self, .record:enter, .record:leave, \@subTrigger', [...])
	 *  ```
	 *
	 * ### Demo
	 *
	 * ```
	 * \@Component({
	 *   selector: 'inner',
	 *   template: `
	 *     <div [\@queryAnimation]="exp">
	 *       <h1>Title</h1>
	 *       <div class="content">
	 *         Blah blah blah
	 *       </div>
	 *     </div>
	 *   `,
	 *   animations: [
	 *    trigger('queryAnimation', [
	 *      transition('* => goAnimate', [
	 *        // hide the inner elements
	 *        query('h1', style({ opacity: 0 })),
	 *        query('.content', style({ opacity: 0 })),
	 *
	 *        // animate the inner elements in, one by one
	 *        query('h1', animate(1000, style({ opacity: 1 })),
	 *        query('.content', animate(1000, style({ opacity: 1 })),
	 *      ])
	 *    ])
	 *  ]
	 * })
	 * class Cmp {
	 *   exp = '';
	 *
	 *   goAnimate() {
	 *     this.exp = 'goAnimate';
	 *   }
	 * }
	 * ```
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} selector
	 * @param {?} animation
	 * @param {?=} options
	 * @return {?}
	 */
	function query(selector, animation, options) {
	    if (options === void 0) { options = null; }
	    return { type: 11 /* Query */, selector: selector, animation: animation, options: options };
	}
	/**
	 * `stagger` is an animation-specific function that is designed to be used inside of Angular's
	 * animation DSL language. It is designed to be used inside of an animation {\@link query query()}
	 * and works by issuing a timing gap between after each queried item is animated.
	 *
	 * ### Usage
	 *
	 * In the example below there is a container element that wraps a list of items stamped out
	 * by an ngFor. The container element contains an animation trigger that will later be set
	 * to query for each of the inner items.
	 *
	 * ```html
	 * <!-- list.component.html -->
	 * <button (click)="toggle()">Show / Hide Items</button>
	 * <hr />
	 * <div [\@listAnimation]="items.length">
	 *   <div *ngFor="let item of items">
	 *     {{ item }}
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The component code for this looks as such:
	 *
	 * ```ts
	 * import {trigger, transition, style, animate, query, stagger} from '\@angular/animations';
	 * \@Component({
	 *   templateUrl: 'list.component.html',
	 *   animations: [
	 *     trigger('listAnimation', [
	 *        //...
	 *     ])
	 *   ]
	 * })
	 * class ListComponent {
	 *   items = [];
	 *
	 *   showItems() {
	 *     this.items = [0,1,2,3,4];
	 *   }
	 *
	 *   hideItems() {
	 *     this.items = [];
	 *   }
	 *
	 *   toggle() {
	 *     this.items.length ? this.hideItems() : this.showItems();
	 *   }
	 * }
	 * ```
	 *
	 * And now for the animation trigger code:
	 *
	 * ```ts
	 * trigger('listAnimation', [
	 *   transition('* => *', [ // each time the binding value changes
	 *     query(':leave', [
	 *       stagger(100, [
	 *         animate('0.5s', style({ opacity: 0 }))
	 *       ])
	 *     ]),
	 *     query(':enter', [
	 *       style({ opacity: 0 }),
	 *       stagger(100, [
	 *         animate('0.5s', style({ opacity: 1 }))
	 *       ])
	 *     ])
	 *   ])
	 * ])
	 * ```
	 *
	 * Now each time the items are added/removed then either the opacity
	 * fade-in animation will run or each removed item will be faded out.
	 * When either of these animations occur then a stagger effect will be
	 * applied after each item's animation is started.
	 *
	 * \@experimental Animation support is experimental.
	 * @param {?} timings
	 * @param {?} animation
	 * @return {?}
	 */
	function stagger(timings, animation) {
	    return { type: 12 /* Stagger */, timings: timings, animation: animation };
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 * @param {?} cb
	 * @return {?}
	 */
	function scheduleMicroTask(cb) {
	    Promise.resolve(null).then(cb);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * AnimationPlayer controls an animation sequence that was produced from a programmatic animation.
	 * (see {\@link AnimationBuilder AnimationBuilder} for more information on how to create programmatic
	 * animations.)
	 *
	 * \@experimental Animation support is experimental.
	 * @record
	 */
	
	/**
	 * \@experimental Animation support is experimental.
	 */
	var NoopAnimationPlayer = /** @class */ (function () {
	    function NoopAnimationPlayer() {
	        this._onDoneFns = [];
	        this._onStartFns = [];
	        this._onDestroyFns = [];
	        this._started = false;
	        this._destroyed = false;
	        this._finished = false;
	        this.parentPlayer = null;
	        this.totalTime = 0;
	    }
	    /**
	     * @return {?}
	     */
	    NoopAnimationPlayer.prototype._onFinish = /**
	     * @return {?}
	     */
	    function () {
	        if (!this._finished) {
	            this._finished = true;
	            this._onDoneFns.forEach(function (fn) { return fn(); });
	            this._onDoneFns = [];
	        }
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    NoopAnimationPlayer.prototype.onStart = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this._onStartFns.push(fn); };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    NoopAnimationPlayer.prototype.onDone = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this._onDoneFns.push(fn); };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    NoopAnimationPlayer.prototype.onDestroy = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this._onDestroyFns.push(fn); };
	    /**
	     * @return {?}
	     */
	    NoopAnimationPlayer.prototype.hasStarted = /**
	     * @return {?}
	     */
	    function () { return this._started; };
	    /**
	     * @return {?}
	     */
	    NoopAnimationPlayer.prototype.init = /**
	     * @return {?}
	     */
	    function () { };
	    /**
	     * @return {?}
	     */
	    NoopAnimationPlayer.prototype.play = /**
	     * @return {?}
	     */
	    function () {
	        if (!this.hasStarted()) {
	            this._onStart();
	            this.triggerMicrotask();
	        }
	        this._started = true;
	    };
	    /* @internal */
	    /**
	     * @return {?}
	     */
	    NoopAnimationPlayer.prototype.triggerMicrotask = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        scheduleMicroTask(function () { return _this._onFinish(); });
	    };
	    /**
	     * @return {?}
	     */
	    NoopAnimationPlayer.prototype._onStart = /**
	     * @return {?}
	     */
	    function () {
	        this._onStartFns.forEach(function (fn) { return fn(); });
	        this._onStartFns = [];
	    };
	    /**
	     * @return {?}
	     */
	    NoopAnimationPlayer.prototype.pause = /**
	     * @return {?}
	     */
	    function () { };
	    /**
	     * @return {?}
	     */
	    NoopAnimationPlayer.prototype.restart = /**
	     * @return {?}
	     */
	    function () { };
	    /**
	     * @return {?}
	     */
	    NoopAnimationPlayer.prototype.finish = /**
	     * @return {?}
	     */
	    function () { this._onFinish(); };
	    /**
	     * @return {?}
	     */
	    NoopAnimationPlayer.prototype.destroy = /**
	     * @return {?}
	     */
	    function () {
	        if (!this._destroyed) {
	            this._destroyed = true;
	            if (!this.hasStarted()) {
	                this._onStart();
	            }
	            this.finish();
	            this._onDestroyFns.forEach(function (fn) { return fn(); });
	            this._onDestroyFns = [];
	        }
	    };
	    /**
	     * @return {?}
	     */
	    NoopAnimationPlayer.prototype.reset = /**
	     * @return {?}
	     */
	    function () { };
	    /**
	     * @param {?} p
	     * @return {?}
	     */
	    NoopAnimationPlayer.prototype.setPosition = /**
	     * @param {?} p
	     * @return {?}
	     */
	    function (p) { };
	    /**
	     * @return {?}
	     */
	    NoopAnimationPlayer.prototype.getPosition = /**
	     * @return {?}
	     */
	    function () { return 0; };
	    /* @internal */
	    /**
	     * @param {?} phaseName
	     * @return {?}
	     */
	    NoopAnimationPlayer.prototype.triggerCallback = /**
	     * @param {?} phaseName
	     * @return {?}
	     */
	    function (phaseName) {
	        var /** @type {?} */ methods = phaseName == 'start' ? this._onStartFns : this._onDoneFns;
	        methods.forEach(function (fn) { return fn(); });
	        methods.length = 0;
	    };
	    return NoopAnimationPlayer;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var AnimationGroupPlayer = /** @class */ (function () {
	    function AnimationGroupPlayer(_players) {
	        var _this = this;
	        this._onDoneFns = [];
	        this._onStartFns = [];
	        this._finished = false;
	        this._started = false;
	        this._destroyed = false;
	        this._onDestroyFns = [];
	        this.parentPlayer = null;
	        this.totalTime = 0;
	        this.players = _players;
	        var /** @type {?} */ doneCount = 0;
	        var /** @type {?} */ destroyCount = 0;
	        var /** @type {?} */ startCount = 0;
	        var /** @type {?} */ total = this.players.length;
	        if (total == 0) {
	            scheduleMicroTask(function () { return _this._onFinish(); });
	        }
	        else {
	            this.players.forEach(function (player) {
	                player.onDone(function () {
	                    if (++doneCount == total) {
	                        _this._onFinish();
	                    }
	                });
	                player.onDestroy(function () {
	                    if (++destroyCount == total) {
	                        _this._onDestroy();
	                    }
	                });
	                player.onStart(function () {
	                    if (++startCount == total) {
	                        _this._onStart();
	                    }
	                });
	            });
	        }
	        this.totalTime = this.players.reduce(function (time, player) { return Math.max(time, player.totalTime); }, 0);
	    }
	    /**
	     * @return {?}
	     */
	    AnimationGroupPlayer.prototype._onFinish = /**
	     * @return {?}
	     */
	    function () {
	        if (!this._finished) {
	            this._finished = true;
	            this._onDoneFns.forEach(function (fn) { return fn(); });
	            this._onDoneFns = [];
	        }
	    };
	    /**
	     * @return {?}
	     */
	    AnimationGroupPlayer.prototype.init = /**
	     * @return {?}
	     */
	    function () { this.players.forEach(function (player) { return player.init(); }); };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    AnimationGroupPlayer.prototype.onStart = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this._onStartFns.push(fn); };
	    /**
	     * @return {?}
	     */
	    AnimationGroupPlayer.prototype._onStart = /**
	     * @return {?}
	     */
	    function () {
	        if (!this.hasStarted()) {
	            this._started = true;
	            this._onStartFns.forEach(function (fn) { return fn(); });
	            this._onStartFns = [];
	        }
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    AnimationGroupPlayer.prototype.onDone = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this._onDoneFns.push(fn); };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    AnimationGroupPlayer.prototype.onDestroy = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this._onDestroyFns.push(fn); };
	    /**
	     * @return {?}
	     */
	    AnimationGroupPlayer.prototype.hasStarted = /**
	     * @return {?}
	     */
	    function () { return this._started; };
	    /**
	     * @return {?}
	     */
	    AnimationGroupPlayer.prototype.play = /**
	     * @return {?}
	     */
	    function () {
	        if (!this.parentPlayer) {
	            this.init();
	        }
	        this._onStart();
	        this.players.forEach(function (player) { return player.play(); });
	    };
	    /**
	     * @return {?}
	     */
	    AnimationGroupPlayer.prototype.pause = /**
	     * @return {?}
	     */
	    function () { this.players.forEach(function (player) { return player.pause(); }); };
	    /**
	     * @return {?}
	     */
	    AnimationGroupPlayer.prototype.restart = /**
	     * @return {?}
	     */
	    function () { this.players.forEach(function (player) { return player.restart(); }); };
	    /**
	     * @return {?}
	     */
	    AnimationGroupPlayer.prototype.finish = /**
	     * @return {?}
	     */
	    function () {
	        this._onFinish();
	        this.players.forEach(function (player) { return player.finish(); });
	    };
	    /**
	     * @return {?}
	     */
	    AnimationGroupPlayer.prototype.destroy = /**
	     * @return {?}
	     */
	    function () { this._onDestroy(); };
	    /**
	     * @return {?}
	     */
	    AnimationGroupPlayer.prototype._onDestroy = /**
	     * @return {?}
	     */
	    function () {
	        if (!this._destroyed) {
	            this._destroyed = true;
	            this._onFinish();
	            this.players.forEach(function (player) { return player.destroy(); });
	            this._onDestroyFns.forEach(function (fn) { return fn(); });
	            this._onDestroyFns = [];
	        }
	    };
	    /**
	     * @return {?}
	     */
	    AnimationGroupPlayer.prototype.reset = /**
	     * @return {?}
	     */
	    function () {
	        this.players.forEach(function (player) { return player.reset(); });
	        this._destroyed = false;
	        this._finished = false;
	        this._started = false;
	    };
	    /**
	     * @param {?} p
	     * @return {?}
	     */
	    AnimationGroupPlayer.prototype.setPosition = /**
	     * @param {?} p
	     * @return {?}
	     */
	    function (p) {
	        var /** @type {?} */ timeAtPosition = p * this.totalTime;
	        this.players.forEach(function (player) {
	            var /** @type {?} */ position = player.totalTime ? Math.min(1, timeAtPosition / player.totalTime) : 1;
	            player.setPosition(position);
	        });
	    };
	    /**
	     * @return {?}
	     */
	    AnimationGroupPlayer.prototype.getPosition = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ min = 0;
	        this.players.forEach(function (player) {
	            var /** @type {?} */ p = player.getPosition();
	            min = Math.min(p, min);
	        });
	        return min;
	    };
	    /**
	     * @return {?}
	     */
	    AnimationGroupPlayer.prototype.beforeDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this.players.forEach(function (player) {
	            if (player.beforeDestroy) {
	                player.beforeDestroy();
	            }
	        });
	    };
	    /* @internal */
	    /**
	     * @param {?} phaseName
	     * @return {?}
	     */
	    AnimationGroupPlayer.prototype.triggerCallback = /**
	     * @param {?} phaseName
	     * @return {?}
	     */
	    function (phaseName) {
	        var /** @type {?} */ methods = phaseName == 'start' ? this._onStartFns : this._onDoneFns;
	        methods.forEach(function (fn) { return fn(); });
	        methods.length = 0;
	    };
	    return AnimationGroupPlayer;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var ɵPRE_STYLE = '!';
	
	exports.AnimationBuilder = AnimationBuilder;
	exports.AnimationFactory = AnimationFactory;
	exports.AUTO_STYLE = AUTO_STYLE;
	exports.animate = animate;
	exports.animateChild = animateChild;
	exports.animation = animation;
	exports.group = group;
	exports.keyframes = keyframes;
	exports.query = query;
	exports.sequence = sequence;
	exports.stagger = stagger;
	exports.state = state;
	exports.style = style;
	exports.transition = transition;
	exports.trigger = trigger;
	exports.useAnimation = useAnimation;
	exports.NoopAnimationPlayer = NoopAnimationPlayer;
	exports.ɵAnimationGroupPlayer = AnimationGroupPlayer;
	exports.ɵPRE_STYLE = ɵPRE_STYLE;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=animations.umd.js.map


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(250)) :
		typeof define === 'function' && define.amd ? define('@angular/animations/browser', ['exports', '@angular/animations'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.animations = global.ng.animations || {}, global.ng.animations.browser = {}),global.ng.animations));
	}(this, (function (exports,_angular_animations) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = Object.assign || function __assign(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	    }
	    return t;
	};
	
	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @param {?} players
	 * @return {?}
	 */
	function optimizeGroupPlayer(players) {
	    switch (players.length) {
	        case 0:
	            return new _angular_animations.NoopAnimationPlayer();
	        case 1:
	            return players[0];
	        default:
	            return new _angular_animations.ɵAnimationGroupPlayer(players);
	    }
	}
	/**
	 * @param {?} driver
	 * @param {?} normalizer
	 * @param {?} element
	 * @param {?} keyframes
	 * @param {?=} preStyles
	 * @param {?=} postStyles
	 * @return {?}
	 */
	function normalizeKeyframes(driver, normalizer, element, keyframes, preStyles, postStyles) {
	    if (preStyles === void 0) { preStyles = {}; }
	    if (postStyles === void 0) { postStyles = {}; }
	    var /** @type {?} */ errors = [];
	    var /** @type {?} */ normalizedKeyframes = [];
	    var /** @type {?} */ previousOffset = -1;
	    var /** @type {?} */ previousKeyframe = null;
	    keyframes.forEach(function (kf) {
	        var /** @type {?} */ offset = /** @type {?} */ (kf['offset']);
	        var /** @type {?} */ isSameOffset = offset == previousOffset;
	        var /** @type {?} */ normalizedKeyframe = (isSameOffset && previousKeyframe) || {};
	        Object.keys(kf).forEach(function (prop) {
	            var /** @type {?} */ normalizedProp = prop;
	            var /** @type {?} */ normalizedValue = kf[prop];
	            if (prop !== 'offset') {
	                normalizedProp = normalizer.normalizePropertyName(normalizedProp, errors);
	                switch (normalizedValue) {
	                    case _angular_animations.ɵPRE_STYLE:
	                        normalizedValue = preStyles[prop];
	                        break;
	                    case _angular_animations.AUTO_STYLE:
	                        normalizedValue = postStyles[prop];
	                        break;
	                    default:
	                        normalizedValue =
	                            normalizer.normalizeStyleValue(prop, normalizedProp, normalizedValue, errors);
	                        break;
	                }
	            }
	            normalizedKeyframe[normalizedProp] = normalizedValue;
	        });
	        if (!isSameOffset) {
	            normalizedKeyframes.push(normalizedKeyframe);
	        }
	        previousKeyframe = normalizedKeyframe;
	        previousOffset = offset;
	    });
	    if (errors.length) {
	        var /** @type {?} */ LINE_START = '\n - ';
	        throw new Error("Unable to animate due to the following errors:" + LINE_START + errors.join(LINE_START));
	    }
	    return normalizedKeyframes;
	}
	/**
	 * @param {?} player
	 * @param {?} eventName
	 * @param {?} event
	 * @param {?} callback
	 * @return {?}
	 */
	function listenOnPlayer(player, eventName, event, callback) {
	    switch (eventName) {
	        case 'start':
	            player.onStart(function () { return callback(event && copyAnimationEvent(event, 'start', player.totalTime)); });
	            break;
	        case 'done':
	            player.onDone(function () { return callback(event && copyAnimationEvent(event, 'done', player.totalTime)); });
	            break;
	        case 'destroy':
	            player.onDestroy(function () { return callback(event && copyAnimationEvent(event, 'destroy', player.totalTime)); });
	            break;
	    }
	}
	/**
	 * @param {?} e
	 * @param {?=} phaseName
	 * @param {?=} totalTime
	 * @return {?}
	 */
	function copyAnimationEvent(e, phaseName, totalTime) {
	    var /** @type {?} */ event = makeAnimationEvent(e.element, e.triggerName, e.fromState, e.toState, phaseName || e.phaseName, totalTime == undefined ? e.totalTime : totalTime);
	    var /** @type {?} */ data = (/** @type {?} */ (e))['_data'];
	    if (data != null) {
	        (/** @type {?} */ (event))['_data'] = data;
	    }
	    return event;
	}
	/**
	 * @param {?} element
	 * @param {?} triggerName
	 * @param {?} fromState
	 * @param {?} toState
	 * @param {?=} phaseName
	 * @param {?=} totalTime
	 * @return {?}
	 */
	function makeAnimationEvent(element, triggerName, fromState, toState, phaseName, totalTime) {
	    if (phaseName === void 0) { phaseName = ''; }
	    if (totalTime === void 0) { totalTime = 0; }
	    return { element: element, triggerName: triggerName, fromState: fromState, toState: toState, phaseName: phaseName, totalTime: totalTime };
	}
	/**
	 * @param {?} map
	 * @param {?} key
	 * @param {?} defaultValue
	 * @return {?}
	 */
	function getOrSetAsInMap(map, key, defaultValue) {
	    var /** @type {?} */ value;
	    if (map instanceof Map) {
	        value = map.get(key);
	        if (!value) {
	            map.set(key, value = defaultValue);
	        }
	    }
	    else {
	        value = map[key];
	        if (!value) {
	            value = map[key] = defaultValue;
	        }
	    }
	    return value;
	}
	/**
	 * @param {?} command
	 * @return {?}
	 */
	function parseTimelineCommand(command) {
	    var /** @type {?} */ separatorPos = command.indexOf(':');
	    var /** @type {?} */ id = command.substring(1, separatorPos);
	    var /** @type {?} */ action = command.substr(separatorPos + 1);
	    return [id, action];
	}
	var _contains = function (elm1, elm2) { return false; };
	var _matches = function (element, selector) {
	    return false;
	};
	var _query = function (element, selector, multi) {
	    return [];
	};
	if (typeof Element != 'undefined') {
	    // this is well supported in all browsers
	    _contains = function (elm1, elm2) { return /** @type {?} */ (elm1.contains(elm2)); };
	    if (Element.prototype.matches) {
	        _matches = function (element, selector) { return element.matches(selector); };
	    }
	    else {
	        var /** @type {?} */ proto = /** @type {?} */ (Element.prototype);
	        var /** @type {?} */ fn_1 = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector ||
	            proto.oMatchesSelector || proto.webkitMatchesSelector;
	        if (fn_1) {
	            _matches = function (element, selector) { return fn_1.apply(element, [selector]); };
	        }
	    }
	    _query = function (element, selector, multi) {
	        var /** @type {?} */ results = [];
	        if (multi) {
	            results.push.apply(results, element.querySelectorAll(selector));
	        }
	        else {
	            var /** @type {?} */ elm = element.querySelector(selector);
	            if (elm) {
	                results.push(elm);
	            }
	        }
	        return results;
	    };
	}
	/**
	 * @param {?} prop
	 * @return {?}
	 */
	function containsVendorPrefix(prop) {
	    // Webkit is the only real popular vendor prefix nowadays
	    // cc: http://shouldiprefix.com/
	    return prop.substring(1, 6) == 'ebkit'; // webkit or Webkit
	}
	var _CACHED_BODY = null;
	var _IS_WEBKIT = false;
	/**
	 * @param {?} prop
	 * @return {?}
	 */
	function validateStyleProperty(prop) {
	    if (!_CACHED_BODY) {
	        _CACHED_BODY = getBodyNode() || {};
	        _IS_WEBKIT = /** @type {?} */ ((_CACHED_BODY)).style ? ('WebkitAppearance' in /** @type {?} */ ((_CACHED_BODY)).style) : false;
	    }
	    var /** @type {?} */ result = true;
	    if (/** @type {?} */ ((_CACHED_BODY)).style && !containsVendorPrefix(prop)) {
	        result = prop in /** @type {?} */ ((_CACHED_BODY)).style;
	        if (!result && _IS_WEBKIT) {
	            var /** @type {?} */ camelProp = 'Webkit' + prop.charAt(0).toUpperCase() + prop.substr(1);
	            result = camelProp in /** @type {?} */ ((_CACHED_BODY)).style;
	        }
	    }
	    return result;
	}
	/**
	 * @return {?}
	 */
	function getBodyNode() {
	    if (typeof document != 'undefined') {
	        return document.body;
	    }
	    return null;
	}
	var matchesElement = _matches;
	var containsElement = _contains;
	var invokeQuery = _query;
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * \@experimental
	 */
	var NoopAnimationDriver = /** @class */ (function () {
	    function NoopAnimationDriver() {
	    }
	    /**
	     * @param {?} prop
	     * @return {?}
	     */
	    NoopAnimationDriver.prototype.validateStyleProperty = /**
	     * @param {?} prop
	     * @return {?}
	     */
	    function (prop) { return validateStyleProperty(prop); };
	    /**
	     * @param {?} element
	     * @param {?} selector
	     * @return {?}
	     */
	    NoopAnimationDriver.prototype.matchesElement = /**
	     * @param {?} element
	     * @param {?} selector
	     * @return {?}
	     */
	    function (element, selector) {
	        return matchesElement(element, selector);
	    };
	    /**
	     * @param {?} elm1
	     * @param {?} elm2
	     * @return {?}
	     */
	    NoopAnimationDriver.prototype.containsElement = /**
	     * @param {?} elm1
	     * @param {?} elm2
	     * @return {?}
	     */
	    function (elm1, elm2) { return containsElement(elm1, elm2); };
	    /**
	     * @param {?} element
	     * @param {?} selector
	     * @param {?} multi
	     * @return {?}
	     */
	    NoopAnimationDriver.prototype.query = /**
	     * @param {?} element
	     * @param {?} selector
	     * @param {?} multi
	     * @return {?}
	     */
	    function (element, selector, multi) {
	        return invokeQuery(element, selector, multi);
	    };
	    /**
	     * @param {?} element
	     * @param {?} prop
	     * @param {?=} defaultValue
	     * @return {?}
	     */
	    NoopAnimationDriver.prototype.computeStyle = /**
	     * @param {?} element
	     * @param {?} prop
	     * @param {?=} defaultValue
	     * @return {?}
	     */
	    function (element, prop, defaultValue) {
	        return defaultValue || '';
	    };
	    /**
	     * @param {?} element
	     * @param {?} keyframes
	     * @param {?} duration
	     * @param {?} delay
	     * @param {?} easing
	     * @param {?=} previousPlayers
	     * @return {?}
	     */
	    NoopAnimationDriver.prototype.animate = /**
	     * @param {?} element
	     * @param {?} keyframes
	     * @param {?} duration
	     * @param {?} delay
	     * @param {?} easing
	     * @param {?=} previousPlayers
	     * @return {?}
	     */
	    function (element, keyframes, duration, delay, easing, previousPlayers) {
	        if (previousPlayers === void 0) { previousPlayers = []; }
	        return new _angular_animations.NoopAnimationPlayer();
	    };
	    return NoopAnimationDriver;
	}());
	/**
	 * \@experimental
	 * @abstract
	 */
	var AnimationDriver = /** @class */ (function () {
	    function AnimationDriver() {
	    }
	    AnimationDriver.NOOP = new NoopAnimationDriver();
	    return AnimationDriver;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var ONE_SECOND = 1000;
	var SUBSTITUTION_EXPR_START = '{{';
	var SUBSTITUTION_EXPR_END = '}}';
	var ENTER_CLASSNAME = 'ng-enter';
	var LEAVE_CLASSNAME = 'ng-leave';
	
	
	var NG_TRIGGER_CLASSNAME = 'ng-trigger';
	var NG_TRIGGER_SELECTOR = '.ng-trigger';
	var NG_ANIMATING_CLASSNAME = 'ng-animating';
	var NG_ANIMATING_SELECTOR = '.ng-animating';
	/**
	 * @param {?} value
	 * @return {?}
	 */
	function resolveTimingValue(value) {
	    if (typeof value == 'number')
	        return value;
	    var /** @type {?} */ matches = (/** @type {?} */ (value)).match(/^(-?[\.\d]+)(m?s)/);
	    if (!matches || matches.length < 2)
	        return 0;
	    return _convertTimeValueToMS(parseFloat(matches[1]), matches[2]);
	}
	/**
	 * @param {?} value
	 * @param {?} unit
	 * @return {?}
	 */
	function _convertTimeValueToMS(value, unit) {
	    switch (unit) {
	        case 's':
	            return value * ONE_SECOND;
	        default:
	            // ms or something else
	            return value;
	    }
	}
	/**
	 * @param {?} timings
	 * @param {?} errors
	 * @param {?=} allowNegativeValues
	 * @return {?}
	 */
	function resolveTiming(timings, errors, allowNegativeValues) {
	    return timings.hasOwnProperty('duration') ? /** @type {?} */ (timings) :
	        parseTimeExpression(/** @type {?} */ (timings), errors, allowNegativeValues);
	}
	/**
	 * @param {?} exp
	 * @param {?} errors
	 * @param {?=} allowNegativeValues
	 * @return {?}
	 */
	function parseTimeExpression(exp, errors, allowNegativeValues) {
	    var /** @type {?} */ regex = /^(-?[\.\d]+)(m?s)(?:\s+(-?[\.\d]+)(m?s))?(?:\s+([-a-z]+(?:\(.+?\))?))?$/i;
	    var /** @type {?} */ duration;
	    var /** @type {?} */ delay = 0;
	    var /** @type {?} */ easing = '';
	    if (typeof exp === 'string') {
	        var /** @type {?} */ matches = exp.match(regex);
	        if (matches === null) {
	            errors.push("The provided timing value \"" + exp + "\" is invalid.");
	            return { duration: 0, delay: 0, easing: '' };
	        }
	        duration = _convertTimeValueToMS(parseFloat(matches[1]), matches[2]);
	        var /** @type {?} */ delayMatch = matches[3];
	        if (delayMatch != null) {
	            delay = _convertTimeValueToMS(Math.floor(parseFloat(delayMatch)), matches[4]);
	        }
	        var /** @type {?} */ easingVal = matches[5];
	        if (easingVal) {
	            easing = easingVal;
	        }
	    }
	    else {
	        duration = /** @type {?} */ (exp);
	    }
	    if (!allowNegativeValues) {
	        var /** @type {?} */ containsErrors = false;
	        var /** @type {?} */ startIndex = errors.length;
	        if (duration < 0) {
	            errors.push("Duration values below 0 are not allowed for this animation step.");
	            containsErrors = true;
	        }
	        if (delay < 0) {
	            errors.push("Delay values below 0 are not allowed for this animation step.");
	            containsErrors = true;
	        }
	        if (containsErrors) {
	            errors.splice(startIndex, 0, "The provided timing value \"" + exp + "\" is invalid.");
	        }
	    }
	    return { duration: duration, delay: delay, easing: easing };
	}
	/**
	 * @param {?} obj
	 * @param {?=} destination
	 * @return {?}
	 */
	function copyObj(obj, destination) {
	    if (destination === void 0) { destination = {}; }
	    Object.keys(obj).forEach(function (prop) { destination[prop] = obj[prop]; });
	    return destination;
	}
	/**
	 * @param {?} styles
	 * @return {?}
	 */
	function normalizeStyles(styles) {
	    var /** @type {?} */ normalizedStyles = {};
	    if (Array.isArray(styles)) {
	        styles.forEach(function (data) { return copyStyles(data, false, normalizedStyles); });
	    }
	    else {
	        copyStyles(styles, false, normalizedStyles);
	    }
	    return normalizedStyles;
	}
	/**
	 * @param {?} styles
	 * @param {?} readPrototype
	 * @param {?=} destination
	 * @return {?}
	 */
	function copyStyles(styles, readPrototype, destination) {
	    if (destination === void 0) { destination = {}; }
	    if (readPrototype) {
	        // we make use of a for-in loop so that the
	        // prototypically inherited properties are
	        // revealed from the backFill map
	        for (var /** @type {?} */ prop in styles) {
	            destination[prop] = styles[prop];
	        }
	    }
	    else {
	        copyObj(styles, destination);
	    }
	    return destination;
	}
	/**
	 * @param {?} element
	 * @param {?} styles
	 * @return {?}
	 */
	function setStyles(element, styles) {
	    if (element['style']) {
	        Object.keys(styles).forEach(function (prop) {
	            var /** @type {?} */ camelProp = dashCaseToCamelCase(prop);
	            element.style[camelProp] = styles[prop];
	        });
	    }
	}
	/**
	 * @param {?} element
	 * @param {?} styles
	 * @return {?}
	 */
	function eraseStyles(element, styles) {
	    if (element['style']) {
	        Object.keys(styles).forEach(function (prop) {
	            var /** @type {?} */ camelProp = dashCaseToCamelCase(prop);
	            element.style[camelProp] = '';
	        });
	    }
	}
	/**
	 * @param {?} steps
	 * @return {?}
	 */
	function normalizeAnimationEntry(steps) {
	    if (Array.isArray(steps)) {
	        if (steps.length == 1)
	            return steps[0];
	        return _angular_animations.sequence(steps);
	    }
	    return /** @type {?} */ (steps);
	}
	/**
	 * @param {?} value
	 * @param {?} options
	 * @param {?} errors
	 * @return {?}
	 */
	function validateStyleParams(value, options, errors) {
	    var /** @type {?} */ params = options.params || {};
	    var /** @type {?} */ matches = extractStyleParams(value);
	    if (matches.length) {
	        matches.forEach(function (varName) {
	            if (!params.hasOwnProperty(varName)) {
	                errors.push("Unable to resolve the local animation param " + varName + " in the given list of values");
	            }
	        });
	    }
	}
	var PARAM_REGEX = new RegExp(SUBSTITUTION_EXPR_START + "\\s*(.+?)\\s*" + SUBSTITUTION_EXPR_END, 'g');
	/**
	 * @param {?} value
	 * @return {?}
	 */
	function extractStyleParams(value) {
	    var /** @type {?} */ params = [];
	    if (typeof value === 'string') {
	        var /** @type {?} */ val = value.toString();
	        var /** @type {?} */ match = void 0;
	        while (match = PARAM_REGEX.exec(val)) {
	            params.push(/** @type {?} */ (match[1]));
	        }
	        PARAM_REGEX.lastIndex = 0;
	    }
	    return params;
	}
	/**
	 * @param {?} value
	 * @param {?} params
	 * @param {?} errors
	 * @return {?}
	 */
	function interpolateParams(value, params, errors) {
	    var /** @type {?} */ original = value.toString();
	    var /** @type {?} */ str = original.replace(PARAM_REGEX, function (_, varName) {
	        var /** @type {?} */ localVal = params[varName];
	        // this means that the value was never overidden by the data passed in by the user
	        if (!params.hasOwnProperty(varName)) {
	            errors.push("Please provide a value for the animation param " + varName);
	            localVal = '';
	        }
	        return localVal.toString();
	    });
	    // we do this to assert that numeric values stay as they are
	    return str == original ? value : str;
	}
	/**
	 * @param {?} iterator
	 * @return {?}
	 */
	function iteratorToArray(iterator) {
	    var /** @type {?} */ arr = [];
	    var /** @type {?} */ item = iterator.next();
	    while (!item.done) {
	        arr.push(item.value);
	        item = iterator.next();
	    }
	    return arr;
	}
	/**
	 * @param {?} source
	 * @param {?} destination
	 * @return {?}
	 */
	
	var DASH_CASE_REGEXP = /-+([a-z0-9])/g;
	/**
	 * @param {?} input
	 * @return {?}
	 */
	function dashCaseToCamelCase(input) {
	    return input.replace(DASH_CASE_REGEXP, function () {
	        var m = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            m[_i] = arguments[_i];
	        }
	        return m[1].toUpperCase();
	    });
	}
	/**
	 * @param {?} duration
	 * @param {?} delay
	 * @return {?}
	 */
	function allowPreviousPlayerStylesMerge(duration, delay) {
	    return duration === 0 || delay === 0;
	}
	/**
	 * @param {?} visitor
	 * @param {?} node
	 * @param {?} context
	 * @return {?}
	 */
	function visitDslNode(visitor, node, context) {
	    switch (node.type) {
	        case 7 /* Trigger */:
	            return visitor.visitTrigger(node, context);
	        case 0 /* State */:
	            return visitor.visitState(node, context);
	        case 1 /* Transition */:
	            return visitor.visitTransition(node, context);
	        case 2 /* Sequence */:
	            return visitor.visitSequence(node, context);
	        case 3 /* Group */:
	            return visitor.visitGroup(node, context);
	        case 4 /* Animate */:
	            return visitor.visitAnimate(node, context);
	        case 5 /* Keyframes */:
	            return visitor.visitKeyframes(node, context);
	        case 6 /* Style */:
	            return visitor.visitStyle(node, context);
	        case 8 /* Reference */:
	            return visitor.visitReference(node, context);
	        case 9 /* AnimateChild */:
	            return visitor.visitAnimateChild(node, context);
	        case 10 /* AnimateRef */:
	            return visitor.visitAnimateRef(node, context);
	        case 11 /* Query */:
	            return visitor.visitQuery(node, context);
	        case 12 /* Stagger */:
	            return visitor.visitStagger(node, context);
	        default:
	            throw new Error("Unable to resolve animation metadata node #" + node.type);
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var ANY_STATE = '*';
	/**
	 * @param {?} transitionValue
	 * @param {?} errors
	 * @return {?}
	 */
	function parseTransitionExpr(transitionValue, errors) {
	    var /** @type {?} */ expressions = [];
	    if (typeof transitionValue == 'string') {
	        (/** @type {?} */ (transitionValue))
	            .split(/\s*,\s*/)
	            .forEach(function (str) { return parseInnerTransitionStr(str, expressions, errors); });
	    }
	    else {
	        expressions.push(/** @type {?} */ (transitionValue));
	    }
	    return expressions;
	}
	/**
	 * @param {?} eventStr
	 * @param {?} expressions
	 * @param {?} errors
	 * @return {?}
	 */
	function parseInnerTransitionStr(eventStr, expressions, errors) {
	    if (eventStr[0] == ':') {
	        var /** @type {?} */ result = parseAnimationAlias(eventStr, errors);
	        if (typeof result == 'function') {
	            expressions.push(result);
	            return;
	        }
	        eventStr = /** @type {?} */ (result);
	    }
	    var /** @type {?} */ match = eventStr.match(/^(\*|[-\w]+)\s*(<?[=-]>)\s*(\*|[-\w]+)$/);
	    if (match == null || match.length < 4) {
	        errors.push("The provided transition expression \"" + eventStr + "\" is not supported");
	        return expressions;
	    }
	    var /** @type {?} */ fromState = match[1];
	    var /** @type {?} */ separator = match[2];
	    var /** @type {?} */ toState = match[3];
	    expressions.push(makeLambdaFromStates(fromState, toState));
	    var /** @type {?} */ isFullAnyStateExpr = fromState == ANY_STATE && toState == ANY_STATE;
	    if (separator[0] == '<' && !isFullAnyStateExpr) {
	        expressions.push(makeLambdaFromStates(toState, fromState));
	    }
	}
	/**
	 * @param {?} alias
	 * @param {?} errors
	 * @return {?}
	 */
	function parseAnimationAlias(alias, errors) {
	    switch (alias) {
	        case ':enter':
	            return 'void => *';
	        case ':leave':
	            return '* => void';
	        case ':increment':
	            return function (fromState, toState) { return parseFloat(toState) > parseFloat(fromState); };
	        case ':decrement':
	            return function (fromState, toState) { return parseFloat(toState) < parseFloat(fromState); };
	        default:
	            errors.push("The transition alias value \"" + alias + "\" is not supported");
	            return '* => *';
	    }
	}
	// DO NOT REFACTOR ... keep the follow set instantiations
	// with the values intact (closure compiler for some reason
	// removes follow-up lines that add the values outside of
	// the constructor...
	var TRUE_BOOLEAN_VALUES = new Set(['true', '1']);
	var FALSE_BOOLEAN_VALUES = new Set(['false', '0']);
	/**
	 * @param {?} lhs
	 * @param {?} rhs
	 * @return {?}
	 */
	function makeLambdaFromStates(lhs, rhs) {
	    var /** @type {?} */ LHS_MATCH_BOOLEAN = TRUE_BOOLEAN_VALUES.has(lhs) || FALSE_BOOLEAN_VALUES.has(lhs);
	    var /** @type {?} */ RHS_MATCH_BOOLEAN = TRUE_BOOLEAN_VALUES.has(rhs) || FALSE_BOOLEAN_VALUES.has(rhs);
	    return function (fromState, toState) {
	        var /** @type {?} */ lhsMatch = lhs == ANY_STATE || lhs == fromState;
	        var /** @type {?} */ rhsMatch = rhs == ANY_STATE || rhs == toState;
	        if (!lhsMatch && LHS_MATCH_BOOLEAN && typeof fromState === 'boolean') {
	            lhsMatch = fromState ? TRUE_BOOLEAN_VALUES.has(lhs) : FALSE_BOOLEAN_VALUES.has(lhs);
	        }
	        if (!rhsMatch && RHS_MATCH_BOOLEAN && typeof toState === 'boolean') {
	            rhsMatch = toState ? TRUE_BOOLEAN_VALUES.has(rhs) : FALSE_BOOLEAN_VALUES.has(rhs);
	        }
	        return lhsMatch && rhsMatch;
	    };
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var SELF_TOKEN = ':self';
	var SELF_TOKEN_REGEX = new RegExp("s*" + SELF_TOKEN + "s*,?", 'g');
	/**
	 * @param {?} driver
	 * @param {?} metadata
	 * @param {?} errors
	 * @return {?}
	 */
	function buildAnimationAst(driver, metadata, errors) {
	    return new AnimationAstBuilderVisitor(driver).build(metadata, errors);
	}
	var ROOT_SELECTOR = '';
	var AnimationAstBuilderVisitor = /** @class */ (function () {
	    function AnimationAstBuilderVisitor(_driver) {
	        this._driver = _driver;
	    }
	    /**
	     * @param {?} metadata
	     * @param {?} errors
	     * @return {?}
	     */
	    AnimationAstBuilderVisitor.prototype.build = /**
	     * @param {?} metadata
	     * @param {?} errors
	     * @return {?}
	     */
	    function (metadata, errors) {
	        var /** @type {?} */ context = new AnimationAstBuilderContext(errors);
	        this._resetContextStyleTimingState(context);
	        return /** @type {?} */ (visitDslNode(this, normalizeAnimationEntry(metadata), context));
	    };
	    /**
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationAstBuilderVisitor.prototype._resetContextStyleTimingState = /**
	     * @param {?} context
	     * @return {?}
	     */
	    function (context) {
	        context.currentQuerySelector = ROOT_SELECTOR;
	        context.collectedStyles = {};
	        context.collectedStyles[ROOT_SELECTOR] = {};
	        context.currentTime = 0;
	    };
	    /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationAstBuilderVisitor.prototype.visitTrigger = /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    function (metadata, context) {
	        var _this = this;
	        var /** @type {?} */ queryCount = context.queryCount = 0;
	        var /** @type {?} */ depCount = context.depCount = 0;
	        var /** @type {?} */ states = [];
	        var /** @type {?} */ transitions = [];
	        if (metadata.name.charAt(0) == '@') {
	            context.errors.push('animation triggers cannot be prefixed with an `@` sign (e.g. trigger(\'@foo\', [...]))');
	        }
	        metadata.definitions.forEach(function (def) {
	            _this._resetContextStyleTimingState(context);
	            if (def.type == 0 /* State */) {
	                var /** @type {?} */ stateDef_1 = /** @type {?} */ (def);
	                var /** @type {?} */ name_1 = stateDef_1.name;
	                name_1.split(/\s*,\s*/).forEach(function (n) {
	                    stateDef_1.name = n;
	                    states.push(_this.visitState(stateDef_1, context));
	                });
	                stateDef_1.name = name_1;
	            }
	            else if (def.type == 1 /* Transition */) {
	                var /** @type {?} */ transition = _this.visitTransition(/** @type {?} */ (def), context);
	                queryCount += transition.queryCount;
	                depCount += transition.depCount;
	                transitions.push(transition);
	            }
	            else {
	                context.errors.push('only state() and transition() definitions can sit inside of a trigger()');
	            }
	        });
	        return {
	            type: 7 /* Trigger */,
	            name: metadata.name, states: states, transitions: transitions, queryCount: queryCount, depCount: depCount,
	            options: null
	        };
	    };
	    /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationAstBuilderVisitor.prototype.visitState = /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    function (metadata, context) {
	        var /** @type {?} */ styleAst = this.visitStyle(metadata.styles, context);
	        var /** @type {?} */ astParams = (metadata.options && metadata.options.params) || null;
	        if (styleAst.containsDynamicStyles) {
	            var /** @type {?} */ missingSubs_1 = new Set();
	            var /** @type {?} */ params_1 = astParams || {};
	            styleAst.styles.forEach(function (value) {
	                if (isObject(value)) {
	                    var /** @type {?} */ stylesObj_1 = /** @type {?} */ (value);
	                    Object.keys(stylesObj_1).forEach(function (prop) {
	                        extractStyleParams(stylesObj_1[prop]).forEach(function (sub) {
	                            if (!params_1.hasOwnProperty(sub)) {
	                                missingSubs_1.add(sub);
	                            }
	                        });
	                    });
	                }
	            });
	            if (missingSubs_1.size) {
	                var /** @type {?} */ missingSubsArr = iteratorToArray(missingSubs_1.values());
	                context.errors.push("state(\"" + metadata.name + "\", ...) must define default values for all the following style substitutions: " + missingSubsArr.join(', '));
	            }
	        }
	        return {
	            type: 0 /* State */,
	            name: metadata.name,
	            style: styleAst,
	            options: astParams ? { params: astParams } : null
	        };
	    };
	    /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationAstBuilderVisitor.prototype.visitTransition = /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    function (metadata, context) {
	        context.queryCount = 0;
	        context.depCount = 0;
	        var /** @type {?} */ animation = visitDslNode(this, normalizeAnimationEntry(metadata.animation), context);
	        var /** @type {?} */ matchers = parseTransitionExpr(metadata.expr, context.errors);
	        return {
	            type: 1 /* Transition */,
	            matchers: matchers,
	            animation: animation,
	            queryCount: context.queryCount,
	            depCount: context.depCount,
	            options: normalizeAnimationOptions(metadata.options)
	        };
	    };
	    /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationAstBuilderVisitor.prototype.visitSequence = /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    function (metadata, context) {
	        var _this = this;
	        return {
	            type: 2 /* Sequence */,
	            steps: metadata.steps.map(function (s) { return visitDslNode(_this, s, context); }),
	            options: normalizeAnimationOptions(metadata.options)
	        };
	    };
	    /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationAstBuilderVisitor.prototype.visitGroup = /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    function (metadata, context) {
	        var _this = this;
	        var /** @type {?} */ currentTime = context.currentTime;
	        var /** @type {?} */ furthestTime = 0;
	        var /** @type {?} */ steps = metadata.steps.map(function (step) {
	            context.currentTime = currentTime;
	            var /** @type {?} */ innerAst = visitDslNode(_this, step, context);
	            furthestTime = Math.max(furthestTime, context.currentTime);
	            return innerAst;
	        });
	        context.currentTime = furthestTime;
	        return {
	            type: 3 /* Group */,
	            steps: steps,
	            options: normalizeAnimationOptions(metadata.options)
	        };
	    };
	    /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationAstBuilderVisitor.prototype.visitAnimate = /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    function (metadata, context) {
	        var /** @type {?} */ timingAst = constructTimingAst(metadata.timings, context.errors);
	        context.currentAnimateTimings = timingAst;
	        var /** @type {?} */ styleAst;
	        var /** @type {?} */ styleMetadata = metadata.styles ? metadata.styles : _angular_animations.style({});
	        if (styleMetadata.type == 5 /* Keyframes */) {
	            styleAst = this.visitKeyframes(/** @type {?} */ (styleMetadata), context);
	        }
	        else {
	            var /** @type {?} */ styleMetadata_1 = /** @type {?} */ (metadata.styles);
	            var /** @type {?} */ isEmpty = false;
	            if (!styleMetadata_1) {
	                isEmpty = true;
	                var /** @type {?} */ newStyleData = {};
	                if (timingAst.easing) {
	                    newStyleData['easing'] = timingAst.easing;
	                }
	                styleMetadata_1 = _angular_animations.style(newStyleData);
	            }
	            context.currentTime += timingAst.duration + timingAst.delay;
	            var /** @type {?} */ _styleAst = this.visitStyle(styleMetadata_1, context);
	            _styleAst.isEmptyStep = isEmpty;
	            styleAst = _styleAst;
	        }
	        context.currentAnimateTimings = null;
	        return {
	            type: 4 /* Animate */,
	            timings: timingAst,
	            style: styleAst,
	            options: null
	        };
	    };
	    /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationAstBuilderVisitor.prototype.visitStyle = /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    function (metadata, context) {
	        var /** @type {?} */ ast = this._makeStyleAst(metadata, context);
	        this._validateStyleAst(ast, context);
	        return ast;
	    };
	    /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationAstBuilderVisitor.prototype._makeStyleAst = /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    function (metadata, context) {
	        var /** @type {?} */ styles = [];
	        if (Array.isArray(metadata.styles)) {
	            (/** @type {?} */ (metadata.styles)).forEach(function (styleTuple) {
	                if (typeof styleTuple == 'string') {
	                    if (styleTuple == _angular_animations.AUTO_STYLE) {
	                        styles.push(/** @type {?} */ (styleTuple));
	                    }
	                    else {
	                        context.errors.push("The provided style string value " + styleTuple + " is not allowed.");
	                    }
	                }
	                else {
	                    styles.push(/** @type {?} */ (styleTuple));
	                }
	            });
	        }
	        else {
	            styles.push(metadata.styles);
	        }
	        var /** @type {?} */ containsDynamicStyles = false;
	        var /** @type {?} */ collectedEasing = null;
	        styles.forEach(function (styleData) {
	            if (isObject(styleData)) {
	                var /** @type {?} */ styleMap = /** @type {?} */ (styleData);
	                var /** @type {?} */ easing = styleMap['easing'];
	                if (easing) {
	                    collectedEasing = /** @type {?} */ (easing);
	                    delete styleMap['easing'];
	                }
	                if (!containsDynamicStyles) {
	                    for (var /** @type {?} */ prop in styleMap) {
	                        var /** @type {?} */ value = styleMap[prop];
	                        if (value.toString().indexOf(SUBSTITUTION_EXPR_START) >= 0) {
	                            containsDynamicStyles = true;
	                            break;
	                        }
	                    }
	                }
	            }
	        });
	        return {
	            type: 6 /* Style */,
	            styles: styles,
	            easing: collectedEasing,
	            offset: metadata.offset, containsDynamicStyles: containsDynamicStyles,
	            options: null
	        };
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationAstBuilderVisitor.prototype._validateStyleAst = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var _this = this;
	        var /** @type {?} */ timings = context.currentAnimateTimings;
	        var /** @type {?} */ endTime = context.currentTime;
	        var /** @type {?} */ startTime = context.currentTime;
	        if (timings && startTime > 0) {
	            startTime -= timings.duration + timings.delay;
	        }
	        ast.styles.forEach(function (tuple) {
	            if (typeof tuple == 'string')
	                return;
	            Object.keys(tuple).forEach(function (prop) {
	                if (!_this._driver.validateStyleProperty(prop)) {
	                    context.errors.push("The provided animation property \"" + prop + "\" is not a supported CSS property for animations");
	                    return;
	                }
	                var /** @type {?} */ collectedStyles = context.collectedStyles[/** @type {?} */ ((context.currentQuerySelector))];
	                var /** @type {?} */ collectedEntry = collectedStyles[prop];
	                var /** @type {?} */ updateCollectedStyle = true;
	                if (collectedEntry) {
	                    if (startTime != endTime && startTime >= collectedEntry.startTime &&
	                        endTime <= collectedEntry.endTime) {
	                        context.errors.push("The CSS property \"" + prop + "\" that exists between the times of \"" + collectedEntry.startTime + "ms\" and \"" + collectedEntry.endTime + "ms\" is also being animated in a parallel animation between the times of \"" + startTime + "ms\" and \"" + endTime + "ms\"");
	                        updateCollectedStyle = false;
	                    }
	                    // we always choose the smaller start time value since we
	                    // want to have a record of the entire animation window where
	                    // the style property is being animated in between
	                    startTime = collectedEntry.startTime;
	                }
	                if (updateCollectedStyle) {
	                    collectedStyles[prop] = { startTime: startTime, endTime: endTime };
	                }
	                if (context.options) {
	                    validateStyleParams(tuple[prop], context.options, context.errors);
	                }
	            });
	        });
	    };
	    /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationAstBuilderVisitor.prototype.visitKeyframes = /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    function (metadata, context) {
	        var _this = this;
	        var /** @type {?} */ ast = { type: 5 /* Keyframes */, styles: [], options: null };
	        if (!context.currentAnimateTimings) {
	            context.errors.push("keyframes() must be placed inside of a call to animate()");
	            return ast;
	        }
	        var /** @type {?} */ MAX_KEYFRAME_OFFSET = 1;
	        var /** @type {?} */ totalKeyframesWithOffsets = 0;
	        var /** @type {?} */ offsets = [];
	        var /** @type {?} */ offsetsOutOfOrder = false;
	        var /** @type {?} */ keyframesOutOfRange = false;
	        var /** @type {?} */ previousOffset = 0;
	        var /** @type {?} */ keyframes = metadata.steps.map(function (styles) {
	            var /** @type {?} */ style$$1 = _this._makeStyleAst(styles, context);
	            var /** @type {?} */ offsetVal = style$$1.offset != null ? style$$1.offset : consumeOffset(style$$1.styles);
	            var /** @type {?} */ offset = 0;
	            if (offsetVal != null) {
	                totalKeyframesWithOffsets++;
	                offset = style$$1.offset = offsetVal;
	            }
	            keyframesOutOfRange = keyframesOutOfRange || offset < 0 || offset > 1;
	            offsetsOutOfOrder = offsetsOutOfOrder || offset < previousOffset;
	            previousOffset = offset;
	            offsets.push(offset);
	            return style$$1;
	        });
	        if (keyframesOutOfRange) {
	            context.errors.push("Please ensure that all keyframe offsets are between 0 and 1");
	        }
	        if (offsetsOutOfOrder) {
	            context.errors.push("Please ensure that all keyframe offsets are in order");
	        }
	        var /** @type {?} */ length = metadata.steps.length;
	        var /** @type {?} */ generatedOffset = 0;
	        if (totalKeyframesWithOffsets > 0 && totalKeyframesWithOffsets < length) {
	            context.errors.push("Not all style() steps within the declared keyframes() contain offsets");
	        }
	        else if (totalKeyframesWithOffsets == 0) {
	            generatedOffset = MAX_KEYFRAME_OFFSET / (length - 1);
	        }
	        var /** @type {?} */ limit = length - 1;
	        var /** @type {?} */ currentTime = context.currentTime;
	        var /** @type {?} */ currentAnimateTimings = /** @type {?} */ ((context.currentAnimateTimings));
	        var /** @type {?} */ animateDuration = currentAnimateTimings.duration;
	        keyframes.forEach(function (kf, i) {
	            var /** @type {?} */ offset = generatedOffset > 0 ? (i == limit ? 1 : (generatedOffset * i)) : offsets[i];
	            var /** @type {?} */ durationUpToThisFrame = offset * animateDuration;
	            context.currentTime = currentTime + currentAnimateTimings.delay + durationUpToThisFrame;
	            currentAnimateTimings.duration = durationUpToThisFrame;
	            _this._validateStyleAst(kf, context);
	            kf.offset = offset;
	            ast.styles.push(kf);
	        });
	        return ast;
	    };
	    /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationAstBuilderVisitor.prototype.visitReference = /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    function (metadata, context) {
	        return {
	            type: 8 /* Reference */,
	            animation: visitDslNode(this, normalizeAnimationEntry(metadata.animation), context),
	            options: normalizeAnimationOptions(metadata.options)
	        };
	    };
	    /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationAstBuilderVisitor.prototype.visitAnimateChild = /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    function (metadata, context) {
	        context.depCount++;
	        return {
	            type: 9 /* AnimateChild */,
	            options: normalizeAnimationOptions(metadata.options)
	        };
	    };
	    /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationAstBuilderVisitor.prototype.visitAnimateRef = /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    function (metadata, context) {
	        return {
	            type: 10 /* AnimateRef */,
	            animation: this.visitReference(metadata.animation, context),
	            options: normalizeAnimationOptions(metadata.options)
	        };
	    };
	    /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationAstBuilderVisitor.prototype.visitQuery = /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    function (metadata, context) {
	        var /** @type {?} */ parentSelector = /** @type {?} */ ((context.currentQuerySelector));
	        var /** @type {?} */ options = /** @type {?} */ ((metadata.options || {}));
	        context.queryCount++;
	        context.currentQuery = metadata;
	        var _a = normalizeSelector(metadata.selector), selector = _a[0], includeSelf = _a[1];
	        context.currentQuerySelector =
	            parentSelector.length ? (parentSelector + ' ' + selector) : selector;
	        getOrSetAsInMap(context.collectedStyles, context.currentQuerySelector, {});
	        var /** @type {?} */ animation = visitDslNode(this, normalizeAnimationEntry(metadata.animation), context);
	        context.currentQuery = null;
	        context.currentQuerySelector = parentSelector;
	        return {
	            type: 11 /* Query */,
	            selector: selector,
	            limit: options.limit || 0,
	            optional: !!options.optional, includeSelf: includeSelf, animation: animation,
	            originalSelector: metadata.selector,
	            options: normalizeAnimationOptions(metadata.options)
	        };
	    };
	    /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationAstBuilderVisitor.prototype.visitStagger = /**
	     * @param {?} metadata
	     * @param {?} context
	     * @return {?}
	     */
	    function (metadata, context) {
	        if (!context.currentQuery) {
	            context.errors.push("stagger() can only be used inside of query()");
	        }
	        var /** @type {?} */ timings = metadata.timings === 'full' ?
	            { duration: 0, delay: 0, easing: 'full' } :
	            resolveTiming(metadata.timings, context.errors, true);
	        return {
	            type: 12 /* Stagger */,
	            animation: visitDslNode(this, normalizeAnimationEntry(metadata.animation), context), timings: timings,
	            options: null
	        };
	    };
	    return AnimationAstBuilderVisitor;
	}());
	/**
	 * @param {?} selector
	 * @return {?}
	 */
	function normalizeSelector(selector) {
	    var /** @type {?} */ hasAmpersand = selector.split(/\s*,\s*/).find(function (token) { return token == SELF_TOKEN; }) ? true : false;
	    if (hasAmpersand) {
	        selector = selector.replace(SELF_TOKEN_REGEX, '');
	    }
	    // the :enter and :leave selectors are filled in at runtime during timeline building
	    selector = selector.replace(/@\*/g, NG_TRIGGER_SELECTOR)
	        .replace(/@\w+/g, function (match) { return NG_TRIGGER_SELECTOR + '-' + match.substr(1); })
	        .replace(/:animating/g, NG_ANIMATING_SELECTOR);
	    return [selector, hasAmpersand];
	}
	/**
	 * @param {?} obj
	 * @return {?}
	 */
	function normalizeParams(obj) {
	    return obj ? copyObj(obj) : null;
	}
	var AnimationAstBuilderContext = /** @class */ (function () {
	    function AnimationAstBuilderContext(errors) {
	        this.errors = errors;
	        this.queryCount = 0;
	        this.depCount = 0;
	        this.currentTransition = null;
	        this.currentQuery = null;
	        this.currentQuerySelector = null;
	        this.currentAnimateTimings = null;
	        this.currentTime = 0;
	        this.collectedStyles = {};
	        this.options = null;
	    }
	    return AnimationAstBuilderContext;
	}());
	/**
	 * @param {?} styles
	 * @return {?}
	 */
	function consumeOffset(styles) {
	    if (typeof styles == 'string')
	        return null;
	    var /** @type {?} */ offset = null;
	    if (Array.isArray(styles)) {
	        styles.forEach(function (styleTuple) {
	            if (isObject(styleTuple) && styleTuple.hasOwnProperty('offset')) {
	                var /** @type {?} */ obj = /** @type {?} */ (styleTuple);
	                offset = parseFloat(/** @type {?} */ (obj['offset']));
	                delete obj['offset'];
	            }
	        });
	    }
	    else if (isObject(styles) && styles.hasOwnProperty('offset')) {
	        var /** @type {?} */ obj = /** @type {?} */ (styles);
	        offset = parseFloat(/** @type {?} */ (obj['offset']));
	        delete obj['offset'];
	    }
	    return offset;
	}
	/**
	 * @param {?} value
	 * @return {?}
	 */
	function isObject(value) {
	    return !Array.isArray(value) && typeof value == 'object';
	}
	/**
	 * @param {?} value
	 * @param {?} errors
	 * @return {?}
	 */
	function constructTimingAst(value, errors) {
	    var /** @type {?} */ timings = null;
	    if (value.hasOwnProperty('duration')) {
	        timings = /** @type {?} */ (value);
	    }
	    else if (typeof value == 'number') {
	        var /** @type {?} */ duration = resolveTiming(/** @type {?} */ (value), errors).duration;
	        return makeTimingAst(/** @type {?} */ (duration), 0, '');
	    }
	    var /** @type {?} */ strValue = /** @type {?} */ (value);
	    var /** @type {?} */ isDynamic = strValue.split(/\s+/).some(function (v) { return v.charAt(0) == '{' && v.charAt(1) == '{'; });
	    if (isDynamic) {
	        var /** @type {?} */ ast = /** @type {?} */ (makeTimingAst(0, 0, ''));
	        ast.dynamic = true;
	        ast.strValue = strValue;
	        return /** @type {?} */ (ast);
	    }
	    timings = timings || resolveTiming(strValue, errors);
	    return makeTimingAst(timings.duration, timings.delay, timings.easing);
	}
	/**
	 * @param {?} options
	 * @return {?}
	 */
	function normalizeAnimationOptions(options) {
	    if (options) {
	        options = copyObj(options);
	        if (options['params']) {
	            options['params'] = /** @type {?} */ ((normalizeParams(options['params'])));
	        }
	    }
	    else {
	        options = {};
	    }
	    return options;
	}
	/**
	 * @param {?} duration
	 * @param {?} delay
	 * @param {?} easing
	 * @return {?}
	 */
	function makeTimingAst(duration, delay, easing) {
	    return { duration: duration, delay: delay, easing: easing };
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @record
	 */
	
	/**
	 * @param {?} element
	 * @param {?} keyframes
	 * @param {?} preStyleProps
	 * @param {?} postStyleProps
	 * @param {?} duration
	 * @param {?} delay
	 * @param {?=} easing
	 * @param {?=} subTimeline
	 * @return {?}
	 */
	function createTimelineInstruction(element, keyframes, preStyleProps, postStyleProps, duration, delay, easing, subTimeline) {
	    if (easing === void 0) { easing = null; }
	    if (subTimeline === void 0) { subTimeline = false; }
	    return {
	        type: 1 /* TimelineAnimation */,
	        element: element,
	        keyframes: keyframes,
	        preStyleProps: preStyleProps,
	        postStyleProps: postStyleProps,
	        duration: duration,
	        delay: delay,
	        totalTime: duration + delay, easing: easing, subTimeline: subTimeline
	    };
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var ElementInstructionMap = /** @class */ (function () {
	    function ElementInstructionMap() {
	        this._map = new Map();
	    }
	    /**
	     * @param {?} element
	     * @return {?}
	     */
	    ElementInstructionMap.prototype.consume = /**
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) {
	        var /** @type {?} */ instructions = this._map.get(element);
	        if (instructions) {
	            this._map.delete(element);
	        }
	        else {
	            instructions = [];
	        }
	        return instructions;
	    };
	    /**
	     * @param {?} element
	     * @param {?} instructions
	     * @return {?}
	     */
	    ElementInstructionMap.prototype.append = /**
	     * @param {?} element
	     * @param {?} instructions
	     * @return {?}
	     */
	    function (element, instructions) {
	        var /** @type {?} */ existingInstructions = this._map.get(element);
	        if (!existingInstructions) {
	            this._map.set(element, existingInstructions = []);
	        }
	        existingInstructions.push.apply(existingInstructions, instructions);
	    };
	    /**
	     * @param {?} element
	     * @return {?}
	     */
	    ElementInstructionMap.prototype.has = /**
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) { return this._map.has(element); };
	    /**
	     * @return {?}
	     */
	    ElementInstructionMap.prototype.clear = /**
	     * @return {?}
	     */
	    function () { this._map.clear(); };
	    return ElementInstructionMap;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var ONE_FRAME_IN_MILLISECONDS = 1;
	var ENTER_TOKEN = ':enter';
	var ENTER_TOKEN_REGEX = new RegExp(ENTER_TOKEN, 'g');
	var LEAVE_TOKEN = ':leave';
	var LEAVE_TOKEN_REGEX = new RegExp(LEAVE_TOKEN, 'g');
	/**
	 * @param {?} driver
	 * @param {?} rootElement
	 * @param {?} ast
	 * @param {?} enterClassName
	 * @param {?} leaveClassName
	 * @param {?=} startingStyles
	 * @param {?=} finalStyles
	 * @param {?=} options
	 * @param {?=} subInstructions
	 * @param {?=} errors
	 * @return {?}
	 */
	function buildAnimationTimelines(driver, rootElement, ast, enterClassName, leaveClassName, startingStyles, finalStyles, options, subInstructions, errors) {
	    if (startingStyles === void 0) { startingStyles = {}; }
	    if (finalStyles === void 0) { finalStyles = {}; }
	    if (errors === void 0) { errors = []; }
	    return new AnimationTimelineBuilderVisitor().buildKeyframes(driver, rootElement, ast, enterClassName, leaveClassName, startingStyles, finalStyles, options, subInstructions, errors);
	}
	var AnimationTimelineBuilderVisitor = /** @class */ (function () {
	    function AnimationTimelineBuilderVisitor() {
	    }
	    /**
	     * @param {?} driver
	     * @param {?} rootElement
	     * @param {?} ast
	     * @param {?} enterClassName
	     * @param {?} leaveClassName
	     * @param {?} startingStyles
	     * @param {?} finalStyles
	     * @param {?} options
	     * @param {?=} subInstructions
	     * @param {?=} errors
	     * @return {?}
	     */
	    AnimationTimelineBuilderVisitor.prototype.buildKeyframes = /**
	     * @param {?} driver
	     * @param {?} rootElement
	     * @param {?} ast
	     * @param {?} enterClassName
	     * @param {?} leaveClassName
	     * @param {?} startingStyles
	     * @param {?} finalStyles
	     * @param {?} options
	     * @param {?=} subInstructions
	     * @param {?=} errors
	     * @return {?}
	     */
	    function (driver, rootElement, ast, enterClassName, leaveClassName, startingStyles, finalStyles, options, subInstructions, errors) {
	        if (errors === void 0) { errors = []; }
	        subInstructions = subInstructions || new ElementInstructionMap();
	        var /** @type {?} */ context = new AnimationTimelineContext(driver, rootElement, subInstructions, enterClassName, leaveClassName, errors, []);
	        context.options = options;
	        context.currentTimeline.setStyles([startingStyles], null, context.errors, options);
	        visitDslNode(this, ast, context);
	        // this checks to see if an actual animation happened
	        var /** @type {?} */ timelines = context.timelines.filter(function (timeline) { return timeline.containsAnimation(); });
	        if (timelines.length && Object.keys(finalStyles).length) {
	            var /** @type {?} */ tl = timelines[timelines.length - 1];
	            if (!tl.allowOnlyTimelineStyles()) {
	                tl.setStyles([finalStyles], null, context.errors, options);
	            }
	        }
	        return timelines.length ? timelines.map(function (timeline) { return timeline.buildKeyframes(); }) :
	            [createTimelineInstruction(rootElement, [], [], [], 0, 0, '', false)];
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationTimelineBuilderVisitor.prototype.visitTrigger = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        // these values are not visited in this AST
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationTimelineBuilderVisitor.prototype.visitState = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        // these values are not visited in this AST
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationTimelineBuilderVisitor.prototype.visitTransition = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        // these values are not visited in this AST
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationTimelineBuilderVisitor.prototype.visitAnimateChild = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var /** @type {?} */ elementInstructions = context.subInstructions.consume(context.element);
	        if (elementInstructions) {
	            var /** @type {?} */ innerContext = context.createSubContext(ast.options);
	            var /** @type {?} */ startTime = context.currentTimeline.currentTime;
	            var /** @type {?} */ endTime = this._visitSubInstructions(elementInstructions, innerContext, /** @type {?} */ (innerContext.options));
	            if (startTime != endTime) {
	                // we do this on the upper context because we created a sub context for
	                // the sub child animations
	                context.transformIntoNewTimeline(endTime);
	            }
	        }
	        context.previousNode = ast;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationTimelineBuilderVisitor.prototype.visitAnimateRef = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var /** @type {?} */ innerContext = context.createSubContext(ast.options);
	        innerContext.transformIntoNewTimeline();
	        this.visitReference(ast.animation, innerContext);
	        context.transformIntoNewTimeline(innerContext.currentTimeline.currentTime);
	        context.previousNode = ast;
	    };
	    /**
	     * @param {?} instructions
	     * @param {?} context
	     * @param {?} options
	     * @return {?}
	     */
	    AnimationTimelineBuilderVisitor.prototype._visitSubInstructions = /**
	     * @param {?} instructions
	     * @param {?} context
	     * @param {?} options
	     * @return {?}
	     */
	    function (instructions, context, options) {
	        var /** @type {?} */ startTime = context.currentTimeline.currentTime;
	        var /** @type {?} */ furthestTime = startTime;
	        // this is a special-case for when a user wants to skip a sub
	        // animation from being fired entirely.
	        var /** @type {?} */ duration = options.duration != null ? resolveTimingValue(options.duration) : null;
	        var /** @type {?} */ delay = options.delay != null ? resolveTimingValue(options.delay) : null;
	        if (duration !== 0) {
	            instructions.forEach(function (instruction) {
	                var /** @type {?} */ instructionTimings = context.appendInstructionToTimeline(instruction, duration, delay);
	                furthestTime =
	                    Math.max(furthestTime, instructionTimings.duration + instructionTimings.delay);
	            });
	        }
	        return furthestTime;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationTimelineBuilderVisitor.prototype.visitReference = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        context.updateOptions(ast.options, true);
	        visitDslNode(this, ast.animation, context);
	        context.previousNode = ast;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationTimelineBuilderVisitor.prototype.visitSequence = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var _this = this;
	        var /** @type {?} */ subContextCount = context.subContextCount;
	        var /** @type {?} */ ctx = context;
	        var /** @type {?} */ options = ast.options;
	        if (options && (options.params || options.delay)) {
	            ctx = context.createSubContext(options);
	            ctx.transformIntoNewTimeline();
	            if (options.delay != null) {
	                if (ctx.previousNode.type == 6 /* Style */) {
	                    ctx.currentTimeline.snapshotCurrentStyles();
	                    ctx.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
	                }
	                var /** @type {?} */ delay = resolveTimingValue(options.delay);
	                ctx.delayNextStep(delay);
	            }
	        }
	        if (ast.steps.length) {
	            ast.steps.forEach(function (s) { return visitDslNode(_this, s, ctx); });
	            // this is here just incase the inner steps only contain or end with a style() call
	            ctx.currentTimeline.applyStylesToKeyframe();
	            // this means that some animation function within the sequence
	            // ended up creating a sub timeline (which means the current
	            // timeline cannot overlap with the contents of the sequence)
	            if (ctx.subContextCount > subContextCount) {
	                ctx.transformIntoNewTimeline();
	            }
	        }
	        context.previousNode = ast;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationTimelineBuilderVisitor.prototype.visitGroup = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var _this = this;
	        var /** @type {?} */ innerTimelines = [];
	        var /** @type {?} */ furthestTime = context.currentTimeline.currentTime;
	        var /** @type {?} */ delay = ast.options && ast.options.delay ? resolveTimingValue(ast.options.delay) : 0;
	        ast.steps.forEach(function (s) {
	            var /** @type {?} */ innerContext = context.createSubContext(ast.options);
	            if (delay) {
	                innerContext.delayNextStep(delay);
	            }
	            visitDslNode(_this, s, innerContext);
	            furthestTime = Math.max(furthestTime, innerContext.currentTimeline.currentTime);
	            innerTimelines.push(innerContext.currentTimeline);
	        });
	        // this operation is run after the AST loop because otherwise
	        // if the parent timeline's collected styles were updated then
	        // it would pass in invalid data into the new-to-be forked items
	        innerTimelines.forEach(function (timeline) { return context.currentTimeline.mergeTimelineCollectedStyles(timeline); });
	        context.transformIntoNewTimeline(furthestTime);
	        context.previousNode = ast;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationTimelineBuilderVisitor.prototype._visitTiming = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        if ((/** @type {?} */ (ast)).dynamic) {
	            var /** @type {?} */ strValue = (/** @type {?} */ (ast)).strValue;
	            var /** @type {?} */ timingValue = context.params ? interpolateParams(strValue, context.params, context.errors) : strValue;
	            return resolveTiming(timingValue, context.errors);
	        }
	        else {
	            return { duration: ast.duration, delay: ast.delay, easing: ast.easing };
	        }
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationTimelineBuilderVisitor.prototype.visitAnimate = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var /** @type {?} */ timings = context.currentAnimateTimings = this._visitTiming(ast.timings, context);
	        var /** @type {?} */ timeline = context.currentTimeline;
	        if (timings.delay) {
	            context.incrementTime(timings.delay);
	            timeline.snapshotCurrentStyles();
	        }
	        var /** @type {?} */ style$$1 = ast.style;
	        if (style$$1.type == 5 /* Keyframes */) {
	            this.visitKeyframes(style$$1, context);
	        }
	        else {
	            context.incrementTime(timings.duration);
	            this.visitStyle(/** @type {?} */ (style$$1), context);
	            timeline.applyStylesToKeyframe();
	        }
	        context.currentAnimateTimings = null;
	        context.previousNode = ast;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationTimelineBuilderVisitor.prototype.visitStyle = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var /** @type {?} */ timeline = context.currentTimeline;
	        var /** @type {?} */ timings = /** @type {?} */ ((context.currentAnimateTimings));
	        // this is a special case for when a style() call
	        // directly follows  an animate() call (but not inside of an animate() call)
	        if (!timings && timeline.getCurrentStyleProperties().length) {
	            timeline.forwardFrame();
	        }
	        var /** @type {?} */ easing = (timings && timings.easing) || ast.easing;
	        if (ast.isEmptyStep) {
	            timeline.applyEmptyStep(easing);
	        }
	        else {
	            timeline.setStyles(ast.styles, easing, context.errors, context.options);
	        }
	        context.previousNode = ast;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationTimelineBuilderVisitor.prototype.visitKeyframes = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var /** @type {?} */ currentAnimateTimings = /** @type {?} */ ((context.currentAnimateTimings));
	        var /** @type {?} */ startTime = (/** @type {?} */ ((context.currentTimeline))).duration;
	        var /** @type {?} */ duration = currentAnimateTimings.duration;
	        var /** @type {?} */ innerContext = context.createSubContext();
	        var /** @type {?} */ innerTimeline = innerContext.currentTimeline;
	        innerTimeline.easing = currentAnimateTimings.easing;
	        ast.styles.forEach(function (step) {
	            var /** @type {?} */ offset = step.offset || 0;
	            innerTimeline.forwardTime(offset * duration);
	            innerTimeline.setStyles(step.styles, step.easing, context.errors, context.options);
	            innerTimeline.applyStylesToKeyframe();
	        });
	        // this will ensure that the parent timeline gets all the styles from
	        // the child even if the new timeline below is not used
	        context.currentTimeline.mergeTimelineCollectedStyles(innerTimeline);
	        // we do this because the window between this timeline and the sub timeline
	        // should ensure that the styles within are exactly the same as they were before
	        context.transformIntoNewTimeline(startTime + duration);
	        context.previousNode = ast;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationTimelineBuilderVisitor.prototype.visitQuery = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var _this = this;
	        // in the event that the first step before this is a style step we need
	        // to ensure the styles are applied before the children are animated
	        var /** @type {?} */ startTime = context.currentTimeline.currentTime;
	        var /** @type {?} */ options = /** @type {?} */ ((ast.options || {}));
	        var /** @type {?} */ delay = options.delay ? resolveTimingValue(options.delay) : 0;
	        if (delay && (context.previousNode.type === 6 /* Style */ ||
	            (startTime == 0 && context.currentTimeline.getCurrentStyleProperties().length))) {
	            context.currentTimeline.snapshotCurrentStyles();
	            context.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
	        }
	        var /** @type {?} */ furthestTime = startTime;
	        var /** @type {?} */ elms = context.invokeQuery(ast.selector, ast.originalSelector, ast.limit, ast.includeSelf, options.optional ? true : false, context.errors);
	        context.currentQueryTotal = elms.length;
	        var /** @type {?} */ sameElementTimeline = null;
	        elms.forEach(function (element, i) {
	            context.currentQueryIndex = i;
	            var /** @type {?} */ innerContext = context.createSubContext(ast.options, element);
	            if (delay) {
	                innerContext.delayNextStep(delay);
	            }
	            if (element === context.element) {
	                sameElementTimeline = innerContext.currentTimeline;
	            }
	            visitDslNode(_this, ast.animation, innerContext);
	            // this is here just incase the inner steps only contain or end
	            // with a style() call (which is here to signal that this is a preparatory
	            // call to style an element before it is animated again)
	            innerContext.currentTimeline.applyStylesToKeyframe();
	            var /** @type {?} */ endTime = innerContext.currentTimeline.currentTime;
	            furthestTime = Math.max(furthestTime, endTime);
	        });
	        context.currentQueryIndex = 0;
	        context.currentQueryTotal = 0;
	        context.transformIntoNewTimeline(furthestTime);
	        if (sameElementTimeline) {
	            context.currentTimeline.mergeTimelineCollectedStyles(sameElementTimeline);
	            context.currentTimeline.snapshotCurrentStyles();
	        }
	        context.previousNode = ast;
	    };
	    /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationTimelineBuilderVisitor.prototype.visitStagger = /**
	     * @param {?} ast
	     * @param {?} context
	     * @return {?}
	     */
	    function (ast, context) {
	        var /** @type {?} */ parentContext = /** @type {?} */ ((context.parentContext));
	        var /** @type {?} */ tl = context.currentTimeline;
	        var /** @type {?} */ timings = ast.timings;
	        var /** @type {?} */ duration = Math.abs(timings.duration);
	        var /** @type {?} */ maxTime = duration * (context.currentQueryTotal - 1);
	        var /** @type {?} */ delay = duration * context.currentQueryIndex;
	        var /** @type {?} */ staggerTransformer = timings.duration < 0 ? 'reverse' : timings.easing;
	        switch (staggerTransformer) {
	            case 'reverse':
	                delay = maxTime - delay;
	                break;
	            case 'full':
	                delay = parentContext.currentStaggerTime;
	                break;
	        }
	        var /** @type {?} */ timeline = context.currentTimeline;
	        if (delay) {
	            timeline.delayNextStep(delay);
	        }
	        var /** @type {?} */ startingTime = timeline.currentTime;
	        visitDslNode(this, ast.animation, context);
	        context.previousNode = ast;
	        // time = duration + delay
	        // the reason why this computation is so complex is because
	        // the inner timeline may either have a delay value or a stretched
	        // keyframe depending on if a subtimeline is not used or is used.
	        parentContext.currentStaggerTime =
	            (tl.currentTime - startingTime) + (tl.startTime - parentContext.currentTimeline.startTime);
	    };
	    return AnimationTimelineBuilderVisitor;
	}());
	var DEFAULT_NOOP_PREVIOUS_NODE = /** @type {?} */ ({});
	var AnimationTimelineContext = /** @class */ (function () {
	    function AnimationTimelineContext(_driver, element, subInstructions, _enterClassName, _leaveClassName, errors, timelines, initialTimeline) {
	        this._driver = _driver;
	        this.element = element;
	        this.subInstructions = subInstructions;
	        this._enterClassName = _enterClassName;
	        this._leaveClassName = _leaveClassName;
	        this.errors = errors;
	        this.timelines = timelines;
	        this.parentContext = null;
	        this.currentAnimateTimings = null;
	        this.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
	        this.subContextCount = 0;
	        this.options = {};
	        this.currentQueryIndex = 0;
	        this.currentQueryTotal = 0;
	        this.currentStaggerTime = 0;
	        this.currentTimeline = initialTimeline || new TimelineBuilder(this._driver, element, 0);
	        timelines.push(this.currentTimeline);
	    }
	    Object.defineProperty(AnimationTimelineContext.prototype, "params", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.options.params; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} options
	     * @param {?=} skipIfExists
	     * @return {?}
	     */
	    AnimationTimelineContext.prototype.updateOptions = /**
	     * @param {?} options
	     * @param {?=} skipIfExists
	     * @return {?}
	     */
	    function (options, skipIfExists) {
	        var _this = this;
	        if (!options)
	            return;
	        var /** @type {?} */ newOptions = /** @type {?} */ (options);
	        var /** @type {?} */ optionsToUpdate = this.options;
	        // NOTE: this will get patched up when other animation methods support duration overrides
	        if (newOptions.duration != null) {
	            (/** @type {?} */ (optionsToUpdate)).duration = resolveTimingValue(newOptions.duration);
	        }
	        if (newOptions.delay != null) {
	            optionsToUpdate.delay = resolveTimingValue(newOptions.delay);
	        }
	        var /** @type {?} */ newParams = newOptions.params;
	        if (newParams) {
	            var /** @type {?} */ paramsToUpdate_1 = /** @type {?} */ ((optionsToUpdate.params));
	            if (!paramsToUpdate_1) {
	                paramsToUpdate_1 = this.options.params = {};
	            }
	            Object.keys(newParams).forEach(function (name) {
	                if (!skipIfExists || !paramsToUpdate_1.hasOwnProperty(name)) {
	                    paramsToUpdate_1[name] = interpolateParams(newParams[name], paramsToUpdate_1, _this.errors);
	                }
	            });
	        }
	    };
	    /**
	     * @return {?}
	     */
	    AnimationTimelineContext.prototype._copyOptions = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ options = {};
	        if (this.options) {
	            var /** @type {?} */ oldParams_1 = this.options.params;
	            if (oldParams_1) {
	                var /** @type {?} */ params_1 = options['params'] = {};
	                Object.keys(oldParams_1).forEach(function (name) { params_1[name] = oldParams_1[name]; });
	            }
	        }
	        return options;
	    };
	    /**
	     * @param {?=} options
	     * @param {?=} element
	     * @param {?=} newTime
	     * @return {?}
	     */
	    AnimationTimelineContext.prototype.createSubContext = /**
	     * @param {?=} options
	     * @param {?=} element
	     * @param {?=} newTime
	     * @return {?}
	     */
	    function (options, element, newTime) {
	        if (options === void 0) { options = null; }
	        var /** @type {?} */ target = element || this.element;
	        var /** @type {?} */ context = new AnimationTimelineContext(this._driver, target, this.subInstructions, this._enterClassName, this._leaveClassName, this.errors, this.timelines, this.currentTimeline.fork(target, newTime || 0));
	        context.previousNode = this.previousNode;
	        context.currentAnimateTimings = this.currentAnimateTimings;
	        context.options = this._copyOptions();
	        context.updateOptions(options);
	        context.currentQueryIndex = this.currentQueryIndex;
	        context.currentQueryTotal = this.currentQueryTotal;
	        context.parentContext = this;
	        this.subContextCount++;
	        return context;
	    };
	    /**
	     * @param {?=} newTime
	     * @return {?}
	     */
	    AnimationTimelineContext.prototype.transformIntoNewTimeline = /**
	     * @param {?=} newTime
	     * @return {?}
	     */
	    function (newTime) {
	        this.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
	        this.currentTimeline = this.currentTimeline.fork(this.element, newTime);
	        this.timelines.push(this.currentTimeline);
	        return this.currentTimeline;
	    };
	    /**
	     * @param {?} instruction
	     * @param {?} duration
	     * @param {?} delay
	     * @return {?}
	     */
	    AnimationTimelineContext.prototype.appendInstructionToTimeline = /**
	     * @param {?} instruction
	     * @param {?} duration
	     * @param {?} delay
	     * @return {?}
	     */
	    function (instruction, duration, delay) {
	        var /** @type {?} */ updatedTimings = {
	            duration: duration != null ? duration : instruction.duration,
	            delay: this.currentTimeline.currentTime + (delay != null ? delay : 0) + instruction.delay,
	            easing: ''
	        };
	        var /** @type {?} */ builder = new SubTimelineBuilder(this._driver, instruction.element, instruction.keyframes, instruction.preStyleProps, instruction.postStyleProps, updatedTimings, instruction.stretchStartingKeyframe);
	        this.timelines.push(builder);
	        return updatedTimings;
	    };
	    /**
	     * @param {?} time
	     * @return {?}
	     */
	    AnimationTimelineContext.prototype.incrementTime = /**
	     * @param {?} time
	     * @return {?}
	     */
	    function (time) {
	        this.currentTimeline.forwardTime(this.currentTimeline.duration + time);
	    };
	    /**
	     * @param {?} delay
	     * @return {?}
	     */
	    AnimationTimelineContext.prototype.delayNextStep = /**
	     * @param {?} delay
	     * @return {?}
	     */
	    function (delay) {
	        // negative delays are not yet supported
	        if (delay > 0) {
	            this.currentTimeline.delayNextStep(delay);
	        }
	    };
	    /**
	     * @param {?} selector
	     * @param {?} originalSelector
	     * @param {?} limit
	     * @param {?} includeSelf
	     * @param {?} optional
	     * @param {?} errors
	     * @return {?}
	     */
	    AnimationTimelineContext.prototype.invokeQuery = /**
	     * @param {?} selector
	     * @param {?} originalSelector
	     * @param {?} limit
	     * @param {?} includeSelf
	     * @param {?} optional
	     * @param {?} errors
	     * @return {?}
	     */
	    function (selector, originalSelector, limit, includeSelf, optional, errors) {
	        var /** @type {?} */ results = [];
	        if (includeSelf) {
	            results.push(this.element);
	        }
	        if (selector.length > 0) {
	            // if :self is only used then the selector is empty
	            selector = selector.replace(ENTER_TOKEN_REGEX, '.' + this._enterClassName);
	            selector = selector.replace(LEAVE_TOKEN_REGEX, '.' + this._leaveClassName);
	            var /** @type {?} */ multi = limit != 1;
	            var /** @type {?} */ elements = this._driver.query(this.element, selector, multi);
	            if (limit !== 0) {
	                elements = limit < 0 ? elements.slice(elements.length + limit, elements.length) :
	                    elements.slice(0, limit);
	            }
	            results.push.apply(results, elements);
	        }
	        if (!optional && results.length == 0) {
	            errors.push("`query(\"" + originalSelector + "\")` returned zero elements. (Use `query(\"" + originalSelector + "\", { optional: true })` if you wish to allow this.)");
	        }
	        return results;
	    };
	    return AnimationTimelineContext;
	}());
	var TimelineBuilder = /** @class */ (function () {
	    function TimelineBuilder(_driver, element, startTime, _elementTimelineStylesLookup) {
	        this._driver = _driver;
	        this.element = element;
	        this.startTime = startTime;
	        this._elementTimelineStylesLookup = _elementTimelineStylesLookup;
	        this.duration = 0;
	        this._previousKeyframe = {};
	        this._currentKeyframe = {};
	        this._keyframes = new Map();
	        this._styleSummary = {};
	        this._pendingStyles = {};
	        this._backFill = {};
	        this._currentEmptyStepKeyframe = null;
	        if (!this._elementTimelineStylesLookup) {
	            this._elementTimelineStylesLookup = new Map();
	        }
	        this._localTimelineStyles = Object.create(this._backFill, {});
	        this._globalTimelineStyles = /** @type {?} */ ((this._elementTimelineStylesLookup.get(element)));
	        if (!this._globalTimelineStyles) {
	            this._globalTimelineStyles = this._localTimelineStyles;
	            this._elementTimelineStylesLookup.set(element, this._localTimelineStyles);
	        }
	        this._loadKeyframe();
	    }
	    /**
	     * @return {?}
	     */
	    TimelineBuilder.prototype.containsAnimation = /**
	     * @return {?}
	     */
	    function () {
	        switch (this._keyframes.size) {
	            case 0:
	                return false;
	            case 1:
	                return this.getCurrentStyleProperties().length > 0;
	            default:
	                return true;
	        }
	    };
	    /**
	     * @return {?}
	     */
	    TimelineBuilder.prototype.getCurrentStyleProperties = /**
	     * @return {?}
	     */
	    function () { return Object.keys(this._currentKeyframe); };
	    Object.defineProperty(TimelineBuilder.prototype, "currentTime", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.startTime + this.duration; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} delay
	     * @return {?}
	     */
	    TimelineBuilder.prototype.delayNextStep = /**
	     * @param {?} delay
	     * @return {?}
	     */
	    function (delay) {
	        // in the event that a style() step is placed right before a stagger()
	        // and that style() step is the very first style() value in the animation
	        // then we need to make a copy of the keyframe [0, copy, 1] so that the delay
	        // properly applies the style() values to work with the stagger...
	        var /** @type {?} */ hasPreStyleStep = this._keyframes.size == 1 && Object.keys(this._pendingStyles).length;
	        if (this.duration || hasPreStyleStep) {
	            this.forwardTime(this.currentTime + delay);
	            if (hasPreStyleStep) {
	                this.snapshotCurrentStyles();
	            }
	        }
	        else {
	            this.startTime += delay;
	        }
	    };
	    /**
	     * @param {?} element
	     * @param {?=} currentTime
	     * @return {?}
	     */
	    TimelineBuilder.prototype.fork = /**
	     * @param {?} element
	     * @param {?=} currentTime
	     * @return {?}
	     */
	    function (element, currentTime) {
	        this.applyStylesToKeyframe();
	        return new TimelineBuilder(this._driver, element, currentTime || this.currentTime, this._elementTimelineStylesLookup);
	    };
	    /**
	     * @return {?}
	     */
	    TimelineBuilder.prototype._loadKeyframe = /**
	     * @return {?}
	     */
	    function () {
	        if (this._currentKeyframe) {
	            this._previousKeyframe = this._currentKeyframe;
	        }
	        this._currentKeyframe = /** @type {?} */ ((this._keyframes.get(this.duration)));
	        if (!this._currentKeyframe) {
	            this._currentKeyframe = Object.create(this._backFill, {});
	            this._keyframes.set(this.duration, this._currentKeyframe);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    TimelineBuilder.prototype.forwardFrame = /**
	     * @return {?}
	     */
	    function () {
	        this.duration += ONE_FRAME_IN_MILLISECONDS;
	        this._loadKeyframe();
	    };
	    /**
	     * @param {?} time
	     * @return {?}
	     */
	    TimelineBuilder.prototype.forwardTime = /**
	     * @param {?} time
	     * @return {?}
	     */
	    function (time) {
	        this.applyStylesToKeyframe();
	        this.duration = time;
	        this._loadKeyframe();
	    };
	    /**
	     * @param {?} prop
	     * @param {?} value
	     * @return {?}
	     */
	    TimelineBuilder.prototype._updateStyle = /**
	     * @param {?} prop
	     * @param {?} value
	     * @return {?}
	     */
	    function (prop, value) {
	        this._localTimelineStyles[prop] = value;
	        this._globalTimelineStyles[prop] = value;
	        this._styleSummary[prop] = { time: this.currentTime, value: value };
	    };
	    /**
	     * @return {?}
	     */
	    TimelineBuilder.prototype.allowOnlyTimelineStyles = /**
	     * @return {?}
	     */
	    function () { return this._currentEmptyStepKeyframe !== this._currentKeyframe; };
	    /**
	     * @param {?} easing
	     * @return {?}
	     */
	    TimelineBuilder.prototype.applyEmptyStep = /**
	     * @param {?} easing
	     * @return {?}
	     */
	    function (easing) {
	        var _this = this;
	        if (easing) {
	            this._previousKeyframe['easing'] = easing;
	        }
	        // special case for animate(duration):
	        // all missing styles are filled with a `*` value then
	        // if any destination styles are filled in later on the same
	        // keyframe then they will override the overridden styles
	        // We use `_globalTimelineStyles` here because there may be
	        // styles in previous keyframes that are not present in this timeline
	        Object.keys(this._globalTimelineStyles).forEach(function (prop) {
	            _this._backFill[prop] = _this._globalTimelineStyles[prop] || _angular_animations.AUTO_STYLE;
	            _this._currentKeyframe[prop] = _angular_animations.AUTO_STYLE;
	        });
	        this._currentEmptyStepKeyframe = this._currentKeyframe;
	    };
	    /**
	     * @param {?} input
	     * @param {?} easing
	     * @param {?} errors
	     * @param {?=} options
	     * @return {?}
	     */
	    TimelineBuilder.prototype.setStyles = /**
	     * @param {?} input
	     * @param {?} easing
	     * @param {?} errors
	     * @param {?=} options
	     * @return {?}
	     */
	    function (input, easing, errors, options) {
	        var _this = this;
	        if (easing) {
	            this._previousKeyframe['easing'] = easing;
	        }
	        var /** @type {?} */ params = (options && options.params) || {};
	        var /** @type {?} */ styles = flattenStyles(input, this._globalTimelineStyles);
	        Object.keys(styles).forEach(function (prop) {
	            var /** @type {?} */ val = interpolateParams(styles[prop], params, errors);
	            _this._pendingStyles[prop] = val;
	            if (!_this._localTimelineStyles.hasOwnProperty(prop)) {
	                _this._backFill[prop] = _this._globalTimelineStyles.hasOwnProperty(prop) ?
	                    _this._globalTimelineStyles[prop] :
	                    _angular_animations.AUTO_STYLE;
	            }
	            _this._updateStyle(prop, val);
	        });
	    };
	    /**
	     * @return {?}
	     */
	    TimelineBuilder.prototype.applyStylesToKeyframe = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ styles = this._pendingStyles;
	        var /** @type {?} */ props = Object.keys(styles);
	        if (props.length == 0)
	            return;
	        this._pendingStyles = {};
	        props.forEach(function (prop) {
	            var /** @type {?} */ val = styles[prop];
	            _this._currentKeyframe[prop] = val;
	        });
	        Object.keys(this._localTimelineStyles).forEach(function (prop) {
	            if (!_this._currentKeyframe.hasOwnProperty(prop)) {
	                _this._currentKeyframe[prop] = _this._localTimelineStyles[prop];
	            }
	        });
	    };
	    /**
	     * @return {?}
	     */
	    TimelineBuilder.prototype.snapshotCurrentStyles = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        Object.keys(this._localTimelineStyles).forEach(function (prop) {
	            var /** @type {?} */ val = _this._localTimelineStyles[prop];
	            _this._pendingStyles[prop] = val;
	            _this._updateStyle(prop, val);
	        });
	    };
	    /**
	     * @return {?}
	     */
	    TimelineBuilder.prototype.getFinalKeyframe = /**
	     * @return {?}
	     */
	    function () { return this._keyframes.get(this.duration); };
	    Object.defineProperty(TimelineBuilder.prototype, "properties", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ properties = [];
	            for (var /** @type {?} */ prop in this._currentKeyframe) {
	                properties.push(prop);
	            }
	            return properties;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} timeline
	     * @return {?}
	     */
	    TimelineBuilder.prototype.mergeTimelineCollectedStyles = /**
	     * @param {?} timeline
	     * @return {?}
	     */
	    function (timeline) {
	        var _this = this;
	        Object.keys(timeline._styleSummary).forEach(function (prop) {
	            var /** @type {?} */ details0 = _this._styleSummary[prop];
	            var /** @type {?} */ details1 = timeline._styleSummary[prop];
	            if (!details0 || details1.time > details0.time) {
	                _this._updateStyle(prop, details1.value);
	            }
	        });
	    };
	    /**
	     * @return {?}
	     */
	    TimelineBuilder.prototype.buildKeyframes = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this.applyStylesToKeyframe();
	        var /** @type {?} */ preStyleProps = new Set();
	        var /** @type {?} */ postStyleProps = new Set();
	        var /** @type {?} */ isEmpty = this._keyframes.size === 1 && this.duration === 0;
	        var /** @type {?} */ finalKeyframes = [];
	        this._keyframes.forEach(function (keyframe, time) {
	            var /** @type {?} */ finalKeyframe = copyStyles(keyframe, true);
	            Object.keys(finalKeyframe).forEach(function (prop) {
	                var /** @type {?} */ value = finalKeyframe[prop];
	                if (value == _angular_animations.ɵPRE_STYLE) {
	                    preStyleProps.add(prop);
	                }
	                else if (value == _angular_animations.AUTO_STYLE) {
	                    postStyleProps.add(prop);
	                }
	            });
	            if (!isEmpty) {
	                finalKeyframe['offset'] = time / _this.duration;
	            }
	            finalKeyframes.push(finalKeyframe);
	        });
	        var /** @type {?} */ preProps = preStyleProps.size ? iteratorToArray(preStyleProps.values()) : [];
	        var /** @type {?} */ postProps = postStyleProps.size ? iteratorToArray(postStyleProps.values()) : [];
	        // special case for a 0-second animation (which is designed just to place styles onscreen)
	        if (isEmpty) {
	            var /** @type {?} */ kf0 = finalKeyframes[0];
	            var /** @type {?} */ kf1 = copyObj(kf0);
	            kf0['offset'] = 0;
	            kf1['offset'] = 1;
	            finalKeyframes = [kf0, kf1];
	        }
	        return createTimelineInstruction(this.element, finalKeyframes, preProps, postProps, this.duration, this.startTime, this.easing, false);
	    };
	    return TimelineBuilder;
	}());
	var SubTimelineBuilder = /** @class */ (function (_super) {
	    __extends(SubTimelineBuilder, _super);
	    function SubTimelineBuilder(driver, element, keyframes, preStyleProps, postStyleProps, timings, _stretchStartingKeyframe) {
	        if (_stretchStartingKeyframe === void 0) { _stretchStartingKeyframe = false; }
	        var _this = _super.call(this, driver, element, timings.delay) || this;
	        _this.element = element;
	        _this.keyframes = keyframes;
	        _this.preStyleProps = preStyleProps;
	        _this.postStyleProps = postStyleProps;
	        _this._stretchStartingKeyframe = _stretchStartingKeyframe;
	        _this.timings = { duration: timings.duration, delay: timings.delay, easing: timings.easing };
	        return _this;
	    }
	    /**
	     * @return {?}
	     */
	    SubTimelineBuilder.prototype.containsAnimation = /**
	     * @return {?}
	     */
	    function () { return this.keyframes.length > 1; };
	    /**
	     * @return {?}
	     */
	    SubTimelineBuilder.prototype.buildKeyframes = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ keyframes = this.keyframes;
	        var _a = this.timings, delay = _a.delay, duration = _a.duration, easing = _a.easing;
	        if (this._stretchStartingKeyframe && delay) {
	            var /** @type {?} */ newKeyframes = [];
	            var /** @type {?} */ totalTime = duration + delay;
	            var /** @type {?} */ startingGap = delay / totalTime;
	            // the original starting keyframe now starts once the delay is done
	            var /** @type {?} */ newFirstKeyframe = copyStyles(keyframes[0], false);
	            newFirstKeyframe['offset'] = 0;
	            newKeyframes.push(newFirstKeyframe);
	            var /** @type {?} */ oldFirstKeyframe = copyStyles(keyframes[0], false);
	            oldFirstKeyframe['offset'] = roundOffset(startingGap);
	            newKeyframes.push(oldFirstKeyframe);
	            /*
	                    When the keyframe is stretched then it means that the delay before the animation
	                    starts is gone. Instead the first keyframe is placed at the start of the animation
	                    and it is then copied to where it starts when the original delay is over. This basically
	                    means nothing animates during that delay, but the styles are still renderered. For this
	                    to work the original offset values that exist in the original keyframes must be "warped"
	                    so that they can take the new keyframe + delay into account.
	            
	                    delay=1000, duration=1000, keyframes = 0 .5 1
	            
	                    turns into
	            
	                    delay=0, duration=2000, keyframes = 0 .33 .66 1
	                   */
	            // offsets between 1 ... n -1 are all warped by the keyframe stretch
	            var /** @type {?} */ limit = keyframes.length - 1;
	            for (var /** @type {?} */ i = 1; i <= limit; i++) {
	                var /** @type {?} */ kf = copyStyles(keyframes[i], false);
	                var /** @type {?} */ oldOffset = /** @type {?} */ (kf['offset']);
	                var /** @type {?} */ timeAtKeyframe = delay + oldOffset * duration;
	                kf['offset'] = roundOffset(timeAtKeyframe / totalTime);
	                newKeyframes.push(kf);
	            }
	            // the new starting keyframe should be added at the start
	            duration = totalTime;
	            delay = 0;
	            easing = '';
	            keyframes = newKeyframes;
	        }
	        return createTimelineInstruction(this.element, keyframes, this.preStyleProps, this.postStyleProps, duration, delay, easing, true);
	    };
	    return SubTimelineBuilder;
	}(TimelineBuilder));
	/**
	 * @param {?} offset
	 * @param {?=} decimalPoints
	 * @return {?}
	 */
	function roundOffset(offset, decimalPoints) {
	    if (decimalPoints === void 0) { decimalPoints = 3; }
	    var /** @type {?} */ mult = Math.pow(10, decimalPoints - 1);
	    return Math.round(offset * mult) / mult;
	}
	/**
	 * @param {?} input
	 * @param {?} allStyles
	 * @return {?}
	 */
	function flattenStyles(input, allStyles) {
	    var /** @type {?} */ styles = {};
	    var /** @type {?} */ allProperties;
	    input.forEach(function (token) {
	        if (token === '*') {
	            allProperties = allProperties || Object.keys(allStyles);
	            allProperties.forEach(function (prop) { styles[prop] = _angular_animations.AUTO_STYLE; });
	        }
	        else {
	            copyStyles(/** @type {?} */ (token), false, styles);
	        }
	    });
	    return styles;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var Animation = /** @class */ (function () {
	    function Animation(_driver, input) {
	        this._driver = _driver;
	        var /** @type {?} */ errors = [];
	        var /** @type {?} */ ast = buildAnimationAst(_driver, input, errors);
	        if (errors.length) {
	            var /** @type {?} */ errorMessage = "animation validation failed:\n" + errors.join("\n");
	            throw new Error(errorMessage);
	        }
	        this._animationAst = ast;
	    }
	    /**
	     * @param {?} element
	     * @param {?} startingStyles
	     * @param {?} destinationStyles
	     * @param {?} options
	     * @param {?=} subInstructions
	     * @return {?}
	     */
	    Animation.prototype.buildTimelines = /**
	     * @param {?} element
	     * @param {?} startingStyles
	     * @param {?} destinationStyles
	     * @param {?} options
	     * @param {?=} subInstructions
	     * @return {?}
	     */
	    function (element, startingStyles, destinationStyles, options, subInstructions) {
	        var /** @type {?} */ start = Array.isArray(startingStyles) ? normalizeStyles(startingStyles) : /** @type {?} */ (startingStyles);
	        var /** @type {?} */ dest = Array.isArray(destinationStyles) ? normalizeStyles(destinationStyles) : /** @type {?} */ (destinationStyles);
	        var /** @type {?} */ errors = [];
	        subInstructions = subInstructions || new ElementInstructionMap();
	        var /** @type {?} */ result = buildAnimationTimelines(this._driver, element, this._animationAst, ENTER_CLASSNAME, LEAVE_CLASSNAME, start, dest, options, subInstructions, errors);
	        if (errors.length) {
	            var /** @type {?} */ errorMessage = "animation building failed:\n" + errors.join("\n");
	            throw new Error(errorMessage);
	        }
	        return result;
	    };
	    return Animation;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * \@experimental Animation support is experimental.
	 * @abstract
	 */
	var AnimationStyleNormalizer = /** @class */ (function () {
	    function AnimationStyleNormalizer() {
	    }
	    return AnimationStyleNormalizer;
	}());
	/**
	 * \@experimental Animation support is experimental.
	 */
	var NoopAnimationStyleNormalizer = /** @class */ (function () {
	    function NoopAnimationStyleNormalizer() {
	    }
	    /**
	     * @param {?} propertyName
	     * @param {?} errors
	     * @return {?}
	     */
	    NoopAnimationStyleNormalizer.prototype.normalizePropertyName = /**
	     * @param {?} propertyName
	     * @param {?} errors
	     * @return {?}
	     */
	    function (propertyName, errors) { return propertyName; };
	    /**
	     * @param {?} userProvidedProperty
	     * @param {?} normalizedProperty
	     * @param {?} value
	     * @param {?} errors
	     * @return {?}
	     */
	    NoopAnimationStyleNormalizer.prototype.normalizeStyleValue = /**
	     * @param {?} userProvidedProperty
	     * @param {?} normalizedProperty
	     * @param {?} value
	     * @param {?} errors
	     * @return {?}
	     */
	    function (userProvidedProperty, normalizedProperty, value, errors) {
	        return /** @type {?} */ (value);
	    };
	    return NoopAnimationStyleNormalizer;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var WebAnimationsStyleNormalizer = /** @class */ (function (_super) {
	    __extends(WebAnimationsStyleNormalizer, _super);
	    function WebAnimationsStyleNormalizer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @param {?} propertyName
	     * @param {?} errors
	     * @return {?}
	     */
	    WebAnimationsStyleNormalizer.prototype.normalizePropertyName = /**
	     * @param {?} propertyName
	     * @param {?} errors
	     * @return {?}
	     */
	    function (propertyName, errors) {
	        return dashCaseToCamelCase(propertyName);
	    };
	    /**
	     * @param {?} userProvidedProperty
	     * @param {?} normalizedProperty
	     * @param {?} value
	     * @param {?} errors
	     * @return {?}
	     */
	    WebAnimationsStyleNormalizer.prototype.normalizeStyleValue = /**
	     * @param {?} userProvidedProperty
	     * @param {?} normalizedProperty
	     * @param {?} value
	     * @param {?} errors
	     * @return {?}
	     */
	    function (userProvidedProperty, normalizedProperty, value, errors) {
	        var /** @type {?} */ unit = '';
	        var /** @type {?} */ strVal = value.toString().trim();
	        if (DIMENSIONAL_PROP_MAP[normalizedProperty] && value !== 0 && value !== '0') {
	            if (typeof value === 'number') {
	                unit = 'px';
	            }
	            else {
	                var /** @type {?} */ valAndSuffixMatch = value.match(/^[+-]?[\d\.]+([a-z]*)$/);
	                if (valAndSuffixMatch && valAndSuffixMatch[1].length == 0) {
	                    errors.push("Please provide a CSS unit value for " + userProvidedProperty + ":" + value);
	                }
	            }
	        }
	        return strVal + unit;
	    };
	    return WebAnimationsStyleNormalizer;
	}(AnimationStyleNormalizer));
	var DIMENSIONAL_PROP_MAP = makeBooleanMap('width,height,minWidth,minHeight,maxWidth,maxHeight,left,top,bottom,right,fontSize,outlineWidth,outlineOffset,paddingTop,paddingLeft,paddingBottom,paddingRight,marginTop,marginLeft,marginBottom,marginRight,borderRadius,borderWidth,borderTopWidth,borderLeftWidth,borderRightWidth,borderBottomWidth,textIndent,perspective'
	    .split(','));
	/**
	 * @param {?} keys
	 * @return {?}
	 */
	function makeBooleanMap(keys) {
	    var /** @type {?} */ map = {};
	    keys.forEach(function (key) { return map[key] = true; });
	    return map;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @record
	 */
	
	/**
	 * @param {?} element
	 * @param {?} triggerName
	 * @param {?} fromState
	 * @param {?} toState
	 * @param {?} isRemovalTransition
	 * @param {?} fromStyles
	 * @param {?} toStyles
	 * @param {?} timelines
	 * @param {?} queriedElements
	 * @param {?} preStyleProps
	 * @param {?} postStyleProps
	 * @param {?=} errors
	 * @return {?}
	 */
	function createTransitionInstruction(element, triggerName, fromState, toState, isRemovalTransition, fromStyles, toStyles, timelines, queriedElements, preStyleProps, postStyleProps, errors) {
	    return {
	        type: 0 /* TransitionAnimation */,
	        element: element,
	        triggerName: triggerName,
	        isRemovalTransition: isRemovalTransition,
	        fromState: fromState,
	        fromStyles: fromStyles,
	        toState: toState,
	        toStyles: toStyles,
	        timelines: timelines,
	        queriedElements: queriedElements,
	        preStyleProps: preStyleProps,
	        postStyleProps: postStyleProps,
	        errors: errors
	    };
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var EMPTY_OBJECT = {};
	var AnimationTransitionFactory = /** @class */ (function () {
	    function AnimationTransitionFactory(_triggerName, ast, _stateStyles) {
	        this._triggerName = _triggerName;
	        this.ast = ast;
	        this._stateStyles = _stateStyles;
	    }
	    /**
	     * @param {?} currentState
	     * @param {?} nextState
	     * @return {?}
	     */
	    AnimationTransitionFactory.prototype.match = /**
	     * @param {?} currentState
	     * @param {?} nextState
	     * @return {?}
	     */
	    function (currentState, nextState) {
	        return oneOrMoreTransitionsMatch(this.ast.matchers, currentState, nextState);
	    };
	    /**
	     * @param {?} stateName
	     * @param {?} params
	     * @param {?} errors
	     * @return {?}
	     */
	    AnimationTransitionFactory.prototype.buildStyles = /**
	     * @param {?} stateName
	     * @param {?} params
	     * @param {?} errors
	     * @return {?}
	     */
	    function (stateName, params, errors) {
	        var /** @type {?} */ backupStateStyler = this._stateStyles['*'];
	        var /** @type {?} */ stateStyler = this._stateStyles[stateName];
	        var /** @type {?} */ backupStyles = backupStateStyler ? backupStateStyler.buildStyles(params, errors) : {};
	        return stateStyler ? stateStyler.buildStyles(params, errors) : backupStyles;
	    };
	    /**
	     * @param {?} driver
	     * @param {?} element
	     * @param {?} currentState
	     * @param {?} nextState
	     * @param {?} enterClassName
	     * @param {?} leaveClassName
	     * @param {?=} currentOptions
	     * @param {?=} nextOptions
	     * @param {?=} subInstructions
	     * @return {?}
	     */
	    AnimationTransitionFactory.prototype.build = /**
	     * @param {?} driver
	     * @param {?} element
	     * @param {?} currentState
	     * @param {?} nextState
	     * @param {?} enterClassName
	     * @param {?} leaveClassName
	     * @param {?=} currentOptions
	     * @param {?=} nextOptions
	     * @param {?=} subInstructions
	     * @return {?}
	     */
	    function (driver, element, currentState, nextState, enterClassName, leaveClassName, currentOptions, nextOptions, subInstructions) {
	        var /** @type {?} */ errors = [];
	        var /** @type {?} */ transitionAnimationParams = this.ast.options && this.ast.options.params || EMPTY_OBJECT;
	        var /** @type {?} */ currentAnimationParams = currentOptions && currentOptions.params || EMPTY_OBJECT;
	        var /** @type {?} */ currentStateStyles = this.buildStyles(currentState, currentAnimationParams, errors);
	        var /** @type {?} */ nextAnimationParams = nextOptions && nextOptions.params || EMPTY_OBJECT;
	        var /** @type {?} */ nextStateStyles = this.buildStyles(nextState, nextAnimationParams, errors);
	        var /** @type {?} */ queriedElements = new Set();
	        var /** @type {?} */ preStyleMap = new Map();
	        var /** @type {?} */ postStyleMap = new Map();
	        var /** @type {?} */ isRemoval = nextState === 'void';
	        var /** @type {?} */ animationOptions = { params: __assign({}, transitionAnimationParams, nextAnimationParams) };
	        var /** @type {?} */ timelines = buildAnimationTimelines(driver, element, this.ast.animation, enterClassName, leaveClassName, currentStateStyles, nextStateStyles, animationOptions, subInstructions, errors);
	        if (errors.length) {
	            return createTransitionInstruction(element, this._triggerName, currentState, nextState, isRemoval, currentStateStyles, nextStateStyles, [], [], preStyleMap, postStyleMap, errors);
	        }
	        timelines.forEach(function (tl) {
	            var /** @type {?} */ elm = tl.element;
	            var /** @type {?} */ preProps = getOrSetAsInMap(preStyleMap, elm, {});
	            tl.preStyleProps.forEach(function (prop) { return preProps[prop] = true; });
	            var /** @type {?} */ postProps = getOrSetAsInMap(postStyleMap, elm, {});
	            tl.postStyleProps.forEach(function (prop) { return postProps[prop] = true; });
	            if (elm !== element) {
	                queriedElements.add(elm);
	            }
	        });
	        var /** @type {?} */ queriedElementsList = iteratorToArray(queriedElements.values());
	        return createTransitionInstruction(element, this._triggerName, currentState, nextState, isRemoval, currentStateStyles, nextStateStyles, timelines, queriedElementsList, preStyleMap, postStyleMap);
	    };
	    return AnimationTransitionFactory;
	}());
	/**
	 * @param {?} matchFns
	 * @param {?} currentState
	 * @param {?} nextState
	 * @return {?}
	 */
	function oneOrMoreTransitionsMatch(matchFns, currentState, nextState) {
	    return matchFns.some(function (fn) { return fn(currentState, nextState); });
	}
	var AnimationStateStyles = /** @class */ (function () {
	    function AnimationStateStyles(styles, defaultParams) {
	        this.styles = styles;
	        this.defaultParams = defaultParams;
	    }
	    /**
	     * @param {?} params
	     * @param {?} errors
	     * @return {?}
	     */
	    AnimationStateStyles.prototype.buildStyles = /**
	     * @param {?} params
	     * @param {?} errors
	     * @return {?}
	     */
	    function (params, errors) {
	        var /** @type {?} */ finalStyles = {};
	        var /** @type {?} */ combinedParams = copyObj(this.defaultParams);
	        Object.keys(params).forEach(function (key) {
	            var /** @type {?} */ value = params[key];
	            if (value != null) {
	                combinedParams[key] = value;
	            }
	        });
	        this.styles.styles.forEach(function (value) {
	            if (typeof value !== 'string') {
	                var /** @type {?} */ styleObj_1 = /** @type {?} */ (value);
	                Object.keys(styleObj_1).forEach(function (prop) {
	                    var /** @type {?} */ val = styleObj_1[prop];
	                    if (val.length > 1) {
	                        val = interpolateParams(val, combinedParams, errors);
	                    }
	                    finalStyles[prop] = val;
	                });
	            }
	        });
	        return finalStyles;
	    };
	    return AnimationStateStyles;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * \@experimental Animation support is experimental.
	 * @param {?} name
	 * @param {?} ast
	 * @return {?}
	 */
	function buildTrigger(name, ast) {
	    return new AnimationTrigger(name, ast);
	}
	/**
	 * \@experimental Animation support is experimental.
	 */
	var AnimationTrigger = /** @class */ (function () {
	    function AnimationTrigger(name, ast) {
	        var _this = this;
	        this.name = name;
	        this.ast = ast;
	        this.transitionFactories = [];
	        this.states = {};
	        ast.states.forEach(function (ast) {
	            var /** @type {?} */ defaultParams = (ast.options && ast.options.params) || {};
	            _this.states[ast.name] = new AnimationStateStyles(ast.style, defaultParams);
	        });
	        balanceProperties(this.states, 'true', '1');
	        balanceProperties(this.states, 'false', '0');
	        ast.transitions.forEach(function (ast) {
	            _this.transitionFactories.push(new AnimationTransitionFactory(name, ast, _this.states));
	        });
	        this.fallbackTransition = createFallbackTransition(name, this.states);
	    }
	    Object.defineProperty(AnimationTrigger.prototype, "containsQueries", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this.ast.queryCount > 0; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} currentState
	     * @param {?} nextState
	     * @return {?}
	     */
	    AnimationTrigger.prototype.matchTransition = /**
	     * @param {?} currentState
	     * @param {?} nextState
	     * @return {?}
	     */
	    function (currentState, nextState) {
	        var /** @type {?} */ entry = this.transitionFactories.find(function (f) { return f.match(currentState, nextState); });
	        return entry || null;
	    };
	    /**
	     * @param {?} currentState
	     * @param {?} params
	     * @param {?} errors
	     * @return {?}
	     */
	    AnimationTrigger.prototype.matchStyles = /**
	     * @param {?} currentState
	     * @param {?} params
	     * @param {?} errors
	     * @return {?}
	     */
	    function (currentState, params, errors) {
	        return this.fallbackTransition.buildStyles(currentState, params, errors);
	    };
	    return AnimationTrigger;
	}());
	/**
	 * @param {?} triggerName
	 * @param {?} states
	 * @return {?}
	 */
	function createFallbackTransition(triggerName, states) {
	    var /** @type {?} */ matchers = [function (fromState, toState) { return true; }];
	    var /** @type {?} */ animation = { type: 2 /* Sequence */, steps: [], options: null };
	    var /** @type {?} */ transition = {
	        type: 1 /* Transition */,
	        animation: animation,
	        matchers: matchers,
	        options: null,
	        queryCount: 0,
	        depCount: 0
	    };
	    return new AnimationTransitionFactory(triggerName, transition, states);
	}
	/**
	 * @param {?} obj
	 * @param {?} key1
	 * @param {?} key2
	 * @return {?}
	 */
	function balanceProperties(obj, key1, key2) {
	    if (obj.hasOwnProperty(key1)) {
	        if (!obj.hasOwnProperty(key2)) {
	            obj[key2] = obj[key1];
	        }
	    }
	    else if (obj.hasOwnProperty(key2)) {
	        obj[key1] = obj[key2];
	    }
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var EMPTY_INSTRUCTION_MAP = new ElementInstructionMap();
	var TimelineAnimationEngine = /** @class */ (function () {
	    function TimelineAnimationEngine(_driver, _normalizer) {
	        this._driver = _driver;
	        this._normalizer = _normalizer;
	        this._animations = {};
	        this._playersById = {};
	        this.players = [];
	    }
	    /**
	     * @param {?} id
	     * @param {?} metadata
	     * @return {?}
	     */
	    TimelineAnimationEngine.prototype.register = /**
	     * @param {?} id
	     * @param {?} metadata
	     * @return {?}
	     */
	    function (id, metadata) {
	        var /** @type {?} */ errors = [];
	        var /** @type {?} */ ast = buildAnimationAst(this._driver, metadata, errors);
	        if (errors.length) {
	            throw new Error("Unable to build the animation due to the following errors: " + errors.join("\n"));
	        }
	        else {
	            this._animations[id] = ast;
	        }
	    };
	    /**
	     * @param {?} i
	     * @param {?} preStyles
	     * @param {?=} postStyles
	     * @return {?}
	     */
	    TimelineAnimationEngine.prototype._buildPlayer = /**
	     * @param {?} i
	     * @param {?} preStyles
	     * @param {?=} postStyles
	     * @return {?}
	     */
	    function (i, preStyles, postStyles) {
	        var /** @type {?} */ element = i.element;
	        var /** @type {?} */ keyframes = normalizeKeyframes(this._driver, this._normalizer, element, i.keyframes, preStyles, postStyles);
	        return this._driver.animate(element, keyframes, i.duration, i.delay, i.easing, []);
	    };
	    /**
	     * @param {?} id
	     * @param {?} element
	     * @param {?=} options
	     * @return {?}
	     */
	    TimelineAnimationEngine.prototype.create = /**
	     * @param {?} id
	     * @param {?} element
	     * @param {?=} options
	     * @return {?}
	     */
	    function (id, element, options) {
	        var _this = this;
	        if (options === void 0) { options = {}; }
	        var /** @type {?} */ errors = [];
	        var /** @type {?} */ ast = this._animations[id];
	        var /** @type {?} */ instructions;
	        var /** @type {?} */ autoStylesMap = new Map();
	        if (ast) {
	            instructions = buildAnimationTimelines(this._driver, element, ast, ENTER_CLASSNAME, LEAVE_CLASSNAME, {}, {}, options, EMPTY_INSTRUCTION_MAP, errors);
	            instructions.forEach(function (inst) {
	                var /** @type {?} */ styles = getOrSetAsInMap(autoStylesMap, inst.element, {});
	                inst.postStyleProps.forEach(function (prop) { return styles[prop] = null; });
	            });
	        }
	        else {
	            errors.push('The requested animation doesn\'t exist or has already been destroyed');
	            instructions = [];
	        }
	        if (errors.length) {
	            throw new Error("Unable to create the animation due to the following errors: " + errors.join("\n"));
	        }
	        autoStylesMap.forEach(function (styles, element) {
	            Object.keys(styles).forEach(function (prop) { styles[prop] = _this._driver.computeStyle(element, prop, _angular_animations.AUTO_STYLE); });
	        });
	        var /** @type {?} */ players = instructions.map(function (i) {
	            var /** @type {?} */ styles = autoStylesMap.get(i.element);
	            return _this._buildPlayer(i, {}, styles);
	        });
	        var /** @type {?} */ player = optimizeGroupPlayer(players);
	        this._playersById[id] = player;
	        player.onDestroy(function () { return _this.destroy(id); });
	        this.players.push(player);
	        return player;
	    };
	    /**
	     * @param {?} id
	     * @return {?}
	     */
	    TimelineAnimationEngine.prototype.destroy = /**
	     * @param {?} id
	     * @return {?}
	     */
	    function (id) {
	        var /** @type {?} */ player = this._getPlayer(id);
	        player.destroy();
	        delete this._playersById[id];
	        var /** @type {?} */ index = this.players.indexOf(player);
	        if (index >= 0) {
	            this.players.splice(index, 1);
	        }
	    };
	    /**
	     * @param {?} id
	     * @return {?}
	     */
	    TimelineAnimationEngine.prototype._getPlayer = /**
	     * @param {?} id
	     * @return {?}
	     */
	    function (id) {
	        var /** @type {?} */ player = this._playersById[id];
	        if (!player) {
	            throw new Error("Unable to find the timeline player referenced by " + id);
	        }
	        return player;
	    };
	    /**
	     * @param {?} id
	     * @param {?} element
	     * @param {?} eventName
	     * @param {?} callback
	     * @return {?}
	     */
	    TimelineAnimationEngine.prototype.listen = /**
	     * @param {?} id
	     * @param {?} element
	     * @param {?} eventName
	     * @param {?} callback
	     * @return {?}
	     */
	    function (id, element, eventName, callback) {
	        // triggerName, fromState, toState are all ignored for timeline animations
	        var /** @type {?} */ baseEvent = makeAnimationEvent(element, '', '', '');
	        listenOnPlayer(this._getPlayer(id), eventName, baseEvent, callback);
	        return function () { };
	    };
	    /**
	     * @param {?} id
	     * @param {?} element
	     * @param {?} command
	     * @param {?} args
	     * @return {?}
	     */
	    TimelineAnimationEngine.prototype.command = /**
	     * @param {?} id
	     * @param {?} element
	     * @param {?} command
	     * @param {?} args
	     * @return {?}
	     */
	    function (id, element, command, args) {
	        if (command == 'register') {
	            this.register(id, /** @type {?} */ (args[0]));
	            return;
	        }
	        if (command == 'create') {
	            var /** @type {?} */ options = /** @type {?} */ ((args[0] || {}));
	            this.create(id, element, options);
	            return;
	        }
	        var /** @type {?} */ player = this._getPlayer(id);
	        switch (command) {
	            case 'play':
	                player.play();
	                break;
	            case 'pause':
	                player.pause();
	                break;
	            case 'reset':
	                player.reset();
	                break;
	            case 'restart':
	                player.restart();
	                break;
	            case 'finish':
	                player.finish();
	                break;
	            case 'init':
	                player.init();
	                break;
	            case 'setPosition':
	                player.setPosition(parseFloat(/** @type {?} */ (args[0])));
	                break;
	            case 'destroy':
	                this.destroy(id);
	                break;
	        }
	    };
	    return TimelineAnimationEngine;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var QUEUED_CLASSNAME = 'ng-animate-queued';
	var QUEUED_SELECTOR = '.ng-animate-queued';
	var DISABLED_CLASSNAME = 'ng-animate-disabled';
	var DISABLED_SELECTOR = '.ng-animate-disabled';
	var STAR_CLASSNAME = 'ng-star-inserted';
	var STAR_SELECTOR = '.ng-star-inserted';
	var EMPTY_PLAYER_ARRAY = [];
	var NULL_REMOVAL_STATE = {
	    namespaceId: '',
	    setForRemoval: null,
	    hasAnimation: false,
	    removedBeforeQueried: false
	};
	var NULL_REMOVED_QUERIED_STATE = {
	    namespaceId: '',
	    setForRemoval: null,
	    hasAnimation: false,
	    removedBeforeQueried: true
	};
	/**
	 * @record
	 */
	
	var REMOVAL_FLAG = '__ng_removed';
	/**
	 * @record
	 */
	
	var StateValue = /** @class */ (function () {
	    function StateValue(input, namespaceId) {
	        if (namespaceId === void 0) { namespaceId = ''; }
	        this.namespaceId = namespaceId;
	        var /** @type {?} */ isObj = input && input.hasOwnProperty('value');
	        var /** @type {?} */ value = isObj ? input['value'] : input;
	        this.value = normalizeTriggerValue(value);
	        if (isObj) {
	            var /** @type {?} */ options = copyObj(/** @type {?} */ (input));
	            delete options['value'];
	            this.options = /** @type {?} */ (options);
	        }
	        else {
	            this.options = {};
	        }
	        if (!this.options.params) {
	            this.options.params = {};
	        }
	    }
	    Object.defineProperty(StateValue.prototype, "params", {
	        get: /**
	         * @return {?}
	         */
	        function () { return /** @type {?} */ (this.options.params); },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} options
	     * @return {?}
	     */
	    StateValue.prototype.absorbOptions = /**
	     * @param {?} options
	     * @return {?}
	     */
	    function (options) {
	        var /** @type {?} */ newParams = options.params;
	        if (newParams) {
	            var /** @type {?} */ oldParams_1 = /** @type {?} */ ((this.options.params));
	            Object.keys(newParams).forEach(function (prop) {
	                if (oldParams_1[prop] == null) {
	                    oldParams_1[prop] = newParams[prop];
	                }
	            });
	        }
	    };
	    return StateValue;
	}());
	var VOID_VALUE = 'void';
	var DEFAULT_STATE_VALUE = new StateValue(VOID_VALUE);
	var DELETED_STATE_VALUE = new StateValue('DELETED');
	var AnimationTransitionNamespace = /** @class */ (function () {
	    function AnimationTransitionNamespace(id, hostElement, _engine) {
	        this.id = id;
	        this.hostElement = hostElement;
	        this._engine = _engine;
	        this.players = [];
	        this._triggers = {};
	        this._queue = [];
	        this._elementListeners = new Map();
	        this._hostClassName = 'ng-tns-' + id;
	        addClass(hostElement, this._hostClassName);
	    }
	    /**
	     * @param {?} element
	     * @param {?} name
	     * @param {?} phase
	     * @param {?} callback
	     * @return {?}
	     */
	    AnimationTransitionNamespace.prototype.listen = /**
	     * @param {?} element
	     * @param {?} name
	     * @param {?} phase
	     * @param {?} callback
	     * @return {?}
	     */
	    function (element, name, phase, callback) {
	        var _this = this;
	        if (!this._triggers.hasOwnProperty(name)) {
	            throw new Error("Unable to listen on the animation trigger event \"" + phase + "\" because the animation trigger \"" + name + "\" doesn't exist!");
	        }
	        if (phase == null || phase.length == 0) {
	            throw new Error("Unable to listen on the animation trigger \"" + name + "\" because the provided event is undefined!");
	        }
	        if (!isTriggerEventValid(phase)) {
	            throw new Error("The provided animation trigger event \"" + phase + "\" for the animation trigger \"" + name + "\" is not supported!");
	        }
	        var /** @type {?} */ listeners = getOrSetAsInMap(this._elementListeners, element, []);
	        var /** @type {?} */ data = { name: name, phase: phase, callback: callback };
	        listeners.push(data);
	        var /** @type {?} */ triggersWithStates = getOrSetAsInMap(this._engine.statesByElement, element, {});
	        if (!triggersWithStates.hasOwnProperty(name)) {
	            addClass(element, NG_TRIGGER_CLASSNAME);
	            addClass(element, NG_TRIGGER_CLASSNAME + '-' + name);
	            triggersWithStates[name] = DEFAULT_STATE_VALUE;
	        }
	        return function () {
	            // the event listener is removed AFTER the flush has occurred such
	            // that leave animations callbacks can fire (otherwise if the node
	            // is removed in between then the listeners would be deregistered)
	            // the event listener is removed AFTER the flush has occurred such
	            // that leave animations callbacks can fire (otherwise if the node
	            // is removed in between then the listeners would be deregistered)
	            _this._engine.afterFlush(function () {
	                var /** @type {?} */ index = listeners.indexOf(data);
	                if (index >= 0) {
	                    listeners.splice(index, 1);
	                }
	                if (!_this._triggers[name]) {
	                    delete triggersWithStates[name];
	                }
	            });
	        };
	    };
	    /**
	     * @param {?} name
	     * @param {?} ast
	     * @return {?}
	     */
	    AnimationTransitionNamespace.prototype.register = /**
	     * @param {?} name
	     * @param {?} ast
	     * @return {?}
	     */
	    function (name, ast) {
	        if (this._triggers[name]) {
	            // throw
	            return false;
	        }
	        else {
	            this._triggers[name] = ast;
	            return true;
	        }
	    };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    AnimationTransitionNamespace.prototype._getTrigger = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        var /** @type {?} */ trigger = this._triggers[name];
	        if (!trigger) {
	            throw new Error("The provided animation trigger \"" + name + "\" has not been registered!");
	        }
	        return trigger;
	    };
	    /**
	     * @param {?} element
	     * @param {?} triggerName
	     * @param {?} value
	     * @param {?=} defaultToFallback
	     * @return {?}
	     */
	    AnimationTransitionNamespace.prototype.trigger = /**
	     * @param {?} element
	     * @param {?} triggerName
	     * @param {?} value
	     * @param {?=} defaultToFallback
	     * @return {?}
	     */
	    function (element, triggerName, value, defaultToFallback) {
	        var _this = this;
	        if (defaultToFallback === void 0) { defaultToFallback = true; }
	        var /** @type {?} */ trigger = this._getTrigger(triggerName);
	        var /** @type {?} */ player = new TransitionAnimationPlayer(this.id, triggerName, element);
	        var /** @type {?} */ triggersWithStates = this._engine.statesByElement.get(element);
	        if (!triggersWithStates) {
	            addClass(element, NG_TRIGGER_CLASSNAME);
	            addClass(element, NG_TRIGGER_CLASSNAME + '-' + triggerName);
	            this._engine.statesByElement.set(element, triggersWithStates = {});
	        }
	        var /** @type {?} */ fromState = triggersWithStates[triggerName];
	        var /** @type {?} */ toState = new StateValue(value, this.id);
	        var /** @type {?} */ isObj = value && value.hasOwnProperty('value');
	        if (!isObj && fromState) {
	            toState.absorbOptions(fromState.options);
	        }
	        triggersWithStates[triggerName] = toState;
	        if (!fromState) {
	            fromState = DEFAULT_STATE_VALUE;
	        }
	        else if (fromState === DELETED_STATE_VALUE) {
	            return player;
	        }
	        var /** @type {?} */ isRemoval = toState.value === VOID_VALUE;
	        // normally this isn't reached by here, however, if an object expression
	        // is passed in then it may be a new object each time. Comparing the value
	        // is important since that will stay the same despite there being a new object.
	        // The removal arc here is special cased because the same element is triggered
	        // twice in the event that it contains animations on the outer/inner portions
	        // of the host container
	        if (!isRemoval && fromState.value === toState.value) {
	            // this means that despite the value not changing, some inner params
	            // have changed which means that the animation final styles need to be applied
	            if (!objEquals(fromState.params, toState.params)) {
	                var /** @type {?} */ errors = [];
	                var /** @type {?} */ fromStyles_1 = trigger.matchStyles(fromState.value, fromState.params, errors);
	                var /** @type {?} */ toStyles_1 = trigger.matchStyles(toState.value, toState.params, errors);
	                if (errors.length) {
	                    this._engine.reportError(errors);
	                }
	                else {
	                    this._engine.afterFlush(function () {
	                        eraseStyles(element, fromStyles_1);
	                        setStyles(element, toStyles_1);
	                    });
	                }
	            }
	            return;
	        }
	        var /** @type {?} */ playersOnElement = getOrSetAsInMap(this._engine.playersByElement, element, []);
	        playersOnElement.forEach(function (player) {
	            // only remove the player if it is queued on the EXACT same trigger/namespace
	            // we only also deal with queued players here because if the animation has
	            // started then we want to keep the player alive until the flush happens
	            // (which is where the previousPlayers are passed into the new palyer)
	            if (player.namespaceId == _this.id && player.triggerName == triggerName && player.queued) {
	                player.destroy();
	            }
	        });
	        var /** @type {?} */ transition = trigger.matchTransition(fromState.value, toState.value);
	        var /** @type {?} */ isFallbackTransition = false;
	        if (!transition) {
	            if (!defaultToFallback)
	                return;
	            transition = trigger.fallbackTransition;
	            isFallbackTransition = true;
	        }
	        this._engine.totalQueuedPlayers++;
	        this._queue.push({ element: element, triggerName: triggerName, transition: transition, fromState: fromState, toState: toState, player: player, isFallbackTransition: isFallbackTransition });
	        if (!isFallbackTransition) {
	            addClass(element, QUEUED_CLASSNAME);
	            player.onStart(function () { removeClass(element, QUEUED_CLASSNAME); });
	        }
	        player.onDone(function () {
	            var /** @type {?} */ index = _this.players.indexOf(player);
	            if (index >= 0) {
	                _this.players.splice(index, 1);
	            }
	            var /** @type {?} */ players = _this._engine.playersByElement.get(element);
	            if (players) {
	                var /** @type {?} */ index_1 = players.indexOf(player);
	                if (index_1 >= 0) {
	                    players.splice(index_1, 1);
	                }
	            }
	        });
	        this.players.push(player);
	        playersOnElement.push(player);
	        return player;
	    };
	    /**
	     * @param {?} name
	     * @return {?}
	     */
	    AnimationTransitionNamespace.prototype.deregister = /**
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        var _this = this;
	        delete this._triggers[name];
	        this._engine.statesByElement.forEach(function (stateMap, element) { delete stateMap[name]; });
	        this._elementListeners.forEach(function (listeners, element) {
	            _this._elementListeners.set(element, listeners.filter(function (entry) { return entry.name != name; }));
	        });
	    };
	    /**
	     * @param {?} element
	     * @return {?}
	     */
	    AnimationTransitionNamespace.prototype.clearElementCache = /**
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) {
	        this._engine.statesByElement.delete(element);
	        this._elementListeners.delete(element);
	        var /** @type {?} */ elementPlayers = this._engine.playersByElement.get(element);
	        if (elementPlayers) {
	            elementPlayers.forEach(function (player) { return player.destroy(); });
	            this._engine.playersByElement.delete(element);
	        }
	    };
	    /**
	     * @param {?} rootElement
	     * @param {?} context
	     * @param {?=} animate
	     * @return {?}
	     */
	    AnimationTransitionNamespace.prototype._signalRemovalForInnerTriggers = /**
	     * @param {?} rootElement
	     * @param {?} context
	     * @param {?=} animate
	     * @return {?}
	     */
	    function (rootElement, context, animate) {
	        var _this = this;
	        if (animate === void 0) { animate = false; }
	        // emulate a leave animation for all inner nodes within this node.
	        // If there are no animations found for any of the nodes then clear the cache
	        // for the element.
	        this._engine.driver.query(rootElement, NG_TRIGGER_SELECTOR, true).forEach(function (elm) {
	            // this means that an inner remove() operation has already kicked off
	            // the animation on this element...
	            if (elm[REMOVAL_FLAG])
	                return;
	            var /** @type {?} */ namespaces = _this._engine.fetchNamespacesByElement(elm);
	            if (namespaces.size) {
	                namespaces.forEach(function (ns) { return ns.triggerLeaveAnimation(elm, context, false, true); });
	            }
	            else {
	                _this.clearElementCache(elm);
	            }
	        });
	    };
	    /**
	     * @param {?} element
	     * @param {?} context
	     * @param {?=} destroyAfterComplete
	     * @param {?=} defaultToFallback
	     * @return {?}
	     */
	    AnimationTransitionNamespace.prototype.triggerLeaveAnimation = /**
	     * @param {?} element
	     * @param {?} context
	     * @param {?=} destroyAfterComplete
	     * @param {?=} defaultToFallback
	     * @return {?}
	     */
	    function (element, context, destroyAfterComplete, defaultToFallback) {
	        var _this = this;
	        var /** @type {?} */ triggerStates = this._engine.statesByElement.get(element);
	        if (triggerStates) {
	            var /** @type {?} */ players_1 = [];
	            Object.keys(triggerStates).forEach(function (triggerName) {
	                // this check is here in the event that an element is removed
	                // twice (both on the host level and the component level)
	                if (_this._triggers[triggerName]) {
	                    var /** @type {?} */ player = _this.trigger(element, triggerName, VOID_VALUE, defaultToFallback);
	                    if (player) {
	                        players_1.push(player);
	                    }
	                }
	            });
	            if (players_1.length) {
	                this._engine.markElementAsRemoved(this.id, element, true, context);
	                if (destroyAfterComplete) {
	                    optimizeGroupPlayer(players_1).onDone(function () { return _this._engine.processLeaveNode(element); });
	                }
	                return true;
	            }
	        }
	        return false;
	    };
	    /**
	     * @param {?} element
	     * @return {?}
	     */
	    AnimationTransitionNamespace.prototype.prepareLeaveAnimationListeners = /**
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) {
	        var _this = this;
	        var /** @type {?} */ listeners = this._elementListeners.get(element);
	        if (listeners) {
	            var /** @type {?} */ visitedTriggers_1 = new Set();
	            listeners.forEach(function (listener) {
	                var /** @type {?} */ triggerName = listener.name;
	                if (visitedTriggers_1.has(triggerName))
	                    return;
	                visitedTriggers_1.add(triggerName);
	                var /** @type {?} */ trigger = _this._triggers[triggerName];
	                var /** @type {?} */ transition = trigger.fallbackTransition;
	                var /** @type {?} */ elementStates = /** @type {?} */ ((_this._engine.statesByElement.get(element)));
	                var /** @type {?} */ fromState = elementStates[triggerName] || DEFAULT_STATE_VALUE;
	                var /** @type {?} */ toState = new StateValue(VOID_VALUE);
	                var /** @type {?} */ player = new TransitionAnimationPlayer(_this.id, triggerName, element);
	                _this._engine.totalQueuedPlayers++;
	                _this._queue.push({
	                    element: element,
	                    triggerName: triggerName,
	                    transition: transition,
	                    fromState: fromState,
	                    toState: toState,
	                    player: player,
	                    isFallbackTransition: true
	                });
	            });
	        }
	    };
	    /**
	     * @param {?} element
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationTransitionNamespace.prototype.removeNode = /**
	     * @param {?} element
	     * @param {?} context
	     * @return {?}
	     */
	    function (element, context) {
	        var _this = this;
	        var /** @type {?} */ engine = this._engine;
	        if (element.childElementCount) {
	            this._signalRemovalForInnerTriggers(element, context, true);
	        }
	        // this means that a * => VOID animation was detected and kicked off
	        if (this.triggerLeaveAnimation(element, context, true))
	            return;
	        // find the player that is animating and make sure that the
	        // removal is delayed until that player has completed
	        var /** @type {?} */ containsPotentialParentTransition = false;
	        if (engine.totalAnimations) {
	            var /** @type {?} */ currentPlayers = engine.players.length ? engine.playersByQueriedElement.get(element) : [];
	            // when this `if statement` does not continue forward it means that
	            // a previous animation query has selected the current element and
	            // is animating it. In this situation want to continue fowards and
	            // allow the element to be queued up for animation later.
	            if (currentPlayers && currentPlayers.length) {
	                containsPotentialParentTransition = true;
	            }
	            else {
	                var /** @type {?} */ parent_1 = element;
	                while (parent_1 = parent_1.parentNode) {
	                    var /** @type {?} */ triggers = engine.statesByElement.get(parent_1);
	                    if (triggers) {
	                        containsPotentialParentTransition = true;
	                        break;
	                    }
	                }
	            }
	        }
	        // at this stage we know that the element will either get removed
	        // during flush or will be picked up by a parent query. Either way
	        // we need to fire the listeners for this element when it DOES get
	        // removed (once the query parent animation is done or after flush)
	        this.prepareLeaveAnimationListeners(element);
	        // whether or not a parent has an animation we need to delay the deferral of the leave
	        // operation until we have more information (which we do after flush() has been called)
	        if (containsPotentialParentTransition) {
	            engine.markElementAsRemoved(this.id, element, false, context);
	        }
	        else {
	            // we do this after the flush has occurred such
	            // that the callbacks can be fired
	            engine.afterFlush(function () { return _this.clearElementCache(element); });
	            engine.destroyInnerAnimations(element);
	            engine._onRemovalComplete(element, context);
	        }
	    };
	    /**
	     * @param {?} element
	     * @param {?} parent
	     * @return {?}
	     */
	    AnimationTransitionNamespace.prototype.insertNode = /**
	     * @param {?} element
	     * @param {?} parent
	     * @return {?}
	     */
	    function (element, parent) { addClass(element, this._hostClassName); };
	    /**
	     * @param {?} microtaskId
	     * @return {?}
	     */
	    AnimationTransitionNamespace.prototype.drainQueuedTransitions = /**
	     * @param {?} microtaskId
	     * @return {?}
	     */
	    function (microtaskId) {
	        var _this = this;
	        var /** @type {?} */ instructions = [];
	        this._queue.forEach(function (entry) {
	            var /** @type {?} */ player = entry.player;
	            if (player.destroyed)
	                return;
	            var /** @type {?} */ element = entry.element;
	            var /** @type {?} */ listeners = _this._elementListeners.get(element);
	            if (listeners) {
	                listeners.forEach(function (listener) {
	                    if (listener.name == entry.triggerName) {
	                        var /** @type {?} */ baseEvent = makeAnimationEvent(element, entry.triggerName, entry.fromState.value, entry.toState.value);
	                        (/** @type {?} */ (baseEvent))['_data'] = microtaskId;
	                        listenOnPlayer(entry.player, listener.phase, baseEvent, listener.callback);
	                    }
	                });
	            }
	            if (player.markedForDestroy) {
	                _this._engine.afterFlush(function () {
	                    // now we can destroy the element properly since the event listeners have
	                    // been bound to the player
	                    player.destroy();
	                });
	            }
	            else {
	                instructions.push(entry);
	            }
	        });
	        this._queue = [];
	        return instructions.sort(function (a, b) {
	            // if depCount == 0 them move to front
	            // otherwise if a contains b then move back
	            var /** @type {?} */ d0 = a.transition.ast.depCount;
	            var /** @type {?} */ d1 = b.transition.ast.depCount;
	            if (d0 == 0 || d1 == 0) {
	                return d0 - d1;
	            }
	            return _this._engine.driver.containsElement(a.element, b.element) ? 1 : -1;
	        });
	    };
	    /**
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationTransitionNamespace.prototype.destroy = /**
	     * @param {?} context
	     * @return {?}
	     */
	    function (context) {
	        this.players.forEach(function (p) { return p.destroy(); });
	        this._signalRemovalForInnerTriggers(this.hostElement, context);
	    };
	    /**
	     * @param {?} element
	     * @return {?}
	     */
	    AnimationTransitionNamespace.prototype.elementContainsData = /**
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) {
	        var /** @type {?} */ containsData = false;
	        if (this._elementListeners.has(element))
	            containsData = true;
	        containsData =
	            (this._queue.find(function (entry) { return entry.element === element; }) ? true : false) || containsData;
	        return containsData;
	    };
	    return AnimationTransitionNamespace;
	}());
	/**
	 * @record
	 */
	
	var TransitionAnimationEngine = /** @class */ (function () {
	    function TransitionAnimationEngine(driver, _normalizer) {
	        this.driver = driver;
	        this._normalizer = _normalizer;
	        this.players = [];
	        this.newHostElements = new Map();
	        this.playersByElement = new Map();
	        this.playersByQueriedElement = new Map();
	        this.statesByElement = new Map();
	        this.disabledNodes = new Set();
	        this.totalAnimations = 0;
	        this.totalQueuedPlayers = 0;
	        this._namespaceLookup = {};
	        this._namespaceList = [];
	        this._flushFns = [];
	        this._whenQuietFns = [];
	        this.namespacesByHostElement = new Map();
	        this.collectedEnterElements = [];
	        this.collectedLeaveElements = [];
	        this.onRemovalComplete = function (element, context) { };
	    }
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} element
	     * @param {?} context
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype._onRemovalComplete = /**
	     * \@internal
	     * @param {?} element
	     * @param {?} context
	     * @return {?}
	     */
	    function (element, context) { this.onRemovalComplete(element, context); };
	    Object.defineProperty(TransitionAnimationEngine.prototype, "queuedPlayers", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ players = [];
	            this._namespaceList.forEach(function (ns) {
	                ns.players.forEach(function (player) {
	                    if (player.queued) {
	                        players.push(player);
	                    }
	                });
	            });
	            return players;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} namespaceId
	     * @param {?} hostElement
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.createNamespace = /**
	     * @param {?} namespaceId
	     * @param {?} hostElement
	     * @return {?}
	     */
	    function (namespaceId, hostElement) {
	        var /** @type {?} */ ns = new AnimationTransitionNamespace(namespaceId, hostElement, this);
	        if (hostElement.parentNode) {
	            this._balanceNamespaceList(ns, hostElement);
	        }
	        else {
	            // defer this later until flush during when the host element has
	            // been inserted so that we know exactly where to place it in
	            // the namespace list
	            this.newHostElements.set(hostElement, ns);
	            // given that this host element is apart of the animation code, it
	            // may or may not be inserted by a parent node that is an of an
	            // animation renderer type. If this happens then we can still have
	            // access to this item when we query for :enter nodes. If the parent
	            // is a renderer then the set data-structure will normalize the entry
	            this.collectEnterElement(hostElement);
	        }
	        return this._namespaceLookup[namespaceId] = ns;
	    };
	    /**
	     * @param {?} ns
	     * @param {?} hostElement
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype._balanceNamespaceList = /**
	     * @param {?} ns
	     * @param {?} hostElement
	     * @return {?}
	     */
	    function (ns, hostElement) {
	        var /** @type {?} */ limit = this._namespaceList.length - 1;
	        if (limit >= 0) {
	            var /** @type {?} */ found = false;
	            for (var /** @type {?} */ i = limit; i >= 0; i--) {
	                var /** @type {?} */ nextNamespace = this._namespaceList[i];
	                if (this.driver.containsElement(nextNamespace.hostElement, hostElement)) {
	                    this._namespaceList.splice(i + 1, 0, ns);
	                    found = true;
	                    break;
	                }
	            }
	            if (!found) {
	                this._namespaceList.splice(0, 0, ns);
	            }
	        }
	        else {
	            this._namespaceList.push(ns);
	        }
	        this.namespacesByHostElement.set(hostElement, ns);
	        return ns;
	    };
	    /**
	     * @param {?} namespaceId
	     * @param {?} hostElement
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.register = /**
	     * @param {?} namespaceId
	     * @param {?} hostElement
	     * @return {?}
	     */
	    function (namespaceId, hostElement) {
	        var /** @type {?} */ ns = this._namespaceLookup[namespaceId];
	        if (!ns) {
	            ns = this.createNamespace(namespaceId, hostElement);
	        }
	        return ns;
	    };
	    /**
	     * @param {?} namespaceId
	     * @param {?} name
	     * @param {?} trigger
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.registerTrigger = /**
	     * @param {?} namespaceId
	     * @param {?} name
	     * @param {?} trigger
	     * @return {?}
	     */
	    function (namespaceId, name, trigger) {
	        var /** @type {?} */ ns = this._namespaceLookup[namespaceId];
	        if (ns && ns.register(name, trigger)) {
	            this.totalAnimations++;
	        }
	    };
	    /**
	     * @param {?} namespaceId
	     * @param {?} context
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.destroy = /**
	     * @param {?} namespaceId
	     * @param {?} context
	     * @return {?}
	     */
	    function (namespaceId, context) {
	        var _this = this;
	        if (!namespaceId)
	            return;
	        var /** @type {?} */ ns = this._fetchNamespace(namespaceId);
	        this.afterFlush(function () {
	            _this.namespacesByHostElement.delete(ns.hostElement);
	            delete _this._namespaceLookup[namespaceId];
	            var /** @type {?} */ index = _this._namespaceList.indexOf(ns);
	            if (index >= 0) {
	                _this._namespaceList.splice(index, 1);
	            }
	        });
	        this.afterFlushAnimationsDone(function () { return ns.destroy(context); });
	    };
	    /**
	     * @param {?} id
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype._fetchNamespace = /**
	     * @param {?} id
	     * @return {?}
	     */
	    function (id) { return this._namespaceLookup[id]; };
	    /**
	     * @param {?} element
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.fetchNamespacesByElement = /**
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) {
	        // normally there should only be one namespace per element, however
	        // if @triggers are placed on both the component element and then
	        // its host element (within the component code) then there will be
	        // two namespaces returned. We use a set here to simply the dedupe
	        // of namespaces incase there are multiple triggers both the elm and host
	        var /** @type {?} */ namespaces = new Set();
	        var /** @type {?} */ elementStates = this.statesByElement.get(element);
	        if (elementStates) {
	            var /** @type {?} */ keys = Object.keys(elementStates);
	            for (var /** @type {?} */ i = 0; i < keys.length; i++) {
	                var /** @type {?} */ nsId = elementStates[keys[i]].namespaceId;
	                if (nsId) {
	                    var /** @type {?} */ ns = this._fetchNamespace(nsId);
	                    if (ns) {
	                        namespaces.add(ns);
	                    }
	                }
	            }
	        }
	        return namespaces;
	    };
	    /**
	     * @param {?} namespaceId
	     * @param {?} element
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.trigger = /**
	     * @param {?} namespaceId
	     * @param {?} element
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    function (namespaceId, element, name, value) {
	        if (isElementNode(element)) {
	            this._fetchNamespace(namespaceId).trigger(element, name, value);
	            return true;
	        }
	        return false;
	    };
	    /**
	     * @param {?} namespaceId
	     * @param {?} element
	     * @param {?} parent
	     * @param {?} insertBefore
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.insertNode = /**
	     * @param {?} namespaceId
	     * @param {?} element
	     * @param {?} parent
	     * @param {?} insertBefore
	     * @return {?}
	     */
	    function (namespaceId, element, parent, insertBefore) {
	        if (!isElementNode(element))
	            return;
	        // special case for when an element is removed and reinserted (move operation)
	        // when this occurs we do not want to use the element for deletion later
	        var /** @type {?} */ details = /** @type {?} */ (element[REMOVAL_FLAG]);
	        if (details && details.setForRemoval) {
	            details.setForRemoval = false;
	        }
	        // in the event that the namespaceId is blank then the caller
	        // code does not contain any animation code in it, but it is
	        // just being called so that the node is marked as being inserted
	        if (namespaceId) {
	            var /** @type {?} */ ns = this._fetchNamespace(namespaceId);
	            // This if-statement is a workaround for router issue #21947.
	            // The router sometimes hits a race condition where while a route
	            // is being instantiated a new navigation arrives, triggering leave
	            // animation of DOM that has not been fully initialized, until this
	            // is resolved, we need to handle the scenario when DOM is not in a
	            // consistent state during the animation.
	            if (ns) {
	                ns.insertNode(element, parent);
	            }
	        }
	        // only *directives and host elements are inserted before
	        if (insertBefore) {
	            this.collectEnterElement(element);
	        }
	    };
	    /**
	     * @param {?} element
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.collectEnterElement = /**
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) { this.collectedEnterElements.push(element); };
	    /**
	     * @param {?} element
	     * @param {?} value
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.markElementAsDisabled = /**
	     * @param {?} element
	     * @param {?} value
	     * @return {?}
	     */
	    function (element, value) {
	        if (value) {
	            if (!this.disabledNodes.has(element)) {
	                this.disabledNodes.add(element);
	                addClass(element, DISABLED_CLASSNAME);
	            }
	        }
	        else if (this.disabledNodes.has(element)) {
	            this.disabledNodes.delete(element);
	            removeClass(element, DISABLED_CLASSNAME);
	        }
	    };
	    /**
	     * @param {?} namespaceId
	     * @param {?} element
	     * @param {?} context
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.removeNode = /**
	     * @param {?} namespaceId
	     * @param {?} element
	     * @param {?} context
	     * @return {?}
	     */
	    function (namespaceId, element, context) {
	        if (!isElementNode(element)) {
	            this._onRemovalComplete(element, context);
	            return;
	        }
	        var /** @type {?} */ ns = namespaceId ? this._fetchNamespace(namespaceId) : null;
	        if (ns) {
	            ns.removeNode(element, context);
	        }
	        else {
	            this.markElementAsRemoved(namespaceId, element, false, context);
	        }
	    };
	    /**
	     * @param {?} namespaceId
	     * @param {?} element
	     * @param {?=} hasAnimation
	     * @param {?=} context
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.markElementAsRemoved = /**
	     * @param {?} namespaceId
	     * @param {?} element
	     * @param {?=} hasAnimation
	     * @param {?=} context
	     * @return {?}
	     */
	    function (namespaceId, element, hasAnimation, context) {
	        this.collectedLeaveElements.push(element);
	        element[REMOVAL_FLAG] = {
	            namespaceId: namespaceId,
	            setForRemoval: context, hasAnimation: hasAnimation,
	            removedBeforeQueried: false
	        };
	    };
	    /**
	     * @param {?} namespaceId
	     * @param {?} element
	     * @param {?} name
	     * @param {?} phase
	     * @param {?} callback
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.listen = /**
	     * @param {?} namespaceId
	     * @param {?} element
	     * @param {?} name
	     * @param {?} phase
	     * @param {?} callback
	     * @return {?}
	     */
	    function (namespaceId, element, name, phase, callback) {
	        if (isElementNode(element)) {
	            return this._fetchNamespace(namespaceId).listen(element, name, phase, callback);
	        }
	        return function () { };
	    };
	    /**
	     * @param {?} entry
	     * @param {?} subTimelines
	     * @param {?} enterClassName
	     * @param {?} leaveClassName
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype._buildInstruction = /**
	     * @param {?} entry
	     * @param {?} subTimelines
	     * @param {?} enterClassName
	     * @param {?} leaveClassName
	     * @return {?}
	     */
	    function (entry, subTimelines, enterClassName, leaveClassName) {
	        return entry.transition.build(this.driver, entry.element, entry.fromState.value, entry.toState.value, enterClassName, leaveClassName, entry.fromState.options, entry.toState.options, subTimelines);
	    };
	    /**
	     * @param {?} containerElement
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.destroyInnerAnimations = /**
	     * @param {?} containerElement
	     * @return {?}
	     */
	    function (containerElement) {
	        var _this = this;
	        var /** @type {?} */ elements = this.driver.query(containerElement, NG_TRIGGER_SELECTOR, true);
	        elements.forEach(function (element) { return _this.destroyActiveAnimationsForElement(element); });
	        if (this.playersByQueriedElement.size == 0)
	            return;
	        elements = this.driver.query(containerElement, NG_ANIMATING_SELECTOR, true);
	        elements.forEach(function (element) { return _this.finishActiveQueriedAnimationOnElement(element); });
	    };
	    /**
	     * @param {?} element
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.destroyActiveAnimationsForElement = /**
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) {
	        var /** @type {?} */ players = this.playersByElement.get(element);
	        if (players) {
	            players.forEach(function (player) {
	                // special case for when an element is set for destruction, but hasn't started.
	                // in this situation we want to delay the destruction until the flush occurs
	                // so that any event listeners attached to the player are triggered.
	                if (player.queued) {
	                    player.markedForDestroy = true;
	                }
	                else {
	                    player.destroy();
	                }
	            });
	        }
	        var /** @type {?} */ stateMap = this.statesByElement.get(element);
	        if (stateMap) {
	            Object.keys(stateMap).forEach(function (triggerName) { return stateMap[triggerName] = DELETED_STATE_VALUE; });
	        }
	    };
	    /**
	     * @param {?} element
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.finishActiveQueriedAnimationOnElement = /**
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) {
	        var /** @type {?} */ players = this.playersByQueriedElement.get(element);
	        if (players) {
	            players.forEach(function (player) { return player.finish(); });
	        }
	    };
	    /**
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.whenRenderingDone = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        return new Promise(function (resolve) {
	            if (_this.players.length) {
	                return optimizeGroupPlayer(_this.players).onDone(function () { return resolve(); });
	            }
	            else {
	                resolve();
	            }
	        });
	    };
	    /**
	     * @param {?} element
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.processLeaveNode = /**
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) {
	        var _this = this;
	        var /** @type {?} */ details = /** @type {?} */ (element[REMOVAL_FLAG]);
	        if (details && details.setForRemoval) {
	            // this will prevent it from removing it twice
	            element[REMOVAL_FLAG] = NULL_REMOVAL_STATE;
	            if (details.namespaceId) {
	                this.destroyInnerAnimations(element);
	                var /** @type {?} */ ns = this._fetchNamespace(details.namespaceId);
	                if (ns) {
	                    ns.clearElementCache(element);
	                }
	            }
	            this._onRemovalComplete(element, details.setForRemoval);
	        }
	        if (this.driver.matchesElement(element, DISABLED_SELECTOR)) {
	            this.markElementAsDisabled(element, false);
	        }
	        this.driver.query(element, DISABLED_SELECTOR, true).forEach(function (node) {
	            _this.markElementAsDisabled(element, false);
	        });
	    };
	    /**
	     * @param {?=} microtaskId
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.flush = /**
	     * @param {?=} microtaskId
	     * @return {?}
	     */
	    function (microtaskId) {
	        var _this = this;
	        if (microtaskId === void 0) { microtaskId = -1; }
	        var /** @type {?} */ players = [];
	        if (this.newHostElements.size) {
	            this.newHostElements.forEach(function (ns, element) { return _this._balanceNamespaceList(ns, element); });
	            this.newHostElements.clear();
	        }
	        if (this.totalAnimations && this.collectedEnterElements.length) {
	            for (var /** @type {?} */ i = 0; i < this.collectedEnterElements.length; i++) {
	                var /** @type {?} */ elm = this.collectedEnterElements[i];
	                addClass(elm, STAR_CLASSNAME);
	            }
	        }
	        if (this._namespaceList.length &&
	            (this.totalQueuedPlayers || this.collectedLeaveElements.length)) {
	            var /** @type {?} */ cleanupFns = [];
	            try {
	                players = this._flushAnimations(cleanupFns, microtaskId);
	            }
	            finally {
	                for (var /** @type {?} */ i = 0; i < cleanupFns.length; i++) {
	                    cleanupFns[i]();
	                }
	            }
	        }
	        else {
	            for (var /** @type {?} */ i = 0; i < this.collectedLeaveElements.length; i++) {
	                var /** @type {?} */ element = this.collectedLeaveElements[i];
	                this.processLeaveNode(element);
	            }
	        }
	        this.totalQueuedPlayers = 0;
	        this.collectedEnterElements.length = 0;
	        this.collectedLeaveElements.length = 0;
	        this._flushFns.forEach(function (fn) { return fn(); });
	        this._flushFns = [];
	        if (this._whenQuietFns.length) {
	            // we move these over to a variable so that
	            // if any new callbacks are registered in another
	            // flush they do not populate the existing set
	            var /** @type {?} */ quietFns_1 = this._whenQuietFns;
	            this._whenQuietFns = [];
	            if (players.length) {
	                optimizeGroupPlayer(players).onDone(function () { quietFns_1.forEach(function (fn) { return fn(); }); });
	            }
	            else {
	                quietFns_1.forEach(function (fn) { return fn(); });
	            }
	        }
	    };
	    /**
	     * @param {?} errors
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.reportError = /**
	     * @param {?} errors
	     * @return {?}
	     */
	    function (errors) {
	        throw new Error("Unable to process animations due to the following failed trigger transitions\n " + errors.join('\n'));
	    };
	    /**
	     * @param {?} cleanupFns
	     * @param {?} microtaskId
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype._flushAnimations = /**
	     * @param {?} cleanupFns
	     * @param {?} microtaskId
	     * @return {?}
	     */
	    function (cleanupFns, microtaskId) {
	        var _this = this;
	        var /** @type {?} */ subTimelines = new ElementInstructionMap();
	        var /** @type {?} */ skippedPlayers = [];
	        var /** @type {?} */ skippedPlayersMap = new Map();
	        var /** @type {?} */ queuedInstructions = [];
	        var /** @type {?} */ queriedElements = new Map();
	        var /** @type {?} */ allPreStyleElements = new Map();
	        var /** @type {?} */ allPostStyleElements = new Map();
	        var /** @type {?} */ disabledElementsSet = new Set();
	        this.disabledNodes.forEach(function (node) {
	            disabledElementsSet.add(node);
	            var /** @type {?} */ nodesThatAreDisabled = _this.driver.query(node, QUEUED_SELECTOR, true);
	            for (var /** @type {?} */ i_1 = 0; i_1 < nodesThatAreDisabled.length; i_1++) {
	                disabledElementsSet.add(nodesThatAreDisabled[i_1]);
	            }
	        });
	        var /** @type {?} */ bodyNode = getBodyNode();
	        var /** @type {?} */ allTriggerElements = Array.from(this.statesByElement.keys());
	        var /** @type {?} */ enterNodeMap = buildRootMap(allTriggerElements, this.collectedEnterElements);
	        // this must occur before the instructions are built below such that
	        // the :enter queries match the elements (since the timeline queries
	        // are fired during instruction building).
	        var /** @type {?} */ enterNodeMapIds = new Map();
	        var /** @type {?} */ i = 0;
	        enterNodeMap.forEach(function (nodes, root) {
	            var /** @type {?} */ className = ENTER_CLASSNAME + i++;
	            enterNodeMapIds.set(root, className);
	            nodes.forEach(function (node) { return addClass(node, className); });
	        });
	        var /** @type {?} */ allLeaveNodes = [];
	        var /** @type {?} */ mergedLeaveNodes = new Set();
	        var /** @type {?} */ leaveNodesWithoutAnimations = new Set();
	        for (var /** @type {?} */ i_2 = 0; i_2 < this.collectedLeaveElements.length; i_2++) {
	            var /** @type {?} */ element = this.collectedLeaveElements[i_2];
	            var /** @type {?} */ details = /** @type {?} */ (element[REMOVAL_FLAG]);
	            if (details && details.setForRemoval) {
	                allLeaveNodes.push(element);
	                mergedLeaveNodes.add(element);
	                if (details.hasAnimation) {
	                    this.driver.query(element, STAR_SELECTOR, true).forEach(function (elm) { return mergedLeaveNodes.add(elm); });
	                }
	                else {
	                    leaveNodesWithoutAnimations.add(element);
	                }
	            }
	        }
	        var /** @type {?} */ leaveNodeMapIds = new Map();
	        var /** @type {?} */ leaveNodeMap = buildRootMap(allTriggerElements, Array.from(mergedLeaveNodes));
	        leaveNodeMap.forEach(function (nodes, root) {
	            var /** @type {?} */ className = LEAVE_CLASSNAME + i++;
	            leaveNodeMapIds.set(root, className);
	            nodes.forEach(function (node) { return addClass(node, className); });
	        });
	        cleanupFns.push(function () {
	            enterNodeMap.forEach(function (nodes, root) {
	                var /** @type {?} */ className = /** @type {?} */ ((enterNodeMapIds.get(root)));
	                nodes.forEach(function (node) { return removeClass(node, className); });
	            });
	            leaveNodeMap.forEach(function (nodes, root) {
	                var /** @type {?} */ className = /** @type {?} */ ((leaveNodeMapIds.get(root)));
	                nodes.forEach(function (node) { return removeClass(node, className); });
	            });
	            allLeaveNodes.forEach(function (element) { _this.processLeaveNode(element); });
	        });
	        var /** @type {?} */ allPlayers = [];
	        var /** @type {?} */ erroneousTransitions = [];
	        for (var /** @type {?} */ i_3 = this._namespaceList.length - 1; i_3 >= 0; i_3--) {
	            var /** @type {?} */ ns = this._namespaceList[i_3];
	            ns.drainQueuedTransitions(microtaskId).forEach(function (entry) {
	                var /** @type {?} */ player = entry.player;
	                allPlayers.push(player);
	                var /** @type {?} */ element = entry.element;
	                if (!bodyNode || !_this.driver.containsElement(bodyNode, element)) {
	                    player.destroy();
	                    return;
	                }
	                var /** @type {?} */ leaveClassName = /** @type {?} */ ((leaveNodeMapIds.get(element)));
	                var /** @type {?} */ enterClassName = /** @type {?} */ ((enterNodeMapIds.get(element)));
	                var /** @type {?} */ instruction = /** @type {?} */ ((_this._buildInstruction(entry, subTimelines, enterClassName, leaveClassName)));
	                if (instruction.errors && instruction.errors.length) {
	                    erroneousTransitions.push(instruction);
	                    return;
	                }
	                // if a unmatched transition is queued to go then it SHOULD NOT render
	                // an animation and cancel the previously running animations.
	                if (entry.isFallbackTransition) {
	                    player.onStart(function () { return eraseStyles(element, instruction.fromStyles); });
	                    player.onDestroy(function () { return setStyles(element, instruction.toStyles); });
	                    skippedPlayers.push(player);
	                    return;
	                }
	                // this means that if a parent animation uses this animation as a sub trigger
	                // then it will instruct the timeline builder to not add a player delay, but
	                // instead stretch the first keyframe gap up until the animation starts. The
	                // reason this is important is to prevent extra initialization styles from being
	                // required by the user in the animation.
	                instruction.timelines.forEach(function (tl) { return tl.stretchStartingKeyframe = true; });
	                subTimelines.append(element, instruction.timelines);
	                var /** @type {?} */ tuple = { instruction: instruction, player: player, element: element };
	                queuedInstructions.push(tuple);
	                instruction.queriedElements.forEach(function (element) { return getOrSetAsInMap(queriedElements, element, []).push(player); });
	                instruction.preStyleProps.forEach(function (stringMap, element) {
	                    var /** @type {?} */ props = Object.keys(stringMap);
	                    if (props.length) {
	                        var /** @type {?} */ setVal_1 = /** @type {?} */ ((allPreStyleElements.get(element)));
	                        if (!setVal_1) {
	                            allPreStyleElements.set(element, setVal_1 = new Set());
	                        }
	                        props.forEach(function (prop) { return setVal_1.add(prop); });
	                    }
	                });
	                instruction.postStyleProps.forEach(function (stringMap, element) {
	                    var /** @type {?} */ props = Object.keys(stringMap);
	                    var /** @type {?} */ setVal = /** @type {?} */ ((allPostStyleElements.get(element)));
	                    if (!setVal) {
	                        allPostStyleElements.set(element, setVal = new Set());
	                    }
	                    props.forEach(function (prop) { return setVal.add(prop); });
	                });
	            });
	        }
	        if (erroneousTransitions.length) {
	            var /** @type {?} */ errors_1 = [];
	            erroneousTransitions.forEach(function (instruction) {
	                errors_1.push("@" + instruction.triggerName + " has failed due to:\n"); /** @type {?} */
	                ((instruction.errors)).forEach(function (error) { return errors_1.push("- " + error + "\n"); });
	            });
	            allPlayers.forEach(function (player) { return player.destroy(); });
	            this.reportError(errors_1);
	        }
	        var /** @type {?} */ allPreviousPlayersMap = new Map();
	        // this map works to tell which element in the DOM tree is contained by
	        // which animation. Further down below this map will get populated once
	        // the players are built and in doing so it can efficiently figure out
	        // if a sub player is skipped due to a parent player having priority.
	        var /** @type {?} */ animationElementMap = new Map();
	        queuedInstructions.forEach(function (entry) {
	            var /** @type {?} */ element = entry.element;
	            if (subTimelines.has(element)) {
	                animationElementMap.set(element, element);
	                _this._beforeAnimationBuild(entry.player.namespaceId, entry.instruction, allPreviousPlayersMap);
	            }
	        });
	        skippedPlayers.forEach(function (player) {
	            var /** @type {?} */ element = player.element;
	            var /** @type {?} */ previousPlayers = _this._getPreviousPlayers(element, false, player.namespaceId, player.triggerName, null);
	            previousPlayers.forEach(function (prevPlayer) {
	                getOrSetAsInMap(allPreviousPlayersMap, element, []).push(prevPlayer);
	                prevPlayer.destroy();
	            });
	        });
	        // this is a special case for nodes that will be removed (either by)
	        // having their own leave animations or by being queried in a container
	        // that will be removed once a parent animation is complete. The idea
	        // here is that * styles must be identical to ! styles because of
	        // backwards compatibility (* is also filled in by default in many places).
	        // Otherwise * styles will return an empty value or auto since the element
	        // that is being getComputedStyle'd will not be visible (since * = destination)
	        var /** @type {?} */ replaceNodes = allLeaveNodes.filter(function (node) {
	            return replacePostStylesAsPre(node, allPreStyleElements, allPostStyleElements);
	        });
	        // POST STAGE: fill the * styles
	        var /** @type {?} */ postStylesMap = new Map();
	        var /** @type {?} */ allLeaveQueriedNodes = cloakAndComputeStyles(postStylesMap, this.driver, leaveNodesWithoutAnimations, allPostStyleElements, _angular_animations.AUTO_STYLE);
	        allLeaveQueriedNodes.forEach(function (node) {
	            if (replacePostStylesAsPre(node, allPreStyleElements, allPostStyleElements)) {
	                replaceNodes.push(node);
	            }
	        });
	        // PRE STAGE: fill the ! styles
	        var /** @type {?} */ preStylesMap = new Map();
	        enterNodeMap.forEach(function (nodes, root) {
	            cloakAndComputeStyles(preStylesMap, _this.driver, new Set(nodes), allPreStyleElements, _angular_animations.ɵPRE_STYLE);
	        });
	        replaceNodes.forEach(function (node) {
	            var /** @type {?} */ post = postStylesMap.get(node);
	            var /** @type {?} */ pre = preStylesMap.get(node);
	            postStylesMap.set(node, /** @type {?} */ (__assign({}, post, pre)));
	        });
	        var /** @type {?} */ rootPlayers = [];
	        var /** @type {?} */ subPlayers = [];
	        var /** @type {?} */ NO_PARENT_ANIMATION_ELEMENT_DETECTED = {};
	        queuedInstructions.forEach(function (entry) {
	            var element = entry.element, player = entry.player, instruction = entry.instruction;
	            // this means that it was never consumed by a parent animation which
	            // means that it is independent and therefore should be set for animation
	            if (subTimelines.has(element)) {
	                if (disabledElementsSet.has(element)) {
	                    player.onDestroy(function () { return setStyles(element, instruction.toStyles); });
	                    skippedPlayers.push(player);
	                    return;
	                }
	                // this will flow up the DOM and query the map to figure out
	                // if a parent animation has priority over it. In the situation
	                // that a parent is detected then it will cancel the loop. If
	                // nothing is detected, or it takes a few hops to find a parent,
	                // then it will fill in the missing nodes and signal them as having
	                // a detected parent (or a NO_PARENT value via a special constant).
	                var /** @type {?} */ parentWithAnimation_1 = NO_PARENT_ANIMATION_ELEMENT_DETECTED;
	                if (animationElementMap.size > 1) {
	                    var /** @type {?} */ elm = element;
	                    var /** @type {?} */ parentsToAdd = [];
	                    while (elm = elm.parentNode) {
	                        var /** @type {?} */ detectedParent = animationElementMap.get(elm);
	                        if (detectedParent) {
	                            parentWithAnimation_1 = detectedParent;
	                            break;
	                        }
	                        parentsToAdd.push(elm);
	                    }
	                    parentsToAdd.forEach(function (parent) { return animationElementMap.set(parent, parentWithAnimation_1); });
	                }
	                var /** @type {?} */ innerPlayer = _this._buildAnimation(player.namespaceId, instruction, allPreviousPlayersMap, skippedPlayersMap, preStylesMap, postStylesMap);
	                player.setRealPlayer(innerPlayer);
	                if (parentWithAnimation_1 === NO_PARENT_ANIMATION_ELEMENT_DETECTED) {
	                    rootPlayers.push(player);
	                }
	                else {
	                    var /** @type {?} */ parentPlayers = _this.playersByElement.get(parentWithAnimation_1);
	                    if (parentPlayers && parentPlayers.length) {
	                        player.parentPlayer = optimizeGroupPlayer(parentPlayers);
	                    }
	                    skippedPlayers.push(player);
	                }
	            }
	            else {
	                eraseStyles(element, instruction.fromStyles);
	                player.onDestroy(function () { return setStyles(element, instruction.toStyles); });
	                // there still might be a ancestor player animating this
	                // element therefore we will still add it as a sub player
	                // even if its animation may be disabled
	                subPlayers.push(player);
	                if (disabledElementsSet.has(element)) {
	                    skippedPlayers.push(player);
	                }
	            }
	        });
	        // find all of the sub players' corresponding inner animation player
	        subPlayers.forEach(function (player) {
	            // even if any players are not found for a sub animation then it
	            // will still complete itself after the next tick since it's Noop
	            var /** @type {?} */ playersForElement = skippedPlayersMap.get(player.element);
	            if (playersForElement && playersForElement.length) {
	                var /** @type {?} */ innerPlayer = optimizeGroupPlayer(playersForElement);
	                player.setRealPlayer(innerPlayer);
	            }
	        });
	        // the reason why we don't actually play the animation is
	        // because all that a skipped player is designed to do is to
	        // fire the start/done transition callback events
	        skippedPlayers.forEach(function (player) {
	            if (player.parentPlayer) {
	                player.syncPlayerEvents(player.parentPlayer);
	            }
	            else {
	                player.destroy();
	            }
	        });
	        // run through all of the queued removals and see if they
	        // were picked up by a query. If not then perform the removal
	        // operation right away unless a parent animation is ongoing.
	        for (var /** @type {?} */ i_4 = 0; i_4 < allLeaveNodes.length; i_4++) {
	            var /** @type {?} */ element = allLeaveNodes[i_4];
	            var /** @type {?} */ details = /** @type {?} */ (element[REMOVAL_FLAG]);
	            removeClass(element, LEAVE_CLASSNAME);
	            // this means the element has a removal animation that is being
	            // taken care of and therefore the inner elements will hang around
	            // until that animation is over (or the parent queried animation)
	            if (details && details.hasAnimation)
	                continue;
	            var /** @type {?} */ players = [];
	            // if this element is queried or if it contains queried children
	            // then we want for the element not to be removed from the page
	            // until the queried animations have finished
	            if (queriedElements.size) {
	                var /** @type {?} */ queriedPlayerResults = queriedElements.get(element);
	                if (queriedPlayerResults && queriedPlayerResults.length) {
	                    players.push.apply(players, queriedPlayerResults);
	                }
	                var /** @type {?} */ queriedInnerElements = this.driver.query(element, NG_ANIMATING_SELECTOR, true);
	                for (var /** @type {?} */ j = 0; j < queriedInnerElements.length; j++) {
	                    var /** @type {?} */ queriedPlayers = queriedElements.get(queriedInnerElements[j]);
	                    if (queriedPlayers && queriedPlayers.length) {
	                        players.push.apply(players, queriedPlayers);
	                    }
	                }
	            }
	            var /** @type {?} */ activePlayers = players.filter(function (p) { return !p.destroyed; });
	            if (activePlayers.length) {
	                removeNodesAfterAnimationDone(this, element, activePlayers);
	            }
	            else {
	                this.processLeaveNode(element);
	            }
	        }
	        // this is required so the cleanup method doesn't remove them
	        allLeaveNodes.length = 0;
	        rootPlayers.forEach(function (player) {
	            _this.players.push(player);
	            player.onDone(function () {
	                player.destroy();
	                var /** @type {?} */ index = _this.players.indexOf(player);
	                _this.players.splice(index, 1);
	            });
	            player.play();
	        });
	        return rootPlayers;
	    };
	    /**
	     * @param {?} namespaceId
	     * @param {?} element
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.elementContainsData = /**
	     * @param {?} namespaceId
	     * @param {?} element
	     * @return {?}
	     */
	    function (namespaceId, element) {
	        var /** @type {?} */ containsData = false;
	        var /** @type {?} */ details = /** @type {?} */ (element[REMOVAL_FLAG]);
	        if (details && details.setForRemoval)
	            containsData = true;
	        if (this.playersByElement.has(element))
	            containsData = true;
	        if (this.playersByQueriedElement.has(element))
	            containsData = true;
	        if (this.statesByElement.has(element))
	            containsData = true;
	        return this._fetchNamespace(namespaceId).elementContainsData(element) || containsData;
	    };
	    /**
	     * @param {?} callback
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.afterFlush = /**
	     * @param {?} callback
	     * @return {?}
	     */
	    function (callback) { this._flushFns.push(callback); };
	    /**
	     * @param {?} callback
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype.afterFlushAnimationsDone = /**
	     * @param {?} callback
	     * @return {?}
	     */
	    function (callback) { this._whenQuietFns.push(callback); };
	    /**
	     * @param {?} element
	     * @param {?} isQueriedElement
	     * @param {?=} namespaceId
	     * @param {?=} triggerName
	     * @param {?=} toStateValue
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype._getPreviousPlayers = /**
	     * @param {?} element
	     * @param {?} isQueriedElement
	     * @param {?=} namespaceId
	     * @param {?=} triggerName
	     * @param {?=} toStateValue
	     * @return {?}
	     */
	    function (element, isQueriedElement, namespaceId, triggerName, toStateValue) {
	        var /** @type {?} */ players = [];
	        if (isQueriedElement) {
	            var /** @type {?} */ queriedElementPlayers = this.playersByQueriedElement.get(element);
	            if (queriedElementPlayers) {
	                players = queriedElementPlayers;
	            }
	        }
	        else {
	            var /** @type {?} */ elementPlayers = this.playersByElement.get(element);
	            if (elementPlayers) {
	                var /** @type {?} */ isRemovalAnimation_1 = !toStateValue || toStateValue == VOID_VALUE;
	                elementPlayers.forEach(function (player) {
	                    if (player.queued)
	                        return;
	                    if (!isRemovalAnimation_1 && player.triggerName != triggerName)
	                        return;
	                    players.push(player);
	                });
	            }
	        }
	        if (namespaceId || triggerName) {
	            players = players.filter(function (player) {
	                if (namespaceId && namespaceId != player.namespaceId)
	                    return false;
	                if (triggerName && triggerName != player.triggerName)
	                    return false;
	                return true;
	            });
	        }
	        return players;
	    };
	    /**
	     * @param {?} namespaceId
	     * @param {?} instruction
	     * @param {?} allPreviousPlayersMap
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype._beforeAnimationBuild = /**
	     * @param {?} namespaceId
	     * @param {?} instruction
	     * @param {?} allPreviousPlayersMap
	     * @return {?}
	     */
	    function (namespaceId, instruction, allPreviousPlayersMap) {
	        var /** @type {?} */ triggerName = instruction.triggerName;
	        var /** @type {?} */ rootElement = instruction.element;
	        // when a removal animation occurs, ALL previous players are collected
	        // and destroyed (even if they are outside of the current namespace)
	        var /** @type {?} */ targetNameSpaceId = instruction.isRemovalTransition ? undefined : namespaceId;
	        var /** @type {?} */ targetTriggerName = instruction.isRemovalTransition ? undefined : triggerName;
	        var _loop_1 = function (timelineInstruction) {
	            var /** @type {?} */ element = timelineInstruction.element;
	            var /** @type {?} */ isQueriedElement = element !== rootElement;
	            var /** @type {?} */ players = getOrSetAsInMap(allPreviousPlayersMap, element, []);
	            var /** @type {?} */ previousPlayers = this_1._getPreviousPlayers(element, isQueriedElement, targetNameSpaceId, targetTriggerName, instruction.toState);
	            previousPlayers.forEach(function (player) {
	                var /** @type {?} */ realPlayer = /** @type {?} */ (player.getRealPlayer());
	                if (realPlayer.beforeDestroy) {
	                    realPlayer.beforeDestroy();
	                }
	                player.destroy();
	                players.push(player);
	            });
	        };
	        var this_1 = this;
	        for (var _i = 0, _a = instruction.timelines; _i < _a.length; _i++) {
	            var timelineInstruction = _a[_i];
	            _loop_1(timelineInstruction);
	        }
	        // this needs to be done so that the PRE/POST styles can be
	        // computed properly without interfering with the previous animation
	        eraseStyles(rootElement, instruction.fromStyles);
	    };
	    /**
	     * @param {?} namespaceId
	     * @param {?} instruction
	     * @param {?} allPreviousPlayersMap
	     * @param {?} skippedPlayersMap
	     * @param {?} preStylesMap
	     * @param {?} postStylesMap
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype._buildAnimation = /**
	     * @param {?} namespaceId
	     * @param {?} instruction
	     * @param {?} allPreviousPlayersMap
	     * @param {?} skippedPlayersMap
	     * @param {?} preStylesMap
	     * @param {?} postStylesMap
	     * @return {?}
	     */
	    function (namespaceId, instruction, allPreviousPlayersMap, skippedPlayersMap, preStylesMap, postStylesMap) {
	        var _this = this;
	        var /** @type {?} */ triggerName = instruction.triggerName;
	        var /** @type {?} */ rootElement = instruction.element;
	        // we first run this so that the previous animation player
	        // data can be passed into the successive animation players
	        var /** @type {?} */ allQueriedPlayers = [];
	        var /** @type {?} */ allConsumedElements = new Set();
	        var /** @type {?} */ allSubElements = new Set();
	        var /** @type {?} */ allNewPlayers = instruction.timelines.map(function (timelineInstruction) {
	            var /** @type {?} */ element = timelineInstruction.element;
	            allConsumedElements.add(element);
	            // FIXME (matsko): make sure to-be-removed animations are removed properly
	            var /** @type {?} */ details = element[REMOVAL_FLAG];
	            if (details && details.removedBeforeQueried)
	                return new _angular_animations.NoopAnimationPlayer();
	            var /** @type {?} */ isQueriedElement = element !== rootElement;
	            var /** @type {?} */ previousPlayers = flattenGroupPlayers((allPreviousPlayersMap.get(element) || EMPTY_PLAYER_ARRAY)
	                .map(function (p) { return p.getRealPlayer(); }))
	                .filter(function (p) {
	                // the `element` is not apart of the AnimationPlayer definition, but
	                // Mock/WebAnimations
	                // use the element within their implementation. This will be added in Angular5 to
	                // AnimationPlayer
	                var /** @type {?} */ pp = /** @type {?} */ (p);
	                return pp.element ? pp.element === element : false;
	            });
	            var /** @type {?} */ preStyles = preStylesMap.get(element);
	            var /** @type {?} */ postStyles = postStylesMap.get(element);
	            var /** @type {?} */ keyframes = normalizeKeyframes(_this.driver, _this._normalizer, element, timelineInstruction.keyframes, preStyles, postStyles);
	            var /** @type {?} */ player = _this._buildPlayer(timelineInstruction, keyframes, previousPlayers);
	            // this means that this particular player belongs to a sub trigger. It is
	            // important that we match this player up with the corresponding (@trigger.listener)
	            if (timelineInstruction.subTimeline && skippedPlayersMap) {
	                allSubElements.add(element);
	            }
	            if (isQueriedElement) {
	                var /** @type {?} */ wrappedPlayer = new TransitionAnimationPlayer(namespaceId, triggerName, element);
	                wrappedPlayer.setRealPlayer(player);
	                allQueriedPlayers.push(wrappedPlayer);
	            }
	            return player;
	        });
	        allQueriedPlayers.forEach(function (player) {
	            getOrSetAsInMap(_this.playersByQueriedElement, player.element, []).push(player);
	            player.onDone(function () { return deleteOrUnsetInMap(_this.playersByQueriedElement, player.element, player); });
	        });
	        allConsumedElements.forEach(function (element) { return addClass(element, NG_ANIMATING_CLASSNAME); });
	        var /** @type {?} */ player = optimizeGroupPlayer(allNewPlayers);
	        player.onDestroy(function () {
	            allConsumedElements.forEach(function (element) { return removeClass(element, NG_ANIMATING_CLASSNAME); });
	            setStyles(rootElement, instruction.toStyles);
	        });
	        // this basically makes all of the callbacks for sub element animations
	        // be dependent on the upper players for when they finish
	        allSubElements.forEach(function (element) { getOrSetAsInMap(skippedPlayersMap, element, []).push(player); });
	        return player;
	    };
	    /**
	     * @param {?} instruction
	     * @param {?} keyframes
	     * @param {?} previousPlayers
	     * @return {?}
	     */
	    TransitionAnimationEngine.prototype._buildPlayer = /**
	     * @param {?} instruction
	     * @param {?} keyframes
	     * @param {?} previousPlayers
	     * @return {?}
	     */
	    function (instruction, keyframes, previousPlayers) {
	        if (keyframes.length > 0) {
	            return this.driver.animate(instruction.element, keyframes, instruction.duration, instruction.delay, instruction.easing, previousPlayers);
	        }
	        // special case for when an empty transition|definition is provided
	        // ... there is no point in rendering an empty animation
	        return new _angular_animations.NoopAnimationPlayer();
	    };
	    return TransitionAnimationEngine;
	}());
	var TransitionAnimationPlayer = /** @class */ (function () {
	    function TransitionAnimationPlayer(namespaceId, triggerName, element) {
	        this.namespaceId = namespaceId;
	        this.triggerName = triggerName;
	        this.element = element;
	        this._player = new _angular_animations.NoopAnimationPlayer();
	        this._containsRealPlayer = false;
	        this._queuedCallbacks = {};
	        this.destroyed = false;
	        this.markedForDestroy = false;
	        this.queued = true;
	    }
	    /**
	     * @param {?} player
	     * @return {?}
	     */
	    TransitionAnimationPlayer.prototype.setRealPlayer = /**
	     * @param {?} player
	     * @return {?}
	     */
	    function (player) {
	        var _this = this;
	        if (this._containsRealPlayer)
	            return;
	        this._player = player;
	        Object.keys(this._queuedCallbacks).forEach(function (phase) {
	            _this._queuedCallbacks[phase].forEach(function (callback) { return listenOnPlayer(player, phase, undefined, callback); });
	        });
	        this._queuedCallbacks = {};
	        this._containsRealPlayer = true;
	        (/** @type {?} */ (this)).queued = false;
	    };
	    /**
	     * @return {?}
	     */
	    TransitionAnimationPlayer.prototype.getRealPlayer = /**
	     * @return {?}
	     */
	    function () { return this._player; };
	    /**
	     * @param {?} player
	     * @return {?}
	     */
	    TransitionAnimationPlayer.prototype.syncPlayerEvents = /**
	     * @param {?} player
	     * @return {?}
	     */
	    function (player) {
	        var _this = this;
	        var /** @type {?} */ p = /** @type {?} */ (this._player);
	        if (p.triggerCallback) {
	            player.onStart(function () { return p.triggerCallback('start'); });
	        }
	        player.onDone(function () { return _this.finish(); });
	        player.onDestroy(function () { return _this.destroy(); });
	    };
	    /**
	     * @param {?} name
	     * @param {?} callback
	     * @return {?}
	     */
	    TransitionAnimationPlayer.prototype._queueEvent = /**
	     * @param {?} name
	     * @param {?} callback
	     * @return {?}
	     */
	    function (name, callback) {
	        getOrSetAsInMap(this._queuedCallbacks, name, []).push(callback);
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    TransitionAnimationPlayer.prototype.onDone = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        if (this.queued) {
	            this._queueEvent('done', fn);
	        }
	        this._player.onDone(fn);
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    TransitionAnimationPlayer.prototype.onStart = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        if (this.queued) {
	            this._queueEvent('start', fn);
	        }
	        this._player.onStart(fn);
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    TransitionAnimationPlayer.prototype.onDestroy = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        if (this.queued) {
	            this._queueEvent('destroy', fn);
	        }
	        this._player.onDestroy(fn);
	    };
	    /**
	     * @return {?}
	     */
	    TransitionAnimationPlayer.prototype.init = /**
	     * @return {?}
	     */
	    function () { this._player.init(); };
	    /**
	     * @return {?}
	     */
	    TransitionAnimationPlayer.prototype.hasStarted = /**
	     * @return {?}
	     */
	    function () { return this.queued ? false : this._player.hasStarted(); };
	    /**
	     * @return {?}
	     */
	    TransitionAnimationPlayer.prototype.play = /**
	     * @return {?}
	     */
	    function () { !this.queued && this._player.play(); };
	    /**
	     * @return {?}
	     */
	    TransitionAnimationPlayer.prototype.pause = /**
	     * @return {?}
	     */
	    function () { !this.queued && this._player.pause(); };
	    /**
	     * @return {?}
	     */
	    TransitionAnimationPlayer.prototype.restart = /**
	     * @return {?}
	     */
	    function () { !this.queued && this._player.restart(); };
	    /**
	     * @return {?}
	     */
	    TransitionAnimationPlayer.prototype.finish = /**
	     * @return {?}
	     */
	    function () { this._player.finish(); };
	    /**
	     * @return {?}
	     */
	    TransitionAnimationPlayer.prototype.destroy = /**
	     * @return {?}
	     */
	    function () {
	        (/** @type {?} */ (this)).destroyed = true;
	        this._player.destroy();
	    };
	    /**
	     * @return {?}
	     */
	    TransitionAnimationPlayer.prototype.reset = /**
	     * @return {?}
	     */
	    function () { !this.queued && this._player.reset(); };
	    /**
	     * @param {?} p
	     * @return {?}
	     */
	    TransitionAnimationPlayer.prototype.setPosition = /**
	     * @param {?} p
	     * @return {?}
	     */
	    function (p) {
	        if (!this.queued) {
	            this._player.setPosition(p);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    TransitionAnimationPlayer.prototype.getPosition = /**
	     * @return {?}
	     */
	    function () { return this.queued ? 0 : this._player.getPosition(); };
	    Object.defineProperty(TransitionAnimationPlayer.prototype, "totalTime", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._player.totalTime; },
	        enumerable: true,
	        configurable: true
	    });
	    /* @internal */
	    /**
	     * @param {?} phaseName
	     * @return {?}
	     */
	    TransitionAnimationPlayer.prototype.triggerCallback = /**
	     * @param {?} phaseName
	     * @return {?}
	     */
	    function (phaseName) {
	        var /** @type {?} */ p = /** @type {?} */ (this._player);
	        if (p.triggerCallback) {
	            p.triggerCallback(phaseName);
	        }
	    };
	    return TransitionAnimationPlayer;
	}());
	/**
	 * @param {?} map
	 * @param {?} key
	 * @param {?} value
	 * @return {?}
	 */
	function deleteOrUnsetInMap(map, key, value) {
	    var /** @type {?} */ currentValues;
	    if (map instanceof Map) {
	        currentValues = map.get(key);
	        if (currentValues) {
	            if (currentValues.length) {
	                var /** @type {?} */ index = currentValues.indexOf(value);
	                currentValues.splice(index, 1);
	            }
	            if (currentValues.length == 0) {
	                map.delete(key);
	            }
	        }
	    }
	    else {
	        currentValues = map[key];
	        if (currentValues) {
	            if (currentValues.length) {
	                var /** @type {?} */ index = currentValues.indexOf(value);
	                currentValues.splice(index, 1);
	            }
	            if (currentValues.length == 0) {
	                delete map[key];
	            }
	        }
	    }
	    return currentValues;
	}
	/**
	 * @param {?} value
	 * @return {?}
	 */
	function normalizeTriggerValue(value) {
	    // we use `!= null` here because it's the most simple
	    // way to test against a "falsy" value without mixing
	    // in empty strings or a zero value. DO NOT OPTIMIZE.
	    return value != null ? value : null;
	}
	/**
	 * @param {?} node
	 * @return {?}
	 */
	function isElementNode(node) {
	    return node && node['nodeType'] === 1;
	}
	/**
	 * @param {?} eventName
	 * @return {?}
	 */
	function isTriggerEventValid(eventName) {
	    return eventName == 'start' || eventName == 'done';
	}
	/**
	 * @param {?} element
	 * @param {?=} value
	 * @return {?}
	 */
	function cloakElement(element, value) {
	    var /** @type {?} */ oldValue = element.style.display;
	    element.style.display = value != null ? value : 'none';
	    return oldValue;
	}
	/**
	 * @param {?} valuesMap
	 * @param {?} driver
	 * @param {?} elements
	 * @param {?} elementPropsMap
	 * @param {?} defaultStyle
	 * @return {?}
	 */
	function cloakAndComputeStyles(valuesMap, driver, elements, elementPropsMap, defaultStyle) {
	    var /** @type {?} */ cloakVals = [];
	    elements.forEach(function (element) { return cloakVals.push(cloakElement(element)); });
	    var /** @type {?} */ failedElements = [];
	    elementPropsMap.forEach(function (props, element) {
	        var /** @type {?} */ styles = {};
	        props.forEach(function (prop) {
	            var /** @type {?} */ value = styles[prop] = driver.computeStyle(element, prop, defaultStyle);
	            // there is no easy way to detect this because a sub element could be removed
	            // by a parent animation element being detached.
	            if (!value || value.length == 0) {
	                element[REMOVAL_FLAG] = NULL_REMOVED_QUERIED_STATE;
	                failedElements.push(element);
	            }
	        });
	        valuesMap.set(element, styles);
	    });
	    // we use a index variable here since Set.forEach(a, i) does not return
	    // an index value for the closure (but instead just the value)
	    var /** @type {?} */ i = 0;
	    elements.forEach(function (element) { return cloakElement(element, cloakVals[i++]); });
	    return failedElements;
	}
	/**
	 * @param {?} roots
	 * @param {?} nodes
	 * @return {?}
	 */
	function buildRootMap(roots, nodes) {
	    var /** @type {?} */ rootMap = new Map();
	    roots.forEach(function (root) { return rootMap.set(root, []); });
	    if (nodes.length == 0)
	        return rootMap;
	    var /** @type {?} */ NULL_NODE = 1;
	    var /** @type {?} */ nodeSet = new Set(nodes);
	    var /** @type {?} */ localRootMap = new Map();
	    /**
	     * @param {?} node
	     * @return {?}
	     */
	    function getRoot(node) {
	        if (!node)
	            return NULL_NODE;
	        var /** @type {?} */ root = localRootMap.get(node);
	        if (root)
	            return root;
	        var /** @type {?} */ parent = node.parentNode;
	        if (rootMap.has(parent)) {
	            // ngIf inside @trigger
	            root = parent;
	        }
	        else if (nodeSet.has(parent)) {
	            // ngIf inside ngIf
	            root = NULL_NODE;
	        }
	        else {
	            // recurse upwards
	            root = getRoot(parent);
	        }
	        localRootMap.set(node, root);
	        return root;
	    }
	    nodes.forEach(function (node) {
	        var /** @type {?} */ root = getRoot(node);
	        if (root !== NULL_NODE) {
	            /** @type {?} */ ((rootMap.get(root))).push(node);
	        }
	    });
	    return rootMap;
	}
	var CLASSES_CACHE_KEY = '$$classes';
	/**
	 * @param {?} element
	 * @param {?} className
	 * @return {?}
	 */
	function addClass(element, className) {
	    if (element.classList) {
	        element.classList.add(className);
	    }
	    else {
	        var /** @type {?} */ classes = element[CLASSES_CACHE_KEY];
	        if (!classes) {
	            classes = element[CLASSES_CACHE_KEY] = {};
	        }
	        classes[className] = true;
	    }
	}
	/**
	 * @param {?} element
	 * @param {?} className
	 * @return {?}
	 */
	function removeClass(element, className) {
	    if (element.classList) {
	        element.classList.remove(className);
	    }
	    else {
	        var /** @type {?} */ classes = element[CLASSES_CACHE_KEY];
	        if (classes) {
	            delete classes[className];
	        }
	    }
	}
	/**
	 * @param {?} engine
	 * @param {?} element
	 * @param {?} players
	 * @return {?}
	 */
	function removeNodesAfterAnimationDone(engine, element, players) {
	    optimizeGroupPlayer(players).onDone(function () { return engine.processLeaveNode(element); });
	}
	/**
	 * @param {?} players
	 * @return {?}
	 */
	function flattenGroupPlayers(players) {
	    var /** @type {?} */ finalPlayers = [];
	    _flattenGroupPlayersRecur(players, finalPlayers);
	    return finalPlayers;
	}
	/**
	 * @param {?} players
	 * @param {?} finalPlayers
	 * @return {?}
	 */
	function _flattenGroupPlayersRecur(players, finalPlayers) {
	    for (var /** @type {?} */ i = 0; i < players.length; i++) {
	        var /** @type {?} */ player = players[i];
	        if (player instanceof _angular_animations.ɵAnimationGroupPlayer) {
	            _flattenGroupPlayersRecur(player.players, finalPlayers);
	        }
	        else {
	            finalPlayers.push(/** @type {?} */ (player));
	        }
	    }
	}
	/**
	 * @param {?} a
	 * @param {?} b
	 * @return {?}
	 */
	function objEquals(a, b) {
	    var /** @type {?} */ k1 = Object.keys(a);
	    var /** @type {?} */ k2 = Object.keys(b);
	    if (k1.length != k2.length)
	        return false;
	    for (var /** @type {?} */ i = 0; i < k1.length; i++) {
	        var /** @type {?} */ prop = k1[i];
	        if (!b.hasOwnProperty(prop) || a[prop] !== b[prop])
	            return false;
	    }
	    return true;
	}
	/**
	 * @param {?} element
	 * @param {?} allPreStyleElements
	 * @param {?} allPostStyleElements
	 * @return {?}
	 */
	function replacePostStylesAsPre(element, allPreStyleElements, allPostStyleElements) {
	    var /** @type {?} */ postEntry = allPostStyleElements.get(element);
	    if (!postEntry)
	        return false;
	    var /** @type {?} */ preEntry = allPreStyleElements.get(element);
	    if (preEntry) {
	        postEntry.forEach(function (data) { return ((preEntry)).add(data); });
	    }
	    else {
	        allPreStyleElements.set(element, postEntry);
	    }
	    allPostStyleElements.delete(element);
	    return true;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var AnimationEngine = /** @class */ (function () {
	    function AnimationEngine(_driver, normalizer) {
	        var _this = this;
	        this._driver = _driver;
	        this._triggerCache = {};
	        this.onRemovalComplete = function (element, context) { };
	        this._transitionEngine = new TransitionAnimationEngine(_driver, normalizer);
	        this._timelineEngine = new TimelineAnimationEngine(_driver, normalizer);
	        this._transitionEngine.onRemovalComplete = function (element, context) {
	            return _this.onRemovalComplete(element, context);
	        };
	    }
	    /**
	     * @param {?} componentId
	     * @param {?} namespaceId
	     * @param {?} hostElement
	     * @param {?} name
	     * @param {?} metadata
	     * @return {?}
	     */
	    AnimationEngine.prototype.registerTrigger = /**
	     * @param {?} componentId
	     * @param {?} namespaceId
	     * @param {?} hostElement
	     * @param {?} name
	     * @param {?} metadata
	     * @return {?}
	     */
	    function (componentId, namespaceId, hostElement, name, metadata) {
	        var /** @type {?} */ cacheKey = componentId + '-' + name;
	        var /** @type {?} */ trigger = this._triggerCache[cacheKey];
	        if (!trigger) {
	            var /** @type {?} */ errors = [];
	            var /** @type {?} */ ast = /** @type {?} */ (buildAnimationAst(this._driver, /** @type {?} */ (metadata), errors));
	            if (errors.length) {
	                throw new Error("The animation trigger \"" + name + "\" has failed to build due to the following errors:\n - " + errors.join("\n - "));
	            }
	            trigger = buildTrigger(name, ast);
	            this._triggerCache[cacheKey] = trigger;
	        }
	        this._transitionEngine.registerTrigger(namespaceId, name, trigger);
	    };
	    /**
	     * @param {?} namespaceId
	     * @param {?} hostElement
	     * @return {?}
	     */
	    AnimationEngine.prototype.register = /**
	     * @param {?} namespaceId
	     * @param {?} hostElement
	     * @return {?}
	     */
	    function (namespaceId, hostElement) {
	        this._transitionEngine.register(namespaceId, hostElement);
	    };
	    /**
	     * @param {?} namespaceId
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationEngine.prototype.destroy = /**
	     * @param {?} namespaceId
	     * @param {?} context
	     * @return {?}
	     */
	    function (namespaceId, context) {
	        this._transitionEngine.destroy(namespaceId, context);
	    };
	    /**
	     * @param {?} namespaceId
	     * @param {?} element
	     * @param {?} parent
	     * @param {?} insertBefore
	     * @return {?}
	     */
	    AnimationEngine.prototype.onInsert = /**
	     * @param {?} namespaceId
	     * @param {?} element
	     * @param {?} parent
	     * @param {?} insertBefore
	     * @return {?}
	     */
	    function (namespaceId, element, parent, insertBefore) {
	        this._transitionEngine.insertNode(namespaceId, element, parent, insertBefore);
	    };
	    /**
	     * @param {?} namespaceId
	     * @param {?} element
	     * @param {?} context
	     * @return {?}
	     */
	    AnimationEngine.prototype.onRemove = /**
	     * @param {?} namespaceId
	     * @param {?} element
	     * @param {?} context
	     * @return {?}
	     */
	    function (namespaceId, element, context) {
	        this._transitionEngine.removeNode(namespaceId, element, context);
	    };
	    /**
	     * @param {?} element
	     * @param {?} disable
	     * @return {?}
	     */
	    AnimationEngine.prototype.disableAnimations = /**
	     * @param {?} element
	     * @param {?} disable
	     * @return {?}
	     */
	    function (element, disable) {
	        this._transitionEngine.markElementAsDisabled(element, disable);
	    };
	    /**
	     * @param {?} namespaceId
	     * @param {?} element
	     * @param {?} property
	     * @param {?} value
	     * @return {?}
	     */
	    AnimationEngine.prototype.process = /**
	     * @param {?} namespaceId
	     * @param {?} element
	     * @param {?} property
	     * @param {?} value
	     * @return {?}
	     */
	    function (namespaceId, element, property, value) {
	        if (property.charAt(0) == '@') {
	            var _a = parseTimelineCommand(property), id = _a[0], action = _a[1];
	            var /** @type {?} */ args = /** @type {?} */ (value);
	            this._timelineEngine.command(id, element, action, args);
	        }
	        else {
	            this._transitionEngine.trigger(namespaceId, element, property, value);
	        }
	    };
	    /**
	     * @param {?} namespaceId
	     * @param {?} element
	     * @param {?} eventName
	     * @param {?} eventPhase
	     * @param {?} callback
	     * @return {?}
	     */
	    AnimationEngine.prototype.listen = /**
	     * @param {?} namespaceId
	     * @param {?} element
	     * @param {?} eventName
	     * @param {?} eventPhase
	     * @param {?} callback
	     * @return {?}
	     */
	    function (namespaceId, element, eventName, eventPhase, callback) {
	        // @@listen
	        if (eventName.charAt(0) == '@') {
	            var _a = parseTimelineCommand(eventName), id = _a[0], action = _a[1];
	            return this._timelineEngine.listen(id, element, action, callback);
	        }
	        return this._transitionEngine.listen(namespaceId, element, eventName, eventPhase, callback);
	    };
	    /**
	     * @param {?=} microtaskId
	     * @return {?}
	     */
	    AnimationEngine.prototype.flush = /**
	     * @param {?=} microtaskId
	     * @return {?}
	     */
	    function (microtaskId) {
	        if (microtaskId === void 0) { microtaskId = -1; }
	        this._transitionEngine.flush(microtaskId);
	    };
	    Object.defineProperty(AnimationEngine.prototype, "players", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return (/** @type {?} */ (this._transitionEngine.players))
	                .concat(/** @type {?} */ (this._timelineEngine.players));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    AnimationEngine.prototype.whenRenderingDone = /**
	     * @return {?}
	     */
	    function () { return this._transitionEngine.whenRenderingDone(); };
	    return AnimationEngine;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var WebAnimationsPlayer = /** @class */ (function () {
	    function WebAnimationsPlayer(element, keyframes, options, previousPlayers) {
	        if (previousPlayers === void 0) { previousPlayers = []; }
	        var _this = this;
	        this.element = element;
	        this.keyframes = keyframes;
	        this.options = options;
	        this.previousPlayers = previousPlayers;
	        this._onDoneFns = [];
	        this._onStartFns = [];
	        this._onDestroyFns = [];
	        this._initialized = false;
	        this._finished = false;
	        this._started = false;
	        this._destroyed = false;
	        this.time = 0;
	        this.parentPlayer = null;
	        this.previousStyles = {};
	        this.currentSnapshot = {};
	        this._duration = /** @type {?} */ (options['duration']);
	        this._delay = /** @type {?} */ (options['delay']) || 0;
	        this.time = this._duration + this._delay;
	        if (allowPreviousPlayerStylesMerge(this._duration, this._delay)) {
	            previousPlayers.forEach(function (player) {
	                var /** @type {?} */ styles = player.currentSnapshot;
	                Object.keys(styles).forEach(function (prop) { return _this.previousStyles[prop] = styles[prop]; });
	            });
	        }
	    }
	    /**
	     * @return {?}
	     */
	    WebAnimationsPlayer.prototype._onFinish = /**
	     * @return {?}
	     */
	    function () {
	        if (!this._finished) {
	            this._finished = true;
	            this._onDoneFns.forEach(function (fn) { return fn(); });
	            this._onDoneFns = [];
	        }
	    };
	    /**
	     * @return {?}
	     */
	    WebAnimationsPlayer.prototype.init = /**
	     * @return {?}
	     */
	    function () {
	        this._buildPlayer();
	        this._preparePlayerBeforeStart();
	    };
	    /**
	     * @return {?}
	     */
	    WebAnimationsPlayer.prototype._buildPlayer = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._initialized)
	            return;
	        this._initialized = true;
	        var /** @type {?} */ keyframes = this.keyframes.map(function (styles) { return copyStyles(styles, false); });
	        var /** @type {?} */ previousStyleProps = Object.keys(this.previousStyles);
	        if (previousStyleProps.length && keyframes.length) {
	            var /** @type {?} */ startingKeyframe_1 = keyframes[0];
	            var /** @type {?} */ missingStyleProps_1 = [];
	            previousStyleProps.forEach(function (prop) {
	                if (!startingKeyframe_1.hasOwnProperty(prop)) {
	                    missingStyleProps_1.push(prop);
	                }
	                startingKeyframe_1[prop] = _this.previousStyles[prop];
	            });
	            if (missingStyleProps_1.length) {
	                var /** @type {?} */ self_1 = this;
	                var _loop_1 = function () {
	                    var /** @type {?} */ kf = keyframes[i];
	                    missingStyleProps_1.forEach(function (prop) {
	                        kf[prop] = _computeStyle(self_1.element, prop);
	                    });
	                };
	                // tslint:disable-next-line
	                for (var /** @type {?} */ i = 1; i < keyframes.length; i++) {
	                    _loop_1();
	                }
	            }
	        }
	        (/** @type {?} */ (this)).domPlayer =
	            this._triggerWebAnimation(this.element, keyframes, this.options);
	        this._finalKeyframe = keyframes.length ? keyframes[keyframes.length - 1] : {};
	        this.domPlayer.addEventListener('finish', function () { return _this._onFinish(); });
	    };
	    /**
	     * @return {?}
	     */
	    WebAnimationsPlayer.prototype._preparePlayerBeforeStart = /**
	     * @return {?}
	     */
	    function () {
	        // this is required so that the player doesn't start to animate right away
	        if (this._delay) {
	            this._resetDomPlayerState();
	        }
	        else {
	            this.domPlayer.pause();
	        }
	    };
	    /** @internal */
	    /**
	     * \@internal
	     * @param {?} element
	     * @param {?} keyframes
	     * @param {?} options
	     * @return {?}
	     */
	    WebAnimationsPlayer.prototype._triggerWebAnimation = /**
	     * \@internal
	     * @param {?} element
	     * @param {?} keyframes
	     * @param {?} options
	     * @return {?}
	     */
	    function (element, keyframes, options) {
	        // jscompiler doesn't seem to know animate is a native property because it's not fully
	        // supported yet across common browsers (we polyfill it for Edge/Safari) [CL #143630929]
	        return /** @type {?} */ (element['animate'](keyframes, options));
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    WebAnimationsPlayer.prototype.onStart = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this._onStartFns.push(fn); };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    WebAnimationsPlayer.prototype.onDone = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this._onDoneFns.push(fn); };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    WebAnimationsPlayer.prototype.onDestroy = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) { this._onDestroyFns.push(fn); };
	    /**
	     * @return {?}
	     */
	    WebAnimationsPlayer.prototype.play = /**
	     * @return {?}
	     */
	    function () {
	        this._buildPlayer();
	        if (!this.hasStarted()) {
	            this._onStartFns.forEach(function (fn) { return fn(); });
	            this._onStartFns = [];
	            this._started = true;
	        }
	        this.domPlayer.play();
	    };
	    /**
	     * @return {?}
	     */
	    WebAnimationsPlayer.prototype.pause = /**
	     * @return {?}
	     */
	    function () {
	        this.init();
	        this.domPlayer.pause();
	    };
	    /**
	     * @return {?}
	     */
	    WebAnimationsPlayer.prototype.finish = /**
	     * @return {?}
	     */
	    function () {
	        this.init();
	        this._onFinish();
	        this.domPlayer.finish();
	    };
	    /**
	     * @return {?}
	     */
	    WebAnimationsPlayer.prototype.reset = /**
	     * @return {?}
	     */
	    function () {
	        this._resetDomPlayerState();
	        this._destroyed = false;
	        this._finished = false;
	        this._started = false;
	    };
	    /**
	     * @return {?}
	     */
	    WebAnimationsPlayer.prototype._resetDomPlayerState = /**
	     * @return {?}
	     */
	    function () {
	        if (this.domPlayer) {
	            this.domPlayer.cancel();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    WebAnimationsPlayer.prototype.restart = /**
	     * @return {?}
	     */
	    function () {
	        this.reset();
	        this.play();
	    };
	    /**
	     * @return {?}
	     */
	    WebAnimationsPlayer.prototype.hasStarted = /**
	     * @return {?}
	     */
	    function () { return this._started; };
	    /**
	     * @return {?}
	     */
	    WebAnimationsPlayer.prototype.destroy = /**
	     * @return {?}
	     */
	    function () {
	        if (!this._destroyed) {
	            this._destroyed = true;
	            this._resetDomPlayerState();
	            this._onFinish();
	            this._onDestroyFns.forEach(function (fn) { return fn(); });
	            this._onDestroyFns = [];
	        }
	    };
	    /**
	     * @param {?} p
	     * @return {?}
	     */
	    WebAnimationsPlayer.prototype.setPosition = /**
	     * @param {?} p
	     * @return {?}
	     */
	    function (p) { this.domPlayer.currentTime = p * this.time; };
	    /**
	     * @return {?}
	     */
	    WebAnimationsPlayer.prototype.getPosition = /**
	     * @return {?}
	     */
	    function () { return this.domPlayer.currentTime / this.time; };
	    Object.defineProperty(WebAnimationsPlayer.prototype, "totalTime", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._delay + this._duration; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    WebAnimationsPlayer.prototype.beforeDestroy = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ styles = {};
	        if (this.hasStarted()) {
	            Object.keys(this._finalKeyframe).forEach(function (prop) {
	                if (prop != 'offset') {
	                    styles[prop] =
	                        _this._finished ? _this._finalKeyframe[prop] : _computeStyle(_this.element, prop);
	                }
	            });
	        }
	        this.currentSnapshot = styles;
	    };
	    /* @internal */
	    /**
	     * @param {?} phaseName
	     * @return {?}
	     */
	    WebAnimationsPlayer.prototype.triggerCallback = /**
	     * @param {?} phaseName
	     * @return {?}
	     */
	    function (phaseName) {
	        var /** @type {?} */ methods = phaseName == 'start' ? this._onStartFns : this._onDoneFns;
	        methods.forEach(function (fn) { return fn(); });
	        methods.length = 0;
	    };
	    return WebAnimationsPlayer;
	}());
	/**
	 * @param {?} element
	 * @param {?} prop
	 * @return {?}
	 */
	function _computeStyle(element, prop) {
	    return (/** @type {?} */ (window.getComputedStyle(element)))[prop];
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var WebAnimationsDriver = /** @class */ (function () {
	    function WebAnimationsDriver() {
	    }
	    /**
	     * @param {?} prop
	     * @return {?}
	     */
	    WebAnimationsDriver.prototype.validateStyleProperty = /**
	     * @param {?} prop
	     * @return {?}
	     */
	    function (prop) { return validateStyleProperty(prop); };
	    /**
	     * @param {?} element
	     * @param {?} selector
	     * @return {?}
	     */
	    WebAnimationsDriver.prototype.matchesElement = /**
	     * @param {?} element
	     * @param {?} selector
	     * @return {?}
	     */
	    function (element, selector) {
	        return matchesElement(element, selector);
	    };
	    /**
	     * @param {?} elm1
	     * @param {?} elm2
	     * @return {?}
	     */
	    WebAnimationsDriver.prototype.containsElement = /**
	     * @param {?} elm1
	     * @param {?} elm2
	     * @return {?}
	     */
	    function (elm1, elm2) { return containsElement(elm1, elm2); };
	    /**
	     * @param {?} element
	     * @param {?} selector
	     * @param {?} multi
	     * @return {?}
	     */
	    WebAnimationsDriver.prototype.query = /**
	     * @param {?} element
	     * @param {?} selector
	     * @param {?} multi
	     * @return {?}
	     */
	    function (element, selector, multi) {
	        return invokeQuery(element, selector, multi);
	    };
	    /**
	     * @param {?} element
	     * @param {?} prop
	     * @param {?=} defaultValue
	     * @return {?}
	     */
	    WebAnimationsDriver.prototype.computeStyle = /**
	     * @param {?} element
	     * @param {?} prop
	     * @param {?=} defaultValue
	     * @return {?}
	     */
	    function (element, prop, defaultValue) {
	        return /** @type {?} */ ((/** @type {?} */ (window.getComputedStyle(element)))[prop]);
	    };
	    /**
	     * @param {?} element
	     * @param {?} keyframes
	     * @param {?} duration
	     * @param {?} delay
	     * @param {?} easing
	     * @param {?=} previousPlayers
	     * @return {?}
	     */
	    WebAnimationsDriver.prototype.animate = /**
	     * @param {?} element
	     * @param {?} keyframes
	     * @param {?} duration
	     * @param {?} delay
	     * @param {?} easing
	     * @param {?=} previousPlayers
	     * @return {?}
	     */
	    function (element, keyframes, duration, delay, easing, previousPlayers) {
	        if (previousPlayers === void 0) { previousPlayers = []; }
	        var /** @type {?} */ fill = delay == 0 ? 'both' : 'forwards';
	        var /** @type {?} */ playerOptions = { duration: duration, delay: delay, fill: fill };
	        // we check for this to avoid having a null|undefined value be present
	        // for the easing (which results in an error for certain browsers #9752)
	        if (easing) {
	            playerOptions['easing'] = easing;
	        }
	        var /** @type {?} */ previousWebAnimationPlayers = /** @type {?} */ (previousPlayers.filter(function (player) { return player instanceof WebAnimationsPlayer; }));
	        return new WebAnimationsPlayer(element, keyframes, playerOptions, previousWebAnimationPlayers);
	    };
	    return WebAnimationsDriver;
	}());
	/**
	 * @return {?}
	 */
	function supportsWebAnimations() {
	    return typeof Element !== 'undefined' && typeof (/** @type {?} */ (Element)).prototype['animate'] === 'function';
	}
	
	exports.AnimationDriver = AnimationDriver;
	exports.ɵAnimation = Animation;
	exports.ɵAnimationStyleNormalizer = AnimationStyleNormalizer;
	exports.ɵNoopAnimationStyleNormalizer = NoopAnimationStyleNormalizer;
	exports.ɵWebAnimationsStyleNormalizer = WebAnimationsStyleNormalizer;
	exports.ɵNoopAnimationDriver = NoopAnimationDriver;
	exports.ɵAnimationEngine = AnimationEngine;
	exports.ɵWebAnimationsDriver = WebAnimationsDriver;
	exports.ɵsupportsWebAnimations = supportsWebAnimations;
	exports.ɵWebAnimationsPlayer = WebAnimationsPlayer;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=animations-browser.umd.js.map


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(253), __webpack_require__(206), __webpack_require__(237), __webpack_require__(254), __webpack_require__(255), __webpack_require__(256), __webpack_require__(257), __webpack_require__(263)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/core', 'rxjs/observable/of', 'rxjs/Observable', 'rxjs/operators/share', 'rxjs/operators/map', 'rxjs/operators/merge', 'rxjs/operators/switchMap', 'rxjs/operators/toArray', 'rxjs/operators/take'], factory) :
		(factory((global['ngx-translate'] = global['ngx-translate'] || {}, global['ngx-translate'].core = {}),global.ng.core,global.Rx.Observable,global.Rx,global.Rx.Observable.prototype,global.Rx.Observable.prototype,global.Rx.Observable.prototype,global.Rx.Observable.prototype,global.Rx.Observable.prototype,global.Rx.Observable.prototype));
	}(this, (function (exports,core,of,Observable,share,map,merge,switchMap,toArray,take) { 'use strict';
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate$1 = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
	        r = Reflect.decorate(decorators, target, key, desc);
	    else
	        for (var i = decorators.length - 1; i >= 0; i--)
	            if (d = decorators[i])
	                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var TranslateLoader = (function () {
	    function TranslateLoader() {
	    }
	    return TranslateLoader;
	}());
	/**
	 * This loader is just a placeholder that does nothing, in case you don't need a loader at all
	 */
	exports.TranslateFakeLoader = (function (_super) {
	    __extends(TranslateFakeLoader, _super);
	    function TranslateFakeLoader() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TranslateFakeLoader.prototype.getTranslation = function (lang) {
	        return of.of({});
	    };
	    return TranslateFakeLoader;
	}(TranslateLoader));
	exports.TranslateFakeLoader = __decorate$1([
	    core.Injectable()
	], exports.TranslateFakeLoader);
	function isScheduler(value) {
	    return value && typeof value.schedule === 'function';
	}
	var isScheduler_2 = isScheduler;
	var isScheduler_1 = {
	    isScheduler: isScheduler_2
	};
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	function createCommonjsModule(fn, module) {
	    return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	// CommonJS / Node have global context exposed as "global" variable.
	// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
	// the global "global" var for now.
	var __window = typeof window !== 'undefined' && window;
	var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
	    self instanceof WorkerGlobalScope && self;
	var __global = typeof commonjsGlobal !== 'undefined' && commonjsGlobal;
	var _root = __window || __global || __self;
	var root_1 = _root;
	// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
	// This is needed when used with angular/tsickle which inserts a goog.module statement.
	// Wrap in IIFE
	(function () {
	    if (!_root) {
	        throw new Error('RxJS could not find any global context (window, self, global)');
	    }
	})();
	var root = {
	    root: root_1
	};
	function isFunction(x) {
	    return typeof x === 'function';
	}
	var isFunction_2 = isFunction;
	var isFunction_1 = {
	    isFunction: isFunction_2
	};
	var isArray_1 = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
	var isArray = {
	    isArray: isArray_1
	};
	function isObject(x) {
	    return x != null && typeof x === 'object';
	}
	var isObject_2 = isObject;
	var isObject_1 = {
	    isObject: isObject_2
	};
	// typeof any so that it we don't have to cast when comparing a result to the error object
	var errorObject_1 = { e: {} };
	var errorObject = {
	    errorObject: errorObject_1
	};
	var tryCatchTarget;
	function tryCatcher() {
	    try {
	        return tryCatchTarget.apply(this, arguments);
	    }
	    catch (e) {
	        errorObject.errorObject.e = e;
	        return errorObject.errorObject;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	var tryCatch_2 = tryCatch;
	var tryCatch_1 = {
	    tryCatch: tryCatch_2
	};
	var __extends$2 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
	    for (var p in b)
	        if (b.hasOwnProperty(p))
	            d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when one or more errors have occurred during the
	 * `unsubscribe` of a {@link Subscription}.
	 */
	var UnsubscriptionError = (function (_super) {
	    __extends$2(UnsubscriptionError, _super);
	    function UnsubscriptionError(errors) {
	        _super.call(this);
	        this.errors = errors;
	        var err = Error.call(this, errors ?
	            errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) { return ((i + 1) + ") " + err.toString()); }).join('\n  ') : '');
	        this.name = err.name = 'UnsubscriptionError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return UnsubscriptionError;
	}(Error));
	var UnsubscriptionError_2 = UnsubscriptionError;
	var UnsubscriptionError_1 = {
	    UnsubscriptionError: UnsubscriptionError_2
	};
	/**
	 * Represents a disposable resource, such as the execution of an Observable. A
	 * Subscription has one important method, `unsubscribe`, that takes no argument
	 * and just disposes the resource held by the subscription.
	 *
	 * Additionally, subscriptions may be grouped together through the `add()`
	 * method, which will attach a child Subscription to the current Subscription.
	 * When a Subscription is unsubscribed, all its children (and its grandchildren)
	 * will be unsubscribed as well.
	 *
	 * @class Subscription
	 */
	var Subscription = (function () {
	    /**
	     * @param {function(): void} [unsubscribe] A function describing how to
	     * perform the disposal of resources when the `unsubscribe` method is called.
	     */
	    function Subscription(unsubscribe) {
	        /**
	         * A flag to indicate whether this Subscription has already been unsubscribed.
	         * @type {boolean}
	         */
	        this.closed = false;
	        this._parent = null;
	        this._parents = null;
	        this._subscriptions = null;
	        if (unsubscribe) {
	            this._unsubscribe = unsubscribe;
	        }
	    }
	    /**
	     * Disposes the resources held by the subscription. May, for instance, cancel
	     * an ongoing Observable execution or cancel any other type of work that
	     * started when the Subscription was created.
	     * @return {void}
	     */
	    Subscription.prototype.unsubscribe = function () {
	        var hasErrors = false;
	        var errors;
	        if (this.closed) {
	            return;
	        }
	        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
	        this.closed = true;
	        this._parent = null;
	        this._parents = null;
	        // null out _subscriptions first so any child subscriptions that attempt
	        // to remove themselves from this subscription will noop
	        this._subscriptions = null;
	        var index = -1;
	        var len = _parents ? _parents.length : 0;
	        // if this._parent is null, then so is this._parents, and we
	        // don't have to remove ourselves from any parent subscriptions.
	        while (_parent) {
	            _parent.remove(this);
	            // if this._parents is null or index >= len,
	            // then _parent is set to null, and the loop exits
	            _parent = ++index < len && _parents[index] || null;
	        }
	        if (isFunction_1.isFunction(_unsubscribe)) {
	            var trial = tryCatch_1.tryCatch(_unsubscribe).call(this);
	            if (trial === errorObject.errorObject) {
	                hasErrors = true;
	                errors = errors || (errorObject.errorObject.e instanceof UnsubscriptionError_1.UnsubscriptionError ?
	                    flattenUnsubscriptionErrors(errorObject.errorObject.e.errors) : [errorObject.errorObject.e]);
	            }
	        }
	        if (isArray.isArray(_subscriptions)) {
	            index = -1;
	            len = _subscriptions.length;
	            while (++index < len) {
	                var sub = _subscriptions[index];
	                if (isObject_1.isObject(sub)) {
	                    var trial = tryCatch_1.tryCatch(sub.unsubscribe).call(sub);
	                    if (trial === errorObject.errorObject) {
	                        hasErrors = true;
	                        errors = errors || [];
	                        var err = errorObject.errorObject.e;
	                        if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
	                            errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
	                        }
	                        else {
	                            errors.push(err);
	                        }
	                    }
	                }
	            }
	        }
	        if (hasErrors) {
	            throw new UnsubscriptionError_1.UnsubscriptionError(errors);
	        }
	    };
	    /**
	     * Adds a tear down to be called during the unsubscribe() of this
	     * Subscription.
	     *
	     * If the tear down being added is a subscription that is already
	     * unsubscribed, is the same reference `add` is being called on, or is
	     * `Subscription.EMPTY`, it will not be added.
	     *
	     * If this subscription is already in an `closed` state, the passed
	     * tear down logic will be executed immediately.
	     *
	     * @param {TeardownLogic} teardown The additional logic to execute on
	     * teardown.
	     * @return {Subscription} Returns the Subscription used or created to be
	     * added to the inner subscriptions list. This Subscription can be used with
	     * `remove()` to remove the passed teardown logic from the inner subscriptions
	     * list.
	     */
	    Subscription.prototype.add = function (teardown) {
	        if (!teardown || (teardown === Subscription.EMPTY)) {
	            return Subscription.EMPTY;
	        }
	        if (teardown === this) {
	            return this;
	        }
	        var subscription = teardown;
	        switch (typeof teardown) {
	            case 'function':
	                subscription = new Subscription(teardown);
	            case 'object':
	                if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
	                    return subscription;
	                }
	                else if (this.closed) {
	                    subscription.unsubscribe();
	                    return subscription;
	                }
	                else if (typeof subscription._addParent !== 'function' /* quack quack */) {
	                    var tmp = subscription;
	                    subscription = new Subscription();
	                    subscription._subscriptions = [tmp];
	                }
	                break;
	            default:
	                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
	        }
	        var subscriptions = this._subscriptions || (this._subscriptions = []);
	        subscriptions.push(subscription);
	        subscription._addParent(this);
	        return subscription;
	    };
	    /**
	     * Removes a Subscription from the internal list of subscriptions that will
	     * unsubscribe during the unsubscribe process of this Subscription.
	     * @param {Subscription} subscription The subscription to remove.
	     * @return {void}
	     */
	    Subscription.prototype.remove = function (subscription) {
	        var subscriptions = this._subscriptions;
	        if (subscriptions) {
	            var subscriptionIndex = subscriptions.indexOf(subscription);
	            if (subscriptionIndex !== -1) {
	                subscriptions.splice(subscriptionIndex, 1);
	            }
	        }
	    };
	    Subscription.prototype._addParent = function (parent) {
	        var _a = this, _parent = _a._parent, _parents = _a._parents;
	        if (!_parent || _parent === parent) {
	            // If we don't have a parent, or the new parent is the same as the
	            // current parent, then set this._parent to the new parent.
	            this._parent = parent;
	        }
	        else if (!_parents) {
	            // If there's already one parent, but not multiple, allocate an Array to
	            // store the rest of the parent Subscriptions.
	            this._parents = [parent];
	        }
	        else if (_parents.indexOf(parent) === -1) {
	            // Only add the new parent to the _parents list if it's not already there.
	            _parents.push(parent);
	        }
	    };
	    Subscription.EMPTY = (function (empty) {
	        empty.closed = true;
	        return empty;
	    }(new Subscription()));
	    return Subscription;
	}());
	var Subscription_2 = Subscription;
	function flattenUnsubscriptionErrors(errors) {
	    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError_1.UnsubscriptionError) ? err.errors : err); }, []);
	}
	var Subscription_1 = {
	    Subscription: Subscription_2
	};
	var empty = {
	    closed: true,
	    next: function (value) { },
	    error: function (err) { throw err; },
	    complete: function () { }
	};
	var Observer = {
	    empty: empty
	};
	var rxSubscriber = createCommonjsModule(function (module, exports) {
	    var Symbol = root.root.Symbol;
	    exports.rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
	        Symbol.for('rxSubscriber') : '@@rxSubscriber';
	    /**
	     * @deprecated use rxSubscriber instead
	     */
	    exports.$$rxSubscriber = exports.rxSubscriber;
	});
	var rxSubscriber_1 = rxSubscriber.rxSubscriber;
	var rxSubscriber_2 = rxSubscriber.$$rxSubscriber;
	var __extends$1 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
	    for (var p in b)
	        if (b.hasOwnProperty(p))
	            d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * Implements the {@link Observer} interface and extends the
	 * {@link Subscription} class. While the {@link Observer} is the public API for
	 * consuming the values of an {@link Observable}, all Observers get converted to
	 * a Subscriber, in order to provide Subscription-like capabilities such as
	 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
	 * implementing operators, but it is rarely used as a public API.
	 *
	 * @class Subscriber<T>
	 */
	var Subscriber = (function (_super) {
	    __extends$1(Subscriber, _super);
	    /**
	     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
	     * defined Observer or a `next` callback function.
	     * @param {function(e: ?any): void} [error] The `error` callback of an
	     * Observer.
	     * @param {function(): void} [complete] The `complete` callback of an
	     * Observer.
	     */
	    function Subscriber(destinationOrNext, error, complete) {
	        _super.call(this);
	        this.syncErrorValue = null;
	        this.syncErrorThrown = false;
	        this.syncErrorThrowable = false;
	        this.isStopped = false;
	        switch (arguments.length) {
	            case 0:
	                this.destination = Observer.empty;
	                break;
	            case 1:
	                if (!destinationOrNext) {
	                    this.destination = Observer.empty;
	                    break;
	                }
	                if (typeof destinationOrNext === 'object') {
	                    if (destinationOrNext instanceof Subscriber) {
	                        this.destination = destinationOrNext;
	                        this.destination.add(this);
	                    }
	                    else {
	                        this.syncErrorThrowable = true;
	                        this.destination = new SafeSubscriber(this, destinationOrNext);
	                    }
	                    break;
	                }
	            default:
	                this.syncErrorThrowable = true;
	                this.destination = new SafeSubscriber(this, destinationOrNext, error, complete);
	                break;
	        }
	    }
	    Subscriber.prototype[rxSubscriber.rxSubscriber] = function () { return this; };
	    /**
	     * A static factory for a Subscriber, given a (potentially partial) definition
	     * of an Observer.
	     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
	     * @param {function(e: ?any): void} [error] The `error` callback of an
	     * Observer.
	     * @param {function(): void} [complete] The `complete` callback of an
	     * Observer.
	     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
	     * Observer represented by the given arguments.
	     */
	    Subscriber.create = function (next, error, complete) {
	        var subscriber = new Subscriber(next, error, complete);
	        subscriber.syncErrorThrowable = false;
	        return subscriber;
	    };
	    /**
	     * The {@link Observer} callback to receive notifications of type `next` from
	     * the Observable, with a value. The Observable may call this method 0 or more
	     * times.
	     * @param {T} [value] The `next` value.
	     * @return {void}
	     */
	    Subscriber.prototype.next = function (value) {
	        if (!this.isStopped) {
	            this._next(value);
	        }
	    };
	    /**
	     * The {@link Observer} callback to receive notifications of type `error` from
	     * the Observable, with an attached {@link Error}. Notifies the Observer that
	     * the Observable has experienced an error condition.
	     * @param {any} [err] The `error` exception.
	     * @return {void}
	     */
	    Subscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            this.isStopped = true;
	            this._error(err);
	        }
	    };
	    /**
	     * The {@link Observer} callback to receive a valueless notification of type
	     * `complete` from the Observable. Notifies the Observer that the Observable
	     * has finished sending push-based notifications.
	     * @return {void}
	     */
	    Subscriber.prototype.complete = function () {
	        if (!this.isStopped) {
	            this.isStopped = true;
	            this._complete();
	        }
	    };
	    Subscriber.prototype.unsubscribe = function () {
	        if (this.closed) {
	            return;
	        }
	        this.isStopped = true;
	        _super.prototype.unsubscribe.call(this);
	    };
	    Subscriber.prototype._next = function (value) {
	        this.destination.next(value);
	    };
	    Subscriber.prototype._error = function (err) {
	        this.destination.error(err);
	        this.unsubscribe();
	    };
	    Subscriber.prototype._complete = function () {
	        this.destination.complete();
	        this.unsubscribe();
	    };
	    Subscriber.prototype._unsubscribeAndRecycle = function () {
	        var _a = this, _parent = _a._parent, _parents = _a._parents;
	        this._parent = null;
	        this._parents = null;
	        this.unsubscribe();
	        this.closed = false;
	        this.isStopped = false;
	        this._parent = _parent;
	        this._parents = _parents;
	        return this;
	    };
	    return Subscriber;
	}(Subscription_1.Subscription));
	var Subscriber_2 = Subscriber;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SafeSubscriber = (function (_super) {
	    __extends$1(SafeSubscriber, _super);
	    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
	        _super.call(this);
	        this._parentSubscriber = _parentSubscriber;
	        var next;
	        var context = this;
	        if (isFunction_1.isFunction(observerOrNext)) {
	            next = observerOrNext;
	        }
	        else if (observerOrNext) {
	            next = observerOrNext.next;
	            error = observerOrNext.error;
	            complete = observerOrNext.complete;
	            if (observerOrNext !== Observer.empty) {
	                context = Object.create(observerOrNext);
	                if (isFunction_1.isFunction(context.unsubscribe)) {
	                    this.add(context.unsubscribe.bind(context));
	                }
	                context.unsubscribe = this.unsubscribe.bind(this);
	            }
	        }
	        this._context = context;
	        this._next = next;
	        this._error = error;
	        this._complete = complete;
	    }
	    SafeSubscriber.prototype.next = function (value) {
	        if (!this.isStopped && this._next) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (!_parentSubscriber.syncErrorThrowable) {
	                this.__tryOrUnsub(this._next, value);
	            }
	            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (this._error) {
	                if (!_parentSubscriber.syncErrorThrowable) {
	                    this.__tryOrUnsub(this._error, err);
	                    this.unsubscribe();
	                }
	                else {
	                    this.__tryOrSetError(_parentSubscriber, this._error, err);
	                    this.unsubscribe();
	                }
	            }
	            else if (!_parentSubscriber.syncErrorThrowable) {
	                this.unsubscribe();
	                throw err;
	            }
	            else {
	                _parentSubscriber.syncErrorValue = err;
	                _parentSubscriber.syncErrorThrown = true;
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.complete = function () {
	        var _this = this;
	        if (!this.isStopped) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (this._complete) {
	                var wrappedComplete = function () { return _this._complete.call(_this._context); };
	                if (!_parentSubscriber.syncErrorThrowable) {
	                    this.__tryOrUnsub(wrappedComplete);
	                    this.unsubscribe();
	                }
	                else {
	                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
	                    this.unsubscribe();
	                }
	            }
	            else {
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
	        try {
	            fn.call(this._context, value);
	        }
	        catch (err) {
	            this.unsubscribe();
	            throw err;
	        }
	    };
	    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
	        try {
	            fn.call(this._context, value);
	        }
	        catch (err) {
	            parent.syncErrorValue = err;
	            parent.syncErrorThrown = true;
	            return true;
	        }
	        return false;
	    };
	    SafeSubscriber.prototype._unsubscribe = function () {
	        var _parentSubscriber = this._parentSubscriber;
	        this._context = null;
	        this._parentSubscriber = null;
	        _parentSubscriber.unsubscribe();
	    };
	    return SafeSubscriber;
	}(Subscriber));
	var Subscriber_1 = {
	    Subscriber: Subscriber_2
	};
	function toSubscriber(nextOrObserver, error, complete) {
	    if (nextOrObserver) {
	        if (nextOrObserver instanceof Subscriber_1.Subscriber) {
	            return nextOrObserver;
	        }
	        if (nextOrObserver[rxSubscriber.rxSubscriber]) {
	            return nextOrObserver[rxSubscriber.rxSubscriber]();
	        }
	    }
	    if (!nextOrObserver && !error && !complete) {
	        return new Subscriber_1.Subscriber(Observer.empty);
	    }
	    return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
	}
	var toSubscriber_2 = toSubscriber;
	var toSubscriber_1 = {
	    toSubscriber: toSubscriber_2
	};
	var observable = createCommonjsModule(function (module, exports) {
	    function getSymbolObservable(context) {
	        var $$observable;
	        var Symbol = context.Symbol;
	        if (typeof Symbol === 'function') {
	            if (Symbol.observable) {
	                $$observable = Symbol.observable;
	            }
	            else {
	                $$observable = Symbol('observable');
	                Symbol.observable = $$observable;
	            }
	        }
	        else {
	            $$observable = '@@observable';
	        }
	        return $$observable;
	    }
	    exports.getSymbolObservable = getSymbolObservable;
	    exports.observable = getSymbolObservable(root.root);
	    /**
	     * @deprecated use observable instead
	     */
	    exports.$$observable = exports.observable;
	});
	var observable_1 = observable.getSymbolObservable;
	var observable_2 = observable.observable;
	var observable_3 = observable.$$observable;
	/* tslint:disable:no-empty */
	function noop() { }
	var noop_2 = noop;
	var noop_1 = {
	    noop: noop_2
	};
	/* tslint:enable:max-line-length */
	function pipe() {
	    var fns = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        fns[_i - 0] = arguments[_i];
	    }
	    return pipeFromArray(fns);
	}
	var pipe_2 = pipe;
	/* @internal */
	function pipeFromArray(fns) {
	    if (!fns) {
	        return noop_1.noop;
	    }
	    if (fns.length === 1) {
	        return fns[0];
	    }
	    return function piped(input) {
	        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
	    };
	}
	var pipeFromArray_1 = pipeFromArray;
	var pipe_1 = {
	    pipe: pipe_2,
	    pipeFromArray: pipeFromArray_1
	};
	/**
	 * A representation of any set of values over any amount of time. This is the most basic building block
	 * of RxJS.
	 *
	 * @class Observable<T>
	 */
	var Observable$2 = (function () {
	    /**
	     * @constructor
	     * @param {Function} subscribe the function that is called when the Observable is
	     * initially subscribed to. This function is given a Subscriber, to which new values
	     * can be `next`ed, or an `error` method can be called to raise an error, or
	     * `complete` can be called to notify of a successful completion.
	     */
	    function Observable$$1(subscribe) {
	        this._isScalar = false;
	        if (subscribe) {
	            this._subscribe = subscribe;
	        }
	    }
	    /**
	     * Creates a new Observable, with this Observable as the source, and the passed
	     * operator defined as the new observable's operator.
	     * @method lift
	     * @param {Operator} operator the operator defining the operation to take on the observable
	     * @return {Observable} a new observable with the Operator applied
	     */
	    Observable$$1.prototype.lift = function (operator) {
	        var observable$$1 = new Observable$$1();
	        observable$$1.source = this;
	        observable$$1.operator = operator;
	        return observable$$1;
	    };
	    /**
	     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
	     *
	     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
	     *
	     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
	     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
	     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
	     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
	     * thought.
	     *
	     * Apart from starting the execution of an Observable, this method allows you to listen for values
	     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
	     * following ways.
	     *
	     * The first way is creating an object that implements {@link Observer} interface. It should have methods
	     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
	     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
	     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
	     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
	     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
	     * be left uncaught.
	     *
	     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
	     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
	     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
	     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
	     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
	     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
	     *
	     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
	     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
	     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
	     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
	     *
	     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
	     * It is an Observable itself that decides when these functions will be called. For example {@link of}
	     * by default emits all its values synchronously. Always check documentation for how given Observable
	     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
	     *
	     * @example <caption>Subscribe with an Observer</caption>
	     * const sumObserver = {
	     *   sum: 0,
	     *   next(value) {
	     *     console.log('Adding: ' + value);
	     *     this.sum = this.sum + value;
	     *   },
	     *   error() { // We actually could just remove this method,
	     *   },        // since we do not really care about errors right now.
	     *   complete() {
	     *     console.log('Sum equals: ' + this.sum);
	     *   }
	     * };
	     *
	     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
	     * .subscribe(sumObserver);
	     *
	     * // Logs:
	     * // "Adding: 1"
	     * // "Adding: 2"
	     * // "Adding: 3"
	     * // "Sum equals: 6"
	     *
	     *
	     * @example <caption>Subscribe with functions</caption>
	     * let sum = 0;
	     *
	     * Rx.Observable.of(1, 2, 3)
	     * .subscribe(
	     *   function(value) {
	     *     console.log('Adding: ' + value);
	     *     sum = sum + value;
	     *   },
	     *   undefined,
	     *   function() {
	     *     console.log('Sum equals: ' + sum);
	     *   }
	     * );
	     *
	     * // Logs:
	     * // "Adding: 1"
	     * // "Adding: 2"
	     * // "Adding: 3"
	     * // "Sum equals: 6"
	     *
	     *
	     * @example <caption>Cancel a subscription</caption>
	     * const subscription = Rx.Observable.interval(1000).subscribe(
	     *   num => console.log(num),
	     *   undefined,
	     *   () => console.log('completed!') // Will not be called, even
	     * );                                // when cancelling subscription
	     *
	     *
	     * setTimeout(() => {
	     *   subscription.unsubscribe();
	     *   console.log('unsubscribed!');
	     * }, 2500);
	     *
	     * // Logs:
	     * // 0 after 1s
	     * // 1 after 2s
	     * // "unsubscribed!" after 2.5s
	     *
	     *
	     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
	     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
	     *  Observable.
	     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
	     *  the error will be thrown as unhandled.
	     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
	     * @return {ISubscription} a subscription reference to the registered handlers
	     * @method subscribe
	     */
	    Observable$$1.prototype.subscribe = function (observerOrNext, error, complete) {
	        var operator = this.operator;
	        var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
	        if (operator) {
	            operator.call(sink, this.source);
	        }
	        else {
	            sink.add(this.source ? this._subscribe(sink) : this._trySubscribe(sink));
	        }
	        if (sink.syncErrorThrowable) {
	            sink.syncErrorThrowable = false;
	            if (sink.syncErrorThrown) {
	                throw sink.syncErrorValue;
	            }
	        }
	        return sink;
	    };
	    Observable$$1.prototype._trySubscribe = function (sink) {
	        try {
	            return this._subscribe(sink);
	        }
	        catch (err) {
	            sink.syncErrorThrown = true;
	            sink.syncErrorValue = err;
	            sink.error(err);
	        }
	    };
	    /**
	     * @method forEach
	     * @param {Function} next a handler for each value emitted by the observable
	     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
	     * @return {Promise} a promise that either resolves on observable completion or
	     *  rejects with the handled error
	     */
	    Observable$$1.prototype.forEach = function (next, PromiseCtor) {
	        var _this = this;
	        if (!PromiseCtor) {
	            if (root.root.Rx && root.root.Rx.config && root.root.Rx.config.Promise) {
	                PromiseCtor = root.root.Rx.config.Promise;
	            }
	            else if (root.root.Promise) {
	                PromiseCtor = root.root.Promise;
	            }
	        }
	        if (!PromiseCtor) {
	            throw new Error('no Promise impl found');
	        }
	        return new PromiseCtor(function (resolve, reject) {
	            // Must be declared in a separate statement to avoid a RefernceError when
	            // accessing subscription below in the closure due to Temporal Dead Zone.
	            var subscription;
	            subscription = _this.subscribe(function (value) {
	                if (subscription) {
	                    // if there is a subscription, then we can surmise
	                    // the next handling is asynchronous. Any errors thrown
	                    // need to be rejected explicitly and unsubscribe must be
	                    // called manually
	                    try {
	                        next(value);
	                    }
	                    catch (err) {
	                        reject(err);
	                        subscription.unsubscribe();
	                    }
	                }
	                else {
	                    // if there is NO subscription, then we're getting a nexted
	                    // value synchronously during subscription. We can just call it.
	                    // If it errors, Observable's `subscribe` will ensure the
	                    // unsubscription logic is called, then synchronously rethrow the error.
	                    // After that, Promise will trap the error and send it
	                    // down the rejection path.
	                    next(value);
	                }
	            }, reject, resolve);
	        });
	    };
	    Observable$$1.prototype._subscribe = function (subscriber) {
	        return this.source.subscribe(subscriber);
	    };
	    /**
	     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
	     * @method Symbol.observable
	     * @return {Observable} this instance of the observable
	     */
	    Observable$$1.prototype[observable.observable] = function () {
	        return this;
	    };
	    /* tslint:enable:max-line-length */
	    /**
	     * Used to stitch together functional operators into a chain.
	     * @method pipe
	     * @return {Observable} the Observable result of all of the operators having
	     * been called in the order they were passed in.
	     *
	     * @example
	     *
	     * import { map, filter, scan } from 'rxjs/operators';
	     *
	     * Rx.Observable.interval(1000)
	     *   .pipe(
	     *     filter(x => x % 2 === 0),
	     *     map(x => x + x),
	     *     scan((acc, x) => acc + x)
	     *   )
	     *   .subscribe(x => console.log(x))
	     */
	    Observable$$1.prototype.pipe = function () {
	        var operations = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            operations[_i - 0] = arguments[_i];
	        }
	        if (operations.length === 0) {
	            return this;
	        }
	        return pipe_1.pipeFromArray(operations)(this);
	    };
	    /* tslint:enable:max-line-length */
	    Observable$$1.prototype.toPromise = function (PromiseCtor) {
	        var _this = this;
	        if (!PromiseCtor) {
	            if (root.root.Rx && root.root.Rx.config && root.root.Rx.config.Promise) {
	                PromiseCtor = root.root.Rx.config.Promise;
	            }
	            else if (root.root.Promise) {
	                PromiseCtor = root.root.Promise;
	            }
	        }
	        if (!PromiseCtor) {
	            throw new Error('no Promise impl found');
	        }
	        return new PromiseCtor(function (resolve, reject) {
	            var value;
	            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
	        });
	    };
	    // HACK: Since TypeScript inherits static properties too, we have to
	    // fight against TypeScript here so Subject can have a different static create signature
	    /**
	     * Creates a new cold Observable by calling the Observable constructor
	     * @static true
	     * @owner Observable
	     * @method create
	     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
	     * @return {Observable} a new cold observable
	     */
	    Observable$$1.create = function (subscribe) {
	        return new Observable$$1(subscribe);
	    };
	    return Observable$$1;
	}());
	var Observable_2 = Observable$2;
	var Observable_1 = {
	    Observable: Observable_2
	};
	var __extends$3 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
	    for (var p in b)
	        if (b.hasOwnProperty(p))
	            d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ScalarObservable = (function (_super) {
	    __extends$3(ScalarObservable, _super);
	    function ScalarObservable(value, scheduler) {
	        _super.call(this);
	        this.value = value;
	        this.scheduler = scheduler;
	        this._isScalar = true;
	        if (scheduler) {
	            this._isScalar = false;
	        }
	    }
	    ScalarObservable.create = function (value, scheduler) {
	        return new ScalarObservable(value, scheduler);
	    };
	    ScalarObservable.dispatch = function (state) {
	        var done = state.done, value = state.value, subscriber = state.subscriber;
	        if (done) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(value);
	        if (subscriber.closed) {
	            return;
	        }
	        state.done = true;
	        this.schedule(state);
	    };
	    ScalarObservable.prototype._subscribe = function (subscriber) {
	        var value = this.value;
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(ScalarObservable.dispatch, 0, {
	                done: false, value: value, subscriber: subscriber
	            });
	        }
	        else {
	            subscriber.next(value);
	            if (!subscriber.closed) {
	                subscriber.complete();
	            }
	        }
	    };
	    return ScalarObservable;
	}(Observable_1.Observable));
	var ScalarObservable_2 = ScalarObservable;
	var ScalarObservable_1 = {
	    ScalarObservable: ScalarObservable_2
	};
	var __extends$4 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
	    for (var p in b)
	        if (b.hasOwnProperty(p))
	            d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var EmptyObservable = (function (_super) {
	    __extends$4(EmptyObservable, _super);
	    function EmptyObservable(scheduler) {
	        _super.call(this);
	        this.scheduler = scheduler;
	    }
	    /**
	     * Creates an Observable that emits no items to the Observer and immediately
	     * emits a complete notification.
	     *
	     * <span class="informal">Just emits 'complete', and nothing else.
	     * </span>
	     *
	     * <img src="./img/empty.png" width="100%">
	     *
	     * This static operator is useful for creating a simple Observable that only
	     * emits the complete notification. It can be used for composing with other
	     * Observables, such as in a {@link mergeMap}.
	     *
	     * @example <caption>Emit the number 7, then complete.</caption>
	     * var result = Rx.Observable.empty().startWith(7);
	     * result.subscribe(x => console.log(x));
	     *
	     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
	     * var interval = Rx.Observable.interval(1000);
	     * var result = interval.mergeMap(x =>
	     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
	     * );
	     * result.subscribe(x => console.log(x));
	     *
	     * // Results in the following to the console:
	     * // x is equal to the count on the interval eg(0,1,2,3,...)
	     * // x will occur every 1000ms
	     * // if x % 2 is equal to 1 print abc
	     * // if x % 2 is not equal to 1 nothing will be output
	     *
	     * @see {@link create}
	     * @see {@link never}
	     * @see {@link of}
	     * @see {@link throw}
	     *
	     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
	     * the emission of the complete notification.
	     * @return {Observable} An "empty" Observable: emits only the complete
	     * notification.
	     * @static true
	     * @name empty
	     * @owner Observable
	     */
	    EmptyObservable.create = function (scheduler) {
	        return new EmptyObservable(scheduler);
	    };
	    EmptyObservable.dispatch = function (arg) {
	        var subscriber = arg.subscriber;
	        subscriber.complete();
	    };
	    EmptyObservable.prototype._subscribe = function (subscriber) {
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(EmptyObservable.dispatch, 0, { subscriber: subscriber });
	        }
	        else {
	            subscriber.complete();
	        }
	    };
	    return EmptyObservable;
	}(Observable_1.Observable));
	var EmptyObservable_2 = EmptyObservable;
	var EmptyObservable_1 = {
	    EmptyObservable: EmptyObservable_2
	};
	var __extends = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
	    for (var p in b)
	        if (b.hasOwnProperty(p))
	            d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ArrayObservable = (function (_super) {
	    __extends(ArrayObservable, _super);
	    function ArrayObservable(array, scheduler) {
	        _super.call(this);
	        this.array = array;
	        this.scheduler = scheduler;
	        if (!scheduler && array.length === 1) {
	            this._isScalar = true;
	            this.value = array[0];
	        }
	    }
	    ArrayObservable.create = function (array, scheduler) {
	        return new ArrayObservable(array, scheduler);
	    };
	    /**
	     * Creates an Observable that emits some values you specify as arguments,
	     * immediately one after the other, and then emits a complete notification.
	     *
	     * <span class="informal">Emits the arguments you provide, then completes.
	     * </span>
	     *
	     * <img src="./img/of.png" width="100%">
	     *
	     * This static operator is useful for creating a simple Observable that only
	     * emits the arguments given, and the complete notification thereafter. It can
	     * be used for composing with other Observables, such as with {@link concat}.
	     * By default, it uses a `null` IScheduler, which means the `next`
	     * notifications are sent synchronously, although with a different IScheduler
	     * it is possible to determine when those notifications will be delivered.
	     *
	     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
	     * var numbers = Rx.Observable.of(10, 20, 30);
	     * var letters = Rx.Observable.of('a', 'b', 'c');
	     * var interval = Rx.Observable.interval(1000);
	     * var result = numbers.concat(letters).concat(interval);
	     * result.subscribe(x => console.log(x));
	     *
	     * @see {@link create}
	     * @see {@link empty}
	     * @see {@link never}
	     * @see {@link throw}
	     *
	     * @param {...T} values Arguments that represent `next` values to be emitted.
	     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
	     * the emissions of the `next` notifications.
	     * @return {Observable<T>} An Observable that emits each given input value.
	     * @static true
	     * @name of
	     * @owner Observable
	     */
	    ArrayObservable.of = function () {
	        var array = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            array[_i - 0] = arguments[_i];
	        }
	        var scheduler = array[array.length - 1];
	        if (isScheduler_1.isScheduler(scheduler)) {
	            array.pop();
	        }
	        else {
	            scheduler = null;
	        }
	        var len = array.length;
	        if (len > 1) {
	            return new ArrayObservable(array, scheduler);
	        }
	        else if (len === 1) {
	            return new ScalarObservable_1.ScalarObservable(array[0], scheduler);
	        }
	        else {
	            return new EmptyObservable_1.EmptyObservable(scheduler);
	        }
	    };
	    ArrayObservable.dispatch = function (state) {
	        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
	        if (index >= count) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(array[index]);
	        if (subscriber.closed) {
	            return;
	        }
	        state.index = index + 1;
	        this.schedule(state);
	    };
	    ArrayObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var array = this.array;
	        var count = array.length;
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(ArrayObservable.dispatch, 0, {
	                array: array, index: index, count: count, subscriber: subscriber
	            });
	        }
	        else {
	            for (var i = 0; i < count && !subscriber.closed; i++) {
	                subscriber.next(array[i]);
	            }
	            subscriber.complete();
	        }
	    };
	    return ArrayObservable;
	}(Observable_1.Observable));
	var ArrayObservable_2 = ArrayObservable;
	var ArrayObservable_1 = {
	    ArrayObservable: ArrayObservable_2
	};
	var of_1 = ArrayObservable_1.ArrayObservable.of;
	var of$2 = {
	    of: of_1
	};
	var isArrayLike_1 = (function (x) { return x && typeof x.length === 'number'; });
	var isArrayLike = {
	    isArrayLike: isArrayLike_1
	};
	function isPromise(value) {
	    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
	}
	var isPromise_2 = isPromise;
	var isPromise_1 = {
	    isPromise: isPromise_2
	};
	var __extends$6 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
	    for (var p in b)
	        if (b.hasOwnProperty(p))
	            d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var PromiseObservable = (function (_super) {
	    __extends$6(PromiseObservable, _super);
	    function PromiseObservable(promise, scheduler) {
	        _super.call(this);
	        this.promise = promise;
	        this.scheduler = scheduler;
	    }
	    /**
	     * Converts a Promise to an Observable.
	     *
	     * <span class="informal">Returns an Observable that just emits the Promise's
	     * resolved value, then completes.</span>
	     *
	     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
	     * Observable. If the Promise resolves with a value, the output Observable
	     * emits that resolved value as a `next`, and then completes. If the Promise
	     * is rejected, then the output Observable emits the corresponding Error.
	     *
	     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
	     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     * @see {@link bindCallback}
	     * @see {@link from}
	     *
	     * @param {PromiseLike<T>} promise The promise to be converted.
	     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
	     * the delivery of the resolved value (or the rejection).
	     * @return {Observable<T>} An Observable which wraps the Promise.
	     * @static true
	     * @name fromPromise
	     * @owner Observable
	     */
	    PromiseObservable.create = function (promise, scheduler) {
	        return new PromiseObservable(promise, scheduler);
	    };
	    PromiseObservable.prototype._subscribe = function (subscriber) {
	        var _this = this;
	        var promise = this.promise;
	        var scheduler = this.scheduler;
	        if (scheduler == null) {
	            if (this._isScalar) {
	                if (!subscriber.closed) {
	                    subscriber.next(this.value);
	                    subscriber.complete();
	                }
	            }
	            else {
	                promise.then(function (value) {
	                    _this.value = value;
	                    _this._isScalar = true;
	                    if (!subscriber.closed) {
	                        subscriber.next(value);
	                        subscriber.complete();
	                    }
	                }, function (err) {
	                    if (!subscriber.closed) {
	                        subscriber.error(err);
	                    }
	                })
	                    .then(null, function (err) {
	                    // escape the promise trap, throw unhandled errors
	                    root.root.setTimeout(function () { throw err; });
	                });
	            }
	        }
	        else {
	            if (this._isScalar) {
	                if (!subscriber.closed) {
	                    return scheduler.schedule(dispatchNext, 0, { value: this.value, subscriber: subscriber });
	                }
	            }
	            else {
	                promise.then(function (value) {
	                    _this.value = value;
	                    _this._isScalar = true;
	                    if (!subscriber.closed) {
	                        subscriber.add(scheduler.schedule(dispatchNext, 0, { value: value, subscriber: subscriber }));
	                    }
	                }, function (err) {
	                    if (!subscriber.closed) {
	                        subscriber.add(scheduler.schedule(dispatchError, 0, { err: err, subscriber: subscriber }));
	                    }
	                })
	                    .then(null, function (err) {
	                    // escape the promise trap, throw unhandled errors
	                    root.root.setTimeout(function () { throw err; });
	                });
	            }
	        }
	    };
	    return PromiseObservable;
	}(Observable_1.Observable));
	var PromiseObservable_2 = PromiseObservable;
	function dispatchNext(arg) {
	    var value = arg.value, subscriber = arg.subscriber;
	    if (!subscriber.closed) {
	        subscriber.next(value);
	        subscriber.complete();
	    }
	}
	function dispatchError(arg) {
	    var err = arg.err, subscriber = arg.subscriber;
	    if (!subscriber.closed) {
	        subscriber.error(err);
	    }
	}
	var PromiseObservable_1 = {
	    PromiseObservable: PromiseObservable_2
	};
	var iterator = createCommonjsModule(function (module, exports) {
	    function symbolIteratorPonyfill(root$$2) {
	        var Symbol = root$$2.Symbol;
	        if (typeof Symbol === 'function') {
	            if (!Symbol.iterator) {
	                Symbol.iterator = Symbol('iterator polyfill');
	            }
	            return Symbol.iterator;
	        }
	        else {
	            // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
	            var Set_1 = root$$2.Set;
	            if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') {
	                return '@@iterator';
	            }
	            var Map_1 = root$$2.Map;
	            // required for compatability with es6-shim
	            if (Map_1) {
	                var keys = Object.getOwnPropertyNames(Map_1.prototype);
	                for (var i = 0; i < keys.length; ++i) {
	                    var key = keys[i];
	                    // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
	                    if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) {
	                        return key;
	                    }
	                }
	            }
	            return '@@iterator';
	        }
	    }
	    exports.symbolIteratorPonyfill = symbolIteratorPonyfill;
	    exports.iterator = symbolIteratorPonyfill(root.root);
	    /**
	     * @deprecated use iterator instead
	     */
	    exports.$$iterator = exports.iterator;
	});
	var iterator_1 = iterator.symbolIteratorPonyfill;
	var iterator_2 = iterator.iterator;
	var iterator_3 = iterator.$$iterator;
	var __extends$7 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
	    for (var p in b)
	        if (b.hasOwnProperty(p))
	            d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var IteratorObservable = (function (_super) {
	    __extends$7(IteratorObservable, _super);
	    function IteratorObservable(iterator$$1, scheduler) {
	        _super.call(this);
	        this.scheduler = scheduler;
	        if (iterator$$1 == null) {
	            throw new Error('iterator cannot be null.');
	        }
	        this.iterator = getIterator(iterator$$1);
	    }
	    IteratorObservable.create = function (iterator$$1, scheduler) {
	        return new IteratorObservable(iterator$$1, scheduler);
	    };
	    IteratorObservable.dispatch = function (state) {
	        var index = state.index, hasError = state.hasError, iterator$$1 = state.iterator, subscriber = state.subscriber;
	        if (hasError) {
	            subscriber.error(state.error);
	            return;
	        }
	        var result = iterator$$1.next();
	        if (result.done) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(result.value);
	        state.index = index + 1;
	        if (subscriber.closed) {
	            if (typeof iterator$$1.return === 'function') {
	                iterator$$1.return();
	            }
	            return;
	        }
	        this.schedule(state);
	    };
	    IteratorObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var _a = this, iterator$$1 = _a.iterator, scheduler = _a.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(IteratorObservable.dispatch, 0, {
	                index: index, iterator: iterator$$1, subscriber: subscriber
	            });
	        }
	        else {
	            do {
	                var result = iterator$$1.next();
	                if (result.done) {
	                    subscriber.complete();
	                    break;
	                }
	                else {
	                    subscriber.next(result.value);
	                }
	                if (subscriber.closed) {
	                    if (typeof iterator$$1.return === 'function') {
	                        iterator$$1.return();
	                    }
	                    break;
	                }
	            } while (true);
	        }
	    };
	    return IteratorObservable;
	}(Observable_1.Observable));
	var IteratorObservable_2 = IteratorObservable;
	var StringIterator = (function () {
	    function StringIterator(str, idx, len) {
	        if (idx === void 0) {
	            idx = 0;
	        }
	        if (len === void 0) {
	            len = str.length;
	        }
	        this.str = str;
	        this.idx = idx;
	        this.len = len;
	    }
	    StringIterator.prototype[iterator.iterator] = function () { return (this); };
	    StringIterator.prototype.next = function () {
	        return this.idx < this.len ? {
	            done: false,
	            value: this.str.charAt(this.idx++)
	        } : {
	            done: true,
	            value: undefined
	        };
	    };
	    return StringIterator;
	}());
	var ArrayIterator = (function () {
	    function ArrayIterator(arr, idx, len) {
	        if (idx === void 0) {
	            idx = 0;
	        }
	        if (len === void 0) {
	            len = toLength(arr);
	        }
	        this.arr = arr;
	        this.idx = idx;
	        this.len = len;
	    }
	    ArrayIterator.prototype[iterator.iterator] = function () { return this; };
	    ArrayIterator.prototype.next = function () {
	        return this.idx < this.len ? {
	            done: false,
	            value: this.arr[this.idx++]
	        } : {
	            done: true,
	            value: undefined
	        };
	    };
	    return ArrayIterator;
	}());
	function getIterator(obj) {
	    var i = obj[iterator.iterator];
	    if (!i && typeof obj === 'string') {
	        return new StringIterator(obj);
	    }
	    if (!i && obj.length !== undefined) {
	        return new ArrayIterator(obj);
	    }
	    if (!i) {
	        throw new TypeError('object is not iterable');
	    }
	    return obj[iterator.iterator]();
	}
	var maxSafeInteger = Math.pow(2, 53) - 1;
	function toLength(o) {
	    var len = +o.length;
	    if (isNaN(len)) {
	        return 0;
	    }
	    if (len === 0 || !numberIsFinite(len)) {
	        return len;
	    }
	    len = sign(len) * Math.floor(Math.abs(len));
	    if (len <= 0) {
	        return 0;
	    }
	    if (len > maxSafeInteger) {
	        return maxSafeInteger;
	    }
	    return len;
	}
	function numberIsFinite(value) {
	    return typeof value === 'number' && root.root.isFinite(value);
	}
	function sign(value) {
	    var valueAsNumber = +value;
	    if (valueAsNumber === 0) {
	        return valueAsNumber;
	    }
	    if (isNaN(valueAsNumber)) {
	        return valueAsNumber;
	    }
	    return valueAsNumber < 0 ? -1 : 1;
	}
	var IteratorObservable_1 = {
	    IteratorObservable: IteratorObservable_2
	};
	var __extends$8 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
	    for (var p in b)
	        if (b.hasOwnProperty(p))
	            d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ArrayLikeObservable = (function (_super) {
	    __extends$8(ArrayLikeObservable, _super);
	    function ArrayLikeObservable(arrayLike, scheduler) {
	        _super.call(this);
	        this.arrayLike = arrayLike;
	        this.scheduler = scheduler;
	        if (!scheduler && arrayLike.length === 1) {
	            this._isScalar = true;
	            this.value = arrayLike[0];
	        }
	    }
	    ArrayLikeObservable.create = function (arrayLike, scheduler) {
	        var length = arrayLike.length;
	        if (length === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        else if (length === 1) {
	            return new ScalarObservable_1.ScalarObservable(arrayLike[0], scheduler);
	        }
	        else {
	            return new ArrayLikeObservable(arrayLike, scheduler);
	        }
	    };
	    ArrayLikeObservable.dispatch = function (state) {
	        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
	        if (subscriber.closed) {
	            return;
	        }
	        if (index >= length) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(arrayLike[index]);
	        state.index = index + 1;
	        this.schedule(state);
	    };
	    ArrayLikeObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
	        var length = arrayLike.length;
	        if (scheduler) {
	            return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
	                arrayLike: arrayLike, index: index, length: length, subscriber: subscriber
	            });
	        }
	        else {
	            for (var i = 0; i < length && !subscriber.closed; i++) {
	                subscriber.next(arrayLike[i]);
	            }
	            subscriber.complete();
	        }
	    };
	    return ArrayLikeObservable;
	}(Observable_1.Observable));
	var ArrayLikeObservable_2 = ArrayLikeObservable;
	var ArrayLikeObservable_1 = {
	    ArrayLikeObservable: ArrayLikeObservable_2
	};
	/**
	 * Represents a push-based event or value that an {@link Observable} can emit.
	 * This class is particularly useful for operators that manage notifications,
	 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
	 * others. Besides wrapping the actual delivered value, it also annotates it
	 * with metadata of, for instance, what type of push message it is (`next`,
	 * `error`, or `complete`).
	 *
	 * @see {@link materialize}
	 * @see {@link dematerialize}
	 * @see {@link observeOn}
	 *
	 * @class Notification<T>
	 */
	var Notification = (function () {
	    function Notification(kind, value, error) {
	        this.kind = kind;
	        this.value = value;
	        this.error = error;
	        this.hasValue = kind === 'N';
	    }
	    /**
	     * Delivers to the given `observer` the value wrapped by this Notification.
	     * @param {Observer} observer
	     * @return
	     */
	    Notification.prototype.observe = function (observer) {
	        switch (this.kind) {
	            case 'N':
	                return observer.next && observer.next(this.value);
	            case 'E':
	                return observer.error && observer.error(this.error);
	            case 'C':
	                return observer.complete && observer.complete();
	        }
	    };
	    /**
	     * Given some {@link Observer} callbacks, deliver the value represented by the
	     * current Notification to the correctly corresponding callback.
	     * @param {function(value: T): void} next An Observer `next` callback.
	     * @param {function(err: any): void} [error] An Observer `error` callback.
	     * @param {function(): void} [complete] An Observer `complete` callback.
	     * @return {any}
	     */
	    Notification.prototype.do = function (next, error, complete) {
	        var kind = this.kind;
	        switch (kind) {
	            case 'N':
	                return next && next(this.value);
	            case 'E':
	                return error && error(this.error);
	            case 'C':
	                return complete && complete();
	        }
	    };
	    /**
	     * Takes an Observer or its individual callback functions, and calls `observe`
	     * or `do` methods accordingly.
	     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
	     * the `next` callback.
	     * @param {function(err: any): void} [error] An Observer `error` callback.
	     * @param {function(): void} [complete] An Observer `complete` callback.
	     * @return {any}
	     */
	    Notification.prototype.accept = function (nextOrObserver, error, complete) {
	        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
	            return this.observe(nextOrObserver);
	        }
	        else {
	            return this.do(nextOrObserver, error, complete);
	        }
	    };
	    /**
	     * Returns a simple Observable that just delivers the notification represented
	     * by this Notification instance.
	     * @return {any}
	     */
	    Notification.prototype.toObservable = function () {
	        var kind = this.kind;
	        switch (kind) {
	            case 'N':
	                return Observable_1.Observable.of(this.value);
	            case 'E':
	                return Observable_1.Observable.throw(this.error);
	            case 'C':
	                return Observable_1.Observable.empty();
	        }
	        throw new Error('unexpected notification kind value');
	    };
	    /**
	     * A shortcut to create a Notification instance of the type `next` from a
	     * given value.
	     * @param {T} value The `next` value.
	     * @return {Notification<T>} The "next" Notification representing the
	     * argument.
	     */
	    Notification.createNext = function (value) {
	        if (typeof value !== 'undefined') {
	            return new Notification('N', value);
	        }
	        return Notification.undefinedValueNotification;
	    };
	    /**
	     * A shortcut to create a Notification instance of the type `error` from a
	     * given error.
	     * @param {any} [err] The `error` error.
	     * @return {Notification<T>} The "error" Notification representing the
	     * argument.
	     */
	    Notification.createError = function (err) {
	        return new Notification('E', undefined, err);
	    };
	    /**
	     * A shortcut to create a Notification instance of the type `complete`.
	     * @return {Notification<any>} The valueless "complete" Notification.
	     */
	    Notification.createComplete = function () {
	        return Notification.completeNotification;
	    };
	    Notification.completeNotification = new Notification('C');
	    Notification.undefinedValueNotification = new Notification('N', undefined);
	    return Notification;
	}());
	var Notification_2 = Notification;
	var Notification_1 = {
	    Notification: Notification_2
	};
	var __extends$9 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
	    for (var p in b)
	        if (b.hasOwnProperty(p))
	            d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 *
	 * Re-emits all notifications from source Observable with specified scheduler.
	 *
	 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
	 *
	 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
	 * notifications emitted by the source Observable. It might be useful, if you do not have control over
	 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
	 *
	 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
	 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
	 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
	 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
	 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
	 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
	 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
	 * little bit more, to ensure that they are emitted at expected moments.
	 *
	 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
	 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
	 * will delay all notifications - including error notifications - while `delay` will pass through error
	 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
	 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
	 * for notification emissions in general.
	 *
	 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
	 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
	 *                                               // with async scheduler by default...
	 *
	 * intervals
	 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
	 * .subscribe(val => {                           // scheduler to ensure smooth animation.
	 *   someDiv.style.height = val + 'px';
	 * });
	 *
	 * @see {@link delay}
	 *
	 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
	 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
	 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
	 * but with provided scheduler.
	 *
	 * @method observeOn
	 * @owner Observable
	 */
	function observeOn(scheduler, delay) {
	    if (delay === void 0) {
	        delay = 0;
	    }
	    return function observeOnOperatorFunction(source) {
	        return source.lift(new ObserveOnOperator(scheduler, delay));
	    };
	}
	var observeOn_2 = observeOn;
	var ObserveOnOperator = (function () {
	    function ObserveOnOperator(scheduler, delay) {
	        if (delay === void 0) {
	            delay = 0;
	        }
	        this.scheduler = scheduler;
	        this.delay = delay;
	    }
	    ObserveOnOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
	    };
	    return ObserveOnOperator;
	}());
	var ObserveOnOperator_1 = ObserveOnOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ObserveOnSubscriber = (function (_super) {
	    __extends$9(ObserveOnSubscriber, _super);
	    function ObserveOnSubscriber(destination, scheduler, delay) {
	        if (delay === void 0) {
	            delay = 0;
	        }
	        _super.call(this, destination);
	        this.scheduler = scheduler;
	        this.delay = delay;
	    }
	    ObserveOnSubscriber.dispatch = function (arg) {
	        var notification = arg.notification, destination = arg.destination;
	        notification.observe(destination);
	        this.unsubscribe();
	    };
	    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
	        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
	    };
	    ObserveOnSubscriber.prototype._next = function (value) {
	        this.scheduleMessage(Notification_1.Notification.createNext(value));
	    };
	    ObserveOnSubscriber.prototype._error = function (err) {
	        this.scheduleMessage(Notification_1.Notification.createError(err));
	    };
	    ObserveOnSubscriber.prototype._complete = function () {
	        this.scheduleMessage(Notification_1.Notification.createComplete());
	    };
	    return ObserveOnSubscriber;
	}(Subscriber_1.Subscriber));
	var ObserveOnSubscriber_1 = ObserveOnSubscriber;
	var ObserveOnMessage = (function () {
	    function ObserveOnMessage(notification, destination) {
	        this.notification = notification;
	        this.destination = destination;
	    }
	    return ObserveOnMessage;
	}());
	var ObserveOnMessage_1 = ObserveOnMessage;
	var observeOn_1 = {
	    observeOn: observeOn_2,
	    ObserveOnOperator: ObserveOnOperator_1,
	    ObserveOnSubscriber: ObserveOnSubscriber_1,
	    ObserveOnMessage: ObserveOnMessage_1
	};
	var __extends$5 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
	    for (var p in b)
	        if (b.hasOwnProperty(p))
	            d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var FromObservable = (function (_super) {
	    __extends$5(FromObservable, _super);
	    function FromObservable(ish, scheduler) {
	        _super.call(this, null);
	        this.ish = ish;
	        this.scheduler = scheduler;
	    }
	    /**
	     * Creates an Observable from an Array, an array-like object, a Promise, an
	     * iterable object, or an Observable-like object.
	     *
	     * <span class="informal">Converts almost anything to an Observable.</span>
	     *
	     * <img src="./img/from.png" width="100%">
	     *
	     * Convert various other objects and data types into Observables. `from`
	     * converts a Promise or an array-like or an
	     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
	     * object into an Observable that emits the items in that promise or array or
	     * iterable. A String, in this context, is treated as an array of characters.
	     * Observable-like objects (contains a function named with the ES2015 Symbol
	     * for Observable) can also be converted through this operator.
	     *
	     * @example <caption>Converts an array to an Observable</caption>
	     * var array = [10, 20, 30];
	     * var result = Rx.Observable.from(array);
	     * result.subscribe(x => console.log(x));
	     *
	     * // Results in the following:
	     * // 10 20 30
	     *
	     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
	     * function* generateDoubles(seed) {
	     *   var i = seed;
	     *   while (true) {
	     *     yield i;
	     *     i = 2 * i; // double it
	     *   }
	     * }
	     *
	     * var iterator = generateDoubles(3);
	     * var result = Rx.Observable.from(iterator).take(10);
	     * result.subscribe(x => console.log(x));
	     *
	     * // Results in the following:
	     * // 3 6 12 24 48 96 192 384 768 1536
	     *
	     * @see {@link create}
	     * @see {@link fromEvent}
	     * @see {@link fromEventPattern}
	     * @see {@link fromPromise}
	     *
	     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
	     * Observable-like, an Array, an iterable or an array-like object to be
	     * converted.
	     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
	     * emissions of values.
	     * @return {Observable<T>} The Observable whose values are originally from the
	     * input object that was converted.
	     * @static true
	     * @name from
	     * @owner Observable
	     */
	    FromObservable.create = function (ish, scheduler) {
	        if (ish != null) {
	            if (typeof ish[observable.observable] === 'function') {
	                if (ish instanceof Observable_1.Observable && !scheduler) {
	                    return ish;
	                }
	                return new FromObservable(ish, scheduler);
	            }
	            else if (isArray.isArray(ish)) {
	                return new ArrayObservable_1.ArrayObservable(ish, scheduler);
	            }
	            else if (isPromise_1.isPromise(ish)) {
	                return new PromiseObservable_1.PromiseObservable(ish, scheduler);
	            }
	            else if (typeof ish[iterator.iterator] === 'function' || typeof ish === 'string') {
	                return new IteratorObservable_1.IteratorObservable(ish, scheduler);
	            }
	            else if (isArrayLike.isArrayLike(ish)) {
	                return new ArrayLikeObservable_1.ArrayLikeObservable(ish, scheduler);
	            }
	        }
	        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
	    };
	    FromObservable.prototype._subscribe = function (subscriber) {
	        var ish = this.ish;
	        var scheduler = this.scheduler;
	        if (scheduler == null) {
	            return ish[observable.observable]().subscribe(subscriber);
	        }
	        else {
	            return ish[observable.observable]().subscribe(new observeOn_1.ObserveOnSubscriber(subscriber, scheduler, 0));
	        }
	    };
	    return FromObservable;
	}(Observable_1.Observable));
	var FromObservable_2 = FromObservable;
	var FromObservable_1 = {
	    FromObservable: FromObservable_2
	};
	var from_1 = FromObservable_1.FromObservable.create;
	var from = {
	    from: from_1
	};
	var __extends$11 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
	    for (var p in b)
	        if (b.hasOwnProperty(p))
	            d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var InnerSubscriber = (function (_super) {
	    __extends$11(InnerSubscriber, _super);
	    function InnerSubscriber(parent, outerValue, outerIndex) {
	        _super.call(this);
	        this.parent = parent;
	        this.outerValue = outerValue;
	        this.outerIndex = outerIndex;
	        this.index = 0;
	    }
	    InnerSubscriber.prototype._next = function (value) {
	        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
	    };
	    InnerSubscriber.prototype._error = function (error) {
	        this.parent.notifyError(error, this);
	        this.unsubscribe();
	    };
	    InnerSubscriber.prototype._complete = function () {
	        this.parent.notifyComplete(this);
	        this.unsubscribe();
	    };
	    return InnerSubscriber;
	}(Subscriber_1.Subscriber));
	var InnerSubscriber_2 = InnerSubscriber;
	var InnerSubscriber_1 = {
	    InnerSubscriber: InnerSubscriber_2
	};
	function subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
	    var destination = new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
	    if (destination.closed) {
	        return null;
	    }
	    if (result instanceof Observable_1.Observable) {
	        if (result._isScalar) {
	            destination.next(result.value);
	            destination.complete();
	            return null;
	        }
	        else {
	            destination.syncErrorThrowable = true;
	            return result.subscribe(destination);
	        }
	    }
	    else if (isArrayLike.isArrayLike(result)) {
	        for (var i = 0, len = result.length; i < len && !destination.closed; i++) {
	            destination.next(result[i]);
	        }
	        if (!destination.closed) {
	            destination.complete();
	        }
	    }
	    else if (isPromise_1.isPromise(result)) {
	        result.then(function (value) {
	            if (!destination.closed) {
	                destination.next(value);
	                destination.complete();
	            }
	        }, function (err) { return destination.error(err); })
	            .then(null, function (err) {
	            // Escaping the Promise trap: globally throw unhandled errors
	            root.root.setTimeout(function () { throw err; });
	        });
	        return destination;
	    }
	    else if (result && typeof result[iterator.iterator] === 'function') {
	        var iterator$$2 = result[iterator.iterator]();
	        do {
	            var item = iterator$$2.next();
	            if (item.done) {
	                destination.complete();
	                break;
	            }
	            destination.next(item.value);
	            if (destination.closed) {
	                break;
	            }
	        } while (true);
	    }
	    else if (result && typeof result[observable.observable] === 'function') {
	        var obs = result[observable.observable]();
	        if (typeof obs.subscribe !== 'function') {
	            destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
	        }
	        else {
	            return obs.subscribe(new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
	        }
	    }
	    else {
	        var value = isObject_1.isObject(result) ? 'an invalid object' : "'" + result + "'";
	        var msg = ("You provided " + value + " where a stream was expected.")
	            + ' You can provide an Observable, Promise, Array, or Iterable.';
	        destination.error(new TypeError(msg));
	    }
	    return null;
	}
	var subscribeToResult_2 = subscribeToResult;
	var subscribeToResult_1 = {
	    subscribeToResult: subscribeToResult_2
	};
	var __extends$12 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
	    for (var p in b)
	        if (b.hasOwnProperty(p))
	            d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var OuterSubscriber = (function (_super) {
	    __extends$12(OuterSubscriber, _super);
	    function OuterSubscriber() {
	        _super.apply(this, arguments);
	    }
	    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.destination.next(innerValue);
	    };
	    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
	        this.destination.error(error);
	    };
	    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.destination.complete();
	    };
	    return OuterSubscriber;
	}(Subscriber_1.Subscriber));
	var OuterSubscriber_2 = OuterSubscriber;
	var OuterSubscriber_1 = {
	    OuterSubscriber: OuterSubscriber_2
	};
	var __extends$10 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
	    for (var p in b)
	        if (b.hasOwnProperty(p))
	            d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link mergeAll}.</span>
	 *
	 * <img src="./img/mergeMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an Observable, and then merging those resulting Observables and
	 * emitting the results of this merger.
	 *
	 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
	 * var letters = Rx.Observable.of('a', 'b', 'c');
	 * var result = letters.mergeMap(x =>
	 *   Rx.Observable.interval(1000).map(i => x+i)
	 * );
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // a0
	 * // b0
	 * // c0
	 * // a1
	 * // b1
	 * // c1
	 * // continues to list a,b,c with respective ascending integers
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaustMap}
	 * @see {@link merge}
	 * @see {@link mergeAll}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and merging the results of the Observables obtained
	 * from this transformation.
	 * @method mergeMap
	 * @owner Observable
	 */
	function mergeMap(project, resultSelector, concurrent) {
	    if (concurrent === void 0) {
	        concurrent = Number.POSITIVE_INFINITY;
	    }
	    return function mergeMapOperatorFunction(source) {
	        if (typeof resultSelector === 'number') {
	            concurrent = resultSelector;
	            resultSelector = null;
	        }
	        return source.lift(new MergeMapOperator(project, resultSelector, concurrent));
	    };
	}
	var mergeMap_2 = mergeMap;
	var MergeMapOperator = (function () {
	    function MergeMapOperator(project, resultSelector, concurrent) {
	        if (concurrent === void 0) {
	            concurrent = Number.POSITIVE_INFINITY;
	        }
	        this.project = project;
	        this.resultSelector = resultSelector;
	        this.concurrent = concurrent;
	    }
	    MergeMapOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
	    };
	    return MergeMapOperator;
	}());
	var MergeMapOperator_1 = MergeMapOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MergeMapSubscriber = (function (_super) {
	    __extends$10(MergeMapSubscriber, _super);
	    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
	        if (concurrent === void 0) {
	            concurrent = Number.POSITIVE_INFINITY;
	        }
	        _super.call(this, destination);
	        this.project = project;
	        this.resultSelector = resultSelector;
	        this.concurrent = concurrent;
	        this.hasCompleted = false;
	        this.buffer = [];
	        this.active = 0;
	        this.index = 0;
	    }
	    MergeMapSubscriber.prototype._next = function (value) {
	        if (this.active < this.concurrent) {
	            this._tryNext(value);
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    MergeMapSubscriber.prototype._tryNext = function (value) {
	        var result;
	        var index = this.index++;
	        try {
	            result = this.project(value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.active++;
	        this._innerSub(result, value, index);
	    };
	    MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
	        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
	    };
	    MergeMapSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.active === 0 && this.buffer.length === 0) {
	            this.destination.complete();
	        }
	    };
	    MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        if (this.resultSelector) {
	            this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            this.destination.next(innerValue);
	        }
	    };
	    MergeMapSubscriber.prototype._notifyResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var result;
	        try {
	            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
	        var buffer = this.buffer;
	        this.remove(innerSub);
	        this.active--;
	        if (buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        else if (this.active === 0 && this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return MergeMapSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	var MergeMapSubscriber_1 = MergeMapSubscriber;
	var mergeMap_1 = {
	    mergeMap: mergeMap_2,
	    MergeMapOperator: MergeMapOperator_1,
	    MergeMapSubscriber: MergeMapSubscriber_1
	};
	function identity(x) {
	    return x;
	}
	var identity_2 = identity;
	var identity_1 = {
	    identity: identity_2
	};
	/**
	 * Converts a higher-order Observable into a first-order Observable which
	 * concurrently delivers all values that are emitted on the inner Observables.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables.</span>
	 *
	 * <img src="./img/mergeAll.png" width="100%">
	 *
	 * `mergeAll` subscribes to an Observable that emits Observables, also known as
	 * a higher-order Observable. Each time it observes one of these emitted inner
	 * Observables, it subscribes to that and delivers all the values from the
	 * inner Observable on the output Observable. The output Observable only
	 * completes once all inner Observables have completed. Any error delivered by
	 * a inner Observable will be immediately emitted on the output Observable.
	 *
	 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
	 * var firstOrder = higherOrder.mergeAll();
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
	 * var firstOrder = higherOrder.mergeAll(2);
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * @see {@link combineAll}
	 * @see {@link concatAll}
	 * @see {@link exhaust}
	 * @see {@link merge}
	 * @see {@link mergeMap}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 * @see {@link switch}
	 * @see {@link zipAll}
	 *
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits values coming from all the
	 * inner Observables emitted by the source Observable.
	 * @method mergeAll
	 * @owner Observable
	 */
	function mergeAll(concurrent) {
	    if (concurrent === void 0) {
	        concurrent = Number.POSITIVE_INFINITY;
	    }
	    return mergeMap_1.mergeMap(identity_1.identity, null, concurrent);
	}
	var mergeAll_2 = mergeAll;
	var mergeAll_1 = {
	    mergeAll: mergeAll_2
	};
	/**
	 * Converts a higher-order Observable into a first-order Observable by
	 * concatenating the inner Observables in order.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by putting one
	 * inner Observable after the other.</span>
	 *
	 * <img src="./img/concatAll.png" width="100%">
	 *
	 * Joins every Observable emitted by the source (a higher-order Observable), in
	 * a serial fashion. It subscribes to each inner Observable only after the
	 * previous inner Observable has completed, and merges all of their values into
	 * the returned observable.
	 *
	 * __Warning:__ If the source Observable emits Observables quickly and
	 * endlessly, and the inner Observables it emits generally complete slower than
	 * the source emits, you can run into memory issues as the incoming Observables
	 * collect in an unbounded buffer.
	 *
	 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
	 * to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
	 * var firstOrder = higherOrder.concatAll();
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // (results are not concurrent)
	 * // For every click on the "document" it will emit values 0 to 3 spaced
	 * // on a 1000ms interval
	 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
	 *
	 * @see {@link combineAll}
	 * @see {@link concat}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 * @see {@link exhaust}
	 * @see {@link mergeAll}
	 * @see {@link switch}
	 * @see {@link zipAll}
	 *
	 * @return {Observable} An Observable emitting values from all the inner
	 * Observables concatenated.
	 * @method concatAll
	 * @owner Observable
	 */
	function concatAll() {
	    return mergeAll_1.mergeAll(1);
	}
	var concatAll_2 = concatAll;
	var concatAll_1 = {
	    concatAll: concatAll_2
	};
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which sequentially emits all values from given
	 * Observable and then moves on to the next.
	 *
	 * <span class="informal">Concatenates multiple Observables together by
	 * sequentially emitting their values, one Observable after the other.</span>
	 *
	 * <img src="./img/concat.png" width="100%">
	 *
	 * `concat` joins multiple Observables together, by subscribing to them one at a time and
	 * merging their results into the output Observable. You can pass either an array of
	 * Observables, or put them directly as arguments. Passing an empty array will result
	 * in Observable that completes immediately.
	 *
	 * `concat` will subscribe to first input Observable and emit all its values, without
	 * changing or affecting them in any way. When that Observable completes, it will
	 * subscribe to then next Observable passed and, again, emit its values. This will be
	 * repeated, until the operator runs out of Observables. When last input Observable completes,
	 * `concat` will complete as well. At any given moment only one Observable passed to operator
	 * emits values. If you would like to emit values from passed Observables concurrently, check out
	 * {@link merge} instead, especially with optional `concurrent` parameter. As a matter of fact,
	 * `concat` is an equivalent of `merge` operator with `concurrent` parameter set to `1`.
	 *
	 * Note that if some input Observable never completes, `concat` will also never complete
	 * and Observables following the one that did not complete will never be subscribed. On the other
	 * hand, if some Observable simply completes immediately after it is subscribed, it will be
	 * invisible for `concat`, which will just move on to the next Observable.
	 *
	 * If any Observable in chain errors, instead of passing control to the next Observable,
	 * `concat` will error immediately as well. Observables that would be subscribed after
	 * the one that emitted error, never will.
	 *
	 * If you pass to `concat` the same Observable many times, its stream of values
	 * will be "replayed" on every subscription, which means you can repeat given Observable
	 * as many times as you like. If passing the same Observable to `concat` 1000 times becomes tedious,
	 * you can always use {@link repeat}.
	 *
	 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
	 * var timer = Rx.Observable.interval(1000).take(4);
	 * var sequence = Rx.Observable.range(1, 10);
	 * var result = Rx.Observable.concat(timer, sequence);
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in:
	 * // 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
	 *
	 *
	 * @example <caption>Concatenate an array of 3 Observables</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var result = Rx.Observable.concat([timer1, timer2, timer3]); // note that array is passed
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in the following:
	 * // (Prints to console sequentially)
	 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
	 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
	 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
	 *
	 *
	 * @example <caption>Concatenate the same Observable to repeat it</caption>
	 * const timer = Rx.Observable.interval(1000).take(2);
	 *
	 * Rx.Observable.concat(timer, timer) // concating the same Observable!
	 * .subscribe(
	 *   value => console.log(value),
	 *   err => {},
	 *   () => console.log('...and it is done!')
	 * );
	 *
	 * // Logs:
	 * // 0 after 1s
	 * // 1 after 2s
	 * // 0 after 3s
	 * // 1 after 4s
	 * // "...and it is done!" also after 4s
	 *
	 * @see {@link concatAll}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 *
	 * @param {ObservableInput} input1 An input Observable to concatenate with others.
	 * @param {ObservableInput} input2 An input Observable to concatenate with others.
	 * More than one input Observables may be given as argument.
	 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
	 * Observable subscription on.
	 * @return {Observable} All values of each passed Observable merged into a
	 * single Observable, in order, in serial fashion.
	 * @static true
	 * @name concat
	 * @owner Observable
	 */
	function concat$1() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    if (observables.length === 1 || (observables.length === 2 && isScheduler_1.isScheduler(observables[1]))) {
	        return from.from(observables[0]);
	    }
	    return concatAll_1.concatAll()(of$2.of.apply(void 0, observables));
	}
	var concat_2$2 = concat$1;
	var concat_1 = {
	    concat: concat_2$2
	};
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which sequentially emits all values from every
	 * given input Observable after the current Observable.
	 *
	 * <span class="informal">Concatenates multiple Observables together by
	 * sequentially emitting their values, one Observable after the other.</span>
	 *
	 * <img src="./img/concat.png" width="100%">
	 *
	 * Joins this Observable with multiple other Observables by subscribing to them
	 * one at a time, starting with the source, and merging their results into the
	 * output Observable. Will wait for each Observable to complete before moving
	 * on to the next.
	 *
	 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
	 * var timer = Rx.Observable.interval(1000).take(4);
	 * var sequence = Rx.Observable.range(1, 10);
	 * var result = timer.concat(sequence);
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in:
	 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
	 *
	 * @example <caption>Concatenate 3 Observables</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var result = timer1.concat(timer2, timer3);
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in the following:
	 * // (Prints to console sequentially)
	 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
	 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
	 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
	 *
	 * @see {@link concatAll}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 *
	 * @param {ObservableInput} other An input Observable to concatenate after the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
	 * Observable subscription on.
	 * @return {Observable} All values of each passed Observable merged into a
	 * single Observable, in order, in serial fashion.
	 * @method concat
	 * @owner Observable
	 */
	function concat() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return function (source) { return source.lift.call(concat_1.concat.apply(void 0, [source].concat(observables))); };
	}
	var concat_3 = concat;
	var __decorate$3 = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
	        r = Reflect.decorate(decorators, target, key, desc);
	    else
	        for (var i = decorators.length - 1; i >= 0; i--)
	            if (d = decorators[i])
	                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var MissingTranslationHandler = (function () {
	    function MissingTranslationHandler() {
	    }
	    return MissingTranslationHandler;
	}());
	/**
	 * This handler is just a placeholder that does nothing, in case you don't need a missing translation handler at all
	 */
	exports.FakeMissingTranslationHandler = (function () {
	    function FakeMissingTranslationHandler() {
	    }
	    FakeMissingTranslationHandler.prototype.handle = function (params) {
	        return params.key;
	    };
	    return FakeMissingTranslationHandler;
	}());
	exports.FakeMissingTranslationHandler = __decorate$3([
	    core.Injectable()
	], exports.FakeMissingTranslationHandler);
	var __decorate$4 = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
	        r = Reflect.decorate(decorators, target, key, desc);
	    else
	        for (var i = decorators.length - 1; i >= 0; i--)
	            if (d = decorators[i])
	                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var TranslateCompiler = (function () {
	    function TranslateCompiler() {
	    }
	    return TranslateCompiler;
	}());
	/**
	 * This compiler is just a placeholder that does nothing, in case you don't need a compiler at all
	 */
	exports.TranslateFakeCompiler = (function (_super) {
	    __extends(TranslateFakeCompiler, _super);
	    function TranslateFakeCompiler() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TranslateFakeCompiler.prototype.compile = function (value, lang) {
	        return value;
	    };
	    TranslateFakeCompiler.prototype.compileTranslations = function (translations, lang) {
	        return translations;
	    };
	    return TranslateFakeCompiler;
	}(TranslateCompiler));
	exports.TranslateFakeCompiler = __decorate$4([
	    core.Injectable()
	], exports.TranslateFakeCompiler);
	/* tslint:disable */
	/**
	 * @name equals
	 *
	 * @description
	 * Determines if two objects or two values are equivalent.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `equals`.
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 */
	function equals(o1, o2) {
	    if (o1 === o2)
	        return true;
	    if (o1 === null || o2 === null)
	        return false;
	    if (o1 !== o1 && o2 !== o2)
	        return true; // NaN === NaN
	    var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	    if (t1 == t2 && t1 == 'object') {
	        if (Array.isArray(o1)) {
	            if (!Array.isArray(o2))
	                return false;
	            if ((length = o1.length) == o2.length) {
	                for (key = 0; key < length; key++) {
	                    if (!equals(o1[key], o2[key]))
	                        return false;
	                }
	                return true;
	            }
	        }
	        else {
	            if (Array.isArray(o2)) {
	                return false;
	            }
	            keySet = Object.create(null);
	            for (key in o1) {
	                if (!equals(o1[key], o2[key])) {
	                    return false;
	                }
	                keySet[key] = true;
	            }
	            for (key in o2) {
	                if (!(key in keySet) && typeof o2[key] !== 'undefined') {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	    return false;
	}
	/* tslint:enable */
	function isDefined(value) {
	    return typeof value !== 'undefined' && value !== null;
	}
	function isObject$1(item) {
	    return (item && typeof item === 'object' && !Array.isArray(item));
	}
	function mergeDeep(target, source) {
	    var output = Object.assign({}, target);
	    if (isObject$1(target) && isObject$1(source)) {
	        Object.keys(source).forEach(function (key) {
	            if (isObject$1(source[key])) {
	                if (!(key in target)) {
	                    Object.assign(output, (_b = {}, _b[key] = source[key], _b));
	                }
	                else {
	                    output[key] = mergeDeep(target[key], source[key]);
	                }
	            }
	            else {
	                Object.assign(output, (_c = {}, _c[key] = source[key], _c));
	            }
	            var _b, _c;
	        });
	    }
	    return output;
	}
	var __decorate$5 = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
	        r = Reflect.decorate(decorators, target, key, desc);
	    else
	        for (var i = decorators.length - 1; i >= 0; i--)
	            if (d = decorators[i])
	                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var TranslateParser = (function () {
	    function TranslateParser() {
	    }
	    return TranslateParser;
	}());
	exports.TranslateDefaultParser = (function (_super) {
	    __extends(TranslateDefaultParser, _super);
	    function TranslateDefaultParser() {
	        var _this = _super.apply(this, arguments) || this;
	        _this.templateMatcher = /{{\s?([^{}\s]*)\s?}}/g;
	        return _this;
	    }
	    TranslateDefaultParser.prototype.interpolate = function (expr, params) {
	        var result;
	        if (typeof expr === 'string') {
	            result = this.interpolateString(expr, params);
	        }
	        else if (typeof expr === 'function') {
	            result = this.interpolateFunction(expr, params);
	        }
	        else {
	            // this should not happen, but an unrelated TranslateService test depends on it
	            result = expr;
	        }
	        return result;
	    };
	    TranslateDefaultParser.prototype.getValue = function (target, key) {
	        var keys = key.split('.');
	        key = '';
	        do {
	            key += keys.shift();
	            if (isDefined(target) && isDefined(target[key]) && (typeof target[key] === 'object' || !keys.length)) {
	                target = target[key];
	                key = '';
	            }
	            else if (!keys.length) {
	                target = undefined;
	            }
	            else {
	                key += '.';
	            }
	        } while (keys.length);
	        return target;
	    };
	    TranslateDefaultParser.prototype.interpolateFunction = function (fn, params) {
	        return fn(params);
	    };
	    TranslateDefaultParser.prototype.interpolateString = function (expr, params) {
	        var _this = this;
	        if (!params) {
	            return expr;
	        }
	        return expr.replace(this.templateMatcher, function (substring, b) {
	            var r = _this.getValue(params, b);
	            return isDefined(r) ? r : substring;
	        });
	    };
	    return TranslateDefaultParser;
	}(TranslateParser));
	exports.TranslateDefaultParser = __decorate$5([
	    core.Injectable()
	], exports.TranslateDefaultParser);
	var TranslateStore = (function () {
	    function TranslateStore() {
	        /**
	         * The lang currently used
	         * @type {string}
	         */
	        this.currentLang = this.defaultLang;
	        /**
	         * a list of translations per lang
	         * @type {{}}
	         */
	        this.translations = {};
	        /**
	         * an array of langs
	         * @type {Array}
	         */
	        this.langs = [];
	        /**
	         * An EventEmitter to listen to translation change events
	         * onTranslationChange.subscribe((params: TranslationChangeEvent) => {
	         *     // do something
	         * });
	         * @type {EventEmitter<TranslationChangeEvent>}
	         */
	        this.onTranslationChange = new core.EventEmitter();
	        /**
	         * An EventEmitter to listen to lang change events
	         * onLangChange.subscribe((params: LangChangeEvent) => {
	         *     // do something
	         * });
	         * @type {EventEmitter<LangChangeEvent>}
	         */
	        this.onLangChange = new core.EventEmitter();
	        /**
	         * An EventEmitter to listen to default lang change events
	         * onDefaultLangChange.subscribe((params: DefaultLangChangeEvent) => {
	         *     // do something
	         * });
	         * @type {EventEmitter<DefaultLangChangeEvent>}
	         */
	        this.onDefaultLangChange = new core.EventEmitter();
	    }
	    return TranslateStore;
	}());
	var __decorate$2 = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
	        r = Reflect.decorate(decorators, target, key, desc);
	    else
	        for (var i = decorators.length - 1; i >= 0; i--)
	            if (d = decorators[i])
	                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
	        return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); };
	};
	var USE_STORE = new core.InjectionToken('USE_STORE');
	var USE_DEFAULT_LANG = new core.InjectionToken('USE_DEFAULT_LANG');
	exports.TranslateService = (function () {
	    /**
	     *
	     * @param store an instance of the store (that is supposed to be unique)
	     * @param currentLoader An instance of the loader currently used
	     * @param compiler An instance of the compiler currently used
	     * @param parser An instance of the parser currently used
	     * @param missingTranslationHandler A handler for missing translations.
	     * @param isolate whether this service should use the store or not
	     * @param useDefaultLang whether we should use default language translation when current language translation is missing.
	     */
	    function TranslateService(store, currentLoader, compiler, parser, missingTranslationHandler, useDefaultLang, isolate) {
	        if (useDefaultLang === void 0) { useDefaultLang = true; }
	        if (isolate === void 0) { isolate = false; }
	        this.store = store;
	        this.currentLoader = currentLoader;
	        this.compiler = compiler;
	        this.parser = parser;
	        this.missingTranslationHandler = missingTranslationHandler;
	        this.useDefaultLang = useDefaultLang;
	        this.isolate = isolate;
	        this.pending = false;
	        this._onTranslationChange = new core.EventEmitter();
	        this._onLangChange = new core.EventEmitter();
	        this._onDefaultLangChange = new core.EventEmitter();
	        this._langs = [];
	        this._translations = {};
	        this._translationRequests = {};
	    }
	    Object.defineProperty(TranslateService.prototype, "onTranslationChange", {
	        /**
	         * An EventEmitter to listen to translation change events
	         * onTranslationChange.subscribe((params: TranslationChangeEvent) => {
	         *     // do something
	         * });
	         * @type {EventEmitter<TranslationChangeEvent>}
	         */
	        get: function () {
	            return this.isolate ? this._onTranslationChange : this.store.onTranslationChange;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TranslateService.prototype, "onLangChange", {
	        /**
	         * An EventEmitter to listen to lang change events
	         * onLangChange.subscribe((params: LangChangeEvent) => {
	         *     // do something
	         * });
	         * @type {EventEmitter<LangChangeEvent>}
	         */
	        get: function () {
	            return this.isolate ? this._onLangChange : this.store.onLangChange;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TranslateService.prototype, "onDefaultLangChange", {
	        /**
	         * An EventEmitter to listen to default lang change events
	         * onDefaultLangChange.subscribe((params: DefaultLangChangeEvent) => {
	         *     // do something
	         * });
	         * @type {EventEmitter<DefaultLangChangeEvent>}
	         */
	        get: function () {
	            return this.isolate ? this._onDefaultLangChange : this.store.onDefaultLangChange;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TranslateService.prototype, "defaultLang", {
	        /**
	         * The default lang to fallback when translations are missing on the current lang
	         */
	        get: function () {
	            return this.isolate ? this._defaultLang : this.store.defaultLang;
	        },
	        set: function (defaultLang) {
	            if (this.isolate) {
	                this._defaultLang = defaultLang;
	            }
	            else {
	                this.store.defaultLang = defaultLang;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TranslateService.prototype, "currentLang", {
	        /**
	         * The lang currently used
	         * @type {string}
	         */
	        get: function () {
	            return this.isolate ? this._currentLang : this.store.currentLang;
	        },
	        set: function (currentLang) {
	            if (this.isolate) {
	                this._currentLang = currentLang;
	            }
	            else {
	                this.store.currentLang = currentLang;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TranslateService.prototype, "langs", {
	        /**
	         * an array of langs
	         * @type {Array}
	         */
	        get: function () {
	            return this.isolate ? this._langs : this.store.langs;
	        },
	        set: function (langs) {
	            if (this.isolate) {
	                this._langs = langs;
	            }
	            else {
	                this.store.langs = langs;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TranslateService.prototype, "translations", {
	        /**
	         * a list of translations per lang
	         * @type {{}}
	         */
	        get: function () {
	            return this.isolate ? this._translations : this.store.translations;
	        },
	        set: function (translations) {
	            if (this.isolate) {
	                this._translations = translations;
	            }
	            else {
	                this.store.translations = translations;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Sets the default language to use as a fallback
	     * @param lang
	     */
	    TranslateService.prototype.setDefaultLang = function (lang) {
	        var _this = this;
	        if (lang === this.defaultLang) {
	            return;
	        }
	        var pending = this.retrieveTranslations(lang);
	        if (typeof pending !== "undefined") {
	            // on init set the defaultLang immediately
	            if (!this.defaultLang) {
	                this.defaultLang = lang;
	            }
	            pending.pipe(take.take(1))
	                .subscribe(function (res) {
	                _this.changeDefaultLang(lang);
	            });
	        }
	        else {
	            this.changeDefaultLang(lang);
	        }
	    };
	    /**
	     * Gets the default language used
	     * @returns string
	     */
	    TranslateService.prototype.getDefaultLang = function () {
	        return this.defaultLang;
	    };
	    /**
	     * Changes the lang currently used
	     * @param lang
	     * @returns {Observable<*>}
	     */
	    TranslateService.prototype.use = function (lang) {
	        var _this = this;
	        // don't change the language if the language given is already selected
	        if (lang === this.currentLang) {
	            return of.of(this.translations[lang]);
	        }
	        var pending = this.retrieveTranslations(lang);
	        if (typeof pending !== "undefined") {
	            // on init set the currentLang immediately
	            if (!this.currentLang) {
	                this.currentLang = lang;
	            }
	            pending.pipe(take.take(1))
	                .subscribe(function (res) {
	                _this.changeLang(lang);
	            });
	            return pending;
	        }
	        else {
	            this.changeLang(lang);
	            return of.of(this.translations[lang]);
	        }
	    };
	    /**
	     * Retrieves the given translations
	     * @param lang
	     * @returns {Observable<*>}
	     */
	    TranslateService.prototype.retrieveTranslations = function (lang) {
	        var pending;
	        // if this language is unavailable, ask for it
	        if (typeof this.translations[lang] === "undefined") {
	            this._translationRequests[lang] = this._translationRequests[lang] || this.getTranslation(lang);
	            pending = this._translationRequests[lang];
	        }
	        return pending;
	    };
	    /**
	     * Gets an object of translations for a given language with the current loader
	     * and passes it through the compiler
	     * @param lang
	     * @returns {Observable<*>}
	     */
	    TranslateService.prototype.getTranslation = function (lang) {
	        var _this = this;
	        this.pending = true;
	        this.loadingTranslations = this.currentLoader.getTranslation(lang).pipe(share.share());
	        this.loadingTranslations.pipe(take.take(1))
	            .subscribe(function (res) {
	            _this.translations[lang] = _this.compiler.compileTranslations(res, lang);
	            _this.updateLangs();
	            _this.pending = false;
	        }, function (err) {
	            _this.pending = false;
	        });
	        return this.loadingTranslations;
	    };
	    /**
	     * Manually sets an object of translations for a given language
	     * after passing it through the compiler
	     * @param lang
	     * @param translations
	     * @param shouldMerge
	     */
	    TranslateService.prototype.setTranslation = function (lang, translations, shouldMerge) {
	        if (shouldMerge === void 0) { shouldMerge = false; }
	        translations = this.compiler.compileTranslations(translations, lang);
	        if (shouldMerge && this.translations[lang]) {
	            this.translations[lang] = mergeDeep(this.translations[lang], translations);
	        }
	        else {
	            this.translations[lang] = translations;
	        }
	        this.updateLangs();
	        this.onTranslationChange.emit({ lang: lang, translations: this.translations[lang] });
	    };
	    /**
	     * Returns an array of currently available langs
	     * @returns {any}
	     */
	    TranslateService.prototype.getLangs = function () {
	        return this.langs;
	    };
	    /**
	     * @param langs
	     * Add available langs
	     */
	    TranslateService.prototype.addLangs = function (langs) {
	        var _this = this;
	        langs.forEach(function (lang) {
	            if (_this.langs.indexOf(lang) === -1) {
	                _this.langs.push(lang);
	            }
	        });
	    };
	    /**
	     * Update the list of available langs
	     */
	    TranslateService.prototype.updateLangs = function () {
	        this.addLangs(Object.keys(this.translations));
	    };
	    /**
	     * Returns the parsed result of the translations
	     * @param translations
	     * @param key
	     * @param interpolateParams
	     * @returns {any}
	     */
	    TranslateService.prototype.getParsedResult = function (translations, key, interpolateParams) {
	        var res;
	        if (key instanceof Array) {
	            var result = {}, observables = false;
	            for (var _b = 0, key_1 = key; _b < key_1.length; _b++) {
	                var k = key_1[_b];
	                result[k] = this.getParsedResult(translations, k, interpolateParams);
	                if (typeof result[k].subscribe === "function") {
	                    observables = true;
	                }
	            }
	            if (observables) {
	                var mergedObs = void 0;
	                for (var _c = 0, key_2 = key; _c < key_2.length; _c++) {
	                    var k = key_2[_c];
	                    var obs = typeof result[k].subscribe === "function" ? result[k] : of.of(result[k]);
	                    if (typeof mergedObs === "undefined") {
	                        mergedObs = obs;
	                    }
	                    else {
	                        mergedObs = mergedObs.pipe(merge.merge(obs));
	                    }
	                }
	                return mergedObs.pipe(toArray.toArray(), map.map(function (arr) {
	                    var obj = {};
	                    arr.forEach(function (value, index) {
	                        obj[key[index]] = value;
	                    });
	                    return obj;
	                }));
	            }
	            return result;
	        }
	        if (translations) {
	            res = this.parser.interpolate(this.parser.getValue(translations, key), interpolateParams);
	        }
	        if (typeof res === "undefined" && this.defaultLang && this.defaultLang !== this.currentLang && this.useDefaultLang) {
	            res = this.parser.interpolate(this.parser.getValue(this.translations[this.defaultLang], key), interpolateParams);
	        }
	        if (typeof res === "undefined") {
	            var params = { key: key, translateService: this };
	            if (typeof interpolateParams !== 'undefined') {
	                params.interpolateParams = interpolateParams;
	            }
	            res = this.missingTranslationHandler.handle(params);
	        }
	        return typeof res !== "undefined" ? res : key;
	    };
	    /**
	     * Gets the translated value of a key (or an array of keys)
	     * @param key
	     * @param interpolateParams
	     * @returns {any} the translated key, or an object of translated keys
	     */
	    TranslateService.prototype.get = function (key, interpolateParams) {
	        var _this = this;
	        if (!isDefined(key) || !key.length) {
	            throw new Error("Parameter \"key\" required");
	        }
	        // check if we are loading a new translation to use
	        if (this.pending) {
	            return Observable.Observable.create(function (observer) {
	                var onComplete = function (res) {
	                    observer.next(res);
	                    observer.complete();
	                };
	                var onError = function (err) {
	                    observer.error(err);
	                };
	                _this.loadingTranslations.subscribe(function (res) {
	                    res = _this.getParsedResult(_this.compiler.compileTranslations(res, _this.currentLang), key, interpolateParams);
	                    if (typeof res.subscribe === "function") {
	                        res.subscribe(onComplete, onError);
	                    }
	                    else {
	                        onComplete(res);
	                    }
	                }, onError);
	            });
	        }
	        else {
	            var res = this.getParsedResult(this.translations[this.currentLang], key, interpolateParams);
	            if (typeof res.subscribe === "function") {
	                return res;
	            }
	            else {
	                return of.of(res);
	            }
	        }
	    };
	    /**
	     * Returns a stream of translated values of a key (or an array of keys) which updates
	     * whenever the language changes.
	     * @param key
	     * @param interpolateParams
	     * @returns {any} A stream of the translated key, or an object of translated keys
	     */
	    TranslateService.prototype.stream = function (key, interpolateParams) {
	        var _this = this;
	        if (!isDefined(key) || !key.length) {
	            throw new Error("Parameter \"key\" required");
	        }
	        return this
	            .get(key, interpolateParams)
	            .pipe(concat_3(this.onLangChange.pipe(switchMap.switchMap(function (event) {
	            var res = _this.getParsedResult(event.translations, key, interpolateParams);
	            if (typeof res.subscribe === "function") {
	                return res;
	            }
	            else {
	                return of.of(res);
	            }
	        }))));
	    };
	    /**
	     * Returns a translation instantly from the internal state of loaded translation.
	     * All rules regarding the current language, the preferred language of even fallback languages will be used except any promise handling.
	     * @param key
	     * @param interpolateParams
	     * @returns {string}
	     */
	    TranslateService.prototype.instant = function (key, interpolateParams) {
	        if (!isDefined(key) || !key.length) {
	            throw new Error("Parameter \"key\" required");
	        }
	        var res = this.getParsedResult(this.translations[this.currentLang], key, interpolateParams);
	        if (typeof res.subscribe !== "undefined") {
	            if (key instanceof Array) {
	                var obj_1 = {};
	                key.forEach(function (value, index) {
	                    obj_1[key[index]] = key[index];
	                });
	                return obj_1;
	            }
	            return key;
	        }
	        else {
	            return res;
	        }
	    };
	    /**
	     * Sets the translated value of a key, after compiling it
	     * @param key
	     * @param value
	     * @param lang
	     */
	    TranslateService.prototype.set = function (key, value, lang) {
	        if (lang === void 0) { lang = this.currentLang; }
	        this.translations[lang][key] = this.compiler.compile(value, lang);
	        this.updateLangs();
	        this.onTranslationChange.emit({ lang: lang, translations: this.translations[lang] });
	    };
	    /**
	     * Changes the current lang
	     * @param lang
	     */
	    TranslateService.prototype.changeLang = function (lang) {
	        this.currentLang = lang;
	        this.onLangChange.emit({ lang: lang, translations: this.translations[lang] });
	        // if there is no default lang, use the one that we just set
	        if (!this.defaultLang) {
	            this.changeDefaultLang(lang);
	        }
	    };
	    /**
	     * Changes the default lang
	     * @param lang
	     */
	    TranslateService.prototype.changeDefaultLang = function (lang) {
	        this.defaultLang = lang;
	        this.onDefaultLangChange.emit({ lang: lang, translations: this.translations[lang] });
	    };
	    /**
	     * Allows to reload the lang file from the file
	     * @param lang
	     * @returns {Observable<any>}
	     */
	    TranslateService.prototype.reloadLang = function (lang) {
	        this.resetLang(lang);
	        return this.getTranslation(lang);
	    };
	    /**
	     * Deletes inner translation
	     * @param lang
	     */
	    TranslateService.prototype.resetLang = function (lang) {
	        this._translationRequests[lang] = undefined;
	        this.translations[lang] = undefined;
	    };
	    /**
	     * Returns the language code name from the browser, e.g. "de"
	     *
	     * @returns string
	     */
	    TranslateService.prototype.getBrowserLang = function () {
	        if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
	            return undefined;
	        }
	        var browserLang = window.navigator.languages ? window.navigator.languages[0] : null;
	        browserLang = browserLang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;
	        if (browserLang.indexOf('-') !== -1) {
	            browserLang = browserLang.split('-')[0];
	        }
	        if (browserLang.indexOf('_') !== -1) {
	            browserLang = browserLang.split('_')[0];
	        }
	        return browserLang;
	    };
	    /**
	     * Returns the culture language code name from the browser, e.g. "de-DE"
	     *
	     * @returns string
	     */
	    TranslateService.prototype.getBrowserCultureLang = function () {
	        if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
	            return undefined;
	        }
	        var browserCultureLang = window.navigator.languages ? window.navigator.languages[0] : null;
	        browserCultureLang = browserCultureLang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;
	        return browserCultureLang;
	    };
	    return TranslateService;
	}());
	exports.TranslateService = __decorate$2([
	    core.Injectable(),
	    __param(5, core.Inject(USE_DEFAULT_LANG)),
	    __param(6, core.Inject(USE_STORE)),
	    __metadata("design:paramtypes", [TranslateStore,
	        TranslateLoader,
	        TranslateCompiler,
	        TranslateParser,
	        MissingTranslationHandler, Boolean, Boolean])
	], exports.TranslateService);
	var __decorate$6 = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
	        r = Reflect.decorate(decorators, target, key, desc);
	    else
	        for (var i = decorators.length - 1; i >= 0; i--)
	            if (d = decorators[i])
	                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata$1 = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
	        return Reflect.metadata(k, v);
	};
	exports.TranslateDirective = (function () {
	    function TranslateDirective(translateService, element, _ref) {
	        var _this = this;
	        this.translateService = translateService;
	        this.element = element;
	        this._ref = _ref;
	        // subscribe to onTranslationChange event, in case the translations of the current lang change
	        if (!this.onTranslationChangeSub) {
	            this.onTranslationChangeSub = this.translateService.onTranslationChange.subscribe(function (event) {
	                if (event.lang === _this.translateService.currentLang) {
	                    _this.checkNodes(true, event.translations);
	                }
	            });
	        }
	        // subscribe to onLangChange event, in case the language changes
	        if (!this.onLangChangeSub) {
	            this.onLangChangeSub = this.translateService.onLangChange.subscribe(function (event) {
	                _this.checkNodes(true, event.translations);
	            });
	        }
	        // subscribe to onDefaultLangChange event, in case the default language changes
	        if (!this.onDefaultLangChangeSub) {
	            this.onDefaultLangChangeSub = this.translateService.onDefaultLangChange.subscribe(function (event) {
	                _this.checkNodes(true);
	            });
	        }
	    }
	    Object.defineProperty(TranslateDirective.prototype, "translate", {
	        set: function (key) {
	            if (key) {
	                this.key = key;
	                this.checkNodes();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TranslateDirective.prototype, "translateParams", {
	        set: function (params) {
	            if (!equals(this.currentParams, params)) {
	                this.currentParams = params;
	                this.checkNodes(true);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TranslateDirective.prototype.ngAfterViewChecked = function () {
	        this.checkNodes();
	    };
	    TranslateDirective.prototype.checkNodes = function (forceUpdate, translations) {
	        if (forceUpdate === void 0) { forceUpdate = false; }
	        var nodes = this.element.nativeElement.childNodes;
	        // if the element is empty
	        if (!nodes.length) {
	            // we add the key as content
	            this.setContent(this.element.nativeElement, this.key);
	            nodes = this.element.nativeElement.childNodes;
	        }
	        for (var i = 0; i < nodes.length; ++i) {
	            var node = nodes[i];
	            if (node.nodeType === 3) {
	                var key = void 0;
	                if (this.key) {
	                    key = this.key;
	                    if (forceUpdate) {
	                        node.lastKey = null;
	                    }
	                }
	                else {
	                    var content = this.getContent(node).trim();
	                    if (content.length) {
	                        // we want to use the content as a key, not the translation value
	                        if (content !== node.currentValue) {
	                            key = content;
	                            // the content was changed from the user, we'll use it as a reference if needed
	                            node.originalContent = this.getContent(node);
	                        }
	                        else if (node.originalContent && forceUpdate) {
	                            node.lastKey = null;
	                            // the current content is the translation, not the key, use the last real content as key
	                            key = node.originalContent.trim();
	                        }
	                    }
	                }
	                this.updateValue(key, node, translations);
	            }
	        }
	    };
	    TranslateDirective.prototype.updateValue = function (key, node, translations) {
	        var _this = this;
	        if (key) {
	            if (node.lastKey === key && this.lastParams === this.currentParams) {
	                return;
	            }
	            this.lastParams = this.currentParams;
	            var onTranslation = function (res) {
	                if (res !== key) {
	                    node.lastKey = key;
	                }
	                if (!node.originalContent) {
	                    node.originalContent = _this.getContent(node);
	                }
	                node.currentValue = isDefined(res) ? res : (node.originalContent || key);
	                // we replace in the original content to preserve spaces that we might have trimmed
	                _this.setContent(node, _this.key ? node.currentValue : node.originalContent.replace(key, node.currentValue));
	                _this._ref.markForCheck();
	            };
	            if (isDefined(translations)) {
	                var res = this.translateService.getParsedResult(translations, key, this.currentParams);
	                if (typeof res.subscribe === "function") {
	                    res.subscribe(onTranslation);
	                }
	                else {
	                    onTranslation(res);
	                }
	            }
	            else {
	                this.translateService.get(key, this.currentParams).subscribe(onTranslation);
	            }
	        }
	    };
	    TranslateDirective.prototype.getContent = function (node) {
	        return isDefined(node.textContent) ? node.textContent : node.data;
	    };
	    TranslateDirective.prototype.setContent = function (node, content) {
	        if (isDefined(node.textContent)) {
	            node.textContent = content;
	        }
	        else {
	            node.data = content;
	        }
	    };
	    TranslateDirective.prototype.ngOnDestroy = function () {
	        if (this.onLangChangeSub) {
	            this.onLangChangeSub.unsubscribe();
	        }
	        if (this.onDefaultLangChangeSub) {
	            this.onDefaultLangChangeSub.unsubscribe();
	        }
	        if (this.onTranslationChangeSub) {
	            this.onTranslationChangeSub.unsubscribe();
	        }
	    };
	    return TranslateDirective;
	}());
	__decorate$6([
	    core.Input(),
	    __metadata$1("design:type", String),
	    __metadata$1("design:paramtypes", [String])
	], exports.TranslateDirective.prototype, "translate", null);
	__decorate$6([
	    core.Input(),
	    __metadata$1("design:type", Object),
	    __metadata$1("design:paramtypes", [Object])
	], exports.TranslateDirective.prototype, "translateParams", null);
	exports.TranslateDirective = __decorate$6([
	    core.Directive({
	        selector: '[translate],[ngx-translate]'
	    }),
	    __metadata$1("design:paramtypes", [exports.TranslateService, core.ElementRef, core.ChangeDetectorRef])
	], exports.TranslateDirective);
	var __decorate$7 = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
	        r = Reflect.decorate(decorators, target, key, desc);
	    else
	        for (var i = decorators.length - 1; i >= 0; i--)
	            if (d = decorators[i])
	                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata$2 = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
	        return Reflect.metadata(k, v);
	};
	exports.TranslatePipe = (function () {
	    function TranslatePipe(translate, _ref) {
	        this.translate = translate;
	        this._ref = _ref;
	        this.value = '';
	    }
	    TranslatePipe.prototype.updateValue = function (key, interpolateParams, translations) {
	        var _this = this;
	        var onTranslation = function (res) {
	            _this.value = res !== undefined ? res : key;
	            _this.lastKey = key;
	            _this._ref.markForCheck();
	        };
	        if (translations) {
	            var res = this.translate.getParsedResult(translations, key, interpolateParams);
	            if (typeof res.subscribe === 'function') {
	                res.subscribe(onTranslation);
	            }
	            else {
	                onTranslation(res);
	            }
	        }
	        this.translate.get(key, interpolateParams).subscribe(onTranslation);
	    };
	    TranslatePipe.prototype.transform = function (query) {
	        var _this = this;
	        var args = [];
	        for (var _b = 1; _b < arguments.length; _b++) {
	            args[_b - 1] = arguments[_b];
	        }
	        if (!query || query.length === 0) {
	            return query;
	        }
	        // if we ask another time for the same key, return the last value
	        if (equals(query, this.lastKey) && equals(args, this.lastParams)) {
	            return this.value;
	        }
	        var interpolateParams;
	        if (isDefined(args[0]) && args.length) {
	            if (typeof args[0] === 'string' && args[0].length) {
	                // we accept objects written in the template such as {n:1}, {'n':1}, {n:'v'}
	                // which is why we might need to change it to real JSON objects such as {"n":1} or {"n":"v"}
	                var validArgs = args[0]
	                    .replace(/(\')?([a-zA-Z0-9_]+)(\')?(\s)?:/g, '"$2":')
	                    .replace(/:(\s)?(\')(.*?)(\')/g, ':"$3"');
	                try {
	                    interpolateParams = JSON.parse(validArgs);
	                }
	                catch (e) {
	                    throw new SyntaxError("Wrong parameter in TranslatePipe. Expected a valid Object, received: " + args[0]);
	                }
	            }
	            else if (typeof args[0] === 'object' && !Array.isArray(args[0])) {
	                interpolateParams = args[0];
	            }
	        }
	        // store the query, in case it changes
	        this.lastKey = query;
	        // store the params, in case they change
	        this.lastParams = args;
	        // set the value
	        this.updateValue(query, interpolateParams);
	        // if there is a subscription to onLangChange, clean it
	        this._dispose();
	        // subscribe to onTranslationChange event, in case the translations change
	        if (!this.onTranslationChange) {
	            this.onTranslationChange = this.translate.onTranslationChange.subscribe(function (event) {
	                if (_this.lastKey && event.lang === _this.translate.currentLang) {
	                    _this.lastKey = null;
	                    _this.updateValue(query, interpolateParams, event.translations);
	                }
	            });
	        }
	        // subscribe to onLangChange event, in case the language changes
	        if (!this.onLangChange) {
	            this.onLangChange = this.translate.onLangChange.subscribe(function (event) {
	                if (_this.lastKey) {
	                    _this.lastKey = null; // we want to make sure it doesn't return the same value until it's been updated
	                    _this.updateValue(query, interpolateParams, event.translations);
	                }
	            });
	        }
	        // subscribe to onDefaultLangChange event, in case the default language changes
	        if (!this.onDefaultLangChange) {
	            this.onDefaultLangChange = this.translate.onDefaultLangChange.subscribe(function () {
	                if (_this.lastKey) {
	                    _this.lastKey = null; // we want to make sure it doesn't return the same value until it's been updated
	                    _this.updateValue(query, interpolateParams);
	                }
	            });
	        }
	        return this.value;
	    };
	    /**
	     * Clean any existing subscription to change events
	     * @private
	     */
	    TranslatePipe.prototype._dispose = function () {
	        if (typeof this.onTranslationChange !== 'undefined') {
	            this.onTranslationChange.unsubscribe();
	            this.onTranslationChange = undefined;
	        }
	        if (typeof this.onLangChange !== 'undefined') {
	            this.onLangChange.unsubscribe();
	            this.onLangChange = undefined;
	        }
	        if (typeof this.onDefaultLangChange !== 'undefined') {
	            this.onDefaultLangChange.unsubscribe();
	            this.onDefaultLangChange = undefined;
	        }
	    };
	    TranslatePipe.prototype.ngOnDestroy = function () {
	        this._dispose();
	    };
	    return TranslatePipe;
	}());
	exports.TranslatePipe = __decorate$7([
	    core.Injectable(),
	    core.Pipe({
	        name: 'translate',
	        pure: false // required to update the value when the promise is resolved
	    }),
	    __metadata$2("design:paramtypes", [exports.TranslateService, core.ChangeDetectorRef])
	], exports.TranslatePipe);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
	        r = Reflect.decorate(decorators, target, key, desc);
	    else
	        for (var i = decorators.length - 1; i >= 0; i--)
	            if (d = decorators[i])
	                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	exports.TranslateModule = TranslateModule_1 = (function () {
	    function TranslateModule() {
	    }
	    /**
	     * Use this method in your root module to provide the TranslateService
	     * @param {TranslateModuleConfig} config
	     * @returns {ModuleWithProviders}
	     */
	    TranslateModule.forRoot = function (config) {
	        if (config === void 0) { config = {}; }
	        return {
	            ngModule: TranslateModule_1,
	            providers: [
	                config.loader || { provide: TranslateLoader, useClass: exports.TranslateFakeLoader },
	                config.compiler || { provide: TranslateCompiler, useClass: exports.TranslateFakeCompiler },
	                config.parser || { provide: TranslateParser, useClass: exports.TranslateDefaultParser },
	                config.missingTranslationHandler || { provide: MissingTranslationHandler, useClass: exports.FakeMissingTranslationHandler },
	                TranslateStore,
	                { provide: USE_STORE, useValue: config.isolate },
	                { provide: USE_DEFAULT_LANG, useValue: config.useDefaultLang },
	                exports.TranslateService
	            ]
	        };
	    };
	    /**
	     * Use this method in your other (non root) modules to import the directive/pipe
	     * @param {TranslateModuleConfig} config
	     * @returns {ModuleWithProviders}
	     */
	    TranslateModule.forChild = function (config) {
	        if (config === void 0) { config = {}; }
	        return {
	            ngModule: TranslateModule_1,
	            providers: [
	                config.loader || { provide: TranslateLoader, useClass: exports.TranslateFakeLoader },
	                config.compiler || { provide: TranslateCompiler, useClass: exports.TranslateFakeCompiler },
	                config.parser || { provide: TranslateParser, useClass: exports.TranslateDefaultParser },
	                config.missingTranslationHandler || { provide: MissingTranslationHandler, useClass: exports.FakeMissingTranslationHandler },
	                { provide: USE_STORE, useValue: config.isolate },
	                { provide: USE_DEFAULT_LANG, useValue: config.useDefaultLang },
	                exports.TranslateService
	            ]
	        };
	    };
	    return TranslateModule;
	}());
	exports.TranslateModule = TranslateModule_1 = __decorate([
	    core.NgModule({
	        declarations: [
	            exports.TranslatePipe,
	            exports.TranslateDirective
	        ],
	        exports: [
	            exports.TranslatePipe,
	            exports.TranslateDirective
	        ]
	    })
	], exports.TranslateModule);
	var TranslateModule_1;
	
	exports.ɵa = TranslateStore;
	exports.TranslateLoader = TranslateLoader;
	exports.USE_STORE = USE_STORE;
	exports.USE_DEFAULT_LANG = USE_DEFAULT_LANG;
	exports.MissingTranslationHandler = MissingTranslationHandler;
	exports.TranslateParser = TranslateParser;
	exports.TranslateCompiler = TranslateCompiler;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=core.umd.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 253 */,
/* 254 */,
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var merge_1 = __webpack_require__(222);
	var merge_2 = __webpack_require__(222);
	exports.mergeStatic = merge_2.merge;
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which concurrently emits all values from every
	 * given input Observable.
	 *
	 * <span class="informal">Flattens multiple Observables together by blending
	 * their values into one Observable.</span>
	 *
	 * <img src="./img/merge.png" width="100%">
	 *
	 * `merge` subscribes to each given input Observable (either the source or an
	 * Observable given as argument), and simply forwards (without doing any
	 * transformation) all the values from all the input Observables to the output
	 * Observable. The output Observable only completes once all input Observables
	 * have completed. Any error delivered by an input Observable will be immediately
	 * emitted on the output Observable.
	 *
	 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var timer = Rx.Observable.interval(1000);
	 * var clicksOrTimer = clicks.merge(timer);
	 * clicksOrTimer.subscribe(x => console.log(x));
	 *
	 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var concurrent = 2; // the argument
	 * var merged = timer1.merge(timer2, timer3, concurrent);
	 * merged.subscribe(x => console.log(x));
	 *
	 * @see {@link mergeAll}
	 * @see {@link mergeMap}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 *
	 * @param {ObservableInput} other An input Observable to merge with the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
	 * concurrency of input Observables.
	 * @return {Observable} An Observable that emits items that are the result of
	 * every input Observable.
	 * @method merge
	 * @owner Observable
	 */
	function merge() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return function (source) { return source.lift.call(merge_1.merge.apply(void 0, [source].concat(observables))); };
	}
	exports.merge = merge;
	//# sourceMappingURL=merge.js.map

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable, emitting values only from the most recently projected Observable.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link switch}.</span>
	 *
	 * <img src="./img/switchMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. Each time it observes one of these
	 * inner Observables, the output Observable begins emitting the items emitted by
	 * that inner Observable. When a new inner Observable is emitted, `switchMap`
	 * stops emitting items from the earlier-emitted inner Observable and begins
	 * emitting items from the new one. It continues to behave like this for
	 * subsequent inner Observables.
	 *
	 * @example <caption>Rerun an interval Observable on every click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaustMap}
	 * @see {@link mergeMap}
	 * @see {@link switch}
	 * @see {@link switchMapTo}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and taking only the values from the most recently
	 * projected inner Observable.
	 * @method switchMap
	 * @owner Observable
	 */
	function switchMap(project, resultSelector) {
	    return function switchMapOperatorFunction(source) {
	        return source.lift(new SwitchMapOperator(project, resultSelector));
	    };
	}
	exports.switchMap = switchMap;
	var SwitchMapOperator = (function () {
	    function SwitchMapOperator(project, resultSelector) {
	        this.project = project;
	        this.resultSelector = resultSelector;
	    }
	    SwitchMapOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
	    };
	    return SwitchMapOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SwitchMapSubscriber = (function (_super) {
	    __extends(SwitchMapSubscriber, _super);
	    function SwitchMapSubscriber(destination, project, resultSelector) {
	        _super.call(this, destination);
	        this.project = project;
	        this.resultSelector = resultSelector;
	        this.index = 0;
	    }
	    SwitchMapSubscriber.prototype._next = function (value) {
	        var result;
	        var index = this.index++;
	        try {
	            result = this.project(value, index);
	        }
	        catch (error) {
	            this.destination.error(error);
	            return;
	        }
	        this._innerSub(result, value, index);
	    };
	    SwitchMapSubscriber.prototype._innerSub = function (result, value, index) {
	        var innerSubscription = this.innerSubscription;
	        if (innerSubscription) {
	            innerSubscription.unsubscribe();
	        }
	        this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, result, value, index));
	    };
	    SwitchMapSubscriber.prototype._complete = function () {
	        var innerSubscription = this.innerSubscription;
	        if (!innerSubscription || innerSubscription.closed) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    /** @deprecated internal use only */ SwitchMapSubscriber.prototype._unsubscribe = function () {
	        this.innerSubscription = null;
	    };
	    SwitchMapSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.remove(innerSub);
	        this.innerSubscription = null;
	        if (this.isStopped) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    SwitchMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        if (this.resultSelector) {
	            this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            this.destination.next(innerValue);
	        }
	    };
	    SwitchMapSubscriber.prototype._tryNotifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var result;
	        try {
	            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return SwitchMapSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var reduce_1 = __webpack_require__(258);
	function toArrayReducer(arr, item, index) {
	    if (index === 0) {
	        return [item];
	    }
	    arr.push(item);
	    return arr;
	}
	function toArray() {
	    return reduce_1.reduce(toArrayReducer, []);
	}
	exports.toArray = toArray;
	//# sourceMappingURL=toArray.js.map

/***/ }),
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	var ArgumentOutOfRangeError_1 = __webpack_require__(261);
	var EmptyObservable_1 = __webpack_require__(225);
	/**
	 * Emits only the first `count` values emitted by the source Observable.
	 *
	 * <span class="informal">Takes the first `count` values from the source, then
	 * completes.</span>
	 *
	 * <img src="./img/take.png" width="100%">
	 *
	 * `take` returns an Observable that emits only the first `count` values emitted
	 * by the source Observable. If the source emits fewer than `count` values then
	 * all of its values are emitted. After that, it completes, regardless if the
	 * source completes.
	 *
	 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
	 * var interval = Rx.Observable.interval(1000);
	 * var five = interval.take(5);
	 * five.subscribe(x => console.log(x));
	 *
	 * @see {@link takeLast}
	 * @see {@link takeUntil}
	 * @see {@link takeWhile}
	 * @see {@link skip}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
	 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
	 *
	 * @param {number} count The maximum number of `next` values to emit.
	 * @return {Observable<T>} An Observable that emits only the first `count`
	 * values emitted by the source Observable, or all of the values from the source
	 * if the source emits fewer than `count` values.
	 * @method take
	 * @owner Observable
	 */
	function take(count) {
	    return function (source) {
	        if (count === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        else {
	            return source.lift(new TakeOperator(count));
	        }
	    };
	}
	exports.take = take;
	var TakeOperator = (function () {
	    function TakeOperator(total) {
	        this.total = total;
	        if (this.total < 0) {
	            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	        }
	    }
	    TakeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TakeSubscriber(subscriber, this.total));
	    };
	    return TakeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TakeSubscriber = (function (_super) {
	    __extends(TakeSubscriber, _super);
	    function TakeSubscriber(destination, total) {
	        _super.call(this, destination);
	        this.total = total;
	        this.count = 0;
	    }
	    TakeSubscriber.prototype._next = function (value) {
	        var total = this.total;
	        var count = ++this.count;
	        if (count <= total) {
	            this.destination.next(value);
	            if (count === total) {
	                this.destination.complete();
	                this.unsubscribe();
	            }
	        }
	    };
	    return TakeSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=take.js.map

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(265));


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var notification_component_1 = __webpack_require__(266);
	var core_1 = __webpack_require__(205);
	var notification_types_1 = __webpack_require__(267);
	var lodash_1 = __webpack_require__(268);
	var router_1 = __webpack_require__(270);
	var DEFAULT_DELAY = 10000; //ms
	var ROOT_CONTAINER = document.querySelector('.notifies');
	//Service for rendering notification messages at page right panel
	var NotificationManager = (function () {
	    function NotificationManager(_injector) {
	        this._injector = _injector;
	        this.RELOAD_PAGE_STRING = 'Reload page.';
	        this.destroyComponentFunctions = [];
	        this.onLeaveRouteClearAllNotification();
	        this.parentEl = ROOT_CONTAINER;
	    }
	    NotificationManager.prototype.changeParentEl = function (el) {
	        this.parentEl = (el) ? el : ROOT_CONTAINER;
	        return this;
	    };
	    NotificationManager.prototype.clearAllNotification = function () {
	        lodash_1.remove(this.destroyComponentFunctions, function (destroyFunction) {
	            destroyFunction();
	            return true;
	        });
	    };
	    /**
	     * Render error notification
	     * @param template                  - html template for notification content
	     * @param delay                     - autoclose delay (boolean,number)
	     * @returns {Function}              - function to close notification
	     */
	    NotificationManager.prototype.error = function (template, delay) {
	        return this.placeNotifyElement(notification_types_1.TYPES.DANGER, template, delay);
	    };
	    /**
	     * Render warning notification
	     * @param template                  - html template for notification content
	     * @param delay                     - autoclose delay (boolean,number)
	     * @returns {Function}              - function to close notification
	     */
	    NotificationManager.prototype.warning = function (template, delay) {
	        return this.placeNotifyElement(notification_types_1.TYPES.WARNING, template, delay);
	    };
	    /**
	     * Render success notification
	     * @param template                  - html template for notification content
	     * @param delay                     - autoclose delay (boolean,number)
	     * @returns {Function}              - function to close notification
	     */
	    NotificationManager.prototype.success = function (template, delay) {
	        return this.placeNotifyElement(notification_types_1.TYPES.SUCCESS, template, delay);
	    };
	    NotificationManager.prototype.primary = function (template, delay) {
	        return this.placeNotifyElement(notification_types_1.TYPES.PRIMARY, template, delay);
	    };
	    NotificationManager.prototype.onLeaveRouteClearAllNotification = function () {
	        var _this = this;
	        setTimeout(function () {
	            _this._injector.get(router_1.Router).events.subscribe(function (event) {
	                if (event instanceof router_1.NavigationStart) {
	                    _this.destroyComponentFunctions.forEach(function (f) { return f(); });
	                    _this.destroyComponentFunctions = [];
	                }
	            });
	        });
	    };
	    NotificationManager.prototype.createNotifyContent = function (template) {
	        if (lodash_1.endsWith(template, this.RELOAD_PAGE_STRING)) {
	            var message = template.substr(0, template.length - this.RELOAD_PAGE_STRING.length);
	            return message + " <a id=\"link_in_error\" href=\"javascript:window.location.reload(true)\">" + this.RELOAD_PAGE_STRING + "</a>";
	        }
	        return template;
	    };
	    NotificationManager.prototype.destroyNotifyElement = function (element) {
	        if (element) {
	            element.destroy();
	        }
	    };
	    NotificationManager.prototype.createNotifyElement = function (type, content) {
	        return new notification_component_1.NotificationComponent(type, content);
	    };
	    NotificationManager.prototype.placeNotifyElement = function (type, template, delay) {
	        var _this = this;
	        if (lodash_1.isNil(delay)) {
	            delay = true;
	        }
	        // restore parent element if it was dynamically removed
	        if (!document.body.contains(this.parentEl)) {
	            this.parentEl = ROOT_CONTAINER;
	        }
	        var content = this.createNotifyContent(template);
	        var element = this.createNotifyElement(type, content);
	        this.parentEl.appendChild(element.getElement());
	        //
	        if (delay === true) {
	            delay = DEFAULT_DELAY;
	        }
	        //
	        if (lodash_1.isNumber(delay)) {
	            setTimeout(function () {
	                _this.destroyNotifyElement(element);
	            }, delay);
	        }
	        var destroyFunc = function () {
	            _this.destroyNotifyElement(element);
	        };
	        this.destroyComponentFunctions.push(destroyFunc);
	        return destroyFunc;
	    };
	    NotificationManager = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [core_1.Injector])
	    ], NotificationManager);
	    return NotificationManager;
	}());
	exports.NotificationManager = NotificationManager;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var notification_types_1 = __webpack_require__(267);
	var NotificationComponent = (function () {
	    function NotificationComponent(type, content) {
	        var _this = this;
	        this.element = document.createElement('div');
	        this.element.className = "notification-container";
	        this.element.innerHTML = this.getTemplate(type, content);
	        this.element.querySelector('button.close').addEventListener('click', function () { return _this.destroy(); });
	    }
	    NotificationComponent.prototype.getNotificationClass = function (type) {
	        switch (type) {
	            case notification_types_1.TYPES.DANGER:
	                return 'danger';
	            case notification_types_1.TYPES.WARNING:
	                return 'warning';
	            case notification_types_1.TYPES.PRIMARY:
	                return 'primary';
	            default:
	                return 'success';
	        }
	    };
	    NotificationComponent.prototype.getTemplate = function (type, customContent) {
	        return "\n        <div class=\"alert alert-dismissible fade in alert-" + this.getNotificationClass(type) + "\">\n            <button type=\"button\" class=\"close notification-close-btn\" data-dismiss=\"alert\" aria-label=\"Close\">\n               <span aria-hidden=\"true\">\u00D7</span>\n            </button>\n            <span class=\"notification-icon\"></span>\n            <span id=\"error-notification\" class=\"error-notification\">" + customContent + "</span>\n        </div>\n        ";
	    };
	    NotificationComponent.prototype.getElement = function () {
	        return this.element;
	    };
	    NotificationComponent.prototype.destroy = function () {
	        var _this = this;
	        var alertEl = this.element.querySelector('div.alert');
	        if (alertEl) {
	            alertEl.style.opacity = '0';
	        }
	        setTimeout(function () {
	            _this.element.remove();
	        }, 400);
	    };
	    return NotificationComponent;
	}());
	exports.NotificationComponent = NotificationComponent;


/***/ }),
/* 267 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TYPES = {
	    DANGER: 'danger',
	    WARNING: 'warning',
	    SUCCESS: 'success',
	    PRIMARY: 'primary'
	};


/***/ }),
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var translate_1 = __webpack_require__(300);
	var AppComponent = (function () {
	    function AppComponent(translateManager) {
	        this.translateManager = translateManager;
	    }
	    AppComponent.prototype.ngOnInit = function () {
	        this.translateManager.configure();
	    };
	    AppComponent = __decorate([
	        core_1.Component({
	            selector: 'app',
	            template: __webpack_require__(734)
	        }),
	        __metadata("design:paramtypes", [translate_1.TranslateManager])
	    ], AppComponent);
	    return AppComponent;
	}());
	exports.AppComponent = AppComponent;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(301));
	__export(__webpack_require__(302));


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(252);
	var translate_1 = __webpack_require__(302);
	exports.TRANSLATE_LOADER_PROVIDER = {
	    loader: {
	        provide: core_1.TranslateLoader,
	        useFactory: function () { return new DashboardTranslateLoader(); }
	    }
	};
	var DashboardTranslateLoader = (function (_super) {
	    __extends(DashboardTranslateLoader, _super);
	    function DashboardTranslateLoader() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DashboardTranslateLoader.prototype.getModuleTranslation = function (lang) {
	        return __webpack_require__(693)("./" + lang + '/index.ts').LOCALE;
	    };
	    return DashboardTranslateLoader;
	}(translate_1.CommonTranslateLoader));
	exports.DashboardTranslateLoader = DashboardTranslateLoader;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(303));
	__export(__webpack_require__(692));
	__export(__webpack_require__(683));


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var rxjs_1 = __webpack_require__(304);
	var core_1 = __webpack_require__(252);
	var CommonTranslateLoader = (function (_super) {
	    __extends(CommonTranslateLoader, _super);
	    function CommonTranslateLoader() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    CommonTranslateLoader.prototype.getTranslation = function (lang) {
	        var commonPack = __webpack_require__(681)("./" + lang + '/index.ts').LOCALE, modulePack = this.getModuleTranslation(lang);
	        return rxjs_1.Observable.of(Object.assign({}, commonPack, modulePack));
	    };
	    return CommonTranslateLoader;
	}(core_1.TranslateLoader));
	exports.CommonTranslateLoader = CommonTranslateLoader;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/* tslint:disable:no-unused-variable */
	// Subject imported before Observable to bypass circular dependency issue since
	// Subject extends Observable and Observable references Subject in it's
	// definition
	var Subject_1 = __webpack_require__(240);
	exports.Subject = Subject_1.Subject;
	exports.AnonymousSubject = Subject_1.AnonymousSubject;
	/* tslint:enable:no-unused-variable */
	var Observable_1 = __webpack_require__(206);
	exports.Observable = Observable_1.Observable;
	// statics
	/* tslint:disable:no-use-before-declare */
	__webpack_require__(305);
	__webpack_require__(309);
	__webpack_require__(312);
	__webpack_require__(315);
	__webpack_require__(317);
	__webpack_require__(320);
	__webpack_require__(322);
	__webpack_require__(325);
	__webpack_require__(326);
	__webpack_require__(329);
	__webpack_require__(332);
	__webpack_require__(333);
	__webpack_require__(336);
	__webpack_require__(339);
	__webpack_require__(348);
	__webpack_require__(349);
	__webpack_require__(351);
	__webpack_require__(354);
	__webpack_require__(355);
	__webpack_require__(358);
	__webpack_require__(361);
	__webpack_require__(364);
	__webpack_require__(367);
	__webpack_require__(370);
	__webpack_require__(374);
	//dom
	__webpack_require__(377);
	__webpack_require__(380);
	//operators
	__webpack_require__(388);
	__webpack_require__(391);
	__webpack_require__(394);
	__webpack_require__(397);
	__webpack_require__(400);
	__webpack_require__(403);
	__webpack_require__(404);
	__webpack_require__(407);
	__webpack_require__(409);
	__webpack_require__(412);
	__webpack_require__(413);
	__webpack_require__(414);
	__webpack_require__(417);
	__webpack_require__(420);
	__webpack_require__(423);
	__webpack_require__(426);
	__webpack_require__(429);
	__webpack_require__(431);
	__webpack_require__(434);
	__webpack_require__(437);
	__webpack_require__(441);
	__webpack_require__(444);
	__webpack_require__(447);
	__webpack_require__(450);
	__webpack_require__(453);
	__webpack_require__(456);
	__webpack_require__(459);
	__webpack_require__(462);
	__webpack_require__(463);
	__webpack_require__(466);
	__webpack_require__(469);
	__webpack_require__(472);
	__webpack_require__(473);
	__webpack_require__(479);
	__webpack_require__(482);
	__webpack_require__(485);
	__webpack_require__(488);
	__webpack_require__(491);
	__webpack_require__(492);
	__webpack_require__(494);
	__webpack_require__(495);
	__webpack_require__(496);
	__webpack_require__(499);
	__webpack_require__(502);
	__webpack_require__(505);
	__webpack_require__(507);
	__webpack_require__(508);
	__webpack_require__(509);
	__webpack_require__(512);
	__webpack_require__(515);
	__webpack_require__(518);
	__webpack_require__(520);
	__webpack_require__(522);
	__webpack_require__(524);
	__webpack_require__(527);
	__webpack_require__(531);
	__webpack_require__(534);
	__webpack_require__(537);
	__webpack_require__(540);
	__webpack_require__(543);
	__webpack_require__(546);
	__webpack_require__(549);
	__webpack_require__(550);
	__webpack_require__(553);
	__webpack_require__(556);
	__webpack_require__(559);
	__webpack_require__(562);
	__webpack_require__(565);
	__webpack_require__(568);
	__webpack_require__(570);
	__webpack_require__(573);
	__webpack_require__(574);
	__webpack_require__(577);
	__webpack_require__(580);
	__webpack_require__(583);
	__webpack_require__(586);
	__webpack_require__(589);
	__webpack_require__(592);
	__webpack_require__(595);
	__webpack_require__(606);
	__webpack_require__(609);
	__webpack_require__(611);
	__webpack_require__(614);
	__webpack_require__(616);
	__webpack_require__(618);
	__webpack_require__(621);
	__webpack_require__(624);
	__webpack_require__(627);
	__webpack_require__(630);
	__webpack_require__(633);
	__webpack_require__(637);
	__webpack_require__(640);
	__webpack_require__(643);
	__webpack_require__(645);
	__webpack_require__(646);
	__webpack_require__(649);
	__webpack_require__(652);
	__webpack_require__(655);
	__webpack_require__(658);
	__webpack_require__(661);
	__webpack_require__(664);
	__webpack_require__(666);
	/* tslint:disable:no-unused-variable */
	var Subscription_1 = __webpack_require__(211);
	exports.Subscription = Subscription_1.Subscription;
	var Subscriber_1 = __webpack_require__(209);
	exports.Subscriber = Subscriber_1.Subscriber;
	var AsyncSubject_1 = __webpack_require__(308);
	exports.AsyncSubject = AsyncSubject_1.AsyncSubject;
	var ReplaySubject_1 = __webpack_require__(383);
	exports.ReplaySubject = ReplaySubject_1.ReplaySubject;
	var BehaviorSubject_1 = __webpack_require__(271);
	exports.BehaviorSubject = BehaviorSubject_1.BehaviorSubject;
	var ConnectableObservable_1 = __webpack_require__(239);
	exports.ConnectableObservable = ConnectableObservable_1.ConnectableObservable;
	var Notification_1 = __webpack_require__(282);
	exports.Notification = Notification_1.Notification;
	var EmptyError_1 = __webpack_require__(289);
	exports.EmptyError = EmptyError_1.EmptyError;
	var ArgumentOutOfRangeError_1 = __webpack_require__(261);
	exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	var ObjectUnsubscribedError_1 = __webpack_require__(241);
	exports.ObjectUnsubscribedError = ObjectUnsubscribedError_1.ObjectUnsubscribedError;
	var TimeoutError_1 = __webpack_require__(636);
	exports.TimeoutError = TimeoutError_1.TimeoutError;
	var UnsubscriptionError_1 = __webpack_require__(216);
	exports.UnsubscriptionError = UnsubscriptionError_1.UnsubscriptionError;
	var timeInterval_1 = __webpack_require__(631);
	exports.TimeInterval = timeInterval_1.TimeInterval;
	var timestamp_1 = __webpack_require__(642);
	exports.Timestamp = timestamp_1.Timestamp;
	var TestScheduler_1 = __webpack_require__(669);
	exports.TestScheduler = TestScheduler_1.TestScheduler;
	var VirtualTimeScheduler_1 = __webpack_require__(675);
	exports.VirtualTimeScheduler = VirtualTimeScheduler_1.VirtualTimeScheduler;
	var AjaxObservable_1 = __webpack_require__(379);
	exports.AjaxResponse = AjaxObservable_1.AjaxResponse;
	exports.AjaxError = AjaxObservable_1.AjaxError;
	exports.AjaxTimeoutError = AjaxObservable_1.AjaxTimeoutError;
	var pipe_1 = __webpack_require__(220);
	exports.pipe = pipe_1.pipe;
	var asap_1 = __webpack_require__(599);
	var async_1 = __webpack_require__(343);
	var queue_1 = __webpack_require__(384);
	var animationFrame_1 = __webpack_require__(676);
	var rxSubscriber_1 = __webpack_require__(218);
	var iterator_1 = __webpack_require__(232);
	var observable_1 = __webpack_require__(219);
	var _operators = __webpack_require__(680);
	exports.operators = _operators;
	/* tslint:enable:no-unused-variable */
	/**
	 * @typedef {Object} Rx.Scheduler
	 * @property {Scheduler} queue Schedules on a queue in the current event frame
	 * (trampoline scheduler). Use this for iteration operations.
	 * @property {Scheduler} asap Schedules on the micro task queue, which uses the
	 * fastest transport mechanism available, either Node.js' `process.nextTick()`
	 * or Web Worker MessageChannel or setTimeout or others. Use this for
	 * asynchronous conversions.
	 * @property {Scheduler} async Schedules work with `setInterval`. Use this for
	 * time-based operations.
	 * @property {Scheduler} animationFrame Schedules work with `requestAnimationFrame`.
	 * Use this for synchronizing with the platform's painting
	 */
	var Scheduler = {
	    asap: asap_1.asap,
	    queue: queue_1.queue,
	    animationFrame: animationFrame_1.animationFrame,
	    async: async_1.async
	};
	exports.Scheduler = Scheduler;
	/**
	 * @typedef {Object} Rx.Symbol
	 * @property {Symbol|string} rxSubscriber A symbol to use as a property name to
	 * retrieve an "Rx safe" Observer from an object. "Rx safety" can be defined as
	 * an object that has all of the traits of an Rx Subscriber, including the
	 * ability to add and remove subscriptions to the subscription chain and
	 * guarantees involving event triggering (can't "next" after unsubscription,
	 * etc).
	 * @property {Symbol|string} observable A symbol to use as a property name to
	 * retrieve an Observable as defined by the [ECMAScript "Observable" spec](https://github.com/zenparsing/es-observable).
	 * @property {Symbol|string} iterator The ES6 symbol to use as a property name
	 * to retrieve an iterator from an object.
	 */
	var Symbol = {
	    rxSubscriber: rxSubscriber_1.rxSubscriber,
	    observable: observable_1.observable,
	    iterator: iterator_1.iterator
	};
	exports.Symbol = Symbol;
	//# sourceMappingURL=Rx.js.map

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var bindCallback_1 = __webpack_require__(306);
	Observable_1.Observable.bindCallback = bindCallback_1.bindCallback;
	//# sourceMappingURL=bindCallback.js.map

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var BoundCallbackObservable_1 = __webpack_require__(307);
	exports.bindCallback = BoundCallbackObservable_1.BoundCallbackObservable.create;
	//# sourceMappingURL=bindCallback.js.map

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(206);
	var tryCatch_1 = __webpack_require__(214);
	var errorObject_1 = __webpack_require__(215);
	var AsyncSubject_1 = __webpack_require__(308);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var BoundCallbackObservable = (function (_super) {
	    __extends(BoundCallbackObservable, _super);
	    function BoundCallbackObservable(callbackFunc, selector, args, context, scheduler) {
	        _super.call(this);
	        this.callbackFunc = callbackFunc;
	        this.selector = selector;
	        this.args = args;
	        this.context = context;
	        this.scheduler = scheduler;
	    }
	    /* tslint:enable:max-line-length */
	    /**
	     * Converts a callback API to a function that returns an Observable.
	     *
	     * <span class="informal">Give it a function `f` of type `f(x, callback)` and
	     * it will return a function `g` that when called as `g(x)` will output an
	     * Observable.</span>
	     *
	     * `bindCallback` is not an operator because its input and output are not
	     * Observables. The input is a function `func` with some parameters, the
	     * last parameter must be a callback function that `func` calls when it is
	     * done.
	     *
	     * The output of `bindCallback` is a function that takes the same parameters
	     * as `func`, except the last one (the callback). When the output function
	     * is called with arguments it will return an Observable. If function `func`
	     * calls its callback with one argument the Observable will emit that value.
	     * If on the other hand the callback is called with multiple values the resulting
	     * Observable will emit an array with said values as arguments.
	     *
	     * It is very important to remember that input function `func` is not called
	     * when the output function is, but rather when the Observable returned by the output
	     * function is subscribed. This means if `func` makes an AJAX request, that request
	     * will be made every time someone subscribes to the resulting Observable, but not before.
	     *
	     * Optionally, a selector function can be passed to `bindObservable`. The selector function
	     * takes the same arguments as the callback and returns the value that will be emitted by the Observable.
	     * Even though by default multiple arguments passed to callback appear in the stream as an array
	     * the selector function will be called with arguments directly, just as the callback would.
	     * This means you can imagine the default selector (when one is not provided explicitly)
	     * as a function that aggregates all its arguments into an array, or simply returns first argument
	     * if there is only one.
	     *
	     * The last optional parameter - {@link Scheduler} - can be used to control when the call
	     * to `func` happens after someone subscribes to Observable, as well as when results
	     * passed to callback will be emitted. By default, the subscription to  an Observable calls `func`
	     * synchronously, but using `Scheduler.async` as the last parameter will defer the call to `func`,
	     * just like wrapping the call in `setTimeout` with a timeout of `0` would. If you use the async Scheduler
	     * and call `subscribe` on the output Observable all function calls that are currently executing
	     * will end before `func` is invoked.
	     *
	     * By default results passed to the callback are emitted immediately after `func` invokes the callback.
	     * In particular, if the callback is called synchronously the subscription of the resulting Observable
	     * will call the `next` function synchronously as well.  If you want to defer that call,
	     * you may use `Scheduler.async` just as before.  This means that by using `Scheduler.async` you can
	     * ensure that `func` always calls its callback asynchronously, thus avoiding terrifying Zalgo.
	     *
	     * Note that the Observable created by the output function will always emit a single value
	     * and then complete immediately. If `func` calls the callback multiple times, values from subsequent
	     * calls will not appear in the stream. If you need to listen for multiple calls,
	     *  you probably want to use {@link fromEvent} or {@link fromEventPattern} instead.
	     *
	     * If `func` depends on some context (`this` property) and is not already bound the context of `func`
	     * will be the context that the output function has at call time. In particular, if `func`
	     * is called as a method of some objec and if `func` is not already bound, in order to preserve the context
	     * it is recommended that the context of the output function is set to that object as well.
	     *
	     * If the input function calls its callback in the "node style" (i.e. first argument to callback is
	     * optional error parameter signaling whether the call failed or not), {@link bindNodeCallback}
	     * provides convenient error handling and probably is a better choice.
	     * `bindCallback` will treat such functions the same as any other and error parameters
	     * (whether passed or not) will always be interpreted as regular callback argument.
	     *
	     *
	     * @example <caption>Convert jQuery's getJSON to an Observable API</caption>
	     * // Suppose we have jQuery.getJSON('/my/url', callback)
	     * var getJSONAsObservable = Rx.Observable.bindCallback(jQuery.getJSON);
	     * var result = getJSONAsObservable('/my/url');
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     *
	     * @example <caption>Receive an array of arguments passed to a callback</caption>
	     * someFunction((a, b, c) => {
	     *   console.log(a); // 5
	     *   console.log(b); // 'some string'
	     *   console.log(c); // {someProperty: 'someValue'}
	     * });
	     *
	     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction);
	     * boundSomeFunction().subscribe(values => {
	     *   console.log(values) // [5, 'some string', {someProperty: 'someValue'}]
	     * });
	     *
	     *
	     * @example <caption>Use bindCallback with a selector function</caption>
	     * someFunction((a, b, c) => {
	     *   console.log(a); // 'a'
	     *   console.log(b); // 'b'
	     *   console.log(c); // 'c'
	     * });
	     *
	     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction, (a, b, c) => a + b + c);
	     * boundSomeFunction().subscribe(value => {
	     *   console.log(value) // 'abc'
	     * });
	     *
	     *
	     * @example <caption>Compare behaviour with and without async Scheduler</caption>
	     * function iCallMyCallbackSynchronously(cb) {
	     *   cb();
	     * }
	     *
	     * const boundSyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously);
	     * const boundAsyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously, null, Rx.Scheduler.async);
	     *
	     * boundSyncFn().subscribe(() => console.log('I was sync!'));
	     * boundAsyncFn().subscribe(() => console.log('I was async!'));
	     * console.log('This happened...');
	     *
	     * // Logs:
	     * // I was sync!
	     * // This happened...
	     * // I was async!
	     *
	     *
	     * @example <caption>Use bindCallback on an object method</caption>
	     * const boundMethod = Rx.Observable.bindCallback(someObject.methodWithCallback);
	     * boundMethod.call(someObject) // make sure methodWithCallback has access to someObject
	     * .subscribe(subscriber);
	     *
	     *
	     * @see {@link bindNodeCallback}
	     * @see {@link from}
	     * @see {@link fromPromise}
	     *
	     * @param {function} func A function with a callback as the last parameter.
	     * @param {function} [selector] A function which takes the arguments from the
	     * callback and maps them to a value that is emitted on the output Observable.
	     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
	     * callbacks.
	     * @return {function(...params: *): Observable} A function which returns the
	     * Observable that delivers the same values the callback would deliver.
	     * @static true
	     * @name bindCallback
	     * @owner Observable
	     */
	    BoundCallbackObservable.create = function (func, selector, scheduler) {
	        if (selector === void 0) { selector = undefined; }
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            return new BoundCallbackObservable(func, selector, args, this, scheduler);
	        };
	    };
	    /** @deprecated internal use only */ BoundCallbackObservable.prototype._subscribe = function (subscriber) {
	        var callbackFunc = this.callbackFunc;
	        var args = this.args;
	        var scheduler = this.scheduler;
	        var subject = this.subject;
	        if (!scheduler) {
	            if (!subject) {
	                subject = this.subject = new AsyncSubject_1.AsyncSubject();
	                var handler = function handlerFn() {
	                    var innerArgs = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        innerArgs[_i - 0] = arguments[_i];
	                    }
	                    var source = handlerFn.source;
	                    var selector = source.selector, subject = source.subject;
	                    if (selector) {
	                        var result_1 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
	                        if (result_1 === errorObject_1.errorObject) {
	                            subject.error(errorObject_1.errorObject.e);
	                        }
	                        else {
	                            subject.next(result_1);
	                            subject.complete();
	                        }
	                    }
	                    else {
	                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
	                        subject.complete();
	                    }
	                };
	                // use named function instance to avoid closure.
	                handler.source = this;
	                var result = tryCatch_1.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
	                if (result === errorObject_1.errorObject) {
	                    subject.error(errorObject_1.errorObject.e);
	                }
	            }
	            return subject.subscribe(subscriber);
	        }
	        else {
	            return scheduler.schedule(BoundCallbackObservable.dispatch, 0, { source: this, subscriber: subscriber, context: this.context });
	        }
	    };
	    BoundCallbackObservable.dispatch = function (state) {
	        var self = this;
	        var source = state.source, subscriber = state.subscriber, context = state.context;
	        var callbackFunc = source.callbackFunc, args = source.args, scheduler = source.scheduler;
	        var subject = source.subject;
	        if (!subject) {
	            subject = source.subject = new AsyncSubject_1.AsyncSubject();
	            var handler = function handlerFn() {
	                var innerArgs = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    innerArgs[_i - 0] = arguments[_i];
	                }
	                var source = handlerFn.source;
	                var selector = source.selector, subject = source.subject;
	                if (selector) {
	                    var result_2 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
	                    if (result_2 === errorObject_1.errorObject) {
	                        self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
	                    }
	                    else {
	                        self.add(scheduler.schedule(dispatchNext, 0, { value: result_2, subject: subject }));
	                    }
	                }
	                else {
	                    var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
	                    self.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
	                }
	            };
	            // use named function to pass values in without closure
	            handler.source = source;
	            var result = tryCatch_1.tryCatch(callbackFunc).apply(context, args.concat(handler));
	            if (result === errorObject_1.errorObject) {
	                subject.error(errorObject_1.errorObject.e);
	            }
	        }
	        self.add(subject.subscribe(subscriber));
	    };
	    return BoundCallbackObservable;
	}(Observable_1.Observable));
	exports.BoundCallbackObservable = BoundCallbackObservable;
	function dispatchNext(arg) {
	    var value = arg.value, subject = arg.subject;
	    subject.next(value);
	    subject.complete();
	}
	function dispatchError(arg) {
	    var err = arg.err, subject = arg.subject;
	    subject.error(err);
	}
	//# sourceMappingURL=BoundCallbackObservable.js.map

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(240);
	var Subscription_1 = __webpack_require__(211);
	/**
	 * @class AsyncSubject<T>
	 */
	var AsyncSubject = (function (_super) {
	    __extends(AsyncSubject, _super);
	    function AsyncSubject() {
	        _super.apply(this, arguments);
	        this.value = null;
	        this.hasNext = false;
	        this.hasCompleted = false;
	    }
	    /** @deprecated internal use only */ AsyncSubject.prototype._subscribe = function (subscriber) {
	        if (this.hasError) {
	            subscriber.error(this.thrownError);
	            return Subscription_1.Subscription.EMPTY;
	        }
	        else if (this.hasCompleted && this.hasNext) {
	            subscriber.next(this.value);
	            subscriber.complete();
	            return Subscription_1.Subscription.EMPTY;
	        }
	        return _super.prototype._subscribe.call(this, subscriber);
	    };
	    AsyncSubject.prototype.next = function (value) {
	        if (!this.hasCompleted) {
	            this.value = value;
	            this.hasNext = true;
	        }
	    };
	    AsyncSubject.prototype.error = function (error) {
	        if (!this.hasCompleted) {
	            _super.prototype.error.call(this, error);
	        }
	    };
	    AsyncSubject.prototype.complete = function () {
	        this.hasCompleted = true;
	        if (this.hasNext) {
	            _super.prototype.next.call(this, this.value);
	        }
	        _super.prototype.complete.call(this);
	    };
	    return AsyncSubject;
	}(Subject_1.Subject));
	exports.AsyncSubject = AsyncSubject;
	//# sourceMappingURL=AsyncSubject.js.map

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var bindNodeCallback_1 = __webpack_require__(310);
	Observable_1.Observable.bindNodeCallback = bindNodeCallback_1.bindNodeCallback;
	//# sourceMappingURL=bindNodeCallback.js.map

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var BoundNodeCallbackObservable_1 = __webpack_require__(311);
	exports.bindNodeCallback = BoundNodeCallbackObservable_1.BoundNodeCallbackObservable.create;
	//# sourceMappingURL=bindNodeCallback.js.map

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(206);
	var tryCatch_1 = __webpack_require__(214);
	var errorObject_1 = __webpack_require__(215);
	var AsyncSubject_1 = __webpack_require__(308);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var BoundNodeCallbackObservable = (function (_super) {
	    __extends(BoundNodeCallbackObservable, _super);
	    function BoundNodeCallbackObservable(callbackFunc, selector, args, context, scheduler) {
	        _super.call(this);
	        this.callbackFunc = callbackFunc;
	        this.selector = selector;
	        this.args = args;
	        this.context = context;
	        this.scheduler = scheduler;
	    }
	    /* tslint:enable:max-line-length */
	    /**
	     * Converts a Node.js-style callback API to a function that returns an
	     * Observable.
	     *
	     * <span class="informal">It's just like {@link bindCallback}, but the
	     * callback is expected to be of type `callback(error, result)`.</span>
	     *
	     * `bindNodeCallback` is not an operator because its input and output are not
	     * Observables. The input is a function `func` with some parameters, but the
	     * last parameter must be a callback function that `func` calls when it is
	     * done. The callback function is expected to follow Node.js conventions,
	     * where the first argument to the callback is an error object, signaling
	     * whether call was successful. If that object is passed to callback, it means
	     * something went wrong.
	     *
	     * The output of `bindNodeCallback` is a function that takes the same
	     * parameters as `func`, except the last one (the callback). When the output
	     * function is called with arguments, it will return an Observable.
	     * If `func` calls its callback with error parameter present, Observable will
	     * error with that value as well. If error parameter is not passed, Observable will emit
	     * second parameter. If there are more parameters (third and so on),
	     * Observable will emit an array with all arguments, except first error argument.
	     *
	     * Optionally `bindNodeCallback` accepts selector function, which allows you to
	     * make resulting Observable emit value computed by selector, instead of regular
	     * callback arguments. It works similarly to {@link bindCallback} selector, but
	     * Node.js-style error argument will never be passed to that function.
	     *
	     * Note that `func` will not be called at the same time output function is,
	     * but rather whenever resulting Observable is subscribed. By default call to
	     * `func` will happen synchronously after subscription, but that can be changed
	     * with proper {@link Scheduler} provided as optional third parameter. Scheduler
	     * can also control when values from callback will be emitted by Observable.
	     * To find out more, check out documentation for {@link bindCallback}, where
	     * Scheduler works exactly the same.
	     *
	     * As in {@link bindCallback}, context (`this` property) of input function will be set to context
	     * of returned function, when it is called.
	     *
	     * After Observable emits value, it will complete immediately. This means
	     * even if `func` calls callback again, values from second and consecutive
	     * calls will never appear on the stream. If you need to handle functions
	     * that call callbacks multiple times, check out {@link fromEvent} or
	     * {@link fromEventPattern} instead.
	     *
	     * Note that `bindNodeCallback` can be used in non-Node.js environments as well.
	     * "Node.js-style" callbacks are just a convention, so if you write for
	     * browsers or any other environment and API you use implements that callback style,
	     * `bindNodeCallback` can be safely used on that API functions as well.
	     *
	     * Remember that Error object passed to callback does not have to be an instance
	     * of JavaScript built-in `Error` object. In fact, it does not even have to an object.
	     * Error parameter of callback function is interpreted as "present", when value
	     * of that parameter is truthy. It could be, for example, non-zero number, non-empty
	     * string or boolean `true`. In all of these cases resulting Observable would error
	     * with that value. This means usually regular style callbacks will fail very often when
	     * `bindNodeCallback` is used. If your Observable errors much more often then you
	     * would expect, check if callback really is called in Node.js-style and, if not,
	     * switch to {@link bindCallback} instead.
	     *
	     * Note that even if error parameter is technically present in callback, but its value
	     * is falsy, it still won't appear in array emitted by Observable or in selector function.
	     *
	     *
	     * @example <caption>Read a file from the filesystem and get the data as an Observable</caption>
	     * import * as fs from 'fs';
	     * var readFileAsObservable = Rx.Observable.bindNodeCallback(fs.readFile);
	     * var result = readFileAsObservable('./roadNames.txt', 'utf8');
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     *
	     * @example <caption>Use on function calling callback with multiple arguments</caption>
	     * someFunction((err, a, b) => {
	     *   console.log(err); // null
	     *   console.log(a); // 5
	     *   console.log(b); // "some string"
	     * });
	     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
	     * boundSomeFunction()
	     * .subscribe(value => {
	     *   console.log(value); // [5, "some string"]
	     * });
	     *
	     *
	     * @example <caption>Use with selector function</caption>
	     * someFunction((err, a, b) => {
	     *   console.log(err); // undefined
	     *   console.log(a); // "abc"
	     *   console.log(b); // "DEF"
	     * });
	     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction, (a, b) => a + b);
	     * boundSomeFunction()
	     * .subscribe(value => {
	     *   console.log(value); // "abcDEF"
	     * });
	     *
	     *
	     * @example <caption>Use on function calling callback in regular style</caption>
	     * someFunction(a => {
	     *   console.log(a); // 5
	     * });
	     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
	     * boundSomeFunction()
	     * .subscribe(
	     *   value => {}             // never gets called
	     *   err => console.log(err) // 5
	     *);
	     *
	     *
	     * @see {@link bindCallback}
	     * @see {@link from}
	     * @see {@link fromPromise}
	     *
	     * @param {function} func Function with a Node.js-style callback as the last parameter.
	     * @param {function} [selector] A function which takes the arguments from the
	     * callback and maps those to a value to emit on the output Observable.
	     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
	     * callbacks.
	     * @return {function(...params: *): Observable} A function which returns the
	     * Observable that delivers the same values the Node.js callback would
	     * deliver.
	     * @static true
	     * @name bindNodeCallback
	     * @owner Observable
	     */
	    BoundNodeCallbackObservable.create = function (func, selector, scheduler) {
	        if (selector === void 0) { selector = undefined; }
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            return new BoundNodeCallbackObservable(func, selector, args, this, scheduler);
	        };
	    };
	    /** @deprecated internal use only */ BoundNodeCallbackObservable.prototype._subscribe = function (subscriber) {
	        var callbackFunc = this.callbackFunc;
	        var args = this.args;
	        var scheduler = this.scheduler;
	        var subject = this.subject;
	        if (!scheduler) {
	            if (!subject) {
	                subject = this.subject = new AsyncSubject_1.AsyncSubject();
	                var handler = function handlerFn() {
	                    var innerArgs = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        innerArgs[_i - 0] = arguments[_i];
	                    }
	                    var source = handlerFn.source;
	                    var selector = source.selector, subject = source.subject;
	                    var err = innerArgs.shift();
	                    if (err) {
	                        subject.error(err);
	                    }
	                    else if (selector) {
	                        var result_1 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
	                        if (result_1 === errorObject_1.errorObject) {
	                            subject.error(errorObject_1.errorObject.e);
	                        }
	                        else {
	                            subject.next(result_1);
	                            subject.complete();
	                        }
	                    }
	                    else {
	                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
	                        subject.complete();
	                    }
	                };
	                // use named function instance to avoid closure.
	                handler.source = this;
	                var result = tryCatch_1.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
	                if (result === errorObject_1.errorObject) {
	                    subject.error(errorObject_1.errorObject.e);
	                }
	            }
	            return subject.subscribe(subscriber);
	        }
	        else {
	            return scheduler.schedule(dispatch, 0, { source: this, subscriber: subscriber, context: this.context });
	        }
	    };
	    return BoundNodeCallbackObservable;
	}(Observable_1.Observable));
	exports.BoundNodeCallbackObservable = BoundNodeCallbackObservable;
	function dispatch(state) {
	    var self = this;
	    var source = state.source, subscriber = state.subscriber, context = state.context;
	    // XXX: cast to `any` to access to the private field in `source`.
	    var _a = source, callbackFunc = _a.callbackFunc, args = _a.args, scheduler = _a.scheduler;
	    var subject = source.subject;
	    if (!subject) {
	        subject = source.subject = new AsyncSubject_1.AsyncSubject();
	        var handler = function handlerFn() {
	            var innerArgs = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                innerArgs[_i - 0] = arguments[_i];
	            }
	            var source = handlerFn.source;
	            var selector = source.selector, subject = source.subject;
	            var err = innerArgs.shift();
	            if (err) {
	                self.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
	            }
	            else if (selector) {
	                var result_2 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
	                if (result_2 === errorObject_1.errorObject) {
	                    self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
	                }
	                else {
	                    self.add(scheduler.schedule(dispatchNext, 0, { value: result_2, subject: subject }));
	                }
	            }
	            else {
	                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
	                self.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
	            }
	        };
	        // use named function to pass values in without closure
	        handler.source = source;
	        var result = tryCatch_1.tryCatch(callbackFunc).apply(context, args.concat(handler));
	        if (result === errorObject_1.errorObject) {
	            self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
	        }
	    }
	    self.add(subject.subscribe(subscriber));
	}
	function dispatchNext(arg) {
	    var value = arg.value, subject = arg.subject;
	    subject.next(value);
	    subject.complete();
	}
	function dispatchError(arg) {
	    var err = arg.err, subject = arg.subject;
	    subject.error(err);
	}
	//# sourceMappingURL=BoundNodeCallbackObservable.js.map

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var combineLatest_1 = __webpack_require__(313);
	Observable_1.Observable.combineLatest = combineLatest_1.combineLatest;
	//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var isScheduler_1 = __webpack_require__(226);
	var isArray_1 = __webpack_require__(212);
	var ArrayObservable_1 = __webpack_require__(223);
	var combineLatest_1 = __webpack_require__(314);
	/* tslint:enable:max-line-length */
	/**
	 * Combines multiple Observables to create an Observable whose values are
	 * calculated from the latest values of each of its input Observables.
	 *
	 * <span class="informal">Whenever any input Observable emits a value, it
	 * computes a formula using the latest values from all the inputs, then emits
	 * the output of that formula.</span>
	 *
	 * <img src="./img/combineLatest.png" width="100%">
	 *
	 * `combineLatest` combines the values from all the Observables passed as
	 * arguments. This is done by subscribing to each Observable in order and,
	 * whenever any Observable emits, collecting an array of the most recent
	 * values from each Observable. So if you pass `n` Observables to operator,
	 * returned Observable will always emit an array of `n` values, in order
	 * corresponding to order of passed Observables (value from the first Observable
	 * on the first place and so on).
	 *
	 * Static version of `combineLatest` accepts either an array of Observables
	 * or each Observable can be put directly as an argument. Note that array of
	 * Observables is good choice, if you don't know beforehand how many Observables
	 * you will combine. Passing empty array will result in Observable that
	 * completes immediately.
	 *
	 * To ensure output array has always the same length, `combineLatest` will
	 * actually wait for all input Observables to emit at least once,
	 * before it starts emitting results. This means if some Observable emits
	 * values before other Observables started emitting, all that values but last
	 * will be lost. On the other hand, is some Observable does not emit value but
	 * completes, resulting Observable will complete at the same moment without
	 * emitting anything, since it will be now impossible to include value from
	 * completed Observable in resulting array. Also, if some input Observable does
	 * not emit any value and never completes, `combineLatest` will also never emit
	 * and never complete, since, again, it will wait for all streams to emit some
	 * value.
	 *
	 * If at least one Observable was passed to `combineLatest` and all passed Observables
	 * emitted something, resulting Observable will complete when all combined
	 * streams complete. So even if some Observable completes, result of
	 * `combineLatest` will still emit values when other Observables do. In case
	 * of completed Observable, its value from now on will always be the last
	 * emitted value. On the other hand, if any Observable errors, `combineLatest`
	 * will error immediately as well, and all other Observables will be unsubscribed.
	 *
	 * `combineLatest` accepts as optional parameter `project` function, which takes
	 * as arguments all values that would normally be emitted by resulting Observable.
	 * `project` can return any kind of value, which will be then emitted by Observable
	 * instead of default array. Note that `project` does not take as argument that array
	 * of values, but values themselves. That means default `project` can be imagined
	 * as function that takes all its arguments and puts them into an array.
	 *
	 *
	 * @example <caption>Combine two timer Observables</caption>
	 * const firstTimer = Rx.Observable.timer(0, 1000); // emit 0, 1, 2... after every second, starting from now
	 * const secondTimer = Rx.Observable.timer(500, 1000); // emit 0, 1, 2... after every second, starting 0,5s from now
	 * const combinedTimers = Rx.Observable.combineLatest(firstTimer, secondTimer);
	 * combinedTimers.subscribe(value => console.log(value));
	 * // Logs
	 * // [0, 0] after 0.5s
	 * // [1, 0] after 1s
	 * // [1, 1] after 1.5s
	 * // [2, 1] after 2s
	 *
	 *
	 * @example <caption>Combine an array of Observables</caption>
	 * const observables = [1, 5, 10].map(
	 *   n => Rx.Observable.of(n).delay(n * 1000).startWith(0) // emit 0 and then emit n after n seconds
	 * );
	 * const combined = Rx.Observable.combineLatest(observables);
	 * combined.subscribe(value => console.log(value));
	 * // Logs
	 * // [0, 0, 0] immediately
	 * // [1, 0, 0] after 1s
	 * // [1, 5, 0] after 5s
	 * // [1, 5, 10] after 10s
	 *
	 *
	 * @example <caption>Use project function to dynamically calculate the Body-Mass Index</caption>
	 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
	 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
	 * var bmi = Rx.Observable.combineLatest(weight, height, (w, h) => w / (h * h));
	 * bmi.subscribe(x => console.log('BMI is ' + x));
	 *
	 * // With output to console:
	 * // BMI is 24.212293388429753
	 * // BMI is 23.93948099205209
	 * // BMI is 23.671253629592222
	 *
	 *
	 * @see {@link combineAll}
	 * @see {@link merge}
	 * @see {@link withLatestFrom}
	 *
	 * @param {ObservableInput} observable1 An input Observable to combine with other Observables.
	 * @param {ObservableInput} observable2 An input Observable to combine with other Observables.
	 * More than one input Observables may be given as arguments
	 * or an array of Observables may be given as the first argument.
	 * @param {function} [project] An optional function to project the values from
	 * the combined latest values into a new value on the output Observable.
	 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
	 * each input Observable.
	 * @return {Observable} An Observable of projected values from the most recent
	 * values from each input Observable, or an array of the most recent values from
	 * each input Observable.
	 * @static true
	 * @name combineLatest
	 * @owner Observable
	 */
	function combineLatest() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    var project = null;
	    var scheduler = null;
	    if (isScheduler_1.isScheduler(observables[observables.length - 1])) {
	        scheduler = observables.pop();
	    }
	    if (typeof observables[observables.length - 1] === 'function') {
	        project = observables.pop();
	    }
	    // if the first and only other argument besides the resultSelector is an array
	    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
	    if (observables.length === 1 && isArray_1.isArray(observables[0])) {
	        observables = observables[0];
	    }
	    return new ArrayObservable_1.ArrayObservable(observables, scheduler).lift(new combineLatest_1.CombineLatestOperator(project));
	}
	exports.combineLatest = combineLatest;
	//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ArrayObservable_1 = __webpack_require__(223);
	var isArray_1 = __webpack_require__(212);
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	var none = {};
	/* tslint:enable:max-line-length */
	/**
	 * Combines multiple Observables to create an Observable whose values are
	 * calculated from the latest values of each of its input Observables.
	 *
	 * <span class="informal">Whenever any input Observable emits a value, it
	 * computes a formula using the latest values from all the inputs, then emits
	 * the output of that formula.</span>
	 *
	 * <img src="./img/combineLatest.png" width="100%">
	 *
	 * `combineLatest` combines the values from this Observable with values from
	 * Observables passed as arguments. This is done by subscribing to each
	 * Observable, in order, and collecting an array of each of the most recent
	 * values any time any of the input Observables emits, then either taking that
	 * array and passing it as arguments to an optional `project` function and
	 * emitting the return value of that, or just emitting the array of recent
	 * values directly if there is no `project` function.
	 *
	 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
	 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
	 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
	 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
	 * bmi.subscribe(x => console.log('BMI is ' + x));
	 *
	 * // With output to console:
	 * // BMI is 24.212293388429753
	 * // BMI is 23.93948099205209
	 * // BMI is 23.671253629592222
	 *
	 * @see {@link combineAll}
	 * @see {@link merge}
	 * @see {@link withLatestFrom}
	 *
	 * @param {ObservableInput} other An input Observable to combine with the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {function} [project] An optional function to project the values from
	 * the combined latest values into a new value on the output Observable.
	 * @return {Observable} An Observable of projected values from the most recent
	 * values from each input Observable, or an array of the most recent values from
	 * each input Observable.
	 * @method combineLatest
	 * @owner Observable
	 */
	function combineLatest() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    var project = null;
	    if (typeof observables[observables.length - 1] === 'function') {
	        project = observables.pop();
	    }
	    // if the first and only other argument besides the resultSelector is an array
	    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
	    if (observables.length === 1 && isArray_1.isArray(observables[0])) {
	        observables = observables[0].slice();
	    }
	    return function (source) { return source.lift.call(new ArrayObservable_1.ArrayObservable([source].concat(observables)), new CombineLatestOperator(project)); };
	}
	exports.combineLatest = combineLatest;
	var CombineLatestOperator = (function () {
	    function CombineLatestOperator(project) {
	        this.project = project;
	    }
	    CombineLatestOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new CombineLatestSubscriber(subscriber, this.project));
	    };
	    return CombineLatestOperator;
	}());
	exports.CombineLatestOperator = CombineLatestOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var CombineLatestSubscriber = (function (_super) {
	    __extends(CombineLatestSubscriber, _super);
	    function CombineLatestSubscriber(destination, project) {
	        _super.call(this, destination);
	        this.project = project;
	        this.active = 0;
	        this.values = [];
	        this.observables = [];
	    }
	    CombineLatestSubscriber.prototype._next = function (observable) {
	        this.values.push(none);
	        this.observables.push(observable);
	    };
	    CombineLatestSubscriber.prototype._complete = function () {
	        var observables = this.observables;
	        var len = observables.length;
	        if (len === 0) {
	            this.destination.complete();
	        }
	        else {
	            this.active = len;
	            this.toRespond = len;
	            for (var i = 0; i < len; i++) {
	                var observable = observables[i];
	                this.add(subscribeToResult_1.subscribeToResult(this, observable, observable, i));
	            }
	        }
	    };
	    CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
	        if ((this.active -= 1) === 0) {
	            this.destination.complete();
	        }
	    };
	    CombineLatestSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var values = this.values;
	        var oldVal = values[outerIndex];
	        var toRespond = !this.toRespond
	            ? 0
	            : oldVal === none ? --this.toRespond : this.toRespond;
	        values[outerIndex] = innerValue;
	        if (toRespond === 0) {
	            if (this.project) {
	                this._tryProject(values);
	            }
	            else {
	                this.destination.next(values.slice());
	            }
	        }
	    };
	    CombineLatestSubscriber.prototype._tryProject = function (values) {
	        var result;
	        try {
	            result = this.project.apply(this, values);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return CombineLatestSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.CombineLatestSubscriber = CombineLatestSubscriber;
	//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var concat_1 = __webpack_require__(316);
	Observable_1.Observable.concat = concat_1.concat;
	//# sourceMappingURL=concat.js.map

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var isScheduler_1 = __webpack_require__(226);
	var of_1 = __webpack_require__(253);
	var from_1 = __webpack_require__(276);
	var concatAll_1 = __webpack_require__(286);
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which sequentially emits all values from given
	 * Observable and then moves on to the next.
	 *
	 * <span class="informal">Concatenates multiple Observables together by
	 * sequentially emitting their values, one Observable after the other.</span>
	 *
	 * <img src="./img/concat.png" width="100%">
	 *
	 * `concat` joins multiple Observables together, by subscribing to them one at a time and
	 * merging their results into the output Observable. You can pass either an array of
	 * Observables, or put them directly as arguments. Passing an empty array will result
	 * in Observable that completes immediately.
	 *
	 * `concat` will subscribe to first input Observable and emit all its values, without
	 * changing or affecting them in any way. When that Observable completes, it will
	 * subscribe to then next Observable passed and, again, emit its values. This will be
	 * repeated, until the operator runs out of Observables. When last input Observable completes,
	 * `concat` will complete as well. At any given moment only one Observable passed to operator
	 * emits values. If you would like to emit values from passed Observables concurrently, check out
	 * {@link merge} instead, especially with optional `concurrent` parameter. As a matter of fact,
	 * `concat` is an equivalent of `merge` operator with `concurrent` parameter set to `1`.
	 *
	 * Note that if some input Observable never completes, `concat` will also never complete
	 * and Observables following the one that did not complete will never be subscribed. On the other
	 * hand, if some Observable simply completes immediately after it is subscribed, it will be
	 * invisible for `concat`, which will just move on to the next Observable.
	 *
	 * If any Observable in chain errors, instead of passing control to the next Observable,
	 * `concat` will error immediately as well. Observables that would be subscribed after
	 * the one that emitted error, never will.
	 *
	 * If you pass to `concat` the same Observable many times, its stream of values
	 * will be "replayed" on every subscription, which means you can repeat given Observable
	 * as many times as you like. If passing the same Observable to `concat` 1000 times becomes tedious,
	 * you can always use {@link repeat}.
	 *
	 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
	 * var timer = Rx.Observable.interval(1000).take(4);
	 * var sequence = Rx.Observable.range(1, 10);
	 * var result = Rx.Observable.concat(timer, sequence);
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in:
	 * // 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
	 *
	 *
	 * @example <caption>Concatenate an array of 3 Observables</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var result = Rx.Observable.concat([timer1, timer2, timer3]); // note that array is passed
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in the following:
	 * // (Prints to console sequentially)
	 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
	 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
	 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
	 *
	 *
	 * @example <caption>Concatenate the same Observable to repeat it</caption>
	 * const timer = Rx.Observable.interval(1000).take(2);
	 *
	 * Rx.Observable.concat(timer, timer) // concating the same Observable!
	 * .subscribe(
	 *   value => console.log(value),
	 *   err => {},
	 *   () => console.log('...and it is done!')
	 * );
	 *
	 * // Logs:
	 * // 0 after 1s
	 * // 1 after 2s
	 * // 0 after 3s
	 * // 1 after 4s
	 * // "...and it is done!" also after 4s
	 *
	 * @see {@link concatAll}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 *
	 * @param {ObservableInput} input1 An input Observable to concatenate with others.
	 * @param {ObservableInput} input2 An input Observable to concatenate with others.
	 * More than one input Observables may be given as argument.
	 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
	 * Observable subscription on.
	 * @return {Observable} All values of each passed Observable merged into a
	 * single Observable, in order, in serial fashion.
	 * @static true
	 * @name concat
	 * @owner Observable
	 */
	function concat() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    if (observables.length === 1 || (observables.length === 2 && isScheduler_1.isScheduler(observables[1]))) {
	        return from_1.from(observables[0]);
	    }
	    return concatAll_1.concatAll()(of_1.of.apply(void 0, observables));
	}
	exports.concat = concat;
	//# sourceMappingURL=concat.js.map

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var defer_1 = __webpack_require__(318);
	Observable_1.Observable.defer = defer_1.defer;
	//# sourceMappingURL=defer.js.map

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var DeferObservable_1 = __webpack_require__(319);
	exports.defer = DeferObservable_1.DeferObservable.create;
	//# sourceMappingURL=defer.js.map

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(206);
	var subscribeToResult_1 = __webpack_require__(229);
	var OuterSubscriber_1 = __webpack_require__(234);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var DeferObservable = (function (_super) {
	    __extends(DeferObservable, _super);
	    function DeferObservable(observableFactory) {
	        _super.call(this);
	        this.observableFactory = observableFactory;
	    }
	    /**
	     * Creates an Observable that, on subscribe, calls an Observable factory to
	     * make an Observable for each new Observer.
	     *
	     * <span class="informal">Creates the Observable lazily, that is, only when it
	     * is subscribed.
	     * </span>
	     *
	     * <img src="./img/defer.png" width="100%">
	     *
	     * `defer` allows you to create the Observable only when the Observer
	     * subscribes, and create a fresh Observable for each Observer. It waits until
	     * an Observer subscribes to it, and then it generates an Observable,
	     * typically with an Observable factory function. It does this afresh for each
	     * subscriber, so although each subscriber may think it is subscribing to the
	     * same Observable, in fact each subscriber gets its own individual
	     * Observable.
	     *
	     * @example <caption>Subscribe to either an Observable of clicks or an Observable of interval, at random</caption>
	     * var clicksOrInterval = Rx.Observable.defer(function () {
	     *   if (Math.random() > 0.5) {
	     *     return Rx.Observable.fromEvent(document, 'click');
	     *   } else {
	     *     return Rx.Observable.interval(1000);
	     *   }
	     * });
	     * clicksOrInterval.subscribe(x => console.log(x));
	     *
	     * // Results in the following behavior:
	     * // If the result of Math.random() is greater than 0.5 it will listen
	     * // for clicks anywhere on the "document"; when document is clicked it
	     * // will log a MouseEvent object to the console. If the result is less
	     * // than 0.5 it will emit ascending numbers, one every second(1000ms).
	     *
	     * @see {@link create}
	     *
	     * @param {function(): SubscribableOrPromise} observableFactory The Observable
	     * factory function to invoke for each Observer that subscribes to the output
	     * Observable. May also return a Promise, which will be converted on the fly
	     * to an Observable.
	     * @return {Observable} An Observable whose Observers' subscriptions trigger
	     * an invocation of the given Observable factory function.
	     * @static true
	     * @name defer
	     * @owner Observable
	     */
	    DeferObservable.create = function (observableFactory) {
	        return new DeferObservable(observableFactory);
	    };
	    /** @deprecated internal use only */ DeferObservable.prototype._subscribe = function (subscriber) {
	        return new DeferSubscriber(subscriber, this.observableFactory);
	    };
	    return DeferObservable;
	}(Observable_1.Observable));
	exports.DeferObservable = DeferObservable;
	var DeferSubscriber = (function (_super) {
	    __extends(DeferSubscriber, _super);
	    function DeferSubscriber(destination, factory) {
	        _super.call(this, destination);
	        this.factory = factory;
	        this.tryDefer();
	    }
	    DeferSubscriber.prototype.tryDefer = function () {
	        try {
	            this._callFactory();
	        }
	        catch (err) {
	            this._error(err);
	        }
	    };
	    DeferSubscriber.prototype._callFactory = function () {
	        var result = this.factory();
	        if (result) {
	            this.add(subscribeToResult_1.subscribeToResult(this, result));
	        }
	    };
	    return DeferSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=DeferObservable.js.map

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var empty_1 = __webpack_require__(321);
	Observable_1.Observable.empty = empty_1.empty;
	//# sourceMappingURL=empty.js.map

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var EmptyObservable_1 = __webpack_require__(225);
	exports.empty = EmptyObservable_1.EmptyObservable.create;
	//# sourceMappingURL=empty.js.map

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var forkJoin_1 = __webpack_require__(323);
	Observable_1.Observable.forkJoin = forkJoin_1.forkJoin;
	//# sourceMappingURL=forkJoin.js.map

/***/ }),
/* 323 */,
/* 324 */,
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var from_1 = __webpack_require__(276);
	Observable_1.Observable.from = from_1.from;
	//# sourceMappingURL=from.js.map

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var fromEvent_1 = __webpack_require__(327);
	Observable_1.Observable.fromEvent = fromEvent_1.fromEvent;
	//# sourceMappingURL=fromEvent.js.map

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var FromEventObservable_1 = __webpack_require__(328);
	exports.fromEvent = FromEventObservable_1.FromEventObservable.create;
	//# sourceMappingURL=fromEvent.js.map

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(206);
	var tryCatch_1 = __webpack_require__(214);
	var isFunction_1 = __webpack_require__(210);
	var errorObject_1 = __webpack_require__(215);
	var Subscription_1 = __webpack_require__(211);
	var toString = Object.prototype.toString;
	function isNodeStyleEventEmitter(sourceObj) {
	    return !!sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
	}
	function isJQueryStyleEventEmitter(sourceObj) {
	    return !!sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
	}
	function isNodeList(sourceObj) {
	    return !!sourceObj && toString.call(sourceObj) === '[object NodeList]';
	}
	function isHTMLCollection(sourceObj) {
	    return !!sourceObj && toString.call(sourceObj) === '[object HTMLCollection]';
	}
	function isEventTarget(sourceObj) {
	    return !!sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
	}
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var FromEventObservable = (function (_super) {
	    __extends(FromEventObservable, _super);
	    function FromEventObservable(sourceObj, eventName, selector, options) {
	        _super.call(this);
	        this.sourceObj = sourceObj;
	        this.eventName = eventName;
	        this.selector = selector;
	        this.options = options;
	    }
	    /* tslint:enable:max-line-length */
	    /**
	     * Creates an Observable that emits events of a specific type coming from the
	     * given event target.
	     *
	     * <span class="informal">Creates an Observable from DOM events, or Node.js
	     * EventEmitter events or others.</span>
	     *
	     * <img src="./img/fromEvent.png" width="100%">
	     *
	     * `fromEvent` accepts as a first argument event target, which is an object with methods
	     * for registering event handler functions. As a second argument it takes string that indicates
	     * type of event we want to listen for. `fromEvent` supports selected types of event targets,
	     * which are described in detail below. If your event target does not match any of the ones listed,
	     * you should use {@link fromEventPattern}, which can be used on arbitrary APIs.
	     * When it comes to APIs supported by `fromEvent`, their methods for adding and removing event
	     * handler functions have different names, but they all accept a string describing event type
	     * and function itself, which will be called whenever said event happens.
	     *
	     * Every time resulting Observable is subscribed, event handler function will be registered
	     * to event target on given event type. When that event fires, value
	     * passed as a first argument to registered function will be emitted by output Observable.
	     * When Observable is unsubscribed, function will be unregistered from event target.
	     *
	     * Note that if event target calls registered function with more than one argument, second
	     * and following arguments will not appear in resulting stream. In order to get access to them,
	     * you can pass to `fromEvent` optional project function, which will be called with all arguments
	     * passed to event handler. Output Observable will then emit value returned by project function,
	     * instead of the usual value.
	     *
	     * Remember that event targets listed below are checked via duck typing. It means that
	     * no matter what kind of object you have and no matter what environment you work in,
	     * you can safely use `fromEvent` on that object if it exposes described methods (provided
	     * of course they behave as was described above). So for example if Node.js library exposes
	     * event target which has the same method names as DOM EventTarget, `fromEvent` is still
	     * a good choice.
	     *
	     * If the API you use is more callback then event handler oriented (subscribed
	     * callback function fires only once and thus there is no need to manually
	     * unregister it), you should use {@link bindCallback} or {@link bindNodeCallback}
	     * instead.
	     *
	     * `fromEvent` supports following types of event targets:
	     *
	     * **DOM EventTarget**
	     *
	     * This is an object with `addEventListener` and `removeEventListener` methods.
	     *
	     * In the browser, `addEventListener` accepts - apart from event type string and event
	     * handler function arguments - optional third parameter, which is either an object or boolean,
	     * both used for additional configuration how and when passed function will be called. When
	     * `fromEvent` is used with event target of that type, you can provide this values
	     * as third parameter as well.
	     *
	     * **Node.js EventEmitter**
	     *
	     * An object with `addListener` and `removeListener` methods.
	     *
	     * **JQuery-style event target**
	     *
	     * An object with `on` and `off` methods
	     *
	     * **DOM NodeList**
	     *
	     * List of DOM Nodes, returned for example by `document.querySelectorAll` or `Node.childNodes`.
	     *
	     * Although this collection is not event target in itself, `fromEvent` will iterate over all Nodes
	     * it contains and install event handler function in every of them. When returned Observable
	     * is unsubscribed, function will be removed from all Nodes.
	     *
	     * **DOM HtmlCollection**
	     *
	     * Just as in case of NodeList it is a collection of DOM nodes. Here as well event handler function is
	     * installed and removed in each of elements.
	     *
	     *
	     * @example <caption>Emits clicks happening on the DOM document</caption>
	     * var clicks = Rx.Observable.fromEvent(document, 'click');
	     * clicks.subscribe(x => console.log(x));
	     *
	     * // Results in:
	     * // MouseEvent object logged to console every time a click
	     * // occurs on the document.
	     *
	     *
	     * @example <caption>Use addEventListener with capture option</caption>
	     * var clicksInDocument = Rx.Observable.fromEvent(document, 'click', true); // note optional configuration parameter
	     *                                                                          // which will be passed to addEventListener
	     * var clicksInDiv = Rx.Observable.fromEvent(someDivInDocument, 'click');
	     *
	     * clicksInDocument.subscribe(() => console.log('document'));
	     * clicksInDiv.subscribe(() => console.log('div'));
	     *
	     * // By default events bubble UP in DOM tree, so normally
	     * // when we would click on div in document
	     * // "div" would be logged first and then "document".
	     * // Since we specified optional `capture` option, document
	     * // will catch event when it goes DOWN DOM tree, so console
	     * // will log "document" and then "div".
	     *
	     * @see {@link bindCallback}
	     * @see {@link bindNodeCallback}
	     * @see {@link fromEventPattern}
	     *
	     * @param {EventTargetLike} target The DOM EventTarget, Node.js
	     * EventEmitter, JQuery-like event target, NodeList or HTMLCollection to attach the event handler to.
	     * @param {string} eventName The event name of interest, being emitted by the
	     * `target`.
	     * @param {EventListenerOptions} [options] Options to pass through to addEventListener
	     * @param {SelectorMethodSignature<T>} [selector] An optional function to
	     * post-process results. It takes the arguments from the event handler and
	     * should return a single value.
	     * @return {Observable<T>}
	     * @static true
	     * @name fromEvent
	     * @owner Observable
	     */
	    FromEventObservable.create = function (target, eventName, options, selector) {
	        if (isFunction_1.isFunction(options)) {
	            selector = options;
	            options = undefined;
	        }
	        return new FromEventObservable(target, eventName, selector, options);
	    };
	    FromEventObservable.setupSubscription = function (sourceObj, eventName, handler, subscriber, options) {
	        var unsubscribe;
	        if (isNodeList(sourceObj) || isHTMLCollection(sourceObj)) {
	            for (var i = 0, len = sourceObj.length; i < len; i++) {
	                FromEventObservable.setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
	            }
	        }
	        else if (isEventTarget(sourceObj)) {
	            var source_1 = sourceObj;
	            sourceObj.addEventListener(eventName, handler, options);
	            unsubscribe = function () { return source_1.removeEventListener(eventName, handler, options); };
	        }
	        else if (isJQueryStyleEventEmitter(sourceObj)) {
	            var source_2 = sourceObj;
	            sourceObj.on(eventName, handler);
	            unsubscribe = function () { return source_2.off(eventName, handler); };
	        }
	        else if (isNodeStyleEventEmitter(sourceObj)) {
	            var source_3 = sourceObj;
	            sourceObj.addListener(eventName, handler);
	            unsubscribe = function () { return source_3.removeListener(eventName, handler); };
	        }
	        else {
	            throw new TypeError('Invalid event target');
	        }
	        subscriber.add(new Subscription_1.Subscription(unsubscribe));
	    };
	    /** @deprecated internal use only */ FromEventObservable.prototype._subscribe = function (subscriber) {
	        var sourceObj = this.sourceObj;
	        var eventName = this.eventName;
	        var options = this.options;
	        var selector = this.selector;
	        var handler = selector ? function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            var result = tryCatch_1.tryCatch(selector).apply(void 0, args);
	            if (result === errorObject_1.errorObject) {
	                subscriber.error(errorObject_1.errorObject.e);
	            }
	            else {
	                subscriber.next(result);
	            }
	        } : function (e) { return subscriber.next(e); };
	        FromEventObservable.setupSubscription(sourceObj, eventName, handler, subscriber, options);
	    };
	    return FromEventObservable;
	}(Observable_1.Observable));
	exports.FromEventObservable = FromEventObservable;
	//# sourceMappingURL=FromEventObservable.js.map

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var fromEventPattern_1 = __webpack_require__(330);
	Observable_1.Observable.fromEventPattern = fromEventPattern_1.fromEventPattern;
	//# sourceMappingURL=fromEventPattern.js.map

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var FromEventPatternObservable_1 = __webpack_require__(331);
	exports.fromEventPattern = FromEventPatternObservable_1.FromEventPatternObservable.create;
	//# sourceMappingURL=fromEventPattern.js.map

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isFunction_1 = __webpack_require__(210);
	var Observable_1 = __webpack_require__(206);
	var Subscription_1 = __webpack_require__(211);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var FromEventPatternObservable = (function (_super) {
	    __extends(FromEventPatternObservable, _super);
	    function FromEventPatternObservable(addHandler, removeHandler, selector) {
	        _super.call(this);
	        this.addHandler = addHandler;
	        this.removeHandler = removeHandler;
	        this.selector = selector;
	    }
	    /**
	     * Creates an Observable from an API based on addHandler/removeHandler
	     * functions.
	     *
	     * <span class="informal">Converts any addHandler/removeHandler API to an
	     * Observable.</span>
	     *
	     * <img src="./img/fromEventPattern.png" width="100%">
	     *
	     * Creates an Observable by using the `addHandler` and `removeHandler`
	     * functions to add and remove the handlers, with an optional selector
	     * function to project the event arguments to a result. The `addHandler` is
	     * called when the output Observable is subscribed, and `removeHandler` is
	     * called when the Subscription is unsubscribed.
	     *
	     * @example <caption>Emits clicks happening on the DOM document</caption>
	     * function addClickHandler(handler) {
	     *   document.addEventListener('click', handler);
	     * }
	     *
	     * function removeClickHandler(handler) {
	     *   document.removeEventListener('click', handler);
	     * }
	     *
	     * var clicks = Rx.Observable.fromEventPattern(
	     *   addClickHandler,
	     *   removeClickHandler
	     * );
	     * clicks.subscribe(x => console.log(x));
	     *
	     * @see {@link from}
	     * @see {@link fromEvent}
	     *
	     * @param {function(handler: Function): any} addHandler A function that takes
	     * a `handler` function as argument and attaches it somehow to the actual
	     * source of events.
	     * @param {function(handler: Function, signal?: any): void} [removeHandler] An optional function that
	     * takes a `handler` function as argument and removes it in case it was
	     * previously attached using `addHandler`. if addHandler returns signal to teardown when remove,
	     * removeHandler function will forward it.
	     * @param {function(...args: any): T} [selector] An optional function to
	     * post-process results. It takes the arguments from the event handler and
	     * should return a single value.
	     * @return {Observable<T>}
	     * @static true
	     * @name fromEventPattern
	     * @owner Observable
	     */
	    FromEventPatternObservable.create = function (addHandler, removeHandler, selector) {
	        return new FromEventPatternObservable(addHandler, removeHandler, selector);
	    };
	    /** @deprecated internal use only */ FromEventPatternObservable.prototype._subscribe = function (subscriber) {
	        var _this = this;
	        var removeHandler = this.removeHandler;
	        var handler = !!this.selector ? function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            _this._callSelector(subscriber, args);
	        } : function (e) { subscriber.next(e); };
	        var retValue = this._callAddHandler(handler, subscriber);
	        if (!isFunction_1.isFunction(removeHandler)) {
	            return;
	        }
	        subscriber.add(new Subscription_1.Subscription(function () {
	            //TODO: determine whether or not to forward to error handler
	            removeHandler(handler, retValue);
	        }));
	    };
	    FromEventPatternObservable.prototype._callSelector = function (subscriber, args) {
	        try {
	            var result = this.selector.apply(this, args);
	            subscriber.next(result);
	        }
	        catch (e) {
	            subscriber.error(e);
	        }
	    };
	    FromEventPatternObservable.prototype._callAddHandler = function (handler, errorSubscriber) {
	        try {
	            return this.addHandler(handler) || null;
	        }
	        catch (e) {
	            errorSubscriber.error(e);
	        }
	    };
	    return FromEventPatternObservable;
	}(Observable_1.Observable));
	exports.FromEventPatternObservable = FromEventPatternObservable;
	//# sourceMappingURL=FromEventPatternObservable.js.map

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var fromPromise_1 = __webpack_require__(290);
	Observable_1.Observable.fromPromise = fromPromise_1.fromPromise;
	//# sourceMappingURL=fromPromise.js.map

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var generate_1 = __webpack_require__(334);
	Observable_1.Observable.generate = generate_1.generate;
	//# sourceMappingURL=generate.js.map

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var GenerateObservable_1 = __webpack_require__(335);
	exports.generate = GenerateObservable_1.GenerateObservable.create;
	//# sourceMappingURL=generate.js.map

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(206);
	var isScheduler_1 = __webpack_require__(226);
	var selfSelector = function (value) { return value; };
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var GenerateObservable = (function (_super) {
	    __extends(GenerateObservable, _super);
	    function GenerateObservable(initialState, condition, iterate, resultSelector, scheduler) {
	        _super.call(this);
	        this.initialState = initialState;
	        this.condition = condition;
	        this.iterate = iterate;
	        this.resultSelector = resultSelector;
	        this.scheduler = scheduler;
	    }
	    GenerateObservable.create = function (initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
	        if (arguments.length == 1) {
	            return new GenerateObservable(initialStateOrOptions.initialState, initialStateOrOptions.condition, initialStateOrOptions.iterate, initialStateOrOptions.resultSelector || selfSelector, initialStateOrOptions.scheduler);
	        }
	        if (resultSelectorOrObservable === undefined || isScheduler_1.isScheduler(resultSelectorOrObservable)) {
	            return new GenerateObservable(initialStateOrOptions, condition, iterate, selfSelector, resultSelectorOrObservable);
	        }
	        return new GenerateObservable(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler);
	    };
	    /** @deprecated internal use only */ GenerateObservable.prototype._subscribe = function (subscriber) {
	        var state = this.initialState;
	        if (this.scheduler) {
	            return this.scheduler.schedule(GenerateObservable.dispatch, 0, {
	                subscriber: subscriber,
	                iterate: this.iterate,
	                condition: this.condition,
	                resultSelector: this.resultSelector,
	                state: state });
	        }
	        var _a = this, condition = _a.condition, resultSelector = _a.resultSelector, iterate = _a.iterate;
	        do {
	            if (condition) {
	                var conditionResult = void 0;
	                try {
	                    conditionResult = condition(state);
	                }
	                catch (err) {
	                    subscriber.error(err);
	                    return;
	                }
	                if (!conditionResult) {
	                    subscriber.complete();
	                    break;
	                }
	            }
	            var value = void 0;
	            try {
	                value = resultSelector(state);
	            }
	            catch (err) {
	                subscriber.error(err);
	                return;
	            }
	            subscriber.next(value);
	            if (subscriber.closed) {
	                break;
	            }
	            try {
	                state = iterate(state);
	            }
	            catch (err) {
	                subscriber.error(err);
	                return;
	            }
	        } while (true);
	    };
	    GenerateObservable.dispatch = function (state) {
	        var subscriber = state.subscriber, condition = state.condition;
	        if (subscriber.closed) {
	            return;
	        }
	        if (state.needIterate) {
	            try {
	                state.state = state.iterate(state.state);
	            }
	            catch (err) {
	                subscriber.error(err);
	                return;
	            }
	        }
	        else {
	            state.needIterate = true;
	        }
	        if (condition) {
	            var conditionResult = void 0;
	            try {
	                conditionResult = condition(state.state);
	            }
	            catch (err) {
	                subscriber.error(err);
	                return;
	            }
	            if (!conditionResult) {
	                subscriber.complete();
	                return;
	            }
	            if (subscriber.closed) {
	                return;
	            }
	        }
	        var value;
	        try {
	            value = state.resultSelector(state.state);
	        }
	        catch (err) {
	            subscriber.error(err);
	            return;
	        }
	        if (subscriber.closed) {
	            return;
	        }
	        subscriber.next(value);
	        if (subscriber.closed) {
	            return;
	        }
	        return this.schedule(state);
	    };
	    return GenerateObservable;
	}(Observable_1.Observable));
	exports.GenerateObservable = GenerateObservable;
	//# sourceMappingURL=GenerateObservable.js.map

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var if_1 = __webpack_require__(337);
	Observable_1.Observable.if = if_1._if;
	//# sourceMappingURL=if.js.map

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var IfObservable_1 = __webpack_require__(338);
	exports._if = IfObservable_1.IfObservable.create;
	//# sourceMappingURL=if.js.map

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(206);
	var subscribeToResult_1 = __webpack_require__(229);
	var OuterSubscriber_1 = __webpack_require__(234);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var IfObservable = (function (_super) {
	    __extends(IfObservable, _super);
	    function IfObservable(condition, thenSource, elseSource) {
	        _super.call(this);
	        this.condition = condition;
	        this.thenSource = thenSource;
	        this.elseSource = elseSource;
	    }
	    IfObservable.create = function (condition, thenSource, elseSource) {
	        return new IfObservable(condition, thenSource, elseSource);
	    };
	    /** @deprecated internal use only */ IfObservable.prototype._subscribe = function (subscriber) {
	        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
	        return new IfSubscriber(subscriber, condition, thenSource, elseSource);
	    };
	    return IfObservable;
	}(Observable_1.Observable));
	exports.IfObservable = IfObservable;
	var IfSubscriber = (function (_super) {
	    __extends(IfSubscriber, _super);
	    function IfSubscriber(destination, condition, thenSource, elseSource) {
	        _super.call(this, destination);
	        this.condition = condition;
	        this.thenSource = thenSource;
	        this.elseSource = elseSource;
	        this.tryIf();
	    }
	    IfSubscriber.prototype.tryIf = function () {
	        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
	        var result;
	        try {
	            result = condition();
	            var source = result ? thenSource : elseSource;
	            if (source) {
	                this.add(subscribeToResult_1.subscribeToResult(this, source));
	            }
	            else {
	                this._complete();
	            }
	        }
	        catch (err) {
	            this._error(err);
	        }
	    };
	    return IfSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=IfObservable.js.map

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var interval_1 = __webpack_require__(340);
	Observable_1.Observable.interval = interval_1.interval;
	//# sourceMappingURL=interval.js.map

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var IntervalObservable_1 = __webpack_require__(341);
	exports.interval = IntervalObservable_1.IntervalObservable.create;
	//# sourceMappingURL=interval.js.map

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isNumeric_1 = __webpack_require__(342);
	var Observable_1 = __webpack_require__(206);
	var async_1 = __webpack_require__(343);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var IntervalObservable = (function (_super) {
	    __extends(IntervalObservable, _super);
	    function IntervalObservable(period, scheduler) {
	        if (period === void 0) { period = 0; }
	        if (scheduler === void 0) { scheduler = async_1.async; }
	        _super.call(this);
	        this.period = period;
	        this.scheduler = scheduler;
	        if (!isNumeric_1.isNumeric(period) || period < 0) {
	            this.period = 0;
	        }
	        if (!scheduler || typeof scheduler.schedule !== 'function') {
	            this.scheduler = async_1.async;
	        }
	    }
	    /**
	     * Creates an Observable that emits sequential numbers every specified
	     * interval of time, on a specified IScheduler.
	     *
	     * <span class="informal">Emits incremental numbers periodically in time.
	     * </span>
	     *
	     * <img src="./img/interval.png" width="100%">
	     *
	     * `interval` returns an Observable that emits an infinite sequence of
	     * ascending integers, with a constant interval of time of your choosing
	     * between those emissions. The first emission is not sent immediately, but
	     * only after the first period has passed. By default, this operator uses the
	     * `async` IScheduler to provide a notion of time, but you may pass any
	     * IScheduler to it.
	     *
	     * @example <caption>Emits ascending numbers, one every second (1000ms)</caption>
	     * var numbers = Rx.Observable.interval(1000);
	     * numbers.subscribe(x => console.log(x));
	     *
	     * @see {@link timer}
	     * @see {@link delay}
	     *
	     * @param {number} [period=0] The interval size in milliseconds (by default)
	     * or the time unit determined by the scheduler's clock.
	     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
	     * the emission of values, and providing a notion of "time".
	     * @return {Observable} An Observable that emits a sequential number each time
	     * interval.
	     * @static true
	     * @name interval
	     * @owner Observable
	     */
	    IntervalObservable.create = function (period, scheduler) {
	        if (period === void 0) { period = 0; }
	        if (scheduler === void 0) { scheduler = async_1.async; }
	        return new IntervalObservable(period, scheduler);
	    };
	    IntervalObservable.dispatch = function (state) {
	        var index = state.index, subscriber = state.subscriber, period = state.period;
	        subscriber.next(index);
	        if (subscriber.closed) {
	            return;
	        }
	        state.index += 1;
	        this.schedule(state, period);
	    };
	    /** @deprecated internal use only */ IntervalObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var period = this.period;
	        var scheduler = this.scheduler;
	        subscriber.add(scheduler.schedule(IntervalObservable.dispatch, period, {
	            index: index, subscriber: subscriber, period: period
	        }));
	    };
	    return IntervalObservable;
	}(Observable_1.Observable));
	exports.IntervalObservable = IntervalObservable;
	//# sourceMappingURL=IntervalObservable.js.map

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var isArray_1 = __webpack_require__(212);
	function isNumeric(val) {
	    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
	    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
	    // subtraction forces infinities to NaN
	    // adding 1 corrects loss of precision from parseFloat (#15100)
	    return !isArray_1.isArray(val) && (val - parseFloat(val) + 1) >= 0;
	}
	exports.isNumeric = isNumeric;
	;
	//# sourceMappingURL=isNumeric.js.map

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var AsyncAction_1 = __webpack_require__(344);
	var AsyncScheduler_1 = __webpack_require__(346);
	/**
	 *
	 * Async Scheduler
	 *
	 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
	 *
	 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
	 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
	 * in intervals.
	 *
	 * If you just want to "defer" task, that is to perform it right after currently
	 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
	 * better choice will be the {@link asap} scheduler.
	 *
	 * @example <caption>Use async scheduler to delay task</caption>
	 * const task = () => console.log('it works!');
	 *
	 * Rx.Scheduler.async.schedule(task, 2000);
	 *
	 * // After 2 seconds logs:
	 * // "it works!"
	 *
	 *
	 * @example <caption>Use async scheduler to repeat task in intervals</caption>
	 * function task(state) {
	 *   console.log(state);
	 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
	 *                                   // which we reschedule with new state and delay
	 * }
	 *
	 * Rx.Scheduler.async.schedule(task, 3000, 0);
	 *
	 * // Logs:
	 * // 0 after 3s
	 * // 1 after 4s
	 * // 2 after 5s
	 * // 3 after 6s
	 *
	 * @static true
	 * @name async
	 * @owner Scheduler
	 */
	exports.async = new AsyncScheduler_1.AsyncScheduler(AsyncAction_1.AsyncAction);
	//# sourceMappingURL=async.js.map

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var root_1 = __webpack_require__(207);
	var Action_1 = __webpack_require__(345);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AsyncAction = (function (_super) {
	    __extends(AsyncAction, _super);
	    function AsyncAction(scheduler, work) {
	        _super.call(this, scheduler, work);
	        this.scheduler = scheduler;
	        this.pending = false;
	        this.work = work;
	    }
	    AsyncAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (this.closed) {
	            return this;
	        }
	        // Always replace the current state with the new state.
	        this.state = state;
	        // Set the pending flag indicating that this action has been scheduled, or
	        // has recursively rescheduled itself.
	        this.pending = true;
	        var id = this.id;
	        var scheduler = this.scheduler;
	        //
	        // Important implementation note:
	        //
	        // Actions only execute once by default, unless rescheduled from within the
	        // scheduled callback. This allows us to implement single and repeat
	        // actions via the same code path, without adding API surface area, as well
	        // as mimic traditional recursion but across asynchronous boundaries.
	        //
	        // However, JS runtimes and timers distinguish between intervals achieved by
	        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
	        // serial `setTimeout` calls can be individually delayed, which delays
	        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
	        // guarantee the interval callback will be invoked more precisely to the
	        // interval period, regardless of load.
	        //
	        // Therefore, we use `setInterval` to schedule single and repeat actions.
	        // If the action reschedules itself with the same delay, the interval is not
	        // canceled. If the action doesn't reschedule, or reschedules with a
	        // different delay, the interval will be canceled after scheduled callback
	        // execution.
	        //
	        if (id != null) {
	            this.id = this.recycleAsyncId(scheduler, id, delay);
	        }
	        this.delay = delay;
	        // If this action has already an async Id, don't request a new one.
	        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
	        return this;
	    };
	    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        return root_1.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
	    };
	    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If this action is rescheduled with the same delay time, don't clear the interval id.
	        if (delay !== null && this.delay === delay && this.pending === false) {
	            return id;
	        }
	        // Otherwise, if the action's delay time is different from the current delay,
	        // or the action has been rescheduled before it's executed, clear the interval id
	        return root_1.root.clearInterval(id) && undefined || undefined;
	    };
	    /**
	     * Immediately executes this action and the `work` it contains.
	     * @return {any}
	     */
	    AsyncAction.prototype.execute = function (state, delay) {
	        if (this.closed) {
	            return new Error('executing a cancelled action');
	        }
	        this.pending = false;
	        var error = this._execute(state, delay);
	        if (error) {
	            return error;
	        }
	        else if (this.pending === false && this.id != null) {
	            // Dequeue if the action didn't reschedule itself. Don't call
	            // unsubscribe(), because the action could reschedule later.
	            // For example:
	            // ```
	            // scheduler.schedule(function doWork(counter) {
	            //   /* ... I'm a busy worker bee ... */
	            //   var originalAction = this;
	            //   /* wait 100ms before rescheduling the action */
	            //   setTimeout(function () {
	            //     originalAction.schedule(counter + 1);
	            //   }, 100);
	            // }, 1000);
	            // ```
	            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
	        }
	    };
	    AsyncAction.prototype._execute = function (state, delay) {
	        var errored = false;
	        var errorValue = undefined;
	        try {
	            this.work(state);
	        }
	        catch (e) {
	            errored = true;
	            errorValue = !!e && e || new Error(e);
	        }
	        if (errored) {
	            this.unsubscribe();
	            return errorValue;
	        }
	    };
	    /** @deprecated internal use only */ AsyncAction.prototype._unsubscribe = function () {
	        var id = this.id;
	        var scheduler = this.scheduler;
	        var actions = scheduler.actions;
	        var index = actions.indexOf(this);
	        this.work = null;
	        this.state = null;
	        this.pending = false;
	        this.scheduler = null;
	        if (index !== -1) {
	            actions.splice(index, 1);
	        }
	        if (id != null) {
	            this.id = this.recycleAsyncId(scheduler, id, null);
	        }
	        this.delay = null;
	    };
	    return AsyncAction;
	}(Action_1.Action));
	exports.AsyncAction = AsyncAction;
	//# sourceMappingURL=AsyncAction.js.map

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscription_1 = __webpack_require__(211);
	/**
	 * A unit of work to be executed in a {@link Scheduler}. An action is typically
	 * created from within a Scheduler and an RxJS user does not need to concern
	 * themselves about creating and manipulating an Action.
	 *
	 * ```ts
	 * class Action<T> extends Subscription {
	 *   new (scheduler: Scheduler, work: (state?: T) => void);
	 *   schedule(state?: T, delay: number = 0): Subscription;
	 * }
	 * ```
	 *
	 * @class Action<T>
	 */
	var Action = (function (_super) {
	    __extends(Action, _super);
	    function Action(scheduler, work) {
	        _super.call(this);
	    }
	    /**
	     * Schedules this action on its parent Scheduler for execution. May be passed
	     * some context object, `state`. May happen at some point in the future,
	     * according to the `delay` parameter, if specified.
	     * @param {T} [state] Some contextual data that the `work` function uses when
	     * called by the Scheduler.
	     * @param {number} [delay] Time to wait before executing the work, where the
	     * time unit is implicit and defined by the Scheduler.
	     * @return {void}
	     */
	    Action.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        return this;
	    };
	    return Action;
	}(Subscription_1.Subscription));
	exports.Action = Action;
	//# sourceMappingURL=Action.js.map

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Scheduler_1 = __webpack_require__(347);
	var AsyncScheduler = (function (_super) {
	    __extends(AsyncScheduler, _super);
	    function AsyncScheduler() {
	        _super.apply(this, arguments);
	        this.actions = [];
	        /**
	         * A flag to indicate whether the Scheduler is currently executing a batch of
	         * queued actions.
	         * @type {boolean}
	         */
	        this.active = false;
	        /**
	         * An internal ID used to track the latest asynchronous task such as those
	         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
	         * others.
	         * @type {any}
	         */
	        this.scheduled = undefined;
	    }
	    AsyncScheduler.prototype.flush = function (action) {
	        var actions = this.actions;
	        if (this.active) {
	            actions.push(action);
	            return;
	        }
	        var error;
	        this.active = true;
	        do {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        } while (action = actions.shift()); // exhaust the scheduler queue
	        this.active = false;
	        if (error) {
	            while (action = actions.shift()) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AsyncScheduler;
	}(Scheduler_1.Scheduler));
	exports.AsyncScheduler = AsyncScheduler;
	//# sourceMappingURL=AsyncScheduler.js.map

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * An execution context and a data structure to order tasks and schedule their
	 * execution. Provides a notion of (potentially virtual) time, through the
	 * `now()` getter method.
	 *
	 * Each unit of work in a Scheduler is called an {@link Action}.
	 *
	 * ```ts
	 * class Scheduler {
	 *   now(): number;
	 *   schedule(work, delay?, state?): Subscription;
	 * }
	 * ```
	 *
	 * @class Scheduler
	 */
	var Scheduler = (function () {
	    function Scheduler(SchedulerAction, now) {
	        if (now === void 0) { now = Scheduler.now; }
	        this.SchedulerAction = SchedulerAction;
	        this.now = now;
	    }
	    /**
	     * Schedules a function, `work`, for execution. May happen at some point in
	     * the future, according to the `delay` parameter, if specified. May be passed
	     * some context object, `state`, which will be passed to the `work` function.
	     *
	     * The given arguments will be processed an stored as an Action object in a
	     * queue of actions.
	     *
	     * @param {function(state: ?T): ?Subscription} work A function representing a
	     * task, or some unit of work to be executed by the Scheduler.
	     * @param {number} [delay] Time to wait before executing the work, where the
	     * time unit is implicit and defined by the Scheduler itself.
	     * @param {T} [state] Some contextual data that the `work` function uses when
	     * called by the Scheduler.
	     * @return {Subscription} A subscription in order to be able to unsubscribe
	     * the scheduled work.
	     */
	    Scheduler.prototype.schedule = function (work, delay, state) {
	        if (delay === void 0) { delay = 0; }
	        return new this.SchedulerAction(this, work).schedule(state, delay);
	    };
	    Scheduler.now = Date.now ? Date.now : function () { return +new Date(); };
	    return Scheduler;
	}());
	exports.Scheduler = Scheduler;
	//# sourceMappingURL=Scheduler.js.map

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var merge_1 = __webpack_require__(222);
	Observable_1.Observable.merge = merge_1.merge;
	//# sourceMappingURL=merge.js.map

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var race_1 = __webpack_require__(350);
	Observable_1.Observable.race = race_1.race;
	//# sourceMappingURL=race.js.map

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isArray_1 = __webpack_require__(212);
	var ArrayObservable_1 = __webpack_require__(223);
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	function race() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    // if the only argument is an array, it was most likely called with
	    // `race([obs1, obs2, ...])`
	    if (observables.length === 1) {
	        if (isArray_1.isArray(observables[0])) {
	            observables = observables[0];
	        }
	        else {
	            return observables[0];
	        }
	    }
	    return new ArrayObservable_1.ArrayObservable(observables).lift(new RaceOperator());
	}
	exports.race = race;
	var RaceOperator = (function () {
	    function RaceOperator() {
	    }
	    RaceOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RaceSubscriber(subscriber));
	    };
	    return RaceOperator;
	}());
	exports.RaceOperator = RaceOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var RaceSubscriber = (function (_super) {
	    __extends(RaceSubscriber, _super);
	    function RaceSubscriber(destination) {
	        _super.call(this, destination);
	        this.hasFirst = false;
	        this.observables = [];
	        this.subscriptions = [];
	    }
	    RaceSubscriber.prototype._next = function (observable) {
	        this.observables.push(observable);
	    };
	    RaceSubscriber.prototype._complete = function () {
	        var observables = this.observables;
	        var len = observables.length;
	        if (len === 0) {
	            this.destination.complete();
	        }
	        else {
	            for (var i = 0; i < len && !this.hasFirst; i++) {
	                var observable = observables[i];
	                var subscription = subscribeToResult_1.subscribeToResult(this, observable, observable, i);
	                if (this.subscriptions) {
	                    this.subscriptions.push(subscription);
	                }
	                this.add(subscription);
	            }
	            this.observables = null;
	        }
	    };
	    RaceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        if (!this.hasFirst) {
	            this.hasFirst = true;
	            for (var i = 0; i < this.subscriptions.length; i++) {
	                if (i !== outerIndex) {
	                    var subscription = this.subscriptions[i];
	                    subscription.unsubscribe();
	                    this.remove(subscription);
	                }
	            }
	            this.subscriptions = null;
	        }
	        this.destination.next(innerValue);
	    };
	    return RaceSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.RaceSubscriber = RaceSubscriber;
	//# sourceMappingURL=race.js.map

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var never_1 = __webpack_require__(352);
	Observable_1.Observable.never = never_1.never;
	//# sourceMappingURL=never.js.map

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var NeverObservable_1 = __webpack_require__(353);
	exports.never = NeverObservable_1.NeverObservable.create;
	//# sourceMappingURL=never.js.map

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(206);
	var noop_1 = __webpack_require__(221);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var NeverObservable = (function (_super) {
	    __extends(NeverObservable, _super);
	    function NeverObservable() {
	        _super.call(this);
	    }
	    /**
	     * Creates an Observable that emits no items to the Observer.
	     *
	     * <span class="informal">An Observable that never emits anything.</span>
	     *
	     * <img src="./img/never.png" width="100%">
	     *
	     * This static operator is useful for creating a simple Observable that emits
	     * neither values nor errors nor the completion notification. It can be used
	     * for testing purposes or for composing with other Observables. Please note
	     * that by never emitting a complete notification, this Observable keeps the
	     * subscription from being disposed automatically. Subscriptions need to be
	     * manually disposed.
	     *
	     * @example <caption>Emit the number 7, then never emit anything else (not even complete).</caption>
	     * function info() {
	     *   console.log('Will not be called');
	     * }
	     * var result = Rx.Observable.never().startWith(7);
	     * result.subscribe(x => console.log(x), info, info);
	     *
	     * @see {@link create}
	     * @see {@link empty}
	     * @see {@link of}
	     * @see {@link throw}
	     *
	     * @return {Observable} A "never" Observable: never emits anything.
	     * @static true
	     * @name never
	     * @owner Observable
	     */
	    NeverObservable.create = function () {
	        return new NeverObservable();
	    };
	    /** @deprecated internal use only */ NeverObservable.prototype._subscribe = function (subscriber) {
	        noop_1.noop();
	    };
	    return NeverObservable;
	}(Observable_1.Observable));
	exports.NeverObservable = NeverObservable;
	//# sourceMappingURL=NeverObservable.js.map

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var of_1 = __webpack_require__(253);
	Observable_1.Observable.of = of_1.of;
	//# sourceMappingURL=of.js.map

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var onErrorResumeNext_1 = __webpack_require__(356);
	Observable_1.Observable.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
	//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var onErrorResumeNext_1 = __webpack_require__(357);
	exports.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNextStatic;
	//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var FromObservable_1 = __webpack_require__(277);
	var isArray_1 = __webpack_require__(212);
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/* tslint:enable:max-line-length */
	/**
	 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
	 * that was passed.
	 *
	 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
	 *
	 * <img src="./img/onErrorResumeNext.png" width="100%">
	 *
	 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
	 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
	 * as the source.
	 *
	 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
	 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
	 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
	 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
	 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
	 * be happening until there is no more Observables left in the series, at which point returned Observable will
	 * complete - even if the last subscribed stream ended with an error.
	 *
	 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
	 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
	 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
	 * an error.
	 *
	 * Note that you do not get any access to errors emitted by the Observables. In particular do not
	 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
	 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
	 *
	 *
	 * @example <caption>Subscribe to the next Observable after map fails</caption>
	 * Rx.Observable.of(1, 2, 3, 0)
	 *   .map(x => {
	 *       if (x === 0) { throw Error(); }
	         return 10 / x;
	 *   })
	 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
	 *   .subscribe(
	 *     val => console.log(val),
	 *     err => console.log(err),          // Will never be called.
	 *     () => console.log('that\'s it!')
	 *   );
	 *
	 * // Logs:
	 * // 10
	 * // 5
	 * // 3.3333333333333335
	 * // 1
	 * // 2
	 * // 3
	 * // "that's it!"
	 *
	 * @see {@link concat}
	 * @see {@link catch}
	 *
	 * @param {...ObservableInput} observables Observables passed either directly or as an array.
	 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
	 * to the next passed Observable and so on, until it completes or runs out of Observables.
	 * @method onErrorResumeNext
	 * @owner Observable
	 */
	function onErrorResumeNext() {
	    var nextSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        nextSources[_i - 0] = arguments[_i];
	    }
	    if (nextSources.length === 1 && isArray_1.isArray(nextSources[0])) {
	        nextSources = nextSources[0];
	    }
	    return function (source) { return source.lift(new OnErrorResumeNextOperator(nextSources)); };
	}
	exports.onErrorResumeNext = onErrorResumeNext;
	/* tslint:enable:max-line-length */
	function onErrorResumeNextStatic() {
	    var nextSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        nextSources[_i - 0] = arguments[_i];
	    }
	    var source = null;
	    if (nextSources.length === 1 && isArray_1.isArray(nextSources[0])) {
	        nextSources = nextSources[0];
	    }
	    source = nextSources.shift();
	    return new FromObservable_1.FromObservable(source, null).lift(new OnErrorResumeNextOperator(nextSources));
	}
	exports.onErrorResumeNextStatic = onErrorResumeNextStatic;
	var OnErrorResumeNextOperator = (function () {
	    function OnErrorResumeNextOperator(nextSources) {
	        this.nextSources = nextSources;
	    }
	    OnErrorResumeNextOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new OnErrorResumeNextSubscriber(subscriber, this.nextSources));
	    };
	    return OnErrorResumeNextOperator;
	}());
	var OnErrorResumeNextSubscriber = (function (_super) {
	    __extends(OnErrorResumeNextSubscriber, _super);
	    function OnErrorResumeNextSubscriber(destination, nextSources) {
	        _super.call(this, destination);
	        this.destination = destination;
	        this.nextSources = nextSources;
	    }
	    OnErrorResumeNextSubscriber.prototype.notifyError = function (error, innerSub) {
	        this.subscribeToNextSource();
	    };
	    OnErrorResumeNextSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.subscribeToNextSource();
	    };
	    OnErrorResumeNextSubscriber.prototype._error = function (err) {
	        this.subscribeToNextSource();
	    };
	    OnErrorResumeNextSubscriber.prototype._complete = function () {
	        this.subscribeToNextSource();
	    };
	    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function () {
	        var next = this.nextSources.shift();
	        if (next) {
	            this.add(subscribeToResult_1.subscribeToResult(this, next));
	        }
	        else {
	            this.destination.complete();
	        }
	    };
	    return OnErrorResumeNextSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var pairs_1 = __webpack_require__(359);
	Observable_1.Observable.pairs = pairs_1.pairs;
	//# sourceMappingURL=pairs.js.map

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var PairsObservable_1 = __webpack_require__(360);
	exports.pairs = PairsObservable_1.PairsObservable.create;
	//# sourceMappingURL=pairs.js.map

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(206);
	function dispatch(state) {
	    var obj = state.obj, keys = state.keys, length = state.length, index = state.index, subscriber = state.subscriber;
	    if (index === length) {
	        subscriber.complete();
	        return;
	    }
	    var key = keys[index];
	    subscriber.next([key, obj[key]]);
	    state.index = index + 1;
	    this.schedule(state);
	}
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var PairsObservable = (function (_super) {
	    __extends(PairsObservable, _super);
	    function PairsObservable(obj, scheduler) {
	        _super.call(this);
	        this.obj = obj;
	        this.scheduler = scheduler;
	        this.keys = Object.keys(obj);
	    }
	    /**
	     * Convert an object into an observable sequence of [key, value] pairs
	     * using an optional IScheduler to enumerate the object.
	     *
	     * @example <caption>Converts a javascript object to an Observable</caption>
	     * var obj = {
	     *   foo: 42,
	     *   bar: 56,
	     *   baz: 78
	     * };
	     *
	     * var source = Rx.Observable.pairs(obj);
	     *
	     * var subscription = source.subscribe(
	     *   function (x) {
	     *     console.log('Next: %s', x);
	     *   },
	     *   function (err) {
	     *     console.log('Error: %s', err);
	     *   },
	     *   function () {
	     *     console.log('Completed');
	     *   });
	     *
	     * @param {Object} obj The object to inspect and turn into an
	     * Observable sequence.
	     * @param {Scheduler} [scheduler] An optional IScheduler to run the
	     * enumeration of the input sequence on.
	     * @returns {(Observable<Array<string | T>>)} An observable sequence of
	     * [key, value] pairs from the object.
	     */
	    PairsObservable.create = function (obj, scheduler) {
	        return new PairsObservable(obj, scheduler);
	    };
	    /** @deprecated internal use only */ PairsObservable.prototype._subscribe = function (subscriber) {
	        var _a = this, keys = _a.keys, scheduler = _a.scheduler;
	        var length = keys.length;
	        if (scheduler) {
	            return scheduler.schedule(dispatch, 0, {
	                obj: this.obj, keys: keys, length: length, index: 0, subscriber: subscriber
	            });
	        }
	        else {
	            for (var idx = 0; idx < length; idx++) {
	                var key = keys[idx];
	                subscriber.next([key, this.obj[key]]);
	            }
	            subscriber.complete();
	        }
	    };
	    return PairsObservable;
	}(Observable_1.Observable));
	exports.PairsObservable = PairsObservable;
	//# sourceMappingURL=PairsObservable.js.map

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var range_1 = __webpack_require__(362);
	Observable_1.Observable.range = range_1.range;
	//# sourceMappingURL=range.js.map

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var RangeObservable_1 = __webpack_require__(363);
	exports.range = RangeObservable_1.RangeObservable.create;
	//# sourceMappingURL=range.js.map

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(206);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var RangeObservable = (function (_super) {
	    __extends(RangeObservable, _super);
	    function RangeObservable(start, count, scheduler) {
	        _super.call(this);
	        this.start = start;
	        this._count = count;
	        this.scheduler = scheduler;
	    }
	    /**
	     * Creates an Observable that emits a sequence of numbers within a specified
	     * range.
	     *
	     * <span class="informal">Emits a sequence of numbers in a range.</span>
	     *
	     * <img src="./img/range.png" width="100%">
	     *
	     * `range` operator emits a range of sequential integers, in order, where you
	     * select the `start` of the range and its `length`. By default, uses no
	     * IScheduler and just delivers the notifications synchronously, but may use
	     * an optional IScheduler to regulate those deliveries.
	     *
	     * @example <caption>Emits the numbers 1 to 10</caption>
	     * var numbers = Rx.Observable.range(1, 10);
	     * numbers.subscribe(x => console.log(x));
	     *
	     * @see {@link timer}
	     * @see {@link interval}
	     *
	     * @param {number} [start=0] The value of the first integer in the sequence.
	     * @param {number} [count=0] The number of sequential integers to generate.
	     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
	     * the emissions of the notifications.
	     * @return {Observable} An Observable of numbers that emits a finite range of
	     * sequential integers.
	     * @static true
	     * @name range
	     * @owner Observable
	     */
	    RangeObservable.create = function (start, count, scheduler) {
	        if (start === void 0) { start = 0; }
	        if (count === void 0) { count = 0; }
	        return new RangeObservable(start, count, scheduler);
	    };
	    RangeObservable.dispatch = function (state) {
	        var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
	        if (index >= count) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(start);
	        if (subscriber.closed) {
	            return;
	        }
	        state.index = index + 1;
	        state.start = start + 1;
	        this.schedule(state);
	    };
	    /** @deprecated internal use only */ RangeObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var start = this.start;
	        var count = this._count;
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(RangeObservable.dispatch, 0, {
	                index: index, count: count, start: start, subscriber: subscriber
	            });
	        }
	        else {
	            do {
	                if (index++ >= count) {
	                    subscriber.complete();
	                    break;
	                }
	                subscriber.next(start++);
	                if (subscriber.closed) {
	                    break;
	                }
	            } while (true);
	        }
	    };
	    return RangeObservable;
	}(Observable_1.Observable));
	exports.RangeObservable = RangeObservable;
	//# sourceMappingURL=RangeObservable.js.map

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var using_1 = __webpack_require__(365);
	Observable_1.Observable.using = using_1.using;
	//# sourceMappingURL=using.js.map

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var UsingObservable_1 = __webpack_require__(366);
	exports.using = UsingObservable_1.UsingObservable.create;
	//# sourceMappingURL=using.js.map

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(206);
	var subscribeToResult_1 = __webpack_require__(229);
	var OuterSubscriber_1 = __webpack_require__(234);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var UsingObservable = (function (_super) {
	    __extends(UsingObservable, _super);
	    function UsingObservable(resourceFactory, observableFactory) {
	        _super.call(this);
	        this.resourceFactory = resourceFactory;
	        this.observableFactory = observableFactory;
	    }
	    UsingObservable.create = function (resourceFactory, observableFactory) {
	        return new UsingObservable(resourceFactory, observableFactory);
	    };
	    /** @deprecated internal use only */ UsingObservable.prototype._subscribe = function (subscriber) {
	        var _a = this, resourceFactory = _a.resourceFactory, observableFactory = _a.observableFactory;
	        var resource;
	        try {
	            resource = resourceFactory();
	            return new UsingSubscriber(subscriber, resource, observableFactory);
	        }
	        catch (err) {
	            subscriber.error(err);
	        }
	    };
	    return UsingObservable;
	}(Observable_1.Observable));
	exports.UsingObservable = UsingObservable;
	var UsingSubscriber = (function (_super) {
	    __extends(UsingSubscriber, _super);
	    function UsingSubscriber(destination, resource, observableFactory) {
	        _super.call(this, destination);
	        this.resource = resource;
	        this.observableFactory = observableFactory;
	        destination.add(resource);
	        this.tryUse();
	    }
	    UsingSubscriber.prototype.tryUse = function () {
	        try {
	            var source = this.observableFactory.call(this, this.resource);
	            if (source) {
	                this.add(subscribeToResult_1.subscribeToResult(this, source));
	            }
	        }
	        catch (err) {
	            this._error(err);
	        }
	    };
	    return UsingSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=UsingObservable.js.map

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var throw_1 = __webpack_require__(368);
	Observable_1.Observable.throw = throw_1._throw;
	//# sourceMappingURL=throw.js.map

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ErrorObservable_1 = __webpack_require__(369);
	exports._throw = ErrorObservable_1.ErrorObservable.create;
	//# sourceMappingURL=throw.js.map

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(206);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ErrorObservable = (function (_super) {
	    __extends(ErrorObservable, _super);
	    function ErrorObservable(error, scheduler) {
	        _super.call(this);
	        this.error = error;
	        this.scheduler = scheduler;
	    }
	    /**
	     * Creates an Observable that emits no items to the Observer and immediately
	     * emits an error notification.
	     *
	     * <span class="informal">Just emits 'error', and nothing else.
	     * </span>
	     *
	     * <img src="./img/throw.png" width="100%">
	     *
	     * This static operator is useful for creating a simple Observable that only
	     * emits the error notification. It can be used for composing with other
	     * Observables, such as in a {@link mergeMap}.
	     *
	     * @example <caption>Emit the number 7, then emit an error.</caption>
	     * var result = Rx.Observable.throw(new Error('oops!')).startWith(7);
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     * @example <caption>Map and flatten numbers to the sequence 'a', 'b', 'c', but throw an error for 13</caption>
	     * var interval = Rx.Observable.interval(1000);
	     * var result = interval.mergeMap(x =>
	     *   x === 13 ?
	     *     Rx.Observable.throw('Thirteens are bad') :
	     *     Rx.Observable.of('a', 'b', 'c')
	     * );
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     * @see {@link create}
	     * @see {@link empty}
	     * @see {@link never}
	     * @see {@link of}
	     *
	     * @param {any} error The particular Error to pass to the error notification.
	     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
	     * the emission of the error notification.
	     * @return {Observable} An error Observable: emits only the error notification
	     * using the given error argument.
	     * @static true
	     * @name throw
	     * @owner Observable
	     */
	    ErrorObservable.create = function (error, scheduler) {
	        return new ErrorObservable(error, scheduler);
	    };
	    ErrorObservable.dispatch = function (arg) {
	        var error = arg.error, subscriber = arg.subscriber;
	        subscriber.error(error);
	    };
	    /** @deprecated internal use only */ ErrorObservable.prototype._subscribe = function (subscriber) {
	        var error = this.error;
	        var scheduler = this.scheduler;
	        subscriber.syncErrorThrowable = true;
	        if (scheduler) {
	            return scheduler.schedule(ErrorObservable.dispatch, 0, {
	                error: error, subscriber: subscriber
	            });
	        }
	        else {
	            subscriber.error(error);
	        }
	    };
	    return ErrorObservable;
	}(Observable_1.Observable));
	exports.ErrorObservable = ErrorObservable;
	//# sourceMappingURL=ErrorObservable.js.map

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var timer_1 = __webpack_require__(371);
	Observable_1.Observable.timer = timer_1.timer;
	//# sourceMappingURL=timer.js.map

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var TimerObservable_1 = __webpack_require__(372);
	exports.timer = TimerObservable_1.TimerObservable.create;
	//# sourceMappingURL=timer.js.map

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isNumeric_1 = __webpack_require__(342);
	var Observable_1 = __webpack_require__(206);
	var async_1 = __webpack_require__(343);
	var isScheduler_1 = __webpack_require__(226);
	var isDate_1 = __webpack_require__(373);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var TimerObservable = (function (_super) {
	    __extends(TimerObservable, _super);
	    function TimerObservable(dueTime, period, scheduler) {
	        if (dueTime === void 0) { dueTime = 0; }
	        _super.call(this);
	        this.period = -1;
	        this.dueTime = 0;
	        if (isNumeric_1.isNumeric(period)) {
	            this.period = Number(period) < 1 && 1 || Number(period);
	        }
	        else if (isScheduler_1.isScheduler(period)) {
	            scheduler = period;
	        }
	        if (!isScheduler_1.isScheduler(scheduler)) {
	            scheduler = async_1.async;
	        }
	        this.scheduler = scheduler;
	        this.dueTime = isDate_1.isDate(dueTime) ?
	            (+dueTime - this.scheduler.now()) :
	            dueTime;
	    }
	    /**
	     * Creates an Observable that starts emitting after an `initialDelay` and
	     * emits ever increasing numbers after each `period` of time thereafter.
	     *
	     * <span class="informal">Its like {@link interval}, but you can specify when
	     * should the emissions start.</span>
	     *
	     * <img src="./img/timer.png" width="100%">
	     *
	     * `timer` returns an Observable that emits an infinite sequence of ascending
	     * integers, with a constant interval of time, `period` of your choosing
	     * between those emissions. The first emission happens after the specified
	     * `initialDelay`. The initial delay may be a {@link Date}. By default, this
	     * operator uses the `async` IScheduler to provide a notion of time, but you
	     * may pass any IScheduler to it. If `period` is not specified, the output
	     * Observable emits only one value, `0`. Otherwise, it emits an infinite
	     * sequence.
	     *
	     * @example <caption>Emits ascending numbers, one every second (1000ms), starting after 3 seconds</caption>
	     * var numbers = Rx.Observable.timer(3000, 1000);
	     * numbers.subscribe(x => console.log(x));
	     *
	     * @example <caption>Emits one number after five seconds</caption>
	     * var numbers = Rx.Observable.timer(5000);
	     * numbers.subscribe(x => console.log(x));
	     *
	     * @see {@link interval}
	     * @see {@link delay}
	     *
	     * @param {number|Date} initialDelay The initial delay time to wait before
	     * emitting the first value of `0`.
	     * @param {number} [period] The period of time between emissions of the
	     * subsequent numbers.
	     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
	     * the emission of values, and providing a notion of "time".
	     * @return {Observable} An Observable that emits a `0` after the
	     * `initialDelay` and ever increasing numbers after each `period` of time
	     * thereafter.
	     * @static true
	     * @name timer
	     * @owner Observable
	     */
	    TimerObservable.create = function (initialDelay, period, scheduler) {
	        if (initialDelay === void 0) { initialDelay = 0; }
	        return new TimerObservable(initialDelay, period, scheduler);
	    };
	    TimerObservable.dispatch = function (state) {
	        var index = state.index, period = state.period, subscriber = state.subscriber;
	        var action = this;
	        subscriber.next(index);
	        if (subscriber.closed) {
	            return;
	        }
	        else if (period === -1) {
	            return subscriber.complete();
	        }
	        state.index = index + 1;
	        action.schedule(state, period);
	    };
	    /** @deprecated internal use only */ TimerObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var _a = this, period = _a.period, dueTime = _a.dueTime, scheduler = _a.scheduler;
	        return scheduler.schedule(TimerObservable.dispatch, dueTime, {
	            index: index, period: period, subscriber: subscriber
	        });
	    };
	    return TimerObservable;
	}(Observable_1.Observable));
	exports.TimerObservable = TimerObservable;
	//# sourceMappingURL=TimerObservable.js.map

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	"use strict";
	function isDate(value) {
	    return value instanceof Date && !isNaN(+value);
	}
	exports.isDate = isDate;
	//# sourceMappingURL=isDate.js.map

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var zip_1 = __webpack_require__(375);
	Observable_1.Observable.zip = zip_1.zip;
	//# sourceMappingURL=zip.js.map

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var zip_1 = __webpack_require__(376);
	exports.zip = zip_1.zipStatic;
	//# sourceMappingURL=zip.js.map

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ArrayObservable_1 = __webpack_require__(223);
	var isArray_1 = __webpack_require__(212);
	var Subscriber_1 = __webpack_require__(209);
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	var iterator_1 = __webpack_require__(232);
	/* tslint:enable:max-line-length */
	/**
	 * @param observables
	 * @return {Observable<R>}
	 * @method zip
	 * @owner Observable
	 */
	function zip() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return function zipOperatorFunction(source) {
	        return source.lift.call(zipStatic.apply(void 0, [source].concat(observables)));
	    };
	}
	exports.zip = zip;
	/* tslint:enable:max-line-length */
	/**
	 * Combines multiple Observables to create an Observable whose values are calculated from the values, in order, of each
	 * of its input Observables.
	 *
	 * If the latest parameter is a function, this function is used to compute the created value from the input values.
	 * Otherwise, an array of the input values is returned.
	 *
	 * @example <caption>Combine age and name from different sources</caption>
	 *
	 * let age$ = Observable.of<number>(27, 25, 29);
	 * let name$ = Observable.of<string>('Foo', 'Bar', 'Beer');
	 * let isDev$ = Observable.of<boolean>(true, true, false);
	 *
	 * Observable
	 *     .zip(age$,
	 *          name$,
	 *          isDev$,
	 *          (age: number, name: string, isDev: boolean) => ({ age, name, isDev }))
	 *     .subscribe(x => console.log(x));
	 *
	 * // outputs
	 * // { age: 27, name: 'Foo', isDev: true }
	 * // { age: 25, name: 'Bar', isDev: true }
	 * // { age: 29, name: 'Beer', isDev: false }
	 *
	 * @param observables
	 * @return {Observable<R>}
	 * @static true
	 * @name zip
	 * @owner Observable
	 */
	function zipStatic() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    var project = observables[observables.length - 1];
	    if (typeof project === 'function') {
	        observables.pop();
	    }
	    return new ArrayObservable_1.ArrayObservable(observables).lift(new ZipOperator(project));
	}
	exports.zipStatic = zipStatic;
	var ZipOperator = (function () {
	    function ZipOperator(project) {
	        this.project = project;
	    }
	    ZipOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ZipSubscriber(subscriber, this.project));
	    };
	    return ZipOperator;
	}());
	exports.ZipOperator = ZipOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ZipSubscriber = (function (_super) {
	    __extends(ZipSubscriber, _super);
	    function ZipSubscriber(destination, project, values) {
	        if (values === void 0) { values = Object.create(null); }
	        _super.call(this, destination);
	        this.iterators = [];
	        this.active = 0;
	        this.project = (typeof project === 'function') ? project : null;
	        this.values = values;
	    }
	    ZipSubscriber.prototype._next = function (value) {
	        var iterators = this.iterators;
	        if (isArray_1.isArray(value)) {
	            iterators.push(new StaticArrayIterator(value));
	        }
	        else if (typeof value[iterator_1.iterator] === 'function') {
	            iterators.push(new StaticIterator(value[iterator_1.iterator]()));
	        }
	        else {
	            iterators.push(new ZipBufferIterator(this.destination, this, value));
	        }
	    };
	    ZipSubscriber.prototype._complete = function () {
	        var iterators = this.iterators;
	        var len = iterators.length;
	        if (len === 0) {
	            this.destination.complete();
	            return;
	        }
	        this.active = len;
	        for (var i = 0; i < len; i++) {
	            var iterator = iterators[i];
	            if (iterator.stillUnsubscribed) {
	                this.add(iterator.subscribe(iterator, i));
	            }
	            else {
	                this.active--; // not an observable
	            }
	        }
	    };
	    ZipSubscriber.prototype.notifyInactive = function () {
	        this.active--;
	        if (this.active === 0) {
	            this.destination.complete();
	        }
	    };
	    ZipSubscriber.prototype.checkIterators = function () {
	        var iterators = this.iterators;
	        var len = iterators.length;
	        var destination = this.destination;
	        // abort if not all of them have values
	        for (var i = 0; i < len; i++) {
	            var iterator = iterators[i];
	            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) {
	                return;
	            }
	        }
	        var shouldComplete = false;
	        var args = [];
	        for (var i = 0; i < len; i++) {
	            var iterator = iterators[i];
	            var result = iterator.next();
	            // check to see if it's completed now that you've gotten
	            // the next value.
	            if (iterator.hasCompleted()) {
	                shouldComplete = true;
	            }
	            if (result.done) {
	                destination.complete();
	                return;
	            }
	            args.push(result.value);
	        }
	        if (this.project) {
	            this._tryProject(args);
	        }
	        else {
	            destination.next(args);
	        }
	        if (shouldComplete) {
	            destination.complete();
	        }
	    };
	    ZipSubscriber.prototype._tryProject = function (args) {
	        var result;
	        try {
	            result = this.project.apply(this, args);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return ZipSubscriber;
	}(Subscriber_1.Subscriber));
	exports.ZipSubscriber = ZipSubscriber;
	var StaticIterator = (function () {
	    function StaticIterator(iterator) {
	        this.iterator = iterator;
	        this.nextResult = iterator.next();
	    }
	    StaticIterator.prototype.hasValue = function () {
	        return true;
	    };
	    StaticIterator.prototype.next = function () {
	        var result = this.nextResult;
	        this.nextResult = this.iterator.next();
	        return result;
	    };
	    StaticIterator.prototype.hasCompleted = function () {
	        var nextResult = this.nextResult;
	        return nextResult && nextResult.done;
	    };
	    return StaticIterator;
	}());
	var StaticArrayIterator = (function () {
	    function StaticArrayIterator(array) {
	        this.array = array;
	        this.index = 0;
	        this.length = 0;
	        this.length = array.length;
	    }
	    StaticArrayIterator.prototype[iterator_1.iterator] = function () {
	        return this;
	    };
	    StaticArrayIterator.prototype.next = function (value) {
	        var i = this.index++;
	        var array = this.array;
	        return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
	    };
	    StaticArrayIterator.prototype.hasValue = function () {
	        return this.array.length > this.index;
	    };
	    StaticArrayIterator.prototype.hasCompleted = function () {
	        return this.array.length === this.index;
	    };
	    return StaticArrayIterator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ZipBufferIterator = (function (_super) {
	    __extends(ZipBufferIterator, _super);
	    function ZipBufferIterator(destination, parent, observable) {
	        _super.call(this, destination);
	        this.parent = parent;
	        this.observable = observable;
	        this.stillUnsubscribed = true;
	        this.buffer = [];
	        this.isComplete = false;
	    }
	    ZipBufferIterator.prototype[iterator_1.iterator] = function () {
	        return this;
	    };
	    // NOTE: there is actually a name collision here with Subscriber.next and Iterator.next
	    //    this is legit because `next()` will never be called by a subscription in this case.
	    ZipBufferIterator.prototype.next = function () {
	        var buffer = this.buffer;
	        if (buffer.length === 0 && this.isComplete) {
	            return { value: null, done: true };
	        }
	        else {
	            return { value: buffer.shift(), done: false };
	        }
	    };
	    ZipBufferIterator.prototype.hasValue = function () {
	        return this.buffer.length > 0;
	    };
	    ZipBufferIterator.prototype.hasCompleted = function () {
	        return this.buffer.length === 0 && this.isComplete;
	    };
	    ZipBufferIterator.prototype.notifyComplete = function () {
	        if (this.buffer.length > 0) {
	            this.isComplete = true;
	            this.parent.notifyInactive();
	        }
	        else {
	            this.destination.complete();
	        }
	    };
	    ZipBufferIterator.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.buffer.push(innerValue);
	        this.parent.checkIterators();
	    };
	    ZipBufferIterator.prototype.subscribe = function (value, index) {
	        return subscribeToResult_1.subscribeToResult(this, this.observable, this, index);
	    };
	    return ZipBufferIterator;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=zip.js.map

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var ajax_1 = __webpack_require__(378);
	Observable_1.Observable.ajax = ajax_1.ajax;
	//# sourceMappingURL=ajax.js.map

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var AjaxObservable_1 = __webpack_require__(379);
	exports.ajax = AjaxObservable_1.AjaxObservable.create;
	//# sourceMappingURL=ajax.js.map

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var root_1 = __webpack_require__(207);
	var tryCatch_1 = __webpack_require__(214);
	var errorObject_1 = __webpack_require__(215);
	var Observable_1 = __webpack_require__(206);
	var Subscriber_1 = __webpack_require__(209);
	var map_1 = __webpack_require__(254);
	function getCORSRequest() {
	    if (root_1.root.XMLHttpRequest) {
	        return new root_1.root.XMLHttpRequest();
	    }
	    else if (!!root_1.root.XDomainRequest) {
	        return new root_1.root.XDomainRequest();
	    }
	    else {
	        throw new Error('CORS is not supported by your browser');
	    }
	}
	function getXMLHttpRequest() {
	    if (root_1.root.XMLHttpRequest) {
	        return new root_1.root.XMLHttpRequest();
	    }
	    else {
	        var progId = void 0;
	        try {
	            var progIds = ['Msxml2.XMLHTTP', 'Microsoft.XMLHTTP', 'Msxml2.XMLHTTP.4.0'];
	            for (var i = 0; i < 3; i++) {
	                try {
	                    progId = progIds[i];
	                    if (new root_1.root.ActiveXObject(progId)) {
	                        break;
	                    }
	                }
	                catch (e) {
	                }
	            }
	            return new root_1.root.ActiveXObject(progId);
	        }
	        catch (e) {
	            throw new Error('XMLHttpRequest is not supported by your browser');
	        }
	    }
	}
	function ajaxGet(url, headers) {
	    if (headers === void 0) { headers = null; }
	    return new AjaxObservable({ method: 'GET', url: url, headers: headers });
	}
	exports.ajaxGet = ajaxGet;
	;
	function ajaxPost(url, body, headers) {
	    return new AjaxObservable({ method: 'POST', url: url, body: body, headers: headers });
	}
	exports.ajaxPost = ajaxPost;
	;
	function ajaxDelete(url, headers) {
	    return new AjaxObservable({ method: 'DELETE', url: url, headers: headers });
	}
	exports.ajaxDelete = ajaxDelete;
	;
	function ajaxPut(url, body, headers) {
	    return new AjaxObservable({ method: 'PUT', url: url, body: body, headers: headers });
	}
	exports.ajaxPut = ajaxPut;
	;
	function ajaxPatch(url, body, headers) {
	    return new AjaxObservable({ method: 'PATCH', url: url, body: body, headers: headers });
	}
	exports.ajaxPatch = ajaxPatch;
	;
	var mapResponse = map_1.map(function (x, index) { return x.response; });
	function ajaxGetJSON(url, headers) {
	    return mapResponse(new AjaxObservable({
	        method: 'GET',
	        url: url,
	        responseType: 'json',
	        headers: headers
	    }));
	}
	exports.ajaxGetJSON = ajaxGetJSON;
	;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var AjaxObservable = (function (_super) {
	    __extends(AjaxObservable, _super);
	    function AjaxObservable(urlOrRequest) {
	        _super.call(this);
	        var request = {
	            async: true,
	            createXHR: function () {
	                return this.crossDomain ? getCORSRequest.call(this) : getXMLHttpRequest();
	            },
	            crossDomain: false,
	            withCredentials: false,
	            headers: {},
	            method: 'GET',
	            responseType: 'json',
	            timeout: 0
	        };
	        if (typeof urlOrRequest === 'string') {
	            request.url = urlOrRequest;
	        }
	        else {
	            for (var prop in urlOrRequest) {
	                if (urlOrRequest.hasOwnProperty(prop)) {
	                    request[prop] = urlOrRequest[prop];
	                }
	            }
	        }
	        this.request = request;
	    }
	    /** @deprecated internal use only */ AjaxObservable.prototype._subscribe = function (subscriber) {
	        return new AjaxSubscriber(subscriber, this.request);
	    };
	    /**
	     * Creates an observable for an Ajax request with either a request object with
	     * url, headers, etc or a string for a URL.
	     *
	     * @example
	     * source = Rx.Observable.ajax('/products');
	     * source = Rx.Observable.ajax({ url: 'products', method: 'GET' });
	     *
	     * @param {string|Object} request Can be one of the following:
	     *   A string of the URL to make the Ajax call.
	     *   An object with the following properties
	     *   - url: URL of the request
	     *   - body: The body of the request
	     *   - method: Method of the request, such as GET, POST, PUT, PATCH, DELETE
	     *   - async: Whether the request is async
	     *   - headers: Optional headers
	     *   - crossDomain: true if a cross domain request, else false
	     *   - createXHR: a function to override if you need to use an alternate
	     *   XMLHttpRequest implementation.
	     *   - resultSelector: a function to use to alter the output value type of
	     *   the Observable. Gets {@link AjaxResponse} as an argument.
	     * @return {Observable} An observable sequence containing the XMLHttpRequest.
	     * @static true
	     * @name ajax
	     * @owner Observable
	    */
	    AjaxObservable.create = (function () {
	        var create = function (urlOrRequest) {
	            return new AjaxObservable(urlOrRequest);
	        };
	        create.get = ajaxGet;
	        create.post = ajaxPost;
	        create.delete = ajaxDelete;
	        create.put = ajaxPut;
	        create.patch = ajaxPatch;
	        create.getJSON = ajaxGetJSON;
	        return create;
	    })();
	    return AjaxObservable;
	}(Observable_1.Observable));
	exports.AjaxObservable = AjaxObservable;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AjaxSubscriber = (function (_super) {
	    __extends(AjaxSubscriber, _super);
	    function AjaxSubscriber(destination, request) {
	        _super.call(this, destination);
	        this.request = request;
	        this.done = false;
	        var headers = request.headers = request.headers || {};
	        // force CORS if requested
	        if (!request.crossDomain && !headers['X-Requested-With']) {
	            headers['X-Requested-With'] = 'XMLHttpRequest';
	        }
	        // ensure content type is set
	        if (!('Content-Type' in headers) && !(root_1.root.FormData && request.body instanceof root_1.root.FormData) && typeof request.body !== 'undefined') {
	            headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
	        }
	        // properly serialize body
	        request.body = this.serializeBody(request.body, request.headers['Content-Type']);
	        this.send();
	    }
	    AjaxSubscriber.prototype.next = function (e) {
	        this.done = true;
	        var _a = this, xhr = _a.xhr, request = _a.request, destination = _a.destination;
	        var response = new AjaxResponse(e, xhr, request);
	        destination.next(response);
	    };
	    AjaxSubscriber.prototype.send = function () {
	        var _a = this, request = _a.request, _b = _a.request, user = _b.user, method = _b.method, url = _b.url, async = _b.async, password = _b.password, headers = _b.headers, body = _b.body;
	        var createXHR = request.createXHR;
	        var xhr = tryCatch_1.tryCatch(createXHR).call(request);
	        if (xhr === errorObject_1.errorObject) {
	            this.error(errorObject_1.errorObject.e);
	        }
	        else {
	            this.xhr = xhr;
	            // set up the events before open XHR
	            // https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest
	            // You need to add the event listeners before calling open() on the request.
	            // Otherwise the progress events will not fire.
	            this.setupEvents(xhr, request);
	            // open XHR
	            var result = void 0;
	            if (user) {
	                result = tryCatch_1.tryCatch(xhr.open).call(xhr, method, url, async, user, password);
	            }
	            else {
	                result = tryCatch_1.tryCatch(xhr.open).call(xhr, method, url, async);
	            }
	            if (result === errorObject_1.errorObject) {
	                this.error(errorObject_1.errorObject.e);
	                return null;
	            }
	            // timeout, responseType and withCredentials can be set once the XHR is open
	            if (async) {
	                xhr.timeout = request.timeout;
	                xhr.responseType = request.responseType;
	            }
	            if ('withCredentials' in xhr) {
	                xhr.withCredentials = !!request.withCredentials;
	            }
	            // set headers
	            this.setHeaders(xhr, headers);
	            // finally send the request
	            result = body ? tryCatch_1.tryCatch(xhr.send).call(xhr, body) : tryCatch_1.tryCatch(xhr.send).call(xhr);
	            if (result === errorObject_1.errorObject) {
	                this.error(errorObject_1.errorObject.e);
	                return null;
	            }
	        }
	        return xhr;
	    };
	    AjaxSubscriber.prototype.serializeBody = function (body, contentType) {
	        if (!body || typeof body === 'string') {
	            return body;
	        }
	        else if (root_1.root.FormData && body instanceof root_1.root.FormData) {
	            return body;
	        }
	        if (contentType) {
	            var splitIndex = contentType.indexOf(';');
	            if (splitIndex !== -1) {
	                contentType = contentType.substring(0, splitIndex);
	            }
	        }
	        switch (contentType) {
	            case 'application/x-www-form-urlencoded':
	                return Object.keys(body).map(function (key) { return (encodeURIComponent(key) + "=" + encodeURIComponent(body[key])); }).join('&');
	            case 'application/json':
	                return JSON.stringify(body);
	            default:
	                return body;
	        }
	    };
	    AjaxSubscriber.prototype.setHeaders = function (xhr, headers) {
	        for (var key in headers) {
	            if (headers.hasOwnProperty(key)) {
	                xhr.setRequestHeader(key, headers[key]);
	            }
	        }
	    };
	    AjaxSubscriber.prototype.setupEvents = function (xhr, request) {
	        var progressSubscriber = request.progressSubscriber;
	        function xhrTimeout(e) {
	            var _a = xhrTimeout, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
	            if (progressSubscriber) {
	                progressSubscriber.error(e);
	            }
	            subscriber.error(new AjaxTimeoutError(this, request)); //TODO: Make betterer.
	        }
	        ;
	        xhr.ontimeout = xhrTimeout;
	        xhrTimeout.request = request;
	        xhrTimeout.subscriber = this;
	        xhrTimeout.progressSubscriber = progressSubscriber;
	        if (xhr.upload && 'withCredentials' in xhr) {
	            if (progressSubscriber) {
	                var xhrProgress_1;
	                xhrProgress_1 = function (e) {
	                    var progressSubscriber = xhrProgress_1.progressSubscriber;
	                    progressSubscriber.next(e);
	                };
	                if (root_1.root.XDomainRequest) {
	                    xhr.onprogress = xhrProgress_1;
	                }
	                else {
	                    xhr.upload.onprogress = xhrProgress_1;
	                }
	                xhrProgress_1.progressSubscriber = progressSubscriber;
	            }
	            var xhrError_1;
	            xhrError_1 = function (e) {
	                var _a = xhrError_1, progressSubscriber = _a.progressSubscriber, subscriber = _a.subscriber, request = _a.request;
	                if (progressSubscriber) {
	                    progressSubscriber.error(e);
	                }
	                subscriber.error(new AjaxError('ajax error', this, request));
	            };
	            xhr.onerror = xhrError_1;
	            xhrError_1.request = request;
	            xhrError_1.subscriber = this;
	            xhrError_1.progressSubscriber = progressSubscriber;
	        }
	        function xhrReadyStateChange(e) {
	            var _a = xhrReadyStateChange, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
	            if (this.readyState === 4) {
	                // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	                var status_1 = this.status === 1223 ? 204 : this.status;
	                var response = (this.responseType === 'text' ? (this.response || this.responseText) : this.response);
	                // fix status code when it is 0 (0 status is undocumented).
	                // Occurs when accessing file resources or on Android 4.1 stock browser
	                // while retrieving files from application cache.
	                if (status_1 === 0) {
	                    status_1 = response ? 200 : 0;
	                }
	                if (200 <= status_1 && status_1 < 300) {
	                    if (progressSubscriber) {
	                        progressSubscriber.complete();
	                    }
	                    subscriber.next(e);
	                    subscriber.complete();
	                }
	                else {
	                    if (progressSubscriber) {
	                        progressSubscriber.error(e);
	                    }
	                    subscriber.error(new AjaxError('ajax error ' + status_1, this, request));
	                }
	            }
	        }
	        ;
	        xhr.onreadystatechange = xhrReadyStateChange;
	        xhrReadyStateChange.subscriber = this;
	        xhrReadyStateChange.progressSubscriber = progressSubscriber;
	        xhrReadyStateChange.request = request;
	    };
	    AjaxSubscriber.prototype.unsubscribe = function () {
	        var _a = this, done = _a.done, xhr = _a.xhr;
	        if (!done && xhr && xhr.readyState !== 4 && typeof xhr.abort === 'function') {
	            xhr.abort();
	        }
	        _super.prototype.unsubscribe.call(this);
	    };
	    return AjaxSubscriber;
	}(Subscriber_1.Subscriber));
	exports.AjaxSubscriber = AjaxSubscriber;
	/**
	 * A normalized AJAX response.
	 *
	 * @see {@link ajax}
	 *
	 * @class AjaxResponse
	 */
	var AjaxResponse = (function () {
	    function AjaxResponse(originalEvent, xhr, request) {
	        this.originalEvent = originalEvent;
	        this.xhr = xhr;
	        this.request = request;
	        this.status = xhr.status;
	        this.responseType = xhr.responseType || request.responseType;
	        this.response = parseXhrResponse(this.responseType, xhr);
	    }
	    return AjaxResponse;
	}());
	exports.AjaxResponse = AjaxResponse;
	/**
	 * A normalized AJAX error.
	 *
	 * @see {@link ajax}
	 *
	 * @class AjaxError
	 */
	var AjaxError = (function (_super) {
	    __extends(AjaxError, _super);
	    function AjaxError(message, xhr, request) {
	        _super.call(this, message);
	        this.message = message;
	        this.xhr = xhr;
	        this.request = request;
	        this.status = xhr.status;
	        this.responseType = xhr.responseType || request.responseType;
	        this.response = parseXhrResponse(this.responseType, xhr);
	    }
	    return AjaxError;
	}(Error));
	exports.AjaxError = AjaxError;
	function parseXhrResponse(responseType, xhr) {
	    switch (responseType) {
	        case 'json':
	            if ('response' in xhr) {
	                //IE does not support json as responseType, parse it internally
	                return xhr.responseType ? xhr.response : JSON.parse(xhr.response || xhr.responseText || 'null');
	            }
	            else {
	                // HACK(benlesh): TypeScript shennanigans
	                // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
	                return JSON.parse(xhr.responseText || 'null');
	            }
	        case 'xml':
	            return xhr.responseXML;
	        case 'text':
	        default:
	            // HACK(benlesh): TypeScript shennanigans
	            // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
	            return ('response' in xhr) ? xhr.response : xhr.responseText;
	    }
	}
	/**
	 * @see {@link ajax}
	 *
	 * @class AjaxTimeoutError
	 */
	var AjaxTimeoutError = (function (_super) {
	    __extends(AjaxTimeoutError, _super);
	    function AjaxTimeoutError(xhr, request) {
	        _super.call(this, 'ajax timeout', xhr, request);
	    }
	    return AjaxTimeoutError;
	}(AjaxError));
	exports.AjaxTimeoutError = AjaxTimeoutError;
	//# sourceMappingURL=AjaxObservable.js.map

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var webSocket_1 = __webpack_require__(381);
	Observable_1.Observable.webSocket = webSocket_1.webSocket;
	//# sourceMappingURL=webSocket.js.map

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var WebSocketSubject_1 = __webpack_require__(382);
	exports.webSocket = WebSocketSubject_1.WebSocketSubject.create;
	//# sourceMappingURL=webSocket.js.map

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(240);
	var Subscriber_1 = __webpack_require__(209);
	var Observable_1 = __webpack_require__(206);
	var Subscription_1 = __webpack_require__(211);
	var root_1 = __webpack_require__(207);
	var ReplaySubject_1 = __webpack_require__(383);
	var tryCatch_1 = __webpack_require__(214);
	var errorObject_1 = __webpack_require__(215);
	var assign_1 = __webpack_require__(387);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var WebSocketSubject = (function (_super) {
	    __extends(WebSocketSubject, _super);
	    function WebSocketSubject(urlConfigOrSource, destination) {
	        if (urlConfigOrSource instanceof Observable_1.Observable) {
	            _super.call(this, destination, urlConfigOrSource);
	        }
	        else {
	            _super.call(this);
	            this.WebSocketCtor = root_1.root.WebSocket;
	            this._output = new Subject_1.Subject();
	            if (typeof urlConfigOrSource === 'string') {
	                this.url = urlConfigOrSource;
	            }
	            else {
	                // WARNING: config object could override important members here.
	                assign_1.assign(this, urlConfigOrSource);
	            }
	            if (!this.WebSocketCtor) {
	                throw new Error('no WebSocket constructor can be found');
	            }
	            this.destination = new ReplaySubject_1.ReplaySubject();
	        }
	    }
	    WebSocketSubject.prototype.resultSelector = function (e) {
	        return JSON.parse(e.data);
	    };
	    /**
	     * Wrapper around the w3c-compatible WebSocket object provided by the browser.
	     *
	     * @example <caption>Wraps browser WebSocket</caption>
	     *
	     * let socket$ = Observable.webSocket('ws://localhost:8081');
	     *
	     * socket$.subscribe(
	     *    (msg) => console.log('message received: ' + msg),
	     *    (err) => console.log(err),
	     *    () => console.log('complete')
	     *  );
	     *
	     * socket$.next(JSON.stringify({ op: 'hello' }));
	     *
	     * @example <caption>Wraps WebSocket from nodejs-websocket (using node.js)</caption>
	     *
	     * import { w3cwebsocket } from 'websocket';
	     *
	     * let socket$ = Observable.webSocket({
	     *   url: 'ws://localhost:8081',
	     *   WebSocketCtor: w3cwebsocket
	     * });
	     *
	     * socket$.subscribe(
	     *    (msg) => console.log('message received: ' + msg),
	     *    (err) => console.log(err),
	     *    () => console.log('complete')
	     *  );
	     *
	     * socket$.next(JSON.stringify({ op: 'hello' }));
	     *
	     * @param {string | WebSocketSubjectConfig} urlConfigOrSource the source of the websocket as an url or a structure defining the websocket object
	     * @return {WebSocketSubject}
	     * @static true
	     * @name webSocket
	     * @owner Observable
	     */
	    WebSocketSubject.create = function (urlConfigOrSource) {
	        return new WebSocketSubject(urlConfigOrSource);
	    };
	    WebSocketSubject.prototype.lift = function (operator) {
	        var sock = new WebSocketSubject(this, this.destination);
	        sock.operator = operator;
	        return sock;
	    };
	    WebSocketSubject.prototype._resetState = function () {
	        this.socket = null;
	        if (!this.source) {
	            this.destination = new ReplaySubject_1.ReplaySubject();
	        }
	        this._output = new Subject_1.Subject();
	    };
	    // TODO: factor this out to be a proper Operator/Subscriber implementation and eliminate closures
	    WebSocketSubject.prototype.multiplex = function (subMsg, unsubMsg, messageFilter) {
	        var self = this;
	        return new Observable_1.Observable(function (observer) {
	            var result = tryCatch_1.tryCatch(subMsg)();
	            if (result === errorObject_1.errorObject) {
	                observer.error(errorObject_1.errorObject.e);
	            }
	            else {
	                self.next(result);
	            }
	            var subscription = self.subscribe(function (x) {
	                var result = tryCatch_1.tryCatch(messageFilter)(x);
	                if (result === errorObject_1.errorObject) {
	                    observer.error(errorObject_1.errorObject.e);
	                }
	                else if (result) {
	                    observer.next(x);
	                }
	            }, function (err) { return observer.error(err); }, function () { return observer.complete(); });
	            return function () {
	                var result = tryCatch_1.tryCatch(unsubMsg)();
	                if (result === errorObject_1.errorObject) {
	                    observer.error(errorObject_1.errorObject.e);
	                }
	                else {
	                    self.next(result);
	                }
	                subscription.unsubscribe();
	            };
	        });
	    };
	    WebSocketSubject.prototype._connectSocket = function () {
	        var _this = this;
	        var WebSocketCtor = this.WebSocketCtor;
	        var observer = this._output;
	        var socket = null;
	        try {
	            socket = this.protocol ?
	                new WebSocketCtor(this.url, this.protocol) :
	                new WebSocketCtor(this.url);
	            this.socket = socket;
	            if (this.binaryType) {
	                this.socket.binaryType = this.binaryType;
	            }
	        }
	        catch (e) {
	            observer.error(e);
	            return;
	        }
	        var subscription = new Subscription_1.Subscription(function () {
	            _this.socket = null;
	            if (socket && socket.readyState === 1) {
	                socket.close();
	            }
	        });
	        socket.onopen = function (e) {
	            var openObserver = _this.openObserver;
	            if (openObserver) {
	                openObserver.next(e);
	            }
	            var queue = _this.destination;
	            _this.destination = Subscriber_1.Subscriber.create(function (x) { return socket.readyState === 1 && socket.send(x); }, function (e) {
	                var closingObserver = _this.closingObserver;
	                if (closingObserver) {
	                    closingObserver.next(undefined);
	                }
	                if (e && e.code) {
	                    socket.close(e.code, e.reason);
	                }
	                else {
	                    observer.error(new TypeError('WebSocketSubject.error must be called with an object with an error code, ' +
	                        'and an optional reason: { code: number, reason: string }'));
	                }
	                _this._resetState();
	            }, function () {
	                var closingObserver = _this.closingObserver;
	                if (closingObserver) {
	                    closingObserver.next(undefined);
	                }
	                socket.close();
	                _this._resetState();
	            });
	            if (queue && queue instanceof ReplaySubject_1.ReplaySubject) {
	                subscription.add(queue.subscribe(_this.destination));
	            }
	        };
	        socket.onerror = function (e) {
	            _this._resetState();
	            observer.error(e);
	        };
	        socket.onclose = function (e) {
	            _this._resetState();
	            var closeObserver = _this.closeObserver;
	            if (closeObserver) {
	                closeObserver.next(e);
	            }
	            if (e.wasClean) {
	                observer.complete();
	            }
	            else {
	                observer.error(e);
	            }
	        };
	        socket.onmessage = function (e) {
	            var result = tryCatch_1.tryCatch(_this.resultSelector)(e);
	            if (result === errorObject_1.errorObject) {
	                observer.error(errorObject_1.errorObject.e);
	            }
	            else {
	                observer.next(result);
	            }
	        };
	    };
	    /** @deprecated internal use only */ WebSocketSubject.prototype._subscribe = function (subscriber) {
	        var _this = this;
	        var source = this.source;
	        if (source) {
	            return source.subscribe(subscriber);
	        }
	        if (!this.socket) {
	            this._connectSocket();
	        }
	        var subscription = new Subscription_1.Subscription();
	        subscription.add(this._output.subscribe(subscriber));
	        subscription.add(function () {
	            var socket = _this.socket;
	            if (_this._output.observers.length === 0) {
	                if (socket && socket.readyState === 1) {
	                    socket.close();
	                }
	                _this._resetState();
	            }
	        });
	        return subscription;
	    };
	    WebSocketSubject.prototype.unsubscribe = function () {
	        var _a = this, source = _a.source, socket = _a.socket;
	        if (socket && socket.readyState === 1) {
	            socket.close();
	            this._resetState();
	        }
	        _super.prototype.unsubscribe.call(this);
	        if (!source) {
	            this.destination = new ReplaySubject_1.ReplaySubject();
	        }
	    };
	    return WebSocketSubject;
	}(Subject_1.AnonymousSubject));
	exports.WebSocketSubject = WebSocketSubject;
	//# sourceMappingURL=WebSocketSubject.js.map

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(240);
	var queue_1 = __webpack_require__(384);
	var Subscription_1 = __webpack_require__(211);
	var observeOn_1 = __webpack_require__(281);
	var ObjectUnsubscribedError_1 = __webpack_require__(241);
	var SubjectSubscription_1 = __webpack_require__(242);
	/**
	 * @class ReplaySubject<T>
	 */
	var ReplaySubject = (function (_super) {
	    __extends(ReplaySubject, _super);
	    function ReplaySubject(bufferSize, windowTime, scheduler) {
	        if (bufferSize === void 0) { bufferSize = Number.POSITIVE_INFINITY; }
	        if (windowTime === void 0) { windowTime = Number.POSITIVE_INFINITY; }
	        _super.call(this);
	        this.scheduler = scheduler;
	        this._events = [];
	        this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
	        this._windowTime = windowTime < 1 ? 1 : windowTime;
	    }
	    ReplaySubject.prototype.next = function (value) {
	        var now = this._getNow();
	        this._events.push(new ReplayEvent(now, value));
	        this._trimBufferThenGetEvents();
	        _super.prototype.next.call(this, value);
	    };
	    /** @deprecated internal use only */ ReplaySubject.prototype._subscribe = function (subscriber) {
	        var _events = this._trimBufferThenGetEvents();
	        var scheduler = this.scheduler;
	        var subscription;
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        else if (this.hasError) {
	            subscription = Subscription_1.Subscription.EMPTY;
	        }
	        else if (this.isStopped) {
	            subscription = Subscription_1.Subscription.EMPTY;
	        }
	        else {
	            this.observers.push(subscriber);
	            subscription = new SubjectSubscription_1.SubjectSubscription(this, subscriber);
	        }
	        if (scheduler) {
	            subscriber.add(subscriber = new observeOn_1.ObserveOnSubscriber(subscriber, scheduler));
	        }
	        var len = _events.length;
	        for (var i = 0; i < len && !subscriber.closed; i++) {
	            subscriber.next(_events[i].value);
	        }
	        if (this.hasError) {
	            subscriber.error(this.thrownError);
	        }
	        else if (this.isStopped) {
	            subscriber.complete();
	        }
	        return subscription;
	    };
	    ReplaySubject.prototype._getNow = function () {
	        return (this.scheduler || queue_1.queue).now();
	    };
	    ReplaySubject.prototype._trimBufferThenGetEvents = function () {
	        var now = this._getNow();
	        var _bufferSize = this._bufferSize;
	        var _windowTime = this._windowTime;
	        var _events = this._events;
	        var eventsCount = _events.length;
	        var spliceCount = 0;
	        // Trim events that fall out of the time window.
	        // Start at the front of the list. Break early once
	        // we encounter an event that falls within the window.
	        while (spliceCount < eventsCount) {
	            if ((now - _events[spliceCount].time) < _windowTime) {
	                break;
	            }
	            spliceCount++;
	        }
	        if (eventsCount > _bufferSize) {
	            spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
	        }
	        if (spliceCount > 0) {
	            _events.splice(0, spliceCount);
	        }
	        return _events;
	    };
	    return ReplaySubject;
	}(Subject_1.Subject));
	exports.ReplaySubject = ReplaySubject;
	var ReplayEvent = (function () {
	    function ReplayEvent(time, value) {
	        this.time = time;
	        this.value = value;
	    }
	    return ReplayEvent;
	}());
	//# sourceMappingURL=ReplaySubject.js.map

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var QueueAction_1 = __webpack_require__(385);
	var QueueScheduler_1 = __webpack_require__(386);
	/**
	 *
	 * Queue Scheduler
	 *
	 * <span class="informal">Put every next task on a queue, instead of executing it immediately</span>
	 *
	 * `queue` scheduler, when used with delay, behaves the same as {@link async} scheduler.
	 *
	 * When used without delay, it schedules given task synchronously - executes it right when
	 * it is scheduled. However when called recursively, that is when inside the scheduled task,
	 * another task is scheduled with queue scheduler, instead of executing immediately as well,
	 * that task will be put on a queue and wait for current one to finish.
	 *
	 * This means that when you execute task with `queue` scheduler, you are sure it will end
	 * before any other task scheduled with that scheduler will start.
	 *
	 * @examples <caption>Schedule recursively first, then do something</caption>
	 *
	 * Rx.Scheduler.queue.schedule(() => {
	 *   Rx.Scheduler.queue.schedule(() => console.log('second')); // will not happen now, but will be put on a queue
	 *
	 *   console.log('first');
	 * });
	 *
	 * // Logs:
	 * // "first"
	 * // "second"
	 *
	 *
	 * @example <caption>Reschedule itself recursively</caption>
	 *
	 * Rx.Scheduler.queue.schedule(function(state) {
	 *   if (state !== 0) {
	 *     console.log('before', state);
	 *     this.schedule(state - 1); // `this` references currently executing Action,
	 *                               // which we reschedule with new state
	 *     console.log('after', state);
	 *   }
	 * }, 0, 3);
	 *
	 * // In scheduler that runs recursively, you would expect:
	 * // "before", 3
	 * // "before", 2
	 * // "before", 1
	 * // "after", 1
	 * // "after", 2
	 * // "after", 3
	 *
	 * // But with queue it logs:
	 * // "before", 3
	 * // "after", 3
	 * // "before", 2
	 * // "after", 2
	 * // "before", 1
	 * // "after", 1
	 *
	 *
	 * @static true
	 * @name queue
	 * @owner Scheduler
	 */
	exports.queue = new QueueScheduler_1.QueueScheduler(QueueAction_1.QueueAction);
	//# sourceMappingURL=queue.js.map

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncAction_1 = __webpack_require__(344);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var QueueAction = (function (_super) {
	    __extends(QueueAction, _super);
	    function QueueAction(scheduler, work) {
	        _super.call(this, scheduler, work);
	        this.scheduler = scheduler;
	        this.work = work;
	    }
	    QueueAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (delay > 0) {
	            return _super.prototype.schedule.call(this, state, delay);
	        }
	        this.delay = delay;
	        this.state = state;
	        this.scheduler.flush(this);
	        return this;
	    };
	    QueueAction.prototype.execute = function (state, delay) {
	        return (delay > 0 || this.closed) ?
	            _super.prototype.execute.call(this, state, delay) :
	            this._execute(state, delay);
	    };
	    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If delay exists and is greater than 0, or if the delay is null (the
	        // action wasn't rescheduled) but was originally scheduled as an async
	        // action, then recycle as an async action.
	        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        // Otherwise flush the scheduler starting with this action.
	        return scheduler.flush(this);
	    };
	    return QueueAction;
	}(AsyncAction_1.AsyncAction));
	exports.QueueAction = QueueAction;
	//# sourceMappingURL=QueueAction.js.map

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncScheduler_1 = __webpack_require__(346);
	var QueueScheduler = (function (_super) {
	    __extends(QueueScheduler, _super);
	    function QueueScheduler() {
	        _super.apply(this, arguments);
	    }
	    return QueueScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.QueueScheduler = QueueScheduler;
	//# sourceMappingURL=QueueScheduler.js.map

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(207);
	function assignImpl(target) {
	    var sources = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        sources[_i - 1] = arguments[_i];
	    }
	    var len = sources.length;
	    for (var i = 0; i < len; i++) {
	        var source = sources[i];
	        for (var k in source) {
	            if (source.hasOwnProperty(k)) {
	                target[k] = source[k];
	            }
	        }
	    }
	    return target;
	}
	exports.assignImpl = assignImpl;
	;
	function getAssign(root) {
	    return root.Object.assign || assignImpl;
	}
	exports.getAssign = getAssign;
	exports.assign = getAssign(root_1.root);
	//# sourceMappingURL=assign.js.map

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var buffer_1 = __webpack_require__(389);
	Observable_1.Observable.prototype.buffer = buffer_1.buffer;
	//# sourceMappingURL=buffer.js.map

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var buffer_1 = __webpack_require__(390);
	/**
	 * Buffers the source Observable values until `closingNotifier` emits.
	 *
	 * <span class="informal">Collects values from the past as an array, and emits
	 * that array only when another Observable emits.</span>
	 *
	 * <img src="./img/buffer.png" width="100%">
	 *
	 * Buffers the incoming Observable values until the given `closingNotifier`
	 * Observable emits a value, at which point it emits the buffer on the output
	 * Observable and starts a new buffer internally, awaiting the next time
	 * `closingNotifier` emits.
	 *
	 * @example <caption>On every click, emit array of most recent interval events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var interval = Rx.Observable.interval(1000);
	 * var buffered = interval.buffer(clicks);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link bufferCount}
	 * @see {@link bufferTime}
	 * @see {@link bufferToggle}
	 * @see {@link bufferWhen}
	 * @see {@link window}
	 *
	 * @param {Observable<any>} closingNotifier An Observable that signals the
	 * buffer to be emitted on the output Observable.
	 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
	 * values.
	 * @method buffer
	 * @owner Observable
	 */
	function buffer(closingNotifier) {
	    return buffer_1.buffer(closingNotifier)(this);
	}
	exports.buffer = buffer;
	//# sourceMappingURL=buffer.js.map

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/**
	 * Buffers the source Observable values until `closingNotifier` emits.
	 *
	 * <span class="informal">Collects values from the past as an array, and emits
	 * that array only when another Observable emits.</span>
	 *
	 * <img src="./img/buffer.png" width="100%">
	 *
	 * Buffers the incoming Observable values until the given `closingNotifier`
	 * Observable emits a value, at which point it emits the buffer on the output
	 * Observable and starts a new buffer internally, awaiting the next time
	 * `closingNotifier` emits.
	 *
	 * @example <caption>On every click, emit array of most recent interval events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var interval = Rx.Observable.interval(1000);
	 * var buffered = interval.buffer(clicks);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link bufferCount}
	 * @see {@link bufferTime}
	 * @see {@link bufferToggle}
	 * @see {@link bufferWhen}
	 * @see {@link window}
	 *
	 * @param {Observable<any>} closingNotifier An Observable that signals the
	 * buffer to be emitted on the output Observable.
	 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
	 * values.
	 * @method buffer
	 * @owner Observable
	 */
	function buffer(closingNotifier) {
	    return function bufferOperatorFunction(source) {
	        return source.lift(new BufferOperator(closingNotifier));
	    };
	}
	exports.buffer = buffer;
	var BufferOperator = (function () {
	    function BufferOperator(closingNotifier) {
	        this.closingNotifier = closingNotifier;
	    }
	    BufferOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
	    };
	    return BufferOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferSubscriber = (function (_super) {
	    __extends(BufferSubscriber, _super);
	    function BufferSubscriber(destination, closingNotifier) {
	        _super.call(this, destination);
	        this.buffer = [];
	        this.add(subscribeToResult_1.subscribeToResult(this, closingNotifier));
	    }
	    BufferSubscriber.prototype._next = function (value) {
	        this.buffer.push(value);
	    };
	    BufferSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var buffer = this.buffer;
	        this.buffer = [];
	        this.destination.next(buffer);
	    };
	    return BufferSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=buffer.js.map

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var bufferCount_1 = __webpack_require__(392);
	Observable_1.Observable.prototype.bufferCount = bufferCount_1.bufferCount;
	//# sourceMappingURL=bufferCount.js.map

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var bufferCount_1 = __webpack_require__(393);
	/**
	 * Buffers the source Observable values until the size hits the maximum
	 * `bufferSize` given.
	 *
	 * <span class="informal">Collects values from the past as an array, and emits
	 * that array only when its size reaches `bufferSize`.</span>
	 *
	 * <img src="./img/bufferCount.png" width="100%">
	 *
	 * Buffers a number of values from the source Observable by `bufferSize` then
	 * emits the buffer and clears it, and starts a new buffer each
	 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
	 * `null`, then new buffers are started immediately at the start of the source
	 * and when each buffer closes and is emitted.
	 *
	 * @example <caption>Emit the last two click events as an array</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferCount(2);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @example <caption>On every click, emit the last two click events as an array</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferCount(2, 1);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferTime}
	 * @see {@link bufferToggle}
	 * @see {@link bufferWhen}
	 * @see {@link pairwise}
	 * @see {@link windowCount}
	 *
	 * @param {number} bufferSize The maximum size of the buffer emitted.
	 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
	 * For example if `startBufferEvery` is `2`, then a new buffer will be started
	 * on every other value from the source. A new buffer is started at the
	 * beginning of the source by default.
	 * @return {Observable<T[]>} An Observable of arrays of buffered values.
	 * @method bufferCount
	 * @owner Observable
	 */
	function bufferCount(bufferSize, startBufferEvery) {
	    if (startBufferEvery === void 0) { startBufferEvery = null; }
	    return bufferCount_1.bufferCount(bufferSize, startBufferEvery)(this);
	}
	exports.bufferCount = bufferCount;
	//# sourceMappingURL=bufferCount.js.map

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	/**
	 * Buffers the source Observable values until the size hits the maximum
	 * `bufferSize` given.
	 *
	 * <span class="informal">Collects values from the past as an array, and emits
	 * that array only when its size reaches `bufferSize`.</span>
	 *
	 * <img src="./img/bufferCount.png" width="100%">
	 *
	 * Buffers a number of values from the source Observable by `bufferSize` then
	 * emits the buffer and clears it, and starts a new buffer each
	 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
	 * `null`, then new buffers are started immediately at the start of the source
	 * and when each buffer closes and is emitted.
	 *
	 * @example <caption>Emit the last two click events as an array</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferCount(2);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @example <caption>On every click, emit the last two click events as an array</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferCount(2, 1);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferTime}
	 * @see {@link bufferToggle}
	 * @see {@link bufferWhen}
	 * @see {@link pairwise}
	 * @see {@link windowCount}
	 *
	 * @param {number} bufferSize The maximum size of the buffer emitted.
	 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
	 * For example if `startBufferEvery` is `2`, then a new buffer will be started
	 * on every other value from the source. A new buffer is started at the
	 * beginning of the source by default.
	 * @return {Observable<T[]>} An Observable of arrays of buffered values.
	 * @method bufferCount
	 * @owner Observable
	 */
	function bufferCount(bufferSize, startBufferEvery) {
	    if (startBufferEvery === void 0) { startBufferEvery = null; }
	    return function bufferCountOperatorFunction(source) {
	        return source.lift(new BufferCountOperator(bufferSize, startBufferEvery));
	    };
	}
	exports.bufferCount = bufferCount;
	var BufferCountOperator = (function () {
	    function BufferCountOperator(bufferSize, startBufferEvery) {
	        this.bufferSize = bufferSize;
	        this.startBufferEvery = startBufferEvery;
	        if (!startBufferEvery || bufferSize === startBufferEvery) {
	            this.subscriberClass = BufferCountSubscriber;
	        }
	        else {
	            this.subscriberClass = BufferSkipCountSubscriber;
	        }
	    }
	    BufferCountOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
	    };
	    return BufferCountOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferCountSubscriber = (function (_super) {
	    __extends(BufferCountSubscriber, _super);
	    function BufferCountSubscriber(destination, bufferSize) {
	        _super.call(this, destination);
	        this.bufferSize = bufferSize;
	        this.buffer = [];
	    }
	    BufferCountSubscriber.prototype._next = function (value) {
	        var buffer = this.buffer;
	        buffer.push(value);
	        if (buffer.length == this.bufferSize) {
	            this.destination.next(buffer);
	            this.buffer = [];
	        }
	    };
	    BufferCountSubscriber.prototype._complete = function () {
	        var buffer = this.buffer;
	        if (buffer.length > 0) {
	            this.destination.next(buffer);
	        }
	        _super.prototype._complete.call(this);
	    };
	    return BufferCountSubscriber;
	}(Subscriber_1.Subscriber));
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferSkipCountSubscriber = (function (_super) {
	    __extends(BufferSkipCountSubscriber, _super);
	    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
	        _super.call(this, destination);
	        this.bufferSize = bufferSize;
	        this.startBufferEvery = startBufferEvery;
	        this.buffers = [];
	        this.count = 0;
	    }
	    BufferSkipCountSubscriber.prototype._next = function (value) {
	        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
	        this.count++;
	        if (count % startBufferEvery === 0) {
	            buffers.push([]);
	        }
	        for (var i = buffers.length; i--;) {
	            var buffer = buffers[i];
	            buffer.push(value);
	            if (buffer.length === bufferSize) {
	                buffers.splice(i, 1);
	                this.destination.next(buffer);
	            }
	        }
	    };
	    BufferSkipCountSubscriber.prototype._complete = function () {
	        var _a = this, buffers = _a.buffers, destination = _a.destination;
	        while (buffers.length > 0) {
	            var buffer = buffers.shift();
	            if (buffer.length > 0) {
	                destination.next(buffer);
	            }
	        }
	        _super.prototype._complete.call(this);
	    };
	    return BufferSkipCountSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=bufferCount.js.map

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var bufferTime_1 = __webpack_require__(395);
	Observable_1.Observable.prototype.bufferTime = bufferTime_1.bufferTime;
	//# sourceMappingURL=bufferTime.js.map

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(343);
	var isScheduler_1 = __webpack_require__(226);
	var bufferTime_1 = __webpack_require__(396);
	/* tslint:enable:max-line-length */
	/**
	 * Buffers the source Observable values for a specific time period.
	 *
	 * <span class="informal">Collects values from the past as an array, and emits
	 * those arrays periodically in time.</span>
	 *
	 * <img src="./img/bufferTime.png" width="100%">
	 *
	 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
	 * Unless the optional argument `bufferCreationInterval` is given, it emits and
	 * resets the buffer every `bufferTimeSpan` milliseconds. If
	 * `bufferCreationInterval` is given, this operator opens the buffer every
	 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
	 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
	 * `maxBufferSize` is specified, the buffer will be closed either after
	 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
	 *
	 * @example <caption>Every second, emit an array of the recent click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferTime(1000);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferTime(2000, 5000);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 * @see {@link bufferToggle}
	 * @see {@link bufferWhen}
	 * @see {@link windowTime}
	 *
	 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
	 * @param {number} [bufferCreationInterval] The interval at which to start new
	 * buffers.
	 * @param {number} [maxBufferSize] The maximum buffer size.
	 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
	 * intervals that determine buffer boundaries.
	 * @return {Observable<T[]>} An observable of arrays of buffered values.
	 * @method bufferTime
	 * @owner Observable
	 */
	function bufferTime(bufferTimeSpan) {
	    var length = arguments.length;
	    var scheduler = async_1.async;
	    if (isScheduler_1.isScheduler(arguments[arguments.length - 1])) {
	        scheduler = arguments[arguments.length - 1];
	        length--;
	    }
	    var bufferCreationInterval = null;
	    if (length >= 2) {
	        bufferCreationInterval = arguments[1];
	    }
	    var maxBufferSize = Number.POSITIVE_INFINITY;
	    if (length >= 3) {
	        maxBufferSize = arguments[2];
	    }
	    return bufferTime_1.bufferTime(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler)(this);
	}
	exports.bufferTime = bufferTime;
	//# sourceMappingURL=bufferTime.js.map

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var async_1 = __webpack_require__(343);
	var Subscriber_1 = __webpack_require__(209);
	var isScheduler_1 = __webpack_require__(226);
	/* tslint:enable:max-line-length */
	/**
	 * Buffers the source Observable values for a specific time period.
	 *
	 * <span class="informal">Collects values from the past as an array, and emits
	 * those arrays periodically in time.</span>
	 *
	 * <img src="./img/bufferTime.png" width="100%">
	 *
	 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
	 * Unless the optional argument `bufferCreationInterval` is given, it emits and
	 * resets the buffer every `bufferTimeSpan` milliseconds. If
	 * `bufferCreationInterval` is given, this operator opens the buffer every
	 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
	 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
	 * `maxBufferSize` is specified, the buffer will be closed either after
	 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
	 *
	 * @example <caption>Every second, emit an array of the recent click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferTime(1000);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferTime(2000, 5000);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 * @see {@link bufferToggle}
	 * @see {@link bufferWhen}
	 * @see {@link windowTime}
	 *
	 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
	 * @param {number} [bufferCreationInterval] The interval at which to start new
	 * buffers.
	 * @param {number} [maxBufferSize] The maximum buffer size.
	 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
	 * intervals that determine buffer boundaries.
	 * @return {Observable<T[]>} An observable of arrays of buffered values.
	 * @method bufferTime
	 * @owner Observable
	 */
	function bufferTime(bufferTimeSpan) {
	    var length = arguments.length;
	    var scheduler = async_1.async;
	    if (isScheduler_1.isScheduler(arguments[arguments.length - 1])) {
	        scheduler = arguments[arguments.length - 1];
	        length--;
	    }
	    var bufferCreationInterval = null;
	    if (length >= 2) {
	        bufferCreationInterval = arguments[1];
	    }
	    var maxBufferSize = Number.POSITIVE_INFINITY;
	    if (length >= 3) {
	        maxBufferSize = arguments[2];
	    }
	    return function bufferTimeOperatorFunction(source) {
	        return source.lift(new BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
	    };
	}
	exports.bufferTime = bufferTime;
	var BufferTimeOperator = (function () {
	    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
	        this.bufferTimeSpan = bufferTimeSpan;
	        this.bufferCreationInterval = bufferCreationInterval;
	        this.maxBufferSize = maxBufferSize;
	        this.scheduler = scheduler;
	    }
	    BufferTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
	    };
	    return BufferTimeOperator;
	}());
	var Context = (function () {
	    function Context() {
	        this.buffer = [];
	    }
	    return Context;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferTimeSubscriber = (function (_super) {
	    __extends(BufferTimeSubscriber, _super);
	    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
	        _super.call(this, destination);
	        this.bufferTimeSpan = bufferTimeSpan;
	        this.bufferCreationInterval = bufferCreationInterval;
	        this.maxBufferSize = maxBufferSize;
	        this.scheduler = scheduler;
	        this.contexts = [];
	        var context = this.openContext();
	        this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
	        if (this.timespanOnly) {
	            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
	            this.add(context.closeAction = scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
	        }
	        else {
	            var closeState = { subscriber: this, context: context };
	            var creationState = { bufferTimeSpan: bufferTimeSpan, bufferCreationInterval: bufferCreationInterval, subscriber: this, scheduler: scheduler };
	            this.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, closeState));
	            this.add(scheduler.schedule(dispatchBufferCreation, bufferCreationInterval, creationState));
	        }
	    }
	    BufferTimeSubscriber.prototype._next = function (value) {
	        var contexts = this.contexts;
	        var len = contexts.length;
	        var filledBufferContext;
	        for (var i = 0; i < len; i++) {
	            var context = contexts[i];
	            var buffer = context.buffer;
	            buffer.push(value);
	            if (buffer.length == this.maxBufferSize) {
	                filledBufferContext = context;
	            }
	        }
	        if (filledBufferContext) {
	            this.onBufferFull(filledBufferContext);
	        }
	    };
	    BufferTimeSubscriber.prototype._error = function (err) {
	        this.contexts.length = 0;
	        _super.prototype._error.call(this, err);
	    };
	    BufferTimeSubscriber.prototype._complete = function () {
	        var _a = this, contexts = _a.contexts, destination = _a.destination;
	        while (contexts.length > 0) {
	            var context = contexts.shift();
	            destination.next(context.buffer);
	        }
	        _super.prototype._complete.call(this);
	    };
	    /** @deprecated internal use only */ BufferTimeSubscriber.prototype._unsubscribe = function () {
	        this.contexts = null;
	    };
	    BufferTimeSubscriber.prototype.onBufferFull = function (context) {
	        this.closeContext(context);
	        var closeAction = context.closeAction;
	        closeAction.unsubscribe();
	        this.remove(closeAction);
	        if (!this.closed && this.timespanOnly) {
	            context = this.openContext();
	            var bufferTimeSpan = this.bufferTimeSpan;
	            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
	            this.add(context.closeAction = this.scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
	        }
	    };
	    BufferTimeSubscriber.prototype.openContext = function () {
	        var context = new Context();
	        this.contexts.push(context);
	        return context;
	    };
	    BufferTimeSubscriber.prototype.closeContext = function (context) {
	        this.destination.next(context.buffer);
	        var contexts = this.contexts;
	        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
	        if (spliceIndex >= 0) {
	            contexts.splice(contexts.indexOf(context), 1);
	        }
	    };
	    return BufferTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchBufferTimeSpanOnly(state) {
	    var subscriber = state.subscriber;
	    var prevContext = state.context;
	    if (prevContext) {
	        subscriber.closeContext(prevContext);
	    }
	    if (!subscriber.closed) {
	        state.context = subscriber.openContext();
	        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
	    }
	}
	function dispatchBufferCreation(state) {
	    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
	    var context = subscriber.openContext();
	    var action = this;
	    if (!subscriber.closed) {
	        subscriber.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, { subscriber: subscriber, context: context }));
	        action.schedule(state, bufferCreationInterval);
	    }
	}
	function dispatchBufferClose(arg) {
	    var subscriber = arg.subscriber, context = arg.context;
	    subscriber.closeContext(context);
	}
	//# sourceMappingURL=bufferTime.js.map

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var bufferToggle_1 = __webpack_require__(398);
	Observable_1.Observable.prototype.bufferToggle = bufferToggle_1.bufferToggle;
	//# sourceMappingURL=bufferToggle.js.map

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var bufferToggle_1 = __webpack_require__(399);
	/**
	 * Buffers the source Observable values starting from an emission from
	 * `openings` and ending when the output of `closingSelector` emits.
	 *
	 * <span class="informal">Collects values from the past as an array. Starts
	 * collecting only when `opening` emits, and calls the `closingSelector`
	 * function to get an Observable that tells when to close the buffer.</span>
	 *
	 * <img src="./img/bufferToggle.png" width="100%">
	 *
	 * Buffers values from the source by opening the buffer via signals from an
	 * Observable provided to `openings`, and closing and sending the buffers when
	 * a Subscribable or Promise returned by the `closingSelector` function emits.
	 *
	 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var openings = Rx.Observable.interval(1000);
	 * var buffered = clicks.bufferToggle(openings, i =>
	 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
	 * );
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 * @see {@link bufferTime}
	 * @see {@link bufferWhen}
	 * @see {@link windowToggle}
	 *
	 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
	 * buffers.
	 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
	 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
	 * which, when it emits, signals that the associated buffer should be emitted
	 * and cleared.
	 * @return {Observable<T[]>} An observable of arrays of buffered values.
	 * @method bufferToggle
	 * @owner Observable
	 */
	function bufferToggle(openings, closingSelector) {
	    return bufferToggle_1.bufferToggle(openings, closingSelector)(this);
	}
	exports.bufferToggle = bufferToggle;
	//# sourceMappingURL=bufferToggle.js.map

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscription_1 = __webpack_require__(211);
	var subscribeToResult_1 = __webpack_require__(229);
	var OuterSubscriber_1 = __webpack_require__(234);
	/**
	 * Buffers the source Observable values starting from an emission from
	 * `openings` and ending when the output of `closingSelector` emits.
	 *
	 * <span class="informal">Collects values from the past as an array. Starts
	 * collecting only when `opening` emits, and calls the `closingSelector`
	 * function to get an Observable that tells when to close the buffer.</span>
	 *
	 * <img src="./img/bufferToggle.png" width="100%">
	 *
	 * Buffers values from the source by opening the buffer via signals from an
	 * Observable provided to `openings`, and closing and sending the buffers when
	 * a Subscribable or Promise returned by the `closingSelector` function emits.
	 *
	 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var openings = Rx.Observable.interval(1000);
	 * var buffered = clicks.bufferToggle(openings, i =>
	 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
	 * );
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 * @see {@link bufferTime}
	 * @see {@link bufferWhen}
	 * @see {@link windowToggle}
	 *
	 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
	 * buffers.
	 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
	 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
	 * which, when it emits, signals that the associated buffer should be emitted
	 * and cleared.
	 * @return {Observable<T[]>} An observable of arrays of buffered values.
	 * @method bufferToggle
	 * @owner Observable
	 */
	function bufferToggle(openings, closingSelector) {
	    return function bufferToggleOperatorFunction(source) {
	        return source.lift(new BufferToggleOperator(openings, closingSelector));
	    };
	}
	exports.bufferToggle = bufferToggle;
	var BufferToggleOperator = (function () {
	    function BufferToggleOperator(openings, closingSelector) {
	        this.openings = openings;
	        this.closingSelector = closingSelector;
	    }
	    BufferToggleOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
	    };
	    return BufferToggleOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferToggleSubscriber = (function (_super) {
	    __extends(BufferToggleSubscriber, _super);
	    function BufferToggleSubscriber(destination, openings, closingSelector) {
	        _super.call(this, destination);
	        this.openings = openings;
	        this.closingSelector = closingSelector;
	        this.contexts = [];
	        this.add(subscribeToResult_1.subscribeToResult(this, openings));
	    }
	    BufferToggleSubscriber.prototype._next = function (value) {
	        var contexts = this.contexts;
	        var len = contexts.length;
	        for (var i = 0; i < len; i++) {
	            contexts[i].buffer.push(value);
	        }
	    };
	    BufferToggleSubscriber.prototype._error = function (err) {
	        var contexts = this.contexts;
	        while (contexts.length > 0) {
	            var context = contexts.shift();
	            context.subscription.unsubscribe();
	            context.buffer = null;
	            context.subscription = null;
	        }
	        this.contexts = null;
	        _super.prototype._error.call(this, err);
	    };
	    BufferToggleSubscriber.prototype._complete = function () {
	        var contexts = this.contexts;
	        while (contexts.length > 0) {
	            var context = contexts.shift();
	            this.destination.next(context.buffer);
	            context.subscription.unsubscribe();
	            context.buffer = null;
	            context.subscription = null;
	        }
	        this.contexts = null;
	        _super.prototype._complete.call(this);
	    };
	    BufferToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
	    };
	    BufferToggleSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.closeBuffer(innerSub.context);
	    };
	    BufferToggleSubscriber.prototype.openBuffer = function (value) {
	        try {
	            var closingSelector = this.closingSelector;
	            var closingNotifier = closingSelector.call(this, value);
	            if (closingNotifier) {
	                this.trySubscribe(closingNotifier);
	            }
	        }
	        catch (err) {
	            this._error(err);
	        }
	    };
	    BufferToggleSubscriber.prototype.closeBuffer = function (context) {
	        var contexts = this.contexts;
	        if (contexts && context) {
	            var buffer = context.buffer, subscription = context.subscription;
	            this.destination.next(buffer);
	            contexts.splice(contexts.indexOf(context), 1);
	            this.remove(subscription);
	            subscription.unsubscribe();
	        }
	    };
	    BufferToggleSubscriber.prototype.trySubscribe = function (closingNotifier) {
	        var contexts = this.contexts;
	        var buffer = [];
	        var subscription = new Subscription_1.Subscription();
	        var context = { buffer: buffer, subscription: subscription };
	        contexts.push(context);
	        var innerSubscription = subscribeToResult_1.subscribeToResult(this, closingNotifier, context);
	        if (!innerSubscription || innerSubscription.closed) {
	            this.closeBuffer(context);
	        }
	        else {
	            innerSubscription.context = context;
	            this.add(innerSubscription);
	            subscription.add(innerSubscription);
	        }
	    };
	    return BufferToggleSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=bufferToggle.js.map

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var bufferWhen_1 = __webpack_require__(401);
	Observable_1.Observable.prototype.bufferWhen = bufferWhen_1.bufferWhen;
	//# sourceMappingURL=bufferWhen.js.map

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var bufferWhen_1 = __webpack_require__(402);
	/**
	 * Buffers the source Observable values, using a factory function of closing
	 * Observables to determine when to close, emit, and reset the buffer.
	 *
	 * <span class="informal">Collects values from the past as an array. When it
	 * starts collecting values, it calls a function that returns an Observable that
	 * tells when to close the buffer and restart collecting.</span>
	 *
	 * <img src="./img/bufferWhen.png" width="100%">
	 *
	 * Opens a buffer immediately, then closes the buffer when the observable
	 * returned by calling `closingSelector` function emits a value. When it closes
	 * the buffer, it immediately opens a new buffer and repeats the process.
	 *
	 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferWhen(() =>
	 *   Rx.Observable.interval(1000 + Math.random() * 4000)
	 * );
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 * @see {@link bufferTime}
	 * @see {@link bufferToggle}
	 * @see {@link windowWhen}
	 *
	 * @param {function(): Observable} closingSelector A function that takes no
	 * arguments and returns an Observable that signals buffer closure.
	 * @return {Observable<T[]>} An observable of arrays of buffered values.
	 * @method bufferWhen
	 * @owner Observable
	 */
	function bufferWhen(closingSelector) {
	    return bufferWhen_1.bufferWhen(closingSelector)(this);
	}
	exports.bufferWhen = bufferWhen;
	//# sourceMappingURL=bufferWhen.js.map

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscription_1 = __webpack_require__(211);
	var tryCatch_1 = __webpack_require__(214);
	var errorObject_1 = __webpack_require__(215);
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/**
	 * Buffers the source Observable values, using a factory function of closing
	 * Observables to determine when to close, emit, and reset the buffer.
	 *
	 * <span class="informal">Collects values from the past as an array. When it
	 * starts collecting values, it calls a function that returns an Observable that
	 * tells when to close the buffer and restart collecting.</span>
	 *
	 * <img src="./img/bufferWhen.png" width="100%">
	 *
	 * Opens a buffer immediately, then closes the buffer when the observable
	 * returned by calling `closingSelector` function emits a value. When it closes
	 * the buffer, it immediately opens a new buffer and repeats the process.
	 *
	 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferWhen(() =>
	 *   Rx.Observable.interval(1000 + Math.random() * 4000)
	 * );
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 * @see {@link bufferTime}
	 * @see {@link bufferToggle}
	 * @see {@link windowWhen}
	 *
	 * @param {function(): Observable} closingSelector A function that takes no
	 * arguments and returns an Observable that signals buffer closure.
	 * @return {Observable<T[]>} An observable of arrays of buffered values.
	 * @method bufferWhen
	 * @owner Observable
	 */
	function bufferWhen(closingSelector) {
	    return function (source) {
	        return source.lift(new BufferWhenOperator(closingSelector));
	    };
	}
	exports.bufferWhen = bufferWhen;
	var BufferWhenOperator = (function () {
	    function BufferWhenOperator(closingSelector) {
	        this.closingSelector = closingSelector;
	    }
	    BufferWhenOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new BufferWhenSubscriber(subscriber, this.closingSelector));
	    };
	    return BufferWhenOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferWhenSubscriber = (function (_super) {
	    __extends(BufferWhenSubscriber, _super);
	    function BufferWhenSubscriber(destination, closingSelector) {
	        _super.call(this, destination);
	        this.closingSelector = closingSelector;
	        this.subscribing = false;
	        this.openBuffer();
	    }
	    BufferWhenSubscriber.prototype._next = function (value) {
	        this.buffer.push(value);
	    };
	    BufferWhenSubscriber.prototype._complete = function () {
	        var buffer = this.buffer;
	        if (buffer) {
	            this.destination.next(buffer);
	        }
	        _super.prototype._complete.call(this);
	    };
	    /** @deprecated internal use only */ BufferWhenSubscriber.prototype._unsubscribe = function () {
	        this.buffer = null;
	        this.subscribing = false;
	    };
	    BufferWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.openBuffer();
	    };
	    BufferWhenSubscriber.prototype.notifyComplete = function () {
	        if (this.subscribing) {
	            this.complete();
	        }
	        else {
	            this.openBuffer();
	        }
	    };
	    BufferWhenSubscriber.prototype.openBuffer = function () {
	        var closingSubscription = this.closingSubscription;
	        if (closingSubscription) {
	            this.remove(closingSubscription);
	            closingSubscription.unsubscribe();
	        }
	        var buffer = this.buffer;
	        if (this.buffer) {
	            this.destination.next(buffer);
	        }
	        this.buffer = [];
	        var closingNotifier = tryCatch_1.tryCatch(this.closingSelector)();
	        if (closingNotifier === errorObject_1.errorObject) {
	            this.error(errorObject_1.errorObject.e);
	        }
	        else {
	            closingSubscription = new Subscription_1.Subscription();
	            this.closingSubscription = closingSubscription;
	            this.add(closingSubscription);
	            this.subscribing = true;
	            closingSubscription.add(subscribeToResult_1.subscribeToResult(this, closingNotifier));
	            this.subscribing = false;
	        }
	    };
	    return BufferWhenSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=bufferWhen.js.map

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var catch_1 = __webpack_require__(283);
	Observable_1.Observable.prototype.catch = catch_1._catch;
	Observable_1.Observable.prototype._catch = catch_1._catch;
	//# sourceMappingURL=catch.js.map

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var combineAll_1 = __webpack_require__(405);
	Observable_1.Observable.prototype.combineAll = combineAll_1.combineAll;
	//# sourceMappingURL=combineAll.js.map

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var combineAll_1 = __webpack_require__(406);
	/**
	 * Converts a higher-order Observable into a first-order Observable by waiting
	 * for the outer Observable to complete, then applying {@link combineLatest}.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by applying
	 * {@link combineLatest} when the Observable-of-Observables completes.</span>
	 *
	 * <img src="./img/combineAll.png" width="100%">
	 *
	 * Takes an Observable of Observables, and collects all Observables from it.
	 * Once the outer Observable completes, it subscribes to all collected
	 * Observables and combines their values using the {@link combineLatest}
	 * strategy, such that:
	 * - Every time an inner Observable emits, the output Observable emits.
	 * - When the returned observable emits, it emits all of the latest values by:
	 *   - If a `project` function is provided, it is called with each recent value
	 *     from each inner Observable in whatever order they arrived, and the result
	 *     of the `project` function is what is emitted by the output Observable.
	 *   - If there is no `project` function, an array of all of the most recent
	 *     values is emitted by the output Observable.
	 *
	 * @example <caption>Map two click events to a finite interval Observable, then apply combineAll</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map(ev =>
	 *   Rx.Observable.interval(Math.random()*2000).take(3)
	 * ).take(2);
	 * var result = higherOrder.combineAll();
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link combineLatest}
	 * @see {@link mergeAll}
	 *
	 * @param {function} [project] An optional function to map the most recent
	 * values from each inner Observable into a new result. Takes each of the most
	 * recent values from each collected inner Observable as arguments, in order.
	 * @return {Observable} An Observable of projected results or arrays of recent
	 * values.
	 * @method combineAll
	 * @owner Observable
	 */
	function combineAll(project) {
	    return combineAll_1.combineAll(project)(this);
	}
	exports.combineAll = combineAll;
	//# sourceMappingURL=combineAll.js.map

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var combineLatest_1 = __webpack_require__(314);
	function combineAll(project) {
	    return function (source) { return source.lift(new combineLatest_1.CombineLatestOperator(project)); };
	}
	exports.combineAll = combineAll;
	//# sourceMappingURL=combineAll.js.map

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var combineLatest_1 = __webpack_require__(408);
	Observable_1.Observable.prototype.combineLatest = combineLatest_1.combineLatest;
	//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var combineLatest_1 = __webpack_require__(314);
	/* tslint:enable:max-line-length */
	/**
	 * Combines multiple Observables to create an Observable whose values are
	 * calculated from the latest values of each of its input Observables.
	 *
	 * <span class="informal">Whenever any input Observable emits a value, it
	 * computes a formula using the latest values from all the inputs, then emits
	 * the output of that formula.</span>
	 *
	 * <img src="./img/combineLatest.png" width="100%">
	 *
	 * `combineLatest` combines the values from this Observable with values from
	 * Observables passed as arguments. This is done by subscribing to each
	 * Observable, in order, and collecting an array of each of the most recent
	 * values any time any of the input Observables emits, then either taking that
	 * array and passing it as arguments to an optional `project` function and
	 * emitting the return value of that, or just emitting the array of recent
	 * values directly if there is no `project` function.
	 *
	 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
	 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
	 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
	 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
	 * bmi.subscribe(x => console.log('BMI is ' + x));
	 *
	 * // With output to console:
	 * // BMI is 24.212293388429753
	 * // BMI is 23.93948099205209
	 * // BMI is 23.671253629592222
	 *
	 * @see {@link combineAll}
	 * @see {@link merge}
	 * @see {@link withLatestFrom}
	 *
	 * @param {ObservableInput} other An input Observable to combine with the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {function} [project] An optional function to project the values from
	 * the combined latest values into a new value on the output Observable.
	 * @return {Observable} An Observable of projected values from the most recent
	 * values from each input Observable, or an array of the most recent values from
	 * each input Observable.
	 * @method combineLatest
	 * @owner Observable
	 */
	function combineLatest() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return combineLatest_1.combineLatest.apply(void 0, observables)(this);
	}
	exports.combineLatest = combineLatest;
	//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var concat_1 = __webpack_require__(410);
	Observable_1.Observable.prototype.concat = concat_1.concat;
	//# sourceMappingURL=concat.js.map

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var concat_1 = __webpack_require__(411);
	var concat_2 = __webpack_require__(316);
	exports.concatStatic = concat_2.concat;
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which sequentially emits all values from every
	 * given input Observable after the current Observable.
	 *
	 * <span class="informal">Concatenates multiple Observables together by
	 * sequentially emitting their values, one Observable after the other.</span>
	 *
	 * <img src="./img/concat.png" width="100%">
	 *
	 * Joins this Observable with multiple other Observables by subscribing to them
	 * one at a time, starting with the source, and merging their results into the
	 * output Observable. Will wait for each Observable to complete before moving
	 * on to the next.
	 *
	 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
	 * var timer = Rx.Observable.interval(1000).take(4);
	 * var sequence = Rx.Observable.range(1, 10);
	 * var result = timer.concat(sequence);
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in:
	 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
	 *
	 * @example <caption>Concatenate 3 Observables</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var result = timer1.concat(timer2, timer3);
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in the following:
	 * // (Prints to console sequentially)
	 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
	 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
	 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
	 *
	 * @see {@link concatAll}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 *
	 * @param {ObservableInput} other An input Observable to concatenate after the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
	 * Observable subscription on.
	 * @return {Observable} All values of each passed Observable merged into a
	 * single Observable, in order, in serial fashion.
	 * @method concat
	 * @owner Observable
	 */
	function concat() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return concat_1.concat.apply(void 0, observables)(this);
	}
	exports.concat = concat;
	//# sourceMappingURL=concat.js.map

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var concat_1 = __webpack_require__(316);
	var concat_2 = __webpack_require__(316);
	exports.concatStatic = concat_2.concat;
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which sequentially emits all values from every
	 * given input Observable after the current Observable.
	 *
	 * <span class="informal">Concatenates multiple Observables together by
	 * sequentially emitting their values, one Observable after the other.</span>
	 *
	 * <img src="./img/concat.png" width="100%">
	 *
	 * Joins this Observable with multiple other Observables by subscribing to them
	 * one at a time, starting with the source, and merging their results into the
	 * output Observable. Will wait for each Observable to complete before moving
	 * on to the next.
	 *
	 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
	 * var timer = Rx.Observable.interval(1000).take(4);
	 * var sequence = Rx.Observable.range(1, 10);
	 * var result = timer.concat(sequence);
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in:
	 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
	 *
	 * @example <caption>Concatenate 3 Observables</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var result = timer1.concat(timer2, timer3);
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in the following:
	 * // (Prints to console sequentially)
	 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
	 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
	 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
	 *
	 * @see {@link concatAll}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 *
	 * @param {ObservableInput} other An input Observable to concatenate after the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
	 * Observable subscription on.
	 * @return {Observable} All values of each passed Observable merged into a
	 * single Observable, in order, in serial fashion.
	 * @method concat
	 * @owner Observable
	 */
	function concat() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return function (source) { return source.lift.call(concat_1.concat.apply(void 0, [source].concat(observables))); };
	}
	exports.concat = concat;
	//# sourceMappingURL=concat.js.map

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var concatAll_1 = __webpack_require__(285);
	Observable_1.Observable.prototype.concatAll = concatAll_1.concatAll;
	//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var concatMap_1 = __webpack_require__(272);
	Observable_1.Observable.prototype.concatMap = concatMap_1.concatMap;
	//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var concatMapTo_1 = __webpack_require__(415);
	Observable_1.Observable.prototype.concatMapTo = concatMapTo_1.concatMapTo;
	//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var concatMapTo_1 = __webpack_require__(416);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to the same Observable which is merged multiple
	 * times in a serialized fashion on the output Observable.
	 *
	 * <span class="informal">It's like {@link concatMap}, but maps each value
	 * always to the same inner Observable.</span>
	 *
	 * <img src="./img/concatMapTo.png" width="100%">
	 *
	 * Maps each source value to the given Observable `innerObservable` regardless
	 * of the source value, and then flattens those resulting Observables into one
	 * single Observable, which is the output Observable. Each new `innerObservable`
	 * instance emitted on the output Observable is concatenated with the previous
	 * `innerObservable` instance.
	 *
	 * __Warning:__ if source values arrive endlessly and faster than their
	 * corresponding inner Observables can complete, it will result in memory issues
	 * as inner Observables amass in an unbounded buffer waiting for their turn to
	 * be subscribed to.
	 *
	 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
	 * set to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // (results are not concurrent)
	 * // For every click on the "document" it will emit values 0 to 3 spaced
	 * // on a 1000ms interval
	 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
	 *
	 * @see {@link concat}
	 * @see {@link concatAll}
	 * @see {@link concatMap}
	 * @see {@link mergeMapTo}
	 * @see {@link switchMapTo}
	 *
	 * @param {ObservableInput} innerObservable An Observable to replace each value from
	 * the source Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An observable of values merged together by joining the
	 * passed observable with itself, one after the other, for each value emitted
	 * from the source.
	 * @method concatMapTo
	 * @owner Observable
	 */
	function concatMapTo(innerObservable, resultSelector) {
	    return concatMapTo_1.concatMapTo(innerObservable, resultSelector)(this);
	}
	exports.concatMapTo = concatMapTo;
	//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var concatMap_1 = __webpack_require__(273);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to the same Observable which is merged multiple
	 * times in a serialized fashion on the output Observable.
	 *
	 * <span class="informal">It's like {@link concatMap}, but maps each value
	 * always to the same inner Observable.</span>
	 *
	 * <img src="./img/concatMapTo.png" width="100%">
	 *
	 * Maps each source value to the given Observable `innerObservable` regardless
	 * of the source value, and then flattens those resulting Observables into one
	 * single Observable, which is the output Observable. Each new `innerObservable`
	 * instance emitted on the output Observable is concatenated with the previous
	 * `innerObservable` instance.
	 *
	 * __Warning:__ if source values arrive endlessly and faster than their
	 * corresponding inner Observables can complete, it will result in memory issues
	 * as inner Observables amass in an unbounded buffer waiting for their turn to
	 * be subscribed to.
	 *
	 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
	 * set to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // (results are not concurrent)
	 * // For every click on the "document" it will emit values 0 to 3 spaced
	 * // on a 1000ms interval
	 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
	 *
	 * @see {@link concat}
	 * @see {@link concatAll}
	 * @see {@link concatMap}
	 * @see {@link mergeMapTo}
	 * @see {@link switchMapTo}
	 *
	 * @param {ObservableInput} innerObservable An Observable to replace each value from
	 * the source Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An observable of values merged together by joining the
	 * passed observable with itself, one after the other, for each value emitted
	 * from the source.
	 * @method concatMapTo
	 * @owner Observable
	 */
	function concatMapTo(innerObservable, resultSelector) {
	    return concatMap_1.concatMap(function () { return innerObservable; }, resultSelector);
	}
	exports.concatMapTo = concatMapTo;
	//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var count_1 = __webpack_require__(418);
	Observable_1.Observable.prototype.count = count_1.count;
	//# sourceMappingURL=count.js.map

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var count_1 = __webpack_require__(419);
	/**
	 * Counts the number of emissions on the source and emits that number when the
	 * source completes.
	 *
	 * <span class="informal">Tells how many values were emitted, when the source
	 * completes.</span>
	 *
	 * <img src="./img/count.png" width="100%">
	 *
	 * `count` transforms an Observable that emits values into an Observable that
	 * emits a single value that represents the number of values emitted by the
	 * source Observable. If the source Observable terminates with an error, `count`
	 * will pass this error notification along without emitting a value first. If
	 * the source Observable does not terminate at all, `count` will neither emit
	 * a value nor terminate. This operator takes an optional `predicate` function
	 * as argument, in which case the output emission will represent the number of
	 * source values that matched `true` with the `predicate`.
	 *
	 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
	 * var seconds = Rx.Observable.interval(1000);
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var secondsBeforeClick = seconds.takeUntil(clicks);
	 * var result = secondsBeforeClick.count();
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
	 * var numbers = Rx.Observable.range(1, 7);
	 * var result = numbers.count(i => i % 2 === 1);
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in:
	 * // 4
	 *
	 * @see {@link max}
	 * @see {@link min}
	 * @see {@link reduce}
	 *
	 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
	 * boolean function to select what values are to be counted. It is provided with
	 * arguments of:
	 * - `value`: the value from the source Observable.
	 * - `index`: the (zero-based) "index" of the value from the source Observable.
	 * - `source`: the source Observable instance itself.
	 * @return {Observable} An Observable of one number that represents the count as
	 * described above.
	 * @method count
	 * @owner Observable
	 */
	function count(predicate) {
	    return count_1.count(predicate)(this);
	}
	exports.count = count;
	//# sourceMappingURL=count.js.map

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	/**
	 * Counts the number of emissions on the source and emits that number when the
	 * source completes.
	 *
	 * <span class="informal">Tells how many values were emitted, when the source
	 * completes.</span>
	 *
	 * <img src="./img/count.png" width="100%">
	 *
	 * `count` transforms an Observable that emits values into an Observable that
	 * emits a single value that represents the number of values emitted by the
	 * source Observable. If the source Observable terminates with an error, `count`
	 * will pass this error notification along without emitting a value first. If
	 * the source Observable does not terminate at all, `count` will neither emit
	 * a value nor terminate. This operator takes an optional `predicate` function
	 * as argument, in which case the output emission will represent the number of
	 * source values that matched `true` with the `predicate`.
	 *
	 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
	 * var seconds = Rx.Observable.interval(1000);
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var secondsBeforeClick = seconds.takeUntil(clicks);
	 * var result = secondsBeforeClick.count();
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
	 * var numbers = Rx.Observable.range(1, 7);
	 * var result = numbers.count(i => i % 2 === 1);
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in:
	 * // 4
	 *
	 * @see {@link max}
	 * @see {@link min}
	 * @see {@link reduce}
	 *
	 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
	 * boolean function to select what values are to be counted. It is provided with
	 * arguments of:
	 * - `value`: the value from the source Observable.
	 * - `index`: the (zero-based) "index" of the value from the source Observable.
	 * - `source`: the source Observable instance itself.
	 * @return {Observable} An Observable of one number that represents the count as
	 * described above.
	 * @method count
	 * @owner Observable
	 */
	function count(predicate) {
	    return function (source) { return source.lift(new CountOperator(predicate, source)); };
	}
	exports.count = count;
	var CountOperator = (function () {
	    function CountOperator(predicate, source) {
	        this.predicate = predicate;
	        this.source = source;
	    }
	    CountOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
	    };
	    return CountOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var CountSubscriber = (function (_super) {
	    __extends(CountSubscriber, _super);
	    function CountSubscriber(destination, predicate, source) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.source = source;
	        this.count = 0;
	        this.index = 0;
	    }
	    CountSubscriber.prototype._next = function (value) {
	        if (this.predicate) {
	            this._tryPredicate(value);
	        }
	        else {
	            this.count++;
	        }
	    };
	    CountSubscriber.prototype._tryPredicate = function (value) {
	        var result;
	        try {
	            result = this.predicate(value, this.index++, this.source);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (result) {
	            this.count++;
	        }
	    };
	    CountSubscriber.prototype._complete = function () {
	        this.destination.next(this.count);
	        this.destination.complete();
	    };
	    return CountSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=count.js.map

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var dematerialize_1 = __webpack_require__(421);
	Observable_1.Observable.prototype.dematerialize = dematerialize_1.dematerialize;
	//# sourceMappingURL=dematerialize.js.map

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var dematerialize_1 = __webpack_require__(422);
	/**
	 * Converts an Observable of {@link Notification} objects into the emissions
	 * that they represent.
	 *
	 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
	 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
	 *
	 * <img src="./img/dematerialize.png" width="100%">
	 *
	 * `dematerialize` is assumed to operate an Observable that only emits
	 * {@link Notification} objects as `next` emissions, and does not emit any
	 * `error`. Such Observable is the output of a `materialize` operation. Those
	 * notifications are then unwrapped using the metadata they contain, and emitted
	 * as `next`, `error`, and `complete` on the output Observable.
	 *
	 * Use this operator in conjunction with {@link materialize}.
	 *
	 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
	 * var notifA = new Rx.Notification('N', 'A');
	 * var notifB = new Rx.Notification('N', 'B');
	 * var notifE = new Rx.Notification('E', void 0,
	 *   new TypeError('x.toUpperCase is not a function')
	 * );
	 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
	 * var upperCase = materialized.dematerialize();
	 * upperCase.subscribe(x => console.log(x), e => console.error(e));
	 *
	 * // Results in:
	 * // A
	 * // B
	 * // TypeError: x.toUpperCase is not a function
	 *
	 * @see {@link Notification}
	 * @see {@link materialize}
	 *
	 * @return {Observable} An Observable that emits items and notifications
	 * embedded in Notification objects emitted by the source Observable.
	 * @method dematerialize
	 * @owner Observable
	 */
	function dematerialize() {
	    return dematerialize_1.dematerialize()(this);
	}
	exports.dematerialize = dematerialize;
	//# sourceMappingURL=dematerialize.js.map

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	/**
	 * Converts an Observable of {@link Notification} objects into the emissions
	 * that they represent.
	 *
	 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
	 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
	 *
	 * <img src="./img/dematerialize.png" width="100%">
	 *
	 * `dematerialize` is assumed to operate an Observable that only emits
	 * {@link Notification} objects as `next` emissions, and does not emit any
	 * `error`. Such Observable is the output of a `materialize` operation. Those
	 * notifications are then unwrapped using the metadata they contain, and emitted
	 * as `next`, `error`, and `complete` on the output Observable.
	 *
	 * Use this operator in conjunction with {@link materialize}.
	 *
	 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
	 * var notifA = new Rx.Notification('N', 'A');
	 * var notifB = new Rx.Notification('N', 'B');
	 * var notifE = new Rx.Notification('E', void 0,
	 *   new TypeError('x.toUpperCase is not a function')
	 * );
	 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
	 * var upperCase = materialized.dematerialize();
	 * upperCase.subscribe(x => console.log(x), e => console.error(e));
	 *
	 * // Results in:
	 * // A
	 * // B
	 * // TypeError: x.toUpperCase is not a function
	 *
	 * @see {@link Notification}
	 * @see {@link materialize}
	 *
	 * @return {Observable} An Observable that emits items and notifications
	 * embedded in Notification objects emitted by the source Observable.
	 * @method dematerialize
	 * @owner Observable
	 */
	function dematerialize() {
	    return function dematerializeOperatorFunction(source) {
	        return source.lift(new DeMaterializeOperator());
	    };
	}
	exports.dematerialize = dematerialize;
	var DeMaterializeOperator = (function () {
	    function DeMaterializeOperator() {
	    }
	    DeMaterializeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DeMaterializeSubscriber(subscriber));
	    };
	    return DeMaterializeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DeMaterializeSubscriber = (function (_super) {
	    __extends(DeMaterializeSubscriber, _super);
	    function DeMaterializeSubscriber(destination) {
	        _super.call(this, destination);
	    }
	    DeMaterializeSubscriber.prototype._next = function (value) {
	        value.observe(this.destination);
	    };
	    return DeMaterializeSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=dematerialize.js.map

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var debounce_1 = __webpack_require__(424);
	Observable_1.Observable.prototype.debounce = debounce_1.debounce;
	//# sourceMappingURL=debounce.js.map

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var debounce_1 = __webpack_require__(425);
	/**
	 * Emits a value from the source Observable only after a particular time span
	 * determined by another Observable has passed without another source emission.
	 *
	 * <span class="informal">It's like {@link debounceTime}, but the time span of
	 * emission silence is determined by a second Observable.</span>
	 *
	 * <img src="./img/debounce.png" width="100%">
	 *
	 * `debounce` delays values emitted by the source Observable, but drops previous
	 * pending delayed emissions if a new value arrives on the source Observable.
	 * This operator keeps track of the most recent value from the source
	 * Observable, and spawns a duration Observable by calling the
	 * `durationSelector` function. The value is emitted only when the duration
	 * Observable emits a value or completes, and if no other value was emitted on
	 * the source Observable since the duration Observable was spawned. If a new
	 * value appears before the duration Observable emits, the previous value will
	 * be dropped and will not be emitted on the output Observable.
	 *
	 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
	 * delay-like operator since output emissions do not necessarily occur at the
	 * same time as they did on the source Observable.
	 *
	 * @example <caption>Emit the most recent click after a burst of clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounceTime}
	 * @see {@link delayWhen}
	 * @see {@link throttle}
	 *
	 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
	 * that receives a value from the source Observable, for computing the timeout
	 * duration for each source value, returned as an Observable or a Promise.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified duration Observable returned by
	 * `durationSelector`, and may drop some values if they occur too frequently.
	 * @method debounce
	 * @owner Observable
	 */
	function debounce(durationSelector) {
	    return debounce_1.debounce(durationSelector)(this);
	}
	exports.debounce = debounce;
	//# sourceMappingURL=debounce.js.map

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/**
	 * Emits a value from the source Observable only after a particular time span
	 * determined by another Observable has passed without another source emission.
	 *
	 * <span class="informal">It's like {@link debounceTime}, but the time span of
	 * emission silence is determined by a second Observable.</span>
	 *
	 * <img src="./img/debounce.png" width="100%">
	 *
	 * `debounce` delays values emitted by the source Observable, but drops previous
	 * pending delayed emissions if a new value arrives on the source Observable.
	 * This operator keeps track of the most recent value from the source
	 * Observable, and spawns a duration Observable by calling the
	 * `durationSelector` function. The value is emitted only when the duration
	 * Observable emits a value or completes, and if no other value was emitted on
	 * the source Observable since the duration Observable was spawned. If a new
	 * value appears before the duration Observable emits, the previous value will
	 * be dropped and will not be emitted on the output Observable.
	 *
	 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
	 * delay-like operator since output emissions do not necessarily occur at the
	 * same time as they did on the source Observable.
	 *
	 * @example <caption>Emit the most recent click after a burst of clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounceTime}
	 * @see {@link delayWhen}
	 * @see {@link throttle}
	 *
	 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
	 * that receives a value from the source Observable, for computing the timeout
	 * duration for each source value, returned as an Observable or a Promise.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified duration Observable returned by
	 * `durationSelector`, and may drop some values if they occur too frequently.
	 * @method debounce
	 * @owner Observable
	 */
	function debounce(durationSelector) {
	    return function (source) { return source.lift(new DebounceOperator(durationSelector)); };
	}
	exports.debounce = debounce;
	var DebounceOperator = (function () {
	    function DebounceOperator(durationSelector) {
	        this.durationSelector = durationSelector;
	    }
	    DebounceOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DebounceSubscriber(subscriber, this.durationSelector));
	    };
	    return DebounceOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DebounceSubscriber = (function (_super) {
	    __extends(DebounceSubscriber, _super);
	    function DebounceSubscriber(destination, durationSelector) {
	        _super.call(this, destination);
	        this.durationSelector = durationSelector;
	        this.hasValue = false;
	        this.durationSubscription = null;
	    }
	    DebounceSubscriber.prototype._next = function (value) {
	        try {
	            var result = this.durationSelector.call(this, value);
	            if (result) {
	                this._tryNext(value, result);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    DebounceSubscriber.prototype._complete = function () {
	        this.emitValue();
	        this.destination.complete();
	    };
	    DebounceSubscriber.prototype._tryNext = function (value, duration) {
	        var subscription = this.durationSubscription;
	        this.value = value;
	        this.hasValue = true;
	        if (subscription) {
	            subscription.unsubscribe();
	            this.remove(subscription);
	        }
	        subscription = subscribeToResult_1.subscribeToResult(this, duration);
	        if (!subscription.closed) {
	            this.add(this.durationSubscription = subscription);
	        }
	    };
	    DebounceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.emitValue();
	    };
	    DebounceSubscriber.prototype.notifyComplete = function () {
	        this.emitValue();
	    };
	    DebounceSubscriber.prototype.emitValue = function () {
	        if (this.hasValue) {
	            var value = this.value;
	            var subscription = this.durationSubscription;
	            if (subscription) {
	                this.durationSubscription = null;
	                subscription.unsubscribe();
	                this.remove(subscription);
	            }
	            this.value = null;
	            this.hasValue = false;
	            _super.prototype._next.call(this, value);
	        }
	    };
	    return DebounceSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=debounce.js.map

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var debounceTime_1 = __webpack_require__(427);
	Observable_1.Observable.prototype.debounceTime = debounceTime_1.debounceTime;
	//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(343);
	var debounceTime_1 = __webpack_require__(428);
	/**
	 * Emits a value from the source Observable only after a particular time span
	 * has passed without another source emission.
	 *
	 * <span class="informal">It's like {@link delay}, but passes only the most
	 * recent value from each burst of emissions.</span>
	 *
	 * <img src="./img/debounceTime.png" width="100%">
	 *
	 * `debounceTime` delays values emitted by the source Observable, but drops
	 * previous pending delayed emissions if a new value arrives on the source
	 * Observable. This operator keeps track of the most recent value from the
	 * source Observable, and emits that only when `dueTime` enough time has passed
	 * without any other value appearing on the source Observable. If a new value
	 * appears before `dueTime` silence occurs, the previous value will be dropped
	 * and will not be emitted on the output Observable.
	 *
	 * This is a rate-limiting operator, because it is impossible for more than one
	 * value to be emitted in any time window of duration `dueTime`, but it is also
	 * a delay-like operator since output emissions do not occur at the same time as
	 * they did on the source Observable. Optionally takes a {@link IScheduler} for
	 * managing timers.
	 *
	 * @example <caption>Emit the most recent click after a burst of clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.debounceTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounce}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttleTime}
	 *
	 * @param {number} dueTime The timeout duration in milliseconds (or the time
	 * unit determined internally by the optional `scheduler`) for the window of
	 * time required to wait for emission silence before emitting the most recent
	 * source value.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the timeout for each value.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified `dueTime`, and may drop some values if they occur
	 * too frequently.
	 * @method debounceTime
	 * @owner Observable
	 */
	function debounceTime(dueTime, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return debounceTime_1.debounceTime(dueTime, scheduler)(this);
	}
	exports.debounceTime = debounceTime;
	//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	var async_1 = __webpack_require__(343);
	/**
	 * Emits a value from the source Observable only after a particular time span
	 * has passed without another source emission.
	 *
	 * <span class="informal">It's like {@link delay}, but passes only the most
	 * recent value from each burst of emissions.</span>
	 *
	 * <img src="./img/debounceTime.png" width="100%">
	 *
	 * `debounceTime` delays values emitted by the source Observable, but drops
	 * previous pending delayed emissions if a new value arrives on the source
	 * Observable. This operator keeps track of the most recent value from the
	 * source Observable, and emits that only when `dueTime` enough time has passed
	 * without any other value appearing on the source Observable. If a new value
	 * appears before `dueTime` silence occurs, the previous value will be dropped
	 * and will not be emitted on the output Observable.
	 *
	 * This is a rate-limiting operator, because it is impossible for more than one
	 * value to be emitted in any time window of duration `dueTime`, but it is also
	 * a delay-like operator since output emissions do not occur at the same time as
	 * they did on the source Observable. Optionally takes a {@link IScheduler} for
	 * managing timers.
	 *
	 * @example <caption>Emit the most recent click after a burst of clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.debounceTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounce}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttleTime}
	 *
	 * @param {number} dueTime The timeout duration in milliseconds (or the time
	 * unit determined internally by the optional `scheduler`) for the window of
	 * time required to wait for emission silence before emitting the most recent
	 * source value.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the timeout for each value.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified `dueTime`, and may drop some values if they occur
	 * too frequently.
	 * @method debounceTime
	 * @owner Observable
	 */
	function debounceTime(dueTime, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return function (source) { return source.lift(new DebounceTimeOperator(dueTime, scheduler)); };
	}
	exports.debounceTime = debounceTime;
	var DebounceTimeOperator = (function () {
	    function DebounceTimeOperator(dueTime, scheduler) {
	        this.dueTime = dueTime;
	        this.scheduler = scheduler;
	    }
	    DebounceTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
	    };
	    return DebounceTimeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DebounceTimeSubscriber = (function (_super) {
	    __extends(DebounceTimeSubscriber, _super);
	    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
	        _super.call(this, destination);
	        this.dueTime = dueTime;
	        this.scheduler = scheduler;
	        this.debouncedSubscription = null;
	        this.lastValue = null;
	        this.hasValue = false;
	    }
	    DebounceTimeSubscriber.prototype._next = function (value) {
	        this.clearDebounce();
	        this.lastValue = value;
	        this.hasValue = true;
	        this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
	    };
	    DebounceTimeSubscriber.prototype._complete = function () {
	        this.debouncedNext();
	        this.destination.complete();
	    };
	    DebounceTimeSubscriber.prototype.debouncedNext = function () {
	        this.clearDebounce();
	        if (this.hasValue) {
	            this.destination.next(this.lastValue);
	            this.lastValue = null;
	            this.hasValue = false;
	        }
	    };
	    DebounceTimeSubscriber.prototype.clearDebounce = function () {
	        var debouncedSubscription = this.debouncedSubscription;
	        if (debouncedSubscription !== null) {
	            this.remove(debouncedSubscription);
	            debouncedSubscription.unsubscribe();
	            this.debouncedSubscription = null;
	        }
	    };
	    return DebounceTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchNext(subscriber) {
	    subscriber.debouncedNext();
	}
	//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var defaultIfEmpty_1 = __webpack_require__(430);
	Observable_1.Observable.prototype.defaultIfEmpty = defaultIfEmpty_1.defaultIfEmpty;
	//# sourceMappingURL=defaultIfEmpty.js.map

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var defaultIfEmpty_1 = __webpack_require__(262);
	/* tslint:enable:max-line-length */
	/**
	 * Emits a given value if the source Observable completes without emitting any
	 * `next` value, otherwise mirrors the source Observable.
	 *
	 * <span class="informal">If the source Observable turns out to be empty, then
	 * this operator will emit a default value.</span>
	 *
	 * <img src="./img/defaultIfEmpty.png" width="100%">
	 *
	 * `defaultIfEmpty` emits the values emitted by the source Observable or a
	 * specified default value if the source Observable is empty (completes without
	 * having emitted any `next` value).
	 *
	 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
	 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link empty}
	 * @see {@link last}
	 *
	 * @param {any} [defaultValue=null] The default value used if the source
	 * Observable is empty.
	 * @return {Observable} An Observable that emits either the specified
	 * `defaultValue` if the source Observable emits no items, or the values emitted
	 * by the source Observable.
	 * @method defaultIfEmpty
	 * @owner Observable
	 */
	function defaultIfEmpty(defaultValue) {
	    if (defaultValue === void 0) { defaultValue = null; }
	    return defaultIfEmpty_1.defaultIfEmpty(defaultValue)(this);
	}
	exports.defaultIfEmpty = defaultIfEmpty;
	//# sourceMappingURL=defaultIfEmpty.js.map

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var delay_1 = __webpack_require__(432);
	Observable_1.Observable.prototype.delay = delay_1.delay;
	//# sourceMappingURL=delay.js.map

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(343);
	var delay_1 = __webpack_require__(433);
	/**
	 * Delays the emission of items from the source Observable by a given timeout or
	 * until a given Date.
	 *
	 * <span class="informal">Time shifts each item by some specified amount of
	 * milliseconds.</span>
	 *
	 * <img src="./img/delay.png" width="100%">
	 *
	 * If the delay argument is a Number, this operator time shifts the source
	 * Observable by that amount of time expressed in milliseconds. The relative
	 * time intervals between the values are preserved.
	 *
	 * If the delay argument is a Date, this operator time shifts the start of the
	 * Observable execution until the given date occurs.
	 *
	 * @example <caption>Delay each click by one second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
	 * delayedClicks.subscribe(x => console.log(x));
	 *
	 * @example <caption>Delay all clicks until a future date happens</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var date = new Date('March 15, 2050 12:00:00'); // in the future
	 * var delayedClicks = clicks.delay(date); // click emitted only after that date
	 * delayedClicks.subscribe(x => console.log(x));
	 *
	 * @see {@link debounceTime}
	 * @see {@link delayWhen}
	 *
	 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
	 * a `Date` until which the emission of the source items is delayed.
	 * @param {Scheduler} [scheduler=async] The IScheduler to use for
	 * managing the timers that handle the time-shift for each item.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified timeout or Date.
	 * @method delay
	 * @owner Observable
	 */
	function delay(delay, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return delay_1.delay(delay, scheduler)(this);
	}
	exports.delay = delay;
	//# sourceMappingURL=delay.js.map

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var async_1 = __webpack_require__(343);
	var isDate_1 = __webpack_require__(373);
	var Subscriber_1 = __webpack_require__(209);
	var Notification_1 = __webpack_require__(282);
	/**
	 * Delays the emission of items from the source Observable by a given timeout or
	 * until a given Date.
	 *
	 * <span class="informal">Time shifts each item by some specified amount of
	 * milliseconds.</span>
	 *
	 * <img src="./img/delay.png" width="100%">
	 *
	 * If the delay argument is a Number, this operator time shifts the source
	 * Observable by that amount of time expressed in milliseconds. The relative
	 * time intervals between the values are preserved.
	 *
	 * If the delay argument is a Date, this operator time shifts the start of the
	 * Observable execution until the given date occurs.
	 *
	 * @example <caption>Delay each click by one second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
	 * delayedClicks.subscribe(x => console.log(x));
	 *
	 * @example <caption>Delay all clicks until a future date happens</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var date = new Date('March 15, 2050 12:00:00'); // in the future
	 * var delayedClicks = clicks.delay(date); // click emitted only after that date
	 * delayedClicks.subscribe(x => console.log(x));
	 *
	 * @see {@link debounceTime}
	 * @see {@link delayWhen}
	 *
	 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
	 * a `Date` until which the emission of the source items is delayed.
	 * @param {Scheduler} [scheduler=async] The IScheduler to use for
	 * managing the timers that handle the time-shift for each item.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified timeout or Date.
	 * @method delay
	 * @owner Observable
	 */
	function delay(delay, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    var absoluteDelay = isDate_1.isDate(delay);
	    var delayFor = absoluteDelay ? (+delay - scheduler.now()) : Math.abs(delay);
	    return function (source) { return source.lift(new DelayOperator(delayFor, scheduler)); };
	}
	exports.delay = delay;
	var DelayOperator = (function () {
	    function DelayOperator(delay, scheduler) {
	        this.delay = delay;
	        this.scheduler = scheduler;
	    }
	    DelayOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
	    };
	    return DelayOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DelaySubscriber = (function (_super) {
	    __extends(DelaySubscriber, _super);
	    function DelaySubscriber(destination, delay, scheduler) {
	        _super.call(this, destination);
	        this.delay = delay;
	        this.scheduler = scheduler;
	        this.queue = [];
	        this.active = false;
	        this.errored = false;
	    }
	    DelaySubscriber.dispatch = function (state) {
	        var source = state.source;
	        var queue = source.queue;
	        var scheduler = state.scheduler;
	        var destination = state.destination;
	        while (queue.length > 0 && (queue[0].time - scheduler.now()) <= 0) {
	            queue.shift().notification.observe(destination);
	        }
	        if (queue.length > 0) {
	            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
	            this.schedule(state, delay_1);
	        }
	        else {
	            this.unsubscribe();
	            source.active = false;
	        }
	    };
	    DelaySubscriber.prototype._schedule = function (scheduler) {
	        this.active = true;
	        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
	            source: this, destination: this.destination, scheduler: scheduler
	        }));
	    };
	    DelaySubscriber.prototype.scheduleNotification = function (notification) {
	        if (this.errored === true) {
	            return;
	        }
	        var scheduler = this.scheduler;
	        var message = new DelayMessage(scheduler.now() + this.delay, notification);
	        this.queue.push(message);
	        if (this.active === false) {
	            this._schedule(scheduler);
	        }
	    };
	    DelaySubscriber.prototype._next = function (value) {
	        this.scheduleNotification(Notification_1.Notification.createNext(value));
	    };
	    DelaySubscriber.prototype._error = function (err) {
	        this.errored = true;
	        this.queue = [];
	        this.destination.error(err);
	    };
	    DelaySubscriber.prototype._complete = function () {
	        this.scheduleNotification(Notification_1.Notification.createComplete());
	    };
	    return DelaySubscriber;
	}(Subscriber_1.Subscriber));
	var DelayMessage = (function () {
	    function DelayMessage(time, notification) {
	        this.time = time;
	        this.notification = notification;
	    }
	    return DelayMessage;
	}());
	//# sourceMappingURL=delay.js.map

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var delayWhen_1 = __webpack_require__(435);
	Observable_1.Observable.prototype.delayWhen = delayWhen_1.delayWhen;
	//# sourceMappingURL=delayWhen.js.map

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var delayWhen_1 = __webpack_require__(436);
	/**
	 * Delays the emission of items from the source Observable by a given time span
	 * determined by the emissions of another Observable.
	 *
	 * <span class="informal">It's like {@link delay}, but the time span of the
	 * delay duration is determined by a second Observable.</span>
	 *
	 * <img src="./img/delayWhen.png" width="100%">
	 *
	 * `delayWhen` time shifts each emitted value from the source Observable by a
	 * time span determined by another Observable. When the source emits a value,
	 * the `delayDurationSelector` function is called with the source value as
	 * argument, and should return an Observable, called the "duration" Observable.
	 * The source value is emitted on the output Observable only when the duration
	 * Observable emits a value or completes.
	 *
	 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
	 * is an Observable. When `subscriptionDelay` emits its first value or
	 * completes, the source Observable is subscribed to and starts behaving like
	 * described in the previous paragraph. If `subscriptionDelay` is not provided,
	 * `delayWhen` will subscribe to the source Observable as soon as the output
	 * Observable is subscribed.
	 *
	 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var delayedClicks = clicks.delayWhen(event =>
	 *   Rx.Observable.interval(Math.random() * 5000)
	 * );
	 * delayedClicks.subscribe(x => console.log(x));
	 *
	 * @see {@link debounce}
	 * @see {@link delay}
	 *
	 * @param {function(value: T): Observable} delayDurationSelector A function that
	 * returns an Observable for each value emitted by the source Observable, which
	 * is then used to delay the emission of that item on the output Observable
	 * until the Observable returned from this function emits a value.
	 * @param {Observable} subscriptionDelay An Observable that triggers the
	 * subscription to the source Observable once it emits any value.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by an amount of time specified by the Observable returned by
	 * `delayDurationSelector`.
	 * @method delayWhen
	 * @owner Observable
	 */
	function delayWhen(delayDurationSelector, subscriptionDelay) {
	    return delayWhen_1.delayWhen(delayDurationSelector, subscriptionDelay)(this);
	}
	exports.delayWhen = delayWhen;
	//# sourceMappingURL=delayWhen.js.map

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	var Observable_1 = __webpack_require__(206);
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/**
	 * Delays the emission of items from the source Observable by a given time span
	 * determined by the emissions of another Observable.
	 *
	 * <span class="informal">It's like {@link delay}, but the time span of the
	 * delay duration is determined by a second Observable.</span>
	 *
	 * <img src="./img/delayWhen.png" width="100%">
	 *
	 * `delayWhen` time shifts each emitted value from the source Observable by a
	 * time span determined by another Observable. When the source emits a value,
	 * the `delayDurationSelector` function is called with the source value as
	 * argument, and should return an Observable, called the "duration" Observable.
	 * The source value is emitted on the output Observable only when the duration
	 * Observable emits a value or completes.
	 *
	 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
	 * is an Observable. When `subscriptionDelay` emits its first value or
	 * completes, the source Observable is subscribed to and starts behaving like
	 * described in the previous paragraph. If `subscriptionDelay` is not provided,
	 * `delayWhen` will subscribe to the source Observable as soon as the output
	 * Observable is subscribed.
	 *
	 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var delayedClicks = clicks.delayWhen(event =>
	 *   Rx.Observable.interval(Math.random() * 5000)
	 * );
	 * delayedClicks.subscribe(x => console.log(x));
	 *
	 * @see {@link debounce}
	 * @see {@link delay}
	 *
	 * @param {function(value: T): Observable} delayDurationSelector A function that
	 * returns an Observable for each value emitted by the source Observable, which
	 * is then used to delay the emission of that item on the output Observable
	 * until the Observable returned from this function emits a value.
	 * @param {Observable} subscriptionDelay An Observable that triggers the
	 * subscription to the source Observable once it emits any value.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by an amount of time specified by the Observable returned by
	 * `delayDurationSelector`.
	 * @method delayWhen
	 * @owner Observable
	 */
	function delayWhen(delayDurationSelector, subscriptionDelay) {
	    if (subscriptionDelay) {
	        return function (source) {
	            return new SubscriptionDelayObservable(source, subscriptionDelay)
	                .lift(new DelayWhenOperator(delayDurationSelector));
	        };
	    }
	    return function (source) { return source.lift(new DelayWhenOperator(delayDurationSelector)); };
	}
	exports.delayWhen = delayWhen;
	var DelayWhenOperator = (function () {
	    function DelayWhenOperator(delayDurationSelector) {
	        this.delayDurationSelector = delayDurationSelector;
	    }
	    DelayWhenOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DelayWhenSubscriber(subscriber, this.delayDurationSelector));
	    };
	    return DelayWhenOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DelayWhenSubscriber = (function (_super) {
	    __extends(DelayWhenSubscriber, _super);
	    function DelayWhenSubscriber(destination, delayDurationSelector) {
	        _super.call(this, destination);
	        this.delayDurationSelector = delayDurationSelector;
	        this.completed = false;
	        this.delayNotifierSubscriptions = [];
	        this.values = [];
	    }
	    DelayWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.destination.next(outerValue);
	        this.removeSubscription(innerSub);
	        this.tryComplete();
	    };
	    DelayWhenSubscriber.prototype.notifyError = function (error, innerSub) {
	        this._error(error);
	    };
	    DelayWhenSubscriber.prototype.notifyComplete = function (innerSub) {
	        var value = this.removeSubscription(innerSub);
	        if (value) {
	            this.destination.next(value);
	        }
	        this.tryComplete();
	    };
	    DelayWhenSubscriber.prototype._next = function (value) {
	        try {
	            var delayNotifier = this.delayDurationSelector(value);
	            if (delayNotifier) {
	                this.tryDelay(delayNotifier, value);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    DelayWhenSubscriber.prototype._complete = function () {
	        this.completed = true;
	        this.tryComplete();
	    };
	    DelayWhenSubscriber.prototype.removeSubscription = function (subscription) {
	        subscription.unsubscribe();
	        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
	        var value = null;
	        if (subscriptionIdx !== -1) {
	            value = this.values[subscriptionIdx];
	            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
	            this.values.splice(subscriptionIdx, 1);
	        }
	        return value;
	    };
	    DelayWhenSubscriber.prototype.tryDelay = function (delayNotifier, value) {
	        var notifierSubscription = subscribeToResult_1.subscribeToResult(this, delayNotifier, value);
	        if (notifierSubscription && !notifierSubscription.closed) {
	            this.add(notifierSubscription);
	            this.delayNotifierSubscriptions.push(notifierSubscription);
	        }
	        this.values.push(value);
	    };
	    DelayWhenSubscriber.prototype.tryComplete = function () {
	        if (this.completed && this.delayNotifierSubscriptions.length === 0) {
	            this.destination.complete();
	        }
	    };
	    return DelayWhenSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SubscriptionDelayObservable = (function (_super) {
	    __extends(SubscriptionDelayObservable, _super);
	    function SubscriptionDelayObservable(/** @deprecated internal use only */ source, subscriptionDelay) {
	        _super.call(this);
	        this.source = source;
	        this.subscriptionDelay = subscriptionDelay;
	    }
	    /** @deprecated internal use only */ SubscriptionDelayObservable.prototype._subscribe = function (subscriber) {
	        this.subscriptionDelay.subscribe(new SubscriptionDelaySubscriber(subscriber, this.source));
	    };
	    return SubscriptionDelayObservable;
	}(Observable_1.Observable));
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SubscriptionDelaySubscriber = (function (_super) {
	    __extends(SubscriptionDelaySubscriber, _super);
	    function SubscriptionDelaySubscriber(parent, source) {
	        _super.call(this);
	        this.parent = parent;
	        this.source = source;
	        this.sourceSubscribed = false;
	    }
	    SubscriptionDelaySubscriber.prototype._next = function (unused) {
	        this.subscribeToSource();
	    };
	    SubscriptionDelaySubscriber.prototype._error = function (err) {
	        this.unsubscribe();
	        this.parent.error(err);
	    };
	    SubscriptionDelaySubscriber.prototype._complete = function () {
	        this.subscribeToSource();
	    };
	    SubscriptionDelaySubscriber.prototype.subscribeToSource = function () {
	        if (!this.sourceSubscribed) {
	            this.sourceSubscribed = true;
	            this.unsubscribe();
	            this.source.subscribe(this.parent);
	        }
	    };
	    return SubscriptionDelaySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=delayWhen.js.map

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var distinct_1 = __webpack_require__(438);
	Observable_1.Observable.prototype.distinct = distinct_1.distinct;
	//# sourceMappingURL=distinct.js.map

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var distinct_1 = __webpack_require__(439);
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
	 *
	 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
	 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
	 * source observable directly with an equality check against previous values.
	 *
	 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
	 *
	 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
	 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
	 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
	 * that the internal `Set` can be "flushed", basically clearing it of values.
	 *
	 * @example <caption>A simple example with numbers</caption>
	 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
	 *   .distinct()
	 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
	 *
	 * @example <caption>An example using a keySelector function</caption>
	 * interface Person {
	 *    age: number,
	 *    name: string
	 * }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo'})
	 *     .distinct((p: Person) => p.name)
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo' }
	 * // { age: 7, name: 'Bar' }
	 *
	 * @see {@link distinctUntilChanged}
	 * @see {@link distinctUntilKeyChanged}
	 *
	 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
	 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
	 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
	 * @method distinct
	 * @owner Observable
	 */
	function distinct(keySelector, flushes) {
	    return distinct_1.distinct(keySelector, flushes)(this);
	}
	exports.distinct = distinct;
	//# sourceMappingURL=distinct.js.map

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	var Set_1 = __webpack_require__(440);
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
	 *
	 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
	 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
	 * source observable directly with an equality check against previous values.
	 *
	 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
	 *
	 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
	 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
	 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
	 * that the internal `Set` can be "flushed", basically clearing it of values.
	 *
	 * @example <caption>A simple example with numbers</caption>
	 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
	 *   .distinct()
	 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
	 *
	 * @example <caption>An example using a keySelector function</caption>
	 * interface Person {
	 *    age: number,
	 *    name: string
	 * }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo'})
	 *     .distinct((p: Person) => p.name)
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo' }
	 * // { age: 7, name: 'Bar' }
	 *
	 * @see {@link distinctUntilChanged}
	 * @see {@link distinctUntilKeyChanged}
	 *
	 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
	 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
	 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
	 * @method distinct
	 * @owner Observable
	 */
	function distinct(keySelector, flushes) {
	    return function (source) { return source.lift(new DistinctOperator(keySelector, flushes)); };
	}
	exports.distinct = distinct;
	var DistinctOperator = (function () {
	    function DistinctOperator(keySelector, flushes) {
	        this.keySelector = keySelector;
	        this.flushes = flushes;
	    }
	    DistinctOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DistinctSubscriber(subscriber, this.keySelector, this.flushes));
	    };
	    return DistinctOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DistinctSubscriber = (function (_super) {
	    __extends(DistinctSubscriber, _super);
	    function DistinctSubscriber(destination, keySelector, flushes) {
	        _super.call(this, destination);
	        this.keySelector = keySelector;
	        this.values = new Set_1.Set();
	        if (flushes) {
	            this.add(subscribeToResult_1.subscribeToResult(this, flushes));
	        }
	    }
	    DistinctSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.values.clear();
	    };
	    DistinctSubscriber.prototype.notifyError = function (error, innerSub) {
	        this._error(error);
	    };
	    DistinctSubscriber.prototype._next = function (value) {
	        if (this.keySelector) {
	            this._useKeySelector(value);
	        }
	        else {
	            this._finalizeNext(value, value);
	        }
	    };
	    DistinctSubscriber.prototype._useKeySelector = function (value) {
	        var key;
	        var destination = this.destination;
	        try {
	            key = this.keySelector(value);
	        }
	        catch (err) {
	            destination.error(err);
	            return;
	        }
	        this._finalizeNext(key, value);
	    };
	    DistinctSubscriber.prototype._finalizeNext = function (key, value) {
	        var values = this.values;
	        if (!values.has(key)) {
	            values.add(key);
	            this.destination.next(value);
	        }
	    };
	    return DistinctSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.DistinctSubscriber = DistinctSubscriber;
	//# sourceMappingURL=distinct.js.map

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(207);
	function minimalSetImpl() {
	    // THIS IS NOT a full impl of Set, this is just the minimum
	    // bits of functionality we need for this library.
	    return (function () {
	        function MinimalSet() {
	            this._values = [];
	        }
	        MinimalSet.prototype.add = function (value) {
	            if (!this.has(value)) {
	                this._values.push(value);
	            }
	        };
	        MinimalSet.prototype.has = function (value) {
	            return this._values.indexOf(value) !== -1;
	        };
	        Object.defineProperty(MinimalSet.prototype, "size", {
	            get: function () {
	                return this._values.length;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        MinimalSet.prototype.clear = function () {
	            this._values.length = 0;
	        };
	        return MinimalSet;
	    }());
	}
	exports.minimalSetImpl = minimalSetImpl;
	exports.Set = root_1.root.Set || minimalSetImpl();
	//# sourceMappingURL=Set.js.map

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var distinctUntilChanged_1 = __webpack_require__(442);
	Observable_1.Observable.prototype.distinctUntilChanged = distinctUntilChanged_1.distinctUntilChanged;
	//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var distinctUntilChanged_1 = __webpack_require__(443);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
	 *
	 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
	 *
	 * If a comparator function is not provided, an equality check is used by default.
	 *
	 * @example <caption>A simple example with numbers</caption>
	 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
	 *   .distinctUntilChanged()
	 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
	 *
	 * @example <caption>An example using a compare function</caption>
	 * interface Person {
	 *    age: number,
	 *    name: string
	 * }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo'})
	 *     { age: 6, name: 'Foo'})
	 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo' }
	 * // { age: 7, name: 'Bar' }
	 * // { age: 5, name: 'Foo' }
	 *
	 * @see {@link distinct}
	 * @see {@link distinctUntilKeyChanged}
	 *
	 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
	 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
	 * @method distinctUntilChanged
	 * @owner Observable
	 */
	function distinctUntilChanged(compare, keySelector) {
	    return distinctUntilChanged_1.distinctUntilChanged(compare, keySelector)(this);
	}
	exports.distinctUntilChanged = distinctUntilChanged;
	//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	var tryCatch_1 = __webpack_require__(214);
	var errorObject_1 = __webpack_require__(215);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
	 *
	 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
	 *
	 * If a comparator function is not provided, an equality check is used by default.
	 *
	 * @example <caption>A simple example with numbers</caption>
	 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
	 *   .distinctUntilChanged()
	 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
	 *
	 * @example <caption>An example using a compare function</caption>
	 * interface Person {
	 *    age: number,
	 *    name: string
	 * }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo'})
	 *     { age: 6, name: 'Foo'})
	 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo' }
	 * // { age: 7, name: 'Bar' }
	 * // { age: 5, name: 'Foo' }
	 *
	 * @see {@link distinct}
	 * @see {@link distinctUntilKeyChanged}
	 *
	 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
	 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
	 * @method distinctUntilChanged
	 * @owner Observable
	 */
	function distinctUntilChanged(compare, keySelector) {
	    return function (source) { return source.lift(new DistinctUntilChangedOperator(compare, keySelector)); };
	}
	exports.distinctUntilChanged = distinctUntilChanged;
	var DistinctUntilChangedOperator = (function () {
	    function DistinctUntilChangedOperator(compare, keySelector) {
	        this.compare = compare;
	        this.keySelector = keySelector;
	    }
	    DistinctUntilChangedOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
	    };
	    return DistinctUntilChangedOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DistinctUntilChangedSubscriber = (function (_super) {
	    __extends(DistinctUntilChangedSubscriber, _super);
	    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
	        _super.call(this, destination);
	        this.keySelector = keySelector;
	        this.hasKey = false;
	        if (typeof compare === 'function') {
	            this.compare = compare;
	        }
	    }
	    DistinctUntilChangedSubscriber.prototype.compare = function (x, y) {
	        return x === y;
	    };
	    DistinctUntilChangedSubscriber.prototype._next = function (value) {
	        var keySelector = this.keySelector;
	        var key = value;
	        if (keySelector) {
	            key = tryCatch_1.tryCatch(this.keySelector)(value);
	            if (key === errorObject_1.errorObject) {
	                return this.destination.error(errorObject_1.errorObject.e);
	            }
	        }
	        var result = false;
	        if (this.hasKey) {
	            result = tryCatch_1.tryCatch(this.compare)(this.key, key);
	            if (result === errorObject_1.errorObject) {
	                return this.destination.error(errorObject_1.errorObject.e);
	            }
	        }
	        else {
	            this.hasKey = true;
	        }
	        if (Boolean(result) === false) {
	            this.key = key;
	            this.destination.next(value);
	        }
	    };
	    return DistinctUntilChangedSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var distinctUntilKeyChanged_1 = __webpack_require__(445);
	Observable_1.Observable.prototype.distinctUntilKeyChanged = distinctUntilKeyChanged_1.distinctUntilKeyChanged;
	//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var distinctUntilKeyChanged_1 = __webpack_require__(446);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
	 * using a property accessed by using the key provided to check if the two items are distinct.
	 *
	 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
	 *
	 * If a comparator function is not provided, an equality check is used by default.
	 *
	 * @example <caption>An example comparing the name of persons</caption>
	 *
	 *  interface Person {
	 *     age: number,
	 *     name: string
	 *  }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo'},
	 *     { age: 6, name: 'Foo'})
	 *     .distinctUntilKeyChanged('name')
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo' }
	 * // { age: 7, name: 'Bar' }
	 * // { age: 5, name: 'Foo' }
	 *
	 * @example <caption>An example comparing the first letters of the name</caption>
	 *
	 * interface Person {
	 *     age: number,
	 *     name: string
	 *  }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo1'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo2'},
	 *     { age: 6, name: 'Foo3'})
	 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo1' }
	 * // { age: 7, name: 'Bar' }
	 * // { age: 5, name: 'Foo2' }
	 *
	 * @see {@link distinct}
	 * @see {@link distinctUntilChanged}
	 *
	 * @param {string} key String key for object property lookup on each item.
	 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
	 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
	 * @method distinctUntilKeyChanged
	 * @owner Observable
	 */
	function distinctUntilKeyChanged(key, compare) {
	    return distinctUntilKeyChanged_1.distinctUntilKeyChanged(key, compare)(this);
	}
	exports.distinctUntilKeyChanged = distinctUntilKeyChanged;
	//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var distinctUntilChanged_1 = __webpack_require__(443);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
	 * using a property accessed by using the key provided to check if the two items are distinct.
	 *
	 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
	 *
	 * If a comparator function is not provided, an equality check is used by default.
	 *
	 * @example <caption>An example comparing the name of persons</caption>
	 *
	 *  interface Person {
	 *     age: number,
	 *     name: string
	 *  }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo'},
	 *     { age: 6, name: 'Foo'})
	 *     .distinctUntilKeyChanged('name')
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo' }
	 * // { age: 7, name: 'Bar' }
	 * // { age: 5, name: 'Foo' }
	 *
	 * @example <caption>An example comparing the first letters of the name</caption>
	 *
	 * interface Person {
	 *     age: number,
	 *     name: string
	 *  }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo1'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo2'},
	 *     { age: 6, name: 'Foo3'})
	 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo1' }
	 * // { age: 7, name: 'Bar' }
	 * // { age: 5, name: 'Foo2' }
	 *
	 * @see {@link distinct}
	 * @see {@link distinctUntilChanged}
	 *
	 * @param {string} key String key for object property lookup on each item.
	 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
	 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
	 * @method distinctUntilKeyChanged
	 * @owner Observable
	 */
	function distinctUntilKeyChanged(key, compare) {
	    return distinctUntilChanged_1.distinctUntilChanged(function (x, y) { return compare ? compare(x[key], y[key]) : x[key] === y[key]; });
	}
	exports.distinctUntilKeyChanged = distinctUntilKeyChanged;
	//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var do_1 = __webpack_require__(448);
	Observable_1.Observable.prototype.do = do_1._do;
	Observable_1.Observable.prototype._do = do_1._do;
	//# sourceMappingURL=do.js.map

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var tap_1 = __webpack_require__(449);
	/* tslint:enable:max-line-length */
	/**
	 * Perform a side effect for every emission on the source Observable, but return
	 * an Observable that is identical to the source.
	 *
	 * <span class="informal">Intercepts each emission on the source and runs a
	 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
	 *
	 * <img src="./img/do.png" width="100%">
	 *
	 * Returns a mirrored Observable of the source Observable, but modified so that
	 * the provided Observer is called to perform a side effect for every value,
	 * error, and completion emitted by the source. Any errors that are thrown in
	 * the aforementioned Observer or handlers are safely sent down the error path
	 * of the output Observable.
	 *
	 * This operator is useful for debugging your Observables for the correct values
	 * or performing other side effects.
	 *
	 * Note: this is different to a `subscribe` on the Observable. If the Observable
	 * returned by `do` is not subscribed, the side effects specified by the
	 * Observer will never happen. `do` therefore simply spies on existing
	 * execution, it does not trigger an execution to happen like `subscribe` does.
	 *
	 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var positions = clicks
	 *   .do(ev => console.log(ev))
	 *   .map(ev => ev.clientX);
	 * positions.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 * @see {@link subscribe}
	 *
	 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
	 * callback for `next`.
	 * @param {function} [error] Callback for errors in the source.
	 * @param {function} [complete] Callback for the completion of the source.
	 * @return {Observable} An Observable identical to the source, but runs the
	 * specified Observer or callback(s) for each item.
	 * @method do
	 * @name do
	 * @owner Observable
	 */
	function _do(nextOrObserver, error, complete) {
	    return tap_1.tap(nextOrObserver, error, complete)(this);
	}
	exports._do = _do;
	//# sourceMappingURL=do.js.map

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	/* tslint:enable:max-line-length */
	/**
	 * Perform a side effect for every emission on the source Observable, but return
	 * an Observable that is identical to the source.
	 *
	 * <span class="informal">Intercepts each emission on the source and runs a
	 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
	 *
	 * <img src="./img/do.png" width="100%">
	 *
	 * Returns a mirrored Observable of the source Observable, but modified so that
	 * the provided Observer is called to perform a side effect for every value,
	 * error, and completion emitted by the source. Any errors that are thrown in
	 * the aforementioned Observer or handlers are safely sent down the error path
	 * of the output Observable.
	 *
	 * This operator is useful for debugging your Observables for the correct values
	 * or performing other side effects.
	 *
	 * Note: this is different to a `subscribe` on the Observable. If the Observable
	 * returned by `do` is not subscribed, the side effects specified by the
	 * Observer will never happen. `do` therefore simply spies on existing
	 * execution, it does not trigger an execution to happen like `subscribe` does.
	 *
	 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var positions = clicks
	 *   .do(ev => console.log(ev))
	 *   .map(ev => ev.clientX);
	 * positions.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 * @see {@link subscribe}
	 *
	 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
	 * callback for `next`.
	 * @param {function} [error] Callback for errors in the source.
	 * @param {function} [complete] Callback for the completion of the source.
	 * @return {Observable} An Observable identical to the source, but runs the
	 * specified Observer or callback(s) for each item.
	 * @name tap
	 */
	function tap(nextOrObserver, error, complete) {
	    return function tapOperatorFunction(source) {
	        return source.lift(new DoOperator(nextOrObserver, error, complete));
	    };
	}
	exports.tap = tap;
	var DoOperator = (function () {
	    function DoOperator(nextOrObserver, error, complete) {
	        this.nextOrObserver = nextOrObserver;
	        this.error = error;
	        this.complete = complete;
	    }
	    DoOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
	    };
	    return DoOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DoSubscriber = (function (_super) {
	    __extends(DoSubscriber, _super);
	    function DoSubscriber(destination, nextOrObserver, error, complete) {
	        _super.call(this, destination);
	        var safeSubscriber = new Subscriber_1.Subscriber(nextOrObserver, error, complete);
	        safeSubscriber.syncErrorThrowable = true;
	        this.add(safeSubscriber);
	        this.safeSubscriber = safeSubscriber;
	    }
	    DoSubscriber.prototype._next = function (value) {
	        var safeSubscriber = this.safeSubscriber;
	        safeSubscriber.next(value);
	        if (safeSubscriber.syncErrorThrown) {
	            this.destination.error(safeSubscriber.syncErrorValue);
	        }
	        else {
	            this.destination.next(value);
	        }
	    };
	    DoSubscriber.prototype._error = function (err) {
	        var safeSubscriber = this.safeSubscriber;
	        safeSubscriber.error(err);
	        if (safeSubscriber.syncErrorThrown) {
	            this.destination.error(safeSubscriber.syncErrorValue);
	        }
	        else {
	            this.destination.error(err);
	        }
	    };
	    DoSubscriber.prototype._complete = function () {
	        var safeSubscriber = this.safeSubscriber;
	        safeSubscriber.complete();
	        if (safeSubscriber.syncErrorThrown) {
	            this.destination.error(safeSubscriber.syncErrorValue);
	        }
	        else {
	            this.destination.complete();
	        }
	    };
	    return DoSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=tap.js.map

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var exhaust_1 = __webpack_require__(451);
	Observable_1.Observable.prototype.exhaust = exhaust_1.exhaust;
	//# sourceMappingURL=exhaust.js.map

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var exhaust_1 = __webpack_require__(452);
	/**
	 * Converts a higher-order Observable into a first-order Observable by dropping
	 * inner Observables while the previous inner Observable has not yet completed.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by dropping the
	 * next inner Observables while the current inner is still executing.</span>
	 *
	 * <img src="./img/exhaust.png" width="100%">
	 *
	 * `exhaust` subscribes to an Observable that emits Observables, also known as a
	 * higher-order Observable. Each time it observes one of these emitted inner
	 * Observables, the output Observable begins emitting the items emitted by that
	 * inner Observable. So far, it behaves like {@link mergeAll}. However,
	 * `exhaust` ignores every new inner Observable if the previous Observable has
	 * not yet completed. Once that one completes, it will accept and flatten the
	 * next inner Observable and repeat this process.
	 *
	 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
	 * var result = higherOrder.exhaust();
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link combineAll}
	 * @see {@link concatAll}
	 * @see {@link switch}
	 * @see {@link mergeAll}
	 * @see {@link exhaustMap}
	 * @see {@link zipAll}
	 *
	 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
	 * exclusively until it completes before subscribing to the next.
	 * @method exhaust
	 * @owner Observable
	 */
	function exhaust() {
	    return exhaust_1.exhaust()(this);
	}
	exports.exhaust = exhaust;
	//# sourceMappingURL=exhaust.js.map

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/**
	 * Converts a higher-order Observable into a first-order Observable by dropping
	 * inner Observables while the previous inner Observable has not yet completed.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by dropping the
	 * next inner Observables while the current inner is still executing.</span>
	 *
	 * <img src="./img/exhaust.png" width="100%">
	 *
	 * `exhaust` subscribes to an Observable that emits Observables, also known as a
	 * higher-order Observable. Each time it observes one of these emitted inner
	 * Observables, the output Observable begins emitting the items emitted by that
	 * inner Observable. So far, it behaves like {@link mergeAll}. However,
	 * `exhaust` ignores every new inner Observable if the previous Observable has
	 * not yet completed. Once that one completes, it will accept and flatten the
	 * next inner Observable and repeat this process.
	 *
	 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
	 * var result = higherOrder.exhaust();
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link combineAll}
	 * @see {@link concatAll}
	 * @see {@link switch}
	 * @see {@link mergeAll}
	 * @see {@link exhaustMap}
	 * @see {@link zipAll}
	 *
	 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
	 * exclusively until it completes before subscribing to the next.
	 * @method exhaust
	 * @owner Observable
	 */
	function exhaust() {
	    return function (source) { return source.lift(new SwitchFirstOperator()); };
	}
	exports.exhaust = exhaust;
	var SwitchFirstOperator = (function () {
	    function SwitchFirstOperator() {
	    }
	    SwitchFirstOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SwitchFirstSubscriber(subscriber));
	    };
	    return SwitchFirstOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SwitchFirstSubscriber = (function (_super) {
	    __extends(SwitchFirstSubscriber, _super);
	    function SwitchFirstSubscriber(destination) {
	        _super.call(this, destination);
	        this.hasCompleted = false;
	        this.hasSubscription = false;
	    }
	    SwitchFirstSubscriber.prototype._next = function (value) {
	        if (!this.hasSubscription) {
	            this.hasSubscription = true;
	            this.add(subscribeToResult_1.subscribeToResult(this, value));
	        }
	    };
	    SwitchFirstSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (!this.hasSubscription) {
	            this.destination.complete();
	        }
	    };
	    SwitchFirstSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.remove(innerSub);
	        this.hasSubscription = false;
	        if (this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return SwitchFirstSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=exhaust.js.map

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var exhaustMap_1 = __webpack_require__(454);
	Observable_1.Observable.prototype.exhaustMap = exhaustMap_1.exhaustMap;
	//# sourceMappingURL=exhaustMap.js.map

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var exhaustMap_1 = __webpack_require__(455);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable only if the previous projected Observable has completed.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link exhaust}.</span>
	 *
	 * <img src="./img/exhaustMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. When it projects a source value to
	 * an Observable, the output Observable begins emitting the items emitted by
	 * that projected Observable. However, `exhaustMap` ignores every new projected
	 * Observable if the previous projected Observable has not yet completed. Once
	 * that one completes, it will accept and flatten the next projected Observable
	 * and repeat this process.
	 *
	 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaust}
	 * @see {@link mergeMap}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable containing projected Observables
	 * of each item of the source, ignoring projected Observables that start before
	 * their preceding Observable has completed.
	 * @method exhaustMap
	 * @owner Observable
	 */
	function exhaustMap(project, resultSelector) {
	    return exhaustMap_1.exhaustMap(project, resultSelector)(this);
	}
	exports.exhaustMap = exhaustMap;
	//# sourceMappingURL=exhaustMap.js.map

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable only if the previous projected Observable has completed.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link exhaust}.</span>
	 *
	 * <img src="./img/exhaustMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. When it projects a source value to
	 * an Observable, the output Observable begins emitting the items emitted by
	 * that projected Observable. However, `exhaustMap` ignores every new projected
	 * Observable if the previous projected Observable has not yet completed. Once
	 * that one completes, it will accept and flatten the next projected Observable
	 * and repeat this process.
	 *
	 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaust}
	 * @see {@link mergeMap}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable containing projected Observables
	 * of each item of the source, ignoring projected Observables that start before
	 * their preceding Observable has completed.
	 * @method exhaustMap
	 * @owner Observable
	 */
	function exhaustMap(project, resultSelector) {
	    return function (source) { return source.lift(new SwitchFirstMapOperator(project, resultSelector)); };
	}
	exports.exhaustMap = exhaustMap;
	var SwitchFirstMapOperator = (function () {
	    function SwitchFirstMapOperator(project, resultSelector) {
	        this.project = project;
	        this.resultSelector = resultSelector;
	    }
	    SwitchFirstMapOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SwitchFirstMapSubscriber(subscriber, this.project, this.resultSelector));
	    };
	    return SwitchFirstMapOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SwitchFirstMapSubscriber = (function (_super) {
	    __extends(SwitchFirstMapSubscriber, _super);
	    function SwitchFirstMapSubscriber(destination, project, resultSelector) {
	        _super.call(this, destination);
	        this.project = project;
	        this.resultSelector = resultSelector;
	        this.hasSubscription = false;
	        this.hasCompleted = false;
	        this.index = 0;
	    }
	    SwitchFirstMapSubscriber.prototype._next = function (value) {
	        if (!this.hasSubscription) {
	            this.tryNext(value);
	        }
	    };
	    SwitchFirstMapSubscriber.prototype.tryNext = function (value) {
	        var index = this.index++;
	        var destination = this.destination;
	        try {
	            var result = this.project(value, index);
	            this.hasSubscription = true;
	            this.add(subscribeToResult_1.subscribeToResult(this, result, value, index));
	        }
	        catch (err) {
	            destination.error(err);
	        }
	    };
	    SwitchFirstMapSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (!this.hasSubscription) {
	            this.destination.complete();
	        }
	    };
	    SwitchFirstMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        if (resultSelector) {
	            this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            destination.next(innerValue);
	        }
	    };
	    SwitchFirstMapSubscriber.prototype.trySelectResult = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        try {
	            var result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	            destination.next(result);
	        }
	        catch (err) {
	            destination.error(err);
	        }
	    };
	    SwitchFirstMapSubscriber.prototype.notifyError = function (err) {
	        this.destination.error(err);
	    };
	    SwitchFirstMapSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.remove(innerSub);
	        this.hasSubscription = false;
	        if (this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return SwitchFirstMapSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=exhaustMap.js.map

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var expand_1 = __webpack_require__(457);
	Observable_1.Observable.prototype.expand = expand_1.expand;
	//# sourceMappingURL=expand.js.map

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var expand_1 = __webpack_require__(458);
	/* tslint:enable:max-line-length */
	/**
	 * Recursively projects each source value to an Observable which is merged in
	 * the output Observable.
	 *
	 * <span class="informal">It's similar to {@link mergeMap}, but applies the
	 * projection function to every source value as well as every output value.
	 * It's recursive.</span>
	 *
	 * <img src="./img/expand.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an Observable, and then merging those resulting Observables and
	 * emitting the results of this merger. *Expand* will re-emit on the output
	 * Observable every source value. Then, each output value is given to the
	 * `project` function which returns an inner Observable to be merged on the
	 * output Observable. Those output values resulting from the projection are also
	 * given to the `project` function to produce new output values. This is how
	 * *expand* behaves recursively.
	 *
	 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var powersOfTwo = clicks
	 *   .mapTo(1)
	 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
	 *   .take(10);
	 * powersOfTwo.subscribe(x => console.log(x));
	 *
	 * @see {@link mergeMap}
	 * @see {@link mergeScan}
	 *
	 * @param {function(value: T, index: number) => Observable} project A function
	 * that, when applied to an item emitted by the source or the output Observable,
	 * returns an Observable.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
	 * each projected inner Observable.
	 * @return {Observable} An Observable that emits the source values and also
	 * result of applying the projection function to each value emitted on the
	 * output Observable and and merging the results of the Observables obtained
	 * from this transformation.
	 * @method expand
	 * @owner Observable
	 */
	function expand(project, concurrent, scheduler) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    if (scheduler === void 0) { scheduler = undefined; }
	    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
	    return expand_1.expand(project, concurrent, scheduler)(this);
	}
	exports.expand = expand;
	//# sourceMappingURL=expand.js.map

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var tryCatch_1 = __webpack_require__(214);
	var errorObject_1 = __webpack_require__(215);
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/* tslint:enable:max-line-length */
	/**
	 * Recursively projects each source value to an Observable which is merged in
	 * the output Observable.
	 *
	 * <span class="informal">It's similar to {@link mergeMap}, but applies the
	 * projection function to every source value as well as every output value.
	 * It's recursive.</span>
	 *
	 * <img src="./img/expand.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an Observable, and then merging those resulting Observables and
	 * emitting the results of this merger. *Expand* will re-emit on the output
	 * Observable every source value. Then, each output value is given to the
	 * `project` function which returns an inner Observable to be merged on the
	 * output Observable. Those output values resulting from the projection are also
	 * given to the `project` function to produce new output values. This is how
	 * *expand* behaves recursively.
	 *
	 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var powersOfTwo = clicks
	 *   .mapTo(1)
	 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
	 *   .take(10);
	 * powersOfTwo.subscribe(x => console.log(x));
	 *
	 * @see {@link mergeMap}
	 * @see {@link mergeScan}
	 *
	 * @param {function(value: T, index: number) => Observable} project A function
	 * that, when applied to an item emitted by the source or the output Observable,
	 * returns an Observable.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
	 * each projected inner Observable.
	 * @return {Observable} An Observable that emits the source values and also
	 * result of applying the projection function to each value emitted on the
	 * output Observable and and merging the results of the Observables obtained
	 * from this transformation.
	 * @method expand
	 * @owner Observable
	 */
	function expand(project, concurrent, scheduler) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    if (scheduler === void 0) { scheduler = undefined; }
	    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
	    return function (source) { return source.lift(new ExpandOperator(project, concurrent, scheduler)); };
	}
	exports.expand = expand;
	var ExpandOperator = (function () {
	    function ExpandOperator(project, concurrent, scheduler) {
	        this.project = project;
	        this.concurrent = concurrent;
	        this.scheduler = scheduler;
	    }
	    ExpandOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
	    };
	    return ExpandOperator;
	}());
	exports.ExpandOperator = ExpandOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ExpandSubscriber = (function (_super) {
	    __extends(ExpandSubscriber, _super);
	    function ExpandSubscriber(destination, project, concurrent, scheduler) {
	        _super.call(this, destination);
	        this.project = project;
	        this.concurrent = concurrent;
	        this.scheduler = scheduler;
	        this.index = 0;
	        this.active = 0;
	        this.hasCompleted = false;
	        if (concurrent < Number.POSITIVE_INFINITY) {
	            this.buffer = [];
	        }
	    }
	    ExpandSubscriber.dispatch = function (arg) {
	        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
	        subscriber.subscribeToProjection(result, value, index);
	    };
	    ExpandSubscriber.prototype._next = function (value) {
	        var destination = this.destination;
	        if (destination.closed) {
	            this._complete();
	            return;
	        }
	        var index = this.index++;
	        if (this.active < this.concurrent) {
	            destination.next(value);
	            var result = tryCatch_1.tryCatch(this.project)(value, index);
	            if (result === errorObject_1.errorObject) {
	                destination.error(errorObject_1.errorObject.e);
	            }
	            else if (!this.scheduler) {
	                this.subscribeToProjection(result, value, index);
	            }
	            else {
	                var state = { subscriber: this, result: result, value: value, index: index };
	                this.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
	            }
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    ExpandSubscriber.prototype.subscribeToProjection = function (result, value, index) {
	        this.active++;
	        this.add(subscribeToResult_1.subscribeToResult(this, result, value, index));
	    };
	    ExpandSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.hasCompleted && this.active === 0) {
	            this.destination.complete();
	        }
	    };
	    ExpandSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this._next(innerValue);
	    };
	    ExpandSubscriber.prototype.notifyComplete = function (innerSub) {
	        var buffer = this.buffer;
	        this.remove(innerSub);
	        this.active--;
	        if (buffer && buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        if (this.hasCompleted && this.active === 0) {
	            this.destination.complete();
	        }
	    };
	    return ExpandSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.ExpandSubscriber = ExpandSubscriber;
	//# sourceMappingURL=expand.js.map

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var elementAt_1 = __webpack_require__(460);
	Observable_1.Observable.prototype.elementAt = elementAt_1.elementAt;
	//# sourceMappingURL=elementAt.js.map

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var elementAt_1 = __webpack_require__(461);
	/**
	 * Emits the single value at the specified `index` in a sequence of emissions
	 * from the source Observable.
	 *
	 * <span class="informal">Emits only the i-th value, then completes.</span>
	 *
	 * <img src="./img/elementAt.png" width="100%">
	 *
	 * `elementAt` returns an Observable that emits the item at the specified
	 * `index` in the source Observable, or a default value if that `index` is out
	 * of range and the `default` argument is provided. If the `default` argument is
	 * not given and the `index` is out of range, the output Observable will emit an
	 * `ArgumentOutOfRangeError` error.
	 *
	 * @example <caption>Emit only the third click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.elementAt(2);
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in:
	 * // click 1 = nothing
	 * // click 2 = nothing
	 * // click 3 = MouseEvent object logged to console
	 *
	 * @see {@link first}
	 * @see {@link last}
	 * @see {@link skip}
	 * @see {@link single}
	 * @see {@link take}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
	 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
	 * Observable has completed before emitting the i-th `next` notification.
	 *
	 * @param {number} index Is the number `i` for the i-th source emission that has
	 * happened since the subscription, starting from the number `0`.
	 * @param {T} [defaultValue] The default value returned for missing indices.
	 * @return {Observable} An Observable that emits a single item, if it is found.
	 * Otherwise, will emit the default value if given. If not, then emits an error.
	 * @method elementAt
	 * @owner Observable
	 */
	function elementAt(index, defaultValue) {
	    return elementAt_1.elementAt(index, defaultValue)(this);
	}
	exports.elementAt = elementAt;
	//# sourceMappingURL=elementAt.js.map

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	var ArgumentOutOfRangeError_1 = __webpack_require__(261);
	/**
	 * Emits the single value at the specified `index` in a sequence of emissions
	 * from the source Observable.
	 *
	 * <span class="informal">Emits only the i-th value, then completes.</span>
	 *
	 * <img src="./img/elementAt.png" width="100%">
	 *
	 * `elementAt` returns an Observable that emits the item at the specified
	 * `index` in the source Observable, or a default value if that `index` is out
	 * of range and the `default` argument is provided. If the `default` argument is
	 * not given and the `index` is out of range, the output Observable will emit an
	 * `ArgumentOutOfRangeError` error.
	 *
	 * @example <caption>Emit only the third click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.elementAt(2);
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in:
	 * // click 1 = nothing
	 * // click 2 = nothing
	 * // click 3 = MouseEvent object logged to console
	 *
	 * @see {@link first}
	 * @see {@link last}
	 * @see {@link skip}
	 * @see {@link single}
	 * @see {@link take}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
	 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
	 * Observable has completed before emitting the i-th `next` notification.
	 *
	 * @param {number} index Is the number `i` for the i-th source emission that has
	 * happened since the subscription, starting from the number `0`.
	 * @param {T} [defaultValue] The default value returned for missing indices.
	 * @return {Observable} An Observable that emits a single item, if it is found.
	 * Otherwise, will emit the default value if given. If not, then emits an error.
	 * @method elementAt
	 * @owner Observable
	 */
	function elementAt(index, defaultValue) {
	    return function (source) { return source.lift(new ElementAtOperator(index, defaultValue)); };
	}
	exports.elementAt = elementAt;
	var ElementAtOperator = (function () {
	    function ElementAtOperator(index, defaultValue) {
	        this.index = index;
	        this.defaultValue = defaultValue;
	        if (index < 0) {
	            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	        }
	    }
	    ElementAtOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ElementAtSubscriber(subscriber, this.index, this.defaultValue));
	    };
	    return ElementAtOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ElementAtSubscriber = (function (_super) {
	    __extends(ElementAtSubscriber, _super);
	    function ElementAtSubscriber(destination, index, defaultValue) {
	        _super.call(this, destination);
	        this.index = index;
	        this.defaultValue = defaultValue;
	    }
	    ElementAtSubscriber.prototype._next = function (x) {
	        if (this.index-- === 0) {
	            this.destination.next(x);
	            this.destination.complete();
	        }
	    };
	    ElementAtSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        if (this.index >= 0) {
	            if (typeof this.defaultValue !== 'undefined') {
	                destination.next(this.defaultValue);
	            }
	            else {
	                destination.error(new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError);
	            }
	        }
	        destination.complete();
	    };
	    return ElementAtSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=elementAt.js.map

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var filter_1 = __webpack_require__(297);
	Observable_1.Observable.prototype.filter = filter_1.filter;
	//# sourceMappingURL=filter.js.map

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var finally_1 = __webpack_require__(464);
	Observable_1.Observable.prototype.finally = finally_1._finally;
	Observable_1.Observable.prototype._finally = finally_1._finally;
	//# sourceMappingURL=finally.js.map

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var finalize_1 = __webpack_require__(465);
	/**
	 * Returns an Observable that mirrors the source Observable, but will call a specified function when
	 * the source terminates on complete or error.
	 * @param {function} callback Function to be called when source terminates.
	 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
	 * @method finally
	 * @owner Observable
	 */
	function _finally(callback) {
	    return finalize_1.finalize(callback)(this);
	}
	exports._finally = _finally;
	//# sourceMappingURL=finally.js.map

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	var Subscription_1 = __webpack_require__(211);
	/**
	 * Returns an Observable that mirrors the source Observable, but will call a specified function when
	 * the source terminates on complete or error.
	 * @param {function} callback Function to be called when source terminates.
	 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
	 * @method finally
	 * @owner Observable
	 */
	function finalize(callback) {
	    return function (source) { return source.lift(new FinallyOperator(callback)); };
	}
	exports.finalize = finalize;
	var FinallyOperator = (function () {
	    function FinallyOperator(callback) {
	        this.callback = callback;
	    }
	    FinallyOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new FinallySubscriber(subscriber, this.callback));
	    };
	    return FinallyOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var FinallySubscriber = (function (_super) {
	    __extends(FinallySubscriber, _super);
	    function FinallySubscriber(destination, callback) {
	        _super.call(this, destination);
	        this.add(new Subscription_1.Subscription(callback));
	    }
	    return FinallySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=finalize.js.map

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var find_1 = __webpack_require__(467);
	Observable_1.Observable.prototype.find = find_1.find;
	//# sourceMappingURL=find.js.map

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var find_1 = __webpack_require__(468);
	/* tslint:enable:max-line-length */
	/**
	 * Emits only the first value emitted by the source Observable that meets some
	 * condition.
	 *
	 * <span class="informal">Finds the first value that passes some test and emits
	 * that.</span>
	 *
	 * <img src="./img/find.png" width="100%">
	 *
	 * `find` searches for the first item in the source Observable that matches the
	 * specified condition embodied by the `predicate`, and returns the first
	 * occurrence in the source. Unlike {@link first}, the `predicate` is required
	 * in `find`, and does not emit an error if a valid value is not found.
	 *
	 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link filter}
	 * @see {@link first}
	 * @see {@link findIndex}
	 * @see {@link take}
	 *
	 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
	 * A function called with each item to test for condition matching.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {Observable<T>} An Observable of the first item that matches the
	 * condition.
	 * @method find
	 * @owner Observable
	 */
	function find(predicate, thisArg) {
	    return find_1.find(predicate, thisArg)(this);
	}
	exports.find = find;
	//# sourceMappingURL=find.js.map

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	/**
	 * Emits only the first value emitted by the source Observable that meets some
	 * condition.
	 *
	 * <span class="informal">Finds the first value that passes some test and emits
	 * that.</span>
	 *
	 * <img src="./img/find.png" width="100%">
	 *
	 * `find` searches for the first item in the source Observable that matches the
	 * specified condition embodied by the `predicate`, and returns the first
	 * occurrence in the source. Unlike {@link first}, the `predicate` is required
	 * in `find`, and does not emit an error if a valid value is not found.
	 *
	 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link filter}
	 * @see {@link first}
	 * @see {@link findIndex}
	 * @see {@link take}
	 *
	 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
	 * A function called with each item to test for condition matching.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {Observable<T>} An Observable of the first item that matches the
	 * condition.
	 * @method find
	 * @owner Observable
	 */
	function find(predicate, thisArg) {
	    if (typeof predicate !== 'function') {
	        throw new TypeError('predicate is not a function');
	    }
	    return function (source) { return source.lift(new FindValueOperator(predicate, source, false, thisArg)); };
	}
	exports.find = find;
	var FindValueOperator = (function () {
	    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
	        this.predicate = predicate;
	        this.source = source;
	        this.yieldIndex = yieldIndex;
	        this.thisArg = thisArg;
	    }
	    FindValueOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
	    };
	    return FindValueOperator;
	}());
	exports.FindValueOperator = FindValueOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var FindValueSubscriber = (function (_super) {
	    __extends(FindValueSubscriber, _super);
	    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.source = source;
	        this.yieldIndex = yieldIndex;
	        this.thisArg = thisArg;
	        this.index = 0;
	    }
	    FindValueSubscriber.prototype.notifyComplete = function (value) {
	        var destination = this.destination;
	        destination.next(value);
	        destination.complete();
	    };
	    FindValueSubscriber.prototype._next = function (value) {
	        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
	        var index = this.index++;
	        try {
	            var result = predicate.call(thisArg || this, value, index, this.source);
	            if (result) {
	                this.notifyComplete(this.yieldIndex ? index : value);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    FindValueSubscriber.prototype._complete = function () {
	        this.notifyComplete(this.yieldIndex ? -1 : undefined);
	    };
	    return FindValueSubscriber;
	}(Subscriber_1.Subscriber));
	exports.FindValueSubscriber = FindValueSubscriber;
	//# sourceMappingURL=find.js.map

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var findIndex_1 = __webpack_require__(470);
	Observable_1.Observable.prototype.findIndex = findIndex_1.findIndex;
	//# sourceMappingURL=findIndex.js.map

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var findIndex_1 = __webpack_require__(471);
	/**
	 * Emits only the index of the first value emitted by the source Observable that
	 * meets some condition.
	 *
	 * <span class="informal">It's like {@link find}, but emits the index of the
	 * found value, not the value itself.</span>
	 *
	 * <img src="./img/findIndex.png" width="100%">
	 *
	 * `findIndex` searches for the first item in the source Observable that matches
	 * the specified condition embodied by the `predicate`, and returns the
	 * (zero-based) index of the first occurrence in the source. Unlike
	 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
	 * an error if a valid value is not found.
	 *
	 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link filter}
	 * @see {@link find}
	 * @see {@link first}
	 * @see {@link take}
	 *
	 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
	 * A function called with each item to test for condition matching.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {Observable} An Observable of the index of the first item that
	 * matches the condition.
	 * @method find
	 * @owner Observable
	 */
	function findIndex(predicate, thisArg) {
	    return findIndex_1.findIndex(predicate, thisArg)(this);
	}
	exports.findIndex = findIndex;
	//# sourceMappingURL=findIndex.js.map

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var find_1 = __webpack_require__(468);
	/**
	 * Emits only the index of the first value emitted by the source Observable that
	 * meets some condition.
	 *
	 * <span class="informal">It's like {@link find}, but emits the index of the
	 * found value, not the value itself.</span>
	 *
	 * <img src="./img/findIndex.png" width="100%">
	 *
	 * `findIndex` searches for the first item in the source Observable that matches
	 * the specified condition embodied by the `predicate`, and returns the
	 * (zero-based) index of the first occurrence in the source. Unlike
	 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
	 * an error if a valid value is not found.
	 *
	 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link filter}
	 * @see {@link find}
	 * @see {@link first}
	 * @see {@link take}
	 *
	 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
	 * A function called with each item to test for condition matching.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {Observable} An Observable of the index of the first item that
	 * matches the condition.
	 * @method find
	 * @owner Observable
	 */
	function findIndex(predicate, thisArg) {
	    return function (source) { return source.lift(new find_1.FindValueOperator(predicate, source, true, thisArg)); };
	}
	exports.findIndex = findIndex;
	//# sourceMappingURL=findIndex.js.map

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var first_1 = __webpack_require__(287);
	Observable_1.Observable.prototype.first = first_1.first;
	//# sourceMappingURL=first.js.map

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var groupBy_1 = __webpack_require__(474);
	Observable_1.Observable.prototype.groupBy = groupBy_1.groupBy;
	//# sourceMappingURL=groupBy.js.map

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var groupBy_1 = __webpack_require__(475);
	exports.GroupedObservable = groupBy_1.GroupedObservable;
	/* tslint:enable:max-line-length */
	/**
	 * Groups the items emitted by an Observable according to a specified criterion,
	 * and emits these grouped items as `GroupedObservables`, one
	 * {@link GroupedObservable} per group.
	 *
	 * <img src="./img/groupBy.png" width="100%">
	 *
	 * @example <caption>Group objects by id and return as array</caption>
	 * Observable.of<Obj>({id: 1, name: 'aze1'},
	 *                    {id: 2, name: 'sf2'},
	 *                    {id: 2, name: 'dg2'},
	 *                    {id: 1, name: 'erg1'},
	 *                    {id: 1, name: 'df1'},
	 *                    {id: 2, name: 'sfqfb2'},
	 *                    {id: 3, name: 'qfs3'},
	 *                    {id: 2, name: 'qsgqsfg2'}
	 *     )
	 *     .groupBy(p => p.id)
	 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
	 *     .subscribe(p => console.log(p));
	 *
	 * // displays:
	 * // [ { id: 1, name: 'aze1' },
	 * //   { id: 1, name: 'erg1' },
	 * //   { id: 1, name: 'df1' } ]
	 * //
	 * // [ { id: 2, name: 'sf2' },
	 * //   { id: 2, name: 'dg2' },
	 * //   { id: 2, name: 'sfqfb2' },
	 * //   { id: 2, name: 'qsgqsfg2' } ]
	 * //
	 * // [ { id: 3, name: 'qfs3' } ]
	 *
	 * @example <caption>Pivot data on the id field</caption>
	 * Observable.of<Obj>({id: 1, name: 'aze1'},
	 *                    {id: 2, name: 'sf2'},
	 *                    {id: 2, name: 'dg2'},
	 *                    {id: 1, name: 'erg1'},
	 *                    {id: 1, name: 'df1'},
	 *                    {id: 2, name: 'sfqfb2'},
	 *                    {id: 3, name: 'qfs1'},
	 *                    {id: 2, name: 'qsgqsfg2'}
	 *                   )
	 *     .groupBy(p => p.id, p => p.name)
	 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
	 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
	 *     .subscribe(p => console.log(p));
	 *
	 * // displays:
	 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
	 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
	 * // { id: 3, values: [ 'qfs1' ] }
	 *
	 * @param {function(value: T): K} keySelector A function that extracts the key
	 * for each item.
	 * @param {function(value: T): R} [elementSelector] A function that extracts the
	 * return element for each item.
	 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
	 * A function that returns an Observable to determine how long each group should
	 * exist.
	 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
	 * GroupedObservables, each of which corresponds to a unique key value and each
	 * of which emits those items from the source Observable that share that key
	 * value.
	 * @method groupBy
	 * @owner Observable
	 */
	function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
	    return groupBy_1.groupBy(keySelector, elementSelector, durationSelector, subjectSelector)(this);
	}
	exports.groupBy = groupBy;
	//# sourceMappingURL=groupBy.js.map

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	var Subscription_1 = __webpack_require__(211);
	var Observable_1 = __webpack_require__(206);
	var Subject_1 = __webpack_require__(240);
	var Map_1 = __webpack_require__(476);
	var FastMap_1 = __webpack_require__(478);
	/* tslint:enable:max-line-length */
	/**
	 * Groups the items emitted by an Observable according to a specified criterion,
	 * and emits these grouped items as `GroupedObservables`, one
	 * {@link GroupedObservable} per group.
	 *
	 * <img src="./img/groupBy.png" width="100%">
	 *
	 * @example <caption>Group objects by id and return as array</caption>
	 * Observable.of<Obj>({id: 1, name: 'aze1'},
	 *                    {id: 2, name: 'sf2'},
	 *                    {id: 2, name: 'dg2'},
	 *                    {id: 1, name: 'erg1'},
	 *                    {id: 1, name: 'df1'},
	 *                    {id: 2, name: 'sfqfb2'},
	 *                    {id: 3, name: 'qfs3'},
	 *                    {id: 2, name: 'qsgqsfg2'}
	 *     )
	 *     .groupBy(p => p.id)
	 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
	 *     .subscribe(p => console.log(p));
	 *
	 * // displays:
	 * // [ { id: 1, name: 'aze1' },
	 * //   { id: 1, name: 'erg1' },
	 * //   { id: 1, name: 'df1' } ]
	 * //
	 * // [ { id: 2, name: 'sf2' },
	 * //   { id: 2, name: 'dg2' },
	 * //   { id: 2, name: 'sfqfb2' },
	 * //   { id: 2, name: 'qsgqsfg2' } ]
	 * //
	 * // [ { id: 3, name: 'qfs3' } ]
	 *
	 * @example <caption>Pivot data on the id field</caption>
	 * Observable.of<Obj>({id: 1, name: 'aze1'},
	 *                    {id: 2, name: 'sf2'},
	 *                    {id: 2, name: 'dg2'},
	 *                    {id: 1, name: 'erg1'},
	 *                    {id: 1, name: 'df1'},
	 *                    {id: 2, name: 'sfqfb2'},
	 *                    {id: 3, name: 'qfs1'},
	 *                    {id: 2, name: 'qsgqsfg2'}
	 *                   )
	 *     .groupBy(p => p.id, p => p.name)
	 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
	 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
	 *     .subscribe(p => console.log(p));
	 *
	 * // displays:
	 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
	 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
	 * // { id: 3, values: [ 'qfs1' ] }
	 *
	 * @param {function(value: T): K} keySelector A function that extracts the key
	 * for each item.
	 * @param {function(value: T): R} [elementSelector] A function that extracts the
	 * return element for each item.
	 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
	 * A function that returns an Observable to determine how long each group should
	 * exist.
	 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
	 * GroupedObservables, each of which corresponds to a unique key value and each
	 * of which emits those items from the source Observable that share that key
	 * value.
	 * @method groupBy
	 * @owner Observable
	 */
	function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
	    return function (source) {
	        return source.lift(new GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
	    };
	}
	exports.groupBy = groupBy;
	var GroupByOperator = (function () {
	    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
	        this.keySelector = keySelector;
	        this.elementSelector = elementSelector;
	        this.durationSelector = durationSelector;
	        this.subjectSelector = subjectSelector;
	    }
	    GroupByOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
	    };
	    return GroupByOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var GroupBySubscriber = (function (_super) {
	    __extends(GroupBySubscriber, _super);
	    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
	        _super.call(this, destination);
	        this.keySelector = keySelector;
	        this.elementSelector = elementSelector;
	        this.durationSelector = durationSelector;
	        this.subjectSelector = subjectSelector;
	        this.groups = null;
	        this.attemptedToUnsubscribe = false;
	        this.count = 0;
	    }
	    GroupBySubscriber.prototype._next = function (value) {
	        var key;
	        try {
	            key = this.keySelector(value);
	        }
	        catch (err) {
	            this.error(err);
	            return;
	        }
	        this._group(value, key);
	    };
	    GroupBySubscriber.prototype._group = function (value, key) {
	        var groups = this.groups;
	        if (!groups) {
	            groups = this.groups = typeof key === 'string' ? new FastMap_1.FastMap() : new Map_1.Map();
	        }
	        var group = groups.get(key);
	        var element;
	        if (this.elementSelector) {
	            try {
	                element = this.elementSelector(value);
	            }
	            catch (err) {
	                this.error(err);
	            }
	        }
	        else {
	            element = value;
	        }
	        if (!group) {
	            group = this.subjectSelector ? this.subjectSelector() : new Subject_1.Subject();
	            groups.set(key, group);
	            var groupedObservable = new GroupedObservable(key, group, this);
	            this.destination.next(groupedObservable);
	            if (this.durationSelector) {
	                var duration = void 0;
	                try {
	                    duration = this.durationSelector(new GroupedObservable(key, group));
	                }
	                catch (err) {
	                    this.error(err);
	                    return;
	                }
	                this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
	            }
	        }
	        if (!group.closed) {
	            group.next(element);
	        }
	    };
	    GroupBySubscriber.prototype._error = function (err) {
	        var groups = this.groups;
	        if (groups) {
	            groups.forEach(function (group, key) {
	                group.error(err);
	            });
	            groups.clear();
	        }
	        this.destination.error(err);
	    };
	    GroupBySubscriber.prototype._complete = function () {
	        var groups = this.groups;
	        if (groups) {
	            groups.forEach(function (group, key) {
	                group.complete();
	            });
	            groups.clear();
	        }
	        this.destination.complete();
	    };
	    GroupBySubscriber.prototype.removeGroup = function (key) {
	        this.groups.delete(key);
	    };
	    GroupBySubscriber.prototype.unsubscribe = function () {
	        if (!this.closed) {
	            this.attemptedToUnsubscribe = true;
	            if (this.count === 0) {
	                _super.prototype.unsubscribe.call(this);
	            }
	        }
	    };
	    return GroupBySubscriber;
	}(Subscriber_1.Subscriber));
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var GroupDurationSubscriber = (function (_super) {
	    __extends(GroupDurationSubscriber, _super);
	    function GroupDurationSubscriber(key, group, parent) {
	        _super.call(this, group);
	        this.key = key;
	        this.group = group;
	        this.parent = parent;
	    }
	    GroupDurationSubscriber.prototype._next = function (value) {
	        this.complete();
	    };
	    /** @deprecated internal use only */ GroupDurationSubscriber.prototype._unsubscribe = function () {
	        var _a = this, parent = _a.parent, key = _a.key;
	        this.key = this.parent = null;
	        if (parent) {
	            parent.removeGroup(key);
	        }
	    };
	    return GroupDurationSubscriber;
	}(Subscriber_1.Subscriber));
	/**
	 * An Observable representing values belonging to the same group represented by
	 * a common key. The values emitted by a GroupedObservable come from the source
	 * Observable. The common key is available as the field `key` on a
	 * GroupedObservable instance.
	 *
	 * @class GroupedObservable<K, T>
	 */
	var GroupedObservable = (function (_super) {
	    __extends(GroupedObservable, _super);
	    function GroupedObservable(key, groupSubject, refCountSubscription) {
	        _super.call(this);
	        this.key = key;
	        this.groupSubject = groupSubject;
	        this.refCountSubscription = refCountSubscription;
	    }
	    /** @deprecated internal use only */ GroupedObservable.prototype._subscribe = function (subscriber) {
	        var subscription = new Subscription_1.Subscription();
	        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
	        if (refCountSubscription && !refCountSubscription.closed) {
	            subscription.add(new InnerRefCountSubscription(refCountSubscription));
	        }
	        subscription.add(groupSubject.subscribe(subscriber));
	        return subscription;
	    };
	    return GroupedObservable;
	}(Observable_1.Observable));
	exports.GroupedObservable = GroupedObservable;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var InnerRefCountSubscription = (function (_super) {
	    __extends(InnerRefCountSubscription, _super);
	    function InnerRefCountSubscription(parent) {
	        _super.call(this);
	        this.parent = parent;
	        parent.count++;
	    }
	    InnerRefCountSubscription.prototype.unsubscribe = function () {
	        var parent = this.parent;
	        if (!parent.closed && !this.closed) {
	            _super.prototype.unsubscribe.call(this);
	            parent.count -= 1;
	            if (parent.count === 0 && parent.attemptedToUnsubscribe) {
	                parent.unsubscribe();
	            }
	        }
	    };
	    return InnerRefCountSubscription;
	}(Subscription_1.Subscription));
	//# sourceMappingURL=groupBy.js.map

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(207);
	var MapPolyfill_1 = __webpack_require__(477);
	exports.Map = root_1.root.Map || (function () { return MapPolyfill_1.MapPolyfill; })();
	//# sourceMappingURL=Map.js.map

/***/ }),
/* 477 */
/***/ (function(module, exports) {

	"use strict";
	var MapPolyfill = (function () {
	    function MapPolyfill() {
	        this.size = 0;
	        this._values = [];
	        this._keys = [];
	    }
	    MapPolyfill.prototype.get = function (key) {
	        var i = this._keys.indexOf(key);
	        return i === -1 ? undefined : this._values[i];
	    };
	    MapPolyfill.prototype.set = function (key, value) {
	        var i = this._keys.indexOf(key);
	        if (i === -1) {
	            this._keys.push(key);
	            this._values.push(value);
	            this.size++;
	        }
	        else {
	            this._values[i] = value;
	        }
	        return this;
	    };
	    MapPolyfill.prototype.delete = function (key) {
	        var i = this._keys.indexOf(key);
	        if (i === -1) {
	            return false;
	        }
	        this._values.splice(i, 1);
	        this._keys.splice(i, 1);
	        this.size--;
	        return true;
	    };
	    MapPolyfill.prototype.clear = function () {
	        this._keys.length = 0;
	        this._values.length = 0;
	        this.size = 0;
	    };
	    MapPolyfill.prototype.forEach = function (cb, thisArg) {
	        for (var i = 0; i < this.size; i++) {
	            cb.call(thisArg, this._values[i], this._keys[i]);
	        }
	    };
	    return MapPolyfill;
	}());
	exports.MapPolyfill = MapPolyfill;
	//# sourceMappingURL=MapPolyfill.js.map

/***/ }),
/* 478 */
/***/ (function(module, exports) {

	"use strict";
	var FastMap = (function () {
	    function FastMap() {
	        this.values = {};
	    }
	    FastMap.prototype.delete = function (key) {
	        this.values[key] = null;
	        return true;
	    };
	    FastMap.prototype.set = function (key, value) {
	        this.values[key] = value;
	        return this;
	    };
	    FastMap.prototype.get = function (key) {
	        return this.values[key];
	    };
	    FastMap.prototype.forEach = function (cb, thisArg) {
	        var values = this.values;
	        for (var key in values) {
	            if (values.hasOwnProperty(key) && values[key] !== null) {
	                cb.call(thisArg, values[key], key);
	            }
	        }
	    };
	    FastMap.prototype.clear = function () {
	        this.values = {};
	    };
	    return FastMap;
	}());
	exports.FastMap = FastMap;
	//# sourceMappingURL=FastMap.js.map

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var ignoreElements_1 = __webpack_require__(480);
	Observable_1.Observable.prototype.ignoreElements = ignoreElements_1.ignoreElements;
	//# sourceMappingURL=ignoreElements.js.map

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ignoreElements_1 = __webpack_require__(481);
	/**
	 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
	 *
	 * <img src="./img/ignoreElements.png" width="100%">
	 *
	 * @return {Observable} An empty Observable that only calls `complete`
	 * or `error`, based on which one is called by the source Observable.
	 * @method ignoreElements
	 * @owner Observable
	 */
	function ignoreElements() {
	    return ignoreElements_1.ignoreElements()(this);
	}
	exports.ignoreElements = ignoreElements;
	;
	//# sourceMappingURL=ignoreElements.js.map

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	var noop_1 = __webpack_require__(221);
	/**
	 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
	 *
	 * <img src="./img/ignoreElements.png" width="100%">
	 *
	 * @return {Observable} An empty Observable that only calls `complete`
	 * or `error`, based on which one is called by the source Observable.
	 * @method ignoreElements
	 * @owner Observable
	 */
	function ignoreElements() {
	    return function ignoreElementsOperatorFunction(source) {
	        return source.lift(new IgnoreElementsOperator());
	    };
	}
	exports.ignoreElements = ignoreElements;
	var IgnoreElementsOperator = (function () {
	    function IgnoreElementsOperator() {
	    }
	    IgnoreElementsOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new IgnoreElementsSubscriber(subscriber));
	    };
	    return IgnoreElementsOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var IgnoreElementsSubscriber = (function (_super) {
	    __extends(IgnoreElementsSubscriber, _super);
	    function IgnoreElementsSubscriber() {
	        _super.apply(this, arguments);
	    }
	    IgnoreElementsSubscriber.prototype._next = function (unused) {
	        noop_1.noop();
	    };
	    return IgnoreElementsSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=ignoreElements.js.map

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var isEmpty_1 = __webpack_require__(483);
	Observable_1.Observable.prototype.isEmpty = isEmpty_1.isEmpty;
	//# sourceMappingURL=isEmpty.js.map

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var isEmpty_1 = __webpack_require__(484);
	/**
	 * If the source Observable is empty it returns an Observable that emits true, otherwise it emits false.
	 *
	 * <img src="./img/isEmpty.png" width="100%">
	 *
	 * @return {Observable} An Observable that emits a Boolean.
	 * @method isEmpty
	 * @owner Observable
	 */
	function isEmpty() {
	    return isEmpty_1.isEmpty()(this);
	}
	exports.isEmpty = isEmpty;
	//# sourceMappingURL=isEmpty.js.map

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	function isEmpty() {
	    return function (source) { return source.lift(new IsEmptyOperator()); };
	}
	exports.isEmpty = isEmpty;
	var IsEmptyOperator = (function () {
	    function IsEmptyOperator() {
	    }
	    IsEmptyOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new IsEmptySubscriber(observer));
	    };
	    return IsEmptyOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var IsEmptySubscriber = (function (_super) {
	    __extends(IsEmptySubscriber, _super);
	    function IsEmptySubscriber(destination) {
	        _super.call(this, destination);
	    }
	    IsEmptySubscriber.prototype.notifyComplete = function (isEmpty) {
	        var destination = this.destination;
	        destination.next(isEmpty);
	        destination.complete();
	    };
	    IsEmptySubscriber.prototype._next = function (value) {
	        this.notifyComplete(false);
	    };
	    IsEmptySubscriber.prototype._complete = function () {
	        this.notifyComplete(true);
	    };
	    return IsEmptySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=isEmpty.js.map

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var audit_1 = __webpack_require__(486);
	Observable_1.Observable.prototype.audit = audit_1.audit;
	//# sourceMappingURL=audit.js.map

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var audit_1 = __webpack_require__(487);
	/**
	 * Ignores source values for a duration determined by another Observable, then
	 * emits the most recent value from the source Observable, then repeats this
	 * process.
	 *
	 * <span class="informal">It's like {@link auditTime}, but the silencing
	 * duration is determined by a second Observable.</span>
	 *
	 * <img src="./img/audit.png" width="100%">
	 *
	 * `audit` is similar to `throttle`, but emits the last value from the silenced
	 * time window, instead of the first value. `audit` emits the most recent value
	 * from the source Observable on the output Observable as soon as its internal
	 * timer becomes disabled, and ignores source values while the timer is enabled.
	 * Initially, the timer is disabled. As soon as the first source value arrives,
	 * the timer is enabled by calling the `durationSelector` function with the
	 * source value, which returns the "duration" Observable. When the duration
	 * Observable emits a value or completes, the timer is disabled, then the most
	 * recent source value is emitted on the output Observable, and this process
	 * repeats for the next source value.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounce}
	 * @see {@link delayWhen}
	 * @see {@link sample}
	 * @see {@link throttle}
	 *
	 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
	 * that receives a value from the source Observable, for computing the silencing
	 * duration, returned as an Observable or a Promise.
	 * @return {Observable<T>} An Observable that performs rate-limiting of
	 * emissions from the source Observable.
	 * @method audit
	 * @owner Observable
	 */
	function audit(durationSelector) {
	    return audit_1.audit(durationSelector)(this);
	}
	exports.audit = audit;
	//# sourceMappingURL=audit.js.map

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var tryCatch_1 = __webpack_require__(214);
	var errorObject_1 = __webpack_require__(215);
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/**
	 * Ignores source values for a duration determined by another Observable, then
	 * emits the most recent value from the source Observable, then repeats this
	 * process.
	 *
	 * <span class="informal">It's like {@link auditTime}, but the silencing
	 * duration is determined by a second Observable.</span>
	 *
	 * <img src="./img/audit.png" width="100%">
	 *
	 * `audit` is similar to `throttle`, but emits the last value from the silenced
	 * time window, instead of the first value. `audit` emits the most recent value
	 * from the source Observable on the output Observable as soon as its internal
	 * timer becomes disabled, and ignores source values while the timer is enabled.
	 * Initially, the timer is disabled. As soon as the first source value arrives,
	 * the timer is enabled by calling the `durationSelector` function with the
	 * source value, which returns the "duration" Observable. When the duration
	 * Observable emits a value or completes, the timer is disabled, then the most
	 * recent source value is emitted on the output Observable, and this process
	 * repeats for the next source value.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounce}
	 * @see {@link delayWhen}
	 * @see {@link sample}
	 * @see {@link throttle}
	 *
	 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
	 * that receives a value from the source Observable, for computing the silencing
	 * duration, returned as an Observable or a Promise.
	 * @return {Observable<T>} An Observable that performs rate-limiting of
	 * emissions from the source Observable.
	 * @method audit
	 * @owner Observable
	 */
	function audit(durationSelector) {
	    return function auditOperatorFunction(source) {
	        return source.lift(new AuditOperator(durationSelector));
	    };
	}
	exports.audit = audit;
	var AuditOperator = (function () {
	    function AuditOperator(durationSelector) {
	        this.durationSelector = durationSelector;
	    }
	    AuditOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new AuditSubscriber(subscriber, this.durationSelector));
	    };
	    return AuditOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AuditSubscriber = (function (_super) {
	    __extends(AuditSubscriber, _super);
	    function AuditSubscriber(destination, durationSelector) {
	        _super.call(this, destination);
	        this.durationSelector = durationSelector;
	        this.hasValue = false;
	    }
	    AuditSubscriber.prototype._next = function (value) {
	        this.value = value;
	        this.hasValue = true;
	        if (!this.throttled) {
	            var duration = tryCatch_1.tryCatch(this.durationSelector)(value);
	            if (duration === errorObject_1.errorObject) {
	                this.destination.error(errorObject_1.errorObject.e);
	            }
	            else {
	                var innerSubscription = subscribeToResult_1.subscribeToResult(this, duration);
	                if (innerSubscription.closed) {
	                    this.clearThrottle();
	                }
	                else {
	                    this.add(this.throttled = innerSubscription);
	                }
	            }
	        }
	    };
	    AuditSubscriber.prototype.clearThrottle = function () {
	        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
	        if (throttled) {
	            this.remove(throttled);
	            this.throttled = null;
	            throttled.unsubscribe();
	        }
	        if (hasValue) {
	            this.value = null;
	            this.hasValue = false;
	            this.destination.next(value);
	        }
	    };
	    AuditSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
	        this.clearThrottle();
	    };
	    AuditSubscriber.prototype.notifyComplete = function () {
	        this.clearThrottle();
	    };
	    return AuditSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=audit.js.map

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var auditTime_1 = __webpack_require__(489);
	Observable_1.Observable.prototype.auditTime = auditTime_1.auditTime;
	//# sourceMappingURL=auditTime.js.map

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(343);
	var auditTime_1 = __webpack_require__(490);
	/**
	 * Ignores source values for `duration` milliseconds, then emits the most recent
	 * value from the source Observable, then repeats this process.
	 *
	 * <span class="informal">When it sees a source values, it ignores that plus
	 * the next ones for `duration` milliseconds, and then it emits the most recent
	 * value from the source.</span>
	 *
	 * <img src="./img/auditTime.png" width="100%">
	 *
	 * `auditTime` is similar to `throttleTime`, but emits the last value from the
	 * silenced time window, instead of the first value. `auditTime` emits the most
	 * recent value from the source Observable on the output Observable as soon as
	 * its internal timer becomes disabled, and ignores source values while the
	 * timer is enabled. Initially, the timer is disabled. As soon as the first
	 * source value arrives, the timer is enabled. After `duration` milliseconds (or
	 * the time unit determined internally by the optional `scheduler`) has passed,
	 * the timer is disabled, then the most recent source value is emitted on the
	 * output Observable, and this process repeats for the next source value.
	 * Optionally takes a {@link IScheduler} for managing timers.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.auditTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounceTime}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttleTime}
	 *
	 * @param {number} duration Time to wait before emitting the most recent source
	 * value, measured in milliseconds or the time unit determined internally
	 * by the optional `scheduler`.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the rate-limiting behavior.
	 * @return {Observable<T>} An Observable that performs rate-limiting of
	 * emissions from the source Observable.
	 * @method auditTime
	 * @owner Observable
	 */
	function auditTime(duration, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return auditTime_1.auditTime(duration, scheduler)(this);
	}
	exports.auditTime = auditTime;
	//# sourceMappingURL=auditTime.js.map

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(343);
	var audit_1 = __webpack_require__(487);
	var timer_1 = __webpack_require__(371);
	/**
	 * Ignores source values for `duration` milliseconds, then emits the most recent
	 * value from the source Observable, then repeats this process.
	 *
	 * <span class="informal">When it sees a source values, it ignores that plus
	 * the next ones for `duration` milliseconds, and then it emits the most recent
	 * value from the source.</span>
	 *
	 * <img src="./img/auditTime.png" width="100%">
	 *
	 * `auditTime` is similar to `throttleTime`, but emits the last value from the
	 * silenced time window, instead of the first value. `auditTime` emits the most
	 * recent value from the source Observable on the output Observable as soon as
	 * its internal timer becomes disabled, and ignores source values while the
	 * timer is enabled. Initially, the timer is disabled. As soon as the first
	 * source value arrives, the timer is enabled. After `duration` milliseconds (or
	 * the time unit determined internally by the optional `scheduler`) has passed,
	 * the timer is disabled, then the most recent source value is emitted on the
	 * output Observable, and this process repeats for the next source value.
	 * Optionally takes a {@link IScheduler} for managing timers.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.auditTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounceTime}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttleTime}
	 *
	 * @param {number} duration Time to wait before emitting the most recent source
	 * value, measured in milliseconds or the time unit determined internally
	 * by the optional `scheduler`.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the rate-limiting behavior.
	 * @return {Observable<T>} An Observable that performs rate-limiting of
	 * emissions from the source Observable.
	 * @method auditTime
	 * @owner Observable
	 */
	function auditTime(duration, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return audit_1.audit(function () { return timer_1.timer(duration, scheduler); });
	}
	exports.auditTime = auditTime;
	//# sourceMappingURL=auditTime.js.map

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var last_1 = __webpack_require__(293);
	Observable_1.Observable.prototype.last = last_1.last;
	//# sourceMappingURL=last.js.map

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var let_1 = __webpack_require__(493);
	Observable_1.Observable.prototype.let = let_1.letProto;
	Observable_1.Observable.prototype.letBind = let_1.letProto;
	//# sourceMappingURL=let.js.map

/***/ }),
/* 493 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @param func
	 * @return {Observable<R>}
	 * @method let
	 * @owner Observable
	 */
	function letProto(func) {
	    return func(this);
	}
	exports.letProto = letProto;
	//# sourceMappingURL=let.js.map

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var every_1 = __webpack_require__(291);
	Observable_1.Observable.prototype.every = every_1.every;
	//# sourceMappingURL=every.js.map

/***/ }),
/* 495 */,
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var mapTo_1 = __webpack_require__(497);
	Observable_1.Observable.prototype.mapTo = mapTo_1.mapTo;
	//# sourceMappingURL=mapTo.js.map

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mapTo_1 = __webpack_require__(498);
	/**
	 * Emits the given constant value on the output Observable every time the source
	 * Observable emits a value.
	 *
	 * <span class="informal">Like {@link map}, but it maps every source value to
	 * the same output value every time.</span>
	 *
	 * <img src="./img/mapTo.png" width="100%">
	 *
	 * Takes a constant `value` as argument, and emits that whenever the source
	 * Observable emits a value. In other words, ignores the actual source value,
	 * and simply uses the emission moment to know when to emit the given `value`.
	 *
	 * @example <caption>Map every click to the string 'Hi'</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var greetings = clicks.mapTo('Hi');
	 * greetings.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 *
	 * @param {any} value The value to map each source value to.
	 * @return {Observable} An Observable that emits the given `value` every time
	 * the source Observable emits something.
	 * @method mapTo
	 * @owner Observable
	 */
	function mapTo(value) {
	    return mapTo_1.mapTo(value)(this);
	}
	exports.mapTo = mapTo;
	//# sourceMappingURL=mapTo.js.map

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	/**
	 * Emits the given constant value on the output Observable every time the source
	 * Observable emits a value.
	 *
	 * <span class="informal">Like {@link map}, but it maps every source value to
	 * the same output value every time.</span>
	 *
	 * <img src="./img/mapTo.png" width="100%">
	 *
	 * Takes a constant `value` as argument, and emits that whenever the source
	 * Observable emits a value. In other words, ignores the actual source value,
	 * and simply uses the emission moment to know when to emit the given `value`.
	 *
	 * @example <caption>Map every click to the string 'Hi'</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var greetings = clicks.mapTo('Hi');
	 * greetings.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 *
	 * @param {any} value The value to map each source value to.
	 * @return {Observable} An Observable that emits the given `value` every time
	 * the source Observable emits something.
	 * @method mapTo
	 * @owner Observable
	 */
	function mapTo(value) {
	    return function (source) { return source.lift(new MapToOperator(value)); };
	}
	exports.mapTo = mapTo;
	var MapToOperator = (function () {
	    function MapToOperator(value) {
	        this.value = value;
	    }
	    MapToOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MapToSubscriber(subscriber, this.value));
	    };
	    return MapToOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MapToSubscriber = (function (_super) {
	    __extends(MapToSubscriber, _super);
	    function MapToSubscriber(destination, value) {
	        _super.call(this, destination);
	        this.value = value;
	    }
	    MapToSubscriber.prototype._next = function (x) {
	        this.destination.next(this.value);
	    };
	    return MapToSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=mapTo.js.map

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var materialize_1 = __webpack_require__(500);
	Observable_1.Observable.prototype.materialize = materialize_1.materialize;
	//# sourceMappingURL=materialize.js.map

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var materialize_1 = __webpack_require__(501);
	/**
	 * Represents all of the notifications from the source Observable as `next`
	 * emissions marked with their original types within {@link Notification}
	 * objects.
	 *
	 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
	 * {@link Notification} objects, emitted as `next` on the output Observable.
	 * </span>
	 *
	 * <img src="./img/materialize.png" width="100%">
	 *
	 * `materialize` returns an Observable that emits a `next` notification for each
	 * `next`, `error`, or `complete` emission of the source Observable. When the
	 * source Observable emits `complete`, the output Observable will emit `next` as
	 * a Notification of type "complete", and then it will emit `complete` as well.
	 * When the source Observable emits `error`, the output will emit `next` as a
	 * Notification of type "error", and then `complete`.
	 *
	 * This operator is useful for producing metadata of the source Observable, to
	 * be consumed as `next` emissions. Use it in conjunction with
	 * {@link dematerialize}.
	 *
	 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
	 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
	 * var upperCase = letters.map(x => x.toUpperCase());
	 * var materialized = upperCase.materialize();
	 * materialized.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
	 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
	 * // - Notification {kind: "E", value: undefined, error: TypeError:
	 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
	 * //   [as project] (http://1…, hasValue: false}
	 *
	 * @see {@link Notification}
	 * @see {@link dematerialize}
	 *
	 * @return {Observable<Notification<T>>} An Observable that emits
	 * {@link Notification} objects that wrap the original emissions from the source
	 * Observable with metadata.
	 * @method materialize
	 * @owner Observable
	 */
	function materialize() {
	    return materialize_1.materialize()(this);
	}
	exports.materialize = materialize;
	//# sourceMappingURL=materialize.js.map

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	var Notification_1 = __webpack_require__(282);
	/**
	 * Represents all of the notifications from the source Observable as `next`
	 * emissions marked with their original types within {@link Notification}
	 * objects.
	 *
	 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
	 * {@link Notification} objects, emitted as `next` on the output Observable.
	 * </span>
	 *
	 * <img src="./img/materialize.png" width="100%">
	 *
	 * `materialize` returns an Observable that emits a `next` notification for each
	 * `next`, `error`, or `complete` emission of the source Observable. When the
	 * source Observable emits `complete`, the output Observable will emit `next` as
	 * a Notification of type "complete", and then it will emit `complete` as well.
	 * When the source Observable emits `error`, the output will emit `next` as a
	 * Notification of type "error", and then `complete`.
	 *
	 * This operator is useful for producing metadata of the source Observable, to
	 * be consumed as `next` emissions. Use it in conjunction with
	 * {@link dematerialize}.
	 *
	 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
	 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
	 * var upperCase = letters.map(x => x.toUpperCase());
	 * var materialized = upperCase.materialize();
	 * materialized.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
	 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
	 * // - Notification {kind: "E", value: undefined, error: TypeError:
	 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
	 * //   [as project] (http://1…, hasValue: false}
	 *
	 * @see {@link Notification}
	 * @see {@link dematerialize}
	 *
	 * @return {Observable<Notification<T>>} An Observable that emits
	 * {@link Notification} objects that wrap the original emissions from the source
	 * Observable with metadata.
	 * @method materialize
	 * @owner Observable
	 */
	function materialize() {
	    return function materializeOperatorFunction(source) {
	        return source.lift(new MaterializeOperator());
	    };
	}
	exports.materialize = materialize;
	var MaterializeOperator = (function () {
	    function MaterializeOperator() {
	    }
	    MaterializeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MaterializeSubscriber(subscriber));
	    };
	    return MaterializeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MaterializeSubscriber = (function (_super) {
	    __extends(MaterializeSubscriber, _super);
	    function MaterializeSubscriber(destination) {
	        _super.call(this, destination);
	    }
	    MaterializeSubscriber.prototype._next = function (value) {
	        this.destination.next(Notification_1.Notification.createNext(value));
	    };
	    MaterializeSubscriber.prototype._error = function (err) {
	        var destination = this.destination;
	        destination.next(Notification_1.Notification.createError(err));
	        destination.complete();
	    };
	    MaterializeSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        destination.next(Notification_1.Notification.createComplete());
	        destination.complete();
	    };
	    return MaterializeSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=materialize.js.map

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var max_1 = __webpack_require__(503);
	Observable_1.Observable.prototype.max = max_1.max;
	//# sourceMappingURL=max.js.map

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var max_1 = __webpack_require__(504);
	/**
	 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
	 * and when source Observable completes it emits a single item: the item with the largest value.
	 *
	 * <img src="./img/max.png" width="100%">
	 *
	 * @example <caption>Get the maximal value of a series of numbers</caption>
	 * Rx.Observable.of(5, 4, 7, 2, 8)
	 *   .max()
	 *   .subscribe(x => console.log(x)); // -> 8
	 *
	 * @example <caption>Use a comparer function to get the maximal item</caption>
	 * interface Person {
	 *   age: number,
	 *   name: string
	 * }
	 * Observable.of<Person>({age: 7, name: 'Foo'},
	 *                       {age: 5, name: 'Bar'},
	 *                       {age: 9, name: 'Beer'})
	 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
	 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
	 * }
	 *
	 * @see {@link min}
	 *
	 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
	 * value of two items.
	 * @return {Observable} An Observable that emits item with the largest value.
	 * @method max
	 * @owner Observable
	 */
	function max(comparer) {
	    return max_1.max(comparer)(this);
	}
	exports.max = max;
	//# sourceMappingURL=max.js.map

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var reduce_1 = __webpack_require__(258);
	/**
	 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
	 * and when source Observable completes it emits a single item: the item with the largest value.
	 *
	 * <img src="./img/max.png" width="100%">
	 *
	 * @example <caption>Get the maximal value of a series of numbers</caption>
	 * Rx.Observable.of(5, 4, 7, 2, 8)
	 *   .max()
	 *   .subscribe(x => console.log(x)); // -> 8
	 *
	 * @example <caption>Use a comparer function to get the maximal item</caption>
	 * interface Person {
	 *   age: number,
	 *   name: string
	 * }
	 * Observable.of<Person>({age: 7, name: 'Foo'},
	 *                       {age: 5, name: 'Bar'},
	 *                       {age: 9, name: 'Beer'})
	 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
	 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
	 * }
	 *
	 * @see {@link min}
	 *
	 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
	 * value of two items.
	 * @return {Observable} An Observable that emits item with the largest value.
	 * @method max
	 * @owner Observable
	 */
	function max(comparer) {
	    var max = (typeof comparer === 'function')
	        ? function (x, y) { return comparer(x, y) > 0 ? x : y; }
	        : function (x, y) { return x > y ? x : y; };
	    return reduce_1.reduce(max);
	}
	exports.max = max;
	//# sourceMappingURL=max.js.map

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var merge_1 = __webpack_require__(506);
	Observable_1.Observable.prototype.merge = merge_1.merge;
	//# sourceMappingURL=merge.js.map

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var merge_1 = __webpack_require__(255);
	var merge_2 = __webpack_require__(222);
	exports.mergeStatic = merge_2.merge;
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which concurrently emits all values from every
	 * given input Observable.
	 *
	 * <span class="informal">Flattens multiple Observables together by blending
	 * their values into one Observable.</span>
	 *
	 * <img src="./img/merge.png" width="100%">
	 *
	 * `merge` subscribes to each given input Observable (either the source or an
	 * Observable given as argument), and simply forwards (without doing any
	 * transformation) all the values from all the input Observables to the output
	 * Observable. The output Observable only completes once all input Observables
	 * have completed. Any error delivered by an input Observable will be immediately
	 * emitted on the output Observable.
	 *
	 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var timer = Rx.Observable.interval(1000);
	 * var clicksOrTimer = clicks.merge(timer);
	 * clicksOrTimer.subscribe(x => console.log(x));
	 *
	 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var concurrent = 2; // the argument
	 * var merged = timer1.merge(timer2, timer3, concurrent);
	 * merged.subscribe(x => console.log(x));
	 *
	 * @see {@link mergeAll}
	 * @see {@link mergeMap}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 *
	 * @param {ObservableInput} other An input Observable to merge with the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
	 * concurrency of input Observables.
	 * @return {Observable} An Observable that emits items that are the result of
	 * every input Observable.
	 * @method merge
	 * @owner Observable
	 */
	function merge() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return merge_1.merge.apply(void 0, observables)(this);
	}
	exports.merge = merge;
	//# sourceMappingURL=merge.js.map

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var mergeAll_1 = __webpack_require__(295);
	Observable_1.Observable.prototype.mergeAll = mergeAll_1.mergeAll;
	//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 508 */,
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var mergeMapTo_1 = __webpack_require__(510);
	Observable_1.Observable.prototype.flatMapTo = mergeMapTo_1.mergeMapTo;
	Observable_1.Observable.prototype.mergeMapTo = mergeMapTo_1.mergeMapTo;
	//# sourceMappingURL=mergeMapTo.js.map

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeMapTo_1 = __webpack_require__(511);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to the same Observable which is merged multiple
	 * times in the output Observable.
	 *
	 * <span class="informal">It's like {@link mergeMap}, but maps each value always
	 * to the same inner Observable.</span>
	 *
	 * <img src="./img/mergeMapTo.png" width="100%">
	 *
	 * Maps each source value to the given Observable `innerObservable` regardless
	 * of the source value, and then merges those resulting Observables into one
	 * single Observable, which is the output Observable.
	 *
	 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMapTo}
	 * @see {@link merge}
	 * @see {@link mergeAll}
	 * @see {@link mergeMap}
	 * @see {@link mergeScan}
	 * @see {@link switchMapTo}
	 *
	 * @param {ObservableInput} innerObservable An Observable to replace each value from
	 * the source Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits items from the given
	 * `innerObservable` (and optionally transformed through `resultSelector`) every
	 * time a value is emitted on the source Observable.
	 * @method mergeMapTo
	 * @owner Observable
	 */
	function mergeMapTo(innerObservable, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return mergeMapTo_1.mergeMapTo(innerObservable, resultSelector, concurrent)(this);
	}
	exports.mergeMapTo = mergeMapTo;
	//# sourceMappingURL=mergeMapTo.js.map

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to the same Observable which is merged multiple
	 * times in the output Observable.
	 *
	 * <span class="informal">It's like {@link mergeMap}, but maps each value always
	 * to the same inner Observable.</span>
	 *
	 * <img src="./img/mergeMapTo.png" width="100%">
	 *
	 * Maps each source value to the given Observable `innerObservable` regardless
	 * of the source value, and then merges those resulting Observables into one
	 * single Observable, which is the output Observable.
	 *
	 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMapTo}
	 * @see {@link merge}
	 * @see {@link mergeAll}
	 * @see {@link mergeMap}
	 * @see {@link mergeScan}
	 * @see {@link switchMapTo}
	 *
	 * @param {ObservableInput} innerObservable An Observable to replace each value from
	 * the source Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits items from the given
	 * `innerObservable` (and optionally transformed through `resultSelector`) every
	 * time a value is emitted on the source Observable.
	 * @method mergeMapTo
	 * @owner Observable
	 */
	function mergeMapTo(innerObservable, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    if (typeof resultSelector === 'number') {
	        concurrent = resultSelector;
	        resultSelector = null;
	    }
	    return function (source) { return source.lift(new MergeMapToOperator(innerObservable, resultSelector, concurrent)); };
	}
	exports.mergeMapTo = mergeMapTo;
	// TODO: Figure out correct signature here: an Operator<Observable<T>, R>
	//       needs to implement call(observer: Subscriber<R>): Subscriber<Observable<T>>
	var MergeMapToOperator = (function () {
	    function MergeMapToOperator(ish, resultSelector, concurrent) {
	        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	        this.ish = ish;
	        this.resultSelector = resultSelector;
	        this.concurrent = concurrent;
	    }
	    MergeMapToOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new MergeMapToSubscriber(observer, this.ish, this.resultSelector, this.concurrent));
	    };
	    return MergeMapToOperator;
	}());
	exports.MergeMapToOperator = MergeMapToOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MergeMapToSubscriber = (function (_super) {
	    __extends(MergeMapToSubscriber, _super);
	    function MergeMapToSubscriber(destination, ish, resultSelector, concurrent) {
	        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	        _super.call(this, destination);
	        this.ish = ish;
	        this.resultSelector = resultSelector;
	        this.concurrent = concurrent;
	        this.hasCompleted = false;
	        this.buffer = [];
	        this.active = 0;
	        this.index = 0;
	    }
	    MergeMapToSubscriber.prototype._next = function (value) {
	        if (this.active < this.concurrent) {
	            var resultSelector = this.resultSelector;
	            var index = this.index++;
	            var ish = this.ish;
	            var destination = this.destination;
	            this.active++;
	            this._innerSub(ish, destination, resultSelector, value, index);
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    MergeMapToSubscriber.prototype._innerSub = function (ish, destination, resultSelector, value, index) {
	        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
	    };
	    MergeMapToSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.active === 0 && this.buffer.length === 0) {
	            this.destination.complete();
	        }
	    };
	    MergeMapToSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        if (resultSelector) {
	            this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            destination.next(innerValue);
	        }
	    };
	    MergeMapToSubscriber.prototype.trySelectResult = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        var result;
	        try {
	            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        catch (err) {
	            destination.error(err);
	            return;
	        }
	        destination.next(result);
	    };
	    MergeMapToSubscriber.prototype.notifyError = function (err) {
	        this.destination.error(err);
	    };
	    MergeMapToSubscriber.prototype.notifyComplete = function (innerSub) {
	        var buffer = this.buffer;
	        this.remove(innerSub);
	        this.active--;
	        if (buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        else if (this.active === 0 && this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return MergeMapToSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.MergeMapToSubscriber = MergeMapToSubscriber;
	//# sourceMappingURL=mergeMapTo.js.map

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var mergeScan_1 = __webpack_require__(513);
	Observable_1.Observable.prototype.mergeScan = mergeScan_1.mergeScan;
	//# sourceMappingURL=mergeScan.js.map

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeScan_1 = __webpack_require__(514);
	/**
	 * Applies an accumulator function over the source Observable where the
	 * accumulator function itself returns an Observable, then each intermediate
	 * Observable returned is merged into the output Observable.
	 *
	 * <span class="informal">It's like {@link scan}, but the Observables returned
	 * by the accumulator are merged into the outer Observable.</span>
	 *
	 * @example <caption>Count the number of click events</caption>
	 * const click$ = Rx.Observable.fromEvent(document, 'click');
	 * const one$ = click$.mapTo(1);
	 * const seed = 0;
	 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
	 * count$.subscribe(x => console.log(x));
	 *
	 * // Results:
	 * 1
	 * 2
	 * 3
	 * 4
	 * // ...and so on for each click
	 *
	 * @param {function(acc: R, value: T): Observable<R>} accumulator
	 * The accumulator function called on each source value.
	 * @param seed The initial accumulation value.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
	 * input Observables being subscribed to concurrently.
	 * @return {Observable<R>} An observable of the accumulated values.
	 * @method mergeScan
	 * @owner Observable
	 */
	function mergeScan(accumulator, seed, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return mergeScan_1.mergeScan(accumulator, seed, concurrent)(this);
	}
	exports.mergeScan = mergeScan;
	//# sourceMappingURL=mergeScan.js.map

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var tryCatch_1 = __webpack_require__(214);
	var errorObject_1 = __webpack_require__(215);
	var subscribeToResult_1 = __webpack_require__(229);
	var OuterSubscriber_1 = __webpack_require__(234);
	/**
	 * Applies an accumulator function over the source Observable where the
	 * accumulator function itself returns an Observable, then each intermediate
	 * Observable returned is merged into the output Observable.
	 *
	 * <span class="informal">It's like {@link scan}, but the Observables returned
	 * by the accumulator are merged into the outer Observable.</span>
	 *
	 * @example <caption>Count the number of click events</caption>
	 * const click$ = Rx.Observable.fromEvent(document, 'click');
	 * const one$ = click$.mapTo(1);
	 * const seed = 0;
	 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
	 * count$.subscribe(x => console.log(x));
	 *
	 * // Results:
	 * 1
	 * 2
	 * 3
	 * 4
	 * // ...and so on for each click
	 *
	 * @param {function(acc: R, value: T): Observable<R>} accumulator
	 * The accumulator function called on each source value.
	 * @param seed The initial accumulation value.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
	 * input Observables being subscribed to concurrently.
	 * @return {Observable<R>} An observable of the accumulated values.
	 * @method mergeScan
	 * @owner Observable
	 */
	function mergeScan(accumulator, seed, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return function (source) { return source.lift(new MergeScanOperator(accumulator, seed, concurrent)); };
	}
	exports.mergeScan = mergeScan;
	var MergeScanOperator = (function () {
	    function MergeScanOperator(accumulator, seed, concurrent) {
	        this.accumulator = accumulator;
	        this.seed = seed;
	        this.concurrent = concurrent;
	    }
	    MergeScanOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
	    };
	    return MergeScanOperator;
	}());
	exports.MergeScanOperator = MergeScanOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MergeScanSubscriber = (function (_super) {
	    __extends(MergeScanSubscriber, _super);
	    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
	        _super.call(this, destination);
	        this.accumulator = accumulator;
	        this.acc = acc;
	        this.concurrent = concurrent;
	        this.hasValue = false;
	        this.hasCompleted = false;
	        this.buffer = [];
	        this.active = 0;
	        this.index = 0;
	    }
	    MergeScanSubscriber.prototype._next = function (value) {
	        if (this.active < this.concurrent) {
	            var index = this.index++;
	            var ish = tryCatch_1.tryCatch(this.accumulator)(this.acc, value);
	            var destination = this.destination;
	            if (ish === errorObject_1.errorObject) {
	                destination.error(errorObject_1.errorObject.e);
	            }
	            else {
	                this.active++;
	                this._innerSub(ish, value, index);
	            }
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    MergeScanSubscriber.prototype._innerSub = function (ish, value, index) {
	        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
	    };
	    MergeScanSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.active === 0 && this.buffer.length === 0) {
	            if (this.hasValue === false) {
	                this.destination.next(this.acc);
	            }
	            this.destination.complete();
	        }
	    };
	    MergeScanSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var destination = this.destination;
	        this.acc = innerValue;
	        this.hasValue = true;
	        destination.next(innerValue);
	    };
	    MergeScanSubscriber.prototype.notifyComplete = function (innerSub) {
	        var buffer = this.buffer;
	        this.remove(innerSub);
	        this.active--;
	        if (buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        else if (this.active === 0 && this.hasCompleted) {
	            if (this.hasValue === false) {
	                this.destination.next(this.acc);
	            }
	            this.destination.complete();
	        }
	    };
	    return MergeScanSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.MergeScanSubscriber = MergeScanSubscriber;
	//# sourceMappingURL=mergeScan.js.map

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var min_1 = __webpack_require__(516);
	Observable_1.Observable.prototype.min = min_1.min;
	//# sourceMappingURL=min.js.map

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var min_1 = __webpack_require__(517);
	/**
	 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
	 * and when source Observable completes it emits a single item: the item with the smallest value.
	 *
	 * <img src="./img/min.png" width="100%">
	 *
	 * @example <caption>Get the minimal value of a series of numbers</caption>
	 * Rx.Observable.of(5, 4, 7, 2, 8)
	 *   .min()
	 *   .subscribe(x => console.log(x)); // -> 2
	 *
	 * @example <caption>Use a comparer function to get the minimal item</caption>
	 * interface Person {
	 *   age: number,
	 *   name: string
	 * }
	 * Observable.of<Person>({age: 7, name: 'Foo'},
	 *                       {age: 5, name: 'Bar'},
	 *                       {age: 9, name: 'Beer'})
	 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
	 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
	 * }
	 *
	 * @see {@link max}
	 *
	 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
	 * value of two items.
	 * @return {Observable<R>} An Observable that emits item with the smallest value.
	 * @method min
	 * @owner Observable
	 */
	function min(comparer) {
	    return min_1.min(comparer)(this);
	}
	exports.min = min;
	//# sourceMappingURL=min.js.map

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var reduce_1 = __webpack_require__(258);
	/**
	 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
	 * and when source Observable completes it emits a single item: the item with the smallest value.
	 *
	 * <img src="./img/min.png" width="100%">
	 *
	 * @example <caption>Get the minimal value of a series of numbers</caption>
	 * Rx.Observable.of(5, 4, 7, 2, 8)
	 *   .min()
	 *   .subscribe(x => console.log(x)); // -> 2
	 *
	 * @example <caption>Use a comparer function to get the minimal item</caption>
	 * interface Person {
	 *   age: number,
	 *   name: string
	 * }
	 * Observable.of<Person>({age: 7, name: 'Foo'},
	 *                       {age: 5, name: 'Bar'},
	 *                       {age: 9, name: 'Beer'})
	 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
	 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
	 * }
	 *
	 * @see {@link max}
	 *
	 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
	 * value of two items.
	 * @return {Observable<R>} An Observable that emits item with the smallest value.
	 * @method min
	 * @owner Observable
	 */
	function min(comparer) {
	    var min = (typeof comparer === 'function')
	        ? function (x, y) { return comparer(x, y) < 0 ? x : y; }
	        : function (x, y) { return x < y ? x : y; };
	    return reduce_1.reduce(min);
	}
	exports.min = min;
	//# sourceMappingURL=min.js.map

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var multicast_1 = __webpack_require__(519);
	Observable_1.Observable.prototype.multicast = multicast_1.multicast;
	//# sourceMappingURL=multicast.js.map

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var multicast_1 = __webpack_require__(238);
	/* tslint:enable:max-line-length */
	/**
	 * Allows source Observable to be subscribed only once with a Subject of choice,
	 * while still sharing its values between multiple subscribers.
	 *
	 * <span class="informal">Subscribe to Observable once, but send its values to multiple subscribers.</span>
	 *
	 * <img src="./img/multicast.png" width="100%">
	 *
	 * `multicast` is an operator that works in two modes.
	 *
	 * In the first mode you provide a single argument to it, which can be either an initialized Subject or a Subject
	 * factory. As a result you will get a special kind of an Observable - a {@link ConnectableObservable}. It can be
	 * subscribed multiple times, just as regular Observable, but it won't subscribe to the source Observable at that
	 * moment. It will do it only if you call its `connect` method. This means you can essentially control by hand, when
	 * source Observable will be actually subscribed. What is more, ConnectableObservable will share this one subscription
	 * between all of its subscribers. This means that, for example, `ajax` Observable will only send a request once,
	 * even though usually it would send a request per every subscriber. Since it sends a request at the moment of
	 * subscription, here request would be sent when the `connect` method of a ConnectableObservable is called.
	 *
	 * The most common pattern of using ConnectableObservable is calling `connect` when the first consumer subscribes,
	 * keeping the subscription alive while several consumers come and go and finally unsubscribing from the source
	 * Observable, when the last consumer unsubscribes. To not implement that logic over and over again,
	 * ConnectableObservable has a special operator, `refCount`. When called, it returns an Observable, which will count
	 * the number of consumers subscribed to it and keep ConnectableObservable connected as long as there is at least
	 * one consumer. So if you don't actually need to decide yourself when to connect and disconnect a
	 * ConnectableObservable, use `refCount`.
	 *
	 * The second mode is invoked by calling `multicast` with an additional, second argument - selector function.
	 * This function accepts an Observable - which basically mirrors the source Observable - and returns Observable
	 * as well, which should be the input stream modified by any operators you want. Note that in this
	 * mode you cannot provide initialized Subject as a first argument - it has to be a Subject factory. If
	 * you provide selector function, `multicast` returns just a regular Observable, instead of ConnectableObservable.
	 * Thus, as usual, each subscription to this stream triggers subscription to the source Observable. However,
	 * if inside the selector function you subscribe to the input Observable multiple times, actual source stream
	 * will be subscribed only once. So if you have a chain of operators that use some Observable many times,
	 * but you want to subscribe to that Observable only once, this is the mode you would use.
	 *
	 * Subject provided as a first parameter of `multicast` is used as a proxy for the single subscription to the
	 * source Observable. It means that all values from the source stream go through that Subject. Thus, if a Subject
	 * has some special properties, Observable returned by `multicast` will have them as well. If you want to use
	 * `multicast` with a Subject that is one of the ones included in RxJS by default - {@link Subject},
	 * {@link AsyncSubject}, {@link BehaviorSubject}, or {@link ReplaySubject} - simply use {@link publish},
	 * {@link publishLast}, {@link publishBehavior} or {@link publishReplay} respectively. These are actually
	 * just wrappers around `multicast`, with a specific Subject hardcoded inside.
	 *
	 * Also, if you use {@link publish} or {@link publishReplay} with a ConnectableObservables `refCount` operator,
	 * you can simply use {@link share} and {@link shareReplay} respectively, which chain these two.
	 *
	 * @example <caption>Use ConnectableObservable</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 * const connectableSeconds = seconds.multicast(new Subject());
	 *
	 * connectableSeconds.subscribe(value => console.log('first: ' + value));
	 * connectableSeconds.subscribe(value => console.log('second: ' + value));
	 *
	 * // At this point still nothing happens, even though we subscribed twice.
	 *
	 * connectableSeconds.connect();
	 *
	 * // From now on `seconds` are being logged to the console,
	 * // twice per every second. `seconds` Observable was however only subscribed once,
	 * // so under the hood Observable.interval had only one clock started.
	 *
	 * @example <caption>Use selector</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 *
	 * seconds
	 *     .multicast(
	 *         () => new Subject(),
	 *         seconds => seconds.zip(seconds) // Usually zip would subscribe to `seconds` twice.
	 *                                         // Because we are inside selector, `seconds` is subscribed once,
	 *     )                                   // thus starting only one clock used internally by Observable.interval.
	 *     .subscribe();
	 *
	 * @see {@link publish}
	 * @see {@link publishLast}
	 * @see {@link publishBehavior}
	 * @see {@link publishReplay}
	 * @see {@link share}
	 * @see {@link shareReplay}
	 *
	 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate Subject through
	 * which the source sequence's elements will be multicast to the selector function input Observable or
	 * ConnectableObservable returned by the operator.
	 * @param {Function} [selector] - Optional selector function that can use the input stream
	 * as many times as needed, without causing multiple subscriptions to the source stream.
	 * Subscribers to the input source will receive all notifications of the source from the
	 * time of the subscription forward.
	 * @return {Observable<T>|ConnectableObservable<T>} An Observable that emits the results of invoking the selector
	 * on the source stream or a special {@link ConnectableObservable}, if selector was not provided.
	 *
	 * @method multicast
	 * @owner Observable
	 */
	function multicast(subjectOrSubjectFactory, selector) {
	    return multicast_1.multicast(subjectOrSubjectFactory, selector)(this);
	}
	exports.multicast = multicast;
	//# sourceMappingURL=multicast.js.map

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var observeOn_1 = __webpack_require__(521);
	Observable_1.Observable.prototype.observeOn = observeOn_1.observeOn;
	//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var observeOn_1 = __webpack_require__(281);
	/**
	 *
	 * Re-emits all notifications from source Observable with specified scheduler.
	 *
	 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
	 *
	 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
	 * notifications emitted by the source Observable. It might be useful, if you do not have control over
	 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
	 *
	 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
	 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
	 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
	 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
	 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
	 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
	 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
	 * little bit more, to ensure that they are emitted at expected moments.
	 *
	 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
	 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
	 * will delay all notifications - including error notifications - while `delay` will pass through error
	 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
	 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
	 * for notification emissions in general.
	 *
	 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
	 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
	 *                                               // with async scheduler by default...
	 *
	 * intervals
	 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
	 * .subscribe(val => {                           // scheduler to ensure smooth animation.
	 *   someDiv.style.height = val + 'px';
	 * });
	 *
	 * @see {@link delay}
	 *
	 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
	 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
	 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
	 * but with provided scheduler.
	 *
	 * @method observeOn
	 * @owner Observable
	 */
	function observeOn(scheduler, delay) {
	    if (delay === void 0) { delay = 0; }
	    return observeOn_1.observeOn(scheduler, delay)(this);
	}
	exports.observeOn = observeOn;
	//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var onErrorResumeNext_1 = __webpack_require__(523);
	Observable_1.Observable.prototype.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
	//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var onErrorResumeNext_1 = __webpack_require__(357);
	/* tslint:enable:max-line-length */
	/**
	 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
	 * that was passed.
	 *
	 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
	 *
	 * <img src="./img/onErrorResumeNext.png" width="100%">
	 *
	 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
	 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
	 * as the source.
	 *
	 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
	 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
	 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
	 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
	 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
	 * be happening until there is no more Observables left in the series, at which point returned Observable will
	 * complete - even if the last subscribed stream ended with an error.
	 *
	 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
	 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
	 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
	 * an error.
	 *
	 * Note that you do not get any access to errors emitted by the Observables. In particular do not
	 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
	 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
	 *
	 *
	 * @example <caption>Subscribe to the next Observable after map fails</caption>
	 * Rx.Observable.of(1, 2, 3, 0)
	 *   .map(x => {
	 *       if (x === 0) { throw Error(); }
	         return 10 / x;
	 *   })
	 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
	 *   .subscribe(
	 *     val => console.log(val),
	 *     err => console.log(err),          // Will never be called.
	 *     () => console.log('that\'s it!')
	 *   );
	 *
	 * // Logs:
	 * // 10
	 * // 5
	 * // 3.3333333333333335
	 * // 1
	 * // 2
	 * // 3
	 * // "that's it!"
	 *
	 * @see {@link concat}
	 * @see {@link catch}
	 *
	 * @param {...ObservableInput} observables Observables passed either directly or as an array.
	 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
	 * to the next passed Observable and so on, until it completes or runs out of Observables.
	 * @method onErrorResumeNext
	 * @owner Observable
	 */
	function onErrorResumeNext() {
	    var nextSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        nextSources[_i - 0] = arguments[_i];
	    }
	    return onErrorResumeNext_1.onErrorResumeNext.apply(void 0, nextSources)(this);
	}
	exports.onErrorResumeNext = onErrorResumeNext;
	//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var pairwise_1 = __webpack_require__(525);
	Observable_1.Observable.prototype.pairwise = pairwise_1.pairwise;
	//# sourceMappingURL=pairwise.js.map

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var pairwise_1 = __webpack_require__(526);
	/**
	 * Groups pairs of consecutive emissions together and emits them as an array of
	 * two values.
	 *
	 * <span class="informal">Puts the current value and previous value together as
	 * an array, and emits that.</span>
	 *
	 * <img src="./img/pairwise.png" width="100%">
	 *
	 * The Nth emission from the source Observable will cause the output Observable
	 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
	 * pair. For this reason, `pairwise` emits on the second and subsequent
	 * emissions from the source Observable, but not on the first emission, because
	 * there is no previous value in that case.
	 *
	 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var pairs = clicks.pairwise();
	 * var distance = pairs.map(pair => {
	 *   var x0 = pair[0].clientX;
	 *   var y0 = pair[0].clientY;
	 *   var x1 = pair[1].clientX;
	 *   var y1 = pair[1].clientY;
	 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
	 * });
	 * distance.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 *
	 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
	 * consecutive values from the source Observable.
	 * @method pairwise
	 * @owner Observable
	 */
	function pairwise() {
	    return pairwise_1.pairwise()(this);
	}
	exports.pairwise = pairwise;
	//# sourceMappingURL=pairwise.js.map

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	/**
	 * Groups pairs of consecutive emissions together and emits them as an array of
	 * two values.
	 *
	 * <span class="informal">Puts the current value and previous value together as
	 * an array, and emits that.</span>
	 *
	 * <img src="./img/pairwise.png" width="100%">
	 *
	 * The Nth emission from the source Observable will cause the output Observable
	 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
	 * pair. For this reason, `pairwise` emits on the second and subsequent
	 * emissions from the source Observable, but not on the first emission, because
	 * there is no previous value in that case.
	 *
	 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var pairs = clicks.pairwise();
	 * var distance = pairs.map(pair => {
	 *   var x0 = pair[0].clientX;
	 *   var y0 = pair[0].clientY;
	 *   var x1 = pair[1].clientX;
	 *   var y1 = pair[1].clientY;
	 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
	 * });
	 * distance.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 *
	 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
	 * consecutive values from the source Observable.
	 * @method pairwise
	 * @owner Observable
	 */
	function pairwise() {
	    return function (source) { return source.lift(new PairwiseOperator()); };
	}
	exports.pairwise = pairwise;
	var PairwiseOperator = (function () {
	    function PairwiseOperator() {
	    }
	    PairwiseOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new PairwiseSubscriber(subscriber));
	    };
	    return PairwiseOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var PairwiseSubscriber = (function (_super) {
	    __extends(PairwiseSubscriber, _super);
	    function PairwiseSubscriber(destination) {
	        _super.call(this, destination);
	        this.hasPrev = false;
	    }
	    PairwiseSubscriber.prototype._next = function (value) {
	        if (this.hasPrev) {
	            this.destination.next([this.prev, value]);
	        }
	        else {
	            this.hasPrev = true;
	        }
	        this.prev = value;
	    };
	    return PairwiseSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=pairwise.js.map

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var partition_1 = __webpack_require__(528);
	Observable_1.Observable.prototype.partition = partition_1.partition;
	//# sourceMappingURL=partition.js.map

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var partition_1 = __webpack_require__(529);
	/**
	 * Splits the source Observable into two, one with values that satisfy a
	 * predicate, and another with values that don't satisfy the predicate.
	 *
	 * <span class="informal">It's like {@link filter}, but returns two Observables:
	 * one like the output of {@link filter}, and the other with values that did not
	 * pass the condition.</span>
	 *
	 * <img src="./img/partition.png" width="100%">
	 *
	 * `partition` outputs an array with two Observables that partition the values
	 * from the source Observable through the given `predicate` function. The first
	 * Observable in that array emits source values for which the predicate argument
	 * returns true. The second Observable emits source values for which the
	 * predicate returns false. The first behaves like {@link filter} and the second
	 * behaves like {@link filter} with the predicate negated.
	 *
	 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
	 * var clicksOnDivs = parts[0];
	 * var clicksElsewhere = parts[1];
	 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
	 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
	 *
	 * @see {@link filter}
	 *
	 * @param {function(value: T, index: number): boolean} predicate A function that
	 * evaluates each value emitted by the source Observable. If it returns `true`,
	 * the value is emitted on the first Observable in the returned array, if
	 * `false` the value is emitted on the second Observable in the array. The
	 * `index` parameter is the number `i` for the i-th source emission that has
	 * happened since the subscription, starting from the number `0`.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
	 * with values that passed the predicate, and another with values that did not
	 * pass the predicate.
	 * @method partition
	 * @owner Observable
	 */
	function partition(predicate, thisArg) {
	    return partition_1.partition(predicate, thisArg)(this);
	}
	exports.partition = partition;
	//# sourceMappingURL=partition.js.map

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var not_1 = __webpack_require__(530);
	var filter_1 = __webpack_require__(298);
	/**
	 * Splits the source Observable into two, one with values that satisfy a
	 * predicate, and another with values that don't satisfy the predicate.
	 *
	 * <span class="informal">It's like {@link filter}, but returns two Observables:
	 * one like the output of {@link filter}, and the other with values that did not
	 * pass the condition.</span>
	 *
	 * <img src="./img/partition.png" width="100%">
	 *
	 * `partition` outputs an array with two Observables that partition the values
	 * from the source Observable through the given `predicate` function. The first
	 * Observable in that array emits source values for which the predicate argument
	 * returns true. The second Observable emits source values for which the
	 * predicate returns false. The first behaves like {@link filter} and the second
	 * behaves like {@link filter} with the predicate negated.
	 *
	 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
	 * var clicksOnDivs = parts[0];
	 * var clicksElsewhere = parts[1];
	 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
	 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
	 *
	 * @see {@link filter}
	 *
	 * @param {function(value: T, index: number): boolean} predicate A function that
	 * evaluates each value emitted by the source Observable. If it returns `true`,
	 * the value is emitted on the first Observable in the returned array, if
	 * `false` the value is emitted on the second Observable in the array. The
	 * `index` parameter is the number `i` for the i-th source emission that has
	 * happened since the subscription, starting from the number `0`.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
	 * with values that passed the predicate, and another with values that did not
	 * pass the predicate.
	 * @method partition
	 * @owner Observable
	 */
	function partition(predicate, thisArg) {
	    return function (source) { return [
	        filter_1.filter(predicate, thisArg)(source),
	        filter_1.filter(not_1.not(predicate, thisArg))(source)
	    ]; };
	}
	exports.partition = partition;
	//# sourceMappingURL=partition.js.map

/***/ }),
/* 530 */
/***/ (function(module, exports) {

	"use strict";
	function not(pred, thisArg) {
	    function notPred() {
	        return !(notPred.pred.apply(notPred.thisArg, arguments));
	    }
	    notPred.pred = pred;
	    notPred.thisArg = thisArg;
	    return notPred;
	}
	exports.not = not;
	//# sourceMappingURL=not.js.map

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var pluck_1 = __webpack_require__(532);
	Observable_1.Observable.prototype.pluck = pluck_1.pluck;
	//# sourceMappingURL=pluck.js.map

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var pluck_1 = __webpack_require__(533);
	/**
	 * Maps each source value (an object) to its specified nested property.
	 *
	 * <span class="informal">Like {@link map}, but meant only for picking one of
	 * the nested properties of every emitted object.</span>
	 *
	 * <img src="./img/pluck.png" width="100%">
	 *
	 * Given a list of strings describing a path to an object property, retrieves
	 * the value of a specified nested property from all values in the source
	 * Observable. If a property can't be resolved, it will return `undefined` for
	 * that value.
	 *
	 * @example <caption>Map every click to the tagName of the clicked target element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var tagNames = clicks.pluck('target', 'tagName');
	 * tagNames.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 *
	 * @param {...string} properties The nested properties to pluck from each source
	 * value (an object).
	 * @return {Observable} A new Observable of property values from the source values.
	 * @method pluck
	 * @owner Observable
	 */
	function pluck() {
	    var properties = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        properties[_i - 0] = arguments[_i];
	    }
	    return pluck_1.pluck.apply(void 0, properties)(this);
	}
	exports.pluck = pluck;
	//# sourceMappingURL=pluck.js.map

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var map_1 = __webpack_require__(254);
	/**
	 * Maps each source value (an object) to its specified nested property.
	 *
	 * <span class="informal">Like {@link map}, but meant only for picking one of
	 * the nested properties of every emitted object.</span>
	 *
	 * <img src="./img/pluck.png" width="100%">
	 *
	 * Given a list of strings describing a path to an object property, retrieves
	 * the value of a specified nested property from all values in the source
	 * Observable. If a property can't be resolved, it will return `undefined` for
	 * that value.
	 *
	 * @example <caption>Map every click to the tagName of the clicked target element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var tagNames = clicks.pluck('target', 'tagName');
	 * tagNames.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 *
	 * @param {...string} properties The nested properties to pluck from each source
	 * value (an object).
	 * @return {Observable} A new Observable of property values from the source values.
	 * @method pluck
	 * @owner Observable
	 */
	function pluck() {
	    var properties = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        properties[_i - 0] = arguments[_i];
	    }
	    var length = properties.length;
	    if (length === 0) {
	        throw new Error('list of properties cannot be empty.');
	    }
	    return function (source) { return map_1.map(plucker(properties, length))(source); };
	}
	exports.pluck = pluck;
	function plucker(props, length) {
	    var mapper = function (x) {
	        var currentProp = x;
	        for (var i = 0; i < length; i++) {
	            var p = currentProp[props[i]];
	            if (typeof p !== 'undefined') {
	                currentProp = p;
	            }
	            else {
	                return undefined;
	            }
	        }
	        return currentProp;
	    };
	    return mapper;
	}
	//# sourceMappingURL=pluck.js.map

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var publish_1 = __webpack_require__(535);
	Observable_1.Observable.prototype.publish = publish_1.publish;
	//# sourceMappingURL=publish.js.map

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var publish_1 = __webpack_require__(536);
	/* tslint:enable:max-line-length */
	/**
	 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
	 * before it begins emitting items to those Observers that have subscribed to it.
	 *
	 * <img src="./img/publish.png" width="100%">
	 *
	 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
	 * as needed, without causing multiple subscriptions to the source sequence.
	 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
	 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
	 * @method publish
	 * @owner Observable
	 */
	function publish(selector) {
	    return publish_1.publish(selector)(this);
	}
	exports.publish = publish;
	//# sourceMappingURL=publish.js.map

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Subject_1 = __webpack_require__(240);
	var multicast_1 = __webpack_require__(238);
	/* tslint:enable:max-line-length */
	/**
	 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
	 * before it begins emitting items to those Observers that have subscribed to it.
	 *
	 * <img src="./img/publish.png" width="100%">
	 *
	 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
	 * as needed, without causing multiple subscriptions to the source sequence.
	 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
	 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
	 * @method publish
	 * @owner Observable
	 */
	function publish(selector) {
	    return selector ?
	        multicast_1.multicast(function () { return new Subject_1.Subject(); }, selector) :
	        multicast_1.multicast(new Subject_1.Subject());
	}
	exports.publish = publish;
	//# sourceMappingURL=publish.js.map

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var publishBehavior_1 = __webpack_require__(538);
	Observable_1.Observable.prototype.publishBehavior = publishBehavior_1.publishBehavior;
	//# sourceMappingURL=publishBehavior.js.map

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var publishBehavior_1 = __webpack_require__(539);
	/**
	 * @param value
	 * @return {ConnectableObservable<T>}
	 * @method publishBehavior
	 * @owner Observable
	 */
	function publishBehavior(value) {
	    return publishBehavior_1.publishBehavior(value)(this);
	}
	exports.publishBehavior = publishBehavior;
	//# sourceMappingURL=publishBehavior.js.map

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var BehaviorSubject_1 = __webpack_require__(271);
	var multicast_1 = __webpack_require__(238);
	/**
	 * @param value
	 * @return {ConnectableObservable<T>}
	 * @method publishBehavior
	 * @owner Observable
	 */
	function publishBehavior(value) {
	    return function (source) { return multicast_1.multicast(new BehaviorSubject_1.BehaviorSubject(value))(source); };
	}
	exports.publishBehavior = publishBehavior;
	//# sourceMappingURL=publishBehavior.js.map

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var publishReplay_1 = __webpack_require__(541);
	Observable_1.Observable.prototype.publishReplay = publishReplay_1.publishReplay;
	//# sourceMappingURL=publishReplay.js.map

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var publishReplay_1 = __webpack_require__(542);
	/* tslint:enable:max-line-length */
	/**
	 * @param bufferSize
	 * @param windowTime
	 * @param selectorOrScheduler
	 * @param scheduler
	 * @return {Observable<T> | ConnectableObservable<T>}
	 * @method publishReplay
	 * @owner Observable
	 */
	function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
	    return publishReplay_1.publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler)(this);
	}
	exports.publishReplay = publishReplay;
	//# sourceMappingURL=publishReplay.js.map

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ReplaySubject_1 = __webpack_require__(383);
	var multicast_1 = __webpack_require__(238);
	/* tslint:enable:max-line-length */
	function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
	    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') {
	        scheduler = selectorOrScheduler;
	    }
	    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
	    var subject = new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler);
	    return function (source) { return multicast_1.multicast(function () { return subject; }, selector)(source); };
	}
	exports.publishReplay = publishReplay;
	//# sourceMappingURL=publishReplay.js.map

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var publishLast_1 = __webpack_require__(544);
	Observable_1.Observable.prototype.publishLast = publishLast_1.publishLast;
	//# sourceMappingURL=publishLast.js.map

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var publishLast_1 = __webpack_require__(545);
	/**
	 * @return {ConnectableObservable<T>}
	 * @method publishLast
	 * @owner Observable
	 */
	function publishLast() {
	    //TODO(benlesh): correct type-flow through here.
	    return publishLast_1.publishLast()(this);
	}
	exports.publishLast = publishLast;
	//# sourceMappingURL=publishLast.js.map

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var AsyncSubject_1 = __webpack_require__(308);
	var multicast_1 = __webpack_require__(238);
	function publishLast() {
	    return function (source) { return multicast_1.multicast(new AsyncSubject_1.AsyncSubject())(source); };
	}
	exports.publishLast = publishLast;
	//# sourceMappingURL=publishLast.js.map

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var race_1 = __webpack_require__(547);
	Observable_1.Observable.prototype.race = race_1.race;
	//# sourceMappingURL=race.js.map

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var race_1 = __webpack_require__(548);
	// NOTE: to support backwards compatability with 5.4.* and lower
	var race_2 = __webpack_require__(350);
	exports.raceStatic = race_2.race;
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that mirrors the first source Observable to emit an item
	 * from the combination of this Observable and supplied Observables.
	 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
	 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
	 * @method race
	 * @owner Observable
	 */
	function race() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return race_1.race.apply(void 0, observables)(this);
	}
	exports.race = race;
	//# sourceMappingURL=race.js.map

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var isArray_1 = __webpack_require__(212);
	var race_1 = __webpack_require__(350);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that mirrors the first source Observable to emit an item
	 * from the combination of this Observable and supplied Observables.
	 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
	 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
	 * @method race
	 * @owner Observable
	 */
	function race() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return function raceOperatorFunction(source) {
	        // if the only argument is an array, it was most likely called with
	        // `pair([obs1, obs2, ...])`
	        if (observables.length === 1 && isArray_1.isArray(observables[0])) {
	            observables = observables[0];
	        }
	        return source.lift.call(race_1.race.apply(void 0, [source].concat(observables)));
	    };
	}
	exports.race = race;
	//# sourceMappingURL=race.js.map

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var reduce_1 = __webpack_require__(296);
	Observable_1.Observable.prototype.reduce = reduce_1.reduce;
	//# sourceMappingURL=reduce.js.map

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var repeat_1 = __webpack_require__(551);
	Observable_1.Observable.prototype.repeat = repeat_1.repeat;
	//# sourceMappingURL=repeat.js.map

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var repeat_1 = __webpack_require__(552);
	/**
	 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
	 *
	 * <img src="./img/repeat.png" width="100%">
	 *
	 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
	 * an empty Observable.
	 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
	 * count times.
	 * @method repeat
	 * @owner Observable
	 */
	function repeat(count) {
	    if (count === void 0) { count = -1; }
	    return repeat_1.repeat(count)(this);
	}
	exports.repeat = repeat;
	//# sourceMappingURL=repeat.js.map

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	var EmptyObservable_1 = __webpack_require__(225);
	/**
	 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
	 *
	 * <img src="./img/repeat.png" width="100%">
	 *
	 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
	 * an empty Observable.
	 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
	 * count times.
	 * @method repeat
	 * @owner Observable
	 */
	function repeat(count) {
	    if (count === void 0) { count = -1; }
	    return function (source) {
	        if (count === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        else if (count < 0) {
	            return source.lift(new RepeatOperator(-1, source));
	        }
	        else {
	            return source.lift(new RepeatOperator(count - 1, source));
	        }
	    };
	}
	exports.repeat = repeat;
	var RepeatOperator = (function () {
	    function RepeatOperator(count, source) {
	        this.count = count;
	        this.source = source;
	    }
	    RepeatOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RepeatSubscriber(subscriber, this.count, this.source));
	    };
	    return RepeatOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var RepeatSubscriber = (function (_super) {
	    __extends(RepeatSubscriber, _super);
	    function RepeatSubscriber(destination, count, source) {
	        _super.call(this, destination);
	        this.count = count;
	        this.source = source;
	    }
	    RepeatSubscriber.prototype.complete = function () {
	        if (!this.isStopped) {
	            var _a = this, source = _a.source, count = _a.count;
	            if (count === 0) {
	                return _super.prototype.complete.call(this);
	            }
	            else if (count > -1) {
	                this.count = count - 1;
	            }
	            source.subscribe(this._unsubscribeAndRecycle());
	        }
	    };
	    return RepeatSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=repeat.js.map

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var repeatWhen_1 = __webpack_require__(554);
	Observable_1.Observable.prototype.repeatWhen = repeatWhen_1.repeatWhen;
	//# sourceMappingURL=repeatWhen.js.map

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var repeatWhen_1 = __webpack_require__(555);
	/**
	 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
	 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
	 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
	 * this method will resubscribe to the source Observable.
	 *
	 * <img src="./img/repeatWhen.png" width="100%">
	 *
	 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
	 * which a user can `complete` or `error`, aborting the repetition.
	 * @return {Observable} The source Observable modified with repeat logic.
	 * @method repeatWhen
	 * @owner Observable
	 */
	function repeatWhen(notifier) {
	    return repeatWhen_1.repeatWhen(notifier)(this);
	}
	exports.repeatWhen = repeatWhen;
	//# sourceMappingURL=repeatWhen.js.map

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(240);
	var tryCatch_1 = __webpack_require__(214);
	var errorObject_1 = __webpack_require__(215);
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/**
	 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
	 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
	 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
	 * this method will resubscribe to the source Observable.
	 *
	 * <img src="./img/repeatWhen.png" width="100%">
	 *
	 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
	 * which a user can `complete` or `error`, aborting the repetition.
	 * @return {Observable} The source Observable modified with repeat logic.
	 * @method repeatWhen
	 * @owner Observable
	 */
	function repeatWhen(notifier) {
	    return function (source) { return source.lift(new RepeatWhenOperator(notifier)); };
	}
	exports.repeatWhen = repeatWhen;
	var RepeatWhenOperator = (function () {
	    function RepeatWhenOperator(notifier) {
	        this.notifier = notifier;
	    }
	    RepeatWhenOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RepeatWhenSubscriber(subscriber, this.notifier, source));
	    };
	    return RepeatWhenOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var RepeatWhenSubscriber = (function (_super) {
	    __extends(RepeatWhenSubscriber, _super);
	    function RepeatWhenSubscriber(destination, notifier, source) {
	        _super.call(this, destination);
	        this.notifier = notifier;
	        this.source = source;
	        this.sourceIsBeingSubscribedTo = true;
	    }
	    RepeatWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.sourceIsBeingSubscribedTo = true;
	        this.source.subscribe(this);
	    };
	    RepeatWhenSubscriber.prototype.notifyComplete = function (innerSub) {
	        if (this.sourceIsBeingSubscribedTo === false) {
	            return _super.prototype.complete.call(this);
	        }
	    };
	    RepeatWhenSubscriber.prototype.complete = function () {
	        this.sourceIsBeingSubscribedTo = false;
	        if (!this.isStopped) {
	            if (!this.retries) {
	                this.subscribeToRetries();
	            }
	            if (!this.retriesSubscription || this.retriesSubscription.closed) {
	                return _super.prototype.complete.call(this);
	            }
	            this._unsubscribeAndRecycle();
	            this.notifications.next();
	        }
	    };
	    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribe = function () {
	        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
	        if (notifications) {
	            notifications.unsubscribe();
	            this.notifications = null;
	        }
	        if (retriesSubscription) {
	            retriesSubscription.unsubscribe();
	            this.retriesSubscription = null;
	        }
	        this.retries = null;
	    };
	    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function () {
	        var _a = this, notifications = _a.notifications, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
	        this.notifications = null;
	        this.retries = null;
	        this.retriesSubscription = null;
	        _super.prototype._unsubscribeAndRecycle.call(this);
	        this.notifications = notifications;
	        this.retries = retries;
	        this.retriesSubscription = retriesSubscription;
	        return this;
	    };
	    RepeatWhenSubscriber.prototype.subscribeToRetries = function () {
	        this.notifications = new Subject_1.Subject();
	        var retries = tryCatch_1.tryCatch(this.notifier)(this.notifications);
	        if (retries === errorObject_1.errorObject) {
	            return _super.prototype.complete.call(this);
	        }
	        this.retries = retries;
	        this.retriesSubscription = subscribeToResult_1.subscribeToResult(this, retries);
	    };
	    return RepeatWhenSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=repeatWhen.js.map

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var retry_1 = __webpack_require__(557);
	Observable_1.Observable.prototype.retry = retry_1.retry;
	//# sourceMappingURL=retry.js.map

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var retry_1 = __webpack_require__(558);
	/**
	 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
	 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
	 * as a number parameter) rather than propagating the `error` call.
	 *
	 * <img src="./img/retry.png" width="100%">
	 *
	 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
	 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
	 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
	 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
	 * @param {number} count - Number of retry attempts before failing.
	 * @return {Observable} The source Observable modified with the retry logic.
	 * @method retry
	 * @owner Observable
	 */
	function retry(count) {
	    if (count === void 0) { count = -1; }
	    return retry_1.retry(count)(this);
	}
	exports.retry = retry;
	//# sourceMappingURL=retry.js.map

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	/**
	 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
	 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
	 * as a number parameter) rather than propagating the `error` call.
	 *
	 * <img src="./img/retry.png" width="100%">
	 *
	 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
	 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
	 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
	 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
	 * @param {number} count - Number of retry attempts before failing.
	 * @return {Observable} The source Observable modified with the retry logic.
	 * @method retry
	 * @owner Observable
	 */
	function retry(count) {
	    if (count === void 0) { count = -1; }
	    return function (source) { return source.lift(new RetryOperator(count, source)); };
	}
	exports.retry = retry;
	var RetryOperator = (function () {
	    function RetryOperator(count, source) {
	        this.count = count;
	        this.source = source;
	    }
	    RetryOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RetrySubscriber(subscriber, this.count, this.source));
	    };
	    return RetryOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var RetrySubscriber = (function (_super) {
	    __extends(RetrySubscriber, _super);
	    function RetrySubscriber(destination, count, source) {
	        _super.call(this, destination);
	        this.count = count;
	        this.source = source;
	    }
	    RetrySubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var _a = this, source = _a.source, count = _a.count;
	            if (count === 0) {
	                return _super.prototype.error.call(this, err);
	            }
	            else if (count > -1) {
	                this.count = count - 1;
	            }
	            source.subscribe(this._unsubscribeAndRecycle());
	        }
	    };
	    return RetrySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=retry.js.map

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var retryWhen_1 = __webpack_require__(560);
	Observable_1.Observable.prototype.retryWhen = retryWhen_1.retryWhen;
	//# sourceMappingURL=retryWhen.js.map

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var retryWhen_1 = __webpack_require__(561);
	/**
	 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
	 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
	 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
	 * subscription. Otherwise this method will resubscribe to the source Observable.
	 *
	 * <img src="./img/retryWhen.png" width="100%">
	 *
	 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
	 * user can `complete` or `error`, aborting the retry.
	 * @return {Observable} The source Observable modified with retry logic.
	 * @method retryWhen
	 * @owner Observable
	 */
	function retryWhen(notifier) {
	    return retryWhen_1.retryWhen(notifier)(this);
	}
	exports.retryWhen = retryWhen;
	//# sourceMappingURL=retryWhen.js.map

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(240);
	var tryCatch_1 = __webpack_require__(214);
	var errorObject_1 = __webpack_require__(215);
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/**
	 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
	 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
	 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
	 * subscription. Otherwise this method will resubscribe to the source Observable.
	 *
	 * <img src="./img/retryWhen.png" width="100%">
	 *
	 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
	 * user can `complete` or `error`, aborting the retry.
	 * @return {Observable} The source Observable modified with retry logic.
	 * @method retryWhen
	 * @owner Observable
	 */
	function retryWhen(notifier) {
	    return function (source) { return source.lift(new RetryWhenOperator(notifier, source)); };
	}
	exports.retryWhen = retryWhen;
	var RetryWhenOperator = (function () {
	    function RetryWhenOperator(notifier, source) {
	        this.notifier = notifier;
	        this.source = source;
	    }
	    RetryWhenOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RetryWhenSubscriber(subscriber, this.notifier, this.source));
	    };
	    return RetryWhenOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var RetryWhenSubscriber = (function (_super) {
	    __extends(RetryWhenSubscriber, _super);
	    function RetryWhenSubscriber(destination, notifier, source) {
	        _super.call(this, destination);
	        this.notifier = notifier;
	        this.source = source;
	    }
	    RetryWhenSubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var errors = this.errors;
	            var retries = this.retries;
	            var retriesSubscription = this.retriesSubscription;
	            if (!retries) {
	                errors = new Subject_1.Subject();
	                retries = tryCatch_1.tryCatch(this.notifier)(errors);
	                if (retries === errorObject_1.errorObject) {
	                    return _super.prototype.error.call(this, errorObject_1.errorObject.e);
	                }
	                retriesSubscription = subscribeToResult_1.subscribeToResult(this, retries);
	            }
	            else {
	                this.errors = null;
	                this.retriesSubscription = null;
	            }
	            this._unsubscribeAndRecycle();
	            this.errors = errors;
	            this.retries = retries;
	            this.retriesSubscription = retriesSubscription;
	            errors.next(err);
	        }
	    };
	    /** @deprecated internal use only */ RetryWhenSubscriber.prototype._unsubscribe = function () {
	        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
	        if (errors) {
	            errors.unsubscribe();
	            this.errors = null;
	        }
	        if (retriesSubscription) {
	            retriesSubscription.unsubscribe();
	            this.retriesSubscription = null;
	        }
	        this.retries = null;
	    };
	    RetryWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var _a = this, errors = _a.errors, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
	        this.errors = null;
	        this.retries = null;
	        this.retriesSubscription = null;
	        this._unsubscribeAndRecycle();
	        this.errors = errors;
	        this.retries = retries;
	        this.retriesSubscription = retriesSubscription;
	        this.source.subscribe(this);
	    };
	    return RetryWhenSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=retryWhen.js.map

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var sample_1 = __webpack_require__(563);
	Observable_1.Observable.prototype.sample = sample_1.sample;
	//# sourceMappingURL=sample.js.map

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var sample_1 = __webpack_require__(564);
	/**
	 * Emits the most recently emitted value from the source Observable whenever
	 * another Observable, the `notifier`, emits.
	 *
	 * <span class="informal">It's like {@link sampleTime}, but samples whenever
	 * the `notifier` Observable emits something.</span>
	 *
	 * <img src="./img/sample.png" width="100%">
	 *
	 * Whenever the `notifier` Observable emits a value or completes, `sample`
	 * looks at the source Observable and emits whichever value it has most recently
	 * emitted since the previous sampling, unless the source has not emitted
	 * anything since the previous sampling. The `notifier` is subscribed to as soon
	 * as the output Observable is subscribed.
	 *
	 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
	 * var seconds = Rx.Observable.interval(1000);
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = seconds.sample(clicks);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounce}
	 * @see {@link sampleTime}
	 * @see {@link throttle}
	 *
	 * @param {Observable<any>} notifier The Observable to use for sampling the
	 * source Observable.
	 * @return {Observable<T>} An Observable that emits the results of sampling the
	 * values emitted by the source Observable whenever the notifier Observable
	 * emits value or completes.
	 * @method sample
	 * @owner Observable
	 */
	function sample(notifier) {
	    return sample_1.sample(notifier)(this);
	}
	exports.sample = sample;
	//# sourceMappingURL=sample.js.map

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/**
	 * Emits the most recently emitted value from the source Observable whenever
	 * another Observable, the `notifier`, emits.
	 *
	 * <span class="informal">It's like {@link sampleTime}, but samples whenever
	 * the `notifier` Observable emits something.</span>
	 *
	 * <img src="./img/sample.png" width="100%">
	 *
	 * Whenever the `notifier` Observable emits a value or completes, `sample`
	 * looks at the source Observable and emits whichever value it has most recently
	 * emitted since the previous sampling, unless the source has not emitted
	 * anything since the previous sampling. The `notifier` is subscribed to as soon
	 * as the output Observable is subscribed.
	 *
	 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
	 * var seconds = Rx.Observable.interval(1000);
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = seconds.sample(clicks);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounce}
	 * @see {@link sampleTime}
	 * @see {@link throttle}
	 *
	 * @param {Observable<any>} notifier The Observable to use for sampling the
	 * source Observable.
	 * @return {Observable<T>} An Observable that emits the results of sampling the
	 * values emitted by the source Observable whenever the notifier Observable
	 * emits value or completes.
	 * @method sample
	 * @owner Observable
	 */
	function sample(notifier) {
	    return function (source) { return source.lift(new SampleOperator(notifier)); };
	}
	exports.sample = sample;
	var SampleOperator = (function () {
	    function SampleOperator(notifier) {
	        this.notifier = notifier;
	    }
	    SampleOperator.prototype.call = function (subscriber, source) {
	        var sampleSubscriber = new SampleSubscriber(subscriber);
	        var subscription = source.subscribe(sampleSubscriber);
	        subscription.add(subscribeToResult_1.subscribeToResult(sampleSubscriber, this.notifier));
	        return subscription;
	    };
	    return SampleOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SampleSubscriber = (function (_super) {
	    __extends(SampleSubscriber, _super);
	    function SampleSubscriber() {
	        _super.apply(this, arguments);
	        this.hasValue = false;
	    }
	    SampleSubscriber.prototype._next = function (value) {
	        this.value = value;
	        this.hasValue = true;
	    };
	    SampleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.emitValue();
	    };
	    SampleSubscriber.prototype.notifyComplete = function () {
	        this.emitValue();
	    };
	    SampleSubscriber.prototype.emitValue = function () {
	        if (this.hasValue) {
	            this.hasValue = false;
	            this.destination.next(this.value);
	        }
	    };
	    return SampleSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=sample.js.map

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var sampleTime_1 = __webpack_require__(566);
	Observable_1.Observable.prototype.sampleTime = sampleTime_1.sampleTime;
	//# sourceMappingURL=sampleTime.js.map

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(343);
	var sampleTime_1 = __webpack_require__(567);
	/**
	 * Emits the most recently emitted value from the source Observable within
	 * periodic time intervals.
	 *
	 * <span class="informal">Samples the source Observable at periodic time
	 * intervals, emitting what it samples.</span>
	 *
	 * <img src="./img/sampleTime.png" width="100%">
	 *
	 * `sampleTime` periodically looks at the source Observable and emits whichever
	 * value it has most recently emitted since the previous sampling, unless the
	 * source has not emitted anything since the previous sampling. The sampling
	 * happens periodically in time every `period` milliseconds (or the time unit
	 * defined by the optional `scheduler` argument). The sampling starts as soon as
	 * the output Observable is subscribed.
	 *
	 * @example <caption>Every second, emit the most recent click at most once</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.sampleTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounceTime}
	 * @see {@link delay}
	 * @see {@link sample}
	 * @see {@link throttleTime}
	 *
	 * @param {number} period The sampling period expressed in milliseconds or the
	 * time unit determined internally by the optional `scheduler`.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the sampling.
	 * @return {Observable<T>} An Observable that emits the results of sampling the
	 * values emitted by the source Observable at the specified time interval.
	 * @method sampleTime
	 * @owner Observable
	 */
	function sampleTime(period, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return sampleTime_1.sampleTime(period, scheduler)(this);
	}
	exports.sampleTime = sampleTime;
	//# sourceMappingURL=sampleTime.js.map

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	var async_1 = __webpack_require__(343);
	/**
	 * Emits the most recently emitted value from the source Observable within
	 * periodic time intervals.
	 *
	 * <span class="informal">Samples the source Observable at periodic time
	 * intervals, emitting what it samples.</span>
	 *
	 * <img src="./img/sampleTime.png" width="100%">
	 *
	 * `sampleTime` periodically looks at the source Observable and emits whichever
	 * value it has most recently emitted since the previous sampling, unless the
	 * source has not emitted anything since the previous sampling. The sampling
	 * happens periodically in time every `period` milliseconds (or the time unit
	 * defined by the optional `scheduler` argument). The sampling starts as soon as
	 * the output Observable is subscribed.
	 *
	 * @example <caption>Every second, emit the most recent click at most once</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.sampleTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounceTime}
	 * @see {@link delay}
	 * @see {@link sample}
	 * @see {@link throttleTime}
	 *
	 * @param {number} period The sampling period expressed in milliseconds or the
	 * time unit determined internally by the optional `scheduler`.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the sampling.
	 * @return {Observable<T>} An Observable that emits the results of sampling the
	 * values emitted by the source Observable at the specified time interval.
	 * @method sampleTime
	 * @owner Observable
	 */
	function sampleTime(period, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return function (source) { return source.lift(new SampleTimeOperator(period, scheduler)); };
	}
	exports.sampleTime = sampleTime;
	var SampleTimeOperator = (function () {
	    function SampleTimeOperator(period, scheduler) {
	        this.period = period;
	        this.scheduler = scheduler;
	    }
	    SampleTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SampleTimeSubscriber(subscriber, this.period, this.scheduler));
	    };
	    return SampleTimeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SampleTimeSubscriber = (function (_super) {
	    __extends(SampleTimeSubscriber, _super);
	    function SampleTimeSubscriber(destination, period, scheduler) {
	        _super.call(this, destination);
	        this.period = period;
	        this.scheduler = scheduler;
	        this.hasValue = false;
	        this.add(scheduler.schedule(dispatchNotification, period, { subscriber: this, period: period }));
	    }
	    SampleTimeSubscriber.prototype._next = function (value) {
	        this.lastValue = value;
	        this.hasValue = true;
	    };
	    SampleTimeSubscriber.prototype.notifyNext = function () {
	        if (this.hasValue) {
	            this.hasValue = false;
	            this.destination.next(this.lastValue);
	        }
	    };
	    return SampleTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchNotification(state) {
	    var subscriber = state.subscriber, period = state.period;
	    subscriber.notifyNext();
	    this.schedule(state, period);
	}
	//# sourceMappingURL=sampleTime.js.map

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var scan_1 = __webpack_require__(569);
	Observable_1.Observable.prototype.scan = scan_1.scan;
	//# sourceMappingURL=scan.js.map

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var scan_1 = __webpack_require__(259);
	/* tslint:enable:max-line-length */
	/**
	 * Applies an accumulator function over the source Observable, and returns each
	 * intermediate result, with an optional seed value.
	 *
	 * <span class="informal">It's like {@link reduce}, but emits the current
	 * accumulation whenever the source emits a value.</span>
	 *
	 * <img src="./img/scan.png" width="100%">
	 *
	 * Combines together all values emitted on the source, using an accumulator
	 * function that knows how to join a new source value into the accumulation from
	 * the past. Is similar to {@link reduce}, but emits the intermediate
	 * accumulations.
	 *
	 * Returns an Observable that applies a specified `accumulator` function to each
	 * item emitted by the source Observable. If a `seed` value is specified, then
	 * that value will be used as the initial value for the accumulator. If no seed
	 * value is specified, the first item of the source is used as the seed.
	 *
	 * @example <caption>Count the number of click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var ones = clicks.mapTo(1);
	 * var seed = 0;
	 * var count = ones.scan((acc, one) => acc + one, seed);
	 * count.subscribe(x => console.log(x));
	 *
	 * @see {@link expand}
	 * @see {@link mergeScan}
	 * @see {@link reduce}
	 *
	 * @param {function(acc: R, value: T, index: number): R} accumulator
	 * The accumulator function called on each source value.
	 * @param {T|R} [seed] The initial accumulation value.
	 * @return {Observable<R>} An observable of the accumulated values.
	 * @method scan
	 * @owner Observable
	 */
	function scan(accumulator, seed) {
	    if (arguments.length >= 2) {
	        return scan_1.scan(accumulator, seed)(this);
	    }
	    return scan_1.scan(accumulator)(this);
	}
	exports.scan = scan;
	//# sourceMappingURL=scan.js.map

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var sequenceEqual_1 = __webpack_require__(571);
	Observable_1.Observable.prototype.sequenceEqual = sequenceEqual_1.sequenceEqual;
	//# sourceMappingURL=sequenceEqual.js.map

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var sequenceEqual_1 = __webpack_require__(572);
	/**
	 * Compares all values of two observables in sequence using an optional comparor function
	 * and returns an observable of a single boolean value representing whether or not the two sequences
	 * are equal.
	 *
	 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
	 *
	 * <img src="./img/sequenceEqual.png" width="100%">
	 *
	 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
	 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
	 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
	 * observables completes, the operator will wait for the other observable to complete; If the other
	 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
	 * completes or emits after the other complets, the returned observable will never complete.
	 *
	 * @example <caption>figure out if the Konami code matches</caption>
	 * var code = Rx.Observable.from([
	 *  "ArrowUp",
	 *  "ArrowUp",
	 *  "ArrowDown",
	 *  "ArrowDown",
	 *  "ArrowLeft",
	 *  "ArrowRight",
	 *  "ArrowLeft",
	 *  "ArrowRight",
	 *  "KeyB",
	 *  "KeyA",
	 *  "Enter" // no start key, clearly.
	 * ]);
	 *
	 * var keys = Rx.Observable.fromEvent(document, 'keyup')
	 *  .map(e => e.code);
	 * var matches = keys.bufferCount(11, 1)
	 *  .mergeMap(
	 *    last11 =>
	 *      Rx.Observable.from(last11)
	 *        .sequenceEqual(code)
	 *   );
	 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
	 *
	 * @see {@link combineLatest}
	 * @see {@link zip}
	 * @see {@link withLatestFrom}
	 *
	 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
	 * @param {function} [comparor] An optional function to compare each value pair
	 * @return {Observable} An Observable of a single boolean value representing whether or not
	 * the values emitted by both observables were equal in sequence.
	 * @method sequenceEqual
	 * @owner Observable
	 */
	function sequenceEqual(compareTo, comparor) {
	    return sequenceEqual_1.sequenceEqual(compareTo, comparor)(this);
	}
	exports.sequenceEqual = sequenceEqual;
	//# sourceMappingURL=sequenceEqual.js.map

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	var tryCatch_1 = __webpack_require__(214);
	var errorObject_1 = __webpack_require__(215);
	/**
	 * Compares all values of two observables in sequence using an optional comparor function
	 * and returns an observable of a single boolean value representing whether or not the two sequences
	 * are equal.
	 *
	 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
	 *
	 * <img src="./img/sequenceEqual.png" width="100%">
	 *
	 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
	 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
	 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
	 * observables completes, the operator will wait for the other observable to complete; If the other
	 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
	 * completes or emits after the other complets, the returned observable will never complete.
	 *
	 * @example <caption>figure out if the Konami code matches</caption>
	 * var code = Rx.Observable.from([
	 *  "ArrowUp",
	 *  "ArrowUp",
	 *  "ArrowDown",
	 *  "ArrowDown",
	 *  "ArrowLeft",
	 *  "ArrowRight",
	 *  "ArrowLeft",
	 *  "ArrowRight",
	 *  "KeyB",
	 *  "KeyA",
	 *  "Enter" // no start key, clearly.
	 * ]);
	 *
	 * var keys = Rx.Observable.fromEvent(document, 'keyup')
	 *  .map(e => e.code);
	 * var matches = keys.bufferCount(11, 1)
	 *  .mergeMap(
	 *    last11 =>
	 *      Rx.Observable.from(last11)
	 *        .sequenceEqual(code)
	 *   );
	 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
	 *
	 * @see {@link combineLatest}
	 * @see {@link zip}
	 * @see {@link withLatestFrom}
	 *
	 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
	 * @param {function} [comparor] An optional function to compare each value pair
	 * @return {Observable} An Observable of a single boolean value representing whether or not
	 * the values emitted by both observables were equal in sequence.
	 * @method sequenceEqual
	 * @owner Observable
	 */
	function sequenceEqual(compareTo, comparor) {
	    return function (source) { return source.lift(new SequenceEqualOperator(compareTo, comparor)); };
	}
	exports.sequenceEqual = sequenceEqual;
	var SequenceEqualOperator = (function () {
	    function SequenceEqualOperator(compareTo, comparor) {
	        this.compareTo = compareTo;
	        this.comparor = comparor;
	    }
	    SequenceEqualOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SequenceEqualSubscriber(subscriber, this.compareTo, this.comparor));
	    };
	    return SequenceEqualOperator;
	}());
	exports.SequenceEqualOperator = SequenceEqualOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SequenceEqualSubscriber = (function (_super) {
	    __extends(SequenceEqualSubscriber, _super);
	    function SequenceEqualSubscriber(destination, compareTo, comparor) {
	        _super.call(this, destination);
	        this.compareTo = compareTo;
	        this.comparor = comparor;
	        this._a = [];
	        this._b = [];
	        this._oneComplete = false;
	        this.add(compareTo.subscribe(new SequenceEqualCompareToSubscriber(destination, this)));
	    }
	    SequenceEqualSubscriber.prototype._next = function (value) {
	        if (this._oneComplete && this._b.length === 0) {
	            this.emit(false);
	        }
	        else {
	            this._a.push(value);
	            this.checkValues();
	        }
	    };
	    SequenceEqualSubscriber.prototype._complete = function () {
	        if (this._oneComplete) {
	            this.emit(this._a.length === 0 && this._b.length === 0);
	        }
	        else {
	            this._oneComplete = true;
	        }
	    };
	    SequenceEqualSubscriber.prototype.checkValues = function () {
	        var _c = this, _a = _c._a, _b = _c._b, comparor = _c.comparor;
	        while (_a.length > 0 && _b.length > 0) {
	            var a = _a.shift();
	            var b = _b.shift();
	            var areEqual = false;
	            if (comparor) {
	                areEqual = tryCatch_1.tryCatch(comparor)(a, b);
	                if (areEqual === errorObject_1.errorObject) {
	                    this.destination.error(errorObject_1.errorObject.e);
	                }
	            }
	            else {
	                areEqual = a === b;
	            }
	            if (!areEqual) {
	                this.emit(false);
	            }
	        }
	    };
	    SequenceEqualSubscriber.prototype.emit = function (value) {
	        var destination = this.destination;
	        destination.next(value);
	        destination.complete();
	    };
	    SequenceEqualSubscriber.prototype.nextB = function (value) {
	        if (this._oneComplete && this._a.length === 0) {
	            this.emit(false);
	        }
	        else {
	            this._b.push(value);
	            this.checkValues();
	        }
	    };
	    return SequenceEqualSubscriber;
	}(Subscriber_1.Subscriber));
	exports.SequenceEqualSubscriber = SequenceEqualSubscriber;
	var SequenceEqualCompareToSubscriber = (function (_super) {
	    __extends(SequenceEqualCompareToSubscriber, _super);
	    function SequenceEqualCompareToSubscriber(destination, parent) {
	        _super.call(this, destination);
	        this.parent = parent;
	    }
	    SequenceEqualCompareToSubscriber.prototype._next = function (value) {
	        this.parent.nextB(value);
	    };
	    SequenceEqualCompareToSubscriber.prototype._error = function (err) {
	        this.parent.error(err);
	    };
	    SequenceEqualCompareToSubscriber.prototype._complete = function () {
	        this.parent._complete();
	    };
	    return SequenceEqualCompareToSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=sequenceEqual.js.map

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var share_1 = __webpack_require__(236);
	Observable_1.Observable.prototype.share = share_1.share;
	//# sourceMappingURL=share.js.map

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var shareReplay_1 = __webpack_require__(575);
	Observable_1.Observable.prototype.shareReplay = shareReplay_1.shareReplay;
	//# sourceMappingURL=shareReplay.js.map

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var shareReplay_1 = __webpack_require__(576);
	/**
	 * @method shareReplay
	 * @owner Observable
	 */
	function shareReplay(bufferSize, windowTime, scheduler) {
	    return shareReplay_1.shareReplay(bufferSize, windowTime, scheduler)(this);
	}
	exports.shareReplay = shareReplay;
	;
	//# sourceMappingURL=shareReplay.js.map

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ReplaySubject_1 = __webpack_require__(383);
	/**
	 * @method shareReplay
	 * @owner Observable
	 */
	function shareReplay(bufferSize, windowTime, scheduler) {
	    return function (source) { return source.lift(shareReplayOperator(bufferSize, windowTime, scheduler)); };
	}
	exports.shareReplay = shareReplay;
	function shareReplayOperator(bufferSize, windowTime, scheduler) {
	    var subject;
	    var refCount = 0;
	    var subscription;
	    var hasError = false;
	    var isComplete = false;
	    return function shareReplayOperation(source) {
	        refCount++;
	        if (!subject || hasError) {
	            hasError = false;
	            subject = new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler);
	            subscription = source.subscribe({
	                next: function (value) { subject.next(value); },
	                error: function (err) {
	                    hasError = true;
	                    subject.error(err);
	                },
	                complete: function () {
	                    isComplete = true;
	                    subject.complete();
	                },
	            });
	        }
	        var innerSub = subject.subscribe(this);
	        return function () {
	            refCount--;
	            innerSub.unsubscribe();
	            if (subscription && refCount === 0 && isComplete) {
	                subscription.unsubscribe();
	            }
	        };
	    };
	}
	;
	//# sourceMappingURL=shareReplay.js.map

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var single_1 = __webpack_require__(578);
	Observable_1.Observable.prototype.single = single_1.single;
	//# sourceMappingURL=single.js.map

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var single_1 = __webpack_require__(579);
	/**
	 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
	 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
	 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
	 *
	 * <img src="./img/single.png" width="100%">
	 *
	 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
	 * callback if the Observable completes before any `next` notification was sent.
	 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
	 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
	 * the predicate.
	 .
	 * @method single
	 * @owner Observable
	 */
	function single(predicate) {
	    return single_1.single(predicate)(this);
	}
	exports.single = single;
	//# sourceMappingURL=single.js.map

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	var EmptyError_1 = __webpack_require__(289);
	/**
	 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
	 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
	 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
	 *
	 * <img src="./img/single.png" width="100%">
	 *
	 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
	 * callback if the Observable completes before any `next` notification was sent.
	 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
	 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
	 * the predicate.
	 .
	 * @method single
	 * @owner Observable
	 */
	function single(predicate) {
	    return function (source) { return source.lift(new SingleOperator(predicate, source)); };
	}
	exports.single = single;
	var SingleOperator = (function () {
	    function SingleOperator(predicate, source) {
	        this.predicate = predicate;
	        this.source = source;
	    }
	    SingleOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SingleSubscriber(subscriber, this.predicate, this.source));
	    };
	    return SingleOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SingleSubscriber = (function (_super) {
	    __extends(SingleSubscriber, _super);
	    function SingleSubscriber(destination, predicate, source) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.source = source;
	        this.seenValue = false;
	        this.index = 0;
	    }
	    SingleSubscriber.prototype.applySingleValue = function (value) {
	        if (this.seenValue) {
	            this.destination.error('Sequence contains more than one element');
	        }
	        else {
	            this.seenValue = true;
	            this.singleValue = value;
	        }
	    };
	    SingleSubscriber.prototype._next = function (value) {
	        var index = this.index++;
	        if (this.predicate) {
	            this.tryNext(value, index);
	        }
	        else {
	            this.applySingleValue(value);
	        }
	    };
	    SingleSubscriber.prototype.tryNext = function (value, index) {
	        try {
	            if (this.predicate(value, index, this.source)) {
	                this.applySingleValue(value);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    SingleSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        if (this.index > 0) {
	            destination.next(this.seenValue ? this.singleValue : undefined);
	            destination.complete();
	        }
	        else {
	            destination.error(new EmptyError_1.EmptyError);
	        }
	    };
	    return SingleSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=single.js.map

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var skip_1 = __webpack_require__(581);
	Observable_1.Observable.prototype.skip = skip_1.skip;
	//# sourceMappingURL=skip.js.map

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var skip_1 = __webpack_require__(582);
	/**
	 * Returns an Observable that skips the first `count` items emitted by the source Observable.
	 *
	 * <img src="./img/skip.png" width="100%">
	 *
	 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
	 * @return {Observable} An Observable that skips values emitted by the source Observable.
	 *
	 * @method skip
	 * @owner Observable
	 */
	function skip(count) {
	    return skip_1.skip(count)(this);
	}
	exports.skip = skip;
	//# sourceMappingURL=skip.js.map

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	/**
	 * Returns an Observable that skips the first `count` items emitted by the source Observable.
	 *
	 * <img src="./img/skip.png" width="100%">
	 *
	 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
	 * @return {Observable} An Observable that skips values emitted by the source Observable.
	 *
	 * @method skip
	 * @owner Observable
	 */
	function skip(count) {
	    return function (source) { return source.lift(new SkipOperator(count)); };
	}
	exports.skip = skip;
	var SkipOperator = (function () {
	    function SkipOperator(total) {
	        this.total = total;
	    }
	    SkipOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SkipSubscriber(subscriber, this.total));
	    };
	    return SkipOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SkipSubscriber = (function (_super) {
	    __extends(SkipSubscriber, _super);
	    function SkipSubscriber(destination, total) {
	        _super.call(this, destination);
	        this.total = total;
	        this.count = 0;
	    }
	    SkipSubscriber.prototype._next = function (x) {
	        if (++this.count > this.total) {
	            this.destination.next(x);
	        }
	    };
	    return SkipSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=skip.js.map

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var skipLast_1 = __webpack_require__(584);
	Observable_1.Observable.prototype.skipLast = skipLast_1.skipLast;
	//# sourceMappingURL=skipLast.js.map

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var skipLast_1 = __webpack_require__(585);
	/**
	 * Skip the last `count` values emitted by the source Observable.
	 *
	 * <img src="./img/skipLast.png" width="100%">
	 *
	 * `skipLast` returns an Observable that accumulates a queue with a length
	 * enough to store the first `count` values. As more values are received,
	 * values are taken from the front of the queue and produced on the result
	 * sequence. This causes values to be delayed.
	 *
	 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
	 * var many = Rx.Observable.range(1, 5);
	 * var skipLastTwo = many.skipLast(2);
	 * skipLastTwo.subscribe(x => console.log(x));
	 *
	 * // Results in:
	 * // 1 2 3
	 *
	 * @see {@link skip}
	 * @see {@link skipUntil}
	 * @see {@link skipWhile}
	 * @see {@link take}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
	 * ArgumentOutOrRangeError if `i < 0`.
	 *
	 * @param {number} count Number of elements to skip from the end of the source Observable.
	 * @returns {Observable<T>} An Observable that skips the last count values
	 * emitted by the source Observable.
	 * @method skipLast
	 * @owner Observable
	 */
	function skipLast(count) {
	    return skipLast_1.skipLast(count)(this);
	}
	exports.skipLast = skipLast;
	//# sourceMappingURL=skipLast.js.map

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	var ArgumentOutOfRangeError_1 = __webpack_require__(261);
	/**
	 * Skip the last `count` values emitted by the source Observable.
	 *
	 * <img src="./img/skipLast.png" width="100%">
	 *
	 * `skipLast` returns an Observable that accumulates a queue with a length
	 * enough to store the first `count` values. As more values are received,
	 * values are taken from the front of the queue and produced on the result
	 * sequence. This causes values to be delayed.
	 *
	 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
	 * var many = Rx.Observable.range(1, 5);
	 * var skipLastTwo = many.skipLast(2);
	 * skipLastTwo.subscribe(x => console.log(x));
	 *
	 * // Results in:
	 * // 1 2 3
	 *
	 * @see {@link skip}
	 * @see {@link skipUntil}
	 * @see {@link skipWhile}
	 * @see {@link take}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
	 * ArgumentOutOrRangeError if `i < 0`.
	 *
	 * @param {number} count Number of elements to skip from the end of the source Observable.
	 * @returns {Observable<T>} An Observable that skips the last count values
	 * emitted by the source Observable.
	 * @method skipLast
	 * @owner Observable
	 */
	function skipLast(count) {
	    return function (source) { return source.lift(new SkipLastOperator(count)); };
	}
	exports.skipLast = skipLast;
	var SkipLastOperator = (function () {
	    function SkipLastOperator(_skipCount) {
	        this._skipCount = _skipCount;
	        if (this._skipCount < 0) {
	            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	        }
	    }
	    SkipLastOperator.prototype.call = function (subscriber, source) {
	        if (this._skipCount === 0) {
	            // If we don't want to skip any values then just subscribe
	            // to Subscriber without any further logic.
	            return source.subscribe(new Subscriber_1.Subscriber(subscriber));
	        }
	        else {
	            return source.subscribe(new SkipLastSubscriber(subscriber, this._skipCount));
	        }
	    };
	    return SkipLastOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SkipLastSubscriber = (function (_super) {
	    __extends(SkipLastSubscriber, _super);
	    function SkipLastSubscriber(destination, _skipCount) {
	        _super.call(this, destination);
	        this._skipCount = _skipCount;
	        this._count = 0;
	        this._ring = new Array(_skipCount);
	    }
	    SkipLastSubscriber.prototype._next = function (value) {
	        var skipCount = this._skipCount;
	        var count = this._count++;
	        if (count < skipCount) {
	            this._ring[count] = value;
	        }
	        else {
	            var currentIndex = count % skipCount;
	            var ring = this._ring;
	            var oldValue = ring[currentIndex];
	            ring[currentIndex] = value;
	            this.destination.next(oldValue);
	        }
	    };
	    return SkipLastSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=skipLast.js.map

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var skipUntil_1 = __webpack_require__(587);
	Observable_1.Observable.prototype.skipUntil = skipUntil_1.skipUntil;
	//# sourceMappingURL=skipUntil.js.map

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var skipUntil_1 = __webpack_require__(588);
	/**
	 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
	 *
	 * <img src="./img/skipUntil.png" width="100%">
	 *
	 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
	 * be mirrored by the resulting Observable.
	 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
	 * an item, then emits the remaining items.
	 * @method skipUntil
	 * @owner Observable
	 */
	function skipUntil(notifier) {
	    return skipUntil_1.skipUntil(notifier)(this);
	}
	exports.skipUntil = skipUntil;
	//# sourceMappingURL=skipUntil.js.map

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/**
	 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
	 *
	 * <img src="./img/skipUntil.png" width="100%">
	 *
	 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
	 * be mirrored by the resulting Observable.
	 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
	 * an item, then emits the remaining items.
	 * @method skipUntil
	 * @owner Observable
	 */
	function skipUntil(notifier) {
	    return function (source) { return source.lift(new SkipUntilOperator(notifier)); };
	}
	exports.skipUntil = skipUntil;
	var SkipUntilOperator = (function () {
	    function SkipUntilOperator(notifier) {
	        this.notifier = notifier;
	    }
	    SkipUntilOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SkipUntilSubscriber(subscriber, this.notifier));
	    };
	    return SkipUntilOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SkipUntilSubscriber = (function (_super) {
	    __extends(SkipUntilSubscriber, _super);
	    function SkipUntilSubscriber(destination, notifier) {
	        _super.call(this, destination);
	        this.hasValue = false;
	        this.isInnerStopped = false;
	        this.add(subscribeToResult_1.subscribeToResult(this, notifier));
	    }
	    SkipUntilSubscriber.prototype._next = function (value) {
	        if (this.hasValue) {
	            _super.prototype._next.call(this, value);
	        }
	    };
	    SkipUntilSubscriber.prototype._complete = function () {
	        if (this.isInnerStopped) {
	            _super.prototype._complete.call(this);
	        }
	        else {
	            this.unsubscribe();
	        }
	    };
	    SkipUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.hasValue = true;
	    };
	    SkipUntilSubscriber.prototype.notifyComplete = function () {
	        this.isInnerStopped = true;
	        if (this.isStopped) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    return SkipUntilSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=skipUntil.js.map

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var skipWhile_1 = __webpack_require__(590);
	Observable_1.Observable.prototype.skipWhile = skipWhile_1.skipWhile;
	//# sourceMappingURL=skipWhile.js.map

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var skipWhile_1 = __webpack_require__(591);
	/**
	 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
	 * true, but emits all further source items as soon as the condition becomes false.
	 *
	 * <img src="./img/skipWhile.png" width="100%">
	 *
	 * @param {Function} predicate - A function to test each item emitted from the source Observable.
	 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
	 * specified predicate becomes false.
	 * @method skipWhile
	 * @owner Observable
	 */
	function skipWhile(predicate) {
	    return skipWhile_1.skipWhile(predicate)(this);
	}
	exports.skipWhile = skipWhile;
	//# sourceMappingURL=skipWhile.js.map

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	/**
	 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
	 * true, but emits all further source items as soon as the condition becomes false.
	 *
	 * <img src="./img/skipWhile.png" width="100%">
	 *
	 * @param {Function} predicate - A function to test each item emitted from the source Observable.
	 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
	 * specified predicate becomes false.
	 * @method skipWhile
	 * @owner Observable
	 */
	function skipWhile(predicate) {
	    return function (source) { return source.lift(new SkipWhileOperator(predicate)); };
	}
	exports.skipWhile = skipWhile;
	var SkipWhileOperator = (function () {
	    function SkipWhileOperator(predicate) {
	        this.predicate = predicate;
	    }
	    SkipWhileOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SkipWhileSubscriber(subscriber, this.predicate));
	    };
	    return SkipWhileOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SkipWhileSubscriber = (function (_super) {
	    __extends(SkipWhileSubscriber, _super);
	    function SkipWhileSubscriber(destination, predicate) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.skipping = true;
	        this.index = 0;
	    }
	    SkipWhileSubscriber.prototype._next = function (value) {
	        var destination = this.destination;
	        if (this.skipping) {
	            this.tryCallPredicate(value);
	        }
	        if (!this.skipping) {
	            destination.next(value);
	        }
	    };
	    SkipWhileSubscriber.prototype.tryCallPredicate = function (value) {
	        try {
	            var result = this.predicate(value, this.index++);
	            this.skipping = Boolean(result);
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    return SkipWhileSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=skipWhile.js.map

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var startWith_1 = __webpack_require__(593);
	Observable_1.Observable.prototype.startWith = startWith_1.startWith;
	//# sourceMappingURL=startWith.js.map

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var startWith_1 = __webpack_require__(594);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits the items you specify as arguments before it begins to emit
	 * items emitted by the source Observable.
	 *
	 * <img src="./img/startWith.png" width="100%">
	 *
	 * @param {...T} values - Items you want the modified Observable to emit first.
	 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
	 * the emissions of the `next` notifications.
	 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
	 * emitted by the source Observable.
	 * @method startWith
	 * @owner Observable
	 */
	function startWith() {
	    var array = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        array[_i - 0] = arguments[_i];
	    }
	    return startWith_1.startWith.apply(void 0, array)(this);
	}
	exports.startWith = startWith;
	//# sourceMappingURL=startWith.js.map

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ArrayObservable_1 = __webpack_require__(223);
	var ScalarObservable_1 = __webpack_require__(224);
	var EmptyObservable_1 = __webpack_require__(225);
	var concat_1 = __webpack_require__(316);
	var isScheduler_1 = __webpack_require__(226);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits the items you specify as arguments before it begins to emit
	 * items emitted by the source Observable.
	 *
	 * <img src="./img/startWith.png" width="100%">
	 *
	 * @param {...T} values - Items you want the modified Observable to emit first.
	 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
	 * the emissions of the `next` notifications.
	 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
	 * emitted by the source Observable.
	 * @method startWith
	 * @owner Observable
	 */
	function startWith() {
	    var array = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        array[_i - 0] = arguments[_i];
	    }
	    return function (source) {
	        var scheduler = array[array.length - 1];
	        if (isScheduler_1.isScheduler(scheduler)) {
	            array.pop();
	        }
	        else {
	            scheduler = null;
	        }
	        var len = array.length;
	        if (len === 1) {
	            return concat_1.concat(new ScalarObservable_1.ScalarObservable(array[0], scheduler), source);
	        }
	        else if (len > 1) {
	            return concat_1.concat(new ArrayObservable_1.ArrayObservable(array, scheduler), source);
	        }
	        else {
	            return concat_1.concat(new EmptyObservable_1.EmptyObservable(scheduler), source);
	        }
	    };
	}
	exports.startWith = startWith;
	//# sourceMappingURL=startWith.js.map

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var subscribeOn_1 = __webpack_require__(596);
	Observable_1.Observable.prototype.subscribeOn = subscribeOn_1.subscribeOn;
	//# sourceMappingURL=subscribeOn.js.map

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var subscribeOn_1 = __webpack_require__(597);
	/**
	 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
	 *
	 * <img src="./img/subscribeOn.png" width="100%">
	 *
	 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
	 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
	 .
	 * @method subscribeOn
	 * @owner Observable
	 */
	function subscribeOn(scheduler, delay) {
	    if (delay === void 0) { delay = 0; }
	    return subscribeOn_1.subscribeOn(scheduler, delay)(this);
	}
	exports.subscribeOn = subscribeOn;
	//# sourceMappingURL=subscribeOn.js.map

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var SubscribeOnObservable_1 = __webpack_require__(598);
	/**
	 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
	 *
	 * <img src="./img/subscribeOn.png" width="100%">
	 *
	 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
	 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
	 .
	 * @method subscribeOn
	 * @owner Observable
	 */
	function subscribeOn(scheduler, delay) {
	    if (delay === void 0) { delay = 0; }
	    return function subscribeOnOperatorFunction(source) {
	        return source.lift(new SubscribeOnOperator(scheduler, delay));
	    };
	}
	exports.subscribeOn = subscribeOn;
	var SubscribeOnOperator = (function () {
	    function SubscribeOnOperator(scheduler, delay) {
	        this.scheduler = scheduler;
	        this.delay = delay;
	    }
	    SubscribeOnOperator.prototype.call = function (subscriber, source) {
	        return new SubscribeOnObservable_1.SubscribeOnObservable(source, this.delay, this.scheduler).subscribe(subscriber);
	    };
	    return SubscribeOnOperator;
	}());
	//# sourceMappingURL=subscribeOn.js.map

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(206);
	var asap_1 = __webpack_require__(599);
	var isNumeric_1 = __webpack_require__(342);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var SubscribeOnObservable = (function (_super) {
	    __extends(SubscribeOnObservable, _super);
	    function SubscribeOnObservable(source, delayTime, scheduler) {
	        if (delayTime === void 0) { delayTime = 0; }
	        if (scheduler === void 0) { scheduler = asap_1.asap; }
	        _super.call(this);
	        this.source = source;
	        this.delayTime = delayTime;
	        this.scheduler = scheduler;
	        if (!isNumeric_1.isNumeric(delayTime) || delayTime < 0) {
	            this.delayTime = 0;
	        }
	        if (!scheduler || typeof scheduler.schedule !== 'function') {
	            this.scheduler = asap_1.asap;
	        }
	    }
	    SubscribeOnObservable.create = function (source, delay, scheduler) {
	        if (delay === void 0) { delay = 0; }
	        if (scheduler === void 0) { scheduler = asap_1.asap; }
	        return new SubscribeOnObservable(source, delay, scheduler);
	    };
	    SubscribeOnObservable.dispatch = function (arg) {
	        var source = arg.source, subscriber = arg.subscriber;
	        return this.add(source.subscribe(subscriber));
	    };
	    /** @deprecated internal use only */ SubscribeOnObservable.prototype._subscribe = function (subscriber) {
	        var delay = this.delayTime;
	        var source = this.source;
	        var scheduler = this.scheduler;
	        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
	            source: source, subscriber: subscriber
	        });
	    };
	    return SubscribeOnObservable;
	}(Observable_1.Observable));
	exports.SubscribeOnObservable = SubscribeOnObservable;
	//# sourceMappingURL=SubscribeOnObservable.js.map

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var AsapAction_1 = __webpack_require__(600);
	var AsapScheduler_1 = __webpack_require__(605);
	/**
	 *
	 * Asap Scheduler
	 *
	 * <span class="informal">Perform task as fast as it can be performed asynchronously</span>
	 *
	 * `asap` scheduler behaves the same as {@link async} scheduler when you use it to delay task
	 * in time. If however you set delay to `0`, `asap` will wait for current synchronously executing
	 * code to end and then it will try to execute given task as fast as possible.
	 *
	 * `asap` scheduler will do its best to minimize time between end of currently executing code
	 * and start of scheduled task. This makes it best candidate for performing so called "deferring".
	 * Traditionally this was achieved by calling `setTimeout(deferredTask, 0)`, but that technique involves
	 * some (although minimal) unwanted delay.
	 *
	 * Note that using `asap` scheduler does not necessarily mean that your task will be first to process
	 * after currently executing code. In particular, if some task was also scheduled with `asap` before,
	 * that task will execute first. That being said, if you need to schedule task asynchronously, but
	 * as soon as possible, `asap` scheduler is your best bet.
	 *
	 * @example <caption>Compare async and asap scheduler</caption>
	 *
	 * Rx.Scheduler.async.schedule(() => console.log('async')); // scheduling 'async' first...
	 * Rx.Scheduler.asap.schedule(() => console.log('asap'));
	 *
	 * // Logs:
	 * // "asap"
	 * // "async"
	 * // ... but 'asap' goes first!
	 *
	 * @static true
	 * @name asap
	 * @owner Scheduler
	 */
	exports.asap = new AsapScheduler_1.AsapScheduler(AsapAction_1.AsapAction);
	//# sourceMappingURL=asap.js.map

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Immediate_1 = __webpack_require__(601);
	var AsyncAction_1 = __webpack_require__(344);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AsapAction = (function (_super) {
	    __extends(AsapAction, _super);
	    function AsapAction(scheduler, work) {
	        _super.call(this, scheduler, work);
	        this.scheduler = scheduler;
	        this.work = work;
	    }
	    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If delay is greater than 0, request as an async action.
	        if (delay !== null && delay > 0) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        // Push the action to the end of the scheduler queue.
	        scheduler.actions.push(this);
	        // If a microtask has already been scheduled, don't schedule another
	        // one. If a microtask hasn't been scheduled yet, schedule one now. Return
	        // the current scheduled microtask id.
	        return scheduler.scheduled || (scheduler.scheduled = Immediate_1.Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
	    };
	    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If delay exists and is greater than 0, or if the delay is null (the
	        // action wasn't rescheduled) but was originally scheduled as an async
	        // action, then recycle as an async action.
	        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
	            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
	        }
	        // If the scheduler queue is empty, cancel the requested microtask and
	        // set the scheduled flag to undefined so the next AsapAction will schedule
	        // its own.
	        if (scheduler.actions.length === 0) {
	            Immediate_1.Immediate.clearImmediate(id);
	            scheduler.scheduled = undefined;
	        }
	        // Return undefined so the action knows to request a new async id if it's rescheduled.
	        return undefined;
	    };
	    return AsapAction;
	}(AsyncAction_1.AsyncAction));
	exports.AsapAction = AsapAction;
	//# sourceMappingURL=AsapAction.js.map

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(clearImmediate, setImmediate) {/**
	Some credit for this helper goes to http://github.com/YuzuJS/setImmediate
	*/
	"use strict";
	var root_1 = __webpack_require__(207);
	var ImmediateDefinition = (function () {
	    function ImmediateDefinition(root) {
	        this.root = root;
	        if (root.setImmediate && typeof root.setImmediate === 'function') {
	            this.setImmediate = root.setImmediate.bind(root);
	            this.clearImmediate = root.clearImmediate.bind(root);
	        }
	        else {
	            this.nextHandle = 1;
	            this.tasksByHandle = {};
	            this.currentlyRunningATask = false;
	            // Don't get fooled by e.g. browserify environments.
	            if (this.canUseProcessNextTick()) {
	                // For Node.js before 0.9
	                this.setImmediate = this.createProcessNextTickSetImmediate();
	            }
	            else if (this.canUsePostMessage()) {
	                // For non-IE10 modern browsers
	                this.setImmediate = this.createPostMessageSetImmediate();
	            }
	            else if (this.canUseMessageChannel()) {
	                // For web workers, where supported
	                this.setImmediate = this.createMessageChannelSetImmediate();
	            }
	            else if (this.canUseReadyStateChange()) {
	                // For IE 6–8
	                this.setImmediate = this.createReadyStateChangeSetImmediate();
	            }
	            else {
	                // For older browsers
	                this.setImmediate = this.createSetTimeoutSetImmediate();
	            }
	            var ci = function clearImmediate(handle) {
	                delete clearImmediate.instance.tasksByHandle[handle];
	            };
	            ci.instance = this;
	            this.clearImmediate = ci;
	        }
	    }
	    ImmediateDefinition.prototype.identify = function (o) {
	        return this.root.Object.prototype.toString.call(o);
	    };
	    ImmediateDefinition.prototype.canUseProcessNextTick = function () {
	        return this.identify(this.root.process) === '[object process]';
	    };
	    ImmediateDefinition.prototype.canUseMessageChannel = function () {
	        return Boolean(this.root.MessageChannel);
	    };
	    ImmediateDefinition.prototype.canUseReadyStateChange = function () {
	        var document = this.root.document;
	        return Boolean(document && 'onreadystatechange' in document.createElement('script'));
	    };
	    ImmediateDefinition.prototype.canUsePostMessage = function () {
	        var root = this.root;
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `root.postMessage` means something completely different and can't be used for this purpose.
	        if (root.postMessage && !root.importScripts) {
	            var postMessageIsAsynchronous_1 = true;
	            var oldOnMessage = root.onmessage;
	            root.onmessage = function () {
	                postMessageIsAsynchronous_1 = false;
	            };
	            root.postMessage('', '*');
	            root.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous_1;
	        }
	        return false;
	    };
	    // This function accepts the same arguments as setImmediate, but
	    // returns a function that requires no arguments.
	    ImmediateDefinition.prototype.partiallyApplied = function (handler) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var fn = function result() {
	            var _a = result, handler = _a.handler, args = _a.args;
	            if (typeof handler === 'function') {
	                handler.apply(undefined, args);
	            }
	            else {
	                (new Function('' + handler))();
	            }
	        };
	        fn.handler = handler;
	        fn.args = args;
	        return fn;
	    };
	    ImmediateDefinition.prototype.addFromSetImmediateArguments = function (args) {
	        this.tasksByHandle[this.nextHandle] = this.partiallyApplied.apply(undefined, args);
	        return this.nextHandle++;
	    };
	    ImmediateDefinition.prototype.createProcessNextTickSetImmediate = function () {
	        var fn = function setImmediate() {
	            var instance = setImmediate.instance;
	            var handle = instance.addFromSetImmediateArguments(arguments);
	            instance.root.process.nextTick(instance.partiallyApplied(instance.runIfPresent, handle));
	            return handle;
	        };
	        fn.instance = this;
	        return fn;
	    };
	    ImmediateDefinition.prototype.createPostMessageSetImmediate = function () {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	        var root = this.root;
	        var messagePrefix = 'setImmediate$' + root.Math.random() + '$';
	        var onGlobalMessage = function globalMessageHandler(event) {
	            var instance = globalMessageHandler.instance;
	            if (event.source === root &&
	                typeof event.data === 'string' &&
	                event.data.indexOf(messagePrefix) === 0) {
	                instance.runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	        onGlobalMessage.instance = this;
	        root.addEventListener('message', onGlobalMessage, false);
	        var fn = function setImmediate() {
	            var _a = setImmediate, messagePrefix = _a.messagePrefix, instance = _a.instance;
	            var handle = instance.addFromSetImmediateArguments(arguments);
	            instance.root.postMessage(messagePrefix + handle, '*');
	            return handle;
	        };
	        fn.instance = this;
	        fn.messagePrefix = messagePrefix;
	        return fn;
	    };
	    ImmediateDefinition.prototype.runIfPresent = function (handle) {
	        // From the spec: 'Wait until any invocations of this algorithm started before this one have completed.'
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (this.currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // 'too much recursion' error.
	            this.root.setTimeout(this.partiallyApplied(this.runIfPresent, handle), 0);
	        }
	        else {
	            var task = this.tasksByHandle[handle];
	            if (task) {
	                this.currentlyRunningATask = true;
	                try {
	                    task();
	                }
	                finally {
	                    this.clearImmediate(handle);
	                    this.currentlyRunningATask = false;
	                }
	            }
	        }
	    };
	    ImmediateDefinition.prototype.createMessageChannelSetImmediate = function () {
	        var _this = this;
	        var channel = new this.root.MessageChannel();
	        channel.port1.onmessage = function (event) {
	            var handle = event.data;
	            _this.runIfPresent(handle);
	        };
	        var fn = function setImmediate() {
	            var _a = setImmediate, channel = _a.channel, instance = _a.instance;
	            var handle = instance.addFromSetImmediateArguments(arguments);
	            channel.port2.postMessage(handle);
	            return handle;
	        };
	        fn.channel = channel;
	        fn.instance = this;
	        return fn;
	    };
	    ImmediateDefinition.prototype.createReadyStateChangeSetImmediate = function () {
	        var fn = function setImmediate() {
	            var instance = setImmediate.instance;
	            var root = instance.root;
	            var doc = root.document;
	            var html = doc.documentElement;
	            var handle = instance.addFromSetImmediateArguments(arguments);
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement('script');
	            script.onreadystatechange = function () {
	                instance.runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	            return handle;
	        };
	        fn.instance = this;
	        return fn;
	    };
	    ImmediateDefinition.prototype.createSetTimeoutSetImmediate = function () {
	        var fn = function setImmediate() {
	            var instance = setImmediate.instance;
	            var handle = instance.addFromSetImmediateArguments(arguments);
	            instance.root.setTimeout(instance.partiallyApplied(instance.runIfPresent, handle), 0);
	            return handle;
	        };
	        fn.instance = this;
	        return fn;
	    };
	    return ImmediateDefinition;
	}());
	exports.ImmediateDefinition = ImmediateDefinition;
	exports.Immediate = new ImmediateDefinition(root_1.root);
	//# sourceMappingURL=Immediate.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(602).clearImmediate, __webpack_require__(602).setImmediate))

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(603);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(604)))

/***/ }),
/* 604 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncScheduler_1 = __webpack_require__(346);
	var AsapScheduler = (function (_super) {
	    __extends(AsapScheduler, _super);
	    function AsapScheduler() {
	        _super.apply(this, arguments);
	    }
	    AsapScheduler.prototype.flush = function (action) {
	        this.active = true;
	        this.scheduled = undefined;
	        var actions = this.actions;
	        var error;
	        var index = -1;
	        var count = actions.length;
	        action = action || actions.shift();
	        do {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        } while (++index < count && (action = actions.shift()));
	        this.active = false;
	        if (error) {
	            while (++index < count && (action = actions.shift())) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AsapScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.AsapScheduler = AsapScheduler;
	//# sourceMappingURL=AsapScheduler.js.map

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var switch_1 = __webpack_require__(607);
	Observable_1.Observable.prototype.switch = switch_1._switch;
	Observable_1.Observable.prototype._switch = switch_1._switch;
	//# sourceMappingURL=switch.js.map

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var switchAll_1 = __webpack_require__(608);
	/**
	 * Converts a higher-order Observable into a first-order Observable by
	 * subscribing to only the most recently emitted of those inner Observables.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by dropping the
	 * previous inner Observable once a new one appears.</span>
	 *
	 * <img src="./img/switch.png" width="100%">
	 *
	 * `switch` subscribes to an Observable that emits Observables, also known as a
	 * higher-order Observable. Each time it observes one of these emitted inner
	 * Observables, the output Observable subscribes to the inner Observable and
	 * begins emitting the items emitted by that. So far, it behaves
	 * like {@link mergeAll}. However, when a new inner Observable is emitted,
	 * `switch` unsubscribes from the earlier-emitted inner Observable and
	 * subscribes to the new inner Observable and begins emitting items from it. It
	 * continues to behave like this for subsequent inner Observables.
	 *
	 * @example <caption>Rerun an interval Observable on every click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * // Each click event is mapped to an Observable that ticks every second
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
	 * var switched = higherOrder.switch();
	 * // The outcome is that `switched` is essentially a timer that restarts
	 * // on every click. The interval Observables from older clicks do not merge
	 * // with the current interval Observable.
	 * switched.subscribe(x => console.log(x));
	 *
	 * @see {@link combineAll}
	 * @see {@link concatAll}
	 * @see {@link exhaust}
	 * @see {@link mergeAll}
	 * @see {@link switchMap}
	 * @see {@link switchMapTo}
	 * @see {@link zipAll}
	 *
	 * @return {Observable<T>} An Observable that emits the items emitted by the
	 * Observable most recently emitted by the source Observable.
	 * @method switch
	 * @name switch
	 * @owner Observable
	 */
	function _switch() {
	    return switchAll_1.switchAll()(this);
	}
	exports._switch = _switch;
	//# sourceMappingURL=switch.js.map

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var switchMap_1 = __webpack_require__(256);
	var identity_1 = __webpack_require__(235);
	function switchAll() {
	    return switchMap_1.switchMap(identity_1.identity);
	}
	exports.switchAll = switchAll;
	//# sourceMappingURL=switchAll.js.map

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var switchMap_1 = __webpack_require__(610);
	Observable_1.Observable.prototype.switchMap = switchMap_1.switchMap;
	//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var switchMap_1 = __webpack_require__(256);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable, emitting values only from the most recently projected Observable.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link switch}.</span>
	 *
	 * <img src="./img/switchMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. Each time it observes one of these
	 * inner Observables, the output Observable begins emitting the items emitted by
	 * that inner Observable. When a new inner Observable is emitted, `switchMap`
	 * stops emitting items from the earlier-emitted inner Observable and begins
	 * emitting items from the new one. It continues to behave like this for
	 * subsequent inner Observables.
	 *
	 * @example <caption>Rerun an interval Observable on every click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaustMap}
	 * @see {@link mergeMap}
	 * @see {@link switch}
	 * @see {@link switchMapTo}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and taking only the values from the most recently
	 * projected inner Observable.
	 * @method switchMap
	 * @owner Observable
	 */
	function switchMap(project, resultSelector) {
	    return switchMap_1.switchMap(project, resultSelector)(this);
	}
	exports.switchMap = switchMap;
	//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var switchMapTo_1 = __webpack_require__(612);
	Observable_1.Observable.prototype.switchMapTo = switchMapTo_1.switchMapTo;
	//# sourceMappingURL=switchMapTo.js.map

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var switchMapTo_1 = __webpack_require__(613);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to the same Observable which is flattened multiple
	 * times with {@link switch} in the output Observable.
	 *
	 * <span class="informal">It's like {@link switchMap}, but maps each value
	 * always to the same inner Observable.</span>
	 *
	 * <img src="./img/switchMapTo.png" width="100%">
	 *
	 * Maps each source value to the given Observable `innerObservable` regardless
	 * of the source value, and then flattens those resulting Observables into one
	 * single Observable, which is the output Observable. The output Observables
	 * emits values only from the most recently emitted instance of
	 * `innerObservable`.
	 *
	 * @example <caption>Rerun an interval Observable on every click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMapTo}
	 * @see {@link switch}
	 * @see {@link switchMap}
	 * @see {@link mergeMapTo}
	 *
	 * @param {ObservableInput} innerObservable An Observable to replace each value from
	 * the source Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits items from the given
	 * `innerObservable` (and optionally transformed through `resultSelector`) every
	 * time a value is emitted on the source Observable, and taking only the values
	 * from the most recently projected inner Observable.
	 * @method switchMapTo
	 * @owner Observable
	 */
	function switchMapTo(innerObservable, resultSelector) {
	    return switchMapTo_1.switchMapTo(innerObservable, resultSelector)(this);
	}
	exports.switchMapTo = switchMapTo;
	//# sourceMappingURL=switchMapTo.js.map

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to the same Observable which is flattened multiple
	 * times with {@link switch} in the output Observable.
	 *
	 * <span class="informal">It's like {@link switchMap}, but maps each value
	 * always to the same inner Observable.</span>
	 *
	 * <img src="./img/switchMapTo.png" width="100%">
	 *
	 * Maps each source value to the given Observable `innerObservable` regardless
	 * of the source value, and then flattens those resulting Observables into one
	 * single Observable, which is the output Observable. The output Observables
	 * emits values only from the most recently emitted instance of
	 * `innerObservable`.
	 *
	 * @example <caption>Rerun an interval Observable on every click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMapTo}
	 * @see {@link switch}
	 * @see {@link switchMap}
	 * @see {@link mergeMapTo}
	 *
	 * @param {ObservableInput} innerObservable An Observable to replace each value from
	 * the source Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits items from the given
	 * `innerObservable` (and optionally transformed through `resultSelector`) every
	 * time a value is emitted on the source Observable, and taking only the values
	 * from the most recently projected inner Observable.
	 * @method switchMapTo
	 * @owner Observable
	 */
	function switchMapTo(innerObservable, resultSelector) {
	    return function (source) { return source.lift(new SwitchMapToOperator(innerObservable, resultSelector)); };
	}
	exports.switchMapTo = switchMapTo;
	var SwitchMapToOperator = (function () {
	    function SwitchMapToOperator(observable, resultSelector) {
	        this.observable = observable;
	        this.resultSelector = resultSelector;
	    }
	    SwitchMapToOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SwitchMapToSubscriber(subscriber, this.observable, this.resultSelector));
	    };
	    return SwitchMapToOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SwitchMapToSubscriber = (function (_super) {
	    __extends(SwitchMapToSubscriber, _super);
	    function SwitchMapToSubscriber(destination, inner, resultSelector) {
	        _super.call(this, destination);
	        this.inner = inner;
	        this.resultSelector = resultSelector;
	        this.index = 0;
	    }
	    SwitchMapToSubscriber.prototype._next = function (value) {
	        var innerSubscription = this.innerSubscription;
	        if (innerSubscription) {
	            innerSubscription.unsubscribe();
	        }
	        this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, this.inner, value, this.index++));
	    };
	    SwitchMapToSubscriber.prototype._complete = function () {
	        var innerSubscription = this.innerSubscription;
	        if (!innerSubscription || innerSubscription.closed) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    /** @deprecated internal use only */ SwitchMapToSubscriber.prototype._unsubscribe = function () {
	        this.innerSubscription = null;
	    };
	    SwitchMapToSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.remove(innerSub);
	        this.innerSubscription = null;
	        if (this.isStopped) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    SwitchMapToSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        if (resultSelector) {
	            this.tryResultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            destination.next(innerValue);
	        }
	    };
	    SwitchMapToSubscriber.prototype.tryResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        var result;
	        try {
	            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        catch (err) {
	            destination.error(err);
	            return;
	        }
	        destination.next(result);
	    };
	    return SwitchMapToSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=switchMapTo.js.map

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var take_1 = __webpack_require__(615);
	Observable_1.Observable.prototype.take = take_1.take;
	//# sourceMappingURL=take.js.map

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var take_1 = __webpack_require__(263);
	/**
	 * Emits only the first `count` values emitted by the source Observable.
	 *
	 * <span class="informal">Takes the first `count` values from the source, then
	 * completes.</span>
	 *
	 * <img src="./img/take.png" width="100%">
	 *
	 * `take` returns an Observable that emits only the first `count` values emitted
	 * by the source Observable. If the source emits fewer than `count` values then
	 * all of its values are emitted. After that, it completes, regardless if the
	 * source completes.
	 *
	 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
	 * var interval = Rx.Observable.interval(1000);
	 * var five = interval.take(5);
	 * five.subscribe(x => console.log(x));
	 *
	 * @see {@link takeLast}
	 * @see {@link takeUntil}
	 * @see {@link takeWhile}
	 * @see {@link skip}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
	 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
	 *
	 * @param {number} count The maximum number of `next` values to emit.
	 * @return {Observable<T>} An Observable that emits only the first `count`
	 * values emitted by the source Observable, or all of the values from the source
	 * if the source emits fewer than `count` values.
	 * @method take
	 * @owner Observable
	 */
	function take(count) {
	    return take_1.take(count)(this);
	}
	exports.take = take;
	//# sourceMappingURL=take.js.map

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var takeLast_1 = __webpack_require__(617);
	Observable_1.Observable.prototype.takeLast = takeLast_1.takeLast;
	//# sourceMappingURL=takeLast.js.map

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var takeLast_1 = __webpack_require__(260);
	/**
	 * Emits only the last `count` values emitted by the source Observable.
	 *
	 * <span class="informal">Remembers the latest `count` values, then emits those
	 * only when the source completes.</span>
	 *
	 * <img src="./img/takeLast.png" width="100%">
	 *
	 * `takeLast` returns an Observable that emits at most the last `count` values
	 * emitted by the source Observable. If the source emits fewer than `count`
	 * values then all of its values are emitted. This operator must wait until the
	 * `complete` notification emission from the source in order to emit the `next`
	 * values on the output Observable, because otherwise it is impossible to know
	 * whether or not more values will be emitted on the source. For this reason,
	 * all values are emitted synchronously, followed by the complete notification.
	 *
	 * @example <caption>Take the last 3 values of an Observable with many values</caption>
	 * var many = Rx.Observable.range(1, 100);
	 * var lastThree = many.takeLast(3);
	 * lastThree.subscribe(x => console.log(x));
	 *
	 * @see {@link take}
	 * @see {@link takeUntil}
	 * @see {@link takeWhile}
	 * @see {@link skip}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
	 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
	 *
	 * @param {number} count The maximum number of values to emit from the end of
	 * the sequence of values emitted by the source Observable.
	 * @return {Observable<T>} An Observable that emits at most the last count
	 * values emitted by the source Observable.
	 * @method takeLast
	 * @owner Observable
	 */
	function takeLast(count) {
	    return takeLast_1.takeLast(count)(this);
	}
	exports.takeLast = takeLast;
	//# sourceMappingURL=takeLast.js.map

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var takeUntil_1 = __webpack_require__(619);
	Observable_1.Observable.prototype.takeUntil = takeUntil_1.takeUntil;
	//# sourceMappingURL=takeUntil.js.map

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var takeUntil_1 = __webpack_require__(620);
	/**
	 * Emits the values emitted by the source Observable until a `notifier`
	 * Observable emits a value.
	 *
	 * <span class="informal">Lets values pass until a second Observable,
	 * `notifier`, emits something. Then, it completes.</span>
	 *
	 * <img src="./img/takeUntil.png" width="100%">
	 *
	 * `takeUntil` subscribes and begins mirroring the source Observable. It also
	 * monitors a second Observable, `notifier` that you provide. If the `notifier`
	 * emits a value, the output Observable stops mirroring the source Observable
	 * and completes.
	 *
	 * @example <caption>Tick every second until the first click happens</caption>
	 * var interval = Rx.Observable.interval(1000);
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = interval.takeUntil(clicks);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link take}
	 * @see {@link takeLast}
	 * @see {@link takeWhile}
	 * @see {@link skip}
	 *
	 * @param {Observable} notifier The Observable whose first emitted value will
	 * cause the output Observable of `takeUntil` to stop emitting values from the
	 * source Observable.
	 * @return {Observable<T>} An Observable that emits the values from the source
	 * Observable until such time as `notifier` emits its first value.
	 * @method takeUntil
	 * @owner Observable
	 */
	function takeUntil(notifier) {
	    return takeUntil_1.takeUntil(notifier)(this);
	}
	exports.takeUntil = takeUntil;
	//# sourceMappingURL=takeUntil.js.map

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/**
	 * Emits the values emitted by the source Observable until a `notifier`
	 * Observable emits a value.
	 *
	 * <span class="informal">Lets values pass until a second Observable,
	 * `notifier`, emits something. Then, it completes.</span>
	 *
	 * <img src="./img/takeUntil.png" width="100%">
	 *
	 * `takeUntil` subscribes and begins mirroring the source Observable. It also
	 * monitors a second Observable, `notifier` that you provide. If the `notifier`
	 * emits a value or a complete notification, the output Observable stops
	 * mirroring the source Observable and completes.
	 *
	 * @example <caption>Tick every second until the first click happens</caption>
	 * var interval = Rx.Observable.interval(1000);
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = interval.takeUntil(clicks);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link take}
	 * @see {@link takeLast}
	 * @see {@link takeWhile}
	 * @see {@link skip}
	 *
	 * @param {Observable} notifier The Observable whose first emitted value will
	 * cause the output Observable of `takeUntil` to stop emitting values from the
	 * source Observable.
	 * @return {Observable<T>} An Observable that emits the values from the source
	 * Observable until such time as `notifier` emits its first value.
	 * @method takeUntil
	 * @owner Observable
	 */
	function takeUntil(notifier) {
	    return function (source) { return source.lift(new TakeUntilOperator(notifier)); };
	}
	exports.takeUntil = takeUntil;
	var TakeUntilOperator = (function () {
	    function TakeUntilOperator(notifier) {
	        this.notifier = notifier;
	    }
	    TakeUntilOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TakeUntilSubscriber(subscriber, this.notifier));
	    };
	    return TakeUntilOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TakeUntilSubscriber = (function (_super) {
	    __extends(TakeUntilSubscriber, _super);
	    function TakeUntilSubscriber(destination, notifier) {
	        _super.call(this, destination);
	        this.notifier = notifier;
	        this.add(subscribeToResult_1.subscribeToResult(this, notifier));
	    }
	    TakeUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.complete();
	    };
	    TakeUntilSubscriber.prototype.notifyComplete = function () {
	        // noop
	    };
	    return TakeUntilSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=takeUntil.js.map

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var takeWhile_1 = __webpack_require__(622);
	Observable_1.Observable.prototype.takeWhile = takeWhile_1.takeWhile;
	//# sourceMappingURL=takeWhile.js.map

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var takeWhile_1 = __webpack_require__(623);
	/**
	 * Emits values emitted by the source Observable so long as each value satisfies
	 * the given `predicate`, and then completes as soon as this `predicate` is not
	 * satisfied.
	 *
	 * <span class="informal">Takes values from the source only while they pass the
	 * condition given. When the first value does not satisfy, it completes.</span>
	 *
	 * <img src="./img/takeWhile.png" width="100%">
	 *
	 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
	 * emitted on the source is given to the `predicate` function which returns a
	 * boolean, representing a condition to be satisfied by the source values. The
	 * output Observable emits the source values until such time as the `predicate`
	 * returns false, at which point `takeWhile` stops mirroring the source
	 * Observable and completes the output Observable.
	 *
	 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.takeWhile(ev => ev.clientX > 200);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link take}
	 * @see {@link takeLast}
	 * @see {@link takeUntil}
	 * @see {@link skip}
	 *
	 * @param {function(value: T, index: number): boolean} predicate A function that
	 * evaluates a value emitted by the source Observable and returns a boolean.
	 * Also takes the (zero-based) index as the second argument.
	 * @return {Observable<T>} An Observable that emits the values from the source
	 * Observable so long as each value satisfies the condition defined by the
	 * `predicate`, then completes.
	 * @method takeWhile
	 * @owner Observable
	 */
	function takeWhile(predicate) {
	    return takeWhile_1.takeWhile(predicate)(this);
	}
	exports.takeWhile = takeWhile;
	//# sourceMappingURL=takeWhile.js.map

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	/**
	 * Emits values emitted by the source Observable so long as each value satisfies
	 * the given `predicate`, and then completes as soon as this `predicate` is not
	 * satisfied.
	 *
	 * <span class="informal">Takes values from the source only while they pass the
	 * condition given. When the first value does not satisfy, it completes.</span>
	 *
	 * <img src="./img/takeWhile.png" width="100%">
	 *
	 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
	 * emitted on the source is given to the `predicate` function which returns a
	 * boolean, representing a condition to be satisfied by the source values. The
	 * output Observable emits the source values until such time as the `predicate`
	 * returns false, at which point `takeWhile` stops mirroring the source
	 * Observable and completes the output Observable.
	 *
	 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.takeWhile(ev => ev.clientX > 200);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link take}
	 * @see {@link takeLast}
	 * @see {@link takeUntil}
	 * @see {@link skip}
	 *
	 * @param {function(value: T, index: number): boolean} predicate A function that
	 * evaluates a value emitted by the source Observable and returns a boolean.
	 * Also takes the (zero-based) index as the second argument.
	 * @return {Observable<T>} An Observable that emits the values from the source
	 * Observable so long as each value satisfies the condition defined by the
	 * `predicate`, then completes.
	 * @method takeWhile
	 * @owner Observable
	 */
	function takeWhile(predicate) {
	    return function (source) { return source.lift(new TakeWhileOperator(predicate)); };
	}
	exports.takeWhile = takeWhile;
	var TakeWhileOperator = (function () {
	    function TakeWhileOperator(predicate) {
	        this.predicate = predicate;
	    }
	    TakeWhileOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TakeWhileSubscriber(subscriber, this.predicate));
	    };
	    return TakeWhileOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TakeWhileSubscriber = (function (_super) {
	    __extends(TakeWhileSubscriber, _super);
	    function TakeWhileSubscriber(destination, predicate) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.index = 0;
	    }
	    TakeWhileSubscriber.prototype._next = function (value) {
	        var destination = this.destination;
	        var result;
	        try {
	            result = this.predicate(value, this.index++);
	        }
	        catch (err) {
	            destination.error(err);
	            return;
	        }
	        this.nextOrComplete(value, result);
	    };
	    TakeWhileSubscriber.prototype.nextOrComplete = function (value, predicateResult) {
	        var destination = this.destination;
	        if (Boolean(predicateResult)) {
	            destination.next(value);
	        }
	        else {
	            destination.complete();
	        }
	    };
	    return TakeWhileSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=takeWhile.js.map

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var throttle_1 = __webpack_require__(625);
	Observable_1.Observable.prototype.throttle = throttle_1.throttle;
	//# sourceMappingURL=throttle.js.map

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var throttle_1 = __webpack_require__(626);
	/**
	 * Emits a value from the source Observable, then ignores subsequent source
	 * values for a duration determined by another Observable, then repeats this
	 * process.
	 *
	 * <span class="informal">It's like {@link throttleTime}, but the silencing
	 * duration is determined by a second Observable.</span>
	 *
	 * <img src="./img/throttle.png" width="100%">
	 *
	 * `throttle` emits the source Observable values on the output Observable
	 * when its internal timer is disabled, and ignores source values when the timer
	 * is enabled. Initially, the timer is disabled. As soon as the first source
	 * value arrives, it is forwarded to the output Observable, and then the timer
	 * is enabled by calling the `durationSelector` function with the source value,
	 * which returns the "duration" Observable. When the duration Observable emits a
	 * value or completes, the timer is disabled, and this process repeats for the
	 * next source value.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounce}
	 * @see {@link delayWhen}
	 * @see {@link sample}
	 * @see {@link throttleTime}
	 *
	 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
	 * that receives a value from the source Observable, for computing the silencing
	 * duration for each source value, returned as an Observable or a Promise.
	 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
	 * to `{ leading: true, trailing: false }`.
	 * @return {Observable<T>} An Observable that performs the throttle operation to
	 * limit the rate of emissions from the source.
	 * @method throttle
	 * @owner Observable
	 */
	function throttle(durationSelector, config) {
	    if (config === void 0) { config = throttle_1.defaultThrottleConfig; }
	    return throttle_1.throttle(durationSelector, config)(this);
	}
	exports.throttle = throttle;
	//# sourceMappingURL=throttle.js.map

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	exports.defaultThrottleConfig = {
	    leading: true,
	    trailing: false
	};
	/**
	 * Emits a value from the source Observable, then ignores subsequent source
	 * values for a duration determined by another Observable, then repeats this
	 * process.
	 *
	 * <span class="informal">It's like {@link throttleTime}, but the silencing
	 * duration is determined by a second Observable.</span>
	 *
	 * <img src="./img/throttle.png" width="100%">
	 *
	 * `throttle` emits the source Observable values on the output Observable
	 * when its internal timer is disabled, and ignores source values when the timer
	 * is enabled. Initially, the timer is disabled. As soon as the first source
	 * value arrives, it is forwarded to the output Observable, and then the timer
	 * is enabled by calling the `durationSelector` function with the source value,
	 * which returns the "duration" Observable. When the duration Observable emits a
	 * value or completes, the timer is disabled, and this process repeats for the
	 * next source value.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounce}
	 * @see {@link delayWhen}
	 * @see {@link sample}
	 * @see {@link throttleTime}
	 *
	 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
	 * that receives a value from the source Observable, for computing the silencing
	 * duration for each source value, returned as an Observable or a Promise.
	 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
	 * to `{ leading: true, trailing: false }`.
	 * @return {Observable<T>} An Observable that performs the throttle operation to
	 * limit the rate of emissions from the source.
	 * @method throttle
	 * @owner Observable
	 */
	function throttle(durationSelector, config) {
	    if (config === void 0) { config = exports.defaultThrottleConfig; }
	    return function (source) { return source.lift(new ThrottleOperator(durationSelector, config.leading, config.trailing)); };
	}
	exports.throttle = throttle;
	var ThrottleOperator = (function () {
	    function ThrottleOperator(durationSelector, leading, trailing) {
	        this.durationSelector = durationSelector;
	        this.leading = leading;
	        this.trailing = trailing;
	    }
	    ThrottleOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
	    };
	    return ThrottleOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc
	 * @ignore
	 * @extends {Ignored}
	 */
	var ThrottleSubscriber = (function (_super) {
	    __extends(ThrottleSubscriber, _super);
	    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
	        _super.call(this, destination);
	        this.destination = destination;
	        this.durationSelector = durationSelector;
	        this._leading = _leading;
	        this._trailing = _trailing;
	        this._hasTrailingValue = false;
	    }
	    ThrottleSubscriber.prototype._next = function (value) {
	        if (this.throttled) {
	            if (this._trailing) {
	                this._hasTrailingValue = true;
	                this._trailingValue = value;
	            }
	        }
	        else {
	            var duration = this.tryDurationSelector(value);
	            if (duration) {
	                this.add(this.throttled = subscribeToResult_1.subscribeToResult(this, duration));
	            }
	            if (this._leading) {
	                this.destination.next(value);
	                if (this._trailing) {
	                    this._hasTrailingValue = true;
	                    this._trailingValue = value;
	                }
	            }
	        }
	    };
	    ThrottleSubscriber.prototype.tryDurationSelector = function (value) {
	        try {
	            return this.durationSelector(value);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return null;
	        }
	    };
	    /** @deprecated internal use only */ ThrottleSubscriber.prototype._unsubscribe = function () {
	        var _a = this, throttled = _a.throttled, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue, _trailing = _a._trailing;
	        this._trailingValue = null;
	        this._hasTrailingValue = false;
	        if (throttled) {
	            this.remove(throttled);
	            this.throttled = null;
	            throttled.unsubscribe();
	        }
	    };
	    ThrottleSubscriber.prototype._sendTrailing = function () {
	        var _a = this, destination = _a.destination, throttled = _a.throttled, _trailing = _a._trailing, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue;
	        if (throttled && _trailing && _hasTrailingValue) {
	            destination.next(_trailingValue);
	            this._trailingValue = null;
	            this._hasTrailingValue = false;
	        }
	    };
	    ThrottleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this._sendTrailing();
	        this._unsubscribe();
	    };
	    ThrottleSubscriber.prototype.notifyComplete = function () {
	        this._sendTrailing();
	        this._unsubscribe();
	    };
	    return ThrottleSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=throttle.js.map

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var throttleTime_1 = __webpack_require__(628);
	Observable_1.Observable.prototype.throttleTime = throttleTime_1.throttleTime;
	//# sourceMappingURL=throttleTime.js.map

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(343);
	var throttle_1 = __webpack_require__(626);
	var throttleTime_1 = __webpack_require__(629);
	/**
	 * Emits a value from the source Observable, then ignores subsequent source
	 * values for `duration` milliseconds, then repeats this process.
	 *
	 * <span class="informal">Lets a value pass, then ignores source values for the
	 * next `duration` milliseconds.</span>
	 *
	 * <img src="./img/throttleTime.png" width="100%">
	 *
	 * `throttleTime` emits the source Observable values on the output Observable
	 * when its internal timer is disabled, and ignores source values when the timer
	 * is enabled. Initially, the timer is disabled. As soon as the first source
	 * value arrives, it is forwarded to the output Observable, and then the timer
	 * is enabled. After `duration` milliseconds (or the time unit determined
	 * internally by the optional `scheduler`) has passed, the timer is disabled,
	 * and this process repeats for the next source value. Optionally takes a
	 * {@link IScheduler} for managing timers.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.throttleTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounceTime}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttle}
	 *
	 * @param {number} duration Time to wait before emitting another value after
	 * emitting the last value, measured in milliseconds or the time unit determined
	 * internally by the optional `scheduler`.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the throttling.
	 * @return {Observable<T>} An Observable that performs the throttle operation to
	 * limit the rate of emissions from the source.
	 * @method throttleTime
	 * @owner Observable
	 */
	function throttleTime(duration, scheduler, config) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    if (config === void 0) { config = throttle_1.defaultThrottleConfig; }
	    return throttleTime_1.throttleTime(duration, scheduler, config)(this);
	}
	exports.throttleTime = throttleTime;
	//# sourceMappingURL=throttleTime.js.map

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	var async_1 = __webpack_require__(343);
	var throttle_1 = __webpack_require__(626);
	/**
	 * Emits a value from the source Observable, then ignores subsequent source
	 * values for `duration` milliseconds, then repeats this process.
	 *
	 * <span class="informal">Lets a value pass, then ignores source values for the
	 * next `duration` milliseconds.</span>
	 *
	 * <img src="./img/throttleTime.png" width="100%">
	 *
	 * `throttleTime` emits the source Observable values on the output Observable
	 * when its internal timer is disabled, and ignores source values when the timer
	 * is enabled. Initially, the timer is disabled. As soon as the first source
	 * value arrives, it is forwarded to the output Observable, and then the timer
	 * is enabled. After `duration` milliseconds (or the time unit determined
	 * internally by the optional `scheduler`) has passed, the timer is disabled,
	 * and this process repeats for the next source value. Optionally takes a
	 * {@link IScheduler} for managing timers.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.throttleTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounceTime}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttle}
	 *
	 * @param {number} duration Time to wait before emitting another value after
	 * emitting the last value, measured in milliseconds or the time unit determined
	 * internally by the optional `scheduler`.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the throttling.
	 * @return {Observable<T>} An Observable that performs the throttle operation to
	 * limit the rate of emissions from the source.
	 * @method throttleTime
	 * @owner Observable
	 */
	function throttleTime(duration, scheduler, config) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    if (config === void 0) { config = throttle_1.defaultThrottleConfig; }
	    return function (source) { return source.lift(new ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing)); };
	}
	exports.throttleTime = throttleTime;
	var ThrottleTimeOperator = (function () {
	    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
	        this.duration = duration;
	        this.scheduler = scheduler;
	        this.leading = leading;
	        this.trailing = trailing;
	    }
	    ThrottleTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
	    };
	    return ThrottleTimeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ThrottleTimeSubscriber = (function (_super) {
	    __extends(ThrottleTimeSubscriber, _super);
	    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
	        _super.call(this, destination);
	        this.duration = duration;
	        this.scheduler = scheduler;
	        this.leading = leading;
	        this.trailing = trailing;
	        this._hasTrailingValue = false;
	        this._trailingValue = null;
	    }
	    ThrottleTimeSubscriber.prototype._next = function (value) {
	        if (this.throttled) {
	            if (this.trailing) {
	                this._trailingValue = value;
	                this._hasTrailingValue = true;
	            }
	        }
	        else {
	            this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, { subscriber: this }));
	            if (this.leading) {
	                this.destination.next(value);
	            }
	        }
	    };
	    ThrottleTimeSubscriber.prototype.clearThrottle = function () {
	        var throttled = this.throttled;
	        if (throttled) {
	            if (this.trailing && this._hasTrailingValue) {
	                this.destination.next(this._trailingValue);
	                this._trailingValue = null;
	                this._hasTrailingValue = false;
	            }
	            throttled.unsubscribe();
	            this.remove(throttled);
	            this.throttled = null;
	        }
	    };
	    return ThrottleTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchNext(arg) {
	    var subscriber = arg.subscriber;
	    subscriber.clearThrottle();
	}
	//# sourceMappingURL=throttleTime.js.map

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var timeInterval_1 = __webpack_require__(631);
	Observable_1.Observable.prototype.timeInterval = timeInterval_1.timeInterval;
	//# sourceMappingURL=timeInterval.js.map

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(343);
	var timeInterval_1 = __webpack_require__(632);
	exports.TimeInterval = timeInterval_1.TimeInterval;
	/**
	 * @param scheduler
	 * @return {Observable<TimeInterval<any>>|WebSocketSubject<T>|Observable<T>}
	 * @method timeInterval
	 * @owner Observable
	 */
	function timeInterval(scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return timeInterval_1.timeInterval(scheduler)(this);
	}
	exports.timeInterval = timeInterval;
	//# sourceMappingURL=timeInterval.js.map

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	var async_1 = __webpack_require__(343);
	function timeInterval(scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return function (source) { return source.lift(new TimeIntervalOperator(scheduler)); };
	}
	exports.timeInterval = timeInterval;
	var TimeInterval = (function () {
	    function TimeInterval(value, interval) {
	        this.value = value;
	        this.interval = interval;
	    }
	    return TimeInterval;
	}());
	exports.TimeInterval = TimeInterval;
	;
	var TimeIntervalOperator = (function () {
	    function TimeIntervalOperator(scheduler) {
	        this.scheduler = scheduler;
	    }
	    TimeIntervalOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new TimeIntervalSubscriber(observer, this.scheduler));
	    };
	    return TimeIntervalOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TimeIntervalSubscriber = (function (_super) {
	    __extends(TimeIntervalSubscriber, _super);
	    function TimeIntervalSubscriber(destination, scheduler) {
	        _super.call(this, destination);
	        this.scheduler = scheduler;
	        this.lastTime = 0;
	        this.lastTime = scheduler.now();
	    }
	    TimeIntervalSubscriber.prototype._next = function (value) {
	        var now = this.scheduler.now();
	        var span = now - this.lastTime;
	        this.lastTime = now;
	        this.destination.next(new TimeInterval(value, span));
	    };
	    return TimeIntervalSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=timeInterval.js.map

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var timeout_1 = __webpack_require__(634);
	Observable_1.Observable.prototype.timeout = timeout_1.timeout;
	//# sourceMappingURL=timeout.js.map

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(343);
	var timeout_1 = __webpack_require__(635);
	/**
	 *
	 * Errors if Observable does not emit a value in given time span.
	 *
	 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
	 *
	 * <img src="./img/timeout.png" width="100%">
	 *
	 * `timeout` operator accepts as an argument either a number or a Date.
	 *
	 * If number was provided, it returns an Observable that behaves like a source
	 * Observable, unless there is a period of time where there is no value emitted.
	 * So if you provide `100` as argument and first value comes after 50ms from
	 * the moment of subscription, this value will be simply re-emitted by the resulting
	 * Observable. If however after that 100ms passes without a second value being emitted,
	 * stream will end with an error and source Observable will be unsubscribed.
	 * These checks are performed throughout whole lifecycle of Observable - from the moment
	 * it was subscribed to, until it completes or errors itself. Thus every value must be
	 * emitted within specified period since previous value.
	 *
	 * If provided argument was Date, returned Observable behaves differently. It throws
	 * if Observable did not complete before provided Date. This means that periods between
	 * emission of particular values do not matter in this case. If Observable did not complete
	 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
	 * stream behaves just as source Observable.
	 *
	 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
	 * when returned Observable will check if source stream emitted value or completed.
	 *
	 * @example <caption>Check if ticks are emitted within certain timespan</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 *
	 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
	 *                       // since `interval` might fire a bit later then scheduled.
	 * .subscribe(
	 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
	 *     err => console.log(err) // Will never be called.
	 * );
	 *
	 * seconds.timeout(900).subscribe(
	 *     value => console.log(value), // Will never be called.
	 *     err => console.log(err) // Will emit error before even first value is emitted,
	 *                             // since it did not arrive within 900ms period.
	 * );
	 *
	 * @example <caption>Use Date to check if Observable completed</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 *
	 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
	 * .subscribe(
	 *     value => console.log(value), // Will emit values as regular `interval` would
	 *                                  // until December 17, 2020 at 03:24:00.
	 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
	 *                             // since Observable did not complete by then.
	 * );
	 *
	 * @see {@link timeoutWith}
	 *
	 * @param {number|Date} due Number specifying period within which Observable must emit values
	 *                          or Date specifying before when Observable should complete
	 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
	 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
	 * @method timeout
	 * @owner Observable
	 */
	function timeout(due, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return timeout_1.timeout(due, scheduler)(this);
	}
	exports.timeout = timeout;
	//# sourceMappingURL=timeout.js.map

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var async_1 = __webpack_require__(343);
	var isDate_1 = __webpack_require__(373);
	var Subscriber_1 = __webpack_require__(209);
	var TimeoutError_1 = __webpack_require__(636);
	/**
	 *
	 * Errors if Observable does not emit a value in given time span.
	 *
	 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
	 *
	 * <img src="./img/timeout.png" width="100%">
	 *
	 * `timeout` operator accepts as an argument either a number or a Date.
	 *
	 * If number was provided, it returns an Observable that behaves like a source
	 * Observable, unless there is a period of time where there is no value emitted.
	 * So if you provide `100` as argument and first value comes after 50ms from
	 * the moment of subscription, this value will be simply re-emitted by the resulting
	 * Observable. If however after that 100ms passes without a second value being emitted,
	 * stream will end with an error and source Observable will be unsubscribed.
	 * These checks are performed throughout whole lifecycle of Observable - from the moment
	 * it was subscribed to, until it completes or errors itself. Thus every value must be
	 * emitted within specified period since previous value.
	 *
	 * If provided argument was Date, returned Observable behaves differently. It throws
	 * if Observable did not complete before provided Date. This means that periods between
	 * emission of particular values do not matter in this case. If Observable did not complete
	 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
	 * stream behaves just as source Observable.
	 *
	 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
	 * when returned Observable will check if source stream emitted value or completed.
	 *
	 * @example <caption>Check if ticks are emitted within certain timespan</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 *
	 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
	 *                       // since `interval` might fire a bit later then scheduled.
	 * .subscribe(
	 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
	 *     err => console.log(err) // Will never be called.
	 * );
	 *
	 * seconds.timeout(900).subscribe(
	 *     value => console.log(value), // Will never be called.
	 *     err => console.log(err) // Will emit error before even first value is emitted,
	 *                             // since it did not arrive within 900ms period.
	 * );
	 *
	 * @example <caption>Use Date to check if Observable completed</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 *
	 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
	 * .subscribe(
	 *     value => console.log(value), // Will emit values as regular `interval` would
	 *                                  // until December 17, 2020 at 03:24:00.
	 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
	 *                             // since Observable did not complete by then.
	 * );
	 *
	 * @see {@link timeoutWith}
	 *
	 * @param {number|Date} due Number specifying period within which Observable must emit values
	 *                          or Date specifying before when Observable should complete
	 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
	 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
	 * @method timeout
	 * @owner Observable
	 */
	function timeout(due, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    var absoluteTimeout = isDate_1.isDate(due);
	    var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
	    return function (source) { return source.lift(new TimeoutOperator(waitFor, absoluteTimeout, scheduler, new TimeoutError_1.TimeoutError())); };
	}
	exports.timeout = timeout;
	var TimeoutOperator = (function () {
	    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
	        this.waitFor = waitFor;
	        this.absoluteTimeout = absoluteTimeout;
	        this.scheduler = scheduler;
	        this.errorInstance = errorInstance;
	    }
	    TimeoutOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
	    };
	    return TimeoutOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TimeoutSubscriber = (function (_super) {
	    __extends(TimeoutSubscriber, _super);
	    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
	        _super.call(this, destination);
	        this.absoluteTimeout = absoluteTimeout;
	        this.waitFor = waitFor;
	        this.scheduler = scheduler;
	        this.errorInstance = errorInstance;
	        this.action = null;
	        this.scheduleTimeout();
	    }
	    TimeoutSubscriber.dispatchTimeout = function (subscriber) {
	        subscriber.error(subscriber.errorInstance);
	    };
	    TimeoutSubscriber.prototype.scheduleTimeout = function () {
	        var action = this.action;
	        if (action) {
	            // Recycle the action if we've already scheduled one. All the production
	            // Scheduler Actions mutate their state/delay time and return themeselves.
	            // VirtualActions are immutable, so they create and return a clone. In this
	            // case, we need to set the action reference to the most recent VirtualAction,
	            // to ensure that's the one we clone from next time.
	            this.action = action.schedule(this, this.waitFor);
	        }
	        else {
	            this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
	        }
	    };
	    TimeoutSubscriber.prototype._next = function (value) {
	        if (!this.absoluteTimeout) {
	            this.scheduleTimeout();
	        }
	        _super.prototype._next.call(this, value);
	    };
	    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function () {
	        this.action = null;
	        this.scheduler = null;
	        this.errorInstance = null;
	    };
	    return TimeoutSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=timeout.js.map

/***/ }),
/* 636 */
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when duetime elapses.
	 *
	 * @see {@link timeout}
	 *
	 * @class TimeoutError
	 */
	var TimeoutError = (function (_super) {
	    __extends(TimeoutError, _super);
	    function TimeoutError() {
	        var err = _super.call(this, 'Timeout has occurred');
	        this.name = err.name = 'TimeoutError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return TimeoutError;
	}(Error));
	exports.TimeoutError = TimeoutError;
	//# sourceMappingURL=TimeoutError.js.map

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var timeoutWith_1 = __webpack_require__(638);
	Observable_1.Observable.prototype.timeoutWith = timeoutWith_1.timeoutWith;
	//# sourceMappingURL=timeoutWith.js.map

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(343);
	var timeoutWith_1 = __webpack_require__(639);
	/* tslint:enable:max-line-length */
	/**
	 *
	 * Errors if Observable does not emit a value in given time span, in case of which
	 * subscribes to the second Observable.
	 *
	 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
	 *
	 * <img src="./img/timeoutWith.png" width="100%">
	 *
	 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
	 * still accepting as a first argument either a number or a Date, which control - respectively -
	 * when values of source Observable should be emitted or when it should complete.
	 *
	 * The only difference is that it accepts a second, required parameter. This parameter
	 * should be an Observable which will be subscribed when source Observable fails any timeout check.
	 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
	 * values from second Observable. Note that this fallback Observable is not checked for timeouts
	 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
	 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
	 * stream completes, it completes as well.
	 *
	 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
	 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
	 * as a consequence - when second Observable will be subscribed, since subscription happens
	 * immediately after failing check.
	 *
	 * @example <caption>Add fallback observable</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 * const minutes = Rx.Observable.interval(60 * 1000);
	 *
	 * seconds.timeoutWith(900, minutes)
	 *     .subscribe(
	 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
	 *                                      // since first value of `seconds` will not arrive fast enough.
	 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
	 *                                 // but here will never be called.
	 *     );
	 *
	 * @param {number|Date} due Number specifying period within which Observable must emit values
	 *                          or Date specifying before when Observable should complete
	 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
	 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
	 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
	 *                          passed as a second parameter.
	 * @method timeoutWith
	 * @owner Observable
	 */
	function timeoutWith(due, withObservable, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return timeoutWith_1.timeoutWith(due, withObservable, scheduler)(this);
	}
	exports.timeoutWith = timeoutWith;
	//# sourceMappingURL=timeoutWith.js.map

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var async_1 = __webpack_require__(343);
	var isDate_1 = __webpack_require__(373);
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/* tslint:enable:max-line-length */
	/**
	 *
	 * Errors if Observable does not emit a value in given time span, in case of which
	 * subscribes to the second Observable.
	 *
	 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
	 *
	 * <img src="./img/timeoutWith.png" width="100%">
	 *
	 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
	 * still accepting as a first argument either a number or a Date, which control - respectively -
	 * when values of source Observable should be emitted or when it should complete.
	 *
	 * The only difference is that it accepts a second, required parameter. This parameter
	 * should be an Observable which will be subscribed when source Observable fails any timeout check.
	 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
	 * values from second Observable. Note that this fallback Observable is not checked for timeouts
	 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
	 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
	 * stream completes, it completes as well.
	 *
	 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
	 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
	 * as a consequence - when second Observable will be subscribed, since subscription happens
	 * immediately after failing check.
	 *
	 * @example <caption>Add fallback observable</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 * const minutes = Rx.Observable.interval(60 * 1000);
	 *
	 * seconds.timeoutWith(900, minutes)
	 *     .subscribe(
	 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
	 *                                      // since first value of `seconds` will not arrive fast enough.
	 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
	 *                                 // but here will never be called.
	 *     );
	 *
	 * @param {number|Date} due Number specifying period within which Observable must emit values
	 *                          or Date specifying before when Observable should complete
	 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
	 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
	 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
	 *                          passed as a second parameter.
	 * @method timeoutWith
	 * @owner Observable
	 */
	function timeoutWith(due, withObservable, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return function (source) {
	        var absoluteTimeout = isDate_1.isDate(due);
	        var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
	        return source.lift(new TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
	    };
	}
	exports.timeoutWith = timeoutWith;
	var TimeoutWithOperator = (function () {
	    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
	        this.waitFor = waitFor;
	        this.absoluteTimeout = absoluteTimeout;
	        this.withObservable = withObservable;
	        this.scheduler = scheduler;
	    }
	    TimeoutWithOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
	    };
	    return TimeoutWithOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TimeoutWithSubscriber = (function (_super) {
	    __extends(TimeoutWithSubscriber, _super);
	    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
	        _super.call(this, destination);
	        this.absoluteTimeout = absoluteTimeout;
	        this.waitFor = waitFor;
	        this.withObservable = withObservable;
	        this.scheduler = scheduler;
	        this.action = null;
	        this.scheduleTimeout();
	    }
	    TimeoutWithSubscriber.dispatchTimeout = function (subscriber) {
	        var withObservable = subscriber.withObservable;
	        subscriber._unsubscribeAndRecycle();
	        subscriber.add(subscribeToResult_1.subscribeToResult(subscriber, withObservable));
	    };
	    TimeoutWithSubscriber.prototype.scheduleTimeout = function () {
	        var action = this.action;
	        if (action) {
	            // Recycle the action if we've already scheduled one. All the production
	            // Scheduler Actions mutate their state/delay time and return themeselves.
	            // VirtualActions are immutable, so they create and return a clone. In this
	            // case, we need to set the action reference to the most recent VirtualAction,
	            // to ensure that's the one we clone from next time.
	            this.action = action.schedule(this, this.waitFor);
	        }
	        else {
	            this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
	        }
	    };
	    TimeoutWithSubscriber.prototype._next = function (value) {
	        if (!this.absoluteTimeout) {
	            this.scheduleTimeout();
	        }
	        _super.prototype._next.call(this, value);
	    };
	    /** @deprecated internal use only */ TimeoutWithSubscriber.prototype._unsubscribe = function () {
	        this.action = null;
	        this.scheduler = null;
	        this.withObservable = null;
	    };
	    return TimeoutWithSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=timeoutWith.js.map

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var timestamp_1 = __webpack_require__(641);
	Observable_1.Observable.prototype.timestamp = timestamp_1.timestamp;
	//# sourceMappingURL=timestamp.js.map

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(343);
	var timestamp_1 = __webpack_require__(642);
	/**
	 * @param scheduler
	 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
	 * @method timestamp
	 * @owner Observable
	 */
	function timestamp(scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return timestamp_1.timestamp(scheduler)(this);
	}
	exports.timestamp = timestamp;
	//# sourceMappingURL=timestamp.js.map

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(343);
	var map_1 = __webpack_require__(254);
	/**
	 * @param scheduler
	 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
	 * @method timestamp
	 * @owner Observable
	 */
	function timestamp(scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return map_1.map(function (value) { return new Timestamp(value, scheduler.now()); });
	    // return (source: Observable<T>) => source.lift(new TimestampOperator(scheduler));
	}
	exports.timestamp = timestamp;
	var Timestamp = (function () {
	    function Timestamp(value, timestamp) {
	        this.value = value;
	        this.timestamp = timestamp;
	    }
	    return Timestamp;
	}());
	exports.Timestamp = Timestamp;
	;
	//# sourceMappingURL=timestamp.js.map

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var toArray_1 = __webpack_require__(644);
	Observable_1.Observable.prototype.toArray = toArray_1.toArray;
	//# sourceMappingURL=toArray.js.map

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var toArray_1 = __webpack_require__(257);
	/**
	 * Collects all source emissions and emits them as an array when the source completes.
	 *
	 * <span class="informal">Get all values inside an array when the source completes</span>
	 *
	 * <img src="./img/toArray.png" width="100%">
	 *
	 * `toArray` will wait until the source Observable completes
	 * before emitting the array containing all emissions.
	 * When the source Observable errors no array will be emitted.
	 *
	 * @example <caption>Create array from input</caption>
	 * const input = Rx.Observable.interval(100).take(4);
	 *
	 * input.toArray()
	 *   .subscribe(arr => console.log(arr)); // [0,1,2,3]
	 *
	 * @see {@link buffer}
	 *
	 * @return {Observable<any[]>|WebSocketSubject<T>|Observable<T>}
	 * @method toArray
	 * @owner Observable
	 */
	function toArray() {
	    return toArray_1.toArray()(this);
	}
	exports.toArray = toArray;
	//# sourceMappingURL=toArray.js.map

/***/ }),
/* 645 */
/***/ (function(module, exports) {

	// HACK: does nothing, because `toPromise` now lives on the `Observable` itself.
	// leaving this module here to prevent breakage.
	//# sourceMappingURL=toPromise.js.map

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var window_1 = __webpack_require__(647);
	Observable_1.Observable.prototype.window = window_1.window;
	//# sourceMappingURL=window.js.map

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var window_1 = __webpack_require__(648);
	/**
	 * Branch out the source Observable values as a nested Observable whenever
	 * `windowBoundaries` emits.
	 *
	 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
	 * instead of an array.</span>
	 *
	 * <img src="./img/window.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits connected, non-overlapping
	 * windows. It emits the current window and opens a new one whenever the
	 * Observable `windowBoundaries` emits an item. Because each window is an
	 * Observable, the output is a higher-order Observable.
	 *
	 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var interval = Rx.Observable.interval(1000);
	 * var result = clicks.window(interval)
	 *   .map(win => win.take(2)) // each window has at most 2 emissions
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link windowCount}
	 * @see {@link windowTime}
	 * @see {@link windowToggle}
	 * @see {@link windowWhen}
	 * @see {@link buffer}
	 *
	 * @param {Observable<any>} windowBoundaries An Observable that completes the
	 * previous window and starts a new window.
	 * @return {Observable<Observable<T>>} An Observable of windows, which are
	 * Observables emitting values of the source Observable.
	 * @method window
	 * @owner Observable
	 */
	function window(windowBoundaries) {
	    return window_1.window(windowBoundaries)(this);
	}
	exports.window = window;
	//# sourceMappingURL=window.js.map

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(240);
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/**
	 * Branch out the source Observable values as a nested Observable whenever
	 * `windowBoundaries` emits.
	 *
	 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
	 * instead of an array.</span>
	 *
	 * <img src="./img/window.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits connected, non-overlapping
	 * windows. It emits the current window and opens a new one whenever the
	 * Observable `windowBoundaries` emits an item. Because each window is an
	 * Observable, the output is a higher-order Observable.
	 *
	 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var interval = Rx.Observable.interval(1000);
	 * var result = clicks.window(interval)
	 *   .map(win => win.take(2)) // each window has at most 2 emissions
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link windowCount}
	 * @see {@link windowTime}
	 * @see {@link windowToggle}
	 * @see {@link windowWhen}
	 * @see {@link buffer}
	 *
	 * @param {Observable<any>} windowBoundaries An Observable that completes the
	 * previous window and starts a new window.
	 * @return {Observable<Observable<T>>} An Observable of windows, which are
	 * Observables emitting values of the source Observable.
	 * @method window
	 * @owner Observable
	 */
	function window(windowBoundaries) {
	    return function windowOperatorFunction(source) {
	        return source.lift(new WindowOperator(windowBoundaries));
	    };
	}
	exports.window = window;
	var WindowOperator = (function () {
	    function WindowOperator(windowBoundaries) {
	        this.windowBoundaries = windowBoundaries;
	    }
	    WindowOperator.prototype.call = function (subscriber, source) {
	        var windowSubscriber = new WindowSubscriber(subscriber);
	        var sourceSubscription = source.subscribe(windowSubscriber);
	        if (!sourceSubscription.closed) {
	            windowSubscriber.add(subscribeToResult_1.subscribeToResult(windowSubscriber, this.windowBoundaries));
	        }
	        return sourceSubscription;
	    };
	    return WindowOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WindowSubscriber = (function (_super) {
	    __extends(WindowSubscriber, _super);
	    function WindowSubscriber(destination) {
	        _super.call(this, destination);
	        this.window = new Subject_1.Subject();
	        destination.next(this.window);
	    }
	    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.openWindow();
	    };
	    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
	        this._error(error);
	    };
	    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
	        this._complete();
	    };
	    WindowSubscriber.prototype._next = function (value) {
	        this.window.next(value);
	    };
	    WindowSubscriber.prototype._error = function (err) {
	        this.window.error(err);
	        this.destination.error(err);
	    };
	    WindowSubscriber.prototype._complete = function () {
	        this.window.complete();
	        this.destination.complete();
	    };
	    /** @deprecated internal use only */ WindowSubscriber.prototype._unsubscribe = function () {
	        this.window = null;
	    };
	    WindowSubscriber.prototype.openWindow = function () {
	        var prevWindow = this.window;
	        if (prevWindow) {
	            prevWindow.complete();
	        }
	        var destination = this.destination;
	        var newWindow = this.window = new Subject_1.Subject();
	        destination.next(newWindow);
	    };
	    return WindowSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=window.js.map

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var windowCount_1 = __webpack_require__(650);
	Observable_1.Observable.prototype.windowCount = windowCount_1.windowCount;
	//# sourceMappingURL=windowCount.js.map

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var windowCount_1 = __webpack_require__(651);
	/**
	 * Branch out the source Observable values as a nested Observable with each
	 * nested Observable emitting at most `windowSize` values.
	 *
	 * <span class="informal">It's like {@link bufferCount}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowCount.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits windows every `startWindowEvery`
	 * items, each containing no more than `windowSize` items. When the source
	 * Observable completes or encounters an error, the output Observable emits
	 * the current window and propagates the notification from the source
	 * Observable. If `startWindowEvery` is not provided, then new windows are
	 * started immediately at the start of the source and when each window completes
	 * with size `windowSize`.
	 *
	 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.windowCount(3)
	 *   .map(win => win.skip(1)) // skip first of every 3 clicks
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.windowCount(2, 3)
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowTime}
	 * @see {@link windowToggle}
	 * @see {@link windowWhen}
	 * @see {@link bufferCount}
	 *
	 * @param {number} windowSize The maximum number of values emitted by each
	 * window.
	 * @param {number} [startWindowEvery] Interval at which to start a new window.
	 * For example if `startWindowEvery` is `2`, then a new window will be started
	 * on every other value from the source. A new window is started at the
	 * beginning of the source by default.
	 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
	 * are Observable of values.
	 * @method windowCount
	 * @owner Observable
	 */
	function windowCount(windowSize, startWindowEvery) {
	    if (startWindowEvery === void 0) { startWindowEvery = 0; }
	    return windowCount_1.windowCount(windowSize, startWindowEvery)(this);
	}
	exports.windowCount = windowCount;
	//# sourceMappingURL=windowCount.js.map

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(209);
	var Subject_1 = __webpack_require__(240);
	/**
	 * Branch out the source Observable values as a nested Observable with each
	 * nested Observable emitting at most `windowSize` values.
	 *
	 * <span class="informal">It's like {@link bufferCount}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowCount.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits windows every `startWindowEvery`
	 * items, each containing no more than `windowSize` items. When the source
	 * Observable completes or encounters an error, the output Observable emits
	 * the current window and propagates the notification from the source
	 * Observable. If `startWindowEvery` is not provided, then new windows are
	 * started immediately at the start of the source and when each window completes
	 * with size `windowSize`.
	 *
	 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.windowCount(3)
	 *   .map(win => win.skip(1)) // skip first of every 3 clicks
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.windowCount(2, 3)
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowTime}
	 * @see {@link windowToggle}
	 * @see {@link windowWhen}
	 * @see {@link bufferCount}
	 *
	 * @param {number} windowSize The maximum number of values emitted by each
	 * window.
	 * @param {number} [startWindowEvery] Interval at which to start a new window.
	 * For example if `startWindowEvery` is `2`, then a new window will be started
	 * on every other value from the source. A new window is started at the
	 * beginning of the source by default.
	 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
	 * are Observable of values.
	 * @method windowCount
	 * @owner Observable
	 */
	function windowCount(windowSize, startWindowEvery) {
	    if (startWindowEvery === void 0) { startWindowEvery = 0; }
	    return function windowCountOperatorFunction(source) {
	        return source.lift(new WindowCountOperator(windowSize, startWindowEvery));
	    };
	}
	exports.windowCount = windowCount;
	var WindowCountOperator = (function () {
	    function WindowCountOperator(windowSize, startWindowEvery) {
	        this.windowSize = windowSize;
	        this.startWindowEvery = startWindowEvery;
	    }
	    WindowCountOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
	    };
	    return WindowCountOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WindowCountSubscriber = (function (_super) {
	    __extends(WindowCountSubscriber, _super);
	    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
	        _super.call(this, destination);
	        this.destination = destination;
	        this.windowSize = windowSize;
	        this.startWindowEvery = startWindowEvery;
	        this.windows = [new Subject_1.Subject()];
	        this.count = 0;
	        destination.next(this.windows[0]);
	    }
	    WindowCountSubscriber.prototype._next = function (value) {
	        var startWindowEvery = (this.startWindowEvery > 0) ? this.startWindowEvery : this.windowSize;
	        var destination = this.destination;
	        var windowSize = this.windowSize;
	        var windows = this.windows;
	        var len = windows.length;
	        for (var i = 0; i < len && !this.closed; i++) {
	            windows[i].next(value);
	        }
	        var c = this.count - windowSize + 1;
	        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) {
	            windows.shift().complete();
	        }
	        if (++this.count % startWindowEvery === 0 && !this.closed) {
	            var window_1 = new Subject_1.Subject();
	            windows.push(window_1);
	            destination.next(window_1);
	        }
	    };
	    WindowCountSubscriber.prototype._error = function (err) {
	        var windows = this.windows;
	        if (windows) {
	            while (windows.length > 0 && !this.closed) {
	                windows.shift().error(err);
	            }
	        }
	        this.destination.error(err);
	    };
	    WindowCountSubscriber.prototype._complete = function () {
	        var windows = this.windows;
	        if (windows) {
	            while (windows.length > 0 && !this.closed) {
	                windows.shift().complete();
	            }
	        }
	        this.destination.complete();
	    };
	    /** @deprecated internal use only */ WindowCountSubscriber.prototype._unsubscribe = function () {
	        this.count = 0;
	        this.windows = null;
	    };
	    return WindowCountSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=windowCount.js.map

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var windowTime_1 = __webpack_require__(653);
	Observable_1.Observable.prototype.windowTime = windowTime_1.windowTime;
	//# sourceMappingURL=windowTime.js.map

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(343);
	var isNumeric_1 = __webpack_require__(342);
	var isScheduler_1 = __webpack_require__(226);
	var windowTime_1 = __webpack_require__(654);
	function windowTime(windowTimeSpan) {
	    var scheduler = async_1.async;
	    var windowCreationInterval = null;
	    var maxWindowSize = Number.POSITIVE_INFINITY;
	    if (isScheduler_1.isScheduler(arguments[3])) {
	        scheduler = arguments[3];
	    }
	    if (isScheduler_1.isScheduler(arguments[2])) {
	        scheduler = arguments[2];
	    }
	    else if (isNumeric_1.isNumeric(arguments[2])) {
	        maxWindowSize = arguments[2];
	    }
	    if (isScheduler_1.isScheduler(arguments[1])) {
	        scheduler = arguments[1];
	    }
	    else if (isNumeric_1.isNumeric(arguments[1])) {
	        windowCreationInterval = arguments[1];
	    }
	    return windowTime_1.windowTime(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler)(this);
	}
	exports.windowTime = windowTime;
	//# sourceMappingURL=windowTime.js.map

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(240);
	var async_1 = __webpack_require__(343);
	var Subscriber_1 = __webpack_require__(209);
	var isNumeric_1 = __webpack_require__(342);
	var isScheduler_1 = __webpack_require__(226);
	function windowTime(windowTimeSpan) {
	    var scheduler = async_1.async;
	    var windowCreationInterval = null;
	    var maxWindowSize = Number.POSITIVE_INFINITY;
	    if (isScheduler_1.isScheduler(arguments[3])) {
	        scheduler = arguments[3];
	    }
	    if (isScheduler_1.isScheduler(arguments[2])) {
	        scheduler = arguments[2];
	    }
	    else if (isNumeric_1.isNumeric(arguments[2])) {
	        maxWindowSize = arguments[2];
	    }
	    if (isScheduler_1.isScheduler(arguments[1])) {
	        scheduler = arguments[1];
	    }
	    else if (isNumeric_1.isNumeric(arguments[1])) {
	        windowCreationInterval = arguments[1];
	    }
	    return function windowTimeOperatorFunction(source) {
	        return source.lift(new WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
	    };
	}
	exports.windowTime = windowTime;
	var WindowTimeOperator = (function () {
	    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
	        this.windowTimeSpan = windowTimeSpan;
	        this.windowCreationInterval = windowCreationInterval;
	        this.maxWindowSize = maxWindowSize;
	        this.scheduler = scheduler;
	    }
	    WindowTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
	    };
	    return WindowTimeOperator;
	}());
	var CountedSubject = (function (_super) {
	    __extends(CountedSubject, _super);
	    function CountedSubject() {
	        _super.apply(this, arguments);
	        this._numberOfNextedValues = 0;
	    }
	    CountedSubject.prototype.next = function (value) {
	        this._numberOfNextedValues++;
	        _super.prototype.next.call(this, value);
	    };
	    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
	        get: function () {
	            return this._numberOfNextedValues;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return CountedSubject;
	}(Subject_1.Subject));
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WindowTimeSubscriber = (function (_super) {
	    __extends(WindowTimeSubscriber, _super);
	    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
	        _super.call(this, destination);
	        this.destination = destination;
	        this.windowTimeSpan = windowTimeSpan;
	        this.windowCreationInterval = windowCreationInterval;
	        this.maxWindowSize = maxWindowSize;
	        this.scheduler = scheduler;
	        this.windows = [];
	        var window = this.openWindow();
	        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
	            var closeState = { subscriber: this, window: window, context: null };
	            var creationState = { windowTimeSpan: windowTimeSpan, windowCreationInterval: windowCreationInterval, subscriber: this, scheduler: scheduler };
	            this.add(scheduler.schedule(dispatchWindowClose, windowTimeSpan, closeState));
	            this.add(scheduler.schedule(dispatchWindowCreation, windowCreationInterval, creationState));
	        }
	        else {
	            var timeSpanOnlyState = { subscriber: this, window: window, windowTimeSpan: windowTimeSpan };
	            this.add(scheduler.schedule(dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
	        }
	    }
	    WindowTimeSubscriber.prototype._next = function (value) {
	        var windows = this.windows;
	        var len = windows.length;
	        for (var i = 0; i < len; i++) {
	            var window_1 = windows[i];
	            if (!window_1.closed) {
	                window_1.next(value);
	                if (window_1.numberOfNextedValues >= this.maxWindowSize) {
	                    this.closeWindow(window_1);
	                }
	            }
	        }
	    };
	    WindowTimeSubscriber.prototype._error = function (err) {
	        var windows = this.windows;
	        while (windows.length > 0) {
	            windows.shift().error(err);
	        }
	        this.destination.error(err);
	    };
	    WindowTimeSubscriber.prototype._complete = function () {
	        var windows = this.windows;
	        while (windows.length > 0) {
	            var window_2 = windows.shift();
	            if (!window_2.closed) {
	                window_2.complete();
	            }
	        }
	        this.destination.complete();
	    };
	    WindowTimeSubscriber.prototype.openWindow = function () {
	        var window = new CountedSubject();
	        this.windows.push(window);
	        var destination = this.destination;
	        destination.next(window);
	        return window;
	    };
	    WindowTimeSubscriber.prototype.closeWindow = function (window) {
	        window.complete();
	        var windows = this.windows;
	        windows.splice(windows.indexOf(window), 1);
	    };
	    return WindowTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchWindowTimeSpanOnly(state) {
	    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
	    if (window) {
	        subscriber.closeWindow(window);
	    }
	    state.window = subscriber.openWindow();
	    this.schedule(state, windowTimeSpan);
	}
	function dispatchWindowCreation(state) {
	    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
	    var window = subscriber.openWindow();
	    var action = this;
	    var context = { action: action, subscription: null };
	    var timeSpanState = { subscriber: subscriber, window: window, context: context };
	    context.subscription = scheduler.schedule(dispatchWindowClose, windowTimeSpan, timeSpanState);
	    action.add(context.subscription);
	    action.schedule(state, windowCreationInterval);
	}
	function dispatchWindowClose(state) {
	    var subscriber = state.subscriber, window = state.window, context = state.context;
	    if (context && context.action && context.subscription) {
	        context.action.remove(context.subscription);
	    }
	    subscriber.closeWindow(window);
	}
	//# sourceMappingURL=windowTime.js.map

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var windowToggle_1 = __webpack_require__(656);
	Observable_1.Observable.prototype.windowToggle = windowToggle_1.windowToggle;
	//# sourceMappingURL=windowToggle.js.map

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var windowToggle_1 = __webpack_require__(657);
	/**
	 * Branch out the source Observable values as a nested Observable starting from
	 * an emission from `openings` and ending when the output of `closingSelector`
	 * emits.
	 *
	 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowToggle.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits windows that contain those items
	 * emitted by the source Observable between the time when the `openings`
	 * Observable emits an item and when the Observable returned by
	 * `closingSelector` emits an item.
	 *
	 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var openings = Rx.Observable.interval(1000);
	 * var result = clicks.windowToggle(openings, i =>
	 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
	 * ).mergeAll();
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowCount}
	 * @see {@link windowTime}
	 * @see {@link windowWhen}
	 * @see {@link bufferToggle}
	 *
	 * @param {Observable<O>} openings An observable of notifications to start new
	 * windows.
	 * @param {function(value: O): Observable} closingSelector A function that takes
	 * the value emitted by the `openings` observable and returns an Observable,
	 * which, when it emits (either `next` or `complete`), signals that the
	 * associated window should complete.
	 * @return {Observable<Observable<T>>} An observable of windows, which in turn
	 * are Observables.
	 * @method windowToggle
	 * @owner Observable
	 */
	function windowToggle(openings, closingSelector) {
	    return windowToggle_1.windowToggle(openings, closingSelector)(this);
	}
	exports.windowToggle = windowToggle;
	//# sourceMappingURL=windowToggle.js.map

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(240);
	var Subscription_1 = __webpack_require__(211);
	var tryCatch_1 = __webpack_require__(214);
	var errorObject_1 = __webpack_require__(215);
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/**
	 * Branch out the source Observable values as a nested Observable starting from
	 * an emission from `openings` and ending when the output of `closingSelector`
	 * emits.
	 *
	 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowToggle.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits windows that contain those items
	 * emitted by the source Observable between the time when the `openings`
	 * Observable emits an item and when the Observable returned by
	 * `closingSelector` emits an item.
	 *
	 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var openings = Rx.Observable.interval(1000);
	 * var result = clicks.windowToggle(openings, i =>
	 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
	 * ).mergeAll();
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowCount}
	 * @see {@link windowTime}
	 * @see {@link windowWhen}
	 * @see {@link bufferToggle}
	 *
	 * @param {Observable<O>} openings An observable of notifications to start new
	 * windows.
	 * @param {function(value: O): Observable} closingSelector A function that takes
	 * the value emitted by the `openings` observable and returns an Observable,
	 * which, when it emits (either `next` or `complete`), signals that the
	 * associated window should complete.
	 * @return {Observable<Observable<T>>} An observable of windows, which in turn
	 * are Observables.
	 * @method windowToggle
	 * @owner Observable
	 */
	function windowToggle(openings, closingSelector) {
	    return function (source) { return source.lift(new WindowToggleOperator(openings, closingSelector)); };
	}
	exports.windowToggle = windowToggle;
	var WindowToggleOperator = (function () {
	    function WindowToggleOperator(openings, closingSelector) {
	        this.openings = openings;
	        this.closingSelector = closingSelector;
	    }
	    WindowToggleOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
	    };
	    return WindowToggleOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WindowToggleSubscriber = (function (_super) {
	    __extends(WindowToggleSubscriber, _super);
	    function WindowToggleSubscriber(destination, openings, closingSelector) {
	        _super.call(this, destination);
	        this.openings = openings;
	        this.closingSelector = closingSelector;
	        this.contexts = [];
	        this.add(this.openSubscription = subscribeToResult_1.subscribeToResult(this, openings, openings));
	    }
	    WindowToggleSubscriber.prototype._next = function (value) {
	        var contexts = this.contexts;
	        if (contexts) {
	            var len = contexts.length;
	            for (var i = 0; i < len; i++) {
	                contexts[i].window.next(value);
	            }
	        }
	    };
	    WindowToggleSubscriber.prototype._error = function (err) {
	        var contexts = this.contexts;
	        this.contexts = null;
	        if (contexts) {
	            var len = contexts.length;
	            var index = -1;
	            while (++index < len) {
	                var context = contexts[index];
	                context.window.error(err);
	                context.subscription.unsubscribe();
	            }
	        }
	        _super.prototype._error.call(this, err);
	    };
	    WindowToggleSubscriber.prototype._complete = function () {
	        var contexts = this.contexts;
	        this.contexts = null;
	        if (contexts) {
	            var len = contexts.length;
	            var index = -1;
	            while (++index < len) {
	                var context = contexts[index];
	                context.window.complete();
	                context.subscription.unsubscribe();
	            }
	        }
	        _super.prototype._complete.call(this);
	    };
	    /** @deprecated internal use only */ WindowToggleSubscriber.prototype._unsubscribe = function () {
	        var contexts = this.contexts;
	        this.contexts = null;
	        if (contexts) {
	            var len = contexts.length;
	            var index = -1;
	            while (++index < len) {
	                var context = contexts[index];
	                context.window.unsubscribe();
	                context.subscription.unsubscribe();
	            }
	        }
	    };
	    WindowToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        if (outerValue === this.openings) {
	            var closingSelector = this.closingSelector;
	            var closingNotifier = tryCatch_1.tryCatch(closingSelector)(innerValue);
	            if (closingNotifier === errorObject_1.errorObject) {
	                return this.error(errorObject_1.errorObject.e);
	            }
	            else {
	                var window_1 = new Subject_1.Subject();
	                var subscription = new Subscription_1.Subscription();
	                var context = { window: window_1, subscription: subscription };
	                this.contexts.push(context);
	                var innerSubscription = subscribeToResult_1.subscribeToResult(this, closingNotifier, context);
	                if (innerSubscription.closed) {
	                    this.closeWindow(this.contexts.length - 1);
	                }
	                else {
	                    innerSubscription.context = context;
	                    subscription.add(innerSubscription);
	                }
	                this.destination.next(window_1);
	            }
	        }
	        else {
	            this.closeWindow(this.contexts.indexOf(outerValue));
	        }
	    };
	    WindowToggleSubscriber.prototype.notifyError = function (err) {
	        this.error(err);
	    };
	    WindowToggleSubscriber.prototype.notifyComplete = function (inner) {
	        if (inner !== this.openSubscription) {
	            this.closeWindow(this.contexts.indexOf(inner.context));
	        }
	    };
	    WindowToggleSubscriber.prototype.closeWindow = function (index) {
	        if (index === -1) {
	            return;
	        }
	        var contexts = this.contexts;
	        var context = contexts[index];
	        var window = context.window, subscription = context.subscription;
	        contexts.splice(index, 1);
	        window.complete();
	        subscription.unsubscribe();
	    };
	    return WindowToggleSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=windowToggle.js.map

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var windowWhen_1 = __webpack_require__(659);
	Observable_1.Observable.prototype.windowWhen = windowWhen_1.windowWhen;
	//# sourceMappingURL=windowWhen.js.map

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var windowWhen_1 = __webpack_require__(660);
	/**
	 * Branch out the source Observable values as a nested Observable using a
	 * factory function of closing Observables to determine when to start a new
	 * window.
	 *
	 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowWhen.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits connected, non-overlapping windows.
	 * It emits the current window and opens a new one whenever the Observable
	 * produced by the specified `closingSelector` function emits an item. The first
	 * window is opened immediately when subscribing to the output Observable.
	 *
	 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks
	 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
	 *   .map(win => win.take(2)) // each window has at most 2 emissions
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowCount}
	 * @see {@link windowTime}
	 * @see {@link windowToggle}
	 * @see {@link bufferWhen}
	 *
	 * @param {function(): Observable} closingSelector A function that takes no
	 * arguments and returns an Observable that signals (on either `next` or
	 * `complete`) when to close the previous window and start a new one.
	 * @return {Observable<Observable<T>>} An observable of windows, which in turn
	 * are Observables.
	 * @method windowWhen
	 * @owner Observable
	 */
	function windowWhen(closingSelector) {
	    return windowWhen_1.windowWhen(closingSelector)(this);
	}
	exports.windowWhen = windowWhen;
	//# sourceMappingURL=windowWhen.js.map

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(240);
	var tryCatch_1 = __webpack_require__(214);
	var errorObject_1 = __webpack_require__(215);
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/**
	 * Branch out the source Observable values as a nested Observable using a
	 * factory function of closing Observables to determine when to start a new
	 * window.
	 *
	 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowWhen.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits connected, non-overlapping windows.
	 * It emits the current window and opens a new one whenever the Observable
	 * produced by the specified `closingSelector` function emits an item. The first
	 * window is opened immediately when subscribing to the output Observable.
	 *
	 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks
	 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
	 *   .map(win => win.take(2)) // each window has at most 2 emissions
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowCount}
	 * @see {@link windowTime}
	 * @see {@link windowToggle}
	 * @see {@link bufferWhen}
	 *
	 * @param {function(): Observable} closingSelector A function that takes no
	 * arguments and returns an Observable that signals (on either `next` or
	 * `complete`) when to close the previous window and start a new one.
	 * @return {Observable<Observable<T>>} An observable of windows, which in turn
	 * are Observables.
	 * @method windowWhen
	 * @owner Observable
	 */
	function windowWhen(closingSelector) {
	    return function windowWhenOperatorFunction(source) {
	        return source.lift(new WindowOperator(closingSelector));
	    };
	}
	exports.windowWhen = windowWhen;
	var WindowOperator = (function () {
	    function WindowOperator(closingSelector) {
	        this.closingSelector = closingSelector;
	    }
	    WindowOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WindowSubscriber(subscriber, this.closingSelector));
	    };
	    return WindowOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WindowSubscriber = (function (_super) {
	    __extends(WindowSubscriber, _super);
	    function WindowSubscriber(destination, closingSelector) {
	        _super.call(this, destination);
	        this.destination = destination;
	        this.closingSelector = closingSelector;
	        this.openWindow();
	    }
	    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.openWindow(innerSub);
	    };
	    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
	        this._error(error);
	    };
	    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.openWindow(innerSub);
	    };
	    WindowSubscriber.prototype._next = function (value) {
	        this.window.next(value);
	    };
	    WindowSubscriber.prototype._error = function (err) {
	        this.window.error(err);
	        this.destination.error(err);
	        this.unsubscribeClosingNotification();
	    };
	    WindowSubscriber.prototype._complete = function () {
	        this.window.complete();
	        this.destination.complete();
	        this.unsubscribeClosingNotification();
	    };
	    WindowSubscriber.prototype.unsubscribeClosingNotification = function () {
	        if (this.closingNotification) {
	            this.closingNotification.unsubscribe();
	        }
	    };
	    WindowSubscriber.prototype.openWindow = function (innerSub) {
	        if (innerSub === void 0) { innerSub = null; }
	        if (innerSub) {
	            this.remove(innerSub);
	            innerSub.unsubscribe();
	        }
	        var prevWindow = this.window;
	        if (prevWindow) {
	            prevWindow.complete();
	        }
	        var window = this.window = new Subject_1.Subject();
	        this.destination.next(window);
	        var closingNotifier = tryCatch_1.tryCatch(this.closingSelector)();
	        if (closingNotifier === errorObject_1.errorObject) {
	            var err = errorObject_1.errorObject.e;
	            this.destination.error(err);
	            this.window.error(err);
	        }
	        else {
	            this.add(this.closingNotification = subscribeToResult_1.subscribeToResult(this, closingNotifier));
	        }
	    };
	    return WindowSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=windowWhen.js.map

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var withLatestFrom_1 = __webpack_require__(662);
	Observable_1.Observable.prototype.withLatestFrom = withLatestFrom_1.withLatestFrom;
	//# sourceMappingURL=withLatestFrom.js.map

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var withLatestFrom_1 = __webpack_require__(663);
	/* tslint:enable:max-line-length */
	/**
	 * Combines the source Observable with other Observables to create an Observable
	 * whose values are calculated from the latest values of each, only when the
	 * source emits.
	 *
	 * <span class="informal">Whenever the source Observable emits a value, it
	 * computes a formula using that value plus the latest values from other input
	 * Observables, then emits the output of that formula.</span>
	 *
	 * <img src="./img/withLatestFrom.png" width="100%">
	 *
	 * `withLatestFrom` combines each value from the source Observable (the
	 * instance) with the latest values from the other input Observables only when
	 * the source emits a value, optionally using a `project` function to determine
	 * the value to be emitted on the output Observable. All input Observables must
	 * emit at least one value before the output Observable will emit a value.
	 *
	 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var timer = Rx.Observable.interval(1000);
	 * var result = clicks.withLatestFrom(timer);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link combineLatest}
	 *
	 * @param {ObservableInput} other An input Observable to combine with the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {Function} [project] Projection function for combining values
	 * together. Receives all values in order of the Observables passed, where the
	 * first parameter is a value from the source Observable. (e.g.
	 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
	 * passed, arrays will be emitted on the output Observable.
	 * @return {Observable} An Observable of projected values from the most recent
	 * values from each input Observable, or an array of the most recent values from
	 * each input Observable.
	 * @method withLatestFrom
	 * @owner Observable
	 */
	function withLatestFrom() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i - 0] = arguments[_i];
	    }
	    return withLatestFrom_1.withLatestFrom.apply(void 0, args)(this);
	}
	exports.withLatestFrom = withLatestFrom;
	//# sourceMappingURL=withLatestFrom.js.map

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(234);
	var subscribeToResult_1 = __webpack_require__(229);
	/* tslint:enable:max-line-length */
	/**
	 * Combines the source Observable with other Observables to create an Observable
	 * whose values are calculated from the latest values of each, only when the
	 * source emits.
	 *
	 * <span class="informal">Whenever the source Observable emits a value, it
	 * computes a formula using that value plus the latest values from other input
	 * Observables, then emits the output of that formula.</span>
	 *
	 * <img src="./img/withLatestFrom.png" width="100%">
	 *
	 * `withLatestFrom` combines each value from the source Observable (the
	 * instance) with the latest values from the other input Observables only when
	 * the source emits a value, optionally using a `project` function to determine
	 * the value to be emitted on the output Observable. All input Observables must
	 * emit at least one value before the output Observable will emit a value.
	 *
	 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var timer = Rx.Observable.interval(1000);
	 * var result = clicks.withLatestFrom(timer);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link combineLatest}
	 *
	 * @param {ObservableInput} other An input Observable to combine with the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {Function} [project] Projection function for combining values
	 * together. Receives all values in order of the Observables passed, where the
	 * first parameter is a value from the source Observable. (e.g.
	 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
	 * passed, arrays will be emitted on the output Observable.
	 * @return {Observable} An Observable of projected values from the most recent
	 * values from each input Observable, or an array of the most recent values from
	 * each input Observable.
	 * @method withLatestFrom
	 * @owner Observable
	 */
	function withLatestFrom() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i - 0] = arguments[_i];
	    }
	    return function (source) {
	        var project;
	        if (typeof args[args.length - 1] === 'function') {
	            project = args.pop();
	        }
	        var observables = args;
	        return source.lift(new WithLatestFromOperator(observables, project));
	    };
	}
	exports.withLatestFrom = withLatestFrom;
	var WithLatestFromOperator = (function () {
	    function WithLatestFromOperator(observables, project) {
	        this.observables = observables;
	        this.project = project;
	    }
	    WithLatestFromOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WithLatestFromSubscriber(subscriber, this.observables, this.project));
	    };
	    return WithLatestFromOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WithLatestFromSubscriber = (function (_super) {
	    __extends(WithLatestFromSubscriber, _super);
	    function WithLatestFromSubscriber(destination, observables, project) {
	        _super.call(this, destination);
	        this.observables = observables;
	        this.project = project;
	        this.toRespond = [];
	        var len = observables.length;
	        this.values = new Array(len);
	        for (var i = 0; i < len; i++) {
	            this.toRespond.push(i);
	        }
	        for (var i = 0; i < len; i++) {
	            var observable = observables[i];
	            this.add(subscribeToResult_1.subscribeToResult(this, observable, observable, i));
	        }
	    }
	    WithLatestFromSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.values[outerIndex] = innerValue;
	        var toRespond = this.toRespond;
	        if (toRespond.length > 0) {
	            var found = toRespond.indexOf(outerIndex);
	            if (found !== -1) {
	                toRespond.splice(found, 1);
	            }
	        }
	    };
	    WithLatestFromSubscriber.prototype.notifyComplete = function () {
	        // noop
	    };
	    WithLatestFromSubscriber.prototype._next = function (value) {
	        if (this.toRespond.length === 0) {
	            var args = [value].concat(this.values);
	            if (this.project) {
	                this._tryProject(args);
	            }
	            else {
	                this.destination.next(args);
	            }
	        }
	    };
	    WithLatestFromSubscriber.prototype._tryProject = function (args) {
	        var result;
	        try {
	            result = this.project.apply(this, args);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return WithLatestFromSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=withLatestFrom.js.map

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var zip_1 = __webpack_require__(665);
	Observable_1.Observable.prototype.zip = zip_1.zipProto;
	//# sourceMappingURL=zip.js.map

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var zip_1 = __webpack_require__(376);
	/* tslint:enable:max-line-length */
	/**
	 * @param observables
	 * @return {Observable<R>}
	 * @method zip
	 * @owner Observable
	 */
	function zipProto() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return zip_1.zip.apply(void 0, observables)(this);
	}
	exports.zipProto = zipProto;
	//# sourceMappingURL=zip.js.map

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(206);
	var zipAll_1 = __webpack_require__(667);
	Observable_1.Observable.prototype.zipAll = zipAll_1.zipAll;
	//# sourceMappingURL=zipAll.js.map

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var zipAll_1 = __webpack_require__(668);
	/**
	 * @param project
	 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
	 * @method zipAll
	 * @owner Observable
	 */
	function zipAll(project) {
	    return zipAll_1.zipAll(project)(this);
	}
	exports.zipAll = zipAll;
	//# sourceMappingURL=zipAll.js.map

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var zip_1 = __webpack_require__(376);
	function zipAll(project) {
	    return function (source) { return source.lift(new zip_1.ZipOperator(project)); };
	}
	exports.zipAll = zipAll;
	//# sourceMappingURL=zipAll.js.map

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(206);
	var Notification_1 = __webpack_require__(282);
	var ColdObservable_1 = __webpack_require__(670);
	var HotObservable_1 = __webpack_require__(674);
	var SubscriptionLog_1 = __webpack_require__(672);
	var VirtualTimeScheduler_1 = __webpack_require__(675);
	var defaultMaxFrame = 750;
	var TestScheduler = (function (_super) {
	    __extends(TestScheduler, _super);
	    function TestScheduler(assertDeepEqual) {
	        _super.call(this, VirtualTimeScheduler_1.VirtualAction, defaultMaxFrame);
	        this.assertDeepEqual = assertDeepEqual;
	        this.hotObservables = [];
	        this.coldObservables = [];
	        this.flushTests = [];
	    }
	    TestScheduler.prototype.createTime = function (marbles) {
	        var indexOf = marbles.indexOf('|');
	        if (indexOf === -1) {
	            throw new Error('marble diagram for time should have a completion marker "|"');
	        }
	        return indexOf * TestScheduler.frameTimeFactor;
	    };
	    TestScheduler.prototype.createColdObservable = function (marbles, values, error) {
	        if (marbles.indexOf('^') !== -1) {
	            throw new Error('cold observable cannot have subscription offset "^"');
	        }
	        if (marbles.indexOf('!') !== -1) {
	            throw new Error('cold observable cannot have unsubscription marker "!"');
	        }
	        var messages = TestScheduler.parseMarbles(marbles, values, error);
	        var cold = new ColdObservable_1.ColdObservable(messages, this);
	        this.coldObservables.push(cold);
	        return cold;
	    };
	    TestScheduler.prototype.createHotObservable = function (marbles, values, error) {
	        if (marbles.indexOf('!') !== -1) {
	            throw new Error('hot observable cannot have unsubscription marker "!"');
	        }
	        var messages = TestScheduler.parseMarbles(marbles, values, error);
	        var subject = new HotObservable_1.HotObservable(messages, this);
	        this.hotObservables.push(subject);
	        return subject;
	    };
	    TestScheduler.prototype.materializeInnerObservable = function (observable, outerFrame) {
	        var _this = this;
	        var messages = [];
	        observable.subscribe(function (value) {
	            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createNext(value) });
	        }, function (err) {
	            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createError(err) });
	        }, function () {
	            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createComplete() });
	        });
	        return messages;
	    };
	    TestScheduler.prototype.expectObservable = function (observable, unsubscriptionMarbles) {
	        var _this = this;
	        if (unsubscriptionMarbles === void 0) { unsubscriptionMarbles = null; }
	        var actual = [];
	        var flushTest = { actual: actual, ready: false };
	        var unsubscriptionFrame = TestScheduler
	            .parseMarblesAsSubscriptions(unsubscriptionMarbles).unsubscribedFrame;
	        var subscription;
	        this.schedule(function () {
	            subscription = observable.subscribe(function (x) {
	                var value = x;
	                // Support Observable-of-Observables
	                if (x instanceof Observable_1.Observable) {
	                    value = _this.materializeInnerObservable(value, _this.frame);
	                }
	                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createNext(value) });
	            }, function (err) {
	                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createError(err) });
	            }, function () {
	                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createComplete() });
	            });
	        }, 0);
	        if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) {
	            this.schedule(function () { return subscription.unsubscribe(); }, unsubscriptionFrame);
	        }
	        this.flushTests.push(flushTest);
	        return {
	            toBe: function (marbles, values, errorValue) {
	                flushTest.ready = true;
	                flushTest.expected = TestScheduler.parseMarbles(marbles, values, errorValue, true);
	            }
	        };
	    };
	    TestScheduler.prototype.expectSubscriptions = function (actualSubscriptionLogs) {
	        var flushTest = { actual: actualSubscriptionLogs, ready: false };
	        this.flushTests.push(flushTest);
	        return {
	            toBe: function (marbles) {
	                var marblesArray = (typeof marbles === 'string') ? [marbles] : marbles;
	                flushTest.ready = true;
	                flushTest.expected = marblesArray.map(function (marbles) {
	                    return TestScheduler.parseMarblesAsSubscriptions(marbles);
	                });
	            }
	        };
	    };
	    TestScheduler.prototype.flush = function () {
	        var hotObservables = this.hotObservables;
	        while (hotObservables.length > 0) {
	            hotObservables.shift().setup();
	        }
	        _super.prototype.flush.call(this);
	        var readyFlushTests = this.flushTests.filter(function (test) { return test.ready; });
	        while (readyFlushTests.length > 0) {
	            var test = readyFlushTests.shift();
	            this.assertDeepEqual(test.actual, test.expected);
	        }
	    };
	    TestScheduler.parseMarblesAsSubscriptions = function (marbles) {
	        if (typeof marbles !== 'string') {
	            return new SubscriptionLog_1.SubscriptionLog(Number.POSITIVE_INFINITY);
	        }
	        var len = marbles.length;
	        var groupStart = -1;
	        var subscriptionFrame = Number.POSITIVE_INFINITY;
	        var unsubscriptionFrame = Number.POSITIVE_INFINITY;
	        for (var i = 0; i < len; i++) {
	            var frame = i * this.frameTimeFactor;
	            var c = marbles[i];
	            switch (c) {
	                case '-':
	                case ' ':
	                    break;
	                case '(':
	                    groupStart = frame;
	                    break;
	                case ')':
	                    groupStart = -1;
	                    break;
	                case '^':
	                    if (subscriptionFrame !== Number.POSITIVE_INFINITY) {
	                        throw new Error('found a second subscription point \'^\' in a ' +
	                            'subscription marble diagram. There can only be one.');
	                    }
	                    subscriptionFrame = groupStart > -1 ? groupStart : frame;
	                    break;
	                case '!':
	                    if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) {
	                        throw new Error('found a second subscription point \'^\' in a ' +
	                            'subscription marble diagram. There can only be one.');
	                    }
	                    unsubscriptionFrame = groupStart > -1 ? groupStart : frame;
	                    break;
	                default:
	                    throw new Error('there can only be \'^\' and \'!\' markers in a ' +
	                        'subscription marble diagram. Found instead \'' + c + '\'.');
	            }
	        }
	        if (unsubscriptionFrame < 0) {
	            return new SubscriptionLog_1.SubscriptionLog(subscriptionFrame);
	        }
	        else {
	            return new SubscriptionLog_1.SubscriptionLog(subscriptionFrame, unsubscriptionFrame);
	        }
	    };
	    TestScheduler.parseMarbles = function (marbles, values, errorValue, materializeInnerObservables) {
	        if (materializeInnerObservables === void 0) { materializeInnerObservables = false; }
	        if (marbles.indexOf('!') !== -1) {
	            throw new Error('conventional marble diagrams cannot have the ' +
	                'unsubscription marker "!"');
	        }
	        var len = marbles.length;
	        var testMessages = [];
	        var subIndex = marbles.indexOf('^');
	        var frameOffset = subIndex === -1 ? 0 : (subIndex * -this.frameTimeFactor);
	        var getValue = typeof values !== 'object' ?
	            function (x) { return x; } :
	            function (x) {
	                // Support Observable-of-Observables
	                if (materializeInnerObservables && values[x] instanceof ColdObservable_1.ColdObservable) {
	                    return values[x].messages;
	                }
	                return values[x];
	            };
	        var groupStart = -1;
	        for (var i = 0; i < len; i++) {
	            var frame = i * this.frameTimeFactor + frameOffset;
	            var notification = void 0;
	            var c = marbles[i];
	            switch (c) {
	                case '-':
	                case ' ':
	                    break;
	                case '(':
	                    groupStart = frame;
	                    break;
	                case ')':
	                    groupStart = -1;
	                    break;
	                case '|':
	                    notification = Notification_1.Notification.createComplete();
	                    break;
	                case '^':
	                    break;
	                case '#':
	                    notification = Notification_1.Notification.createError(errorValue || 'error');
	                    break;
	                default:
	                    notification = Notification_1.Notification.createNext(getValue(c));
	                    break;
	            }
	            if (notification) {
	                testMessages.push({ frame: groupStart > -1 ? groupStart : frame, notification: notification });
	            }
	        }
	        return testMessages;
	    };
	    return TestScheduler;
	}(VirtualTimeScheduler_1.VirtualTimeScheduler));
	exports.TestScheduler = TestScheduler;
	//# sourceMappingURL=TestScheduler.js.map

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(206);
	var Subscription_1 = __webpack_require__(211);
	var SubscriptionLoggable_1 = __webpack_require__(671);
	var applyMixins_1 = __webpack_require__(673);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ColdObservable = (function (_super) {
	    __extends(ColdObservable, _super);
	    function ColdObservable(messages, scheduler) {
	        _super.call(this, function (subscriber) {
	            var observable = this;
	            var index = observable.logSubscribedFrame();
	            subscriber.add(new Subscription_1.Subscription(function () {
	                observable.logUnsubscribedFrame(index);
	            }));
	            observable.scheduleMessages(subscriber);
	            return subscriber;
	        });
	        this.messages = messages;
	        this.subscriptions = [];
	        this.scheduler = scheduler;
	    }
	    ColdObservable.prototype.scheduleMessages = function (subscriber) {
	        var messagesLength = this.messages.length;
	        for (var i = 0; i < messagesLength; i++) {
	            var message = this.messages[i];
	            subscriber.add(this.scheduler.schedule(function (_a) {
	                var message = _a.message, subscriber = _a.subscriber;
	                message.notification.observe(subscriber);
	            }, message.frame, { message: message, subscriber: subscriber }));
	        }
	    };
	    return ColdObservable;
	}(Observable_1.Observable));
	exports.ColdObservable = ColdObservable;
	applyMixins_1.applyMixins(ColdObservable, [SubscriptionLoggable_1.SubscriptionLoggable]);
	//# sourceMappingURL=ColdObservable.js.map

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var SubscriptionLog_1 = __webpack_require__(672);
	var SubscriptionLoggable = (function () {
	    function SubscriptionLoggable() {
	        this.subscriptions = [];
	    }
	    SubscriptionLoggable.prototype.logSubscribedFrame = function () {
	        this.subscriptions.push(new SubscriptionLog_1.SubscriptionLog(this.scheduler.now()));
	        return this.subscriptions.length - 1;
	    };
	    SubscriptionLoggable.prototype.logUnsubscribedFrame = function (index) {
	        var subscriptionLogs = this.subscriptions;
	        var oldSubscriptionLog = subscriptionLogs[index];
	        subscriptionLogs[index] = new SubscriptionLog_1.SubscriptionLog(oldSubscriptionLog.subscribedFrame, this.scheduler.now());
	    };
	    return SubscriptionLoggable;
	}());
	exports.SubscriptionLoggable = SubscriptionLoggable;
	//# sourceMappingURL=SubscriptionLoggable.js.map

/***/ }),
/* 672 */
/***/ (function(module, exports) {

	"use strict";
	var SubscriptionLog = (function () {
	    function SubscriptionLog(subscribedFrame, unsubscribedFrame) {
	        if (unsubscribedFrame === void 0) { unsubscribedFrame = Number.POSITIVE_INFINITY; }
	        this.subscribedFrame = subscribedFrame;
	        this.unsubscribedFrame = unsubscribedFrame;
	    }
	    return SubscriptionLog;
	}());
	exports.SubscriptionLog = SubscriptionLog;
	//# sourceMappingURL=SubscriptionLog.js.map

/***/ }),
/* 673 */
/***/ (function(module, exports) {

	"use strict";
	function applyMixins(derivedCtor, baseCtors) {
	    for (var i = 0, len = baseCtors.length; i < len; i++) {
	        var baseCtor = baseCtors[i];
	        var propertyKeys = Object.getOwnPropertyNames(baseCtor.prototype);
	        for (var j = 0, len2 = propertyKeys.length; j < len2; j++) {
	            var name_1 = propertyKeys[j];
	            derivedCtor.prototype[name_1] = baseCtor.prototype[name_1];
	        }
	    }
	}
	exports.applyMixins = applyMixins;
	//# sourceMappingURL=applyMixins.js.map

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(240);
	var Subscription_1 = __webpack_require__(211);
	var SubscriptionLoggable_1 = __webpack_require__(671);
	var applyMixins_1 = __webpack_require__(673);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var HotObservable = (function (_super) {
	    __extends(HotObservable, _super);
	    function HotObservable(messages, scheduler) {
	        _super.call(this);
	        this.messages = messages;
	        this.subscriptions = [];
	        this.scheduler = scheduler;
	    }
	    /** @deprecated internal use only */ HotObservable.prototype._subscribe = function (subscriber) {
	        var subject = this;
	        var index = subject.logSubscribedFrame();
	        subscriber.add(new Subscription_1.Subscription(function () {
	            subject.logUnsubscribedFrame(index);
	        }));
	        return _super.prototype._subscribe.call(this, subscriber);
	    };
	    HotObservable.prototype.setup = function () {
	        var subject = this;
	        var messagesLength = subject.messages.length;
	        /* tslint:disable:no-var-keyword */
	        for (var i = 0; i < messagesLength; i++) {
	            (function () {
	                var message = subject.messages[i];
	                /* tslint:enable */
	                subject.scheduler.schedule(function () { message.notification.observe(subject); }, message.frame);
	            })();
	        }
	    };
	    return HotObservable;
	}(Subject_1.Subject));
	exports.HotObservable = HotObservable;
	applyMixins_1.applyMixins(HotObservable, [SubscriptionLoggable_1.SubscriptionLoggable]);
	//# sourceMappingURL=HotObservable.js.map

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncAction_1 = __webpack_require__(344);
	var AsyncScheduler_1 = __webpack_require__(346);
	var VirtualTimeScheduler = (function (_super) {
	    __extends(VirtualTimeScheduler, _super);
	    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
	        var _this = this;
	        if (SchedulerAction === void 0) { SchedulerAction = VirtualAction; }
	        if (maxFrames === void 0) { maxFrames = Number.POSITIVE_INFINITY; }
	        _super.call(this, SchedulerAction, function () { return _this.frame; });
	        this.maxFrames = maxFrames;
	        this.frame = 0;
	        this.index = -1;
	    }
	    /**
	     * Prompt the Scheduler to execute all of its queued actions, therefore
	     * clearing its queue.
	     * @return {void}
	     */
	    VirtualTimeScheduler.prototype.flush = function () {
	        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
	        var error, action;
	        while ((action = actions.shift()) && (this.frame = action.delay) <= maxFrames) {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        }
	        if (error) {
	            while (action = actions.shift()) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    VirtualTimeScheduler.frameTimeFactor = 10;
	    return VirtualTimeScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.VirtualTimeScheduler = VirtualTimeScheduler;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var VirtualAction = (function (_super) {
	    __extends(VirtualAction, _super);
	    function VirtualAction(scheduler, work, index) {
	        if (index === void 0) { index = scheduler.index += 1; }
	        _super.call(this, scheduler, work);
	        this.scheduler = scheduler;
	        this.work = work;
	        this.index = index;
	        this.active = true;
	        this.index = scheduler.index = index;
	    }
	    VirtualAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (!this.id) {
	            return _super.prototype.schedule.call(this, state, delay);
	        }
	        this.active = false;
	        // If an action is rescheduled, we save allocations by mutating its state,
	        // pushing it to the end of the scheduler queue, and recycling the action.
	        // But since the VirtualTimeScheduler is used for testing, VirtualActions
	        // must be immutable so they can be inspected later.
	        var action = new VirtualAction(this.scheduler, this.work);
	        this.add(action);
	        return action.schedule(state, delay);
	    };
	    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        this.delay = scheduler.frame + delay;
	        var actions = scheduler.actions;
	        actions.push(this);
	        actions.sort(VirtualAction.sortActions);
	        return true;
	    };
	    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        return undefined;
	    };
	    VirtualAction.prototype._execute = function (state, delay) {
	        if (this.active === true) {
	            return _super.prototype._execute.call(this, state, delay);
	        }
	    };
	    VirtualAction.sortActions = function (a, b) {
	        if (a.delay === b.delay) {
	            if (a.index === b.index) {
	                return 0;
	            }
	            else if (a.index > b.index) {
	                return 1;
	            }
	            else {
	                return -1;
	            }
	        }
	        else if (a.delay > b.delay) {
	            return 1;
	        }
	        else {
	            return -1;
	        }
	    };
	    return VirtualAction;
	}(AsyncAction_1.AsyncAction));
	exports.VirtualAction = VirtualAction;
	//# sourceMappingURL=VirtualTimeScheduler.js.map

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var AnimationFrameAction_1 = __webpack_require__(677);
	var AnimationFrameScheduler_1 = __webpack_require__(679);
	/**
	 *
	 * Animation Frame Scheduler
	 *
	 * <span class="informal">Perform task when `window.requestAnimationFrame` would fire</span>
	 *
	 * When `animationFrame` scheduler is used with delay, it will fall back to {@link async} scheduler
	 * behaviour.
	 *
	 * Without delay, `animationFrame` scheduler can be used to create smooth browser animations.
	 * It makes sure scheduled task will happen just before next browser content repaint,
	 * thus performing animations as efficiently as possible.
	 *
	 * @example <caption>Schedule div height animation</caption>
	 * const div = document.querySelector('.some-div');
	 *
	 * Rx.Scheduler.schedule(function(height) {
	 *   div.style.height = height + "px";
	 *
	 *   this.schedule(height + 1);  // `this` references currently executing Action,
	 *                               // which we reschedule with new state
	 * }, 0, 0);
	 *
	 * // You will see .some-div element growing in height
	 *
	 *
	 * @static true
	 * @name animationFrame
	 * @owner Scheduler
	 */
	exports.animationFrame = new AnimationFrameScheduler_1.AnimationFrameScheduler(AnimationFrameAction_1.AnimationFrameAction);
	//# sourceMappingURL=animationFrame.js.map

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncAction_1 = __webpack_require__(344);
	var AnimationFrame_1 = __webpack_require__(678);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AnimationFrameAction = (function (_super) {
	    __extends(AnimationFrameAction, _super);
	    function AnimationFrameAction(scheduler, work) {
	        _super.call(this, scheduler, work);
	        this.scheduler = scheduler;
	        this.work = work;
	    }
	    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If delay is greater than 0, request as an async action.
	        if (delay !== null && delay > 0) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        // Push the action to the end of the scheduler queue.
	        scheduler.actions.push(this);
	        // If an animation frame has already been requested, don't request another
	        // one. If an animation frame hasn't been requested yet, request one. Return
	        // the current animation frame request id.
	        return scheduler.scheduled || (scheduler.scheduled = AnimationFrame_1.AnimationFrame.requestAnimationFrame(scheduler.flush.bind(scheduler, null)));
	    };
	    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If delay exists and is greater than 0, or if the delay is null (the
	        // action wasn't rescheduled) but was originally scheduled as an async
	        // action, then recycle as an async action.
	        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
	            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
	        }
	        // If the scheduler queue is empty, cancel the requested animation frame and
	        // set the scheduled flag to undefined so the next AnimationFrameAction will
	        // request its own.
	        if (scheduler.actions.length === 0) {
	            AnimationFrame_1.AnimationFrame.cancelAnimationFrame(id);
	            scheduler.scheduled = undefined;
	        }
	        // Return undefined so the action knows to request a new async id if it's rescheduled.
	        return undefined;
	    };
	    return AnimationFrameAction;
	}(AsyncAction_1.AsyncAction));
	exports.AnimationFrameAction = AnimationFrameAction;
	//# sourceMappingURL=AnimationFrameAction.js.map

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(207);
	var RequestAnimationFrameDefinition = (function () {
	    function RequestAnimationFrameDefinition(root) {
	        if (root.requestAnimationFrame) {
	            this.cancelAnimationFrame = root.cancelAnimationFrame.bind(root);
	            this.requestAnimationFrame = root.requestAnimationFrame.bind(root);
	        }
	        else if (root.mozRequestAnimationFrame) {
	            this.cancelAnimationFrame = root.mozCancelAnimationFrame.bind(root);
	            this.requestAnimationFrame = root.mozRequestAnimationFrame.bind(root);
	        }
	        else if (root.webkitRequestAnimationFrame) {
	            this.cancelAnimationFrame = root.webkitCancelAnimationFrame.bind(root);
	            this.requestAnimationFrame = root.webkitRequestAnimationFrame.bind(root);
	        }
	        else if (root.msRequestAnimationFrame) {
	            this.cancelAnimationFrame = root.msCancelAnimationFrame.bind(root);
	            this.requestAnimationFrame = root.msRequestAnimationFrame.bind(root);
	        }
	        else if (root.oRequestAnimationFrame) {
	            this.cancelAnimationFrame = root.oCancelAnimationFrame.bind(root);
	            this.requestAnimationFrame = root.oRequestAnimationFrame.bind(root);
	        }
	        else {
	            this.cancelAnimationFrame = root.clearTimeout.bind(root);
	            this.requestAnimationFrame = function (cb) { return root.setTimeout(cb, 1000 / 60); };
	        }
	    }
	    return RequestAnimationFrameDefinition;
	}());
	exports.RequestAnimationFrameDefinition = RequestAnimationFrameDefinition;
	exports.AnimationFrame = new RequestAnimationFrameDefinition(root_1.root);
	//# sourceMappingURL=AnimationFrame.js.map

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncScheduler_1 = __webpack_require__(346);
	var AnimationFrameScheduler = (function (_super) {
	    __extends(AnimationFrameScheduler, _super);
	    function AnimationFrameScheduler() {
	        _super.apply(this, arguments);
	    }
	    AnimationFrameScheduler.prototype.flush = function (action) {
	        this.active = true;
	        this.scheduled = undefined;
	        var actions = this.actions;
	        var error;
	        var index = -1;
	        var count = actions.length;
	        action = action || actions.shift();
	        do {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        } while (++index < count && (action = actions.shift()));
	        this.active = false;
	        if (error) {
	            while (++index < count && (action = actions.shift())) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AnimationFrameScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.AnimationFrameScheduler = AnimationFrameScheduler;
	//# sourceMappingURL=AnimationFrameScheduler.js.map

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var audit_1 = __webpack_require__(487);
	exports.audit = audit_1.audit;
	var auditTime_1 = __webpack_require__(490);
	exports.auditTime = auditTime_1.auditTime;
	var buffer_1 = __webpack_require__(390);
	exports.buffer = buffer_1.buffer;
	var bufferCount_1 = __webpack_require__(393);
	exports.bufferCount = bufferCount_1.bufferCount;
	var bufferTime_1 = __webpack_require__(396);
	exports.bufferTime = bufferTime_1.bufferTime;
	var bufferToggle_1 = __webpack_require__(399);
	exports.bufferToggle = bufferToggle_1.bufferToggle;
	var bufferWhen_1 = __webpack_require__(402);
	exports.bufferWhen = bufferWhen_1.bufferWhen;
	var catchError_1 = __webpack_require__(284);
	exports.catchError = catchError_1.catchError;
	var combineAll_1 = __webpack_require__(406);
	exports.combineAll = combineAll_1.combineAll;
	var combineLatest_1 = __webpack_require__(314);
	exports.combineLatest = combineLatest_1.combineLatest;
	var concat_1 = __webpack_require__(411);
	exports.concat = concat_1.concat;
	var concatAll_1 = __webpack_require__(286);
	exports.concatAll = concatAll_1.concatAll;
	var concatMap_1 = __webpack_require__(273);
	exports.concatMap = concatMap_1.concatMap;
	var concatMapTo_1 = __webpack_require__(416);
	exports.concatMapTo = concatMapTo_1.concatMapTo;
	var count_1 = __webpack_require__(419);
	exports.count = count_1.count;
	var debounce_1 = __webpack_require__(425);
	exports.debounce = debounce_1.debounce;
	var debounceTime_1 = __webpack_require__(428);
	exports.debounceTime = debounceTime_1.debounceTime;
	var defaultIfEmpty_1 = __webpack_require__(262);
	exports.defaultIfEmpty = defaultIfEmpty_1.defaultIfEmpty;
	var delay_1 = __webpack_require__(433);
	exports.delay = delay_1.delay;
	var delayWhen_1 = __webpack_require__(436);
	exports.delayWhen = delayWhen_1.delayWhen;
	var dematerialize_1 = __webpack_require__(422);
	exports.dematerialize = dematerialize_1.dematerialize;
	var distinct_1 = __webpack_require__(439);
	exports.distinct = distinct_1.distinct;
	var distinctUntilChanged_1 = __webpack_require__(443);
	exports.distinctUntilChanged = distinctUntilChanged_1.distinctUntilChanged;
	var distinctUntilKeyChanged_1 = __webpack_require__(446);
	exports.distinctUntilKeyChanged = distinctUntilKeyChanged_1.distinctUntilKeyChanged;
	var elementAt_1 = __webpack_require__(461);
	exports.elementAt = elementAt_1.elementAt;
	var every_1 = __webpack_require__(292);
	exports.every = every_1.every;
	var exhaust_1 = __webpack_require__(452);
	exports.exhaust = exhaust_1.exhaust;
	var exhaustMap_1 = __webpack_require__(455);
	exports.exhaustMap = exhaustMap_1.exhaustMap;
	var expand_1 = __webpack_require__(458);
	exports.expand = expand_1.expand;
	var filter_1 = __webpack_require__(298);
	exports.filter = filter_1.filter;
	var finalize_1 = __webpack_require__(465);
	exports.finalize = finalize_1.finalize;
	var find_1 = __webpack_require__(468);
	exports.find = find_1.find;
	var findIndex_1 = __webpack_require__(471);
	exports.findIndex = findIndex_1.findIndex;
	var first_1 = __webpack_require__(288);
	exports.first = first_1.first;
	var groupBy_1 = __webpack_require__(475);
	exports.groupBy = groupBy_1.groupBy;
	var ignoreElements_1 = __webpack_require__(481);
	exports.ignoreElements = ignoreElements_1.ignoreElements;
	var isEmpty_1 = __webpack_require__(484);
	exports.isEmpty = isEmpty_1.isEmpty;
	var last_1 = __webpack_require__(294);
	exports.last = last_1.last;
	var map_1 = __webpack_require__(254);
	exports.map = map_1.map;
	var mapTo_1 = __webpack_require__(498);
	exports.mapTo = mapTo_1.mapTo;
	var materialize_1 = __webpack_require__(501);
	exports.materialize = materialize_1.materialize;
	var max_1 = __webpack_require__(504);
	exports.max = max_1.max;
	var merge_1 = __webpack_require__(255);
	exports.merge = merge_1.merge;
	var mergeAll_1 = __webpack_require__(227);
	exports.mergeAll = mergeAll_1.mergeAll;
	var mergeMap_1 = __webpack_require__(228);
	exports.mergeMap = mergeMap_1.mergeMap;
	var mergeMap_2 = __webpack_require__(228);
	exports.flatMap = mergeMap_2.mergeMap;
	var mergeMapTo_1 = __webpack_require__(511);
	exports.mergeMapTo = mergeMapTo_1.mergeMapTo;
	var mergeScan_1 = __webpack_require__(514);
	exports.mergeScan = mergeScan_1.mergeScan;
	var min_1 = __webpack_require__(517);
	exports.min = min_1.min;
	var multicast_1 = __webpack_require__(238);
	exports.multicast = multicast_1.multicast;
	var observeOn_1 = __webpack_require__(281);
	exports.observeOn = observeOn_1.observeOn;
	var onErrorResumeNext_1 = __webpack_require__(357);
	exports.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
	var pairwise_1 = __webpack_require__(526);
	exports.pairwise = pairwise_1.pairwise;
	var partition_1 = __webpack_require__(529);
	exports.partition = partition_1.partition;
	var pluck_1 = __webpack_require__(533);
	exports.pluck = pluck_1.pluck;
	var publish_1 = __webpack_require__(536);
	exports.publish = publish_1.publish;
	var publishBehavior_1 = __webpack_require__(539);
	exports.publishBehavior = publishBehavior_1.publishBehavior;
	var publishLast_1 = __webpack_require__(545);
	exports.publishLast = publishLast_1.publishLast;
	var publishReplay_1 = __webpack_require__(542);
	exports.publishReplay = publishReplay_1.publishReplay;
	var race_1 = __webpack_require__(548);
	exports.race = race_1.race;
	var reduce_1 = __webpack_require__(258);
	exports.reduce = reduce_1.reduce;
	var repeat_1 = __webpack_require__(552);
	exports.repeat = repeat_1.repeat;
	var repeatWhen_1 = __webpack_require__(555);
	exports.repeatWhen = repeatWhen_1.repeatWhen;
	var retry_1 = __webpack_require__(558);
	exports.retry = retry_1.retry;
	var retryWhen_1 = __webpack_require__(561);
	exports.retryWhen = retryWhen_1.retryWhen;
	var refCount_1 = __webpack_require__(243);
	exports.refCount = refCount_1.refCount;
	var sample_1 = __webpack_require__(564);
	exports.sample = sample_1.sample;
	var sampleTime_1 = __webpack_require__(567);
	exports.sampleTime = sampleTime_1.sampleTime;
	var scan_1 = __webpack_require__(259);
	exports.scan = scan_1.scan;
	var sequenceEqual_1 = __webpack_require__(572);
	exports.sequenceEqual = sequenceEqual_1.sequenceEqual;
	var share_1 = __webpack_require__(237);
	exports.share = share_1.share;
	var shareReplay_1 = __webpack_require__(576);
	exports.shareReplay = shareReplay_1.shareReplay;
	var single_1 = __webpack_require__(579);
	exports.single = single_1.single;
	var skip_1 = __webpack_require__(582);
	exports.skip = skip_1.skip;
	var skipLast_1 = __webpack_require__(585);
	exports.skipLast = skipLast_1.skipLast;
	var skipUntil_1 = __webpack_require__(588);
	exports.skipUntil = skipUntil_1.skipUntil;
	var skipWhile_1 = __webpack_require__(591);
	exports.skipWhile = skipWhile_1.skipWhile;
	var startWith_1 = __webpack_require__(594);
	exports.startWith = startWith_1.startWith;
	/**
	 * TODO(https://github.com/ReactiveX/rxjs/issues/2900): Add back subscribeOn once it can be
	 * treeshaken. Currently if this export is added back, it
	 * forces apps to bring in asap scheduler along with
	 * Immediate, root, and other supporting code.
	 */
	// export { subscribeOn } from './operators/subscribeOn';
	var switchAll_1 = __webpack_require__(608);
	exports.switchAll = switchAll_1.switchAll;
	var switchMap_1 = __webpack_require__(256);
	exports.switchMap = switchMap_1.switchMap;
	var switchMapTo_1 = __webpack_require__(613);
	exports.switchMapTo = switchMapTo_1.switchMapTo;
	var take_1 = __webpack_require__(263);
	exports.take = take_1.take;
	var takeLast_1 = __webpack_require__(260);
	exports.takeLast = takeLast_1.takeLast;
	var takeUntil_1 = __webpack_require__(620);
	exports.takeUntil = takeUntil_1.takeUntil;
	var takeWhile_1 = __webpack_require__(623);
	exports.takeWhile = takeWhile_1.takeWhile;
	var tap_1 = __webpack_require__(449);
	exports.tap = tap_1.tap;
	var throttle_1 = __webpack_require__(626);
	exports.throttle = throttle_1.throttle;
	var throttleTime_1 = __webpack_require__(629);
	exports.throttleTime = throttleTime_1.throttleTime;
	var timeInterval_1 = __webpack_require__(632);
	exports.timeInterval = timeInterval_1.timeInterval;
	var timeout_1 = __webpack_require__(635);
	exports.timeout = timeout_1.timeout;
	var timeoutWith_1 = __webpack_require__(639);
	exports.timeoutWith = timeoutWith_1.timeoutWith;
	var timestamp_1 = __webpack_require__(642);
	exports.timestamp = timestamp_1.timestamp;
	var toArray_1 = __webpack_require__(257);
	exports.toArray = toArray_1.toArray;
	var window_1 = __webpack_require__(648);
	exports.window = window_1.window;
	var windowCount_1 = __webpack_require__(651);
	exports.windowCount = windowCount_1.windowCount;
	var windowTime_1 = __webpack_require__(654);
	exports.windowTime = windowTime_1.windowTime;
	var windowToggle_1 = __webpack_require__(657);
	exports.windowToggle = windowToggle_1.windowToggle;
	var windowWhen_1 = __webpack_require__(660);
	exports.windowWhen = windowWhen_1.windowWhen;
	var withLatestFrom_1 = __webpack_require__(663);
	exports.withLatestFrom = withLatestFrom_1.withLatestFrom;
	var zip_1 = __webpack_require__(376);
	exports.zip = zip_1.zip;
	var zipAll_1 = __webpack_require__(668);
	exports.zipAll = zipAll_1.zipAll;
	//# sourceMappingURL=operators.js.map

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./en/index.ts": 682,
		"./it/index.ts": 686,
		"./ua/index.ts": 689
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 681;


/***/ }),
/* 682 */
[3021, 684, 685],
/* 683 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var TranslateUtils = (function () {
	    function TranslateUtils() {
	    }
	    TranslateUtils.buildTranslatePack = function (translations) {
	        var response = {};
	        translations.forEach(function (translatePack) {
	            Object.assign(response, translatePack);
	        });
	        return response;
	    };
	    return TranslateUtils;
	}());
	exports.TranslateUtils = TranslateUtils;


/***/ }),
/* 684 */
/***/ (function(module, exports) {

	module.exports = {
	    VALIDATION: {
	        DEFAULT: 'Invalid value',
	        REQUIRED: 'This is a required field, please fill it in',
	        MAX_LENGTH: 'Maximum value length exceeded',
	        MIN_LENGTH: "Minimum length is {{value}} symbols",
	        EMAIL: 'Email is incorrect',
	        PHONE: 'Phone value is incorrect',
	        URL: 'Url is not valid',
	        EMAIL_MATCH: 'The email confirmation does not match you email address',
	        SHARE_OVERFLOW: 'The total share value cannot be greater than 100%',
	        SHARE_LOW: 'The total share value cannot be less than 100%',
	        MATCHES_NOT_FOUND: "No issue found",
	    },
	    AUTHORIZATION: {
	        UNAUTHORIZED_TITLE: "Sorry, you don't have authorization...",
	        UNAUTHORIZED_MESSAGE: "You don't have permission to perform the action. Contact your Administrator for more help"
	    }
	};


/***/ }),
/* 685 */
/***/ (function(module, exports) {

	module.exports = {
	    THANK_YOU_PAGE: {
	        SUCCESS: 'Thank you!',
	        ERROR: 'An error occurred...',
	        HOME: 'Back to home'
	    }
	};


/***/ }),
/* 686 */
[3021, 687, 688],
/* 687 */
684,
/* 688 */
685,
/* 689 */
[3021, 690, 691],
/* 690 */
/***/ (function(module, exports) {

	module.exports = {
	    VALIDATION: {
	        DEFAULT: 'Неправильне значення поля',
	        REQUIRED: 'Це поле є обов\'язковим, будь-ласка заповніть його',
	        MAX_LENGTH: 'Перевищено максимальну кількість символів',
	        MIN_LENGTH: 'Мінімальна кількість символів {{value}}',
	        EMAIL: 'Неправильне значення email',
	        PHONE: 'Неправильне значення телефону',
	        URL: 'Неправильне значення адреси сайту',
	        SHARE_OVERFLOW: 'The total share value cannot be greater than 100%',
	        SHARE_LOW: 'The total share value cannot be less than 100%'
	    }
	};


/***/ }),
/* 691 */
685,
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(252);
	var core_2 = __webpack_require__(205);
	var TranslateManager = (function () {
	    function TranslateManager(translate) {
	        this.translate = translate;
	    }
	    TranslateManager.prototype.configure = function () {
	        console.log('VENDOR:' + ("paytah"));
	        if (false) {
	            this.translate.setDefaultLang('it');
	            this.translate.use('it');
	        }
	        else {
	            this.translate.setDefaultLang('en');
	            this.translate.use('en');
	        }
	    };
	    ;
	    TranslateManager.prototype.getLocale = function () {
	        //todo andrey implement
	        return 'en';
	    };
	    ;
	    TranslateManager.prototype.setLocale = function (locale) {
	        //todo andrey implement
	    };
	    ;
	    TranslateManager.prototype.getValueAsync = function (key, interpolation) {
	        return this.translate.get(key, interpolation);
	    };
	    TranslateManager.prototype.getValue = function (key, interpolation) {
	        return this.translate.instant(key, interpolation);
	    };
	    TranslateManager = __decorate([
	        core_2.Injectable(),
	        __param(0, core_2.Inject(core_1.TranslateService)),
	        __metadata("design:paramtypes", [core_1.TranslateService])
	    ], TranslateManager);
	    return TranslateManager;
	}());
	exports.TranslateManager = TranslateManager;


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./en/index.ts": 694,
		"./it/index.ts": 714
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 693;


/***/ }),
/* 694 */
[3022, 695, 696, 697, 698, 699, 700, 701, 702, 703, 704, 705, 706, 707, 708, 709, 710, 711, 712, 713],
/* 695 */
/***/ (function(module, exports) {

	module.exports = {"COMMON":{"ID":"ID","LOGIN":"Login","BACK":"Back","EDIT":"Edit","DELETE":"Delete","SAVE":"Save","NEXT":"Next","CANCEL":"Cancel","CONFIRM":"Confirm","CLOSE":"Close","LOADING":"Loading","APPROVE":"Approve","DONE":"Done","COPY":"Copy","GOT_IT":"Got it","VIEW":"View","HIDE":"Hide","SHOW_ALL":"Show all","NEXT_STEP":"Next step","PREVIOUS_STEP":"Previous step","EMPTY_RESULT":"There are no records!","VALIDATION":{"REQUIRED":"This field is required.","EMAIL":"E-mail is incorrect.","IBAN":{"REQUIRED_FOR_POOL":"You should specify IBAN for current pool","CHECKSUM":"This IBAN is not valid. Checksum is incorrect","COUNTRY":"This IBAN number is not valid. Numbers issued in {{country_name}} are not supported","LENGTH":"This IBAN is too {{size}}. Numbers for {{country_name}} must have {{chars}} character length","BIG":"big","SMALL":"small"}},"LOAD_MORE":"Load more","ROW_PER_PAGE":"Row per page","ERROR":"Sorry, something went wrong! Please contact the technical support team.","RELOAD_PAGE":"Reload page.","LEAVE_BLOCK":{"TITLE":"Leave page?","MESSAGE":"If you leave before saving, your changes will be lost.","STAY":"Stay","LEAVE":"Leave"},"YES":"Yes","NO":"No","CLEAR":"Clear","SEARCH":"Search","DIALOG":{"ATTENTION":"Attention!"}},"TABLES":{"RECORDS_OF_TOTAL":"{{min}} - {{records}}  of  {{total}}"}}

/***/ }),
/* 696 */
/***/ (function(module, exports) {

	module.exports = {"LOGIN":{"LOGIN_BUTTON":"LOG IN","USERNAME":"E-mail","PASSWORD":"Password","LOGIN_MIN_LENGTH":"Minimum length is 3 symbols.","LOGIN_MAX_LENGTH":"Maximum length is 50 symbols.","PASSWORD_MAX_LENGTH":"Maximum length is 50 symbols.","EXPIRED_LOGOUT":"Your session has expired. Please log in again."}}

/***/ }),
/* 697 */
/***/ (function(module, exports) {

	module.exports = {"POOLS":{"TITLE":"Liquidity pools","WARNING":"Sorry! There isn't any pool. You can add the first","POOL":{"TITLE":"Pool detail information","ID":"Pool ID:","NAME":"Pool name:","TYPE":"Pool type:","SENDER_INFORMATION":"Ultimate Sender Information:","COULD_CREATE_ACCOUNT_UNDER_POOL":"Can your customers fund their current account through this liquidity pool? If yes, you need to make it a public pool and define funding instructions:","PUBLIC_PERMISSION":"Public","PRIVATE_PERMISSION":"Private"}}}

/***/ }),
/* 698 */
/***/ (function(module, exports) {

	module.exports = {"LIQUIDITY_ACCOUNTS":{"WARNING":{"NO_ACCOUNTS":"Sorry! There aren't any accounts. You can add the first!"},"TABLE_COLUMN":{"ID":"ID","NAME":"Name","NUMBER":"Number","BALANCE":"Balance","CURRENCY":"Currency","IBAN":"IBAN","REFILL_DATE":"Last refill date"},"EDIT":{"SELECT_TITLE":"Select liquidity account"},"MODAL":{"HEADER":"Change liquidity account","BODY":{"DESCRIPTION":"To change the liquidity pool of this transactions select it from the list below. Be aware that this action can not be undone."}}}}

/***/ }),
/* 699 */
/***/ (function(module, exports) {

	module.exports = {"FULL_ACCOUNT_INFO":{"ACCOUNT":{"TITLE":"Account detail information","ACCOUNT_NAME":"Account name:","LIQUIDITY_ACCOUNT_NUMBER":"Liquidity account number:","BALANCE":"Balance:","STATUS":"Status:","COULD_TRANSFER":"Can fund be transferred out of this liquidity account:"},"FUNDING_INSTRUCTIONS":{"TITLE":"Funding instruction","IBAN":"IBAN:","BANK_ACCOUNT_NUMBER":"Bank account number:","ACCOUNT_BRANCH":"Account branch:","BANK_ACCOUNT_NAME":"Bank account name:","CURRENCY":"Currency:","BANK_NAME":"Bank name:","BANK_ADDRESS":"Bank address:","COUNTRY":"Country:","BANK_BRANCH":"Bank branch:","SWIFT":"SWIFT:","IBAN_SOURCE":"IBAN source:"}},"CUSTOMER_ACCOUNTS":{"TITLE":"Customer accounts","LOAD_MORE":"Load more","ACCOUNT_NAME":"Account Name","ACCOUNT_TYPE":"Account Type","ACCOUNT_NUMBER":"Account №","CURRENCY":"Currency","CUSTOMER_NAME":"Customer","BALANCE":"Balance","AVAILABLE_BALANCE":"Available balance","LAST_TRANSFER_DATE":"Last Transfer Date","NO_ANY_CUSTOMER_ACCOUNT":"Sorry! There are not any customer accounts in system.","MIN_SEARCH_LENGTH":"Minimum length is 3 symbols","MIN_ACCOUNT_LENGTH":"Minimum length is 12 symbols","NEW_ACCOUNT":"New Account","NEW_ACCOUNT_TITLE":"New Customer Account","TYPE_CUSTOMER_NAME":"Type customer name","CHOOSE_POOL":"Select liquidity pool","PRODUCT_CODE":"Select product code","CHOOSE_ACCOUNT":"Select liquidity account","CHOOSE_CURRENCY":"Select account currency","CHOOSE_TARIFF":"Select tariff (optional)","CHOOSE_ACCOUNT_TYPE":"Select account type","IBAN_WILL_BE_GENERATED":"IBAN will be generated after confirmation","PLACEHOLDER":{"IBAN":"Enter IBAN number","ACCOUNT_NAME":"Account name (optional)"},"FILTER":{"ACCOUNT":"Account","ACCOUNT_NAME":"Account name","CUSTOMER_NAME":"Customer name","PERIOD":"Period","AMOUNT":"Amount","CURRENCY":"Currency","NOTHING_FOUND":"Sorry! Nothing found! Try other search condition, please!","SEARCH":"Search","RESET":"Reset","ROW_PER_PAGE":"Row per page","INVALID_DATE":"Please select a valid date from the calendar before downloading.","PLACEHOLDER":{"CHOOSE_PERIOD":"Choose period"}},"LINKS":{"POOL":"Pool","LIQUIDITY_ACCOUNT":"Liquidity account","IBAN":"IBAN","EMPTY_LINKS":"No connected pools!","ALLOW_INCOMING":"Allow income","ALLOW_OUTGOING":"Allow send funds","APPLY":"Apply","RESET":"Reset"},"TARIFF":"Tariff","USES_BASED_TARIFF":"Uses based tariff","SHOW_IBANS":"Show IBANs","HIDE_IBANS":"Hide IBANs","SHOW_STATE_LOG":"Show state log","HIDE_STATE_LOG":"Hide state log","ACTIVE_ACTION":"Active","INACTIVE_ACTION":"Inactive","STATE_LOG":{"CHANGE_DATETIME":"Date and time the change","USER_INITIATOR_NAME":"User name","STATE":"State","REASON":"Reason"},"DEACTIVATE":{"DIALOG":{"TITLE":"Specify reason:","BUTTONS":{"CONFIRM":"Confirm","CANCEL":"Cancel"}}}},"SYSTEM_ACCOUNTS":{"TITLE":"System accounts","LOAD_MORE":"Load more","ACCOUNT_NAME":"Account Name","ACCOUNT_TYPE":"Account Type","ACCOUNT_NUMBER":"Account №","CURRENCY":"Currency","BALANCE":"Balance","LAST_TRANSFER_DATE":"Last Transfer Date","NO_ANY_CUSTOMER_ACCOUNT":"Sorry! There are not any system accounts in system."}}

/***/ }),
/* 700 */
/***/ (function(module, exports) {

	module.exports = {"MODAL":{"FOOTER":{"DISMISS":"Dismiss","SAVE":"Save"}}}

/***/ }),
/* 701 */
/***/ (function(module, exports) {

	module.exports = {"TRANSFERS":{"OUTGOING":{"TITLE":"New Outgoing Transfers","CUSTOMER_NAME":"Sender Name","PAYMENT_ID":"ID","ACCOUNT":"Account","NARRATIVE":"Narrative","AML_REASON":"AML Reason","PREVIOUS_APPROVED_REASON":"Previous approved reason","AMOUNT":"Amount","BENEFICIARY_ACCOUNT":"Account","NAME":"Beneficiary Name","BANK_FEE":"Bank fee","BANK":"Bank","VIEW":"View","LIQUIDITY":"Liquidity account","COMPLIANCE":"Compliance","APPROVE":"Approve","REJECT":"Reject","NO_OUTGOINGS":"Outgoing transfers not found.","REPORT_BUTTON":"Report","REFERENCE_CONTAINS_SPACES":"Reference \"{{reference}}\" contain whitespaces!","NEW":{"BACK_TO_NEW_TRANSFER":"Back to page New transfer."},"DIALOG":{"SENDER_ADDRESS_MISSING":"Impossible to fetch the sender address","RECIPIENT_ADDRESS_MISSING":"Beneficiary address is not provided"},"APPROVED":{"TITLE":"Approved Outgoing Transfers","NO_OUTGOINGS":"Approved outgoing transfers not found.","BACK_TO_APPROVED_TRANSFER":"Back to page Approved transfer.","SUMMARY":{"TRANSFERS":"Transfers","TOTAL_AMOUNT":"Total amount","FROM":"From","TO":"to","NO_OUTGOINGS":"There are no any approved outgoing transfers.","EXPORT":"Export"}},"UPLOADED":{"TITLE":"Outgoing Transfers Awaiting Reference","NO_OUTGOINGS":"Transfers awaiting reference not found.","CONFIRM":"Confirm","RESTORE":"Restore","REFERENCE":"Reference","BACK_TO_AWAITING_REFERENCE":"Back to Awaiting reference transfers."},"FILE":{"TITLE":"Transfers Awaiting Reference","NO_OUTGOINGS":"There are no any not processed files.","VIEW":"View","RE_EXPORT":"Re-Export","UPLOAD":"Upload","DONE":"Done","STATE_MODIFIED_ERROR_NOTIFICATION":"You can not view transfers included in this file! File state has been modified on ","RELOAD_PAGE":"Reload page.","FILE_NOT_PROCESSED":"You can not Re-Export file! File has been uploaded.","FILE_CANCELED":"You can not Re-Export file! File has been already re-export.","FILE_PROCESSED":"You can not Re-Export file! File has been processed.","BATCH":"Batch","DOWNLOAD":{"ERROR":{"FILE_NOT_RELEVANT":"You can not Download file! Transfer information has been modified and this file isn't relevant.","FILE_CANCELED":"You can not Download file! File has been re-exported so it isn't relevant.","FILE_NOT_PROCESSED":"You can not Download file! File has been uploaded.","FILE_PROCESSED":"You can not Download file! File has been processed."}}},"FILE_PROCESSED":"You can not Confirm transfer! File has been already processed.","BACK_TO_AWAITING_REFERENCE_TRANSFERS":"Back to Awaiting reference transfers.","REFERENCE":{"BATCH":"Batch - {{ fileName }} ({{liquidityName}})","CONFIRMED":"You can not change reference! Transfer has been already confirmed. Reload page.","CHANGED":"You can not change reference! Transfer reference has been modified on {{reference}}. Reload page.","FILE_PROCESSED":"You can not change reference! File has been already processed.","ALREADY_EXISTS":"Transfer with bank reference {{reference}} already exists!"},"CONFIRM_PAYMENT_WITH_ZERO_BANK_FEE":"Do you want to confirm payment without bank commission?"},"CARD":{"ID":"ID","TITLE":"Refill Card Transfers","TITLE_AWAITING":"Refill Card Transfers awaiting reference","ACCOUNT":"Account","CARD":"Card","NAME":"Name","HOLDER_NAME":"Cardholder name","HOLDER_ID":"Cardholder ID","NARRATIVE":"Narrative","AMOUNT":"Amount","FEE_AMOUNT":"Fee","APPROVE":"Approve","CONFIRM":"Confirm","REJECT":"Reject","NO_TRANSFERS":"Card transfers are not found.","REFERENCE":{"STATE_CHANGED":"You can not approve this transfer! Information has been modified. Reload page.","CHANGED":"You can not change reference! Transfer reference has been modified on {{reference}}. Reload page.","ALREADY_EXISTS":"Transfer with reference {{reference}} already exists!"}},"HISTORY":{"TITLE":"History","EMPTY":"There are no any processed transfers.","LOAD_MORE":"Load more","NO_RESULTS":"Sorry! Nothing found! Try other search condition, please!","SEARCH":"Search","RESET":"Reset","TABLE_COLUMN":{"DATE":"Date","ID":"ID","BANK_REFERENCE":"Bank reference","CUSTOMER":"Customer","ACCOUNT_NUMBER":"Account Number","WHITELABEL":"Whitelabel","AMOUNT":"Amount","FEE":"Fee","NARRATIVE":"Narrative"},"TABLE_ENTRY_COLUMN":{"DEBIT":"Debit","CREDIT":"Credit","AMOUNT":"Amount","NARRATIVE":"Narrative","REFERENCE":"Reference"},"TABLE_DOCUMENT_COLUMN":{"ID":"Document ID","TYPE":"Document type","NAME":"Document name"},"TABLE_STATE_LOG_COLUMN":{"DATE":"Date","USERNAME":"Username","STATE":"State","REASON":"Reason"},"TABLE_MENU":{"VIEW":"View","ALLOCATE":"Allocate","SHOW_ENTRIES":"Show entries","HIDE_ENTRIES":"Hide entries","SHOW_STATE_LOG":"Show state log","HIDE_STATE_LOG":"Hide state log","SHOW_ATTACHMENTS":"Show attachments","HIDE_ATTACHMENTS":"Hide attachments","CANCEL_TRANSFER":"Initiate cancellation"},"CANCELLATION_DIALOG":{"TITLE":"Cancel outgoing transfer","REASON":"Reason","CHOOSE_REASON":"Choose reason","DESCRIPTION":"Further details","SUBMIT":"Yes, cancel a transaction","VALIDATION":{"FIELD_REQUIRED":"This field is required"}},"FILTER":{"PERIOD":"Period","AMOUNT":"Amount","REFERENCE":"Transfer ID","BANK_REFERENCE":"Bank reference","PAYMENT_TYPE":"Payment type","ACCOUNT_NAME":"Account name","ACCOUNT_NUMBER":"Account number","BANK":"Bank","NARRATIVE":"Narrative","CURRENCY":"Currency","STATE":"Transfer state","SHOW_ALL":"Show all","PLACEHOLDER":{"PERIOD":"Choose period","BANK":"Select bank","NARRATIVE":"Input narrative part","CURRENCY":"Select currency","REFERENCE":"Input reference"}},"VALIDATION":{"BANK_REFERENCE":"Bank ref. must be at least 3 characters long.","ACCOUNT_NAME":"Acc. name must be at least 3 characters long.","ACCOUNT":"Acc. must be at least 3 characters long."}},"INCOMING":{"UPLOAD":{"TITLE":"Incoming transfers","TITLE_WITH_BANK":"Incoming transfers ({{bank}})","BANK_COMBO_LABEL":"Choose the bank","BANK_CHOOSE_BUTTON":"Choose file","TRANSACTIONS":"{{count}} Transactions","SUCCESSFUL":"Incoming transfers successfully has been created!","BY_TARIFF":"By tariff","WITHOUT_SCHEME_TRANSFER":"{{transfersCount}} payment will be carried-out as SWIFT payment, due to absence of payment scheme specifications.","WITHOUT_SCHEME_TRANSFERS":"{{transfersCount}} payments will be carried-out as SWIFT payments, due to absence of payment scheme specifications.","GRID":{"DATE":"Doc date","PAYMENT_TYPE":"Payment type","BRANCH_NUMBER":"Branch No","ACCOUNT_NUMBER":"Account No","AMOUNT":"Amount","FEE_AMOUNT":"Fee amount","BANK_FEE_AMOUNT":"Bank fee amount","NAME_AND_ADDRESS":"Name & address","NAME":"Name","ADDRESS":"Address","BANK":"Bank","BANK_ADDRESS":"Bank address","SENDER_CORRESPONDENT":"Sender's corres-nt","NARRATIVE":"Narrative","IDENTIFICATION_NUMBER":"Identification No","BANK_REFERENCE":"Reference","SENDER_INFO":"Sender","RECIPIENT_INFO":"Beneficiary","ALLOCATE":"Allocate","RESET":"Reset","SHOW_FILE_ROW":"Show file row","HIDE_FILE_ROW":"Hide file row"},"ERROR":{"MAX_SIZE":"File size exceeds the permissible value!","IPE_000":"Not enough information for transfer creation.","IPE_001":"Not enough information for transfer creation.","IPE_002":"Reference {{reference}} duplicate in file!","IPE_003":"Account {{account}} is not found among liquidity accounts!","IPE_004":"Beneficiary account is not found! Undelivered transfer will be created.","IPE_005":"Account {{account}} is blocked! Undelivered transfer will be created.","IPE_006":"Profile which has account {{account}} is blocked! Undelivered transfer will be created.","IPE_007":"Transfer with reference {{reference}} already exists in the system.","IPE_008":"Account {{account}} with currency {{currency}} is not found among liquidity accounts!","IPE_018":"Liquidity account {{account}} is not active","IPE_019":"Incoming payments to revenue accounts are forbidden!  Undelivered transfer will be created.","IPE_020":"Invalid bank reference! Bank reference should be less or equal 40 symbols and without whitespaces!","IPE_021":"Incoming payments through this liquidity account are forbidden for customer account {{recipientAccountName}}! Undelivered transfer will be created.","IPE_022":"Actual rate for currencies {{currency}} and {{customer_account_currency}} is not found! Undelivered transfer will be created","FILE_ALREADY_CONFIRMED":"File already exist in the system!","FILE_NOT_FOUND":"File not found!","BANK_REFERENCE_ALREADY_EXISTS":"Payments with same references can't be saved!"},"ALLOCATE":{"DIALOG":"Allocate transfer {{reference}}","CUSTOMER":"Customer Name","CHOOSE_CUSTOMER_ACCOUNT":"Choose customer account","CUSTOMER_ACCOUNT_EMPTY":"No available accounts were found!","ACCOUNTS_LOADING":"Loading customer accounts...","CUSTOMERS_NOT_FOUND":"Sorry! There are not found any customer by this condition! Try other search condition, please!","ACCOUNT_NOT_SAME_CURRENCY":"Transfer currency run counter to currency of selected account!"}},"DIALOG":{"BUTTON_CONFIRM":"Confirm"}},"INTERNAL":{"TITLE":"New Internal Transfers","NO_INTERNAL_TRANSFERS":"There are no any new internal transfers.","PAYMENT_ID":"ID","SENDER_NAME":"Sender Name","SENDER_ACCOUNT":"Account","NARRATIVE":"Narrative","AMOUNT":"Amount","RECIPIENT_NAME":"Beneficiary Name","RECIPIENT_ACCOUNT":"Account","VIEW":"View","COMPLIANCE":"Compliance","APPROVE":"Approve","REJECT":"Reject","BACK_TO_NEW_TRANSFER":"Back to page New transfer.","DETAILS":{"TRANSFER_DETAILS":"Transfer details (ID: {{id}})","BENEFICIARY_DETAILS":"Beneficiary details","SENDER":{"NAME":"Customer name :","EMAIL":"Email address :","ACCOUNT_NUMBER":"Account No :","ACCOUNT_NAME":"Account name :","INTRODUCER":"Introducer :"},"TRANSACTION":{"NARRATIVE":"Narrative :","CREATE_TIME":"Request date :","CURRENCY_RATE":"Rate :","FEE_AMOUNT":"Fee :","SOURCE_AMOUNT":"Source :","DESTINATION_AMOUNT":"Destination :"},"RECIPIENT":{"ACCOUNT_NUMBER":"Account No :","ACCOUNT_NAME":"Account name:","IBAN":"IBAN :","NAME":"Beneficiary name :","ADDRESS":"Address :"}}},"SYSTEM":{"WIZARD":{"CREATE":"Create","PREVIEW":"Preview","SUCCESS":"Success"},"REVENUE_TO_INTERNAL":"Revenue to internal","TYPE_CUSTOMER_NAME":"Type customer name","CHOOSE_CUSTOMER_ACCOUNT":"Choose customer account","CHOOSE_REVENUE_ACCOUNT":"Choose revenue account","CHARGE_FEES":{"TITLE":"Charge additional fee","CHOOSE_FEE":"Choose fee"},"CARDS":{"CHOOSE_CARDS":"Choose client's card","NOT_FOUND":"Сustomer doesn't have any cards"},"ACCOUNTS":{"CHOOSE_LIQUIDITY":"","NOT_FOUND":"Any accounts found!"},"INACTIVE_MODAL":{"TITLE":"Confirm proceed with inactive account","MESSAGE":"Selected account is inactive, are you sure you want to continue?","OK_BUTTON":"OK"}},"BUTTONS":{"CANCEL":"Cancel","CONFIRM":"Confirm"},"DIALOG":{"REJECT":"Specify reject reason:","REJECT_CLIENT_WARNING":"The reason is shown to the client in the Client Office and the API.","APPROVE":"Specify approval reason:","REFERENCE":"Specify reference:"},"DETAILS":{"CUSTOMER_NAME":"Customer name","CUSTOMER_ACCOUNT_NUMBER":"Customer account number","ALLOCATED_TO":"Allocated to","TRANSACTION_DATE":"Transaction date","PROVIDER":"Provider","SUB_ACCOUNT_CLIENT_PART":"Linked sub-account payment (client's part)","SUB_ACCOUNT_MASTER_PART":"Master account part","SUB_ACCOUNT_THIS_IS_MASTER":"this payment is the master account part","SUB_ACCOUNT_THIS_IS_CLIENT":"this payment is the client's part","UNDELIVERED_TRANSACTION_DATE":"Undelivered transfer create date","UNDELIVERED_TRANSACTION_ID":"Undelivered transfer ID","DELIVERED_TRANSACTION_ID":"Delivered transfer ID","CANCELED_TRANSACTION_ID":"Cancellation transfer ID","FEE":"Fee","BANK_FEE":"Bank fee","FEE_NAME":"Fee name","NARRATIVE":"Narrative","REFUND_REASON":"Refund reason","BENEFICIARY_NAME":"Beneficiary name","BENEFICIARY_ADDRESS":"Beneficiary address","BENEFICIARY_ACCOUNT_NUMBER":"Beneficiary account number","BANK_NAME":"Bank name","BANK_ADDRESS":"Bank address","IBAN_ACC":"IBAN / Sender account","SWIFT":"SWIFT","BANK_REFERENCE":"Bank reference","SENDER_NAME":"Sender name","SENDER_ACCOUNT_NUMBER":"Sender account number","SENDER_ADDRESS":"Sender address","CARD_NUMBER":"Card number","EXPRESS_PAYMENT":"Express payment","IP_ADDRESS":"IP Address","IP_COUNTRY":"IP Country","TRANSACTION_AMOUNT":"Transaction amount","CURRENCY":"Currency","AMOUNT":"Amount","AMOUNT_BY_RATE":"Amount by rate","PAYMENT_AMOUNT":"Payment Amount","CURRENCY_EXCHANGE_RATE":"Currency rate","REJECT_REASON":"Reject reason","TRANSACTION_DETAILS":"Transaction details","TRANSFERS_TITLE":"Transfers / ID","FILES_TITLE":"Attached files","SAVE_ALL":"Save all","REVENUE_ACCOUNT":"Revenue account","NOT_PROVIDED":"NOT PROVIDED","NOT_DELIVERED":"NOT DELIVERED","NOT_CANCELED":"NOT CANCELED","RECALL_PAYMENT":"Recall Payment","INVERT_PAYMENT":"Invert Payment","RETURN_3R_IN_PAYMENT":"Return 3R Incoming","CREDIT_SUBACCOUNT":"Credit sub-account","SUB_ACCOUNT_CREDITED":"Credited to sub-account (payment)","CREDIT_SUBACCOUNT_DIALOG":{"MODAL_TITLE":"Credit sub-account from payment","EXPLANATION":"This creates an incoming payment in the sub-account for the amount of this payment, so the client sees it in the sub-account. The real money does not move: it is already in the master account.","EXPLANATION_FEE":"With \"Charge fee\" the incoming fee of the sub-account tariff is charged, as for a normal incoming payment. Without it, the full amount is credited and no fee is charged.","EXPLANATION_FINAL":"The credit is executed immediately and cannot be undone from the back office. Do not repeat it if the sub-account was already credited.","SUGGESTED":"Suggested sub-account","SUGGESTION_OTHER":"Other account (type the number below)","IN_NARRATIVE":"IBAN in the narrative","PREVIOUS_CREDITS":"Earlier credits from this sender: {{count}}","SUBACCOUNT_NUMBER":"Sub-account number","CHECK":"Check","CHARGE_FEE":"Charge fee","CHARGE_FEE_HINT":"Untick to credit the full amount without the incoming fee.","DESTINATION":"Sub-account","AMOUNT":"Amount","FEE":"Fee","FEE_WAIVED":"tariff fee not charged:","NO_FEE_RULE":"no incoming fee rule in the tariff, credited without fee","NET":"Net credited to the sub-account","NOT_A_SUBACCOUNT":"This account is not a sub-account. Check the number.","ALREADY_CREDITED":"This payment was already credited to a sub-account (payment {{ids}}).","MODAL_ACCEPT":"Yes, credit the sub-account","SUCCESS":"Sub-account {{account}} credited"},"REPROCESS_INTERNALS":"Reprocess Internals","ERROR":{"GET_DETAILS":"Something went wrong, while getting transfer details."},"RECALL_DIALOG":{"MODAL_TITLE":"Recall Transaction","MODAL_ACCEPT":"Yes, recall transaction"},"INVERT_DIALOG":{"MODAL_TITLE":"Invert Transaction","MODAL_ACCEPT":"Yes, invert transaction"},"RETURN_3R_IN_DIALOG":{"MODAL_TITLE":"Return 3R Incoming","MODAL_ACCEPT":"Yes, return incoming"}},"OPEN_BANKING":{"TITLE":"Open Banking","EMPTY":"There are no any client.","DETAIL_HEADER":"ID:{{id}}","PAYMENT_DETAIL_HEADER":"Payment ID:{{id}}","VIEW_BUTTON":"View","ADD_BUTTON":"Add","EDIT_BUTTON":"Edit","DELETE_BUTTON":"Delete","PAYMENTS_BUTTON":"Payments","PAY_ALL_UNPAID_BUTTON":"Pay All","IBAN_OR_ACCOUNT_NUMBER_REQUIRED":"Iban or Account number required","STATUS_UPDATE_SUCCESS":"{{count}} payments updated successfully.","STATUS_UPDATE_WARNING":"No payments found to update.","STATUS_UPDATE_ERROR":"An error occurred while updating payments.","STATUS_UPDATE_BUTTON":"Refresh Status for All","TAB":{"CLIENTS":{"TITLE":"Clients","DETAIL_TITLE":"Details","NEW_CLIENT_TITLE":"Add New Client","TABLE":{"ID":"ID","NAME":"Name","PROFILE_ID":"Profile ID","CUSTOMER_NAME":"Customer Name","HAS_MONETUM_ACCOUNT":"Has Monetum Account","USE_MASTER_ACCOUNT":"Use Master Account","DIRECT_EXTERNAL_PAYMENT":"Direct External Payment","TOTAL_PAYMENTS":"Total Payments","PAYABLE_PAYMENTS":"Payable Payments","ACTIVE":"Active","CREATED_AT":"Created At"},"LEGEND":{"HAS_MONETUM_ACCOUNT":"Traditional Monetum Account","USES_MASTER_ACCOUNT":"Master Account (Hybrid Solution)","DIRECT_EXTERNAL_PAYMENT":"Direct External Payment"},"SECTION":{"BASIC_INFO":"Basic Information","ACCOUNT_CONFIG":"Account Configuration","API_CONFIG":"API Configuration","BUSINESS_CONFIG":"Business Configuration","STATEMENTS_CONFIG":"Reports Configuration"},"SAVE_BUTTON":"Save","CLIENT_NAME":"Client name","CLIENT_TOKEN":"Token","CLIENT_PROFILE_ID":"Client profile Id","CUSTOMER_NAME":"Customer Name","CLIENT_IBAN":"Iban","CLIENT_ACCOUNT_NUMBER":"Account number","URL":"URL Logo image","CALLBACK_URL":"Callback URL","STATEMENTS_EMAILS":"Statements to email(s)","DAILY_REPORT_ENABLED":"Daily Report Enabled","DAILY_REPORT_EMAILS":"Daily Report Email(s)","DAILY_REPORT_DESCRIPTION":"Configure automatic daily payment reports sent via email","INVALID_EMAILS":"Invalid email(s)","FEE":"Fee","MINIMUM_FEE":"Minimum Fee","IBAN_PAYMENT_ALLOWED":"Iban payment allowed","HAS_MONETUM_ACCOUNT":"Has Monetum Account","USE_MASTER_ACCOUNT":"Use Master Account","MONETUM_IBAN":"Monetum IBAN","DIRECT_EXTERNAL_PAYMENT":"Direct External Payment","EXTERNAL_DIRECTLY_IBAN":"External Directly Iban","FEE_ACCOUNT":"Customer Fee Account","APPLICATION_ID":"Application ID","ADDED_SUCCESS":"Client successfully added","DELETE_SUCCESS":"Client successfully deleted","DELETE_FAILURE":"The client has associated payments, it cannot be deleted","ADD_BUTTON":"Create new client","EDIT_BUTTON":"Edit","PAY_ALL_DIALOG_TITLE":"Payment Information","PAY_ALL_DIALOG_CONFIRM_BUTTON":"Confirm Payment","PAY_ALL_DIALOG_CLOSE_BUTTON":"Cancel","TOTAL_PAYMENTS":"Total Payments","TOTAL_PAID_PAYMENTS":"Total Paid Payments","TOTAL_UNPAID_PAYMENTS":"Total Unpaid Payments","TOTAL_PAYABLE_PAYMENTS":"Total Payable Payments","TOTAL_NON_PAYABLE_PAYMENTS":"Total Non-Payable Payments","TOTAL_ACCUMULATED_AMOUNT":"Total accumulated amount","ACCUMULATED_AMOUNT":"Accumulated amount","ACCUMULATED_FEES":"Accumulated fees","ACCUMULATED_PAID_AMOUNT":"Accumulated Paid Amount","ACCUMULATED_UNPAID_AMOUNT":"Accumulated Unpaid Amount","ACCUMULATED_PAYABLE_AMOUNT":"Accumulated Payable Amount","ACCUMULATED_NON_PAYABLE_AMOUNT":"Accumulated Non-Payable Amount","TOTAL_ACCUMULATED_FEE_AMOUNT":"Total Accumulated Fee Amount","ACCUMULATED_PAID_FEE_AMOUNT":"Accumulated Paid Fee Amount","ACCUMULATED_UNPAID_FEE_AMOUNT":"Accumulated Unpaid Fee Amount","ACCUMULATED_PAYABLE_FEE_AMOUNT":"Accumulated Payable Fee Amount","ACCUMULATED_NON_PAYABLE_FEE_AMOUNT":"Accumulated Non-Payable Fee Amount","PENDING_AMOUNT":"Pending amount to be paid","PAY_ALL_UNPAID_SUCCESS":"{{amount}} Euros have been paid correctly","PPC_LIST":"Payment Purpose Code","MCC_LIST":"Merchant Category Code","FREQUENCY_PAYMENT":"Frequency Payment","DELAY":"Delay Payment","COUNTRY_LIST":"Allowed countries","PAY_ALL_AUTOMATICALLY":"Pay All Automatically","ACTIVE":"Active"},"PAYMENTS":{"ID":"ID","TITLE":"Payments","DETAIL_TITLE":"General Information","TABLE":{"ID":"ID","DATE":"Date","CLIENT_NAME":"Client Name","PAYEE_NAME":"Payee Name","AMOUNT":"Amount","STATUS":"Status","PAID":"Paid","PROVIDER":"Provider"},"ACCOUNT_NUMBER":"Account number","IBAN":"Iban","AMOUNT":"Amount","CURRENCY":"Currency","DESCRIPTION":"Description","CONSENT":"Consent","PAYEE_NAME":"Payee name","CLIENT_NAME":"Client name","OB_PAYMENT_ID":"OB Payment ID","M_PAYMENT_ID":"Monetum Payment ID","BANK":"Bank ID","OPEN_BANKING_CLIENT_ID":"Open banking client id","CREATE_TIME":"Create time","EMPTY":"There are no any payments.","STATUS":"Payment Status","CLIENT_ID":"Client ID","PAY":"Pay","PAYED":"Payed","YAPILY_STATUS":"Yapily Status","CONSENT_STATUS":"Consent Status","PROCESSING_STATUS":"Processing Status","FLOW":"Flow","YAPILY_ISO_STATUS":"ISO Status","YAPILY_ISO_STATUS_CODE":"ISO Status Code","YAPILY_ISO_STATUS_NAME":"ISO Status Name","YAPILY_ISO_STATUS_DESCRIPTION":"ISO Status Description","TYPE":"Type","CHECK_STATUS_BUTTON":"Check Status","DETAILS_TAB":"Payment Details","TRACKS_TAB":"Tracks","STATE_LOGS_TAB":"State Logs","PAY_DIALOG_TITLE":"Confirm Payment Processing","PAY_DIALOG_CONFIRM_BUTTON":"Process Payment","SETTLEMENT_STATUS":"Settlement Status","PROVIDER_STATUS":"Provider Status","PROVIDER_PAYMENT_ID":"Provider Payment ID","HAS_PAYMENT_ID":"Payment ID Status","EXTERNAL_ID":"External ID"},"PAYMENT_TRACKS":{"TITLE":"Payment Tracks"},"INSTITUTIONS":{"TITLE":"Institutions"}},"PAYMENT_TRACKS":{"TITLE":"Payment Tracks","ID":"ID","PAYMENT_ID":"Payment ID","TYPE":"Type","STATUS":"Status","CREATE_TIME":"Created At","ERRORS":"Errors","VIEW_PAYMENT":"View Payment","NO_TRACKS":"No payment tracks found.","INFO_TITLE":"Track History","INFO_MESSAGE":"This table shows the complete history of status changes and events for this payment.","TOTAL":"Total tracks","RECORDS":"record(s)"},"PAYMENT_STATE_LOGS":{"TITLE":"Payment State Logs","DETAILS_TITLE":"State Log Details","ID":"ID","PAYMENT_ID":"Payment ID","PROVIDER":"Provider","PREVIOUS_STATUS":"Previous Status","NEW_STATUS":"New Status","REASON":"Transition Reason","NOTES":"Notes","METADATA":"Metadata","CREATED_AT":"Created At","NO_LOGS":"No state logs found for this payment.","INFO_TITLE":"State Transition History","INFO_MESSAGE":"This table shows the complete history of state transitions for this payment.","TOTAL":"Total logs","RECORDS":"record(s)"},"INSTITUTIONS":{"TITLE":"Institutions","SUBTITLE":"Manage Open Banking institutions and bank configurations","DETAILS_TITLE":"Institution Details","PROVIDER":"Provider","ID":"ID","NAME":"Name","ID_INST":"Institution ID","PROVIDER_ID":"Provider ID","BIC":"BIC","COUNTRY_CODE":"Country","EMBEDDED_FLOW":"Embedded Flow","SINGLE_PAYMENT":"Single Payment","SCHEDULED_PAYMENT":"Scheduled Payment","INSTANT_PAYMENT":"Instant Payment","ENABLED":"Enabled","VIEW_DETAILS":"View Details","UPDATE":"Update from Yapily","NO_INSTITUTIONS":"No institutions found.","BASIC_INFO":"Basic Information","REQUIREMENTS":"Requirements","FEATURES":"Features","NO_FEATURES":"No features available.","NEED_PSU_ID":"Need PSU ID","NEED_PSU_CORPORATE_ID":"Need PSU Corporate ID","NEED_PSU_IP_ADDRESS":"Need PSU IP Address","NEED_PAYER_BIC":"Need Payer BIC","NEED_PAYER_IBAN":"Need Payer IBAN","NEED_PAYER_DETAILS":"Need Payer Details","NEED_PAYER_ACCOUNT_NUMBER":"Need Payer Account Number","NEED_PAYER_EMAIL":"Need Payer Email","NEED_PAYER_BBAN":"Need Payer BBAN","NEED_PAYER_COUNTRY":"Need Payer Country","NEED_PAYER_ADDRESS":"Need Payer Address"},"WEBHOOKS":{"TITLE":"Webhooks","EMPTY":"No webhooks configured.","ADD_BUTTON":"Add Webhook","EDIT_BUTTON":"Edit","DELETE_BUTTON":"Delete","SAVE_BUTTON":"Save","CANCEL_BUTTON":"Cancel","ACTIVATE_BUTTON":"Activate","DEACTIVATE_BUTTON":"Deactivate","DELETE_CONFIRM_TITLE":"Delete Webhook","DELETE_CONFIRM":"Are you sure you want to delete this webhook? This action cannot be undone.","FORM":{"URL":"Webhook URL","URL_PLACEHOLDER":"https://your-domain.com/webhook","VERSION":"Payload Version","VERSION_PLACEHOLDER":"Select version","ACTIVE":"Active","ACTIVE_HELP":"Enable this webhook","CREATED_AT":"Created","UPDATED_AT":"Updated","CUSTOM_UA":"Custom User-Agent","CUSTOM_UA_HELP":"Override the default User-Agent sent with webhook requests","CUSTOM_UA_TOOLTIP":"Use this if the destination server blocks default Java requests (e.g. WAF returning 403)","CUSTOM_UA_TYPE":"User-Agent Type","UA_TYPE_RECOMMENDED":"Recommended (Browser)","UA_TYPE_BASIC":"Basic (Mozilla/5.0)","UA_TYPE_CUSTOM":"Custom","CUSTOM_UA_VALUE":"User-Agent Value","CUSTOM_UA_HINT":"Example: Mozilla/5.0 (compatible; MyApp/1.0)","CUSTOM_UA_TIP":"Tip: Use a browser-like User-Agent to avoid firewall blocking.","RENEW_SECRET":"Webhook Secret","RENEW_SECRET_TOOLTIP":"V4 webhooks use an HMAC-SHA256 secret to sign each request. The secret is set once on creation and never exposed again. Tick the checkbox only if you need to rotate it.","SECRET_ACTIVE":"Secret configured","SECRET_ACTIVE_HELP":"A signing secret is active for this webhook.","RENEW_SECRET_LABEL":"Renew secret (generate a new one on save)","RENEW_SECRET_WARNING":"The current secret will be replaced. Make sure your server is updated to validate the new secret before saving."},"TABLE":{"ID":"ID","URL":"URL","VERSION":"Version","STATUS":"Status","ACTIONS":"Actions"},"VALIDATION":{"URL_REQUIRED":"Webhook URL is required","URL_INVALID":"Invalid URL format","VERSION_REQUIRED":"Version is required","UA_VALUE_REQUIRED":"User-Agent value is required when custom User-Agent is enabled","UA_VALUE_TOO_LONG":"User-Agent value must not exceed 512 characters"},"MESSAGES":{"CREATE_SUCCESS":"Webhook created successfully","UPDATE_SUCCESS":"Webhook updated successfully","DELETE_SUCCESS":"Webhook deleted successfully","TOGGLE_SUCCESS":"Webhook status updated successfully","ERROR":"An error occurred. Please try again."}},"NOTIFICATIONS":{"TITLE":"Notification History","SUBTITLE":"View and manage Open Banking webhook notifications","EMPTY":"No notifications sent yet.","REFRESH_BUTTON":"Refresh","TABLE":{"ID":"ID","WEBHOOK_ID":"Webhook ID","WEBHOOK_URL":"Webhook URL","PAYMENT_ID":"Payment ID","CLIENT_NAME":"Client Name","TYPE":"Type","VERSION":"Version","STATUS":"Status","CREATED_AT":"Created At","IS_MANUAL":"Manual","PAYLOAD":"Payload","VIEW_PAYLOAD":"View Payload"},"FILTERS":{"TITLE":"Filters","PAYMENT_ID_PLACEHOLDER":"Enter Payment ID","WEBHOOK_ID":"Webhook ID","WEBHOOK_ID_PLACEHOLDER":"Enter Webhook ID","CLIENT_ID":"Client ID","CLIENT_ID_PLACEHOLDER":"Enter Client ID","PERIOD":"Period","APPLY":"Apply Filters","CLEAR":"Clear"},"ACTIONS":{"VIEW_DETAILS":"View Details","RESEND":"Resend"},"MODAL":{"TITLE":"Notification Details","RESPONSE_STATUS":"Response Status","RESPONSE_BODY":"Response Body","REQUEST_BODY":"Request Body","PAYLOAD":"Payload","SOURCE_IP":"Source IP","REQUEST_HEADERS":"Request Headers"},"PAYLOAD_MODAL":{"TITLE":"Notification Payload","CLOSE_BUTTON":"Close"},"MANUAL":{"BUTTON":"Send Manual Notification","TITLE":"Send Manual Notification","INFO":"This will send a webhook notification directly to the active webhook of the selected client, using the exact payload provided.","CLIENT":"Client","SELECT_CLIENT":"— Select a client —","LOADING_CLIENTS":"Loading clients…","SELECT_WEBHOOK":"Target Webhook","PICK_WEBHOOK":"— Select a webhook —","LOADING_WEBHOOKS":"Loading webhooks…","NO_WEBHOOKS":"No webhooks configured for this client","WEBHOOK_INFO":"Webhook configuration","SECRET_STATUS":"Signing secret (HMAC)","CUSTOM_UA":"Custom User-Agent","V4_SECRET_WARN":"This is a V4 webhook — the notification will be signed with HMAC-SHA256. Make sure the secret is configured, otherwise the delivery will be rejected.","TYPE":"Notification Type","WEBHOOK_VERSION":"Webhook Version","WEBHOOK_VERSION_HINT":"Select the webhook version configured for the client. Each version has a different payload structure. V4 webhooks also require an HMAC secret.","INTERNAL_PAYMENT_ID":"Internal Payment ID","PAYMENT_ID":"Payment ID","STATUS":"Payment Status","EXTERNAL_PAYMENT_ID":"External Payment ID","CUSTOMER_ID":"Customer ID","AMOUNT":"Amount","CURRENCY":"Currency","STATUS_ISO_CODE":"Status ISO Code","STATUS_ISO_NAME":"Status ISO Name","STATUS_ISO_DESC":"Status ISO Description","PAYLOAD":"Payload (JSON)","PAYLOAD_EDITABLE_HINT":"auto-generated · editable","SEND":"Send Notification","SENDING":"Sending…"}},"ANALYTICS":{"TITLE":"Open Banking Analytics","SUBTITLE":"Monitor widget usage, conversion rates, and API performance","FILTERS":{"TITLE":"Filters","CLIENT":"Client","ALL_CLIENTS":"All Clients","SOURCE":"Source","ALL_SOURCES":"All Sources","PERIOD":"Period","APPLY":"Apply","CLEAR":"Clear"}}}}}

/***/ }),
/* 702 */
/***/ (function(module, exports) {

	module.exports = {"OUTER_PAYMENTS":{"DETAILS":{"TRANSFER_DETAILS":"Transfer details (ID: {{id}})","BENEFICIARY_DETAILS":"Beneficiary details","ATTACHMENTS":"Attachments","EMPTY_ATTACHMENTS":"No attachments!","AML_REASON":"Aml Reasons","AML_REASON_DESCRIPTION":"Description","CUSTOMER":{"NAME":"Customer name :","INTRODUCER":"Introducer :"},"SENDER":{"NAME":"Sender name :","COUNTRY":"Sender country :","CITY":"Sender city :","ADDRESS":"Sender address :","ZIP_CODE":"Sender zip code :","ACCOUNT_NUMBER":"Account No :","ACCOUNT_NAME":"Account name :"},"TRANSACTION":{"NARRATIVE":"Narrative :","CREATE_TIME":"Request date :","CURRENCY_RATE":"Rate :","FEE_AMOUNT":"Fee :","SOURCE_AMOUNT":"Source :","DESTINATION_AMOUNT":"Destination :","BANK_REFERENCE":"Bank reference :"},"RECIPIENT":{"ACCOUNT_NUMBER":"Account No :","IBAN":"IBAN :","NAME":"Beneficiary name :","ADDRESS":"Address :","BANK_NAME":"Bank name :","BANK_ADRESS":"Bank address :","BANK_COUNTRY":"Bank country :","SWIFT_BIC":"SWIFT BIC :","BENEFICIARY_CITY":"City :","BENEFICIARY_COUNTRY":"Country :"}}}}

/***/ }),
/* 703 */
/***/ (function(module, exports) {

	module.exports = {"SYSTEM":{"ACCOUNTS":{"REVENUE":"Revenue account","CUSTOMER":"Customer account","LIQUIDITY":"Liquidity account"},"CUSTOMER":{"NAME":"Customer name"},"AMOUNT":{"TITLE":"Amount","BANK_FEE_AMOUNT":"Bank fee","MAX":"Insufficient funds. Please, fund revenue account","MAX_FEE":"Insufficient funds on customer account","MAX_BANK_FEE":"Expenses are more than revenue","MIN":"Please enter transfer amount","MIN_FEE":"Please enter transfer amount"},"CURRENCY":{"TITLE":"Currency","PLACEHOLDER":"Choose currency"},"PURPOSE":{"TITLE":"Purpose of payment","TITLE_FOR_FEE":"Purpose of fee","PLACEHOLDER":"Input payment purpose","PLACEHOLDER_FOR_FEE":"Input fee purpose"},"FEE":{"TITLE":"Fee","CHOOSE_FEE":"Choose fee","CLAIM_SHARE":"Claim share"},"CARD":{"CHOOSE_CARD":"Choose card"},"SUCCESS":{"PAYMENT":{"HEADER":"Congratulations!","STATUS":"You've done the payment with status","LINK1":"Create new one","LINK2":"explore the transfer history","LINKS_SEPARATOR_VALUE":"or"},"FEES":{"HEADER":"Congratulations!","CHARGED":"You've charged from","WITH_PURPOSE":"with purpose"}}}}

/***/ }),
/* 704 */
/***/ (function(module, exports) {

	module.exports = {"CUSTOMER":{"TITLE":{"REGISTERED":"Customers/Registered","PENDING":"Customers/Pending","PENDING_DETAIL":"Customer/Pending/ID:{{id}}","DETAIL":"Customer/Registered/ID:{{id}}"},"APPROVED":"Approved customers","DECLINED":"Declined customers","TABLE":{"COMPANY":"Company Name","DESCRIPTION":"Brief Description","CREATED":"Created: {{value}}","SIGNATORY":"Authorized signatory","INTRODUCER":"Introducer","INTRODUCER_FROM_APPLICATION":"Introducer from application","EMAIL":"Authorized email","PRIVATE_EMAIL":"Email","CURRENCY":"Currency","NAME":"Customer name","TARIFF":"Based tariff","ADDRESS":"Address","OPENING_DATE":"Opening date","APPROVING_DATE":"Approving date","PHONE":"Authorized phone","USER_EMAIL":"Email","EMAIL_ADDRESS":"Email","PHONE_NUMBER":"Phone number","MOBILE_NUMBER":"Mobile number","PRIVATE_PHONE":"Phone number","MOBILE_PHONE":"Mobile number","MIN_TOTAL_ASSET":"Min total asset"},"BUTTONS":{"APPROVE":"Approve","DECLINE":"Decline","PROCESS":"Process","AGENT":"Agent","MOONWARD":"Moorwand","FINXP":"FinXp","EMONEY":"Emoney","ON_HOLD":"On hold","COMPLIANCE":"Compliance","ARCHIVED":"Archived","REJECT":"Reject","BACK":"Back","SAVE":"Save","VIEW":"View","COPY":"Copy","DONE":"Done","RESET":"Reset","DECLINE_MODAL":{"CONFIRM":"Yes, decline request","CANCEL":"Cancel"},"ON_HOLD_MODAL":{"CONFIRM":"Yes, put on hold","CANCEL":"Cancel"},"ARCHIVED_MODAL":{"CONFIRM":"Yes, archive request","CANCEL":"Cancel"},"SUSPEND_MODAL":{"CONFIRM":"Yes, suspend profile","CANCEL":"Cancel"},"REJECT_MODAL":{"CONFIRM":"Yes, reject profile","CANCEL":"Cancel"},"SUSPEND":"Suspend","CLOSE_MODAL":{"CONFIRM":"Yes, close profile","CANCEL":"Cancel"},"CLOSE":"Close"},"DECLINE_MODAL":{"TITLE":"Decline registration request from {{customer}}?","MESSAGE":"This can not be undone","TITLE_INPUT_REJECT":"Reason for rejection"},"REJECT_MODAL":{"TITLE":"Reject registration request from {{customer}}?","MESSAGE":"This can not be undone","TITLE_INPUT_REJECT":"Reason for rejection"},"ON_HOLD_MODAL":{"TITLE":"Put on hold registration request from {{customer}}?","MESSAGE":"This can not be undone","TITLE_INPUT_REJECT":"Reason for on hold"},"ARCHIVED_MODAL":{"TITLE":"Archive registration request from {{customer}}?","MESSAGE":"This can not be undone","TITLE_INPUT_REJECT":"Reason for archived"},"SUSPENDED_MODAL":{"TITLE":"Suspend customer profile from {{customer}}?","MESSAGE":"This can not be undone","TITLE_INPUT_REJECT":"Reason for suspension","REASON_DETAILS":"Further details on the suspension status reason"},"CLOSE_MODAL":{"TITLE":"Close customer profile from {{customer}}?","MESSAGE":"This can not be undone","TITLE_INPUT_REJECT":"Reason for close","REASON_DETAILS":"Further details on the close status reason"},"UNSUSPEND_MODAL":{"TITLE":"Unsuspend user profile","MESSAGE":"Do you really want to unsuspend this user profile?","BUTTON":"Unsuspend"},"INFO":{"TITLE":"Customer information","COMPANY":"Company name","ACTIVITY_TYPE":"Type of legal entity","INCORP_DATE":"Date of incorporation","REG_NUMBER":"Registration number","TAXPAYER_REG_NUM":"Taxpayer registration number","PHONE":"Phone","COUNTY_REGION":"County / Region","CITY":"City","REG_OFFICE":"Registered office","COUNTRY":"Country","ZIP_CODE":"Zip code","E_MAIL":"E-mail","SITE":"Web site","DESC":"Brief description"},"BUSINESS":{"TITLE":"Business activities","PROFILE":"Business profile","FULL_DESC":"Full description of the business, activities and operations","LICENSE":"License","LICENSE_NOT_REQUIRE":"I confirm that the aforementioned business activities do not require a licence or special permit at the place of business.","LICENSE_REQUIRE":"The aforementioned business activities require a licence or special permit at the place of business and I attach a copy of the licence and/or special permit.","DURATION":"Duration of business activities (years)","NUMBER_OF_EMPLOYEES":"Number of employees of the company","KEY_FIN_INDICATORS":"Key financial indicators. Annual sales volume of the company (USD /EUR. Please circle appropriate currency)","TOTAL_ASSETS":"Total assets on the company’s balance sheet (USD /EUR mio. Please circle appropriate currency)"},"TRANSACTION":{"TITLE":"Transfer activities","INCOMING_TRANSFERS":"Incoming transfers","OUTGOING_TRANSFERS":"Outgoing transfers","CURRENCY":"Currency","COUNTRIES_MAKE_TRANSFER":"Main countries to which you will make transfers","COUNTRIES_RECEIVE_TRANSFER":"Main countries from which you will receive transfers","OUT_TRANSFERS_COUNT":"Estimated number of outgoing transfers per month","IN_TRANSFERS_COUNT":"Estimated number of incoming transfers per month","AVERAGE_TRANSFER":"Average value for each transfer","MAXIMUM_TRANSFER":"Maximum value of each transfer","INCOMING":"Planned incoming","OUTGOING":"Planned outgoing","MAX_MONTHLY":"Maximum MONTHLY account turnover","MAX_SINGLE":"Maximum amount of a SINGLE transaction"},"AUTHORITY_SIGNATORY_DETAILS":{"TITLE":"Authority signatory details","FIRST_NAME":"First name","LAST_NAME":"Last name","ADDRESS":"Address","CITY":"City/state","ZIP":"Zip code","COUNTRY":"Country","NATIONALITY":"Nationality","PASSPORT":"Passport/ID","PASSPORT_ISSUE_DATE":"Passport Issue Date","PASSPORT_EXPIRY_DATE":"Passport Expiry Date","PHONE":"Telephone","EMAIL":"E-mail"},"DIRECTORS":{"TITLE":"Directors information","FULL_NAME":"Full name","FIRST_NAME":"First name","LAST_NAME":"Last name","NATIONALITY":"Nationality","PASSPORT":"Passport/ID","PASSPORT_ISSUE_DATE":"Passport Issue Date","PASSPORT_EXPIRY_DATE":"Passport Expiry Date","ADDRESS":"Address","PHONE":"Telephone","EMAIL":"E-mail"},"BENEFICIARY":{"TITLE":"Beneficiary details","SHARE":"Share","FULL_NAME":"Full name","FIRST_NAME":"First name","LAST_NAME":"Last name","NATIONALITY":"Nationality","PASSPORT":"Passport/ID","PASSPORT_ISSUE_DATE":"Passport Issue Date","PASSPORT_EXPIRY_DATE":"Passport Expiry Date","ADDRESS":"Address","PHONE":"Telephone","EMAIL":"E-mail"},"COMPANY_ACCOUNT":{"TITLE":"Company account information","VALUE_OF_INITIAL_FUNDING":"Value of Initial Funding","CURRENCY_OF_INITIAL_FUNDING":"Currency of initial funding","ORIGINATING_BANK_NAME":"Originating Bank Name","ORIGINATING_BANK_ADDRESS":"Originating Bank Address","ACCOUNT_NAME":"Account Name","ACCOUNT_NUMBER":"Account Number","SIGNATORY":"Signatory","FUNDS_DESCRIPTION":"Describe precisely how these funds were generated","ACCOUNT_CURRENCY":"Account currency","INTRODUCER":"Introducer","INTRODUCER_EMAIL_ADDRESS":"Introducer Email Address"},"PARTNERS":{"TITLE":"Information on business partners","INCOMING":"Incoming payments","OUTGOING":"Outgoing payments","PARTNER_NAME":"Name of partner","PARTNER_COUNTRY":"Country of incorporation","PARTNER_DESCRIPTION":"Brief description of the economic essence of planned transactions"},"ADDITIONAL":{"TITLE":"Additional information","SERVICES":"Products/Services planing to use"},"PAGINATION":{"ROWS_PER_PAGE":"Rows"},"EMPTY":{"PROFILES":"Sorry! There are not any customer profiles in system."},"STATE":{"ACTIVE":"Active","BLOCKED":"Blocked","NEW":"New","PENDING":"Pending","SUSPENDED":"Suspended","PROCESSING":"Processing","ON_HOLD":"On hold","ARCHIVED":"Archived","REJECTED":"Rejected","DECLINED":"Declined","CLOSED":"Closed","4STOP_PROCESSING":"Processing by 4stop"},"PROVIDER":{"MODULR":"Processed as: Modulr","AGENT":"Processed as: Agent","MOORWAND":"Processed as: Moorwand","EMONEY":"Processed as: Emoney"},"KIND":{"CUSTOMER":"Customer","AGENT":"Agent","SALESMAN":"Salesman","SALESMAN_LEAD":"Salesman Lead","WHITE_LABEL":"White Label","INSTITUTIONAL_CLIENT":"Institutional Client","SUB_CLIENT":"Sub Client"},"FILTER":{"CUSTOMER_NAME":"Customer name","ID":"ID","EMAIL":"Signatory email","INTRODUCER_NAME":"Introducer name","INTRODUCER_SELECT":"Select introducer","ACCOUNT_TYPE":"Profile type","ACCOUNT_STATE":"Profile state","VERIFICATION_STATUS":"Verification status","VERIFICATION_STATUS_EXCLUSION":"Not Verified","ACCOUNT_OPENING_DATE_REGISTERED":"Opening date","ACCOUNT_OPENING_DATE_APPLICANTS":"Application date","VALIDATOR":{"CUSTOMER_NAME_MIN_SEARCH_LENGTH":"Minimum length is 3 symbols"},"PLACEHOLDER":{"CUSTOMER_NAME":"e.g. John Doe","COUNTRY_OF_REGISTRATION":"Country of registration","NATIONALITY":"Nationality","ID":"e.g. 123456","EMAIL":"e.g. john.doe@mail.com","INTRODUCER_NAME":"e.g. John Doe","INTRODUCER_SELECT":"Choose one to proceed","ACCOUNT_TYPE":"Show all","ACCOUNT_STATE":"Show all","VERIFICATION_STATUS":"Show all","BANK_LIST":"Show all","TARIFF_LIST":"Show all","TELEPHONE_NUMBER":"+23 (423) 423 42 34"},"NOT_FOUND":{"INTRODUCER_SELECT":"There are no available introducers","COUNTRY_OF_REGISTRATION":"There are no registration country","NATIONALITY":"There are no Nationality"},"BANK_LIST":"Bank List","TELEPHONE_NUMBER":"Telephone Number","TARIFF_LIST":"Tariff LIst","COUNTRY_OF_REGISTRATION":"Country of registration","NATIONALITY":"Nationality"},"DETAILS":{"EDIT.BUTTON.NAME":"Edit","TAB.DETAILS":{"HEADER":"Details","CRYPTO_WALLETS":{"TITLE":"Crypto Wallets","ADDRESS":"Wallet Address","COPY":"Copy to clipboard"},"PRIVATE":{"APPLICANT_INFORMATION":{"TITLE":"Applicant","PERSONAL_DETAILS":{"TITLE":"Personal details","FIRST_NAME":"First name","LAST_NAME":"Last name"},"NATIONALITY":"Nationality","PASSPORT":"NIC / Passport number","PLACE_OF_ISSUE":"Issuing Authority","PLACE_OF_ISSUE_COUNTRY":"Issuing Authority (Country)","DATE":{"TITLE":"Date of issue/ expiry","ISSUE":"Date of issue","EXPIRY":"Date of expiry","EXPIRY_WARNING":"Please note, passport is expiring soon. ","EXPIRED_WARNING":"Please note, passport is expired. "},"SECOND_NATIONALITY":"Second nationality","RESIDENTIAL_ADDRESS":{"TITLE":"Home address","RESIDENTIAL_POSTAL_ADDRESS":"Home address","RESIDENTIAL_POSTAL_CITY":"City","RESIDENTIAL_POSTAL_COUNTY_OR_REGION":"County or region","RESIDENTIAL_COUNTRY":"Country","RESIDENTIAL_ZIP_CODE":"Postcode / ZIP code"},"POSTAL_ADDRESS":{"TITLE":"Mailing address","POSTAL_ADDRESS":"Mailing address","POSTAL_CITY":"Mailing city","POSTAL_COUNTY_OR_REGION":"Mailing county or region","COUNTRY":"Mailing country","ZIP_CODE":"Postcode / ZIP code"},"PHONE_NUMBER":"Phone number","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","BIRTH_DATE":"Date of birth","PLACE_OF_BIRTH":"Place of Birth (Country)","TAX_IDENTIFICATION_NUMBER":"Tax Identification Number","TAX_COUNTRY":"Tax Country","FAX_NUMBER":"Fax number","FACEBOOK_PROFILE":"Facebook profile","LINKEDIN":"LinkedIn","OTHER":"Other","ID_OR_PASSPORT_ATTACHMENT_ITEMS":"ID or Passport attachment items","PASSPORT_SELFIE_ATTACHMENT_ITEMS":"Passport selfie attachment items","ADDRESS_ATTACHMENT_ITEMS":"Address attachment items","SAVE_ALL":"Save all","UPLOAD":{"TITLE":"Upload","ERROR":{"MAX_SIZE":"File size exceeds the permissible value!","FILE_ALREADY_CONFIRMED":"File already exist in the system!","FILE_NOT_FOUND":"File not found!","UNSUPPORTED_FORMAT":"Unsupported format of file!"}},"FILTER":{"NOT_FOUND":{"NATIONALITY_SELECT":"There are no available country","SECOND_NATIONALITY_SELECT":"There are no available country","COUNTRY_SELECT":"There are no available country","RESULT_COUNTRY_SELECT":"No results found","JURISDICTION":"There are no available jurisdiction"}},"DIALOG":{"TITLE":"Change user email? Warning!","MESSAGE":"This will block sign in using the previous email address and force the user to use the new one assigned. Keep in mind that we don't have an opportunity to inform the user about the new changes over its profile. This operation cannot be undone.","OK":"CHANGE","CANCEL":"CANCEL"}},"EMPLOYMENT_INFORMATION":{"TITLE":"Employment","PRESENT_OCCUPATION":"Present occupation","EMPLOYMENT_DETAILS":{"TITLE":"Employment details","NAME":"Employer's name/Name of business","ADDRESS":{"TITLE":"Employer's address","POSTAL_ADDRESS":"Employer's office address","POSTAL_CITY":"City","POSTAL_COUNTY_OR_REGION":"County or region","COUNTRY":"Country","ZIP_CODE":"Postcode / ZIP code"},"BUSINESS_SECTOR":"Name of Business Activity","YEARS_IN_EMPLOYMENT":"Number of years in employment/business"}},"PEP_INFORMATION":{"TITLE":"PEP","POSITION_IN_ANY_COUNTRY":"Are you a PEP or linked to a PEP? A \"Politically Exposed Person\" is a natural person (individual) who is or has been entrusted with a prominent public function and includes his or her immediate family members or persons known to be close associates of such persons but excludes middle ranking or more junior officers.","FAMILY_POSITION_IN_ANY_COUNTRY":"Does any member of your close family currently hold, or has ever held any political, diplomatic or governmental office in any country? (Please tick the box if the answer is YES)"},"LITIGATION_INFORMATION":{"TITLE":"Litigation","LITIGATION":"Have you ever been the subject of any legal enquiries, court orders, judgements, bankruptcy proceedings, criminal sanctions (excluding minor traffic incidents)? (Please tick the box if the answer is YES)"},"MASTER_ACCOUNT_INFORMATION":{"TITLE":"Master account","MASTER_ACCOUNT_CURRENCY":"Master account currency","ADDITIONAL_CURRENCIES":"Additional currencies"},"FUNDS_INFORMATION":{"TITLE":"Funds","SOURCE_OF_INITIAL_FUNDING":{"TITLE":"Source of Initial funding","JURISDICTION":"Jurisdiction","AVERAGE_MONTHLY_INCOME":"What is your average monthly income?","PRIMARY_INCOME_SOURCE":"Please provide your primary income source","ORIGINAL_BANK_NAME":"Original bank name","ORIGINAL_BANK_ADDRESS":"Original bank address","ACCOUNT_NAME":"Account name","SIGNATORY":"Signatory","HOW_FUNDS_GENERATED":"Describe precisely how these funds were generated"},"EXPECTED_TRANSFER_ACTIVITY":{"TITLE":"Expected transfer activity","AVERAGE_VALUE_OF_TRANSFER":"Average value of each transfer ({{currency}})","MAX_VALUE_OF_TRANSFER":"Maximum value of each transfer ({{currency}})","MAIN_COUNTRIES_TO":"Countries to which transfers will be made","MAIN_COUNTRIES_FROM":"Countries from which transfers will be received","PURPOSE_OF_ACCOUNT":" Purpose of this account","AVERAGE_INCOMING_TRANSACTION":"Average transaction value/size","PLANNED_MONTHLY_INCOMING_TURNOVER":"Planned monthly turnover of incoming payments using {{vendorTitle}} account","MONTHLY_INCOMING_FREQUENCY":"Monthly frequency of payments","AVERAGE_OUTGOING_TRANSACTION":"Average outgoing transaction value/size","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Planned monthly turnover of outgoing payments on {{vendorTitle}} account","MONTHLY_OUTGOING_FREQUENCY":"Monthly frequency of outgoing payments"},"RANGE":{"UP":"Up to {{amountTo}} {{unit}}","FROM_TO":"From {{amountFrom}} {{unit}} to {{amountTo}} {{unit}}","MORE":"More than {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Up to {{amountTo}}","FROM_TO":"From {{amountFrom}} to {{amountTo}}","MORE":"More than {{amountFrom}}"}},"INTRODUCER_INFORMATION":{"TITLE":"Introducer/Reseller","INTRODUCER_NAME":"Introducer/reseller name","INTRODUCER_EMAIL":"Introducer/reseller email"},"ABOUT_YOURSELF_INFORMATION":{"TITLE":"Tell us about yourself","PRODUCTS":"What {{company}} products/services are you planning to use?","PRODUCTS_CUSTOM":"Products custom","REASONS":"Reasons","REASONS_CUSTOM":"Reasons custom","INFORMATION_SOURCE":"Information sources","INFORMATION_SOURCES_CUSTOM":"Information sources custom","USA_CITIZEN":"By ticking the box I declare that I am NOT a citizen and/or a tax resident of the USA."},"REQUIRED_INPUT":"This field is required!","MINIMUM_LENGTH":"Minimum length is {{value}} symbols","MAXIMUM_LENGTH":"Maximum length is {{value}} symbols"},"CORPORATE":{"BUSINESS_CUSTOMER_INFORMATION":{"TITLE":"Business Customer Information","DATE_OF_REGISTRATION":"Date of registration","REGISTRATION_NUMBER":"Registration number","TRADING_NAME":"Trading name","TAX_IDENTIFICATION_NUMBER":"Tax Identification Number","COMPANY_PHONE":"Company phone"},"STATEMENT_OF_AFFAIRS":{"TITLE":"Statement of Affairs","SPECIFIC_COUNTRIES":"Specific countries of Operations Targeted markets","NATURE_OF_BUSINESS":"Nature of business"},"INITIAL_DEPOSITS":{"TITLE":"Source of funds","SOURCE_OF_INITIAL_DEPOSIT":"Describe source of initial deposit","ORIGINATING_BANK_JURISDICTION":"Originating Bank Jurisdiction","DESCRIBE_FUNDS_WERE_GENERATED":"Describe precisely how these funds were generated","AMOUNT":"Amount","CURRENCY":"Currency","ACCOUNT_NAME":"Account name"},"ACCOUNT_CURRENCIES":{"TITLE":"Account currencies","MASTER_ACCOUNT_CURRENCY":"Master account currency","ADDITIONAL_CURRENCIES":"Additional currencies"},"EXPECTED_TURNOVER":{"TITLE":"Expected turnover","NUMBER_OF_INCOMING":"Number of incoming per month","NUMBER_OF_OUTGOING":"Number of outgoing per month","AMOUNT_OF_INCOMING":"Amount of incoming per month (EUR)","AMOUNT_OF_OUTGOING":"Amount of outgoing per month (EUR)","MAXIMUM_TRANSFER_AMOUNT":"Maximum transfer amount (EUR)","MAIN_SUPPLIERS":"Main counterparties for outgoing payments","MAIN_CLIENTS":"Main counterparties for incoming payments"},"AUTHORISED_SIGNATORY":{"TITLE":"Authorized signatory","SAVE_ALL":"Save all","DETAILS":"Authorized signatory details","ADDRESS":"Authorized signatory address","CONTACTS":"Authorized signatory contacts","PASSPORT":"Passport","SELFIE":"Selfie with ID Card"},"INTRODUCER":{"TITLE":"Introducer/Reseller","INTRODUCER_NAME":"Introducer/reseller name","INTRODUCER_EMAIL":"Introducer/reseller email"},"USAGE_AND_REFERRAL":{"TITLE":"Usage and referral","WHAT_PRODUCTS_SERVICES":"What {{company}} products/services are you planning to use?","REASON_FOR_CHOOSING":"Reason for choosing {{company}}","SOURCE_OF_INFORMATION":"Source of information about {{company}}?"},"COMMON":{"FIRST_NAME":"First name","LAST_NAME":"Last name","DATE_OF_BIRTH":"Date of birth","ATTORNEY_POWER_EXPIRE_DATE":"Expiry date of power of attorney (if applicable)","JOB_TITLE_OCCUPATION":"Job title / Occupation","NIC_PASSPORT_ID":"NIC/Passport No","PASSPORT_ID":"Passport/ID number","NATIONALITY":"Nationality","SECOND_NATIONALITY":"Second nationality","ADDRESS_LINE":"Address line","COUNTRY":"Country","COUNTY_REGION":"County / Region","CITY":"City","ZIP_CODE":"Postcode / ZIP code","PHONE_NUMBER":"Phone number","MOBILE":"Mobile","LINKEDIN":"Linkedin","FACEBOOK":"Facebook","WEBSITE":"Website","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","NAME_OF_CORPORATE_SHAREHOLDER":"Name of corporate shareholder","LEGAL_DOCUMENTS":"Legal documents","PERSONAL_INFORMATION":"Personal information","COMPANY_INFORMATION":"Company information","COMPANY_NAME":"Company name","COUNTRY_OF_INCORPORATION":"Country of incorporation","COMPANY_REGISTRATION_NUMBER":"Company registration number","COMPANY_ADDRESS":"Company address (Optional)","COMPANY_CONTACTS":"Company contacts","HOME_ADDRESS":"Home address (Optional)","CONTACTS":"Contacts","INDIVIDUAL":"Individual","CORPORATE":"Corporate","IDENTITY_CONFIRMATION":"Identity confirmation","YES":"Yes","NO":"No","PROOF_OF_ADDRESS":"Proof of address","OPTIONAL_ADDRESS":"Optional address","INVALID_VALUE":"Invalid value"},"MINIMUM_LENGTH":"Minimum length is {{value}} symbols","MAXIMUM_LENGTH":"Maximum length is {{value}} symbols"},"OTHER":"Other","UNAVAILABLE_CURRENCY":"Unavailable currency","SAVE.BUTTON.NAME":"Save","SAVE_ALL.BUTTON.NAME":"Save all","UPLOAD.BUTTON.NAME":"Upload","DISCARD.BUTTON.NAME":"Discard","ADD_NEW.BUTTON.NAME":"Add new"},"TAB.SETTINGS":{"HEADER":"Settings","LINKED_ACCOUNTS":"Linked accounts","PROFILE_SETTINGS":"Profile settings","UPDATE_PROFILE_STATUS":"Update Profile Status","CHANGE_PROFILE_STATUS":"Change Profile Status","RISK_LEVEL":"Risk level","TARIFF":"Tariff","WHITELABEL_TARIFF":"Whitelabel tariff","PROFILE_TYPE":"Profile type","INTRODUCER_NAME":"Introducer name","MINTOTAL_ASSET":"Mintotal asset","NEGATIVE_INTEREST":"Threshold Negative interest","MAX_LIMIT_AMOUNT":"Minimum amount for TM filtering","CLOSELY_MONITORING_ACCOUNT":"Closely monitoring account","VIP_HIGH_VOLUME_CLIENTS":"VIP - High Volume Clients","RESET":"Reset","SUSPEND_ACTIVITY":"Suspend activity","UNSUSPEND_ACTIVITY":"Unsuspend activity","SUSPENDED_REASON":"Suspended Reason:","SUSPENDED_CUSTOM_REASON":"Custom suspended Reason:","CLOSED_REASON":"Close Reason:","CLOSED_CUSTOM_REASON":"Custom close Reason:","SUSPEND":"Suspend","UNSUSPEND":"Unsuspend","DELETE_PROFILE":"Delete profile","DELETE":"Delete","CLOSE":"Close","PASSWORD_SETTINGS":"Password settings","MANUALLY_RESET_PASSWORD":"Manually reset password","UPDATE_REVENUE_DISTRIBUTION_SETTINGS":"Update Revenue distribution settings","REVENUE_DISTRIBUTION_SETTINGS":"Revenue distribution settings","PROFILE_TYPE_SETTINGS":"Profile type settings","REFERRAL_LINKS":"Referral links","DEFAULT_REVENUE_DISTRIBUTION_RULES":"Default revenue distribution rules","RESTORE_DEFAULTS":"Restore defaults","UPDATE":"Update","DISTRIBUTION_RULES_TABLE":{"SERVICE":"Service","SYSTEM":"SYS","WHITELABEL":"WL","SALESMANLEAD":"SL","SALESMAN":"S","AGENT":"A","INSTITUTIONAL":"IC"},"DESCRIBE_EXCEPTION_RULE":"Describe the exception rule","SELECT_USERS_TO_APPLY_EXCEPTION":"Select users to apply the exception","SELECT_TYPES_OF_USERS_TO_APPLY_EXCEPTION":"Select types of users to apply the exception","APPLIES_TO":"Applies to","TYPES_OF_USERS":"Types of users","USERS":"Users","DISTRIBUTION_CONDITIONS_PROFILE_KINDS":{"SALESMANLEAD":"Salesman Leads","SALESMAN":"Salesmen","AGENT":"Agents","CUSTOMER":"Customers","WHITELABEL":"White Label"},"ACTIONS":{"REMOVE":"Remove","ADD_EXCEPTION_PROFILES":"Add exception for specific profiles","ADD_EXCEPTION_KINDS":"Add exception for specific kinds","ADD_EXCEPTION":"Add exception","NEW_ROW":"New Row"},"EXCEPTION_TYPES":{"FOR_PROFILE":"For profile","FOR_MEMBER_TYPE":"For member type"},"VALIDATION":{"AT_LEAST_ONE_CONDITION":"At least one condition should be selected!","SETTINGS_CONFLICT":"This exception can't be applied because of a settings conflict. Check already existing exceptions or remove the current one","ALL_CONDITIONS_SELECTED":"There is no difference found between the \"{{exception_name}}\" and the default Revenue Distribution settings !","SUM_OF_SHARES_PERCENTAGE":"The percentage of this row must be 100%"},"MESSAGES":{"SETTINGS_SUCCESSFULLY_UPDATED":"Settings were successfully updated"},"REFERRAL_WARNING_DIALOG":{"TITLE":"Warning","MESSAGE":"After changing profile type - referral links will be deleted"},"VERIFICATION_CODE_HEADER":"Verification code mail","VERIFICATION_CODE_TEXT":"Generate code and send to client"},"TAB.ACCOUNTS":{"HEADER":"Accounts","NO_ACCOUNTS":"Sorry! There are not any customer accounts in system.","OPTIONS":{"BLOCK":"Block Account"},"BUTTON":{"NEW_ACCOUNT":"New account"},"STATE":{"ACTIVE":"Active","INACTIVE":"Inactive"},"FILTER":{"PLACEHOLDER":{"ACCOUNT_STATE":"State","ACCOUNT_CURRENCY":"Currency","ACCOUNT_NAME":"Search account name","ACCOUNT_NUMBER":"Search account number","CARD_STATE":"State","CARD_CURRENCY":"Currency","CARD_HOLDER":"Search cardholder name","CARD_NUMBER":"Search card number"}}},"TAB.USERS":{"HEADER":"Users","NO_USERS":"Sorry! No results were found!","INVITE_MESSAGE":"An invitation email has been sent","INVITE_BUTTON":"Invite user (email)","INVITE_EMAIL_INVALID":"Enter a valid email address.","NEW_USER_HINT":"New users start with a role of their own and without accounts (unless the customer has a single active account). Link their accounts from the user details.","ROLE_COLUMN":"Role","LOADING":"Loading...","YES":"Yes","NO":"No","CONFIRM":"Confirm","CANCEL":"Cancel","ACTION_ERROR":"The action could not be completed. Please try again.","NEW.DIALOG":{"TITLE":"Invite User","MESSAGE":"Email of the person to invite. They will receive a link to register as a user of this customer.","BUTTONS.INVITE":"Send Mail","BUTTONS.CANCEL":"Cancel"},"BUTTON":{"NEW_USER":"New user"},"STATE":{"CREATED":"Created","APPROVED":"Approved","DECLINED":"Declined","EDITED":"Edited","EDITED_MESSAGE":"Status changed successfully"},"STATE_DIALOG":{"TITLE":"Change user state","MESSAGE":"Change {{user}} to \"{{state}}\"?"},"FILTER":{"PLACEHOLDER":{"USER_STATE":"State","USER_NAME":"Search username"}},"MANUAL":{"BUTTON":"Create user manually","TITLE":"Create authorised user manually","MANDATORY_HINT":"All fields are mandatory (same data the invitation form collects), except middle name.","EMAIL":"Email","PHONE":"Phone","FIRST_NAME":"First name","LAST_NAME":"Last name","MIDDLE_NAME":"Middle name","DATE_OF_BIRTH":"Date of birth","PASSPORT_NUMBER":"Passport number","NATIONALITY":"Nationality","PASSPORT_ISSUE_DATE":"Passport issue date","PASSPORT_EXPIRY_DATE":"Passport expiry date","ISSUE_COUNTRY":"Country of issue","ISSUE_PLACE":"Place of issue","SELECT":"Select...","CREATE":"Create user","CREATING":"Creating...","CLOSE":"Close","CREATED":"User created successfully.","CREATE_ERROR":"Could not create the user. Please check the data and try again.","SHARE_HINT":"Share these credentials securely with the user.","TEMP_PASSWORD":"Temporary password","COPY":"Copy","COPIED":"Copied","PASSWORD_ONCE":"The password is shown only once: copy it before closing this panel.","NO_ACCOUNTS_HINT":"The user has a role of their own and no accounts yet: link them from the user details."},"PROFILE_USER_DETAILS":{"ID":"Id","FULL_NAME":"Full name","FIRST_NAME":"First name","LAST_NAME":"Last name","USER_NAME":"Username","CREATE_TIME":"Create time","STATE":"State","USER_RELATED_ROLE":"User related role","USER_RELATED_ROLE_DETAILS":"Role Details","SHOW_DETAILS":"Show details","HIDE_DETAILS":"Hide details","ACTION":"Action","TWO_FA_TITLE":"2FA","TWO_FA_ACTIONS":"2FA Actions","NONE":"None","ACTIVE_2FA":"Active 2FA","DISABLE_2FA":"Disable 2FA","DISABLE_TOTP":"Disable TOTP","NO_ROLES_ASSOCIATED":"No roles associated","TWO_FA_REQUESTED":"2FA activation requested. It can take a few seconds to show.","TWO_FA_DIALOG_TITLE":"Change 2FA","MAKE_ADMIN":"Make administrator","REMOVE_ADMIN":"Remove administrator","ADMIN_DIALOG_TITLE":"Customer administrator","MAKE_ADMIN_DIALOG":{"MESSAGE":"Make {{user}} an administrator of this customer? They will see every account, have full payment permissions and manage the users and roles in the Client Office."},"REMOVE_ADMIN_DIALOG":{"MESSAGE":"Remove the administrator role from {{user}}? They will go to their own role USER_{{id}} (the existing one, or a new one without accounts) and lose the admin section of the Client Office. If they are the only administrator, nobody in the customer will be able to manage users."},"DISABLE_2FA_DIALOG":{"MESSAGE":"Disable every 2FA method of {{user}}? They will be able to log in without a second factor."},"DISABLE_TOTP_DIALOG":{"MESSAGE":"Disable the authenticator app (TOTP) of {{user}}?"},"SECURITY_SHOW":"View 2FA & Login Activity","SECURITY_HIDE":"Hide 2FA & Login Activity","PHONE_EMPTY":"Phone number cannot be empty","PHONE_SAVE_ERROR":"Failed to save phone. Please try again.","ACTION_ERROR":"The action could not be completed. Please try again."},"USER_RELATED_ROLE_DETAILS":{"ID":"Id","ROLE_NAME":"Role name","USERS_WITH_ROLE":"Users with this role","CREATE_PAYMENT":"Create Payment","AUTHORIZE_PAYMENT":"Authorize Payment","STATEMENTS":"Statements","HISTORY":"History","PAYMENT_AMOUNT":"Payment Amount","AUTHORIZE_AMOUNT":"Authorize Amount","CREATE_TIME":"Create Time","ASSOCIATED_ACCOUNTS":"Associated Accounts","ALL_ACCOUNTS":"All accounts","NO_ASSOCIATED_ACCOUNTS":"No associated accounts","VIEW_ACCOUNTS":"View Accounts","SHOW_ROLE_DETAILS":"Show Role details","HIDE_ROLE_DETAILS":"Hide Role details","SHOW_ROLE_ACCOUNT_DETAILS":"Show Accounts","HIDE_ROLE_ACCOUNT_DETAILS":"Hide Accounts","ACCOUNT_NAME":"Account Name","ACCOUNT_NUMBER":"Account Number","ACCOUNT_IBAN":"Account Iban","POOL_NAME":"Pool name","LIQUIDITY_NAME":"Liquidity account","ASSOCIATED":"Associated","ASSOCIATE_ACCOUNT_ACTION":"Associate Account","REMOVE_ACCOUNT_ACTION":"Remove Account"},"ROLE_ACCOUNTS":{"TITLE":"Accounts of the role {{role}}","LINKED_COUNT":"{{count}} of {{total}} linked","ADMIN_INFO":"The administrator role always sees every account of the customer. To limit the accounts of a user, the user needs a different role.","SHARED_WARNING":"This role is shared by {{count}} users ({{users}}). Linking or unlinking an account changes what all of them see.","NOT_SHARED":"Only this user has this role: changes apply to this user only.","GIVE_OWN_ROLE":"Give this user their own role","GIVE_OWN_ROLE_DIALOG":{"TITLE":"Give the user their own role","MESSAGE":"A new role USER_{{id}} will be created for this user only, with the same permissions and accounts as {{role}}. The other users keep {{role}}."},"UNLINK_DIALOG":{"TITLE":"Unlink account","MESSAGE":"Unlink {{account}} from the role {{role}}?"},"CURRENCY":"Currency","STATE":"State","LINKED":"Linked","NOT_LINKED":"Not linked","LINK":"Link","UNLINK":"Unlink","CANCEL":"Cancel","LINKED_MESSAGE":"Account linked","UNLINKED_MESSAGE":"Account unlinked","LOADING":"Loading accounts...","EMPTY":"This customer has no accounts.","LOAD_ERROR":"The accounts could not be loaded.","RETRY":"Retry","ACTION_ERROR":"The action could not be completed. Please try again."}},"TAB.API_ACCESS":{"HEADER":"API access","EMPTY":"This customer has no Payments API access yet.","CREATE_BUTTON":"Create API access","READ_ONLY_SETTINGS":"Advanced settings (express, sub-account, allowed pools, eMoney, wallets) can't be changed here.","CREATED":"API access created.","ROTATED":"API key rotated.","BLOCKED":"API access blocked.","UNBLOCKED":"API access unblocked.","PERMISSIONS_UPDATED":"Permissions updated.","OTHER_PERMISSIONS":"Also allowed (not managed here)","RETRY":"Retry","CANCEL":"Cancel","SAVE":"Save","YES":"Yes","NO":"No","ACTION_ERROR":"The action could not be completed. Please try again.","TABLE":{"NAME":"Name","KEY":"Key","STATE":"State","PERMISSIONS":"Permissions","CREATED":"Created","KEY_ROTATED":"Key rotated","ACTIONS":"Actions"},"FORM":{"NAME":"Consumer name","NAME_HINT":"3 to 64 lowercase letters, digits or hyphens. It must be unique.","PERMISSIONS":"Permissions","INTERNAL_NOTE":"Internal payments is also required to confirm payments to the master account."},"PERMISSION":{"BALANCES":"Balances","TRANSACTION_HISTORY":"Transaction history","EXTERNAL_PAYMENTS":"External payments","INTERNAL_PAYMENTS":"Internal payments","MASTER_PAYMENTS":"Payments to the master account"},"KEY":{"ONCE":"Copy the API key now. For security it will not be shown again.","COPY":"Copy","COPIED":"Copied","STORED":"I have stored the key","SEND_HINT":"Send it to the customer through a one-time secret link, never by email or chat."},"ACTIONS":{"ROTATE":"Rotate key","BLOCK":"Block","UNBLOCK":"Unblock","PERMISSIONS":"Permissions"},"ROTATE":{"TITLE":"Rotate API key","MESSAGE":"Rotate the API key of {{name}}? The current key stops working immediately and the customer must switch to the new one.","CONFIRM":"Rotate key"},"BLOCK":{"TITLE":"Block API access","MESSAGE":"Block API access for {{name}}? Every request with its key will be rejected immediately.","CONFIRM":"Block"},"UNBLOCK":{"TITLE":"Unblock API access","MESSAGE":"Unblock API access for {{name}}?","CONFIRM":"Unblock"},"SETTINGS":{"EXPRESS":"Express","SUB_ACCOUNT":"Sub-account","ALLOWED_POOLS":"Allowed pools","EMONEY":"eMoney","WALLETS":"Wallets"},"ACTIVITY":{"TITLE":"Activity","EMPTY":"No changes recorded from the back office.","DATE":"Date","ACTION":"Action","BY":"By","CHANGES":"Changes","ACTIONS":{"CREATE":"Created","ROTATE_KEY":"Key rotated","BLOCK":"Blocked","UNBLOCK":"Unblocked","UPDATE_PERMISSIONS":"Permissions updated"}}},"TAB.CARDS":{"HEADER":"Cards","NO_CARDS":"There is no cards in the system","OPTIONS":{"BLOCK":"Block Card","REACTIVATE":"Re-Activate Card"},"STATUS":{"ACTIVE":"Active","INACTIVE":"Inactive","SET":"Assigned"}},"TAB.DOCUMENTS":{"HEADER":"Documents","AUTHORISED_SIGNATORY":"Authorized signatory","DIRECTORS_OF_COMPANY":"Directors of the company","SHAREHOLDERS":"Shareholders","COMPANY_INFORMATION":"Company Information","COMPANY_NAME":"Company name","FIRST_NAME":"First name","LAST_NAME":"Last name","DIRECTOR":"Director","SHAREHOLDER":"Shareholder","IDENTITY_CONFIRMATION":"Identity confirmation","LEGAL_DOCUMENTS":"Legal documents","SELFIE":"Selfie","PROOF_OF_ADDRESS":"Proof Of Address","ARCHIVE_BUTTON":"Save archive","NO_DOCUMENTS":"Sorry! There are not any attachments."},"TAB.DEPENDENT_PROFILES":{"HEADER":"Dependent profiles","EMPTY":{"PROFILES":"Sorry! There are not any dependent profiles."}},"RESET_PASSWORD_DIALOG":{"TITLE":{"SUCCESS":"Reset password for {{username}} is successful","ERROR":"The message hasn’t been delivered. Something went wrong, so please contact tech support to resolve the issue.","DISABLE":"The message hasn’t been delivered as automatic message delivery is inactive for this client."},"BODY":"To reset password copy this link below and send it to customer."}},"VERIFICATION":{"TAB":"Verification","VERIFY_BUTTON":"Verify","UPDATE_BUTTON":"Update","KYC":{"OVERALL":"Overall status:","APPLICANTS_BADGE_EXPLANATION":"KYC:","TAB":"KYC","EMPTY_PROFILE":"Profile has never been verified","TITLE":"KYC Verification Results","CAR":"CRA File"},"ONFIDO":{"APPLICANTS_BADGE_EXPLANATION":"Onfido:","TAB":"Onfido","TITLE":"Onfido Verification Results","EMPTY_PROFILE":"Profile has never been verified","NOT_AVAILABLE":"Onfido in unavailable right now","CREATE_APPLICANT":"New applicant"},"ARIADNEXT":{"APPLICANTS_BADGE_EXPLANATION":"Ariad:","TAB":"Ariadnext","TITLE":"Ariadnext Verification Results","EMPTY_PROFILE":"Profile has never been verified","EXPIRED":"Expired","NOT_AVAILABLE":"Ariadnext in unavailable right now","CREATE_APPLICANT":{"TITLE":"Start verification","MODAL_DESCRIPTION":"How the user should be invited to the verification procedure?","SEND_LINK_TO":"Send link to","START_BUTTON":"Start","CLOSE_BUTTON":"Close","EMAIL":"By Email","PHONE":"By Phone"},"CARD":{"FIRST_NAME":"First name","LAST_NAME":"Last name","PHONE_NUMBER":"Phone number","CREATED":"Created","UPDATED":"Updated","ATTEMPTS":"Verification attempts","UUID":"File UUID","ACTION":{"VERIFY":"Verify","DECLINE":"Decline","START":"Start verification","PDF_DOC":"Passport","PDF_SELFIE":"Selfie"}},"CHECKS":{"SHOW":"Show checks","HIDE":"Hide checks"}},"BLOCK":{"TITLE":{"PROFILE":"Profile verification","COMPANY":"Company verification","SIGNATORY":"Authorized signatory verification","DIRECTORS":"Directors verification","SHAREHOLDERS":"Shareholders verification","SHAREHOLDER":"Shareholder","DIRECTOR":"Director","CHECKS":"User checks","BREAKDOWN":"Report breakdowns","REPORTS":"Check reports"},"DETAILS":"Verification details","STATUS":{"VERIFIED":"Verified","DECLINED":"Declined","OPEN_TO_UPLOAD_DATA":"Open to upload data","OUT_OF_VERIFICATION":"Out of verification","CONSIDER":"Consider","CLEAR":"Clear","AML_FOUND":"AML Found","NOT_VERIFIED":"Not verified","IN_PROGRESS":"In progress","INVALID":"Invalid","CORPORATE":"Corporate","INDIVIDUAL":"Individual","INCOMPLETE_DATA":"Incomplete company data","NONE":"None","ERROR":"Error","WARN":"Warning","OBSOLETE":"Obsolete","OK":"Success"},"FIELD":{"COMPANY_NAME":"Company name","REG_NUMBER":"Registration number","COMPANY_TYPE":"Company type","REG_OFFICE_COUNTRY":"Registered office country","VERIFICATION_DATE":"Verification date","FIRST_NAME":"First name","LAST_NAME":"Last name","DOB":"Date of Birth","NATIONALITY":"Nationality","ADDRESS":"Address","CREATE_DATE_TIME":"Create date and time","COMPLETE_DATE_TIME":"Complete date and time","STATUS":"Status","CHECK_ID":"Check id","REPORT_ID":"Report id","HAS_ERRORS":"Errors","REPORT_NAME":"Report name","REPORT_CREATED_AT":"Created at","LINK":"Link","BREAKDOWNS":"Breakdowns","APPLICANT_ID":"Applicant id","EMAIL":"Email","COLOUR_PICTURE":"Colour picture","TEMPLATE":"Template","COMPROMISED_DOCUMENT":"Compromised document","DATA_COMPARISON":"Data comparison","DATE_OF_BIRTH":"Date of birth","FACE_COMPARISON":"Face comparison","FACE_MATCH":"Face match","IMAGE_INTEGRITY":"Image integrity","FACE_DETECTED":"Face detected","VISUAL_AUTHENTICITY":"Visual authenticity","LIVENESS_DETECTED":"Liveness detected","SPOOFING_DETECTION":"Spoofing detection","ISSUING_COUNTRY":"Issuing country","GENDER":"Gender","DATE_OF_EXPIRY":"Date of expiry","DOCUMENT_TYPE":"Document type","DOCUMENT_NUMBERS":"Document numbers","DATA_CONSISTENCY":"Data consistency","DATA_VALIDATION":"Data validation","DOCUMENT_EXPIRATION":"Document expiration","EXPIRY_DATE":"Expiry date","MRZ":"MRZ","FONTS":"Fonts","PICTURE_FACE_INTEGRITY":"Picture face integrity","SECURITY_FEATURES":"Security features","ORIGINAL_DOCUMENT_PRESENT":"Original document present","DIGITAL_TAMPERING":"Digital tampering","OTHER":"Other","FACE_DETECTION":"Face detection","IMAGE_QUALITY":"Image quality","SUPPORTED_DOCUMENT":"Supported document","POLICE_RECORD":"Police record","SEND_DATE_TIME":"Send date time","NOTIFICATION_LINK":"Notification link","SEND_LINK_APPROACH":"Send link approach","ERROR_REASON":"Error reason"}},"AML":{"TITLE":"AML Results","AML_REASON_FIELDS":"Fields with errors","AML_DETAILS_PEP":"PEP Details"}},"MAILING":{"ITEMS":{"PASSWORD_LINK":"password link","CONFIRM_CODE":"confirm code","RESET_PASSWORD_LINK":"reset password link"},"NOT_SEND":{"MSG":"E-mail {{data}} hasn't been sent yet","SIMPLE_MSG":"E-mail hasn't been sent yet"},"PROCESSING":{"SIMPLE_MSG":"Sending e-mail...","MSG":"Sending {{data}} e-mail ..."},"SUCCESS":{"MSG":"E-mail {{data}} was sent success","SIMPLE_MSG":"E-mail was sent success","APPROVAL_MAIL":"The welcome letter with the account information has been sent"},"ERROR":{"MSG":"Sending {{data}} e-mail error occurred: {{error_message}}","SIMPLE_MSG":"The message hasn’t been delivered. Something went wrong, so please contact tech support to resolve the issue.","DETAILS":"{{error_details}}","FAILURE":"Sending mail was failure","APPROVAL_MAIL":"The welcome letter with the account information has not been sent, so please contact tech support to resolve the issue"},"DISABLED":{"SIMPLE_MSG":"The message hasn’t been delivered as automatic message delivery is inactive for this client."}},"APPROVE":{"STATE_CHANGED":"Profile state changed."},"CONFIRM_CHANGE_STATE":"Confirm process request from {{customer}}"}}

/***/ }),
/* 705 */
/***/ (function(module, exports) {

	module.exports = {"APPLICATIONS":{"NEW":{"TITLE":"Applications/New","NOT_FOUND":"Sorry! There are not any applications in system.","DETAIL":{"TITLE":"Application/New/ID:{{id}}","TAB.DETAILS":{"PRIVATE":{"APPLICANT_INFORMATION":{"TITLE":"Applicant","PERSONAL_DETAILS":{"TITLE":"Personal details","FIRST_NAME":"First name","LAST_NAME":"Last name"},"NATIONALITY":"Nationality","PASSPORT":"NIC / Passport number","PLACE_OF_ISSUE":"Issuing Authority","DATE":{"TITLE":"Date of issue/ expiry","ISSUE":"Date of issue","EXPIRY":"Date of expiry","EXPIRY_WARNING":"Please note, passport is expiring soon. "},"SECOND_NATIONALITY":"Second nationality","RESIDENTIAL_ADDRESS":{"TITLE":"Home address","RESIDENTIAL_POSTAL_ADDRESS":"Home address","RESIDENTIAL_POSTAL_CITY":"City","RESIDENTIAL_POSTAL_COUNTY_OR_REGION":"County or region","RESIDENTIAL_COUNTRY":"Country","RESIDENTIAL_ZIP_CODE":"Postcode / ZIP code"},"POSTAL_ADDRESS":{"TITLE":"Mailing address","POSTAL_ADDRESS":"Mailing address","POSTAL_CITY":"Mailing city","POSTAL_COUNTY_OR_REGION":"Mailing county or region","COUNTRY":"Mailing country","ZIP_CODE":"Postcode / ZIP code"},"PHONE_NUMBER":"Phone number","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","IP_ADDRESS":"IP Address","IP_COUNTRY":"IP Country","BIRTH_DATE":"Date of birth","PLACE_OF_BIRTH":"Place of Birth (Country)","TAX_IDENTIFICATION_NUMBER":"Tax Identification Number","TAX_COUNTRY":"Tax Country","FAX_NUMBER":"Fax number","FACEBOOK_PROFILE":"Facebook profile","LINKEDIN":"LinkedIn","OTHER":"Other","ID_OR_PASSPORT_ATTACHMENT_ITEMS":"ID or Passport attachment items","PASSPORT_SELFIE_ATTACHMENT_ITEMS":"Passport selfie attachment items","ADDRESS_ATTACHMENT_ITEMS":"Address attachment items","SAVE_ALL":"Save all","UPLOAD":{"TITLE":"Upload","ERROR":{"MAX_SIZE":"File size exceeds the permissible value!","FILE_ALREADY_CONFIRMED":"File already exist in the system!","FILE_NOT_FOUND":"File not found!","UNSUPPORTED_FORMAT":"Unsupported format of file!"}},"FILTER":{"NOT_FOUND":{"NATIONALITY_SELECT":"There are no available country","SECOND_NATIONALITY_SELECT":"There are no available country","COUNTRY_SELECT":"There are no available country","RESULT_COUNTRY_SELECT":"No results found","JURISDICTION":"There are no available jurisdiction"}}},"EMPLOYMENT_INFORMATION":{"TITLE":"Employment","PRESENT_OCCUPATION":"Present occupation","EMPLOYMENT_DETAILS":{"TITLE":"Employment details","NAME":"Employer's name/Name of business","ADDRESS":{"TITLE":"Employer's address","POSTAL_ADDRESS":"Employer's office address","POSTAL_CITY":"City","POSTAL_COUNTY_OR_REGION":"County or region","COUNTRY":"Country","ZIP_CODE":"Postcode / ZIP code"},"BUSINESS_SECTOR":"Name of Business Activity","YEARS_IN_EMPLOYMENT":"Number of years in employment/business"}},"PEP_INFORMATION":{"TITLE":"PEP","POSITION_IN_ANY_COUNTRY":"Are you a PEP or linked to a PEP? A \"Politically Exposed Person\" is a natural person (individual) who is or has been entrusted with a prominent public function and includes his or her immediate family members or persons known to be close associates of such persons but excludes middle ranking or more junior officers.","FAMILY_POSITION_IN_ANY_COUNTRY":"Does any member of your close family currently hold, or has ever held any political, diplomatic or governmental office in any country? (Please tick the box if the answer is YES)"},"LITIGATION_INFORMATION":{"TITLE":"Litigation","LITIGATION":"Have you ever been the subject of any legal enquiries, court orders, judgements, bankruptcy proceedings, criminal sanctions (excluding minor traffic incidents)? (Please tick the box if the answer is YES)"},"MASTER_ACCOUNT_INFORMATION":{"TITLE":"Master account","MASTER_ACCOUNT_CURRENCY":"Master account currency","ADDITIONAL_CURRENCIES":"Additional currencies"},"FUNDS_INFORMATION":{"TITLE":"Funds","CRYPTOCURRENCIES":"Will your incoming or outgoing payments relate to cryptocurrencies?","SOURCE_OF_INITIAL_FUNDING":{"TITLE":"Source of Initial funding","JURISDICTION":"Jurisdiction","AVERAGE_MONTHLY_INCOME":"What is your average monthly income?","PRIMARY_INCOME_SOURCE":"Please provide your primary income source","ORIGINAL_BANK_NAME":"Original bank name","ORIGINAL_BANK_ADDRESS":"Original bank address","ACCOUNT_NAME":"Account name","SIGNATORY":"Signatory","HOW_FUNDS_GENERATED":"Describe precisely how these funds were generated"},"EXPECTED_TRANSFER_ACTIVITY":{"TITLE":"Expected transfer activity","AVERAGE_VALUE_OF_TRANSFER":"Average value of each transfer ({{currency}})","MAX_VALUE_OF_TRANSFER":"Maximum value of each transfer ({{currency}})","MAIN_COUNTRIES_TO":"Countries to which transfers will be made","MAIN_COUNTRIES_FROM":"Countries from which transfers will be received","PURPOSE_OF_ACCOUNT":" Purpose of this account","AVERAGE_INCOMING_TRANSACTION":"Average transaction value/size","PLANNED_MONTHLY_INCOMING_TURNOVER":"Planned monthly turnover of incoming payments using {{vendorTitle}} account","MONTHLY_INCOMING_FREQUENCY":"Monthly frequency of payments","AVERAGE_OUTGOING_TRANSACTION":"Average outgoing transaction value/size","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Planned monthly turnover of outgoing payments on {{vendorTitle}} account","MONTHLY_OUTGOING_FREQUENCY":"Monthly frequency of outgoing payments"},"RANGE":{"UP":"Up to {{amountTo}} {{unit}}","FROM_TO":"From {{amountFrom}} {{unit}} to {{amountTo}} {{unit}}","MORE":"More than {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Up to {{amountTo}}","FROM_TO":"From {{amountFrom}} to {{amountTo}}","MORE":"More than {{amountFrom}}"}},"INTRODUCER_INFORMATION":{"TITLE":"Introducer/Reseller","INTRODUCER_NAME":"Introducer/reseller name","INTRODUCER_EMAIL":"Introducer/reseller email"},"ABOUT_YOURSELF_INFORMATION":{"TITLE":"Tell us about yourself","PRODUCTS":"What {{company}} products/services are you planning to use?","PRODUCTS_CUSTOM":"Products custom","REASONS":"Reasons","REASONS_CUSTOM":"Reasons custom","INFORMATION_SOURCE":"Information sources","INFORMATION_SOURCES_CUSTOM":"Information sources custom","USA_CITIZEN":"By ticking the box I declare that I am NOT a citizen and/or a tax resident of the USA."},"REQUIRED_INPUT":"This field is required!","MINIMUM_LENGTH":"Minimum length is {{value}} symbols","MAXIMUM_LENGTH":"Maximum length is {{value}} symbols"},"EDIT.BUTTON.NAME":"Edit","HEADER":"Details","UNAVAILABLE_CURRENCY":" is unavailable at the moment","SAVE.BUTTON.NAME":"Save","SAVE_ALL.BUTTON.NAME":"Save all","UPLOAD.BUTTON.NAME":"Upload","CANCEL.BUTTON.NAME":"Cancel","DISCARD.BUTTON.NAME":"Discard","REMOVE.BUTTON.NAME":"Remove","ADD_NEW.BUTTON.NAME":"Add new","CHOSE.BUTTON.NAME":"Chose files","UPLOAD.DOCUMENT.HEADER":"Upload document","OTHER":"Other","CORPORATE":{"COMMON":{"FIRST_NAME":"First name","LAST_NAME":"Last name","DATE_OF_BIRTH":"Date of birth","ATTORNEY_POWER_EXPIRE_DATE":"Expiry date of power of attorney (if applicable)","JOB_TITLE_OCCUPATION":"Job title / Occupation","NIC_PASSPORT_ID":"NIC/Passport No","IS_PEP":"Is this person a PEP or linked to a PEP?","TRUE":"True","FALSE":"False","NATIONALITY":"Nationality","SECOND_NATIONALITY":"Second nationality","ADDRESS_LINE":"Address line","COUNTRY":"Country","COUNTY_REGION":"County / Region","CITY":"City","ZIP_CODE":"Postcode / ZIP code","RESULT_COUNTRY_SELECT":"No results found","PHONE_NUMBER":"Phone number","MOBILE":"Mobile","LINKEDIN":"Linkedin","FACEBOOK":"Facebook","WEBSITE":"Website","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","NAME_OF_CORPORATE_SHAREHOLDER":"Name of corporate shareholder","LEGAL_DOCUMENTS":"Legal documents","LEGAL_DOCUMENTS_VERIFY":"Legal documents(Check to Verify)","LEGAL_DOCUMENTS_VERIFY_UPDATED":"Document status has been updated","PERSONAL_INFORMATION":"Personal information","COMPANY_INFORMATION":"Company information","COMPANY_NAME":"Company name","COUNTRY_OF_INCORPORATION":"Country of incorporation","COMPANY_REGISTRATION_NUMBER":"Company registration number","COMPANY_ADDRESS":"Company address (Optional)","COMPANY_CONTACTS":"Company contacts","HOME_ADDRESS":"Home address (Optional)","CONTACTS":"Contacts","INDIVIDUAL":"Individual","CORPORATE":"Corporate","IDENTITY_CONFIRMATION":"Identity confirmation","CORPORATE_STRUCTURE":"Corporate Structure","YES":"Yes","NO":"No","PROOF_OF_ADDRESS":"Proof of address","OPTIONAL_ADDRESS":"Optional address","INVALID_VALUE":"Invalid value"},"BUSINESS_CUSTOMER_INFORMATION":{"TITLE":"Business Customer Information","DATE_OF_REGISTRATION":"Date of registration","REGISTRATION_NUMBER":"Registration number","TRADING_NAME":"Trading name","TAX_IDENTIFICATION_NUMBER":"Tax Identification Number","USER_EMAIL":"Email","BUSINESS_ACTIVITIES":"Business activities","SEARCH_BUSINESS_ACTIVITIES":"Search business activities","COMPANY_PHONE":"Company phone","IP_ADDRESS":"IP Address","IP_COUNTRY":"IP Country"},"REGISTERED_OFFICE_ADDRESS":{"TITLE":"Registered office address"},"OFFICIAL_BUSINESS_LOCATION":{"TITLE":"Official business location","PROOF_OF_ADDRESS":"Documents for proof of address"},"CONTACT_INFORMATION":{"TITLE":"Contact Information","PHONE_NUMBER":"Phone number"},"STATEMENT_OF_AFFAIRS":{"TITLE":"Statement of Affairs","SPECIFIC_COUNTRIES":"Specific countries of Operations Targeted markets","NATURE_OF_BUSINESS":"Nature of business"},"INITIAL_DEPOSITS":{"TITLE":"Source of funds","SOURCE_OF_INITIAL_DEPOSIT":"Describe source of initial deposit","ORIGINATING_BANK_JURISDICTION":"Originating Bank Jurisdiction","DESCRIBE_FUNDS_WERE_GENERATED":"Describe precisely how these funds were generated","AMOUNT":"Amount","CURRENCY":"Currency","ACCOUNT_NAME":"Account name"},"EXPECTED_TURNOVER":{"TITLE":"Expected turnover","AVERAGE_INCOMING_TRANSACTION":"Average transaction value/size","PLANNED_MONTHLY_INCOMING_TURNOVER":"Planned monthly turnover of incoming payments using {{vendorTitle}} account","MONTHLY_INCOMING_FREQUENCY":"Monthly frequency of payments","AVERAGE_OUTGOING_TRANSACTION":"Average outgoing transaction value/size","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Planned monthly turnover of outgoing payments on {{vendorTitle}} account","MONTHLY_OUTGOING_FREQUENCY":"Monthly frequency of outgoing payments","RANGE":{"UP":"Up to {{amountTo}} {{unit}}","FROM_TO":"From {{amountFrom}} {{unit}} to {{amountTo}} {{unit}}","MORE":"More than {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Up to {{amountTo}}","FROM_TO":"From {{amountFrom}} to {{amountTo}}","MORE":"More than {{amountFrom}}"},"MAIN_SUPPLIERS":"Main counterparties for outgoing payments (name/jurisdiction)","MAIN_CLIENTS":"Main counterparties for incoming payments (name/jurisdiction)"},"AUTHORISED_SIGNATORY":{"TITLE":"Authorized signatory","SAVE_ALL":"Save all","DETAILS":"Authorized signatory details","ADDRESS":"Authorized signatory address","CONTACTS":"Authorized signatory contacts","PASSPORT":"Passport","SELFIE":"Selfie with ID Card"},"DIRECTORS":{"TITLE":"Directors of the company","DIRECTOR_TYPE":"Director type","NIC_PASSPORT_ID":"Passport/ID number"},"SHAREHOLDERS":{"TITLE":"Shareholders","SHARE_NUMBER":"Share: {{share}}%","SHARE":"Share: %","EMPTY":"Sorry! There are no shareholders.","SHAREHOLDER_TYPE":"Shareholder type","SHAREHOLDER_SUM_ERROR":"Share % sum should be equal 100%","NIC_PASSPORT_ID":"Passport/ID number"},"INTRODUCER":{"TITLE":"Introducer/Reseller","INTRODUCER_NAME":"Introducer/reseller name","INTRODUCER_EMAIL":"Introducer/reseller email"},"ACCOUNT_CURRENCIES":{"TITLE":"Account currencies","MASTER_ACCOUNT_CURRENCY":"Master account currency","ADDITIONAL_CURRENCIES":"Additional currencies"},"USAGE_AND_REFERRAL":{"TITLE":"Usage and referral","WHAT_PRODUCTS_SERVICES":"What {{company}} products/services are you planning to use?","REASON_FOR_CHOOSING":"Reason for choosing {{company}}","SOURCE_OF_INFORMATION":"Source of information about {{company}}?"}}},"TAB.DOCUMENTS":{"HEADER":"Documents","IDENTITY_CONFIRMATION":"Identity confirmation","LEGAL_DOCUMENTS":"Legal documents","SELFIE":"Selfie","PROOF_OF_ADDRESS":"Proof Of Address","ARCHIVE_BUTTON":"Save archive","NO_DOCUMENTS":"Sorry! There are not any attachments."}},"PROCESS":{"CONFIRM.TITLE":"Confirm process request","CONFIRM.MESSAGE":"This customer will be in <b>process</b> status, are you sure you want to continue?","CONFIRM.MODULR.MESSAGE":"This customer will be in process status, are you sure you want to continue?","CONFIRM.BUTTON":"Confirm","AGENT.MESSAGE":"This customer will be in <b>process</b> status as an Agent, are you sure you want to continue?","MOORWAND.MESSAGE":"This customer will be <b>process</b> with Moorwand, are you sure you want to continue?","EMONEY.MESSAGE":"This customer will be <b>process</b> with Emoney, are you sure you want to continue?"}},"MANUAL_REVIEW":{"TITLE":"Applications/Manual Review","NOT_FOUND":"Sorry! There are not any applications in system.","DETAIL":{"TITLE":"Application/Manual Review/ID:{{id}}","TAB.DETAILS":{"PRIVATE":{"APPLICANT_INFORMATION":{"TITLE":"Applicant","PERSONAL_DETAILS":{"TITLE":"Personal details","FIRST_NAME":"First name","LAST_NAME":"Last name"},"NATIONALITY":"Nationality","PASSPORT":"NIC / Passport number","PLACE_OF_ISSUE":"Issuing Authority","DATE":{"TITLE":"Date of issue/ expiry","ISSUE":"Date of issue","EXPIRY":"Date of expiry","EXPIRY_WARNING":"Please note, passport is expiring soon. "},"SECOND_NATIONALITY":"Second nationality","RESIDENTIAL_ADDRESS":{"TITLE":"Home address","RESIDENTIAL_POSTAL_ADDRESS":"Home address","RESIDENTIAL_POSTAL_CITY":"City","RESIDENTIAL_POSTAL_COUNTY_OR_REGION":"County or region","RESIDENTIAL_COUNTRY":"Country","RESIDENTIAL_ZIP_CODE":"Postcode / ZIP code"},"POSTAL_ADDRESS":{"TITLE":"Mailing address","POSTAL_ADDRESS":"Mailing address","POSTAL_CITY":"Mailing city","POSTAL_COUNTY_OR_REGION":"Mailing county or region","COUNTRY":"Mailing country","ZIP_CODE":"Postcode / ZIP code"},"PHONE_NUMBER":"Phone number","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","IP_ADDRESS":"IP Address","IP_COUNTRY":"IP Country","BIRTH_DATE":"Date of birth","PLACE_OF_BIRTH":"Place of Birth (Country)","TAX_IDENTIFICATION_NUMBER":"Tax Identification Number","TAX_COUNTRY":"Tax Country","FAX_NUMBER":"Fax number","FACEBOOK_PROFILE":"Facebook profile","LINKEDIN":"LinkedIn","OTHER":"Other","ID_OR_PASSPORT_ATTACHMENT_ITEMS":"ID or Passport attachment items","PASSPORT_SELFIE_ATTACHMENT_ITEMS":"Passport selfie attachment items","ADDRESS_ATTACHMENT_ITEMS":"Address attachment items","SAVE_ALL":"Save all","UPLOAD":{"TITLE":"Upload","ERROR":{"MAX_SIZE":"File size exceeds the permissible value!","FILE_ALREADY_CONFIRMED":"File already exist in the system!","FILE_NOT_FOUND":"File not found!","UNSUPPORTED_FORMAT":"Unsupported format of file!"}},"FILTER":{"NOT_FOUND":{"NATIONALITY_SELECT":"There are no available country","SECOND_NATIONALITY_SELECT":"There are no available country","COUNTRY_SELECT":"There are no available country","RESULT_COUNTRY_SELECT":"No results found","JURISDICTION":"There are no available jurisdiction"}}},"EMPLOYMENT_INFORMATION":{"TITLE":"Employment","PRESENT_OCCUPATION":"Present occupation","EMPLOYMENT_DETAILS":{"TITLE":"Employment details","NAME":"Employer's name/Name of business","ADDRESS":{"TITLE":"Employer's address","POSTAL_ADDRESS":"Employer's office address","POSTAL_CITY":"City","POSTAL_COUNTY_OR_REGION":"County or region","COUNTRY":"Country","ZIP_CODE":"Postcode / ZIP code"},"BUSINESS_SECTOR":"Name of Business Activity","YEARS_IN_EMPLOYMENT":"Number of years in employment/business"}},"PEP_INFORMATION":{"TITLE":"PEP","POSITION_IN_ANY_COUNTRY":"Are you a PEP or linked to a PEP? A \"Politically Exposed Person\" is a natural person (individual) who is or has been entrusted with a prominent public function and includes his or her immediate family members or persons known to be close associates of such persons but excludes middle ranking or more junior officers.","FAMILY_POSITION_IN_ANY_COUNTRY":"Does any member of your close family currently hold, or has ever held any political, diplomatic or governmental office in any country? (Please tick the box if the answer is YES)"},"LITIGATION_INFORMATION":{"TITLE":"Litigation","LITIGATION":"Have you ever been the subject of any legal enquiries, court orders, judgements, bankruptcy proceedings, criminal sanctions (excluding minor traffic incidents)? (Please tick the box if the answer is YES)"},"MASTER_ACCOUNT_INFORMATION":{"TITLE":"Master account","MASTER_ACCOUNT_CURRENCY":"Master account currency","ADDITIONAL_CURRENCIES":"Additional currencies"},"FUNDS_INFORMATION":{"TITLE":"Funds","SOURCE_OF_INITIAL_FUNDING":{"TITLE":"Source of Initial funding","JURISDICTION":"Jurisdiction","AVERAGE_MONTHLY_INCOME":"What is your average monthly income?","PRIMARY_INCOME_SOURCE":"Please provide your primary income source","ORIGINAL_BANK_NAME":"Original bank name","ORIGINAL_BANK_ADDRESS":"Original bank address","ACCOUNT_NAME":"Account name","SIGNATORY":"Signatory","HOW_FUNDS_GENERATED":"Describe precisely how these funds were generated"},"EXPECTED_TRANSFER_ACTIVITY":{"TITLE":"Expected transfer activity","AVERAGE_VALUE_OF_TRANSFER":"Average value of each transfer ({{currency}})","MAX_VALUE_OF_TRANSFER":"Maximum value of each transfer ({{currency}})","MAIN_COUNTRIES_TO":"Countries to which transfers will be made","MAIN_COUNTRIES_FROM":"Countries from which transfers will be received","PURPOSE_OF_ACCOUNT":" Purpose of this account","AVERAGE_INCOMING_TRANSACTION":"Average transaction value/size","PLANNED_MONTHLY_INCOMING_TURNOVER":"Planned monthly turnover of incoming payments using {{vendorTitle}} account","MONTHLY_INCOMING_FREQUENCY":"Monthly frequency of payments","AVERAGE_OUTGOING_TRANSACTION":"Average outgoing transaction value/size","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Planned monthly turnover of outgoing payments on {{vendorTitle}} account","MONTHLY_OUTGOING_FREQUENCY":"Monthly frequency of outgoing payments"},"RANGE":{"UP":"Up to {{amountTo}} {{unit}}","FROM_TO":"From {{amountFrom}} {{unit}} to {{amountTo}} {{unit}}","MORE":"More than {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Up to {{amountTo}}","FROM_TO":"From {{amountFrom}} to {{amountTo}}","MORE":"More than {{amountFrom}}"}},"INTRODUCER_INFORMATION":{"TITLE":"Introducer/Reseller","INTRODUCER_NAME":"Introducer/reseller name","INTRODUCER_EMAIL":"Introducer/reseller email"},"ABOUT_YOURSELF_INFORMATION":{"TITLE":"Tell us about yourself","PRODUCTS":"What {{company}} products/services are you planning to use?","PRODUCTS_CUSTOM":"Products custom","REASONS":"Reasons","REASONS_CUSTOM":"Reasons custom","INFORMATION_SOURCE":"Information sources","INFORMATION_SOURCES_CUSTOM":"Information sources custom","USA_CITIZEN":"By ticking the box I declare that I am NOT a citizen and/or a tax resident of the USA."},"REQUIRED_INPUT":"This field is required!","MINIMUM_LENGTH":"Minimum length is {{value}} symbols","MAXIMUM_LENGTH":"Maximum length is {{value}} symbols"},"EDIT.BUTTON.NAME":"Edit","HEADER":"Details","UNAVAILABLE_CURRENCY":" is unavailable at the moment","SAVE.BUTTON.NAME":"Save","SAVE_ALL.BUTTON.NAME":"Save all","UPLOAD.BUTTON.NAME":"Upload","CANCEL.BUTTON.NAME":"Cancel","DISCARD.BUTTON.NAME":"Discard","REMOVE.BUTTON.NAME":"Remove","ADD_NEW.BUTTON.NAME":"Add new","CHOSE.BUTTON.NAME":"Chose files","UPLOAD.DOCUMENT.HEADER":"Upload document","OTHER":"Other","CORPORATE":{"COMMON":{"FIRST_NAME":"First name","LAST_NAME":"Last name","DATE_OF_BIRTH":"Date of birth","ATTORNEY_POWER_EXPIRE_DATE":"Expiry date of power of attorney (if applicable)","JOB_TITLE_OCCUPATION":"Job title / Occupation","NIC_PASSPORT_ID":"NIC/Passport No","IS_PEP":"Is this person a PEP or linked to a PEP?","TRUE":"True","FALSE":"False","NATIONALITY":"Nationality","SECOND_NATIONALITY":"Second nationality","ADDRESS_LINE":"Address line","COUNTRY":"Country","COUNTY_REGION":"County / Region","CITY":"City","ZIP_CODE":"Postcode / ZIP code","RESULT_COUNTRY_SELECT":"No results found","PHONE_NUMBER":"Phone number","MOBILE":"Mobile","LINKEDIN":"Linkedin","FACEBOOK":"Facebook","WEBSITE":"Website","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","NAME_OF_CORPORATE_SHAREHOLDER":"Name of corporate shareholder","LEGAL_DOCUMENTS":"Legal documents","PERSONAL_INFORMATION":"Personal information","COMPANY_INFORMATION":"Company information","COMPANY_NAME":"Company name","COUNTRY_OF_INCORPORATION":"Country of incorporation","COMPANY_REGISTRATION_NUMBER":"Company registration number","COMPANY_ADDRESS":"Company address (Optional)","COMPANY_CONTACTS":"Company contacts","HOME_ADDRESS":"Home address (Optional)","CONTACTS":"Contacts","INDIVIDUAL":"Individual","CORPORATE":"Corporate","IDENTITY_CONFIRMATION":"Identity confirmation","YES":"Yes","NO":"No","PROOF_OF_ADDRESS":"Proof of address","OPTIONAL_ADDRESS":"Optional address","INVALID_VALUE":"Invalid value"},"BUSINESS_CUSTOMER_INFORMATION":{"TITLE":"Business Customer Information","DATE_OF_REGISTRATION":"Date of registration","REGISTRATION_NUMBER":"Registration number","TRADING_NAME":"Trading name","TAX_IDENTIFICATION_NUMBER":"Tax Identification Number","BUSINESS_ACTIVITIES":"Business activities","SEARCH_BUSINESS_ACTIVITIES":"Search business activities","COMPANY_PHONE":"Company phone","IP_ADDRESS":"IP Address","IP_COUNTRY":"IP Country"},"REGISTERED_OFFICE_ADDRESS":{"TITLE":"Registered office address"},"OFFICIAL_BUSINESS_LOCATION":{"TITLE":"Official business location","PROOF_OF_ADDRESS":"Documents for proof of address"},"CONTACT_INFORMATION":{"TITLE":"Contact Information","PHONE_NUMBER":"Phone number"},"STATEMENT_OF_AFFAIRS":{"TITLE":"Statement of Affairs","SPECIFIC_COUNTRIES":"Specific countries of Operations Targeted markets","NATURE_OF_BUSINESS":"Nature of business"},"INITIAL_DEPOSITS":{"TITLE":"Source of funds","SOURCE_OF_INITIAL_DEPOSIT":"Describe source of initial deposit","ORIGINATING_BANK_JURISDICTION":"Originating Bank Jurisdiction","DESCRIBE_FUNDS_WERE_GENERATED":"Describe precisely how these funds were generated","AMOUNT":"Amount","CURRENCY":"Currency","ACCOUNT_NAME":"Account name"},"EXPECTED_TURNOVER":{"TITLE":"Expected turnover","AVERAGE_INCOMING_TRANSACTION":"Average transaction value/size","PLANNED_MONTHLY_INCOMING_TURNOVER":"Planned monthly turnover of incoming payments using {{vendorTitle}} account","MONTHLY_INCOMING_FREQUENCY":"Monthly frequency of payments","AVERAGE_OUTGOING_TRANSACTION":"Average outgoing transaction value/size","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Planned monthly turnover of outgoing payments on {{vendorTitle}} account","MONTHLY_OUTGOING_FREQUENCY":"Monthly frequency of outgoing payments","RANGE":{"UP":"Up to {{amountTo}} {{unit}}","FROM_TO":"From {{amountFrom}} {{unit}} to {{amountTo}} {{unit}}","MORE":"More than {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Up to {{amountTo}}","FROM_TO":"From {{amountFrom}} to {{amountTo}}","MORE":"More than {{amountFrom}}"},"MAIN_SUPPLIERS":"Main counterparties for outgoing payments (name/jurisdiction)","MAIN_CLIENTS":"Main counterparties for incoming payments (name/jurisdiction)"},"AUTHORISED_SIGNATORY":{"TITLE":"Authorized signatory","SAVE_ALL":"Save all","DETAILS":"Authorized signatory details","ADDRESS":"Authorized signatory address","CONTACTS":"Authorized signatory contacts","PASSPORT":"Passport","SELFIE":"Selfie with ID Card"},"DIRECTORS":{"TITLE":"Directors of the company","DIRECTOR_TYPE":"Director type","NIC_PASSPORT_ID":"Passport/ID number"},"SHAREHOLDERS":{"TITLE":"Shareholders","SHARE_NUMBER":"Share: {{share}}%","SHARE":"Share: %","EMPTY":"Sorry! There are no shareholders.","SHAREHOLDER_TYPE":"Shareholder type","SHAREHOLDER_SUM_ERROR":"Share % sum should be equal 100%","NIC_PASSPORT_ID":"Passport/ID number"},"INTRODUCER":{"TITLE":"Introducer/Reseller","INTRODUCER_NAME":"Introducer/reseller name","INTRODUCER_EMAIL":"Introducer/reseller email"},"ACCOUNT_CURRENCIES":{"TITLE":"Account currencies","MASTER_ACCOUNT_CURRENCY":"Master account currency","ADDITIONAL_CURRENCIES":"Additional currencies"},"USAGE_AND_REFERRAL":{"TITLE":"Usage and referral","WHAT_PRODUCTS_SERVICES":"What {{company}} products/services are you planning to use?","REASON_FOR_CHOOSING":"Reason for choosing {{company}}","SOURCE_OF_INFORMATION":"Source of information about {{company}}?"}}},"TAB.DOCUMENTS":{"HEADER":"Documents","IDENTITY_CONFIRMATION":"Identity confirmation","LEGAL_DOCUMENTS":"Legal documents","SELFIE":"Selfie","PROOF_OF_ADDRESS":"Proof Of Address","ARCHIVE_BUTTON":"Save archive","NO_DOCUMENTS":"Sorry! There are not any attachments."},"CUSTOM_REASON":"Custom Reason","TABLE_REASONS":{"HEADER":{"NAME":"Reason"},"EMPTY":"Sorry! There are no reasons."},"TAB_MANUAL_REVIEW":{"TITLE":"Manual Review Details"}},"PROCESS":{"CONFIRM.TITLE":"Confirm process request","CONFIRM.MESSAGE":"This customer will be moved to <b>processing</b> status, are you sure you want to continue?","CONFIRM.BUTTON":"Confirm"}},"ON_HOLD":{"TITLE":"Applications/On hold","NOT_FOUND":"Sorry! There are not any applications in system.","DETAIL":{"TITLE":"Application/On hold/ID:{{id}}","TAB.DETAILS":{"PRIVATE":{"APPLICANT_INFORMATION":{"TITLE":"Applicant","PERSONAL_DETAILS":{"TITLE":"Personal details","FIRST_NAME":"First name","LAST_NAME":"Last name"},"NATIONALITY":"Nationality","PASSPORT":"NIC / Passport number","PLACE_OF_ISSUE":"Issuing Authority","DATE":{"TITLE":"Date of issue/ expiry","ISSUE":"Date of issue","EXPIRY":"Date of expiry","EXPIRY_WARNING":"Please note, passport is expiring soon. "},"SECOND_NATIONALITY":"Second nationality","RESIDENTIAL_ADDRESS":{"TITLE":"Home address","RESIDENTIAL_POSTAL_ADDRESS":"Home address","RESIDENTIAL_POSTAL_CITY":"City","RESIDENTIAL_POSTAL_COUNTY_OR_REGION":"County or region","RESIDENTIAL_COUNTRY":"Country","RESIDENTIAL_ZIP_CODE":"Postcode / ZIP code"},"POSTAL_ADDRESS":{"TITLE":"Mailing address","POSTAL_ADDRESS":"Mailing address","POSTAL_CITY":"Mailing city","POSTAL_COUNTY_OR_REGION":"Mailing county or region","COUNTRY":"Mailing country","ZIP_CODE":"Postcode / ZIP code"},"PHONE_NUMBER":"Phone number","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","IP_ADDRESS":"IP Address","IP_COUNTRY":"IP Country","BIRTH_DATE":"Date of birth","PLACE_OF_BIRTH":"Place of Birth (Country)","TAX_IDENTIFICATION_NUMBER":"Tax Identification Number","TAX_COUNTRY":"Tax Country","FAX_NUMBER":"Fax number","FACEBOOK_PROFILE":"Facebook profile","LINKEDIN":"LinkedIn","OTHER":"Other","ID_OR_PASSPORT_ATTACHMENT_ITEMS":"ID or Passport attachment items","PASSPORT_SELFIE_ATTACHMENT_ITEMS":"Passport selfie attachment items","ADDRESS_ATTACHMENT_ITEMS":"Address attachment items","SAVE_ALL":"Save all","UPLOAD":{"TITLE":"Upload","ERROR":{"MAX_SIZE":"File size exceeds the permissible value!","FILE_ALREADY_CONFIRMED":"File already exist in the system!","FILE_NOT_FOUND":"File not found!","UNSUPPORTED_FORMAT":"Unsupported format of file!"}},"FILTER":{"NOT_FOUND":{"NATIONALITY_SELECT":"There are no available country","SECOND_NATIONALITY_SELECT":"There are no available country","COUNTRY_SELECT":"There are no available country","RESULT_COUNTRY_SELECT":"No results found","JURISDICTION":"There are no available jurisdiction"}}},"EMPLOYMENT_INFORMATION":{"TITLE":"Employment","PRESENT_OCCUPATION":"Present occupation","EMPLOYMENT_DETAILS":{"TITLE":"Employment details","NAME":"Employer's name/Name of business","ADDRESS":{"TITLE":"Employer's address","POSTAL_ADDRESS":"Employer's office address","POSTAL_CITY":"City","POSTAL_COUNTY_OR_REGION":"County or region","COUNTRY":"Country","ZIP_CODE":"Postcode / ZIP code"},"BUSINESS_SECTOR":"Name of Business Activity","YEARS_IN_EMPLOYMENT":"Number of years in employment/business"}},"PEP_INFORMATION":{"TITLE":"PEP","POSITION_IN_ANY_COUNTRY":"Are you a PEP or linked to a PEP? A \"Politically Exposed Person\" is a natural person (individual) who is or has been entrusted with a prominent public function and includes his or her immediate family members or persons known to be close associates of such persons but excludes middle ranking or more junior officers.","FAMILY_POSITION_IN_ANY_COUNTRY":"Does any member of your close family currently hold, or has ever held any political, diplomatic or governmental office in any country? (Please tick the box if the answer is YES)"},"LITIGATION_INFORMATION":{"TITLE":"Litigation","LITIGATION":"Have you ever been the subject of any legal enquiries, court orders, judgements, bankruptcy proceedings, criminal sanctions (excluding minor traffic incidents)? (Please tick the box if the answer is YES)"},"MASTER_ACCOUNT_INFORMATION":{"TITLE":"Master account","MASTER_ACCOUNT_CURRENCY":"Master account currency","ADDITIONAL_CURRENCIES":"Additional currencies"},"FUNDS_INFORMATION":{"TITLE":"Funds","SOURCE_OF_INITIAL_FUNDING":{"TITLE":"Source of Initial funding","JURISDICTION":"Jurisdiction","AVERAGE_MONTHLY_INCOME":"What is your average monthly income?","PRIMARY_INCOME_SOURCE":"Please provide your primary income source","ORIGINAL_BANK_NAME":"Original bank name","ORIGINAL_BANK_ADDRESS":"Original bank address","ACCOUNT_NAME":"Account name","SIGNATORY":"Signatory","HOW_FUNDS_GENERATED":"Describe precisely how these funds were generated"},"EXPECTED_TRANSFER_ACTIVITY":{"TITLE":"Expected transfer activity","AVERAGE_VALUE_OF_TRANSFER":"Average value of each transfer ({{currency}})","MAX_VALUE_OF_TRANSFER":"Maximum value of each transfer ({{currency}})","MAIN_COUNTRIES_TO":"Countries to which transfers will be made","MAIN_COUNTRIES_FROM":"Countries from which transfers will be received","PURPOSE_OF_ACCOUNT":" Purpose of this account","AVERAGE_INCOMING_TRANSACTION":"Average transaction value/size","PLANNED_MONTHLY_INCOMING_TURNOVER":"Planned monthly turnover of incoming payments using {{vendorTitle}} account","MONTHLY_INCOMING_FREQUENCY":"Monthly frequency of payments","AVERAGE_OUTGOING_TRANSACTION":"Average outgoing transaction value/size","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Planned monthly turnover of outgoing payments on {{vendorTitle}} account","MONTHLY_OUTGOING_FREQUENCY":"Monthly frequency of outgoing payments"},"RANGE":{"UP":"Up to {{amountTo}} {{unit}}","FROM_TO":"From {{amountFrom}} {{unit}} to {{amountTo}} {{unit}}","MORE":"More than {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Up to {{amountTo}}","FROM_TO":"From {{amountFrom}} to {{amountTo}}","MORE":"More than {{amountFrom}}"}},"INTRODUCER_INFORMATION":{"TITLE":"Introducer/Reseller","INTRODUCER_NAME":"Introducer/reseller name","INTRODUCER_EMAIL":"Introducer/reseller email"},"ABOUT_YOURSELF_INFORMATION":{"TITLE":"Tell us about yourself","PRODUCTS":"What {{company}} products/services are you planning to use?","PRODUCTS_CUSTOM":"Products custom","REASONS":"Reasons","REASONS_CUSTOM":"Reasons custom","INFORMATION_SOURCE":"Information sources","INFORMATION_SOURCES_CUSTOM":"Information sources custom","USA_CITIZEN":"By ticking the box I declare that I am NOT a citizen and/or a tax resident of the USA."},"REQUIRED_INPUT":"This field is required!","MINIMUM_LENGTH":"Minimum length is {{value}} symbols","MAXIMUM_LENGTH":"Maximum length is {{value}} symbols"},"EDIT.BUTTON.NAME":"Edit","HEADER":"Details","UNAVAILABLE_CURRENCY":" is unavailable at the moment","SAVE.BUTTON.NAME":"Save","SAVE_ALL.BUTTON.NAME":"Save all","UPLOAD.BUTTON.NAME":"Upload","CANCEL.BUTTON.NAME":"Cancel","DISCARD.BUTTON.NAME":"Discard","REMOVE.BUTTON.NAME":"Remove","ADD_NEW.BUTTON.NAME":"Add new","CHOSE.BUTTON.NAME":"Chose files","UPLOAD.DOCUMENT.HEADER":"Upload document","OTHER":"Other","CORPORATE":{"COMMON":{"FIRST_NAME":"First name","LAST_NAME":"Last name","DATE_OF_BIRTH":"Date of birth","ATTORNEY_POWER_EXPIRE_DATE":"Expiry date of power of attorney (if applicable)","JOB_TITLE_OCCUPATION":"Job title / Occupation","NIC_PASSPORT_ID":"NIC/Passport No","IS_PEP":"Is this person a PEP or linked to a PEP?","TRUE":"True","FALSE":"False","NATIONALITY":"Nationality","SECOND_NATIONALITY":"Second nationality","ADDRESS_LINE":"Address line","COUNTRY":"Country","COUNTY_REGION":"County / Region","CITY":"City","ZIP_CODE":"Postcode / ZIP code","RESULT_COUNTRY_SELECT":"No results found","PHONE_NUMBER":"Phone number","MOBILE":"Mobile","LINKEDIN":"Linkedin","FACEBOOK":"Facebook","WEBSITE":"Website","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","NAME_OF_CORPORATE_SHAREHOLDER":"Name of corporate shareholder","LEGAL_DOCUMENTS":"Legal documents","PERSONAL_INFORMATION":"Personal information","COMPANY_INFORMATION":"Company information","COMPANY_NAME":"Company name","COUNTRY_OF_INCORPORATION":"Country of incorporation","COMPANY_REGISTRATION_NUMBER":"Company registration number","COMPANY_ADDRESS":"Company address (Optional)","COMPANY_CONTACTS":"Company contacts","HOME_ADDRESS":"Home address (Optional)","CONTACTS":"Contacts","INDIVIDUAL":"Individual","CORPORATE":"Corporate","IDENTITY_CONFIRMATION":"Identity confirmation","YES":"Yes","NO":"No","PROOF_OF_ADDRESS":"Proof of address","OPTIONAL_ADDRESS":"Optional address","INVALID_VALUE":"Invalid value"},"BUSINESS_CUSTOMER_INFORMATION":{"TITLE":"Business Customer Information","DATE_OF_REGISTRATION":"Date of registration","REGISTRATION_NUMBER":"Registration number","TRADING_NAME":"Trading name","TAX_IDENTIFICATION_NUMBER":"Tax Identification Number","BUSINESS_ACTIVITIES":"Business activities","SEARCH_BUSINESS_ACTIVITIES":"Search business activities","COMPANY_PHONE":"Company phone","IP_ADDRESS":"IP Address","IP_COUNTRY":"IP Country"},"REGISTERED_OFFICE_ADDRESS":{"TITLE":"Registered office address"},"OFFICIAL_BUSINESS_LOCATION":{"TITLE":"Official business location","PROOF_OF_ADDRESS":"Documents for proof of address"},"CONTACT_INFORMATION":{"TITLE":"Contact Information","PHONE_NUMBER":"Phone number"},"STATEMENT_OF_AFFAIRS":{"TITLE":"Statement of Affairs","SPECIFIC_COUNTRIES":"Specific countries of Operations Targeted markets","NATURE_OF_BUSINESS":"Nature of business"},"INITIAL_DEPOSITS":{"TITLE":"Source of funds","SOURCE_OF_INITIAL_DEPOSIT":"Describe source of initial deposit","ORIGINATING_BANK_JURISDICTION":"Originating Bank Jurisdiction","DESCRIBE_FUNDS_WERE_GENERATED":"Describe precisely how these funds were generated","AMOUNT":"Amount","CURRENCY":"Currency","ACCOUNT_NAME":"Account name"},"EXPECTED_TURNOVER":{"TITLE":"Expected turnover","AVERAGE_INCOMING_TRANSACTION":"Average transaction value/size","PLANNED_MONTHLY_INCOMING_TURNOVER":"Planned monthly turnover of incoming payments using {{vendorTitle}} account","MONTHLY_INCOMING_FREQUENCY":"Monthly frequency of payments","AVERAGE_OUTGOING_TRANSACTION":"Average outgoing transaction value/size","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Planned monthly turnover of outgoing payments on {{vendorTitle}} account","MONTHLY_OUTGOING_FREQUENCY":"Monthly frequency of outgoing payments","RANGE":{"UP":"Up to {{amountTo}} {{unit}}","FROM_TO":"From {{amountFrom}} {{unit}} to {{amountTo}} {{unit}}","MORE":"More than {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Up to {{amountTo}}","FROM_TO":"From {{amountFrom}} to {{amountTo}}","MORE":"More than {{amountFrom}}"},"MAIN_SUPPLIERS":"Main counterparties for outgoing payments (name/jurisdiction)","MAIN_CLIENTS":"Main counterparties for incoming payments (name/jurisdiction)"},"AUTHORISED_SIGNATORY":{"TITLE":"Authorized signatory","SAVE_ALL":"Save all","DETAILS":"Authorized signatory details","ADDRESS":"Authorized signatory address","CONTACTS":"Authorized signatory contacts","PASSPORT":"Passport","SELFIE":"Selfie with ID Card"},"DIRECTORS":{"TITLE":"Directors of the company","DIRECTOR_TYPE":"Director type","NIC_PASSPORT_ID":"Passport/ID number"},"SHAREHOLDERS":{"TITLE":"Shareholders","SHARE_NUMBER":"Share: {{share}}%","SHARE":"Share: %","EMPTY":"Sorry! There are no shareholders.","SHAREHOLDER_TYPE":"Shareholder type","SHAREHOLDER_SUM_ERROR":"Share % sum should be equal 100%","NIC_PASSPORT_ID":"Passport/ID number"},"INTRODUCER":{"TITLE":"Introducer/Reseller","INTRODUCER_NAME":"Introducer/reseller name","INTRODUCER_EMAIL":"Introducer/reseller email"},"ACCOUNT_CURRENCIES":{"TITLE":"Account currencies","MASTER_ACCOUNT_CURRENCY":"Master account currency","ADDITIONAL_CURRENCIES":"Additional currencies"},"USAGE_AND_REFERRAL":{"TITLE":"Usage and referral","WHAT_PRODUCTS_SERVICES":"What {{company}} products/services are you planning to use?","REASON_FOR_CHOOSING":"Reason for choosing {{company}}","SOURCE_OF_INFORMATION":"Source of information about {{company}}?"}}},"TAB.DOCUMENTS":{"HEADER":"Documents","IDENTITY_CONFIRMATION":"Identity confirmation","LEGAL_DOCUMENTS":"Legal documents","SELFIE":"Selfie","PROOF_OF_ADDRESS":"Proof Of Address","ARCHIVE_BUTTON":"Save archive","NO_DOCUMENTS":"Sorry! There are not any attachments."},"CUSTOM_REASON":"Custom Reason","TABLE_REASONS":{"HEADER":{"NAME":"Reason"},"EMPTY":"Sorry! There are no reasons."},"TAB_ON_HOLD":{"TITLE":"On hold Details"}},"PROCESS":{"CONFIRM.TITLE":"Confirm process request","CONFIRM.MESSAGE":"This customer will be in <b>process</b> status, are you sure you want to continue?","CONFIRM.BUTTON":"Confirm"},"APPROVE":{"HEADER":"Approve registration request from {{name}}?","HEADER_WITHOUT_PROFILE":"Profile state changed.","RISK":{"TITLE":"Risk level","PLACEHOLDER":"Select"},"TARIFF":{"TITLE":"Tariff","PLACEHOLDER":"Select","WHITELABEL_TITLE":"Whitelabel tariff"},"MIN_TOTAL_ASSET":{"TITLE":"Min total asset","ABOUT":"Min total asset currency equals EUR"},"BANK":{"TITLE":"Bank","PLACEHOLDER":"Select","VALIDATION":{"EMPTY_LIST":"No bank assigned with {{currency_code}} at the moment"}},"IBAN":{"TITLE":"IBAN","PLACEHOLDER":"Enter IBAN number","IBAN_WILL_BE_GENERATED":"IBAN will be generated after confirmation"},"LIQUIDITY":{"TITLE":"Liquidity account","PLACEHOLDER":"Select"},"PROFILE_KIND":{"TITLE":"Profile type","PLACEHOLDER":"Select"},"PRODUCT_CODE":{"TITLE":"Product code","PLACEHOLDER":"Select"},"INTRODUCER_NAME":{"TITLE":"Introducer name","PLACEHOLDER":"Select","NOT_FOUND":"Sorry! There are not found any introducer by this condition! Try other search condition, please!"},"SUCCESS":{"TITLE":"Registration approved!","SECURITY_CODE":{"TITLE":"Security Code","TEXT":"Security code for this account is generated. Copy it and send it to the client."},"PASSWORD":{"TITLE":"Link to set a password","TEXT":"To set a password copy this link and send it to the client."}}}},"ARCHIVED":{"TITLE":"Applications/Archived","NOT_FOUND":"Sorry! There are not any applications in system.","DETAIL":{"TITLE":"Application/Archived/ID:{{id}}","TAB.DETAILS":{"PRIVATE":{"APPLICANT_INFORMATION":{"TITLE":"Applicant","PERSONAL_DETAILS":{"TITLE":"Personal details","FIRST_NAME":"First name","LAST_NAME":"Last name"},"NATIONALITY":"Nationality","PASSPORT":"NIC / Passport number","PLACE_OF_ISSUE":"Issuing Authority","DATE":{"TITLE":"Date of issue/ expiry","ISSUE":"Date of issue","EXPIRY":"Date of expiry","EXPIRY_WARNING":"Please note, passport is expiring soon. "},"SECOND_NATIONALITY":"Second nationality","RESIDENTIAL_ADDRESS":{"TITLE":"Home address","RESIDENTIAL_POSTAL_ADDRESS":"Home address","RESIDENTIAL_POSTAL_CITY":"City","RESIDENTIAL_POSTAL_COUNTY_OR_REGION":"County or region","RESIDENTIAL_COUNTRY":"Country","RESIDENTIAL_ZIP_CODE":"Postcode / ZIP code"},"POSTAL_ADDRESS":{"TITLE":"Mailing address","POSTAL_ADDRESS":"Mailing address","POSTAL_CITY":"Mailing city","POSTAL_COUNTY_OR_REGION":"Mailing county or region","COUNTRY":"Mailing country","ZIP_CODE":"Postcode / ZIP code"},"PHONE_NUMBER":"Phone number","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","IP_ADDRESS":"IP Address","IP_COUNTRY":"IP Country","BIRTH_DATE":"Date of birth","PLACE_OF_BIRTH":"Place of Birth (Country)","TAX_IDENTIFICATION_NUMBER":"Tax Identification Number","TAX_COUNTRY":"Tax Country","FAX_NUMBER":"Fax number","FACEBOOK_PROFILE":"Facebook profile","LINKEDIN":"LinkedIn","OTHER":"Other","ID_OR_PASSPORT_ATTACHMENT_ITEMS":"ID or Passport attachment items","PASSPORT_SELFIE_ATTACHMENT_ITEMS":"Passport selfie attachment items","ADDRESS_ATTACHMENT_ITEMS":"Address attachment items","SAVE_ALL":"Save all","UPLOAD":{"TITLE":"Upload","ERROR":{"MAX_SIZE":"File size exceeds the permissible value!","FILE_ALREADY_CONFIRMED":"File already exist in the system!","FILE_NOT_FOUND":"File not found!","UNSUPPORTED_FORMAT":"Unsupported format of file!"}},"FILTER":{"NOT_FOUND":{"NATIONALITY_SELECT":"There are no available country","SECOND_NATIONALITY_SELECT":"There are no available country","COUNTRY_SELECT":"There are no available country","RESULT_COUNTRY_SELECT":"No results found","JURISDICTION":"There are no available jurisdiction"}}},"EMPLOYMENT_INFORMATION":{"TITLE":"Employment","PRESENT_OCCUPATION":"Present occupation","EMPLOYMENT_DETAILS":{"TITLE":"Employment details","NAME":"Employer's name/Name of business","ADDRESS":{"TITLE":"Employer's address","POSTAL_ADDRESS":"Employer's office address","POSTAL_CITY":"City","POSTAL_COUNTY_OR_REGION":"County or region","COUNTRY":"Country","ZIP_CODE":"Postcode / ZIP code"},"BUSINESS_SECTOR":"Name of Business Activity","YEARS_IN_EMPLOYMENT":"Number of years in employment/business"}},"PEP_INFORMATION":{"TITLE":"PEP","POSITION_IN_ANY_COUNTRY":"Are you a PEP or linked to a PEP? A \"Politically Exposed Person\" is a natural person (individual) who is or has been entrusted with a prominent public function and includes his or her immediate family members or persons known to be close associates of such persons but excludes middle ranking or more junior officers.","FAMILY_POSITION_IN_ANY_COUNTRY":"Does any member of your close family currently hold, or has ever held any political, diplomatic or governmental office in any country? (Please tick the box if the answer is YES)"},"LITIGATION_INFORMATION":{"TITLE":"Litigation","LITIGATION":"Have you ever been the subject of any legal enquiries, court orders, judgements, bankruptcy proceedings, criminal sanctions (excluding minor traffic incidents)? (Please tick the box if the answer is YES)"},"MASTER_ACCOUNT_INFORMATION":{"TITLE":"Master account","MASTER_ACCOUNT_CURRENCY":"Master account currency","ADDITIONAL_CURRENCIES":"Additional currencies"},"FUNDS_INFORMATION":{"TITLE":"Funds","SOURCE_OF_INITIAL_FUNDING":{"TITLE":"Source of Initial funding","JURISDICTION":"Jurisdiction","AVERAGE_MONTHLY_INCOME":"What is your average monthly income?","PRIMARY_INCOME_SOURCE":"Please provide your primary income source","ORIGINAL_BANK_NAME":"Original bank name","ORIGINAL_BANK_ADDRESS":"Original bank address","ACCOUNT_NAME":"Account name","SIGNATORY":"Signatory","HOW_FUNDS_GENERATED":"Describe precisely how these funds were generated"},"EXPECTED_TRANSFER_ACTIVITY":{"TITLE":"Expected transfer activity","AVERAGE_VALUE_OF_TRANSFER":"Average value of each transfer ({{currency}})","MAX_VALUE_OF_TRANSFER":"Maximum value of each transfer ({{currency}})","MAIN_COUNTRIES_TO":"Countries to which transfers will be made","MAIN_COUNTRIES_FROM":"Countries from which transfers will be received","PURPOSE_OF_ACCOUNT":" Purpose of this account","AVERAGE_INCOMING_TRANSACTION":"Average transaction value/size","PLANNED_MONTHLY_INCOMING_TURNOVER":"Planned monthly turnover of incoming payments using {{vendorTitle}} account","MONTHLY_INCOMING_FREQUENCY":"Monthly frequency of payments","AVERAGE_OUTGOING_TRANSACTION":"Average outgoing transaction value/size","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Planned monthly turnover of outgoing payments on {{vendorTitle}} account","MONTHLY_OUTGOING_FREQUENCY":"Monthly frequency of outgoing payments"},"RANGE":{"UP":"Up to {{amountTo}} {{unit}}","FROM_TO":"From {{amountFrom}} {{unit}} to {{amountTo}} {{unit}}","MORE":"More than {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Up to {{amountTo}}","FROM_TO":"From {{amountFrom}} to {{amountTo}}","MORE":"More than {{amountFrom}}"}},"INTRODUCER_INFORMATION":{"TITLE":"Introducer/Reseller","INTRODUCER_NAME":"Introducer/reseller name","INTRODUCER_EMAIL":"Introducer/reseller email"},"ABOUT_YOURSELF_INFORMATION":{"TITLE":"Tell us about yourself","PRODUCTS":"What {{company}} products/services are you planning to use?","PRODUCTS_CUSTOM":"Products custom","REASONS":"Reasons","REASONS_CUSTOM":"Reasons custom","INFORMATION_SOURCE":"Information sources","INFORMATION_SOURCES_CUSTOM":"Information sources custom","USA_CITIZEN":"By ticking the box I declare that I am NOT a citizen and/or a tax resident of the USA."},"REQUIRED_INPUT":"This field is required!","MINIMUM_LENGTH":"Minimum length is {{value}} symbols","MAXIMUM_LENGTH":"Maximum length is {{value}} symbols"},"EDIT.BUTTON.NAME":"Edit","HEADER":"Details","UNAVAILABLE_CURRENCY":" is unavailable at the moment","SAVE.BUTTON.NAME":"Save","SAVE_ALL.BUTTON.NAME":"Save all","UPLOAD.BUTTON.NAME":"Upload","CANCEL.BUTTON.NAME":"Cancel","DISCARD.BUTTON.NAME":"Discard","REMOVE.BUTTON.NAME":"Remove","ADD_NEW.BUTTON.NAME":"Add new","CHOSE.BUTTON.NAME":"Chose files","UPLOAD.DOCUMENT.HEADER":"Upload document","OTHER":"Other","CORPORATE":{"COMMON":{"FIRST_NAME":"First name","LAST_NAME":"Last name","DATE_OF_BIRTH":"Date of birth","ATTORNEY_POWER_EXPIRE_DATE":"Expiry date of power of attorney (if applicable)","JOB_TITLE_OCCUPATION":"Job title / Occupation","NIC_PASSPORT_ID":"NIC/Passport No","IS_PEP":"Is this person a PEP or linked to a PEP?","TRUE":"True","FALSE":"False","NATIONALITY":"Nationality","SECOND_NATIONALITY":"Second nationality","ADDRESS_LINE":"Address line","COUNTRY":"Country","COUNTY_REGION":"County / Region","CITY":"City","ZIP_CODE":"Postcode / ZIP code","RESULT_COUNTRY_SELECT":"No results found","PHONE_NUMBER":"Phone number","MOBILE":"Mobile","LINKEDIN":"Linkedin","FACEBOOK":"Facebook","WEBSITE":"Website","REJECTED_EMAIL":"Rejected Email","EMAIL":"Email","NAME_OF_CORPORATE_SHAREHOLDER":"Name of corporate shareholder","LEGAL_DOCUMENTS":"Legal documents","PERSONAL_INFORMATION":"Personal information","COMPANY_INFORMATION":"Company information","COMPANY_NAME":"Company name","COUNTRY_OF_INCORPORATION":"Country of incorporation","COMPANY_REGISTRATION_NUMBER":"Company registration number","COMPANY_ADDRESS":"Company address (Optional)","COMPANY_CONTACTS":"Company contacts","HOME_ADDRESS":"Home address (Optional)","CONTACTS":"Contacts","INDIVIDUAL":"Individual","CORPORATE":"Corporate","IDENTITY_CONFIRMATION":"Identity confirmation","YES":"Yes","NO":"No","PROOF_OF_ADDRESS":"Proof of address","OPTIONAL_ADDRESS":"Optional address","INVALID_VALUE":"Invalid value"},"BUSINESS_CUSTOMER_INFORMATION":{"TITLE":"Business Customer Information","DATE_OF_REGISTRATION":"Date of registration","REGISTRATION_NUMBER":"Registration number","TRADING_NAME":"Trading name","TAX_IDENTIFICATION_NUMBER":"Tax Identification Number","BUSINESS_ACTIVITIES":"Business activities","SEARCH_BUSINESS_ACTIVITIES":"Search business activities","COMPANY_PHONE":"Company phone","IP_ADDRESS":"IP Address","IP_COUNTRY":"IP Country"},"REGISTERED_OFFICE_ADDRESS":{"TITLE":"Registered office address"},"OFFICIAL_BUSINESS_LOCATION":{"TITLE":"Official business location","PROOF_OF_ADDRESS":"Documents for proof of address"},"CONTACT_INFORMATION":{"TITLE":"Contact Information","PHONE_NUMBER":"Phone number"},"STATEMENT_OF_AFFAIRS":{"TITLE":"Statement of Affairs","SPECIFIC_COUNTRIES":"Specific countries of Operations Targeted markets","NATURE_OF_BUSINESS":"Nature of business"},"INITIAL_DEPOSITS":{"TITLE":"Source of funds","SOURCE_OF_INITIAL_DEPOSIT":"Describe source of initial deposit","ORIGINATING_BANK_JURISDICTION":"Originating Bank Jurisdiction","DESCRIBE_FUNDS_WERE_GENERATED":"Describe precisely how these funds were generated","AMOUNT":"Amount","CURRENCY":"Currency","ACCOUNT_NAME":"Account name"},"EXPECTED_TURNOVER":{"TITLE":"Expected turnover","AVERAGE_INCOMING_TRANSACTION":"Average transaction value/size","PLANNED_MONTHLY_INCOMING_TURNOVER":"Planned monthly turnover of incoming payments using {{vendorTitle}} account","MONTHLY_INCOMING_FREQUENCY":"Monthly frequency of payments","AVERAGE_OUTGOING_TRANSACTION":"Average outgoing transaction value/size","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Planned monthly turnover of outgoing payments on {{vendorTitle}} account","MONTHLY_OUTGOING_FREQUENCY":"Monthly frequency of outgoing payments","RANGE":{"UP":"Up to {{amountTo}} {{unit}}","FROM_TO":"From {{amountFrom}} {{unit}} to {{amountTo}} {{unit}}","MORE":"More than {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Up to {{amountTo}}","FROM_TO":"From {{amountFrom}} to {{amountTo}}","MORE":"More than {{amountFrom}}"},"MAIN_SUPPLIERS":"Main counterparties for outgoing payments (name/jurisdiction)","MAIN_CLIENTS":"Main counterparties for incoming payments (name/jurisdiction)"},"AUTHORISED_SIGNATORY":{"TITLE":"Authorized signatory","SAVE_ALL":"Save all","DETAILS":"Authorized signatory details","ADDRESS":"Authorized signatory address","CONTACTS":"Authorized signatory contacts","PASSPORT":"Passport","SELFIE":"Selfie with ID Card"},"DIRECTORS":{"TITLE":"Directors of the company","DIRECTOR_TYPE":"Director type","NIC_PASSPORT_ID":"Passport/ID number"},"SHAREHOLDERS":{"TITLE":"Shareholders","SHARE_NUMBER":"Share: {{share}}%","SHARE":"Share: %","EMPTY":"Sorry! There are no shareholders.","SHAREHOLDER_TYPE":"Shareholder type","SHAREHOLDER_SUM_ERROR":"Share % sum should be equal 100%","NIC_PASSPORT_ID":"Passport/ID number"},"INTRODUCER":{"TITLE":"Introducer/Reseller","INTRODUCER_NAME":"Introducer/reseller name","INTRODUCER_EMAIL":"Introducer/reseller email"},"ACCOUNT_CURRENCIES":{"TITLE":"Account currencies","MASTER_ACCOUNT_CURRENCY":"Master account currency","ADDITIONAL_CURRENCIES":"Additional currencies"},"USAGE_AND_REFERRAL":{"TITLE":"Usage and referral","WHAT_PRODUCTS_SERVICES":"What {{company}} products/services are you planning to use?","REASON_FOR_CHOOSING":"Reason for choosing {{company}}","SOURCE_OF_INFORMATION":"Source of information about {{company}}?"}}},"TAB.DOCUMENTS":{"HEADER":"Documents","IDENTITY_CONFIRMATION":"Identity confirmation","LEGAL_DOCUMENTS":"Legal documents","SELFIE":"Selfie","PROOF_OF_ADDRESS":"Proof Of Address","ARCHIVE_BUTTON":"Save archive","NO_DOCUMENTS":"Sorry! There are not any attachments."},"CUSTOM_REASON":"Custom Reason","TABLE_REASONS":{"HEADER":{"NAME":"Reason"},"EMPTY":"Sorry! There are no reasons."},"TAB_ARCHIVED":{"TITLE":"Archived Details"}},"PROCESS":{"CONFIRM.TITLE":"Confirm process request","CONFIRM.MESSAGE":"This customer will be in <b>process</b> status, are you sure you want to continue?","CONFIRM.BUTTON":"Confirm"},"APPROVE":{"HEADER":"Approve registration request from {{name}}?","HEADER_WITHOUT_PROFILE":"Profile state changed.","RISK":{"TITLE":"Risk level","PLACEHOLDER":"Select"},"TARIFF":{"TITLE":"Tariff","PLACEHOLDER":"Select","WHITELABEL_TITLE":"Whitelabel tariff"},"MIN_TOTAL_ASSET":{"TITLE":"Min total asset","ABOUT":"Min total asset currency equals EUR"},"BANK":{"TITLE":"Bank","PLACEHOLDER":"Select","VALIDATION":{"EMPTY_LIST":"No bank assigned with {{currency_code}} at the moment"}},"IBAN":{"TITLE":"IBAN","PLACEHOLDER":"Enter IBAN number","IBAN_WILL_BE_GENERATED":"IBAN will be generated after confirmation"},"LIQUIDITY":{"TITLE":"Liquidity account","PLACEHOLDER":"Select"},"PROFILE_KIND":{"TITLE":"Profile type","PLACEHOLDER":"Select"},"PRODUCT_CODE":{"TITLE":"Product code","PLACEHOLDER":"Select"},"INTRODUCER_NAME":{"TITLE":"Introducer name","PLACEHOLDER":"Select","NOT_FOUND":"Sorry! There are not found any introducer by this condition! Try other search condition, please!"},"SUCCESS":{"TITLE":"Registration approved!","SECURITY_CODE":{"TITLE":"Security Code","TEXT":"Security code for this account is generated. Copy it and send it to the client."},"PASSWORD":{"TITLE":"Link to set a password","TEXT":"To set a password copy this link and send it to the client."}}}},"FILTER":{"PLACEHOLDER":{"PERIOD":"Choose period"}},"PENDING":{"APPROVE":{"HEADER":"Approve registration request from {{name}}?","RISK":{"TITLE":"Risk level","PLACEHOLDER":"Select"},"TARIFF":{"TITLE":"Tariff","PLACEHOLDER":"Select"},"BANK":{"TITLE":"Bank","PLACEHOLDER":"Select","VALIDATION":{"EMPTY_LIST":"No bank assigned with {{currency_code}} at the moment"}},"IBAN":{"TITLE":"IBAN","PLACEHOLDER":"Enter IBAN number","IBAN_WILL_BE_GENERATED":"IBAN will be generated after confirmation"},"LIQUIDITY":{"TITLE":"Liquidity account","PLACEHOLDER":"Select"},"PROFILE_KIND":{"TITLE":"Profile type","PLACEHOLDER":"Select"},"PRODUCT_CODE":{"TITLE":"Product code","PLACEHOLDER":"Select"},"INTRODUCER_NAME":{"TITLE":"Introducer name","PLACEHOLDER":"Select","NOT_FOUND":"Sorry! There are not found any introducer by this condition! Try other search condition, please!"},"SUCCESS":{"TITLE":"Registration approved!","SECURITY_CODE":{"TITLE":"Security Code","TEXT":"Security code for this account is generated. Copy it and send it to the client."},"PASSWORD":{"TITLE":"Link to set a password","TEXT":"To set a password copy this link and send it to the client."}}}},"DECLINED":{"TITLE":"Applications/Declined","NOT_FOUND":"Sorry! There are not any applications in system.","DETAIL":{"TITLE":"Application/{{status}}/ID:{{id}}","TAB.DETAILS":{"PRIVATE":{"APPLICANT_INFORMATION":{"TITLE":"Applicant","PERSONAL_DETAILS":{"TITLE":"Personal details","FIRST_NAME":"First name","LAST_NAME":"Last name"},"NATIONALITY":"Nationality","PASSPORT":"NIC / Passport number","PLACE_OF_ISSUE":"Issuing Authority","DATE":{"TITLE":"Date of issue/ expiry","ISSUE":"Date of issue","EXPIRY":"Date of expiry","EXPIRY_WARNING":"Please note, passport is expiring soon. "},"SECOND_NATIONALITY":"Second nationality","RESIDENTIAL_ADDRESS":{"TITLE":"Home address","RESIDENTIAL_POSTAL_ADDRESS":"Home address","RESIDENTIAL_POSTAL_CITY":"City","RESIDENTIAL_POSTAL_COUNTY_OR_REGION":"County or region","RESIDENTIAL_COUNTRY":"Country","RESIDENTIAL_ZIP_CODE":"Postcode / ZIP code"},"POSTAL_ADDRESS":{"TITLE":"Mailing address","POSTAL_ADDRESS":"Mailing address","POSTAL_CITY":"Mailing city","POSTAL_COUNTY_OR_REGION":"Mailing county or region","COUNTRY":"Mailing country","ZIP_CODE":"Postcode / ZIP code"},"PHONE_NUMBER":"Phone number","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","IP_ADDRESS":"IP Address","IP_COUNTRY":"IP Country","BIRTH_DATE":"Date of birth","PLACE_OF_BIRTH":"Place of Birth (Country)","TAX_IDENTIFICATION_NUMBER":"Tax Identification Number","TAX_COUNTRY":"Tax Country","FAX_NUMBER":"Fax number","FACEBOOK_PROFILE":"Facebook profile","LINKEDIN":"LinkedIn","OTHER":"Other","ID_OR_PASSPORT_ATTACHMENT_ITEMS":"ID or Passport attachment items","PASSPORT_SELFIE_ATTACHMENT_ITEMS":"Passport selfie attachment items","ADDRESS_ATTACHMENT_ITEMS":"Address attachment items","SAVE_ALL":"Save all","UPLOAD":{"TITLE":"Upload","ERROR":{"MAX_SIZE":"File size exceeds the permissible value!","FILE_ALREADY_CONFIRMED":"File already exist in the system!","FILE_NOT_FOUND":"File not found!","UNSUPPORTED_FORMAT":"Unsupported format of file!"}},"FILTER":{"NOT_FOUND":{"NATIONALITY_SELECT":"There are no available country","SECOND_NATIONALITY_SELECT":"There are no available country","COUNTRY_SELECT":"There are no available country","RESULT_COUNTRY_SELECT":"No results found","JURISDICTION":"There are no available jurisdiction"}}},"EMPLOYMENT_INFORMATION":{"TITLE":"Employment","PRESENT_OCCUPATION":"Present occupation","EMPLOYMENT_DETAILS":{"TITLE":"Employment details","NAME":"Employer's name/Name of business","ADDRESS":{"TITLE":"Employer's address","POSTAL_ADDRESS":"Employer's office address","POSTAL_CITY":"City","POSTAL_COUNTY_OR_REGION":"County or region","COUNTRY":"Country","ZIP_CODE":"Postcode / ZIP code"},"BUSINESS_SECTOR":"Name of Business Activity","YEARS_IN_EMPLOYMENT":"Number of years in employment/business"}},"PEP_INFORMATION":{"TITLE":"PEP","POSITION_IN_ANY_COUNTRY":"Are you a PEP or linked to a PEP? A \"Politically Exposed Person\" is a natural person (individual) who is or has been entrusted with a prominent public function and includes his or her immediate family members or persons known to be close associates of such persons but excludes middle ranking or more junior officers.","FAMILY_POSITION_IN_ANY_COUNTRY":"Does any member of your close family currently hold, or has ever held any political, diplomatic or governmental office in any country? (Please tick the box if the answer is YES)"},"LITIGATION_INFORMATION":{"TITLE":"Litigation","LITIGATION":"Have you ever been the subject of any legal enquiries, court orders, judgements, bankruptcy proceedings, criminal sanctions (excluding minor traffic incidents)? (Please tick the box if the answer is YES)"},"MASTER_ACCOUNT_INFORMATION":{"TITLE":"Master account","MASTER_ACCOUNT_CURRENCY":"Master account currency","ADDITIONAL_CURRENCIES":"DECLINEDAdditional currencies"},"FUNDS_INFORMATION":{"TITLE":"Funds","SOURCE_OF_INITIAL_FUNDING":{"TITLE":"Source of Initial funding","JURISDICTION":"Jurisdiction","AVERAGE_MONTHLY_INCOME":"What is your average monthly income?","PRIMARY_INCOME_SOURCE":"Please provide your primary income source","ORIGINAL_BANK_NAME":"Original bank name","ORIGINAL_BANK_ADDRESS":"Original bank address","ACCOUNT_NAME":"Account name","SIGNATORY":"Signatory","HOW_FUNDS_GENERATED":"Describe precisely how these funds were generated"},"EXPECTED_TRANSFER_ACTIVITY":{"TITLE":"Expected transfer activity","AVERAGE_VALUE_OF_TRANSFER":"Average value of each transfer ({{currency}})","MAX_VALUE_OF_TRANSFER":"Maximum value of each transfer ({{currency}})","MAIN_COUNTRIES_TO":"Countries to which transfers will be made","MAIN_COUNTRIES_FROM":"Countries from which transfers will be received","PURPOSE_OF_ACCOUNT":" Purpose of this account","AVERAGE_INCOMING_TRANSACTION":"Average transaction value/size","PLANNED_MONTHLY_INCOMING_TURNOVER":"Planned monthly turnover of incoming payments using {{vendorTitle}} account","MONTHLY_INCOMING_FREQUENCY":"Monthly frequency of payments","AVERAGE_OUTGOING_TRANSACTION":"Average outgoing transaction value/size","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Planned monthly turnover of outgoing payments on {{vendorTitle}} account","MONTHLY_OUTGOING_FREQUENCY":"Monthly frequency of outgoing payments"},"RANGE":{"UP":"Up to {{amountTo}} {{unit}}","FROM_TO":"From {{amountFrom}} {{unit}} to {{amountTo}} {{unit}}","MORE":"More than {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Up to {{amountTo}}","FROM_TO":"From {{amountFrom}} to {{amountTo}}","MORE":"More than {{amountFrom}}"}},"INTRODUCER_INFORMATION":{"TITLE":"Introducer/Reseller","INTRODUCER_NAME":"Introducer/reseller name","INTRODUCER_EMAIL":"Introducer/reseller email"},"ABOUT_YOURSELF_INFORMATION":{"TITLE":"Tell us about yourself","PRODUCTS":"What {{company}} products/services are you planning to use?","PRODUCTS_CUSTOM":"Products custom","REASONS":"Reasons","REASONS_CUSTOM":"Reasons custom","INFORMATION_SOURCE":"Information sources","INFORMATION_SOURCES_CUSTOM":"Information sources custom","USA_CITIZEN":"By ticking the box I declare that I am NOT a citizen and/or a tax resident of the USA."},"REQUIRED_INPUT":"This field is required!","MINIMUM_LENGTH":"Minimum length is {{value}} symbols","MAXIMUM_LENGTH":"Maximum length is {{value}} symbols"},"EDIT.BUTTON.NAME":"Edit","HEADER":"Details","UNAVAILABLE_CURRENCY":" is unavailable at the moment","SAVE.BUTTON.NAME":"Save","SAVE_ALL.BUTTON.NAME":"Save all","UPLOAD.BUTTON.NAME":"Upload","CANCEL.BUTTON.NAME":"Cancel","DISCARD.BUTTON.NAME":"Discard","REMOVE.BUTTON.NAME":"Remove","ADD_NEW.BUTTON.NAME":"Add new","CHOSE.BUTTON.NAME":"Chose files","UPLOAD.DOCUMENT.HEADER":"Upload document","OTHER":"Other","CORPORATE":{"COMMON":{"FIRST_NAME":"First name","LAST_NAME":"Last name","DATE_OF_BIRTH":"Date of birth","ATTORNEY_POWER_EXPIRE_DATE":"Expiry date of power of attorney (if applicable)","JOB_TITLE_OCCUPATION":"Job title / Occupation","NIC_PASSPORT_ID":"NIC/Passport No","IS_PEP":"Is this person a PEP or linked to a PEP?","TRUE":"True","FALSE":"False","NATIONALITY":"Nationality","SECOND_NATIONALITY":"Second nationality","ADDRESS_LINE":"Address line","COUNTRY":"Country","COUNTY_REGION":"County / Region","CITY":"City","ZIP_CODE":"Postcode / ZIP code","RESULT_COUNTRY_SELECT":"No results found","PHONE_NUMBER":"Phone number","MOBILE":"Mobile","LINKEDIN":"Linkedin","FACEBOOK":"Facebook","WEBSITE":"Website","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","NAME_OF_CORPORATE_SHAREHOLDER":"Name of corporate shareholder","LEGAL_DOCUMENTS":"Legal documents","PERSONAL_INFORMATION":"Personal information","COMPANY_INFORMATION":"Company information","COMPANY_NAME":"Company name","COUNTRY_OF_INCORPORATION":"Country of incorporation","COMPANY_REGISTRATION_NUMBER":"Company registration number","COMPANY_ADDRESS":"Company address (Optional)","COMPANY_CONTACTS":"Company contacts","HOME_ADDRESS":"Home address (Optional)","CONTACTS":"Contacts","INDIVIDUAL":"Individual","CORPORATE":"Corporate","IDENTITY_CONFIRMATION":"Identity confirmation","YES":"Yes","NO":"No","PROOF_OF_ADDRESS":"Proof of address","OPTIONAL_ADDRESS":"Optional address","INVALID_VALUE":"Invalid value"},"BUSINESS_CUSTOMER_INFORMATION":{"TITLE":"Business Customer Information","DATE_OF_REGISTRATION":"Date of registration","REGISTRATION_NUMBER":"Registration number","TRADING_NAME":"Trading name","TAX_IDENTIFICATION_NUMBER":"Tax Identification Number","BUSINESS_ACTIVITIES":"Business activities","SEARCH_BUSINESS_ACTIVITIES":"Search business activities","COMPANY_PHONE":"Company phone","IP_ADDRESS":"IP Address","IP_COUNTRY":"IP Country"},"REGISTERED_OFFICE_ADDRESS":{"TITLE":"Registered office address"},"OFFICIAL_BUSINESS_LOCATION":{"TITLE":"Official business location","PROOF_OF_ADDRESS":"Documents for proof of address"},"CONTACT_INFORMATION":{"TITLE":"Contact Information","PHONE_NUMBER":"Phone number"},"STATEMENT_OF_AFFAIRS":{"TITLE":"Statement of Affairs","SPECIFIC_COUNTRIES":"Specific countries of Operations Targeted markets","NATURE_OF_BUSINESS":"Nature of business"},"INITIAL_DEPOSITS":{"TITLE":"Source of funds","SOURCE_OF_INITIAL_DEPOSIT":"Describe source of initial deposit","ORIGINATING_BANK_JURISDICTION":"Originating Bank Jurisdiction","DESCRIBE_FUNDS_WERE_GENERATED":"Describe precisely how these funds were generated","AMOUNT":"Amount","CURRENCY":"Currency","ACCOUNT_NAME":"Account name"},"EXPECTED_TURNOVER":{"TITLE":"Expected turnover","AVERAGE_INCOMING_TRANSACTION":"Average transaction value/size","PLANNED_MONTHLY_INCOMING_TURNOVER":"Planned monthly turnover of incoming payments using {{vendorTitle}} account","MONTHLY_INCOMING_FREQUENCY":"Monthly frequency of payments","AVERAGE_OUTGOING_TRANSACTION":"Average outgoing transaction value/size","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Planned monthly turnover of outgoing payments on {{vendorTitle}} account","MONTHLY_OUTGOING_FREQUENCY":"Monthly frequency of outgoing payments","RANGE":{"UP":"Up to {{amountTo}} {{unit}}","FROM_TO":"From {{amountFrom}} {{unit}} to {{amountTo}} {{unit}}","MORE":"More than {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Up to {{amountTo}}","FROM_TO":"From {{amountFrom}} to {{amountTo}}","MORE":"More than {{amountFrom}}"},"MAIN_SUPPLIERS":"Main counterparties for outgoing payments (name/jurisdiction)","MAIN_CLIENTS":"Main counterparties for incoming payments (name/jurisdiction)"},"AUTHORISED_SIGNATORY":{"TITLE":"Authorized signatory","SAVE_ALL":"Save all","DETAILS":"Authorized signatory details","ADDRESS":"Authorized signatory address","CONTACTS":"Authorized signatory contacts","PASSPORT":"Passport","SELFIE":"Selfie with ID Card"},"DIRECTORS":{"TITLE":"Directors of the company","DIRECTOR_TYPE":"Director type","NIC_PASSPORT_ID":"Passport/ID number"},"SHAREHOLDERS":{"TITLE":"Shareholders","SHARE_NUMBER":"Share: {{share}}%","SHARE":"Share: %","EMPTY":"Sorry! There are no shareholders.","SHAREHOLDER_TYPE":"Shareholder type","SHAREHOLDER_SUM_ERROR":"Share % sum should be equal 100%","NIC_PASSPORT_ID":"Passport/ID number"},"INTRODUCER":{"TITLE":"Introducer/Reseller","INTRODUCER_NAME":"Introducer/reseller name","INTRODUCER_EMAIL":"Introducer/reseller email"},"ACCOUNT_CURRENCIES":{"TITLE":"Account currencies","MASTER_ACCOUNT_CURRENCY":"Master account currency","ADDITIONAL_CURRENCIES":"Additional currencies"},"USAGE_AND_REFERRAL":{"TITLE":"Usage and referral","WHAT_PRODUCTS_SERVICES":"What {{company}} products/services are you planning to use?","REASON_FOR_CHOOSING":"Reason for choosing {{company}}","SOURCE_OF_INFORMATION":"Source of information about {{company}}?"}}},"TAB.DOCUMENTS":{"HEADER":"Documents","IDENTITY_CONFIRMATION":"Identity confirmation","LEGAL_DOCUMENTS":"Legal documents","SELFIE":"Selfie","PROOF_OF_ADDRESS":"Proof Of Address","ARCHIVE_BUTTON":"Save archive","NO_DOCUMENTS":"Sorry! There are not any attachments."},"CUSTOM_REASON":"Custom Reason","TABLE_REASONS":{"HEADER":{"NAME":"Reason"},"EMPTY":"Sorry! There are no reasons."},"TAB_DECLINED":{"TITLE":"Declined Details"},"PROCESS":{"CONFIRM.TITLE":"Confirm process request","CONFIRM.MESSAGE":"This customer will be in <b>process</b> status, are you sure you want to continue?","CONFIRM.BUTTON":"Confirm"}},"REJECTED_CONFIRM":{"PROCESS":{"CONFIRM.TITLE":"Confirm process request","CONFIRM.MESSAGE":"This customer will be in <b>process</b> status, are you sure you want to continue?","CONFIRM.BUTTON":"Confirm"}},"PROCESS":{"CONFIRM.TITLE":"Confirm process request","CONFIRM.MESSAGE":"This customer will be in <b>process</b> status, are you sure you want to continue?","CONFIRM.BUTTON":"Confirm"}},"PROCESSING":{"TITLE":"Applications/Processing","NOT_FOUND":"Sorry! There are not any applications in system.","DETAIL":{"TITLE":"Application/Processing/ID:{{id}}","TAB.DETAILS":{"PRIVATE":{"APPLICANT_INFORMATION":{"TITLE":"Applicant","PERSONAL_DETAILS":{"TITLE":"Personal details","FIRST_NAME":"First name","LAST_NAME":"Last name"},"NATIONALITY":"Nationality","PASSPORT":"NIC / Passport number","PLACE_OF_ISSUE":"Issuing Authority","DATE":{"TITLE":"Date of issue/ expiry","ISSUE":"Date of issue","EXPIRY":"Date of expiry","EXPIRY_WARNING":"Please note, passport is expiring soon. "},"SECOND_NATIONALITY":"Second nationality","RESIDENTIAL_ADDRESS":{"TITLE":"Home address","RESIDENTIAL_POSTAL_ADDRESS":"Home address","RESIDENTIAL_POSTAL_CITY":"City","RESIDENTIAL_POSTAL_COUNTY_OR_REGION":"County or region","RESIDENTIAL_COUNTRY":"Country","RESIDENTIAL_ZIP_CODE":"Postcode / ZIP code"},"POSTAL_ADDRESS":{"TITLE":"Mailing address","POSTAL_ADDRESS":"Mailing address","POSTAL_CITY":"Mailing city","POSTAL_COUNTY_OR_REGION":"Mailing county or region","COUNTRY":"Mailing country","ZIP_CODE":"Postcode / ZIP code"},"PHONE_NUMBER":"Phone number","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","IP_ADDRESS":"IP Address","IP_COUNTRY":"IP Country","BIRTH_DATE":"Date of birth","PLACE_OF_BIRTH":"Place of Birth (Country)","TAX_IDENTIFICATION_NUMBER":"Tax Identification Number","TAX_COUNTRY":"Tax Country","FAX_NUMBER":"Fax number","FACEBOOK_PROFILE":"Facebook profile","LINKEDIN":"LinkedIn","OTHER":"Other","ID_OR_PASSPORT_ATTACHMENT_ITEMS":"ID or Passport attachment items","PASSPORT_SELFIE_ATTACHMENT_ITEMS":"Passport selfie attachment items","ADDRESS_ATTACHMENT_ITEMS":"Address attachment items","SAVE_ALL":"Save all","UPLOAD":{"TITLE":"Upload","ERROR":{"MAX_SIZE":"File size exceeds the permissible value!","FILE_ALREADY_CONFIRMED":"File already exist in the system!","FILE_NOT_FOUND":"File not found!","UNSUPPORTED_FORMAT":"Unsupported format of file!"}},"FILTER":{"NOT_FOUND":{"NATIONALITY_SELECT":"There are no available country","SECOND_NATIONALITY_SELECT":"There are no available country","COUNTRY_SELECT":"There are no available country","RESULT_COUNTRY_SELECT":"No results found","JURISDICTION":"There are no available jurisdiction"}}},"EMPLOYMENT_INFORMATION":{"TITLE":"Employment","PRESENT_OCCUPATION":"Present occupation","EMPLOYMENT_DETAILS":{"TITLE":"Employment details","NAME":"Employer's name/Name of business","ADDRESS":{"TITLE":"Employer's address","POSTAL_ADDRESS":"Employer's office address","POSTAL_CITY":"City","POSTAL_COUNTY_OR_REGION":"County or region","COUNTRY":"Country","ZIP_CODE":"Postcode / ZIP code"},"BUSINESS_SECTOR":"Name of Business Activity","YEARS_IN_EMPLOYMENT":"Number of years in employment/business"}},"PEP_INFORMATION":{"TITLE":"PEP","POSITION_IN_ANY_COUNTRY":"Are you a PEP or linked to a PEP? A \"Politically Exposed Person\" is a natural person (individual) who is or has been entrusted with a prominent public function and includes his or her immediate family members or persons known to be close associates of such persons but excludes middle ranking or more junior officers.","FAMILY_POSITION_IN_ANY_COUNTRY":"Does any member of your close family currently hold, or has ever held any political, diplomatic or governmental office in any country? (Please tick the box if the answer is YES)"},"LITIGATION_INFORMATION":{"TITLE":"Litigation","LITIGATION":"Have you ever been the subject of any legal enquiries, court orders, judgements, bankruptcy proceedings, criminal sanctions (excluding minor traffic incidents)? (Please tick the box if the answer is YES)"},"MASTER_ACCOUNT_INFORMATION":{"TITLE":"Master account","MASTER_ACCOUNT_CURRENCY":"Master account currency","ADDITIONAL_CURRENCIES":"Additional currencies"},"FUNDS_INFORMATION":{"TITLE":"Funds","SOURCE_OF_INITIAL_FUNDING":{"TITLE":"Source of Initial funding","JURISDICTION":"Jurisdiction","AVERAGE_MONTHLY_INCOME":"What is your average monthly income?","PRIMARY_INCOME_SOURCE":"Please provide your primary income source","ORIGINAL_BANK_NAME":"Original bank name","ORIGINAL_BANK_ADDRESS":"Original bank address","ACCOUNT_NAME":"Account name","SIGNATORY":"Signatory","HOW_FUNDS_GENERATED":"Describe precisely how these funds were generated"},"EXPECTED_TRANSFER_ACTIVITY":{"TITLE":"Expected transfer activity","AVERAGE_VALUE_OF_TRANSFER":"Average value of each transfer ({{currency}})","MAX_VALUE_OF_TRANSFER":"Maximum value of each transfer ({{currency}})","MAIN_COUNTRIES_TO":"Countries to which transfers will be made","MAIN_COUNTRIES_FROM":"Countries from which transfers will be received","PURPOSE_OF_ACCOUNT":" Purpose of this account","AVERAGE_INCOMING_TRANSACTION":"Average transaction value/size","PLANNED_MONTHLY_INCOMING_TURNOVER":"Planned monthly turnover of incoming payments using {{vendorTitle}} account","MONTHLY_INCOMING_FREQUENCY":"Monthly frequency of payments","AVERAGE_OUTGOING_TRANSACTION":"Average outgoing transaction value/size","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Planned monthly turnover of outgoing payments on {{vendorTitle}} account","MONTHLY_OUTGOING_FREQUENCY":"Monthly frequency of outgoing payments"},"RANGE":{"UP":"Up to {{amountTo}} {{unit}}","FROM_TO":"From {{amountFrom}} {{unit}} to {{amountTo}} {{unit}}","MORE":"More than {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Up to {{amountTo}}","FROM_TO":"From {{amountFrom}} to {{amountTo}}","MORE":"More than {{amountFrom}}"}},"INTRODUCER_INFORMATION":{"TITLE":"Introducer/Reseller","INTRODUCER_NAME":"Introducer/reseller name","INTRODUCER_EMAIL":"Introducer/reseller email"},"ABOUT_YOURSELF_INFORMATION":{"TITLE":"Tell us about yourself","PRODUCTS":"What {{company}} products/services are you planning to use?","PRODUCTS_CUSTOM":"Products custom","REASONS":"Reasons","REASONS_CUSTOM":"Reasons custom","INFORMATION_SOURCE":"Information sources","INFORMATION_SOURCES_CUSTOM":"Information sources custom","USA_CITIZEN":"By ticking the box I declare that I am NOT a citizen and/or a tax resident of the USA."},"REQUIRED_INPUT":"This field is required!","MINIMUM_LENGTH":"Minimum length is {{value}} symbols","MAXIMUM_LENGTH":"Maximum length is {{value}} symbols"},"EDIT.BUTTON.NAME":"Edit","HEADER":"Details","UNAVAILABLE_CURRENCY":" is unavailable at the moment","SAVE.BUTTON.NAME":"Save","SAVE_ALL.BUTTON.NAME":"Save all","UPLOAD.BUTTON.NAME":"Upload","CANCEL.BUTTON.NAME":"Cancel","DISCARD.BUTTON.NAME":"Discard","REMOVE.BUTTON.NAME":"Remove","ADD_NEW.BUTTON.NAME":"Add new","CHOSE.BUTTON.NAME":"Chose files","UPLOAD.DOCUMENT.HEADER":"Upload document","OTHER":"Other","CORPORATE":{"COMMON":{"FIRST_NAME":"First name","LAST_NAME":"Last name","DATE_OF_BIRTH":"Date of birth","ATTORNEY_POWER_EXPIRE_DATE":"Expiry date of power of attorney (if applicable)","JOB_TITLE_OCCUPATION":"Job title / Occupation","NIC_PASSPORT_ID":"NIC/Passport No","IS_PEP":"Is this person a PEP or linked to a PEP?","TRUE":"True","FALSE":"False","NATIONALITY":"Nationality","SECOND_NATIONALITY":"Second nationality","ADDRESS_LINE":"Address line","COUNTRY":"Country","COUNTY_REGION":"County / Region","CITY":"City","ZIP_CODE":"Postcode / ZIP code","RESULT_COUNTRY_SELECT":"No results found","PHONE_NUMBER":"Phone number","MOBILE":"Mobile","LINKEDIN":"Linkedin","FACEBOOK":"Facebook","WEBSITE":"Website","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","NAME_OF_CORPORATE_SHAREHOLDER":"Name of corporate shareholder","LEGAL_DOCUMENTS":"Legal documents","PERSONAL_INFORMATION":"Personal information","COMPANY_INFORMATION":"Company information","COMPANY_NAME":"Company name","COUNTRY_OF_INCORPORATION":"Country of incorporation","COMPANY_REGISTRATION_NUMBER":"Company registration number","COMPANY_ADDRESS":"Company address (Optional)","COMPANY_CONTACTS":"Company contacts","HOME_ADDRESS":"Home address (Optional)","CONTACTS":"Contacts","INDIVIDUAL":"Individual","CORPORATE":"Corporate","IDENTITY_CONFIRMATION":"Identity confirmation","YES":"Yes","NO":"No","PROOF_OF_ADDRESS":"Proof of address","OPTIONAL_ADDRESS":"Optional address","INVALID_VALUE":"Invalid value"},"BUSINESS_CUSTOMER_INFORMATION":{"TITLE":"Business Customer Information","DATE_OF_REGISTRATION":"Date of registration","REGISTRATION_NUMBER":"Registration number","TRADING_NAME":"Trading name","TAX_IDENTIFICATION_NUMBER":"Tax Identification Number","BUSINESS_ACTIVITIES":"Business activities","SEARCH_BUSINESS_ACTIVITIES":"Search business activities","COMPANY_PHONE":"Company phone","IP_ADDRESS":"IP Address","IP_COUNTRY":"IP Country"},"REGISTERED_OFFICE_ADDRESS":{"TITLE":"Registered office address"},"OFFICIAL_BUSINESS_LOCATION":{"TITLE":"Official business location","PROOF_OF_ADDRESS":"Documents for proof of address"},"CONTACT_INFORMATION":{"TITLE":"Contact Information","PHONE_NUMBER":"Phone number"},"STATEMENT_OF_AFFAIRS":{"TITLE":"Statement of Affairs","SPECIFIC_COUNTRIES":"Specific countries of Operations Targeted markets","NATURE_OF_BUSINESS":"Nature of business"},"INITIAL_DEPOSITS":{"TITLE":"Source of funds","SOURCE_OF_INITIAL_DEPOSIT":"Describe source of initial deposit","ORIGINATING_BANK_JURISDICTION":"Originating Bank Jurisdiction","DESCRIBE_FUNDS_WERE_GENERATED":"Describe precisely how these funds were generated","AMOUNT":"Amount","CURRENCY":"Currency","ACCOUNT_NAME":"Account name"},"EXPECTED_TURNOVER":{"TITLE":"Expected turnover","AVERAGE_INCOMING_TRANSACTION":"Average transaction value/size","PLANNED_MONTHLY_INCOMING_TURNOVER":"Planned monthly turnover of incoming payments using {{vendorTitle}} account","MONTHLY_INCOMING_FREQUENCY":"Monthly frequency of payments","AVERAGE_OUTGOING_TRANSACTION":"Average outgoing transaction value/size","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Planned monthly turnover of outgoing payments on {{vendorTitle}} account","MONTHLY_OUTGOING_FREQUENCY":"Monthly frequency of outgoing payments","RANGE":{"UP":"Up to {{amountTo}} {{unit}}","FROM_TO":"From {{amountFrom}} {{unit}} to {{amountTo}} {{unit}}","MORE":"More than {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Up to {{amountTo}}","FROM_TO":"From {{amountFrom}} to {{amountTo}}","MORE":"More than {{amountFrom}}"},"MAIN_SUPPLIERS":"Main counterparties for outgoing payments (name/jurisdiction)","MAIN_CLIENTS":"Main counterparties for incoming payments (name/jurisdiction)"},"AUTHORISED_SIGNATORY":{"TITLE":"Authorized signatory","SAVE_ALL":"Save all","DETAILS":"Authorized signatory details","ADDRESS":"Authorized signatory address","CONTACTS":"Authorized signatory contacts","PASSPORT":"Passport","SELFIE":"Selfie with ID Card"},"DIRECTORS":{"TITLE":"Directors of the company","DIRECTOR_TYPE":"Director type","NIC_PASSPORT_ID":"Passport/ID number"},"SHAREHOLDERS":{"TITLE":"Shareholders","SHARE_NUMBER":"Share: {{share}}%","SHARE":"Share: %","EMPTY":"Sorry! There are no shareholders.","SHAREHOLDER_TYPE":"Shareholder type","SHAREHOLDER_SUM_ERROR":"Share % sum should be equal 100%","NIC_PASSPORT_ID":"Passport/ID number"},"INTRODUCER":{"TITLE":"Introducer/Reseller","INTRODUCER_NAME":"Introducer/reseller name","INTRODUCER_EMAIL":"Introducer/reseller email"},"ACCOUNT_CURRENCIES":{"TITLE":"Account currencies","MASTER_ACCOUNT_CURRENCY":"Master account currency","ADDITIONAL_CURRENCIES":"Additional currencies"},"USAGE_AND_REFERRAL":{"TITLE":"Usage and referral","WHAT_PRODUCTS_SERVICES":"What {{company}} products/services are you planning to use?","REASON_FOR_CHOOSING":"Reason for choosing {{company}}","SOURCE_OF_INFORMATION":"Source of information about {{company}}?"}}},"TAB.DOCUMENTS":{"HEADER":"Documents","IDENTITY_CONFIRMATION":"Identity confirmation","LEGAL_DOCUMENTS":"Legal documents","SELFIE":"Selfie","PROOF_OF_ADDRESS":"Proof Of Address","ARCHIVE_BUTTON":"Save archive","NO_DOCUMENTS":"Sorry! There are not any attachments."}},"APPROVE":{"HEADER":"Approve registration request from {{name}}?","HEADER_WITHOUT_PROFILE":"Profile state changed.","RISK":{"TITLE":"Risk level","PLACEHOLDER":"Select"},"TARIFF":{"TITLE":"Tariff","PLACEHOLDER":"Select","WHITELABEL_TITLE":"Whitelabel tariff"},"MIN_TOTAL_ASSET":{"TITLE":"Min total asset","ABOUT":"Min total asset currency equals EUR"},"BANK":{"TITLE":"Bank","PLACEHOLDER":"Select","VALIDATION":{"EMPTY_LIST":"No bank assigned with {{currency_code}} at the moment"}},"IBAN":{"TITLE":"IBAN","PLACEHOLDER":"Enter IBAN number","IBAN_WILL_BE_GENERATED":"IBAN will be generated after confirmation"},"LIQUIDITY":{"TITLE":"Liquidity account","PLACEHOLDER":"Select","VALIDATION":{"EMPTY_LIST":"No liquidity account assigned with {{currency_code}} at the moment"}},"FINXP":{"CHANNEL_ID":{"TITLE":"Channel ID"},"IBAN":{"TITLE":"IBAN"},"ACCOUNT_NUMBER":{"TITLE":"Account Number"}},"PROFILE_KIND":{"TITLE":"Profile type","PLACEHOLDER":"Select"},"PRODUCT_CODE":{"TITLE":"Product code","PLACEHOLDER":"Select"},"INTRODUCER_NAME":{"TITLE":"Introducer name","PLACEHOLDER":"Select","NOT_FOUND":"Sorry! There are not found any introducer by this condition! Try other search condition, please!"},"SUCCESS":{"TITLE":"Registration approved!","SECURITY_CODE":{"TITLE":"Security Code","TEXT":"Security code for this account is generated. Copy it and send it to the client."},"PASSWORD":{"TITLE":"Link to set a password","TEXT":"To set a password copy this link and send it to the client."}}},"FILTER":{"PLACEHOLDER":{"PERIOD":"Choose period"}}}}}

/***/ }),
/* 706 */
/***/ (function(module, exports) {

	module.exports = {"CARDS":{"NEW":{"TITLE":"New cards","NO_NEW_CARDS":"There are no any new cards."},"CARD_NUMBER":"Card No","CARD_PROGRAM":"Card Program","CURRENCY":"Currency","SHORT_NUMBER":"Short Number","CARD_VALIDITY":"Card validity"}}

/***/ }),
/* 707 */
/***/ (function(module, exports) {

	module.exports = {"CONFIGURATION":{"TARIFFS":{"BASE":"Base","FEE":"Fee","MIN_FEE":"Min Fee","MAX_FEE":"Max Fee","FROM":"From","MARGIN":"FX Margin","NAME":"Name","NO_TARIFFS":"Sorry! There are no any tariffs in system.","NO_RULES":"Sorry! There are no any rules for this tariff in system.","SERVICE_NAME":"Service name","TO":"To","TITLE":"Tariffs","TYPE":"Type","DELETED":"Tariff deleted successfully","NOT_DELETED":"The tariff cannot be removed. It is related to a customer account","TAB_TITLE":{"CUSTOMER":"Customer tariffs","BANK":"Bank tariffs","CARD":"Card tariffs","WL":"Whitelabel tariffs","CREATE":"Create tariff"},"NEW_TARIFF":{"NEW":"New tariff","UPDATE":"Update tariff","NAME":"Name","TYPE":"Type","BASE":"Base","MARGIN":"Margin(%)","SAVED":"Tariff saved successfully","UPDATED":"Tariff updated successfully","FEE_RULE":{"TITLE":"Fees","FEE_ID":"Fee id","FEE_NAME":"Service Name","LEFT_BOUNDARY":"From","RIGHT_BOUNDARY":"To","FIXED_VALUE":"Fixed value","TARIFF_ID":"Tariff id","FEE_SERVICE_ID":"Fee service id","PERCENT_VALUE":"Percent value","MIN_FEE_AMOUNT":"Min fee amount","MAX_FEE_AMOUNT":"Max fee amount","FEE_REMAINDER_PERCENT":"Fee remainder percent","SUPPLEMENT":"Express Transfer Fee Supplement"}}},"AML_RULES":{"TITLE":"TM Rules","RULE_TYPE":"Rule type","RETAIL":"Retail","SOLE_TRADER":"Sole trader","CORPORATE":"Corporate","VIP_HIGH_VOLUME_CLIENTS":"Vip high volume clients","PRE_TRANSACTION":"Pre transaction","POST_TRANSACTION":"Post transaction","PERIODICITY_POST_TRANSACTION_ONLY":"Periodicity post transaction only","ACTIVE":"Active","INACTIVE":"Inactive","ACTIVATE":"Activate","DEACTIVATE":"Deactivate","REPORT_FILTER":{"TITLE":"Filters","STOPPED_DATE":"Stopped date","BUTTON_GENERATE":"Generate Report"}},"MOORWAND_REPORTS":{"TITLE":"Provider Reports","REPORT_TYPE":"Report type","MANUAL_FIELDS":"Manual fields","REPORT_FILTER":{"TITLE":"Filters","MONTH":"Month","YEAR":"Year","PROVIDER":"Provider"},"MI_REPORT":{"TITLE":"MI Report","PERSON_RESPONSIBLE":"Person responsible for submission","PERSON_RESPONSIBLE_MAIL":"Email","READY_DOWNLOAD":"The report is now ready to be downloaded.","GENERATED_REPORT_TITLE":"Generated report","GENERATED_REPORT_MESSAGE":"The report has been generated, you can review the history in the History Tab. If the report does not appear, wait a few minutes and press the Reload button","UK_REPCRIM_TAB":{"HEADER":"UK REPCRIM"},"EEA_REPCRIM_TAB":{"HEADER":"EEA REPCRIM"},"HISTORY_TAB":{"HEADER":"History","RELAUNCH_BUTTON":"Reload"}}},"DEPOSIT_BALANCE":{"TITLE":"Deposit Balance","FILTER":"Date From","PROFILE_ID":"Id","NAME":"Name","DAYS":"Days","TOTAL_OUTCOME":"Total Outcome","PENDING_BALANCE":"Total Pending","SEARCH":"Search","NO_RESULTS":"No results found","SEARCH_BUTTON":"Search"},"CLIENT_NOTIFICATIONS":{"TITLE":"Client Office Notifications","ID":"ID","TITLE_FIELD":"Title","CONTENT":"Content","PRIORITY_LABEL":"Priority","PRIORITY":{"LOW":"Low","MEDIUM":"Medium","HIGH":"High","URGENT":"Urgent"},"CREATED_AT":"Created At","CREATED_BY":"Created By","UPDATED_AT":"Updated At","UPDATED_BY":"Updated By","ACTIVE":"Active","INACTIVE":"Inactive","CREATE_BUTTON":"Create Notification","UPDATE_BUTTON":"Update Notification","CANCEL":"Cancel","EDIT":"Edit","DELETE":"Delete","ACTIVATE":"Activate","DEACTIVATE":"Deactivate","DELETE_CONFIRM":"Are you sure you want to delete this notification?","NO_RECORDS":"No notifications found","NEW_NOTIFICATION":"New Notification","EDIT_NOTIFICATION":"Edit Notification","TITLE_PLACEHOLDER":"Enter notification title","CONTENT_PLACEHOLDER":"Enter notification content","CREATED_SUCCESS":"Notification created successfully","CREATED_ERROR":"Error creating notification","UPDATED_SUCCESS":"Notification updated successfully","UPDATED_ERROR":"Error updating notification","LOAD_ERROR":"Error loading notification","RECIPIENTS":"Recipients","RECIPIENTS_REQUIRED":"At least one recipient is required","ALL_ACTIVE_USERS":"All Active Users","ALL_ACTIVE_USERS_INFO":"This notification will be sent to all active client users in the system.","BY_CUSTOMER":"By Customer","BY_USER":"By User","BY_USER_ID":"By User ID","BY_EMAIL":"By Email","SEARCH_CUSTOMER":"Search customer by name...","SEARCH_USER":"Search user by email or name...","ENTER_USER_ID":"Enter User ID","ENTER_EMAIL":"Enter email address","ADD":"Add","ADDED_USER_IDS":"Added User IDs","ADDED_EMAILS":"Added Emails","SELECTED_CUSTOMERS":"Selected Customers","SELECTED_USERS":"Selected Users","PRIORITY_LOW":"Low","PRIORITY_MEDIUM":"Medium","PRIORITY_HIGH":"High","PRIORITY_URGENT":"Urgent","ACTIVE_YES":"Active","ACTIVE_NO":"Inactive","VIEW":"View","VIEW_TITLE":"View Notification","BACK":"Back","CONTENT_FIELD":"Content","NO_RECIPIENTS":"No recipients","RECIPIENT_NAME":"Name","RECIPIENT_EMAIL":"Email / Login","RECIPIENT_CUSTOMER":"Customer","RECIPIENT_STATUS":"Status","ADD_RECIPIENTS":"Add Recipients","PENDING_ADD":"to add","PENDING_REMOVE":"to remove","REMOVE":"Remove","UNDO":"Undo","RECIPIENT_ADDED":"added to pending list","IMAGE_LABEL":"Image","IMAGE_HINT":"optional, max 2 MB, image formats only","IMAGE_SELECT":"Select image","IMAGE_CHANGE":"Change image","IMAGE_REMOVE":"Remove selected","IMAGE_DELETE":"Delete image","IMAGE_WILL_DELETE":"Image will be deleted on save.","IMAGE_TYPE_ERROR":"Only image files are allowed (jpg, png, gif, webp...)","IMAGE_SIZE_ERROR":"Image must be smaller than 2 MB","USER_NOT_FOUND":"User not found with that email","READ_STATUS":"Read status","READ_STATUS_ALL":"All read","READ_STATUS_NONE":"None read","READ_STATUS_PARTIAL":"{{read}} / {{total}} read","READ_STATUS_NO_RECIPIENTS":"—","ACTIONS":"Actions","MARK_READ":"Mark as read","MARK_UNREAD":"Mark as unread","MARK_READ_ERROR":"Error marking notification as read","MARK_UNREAD_ERROR":"Error marking notification as unread","HAS_BUTTON":"Include action button","BUTTON_YES":"Yes","BUTTON_NO":"No","BUTTON_LABEL":"Button label","BUTTON_LABEL_PLACEHOLDER":"e.g. Go to Crypto Wallet","BUTTON_PATH":"Button URL path","BUTTON_PATH_PLACEHOLDER":"e.g. /crypto-wallet","BUTTON_PATH_HINT":"Path suffix only — the base URL is provided by the client environment"},"ADMIN_USERS":{"TITLE":"Admin Users","CREATE_BUTTON":"New Admin","CREATE_TITLE":"Create New Admin User","USERNAME":"Username (email)","PASSWORD":"Password","FIRST_NAME":"First Name","LAST_NAME":"Last Name","SAVE":"Save","CANCEL":"Cancel","COL_ID":"ID","COL_USERNAME":"Username","COL_NAME":"Name","COL_STATE":"Status","ACTIVE":"Active","INACTIVE":"Inactive","ENABLE":"Enable","DISABLE":"Disable","YOU":"You","CHANGE_PASSWORD_TITLE":"Change My Password","CHANGE_PASSWORD_NOTICE":"You are changing the password for your own account:","CURRENT_PASSWORD":"Current Password","NEW_PASSWORD":"New Password","CONFIRM_PASSWORD":"Confirm New Password","CHANGE_PASSWORD_BUTTON":"Change Password"}}}

/***/ }),
/* 708 */
/***/ (function(module, exports) {

	module.exports = {"SPACE":{"MENU":{"HOME":"Home","DASHBOARD":"Dashboard","APPROVAL":"Applicants","APPROVED":"Approved","DECLINED":"Declined","ACCOUNTS":"Accounts","CUSTOMER_ACCOUNTS":"Customer accounts","SYSTEM_ACCOUNTS":"System accounts","LIQUIDITY_ACCOUNTS":"Liquidity accounts","DAILY_BALANCE_REPORT":"Daily balance report","OUTGOING":{"TITLE":"Outgoing Transfers","NEW":"New Transfers","APPROVED":"Approved Transfers","UPLOADED":"Awaiting Reference","HISTORY":"History"},"HISTORY":{"TITLE":"History","TRANSFERS":"Transfers"},"OPEN_BANKING":{"TITLE":"Open Banking","FIAT_LABEL":"─ FIAT","CRYPTO_LABEL":"─ CRYPTO","CLIENTS":"Clients","PAYMENTS":"Payments","INSTITUTIONS":"Institutions","NOTIFICATIONS":"Notifications","GROUPS":"Business Groups","FAILURE_REASONS":"Failure Reasons","SETTLEMENTS":"Settlements","ANALYTICS":"Analytics","CRYPTO_PAYMENTS":"Crypto Payments","CRYPTO_CLIENTS":"Crypto Clients","CRYPTO_ANALYTICS":"Crypto Analytics","CRYPTO_SYSTEM":"Crypto System","CRYPTO_SETTLEMENT_REPORT":"Crypto Settlement"},"INCOMING":{"TITLE":"Incoming Transfers","UPLOADING":"Upload"},"REFILL_CARD":{"TITLE":"Refill Card Transfers","NEW":"New Transfers","AWAITING":"Awaiting Reference"},"INTERNAL":{"TITLE":"Internal Transfers","NEW":"New Transfers"},"SYSTEM":{"TITLE":"System Transfers","REVENUE_TO_INTERNAL":"Revenue to Internal Account","CHARGE_FEES":"Charge additional fee"},"CARDS":{"TITLE":"Cards","NEW":"New cards"},"REPORTS":{"TITLE":"Reports","CUSTOMER_ACCOUNT_STATEMENT":"Customer Account Statement","CUSTOMER_ACCOUNT_STATEMENT_PAYTAH":"Customer Account Statement PAYTAH STATEMENTS","CUSTOMER_ACCOUNT_STATEMENT_PAYTAH_1":"Customer Account Statement PDF PAYTAH STATEMENTS (1)","CUSTOMER_BALANCES":"Customer Balances","FEE_ERRORS":"Fee Errors","REVENUE_ACCOUNT":"Revenue Account","TX_RECONCILIATION":"TX Reconciliation","LEGACY_CONFIG":"Legacy DB Config","TRANSACTION_DETAIL":"Transaction Detail","MOORWAND_BALANCE_REPORT":"Moorwand Balance Report (SFTP)"},"CONFIG":{"TITLE":"Configuration","TARIFFS":"Tariffs","AML_RULES":"TM Rules","MOORWAND_REPORTS":"Provider Reports","DEPOSIT_BALANCE":"Deposit Balance","DAILY_CHECK_PEP":"Daily check PEP","CLIENT_NOTIFICATIONS":"Client Notifications","ADMIN_USERS":"Admin Users","IBAN_CACHE":"IBAN / iban.com Cache"},"CRYPTO":{"TITLE":"Kraken Embed","TRANSACTIONS":"Transactions","CONVERSIONS":"Conversions","KYC":"KYC","SETTLEMENT":"Settlement","SETUP":"Customer setup","ACCESS":"Feature access","API_CONSOLE":"API console","TOKENS":"Tokens"},"CUSTOMERS":{"TITLE":"Customers","REGISTERED_PROFILES":"Registered","PENDING_PROFILES":"Pending"},"APPLICATIONS":{"TITLE":"Applications","NEW":"New","PROCESSING":"Processing","DECLINED":"Declined / Rejected","ON_HOLD":"On hold","ARCHIVED":"Archived","MANUAL_REVIEW":"Manual review"},"PAYMENT_PROCESSING":{"TITLE":{"ORDERS":"External processing orders","PAYMENTS_CONTROL":"Manual Payments Control"},"REFUND":"Refund outgoing","CANCELLED":"Cancelled incoming","UNDELIVERED":"Undelivered","INCOMING":"Incoming","OUTGOING":"Outgoing","MOORWAND_PAYMENT":"Moorwand Payments","MOORWAND_BLACK_LIST":"Moorwand Black List","MOORWAND_RECONCILIATION_REPORT":"Moorwand Reconciliation Report"}}}}

/***/ }),
/* 709 */
/***/ (function(module, exports) {

	module.exports = {"FILTER":{"BUTTON":{"SEARCH":"Search","RESET":"Reset","SHOW":"Show","HIDE":"Hide"}}}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

	module.exports = {"PROCESSING":{"FILTER":{"ID_PLACEHOLDER":"e.q. 12345","PAYMENT_ID":"Payment ID","PERIOD":"Order created","SCHEME":"Transfer scheme","ORDER_ID":"Order ID","SENDER_NAME":"Sender name","SENDER_BIC":"Sender BIC","SENDER_ACCOUNT":"Sender IBAN","AMOUNT":"Amount","CUSTOMER_NAME":"Customer name","CUSTOMER_ACCOUNT":"Customer IBAN","PROCESSING_MODULE":"Processing system","PROVIDER":"Provider","ALL_PROVIDERS":"All providers","PLACEHOLDER":{"NON_SPECIFIED_NUMBER_VALUE":"e.g. 12345","NON_SPECIFIED_STRING_VALUE":"e.g. John Doe","SENDER_BIC":"e.g. MDNDP123"}},"ACTIONS":{"SHOW_DETAILS":"Show details","HIDE_DETAILS":"Hide details","ACCEPT":"Accept","REJECT":"Reject","DELAY_PAYMENT":"Delay payment","REPROCESS":"Reprocess"},"ITEM":{"ORDER_ID":"Order ID","ORDER":"Order","PAYMENT_ID":"Payment ID","ORDER_CREATED":"Order created","REFERENCE":"Reference","OUTGOING_BANK_REFERENCE":"Outgoing bank reference","RETURN_BANK_REFERENCE":"Return bank reference","BANK_REFERENCE":"Bank reference","MESSAGE":"Message","DETAILS":"Order Details","ATTRIBUTE":"Attribute","VALUE":"Value","TRANSFER_INFORMATION":"Transfer information","EMPTY_DETAILS":"There are no details!","STATE_LOG":"Order State Changes","ORDER_STATE":"Order state","REASON":"Reason","SUSPENSION_REASON":"Reason of suspension","SUSPENSION_TIME":"Time of suspension","REJECTION_REASON":"Rejection reason","NO_REASON":"No reason recorded","PAYMENT_STATE_BADGE":"Payment: {{state}}","PAYMENT_CREATED":"Payment created","SENDER_TO_BENEFICIARY":"Sender → Beneficiary","INSTRUCTION_DATE":"Instruction date","PROVIDER_TITLE":"Provider (liquidity pool) of the payment","PAYMENT_STATE_TITLE":"Current state of the payment","AMOUNT":"Amount","CURRENCY":"Currency","ERROR":"Error","RETURNED_AMOUNT":"Returned amount","OUTGOING_PAYMENT_AMOUNT":"Outgoing payment amount","NARRATIVE":"Narrative","REMITTANCE":"Remittance information","ERROR_REASON":"Error reason","AML_RULE_MESSAGE":"AML Rule Message","PEP_MESSAGE":"PEP Message","SENDER":{"NAME":"Sender name","IBAN":"Sender IBAN","ACCOUNT":"Sender account","ULTIMATE_SENDER":"Ultimate Sender","BIC":"Sender BIC","RISK_LEVEL":"Risk Level"},"CUSTOMER":{"NAME":"Customer name","ACCOUNT":"Customer account","ULTIMATE_BENEFICIARY":"Ultimate beneficiary"},"BENEFICIARY":{"BIC":"Beneficiary BIC","NAME":"Beneficiary name","ACCOUNT":"Beneficiary account","IBAN":"Beneficiary IBAN"},"FEE":"Fee","LOG":{"DATE":"Date","USERNAME":"Username","STATE":"State","MESSAGE":"Message","EMPTY":"No activity for the order!"},"ALLOCATE":"Allocate","APPROVE":"Approve","REJECT":"Reject","SHOW":"Show details","HIDE":"Hide details","NOT_UNIQUE_ACCOUNT":"Customer account number isn’t unique","ACCOUNT_IS_NOT_ACTIVE":"Account is not active","MODULE":{"SEPA_MMS_CT":"SCT (SEPA-MMS)","SEPA_MMS_CT_INST":"SCT INST (SEPA-MMS)","CURRENCY_CLOUD":"CURRENCY CLOUD (FTG)"}},"EMPTY_ORDERS":"No orders found!","LIST":{"TOTAL":"{{total}} orders","TOTAL_ONE":"1 order","SORT_TITLE":"Sort by order creation date","SORT_BY_DATE":"Sort by date","NEWEST_FIRST":"Newest first","OLDEST_FIRST":"Oldest first"},"CANCELLED":{"TITLE":"Manual Cancelled Incoming Transfers Control","REJECT":{"MODAL_TITLE":"Reject cancellation request?","MODAL_ACCEPT":"Yes, keep a transaction","REASON":"Reason","MW_REASON":"Moorwand Reason","CHOOSE_REASON":"Choose reason","DESCRIPTION":"Further details on the cancellation status reason","DESCRIPTION_REQUIRED":"This field is required, with current reason.","EMAIL_NOTIFICATION":"*Customer will be notified by email after your confirmation"},"ARCHIVED":{"DESCRIPTION":"Further details on the archived status reason","EMAIL_NOTIFICATION":"*Customer will be notified by email after your confirmation"},"ON_HOLD":{"DESCRIPTION":"Further details on the on hold status reason"}},"REFUND":{"TITLE":"Manual Refund Outgoing Transfers Control","EMPTY_ORDERS":"There are no any transfers with refund."},"REJECTED":{"TITLE":"Manual Rejected Transfers Control"},"UNDELIVERED":{"REJECT":{"MODAL_TITLE":"Reject payment?","MODAL_ACCEPT":"Yes","REASON":"Reason","CHOOSE_REASON":"Choose reason"},"ALLOCATE":{"MODAL_TITLE":"Allocate payment?","MODAL_QUESTION":"Do you want to allocate order with id = {{id}}?","MODAL_ACCEPT":"Yes","MODAL_CLOSE":"No"}},"INCOMING":{"TITLE":"Manual Payments Control / Incoming","TABS":{"NEW":"New","UNDELIVERED":"Undelivered","REJECTED":"Rejected","WAITING_CANCELLATION":"Waiting cancellation","SUSPENDED":"Suspended"},"REJECT":{"MODAL_TITLE":"Reject Incoming Transaction","MODAL_ACCEPT":"Yes, reject transaction","REASON":"Reason","CHOOSE_REASON":"Choose reason","DESCRIPTION":"Further details on the rejection reason","DESCRIPTION_REQUIRED":"This field is required, with current reason."},"REPROCESS":{"DIALOG_TITLE":"Reprocess Incoming Transaction","DIALOG_REPROCESS":"Reprocess","DESCRIPTION":"This will credit the incoming transfer in the customer account, are you sure you want to continue?"},"ACCEPT":{"DIALOG_TITLE":"Accept cancellation request","DIALOG_DESCRIPTION":"Are you sure you want to continue?","SUCCESS":"Cancelation request approved. Return payment created - ID {{id}}","DIALOG_ACCEPT":"Accept"}},"OUTGOING":{"EMPTY_ORDERS":"There are no any outgoing transfers.","TITLE":"Manual Payments Control / Outgoing","TABS":{"RETURNED":"Returned","REJECTED":"Rejected","IN_PROGRESS":"In progress","ERROR":"Error"},"ORDER_STATE":{"NEW":"New","IN_PROGRESS":"In progress"},"IN_PROGRESS":{"STALE_BADGE":"Stale","STALE":"The payment state is {{state}}: this order is no longer pending."},"DIALOG":{"TITLE":"Reject Transaction","BUTTON":"Yes, reject Transaction","REASON":"Specify reason:"},"REJECTED_ORDER":{"SUB_ACCOUNT_BADGE":"Sub-account payment","CLIENT":"Client: {{clientName}} · Sub-account {{clientAccount}}","MASTER_PART":"This is the master account part. Client's part: payment","SUBACCOUNT_PART":"This is the client's part. Master account part: payment","RELEASE":"Accepting rejects both parts and releases {{amount}} to the client.","ALSO_REJECTS_MASTER":"Accepting also rejects the master account part (payment {{linkedPaymentId}}).","NOT_ACCEPTABLE":"This order cannot be accepted: payment {{id}} is already {{state}}.","NOT_ACCEPTABLE_NO_PAYMENT":"This order cannot be accepted: it has no outgoing payment in external processing.","EMPTY":"No rejected outgoing orders found","EMPTY_HINT":"Orders stay here until their rejection is accepted. Change the filters to search again.","ACCEPT_DISABLED":"Accept is not possible: the payment of this order is no longer in external processing.","DIALOG":{"SUMMARY":"Reject payment {{id}} · {{amount}} · to {{recipient}}","SUB_ACCOUNT_MASTER":"Sub-account payment of {{clientName}} (the client's part, payment {{linkedPaymentId}}, is rejected too)","SUB_ACCOUNT_MASTER_INFO":"Sub-account payment of {{clientName}} (client's part: payment {{linkedPaymentId}}, {{state}})","SUB_ACCOUNT_CLIENT":"Sub-account payment of {{clientName}} (the master account part, payment {{linkedPaymentId}}, is rejected too)","SUB_ACCOUNT_CLIENT_INFO":"Sub-account payment of {{clientName}} (master account part: payment {{linkedPaymentId}}, {{state}})","EMAIL_WARNING":"The text below is sent to the client in the rejection email.","RECIPIENTS_TITLE":"Send the rejection email to","RECIPIENTS_HINT":"Users with access to account {{account}}. Nothing selected: no email is sent.","RECIPIENTS_LOADING":"Loading recipients...","RECIPIENTS_ERROR":"Could not load the recipients. The email goes to the configured rejected payments email.","SELECT_ALL":"Select all","SELECTED":"{{selected}} of {{total}} selected","CONFIGURED_EMAIL":"Rejected payments email of the client","NO_CONFIGURED_EMAIL":"The client has no rejected payments email configured.","NO_USERS":"No active user has access to this account.","NO_RECIPIENTS_WARNING":"No recipient selected: the rejection will be accepted without sending any email."}},"ERROR":{"DIALOG_TITLE":"Change narrative and resend the payment to Modulr","DIALOG_DESCRIPTION":"Are you sure you want to resend the payment to Modulr?","SUCCESS":"Payment send to Modulr","DIALOG_ACCEPT":"Accept","EDIT":"Edit narrative","FILTERS":"Filters","MERCHANT_TXN_REF":"Merchant Txn Ref","MERCHANT_TXN_REF_PLACEHOLDER":"Search by merchant txn ref...","CREATED_AT":"Created at","CREATED_AT_PLACEHOLDER":"Search by date (dd.mm.yyyy)...","AMOUNT":"Amount","AMOUNT_PLACEHOLDER":"Search by amount...","CLEAR_FILTERS":"Clear filters","SHOWING":"Showing {{shown}} of {{total}} results","LOAD_ERROR":"Could not load the payments in error from the payment gateway. This does not mean that there are none.","RETRY":"Try again","REPROCESS_SUCCESS":"Payment reprocessed successfully","REJECT_SUCCESS":"Payment rejected successfully","REJECT_DIALOG":{"TITLE":"Reject this FinXP payment?","REFERENCE":"Payment reference: {{reference}}","AMOUNT":"Amount: {{amount}}","BENEFICIARY":"Beneficiary: {{beneficiary}}","WARNING":"The payment is rejected in the FinXP gateway with reason UNKNOWN.","CONFIRM":"Yes, reject payment"}}},"MOORWAND_PAYMENT":{"EMPTY_ORDERS":"There are no any transfer.","LOAD_ERROR":"Could not load Moorwand transfers. Please try again shortly.","EMPTY_HINT":"By default only the last 31 days are searched (Moorwand limit). If you are looking for an older payment, select a date range above and search again.","TITLE":"Moorwand Transfers","GENERAL":{"TITLE":"General Data","TOTAL_COUNT":"Total Count","REJECTED_COUNT":"Rejected Count","SUM_CREDITS":"Sum Credits","SUM_DEBITS":"Sum Debits","COUNT_CREDITS":"Count Credits","COUNT_DEBITS":"Count Debits"},"FILTER":{"FILTER_LIST":"Filter on list","WEBBANK_PAYMENT_ID":"Payment ID (Monetum)","MW_PAYMENT_ID":"Payment ID (Moorwand)","END_TO_END_ID":"End to End identifier","TRANSACTION_IDENTIFIER":"Transaction identifier","REFERENCE":"Reference","REQUEST_REFERENCE":"Request reference","SENDER_NAME":"Sender name","SENDER_IBAN":"Sender iban","RECIPIENT_NAME":"Recipient name","RECEIVER_IBAN":"Receiver iban","AMOUNT":"Amount (debit or credit)","NARRATIVE":"Narrative / note","PERIOD_HINT":"All filters are optional. Without a date range, the last {{days}} days are shown - Moorwand only allows querying up to 31 days at a time. To find older payments, select a date range.","SECTION_MOORWAND":"Search by Moorwand data","SECTION_MONETUM":"Search by our data (Monetum)","WEBBANK_STATE":"Our payment state","WEBBANK_CUSTOMER_NAME":"Our customer name","DEBIT_AMOUNT":"Debit amount","CREDIT_AMOUNT":"Credit amount","NOTE":"Note"},"TABLE_COLUMN":{"GROUP_MOORWAND":"Moorwand data","GROUP_MONETUM":"Our data (Monetum)","MONETUM_ID":"Our ID","MONETUM_STATE":"Our state","ID":"ID","DATE":"Date","SENDER":"Sender","RECIPIENT":"Recipient","DEBIT":"Debit","CREDIT":"Credit","DESCRIPTION":"Description","PARENT_TX_ID":"Parent Transaction ID","TRANSACTION_TYPE":"Transaction Type","IS_REJECTED":"Is Rejected","DATETIME":"Datetime","CURRENCY":"Currency","ADDITIONAL_INFO":{"SOURCE_MANDATE_ORIGINATOR":"Source Mandate Originator","DESTINATION_MANDATE":"Destination Mandate","SENDER_DATA":"Sender Data","RECEIVER_DATA":"Receiver Data","RETURN_DETAILS":"Return Details","REASON_CODE":"Reason Code","TRANSACTION_DETAILS":"Transaction Details","REFERENCE":"Reference","REQUEST_REFERENCE":"Request Reference","TRANSACTION_IDENTIFIER":"Transaction Identifier","END_TO_END_IDENTIFIER":"End-to-End Identifier","TX_SCHEME":"Transaction Scheme","TX_CREATED_DATE":"Transaction Created Date","TX_CREATED_DATETIME":"Transaction Created Datetime","TX_UPDATED_DATE":"Transaction Updated Date","TX_UPDATED_DATETIME":"Transaction Updated Datetime","IS_STATUS_SETTLED":"Is Status Settled","IS_STATUS_PENDING":"Is Status Pending","IS_STATUS_REVERSAL":"Is Status Reversal","IS_STATUS_HELD":"Is Status Held","IS_CANCELLATION":"Is Cancellation","IS_RETURN":"Is Return","IS_DIRECT_CREDIT":"Is Direct Credit","IS_DIRECT_DEBIT":"Is Direct Debit","SENDER_DATA_OBJ":{"IBAN_ID":"IBAN ID","IBAN":"Sender Iban","ACCOUNT_NAME":"Account Name","ACCOUNT_NUMBER":"Account Number","SORT_CODE":"Sort Code","BIC":"BIC","NAME":"Name","COUNTRY":"Country","ADDRESS_LINE_ONE":"Address Line One","ADDRESS_LINE_TWO":"Address Line Two"},"RECEIVER_DATA_OBJ":{"IBAN_ID":"IBAN ID","IBAN":"Receiver Iban","ACCOUNT_NAME":"Account Name","ACCOUNT_NUMBER":"Account Number","SORT_CODE":"Sort Code","BIC":"BIC","NAME":"Name","COUNTRY":"Country","ADDRESS_LINE_ONE":"Address Line One","ADDRESS_LINE_TWO":"Address Line Two"},"TRANSACTION_DETAILS_OBJ":{"SENDER_DATA":{"NAME":"Name","IBAN":"Iban","COUNTRY":"Country","ADDRESS_LINE_ONE":"Address line one","ADDRESS_LINE_TWO":"Address line two"},"RECEIVER_DATA":{"NAME":"Name","IBAN":"Iban","COUNTRY":"Country","ADDRESS_LINE_ONE":"Address line one","ADDRESS_LINE_TWO":"Address line two"},"NOTE":"Note","PURPOSE":"Purpose"}}},"DETAIL":{"SECTION_MONETUM":"Our data (Monetum)","SECTION_MOORWAND":"Moorwand data","MONETUM_ID":"Our payment ID","MONETUM_STATE":"Our payment state","MONETUM_TYPE":"Our payment type","MONETUM_SENDER_NAME":"Our sender name","MONETUM_SENDER_ACCOUNT":"Our sender account","MONETUM_RECIPIENT_NAME":"Our recipient name","MONETUM_RECIPIENT_ACCOUNT":"Our recipient account","MONETUM_AMOUNT":"Our amount","MONETUM_NARRATIVE":"Our narrative","MONETUM_DATE":"Created in our system"}},"MOORWAND_RECONCILIATION_REPORT":{"EMPTY_ORDERS":"There are no any transfer.","TITLE":"Moorwand Reconciliation Report","FILTER":{"IBAN":"Iban"},"TABLE_COLUMN":{"PAYMENT_ID":"Payment ID","CLIENT_NAME":"Client Name","TYPE":"Type","STATUS":"Status","SENDER_IBAN":"Sender IBAN","RECIPIENT_IBAN":"Recipient IBAN","AMOUNT":"Amount","NARRATIVE":"Narrative","CREATE_TIME":"Create Time","BANK_REFERENCE":"Bank Reference"}},"MOORWNAD_BLACK_LIST":{"TITLE":"Moorwand Black List","SUCCESS_UPLOAD":"File loaded successfully","UPLOAD_BUTTON":"Upload File","ADD_MULTIPLE_NAMES_INFO":"You can add multiple names separated by a semicolon (;) if you wish to add more than one person at once.","PERSON_NAME":"Full Name","ADD_DIALOG":"Add to blacklist","ADD_SINGLE_NAME_LABEL":"Add a single name","ADD_MULTIPLE_NAMES_CHECK_LABEL":"Add more than one name","ADD_MULTIPLE_NAMES_TEXTAREA_LABEL":"Names to add to the blacklist","ADD_DIALOG_ACCEPT_BUTTON":"Accept","ADD_PERSON":"Add Member","ADD_SUCCES":"Person successfully added","EDIT_DIALOG":"Edit person name","EDIT":"Edit","EDIT_SUCCES":"Correctly edited person","DELETE":"Delete","DELETE_SUCCES":"Successfully removed person","NO_PERSON":"There are no people on the blacklist","PERSON_NOT_FOUND":"No one with that name has been found","ACTIONS":"Actions","CONFIRM_UPLOAD_DIALOG_TITLE":"Confirmation Required","CONFIRM_UPLOAD_DIALOG_MESSAGE":"By performing this action, the current list will be deleted and replaced with a new one. Are you sure you want to proceed?","CONFIRM_UPLOAD_DIALOG_CONFIRM_BUTTON":"Yes, Proceed","CONFIRM_UPLOAD_DIALOG_CANCEL_BUTTON":"Cancel"},"MANUAL":{"ACCEPT":{"DIALOG_TITLE":"Accept incoming order","DIALOG_DESCRIPTION":"This will credit the incoming transfer in the customer account, are you sure you want to continue?","DIALOG_ACCEPT":"Accept"}},"RETURNED":{"EMPTY_ORDERS":"There are no any returned transfers.","APPROVE_UNDELIVERED":{"FAILURE":"Something has changed after initial approval attempt, please try again","MODAL_TITLE":"Undelivered payment will be created","MODAL_QUESTION":"Reason(s):","MODAL_ACCEPT":"Yes, create undelivered payment","MODAL_CLOSE":"No"}}}}

/***/ }),
/* 711 */
/***/ (function(module, exports) {

	module.exports = {"REPORTS":{"OVERVIEW":{"TITLE":"Reports","SUBTITLE":"Select a report to generate and download.","OPEN":"Open Report","COUNT":"reports available","LEGACY_CONFIG":"Legacy DB Config"},"RUNNER":{"BACK":"Back to Reports","FORMAT":"Output Format","FORMAT_PDF_DESC":"Formatted document","FORMAT_CSV_DESC":"Spreadsheet / data export","PARAMETERS":"Report Parameters","REQUIRED_HINT":"Fields marked with * are required","GENERATE":"Generate Report","GENERATING":"Generating...","CANCEL":"Cancel","FIELD_REQUIRED":"This field is required.","SUCCESS":"Report generated successfully. Download started.","LEGACY_BADGE":"Legacy DB","LEGACY_WARNING_TITLE":"Outdated data source.","LEGACY_WARNING_TEXT":"This report queries the legacy reporting database (webbank), which is no longer the system of record and may contain stale or incomplete data. Use only for historical reconciliation.","PRESETS":"Quick select","PROVIDER_HINT":"select one or more providers, or use a preset","PROVIDERS_SELECTED":"provider(s) selected"},"FIELD":{"ACCOUNT_NUMBER":"Account Number","IBAN":"IBAN","TRX_ID":"Transaction ID","PERIOD":"Period (From / To)","PERIOD_BASIC":"Statement Period (Start / End)","END_DATE":"End Date","STATEMENT_TYPE":"Statement Type","PROVIDER":"Provider","REVENUE_POOL":"Revenue Pool","REPORT_VARIANT":"Report"},"STMT_TYPE":{"PDF_BASIC":"Customer Account Statement PDF","PDF_PAYTAH":"Customer Account Statement PDF PAYTAH","CSV_BASIC":"Customer Account Statement CSV","CSV_PAYTAH":"Customer Account Statement CSV PAYTAH"},"PROVIDER":{"ALL":"All Providers","DEFAULT":"All providers","MOORWAND":"Moorwand","3R":"3R","VERIFO":"Verifo","EMONEY":"3R","FINXP":"FinXp","MODULR":"Modulr","MODULR_ES":"Modulr ES","PAYSWIX":"Payswix","MONETUM_SUBACCOUNT":"Monetum Subaccount","MONETUM_NOIBAN":"Monetum No-IBAN"},"PROVIDER_PRESET":{"ALL":"All providers (no filter)","MOORWAND_MODULR_MODULR_ES_3R":"Moorwand + Modulr + Modulr ES + 3R","MOORWAND_MODULR_MODULR_ES":"Moorwand + Modulr + Modulr ES","MOORWAND_MODULR":"Moorwand + Modulr"},"REVENUE_POOL":{"ALL":"All Revenue Pools","MOORWAND":"Moorwand","EMONEY":"3R","MODULR":"Modulr","FINXP":"FinXp","PAYSWIX":"Payswix","MONETUM_SUBACCOUNT":"Monetum Subaccount"},"REVENUE_VARIANT":{"BALANCE_MODIFICATIONS":"Revenue Account Balance Modifications","TRANSACTIONS":"Revenue Account Transactions Statement","MODULR_MOORWAND":"Revenue Account Transactions Statement - Monetum Pay (Modulr-MW)","MOORWAND":"Revenue Account Transactions Statement - Moorwand","THREE_R":"Revenue Account Transactions Statement - 3R"},"CUSTOMER_ACCOUNT_STATEMENT":{"TITLE":"Customer Account Statement","DESC":"Generate a full account statement (PDF or CSV) for a given account number and date range."},"CUSTOMER_ACCOUNT_STATEMENT_PAYTAH":{"TITLE":"Customer Account Statement PAYTAH STATEMENTS","DESC":"Generate a Paytah-branded account statement. Choose PDF for a branded document or CSV for data export."},"CUSTOMER_ACCOUNT_STATEMENT_PAYTAH_1":{"TITLE":"Customer Account Statement PDF PAYTAH STATEMENTS (1)","DESC":"Generate the alternate Paytah-branded PDF account statement variant."},"CUSTOMER_BALANCES":{"TITLE":"Customer Balances","DESC":"Snapshot of all customer account balances at a given date."},"FEE_ERRORS":{"TITLE":"Fee Errors","DESC":"List of transactions where fee processing encountered errors."},"TRANSACTION_DETAIL":{"TITLE":"Transaction Detail","DESC":"Full detail view of a single payment transaction by ID."},"REVENUE_ACCOUNT":{"TITLE":"Revenue Account","DESC":"Revenue account transactions for a given period."},"TX_RECONCILIATION":{"TITLE":"TX Reconciliation","DESC":"Reconciliation report of all transactions by provider."},"LEGACY_CONFIG":{"TITLE":"Legacy DB Configuration","DESC":"Manage connections to legacy reporting databases. The active connection is used exclusively by Paytah statement reports (PDF and CSV). Only one connection can be active at a time — activating a new one automatically deactivates the current one.","SAVED_CONFIGS":"Saved Connections","ADD_NEW":"Add Connection","NO_CONFIGS":"No connections configured yet. Click \"Add Connection\" to get started.","NEW_CONFIG":"New Connection","EDIT_CONFIG":"Edit Connection","COL_NAME":"Name","COL_URL":"JDBC URL","COL_USER":"Username","COL_DATABASE":"Database","COL_STATUS":"Status","NAME":"Connection Name","CONNECTION":"JDBC Connection Settings","HOST":"Host","PORT":"Port","DATABASE":"Database","SSL_MODE":"SSL Mode","JDBC_URL_PREVIEW":"JDBC URL","JDBC_URL_MANUAL_MODE":"Enter full URL manually","JDBC_URL_FIELDS_MODE":"Use individual fields","JDBC_URL_MANUAL_HINT":"Paste a full JDBC URL, e.g. jdbc:postgresql://host:5432/db or jdbc:postgresql://host:5432/db?sslmode=require","USERNAME":"Username","PASSWORD":"Password","MAX_ACTIVE":"Max Pool Size","POOL_ACTIVE":"Pool Active","POOL_INACTIVE":"Pool Inactive","INACTIVE":"Inactive","ACTIVATE":"Activate","LAST_UPDATED":"Last updated","TEST_CONNECTION":"Test Connection","TESTING":"Testing...","TEST_SUCCESS":"Connection successful! The credentials are valid.","TEST_FAILED":"Connection failed","SAVE":"Save","SAVING":"Saving...","SAVE_SUCCESS":"Configuration saved successfully.","ERROR_LOAD":"Failed to load legacy datasource configurations.","ERROR_SAVE":"Failed to save configuration. Please try again.","ERROR_ACTIVATE":"Failed to activate configuration. Please try again.","ERROR_DELETE":"Failed to delete configuration. Please try again."},"MOORWAND_BALANCE":{"TITLE":"Moorwand IBAN Daily Balance Report","DESC":"Download the daily balance report for all Moorwand IBANs as an Excel file.","INFO":"This report is generated on demand and downloaded directly as an Excel file.","AUTO_INFO":"This report is also generated automatically every day and transmitted to Moorwand. Use this page to manually download it for any date.","DOWNLOAD":"Download Report","DATE_HINT":"Select the date of the data you want. Example: select the 14th to get balances as of the 14th. The automatic report runs at 00:30h on the 15th and contains data from the 14th.","CUTOFF":{"TITLE":"Day cutoff hour configuration","DESC":"Moorwand closes each reporting day at midnight London time. Depending on the time of year, this corresponds to a different UTC hour. Select the correct mode below — it applies to both the automatic daily report and any manual download on this page.","LABEL":"Active time mode","OPT_SUMMER":"Summer / BST (Mar–Oct) — cutoff at 22:59:59 UTC (midnight London UTC+1)","OPT_WINTER":"Winter / GMT (Nov–Mar) — cutoff at 23:59:59 UTC (midnight London UTC+0)","HINT":"Last UK clock change: 30 Mar 2026 → BST active. Next change: 26 Oct 2026 → GMT.","LOADING":"Loading configuration...","SAVE":"Save configuration","SAVING":"Saving...","SAVED":"Configuration saved successfully.","LOAD_ERROR":"Could not load the cutoff configuration. Please refresh the page.","SAVE_ERROR":"Could not save the configuration. Please try again."}},"ERROR":{"GENERATION_FAILED":"Report generation failed. Please check the parameters and try again.","INVALID_DATE":"Please select a valid date before downloading.","BUSY":"Another report is being generated. Please try again in a minute.","TOO_MANY_ROWS":"This report has {{rows}} transactions and a {{format}} file can hold up to {{max}}. Please choose a shorter date range.","TOO_MANY_ROWS_OVER":"This report has more than {{max}} transactions, the most a {{format}} file can hold. Please choose a shorter date range."}}}

/***/ }),
/* 712 */
/***/ (function(module, exports) {

	module.exports = {"BY_VENDOR":{"SPACE.TRADE":"Monetum","LOGIN.HEADER":"Log in to Monetum Back-office","CUSTOMER":{"ADDITIONAL":{"SEND_NOTIFICATIONS":"Monetum send notifications","SEND_NOTIFICATIONS_TRUE":"I would like Paytah to send me commercial offers, promotional and/or analytical materials.","SEND_NOTIFICATIONS_FALSE":"I would not like Paytah to send me any promotional materials. I acknowledge that in this case the White Label may be unable to offer me new, better services and/or terms of account maintenance.","REASON":"Reasons for choosing Monetum","SOURCE":"Source of information about Monetum"}}}}

/***/ }),
/* 713 */
/***/ (function(module, exports) {

	module.exports = {"BY_VENDOR":{"SPACE.TRADE":"White Label","LOGIN.HEADER":"Log in to White Label Back-office","CUSTOMER":{"ADDITIONAL":{"SEND_NOTIFICATIONS":"White Label send notifications","SEND_NOTIFICATIONS_TRUE":"I would like White Label to send me commercial offers, promotional and/or analytical materials.","SEND_NOTIFICATIONS_FALSE":"I would not like White Label to send me any promotional materials. I acknowledge that in this case the White Label may be unable to offer me new, better services and/or terms of account maintenance.","REASON":"Reasons for choosing White Label","SOURCE":"Source of information about White Label"}}}}

/***/ }),
/* 714 */
[3022, 715, 716, 717, 718, 719, 720, 721, 722, 723, 724, 725, 726, 727, 728, 729, 730, 731, 732, 733],
/* 715 */
/***/ (function(module, exports) {

	module.exports = {"COMMON":{"ID":"ID","LOGIN":"Accedi","BACK":"Indietro","SAVE":"Salva","NEXT":"Avanti","CANCEL":"Annulla","CONFIRM":"Conferma","CLOSE":"Chiudi","LOADING":"Caricamento","APPROVE":"Approva","DONE":"Fatto","COPY":"Copia","GOT_IT":"Fatto","VIEW":"Vedi","HIDE":"Nascondi","SHOW_ALL":"mostra tutto","NEXT_STEP":"Passaggio successivo","PREVIOUS_STEP":"Passaggio precedente","EMPTY_RESULT":"Non ci sono registrazioni!","VALIDATION":{"REQUIRED":"Questo campo è necessario.","EMAIL":"E-mail è errata.","IBAN":{"REQUIRED_FOR_POOL":"Devi specificare l'IBAN per il pool corrente","CHECKSUM":"Questo IBAN non è valido. Il checksum non è corretto","COUNTRY":"Questo numero IBAN non è valido. I numeri emessi in {{country_name}} non sono supportati","LENGTH":"Questo IBAN è troppo {{size}}. I numeri per {{country_name}} devono avere una lunghezza di {{chars}} caratteri","BIG":"grande","SMALL":"piccolo"}},"LOAD_MORE":"Carica altro","ROW_PER_PAGE":"Riga per pagina","ERROR":"Spiacenti, qualcosa è andato storto! Contatta il team di assistenza tecnica.","RELOAD_PAGE":"Ricarica pagina.","LEAVE_BLOCK":{"TITLE":"Lasciare la pagina?","MESSAGE":"Se esci prima di salvare, le modifiche andranno perse.","STAY":"Resta","LEAVE":"Abbandona"},"YES":"Si","NO":"No","CLEAR":"Cancella","SEARCH":"Cerca","DIALOG":{"ATTENTION":"Attenzione!"}},"TABLES":{"RECORDS_OF_TOTAL":"{{min}} - {{records}}  di  {{total}}"}}

/***/ }),
/* 716 */
/***/ (function(module, exports) {

	module.exports = {"LOGIN":{"LOGIN_BUTTON":"ACCEDI","USERNAME":"E-mail","PASSWORD":"Password","LOGIN_MIN_LENGTH":"La lunghezza minima è di 3 caratteri.","LOGIN_MAX_LENGTH":"La lunghezza massima è di 50 caratteri.","PASSWORD_MAX_LENGTH":"La lunghezza massima è di 50 caratteri.","EXPIRED_LOGOUT":"La tua sessione è scaduta. Accedi di nuovo."}}

/***/ }),
/* 717 */
/***/ (function(module, exports) {

	module.exports = {"POOLS":{"TITLE":"Pool di liquidità","WARNING":"Spiacenti! Non c'è nessun pool presente. Puoi aggiungere il primo.","POOL":{"TITLE":"Informazioni Pool","ID":"Pool ID:","NAME":"Nome Pool:","TYPE":"Tipo Pool:","SENDER_INFORMATION":"Informazioni sul mittente:","COULD_CREATE_ACCOUNT_UNDER_POOL":"I tuoi clienti possono finanziare il loro conto corrente tramite questo pool di liquidità? Se sì, devi renderlo un pool pubblico e definire le istruzioni di finanziamento:","PUBLIC_PERMISSION":"Pubblico","PRIVATE_PERMISSION":"Privato"}}}

/***/ }),
/* 718 */
/***/ (function(module, exports) {

	module.exports = {"LIQUIDITY_ACCOUNTS":{"WARNING":{"NO_ACCOUNTS":"Spiacenti! Non ci sono account. Puoi aggiungere il primo!"},"TABLE_COLUMN":{"ID":"ID","NAME":"Nome","NUMBER":"Numero","BALANCE":"Saldo","CURRENCY":"Valuta","IBAN":"IBAN","REFILL_DATE":"Data ultima ricarica"},"EDIT":{"SELECT_TITLE":"Seleziona account di liquidità"},"MODAL":{"HEADER":"Cambia account di liquidità","BODY":{"DESCRIPTION":"Per modificare il pool di liquidità di queste transazioni selezionalo dall'elenco sottostante. Tieni presente che questa azione non può essere annullata."}}}}

/***/ }),
/* 719 */
/***/ (function(module, exports) {

	module.exports = {"FULL_ACCOUNT_INFO":{"ACCOUNT":{"TITLE":"Informazioni Account","ACCOUNT_NAME":"Nome Account:","LIQUIDITY_ACCOUNT_NUMBER":"Numero Accoun liquidità:","BALANCE":"Saldo:","STATUS":"Status:","COULD_TRANSFER":"È possibile trasferire fondi da questo conto di liquidità:"},"FUNDING_INSTRUCTIONS":{"TITLE":"Istruzioni invio fondi","IBAN":"IBAN:","BANK_ACCOUNT_NUMBER":"Conto bancario numero:","ACCOUNT_BRANCH":"Filiale di conto :","BANK_ACCOUNT_NAME":"Nome conto bancario:","CURRENCY":"Valuta:","BANK_NAME":"Nome banca:","BANK_ADDRESS":"Indirizzo banca:","COUNTRY":"Paese:","BANK_BRANCH":"Filiale Banca:","SWIFT":"SWIFT:","IBAN_SOURCE":"IBAN:"}},"CUSTOMER_ACCOUNTS":{"TITLE":"Conti Cliente","LOAD_MORE":"Carica altro","ACCOUNT_NAME":"Nome account","ACCOUNT_TYPE":"Tipo","ACCOUNT_NUMBER":"Account №","CURRENCY":"Valuta","CUSTOMER_NAME":"Cliente","BALANCE":"Saldo","AVAILABLE_BALANCE":"Saldo disponibile","LAST_TRANSFER_DATE":"Data ultimo trasferimento","NO_ANY_CUSTOMER_ACCOUNT":"Spiacenti! Non ci sono account cliente nel sistema.","MIN_SEARCH_LENGTH":"La lunghezza minima è di 3 caratteri","MIN_ACCOUNT_LENGTH":"La lunghezza massima è di 12 caratteri","NEW_ACCOUNT":"Nuovo Account","NEW_ACCOUNT_TITLE":"Nuovo Account Cliente","TYPE_CUSTOMER_NAME":"Digita il nome del cliente","CHOOSE_POOL":"Seleziona pool liquidità","PRODUCT_CODE":"Select product code","CHOOSE_ACCOUNT":"Seleziona conto liquidità","CHOOSE_CURRENCY":"Seleziona valuta conto","CHOOSE_TARIFF":"Seleziona tariffa (facoltativo)","CHOOSE_ACCOUNT_TYPE":"Seleziona tipo account","IBAN_WILL_BE_GENERATED":"IBAN sarà generato dopo la conferma","PLACEHOLDER":{"IBAN":"inserisci IBAN","ACCOUNT_NAME":"Nome account (facoltativo)"},"FILTER":{"ACCOUNT":"Account","ACCOUNT_NAME":"Nome account","CUSTOMER_NAME":"Nome cliente","PERIOD":"Periodo","AMOUNT":"Importo","CURRENCY":"Valuta","NOTHING_FOUND":"Spiacenti! Non è stato trovato nulla! Prova un'altra condizione di ricerca, per favore!!","SEARCH":"Cerca","RESET":"Reset","ROW_PER_PAGE":"Riga per pagina","INVALID_DATE":"Seleziona una data valida dal calendario prima di scaricare.","PLACEHOLDER":{"CHOOSE_PERIOD":"Scegli periodo"}},"LINKS":{"POOL":"Pool","LIQUIDITY_ACCOUNT":"Conto liquidità","IBAN":"IBAN","EMPTY_LINKS":"Nessun pool collegato!","ALLOW_INCOMING":"SEPA SCT IN","ALLOW_INCOMING_INST":"SEPA INST IN","ALLOW_OUTGOING":"SEPA SCT OUT","ALLOW_OUTGOING_INST":"SEPA INST OUT","APPLY":"Applica","RESET":"Reset"},"TARIFF":"Tariffa","USES_BASED_TARIFF":"Uses tariffa base","SHOW_IBANS":"Mostra IBANs","HIDE_IBANS":"Nascondi IBANs","SHOW_STATE_LOG":"Mostra state log","HIDE_STATE_LOG":"Nascondi state log","ACTIVE_ACTION":"Attiva","INACTIVE_ACTION":"Inattiva","STATE_LOG":{"CHANGE_DATETIME":"Data e ora della modifica","USER_INITIATOR_NAME":"Nome utente ","STATE":"Stato","REASON":"Motivo"},"DEACTIVATE":{"DIALOG":{"TITLE":"Specifica motivo:","BUTTONS":{"CONFIRM":"Conferma","CANCEL":"Annulla"}}}},"SYSTEM_ACCOUNTS":{"TITLE":"Account di sistema","LOAD_MORE":"Carica altro","ACCOUNT_NAME":"Nome Account","ACCOUNT_TYPE":"Tipo Account","ACCOUNT_NUMBER":"Account №","CURRENCY":"Valuta","BALANCE":"Saldo","LAST_TRANSFER_DATE":"data ultimo trasferimento","NO_ANY_CUSTOMER_ACCOUNT":"Spiacenti! Non ci sono account di sistema nel database."}}

/***/ }),
/* 720 */
/***/ (function(module, exports) {

	module.exports = {"MODAL":{"FOOTER":{"DISMISS":"Ignora","SAVE":"Salva"}}}

/***/ }),
/* 721 */
/***/ (function(module, exports) {

	module.exports = {"TRANSFERS":{"OUTGOING":{"TITLE":"Nuovi trasferimenti in uscita","CUSTOMER_NAME":"Nome del mittente","PAYMENT_ID":"ID","ACCOUNT":"Account","NARRATIVE":"Report","AMOUNT":"Importo","BENEFICIARY_ACCOUNT":"Account","NAME":"Nome del beneficiario","BANK_FEE":"Oneri bancari","BANK":"Banca","VIEW":"Visualizza","LIQUIDITY":"Account di liquidità","COMPLIANCE":"Compliance","APPROVE":"Approva","REJECT":"Rifiuta","NO_OUTGOINGS":"Trasferimenti in uscita non trovati.","REFERENCE_CONTAINS_SPACES":"Il riferimento \"{{riferimento}}\" contiene spazi bianchi!","NEW":{"BACK_TO_NEW_TRANSFER":"Torna alla pagina Nuovo Trasferimento."},"DIALOG":{"SENDER_ADDRESS_MISSING":"Impossibile recuperare l'indirizzo del mittente","RECIPIENT_ADDRESS_MISSING":"L'indirizzo del beneficiario non è fornito"},"APPROVED":{"TITLE":"Trasferimenti in uscita approvati","NO_OUTGOINGS":"Trasferimenti in uscita approvati non trovati.","BACK_TO_APPROVED_TRANSFER":"Torna alla pagina Trrasferimento Approvato.","SUMMARY":{"TRANSFERS":"Trasferimenti","TOTAL_AMOUNT":"Importo totale","FROM":"da","TO":"a","NO_OUTGOINGS":"Non ci sono trasferimenti in uscita approvati.","EXPORT":"Esporta"}},"UPLOADED":{"TITLE":"Trasferimenti in uscita in attesa di riferimento","NO_OUTGOINGS":"Trasferimenti in attesa di riferimento non trovati.","CONFIRM":"Conferma","RESTORE":"Ripristina","REFERENCE":"Riferimento","BACK_TO_AWAITING_REFERENCE":"Torna a Trasferimenti in attesa di riferimento."},"FILE":{"TITLE":"Trasferimenti in attesa di riferimento","NO_OUTGOINGS":"Non ci sono file non processati.","VIEW":"Visualizza","RE_EXPORT":"Riesporta","UPLOAD":"Carica","DONE":"Fatto","STATE_MODIFIED_ERROR_NOTIFICATION":"Non è possibile visualizzare i trasferimenti inclusi in questo file! Lo stato del file è stato modificato.","RELOAD_PAGE":"Ricarica la pagina.","FILE_NOT_PROCESSED":"Non puoi riesportare il file! Il file è stato caricato.","FILE_CANCELED":"Non puoi riesportare il file! Il file è già stato riesportato.","FILE_PROCESSED":"Non puoi riesportare il file! Il file è stato elaborato.","BATCH":"Batch","DOWNLOAD":{"ERROR":{"FILE_NOT_RELEVANT":"Non puoi scaricare il file! Le informazioni sul trasferimento sono state modificate e questo file non è rilevante.","FILE_CANCELED":"Non puoi scaricare il file! Il file è stato riesportato quindi non è rilevante.","FILE_NOT_PROCESSED":"Non puoi scaricare il file! Il file è stato caricato.","FILE_PROCESSED":"Non puoi scaricare il file! Il file è stato elaborato."}}},"FILE_PROCESSED":"Non puoi confermare il trasferimento! Il file è già stato elaborato","BACK_TO_AWAITING_REFERENCE_TRANSFERS":"Torna a Trasferimenti in attesa di riferimento","REFERENCE":{"BATCH":"Batch - {{namefile}} ({{liquidityname}})","CONFIRMED":"Non puoi cambiare il riferimento! Il trasferimento è già stato confermato. Ricarica la pagina.","CHANGED":"Non puoi cambiare il riferimento! Il riferimento del trasferimento è stato modificato con {{riferimento}}. Ricarica la pagina.","FILE_PROCESSED":"Non puoi cambiare il riferimento!Il file è già stato elaborato.","ALREADY_EXISTS":"Trasferimento con riferimento bancario {{riferimento}} esiste già!"},"CONFIRM_PAYMENT_WITH_ZERO_BANK_FEE":" Vuoi confermare il pagamento senza commissioni bancarie?"},"CARD":{"ID":"ID","TITLE":"Trasferimenti ricarica carta","TITLE_AWAITING":"Trasferimenti ricarica carta in attesa di riferimento","ACCOUNT":"Account","CARD":"Carta","NAME":"Nome","HOLDER_NAME":"Nome del titolare","HOLDER_ID":"ID Titolare","NARRATIVE":"Report","AMOUNT":"Importo","FEE_AMOUNT":"Oneri","APPROVE":"Approva","CONFIRM":"Conferma","REJECT":"Rifiuta","NO_TRANSFERS":"I trasferimenti con carta non sono stati trovati .","REFERENCE":{"STATE_CHANGED":"Non puoi approvare questo trasferimento! Le informazioni sono state modificate. Ricarica la pagina.","CHANGED":"Non puoi cambiare il riferimento! Il riferimento del trasferimento è stato modificato con {{riferimento}}. Ricarica la pagina.","ALREADY_EXISTS":"Trasferimento con riferimento {{riferimento}} esiste già!"}},"HISTORY":{"TITLE":"Cronologia","EMPTY":"Non ci sono trasferimenti elaborati.","LOAD_MORE":"Carica di più","NO_RESULTS":"Siamo spiacenti! Non abbiamo trovato nulla! Prova altre condizioni di ricerca, per favore!","SEARCH":"Cerca","RESET":"Reset","TABLE_COLUMN":{"DATE":"Data","ID":"ID","BANK_REFERENCE":"Riferimento bancario","CUSTOMER":"Cliente","ACCOUNT_NUMBER":"Numero di Conto","WHITELABEL":"Whitelabel","AMOUNT":"Importo","FEE":"Oneri","NARRATIVE":"Report"},"TABLE_ENTRY_COLUMN":{"DEBIT":"Addebito","CREDIT":"Credito","AMOUNT":"Importo","NARRATIVE":"Report","REFERENCE":"Riferimento"},"TABLE_DOCUMENT_COLUMN":{"ID":"Documento Identità","TYPE":"Tipo di documento","NAME":"Nome documento"},"TABLE_STATE_LOG_COLUMN":{"DATE":"Data","USERNAME":"Nome utente","STATE":"Stato","REASON":"Motivazione"},"TABLE_MENU":{"VIEW":"Visualizza","ALLOCATE":"Assegna","SHOW_ENTRIES":"Mostra voci","HIDE_ENTRIES":"Nascondi voci","SHOW_STATE_LOG":"Mostra state log","HIDE_STATE_LOG":"Nascondi state log","SHOW_ATTACHMENTS":"Mostra allegati","HIDE_ATTACHMENTS":"Nascondi allegati","CANCEL_TRANSFER":"Avvia annullamento"},"CANCELLATION_DIALOG":{"TITLE":"Annulla trasferimento in uscita","REASON":"Motivo","CHOOSE_REASON":"Scegli il motivo","DESCRIPTION":"Maggiori dettagli","SUBMIT":"Sì, annulla una transazione","VALIDATION":{"FIELD_REQUIRED":"Questo campo è obbligatorio"}},"FILTER":{"PERIOD":"Periodo","AMOUNT":"Importo","REFERENCE":"ID trasferimento","BANK_REFERENCE":"Riferimento bancario","PAYMENT_TYPE":"Modalità di pagamento","ACCOUNT_NAME":"Nome utente","ACCOUNT_NUMBER":"Numero utente","BANK":"Banca","NARRATIVE":"Report","CURRENCY":"Valuta","STATE":"Stato di trasferimento","SHOW_ALL":"Mostra tutto","PLACEHOLDER":{"PERIOD":"Scegli il periodo","BANK":"Seleziona la banca","NARRATIVE":"Inserire Report","CURRENCY":"Seleziona Valuta","REFERENCE":"riferimento"}},"VALIDATION":{"BANK_REFERENCE":"Il riferimento bancario deve essere lungo almeno 3 caratteri.","ACCOUNT_NAME":"Il nome dell'account deve contenere almeno 3 caratteri.","ACCOUNT":"L'account dev'essere lungo almeno 3 caratteri."}},"INCOMING":{"UPLOAD":{"TITLE":"Trasferimenti in entrata","TITLE_WITH_BANK":"Trasferimenti in entrata ({{banca}})","BANK_COMBO_LABEL":"Scegli la banca","BANK_CHOOSE_BUTTON":"Scegli il file","TRANSACTIONS":"{{count}} Transazioni","SUCCESSFUL":"I trasferimenti in entrata sono stati creati con successo!","BY_TARIFF":"Per tariffa","WITHOUT_SCHEME_TRANSFER":"{{transfersCount}} il pagamento sarà effettuato come pagamento SWIFT, a causa dell'assenza di uno schema specifico di pagamento.","WITHOUT_SCHEME_TRANSFERS":"{{transfersCount}} il pagamento sarà effettuato come pagamento SWIFT, a causa dell'assenza di uno schema specifico di pagamento.","GRID":{"DATE":"Data documento","PAYMENT_TYPE":"Modalità di pagamento","BRANCH_NUMBER":"Filiale N°","ACCOUNT_NUMBER":"Account N°","AMOUNT":"Importo","FEE_AMOUNT":"Impoto tassa","BANK_FEE_AMOUNT":"Importo della commissione bancaria","NAME_AND_ADDRESS":"Nome e indirizzo","NAME":"Nome","ADDRESS":"Indirizzo","BANK":"Banca","BANK_ADDRESS":"Indirizzo banca","SENDER_CORRESPONDENT":"Mittente corrispondente","NARRATIVE":"Report","IDENTIFICATION_NUMBER":"N° di identificazione","BANK_REFERENCE":"Riferimento","SENDER_INFO":"Mittente","RECIPIENT_INFO":"Beneficiario","ALLOCATE":"Allocare","RESET":"Reset","SHOW_FILE_ROW":"Mostra righe file","HIDE_FILE_ROW":"Nascondi righe file"},"ERROR":{"MAX_SIZE":"La dimensione del file supera il valore consentito!","IPE_000":"Informazioni insufficienti per la creazione del trasferimento.","IPE_001":"Informazioni insufficienti per la creazione del trasferimento.","IPE_002":"Riferimento {{riferimento}} doppio nel file!","IPE_003":"Account {{account}} non trovato tra gli account di liquidità!","IPE_004":"Account del beneficiario non trovato! Verrà creato un trasferimento non consegnato.","IPE_005":"Account {{account}} bloccato! Verrà creato un trasferimento non consegnato.","IPE_006":"Profilo il cui account {{account}} è stato bloccato! Verrà creato un trasferimento non consegnato.","IPE_007":"Trasferimento con riferimento {{riferimento}} già esistente nel sistema.","IPE_008":"Account {{account}} con valuta {{valuta}} non trovato tra gli account di liquidità!","IPE_018":"L' account di liquidità {{account}} non è attivo","IPE_019":"I pagamenti in entrata a revenue account sono vietati! Verrà creato un trasferimento non consegnato.","IPE_020":"Riferimento bancario non valido! Il riferimento bancario deve essere inferiore o uguale a 40 caratteri e senza spazi bianchi!","IPE_021":"I pagamenti in entrata tramite questo account di liquidità sono vietati per l'account del cliente {{recipientAccountName}}! Verrà creato un trasferimento non consegnato.","IPE_022":"Il tasso effettivo per le valute {{valuta}} e {{valuta account cliente}} non è stato trovato! Verrà creato un trasferimento non consegnato","FILE_ALREADY_CONFIRMED":"Il file esiste già nel sistema!","FILE_NOT_FOUND":"File non trovato!","BANK_REFERENCE_ALREADY_EXISTS":"I pagamenti con gli stessi riferimenti non possono essere salvati!"},"ALLOCATE":{"DIALOG":"Assegna il trasferimento {{riferimento}}","CUSTOMER":"Nome cliente","CHOOSE_CUSTOMER_ACCOUNT":"Scegli account cliente","CUSTOMER_ACCOUNT_EMPTY":"Nessun account disponibile trovato!","ACCOUNTS_LOADING":"Caricamento account clienti...","CUSTOMERS_NOT_FOUND":"Siamo spiacenti! Non ci sono clienti trovati con questa condizione! Prova altre condizioni di ricerca, per favore!","ACCOUNT_NOT_SAME_CURRENCY":"Trasferisci controvaluta alla valuta dell'account selezionato!"}},"DIALOG":{"BUTTON_CONFIRM":"Conferma"}},"INTERNAL":{"TITLE":"Nuovi trasferimenti interni","NO_INTERNAL_TRANSFERS":"Non ci sono nuovi trasferimenti interni.","PAYMENT_ID":"ID","SENDER_NAME":"Nome mittente","SENDER_ACCOUNT":"Account","NARRATIVE":"Report","AMOUNT":"Importo","RECIPIENT_NAME":"Nome beneficiario","RECIPIENT_ACCOUNT":"Account","VIEW":"Visualizza","COMPLIANCE":"Compliance","APPROVE":"Approva","REJECT":"Rifiuta","BACK_TO_NEW_TRANSFER":"Torna alla pagina Nuovo trasferimento.","DETAILS":{"TRANSFER_DETAILS":"Dettagli trasferimento(ID: {{id}})","BENEFICIARY_DETAILS":"Dettagli beneficiario","SENDER":{"NAME":"Nome cliente :","EMAIL":"Email :","ACCOUNT_NUMBER":"Account n°:","ACCOUNT_NAME":"Nome account :","INTRODUCER":"Sponsor :"},"TRANSACTION":{"NARRATIVE":"Report :","CREATE_TIME":"Data richiesta :","CURRENCY_RATE":"Tasso :","FEE_AMOUNT":"Oneri :","SOURCE_AMOUNT":"Origine :","DESTINATION_AMOUNT":"Destinazione :"},"RECIPIENT":{"ACCOUNT_NUMBER":"Account N° :","ACCOUNT_NAME":"Nome account:","IBAN":"IBAN :","NAME":"Nome beneficiario:","ADDRESS":"Indirizzo :"}}},"SYSTEM":{"WIZARD":{"CREATE":"Crea","PREVIEW":"Anteprima","SUCCESS":"Successo"},"REVENUE_TO_INTERNAL":"Entrate interne","TYPE_CUSTOMER_NAME":"Digita il nome cliente","CHOOSE_CUSTOMER_ACCOUNT":"Scegli l'account cliente","CHOOSE_REVENUE_ACCOUNT":"Scegli il revenue account","CHARGE_FEES":{"TITLE":"Carica una tassa aggiuntiva","CHOOSE_FEE":"Scegli tassa"},"CARDS":{"CHOOSE_CARDS":"Scegli la carta del cliente","NOT_FOUND":"Il cliente non possiede alcuna carta"},"ACCOUNTS":{"CHOOSE_LIQUIDITY":"","NOT_FOUND":"Nessun accounts trovato!"},"INACTIVE_MODAL":{"TITLE":"Conferma e procedi con account inattivo","MESSAGE":"L'account selezionato è inattivo, sei sicuro di voler continuare?","OK_BUTTON":"OK"}},"BUTTONS":{"CANCEL":"Cancella","CONFIRM":"Conferma"},"DIALOG":{"REJECT":"Specifica la motivazione:","REJECT_CLIENT_WARNING":"La motivazione è visibile al cliente nel Client Office e nell'API.","REFERENCE":"Specifica il riferimento:"},"DETAILS":{"CUSTOMER_NAME":"Nome cliente","CUSTOMER_ACCOUNT_NUMBER":"N° account cliente","ALLOCATED_TO":"Assegnato a","TRANSACTION_DATE":"Data della transazione","PROVIDER":"Provider","SUB_ACCOUNT_CLIENT_PART":"Pagamento del sottoconto collegato (parte del cliente)","SUB_ACCOUNT_MASTER_PART":"Parte del conto master","SUB_ACCOUNT_THIS_IS_MASTER":"questo pagamento è la parte del conto master","SUB_ACCOUNT_THIS_IS_CLIENT":"questo pagamento è la parte del cliente","UNDELIVERED_TRANSACTION_DATE":"Data di creazione del trasferimento non consegnato","UNDELIVERED_TRANSACTION_ID":"ID trasferimento non consegnato","DELIVERED_TRANSACTION_ID":"ID trasferimento consegnato","CANCELED_TRANSACTION_ID":"ID trasferimento cancellato","FEE":"Oneri","BANK_FEE":"Oneri bancari","FEE_NAME":"Nome oneri","NARRATIVE":"Report","REFUND_REASON":"Motivo del rimborso","BENEFICIARY_NAME":"Nome beneficiario","BENEFICIARY_ADDRESS":"Indirizzo del beneficiario","BENEFICIARY_ACCOUNT_NUMBER":"N° account beneficiario","BANK_NAME":"Nome banca","BANK_ADDRESS":"Indirizzo banca","IBAN_ACC":"IBAN / account mittente","SWIFT":"SWIFT","BANK_REFERENCE":"Riferimento bancario","SENDER_NAME":"Nome mittente","SENDER_ACCOUNT_NUMBER":"N° account mittente","SENDER_ADDRESS":"Indirizzo mittente","CARD_NUMBER":"N° carta","EXPRESS_PAYMENT":"Pagamento espresso","TRANSACTION_AMOUNT":"Importo transazione","CURRENCY":"Valuta","AMOUNT":"Importo","AMOUNT_BY_RATE":"Importo per tasso","PAYMENT_AMOUNT":"Importo pagamento","CURRENCY_EXCHANGE_RATE":"Tasso di cambio valuta","REJECT_REASON":"Motivo di rifiuto","TRANSACTION_DETAILS":"Dettagli transazione","TRANSFERS_TITLE":"Trasferimento / ID","FILES_TITLE":"File allegati","SAVE_ALL":"Salva tutto","REVENUE_ACCOUNT":"Revenue account","NOT_PROVIDED":"Non fornito","NOT_DELIVERED":"Non consegnato","NOT_CANCELED":"Non cancellato","RECALL_PAYMENT":"Recall Payment","INVERT_PAYMENT":"Invert Payment","RETURN_3R_IN_PAYMENT":"Return 3R Incoming","CREDIT_SUBACCOUNT":"Accredita sotto-conto","SUB_ACCOUNT_CREDITED":"Accreditato al sotto-conto (pagamento)","CREDIT_SUBACCOUNT_DIALOG":{"MODAL_TITLE":"Accredita sotto-conto dal pagamento","EXPLANATION":"Crea un pagamento in entrata nel sotto-conto per l'importo di questo pagamento, così il cliente lo vede nel sotto-conto. Il denaro reale non si muove: è già nel conto master.","EXPLANATION_FEE":"Con \"Addebita commissione\" si applica la commissione in entrata della tariffa del sotto-conto, come per un normale pagamento in entrata. Senza, si accredita l'importo intero senza commissione.","EXPLANATION_FINAL":"L'accredito viene eseguito subito e non si può annullare dal back office. Non ripeterlo se il sotto-conto è già stato accreditato.","SUGGESTED":"Sotto-conto suggerito","SUGGESTION_OTHER":"Altro conto (scrivi il numero sotto)","IN_NARRATIVE":"IBAN nella causale","PREVIOUS_CREDITS":"Accrediti precedenti da questo mittente: {{count}}","SUBACCOUNT_NUMBER":"Numero del sotto-conto","CHECK":"Verifica","CHARGE_FEE":"Addebita commissione","CHARGE_FEE_HINT":"Deseleziona per accreditare l'importo intero senza la commissione in entrata.","DESTINATION":"Sotto-conto","AMOUNT":"Importo","FEE":"Commissione","FEE_WAIVED":"commissione della tariffa non addebitata:","NO_FEE_RULE":"nessuna regola di commissione in entrata nella tariffa, accreditato senza commissione","NET":"Netto accreditato al sotto-conto","NOT_A_SUBACCOUNT":"Questo conto non è un sotto-conto. Controlla il numero.","ALREADY_CREDITED":"Questo pagamento è già stato accreditato a un sotto-conto (pagamento {{ids}}).","MODAL_ACCEPT":"Sì, accredita il sotto-conto","SUCCESS":"Sotto-conto {{account}} accreditato"},"REPROCESS_INTERNALS":"Reprocess Internals","ERROR":{"GET_DETAILS":"Qualcosa è andato storto durante il recupero dei dettagli del trasferimento."}},"OPEN_BANKING":{"TITLE":"Open Banking","EMPTY":"Non ci sono clienti.","DETAIL_HEADER":"ID:{{id}}","PAYMENT_DETAIL_HEADER":"ID Pagamento:{{id}}","VIEW_BUTTON":"Visualizza","ADD_BUTTON":"Aggiungi","EDIT_BUTTON":"Modifica","DELETE_BUTTON":"Elimina","PAYMENTS_BUTTON":"Pagamenti","PAY_ALL_UNPAID_BUTTON":"Paga Tutto","TAB":{"CLIENTS":{"TITLE":"Clienti","DETAIL_TITLE":"Dettagli","NEW_CLIENT_TITLE":"Aggiungi Nuovo Cliente","TABLE":{"ID":"ID","NAME":"Nome","PROFILE_ID":"ID Profilo","HAS_MONETUM_ACCOUNT":"Ha Account Monetum","USE_MASTER_ACCOUNT":"Usa Account Master","DIRECT_EXTERNAL_PAYMENT":"Pagamento Esterno Diretto","TOTAL_PAYMENTS":"Pagamenti Totali","PAYABLE_PAYMENTS":"Pagamenti Pagabili","ACTIVE":"Attivo"},"LEGEND":{"HAS_MONETUM_ACCOUNT":"Account Monetum Tradizionale","USES_MASTER_ACCOUNT":"Account Master (Soluzione Ibrida)","DIRECT_EXTERNAL_PAYMENT":"Pagamento Esterno Diretto"}},"PAYMENTS":{"DETAILS_TAB":"Dettagli Pagamento","TRACKS_TAB":"Tracciamento","STATE_LOGS_TAB":"Log di Stato","CHECK_STATUS_BUTTON":"Verifica Stato","TABLE":{"PROVIDER":"Provider"},"SETTLEMENT_STATUS":"Stato Liquidazione","PROVIDER_STATUS":"Stato Provider","PROVIDER_PAYMENT_ID":"ID Pagamento Provider","CLIENT_NAME":"Nome Cliente","HAS_PAYMENT_ID":"Stato ID Pagamento"}},"PAYMENT_TRACKS":{"TITLE":"Tracciamento Pagamenti","ID":"ID","PAYMENT_ID":"ID Pagamento","TYPE":"Tipo","STATUS":"Stato","CREATE_TIME":"Creato il","ERRORS":"Errori","VIEW_PAYMENT":"Visualizza Pagamento","NO_TRACKS":"Nessun tracciamento trovato.","INFO_TITLE":"Cronologia Tracciamento","INFO_MESSAGE":"Questa tabella mostra la cronologia completa delle modifiche di stato e degli eventi per questo pagamento.","TOTAL":"Tracciamenti totali","RECORDS":"record"},"PAYMENT_STATE_LOGS":{"TITLE":"Log di Stato Pagamento","DETAILS_TITLE":"Dettagli Log di Stato","ID":"ID","PAYMENT_ID":"ID Pagamento","PROVIDER":"Provider","PREVIOUS_STATUS":"Stato Precedente","NEW_STATUS":"Nuovo Stato","REASON":"Motivo Transizione","NOTES":"Note","METADATA":"Metadati","CREATED_AT":"Creato il","NO_LOGS":"Nessun log di stato trovato per questo pagamento.","INFO_TITLE":"Cronologia Transizioni di Stato","INFO_MESSAGE":"Questa tabella mostra la cronologia completa delle transizioni di stato per questo pagamento.","TOTAL":"Log totali","RECORDS":"record"},"INSTITUTIONS":{"TITLE":"Istituzioni","SUBTITLE":"Gestisci le istituzioni Open Banking e le configurazioni bancarie","DETAILS_TITLE":"Dettagli Istituzione","PROVIDER":"Provider","ID":"ID","NAME":"Nome","ID_INST":"ID Istituzione","PROVIDER_ID":"ID Provider","BIC":"BIC","COUNTRY_CODE":"Paese","EMBEDDED_FLOW":"Flusso Embedded","SINGLE_PAYMENT":"Pagamento Singolo","SCHEDULED_PAYMENT":"Pagamento Programmato","INSTANT_PAYMENT":"Pagamento Istantaneo","ENABLED":"Abilitato","VIEW_DETAILS":"Visualizza Dettagli","UPDATE":"Aggiorna da Yapily","NO_INSTITUTIONS":"Nessuna istituzione trovata.","BASIC_INFO":"Informazioni Base","REQUIREMENTS":"Requisiti","FEATURES":"Funzionalità","NO_FEATURES":"Nessuna funzionalità disponibile.","NEED_PSU_ID":"Richiede PSU ID","NEED_PSU_CORPORATE_ID":"Richiede PSU Corporate ID","NEED_PSU_IP_ADDRESS":"Richiede PSU IP Address","NEED_PAYER_BIC":"Richiede BIC Pagatore","NEED_PAYER_IBAN":"Richiede IBAN Pagatore","NEED_PAYER_DETAILS":"Richiede Dettagli Pagatore","NEED_PAYER_ACCOUNT_NUMBER":"Richiede Numero Conto Pagatore","NEED_PAYER_EMAIL":"Richiede Email Pagatore","NEED_PAYER_BBAN":"Richiede BBAN Pagatore","NEED_PAYER_COUNTRY":"Richiede Paese Pagatore","NEED_PAYER_ADDRESS":"Richiede Indirizzo Pagatore"},"NOTIFICATIONS":{"TITLE":"Cronologia Notifiche","SUBTITLE":"Visualizza e gestisci le notifiche webhook Open Banking","EMPTY":"Nessuna notifica inviata.","REFRESH_BUTTON":"Aggiorna","TABLE":{"ID":"ID","WEBHOOK_ID":"ID Webhook","WEBHOOK_URL":"URL Webhook","PAYMENT_ID":"ID Pagamento","CLIENT_NAME":"Nome Cliente","TYPE":"Tipo","VERSION":"Versione","STATUS":"Stato","CREATED_AT":"Creato il","IS_MANUAL":"Manuale","PAYLOAD":"Payload","VIEW_PAYLOAD":"Visualizza Payload"},"FILTERS":{"TITLE":"Filtri","PAYMENT_ID_PLACEHOLDER":"Inserisci ID Pagamento","WEBHOOK_ID":"ID Webhook","WEBHOOK_ID_PLACEHOLDER":"Inserisci ID Webhook","PERIOD":"Periodo","APPLY":"Applica Filtri","CLEAR":"Cancella"},"ACTIONS":{"VIEW_DETAILS":"Visualizza Dettagli","RESEND":"Reinvia"},"MODAL":{"TITLE":"Dettagli Notifica","RESPONSE_STATUS":"Stato Risposta","RESPONSE_BODY":"Corpo Risposta","REQUEST_BODY":"Corpo Richiesta"},"PAYLOAD_MODAL":{"TITLE":"Payload Notifica","CLOSE_BUTTON":"Chiudi"}},"ANALYTICS":{"TITLE":"Analisi Open Banking","SUBTITLE":"Monitora l'utilizzo del widget, i tassi di conversione e le prestazioni API","FILTERS":{"TITLE":"Filtri","CLIENT":"Cliente","ALL_CLIENTS":"Tutti i Clienti","SOURCE":"Fonte","ALL_SOURCES":"Tutte le Fonti","PERIOD":"Periodo","APPLY":"Applica","CLEAR":"Cancella"}}}}}

/***/ }),
/* 722 */
/***/ (function(module, exports) {

	module.exports = {"OUTER_PAYMENTS":{"DETAILS":{"TRANSFER_DETAILS":"Dettagli trasferimento (ID: {{id}})","BENEFICIARY_DETAILS":"Dettagli beneficiario","ATTACHMENTS":"Allegati","EMPTY_ATTACHMENTS":"Nessun allegato presente!","CUSTOMER":{"NAME":"Nome cliente :","INTRODUCER":"Sponsor :"},"SENDER":{"NAME":"Nome mittente :","COUNTRY":"Paese mittente :","CITY":"Città mittente :","ADDRESS":"Indirizzo mittente :","ZIP_CODE":"CAP mittente :","ACCOUNT_NUMBER":"Account No :","ACCOUNT_NAME":"Nome account :"},"TRANSACTION":{"NARRATIVE":"Narrative :","CREATE_TIME":"Data di richiesta :","CURRENCY_RATE":"Tasso :","FEE_AMOUNT":"Spesa :","SOURCE_AMOUNT":"Fonte :","DESTINATION_AMOUNT":"Destinazione :","BANK_REFERENCE":"Riferimento bancario :"},"RECIPIENT":{"ACCOUNT_NUMBER":"Account No :","IBAN":"IBAN :","NAME":"Nome del beneficiario :","ADDRESS":"Indirizzo :","BANK_NAME":"Nome banca :","BANK_ADRESS":"Indirizzo banca :","BANK_COUNTRY":"Paese banca :","SWIFT_BIC":"SWIFT BIC :","BENEFICIARY_CITY":"Città :","BENEFICIARY_COUNTRY":"Paese :"}}}}

/***/ }),
/* 723 */
/***/ (function(module, exports) {

	module.exports = {"SYSTEM":{"ACCOUNTS":{"REVENUE":"Account revenue","CUSTOMER":"Account cliente","LIQUIDITY":"Account di liquidità"},"CUSTOMER":{"NAME":"Nome del cliente"},"AMOUNT":{"TITLE":"Importo","BANK_FEE_AMOUNT":"Spesa bancaria","MAX":"Fondi insufficienti. Si prega di rifinanziare il conto revenue.","MAX_FEE":"Fondi insufficienti sull'account cliente.","MAX_BANK_FEE":"Le spese superano le entrate","MIN":"Si prega di insrire l'importo da trasferire","MIN_FEE":"Si prega di insrire l'importo da trasferire"},"CURRENCY":{"TITLE":"Valuta","PLACEHOLDER":"Scegli valuta"},"PURPOSE":{"TITLE":"Causale pagamento","TITLE_FOR_FEE":"Scopo della spesa","PLACEHOLDER":"Causale pagamento in entrata","PLACEHOLDER_FOR_FEE":"Causale spesa entrata"},"FEE":{"TITLE":"Spesa","CHOOSE_FEE":"Scegliere spesa","CLAIM_SHARE":"Richiedere quota"},"CARD":{"CHOOSE_CARD":"Scegliere carta"},"SUCCESS":{"PAYMENT":{"HEADER":"Congratulazioni!","STATUS":"Effettuato pagamento con status","LINK1":"Creane uno nuovo","LINK2":"Esplora la cronologia dei trasferimenti","LINKS_SEPARATOR_VALUE":"o"},"FEES":{"HEADER":"Congratulazioni!","CHARGED":"Addebitato da","WITH_PURPOSE":"con scopo"}}}}

/***/ }),
/* 724 */
/***/ (function(module, exports) {

	module.exports = {"CUSTOMER":{"TITLE":{"REGISTERED":"Clienti/Registrati","PENDING":"Clienti/In attesa","PENDING_DETAIL":"Cliente/In attesa/ID:{{id}}","DETAIL":"Cliente/Registrato/ID:{{id}}"},"APPROVED":"Clienti approvati","DECLINED":"Clienti rifiutati","TABLE":{"COMPANY":"Nome azienda","DESCRIPTION":"Breve descrizione","CREATED":"Creazione: {{valore}}","SIGNATORY":"Firmatario autorizzato","INTRODUCER":"Sponsor","INTRODUCER_FROM_APPLICATION":"Sponsor dall' applicazione","EMAIL":"Email autorizzata","PRIVATE_EMAIL":"Email","CURRENCY":"Valuta","NAME":"Nome cliente","TARIFF":"Tariffa base","ADDRESS":"Indirizzo","OPENING_DATE":"Data da apertura","APPROVING_DATE":"Data di approvazione","PHONE":"Telefono autorizzato","USER_EMAIL":"Email","EMAIL_ADDRESS":"Email","PHONE_NUMBER":"Numero di telefono","MOBILE_NUMBER":"Numero di telefono cellulare","PRIVATE_PHONE":"Numero di telefono","MOBILE_PHONE":"Numero di telefono cellulare","MIN_TOTAL_ASSET":"Asset totale minimo"},"BUTTONS":{"APPROVE":"Approva","DECLINE":"Rifiuta","PROCESS":"Processo","ON_HOLD":"In attesa","COMPLIANCE":"Compliance","ARCHIVED":"Archiviato","REJECT":"Rifiuta","BACK":"Indietro","SAVE":"Salva","VIEW":"Visualizza","COPY":"Copia","DONE":"Fatto","RESET":"Reset","DECLINE_MODAL":{"CONFIRM":"Sì, rifiuta la richiesta","CANCEL":"Cancella"},"ON_HOLD_MODAL":{"CONFIRM":"Sì, metti in attesa ","CANCEL":"Cancella"},"ARCHIVED_MODAL":{"CONFIRM":"Sì, archivia la richiesta","CANCEL":"Cancella"},"SUSPEND_MODAL":{"CONFIRM":"Sì, sospendi il profilo","CANCEL":"Cancella"},"REJECT_MODAL":{"CONFIRM":"Sì, rifiuta il profilo","CANCEL":"Cancella"},"SUSPEND":"Sospendi","CLOSE_MODAL":{"CONFIRM":"Sì, chiudi il profilo","CANCEL":"Cancella"},"CLOSE":"Chiudi"},"DECLINE_MODAL":{"TITLE":"Rifiuta la richiesta di registrazione da {{cliente}}?","MESSAGE":"Questo non può essere annullato","TITLE_INPUT_REJECT":"Motivo del rifiuto"},"REJECT_MODAL":{"TITLE":"Rifiuta la richiesta di registrazione da {{cliente}}?","MESSAGE":"Questo non può essere annullato","TITLE_INPUT_REJECT":"Motivo del rifiuto"},"ON_HOLD_MODAL":{"TITLE":"Metti in attesa la richiesta di registrazione da {{cliente}}?","MESSAGE":"Questo non può essere annullato","TITLE_INPUT_REJECT":"Motivo attesa"},"ARCHIVED_MODAL":{"TITLE":"Archivia richiesta di registrazione da {{cliente}}?","MESSAGE":"Questo non può essere annullato","TITLE_INPUT_REJECT":"Motivo archiviazione"},"SUSPENDED_MODAL":{"TITLE":"Sospendi il profilo del cliente da {{cliente}}?","MESSAGE":"Questo non può essere annullato","TITLE_INPUT_REJECT":"Motivo della sospensione","REASON_DETAILS":"Ulteriori dettagli sul motivo dello stato di sospensione"},"CLOSE_MODAL":{"TITLE":"Chiudi il profilo del cliente da {{cliente}}?","MESSAGE":"Questo non può essere annullato","TITLE_INPUT_REJECT":"Motivo chiusura","REASON_DETAILS":"Ulteriori dettagli sul motivo dello stato di chiusura"},"UNSUSPEND_MODAL":{"TITLE":"Annulla sospensione profilo utente","MESSAGE":"Vuoi davvero annullare la sospensione di questo profilo?","BUTTON":"Annulla la sospensione"},"INFO":{"TITLE":"Informazioni cliente","COMPANY":"Nome azienda","ACTIVITY_TYPE":"Tipo di persona giuridica","INCORP_DATE":"Data di incorporazione","REG_NUMBER":"Numero di registrazione","TAXPAYER_REG_NUM":"Numero di registrazione del contribuente","PHONE":"Telefono","COUNTY_REGION":"Provincia / Regione","CITY":"Città","REG_OFFICE":"Sede legale","COUNTRY":"Paese","ZIP_CODE":"Cap","E_MAIL":"E-mail","SITE":"Web site","DESC":"Breve descrizione"},"BUSINESS":{"TITLE":"Attività commerciali","PROFILE":"Profilo Business","FULL_DESC":"Descrizione completa dell'attività commerciali aziendali","LICENSE":"Licenza","LICENSE_NOT_REQUIRE":"Confermo che le suddette attività commerciali non necessitano di licenza o permesso speciale presso la sede dell'attività.","LICENSE_REQUIRE":"Le suddette attività commerciali richiedono una licenza o un permesso speciale presso la sede dell'attività e allego una copia della licenza e/o del permesso speciale.","DURATION":"Durata delle attività aziendali (anni)","NUMBER_OF_EMPLOYEES":"Numero dei dipendenti dell'azienda","KEY_FIN_INDICATORS":"Indicatori finanziari chiave. Volume annuale delle vendite dell'azienda (USD / EUR. La preghiamo di cerchiare la valuta appropriata)","TOTAL_ASSETS":"Attività totali sul bilancio della società (milioni di USD / EUR. La preghiamo di cerchiare la valuta appropriata)"},"TRANSACTION":{"TITLE":"Attività di trasferimento","INCOMING_TRANSFERS":"Trasferimenti in entrata","OUTGOING_TRANSFERS":"Trasferimenti in uscita","CURRENCY":"Valuta","COUNTRIES_MAKE_TRANSFER":"Principali paesi con i quali farai trasferimenti","COUNTRIES_RECEIVE_TRANSFER":"Principali paesi dai quali riceverai trasferimenti","OUT_TRANSFERS_COUNT":"Numero stimato di trasferimenti in uscita al mese","IN_TRANSFERS_COUNT":"Numero stimato di trasferimenti in entrata al mese","AVERAGE_TRANSFER":"Valore medio per ogni trasferimento","MAXIMUM_TRANSFER":"Valore massimo per ogni trasferimento","INCOMING":"Trasferimenti pianificati in entrata","OUTGOING":"Trasferimenti pianificati in uscita","MAX_MONTHLY":"Fatturato MENSILE massimo dell'account","MAX_SINGLE":"Importo massimo di una SINGOLA transazione"},"AUTHORITY_SIGNATORY_DETAILS":{"TITLE":"Dettagli dell'autorità firmataria","FIRST_NAME":"Nome","LAST_NAME":"Cognome","ADDRESS":"Indirizzo","CITY":"Città/stato","ZIP":"Cap","COUNTRY":"Paese","NATIONALITY":"Nazionalità","PASSPORT":"Passaporto/Carta d'identità","PASSPORT_ISSUE_DATE":"Data di rilascio del passaporto","PASSPORT_EXPIRY_DATE":"Data di scadenza del passaporto","PHONE":"Telefono","EMAIL":"E-mail"},"DIRECTORS":{"TITLE":"Informazioni amministratori","FULL_NAME":"Nome completo","FIRST_NAME":"Nome","LAST_NAME":"Cognome","NATIONALITY":"Nazionalità","PASSPORT":"Passaporto/Carta d'identità","PASSPORT_ISSUE_DATE":"Data di rilascio del passaporto","PASSPORT_EXPIRY_DATE":"Data di scadenza del passaporto","ADDRESS":"Indirizzo","PHONE":"Telefono","EMAIL":"E-mail"},"BENEFICIARY":{"TITLE":"Dettagli beneficiario","SHARE":"Share","FULL_NAME":"Nome completo","FIRST_NAME":"Nome","LAST_NAME":"Cognome","NATIONALITY":"Nazionalità","PASSPORT":"Passaporto/Carta d'identità","PASSPORT_ISSUE_DATE":"Data di rilascio del passaporto","PASSPORT_EXPIRY_DATE":"Data di scadenza del passaporto","ADDRESS":"Indirizzo","PHONE":"Telefono","EMAIL":"E-mail"},"COMPANY_ACCOUNT":{"TITLE":"Informazioni account aziendale","VALUE_OF_INITIAL_FUNDING":"Valore del finanziamento iniziale","CURRENCY_OF_INITIAL_FUNDING":"Valuta del finanziamento iniziale","ORIGINATING_BANK_NAME":"Nome banca di origine","ORIGINATING_BANK_ADDRESS":"Indirizzo banca di origine","ACCOUNT_NAME":"Nome account","ACCOUNT_NUMBER":"Numero account","SIGNATORY":"Firmatario","FUNDS_DESCRIPTION":"Descrivi con precisione come sono stati generati questi fondi","ACCOUNT_CURRENCY":"Valuta account","INTRODUCER":"Sponsor","INTRODUCER_EMAIL_ADDRESS":"Indirizzo email Sponsor"},"PARTNERS":{"TITLE":"Informazioni partner commerciali","INCOMING":"Pagamenti in entrata","OUTGOING":"Pagamenti in uscita","PARTNER_NAME":"Nome del partner","PARTNER_COUNTRY":"Paese di costituzione","PARTNER_DESCRIPTION":"Breve descrizione della natura economica delle transazioni pianificate"},"ADDITIONAL":{"TITLE":"Informazioni aggiuntive","SERVICES":"Prodotti/Servizi che intendi utilizzare"},"PAGINATION":{"ROWS_PER_PAGE":"Righe"},"EMPTY":{"PROFILES":"Siamo spiacenti! Non c'è nessun profilo cliente nel sistema."},"STATE":{"ACTIVE":"Attivo","BLOCKED":"Bloccato","NEW":"Nuovo","PENDING":"In attesa","SUSPENDED":"Sospeso","PROCESSING":"In elaborazione","ON_HOLD":"In attesa","ARCHIVED":"Archiviato","REJECTED":"Rifiutato","DECLINED":"Rifiutato","CLOSED":"Chiuso","4STOP_PROCESSING":"In elaborazione da 4stop"},"KIND":{"CUSTOMER":"Cliente","AGENT":"Agente","SALESMAN":"Venditore","SALESMAN_LEAD":"Resposabile venditore","WHITE_LABEL":"White Label","INSTITUTIONAL_CLIENT":"Cliente istituzionale","SUB_CLIENT":"Sub Client"},"FILTER":{"CUSTOMER_NAME":"Nome cliente","ID":"ID","EMAIL":"Email firmatario","INTRODUCER_NAME":"Nome sponsor","INTRODUCER_SELECT":"Seleziona sponsor","ACCOUNT_TYPE":"Tipo di profilo","ACCOUNT_STATE":"Stato del profilo","VERIFICATION_STATUS":"Status di verifica","VERIFICATION_STATUS_EXCLUSION":"Non verificato","ACCOUNT_OPENING_DATE_REGISTERED":"Data di approvazione","ACCOUNT_OPENING_DATE_APPLICANTS":"Data di applicazione","VALIDATOR":{"CUSTOMER_NAME_MIN_SEARCH_LENGTH":"La lunghezza minima è 3 caratteri"},"PLACEHOLDER":{"CUSTOMER_NAME":"e.s. John Doe","COUNTRY_OF_REGISTRATION":"Paese di registrazione","NATIONALITY":"Nazionalita","ID":"e.s. 123456","EMAIL":"e.s. john.doe@mail.com","INTRODUCER_NAME":"e.g. John Doe","INTRODUCER_SELECT":"Scegline uno per procedere","ACCOUNT_TYPE":"Mostra tutto","ACCOUNT_STATE":"Mostra tutto","VERIFICATION_STATUS":"Mostra tutto","BANK_LIST":"Mostra tutto","TARIFF_LIST":"Mostra tutto","TELEPHONE_NUMBER":"+23 (423) 423 42 34"},"NOT_FOUND":{"INTRODUCER_SELECT":"Non ci sono sponsor a disposizione","COUNTRY_OF_REGISTRATION":"Non ci sono paesi di registrazione","NATIONALITY":"Non ci sono nazionalità"},"BANK_LIST":"Lista bancaria","TELEPHONE_NUMBER":"Numero di telefono","TARIFF_LIST":"Lista tariffe","COUNTRY_OF_REGISTRATION":"Paese di registrazione","NATIONALITY":"Nazionalità"},"DETAILS":{"EDIT.BUTTON.NAME":"Modifica","TAB.DETAILS":{"HEADER":"Dettagli","CRYPTO_WALLETS":{"TITLE":"Portafogli Crypto","ADDRESS":"Indirizzo Portafoglio","COPY":"Copia negli appunti"},"PRIVATE":{"APPLICANT_INFORMATION":{"TITLE":"Richiedente","PERSONAL_DETAILS":{"TITLE":"Dettagli personali","FIRST_NAME":"Nome","LAST_NAME":"Cognome"},"NATIONALITY":"Nazionalità","PASSPORT":"Numero Carta d'identità / Passaporto","PLACE_OF_ISSUE":"Autorità di rilascio","DATE":{"TITLE":"Data di rilascio/ scadenza","ISSUE":"Data di rilascio","EXPIRY":"Data di scadenza","EXPIRY_WARNING":"Si prega di notare che, il passaporto è prossimo alla scadenza. ","EXPIRED_WARNING":"Si prega di notare che, il passaporto è scaduto. "},"SECOND_NATIONALITY":"Seconda nazionalità","RESIDENTIAL_ADDRESS":{"TITLE":"Indirizzo di casa","RESIDENTIAL_POSTAL_ADDRESS":"Indirizzo di casa","RESIDENTIAL_POSTAL_CITY":"Città","RESIDENTIAL_POSTAL_COUNTY_OR_REGION":"Provincia o regione","RESIDENTIAL_COUNTRY":"Paese","RESIDENTIAL_ZIP_CODE":"Codice postale / Cap"},"POSTAL_ADDRESS":{"TITLE":"Indirizzo postale","POSTAL_ADDRESS":"Indirizzo postale","POSTAL_CITY":"Indirizzo postale","POSTAL_COUNTY_OR_REGION":"Provincia o regione di spedizione","COUNTRY":"Paese di spedizione","ZIP_CODE":"Codice postale / Cap"},"PHONE_NUMBER":"Numero di telefono","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","BIRTH_DATE":"Data di nascita","PLACE_OF_BIRTH":"Luogo di nascita (Paese)","TAX_IDENTIFICATION_NUMBER":"Partita Iva","TAX_COUNTRY":"Paese di contribuzione fiscale","FAX_NUMBER":"Numero di fax","FACEBOOK_PROFILE":"Profilo facebook","LINKEDIN":"LinkedIn","OTHER":"Altri","ID_OR_PASSPORT_ATTACHMENT_ITEMS":"Elementi allegati ID o Passaporto","PASSPORT_SELFIE_ATTACHMENT_ITEMS":"Elemtnti allegati selfie Passaporto","ADDRESS_ATTACHMENT_ITEMS":"Elementi allegati indirizzo","SAVE_ALL":"Salva tutto","UPLOAD":{"TITLE":"Carica","ERROR":{"MAX_SIZE":"La dimensione del file supera il valore consentito!","FILE_ALREADY_CONFIRMED":"Il file è già esistente nel sistema!","FILE_NOT_FOUND":"File non trovato!","UNSUPPORTED_FORMAT":"Formato del file non supportato!"}},"FILTER":{"NOT_FOUND":{"NATIONALITY_SELECT":"Non ci sono paesi disponibili","SECOND_NATIONALITY_SELECT":"Non ci sono paesi disponibili","COUNTRY_SELECT":"Non ci sono paesi disponibili","RESULT_COUNTRY_SELECT":"Nessun risultato trovato","JURISDICTION":"Non ci sono giurisdizioni disponibili"}},"DIALOG":{"TITLE":"Modifica l'email dell'utente? Attenzione!","MESSAGE":"Questo bloccherà l'accesso utilizzando l'indirizzo email precedente e costringerà l'utente a utilizzare quello nuovo assegnato. Tieni presente che non abbiamo l'opportunità di informare l'utente delle nuove modifiche sul suo profilo . Questa operazione non può essere annullata.","OK":"MODIFICA","CANCEL":"CANCELLA"}},"EMPLOYMENT_INFORMATION":{"TITLE":"Occupazione","PRESENT_OCCUPATION":"Occupazione attuale","EMPLOYMENT_DETAILS":{"TITLE":"Dettagli occupazione","NAME":"Nome del datore di lavoro/Nome dell'azienda","ADDRESS":{"TITLE":"Indirizzo del datore di lavoro","POSTAL_ADDRESS":"Indirizzo dell'ufficio del datore di lavoro","POSTAL_CITY":"Città","POSTAL_COUNTY_OR_REGION":"Provincia o regione","COUNTRY":"Paese","ZIP_CODE":"Codice postale / Cap"},"BUSINESS_SECTOR":"Nome dell'attività commerciale","YEARS_IN_EMPLOYMENT":"Numero degli anni di occumapzione / attività commerciale"}},"PEP_INFORMATION":{"TITLE":"PEP","POSITION_IN_ANY_COUNTRY":"Sei un PEP o sei legato a un PEP? Una \"Persona Politicamente Esposta \" è una persona fisica (individuo) a cui è o è stata affidata una funzione pubblica di rilievo e include i suoi parenti stretti o persone note per essere stretti collaboratori di tali persone, ma esclude gli ufficiali di grado medio o più giovani.","FAMILY_POSITION_IN_ANY_COUNTRY":"Qualche membro della tua famiglia stretta attualmente ricopre o ha mai ricoperto cariche politiche, diplomatiche o governative in un paese? (La preghiamo di barrare la casella se la risposta è SI)"},"LITIGATION_INFORMATION":{"TITLE":"Processi","LITIGATION":"Sei a conoscenza di essere o essere mai stato oggetto di indagini legali, ordinanze del tribunale, sentenze, procedimenti fallimentari, sanzioni penali (esclusi incidenti stradali minori)? (La preghiamo di barrare la casella se la risposta è SI)"},"MASTER_ACCOUNT_INFORMATION":{"TITLE":"Account principale","MASTER_ACCOUNT_CURRENCY":"Valuta account principale","ADDITIONAL_CURRENCIES":"Valute aggiuntive"},"FUNDS_INFORMATION":{"TITLE":"Fondi","SOURCE_OF_INITIAL_FUNDING":{"TITLE":"Fonte del deposito iniziale","JURISDICTION":"Giurisdizione","AVERAGE_MONTHLY_INCOME":"Qual è il tuo reddito mensile medio?","PRIMARY_INCOME_SOURCE":"La preghiamo di fornirci la tua fonte di reddito principale","ORIGINAL_BANK_NAME":"Nome della banca di origine","ORIGINAL_BANK_ADDRESS":"Indirizzo della banca di origine","ACCOUNT_NAME":"Nome account","SIGNATORY":"Firmatario","HOW_FUNDS_GENERATED":"Descrivi con precisione come sono stati generati questi fondi"},"EXPECTED_TRANSFER_ACTIVITY":{"TITLE":"Attività di trasferimento prevista","AVERAGE_VALUE_OF_TRANSFER":"Valore medio di ogni trasferimento ({{valuta}})","MAX_VALUE_OF_TRANSFER":"Valore massimo di ogni trasferimento ({{currency}})","MAIN_COUNTRIES_TO":"Paesi verso i quali verranno effettuati i trasferimenti","MAIN_COUNTRIES_FROM":"Paesi da cui verranno ricevuti i trasferimenti","PURPOSE_OF_ACCOUNT":"Scopo di questo account","AVERAGE_INCOMING_TRANSACTION":"Valore / dimensione media delle transazioni in entrata","PLANNED_MONTHLY_INCOMING_TURNOVER":"Fatturato mensile pianificato dei pagamenti in entrata utilizzando l'account {{vendorTitle}} ","MONTHLY_INCOMING_FREQUENCY":"Frequenza mensile dei pagamenti in entrata","AVERAGE_OUTGOING_TRANSACTION":"Valore / dimensione media delle transazioni in uscita","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Fatturato mensile pianificato dei pagamenti in uscita sull' account {{vendorTitle}} ","MONTHLY_OUTGOING_FREQUENCY":"Frequenza mensile dei pagamenti in uscita"},"RANGE":{"UP":"Fino a {{amountTo}} {{unit}}","FROM_TO":"Da {{amountFrom}} {{unit}} a {{amountTo}} {{unit}}","MORE":"Più di {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Fino a {{amountTo}}","FROM_TO":"Da {{amountFrom}} a {{amountTo}}","MORE":"Più di {{amountFrom}}"}},"INTRODUCER_INFORMATION":{"TITLE":"Sponsor/Rivenditore","INTRODUCER_NAME":"Nome Sponsor/Rivenditore","INTRODUCER_EMAIL":"Email Sponsor /Rivenditore"},"ABOUT_YOURSELF_INFORMATION":{"TITLE":"Parlaci di te","PRODUCTS":"Quali {{azienda}} prodotti/servizi prevedi di utilizzare?","PRODUCTS_CUSTOM":"Prodotti personalizzati","REASONS":"Motivi","REASONS_CUSTOM":"Motivi personalizzati","INFORMATION_SOURCE":"Fonti di informazione","INFORMATION_SOURCES_CUSTOM":"Fonti di informazione personalizzate","USA_CITIZEN":"Con la presente dichiaro di NON essere cittadino e/o residente fiscale negli USA."},"REQUIRED_INPUT":"Questo campo è obbligatorio!","MINIMUM_LENGTH":"La lungezza minima è di {{valore}} caratteri","MAXIMUM_LENGTH":"La lungezza massima è di {{valore}} caratteri"},"CORPORATE":{"BUSINESS_CUSTOMER_INFORMATION":{"TITLE":"Informazioni sui clienti aziendali","DATE_OF_REGISTRATION":"Data di registrazione","REGISTRATION_NUMBER":"Numero di registrazione","TRADING_NAME":"Denominazione commerciale","TAX_IDENTIFICATION_NUMBER":"Numero di identificazione fiscale"},"STATEMENT_OF_AFFAIRS":{"TITLE":"Dichiarazione degli affari","SPECIFIC_COUNTRIES":"Specifici paesi per operazioni su mercati targhettizati","NATURE_OF_BUSINESS":"Natura dell'attività"},"INITIAL_DEPOSITS":{"TITLE":"Fonte dei fondi","SOURCE_OF_INITIAL_DEPOSIT":"Descrivi la fonte del deposito iniziale","ORIGINATING_BANK_JURISDICTION":"Giurisdizione della banca di origine","DESCRIBE_FUNDS_WERE_GENERATED":"Descrivi con precisione come sono stati generati questi fondi","AMOUNT":"Importo","CURRENCY":"Valuta","ACCOUNT_NAME":"Nome account"},"ACCOUNT_CURRENCIES":{"TITLE":"Valute account","MASTER_ACCOUNT_CURRENCY":"Valuta del conto principale","ADDITIONAL_CURRENCIES":"Valute aggiuntive"},"EXPECTED_TURNOVER":{"TITLE":"Fatturato atteso","NUMBER_OF_INCOMING":"Numero di entrate al mese","NUMBER_OF_OUTGOING":"Numero di uscite al mese","AMOUNT_OF_INCOMING":"Importo mensile in entrata (EUR)","AMOUNT_OF_OUTGOING":"Importo mensile in uscita (EUR)","MAXIMUM_TRANSFER_AMOUNT":"Importo massimo del trasferimento (EUR)","MAIN_SUPPLIERS":"Principali controparti per i pagamenti in uscita","MAIN_CLIENTS":"Principali controparti per i pagamenti in entrata"},"AUTHORISED_SIGNATORY":{"TITLE":"Firmatario autorizzato","SAVE_ALL":"Salva tutto","DETAILS":"Dettagli firmatario autorizzato","ADDRESS":"Indirizzo firmatario autorizzato","CONTACTS":"Contatti firmatario autorizzato","PASSPORT":"Passaporto","SELFIE":"Selfie con carta d'identità"},"INTRODUCER":{"TITLE":"Sponsor/Rivenditore","INTRODUCER_NAME":"Nome Sponsor/Rivenditore","INTRODUCER_EMAIL":"Email Sponsor/Rivenditore"},"USAGE_AND_REFERRAL":{"TITLE":"Utilizzo e rinvio","WHAT_PRODUCTS_SERVICES":"Quali {{azienda}} prodotti/servizi prevedi di utilizzare?","REASON_FOR_CHOOSING":"Motivo per scegliere {{azienda}}","SOURCE_OF_INFORMATION":"Fonte di informazioni su {{azienda}}"},"COMMON":{"FIRST_NAME":"Nome","LAST_NAME":"Cognome","DATE_OF_BIRTH":"Data di nascita","ATTORNEY_POWER_EXPIRE_DATE":"Data di scadenza della procura (se applicabile)","JOB_TITLE_OCCUPATION":"Titolo di lavoro / Occupazione","NIC_PASSPORT_ID":"Numero Carta d'identità/Passaporto","PASSPORT_ID":"Numero Carta d'identità/Passaporto","NATIONALITY":"Nazionalità","SECOND_NATIONALITY":"Seconda nazionalità","ADDRESS_LINE":"Riga dell'indirizzo","COUNTRY":"Paese","COUNTY_REGION":"Provincia / Regione","CITY":"Città","ZIP_CODE":"Codice postale / Cap","PHONE_NUMBER":"Numero di telefono","MOBILE":"Cellulare","LINKEDIN":"Linkedin","FACEBOOK":"Facebook","WEBSITE":"Website","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","NAME_OF_CORPORATE_SHAREHOLDER":"Nome dell'azionista aziendale","LEGAL_DOCUMENTS":"Documenti legali","PERSONAL_INFORMATION":"Informazioni personali","COMPANY_INFORMATION":"Informazioni sull'azienda","COMPANY_NAME":"Nome azinda","COUNTRY_OF_INCORPORATION":"Paese di incorporazione","COMPANY_REGISTRATION_NUMBER":"Numero di registrazione azienda","COMPANY_ADDRESS":"Indirizzo azienda (Opzionale)","COMPANY_CONTACTS":"Contatti aziendali","HOME_ADDRESS":"Indirizzo di casa (Opzionale)","CONTACTS":"Contatti","INDIVIDUAL":"Individuale","CORPORATE":"Aziendale","IDENTITY_CONFIRMATION":"Conferma dell'identità","YES":"Si","NO":"No","PROOF_OF_ADDRESS":"Prova di residenza","OPTIONAL_ADDRESS":"Indirizzo facoltativo","INVALID_VALUE":"Valore non valido"},"MINIMUM_LENGTH":"La lunghezza minia è {{valore}} caratteri","MAXIMUM_LENGTH":"La lunghezza massima è {{valore}} caratteri"},"OTHER":"Altro","UNAVAILABLE_CURRENCY":"Valuta non disponibile","SAVE.BUTTON.NAME":"Salva","SAVE_ALL.BUTTON.NAME":"Salva tutto","UPLOAD.BUTTON.NAME":"Carica","DISCARD.BUTTON.NAME":"Scarta","ADD_NEW.BUTTON.NAME":"Aggiungi nuovo"},"TAB.SETTINGS":{"HEADER":"Impostazioni","LINKED_ACCOUNTS":"Account collegati","PROFILE_SETTINGS":"Impostazioni profilo","UPDATE_PROFILE_STATUS":"Aggiorna Status profilo","CHANGE_PROFILE_STATUS":"Cambia Status profilo","RISK_LEVEL":"Livello di rischio","TARIFF":"Tariffa","WHITELABEL_TARIFF":"Whitelabel tariff","PROFILE_TYPE":"Tipo di profilo","INTRODUCER_NAME":"Nome Sponsor","MINTOTAL_ASSET":"Asset totale minimo","NEGATIVE_INTEREST":"Limite di interesse negativo","MAX_LIMIT_AMOUNT":"Importo minimo per il filtraggio TM","RESET":"Reset","SUSPEND_ACTIVITY":"Sospendi attività","UNSUSPEND_ACTIVITY":"Annulla sospensione dell'attività","SUSPENDED_REASON":"Motivo di sospensione:","SUSPENDED_CUSTOM_REASON":"Motivo sospensione personalizzata:","CLOSED_REASON":"Motivo di chiusura:","CLOSED_CUSTOM_REASON":"Motivo chiusura personalizzata:","SUSPEND":"Sospendere","UNSUSPEND":"Annulla sospensione","DELETE_PROFILE":"Cancella profilo","DELETE":"Cancella","CLOSE":"Chiudi","PASSWORD_SETTINGS":"Impostazioni password","MANUALLY_RESET_PASSWORD":"Reimpostare manualmente la password","UPDATE_REVENUE_DISTRIBUTION_SETTINGS":"Aggiorna impostazioni di distrubuzione Revenue","REVENUE_DISTRIBUTION_SETTINGS":"Impostazioni di distribuzione Revenue","PROFILE_TYPE_SETTINGS":"Impostazioni tipo di profilo","REFERRAL_LINKS":"Link di riferimento","DEFAULT_REVENUE_DISTRIBUTION_RULES":"Regole predefinite di distribuzione revenue","RESTORE_DEFAULTS":"Ripristina i valori predefiniti","UPDATE":"Aggiorna","DISTRIBUTION_RULES_TABLE":{"SERVICE":"Servizio","SYSTEM":"SYS","WHITELABEL":"WL","SALESMANLEAD":"SL","SALESMAN":"S","AGENT":"A","INSTITUTIONAL":"IC"},"DESCRIBE_EXCEPTION_RULE":"Descrivi la regola di eccezione","SELECT_USERS_TO_APPLY_EXCEPTION":"Seleziona gli utenti per applicare l'eccezione","SELECT_TYPES_OF_USERS_TO_APPLY_EXCEPTION":"Seleziona le tipologie di utenti per applicare l'eccezione","APPLIES_TO":"Applica a","TYPES_OF_USERS":"Tipologie di utenti","USERS":"Utenti","DISTRIBUTION_CONDITIONS_PROFILE_KINDS":{"SALESMANLEAD":"Responsabile venditore","SALESMAN":"Venditori","AGENT":"Agenti","CUSTOMER":"Clienti","WHITELABEL":"White Label"},"ACTIONS":{"REMOVE":"Rimuovi","ADD_EXCEPTION_PROFILES":"Aggiungi eccezione per profili specifici","ADD_EXCEPTION_KINDS":"Aggiungi eccezione per tipi specifici","ADD_EXCEPTION":"Aggiungi eccezione","NEW_ROW":"Nuova riga"},"EXCEPTION_TYPES":{"FOR_PROFILE":"Per profilo","FOR_MEMBER_TYPE":"Per tipo di membro"},"VALIDATION":{"AT_LEAST_ONE_CONDITION":"È necessario selezionare almeno una condizione!","SETTINGS_CONFLICT":"Questa eccezione non può essere applicata a causa di un conflitto di impostazioni. Controlla le eccezioni già esistenti o rimuovi quella attuale","ALL_CONDITIONS_SELECTED":"Non è stata trovata alcuna differenza tra \"{{exception_name}} \" e le impostazioni predefinite di distribuzione Revenue!","SUM_OF_SHARES_PERCENTAGE":"La percentuale di questa riga deve essere del 100%"},"MESSAGES":{"SETTINGS_SUCCESSFULLY_UPDATED":"Le impostazioni sono state aggiornate con successo"},"REFERRAL_WARNING_DIALOG":{"TITLE":"Attenzione","MESSAGE":"Dopo aver modificato il tipo di profilo - i link di riferimento verranno eliminati"}},"TAB.ACCOUNTS":{"HEADER":"Accounts","NO_ACCOUNTS":"Siamo spiacenti! Non ci sono account cliente nel sistema.","OPTIONS":{"BLOCK":"Blocca account"},"BUTTON":{"NEW_ACCOUNT":"Nuovo account"},"STATE":{"ACTIVE":"Attivo","INACTIVE":"Non attivo"},"FILTER":{"PLACEHOLDER":{"ACCOUNT_STATE":"Stato","ACCOUNT_CURRENCY":"Valuta","ACCOUNT_NAME":"Cerca nome account","ACCOUNT_NUMBER":"Cerca numero account","CARD_STATE":"Stato","CARD_CURRENCY":"Valuta","CARD_HOLDER":"Cerca nome titolare della carta","CARD_NUMBER":"Cerca numero carta"}}},"TAB.USERS":{"HEADER":"Utenti","NO_USERS":"Spiacenti! Nessun risultato trovato!","INVITE_MESSAGE":"È stata inviata un'email di invito","INVITE_BUTTON":"Invita utente (email)","INVITE_EMAIL_INVALID":"Inserisci un indirizzo email valido.","NEW_USER_HINT":"I nuovi utenti partono con un ruolo proprio e senza conti (salvo che il cliente abbia un solo conto attivo). Collega i loro conti dal dettaglio dell'utente.","ROLE_COLUMN":"Ruolo","LOADING":"Caricamento...","YES":"Sì","NO":"No","CONFIRM":"Conferma","CANCEL":"Annulla","ACTION_ERROR":"Non è stato possibile completare l'azione. Riprova.","NEW.DIALOG":{"TITLE":"Invita utente","MESSAGE":"Email della persona da invitare. Riceverà un link per registrarsi come utente di questo cliente.","BUTTONS.INVITE":"Invia email","BUTTONS.CANCEL":"Annulla"},"BUTTON":{"NEW_USER":"Nuovo utente"},"STATE":{"CREATED":"Creato","APPROVED":"Approvato","DECLINED":"Rifiutato","EDITED":"Modificato","EDITED_MESSAGE":"Stato modificato correttamente"},"STATE_DIALOG":{"TITLE":"Cambia stato dell'utente","MESSAGE":"Cambiare {{user}} in \"{{state}}\"?"},"FILTER":{"PLACEHOLDER":{"USER_STATE":"Stato","USER_NAME":"Cerca nome utente"}},"MANUAL":{"BUTTON":"Crea utente manualmente","TITLE":"Crea manualmente un utente autorizzato","MANDATORY_HINT":"Tutti i campi sono obbligatori (gli stessi dati del modulo di invito), tranne il secondo nome.","EMAIL":"Email","PHONE":"Telefono","FIRST_NAME":"Nome","LAST_NAME":"Cognome","MIDDLE_NAME":"Secondo nome","DATE_OF_BIRTH":"Data di nascita","PASSPORT_NUMBER":"Numero di passaporto","NATIONALITY":"Nazionalità","PASSPORT_ISSUE_DATE":"Data di rilascio del passaporto","PASSPORT_EXPIRY_DATE":"Data di scadenza del passaporto","ISSUE_COUNTRY":"Paese di rilascio","ISSUE_PLACE":"Luogo di rilascio","SELECT":"Seleziona...","CREATE":"Crea utente","CREATING":"Creazione...","CLOSE":"Chiudi","CREATED":"Utente creato correttamente.","CREATE_ERROR":"Impossibile creare l'utente. Controlla i dati e riprova.","SHARE_HINT":"Condividi queste credenziali con l'utente in modo sicuro.","TEMP_PASSWORD":"Password temporanea","COPY":"Copia","COPIED":"Copiata","PASSWORD_ONCE":"La password viene mostrata una sola volta: copiala prima di chiudere questo pannello.","NO_ACCOUNTS_HINT":"L'utente ha un ruolo proprio e ancora nessun conto: collegali dal dettaglio dell'utente."},"PROFILE_USER_DETAILS":{"ID":"Id","FULL_NAME":"Nome completo","FIRST_NAME":"Nome","LAST_NAME":"Cognome","USER_NAME":"Nome utente","CREATE_TIME":"Data di creazione","STATE":"Stato","USER_RELATED_ROLE":"Ruolo dell'utente","USER_RELATED_ROLE_DETAILS":"Dettagli del ruolo","SHOW_DETAILS":"Mostra dettagli","HIDE_DETAILS":"Nascondi dettagli","ACTION":"Azione","TWO_FA_TITLE":"2FA","TWO_FA_ACTIONS":"Azioni 2FA","NONE":"Nessuno","ACTIVE_2FA":"Attiva 2FA","DISABLE_2FA":"Disattiva 2FA","DISABLE_TOTP":"Disattiva TOTP","NO_ROLES_ASSOCIATED":"Nessun ruolo associato","TWO_FA_REQUESTED":"Attivazione 2FA richiesta. Potrebbero servire alcuni secondi perché sia visibile.","TWO_FA_DIALOG_TITLE":"Modifica 2FA","MAKE_ADMIN":"Rendi amministratore","REMOVE_ADMIN":"Rimuovi amministratore","ADMIN_DIALOG_TITLE":"Amministratore del cliente","MAKE_ADMIN_DIALOG":{"MESSAGE":"Rendere {{user}} amministratore di questo cliente? Vedrà tutti i conti, avrà tutti i permessi di pagamento e gestirà utenti e ruoli nel Client Office."},"REMOVE_ADMIN_DIALOG":{"MESSAGE":"Rimuovere il ruolo di amministratore a {{user}}? Passerà al proprio ruolo USER_{{id}} (quello esistente o uno nuovo senza conti) e perderà la sezione di amministrazione del Client Office. Se è l'unico amministratore, nessuno del cliente potrà gestire gli utenti."},"DISABLE_2FA_DIALOG":{"MESSAGE":"Disattivare tutti i metodi 2FA di {{user}}? Potrà accedere senza secondo fattore."},"DISABLE_TOTP_DIALOG":{"MESSAGE":"Disattivare l'app di autenticazione (TOTP) di {{user}}?"},"SECURITY_SHOW":"Mostra attività 2FA e accessi","SECURITY_HIDE":"Nascondi attività 2FA e accessi","PHONE_EMPTY":"Il numero di telefono non può essere vuoto","PHONE_SAVE_ERROR":"Impossibile salvare il telefono. Riprova.","ACTION_ERROR":"Non è stato possibile completare l'azione. Riprova."},"USER_RELATED_ROLE_DETAILS":{"ID":"Id","ROLE_NAME":"Nome del ruolo","USERS_WITH_ROLE":"Utenti con questo ruolo","CREATE_PAYMENT":"Crea pagamento","AUTHORIZE_PAYMENT":"Autorizza pagamento","STATEMENTS":"Estratti conto","HISTORY":"Storico","PAYMENT_AMOUNT":"Importo pagamento","AUTHORIZE_AMOUNT":"Importo autorizzazione","CREATE_TIME":"Data di creazione","ASSOCIATED_ACCOUNTS":"Conti associati","ALL_ACCOUNTS":"Tutti i conti","NO_ASSOCIATED_ACCOUNTS":"Nessun conto associato","VIEW_ACCOUNTS":"Vedi conti","SHOW_ROLE_DETAILS":"Mostra dettagli del ruolo","HIDE_ROLE_DETAILS":"Nascondi dettagli del ruolo","SHOW_ROLE_ACCOUNT_DETAILS":"Mostra conti","HIDE_ROLE_ACCOUNT_DETAILS":"Nascondi conti","ACCOUNT_NAME":"Nome del conto","ACCOUNT_NUMBER":"Numero del conto","ACCOUNT_IBAN":"IBAN del conto","POOL_NAME":"Pool","LIQUIDITY_NAME":"Conto di liquidità","ASSOCIATED":"Associato","ASSOCIATE_ACCOUNT_ACTION":"Associa conto","REMOVE_ACCOUNT_ACTION":"Rimuovi conto"},"ROLE_ACCOUNTS":{"TITLE":"Conti del ruolo {{role}}","LINKED_COUNT":"{{count}} di {{total}} collegati","ADMIN_INFO":"Il ruolo di amministratore vede sempre tutti i conti del cliente. Per limitare i conti di un utente, l'utente deve avere un altro ruolo.","SHARED_WARNING":"Questo ruolo è condiviso da {{count}} utenti ({{users}}). Collegare o scollegare un conto cambia ciò che vedono tutti.","NOT_SHARED":"Solo questo utente ha questo ruolo: le modifiche valgono solo per lui.","GIVE_OWN_ROLE":"Dai a questo utente un ruolo proprio","GIVE_OWN_ROLE_DIALOG":{"TITLE":"Ruolo proprio per l'utente","MESSAGE":"Verrà creato un nuovo ruolo USER_{{id}} solo per questo utente, con gli stessi permessi e conti di {{role}}. Gli altri utenti mantengono {{role}}."},"UNLINK_DIALOG":{"TITLE":"Scollega conto","MESSAGE":"Scollegare {{account}} dal ruolo {{role}}?"},"CURRENCY":"Valuta","STATE":"Stato","LINKED":"Collegato","NOT_LINKED":"Non collegato","LINK":"Collega","UNLINK":"Scollega","CANCEL":"Annulla","LINKED_MESSAGE":"Conto collegato","UNLINKED_MESSAGE":"Conto scollegato","LOADING":"Caricamento dei conti...","EMPTY":"Questo cliente non ha conti.","LOAD_ERROR":"Impossibile caricare i conti.","RETRY":"Riprova","ACTION_ERROR":"Non è stato possibile completare l'azione. Riprova."}},"TAB.API_ACCESS":{"HEADER":"Accesso API","EMPTY":"Questo cliente non ha ancora accesso alla Payments API.","CREATE_BUTTON":"Crea accesso API","READ_ONLY_SETTINGS":"Le impostazioni avanzate (express, sotto-conto, pool consentiti, eMoney, wallet) non si possono modificare qui.","CREATED":"Accesso API creato.","ROTATED":"Chiave API ruotata.","BLOCKED":"Accesso API bloccato.","UNBLOCKED":"Accesso API sbloccato.","PERMISSIONS_UPDATED":"Permessi aggiornati.","OTHER_PERMISSIONS":"Consentiti anche (non gestiti qui)","RETRY":"Riprova","CANCEL":"Annulla","SAVE":"Salva","YES":"Sì","NO":"No","ACTION_ERROR":"Non è stato possibile completare l'azione. Riprova.","TABLE":{"NAME":"Nome","KEY":"Chiave","STATE":"Stato","PERMISSIONS":"Permessi","CREATED":"Creato","KEY_ROTATED":"Chiave ruotata","ACTIONS":"Azioni"},"FORM":{"NAME":"Nome del consumer","NAME_HINT":"Da 3 a 64 lettere minuscole, cifre o trattini. Deve essere unico.","PERMISSIONS":"Permessi","INTERNAL_NOTE":"I pagamenti interni servono anche per confermare i pagamenti al conto master."},"PERMISSION":{"BALANCES":"Saldi","TRANSACTION_HISTORY":"Storico transazioni","EXTERNAL_PAYMENTS":"Pagamenti esterni","INTERNAL_PAYMENTS":"Pagamenti interni","MASTER_PAYMENTS":"Pagamenti al conto master"},"KEY":{"ONCE":"Copia ora la chiave API. Per sicurezza non verrà più mostrata.","COPY":"Copia","COPIED":"Copiata","STORED":"Ho salvato la chiave","SEND_HINT":"Inviala al cliente tramite un link segreto monouso, mai per email o chat."},"ACTIONS":{"ROTATE":"Ruota chiave","BLOCK":"Blocca","UNBLOCK":"Sblocca","PERMISSIONS":"Permessi"},"ROTATE":{"TITLE":"Ruota chiave API","MESSAGE":"Ruotare la chiave API di {{name}}? La chiave attuale smette subito di funzionare e il cliente deve passare a quella nuova.","CONFIRM":"Ruota chiave"},"BLOCK":{"TITLE":"Blocca accesso API","MESSAGE":"Bloccare l'accesso API di {{name}}? Ogni richiesta con la sua chiave verrà rifiutata subito.","CONFIRM":"Blocca"},"UNBLOCK":{"TITLE":"Sblocca accesso API","MESSAGE":"Sbloccare l'accesso API di {{name}}?","CONFIRM":"Sblocca"},"SETTINGS":{"EXPRESS":"Express","SUB_ACCOUNT":"Sotto-conto","ALLOWED_POOLS":"Pool consentiti","EMONEY":"eMoney","WALLETS":"Wallet"},"ACTIVITY":{"TITLE":"Attività","EMPTY":"Nessuna modifica registrata dal back office.","DATE":"Data","ACTION":"Azione","BY":"Da","CHANGES":"Modifiche","ACTIONS":{"CREATE":"Creato","ROTATE_KEY":"Chiave ruotata","BLOCK":"Bloccato","UNBLOCK":"Sbloccato","UPDATE_PERMISSIONS":"Permessi aggiornati"}}},"TAB.CARDS":{"HEADER":"Carte","NO_CARDS":"Non c'è nessuna carta nel sistema","OPTIONS":{"BLOCK":"Blocca carta","REACTIVATE":"Riattiva carta"},"STATUS":{"ACTIVE":"Attivo","INACTIVE":"Non attivo","SET":"Assegnato"}},"TAB.DOCUMENTS":{"HEADER":"Documenti","AUTHORISED_SIGNATORY":"Firmatario autorizzato","DIRECTORS_OF_COMPANY":"Amministratori della società","SHAREHOLDERS":"Azionisti","COMPANY_INFORMATION":"Informazioni sulla società","COMPANY_NAME":"Nome società","FIRST_NAME":"Nome","LAST_NAME":"Cognome","DIRECTOR":"Direttore","SHAREHOLDER":"Azionista","IDENTITY_CONFIRMATION":"Conferma dell'identità","LEGAL_DOCUMENTS":"Documenti legali","SELFIE":"Selfie","PROOF_OF_ADDRESS":"Prova di residenza","ARCHIVE_BUTTON":"Salva archivio","NO_DOCUMENTS":"Siamo spiacenti! Non c'è nessun allegato."},"TAB.DEPENDENT_PROFILES":{"HEADER":"Profili dipendenti","EMPTY":{"PROFILES":"Siamo spiacenti! Non ci sono profili dipendenti."}},"RESET_PASSWORD_DIALOG":{"TITLE":{"SUCCESS":"La reimpostazione della password per {{nome utente}} è riuscita","ERROR":"Il messaggio non è stato consegnato. Qualcosa è andato storto, contatta il supporto tecnico per risolvere il problema.","DISABLE":"Il messaggio non è stato consegnato poiché la consegna automatica dei messaggi non è attiva per questo cliente."},"BODY":"Per reimpostare la password, copia questo link sottostante e invialo al cliente"}},"VERIFICATION":{"TAB":"Verifica","VERIFY_BUTTON":"Verificare","UPDATE_BUTTON":"Aggiorna","KYC":{"OVERALL":"Stato generale:","APPLICANTS_BADGE_EXPLANATION":"KYC:","TAB":"KYC","EMPTY_PROFILE":"Il profilo non è mai stato verificato","TITLE":"Risultati di verifica KYC","CAR":"CRA File"},"ONFIDO":{"APPLICANTS_BADGE_EXPLANATION":"Onfido:","TAB":"Onfido","TITLE":"Risultati di verifica Onfido","EMPTY_PROFILE":"Il profilo non è mai stato verificato","NOT_AVAILABLE":"Onfido non è disponibile in questo momento","CREATE_APPLICANT":"Nuovo richiedente"},"ARIADNEXT":{"APPLICANTS_BADGE_EXPLANATION":"Ariad:","TAB":"Ariadnext","TITLE":"Risultati di verifica Ariadnext","EMPTY_PROFILE":"Il profilo non è mai stato verificato","EXPIRED":"Scaduto","NOT_AVAILABLE":"Ariadnext non è disponibile in questo momento","CREATE_APPLICANT":{"TITLE":"Inizia verifica","MODAL_DESCRIPTION":"Come dovrebbe essere invitato l'utente alla procedura di verifica??","SEND_LINK_TO":"Manda in link a","START_BUTTON":"Inizia","CLOSE_BUTTON":"Chiudi","EMAIL":"Per Email","PHONE":"Per Phone"},"CARD":{"FIRST_NAME":"Nome","LAST_NAME":"Cognome","PHONE_NUMBER":"Numero di telefono","CREATED":"Creato","UPDATED":"Aggiornato","ATTEMPTS":"Tentativi di verifica","UUID":"File UUID","ACTION":{"VERIFY":"Verificare","DECLINE":"Rifiuta","START":"Inizia verifica","PDF_DOC":"Passaporto","PDF_SELFIE":"Selfie"}},"CHECKS":{"SHOW":"Mostra controlli","HIDE":"Nascondi controlli"}},"BLOCK":{"TITLE":{"PROFILE":"Verifica del profilo","COMPANY":"Verifica dell'azienda","SIGNATORY":"Verifica firmatario autorizzato","DIRECTORS":"Verifica direttori","SHAREHOLDERS":"Verifica azionisti","SHAREHOLDER":"Azionista","DIRECTOR":"Direttore","CHECKS":"Controlli utente","BREAKDOWN":"Report guasti","REPORTS":"Report controlli"},"DETAILS":"Dettagli di verifica","STATUS":{"VERIFIED":"Verificato","DECLINED":"Rifiutato","OPEN_TO_UPLOAD_DATA":"Apri per caricare dati","OUT_OF_VERIFICATION":"Fuori verifica","CONSIDER":"Considera","CLEAR":"Cancella","AML_FOUND":"Trovato AML","NOT_VERIFIED":"Non verificato","IN_PROGRESS":"In corso","INVALID":"Non valido","CORPORATE":"Aziendale","INDIVIDUAL":"Individuale","INCOMPLETE_DATA":"Dati aziendali incompleti","NONE":"Nessuno","ERROR":"Errore","WARN":"Attenzione","OBSOLETE":"Obsoleto","OK":"Successo"},"FIELD":{"COMPANY_NAME":"Nome azienda","REG_NUMBER":"Numero registrazione","COMPANY_TYPE":"Tipo di azienda","REG_OFFICE_COUNTRY":"Paese della sede legale","VERIFICATION_DATE":"Data di verifica","FIRST_NAME":"Nome","LAST_NAME":"Cognome","DOB":"Data di nascita","NATIONALITY":"Nazionalità","ADDRESS":"Indirizzo","CREATE_DATE_TIME":"Crea data e ora","COMPLETE_DATE_TIME":"Completa data e ora","STATUS":"Status","CHECK_ID":"Controlla id","REPORT_ID":"Report id","HAS_ERRORS":"Errori","REPORT_NAME":"Report name","REPORT_CREATED_AT":"Creato a","LINK":"Link","BREAKDOWNS":"Guasti","APPLICANT_ID":"Richiedente id","EMAIL":"Email","COLOUR_PICTURE":"Immagine a colori","TEMPLATE":"Template","COMPROMISED_DOCUMENT":"Documento compromesso","DATA_COMPARISON":"Confronto dei dati","DATE_OF_BIRTH":"Data di nascita","FACE_COMPARISON":"Confronto del viso","FACE_MATCH":"Corrispondenza viso","IMAGE_INTEGRITY":"Integrità dell'immagine","FACE_DETECTED":"Viso rilevato","VISUAL_AUTHENTICITY":"Autenticità visiva","LIVENESS_DETECTED":"Vivacità rilevata","SPOOFING_DETECTION":"Rilevamento di spoofing","ISSUING_COUNTRY":"Paese emittente","GENDER":"Genere","DATE_OF_EXPIRY":"Data di scadenza","DOCUMENT_TYPE":"Tipo di documento","DOCUMENT_NUMBERS":"Numeri documento","DATA_CONSISTENCY":"Coerenza sei dati","DATA_VALIDATION":"Convalida dei dati","DOCUMENT_EXPIRATION":"Scadenza del documento","EXPIRY_DATE":"Data di scadenza","MRZ":"MRZ","FONTS":"Caratteri","PICTURE_FACE_INTEGRITY":"Integrità dell'immagine del viso","SECURITY_FEATURES":"Caratteristiche di sicurezza","ORIGINAL_DOCUMENT_PRESENT":"Documento originale attuale","DIGITAL_TAMPERING":"Manomissione digitale","OTHER":"Altro","FACE_DETECTION":"Riconoscimento facciale","IMAGE_QUALITY":"Qualità dell'immagine","SUPPORTED_DOCUMENT":"Documento supportato","POLICE_RECORD":"Fedina penale","SEND_DATE_TIME":"Invia data e ora","NOTIFICATION_LINK":"Link di notifica","SEND_LINK_APPROACH":"Inviare link accesso","ERROR_REASON":"Motivo dell'errore"}}},"MAILING":{"ITEMS":{"PASSWORD_LINK":"Link password","CONFIRM_CODE":"Codice di conferma","RESET_PASSWORD_LINK":"Link reset password"},"NOT_SEND":{"MSG":"L'e-mail {{dati}} non è stata ancora inviata","SIMPLE_MSG":"L'e-mail non è stata ancora inviata"},"PROCESSING":{"SIMPLE_MSG":"Invio e-mail...","MSG":"Invio {{dati}} e-mail ..."},"SUCCESS":{"MSG":"L'e-mail {{dati}} è stata inviata con successo","SIMPLE_MSG":"L'e-mail è stata inviata con successo","APPROVAL_MAIL":"La lettera di benvenuto con le informazioni sull'account è stata inviata"},"ERROR":{"MSG":"Si è verificato un errore durante l'invio di {{dati}} email: {{error_message}}","SIMPLE_MSG":"Il messaggio non è stato consegnato. Qualcosa è andato storto, contatta l'assistenza tecnica per risolvere il problema.","DETAILS":"{{error_details}}","FAILURE":"Sending mail was failure","APPROVAL_MAIL":"La lettera di benvenuto con le informazioni sull'account non è stata inviata, contatta l'assistenza tecnica per risolvere il problema."},"DISABLED":{"SIMPLE_MSG":"Il messaggio non è stato consegnato poiché la consegna automatica dei messaggi non è attiva per questo cliente."}},"APPROVE":{"STATE_CHANGED":"Lo stato del profilo è cambiato."},"CONFIRM_CHANGE_STATE":"Conferma la richiesta di processo da {{cliente}}"}}

/***/ }),
/* 725 */
/***/ (function(module, exports) {

	module.exports = {"APPLICATIONS":{"NEW":{"TITLE":"Applicazioni/Nuovo","NOT_FOUND":"Spiacenti! Non ci sono applicazioni nel sistema.","DETAIL":{"TITLE":"Applicazione/Nuovo/ID:{{id}}","TAB.DETAILS":{"PRIVATE":{"APPLICANT_INFORMATION":{"TITLE":"Richiedente","PERSONAL_DETAILS":{"TITLE":"Dettagli personali","FIRST_NAME":"Nome","LAST_NAME":"Cognome"},"NATIONALITY":"Nazionalità","PASSPORT":"Carta identità / Passaporto No.","PLACE_OF_ISSUE":"Ente emittente","DATE":{"TITLE":"Data di emissione/ scadenza","ISSUE":"Data di emissione","EXPIRY":"Data di scadenza","EXPIRY_WARNING":"Si prega di notare che il passaporto è vicino alla scadenza."},"SECOND_NATIONALITY":"Seconda cittadinanza","RESIDENTIAL_ADDRESS":{"TITLE":"Indirizzo di casa","RESIDENTIAL_POSTAL_ADDRESS":"Indirizzo di casa","RESIDENTIAL_POSTAL_CITY":"Città","RESIDENTIAL_POSTAL_COUNTY_OR_REGION":"Provincia o regione","RESIDENTIAL_COUNTRY":"Paese","RESIDENTIAL_ZIP_CODE":"CAP / ZIP code"},"POSTAL_ADDRESS":{"TITLE":"Indirizzo postale","POSTAL_ADDRESS":"Indirizzo postale","POSTAL_CITY":"Città","POSTAL_COUNTY_OR_REGION":"Provincia o regione","COUNTRY":"Paese","ZIP_CODE":"CAP / ZIP code"},"PHONE_NUMBER":"Numero di telefono","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","BIRTH_DATE":"Data di nascita","PLACE_OF_BIRTH":"Luogo di nascita (Paese)","TAX_IDENTIFICATION_NUMBER":"P.IVA/Codice fiscale","TAX_COUNTRY":"Paese contribuzione fiscale","FAX_NUMBER":"Numero di fax","FACEBOOK_PROFILE":"Profilo Facebook","LINKEDIN":"LinkedIn","OTHER":"Altro","ID_OR_PASSPORT_ATTACHMENT_ITEMS":"Elementi allegati Carta identità o Passaporto","PASSPORT_SELFIE_ATTACHMENT_ITEMS":"Elementi allegati selfie Passaporto","ADDRESS_ATTACHMENT_ITEMS":"Elementi allegati indirizzo","SAVE_ALL":"Salva tutto","UPLOAD":{"TITLE":"Carica","ERROR":{"MAX_SIZE":"La dimensione del file supera il valore consentito!","FILE_ALREADY_CONFIRMED":"File già presente nel sistema!","FILE_NOT_FOUND":"File non trovato!","UNSUPPORTED_FORMAT":"Formato di file non supportato!"}},"FILTER":{"NOT_FOUND":{"NATIONALITY_SELECT":"Non ci sono Paesi disponibili","SECOND_NATIONALITY_SELECT":"Non ci sono Paesi disponibili","COUNTRY_SELECT":"Non ci sono Paesi disponibili","RESULT_COUNTRY_SELECT":"Nessun risultato trovato","JURISDICTION":"Non ci sono Giurisdizioni disponibili"}}},"EMPLOYMENT_INFORMATION":{"TITLE":"Impiego","PRESENT_OCCUPATION":"Attuale occupazione","EMPLOYMENT_DETAILS":{"TITLE":"Dettagli impiego","NAME":"Nome del datore di lavoro/Nome dell'attività","ADDRESS":{"TITLE":"Indirizzo datore di lavoro","POSTAL_ADDRESS":"Indirizzo ufficio datore di lavoro","POSTAL_CITY":"Città","POSTAL_COUNTY_OR_REGION":"Provincia o regione","COUNTRY":"Paese","ZIP_CODE":"CAP / ZIP code"},"BUSINESS_SECTOR":"Nome Attività aziendale","YEARS_IN_EMPLOYMENT":"Numero anni di lavoro/attività"}},"PEP_INFORMATION":{"TITLE":"PEP","POSITION_IN_ANY_COUNTRY":"Sei un PEP o sei collegato a un PEP? Una \" Persona politicamente esposta \" è una persona fisica (individuo) a cui è o è stata affidata una funzione pubblica di rilievo e include i suoi parenti stretti o persone note per essere stretti collaboratori di tali persone, ma escludendo gli esponenti di medio/basso livello.","FAMILY_POSITION_IN_ANY_COUNTRY":"Qualche tuo parente stretto attualmente detiene o ha mai ricoperto cariche politiche, diplomatiche o governative in un paese? (Barrare la casella se la risposta è SÌ)"},"LITIGATION_INFORMATION":{"TITLE":"Contenzioso","LITIGATION":"Sei mai stato oggetto di indagini legali, ordinanze di tribunali, sentenze, procedimenti fallimentari, sanzioni penali (esclusi incidenti stradali minori)? (Barrare la casella se la risposta è SI)"},"MASTER_ACCOUNT_INFORMATION":{"TITLE":"Account principale","MASTER_ACCOUNT_CURRENCY":"Valuta account principale","ADDITIONAL_CURRENCIES":"Valute aggiuntive"},"FUNDS_INFORMATION":{"TITLE":"Fondi","SOURCE_OF_INITIAL_FUNDING":{"TITLE":"Origine del deposito iniziale","JURISDICTION":"Giurisdizione","AVERAGE_MONTHLY_INCOME":"Qual è il tuo reddito mensile medio?","PRIMARY_INCOME_SOURCE":"Indica la tua fonte di reddito principale","ORIGINAL_BANK_NAME":"Nome Banca d'origine","ORIGINAL_BANK_ADDRESS":"Indirizzo Banca d'origine","ACCOUNT_NAME":"Nome account","SIGNATORY":"Firmatario","HOW_FUNDS_GENERATED":"Descrivi con precisione come sono stati generati questi fondi"},"EXPECTED_TRANSFER_ACTIVITY":{"TITLE":"Attività di trasferimento prevista","AVERAGE_VALUE_OF_TRANSFER":"Valore medio di ogni trasferimento ({{currency}})","MAX_VALUE_OF_TRANSFER":"Valore massimo di ogni trasferimento ({{currency}})","MAIN_COUNTRIES_TO":"Paesi verso i quali saranno effettuati i trasferimenti","MAIN_COUNTRIES_FROM":"Paesi dai quali verranno ricevuti trasferimenti","PURPOSE_OF_ACCOUNT":" Scopo di questo account","AVERAGE_INCOMING_TRANSACTION":"Valore medio delle transazioni in entrata","PLANNED_MONTHLY_INCOMING_TURNOVER":"Fatturato mensile pianificato dei pagamenti in entrata utilizzando l'account {{vendorTitle}}","MONTHLY_INCOMING_FREQUENCY":"Frequenza media dei pagamenti in entrata","AVERAGE_OUTGOING_TRANSACTION":"Valore medio delle transazioni in uscita","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Fatturato mensile pianificato dei pagamenti in uscita utilizzando l'account {{vendorTitle}}","MONTHLY_OUTGOING_FREQUENCY":"Monthly frequency of outgoing payments"},"RANGE":{"UP":"Fino a {{amountTo}} {{unit}}","FROM_TO":"Da {{amountFrom}} {{unit}} a {{amountTo}} {{unit}}","MORE":"Più di {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Fino a {{amountTo}}","FROM_TO":"Da {{amountFrom}} a {{amountTo}}","MORE":"Più di {{amountFrom}}"}},"INTRODUCER_INFORMATION":{"TITLE":"Sponsor/Rivenditore","INTRODUCER_NAME":"Nome Sponsor/Rivenditore","INTRODUCER_EMAIL":"Email Sponsor/Rivenditore"},"ABOUT_YOURSELF_INFORMATION":{"TITLE":"Parlaci di te","PRODUCTS":"Quali {{company}} prodotti/servizi hai intenzione di usare?","PRODUCTS_CUSTOM":"Peronalizza prodotti","REASONS":"Motivi","REASONS_CUSTOM":"Personalizza motivi","INFORMATION_SOURCE":"Fonti di informazione","INFORMATION_SOURCES_CUSTOM":"Personalizza fonti informazione","USA_CITIZEN":"Spuntando la casella dichiaro di NON essere un cittadino e / o residente fiscale degli USA."},"REQUIRED_INPUT":"Questo campo è obbligatorio!","MINIMUM_LENGTH":"La lunghezza minima è di {{value}} caratteri","MAXIMUM_LENGTH":"La lunghezza massima è di {{value}} caratteri"},"EDIT.BUTTON.NAME":"Modifica","HEADER":"Dettagli","UNAVAILABLE_CURRENCY":" non è al momento disponibile","SAVE.BUTTON.NAME":"Salva","SAVE_ALL.BUTTON.NAME":"Salva tutto","UPLOAD.BUTTON.NAME":"Carica","CANCEL.BUTTON.NAME":"Cancella","DISCARD.BUTTON.NAME":"Scarta","REMOVE.BUTTON.NAME":"Elimina","ADD_NEW.BUTTON.NAME":"Aggiungi nuovo","CHOSE.BUTTON.NAME":"Scegli file","UPLOAD.DOCUMENT.HEADER":"Carica documenti","OTHER":"Altro","CORPORATE":{"COMMON":{"FIRST_NAME":"Nome","LAST_NAME":"Cognome","DATE_OF_BIRTH":"Data di nascita","ATTORNEY_POWER_EXPIRE_DATE":"Data di scadenza della procura (se applicabile)","JOB_TITLE_OCCUPATION":"Lavoro / Occupazione","NIC_PASSPORT_ID":"Carta Identità/Passaporto No","IS_PEP":"Questa persona è una PEP o correlata ad una PEP?","TRUE":"Vero","FALSE":"Falso","NATIONALITY":"Nazionalità","SECOND_NATIONALITY":"Seconda cittadinanza","ADDRESS_LINE":"Indirizzo","COUNTRY":"Paese","COUNTY_REGION":"Provincia / Regione","CITY":"Città","ZIP_CODE":"CAP / ZIP code","RESULT_COUNTRY_SELECT":"Nessun risultato trovato","PHONE_NUMBER":"Numero di telefono","MOBILE":"Cellulare","LINKEDIN":"Linkedin","FACEBOOK":"Facebook","WEBSITE":"Website","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","NAME_OF_CORPORATE_SHAREHOLDER":"Nome del socio aziendale","LEGAL_DOCUMENTS":"Documenti legali","PERSONAL_INFORMATION":"Informazioni personali","COMPANY_INFORMATION":"Informazioni Azienda","COMPANY_NAME":"Nome Azienda","COUNTRY_OF_INCORPORATION":"Paese di costituzione","COMPANY_REGISTRATION_NUMBER":"Numero riferimento Azienda","COMPANY_ADDRESS":"Indirizzo Azienda (Facoltativo)","COMPANY_CONTACTS":"Contatti Azienda","HOME_ADDRESS":"Indirizzo di casa (Facoltativo)","CONTACTS":"Contatti","INDIVIDUAL":"Privato","CORPORATE":"Aziendale","IDENTITY_CONFIRMATION":"Conferma identità","YES":"Sì","NO":"No","PROOF_OF_ADDRESS":"Prova di recapito","OPTIONAL_ADDRESS":"Indirizzo facoltativo","INVALID_VALUE":"Valore non valido"},"BUSINESS_CUSTOMER_INFORMATION":{"TITLE":"informazioni Cliente Business","DATE_OF_REGISTRATION":"Data di registrazione","REGISTRATION_NUMBER":"Numero di registrazione","TRADING_NAME":"Denominazione commerciale","TAX_IDENTIFICATION_NUMBER":"Partita IVA","USER_EMAIL":"Email","BUSINESS_ACTIVITIES":"Attività aziendali","SEARCH_BUSINESS_ACTIVITIES":"Cerca attività aziendali"},"REGISTERED_OFFICE_ADDRESS":{"TITLE":"Indirizzo sede legale"},"OFFICIAL_BUSINESS_LOCATION":{"TITLE":"Sede ufficiale attività","PROOF_OF_ADDRESS":"Documenti per prova di recapito"},"CONTACT_INFORMATION":{"TITLE":"Informazioni di contatto","PHONE_NUMBER":"Numero di telefono"},"STATEMENT_OF_AFFAIRS":{"TITLE":"Dichiarazione di attività","SPECIFIC_COUNTRIES":"Specifici Paesi per operazioni su mercati targhettizzati","NATURE_OF_BUSINESS":"Natura del business"},"INITIAL_DEPOSITS":{"TITLE":"Origine die fondi","SOURCE_OF_INITIAL_DEPOSIT":"Descrivi l'origine del deposito iniziale","ORIGINATING_BANK_JURISDICTION":"Giurisdizione della Banca di origine","DESCRIBE_FUNDS_WERE_GENERATED":"Descrivi con precisione come sono stati generati questi fondi","AMOUNT":"Importo","CURRENCY":"Valuta","ACCOUNT_NAME":"Nome account"},"EXPECTED_TURNOVER":{"TITLE":"Fatturato previsto","AVERAGE_INCOMING_TRANSACTION":"Valore / dimensione medio della transazione in entrata","PLANNED_MONTHLY_INCOMING_TURNOVER":"Fatturato mensile previsto dei pagamenti in entrata utilizzando l'account {{vendorTitle}}","MONTHLY_INCOMING_FREQUENCY":"Frequenza mensile dei pagamenti in entrata","AVERAGE_OUTGOING_TRANSACTION":"Valore / dimensione medio della transazione in uscita","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Fatturato mensile previsto dei pagamenti in uscita sull'account {{vendorTitle}}","MONTHLY_OUTGOING_FREQUENCY":"Frequenza mensile dei pagamenti in uscita","RANGE":{"UP":"Fino a {{amountTo}} {{unit}}","FROM_TO":"Da {{amountFrom}} {{unit}} a {{amountTo}} {{unit}}","MORE":"Più di {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Fino a {{amountTo}}","FROM_TO":"Da {{amountFrom}} to {{amountTo}}","MORE":"Più di {{amountFrom}}"},"MAIN_SUPPLIERS":"Controparti principali per i pagamenti in uscita (nome / giurisdizione)","MAIN_CLIENTS":"Controparti principali per i pagamenti in entrata (nome / giurisdizione)"},"AUTHORISED_SIGNATORY":{"TITLE":"Firmatario autorizzato","SAVE_ALL":"Salva tutto","DETAILS":"Dettagli firmatario autorizzato","ADDRESS":"Indirizzo firmatario autorizzato","CONTACTS":"Contatti firmatario autorizzato","PASSPORT":"Passaporto","SELFIE":"Selfie con Carta Identità"},"DIRECTORS":{"TITLE":"Amministratori dell'Azienda","DIRECTOR_TYPE":"Tipo Amministratore","NIC_PASSPORT_ID":"Passaporto/Carta Identità No"},"SHAREHOLDERS":{"TITLE":"Soci","SHARE_NUMBER":"Quota: {{share}}%","SHARE":"Quota: %","EMPTY":"Siamo spiacenti! Non ci sono soci.","SHAREHOLDER_TYPE":"Tipo di socio","SHAREHOLDER_SUM_ERROR":"La somma delle % di quote deve essere uguale a 100%","NIC_PASSPORT_ID":"Passaporto/Carta Identità No."},"INTRODUCER":{"TITLE":"Sponsor/Rivenditore","INTRODUCER_NAME":"Nome Sponsor/Rivenditore","INTRODUCER_EMAIL":"Email Sponsor/Rivenditore"},"ACCOUNT_CURRENCIES":{"TITLE":"Valute account","MASTER_ACCOUNT_CURRENCY":"Valuta account principale","ADDITIONAL_CURRENCIES":"Valute aggiuntive"},"USAGE_AND_REFERRAL":{"TITLE":"Utilizzo e referral","WHAT_PRODUCTS_SERVICES":"Quali {{company}} prodotti/servizi avete intenzione di utilizzare?","REASON_FOR_CHOOSING":"Motivazione della scelta {{company}}","SOURCE_OF_INFORMATION":"Fonte delle informazioni circa {{company}}?"}}},"TAB.DOCUMENTS":{"HEADER":"Documentt","IDENTITY_CONFIRMATION":"Conferma identità","LEGAL_DOCUMENTS":"Documenti legali","SELFIE":"Selfie","PROOF_OF_ADDRESS":"Prova di recapito","ARCHIVE_BUTTON":"Salva archivio","NO_DOCUMENTS":"Siamo spiacenti! Non c'è alcun allegato."}},"PROCESS":{"CONFIRM.TITLE":"Conferma richiesta processo","CONFIRM.MESSAGE":"Questo cliente sarà nello stato <b> elaborazione </b>, sei sicuro di voler continuare?","CONFIRM.BUTTON":"Conferma"}},"MANUAL_REVIEW":{"TITLE":"Applicazioni/Revisione manuale","NOT_FOUND":"Siamo spiacenti! Non ci sono applicazioni presenti nel sistema.","DETAIL":{"TITLE":"Applicazione/Revisione manuale/ID:{{id}}","TAB.DETAILS":{"PRIVATE":{"APPLICANT_INFORMATION":{"TITLE":"Richiedente","PERSONAL_DETAILS":{"TITLE":"Dettagli personali","FIRST_NAME":"Nome","LAST_NAME":"Cognome"},"NATIONALITY":"Nazionalità","PASSPORT":"Carta Identità / Passaporto No.","PLACE_OF_ISSUE":"Autorità emittente","DATE":{"TITLE":"Data di emissione/scadenza","ISSUE":"Data di emissione","EXPIRY":"Data di scadenza","EXPIRY_WARNING":"Si prega di notare che il passaporto è prossimo alla scadenza."},"SECOND_NATIONALITY":"Seconda cittadinanza","RESIDENTIAL_ADDRESS":{"TITLE":"Indirizzo di casa","RESIDENTIAL_POSTAL_ADDRESS":"Indirizzo di casa","RESIDENTIAL_POSTAL_CITY":"Città","RESIDENTIAL_POSTAL_COUNTY_OR_REGION":"Provincia o regione","RESIDENTIAL_COUNTRY":"Paese","RESIDENTIAL_ZIP_CODE":"CAP / ZIP code"},"POSTAL_ADDRESS":{"TITLE":"Indirizzo postale","POSTAL_ADDRESS":"Indirizzo postale","POSTAL_CITY":"Città","POSTAL_COUNTY_OR_REGION":"Provincia o regione","COUNTRY":"Paese","ZIP_CODE":"CAP / ZIP code"},"PHONE_NUMBER":"Numero di telefono","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","BIRTH_DATE":"Data di nascita","PLACE_OF_BIRTH":"Luogo di nascita (Paese)","TAX_IDENTIFICATION_NUMBER":"P.IVA/Codice fiscale","TAX_COUNTRY":"Paese contribuzione fiscale","FAX_NUMBER":"Numero di fax","FACEBOOK_PROFILE":"Profilo Facebook","LINKEDIN":"LinkedIn","OTHER":"Altro","ID_OR_PASSPORT_ATTACHMENT_ITEMS":"Elementi allegati Carta identità o Passaporto","PASSPORT_SELFIE_ATTACHMENT_ITEMS":"Elementi allegati selfie Passaporto","ADDRESS_ATTACHMENT_ITEMS":"Elementi allegati indirizzo","SAVE_ALL":"Salva tutto","UPLOAD":{"TITLE":"Carica","ERROR":{"MAX_SIZE":"La dimensione del file supera il valore consentito!","FILE_ALREADY_CONFIRMED":"File già presente nel sistema!","FILE_NOT_FOUND":"File non trovato!","UNSUPPORTED_FORMAT":"Formato di file non supportato!"}},"FILTER":{"NOT_FOUND":{"NATIONALITY_SELECT":"Non ci sono Paesi disponibili","SECOND_NATIONALITY_SELECT":"Non ci sono Paesi disponibili","COUNTRY_SELECT":"Non ci sono Paesi disponibili","RESULT_COUNTRY_SELECT":"Nessun risultato trovato","JURISDICTION":"Non ci sono Giurisdizioni disponibili"}}},"EMPLOYMENT_INFORMATION":{"TITLE":"Impiego","PRESENT_OCCUPATION":"Attuale occupazione","EMPLOYMENT_DETAILS":{"TITLE":"Dettagli impiego","NAME":"Nome del datore di lavoro/Nome dell'attività","ADDRESS":{"TITLE":"Indirizzo datore di lavoro","POSTAL_ADDRESS":"Indirizzo ufficio datore di lavoro","POSTAL_CITY":"Città","POSTAL_COUNTY_OR_REGION":"Provincia o regione","COUNTRY":"Paese","ZIP_CODE":"CAP / ZIP code"},"BUSINESS_SECTOR":"Nome Attività aziendale","YEARS_IN_EMPLOYMENT":"Numero anni di lavoro/attività"}},"PEP_INFORMATION":{"TITLE":"PEP","POSITION_IN_ANY_COUNTRY":"Sei un PEP o sei collegato a un PEP? Una \" Persona politicamente esposta \" è una persona fisica (individuo) a cui è o è stata affidata una funzione pubblica di rilievo e include i suoi parenti stretti o persone note per essere stretti collaboratori di tali persone, ma escludendo gli esponenti di medio/basso livello.","FAMILY_POSITION_IN_ANY_COUNTRY":"Qualche tuo parente stretto attualmente detiene o ha mai ricoperto cariche politiche, diplomatiche o governative in un paese? (Barrare la casella se la risposta è SÌ)"},"LITIGATION_INFORMATION":{"TITLE":"Contenzioso","LITIGATION":"Sei mai stato oggetto di indagini legali, ordinanze di tribunali, sentenze, procedimenti fallimentari, sanzioni penali (esclusi incidenti stradali minori)? (Barrare la casella se la risposta è SI)"},"MASTER_ACCOUNT_INFORMATION":{"TITLE":"Account principale","MASTER_ACCOUNT_CURRENCY":"Valuta account principale","ADDITIONAL_CURRENCIES":"Valute aggiuntive"},"FUNDS_INFORMATION":{"TITLE":"Fondi","SOURCE_OF_INITIAL_FUNDING":{"TITLE":"Origine del deposito iniziale","JURISDICTION":"Giurisdizione","AVERAGE_MONTHLY_INCOME":"Qual è il tuo reddito mensile medio?","PRIMARY_INCOME_SOURCE":"Indica la tua fonte di reddito principale","ORIGINAL_BANK_NAME":"Nome Banca d'origine","ORIGINAL_BANK_ADDRESS":"Indirizzo Banca d'origine","ACCOUNT_NAME":"Nome account","SIGNATORY":"Firmatario","HOW_FUNDS_GENERATED":"Descrivi con precisione come sono stati generati questi fondi"},"EXPECTED_TRANSFER_ACTIVITY":{"TITLE":"Attività di trasferimento prevista","AVERAGE_VALUE_OF_TRANSFER":"Valore medio di ogni trasferimento ({{currency}})","MAX_VALUE_OF_TRANSFER":"Valore massimo di ogni trasferimento ({{currency}})","MAIN_COUNTRIES_TO":"Paesi verso i quali saranno effettuati i trasferimenti","MAIN_COUNTRIES_FROM":"Paesi dai quali verranno ricevuti trasferimenti","PURPOSE_OF_ACCOUNT":" Scopo di questo account","AVERAGE_INCOMING_TRANSACTION":"Valore medio delle transazioni in entrata","PLANNED_MONTHLY_INCOMING_TURNOVER":"Fatturato mensile pianificato dei pagamenti in entrata utilizzando l'account {{vendorTitle}}","MONTHLY_INCOMING_FREQUENCY":"Frequenza media dei pagamenti in entrata","AVERAGE_OUTGOING_TRANSACTION":"Valore medio delle transazioni in uscita","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Fatturato mensile pianificato dei pagamenti in uscita utilizzando l'account {{vendorTitle}}","MONTHLY_OUTGOING_FREQUENCY":"Frequenza mensile pagamenti in uscita"},"RANGE":{"UP":"Fino a {{amountTo}} {{unit}}","FROM_TO":"Da {{amountFrom}} {{unit}} a {{amountTo}} {{unit}}","MORE":"Più di {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Fino a {{amountTo}}","FROM_TO":"Da {{amountFrom}} a {{amountTo}}","MORE":"Più di {{amountFrom}}"}},"INTRODUCER_INFORMATION":{"TITLE":"Sponsor/Rivenditore","INTRODUCER_NAME":"Nome Sponsor/Rivenditore","INTRODUCER_EMAIL":"Email Sponsor/Rivenditore"},"ABOUT_YOURSELF_INFORMATION":{"TITLE":"Parlaci di te","PRODUCTS":"Quali {{company}} prodotti/servizi hai intenzione di usare?","PRODUCTS_CUSTOM":"Peronalizza prodotti","REASONS":"Motivi","REASONS_CUSTOM":"Personalizza motivi","INFORMATION_SOURCE":"Fonti di informazione","INFORMATION_SOURCES_CUSTOM":"Personalizza fonti informazione","USA_CITIZEN":"Spuntando la casella dichiaro di NON essere un cittadino e / o residente fiscale degli USA."},"REQUIRED_INPUT":"Questo campo è obbligatorio!","MINIMUM_LENGTH":"La lunghezza minima è di {{value}} caratteri","MAXIMUM_LENGTH":"La lunghezza massima è di {{value}} caratteri"},"EDIT.BUTTON.NAME":"Modifica","HEADER":"Dettagli","UNAVAILABLE_CURRENCY":" non è al momento disponibile","SAVE.BUTTON.NAME":"Salva","SAVE_ALL.BUTTON.NAME":"Salva tutto","UPLOAD.BUTTON.NAME":"Carica","CANCEL.BUTTON.NAME":"Cancella","DISCARD.BUTTON.NAME":"Scarta","REMOVE.BUTTON.NAME":"Elimina","ADD_NEW.BUTTON.NAME":"Aggiungi nuovo","CHOSE.BUTTON.NAME":"Scegli file","UPLOAD.DOCUMENT.HEADER":"Carica documenti","OTHER":"Altro","CORPORATE":{"COMMON":{"FIRST_NAME":"Nome","LAST_NAME":"Cognome","DATE_OF_BIRTH":"Data di nascita","ATTORNEY_POWER_EXPIRE_DATE":"Data di scadenza della procura (se applicabile)","JOB_TITLE_OCCUPATION":"Lavoro / Occupazione","NIC_PASSPORT_ID":"Carta Identità/Passaporto No","IS_PEP":"Questa persona è una PEP o correlata ad una PEP?","TRUE":"Vero","FALSE":"Falso","NATIONALITY":"Nazionalità","SECOND_NATIONALITY":"Seconda cittadinanza","ADDRESS_LINE":"Indirizzo","COUNTRY":"Paese","COUNTY_REGION":"Provincia / Regione","CITY":"Città","ZIP_CODE":"CAP / ZIP code","RESULT_COUNTRY_SELECT":"Nessun risultato trovato","PHONE_NUMBER":"Numero di telefono","MOBILE":"Cellulare","LINKEDIN":"Linkedin","FACEBOOK":"Facebook","WEBSITE":"Website","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","NAME_OF_CORPORATE_SHAREHOLDER":"Nome del socio aziendale","LEGAL_DOCUMENTS":"Documenti legali","PERSONAL_INFORMATION":"Informazioni personali","COMPANY_INFORMATION":"Informazioni Azienda","COMPANY_NAME":"Nome Azienda","COUNTRY_OF_INCORPORATION":"Paese di costituzione","COMPANY_REGISTRATION_NUMBER":"Numero riferimento Azienda","COMPANY_ADDRESS":"Indirizzo Azienda (Facoltativo)","COMPANY_CONTACTS":"Contatti Azienda","HOME_ADDRESS":"Indirizzo di casa (Facoltativo)","CONTACTS":"Contatti","INDIVIDUAL":"Privato","CORPORATE":"Aziendale","IDENTITY_CONFIRMATION":"Conferma identità","YES":"Sì","NO":"No","PROOF_OF_ADDRESS":"Prova di recapito","OPTIONAL_ADDRESS":"Indirizzo facoltativo","INVALID_VALUE":"Valore non valido"},"BUSINESS_CUSTOMER_INFORMATION":{"TITLE":"informazioni Cliente Business","DATE_OF_REGISTRATION":"Data di registrazione","REGISTRATION_NUMBER":"Numero di registrazione","TRADING_NAME":"Denominazione commerciale","TAX_IDENTIFICATION_NUMBER":"Partita IVA","BUSINESS_ACTIVITIES":"Attività aziendali","SEARCH_BUSINESS_ACTIVITIES":"Cerca attività aziendali"},"REGISTERED_OFFICE_ADDRESS":{"TITLE":"Indirizzo sede legale"},"OFFICIAL_BUSINESS_LOCATION":{"TITLE":"Sede ufficiale attività","PROOF_OF_ADDRESS":"Documenti per prova di recapito"},"CONTACT_INFORMATION":{"TITLE":"Informazioni di contatto","PHONE_NUMBER":"Numero di telefono"},"STATEMENT_OF_AFFAIRS":{"TITLE":"Dichiarazione di attività","SPECIFIC_COUNTRIES":"Specifici Paesi per operazioni su mercati targhettizzati","NATURE_OF_BUSINESS":"Natura del business"},"INITIAL_DEPOSITS":{"TITLE":"Origine die fondi","SOURCE_OF_INITIAL_DEPOSIT":"Descrivi l'origine del deposito iniziale","ORIGINATING_BANK_JURISDICTION":"Giurisdizione della Banca di origine","DESCRIBE_FUNDS_WERE_GENERATED":"Descrivi con precisione come sono stati generati questi fondi","AMOUNT":"Importo","CURRENCY":"Valuta","ACCOUNT_NAME":"Nome account"},"EXPECTED_TURNOVER":{"TITLE":"Fatturato previsto","AVERAGE_INCOMING_TRANSACTION":"Valore / dimensione medio della transazione in entrata","PLANNED_MONTHLY_INCOMING_TURNOVER":"Fatturato mensile previsto dei pagamenti in entrata utilizzando l'account {{vendorTitle}}","MONTHLY_INCOMING_FREQUENCY":"Frequenza mensile dei pagamenti in entrata","AVERAGE_OUTGOING_TRANSACTION":"Valore / dimensione medio della transazione in uscita","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Fatturato mensile previsto dei pagamenti in uscita sull'account {{vendorTitle}}","MONTHLY_OUTGOING_FREQUENCY":"Frequenza mensile dei pagamenti in uscita","RANGE":{"UP":"Fino a {{amountTo}} {{unit}}","FROM_TO":"Da {{amountFrom}} {{unit}} a {{amountTo}} {{unit}}","MORE":"Più di {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Fino a {{amountTo}}","FROM_TO":"Da {{amountFrom}} to {{amountTo}}","MORE":"Più di {{amountFrom}}"},"MAIN_SUPPLIERS":"Controparti principali per i pagamenti in uscita (nome / giurisdizione)","MAIN_CLIENTS":"Controparti principali per i pagamenti in entrata (nome / giurisdizione)"},"AUTHORISED_SIGNATORY":{"TITLE":"Firmatario autorizzato","SAVE_ALL":"Salva tutto","DETAILS":"Dettagli firmatario autorizzato","ADDRESS":"Indirizzo firmatario autorizzato","CONTACTS":"Contatti firmatario autorizzato","PASSPORT":"Passaporto","SELFIE":"Selfie con Carta Identità"},"DIRECTORS":{"TITLE":"Amministratori dell'Azienda","DIRECTOR_TYPE":"Tipo Amministratore","NIC_PASSPORT_ID":"Passaporto/Carta Identità No"},"SHAREHOLDERS":{"TITLE":"Soci","SHARE_NUMBER":"Quota: {{share}}%","SHARE":"Quota: %","EMPTY":"Siamo spiacenti! Non ci sono soci.","SHAREHOLDER_TYPE":"Tipo di socio","SHAREHOLDER_SUM_ERROR":"La somma delle % di quote deve essere uguale a 100%","NIC_PASSPORT_ID":"Passaporto/Carta Identità No."},"INTRODUCER":{"TITLE":"Sponsor/Rivenditore","INTRODUCER_NAME":"Nome Sponsor/Rivenditore","INTRODUCER_EMAIL":"Email Sponsor/Rivenditore"},"ACCOUNT_CURRENCIES":{"TITLE":"Valute account","MASTER_ACCOUNT_CURRENCY":"Valuta account principale","ADDITIONAL_CURRENCIES":"Valute aggiuntive"},"USAGE_AND_REFERRAL":{"TITLE":"Utilizzo e referral","WHAT_PRODUCTS_SERVICES":"Quali {{company}} prodotti/servizi avete intenzione di utilizzare?","REASON_FOR_CHOOSING":"Motivazione della scelta {{company}}","SOURCE_OF_INFORMATION":"Fonte delle informazioni circa {{company}}?"}}},"TAB.DOCUMENTS":{"HEADER":"Documentt","IDENTITY_CONFIRMATION":"Conferma identità","LEGAL_DOCUMENTS":"Documenti legali","SELFIE":"Selfie","PROOF_OF_ADDRESS":"Prova di recapito","ARCHIVE_BUTTON":"Salva archivio","NO_DOCUMENTS":"Siamo spiacenti! Non c'è alcun allegato."},"CUSTOM_REASON":"Personalizza motivo","TABLE_REASONS":{"HEADER":{"NAME":"Motivo"},"EMPTY":"Siamo spiacenti! Non ci sono motivi."},"TAB_MANUAL_REVIEW":{"TITLE":"Dettagli revisione manuale"}},"PROCESS":{"CONFIRM.TITLE":"Conferma richiesta di processo","CONFIRM.MESSAGE":"Questo cliente verrà spostato allo stato di <b> elaborazione </b>, sei sicuro di voler continuare?","CONFIRM.BUTTON":"Conferma"}},"ON_HOLD":{"TITLE":"Applicazioni/In attesa","NOT_FOUND":"Siamo spiacenti! Non ci sono applicazioni nel sistema.","DETAIL":{"TITLE":"Applicazione/In attesa/ID:{{id}}","TAB.DETAILS":{"PRIVATE":{"APPLICANT_INFORMATION":{"TITLE":"Richiedente","PERSONAL_DETAILS":{"TITLE":"Dettagli personali","FIRST_NAME":"Nome","LAST_NAME":"Cognome"},"NATIONALITY":"Nazionalità","PASSPORT":"Carta Identità / Passaporto No.","PLACE_OF_ISSUE":"Autorità emittente","DATE":{"TITLE":"Data di emissione/scadenza","ISSUE":"Data di emissione","EXPIRY":"Data di scadenza","EXPIRY_WARNING":"Si prega di notare che il passaporto è prossimo alla scadenza."},"SECOND_NATIONALITY":"Seconda cittadinanza","RESIDENTIAL_ADDRESS":{"TITLE":"Indirizzo di casa","RESIDENTIAL_POSTAL_ADDRESS":"Indirizzo di casa","RESIDENTIAL_POSTAL_CITY":"Città","RESIDENTIAL_POSTAL_COUNTY_OR_REGION":"Provincia o regione","RESIDENTIAL_COUNTRY":"Paese","RESIDENTIAL_ZIP_CODE":"CAP / ZIP code"},"POSTAL_ADDRESS":{"TITLE":"Indirizzo postale","POSTAL_ADDRESS":"Indirizzo postale","POSTAL_CITY":"Città","POSTAL_COUNTY_OR_REGION":"Provincia o regione","COUNTRY":"Paese","ZIP_CODE":"CAP / ZIP code"},"PHONE_NUMBER":"Numero di telefono","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","BIRTH_DATE":"Data di nascita","PLACE_OF_BIRTH":"Luogo di nascita (Paese)","TAX_IDENTIFICATION_NUMBER":"P.IVA/Codice fiscale","TAX_COUNTRY":"Paese contribuzione fiscale","FAX_NUMBER":"Numero di fax","FACEBOOK_PROFILE":"Profilo Facebook","LINKEDIN":"LinkedIn","OTHER":"Altro","ID_OR_PASSPORT_ATTACHMENT_ITEMS":"Elementi allegati Carta identità o Passaporto","PASSPORT_SELFIE_ATTACHMENT_ITEMS":"Elementi allegati selfie Passaporto","ADDRESS_ATTACHMENT_ITEMS":"Elementi allegati indirizzo","SAVE_ALL":"Salva tutto","UPLOAD":{"TITLE":"Carica","ERROR":{"MAX_SIZE":"La dimensione del file supera il valore consentito!","FILE_ALREADY_CONFIRMED":"File già presente nel sistema!","FILE_NOT_FOUND":"File non trovato!","UNSUPPORTED_FORMAT":"Formato di file non supportato!"}},"FILTER":{"NOT_FOUND":{"NATIONALITY_SELECT":"Non ci sono Paesi disponibili","SECOND_NATIONALITY_SELECT":"Non ci sono Paesi disponibili","COUNTRY_SELECT":"Non ci sono Paesi disponibili","RESULT_COUNTRY_SELECT":"Nessun risultato trovato","JURISDICTION":"Non ci sono Giurisdizioni disponibili"}}},"EMPLOYMENT_INFORMATION":{"TITLE":"Impiego","PRESENT_OCCUPATION":"Attuale occupazione","EMPLOYMENT_DETAILS":{"TITLE":"Dettagli impiego","NAME":"Nome del datore di lavoro/Nome dell'attività","ADDRESS":{"TITLE":"Indirizzo datore di lavoro","POSTAL_ADDRESS":"Indirizzo ufficio datore di lavoro","POSTAL_CITY":"Città","POSTAL_COUNTY_OR_REGION":"Provincia o regione","COUNTRY":"Paese","ZIP_CODE":"CAP / ZIP code"},"BUSINESS_SECTOR":"Nome Attività aziendale","YEARS_IN_EMPLOYMENT":"Numero anni di lavoro/attività"}},"PEP_INFORMATION":{"TITLE":"PEP","POSITION_IN_ANY_COUNTRY":"Sei un PEP o sei collegato a un PEP? Una \" Persona politicamente esposta \" è una persona fisica (individuo) a cui è o è stata affidata una funzione pubblica di rilievo e include i suoi parenti stretti o persone note per essere stretti collaboratori di tali persone, ma escludendo gli esponenti di medio/basso livello.","FAMILY_POSITION_IN_ANY_COUNTRY":"Qualche tuo parente stretto attualmente detiene o ha mai ricoperto cariche politiche, diplomatiche o governative in un paese? (Barrare la casella se la risposta è SÌ)"},"LITIGATION_INFORMATION":{"TITLE":"Contenzioso","LITIGATION":"Sei mai stato oggetto di indagini legali, ordinanze di tribunali, sentenze, procedimenti fallimentari, sanzioni penali (esclusi incidenti stradali minori)? (Barrare la casella se la risposta è SI)"},"MASTER_ACCOUNT_INFORMATION":{"TITLE":"Account principale","MASTER_ACCOUNT_CURRENCY":"Valuta account principale","ADDITIONAL_CURRENCIES":"Valute aggiuntive"},"FUNDS_INFORMATION":{"TITLE":"Fondi","SOURCE_OF_INITIAL_FUNDING":{"TITLE":"Origine del deposito iniziale","JURISDICTION":"Giurisdizione","AVERAGE_MONTHLY_INCOME":"Qual è il tuo reddito mensile medio?","PRIMARY_INCOME_SOURCE":"Indica la tua fonte di reddito principale","ORIGINAL_BANK_NAME":"Nome Banca d'origine","ORIGINAL_BANK_ADDRESS":"Indirizzo Banca d'origine","ACCOUNT_NAME":"Nome account","SIGNATORY":"Firmatario","HOW_FUNDS_GENERATED":"Descrivi con precisione come sono stati generati questi fondi"},"EXPECTED_TRANSFER_ACTIVITY":{"TITLE":"Attività di trasferimento prevista","AVERAGE_VALUE_OF_TRANSFER":"Valore medio di ogni trasferimento ({{currency}})","MAX_VALUE_OF_TRANSFER":"Valore massimo di ogni trasferimento ({{currency}})","MAIN_COUNTRIES_TO":"Paesi verso i quali saranno effettuati i trasferimenti","MAIN_COUNTRIES_FROM":"Paesi dai quali verranno ricevuti trasferimenti","PURPOSE_OF_ACCOUNT":" Scopo di questo account","AVERAGE_INCOMING_TRANSACTION":"Valore medio delle transazioni in entrata","PLANNED_MONTHLY_INCOMING_TURNOVER":"Fatturato mensile pianificato dei pagamenti in entrata utilizzando l'account {{vendorTitle}}","MONTHLY_INCOMING_FREQUENCY":"Frequenza media dei pagamenti in entrata","AVERAGE_OUTGOING_TRANSACTION":"Valore medio delle transazioni in uscita","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Fatturato mensile pianificato dei pagamenti in uscita utilizzando l'account {{vendorTitle}}","MONTHLY_OUTGOING_FREQUENCY":"Frequenza mensile pagamenti in uscita"},"RANGE":{"UP":"Fino a {{amountTo}} {{unit}}","FROM_TO":"Da {{amountFrom}} {{unit}} a {{amountTo}} {{unit}}","MORE":"Più di {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Fino a {{amountTo}}","FROM_TO":"Da {{amountFrom}} a {{amountTo}}","MORE":"Più di {{amountFrom}}"}},"INTRODUCER_INFORMATION":{"TITLE":"Sponsor/Rivenditore","INTRODUCER_NAME":"Nome Sponsor/Rivenditore","INTRODUCER_EMAIL":"Email Sponsor/Rivenditore"},"ABOUT_YOURSELF_INFORMATION":{"TITLE":"Parlaci di te","PRODUCTS":"Quali {{company}} prodotti/servizi hai intenzione di usare?","PRODUCTS_CUSTOM":"Peronalizza prodotti","REASONS":"Motivi","REASONS_CUSTOM":"Personalizza motivi","INFORMATION_SOURCE":"Fonti di informazione","INFORMATION_SOURCES_CUSTOM":"Personalizza fonti informazione","USA_CITIZEN":"Spuntando la casella dichiaro di NON essere un cittadino e / o residente fiscale degli USA."},"REQUIRED_INPUT":"Questo campo è obbligatorio!","MINIMUM_LENGTH":"La lunghezza minima è di {{value}} caratteri","MAXIMUM_LENGTH":"La lunghezza massima è di {{value}} caratteri"},"EDIT.BUTTON.NAME":"Modifica","HEADER":"Dettagli","UNAVAILABLE_CURRENCY":" non è al momento disponibile","SAVE.BUTTON.NAME":"Salva","SAVE_ALL.BUTTON.NAME":"Salva tutto","UPLOAD.BUTTON.NAME":"Carica","CANCEL.BUTTON.NAME":"Cancella","DISCARD.BUTTON.NAME":"Scarta","REMOVE.BUTTON.NAME":"Elimina","ADD_NEW.BUTTON.NAME":"Aggiungi nuovo","CHOSE.BUTTON.NAME":"Scegli file","UPLOAD.DOCUMENT.HEADER":"Carica documenti","OTHER":"Altro","CORPORATE":{"COMMON":{"FIRST_NAME":"Nome","LAST_NAME":"Cognome","DATE_OF_BIRTH":"Data di nascita","ATTORNEY_POWER_EXPIRE_DATE":"Data di scadenza della procura (se applicabile)","JOB_TITLE_OCCUPATION":"Lavoro / Occupazione","NIC_PASSPORT_ID":"Carta Identità/Passaporto No","IS_PEP":"Questa persona è una PEP o correlata ad una PEP?","TRUE":"Vero","FALSE":"Falso","NATIONALITY":"Nazionalità","SECOND_NATIONALITY":"Seconda cittadinanza","ADDRESS_LINE":"Indirizzo","COUNTRY":"Paese","COUNTY_REGION":"Provincia / Regione","CITY":"Città","ZIP_CODE":"CAP / ZIP code","RESULT_COUNTRY_SELECT":"Nessun risultato trovato","PHONE_NUMBER":"Numero di telefono","MOBILE":"Cellulare","LINKEDIN":"Linkedin","FACEBOOK":"Facebook","WEBSITE":"Website","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","NAME_OF_CORPORATE_SHAREHOLDER":"Nome del socio aziendale","LEGAL_DOCUMENTS":"Documenti legali","PERSONAL_INFORMATION":"Informazioni personali","COMPANY_INFORMATION":"Informazioni Azienda","COMPANY_NAME":"Nome Azienda","COUNTRY_OF_INCORPORATION":"Paese di costituzione","COMPANY_REGISTRATION_NUMBER":"Numero riferimento Azienda","COMPANY_ADDRESS":"Indirizzo Azienda (Facoltativo)","COMPANY_CONTACTS":"Contatti Azienda","HOME_ADDRESS":"Indirizzo di casa (Facoltativo)","CONTACTS":"Contatti","INDIVIDUAL":"Privato","CORPORATE":"Aziendale","IDENTITY_CONFIRMATION":"Conferma identità","YES":"Sì","NO":"No","PROOF_OF_ADDRESS":"Prova di recapito","OPTIONAL_ADDRESS":"Indirizzo facoltativo","INVALID_VALUE":"Valore non valido"},"BUSINESS_CUSTOMER_INFORMATION":{"TITLE":"informazioni Cliente Business","DATE_OF_REGISTRATION":"Data di registrazione","REGISTRATION_NUMBER":"Numero di registrazione","TRADING_NAME":"Denominazione commerciale","TAX_IDENTIFICATION_NUMBER":"Partita IVA","BUSINESS_ACTIVITIES":"Attività aziendali","SEARCH_BUSINESS_ACTIVITIES":"Cerca attività aziendali"},"REGISTERED_OFFICE_ADDRESS":{"TITLE":"Indirizzo sede legale"},"OFFICIAL_BUSINESS_LOCATION":{"TITLE":"Sede ufficiale attività","PROOF_OF_ADDRESS":"Documenti per prova di recapito"},"CONTACT_INFORMATION":{"TITLE":"Informazioni di contatto","PHONE_NUMBER":"Numero di telefono"},"STATEMENT_OF_AFFAIRS":{"TITLE":"Dichiarazione di attività","SPECIFIC_COUNTRIES":"Specifici Paesi per operazioni su mercati targhettizzati","NATURE_OF_BUSINESS":"Natura del business"},"INITIAL_DEPOSITS":{"TITLE":"Origine die fondi","SOURCE_OF_INITIAL_DEPOSIT":"Descrivi l'origine del deposito iniziale","ORIGINATING_BANK_JURISDICTION":"Giurisdizione della Banca di origine","DESCRIBE_FUNDS_WERE_GENERATED":"Descrivi con precisione come sono stati generati questi fondi","AMOUNT":"Importo","CURRENCY":"Valuta","ACCOUNT_NAME":"Nome account"},"EXPECTED_TURNOVER":{"TITLE":"Fatturato previsto","AVERAGE_INCOMING_TRANSACTION":"Valore / dimensione medio della transazione in entrata","PLANNED_MONTHLY_INCOMING_TURNOVER":"Fatturato mensile previsto dei pagamenti in entrata utilizzando l'account {{vendorTitle}}","MONTHLY_INCOMING_FREQUENCY":"Frequenza mensile dei pagamenti in entrata","AVERAGE_OUTGOING_TRANSACTION":"Valore / dimensione medio della transazione in uscita","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Fatturato mensile previsto dei pagamenti in uscita sull'account {{vendorTitle}}","MONTHLY_OUTGOING_FREQUENCY":"Frequenza mensile dei pagamenti in uscita","RANGE":{"UP":"Fino a {{amountTo}} {{unit}}","FROM_TO":"Da {{amountFrom}} {{unit}} a {{amountTo}} {{unit}}","MORE":"Più di {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Fino a {{amountTo}}","FROM_TO":"Da {{amountFrom}} to {{amountTo}}","MORE":"Più di {{amountFrom}}"},"MAIN_SUPPLIERS":"Controparti principali per i pagamenti in uscita (nome / giurisdizione)","MAIN_CLIENTS":"Controparti principali per i pagamenti in entrata (nome / giurisdizione)"},"AUTHORISED_SIGNATORY":{"TITLE":"Firmatario autorizzato","SAVE_ALL":"Salva tutto","DETAILS":"Dettagli firmatario autorizzato","ADDRESS":"Indirizzo firmatario autorizzato","CONTACTS":"Contatti firmatario autorizzato","PASSPORT":"Passaporto","SELFIE":"Selfie con Carta Identità"},"DIRECTORS":{"TITLE":"Amministratori dell'Azienda","DIRECTOR_TYPE":"Tipo Amministratore","NIC_PASSPORT_ID":"Passaporto/Carta Identità No"},"SHAREHOLDERS":{"TITLE":"Soci","SHARE_NUMBER":"Quota: {{share}}%","SHARE":"Quota: %","EMPTY":"Siamo spiacenti! Non ci sono soci.","SHAREHOLDER_TYPE":"Tipo di socio","SHAREHOLDER_SUM_ERROR":"La somma delle % di quote deve essere uguale a 100%","NIC_PASSPORT_ID":"Passaporto/Carta Identità No."},"INTRODUCER":{"TITLE":"Sponsor/Rivenditore","INTRODUCER_NAME":"Nome Sponsor/Rivenditore","INTRODUCER_EMAIL":"Email Sponsor/Rivenditore"},"ACCOUNT_CURRENCIES":{"TITLE":"Valute account","MASTER_ACCOUNT_CURRENCY":"Valuta account principale","ADDITIONAL_CURRENCIES":"Valute aggiuntive"},"USAGE_AND_REFERRAL":{"TITLE":"Utilizzo e referral","WHAT_PRODUCTS_SERVICES":"Quali {{company}} prodotti/servizi avete intenzione di utilizzare?","REASON_FOR_CHOOSING":"Motivazione della scelta {{company}}","SOURCE_OF_INFORMATION":"Fonte delle informazioni circa {{company}}?"}}},"TAB.DOCUMENTS":{"HEADER":"Documenti","IDENTITY_CONFIRMATION":"Conferma identità","LEGAL_DOCUMENTS":"Documenti legali","SELFIE":"Selfie","PROOF_OF_ADDRESS":"Prova di recapito","ARCHIVE_BUTTON":"Salva archivio","NO_DOCUMENTS":"Siamo spiacenti! Non c'è alcun allegato."},"CUSTOM_REASON":"Personalizza motivo","TABLE_REASONS":{"HEADER":{"NAME":"Motivo"},"EMPTY":"Siamo spiacenti! Non ci sono motivi."},"TAB_MANUAL_REVIEW":{"TITLE":"Dettagli revisione manuale"}},"PROCESS":{"CONFIRM.TITLE":"Conferma richiesta di processo","CONFIRM.MESSAGE":"Questo cliente verrà spostato allo stato di <b> elaborazione </b>, sei sicuro di voler continuare?","CONFIRM.BUTTON":"Conferma"},"APPROVE":{"HEADER":"Approvare la richiesta di registrazione da {{name}}?","HEADER_WITHOUT_PROFILE":"Lo stato del profilo è cambiato.","RISK":{"TITLE":"Livello di rischio","PLACEHOLDER":"Seleziona"},"TARIFF":{"TITLE":"Tariffa","PLACEHOLDER":"Seleziona","WHITELABEL_TITLE":"Whitelabel tariffa"},"MIN_TOTAL_ASSET":{"TITLE":"Min total asset","ABOUT":"Min total asset è pari a EUR"},"BANK":{"TITLE":"Banca","PLACEHOLDER":"Seleziona","VALIDATION":{"EMPTY_LIST":"Nessuna banca assegnata con {{currency_code}} al momento"}},"IBAN":{"TITLE":"IBAN","PLACEHOLDER":"Inserire IBAN","IBAN_WILL_BE_GENERATED":"IBAN sarà generato dopo la conferma"},"LIQUIDITY":{"TITLE":"Account di liquidità","PLACEHOLDER":"Seleziona"},"PROFILE_KIND":{"TITLE":"Tipo profilo","PLACEHOLDER":"Seleziona"},"PRODUCT_CODE":{"TITLE":"Product code","PLACEHOLDER":"Select"},"INTRODUCER_NAME":{"TITLE":"Nome sponsor","PLACEHOLDER":"Seleziona","NOT_FOUND":"Siamo spiacenti! Non è stato trovato alcuno sponsor! Si prega di provare con un altro criterio di ricerca!"},"SUCCESS":{"TITLE":"Registrazione approvata!","SECURITY_CODE":{"TITLE":"Codice di sicurezza","TEXT":"Il codice di sicurezza per questo account è stato generato. Copialo ed invialo al cliente."},"PASSWORD":{"TITLE":"Link per impostare una password","TEXT":"Per impostare una password, copia questo link ed invialo al cliente."}}}},"ARCHIVED":{"TITLE":"Applicazioni/Archiviate","NOT_FOUND":"Siamo spiacenti! Non ci sono applicazioni presenti nel sistema.","DETAIL":{"TITLE":"Applicazione/Archiviata/ID:{{id}}","TAB.DETAILS":{"PRIVATE":{"APPLICANT_INFORMATION":{"TITLE":"Richiedente","PERSONAL_DETAILS":{"TITLE":"Dettagli personali","FIRST_NAME":"Nome","LAST_NAME":"Cognome"},"NATIONALITY":"Nazionalità","PASSPORT":"Carta Identità / Passaporto No.","PLACE_OF_ISSUE":"Autorità emittente","DATE":{"TITLE":"Data di emissione/scadenza","ISSUE":"Data di emissione","EXPIRY":"Data di scadenza","EXPIRY_WARNING":"Si prega di notare che il passaporto è prossimo alla scadenza."},"SECOND_NATIONALITY":"Seconda cittadinanza","RESIDENTIAL_ADDRESS":{"TITLE":"Indirizzo di casa","RESIDENTIAL_POSTAL_ADDRESS":"Indirizzo di casa","RESIDENTIAL_POSTAL_CITY":"Città","RESIDENTIAL_POSTAL_COUNTY_OR_REGION":"Provincia o regione","RESIDENTIAL_COUNTRY":"Paese","RESIDENTIAL_ZIP_CODE":"CAP / ZIP code"},"POSTAL_ADDRESS":{"TITLE":"Indirizzo postale","POSTAL_ADDRESS":"Indirizzo postale","POSTAL_CITY":"Città","POSTAL_COUNTY_OR_REGION":"Provincia o regione","COUNTRY":"Paese","ZIP_CODE":"CAP / ZIP code"},"PHONE_NUMBER":"Numero di telefono","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","BIRTH_DATE":"Data di nascita","PLACE_OF_BIRTH":"Luogo di nascita (Paese)","TAX_IDENTIFICATION_NUMBER":"P.IVA/Codice fiscale","TAX_COUNTRY":"Paese contribuzione fiscale","FAX_NUMBER":"Numero di fax","FACEBOOK_PROFILE":"Profilo Facebook","LINKEDIN":"LinkedIn","OTHER":"Altro","ID_OR_PASSPORT_ATTACHMENT_ITEMS":"Elementi allegati Carta identità o Passaporto","PASSPORT_SELFIE_ATTACHMENT_ITEMS":"Elementi allegati selfie Passaporto","ADDRESS_ATTACHMENT_ITEMS":"Elementi allegati indirizzo","SAVE_ALL":"Salva tutto","UPLOAD":{"TITLE":"Carica","ERROR":{"MAX_SIZE":"La dimensione del file supera il valore consentito!","FILE_ALREADY_CONFIRMED":"File già presente nel sistema!","FILE_NOT_FOUND":"File non trovato!","UNSUPPORTED_FORMAT":"Formato di file non supportato!"}},"FILTER":{"NOT_FOUND":{"NATIONALITY_SELECT":"Non ci sono Paesi disponibili","SECOND_NATIONALITY_SELECT":"Non ci sono Paesi disponibili","COUNTRY_SELECT":"Non ci sono Paesi disponibili","RESULT_COUNTRY_SELECT":"Nessun risultato trovato","JURISDICTION":"Non ci sono Giurisdizioni disponibili"}}},"EMPLOYMENT_INFORMATION":{"TITLE":"Impiego","PRESENT_OCCUPATION":"Attuale occupazione","EMPLOYMENT_DETAILS":{"TITLE":"Dettagli impiego","NAME":"Nome del datore di lavoro/Nome dell'attività","ADDRESS":{"TITLE":"Indirizzo datore di lavoro","POSTAL_ADDRESS":"Indirizzo ufficio datore di lavoro","POSTAL_CITY":"Città","POSTAL_COUNTY_OR_REGION":"Provincia o regione","COUNTRY":"Paese","ZIP_CODE":"CAP / ZIP code"},"BUSINESS_SECTOR":"Nome Attività aziendale","YEARS_IN_EMPLOYMENT":"Numero anni di lavoro/attività"}},"PEP_INFORMATION":{"TITLE":"PEP","POSITION_IN_ANY_COUNTRY":"Sei un PEP o sei collegato a un PEP? Una \" Persona politicamente esposta \" è una persona fisica (individuo) a cui è o è stata affidata una funzione pubblica di rilievo e include i suoi parenti stretti o persone note per essere stretti collaboratori di tali persone, ma escludendo gli esponenti di medio/basso livello.","FAMILY_POSITION_IN_ANY_COUNTRY":"Qualche tuo parente stretto attualmente detiene o ha mai ricoperto cariche politiche, diplomatiche o governative in un paese? (Barrare la casella se la risposta è SÌ)"},"LITIGATION_INFORMATION":{"TITLE":"Contenzioso","LITIGATION":"Sei mai stato oggetto di indagini legali, ordinanze di tribunali, sentenze, procedimenti fallimentari, sanzioni penali (esclusi incidenti stradali minori)? (Barrare la casella se la risposta è SI)"},"MASTER_ACCOUNT_INFORMATION":{"TITLE":"Account principale","MASTER_ACCOUNT_CURRENCY":"Valuta account principale","ADDITIONAL_CURRENCIES":"Valute aggiuntive"},"FUNDS_INFORMATION":{"TITLE":"Fondi","SOURCE_OF_INITIAL_FUNDING":{"TITLE":"Origine del deposito iniziale","JURISDICTION":"Giurisdizione","AVERAGE_MONTHLY_INCOME":"Qual è il tuo reddito mensile medio?","PRIMARY_INCOME_SOURCE":"Indica la tua fonte di reddito principale","ORIGINAL_BANK_NAME":"Nome Banca d'origine","ORIGINAL_BANK_ADDRESS":"Indirizzo Banca d'origine","ACCOUNT_NAME":"Nome account","SIGNATORY":"Firmatario","HOW_FUNDS_GENERATED":"Descrivi con precisione come sono stati generati questi fondi"},"EXPECTED_TRANSFER_ACTIVITY":{"TITLE":"Attività di trasferimento prevista","AVERAGE_VALUE_OF_TRANSFER":"Valore medio di ogni trasferimento ({{currency}})","MAX_VALUE_OF_TRANSFER":"Valore massimo di ogni trasferimento ({{currency}})","MAIN_COUNTRIES_TO":"Paesi verso i quali saranno effettuati i trasferimenti","MAIN_COUNTRIES_FROM":"Paesi dai quali verranno ricevuti trasferimenti","PURPOSE_OF_ACCOUNT":" Scopo di questo account","AVERAGE_INCOMING_TRANSACTION":"Valore medio delle transazioni in entrata","PLANNED_MONTHLY_INCOMING_TURNOVER":"Fatturato mensile pianificato dei pagamenti in entrata utilizzando l'account {{vendorTitle}}","MONTHLY_INCOMING_FREQUENCY":"Frequenza media dei pagamenti in entrata","AVERAGE_OUTGOING_TRANSACTION":"Valore medio delle transazioni in uscita","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Fatturato mensile pianificato dei pagamenti in uscita utilizzando l'account {{vendorTitle}}","MONTHLY_OUTGOING_FREQUENCY":"Frequenza mensile pagamenti in uscita"},"RANGE":{"UP":"Fino a {{amountTo}} {{unit}}","FROM_TO":"Da {{amountFrom}} {{unit}} a {{amountTo}} {{unit}}","MORE":"Più di {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Fino a {{amountTo}}","FROM_TO":"Da {{amountFrom}} a {{amountTo}}","MORE":"Più di {{amountFrom}}"}},"INTRODUCER_INFORMATION":{"TITLE":"Sponsor/Rivenditore","INTRODUCER_NAME":"Nome Sponsor/Rivenditore","INTRODUCER_EMAIL":"Email Sponsor/Rivenditore"},"ABOUT_YOURSELF_INFORMATION":{"TITLE":"Parlaci di te","PRODUCTS":"Quali {{company}} prodotti/servizi hai intenzione di usare?","PRODUCTS_CUSTOM":"Peronalizza prodotti","REASONS":"Motivi","REASONS_CUSTOM":"Personalizza motivi","INFORMATION_SOURCE":"Fonti di informazione","INFORMATION_SOURCES_CUSTOM":"Personalizza fonti informazione","USA_CITIZEN":"Spuntando la casella dichiaro di NON essere un cittadino e / o residente fiscale degli USA."},"REQUIRED_INPUT":"Questo campo è obbligatorio!","MINIMUM_LENGTH":"La lunghezza minima è di {{value}} caratteri","MAXIMUM_LENGTH":"La lunghezza massima è di {{value}} caratteri"},"EDIT.BUTTON.NAME":"Modifica","HEADER":"Dettagli","UNAVAILABLE_CURRENCY":" non è al momento disponibile","SAVE.BUTTON.NAME":"Salva","SAVE_ALL.BUTTON.NAME":"Salva tutto","UPLOAD.BUTTON.NAME":"Carica","CANCEL.BUTTON.NAME":"Cancella","DISCARD.BUTTON.NAME":"Scarta","REMOVE.BUTTON.NAME":"Elimina","ADD_NEW.BUTTON.NAME":"Aggiungi nuovo","CHOSE.BUTTON.NAME":"Scegli file","UPLOAD.DOCUMENT.HEADER":"Carica documenti","OTHER":"Altro","CORPORATE":{"COMMON":{"FIRST_NAME":"Nome","LAST_NAME":"Cognome","DATE_OF_BIRTH":"Data di nascita","ATTORNEY_POWER_EXPIRE_DATE":"Data di scadenza della procura (se applicabile)","JOB_TITLE_OCCUPATION":"Lavoro / Occupazione","NIC_PASSPORT_ID":"Carta Identità/Passaporto No","IS_PEP":"Questa persona è una PEP o correlata ad una PEP?","TRUE":"Vero","FALSE":"Falso","NATIONALITY":"Nazionalità","SECOND_NATIONALITY":"Seconda cittadinanza","ADDRESS_LINE":"Indirizzo","COUNTRY":"Paese","COUNTY_REGION":"Provincia / Regione","CITY":"Città","ZIP_CODE":"CAP / ZIP code","RESULT_COUNTRY_SELECT":"Nessun risultato trovato","PHONE_NUMBER":"Numero di telefono","MOBILE":"Cellulare","LINKEDIN":"Linkedin","FACEBOOK":"Facebook","WEBSITE":"Website","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","NAME_OF_CORPORATE_SHAREHOLDER":"Nome del socio aziendale","LEGAL_DOCUMENTS":"Documenti legali","PERSONAL_INFORMATION":"Informazioni personali","COMPANY_INFORMATION":"Informazioni Azienda","COMPANY_NAME":"Nome Azienda","COUNTRY_OF_INCORPORATION":"Paese di costituzione","COMPANY_REGISTRATION_NUMBER":"Numero riferimento Azienda","COMPANY_ADDRESS":"Indirizzo Azienda (Facoltativo)","COMPANY_CONTACTS":"Contatti Azienda","HOME_ADDRESS":"Indirizzo di casa (Facoltativo)","CONTACTS":"Contatti","INDIVIDUAL":"Privato","CORPORATE":"Aziendale","IDENTITY_CONFIRMATION":"Conferma identità","YES":"Sì","NO":"No","PROOF_OF_ADDRESS":"Prova di recapito","OPTIONAL_ADDRESS":"Indirizzo facoltativo","INVALID_VALUE":"Valore non valido"},"BUSINESS_CUSTOMER_INFORMATION":{"TITLE":"Informazioni Cliente Business","DATE_OF_REGISTRATION":"Data di registrazione","REGISTRATION_NUMBER":"Numero di registrazione","TRADING_NAME":"Denominazione commerciale","TAX_IDENTIFICATION_NUMBER":"Partita IVA","BUSINESS_ACTIVITIES":"Attività aziendali","SEARCH_BUSINESS_ACTIVITIES":"Cerca attività aziendali"},"REGISTERED_OFFICE_ADDRESS":{"TITLE":"Indirizzo sede legale"},"OFFICIAL_BUSINESS_LOCATION":{"TITLE":"Sede ufficiale attività","PROOF_OF_ADDRESS":"Documenti per prova di recapito"},"CONTACT_INFORMATION":{"TITLE":"Informazioni di contatto","PHONE_NUMBER":"Numero di telefono"},"STATEMENT_OF_AFFAIRS":{"TITLE":"Dichiarazione di attività","SPECIFIC_COUNTRIES":"Specifici Paesi per operazioni su mercati targhettizzati","NATURE_OF_BUSINESS":"Natura del business"},"INITIAL_DEPOSITS":{"TITLE":"Origine die fondi","SOURCE_OF_INITIAL_DEPOSIT":"Descrivi l'origine del deposito iniziale","ORIGINATING_BANK_JURISDICTION":"Giurisdizione della Banca di origine","DESCRIBE_FUNDS_WERE_GENERATED":"Descrivi con precisione come sono stati generati questi fondi","AMOUNT":"Importo","CURRENCY":"Valuta","ACCOUNT_NAME":"Nome account"},"EXPECTED_TURNOVER":{"TITLE":"Fatturato previsto","AVERAGE_INCOMING_TRANSACTION":"Valore / dimensione medio della transazione in entrata","PLANNED_MONTHLY_INCOMING_TURNOVER":"Fatturato mensile previsto dei pagamenti in entrata utilizzando l'account {{vendorTitle}}","MONTHLY_INCOMING_FREQUENCY":"Frequenza mensile dei pagamenti in entrata","AVERAGE_OUTGOING_TRANSACTION":"Valore / dimensione medio della transazione in uscita","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Fatturato mensile previsto dei pagamenti in uscita sull'account {{vendorTitle}}","MONTHLY_OUTGOING_FREQUENCY":"Frequenza mensile dei pagamenti in uscita","RANGE":{"UP":"Fino a {{amountTo}} {{unit}}","FROM_TO":"Da {{amountFrom}} {{unit}} a {{amountTo}} {{unit}}","MORE":"Più di {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Fino a {{amountTo}}","FROM_TO":"Da {{amountFrom}} to {{amountTo}}","MORE":"Più di {{amountFrom}}"},"MAIN_SUPPLIERS":"Controparti principali per i pagamenti in uscita (nome / giurisdizione)","MAIN_CLIENTS":"Controparti principali per i pagamenti in entrata (nome / giurisdizione)"},"AUTHORISED_SIGNATORY":{"TITLE":"Firmatario autorizzato","SAVE_ALL":"Salva tutto","DETAILS":"Dettagli firmatario autorizzato","ADDRESS":"Indirizzo firmatario autorizzato","CONTACTS":"Contatti firmatario autorizzato","PASSPORT":"Passaporto","SELFIE":"Selfie con Carta Identità"},"DIRECTORS":{"TITLE":"Amministratori dell'Azienda","DIRECTOR_TYPE":"Tipo Amministratore","NIC_PASSPORT_ID":"Passaporto/Carta Identità No"},"SHAREHOLDERS":{"TITLE":"Soci","SHARE_NUMBER":"Quota: {{share}}%","SHARE":"Quota: %","EMPTY":"Siamo spiacenti! Non ci sono soci.","SHAREHOLDER_TYPE":"Tipo di socio","SHAREHOLDER_SUM_ERROR":"La somma delle % di quote deve essere uguale a 100%","NIC_PASSPORT_ID":"Passaporto/Carta Identità No."},"INTRODUCER":{"TITLE":"Sponsor/Rivenditore","INTRODUCER_NAME":"Nome Sponsor/Rivenditore","INTRODUCER_EMAIL":"Email Sponsor/Rivenditore"},"ACCOUNT_CURRENCIES":{"TITLE":"Valute account","MASTER_ACCOUNT_CURRENCY":"Valuta account principale","ADDITIONAL_CURRENCIES":"Valute aggiuntive"},"USAGE_AND_REFERRAL":{"TITLE":"Utilizzo e referral","WHAT_PRODUCTS_SERVICES":"Quali {{company}} prodotti/servizi avete intenzione di utilizzare?","REASON_FOR_CHOOSING":"Motivazione della scelta {{company}}","SOURCE_OF_INFORMATION":"Fonte delle informazioni circa {{company}}?"}}},"TAB.DOCUMENTS":{"HEADER":"Documentt","IDENTITY_CONFIRMATION":"Conferma identità","LEGAL_DOCUMENTS":"Documenti legali","SELFIE":"Selfie","PROOF_OF_ADDRESS":"Prova di recapito","ARCHIVE_BUTTON":"Salva archivio","NO_DOCUMENTS":"Siamo spiacenti! Non c'è alcun allegato."},"CUSTOM_REASON":"Personalizza motivo","TABLE_REASONS":{"HEADER":{"NAME":"Motivo"},"EMPTY":"Siamo spiacenti! Non ci sono motivi."},"TAB_MANUAL_REVIEW":{"TITLE":"Dettagli revisione manuale"}},"PROCESS":{"CONFIRM.TITLE":"Conferma richiesta di processo","CONFIRM.MESSAGE":"Questo cliente verrà spostato allo stato di <b> elaborazione </b>, sei sicuro di voler continuare?","CONFIRM.BUTTON":"Conferma"},"APPROVE":{"HEADER":"Approvare la richiesta di registrazione da {{name}}?","HEADER_WITHOUT_PROFILE":"Lo stato del profilo è cambiato.","RISK":{"TITLE":"Livello di rischio","PLACEHOLDER":"Seleziona"},"TARIFF":{"TITLE":"Tariffa","PLACEHOLDER":"Seleziona","WHITELABEL_TITLE":"Whitelabel tariffa"},"MIN_TOTAL_ASSET":{"TITLE":"Min total asset","ABOUT":"Min total asset è pari a EUR"},"BANK":{"TITLE":"Banca","PLACEHOLDER":"Seleziona","VALIDATION":{"EMPTY_LIST":"Nessuna banca assegnata con {{currency_code}} al momento"}},"IBAN":{"TITLE":"IBAN","PLACEHOLDER":"Inserire IBAN","IBAN_WILL_BE_GENERATED":"IBAN sarà generato dopo la conferma"},"LIQUIDITY":{"TITLE":"Account di liquidità","PLACEHOLDER":"Seleziona"},"PROFILE_KIND":{"TITLE":"Tipo profilo","PLACEHOLDER":"Seleziona"},"PRODUCT_CODE":{"TITLE":"Product code","PLACEHOLDER":"Select"},"INTRODUCER_NAME":{"TITLE":"Nome sponsor","PLACEHOLDER":"Seleziona","NOT_FOUND":"Siamo spiacenti! Non è stato trovato alcuno sponsor! Si prega di provare con un altro criterio di ricerca!"},"SUCCESS":{"TITLE":"Registrazione approvata!","SECURITY_CODE":{"TITLE":"Codice di sicurezza","TEXT":"Il codice di sicurezza per questo account è stato generato. Copialo ed invialo al cliente."},"PASSWORD":{"TITLE":"Link per impostare una password","TEXT":"Per impostare una password, copia questo link ed invialo al cliente."}}}},"FILTER":{"PLACEHOLDER":{"PERIOD":"Scegli periodo"}},"PENDING":{"APPROVE":{"HEADER":"Approvare la richiesta di registrazione da {{name}}?","RISK":{"TITLE":"Livello di rischio","PLACEHOLDER":"Seleziona"},"TARIFF":{"TITLE":"Tariffa","PLACEHOLDER":"Seleziona"},"BANK":{"TITLE":"Banca","PLACEHOLDER":"Seleziona","VALIDATION":{"EMPTY_LIST":"Nessuna banca assegnata con {{currency_code}} al momento"}},"IBAN":{"TITLE":"IBAN","PLACEHOLDER":"Inserire IBAN","IBAN_WILL_BE_GENERATED":"IBAN sarà generato dopo la conferma"},"LIQUIDITY":{"TITLE":"Account di liquidità","PLACEHOLDER":"Seleziona"},"PROFILE_KIND":{"TITLE":"Tipo profilo","PLACEHOLDER":"Seleziona"},"PRODUCT_CODE":{"TITLE":"Product code","PLACEHOLDER":"Select"},"INTRODUCER_NAME":{"TITLE":"Nome sponsor","PLACEHOLDER":"Seleziona","NOT_FOUND":"Siamo spiacenti! Non è stato trovato alcuno sponsor! Si prega di provare con un altro criterio di ricerca!"},"SUCCESS":{"TITLE":"Registrazione approvata!","SECURITY_CODE":{"TITLE":"Codice di sicurezza","TEXT":"Il codice di sicurezza per questo account è stato creato. Copialo ed invialo al cliente."},"PASSWORD":{"TITLE":"Link per impostare una password","TEXT":"Per impostare una password, copia questo link ed invialo al cliente."}}}},"DECLINED":{"TITLE":"Applicazioni/Rifiutate","NOT_FOUND":"Siamo spiacenti! Non ci sono applicazioni presenti nel sistema.","DETAIL":{"TITLE":"Applicazione/{{status}}/ID:{{id}}","TAB.DETAILS":{"PRIVATE":{"APPLICANT_INFORMATION":{"TITLE":"Richiedente","PERSONAL_DETAILS":{"TITLE":"Dettagli personali","FIRST_NAME":"Nome","LAST_NAME":"Cognome"},"NATIONALITY":"Nazionalità","PASSPORT":"Carta Identità / Passaporto No.","PLACE_OF_ISSUE":"Autorità emittente","DATE":{"TITLE":"Data di emissione/scadenza","ISSUE":"Data di emissione","EXPIRY":"Data di scadenza","EXPIRY_WARNING":"Si prega di notare che il passaporto è prossimo alla scadenza."},"SECOND_NATIONALITY":"Seconda cittadinanza","RESIDENTIAL_ADDRESS":{"TITLE":"Indirizzo di casa","RESIDENTIAL_POSTAL_ADDRESS":"Indirizzo di casa","RESIDENTIAL_POSTAL_CITY":"Città","RESIDENTIAL_POSTAL_COUNTY_OR_REGION":"Provincia o regione","RESIDENTIAL_COUNTRY":"Paese","RESIDENTIAL_ZIP_CODE":"CAP / ZIP code"},"POSTAL_ADDRESS":{"TITLE":"Indirizzo postale","POSTAL_ADDRESS":"Indirizzo postale","POSTAL_CITY":"Città","POSTAL_COUNTY_OR_REGION":"Provincia o regione","COUNTRY":"Paese","ZIP_CODE":"CAP / ZIP code"},"PHONE_NUMBER":"Numero di telefono","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","BIRTH_DATE":"Data di nascita","PLACE_OF_BIRTH":"Luogo di nascita (Paese)","TAX_IDENTIFICATION_NUMBER":"P.IVA/Codice fiscale","TAX_COUNTRY":"Paese contribuzione fiscale","FAX_NUMBER":"Numero di fax","FACEBOOK_PROFILE":"Profilo Facebook","LINKEDIN":"LinkedIn","OTHER":"Altro","ID_OR_PASSPORT_ATTACHMENT_ITEMS":"Elementi allegati Carta identità o Passaporto","PASSPORT_SELFIE_ATTACHMENT_ITEMS":"Elementi allegati selfie Passaporto","ADDRESS_ATTACHMENT_ITEMS":"Elementi allegati indirizzo","SAVE_ALL":"Salva tutto","UPLOAD":{"TITLE":"Carica","ERROR":{"MAX_SIZE":"La dimensione del file supera il valore consentito!","FILE_ALREADY_CONFIRMED":"File già presente nel sistema!","FILE_NOT_FOUND":"File non trovato!","UNSUPPORTED_FORMAT":"Formato di file non supportato!"}},"FILTER":{"NOT_FOUND":{"NATIONALITY_SELECT":"Non ci sono Paesi disponibili","SECOND_NATIONALITY_SELECT":"Non ci sono Paesi disponibili","COUNTRY_SELECT":"Non ci sono Paesi disponibili","RESULT_COUNTRY_SELECT":"Nessun risultato trovato","JURISDICTION":"Non ci sono Giurisdizioni disponibili"}}},"EMPLOYMENT_INFORMATION":{"TITLE":"Impiego","PRESENT_OCCUPATION":"Attuale occupazione","EMPLOYMENT_DETAILS":{"TITLE":"Dettagli impiego","NAME":"Nome del datore di lavoro/Nome dell'attività","ADDRESS":{"TITLE":"Indirizzo datore di lavoro","POSTAL_ADDRESS":"Indirizzo ufficio datore di lavoro","POSTAL_CITY":"Città","POSTAL_COUNTY_OR_REGION":"Provincia o regione","COUNTRY":"Paese","ZIP_CODE":"CAP / ZIP code"},"BUSINESS_SECTOR":"Nome Attività aziendale","YEARS_IN_EMPLOYMENT":"Numero anni di lavoro/attività"}},"PEP_INFORMATION":{"TITLE":"PEP","POSITION_IN_ANY_COUNTRY":"Sei un PEP o sei collegato a un PEP? Una \" Persona politicamente esposta \" è una persona fisica (individuo) a cui è o è stata affidata una funzione pubblica di rilievo e include i suoi parenti stretti o persone note per essere stretti collaboratori di tali persone, ma escludendo gli esponenti di medio/basso livello.","FAMILY_POSITION_IN_ANY_COUNTRY":"Qualche tuo parente stretto attualmente detiene o ha mai ricoperto cariche politiche, diplomatiche o governative in un paese? (Barrare la casella se la risposta è SÌ)"},"LITIGATION_INFORMATION":{"TITLE":"Contenzioso","LITIGATION":"Sei mai stato oggetto di indagini legali, ordinanze di tribunali, sentenze, procedimenti fallimentari, sanzioni penali (esclusi incidenti stradali minori)? (Barrare la casella se la risposta è SI)"},"MASTER_ACCOUNT_INFORMATION":{"TITLE":"Account principale","MASTER_ACCOUNT_CURRENCY":"Valuta account principale","ADDITIONAL_CURRENCIES":"Valute aggiuntive"},"FUNDS_INFORMATION":{"TITLE":"Fondi","SOURCE_OF_INITIAL_FUNDING":{"TITLE":"Origine del deposito iniziale","JURISDICTION":"Giurisdizione","AVERAGE_MONTHLY_INCOME":"Qual è il tuo reddito mensile medio?","PRIMARY_INCOME_SOURCE":"Indica la tua fonte di reddito principale","ORIGINAL_BANK_NAME":"Nome Banca d'origine","ORIGINAL_BANK_ADDRESS":"Indirizzo Banca d'origine","ACCOUNT_NAME":"Nome account","SIGNATORY":"Firmatario","HOW_FUNDS_GENERATED":"Descrivi con precisione come sono stati generati questi fondi"},"EXPECTED_TRANSFER_ACTIVITY":{"TITLE":"Attività di trasferimento prevista","AVERAGE_VALUE_OF_TRANSFER":"Valore medio di ogni trasferimento ({{currency}})","MAX_VALUE_OF_TRANSFER":"Valore massimo di ogni trasferimento ({{currency}})","MAIN_COUNTRIES_TO":"Paesi verso i quali saranno effettuati i trasferimenti","MAIN_COUNTRIES_FROM":"Paesi dai quali verranno ricevuti trasferimenti","PURPOSE_OF_ACCOUNT":" Scopo di questo account","AVERAGE_INCOMING_TRANSACTION":"Valore medio delle transazioni in entrata","PLANNED_MONTHLY_INCOMING_TURNOVER":"Fatturato mensile pianificato dei pagamenti in entrata utilizzando l'account {{vendorTitle}}","MONTHLY_INCOMING_FREQUENCY":"Frequenza media dei pagamenti in entrata","AVERAGE_OUTGOING_TRANSACTION":"Valore medio delle transazioni in uscita","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Fatturato mensile pianificato dei pagamenti in uscita utilizzando l'account {{vendorTitle}}","MONTHLY_OUTGOING_FREQUENCY":"Frequenza mensile pagamenti in uscita"},"RANGE":{"UP":"Fino a {{amountTo}} {{unit}}","FROM_TO":"Da {{amountFrom}} {{unit}} a {{amountTo}} {{unit}}","MORE":"Più di {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Fino a {{amountTo}}","FROM_TO":"Da {{amountFrom}} a {{amountTo}}","MORE":"Più di {{amountFrom}}"}},"INTRODUCER_INFORMATION":{"TITLE":"Sponsor/Rivenditore","INTRODUCER_NAME":"Nome Sponsor/Rivenditore","INTRODUCER_EMAIL":"Email Sponsor/Rivenditore"},"ABOUT_YOURSELF_INFORMATION":{"TITLE":"Parlaci di te","PRODUCTS":"Quali {{company}} prodotti/servizi hai intenzione di usare?","PRODUCTS_CUSTOM":"Peronalizza prodotti","REASONS":"Motivi","REASONS_CUSTOM":"Personalizza motivi","INFORMATION_SOURCE":"Fonti di informazione","INFORMATION_SOURCES_CUSTOM":"Personalizza fonti informazione","USA_CITIZEN":"Spuntando la casella dichiaro di NON essere un cittadino e / o residente fiscale degli USA."},"REQUIRED_INPUT":"Questo campo è obbligatorio!","MINIMUM_LENGTH":"La lunghezza minima è di {{value}} caratteri","MAXIMUM_LENGTH":"La lunghezza massima è di {{value}} caratteri"},"EDIT.BUTTON.NAME":"Modifica","HEADER":"Dettagli","UNAVAILABLE_CURRENCY":" non è al momento disponibile","SAVE.BUTTON.NAME":"Salva","SAVE_ALL.BUTTON.NAME":"Salva tutto","UPLOAD.BUTTON.NAME":"Carica","CANCEL.BUTTON.NAME":"Cancella","DISCARD.BUTTON.NAME":"Scarta","REMOVE.BUTTON.NAME":"Elimina","ADD_NEW.BUTTON.NAME":"Aggiungi nuovo","CHOSE.BUTTON.NAME":"Scegli file","UPLOAD.DOCUMENT.HEADER":"Carica documenti","OTHER":"Altro","CORPORATE":{"COMMON":{"FIRST_NAME":"Nome","LAST_NAME":"Cognome","DATE_OF_BIRTH":"Data di nascita","ATTORNEY_POWER_EXPIRE_DATE":"Data di scadenza della procura (se applicabile)","JOB_TITLE_OCCUPATION":"Lavoro / Occupazione","NIC_PASSPORT_ID":"Carta Identità/Passaporto No","IS_PEP":"Questa persona è una PEP o correlata ad una PEP?","TRUE":"Vero","FALSE":"Falso","NATIONALITY":"Nazionalità","SECOND_NATIONALITY":"Seconda cittadinanza","ADDRESS_LINE":"Indirizzo","COUNTRY":"Paese","COUNTY_REGION":"Provincia / Regione","CITY":"Città","ZIP_CODE":"CAP / ZIP code","RESULT_COUNTRY_SELECT":"Nessun risultato trovato","PHONE_NUMBER":"Numero di telefono","MOBILE":"Cellulare","LINKEDIN":"Linkedin","FACEBOOK":"Facebook","WEBSITE":"Website","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","NAME_OF_CORPORATE_SHAREHOLDER":"Nome del socio aziendale","LEGAL_DOCUMENTS":"Documenti legali","PERSONAL_INFORMATION":"Informazioni personali","COMPANY_INFORMATION":"Informazioni Azienda","COMPANY_NAME":"Nome Azienda","COUNTRY_OF_INCORPORATION":"Paese di costituzione","COMPANY_REGISTRATION_NUMBER":"Numero riferimento Azienda","COMPANY_ADDRESS":"Indirizzo Azienda (Facoltativo)","COMPANY_CONTACTS":"Contatti Azienda","HOME_ADDRESS":"Indirizzo di casa (Facoltativo)","CONTACTS":"Contatti","INDIVIDUAL":"Privato","CORPORATE":"Aziendale","IDENTITY_CONFIRMATION":"Conferma identità","YES":"Sì","NO":"No","PROOF_OF_ADDRESS":"Prova di recapito","OPTIONAL_ADDRESS":"Indirizzo facoltativo","INVALID_VALUE":"Valore non valido"},"BUSINESS_CUSTOMER_INFORMATION":{"TITLE":"informazioni Cliente Business","DATE_OF_REGISTRATION":"Data di registrazione","REGISTRATION_NUMBER":"Numero di registrazione","TRADING_NAME":"Denominazione commerciale","TAX_IDENTIFICATION_NUMBER":"Partita IVA","BUSINESS_ACTIVITIES":"Attività aziendali","SEARCH_BUSINESS_ACTIVITIES":"Cerca attività aziendali"},"REGISTERED_OFFICE_ADDRESS":{"TITLE":"Indirizzo sede legale"},"OFFICIAL_BUSINESS_LOCATION":{"TITLE":"Sede ufficiale attività","PROOF_OF_ADDRESS":"Documenti per prova di recapito"},"CONTACT_INFORMATION":{"TITLE":"Informazioni di contatto","PHONE_NUMBER":"Numero di telefono"},"STATEMENT_OF_AFFAIRS":{"TITLE":"Dichiarazione di attività","SPECIFIC_COUNTRIES":"Specifici Paesi per operazioni su mercati targhettizzati","NATURE_OF_BUSINESS":"Natura del business"},"INITIAL_DEPOSITS":{"TITLE":"Origine die fondi","SOURCE_OF_INITIAL_DEPOSIT":"Descrivi l'origine del deposito iniziale","ORIGINATING_BANK_JURISDICTION":"Giurisdizione della Banca di origine","DESCRIBE_FUNDS_WERE_GENERATED":"Descrivi con precisione come sono stati generati questi fondi","AMOUNT":"Importo","CURRENCY":"Valuta","ACCOUNT_NAME":"Nome account"},"EXPECTED_TURNOVER":{"TITLE":"Fatturato previsto","AVERAGE_INCOMING_TRANSACTION":"Valore / dimensione medio della transazione in entrata","PLANNED_MONTHLY_INCOMING_TURNOVER":"Fatturato mensile previsto dei pagamenti in entrata utilizzando l'account {{vendorTitle}}","MONTHLY_INCOMING_FREQUENCY":"Frequenza mensile dei pagamenti in entrata","AVERAGE_OUTGOING_TRANSACTION":"Valore / dimensione medio della transazione in uscita","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Fatturato mensile previsto dei pagamenti in uscita sull'account {{vendorTitle}}","MONTHLY_OUTGOING_FREQUENCY":"Frequenza mensile dei pagamenti in uscita","RANGE":{"UP":"Fino a {{amountTo}} {{unit}}","FROM_TO":"Da {{amountFrom}} {{unit}} a {{amountTo}} {{unit}}","MORE":"Più di {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Fino a {{amountTo}}","FROM_TO":"Da {{amountFrom}} to {{amountTo}}","MORE":"Più di {{amountFrom}}"},"MAIN_SUPPLIERS":"Controparti principali per i pagamenti in uscita (nome / giurisdizione)","MAIN_CLIENTS":"Controparti principali per i pagamenti in entrata (nome / giurisdizione)"},"AUTHORISED_SIGNATORY":{"TITLE":"Firmatario autorizzato","SAVE_ALL":"Salva tutto","DETAILS":"Dettagli firmatario autorizzato","ADDRESS":"Indirizzo firmatario autorizzato","CONTACTS":"Contatti firmatario autorizzato","PASSPORT":"Passaporto","SELFIE":"Selfie con Carta Identità"},"DIRECTORS":{"TITLE":"Amministratori dell'Azienda","DIRECTOR_TYPE":"Tipo Amministratore","NIC_PASSPORT_ID":"Passaporto/Carta Identità No"},"SHAREHOLDERS":{"TITLE":"Soci","SHARE_NUMBER":"Quota: {{share}}%","SHARE":"Quota: %","EMPTY":"Siamo spiacenti! Non ci sono soci.","SHAREHOLDER_TYPE":"Tipo di socio","SHAREHOLDER_SUM_ERROR":"La somma delle % di quote deve essere uguale a 100%","NIC_PASSPORT_ID":"Passaporto/Carta Identità No."},"INTRODUCER":{"TITLE":"Sponsor/Rivenditore","INTRODUCER_NAME":"Nome Sponsor/Rivenditore","INTRODUCER_EMAIL":"Email Sponsor/Rivenditore"},"ACCOUNT_CURRENCIES":{"TITLE":"Valute account","MASTER_ACCOUNT_CURRENCY":"Valuta account principale","ADDITIONAL_CURRENCIES":"Valute aggiuntive"},"USAGE_AND_REFERRAL":{"TITLE":"Utilizzo e referral","WHAT_PRODUCTS_SERVICES":"Quali {{company}} prodotti/servizi avete intenzione di utilizzare?","REASON_FOR_CHOOSING":"Motivazione della scelta {{company}}","SOURCE_OF_INFORMATION":"Fonte delle informazioni circa {{company}}?"}}},"TAB.DOCUMENTS":{"HEADER":"Documentt","IDENTITY_CONFIRMATION":"Conferma identità","LEGAL_DOCUMENTS":"Documenti legali","SELFIE":"Selfie","PROOF_OF_ADDRESS":"Prova di recapito","ARCHIVE_BUTTON":"Salva archivio","NO_DOCUMENTS":"Siamo spiacenti! Non c'è alcun allegato."},"CUSTOM_REASON":"Motivo personalizzato","TABLE_REASONS":{"HEADER":{"NAME":"Motivo"},"EMPTY":"Siamo spiacenti! Non ci sono motivi."},"TAB_DECLINED":{"TITLE":"Dettagli rifiutati"},"PROCESS":{"CONFIRM.TITLE":"Conferma richiesta processo","CONFIRM.MESSAGE":"Questo cliente sarà nello stato <b> elaborazione </b>, sei sicuro di voler continuare?","CONFIRM.BUTTON":"Conferma"}},"REJECTED_CONFIRM":{"PROCESS":{"CONFIRM.TITLE":"Conferma richiesta processo","CONFIRM.MESSAGE":"Questo cliente sarà nello stato <b> elaborazione </b>, sei sicuro di voler continuare?","CONFIRM.BUTTON":"Conferma"}},"PROCESS":{"CONFIRM.TITLE":"Conferma richiesta processo","CONFIRM.MESSAGE":"Questo cliente sarà nello stato <b> elaborazione </b>, sei sicuro di voler continuare?","CONFIRM.BUTTON":"Conferma"}},"PROCESSING":{"TITLE":"Applicazioni/In lavorazione","NOT_FOUND":"Sorry! There are not any applications in system.","DETAIL":{"TITLE":"Applicatione/in lavorazione/ID:{{id}}","TAB.DETAILS":{"PRIVATE":{"APPLICANT_INFORMATION":{"TITLE":"Richiedente","PERSONAL_DETAILS":{"TITLE":"Dettagli personali","FIRST_NAME":"Nome","LAST_NAME":"Cognome"},"NATIONALITY":"Nazionalità","PASSPORT":"Carta Identità / Passaporto No.","PLACE_OF_ISSUE":"Autorità emittente","DATE":{"TITLE":"Data di emissione/scadenza","ISSUE":"Data di emissione","EXPIRY":"Data di scadenza","EXPIRY_WARNING":"Si prega di notare che il passaporto è prossimo alla scadenza."},"SECOND_NATIONALITY":"Seconda cittadinanza","RESIDENTIAL_ADDRESS":{"TITLE":"Indirizzo di casa","RESIDENTIAL_POSTAL_ADDRESS":"Indirizzo di casa","RESIDENTIAL_POSTAL_CITY":"Città","RESIDENTIAL_POSTAL_COUNTY_OR_REGION":"Provincia o regione","RESIDENTIAL_COUNTRY":"Paese","RESIDENTIAL_ZIP_CODE":"CAP / ZIP code"},"POSTAL_ADDRESS":{"TITLE":"Indirizzo postale","POSTAL_ADDRESS":"Indirizzo postale","POSTAL_CITY":"Città","POSTAL_COUNTY_OR_REGION":"Provincia o regione","COUNTRY":"Paese","ZIP_CODE":"CAP / ZIP code"},"PHONE_NUMBER":"Numero di telefono","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","BIRTH_DATE":"Data di nascita","PLACE_OF_BIRTH":"Luogo di nascita (Paese)","TAX_IDENTIFICATION_NUMBER":"P.IVA/Codice fiscale","TAX_COUNTRY":"Paese contribuzione fiscale","FAX_NUMBER":"Numero di fax","FACEBOOK_PROFILE":"Profilo Facebook","LINKEDIN":"LinkedIn","OTHER":"Altro","ID_OR_PASSPORT_ATTACHMENT_ITEMS":"Elementi allegati Carta identità o Passaporto","PASSPORT_SELFIE_ATTACHMENT_ITEMS":"Elementi allegati selfie Passaporto","ADDRESS_ATTACHMENT_ITEMS":"Elementi allegati indirizzo","SAVE_ALL":"Salva tutto","UPLOAD":{"TITLE":"Carica","ERROR":{"MAX_SIZE":"La dimensione del file supera il valore consentito!","FILE_ALREADY_CONFIRMED":"File già presente nel sistema!","FILE_NOT_FOUND":"File non trovato!","UNSUPPORTED_FORMAT":"Formato di file non supportato!"}},"FILTER":{"NOT_FOUND":{"NATIONALITY_SELECT":"Non ci sono Paesi disponibili","SECOND_NATIONALITY_SELECT":"Non ci sono Paesi disponibili","COUNTRY_SELECT":"Non ci sono Paesi disponibili","RESULT_COUNTRY_SELECT":"Nessun risultato trovato","JURISDICTION":"Non ci sono Giurisdizioni disponibili"}}},"EMPLOYMENT_INFORMATION":{"TITLE":"Impiego","PRESENT_OCCUPATION":"Attuale occupazione","EMPLOYMENT_DETAILS":{"TITLE":"Dettagli impiego","NAME":"Nome del datore di lavoro/Nome dell'attività","ADDRESS":{"TITLE":"Indirizzo datore di lavoro","POSTAL_ADDRESS":"Indirizzo ufficio datore di lavoro","POSTAL_CITY":"Città","POSTAL_COUNTY_OR_REGION":"Provincia o regione","COUNTRY":"Paese","ZIP_CODE":"CAP / ZIP code"},"BUSINESS_SECTOR":"Nome Attività aziendale","YEARS_IN_EMPLOYMENT":"Numero anni di lavoro/attività"}},"PEP_INFORMATION":{"TITLE":"PEP","POSITION_IN_ANY_COUNTRY":"Sei un PEP o sei collegato a un PEP? Una \" Persona politicamente esposta \" è una persona fisica (individuo) a cui è o è stata affidata una funzione pubblica di rilievo e include i suoi parenti stretti o persone note per essere stretti collaboratori di tali persone, ma escludendo gli esponenti di medio/basso livello.","FAMILY_POSITION_IN_ANY_COUNTRY":"Qualche tuo parente stretto attualmente detiene o ha mai ricoperto cariche politiche, diplomatiche o governative in un paese? (Barrare la casella se la risposta è SÌ)"},"LITIGATION_INFORMATION":{"TITLE":"Contenzioso","LITIGATION":"Sei mai stato oggetto di indagini legali, ordinanze di tribunali, sentenze, procedimenti fallimentari, sanzioni penali (esclusi incidenti stradali minori)? (Barrare la casella se la risposta è SI)"},"MASTER_ACCOUNT_INFORMATION":{"TITLE":"Account principale","MASTER_ACCOUNT_CURRENCY":"Valuta account principale","ADDITIONAL_CURRENCIES":"Valute aggiuntive"},"FUNDS_INFORMATION":{"TITLE":"Fondi","SOURCE_OF_INITIAL_FUNDING":{"TITLE":"Origine del deposito iniziale","JURISDICTION":"Giurisdizione","AVERAGE_MONTHLY_INCOME":"Qual è il tuo reddito mensile medio?","PRIMARY_INCOME_SOURCE":"Indica la tua fonte di reddito principale","ORIGINAL_BANK_NAME":"Nome Banca d'origine","ORIGINAL_BANK_ADDRESS":"Indirizzo Banca d'origine","ACCOUNT_NAME":"Nome account","SIGNATORY":"Firmatario","HOW_FUNDS_GENERATED":"Descrivi con precisione come sono stati generati questi fondi"},"EXPECTED_TRANSFER_ACTIVITY":{"TITLE":"Attività di trasferimento prevista","AVERAGE_VALUE_OF_TRANSFER":"Valore medio di ogni trasferimento ({{currency}})","MAX_VALUE_OF_TRANSFER":"Valore massimo di ogni trasferimento ({{currency}})","MAIN_COUNTRIES_TO":"Paesi verso i quali saranno effettuati i trasferimenti","MAIN_COUNTRIES_FROM":"Paesi dai quali verranno ricevuti trasferimenti","PURPOSE_OF_ACCOUNT":" Scopo di questo account","AVERAGE_INCOMING_TRANSACTION":"Valore medio delle transazioni in entrata","PLANNED_MONTHLY_INCOMING_TURNOVER":"Fatturato mensile pianificato dei pagamenti in entrata utilizzando l'account {{vendorTitle}}","MONTHLY_INCOMING_FREQUENCY":"Frequenza media dei pagamenti in entrata","AVERAGE_OUTGOING_TRANSACTION":"Valore medio delle transazioni in uscita","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Fatturato mensile pianificato dei pagamenti in uscita utilizzando l'account {{vendorTitle}}","MONTHLY_OUTGOING_FREQUENCY":"Frequenza mensile pagamenti in uscita"},"RANGE":{"UP":"Fino a {{amountTo}} {{unit}}","FROM_TO":"Da {{amountFrom}} {{unit}} a {{amountTo}} {{unit}}","MORE":"Più di {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Fino a {{amountTo}}","FROM_TO":"Da {{amountFrom}} a {{amountTo}}","MORE":"Più di {{amountFrom}}"}},"INTRODUCER_INFORMATION":{"TITLE":"Sponsor/Rivenditore","INTRODUCER_NAME":"Nome Sponsor/Rivenditore","INTRODUCER_EMAIL":"Email Sponsor/Rivenditore"},"ABOUT_YOURSELF_INFORMATION":{"TITLE":"Parlaci di te","PRODUCTS":"Quali {{company}} prodotti/servizi hai intenzione di usare?","PRODUCTS_CUSTOM":"Peronalizza prodotti","REASONS":"Motivi","REASONS_CUSTOM":"Personalizza motivi","INFORMATION_SOURCE":"Fonti di informazione","INFORMATION_SOURCES_CUSTOM":"Personalizza fonti informazione","USA_CITIZEN":"Spuntando la casella dichiaro di NON essere un cittadino e / o residente fiscale degli USA."},"REQUIRED_INPUT":"Questo campo è obbligatorio!","MINIMUM_LENGTH":"La lunghezza minima è di {{value}} caratteri","MAXIMUM_LENGTH":"La lunghezza massima è di {{value}} caratteri"},"EDIT.BUTTON.NAME":"Modifica","HEADER":"Dettagli","UNAVAILABLE_CURRENCY":" non è al momento disponibile","SAVE.BUTTON.NAME":"Salva","SAVE_ALL.BUTTON.NAME":"Salva tutto","UPLOAD.BUTTON.NAME":"Carica","CANCEL.BUTTON.NAME":"Cancella","DISCARD.BUTTON.NAME":"Scarta","REMOVE.BUTTON.NAME":"Elimina","ADD_NEW.BUTTON.NAME":"Aggiungi nuovo","CHOSE.BUTTON.NAME":"Scegli file","UPLOAD.DOCUMENT.HEADER":"Carica documenti","OTHER":"Altro","CORPORATE":{"COMMON":{"FIRST_NAME":"Nome","LAST_NAME":"Cognome","DATE_OF_BIRTH":"Data di nascita","ATTORNEY_POWER_EXPIRE_DATE":"Data di scadenza della procura (se applicabile)","JOB_TITLE_OCCUPATION":"Lavoro / Occupazione","NIC_PASSPORT_ID":"Carta Identità/Passaporto No","IS_PEP":"Questa persona è una PEP o correlata ad una PEP?","TRUE":"Vero","FALSE":"Falso","NATIONALITY":"Nazionalità","SECOND_NATIONALITY":"Seconda cittadinanza","ADDRESS_LINE":"Indirizzo","COUNTRY":"Paese","COUNTY_REGION":"Provincia / Regione","CITY":"Città","ZIP_CODE":"CAP / ZIP code","RESULT_COUNTRY_SELECT":"Nessun risultato trovato","PHONE_NUMBER":"Numero di telefono","MOBILE":"Cellulare","LINKEDIN":"Linkedin","FACEBOOK":"Facebook","WEBSITE":"Website","EMAIL":"Email","REJECTED_EMAIL":"Rejected Email","NAME_OF_CORPORATE_SHAREHOLDER":"Nome del socio aziendale","LEGAL_DOCUMENTS":"Documenti legali","PERSONAL_INFORMATION":"Informazioni personali","COMPANY_INFORMATION":"Informazioni Azienda","COMPANY_NAME":"Nome Azienda","COUNTRY_OF_INCORPORATION":"Paese di costituzione","COMPANY_REGISTRATION_NUMBER":"Numero riferimento Azienda","COMPANY_ADDRESS":"Indirizzo Azienda (Facoltativo)","COMPANY_CONTACTS":"Contatti Azienda","HOME_ADDRESS":"Indirizzo di casa (Facoltativo)","CONTACTS":"Contatti","INDIVIDUAL":"Privato","CORPORATE":"Aziendale","IDENTITY_CONFIRMATION":"Conferma identità","YES":"Sì","NO":"No","PROOF_OF_ADDRESS":"Prova di recapito","OPTIONAL_ADDRESS":"Indirizzo facoltativo","INVALID_VALUE":"Valore non valido"},"BUSINESS_CUSTOMER_INFORMATION":{"TITLE":"informazioni Cliente Business","DATE_OF_REGISTRATION":"Data di registrazione","REGISTRATION_NUMBER":"Numero di registrazione","TRADING_NAME":"Denominazione commerciale","TAX_IDENTIFICATION_NUMBER":"Partita IVA","BUSINESS_ACTIVITIES":"Attività aziendali","SEARCH_BUSINESS_ACTIVITIES":"Cerca attività aziendali"},"REGISTERED_OFFICE_ADDRESS":{"TITLE":"Indirizzo sede legale"},"OFFICIAL_BUSINESS_LOCATION":{"TITLE":"Sede ufficiale attività","PROOF_OF_ADDRESS":"Documenti per prova di recapito"},"CONTACT_INFORMATION":{"TITLE":"Informazioni di contatto","PHONE_NUMBER":"Numero di telefono"},"STATEMENT_OF_AFFAIRS":{"TITLE":"Dichiarazione di attività","SPECIFIC_COUNTRIES":"Specifici Paesi per operazioni su mercati targhettizzati","NATURE_OF_BUSINESS":"Natura del business"},"INITIAL_DEPOSITS":{"TITLE":"Origine die fondi","SOURCE_OF_INITIAL_DEPOSIT":"Descrivi l'origine del deposito iniziale","ORIGINATING_BANK_JURISDICTION":"Giurisdizione della Banca di origine","DESCRIBE_FUNDS_WERE_GENERATED":"Descrivi con precisione come sono stati generati questi fondi","AMOUNT":"Importo","CURRENCY":"Valuta","ACCOUNT_NAME":"Nome account"},"EXPECTED_TURNOVER":{"TITLE":"Fatturato previsto","AVERAGE_INCOMING_TRANSACTION":"Valore / dimensione medio della transazione in entrata","PLANNED_MONTHLY_INCOMING_TURNOVER":"Fatturato mensile previsto dei pagamenti in entrata utilizzando l'account {{vendorTitle}}","MONTHLY_INCOMING_FREQUENCY":"Frequenza mensile dei pagamenti in entrata","AVERAGE_OUTGOING_TRANSACTION":"Valore / dimensione medio della transazione in uscita","PLANNED_MONTHLY_OUTGOING_TURNOVER":"Fatturato mensile previsto dei pagamenti in uscita sull'account {{vendorTitle}}","MONTHLY_OUTGOING_FREQUENCY":"Frequenza mensile dei pagamenti in uscita","RANGE":{"UP":"Fino a {{amountTo}} {{unit}}","FROM_TO":"Da {{amountFrom}} {{unit}} a {{amountTo}} {{unit}}","MORE":"Più di {{amountFrom}} {{unit}}"},"RANGE_WITHOUT_UNIT":{"UP":"Fino a {{amountTo}}","FROM_TO":"Da {{amountFrom}} to {{amountTo}}","MORE":"Più di {{amountFrom}}"},"MAIN_SUPPLIERS":"Controparti principali per i pagamenti in uscita (nome / giurisdizione)","MAIN_CLIENTS":"Controparti principali per i pagamenti in entrata (nome / giurisdizione)"},"AUTHORISED_SIGNATORY":{"TITLE":"Firmatario autorizzato","SAVE_ALL":"Salva tutto","DETAILS":"Dettagli firmatario autorizzato","ADDRESS":"Indirizzo firmatario autorizzato","CONTACTS":"Contatti firmatario autorizzato","PASSPORT":"Passaporto","SELFIE":"Selfie con Carta Identità"},"DIRECTORS":{"TITLE":"Amministratori dell'Azienda","DIRECTOR_TYPE":"Tipo Amministratore","NIC_PASSPORT_ID":"Passaporto/Carta Identità No"},"SHAREHOLDERS":{"TITLE":"Soci","SHARE_NUMBER":"Quota: {{share}}%","SHARE":"Quota: %","EMPTY":"Siamo spiacenti! Non ci sono soci.","SHAREHOLDER_TYPE":"Tipo di socio","SHAREHOLDER_SUM_ERROR":"La somma delle % di quote deve essere uguale a 100%","NIC_PASSPORT_ID":"Passaporto/Carta Identità No."},"INTRODUCER":{"TITLE":"Sponsor/Rivenditore","INTRODUCER_NAME":"Nome Sponsor/Rivenditore","INTRODUCER_EMAIL":"Email Sponsor/Rivenditore"},"ACCOUNT_CURRENCIES":{"TITLE":"Valute account","MASTER_ACCOUNT_CURRENCY":"Valuta account principale","ADDITIONAL_CURRENCIES":"Valute aggiuntive"},"USAGE_AND_REFERRAL":{"TITLE":"Utilizzo e referral","WHAT_PRODUCTS_SERVICES":"Quali {{company}} prodotti/servizi avete intenzione di utilizzare?","REASON_FOR_CHOOSING":"Motivazione della scelta {{company}}","SOURCE_OF_INFORMATION":"Fonte delle informazioni circa {{company}}?"}}},"TAB.DOCUMENTS":{"HEADER":"Documenti","IDENTITY_CONFIRMATION":"Conferma identità","LEGAL_DOCUMENTS":"Documenti legali","SELFIE":"Selfie","PROOF_OF_ADDRESS":"Prova di recapito","ARCHIVE_BUTTON":"Salva archivio","NO_DOCUMENTS":"Siamo spiacenti! Non c'è alcun allegato."}},"APPROVE":{"HEADER":"Approvare la richiesta di registrazione da {{name}}?","HEADER_WITHOUT_PROFILE":"Lo stato del profilo è cambiato.","RISK":{"TITLE":"Livello di rischio","PLACEHOLDER":"Seleziona"},"TARIFF":{"TITLE":"Tariffa","PLACEHOLDER":"Seleziona","WHITELABEL_TITLE":"Whitelabel tariffa"},"MIN_TOTAL_ASSET":{"TITLE":"Min total asset","ABOUT":"Min total asset è pari a EUR"},"BANK":{"TITLE":"Banca","PLACEHOLDER":"Seleziona","VALIDATION":{"EMPTY_LIST":"Nessuna banca assegnata con {{currency_code}} al momento"}},"IBAN":{"TITLE":"IBAN","PLACEHOLDER":"Inserire IBAN","IBAN_WILL_BE_GENERATED":"IBAN sarà generato dopo la conferma"},"LIQUIDITY":{"TITLE":"Account di liquidità","PLACEHOLDER":"Seleziona"},"PROFILE_KIND":{"TITLE":"Tipo profilo","PLACEHOLDER":"Seleziona"},"PRODUCT_CODE":{"TITLE":"Product code","PLACEHOLDER":"Select"},"INTRODUCER_NAME":{"TITLE":"Nome sponsor","PLACEHOLDER":"Seleziona","NOT_FOUND":"Siamo spiacenti! Non è stato trovato alcuno sponsor! Si prega di provare con un altro criterio di ricerca!"},"SUCCESS":{"TITLE":"Registrazione approvata!","SECURITY_CODE":{"TITLE":"Codice di sicurezza","TEXT":"Il codice di sicurezza per questo account è stato generato. Copialo ed invialo al cliente."},"PASSWORD":{"TITLE":"Link per impostare una password","TEXT":"Per impostare una password, copia questo link ed invialo al cliente."}}},"FILTER":{"PLACEHOLDER":{"PERIOD":"Scegli periodo"}}}}}

/***/ }),
/* 726 */
/***/ (function(module, exports) {

	module.exports = {"CARDS":{"NEW":{"TITLE":"Nuove carte","NO_NEW_CARDS":"Non ci sono nuove carte"},"CARD_NUMBER":"Carta No","CARD_PROGRAM":"Card Program","CURRENCY":"Valuta","SHORT_NUMBER":"Numero breve","CARD_VALIDITY":"Validità della carta"}}

/***/ }),
/* 727 */
/***/ (function(module, exports) {

	module.exports = {"CONFIGURATION":{"TARIFFS":{"BASE":"Base","FEE":"Spesa","MIN_FEE":"Min spesa","MAX_FEE":"Max spesa","FROM":"Da","MARGIN":"FX Margin","NAME":"Nome","NO_TARIFFS":"Spiacenti! Non ci sono tariffe nel sistema.","NO_RULES":"Spiacenti! Non ci sono regole nel sistema per questa tariffa.","SERVICE_NAME":"Nome servizio","TO":"A","TITLE":"Tariffe","TYPE":"Tipo","TAB_TITLE":{"CUSTOMER":"Tariffe cliente","BANK":"Tariffe bancarie","CARD":"Tariffe carta","WL":"Tariffe Whitelabel"}},"CLIENT_NOTIFICATIONS":{"TITLE":"Notifiche Client Office","ID":"ID","TITLE_FIELD":"Titolo","CONTENT":"Contenuto","PRIORITY_LABEL":"Priorità","CREATED_AT":"Creato il","CREATED_BY":"Creato da","UPDATED_AT":"Aggiornato il","UPDATED_BY":"Aggiornato da","ACTIVE":"Attivo","INACTIVE":"Inattivo","CREATE_BUTTON":"Crea notifica","UPDATE_BUTTON":"Aggiorna notifica","CANCEL":"Annulla","EDIT":"Modifica","DELETE":"Elimina","ACTIVATE":"Attiva","DEACTIVATE":"Disattiva","DELETE_CONFIRM":"Sei sicuro di voler eliminare questa notifica?","NO_RECORDS":"Nessuna notifica trovata","NEW_NOTIFICATION":"Nuova notifica","EDIT_NOTIFICATION":"Modifica notifica","TITLE_PLACEHOLDER":"Inserisci il titolo della notifica","CONTENT_PLACEHOLDER":"Inserisci il contenuto della notifica","CREATED_SUCCESS":"Notifica creata con successo","CREATED_ERROR":"Errore durante la creazione della notifica","UPDATED_SUCCESS":"Notifica aggiornata con successo","UPDATED_ERROR":"Errore durante l'aggiornamento della notifica","LOAD_ERROR":"Errore durante il caricamento della notifica","RECIPIENTS":"Destinatari","RECIPIENTS_REQUIRED":"È richiesto almeno un destinatario","ALL_ACTIVE_USERS":"Tutti gli utenti attivi","ALL_ACTIVE_USERS_INFO":"Questa notifica verrà inviata a tutti gli utenti client attivi nel sistema.","BY_CUSTOMER":"Per Cliente","BY_USER":"Per Utente","BY_USER_ID":"Per ID Utente","BY_EMAIL":"Per Email","SEARCH_CUSTOMER":"Cerca cliente per nome...","SEARCH_USER":"Cerca utente per email o nome...","ENTER_USER_ID":"Inserisci ID Utente","ENTER_EMAIL":"Inserisci indirizzo email","ADD":"Aggiungi","ADDED_USER_IDS":"ID Utenti Aggiunti","ADDED_EMAILS":"Email Aggiunte","SELECTED_CUSTOMERS":"Clienti Selezionati","SELECTED_USERS":"Utenti Selezionati","PRIORITY_LOW":"Bassa","PRIORITY_MEDIUM":"Media","PRIORITY_HIGH":"Alta","PRIORITY_URGENT":"Urgente","ACTIVE_YES":"Attivo","ACTIVE_NO":"Inattivo","VIEW":"Visualizza","VIEW_TITLE":"Visualizza Notifica","BACK":"Indietro","CONTENT_FIELD":"Contenuto","NO_RECIPIENTS":"Nessun destinatario","RECIPIENT_NAME":"Nome","RECIPIENT_EMAIL":"Email / Login","RECIPIENT_CUSTOMER":"Cliente","RECIPIENT_STATUS":"Stato","ADD_RECIPIENTS":"Aggiungi Destinatari","PENDING_ADD":"da aggiungere","PENDING_REMOVE":"da rimuovere","REMOVE":"Rimuovi","UNDO":"Annulla","RECIPIENT_ADDED":"aggiunto alla lista","IMAGE_LABEL":"Immagine","IMAGE_HINT":"opzionale, max 2 MB, solo formati immagine","IMAGE_SELECT":"Seleziona immagine","IMAGE_CHANGE":"Cambia immagine","IMAGE_REMOVE":"Rimuovi selezionata","IMAGE_DELETE":"Elimina immagine","IMAGE_WILL_DELETE":"L'immagine verrà eliminata al salvataggio.","IMAGE_TYPE_ERROR":"Sono consentiti solo file immagine (jpg, png, gif, webp...)","IMAGE_SIZE_ERROR":"L'immagine deve essere inferiore a 2 MB","USER_NOT_FOUND":"Utente non trovato con quell'email","READ_STATUS":"Stato lettura","READ_STATUS_ALL":"Tutte lette","READ_STATUS_NONE":"Nessuna letta","READ_STATUS_PARTIAL":"{{read}} / {{total}} lette","READ_STATUS_NO_RECIPIENTS":"—","ACTIONS":"Azioni","MARK_READ":"Segna come letta","MARK_UNREAD":"Segna come non letta","MARK_READ_ERROR":"Errore durante la marcatura come letta","MARK_UNREAD_ERROR":"Errore durante la marcatura come non letta","HAS_BUTTON":"Includi pulsante di azione","BUTTON_YES":"Sì","BUTTON_NO":"No","BUTTON_LABEL":"Etichetta del pulsante","BUTTON_LABEL_PLACEHOLDER":"es. Vai al Crypto Wallet","BUTTON_PATH":"Percorso URL del pulsante","BUTTON_PATH_PLACEHOLDER":"es. /crypto-wallet","BUTTON_PATH_HINT":"Solo il suffisso del percorso — la URL base è fornita dall'ambiente del client","PRIORITY":{"LOW":"Bassa","MEDIUM":"Media","HIGH":"Alta","URGENT":"Urgente"}},"ADMIN_USERS":{"TITLE":"Utenti Admin","CREATE_BUTTON":"Nuovo Admin","CREATE_TITLE":"Crea nuovo utente Admin","USERNAME":"Username (email)","PASSWORD":"Password","FIRST_NAME":"Nome","LAST_NAME":"Cognome","SAVE":"Salva","CANCEL":"Annulla","COL_ID":"ID","COL_USERNAME":"Username","COL_NAME":"Nome","COL_STATE":"Stato","ACTIVE":"Attivo","INACTIVE":"Inattivo","ENABLE":"Abilita","DISABLE":"Disabilita","YOU":"Tu","CHANGE_PASSWORD_TITLE":"Cambia la mia password","CHANGE_PASSWORD_NOTICE":"Stai cambiando la password del tuo account:","CURRENT_PASSWORD":"Password attuale","NEW_PASSWORD":"Nuova password","CONFIRM_PASSWORD":"Conferma nuova password","CHANGE_PASSWORD_BUTTON":"Cambia password"}}}

/***/ }),
/* 728 */
/***/ (function(module, exports) {

	module.exports = {"SPACE":{"MENU":{"HOME":"Home","DASHBOARD":"Dashboard","APPROVAL":"Richiedenti","APPROVED":"Approvato","DECLINED":"Respinto","ACCOUNTS":"Accounts","CUSTOMER_ACCOUNTS":"Account cliente","SYSTEM_ACCOUNTS":"Account di sistema","LIQUIDITY_ACCOUNTS":"Account di liquidità","OUTGOING":{"TITLE":"Trasferimenti in uscita","NEW":"Nuovi trasferimenti","APPROVED":"Trasferimenti approvati","UPLOADED":"In attesa di riferimento","HISTORY":"Cronologia"},"HISTORY":{"TITLE":"Cronologia","TRANSFERS":"Trasferimenti"},"OPEN_BANKING":{"TITLE":"Open Banking","FIAT_LABEL":"─ FIAT","CRYPTO_LABEL":"─ CRYPTO","CLIENTS":"Clienti","PAYMENTS":"Pagamenti","INSTITUTIONS":"Istituzioni","NOTIFICATIONS":"Notifiche","GROUPS":"Gruppi Aziendali","FAILURE_REASONS":"Motivi di Fallimento","SETTLEMENTS":"Liquidazioni","ANALYTICS":"Analisi","CRYPTO_PAYMENTS":"Pagamenti Crypto","CRYPTO_CLIENTS":"Clienti Crypto","CRYPTO_ANALYTICS":"Analisi Crypto","CRYPTO_SYSTEM":"Sistema Crypto","CRYPTO_SETTLEMENT_REPORT":"Crypto Settlement"},"INCOMING":{"TITLE":"Trasferimenti in entrata","UPLOADING":"Carica"},"REFILL_CARD":{"TITLE":"Trasferimenti ricarica carta","NEW":"Nuovi trasferimenti","AWAITING":"In attesa di riferimento"},"INTERNAL":{"TITLE":"Trasferimenti interni","NEW":"Nuovi trasferimenti"},"SYSTEM":{"TITLE":"Trasferimenti di sistema","REVENUE_TO_INTERNAL":"Entrate account interno","CHARGE_FEES":"Addebitare oneri aggiuntivi"},"CARDS":{"TITLE":"Carte","NEW":"Nuove"},"REPORTS":{"TITLE":"Report","ACCOUNT_STATEMENT":"Estratto conto","PAYTAH_STATEMENT":"Estratto Paytah","CUSTOMER_BALANCES":"Saldi clienti","FEE_ERRORS":"Errori commissioni","REVENUE_ACCOUNT":"Conto ricavi","TX_RECONCILIATION":"Riconciliazione TX","LEGACY_CONFIG":"Config DB Legacy","TRANSACTION_DETAIL":"Dettaglio transazione","MOORWAND_BALANCE_REPORT":"Report Saldi Moorwand (SFTP)"},"CONFIG":{"TITLE":"Configurazione","TARIFFS":"Tariffe","AML_RULES":"Regole TM","MOORWAND_REPORTS":"Report Moorwand","DEPOSIT_BALANCE":"Saldo deposito","DAILY_CHECK_PEP":"Controllo giornaliero PEP","CLIENT_NOTIFICATIONS":"Notifiche clienti","ADMIN_USERS":"Utenti Admin","IBAN_CACHE":"Cache IBAN / iban.com"},"CRYPTO":{"TITLE":"Kraken Embed","TRANSACTIONS":"Transazioni","CONVERSIONS":"Conversioni","KYC":"KYC","SETTLEMENT":"Regolamento","SETUP":"Configurazione cliente","ACCESS":"Accesso funzionalità","API_CONSOLE":"Console API","TOKENS":"Token"},"CUSTOMERS":{"TITLE":"Clienti","REGISTERED_PROFILES":"Registrato","PENDING_PROFILES":"In attesa"},"APPLICATIONS":{"TITLE":"Applicazioni","NEW":"Nuovo","PROCESSING":"Inelaborazione","DECLINED":"Rifiutato / Respinto","ON_HOLD":"In attesa","ARCHIVED":"Archiviato","MANUAL_REVIEW":"Revisione manuale"},"PAYMENT_PROCESSING":{"TITLE":{"ORDERS":"Elaborazione esterna ordini","PAYMENTS_CONTROL":"Controllo pagamenti manuali"},"REFUND":"Rimborso in uscita","CANCELLED":"Entrata cancellata","UNDELIVERED":"Non consegnato","INCOMING":"In entrata","OUTGOING":"In uscita"}}}}

/***/ }),
/* 729 */
/***/ (function(module, exports) {

	module.exports = {"FILTER":{"BUTTON":{"SEARCH":"Cerca","RESET":"Reset","SHOW":"Mostra","HIDE":"Nascondi"}}}

/***/ }),
/* 730 */
/***/ (function(module, exports) {

	module.exports = {"PROCESSING":{"FILTER":{"ID_PLACEHOLDER":"esempio 12345","PAYMENT_ID":"ID pagamento","PERIOD":"Odine creato","SCHEME":"Schema di trasferimento","ORDER_ID":"ID ordine","SENDER_NAME":"Nome mittente","SENDER_BIC":"BIC mittente","SENDER_ACCOUNT":"IBAN mittente","AMOUNT":"Importo","CUSTOMER_NAME":"Nome cliente","CUSTOMER_ACCOUNT":"IBAN cliente","PROCESSING_MODULE":"Sistema di elaborazione","PROVIDER":"Fornitore","ALL_PROVIDERS":"Tutti i fornitori","PLACEHOLDER":{"NON_SPECIFIED_NUMBER_VALUE":"esempio 12345","NON_SPECIFIED_STRING_VALUE":"esempio John Doe","SENDER_BIC":"esempio MDNDP123"}},"ACTIONS":{"SHOW_DETAILS":"Mostra dettagli","HIDE_DETAILS":"Nascondi dettagli","ACCEPT":"Accetta","REJECT":"Respingi","DELAY_PAYMENT":"Posticipa pagamento","REPROCESS":"Riprocessa"},"ITEM":{"ORDER_ID":"ID ordin","ORDER":"Ordine","PAYMENT_ID":"ID pagamento","ORDER_CREATED":"Ordine generato","REFERENCE":"Riferimento","OUTGOING_BANK_REFERENCE":"Riferimento bancario in uscita","RETURN_BANK_REFERENCE":"Riferimento bancario di reso","BANK_REFERENCE":"Riferimento bancario","MESSAGE":"Messaggio","DETAILS":"Dettagli ordine","ATTRIBUTE":"Attribuire","VALUE":"Valore","TRANSFER_INFORMATION":"Informazioni trasferimento","EMPTY_DETAILS":"Non ci sono informazioni!","STATE_LOG":"Modifiche stato ordine","ORDER_STATE":"Stato ordine","REASON":"Motivo","SUSPENSION_REASON":"Motivo della sospensione","SUSPENSION_TIME":"Tempo di sospensione","REJECTION_REASON":"Motivo del rifiuto","NO_REASON":"Nessun motivo registrato","PAYMENT_STATE_BADGE":"Pagamento: {{state}}","PAYMENT_CREATED":"Pagamento creato","SENDER_TO_BENEFICIARY":"Mittente → Beneficiario","INSTRUCTION_DATE":"Data dell'istruzione","PROVIDER_TITLE":"Fornitore (pool di liquidità) del pagamento","PAYMENT_STATE_TITLE":"Stato attuale del pagamento","AMOUNT":"importo","CURRENCY":"Valuta","ERROR":"Errore","RETURNED_AMOUNT":"Importo restituito","OUTGOING_PAYMENT_AMOUNT":"Importo pagamento in uscita","NARRATIVE":"Descrizione","REMITTANCE":"Informazioni rimessa","SENDER":{"NAME":"Nome mittente","IBAN":"IBAN mittente","ACCOUNT":"Account mittente","ULTIMATE_SENDER":"mittente finale","BIC":"BIC mittente","RISK_LEVEL":"Livello di rischio"},"CUSTOMER":{"NAME":"Nome del cliente","ACCOUNT":"Account cliente","ULTIMATE_BENEFICIARY":"beneficiario finale"},"BENEFICIARY":{"BIC":"BIC beneficiario","NAME":"Nome beneficiario","ACCOUNT":"Account beneficiario"},"FEE":"Spesa","LOG":{"DATE":"Data","USERNAME":"Username","STATE":"Stato","MESSAGE":"Messaggio","EMPTY":"Nessuna attività relativa all'ordine!"},"ALLOCATE":"Assegna","APPROVE":"Approva","REJECT":"Rifiuta","SHOW":"Mostra dettagli","HIDE":"Nascondi dettagli","NOT_UNIQUE_ACCOUNT":"Il numero di account cliente non è unico","ACCOUNT_IS_NOT_ACTIVE":"Account non attivo","MODULE":{"SEPA_MMS_CT":"SCT (SEPA-MMS)","SEPA_MMS_CT_INST":"SCT INST (SEPA-MMS)","CURRENCY_CLOUD":"CURRENCY CLOUD (FTG)"}},"EMPTY_ORDERS":"Nessun ordine trovato!","LIST":{"TOTAL":"{{total}} ordini","TOTAL_ONE":"1 ordine","SORT_TITLE":"Ordina per data di creazione dell'ordine","SORT_BY_DATE":"Ordina per data","NEWEST_FIRST":"Prima i più recenti","OLDEST_FIRST":"Prima i meno recenti"},"CANCELLED":{"TITLE":"Controllo trasferimenti in entrata annullati manualmente","REJECT":{"MODAL_TITLE":"Annullare la richiesta di cancellazione?","MODAL_ACCEPT":"Sì, mantieni la transazione","REASON":"Motivo","CHOOSE_REASON":"Scegli motivo","DESCRIPTION":"Ulteriori dettagli sul motivo dello stato di cancellazione","DESCRIPTION_REQUIRED":"Questo campo è obbligatorio, con il motivo attuale.","EMAIL_NOTIFICATION":"*Il cliente sarà informato con email dopo la conferma"},"ARCHIVED":{"DESCRIPTION":"Ulteriori dettagli sul motivo dell'archiviazione","EMAIL_NOTIFICATION":"*Il cliente verrà avvisato tramite email dopo la conferma"},"ON_HOLD":{"DESCRIPTION":"Ulteriori dettagli sul motivo dello stato di sospensione"}},"REFUND":{"TITLE":"Controllo manule trasferimenti in uscita di rimborso","EMPTY_ORDERS":"Non ci sono trasferimenti con rimborso."},"REJECTED":{"TITLE":"Controllo manuale dei trasferimenti rifiutati"},"UNDELIVERED":{"REJECT":{"MODAL_TITLE":"Respingere pagamento?","MODAL_ACCEPT":"Sì","REASON":"Motivo","CHOOSE_REASON":"Scegli motivo"},"ALLOCATE":{"MODAL_TITLE":"Assegnare il pagamento?","MODAL_QUESTION":"Vuoi assegnare ordine con id = {{id}}?","MODAL_ACCEPT":"Sì","MODAL_CLOSE":"No"}},"INCOMING":{"TITLE":"Controllo manuale pagamento / in entrata","TABS":{"NEW":"Nuovo","UNDELIVERED":"Non consegnato","REJECTED":"Respinto","WAITING_CANCELLATION":"In attesa cancellazione","SUSPENDED":"Sospeso"},"REJECT":{"MODAL_TITLE":"Respingi transazione in entrata","MODAL_ACCEPT":"Sì, respingi transazione","REASON":"Motivo","CHOOSE_REASON":"Scegli motivo","DESCRIPTION":"Ulteriori dettagli sul motivo del rifiuto","DESCRIPTION_REQUIRED":"Questo campo è obbligatorio, con il motivo attuale."},"REPROCESS":{"DIALOG_TITLE":"Riprocessare transazione in entrata","DIALOG_REPROCESS":"Riprocessa","DESCRIPTION":"Verrà accreditato il trasferimento in entrata nell'account del cliente, sei sicuro di voler continuare?"},"ACCEPT":{"DIALOG_TITLE":"Accetta richiesta cancellazione","DIALOG_DESCRIPTION":"Sei sicuro di voler continuare?","SUCCESS":"Richiesta di cancellazione approvata. Restituzione pagamento creata - ID {{id}}","DIALOG_ACCEPT":"Accetta"}},"OUTGOING":{"EMPTY_ORDERS":"Non ci sono trasferimenti in uscita.","TITLE":"Controllo manuale pagamento / In uscita","TABS":{"RETURNED":"Restituito","REJECTED":"Rifiutato","IN_PROGRESS":"In corso"},"ORDER_STATE":{"NEW":"Nuovo","IN_PROGRESS":"In corso"},"IN_PROGRESS":{"STALE_BADGE":"Superato","STALE":"Lo stato del pagamento è {{state}}: questo ordine non è più in sospeso."},"DIALOG":{"REASON":"Specifica motivo:"},"REJECTED_ORDER":{"SUB_ACCOUNT_BADGE":"Pagamento da sottoconto","CLIENT":"Cliente: {{clientName}} · Sottoconto {{clientAccount}}","MASTER_PART":"Questa è la parte del conto master. Parte del cliente: pagamento","SUBACCOUNT_PART":"Questa è la parte del cliente. Parte del conto master: pagamento","RELEASE":"Accettando si rifiutano entrambe le parti e si sbloccano {{amount}} al cliente.","ALSO_REJECTS_MASTER":"Accettando si rifiuta anche la parte del conto master (pagamento {{linkedPaymentId}}).","NOT_ACCEPTABLE":"Questo ordine non può essere accettato: il pagamento {{id}} è già {{state}}.","NOT_ACCEPTABLE_NO_PAYMENT":"Questo ordine non può essere accettato: non ha un pagamento in uscita in elaborazione esterna.","EMPTY":"Nessun ordine in uscita rifiutato","EMPTY_HINT":"Gli ordini restano qui finché il loro rifiuto non viene accettato. Modifica i filtri per cercare di nuovo.","ACCEPT_DISABLED":"Non è possibile accettare: il pagamento di questo ordine non è più in elaborazione esterna.","DIALOG":{"SUMMARY":"Rifiuta il pagamento {{id}} · {{amount}} · a {{recipient}}","SUB_ACCOUNT_MASTER":"Pagamento da sottoconto di {{clientName}} (viene rifiutata anche la parte del cliente, pagamento {{linkedPaymentId}})","SUB_ACCOUNT_MASTER_INFO":"Pagamento da sottoconto di {{clientName}} (parte del cliente: pagamento {{linkedPaymentId}}, {{state}})","SUB_ACCOUNT_CLIENT":"Pagamento da sottoconto di {{clientName}} (viene rifiutata anche la parte del conto master, pagamento {{linkedPaymentId}})","SUB_ACCOUNT_CLIENT_INFO":"Pagamento da sottoconto di {{clientName}} (parte del conto master: pagamento {{linkedPaymentId}}, {{state}})","EMAIL_WARNING":"Il testo qui sotto viene inviato al cliente nell'email di rifiuto.","RECIPIENTS_TITLE":"Invia l'email di rifiuto a","RECIPIENTS_HINT":"Utenti con accesso al conto {{account}}. Nessuna selezione: non viene inviata alcuna email.","RECIPIENTS_LOADING":"Caricamento destinatari...","RECIPIENTS_ERROR":"Impossibile caricare i destinatari. L'email va all'indirizzo configurato per i pagamenti rifiutati.","SELECT_ALL":"Seleziona tutti","SELECTED":"{{selected}} di {{total}} selezionati","CONFIGURED_EMAIL":"Email per i pagamenti rifiutati del cliente","NO_CONFIGURED_EMAIL":"Il cliente non ha configurato un'email per i pagamenti rifiutati.","NO_USERS":"Nessun utente attivo ha accesso a questo conto.","NO_RECIPIENTS_WARNING":"Nessun destinatario selezionato: il rifiuto verrà accettato senza inviare email."}},"ERROR":{"FILTERS":"Filtri","MERCHANT_TXN_REF":"Rif. transazione merchant","MERCHANT_TXN_REF_PLACEHOLDER":"Cerca per rif. transazione merchant...","CREATED_AT":"Creato il","CREATED_AT_PLACEHOLDER":"Cerca per data (gg.mm.aaaa)...","AMOUNT":"Importo","AMOUNT_PLACEHOLDER":"Cerca per importo...","CLEAR_FILTERS":"Cancella filtri","SHOWING":"Visualizzati {{shown}} di {{total}} risultati","LOAD_ERROR":"Impossibile caricare dal payment gateway i pagamenti in errore. Questo non significa che non ce ne siano.","RETRY":"Riprova","REPROCESS_SUCCESS":"Pagamento rielaborato correttamente","REJECT_SUCCESS":"Pagamento rifiutato correttamente","REJECT_DIALOG":{"TITLE":"Rifiutare questo pagamento FinXP?","REFERENCE":"Riferimento pagamento: {{reference}}","AMOUNT":"Importo: {{amount}}","BENEFICIARY":"Beneficiario: {{beneficiary}}","WARNING":"Il pagamento viene rifiutato nel gateway FinXP con motivo UNKNOWN.","CONFIRM":"Sì, rifiuta il pagamento"}}},"MANUAL":{"ACCEPT":{"DIALOG_TITLE":"Accetta ordine in entrata","DIALOG_DESCRIPTION":"Verrà accreditato il trasferimento in entrata nell'account del cliente, sei sicuro di voler continuare?","DIALOG_ACCEPT":"Accetta"}},"RETURNED":{"EMPTY_ORDERS":"Nessun trasferimento restituito.","APPROVE_UNDELIVERED":{"FAILURE":"Qualcosa è cambiato dopo il tentativo di approvazione iniziale,  si prega di riprovare","MODAL_TITLE":"Verrà creto un pagamento non consegnato","MODAL_QUESTION":"Motivo(i):","MODAL_ACCEPT":"Sì, crea pagamento non consegnato","MODAL_CLOSE":"No"}}}}

/***/ }),
/* 731 */
/***/ (function(module, exports) {

	module.exports = {"REPORTS":{"OVERVIEW":{"TITLE":"Report","SUBTITLE":"Seleziona un report da generare e scaricare.","OPEN":"Apri Report","COUNT":"report disponibili","LEGACY_CONFIG":"Config DB Legacy"},"RUNNER":{"BACK":"Torna ai Report","FORMAT":"Formato di output","FORMAT_PDF_DESC":"Documento formattato","FORMAT_CSV_DESC":"Foglio di calcolo / esportazione dati","PARAMETERS":"Parametri del report","REQUIRED_HINT":"I campi contrassegnati con * sono obbligatori","GENERATE":"Genera Report","GENERATING":"Generazione in corso...","CANCEL":"Annulla","FIELD_REQUIRED":"Questo campo è obbligatorio.","SUCCESS":"Report generato con successo. Download avviato.","LEGACY_BADGE":"DB obsoleto","LEGACY_WARNING_TITLE":"Origine dati non aggiornata.","LEGACY_WARNING_TEXT":"Questo report interroga il database di reporting legacy (webbank), che non è più la fonte autoritativa e può contenere dati obsoleti o incompleti. Da usare solo per riconciliazioni storiche.","PRESETS":"Selezione rapida","PROVIDER_HINT":"seleziona uno o più provider, o usa una selezione rapida","PROVIDERS_SELECTED":"provider selezionati"},"PROVIDER_PRESET":{"ALL":"Tutti i provider (nessun filtro)","MOORWAND_MODULR_MODULR_ES_3R":"Moorwand + Modulr + Modulr ES + 3R","MOORWAND_MODULR_MODULR_ES":"Moorwand + Modulr + Modulr ES","MOORWAND_MODULR":"Moorwand + Modulr"},"FIELD":{"ACCOUNT_NUMBER":"Numero conto","IBAN":"IBAN","TRX_ID":"ID transazione","PERIOD":"Periodo (Da / A)","PERIOD_BASIC":"Periodo estratto (Inizio / Fine)","END_DATE":"Data fine","STATEMENT_TYPE":"Tipo di estratto","PROVIDER":"Provider","REVENUE_POOL":"Pool ricavi","REPORT_VARIANT":"Report"},"STMT_TYPE":{"PDF_BASIC":"Estratto conto PDF","PDF_PAYTAH":"Estratto conto PDF PAYTAH","CSV_BASIC":"Estratto conto CSV","CSV_PAYTAH":"Estratto conto CSV PAYTAH"},"PROVIDER":{"ALL":"Tutti i provider","DEFAULT":"Tutti i provider","PAYTAH":"Paytah","MOORWAND":"Moorwand","3R":"3R","VERIFO":"Verifo","EMONEY":"3R","FINXP":"FinXp","MODULR":"Modulr","MODULR_ES":"Modulr ES","PAYSWIX":"Payswix","MONETUM_SUBACCOUNT":"Monetum Subaccount","MONETUM_NOIBAN":"Monetum No-IBAN"},"REVENUE_POOL":{"ALL":"Tutti i pool ricavi","MOORWAND":"Moorwand","EMONEY":"3R","MODULR":"Modulr","FINXP":"FinXp","PAYSWIX":"Payswix","MONETUM_SUBACCOUNT":"Monetum Subaccount"},"REVENUE_VARIANT":{"BALANCE_MODIFICATIONS":"Revenue Account Balance Modifications","TRANSACTIONS":"Revenue Account Transactions Statement","MODULR_MOORWAND":"Revenue Account Transactions Statement - Monetum Pay (Modulr-MW)","MOORWAND":"Revenue Account Transactions Statement - Moorwand","THREE_R":"Revenue Account Transactions Statement - 3R"},"CUSTOMER_ACCOUNT_STATEMENT":{"TITLE":"Estratto conto cliente","DESC":"Genera un estratto conto completo (PDF o CSV) per numero conto e periodo."},"CUSTOMER_BALANCES":{"TITLE":"Saldi clienti","DESC":"Snapshot dei saldi di tutti i conti cliente a una data specificata."},"FEE_ERRORS":{"TITLE":"Errori commissioni","DESC":"Elenco delle transazioni con errori nell'elaborazione delle commissioni."},"TRANSACTION_DETAIL":{"TITLE":"Dettaglio transazione","DESC":"Vista completa di una singola transazione di pagamento tramite ID."},"REVENUE_ACCOUNT":{"TITLE":"Conto ricavi","DESC":"Transazioni del conto ricavi per un periodo specificato."},"TX_RECONCILIATION":{"TITLE":"Riconciliazione TX","DESC":"Report di riconciliazione di tutte le transazioni per provider."},"LEGACY_CONFIG":{"TITLE":"Configurazione DB Legacy","DESC":"Gestisci le connessioni ai database di reporting legacy. La connessione attiva è utilizzata esclusivamente dai report estratti conto Paytah (PDF e CSV). Solo una connessione può essere attiva alla volta — attivarne una nuova disattiva automaticamente quella corrente.","SAVED_CONFIGS":"Connessioni salvate","ADD_NEW":"Aggiungi connessione","NO_CONFIGS":"Nessuna connessione configurata. Clicca \"Aggiungi connessione\" per iniziare.","NEW_CONFIG":"Nuova connessione","EDIT_CONFIG":"Modifica connessione","COL_NAME":"Nome","COL_URL":"URL JDBC","COL_USER":"Utente","COL_DATABASE":"Database","COL_STATUS":"Stato","NAME":"Nome connessione","CONNECTION":"Impostazioni connessione JDBC","HOST":"Host","PORT":"Porta","DATABASE":"Database","SSL_MODE":"Modalità SSL","JDBC_URL_PREVIEW":"URL JDBC","JDBC_URL_MANUAL_MODE":"Inserisci URL completo manualmente","JDBC_URL_FIELDS_MODE":"Usa i campi individuali","JDBC_URL_MANUAL_HINT":"Incolla un URL JDBC completo, es. jdbc:postgresql://host:5432/db o jdbc:postgresql://host:5432/db?sslmode=require","USERNAME":"Nome utente","PASSWORD":"Password","MAX_ACTIVE":"Dimensione max pool","POOL_ACTIVE":"Pool attivo","POOL_INACTIVE":"Pool inattivo","INACTIVE":"Inattivo","ACTIVATE":"Attiva","LAST_UPDATED":"Ultimo aggiornamento","TEST_CONNECTION":"Testa connessione","TESTING":"Test in corso...","TEST_SUCCESS":"Connessione riuscita! Le credenziali sono valide.","TEST_FAILED":"Connessione fallita","SAVE":"Salva","SAVING":"Salvataggio...","SAVE_SUCCESS":"Configurazione salvata con successo.","ERROR_LOAD":"Impossibile caricare le configurazioni del datasource legacy.","ERROR_SAVE":"Impossibile salvare la configurazione. Riprovare.","ERROR_ACTIVATE":"Impossibile attivare la configurazione. Riprovare.","ERROR_DELETE":"Impossibile eliminare la configurazione. Riprovare."},"MOORWAND_BALANCE":{"TITLE":"Report giornaliero saldi IBAN Moorwand","DESC":"Scarica il report giornaliero dei saldi di tutti gli IBAN Moorwand in formato Excel.","INFO":"Questo report viene generato su richiesta e scaricato direttamente in formato Excel.","AUTO_INFO":"Questo report viene anche generato automaticamente ogni giorno e trasmesso a Moorwand. Usa questa pagina per scaricarlo manualmente per qualsiasi data.","DOWNLOAD":"Scarica report","DATE_HINT":"Seleziona la data dei dati che vuoi visualizzare. Esempio: seleziona il 14 per ottenere i saldi del 14. Il report automatico viene eseguito alle 00:30h del 15 e contiene i dati del 14.","CUTOFF":{"TITLE":"Configurazione ora di taglio giornaliero","DESC":"Moorwand chiude ogni giornata di rendicontazione a mezzanotte ora di Londra. A seconda del periodo dell'anno, questo corrisponde a un'ora UTC diversa. Selezionare la modalità corretta — si applica sia al report automatico giornaliero che a qualsiasi download manuale in questa pagina.","LABEL":"Modalità oraria attiva","OPT_SUMMER":"Estate / BST (mar–ott) — taglio alle 22:59:59 UTC (mezzanotte Londra UTC+1)","OPT_WINTER":"Inverno / GMT (nov–mar) — taglio alle 23:59:59 UTC (mezzanotte Londra UTC+0)","HINT":"Ultimo cambio ora UK: 30 mar 2026 → BST attivo. Prossimo cambio: 26 ott 2026 → GMT.","LOADING":"Caricamento configurazione...","SAVE":"Salva configurazione","SAVING":"Salvataggio...","SAVED":"Configurazione salvata con successo.","LOAD_ERROR":"Impossibile caricare la configurazione. Aggiornare la pagina.","SAVE_ERROR":"Impossibile salvare la configurazione. Riprovare."}},"ERROR":{"GENERATION_FAILED":"Generazione del report fallita. Controllare i parametri e riprovare.","INVALID_DATE":"Seleziona una data valida prima di scaricare.","BUSY":"È in corso la generazione di un altro report. Riprovare tra un minuto.","TOO_MANY_ROWS":"Questo report contiene {{rows}} transazioni e un file {{format}} ne può contenere al massimo {{max}}. Selezionare un intervallo di date più breve.","TOO_MANY_ROWS_OVER":"Questo report contiene più di {{max}} transazioni, il massimo per un file {{format}}. Selezionare un intervallo di date più breve."}}}

/***/ }),
/* 732 */
/***/ (function(module, exports) {

	module.exports = {"BY_VENDOR":{"SPACE.TRADE":"Paytah","LOGIN.HEADER":"Accedi al Back-office Paytah","CUSTOMER":{"ADDITIONAL":{"SEND_NOTIFICATIONS":"Paytah invia notifiche","SEND_NOTIFICATIONS_TRUE":"Vorrei che Paytah mi inviasse offerte commerciali, materiale promozionale e / o analitico.","SEND_NOTIFICATIONS_FALSE":"Non desidero che Paytah mi invii materiale promozionale. Riconosco che in questo caso il White Label potrebbe non essere in grado di offrirmi nuovi, migliori servizi e / o termini di manutenzione dell'account.","REASON":"Motivi per scegliere Paytah","SOURCE":"Fonte informazioni su Paytah"}}}}

/***/ }),
/* 733 */
/***/ (function(module, exports) {

	module.exports = {"BY_VENDOR":{"SPACE.TRADE":"White Label","LOGIN.HEADER":"Accedi al Back-office White Label","CUSTOMER":{"ADDITIONAL":{"SEND_NOTIFICATIONS":"White Label invia notifiche","SEND_NOTIFICATIONS_TRUE":"Vorrei che White Label mi inviasse offerte commerciali, materiale promozionale e / o analitico.","SEND_NOTIFICATIONS_FALSE":"Non desidero che White Label mi invii materiale promozionale. Riconosco che in questo caso il White Label potrebbe non essere in grado di offrirmi nuovi, migliori servizi e / o termini di manutenzione dell'account.","REASON":"Motivi per scegliere White Label","SOURCE":"Fonte informazioni su White Label"}}}}

/***/ }),
/* 734 */
/***/ (function(module, exports) {

	module.exports = "<main>\n    <router-outlet></router-outlet>\n    <tfl-option-dialog></tfl-option-dialog>\n</main>\n"

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var router_1 = __webpack_require__(270);
	var security_1 = __webpack_require__(736);
	var login_1 = __webpack_require__(858);
	var space_1 = __webpack_require__(874);
	var error_1 = __webpack_require__(890);
	var dashboard_1 = __webpack_require__(895);
	var blank_component_1 = __webpack_require__(898);
	var roles_guard_1 = __webpack_require__(856);
	var routes = [
	    {
	        path: '',
	        pathMatch: 'full',
	        redirectTo: 'login'
	    },
	    {
	        path: 'login',
	        component: login_1.LoginComponent
	    },
	    {
	        path: 'space',
	        component: space_1.SpaceComponent,
	        canActivate: [security_1.SessionGuard],
	        canActivateChild: [security_1.SessionGuard],
	        children: [
	            {
	                path: '',
	                pathMatch: 'full',
	                redirectTo: 'accounts',
	                canActivate: [roles_guard_1.RolesGuard],
	                canActivateChild: [roles_guard_1.RolesGuard],
	            },
	            {
	                path: 'applications',
	                loadChildren: function () { return new Promise(function (resolve) { __webpack_require__.e/* nsure */(1, function (require) { resolve(__webpack_require__(899)['ApplicationsModule']); }); }); },
	                canActivate: [roles_guard_1.RolesGuard],
	                canActivateChild: [roles_guard_1.RolesGuard],
	            },
	            {
	                path: 'customers',
	                loadChildren: function () { return new Promise(function (resolve) { __webpack_require__.e/* nsure */(2, function (require) { resolve(__webpack_require__(1900)['CustomersModule']); }); }); },
	                canActivate: [roles_guard_1.RolesGuard],
	                canActivateChild: [roles_guard_1.RolesGuard],
	            },
	            {
	                path: 'accounts',
	                loadChildren: function () { return new Promise(function (resolve) { __webpack_require__.e/* nsure */(3, function (require) { resolve(__webpack_require__(2050)['AccountsModule']); }); }); },
	                canActivate: [roles_guard_1.RolesGuard],
	                canActivateChild: [roles_guard_1.RolesGuard],
	            },
	            {
	                path: 'transfers/outgoing',
	                loadChildren: function () { return new Promise(function (resolve) { __webpack_require__.e/* nsure */(4, function (require) { resolve(__webpack_require__(2088)['OutgoingTransfersModule']); }); }); },
	                canActivate: [roles_guard_1.RolesGuard],
	                canActivateChild: [roles_guard_1.RolesGuard],
	            },
	            {
	                path: 'cards',
	                loadChildren: function () { return new Promise(function (resolve) { __webpack_require__.e/* nsure */(5, function (require) { resolve(__webpack_require__(2150)['CardsModule']); }); }); },
	                canActivate: [roles_guard_1.RolesGuard],
	                canActivateChild: [roles_guard_1.RolesGuard],
	            },
	            {
	                path: 'transfers/card',
	                loadChildren: function () { return new Promise(function (resolve) { __webpack_require__.e/* nsure */(6, function (require) { resolve(__webpack_require__(2156)['CardTransfersModule']); }); }); },
	                canActivate: [roles_guard_1.RolesGuard.forRoles(security_1.Roles.EDIT)],
	                canActivateChild: [roles_guard_1.RolesGuard.forRoles(security_1.Roles.EDIT)],
	            },
	            {
	                path: 'history',
	                loadChildren: function () { return new Promise(function (resolve) { __webpack_require__.e/* nsure */(7, function (require) { resolve(__webpack_require__(2170)['HistoryModule']); }); }); },
	                canActivate: [roles_guard_1.RolesGuard],
	                canActivateChild: [roles_guard_1.RolesGuard],
	            },
	            {
	                path: 'crypto',
	                loadChildren: function () { return new Promise(function (resolve) { __webpack_require__.e/* nsure */(8, function (require) { resolve(__webpack_require__(2203)['CryptoModule']); }); }); },
	                canActivate: [roles_guard_1.RolesGuard],
	                canActivateChild: [roles_guard_1.RolesGuard],
	            },
	            {
	                path: 'open-banking',
	                loadChildren: function () { return new Promise(function (resolve) { __webpack_require__.e/* nsure */(9, function (require) { resolve(__webpack_require__(2232)['OpenBankingModule']); }); }); },
	                canActivate: [roles_guard_1.RolesGuard],
	                canActivateChild: [roles_guard_1.RolesGuard],
	            },
	            {
	                path: 'transfers/incoming',
	                loadChildren: function () { return new Promise(function (resolve) { __webpack_require__.e/* nsure */(10, function (require) { resolve(__webpack_require__(2322)['IncomingTransfersModule']); }); }); },
	                canActivate: [roles_guard_1.RolesGuard.forRoles(security_1.Roles.EDIT)],
	                canActivateChild: [roles_guard_1.RolesGuard.forRoles(security_1.Roles.EDIT)],
	            },
	            {
	                path: 'transfers/internal',
	                loadChildren: function () { return new Promise(function (resolve) { __webpack_require__.e/* nsure */(11, function (require) { resolve(__webpack_require__(2356)['InternalTransfersModule']); }); }); },
	                canActivate: [roles_guard_1.RolesGuard],
	                canActivateChild: [roles_guard_1.RolesGuard],
	            },
	            {
	                path: 'configuration',
	                loadChildren: function () { return new Promise(function (resolve) { __webpack_require__.e/* nsure */(12, function (require) { resolve(__webpack_require__(2371)['ConfigurationModule']); }); }); },
	                canActivate: [roles_guard_1.RolesGuard.forRoles(security_1.Roles.VIEW)],
	                canActivateChild: [roles_guard_1.RolesGuard.forRoles(security_1.Roles.VIEW)],
	            },
	            {
	                path: 'transfers/system',
	                loadChildren: function () { return new Promise(function (resolve) { __webpack_require__.e/* nsure */(13, function (require) { resolve(__webpack_require__(2465)['SystemTransferModule']); }); }); },
	                canActivate: [roles_guard_1.RolesGuard.forRoles(security_1.Roles.EDIT)],
	                canActivateChild: [roles_guard_1.RolesGuard.forRoles(security_1.Roles.EDIT)],
	            },
	            {
	                path: 'processing/external-orders',
	                loadChildren: function () { return new Promise(function (resolve) { __webpack_require__.e/* nsure */(14, function (require) { resolve(__webpack_require__(2498)['PaymentProcessingModule']); }); }); },
	                canActivate: [roles_guard_1.RolesGuard],
	                canActivateChild: [roles_guard_1.RolesGuard],
	            },
	            {
	                path: 'processing/manual-controls',
	                loadChildren: function () { return new Promise(function (resolve) { __webpack_require__.e/* nsure */(15, function (require) { resolve(__webpack_require__(2516)['ManualPaymentControlsModule']); }); }); },
	                canActivate: [roles_guard_1.RolesGuard],
	                canActivateChild: [roles_guard_1.RolesGuard],
	            },
	            {
	                path: 'reports',
	                loadChildren: function () { return new Promise(function (resolve) { __webpack_require__.e/* nsure */(16, function (require) { resolve(__webpack_require__(2585)['ReportsModule']); }); }); },
	                canActivate: [roles_guard_1.RolesGuard],
	                canActivateChild: [roles_guard_1.RolesGuard],
	            },
	            {
	                path: 'error',
	                component: error_1.ErrorComponent
	            },
	            {
	                path: 'unauthorized',
	                component: error_1.UnauthorizedComponent
	            }
	        ]
	    },
	    {
	        path: 'error',
	        component: error_1.ErrorComponent
	    },
	    {
	        path: 'unauthorized',
	        component: error_1.UnauthorizedComponent
	    },
	    {
	        path: 'blank',
	        component: blank_component_1.BlankComponent
	    }
	];
	exports.ROUTER = router_1.RouterModule.forRoot(routes, { useHash: true });
	exports.ROUTER_COMPONENTS = [
	    login_1.LoginComponent,
	    space_1.SpaceComponent,
	    error_1.ErrorComponent,
	    error_1.UnauthorizedComponent,
	    blank_component_1.BlankComponent,
	    dashboard_1.DashboardComponent
	].concat(login_1.LOGIN_COMPONENTS, space_1.SPACE_COMPONENTS);


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var router_1 = __webpack_require__(270);
	var session_guard_1 = __webpack_require__(737);
	var session_service_1 = __webpack_require__(850);
	var role_service_1 = __webpack_require__(851);
	__export(__webpack_require__(737));
	__export(__webpack_require__(850));
	__export(__webpack_require__(851));
	__export(__webpack_require__(855));
	__export(__webpack_require__(857));
	exports.SESSION_SECURITY_PROVIDERS = [
	    role_service_1.RoleService,
	    session_service_1.SessionService,
	    {
	        provide: session_guard_1.SessionGuard,
	        useClass: session_guard_1.SessionGuard,
	        deps: [router_1.Router, session_service_1.SessionService, role_service_1.RoleService]
	    }
	];


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var router_1 = __webpack_require__(270);
	var cookies_1 = __webpack_require__(738);
	var security_1 = __webpack_require__(736);
	var SessionGuard = (function () {
	    function SessionGuard(_router, _sessionService, roleService) {
	        this._router = _router;
	        this._sessionService = _sessionService;
	        this.roleService = roleService;
	    }
	    SessionGuard.prototype.canActivate = function (route, state) {
	        return this.checkToken(state.url);
	    };
	    SessionGuard.prototype.canActivateChild = function (childRoute, state) {
	        return this.checkToken(state.url);
	    };
	    SessionGuard.prototype.checkToken = function (url) {
	        if (this.isTokenExist()) {
	            if (this.roleService.arePermissionsLoaded()) {
	                return true;
	            }
	            else {
	                return this.roleService.fetchPermissions()
	                    .map(function () { return true; });
	            }
	        }
	        this.saveDestinationURL(url);
	        this._sessionService.setSessionCloseAsExpire();
	        this._router.navigate(['login']);
	        return false;
	    };
	    SessionGuard.prototype.isTokenExist = function () {
	        return cookies_1.CookiesManager.isTokenExist();
	    };
	    SessionGuard.prototype.saveDestinationURL = function (url) {
	        if (!url.includes('login') && url.length > 3) {
	            cookies_1.CookiesManager.setDestinationURL(url);
	        }
	    };
	    SessionGuard = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [router_1.Router,
	            security_1.SessionService,
	            security_1.RoleService])
	    ], SessionGuard);
	    return SessionGuard;
	}());
	exports.SessionGuard = SessionGuard;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(739));


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(740);
	var StorageHolder_1 = __webpack_require__(848);
	var CookiesManager = (function () {
	    function CookiesManager() {
	    }
	    CookiesManager.isTokenExist = function () {
	        return utils_1.CookieUtils.check(CookiesManager.TOKEN_COOKIE);
	    };
	    CookiesManager.getToken = function () {
	        return utils_1.CookieUtils.get(CookiesManager.TOKEN_COOKIE);
	    };
	    CookiesManager.getTokenExpireMinutes = function () {
	        return JSON.parse(StorageHolder_1.StorageHolder.localStorage.getItem(CookiesManager.TOKEN_EXPIRES));
	    };
	    CookiesManager.setToken = function (token, expires) {
	        if (expires) {
	            StorageHolder_1.StorageHolder.localStorage.setItem(CookiesManager.TOKEN_EXPIRES, JSON.stringify(expires));
	        }
	        utils_1.CookieUtils.set(CookiesManager.TOKEN_COOKIE, token, CookiesManager.getTokenExpireDate());
	    };
	    CookiesManager.clearToken = function () {
	        utils_1.CookieUtils.remove(CookiesManager.TOKEN_COOKIE);
	    };
	    CookiesManager.isDestinationURLExists = function () {
	        return utils_1.CookieUtils.check(CookiesManager.DESTINATION_URL_COOKIE);
	    };
	    CookiesManager.getDestinationURL = function () {
	        return utils_1.CookieUtils.get(CookiesManager.DESTINATION_URL_COOKIE);
	    };
	    CookiesManager.setDestinationURL = function (url) {
	        utils_1.CookieUtils.set(CookiesManager.DESTINATION_URL_COOKIE, url);
	    };
	    CookiesManager.clearDestinationURL = function () {
	        utils_1.CookieUtils.remove(CookiesManager.DESTINATION_URL_COOKIE);
	    };
	    CookiesManager.getTokenExpireDate = function () {
	        return new Date(new Date().getTime() + CookiesManager.getTokenExpireMinutes() * 1000 * 60);
	    };
	    CookiesManager.TOKEN_EXPIRES = 'BS-Token-Lifetime';
	    CookiesManager.TOKEN_COOKIE = 'BS-Auth-Token';
	    CookiesManager.DESTINATION_URL_COOKIE = 'BS-Destination-URL';
	    return CookiesManager;
	}());
	exports.CookiesManager = CookiesManager;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(741));
	__export(__webpack_require__(742));
	__export(__webpack_require__(746));
	__export(__webpack_require__(750));
	__export(__webpack_require__(751));
	__export(__webpack_require__(752));
	__export(__webpack_require__(755));
	__export(__webpack_require__(767));
	__export(__webpack_require__(832));
	__export(__webpack_require__(833));
	__export(__webpack_require__(834));
	__export(__webpack_require__(835));
	__export(__webpack_require__(837));


/***/ }),
/* 741 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var JSONUtils = (function () {
	    function JSONUtils() {
	    }
	    return JSONUtils;
	}());
	exports.JSONUtils = JSONUtils;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(743);
	var StringUtils = (function () {
	    function StringUtils() {
	    }
	    StringUtils.getStringToSetStrongTag = function (item, name) {
	        var positions = [];
	        var searchWordsKeys = Object.keys(item.metadata);
	        searchWordsKeys.forEach(function (key) {
	            if (!!item.metadata[key][name]) {
	                item.metadata[key][name].position.forEach(function (pos) {
	                    return positions.push(pos);
	                });
	            }
	        });
	        return this.addStrongTag(item[name], this.intersect(positions));
	    };
	    StringUtils.addStrongTag = function (source, positions) {
	        var startTag = '<b>';
	        var endTag = '</b>';
	        for (var i = 0, offset = 0; i < positions.length; i++, offset += 7) {
	            var start = positions[i];
	            source = source.slice(0, start[0] + offset) + startTag + source.slice(start[0] + offset, start[1] + offset) + endTag + source.slice(start[1] + offset, source.length);
	        }
	        return source;
	    };
	    StringUtils.intersect = function (positions) {
	        var highlightPositions = [];
	        if (positions.length == 0) {
	            return highlightPositions;
	        }
	        if (positions.length == 1) {
	            highlightPositions.push([positions[0][0], positions[0][0] + positions[0][1]]);
	            return highlightPositions;
	        }
	        positions.sort(function (a, b) {
	            return a[0] < b[0] ? -1 : 1;
	        });
	        var startIndex = positions[0][0], endIndex = positions[0][0] + positions[0][1];
	        for (var current = 0, next = 1; current < positions.length; current++, next++) {
	            if (next < positions.length && endIndex > positions[next][0]) {
	                var nextEndIndex = positions[next][0] + positions[next][1];
	                endIndex = nextEndIndex > endIndex ? nextEndIndex : endIndex;
	                continue;
	            }
	            highlightPositions.push([startIndex, endIndex]);
	            if (next < positions.length) {
	                startIndex = positions[next][0];
	                endIndex = positions[next][0] + positions[next][1];
	            }
	        }
	        return highlightPositions;
	    };
	    StringUtils.equalsIgnoreCase = function (str1, str2) {
	        return !util_1.isNullOrUndefined(str1)
	            && !util_1.isNullOrUndefined(str1)
	            && str1.toLocaleLowerCase().localeCompare(str2.toLocaleLowerCase()) == 0;
	    };
	    StringUtils.isBlank = function (str) {
	        return str.trim().length === 0;
	    };
	    StringUtils.contains = function (parentStr, childStr, ignoreCase) {
	        if (ignoreCase) {
	            parentStr = parentStr.toLowerCase();
	            childStr = childStr.toLowerCase();
	        }
	        return parentStr.indexOf(childStr) > -1;
	    };
	    return StringUtils;
	}());
	exports.StringUtils = StringUtils;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(744);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(745);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(604)))

/***/ }),
/* 744 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 745 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var browser = __webpack_require__(747);
	var BrowserUtils = (function () {
	    function BrowserUtils() {
	    }
	    BrowserUtils.isBrowser = function (name) {
	        return browser.name === name;
	    };
	    BrowserUtils.EDGE = "edge";
	    BrowserUtils.CHROME = "chrome";
	    BrowserUtils.FIREFOX = "firefox";
	    BrowserUtils.OPERA = "opera";
	    BrowserUtils.IE = "ie";
	    BrowserUtils.ANDROID = "android";
	    BrowserUtils.IOS = "ios";
	    BrowserUtils.SAFARI = "safari";
	    return BrowserUtils;
	}());
	exports.BrowserUtils = BrowserUtils;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	var detectBrowser = __webpack_require__(748);
	
	var agent;
	
	if (typeof navigator !== 'undefined' && navigator) {
	  agent = navigator.userAgent;
	}
	
	module.exports = detectBrowser(agent);


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	var detectOS = __webpack_require__(749);
	
	module.exports = function detectBrowser(userAgentString) {
	  if (!userAgentString) return null;
	
	  var browsers = [
	    [ 'edge', /Edge\/([0-9\._]+)/ ],
	    [ 'yandexbrowser', /YaBrowser\/([0-9\._]+)/ ],
	    [ 'vivaldi', /Vivaldi\/([0-9\.]+)/ ],
	    [ 'kakaotalk', /KAKAOTALK\s([0-9\.]+)/ ],
	    [ 'chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/ ],
	    [ 'phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/ ],
	    [ 'crios', /CriOS\/([0-9\.]+)(:?\s|$)/ ],
	    [ 'firefox', /Firefox\/([0-9\.]+)(?:\s|$)/ ],
	    [ 'fxios', /FxiOS\/([0-9\.]+)/ ],
	    [ 'opera', /Opera\/([0-9\.]+)(?:\s|$)/ ],
	    [ 'opera', /OPR\/([0-9\.]+)(:?\s|$)$/ ],
	    [ 'ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/ ],
	    [ 'ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/ ],
	    [ 'ie', /MSIE\s(7\.0)/ ],
	    [ 'bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/ ],
	    [ 'android', /Android\s([0-9\.]+)/ ],
	    [ 'ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/ ],
	    [ 'safari', /Version\/([0-9\._]+).*Safari/ ]
	  ];
	
	  return browsers.map(function (rule) {
	      if (rule[1].test(userAgentString)) {
	          var match = rule[1].exec(userAgentString);
	          var version = match && match[1].split(/[._]/).slice(0,3);
	
	          if (version && version.length < 3) {
	              Array.prototype.push.apply(version, (version.length == 1) ? [0, 0] : [0]);
	          }
	
	          return {
	              name: rule[0],
	              version: version.join('.'),
	              os: detectOS(userAgentString)
	          };
	      }
	  }).filter(Boolean).shift();
	};


/***/ }),
/* 749 */
/***/ (function(module, exports) {

	module.exports = function detectOS(userAgentString) {
	  var operatingSystems = [
	    {
	      name: 'iOS',
	      rule: /iP(hone|od|ad)/
	    },
	    {
	      name: 'Android OS',
	      rule: /Android/
	    },
	    {
	      name: 'BlackBerry OS',
	      rule: /BlackBerry|BB10/
	    },
	    {
	      name: 'Windows Mobile',
	      rule: /IEMobile/
	    },
	    {
	      name: 'Amazon OS',
	      rule: /Kindle/
	    },
	    {
	      name: 'Windows 3.11',
	      rule: /Win16/
	    },
	    {
	      name: 'Windows 95',
	      rule: /(Windows 95)|(Win95)|(Windows_95)/
	    },
	    {
	      name: 'Windows 98',
	      rule: /(Windows 98)|(Win98)/
	    },
	    {
	      name: 'Windows 2000',
	      rule: /(Windows NT 5.0)|(Windows 2000)/
	    },
	    {
	      name: 'Windows XP',
	      rule: /(Windows NT 5.1)|(Windows XP)/
	    },
	    {
	      name: 'Windows Server 2003',
	      rule: /(Windows NT 5.2)/
	    },
	    {
	      name: 'Windows Vista',
	      rule: /(Windows NT 6.0)/
	    },
	    {
	      name: 'Windows 7',
	      rule: /(Windows NT 6.1)/
	    },
	    {
	      name: 'Windows 8',
	      rule: /(Windows NT 6.2)/
	    },
	    {
	      name: 'Windows 8.1',
	      rule: /(Windows NT 6.3)/
	    },
	    {
	      name: 'Windows 10',
	      rule: /(Windows NT 10.0)/
	    },
	    {
	      name: 'Windows ME',
	      rule: /Windows ME/
	    },
	    {
	      name: 'Open BSD',
	      rule: /OpenBSD/
	    },
	    {
	      name: 'Sun OS',
	      rule: /SunOS/
	    },
	    {
	      name: 'Linux',
	      rule: /(Linux)|(X11)/
	    },
	    {
	      name: 'Mac OS',
	      rule: /(Mac_PowerPC)|(Macintosh)/
	    },
	    {
	      name: 'QNX',
	      rule: /QNX/
	    },
	    {
	      name: 'BeOS',
	      rule: /BeOS/
	    },
	    {
	      name: 'OS/2',
	      rule: /OS\/2/
	    },
	    {
	      name: 'Search Bot',
	      rule: /(nuhk)|(Googlebot)|(Yammybot)|(Openbot)|(Slurp)|(MSNBot)|(Ask Jeeves\/Teoma)|(ia_archiver)/
	    }
	  ];
	
	  var detected = operatingSystems.filter(function (os) {
	    if (userAgentString.match(os.rule)) {
	      return true;
	    }
	  });
	
	  return detected && detected[0] ? detected[0].name : null;
	};


/***/ }),
/* 750 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ArrayUtils = (function () {
	    function ArrayUtils() {
	    }
	    ArrayUtils.remove = function (array, itemToRemove) {
	        array.splice(array.indexOf(itemToRemove), 1);
	    };
	    return ArrayUtils;
	}());
	exports.ArrayUtils = ArrayUtils;


/***/ }),
/* 751 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CookieUtils = (function () {
	    function CookieUtils() {
	    }
	    CookieUtils.check = function (name) {
	        name = encodeURIComponent(name);
	        var regexp = new RegExp('(?:^' + name + '|;\\s*' + name + ')=(.*?)(?:;|$)', 'g');
	        return regexp.test(document.cookie);
	    };
	    CookieUtils.get = function (name) {
	        if (CookieUtils.check(name)) {
	            name = encodeURIComponent(name);
	            var regexp = new RegExp('(?:^' + name + '|;\\s*' + name + ')=(.*?)(?:;|$)', 'g');
	            var result = regexp.exec(document.cookie);
	            return decodeURIComponent(result[1]);
	        }
	        else {
	            return '';
	        }
	    };
	    CookieUtils.set = function (name, value, expires, path, domain, secure) {
	        var cookieStr = encodeURIComponent(name) + '=' + encodeURIComponent(value) + ';';
	        if (expires) {
	            if (typeof expires === 'number') {
	                var dtExpires = new Date(new Date().getTime() + expires * 1000 * 60 * 60 * 24);
	                cookieStr += 'expires=' + dtExpires.toUTCString() + ';';
	            }
	            else {
	                cookieStr += 'expires=' + expires.toUTCString() + ';';
	            }
	        }
	        if (path) {
	            cookieStr += 'path=' + path + ';';
	        }
	        if (domain) {
	            cookieStr += 'domain=' + domain + ';';
	        }
	        if (secure) {
	            cookieStr += 'secure;';
	        }
	        document.cookie = cookieStr;
	    };
	    CookieUtils.remove = function (name, path, domain) {
	        if (CookieUtils.get(name)) {
	            CookieUtils.set(name, '', -1, path, domain);
	        }
	    };
	    return CookieUtils;
	}());
	exports.CookieUtils = CookieUtils;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var md5_1 = __webpack_require__(753);
	var _sha512 = __webpack_require__(754);
	var HashUtils = (function () {
	    function HashUtils() {
	    }
	    HashUtils.sha512 = function (input) {
	        return _sha512(input);
	    };
	    HashUtils.md5 = function (input) {
	        return md5_1.Md5.hashStr(input);
	    };
	    return HashUtils;
	}());
	exports.HashUtils = HashUtils;


/***/ }),
/* 753 */
/***/ (function(module, exports) {

	"use strict";
	/*
	
	TypeScript Md5
	==============
	
	Based on work by
	* Joseph Myers: http://www.myersdaily.org/joseph/javascript/md5-text.html
	* André Cruz: https://github.com/satazor/SparkMD5
	* Raymond Hill: https://github.com/gorhill/yamd5.js
	
	Effectively a TypeScrypt re-write of Raymond Hill JS Library
	
	The MIT License (MIT)
	
	Copyright (C) 2014 Raymond Hill
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	
	
	
	            DO WHAT THE FUCK YOU WANT TO PUBLIC LICENSE
	                    Version 2, December 2004
	
	 Copyright (C) 2015 André Cruz <amdfcruz@gmail.com>
	
	 Everyone is permitted to copy and distribute verbatim or modified
	 copies of this license document, and changing it is allowed as long
	 as the name is changed.
	
	            DO WHAT THE FUCK YOU WANT TO PUBLIC LICENSE
	   TERMS AND CONDITIONS FOR COPYING, DISTRIBUTION AND MODIFICATION
	
	  0. You just DO WHAT THE FUCK YOU WANT TO.
	
	
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	var Md5 = /** @class */ (function () {
	    function Md5() {
	        this._state = new Int32Array(4);
	        this._buffer = new ArrayBuffer(68);
	        this._buffer8 = new Uint8Array(this._buffer, 0, 68);
	        this._buffer32 = new Uint32Array(this._buffer, 0, 17);
	        this.start();
	    }
	    Md5.hashStr = function (str, raw) {
	        if (raw === void 0) { raw = false; }
	        return this.onePassHasher
	            .start()
	            .appendStr(str)
	            .end(raw);
	    };
	    Md5.hashAsciiStr = function (str, raw) {
	        if (raw === void 0) { raw = false; }
	        return this.onePassHasher
	            .start()
	            .appendAsciiStr(str)
	            .end(raw);
	    };
	    Md5._hex = function (x) {
	        var hc = Md5.hexChars;
	        var ho = Md5.hexOut;
	        var n;
	        var offset;
	        var j;
	        var i;
	        for (i = 0; i < 4; i += 1) {
	            offset = i * 8;
	            n = x[i];
	            for (j = 0; j < 8; j += 2) {
	                ho[offset + 1 + j] = hc.charAt(n & 0x0F);
	                n >>>= 4;
	                ho[offset + 0 + j] = hc.charAt(n & 0x0F);
	                n >>>= 4;
	            }
	        }
	        return ho.join('');
	    };
	    Md5._md5cycle = function (x, k) {
	        var a = x[0];
	        var b = x[1];
	        var c = x[2];
	        var d = x[3];
	        // ff()
	        a += (b & c | ~b & d) + k[0] - 680876936 | 0;
	        a = (a << 7 | a >>> 25) + b | 0;
	        d += (a & b | ~a & c) + k[1] - 389564586 | 0;
	        d = (d << 12 | d >>> 20) + a | 0;
	        c += (d & a | ~d & b) + k[2] + 606105819 | 0;
	        c = (c << 17 | c >>> 15) + d | 0;
	        b += (c & d | ~c & a) + k[3] - 1044525330 | 0;
	        b = (b << 22 | b >>> 10) + c | 0;
	        a += (b & c | ~b & d) + k[4] - 176418897 | 0;
	        a = (a << 7 | a >>> 25) + b | 0;
	        d += (a & b | ~a & c) + k[5] + 1200080426 | 0;
	        d = (d << 12 | d >>> 20) + a | 0;
	        c += (d & a | ~d & b) + k[6] - 1473231341 | 0;
	        c = (c << 17 | c >>> 15) + d | 0;
	        b += (c & d | ~c & a) + k[7] - 45705983 | 0;
	        b = (b << 22 | b >>> 10) + c | 0;
	        a += (b & c | ~b & d) + k[8] + 1770035416 | 0;
	        a = (a << 7 | a >>> 25) + b | 0;
	        d += (a & b | ~a & c) + k[9] - 1958414417 | 0;
	        d = (d << 12 | d >>> 20) + a | 0;
	        c += (d & a | ~d & b) + k[10] - 42063 | 0;
	        c = (c << 17 | c >>> 15) + d | 0;
	        b += (c & d | ~c & a) + k[11] - 1990404162 | 0;
	        b = (b << 22 | b >>> 10) + c | 0;
	        a += (b & c | ~b & d) + k[12] + 1804603682 | 0;
	        a = (a << 7 | a >>> 25) + b | 0;
	        d += (a & b | ~a & c) + k[13] - 40341101 | 0;
	        d = (d << 12 | d >>> 20) + a | 0;
	        c += (d & a | ~d & b) + k[14] - 1502002290 | 0;
	        c = (c << 17 | c >>> 15) + d | 0;
	        b += (c & d | ~c & a) + k[15] + 1236535329 | 0;
	        b = (b << 22 | b >>> 10) + c | 0;
	        // gg()
	        a += (b & d | c & ~d) + k[1] - 165796510 | 0;
	        a = (a << 5 | a >>> 27) + b | 0;
	        d += (a & c | b & ~c) + k[6] - 1069501632 | 0;
	        d = (d << 9 | d >>> 23) + a | 0;
	        c += (d & b | a & ~b) + k[11] + 643717713 | 0;
	        c = (c << 14 | c >>> 18) + d | 0;
	        b += (c & a | d & ~a) + k[0] - 373897302 | 0;
	        b = (b << 20 | b >>> 12) + c | 0;
	        a += (b & d | c & ~d) + k[5] - 701558691 | 0;
	        a = (a << 5 | a >>> 27) + b | 0;
	        d += (a & c | b & ~c) + k[10] + 38016083 | 0;
	        d = (d << 9 | d >>> 23) + a | 0;
	        c += (d & b | a & ~b) + k[15] - 660478335 | 0;
	        c = (c << 14 | c >>> 18) + d | 0;
	        b += (c & a | d & ~a) + k[4] - 405537848 | 0;
	        b = (b << 20 | b >>> 12) + c | 0;
	        a += (b & d | c & ~d) + k[9] + 568446438 | 0;
	        a = (a << 5 | a >>> 27) + b | 0;
	        d += (a & c | b & ~c) + k[14] - 1019803690 | 0;
	        d = (d << 9 | d >>> 23) + a | 0;
	        c += (d & b | a & ~b) + k[3] - 187363961 | 0;
	        c = (c << 14 | c >>> 18) + d | 0;
	        b += (c & a | d & ~a) + k[8] + 1163531501 | 0;
	        b = (b << 20 | b >>> 12) + c | 0;
	        a += (b & d | c & ~d) + k[13] - 1444681467 | 0;
	        a = (a << 5 | a >>> 27) + b | 0;
	        d += (a & c | b & ~c) + k[2] - 51403784 | 0;
	        d = (d << 9 | d >>> 23) + a | 0;
	        c += (d & b | a & ~b) + k[7] + 1735328473 | 0;
	        c = (c << 14 | c >>> 18) + d | 0;
	        b += (c & a | d & ~a) + k[12] - 1926607734 | 0;
	        b = (b << 20 | b >>> 12) + c | 0;
	        // hh()
	        a += (b ^ c ^ d) + k[5] - 378558 | 0;
	        a = (a << 4 | a >>> 28) + b | 0;
	        d += (a ^ b ^ c) + k[8] - 2022574463 | 0;
	        d = (d << 11 | d >>> 21) + a | 0;
	        c += (d ^ a ^ b) + k[11] + 1839030562 | 0;
	        c = (c << 16 | c >>> 16) + d | 0;
	        b += (c ^ d ^ a) + k[14] - 35309556 | 0;
	        b = (b << 23 | b >>> 9) + c | 0;
	        a += (b ^ c ^ d) + k[1] - 1530992060 | 0;
	        a = (a << 4 | a >>> 28) + b | 0;
	        d += (a ^ b ^ c) + k[4] + 1272893353 | 0;
	        d = (d << 11 | d >>> 21) + a | 0;
	        c += (d ^ a ^ b) + k[7] - 155497632 | 0;
	        c = (c << 16 | c >>> 16) + d | 0;
	        b += (c ^ d ^ a) + k[10] - 1094730640 | 0;
	        b = (b << 23 | b >>> 9) + c | 0;
	        a += (b ^ c ^ d) + k[13] + 681279174 | 0;
	        a = (a << 4 | a >>> 28) + b | 0;
	        d += (a ^ b ^ c) + k[0] - 358537222 | 0;
	        d = (d << 11 | d >>> 21) + a | 0;
	        c += (d ^ a ^ b) + k[3] - 722521979 | 0;
	        c = (c << 16 | c >>> 16) + d | 0;
	        b += (c ^ d ^ a) + k[6] + 76029189 | 0;
	        b = (b << 23 | b >>> 9) + c | 0;
	        a += (b ^ c ^ d) + k[9] - 640364487 | 0;
	        a = (a << 4 | a >>> 28) + b | 0;
	        d += (a ^ b ^ c) + k[12] - 421815835 | 0;
	        d = (d << 11 | d >>> 21) + a | 0;
	        c += (d ^ a ^ b) + k[15] + 530742520 | 0;
	        c = (c << 16 | c >>> 16) + d | 0;
	        b += (c ^ d ^ a) + k[2] - 995338651 | 0;
	        b = (b << 23 | b >>> 9) + c | 0;
	        // ii()
	        a += (c ^ (b | ~d)) + k[0] - 198630844 | 0;
	        a = (a << 6 | a >>> 26) + b | 0;
	        d += (b ^ (a | ~c)) + k[7] + 1126891415 | 0;
	        d = (d << 10 | d >>> 22) + a | 0;
	        c += (a ^ (d | ~b)) + k[14] - 1416354905 | 0;
	        c = (c << 15 | c >>> 17) + d | 0;
	        b += (d ^ (c | ~a)) + k[5] - 57434055 | 0;
	        b = (b << 21 | b >>> 11) + c | 0;
	        a += (c ^ (b | ~d)) + k[12] + 1700485571 | 0;
	        a = (a << 6 | a >>> 26) + b | 0;
	        d += (b ^ (a | ~c)) + k[3] - 1894986606 | 0;
	        d = (d << 10 | d >>> 22) + a | 0;
	        c += (a ^ (d | ~b)) + k[10] - 1051523 | 0;
	        c = (c << 15 | c >>> 17) + d | 0;
	        b += (d ^ (c | ~a)) + k[1] - 2054922799 | 0;
	        b = (b << 21 | b >>> 11) + c | 0;
	        a += (c ^ (b | ~d)) + k[8] + 1873313359 | 0;
	        a = (a << 6 | a >>> 26) + b | 0;
	        d += (b ^ (a | ~c)) + k[15] - 30611744 | 0;
	        d = (d << 10 | d >>> 22) + a | 0;
	        c += (a ^ (d | ~b)) + k[6] - 1560198380 | 0;
	        c = (c << 15 | c >>> 17) + d | 0;
	        b += (d ^ (c | ~a)) + k[13] + 1309151649 | 0;
	        b = (b << 21 | b >>> 11) + c | 0;
	        a += (c ^ (b | ~d)) + k[4] - 145523070 | 0;
	        a = (a << 6 | a >>> 26) + b | 0;
	        d += (b ^ (a | ~c)) + k[11] - 1120210379 | 0;
	        d = (d << 10 | d >>> 22) + a | 0;
	        c += (a ^ (d | ~b)) + k[2] + 718787259 | 0;
	        c = (c << 15 | c >>> 17) + d | 0;
	        b += (d ^ (c | ~a)) + k[9] - 343485551 | 0;
	        b = (b << 21 | b >>> 11) + c | 0;
	        x[0] = a + x[0] | 0;
	        x[1] = b + x[1] | 0;
	        x[2] = c + x[2] | 0;
	        x[3] = d + x[3] | 0;
	    };
	    Md5.prototype.start = function () {
	        this._dataLength = 0;
	        this._bufferLength = 0;
	        this._state.set(Md5.stateIdentity);
	        return this;
	    };
	    // Char to code point to to array conversion:
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/charCodeAt
	    // #Example.3A_Fixing_charCodeAt_to_handle_non-Basic-Multilingual-Plane_characters_if_their_presence_earlier_in_the_string_is_unknown
	    Md5.prototype.appendStr = function (str) {
	        var buf8 = this._buffer8;
	        var buf32 = this._buffer32;
	        var bufLen = this._bufferLength;
	        var code;
	        var i;
	        for (i = 0; i < str.length; i += 1) {
	            code = str.charCodeAt(i);
	            if (code < 128) {
	                buf8[bufLen++] = code;
	            }
	            else if (code < 0x800) {
	                buf8[bufLen++] = (code >>> 6) + 0xC0;
	                buf8[bufLen++] = code & 0x3F | 0x80;
	            }
	            else if (code < 0xD800 || code > 0xDBFF) {
	                buf8[bufLen++] = (code >>> 12) + 0xE0;
	                buf8[bufLen++] = (code >>> 6 & 0x3F) | 0x80;
	                buf8[bufLen++] = (code & 0x3F) | 0x80;
	            }
	            else {
	                code = ((code - 0xD800) * 0x400) + (str.charCodeAt(++i) - 0xDC00) + 0x10000;
	                if (code > 0x10FFFF) {
	                    throw new Error('Unicode standard supports code points up to U+10FFFF');
	                }
	                buf8[bufLen++] = (code >>> 18) + 0xF0;
	                buf8[bufLen++] = (code >>> 12 & 0x3F) | 0x80;
	                buf8[bufLen++] = (code >>> 6 & 0x3F) | 0x80;
	                buf8[bufLen++] = (code & 0x3F) | 0x80;
	            }
	            if (bufLen >= 64) {
	                this._dataLength += 64;
	                Md5._md5cycle(this._state, buf32);
	                bufLen -= 64;
	                buf32[0] = buf32[16];
	            }
	        }
	        this._bufferLength = bufLen;
	        return this;
	    };
	    Md5.prototype.appendAsciiStr = function (str) {
	        var buf8 = this._buffer8;
	        var buf32 = this._buffer32;
	        var bufLen = this._bufferLength;
	        var i;
	        var j = 0;
	        for (;;) {
	            i = Math.min(str.length - j, 64 - bufLen);
	            while (i--) {
	                buf8[bufLen++] = str.charCodeAt(j++);
	            }
	            if (bufLen < 64) {
	                break;
	            }
	            this._dataLength += 64;
	            Md5._md5cycle(this._state, buf32);
	            bufLen = 0;
	        }
	        this._bufferLength = bufLen;
	        return this;
	    };
	    Md5.prototype.appendByteArray = function (input) {
	        var buf8 = this._buffer8;
	        var buf32 = this._buffer32;
	        var bufLen = this._bufferLength;
	        var i;
	        var j = 0;
	        for (;;) {
	            i = Math.min(input.length - j, 64 - bufLen);
	            while (i--) {
	                buf8[bufLen++] = input[j++];
	            }
	            if (bufLen < 64) {
	                break;
	            }
	            this._dataLength += 64;
	            Md5._md5cycle(this._state, buf32);
	            bufLen = 0;
	        }
	        this._bufferLength = bufLen;
	        return this;
	    };
	    Md5.prototype.getState = function () {
	        var self = this;
	        var s = self._state;
	        return {
	            buffer: String.fromCharCode.apply(null, self._buffer8),
	            buflen: self._bufferLength,
	            length: self._dataLength,
	            state: [s[0], s[1], s[2], s[3]]
	        };
	    };
	    Md5.prototype.setState = function (state) {
	        var buf = state.buffer;
	        var x = state.state;
	        var s = this._state;
	        var i;
	        this._dataLength = state.length;
	        this._bufferLength = state.buflen;
	        s[0] = x[0];
	        s[1] = x[1];
	        s[2] = x[2];
	        s[3] = x[3];
	        for (i = 0; i < buf.length; i += 1) {
	            this._buffer8[i] = buf.charCodeAt(i);
	        }
	    };
	    Md5.prototype.end = function (raw) {
	        if (raw === void 0) { raw = false; }
	        var bufLen = this._bufferLength;
	        var buf8 = this._buffer8;
	        var buf32 = this._buffer32;
	        var i = (bufLen >> 2) + 1;
	        var dataBitsLen;
	        this._dataLength += bufLen;
	        buf8[bufLen] = 0x80;
	        buf8[bufLen + 1] = buf8[bufLen + 2] = buf8[bufLen + 3] = 0;
	        buf32.set(Md5.buffer32Identity.subarray(i), i);
	        if (bufLen > 55) {
	            Md5._md5cycle(this._state, buf32);
	            buf32.set(Md5.buffer32Identity);
	        }
	        // Do the final computation based on the tail and length
	        // Beware that the final length may not fit in 32 bits so we take care of that
	        dataBitsLen = this._dataLength * 8;
	        if (dataBitsLen <= 0xFFFFFFFF) {
	            buf32[14] = dataBitsLen;
	        }
	        else {
	            var matches = dataBitsLen.toString(16).match(/(.*?)(.{0,8})$/);
	            if (matches === null) {
	                return;
	            }
	            var lo = parseInt(matches[2], 16);
	            var hi = parseInt(matches[1], 16) || 0;
	            buf32[14] = lo;
	            buf32[15] = hi;
	        }
	        Md5._md5cycle(this._state, buf32);
	        return raw ? this._state : Md5._hex(this._state);
	    };
	    // Private Static Variables
	    Md5.stateIdentity = new Int32Array([1732584193, -271733879, -1732584194, 271733878]);
	    Md5.buffer32Identity = new Int32Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
	    Md5.hexChars = '0123456789abcdef';
	    Md5.hexOut = [];
	    // Permanent instance is to use for one-call hashing
	    Md5.onePassHasher = new Md5();
	    return Md5;
	}());
	exports.Md5 = Md5;
	if (Md5.hashStr('hello') !== '5d41402abc4b2a76b9719d911017c592') {
	    console.error('Md5 self test failed.');
	}
	//# sourceMappingURL=md5.js.map

/***/ }),
/* 754 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	 * js-sha512 v0.2.2
	 * https://github.com/emn178/js-sha512
	 *
	 * Copyright 2014-2015, emn178@gmail.com
	 *
	 * Licensed under the MIT license:
	 * http://www.opensource.org/licenses/MIT
	 */
	;(function(root, undefined) {
	  'use strict';
	
	  var NODE_JS = typeof(module) != 'undefined';
	  if(NODE_JS) {
	    root = global;
	  }
	  var HEX_CHARS = '0123456789abcdef'.split('');
	  var EXTRA = [-2147483648, 8388608, 32768, 128];
	  var SHIFT = [24, 16, 8, 0];
	  var K =[0x428A2F98, 0xD728AE22, 0x71374491, 0x23EF65CD,
	          0xB5C0FBCF, 0xEC4D3B2F, 0xE9B5DBA5, 0x8189DBBC,
	          0x3956C25B, 0xF348B538, 0x59F111F1, 0xB605D019,
	          0x923F82A4, 0xAF194F9B, 0xAB1C5ED5, 0xDA6D8118,
	          0xD807AA98, 0xA3030242, 0x12835B01, 0x45706FBE,
	          0x243185BE, 0x4EE4B28C, 0x550C7DC3, 0xD5FFB4E2,
	          0x72BE5D74, 0xF27B896F, 0x80DEB1FE, 0x3B1696B1,
	          0x9BDC06A7, 0x25C71235, 0xC19BF174, 0xCF692694,
	          0xE49B69C1, 0x9EF14AD2, 0xEFBE4786, 0x384F25E3,
	          0x0FC19DC6, 0x8B8CD5B5, 0x240CA1CC, 0x77AC9C65,
	          0x2DE92C6F, 0x592B0275, 0x4A7484AA, 0x6EA6E483,
	          0x5CB0A9DC, 0xBD41FBD4, 0x76F988DA, 0x831153B5,
	          0x983E5152, 0xEE66DFAB, 0xA831C66D, 0x2DB43210,
	          0xB00327C8, 0x98FB213F, 0xBF597FC7, 0xBEEF0EE4,
	          0xC6E00BF3, 0x3DA88FC2, 0xD5A79147, 0x930AA725,
	          0x06CA6351, 0xE003826F, 0x14292967, 0x0A0E6E70,
	          0x27B70A85, 0x46D22FFC, 0x2E1B2138, 0x5C26C926,
	          0x4D2C6DFC, 0x5AC42AED, 0x53380D13, 0x9D95B3DF,
	          0x650A7354, 0x8BAF63DE, 0x766A0ABB, 0x3C77B2A8,
	          0x81C2C92E, 0x47EDAEE6, 0x92722C85, 0x1482353B,
	          0xA2BFE8A1, 0x4CF10364, 0xA81A664B, 0xBC423001,
	          0xC24B8B70, 0xD0F89791, 0xC76C51A3, 0x0654BE30,
	          0xD192E819, 0xD6EF5218, 0xD6990624, 0x5565A910,
	          0xF40E3585, 0x5771202A, 0x106AA070, 0x32BBD1B8,
	          0x19A4C116, 0xB8D2D0C8, 0x1E376C08, 0x5141AB53,
	          0x2748774C, 0xDF8EEB99, 0x34B0BCB5, 0xE19B48A8,
	          0x391C0CB3, 0xC5C95A63, 0x4ED8AA4A, 0xE3418ACB,
	          0x5B9CCA4F, 0x7763E373, 0x682E6FF3, 0xD6B2B8A3,
	          0x748F82EE, 0x5DEFB2FC, 0x78A5636F, 0x43172F60,
	          0x84C87814, 0xA1F0AB72, 0x8CC70208, 0x1A6439EC,
	          0x90BEFFFA, 0x23631E28, 0xA4506CEB, 0xDE82BDE9,
	          0xBEF9A3F7, 0xB2C67915, 0xC67178F2, 0xE372532B,
	          0xCA273ECE, 0xEA26619C, 0xD186B8C7, 0x21C0C207,
	          0xEADA7DD6, 0xCDE0EB1E, 0xF57D4F7F, 0xEE6ED178,
	          0x06F067AA, 0x72176FBA, 0x0A637DC5, 0xA2C898A6,
	          0x113F9804, 0xBEF90DAE, 0x1B710B35, 0x131C471B,
	          0x28DB77F5, 0x23047D84, 0x32CAAB7B, 0x40C72493,
	          0x3C9EBE0A, 0x15C9BEBC, 0x431D67C4, 0x9C100D4C,
	          0x4CC5D4BE, 0xCB3E42B6, 0x597F299C, 0xFC657E2A,
	          0x5FCB6FAB, 0x3AD6FAEC, 0x6C44198C, 0x4A475817];
	
	  var blocks = [];
	
	  var sha384 = function(message) {
	    return sha512(message, 384);
	  };
	
	  var sha512_256 = function(message) {
	    return sha512(message, 256);
	  };
	
	  var sha512_224 = function(message) {
	    return sha512(message, 224);
	  };
	
	  var sha512 = function(message, bits) {
	    var h0h, h0l, h1h, h1l, h2h, h2l, h3h, h3l, 
	        h4h, h4l, h5h, h5l, h6h, h6l, h7h, h7l, block, code, end = false,
	        i, j, index = 0, start = 0, bytes = 0, length = message.length,
	        s0h, s0l, s1h, s1l, c1, c2, c3, c4, 
	        abh, abl, dah, dal, cdh, cdl, bch, bcl,
	        majh, majl, t1h, t1l, t2h, t2l, chh, chl;
	
	    if(bits == 384) {
	      h0h = 0xCBBB9D5D;
	      h0l = 0xC1059ED8;
	      h1h = 0x629A292A;
	      h1l = 0x367CD507;
	      h2h = 0x9159015A;
	      h2l = 0x3070DD17;
	      h3h = 0x152FECD8;
	      h3l = 0xF70E5939;
	      h4h = 0x67332667;
	      h4l = 0xFFC00B31;
	      h5h = 0x8EB44A87;
	      h5l = 0x68581511;
	      h6h = 0xDB0C2E0D;
	      h6l = 0x64F98FA7;
	      h7h = 0x47B5481D;
	      h7l = 0xBEFA4FA4;
	    } else if(bits == 256) {
	      h0h = 0x22312194;
	      h0l = 0xFC2BF72C;
	      h1h = 0x9F555FA3;
	      h1l = 0xC84C64C2;
	      h2h = 0x2393B86B;
	      h2l = 0x6F53B151;
	      h3h = 0x96387719;
	      h3l = 0x5940EABD;
	      h4h = 0x96283EE2;
	      h4l = 0xA88EFFE3;
	      h5h = 0xBE5E1E25;
	      h5l = 0x53863992;
	      h6h = 0x2B0199FC;
	      h6l = 0x2C85B8AA;
	      h7h = 0x0EB72DDC;
	      h7l = 0x81C52CA2;
	    } else if(bits == 224) {
	      h0h = 0x8C3D37C8;
	      h0l = 0x19544DA2;
	      h1h = 0x73E19966;
	      h1l = 0x89DCD4D6;
	      h2h = 0x1DFAB7AE;
	      h2l = 0x32FF9C82;
	      h3h = 0x679DD514;
	      h3l = 0x582F9FCF;
	      h4h = 0x0F6D2B69;
	      h4l = 0x7BD44DA8;
	      h5h = 0x77E36F73;
	      h5l = 0x04C48942;
	      h6h = 0x3F9D85A8;
	      h6l = 0x6A1D36C8;
	      h7h = 0x1112E6AD;
	      h7l = 0x91D692A1;
	    } else { // 512
	      h0h = 0x6A09E667;
	      h0l = 0xF3BCC908;
	      h1h = 0xBB67AE85;
	      h1l = 0x84CAA73B;
	      h2h = 0x3C6EF372;
	      h2l = 0xFE94F82B;
	      h3h = 0xA54FF53A;
	      h3l = 0x5F1D36F1;
	      h4h = 0x510E527F;
	      h4l = 0xADE682D1;
	      h5h = 0x9B05688C;
	      h5l = 0x2B3E6C1F;
	      h6h = 0x1F83D9AB;
	      h6l = 0xFB41BD6B;
	      h7h = 0x5BE0CD19;
	      h7l = 0x137E2179;
	      bits = 512;
	    }
	    block = 0;
	    do {
	      blocks[0] = block;
	      blocks[1] = blocks[2] = blocks[3] = blocks[4] = 
	      blocks[5] = blocks[6] = blocks[7] = blocks[8] = 
	      blocks[9] = blocks[10] = blocks[11] = blocks[12] = 
	      blocks[13] = blocks[14] = blocks[15] = blocks[16] = 
	      blocks[17] = blocks[18] = blocks[19] = blocks[20] =
	      blocks[21] = blocks[22] = blocks[23] = blocks[24] =
	      blocks[25] = blocks[26] = blocks[27] = blocks[28] =
	      blocks[29] = blocks[30] = blocks[31] = blocks[32] = 0;
	      for (i = start;index < length && i < 128; ++index) {
	        code = message.charCodeAt(index);
	        if (code < 0x80) {
	          blocks[i >> 2] |= code << SHIFT[i++ & 3];
	        } else if (code < 0x800) {
	          blocks[i >> 2] |= (0xc0 | (code >> 6)) << SHIFT[i++ & 3];
	          blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
	        } else if (code < 0xd800 || code >= 0xe000) {
	          blocks[i >> 2] |= (0xe0 | (code >> 12)) << SHIFT[i++ & 3];
	          blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
	          blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
	        } else {
	          code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
	          blocks[i >> 2] |= (0xf0 | (code >> 18)) << SHIFT[i++ & 3];
	          blocks[i >> 2] |= (0x80 | ((code >> 12) & 0x3f)) << SHIFT[i++ & 3];
	          blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
	          blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
	        }
	      }
	      bytes += i - start;
	      start = i - 128;
	      if(index == length) {
	        blocks[i >> 2] |= EXTRA[i & 3];
	        ++index;
	      }
	      block = blocks[32];
	      if(index > length && i < 112) {
	        blocks[31] = bytes << 3;
	        end = true;
	      }
	
	      for(j = 32;j < 160;j += 2) {
	        t1h = blocks[j - 30];
	        t1l = blocks[j - 29];
	        s0h = ((t1h >>> 1) | (t1l << 31)) ^ ((t1h >>> 8) | (t1l << 24)) ^ (t1h >>> 7);
	        s0l = ((t1l >>> 1) | (t1h << 31)) ^ ((t1l >>> 8) | (t1h << 24)) ^ ((t1l >>> 7) | t1h << 25);
	
	        t1h = blocks[j - 4];
	        t1l = blocks[j - 3];
	        s1h = ((t1h >>> 19) | (t1l << 13)) ^ ((t1l >>> 29) | (t1h << 3)) ^ (t1h >>> 6);
	        s1l = ((t1l >>> 19) | (t1h << 13)) ^ ((t1h >>> 29) | (t1l << 3)) ^ ((t1l >>> 6) | t1h << 26);
	
	        t1h = blocks[j - 32];
	        t1l = blocks[j - 31];
	        t2h = blocks[j - 14];
	        t2l = blocks[j - 13];
	
	        c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (s0l & 0xFFFF) + (s1l & 0xFFFF);
	        c2 = (t2l >>> 16) + (t1l >>> 16) + (s0l >>> 16) + (s1l >>> 16) + (c1 >>> 16);
	        c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (s0h & 0xFFFF) + (s1h & 0xFFFF) + (c2 >>> 16);
	        c4 = (t2h >>> 16) + (t1h >>> 16) + (s0h >>> 16) + (s1h >>> 16) + (c3 >>> 16);
	
	        blocks[j] = (c4 << 16) | (c3 & 0xFFFF);
	        blocks[j + 1] = (c2 << 16) | (c1 & 0xFFFF);
	      }
	
	      var ah = h0h, al = h0l, bh = h1h, bl = h1l, ch = h2h, cl = h2l, dh = h3h, dl = h3l, eh = h4h, el = h4l, fh = h5h, fl = h5l, gh = h6h, gl = h6l, hh = h7h, hl = h7l;
	      bch = bh & ch;
	      bcl = bl & cl;
	      for(j = 0;j < 160;j += 8) {
	        s0h = ((ah >>> 28) | (al << 4)) ^ ((al >>> 2) | (ah << 30)) ^ ((al >>> 7) | (ah << 25));
	        s0l = ((al >>> 28) | (ah << 4)) ^ ((ah >>> 2) | (al << 30)) ^ ((ah >>> 7) | (al << 25));
	
	        s1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((el >>> 9) | (eh << 23));
	        s1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((eh >>> 9) | (el << 23));
	
	        abh = ah & bh;
	        abl = al & bl;
	        majh = abh ^ (ah & ch) ^ bch;
	        majl = abl ^ (al & cl) ^ bcl;
	
	        chh = (eh & fh) ^ (~eh & gh);
	        chl = (el & fl) ^ (~el & gl);
	
	        t1h = blocks[j];
	        t1l = blocks[j + 1];
	        t2h = K[j];
	        t2l = K[j + 1];
	
	        c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (chl & 0xFFFF) + (s1l & 0xFFFF) + (hl & 0xFFFF);
	        c2 = (t2l >>> 16) + (t1l >>> 16) + (chl >>> 16) + (s1l >>> 16) + (hl >>> 16) + (c1 >>> 16);
	        c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (chh & 0xFFFF) + (s1h & 0xFFFF) + (hh & 0xFFFF) + (c2 >>> 16);
	        c4 = (t2h >>> 16) + (t1h >>> 16) + (chh >>> 16) + (s1h >>> 16) + (hh >>> 16) + (c3 >>> 16);
	
	        t1h = (c4 << 16) | (c3 & 0xFFFF);
	        t1l = (c2 << 16) | (c1 & 0xFFFF);
	
	        c1 = (majl & 0xFFFF) + (s0l & 0xFFFF);
	        c2 = (majl >>> 16) + (s0l >>> 16) + (c1 >>> 16);
	        c3 = (majh & 0xFFFF) + (s0h & 0xFFFF) + (c2 >>> 16);
	        c4 = (majh >>> 16) + (s0h >>> 16) + (c3 >>> 16);
	
	        t2h = (c4 << 16) | (c3 & 0xFFFF);
	        t2l = (c2 << 16) | (c1 & 0xFFFF);
	
	        c1 = (dl & 0xFFFF) + (t1l & 0xFFFF);
	        c2 = (dl >>> 16) + (t1l >>> 16) + (c1 >>> 16);
	        c3 = (dh & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
	        c4 = (dh >>> 16) + (t1h >>> 16) + (c3 >>> 16);
	
	        hh = (c4 << 16) | (c3 & 0xFFFF);
	        hl = (c2 << 16) | (c1 & 0xFFFF);
	
	        c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF);
	        c2 = (t2l >>> 16) + (t1l >>> 16) + (c1 >>> 16);
	        c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
	        c4 = (t2h >>> 16) + (t1h >>> 16) + (c3 >>> 16);
	
	        dh = (c4 << 16) | (c3 & 0xFFFF);
	        dl = (c2 << 16) | (c1 & 0xFFFF);
	
	        s0h = ((dh >>> 28) | (dl << 4)) ^ ((dl >>> 2) | (dh << 30)) ^ ((dl >>> 7) | (dh << 25));
	        s0l = ((dl >>> 28) | (dh << 4)) ^ ((dh >>> 2) | (dl << 30)) ^ ((dh >>> 7) | (dl << 25));
	
	        s1h = ((hh >>> 14) | (hl << 18)) ^ ((hh >>> 18) | (hl << 14)) ^ ((hl >>> 9) | (hh << 23));
	        s1l = ((hl >>> 14) | (hh << 18)) ^ ((hl >>> 18) | (hh << 14)) ^ ((hh >>> 9) | (hl << 23));
	
	        dah = dh & ah;
	        dal = dl & al;
	        majh = dah ^ (dh & bh) ^ abh;
	        majl = dal ^ (dl & bl) ^ abl;
	
	        chh = (hh & eh) ^ (~hh & fh);
	        chl = (hl & el) ^ (~hl & fl);
	
	        t1h = blocks[j + 2];
	        t1l = blocks[j + 3];
	        t2h = K[j + 2];
	        t2l = K[j + 3];
	
	        c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (chl & 0xFFFF) + (s1l & 0xFFFF) + (gl & 0xFFFF);
	        c2 = (t2l >>> 16) + (t1l >>> 16) + (chl >>> 16) + (s1l >>> 16) + (gl >>> 16) + (c1 >>> 16);
	        c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (chh & 0xFFFF) + (s1h & 0xFFFF) + (gh & 0xFFFF) + (c2 >>> 16);
	        c4 = (t2h >>> 16) + (t1h >>> 16) + (chh >>> 16) + (s1h >>> 16) + (gh >>> 16) + (c3 >>> 16);
	
	        t1h = (c4 << 16) | (c3 & 0xFFFF);
	        t1l = (c2 << 16) | (c1 & 0xFFFF);
	
	        c1 = (majl & 0xFFFF) + (s0l & 0xFFFF);
	        c2 = (majl >>> 16) + (s0l >>> 16) + (c1 >>> 16);
	        c3 = (majh & 0xFFFF) + (s0h & 0xFFFF) + (c2 >>> 16);
	        c4 = (majh >>> 16) + (s0h >>> 16) + (c3 >>> 16);
	
	        t2h = (c4 << 16) | (c3 & 0xFFFF);
	        t2l = (c2 << 16) | (c1 & 0xFFFF);
	
	        c1 = (cl & 0xFFFF) + (t1l & 0xFFFF);
	        c2 = (cl >>> 16) + (t1l >>> 16) + (c1 >>> 16);
	        c3 = (ch & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
	        c4 = (ch >>> 16) + (t1h >>> 16) + (c3 >>> 16);
	
	        gh = (c4 << 16) | (c3 & 0xFFFF);
	        gl = (c2 << 16) | (c1 & 0xFFFF);
	
	        c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF);
	        c2 = (t2l >>> 16) + (t1l >>> 16) + (c1 >>> 16);
	        c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
	        c4 = (t2h >>> 16) + (t1h >>> 16) + (c3 >>> 16);
	
	        ch = (c4 << 16) | (c3 & 0xFFFF);
	        cl = (c2 << 16) | (c1 & 0xFFFF);
	
	        s0h = ((ch >>> 28) | (cl << 4)) ^ ((cl >>> 2) | (ch << 30)) ^ ((cl >>> 7) | (ch << 25));
	        s0l = ((cl >>> 28) | (ch << 4)) ^ ((ch >>> 2) | (cl << 30)) ^ ((ch >>> 7) | (cl << 25));
	
	        s1h = ((gh >>> 14) | (gl << 18)) ^ ((gh >>> 18) | (gl << 14)) ^ ((gl >>> 9) | (gh << 23));
	        s1l = ((gl >>> 14) | (gh << 18)) ^ ((gl >>> 18) | (gh << 14)) ^ ((gh >>> 9) | (gl << 23));
	
	        cdh = ch & dh;
	        cdl = cl & dl;
	        majh = cdh ^ (ch & ah) ^ dah;
	        majl = cdl ^ (cl & al) ^ dal;
	
	        chh = (gh & hh) ^ (~gh & eh);
	        chl = (gl & hl) ^ (~gl & el);
	
	        t1h = blocks[j + 4];
	        t1l = blocks[j + 5];
	        t2h = K[j + 4];
	        t2l = K[j + 5];
	
	        c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (chl & 0xFFFF) + (s1l & 0xFFFF) + (fl & 0xFFFF);
	        c2 = (t2l >>> 16) + (t1l >>> 16) + (chl >>> 16) + (s1l >>> 16) + (fl >>> 16) + (c1 >>> 16);
	        c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (chh & 0xFFFF) + (s1h & 0xFFFF) + (fh & 0xFFFF) + (c2 >>> 16);
	        c4 = (t2h >>> 16) + (t1h >>> 16) + (chh >>> 16) + (s1h >>> 16) + (fh >>> 16) + (c3 >>> 16);
	
	        t1h = (c4 << 16) | (c3 & 0xFFFF);
	        t1l = (c2 << 16) | (c1 & 0xFFFF);
	
	        c1 = (majl & 0xFFFF) + (s0l & 0xFFFF);
	        c2 = (majl >>> 16) + (s0l >>> 16) + (c1 >>> 16);
	        c3 = (majh & 0xFFFF) + (s0h & 0xFFFF) + (c2 >>> 16);
	        c4 = (majh >>> 16) + (s0h >>> 16) + (c3 >>> 16);
	
	        t2h = (c4 << 16) | (c3 & 0xFFFF);
	        t2l = (c2 << 16) | (c1 & 0xFFFF);
	
	        c1 = (bl & 0xFFFF) + (t1l & 0xFFFF);
	        c2 = (bl >>> 16) + (t1l >>> 16) + (c1 >>> 16);
	        c3 = (bh & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
	        c4 = (bh >>> 16) + (t1h >>> 16) + (c3 >>> 16);
	
	        fh = (c4 << 16) | (c3 & 0xFFFF);
	        fl = (c2 << 16) | (c1 & 0xFFFF);
	
	        c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF);
	        c2 = (t2l >>> 16) + (t1l >>> 16) + (c1 >>> 16);
	        c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
	        c4 = (t2h >>> 16) + (t1h >>> 16) + (c3 >>> 16);
	
	        bh = (c4 << 16) | (c3 & 0xFFFF);
	        bl = (c2 << 16) | (c1 & 0xFFFF);
	
	        s0h = ((bh >>> 28) | (bl << 4)) ^ ((bl >>> 2) | (bh << 30)) ^ ((bl >>> 7) | (bh << 25));
	        s0l = ((bl >>> 28) | (bh << 4)) ^ ((bh >>> 2) | (bl << 30)) ^ ((bh >>> 7) | (bl << 25));
	
	        s1h = ((fh >>> 14) | (fl << 18)) ^ ((fh >>> 18) | (fl << 14)) ^ ((fl >>> 9) | (fh << 23));
	        s1l = ((fl >>> 14) | (fh << 18)) ^ ((fl >>> 18) | (fh << 14)) ^ ((fh >>> 9) | (fl << 23));
	
	        bch = bh & ch;
	        bcl = bl & cl;
	        majh = bch ^ (bh & dh) ^ cdh;
	        majl = bcl ^ (bl & dl) ^ cdl;
	
	        chh = (fh & gh) ^ (~fh & hh);
	        chl = (fl & gl) ^ (~fl & hl);
	
	        t1h = blocks[j + 6];
	        t1l = blocks[j + 7];
	        t2h = K[j + 6];
	        t2l = K[j + 7];
	
	        c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (chl & 0xFFFF) + (s1l & 0xFFFF) + (el & 0xFFFF);
	        c2 = (t2l >>> 16) + (t1l >>> 16) + (chl >>> 16) + (s1l >>> 16) + (el >>> 16) + (c1 >>> 16);
	        c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (chh & 0xFFFF) + (s1h & 0xFFFF) + (eh & 0xFFFF) + (c2 >>> 16);
	        c4 = (t2h >>> 16) + (t1h >>> 16) + (chh >>> 16) + (s1h >>> 16) + (eh >>> 16) + (c3 >>> 16);
	
	        t1h = (c4 << 16) | (c3 & 0xFFFF);
	        t1l = (c2 << 16) | (c1 & 0xFFFF);
	
	        c1 = (majl & 0xFFFF) + (s0l & 0xFFFF);
	        c2 = (majl >>> 16) + (s0l >>> 16) + (c1 >>> 16);
	        c3 = (majh & 0xFFFF) + (s0h & 0xFFFF) + (c2 >>> 16);
	        c4 = (majh >>> 16) + (s0h >>> 16) + (c3 >>> 16);
	
	        t2h = (c4 << 16) | (c3 & 0xFFFF);
	        t2l = (c2 << 16) | (c1 & 0xFFFF);
	
	        c1 = (al & 0xFFFF) + (t1l & 0xFFFF);
	        c2 = (al >>> 16) + (t1l >>> 16) + (c1 >>> 16);
	        c3 = (ah & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
	        c4 = (ah >>> 16) + (t1h >>> 16) + (c3 >>> 16);
	
	        eh = (c4 << 16) | (c3 & 0xFFFF);
	        el = (c2 << 16) | (c1 & 0xFFFF);
	
	        c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF);
	        c2 = (t2l >>> 16) + (t1l >>> 16) + (c1 >>> 16);
	        c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
	        c4 = (t2h >>> 16) + (t1h >>> 16) + (c3 >>> 16);
	
	        ah = (c4 << 16) | (c3 & 0xFFFF);
	        al = (c2 << 16) | (c1 & 0xFFFF);
	      }
	
	      c1 = (h0l & 0xFFFF) + (al & 0xFFFF);
	      c2 = (h0l >>> 16) + (al >>> 16) + (c1 >>> 16);
	      c3 = (h0h & 0xFFFF) + (ah & 0xFFFF) + (c2 >>> 16);
	      c4 = (h0h >>> 16) + (ah >>> 16) + (c3 >>> 16);
	
	      h0h = (c4 << 16) | (c3 & 0xFFFF);
	      h0l = (c2 << 16) | (c1 & 0xFFFF);
	
	      c1 = (h1l & 0xFFFF) + (bl & 0xFFFF);
	      c2 = (h1l >>> 16) + (bl >>> 16) + (c1 >>> 16);
	      c3 = (h1h & 0xFFFF) + (bh & 0xFFFF) + (c2 >>> 16);
	      c4 = (h1h >>> 16) + (bh >>> 16) + (c3 >>> 16);
	
	      h1h = (c4 << 16) | (c3 & 0xFFFF);
	      h1l = (c2 << 16) | (c1 & 0xFFFF);
	
	      c1 = (h2l & 0xFFFF) + (cl & 0xFFFF);
	      c2 = (h2l >>> 16) + (cl >>> 16) + (c1 >>> 16);
	      c3 = (h2h & 0xFFFF) + (ch & 0xFFFF) + (c2 >>> 16);
	      c4 = (h2h >>> 16) + (ch >>> 16) + (c3 >>> 16);
	
	      h2h = (c4 << 16) | (c3 & 0xFFFF);
	      h2l = (c2 << 16) | (c1 & 0xFFFF);
	
	      c1 = (h3l & 0xFFFF) + (dl & 0xFFFF);
	      c2 = (h3l >>> 16) + (dl >>> 16) + (c1 >>> 16);
	      c3 = (h3h & 0xFFFF) + (dh & 0xFFFF) + (c2 >>> 16);
	      c4 = (h3h >>> 16) + (dh >>> 16) + (c3 >>> 16);
	
	      h3h = (c4 << 16) | (c3 & 0xFFFF);
	      h3l = (c2 << 16) | (c1 & 0xFFFF);
	
	      c1 = (h4l & 0xFFFF) + (el & 0xFFFF);
	      c2 = (h4l >>> 16) + (el >>> 16) + (c1 >>> 16);
	      c3 = (h4h & 0xFFFF) + (eh & 0xFFFF) + (c2 >>> 16);
	      c4 = (h4h >>> 16) + (eh >>> 16) + (c3 >>> 16);
	
	      h4h = (c4 << 16) | (c3 & 0xFFFF);
	      h4l = (c2 << 16) | (c1 & 0xFFFF);
	
	      c1 = (h5l & 0xFFFF) + (fl & 0xFFFF);
	      c2 = (h5l >>> 16) + (fl >>> 16) + (c1 >>> 16);
	      c3 = (h5h & 0xFFFF) + (fh & 0xFFFF) + (c2 >>> 16);
	      c4 = (h5h >>> 16) + (fh >>> 16) + (c3 >>> 16);
	
	      h5h = (c4 << 16) | (c3 & 0xFFFF);
	      h5l = (c2 << 16) | (c1 & 0xFFFF);
	
	      c1 = (h6l & 0xFFFF) + (gl & 0xFFFF);
	      c2 = (h6l >>> 16) + (gl >>> 16) + (c1 >>> 16);
	      c3 = (h6h & 0xFFFF) + (gh & 0xFFFF) + (c2 >>> 16);
	      c4 = (h6h >>> 16) + (gh >>> 16) + (c3 >>> 16);
	
	      h6h = (c4 << 16) | (c3 & 0xFFFF);
	      h6l = (c2 << 16) | (c1 & 0xFFFF);
	
	      c1 = (h7l & 0xFFFF) + (hl & 0xFFFF);
	      c2 = (h7l >>> 16) + (hl >>> 16) + (c1 >>> 16);
	      c3 = (h7h & 0xFFFF) + (hh & 0xFFFF) + (c2 >>> 16);
	      c4 = (h7h >>> 16) + (hh >>> 16) + (c3 >>> 16);
	
	      h7h = (c4 << 16) | (c3 & 0xFFFF);
	      h7l = (c2 << 16) | (c1 & 0xFFFF);
	    } while(!end);
	
	    var hex = HEX_CHARS[(h0h >> 28) & 0x0F] + HEX_CHARS[(h0h >> 24) & 0x0F] +
	              HEX_CHARS[(h0h >> 20) & 0x0F] + HEX_CHARS[(h0h >> 16) & 0x0F] +
	              HEX_CHARS[(h0h >> 12) & 0x0F] + HEX_CHARS[(h0h >> 8) & 0x0F] +
	              HEX_CHARS[(h0h >> 4) & 0x0F] + HEX_CHARS[h0h & 0x0F] +
	              HEX_CHARS[(h0l >> 28) & 0x0F] + HEX_CHARS[(h0l >> 24) & 0x0F] +
	              HEX_CHARS[(h0l >> 20) & 0x0F] + HEX_CHARS[(h0l >> 16) & 0x0F] +
	              HEX_CHARS[(h0l >> 12) & 0x0F] + HEX_CHARS[(h0l >> 8) & 0x0F] +
	              HEX_CHARS[(h0l >> 4) & 0x0F] + HEX_CHARS[h0l & 0x0F] +
	              HEX_CHARS[(h1h >> 28) & 0x0F] + HEX_CHARS[(h1h >> 24) & 0x0F] +
	              HEX_CHARS[(h1h >> 20) & 0x0F] + HEX_CHARS[(h1h >> 16) & 0x0F] +
	              HEX_CHARS[(h1h >> 12) & 0x0F] + HEX_CHARS[(h1h >> 8) & 0x0F] +
	              HEX_CHARS[(h1h >> 4) & 0x0F] + HEX_CHARS[h1h & 0x0F] +
	              HEX_CHARS[(h1l >> 28) & 0x0F] + HEX_CHARS[(h1l >> 24) & 0x0F] +
	              HEX_CHARS[(h1l >> 20) & 0x0F] + HEX_CHARS[(h1l >> 16) & 0x0F] +
	              HEX_CHARS[(h1l >> 12) & 0x0F] + HEX_CHARS[(h1l >> 8) & 0x0F] +
	              HEX_CHARS[(h1l >> 4) & 0x0F] + HEX_CHARS[h1l & 0x0F] +
	              HEX_CHARS[(h2h >> 28) & 0x0F] + HEX_CHARS[(h2h >> 24) & 0x0F] +
	              HEX_CHARS[(h2h >> 20) & 0x0F] + HEX_CHARS[(h2h >> 16) & 0x0F] +
	              HEX_CHARS[(h2h >> 12) & 0x0F] + HEX_CHARS[(h2h >> 8) & 0x0F] +
	              HEX_CHARS[(h2h >> 4) & 0x0F] + HEX_CHARS[h2h & 0x0F] +
	              HEX_CHARS[(h2l >> 28) & 0x0F] + HEX_CHARS[(h2l >> 24) & 0x0F] +
	              HEX_CHARS[(h2l >> 20) & 0x0F] + HEX_CHARS[(h2l >> 16) & 0x0F] +
	              HEX_CHARS[(h2l >> 12) & 0x0F] + HEX_CHARS[(h2l >> 8) & 0x0F] +
	              HEX_CHARS[(h2l >> 4) & 0x0F] + HEX_CHARS[h2l & 0x0F] +
	              HEX_CHARS[(h3h >> 28) & 0x0F] + HEX_CHARS[(h3h >> 24) & 0x0F] +
	              HEX_CHARS[(h3h >> 20) & 0x0F] + HEX_CHARS[(h3h >> 16) & 0x0F] +
	              HEX_CHARS[(h3h >> 12) & 0x0F] + HEX_CHARS[(h3h >> 8) & 0x0F] +
	              HEX_CHARS[(h3h >> 4) & 0x0F] + HEX_CHARS[h3h & 0x0F];
	    if(bits >= 256) {
	      hex += HEX_CHARS[(h3l >> 28) & 0x0F] + HEX_CHARS[(h3l >> 24) & 0x0F] +
	             HEX_CHARS[(h3l >> 20) & 0x0F] + HEX_CHARS[(h3l >> 16) & 0x0F] +
	             HEX_CHARS[(h3l >> 12) & 0x0F] + HEX_CHARS[(h3l >> 8) & 0x0F] +
	             HEX_CHARS[(h3l >> 4) & 0x0F] + HEX_CHARS[h3l & 0x0F];
	    }
	    if(bits >= 384) {
	      hex += HEX_CHARS[(h4h >> 28) & 0x0F] + HEX_CHARS[(h4h >> 24) & 0x0F] +
	             HEX_CHARS[(h4h >> 20) & 0x0F] + HEX_CHARS[(h4h >> 16) & 0x0F] +
	             HEX_CHARS[(h4h >> 12) & 0x0F] + HEX_CHARS[(h4h >> 8) & 0x0F] +
	             HEX_CHARS[(h4h >> 4) & 0x0F] + HEX_CHARS[h4h & 0x0F] +
	             HEX_CHARS[(h4l >> 28) & 0x0F] + HEX_CHARS[(h4l >> 24) & 0x0F] +
	             HEX_CHARS[(h4l >> 20) & 0x0F] + HEX_CHARS[(h4l >> 16) & 0x0F] +
	             HEX_CHARS[(h4l >> 12) & 0x0F] + HEX_CHARS[(h4l >> 8) & 0x0F] +
	             HEX_CHARS[(h4l >> 4) & 0x0F] + HEX_CHARS[h4l & 0x0F] +
	             HEX_CHARS[(h5h >> 28) & 0x0F] + HEX_CHARS[(h5h >> 24) & 0x0F] +
	             HEX_CHARS[(h5h >> 20) & 0x0F] + HEX_CHARS[(h5h >> 16) & 0x0F] +
	             HEX_CHARS[(h5h >> 12) & 0x0F] + HEX_CHARS[(h5h >> 8) & 0x0F] +
	             HEX_CHARS[(h5h >> 4) & 0x0F] + HEX_CHARS[h5h & 0x0F] +
	             HEX_CHARS[(h5l >> 28) & 0x0F] + HEX_CHARS[(h5l >> 24) & 0x0F] +
	             HEX_CHARS[(h5l >> 20) & 0x0F] + HEX_CHARS[(h5l >> 16) & 0x0F] +
	             HEX_CHARS[(h5l >> 12) & 0x0F] + HEX_CHARS[(h5l >> 8) & 0x0F] +
	             HEX_CHARS[(h5l >> 4) & 0x0F] + HEX_CHARS[h5l & 0x0F];
	    }
	    if(bits == 512) {
	      hex += HEX_CHARS[(h6h >> 28) & 0x0F] + HEX_CHARS[(h6h >> 24) & 0x0F] +
	             HEX_CHARS[(h6h >> 20) & 0x0F] + HEX_CHARS[(h6h >> 16) & 0x0F] +
	             HEX_CHARS[(h6h >> 12) & 0x0F] + HEX_CHARS[(h6h >> 8) & 0x0F] +
	             HEX_CHARS[(h6h >> 4) & 0x0F] + HEX_CHARS[h6h & 0x0F] +
	             HEX_CHARS[(h6l >> 28) & 0x0F] + HEX_CHARS[(h6l >> 24) & 0x0F] +
	             HEX_CHARS[(h6l >> 20) & 0x0F] + HEX_CHARS[(h6l >> 16) & 0x0F] +
	             HEX_CHARS[(h6l >> 12) & 0x0F] + HEX_CHARS[(h6l >> 8) & 0x0F] +
	             HEX_CHARS[(h6l >> 4) & 0x0F] + HEX_CHARS[h6l & 0x0F] +
	             HEX_CHARS[(h7h >> 28) & 0x0F] + HEX_CHARS[(h7h >> 24) & 0x0F] +
	             HEX_CHARS[(h7h >> 20) & 0x0F] + HEX_CHARS[(h7h >> 16) & 0x0F] +
	             HEX_CHARS[(h7h >> 12) & 0x0F] + HEX_CHARS[(h7h >> 8) & 0x0F] +
	             HEX_CHARS[(h7h >> 4) & 0x0F] + HEX_CHARS[h7h & 0x0F] +
	             HEX_CHARS[(h7l >> 28) & 0x0F] + HEX_CHARS[(h7l >> 24) & 0x0F] +
	             HEX_CHARS[(h7l >> 20) & 0x0F] + HEX_CHARS[(h7l >> 16) & 0x0F] +
	             HEX_CHARS[(h7l >> 12) & 0x0F] + HEX_CHARS[(h7l >> 8) & 0x0F] +
	             HEX_CHARS[(h7l >> 4) & 0x0F] + HEX_CHARS[h7l & 0x0F];
	    }
	    return hex;
	  };
	
	  if(!root.JS_SHA512_TEST && NODE_JS) {
	    sha512.sha512 = sha512;
	    sha512.sha384 = sha384;
	    sha512.sha512_256 = sha512_256;
	    sha512.sha512_224 = sha512_224;
	    module.exports = sha512;
	  } else if(root) {
	    root.sha512 = sha512;
	    root.sha384 = sha384;
	    root.sha512_256 = sha512_256;
	    root.sha512_224 = sha512_224;
	  }
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(756));
	__export(__webpack_require__(757));
	__export(__webpack_require__(761));


/***/ }),
/* 756 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ANALYTIC_EVENTS = {
	    NEW_TRANSFER: {
	        NAME: 'New transfer',
	        LABEL: {
	            INTERNAL: 'Between Your Accounts',
	            TO_BANK_ACCOUNT: 'To Inner Client Account',
	            EXTERNAL: 'External Transfer',
	            DEBIT_CARD: 'Top-up Your Card',
	            TO_MASTER_ACCOUNT: 'Fund Master Account',
	            EXTERNAL_MASS: 'External mass payments'
	        },
	        ACTION: {
	            CREATE: 'create',
	            CONFIRM: 'confirm',
	            CANCEL: 'cancel',
	        }
	    }
	};


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var config_1 = __webpack_require__(758);
	var providers_1 = __webpack_require__(761);
	var AnalyticsUtils = (function () {
	    function AnalyticsUtils() {
	    }
	    AnalyticsUtils.init = function () {
	        if (config_1.APP_CONFIGURATIONS.analytic.mixpanel.enabled) {
	            this.providers.push(new providers_1.MixpanelAnalyticsProvider(config_1.APP_CONFIGURATIONS.analytic.mixpanel.token));
	        }
	        if (config_1.APP_CONFIGURATIONS.analytic.ga.enabled) {
	            this.providers.push(new providers_1.GoogleAnalyticsProvider(config_1.APP_CONFIGURATIONS.analytic.ga.token));
	        }
	        if (config_1.APP_CONFIGURATIONS.analytic.gtm.enabled) {
	            this.providers.push(new providers_1.GtmAnalyticsProvider(config_1.APP_CONFIGURATIONS.analytic.gtm.token));
	        }
	    };
	    AnalyticsUtils.trackEvent = function (event_type, event_data, cb) {
	        this.delegateToProviders(function (provider) { return provider.trackEvent(event_type, event_data); });
	    };
	    AnalyticsUtils.delegateToProviders = function (callback) {
	        this.providers.forEach(callback);
	    };
	    AnalyticsUtils.providers = [];
	    return AnalyticsUtils;
	}());
	exports.AnalyticsUtils = AnalyticsUtils;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(759));
	__export(__webpack_require__(760));


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var app_config_default_1 = __webpack_require__(760);
	function initConfigurations(config) {
	    /* Disable overriding from server configs*/
	    // delete config.isProduction;
	    if (!app_config_default_1.APP_CONFIGURATIONS.$$init) {
	        /* lodash merge for deep merging */
	        lodash_1.merge(app_config_default_1.APP_CONFIGURATIONS, config);
	        // Migrating current settings to new config object
	        // FIXME mikhail - Remove after config migration
	        if (!!app_config_default_1.APP_CONFIGURATIONS.newAccountCreationUrl) {
	            app_config_default_1.APP_CONFIGURATIONS.newAccountButton.enabled = true;
	            app_config_default_1.APP_CONFIGURATIONS.newAccountButton.url = app_config_default_1.APP_CONFIGURATIONS.newAccountCreationUrl;
	        }
	        app_config_default_1.APP_CONFIGURATIONS.$$init = true;
	    }
	    else {
	        console.error('Re-initialize the configuration!');
	    }
	}
	exports.initConfigurations = initConfigurations;


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.APP_CONFIGURATIONS = {
	    $$init: false,
	    isProduction: ("prod") === 'prod',
	    recaptchaSiteKey: undefined,
	    homePageUrl: undefined,
	    newAccountCreationUrl: undefined,
	    externalPayments: {
	        beneficiaryAddressDetailsOptional: false
	    },
	    analytic: {
	        mixpanel: { enabled: false },
	        ga: { enabled: false },
	        gtm: { enabled: false }
	    },
	    support: {
	        phone: undefined,
	        email: undefined
	    },
	    newAccountButton: {
	        enabled: true
	    },
	    survey: { enabled: false },
	    sidebar: {
	        tac: { enabled: false }
	    },
	    registration: {
	        tacUrl: undefined,
	        prohibitedActivitiesUrl: undefined,
	        delegateTo: {},
	        providerTac: {},
	        requireAuthorizedSignatoryIDDocumentsUploading: true,
	        fileUpload: {
	            passport: {
	                allowedMimeTypes: {
	                    'application/pdf': '.pdf',
	                    'image/png': '.png',
	                    'image/jpeg': '.jpeg',
	                },
	                allowedMaxFileSize: 52428800,
	                allowedMaxCountAttachments: 50
	            },
	            selfie: {
	                allowedMimeTypes: {
	                    'application/pdf': '.pdf',
	                    'image/png': '.png',
	                    'image/jpeg': '.jpeg',
	                },
	                allowedMaxFileSize: 52428800,
	                allowedMaxCountAttachments: 50
	            },
	            address: {
	                allowedMimeTypes: {
	                    'application/pdf': '.pdf',
	                    'image/png': '.png',
	                    'image/jpeg': '.jpeg',
	                    'application/msword': '.doc',
	                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
	                },
	                allowedMaxFileSize: 52428800,
	                allowedMaxCountAttachments: 50
	            },
	            documents: {
	                allowedMimeTypes: {
	                    'application/pdf': '.pdf',
	                    'image/png': '.png',
	                    'image/jpeg': '.jpeg',
	                    'application/msword': '.doc',
	                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
	                },
	                allowedMaxFileSize: 52428800,
	                allowedMaxCountAttachments: 50
	            },
	            proof: {
	                allowedMimeTypes: {
	                    'application/pdf': '.pdf',
	                    'image/png': '.png',
	                    'image/jpeg': '.jpeg',
	                    'application/msword': '.doc',
	                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
	                },
	                allowedMaxFileSize: 52428800,
	                allowedMaxCountAttachments: 50
	            }
	        }
	    },
	    freshchat: {
	        enabled: false,
	        vendor: undefined
	    },
	    ctaButton: {
	        enabled: false,
	        url: undefined,
	        tooltipEnabled: false,
	        tooltipEmail: undefined
	    },
	    identification: {
	        appStoreUrl: undefined,
	        playMarketUrl: undefined
	    },
	    validation: {
	        urlPattern: '^((http|https)://)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,10}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)$'
	    },
	    twoFactorAuth: {
	        signInHelpUrl: undefined
	    },
	    onlineTransaction: {
	        expireTime: 30
	    },
	    loginFooter: {
	        enabled: true,
	        tacUrl: undefined,
	        privacyUrl: undefined
	    },
	    massPaymentTemplateFile: {
	        urlFile: '/static/Valid_payment.csv'
	    },
	    card: {
	        details: {
	            closeTimeoutSec: 30
	        },
	        history: {
	            limits: {
	                dateRange: 89
	            }
	        }
	    }
	};


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(762));
	__export(__webpack_require__(763));
	__export(__webpack_require__(765));


/***/ }),
/* 762 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var GoogleAnalyticsProvider = (function () {
	    function GoogleAnalyticsProvider(token) {
	        this.ga = ga;
	        this.ga('create', token);
	        console.log('Google analytics is enabled!');
	    }
	    GoogleAnalyticsProvider.prototype.trackEvent = function (event_type, event_data, cb) {
	        switch (event_type) {
	            case 'pageview':
	                this.ga('set', 'page', event_data);
	                this.ga('send', 'pageview');
	                break;
	            case 'event':
	                var _data = event_data;
	                var analytic_event_data = {
	                    hitType: 'event',
	                    eventCategory: _data.category,
	                    eventAction: _data.action,
	                    eventLabel: _data.label || '',
	                    eventValue: _data.value || null,
	                };
	                this.ga('send', analytic_event_data);
	                break;
	            case 'set_user_id':
	                this.ga('set', 'userId', event_data || 0);
	                break;
	            default:
	                break;
	        }
	    };
	    return GoogleAnalyticsProvider;
	}());
	exports.GoogleAnalyticsProvider = GoogleAnalyticsProvider;


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var mixpanel = __webpack_require__(764);
	var MixpanelAnalyticsProvider = (function () {
	    function MixpanelAnalyticsProvider(token) {
	        this.mixpanel = mixpanel;
	        this.mixpanel.init(token);
	        console.log('Mixpanel analytics is enabled!');
	    }
	    MixpanelAnalyticsProvider.prototype.trackEvent = function (event_type, event_data, cb) {
	        switch (event_type) {
	            case 'event':
	                var _event_data = event_data;
	                this.mixpanel.track(_event_data.category, _event_data);
	                break;
	            default:
	                break;
	        }
	    };
	    return MixpanelAnalyticsProvider;
	}());
	exports.MixpanelAnalyticsProvider = MixpanelAnalyticsProvider;


/***/ }),
/* 764 */
/***/ (function(module, exports) {

	'use strict';
	
	var Config = {
	    DEBUG: false,
	    LIB_VERSION: '2.41.0'
	};
	
	// since es6 imports are static and we run unit tests from the console, window won't be defined when importing this file
	var window$1;
	if (typeof(window) === 'undefined') {
	    var loc = {
	        hostname: ''
	    };
	    window$1 = {
	        navigator: { userAgent: '' },
	        document: {
	            location: loc,
	            referrer: ''
	        },
	        screen: { width: 0, height: 0 },
	        location: loc
	    };
	} else {
	    window$1 = window;
	}
	
	/*
	 * Saved references to long variable names, so that closure compiler can
	 * minimize file size.
	 */
	
	var ArrayProto = Array.prototype;
	var FuncProto = Function.prototype;
	var ObjProto = Object.prototype;
	var slice = ArrayProto.slice;
	var toString = ObjProto.toString;
	var hasOwnProperty = ObjProto.hasOwnProperty;
	var windowConsole = window$1.console;
	var navigator$1 = window$1.navigator;
	var document$1 = window$1.document;
	var windowOpera = window$1.opera;
	var screen = window$1.screen;
	var userAgent = navigator$1.userAgent;
	var nativeBind = FuncProto.bind;
	var nativeForEach = ArrayProto.forEach;
	var nativeIndexOf = ArrayProto.indexOf;
	var nativeMap = ArrayProto.map;
	var nativeIsArray = Array.isArray;
	var breaker = {};
	var _ = {
	    trim: function(str) {
	        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
	        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	    }
	};
	
	// Console override
	var console = {
	    /** @type {function(...*)} */
	    log: function() {
	        if (Config.DEBUG && !_.isUndefined(windowConsole) && windowConsole) {
	            try {
	                windowConsole.log.apply(windowConsole, arguments);
	            } catch (err) {
	                _.each(arguments, function(arg) {
	                    windowConsole.log(arg);
	                });
	            }
	        }
	    },
	    /** @type {function(...*)} */
	    warn: function() {
	        if (Config.DEBUG && !_.isUndefined(windowConsole) && windowConsole) {
	            var args = ['Mixpanel warning:'].concat(_.toArray(arguments));
	            try {
	                windowConsole.warn.apply(windowConsole, args);
	            } catch (err) {
	                _.each(args, function(arg) {
	                    windowConsole.warn(arg);
	                });
	            }
	        }
	    },
	    /** @type {function(...*)} */
	    error: function() {
	        if (Config.DEBUG && !_.isUndefined(windowConsole) && windowConsole) {
	            var args = ['Mixpanel error:'].concat(_.toArray(arguments));
	            try {
	                windowConsole.error.apply(windowConsole, args);
	            } catch (err) {
	                _.each(args, function(arg) {
	                    windowConsole.error(arg);
	                });
	            }
	        }
	    },
	    /** @type {function(...*)} */
	    critical: function() {
	        if (!_.isUndefined(windowConsole) && windowConsole) {
	            var args = ['Mixpanel error:'].concat(_.toArray(arguments));
	            try {
	                windowConsole.error.apply(windowConsole, args);
	            } catch (err) {
	                _.each(args, function(arg) {
	                    windowConsole.error(arg);
	                });
	            }
	        }
	    }
	};
	
	var log_func_with_prefix = function(func, prefix) {
	    return function() {
	        arguments[0] = '[' + prefix + '] ' + arguments[0];
	        return func.apply(console, arguments);
	    };
	};
	var console_with_prefix = function(prefix) {
	    return {
	        log: log_func_with_prefix(console.log, prefix),
	        error: log_func_with_prefix(console.error, prefix),
	        critical: log_func_with_prefix(console.critical, prefix)
	    };
	};
	
	
	// UNDERSCORE
	// Embed part of the Underscore Library
	_.bind = function(func, context) {
	    var args, bound;
	    if (nativeBind && func.bind === nativeBind) {
	        return nativeBind.apply(func, slice.call(arguments, 1));
	    }
	    if (!_.isFunction(func)) {
	        throw new TypeError();
	    }
	    args = slice.call(arguments, 2);
	    bound = function() {
	        if (!(this instanceof bound)) {
	            return func.apply(context, args.concat(slice.call(arguments)));
	        }
	        var ctor = {};
	        ctor.prototype = func.prototype;
	        var self = new ctor();
	        ctor.prototype = null;
	        var result = func.apply(self, args.concat(slice.call(arguments)));
	        if (Object(result) === result) {
	            return result;
	        }
	        return self;
	    };
	    return bound;
	};
	
	_.bind_instance_methods = function(obj) {
	    for (var func in obj) {
	        if (typeof(obj[func]) === 'function') {
	            obj[func] = _.bind(obj[func], obj);
	        }
	    }
	};
	
	/**
	 * @param {*=} obj
	 * @param {function(...*)=} iterator
	 * @param {Object=} context
	 */
	_.each = function(obj, iterator, context) {
	    if (obj === null || obj === undefined) {
	        return;
	    }
	    if (nativeForEach && obj.forEach === nativeForEach) {
	        obj.forEach(iterator, context);
	    } else if (obj.length === +obj.length) {
	        for (var i = 0, l = obj.length; i < l; i++) {
	            if (i in obj && iterator.call(context, obj[i], i, obj) === breaker) {
	                return;
	            }
	        }
	    } else {
	        for (var key in obj) {
	            if (hasOwnProperty.call(obj, key)) {
	                if (iterator.call(context, obj[key], key, obj) === breaker) {
	                    return;
	                }
	            }
	        }
	    }
	};
	
	_.escapeHTML = function(s) {
	    var escaped = s;
	    if (escaped && _.isString(escaped)) {
	        escaped = escaped
	            .replace(/&/g, '&amp;')
	            .replace(/</g, '&lt;')
	            .replace(/>/g, '&gt;')
	            .replace(/"/g, '&quot;')
	            .replace(/'/g, '&#039;');
	    }
	    return escaped;
	};
	
	_.extend = function(obj) {
	    _.each(slice.call(arguments, 1), function(source) {
	        for (var prop in source) {
	            if (source[prop] !== void 0) {
	                obj[prop] = source[prop];
	            }
	        }
	    });
	    return obj;
	};
	
	_.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	};
	
	// from a comment on http://dbj.org/dbj/?p=286
	// fails on only one very rare and deliberate custom object:
	// var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
	_.isFunction = function(f) {
	    try {
	        return /^\s*\bfunction\b/.test(f);
	    } catch (x) {
	        return false;
	    }
	};
	
	_.isArguments = function(obj) {
	    return !!(obj && hasOwnProperty.call(obj, 'callee'));
	};
	
	_.toArray = function(iterable) {
	    if (!iterable) {
	        return [];
	    }
	    if (iterable.toArray) {
	        return iterable.toArray();
	    }
	    if (_.isArray(iterable)) {
	        return slice.call(iterable);
	    }
	    if (_.isArguments(iterable)) {
	        return slice.call(iterable);
	    }
	    return _.values(iterable);
	};
	
	_.map = function(arr, callback, context) {
	    if (nativeMap && arr.map === nativeMap) {
	        return arr.map(callback, context);
	    } else {
	        var results = [];
	        _.each(arr, function(item) {
	            results.push(callback.call(context, item));
	        });
	        return results;
	    }
	};
	
	_.keys = function(obj) {
	    var results = [];
	    if (obj === null) {
	        return results;
	    }
	    _.each(obj, function(value, key) {
	        results[results.length] = key;
	    });
	    return results;
	};
	
	_.values = function(obj) {
	    var results = [];
	    if (obj === null) {
	        return results;
	    }
	    _.each(obj, function(value) {
	        results[results.length] = value;
	    });
	    return results;
	};
	
	_.include = function(obj, target) {
	    var found = false;
	    if (obj === null) {
	        return found;
	    }
	    if (nativeIndexOf && obj.indexOf === nativeIndexOf) {
	        return obj.indexOf(target) != -1;
	    }
	    _.each(obj, function(value) {
	        if (found || (found = (value === target))) {
	            return breaker;
	        }
	    });
	    return found;
	};
	
	_.includes = function(str, needle) {
	    return str.indexOf(needle) !== -1;
	};
	
	// Underscore Addons
	_.inherit = function(subclass, superclass) {
	    subclass.prototype = new superclass();
	    subclass.prototype.constructor = subclass;
	    subclass.superclass = superclass.prototype;
	    return subclass;
	};
	
	_.isObject = function(obj) {
	    return (obj === Object(obj) && !_.isArray(obj));
	};
	
	_.isEmptyObject = function(obj) {
	    if (_.isObject(obj)) {
	        for (var key in obj) {
	            if (hasOwnProperty.call(obj, key)) {
	                return false;
	            }
	        }
	        return true;
	    }
	    return false;
	};
	
	_.isUndefined = function(obj) {
	    return obj === void 0;
	};
	
	_.isString = function(obj) {
	    return toString.call(obj) == '[object String]';
	};
	
	_.isDate = function(obj) {
	    return toString.call(obj) == '[object Date]';
	};
	
	_.isNumber = function(obj) {
	    return toString.call(obj) == '[object Number]';
	};
	
	_.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	};
	
	_.encodeDates = function(obj) {
	    _.each(obj, function(v, k) {
	        if (_.isDate(v)) {
	            obj[k] = _.formatDate(v);
	        } else if (_.isObject(v)) {
	            obj[k] = _.encodeDates(v); // recurse
	        }
	    });
	    return obj;
	};
	
	_.timestamp = function() {
	    Date.now = Date.now || function() {
	        return +new Date;
	    };
	    return Date.now();
	};
	
	_.formatDate = function(d) {
	    // YYYY-MM-DDTHH:MM:SS in UTC
	    function pad(n) {
	        return n < 10 ? '0' + n : n;
	    }
	    return d.getUTCFullYear() + '-' +
	        pad(d.getUTCMonth() + 1) + '-' +
	        pad(d.getUTCDate()) + 'T' +
	        pad(d.getUTCHours()) + ':' +
	        pad(d.getUTCMinutes()) + ':' +
	        pad(d.getUTCSeconds());
	};
	
	_.safewrap = function(f) {
	    return function() {
	        try {
	            return f.apply(this, arguments);
	        } catch (e) {
	            console.critical('Implementation error. Please turn on debug and contact support@mixpanel.com.');
	            if (Config.DEBUG){
	                console.critical(e);
	            }
	        }
	    };
	};
	
	_.safewrap_class = function(klass, functions) {
	    for (var i = 0; i < functions.length; i++) {
	        klass.prototype[functions[i]] = _.safewrap(klass.prototype[functions[i]]);
	    }
	};
	
	_.safewrap_instance_methods = function(obj) {
	    for (var func in obj) {
	        if (typeof(obj[func]) === 'function') {
	            obj[func] = _.safewrap(obj[func]);
	        }
	    }
	};
	
	_.strip_empty_properties = function(p) {
	    var ret = {};
	    _.each(p, function(v, k) {
	        if (_.isString(v) && v.length > 0) {
	            ret[k] = v;
	        }
	    });
	    return ret;
	};
	
	/*
	 * this function returns a copy of object after truncating it.  If
	 * passed an Array or Object it will iterate through obj and
	 * truncate all the values recursively.
	 */
	_.truncate = function(obj, length) {
	    var ret;
	
	    if (typeof(obj) === 'string') {
	        ret = obj.slice(0, length);
	    } else if (_.isArray(obj)) {
	        ret = [];
	        _.each(obj, function(val) {
	            ret.push(_.truncate(val, length));
	        });
	    } else if (_.isObject(obj)) {
	        ret = {};
	        _.each(obj, function(val, key) {
	            ret[key] = _.truncate(val, length);
	        });
	    } else {
	        ret = obj;
	    }
	
	    return ret;
	};
	
	_.JSONEncode = (function() {
	    return function(mixed_val) {
	        var value = mixed_val;
	        var quote = function(string) {
	            var escapable = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex
	            var meta = { // table of character substitutions
	                '\b': '\\b',
	                '\t': '\\t',
	                '\n': '\\n',
	                '\f': '\\f',
	                '\r': '\\r',
	                '"': '\\"',
	                '\\': '\\\\'
	            };
	
	            escapable.lastIndex = 0;
	            return escapable.test(string) ?
	                '"' + string.replace(escapable, function(a) {
	                    var c = meta[a];
	                    return typeof c === 'string' ? c :
	                        '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
	                }) + '"' :
	                '"' + string + '"';
	        };
	
	        var str = function(key, holder) {
	            var gap = '';
	            var indent = '    ';
	            var i = 0; // The loop counter.
	            var k = ''; // The member key.
	            var v = ''; // The member value.
	            var length = 0;
	            var mind = gap;
	            var partial = [];
	            var value = holder[key];
	
	            // If the value has a toJSON method, call it to obtain a replacement value.
	            if (value && typeof value === 'object' &&
	                typeof value.toJSON === 'function') {
	                value = value.toJSON(key);
	            }
	
	            // What happens next depends on the value's type.
	            switch (typeof value) {
	                case 'string':
	                    return quote(value);
	
	                case 'number':
	                    // JSON numbers must be finite. Encode non-finite numbers as null.
	                    return isFinite(value) ? String(value) : 'null';
	
	                case 'boolean':
	                case 'null':
	                    // If the value is a boolean or null, convert it to a string. Note:
	                    // typeof null does not produce 'null'. The case is included here in
	                    // the remote chance that this gets fixed someday.
	
	                    return String(value);
	
	                case 'object':
	                    // If the type is 'object', we might be dealing with an object or an array or
	                    // null.
	                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
	                    // so watch out for that case.
	                    if (!value) {
	                        return 'null';
	                    }
	
	                    // Make an array to hold the partial results of stringifying this object value.
	                    gap += indent;
	                    partial = [];
	
	                    // Is the value an array?
	                    if (toString.apply(value) === '[object Array]') {
	                        // The value is an array. Stringify every element. Use null as a placeholder
	                        // for non-JSON values.
	
	                        length = value.length;
	                        for (i = 0; i < length; i += 1) {
	                            partial[i] = str(i, value) || 'null';
	                        }
	
	                        // Join all of the elements together, separated with commas, and wrap them in
	                        // brackets.
	                        v = partial.length === 0 ? '[]' :
	                            gap ? '[\n' + gap +
	                            partial.join(',\n' + gap) + '\n' +
	                            mind + ']' :
	                                '[' + partial.join(',') + ']';
	                        gap = mind;
	                        return v;
	                    }
	
	                    // Iterate through all of the keys in the object.
	                    for (k in value) {
	                        if (hasOwnProperty.call(value, k)) {
	                            v = str(k, value);
	                            if (v) {
	                                partial.push(quote(k) + (gap ? ': ' : ':') + v);
	                            }
	                        }
	                    }
	
	                    // Join all of the member texts together, separated with commas,
	                    // and wrap them in braces.
	                    v = partial.length === 0 ? '{}' :
	                        gap ? '{' + partial.join(',') + '' +
	                        mind + '}' : '{' + partial.join(',') + '}';
	                    gap = mind;
	                    return v;
	            }
	        };
	
	        // Make a fake root object containing our value under the key of ''.
	        // Return the result of stringifying the value.
	        return str('', {
	            '': value
	        });
	    };
	})();
	
	/**
	 * From https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
	 * Slightly modified to throw a real Error rather than a POJO
	 */
	_.JSONDecode = (function() {
	    var at, // The index of the current character
	        ch, // The current character
	        escapee = {
	            '"': '"',
	            '\\': '\\',
	            '/': '/',
	            'b': '\b',
	            'f': '\f',
	            'n': '\n',
	            'r': '\r',
	            't': '\t'
	        },
	        text,
	        error = function(m) {
	            var e = new SyntaxError(m);
	            e.at = at;
	            e.text = text;
	            throw e;
	        },
	        next = function(c) {
	            // If a c parameter is provided, verify that it matches the current character.
	            if (c && c !== ch) {
	                error('Expected \'' + c + '\' instead of \'' + ch + '\'');
	            }
	            // Get the next character. When there are no more characters,
	            // return the empty string.
	            ch = text.charAt(at);
	            at += 1;
	            return ch;
	        },
	        number = function() {
	            // Parse a number value.
	            var number,
	                string = '';
	
	            if (ch === '-') {
	                string = '-';
	                next('-');
	            }
	            while (ch >= '0' && ch <= '9') {
	                string += ch;
	                next();
	            }
	            if (ch === '.') {
	                string += '.';
	                while (next() && ch >= '0' && ch <= '9') {
	                    string += ch;
	                }
	            }
	            if (ch === 'e' || ch === 'E') {
	                string += ch;
	                next();
	                if (ch === '-' || ch === '+') {
	                    string += ch;
	                    next();
	                }
	                while (ch >= '0' && ch <= '9') {
	                    string += ch;
	                    next();
	                }
	            }
	            number = +string;
	            if (!isFinite(number)) {
	                error('Bad number');
	            } else {
	                return number;
	            }
	        },
	
	        string = function() {
	            // Parse a string value.
	            var hex,
	                i,
	                string = '',
	                uffff;
	            // When parsing for string values, we must look for " and \ characters.
	            if (ch === '"') {
	                while (next()) {
	                    if (ch === '"') {
	                        next();
	                        return string;
	                    }
	                    if (ch === '\\') {
	                        next();
	                        if (ch === 'u') {
	                            uffff = 0;
	                            for (i = 0; i < 4; i += 1) {
	                                hex = parseInt(next(), 16);
	                                if (!isFinite(hex)) {
	                                    break;
	                                }
	                                uffff = uffff * 16 + hex;
	                            }
	                            string += String.fromCharCode(uffff);
	                        } else if (typeof escapee[ch] === 'string') {
	                            string += escapee[ch];
	                        } else {
	                            break;
	                        }
	                    } else {
	                        string += ch;
	                    }
	                }
	            }
	            error('Bad string');
	        },
	        white = function() {
	            // Skip whitespace.
	            while (ch && ch <= ' ') {
	                next();
	            }
	        },
	        word = function() {
	            // true, false, or null.
	            switch (ch) {
	                case 't':
	                    next('t');
	                    next('r');
	                    next('u');
	                    next('e');
	                    return true;
	                case 'f':
	                    next('f');
	                    next('a');
	                    next('l');
	                    next('s');
	                    next('e');
	                    return false;
	                case 'n':
	                    next('n');
	                    next('u');
	                    next('l');
	                    next('l');
	                    return null;
	            }
	            error('Unexpected "' + ch + '"');
	        },
	        value, // Placeholder for the value function.
	        array = function() {
	            // Parse an array value.
	            var array = [];
	
	            if (ch === '[') {
	                next('[');
	                white();
	                if (ch === ']') {
	                    next(']');
	                    return array; // empty array
	                }
	                while (ch) {
	                    array.push(value());
	                    white();
	                    if (ch === ']') {
	                        next(']');
	                        return array;
	                    }
	                    next(',');
	                    white();
	                }
	            }
	            error('Bad array');
	        },
	        object = function() {
	            // Parse an object value.
	            var key,
	                object = {};
	
	            if (ch === '{') {
	                next('{');
	                white();
	                if (ch === '}') {
	                    next('}');
	                    return object; // empty object
	                }
	                while (ch) {
	                    key = string();
	                    white();
	                    next(':');
	                    if (Object.hasOwnProperty.call(object, key)) {
	                        error('Duplicate key "' + key + '"');
	                    }
	                    object[key] = value();
	                    white();
	                    if (ch === '}') {
	                        next('}');
	                        return object;
	                    }
	                    next(',');
	                    white();
	                }
	            }
	            error('Bad object');
	        };
	
	    value = function() {
	        // Parse a JSON value. It could be an object, an array, a string,
	        // a number, or a word.
	        white();
	        switch (ch) {
	            case '{':
	                return object();
	            case '[':
	                return array();
	            case '"':
	                return string();
	            case '-':
	                return number();
	            default:
	                return ch >= '0' && ch <= '9' ? number() : word();
	        }
	    };
	
	    // Return the json_parse function. It will have access to all of the
	    // above functions and variables.
	    return function(source) {
	        var result;
	
	        text = source;
	        at = 0;
	        ch = ' ';
	        result = value();
	        white();
	        if (ch) {
	            error('Syntax error');
	        }
	
	        return result;
	    };
	})();
	
	_.base64Encode = function(data) {
	    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0,
	        ac = 0,
	        enc = '',
	        tmp_arr = [];
	
	    if (!data) {
	        return data;
	    }
	
	    data = _.utf8Encode(data);
	
	    do { // pack three octets into four hexets
	        o1 = data.charCodeAt(i++);
	        o2 = data.charCodeAt(i++);
	        o3 = data.charCodeAt(i++);
	
	        bits = o1 << 16 | o2 << 8 | o3;
	
	        h1 = bits >> 18 & 0x3f;
	        h2 = bits >> 12 & 0x3f;
	        h3 = bits >> 6 & 0x3f;
	        h4 = bits & 0x3f;
	
	        // use hexets to index into b64, and append result to encoded string
	        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
	    } while (i < data.length);
	
	    enc = tmp_arr.join('');
	
	    switch (data.length % 3) {
	        case 1:
	            enc = enc.slice(0, -2) + '==';
	            break;
	        case 2:
	            enc = enc.slice(0, -1) + '=';
	            break;
	    }
	
	    return enc;
	};
	
	_.utf8Encode = function(string) {
	    string = (string + '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
	
	    var utftext = '',
	        start,
	        end;
	    var stringl = 0,
	        n;
	
	    start = end = 0;
	    stringl = string.length;
	
	    for (n = 0; n < stringl; n++) {
	        var c1 = string.charCodeAt(n);
	        var enc = null;
	
	        if (c1 < 128) {
	            end++;
	        } else if ((c1 > 127) && (c1 < 2048)) {
	            enc = String.fromCharCode((c1 >> 6) | 192, (c1 & 63) | 128);
	        } else {
	            enc = String.fromCharCode((c1 >> 12) | 224, ((c1 >> 6) & 63) | 128, (c1 & 63) | 128);
	        }
	        if (enc !== null) {
	            if (end > start) {
	                utftext += string.substring(start, end);
	            }
	            utftext += enc;
	            start = end = n + 1;
	        }
	    }
	
	    if (end > start) {
	        utftext += string.substring(start, string.length);
	    }
	
	    return utftext;
	};
	
	_.UUID = (function() {
	
	    // Time/ticks information
	    // 1*new Date() is a cross browser version of Date.now()
	    var T = function() {
	        var d = 1 * new Date(),
	            i = 0;
	
	        // this while loop figures how many browser ticks go by
	        // before 1*new Date() returns a new number, ie the amount
	        // of ticks that go by per millisecond
	        while (d == 1 * new Date()) {
	            i++;
	        }
	
	        return d.toString(16) + i.toString(16);
	    };
	
	    // Math.Random entropy
	    var R = function() {
	        return Math.random().toString(16).replace('.', '');
	    };
	
	    // User agent entropy
	    // This function takes the user agent string, and then xors
	    // together each sequence of 8 bytes.  This produces a final
	    // sequence of 8 bytes which it returns as hex.
	    var UA = function() {
	        var ua = userAgent,
	            i, ch, buffer = [],
	            ret = 0;
	
	        function xor(result, byte_array) {
	            var j, tmp = 0;
	            for (j = 0; j < byte_array.length; j++) {
	                tmp |= (buffer[j] << j * 8);
	            }
	            return result ^ tmp;
	        }
	
	        for (i = 0; i < ua.length; i++) {
	            ch = ua.charCodeAt(i);
	            buffer.unshift(ch & 0xFF);
	            if (buffer.length >= 4) {
	                ret = xor(ret, buffer);
	                buffer = [];
	            }
	        }
	
	        if (buffer.length > 0) {
	            ret = xor(ret, buffer);
	        }
	
	        return ret.toString(16);
	    };
	
	    return function() {
	        var se = (screen.height * screen.width).toString(16);
	        return (T() + '-' + R() + '-' + UA() + '-' + se + '-' + T());
	    };
	})();
	
	// _.isBlockedUA()
	// This is to block various web spiders from executing our JS and
	// sending false tracking data
	var BLOCKED_UA_STRS = [
	    'baiduspider',
	    'bingbot',
	    'bingpreview',
	    'facebookexternal',
	    'pinterest',
	    'screaming frog',
	    'yahoo! slurp',
	    'yandexbot',
	
	    // a whole bunch of goog-specific crawlers
	    // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
	    'adsbot-google',
	    'apis-google',
	    'duplexweb-google',
	    'feedfetcher-google',
	    'google favicon',
	    'google web preview',
	    'google-read-aloud',
	    'googlebot',
	    'googleweblight',
	    'mediapartners-google',
	    'storebot-google'
	];
	_.isBlockedUA = function(ua) {
	    var i;
	    ua = ua.toLowerCase();
	    for (i = 0; i < BLOCKED_UA_STRS.length; i++) {
	        if (ua.indexOf(BLOCKED_UA_STRS[i]) !== -1) {
	            return true;
	        }
	    }
	    return false;
	};
	
	/**
	 * @param {Object=} formdata
	 * @param {string=} arg_separator
	 */
	_.HTTPBuildQuery = function(formdata, arg_separator) {
	    var use_val, use_key, tmp_arr = [];
	
	    if (_.isUndefined(arg_separator)) {
	        arg_separator = '&';
	    }
	
	    _.each(formdata, function(val, key) {
	        use_val = encodeURIComponent(val.toString());
	        use_key = encodeURIComponent(key);
	        tmp_arr[tmp_arr.length] = use_key + '=' + use_val;
	    });
	
	    return tmp_arr.join(arg_separator);
	};
	
	_.getQueryParam = function(url, param) {
	    // Expects a raw URL
	
	    param = param.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
	    var regexS = '[\\?&]' + param + '=([^&#]*)',
	        regex = new RegExp(regexS),
	        results = regex.exec(url);
	    if (results === null || (results && typeof(results[1]) !== 'string' && results[1].length)) {
	        return '';
	    } else {
	        var result = results[1];
	        try {
	            result = decodeURIComponent(result);
	        } catch(err) {
	            console.error('Skipping decoding for malformed query param: ' + result);
	        }
	        return result.replace(/\+/g, ' ');
	    }
	};
	
	
	// _.cookie
	// Methods partially borrowed from quirksmode.org/js/cookies.html
	_.cookie = {
	    get: function(name) {
	        var nameEQ = name + '=';
	        var ca = document$1.cookie.split(';');
	        for (var i = 0; i < ca.length; i++) {
	            var c = ca[i];
	            while (c.charAt(0) == ' ') {
	                c = c.substring(1, c.length);
	            }
	            if (c.indexOf(nameEQ) === 0) {
	                return decodeURIComponent(c.substring(nameEQ.length, c.length));
	            }
	        }
	        return null;
	    },
	
	    parse: function(name) {
	        var cookie;
	        try {
	            cookie = _.JSONDecode(_.cookie.get(name)) || {};
	        } catch (err) {
	            // noop
	        }
	        return cookie;
	    },
	
	    set_seconds: function(name, value, seconds, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
	        var cdomain = '',
	            expires = '',
	            secure = '';
	
	        if (domain_override) {
	            cdomain = '; domain=' + domain_override;
	        } else if (is_cross_subdomain) {
	            var domain = extract_domain(document$1.location.hostname);
	            cdomain = domain ? '; domain=.' + domain : '';
	        }
	
	        if (seconds) {
	            var date = new Date();
	            date.setTime(date.getTime() + (seconds * 1000));
	            expires = '; expires=' + date.toGMTString();
	        }
	
	        if (is_cross_site) {
	            is_secure = true;
	            secure = '; SameSite=None';
	        }
	        if (is_secure) {
	            secure += '; secure';
	        }
	
	        document$1.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
	    },
	
	    set: function(name, value, days, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
	        var cdomain = '', expires = '', secure = '';
	
	        if (domain_override) {
	            cdomain = '; domain=' + domain_override;
	        } else if (is_cross_subdomain) {
	            var domain = extract_domain(document$1.location.hostname);
	            cdomain = domain ? '; domain=.' + domain : '';
	        }
	
	        if (days) {
	            var date = new Date();
	            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
	            expires = '; expires=' + date.toGMTString();
	        }
	
	        if (is_cross_site) {
	            is_secure = true;
	            secure = '; SameSite=None';
	        }
	        if (is_secure) {
	            secure += '; secure';
	        }
	
	        var new_cookie_val = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
	        document$1.cookie = new_cookie_val;
	        return new_cookie_val;
	    },
	
	    remove: function(name, is_cross_subdomain, domain_override) {
	        _.cookie.set(name, '', -1, is_cross_subdomain, false, false, domain_override);
	    }
	};
	
	var _localStorageSupported = null;
	var localStorageSupported = function(storage, forceCheck) {
	    if (_localStorageSupported !== null && !forceCheck) {
	        return _localStorageSupported;
	    }
	
	    var supported = true;
	    try {
	        storage = storage || window.localStorage;
	        var key = '__mplss_' + cheap_guid(8),
	            val = 'xyz';
	        storage.setItem(key, val);
	        if (storage.getItem(key) !== val) {
	            supported = false;
	        }
	        storage.removeItem(key);
	    } catch (err) {
	        supported = false;
	    }
	
	    _localStorageSupported = supported;
	    return supported;
	};
	
	// _.localStorage
	_.localStorage = {
	    is_supported: function(force_check) {
	        var supported = localStorageSupported(null, force_check);
	        if (!supported) {
	            console.error('localStorage unsupported; falling back to cookie store');
	        }
	        return supported;
	    },
	
	    error: function(msg) {
	        console.error('localStorage error: ' + msg);
	    },
	
	    get: function(name) {
	        try {
	            return window.localStorage.getItem(name);
	        } catch (err) {
	            _.localStorage.error(err);
	        }
	        return null;
	    },
	
	    parse: function(name) {
	        try {
	            return _.JSONDecode(_.localStorage.get(name)) || {};
	        } catch (err) {
	            // noop
	        }
	        return null;
	    },
	
	    set: function(name, value) {
	        try {
	            window.localStorage.setItem(name, value);
	        } catch (err) {
	            _.localStorage.error(err);
	        }
	    },
	
	    remove: function(name) {
	        try {
	            window.localStorage.removeItem(name);
	        } catch (err) {
	            _.localStorage.error(err);
	        }
	    }
	};
	
	_.register_event = (function() {
	    // written by Dean Edwards, 2005
	    // with input from Tino Zijdel - crisp@xs4all.nl
	    // with input from Carl Sverre - mail@carlsverre.com
	    // with input from Mixpanel
	    // http://dean.edwards.name/weblog/2005/10/add-event/
	    // https://gist.github.com/1930440
	
	    /**
	     * @param {Object} element
	     * @param {string} type
	     * @param {function(...*)} handler
	     * @param {boolean=} oldSchool
	     * @param {boolean=} useCapture
	     */
	    var register_event = function(element, type, handler, oldSchool, useCapture) {
	        if (!element) {
	            console.error('No valid element provided to register_event');
	            return;
	        }
	
	        if (element.addEventListener && !oldSchool) {
	            element.addEventListener(type, handler, !!useCapture);
	        } else {
	            var ontype = 'on' + type;
	            var old_handler = element[ontype]; // can be undefined
	            element[ontype] = makeHandler(element, handler, old_handler);
	        }
	    };
	
	    function makeHandler(element, new_handler, old_handlers) {
	        var handler = function(event) {
	            event = event || fixEvent(window.event);
	
	            // this basically happens in firefox whenever another script
	            // overwrites the onload callback and doesn't pass the event
	            // object to previously defined callbacks.  All the browsers
	            // that don't define window.event implement addEventListener
	            // so the dom_loaded handler will still be fired as usual.
	            if (!event) {
	                return undefined;
	            }
	
	            var ret = true;
	            var old_result, new_result;
	
	            if (_.isFunction(old_handlers)) {
	                old_result = old_handlers(event);
	            }
	            new_result = new_handler.call(element, event);
	
	            if ((false === old_result) || (false === new_result)) {
	                ret = false;
	            }
	
	            return ret;
	        };
	
	        return handler;
	    }
	
	    function fixEvent(event) {
	        if (event) {
	            event.preventDefault = fixEvent.preventDefault;
	            event.stopPropagation = fixEvent.stopPropagation;
	        }
	        return event;
	    }
	    fixEvent.preventDefault = function() {
	        this.returnValue = false;
	    };
	    fixEvent.stopPropagation = function() {
	        this.cancelBubble = true;
	    };
	
	    return register_event;
	})();
	
	
	var TOKEN_MATCH_REGEX = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
	
	_.dom_query = (function() {
	    /* document.getElementsBySelector(selector)
	    - returns an array of element objects from the current document
	    matching the CSS selector. Selectors can contain element names,
	    class names and ids and can be nested. For example:
	
	    elements = document.getElementsBySelector('div#main p a.external')
	
	    Will return an array of all 'a' elements with 'external' in their
	    class attribute that are contained inside 'p' elements that are
	    contained inside the 'div' element which has id="main"
	
	    New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
	    See http://www.w3.org/TR/css3-selectors/#attribute-selectors
	
	    Version 0.4 - Simon Willison, March 25th 2003
	    -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
	    -- Opera 7 fails
	
	    Version 0.5 - Carl Sverre, Jan 7th 2013
	    -- Now uses jQuery-esque `hasClass` for testing class name
	    equality.  This fixes a bug related to '-' characters being
	    considered not part of a 'word' in regex.
	    */
	
	    function getAllChildren(e) {
	        // Returns all children of element. Workaround required for IE5/Windows. Ugh.
	        return e.all ? e.all : e.getElementsByTagName('*');
	    }
	
	    var bad_whitespace = /[\t\r\n]/g;
	
	    function hasClass(elem, selector) {
	        var className = ' ' + selector + ' ';
	        return ((' ' + elem.className + ' ').replace(bad_whitespace, ' ').indexOf(className) >= 0);
	    }
	
	    function getElementsBySelector(selector) {
	        // Attempt to fail gracefully in lesser browsers
	        if (!document$1.getElementsByTagName) {
	            return [];
	        }
	        // Split selector in to tokens
	        var tokens = selector.split(' ');
	        var token, bits, tagName, found, foundCount, i, j, k, elements, currentContextIndex;
	        var currentContext = [document$1];
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i].replace(/^\s+/, '').replace(/\s+$/, '');
	            if (token.indexOf('#') > -1) {
	                // Token is an ID selector
	                bits = token.split('#');
	                tagName = bits[0];
	                var id = bits[1];
	                var element = document$1.getElementById(id);
	                if (!element || (tagName && element.nodeName.toLowerCase() != tagName)) {
	                    // element not found or tag with that ID not found, return false
	                    return [];
	                }
	                // Set currentContext to contain just this element
	                currentContext = [element];
	                continue; // Skip to next token
	            }
	            if (token.indexOf('.') > -1) {
	                // Token contains a class selector
	                bits = token.split('.');
	                tagName = bits[0];
	                var className = bits[1];
	                if (!tagName) {
	                    tagName = '*';
	                }
	                // Get elements matching tag, filter them for class selector
	                found = [];
	                foundCount = 0;
	                for (j = 0; j < currentContext.length; j++) {
	                    if (tagName == '*') {
	                        elements = getAllChildren(currentContext[j]);
	                    } else {
	                        elements = currentContext[j].getElementsByTagName(tagName);
	                    }
	                    for (k = 0; k < elements.length; k++) {
	                        found[foundCount++] = elements[k];
	                    }
	                }
	                currentContext = [];
	                currentContextIndex = 0;
	                for (j = 0; j < found.length; j++) {
	                    if (found[j].className &&
	                        _.isString(found[j].className) && // some SVG elements have classNames which are not strings
	                        hasClass(found[j], className)
	                    ) {
	                        currentContext[currentContextIndex++] = found[j];
	                    }
	                }
	                continue; // Skip to next token
	            }
	            // Code to deal with attribute selectors
	            var token_match = token.match(TOKEN_MATCH_REGEX);
	            if (token_match) {
	                tagName = token_match[1];
	                var attrName = token_match[2];
	                var attrOperator = token_match[3];
	                var attrValue = token_match[4];
	                if (!tagName) {
	                    tagName = '*';
	                }
	                // Grab all of the tagName elements within current context
	                found = [];
	                foundCount = 0;
	                for (j = 0; j < currentContext.length; j++) {
	                    if (tagName == '*') {
	                        elements = getAllChildren(currentContext[j]);
	                    } else {
	                        elements = currentContext[j].getElementsByTagName(tagName);
	                    }
	                    for (k = 0; k < elements.length; k++) {
	                        found[foundCount++] = elements[k];
	                    }
	                }
	                currentContext = [];
	                currentContextIndex = 0;
	                var checkFunction; // This function will be used to filter the elements
	                switch (attrOperator) {
	                    case '=': // Equality
	                        checkFunction = function(e) {
	                            return (e.getAttribute(attrName) == attrValue);
	                        };
	                        break;
	                    case '~': // Match one of space seperated words
	                        checkFunction = function(e) {
	                            return (e.getAttribute(attrName).match(new RegExp('\\b' + attrValue + '\\b')));
	                        };
	                        break;
	                    case '|': // Match start with value followed by optional hyphen
	                        checkFunction = function(e) {
	                            return (e.getAttribute(attrName).match(new RegExp('^' + attrValue + '-?')));
	                        };
	                        break;
	                    case '^': // Match starts with value
	                        checkFunction = function(e) {
	                            return (e.getAttribute(attrName).indexOf(attrValue) === 0);
	                        };
	                        break;
	                    case '$': // Match ends with value - fails with "Warning" in Opera 7
	                        checkFunction = function(e) {
	                            return (e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length);
	                        };
	                        break;
	                    case '*': // Match ends with value
	                        checkFunction = function(e) {
	                            return (e.getAttribute(attrName).indexOf(attrValue) > -1);
	                        };
	                        break;
	                    default:
	                        // Just test for existence of attribute
	                        checkFunction = function(e) {
	                            return e.getAttribute(attrName);
	                        };
	                }
	                currentContext = [];
	                currentContextIndex = 0;
	                for (j = 0; j < found.length; j++) {
	                    if (checkFunction(found[j])) {
	                        currentContext[currentContextIndex++] = found[j];
	                    }
	                }
	                // alert('Attribute Selector: '+tagName+' '+attrName+' '+attrOperator+' '+attrValue);
	                continue; // Skip to next token
	            }
	            // If we get here, token is JUST an element (not a class or ID selector)
	            tagName = token;
	            found = [];
	            foundCount = 0;
	            for (j = 0; j < currentContext.length; j++) {
	                elements = currentContext[j].getElementsByTagName(tagName);
	                for (k = 0; k < elements.length; k++) {
	                    found[foundCount++] = elements[k];
	                }
	            }
	            currentContext = found;
	        }
	        return currentContext;
	    }
	
	    return function(query) {
	        if (_.isElement(query)) {
	            return [query];
	        } else if (_.isObject(query) && !_.isUndefined(query.length)) {
	            return query;
	        } else {
	            return getElementsBySelector.call(this, query);
	        }
	    };
	})();
	
	_.info = {
	    campaignParams: function() {
	        var campaign_keywords = 'utm_source utm_medium utm_campaign utm_content utm_term'.split(' '),
	            kw = '',
	            params = {};
	        _.each(campaign_keywords, function(kwkey) {
	            kw = _.getQueryParam(document$1.URL, kwkey);
	            if (kw.length) {
	                params[kwkey] = kw;
	            }
	        });
	
	        return params;
	    },
	
	    searchEngine: function(referrer) {
	        if (referrer.search('https?://(.*)google.([^/?]*)') === 0) {
	            return 'google';
	        } else if (referrer.search('https?://(.*)bing.com') === 0) {
	            return 'bing';
	        } else if (referrer.search('https?://(.*)yahoo.com') === 0) {
	            return 'yahoo';
	        } else if (referrer.search('https?://(.*)duckduckgo.com') === 0) {
	            return 'duckduckgo';
	        } else {
	            return null;
	        }
	    },
	
	    searchInfo: function(referrer) {
	        var search = _.info.searchEngine(referrer),
	            param = (search != 'yahoo') ? 'q' : 'p',
	            ret = {};
	
	        if (search !== null) {
	            ret['$search_engine'] = search;
	
	            var keyword = _.getQueryParam(referrer, param);
	            if (keyword.length) {
	                ret['mp_keyword'] = keyword;
	            }
	        }
	
	        return ret;
	    },
	
	    /**
	     * This function detects which browser is running this script.
	     * The order of the checks are important since many user agents
	     * include key words used in later checks.
	     */
	    browser: function(user_agent, vendor, opera) {
	        vendor = vendor || ''; // vendor is undefined for at least IE9
	        if (opera || _.includes(user_agent, ' OPR/')) {
	            if (_.includes(user_agent, 'Mini')) {
	                return 'Opera Mini';
	            }
	            return 'Opera';
	        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) {
	            return 'BlackBerry';
	        } else if (_.includes(user_agent, 'IEMobile') || _.includes(user_agent, 'WPDesktop')) {
	            return 'Internet Explorer Mobile';
	        } else if (_.includes(user_agent, 'SamsungBrowser/')) {
	            // https://developer.samsung.com/internet/user-agent-string-format
	            return 'Samsung Internet';
	        } else if (_.includes(user_agent, 'Edge') || _.includes(user_agent, 'Edg/')) {
	            return 'Microsoft Edge';
	        } else if (_.includes(user_agent, 'FBIOS')) {
	            return 'Facebook Mobile';
	        } else if (_.includes(user_agent, 'Chrome')) {
	            return 'Chrome';
	        } else if (_.includes(user_agent, 'CriOS')) {
	            return 'Chrome iOS';
	        } else if (_.includes(user_agent, 'UCWEB') || _.includes(user_agent, 'UCBrowser')) {
	            return 'UC Browser';
	        } else if (_.includes(user_agent, 'FxiOS')) {
	            return 'Firefox iOS';
	        } else if (_.includes(vendor, 'Apple')) {
	            if (_.includes(user_agent, 'Mobile')) {
	                return 'Mobile Safari';
	            }
	            return 'Safari';
	        } else if (_.includes(user_agent, 'Android')) {
	            return 'Android Mobile';
	        } else if (_.includes(user_agent, 'Konqueror')) {
	            return 'Konqueror';
	        } else if (_.includes(user_agent, 'Firefox')) {
	            return 'Firefox';
	        } else if (_.includes(user_agent, 'MSIE') || _.includes(user_agent, 'Trident/')) {
	            return 'Internet Explorer';
	        } else if (_.includes(user_agent, 'Gecko')) {
	            return 'Mozilla';
	        } else {
	            return '';
	        }
	    },
	
	    /**
	     * This function detects which browser version is running this script,
	     * parsing major and minor version (e.g., 42.1). User agent strings from:
	     * http://www.useragentstring.com/pages/useragentstring.php
	     */
	    browserVersion: function(userAgent, vendor, opera) {
	        var browser = _.info.browser(userAgent, vendor, opera);
	        var versionRegexs = {
	            'Internet Explorer Mobile': /rv:(\d+(\.\d+)?)/,
	            'Microsoft Edge': /Edge?\/(\d+(\.\d+)?)/,
	            'Chrome': /Chrome\/(\d+(\.\d+)?)/,
	            'Chrome iOS': /CriOS\/(\d+(\.\d+)?)/,
	            'UC Browser' : /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
	            'Safari': /Version\/(\d+(\.\d+)?)/,
	            'Mobile Safari': /Version\/(\d+(\.\d+)?)/,
	            'Opera': /(Opera|OPR)\/(\d+(\.\d+)?)/,
	            'Firefox': /Firefox\/(\d+(\.\d+)?)/,
	            'Firefox iOS': /FxiOS\/(\d+(\.\d+)?)/,
	            'Konqueror': /Konqueror:(\d+(\.\d+)?)/,
	            'BlackBerry': /BlackBerry (\d+(\.\d+)?)/,
	            'Android Mobile': /android\s(\d+(\.\d+)?)/,
	            'Samsung Internet': /SamsungBrowser\/(\d+(\.\d+)?)/,
	            'Internet Explorer': /(rv:|MSIE )(\d+(\.\d+)?)/,
	            'Mozilla': /rv:(\d+(\.\d+)?)/
	        };
	        var regex = versionRegexs[browser];
	        if (regex === undefined) {
	            return null;
	        }
	        var matches = userAgent.match(regex);
	        if (!matches) {
	            return null;
	        }
	        return parseFloat(matches[matches.length - 2]);
	    },
	
	    os: function() {
	        var a = userAgent;
	        if (/Windows/i.test(a)) {
	            if (/Phone/.test(a) || /WPDesktop/.test(a)) {
	                return 'Windows Phone';
	            }
	            return 'Windows';
	        } else if (/(iPhone|iPad|iPod)/.test(a)) {
	            return 'iOS';
	        } else if (/Android/.test(a)) {
	            return 'Android';
	        } else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) {
	            return 'BlackBerry';
	        } else if (/Mac/i.test(a)) {
	            return 'Mac OS X';
	        } else if (/Linux/.test(a)) {
	            return 'Linux';
	        } else if (/CrOS/.test(a)) {
	            return 'Chrome OS';
	        } else {
	            return '';
	        }
	    },
	
	    device: function(user_agent) {
	        if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) {
	            return 'Windows Phone';
	        } else if (/iPad/.test(user_agent)) {
	            return 'iPad';
	        } else if (/iPod/.test(user_agent)) {
	            return 'iPod Touch';
	        } else if (/iPhone/.test(user_agent)) {
	            return 'iPhone';
	        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) {
	            return 'BlackBerry';
	        } else if (/Android/.test(user_agent)) {
	            return 'Android';
	        } else {
	            return '';
	        }
	    },
	
	    referringDomain: function(referrer) {
	        var split = referrer.split('/');
	        if (split.length >= 3) {
	            return split[2];
	        }
	        return '';
	    },
	
	    properties: function() {
	        return _.extend(_.strip_empty_properties({
	            '$os': _.info.os(),
	            '$browser': _.info.browser(userAgent, navigator$1.vendor, windowOpera),
	            '$referrer': document$1.referrer,
	            '$referring_domain': _.info.referringDomain(document$1.referrer),
	            '$device': _.info.device(userAgent)
	        }), {
	            '$current_url': window$1.location.href,
	            '$browser_version': _.info.browserVersion(userAgent, navigator$1.vendor, windowOpera),
	            '$screen_height': screen.height,
	            '$screen_width': screen.width,
	            'mp_lib': 'web',
	            '$lib_version': Config.LIB_VERSION,
	            '$insert_id': cheap_guid(),
	            'time': _.timestamp() / 1000 // epoch time in seconds
	        });
	    },
	
	    people_properties: function() {
	        return _.extend(_.strip_empty_properties({
	            '$os': _.info.os(),
	            '$browser': _.info.browser(userAgent, navigator$1.vendor, windowOpera)
	        }), {
	            '$browser_version': _.info.browserVersion(userAgent, navigator$1.vendor, windowOpera)
	        });
	    },
	
	    pageviewInfo: function(page) {
	        return _.strip_empty_properties({
	            'mp_page': page,
	            'mp_referrer': document$1.referrer,
	            'mp_browser': _.info.browser(userAgent, navigator$1.vendor, windowOpera),
	            'mp_platform': _.info.os()
	        });
	    }
	};
	
	var cheap_guid = function(maxlen) {
	    var guid = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
	    return maxlen ? guid.substring(0, maxlen) : guid;
	};
	
	/**
	 * Check deterministically whether to include or exclude from a feature rollout/test based on the
	 * given string and the desired percentage to include.
	 * @param {String} str - string to run the check against (for instance a project's token)
	 * @param {String} feature - name of feature (for inclusion in hash, to ensure different results
	 * for different features)
	 * @param {Number} percent_allowed - percentage chance that a given string will be included
	 * @returns {Boolean} whether the given string should be included
	 */
	var determine_eligibility = _.safewrap(function(str, feature, percent_allowed) {
	    str = str + feature;
	
	    // Bernstein's hash: http://www.cse.yorku.ca/~oz/hash.html#djb2
	    var hash = 5381;
	    for (var i = 0; i < str.length; i++) {
	        hash = ((hash << 5) + hash) + str.charCodeAt(i);
	        hash = hash & hash;
	    }
	    var dart = (hash >>> 0) % 100;
	    return dart < percent_allowed;
	});
	
	// naive way to extract domain name (example.com) from full hostname (my.sub.example.com)
	var SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;
	// this next one attempts to account for some ccSLDs, e.g. extracting oxford.ac.uk from www.oxford.ac.uk
	var DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
	/**
	 * Attempts to extract main domain name from full hostname, using a few blunt heuristics. For
	 * common TLDs like .com/.org that always have a simple SLD.TLD structure (example.com), we
	 * simply extract the last two .-separated parts of the hostname (SIMPLE_DOMAIN_MATCH_REGEX).
	 * For others, we attempt to account for short ccSLD+TLD combos (.ac.uk) with the legacy
	 * DOMAIN_MATCH_REGEX (kept to maintain backwards compatibility with existing Mixpanel
	 * integrations). The only _reliable_ way to extract domain from hostname is with an up-to-date
	 * list like at https://publicsuffix.org/ so for cases that this helper fails at, the SDK
	 * offers the 'cookie_domain' config option to set it explicitly.
	 * @example
	 * extract_domain('my.sub.example.com')
	 * // 'example.com'
	 */
	var extract_domain = function(hostname) {
	    var domain_regex = DOMAIN_MATCH_REGEX;
	    var parts = hostname.split('.');
	    var tld = parts[parts.length - 1];
	    if (tld.length > 4 || tld === 'com' || tld === 'org') {
	        domain_regex = SIMPLE_DOMAIN_MATCH_REGEX;
	    }
	    var matches = hostname.match(domain_regex);
	    return matches ? matches[0] : '';
	};
	
	var JSONStringify = null;
	var JSONParse = null;
	if (typeof JSON !== 'undefined') {
	    JSONStringify = JSON.stringify;
	    JSONParse = JSON.parse;
	}
	JSONStringify = JSONStringify || _.JSONEncode;
	JSONParse = JSONParse || _.JSONDecode;
	
	// EXPORTS (for closure compiler)
	_['toArray']                = _.toArray;
	_['isObject']               = _.isObject;
	_['JSONEncode']             = _.JSONEncode;
	_['JSONDecode']             = _.JSONDecode;
	_['isBlockedUA']            = _.isBlockedUA;
	_['isEmptyObject']          = _.isEmptyObject;
	_['info']                   = _.info;
	_['info']['device']         = _.info.device;
	_['info']['browser']        = _.info.browser;
	_['info']['browserVersion'] = _.info.browserVersion;
	_['info']['properties']     = _.info.properties;
	
	/**
	 * DomTracker Object
	 * @constructor
	 */
	var DomTracker = function() {};
	
	
	// interface
	DomTracker.prototype.create_properties = function() {};
	DomTracker.prototype.event_handler = function() {};
	DomTracker.prototype.after_track_handler = function() {};
	
	DomTracker.prototype.init = function(mixpanel_instance) {
	    this.mp = mixpanel_instance;
	    return this;
	};
	
	/**
	 * @param {Object|string} query
	 * @param {string} event_name
	 * @param {Object=} properties
	 * @param {function=} user_callback
	 */
	DomTracker.prototype.track = function(query, event_name, properties, user_callback) {
	    var that = this;
	    var elements = _.dom_query(query);
	
	    if (elements.length === 0) {
	        console.error('The DOM query (' + query + ') returned 0 elements');
	        return;
	    }
	
	    _.each(elements, function(element) {
	        _.register_event(element, this.override_event, function(e) {
	            var options = {};
	            var props = that.create_properties(properties, this);
	            var timeout = that.mp.get_config('track_links_timeout');
	
	            that.event_handler(e, this, options);
	
	            // in case the mixpanel servers don't get back to us in time
	            window.setTimeout(that.track_callback(user_callback, props, options, true), timeout);
	
	            // fire the tracking event
	            that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
	        });
	    }, this);
	
	    return true;
	};
	
	/**
	 * @param {function} user_callback
	 * @param {Object} props
	 * @param {boolean=} timeout_occured
	 */
	DomTracker.prototype.track_callback = function(user_callback, props, options, timeout_occured) {
	    timeout_occured = timeout_occured || false;
	    var that = this;
	
	    return function() {
	        // options is referenced from both callbacks, so we can have
	        // a 'lock' of sorts to ensure only one fires
	        if (options.callback_fired) { return; }
	        options.callback_fired = true;
	
	        if (user_callback && user_callback(timeout_occured, props) === false) {
	            // user can prevent the default functionality by
	            // returning false from their callback
	            return;
	        }
	
	        that.after_track_handler(props, options, timeout_occured);
	    };
	};
	
	DomTracker.prototype.create_properties = function(properties, element) {
	    var props;
	
	    if (typeof(properties) === 'function') {
	        props = properties(element);
	    } else {
	        props = _.extend({}, properties);
	    }
	
	    return props;
	};
	
	/**
	 * LinkTracker Object
	 * @constructor
	 * @extends DomTracker
	 */
	var LinkTracker = function() {
	    this.override_event = 'click';
	};
	_.inherit(LinkTracker, DomTracker);
	
	LinkTracker.prototype.create_properties = function(properties, element) {
	    var props = LinkTracker.superclass.create_properties.apply(this, arguments);
	
	    if (element.href) { props['url'] = element.href; }
	
	    return props;
	};
	
	LinkTracker.prototype.event_handler = function(evt, element, options) {
	    options.new_tab = (
	        evt.which === 2 ||
	        evt.metaKey ||
	        evt.ctrlKey ||
	        element.target === '_blank'
	    );
	    options.href = element.href;
	
	    if (!options.new_tab) {
	        evt.preventDefault();
	    }
	};
	
	LinkTracker.prototype.after_track_handler = function(props, options) {
	    if (options.new_tab) { return; }
	
	    setTimeout(function() {
	        window.location = options.href;
	    }, 0);
	};
	
	/**
	 * FormTracker Object
	 * @constructor
	 * @extends DomTracker
	 */
	var FormTracker = function() {
	    this.override_event = 'submit';
	};
	_.inherit(FormTracker, DomTracker);
	
	FormTracker.prototype.event_handler = function(evt, element, options) {
	    options.element = element;
	    evt.preventDefault();
	};
	
	FormTracker.prototype.after_track_handler = function(props, options) {
	    setTimeout(function() {
	        options.element.submit();
	    }, 0);
	};
	
	// eslint-disable-line camelcase
	
	var logger$2 = console_with_prefix('lock');
	
	/**
	 * SharedLock: a mutex built on HTML5 localStorage, to ensure that only one browser
	 * window/tab at a time will be able to access shared resources.
	 *
	 * Based on the Alur and Taubenfeld fast lock
	 * (http://www.cs.rochester.edu/research/synchronization/pseudocode/fastlock.html)
	 * with an added timeout to ensure there will be eventual progress in the event
	 * that a window is closed in the middle of the callback.
	 *
	 * Implementation based on the original version by David Wolever (https://github.com/wolever)
	 * at https://gist.github.com/wolever/5fd7573d1ef6166e8f8c4af286a69432.
	 *
	 * @example
	 * const myLock = new SharedLock('some-key');
	 * myLock.withLock(function() {
	 *   console.log('I hold the mutex!');
	 * });
	 *
	 * @constructor
	 */
	var SharedLock = function(key, options) {
	    options = options || {};
	
	    this.storageKey = key;
	    this.storage = options.storage || window.localStorage;
	    this.pollIntervalMS = options.pollIntervalMS || 100;
	    this.timeoutMS = options.timeoutMS || 2000;
	};
	
	// pass in a specific pid to test contention scenarios; otherwise
	// it is chosen randomly for each acquisition attempt
	SharedLock.prototype.withLock = function(lockedCB, errorCB, pid) {
	    if (!pid && typeof errorCB !== 'function') {
	        pid = errorCB;
	        errorCB = null;
	    }
	
	    var i = pid || (new Date().getTime() + '|' + Math.random());
	    var startTime = new Date().getTime();
	
	    var key = this.storageKey;
	    var pollIntervalMS = this.pollIntervalMS;
	    var timeoutMS = this.timeoutMS;
	    var storage = this.storage;
	
	    var keyX = key + ':X';
	    var keyY = key + ':Y';
	    var keyZ = key + ':Z';
	
	    var reportError = function(err) {
	        errorCB && errorCB(err);
	    };
	
	    var delay = function(cb) {
	        if (new Date().getTime() - startTime > timeoutMS) {
	            logger$2.error('Timeout waiting for mutex on ' + key + '; clearing lock. [' + i + ']');
	            storage.removeItem(keyZ);
	            storage.removeItem(keyY);
	            loop();
	            return;
	        }
	        setTimeout(function() {
	            try {
	                cb();
	            } catch(err) {
	                reportError(err);
	            }
	        }, pollIntervalMS * (Math.random() + 0.1));
	    };
	
	    var waitFor = function(predicate, cb) {
	        if (predicate()) {
	            cb();
	        } else {
	            delay(function() {
	                waitFor(predicate, cb);
	            });
	        }
	    };
	
	    var getSetY = function() {
	        var valY = storage.getItem(keyY);
	        if (valY && valY !== i) { // if Y == i then this process already has the lock (useful for test cases)
	            return false;
	        } else {
	            storage.setItem(keyY, i);
	            if (storage.getItem(keyY) === i) {
	                return true;
	            } else {
	                if (!localStorageSupported(storage, true)) {
	                    throw new Error('localStorage support dropped while acquiring lock');
	                }
	                return false;
	            }
	        }
	    };
	
	    var loop = function() {
	        storage.setItem(keyX, i);
	
	        waitFor(getSetY, function() {
	            if (storage.getItem(keyX) === i) {
	                criticalSection();
	                return;
	            }
	
	            delay(function() {
	                if (storage.getItem(keyY) !== i) {
	                    loop();
	                    return;
	                }
	                waitFor(function() {
	                    return !storage.getItem(keyZ);
	                }, criticalSection);
	            });
	        });
	    };
	
	    var criticalSection = function() {
	        storage.setItem(keyZ, '1');
	        try {
	            lockedCB();
	        } finally {
	            storage.removeItem(keyZ);
	            if (storage.getItem(keyY) === i) {
	                storage.removeItem(keyY);
	            }
	            if (storage.getItem(keyX) === i) {
	                storage.removeItem(keyX);
	            }
	        }
	    };
	
	    try {
	        if (localStorageSupported(storage, true)) {
	            loop();
	        } else {
	            throw new Error('localStorage support check failed');
	        }
	    } catch(err) {
	        reportError(err);
	    }
	};
	
	// eslint-disable-line camelcase
	
	var logger$1 = console_with_prefix('batch');
	
	/**
	 * RequestQueue: queue for batching API requests with localStorage backup for retries.
	 * Maintains an in-memory queue which represents the source of truth for the current
	 * page, but also writes all items out to a copy in the browser's localStorage, which
	 * can be read on subsequent pageloads and retried. For batchability, all the request
	 * items in the queue should be of the same type (events, people updates, group updates)
	 * so they can be sent in a single request to the same API endpoint.
	 *
	 * LocalStorage keying and locking: In order for reloads and subsequent pageloads of
	 * the same site to access the same persisted data, they must share the same localStorage
	 * key (for instance based on project token and queue type). Therefore access to the
	 * localStorage entry is guarded by an asynchronous mutex (SharedLock) to prevent
	 * simultaneously open windows/tabs from overwriting each other's data (which would lead
	 * to data loss in some situations).
	 * @constructor
	 */
	var RequestQueue = function(storageKey, options) {
	    options = options || {};
	    this.storageKey = storageKey;
	    this.storage = options.storage || window.localStorage;
	    this.lock = new SharedLock(storageKey, {storage: this.storage});
	
	    this.pid = options.pid || null; // pass pid to test out storage lock contention scenarios
	
	    this.memQueue = [];
	};
	
	/**
	 * Add one item to queues (memory and localStorage). The queued entry includes
	 * the given item along with an auto-generated ID and a "flush-after" timestamp.
	 * It is expected that the item will be sent over the network and dequeued
	 * before the flush-after time; if this doesn't happen it is considered orphaned
	 * (e.g., the original tab where it was enqueued got closed before it could be
	 * sent) and the item can be sent by any tab that finds it in localStorage.
	 *
	 * The final callback param is called with a param indicating success or
	 * failure of the enqueue operation; it is asynchronous because the localStorage
	 * lock is asynchronous.
	 */
	RequestQueue.prototype.enqueue = function(item, flushInterval, cb) {
	    var queueEntry = {
	        'id': cheap_guid(),
	        'flushAfter': new Date().getTime() + flushInterval * 2,
	        'payload': item
	    };
	
	    this.lock.withLock(_.bind(function lockAcquired() {
	        var succeeded;
	        try {
	            var storedQueue = this.readFromStorage();
	            storedQueue.push(queueEntry);
	            succeeded = this.saveToStorage(storedQueue);
	            if (succeeded) {
	                // only add to in-memory queue when storage succeeds
	                this.memQueue.push(queueEntry);
	            }
	        } catch(err) {
	            logger$1.error('Error enqueueing item', item);
	            succeeded = false;
	        }
	        if (cb) {
	            cb(succeeded);
	        }
	    }, this), function lockFailure(err) {
	        logger$1.error('Error acquiring storage lock', err);
	        if (cb) {
	            cb(false);
	        }
	    }, this.pid);
	};
	
	/**
	 * Read out the given number of queue entries. If this.memQueue
	 * has fewer than batchSize items, then look for "orphaned" items
	 * in the persisted queue (items where the 'flushAfter' time has
	 * already passed).
	 */
	RequestQueue.prototype.fillBatch = function(batchSize) {
	    var batch = this.memQueue.slice(0, batchSize);
	    if (batch.length < batchSize) {
	        // don't need lock just to read events; localStorage is thread-safe
	        // and the worst that could happen is a duplicate send of some
	        // orphaned events, which will be deduplicated on the server side
	        var storedQueue = this.readFromStorage();
	        if (storedQueue.length) {
	            // item IDs already in batch; don't duplicate out of storage
	            var idsInBatch = {}; // poor man's Set
	            _.each(batch, function(item) { idsInBatch[item['id']] = true; });
	
	            for (var i = 0; i < storedQueue.length; i++) {
	                var item = storedQueue[i];
	                if (new Date().getTime() > item['flushAfter'] && !idsInBatch[item['id']]) {
	                    item.orphaned = true;
	                    batch.push(item);
	                    if (batch.length >= batchSize) {
	                        break;
	                    }
	                }
	            }
	        }
	    }
	    return batch;
	};
	
	/**
	 * Remove items with matching 'id' from array (immutably)
	 * also remove any item without a valid id (e.g., malformed
	 * storage entries).
	 */
	var filterOutIDsAndInvalid = function(items, idSet) {
	    var filteredItems = [];
	    _.each(items, function(item) {
	        if (item['id'] && !idSet[item['id']]) {
	            filteredItems.push(item);
	        }
	    });
	    return filteredItems;
	};
	
	/**
	 * Remove items with matching IDs from both in-memory queue
	 * and persisted queue
	 */
	RequestQueue.prototype.removeItemsByID = function(ids, cb) {
	    var idSet = {}; // poor man's Set
	    _.each(ids, function(id) { idSet[id] = true; });
	
	    this.memQueue = filterOutIDsAndInvalid(this.memQueue, idSet);
	    this.lock.withLock(_.bind(function lockAcquired() {
	        var succeeded;
	        try {
	            var storedQueue = this.readFromStorage();
	            storedQueue = filterOutIDsAndInvalid(storedQueue, idSet);
	            succeeded = this.saveToStorage(storedQueue);
	        } catch(err) {
	            logger$1.error('Error removing items', ids);
	            succeeded = false;
	        }
	        if (cb) {
	            cb(succeeded);
	        }
	    }, this), function lockFailure(err) {
	        logger$1.error('Error acquiring storage lock', err);
	        if (cb) {
	            cb(false);
	        }
	    }, this.pid);
	};
	
	// internal helper for RequestQueue.updatePayloads
	var updatePayloads = function(existingItems, itemsToUpdate) {
	    var newItems = [];
	    _.each(existingItems, function(item) {
	        var id = item['id'];
	        if (id in itemsToUpdate) {
	            var newPayload = itemsToUpdate[id];
	            if (newPayload !== null) {
	                item['payload'] = newPayload;
	                newItems.push(item);
	            }
	        } else {
	            // no update
	            newItems.push(item);
	        }
	    });
	    return newItems;
	};
	
	/**
	 * Update payloads of given items in both in-memory queue and
	 * persisted queue. Items set to null are removed from queues.
	 */
	RequestQueue.prototype.updatePayloads = function(itemsToUpdate, cb) {
	    this.memQueue = updatePayloads(this.memQueue, itemsToUpdate);
	    this.lock.withLock(_.bind(function lockAcquired() {
	        var succeeded;
	        try {
	            var storedQueue = this.readFromStorage();
	            storedQueue = updatePayloads(storedQueue, itemsToUpdate);
	            succeeded = this.saveToStorage(storedQueue);
	        } catch(err) {
	            logger$1.error('Error updating items', itemsToUpdate);
	            succeeded = false;
	        }
	        if (cb) {
	            cb(succeeded);
	        }
	    }, this), function lockFailure(err) {
	        logger$1.error('Error acquiring storage lock', err);
	        if (cb) {
	            cb(false);
	        }
	    }, this.pid);
	};
	
	/**
	 * Read and parse items array from localStorage entry, handling
	 * malformed/missing data if necessary.
	 */
	RequestQueue.prototype.readFromStorage = function() {
	    var storageEntry;
	    try {
	        storageEntry = this.storage.getItem(this.storageKey);
	        if (storageEntry) {
	            storageEntry = JSONParse(storageEntry);
	            if (!_.isArray(storageEntry)) {
	                logger$1.error('Invalid storage entry:', storageEntry);
	                storageEntry = null;
	            }
	        }
	    } catch (err) {
	        logger$1.error('Error retrieving queue', err);
	        storageEntry = null;
	    }
	    return storageEntry || [];
	};
	
	/**
	 * Serialize the given items array to localStorage.
	 */
	RequestQueue.prototype.saveToStorage = function(queue) {
	    try {
	        this.storage.setItem(this.storageKey, JSONStringify(queue));
	        return true;
	    } catch (err) {
	        logger$1.error('Error saving queue', err);
	        return false;
	    }
	};
	
	/**
	 * Clear out queues (memory and localStorage).
	 */
	RequestQueue.prototype.clear = function() {
	    this.memQueue = [];
	    this.storage.removeItem(this.storageKey);
	};
	
	// eslint-disable-line camelcase
	
	// maximum interval between request retries after exponential backoff
	var MAX_RETRY_INTERVAL_MS = 10 * 60 * 1000; // 10 minutes
	
	var logger = console_with_prefix('batch');
	
	/**
	 * RequestBatcher: manages the queueing, flushing, retry etc of requests of one
	 * type (events, people, groups).
	 * Uses RequestQueue to manage the backing store.
	 * @constructor
	 */
	var RequestBatcher = function(storageKey, options) {
	    this.queue = new RequestQueue(storageKey, {storage: options.storage});
	
	    this.libConfig = options.libConfig;
	    this.sendRequest = options.sendRequestFunc;
	    this.beforeSendHook = options.beforeSendHook;
	
	    // seed variable batch size + flush interval with configured values
	    this.batchSize = this.libConfig['batch_size'];
	    this.flushInterval = this.libConfig['batch_flush_interval_ms'];
	
	    this.stopped = !this.libConfig['batch_autostart'];
	};
	
	/**
	 * Add one item to queue.
	 */
	RequestBatcher.prototype.enqueue = function(item, cb) {
	    this.queue.enqueue(item, this.flushInterval, cb);
	};
	
	/**
	 * Start flushing batches at the configured time interval. Must call
	 * this method upon SDK init in order to send anything over the network.
	 */
	RequestBatcher.prototype.start = function() {
	    this.stopped = false;
	    this.flush();
	};
	
	/**
	 * Stop flushing batches. Can be restarted by calling start().
	 */
	RequestBatcher.prototype.stop = function() {
	    this.stopped = true;
	    if (this.timeoutID) {
	        clearTimeout(this.timeoutID);
	        this.timeoutID = null;
	    }
	};
	
	/**
	 * Clear out queue.
	 */
	RequestBatcher.prototype.clear = function() {
	    this.queue.clear();
	};
	
	/**
	 * Restore batch size configuration to whatever is set in the main SDK.
	 */
	RequestBatcher.prototype.resetBatchSize = function() {
	    this.batchSize = this.libConfig['batch_size'];
	};
	
	/**
	 * Restore flush interval time configuration to whatever is set in the main SDK.
	 */
	RequestBatcher.prototype.resetFlush = function() {
	    this.scheduleFlush(this.libConfig['batch_flush_interval_ms']);
	};
	
	/**
	 * Schedule the next flush in the given number of milliseconds.
	 */
	RequestBatcher.prototype.scheduleFlush = function(flushMS) {
	    this.flushInterval = flushMS;
	    if (!this.stopped) { // don't schedule anymore if batching has been stopped
	        this.timeoutID = setTimeout(_.bind(this.flush, this), this.flushInterval);
	    }
	};
	
	/**
	 * Flush one batch to network. Depending on success/failure modes, it will either
	 * remove the batch from the queue or leave it in for retry, and schedule the next
	 * flush. In cases of most network or API failures, it will back off exponentially
	 * when retrying.
	 * @param {Object} [options]
	 * @param {boolean} [options.sendBeacon] - whether to send batch with
	 * navigator.sendBeacon (only useful for sending batches before page unloads, as
	 * sendBeacon offers no callbacks or status indications)
	 */
	RequestBatcher.prototype.flush = function(options) {
	    try {
	
	        if (this.requestInProgress) {
	            logger.log('Flush: Request already in progress');
	            return;
	        }
	
	        options = options || {};
	        var timeoutMS = this.libConfig['batch_request_timeout_ms'];
	        var startTime = new Date().getTime();
	        var currentBatchSize = this.batchSize;
	        var batch = this.queue.fillBatch(currentBatchSize);
	        var dataForRequest = [];
	        var transformedItems = {};
	        _.each(batch, function(item) {
	            var payload = item['payload'];
	            if (this.beforeSendHook && !item.orphaned) {
	                payload = this.beforeSendHook(payload);
	            }
	            if (payload) {
	                dataForRequest.push(payload);
	            }
	            transformedItems[item['id']] = payload;
	        }, this);
	        if (dataForRequest.length < 1) {
	            this.resetFlush();
	            return; // nothing to do
	        }
	
	        this.requestInProgress = true;
	
	        var batchSendCallback = _.bind(function(res) {
	            this.requestInProgress = false;
	
	            try {
	
	                // handle API response in a try-catch to make sure we can reset the
	                // flush operation if something goes wrong
	
	                var removeItemsFromQueue = false;
	                if (options.unloading) {
	                    // update persisted data to include hook transformations
	                    this.queue.updatePayloads(transformedItems);
	                } else if (
	                    _.isObject(res) &&
	                    res.error === 'timeout' &&
	                    new Date().getTime() - startTime >= timeoutMS
	                ) {
	                    logger.error('Network timeout; retrying');
	                    this.flush();
	                } else if (
	                    _.isObject(res) &&
	                    res.xhr_req &&
	                    (res.xhr_req['status'] >= 500 || res.xhr_req['status'] <= 0)
	                ) {
	                    // network or API error, retry
	                    var retryMS = this.flushInterval * 2;
	                    var headers = res.xhr_req['responseHeaders'];
	                    if (headers) {
	                        var retryAfter = headers['Retry-After'];
	                        if (retryAfter) {
	                            retryMS = (parseInt(retryAfter, 10) * 1000) || retryMS;
	                        }
	                    }
	                    retryMS = Math.min(MAX_RETRY_INTERVAL_MS, retryMS);
	                    logger.error('Error; retry in ' + retryMS + ' ms');
	                    this.scheduleFlush(retryMS);
	                } else if (_.isObject(res) && res.xhr_req && res.xhr_req['status'] === 413) {
	                    // 413 Payload Too Large
	                    if (batch.length > 1) {
	                        var halvedBatchSize = Math.max(1, Math.floor(currentBatchSize / 2));
	                        this.batchSize = Math.min(this.batchSize, halvedBatchSize, batch.length - 1);
	                        logger.error('413 response; reducing batch size to ' + this.batchSize);
	                        this.resetFlush();
	                    } else {
	                        logger.error('Single-event request too large; dropping', batch);
	                        this.resetBatchSize();
	                        removeItemsFromQueue = true;
	                    }
	                } else {
	                    // successful network request+response; remove each item in batch from queue
	                    // (even if it was e.g. a 400, in which case retrying won't help)
	                    removeItemsFromQueue = true;
	                }
	
	                if (removeItemsFromQueue) {
	                    this.queue.removeItemsByID(
	                        _.map(batch, function(item) { return item['id']; }),
	                        _.bind(this.flush, this) // handle next batch if the queue isn't empty
	                    );
	                }
	
	            } catch(err) {
	                logger.error('Error handling API response', err);
	                this.resetFlush();
	            }
	        }, this);
	        var requestOptions = {
	            method: 'POST',
	            verbose: true,
	            ignore_json_errors: true, // eslint-disable-line camelcase
	            timeout_ms: timeoutMS // eslint-disable-line camelcase
	        };
	        if (options.unloading) {
	            requestOptions.transport = 'sendBeacon';
	        }
	        logger.log('MIXPANEL REQUEST:', dataForRequest);
	        this.sendRequest(dataForRequest, requestOptions, batchSendCallback);
	
	    } catch(err) {
	        logger.error('Error flushing request queue', err);
	        this.resetFlush();
	    }
	};
	
	/**
	 * A function used to track a Mixpanel event (e.g. MixpanelLib.track)
	 * @callback trackFunction
	 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
	 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
	 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
	 */
	
	/** Public **/
	
	var GDPR_DEFAULT_PERSISTENCE_PREFIX = '__mp_opt_in_out_';
	
	/**
	 * Opt the user in to data tracking and cookies/localstorage for the given token
	 * @param {string} token - Mixpanel project tracking token
	 * @param {Object} [options]
	 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
	 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
	 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
	 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
	 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
	 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
	 * @param {string} [options.cookieDomain] - custom cookie domain
	 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
	 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
	 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
	 */
	function optIn(token, options) {
	    _optInOut(true, token, options);
	}
	
	/**
	 * Opt the user out of data tracking and cookies/localstorage for the given token
	 * @param {string} token - Mixpanel project tracking token
	 * @param {Object} [options]
	 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
	 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
	 * @param {Number} [options.cookieExpiration] - number of days until the opt-out cookie expires
	 * @param {string} [options.cookieDomain] - custom cookie domain
	 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
	 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-out cookie is set as cross-subdomain or not
	 * @param {boolean} [options.secureCookie] - whether the opt-out cookie is set as secure or not
	 */
	function optOut(token, options) {
	    _optInOut(false, token, options);
	}
	
	/**
	 * Check whether the user has opted in to data tracking and cookies/localstorage for the given token
	 * @param {string} token - Mixpanel project tracking token
	 * @param {Object} [options]
	 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
	 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
	 * @returns {boolean} whether the user has opted in to the given opt type
	 */
	function hasOptedIn(token, options) {
	    return _getStorageValue(token, options) === '1';
	}
	
	/**
	 * Check whether the user has opted out of data tracking and cookies/localstorage for the given token
	 * @param {string} token - Mixpanel project tracking token
	 * @param {Object} [options]
	 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
	 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
	 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
	 * @returns {boolean} whether the user has opted out of the given opt type
	 */
	function hasOptedOut(token, options) {
	    if (_hasDoNotTrackFlagOn(options)) {
	        console.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"');
	        return true;
	    }
	    var optedOut = _getStorageValue(token, options) === '0';
	    if (optedOut) {
	        console.warn('You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data.');
	    }
	    return optedOut;
	}
	
	/**
	 * Wrap a MixpanelLib method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
	 * If the user has opted out, return early instead of executing the method.
	 * If a callback argument was provided, execute it passing the 0 error code.
	 * @param {function} method - wrapped method to be executed if the user has not opted out
	 * @returns {*} the result of executing method OR undefined if the user has opted out
	 */
	function addOptOutCheckMixpanelLib(method) {
	    return _addOptOutCheck(method, function(name) {
	        return this.get_config(name);
	    });
	}
	
	/**
	 * Wrap a MixpanelPeople method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
	 * If the user has opted out, return early instead of executing the method.
	 * If a callback argument was provided, execute it passing the 0 error code.
	 * @param {function} method - wrapped method to be executed if the user has not opted out
	 * @returns {*} the result of executing method OR undefined if the user has opted out
	 */
	function addOptOutCheckMixpanelPeople(method) {
	    return _addOptOutCheck(method, function(name) {
	        return this._get_config(name);
	    });
	}
	
	/**
	 * Wrap a MixpanelGroup method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
	 * If the user has opted out, return early instead of executing the method.
	 * If a callback argument was provided, execute it passing the 0 error code.
	 * @param {function} method - wrapped method to be executed if the user has not opted out
	 * @returns {*} the result of executing method OR undefined if the user has opted out
	 */
	function addOptOutCheckMixpanelGroup(method) {
	    return _addOptOutCheck(method, function(name) {
	        return this._get_config(name);
	    });
	}
	
	/**
	 * Clear the user's opt in/out status of data tracking and cookies/localstorage for the given token
	 * @param {string} token - Mixpanel project tracking token
	 * @param {Object} [options]
	 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
	 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
	 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
	 * @param {string} [options.cookieDomain] - custom cookie domain
	 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
	 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
	 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
	 */
	function clearOptInOut(token, options) {
	    options = options || {};
	    _getStorage(options).remove(
	        _getStorageKey(token, options), !!options.crossSubdomainCookie, options.cookieDomain
	    );
	}
	
	/** Private **/
	
	/**
	 * Get storage util
	 * @param {Object} [options]
	 * @param {string} [options.persistenceType]
	 * @returns {object} either _.cookie or _.localstorage
	 */
	function _getStorage(options) {
	    options = options || {};
	    return options.persistenceType === 'localStorage' ? _.localStorage : _.cookie;
	}
	
	/**
	 * Get the name of the cookie that is used for the given opt type (tracking, cookie, etc.)
	 * @param {string} token - Mixpanel project tracking token
	 * @param {Object} [options]
	 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
	 * @returns {string} the name of the cookie for the given opt type
	 */
	function _getStorageKey(token, options) {
	    options = options || {};
	    return (options.persistencePrefix || GDPR_DEFAULT_PERSISTENCE_PREFIX) + token;
	}
	
	/**
	 * Get the value of the cookie that is used for the given opt type (tracking, cookie, etc.)
	 * @param {string} token - Mixpanel project tracking token
	 * @param {Object} [options]
	 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
	 * @returns {string} the value of the cookie for the given opt type
	 */
	function _getStorageValue(token, options) {
	    return _getStorage(options).get(_getStorageKey(token, options));
	}
	
	/**
	 * Check whether the user has set the DNT/doNotTrack setting to true in their browser
	 * @param {Object} [options]
	 * @param {string} [options.window] - alternate window object to check; used to force various DNT settings in browser tests
	 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
	 * @returns {boolean} whether the DNT setting is true
	 */
	function _hasDoNotTrackFlagOn(options) {
	    if (options && options.ignoreDnt) {
	        return false;
	    }
	    var win = (options && options.window) || window$1;
	    var nav = win['navigator'] || {};
	    var hasDntOn = false;
	
	    _.each([
	        nav['doNotTrack'], // standard
	        nav['msDoNotTrack'],
	        win['doNotTrack']
	    ], function(dntValue) {
	        if (_.includes([true, 1, '1', 'yes'], dntValue)) {
	            hasDntOn = true;
	        }
	    });
	
	    return hasDntOn;
	}
	
	/**
	 * Set cookie/localstorage for the user indicating that they are opted in or out for the given opt type
	 * @param {boolean} optValue - whether to opt the user in or out for the given opt type
	 * @param {string} token - Mixpanel project tracking token
	 * @param {Object} [options]
	 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
	 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
	 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
	 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
	 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
	 * @param {string} [options.cookieDomain] - custom cookie domain
	 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
	 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
	 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
	 */
	function _optInOut(optValue, token, options) {
	    if (!_.isString(token) || !token.length) {
	        console.error('gdpr.' + (optValue ? 'optIn' : 'optOut') + ' called with an invalid token');
	        return;
	    }
	
	    options = options || {};
	
	    _getStorage(options).set(
	        _getStorageKey(token, options),
	        optValue ? 1 : 0,
	        _.isNumber(options.cookieExpiration) ? options.cookieExpiration : null,
	        !!options.crossSubdomainCookie,
	        !!options.secureCookie,
	        !!options.crossSiteCookie,
	        options.cookieDomain
	    );
	
	    if (options.track && optValue) { // only track event if opting in (optValue=true)
	        options.track(options.trackEventName || '$opt_in', options.trackProperties, {
	            'send_immediately': true
	        });
	    }
	}
	
	/**
	 * Wrap a method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
	 * If the user has opted out, return early instead of executing the method.
	 * If a callback argument was provided, execute it passing the 0 error code.
	 * @param {function} method - wrapped method to be executed if the user has not opted out
	 * @param {function} getConfigValue - getter function for the Mixpanel API token and other options to be used with opt-out check
	 * @returns {*} the result of executing method OR undefined if the user has opted out
	 */
	function _addOptOutCheck(method, getConfigValue) {
	    return function() {
	        var optedOut = false;
	
	        try {
	            var token = getConfigValue.call(this, 'token');
	            var ignoreDnt = getConfigValue.call(this, 'ignore_dnt');
	            var persistenceType = getConfigValue.call(this, 'opt_out_tracking_persistence_type');
	            var persistencePrefix = getConfigValue.call(this, 'opt_out_tracking_cookie_prefix');
	            var win = getConfigValue.call(this, 'window'); // used to override window during browser tests
	
	            if (token) { // if there was an issue getting the token, continue method execution as normal
	                optedOut = hasOptedOut(token, {
	                    ignoreDnt: ignoreDnt,
	                    persistenceType: persistenceType,
	                    persistencePrefix: persistencePrefix,
	                    window: win
	                });
	            }
	        } catch(err) {
	            console.error('Unexpected error when checking tracking opt-out status: ' + err);
	        }
	
	        if (!optedOut) {
	            return method.apply(this, arguments);
	        }
	
	        var callback = arguments[arguments.length - 1];
	        if (typeof(callback) === 'function') {
	            callback(0);
	        }
	
	        return;
	    };
	}
	
	/** @const */ var SET_ACTION      = '$set';
	/** @const */ var SET_ONCE_ACTION = '$set_once';
	/** @const */ var UNSET_ACTION    = '$unset';
	/** @const */ var ADD_ACTION      = '$add';
	/** @const */ var APPEND_ACTION   = '$append';
	/** @const */ var UNION_ACTION    = '$union';
	/** @const */ var REMOVE_ACTION   = '$remove';
	/** @const */ var DELETE_ACTION   = '$delete';
	
	// Common internal methods for mixpanel.people and mixpanel.group APIs.
	// These methods shouldn't involve network I/O.
	var apiActions = {
	    set_action: function(prop, to) {
	        var data = {};
	        var $set = {};
	        if (_.isObject(prop)) {
	            _.each(prop, function(v, k) {
	                if (!this._is_reserved_property(k)) {
	                    $set[k] = v;
	                }
	            }, this);
	        } else {
	            $set[prop] = to;
	        }
	
	        data[SET_ACTION] = $set;
	        return data;
	    },
	
	    unset_action: function(prop) {
	        var data = {};
	        var $unset = [];
	        if (!_.isArray(prop)) {
	            prop = [prop];
	        }
	
	        _.each(prop, function(k) {
	            if (!this._is_reserved_property(k)) {
	                $unset.push(k);
	            }
	        }, this);
	
	        data[UNSET_ACTION] = $unset;
	        return data;
	    },
	
	    set_once_action: function(prop, to) {
	        var data = {};
	        var $set_once = {};
	        if (_.isObject(prop)) {
	            _.each(prop, function(v, k) {
	                if (!this._is_reserved_property(k)) {
	                    $set_once[k] = v;
	                }
	            }, this);
	        } else {
	            $set_once[prop] = to;
	        }
	        data[SET_ONCE_ACTION] = $set_once;
	        return data;
	    },
	
	    union_action: function(list_name, values) {
	        var data = {};
	        var $union = {};
	        if (_.isObject(list_name)) {
	            _.each(list_name, function(v, k) {
	                if (!this._is_reserved_property(k)) {
	                    $union[k] = _.isArray(v) ? v : [v];
	                }
	            }, this);
	        } else {
	            $union[list_name] = _.isArray(values) ? values : [values];
	        }
	        data[UNION_ACTION] = $union;
	        return data;
	    },
	
	    append_action: function(list_name, value) {
	        var data = {};
	        var $append = {};
	        if (_.isObject(list_name)) {
	            _.each(list_name, function(v, k) {
	                if (!this._is_reserved_property(k)) {
	                    $append[k] = v;
	                }
	            }, this);
	        } else {
	            $append[list_name] = value;
	        }
	        data[APPEND_ACTION] = $append;
	        return data;
	    },
	
	    remove_action: function(list_name, value) {
	        var data = {};
	        var $remove = {};
	        if (_.isObject(list_name)) {
	            _.each(list_name, function(v, k) {
	                if (!this._is_reserved_property(k)) {
	                    $remove[k] = v;
	                }
	            }, this);
	        } else {
	            $remove[list_name] = value;
	        }
	        data[REMOVE_ACTION] = $remove;
	        return data;
	    },
	
	    delete_action: function() {
	        var data = {};
	        data[DELETE_ACTION] = '';
	        return data;
	    }
	};
	
	/**
	 * Mixpanel Group Object
	 * @constructor
	 */
	var MixpanelGroup = function() {};
	
	_.extend(MixpanelGroup.prototype, apiActions);
	
	MixpanelGroup.prototype._init = function(mixpanel_instance, group_key, group_id) {
	    this._mixpanel = mixpanel_instance;
	    this._group_key = group_key;
	    this._group_id = group_id;
	};
	
	/**
	 * Set properties on a group.
	 *
	 * ### Usage:
	 *
	 *     mixpanel.get_group('company', 'mixpanel').set('Location', '405 Howard');
	 *
	 *     // or set multiple properties at once
	 *     mixpanel.get_group('company', 'mixpanel').set({
	 *          'Location': '405 Howard',
	 *          'Founded' : 2009,
	 *     });
	 *     // properties can be strings, integers, dates, or lists
	 *
	 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
	 * @param {*} [to] A value to set on the given property name
	 * @param {Function} [callback] If provided, the callback will be called after the tracking event
	 */
	MixpanelGroup.prototype.set = addOptOutCheckMixpanelGroup(function(prop, to, callback) {
	    var data = this.set_action(prop, to);
	    if (_.isObject(prop)) {
	        callback = to;
	    }
	    return this._send_request(data, callback);
	});
	
	/**
	 * Set properties on a group, only if they do not yet exist.
	 * This will not overwrite previous group property values, unlike
	 * group.set().
	 *
	 * ### Usage:
	 *
	 *     mixpanel.get_group('company', 'mixpanel').set_once('Location', '405 Howard');
	 *
	 *     // or set multiple properties at once
	 *     mixpanel.get_group('company', 'mixpanel').set_once({
	 *          'Location': '405 Howard',
	 *          'Founded' : 2009,
	 *     });
	 *     // properties can be strings, integers, lists or dates
	 *
	 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
	 * @param {*} [to] A value to set on the given property name
	 * @param {Function} [callback] If provided, the callback will be called after the tracking event
	 */
	MixpanelGroup.prototype.set_once = addOptOutCheckMixpanelGroup(function(prop, to, callback) {
	    var data = this.set_once_action(prop, to);
	    if (_.isObject(prop)) {
	        callback = to;
	    }
	    return this._send_request(data, callback);
	});
	
	/**
	 * Unset properties on a group permanently.
	 *
	 * ### Usage:
	 *
	 *     mixpanel.get_group('company', 'mixpanel').unset('Founded');
	 *
	 * @param {String} prop The name of the property.
	 * @param {Function} [callback] If provided, the callback will be called after the tracking event
	 */
	MixpanelGroup.prototype.unset = addOptOutCheckMixpanelGroup(function(prop, callback) {
	    var data = this.unset_action(prop);
	    return this._send_request(data, callback);
	});
	
	/**
	 * Merge a given list with a list-valued group property, excluding duplicate values.
	 *
	 * ### Usage:
	 *
	 *     // merge a value to a list, creating it if needed
	 *     mixpanel.get_group('company', 'mixpanel').union('Location', ['San Francisco', 'London']);
	 *
	 * @param {String} list_name Name of the property.
	 * @param {Array} values Values to merge with the given property
	 * @param {Function} [callback] If provided, the callback will be called after the tracking event
	 */
	MixpanelGroup.prototype.union = addOptOutCheckMixpanelGroup(function(list_name, values, callback) {
	    if (_.isObject(list_name)) {
	        callback = values;
	    }
	    var data = this.union_action(list_name, values);
	    return this._send_request(data, callback);
	});
	
	/**
	 * Permanently delete a group.
	 *
	 * ### Usage:
	 *     mixpanel.get_group('company', 'mixpanel').delete();
	 */
	MixpanelGroup.prototype['delete'] = addOptOutCheckMixpanelGroup(function(callback) {
	    var data = this.delete_action();
	    return this._send_request(data, callback);
	});
	
	/**
	 * Remove a property from a group. The value will be ignored if doesn't exist.
	 *
	 * ### Usage:
	 *
	 *     mixpanel.get_group('company', 'mixpanel').remove('Location', 'London');
	 *
	 * @param {String} list_name Name of the property.
	 * @param {Object} value Value to remove from the given group property
	 * @param {Function} [callback] If provided, the callback will be called after the tracking event
	 */
	MixpanelGroup.prototype.remove = addOptOutCheckMixpanelGroup(function(list_name, value, callback) {
	    var data = this.remove_action(list_name, value);
	    return this._send_request(data, callback);
	});
	
	MixpanelGroup.prototype._send_request = function(data, callback) {
	    data['$group_key'] = this._group_key;
	    data['$group_id'] = this._group_id;
	    data['$token'] = this._get_config('token');
	
	    var date_encoded_data = _.encodeDates(data);
	    return this._mixpanel._track_or_batch({
	        type: 'groups',
	        data: date_encoded_data,
	        endpoint: this._get_config('api_host') + '/groups/',
	        batcher: this._mixpanel.request_batchers.groups
	    }, callback);
	};
	
	MixpanelGroup.prototype._is_reserved_property = function(prop) {
	    return prop === '$group_key' || prop === '$group_id';
	};
	
	MixpanelGroup.prototype._get_config = function(conf) {
	    return this._mixpanel.get_config(conf);
	};
	
	MixpanelGroup.prototype.toString = function() {
	    return this._mixpanel.toString() + '.group.' + this._group_key + '.' + this._group_id;
	};
	
	// MixpanelGroup Exports
	MixpanelGroup.prototype['remove']   = MixpanelGroup.prototype.remove;
	MixpanelGroup.prototype['set']      = MixpanelGroup.prototype.set;
	MixpanelGroup.prototype['set_once'] = MixpanelGroup.prototype.set_once;
	MixpanelGroup.prototype['union']    = MixpanelGroup.prototype.union;
	MixpanelGroup.prototype['unset']    = MixpanelGroup.prototype.unset;
	MixpanelGroup.prototype['toString'] = MixpanelGroup.prototype.toString;
	
	/*
	 * Constants
	 */
	/** @const */ var SET_QUEUE_KEY          = '__mps';
	/** @const */ var SET_ONCE_QUEUE_KEY     = '__mpso';
	/** @const */ var UNSET_QUEUE_KEY        = '__mpus';
	/** @const */ var ADD_QUEUE_KEY          = '__mpa';
	/** @const */ var APPEND_QUEUE_KEY       = '__mpap';
	/** @const */ var REMOVE_QUEUE_KEY       = '__mpr';
	/** @const */ var UNION_QUEUE_KEY        = '__mpu';
	// This key is deprecated, but we want to check for it to see whether aliasing is allowed.
	/** @const */ var PEOPLE_DISTINCT_ID_KEY = '$people_distinct_id';
	/** @const */ var ALIAS_ID_KEY           = '__alias';
	/** @const */ var CAMPAIGN_IDS_KEY       = '__cmpns';
	/** @const */ var EVENT_TIMERS_KEY       = '__timers';
	/** @const */ var RESERVED_PROPERTIES = [
	    SET_QUEUE_KEY,
	    SET_ONCE_QUEUE_KEY,
	    UNSET_QUEUE_KEY,
	    ADD_QUEUE_KEY,
	    APPEND_QUEUE_KEY,
	    REMOVE_QUEUE_KEY,
	    UNION_QUEUE_KEY,
	    PEOPLE_DISTINCT_ID_KEY,
	    ALIAS_ID_KEY,
	    CAMPAIGN_IDS_KEY,
	    EVENT_TIMERS_KEY
	];
	
	/**
	 * Mixpanel Persistence Object
	 * @constructor
	 */
	var MixpanelPersistence = function(config) {
	    this['props'] = {};
	    this.campaign_params_saved = false;
	
	    if (config['persistence_name']) {
	        this.name = 'mp_' + config['persistence_name'];
	    } else {
	        this.name = 'mp_' + config['token'] + '_mixpanel';
	    }
	
	    var storage_type = config['persistence'];
	    if (storage_type !== 'cookie' && storage_type !== 'localStorage') {
	        console.critical('Unknown persistence type ' + storage_type + '; falling back to cookie');
	        storage_type = config['persistence'] = 'cookie';
	    }
	
	    if (storage_type === 'localStorage' && _.localStorage.is_supported()) {
	        this.storage = _.localStorage;
	    } else {
	        this.storage = _.cookie;
	    }
	
	    this.load();
	    this.update_config(config);
	    this.upgrade(config);
	    this.save();
	};
	
	MixpanelPersistence.prototype.properties = function() {
	    var p = {};
	    // Filter out reserved properties
	    _.each(this['props'], function(v, k) {
	        if (!_.include(RESERVED_PROPERTIES, k)) {
	            p[k] = v;
	        }
	    });
	    return p;
	};
	
	MixpanelPersistence.prototype.load = function() {
	    if (this.disabled) { return; }
	
	    var entry = this.storage.parse(this.name);
	
	    if (entry) {
	        this['props'] = _.extend({}, entry);
	    }
	};
	
	MixpanelPersistence.prototype.upgrade = function(config) {
	    var upgrade_from_old_lib = config['upgrade'],
	        old_cookie_name,
	        old_cookie;
	
	    if (upgrade_from_old_lib) {
	        old_cookie_name = 'mp_super_properties';
	        // Case where they had a custom cookie name before.
	        if (typeof(upgrade_from_old_lib) === 'string') {
	            old_cookie_name = upgrade_from_old_lib;
	        }
	
	        old_cookie = this.storage.parse(old_cookie_name);
	
	        // remove the cookie
	        this.storage.remove(old_cookie_name);
	        this.storage.remove(old_cookie_name, true);
	
	        if (old_cookie) {
	            this['props'] = _.extend(
	                this['props'],
	                old_cookie['all'],
	                old_cookie['events']
	            );
	        }
	    }
	
	    if (!config['cookie_name'] && config['name'] !== 'mixpanel') {
	        // special case to handle people with cookies of the form
	        // mp_TOKEN_INSTANCENAME from the first release of this library
	        old_cookie_name = 'mp_' + config['token'] + '_' + config['name'];
	        old_cookie = this.storage.parse(old_cookie_name);
	
	        if (old_cookie) {
	            this.storage.remove(old_cookie_name);
	            this.storage.remove(old_cookie_name, true);
	
	            // Save the prop values that were in the cookie from before -
	            // this should only happen once as we delete the old one.
	            this.register_once(old_cookie);
	        }
	    }
	
	    if (this.storage === _.localStorage) {
	        old_cookie = _.cookie.parse(this.name);
	
	        _.cookie.remove(this.name);
	        _.cookie.remove(this.name, true);
	
	        if (old_cookie) {
	            this.register_once(old_cookie);
	        }
	    }
	};
	
	MixpanelPersistence.prototype.save = function() {
	    if (this.disabled) { return; }
	    this._expire_notification_campaigns();
	    this.storage.set(
	        this.name,
	        _.JSONEncode(this['props']),
	        this.expire_days,
	        this.cross_subdomain,
	        this.secure,
	        this.cross_site,
	        this.cookie_domain
	    );
	};
	
	MixpanelPersistence.prototype.remove = function() {
	    // remove both domain and subdomain cookies
	    this.storage.remove(this.name, false, this.cookie_domain);
	    this.storage.remove(this.name, true, this.cookie_domain);
	};
	
	// removes the storage entry and deletes all loaded data
	// forced name for tests
	MixpanelPersistence.prototype.clear = function() {
	    this.remove();
	    this['props'] = {};
	};
	
	/**
	* @param {Object} props
	* @param {*=} default_value
	* @param {number=} days
	*/
	MixpanelPersistence.prototype.register_once = function(props, default_value, days) {
	    if (_.isObject(props)) {
	        if (typeof(default_value) === 'undefined') { default_value = 'None'; }
	        this.expire_days = (typeof(days) === 'undefined') ? this.default_expiry : days;
	
	        _.each(props, function(val, prop) {
	            if (!this['props'].hasOwnProperty(prop) || this['props'][prop] === default_value) {
	                this['props'][prop] = val;
	            }
	        }, this);
	
	        this.save();
	
	        return true;
	    }
	    return false;
	};
	
	/**
	* @param {Object} props
	* @param {number=} days
	*/
	MixpanelPersistence.prototype.register = function(props, days) {
	    if (_.isObject(props)) {
	        this.expire_days = (typeof(days) === 'undefined') ? this.default_expiry : days;
	
	        _.extend(this['props'], props);
	
	        this.save();
	
	        return true;
	    }
	    return false;
	};
	
	MixpanelPersistence.prototype.unregister = function(prop) {
	    if (prop in this['props']) {
	        delete this['props'][prop];
	        this.save();
	    }
	};
	
	MixpanelPersistence.prototype._expire_notification_campaigns = _.safewrap(function() {
	    var campaigns_shown = this['props'][CAMPAIGN_IDS_KEY],
	        EXPIRY_TIME = Config.DEBUG ? 60 * 1000 : 60 * 60 * 1000; // 1 minute (Config.DEBUG) / 1 hour (PDXN)
	    if (!campaigns_shown) {
	        return;
	    }
	    for (var campaign_id in campaigns_shown) {
	        if (1 * new Date() - campaigns_shown[campaign_id] > EXPIRY_TIME) {
	            delete campaigns_shown[campaign_id];
	        }
	    }
	    if (_.isEmptyObject(campaigns_shown)) {
	        delete this['props'][CAMPAIGN_IDS_KEY];
	    }
	});
	
	MixpanelPersistence.prototype.update_campaign_params = function() {
	    if (!this.campaign_params_saved) {
	        this.register_once(_.info.campaignParams());
	        this.campaign_params_saved = true;
	    }
	};
	
	MixpanelPersistence.prototype.update_search_keyword = function(referrer) {
	    this.register(_.info.searchInfo(referrer));
	};
	
	// EXPORTED METHOD, we test this directly.
	MixpanelPersistence.prototype.update_referrer_info = function(referrer) {
	    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
	    this.register_once({
	        '$initial_referrer': referrer || '$direct',
	        '$initial_referring_domain': _.info.referringDomain(referrer) || '$direct'
	    }, '');
	};
	
	MixpanelPersistence.prototype.get_referrer_info = function() {
	    return _.strip_empty_properties({
	        '$initial_referrer': this['props']['$initial_referrer'],
	        '$initial_referring_domain': this['props']['$initial_referring_domain']
	    });
	};
	
	// safely fills the passed in object with stored properties,
	// does not override any properties defined in both
	// returns the passed in object
	MixpanelPersistence.prototype.safe_merge = function(props) {
	    _.each(this['props'], function(val, prop) {
	        if (!(prop in props)) {
	            props[prop] = val;
	        }
	    });
	
	    return props;
	};
	
	MixpanelPersistence.prototype.update_config = function(config) {
	    this.default_expiry = this.expire_days = config['cookie_expiration'];
	    this.set_disabled(config['disable_persistence']);
	    this.set_cookie_domain(config['cookie_domain']);
	    this.set_cross_site(config['cross_site_cookie']);
	    this.set_cross_subdomain(config['cross_subdomain_cookie']);
	    this.set_secure(config['secure_cookie']);
	};
	
	MixpanelPersistence.prototype.set_disabled = function(disabled) {
	    this.disabled = disabled;
	    if (this.disabled) {
	        this.remove();
	    } else {
	        this.save();
	    }
	};
	
	MixpanelPersistence.prototype.set_cookie_domain = function(cookie_domain) {
	    if (cookie_domain !== this.cookie_domain) {
	        this.remove();
	        this.cookie_domain = cookie_domain;
	        this.save();
	    }
	};
	
	MixpanelPersistence.prototype.set_cross_site = function(cross_site) {
	    if (cross_site !== this.cross_site) {
	        this.cross_site = cross_site;
	        this.remove();
	        this.save();
	    }
	};
	
	MixpanelPersistence.prototype.set_cross_subdomain = function(cross_subdomain) {
	    if (cross_subdomain !== this.cross_subdomain) {
	        this.cross_subdomain = cross_subdomain;
	        this.remove();
	        this.save();
	    }
	};
	
	MixpanelPersistence.prototype.get_cross_subdomain = function() {
	    return this.cross_subdomain;
	};
	
	MixpanelPersistence.prototype.set_secure = function(secure) {
	    if (secure !== this.secure) {
	        this.secure = secure ? true : false;
	        this.remove();
	        this.save();
	    }
	};
	
	MixpanelPersistence.prototype._add_to_people_queue = function(queue, data) {
	    var q_key = this._get_queue_key(queue),
	        q_data = data[queue],
	        set_q = this._get_or_create_queue(SET_ACTION),
	        set_once_q = this._get_or_create_queue(SET_ONCE_ACTION),
	        unset_q = this._get_or_create_queue(UNSET_ACTION),
	        add_q = this._get_or_create_queue(ADD_ACTION),
	        union_q = this._get_or_create_queue(UNION_ACTION),
	        remove_q = this._get_or_create_queue(REMOVE_ACTION, []),
	        append_q = this._get_or_create_queue(APPEND_ACTION, []);
	
	    if (q_key === SET_QUEUE_KEY) {
	        // Update the set queue - we can override any existing values
	        _.extend(set_q, q_data);
	        // if there was a pending increment, override it
	        // with the set.
	        this._pop_from_people_queue(ADD_ACTION, q_data);
	        // if there was a pending union, override it
	        // with the set.
	        this._pop_from_people_queue(UNION_ACTION, q_data);
	        this._pop_from_people_queue(UNSET_ACTION, q_data);
	    } else if (q_key === SET_ONCE_QUEUE_KEY) {
	        // only queue the data if there is not already a set_once call for it.
	        _.each(q_data, function(v, k) {
	            if (!(k in set_once_q)) {
	                set_once_q[k] = v;
	            }
	        });
	        this._pop_from_people_queue(UNSET_ACTION, q_data);
	    } else if (q_key === UNSET_QUEUE_KEY) {
	        _.each(q_data, function(prop) {
	
	            // undo previously-queued actions on this key
	            _.each([set_q, set_once_q, add_q, union_q], function(enqueued_obj) {
	                if (prop in enqueued_obj) {
	                    delete enqueued_obj[prop];
	                }
	            });
	            _.each(append_q, function(append_obj) {
	                if (prop in append_obj) {
	                    delete append_obj[prop];
	                }
	            });
	
	            unset_q[prop] = true;
	
	        });
	    } else if (q_key === ADD_QUEUE_KEY) {
	        _.each(q_data, function(v, k) {
	            // If it exists in the set queue, increment
	            // the value
	            if (k in set_q) {
	                set_q[k] += v;
	            } else {
	                // If it doesn't exist, update the add
	                // queue
	                if (!(k in add_q)) {
	                    add_q[k] = 0;
	                }
	                add_q[k] += v;
	            }
	        }, this);
	        this._pop_from_people_queue(UNSET_ACTION, q_data);
	    } else if (q_key === UNION_QUEUE_KEY) {
	        _.each(q_data, function(v, k) {
	            if (_.isArray(v)) {
	                if (!(k in union_q)) {
	                    union_q[k] = [];
	                }
	                // We may send duplicates, the server will dedup them.
	                union_q[k] = union_q[k].concat(v);
	            }
	        });
	        this._pop_from_people_queue(UNSET_ACTION, q_data);
	    } else if (q_key === REMOVE_QUEUE_KEY) {
	        remove_q.push(q_data);
	        this._pop_from_people_queue(APPEND_ACTION, q_data);
	    } else if (q_key === APPEND_QUEUE_KEY) {
	        append_q.push(q_data);
	        this._pop_from_people_queue(UNSET_ACTION, q_data);
	    }
	
	    console.log('MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):');
	    console.log(data);
	
	    this.save();
	};
	
	MixpanelPersistence.prototype._pop_from_people_queue = function(queue, data) {
	    var q = this._get_queue(queue);
	    if (!_.isUndefined(q)) {
	        _.each(data, function(v, k) {
	            if (queue === APPEND_ACTION || queue === REMOVE_ACTION) {
	                // list actions: only remove if both k+v match
	                // e.g. remove should not override append in a case like
	                // append({foo: 'bar'}); remove({foo: 'qux'})
	                _.each(q, function(queued_action) {
	                    if (queued_action[k] === v) {
	                        delete queued_action[k];
	                    }
	                });
	            } else {
	                delete q[k];
	            }
	        }, this);
	
	        this.save();
	    }
	};
	
	MixpanelPersistence.prototype._get_queue_key = function(queue) {
	    if (queue === SET_ACTION) {
	        return SET_QUEUE_KEY;
	    } else if (queue === SET_ONCE_ACTION) {
	        return SET_ONCE_QUEUE_KEY;
	    } else if (queue === UNSET_ACTION) {
	        return UNSET_QUEUE_KEY;
	    } else if (queue === ADD_ACTION) {
	        return ADD_QUEUE_KEY;
	    } else if (queue === APPEND_ACTION) {
	        return APPEND_QUEUE_KEY;
	    } else if (queue === REMOVE_ACTION) {
	        return REMOVE_QUEUE_KEY;
	    } else if (queue === UNION_ACTION) {
	        return UNION_QUEUE_KEY;
	    } else {
	        console.error('Invalid queue:', queue);
	    }
	};
	
	MixpanelPersistence.prototype._get_queue = function(queue) {
	    return this['props'][this._get_queue_key(queue)];
	};
	MixpanelPersistence.prototype._get_or_create_queue = function(queue, default_val) {
	    var key = this._get_queue_key(queue);
	    default_val = _.isUndefined(default_val) ? {} : default_val;
	
	    return this['props'][key] || (this['props'][key] = default_val);
	};
	
	MixpanelPersistence.prototype.set_event_timer = function(event_name, timestamp) {
	    var timers = this['props'][EVENT_TIMERS_KEY] || {};
	    timers[event_name] = timestamp;
	    this['props'][EVENT_TIMERS_KEY] = timers;
	    this.save();
	};
	
	MixpanelPersistence.prototype.remove_event_timer = function(event_name) {
	    var timers = this['props'][EVENT_TIMERS_KEY] || {};
	    var timestamp = timers[event_name];
	    if (!_.isUndefined(timestamp)) {
	        delete this['props'][EVENT_TIMERS_KEY][event_name];
	        this.save();
	    }
	    return timestamp;
	};
	
	/*
	 * This file is a js implementation for a subset in eval_node.c
	 */
	
	/*
	 * Constants
	 */
	// Metadata keys
	/** @const */   var OPERATOR_KEY                  = 'operator';
	/** @const */   var PROPERTY_KEY                  = 'property';
	/** @const */   var WINDOW_KEY                    = 'window';
	/** @const */   var UNIT_KEY                      = 'unit';
	/** @const */   var VALUE_KEY                     = 'value';
	/** @const */   var HOUR_KEY                      = 'hour';
	/** @const */   var DAY_KEY                       = 'day';
	/** @const */   var WEEK_KEY                      = 'week';
	/** @const */   var MONTH_KEY                     = 'month';
	
	// Operands
	/** @const */   var EVENT_PROPERTY         = 'event';
	/** @const */   var LITERAL_PROPERTY       = 'literal';
	
	// Binary Operators
	/** @const */   var AND_OPERATOR           = 'and';
	/** @const */   var OR_OPERATOR            = 'or';
	/** @const */   var IN_OPERATOR            = 'in';
	/** @const */   var NOT_IN_OPERATOR        = 'not in';
	/** @const */   var PLUS_OPERATOR          = '+';
	/** @const */   var MINUS_OPERATOR         = '-';
	/** @const */   var MUL_OPERATOR           = '*';
	/** @const */   var DIV_OPERATOR           = '/';
	/** @const */   var MOD_OPERATOR           = '%';
	/** @const */   var EQUALS_OPERATOR        = '==';
	/** @const */   var NOT_EQUALS_OPERATOR    = '!=';
	/** @const */   var GREATER_OPERATOR       = '>';
	/** @const */   var LESS_OPERATOR          = '<';
	/** @const */   var GREATER_EQUAL_OPERATOR = '>=';
	/** @const */   var LESS_EQUAL_OPERATOR    = '<=';
	
	// Typecast Operators
	/** @const */   var BOOLEAN_OPERATOR       = 'boolean';
	/** @const */   var DATETIME_OPERATOR      = 'datetime';
	/** @const */   var LIST_OPERATOR          = 'list';
	/** @const */   var NUMBER_OPERATOR        = 'number';
	/** @const */   var STRING_OPERATOR        = 'string';
	
	// Unary Operators
	/** @const */   var NOT_OPERATOR           = 'not';
	/** @const */   var DEFINED_OPERATOR       = 'defined';
	/** @const */   var NOT_DEFINED_OPERATOR   = 'not defined';
	
	// Special literals
	/** @const */   var NOW_LITERAL            = 'now';
	
	// Type cast functions
	function toNumber(value) {
	    if (value === null) {
	        return null;
	    }
	
	    switch (typeof(value)) {
	        case 'object':
	            if (_.isDate(value) && value.getTime() >= 0) {
	                return value.getTime();
	            }
	            return null;
	        case 'boolean':
	            return Number(value);
	        case 'number':
	            return value;
	        case 'string':
	            value = Number(value);
	            if (!isNaN(value)) {
	                return value;
	            }
	            return 0;
	    }
	    return null;
	}
	
	function evaluateNumber(op, properties) {
	    if (!op['operator'] || op['operator'] !== NUMBER_OPERATOR || !op['children'] || op['children'].length !== 1) {
	        throw ('Invalid cast operator: number ' + op);
	    }
	
	    return toNumber(evaluateSelector(op['children'][0], properties));
	}
	
	function toBoolean(value) {
	    if (value === null) {
	        return false;
	    }
	
	    switch (typeof value) {
	        case 'boolean':
	            return value;
	        case 'number':
	            return value !== 0.0;
	        case 'string':
	            return value.length > 0;
	        case 'object':
	            if (_.isArray(value) && value.length > 0) {
	                return true;
	            }
	            if (_.isDate(value) && value.getTime() > 0) {
	                return true;
	            }
	            if (_.isObject(value) && !_.isEmptyObject(value)) {
	                return true;
	            }
	            return false;
	    }
	    return false;
	}
	
	function evaluateBoolean(op, properties) {
	    if (!op['operator'] || op['operator'] !== BOOLEAN_OPERATOR || !op['children'] || op['children'].length !== 1) {
	        throw ('Invalid cast operator: boolean ' + op);
	    }
	
	    return toBoolean(evaluateSelector(op['children'][0], properties));
	}
	
	function evaluateDateTime(op, properties) {
	    if (!op['operator'] || op['operator'] !== DATETIME_OPERATOR || !op['children'] || op['children'].length !== 1) {
	        throw ('Invalid cast operator: datetime ' + op);
	    }
	
	    var v = evaluateSelector(op['children'][0], properties);
	    if (v === null) {
	        return null;
	    }
	
	    switch (typeof(v)) {
	        case 'number':
	        case 'string':
	            var d = new Date(v);
	            if (isNaN(d.getTime())) {
	                return null;
	            }
	            return d;
	        case 'object':
	            if (_.isDate(v)) {
	                return v;
	            }
	    }
	
	    return null;
	}
	
	function evaluateList(op, properties) {
	    if (!op['operator'] || op['operator'] !== LIST_OPERATOR || !op['children'] || op['children'].length !== 1) {
	        throw ('Invalid cast operator: list ' + op);
	    }
	
	    var v = evaluateSelector(op['children'][0], properties);
	    if (v === null) {
	        return null;
	    }
	
	    if (_.isArray(v)) {
	        return v;
	    }
	
	    return null;
	}
	
	function evaluateString(op, properties) {
	    if (!op['operator'] || op['operator'] !== STRING_OPERATOR || !op['children'] || op['children'].length !== 1) {
	        throw ('Invalid cast operator: string ' + op);
	    }
	
	    var v = evaluateSelector(op['children'][0], properties);
	    switch (typeof(v)) {
	        case 'object':
	            if (_.isDate(v)) {
	                return v.toJSON();
	            }
	            return JSON.stringify(v);
	    }
	    return String(v);
	}
	
	// Operators
	function evaluateAnd(op, properties) {
	    if (!op['operator'] || op['operator'] !== AND_OPERATOR || !op['children'] || op['children'].length !== 2) {
	        throw ('Invalid operator: AND ' + op);
	    }
	
	    return toBoolean(evaluateSelector(op['children'][0], properties)) && toBoolean(evaluateSelector(op['children'][1], properties));
	}
	
	function evaluateOr(op, properties) {
	    if (!op['operator'] || op['operator'] !== OR_OPERATOR || !op['children'] || op['children'].length !== 2) {
	        throw ('Invalid operator: OR ' + op);
	    }
	
	    return toBoolean(evaluateSelector(op['children'][0], properties)) || toBoolean(evaluateSelector(op['children'][1], properties));
	}
	
	function evaluateIn(op, properties) {
	    if (!op['operator'] || [IN_OPERATOR, NOT_IN_OPERATOR].indexOf(op['operator']) === -1 || !op['children'] || op['children'].length !== 2) {
	        throw ('Invalid operator: IN/NOT IN ' + op);
	    }
	    var leftValue = evaluateSelector(op['children'][0], properties);
	    var rightValue = evaluateSelector(op['children'][1], properties);
	
	    if (!_.isArray(rightValue) && !_.isString(rightValue)) {
	        throw ('Invalid operand for operator IN: invalid type' + rightValue);
	    }
	
	    var v = rightValue.indexOf(leftValue) > -1;
	    if (op['operator'] === NOT_IN_OPERATOR) {
	        return !v;
	    }
	    return v;
	}
	
	function evaluatePlus(op, properties) {
	    if (!op['operator'] || op['operator'] !== PLUS_OPERATOR || !op['children'] || op['children'].length < 2) {
	        throw ('Invalid operator: PLUS ' + op);
	    }
	    var l = evaluateSelector(op['children'][0], properties);
	    var r = evaluateSelector(op['children'][1], properties);
	
	    if (typeof l === 'number' && typeof r === 'number') {
	        return l + r;
	    }
	    if (typeof l === 'string' && typeof r === 'string') {
	        return l + r;
	    }
	    return null;
	}
	
	function evaluateArithmetic(op, properties) {
	    if (!op['operator'] || [MINUS_OPERATOR, MUL_OPERATOR, DIV_OPERATOR, MOD_OPERATOR].indexOf(op['operator']) === -1 ||
	        !op['children'] || op['children'].length < 2) {
	        throw ('Invalid arithmetic operator ' + op);
	    }
	
	    var l = evaluateSelector(op['children'][0], properties);
	    var r = evaluateSelector(op['children'][1], properties);
	
	    if (typeof l === 'number' && typeof r === 'number') {
	        switch (op['operator']) {
	            case MINUS_OPERATOR:
	                return l - r;
	            case MUL_OPERATOR:
	                return l * r;
	            case DIV_OPERATOR:
	                if (r !== 0) {
	                    return l / r;
	                }
	                return null;
	            case MOD_OPERATOR:
	                if (r === 0) {
	                    return null;
	                }
	                if (l === 0) {
	                    return 0;
	                }
	                if ((l < 0 && r > 0) || (l > 0 && r < 0)) {
	                    /* Mimic python modulo - result takes sign of the divisor
	                     * if one operand is negative. */
	                    return -(Math.floor(l / r) * r - l);
	                }
	                return l % r;
	            default:
	                throw('Unknown operator: ' + op['operator']);
	        }
	    }
	
	    return null;
	}
	
	function _isArrayEqual(l, r) {
	    if (l === r) return true;
	    if (l === null || r === null) return false;
	    if (l.length !== r.length) return false;
	
	    for (var i = 0; i < l.length; i++) {
	        if (l[i] !== r[i]) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	function _isEqual(l, r) {
	    if ( l === null && l === r ) {
	        return true;
	    }
	    if (typeof l === typeof r) {
	        switch (typeof l) {
	            case 'number':
	            case 'string':
	            case 'boolean':
	                return l === r;
	            case 'object':
	                if (_.isArray(l) && _.isArray(r)) {
	                    return _isArrayEqual(l, r);
	                }
	                if (_.isDate(l) && _.isDate(r)) {
	                    return l.getTime() === r.getTime();
	                }
	                if (_.isObject(l) && _.isObject(r)) {
	                    return JSON.stringify(l) === JSON.stringify(r);
	                }
	        }
	    }
	    return false;
	}
	
	function evaluateEquality(op, properties) {
	    if (!op['operator'] || [EQUALS_OPERATOR, NOT_EQUALS_OPERATOR].indexOf(op['operator']) === -1 || !op['children'] || op['children'].length !== 2) {
	        throw ('Invalid equality operator ' + op);
	    }
	
	    var v = _isEqual(evaluateSelector(op['children'][0], properties), evaluateSelector(op['children'][1], properties));
	
	    switch (op['operator']) {
	        case EQUALS_OPERATOR:
	            return v;
	        case NOT_EQUALS_OPERATOR:
	            return !v;
	    }
	}
	
	function evaluateComparison(op, properties) {
	    if (!op['operator'] ||
	        [GREATER_OPERATOR, GREATER_EQUAL_OPERATOR, LESS_OPERATOR, LESS_EQUAL_OPERATOR].indexOf(op['operator']) === -1 ||
	        !op['children'] || op['children'].length !== 2) {
	        throw ('Invalid comparison operator ' + op);
	    }
	    var l = evaluateSelector(op['children'][0], properties);
	    var r = evaluateSelector(op['children'][1], properties);
	
	    if (typeof(l) === typeof(r)) {
	        if (typeof(r) === 'number' || _.isDate(r)) {
	            l = toNumber(l);
	            r = toNumber(r);
	            switch (op['operator']) {
	                case GREATER_OPERATOR:
	                    return l > r;
	                case GREATER_EQUAL_OPERATOR:
	                    return l >= r;
	                case LESS_OPERATOR:
	                    return l < r;
	                case LESS_EQUAL_OPERATOR:
	                    return l <= r;
	            }
	        } else if (typeof(r) === 'string') {
	            var compare = l.localeCompare(r);
	            switch (op['operator']) {
	                case GREATER_OPERATOR:
	                    return compare > 0;
	                case GREATER_EQUAL_OPERATOR:
	                    return compare >= 0;
	                case LESS_OPERATOR:
	                    return compare < 0;
	                case LESS_EQUAL_OPERATOR:
	                    return compare <= 0;
	            }
	        }
	    }
	
	    return null;
	}
	
	function evaluateDefined(op, properties) {
	    if (!op['operator'] || [DEFINED_OPERATOR, NOT_DEFINED_OPERATOR].indexOf(op['operator']) === -1 ||
	        !op['children'] || op['children'].length !== 1) {
	        throw ('Invalid defined/not defined operator: ' + op);
	    }
	
	    var b = evaluateSelector(op['children'][0], properties) !== null;
	    if (op['operator'] === NOT_DEFINED_OPERATOR) {
	        return !b;
	    }
	
	    return b;
	}
	
	function evaluateNot(op, properties) {
	    if (!op['operator'] || op['operator'] !== NOT_OPERATOR || !op['children'] || op['children'].length !== 1) {
	        throw ('Invalid not operator: ' + op);
	    }
	
	    var v = evaluateSelector(op['children'][0], properties);
	    if (v === null) {
	        return true;
	    }
	
	    if (typeof(v) === 'boolean') {
	        return !v;
	    }
	
	    return null;
	}
	
	function evaluateOperator(op, properties) {
	    if (!op['operator']) {
	        throw ('Invalid operator: operator key missing ' + op);
	    }
	
	    switch (op['operator']) {
	        case AND_OPERATOR:
	            return evaluateAnd(op, properties);
	        case OR_OPERATOR:
	            return evaluateOr(op, properties);
	        case IN_OPERATOR:
	        case NOT_IN_OPERATOR:
	            return evaluateIn(op, properties);
	        case PLUS_OPERATOR:
	            return evaluatePlus(op, properties);
	        case MINUS_OPERATOR:
	        case MUL_OPERATOR:
	        case DIV_OPERATOR:
	        case MOD_OPERATOR:
	            return evaluateArithmetic(op, properties);
	        case EQUALS_OPERATOR:
	        case NOT_EQUALS_OPERATOR:
	            return evaluateEquality(op, properties);
	        case GREATER_OPERATOR:
	        case LESS_OPERATOR:
	        case GREATER_EQUAL_OPERATOR:
	        case LESS_EQUAL_OPERATOR:
	            return evaluateComparison(op, properties);
	        case BOOLEAN_OPERATOR:
	            return evaluateBoolean(op, properties);
	        case DATETIME_OPERATOR:
	            return evaluateDateTime(op, properties);
	        case LIST_OPERATOR:
	            return evaluateList(op, properties);
	        case NUMBER_OPERATOR:
	            return evaluateNumber(op, properties);
	        case STRING_OPERATOR:
	            return evaluateString(op, properties);
	        case DEFINED_OPERATOR:
	        case NOT_DEFINED_OPERATOR:
	            return evaluateDefined(op, properties);
	        case NOT_OPERATOR:
	            return evaluateNot(op, properties);
	    }
	}
	
	function evaluateWindow(value) {
	    var win = value[WINDOW_KEY];
	    if (!win || !win[UNIT_KEY] || !win[VALUE_KEY]) {
	        throw('Invalid window: missing required keys ' + JSON.stringify(value));
	    }
	    var out = new Date();
	    switch (win[UNIT_KEY]) {
	        case HOUR_KEY:
	            out.setTime(out.getTime() + (win[VALUE_KEY]*-1*60*60*1000));
	            break;
	        case DAY_KEY:
	            out.setTime(out.getTime() + (win[VALUE_KEY]*-1*24*60*60*1000));
	            break;
	        case WEEK_KEY:
	            out.setTime(out.getTime() + (win[VALUE_KEY]*-1*7*24*60*60*1000));
	            break;
	        case MONTH_KEY:
	            out.setTime(out.getTime() + (win[VALUE_KEY]*-1*30*24*60*60*1000));
	            break;
	        default:
	            throw('Invalid unit: ' + win[UNIT_KEY]);
	    }
	
	    return out;
	}
	
	function evaluateOperand(op, properties) {
	    if (!op['property'] || !op['value']) {
	        throw('Invalid operand: missing required keys ' + op);
	    }
	    switch (op['property']) {
	        case EVENT_PROPERTY:
	            if (properties[op['value']] !== undefined) {
	                return properties[op['value']];
	            }
	            return null;
	        case LITERAL_PROPERTY:
	            if (op['value'] === NOW_LITERAL) {
	                return new Date();
	            }
	            if (typeof(op['value']) === 'object') {
	                return evaluateWindow(op['value']);
	            }
	            return op['value'];
	        default:
	            throw('Invalid operand: Invalid property type ' + op['property']);
	    }
	}
	
	function evaluateSelector(filters, properties) {
	    if (filters[PROPERTY_KEY]) {
	        return evaluateOperand(filters, properties);
	    }
	    if (filters[OPERATOR_KEY]) {
	        return evaluateOperator(filters, properties);
	    }
	}
	
	// Internal class for notification display
	
	var MixpanelNotification = function(notif_data, mixpanel_instance) {
	    _.bind_instance_methods(this);
	
	    this.mixpanel          = mixpanel_instance;
	    this.persistence       = this.mixpanel['persistence'];
	    this.resource_protocol = this.mixpanel.get_config('inapp_protocol');
	    this.cdn_host          = this.mixpanel.get_config('cdn');
	
	    this.campaign_id = _.escapeHTML(notif_data['id']);
	    this.message_id  = _.escapeHTML(notif_data['message_id']);
	
	    this.body            = (_.escapeHTML(notif_data['body']) || '').replace(/\n/g, '<br/>');
	    this.cta             = _.escapeHTML(notif_data['cta']) || 'Close';
	    this.notif_type      = _.escapeHTML(notif_data['type']) || 'takeover';
	    this.style           = _.escapeHTML(notif_data['style']) || 'light';
	    this.title           = _.escapeHTML(notif_data['title']) || '';
	    this.video_width     = MixpanelNotification.VIDEO_WIDTH;
	    this.video_height    = MixpanelNotification.VIDEO_HEIGHT;
	
	    this.display_triggers = notif_data['display_triggers'] || [];
	
	    // These fields are url-sanitized in the backend already.
	    this.dest_url        = notif_data['cta_url'] || null;
	    this.image_url       = notif_data['image_url'] || null;
	    this.thumb_image_url = notif_data['thumb_image_url'] || null;
	    this.video_url       = notif_data['video_url'] || null;
	
	    if (this.thumb_image_url && this.thumb_image_url.indexOf('//') === 0) {
	        this.thumb_image_url = this.thumb_image_url.replace('//', this.resource_protocol);
	    }
	
	    this.clickthrough = true;
	    if (!this.dest_url) {
	        this.dest_url = '#dismiss';
	        this.clickthrough = false;
	    }
	
	    this.mini = this.notif_type === 'mini';
	    if (!this.mini) {
	        this.notif_type = 'takeover';
	    }
	    this.notif_width = !this.mini ? MixpanelNotification.NOTIF_WIDTH : MixpanelNotification.NOTIF_WIDTH_MINI;
	
	    this._set_client_config();
	    this.imgs_to_preload = this._init_image_html();
	    this._init_video();
	};
	
	MixpanelNotification.ANIM_TIME         = 200;
	MixpanelNotification.MARKUP_PREFIX     = 'mixpanel-notification';
	MixpanelNotification.BG_OPACITY        = 0.6;
	MixpanelNotification.NOTIF_TOP         = 25;
	MixpanelNotification.NOTIF_START_TOP   = 200;
	MixpanelNotification.NOTIF_WIDTH       = 388;
	MixpanelNotification.NOTIF_WIDTH_MINI  = 420;
	MixpanelNotification.NOTIF_HEIGHT_MINI = 85;
	MixpanelNotification.THUMB_BORDER_SIZE = 5;
	MixpanelNotification.THUMB_IMG_SIZE    = 60;
	MixpanelNotification.THUMB_OFFSET      = Math.round(MixpanelNotification.THUMB_IMG_SIZE / 2);
	MixpanelNotification.VIDEO_WIDTH       = 595;
	MixpanelNotification.VIDEO_HEIGHT      = 334;
	
	MixpanelNotification.prototype.show = function() {
	    var self = this;
	    this._set_client_config();
	
	    // don't display until HTML body exists
	    if (!this.body_el) {
	        setTimeout(function() { self.show(); }, 300);
	        return;
	    }
	
	    this._init_styles();
	    this._init_notification_el();
	
	    // wait for any images to load before showing notification
	    this._preload_images(this._attach_and_animate);
	};
	
	MixpanelNotification.prototype.dismiss = _.safewrap(function() {
	    if (!this.marked_as_shown) {
	        // unexpected condition: user interacted with notif even though we didn't consider it
	        // visible (see _mark_as_shown()); send tracking signals to mark delivery
	        this._mark_delivery({'invisible': true});
	    }
	
	    var exiting_el = this.showing_video ? this._get_el('video') : this._get_notification_display_el();
	    if (this.use_transitions) {
	        this._remove_class('bg', 'visible');
	        this._add_class(exiting_el, 'exiting');
	        setTimeout(this._remove_notification_el, MixpanelNotification.ANIM_TIME);
	    } else {
	        var notif_attr, notif_start, notif_goal;
	        if (this.mini) {
	            notif_attr  = 'right';
	            notif_start = 20;
	            notif_goal  = -100;
	        } else {
	            notif_attr  = 'top';
	            notif_start = MixpanelNotification.NOTIF_TOP;
	            notif_goal  = MixpanelNotification.NOTIF_START_TOP + MixpanelNotification.NOTIF_TOP;
	        }
	        this._animate_els([
	            {
	                el:    this._get_el('bg'),
	                attr:  'opacity',
	                start: MixpanelNotification.BG_OPACITY,
	                goal:  0.0
	            },
	            {
	                el:    exiting_el,
	                attr:  'opacity',
	                start: 1.0,
	                goal:  0.0
	            },
	            {
	                el:    exiting_el,
	                attr:  notif_attr,
	                start: notif_start,
	                goal:  notif_goal
	            }
	        ], MixpanelNotification.ANIM_TIME, this._remove_notification_el);
	    }
	});
	
	MixpanelNotification.prototype._add_class = _.safewrap(function(el, class_name) {
	    class_name = MixpanelNotification.MARKUP_PREFIX + '-' + class_name;
	    if (typeof el === 'string') {
	        el = this._get_el(el);
	    }
	    if (!el.className) {
	        el.className = class_name;
	    } else if (!~(' ' + el.className + ' ').indexOf(' ' + class_name + ' ')) {
	        el.className += ' ' + class_name;
	    }
	});
	MixpanelNotification.prototype._remove_class = _.safewrap(function(el, class_name) {
	    class_name = MixpanelNotification.MARKUP_PREFIX + '-' + class_name;
	    if (typeof el === 'string') {
	        el = this._get_el(el);
	    }
	    if (el.className) {
	        el.className = (' ' + el.className + ' ')
	            .replace(' ' + class_name + ' ', '')
	            .replace(/^[\s\xA0]+/, '')
	            .replace(/[\s\xA0]+$/, '');
	    }
	});
	
	MixpanelNotification.prototype._animate_els = _.safewrap(function(anims, mss, done_cb, start_time) {
	    var self = this,
	        in_progress = false,
	        ai, anim,
	        cur_time = 1 * new Date(), time_diff;
	
	    start_time = start_time || cur_time;
	    time_diff = cur_time - start_time;
	
	    for (ai = 0; ai < anims.length; ai++) {
	        anim = anims[ai];
	        if (typeof anim.val === 'undefined') {
	            anim.val = anim.start;
	        }
	        if (anim.val !== anim.goal) {
	            in_progress = true;
	            var anim_diff = anim.goal - anim.start,
	                anim_dir = anim.goal >= anim.start ? 1 : -1;
	            anim.val = anim.start + anim_diff * time_diff / mss;
	            if (anim.attr !== 'opacity') {
	                anim.val = Math.round(anim.val);
	            }
	            if ((anim_dir > 0 && anim.val >= anim.goal) || (anim_dir < 0 && anim.val <= anim.goal)) {
	                anim.val = anim.goal;
	            }
	        }
	    }
	    if (!in_progress) {
	        if (done_cb) {
	            done_cb();
	        }
	        return;
	    }
	
	    for (ai = 0; ai < anims.length; ai++) {
	        anim = anims[ai];
	        if (anim.el) {
	            var suffix = anim.attr === 'opacity' ? '' : 'px';
	            anim.el.style[anim.attr] = String(anim.val) + suffix;
	        }
	    }
	    setTimeout(function() { self._animate_els(anims, mss, done_cb, start_time); }, 10);
	});
	
	MixpanelNotification.prototype._attach_and_animate = _.safewrap(function() {
	    var self = this;
	
	    // no possibility to double-display
	    if (this.shown || this._get_shown_campaigns()[this.campaign_id]) {
	        return;
	    }
	    this.shown = true;
	
	    this.body_el.appendChild(this.notification_el);
	    setTimeout(function() {
	        var notif_el = self._get_notification_display_el();
	        if (self.use_transitions) {
	            if (!self.mini) {
	                self._add_class('bg', 'visible');
	            }
	            self._add_class(notif_el, 'visible');
	            self._mark_as_shown();
	        } else {
	            var notif_attr, notif_start, notif_goal;
	            if (self.mini) {
	                notif_attr  = 'right';
	                notif_start = -100;
	                notif_goal  = 20;
	            } else {
	                notif_attr  = 'top';
	                notif_start = MixpanelNotification.NOTIF_START_TOP + MixpanelNotification.NOTIF_TOP;
	                notif_goal  = MixpanelNotification.NOTIF_TOP;
	            }
	            self._animate_els([
	                {
	                    el:    self._get_el('bg'),
	                    attr:  'opacity',
	                    start: 0.0,
	                    goal:  MixpanelNotification.BG_OPACITY
	                },
	                {
	                    el:    notif_el,
	                    attr:  'opacity',
	                    start: 0.0,
	                    goal:  1.0
	                },
	                {
	                    el:    notif_el,
	                    attr:  notif_attr,
	                    start: notif_start,
	                    goal:  notif_goal
	                }
	            ], MixpanelNotification.ANIM_TIME, self._mark_as_shown);
	        }
	    }, 100);
	    _.register_event(self._get_el('cancel'), 'click', function(e) {
	        e.preventDefault();
	        self.dismiss();
	    });
	    var click_el = self._get_el('button') ||
	                        self._get_el('mini-content');
	    _.register_event(click_el, 'click', function(e) {
	        e.preventDefault();
	        if (self.show_video) {
	            self._track_event('$campaign_open', {'$resource_type': 'video'});
	            self._switch_to_video();
	        } else {
	            self.dismiss();
	            if (self.clickthrough) {
	                var tracking_cb = null;
	                if (self.mixpanel.get_config('inapp_link_new_window')) {
	                    window.open(self.dest_url);
	                } else {
	                    tracking_cb = function() {
	                        window.location.href = self.dest_url;
	                    };
	                }
	                self._track_event('$campaign_open', {'$resource_type': 'link'}, tracking_cb);
	            }
	        }
	    });
	});
	
	MixpanelNotification.prototype._get_el = function(id) {
	    return document.getElementById(MixpanelNotification.MARKUP_PREFIX + '-' + id);
	};
	
	MixpanelNotification.prototype._get_notification_display_el = function() {
	    return this._get_el(this.notif_type);
	};
	
	MixpanelNotification.prototype._get_shown_campaigns = function() {
	    return this.persistence['props'][CAMPAIGN_IDS_KEY] || (this.persistence['props'][CAMPAIGN_IDS_KEY] = {});
	};
	
	MixpanelNotification.prototype._matches_event_data = _.safewrap(function(event_data) {
	    var event_name = event_data['event'] || '';
	    for (var i = 0; i < this.display_triggers.length; i++) {
	        var display_trigger = this.display_triggers[i];
	        var match_event = display_trigger['event'] || '';
	        if (match_event === '$any_event' || event_name === display_trigger['event']) {
	            if (display_trigger['selector'] && !_.isEmptyObject(display_trigger['selector'])) {
	                if (evaluateSelector(display_trigger['selector'], event_data['properties'])) {
	                    return true;
	                }
	            } else {
	                return true;
	            }
	        }
	    }
	    return false;
	});
	
	
	MixpanelNotification.prototype._browser_lte = function(browser, version) {
	    return this.browser_versions[browser] && this.browser_versions[browser] <= version;
	};
	
	MixpanelNotification.prototype._init_image_html = function() {
	    var imgs_to_preload = [];
	
	    if (!this.mini) {
	        if (this.image_url) {
	            imgs_to_preload.push(this.image_url);
	            this.img_html = '<img id="img" src="' + this.image_url + '"/>';
	        } else {
	            this.img_html = '';
	        }
	        if (this.thumb_image_url) {
	            imgs_to_preload.push(this.thumb_image_url);
	            this.thumb_img_html =
	                    '<div id="thumbborder-wrapper"><div id="thumbborder"></div></div>' +
	                    '<img id="thumbnail"' +
	                        ' src="' + this.thumb_image_url + '"' +
	                        ' width="' + MixpanelNotification.THUMB_IMG_SIZE + '"' +
	                        ' height="' + MixpanelNotification.THUMB_IMG_SIZE + '"' +
	                    '/>' +
	                    '<div id="thumbspacer"></div>';
	        } else {
	            this.thumb_img_html = '';
	        }
	    } else {
	        this.thumb_image_url = this.thumb_image_url || (this.cdn_host + '/site_media/images/icons/notifications/mini-news-dark.png');
	        imgs_to_preload.push(this.thumb_image_url);
	    }
	
	    return imgs_to_preload;
	};
	
	MixpanelNotification.prototype._init_notification_el = function() {
	    var notification_html = '';
	    var video_src         = '';
	    var video_html        = '';
	    var cancel_html       = '<div id="cancel">' +
	                                    '<div id="cancel-icon"></div>' +
	                                '</div>';
	
	    this.notification_el = document.createElement('div');
	    this.notification_el.id = MixpanelNotification.MARKUP_PREFIX + '-wrapper';
	    if (!this.mini) {
	        // TAKEOVER notification
	        var close_html  = (this.clickthrough || this.show_video) ? '' : '<div id="button-close"></div>',
	            play_html   = this.show_video ? '<div id="button-play"></div>' : '';
	        if (this._browser_lte('ie', 7)) {
	            close_html = '';
	            play_html = '';
	        }
	        notification_html =
	                '<div id="takeover">' +
	                    this.thumb_img_html +
	                    '<div id="mainbox">' +
	                        cancel_html +
	                        '<div id="content">' +
	                            this.img_html +
	                            '<div id="title">' + this.title + '</div>' +
	                            '<div id="body">' + this.body + '</div>' +
	                            '<div id="tagline">' +
	                                '<a href="http://mixpanel.com?from=inapp" target="_blank">POWERED BY MIXPANEL</a>' +
	                            '</div>' +
	                        '</div>' +
	                        '<div id="button">' +
	                            close_html +
	                            '<a id="button-link" href="' + this.dest_url + '">' + this.cta + '</a>' +
	                            play_html +
	                        '</div>' +
	                    '</div>' +
	                '</div>';
	    } else {
	        // MINI notification
	        notification_html =
	                '<div id="mini">' +
	                    '<div id="mainbox">' +
	                        cancel_html +
	                        '<div id="mini-content">' +
	                            '<div id="mini-icon">' +
	                                '<div id="mini-icon-img"></div>' +
	                            '</div>' +
	                            '<div id="body">' +
	                                '<div id="body-text"><div>' + this.body + '</div></div>' +
	                            '</div>' +
	                        '</div>' +
	                    '</div>' +
	                    '<div id="mini-border"></div>' +
	                '</div>';
	    }
	    if (this.youtube_video) {
	        video_src = this.resource_protocol + 'www.youtube.com/embed/' + this.youtube_video +
	                '?wmode=transparent&showinfo=0&modestbranding=0&rel=0&autoplay=1&loop=0&vq=hd1080';
	        if (this.yt_custom) {
	            video_src += '&enablejsapi=1&html5=1&controls=0';
	            video_html =
	                    '<div id="video-controls">' +
	                        '<div id="video-progress" class="video-progress-el">' +
	                            '<div id="video-progress-total" class="video-progress-el"></div>' +
	                            '<div id="video-elapsed" class="video-progress-el"></div>' +
	                        '</div>' +
	                        '<div id="video-time" class="video-progress-el"></div>' +
	                    '</div>';
	        }
	    } else if (this.vimeo_video) {
	        video_src = this.resource_protocol + 'player.vimeo.com/video/' + this.vimeo_video + '?autoplay=1&title=0&byline=0&portrait=0';
	    }
	    if (this.show_video) {
	        this.video_iframe =
	                '<iframe id="' + MixpanelNotification.MARKUP_PREFIX + '-video-frame" ' +
	                    'width="' + this.video_width + '" height="' + this.video_height + '" ' +
	                    ' src="' + video_src + '"' +
	                    ' frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen="1" scrolling="no"' +
	                '></iframe>';
	        video_html =
	                '<div id="video-' + (this.flip_animate ? '' : 'no') + 'flip">' +
	                    '<div id="video">' +
	                        '<div id="video-holder"></div>' +
	                        video_html +
	                    '</div>' +
	                '</div>';
	    }
	    var main_html = video_html + notification_html;
	    if (this.flip_animate) {
	        main_html =
	                (this.mini ? notification_html : '') +
	                '<div id="flipcontainer"><div id="flipper">' +
	                    (this.mini ? video_html : main_html) +
	                '</div></div>';
	    }
	
	    this.notification_el.innerHTML =
	        ('<div id="overlay" class="' + this.notif_type + '">' +
	            '<div id="campaignid-' + this.campaign_id + '">' +
	                '<div id="bgwrapper">' +
	                    '<div id="bg"></div>' +
	                    main_html +
	                '</div>' +
	            '</div>' +
	        '</div>')
	            .replace(/class="/g, 'class="' + MixpanelNotification.MARKUP_PREFIX + '-')
	            .replace(/id="/g, 'id="' + MixpanelNotification.MARKUP_PREFIX + '-');
	};
	
	MixpanelNotification.prototype._init_styles = function() {
	    if (this.style === 'dark') {
	        this.style_vals = {
	            bg:             '#1d1f25',
	            bg_actions:     '#282b32',
	            bg_hover:       '#3a4147',
	            bg_light:       '#4a5157',
	            border_gray:    '#32353c',
	            cancel_opacity: '0.4',
	            mini_hover:     '#2a3137',
	            text_title:     '#fff',
	            text_main:      '#9498a3',
	            text_tagline:   '#464851',
	            text_hover:     '#ddd'
	        };
	    } else {
	        this.style_vals = {
	            bg:             '#fff',
	            bg_actions:     '#e7eaee',
	            bg_hover:       '#eceff3',
	            bg_light:       '#f5f5f5',
	            border_gray:    '#e4ecf2',
	            cancel_opacity: '1.0',
	            mini_hover:     '#fafafa',
	            text_title:     '#5c6578',
	            text_main:      '#8b949b',
	            text_tagline:   '#ced9e6',
	            text_hover:     '#7c8598'
	        };
	    }
	    var shadow = '0px 0px 35px 0px rgba(45, 49, 56, 0.7)',
	        video_shadow = shadow,
	        mini_shadow = shadow,
	        thumb_total_size = MixpanelNotification.THUMB_IMG_SIZE + MixpanelNotification.THUMB_BORDER_SIZE * 2,
	        anim_seconds = (MixpanelNotification.ANIM_TIME / 1000) + 's';
	    if (this.mini) {
	        shadow = 'none';
	    }
	
	    // don't display on small viewports
	    var notif_media_queries = {},
	        min_width = MixpanelNotification.NOTIF_WIDTH_MINI + 20;
	    notif_media_queries['@media only screen and (max-width: ' + (min_width - 1) + 'px)'] = {
	        '#overlay': {
	            'display': 'none'
	        }
	    };
	    var notif_styles = {
	        '.flipped': {
	            'transform': 'rotateY(180deg)'
	        },
	        '#overlay': {
	            'position': 'fixed',
	            'top': '0',
	            'left': '0',
	            'width': '100%',
	            'height': '100%',
	            'overflow': 'auto',
	            'text-align': 'center',
	            'z-index': '10000',
	            'font-family': '"Helvetica", "Arial", sans-serif',
	            '-webkit-font-smoothing': 'antialiased',
	            '-moz-osx-font-smoothing': 'grayscale'
	        },
	        '#overlay.mini': {
	            'height': '0',
	            'overflow': 'visible'
	        },
	        '#overlay a': {
	            'width': 'initial',
	            'padding': '0',
	            'text-decoration': 'none',
	            'text-transform': 'none',
	            'color': 'inherit'
	        },
	        '#bgwrapper': {
	            'position': 'relative',
	            'width': '100%',
	            'height': '100%'
	        },
	        '#bg': {
	            'position': 'fixed',
	            'top': '0',
	            'left': '0',
	            'width': '100%',
	            'height': '100%',
	            'min-width': this.doc_width * 4 + 'px',
	            'min-height': this.doc_height * 4 + 'px',
	            'background-color': 'black',
	            'opacity': '0.0',
	            '-ms-filter': 'progid:DXImageTransform.Microsoft.Alpha(Opacity=60)', // IE8
	            'filter': 'alpha(opacity=60)', // IE5-7
	            'transition': 'opacity ' + anim_seconds
	        },
	        '#bg.visible': {
	            'opacity': MixpanelNotification.BG_OPACITY
	        },
	        '.mini #bg': {
	            'width': '0',
	            'height': '0',
	            'min-width': '0'
	        },
	        '#flipcontainer': {
	            'perspective': '1000px',
	            'position': 'absolute',
	            'width': '100%'
	        },
	        '#flipper': {
	            'position': 'relative',
	            'transform-style': 'preserve-3d',
	            'transition': '0.3s'
	        },
	        '#takeover': {
	            'position': 'absolute',
	            'left': '50%',
	            'width': MixpanelNotification.NOTIF_WIDTH + 'px',
	            'margin-left': Math.round(-MixpanelNotification.NOTIF_WIDTH / 2) + 'px',
	            'backface-visibility': 'hidden',
	            'transform': 'rotateY(0deg)',
	            'opacity': '0.0',
	            'top': MixpanelNotification.NOTIF_START_TOP + 'px',
	            'transition': 'opacity ' + anim_seconds + ', top ' + anim_seconds
	        },
	        '#takeover.visible': {
	            'opacity': '1.0',
	            'top': MixpanelNotification.NOTIF_TOP + 'px'
	        },
	        '#takeover.exiting': {
	            'opacity': '0.0',
	            'top': MixpanelNotification.NOTIF_START_TOP + 'px'
	        },
	        '#thumbspacer': {
	            'height': MixpanelNotification.THUMB_OFFSET + 'px'
	        },
	        '#thumbborder-wrapper': {
	            'position': 'absolute',
	            'top': (-MixpanelNotification.THUMB_BORDER_SIZE) + 'px',
	            'left': (MixpanelNotification.NOTIF_WIDTH / 2 - MixpanelNotification.THUMB_OFFSET - MixpanelNotification.THUMB_BORDER_SIZE) + 'px',
	            'width': thumb_total_size + 'px',
	            'height': (thumb_total_size / 2) + 'px',
	            'overflow': 'hidden'
	        },
	        '#thumbborder': {
	            'position': 'absolute',
	            'width': thumb_total_size + 'px',
	            'height': thumb_total_size + 'px',
	            'border-radius': thumb_total_size + 'px',
	            'background-color': this.style_vals.bg_actions,
	            'opacity': '0.5'
	        },
	        '#thumbnail': {
	            'position': 'absolute',
	            'top': '0px',
	            'left': (MixpanelNotification.NOTIF_WIDTH / 2 - MixpanelNotification.THUMB_OFFSET) + 'px',
	            'width': MixpanelNotification.THUMB_IMG_SIZE + 'px',
	            'height': MixpanelNotification.THUMB_IMG_SIZE + 'px',
	            'overflow': 'hidden',
	            'z-index': '100',
	            'border-radius': MixpanelNotification.THUMB_IMG_SIZE + 'px'
	        },
	        '#mini': {
	            'position': 'absolute',
	            'right': '20px',
	            'top': MixpanelNotification.NOTIF_TOP + 'px',
	            'width': this.notif_width + 'px',
	            'height': MixpanelNotification.NOTIF_HEIGHT_MINI * 2 + 'px',
	            'margin-top': 20 - MixpanelNotification.NOTIF_HEIGHT_MINI + 'px',
	            'backface-visibility': 'hidden',
	            'opacity': '0.0',
	            'transform': 'rotateX(90deg)',
	            'transition': 'opacity 0.3s, transform 0.3s, right 0.3s'
	        },
	        '#mini.visible': {
	            'opacity': '1.0',
	            'transform': 'rotateX(0deg)'
	        },
	        '#mini.exiting': {
	            'opacity': '0.0',
	            'right': '-150px'
	        },
	        '#mainbox': {
	            'border-radius': '4px',
	            'box-shadow': shadow,
	            'text-align': 'center',
	            'background-color': this.style_vals.bg,
	            'font-size': '14px',
	            'color': this.style_vals.text_main
	        },
	        '#mini #mainbox': {
	            'height': MixpanelNotification.NOTIF_HEIGHT_MINI + 'px',
	            'margin-top': MixpanelNotification.NOTIF_HEIGHT_MINI + 'px',
	            'border-radius': '3px',
	            'transition': 'background-color ' + anim_seconds
	        },
	        '#mini-border': {
	            'height': (MixpanelNotification.NOTIF_HEIGHT_MINI + 6) + 'px',
	            'width': (MixpanelNotification.NOTIF_WIDTH_MINI + 6) + 'px',
	            'position': 'absolute',
	            'top': '-3px',
	            'left': '-3px',
	            'margin-top': MixpanelNotification.NOTIF_HEIGHT_MINI + 'px',
	            'border-radius': '6px',
	            'opacity': '0.25',
	            'background-color': '#fff',
	            'z-index': '-1',
	            'box-shadow': mini_shadow
	        },
	        '#mini-icon': {
	            'position': 'relative',
	            'display': 'inline-block',
	            'width': '75px',
	            'height': MixpanelNotification.NOTIF_HEIGHT_MINI + 'px',
	            'border-radius': '3px 0 0 3px',
	            'background-color': this.style_vals.bg_actions,
	            'background': 'linear-gradient(135deg, ' + this.style_vals.bg_light + ' 0%, ' + this.style_vals.bg_actions + ' 100%)',
	            'transition': 'background-color ' + anim_seconds
	        },
	        '#mini:hover #mini-icon': {
	            'background-color': this.style_vals.mini_hover
	        },
	        '#mini:hover #mainbox': {
	            'background-color': this.style_vals.mini_hover
	        },
	        '#mini-icon-img': {
	            'position': 'absolute',
	            'background-image': 'url(' + this.thumb_image_url + ')',
	            'width': '48px',
	            'height': '48px',
	            'top': '20px',
	            'left': '12px'
	        },
	        '#content': {
	            'padding': '30px 20px 0px 20px'
	        },
	        '#mini-content': {
	            'text-align': 'left',
	            'height': MixpanelNotification.NOTIF_HEIGHT_MINI + 'px',
	            'cursor': 'pointer'
	        },
	        '#img': {
	            'width': '328px',
	            'margin-top': '30px',
	            'border-radius': '5px'
	        },
	        '#title': {
	            'max-height': '600px',
	            'overflow': 'hidden',
	            'word-wrap': 'break-word',
	            'padding': '25px 0px 20px 0px',
	            'font-size': '19px',
	            'font-weight': 'bold',
	            'color': this.style_vals.text_title
	        },
	        '#body': {
	            'max-height': '600px',
	            'margin-bottom': '25px',
	            'overflow': 'hidden',
	            'word-wrap': 'break-word',
	            'line-height': '21px',
	            'font-size': '15px',
	            'font-weight': 'normal',
	            'text-align': 'left'
	        },
	        '#mini #body': {
	            'display': 'inline-block',
	            'max-width': '250px',
	            'margin': '0 0 0 30px',
	            'height': MixpanelNotification.NOTIF_HEIGHT_MINI + 'px',
	            'font-size': '16px',
	            'letter-spacing': '0.8px',
	            'color': this.style_vals.text_title
	        },
	        '#mini #body-text': {
	            'display': 'table',
	            'height': MixpanelNotification.NOTIF_HEIGHT_MINI + 'px'
	        },
	        '#mini #body-text div': {
	            'display': 'table-cell',
	            'vertical-align': 'middle'
	        },
	        '#tagline': {
	            'margin-bottom': '15px',
	            'font-size': '10px',
	            'font-weight': '600',
	            'letter-spacing': '0.8px',
	            'color': '#ccd7e0',
	            'text-align': 'left'
	        },
	        '#tagline a': {
	            'color': this.style_vals.text_tagline,
	            'transition': 'color ' + anim_seconds
	        },
	        '#tagline a:hover': {
	            'color': this.style_vals.text_hover
	        },
	        '#cancel': {
	            'position': 'absolute',
	            'right': '0',
	            'width': '8px',
	            'height': '8px',
	            'padding': '10px',
	            'border-radius': '20px',
	            'margin': '12px 12px 0 0',
	            'box-sizing': 'content-box',
	            'cursor': 'pointer',
	            'transition': 'background-color ' + anim_seconds
	        },
	        '#mini #cancel': {
	            'margin': '7px 7px 0 0'
	        },
	        '#cancel-icon': {
	            'width': '8px',
	            'height': '8px',
	            'overflow': 'hidden',
	            'background-image': 'url(' + this.cdn_host + '/site_media/images/icons/notifications/cancel-x.png)',
	            'opacity': this.style_vals.cancel_opacity
	        },
	        '#cancel:hover': {
	            'background-color': this.style_vals.bg_hover
	        },
	        '#button': {
	            'display': 'block',
	            'height': '60px',
	            'line-height': '60px',
	            'text-align': 'center',
	            'background-color': this.style_vals.bg_actions,
	            'border-radius': '0 0 4px 4px',
	            'overflow': 'hidden',
	            'cursor': 'pointer',
	            'transition': 'background-color ' + anim_seconds
	        },
	        '#button-close': {
	            'display': 'inline-block',
	            'width': '9px',
	            'height': '60px',
	            'margin-right': '8px',
	            'vertical-align': 'top',
	            'background-image': 'url(' + this.cdn_host + '/site_media/images/icons/notifications/close-x-' + this.style + '.png)',
	            'background-repeat': 'no-repeat',
	            'background-position': '0px 25px'
	        },
	        '#button-play': {
	            'display': 'inline-block',
	            'width': '30px',
	            'height': '60px',
	            'margin-left': '15px',
	            'background-image': 'url(' + this.cdn_host + '/site_media/images/icons/notifications/play-' + this.style + '-small.png)',
	            'background-repeat': 'no-repeat',
	            'background-position': '0px 15px'
	        },
	        'a#button-link': {
	            'display': 'inline-block',
	            'vertical-align': 'top',
	            'text-align': 'center',
	            'font-size': '17px',
	            'font-weight': 'bold',
	            'overflow': 'hidden',
	            'word-wrap': 'break-word',
	            'color': this.style_vals.text_title,
	            'transition': 'color ' + anim_seconds
	        },
	        '#button:hover': {
	            'background-color': this.style_vals.bg_hover,
	            'color': this.style_vals.text_hover
	        },
	        '#button:hover a': {
	            'color': this.style_vals.text_hover
	        },
	
	        '#video-noflip': {
	            'position': 'relative',
	            'top': (-this.video_height * 2) + 'px'
	        },
	        '#video-flip': {
	            'backface-visibility': 'hidden',
	            'transform': 'rotateY(180deg)'
	        },
	        '#video': {
	            'position': 'absolute',
	            'width': (this.video_width - 1) + 'px',
	            'height': this.video_height + 'px',
	            'top': MixpanelNotification.NOTIF_TOP + 'px',
	            'margin-top': '100px',
	            'left': '50%',
	            'margin-left': Math.round(-this.video_width / 2) + 'px',
	            'overflow': 'hidden',
	            'border-radius': '5px',
	            'box-shadow': video_shadow,
	            'transform': 'translateZ(1px)', // webkit rendering bug http://stackoverflow.com/questions/18167981/clickable-link-area-unexpectedly-smaller-after-css-transform
	            'transition': 'opacity ' + anim_seconds + ', top ' + anim_seconds
	        },
	        '#video.exiting': {
	            'opacity': '0.0',
	            'top': this.video_height + 'px'
	        },
	        '#video-holder': {
	            'position': 'absolute',
	            'width': (this.video_width - 1) + 'px',
	            'height': this.video_height + 'px',
	            'overflow': 'hidden',
	            'border-radius': '5px'
	        },
	        '#video-frame': {
	            'margin-left': '-1px',
	            'width': this.video_width + 'px'
	        },
	        '#video-controls': {
	            'opacity': '0',
	            'transition': 'opacity 0.5s'
	        },
	        '#video:hover #video-controls': {
	            'opacity': '1.0'
	        },
	        '#video .video-progress-el': {
	            'position': 'absolute',
	            'bottom': '0',
	            'height': '25px',
	            'border-radius': '0 0 0 5px'
	        },
	        '#video-progress': {
	            'width': '90%'
	        },
	        '#video-progress-total': {
	            'width': '100%',
	            'background-color': this.style_vals.bg,
	            'opacity': '0.7'
	        },
	        '#video-elapsed': {
	            'width': '0',
	            'background-color': '#6cb6f5',
	            'opacity': '0.9'
	        },
	        '#video #video-time': {
	            'width': '10%',
	            'right': '0',
	            'font-size': '11px',
	            'line-height': '25px',
	            'color': this.style_vals.text_main,
	            'background-color': '#666',
	            'border-radius': '0 0 5px 0'
	        }
	    };
	
	    // IE hacks
	    if (this._browser_lte('ie', 8)) {
	        _.extend(notif_styles, {
	            '* html #overlay': {
	                'position': 'absolute'
	            },
	            '* html #bg': {
	                'position': 'absolute'
	            },
	            'html, body': {
	                'height': '100%'
	            }
	        });
	    }
	    if (this._browser_lte('ie', 7)) {
	        _.extend(notif_styles, {
	            '#mini #body': {
	                'display': 'inline',
	                'zoom': '1',
	                'border': '1px solid ' + this.style_vals.bg_hover
	            },
	            '#mini #body-text': {
	                'padding': '20px'
	            },
	            '#mini #mini-icon': {
	                'display': 'none'
	            }
	        });
	    }
	
	    // add vendor-prefixed style rules
	    var VENDOR_STYLES = [
	            'backface-visibility', 'border-radius', 'box-shadow', 'opacity',
	            'perspective', 'transform', 'transform-style', 'transition'
	        ],
	        VENDOR_PREFIXES = ['khtml', 'moz', 'ms', 'o', 'webkit'];
	    for (var selector in notif_styles) {
	        for (var si = 0; si < VENDOR_STYLES.length; si++) {
	            var prop = VENDOR_STYLES[si];
	            if (prop in notif_styles[selector]) {
	                var val = notif_styles[selector][prop];
	                for (var pi = 0; pi < VENDOR_PREFIXES.length; pi++) {
	                    notif_styles[selector]['-' + VENDOR_PREFIXES[pi] + '-' + prop] = val;
	                }
	            }
	        }
	    }
	
	    var inject_styles = function(styles, media_queries) {
	        var create_style_text = function(style_defs) {
	            var st = '';
	            for (var selector in style_defs) {
	                var mp_selector = selector
	                    .replace(/#/g, '#' + MixpanelNotification.MARKUP_PREFIX + '-')
	                    .replace(/\./g, '.' + MixpanelNotification.MARKUP_PREFIX + '-');
	                st += '\n' + mp_selector + ' {';
	                var props = style_defs[selector];
	                for (var k in props) {
	                    st += k + ':' + props[k] + ';';
	                }
	                st += '}';
	            }
	            return st;
	        };
	        var create_media_query_text = function(mq_defs) {
	            var mqt = '';
	            for (var mq in mq_defs) {
	                mqt += '\n' + mq + ' {' + create_style_text(mq_defs[mq]) + '\n}';
	            }
	            return mqt;
	        };
	
	        var style_text = create_style_text(styles) + create_media_query_text(media_queries),
	            head_el = document.head || document.getElementsByTagName('head')[0] || document.documentElement,
	            style_el = document.createElement('style');
	        head_el.appendChild(style_el);
	        style_el.setAttribute('type', 'text/css');
	        if (style_el.styleSheet) { // IE
	            style_el.styleSheet.cssText = style_text;
	        } else {
	            style_el.textContent = style_text;
	        }
	    };
	    inject_styles(notif_styles, notif_media_queries);
	};
	
	MixpanelNotification.prototype._init_video = _.safewrap(function() {
	    if (!this.video_url) {
	        return;
	    }
	    var self = this;
	
	    // Youtube iframe API compatibility
	    self.yt_custom = 'postMessage' in window;
	
	    self.dest_url = self.video_url;
	    var youtube_match = self.video_url.match(
	            // http://stackoverflow.com/questions/2936467/parse-youtube-video-id-using-preg-match
	            /(?:youtube(?:-nocookie)?\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/ ]{11})/i
	        ),
	        vimeo_match = self.video_url.match(
	            /vimeo\.com\/.*?(\d+)/i
	        );
	    if (youtube_match) {
	        self.show_video = true;
	        self.youtube_video = youtube_match[1];
	
	        if (self.yt_custom) {
	            window['onYouTubeIframeAPIReady'] = function() {
	                if (self._get_el('video-frame')) {
	                    self._yt_video_ready();
	                }
	            };
	
	            // load Youtube iframe API; see https://developers.google.com/youtube/iframe_api_reference
	            var tag = document.createElement('script');
	            tag.src = self.resource_protocol + 'www.youtube.com/iframe_api';
	            var firstScriptTag = document.getElementsByTagName('script')[0];
	            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	        }
	    } else if (vimeo_match) {
	        self.show_video = true;
	        self.vimeo_video = vimeo_match[1];
	    }
	
	    // IE <= 7, FF <= 3: fall through to video link rather than embedded player
	    if (self._browser_lte('ie', 7) || self._browser_lte('firefox', 3)) {
	        self.show_video = false;
	        self.clickthrough = true;
	    }
	});
	
	MixpanelNotification.prototype._mark_as_shown = _.safewrap(function() {
	    // click on background to dismiss
	    var self = this;
	    _.register_event(self._get_el('bg'), 'click', function() {
	        self.dismiss();
	    });
	
	    var get_style = function(el, style_name) {
	        var styles = {};
	        if (document.defaultView && document.defaultView.getComputedStyle) {
	            styles = document.defaultView.getComputedStyle(el, null); // FF3 requires both args
	        } else if (el.currentStyle) { // IE
	            styles = el.currentStyle;
	        }
	        return styles[style_name];
	    };
	
	    if (this.campaign_id) {
	        var notif_el = this._get_el('overlay');
	        if (notif_el && get_style(notif_el, 'visibility') !== 'hidden' && get_style(notif_el, 'display') !== 'none') {
	            this._mark_delivery();
	        }
	    }
	});
	
	MixpanelNotification.prototype._mark_delivery = _.safewrap(function(extra_props) {
	    if (!this.marked_as_shown) {
	        this.marked_as_shown = true;
	
	        if (this.campaign_id) {
	            // mark notification shown (local cache)
	            this._get_shown_campaigns()[this.campaign_id] = 1 * new Date();
	            this.persistence.save();
	        }
	
	        // track delivery
	        this._track_event('$campaign_delivery', extra_props);
	
	        // mark notification shown (mixpanel property)
	        this.mixpanel['people']['append']({
	            '$campaigns': this.campaign_id,
	            '$notifications': {
	                'campaign_id': this.campaign_id,
	                'message_id':  this.message_id,
	                'type':        'web',
	                'time':        new Date()
	            }
	        });
	    }
	});
	
	MixpanelNotification.prototype._preload_images = function(all_loaded_cb) {
	    var self = this;
	    if (this.imgs_to_preload.length === 0) {
	        all_loaded_cb();
	        return;
	    }
	
	    var preloaded_imgs = 0;
	    var img_objs = [];
	    var onload = function() {
	        preloaded_imgs++;
	        if (preloaded_imgs === self.imgs_to_preload.length && all_loaded_cb) {
	            all_loaded_cb();
	            all_loaded_cb = null;
	        }
	    };
	    for (var i = 0; i < this.imgs_to_preload.length; i++) {
	        var img = new Image();
	        img.onload = onload;
	        img.src = this.imgs_to_preload[i];
	        if (img.complete) {
	            onload();
	        }
	        img_objs.push(img);
	    }
	
	    // IE6/7 doesn't fire onload reliably
	    if (this._browser_lte('ie', 7)) {
	        setTimeout(function() {
	            var imgs_loaded = true;
	            for (i = 0; i < img_objs.length; i++) {
	                if (!img_objs[i].complete) {
	                    imgs_loaded = false;
	                }
	            }
	            if (imgs_loaded && all_loaded_cb) {
	                all_loaded_cb();
	                all_loaded_cb = null;
	            }
	        }, 500);
	    }
	};
	
	MixpanelNotification.prototype._remove_notification_el = _.safewrap(function() {
	    window.clearInterval(this._video_progress_checker);
	    this.notification_el.style.visibility = 'hidden';
	    this.body_el.removeChild(this.notification_el);
	});
	
	MixpanelNotification.prototype._set_client_config = function() {
	    var get_browser_version = function(browser_ex) {
	        var match = navigator.userAgent.match(browser_ex);
	        return match && match[1];
	    };
	    this.browser_versions = {};
	    this.browser_versions['chrome']  = get_browser_version(/Chrome\/(\d+)/);
	    this.browser_versions['firefox'] = get_browser_version(/Firefox\/(\d+)/);
	    this.browser_versions['ie']      = get_browser_version(/MSIE (\d+).+/);
	    if (!this.browser_versions['ie'] && !(window.ActiveXObject) && 'ActiveXObject' in window) {
	        this.browser_versions['ie'] = 11;
	    }
	
	    this.body_el = document.body || document.getElementsByTagName('body')[0];
	    if (this.body_el) {
	        this.doc_width = Math.max(
	            this.body_el.scrollWidth, document.documentElement.scrollWidth,
	            this.body_el.offsetWidth, document.documentElement.offsetWidth,
	            this.body_el.clientWidth, document.documentElement.clientWidth
	        );
	        this.doc_height = Math.max(
	            this.body_el.scrollHeight, document.documentElement.scrollHeight,
	            this.body_el.offsetHeight, document.documentElement.offsetHeight,
	            this.body_el.clientHeight, document.documentElement.clientHeight
	        );
	    }
	
	    // detect CSS compatibility
	    var ie_ver = this.browser_versions['ie'];
	    var sample_styles = document.createElement('div').style,
	        is_css_compatible = function(rule) {
	            if (rule in sample_styles) {
	                return true;
	            }
	            if (!ie_ver) {
	                rule = rule[0].toUpperCase() + rule.slice(1);
	                var props = ['O' + rule, 'Webkit' + rule, 'Moz' + rule];
	                for (var i = 0; i < props.length; i++) {
	                    if (props[i] in sample_styles) {
	                        return true;
	                    }
	                }
	            }
	            return false;
	        };
	    this.use_transitions = this.body_el &&
	        is_css_compatible('transition') &&
	        is_css_compatible('transform');
	    this.flip_animate = (this.browser_versions['chrome'] >= 33 || this.browser_versions['firefox'] >= 15) &&
	        this.body_el &&
	        is_css_compatible('backfaceVisibility') &&
	        is_css_compatible('perspective') &&
	        is_css_compatible('transform');
	};
	
	MixpanelNotification.prototype._switch_to_video = _.safewrap(function() {
	    var self = this,
	        anims = [
	            {
	                el:    self._get_notification_display_el(),
	                attr:  'opacity',
	                start: 1.0,
	                goal:  0.0
	            },
	            {
	                el:    self._get_notification_display_el(),
	                attr:  'top',
	                start: MixpanelNotification.NOTIF_TOP,
	                goal:  -500
	            },
	            {
	                el:    self._get_el('video-noflip'),
	                attr:  'opacity',
	                start: 0.0,
	                goal:  1.0
	            },
	            {
	                el:    self._get_el('video-noflip'),
	                attr:  'top',
	                start: -self.video_height * 2,
	                goal:  0
	            }
	        ];
	
	    if (self.mini) {
	        var bg = self._get_el('bg'),
	            overlay = self._get_el('overlay');
	        bg.style.width = '100%';
	        bg.style.height = '100%';
	        overlay.style.width = '100%';
	
	        self._add_class(self._get_notification_display_el(), 'exiting');
	        self._add_class(bg, 'visible');
	
	        anims.push({
	            el:    self._get_el('bg'),
	            attr:  'opacity',
	            start: 0.0,
	            goal:  MixpanelNotification.BG_OPACITY
	        });
	    }
	
	    var video_el = self._get_el('video-holder');
	    video_el.innerHTML = self.video_iframe;
	
	    var video_ready = function() {
	        if (window['YT'] && window['YT']['loaded']) {
	            self._yt_video_ready();
	        }
	        self.showing_video = true;
	        self._get_notification_display_el().style.visibility = 'hidden';
	    };
	    if (self.flip_animate) {
	        self._add_class('flipper', 'flipped');
	        setTimeout(video_ready, MixpanelNotification.ANIM_TIME);
	    } else {
	        self._animate_els(anims, MixpanelNotification.ANIM_TIME, video_ready);
	    }
	});
	
	MixpanelNotification.prototype._track_event = function(event_name, properties, cb) {
	    if (this.campaign_id) {
	        properties = properties || {};
	        properties = _.extend(properties, {
	            'campaign_id':     this.campaign_id,
	            'message_id':      this.message_id,
	            'message_type':    'web_inapp',
	            'message_subtype': this.notif_type
	        });
	        this.mixpanel['track'](event_name, properties, cb);
	    } else if (cb) {
	        cb.call();
	    }
	};
	
	MixpanelNotification.prototype._yt_video_ready = _.safewrap(function() {
	    var self = this;
	    if (self.video_inited) {
	        return;
	    }
	    self.video_inited = true;
	
	    var progress_bar  = self._get_el('video-elapsed'),
	        progress_time = self._get_el('video-time'),
	        progress_el   = self._get_el('video-progress');
	
	    new window['YT']['Player'](MixpanelNotification.MARKUP_PREFIX + '-video-frame', {
	        'events': {
	            'onReady': function(event) {
	                var ytplayer = event['target'],
	                    video_duration = ytplayer['getDuration'](),
	                    pad = function(i) {
	                        return ('00' + i).slice(-2);
	                    },
	                    update_video_time = function(current_time) {
	                        var secs = Math.round(video_duration - current_time),
	                            mins = Math.floor(secs / 60),
	                            hours = Math.floor(mins / 60);
	                        secs -= mins * 60;
	                        mins -= hours * 60;
	                        progress_time.innerHTML = '-' + (hours ? hours + ':' : '') + pad(mins) + ':' + pad(secs);
	                    };
	                update_video_time(0);
	                self._video_progress_checker = window.setInterval(function() {
	                    var current_time = ytplayer['getCurrentTime']();
	                    progress_bar.style.width = (current_time / video_duration * 100) + '%';
	                    update_video_time(current_time);
	                }, 250);
	                _.register_event(progress_el, 'click', function(e) {
	                    var clickx = Math.max(0, e.pageX - progress_el.getBoundingClientRect().left);
	                    ytplayer['seekTo'](video_duration * clickx / progress_el.clientWidth, true);
	                });
	            }
	        }
	    });
	});
	
	/**
	 * Mixpanel People Object
	 * @constructor
	 */
	var MixpanelPeople = function() {};
	
	_.extend(MixpanelPeople.prototype, apiActions);
	
	MixpanelPeople.prototype._init = function(mixpanel_instance) {
	    this._mixpanel = mixpanel_instance;
	};
	
	/*
	* Set properties on a user record.
	*
	* ### Usage:
	*
	*     mixpanel.people.set('gender', 'm');
	*
	*     // or set multiple properties at once
	*     mixpanel.people.set({
	*         'Company': 'Acme',
	*         'Plan': 'Premium',
	*         'Upgrade date': new Date()
	*     });
	*     // properties can be strings, integers, dates, or lists
	*
	* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
	* @param {*} [to] A value to set on the given property name
	* @param {Function} [callback] If provided, the callback will be called after tracking the event.
	*/
	MixpanelPeople.prototype.set = addOptOutCheckMixpanelPeople(function(prop, to, callback) {
	    var data = this.set_action(prop, to);
	    if (_.isObject(prop)) {
	        callback = to;
	    }
	    // make sure that the referrer info has been updated and saved
	    if (this._get_config('save_referrer')) {
	        this._mixpanel['persistence'].update_referrer_info(document.referrer);
	    }
	
	    // update $set object with default people properties
	    data[SET_ACTION] = _.extend(
	        {},
	        _.info.people_properties(),
	        this._mixpanel['persistence'].get_referrer_info(),
	        data[SET_ACTION]
	    );
	    return this._send_request(data, callback);
	});
	
	/*
	* Set properties on a user record, only if they do not yet exist.
	* This will not overwrite previous people property values, unlike
	* people.set().
	*
	* ### Usage:
	*
	*     mixpanel.people.set_once('First Login Date', new Date());
	*
	*     // or set multiple properties at once
	*     mixpanel.people.set_once({
	*         'First Login Date': new Date(),
	*         'Starting Plan': 'Premium'
	*     });
	*
	*     // properties can be strings, integers or dates
	*
	* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
	* @param {*} [to] A value to set on the given property name
	* @param {Function} [callback] If provided, the callback will be called after tracking the event.
	*/
	MixpanelPeople.prototype.set_once = addOptOutCheckMixpanelPeople(function(prop, to, callback) {
	    var data = this.set_once_action(prop, to);
	    if (_.isObject(prop)) {
	        callback = to;
	    }
	    return this._send_request(data, callback);
	});
	
	/*
	* Unset properties on a user record (permanently removes the properties and their values from a profile).
	*
	* ### Usage:
	*
	*     mixpanel.people.unset('gender');
	*
	*     // or unset multiple properties at once
	*     mixpanel.people.unset(['gender', 'Company']);
	*
	* @param {Array|String} prop If a string, this is the name of the property. If an array, this is a list of property names.
	* @param {Function} [callback] If provided, the callback will be called after tracking the event.
	*/
	MixpanelPeople.prototype.unset = addOptOutCheckMixpanelPeople(function(prop, callback) {
	    var data = this.unset_action(prop);
	    return this._send_request(data, callback);
	});
	
	/*
	* Increment/decrement numeric people analytics properties.
	*
	* ### Usage:
	*
	*     mixpanel.people.increment('page_views', 1);
	*
	*     // or, for convenience, if you're just incrementing a counter by
	*     // 1, you can simply do
	*     mixpanel.people.increment('page_views');
	*
	*     // to decrement a counter, pass a negative number
	*     mixpanel.people.increment('credits_left', -1);
	*
	*     // like mixpanel.people.set(), you can increment multiple
	*     // properties at once:
	*     mixpanel.people.increment({
	*         counter1: 1,
	*         counter2: 6
	*     });
	*
	* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and numeric values.
	* @param {Number} [by] An amount to increment the given property
	* @param {Function} [callback] If provided, the callback will be called after tracking the event.
	*/
	MixpanelPeople.prototype.increment = addOptOutCheckMixpanelPeople(function(prop, by, callback) {
	    var data = {};
	    var $add = {};
	    if (_.isObject(prop)) {
	        _.each(prop, function(v, k) {
	            if (!this._is_reserved_property(k)) {
	                if (isNaN(parseFloat(v))) {
	                    console.error('Invalid increment value passed to mixpanel.people.increment - must be a number');
	                    return;
	                } else {
	                    $add[k] = v;
	                }
	            }
	        }, this);
	        callback = by;
	    } else {
	        // convenience: mixpanel.people.increment('property'); will
	        // increment 'property' by 1
	        if (_.isUndefined(by)) {
	            by = 1;
	        }
	        $add[prop] = by;
	    }
	    data[ADD_ACTION] = $add;
	
	    return this._send_request(data, callback);
	});
	
	/*
	* Append a value to a list-valued people analytics property.
	*
	* ### Usage:
	*
	*     // append a value to a list, creating it if needed
	*     mixpanel.people.append('pages_visited', 'homepage');
	*
	*     // like mixpanel.people.set(), you can append multiple
	*     // properties at once:
	*     mixpanel.people.append({
	*         list1: 'bob',
	*         list2: 123
	*     });
	*
	* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
	* @param {*} [value] value An item to append to the list
	* @param {Function} [callback] If provided, the callback will be called after tracking the event.
	*/
	MixpanelPeople.prototype.append = addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
	    if (_.isObject(list_name)) {
	        callback = value;
	    }
	    var data = this.append_action(list_name, value);
	    return this._send_request(data, callback);
	});
	
	/*
	* Remove a value from a list-valued people analytics property.
	*
	* ### Usage:
	*
	*     mixpanel.people.remove('School', 'UCB');
	*
	* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
	* @param {*} [value] value Item to remove from the list
	* @param {Function} [callback] If provided, the callback will be called after tracking the event.
	*/
	MixpanelPeople.prototype.remove = addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
	    if (_.isObject(list_name)) {
	        callback = value;
	    }
	    var data = this.remove_action(list_name, value);
	    return this._send_request(data, callback);
	});
	
	/*
	* Merge a given list with a list-valued people analytics property,
	* excluding duplicate values.
	*
	* ### Usage:
	*
	*     // merge a value to a list, creating it if needed
	*     mixpanel.people.union('pages_visited', 'homepage');
	*
	*     // like mixpanel.people.set(), you can append multiple
	*     // properties at once:
	*     mixpanel.people.union({
	*         list1: 'bob',
	*         list2: 123
	*     });
	*
	*     // like mixpanel.people.append(), you can append multiple
	*     // values to the same list:
	*     mixpanel.people.union({
	*         list1: ['bob', 'billy']
	*     });
	*
	* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
	* @param {*} [value] Value / values to merge with the given property
	* @param {Function} [callback] If provided, the callback will be called after tracking the event.
	*/
	MixpanelPeople.prototype.union = addOptOutCheckMixpanelPeople(function(list_name, values, callback) {
	    if (_.isObject(list_name)) {
	        callback = values;
	    }
	    var data = this.union_action(list_name, values);
	    return this._send_request(data, callback);
	});
	
	/*
	* Record that you have charged the current user a certain amount
	* of money. Charges recorded with track_charge() will appear in the
	* Mixpanel revenue report.
	*
	* ### Usage:
	*
	*     // charge a user $50
	*     mixpanel.people.track_charge(50);
	*
	*     // charge a user $30.50 on the 2nd of january
	*     mixpanel.people.track_charge(30.50, {
	*         '$time': new Date('jan 1 2012')
	*     });
	*
	* @param {Number} amount The amount of money charged to the current user
	* @param {Object} [properties] An associative array of properties associated with the charge
	* @param {Function} [callback] If provided, the callback will be called when the server responds
	*/
	MixpanelPeople.prototype.track_charge = addOptOutCheckMixpanelPeople(function(amount, properties, callback) {
	    if (!_.isNumber(amount)) {
	        amount = parseFloat(amount);
	        if (isNaN(amount)) {
	            console.error('Invalid value passed to mixpanel.people.track_charge - must be a number');
	            return;
	        }
	    }
	
	    return this.append('$transactions', _.extend({
	        '$amount': amount
	    }, properties), callback);
	});
	
	/*
	* Permanently clear all revenue report transactions from the
	* current user's people analytics profile.
	*
	* ### Usage:
	*
	*     mixpanel.people.clear_charges();
	*
	* @param {Function} [callback] If provided, the callback will be called after tracking the event.
	*/
	MixpanelPeople.prototype.clear_charges = function(callback) {
	    return this.set('$transactions', [], callback);
	};
	
	/*
	* Permanently deletes the current people analytics profile from
	* Mixpanel (using the current distinct_id).
	*
	* ### Usage:
	*
	*     // remove the all data you have stored about the current user
	*     mixpanel.people.delete_user();
	*
	*/
	MixpanelPeople.prototype.delete_user = function() {
	    if (!this._identify_called()) {
	        console.error('mixpanel.people.delete_user() requires you to call identify() first');
	        return;
	    }
	    var data = {'$delete': this._mixpanel.get_distinct_id()};
	    return this._send_request(data);
	};
	
	MixpanelPeople.prototype.toString = function() {
	    return this._mixpanel.toString() + '.people';
	};
	
	MixpanelPeople.prototype._send_request = function(data, callback) {
	    data['$token'] = this._get_config('token');
	    data['$distinct_id'] = this._mixpanel.get_distinct_id();
	    var device_id = this._mixpanel.get_property('$device_id');
	    var user_id = this._mixpanel.get_property('$user_id');
	    var had_persisted_distinct_id = this._mixpanel.get_property('$had_persisted_distinct_id');
	    if (device_id) {
	        data['$device_id'] = device_id;
	    }
	    if (user_id) {
	        data['$user_id'] = user_id;
	    }
	    if (had_persisted_distinct_id) {
	        data['$had_persisted_distinct_id'] = had_persisted_distinct_id;
	    }
	
	    var date_encoded_data = _.encodeDates(data);
	
	    if (!this._identify_called()) {
	        this._enqueue(data);
	        if (!_.isUndefined(callback)) {
	            if (this._get_config('verbose')) {
	                callback({status: -1, error: null});
	            } else {
	                callback(-1);
	            }
	        }
	        return _.truncate(date_encoded_data, 255);
	    }
	
	    return this._mixpanel._track_or_batch({
	        type: 'people',
	        data: date_encoded_data,
	        endpoint: this._get_config('api_host') + '/engage/',
	        batcher: this._mixpanel.request_batchers.people
	    }, callback);
	};
	
	MixpanelPeople.prototype._get_config = function(conf_var) {
	    return this._mixpanel.get_config(conf_var);
	};
	
	MixpanelPeople.prototype._identify_called = function() {
	    return this._mixpanel._flags.identify_called === true;
	};
	
	// Queue up engage operations if identify hasn't been called yet.
	MixpanelPeople.prototype._enqueue = function(data) {
	    if (SET_ACTION in data) {
	        this._mixpanel['persistence']._add_to_people_queue(SET_ACTION, data);
	    } else if (SET_ONCE_ACTION in data) {
	        this._mixpanel['persistence']._add_to_people_queue(SET_ONCE_ACTION, data);
	    } else if (UNSET_ACTION in data) {
	        this._mixpanel['persistence']._add_to_people_queue(UNSET_ACTION, data);
	    } else if (ADD_ACTION in data) {
	        this._mixpanel['persistence']._add_to_people_queue(ADD_ACTION, data);
	    } else if (APPEND_ACTION in data) {
	        this._mixpanel['persistence']._add_to_people_queue(APPEND_ACTION, data);
	    } else if (REMOVE_ACTION in data) {
	        this._mixpanel['persistence']._add_to_people_queue(REMOVE_ACTION, data);
	    } else if (UNION_ACTION in data) {
	        this._mixpanel['persistence']._add_to_people_queue(UNION_ACTION, data);
	    } else {
	        console.error('Invalid call to _enqueue():', data);
	    }
	};
	
	MixpanelPeople.prototype._flush_one_queue = function(action, action_method, callback, queue_to_params_fn) {
	    var _this = this;
	    var queued_data = _.extend({}, this._mixpanel['persistence']._get_queue(action));
	    var action_params = queued_data;
	
	    if (!_.isUndefined(queued_data) && _.isObject(queued_data) && !_.isEmptyObject(queued_data)) {
	        _this._mixpanel['persistence']._pop_from_people_queue(action, queued_data);
	        if (queue_to_params_fn) {
	            action_params = queue_to_params_fn(queued_data);
	        }
	        action_method.call(_this, action_params, function(response, data) {
	            // on bad response, we want to add it back to the queue
	            if (response === 0) {
	                _this._mixpanel['persistence']._add_to_people_queue(action, queued_data);
	            }
	            if (!_.isUndefined(callback)) {
	                callback(response, data);
	            }
	        });
	    }
	};
	
	// Flush queued engage operations - order does not matter,
	// and there are network level race conditions anyway
	MixpanelPeople.prototype._flush = function(
	    _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback
	) {
	    var _this = this;
	    var $append_queue = this._mixpanel['persistence']._get_queue(APPEND_ACTION);
	    var $remove_queue = this._mixpanel['persistence']._get_queue(REMOVE_ACTION);
	
	    this._flush_one_queue(SET_ACTION, this.set, _set_callback);
	    this._flush_one_queue(SET_ONCE_ACTION, this.set_once, _set_once_callback);
	    this._flush_one_queue(UNSET_ACTION, this.unset, _unset_callback, function(queue) { return _.keys(queue); });
	    this._flush_one_queue(ADD_ACTION, this.increment, _add_callback);
	    this._flush_one_queue(UNION_ACTION, this.union, _union_callback);
	
	    // we have to fire off each $append individually since there is
	    // no concat method server side
	    if (!_.isUndefined($append_queue) && _.isArray($append_queue) && $append_queue.length) {
	        var $append_item;
	        var append_callback = function(response, data) {
	            if (response === 0) {
	                _this._mixpanel['persistence']._add_to_people_queue(APPEND_ACTION, $append_item);
	            }
	            if (!_.isUndefined(_append_callback)) {
	                _append_callback(response, data);
	            }
	        };
	        for (var i = $append_queue.length - 1; i >= 0; i--) {
	            $append_item = $append_queue.pop();
	            if (!_.isEmptyObject($append_item)) {
	                _this.append($append_item, append_callback);
	            }
	        }
	        // Save the shortened append queue
	        _this._mixpanel['persistence'].save();
	    }
	
	    // same for $remove
	    if (!_.isUndefined($remove_queue) && _.isArray($remove_queue) && $remove_queue.length) {
	        var $remove_item;
	        var remove_callback = function(response, data) {
	            if (response === 0) {
	                _this._mixpanel['persistence']._add_to_people_queue(REMOVE_ACTION, $remove_item);
	            }
	            if (!_.isUndefined(_remove_callback)) {
	                _remove_callback(response, data);
	            }
	        };
	        for (var j = $remove_queue.length - 1; j >= 0; j--) {
	            $remove_item = $remove_queue.pop();
	            if (!_.isEmptyObject($remove_item)) {
	                _this.remove($remove_item, remove_callback);
	            }
	        }
	        _this._mixpanel['persistence'].save();
	    }
	};
	
	MixpanelPeople.prototype._is_reserved_property = function(prop) {
	    return prop === '$distinct_id' || prop === '$token' || prop === '$device_id' || prop === '$user_id' || prop === '$had_persisted_distinct_id';
	};
	
	// MixpanelPeople Exports
	MixpanelPeople.prototype['set']           = MixpanelPeople.prototype.set;
	MixpanelPeople.prototype['set_once']      = MixpanelPeople.prototype.set_once;
	MixpanelPeople.prototype['unset']         = MixpanelPeople.prototype.unset;
	MixpanelPeople.prototype['increment']     = MixpanelPeople.prototype.increment;
	MixpanelPeople.prototype['append']        = MixpanelPeople.prototype.append;
	MixpanelPeople.prototype['remove']        = MixpanelPeople.prototype.remove;
	MixpanelPeople.prototype['union']         = MixpanelPeople.prototype.union;
	MixpanelPeople.prototype['track_charge']  = MixpanelPeople.prototype.track_charge;
	MixpanelPeople.prototype['clear_charges'] = MixpanelPeople.prototype.clear_charges;
	MixpanelPeople.prototype['delete_user']   = MixpanelPeople.prototype.delete_user;
	MixpanelPeople.prototype['toString']      = MixpanelPeople.prototype.toString;
	
	/*
	 * Mixpanel JS Library
	 *
	 * Copyright 2012, Mixpanel, Inc. All Rights Reserved
	 * http://mixpanel.com/
	 *
	 * Includes portions of Underscore.js
	 * http://documentcloud.github.com/underscore/
	 * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
	 * Released under the MIT License.
	 */
	
	// ==ClosureCompiler==
	// @compilation_level ADVANCED_OPTIMIZATIONS
	// @output_file_name mixpanel-2.8.min.js
	// ==/ClosureCompiler==
	
	/*
	SIMPLE STYLE GUIDE:
	
	this.x === public function
	this._x === internal - only use within this file
	this.__x === private - only use within the class
	
	Globals should be all caps
	*/
	
	var init_type;       // MODULE or SNIPPET loader
	var mixpanel_master; // main mixpanel instance / object
	var INIT_MODULE  = 0;
	var INIT_SNIPPET = 1;
	
	var IDENTITY_FUNC = function(x) {return x;};
	var NOOP_FUNC = function() {};
	
	/** @const */ var PRIMARY_INSTANCE_NAME = 'mixpanel';
	
	
	/*
	 * Dynamic... constants? Is that an oxymoron?
	 */
	// http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
	// https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
	var USE_XHR = (window$1.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest());
	
	// IE<10 does not support cross-origin XHR's but script tags
	// with defer won't block window.onload; ENQUEUE_REQUESTS
	// should only be true for Opera<12
	var ENQUEUE_REQUESTS = !USE_XHR && (userAgent.indexOf('MSIE') === -1) && (userAgent.indexOf('Mozilla') === -1);
	
	// save reference to navigator.sendBeacon so it can be minified
	var sendBeacon = null;
	if (navigator$1['sendBeacon']) {
	    sendBeacon = function() {
	        // late reference to navigator.sendBeacon to allow patching/spying
	        return navigator$1['sendBeacon'].apply(navigator$1, arguments);
	    };
	}
	
	/*
	 * Module-level globals
	 */
	var DEFAULT_CONFIG = {
	    'api_host':                          'https://api-js.mixpanel.com',
	    'api_method':                        'POST',
	    'api_transport':                     'XHR',
	    'app_host':                          'https://mixpanel.com',
	    'cdn':                               'https://cdn.mxpnl.com',
	    'cross_site_cookie':                 false,
	    'cross_subdomain_cookie':            true,
	    'persistence':                       'cookie',
	    'persistence_name':                  '',
	    'cookie_domain':                     '',
	    'cookie_name':                       '',
	    'loaded':                            NOOP_FUNC,
	    'store_google':                      true,
	    'save_referrer':                     true,
	    'test':                              false,
	    'verbose':                           false,
	    'img':                               false,
	    'debug':                             false,
	    'track_links_timeout':               300,
	    'cookie_expiration':                 365,
	    'upgrade':                           false,
	    'disable_persistence':               false,
	    'disable_cookie':                    false,
	    'secure_cookie':                     false,
	    'ip':                                true,
	    'opt_out_tracking_by_default':       false,
	    'opt_out_persistence_by_default':    false,
	    'opt_out_tracking_persistence_type': 'localStorage',
	    'opt_out_tracking_cookie_prefix':    null,
	    'property_blacklist':                [],
	    'xhr_headers':                       {}, // { header: value, header2: value }
	    'inapp_protocol':                    '//',
	    'inapp_link_new_window':             false,
	    'ignore_dnt':                        false,
	    'batch_requests':                    false, // for now
	    'batch_size':                        50,
	    'batch_flush_interval_ms':           5000,
	    'batch_request_timeout_ms':          90000,
	    'batch_autostart':                   true,
	    'hooks':                             {}
	};
	
	var DOM_LOADED = false;
	
	/**
	 * Mixpanel Library Object
	 * @constructor
	 */
	var MixpanelLib = function() {};
	
	
	/**
	 * create_mplib(token:string, config:object, name:string)
	 *
	 * This function is used by the init method of MixpanelLib objects
	 * as well as the main initializer at the end of the JSLib (that
	 * initializes document.mixpanel as well as any additional instances
	 * declared before this file has loaded).
	 */
	var create_mplib = function(token, config, name) {
	    var instance,
	        target = (name === PRIMARY_INSTANCE_NAME) ? mixpanel_master : mixpanel_master[name];
	
	    if (target && init_type === INIT_MODULE) {
	        instance = target;
	    } else {
	        if (target && !_.isArray(target)) {
	            console.error('You have already initialized ' + name);
	            return;
	        }
	        instance = new MixpanelLib();
	    }
	
	    instance._cached_groups = {}; // cache groups in a pool
	    instance._user_decide_check_complete = false;
	    instance._events_tracked_before_user_decide_check_complete = [];
	
	    instance._init(token, config, name);
	
	    instance['people'] = new MixpanelPeople();
	    instance['people']._init(instance);
	
	    // if any instance on the page has debug = true, we set the
	    // global debug to be true
	    Config.DEBUG = Config.DEBUG || instance.get_config('debug');
	
	    // if target is not defined, we called init after the lib already
	    // loaded, so there won't be an array of things to execute
	    if (!_.isUndefined(target) && _.isArray(target)) {
	        // Crunch through the people queue first - we queue this data up &
	        // flush on identify, so it's better to do all these operations first
	        instance._execute_array.call(instance['people'], target['people']);
	        instance._execute_array(target);
	    }
	
	    return instance;
	};
	
	var encode_data_for_request = function(data) {
	    var json_data = _.JSONEncode(data);
	    var encoded_data = _.base64Encode(json_data);
	    return {'data': encoded_data};
	};
	
	// Initialization methods
	
	/**
	 * This function initializes a new instance of the Mixpanel tracking object.
	 * All new instances are added to the main mixpanel object as sub properties (such as
	 * mixpanel.library_name) and also returned by this function. To define a
	 * second instance on the page, you would call:
	 *
	 *     mixpanel.init('new token', { your: 'config' }, 'library_name');
	 *
	 * and use it like so:
	 *
	 *     mixpanel.library_name.track(...);
	 *
	 * @param {String} token   Your Mixpanel API token
	 * @param {Object} [config]  A dictionary of config options to override. <a href="https://github.com/mixpanel/mixpanel-js/blob/8b2e1f7b/src/mixpanel-core.js#L87-L110">See a list of default config options</a>.
	 * @param {String} [name]    The name for the new mixpanel instance that you want created
	 */
	MixpanelLib.prototype.init = function (token, config, name) {
	    if (_.isUndefined(name)) {
	        console.error('You must name your new library: init(token, config, name)');
	        return;
	    }
	    if (name === PRIMARY_INSTANCE_NAME) {
	        console.error('You must initialize the main mixpanel object right after you include the Mixpanel js snippet');
	        return;
	    }
	
	    var instance = create_mplib(token, config, name);
	    mixpanel_master[name] = instance;
	    instance._loaded();
	
	    return instance;
	};
	
	// mixpanel._init(token:string, config:object, name:string)
	//
	// This function sets up the current instance of the mixpanel
	// library.  The difference between this method and the init(...)
	// method is this one initializes the actual instance, whereas the
	// init(...) method sets up a new library and calls _init on it.
	//
	MixpanelLib.prototype._init = function(token, config, name) {
	    config = config || {};
	
	    this['__loaded'] = true;
	    this['config'] = {};
	    this['_triggered_notifs'] = [];
	
	    // rollout: enable batch_requests by default for 60% of projects
	    // (only if they have not specified a value in their init config
	    // and they aren't using a custom API host)
	    var variable_features = {};
	    var api_host = config['api_host'];
	    var is_custom_api = !!api_host && !api_host.match(/\.mixpanel\.com$/);
	    if (!('batch_requests' in config) && !is_custom_api && determine_eligibility(token, 'batch', 60)) {
	        variable_features['batch_requests'] = true;
	    }
	
	    this.set_config(_.extend({}, DEFAULT_CONFIG, variable_features, config, {
	        'name': name,
	        'token': token,
	        'callback_fn': ((name === PRIMARY_INSTANCE_NAME) ? name : PRIMARY_INSTANCE_NAME + '.' + name) + '._jsc'
	    }));
	
	    this['_jsc'] = NOOP_FUNC;
	
	    this.__dom_loaded_queue = [];
	    this.__request_queue = [];
	    this.__disabled_events = [];
	    this._flags = {
	        'disable_all_events': false,
	        'identify_called': false
	    };
	
	    // set up request queueing/batching
	    this.request_batchers = {};
	    this._batch_requests = this.get_config('batch_requests');
	    if (this._batch_requests) {
	        if (!_.localStorage.is_supported(true) || !USE_XHR) {
	            this._batch_requests = false;
	            console.log('Turning off Mixpanel request-queueing; needs XHR and localStorage support');
	        } else {
	            this.init_batchers();
	            if (sendBeacon && window$1.addEventListener) {
	                window$1.addEventListener('unload', _.bind(function() {
	                    // Before page closes, attempt to flush any events queued up via navigator.sendBeacon.
	                    // Since sendBeacon doesn't report success/failure, events will not be removed from
	                    // the persistent store; if the site is loaded again, the events will be flushed again
	                    // on startup and deduplicated on the Mixpanel server side.
	                    if (!this.request_batchers.events.stopped) {
	                        this.request_batchers.events.flush({unloading: true});
	                    }
	                }, this));
	            }
	        }
	    }
	
	    this['persistence'] = this['cookie'] = new MixpanelPersistence(this['config']);
	    this.unpersisted_superprops = {};
	    this._gdpr_init();
	
	    var uuid = _.UUID();
	    if (!this.get_distinct_id()) {
	        // There is no need to set the distinct id
	        // or the device id if something was already stored
	        // in the persitence
	        this.register_once({
	            'distinct_id': uuid,
	            '$device_id': uuid
	        }, '');
	    }
	};
	
	// Private methods
	
	MixpanelLib.prototype._loaded = function() {
	    this.get_config('loaded')(this);
	    this._set_default_superprops();
	};
	
	// update persistence with info on referrer, UTM params, etc
	MixpanelLib.prototype._set_default_superprops = function() {
	    this['persistence'].update_search_keyword(document$1.referrer);
	    if (this.get_config('store_google')) {
	        this['persistence'].update_campaign_params();
	    }
	    if (this.get_config('save_referrer')) {
	        this['persistence'].update_referrer_info(document$1.referrer);
	    }
	};
	
	MixpanelLib.prototype._dom_loaded = function() {
	    _.each(this.__dom_loaded_queue, function(item) {
	        this._track_dom.apply(this, item);
	    }, this);
	
	    if (!this.has_opted_out_tracking()) {
	        _.each(this.__request_queue, function(item) {
	            this._send_request.apply(this, item);
	        }, this);
	    }
	
	    delete this.__dom_loaded_queue;
	    delete this.__request_queue;
	};
	
	MixpanelLib.prototype._track_dom = function(DomClass, args) {
	    if (this.get_config('img')) {
	        console.error('You can\'t use DOM tracking functions with img = true.');
	        return false;
	    }
	
	    if (!DOM_LOADED) {
	        this.__dom_loaded_queue.push([DomClass, args]);
	        return false;
	    }
	
	    var dt = new DomClass().init(this);
	    return dt.track.apply(dt, args);
	};
	
	/**
	 * _prepare_callback() should be called by callers of _send_request for use
	 * as the callback argument.
	 *
	 * If there is no callback, this returns null.
	 * If we are going to make XHR/XDR requests, this returns a function.
	 * If we are going to use script tags, this returns a string to use as the
	 * callback GET param.
	 */
	MixpanelLib.prototype._prepare_callback = function(callback, data) {
	    if (_.isUndefined(callback)) {
	        return null;
	    }
	
	    if (USE_XHR) {
	        var callback_function = function(response) {
	            callback(response, data);
	        };
	        return callback_function;
	    } else {
	        // if the user gives us a callback, we store as a random
	        // property on this instances jsc function and update our
	        // callback string to reflect that.
	        var jsc = this['_jsc'];
	        var randomized_cb = '' + Math.floor(Math.random() * 100000000);
	        var callback_string = this.get_config('callback_fn') + '[' + randomized_cb + ']';
	        jsc[randomized_cb] = function(response) {
	            delete jsc[randomized_cb];
	            callback(response, data);
	        };
	        return callback_string;
	    }
	};
	
	MixpanelLib.prototype._send_request = function(url, data, options, callback) {
	    var succeeded = true;
	
	    if (ENQUEUE_REQUESTS) {
	        this.__request_queue.push(arguments);
	        return succeeded;
	    }
	
	    var DEFAULT_OPTIONS = {
	        method: this.get_config('api_method'),
	        transport: this.get_config('api_transport'),
	        verbose: this.get_config('verbose')
	    };
	    var body_data = null;
	
	    if (!callback && (_.isFunction(options) || typeof options === 'string')) {
	        callback = options;
	        options = null;
	    }
	    options = _.extend(DEFAULT_OPTIONS, options || {});
	    if (!USE_XHR) {
	        options.method = 'GET';
	    }
	    var use_post = options.method === 'POST';
	    var use_sendBeacon = sendBeacon && use_post && options.transport.toLowerCase() === 'sendbeacon';
	
	    // needed to correctly format responses
	    var verbose_mode = options.verbose;
	    if (data['verbose']) { verbose_mode = true; }
	
	    if (this.get_config('test')) { data['test'] = 1; }
	    if (verbose_mode) { data['verbose'] = 1; }
	    if (this.get_config('img')) { data['img'] = 1; }
	    if (!USE_XHR) {
	        if (callback) {
	            data['callback'] = callback;
	        } else if (verbose_mode || this.get_config('test')) {
	            // Verbose output (from verbose mode, or an error in test mode) is a json blob,
	            // which by itself is not valid javascript. Without a callback, this verbose output will
	            // cause an error when returned via jsonp, so we force a no-op callback param.
	            // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
	            data['callback'] = '(function(){})';
	        }
	    }
	
	    data['ip'] = this.get_config('ip')?1:0;
	    data['_'] = new Date().getTime().toString();
	
	    if (use_post) {
	        body_data = 'data=' + encodeURIComponent(data['data']);
	        delete data['data'];
	    }
	
	    url += '?' + _.HTTPBuildQuery(data);
	
	    if ('img' in data) {
	        var img = document$1.createElement('img');
	        img.src = url;
	        document$1.body.appendChild(img);
	    } else if (use_sendBeacon) {
	        try {
	            succeeded = sendBeacon(url, body_data);
	        } catch (e) {
	            console.error(e);
	            succeeded = false;
	        }
	        try {
	            if (callback) {
	                callback(succeeded ? 1 : 0);
	            }
	        } catch (e) {
	            console.error(e);
	        }
	    } else if (USE_XHR) {
	        try {
	            var req = new XMLHttpRequest();
	            req.open(options.method, url, true);
	
	            var headers = this.get_config('xhr_headers');
	            if (use_post) {
	                headers['Content-Type'] = 'application/x-www-form-urlencoded';
	            }
	            _.each(headers, function(headerValue, headerName) {
	                req.setRequestHeader(headerName, headerValue);
	            });
	
	            if (options.timeout_ms && typeof req.timeout !== 'undefined') {
	                req.timeout = options.timeout_ms;
	                var start_time = new Date().getTime();
	            }
	
	            // send the mp_optout cookie
	            // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
	            req.withCredentials = true;
	            req.onreadystatechange = function () {
	                if (req.readyState === 4) { // XMLHttpRequest.DONE == 4, except in safari 4
	                    if (req.status === 200) {
	                        if (callback) {
	                            if (verbose_mode) {
	                                var response;
	                                try {
	                                    response = _.JSONDecode(req.responseText);
	                                } catch (e) {
	                                    console.error(e);
	                                    if (options.ignore_json_errors) {
	                                        response = req.responseText;
	                                    } else {
	                                        return;
	                                    }
	                                }
	                                callback(response);
	                            } else {
	                                callback(Number(req.responseText));
	                            }
	                        }
	                    } else {
	                        var error;
	                        if (
	                            req.timeout &&
	                            !req.status &&
	                            new Date().getTime() - start_time >= req.timeout
	                        ) {
	                            error = 'timeout';
	                        } else {
	                            error = 'Bad HTTP status: ' + req.status + ' ' + req.statusText;
	                        }
	                        console.error(error);
	                        if (callback) {
	                            if (verbose_mode) {
	                                callback({status: 0, error: error, xhr_req: req});
	                            } else {
	                                callback(0);
	                            }
	                        }
	                    }
	                }
	            };
	            req.send(body_data);
	        } catch (e) {
	            console.error(e);
	            succeeded = false;
	        }
	    } else {
	        var script = document$1.createElement('script');
	        script.type = 'text/javascript';
	        script.async = true;
	        script.defer = true;
	        script.src = url;
	        var s = document$1.getElementsByTagName('script')[0];
	        s.parentNode.insertBefore(script, s);
	    }
	
	    return succeeded;
	};
	
	/**
	 * _execute_array() deals with processing any mixpanel function
	 * calls that were called before the Mixpanel library were loaded
	 * (and are thus stored in an array so they can be called later)
	 *
	 * Note: we fire off all the mixpanel function calls && user defined
	 * functions BEFORE we fire off mixpanel tracking calls. This is so
	 * identify/register/set_config calls can properly modify early
	 * tracking calls.
	 *
	 * @param {Array} array
	 */
	MixpanelLib.prototype._execute_array = function(array) {
	    var fn_name, alias_calls = [], other_calls = [], tracking_calls = [];
	    _.each(array, function(item) {
	        if (item) {
	            fn_name = item[0];
	            if (_.isArray(fn_name)) {
	                tracking_calls.push(item); // chained call e.g. mixpanel.get_group().set()
	            } else if (typeof(item) === 'function') {
	                item.call(this);
	            } else if (_.isArray(item) && fn_name === 'alias') {
	                alias_calls.push(item);
	            } else if (_.isArray(item) && fn_name.indexOf('track') !== -1 && typeof(this[fn_name]) === 'function') {
	                tracking_calls.push(item);
	            } else {
	                other_calls.push(item);
	            }
	        }
	    }, this);
	
	    var execute = function(calls, context) {
	        _.each(calls, function(item) {
	            if (_.isArray(item[0])) {
	                // chained call
	                var caller = context;
	                _.each(item, function(call) {
	                    caller = caller[call[0]].apply(caller, call.slice(1));
	                });
	            } else {
	                this[item[0]].apply(this, item.slice(1));
	            }
	        }, context);
	    };
	
	    execute(alias_calls, this);
	    execute(other_calls, this);
	    execute(tracking_calls, this);
	};
	
	// request queueing utils
	
	MixpanelLib.prototype.are_batchers_initialized = function() {
	    return !!this.request_batchers.events;
	};
	
	MixpanelLib.prototype.init_batchers = function() {
	    var token = this.get_config('token');
	    if (!this.are_batchers_initialized()) {
	        var batcher_for = _.bind(function(attrs) {
	            return new RequestBatcher(
	                '__mpq_' + token + attrs.queue_suffix,
	                {
	                    libConfig: this['config'],
	                    sendRequestFunc: _.bind(function(data, options, cb) {
	                        this._send_request(
	                            this.get_config('api_host') + attrs.endpoint,
	                            encode_data_for_request(data),
	                            options,
	                            this._prepare_callback(cb, data)
	                        );
	                    }, this),
	                    beforeSendHook: _.bind(function(item) {
	                        return this._run_hook('before_send_' + attrs.type, item);
	                    }, this)
	                }
	            );
	        }, this);
	        this.request_batchers = {
	            events: batcher_for({type: 'events', endpoint: '/track/', queue_suffix: '_ev'}),
	            people: batcher_for({type: 'people', endpoint: '/engage/', queue_suffix: '_pp'}),
	            groups: batcher_for({type: 'groups', endpoint: '/groups/', queue_suffix: '_gr'})
	        };
	    }
	    if (this.get_config('batch_autostart')) {
	        this.start_batch_senders();
	    }
	};
	
	MixpanelLib.prototype.start_batch_senders = function() {
	    if (this.are_batchers_initialized()) {
	        this._batch_requests = true;
	        _.each(this.request_batchers, function(batcher) {
	            batcher.start();
	        });
	    }
	};
	
	MixpanelLib.prototype.stop_batch_senders = function() {
	    this._batch_requests = false;
	    _.each(this.request_batchers, function(batcher) {
	        batcher.stop();
	        batcher.clear();
	    });
	};
	
	/**
	 * push() keeps the standard async-array-push
	 * behavior around after the lib is loaded.
	 * This is only useful for external integrations that
	 * do not wish to rely on our convenience methods
	 * (created in the snippet).
	 *
	 * ### Usage:
	 *     mixpanel.push(['register', { a: 'b' }]);
	 *
	 * @param {Array} item A [function_name, args...] array to be executed
	 */
	MixpanelLib.prototype.push = function(item) {
	    this._execute_array([item]);
	};
	
	/**
	 * Disable events on the Mixpanel object. If passed no arguments,
	 * this function disables tracking of any event. If passed an
	 * array of event names, those events will be disabled, but other
	 * events will continue to be tracked.
	 *
	 * Note: this function does not stop other mixpanel functions from
	 * firing, such as register() or people.set().
	 *
	 * @param {Array} [events] An array of event names to disable
	 */
	MixpanelLib.prototype.disable = function(events) {
	    if (typeof(events) === 'undefined') {
	        this._flags.disable_all_events = true;
	    } else {
	        this.__disabled_events = this.__disabled_events.concat(events);
	    }
	};
	
	// internal method for handling track vs batch-enqueue logic
	MixpanelLib.prototype._track_or_batch = function(options, callback) {
	    var truncated_data = _.truncate(options.data, 255);
	    var endpoint = options.endpoint;
	    var batcher = options.batcher;
	    var should_send_immediately = options.should_send_immediately;
	    var send_request_options = options.send_request_options || {};
	    callback = callback || NOOP_FUNC;
	
	    var request_enqueued_or_initiated = true;
	    var send_request_immediately = _.bind(function() {
	        if (!send_request_options.skip_hooks) {
	            truncated_data = this._run_hook('before_send_' + options.type, truncated_data);
	        }
	        if (truncated_data) {
	            console.log('MIXPANEL REQUEST:');
	            console.log(truncated_data);
	            return this._send_request(
	                endpoint,
	                encode_data_for_request(truncated_data),
	                send_request_options,
	                this._prepare_callback(callback, truncated_data)
	            );
	        } else {
	            return null;
	        }
	    }, this);
	
	    if (this._batch_requests && !should_send_immediately) {
	        batcher.enqueue(truncated_data, function(succeeded) {
	            if (succeeded) {
	                callback(1, truncated_data);
	            } else {
	                send_request_immediately();
	            }
	        });
	    } else {
	        request_enqueued_or_initiated = send_request_immediately();
	    }
	
	    return request_enqueued_or_initiated && truncated_data;
	};
	
	/**
	 * Track an event. This is the most important and
	 * frequently used Mixpanel function.
	 *
	 * ### Usage:
	 *
	 *     // track an event named 'Registered'
	 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
	 *
	 *     // track an event using navigator.sendBeacon
	 *     mixpanel.track('Left page', {'duration_seconds': 35}, {transport: 'sendBeacon'});
	 *
	 * To track link clicks or form submissions, see track_links() or track_forms().
	 *
	 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
	 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
	 * @param {Object} [options] Optional configuration for this track request.
	 * @param {String} [options.transport] Transport method for network request ('xhr' or 'sendBeacon').
	 * @param {Boolean} [options.send_immediately] Whether to bypass batching/queueing and send track request immediately.
	 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
	 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
	 * with the tracking payload sent to the API server is returned; otherwise false.
	 */
	MixpanelLib.prototype.track = addOptOutCheckMixpanelLib(function(event_name, properties, options, callback) {
	    if (!callback && typeof options === 'function') {
	        callback = options;
	        options = null;
	    }
	    options = options || {};
	    var transport = options['transport']; // external API, don't minify 'transport' prop
	    if (transport) {
	        options.transport = transport; // 'transport' prop name can be minified internally
	    }
	    var should_send_immediately = options['send_immediately'];
	    if (typeof callback !== 'function') {
	        callback = NOOP_FUNC;
	    }
	
	    if (_.isUndefined(event_name)) {
	        console.error('No event name provided to mixpanel.track');
	        return;
	    }
	
	    if (this._event_is_disabled(event_name)) {
	        callback(0);
	        return;
	    }
	
	    // set defaults
	    properties = properties || {};
	    properties['token'] = this.get_config('token');
	
	    // set $duration if time_event was previously called for this event
	    var start_timestamp = this['persistence'].remove_event_timer(event_name);
	    if (!_.isUndefined(start_timestamp)) {
	        var duration_in_ms = new Date().getTime() - start_timestamp;
	        properties['$duration'] = parseFloat((duration_in_ms / 1000).toFixed(3));
	    }
	
	    this._set_default_superprops();
	
	    // note: extend writes to the first object, so lets make sure we
	    // don't write to the persistence properties object and info
	    // properties object by passing in a new object
	
	    // update properties with pageview info and super-properties
	    properties = _.extend(
	        {},
	        _.info.properties(),
	        this['persistence'].properties(),
	        this.unpersisted_superprops,
	        properties
	    );
	
	    var property_blacklist = this.get_config('property_blacklist');
	    if (_.isArray(property_blacklist)) {
	        _.each(property_blacklist, function(blacklisted_prop) {
	            delete properties[blacklisted_prop];
	        });
	    } else {
	        console.error('Invalid value for property_blacklist config: ' + property_blacklist);
	    }
	
	    var data = {
	        'event': event_name,
	        'properties': properties
	    };
	    var ret = this._track_or_batch({
	        type: 'events',
	        data: data,
	        endpoint: this.get_config('api_host') + '/track/',
	        batcher: this.request_batchers.events,
	        should_send_immediately: should_send_immediately,
	        send_request_options: options
	    }, callback);
	
	    this._check_and_handle_triggered_notifications(data);
	
	    return ret;
	});
	
	/**
	 * Register the current user into one/many groups.
	 *
	 * ### Usage:
	 *
	 *      mixpanel.set_group('company', ['mixpanel', 'google']) // an array of IDs
	 *      mixpanel.set_group('company', 'mixpanel')
	 *      mixpanel.set_group('company', 128746312)
	 *
	 * @param {String} group_key Group key
	 * @param {Array|String|Number} group_ids An array of group IDs, or a singular group ID
	 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
	 *
	 */
	MixpanelLib.prototype.set_group = addOptOutCheckMixpanelLib(function(group_key, group_ids, callback) {
	    if (!_.isArray(group_ids)) {
	        group_ids = [group_ids];
	    }
	    var prop = {};
	    prop[group_key] = group_ids;
	    this.register(prop);
	    return this['people'].set(group_key, group_ids, callback);
	});
	
	/**
	 * Add a new group for this user.
	 *
	 * ### Usage:
	 *
	 *      mixpanel.add_group('company', 'mixpanel')
	 *
	 * @param {String} group_key Group key
	 * @param {*} group_id A valid Mixpanel property type
	 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
	 */
	MixpanelLib.prototype.add_group = addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
	    var old_values = this.get_property(group_key);
	    if (old_values === undefined) {
	        var prop = {};
	        prop[group_key] = [group_id];
	        this.register(prop);
	    } else {
	        if (old_values.indexOf(group_id) === -1) {
	            old_values.push(group_id);
	            this.register(prop);
	        }
	    }
	    return this['people'].union(group_key, group_id, callback);
	});
	
	/**
	 * Remove a group from this user.
	 *
	 * ### Usage:
	 *
	 *      mixpanel.remove_group('company', 'mixpanel')
	 *
	 * @param {String} group_key Group key
	 * @param {*} group_id A valid Mixpanel property type
	 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
	 */
	MixpanelLib.prototype.remove_group = addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
	    var old_value = this.get_property(group_key);
	    // if the value doesn't exist, the persistent store is unchanged
	    if (old_value !== undefined) {
	        var idx = old_value.indexOf(group_id);
	        if (idx > -1) {
	            old_value.splice(idx, 1);
	            this.register({group_key: old_value});
	        }
	        if (old_value.length === 0) {
	            this.unregister(group_key);
	        }
	    }
	    return this['people'].remove(group_key, group_id, callback);
	});
	
	/**
	 * Track an event with specific groups.
	 *
	 * ### Usage:
	 *
	 *      mixpanel.track_with_groups('purchase', {'product': 'iphone'}, {'University': ['UCB', 'UCLA']})
	 *
	 * @param {String} event_name The name of the event (see `mixpanel.track()`)
	 * @param {Object=} properties A set of properties to include with the event you're sending (see `mixpanel.track()`)
	 * @param {Object=} groups An object mapping group name keys to one or more values
	 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
	 */
	MixpanelLib.prototype.track_with_groups = addOptOutCheckMixpanelLib(function(event_name, properties, groups, callback) {
	    var tracking_props = _.extend({}, properties || {});
	    _.each(groups, function(v, k) {
	        if (v !== null && v !== undefined) {
	            tracking_props[k] = v;
	        }
	    });
	    return this.track(event_name, tracking_props, callback);
	});
	
	MixpanelLib.prototype._create_map_key = function (group_key, group_id) {
	    return group_key + '_' + JSON.stringify(group_id);
	};
	
	MixpanelLib.prototype._remove_group_from_cache = function (group_key, group_id) {
	    delete this._cached_groups[this._create_map_key(group_key, group_id)];
	};
	
	/**
	 * Look up reference to a Mixpanel group
	 *
	 * ### Usage:
	 *
	 *       mixpanel.get_group(group_key, group_id)
	 *
	 * @param {String} group_key Group key
	 * @param {Object} group_id A valid Mixpanel property type
	 * @returns {Object} A MixpanelGroup identifier
	 */
	MixpanelLib.prototype.get_group = function (group_key, group_id) {
	    var map_key = this._create_map_key(group_key, group_id);
	    var group = this._cached_groups[map_key];
	    if (group === undefined || group._group_key !== group_key || group._group_id !== group_id) {
	        group = new MixpanelGroup();
	        group._init(this, group_key, group_id);
	        this._cached_groups[map_key] = group;
	    }
	    return group;
	};
	
	/**
	 * Track mp_page_view event. This is now ignored by the server.
	 *
	 * @param {String} [page] The url of the page to record. If you don't include this, it defaults to the current url.
	 * @deprecated
	 */
	MixpanelLib.prototype.track_pageview = function(page) {
	    if (_.isUndefined(page)) {
	        page = document$1.location.href;
	    }
	    this.track('mp_page_view', _.info.pageviewInfo(page));
	};
	
	/**
	 * Track clicks on a set of document elements. Selector must be a
	 * valid query. Elements must exist on the page at the time track_links is called.
	 *
	 * ### Usage:
	 *
	 *     // track click for link id #nav
	 *     mixpanel.track_links('#nav', 'Clicked Nav Link');
	 *
	 * ### Notes:
	 *
	 * This function will wait up to 300 ms for the Mixpanel
	 * servers to respond. If they have not responded by that time
	 * it will head to the link without ensuring that your event
	 * has been tracked.  To configure this timeout please see the
	 * set_config() documentation below.
	 *
	 * If you pass a function in as the properties argument, the
	 * function will receive the DOMElement that triggered the
	 * event as an argument.  You are expected to return an object
	 * from the function; any properties defined on this object
	 * will be sent to mixpanel as event properties.
	 *
	 * @type {Function}
	 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
	 * @param {String} event_name The name of the event to track
	 * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
	 */
	MixpanelLib.prototype.track_links = function() {
	    return this._track_dom.call(this, LinkTracker, arguments);
	};
	
	/**
	 * Track form submissions. Selector must be a valid query.
	 *
	 * ### Usage:
	 *
	 *     // track submission for form id 'register'
	 *     mixpanel.track_forms('#register', 'Created Account');
	 *
	 * ### Notes:
	 *
	 * This function will wait up to 300 ms for the mixpanel
	 * servers to respond, if they have not responded by that time
	 * it will head to the link without ensuring that your event
	 * has been tracked.  To configure this timeout please see the
	 * set_config() documentation below.
	 *
	 * If you pass a function in as the properties argument, the
	 * function will receive the DOMElement that triggered the
	 * event as an argument.  You are expected to return an object
	 * from the function; any properties defined on this object
	 * will be sent to mixpanel as event properties.
	 *
	 * @type {Function}
	 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
	 * @param {String} event_name The name of the event to track
	 * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
	 */
	MixpanelLib.prototype.track_forms = function() {
	    return this._track_dom.call(this, FormTracker, arguments);
	};
	
	/**
	 * Time an event by including the time between this call and a
	 * later 'track' call for the same event in the properties sent
	 * with the event.
	 *
	 * ### Usage:
	 *
	 *     // time an event named 'Registered'
	 *     mixpanel.time_event('Registered');
	 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
	 *
	 * When called for a particular event name, the next track call for that event
	 * name will include the elapsed time between the 'time_event' and 'track'
	 * calls. This value is stored as seconds in the '$duration' property.
	 *
	 * @param {String} event_name The name of the event.
	 */
	MixpanelLib.prototype.time_event = function(event_name) {
	    if (_.isUndefined(event_name)) {
	        console.error('No event name provided to mixpanel.time_event');
	        return;
	    }
	
	    if (this._event_is_disabled(event_name)) {
	        return;
	    }
	
	    this['persistence'].set_event_timer(event_name,  new Date().getTime());
	};
	
	var REGISTER_DEFAULTS = {
	    'persistent': true
	};
	/**
	 * Helper to parse options param for register methods, maintaining
	 * legacy support for plain "days" param instead of options object
	 * @param {Number|Object} [days_or_options] 'days' option (Number), or Options object for register methods
	 * @returns {Object} options object
	 */
	var options_for_register = function(days_or_options) {
	    var options;
	    if (_.isObject(days_or_options)) {
	        options = days_or_options;
	    } else if (!_.isUndefined(days_or_options)) {
	        options = {'days': days_or_options};
	    } else {
	        options = {};
	    }
	    return _.extend({}, REGISTER_DEFAULTS, options);
	};
	
	/**
	 * Register a set of super properties, which are included with all
	 * events. This will overwrite previous super property values.
	 *
	 * ### Usage:
	 *
	 *     // register 'Gender' as a super property
	 *     mixpanel.register({'Gender': 'Female'});
	 *
	 *     // register several super properties when a user signs up
	 *     mixpanel.register({
	 *         'Email': 'jdoe@example.com',
	 *         'Account Type': 'Free'
	 *     });
	 *
	 *     // register only for the current pageload
	 *     mixpanel.register({'Name': 'Pat'}, {persistent: false});
	 *
	 * @param {Object} properties An associative array of properties to store about the user
	 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
	 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
	 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
	 */
	MixpanelLib.prototype.register = function(props, days_or_options) {
	    var options = options_for_register(days_or_options);
	    if (options['persistent']) {
	        this['persistence'].register(props, options['days']);
	    } else {
	        _.extend(this.unpersisted_superprops, props);
	    }
	};
	
	/**
	 * Register a set of super properties only once. This will not
	 * overwrite previous super property values, unlike register().
	 *
	 * ### Usage:
	 *
	 *     // register a super property for the first time only
	 *     mixpanel.register_once({
	 *         'First Login Date': new Date().toISOString()
	 *     });
	 *
	 *     // register once, only for the current pageload
	 *     mixpanel.register_once({
	 *         'First interaction time': new Date().toISOString()
	 *     }, 'None', {persistent: false});
	 *
	 * ### Notes:
	 *
	 * If default_value is specified, current super properties
	 * with that value will be overwritten.
	 *
	 * @param {Object} properties An associative array of properties to store about the user
	 * @param {*} [default_value] Value to override if already set in super properties (ex: 'False') Default: 'None'
	 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
	 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
	 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
	 */
	MixpanelLib.prototype.register_once = function(props, default_value, days_or_options) {
	    var options = options_for_register(days_or_options);
	    if (options['persistent']) {
	        this['persistence'].register_once(props, default_value, options['days']);
	    } else {
	        if (typeof(default_value) === 'undefined') {
	            default_value = 'None';
	        }
	        _.each(props, function(val, prop) {
	            if (!this.unpersisted_superprops.hasOwnProperty(prop) || this.unpersisted_superprops[prop] === default_value) {
	                this.unpersisted_superprops[prop] = val;
	            }
	        }, this);
	    }
	};
	
	/**
	 * Delete a super property stored with the current user.
	 *
	 * @param {String} property The name of the super property to remove
	 * @param {Object} [options]
	 * @param {boolean} [options.persistent=true] - whether to look in persistent storage (cookie/localStorage)
	 */
	MixpanelLib.prototype.unregister = function(property, options) {
	    options = options_for_register(options);
	    if (options['persistent']) {
	        this['persistence'].unregister(property);
	    } else {
	        delete this.unpersisted_superprops[property];
	    }
	};
	
	MixpanelLib.prototype._register_single = function(prop, value) {
	    var props = {};
	    props[prop] = value;
	    this.register(props);
	};
	
	/**
	 * Identify a user with a unique ID to track user activity across
	 * devices, tie a user to their events, and create a user profile.
	 * If you never call this method, unique visitors are tracked using
	 * a UUID generated the first time they visit the site.
	 *
	 * Call identify when you know the identity of the current user,
	 * typically after login or signup. We recommend against using
	 * identify for anonymous visitors to your site.
	 *
	 * ### Notes:
	 * If your project has
	 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
	 * enabled, the identify method will connect pre- and
	 * post-authentication events when appropriate.
	 *
	 * If your project does not have ID Merge enabled, identify will
	 * change the user's local distinct_id to the unique ID you pass.
	 * Events tracked prior to authentication will not be connected
	 * to the same user identity. If ID Merge is disabled, alias can
	 * be used to connect pre- and post-registration events.
	 *
	 * @param {String} [unique_id] A string that uniquely identifies a user. If not provided, the distinct_id currently in the persistent store (cookie or localStorage) will be used.
	 */
	MixpanelLib.prototype.identify = function(
	    new_distinct_id, _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback
	) {
	    // Optional Parameters
	    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
	    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
	    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
	    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
	    //  _union_callback:function  A callback to be run if and when the People union queue is flushed
	    //  _unset_callback:function  A callback to be run if and when the People unset queue is flushed
	
	    var previous_distinct_id = this.get_distinct_id();
	    this.register({'$user_id': new_distinct_id});
	
	    if (!this.get_property('$device_id')) {
	        // The persisted distinct id might not actually be a device id at all
	        // it might be a distinct id of the user from before
	        var device_id = previous_distinct_id;
	        this.register_once({
	            '$had_persisted_distinct_id': true,
	            '$device_id': device_id
	        }, '');
	    }
	
	    // identify only changes the distinct id if it doesn't match either the existing or the alias;
	    // if it's new, blow away the alias as well.
	    if (new_distinct_id !== previous_distinct_id && new_distinct_id !== this.get_property(ALIAS_ID_KEY)) {
	        this.unregister(ALIAS_ID_KEY);
	        this.register({'distinct_id': new_distinct_id});
	    }
	    this._check_and_handle_notifications(this.get_distinct_id());
	    this._flags.identify_called = true;
	    // Flush any queued up people requests
	    this['people']._flush(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback);
	
	    // send an $identify event any time the distinct_id is changing - logic on the server
	    // will determine whether or not to do anything with it.
	    if (new_distinct_id !== previous_distinct_id) {
	        this.track('$identify', {
	            'distinct_id': new_distinct_id,
	            '$anon_distinct_id': previous_distinct_id
	        }, {skip_hooks: true});
	    }
	};
	
	/**
	 * Clears super properties and generates a new random distinct_id for this instance.
	 * Useful for clearing data when a user logs out.
	 */
	MixpanelLib.prototype.reset = function() {
	    this['persistence'].clear();
	    this._flags.identify_called = false;
	    var uuid = _.UUID();
	    this.register_once({
	        'distinct_id': uuid,
	        '$device_id': uuid
	    }, '');
	};
	
	/**
	 * Returns the current distinct id of the user. This is either the id automatically
	 * generated by the library or the id that has been passed by a call to identify().
	 *
	 * ### Notes:
	 *
	 * get_distinct_id() can only be called after the Mixpanel library has finished loading.
	 * init() has a loaded function available to handle this automatically. For example:
	 *
	 *     // set distinct_id after the mixpanel library has loaded
	 *     mixpanel.init('YOUR PROJECT TOKEN', {
	 *         loaded: function(mixpanel) {
	 *             distinct_id = mixpanel.get_distinct_id();
	 *         }
	 *     });
	 */
	MixpanelLib.prototype.get_distinct_id = function() {
	    return this.get_property('distinct_id');
	};
	
	/**
	 * The alias method creates an alias which Mixpanel will use to
	 * remap one id to another. Multiple aliases can point to the
	 * same identifier.
	 *
	 * The following is a valid use of alias:
	 *
	 *     mixpanel.alias('new_id', 'existing_id');
	 *     // You can add multiple id aliases to the existing ID
	 *     mixpanel.alias('newer_id', 'existing_id');
	 *
	 * Aliases can also be chained - the following is a valid example:
	 *
	 *     mixpanel.alias('new_id', 'existing_id');
	 *     // chain newer_id - new_id - existing_id
	 *     mixpanel.alias('newer_id', 'new_id');
	 *
	 * Aliases cannot point to multiple identifiers - the following
	 * example will not work:
	 *
	 *     mixpanel.alias('new_id', 'existing_id');
	 *     // this is invalid as 'new_id' already points to 'existing_id'
	 *     mixpanel.alias('new_id', 'newer_id');
	 *
	 * ### Notes:
	 *
	 * If your project does not have
	 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
	 * enabled, the best practice is to call alias once when a unique
	 * ID is first created for a user (e.g., when a user first registers
	 * for an account). Do not use alias multiple times for a single
	 * user without ID Merge enabled.
	 *
	 * @param {String} alias A unique identifier that you want to use for this user in the future.
	 * @param {String} [original] The current identifier being used for this user.
	 */
	MixpanelLib.prototype.alias = function(alias, original) {
	    // If the $people_distinct_id key exists in persistence, there has been a previous
	    // mixpanel.people.identify() call made for this user. It is VERY BAD to make an alias with
	    // this ID, as it will duplicate users.
	    if (alias === this.get_property(PEOPLE_DISTINCT_ID_KEY)) {
	        console.critical('Attempting to create alias for existing People user - aborting.');
	        return -2;
	    }
	
	    var _this = this;
	    if (_.isUndefined(original)) {
	        original = this.get_distinct_id();
	    }
	    if (alias !== original) {
	        this._register_single(ALIAS_ID_KEY, alias);
	        return this.track('$create_alias', {
	            'alias': alias,
	            'distinct_id': original
	        }, {
	            skip_hooks: true
	        }, function() {
	            // Flush the people queue
	            _this.identify(alias);
	        });
	    } else {
	        console.error('alias matches current distinct_id - skipping api call.');
	        this.identify(alias);
	        return -1;
	    }
	};
	
	/**
	 * Provide a string to recognize the user by. The string passed to
	 * this method will appear in the Mixpanel Streams product rather
	 * than an automatically generated name. Name tags do not have to
	 * be unique.
	 *
	 * This value will only be included in Streams data.
	 *
	 * @param {String} name_tag A human readable name for the user
	 * @deprecated
	 */
	MixpanelLib.prototype.name_tag = function(name_tag) {
	    this._register_single('mp_name_tag', name_tag);
	};
	
	/**
	 * Update the configuration of a mixpanel library instance.
	 *
	 * The default config is:
	 *
	 *     {
	 *       // HTTP method for tracking requests
	 *       api_method: 'POST'
	 *
	 *       // transport for sending requests ('XHR' or 'sendBeacon')
	 *       // NB: sendBeacon should only be used for scenarios such as
	 *       // page unload where a "best-effort" attempt to send is
	 *       // acceptable; the sendBeacon API does not support callbacks
	 *       // or any way to know the result of the request. Mixpanel
	 *       // tracking via sendBeacon will not support any event-
	 *       // batching or retry mechanisms.
	 *       api_transport: 'XHR'
	 *
	 *       // turn on request-batching/queueing/retry
	 *       batch_requests: false,
	 *
	 *       // maximum number of events/updates to send in a single
	 *       // network request
	 *       batch_size: 50,
	 *
	 *       // milliseconds to wait between sending batch requests
	 *       batch_flush_interval_ms: 5000,
	 *
	 *       // milliseconds to wait for network responses to batch requests
	 *       // before they are considered timed-out and retried
	 *       batch_request_timeout_ms: 90000,
	 *
	 *       // override value for cookie domain, only useful for ensuring
	 *       // correct cross-subdomain cookies on unusual domains like
	 *       // subdomain.mainsite.avocat.fr; NB this cannot be used to
	 *       // set cookies on a different domain than the current origin
	 *       cookie_domain: ''
	 *
	 *       // super properties cookie expiration (in days)
	 *       cookie_expiration: 365
	 *
	 *       // if true, cookie will be set with SameSite=None; Secure
	 *       // this is only useful in special situations, like embedded
	 *       // 3rd-party iframes that set up a Mixpanel instance
	 *       cross_site_cookie: false
	 *
	 *       // super properties span subdomains
	 *       cross_subdomain_cookie: true
	 *
	 *       // debug mode
	 *       debug: false
	 *
	 *       // if this is true, the mixpanel cookie or localStorage entry
	 *       // will be deleted, and no user persistence will take place
	 *       disable_persistence: false
	 *
	 *       // if this is true, Mixpanel will automatically determine
	 *       // City, Region and Country data using the IP address of
	 *       //the client
	 *       ip: true
	 *
	 *       // opt users out of tracking by this Mixpanel instance by default
	 *       opt_out_tracking_by_default: false
	 *
	 *       // opt users out of browser data storage by this Mixpanel instance by default
	 *       opt_out_persistence_by_default: false
	 *
	 *       // persistence mechanism used by opt-in/opt-out methods - cookie
	 *       // or localStorage - falls back to cookie if localStorage is unavailable
	 *       opt_out_tracking_persistence_type: 'localStorage'
	 *
	 *       // customize the name of cookie/localStorage set by opt-in/opt-out methods
	 *       opt_out_tracking_cookie_prefix: null
	 *
	 *       // type of persistent store for super properties (cookie/
	 *       // localStorage) if set to 'localStorage', any existing
	 *       // mixpanel cookie value with the same persistence_name
	 *       // will be transferred to localStorage and deleted
	 *       persistence: 'cookie'
	 *
	 *       // name for super properties persistent store
	 *       persistence_name: ''
	 *
	 *       // names of properties/superproperties which should never
	 *       // be sent with track() calls
	 *       property_blacklist: []
	 *
	 *       // if this is true, mixpanel cookies will be marked as
	 *       // secure, meaning they will only be transmitted over https
	 *       secure_cookie: false
	 *
	 *       // the amount of time track_links will
	 *       // wait for Mixpanel's servers to respond
	 *       track_links_timeout: 300
	 *
	 *       // if you set upgrade to be true, the library will check for
	 *       // a cookie from our old js library and import super
	 *       // properties from it, then the old cookie is deleted
	 *       // The upgrade config option only works in the initialization,
	 *       // so make sure you set it when you create the library.
	 *       upgrade: false
	 *
	 *       // extra HTTP request headers to set for each API request, in
	 *       // the format {'Header-Name': value}
	 *       xhr_headers: {}
	 *
	 *       // protocol for fetching in-app message resources, e.g.
	 *       // 'https://' or 'http://'; defaults to '//' (which defers to the
	 *       // current page's protocol)
	 *       inapp_protocol: '//'
	 *
	 *       // whether to open in-app message link in new tab/window
	 *       inapp_link_new_window: false
	 *
	 *       // whether to ignore or respect the web browser's Do Not Track setting
	 *       ignore_dnt: false
	 *     }
	 *
	 *
	 * @param {Object} config A dictionary of new configuration values to update
	 */
	MixpanelLib.prototype.set_config = function(config) {
	    if (_.isObject(config)) {
	        _.extend(this['config'], config);
	
	        var new_batch_size = config['batch_size'];
	        if (new_batch_size) {
	            _.each(this.request_batchers, function(batcher) {
	                batcher.resetBatchSize();
	            });
	        }
	
	        if (!this.get_config('persistence_name')) {
	            this['config']['persistence_name'] = this['config']['cookie_name'];
	        }
	        if (!this.get_config('disable_persistence')) {
	            this['config']['disable_persistence'] = this['config']['disable_cookie'];
	        }
	
	        if (this['persistence']) {
	            this['persistence'].update_config(this['config']);
	        }
	        Config.DEBUG = Config.DEBUG || this.get_config('debug');
	    }
	};
	
	/**
	 * returns the current config object for the library.
	 */
	MixpanelLib.prototype.get_config = function(prop_name) {
	    return this['config'][prop_name];
	};
	
	/**
	 * Fetch a hook function from config, with safe default, and run it
	 * against the given arguments
	 * @param {string} hook_name which hook to retrieve
	 * @returns {any|null} return value of user-provided hook, or null if nothing was returned
	 */
	MixpanelLib.prototype._run_hook = function(hook_name) {
	    var ret = (this['config']['hooks'][hook_name] || IDENTITY_FUNC).apply(this, slice.call(arguments, 1));
	    if (typeof ret === 'undefined') {
	        console.error(hook_name + ' hook did not return a value');
	        ret = null;
	    }
	    return ret;
	};
	
	/**
	 * Returns the value of the super property named property_name. If no such
	 * property is set, get_property() will return the undefined value.
	 *
	 * ### Notes:
	 *
	 * get_property() can only be called after the Mixpanel library has finished loading.
	 * init() has a loaded function available to handle this automatically. For example:
	 *
	 *     // grab value for 'user_id' after the mixpanel library has loaded
	 *     mixpanel.init('YOUR PROJECT TOKEN', {
	 *         loaded: function(mixpanel) {
	 *             user_id = mixpanel.get_property('user_id');
	 *         }
	 *     });
	 *
	 * @param {String} property_name The name of the super property you want to retrieve
	 */
	MixpanelLib.prototype.get_property = function(property_name) {
	    return this['persistence']['props'][property_name];
	};
	
	MixpanelLib.prototype.toString = function() {
	    var name = this.get_config('name');
	    if (name !== PRIMARY_INSTANCE_NAME) {
	        name = PRIMARY_INSTANCE_NAME + '.' + name;
	    }
	    return name;
	};
	
	MixpanelLib.prototype._event_is_disabled = function(event_name) {
	    return _.isBlockedUA(userAgent) ||
	        this._flags.disable_all_events ||
	        _.include(this.__disabled_events, event_name);
	};
	
	MixpanelLib.prototype._check_and_handle_triggered_notifications = addOptOutCheckMixpanelLib(function(event_data) {
	    if (!this._user_decide_check_complete) {
	        this._events_tracked_before_user_decide_check_complete.push(event_data);
	    } else {
	        var arr = this['_triggered_notifs'];
	        for (var i = 0; i < arr.length; i++) {
	            var notif = new MixpanelNotification(arr[i], this);
	            if (notif._matches_event_data(event_data)) {
	                this._show_notification(arr[i]);
	                return;
	            }
	        }
	    }
	});
	
	MixpanelLib.prototype._check_and_handle_notifications = addOptOutCheckMixpanelLib(function(distinct_id) {
	    if (
	        !distinct_id ||
	        this._flags.identify_called ||
	        this.get_config('disable_notifications')
	    ) {
	        return;
	    }
	
	    console.log('MIXPANEL NOTIFICATION CHECK');
	
	    var data = {
	        'verbose':     true,
	        'version':     '3',
	        'lib':         'web',
	        'token':       this.get_config('token'),
	        'distinct_id': distinct_id
	    };
	    this._send_request(
	        this.get_config('api_host') + '/decide/',
	        data,
	        {method: 'GET', transport: 'XHR'},
	        this._prepare_callback(_.bind(function(result) {
	            if (result['notifications'] && result['notifications'].length > 0) {
	                this['_triggered_notifs'] = [];
	                var notifications = [];
	                _.each(result['notifications'], function(notif) {
	                    (notif['display_triggers'] && notif['display_triggers'].length > 0 ? this['_triggered_notifs'] : notifications).push(notif);
	                }, this);
	                if (notifications.length > 0) {
	                    this._show_notification.call(this, notifications[0]);
	                }
	            }
	            this._handle_user_decide_check_complete();
	        }, this))
	    );
	});
	
	MixpanelLib.prototype._handle_user_decide_check_complete = function() {
	    this._user_decide_check_complete = true;
	
	    // check notifications against events that were tracked before decide call completed
	    var events = this._events_tracked_before_user_decide_check_complete;
	    while (events.length > 0) {
	        var data = events.shift(); // replay in the same order they came in
	        this._check_and_handle_triggered_notifications(data);
	    }
	};
	
	MixpanelLib.prototype._show_notification = function(notif_data) {
	    var notification = new MixpanelNotification(notif_data, this);
	    notification.show();
	};
	
	// perform some housekeeping around GDPR opt-in/out state
	MixpanelLib.prototype._gdpr_init = function() {
	    var is_localStorage_requested = this.get_config('opt_out_tracking_persistence_type') === 'localStorage';
	
	    // try to convert opt-in/out cookies to localStorage if possible
	    if (is_localStorage_requested && _.localStorage.is_supported()) {
	        if (!this.has_opted_in_tracking() && this.has_opted_in_tracking({'persistence_type': 'cookie'})) {
	            this.opt_in_tracking({'enable_persistence': false});
	        }
	        if (!this.has_opted_out_tracking() && this.has_opted_out_tracking({'persistence_type': 'cookie'})) {
	            this.opt_out_tracking({'clear_persistence': false});
	        }
	        this.clear_opt_in_out_tracking({
	            'persistence_type': 'cookie',
	            'enable_persistence': false
	        });
	    }
	
	    // check whether the user has already opted out - if so, clear & disable persistence
	    if (this.has_opted_out_tracking()) {
	        this._gdpr_update_persistence({'clear_persistence': true});
	
	    // check whether we should opt out by default
	    // note: we don't clear persistence here by default since opt-out default state is often
	    //       used as an initial state while GDPR information is being collected
	    } else if (!this.has_opted_in_tracking() && (
	        this.get_config('opt_out_tracking_by_default') || _.cookie.get('mp_optout')
	    )) {
	        _.cookie.remove('mp_optout');
	        this.opt_out_tracking({
	            'clear_persistence': this.get_config('opt_out_persistence_by_default')
	        });
	    }
	};
	
	/**
	 * Enable or disable persistence based on options
	 * only enable/disable if persistence is not already in this state
	 * @param {boolean} [options.clear_persistence] If true, will delete all data stored by the sdk in persistence and disable it
	 * @param {boolean} [options.enable_persistence] If true, will re-enable sdk persistence
	 */
	MixpanelLib.prototype._gdpr_update_persistence = function(options) {
	    var disabled;
	    if (options && options['clear_persistence']) {
	        disabled = true;
	    } else if (options && options['enable_persistence']) {
	        disabled = false;
	    } else {
	        return;
	    }
	
	    if (!this.get_config('disable_persistence') && this['persistence'].disabled !== disabled) {
	        this['persistence'].set_disabled(disabled);
	    }
	
	    if (disabled) {
	        _.each(this.request_batchers, function(batcher) {
	            batcher.clear();
	        });
	    }
	};
	
	// call a base gdpr function after constructing the appropriate token and options args
	MixpanelLib.prototype._gdpr_call_func = function(func, options) {
	    options = _.extend({
	        'track': _.bind(this.track, this),
	        'persistence_type': this.get_config('opt_out_tracking_persistence_type'),
	        'cookie_prefix': this.get_config('opt_out_tracking_cookie_prefix'),
	        'cookie_expiration': this.get_config('cookie_expiration'),
	        'cross_site_cookie': this.get_config('cross_site_cookie'),
	        'cross_subdomain_cookie': this.get_config('cross_subdomain_cookie'),
	        'cookie_domain': this.get_config('cookie_domain'),
	        'secure_cookie': this.get_config('secure_cookie'),
	        'ignore_dnt': this.get_config('ignore_dnt')
	    }, options);
	
	    // check if localStorage can be used for recording opt out status, fall back to cookie if not
	    if (!_.localStorage.is_supported()) {
	        options['persistence_type'] = 'cookie';
	    }
	
	    return func(this.get_config('token'), {
	        track: options['track'],
	        trackEventName: options['track_event_name'],
	        trackProperties: options['track_properties'],
	        persistenceType: options['persistence_type'],
	        persistencePrefix: options['cookie_prefix'],
	        cookieDomain: options['cookie_domain'],
	        cookieExpiration: options['cookie_expiration'],
	        crossSiteCookie: options['cross_site_cookie'],
	        crossSubdomainCookie: options['cross_subdomain_cookie'],
	        secureCookie: options['secure_cookie'],
	        ignoreDnt: options['ignore_dnt']
	    });
	};
	
	/**
	 * Opt the user in to data tracking and cookies/localstorage for this Mixpanel instance
	 *
	 * ### Usage
	 *
	 *     // opt user in
	 *     mixpanel.opt_in_tracking();
	 *
	 *     // opt user in with specific event name, properties, cookie configuration
	 *     mixpanel.opt_in_tracking({
	 *         track_event_name: 'User opted in',
	 *         track_event_properties: {
	 *             'Email': 'jdoe@example.com'
	 *         },
	 *         cookie_expiration: 30,
	 *         secure_cookie: true
	 *     });
	 *
	 * @param {Object} [options] A dictionary of config options to override
	 * @param {function} [options.track] Function used for tracking a Mixpanel event to record the opt-in action (default is this Mixpanel instance's track method)
	 * @param {string} [options.track_event_name=$opt_in] Event name to be used for tracking the opt-in action
	 * @param {Object} [options.track_properties] Set of properties to be tracked along with the opt-in action
	 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
	 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
	 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
	 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
	 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
	 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
	 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
	 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
	 */
	MixpanelLib.prototype.opt_in_tracking = function(options) {
	    options = _.extend({
	        'enable_persistence': true
	    }, options);
	
	    this._gdpr_call_func(optIn, options);
	    this._gdpr_update_persistence(options);
	};
	
	/**
	 * Opt the user out of data tracking and cookies/localstorage for this Mixpanel instance
	 *
	 * ### Usage
	 *
	 *     // opt user out
	 *     mixpanel.opt_out_tracking();
	 *
	 *     // opt user out with different cookie configuration from Mixpanel instance
	 *     mixpanel.opt_out_tracking({
	 *         cookie_expiration: 30,
	 *         secure_cookie: true
	 *     });
	 *
	 * @param {Object} [options] A dictionary of config options to override
	 * @param {boolean} [options.delete_user=true] If true, will delete the currently identified user's profile and clear all charges after opting the user out
	 * @param {boolean} [options.clear_persistence=true] If true, will delete all data stored by the sdk in persistence
	 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
	 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
	 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
	 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
	 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
	 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
	 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
	 */
	MixpanelLib.prototype.opt_out_tracking = function(options) {
	    options = _.extend({
	        'clear_persistence': true,
	        'delete_user': true
	    }, options);
	
	    // delete user and clear charges since these methods may be disabled by opt-out
	    if (options['delete_user'] && this['people'] && this['people']._identify_called()) {
	        this['people'].delete_user();
	        this['people'].clear_charges();
	    }
	
	    this._gdpr_call_func(optOut, options);
	    this._gdpr_update_persistence(options);
	};
	
	/**
	 * Check whether the user has opted in to data tracking and cookies/localstorage for this Mixpanel instance
	 *
	 * ### Usage
	 *
	 *     var has_opted_in = mixpanel.has_opted_in_tracking();
	 *     // use has_opted_in value
	 *
	 * @param {Object} [options] A dictionary of config options to override
	 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
	 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
	 * @returns {boolean} current opt-in status
	 */
	MixpanelLib.prototype.has_opted_in_tracking = function(options) {
	    return this._gdpr_call_func(hasOptedIn, options);
	};
	
	/**
	 * Check whether the user has opted out of data tracking and cookies/localstorage for this Mixpanel instance
	 *
	 * ### Usage
	 *
	 *     var has_opted_out = mixpanel.has_opted_out_tracking();
	 *     // use has_opted_out value
	 *
	 * @param {Object} [options] A dictionary of config options to override
	 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
	 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
	 * @returns {boolean} current opt-out status
	 */
	MixpanelLib.prototype.has_opted_out_tracking = function(options) {
	    return this._gdpr_call_func(hasOptedOut, options);
	};
	
	/**
	 * Clear the user's opt in/out status of data tracking and cookies/localstorage for this Mixpanel instance
	 *
	 * ### Usage
	 *
	 *     // clear user's opt-in/out status
	 *     mixpanel.clear_opt_in_out_tracking();
	 *
	 *     // clear user's opt-in/out status with specific cookie configuration - should match
	 *     // configuration used when opt_in_tracking/opt_out_tracking methods were called.
	 *     mixpanel.clear_opt_in_out_tracking({
	 *         cookie_expiration: 30,
	 *         secure_cookie: true
	 *     });
	 *
	 * @param {Object} [options] A dictionary of config options to override
	 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
	 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
	 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
	 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
	 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
	 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
	 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
	 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
	 */
	MixpanelLib.prototype.clear_opt_in_out_tracking = function(options) {
	    options = _.extend({
	        'enable_persistence': true
	    }, options);
	
	    this._gdpr_call_func(clearOptInOut, options);
	    this._gdpr_update_persistence(options);
	};
	
	// EXPORTS (for closure compiler)
	
	// MixpanelLib Exports
	MixpanelLib.prototype['init']                               = MixpanelLib.prototype.init;
	MixpanelLib.prototype['reset']                              = MixpanelLib.prototype.reset;
	MixpanelLib.prototype['disable']                            = MixpanelLib.prototype.disable;
	MixpanelLib.prototype['time_event']                         = MixpanelLib.prototype.time_event;
	MixpanelLib.prototype['track']                              = MixpanelLib.prototype.track;
	MixpanelLib.prototype['track_links']                        = MixpanelLib.prototype.track_links;
	MixpanelLib.prototype['track_forms']                        = MixpanelLib.prototype.track_forms;
	MixpanelLib.prototype['track_pageview']                     = MixpanelLib.prototype.track_pageview;
	MixpanelLib.prototype['register']                           = MixpanelLib.prototype.register;
	MixpanelLib.prototype['register_once']                      = MixpanelLib.prototype.register_once;
	MixpanelLib.prototype['unregister']                         = MixpanelLib.prototype.unregister;
	MixpanelLib.prototype['identify']                           = MixpanelLib.prototype.identify;
	MixpanelLib.prototype['alias']                              = MixpanelLib.prototype.alias;
	MixpanelLib.prototype['name_tag']                           = MixpanelLib.prototype.name_tag;
	MixpanelLib.prototype['set_config']                         = MixpanelLib.prototype.set_config;
	MixpanelLib.prototype['get_config']                         = MixpanelLib.prototype.get_config;
	MixpanelLib.prototype['get_property']                       = MixpanelLib.prototype.get_property;
	MixpanelLib.prototype['get_distinct_id']                    = MixpanelLib.prototype.get_distinct_id;
	MixpanelLib.prototype['toString']                           = MixpanelLib.prototype.toString;
	MixpanelLib.prototype['_check_and_handle_notifications']    = MixpanelLib.prototype._check_and_handle_notifications;
	MixpanelLib.prototype['_handle_user_decide_check_complete'] = MixpanelLib.prototype._handle_user_decide_check_complete;
	MixpanelLib.prototype['_show_notification']                 = MixpanelLib.prototype._show_notification;
	MixpanelLib.prototype['opt_out_tracking']                   = MixpanelLib.prototype.opt_out_tracking;
	MixpanelLib.prototype['opt_in_tracking']                    = MixpanelLib.prototype.opt_in_tracking;
	MixpanelLib.prototype['has_opted_out_tracking']             = MixpanelLib.prototype.has_opted_out_tracking;
	MixpanelLib.prototype['has_opted_in_tracking']              = MixpanelLib.prototype.has_opted_in_tracking;
	MixpanelLib.prototype['clear_opt_in_out_tracking']          = MixpanelLib.prototype.clear_opt_in_out_tracking;
	MixpanelLib.prototype['get_group']                          = MixpanelLib.prototype.get_group;
	MixpanelLib.prototype['set_group']                          = MixpanelLib.prototype.set_group;
	MixpanelLib.prototype['add_group']                          = MixpanelLib.prototype.add_group;
	MixpanelLib.prototype['remove_group']                       = MixpanelLib.prototype.remove_group;
	MixpanelLib.prototype['track_with_groups']                  = MixpanelLib.prototype.track_with_groups;
	MixpanelLib.prototype['start_batch_senders']                = MixpanelLib.prototype.start_batch_senders;
	MixpanelLib.prototype['stop_batch_senders']                 = MixpanelLib.prototype.stop_batch_senders;
	
	// MixpanelPersistence Exports
	MixpanelPersistence.prototype['properties']            = MixpanelPersistence.prototype.properties;
	MixpanelPersistence.prototype['update_search_keyword'] = MixpanelPersistence.prototype.update_search_keyword;
	MixpanelPersistence.prototype['update_referrer_info']  = MixpanelPersistence.prototype.update_referrer_info;
	MixpanelPersistence.prototype['get_cross_subdomain']   = MixpanelPersistence.prototype.get_cross_subdomain;
	MixpanelPersistence.prototype['clear']                 = MixpanelPersistence.prototype.clear;
	
	_.safewrap_class(MixpanelLib, ['identify', '_check_and_handle_notifications', '_show_notification']);
	
	
	var instances = {};
	var extend_mp = function() {
	    // add all the sub mixpanel instances
	    _.each(instances, function(instance, name) {
	        if (name !== PRIMARY_INSTANCE_NAME) { mixpanel_master[name] = instance; }
	    });
	
	    // add private functions as _
	    mixpanel_master['_'] = _;
	};
	
	var override_mp_init_func = function() {
	    // we override the snippets init function to handle the case where a
	    // user initializes the mixpanel library after the script loads & runs
	    mixpanel_master['init'] = function(token, config, name) {
	        if (name) {
	            // initialize a sub library
	            if (!mixpanel_master[name]) {
	                mixpanel_master[name] = instances[name] = create_mplib(token, config, name);
	                mixpanel_master[name]._loaded();
	            }
	            return mixpanel_master[name];
	        } else {
	            var instance = mixpanel_master;
	
	            if (instances[PRIMARY_INSTANCE_NAME]) {
	                // main mixpanel lib already initialized
	                instance = instances[PRIMARY_INSTANCE_NAME];
	            } else if (token) {
	                // intialize the main mixpanel lib
	                instance = create_mplib(token, config, PRIMARY_INSTANCE_NAME);
	                instance._loaded();
	                instances[PRIMARY_INSTANCE_NAME] = instance;
	            }
	
	            mixpanel_master = instance;
	            if (init_type === INIT_SNIPPET) {
	                window$1[PRIMARY_INSTANCE_NAME] = mixpanel_master;
	            }
	            extend_mp();
	        }
	    };
	};
	
	var add_dom_loaded_handler = function() {
	    // Cross browser DOM Loaded support
	    function dom_loaded_handler() {
	        // function flag since we only want to execute this once
	        if (dom_loaded_handler.done) { return; }
	        dom_loaded_handler.done = true;
	
	        DOM_LOADED = true;
	        ENQUEUE_REQUESTS = false;
	
	        _.each(instances, function(inst) {
	            inst._dom_loaded();
	        });
	    }
	
	    function do_scroll_check() {
	        try {
	            document$1.documentElement.doScroll('left');
	        } catch(e) {
	            setTimeout(do_scroll_check, 1);
	            return;
	        }
	
	        dom_loaded_handler();
	    }
	
	    if (document$1.addEventListener) {
	        if (document$1.readyState === 'complete') {
	            // safari 4 can fire the DOMContentLoaded event before loading all
	            // external JS (including this file). you will see some copypasta
	            // on the internet that checks for 'complete' and 'loaded', but
	            // 'loaded' is an IE thing
	            dom_loaded_handler();
	        } else {
	            document$1.addEventListener('DOMContentLoaded', dom_loaded_handler, false);
	        }
	    } else if (document$1.attachEvent) {
	        // IE
	        document$1.attachEvent('onreadystatechange', dom_loaded_handler);
	
	        // check to make sure we arn't in a frame
	        var toplevel = false;
	        try {
	            toplevel = window$1.frameElement === null;
	        } catch(e) {
	            // noop
	        }
	
	        if (document$1.documentElement.doScroll && toplevel) {
	            do_scroll_check();
	        }
	    }
	
	    // fallback handler, always will work
	    _.register_event(window$1, 'load', dom_loaded_handler, true);
	};
	
	function init_as_module() {
	    init_type = INIT_MODULE;
	    mixpanel_master = new MixpanelLib();
	
	    override_mp_init_func();
	    mixpanel_master['init']();
	    add_dom_loaded_handler();
	
	    return mixpanel_master;
	}
	
	var mixpanel = init_as_module();
	
	module.exports = mixpanel;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var gtmWidget = __webpack_require__(766);
	var GtmAnalyticsProvider = (function () {
	    function GtmAnalyticsProvider(token) {
	        this.widget = gtmWidget;
	        this.widget.init(token);
	    }
	    GtmAnalyticsProvider.prototype.trackEvent = function (event_type, event_data, cb) {
	    };
	    return GtmAnalyticsProvider;
	}());
	exports.GtmAnalyticsProvider = GtmAnalyticsProvider;


/***/ }),
/* 766 */
/***/ (function(module, exports) {

	module.exports.init = function (token) {
	    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
	            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
	        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
	        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
	    })(window,document,'script','dataLayer', token);
	};


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(743);
	var forms_1 = __webpack_require__(768);
	var lodash_1 = __webpack_require__(268);
	var validators_1 = __webpack_require__(769);
	var FormDefinitionControl = (function () {
	    function FormDefinitionControl() {
	        this.controls = [];
	    }
	    FormDefinitionControl.prototype.unRegister = function () {
	        FormUtils.unRegister(this.form, this.controls, this.validation);
	    };
	    FormDefinitionControl.prototype.setFormGroup = function (form) {
	        this.form = form;
	    };
	    FormDefinitionControl.prototype.getFormGroup = function () {
	        return this.form;
	    };
	    FormDefinitionControl.prototype.putControlName = function (control) {
	        this.controls.push(control);
	    };
	    FormDefinitionControl.prototype.setFormGroupValidation = function (validator) {
	        this.validation = validator;
	    };
	    return FormDefinitionControl;
	}());
	exports.FormDefinitionControl = FormDefinitionControl;
	var FormUtils = (function () {
	    function FormUtils() {
	    }
	    FormUtils.updateValidity = function (form, control, timeout) {
	        if (lodash_1.isNil(timeout)) {
	            timeout = true;
	        }
	        var updateFun = function () { return form.controls[control].updateValueAndValidity({ onlySelf: true }); };
	        if (timeout) {
	            setTimeout(updateFun);
	        }
	        else {
	            updateFun();
	        }
	    };
	    FormUtils.markAsTouched = function (form) {
	        if (form) {
	            for (var control in form.controls) {
	                var c = form.controls[control];
	                if (c instanceof forms_1.FormControl) {
	                    c.markAsTouched({ onlySelf: true });
	                }
	                else {
	                    FormUtils.markAsTouched(c);
	                }
	            }
	        }
	    };
	    FormUtils.isValidControl = function (control) {
	        return control && control.valid;
	    };
	    FormUtils.isValidControls = function (controls) {
	        for (var _i = 0, controls_1 = controls; _i < controls_1.length; _i++) {
	            var control = controls_1[_i];
	            if (!FormUtils.isValidControl(control)) {
	                return false;
	            }
	        }
	        return true;
	    };
	    FormUtils.isValid = function (form, considerFormItself) {
	        if (considerFormItself === void 0) { considerFormItself = false; }
	        var valid = true;
	        if (form) {
	            for (var control in form.controls) {
	                form.controls[control].markAsTouched({ onlySelf: true });
	                if (!form.controls[control].valid && form.controls[control].enabled) {
	                    valid = false;
	                }
	            }
	        }
	        console.log('is Valid form: ' + valid && (considerFormItself ? form.valid : true));
	        return valid && (considerFormItself ? form.valid : true);
	    };
	    FormUtils.register = function (form, controls, validator) {
	        var definition = new FormDefinitionControl;
	        definition.setFormGroup(form);
	        for (var control in controls) {
	            definition.putControlName(control);
	            var config = controls[control] || {};
	            form.registerControl(control, new forms_1.FormControl(FormUtils.toFormState(config), FormUtils.toFormValidator(config), FormUtils.toFormAsyncValidator(config)));
	        }
	        definition.setFormGroupValidation(form.validator);
	        form.setValidators(forms_1.Validators.compose([form.validator, validator]));
	        return definition;
	    };
	    FormUtils.unRegister = function (form, controls, validator) {
	        form.setValidators(validator);
	        for (var _i = 0, controls_2 = controls; _i < controls_2.length; _i++) {
	            var control = controls_2[_i];
	            form.removeControl(control);
	        }
	    };
	    FormUtils.validateIf = function (checkFn, validators) {
	        return function (control) {
	            if (checkFn(control))
	                return forms_1.Validators.compose(validators);
	        };
	    };
	    FormUtils.disableEnableControls = function (form, targetControlName, enableDisableControlNames) {
	        var enableDisableControls = enableDisableControlNames.map(function (name) { return form.get(name); });
	        var targetControl = form.get(targetControlName);
	        var subscription = targetControl.valueChanges.subscribe(function (val) {
	            enableDisableControls.map(function (control) {
	                val ? control.enable() : control.disable();
	            });
	        });
	        targetControl.updateValueAndValidity();
	        return subscription;
	    };
	    FormUtils.toFormState = function (config) {
	        return {
	            value: config.value,
	            disabled: config.disabled || false
	        };
	    };
	    FormUtils.toFormValidator = function (config) {
	        var validators = [];
	        for (var validator in config.validation) {
	            var validatorFn = FormUtils.getFormValidator(validator, config.validation[validator]);
	            if (!util_1.isNullOrUndefined(validatorFn))
	                validators.push(validatorFn);
	        }
	        return forms_1.Validators.compose(validators);
	    };
	    FormUtils.getFormValidator = function (name, value) {
	        switch (name) {
	            case 'required':
	                return value && forms_1.Validators.required;
	            case 'requiredTrue':
	                return value && forms_1.Validators.requiredTrue;
	            case 'minlength':
	                return lodash_1.isFunction(value) ? value : forms_1.Validators.minLength(Number(value));
	            case 'maxlength':
	                return lodash_1.isFunction(value) ? value : forms_1.Validators.maxLength(Number(value));
	            case 'pattern':
	                return forms_1.Validators.pattern(value);
	            case 'match':
	                return validators_1.matchValidatorFactory(value);
	            case 'nullValidator':
	                return value && forms_1.Validators.nullValidator;
	            default:
	                if (lodash_1.isFunction(value)) {
	                    return value;
	                }
	        }
	    };
	    FormUtils.toFormAsyncValidator = function (config) {
	        var validators = [];
	        if (config.validationAsync) {
	            for (var validator in config.validationAsync) {
	                if (!util_1.isNullOrUndefined(config.validationAsync[validator]))
	                    validators.push(config.validationAsync[validator]);
	            }
	        }
	        return forms_1.Validators.composeAsync(validators);
	    };
	    FormUtils.configItemMapAction = function (src, config, action) {
	        Object.keys(src)
	            .map(function (k) {
	            var val = src[k];
	            return {
	                val: val,
	                enable: util_1.isNullOrUndefined(config[val]) || config[val].enable
	            };
	        })
	            .filter(function (kv) { return kv.enable; })
	            .forEach(function (kv) { return action(kv.val); });
	    };
	    return FormUtils;
	}());
	exports.FormUtils = FormUtils;


/***/ }),
/* 768 */,
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(770));
	__export(__webpack_require__(771));
	__export(__webpack_require__(826));
	__export(__webpack_require__(827));
	__export(__webpack_require__(828));
	__export(__webpack_require__(772));
	__export(__webpack_require__(773));
	__export(__webpack_require__(830));
	__export(__webpack_require__(831));


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var type_validators_1 = __webpack_require__(771);
	var PROVIDER_VALIDATOR = {
	    provide: forms_1.NG_VALIDATORS,
	    useExisting: core_1.forwardRef(function () { return TypeValidator; }),
	    multi: true
	};
	/**
	 * Directive, which adds validators by type attribute
	 */
	var TypeValidator = (function () {
	    function TypeValidator() {
	    }
	    TypeValidator.prototype.validate = function (control) {
	        if (type_validators_1.TYPE_VALIDATORS[this.validatorType]) {
	            return type_validators_1.TYPE_VALIDATORS[this.validatorType](control);
	        }
	        else {
	            return null;
	        }
	    };
	    __decorate([
	        core_1.Input('type'),
	        __metadata("design:type", String)
	    ], TypeValidator.prototype, "validatorType", void 0);
	    TypeValidator = __decorate([
	        core_1.Directive({
	            selector: '[type]',
	            providers: [PROVIDER_VALIDATOR]
	        })
	    ], TypeValidator);
	    return TypeValidator;
	}());
	exports.TypeValidator = TypeValidator;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var email_validator_1 = __webpack_require__(772);
	var phone_validator_1 = __webpack_require__(773);
	/*
	 Validators map (key is attribute value of 'type')
	 For example: <input type='email' .../> will receive EmailValidator.validate validator
	 */
	exports.TYPE_VALIDATORS = {
	    email: email_validator_1.EmailValidator.validate,
	    phone: phone_validator_1.PhoneValidator.validate
	};


/***/ }),
/* 772 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 Validator for email value
	 */
	var EmailValidator = (function () {
	    function EmailValidator() {
	    }
	    EmailValidator.validate = function (c) {
	        var EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	        var isValid = c.value == null || c.value.length === 0 || EMAIL_REGEXP.test(c.value);
	        return isValid ? null : {
	            email: {
	                valid: false
	            }
	        };
	    };
	    return EmailValidator;
	}());
	exports.EmailValidator = EmailValidator;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var libphonenumber_js_1 = __webpack_require__(774);
	/*
	 Validator for phone value
	 */
	var PhoneValidator = (function () {
	    function PhoneValidator() {
	    }
	    PhoneValidator.validate = function (c) {
	        var isValid = c.value == null || c.value.length === 0 || libphonenumber_js_1.isValidNumber(libphonenumber_js_1.parse(c.value));
	        return isValid ? null : { phone: true };
	    };
	    return PhoneValidator;
	}());
	exports.PhoneValidator = PhoneValidator;


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	// Deprecated.
	// Use `libphonenumber-js/min` or `libphonenumber-js/max` or `libphonenumber-js/core` instead.
	
	'use strict'
	
	var custom   = __webpack_require__(775)
	var metadata = __webpack_require__(825)
	
	exports = module.exports = {}
	
	exports.ParseError = custom.ParseError
	
	exports.parsePhoneNumber = function parsePhoneNumber()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.parsePhoneNumber.apply(this, parameters)
	}
	
	exports.parsePhoneNumberFromString = function parsePhoneNumberFromString()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.parsePhoneNumberFromString.apply(this, parameters)
	}
	// Deprecated: remove `parse()` export in 2.0.0.
	// (renamed to `parseNumber()`)
	exports.parse = function parse()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.parseNumber.apply(this, parameters)
	}
	
	exports.parseNumber = function parseNumber()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.parseNumber.apply(this, parameters)
	}
	
	// Deprecated: remove `format()` export in 2.0.0.
	// (renamed to `formatNumber()`)
	exports.format = function format()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.formatNumber.apply(this, parameters)
	}
	
	exports.formatNumber = function formatNumber()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.formatNumber.apply(this, parameters)
	}
	
	exports.getNumberType = function getNumberType()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.getNumberType.apply(this, parameters)
	}
	
	exports.getExampleNumber = function getExampleNumber()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.getExampleNumber.apply(this, parameters)
	}
	
	exports.isPossibleNumber = function isPossibleNumber()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.isPossibleNumber.apply(this, parameters)
	}
	
	exports.isValidNumber = function isValidNumber()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.isValidNumber.apply(this, parameters)
	}
	
	exports.isValidNumberForRegion = function isValidNumberForRegion()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.isValidNumberForRegion.apply(this, parameters)
	}
	
	// Deprecated.
	exports.findPhoneNumbers = function findPhoneNumbers()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.findPhoneNumbers.apply(this, parameters)
	}
	
	// Deprecated.
	exports.searchPhoneNumbers = function searchPhoneNumbers()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.searchPhoneNumbers.apply(this, parameters)
	}
	
	// Deprecated.
	exports.PhoneNumberSearch = function PhoneNumberSearch(text, options)
	{
		custom.PhoneNumberSearch.call(this, text, options, metadata)
	}
	
	// Deprecated.
	exports.PhoneNumberSearch.prototype = Object.create(custom.PhoneNumberSearch.prototype, {})
	exports.PhoneNumberSearch.prototype.constructor = exports.PhoneNumberSearch
	
	exports.findNumbers = function findPhoneNumbers()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.findNumbers.apply(this, parameters)
	}
	
	exports.searchNumbers = function searchPhoneNumbers()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.searchNumbers.apply(this, parameters)
	}
	
	exports.findPhoneNumbersInText = function findPhoneNumbersInText()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.findPhoneNumbersInText.apply(this, parameters)
	}
	
	exports.searchPhoneNumbersInText = function searchPhoneNumbersInText()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.searchPhoneNumbersInText.apply(this, parameters)
	}
	
	exports.PhoneNumberMatcher = function PhoneNumberMatcher(text, options)
	{
		custom.PhoneNumberMatcher.call(this, text, options, metadata)
	}
	
	exports.PhoneNumberMatcher.prototype = Object.create(custom.PhoneNumberMatcher.prototype, {})
	exports.PhoneNumberMatcher.prototype.constructor = exports.PhoneNumberMatcher
	
	exports.AsYouType = function AsYouType(country)
	{
		custom.AsYouType.call(this, country, metadata)
	}
	
	exports.AsYouType.prototype = Object.create(custom.AsYouType.prototype, {})
	exports.AsYouType.prototype.constructor = exports.AsYouType
	
	exports.isSupportedCountry = function()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.isSupportedCountry.apply(this, parameters)
	}
	
	exports.getExtPrefix = function()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.getExtPrefix.apply(this, parameters)
	}
	
	exports.parseRFC3966 = function()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.parseRFC3966.apply(this, parameters)
	}
	
	exports.formatRFC3966 = function()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.formatRFC3966.apply(this, parameters)
	}
	
	// Deprecated: `DIGITS` were used by `react-phone-number-input`.
	// Replaced by `parseDigits()`.
	//
	// Deprecated: `DIGIT_PLACEHOLDER` was used by `react-phone-number-input`.
	// Not used anymore.
	//
	exports.DIGITS = custom.DIGITS
	exports.DIGIT_PLACEHOLDER = custom.DIGIT_PLACEHOLDER
	
	exports.getCountries = function()
	{
		return custom.getCountries(metadata)
	}
	
	exports.getCountryCallingCode = function(country)
	{
		return custom.getCountryCallingCode(country, metadata)
	}
	
	// `getPhoneCode` name is deprecated
	exports.getPhoneCode = exports.getCountryCallingCode
	
	exports.formatIncompletePhoneNumber = function()
	{
		var parameters = Array.prototype.slice.call(arguments)
		parameters.push(metadata)
		return custom.formatIncompletePhoneNumber.apply(this, parameters)
	}
	
	exports.parseIncompletePhoneNumber = custom.parseIncompletePhoneNumber
	exports.parsePhoneNumberCharacter = custom.parsePhoneNumberCharacter
	exports.parseDigits = custom.parseDigits

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	// Deprecated.
	// Use `libphonenumber-js/min` or `libphonenumber-js/max` or `libphonenumber-js/core` instead.
	
	'use strict'
	
	exports = module.exports = {}
	
	exports.ParseError = __webpack_require__(776).default
	exports.parsePhoneNumber = __webpack_require__(777).default
	exports.parsePhoneNumberFromString = __webpack_require__(797).default
	
	// Deprecated: remove `parse()` export in 2.0.0.
	// (renamed to `parseNumber()`)
	exports.parse              = __webpack_require__(799).default
	exports.parseNumber        = __webpack_require__(799).default
	// Deprecated: remove `format()` export in 2.0.0.
	// (renamed to `formatNumber()`)
	exports.format             = __webpack_require__(800).default
	exports.formatNumber       = __webpack_require__(800).default
	exports.getNumberType      = __webpack_require__(801).default
	exports.getExampleNumber   = __webpack_require__(802).default
	exports.isPossibleNumber   = __webpack_require__(803).default
	exports.isValidNumber      = __webpack_require__(804).default
	exports.isValidNumberForRegion = __webpack_require__(805).default
	
	exports.findNumbers        = __webpack_require__(806).default
	exports.searchNumbers      = __webpack_require__(817).default
	exports.findPhoneNumbersInText = __webpack_require__(818).default
	exports.searchPhoneNumbersInText = __webpack_require__(819).default
	exports.PhoneNumberMatcher = __webpack_require__(808).default
	
	// Deprecated.
	exports.findPhoneNumbers   = __webpack_require__(820).default
	exports.searchPhoneNumbers = __webpack_require__(820).searchPhoneNumbers
	exports.PhoneNumberSearch  = __webpack_require__(821).PhoneNumberSearch
	
	exports.AsYouType = __webpack_require__(822).default
	
	exports.formatIncompletePhoneNumber = __webpack_require__(823).default
	exports.parseIncompletePhoneNumber  = __webpack_require__(786).default
	exports.parsePhoneNumberCharacter   = __webpack_require__(786).parsePhoneNumberCharacter
	exports.parseDigits   = __webpack_require__(787).default
	
	// Deprecated: `DIGITS` were used by `react-phone-number-input`.
	// Replaced by `parseDigits()`.
	//
	// Deprecated: `DIGIT_PLACEHOLDER` was used by `react-phone-number-input`.
	// Not used anymore.
	//
	exports.DIGITS            = __webpack_require__(787).DIGITS
	exports.DIGIT_PLACEHOLDER = __webpack_require__(822).DIGIT_PLACEHOLDER
	
	exports.getCountries = __webpack_require__(824).default
	exports.getCountryCallingCode = __webpack_require__(788).default
	// `getPhoneCode` name is deprecated, use `getCountryCallingCode` instead.
	exports.getPhoneCode = exports.getCountryCallingCode
	
	exports.Metadata = __webpack_require__(782).default
	exports.isSupportedCountry = __webpack_require__(782).isSupportedCountry
	exports.getExtPrefix = __webpack_require__(782).getExtPrefix
	
	exports.parseRFC3966 = __webpack_require__(792).parseRFC3966
	exports.formatRFC3966 = __webpack_require__(792).formatRFC3966
	
	// exports['default'] = ...

/***/ }),
/* 776 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// https://stackoverflow.com/a/46971044/970769
	var ParseError = function ParseError(code) {
	  _classCallCheck(this, ParseError);
	
	  this.name = this.constructor.name;
	  this.message = code;
	  this.stack = new Error(code).stack;
	};
	
	exports["default"] = ParseError;
	ParseError.prototype = Object.create(Error.prototype);
	ParseError.prototype.constructor = ParseError;
	//# sourceMappingURL=ParseError.js.map

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parsePhoneNumber;
	exports.normalizeArguments = normalizeArguments;
	
	var _parsePhoneNumber_ = _interopRequireDefault(__webpack_require__(778));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function parsePhoneNumber() {
	  var _normalizeArguments = normalizeArguments(arguments),
	      text = _normalizeArguments.text,
	      options = _normalizeArguments.options,
	      metadata = _normalizeArguments.metadata;
	
	  return (0, _parsePhoneNumber_["default"])(text, options, metadata);
	}
	
	function normalizeArguments(args) {
	  var _Array$prototype$slic = Array.prototype.slice.call(args),
	      _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4),
	      arg_1 = _Array$prototype$slic2[0],
	      arg_2 = _Array$prototype$slic2[1],
	      arg_3 = _Array$prototype$slic2[2],
	      arg_4 = _Array$prototype$slic2[3];
	
	  var text;
	  var options;
	  var metadata; // If the phone number is passed as a string.
	  // `parsePhoneNumber('88005553535', ...)`.
	
	  if (typeof arg_1 === 'string') {
	    text = arg_1;
	  } else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
	  // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
	
	
	  if (!arg_2 || typeof arg_2 === 'string') {
	    if (arg_4) {
	      options = arg_3;
	      metadata = arg_4;
	    } else {
	      options = undefined;
	      metadata = arg_3;
	    }
	
	    if (arg_2) {
	      options = _objectSpread({
	        defaultCountry: arg_2
	      }, options);
	    }
	  } // `defaultCountry` is not passed.
	  // Example: `parsePhoneNumber('+78005553535', [options], metadata)`.
	  else if (isObject(arg_2)) {
	      if (arg_3) {
	        options = arg_2;
	        metadata = arg_3;
	      } else {
	        metadata = arg_2;
	      }
	    } else throw new Error("Invalid second argument: ".concat(arg_2));
	
	  return {
	    text: text,
	    options: options,
	    metadata: metadata
	  };
	} // Otherwise istanbul would show this as "branch not covered".
	
	/* istanbul ignore next */
	
	
	var isObject = function isObject(_) {
	  return _typeof(_) === 'object';
	};
	//# sourceMappingURL=parsePhoneNumber.js.map

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parsePhoneNumber;
	
	var _parse_ = _interopRequireDefault(__webpack_require__(779));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function parsePhoneNumber(text, options, metadata) {
	  return (0, _parse_["default"])(text, _objectSpread({}, options, {
	    v2: true
	  }), metadata);
	}
	//# sourceMappingURL=parsePhoneNumber_.js.map

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parse;
	exports.extractFormattedPhoneNumber = extractFormattedPhoneNumber;
	exports.stripNationalPrefixAndCarrierCode = stripNationalPrefixAndCarrierCode;
	exports.findCountryCode = findCountryCode;
	exports.stripNationalPrefixAndCarrierCodeFromCompleteNumber = stripNationalPrefixAndCarrierCodeFromCompleteNumber;
	exports.extractCountryCallingCode = extractCountryCallingCode;
	exports.extractCountryCallingCodeFromInternationalNumberWithoutPlusSign = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign;
	
	var _constants = __webpack_require__(780);
	
	var _util = __webpack_require__(781);
	
	var _ParseError = _interopRequireDefault(__webpack_require__(776));
	
	var _metadata = _interopRequireDefault(__webpack_require__(782));
	
	var _isViablePhoneNumber = _interopRequireDefault(__webpack_require__(784));
	
	var _extension = __webpack_require__(785);
	
	var _parseIncompletePhoneNumber = _interopRequireDefault(__webpack_require__(786));
	
	var _getCountryCallingCode = _interopRequireDefault(__webpack_require__(788));
	
	var _getNumberType_ = _interopRequireWildcard(__webpack_require__(789));
	
	var _isPossibleNumber_ = __webpack_require__(790);
	
	var _IDD = __webpack_require__(791);
	
	var _RFC = __webpack_require__(792);
	
	var _PhoneNumber = _interopRequireDefault(__webpack_require__(793));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// This is a port of Google Android `libphonenumber`'s
	// `phonenumberutil.js` of December 31th, 2018.
	//
	// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
	// We don't allow input strings for parsing to be longer than 250 chars.
	// This prevents malicious input from consuming CPU.
	var MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
	
	var PHONE_NUMBER_START_PATTERN = new RegExp('[' + _constants.PLUS_CHARS + _constants.VALID_DIGITS + ']'); // Regular expression of trailing characters that we want to remove.
	
	var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + _constants.VALID_DIGITS + ']+$');
	var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // `options`:
	//  {
	//    country:
	//    {
	//      restrict - (a two-letter country code)
	//                 the phone number must be in this country
	//
	//      default - (a two-letter country code)
	//                default country to use for phone number parsing and validation
	//                (if no country code could be derived from the phone number)
	//    }
	//  }
	//
	// Returns `{ country, number }`
	//
	// Example use cases:
	//
	// ```js
	// parse('8 (800) 555-35-35', 'RU')
	// parse('8 (800) 555-35-35', 'RU', metadata)
	// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
	// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
	// parse('+7 800 555 35 35')
	// parse('+7 800 555 35 35', metadata)
	// ```
	//
	
	function parse(text, options, metadata) {
	  // If assigning the `{}` default value is moved to the arguments above,
	  // code coverage would decrease for some weird reason.
	  options = options || {};
	  metadata = new _metadata["default"](metadata); // Validate `defaultCountry`.
	
	  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
	    if (options.v2) {
	      throw new _ParseError["default"]('INVALID_COUNTRY');
	    }
	
	    throw new Error("Unknown country: ".concat(options.defaultCountry));
	  } // Parse the phone number.
	
	
	  var _parseInput = parseInput(text, options.v2),
	      formattedPhoneNumber = _parseInput.number,
	      ext = _parseInput.ext; // If the phone number is not viable then return nothing.
	
	
	  if (!formattedPhoneNumber) {
	    if (options.v2) {
	      throw new _ParseError["default"]('NOT_A_NUMBER');
	    }
	
	    return {};
	  }
	
	  var _parsePhoneNumber = parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata),
	      country = _parsePhoneNumber.country,
	      nationalNumber = _parsePhoneNumber.nationalNumber,
	      countryCallingCode = _parsePhoneNumber.countryCallingCode,
	      carrierCode = _parsePhoneNumber.carrierCode;
	
	  if (!metadata.hasSelectedNumberingPlan()) {
	    if (options.v2) {
	      throw new _ParseError["default"]('INVALID_COUNTRY');
	    }
	
	    return {};
	  } // Validate national (significant) number length.
	
	
	  if (!nationalNumber || nationalNumber.length < _constants.MIN_LENGTH_FOR_NSN) {
	    // Won't throw here because the regexp already demands length > 1.
	
	    /* istanbul ignore if */
	    if (options.v2) {
	      throw new _ParseError["default"]('TOO_SHORT');
	    } // Google's demo just throws an error in this case.
	
	
	    return {};
	  } // Validate national (significant) number length.
	  //
	  // A sidenote:
	  //
	  // They say that sometimes national (significant) numbers
	  // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
	  // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
	  // Such numbers will just be discarded.
	  //
	
	
	  if (nationalNumber.length > _constants.MAX_LENGTH_FOR_NSN) {
	    if (options.v2) {
	      throw new _ParseError["default"]('TOO_LONG');
	    } // Google's demo just throws an error in this case.
	
	
	    return {};
	  }
	
	  if (options.v2) {
	    var phoneNumber = new _PhoneNumber["default"](countryCallingCode, nationalNumber, metadata.metadata);
	
	    if (country) {
	      phoneNumber.country = country;
	    }
	
	    if (carrierCode) {
	      phoneNumber.carrierCode = carrierCode;
	    }
	
	    if (ext) {
	      phoneNumber.ext = ext;
	    }
	
	    return phoneNumber;
	  } // Check if national phone number pattern matches the number.
	  // National number pattern is different for each country,
	  // even for those ones which are part of the "NANPA" group.
	
	
	  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, _util.matchesEntirely)(nationalNumber, metadata.nationalNumberPattern()) : false;
	
	  if (!options.extended) {
	    return valid ? result(country, nationalNumber, ext) : {};
	  }
	
	  return {
	    country: country,
	    countryCallingCode: countryCallingCode,
	    carrierCode: carrierCode,
	    valid: valid,
	    possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, _isPossibleNumber_.isPossibleNumber)(nationalNumber, countryCallingCode !== undefined, metadata) ? true : false,
	    phone: nationalNumber,
	    ext: ext
	  };
	}
	/**
	 * Extracts a formatted phone number from text.
	 * Doesn't guarantee that the extracted phone number
	 * is a valid phone number (for example, doesn't validate its length).
	 * @param  {string} text
	 * @param  {boolean} throwOnError — By default, it won't throw if the text is too long.
	 * @return {string}
	 * @example
	 * // Returns "(213) 373-4253".
	 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
	 */
	
	
	function extractFormattedPhoneNumber(text, throwOnError) {
	  if (!text) {
	    return;
	  }
	
	  if (text.length > MAX_INPUT_STRING_LENGTH) {
	    if (throwOnError) {
	      throw new _ParseError["default"]('TOO_LONG');
	    }
	
	    return;
	  } // Attempt to extract a possible number from the string passed in
	
	
	  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);
	
	  if (startsAt < 0) {
	    return;
	  }
	
	  return text // Trim everything to the left of the phone number
	  .slice(startsAt) // Remove trailing non-numerical characters
	  .replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
	}
	/**
	 * Strips any national prefix (such as 0, 1) present in a
	 * (possibly incomplete) number provided.
	 * "Carrier codes" are only used  in Colombia and Brazil,
	 * and only when dialing within those countries from a mobile phone to a fixed line number.
	 * Sometimes it won't actually strip national prefix
	 * and will instead prepend some digits to the `number`:
	 * for example, when number `2345678` is passed with `VI` country selected,
	 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
	 * @param {string} number — National number digits.
	 * @param {object} metadata — Metadata with country selected.
	 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
	 */
	
	
	function stripNationalPrefixAndCarrierCode(number, metadata) {
	  if (number && metadata.nationalPrefixForParsing()) {
	    // See METADATA.md for the description of
	    // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
	    // Attempt to parse the first digits as a national prefix.
	    var prefixPattern = new RegExp('^(?:' + metadata.nationalPrefixForParsing() + ')');
	    var prefixMatch = prefixPattern.exec(number);
	
	    if (prefixMatch) {
	      var nationalNumber;
	      var carrierCode; // If a "capturing group" didn't match
	      // then its element in `prefixMatch[]` array will be `undefined`.
	
	      var capturedGroupsCount = prefixMatch.length - 1;
	
	      if (metadata.nationalPrefixTransformRule() && capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount]) {
	        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // Carrier code is the last captured group,
	        // but only when there's more than one captured group.
	
	        if (capturedGroupsCount > 1 && prefixMatch[capturedGroupsCount]) {
	          carrierCode = prefixMatch[1];
	        }
	      } // If it's a simple-enough case then just
	      // strip the national prefix from the number.
	      else {
	          // National prefix is the whole substring matched by
	          // the `national_prefix_for_parsing` regexp.
	          var nationalPrefix = prefixMatch[0];
	          nationalNumber = number.slice(nationalPrefix.length); // Carrier code is the last captured group.
	
	          if (capturedGroupsCount > 0) {
	            carrierCode = prefixMatch[1];
	          }
	        } // We require that the national (significant) number remaining after
	      // stripping the national prefix and carrier code be long enough
	      // to be a possible length for the region. Otherwise, we don't do
	      // the stripping, since the original number could be a valid number.
	      // For example, in some countries (Russia, Belarus) the same digit
	      // could be both a national prefix and a leading digit of a valid
	      // national phone number, like `8` is the national prefix for Russia
	      // and `800 555 35 35` is a valid national (significant) number.
	
	
	      if ((0, _util.matchesEntirely)(number, metadata.nationalNumberPattern()) && !(0, _util.matchesEntirely)(nationalNumber, metadata.nationalNumberPattern())) {// Don't strip national prefix or carrier code.
	      } else {
	        return {
	          nationalNumber: nationalNumber,
	          carrierCode: carrierCode
	        };
	      }
	    }
	  }
	
	  return {
	    nationalNumber: number
	  };
	}
	
	function findCountryCode(callingCode, nationalPhoneNumber, metadata) {
	  /* istanbul ignore if */
	  if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
	    if (metadata.isNonGeographicCallingCode(callingCode)) {
	      return '001';
	    }
	  } // Is always non-empty, because `callingCode` is always valid
	
	
	  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
	
	  if (!possibleCountries) {
	    return;
	  } // If there's just one country corresponding to the country code,
	  // then just return it, without further phone number digits validation.
	
	
	  if (possibleCountries.length === 1) {
	    return possibleCountries[0];
	  }
	
	  return _findCountryCode(possibleCountries, nationalPhoneNumber, metadata.metadata);
	} // Changes `metadata` `country`.
	
	
	function _findCountryCode(possibleCountries, nationalPhoneNumber, metadata) {
	  metadata = new _metadata["default"](metadata);
	
	  for (var _iterator = possibleCountries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var country = _ref;
	    metadata.country(country); // Leading digits check would be the simplest one
	
	    if (metadata.leadingDigits()) {
	      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
	        return country;
	      }
	    } // Else perform full validation with all of those
	    // fixed-line/mobile/etc regular expressions.
	    else if ((0, _getNumberType_["default"])({
	        phone: nationalPhoneNumber,
	        country: country
	      }, undefined, metadata.metadata)) {
	        return country;
	      }
	  }
	}
	/**
	 * @param  {string} text - Input.
	 * @return {object} `{ ?number, ?ext }`.
	 */
	
	
	function parseInput(text, v2) {
	  // Parse RFC 3966 phone number URI.
	  if (text && text.indexOf('tel:') === 0) {
	    return (0, _RFC.parseRFC3966)(text);
	  }
	
	  var number = extractFormattedPhoneNumber(text, v2); // If the phone number is not viable, then abort.
	
	  if (!number || !(0, _isViablePhoneNumber["default"])(number)) {
	    return {};
	  } // Attempt to parse extension first, since it doesn't require region-specific
	  // data and we want to have the non-normalised number here.
	
	
	  var withExtensionStripped = (0, _extension.extractExtension)(number);
	
	  if (withExtensionStripped.ext) {
	    return withExtensionStripped;
	  }
	
	  return {
	    number: number
	  };
	}
	/**
	 * Creates `parse()` result object.
	 */
	
	
	function result(country, nationalNumber, ext) {
	  var result = {
	    country: country,
	    phone: nationalNumber
	  };
	
	  if (ext) {
	    result.ext = ext;
	  }
	
	  return result;
	}
	/**
	 * Parses a viable phone number.
	 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
	 * @param {string} [defaultCountry]
	 * @param {string} [defaultCallingCode]
	 * @param {Metadata} metadata
	 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
	 */
	
	
	function parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
	  // Extract calling code from phone number.
	  var _extractCountryCallin = extractCountryCallingCode((0, _parseIncompletePhoneNumber["default"])(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata),
	      countryCallingCode = _extractCountryCallin.countryCallingCode,
	      number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
	
	
	  var country;
	
	  if (countryCallingCode) {
	    metadata.chooseCountryByCountryCallingCode(countryCallingCode);
	  } // If `formattedPhoneNumber` is in "national" format
	  // then `number` is defined and `countryCallingCode` isn't.
	  else if (number && (defaultCountry || defaultCallingCode)) {
	      metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
	
	      if (defaultCountry) {
	        country = defaultCountry;
	      } else {
	        /* istanbul ignore if */
	        if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
	          if (metadata.isNonGeographicCallingCode(defaultCallingCode)) {
	            country = '001';
	          }
	        }
	      }
	
	      countryCallingCode = defaultCallingCode || (0, _getCountryCallingCode["default"])(defaultCountry, metadata.metadata);
	    } else return {};
	
	  if (!number) {
	    return {
	      countryCallingCode: countryCallingCode
	    };
	  }
	
	  var _stripNationalPrefixA = stripNationalPrefixAndCarrierCodeFromCompleteNumber((0, _parseIncompletePhoneNumber["default"])(number), metadata),
	      nationalNumber = _stripNationalPrefixA.nationalNumber,
	      carrierCode = _stripNationalPrefixA.carrierCode; // Sometimes there are several countries
	  // corresponding to the same country phone code
	  // (e.g. NANPA countries all having `1` country phone code).
	  // Therefore, to reliably determine the exact country,
	  // national (significant) number should have been parsed first.
	  //
	  // When `metadata.json` is generated, all "ambiguous" country phone codes
	  // get their countries populated with the full set of
	  // "phone number type" regular expressions.
	  //
	
	
	  var exactCountry = findCountryCode(countryCallingCode, nationalNumber, metadata);
	
	  if (exactCountry) {
	    country = exactCountry;
	    /* istanbul ignore if */
	
	    if (exactCountry === '001') {// Can't happen with `USE_NON_GEOGRAPHIC_COUNTRY_CODE` being `false`.
	      // If `USE_NON_GEOGRAPHIC_COUNTRY_CODE` is set to `true` for some reason,
	      // then remove the "istanbul ignore if".
	    } else {
	      metadata.country(country);
	    }
	  }
	
	  return {
	    country: country,
	    countryCallingCode: countryCallingCode,
	    nationalNumber: nationalNumber,
	    carrierCode: carrierCode
	  };
	}
	/**
	 * Strips national prefix and carrier code from a complete phone number.
	 * The difference from the non-"FromCompleteNumber" function is that
	 * it won't extract national prefix if the resultant number is too short
	 * to be a complete number for the selected phone numbering plan.
	 * @param  {string} number — Complete phone number digits.
	 * @param  {Metadata} metadata — Metadata with a phone numbering plan selected.
	 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
	 */
	
	
	function stripNationalPrefixAndCarrierCodeFromCompleteNumber(number, metadata) {
	  // Parsing national prefixes and carrier codes
	  // is only required for local phone numbers
	  // but some people don't understand that
	  // and sometimes write international phone numbers
	  // with national prefixes (or maybe even carrier codes).
	  // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
	  // Google's original library forgives such mistakes
	  // and so does this library, because it has been requested:
	  // https://github.com/catamphetamine/libphonenumber-js/issues/127
	  var _stripNationalPrefixA2 = stripNationalPrefixAndCarrierCode((0, _parseIncompletePhoneNumber["default"])(number), metadata),
	      nationalNumber = _stripNationalPrefixA2.nationalNumber,
	      carrierCode = _stripNationalPrefixA2.carrierCode; // If a national prefix has been extracted, check to see
	  // if the resultant number isn't too short.
	
	
	  if (nationalNumber.length !== number.length + (carrierCode ? carrierCode.length : 0)) {
	    // If not using legacy generated metadata (before version `1.0.18`)
	    // then it has "possible lengths", so use those to validate the number length.
	    if (metadata.possibleLengths()) {
	      // "We require that the NSN remaining after stripping the national prefix and
	      // carrier code be long enough to be a possible length for the region.
	      // Otherwise, we don't do the stripping, since the original number could be
	      // a valid short number."
	      // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
	      switch ((0, _getNumberType_.checkNumberLengthForType)(nationalNumber, undefined, metadata)) {
	        case 'TOO_SHORT':
	        case 'INVALID_LENGTH':
	          // case 'IS_POSSIBLE_LOCAL_ONLY':
	          // Don't strip the national prefix.
	          return {
	            nationalNumber: number
	          };
	      }
	    }
	  }
	
	  return {
	    nationalNumber: nationalNumber,
	    carrierCode: carrierCode
	  };
	}
	/**
	 * Converts a phone number digits (possibly with a `+`)
	 * into a calling code and the rest phone number digits.
	 * The "rest phone number digits" could include
	 * a national prefix, carrier code, and national
	 * (significant) number.
	 * @param  {string} number — Phone number digits (possibly with a `+`).
	 * @param  {string} [country] — Default country.
	 * @param  {string} [callingCode] — Default calling code (some phone numbering plans are non-geographic).
	 * @param  {object} metadata
	 * @return {object} `{ countryCallingCode: string?, number: string }`
	 * @example
	 * // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
	 * extractCountryCallingCode('2133734253', 'US', null, metadata)
	 * extractCountryCallingCode('2133734253', null, '1', metadata)
	 * extractCountryCallingCode('+12133734253', null, null, metadata)
	 * extractCountryCallingCode('+12133734253', 'RU', null, metadata)
	 */
	
	
	function extractCountryCallingCode(number, country, callingCode, metadata) {
	  if (!number) {
	    return {};
	  } // If this is not an international phone number,
	  // then either extract an "IDD" prefix, or extract a
	  // country calling code from a number by autocorrecting it
	  // by prepending a leading `+` in cases when it starts
	  // with the country calling code.
	  // https://wikitravel.org/en/International_dialling_prefix
	  // https://github.com/catamphetamine/libphonenumber-js/issues/376
	
	
	  if (number[0] !== '+') {
	    // Convert an "out-of-country" dialing phone number
	    // to a proper international phone number.
	    var numberWithoutIDD = (0, _IDD.stripIDDPrefix)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
	    // convert the number to international one
	    // for subsequent parsing.
	
	    if (numberWithoutIDD && numberWithoutIDD !== number) {
	      number = '+' + numberWithoutIDD;
	    } else {
	      // Check to see if the number starts with the country calling code
	      // for the default country. If so, we remove the country calling code,
	      // and do some checks on the validity of the number before and after.
	      // https://github.com/catamphetamine/libphonenumber-js/issues/376
	      if (country || callingCode) {
	        var _extractCountryCallin2 = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata),
	            countryCallingCode = _extractCountryCallin2.countryCallingCode,
	            shorterNumber = _extractCountryCallin2.number;
	
	        if (countryCallingCode) {
	          return {
	            countryCallingCode: countryCallingCode,
	            number: shorterNumber
	          };
	        }
	      }
	
	      return {
	        number: number
	      };
	    }
	  } // Fast abortion: country codes do not begin with a '0'
	
	
	  if (number[1] === '0') {
	    return {};
	  }
	
	  metadata = new _metadata["default"](metadata); // The thing with country phone codes
	  // is that they are orthogonal to each other
	  // i.e. there's no such country phone code A
	  // for which country phone code B exists
	  // where B starts with A.
	  // Therefore, while scanning digits,
	  // if a valid country code is found,
	  // that means that it is the country code.
	  //
	
	  var i = 2;
	
	  while (i - 1 <= _constants.MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
	    var _countryCallingCode = number.slice(1, i);
	
	    if (metadata.hasCallingCode(_countryCallingCode)) {
	      metadata.selectNumberingPlan(undefined, _countryCallingCode);
	      return {
	        countryCallingCode: _countryCallingCode,
	        number: number.slice(i)
	      };
	    }
	
	    i++;
	  }
	
	  return {};
	}
	/**
	 * Sometimes some people incorrectly input international phone numbers
	 * without the leading `+`. This function corrects such input.
	 * @param  {string} number — Phone number digits.
	 * @param  {string?} country
	 * @param  {string?} callingCode
	 * @param  {object} metadata
	 * @return {object} `{ countryCallingCode: string?, number: string }`.
	 */
	
	
	function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
	  var countryCallingCode = country ? (0, _getCountryCallingCode["default"])(country, metadata) : callingCode;
	
	  if (number.indexOf(countryCallingCode) === 0) {
	    metadata = new _metadata["default"](metadata);
	    metadata.selectNumberingPlan(country, callingCode);
	    var possibleShorterNumber = number.slice(countryCallingCode.length);
	
	    var _stripNationalPrefixA3 = stripNationalPrefixAndCarrierCode(possibleShorterNumber, metadata),
	        possibleShorterNationalNumber = _stripNationalPrefixA3.nationalNumber;
	
	    var _stripNationalPrefixA4 = stripNationalPrefixAndCarrierCode(number, metadata),
	        nationalNumber = _stripNationalPrefixA4.nationalNumber; // If the number was not valid before but is valid now,
	    // or if it was too long before, we consider the number
	    // with the country calling code stripped to be a better result
	    // and keep that instead.
	    // For example, in Germany (+49), `49` is a valid area code,
	    // so if a number starts with `49`, it could be both a valid
	    // national German number or an international number without
	    // a leading `+`.
	
	
	    if (!(0, _util.matchesEntirely)(nationalNumber, metadata.nationalNumberPattern()) && (0, _util.matchesEntirely)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, _getNumberType_.checkNumberLengthForType)(nationalNumber, undefined, metadata) === 'TOO_LONG') {
	      return {
	        countryCallingCode: countryCallingCode,
	        number: possibleShorterNumber
	      };
	    }
	  }
	
	  return {
	    number: number
	  };
	}
	//# sourceMappingURL=parse_.js.map

/***/ }),
/* 780 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PLUS_CHARS = exports.VALID_PUNCTUATION = exports.WHITESPACE = exports.VALID_DIGITS = exports.MAX_LENGTH_COUNTRY_CODE = exports.MAX_LENGTH_FOR_NSN = exports.MIN_LENGTH_FOR_NSN = void 0;
	// The minimum length of the national significant number.
	var MIN_LENGTH_FOR_NSN = 2; // The ITU says the maximum length should be 15,
	// but one can find longer numbers in Germany.
	
	exports.MIN_LENGTH_FOR_NSN = MIN_LENGTH_FOR_NSN;
	var MAX_LENGTH_FOR_NSN = 17; // The maximum length of the country calling code.
	
	exports.MAX_LENGTH_FOR_NSN = MAX_LENGTH_FOR_NSN;
	var MAX_LENGTH_COUNTRY_CODE = 3; // Digits accepted in phone numbers
	// (ascii, fullwidth, arabic-indic, and eastern arabic digits).
	
	exports.MAX_LENGTH_COUNTRY_CODE = MAX_LENGTH_COUNTRY_CODE;
	var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"
	
	exports.VALID_DIGITS = VALID_DIGITS;
	var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
	var SLASHES = "\uFF0F/";
	var DOTS = "\uFF0E.";
	var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
	exports.WHITESPACE = WHITESPACE;
	var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
	
	var TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
	// excludes punctuation found as a leading character only. This consists of dash
	// characters, white space characters, full stops, slashes, square brackets,
	// parentheses and tildes. Full-width variants are also present.
	
	var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
	exports.VALID_PUNCTUATION = VALID_PUNCTUATION;
	var PLUS_CHARS = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')
	
	exports.PLUS_CHARS = PLUS_CHARS;
	//# sourceMappingURL=constants.js.map

/***/ }),
/* 781 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.matchesEntirely = matchesEntirely;
	exports.mergeArrays = mergeArrays;
	
	/**
	 * Checks whether the entire input sequence can be matched
	 * against the regular expression.
	 * @return {boolean}
	 */
	function matchesEntirely(text, regular_expression) {
	  // If assigning the `''` default value is moved to the arguments above,
	  // code coverage would decrease for some weird reason.
	  text = text || '';
	  return new RegExp('^(?:' + regular_expression + ')$').test(text);
	}
	/**
	 * Merges two arrays.
	 * @param  {*} a
	 * @param  {*} b
	 * @return {*}
	 */
	
	
	function mergeArrays(a, b) {
	  var merged = a.slice();
	
	  for (var _iterator = b, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var element = _ref;
	
	    if (a.indexOf(element) < 0) {
	      merged.push(element);
	    }
	  }
	
	  return merged.sort(function (a, b) {
	    return a - b;
	  }); // ES6 version, requires Set polyfill.
	  // let merged = new Set(a)
	  // for (const element of b)
	  // {
	  // 	merged.add(i)
	  // }
	  // return Array.from(merged).sort((a, b) => a - b)
	}
	//# sourceMappingURL=util.js.map

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateMetadata = validateMetadata;
	exports.getExtPrefix = getExtPrefix;
	exports.getCountryCallingCode = getCountryCallingCode;
	exports.isSupportedCountry = isSupportedCountry;
	exports["default"] = void 0;
	
	var _semverCompare = _interopRequireDefault(__webpack_require__(783));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	// Added "possibleLengths" and renamed
	// "country_phone_code_to_countries" to "country_calling_codes".
	var V2 = '1.0.18'; // Added "idd_prefix" and "default_idd_prefix".
	
	var V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.
	
	var V4 = '1.7.35';
	var DEFAULT_EXT_PREFIX = ' ext. ';
	/**
	 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
	 */
	
	var Metadata =
	/*#__PURE__*/
	function () {
	  function Metadata(metadata) {
	    _classCallCheck(this, Metadata);
	
	    validateMetadata(metadata);
	    this.metadata = metadata;
	    setVersion.call(this, metadata);
	  }
	
	  _createClass(Metadata, [{
	    key: "getCountries",
	    value: function getCountries() {
	      return Object.keys(this.metadata.countries).filter(function (_) {
	        return _ !== '001';
	      });
	    }
	  }, {
	    key: "getCountryMetadata",
	    value: function getCountryMetadata(countryCode) {
	      return this.metadata.countries[countryCode];
	    }
	  }, {
	    key: "nonGeographic",
	    value: function nonGeographic() {
	      if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
	      // It's present in metadata generated from `1.7.35` to `1.7.37`.
	
	      return this.metadata.nonGeographic || this.metadata.nonGeographical;
	    }
	  }, {
	    key: "hasCountry",
	    value: function hasCountry(country) {
	      return this.getCountryMetadata(country) !== undefined;
	    }
	  }, {
	    key: "hasCallingCode",
	    value: function hasCallingCode(callingCode) {
	      if (this.getCountryCodesForCallingCode(callingCode)) {
	        return true;
	      }
	
	      if (this.nonGeographic()) {
	        if (this.nonGeographic()[callingCode]) {
	          return true;
	        }
	      } else {
	        // A hacky workaround for old custom metadata (generated before V4).
	        var countryCodes = this.countryCallingCodes()[callingCode];
	
	        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
	          return true;
	        }
	      }
	    }
	  }, {
	    key: "isNonGeographicCallingCode",
	    value: function isNonGeographicCallingCode(callingCode) {
	      if (this.nonGeographic()) {
	        return this.nonGeographic()[callingCode] ? true : false;
	      } else {
	        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
	      }
	    } // Deprecated.
	
	  }, {
	    key: "country",
	    value: function country(countryCode) {
	      return this.selectNumberingPlan(countryCode);
	    }
	  }, {
	    key: "selectNumberingPlan",
	    value: function selectNumberingPlan(countryCode, callingCode) {
	      if (countryCode && countryCode !== '001') {
	        if (!this.hasCountry(countryCode)) {
	          throw new Error("Unknown country: ".concat(countryCode));
	        }
	
	        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
	      } else if (callingCode) {
	        if (!this.hasCallingCode(callingCode)) {
	          throw new Error("Unknown calling code: ".concat(callingCode));
	        }
	
	        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
	      } else {
	        this.numberingPlan = undefined;
	      }
	
	      return this;
	    }
	  }, {
	    key: "getCountryCodesForCallingCode",
	    value: function getCountryCodesForCallingCode(callingCode) {
	      var countryCodes = this.countryCallingCodes()[callingCode];
	
	      if (countryCodes) {
	        // Metadata before V4 included "non-geographic entity" calling codes
	        // inside `country_calling_codes` (for example, `"881":["001"]`).
	        // Now the semantics of `country_calling_codes` has changed:
	        // it's specifically for "countries" now.
	        // Older versions of custom metadata will simply skip parsing
	        // "non-geographic entity" phone numbers with new versions
	        // of this library: it's not considered a bug,
	        // because such numbers are extremely rare,
	        // and developers extremely rarely use custom metadata.
	        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
	          return;
	        }
	
	        return countryCodes;
	      }
	    }
	  }, {
	    key: "getCountryCodeForCallingCode",
	    value: function getCountryCodeForCallingCode(callingCode) {
	      var countryCodes = this.getCountryCodesForCallingCode(callingCode);
	
	      if (countryCodes) {
	        return countryCodes[0];
	      }
	    }
	  }, {
	    key: "getNumberingPlanMetadata",
	    value: function getNumberingPlanMetadata(callingCode) {
	      var countryCode = this.getCountryCodeForCallingCode(callingCode);
	
	      if (countryCode) {
	        return this.getCountryMetadata(countryCode);
	      }
	
	      if (this.nonGeographic()) {
	        var metadata = this.nonGeographic()[callingCode];
	
	        if (metadata) {
	          return metadata;
	        }
	      } else {
	        // A hacky workaround for old custom metadata (generated before V4).
	        var countryCodes = this.countryCallingCodes()[callingCode];
	
	        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
	          return this.metadata.countries['001'];
	        }
	      }
	    } // Deprecated.
	
	  }, {
	    key: "countryCallingCode",
	    value: function countryCallingCode() {
	      return this.numberingPlan.callingCode();
	    } // Deprecated.
	
	  }, {
	    key: "IDDPrefix",
	    value: function IDDPrefix() {
	      return this.numberingPlan.IDDPrefix();
	    } // Deprecated.
	
	  }, {
	    key: "defaultIDDPrefix",
	    value: function defaultIDDPrefix() {
	      return this.numberingPlan.defaultIDDPrefix();
	    } // Deprecated.
	
	  }, {
	    key: "nationalNumberPattern",
	    value: function nationalNumberPattern() {
	      return this.numberingPlan.nationalNumberPattern();
	    } // Deprecated.
	
	  }, {
	    key: "possibleLengths",
	    value: function possibleLengths() {
	      return this.numberingPlan.possibleLengths();
	    } // Deprecated.
	
	  }, {
	    key: "formats",
	    value: function formats() {
	      return this.numberingPlan.formats();
	    } // Deprecated.
	
	  }, {
	    key: "nationalPrefixForParsing",
	    value: function nationalPrefixForParsing() {
	      return this.numberingPlan.nationalPrefixForParsing();
	    } // Deprecated.
	
	  }, {
	    key: "nationalPrefixTransformRule",
	    value: function nationalPrefixTransformRule() {
	      return this.numberingPlan.nationalPrefixTransformRule();
	    } // Deprecated.
	
	  }, {
	    key: "leadingDigits",
	    value: function leadingDigits() {
	      return this.numberingPlan.leadingDigits();
	    } // Deprecated.
	
	  }, {
	    key: "hasTypes",
	    value: function hasTypes() {
	      return this.numberingPlan.hasTypes();
	    } // Deprecated.
	
	  }, {
	    key: "type",
	    value: function type(_type) {
	      return this.numberingPlan.type(_type);
	    } // Deprecated.
	
	  }, {
	    key: "ext",
	    value: function ext() {
	      return this.numberingPlan.ext();
	    }
	  }, {
	    key: "countryCallingCodes",
	    value: function countryCallingCodes() {
	      if (this.v1) return this.metadata.country_phone_code_to_countries;
	      return this.metadata.country_calling_codes;
	    } // Deprecated.
	
	  }, {
	    key: "chooseCountryByCountryCallingCode",
	    value: function chooseCountryByCountryCallingCode(callingCode) {
	      this.selectNumberingPlan(null, callingCode);
	    }
	  }, {
	    key: "hasSelectedNumberingPlan",
	    value: function hasSelectedNumberingPlan() {
	      return this.numberingPlan !== undefined;
	    }
	  }]);
	
	  return Metadata;
	}();
	
	exports["default"] = Metadata;
	
	var NumberingPlan =
	/*#__PURE__*/
	function () {
	  function NumberingPlan(metadata, globalMetadataObject) {
	    _classCallCheck(this, NumberingPlan);
	
	    this.globalMetadataObject = globalMetadataObject;
	    this.metadata = metadata;
	    setVersion.call(this, globalMetadataObject.metadata);
	  }
	
	  _createClass(NumberingPlan, [{
	    key: "callingCode",
	    value: function callingCode() {
	      return this.metadata[0];
	    } // Formatting information for regions which share
	    // a country calling code is contained by only one region
	    // for performance reasons. For example, for NANPA region
	    // ("North American Numbering Plan Administration",
	    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
	    // it will be contained in the metadata for `US`.
	
	  }, {
	    key: "getDefaultCountryMetadataForRegion",
	    value: function getDefaultCountryMetadataForRegion() {
	      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
	    }
	  }, {
	    key: "IDDPrefix",
	    value: function IDDPrefix() {
	      if (this.v1 || this.v2) return;
	      return this.metadata[1];
	    }
	  }, {
	    key: "defaultIDDPrefix",
	    value: function defaultIDDPrefix() {
	      if (this.v1 || this.v2) return;
	      return this.metadata[12];
	    }
	  }, {
	    key: "nationalNumberPattern",
	    value: function nationalNumberPattern() {
	      if (this.v1 || this.v2) return this.metadata[1];
	      return this.metadata[2];
	    }
	  }, {
	    key: "possibleLengths",
	    value: function possibleLengths() {
	      if (this.v1) return;
	      return this.metadata[this.v2 ? 2 : 3];
	    }
	  }, {
	    key: "_getFormats",
	    value: function _getFormats(metadata) {
	      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
	    } // For countries of the same region (e.g. NANPA)
	    // formats are all stored in the "main" country for that region.
	    // E.g. "RU" and "KZ", "US" and "CA".
	
	  }, {
	    key: "formats",
	    value: function formats() {
	      var _this = this;
	
	      var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
	      return formats.map(function (_) {
	        return new Format(_, _this);
	      });
	    }
	  }, {
	    key: "nationalPrefix",
	    value: function nationalPrefix() {
	      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
	    }
	  }, {
	    key: "_getNationalPrefixFormattingRule",
	    value: function _getNationalPrefixFormattingRule(metadata) {
	      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
	    } // For countries of the same region (e.g. NANPA)
	    // national prefix formatting rule is stored in the "main" country for that region.
	    // E.g. "RU" and "KZ", "US" and "CA".
	
	  }, {
	    key: "nationalPrefixFormattingRule",
	    value: function nationalPrefixFormattingRule() {
	      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
	    }
	  }, {
	    key: "_nationalPrefixForParsing",
	    value: function _nationalPrefixForParsing() {
	      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
	    }
	  }, {
	    key: "nationalPrefixForParsing",
	    value: function nationalPrefixForParsing() {
	      // If `national_prefix_for_parsing` is not set explicitly,
	      // then infer it from `national_prefix` (if any)
	      return this._nationalPrefixForParsing() || this.nationalPrefix();
	    }
	  }, {
	    key: "nationalPrefixTransformRule",
	    value: function nationalPrefixTransformRule() {
	      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
	    }
	  }, {
	    key: "_getNationalPrefixIsOptionalWhenFormatting",
	    value: function _getNationalPrefixIsOptionalWhenFormatting() {
	      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
	    } // For countries of the same region (e.g. NANPA)
	    // "national prefix is optional when formatting" flag is
	    // stored in the "main" country for that region.
	    // E.g. "RU" and "KZ", "US" and "CA".
	
	  }, {
	    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
	    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
	      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
	    }
	  }, {
	    key: "leadingDigits",
	    value: function leadingDigits() {
	      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
	    }
	  }, {
	    key: "types",
	    value: function types() {
	      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
	    }
	  }, {
	    key: "hasTypes",
	    value: function hasTypes() {
	      // Versions 1.2.0 - 1.2.4: can be `[]`.
	
	      /* istanbul ignore next */
	      if (this.types() && this.types().length === 0) {
	        return false;
	      } // Versions <= 1.2.4: can be `undefined`.
	      // Version >= 1.2.5: can be `0`.
	
	
	      return !!this.types();
	    }
	  }, {
	    key: "type",
	    value: function type(_type2) {
	      if (this.hasTypes() && getType(this.types(), _type2)) {
	        return new Type(getType(this.types(), _type2), this);
	      }
	    }
	  }, {
	    key: "ext",
	    value: function ext() {
	      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
	      return this.metadata[13] || DEFAULT_EXT_PREFIX;
	    }
	  }]);
	
	  return NumberingPlan;
	}();
	
	var Format =
	/*#__PURE__*/
	function () {
	  function Format(format, metadata) {
	    _classCallCheck(this, Format);
	
	    this._format = format;
	    this.metadata = metadata;
	  }
	
	  _createClass(Format, [{
	    key: "pattern",
	    value: function pattern() {
	      return this._format[0];
	    }
	  }, {
	    key: "format",
	    value: function format() {
	      return this._format[1];
	    }
	  }, {
	    key: "leadingDigitsPatterns",
	    value: function leadingDigitsPatterns() {
	      return this._format[2] || [];
	    }
	  }, {
	    key: "nationalPrefixFormattingRule",
	    value: function nationalPrefixFormattingRule() {
	      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
	    }
	  }, {
	    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
	    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
	      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
	    }
	  }, {
	    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
	    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
	      // National prefix is omitted if there's no national prefix formatting rule
	      // set for this country, or when the national prefix formatting rule
	      // contains no national prefix itself, or when this rule is set but
	      // national prefix is optional for this phone number format
	      // (and it is not enforced explicitly)
	      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
	    } // Checks whether national prefix formatting rule contains national prefix.
	
	  }, {
	    key: "usesNationalPrefix",
	    value: function usesNationalPrefix() {
	      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
	      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()); // Previously, `FIRST_GROUP_ONLY_PREFIX_PATTERN` check was instead done via:
	      // // Check that national prefix formatting rule is not a "dummy" one.
	      // this.nationalPrefixFormattingRule() !== '$1' &&
	      // // Check that national prefix formatting rule actually has national prefix digit(s).
	      // // Filters out cases like "($1)".
	      // // Is used in place of `libphonenumber`'s `FIRST_GROUP_ONLY_PREFIX_PATTERN_` regexp.
	      // /\d/.test(this.nationalPrefixFormattingRule().replace('$1', ''))
	    }
	  }, {
	    key: "internationalFormat",
	    value: function internationalFormat() {
	      return this._format[5] || this.format();
	    }
	  }]);
	
	  return Format;
	}();
	/**
	 * A pattern that is used to determine if the national prefix formatting rule
	 * has the first group only, i.e., does not start with the national prefix.
	 * Note that the pattern explicitly allows for unbalanced parentheses.
	 */
	
	
	var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
	
	var Type =
	/*#__PURE__*/
	function () {
	  function Type(type, metadata) {
	    _classCallCheck(this, Type);
	
	    this.type = type;
	    this.metadata = metadata;
	  }
	
	  _createClass(Type, [{
	    key: "pattern",
	    value: function pattern() {
	      if (this.metadata.v1) return this.type;
	      return this.type[0];
	    }
	  }, {
	    key: "possibleLengths",
	    value: function possibleLengths() {
	      if (this.metadata.v1) return;
	      return this.type[1] || this.metadata.possibleLengths();
	    }
	  }]);
	
	  return Type;
	}();
	
	function getType(types, type) {
	  switch (type) {
	    case 'FIXED_LINE':
	      return types[0];
	
	    case 'MOBILE':
	      return types[1];
	
	    case 'TOLL_FREE':
	      return types[2];
	
	    case 'PREMIUM_RATE':
	      return types[3];
	
	    case 'PERSONAL_NUMBER':
	      return types[4];
	
	    case 'VOICEMAIL':
	      return types[5];
	
	    case 'UAN':
	      return types[6];
	
	    case 'PAGER':
	      return types[7];
	
	    case 'VOIP':
	      return types[8];
	
	    case 'SHARED_COST':
	      return types[9];
	  }
	}
	
	function validateMetadata(metadata) {
	  if (!metadata) {
	    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
	  } // `country_phone_code_to_countries` was renamed to
	  // `country_calling_codes` in `1.0.18`.
	
	
	  if (!is_object(metadata) || !is_object(metadata.countries)) {
	    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(is_object(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + type_of(metadata) + ': ' + metadata, "."));
	  }
	} // Babel transforms `typeof` into some "branches"
	// so istanbul will show this as "branch not covered".
	
	/* istanbul ignore next */
	
	
	var is_object = function is_object(_) {
	  return _typeof(_) === 'object';
	}; // Babel transforms `typeof` into some "branches"
	// so istanbul will show this as "branch not covered".
	
	/* istanbul ignore next */
	
	
	var type_of = function type_of(_) {
	  return _typeof(_);
	};
	/**
	 * Returns extension prefix for a country.
	 * @param  {string} country
	 * @param  {object} metadata
	 * @return {string?}
	 * @example
	 * // Returns " ext. "
	 * getExtPrefix("US")
	 */
	
	
	function getExtPrefix(country, metadata) {
	  metadata = new Metadata(metadata);
	
	  if (metadata.hasCountry(country)) {
	    return metadata.country(country).ext();
	  }
	
	  return DEFAULT_EXT_PREFIX;
	}
	/**
	 * Returns "country calling code" for a country.
	 * Throws an error if the country doesn't exist or isn't supported by this library.
	 * @param  {string} country
	 * @param  {object} metadata
	 * @return {string}
	 * @example
	 * // Returns "44"
	 * getCountryCallingCode("GB")
	 */
	
	
	function getCountryCallingCode(country, metadata) {
	  metadata = new Metadata(metadata);
	
	  if (metadata.hasCountry(country)) {
	    return metadata.country(country).countryCallingCode();
	  }
	
	  throw new Error("Unknown country: ".concat(country));
	}
	
	function isSupportedCountry(country, metadata) {
	  // metadata = new Metadata(metadata)
	  // return metadata.hasCountry(country)
	  return metadata.countries[country] !== undefined;
	}
	
	function setVersion(metadata) {
	  this.v1 = !metadata.version;
	  this.v2 = metadata.version !== undefined && (0, _semverCompare["default"])(metadata.version, V3) === -1;
	  this.v3 = metadata.version !== undefined && (0, _semverCompare["default"])(metadata.version, V4) === -1;
	  this.v4 = metadata.version !== undefined; // && compare(metadata.version, V5) === -1
	} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
	// function isCountryCode(countryCode) {
	// 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
	// }
	//# sourceMappingURL=metadata.js.map

/***/ }),
/* 783 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = _default;
	
	// Copy-pasted from:
	// https://github.com/substack/semver-compare/blob/master/index.js
	//
	// Inlining this function because some users reported issues with
	// importing from `semver-compare` in a browser with ES6 "native" modules.
	//
	// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
	// https://github.com/catamphetamine/libphonenumber-js/issues/381
	function _default(a, b) {
	  a = a.split('-');
	  b = b.split('-');
	  var pa = a[0].split('.');
	  var pb = b[0].split('.');
	
	  for (var i = 0; i < 3; i++) {
	    var na = Number(pa[i]);
	    var nb = Number(pb[i]);
	    if (na > nb) return 1;
	    if (nb > na) return -1;
	    if (!isNaN(na) && isNaN(nb)) return 1;
	    if (isNaN(na) && !isNaN(nb)) return -1;
	  }
	
	  if (a[1] && b[1]) {
	    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
	  }
	
	  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
	}
	//# sourceMappingURL=semver-compare.js.map

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isViablePhoneNumber;
	
	var _constants = __webpack_require__(780);
	
	var _extension = __webpack_require__(785);
	
	//  Regular expression of viable phone numbers. This is location independent.
	//  Checks we have at least three leading digits, and only valid punctuation,
	//  alpha characters and digits in the phone number. Does not include extension
	//  data. The symbol 'x' is allowed here as valid punctuation since it is often
	//  used as a placeholder for carrier codes, for example in Brazilian phone
	//  numbers. We also allow multiple '+' characters at the start.
	//
	//  Corresponds to the following:
	//  [digits]{minLengthNsn}|
	//  plus_sign*
	//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
	//
	//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
	//  they are entered as "15" etc, but only if there is no punctuation in them.
	//  The second expression restricts the number of digits to three or more, but
	//  then allows them to be in international form, and to have alpha-characters
	//  and punctuation. We split up the two reg-exes here and combine them when
	//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
	//  with ^ and append $ to each branch.
	//
	//  "Note VALID_PUNCTUATION starts with a -,
	//   so must be the first in the range" (c) Google devs.
	//  (wtf did they mean by saying that; probably nothing)
	//
	var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + _constants.VALID_DIGITS + ']{' + _constants.MIN_LENGTH_FOR_NSN + '}'; //
	// And this is the second reg-exp:
	// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
	//
	
	var VALID_PHONE_NUMBER = '[' + _constants.PLUS_CHARS + ']{0,1}' + '(?:' + '[' + _constants.VALID_PUNCTUATION + ']*' + '[' + _constants.VALID_DIGITS + ']' + '){3,}' + '[' + _constants.VALID_PUNCTUATION + _constants.VALID_DIGITS + ']*'; // The combined regular expression for valid phone numbers:
	//
	
	var VALID_PHONE_NUMBER_PATTERN = new RegExp( // Either a short two-digit-only phone number
	'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
	'^' + VALID_PHONE_NUMBER + // Phone number extensions
	'(?:' + _extension.EXTN_PATTERNS_FOR_PARSING + ')?' + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
	// all. At the moment, checks to see that the string begins with at least 2
	// digits, ignoring any punctuation commonly found in phone numbers. This method
	// does not require the number to be normalized in advance - but does assume
	// that leading non-number symbols have been removed, such as by the method
	// `extract_possible_number`.
	//
	
	function isViablePhoneNumber(number) {
	  return number.length >= _constants.MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
	}
	//# sourceMappingURL=isViablePhoneNumber.js.map

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.extractExtension = extractExtension;
	exports.EXTN_PATTERNS_FOR_MATCHING = exports.EXTN_PATTERNS_FOR_PARSING = void 0;
	
	var _constants = __webpack_require__(780);
	
	// The RFC 3966 format for extensions.
	var RFC3966_EXTN_PREFIX = ';ext='; // Pattern to capture digits used in an extension.
	// Places a maximum length of '7' for an extension.
	
	var CAPTURING_EXTN_DIGITS = '([' + _constants.VALID_DIGITS + ']{1,7})';
	/**
	 * Regexp of all possible ways to write extensions, for use when parsing. This
	 * will be run as a case-insensitive regexp match. Wide character versions are
	 * also provided after each ASCII version. There are three regular expressions
	 * here. The first covers RFC 3966 format, where the extension is added using
	 * ';ext='. The second more generic one starts with optional white space and
	 * ends with an optional full stop (.), followed by zero or more spaces/tabs
	 * /commas and then the numbers themselves. The other one covers the special
	 * case of American numbers where the extension is written with a hash at the
	 * end, such as '- 503#'. Note that the only capturing groups should be around
	 * the digits that you want to capture as part of the extension, or else parsing
	 * will fail! We allow two options for representing the accented o - the
	 * character itself, and one in the unicode decomposed form with the combining
	 * acute accent.
	 */
	
	function create_extension_pattern(purpose) {
	  // One-character symbols that can be used to indicate an extension.
	  var single_extension_characters = "x\uFF58#\uFF03~\uFF5E";
	
	  switch (purpose) {
	    // For parsing, we are slightly more lenient in our interpretation than for matching. Here we
	    // allow "comma" and "semicolon" as possible extension indicators. When matching, these are
	    case 'parsing':
	      single_extension_characters = ',;' + single_extension_characters;
	  }
	
	  return RFC3966_EXTN_PREFIX + CAPTURING_EXTN_DIGITS + '|' + "[ \xA0\\t,]*" + "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|" + // "доб."
	  "\u0434\u043E\u0431|" + '[' + single_extension_characters + "]|int|anexo|\uFF49\uFF4E\uFF54)" + "[:\\.\uFF0E]?[ \xA0\\t,-]*" + CAPTURING_EXTN_DIGITS + '#?|' + '[- ]+([' + _constants.VALID_DIGITS + ']{1,5})#';
	}
	/**
	 * Regexp of all possible ways to write extensions, for use when parsing. This
	 * will be run as a case-insensitive regexp match. Wide character versions are
	 * also provided after each ASCII version. There are three regular expressions
	 * here. The first covers RFC 3966 format, where the extension is added using
	 * ';ext='. The second more generic one starts with optional white space and
	 * ends with an optional full stop (.), followed by zero or more spaces/tabs
	 * /commas and then the numbers themselves. The other one covers the special
	 * case of American numbers where the extension is written with a hash at the
	 * end, such as '- 503#'. Note that the only capturing groups should be around
	 * the digits that you want to capture as part of the extension, or else parsing
	 * will fail! We allow two options for representing the accented o - the
	 * character itself, and one in the unicode decomposed form with the combining
	 * acute accent.
	 */
	
	
	var EXTN_PATTERNS_FOR_PARSING = create_extension_pattern('parsing');
	exports.EXTN_PATTERNS_FOR_PARSING = EXTN_PATTERNS_FOR_PARSING;
	var EXTN_PATTERNS_FOR_MATCHING = create_extension_pattern('matching'); // Regexp of all known extension prefixes used by different regions followed by
	// 1 or more valid digits, for use when parsing.
	
	exports.EXTN_PATTERNS_FOR_MATCHING = EXTN_PATTERNS_FOR_MATCHING;
	var EXTN_PATTERN = new RegExp('(?:' + EXTN_PATTERNS_FOR_PARSING + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
	// connected, usually indicated with extn, ext, x or similar) from the end of
	// the number, and returns it.
	
	function extractExtension(number) {
	  var start = number.search(EXTN_PATTERN);
	
	  if (start < 0) {
	    return {};
	  } // If we find a potential extension, and the number preceding this is a viable
	  // number, we assume it is an extension.
	
	
	  var number_without_extension = number.slice(0, start);
	  var matches = number.match(EXTN_PATTERN);
	  var i = 1;
	
	  while (i < matches.length) {
	    if (matches[i] != null && matches[i].length > 0) {
	      return {
	        number: number_without_extension,
	        ext: matches[i]
	      };
	    }
	
	    i++;
	  }
	}
	//# sourceMappingURL=extension.js.map

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parseIncompletePhoneNumber;
	exports.parsePhoneNumberCharacter = parsePhoneNumberCharacter;
	
	var _parseDigits = __webpack_require__(787);
	
	/**
	 * Parses phone number characters from a string.
	 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
	 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
	 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
	 * @param  {string} string
	 * @return {string}
	 * @example
	 * ```js
	 * // Outputs '8800555'.
	 * parseIncompletePhoneNumber('8 (800) 555')
	 * // Outputs '+7800555'.
	 * parseIncompletePhoneNumber('+7 800 555')
	 * ```
	 */
	function parseIncompletePhoneNumber(string) {
	  var result = ''; // Using `.split('')` here instead of normal `for ... of`
	  // because the importing application doesn't neccessarily include an ES6 polyfill.
	  // The `.split('')` approach discards "exotic" UTF-8 characters
	  // (the ones consisting of four bytes) but digits
	  // (including non-European ones) don't fall into that range
	  // so such "exotic" characters would be discarded anyway.
	
	  for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var character = _ref;
	    result += parsePhoneNumberCharacter(character, result) || '';
	  }
	
	  return result;
	}
	/**
	 * `input-format` `parse()` function.
	 * https://gitlab.com/catamphetamine/input-format
	 * @param  {string} character - Yet another character from raw input string.
	 * @param  {string} value - The value parsed so far.
	 * @param  {object} meta - Optional custom use-case-specific metadata.
	 * @return {string?} The parsed character.
	 */
	
	
	function parsePhoneNumberCharacter(character, value) {
	  // Only allow a leading `+`.
	  if (character === '+') {
	    // If this `+` is not the first parsed character
	    // then discard it.
	    if (value) {
	      return;
	    }
	
	    return '+';
	  } // Allow digits.
	
	
	  return (0, _parseDigits.parseDigit)(character);
	}
	//# sourceMappingURL=parseIncompletePhoneNumber.js.map

/***/ }),
/* 787 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseDigit = parseDigit;
	exports["default"] = parseDigits;
	exports.DIGITS = void 0;
	// These mappings map a character (key) to a specific digit that should
	// replace it for normalization purposes. Non-European digits that
	// may be used in phone numbers are mapped to a European equivalent.
	//
	// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
	//
	var DIGITS = {
	  '0': '0',
	  '1': '1',
	  '2': '2',
	  '3': '3',
	  '4': '4',
	  '5': '5',
	  '6': '6',
	  '7': '7',
	  '8': '8',
	  '9': '9',
	  "\uFF10": '0',
	  // Fullwidth digit 0
	  "\uFF11": '1',
	  // Fullwidth digit 1
	  "\uFF12": '2',
	  // Fullwidth digit 2
	  "\uFF13": '3',
	  // Fullwidth digit 3
	  "\uFF14": '4',
	  // Fullwidth digit 4
	  "\uFF15": '5',
	  // Fullwidth digit 5
	  "\uFF16": '6',
	  // Fullwidth digit 6
	  "\uFF17": '7',
	  // Fullwidth digit 7
	  "\uFF18": '8',
	  // Fullwidth digit 8
	  "\uFF19": '9',
	  // Fullwidth digit 9
	  "\u0660": '0',
	  // Arabic-indic digit 0
	  "\u0661": '1',
	  // Arabic-indic digit 1
	  "\u0662": '2',
	  // Arabic-indic digit 2
	  "\u0663": '3',
	  // Arabic-indic digit 3
	  "\u0664": '4',
	  // Arabic-indic digit 4
	  "\u0665": '5',
	  // Arabic-indic digit 5
	  "\u0666": '6',
	  // Arabic-indic digit 6
	  "\u0667": '7',
	  // Arabic-indic digit 7
	  "\u0668": '8',
	  // Arabic-indic digit 8
	  "\u0669": '9',
	  // Arabic-indic digit 9
	  "\u06F0": '0',
	  // Eastern-Arabic digit 0
	  "\u06F1": '1',
	  // Eastern-Arabic digit 1
	  "\u06F2": '2',
	  // Eastern-Arabic digit 2
	  "\u06F3": '3',
	  // Eastern-Arabic digit 3
	  "\u06F4": '4',
	  // Eastern-Arabic digit 4
	  "\u06F5": '5',
	  // Eastern-Arabic digit 5
	  "\u06F6": '6',
	  // Eastern-Arabic digit 6
	  "\u06F7": '7',
	  // Eastern-Arabic digit 7
	  "\u06F8": '8',
	  // Eastern-Arabic digit 8
	  "\u06F9": '9' // Eastern-Arabic digit 9
	
	};
	exports.DIGITS = DIGITS;
	
	function parseDigit(character) {
	  return DIGITS[character];
	}
	/**
	 * Parses phone number digits from a string.
	 * Drops all punctuation leaving only digits.
	 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
	 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
	 * @param  {string} string
	 * @return {string}
	 * @example
	 * ```js
	 * parseDigits('8 (800) 555')
	 * // Outputs '8800555'.
	 * ```
	 */
	
	
	function parseDigits(string) {
	  var result = ''; // Using `.split('')` here instead of normal `for ... of`
	  // because the importing application doesn't neccessarily include an ES6 polyfill.
	  // The `.split('')` approach discards "exotic" UTF-8 characters
	  // (the ones consisting of four bytes) but digits
	  // (including non-European ones) don't fall into that range
	  // so such "exotic" characters would be discarded anyway.
	
	  for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var character = _ref;
	    var digit = parseDigit(character);
	
	    if (digit) {
	      result += digit;
	    }
	  }
	
	  return result;
	}
	//# sourceMappingURL=parseDigits.js.map

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _metadata.getCountryCallingCode;
	  }
	});
	
	var _metadata = __webpack_require__(782);
	//# sourceMappingURL=getCountryCallingCode.js.map

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getNumberType;
	exports.is_of_type = is_of_type;
	exports.checkNumberLengthForType = checkNumberLengthForType;
	
	var _metadata = _interopRequireDefault(__webpack_require__(782));
	
	var _util = __webpack_require__(781);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL']; // Finds out national phone number type (fixed line, mobile, etc)
	
	function getNumberType(input, options, metadata) {
	  // If assigning the `{}` default value is moved to the arguments above,
	  // code coverage would decrease for some weird reason.
	  options = options || {}; // When `parse()` returned `{}`
	  // meaning that the phone number is not a valid one.
	
	  if (!input.country) {
	    return;
	  }
	
	  metadata = new _metadata["default"](metadata);
	  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
	  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
	  // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
	  // Is this national number even valid for this country
	
	  if (!(0, _util.matchesEntirely)(nationalNumber, metadata.nationalNumberPattern())) {
	    return;
	  } // Is it fixed line number
	
	
	  if (is_of_type(nationalNumber, 'FIXED_LINE', metadata)) {
	    // Because duplicate regular expressions are removed
	    // to reduce metadata size, if "mobile" pattern is ""
	    // then it means it was removed due to being a duplicate of the fixed-line pattern.
	    //
	    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
	      return 'FIXED_LINE_OR_MOBILE';
	    } // v1 metadata.
	    // Legacy.
	    // Deprecated.
	
	
	    if (!metadata.type('MOBILE')) {
	      return 'FIXED_LINE_OR_MOBILE';
	    } // Check if the number happens to qualify as both fixed line and mobile.
	    // (no such country in the minimal metadata set)
	
	    /* istanbul ignore if */
	
	
	    if (is_of_type(nationalNumber, 'MOBILE', metadata)) {
	      return 'FIXED_LINE_OR_MOBILE';
	    }
	
	    return 'FIXED_LINE';
	  }
	
	  for (var _i = 0, _NON_FIXED_LINE_PHONE = NON_FIXED_LINE_PHONE_TYPES; _i < _NON_FIXED_LINE_PHONE.length; _i++) {
	    var _type = _NON_FIXED_LINE_PHONE[_i];
	
	    if (is_of_type(nationalNumber, _type, metadata)) {
	      return _type;
	    }
	  }
	}
	
	function is_of_type(nationalNumber, type, metadata) {
	  type = metadata.type(type);
	
	  if (!type || !type.pattern()) {
	    return false;
	  } // Check if any possible number lengths are present;
	  // if so, we use them to avoid checking
	  // the validation pattern if they don't match.
	  // If they are absent, this means they match
	  // the general description, which we have
	  // already checked before a specific number type.
	
	
	  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
	    return false;
	  }
	
	  return (0, _util.matchesEntirely)(nationalNumber, type.pattern());
	} // Should only be called for the "new" metadata which has "possible lengths".
	
	
	function checkNumberLengthForType(nationalNumber, type, metadata) {
	  var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
	  // This is declared in the XML schema.
	  // For size efficiency, where a sub-description (e.g. fixed-line)
	  // has the same "<possiblePengths/>" as the "general description", this is missing,
	  // so we fall back to the "general description". Where no numbers of the type
	  // exist at all, there is one possible length (-1) which is guaranteed
	  // not to match the length of any real phone number.
	
	  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
	  // Metadata before version `1.0.18` didn't contain `possible_lengths`.
	
	  if (!possible_lengths) {
	    return 'IS_POSSIBLE';
	  }
	
	  if (type === 'FIXED_LINE_OR_MOBILE') {
	    // No such country in metadata.
	
	    /* istanbul ignore next */
	    if (!metadata.type('FIXED_LINE')) {
	      // The rare case has been encountered where no fixedLine data is available
	      // (true for some non-geographic entities), so we just check mobile.
	      return checkNumberLengthForType(nationalNumber, 'MOBILE', metadata);
	    }
	
	    var mobile_type = metadata.type('MOBILE');
	
	    if (mobile_type) {
	      // Merge the mobile data in if there was any. "Concat" creates a new
	      // array, it doesn't edit possible_lengths in place, so we don't need a copy.
	      // Note that when adding the possible lengths from mobile, we have
	      // to again check they aren't empty since if they are this indicates
	      // they are the same as the general desc and should be obtained from there.
	      possible_lengths = (0, _util.mergeArrays)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
	      // re-sort (duplicates are okay). Sorting isn't so expensive because
	      // the lists are very small.
	      // if (local_lengths)
	      // {
	      // 	local_lengths = mergeArrays(local_lengths, mobile_type.possibleLengthsLocal())
	      // }
	      // else
	      // {
	      // 	local_lengths = mobile_type.possibleLengthsLocal()
	      // }
	    }
	  } // If the type doesn't exist then return 'INVALID_LENGTH'.
	  else if (type && !type_info) {
	      return 'INVALID_LENGTH';
	    }
	
	  var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
	  // // This is safe because there is never an overlap beween the possible lengths
	  // // and the local-only lengths; this is checked at build time.
	  // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
	  // {
	  // 	return 'IS_POSSIBLE_LOCAL_ONLY'
	  // }
	
	  var minimum_length = possible_lengths[0];
	
	  if (minimum_length === actual_length) {
	    return 'IS_POSSIBLE';
	  }
	
	  if (minimum_length > actual_length) {
	    return 'TOO_SHORT';
	  }
	
	  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
	    return 'TOO_LONG';
	  } // We skip the first element since we've already checked it.
	
	
	  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
	}
	//# sourceMappingURL=getNumberType_.js.map

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isPossiblePhoneNumber;
	exports.isPossibleNumber = isPossibleNumber;
	
	var _metadata = _interopRequireDefault(__webpack_require__(782));
	
	var _getNumberType_ = __webpack_require__(789);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function isPossiblePhoneNumber(input, options, metadata) {
	  /* istanbul ignore if */
	  if (options === undefined) {
	    options = {};
	  }
	
	  metadata = new _metadata["default"](metadata);
	
	  if (options.v2) {
	    if (!input.countryCallingCode) {
	      throw new Error('Invalid phone number object passed');
	    }
	
	    metadata.chooseCountryByCountryCallingCode(input.countryCallingCode);
	  } else {
	    if (!input.phone) {
	      return false;
	    }
	
	    if (input.country) {
	      if (!metadata.hasCountry(input.country)) {
	        throw new Error("Unknown country: ".concat(input.country));
	      }
	
	      metadata.country(input.country);
	    } else {
	      if (!input.countryCallingCode) {
	        throw new Error('Invalid phone number object passed');
	      }
	
	      metadata.chooseCountryByCountryCallingCode(input.countryCallingCode);
	    }
	  }
	
	  if (metadata.possibleLengths()) {
	    return isPossibleNumber(input.phone || input.nationalNumber, undefined, metadata);
	  } else {
	    // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
	    // were missing for "non-geographical" numbering plans.
	    // Just assume the number is possible in such cases:
	    // it's unlikely that anyone generated their custom metadata
	    // in that short period of time (one day).
	    // This code can be removed in some future major version update.
	    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
	      // "Non-geographic entities" did't have `possibleLengths`
	      // due to a bug in metadata generation process.
	      return true;
	    } else {
	      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
	    }
	  }
	}
	
	function isPossibleNumber(nationalNumber, isInternational, metadata) {
	  switch ((0, _getNumberType_.checkNumberLengthForType)(nationalNumber, undefined, metadata)) {
	    case 'IS_POSSIBLE':
	      return true;
	    // case 'IS_POSSIBLE_LOCAL_ONLY':
	    // 	return !isInternational
	
	    default:
	      return false;
	  }
	}
	//# sourceMappingURL=isPossibleNumber_.js.map

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getIDDPrefix = getIDDPrefix;
	exports.stripIDDPrefix = stripIDDPrefix;
	
	var _metadata = _interopRequireDefault(__webpack_require__(782));
	
	var _constants = __webpack_require__(780);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var CAPTURING_DIGIT_PATTERN = new RegExp('([' + _constants.VALID_DIGITS + '])');
	/**
	 * Pattern that makes it easy to distinguish whether a region has a single
	 * international dialing prefix or not. If a region has a single international
	 * prefix (e.g. 011 in USA), it will be represented as a string that contains
	 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
	 * the tone. If there are multiple available international prefixes in a
	 * region, they will be represented as a regex string that always contains one
	 * or more characters that are not ASCII digits or a tilde.
	 */
	
	var SINGLE_IDD_PREFIX = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
	// a preferred IDD prefix is returned.
	
	function getIDDPrefix(country, callingCode, metadata) {
	  var countryMetadata = new _metadata["default"](metadata);
	  countryMetadata.selectNumberingPlan(country, callingCode);
	
	  if (SINGLE_IDD_PREFIX.test(countryMetadata.IDDPrefix())) {
	    return countryMetadata.IDDPrefix();
	  }
	
	  return countryMetadata.defaultIDDPrefix();
	}
	
	function stripIDDPrefix(number, country, callingCode, metadata) {
	  if (!country) {
	    return;
	  } // Check if the number is IDD-prefixed.
	
	
	  var countryMetadata = new _metadata["default"](metadata);
	  countryMetadata.selectNumberingPlan(country, callingCode);
	  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
	
	  if (number.search(IDDPrefixPattern) !== 0) {
	    return;
	  } // Strip IDD prefix.
	
	
	  number = number.slice(number.match(IDDPrefixPattern)[0].length); // Some kind of a weird edge case.
	  // No explanation from Google given.
	
	  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);
	  /* istanbul ignore next */
	
	  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
	    if (matchedGroups[1] === '0') {
	      return;
	    }
	  }
	
	  return number;
	}
	//# sourceMappingURL=IDD.js.map

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseRFC3966 = parseRFC3966;
	exports.formatRFC3966 = formatRFC3966;
	
	var _isViablePhoneNumber = _interopRequireDefault(__webpack_require__(784));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	// https://www.ietf.org/rfc/rfc3966.txt
	
	/**
	 * @param  {string} text - Phone URI (RFC 3966).
	 * @return {object} `{ ?number, ?ext }`.
	 */
	function parseRFC3966(text) {
	  var number;
	  var ext; // Replace "tel:" with "tel=" for parsing convenience.
	
	  text = text.replace(/^tel:/, 'tel=');
	
	  for (var _iterator = text.split(';'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var part = _ref;
	
	    var _part$split = part.split('='),
	        _part$split2 = _slicedToArray(_part$split, 2),
	        name = _part$split2[0],
	        value = _part$split2[1];
	
	    switch (name) {
	      case 'tel':
	        number = value;
	        break;
	
	      case 'ext':
	        ext = value;
	        break;
	
	      case 'phone-context':
	        // Only "country contexts" are supported.
	        // "Domain contexts" are ignored.
	        if (value[0] === '+') {
	          number = value + number;
	        }
	
	        break;
	    }
	  } // If the phone number is not viable, then abort.
	
	
	  if (!(0, _isViablePhoneNumber["default"])(number)) {
	    return {};
	  }
	
	  var result = {
	    number: number
	  };
	
	  if (ext) {
	    result.ext = ext;
	  }
	
	  return result;
	}
	/**
	 * @param  {object} - `{ ?number, ?extension }`.
	 * @return {string} Phone URI (RFC 3966).
	 */
	
	
	function formatRFC3966(_ref2) {
	  var number = _ref2.number,
	      ext = _ref2.ext;
	
	  if (!number) {
	    return '';
	  }
	
	  if (number[0] !== '+') {
	    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
	  }
	
	  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
	}
	//# sourceMappingURL=RFC3966.js.map

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _metadata2 = _interopRequireDefault(__webpack_require__(782));
	
	var _isPossibleNumber_ = _interopRequireDefault(__webpack_require__(790));
	
	var _validate_ = _interopRequireDefault(__webpack_require__(794));
	
	var _isValidNumberForRegion_ = _interopRequireDefault(__webpack_require__(795));
	
	var _getNumberType_ = _interopRequireDefault(__webpack_require__(789));
	
	var _format_ = _interopRequireDefault(__webpack_require__(796));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
	
	var PhoneNumber =
	/*#__PURE__*/
	function () {
	  function PhoneNumber(countryCallingCode, nationalNumber, metadata) {
	    _classCallCheck(this, PhoneNumber);
	
	    if (!countryCallingCode) {
	      throw new TypeError('`country` or `countryCallingCode` not passed');
	    }
	
	    if (!nationalNumber) {
	      throw new TypeError('`nationalNumber` not passed');
	    }
	
	    var _metadata = new _metadata2["default"](metadata); // If country code is passed then derive `countryCallingCode` from it.
	    // Also store the country code as `.country`.
	
	
	    if (isCountryCode(countryCallingCode)) {
	      this.country = countryCallingCode;
	
	      _metadata.country(countryCallingCode);
	
	      countryCallingCode = _metadata.countryCallingCode();
	    } else {
	      /* istanbul ignore if */
	      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
	        if (_metadata.isNonGeographicCallingCode(countryCallingCode)) {
	          this.country = '001';
	        }
	      }
	    }
	
	    this.countryCallingCode = countryCallingCode;
	    this.nationalNumber = nationalNumber;
	    this.number = '+' + this.countryCallingCode + this.nationalNumber;
	    this.metadata = metadata;
	  }
	
	  _createClass(PhoneNumber, [{
	    key: "isPossible",
	    value: function isPossible() {
	      return (0, _isPossibleNumber_["default"])(this, {
	        v2: true
	      }, this.metadata);
	    }
	  }, {
	    key: "isValid",
	    value: function isValid() {
	      return (0, _validate_["default"])(this, {
	        v2: true
	      }, this.metadata);
	    }
	  }, {
	    key: "isNonGeographic",
	    value: function isNonGeographic() {
	      var metadata = new _metadata2["default"](this.metadata);
	      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
	    }
	  }, {
	    key: "isEqual",
	    value: function isEqual(phoneNumber) {
	      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
	    } // // Is just an alias for `this.isValid() && this.country === country`.
	    // // https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
	    // isValidForRegion(country) {
	    // 	return isValidNumberForRegion(this, country, { v2: true }, this.metadata)
	    // }
	
	  }, {
	    key: "getType",
	    value: function getType() {
	      return (0, _getNumberType_["default"])(this, {
	        v2: true
	      }, this.metadata);
	    }
	  }, {
	    key: "format",
	    value: function format(_format, options) {
	      return (0, _format_["default"])(this, _format, options ? _objectSpread({}, options, {
	        v2: true
	      }) : {
	        v2: true
	      }, this.metadata);
	    }
	  }, {
	    key: "formatNational",
	    value: function formatNational(options) {
	      return this.format('NATIONAL', options);
	    }
	  }, {
	    key: "formatInternational",
	    value: function formatInternational(options) {
	      return this.format('INTERNATIONAL', options);
	    }
	  }, {
	    key: "getURI",
	    value: function getURI(options) {
	      return this.format('RFC3966', options);
	    }
	  }]);
	
	  return PhoneNumber;
	}();
	
	exports["default"] = PhoneNumber;
	
	var isCountryCode = function isCountryCode(value) {
	  return /^[A-Z]{2}$/.test(value);
	};
	//# sourceMappingURL=PhoneNumber.js.map

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isValidNumber;
	
	var _metadata = _interopRequireDefault(__webpack_require__(782));
	
	var _util = __webpack_require__(781);
	
	var _getNumberType_ = _interopRequireDefault(__webpack_require__(789));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Checks if a given phone number is valid.
	 *
	 * If the `number` is a string, it will be parsed to an object,
	 * but only if it contains only valid phone number characters (including punctuation).
	 * If the `number` is an object, it is used as is.
	 *
	 * The optional `defaultCountry` argument is the default country.
	 * I.e. it does not restrict to just that country,
	 * e.g. in those cases where several countries share
	 * the same phone numbering rules (NANPA, Britain, etc).
	 * For example, even though the number `07624 369230`
	 * belongs to the Isle of Man ("IM" country code)
	 * calling `isValidNumber('07624369230', 'GB', metadata)`
	 * still returns `true` because the country is not restricted to `GB`,
	 * it's just that `GB` is the default one for the phone numbering rules.
	 * For restricting the country see `isValidNumberForRegion()`
	 * though restricting a country might not be a good idea.
	 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
	 *
	 * Examples:
	 *
	 * ```js
	 * isValidNumber('+78005553535', metadata)
	 * isValidNumber('8005553535', 'RU', metadata)
	 * isValidNumber('88005553535', 'RU', metadata)
	 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
	 * ```
	 */
	function isValidNumber(input, options, metadata) {
	  // If assigning the `{}` default value is moved to the arguments above,
	  // code coverage would decrease for some weird reason.
	  options = options || {};
	  metadata = new _metadata["default"](metadata); // This is just to support `isValidNumber({})`
	  // for cases when `parseNumber()` returns `{}`.
	
	  if (!input.country) {
	    return false;
	  }
	
	  metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
	  // distinguishing different countries having the same `countryCallingCode`.
	
	  if (metadata.hasTypes()) {
	    return (0, _getNumberType_["default"])(input, options, metadata.metadata) !== undefined;
	  } // If there are no type regexps for this country in metadata then use
	  // `nationalNumberPattern` as a "better than nothing" replacement.
	
	
	  var national_number = options.v2 ? input.nationalNumber : input.phone;
	  return (0, _util.matchesEntirely)(national_number, metadata.nationalNumberPattern());
	}
	//# sourceMappingURL=validate_.js.map

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isValidNumberForRegion;
	
	var _validate_ = _interopRequireDefault(__webpack_require__(794));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Checks if a given phone number is valid within a given region.
	 * Is just an alias for `phoneNumber.isValid() && phoneNumber.country === country`.
	 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
	 */
	function isValidNumberForRegion(input, country, options, metadata) {
	  // If assigning the `{}` default value is moved to the arguments above,
	  // code coverage would decrease for some weird reason.
	  options = options || {};
	  return input.country === country && (0, _validate_["default"])(input, options, metadata);
	}
	//# sourceMappingURL=isValidNumberForRegion_.js.map

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = formatNumber;
	exports.formatNationalNumberUsingFormat = formatNationalNumberUsingFormat;
	exports.applyInternationalSeparatorStyle = applyInternationalSeparatorStyle;
	exports.FIRST_GROUP_PATTERN = void 0;
	
	var _constants = __webpack_require__(780);
	
	var _util = __webpack_require__(781);
	
	var _metadata = _interopRequireDefault(__webpack_require__(782));
	
	var _IDD = __webpack_require__(791);
	
	var _RFC = __webpack_require__(792);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var DEFAULT_OPTIONS = {
	  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
	    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
	  } // Formats a phone number
	  //
	  // Example use cases:
	  //
	  // ```js
	  // formatNumber('8005553535', 'RU', 'INTERNATIONAL')
	  // formatNumber('8005553535', 'RU', 'INTERNATIONAL', metadata)
	  // formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL')
	  // formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', metadata)
	  // formatNumber('+78005553535', 'NATIONAL')
	  // formatNumber('+78005553535', 'NATIONAL', metadata)
	  // ```
	  //
	
	};
	
	function formatNumber(input, format, options, metadata) {
	  // Apply default options.
	  if (options) {
	    options = _objectSpread({}, DEFAULT_OPTIONS, options);
	  } else {
	    options = DEFAULT_OPTIONS;
	  }
	
	  metadata = new _metadata["default"](metadata);
	
	  if (input.country && input.country !== '001') {
	    // Validate `input.country`.
	    if (!metadata.hasCountry(input.country)) {
	      throw new Error("Unknown country: ".concat(input.country));
	    }
	
	    metadata.country(input.country);
	  } else if (input.countryCallingCode) {
	    metadata.chooseCountryByCountryCallingCode(input.countryCallingCode);
	  } else return input.phone || '';
	
	  var countryCallingCode = metadata.countryCallingCode();
	  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
	  // but Babel has a bug and it says "duplicate variable declaration".
	
	  var number;
	
	  switch (format) {
	    case 'NATIONAL':
	      // Legacy argument support.
	      // (`{ country: ..., phone: '' }`)
	      if (!nationalNumber) {
	        return '';
	      }
	
	      number = formatNationalNumber(nationalNumber, 'NATIONAL', metadata, options);
	      return addExtension(number, input.ext, metadata, options.formatExtension);
	
	    case 'INTERNATIONAL':
	      // Legacy argument support.
	      // (`{ country: ..., phone: '' }`)
	      if (!nationalNumber) {
	        return "+".concat(countryCallingCode);
	      }
	
	      number = formatNationalNumber(nationalNumber, 'INTERNATIONAL', metadata, options);
	      number = "+".concat(countryCallingCode, " ").concat(number);
	      return addExtension(number, input.ext, metadata, options.formatExtension);
	
	    case 'E.164':
	      // `E.164` doesn't define "phone number extensions".
	      return "+".concat(countryCallingCode).concat(nationalNumber);
	
	    case 'RFC3966':
	      return (0, _RFC.formatRFC3966)({
	        number: "+".concat(countryCallingCode).concat(nationalNumber),
	        ext: input.ext
	      });
	
	    case 'IDD':
	      if (!options.fromCountry) {
	        return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
	      }
	
	      var IDDPrefix = (0, _IDD.getIDDPrefix)(options.fromCountry, undefined, metadata.metadata);
	
	      if (!IDDPrefix) {
	        return;
	      }
	
	      if (options.humanReadable) {
	        var formattedForSameCountryCallingCode = countryCallingCode && formatIDDSameCountryCallingCodeNumber(nationalNumber, metadata.countryCallingCode(), options.fromCountry, metadata, options);
	
	        if (formattedForSameCountryCallingCode) {
	          number = formattedForSameCountryCallingCode;
	        } else {
	          number = "".concat(IDDPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, 'INTERNATIONAL', metadata, options));
	        }
	
	        return addExtension(number, input.ext, metadata, options.formatExtension);
	      }
	
	      return "".concat(IDDPrefix).concat(countryCallingCode).concat(nationalNumber);
	
	    default:
	      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
	  }
	} // This was originally set to $1 but there are some countries for which the
	// first group is not used in the national pattern (e.g. Argentina) so the $1
	// group does not match correctly.  Therefore, we use \d, so that the first
	// group actually used in the pattern will be matched.
	
	
	var FIRST_GROUP_PATTERN = /(\$\d)/;
	exports.FIRST_GROUP_PATTERN = FIRST_GROUP_PATTERN;
	
	function formatNationalNumberUsingFormat(number, format, useInternationalSeparator, useNationalPrefixFormattingRule, metadata) {
	  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalSeparator ? format.internationalFormat() : useNationalPrefixFormattingRule && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());
	
	  if (useInternationalSeparator) {
	    return applyInternationalSeparatorStyle(formattedNumber);
	  }
	
	  return formattedNumber;
	}
	
	function formatNationalNumber(number, formatAs, metadata, options) {
	  var format = chooseFormatForNumber(metadata.formats(), number);
	
	  if (!format) {
	    return number;
	  }
	
	  return formatNationalNumberUsingFormat(number, format, formatAs === 'INTERNATIONAL', format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options.nationalPrefix === false ? false : true, metadata);
	}
	
	function chooseFormatForNumber(availableFormats, nationalNnumber) {
	  for (var _iterator = availableFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var format = _ref;
	
	    // Validate leading digits
	    if (format.leadingDigitsPatterns().length > 0) {
	      // The last leading_digits_pattern is used here, as it is the most detailed
	      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
	
	      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
	        continue;
	      }
	    } // Check that the national number matches the phone number format regular expression
	
	
	    if ((0, _util.matchesEntirely)(nationalNnumber, format.pattern())) {
	      return format;
	    }
	  }
	} // Removes brackets and replaces dashes with spaces.
	//
	// E.g. "(999) 111-22-33" -> "999 111 22 33"
	//
	// For some reason Google's metadata contains `<intlFormat/>`s with brackets and dashes.
	// Meanwhile, there's no single opinion about using punctuation in international phone numbers.
	//
	// For example, Google's `<intlFormat/>` for USA is `+1 213-373-4253`.
	// And here's a quote from WikiPedia's "North American Numbering Plan" page:
	// https://en.wikipedia.org/wiki/North_American_Numbering_Plan
	//
	// "The country calling code for all countries participating in the NANP is 1.
	// In international format, an NANP number should be listed as +1 301 555 01 00,
	// where 301 is an area code (Maryland)."
	//
	// I personally prefer the international format without any punctuation.
	// For example, brackets are remnants of the old age, meaning that the
	// phone number part in brackets (so called "area code") can be omitted
	// if dialing within the same "area".
	// And hyphens were clearly introduced for splitting local numbers into memorizable groups.
	// For example, remembering "5553535" is difficult but "555-35-35" is much simpler.
	// Imagine a man taking a bus from home to work and seeing an ad with a phone number.
	// He has a couple of seconds to memorize that number until it passes by.
	// If it were spaces instead of hyphens the man wouldn't necessarily get it,
	// but with hyphens instead of spaces the grouping is more explicit.
	// I personally think that hyphens introduce visual clutter,
	// so I prefer replacing them with spaces in international numbers.
	// In the modern age all output is done on displays where spaces are clearly distinguishable
	// so hyphens can be safely replaced with spaces without losing any legibility.
	//
	
	
	function applyInternationalSeparatorStyle(local) {
	  return local.replace(new RegExp("[".concat(_constants.VALID_PUNCTUATION, "]+"), 'g'), ' ').trim();
	}
	
	function addExtension(formattedNumber, ext, metadata, formatExtension) {
	  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
	}
	
	function formatIDDSameCountryCallingCodeNumber(number, toCountryCallingCode, fromCountry, toCountryMetadata, options) {
	  var fromCountryMetadata = new _metadata["default"](toCountryMetadata.metadata);
	  fromCountryMetadata.country(fromCountry); // If calling within the same country calling code.
	
	  if (toCountryCallingCode === fromCountryMetadata.countryCallingCode()) {
	    // For NANPA regions, return the national format for these regions
	    // but prefix it with the country calling code.
	    if (toCountryCallingCode === '1') {
	      return toCountryCallingCode + ' ' + formatNationalNumber(number, 'NATIONAL', toCountryMetadata, options);
	    } // If regions share a country calling code, the country calling code need
	    // not be dialled. This also applies when dialling within a region, so this
	    // if clause covers both these cases. Technically this is the case for
	    // dialling from La Reunion to other overseas departments of France (French
	    // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
	    // this edge case for now and for those cases return the version including
	    // country calling code. Details here:
	    // http://www.petitfute.com/voyage/225-info-pratiques-reunion
	    //
	
	
	    return formatNationalNumber(number, 'NATIONAL', toCountryMetadata, options);
	  }
	}
	//# sourceMappingURL=format_.js.map

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parsePhoneNumberFromString;
	
	var _parsePhoneNumber = __webpack_require__(777);
	
	var _parsePhoneNumberFromString_ = _interopRequireDefault(__webpack_require__(798));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function parsePhoneNumberFromString() {
	  var _normalizeArguments = (0, _parsePhoneNumber.normalizeArguments)(arguments),
	      text = _normalizeArguments.text,
	      options = _normalizeArguments.options,
	      metadata = _normalizeArguments.metadata;
	
	  return (0, _parsePhoneNumberFromString_["default"])(text, options, metadata);
	}
	//# sourceMappingURL=parsePhoneNumberFromString.js.map

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parsePhoneNumberFromString;
	
	var _parsePhoneNumber_ = _interopRequireDefault(__webpack_require__(778));
	
	var _ParseError = _interopRequireDefault(__webpack_require__(776));
	
	var _metadata = __webpack_require__(782);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function parsePhoneNumberFromString(text, options, metadata) {
	  // Validate `defaultCountry`.
	  if (options && options.defaultCountry && !(0, _metadata.isSupportedCountry)(options.defaultCountry, metadata)) {
	    options = _objectSpread({}, options, {
	      defaultCountry: undefined
	    });
	  } // Parse phone number.
	
	
	  try {
	    return (0, _parsePhoneNumber_["default"])(text, options, metadata);
	  } catch (error) {
	    /* istanbul ignore else */
	    if (error instanceof _ParseError["default"]) {//
	    } else {
	      throw error;
	    }
	  }
	}
	//# sourceMappingURL=parsePhoneNumberFromString_.js.map

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parseNumber;
	
	var _parse_ = _interopRequireDefault(__webpack_require__(779));
	
	var _parsePhoneNumber = __webpack_require__(777);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// `options`:
	//  {
	//    country:
	//    {
	//      restrict - (a two-letter country code)
	//                 the phone number must be in this country
	//
	//      default - (a two-letter country code)
	//                default country to use for phone number parsing and validation
	//                (if no country code could be derived from the phone number)
	//    }
	//  }
	//
	// Returns `{ country, number }`
	//
	// Example use cases:
	//
	// ```js
	// parse('8 (800) 555-35-35', 'RU')
	// parse('8 (800) 555-35-35', 'RU', metadata)
	// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
	// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
	// parse('+7 800 555 35 35')
	// parse('+7 800 555 35 35', metadata)
	// ```
	//
	function parseNumber() {
	  var _normalizeArguments = (0, _parsePhoneNumber.normalizeArguments)(arguments),
	      text = _normalizeArguments.text,
	      options = _normalizeArguments.options,
	      metadata = _normalizeArguments.metadata;
	
	  return (0, _parse_["default"])(text, options, metadata);
	}
	//# sourceMappingURL=parse.js.map

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = formatNumber;
	
	var _format_ = _interopRequireDefault(__webpack_require__(796));
	
	var _parse_ = _interopRequireDefault(__webpack_require__(779));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function formatNumber() {
	  var _normalizeArguments = normalizeArguments(arguments),
	      input = _normalizeArguments.input,
	      format = _normalizeArguments.format,
	      options = _normalizeArguments.options,
	      metadata = _normalizeArguments.metadata;
	
	  return (0, _format_["default"])(input, format, options, metadata);
	} // Sort out arguments
	
	
	function normalizeArguments(args) {
	  var _Array$prototype$slic = Array.prototype.slice.call(args),
	      _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 5),
	      arg_1 = _Array$prototype$slic2[0],
	      arg_2 = _Array$prototype$slic2[1],
	      arg_3 = _Array$prototype$slic2[2],
	      arg_4 = _Array$prototype$slic2[3],
	      arg_5 = _Array$prototype$slic2[4];
	
	  var input;
	  var format;
	  var options;
	  var metadata; // Sort out arguments.
	  // If the phone number is passed as a string.
	  // `format('8005553535', ...)`.
	
	  if (typeof arg_1 === 'string') {
	    // If country code is supplied.
	    // `format('8005553535', 'RU', 'NATIONAL', [options], metadata)`.
	    if (typeof arg_3 === 'string') {
	      format = arg_3;
	
	      if (arg_5) {
	        options = arg_4;
	        metadata = arg_5;
	      } else {
	        metadata = arg_4;
	      }
	
	      input = (0, _parse_["default"])(arg_1, {
	        defaultCountry: arg_2,
	        extended: true
	      }, metadata);
	    } // Just an international phone number is supplied
	    // `format('+78005553535', 'NATIONAL', [options], metadata)`.
	    else {
	        if (typeof arg_2 !== 'string') {
	          throw new Error('`format` argument not passed to `formatNumber(number, format)`');
	        }
	
	        format = arg_2;
	
	        if (arg_4) {
	          options = arg_3;
	          metadata = arg_4;
	        } else {
	          metadata = arg_3;
	        }
	
	        input = (0, _parse_["default"])(arg_1, {
	          extended: true
	        }, metadata);
	      }
	  } // If the phone number is passed as a parsed number object.
	  // `format({ phone: '8005553535', country: 'RU' }, 'NATIONAL', [options], metadata)`.
	  else if (is_object(arg_1)) {
	      input = arg_1;
	      format = arg_2;
	
	      if (arg_4) {
	        options = arg_3;
	        metadata = arg_4;
	      } else {
	        metadata = arg_3;
	      }
	    } else throw new TypeError('A phone number must either be a string or an object of shape { phone, [country] }.'); // Legacy lowercase formats.
	
	
	  if (format === 'International') {
	    format = 'INTERNATIONAL';
	  } else if (format === 'National') {
	    format = 'NATIONAL';
	  }
	
	  return {
	    input: input,
	    format: format,
	    options: options,
	    metadata: metadata
	  };
	} // Babel transforms `typeof` into some "branches"
	// so istanbul will show this as "branch not covered".
	
	/* istanbul ignore next */
	
	
	var is_object = function is_object(_) {
	  return _typeof(_) === 'object';
	};
	//# sourceMappingURL=format.js.map

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getNumberType;
	exports.normalizeArguments = normalizeArguments;
	
	var _isViablePhoneNumber = _interopRequireDefault(__webpack_require__(784));
	
	var _getNumberType_ = _interopRequireDefault(__webpack_require__(789));
	
	var _parse_ = _interopRequireDefault(__webpack_require__(779));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	// Finds out national phone number type (fixed line, mobile, etc)
	function getNumberType() {
	  var _normalizeArguments = normalizeArguments(arguments),
	      input = _normalizeArguments.input,
	      options = _normalizeArguments.options,
	      metadata = _normalizeArguments.metadata;
	
	  return (0, _getNumberType_["default"])(input, options, metadata);
	} // Sort out arguments
	
	
	function normalizeArguments(args) {
	  var _Array$prototype$slic = Array.prototype.slice.call(args),
	      _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4),
	      arg_1 = _Array$prototype$slic2[0],
	      arg_2 = _Array$prototype$slic2[1],
	      arg_3 = _Array$prototype$slic2[2],
	      arg_4 = _Array$prototype$slic2[3];
	
	  var input;
	  var options = {};
	  var metadata; // If the phone number is passed as a string.
	  // `getNumberType('88005553535', ...)`.
	
	  if (typeof arg_1 === 'string') {
	    // If "default country" argument is being passed
	    // then convert it to an `options` object.
	    // `getNumberType('88005553535', 'RU', metadata)`.
	    if (_typeof(arg_2) !== 'object') {
	      if (arg_4) {
	        options = arg_3;
	        metadata = arg_4;
	      } else {
	        metadata = arg_3;
	      } // `parse` extracts phone numbers from raw text,
	      // therefore it will cut off all "garbage" characters,
	      // while this `validate` function needs to verify
	      // that the phone number contains no "garbage"
	      // therefore the explicit `isViablePhoneNumber` check.
	
	
	      if ((0, _isViablePhoneNumber["default"])(arg_1)) {
	        input = (0, _parse_["default"])(arg_1, {
	          defaultCountry: arg_2
	        }, metadata);
	      } else {
	        input = {};
	      }
	    } // No "resrict country" argument is being passed.
	    // International phone number is passed.
	    // `getNumberType('+78005553535', metadata)`.
	    else {
	        if (arg_3) {
	          options = arg_2;
	          metadata = arg_3;
	        } else {
	          metadata = arg_2;
	        } // `parse` extracts phone numbers from raw text,
	        // therefore it will cut off all "garbage" characters,
	        // while this `validate` function needs to verify
	        // that the phone number contains no "garbage"
	        // therefore the explicit `isViablePhoneNumber` check.
	
	
	        if ((0, _isViablePhoneNumber["default"])(arg_1)) {
	          input = (0, _parse_["default"])(arg_1, undefined, metadata);
	        } else {
	          input = {};
	        }
	      }
	  } // If the phone number is passed as a parsed phone number.
	  // `getNumberType({ phone: '88005553535', country: 'RU' }, ...)`.
	  else if (is_object(arg_1)) {
	      input = arg_1;
	
	      if (arg_3) {
	        options = arg_2;
	        metadata = arg_3;
	      } else {
	        metadata = arg_2;
	      }
	    } else throw new TypeError('A phone number must either be a string or an object of shape { phone, [country] }.');
	
	  return {
	    input: input,
	    options: options,
	    metadata: metadata
	  };
	} // Babel transforms `typeof` into some "branches"
	// so istanbul will show this as "branch not covered".
	
	/* istanbul ignore next */
	
	
	var is_object = function is_object(_) {
	  return _typeof(_) === 'object';
	};
	//# sourceMappingURL=getNumberType.js.map

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getExampleNumber;
	
	var _PhoneNumber = _interopRequireDefault(__webpack_require__(793));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getExampleNumber(country, examples, metadata) {
	  if (examples[country]) {
	    return new _PhoneNumber["default"](country, examples[country], metadata);
	  }
	}
	//# sourceMappingURL=getExampleNumber.js.map

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isPossibleNumber;
	
	var _getNumberType = __webpack_require__(801);
	
	var _isPossibleNumber_ = _interopRequireDefault(__webpack_require__(790));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Checks if a given phone number is possible.
	 * Which means it only checks phone number length
	 * and doesn't test any regular expressions.
	 *
	 * Examples:
	 *
	 * ```js
	 * isPossibleNumber('+78005553535', metadata)
	 * isPossibleNumber('8005553535', 'RU', metadata)
	 * isPossibleNumber('88005553535', 'RU', metadata)
	 * isPossibleNumber({ phone: '8005553535', country: 'RU' }, metadata)
	 * ```
	 */
	function isPossibleNumber() {
	  var _normalizeArguments = (0, _getNumberType.normalizeArguments)(arguments),
	      input = _normalizeArguments.input,
	      options = _normalizeArguments.options,
	      metadata = _normalizeArguments.metadata;
	
	  return (0, _isPossibleNumber_["default"])(input, options, metadata);
	}
	//# sourceMappingURL=isPossibleNumber.js.map

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isValidNumber;
	
	var _validate_ = _interopRequireDefault(__webpack_require__(794));
	
	var _getNumberType = __webpack_require__(801);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// Finds out national phone number type (fixed line, mobile, etc)
	function isValidNumber() {
	  var _normalizeArguments = (0, _getNumberType.normalizeArguments)(arguments),
	      input = _normalizeArguments.input,
	      options = _normalizeArguments.options,
	      metadata = _normalizeArguments.metadata;
	
	  return (0, _validate_["default"])(input, options, metadata);
	}
	//# sourceMappingURL=validate.js.map

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isValidNumberForRegion;
	
	var _isViablePhoneNumber = _interopRequireDefault(__webpack_require__(784));
	
	var _parse_ = _interopRequireDefault(__webpack_require__(779));
	
	var _isValidNumberForRegion_ = _interopRequireDefault(__webpack_require__(795));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function isValidNumberForRegion(number, country, metadata) {
	  if (typeof number !== 'string') {
	    throw new TypeError('number must be a string');
	  }
	
	  if (typeof country !== 'string') {
	    throw new TypeError('country must be a string');
	  } // `parse` extracts phone numbers from raw text,
	  // therefore it will cut off all "garbage" characters,
	  // while this `validate` function needs to verify
	  // that the phone number contains no "garbage"
	  // therefore the explicit `isViablePhoneNumber` check.
	
	
	  var input;
	
	  if ((0, _isViablePhoneNumber["default"])(number)) {
	    input = (0, _parse_["default"])(number, {
	      defaultCountry: country
	    }, metadata);
	  } else {
	    input = {};
	  }
	
	  return (0, _isValidNumberForRegion_["default"])(input, country, undefined, metadata);
	}
	//# sourceMappingURL=isValidNumberForRegion.js.map

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = findNumbers;
	
	var _findNumbers_ = _interopRequireDefault(__webpack_require__(807));
	
	var _parsePhoneNumber = __webpack_require__(777);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function findNumbers() {
	  var _normalizeArguments = (0, _parsePhoneNumber.normalizeArguments)(arguments),
	      text = _normalizeArguments.text,
	      options = _normalizeArguments.options,
	      metadata = _normalizeArguments.metadata;
	
	  return (0, _findNumbers_["default"])(text, options, metadata);
	}
	//# sourceMappingURL=findNumbers.js.map

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = findNumbers;
	
	var _PhoneNumberMatcher = _interopRequireDefault(__webpack_require__(808));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function findNumbers(text, options, metadata) {
	  var matcher = new _PhoneNumberMatcher["default"](text, options, metadata);
	  var results = [];
	
	  while (matcher.hasNext()) {
	    results.push(matcher.next());
	  }
	
	  return results;
	}
	//# sourceMappingURL=findNumbers_.js.map

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _PhoneNumber = _interopRequireDefault(__webpack_require__(793));
	
	var _constants = __webpack_require__(780);
	
	var _extension = __webpack_require__(785);
	
	var _RegExpCache = _interopRequireDefault(__webpack_require__(809));
	
	var _util = __webpack_require__(811);
	
	var _utf = __webpack_require__(812);
	
	var _Leniency = _interopRequireDefault(__webpack_require__(813));
	
	var _parsePreCandidate = _interopRequireDefault(__webpack_require__(814));
	
	var _isValidPreCandidate = _interopRequireDefault(__webpack_require__(815));
	
	var _isValidCandidate = _interopRequireWildcard(__webpack_require__(816));
	
	var _metadata = __webpack_require__(782);
	
	var _parse_ = _interopRequireDefault(__webpack_require__(779));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Patterns used to extract phone numbers from a larger phone-number-like pattern. These are
	 * ordered according to specificity. For example, white-space is last since that is frequently
	 * used in numbers, not just to separate two numbers. We have separate patterns since we don't
	 * want to break up the phone-number-like text on more than one different kind of symbol at one
	 * time, although symbols of the same type (e.g. space) can be safely grouped together.
	 *
	 * Note that if there is a match, we will always check any text found up to the first match as
	 * well.
	 */
	var INNER_MATCHES = [// Breaks on the slash - e.g. "651-234-2345/332-445-1234"
	'\\/+(.*)/', // Note that the bracket here is inside the capturing group, since we consider it part of the
	// phone number. Will match a pattern like "(650) 223 3345 (754) 223 3321".
	'(\\([^(]*)', // Breaks on a hyphen - e.g. "12345 - 332-445-1234 is my number."
	// We require a space on either side of the hyphen for it to be considered a separator.
	"(?:".concat(_utf.pZ, "-|-").concat(_utf.pZ, ")").concat(_utf.pZ, "*(.+)"), // Various types of wide hyphens. Note we have decided not to enforce a space here, since it's
	// possible that it's supposed to be used to break two numbers without spaces, and we haven't
	// seen many instances of it used within a number.
	"[\u2012-\u2015\uFF0D]".concat(_utf.pZ, "*(.+)"), // Breaks on a full stop - e.g. "12345. 332-445-1234 is my number."
	"\\.+".concat(_utf.pZ, "*([^.]+)"), // Breaks on space - e.g. "3324451234 8002341234"
	"".concat(_utf.pZ, "+(").concat(_utf.PZ, "+)")]; // Limit on the number of leading (plus) characters.
	
	var leadLimit = (0, _util.limit)(0, 2); // Limit on the number of consecutive punctuation characters.
	
	var punctuationLimit = (0, _util.limit)(0, 4);
	/* The maximum number of digits allowed in a digit-separated block. As we allow all digits in a
	 * single block, set high enough to accommodate the entire national number and the international
	 * country code. */
	
	var digitBlockLimit = _constants.MAX_LENGTH_FOR_NSN + _constants.MAX_LENGTH_COUNTRY_CODE; // Limit on the number of blocks separated by punctuation.
	// Uses digitBlockLimit since some formats use spaces to separate each digit.
	
	var blockLimit = (0, _util.limit)(0, digitBlockLimit);
	/* A punctuation sequence allowing white space. */
	
	var punctuation = "[".concat(_constants.VALID_PUNCTUATION, "]") + punctuationLimit; // A digits block without punctuation.
	
	var digitSequence = _utf.pNd + (0, _util.limit)(1, digitBlockLimit);
	/**
	 * Phone number pattern allowing optional punctuation.
	 * The phone number pattern used by `find()`, similar to
	 * VALID_PHONE_NUMBER, but with the following differences:
	 * <ul>
	 *   <li>All captures are limited in order to place an upper bound to the text matched by the
	 *       pattern.
	 * <ul>
	 *   <li>Leading punctuation / plus signs are limited.
	 *   <li>Consecutive occurrences of punctuation are limited.
	 *   <li>Number of digits is limited.
	 * </ul>
	 *   <li>No whitespace is allowed at the start or end.
	 *   <li>No alpha digits (vanity numbers such as 1-800-SIX-FLAGS) are currently supported.
	 * </ul>
	 */
	
	var PATTERN = '(?:' + _isValidCandidate.LEAD_CLASS + punctuation + ')' + leadLimit + digitSequence + '(?:' + punctuation + digitSequence + ')' + blockLimit + '(?:' + _extension.EXTN_PATTERNS_FOR_MATCHING + ')?'; // Regular expression of trailing characters that we want to remove.
	// We remove all characters that are not alpha or numerical characters.
	// The hash character is retained here, as it may signify
	// the previous block was an extension.
	//
	// // Don't know what does '&&' mean here.
	// const UNWANTED_END_CHAR_PATTERN = new RegExp(`[[\\P{N}&&\\P{L}]&&[^#]]+$`)
	//
	
	var UNWANTED_END_CHAR_PATTERN = new RegExp("[^".concat(_utf._pN).concat(_utf._pL, "#]+$"));
	var NON_DIGITS_PATTERN = /(\D+)/;
	var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
	/**
	 * A stateful class that finds and extracts telephone numbers from {@linkplain CharSequence text}.
	 * Instances can be created using the {@linkplain PhoneNumberUtil#findNumbers factory methods} in
	 * {@link PhoneNumberUtil}.
	 *
	 * <p>Vanity numbers (phone numbers using alphabetic digits such as <tt>1-800-SIX-FLAGS</tt> are
	 * not found.
	 *
	 * <p>This class is not thread-safe.
	 */
	
	var PhoneNumberMatcher =
	/*#__PURE__*/
	function () {
	  /** The iteration tristate. */
	
	  /** The next index to start searching at. Undefined in {@link State#DONE}. */
	  // A cache for frequently used country-specific regular expressions. Set to 32 to cover ~2-3
	  // countries being used for the same doc with ~10 patterns for each country. Some pages will have
	  // a lot more countries in use, but typically fewer numbers for each so expanding the cache for
	  // that use-case won't have a lot of benefit.
	
	  /**
	   * Creates a new instance. See the factory methods in {@link PhoneNumberUtil} on how to obtain a
	   * new instance.
	   *
	   * @param util  the phone number util to use
	   * @param text  the character sequence that we will search, null for no text
	   * @param country  the country to assume for phone numbers not written in international format
	   *     (with a leading plus, or with the international dialing prefix of the specified region).
	   *     May be null or "ZZ" if only numbers with a leading plus should be
	   *     considered.
	   * @param leniency  the leniency to use when evaluating candidate phone numbers
	   * @param maxTries  the maximum number of invalid numbers to try before giving up on the text.
	   *     This is to cover degenerate cases where the text has a lot of false positives in it. Must
	   *     be {@code >= 0}.
	   */
	  function PhoneNumberMatcher() {
	    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var metadata = arguments.length > 2 ? arguments[2] : undefined;
	
	    _classCallCheck(this, PhoneNumberMatcher);
	
	    _defineProperty(this, "state", 'NOT_READY');
	
	    _defineProperty(this, "searchIndex", 0);
	
	    _defineProperty(this, "regExpCache", new _RegExpCache["default"](32));
	
	    options = _objectSpread({}, options, {
	      defaultCallingCode: options.defaultCallingCode,
	      defaultCountry: options.defaultCountry && (0, _metadata.isSupportedCountry)(options.defaultCountry, metadata) ? options.defaultCountry : undefined,
	      leniency: options.leniency || options.extended ? 'POSSIBLE' : 'VALID',
	      maxTries: options.maxTries || MAX_SAFE_INTEGER
	    });
	
	    if (!options.leniency) {
	      throw new TypeError('`Leniency` not supplied');
	    }
	
	    if (options.maxTries < 0) {
	      throw new TypeError('`maxTries` not supplied');
	    }
	
	    this.text = text;
	    this.options = options;
	    this.metadata = metadata;
	    /** The degree of validation requested. */
	
	    this.leniency = _Leniency["default"][options.leniency];
	
	    if (!this.leniency) {
	      throw new TypeError("Unknown leniency: ".concat(options.leniency, "."));
	    }
	    /** The maximum number of retries after matching an invalid number. */
	
	
	    this.maxTries = options.maxTries;
	    this.PATTERN = new RegExp(PATTERN, 'ig');
	  }
	  /**
	   * Attempts to find the next subsequence in the searched sequence on or after {@code searchIndex}
	   * that represents a phone number. Returns the next match, null if none was found.
	   *
	   * @param index  the search index to start searching at
	   * @return  the phone number match found, null if none can be found
	   */
	
	
	  _createClass(PhoneNumberMatcher, [{
	    key: "find",
	    value: function find() // (index)
	    {
	      // // Reset the regular expression.
	      // this.PATTERN.lastIndex = index
	      var matches;
	
	      while (this.maxTries > 0 && (matches = this.PATTERN.exec(this.text)) !== null) {
	        var candidate = matches[0];
	        var offset = matches.index;
	        candidate = (0, _parsePreCandidate["default"])(candidate);
	
	        if ((0, _isValidPreCandidate["default"])(candidate, offset, this.text)) {
	          var match = // Try to come up with a valid match given the entire candidate.
	          this.parseAndVerify(candidate, offset, this.text) // If that failed, try to find an "inner match" -
	          // there might be a phone number within this candidate.
	          || this.extractInnerMatch(candidate, offset, this.text);
	
	          if (match) {
	            if (this.options.v2) {
	              var phoneNumber = new _PhoneNumber["default"](match.country || match.countryCallingCode, match.phone, this.metadata);
	
	              if (match.ext) {
	                phoneNumber.ext = match.ext;
	              }
	
	              return {
	                startsAt: match.startsAt,
	                endsAt: match.endsAt,
	                number: phoneNumber
	              };
	            }
	
	            return match;
	          }
	        }
	
	        this.maxTries--;
	      }
	    }
	    /**
	     * Attempts to extract a match from `candidate`
	     * if the whole candidate does not qualify as a match.
	     */
	
	  }, {
	    key: "extractInnerMatch",
	    value: function extractInnerMatch(candidate, offset, text) {
	      for (var _i = 0, _INNER_MATCHES = INNER_MATCHES; _i < _INNER_MATCHES.length; _i++) {
	        var innerMatchPattern = _INNER_MATCHES[_i];
	        var isFirstMatch = true;
	        var matches = void 0;
	        var possibleInnerMatch = new RegExp(innerMatchPattern, 'g');
	
	        while ((matches = possibleInnerMatch.exec(candidate)) !== null && this.maxTries > 0) {
	          if (isFirstMatch) {
	            // We should handle any group before this one too.
	            var _group = (0, _util.trimAfterFirstMatch)(UNWANTED_END_CHAR_PATTERN, candidate.slice(0, matches.index));
	
	            var _match = this.parseAndVerify(_group, offset, text);
	
	            if (_match) {
	              return _match;
	            }
	
	            this.maxTries--;
	            isFirstMatch = false;
	          }
	
	          var group = (0, _util.trimAfterFirstMatch)(UNWANTED_END_CHAR_PATTERN, matches[1]); // Java code does `groupMatcher.start(1)` here,
	          // but there's no way in javascript to get a group match start index,
	          // therefore using the overall match start index `matches.index`.
	
	          var match = this.parseAndVerify(group, offset + matches.index, text);
	
	          if (match) {
	            return match;
	          }
	
	          this.maxTries--;
	        }
	      }
	    }
	    /**
	     * Parses a phone number from the `candidate` using `parseNumber` and
	     * verifies it matches the requested `leniency`. If parsing and verification succeed,
	     * a corresponding `PhoneNumberMatch` is returned, otherwise this method returns `null`.
	     *
	     * @param candidate  the candidate match
	     * @param offset  the offset of {@code candidate} within {@link #text}
	     * @return  the parsed and validated phone number match, or null
	     */
	
	  }, {
	    key: "parseAndVerify",
	    value: function parseAndVerify(candidate, offset, text) {
	      if (!(0, _isValidCandidate["default"])(candidate, offset, text, this.options.leniency)) {
	        return;
	      }
	
	      var number = (0, _parse_["default"])(candidate, {
	        extended: true,
	        defaultCountry: this.options.defaultCountry,
	        defaultCallingCode: this.options.defaultCallingCode
	      }, this.metadata);
	
	      if (!number.possible) {
	        return;
	      }
	
	      if (this.leniency(number, candidate, this.metadata, this.regExpCache)) {
	        // // We used parseAndKeepRawInput to create this number,
	        // // but for now we don't return the extra values parsed.
	        // // TODO: stop clearing all values here and switch all users over
	        // // to using rawInput() rather than the rawString() of PhoneNumberMatch.
	        // number.clearCountryCodeSource()
	        // number.clearRawInput()
	        // number.clearPreferredDomesticCarrierCode()
	        var result = {
	          startsAt: offset,
	          endsAt: offset + candidate.length,
	          phone: number.phone
	        };
	
	        if (number.country && number.country !== '001') {
	          result.country = number.country;
	        } else {
	          result.countryCallingCode = number.countryCallingCode;
	        }
	
	        if (number.ext) {
	          result.ext = number.ext;
	        }
	
	        return result;
	      }
	    }
	  }, {
	    key: "hasNext",
	    value: function hasNext() {
	      if (this.state === 'NOT_READY') {
	        this.lastMatch = this.find(); // (this.searchIndex)
	
	        if (this.lastMatch) {
	          // this.searchIndex = this.lastMatch.endsAt
	          this.state = 'READY';
	        } else {
	          this.state = 'DONE';
	        }
	      }
	
	      return this.state === 'READY';
	    }
	  }, {
	    key: "next",
	    value: function next() {
	      // Check the state and find the next match as a side-effect if necessary.
	      if (!this.hasNext()) {
	        throw new Error('No next element');
	      } // Don't retain that memory any longer than necessary.
	
	
	      var result = this.lastMatch;
	      this.lastMatch = null;
	      this.state = 'NOT_READY';
	      return result;
	    }
	  }]);
	
	  return PhoneNumberMatcher;
	}();
	
	exports["default"] = PhoneNumberMatcher;
	//# sourceMappingURL=PhoneNumberMatcher.js.map

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _LRUCache = _interopRequireDefault(__webpack_require__(810));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	// A cache for frequently used country-specific regular expressions. Set to 32 to cover ~2-3
	// countries being used for the same doc with ~10 patterns for each country. Some pages will have
	// a lot more countries in use, but typically fewer numbers for each so expanding the cache for
	// that use-case won't have a lot of benefit.
	var RegExpCache =
	/*#__PURE__*/
	function () {
	  function RegExpCache(size) {
	    _classCallCheck(this, RegExpCache);
	
	    this.cache = new _LRUCache["default"](size);
	  }
	
	  _createClass(RegExpCache, [{
	    key: "getPatternForRegExp",
	    value: function getPatternForRegExp(pattern) {
	      var regExp = this.cache.get(pattern);
	
	      if (!regExp) {
	        regExp = new RegExp('^' + pattern);
	        this.cache.put(pattern, regExp);
	      }
	
	      return regExp;
	    }
	  }]);
	
	  return RegExpCache;
	}();
	
	exports["default"] = RegExpCache;
	//# sourceMappingURL=RegExpCache.js.map

/***/ }),
/* 810 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// https://medium.com/dsinjs/implementing-lru-cache-in-javascript-94ba6755cda9
	var Node = function Node(key, value) {
	  var next = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  var prev = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  _classCallCheck(this, Node);
	
	  this.key = key;
	  this.value = value;
	  this.next = next;
	  this.prev = prev;
	};
	
	var LRUCache =
	/*#__PURE__*/
	function () {
	  //set default limit of 10 if limit is not passed.
	  function LRUCache() {
	    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
	
	    _classCallCheck(this, LRUCache);
	
	    this.size = 0;
	    this.limit = limit;
	    this.head = null;
	    this.tail = null;
	    this.cache = {};
	  } // Write Node to head of LinkedList
	  // update cache with Node key and Node reference
	
	
	  _createClass(LRUCache, [{
	    key: "put",
	    value: function put(key, value) {
	      this.ensureLimit();
	
	      if (!this.head) {
	        this.head = this.tail = new Node(key, value);
	      } else {
	        var node = new Node(key, value, this.head);
	        this.head.prev = node;
	        this.head = node;
	      } //Update the cache map
	
	
	      this.cache[key] = this.head;
	      this.size++;
	    } // Read from cache map and make that node as new Head of LinkedList
	
	  }, {
	    key: "get",
	    value: function get(key) {
	      if (this.cache[key]) {
	        var value = this.cache[key].value; // node removed from it's position and cache
	
	        this.remove(key); // write node again to the head of LinkedList to make it most recently used
	
	        this.put(key, value);
	        return value;
	      }
	
	      console.log("Item not available in cache for key ".concat(key));
	    }
	  }, {
	    key: "ensureLimit",
	    value: function ensureLimit() {
	      if (this.size === this.limit) {
	        this.remove(this.tail.key);
	      }
	    }
	  }, {
	    key: "remove",
	    value: function remove(key) {
	      var node = this.cache[key];
	
	      if (node.prev !== null) {
	        node.prev.next = node.next;
	      } else {
	        this.head = node.next;
	      }
	
	      if (node.next !== null) {
	        node.next.prev = node.prev;
	      } else {
	        this.tail = node.prev;
	      }
	
	      delete this.cache[key];
	      this.size--;
	    }
	  }, {
	    key: "clear",
	    value: function clear() {
	      this.head = null;
	      this.tail = null;
	      this.size = 0;
	      this.cache = {};
	    } // // Invokes the callback function with every node of the chain and the index of the node.
	    // forEach(fn) {
	    //   let node = this.head;
	    //   let counter = 0;
	    //   while (node) {
	    //     fn(node, counter);
	    //     node = node.next;
	    //     counter++;
	    //   }
	    // }
	    // // To iterate over LRU with a 'for...of' loop
	    // *[Symbol.iterator]() {
	    //   let node = this.head;
	    //   while (node) {
	    //     yield node;
	    //     node = node.next;
	    //   }
	    // }
	
	  }]);
	
	  return LRUCache;
	}();
	
	exports["default"] = LRUCache;
	//# sourceMappingURL=LRUCache.js.map

/***/ }),
/* 811 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.limit = limit;
	exports.trimAfterFirstMatch = trimAfterFirstMatch;
	exports.startsWith = startsWith;
	exports.endsWith = endsWith;
	
	/** Returns a regular expression quantifier with an upper and lower limit. */
	function limit(lower, upper) {
	  if (lower < 0 || upper <= 0 || upper < lower) {
	    throw new TypeError();
	  }
	
	  return "{".concat(lower, ",").concat(upper, "}");
	}
	/**
	 * Trims away any characters after the first match of {@code pattern} in {@code candidate},
	 * returning the trimmed version.
	 */
	
	
	function trimAfterFirstMatch(regexp, string) {
	  var index = string.search(regexp);
	
	  if (index >= 0) {
	    return string.slice(0, index);
	  }
	
	  return string;
	}
	
	function startsWith(string, substring) {
	  return string.indexOf(substring) === 0;
	}
	
	function endsWith(string, substring) {
	  return string.indexOf(substring, string.length - substring.length) === string.length - substring.length;
	}
	//# sourceMappingURL=util.js.map

/***/ }),
/* 812 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isLatinLetter = isLatinLetter;
	exports.isInvalidPunctuationSymbol = isInvalidPunctuationSymbol;
	exports._pL = exports.pNd = exports._pN = exports.PZ = exports.pZ = void 0;
	// Javascript doesn't support UTF-8 regular expressions.
	// So mimicking them here.
	// Copy-pasted from `PhoneNumberMatcher.js`.
	
	/**
	 * "\p{Z}" is any kind of whitespace or invisible separator ("Separator").
	 * http://www.regular-expressions.info/unicode.html
	 * "\P{Z}" is the reverse of "\p{Z}".
	 * "\p{N}" is any kind of numeric character in any script ("Number").
	 * "\p{Nd}" is a digit zero through nine in any script except "ideographic scripts" ("Decimal_Digit_Number").
	 * "\p{Sc}" is a currency symbol ("Currency_Symbol").
	 * "\p{L}" is any kind of letter from any language ("Letter").
	 * "\p{Mn}" is "non-spacing mark".
	 *
	 * Javascript doesn't support Unicode Regular Expressions
	 * so substituting it with this explicit set of characters.
	 *
	 * https://stackoverflow.com/questions/13210194/javascript-regex-equivalent-of-a-za-z-using-pl
	 * https://github.com/danielberndt/babel-plugin-utf-8-regex/blob/master/src/transformer.js
	 */
	var _pZ = " \xA0\u1680\u180E\u2000-\u200A\u2028\u2029\u202F\u205F\u3000";
	var pZ = "[".concat(_pZ, "]");
	exports.pZ = pZ;
	var PZ = "[^".concat(_pZ, "]");
	exports.PZ = PZ;
	var _pN = "0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19"; // const pN = `[${_pN}]`
	
	exports._pN = _pN;
	var _pNd = "0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19";
	var pNd = "[".concat(_pNd, "]");
	exports.pNd = pNd;
	var _pL = "A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
	exports._pL = _pL;
	var pL = "[".concat(_pL, "]");
	var pL_regexp = new RegExp(pL);
	var _pSc = "$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20B9\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6";
	var pSc = "[".concat(_pSc, "]");
	var pSc_regexp = new RegExp(pSc);
	var _pMn = "\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E4-\u08FE\u0900-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1DC0-\u1DE6\u1DFC-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE26";
	var pMn = "[".concat(_pMn, "]");
	var pMn_regexp = new RegExp(pMn);
	var _InBasic_Latin = "\0-\x7F";
	var _InLatin_1_Supplement = "\x80-\xFF";
	var _InLatin_Extended_A = "\u0100-\u017F";
	var _InLatin_Extended_Additional = "\u1E00-\u1EFF";
	var _InLatin_Extended_B = "\u0180-\u024F";
	var _InCombining_Diacritical_Marks = "\u0300-\u036F";
	var latinLetterRegexp = new RegExp('[' + _InBasic_Latin + _InLatin_1_Supplement + _InLatin_Extended_A + _InLatin_Extended_Additional + _InLatin_Extended_B + _InCombining_Diacritical_Marks + ']');
	/**
	 * Helper method to determine if a character is a Latin-script letter or not.
	 * For our purposes, combining marks should also return true since we assume
	 * they have been added to a preceding Latin character.
	 */
	
	function isLatinLetter(letter) {
	  // Combining marks are a subset of non-spacing-mark.
	  if (!pL_regexp.test(letter) && !pMn_regexp.test(letter)) {
	    return false;
	  }
	
	  return latinLetterRegexp.test(letter);
	}
	
	function isInvalidPunctuationSymbol(character) {
	  return character === '%' || pSc_regexp.test(character);
	}
	//# sourceMappingURL=utf-8.js.map

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.containsMoreThanOneSlashInNationalNumber = containsMoreThanOneSlashInNationalNumber;
	exports["default"] = void 0;
	
	var _validate_ = _interopRequireDefault(__webpack_require__(794));
	
	var _parseDigits = _interopRequireDefault(__webpack_require__(787));
	
	var _util = __webpack_require__(811);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Leniency when finding potential phone numbers in text segments
	 * The levels here are ordered in increasing strictness.
	 */
	var _default = {
	  /**
	   * Phone numbers accepted are "possible", but not necessarily "valid".
	   */
	  POSSIBLE: function POSSIBLE(number, candidate, metadata) {
	    return true;
	  },
	
	  /**
	   * Phone numbers accepted are "possible" and "valid".
	   * Numbers written in national format must have their national-prefix
	   * present if it is usually written for a number of this type.
	   */
	  VALID: function VALID(number, candidate, metadata) {
	    if (!(0, _validate_["default"])(number, undefined, metadata) || !containsOnlyValidXChars(number, candidate.toString(), metadata)) {
	      return false;
	    } // Skipped for simplicity.
	    // return isNationalPrefixPresentIfRequired(number, metadata)
	
	
	    return true;
	  },
	
	  /**
	   * Phone numbers accepted are "valid" and
	   * are grouped in a possible way for this locale. For example, a US number written as
	   * "65 02 53 00 00" and "650253 0000" are not accepted at this leniency level, whereas
	   * "650 253 0000", "650 2530000" or "6502530000" are.
	   * Numbers with more than one '/' symbol in the national significant number
	   * are also dropped at this level.
	   *
	   * Warning: This level might result in lower coverage especially for regions outside of
	   * country code "+1". If you are not sure about which level to use,
	   * email the discussion group libphonenumber-discuss@googlegroups.com.
	   */
	  STRICT_GROUPING: function STRICT_GROUPING(number, candidate, metadata, regExpCache) {
	    var candidateString = candidate.toString();
	
	    if (!(0, _validate_["default"])(number, undefined, metadata) || !containsOnlyValidXChars(number, candidateString, metadata) || containsMoreThanOneSlashInNationalNumber(number, candidateString) || !isNationalPrefixPresentIfRequired(number, metadata)) {
	      return false;
	    }
	
	    return checkNumberGroupingIsValid(number, candidate, metadata, allNumberGroupsRemainGrouped, regExpCache);
	  },
	
	  /**
	   * Phone numbers accepted are {@linkplain PhoneNumberUtil#isValidNumber(PhoneNumber) valid} and
	   * are grouped in the same way that we would have formatted it, or as a single block. For
	   * example, a US number written as "650 2530000" is not accepted at this leniency level, whereas
	   * "650 253 0000" or "6502530000" are.
	   * Numbers with more than one '/' symbol are also dropped at this level.
	   * <p>
	   * Warning: This level might result in lower coverage especially for regions outside of country
	   * code "+1". If you are not sure about which level to use, email the discussion group
	   * libphonenumber-discuss@googlegroups.com.
	   */
	  EXACT_GROUPING: function EXACT_GROUPING(number, candidate, metadata, regExpCache) {
	    var candidateString = candidate.toString();
	
	    if (!(0, _validate_["default"])(number, undefined, metadata) || !containsOnlyValidXChars(number, candidateString, metadata) || containsMoreThanOneSlashInNationalNumber(number, candidateString) || !isNationalPrefixPresentIfRequired(number, metadata)) {
	      return false;
	    }
	
	    return checkNumberGroupingIsValid(number, candidate, metadata, allNumberGroupsAreExactlyPresent, regExpCache);
	  }
	};
	exports["default"] = _default;
	
	function containsOnlyValidXChars(number, candidate, metadata) {
	  // The characters 'x' and 'X' can be (1) a carrier code, in which case they always precede the
	  // national significant number or (2) an extension sign, in which case they always precede the
	  // extension number. We assume a carrier code is more than 1 digit, so the first case has to
	  // have more than 1 consecutive 'x' or 'X', whereas the second case can only have exactly 1 'x'
	  // or 'X'. We ignore the character if it appears as the last character of the string.
	  for (var index = 0; index < candidate.length - 1; index++) {
	    var charAtIndex = candidate.charAt(index);
	
	    if (charAtIndex === 'x' || charAtIndex === 'X') {
	      var charAtNextIndex = candidate.charAt(index + 1);
	
	      if (charAtNextIndex === 'x' || charAtNextIndex === 'X') {
	        // This is the carrier code case, in which the 'X's always precede the national
	        // significant number.
	        index++;
	
	        if (util.isNumberMatch(number, candidate.substring(index)) != MatchType.NSN_MATCH) {
	          return false;
	        } // This is the extension sign case, in which the 'x' or 'X' should always precede the
	        // extension number.
	
	      } else if ((0, _parseDigits["default"])(candidate.substring(index)) !== number.ext) {
	        return false;
	      }
	    }
	  }
	
	  return true;
	}
	
	function isNationalPrefixPresentIfRequired(number, _metadata) {
	  // First, check how we deduced the country code. If it was written in international format, then
	  // the national prefix is not required.
	  if (number.getCountryCodeSource() != 'FROM_DEFAULT_COUNTRY') {
	    return true;
	  }
	
	  var phoneNumberRegion = util.getRegionCodeForCountryCode(number.getCountryCode());
	  var metadata = util.getMetadataForRegion(phoneNumberRegion);
	
	  if (metadata == null) {
	    return true;
	  } // Check if a national prefix should be present when formatting this number.
	
	
	  var nationalNumber = util.getNationalSignificantNumber(number);
	  var formatRule = util.chooseFormattingPatternForNumber(metadata.numberFormats(), nationalNumber); // To do this, we check that a national prefix formatting rule was present
	  // and that it wasn't just the first-group symbol ($1) with punctuation.
	
	  if (formatRule && formatRule.getNationalPrefixFormattingRule().length > 0) {
	    if (formatRule.getNationalPrefixOptionalWhenFormatting()) {
	      // The national-prefix is optional in these cases, so we don't need to check if it was
	      // present.
	      return true;
	    }
	
	    if (PhoneNumberUtil.formattingRuleHasFirstGroupOnly(formatRule.getNationalPrefixFormattingRule())) {
	      // National Prefix not needed for this number.
	      return true;
	    } // Normalize the remainder.
	
	
	    var rawInputCopy = PhoneNumberUtil.normalizeDigitsOnly(number.getRawInput()); // Check if we found a national prefix and/or carrier code at the start of the raw input, and
	    // return the result.
	
	    return util.maybeStripNationalPrefixAndCarrierCode(rawInputCopy, metadata, null);
	  }
	
	  return true;
	}
	
	function containsMoreThanOneSlashInNationalNumber(number, candidate) {
	  var firstSlashInBodyIndex = candidate.indexOf('/');
	
	  if (firstSlashInBodyIndex < 0) {
	    // No slashes, this is okay.
	    return false;
	  } // Now look for a second one.
	
	
	  var secondSlashInBodyIndex = candidate.indexOf('/', firstSlashInBodyIndex + 1);
	
	  if (secondSlashInBodyIndex < 0) {
	    // Only one slash, this is okay.
	    return false;
	  } // If the first slash is after the country calling code, this is permitted.
	
	
	  var candidateHasCountryCode = number.getCountryCodeSource() === CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN || number.getCountryCodeSource() === CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN;
	
	  if (candidateHasCountryCode && PhoneNumberUtil.normalizeDigitsOnly(candidate.substring(0, firstSlashInBodyIndex)) === String(number.getCountryCode())) {
	    // Any more slashes and this is illegal.
	    return candidate.slice(secondSlashInBodyIndex + 1).indexOf('/') >= 0;
	  }
	
	  return true;
	}
	
	function checkNumberGroupingIsValid(number, candidate, metadata, checkGroups, regExpCache) {
	  var normalizedCandidate = normalizeDigits(candidate, true
	  /* keep non-digits */
	  );
	  var formattedNumberGroups = getNationalNumberGroups(metadata, number, null);
	
	  if (checkGroups(metadata, number, normalizedCandidate, formattedNumberGroups)) {
	    return true;
	  } // If this didn't pass, see if there are any alternate formats that match, and try them instead.
	
	
	  var alternateFormats = MetadataManager.getAlternateFormatsForCountry(number.getCountryCode());
	  var nationalSignificantNumber = util.getNationalSignificantNumber(number);
	
	  if (alternateFormats) {
	    for (var _iterator = alternateFormats.numberFormats(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var alternateFormat = _ref;
	
	      if (alternateFormat.leadingDigitsPatterns().length > 0) {
	        // There is only one leading digits pattern for alternate formats.
	        var leadingDigitsRegExp = regExpCache.getPatternForRegExp('^' + alternateFormat.leadingDigitsPatterns()[0]);
	
	        if (!leadingDigitsRegExp.test(nationalSignificantNumber)) {
	          // Leading digits don't match; try another one.
	          continue;
	        }
	      }
	
	      formattedNumberGroups = getNationalNumberGroups(metadata, number, alternateFormat);
	
	      if (checkGroups(metadata, number, normalizedCandidate, formattedNumberGroups)) {
	        return true;
	      }
	    }
	  }
	
	  return false;
	}
	/**
	 * Helper method to get the national-number part of a number, formatted without any national
	 * prefix, and return it as a set of digit blocks that would be formatted together following
	 * standard formatting rules.
	 */
	
	
	function getNationalNumberGroups(metadata, number, formattingPattern) {
	  if (formattingPattern) {
	    // We format the NSN only, and split that according to the separator.
	    var nationalSignificantNumber = util.getNationalSignificantNumber(number);
	    return util.formatNsnUsingPattern(nationalSignificantNumber, formattingPattern, 'RFC3966', metadata).split('-');
	  } // This will be in the format +CC-DG1-DG2-DGX;ext=EXT where DG1..DGX represents groups of digits.
	
	
	  var rfc3966Format = formatNumber(number, 'RFC3966', metadata); // We remove the extension part from the formatted string before splitting it into different
	  // groups.
	
	  var endIndex = rfc3966Format.indexOf(';');
	
	  if (endIndex < 0) {
	    endIndex = rfc3966Format.length;
	  } // The country-code will have a '-' following it.
	
	
	  var startIndex = rfc3966Format.indexOf('-') + 1;
	  return rfc3966Format.slice(startIndex, endIndex).split('-');
	}
	
	function allNumberGroupsAreExactlyPresent(metadata, number, normalizedCandidate, formattedNumberGroups) {
	  var candidateGroups = normalizedCandidate.split(NON_DIGITS_PATTERN); // Set this to the last group, skipping it if the number has an extension.
	
	  var candidateNumberGroupIndex = number.hasExtension() ? candidateGroups.length - 2 : candidateGroups.length - 1; // First we check if the national significant number is formatted as a block.
	  // We use contains and not equals, since the national significant number may be present with
	  // a prefix such as a national number prefix, or the country code itself.
	
	  if (candidateGroups.length == 1 || candidateGroups[candidateNumberGroupIndex].contains(util.getNationalSignificantNumber(number))) {
	    return true;
	  } // Starting from the end, go through in reverse, excluding the first group, and check the
	  // candidate and number groups are the same.
	
	
	  var formattedNumberGroupIndex = formattedNumberGroups.length - 1;
	
	  while (formattedNumberGroupIndex > 0 && candidateNumberGroupIndex >= 0) {
	    if (candidateGroups[candidateNumberGroupIndex] !== formattedNumberGroups[formattedNumberGroupIndex]) {
	      return false;
	    }
	
	    formattedNumberGroupIndex--;
	    candidateNumberGroupIndex--;
	  } // Now check the first group. There may be a national prefix at the start, so we only check
	  // that the candidate group ends with the formatted number group.
	
	
	  return candidateNumberGroupIndex >= 0 && (0, _util.endsWith)(candidateGroups[candidateNumberGroupIndex], formattedNumberGroups[0]);
	}
	
	function allNumberGroupsRemainGrouped(metadata, number, normalizedCandidate, formattedNumberGroups) {
	  var fromIndex = 0;
	
	  if (number.getCountryCodeSource() !== CountryCodeSource.FROM_DEFAULT_COUNTRY) {
	    // First skip the country code if the normalized candidate contained it.
	    var countryCode = String(number.getCountryCode());
	    fromIndex = normalizedCandidate.indexOf(countryCode) + countryCode.length();
	  } // Check each group of consecutive digits are not broken into separate groupings in the
	  // {@code normalizedCandidate} string.
	
	
	  for (var i = 0; i < formattedNumberGroups.length; i++) {
	    // Fails if the substring of {@code normalizedCandidate} starting from {@code fromIndex}
	    // doesn't contain the consecutive digits in formattedNumberGroups[i].
	    fromIndex = normalizedCandidate.indexOf(formattedNumberGroups[i], fromIndex);
	
	    if (fromIndex < 0) {
	      return false;
	    } // Moves {@code fromIndex} forward.
	
	
	    fromIndex += formattedNumberGroups[i].length();
	
	    if (i == 0 && fromIndex < normalizedCandidate.length()) {
	      // We are at the position right after the NDC. We get the region used for formatting
	      // information based on the country code in the phone number, rather than the number itself,
	      // as we do not need to distinguish between different countries with the same country
	      // calling code and this is faster.
	      var region = util.getRegionCodeForCountryCode(number.getCountryCode());
	
	      if (util.getNddPrefixForRegion(region, true) != null && Character.isDigit(normalizedCandidate.charAt(fromIndex))) {
	        // This means there is no formatting symbol after the NDC. In this case, we only
	        // accept the number if there is no formatting symbol at all in the number, except
	        // for extensions. This is only important for countries with national prefixes.
	        var nationalSignificantNumber = util.getNationalSignificantNumber(number);
	        return (0, _util.startsWith)(normalizedCandidate.slice(fromIndex - formattedNumberGroups[i].length), nationalSignificantNumber);
	      }
	    }
	  } // The check here makes sure that we haven't mistakenly already used the extension to
	  // match the last group of the subscriber number. Note the extension cannot have
	  // formatting in-between digits.
	
	
	  return normalizedCandidate.slice(fromIndex).contains(number.getExtension());
	}
	//# sourceMappingURL=Leniency.js.map

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = parsePreCandidate;
	
	var _util = __webpack_require__(811);
	
	// Regular expression of characters typically used to start a second phone number for the purposes
	// of parsing. This allows us to strip off parts of the number that are actually the start of
	// another number, such as for: (530) 583-6985 x302/x2303 -> the second extension here makes this
	// actually two phone numbers, (530) 583-6985 x302 and (530) 583-6985 x2303. We remove the second
	// extension so that the first number is parsed correctly.
	//
	// Matches a slash (\ or /) followed by a space followed by an `x`.
	//
	var SECOND_NUMBER_START_PATTERN = /[\\/] *x/;
	
	function parsePreCandidate(candidate) {
	  // Check for extra numbers at the end.
	  // TODO: This is the place to start when trying to support extraction of multiple phone number
	  // from split notations (+41 79 123 45 67 / 68).
	  return (0, _util.trimAfterFirstMatch)(SECOND_NUMBER_START_PATTERN, candidate);
	}
	//# sourceMappingURL=parsePreCandidate.js.map

/***/ }),
/* 815 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isValidPreCandidate;
	// Matches strings that look like dates using "/" as a separator.
	// Examples: 3/10/2011, 31/10/96 or 08/31/95.
	var SLASH_SEPARATED_DATES = /(?:(?:[0-3]?\d\/[01]?\d)|(?:[01]?\d\/[0-3]?\d))\/(?:[12]\d)?\d{2}/; // Matches timestamps.
	// Examples: "2012-01-02 08:00".
	// Note that the reg-ex does not include the
	// trailing ":\d\d" -- that is covered by TIME_STAMPS_SUFFIX.
	
	var TIME_STAMPS = /[12]\d{3}[-/]?[01]\d[-/]?[0-3]\d +[0-2]\d$/;
	var TIME_STAMPS_SUFFIX_LEADING = /^:[0-5]\d/;
	
	function isValidPreCandidate(candidate, offset, text) {
	  // Skip a match that is more likely to be a date.
	  if (SLASH_SEPARATED_DATES.test(candidate)) {
	    return false;
	  } // Skip potential time-stamps.
	
	
	  if (TIME_STAMPS.test(candidate)) {
	    var followingText = text.slice(offset + candidate.length);
	
	    if (TIME_STAMPS_SUFFIX_LEADING.test(followingText)) {
	      return false;
	    }
	  }
	
	  return true;
	}
	//# sourceMappingURL=isValidPreCandidate.js.map

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = isValidCandidate;
	exports.LEAD_CLASS = void 0;
	
	var _constants = __webpack_require__(780);
	
	var _util = __webpack_require__(811);
	
	var _utf = __webpack_require__(812);
	
	// Copy-pasted from `PhoneNumberMatcher.js`.
	var OPENING_PARENS = "(\\[\uFF08\uFF3B";
	var CLOSING_PARENS = ")\\]\uFF09\uFF3D";
	var NON_PARENS = "[^".concat(OPENING_PARENS).concat(CLOSING_PARENS, "]");
	var LEAD_CLASS = "[".concat(OPENING_PARENS).concat(_constants.PLUS_CHARS, "]"); // Punctuation that may be at the start of a phone number - brackets and plus signs.
	
	exports.LEAD_CLASS = LEAD_CLASS;
	var LEAD_CLASS_LEADING = new RegExp('^' + LEAD_CLASS); // Limit on the number of pairs of brackets in a phone number.
	
	var BRACKET_PAIR_LIMIT = (0, _util.limit)(0, 3);
	/**
	 * Pattern to check that brackets match. Opening brackets should be closed within a phone number.
	 * This also checks that there is something inside the brackets. Having no brackets at all is also
	 * fine.
	 *
	 * An opening bracket at the beginning may not be closed, but subsequent ones should be.  It's
	 * also possible that the leading bracket was dropped, so we shouldn't be surprised if we see a
	 * closing bracket first. We limit the sets of brackets in a phone number to four.
	 */
	
	var MATCHING_BRACKETS_ENTIRE = new RegExp('^' + "(?:[" + OPENING_PARENS + "])?" + "(?:" + NON_PARENS + "+" + "[" + CLOSING_PARENS + "])?" + NON_PARENS + "+" + "(?:[" + OPENING_PARENS + "]" + NON_PARENS + "+[" + CLOSING_PARENS + "])" + BRACKET_PAIR_LIMIT + NON_PARENS + "*" + '$');
	/**
	 * Matches strings that look like publication pages. Example:
	 * <pre>Computing Complete Answers to Queries in the Presence of Limited Access Patterns.
	 * Chen Li. VLDB J. 12(3): 211-227 (2003).</pre>
	 *
	 * The string "211-227 (2003)" is not a telephone number.
	 */
	
	var PUB_PAGES = /\d{1,5}-+\d{1,5}\s{0,4}\(\d{1,4}/;
	
	function isValidCandidate(candidate, offset, text, leniency) {
	  // Check the candidate doesn't contain any formatting
	  // which would indicate that it really isn't a phone number.
	  if (!MATCHING_BRACKETS_ENTIRE.test(candidate) || PUB_PAGES.test(candidate)) {
	    return;
	  } // If leniency is set to VALID or stricter, we also want to skip numbers that are surrounded
	  // by Latin alphabetic characters, to skip cases like abc8005001234 or 8005001234def.
	
	
	  if (leniency !== 'POSSIBLE') {
	    // If the candidate is not at the start of the text,
	    // and does not start with phone-number punctuation,
	    // check the previous character.
	    if (offset > 0 && !LEAD_CLASS_LEADING.test(candidate)) {
	      var previousChar = text[offset - 1]; // We return null if it is a latin letter or an invalid punctuation symbol.
	
	      if ((0, _utf.isInvalidPunctuationSymbol)(previousChar) || (0, _utf.isLatinLetter)(previousChar)) {
	        return false;
	      }
	    }
	
	    var lastCharIndex = offset + candidate.length;
	
	    if (lastCharIndex < text.length) {
	      var nextChar = text[lastCharIndex];
	
	      if ((0, _utf.isInvalidPunctuationSymbol)(nextChar) || (0, _utf.isLatinLetter)(nextChar)) {
	        return false;
	      }
	    }
	  }
	
	  return true;
	}
	//# sourceMappingURL=isValidCandidate.js.map

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = searchNumbers;
	
	var _parsePhoneNumber = __webpack_require__(777);
	
	var _PhoneNumberMatcher = _interopRequireDefault(__webpack_require__(808));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * @return ES6 `for ... of` iterator.
	 */
	function searchNumbers() {
	  var _normalizeArguments = (0, _parsePhoneNumber.normalizeArguments)(arguments),
	      text = _normalizeArguments.text,
	      options = _normalizeArguments.options,
	      metadata = _normalizeArguments.metadata;
	
	  var matcher = new _PhoneNumberMatcher["default"](text, options, metadata);
	  return _defineProperty({}, Symbol.iterator, function () {
	    return {
	      next: function next() {
	        if (matcher.hasNext()) {
	          return {
	            done: false,
	            value: matcher.next()
	          };
	        }
	
	        return {
	          done: true
	        };
	      }
	    };
	  });
	}
	//# sourceMappingURL=searchNumbers.js.map

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = findPhoneNumbersInText;
	exports.getArguments = getArguments;
	
	var _findNumbers = _interopRequireDefault(__webpack_require__(806));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function findPhoneNumbersInText(text, defaultCountry, options, metadata) {
	  var args = getArguments(defaultCountry, options, metadata);
	  return (0, _findNumbers["default"])(text, args.options, args.metadata);
	}
	
	function getArguments(defaultCountry, options, metadata) {
	  if (metadata) {
	    if (defaultCountry) {
	      options = _objectSpread({}, options, {
	        defaultCountry: defaultCountry
	      });
	    }
	  } else {
	    if (options) {
	      metadata = options;
	
	      if (defaultCountry) {
	        if (is_object(defaultCountry)) {
	          options = defaultCountry;
	        } else {
	          options = {
	            defaultCountry: defaultCountry
	          };
	        }
	      } else {
	        options = undefined;
	      }
	    } else {
	      metadata = defaultCountry;
	      options = undefined;
	    }
	  }
	
	  return {
	    options: _objectSpread({}, options, {
	      v2: true
	    }),
	    metadata: metadata
	  };
	} // Babel transforms `typeof` into some "branches"
	// so istanbul will show this as "branch not covered".
	
	/* istanbul ignore next */
	
	
	var is_object = function is_object(_) {
	  return _typeof(_) === 'object';
	};
	//# sourceMappingURL=findPhoneNumbersInText.js.map

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = searchPhoneNumbersInText;
	
	var _searchNumbers = _interopRequireDefault(__webpack_require__(817));
	
	var _findPhoneNumbersInText = __webpack_require__(818);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function searchPhoneNumbersInText(text, defaultCountry, options, metadata) {
	  var args = (0, _findPhoneNumbersInText.getArguments)(defaultCountry, options, metadata);
	  return (0, _searchNumbers["default"])(text, args.options, args.metadata);
	}
	//# sourceMappingURL=searchPhoneNumbersInText.js.map

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = findPhoneNumbers;
	exports.searchPhoneNumbers = searchPhoneNumbers;
	
	var _findPhoneNumbers_ = _interopRequireWildcard(__webpack_require__(821));
	
	var _parsePhoneNumber = __webpack_require__(777);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	// This is a legacy function.
	// Use `findNumbers()` instead.
	function findPhoneNumbers() {
	  var _normalizeArguments = (0, _parsePhoneNumber.normalizeArguments)(arguments),
	      text = _normalizeArguments.text,
	      options = _normalizeArguments.options,
	      metadata = _normalizeArguments.metadata;
	
	  return (0, _findPhoneNumbers_["default"])(text, options, metadata);
	}
	/**
	 * @return ES6 `for ... of` iterator.
	 */
	
	
	function searchPhoneNumbers() {
	  var _normalizeArguments2 = (0, _parsePhoneNumber.normalizeArguments)(arguments),
	      text = _normalizeArguments2.text,
	      options = _normalizeArguments2.options,
	      metadata = _normalizeArguments2.metadata;
	
	  return (0, _findPhoneNumbers_.searchPhoneNumbers)(text, options, metadata);
	}
	//# sourceMappingURL=findPhoneNumbers.js.map

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = findPhoneNumbers;
	exports.searchPhoneNumbers = searchPhoneNumbers;
	exports.PhoneNumberSearch = void 0;
	
	var _constants = __webpack_require__(780);
	
	var _extension = __webpack_require__(785);
	
	var _parse_ = _interopRequireDefault(__webpack_require__(779));
	
	var _parsePreCandidate = _interopRequireDefault(__webpack_require__(814));
	
	var _isValidPreCandidate = _interopRequireDefault(__webpack_require__(815));
	
	var _isValidCandidate = _interopRequireDefault(__webpack_require__(816));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Copy-pasted from `./parse.js`.
	var VALID_PHONE_NUMBER = '[' + _constants.PLUS_CHARS + ']{0,1}' + '(?:' + '[' + _constants.VALID_PUNCTUATION + ']*' + '[' + _constants.VALID_DIGITS + ']' + '){3,}' + '[' + _constants.VALID_PUNCTUATION + _constants.VALID_DIGITS + ']*';
	var WHITESPACE_IN_THE_BEGINNING_PATTERN = new RegExp('^[' + _constants.WHITESPACE + ']+');
	var PUNCTUATION_IN_THE_END_PATTERN = new RegExp('[' + _constants.VALID_PUNCTUATION + ']+$'); // // Regular expression for getting opening brackets for a valid number
	// // found using `PHONE_NUMBER_START_PATTERN` for prepending those brackets to the number.
	// const BEFORE_NUMBER_DIGITS_PUNCTUATION = new RegExp('[' + OPENING_BRACKETS + ']+' + '[' + WHITESPACE + ']*' + '$')
	
	var VALID_PRECEDING_CHARACTER_PATTERN = /[^a-zA-Z0-9]/;
	
	function findPhoneNumbers(text, options, metadata) {
	  /* istanbul ignore if */
	  if (options === undefined) {
	    options = {};
	  }
	
	  var search = new PhoneNumberSearch(text, options, metadata);
	  var phones = [];
	
	  while (search.hasNext()) {
	    phones.push(search.next());
	  }
	
	  return phones;
	}
	/**
	 * @return ES6 `for ... of` iterator.
	 */
	
	
	function searchPhoneNumbers(text, options, metadata) {
	  /* istanbul ignore if */
	  if (options === undefined) {
	    options = {};
	  }
	
	  var search = new PhoneNumberSearch(text, options, metadata);
	  return _defineProperty({}, Symbol.iterator, function () {
	    return {
	      next: function next() {
	        if (search.hasNext()) {
	          return {
	            done: false,
	            value: search.next()
	          };
	        }
	
	        return {
	          done: true
	        };
	      }
	    };
	  });
	}
	/**
	 * Extracts a parseable phone number including any opening brackets, etc.
	 * @param  {string} text - Input.
	 * @return {object} `{ ?number, ?startsAt, ?endsAt }`.
	 */
	
	
	var PhoneNumberSearch =
	/*#__PURE__*/
	function () {
	  // Iteration tristate.
	  function PhoneNumberSearch(text, options, metadata) {
	    _classCallCheck(this, PhoneNumberSearch);
	
	    _defineProperty(this, "state", 'NOT_READY');
	
	    this.text = text; // If assigning the `{}` default value is moved to the arguments above,
	    // code coverage would decrease for some weird reason.
	
	    this.options = options || {};
	    this.metadata = metadata;
	    this.regexp = new RegExp(VALID_PHONE_NUMBER + // Phone number extensions
	    '(?:' + _extension.EXTN_PATTERNS_FOR_PARSING + ')?', 'ig'); // this.searching_from = 0
	  }
	
	  _createClass(PhoneNumberSearch, [{
	    key: "find",
	    value: function find() {
	      var matches = this.regexp.exec(this.text);
	
	      if (!matches) {
	        return;
	      }
	
	      var number = matches[0];
	      var startsAt = matches.index;
	      number = number.replace(WHITESPACE_IN_THE_BEGINNING_PATTERN, '');
	      startsAt += matches[0].length - number.length; // Fixes not parsing numbers with whitespace in the end.
	      // Also fixes not parsing numbers with opening parentheses in the end.
	      // https://github.com/catamphetamine/libphonenumber-js/issues/252
	
	      number = number.replace(PUNCTUATION_IN_THE_END_PATTERN, '');
	      number = (0, _parsePreCandidate["default"])(number);
	      var result = this.parseCandidate(number, startsAt);
	
	      if (result) {
	        return result;
	      } // Tail recursion.
	      // Try the next one if this one is not a valid phone number.
	
	
	      return this.find();
	    }
	  }, {
	    key: "parseCandidate",
	    value: function parseCandidate(number, startsAt) {
	      if (!(0, _isValidPreCandidate["default"])(number, startsAt, this.text)) {
	        return;
	      } // Don't parse phone numbers which are non-phone numbers
	      // due to being part of something else (e.g. a UUID).
	      // https://github.com/catamphetamine/libphonenumber-js/issues/213
	      // Copy-pasted from Google's `PhoneNumberMatcher.js` (`.parseAndValidate()`).
	
	
	      if (!(0, _isValidCandidate["default"])(number, startsAt, this.text, this.options.extended ? 'POSSIBLE' : 'VALID')) {
	        return;
	      } // // Prepend any opening brackets left behind by the
	      // // `PHONE_NUMBER_START_PATTERN` regexp.
	      // const text_before_number = text.slice(this.searching_from, startsAt)
	      // const full_number_starts_at = text_before_number.search(BEFORE_NUMBER_DIGITS_PUNCTUATION)
	      // if (full_number_starts_at >= 0)
	      // {
	      // 	number   = text_before_number.slice(full_number_starts_at) + number
	      // 	startsAt = full_number_starts_at
	      // }
	      //
	      // this.searching_from = matches.lastIndex
	
	
	      var result = (0, _parse_["default"])(number, this.options, this.metadata);
	
	      if (!result.phone) {
	        return;
	      }
	
	      result.startsAt = startsAt;
	      result.endsAt = startsAt + number.length;
	      return result;
	    }
	  }, {
	    key: "hasNext",
	    value: function hasNext() {
	      if (this.state === 'NOT_READY') {
	        this.last_match = this.find();
	
	        if (this.last_match) {
	          this.state = 'READY';
	        } else {
	          this.state = 'DONE';
	        }
	      }
	
	      return this.state === 'READY';
	    }
	  }, {
	    key: "next",
	    value: function next() {
	      // Check the state and find the next match as a side-effect if necessary.
	      if (!this.hasNext()) {
	        throw new Error('No next element');
	      } // Don't retain that memory any longer than necessary.
	
	
	      var result = this.last_match;
	      this.last_match = null;
	      this.state = 'NOT_READY';
	      return result;
	    }
	  }]);
	
	  return PhoneNumberSearch;
	}();
	
	exports.PhoneNumberSearch = PhoneNumberSearch;
	//# sourceMappingURL=findPhoneNumbers_.js.map

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stripNonPairedParens = stripNonPairedParens;
	exports.cutAndStripNonPairedParens = cutAndStripNonPairedParens;
	exports.closeNonPairedParens = closeNonPairedParens;
	exports.countOccurences = countOccurences;
	exports.repeat = repeat;
	exports["default"] = exports.DIGIT_PLACEHOLDER = void 0;
	
	var _metadata = _interopRequireDefault(__webpack_require__(782));
	
	var _PhoneNumber = _interopRequireDefault(__webpack_require__(793));
	
	var _constants = __webpack_require__(780);
	
	var _util = __webpack_require__(781);
	
	var _parse_ = __webpack_require__(779);
	
	var _format_ = __webpack_require__(796);
	
	var _IDD = __webpack_require__(791);
	
	var _getNumberType_ = __webpack_require__(789);
	
	var _parseDigits = _interopRequireDefault(__webpack_require__(787));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Used in phone number format template creation.
	// Could be any digit, I guess.
	var DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`
	
	var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
	// `number_pattern` by applying the pattern to the "longest phone number" string.
	
	var LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // The digits that have not been entered yet will be represented by a \u2008,
	// the punctuation space.
	
	var DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)
	
	exports.DIGIT_PLACEHOLDER = DIGIT_PLACEHOLDER;
	var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
	// us that we should separate the national prefix from the number when formatting.
	
	var NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
	// https://github.com/googlei18n/libphonenumber/commit/a395b4fef3caf57c4bc5f082e1152a4d2bd0ba4c
	// "We no longer have numbers in formatting matching patterns, only \d."
	// Because this library supports generating custom metadata
	// some users may still be using old metadata so the relevant
	// code seems to stay until some next major version update.
	
	var SUPPORT_LEGACY_FORMATTING_PATTERNS = true; // A pattern that is used to match character classes in regular expressions.
	// An example of a character class is "[1-4]".
	
	var CREATE_CHARACTER_CLASS_PATTERN = SUPPORT_LEGACY_FORMATTING_PATTERNS && function () {
	  return /\[([^\[\]])*\]/g;
	}; // Any digit in a regular expression that actually denotes a digit. For
	// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
	// (8 and 0) are standalone digits, but the rest are not.
	// Two look-aheads are needed because the number following \\d could be a
	// two-digit number, since the phone number can be as long as 15 digits.
	
	
	var CREATE_STANDALONE_DIGIT_PATTERN = SUPPORT_LEGACY_FORMATTING_PATTERNS && function () {
	  return /\d(?=[^,}][^,}])/g;
	}; // A pattern that is used to determine if a `format` is eligible
	// to be used by the "as you type formatter".
	// It is eligible when the `format` contains groups of the dollar sign
	// followed by a single digit, separated by valid phone number punctuation.
	// This prevents invalid punctuation (such as the star sign in Israeli star numbers)
	// getting into the output of the "as you type formatter".
	
	
	var ELIGIBLE_FORMAT_PATTERN = new RegExp('^' + '[' + _constants.VALID_PUNCTUATION + ']*' + '(\\$\\d[' + _constants.VALID_PUNCTUATION + ']*)+' + '$'); // This is the minimum length of the leading digits of a phone number
	// to guarantee the first "leading digits pattern" for a phone number format
	// to be preemptive.
	
	var MIN_LEADING_DIGITS_LENGTH = 3;
	var VALID_FORMATTED_PHONE_NUMBER_PART = '[' + _constants.VALID_PUNCTUATION + _constants.VALID_DIGITS + ']+';
	var VALID_FORMATTED_PHONE_NUMBER_PART_PATTERN = new RegExp('^' + VALID_FORMATTED_PHONE_NUMBER_PART + '$', 'i');
	var VALID_PHONE_NUMBER = '(?:' + '[' + _constants.PLUS_CHARS + ']' + '[' + _constants.VALID_PUNCTUATION + _constants.VALID_DIGITS + ']*' + '|' + '[' + _constants.VALID_PUNCTUATION + _constants.VALID_DIGITS + ']+' + ')';
	var AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + _constants.VALID_PUNCTUATION + _constants.VALID_DIGITS + ']+' + '.*' + '$');
	var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
	
	var AsYouType =
	/*#__PURE__*/
	function () {
	  // Not setting `options` to a constructor argument
	  // not to break backwards compatibility
	  // for older versions of the library.
	
	  /**
	   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
	   * @param {Object} metadata
	   */
	  function AsYouType(optionsOrDefaultCountry, metadata) {
	    _classCallCheck(this, AsYouType);
	
	    _defineProperty(this, "options", {});
	
	    this.metadata = new _metadata["default"](metadata); // Set `defaultCountry` and `defaultCallingCode` options.
	
	    var defaultCountry;
	    var defaultCallingCode; // Turns out `null` also has type "object". Weird.
	
	    if (optionsOrDefaultCountry) {
	      if (_typeof(optionsOrDefaultCountry) === 'object') {
	        defaultCountry = optionsOrDefaultCountry.defaultCountry;
	        defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
	      } else {
	        defaultCountry = optionsOrDefaultCountry;
	      }
	    }
	
	    if (defaultCountry && this.metadata.hasCountry(defaultCountry)) {
	      this.defaultCountry = defaultCountry;
	    }
	
	    if (defaultCallingCode) {
	      /* istanbul ignore if */
	      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
	        if (this.metadata.isNonGeographicCallingCode(defaultCallingCode)) {
	          this.defaultCountry = '001';
	        }
	      }
	
	      this.defaultCallingCode = defaultCallingCode;
	    } // Reset.
	
	
	    this.reset();
	  }
	
	  _createClass(AsYouType, [{
	    key: "reset",
	    value: function reset() {
	      this.formattedOutput = '';
	      this.international = false;
	      this.internationalPrefix = undefined;
	      this.countryCallingCode = undefined;
	      this.digits = '';
	      this.nationalNumberDigits = '';
	      this.nationalPrefix = '';
	      this.carrierCode = '';
	      this.setCountry(this.defaultCountry, this.defaultCallingCode);
	      return this;
	    }
	  }, {
	    key: "resetFormat",
	    value: function resetFormat() {
	      this.chosenFormat = undefined;
	      this.template = undefined;
	      this.populatedNationalNumberTemplate = undefined;
	      this.populatedNationalNumberTemplatePosition = -1;
	    }
	    /**
	     * Returns `true` if the phone number is being input in international format.
	     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
	     * @return {boolean}
	     */
	
	  }, {
	    key: "isInternational",
	    value: function isInternational() {
	      return this.international;
	    }
	    /**
	     * Returns the "country calling code" part of the phone number.
	     * Returns `undefined` if the number is not being input in international format.
	     * Returns "country calling code" for "non-geographic" phone numbering plans too.
	     * @return {string} [countryCallingCode]
	     */
	
	  }, {
	    key: "getCountryCallingCode",
	    value: function getCountryCallingCode() {
	      return this.countryCallingCode;
	    }
	    /**
	     * Returns a two-letter country code of the phone number.
	     * Returns `undefined` for "non-geographic" phone numbering plans.
	     * Returns `undefined` if no phone number has been input yet.
	     * @return {string} [country]
	     */
	
	  }, {
	    key: "getCountry",
	    value: function getCountry() {
	      // If no digits have been input yet,
	      // then `this.country` is the `defaultCountry`.
	      // Won't return the `defaultCountry` in such case.
	      if (!this.digits) {
	        return;
	      }
	
	      var countryCode = this.country;
	      /* istanbul ignore if */
	
	      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
	        if (this.country === '001') {
	          countryCode = undefined;
	        }
	      }
	
	      return countryCode;
	    }
	  }, {
	    key: "setCountry",
	    value: function setCountry(country, callingCode) {
	      this.country = country;
	      this.metadata.selectNumberingPlan(country, callingCode);
	
	      if (this.metadata.hasSelectedNumberingPlan()) {
	        this.initializePhoneNumberFormatsForCountry();
	      } else {
	        this.matchingFormats = [];
	      }
	
	      this.resetFormat();
	    }
	    /**
	     * Inputs "next" phone number characters.
	     * @param  {string} text
	     * @return {string} Formatted phone number characters that have been input so far.
	     */
	
	  }, {
	    key: "input",
	    value: function input(text) {
	      var formattedDigits = this.extractFormattedDigits(text); // If the extracted phone number part
	      // can possibly be a part of some valid phone number
	      // then parse phone number characters from a formatted phone number.
	
	      if (VALID_FORMATTED_PHONE_NUMBER_PART_PATTERN.test(formattedDigits)) {
	        this.formattedOutput = this.getFullNumber(this.inputDigits((0, _parseDigits["default"])(formattedDigits)) || this.getNonFormattedNationalNumber());
	      }
	
	      return this.formattedOutput;
	    }
	    /**
	     * Extracts formatted phone number digits from text (if there're any).
	     * @param  {string} text
	     * @return {string}
	     */
	
	  }, {
	    key: "extractFormattedDigits",
	    value: function extractFormattedDigits(text) {
	      // Extract a formatted phone number part from text.
	      var extractedNumber = extractFormattedPhoneNumber(text) || ''; // Trim a `+`.
	
	      if (extractedNumber[0] === '+') {
	        // Trim the `+`.
	        extractedNumber = extractedNumber.slice('+'.length);
	
	        if (this.digits) {// If an out of position `+` is detected
	          // (or a second `+`) then just ignore it.
	        } else {
	          this.formattedOutput = '+';
	          this.startInternationalNumber();
	        }
	      }
	
	      return extractedNumber;
	    }
	  }, {
	    key: "startInternationalNumber",
	    value: function startInternationalNumber() {
	      // Prepend the `+` to parsed input.
	      this.international = true; // If a default country was set then reset it
	      // because an explicitly international phone
	      // number is being entered.
	
	      this.setCountry();
	    }
	    /**
	     * Inputs "next" phone number digits.
	     * @param  {string} digits
	     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
	     */
	
	  }, {
	    key: "inputDigits",
	    value: function inputDigits(nextDigits) {
	      // Some users input their phone number in "out-of-country"
	      // dialing format instead of using the leading `+`.
	      // https://github.com/catamphetamine/libphonenumber-js/issues/185
	      // Detect such numbers.
	      if (!this.digits) {
	        var numberWithoutIDD = (0, _IDD.stripIDDPrefix)(nextDigits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
	
	        if (numberWithoutIDD && numberWithoutIDD !== nextDigits) {
	          // If an IDD prefix was stripped then
	          // convert the number to international one
	          // for subsequent parsing.
	          this.internationalPrefix = nextDigits.slice(0, nextDigits.length - numberWithoutIDD.length);
	          nextDigits = numberWithoutIDD;
	          this.startInternationalNumber();
	        }
	      } // Append phone number digits.
	
	
	      this.digits += nextDigits; // Try to format the parsed input
	
	      if (this.isInternational()) {
	        if (this.countryCallingCode) {
	          this.nationalNumberDigits += nextDigits; // `this.country` could be `undefined`, for example, when there is
	          // ambiguity in a form of several different countries,
	          // each corresponding to the same country phone code
	          // (e.g. NANPA: USA, Canada, etc), and there's not enough digits
	          // to reliably determine the country the phone number belongs to.
	          // Therefore, in cases of such ambiguity, each time something is input,
	          // try to determine the country (if it hasn't been determined yet).
	
	          if (!this.country || this.isCountryCallingCodeAmbiguous()) {
	            this.determineTheCountry();
	          }
	        } else {
	          // Extract country calling code from the digits entered so far.
	          // There must be some digits in order to extract anything from them.
	          //
	          // If one looks at country phone codes
	          // then they can notice that no one country phone code
	          // is ever a (leftmost) substring of another country phone code.
	          // So if a valid country code is extracted so far
	          // then it means that this is the country code.
	          //
	          // If no country phone code could be extracted so far,
	          // then don't format the phone number.
	          //
	          if (!this.extractCountryCallingCode()) {
	            // Don't format the phone number.
	            return;
	          } // Possibly extract a national prefix.
	          // Some people incorrectly input national prefix
	          // in an international phone number.
	          // For example, some people write British phone numbers as `+44(0)...`.
	          // Also, mobile phone numbers in Mexico are supposed to be dialled
	          // internationally using a `15` national prefix.
	          //
	          // https://www.mexperience.com/dialing-cell-phones-in-mexico/
	          //
	          // "Dialing a Mexican cell phone from abroad
	          // When you are calling a cell phone number in Mexico from outside Mexico,
	          // it’s necessary to dial an additional “1” after Mexico’s country code
	          // (which is “52”) and before the area code.
	          // You also ignore the 045, and simply dial the area code and the
	          // cell phone’s number.
	          //
	          // If you don’t add the “1”, you’ll receive a recorded announcement
	          // asking you to redial using it.
	          //
	          // For example, if you are calling from the USA to a cell phone
	          // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
	          // (Note that this is different to calling a land line in Mexico City
	          // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
	          //
	
	
	          this.nationalNumberDigits = this.digits.slice(this.countryCallingCode.length); // this.extractNationalPrefix()
	          //
	          // Determine the country from country calling code and national number.
	
	          this.determineTheCountry();
	        }
	      } else {
	        this.nationalNumberDigits += nextDigits; // If `defaultCallingCode` is set,
	        // see if the `country` could be derived.
	
	        if (!this.country) {
	          this.determineTheCountry();
	        } // Some national prefixes are substrings of other national prefixes
	        // (for the same country), therefore try to extract national prefix each time
	        // because a longer national prefix might be available at some point in time.
	
	
	        var previousNationalPrefix = this.nationalPrefix;
	        this.nationalNumberDigits = this.nationalPrefix + this.nationalNumberDigits; // Re-extract national prefix.
	
	        this.extractNationalPrefix(); // If another national prefix has been extracted.
	
	        if (this.nationalPrefix !== previousNationalPrefix) {
	          // National number has changed
	          // (due to another national prefix been extracted)
	          // therefore national number has changed
	          // therefore reset all previous formatting data.
	          // (and leading digits matching state)
	          this.initializePhoneNumberFormatsForCountry();
	          this.resetFormat();
	        }
	      }
	
	      if (this.nationalNumberDigits) {
	        // Match the available formats by the currently available leading digits.
	        this.matchFormats(this.nationalNumberDigits);
	      } // Format the phone number (given the next digits)
	
	
	      return this.formatNationalNumberWithNextDigits(nextDigits);
	    }
	  }, {
	    key: "formatNationalNumberWithNextDigits",
	    value: function formatNationalNumberWithNextDigits(nextDigits) {
	      // See if the phone number digits can be formatted as a complete phone number.
	      // If not, use the results from `formatNextNationalNumberDigits()`,
	      // which formats based on the chosen formatting pattern.
	      // Attempting to format complete phone number first is how it's done
	      // in Google's `libphonenumber`.
	      var formattedNumber = this.attemptToFormatCompletePhoneNumber(); // Just because a phone number doesn't have a suitable format
	      // that doesn't mean that the phone number is invalid,
	      // because phone number formats only format phone numbers,
	      // they don't validate them and some (rare) phone numbers
	      // are meant to stay non-formatted.
	
	      if (formattedNumber) {
	        return formattedNumber;
	      } // Format the next phone number digits
	      // using the previously chosen phone number format.
	      //
	      // This is done here because if `attemptToFormatCompletePhoneNumber`
	      // was placed before this call then the `template`
	      // wouldn't reflect the situation correctly (and would therefore be inconsistent)
	      //
	
	
	      var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.
	
	      var newlyChosenFormat = this.chooseFormat();
	
	      if (newlyChosenFormat) {
	        if (newlyChosenFormat === previouslyChosenFormat) {
	          // If could format the next (current) digit
	          // using the previously chosen phone number format
	          // then return the formatted number so far.
	          //
	          // If no new phone number format could be chosen,
	          // and couldn't format the supplied national number
	          // using the previously chosen phone number pattern,
	          // then return `undefined`.
	          //
	          return this.formatNextNationalNumberDigits(nextDigits);
	        } else {
	          // If a more appropriate phone number format
	          // has been chosen for these "leading digits",
	          // then format the national phone number (so far)
	          // using the newly selected format.
	          //
	          // Will return `undefined` if it couldn't format
	          // the supplied national number
	          // using the selected phone number pattern.
	          //
	          return this.reformatNationalNumber();
	        }
	      }
	    }
	  }, {
	    key: "chooseFormat",
	    value: function chooseFormat() {
	      // When there are multiple available formats, the formatter uses the first
	      // format where a formatting template could be created.
	      for (var _iterator = this.matchingFormats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var format = _ref;
	
	        // If this format is currently being used
	        // and is still possible, then stick to it.
	        if (this.chosenFormat === format) {
	          break;
	        }
	
	        if (!this.createFormattingTemplate(format)) {
	          continue;
	        }
	
	        this.chosenFormat = format; // With a new formatting template, the matched position
	        // using the old template needs to be reset.
	
	        this.populatedNationalNumberTemplatePosition = -1;
	        break;
	      }
	
	      if (!this.chosenFormat) {
	        // No format matches the national phone number entered.
	        this.resetFormat();
	      }
	
	      return this.chosenFormat;
	    } // Formats each digit of the national phone number (so far)
	    // using the selected format.
	
	  }, {
	    key: "reformatNationalNumber",
	    value: function reformatNationalNumber() {
	      return this.formatNextNationalNumberDigits(this.nationalPrefix + this.nationalNumberDigits);
	    }
	  }, {
	    key: "initializePhoneNumberFormatsForCountry",
	    value: function initializePhoneNumberFormatsForCountry() {
	      // Get all "eligible" phone number formats for this country
	      this.matchingFormats = this.metadata.formats().filter(function (format) {
	        // Compared to `libphonenumber`'s code, the two "Discard a few formats
	        // that we know are not relevant based on the presence of the national prefix"
	        // checks have changed: the first one has been moved to `.matchFormats()`,
	        // and the second one doesn't apply to this library because it doesn't deal with
	        // "incomplete" phone numbers (for example, phone numbers, entered without "area code").
	        return ELIGIBLE_FORMAT_PATTERN.test(format.internationalFormat());
	      });
	    }
	  }, {
	    key: "matchFormats",
	    value: function matchFormats(leadingDigits) {
	      var _this = this;
	
	      // "leading digits" pattern list starts with a
	      // "leading digits" pattern fitting a maximum of 3 leading digits.
	      // So, after a user inputs 3 digits of a national (significant) phone number
	      // this national (significant) number can already be formatted.
	      // The next "leading digits" pattern is for 4 leading digits max,
	      // and the "leading digits" pattern after it is for 5 leading digits max, etc.
	      // This implementation is different from Google's
	      // in that it searches for a fitting format
	      // even if the user has entered less than
	      // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
	      // Because some leading digit patterns already match for a single first digit.
	      var leadingDigitsPatternIndex = leadingDigits.length - MIN_LEADING_DIGITS_LENGTH;
	
	      if (leadingDigitsPatternIndex < 0) {
	        leadingDigitsPatternIndex = 0;
	      }
	
	      this.matchingFormats = this.matchingFormats.filter(function (format) {
	        // If national prefix is mandatory for this phone number format
	        // and the user didn't input the national prefix
	        // then this phone number format isn't suitable.
	        if (!_this.isInternational() && !_this.nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) {
	          return false;
	        }
	
	        var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
	        // leading digits pattern then it fits.
	
	        if (leadingDigitsPatternsCount === 0) {
	          return true;
	        } // Start excluding any non-matching formats only when the
	        // national number entered so far is at least 3 digits long,
	        // otherwise format matching would give false negatives.
	        // For example, when the digits entered so far are `2`
	        // and the leading digits pattern is `21` –
	        // it's quite obvious in this case that the format could be the one
	        // but due to the absence of further digits it would give false negative.
	
	
	        if (leadingDigits.length < MIN_LEADING_DIGITS_LENGTH) {
	          return true;
	        } // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are available
	        // then format matching starts narrowing down the list of possible formats
	        // (only previously matched formats are considered for next digits).
	
	
	        leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
	        var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Brackets are required for `^` to be applied to
	        // all or-ed (`|`) parts, not just the first one.
	
	        return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
	      }); // If there was a phone number format chosen
	      // and it no longer holds given the new leading digits then reset it.
	      // The test for this `if` condition is marked as:
	      // "Reset a chosen format when it no longer holds given the new leading digits".
	      // To construct a valid test case for this one can find a country
	      // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
	      // and yielding another format for 4 `<leadingDigits>` (Australia in this case).
	
	      if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) {
	        this.resetFormat();
	      }
	    }
	  }, {
	    key: "getSeparatorAfterNationalPrefix",
	    value: function getSeparatorAfterNationalPrefix(format) {
	      if (this.metadata.countryCallingCode() === '1') {
	        return ' ';
	      }
	
	      if (format && format.nationalPrefixFormattingRule() && NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) {
	        return ' ';
	      }
	
	      return '';
	    } // This is in accordance to how Google's `libphonenumber` does it.
	    // "Check to see if there is an exact pattern match for these digits.
	    // If so, we should use this instead of any other formatting template
	    // whose `leadingDigitsPattern` also matches the input."
	
	  }, {
	    key: "attemptToFormatCompletePhoneNumber",
	    value: function attemptToFormatCompletePhoneNumber() {
	      for (var _iterator2 = this.matchingFormats, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	        var _ref2;
	
	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }
	
	        var format = _ref2;
	        var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));
	
	        if (!matcher.test(this.nationalNumberDigits)) {
	          continue;
	        } // Here, national number is formatted without "national prefix
	        // formatting rule", because otherwise there'd be a bug
	        // when "area code" is "duplicated" during input:
	        // https://github.com/catamphetamine/libphonenumber-js/issues/318
	
	
	        var formattedNationalNumber = (0, _format_.formatNationalNumberUsingFormat)(this.nationalNumberDigits, format, this.isInternational(), false, // Don't prepend national prefix (it will be prepended manually).
	        this.metadata); // Check if this `format` preserves all digits.
	        // This is how it's done in Google's `libphonenumber`.
	        // Also, it fixes the bug when "area code" is "duplicated" during input:
	        // https://github.com/catamphetamine/libphonenumber-js/issues/318
	        //
	        // "Check that we didn't remove nor add any extra digits when we matched
	        // this formatting pattern. This usually happens after we entered the last
	        // digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
	        // formatted but AYTF should retain all the number entered and not change
	        // in order to match a format (of same leading digits and length) display
	        // in that way."
	        // "If it's the same (i.e entered number and format is same), then it's
	        // safe to return this in formatted number as nothing is lost / added."
	        // Otherwise, don't use this format.
	        // https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
	        // https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
	        //
	
	        if ((0, _parseDigits["default"])(formattedNationalNumber) !== this.nationalNumberDigits) {
	          continue;
	        } // Prepend national prefix (if any).
	
	
	        if (this.nationalPrefix) {
	          // Here, national number is formatted with "national prefix
	          // formatting rule". The reason is that "national prefix
	          // formatting rule" often adds parentheses, and while Google's
	          // `libphonenumber` dismisses those preferring simply prepending
	          // national prefix followed by a " " character, this library
	          // looks if the national prefix could be formatted better.
	          var formattedNationalNumberWithNationalPrefix = (0, _format_.formatNationalNumberUsingFormat)(this.nationalNumberDigits, format, this.isInternational(), true, // Prepend national prefix.
	          this.metadata);
	
	          if ((0, _parseDigits["default"])(formattedNationalNumberWithNationalPrefix) === this.nationalPrefix + this.nationalNumberDigits) {
	            formattedNationalNumber = formattedNationalNumberWithNationalPrefix;
	          } else {
	            formattedNationalNumber = this.nationalPrefix + this.getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
	          }
	        } // formats national number (probably) without national prefix.
	        // Formatting a national number with national prefix could result in
	        // bugs when "area code" is "duplicated" during input:
	        // https://github.com/catamphetamine/libphonenumber-js/issues/318
	        // The "are all digits preserved" check fixes that type of bug.
	        // To leave the formatter in a consistent state
	
	
	        this.resetFormat();
	        this.chosenFormat = format; // Set `this.template` and `this.populatedNationalNumberTemplate`.
	
	        /* istanbul ignore else */
	
	        if (this.createFormattingTemplate(format)) {
	          // Populate `this.populatedNationalNumberTemplate` with phone number digits.
	          this.reformatNationalNumber();
	        } else {
	          // If the formatting template couldn't be created for a format,
	          // create it manually from the formatted phone number.
	          // This case doesn't ever happen with the current metadata.
	          this.template = this.getFullNumber(formattedNationalNumber).replace(/[\d\+]/g, DIGIT_PLACEHOLDER);
	          this.populatedNationalNumberTemplate = formattedNationalNumber;
	          this.populatedNationalNumberTemplatePosition = this.populatedNationalNumberTemplate.length - 1;
	        }
	
	        return formattedNationalNumber;
	      }
	    }
	  }, {
	    key: "getInternationalPrefix",
	    value: function getInternationalPrefix(options) {
	      return this.internationalPrefix ? options && options.spacing === false ? this.internationalPrefix : this.internationalPrefix + ' ' : '+';
	    } // Prepends `+CountryCode ` in case of an international phone number
	
	  }, {
	    key: "getFullNumber",
	    value: function getFullNumber(formattedNationalNumber) {
	      if (this.isInternational()) {
	        var prefix = this.getInternationalPrefix();
	
	        if (!this.countryCallingCode) {
	          return "".concat(prefix).concat(this.digits);
	        }
	
	        if (!formattedNationalNumber) {
	          return "".concat(prefix).concat(this.countryCallingCode);
	        }
	
	        return "".concat(prefix).concat(this.countryCallingCode, " ").concat(formattedNationalNumber);
	      }
	
	      return formattedNationalNumber;
	    }
	  }, {
	    key: "getNonFormattedNationalNumber",
	    value: function getNonFormattedNationalNumber() {
	      return this.nationalPrefix + (this.nationalPrefix && this.nationalNumberDigits && this.getSeparatorAfterNationalPrefix()) + this.nationalNumberDigits;
	    } // Extracts the country calling code from the beginning
	    // of the entered `national_number` (so far),
	    // and places the remaining input into the `national_number`.
	
	  }, {
	    key: "extractCountryCallingCode",
	    value: function extractCountryCallingCode() {
	      var _extractCountryCallin = (0, _parse_.extractCountryCallingCode)('+' + this.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
	          countryCallingCode = _extractCountryCallin.countryCallingCode,
	          number = _extractCountryCallin.number;
	
	      if (!countryCallingCode) {
	        return;
	      }
	
	      this.nationalNumberDigits = number;
	      this.countryCallingCode = countryCallingCode;
	      this.metadata.chooseCountryByCountryCallingCode(countryCallingCode);
	      this.initializePhoneNumberFormatsForCountry();
	      this.resetFormat();
	      return this.metadata.hasSelectedNumberingPlan();
	    }
	  }, {
	    key: "extractNationalPrefix",
	    value: function extractNationalPrefix() {
	      this.nationalPrefix = '';
	
	      if (!this.metadata.hasSelectedNumberingPlan()) {
	        return;
	      } // Only strip national prefixes for non-international phone numbers
	      // because national prefixes can't be present in international phone numbers.
	      // While `parseNumber()` is forgiving is such cases, `AsYouType` is not.
	
	
	      var _stripNationalPrefixA = (0, _parse_.stripNationalPrefixAndCarrierCode)(this.nationalNumberDigits, this.metadata),
	          nationalNumber = _stripNationalPrefixA.nationalNumber,
	          carrierCode = _stripNationalPrefixA.carrierCode; // Sometimes `stripNationalPrefixAndCarrierCode()` won't actually
	      // strip national prefix and will instead prepend some digits to the `number`:
	      // for example, when number `2345678` is passed with `VI` country selected,
	      // it will return `{ number: "3402345678" }`, because `340` area code is prepended.
	      // So check if the `nationalNumber` is actually at the end of `this.nationalNumberDigits`.
	
	
	      if (nationalNumber) {
	        var index = this.nationalNumberDigits.indexOf(nationalNumber);
	
	        if (index < 0 || index !== this.nationalNumberDigits.length - nationalNumber.length) {
	          return;
	        }
	      }
	
	      if (carrierCode) {
	        this.carrierCode = carrierCode;
	      }
	
	      this.nationalPrefix = this.nationalNumberDigits.slice(0, this.nationalNumberDigits.length - nationalNumber.length);
	      this.nationalNumberDigits = nationalNumber;
	      return this.nationalPrefix;
	    } // isPossibleNumber(number) {
	    // 	switch (checkNumberLengthForType(number, undefined, this.metadata)) {
	    // 		case 'IS_POSSIBLE':
	    // 			return true
	    // 		// case 'IS_POSSIBLE_LOCAL_ONLY':
	    // 		// 	return !this.isInternational()
	    // 		default:
	    // 			return false
	    // 	}
	    // }
	
	  }, {
	    key: "isCountryCallingCodeAmbiguous",
	    value: function isCountryCallingCodeAmbiguous() {
	      var countryCodes = this.metadata.getCountryCodesForCallingCode(this.countryCallingCode);
	      return countryCodes && countryCodes.length > 1;
	    }
	  }, {
	    key: "createFormattingTemplate",
	    value: function createFormattingTemplate(format) {
	      // The formatter doesn't format numbers when numberPattern contains '|', e.g.
	      // (20|3)\d{4}. In those cases we quickly return.
	      // (Though there's no such format in current metadata)
	
	      /* istanbul ignore if */
	      if (SUPPORT_LEGACY_FORMATTING_PATTERNS && format.pattern().indexOf('|') >= 0) {
	        return;
	      } // Get formatting template for this phone number format
	
	
	      var template = this.getTemplateForNumberFormatPattern(format, this.nationalPrefix); // If the national number entered is too long
	      // for any phone number format, then abort.
	
	      if (!template) {
	        return;
	      }
	
	      this.template = template;
	      this.populatedNationalNumberTemplate = template; // For convenience, the public `.template` property
	      // contains the whole international number
	      // if the phone number being input is international:
	      // 'x' for the '+' sign, 'x'es for the country phone code,
	      // a spacebar and then the template for the formatted national number.
	
	      if (this.isInternational()) {
	        this.template = this.getInternationalPrefix().replace(/[\d\+]/g, DIGIT_PLACEHOLDER) + repeat(DIGIT_PLACEHOLDER, this.countryCallingCode.length) + ' ' + template;
	      }
	
	      return this.template;
	    }
	    /**
	     * Generates formatting template for a national phone number,
	     * optionally containing a national prefix, for a format.
	     * @param  {Format} format
	     * @param  {string} nationalPrefix
	     * @return {string}
	     */
	
	  }, {
	    key: "getTemplateForNumberFormatPattern",
	    value: function getTemplateForNumberFormatPattern(format, nationalPrefix) {
	      var pattern = format.pattern();
	      /* istanbul ignore else */
	
	      if (SUPPORT_LEGACY_FORMATTING_PATTERNS) {
	        pattern = pattern // Replace anything in the form of [..] with \d
	        .replace(CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
	        .replace(CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
	      } // Generate a dummy national number (consisting of `9`s)
	      // that fits this format's `pattern`.
	      //
	      // This match will always succeed,
	      // because the "longest dummy phone number"
	      // has enough length to accomodate any possible
	      // national phone number format pattern.
	      //
	
	
	      var digits = LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
	      // for any phone number format, then abort.
	
	      if (this.nationalNumberDigits.length > digits.length) {
	        return;
	      } // Get a formatting template which can be used to efficiently format
	      // a partial number where digits are added one by one.
	      // Below `strictPattern` is used for the
	      // regular expression (with `^` and `$`).
	      // This wasn't originally in Google's `libphonenumber`
	      // and I guess they don't really need it
	      // because they're not using "templates" to format phone numbers
	      // but I added `strictPattern` after encountering
	      // South Korean phone number formatting bug.
	      //
	      // Non-strict regular expression bug demonstration:
	      //
	      // this.nationalNumberDigits : `111111111` (9 digits)
	      //
	      // pattern : (\d{2})(\d{3,4})(\d{4})
	      // format : `$1 $2 $3`
	      // digits : `9999999999` (10 digits)
	      //
	      // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
	      //
	      // template : xx xxxx xxxx
	      //
	      // But the correct template in this case is `xx xxx xxxx`.
	      // The template was generated incorrectly because of the
	      // `{3,4}` variability in the `pattern`.
	      //
	      // The fix is, if `this.nationalNumberDigits` has already sufficient length
	      // to satisfy the `pattern` completely then `this.nationalNumberDigits`
	      // is used instead of `digits`.
	
	
	      var strictPattern = new RegExp('^' + pattern + '$');
	      var nationalNumberDummyDigits = this.nationalNumberDigits.replace(/\d/g, DUMMY_DIGIT); // If `this.nationalNumberDigits` has already sufficient length
	      // to satisfy the `pattern` completely then use it
	      // instead of `digits`.
	
	      if (strictPattern.test(nationalNumberDummyDigits)) {
	        digits = nationalNumberDummyDigits;
	      }
	
	      var numberFormat = this.getFormatFormat(format);
	      var includesNationalPrefix;
	
	      if (nationalPrefix) {
	        if (format.nationalPrefixFormattingRule()) {
	          var numberFormatWithNationalPrefix = numberFormat.replace(_format_.FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule());
	
	          if ((0, _parseDigits["default"])(numberFormatWithNationalPrefix) === nationalPrefix + (0, _parseDigits["default"])(numberFormat)) {
	            numberFormat = numberFormatWithNationalPrefix;
	            includesNationalPrefix = true;
	            var i = nationalPrefix.length;
	
	            while (i > 0) {
	              numberFormat = numberFormat.replace(/\d/, DIGIT_PLACEHOLDER);
	              i--;
	            }
	          }
	        }
	      } // Generate formatting template for this phone number format.
	
	
	      var template = digits // Format the dummy phone number according to the format.
	      .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
	      .replace(new RegExp(DUMMY_DIGIT, 'g'), DIGIT_PLACEHOLDER);
	
	      if (nationalPrefix) {
	        if (!includesNationalPrefix) {
	          // Prepend national prefix to the template manually.
	          template = repeat(DIGIT_PLACEHOLDER, nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
	        }
	      }
	
	      return template;
	    }
	  }, {
	    key: "formatNextNationalNumberDigits",
	    value: function formatNextNationalNumberDigits(digits) {
	      // Using `.split('')` to iterate through a string here
	      // to avoid requiring `Symbol.iterator` polyfill.
	      // `.split('')` is generally not safe for Unicode,
	      // but in this particular case for `digits` it is safe.
	      // for (const digit of digits)
	      for (var _iterator3 = digits.split(''), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
	        var _ref3;
	
	        if (_isArray3) {
	          if (_i3 >= _iterator3.length) break;
	          _ref3 = _iterator3[_i3++];
	        } else {
	          _i3 = _iterator3.next();
	          if (_i3.done) break;
	          _ref3 = _i3.value;
	        }
	
	        var digit = _ref3;
	
	        // If there is room for more digits in current `template`,
	        // then set the next digit in the `template`,
	        // and return the formatted digits so far.
	        // If more digits are entered than the current format could handle.
	        if (this.populatedNationalNumberTemplate.slice(this.populatedNationalNumberTemplatePosition + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0) {
	          // Reset the format.
	          this.resetFormat();
	          return;
	        }
	
	        this.populatedNationalNumberTemplatePosition = this.populatedNationalNumberTemplate.search(DIGIT_PLACEHOLDER_MATCHER);
	        this.populatedNationalNumberTemplate = this.populatedNationalNumberTemplate.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
	      } // Return the formatted phone number so far.
	
	
	      return cutAndStripNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
	      // for `react-phone-number-input`'s default input (`InputBasic`).
	      // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
	      // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
	    }
	  }, {
	    key: "getFormatFormat",
	    value: function getFormatFormat(format) {
	      if (this.isInternational()) {
	        return (0, _format_.applyInternationalSeparatorStyle)(format.internationalFormat());
	      }
	
	      return format.format();
	    } // Determines the country of the phone number
	    // entered so far based on the country phone code
	    // and the national phone number.
	
	  }, {
	    key: "determineTheCountry",
	    value: function determineTheCountry() {
	      this.country = (0, _parse_.findCountryCode)(this.isInternational() ? this.countryCallingCode : this.defaultCallingCode, this.nationalNumberDigits, this.metadata);
	    }
	    /**
	     * Returns an instance of `PhoneNumber` class.
	     * Will return `undefined` if no national (significant) number
	     * digits have been entered so far, or if no `defaultCountry` has been
	     * set and the user enters a phone number not in international format.
	     */
	
	  }, {
	    key: "getNumber",
	    value: function getNumber() {
	      if (this.isInternational()) {
	        if (!this.countryCallingCode) {
	          return;
	        }
	      } else {
	        if (!this.country && !this.defaultCallingCode) {
	          return;
	        }
	      }
	
	      if (!this.nationalNumberDigits) {
	        return undefined;
	      }
	
	      var countryCode = this.getCountry();
	      var callingCode = this.getCountryCallingCode() || this.defaultCallingCode;
	      var nationalNumber = this.nationalNumberDigits;
	      var carrierCode = this.carrierCode; // When an international number without a leading `+` has been autocorrected,
	      // extract country calling code, because normally it's only extracted
	      // for international numbers with a leading `+`.
	      // Could also just use `parsePhoneNumberFromString()` here
	      // instead of hacking around this single case.
	
	      if (!this.isInternational() && this.nationalNumberDigits === this.digits) {
	        var _extractCountryCallin2 = (0, _parse_.extractCountryCallingCodeFromInternationalNumberWithoutPlusSign)(this.digits, countryCode, callingCode, this.metadata.metadata),
	            countryCallingCode = _extractCountryCallin2.countryCallingCode,
	            number = _extractCountryCallin2.number;
	
	        if (countryCallingCode) {
	          var _stripNationalPrefixA2 = (0, _parse_.stripNationalPrefixAndCarrierCodeFromCompleteNumber)(number, this.metadata),
	              shorterNationalNumber = _stripNationalPrefixA2.nationalNumber,
	              newCarrierCode = _stripNationalPrefixA2.carrierCode;
	
	          nationalNumber = shorterNationalNumber;
	          carrierCode = newCarrierCode;
	        }
	      }
	
	      var phoneNumber = new _PhoneNumber["default"](countryCode || callingCode, nationalNumber, this.metadata.metadata);
	
	      if (carrierCode) {
	        phoneNumber.carrierCode = carrierCode;
	      } // Phone number extensions are not supported by "As You Type" formatter.
	
	
	      return phoneNumber;
	    }
	    /**
	     * Returns `true` if the phone number is "possible".
	     * Is just a shortcut for `PhoneNumber.isPossible()`.
	     * @return {boolean}
	     */
	
	  }, {
	    key: "isPossible",
	    value: function isPossible() {
	      var phoneNumber = this.getNumber();
	
	      if (!phoneNumber) {
	        return false;
	      }
	
	      return phoneNumber.isPossible();
	    }
	    /**
	     * Returns `true` if the phone number is "valid".
	     * Is just a shortcut for `PhoneNumber.isValid()`.
	     * @return {boolean}
	     */
	
	  }, {
	    key: "isValid",
	    value: function isValid() {
	      var phoneNumber = this.getNumber();
	
	      if (!phoneNumber) {
	        return false;
	      }
	
	      return phoneNumber.isValid();
	    }
	    /**
	     * @deprecated
	     * This method is used in `react-phone-number-input/source/input-control.js`
	     * in versions before `3.0.16`.
	     */
	
	  }, {
	    key: "getNationalNumber",
	    value: function getNationalNumber() {
	      return this.nationalNumberDigits;
	    }
	  }, {
	    key: "getNonFormattedTemplate",
	    value: function getNonFormattedTemplate() {
	      return this.getFullNumber(this.getNonFormattedNationalNumber()).replace(/[\+\d]/g, DIGIT_PLACEHOLDER);
	    }
	    /**
	     * Returns formatted phone number template.
	     * @return {string} [template]
	     */
	
	  }, {
	    key: "getTemplate",
	    value: function getTemplate() {
	      if (!this.template) {
	        return this.getNonFormattedTemplate();
	      }
	
	      var index = -1;
	      var i = 0;
	
	      while (i < (this.isInternational() ? this.getInternationalPrefix({
	        spacing: false
	      }).length : 0) + this.digits.length) {
	        index = this.template.indexOf(DIGIT_PLACEHOLDER, index + 1);
	        i++;
	      }
	
	      return cutAndStripNonPairedParens(this.template, index + 1);
	    }
	  }]);
	
	  return AsYouType;
	}();
	
	exports["default"] = AsYouType;
	
	function stripNonPairedParens(string) {
	  var dangling_braces = [];
	  var i = 0;
	
	  while (i < string.length) {
	    if (string[i] === '(') {
	      dangling_braces.push(i);
	    } else if (string[i] === ')') {
	      dangling_braces.pop();
	    }
	
	    i++;
	  }
	
	  var start = 0;
	  var cleared_string = '';
	  dangling_braces.push(string.length);
	
	  for (var _i4 = 0, _dangling_braces = dangling_braces; _i4 < _dangling_braces.length; _i4++) {
	    var index = _dangling_braces[_i4];
	    cleared_string += string.slice(start, index);
	    start = index + 1;
	  }
	
	  return cleared_string;
	}
	
	function cutAndStripNonPairedParens(string, cutBeforeIndex) {
	  if (string[cutBeforeIndex] === ')') {
	    cutBeforeIndex++;
	  }
	
	  return stripNonPairedParens(string.slice(0, cutBeforeIndex));
	}
	
	function closeNonPairedParens(template, cut_before) {
	  var retained_template = template.slice(0, cut_before);
	  var opening_braces = countOccurences('(', retained_template);
	  var closing_braces = countOccurences(')', retained_template);
	  var dangling_braces = opening_braces - closing_braces;
	
	  while (dangling_braces > 0 && cut_before < template.length) {
	    if (template[cut_before] === ')') {
	      dangling_braces--;
	    }
	
	    cut_before++;
	  }
	
	  return template.slice(0, cut_before);
	} // Counts all occurences of a symbol in a string.
	// Unicode-unsafe (because using `.split()`).
	
	
	function countOccurences(symbol, string) {
	  var count = 0; // Using `.split('')` to iterate through a string here
	  // to avoid requiring `Symbol.iterator` polyfill.
	  // `.split('')` is generally not safe for Unicode,
	  // but in this particular case for counting brackets it is safe.
	  // for (const character of string)
	
	  for (var _iterator4 = string.split(''), _isArray4 = Array.isArray(_iterator4), _i5 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
	    var _ref4;
	
	    if (_isArray4) {
	      if (_i5 >= _iterator4.length) break;
	      _ref4 = _iterator4[_i5++];
	    } else {
	      _i5 = _iterator4.next();
	      if (_i5.done) break;
	      _ref4 = _i5.value;
	    }
	
	    var character = _ref4;
	
	    if (character === symbol) {
	      count++;
	    }
	  }
	
	  return count;
	} // Repeats a string (or a symbol) N times.
	// http://stackoverflow.com/questions/202605/repeat-string-javascript
	
	
	function repeat(string, times) {
	  if (times < 1) {
	    return '';
	  }
	
	  var result = '';
	
	  while (times > 1) {
	    if (times & 1) {
	      result += string;
	    }
	
	    times >>= 1;
	    string += string;
	  }
	
	  return result + string;
	}
	/**
	 * Extracts formatted phone number from text (if there's any).
	 * @param  {string} text
	 * @return {string} [formattedPhoneNumber]
	 */
	
	
	function extractFormattedPhoneNumber(text) {
	  // Attempt to extract a possible number from the string passed in.
	  var startsAt = text.search(VALID_PHONE_NUMBER);
	
	  if (startsAt < 0) {
	    return;
	  } // Trim everything to the left of the phone number.
	
	
	  text = text.slice(startsAt); // Trim the `+`.
	
	  var hasPlus;
	
	  if (text[0] === '+') {
	    hasPlus = true;
	    text = text.slice('+'.length);
	  } // Trim everything to the right of the phone number.
	
	
	  text = text.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.
	
	  if (hasPlus) {
	    text = '+' + text;
	  }
	
	  return text;
	}
	//# sourceMappingURL=AsYouType.js.map

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = formatIncompletePhoneNumber;
	
	var _AsYouType = _interopRequireDefault(__webpack_require__(822));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Formats a (possibly incomplete) phone number.
	 * The phone number can be either in E.164 format
	 * or in a form of national number digits.
	 * @param {string} value - A possibly incomplete phone number. Either in E.164 format or in a form of national number digits.
	 * @param {string?} country - Two-letter ("ISO 3166-1 alpha-2") country code.
	 * @return {string} Formatted (possibly incomplete) phone number.
	 */
	function formatIncompletePhoneNumber(value, country, metadata) {
	  if (!metadata) {
	    metadata = country;
	    country = undefined;
	  }
	
	  return new _AsYouType["default"](country, metadata).input(value);
	}
	//# sourceMappingURL=formatIncompletePhoneNumber.js.map

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getCountries;
	
	var _metadata = _interopRequireDefault(__webpack_require__(782));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getCountries(metadata) {
	  return new _metadata["default"](metadata).getCountries();
	}
	//# sourceMappingURL=getCountries.js.map

/***/ }),
/* 825 */
/***/ (function(module, exports) {

	module.exports = {"version":"1.7.51","country_calling_codes":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"383":["XK"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"880":["BD"],"886":["TW"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","00","(?:[01589]\\d|[46])\\d{4}",[5,6]],"AD":["376","00","(?:1|6\\d)\\d{7}|[135-9]\\d{5}",[6,8,9],[["(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],["(\\d{4})(\\d{4})","$1 $2",["1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]]],"AE":["971","00","(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",[5,6,7,8,9,10,11,12],[["(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],["(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],"0"],"AF":["93","00","[2-7]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],"0"],"AG":["1","011","(?:268|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([457]\\d{6})$","268$1",0,"268"],"AI":["1","011","(?:264|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2457]\\d{6})$","264$1",0,"264"],"AL":["355","00","(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",[6,7,8,9],[["(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],"0"],"AM":["374","00","(?:[1-489]\\d|55|60|77)\\d{6}",[8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],["(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],"0"],"AO":["244","00","[29]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]]],"AR":["54","00","11\\d{8}|(?:[2368]|9\\d)\\d{9}",[10,11],[["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",1],["(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1",0,"$1 $2 $3-$4"]],"0",0,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?","9$1"],"AS":["1","011","(?:[58]\\d\\d|684|900)\\d{7}",[10],0,"1",0,"1|([267]\\d{6})$","684$1",0,"684"],"AT":["43","00","1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",[4,5,6,7,8,9,10,11,12,13],[["(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],["(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],["(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],"0"],"AU":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|(?:[2-478]\\d\\d|550)\\d{6}|1\\d{4,7}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|[45]"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],"0",0,"0|(183[12])",0,0,0,[["(?:[237]\\d{5}|8(?:51(?:0(?:0[03-9]|[1247]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-6])|1(?:1[69]|[23]\\d|4[0-4]))|(?:[6-8]\\d{3}|9(?:[02-9]\\d\\d|1(?:[0-57-9]\\d|6[0135-9])))\\d))\\d{3}",[9]],["4(?:83[0-38]|93[01])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-2457-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,["16\\d{3,7}",[5,6,7,8,9]],["(?:14(?:5(?:1[0458]|[23][458])|71\\d)|550\\d\\d)\\d{4}",[9]],["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",[6,8,10]]],"0011"],"AW":["297","00","(?:[25-79]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]]],"AX":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",[5,6,7,8,9,10,11,12],0,"0",0,0,0,0,"18",0,"00"],"AZ":["994","00","365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365|46","1[28]|2|365(?:[0-46-9]|5[0-35-9])|46"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],"0"],"BA":["387","00","6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],"0"],"BB":["1","011","(?:246|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","246$1",0,"246"],"BD":["880","00","1\\d{9}|2\\d{7,8}|88\\d{4,6}|(?:8[0-79]|9\\d)\\d{4,8}|(?:[346]\\d|[57])\\d{5,8}",[6,7,8,9,10],[["(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],["(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],"0$1"],["(\\d{4})(\\d{3,6})","$1-$2",["[13-9]"],"0$1"],["(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],"0"],"BE":["32","00","4\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],"0"],"BF":["226","00","[025-7]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]]],"BG":["359","00","[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",[6,7,8,9],[["(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],"0"],"BH":["973","00","[136-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[13679]|8[047]"]]]],"BI":["257","00","(?:[267]\\d|31)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]]],"BJ":["229","00","(?:[2689]\\d|51)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[25689]"]]]],"BL":["590","00","(?:590|69\\d|976)\\d{6}",[9],0,"0",0,0,0,0,0,[["590(?:2[7-9]|5[12]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"],0,0,0,0,0,0,["976[01]\\d{5}"]]],"BM":["1","011","(?:441|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-8]\\d{6})$","441$1",0,"441"],"BN":["673","00","[2-578]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]]],"BO":["591","00(?:1\\d)?","(?:[2-467]\\d\\d|8001)\\d{5}",[8,9],[["(\\d)(\\d{7})","$1 $2",["[23]|4[46]"]],["(\\d{8})","$1",["[67]"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"]]],"0",0,"0(1\\d)?"],"BQ":["599","00","(?:[34]1|7\\d)\\d{5}",[7],0,0,0,0,0,0,"[347]"],"BR":["55","00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",[8,9,10,11],[["(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],["(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)"]],"0",0,"0(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],"BS":["1","011","(?:242|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([3-8]\\d{6})$","242$1",0,"242"],"BT":["975","00","[17]\\d{7}|[2-8]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]]],"BW":["267","00","90\\d{5}|(?:[2-6]|7\\d)\\d{6}",[7,8],[["(\\d{2})(\\d{5})","$1 $2",["90"]],["(\\d{3})(\\d{4})","$1 $2",["[2-6]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["7"]]]],"BY":["375","810","(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],["(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],"8",0,"0|80?",0,0,0,0,"8~10"],"BZ":["501","00","(?:0800\\d|[2-8])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]]],"CA":["1","011","(?:[2-8]\\d|90)\\d{8}",[10],0,"1",0,0,0,0,0,[["(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[57])|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}"],0,0,0,["600[2-9]\\d{6}"]]],"CC":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d|8[0-24-9])\\d{7}|(?:[148]\\d\\d|550)\\d{6}|1\\d{5,7}",[6,7,8,9,10],0,"0",0,"0|([59]\\d{7})$","8$1",0,0,[["8(?:51(?:0(?:02|31|60)|118)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",[9]],["4(?:83[0-38]|93[01])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-2457-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["(?:14(?:5(?:1[0458]|[23][458])|71\\d)|550\\d\\d)\\d{4}",[9]],["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",[6,8,10]]],"0011"],"CD":["243","00","[189]\\d{8}|[1-68]\\d{6}",[7,9],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"]],"0"],"CF":["236","00","(?:[27]\\d{3}|8776)\\d{4}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]]],"CG":["242","00","222\\d{6}|(?:0\\d|80)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["801"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]]],"CH":["41","00","8\\d{11}|[2-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],"0"],"CI":["225","00","[02-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[02-9]"]]]],"CK":["682","00","[2-578]\\d{4}",[5],[["(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]]],"CL":["56","(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0","12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",[9,10,11],[["(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-3]"],"($1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]]],"CM":["237","00","(?:[26]\\d\\d|88)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]"]]]],"CN":["86","00|1(?:[12]\\d|79)\\d\\d00","1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","(?:10|2[0-57-9])(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1",1],["(\\d{3})(\\d{7,8})","$1 $2",["9"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",1]],"0",0,"0|(1(?:[12]\\d|79)\\d\\d)",0,0,0,0,"00"],"CO":["57","00(?:4(?:[14]4|56)|[579])","(?:1\\d|3)\\d{9}|[124-8]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1 $2",["[14][2-9]|[25-8]"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["3"]],["(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1",0,"$1 $2 $3"]],"0",0,"0([3579]|4(?:[14]4|56))?"],"CR":["506","00","(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",[8,10],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"]]],0,0,"(19(?:0[0-2468]|1[09]|20|66|77|99))"],"CU":["53","119","[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",[6,7,8,10],[["(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],["(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["5"],"0$1"],["(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],"0"],"CV":["238","0","(?:[2-59]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]]],"CW":["599","00","(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[3467]"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],0,0,0,0,0,"[69]"],"CX":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d|8[0-24-9])\\d{7}|(?:[148]\\d\\d|550)\\d{6}|1\\d{5,7}",[6,7,8,9,10],0,"0",0,"0|([59]\\d{7})$","8$1",0,0,[["8(?:51(?:0(?:01|30|59)|117)|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",[9]],["4(?:83[0-38]|93[01])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-2457-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["(?:14(?:5(?:1[0458]|[23][458])|71\\d)|550\\d\\d)\\d{4}",[9]],["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",[6,8,10]]],"0011"],"CY":["357","00","(?:[279]\\d|[58]0)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]]],"CZ":["420","00","(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]]],"DE":["49","00","[2579]\\d{5,14}|49(?:[05]\\d{10}|[46][1-8]\\d{4,9})|49(?:[0-25]\\d|3[1-689]|7[1-7])\\d{4,8}|49(?:[0-2579]\\d|[34][1-9]|6[0-8])\\d{3}|49\\d{3,4}|(?:1|[368]\\d|4[0-8])\\d{3,13}",[4,5,6,7,8,9,10,11,12,13,14,15],[["(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],["(\\d{3})(\\d{3,12})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],["(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],["(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],["(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],["(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["15[0568]"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],["(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],["(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],["(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],["(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],"0"],"DJ":["253","00","(?:2\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]]],"DK":["45","00","[2-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]]],"DM":["1","011","(?:[58]\\d\\d|767|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","767$1",0,"767"],"DO":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"8[024]9"],"DZ":["213","00","(?:[1-4]|[5-79]\\d|80)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],"0"],"EC":["593","00","1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",[8,9,10,11],[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)",0,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],"0"],"EE":["372","00","8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],["(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"EG":["20","00","[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",[8,9,10],[["(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],["(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[189]"],"0$1"]],"0"],"EH":["212","00","[5-8]\\d{8}",[9],0,"0",0,0,0,0,"528[89]"],"ER":["291","00","[178]\\d{6}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],"0"],"ES":["34","00","(?:51|[6-9]\\d)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]]],"ET":["251","00","(?:11|[2-59]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-59]"],"0$1"]],"0"],"FI":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",[5,6,7,8,9,10,11,12],[["(\\d)(\\d{4,9})","$1 $2",["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"],["(\\d{3})(\\d{3,7})","$1 $2",["[12]00|[368]|70[07-9]"],"0$1"],["(\\d{2})(\\d{4,8})","$1 $2",["[1245]|7[135]"],"0$1"],["(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"]],"0",0,0,0,0,"1[03-79]|[2-9]",0,"00"],"FJ":["679","0(?:0|52)","45\\d{5}|(?:0800\\d|[235-9])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],0,0,0,0,0,0,0,"00"],"FK":["500","00","[2-7]\\d{4}",[5]],"FM":["691","00","(?:[39]\\d\\d|820)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[389]"]]]],"FO":["298","00","(?:[2-8]\\d|90)\\d{4}",[6],[["(\\d{6})","$1",["[2-9]"]]],0,0,"(10(?:01|[12]0|88))"],"FR":["33","00","[1-9]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],"0"],"GA":["241","00","(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",[7,8],[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]]],0,0,"0(11\\d{6}|6[256]\\d{6}|7[47]\\d{6})","$1"],"GB":["44","00","[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",[7,9,10],[["(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])","[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],"0",0,0,0,0,0,[["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[03])|(?:4[0-5]|5[0-26-9]|6[0-4]|[78][0-49])\\d\\d)|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:0\\d|20)))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",[9,10]],["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:0[0-2]|2[356]|34|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}",[10]],["56\\d{8}",[10]]],0," x"],"GD":["1","011","(?:473|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","473$1",0,"473"],"GE":["995","00","(?:[3-57]\\d\\d|800)\\d{6}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],"0"],"GF":["594","00","(?:[56]94|976)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"]],"0"],"GG":["44","00","(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",[7,9,10],0,"0",0,"0|([25-9]\\d{5})$","1481$1",0,0,[["1481[25-9]\\d{5}",[10]],["7(?:(?:781|839)\\d|911[17])\\d{5}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:0[0-2]|2[356]|34|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}",[10]],["56\\d{8}",[10]]]],"GH":["233","00","(?:[235]\\d{3}|800)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],"0"],"GI":["350","00","[256]\\d{7}",[8],[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],"GL":["299","00","(?:19|[2-689]\\d)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-689]"]]]],"GM":["220","00","[2-9]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"GN":["224","00","722\\d{6}|(?:3|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","00","(?:590|69\\d|976)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"]],"0",0,0,0,0,0,[["590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}"],["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"],0,0,0,0,0,0,["976[01]\\d{5}"]]],"GQ":["240","00","222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],"GR":["30","00","5005000\\d{3}|(?:[2689]\\d|70)\\d{8}",[10],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]]]],"GT":["502","00","(?:1\\d{3}|[2-7])\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","011","(?:[58]\\d\\d|671|900)\\d{7}",[10],0,"1",0,"1|([3-9]\\d{6})$","671$1",0,"671"],"GW":["245","00","[49]\\d{8}|4\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["40"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]]],"GY":["592","001","(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-46-9]"]]]],"HK":["852","00(?:30|5[09]|[126-9]?)","8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}",[5,6,7,8,9,11],[["(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,0,"00"],"HN":["504","00","8\\d{10}|[237-9]\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]]],"HR":["385","00","(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",[6,7,8,9],[["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],"0"],"HT":["509","00","[2-489]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-489]"]]]],"HU":["36","00","[2357]\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-57-9]"],"06 $1"]],"06"],"ID":["62","00[189]","(?:(?:007803|8\\d{4})\\d|[1-36])\\d{6}|[1-9]\\d{8,10}|[2-9]\\d{7}",[7,8,9,10,11,12,13],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],["(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],["(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],["(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],["(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],["(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],"0"],"IE":["353","00","(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],["(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],["(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"IL":["972","0(?:0|1[2-9])","1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",[7,8,9,10,11,12],[["(\\d{4})(\\d{3})","$1-$2",["125"]],["(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],["(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],["(\\d{4})(\\d{6})","$1-$2",["159"]],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],"0"],"IM":["44","00","1624\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"0|([5-8]\\d{5})$","1624$1",0,"74576|(?:16|7[56])24"],"IN":["91","00","(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",[8,9,10,11,12,13],[["(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],0,1],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],0,1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],"0$1",1],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]","1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",1],["(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",1],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],0,1],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],0,1]],"0"],"IO":["246","00","3\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["3"]]]],"IQ":["964","00","(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"IR":["98","00","[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",[4,5,6,7,10],[["(\\d{4,5})","$1",["96"],"0$1"],["(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],"0"],"IS":["354","00|1(?:0(?:01|[12]0)|100)","(?:38\\d|[4-9])\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],0,0,0,0,0,0,0,"00"],"IT":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11],[["(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[245])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]],["(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],["(\\d{4})(\\d{4})","$1 $2",["894"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1[4679]|[38]"]],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]"]],["(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],0,0,0,0,0,0,[["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"],["3[1-9]\\d{8}|3[2-9]\\d{7}",[9,10]],["80(?:0\\d{3}|3)\\d{3}",[6,9]],["(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}",[6,8,9,10]],["1(?:78\\d|99)\\d{6}",[9,10]],0,0,0,["55\\d{8}",[10]],["84(?:[08]\\d{3}|[17])\\d{3}",[6,9]]]],"JE":["44","00","1534\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"0|([0-24-8]\\d{5})$","1534$1",0,0,[["1534[0-24-8]\\d{5}"],["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"],["80(?:07(?:35|81)|8901)\\d{4}"],["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"],["701511\\d{4}"],0,["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"],["76(?:0[0-2]|2[356]|34|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}"],["56\\d{8}"]]],"JM":["1","011","(?:[58]\\d\\d|658|900)\\d{7}",[10],0,"1",0,0,0,0,"658|876"],"JO":["962","00","(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"JP":["81","010","00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",[8,9,10,11,12,13,14,15,16,17],[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[78]|96)|477|51[24]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[78]|96[2457-9])|477|51[24]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[279]|49|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[0468][01]|[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|2[01]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:47[59]|59[89]|8(?:6[68]|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[0468][01]|[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|2[01]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[0468][01]|[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|2[01]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[29][2-9]|5[3-9]|7[2-4679]|8(?:[246-9]|3[3-8]|5[2-9])","[14]|[29][2-9]|5[3-9]|7[2-4679]|8(?:[246-9]|3(?:[3-6][2-9]|7|8[2-5])|5[2-9])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[2579]|80"],"0$1"]],"0"],"KE":["254","000","(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",[7,8,9,10],[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0"],"KG":["996","00","8\\d{9}|(?:[235-8]\\d|99)\\d{7}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],["(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"KH":["855","00[14-9]","1\\d{9}|[1-9]\\d{7,8}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"KI":["686","00","(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",[5,8],0,"0"],"KM":["269","00","[3478]\\d{6}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]]],"KN":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","869$1",0,"869"],"KP":["850","00|99","85\\d{6}|(?:19\\d|[2-7])\\d{7}",[8,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],"0"],"KR":["82","00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",[5,6,8,9,10,11,12,13,14],[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1"],["(\\d{4})(\\d{4})","$1-$2",["1"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1"]],"0",0,"0(8(?:[1-46-8]|5\\d\\d))?"],"KW":["965","00","(?:18|[2569]\\d\\d)\\d{5}",[7,8],[["(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],["(\\d{3})(\\d{5})","$1 $2",["[25]"]]]],"KY":["1","011","(?:345|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","345$1",0,"345"],"KZ":["7","810","33622\\d{5}|(?:7\\d|80)\\d{8}",[10],0,"8",0,0,0,0,"33|7",0,"8~10"],"LA":["856","00","[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[013-9]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],"0"],"LB":["961","00","[7-9]\\d{7}|[13-9]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"]]],"0"],"LC":["1","011","(?:[58]\\d\\d|758|900)\\d{7}",[10],0,"1",0,"1|([2-8]\\d{6})$","758$1",0,"758"],"LI":["423","00","90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}",[7,9],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[237-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["69"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],"0",0,"0|(1001)"],"LK":["94","00","[1-9]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],"0"],"LR":["231","00","(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[4-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3578]"],"0$1"]],"0"],"LS":["266","00","(?:[256]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2568]"]]]],"LT":["370","00","(?:[3469]\\d|52|[78]0)\\d{6}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(8-$1)",1],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1",1],["(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(8-$1)",1],["(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(8-$1)",1]],"8",0,"[08]"],"LU":["352","00","35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",[4,5,6,7,8,9,10,11],[["(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]],0,0,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],"LV":["371","00","(?:[268]\\d|90)\\d{6}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[269]|8[01]"]]]],"LY":["218","00","[2-9]\\d{8}",[9],[["(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],"0"],"MA":["212","00","[5-8]\\d{8}",[9],[["(\\d{5})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29|38)[89]","5(?:29|38)[89]0"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],["(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|9)|892","5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"],"0$1"],["(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],["(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],"0",0,0,0,0,0,[["5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[015-7]\\d|2[02-9]|3[0-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"],["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[016-8]|6[1267]|7[0-27]))\\d{6}"],["80\\d{7}"],["89\\d{7}"],0,0,0,0,["592(?:4[0-2]|93)\\d{4}"]]],"MC":["377","00","870\\d{5}|(?:[349]|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[39]"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],"0"],"MD":["373","00","(?:[235-7]\\d|[89]0)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],"0"],"ME":["382","00","(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],"0"],"MF":["590","00","(?:590|69\\d|976)\\d{6}",[9],0,"0",0,0,0,0,0,[["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"],0,0,0,0,0,0,["976[01]\\d{5}"]]],"MG":["261","00","[23]\\d{8}",[9],[["(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],"0",0,"0|([24-9]\\d{6})$","20$1"],"MH":["692","011","329\\d{4}|(?:[256]\\d|45)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],"1"],"MK":["389","00","[2-578]\\d{7}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],"0"],"ML":["223","00","[24-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]]],"MM":["95","00","1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",[6,7,8,9,10],[["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],["(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],["(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],"0"],"MN":["976","001","[12]\\d{7,9}|[57-9]\\d{7}",[8,9,10],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[57-9]"]],["(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],"0"],"MO":["853","00","(?:28|[68]\\d)\\d{6}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[268]"]]]],"MP":["1","011","[58]\\d{9}|(?:67|90)0\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","670$1",0,"670"],"MQ":["596","00","69\\d{7}|(?:59|97)6\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"]],"0"],"MR":["222","00","(?:[2-4]\\d\\d|800)\\d{5}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],"MS":["1","011","(?:[58]\\d\\d|664|900)\\d{7}",[10],0,"1",0,"1|([34]\\d{6})$","664$1",0,"664"],"MT":["356","00","3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]]],"MU":["230","0(?:0|[24-7]0|3[03])","(?:[2-468]|5\\d)\\d{6}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],["(\\d{4})(\\d{4})","$1 $2",["5"]]],0,0,0,0,0,0,0,"020"],"MV":["960","0(?:0|19)","(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",[7,10],[["(\\d{3})(\\d{4})","$1-$2",["[3467]|9[13-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,0,"00"],"MW":["265","00","1\\d{6}(?:\\d{2})?|(?:[23]1|77|88|99)\\d{7}",[7,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],"0"],"MX":["52","0[09]","(?:1(?:[01467]\\d|[2359][1-9]|8[1-79])|[2-9]\\d)\\d{8}",[10,11],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],0,1],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],0,1],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 $3 $4",["1"],0,1]],"01",0,"0(?:[12]|4[45])|1",0,0,0,0,"00"],"MY":["60","00","1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9])|8"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1[36-8]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],"0"],"MZ":["258","00","(?:2|8\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"NA":["264","00","[68]\\d{7,8}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"NC":["687","00","[2-57-9]\\d{5}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[2-57-9]"]]]],"NE":["227","00","[0289]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]"]]]],"NF":["672","00","[13]\\d{5}",[6],[["(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],["(\\d)(\\d{5})","$1 $2",["[13]"]]],0,0,"([0-258]\\d{4})$","3$1"],"NG":["234","009","(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",[7,8,10,11,12,13,14],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["78"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-7]|8[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],["(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],"0"],"NI":["505","00","(?:1800|[25-8]\\d{3})\\d{4}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]]],"NL":["31","00","(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}",[5,6,7,8,9,10],[["(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],["(\\d)(\\d{8})","$1 $2",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-57-9]"],"0$1"]],"0"],"NO":["47","00","(?:0|[2-9]\\d{3})\\d{4}",[5,8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[489]|5[89]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],0,0,0,0,0,"[02-689]|7[0-8]"],"NP":["977","00","9\\d{9}|[1-9]\\d{7}",[8,10],[["(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],["(\\d{2})(\\d{6})","$1-$2",["[1-8]|9(?:[1-579]|6[2-6])"],"0$1"],["(\\d{3})(\\d{7})","$1-$2",["9"]]],"0"],"NR":["674","00","(?:444|(?:55|8\\d)\\d|666)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]]],"NU":["683","00","(?:[47]|888\\d)\\d{3}",[4,7],[["(\\d{3})(\\d{4})","$1 $2",["8"]]]],"NZ":["64","0(?:0|161)","[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,8})","$1 $2",["83"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[0367]|[89]0"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[59]|80"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7|86"],"0$1"]],"0",0,0,0,0,0,0,"00"],"OM":["968","00","(?:1505|[279]\\d{3}|500)\\d{4}|8007\\d{4,5}",[7,8,9],[["(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],["(\\d{2})(\\d{6})","$1 $2",["2"]],["(\\d{4})(\\d{4})","$1 $2",["[179]"]]]],"PA":["507","00","(?:[1-57-9]|6\\d)\\d{6}",[7,8],[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["6"]]]],"PE":["51","19(?:1[124]|77|90)00","(?:[14-8]|9\\d)\\d{7}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0",0,0,0,0,0,0,0," Anexo "],"PF":["689","00","[48]\\d{7}|4\\d{5}",[6,8],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[48]"]]]],"PG":["675","00|140[1-3]","(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],["(\\d{4})(\\d{4})","$1 $2",["[78]"]]],0,0,0,0,0,0,0,"00"],"PH":["63","00","1800\\d{7,9}|(?:2|[89]\\d{4})\\d{5}|[2-8]\\d{8}|[28]\\d{7}",[6,8,9,10,11,12,13],[["(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],"0"],"PK":["92","00","122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["[89]0"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["1"]],["(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],"(0$1)"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],["(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],["(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],"0"],"PL":["48","00","[1-57-9]\\d{6}(?:\\d{2})?|6\\d{5,8}",[6,7,8,9],[["(\\d{5})","$1",["19"]],["(\\d{3})(\\d{3})","$1 $2",["11|64"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["39|45|5[0137]|6[0469]|7[02389]|8[08]"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-8]|9[145]"]]]],"PM":["508","00","[45]\\d{5}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"]],"0"],"PR":["1","011","(?:[589]\\d\\d|787)\\d{7}",[10],0,"1",0,0,0,0,"787|939"],"PS":["970","00","[2489]2\\d{6}|(?:1\\d|5)\\d{8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"PT":["351","00","(?:[26-9]\\d|30)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[236-9]"]]]],"PW":["680","01[12]","(?:[24-8]\\d\\d|345|900)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"PY":["595","00","59\\d{4,6}|(?:[2-46-9]\\d|5[0-8])\\d{4,7}",[6,7,8,9],[["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],["(\\d{3})(\\d{6})","$1 $2",["9"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"]],"0"],"QA":["974","00","[2-7]\\d{7}|(?:2\\d\\d|800)\\d{4}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["2[126]|8"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]]]],"RE":["262","00","9769\\d{5}|(?:26|[68]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"],"0$1"]],"0",0,0,0,0,"26[23]|69|[89]"],"RO":["40","00","(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}",[6,9],[["(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],["(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[237-9]"],"0$1"]],"0",0,0,0,0,0,0,0," int "],"RS":["381","00","38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",[6,7,8,9,10,11,12],[["(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],["(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],"0"],"RU":["7","810","[347-9]\\d{9}",[10],[["(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",1],["(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[3489]"],"8 ($1)",1]],"8",0,0,0,0,"3[04-689]|[489]",0,"8~10"],"RW":["250","00","(?:06|[27]\\d\\d|[89]00)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]]],"0"],"SA":["966","00","92\\d{7}|(?:[15]|8\\d)\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["9"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],"0"],"SB":["677","0[01]","(?:[1-6]|[7-9]\\d\\d)\\d{4}",[5,7],[["(\\d{2})(\\d{5})","$1 $2",["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]],"SC":["248","010|0[0-2]","8000\\d{3}|(?:[249]\\d|64)\\d{5}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],0,0,0,0,0,0,0,"00"],"SD":["249","00","[19]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],"0"],"SE":["46","00","(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44)"],"0$1",0,"$1 $2"],["(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3"],["(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1",0,"$1 $2 $3"],["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3 $4"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1",0,"$1 $2 $3 $4"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1",0,"$1 $2 $3 $4 $5"]],"0"],"SG":["65","0[0-3]\\d","(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:01|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],["(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"SH":["290","00","(?:[256]\\d|8)\\d{3}",[4,5],0,0,0,0,0,0,"[256]"],"SI":["386","00|10(?:22|66|88|99)","[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",[5,6,7,8],[["(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],"0",0,0,0,0,0,0,"00"],"SJ":["47","00","0\\d{4}|(?:[4589]\\d|79)\\d{6}",[5,8],0,0,0,0,0,0,"79"],"SK":["421","00","[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",[6,7,9],[["(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],"0"],"SL":["232","00","(?:[2378]\\d|66|99)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],"0"],"SM":["378","00","(?:0549|[5-7]\\d)\\d{6}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(\\d{4})(\\d{6})","$1 $2",["0"]]],0,0,"([89]\\d{5})$","0549$1"],"SN":["221","00","(?:[378]\\d{4}|93330)\\d{4}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]]],"SO":["252","00","[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",[6,7,8,9],[["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],["(\\d)(\\d{7})","$1 $2",["24|[67]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3478]|64|90"]],["(\\d{2})(\\d{5,7})","$1 $2",["1|28|6[1-35-9]|9[2-9]"]]],"0"],"SR":["597","00","(?:[2-5]|68|[78]\\d)\\d{5}",[6,7],[["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]]],"SS":["211","00","[19]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],"0"],"ST":["239","00","(?:22|9\\d)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[29]"]]]],"SV":["503","00","[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",[7,8,11],[["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","011","7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|(5\\d{6})$","721$1",0,"721"],"SY":["963","00","[1-39]\\d{8}|[1-5]\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1",1]],"0"],"SZ":["268","00","0800\\d{4}|(?:[237]\\d|900)\\d{6}",[8,9],[["(\\d{4})(\\d{4})","$1 $2",["[0237]"]],["(\\d{5})(\\d{4})","$1 $2",["9"]]]],"TA":["290","00","8\\d{3}",[4],0,0,0,0,0,0,"8"],"TC":["1","011","(?:[58]\\d\\d|649|900)\\d{7}",[10],0,"1",0,"1|([2-479]\\d{6})$","649$1",0,"649"],"TD":["235","00|16","(?:22|[69]\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2679]"]]],0,0,0,0,0,0,0,"00"],"TG":["228","00","[279]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]]],"TH":["66","00[1-9]","1\\d{8,9}|(?:[2-57]|[689]\\d)\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["14|[3-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"TJ":["992","810","(?:00|11|[3-579]\\d|88)\\d{7}",[9],[["(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"],0,1],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[34]7|91[78]"],0,1],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3"],0,1],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[0457-9]|11"],0,1]],"8",0,0,0,0,0,0,"8~10"],"TK":["690","00","[2-47]\\d{3,6}",[4,5,6,7]],"TL":["670","00","7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7"]]]],"TM":["993","810","[1-6]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],["(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"TN":["216","00","[2-57-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]]],"TO":["676","00","(?:0800|[5-8]\\d{3})\\d{3}|[2-8]\\d{4}",[5,7],[["(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[5-8]"]]]],"TR":["90","00","(?:4|8\\d{5})\\d{6}|(?:[2-58]\\d\\d|900)\\d{7}",[7,10,12],[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[0589]|90"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|616)","5(?:[0-59]|6161)"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",1],["(\\d{3})(\\d{3})(\\d{6})","$1 $2 $3",["80"],"0$1",1]],"0"],"TT":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-46-8]\\d{6})$","868$1",0,"868"],"TV":["688","00","(?:2|7\\d\\d|90)\\d{4}",[5,6,7],[["(\\d{2})(\\d{3})","$1 $2",["2"]],["(\\d{2})(\\d{4})","$1 $2",["90"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"TW":["886","0(?:0[25-79]|19)","[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",[7,8,9,10,11],[["(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,0,0,"#"],"TZ":["255","00[056]","(?:[26-8]\\d|41|90)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],"0"],"UA":["380","00","[89]\\d{9}|[3-9]\\d{8}",[9,10],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]","4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["[3-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,0,"0~0"],"UG":["256","00[057]","800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",[9],[["(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],"0"],"US":["1","011","[2-9]\\d{9}",[10],[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],0,1,"$1-$2-$3"]],"1",0,0,0,0,0,[["(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-28]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:35(?:[02-46-9]\\d|1[02-9]|5[0-46-9])|45(?:[034]\\d|1[02-9]|2[024-9]|5[0-46-9]))\\d{4}|52(?:3[2-46-9]|4[2-4])(?:[02-9]\\d|1[02-9])\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],"UY":["598","0(?:0|1[3-9]\\d)","(?:[249]\\d\\d|80)\\d{5}|9\\d{6}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["8|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[24]"]]],"0",0,0,0,0,0,0,"00"," int. "],"UZ":["998","810","(?:[679]\\d|88)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[6-9]"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"VA":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11],0,0,0,0,0,0,"06698"],"VC":["1","011","(?:[58]\\d\\d|784|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","784$1",0,"784"],"VE":["58","00","[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",[10],[["(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1"]],"0"],"VG":["1","011","(?:284|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-578]\\d{6})$","284$1",0,"284"],"VI":["1","011","[58]\\d{9}|(?:34|90)0\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","340$1",0,"340"],"VN":["84","00","[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",1],["(\\d{4})(\\d{4,6})","$1 $2",["1"],0,1],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[69]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3578]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",1]],"0"],"VU":["678","00","(?:[23]\\d|[48]8)\\d{3}|(?:[57]\\d|90)\\d{5}",[5,7],[["(\\d{3})(\\d{4})","$1 $2",["[579]"]]]],"WF":["681","00","(?:[45]0|68|72|8\\d)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[4-8]"]]]],"WS":["685","0","(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",[5,6,7,10],[["(\\d{5})","$1",["[2-5]|6[1-9]"]],["(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"XK":["383","00","[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23]"],"0$1"]],"0"],"YE":["967","00","(?:1|7\\d)\\d{7}|[1-7]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7[24-68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],"0"],"YT":["262","00","80\\d{7}|(?:26|63)9\\d{6}",[9],0,"0",0,0,0,0,"269|63"],"ZA":["27","00","[1-9]\\d{8}|8\\d{4,7}",[5,6,7,8,9],[["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"]],"0"],"ZM":["260","00","(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],"0"],"ZW":["263","00","2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",[5,6,7,8,9,10],[["(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],["(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],["(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],"0"]},"nonGeographic":{"800":["800",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,["[1-9]\\d{7}"]]],"808":["808",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,0,["[1-9]\\d{7}"]]],"870":["870",0,"[35-7]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[35-7]"]]],0,0,0,0,0,0,[0,["(?:[356]\\d|7[6-8])\\d{7}"]]],"878":["878",0,"10\\d{10}",[12],[["(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["10\\d{10}"]]],"881":["881",0,"[0-36-9]\\d{8}",[9],[["(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-36-9]"]]],0,0,0,0,0,0,[0,["[0-36-9]\\d{8}"]]],"882":["882",0,"[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|[19]\\d{7}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5})","$1 $2",["16|342"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[19]"]],["(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["34[57]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],["(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-3]"]]],0,0,0,0,0,0,[0,["3(?:37\\d\\d|42)\\d{4}|3(?:2|47|7\\d{3})\\d{7}",[7,9,10,12]],0,0,0,0,0,0,["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"]]],"883":["883",0,"51\\d{7}(?:\\d{3})?",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["510"]],["(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["5"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["51[013]0\\d{8}|5100\\d{5}"]]],"888":["888",0,"\\d{11}",[11],[["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],0,0,0,0,0,0,[0,0,0,0,0,0,["\\d{11}"]]],"979":["979",0,"[1359]\\d{8}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],0,0,0,0,0,0,[0,0,0,["[1359]\\d{8}"]]]}}

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var lodash_1 = __webpack_require__(268);
	var PROVIDER_VALIDATOR = {
	    provide: forms_1.NG_VALIDATORS,
	    useExisting: core_1.forwardRef(function () { return MatchValidator; }),
	    multi: true
	};
	/**
	 * Directive, which adds validators
	 */
	var MatchValidator = (function () {
	    function MatchValidator(form, matchControlAlias) {
	        this.form = form;
	        this.matchControlAlias = matchControlAlias;
	        this.validator = matchValidatorFactory(this.matchControlAlias);
	    }
	    MatchValidator.prototype.validate = function (control) {
	        return this.validator(control);
	    };
	    MatchValidator = __decorate([
	        core_1.Directive({
	            selector: '[match]',
	            providers: [PROVIDER_VALIDATOR]
	        }),
	        __param(1, core_1.Attribute('match')),
	        __metadata("design:paramtypes", [forms_1.NgForm, String])
	    ], MatchValidator);
	    return MatchValidator;
	}());
	exports.MatchValidator = MatchValidator;
	function matchValidatorFactory(matchControlName) {
	    var matchControlSubscr;
	    return function (control) {
	        var matchControl = control.root.get(matchControlName);
	        //
	        if (lodash_1.isUndefined(matchControlSubscr) && matchControl) {
	            matchControlSubscr = matchControl.valueChanges.subscribe(function (val) {
	                control.updateValueAndValidity();
	            });
	            if (!lodash_1.isEmpty(control.value)) {
	                control.markAsTouched();
	            }
	        }
	        //
	        return (matchControl && control.value === matchControl.value) ? null : { match: { valid: false } };
	    };
	}
	exports.matchValidatorFactory = matchValidatorFactory;


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var PROVIDER_VALIDATOR = {
	    provide: forms_1.NG_VALIDATORS,
	    useExisting: core_1.forwardRef(function () { return AmountValidator; }),
	    multi: true
	};
	var AmountValidator = (function () {
	    function AmountValidator() {
	        this.minAmount = 0;
	    }
	    AmountValidator.prototype.validate = function (control) {
	        if (control.value || control.value === 0) {
	            var value = Number(control.value);
	            if (value > this.maxAmount) {
	                return { 'max-amount': { valid: false } };
	            }
	            else if (value < this.minAmount) {
	                return { 'min-amount': { valid: false } };
	            }
	            return null;
	        }
	        return null;
	    };
	    __decorate([
	        core_1.Input('max-amount'),
	        __metadata("design:type", Number)
	    ], AmountValidator.prototype, "maxAmount", void 0);
	    __decorate([
	        core_1.Input('min-amount'),
	        __metadata("design:type", Object)
	    ], AmountValidator.prototype, "minAmount", void 0);
	    AmountValidator = __decorate([
	        core_1.Directive({
	            selector: '[amount]',
	            providers: [PROVIDER_VALIDATOR]
	        }),
	        __metadata("design:paramtypes", [])
	    ], AmountValidator);
	    return AmountValidator;
	}());
	exports.AmountValidator = AmountValidator;


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(743);
	var ibantools = __webpack_require__(829);
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var PROVIDER_VALIDATOR = {
	    provide: forms_1.NG_VALIDATORS,
	    useExisting: core_1.forwardRef(function () { return IbanValidator; }),
	    multi: true
	};
	function validateIban(iban, countryCode) {
	    if (!util_1.isNullOrUndefined(iban) && iban.length) {
	        if (ibantools.isValidIBAN(iban)) {
	            /* If IBAN valid check country if defined */
	            if (!!countryCode && !isIbanValidByCountry(iban, countryCode)) {
	                return { 'iban-country': { valid: false } };
	            }
	        }
	        else {
	            /* If IBAN broken try determinate problem */
	            if (!!countryCode && !isIbanValidByLength(iban, countryCode)) {
	                return { 'iban-length': { valid: false } };
	            }
	            /* Shown invalid checksum error */
	            return { 'iban-checksum': { valid: false } };
	        }
	    }
	    return null;
	}
	exports.validateIban = validateIban;
	var IbanValidator = (function () {
	    function IbanValidator() {
	    }
	    IbanValidator.prototype.validate = function (c) {
	        return validateIban(c.value, this.countryCode);
	    };
	    __decorate([
	        core_1.Input('countryCode'),
	        __metadata("design:type", String)
	    ], IbanValidator.prototype, "countryCode", void 0);
	    IbanValidator = __decorate([
	        core_1.Directive({
	            selector: '[ibanValidator]',
	            providers: [PROVIDER_VALIDATOR]
	        })
	    ], IbanValidator);
	    return IbanValidator;
	}());
	exports.IbanValidator = IbanValidator;
	function isIbanValidByCountry(iban, countryCode) {
	    return ibantools.extractIBAN(iban).countryCode === countryCode;
	}
	function isIbanValidByLength(iban, countryCode) {
	    var countrySpec = ibantools.getCountrySpecifications()[countryCode];
	    if (countrySpec) {
	        var expectedCharCount = ibantools.getCountrySpecifications()[countryCode].chars;
	        var actualCharCount = iban.replace(/\s/g, '').length;
	        return expectedCharCount === actualCharCount;
	    }
	    return true;
	}


/***/ }),
/* 829 */
/***/ (function(module, exports) {

	/*!
	 * @license
	 * This Source Code Form is subject to the terms of the Mozilla Public
	 * License, v. 2.0. If a copy of the MPL was not distributed with this
	 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */
	/**
	 * @file Validation, extraction and creation of IBAN, BBAN, BIC/SWIFT numbers plus some other helpful stuff
	 * @author Saša Jovanić
	 * @module ibantools
	 * @see module:ibantools
	 * @version 2.2.0
	 * @license MPL-2.0
	 */
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Validate IBAN
	 * @example
	 * // returns true
	 * ibantools.isValidIBAN("NL91ABNA0517164300");
	 * @example
	 * // returns false
	 * ibantools.isValidIBAN("NL92ABNA0517164300");
	 * @alias module:ibantools.isValidIBAN
	 * @param {string} IBAN IBAN
	 * @return {boolean} valid
	 */
	function isValidIBAN(iban) {
	    if (iban !== undefined && iban !== null) {
	        var reg = new RegExp("^[0-9]{2}$", "");
	        var spec = countrySpecs[iban.slice(0, 2)];
	        if (spec !== undefined &&
	            spec.IBANRegistry &&
	            spec.chars === iban.length &&
	            reg.test(iban.slice(2, 4)) &&
	            checkFormatBBAN(iban.slice(4), spec.bban_regexp) &&
	            isValidIBANChecksum(iban)) {
	            return true;
	        }
	    }
	    return false;
	}
	exports.isValidIBAN = isValidIBAN;
	/**
	 * Validate BBAN
	 * @example
	 * // returns true
	 * ibantools.isValidBBAN("ABNA0517164300", "NL");
	 * @example
	 * // returns false
	 * ibantools.isValidBBAN("A7NA0517164300", "NL");
	 * @alias module:ibantools.isValidBBAN
	 * @param {string} BBAN BBAN
	 * @param {string} countryCode Country code
	 * @return {boolean} valid
	 */
	function isValidBBAN(bban, countryCode) {
	    if (bban !== undefined && bban !== null && countryCode !== undefined && countryCode !== null) {
	        var spec = countrySpecs[countryCode];
	        if (spec !== undefined &&
	            spec.chars - 4 === bban.length &&
	            checkFormatBBAN(bban, spec.bban_regexp)) {
	            return true;
	        }
	    }
	    return false;
	}
	exports.isValidBBAN = isValidBBAN;
	/**
	 * composeIBAN
	 * @example
	 * // returns NL91ABNA0417164300
	 * ibantools.composeIBAN("NL", "ABNA0417164300");
	 * @alias module:ibantools.composeIBAN
	 * @param {ComposeIBANParams} Object {bban: string, countryCode: string}
	 * @result {string} IBAN IBAN
	 */
	function composeIBAN(params) {
	    var bban = electronicFormatIBAN(params.bban);
	    var spec = countrySpecs[params.countryCode];
	    if (bban !== null &&
	        spec !== undefined &&
	        spec.chars === (bban.length + 4) &&
	        checkFormatBBAN(bban, spec.bban_regexp)) {
	        var checksom = mod9710(params.countryCode + "00" + bban);
	        return params.countryCode + ("0" + (98 - checksom)).slice(-2) + bban;
	    }
	    return null;
	}
	exports.composeIBAN = composeIBAN;
	/**
	 * extractIBAN
	 * @example
	 * // returns {iban: "NL91ABNA0417164300", bban: "ABNA0417164300", countryCode: "NL", countryName: "Netherlands", valid: true}
	 * ibantools.extractIBAN("NL91 ABNA 0417 1643 00");
	 * @alias module:ibantools.extractIBAN
	 * @param {string} IBAN IBAN
	 * @return {ExtractIBANResult} Object {iban: string, bban: string, countryCode: string, countryName: string, valid: boolean}
	 */
	function extractIBAN(iban) {
	    var result = {};
	    result.iban = iban;
	    if (isValidIBAN(iban)) {
	        result.bban = iban.slice(4);
	        result.countryCode = iban.slice(0, 2);
	        var spec = countrySpecs[result.countryCode];
	        result.countryName = spec.name;
	        result.valid = true;
	    }
	    else {
	        result.valid = false;
	    }
	    return result;
	}
	exports.extractIBAN = extractIBAN;
	/**
	 * Check BBAN format
	 * @param {string} BBAN
	 * @param {string} Regexp BBAN validation regexp
	 * @return {boolean} valid
	 */
	function checkFormatBBAN(bban, bformat) {
	    var reg = new RegExp(bformat, "");
	    return reg.test(bban);
	}
	/**
	 * Get IBAN in electronic format (no spaces)
	 * IBAN validation is not performed.
	 * When non-string value for IBAN is provided, returns null.
	 * @example
	 * // returns "NL91ABNA0417164300"
	 * ibantools.electronicFormatIBAN("NL91 ABNA 0417 1643 00");
	 * @alias module:ibantools.electronicFormatIBAN
	 * @param {string} IBAN IBAN
	 * @return {string} IBAN Electronic formated IBAN
	 */
	function electronicFormatIBAN(iban) {
	    if (typeof iban !== "string") {
	        return null;
	    }
	    return iban.replace(/[-\ ]/g, "").toUpperCase();
	}
	exports.electronicFormatIBAN = electronicFormatIBAN;
	/**
	 * Get IBAN in friendly format (separated after every 4 characters)
	 * IBAN validation is not performed.
	 * When non-string value for IBAN is provided, returns null.
	 * @example
	 * // returns "NL91 ABNA 0417 1643 00"
	 * ibantools.friendlyFormatIBAN("NL91ABNA0417164300");
	 * @example
	 * // returns "NL91-ABNA-0417-1643-00"
	 * ibantools.friendlyFormatIBAN("NL91ABNA0417164300","-");
	 * @alias module:ibantools.friendlyFormatIBAN
	 * @param {string} IBAN IBAN
	 * @param {string} separator Not required. Default separator is space " "
	 * @return {string} IBAN Friendly formated IBAN
	 */
	function friendlyFormatIBAN(iban, separator) {
	    if (typeof iban !== "string") {
	        return null;
	    }
	    if (typeof separator === "undefined") {
	        separator = " ";
	    }
	    return electronicFormatIBAN(iban).replace(/(.{4})(?!$)/g, "$1" + separator);
	}
	exports.friendlyFormatIBAN = friendlyFormatIBAN;
	/**
	 * Calculate checksum of IBAN and compares it with checksum provided in IBANregistry
	 * @param {string} IBAN
	 * @return {boolean}
	 */
	function isValidIBANChecksum(iban) {
	    var providedChecksum = parseInt(iban.slice(2, 4), 10);
	    var temp = iban.slice(3) + iban.slice(0, 2) + '00';
	    var validationString = "";
	    for (var n = 1; n < temp.length; n++) {
	        var c = temp.charCodeAt(n);
	        if (c >= 65) {
	            validationString += (c - 55).toString();
	        }
	        else {
	            validationString += temp[n];
	        }
	    }
	    while (validationString.length > 2) {
	        var part = validationString.slice(0, 6);
	        validationString = (parseInt(part, 10) % 97).toString() + validationString.slice(part.length);
	    }
	    var rest = parseInt(validationString, 10) % 97;
	    return (98 - rest) === providedChecksum;
	}
	/**
	 * MOD-97-10
	 * @param {string}
	 * @return {number}
	 */
	function mod9710(iban) {
	    iban = iban.slice(3) + iban.slice(0, 4);
	    var validationString = "";
	    for (var n = 1; n < iban.length; n++) {
	        var c = iban.charCodeAt(n);
	        if (c >= 65) {
	            validationString += (c - 55).toString();
	        }
	        else {
	            validationString += iban[n];
	        }
	    }
	    while (validationString.length > 2) {
	        var part = validationString.slice(0, 6);
	        validationString = (parseInt(part, 10) % 97).toString() + validationString.slice(part.length);
	    }
	    return parseInt(validationString, 10) % 97;
	}
	/**
	 * getCountrySpecifications
	 * Returns specifications for all countries, even those who are not
	 * members of IBAN registry. `IBANRegistry` field indicates if country
	 * is member of not.
	 * @example
	 * // Validating IBAN form field after user selects his country
	 * // <select id="countries">
	 * //   ...
	 * //   <option value="NL">Netherlands</option>
	 * //   ...
	 * // </select>
	 * $("#countries").select(function() {
	 *   // Find country
	 *   let country = ibantools.getCountrySpecifications()[$(this).val()];
	 *   // Add country code letters to IBAN form field
	 *   $("input#iban").value($(this).val());
	 *   // Add new value to "pattern" attribute to #iban input text field
	 *   $("input#iban").attr("pattern", $(this).val() + "[0-9]{2}" + country.bban_regexp.slice(1).replace("$",""));
	 * });
	 * @alias module:ibantools.getCountrySpecifications
	 * @return {CountryMap} Object [countryCode: string]CountrySpec -> {chars: :number, bban_regexp: string, name: string, IBANRegistry: boolean}
	 */
	function getCountrySpecifications() {
	    return countrySpecs;
	}
	exports.getCountrySpecifications = getCountrySpecifications;
	/**
	 * Validate BIC/SWIFT
	 * @example
	 * // returns true
	 * ibantools.isValidBIC("ABNANL2A");
	 * @example
	 * // returns true
	 * ibantools.isValidBIC("NEDSZAJJXXX");
	 * @example
	 * // returns false
	 * ibantools.isValidBIC("ABN4NL2A");
	 * @example
	 * // returns false
	 * ibantools.isValidBIC("ABNA NL 2A");
	 * @alias module:ibantools.isValidBIC
	 * @param {string} BIC BIC
	 * @return {boolean} valid
	 */
	function isValidBIC(bic) {
	    var reg = new RegExp("^[a-zA-Z]{6}[a-zA-Z0-9]{2}([a-zA-Z0-9]{3})?$", "");
	    var spec = countrySpecs[bic.toUpperCase().slice(4, 6)];
	    return reg.test(bic) && spec !== undefined;
	}
	exports.isValidBIC = isValidBIC;
	/**
	 * extractBIC
	 * @example
	 * // returns {bankCode: "ABNA", countryCode: "NL", countryName: "Netherlands", locationCode: "2A", branchCode: null, testBIC: flase, valid: true}
	 * ibantools.extractBIC("ABNANL2A");
	 * @alias module:ibantools.extractBIC
	 * @param {string} BIC BIC
	 * @return {ExtractBICResult} Object {bancCode: string, countryCode: string, countryName: string, locationCode: string, branchCode: string, testBIC: boolean, valid: boolean}
	 */
	function extractBIC(inputBic) {
	    var result = {};
	    var bic = inputBic.toUpperCase();
	    if (isValidBIC(bic)) {
	        result.bankCode = bic.slice(0, 4);
	        result.countryCode = bic.slice(4, 6);
	        var spec = countrySpecs[result.countryCode];
	        result.countryName = spec.name;
	        result.locationCode = bic.slice(6, 8);
	        result.testBIC = (result.locationCode[1] === "0" ? true : false);
	        result.branchCode = (bic.length > 8 ? bic.slice(8) : "619");
	        result.valid = true;
	    }
	    else {
	        result.valid = false;
	    }
	    return result;
	}
	exports.extractBIC = extractBIC;
	// Country specifications
	var countrySpecs = {
	    AD: { chars: 24, bban_regexp: "^[0-9]{8}[A-Z0-9]{12}$", name: "Andorra", IBANRegistry: true },
	    AE: { chars: 23, bban_regexp: "^[0-9]{3}[0-9]{16}$", name: "United Arab Emirates", IBANRegistry: true },
	    AF: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Afganistan" },
	    AG: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Antigua and Bermuda" },
	    AI: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Anguilla" },
	    AL: { chars: 28, bban_regexp: "^[0-9]{8}[A-Z0-9]{16}$", name: "Albania", IBANRegistry: true },
	    AM: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Armenia" },
	    AO: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Angola" },
	    AQ: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Antartica" },
	    AR: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Argentina" },
	    AS: { chars: null, bban_regexp: null, IBANRegistry: false, name: "American Samoa" },
	    AT: { chars: 20, bban_regexp: "^[0-9]{16}$", name: "Austria", IBANRegistry: true },
	    AU: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Australia" },
	    AW: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Aruba" },
	    AX: { chars: 18, bban_regexp: "^[0-9]{14}$", name: "Åland Islands", IBANRegistry: true },
	    AZ: { chars: 28, bban_regexp: "^[A-Z]{4}[0-9]{20}$", name: "Republic of Azerbaijan", IBANRegistry: true },
	    BA: { chars: 20, bban_regexp: "^[0-9]{16}$", name: "Bosnia and Herzegovina", IBANRegistry: true },
	    BB: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Barbados" },
	    BD: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Bangladesh" },
	    BE: { chars: 16, bban_regexp: "^[0-9]{12}$", name: "Belgium", IBANRegistry: true },
	    BF: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Burkina Faso" },
	    BG: { chars: 22, bban_regexp: "^[A-Z]{4}[0-9]{6}[A-Z0-9]{8}$", name: "Bulgaria", IBANRegistry: true },
	    BH: { chars: 22, bban_regexp: "^[A-Z]{4}[A-Z0-9]{14}$", name: "Bahrain", IBANRegistry: true },
	    BI: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Burundi" },
	    BJ: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Benin" },
	    BL: { chars: 27, bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$", name: "Saint Barthelemy", IBANRegistry: true },
	    BM: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Bermuda" },
	    BN: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Brunei Darusslam" },
	    BO: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Bolivia, Plurinational State of" },
	    BQ: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Bonaire, Sint Eustatius and Saba" },
	    BR: { chars: 29, bban_regexp: "^[0-9]{23}[A-Z]{1}[A-Z0-9]{1}$", name: "Brazil", IBANRegistry: true },
	    BS: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Bahamas" },
	    BT: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Bhutan" },
	    BV: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Bouvet Island" },
	    BW: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Botswana" },
	    BY: { chars: 28, bban_regexp: "^[A-Z]{4}[0-9]{4}[A-Z0-9]{16}$", name: "Republic of Belarus", IBANRegistry: true },
	    BZ: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Belize" },
	    CA: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Canada" },
	    CC: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Cocos (Keeling) Islands" },
	    CD: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Congo, the Democratic Republic of the" },
	    CF: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Central African Republic" },
	    CG: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Congo" },
	    CH: { chars: 21, bban_regexp: "^[0-9]{5}[A-Z0-9]{12}$", name: "Switzerland", IBANRegistry: true },
	    CI: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Côte d'Ivoire" },
	    CK: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Cook Islands" },
	    CL: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Chile" },
	    CM: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Cameroon" },
	    CN: { chars: null, bban_regexp: null, IBANRegistry: false, name: "China" },
	    CO: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Columbia" },
	    CR: { chars: 22, bban_regexp: "^[0-9]{18}$", name: "Costa Rica", IBANRegistry: true },
	    CU: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Cuba" },
	    CV: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Cabo Verde" },
	    CW: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Curaçao" },
	    CX: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Christmas Island" },
	    CY: { chars: 28, bban_regexp: "^[0-9]{8}[A-Z0-9]{16}$", name: "Cyprus", IBANRegistry: true },
	    CZ: { chars: 24, bban_regexp: "^[0-9]{20}$", name: "Czech Republic", IBANRegistry: true },
	    DE: { chars: 22, bban_regexp: "^[0-9]{18}$", name: "Germany", IBANRegistry: true },
	    DJ: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Djibouti" },
	    DK: { chars: 18, bban_regexp: "^[0-9]{14}$", name: "Denmark", IBANRegistry: true },
	    DM: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Dominica" },
	    DO: { chars: 28, bban_regexp: "^[A-Z]{4}[0-9]{20}$", name: "Dominican Republic", IBANRegistry: true },
	    DZ: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Algeria" },
	    EC: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Ecuador" },
	    EE: { chars: 20, bban_regexp: "^[0-9]{16}$", name: "Estonia", IBANRegistry: true },
	    EG: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Egypt" },
	    EH: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Western Sahara" },
	    ER: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Eritrea" },
	    ES: { chars: 24, bban_regexp: "^[0-9]{20}$", name: "Spain", IBANRegistry: true },
	    ET: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Ethiopia" },
	    FI: { chars: 18, bban_regexp: "^[0-9]{14}$", name: "Finland", IBANRegistry: true },
	    FJ: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Fiji" },
	    FK: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Falkland Islands (Malvinas)" },
	    FM: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Micronesia, Federated States of" },
	    FO: { chars: 18, bban_regexp: "^[0-9]{14}$", name: "Faroe Islands (Denmark)", IBANRegistry: true },
	    FR: { chars: 27, bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$", name: "France", IBANRegistry: true },
	    GA: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Gabon" },
	    GB: { chars: 22, bban_regexp: "^[A-Z]{4}[0-9]{14}$", name: "United Kingdom", IBANRegistry: true },
	    GD: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Grenada" },
	    GE: { chars: 22, bban_regexp: "^[A-Z0-9]{2}[0-9]{16}$", name: "Georgia", IBANRegistry: true },
	    GF: { chars: 27, bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$", name: "French Guyana", IBANRegistry: true },
	    GG: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Guernsey" },
	    GH: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Ghana" },
	    GI: { chars: 23, bban_regexp: "^[A-Z]{4}[A-Z0-9]{15}$", name: "Gibraltar", IBANRegistry: true },
	    GL: { chars: 18, bban_regexp: "^[0-9]{14}$", name: "Greenland", IBANRegistry: true },
	    GM: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Gambia" },
	    GN: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Guinea" },
	    GP: { chars: 27, bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$", name: "Guadeloupe", IBANRegistry: true },
	    GQ: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Equatorial Guinea" },
	    GR: { chars: 27, bban_regexp: "^[0-9]{7}[A-Z0-9]{16}$", name: "Greece", IBANRegistry: true },
	    GS: { chars: null, bban_regexp: null, IBANRegistry: false, name: "South Georgia and the South Sandwitch Islands" },
	    GT: { chars: 28, bban_regexp: "^[A-Z0-9]{24}$", name: "Guatemala", IBANRegistry: true },
	    GU: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Guam" },
	    GW: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Guinea-Bissau" },
	    GY: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Guyana" },
	    HK: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Hong Kong" },
	    HM: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Heard Island and McDonald Islands" },
	    HN: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Honduras" },
	    HR: { chars: 21, bban_regexp: "^[0-9]{17}$", name: "Croatia", IBANRegistry: true },
	    HT: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Haiti" },
	    HU: { chars: 28, bban_regexp: "^[0-9]{24}$", name: "Hungary", IBANRegistry: true },
	    ID: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Indonesia" },
	    IE: { chars: 22, bban_regexp: "^[A-Z0-9]{4}[0-9]{14}$", name: "Republic of Ireland", IBANRegistry: true },
	    IL: { chars: 23, bban_regexp: "^[0-9]{19}$", name: "Israel", IBANRegistry: true },
	    IM: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Isle of Man" },
	    IN: { chars: null, bban_regexp: null, IBANRegistry: false, name: "India" },
	    IO: { chars: null, bban_regexp: null, IBANRegistry: false, name: "British Indian Ocean Territory" },
	    IQ: { chars: 23, bban_regexp: "^[A-Z]{4}[0-9]{15}$", name: "Iraq", IBANRegistry: true },
	    IR: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Iran, Islamic Republic of" },
	    IS: { chars: 26, bban_regexp: "^[0-9]{22}$", name: "Iceland", IBANRegistry: true },
	    IT: { chars: 27, bban_regexp: "^[A-Z]{1}[0-9]{10}[A-Z0-9]{12}$", name: "Italy", IBANRegistry: true },
	    JE: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Jersey" },
	    JM: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Jamaica" },
	    JO: { chars: 30, bban_regexp: "^[A-Z]{4}[0-9]{4}[A-Z0-9]{18}$", name: "Jordan", IBANRegistry: true },
	    JP: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Japan" },
	    KE: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Kenya" },
	    KG: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Kyrgyzstan" },
	    KH: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Cambodia" },
	    KI: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Kiribati" },
	    KM: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Comoros" },
	    KN: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Saint Kitts and Nevis" },
	    KP: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Korea, Domocratic People's Republic of" },
	    KR: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Korea, Republic of" },
	    KW: { chars: 30, bban_regexp: "^[A-Z]{4}[A-Z0-9]{22}$", name: "Kuwait", IBANRegistry: true },
	    KY: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Cayman Islands" },
	    KZ: { chars: 20, bban_regexp: "^[0-9]{3}[A-Z0-9]{13}$", name: "Kazakhstan", IBANRegistry: true },
	    LA: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Lao People's Democratic Republic" },
	    LB: { chars: 28, bban_regexp: "^[0-9]{4}[A-Z0-9]{20}$", name: "Lebanon", IBANRegistry: true },
	    LC: { chars: 32, bban_regexp: "^[A-Z]{4}[A-Z0-9]{24}$", name: "Saint Lucia", IBANRegistry: true },
	    LI: { chars: 21, bban_regexp: "^[0-9]{5}[A-Z0-9]{12}$", name: "Liechtenstein", IBANRegistry: true },
	    LK: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Sri Lanka" },
	    LR: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Liberia" },
	    LS: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Lesotho" },
	    LT: { chars: 20, bban_regexp: "^[0-9]{16}$", name: "Lithuania", IBANRegistry: true },
	    LU: { chars: 20, bban_regexp: "^[0-9]{3}[A-Z0-9]{13}$", name: "Luxembourg", IBANRegistry: true },
	    LV: { chars: 21, bban_regexp: "^[A-Z]{4}[A-Z0-9]{13}$", name: "Latvia", IBANRegistry: true },
	    LY: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Libya" },
	    MA: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Marocco" },
	    MC: { chars: 27, bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$", name: "Monaco", IBANRegistry: true },
	    MD: { chars: 24, bban_regexp: "^[A-Z0-9]{2}[A-Z0-9]{18}$", name: "Moldova", IBANRegistry: true },
	    ME: { chars: 22, bban_regexp: "^[0-9]{18}$", name: "Montenegro", IBANRegistry: true },
	    MF: { chars: 27, bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$", name: "Saint Martin", IBANRegistry: true },
	    MG: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Madagascar" },
	    MH: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Marshall Islands" },
	    MK: { chars: 19, bban_regexp: "^[0-9]{3}[A-Z0-9]{10}[0-9]{2}$", name: "Macedonia, the former Yugoslav Republic of", IBANRegistry: true },
	    ML: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Mali" },
	    MM: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Myanman" },
	    MN: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Mongolia" },
	    MO: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Macao" },
	    MP: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Northern mariana Islands" },
	    MQ: { chars: 27, bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$", name: "Martinique", IBANRegistry: true },
	    MR: { chars: 27, bban_regexp: "^[0-9]{23}$", name: "Mauritania", IBANRegistry: true },
	    MS: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Montserrat" },
	    MT: { chars: 31, bban_regexp: "^[A-Z]{4}[0-9]{5}[A-Z0-9]{18}$", name: "Malta", IBANRegistry: true },
	    MU: { chars: 30, bban_regexp: "^[A-Z]{4}[0-9]{19}[A-Z]{3}$", name: "Mauritius", IBANRegistry: true },
	    MV: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Maldives" },
	    MW: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Malawi" },
	    MX: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Mexico" },
	    MY: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Malaysia" },
	    MZ: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Mozambique" },
	    NA: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Namibia" },
	    NC: { chars: 27, bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$", name: "New Caledonia", IBANRegistry: true },
	    NE: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Niger" },
	    NF: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Norfolk Island" },
	    NG: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Nigeria" },
	    NI: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Nicaraqua" },
	    NL: { chars: 18, bban_regexp: "^[A-Z]{4}[0-9]{10}$", name: "Netherlands", IBANRegistry: true },
	    NO: { chars: 15, bban_regexp: "^[0-9]{11}$", name: "Norway", IBANRegistry: true },
	    NP: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Nepal" },
	    NR: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Nauru" },
	    NU: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Niue" },
	    NZ: { chars: null, bban_regexp: null, IBANRegistry: false, name: "New Zealand" },
	    OM: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Oman" },
	    PA: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Panama" },
	    PE: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Peru" },
	    PF: { chars: 27, bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$", name: "French Polynesia", IBANRegistry: true },
	    PG: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Papua New Guinea" },
	    PH: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Philippines" },
	    PK: { chars: 24, bban_regexp: "^[A-Z0-9]{4}[0-9]{16}$", name: "Pakistan", IBANRegistry: true },
	    PL: { chars: 28, bban_regexp: "^[0-9]{24}$", name: "Poland", IBANRegistry: true },
	    PM: { chars: 27, bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$", name: "Saint Pierre et Miquelon", IBANRegistry: true },
	    PN: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Pitcairn" },
	    PR: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Puerto Rico" },
	    PS: { chars: 29, bban_regexp: "^[A-Z0-9]{4}[0-9]{21}$", name: "Palestine, State of", IBANRegistry: true },
	    PT: { chars: 25, bban_regexp: "^[0-9]{21}$", name: "Portugal", IBANRegistry: true },
	    PW: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Palau" },
	    PY: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Paraguay" },
	    QA: { chars: 29, bban_regexp: "^[A-Z]{4}[A-Z0-9]{21}$", name: "Qatar", IBANRegistry: true },
	    RE: { chars: 27, bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$", name: "Reunion", IBANRegistry: true },
	    RO: { chars: 24, bban_regexp: "^[A-Z]{4}[A-Z0-9]{16}$", name: "Romania", IBANRegistry: true },
	    RS: { chars: 22, bban_regexp: "^[0-9]{18}$", name: "Serbia", IBANRegistry: true },
	    RU: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Russian Federation" },
	    RW: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Rwanda" },
	    SA: { chars: 24, bban_regexp: "^[0-9]{2}[A-Z0-9]{18}$", name: "Saudi Arabia", IBANRegistry: true },
	    SB: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Solomon Islands" },
	    SC: { chars: 31, bban_regexp: "^[[A-Z]{4}[]0-9]{20}[A-Z]{3}$", name: "Seychelles", IBANRegistry: true },
	    SD: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Sudan" },
	    SE: { chars: 24, bban_regexp: "^[0-9]{20}$", name: "Sweden", IBANRegistry: true },
	    SG: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Singapore" },
	    SH: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Saint Helena, Ascension and Tristan da Cunha" },
	    SI: { chars: 19, bban_regexp: "^[0-9]{15}$", name: "Slovenia", IBANRegistry: true },
	    SJ: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Svalbard and Jan Mayen" },
	    SK: { chars: 24, bban_regexp: "^[0-9]{20}$", name: "Slovak Republic", IBANRegistry: true },
	    SL: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Siera Leone" },
	    SM: { chars: 27, bban_regexp: "^[A-Z]{1}[0-9]{10}[A-Z0-9]{12}$", name: "San Marino", IBANRegistry: true },
	    SN: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Senegal" },
	    SO: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Somalia" },
	    SR: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Suriname" },
	    SS: { chars: null, bban_regexp: null, IBANRegistry: false, name: "South Sudan" },
	    ST: { chars: 25, bban_regexp: "^[0-9]{21}$", name: "Sao Tome And Principe", IBANRegistry: true },
	    SV: { chars: 28, bban_regexp: "^[A-Z]{4}[0-9]{20}$", name: "El Salvador", IBANRegistry: true },
	    SX: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Sint Maarten (Dutch part)" },
	    SY: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Syrian Arab Republic" },
	    SZ: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Swaziland" },
	    TC: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Turks and Caicos Islands" },
	    TD: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Chad" },
	    TF: { chars: 27, bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$", name: "French Southern Territories", IBANRegistry: true },
	    TG: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Togo" },
	    TH: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Thailand" },
	    TJ: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Tajikistan" },
	    TK: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Tokelau" },
	    TL: { chars: 23, bban_regexp: "^[0-9]{19}$", name: "Timor-Leste", IBANRegistry: true },
	    TM: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Turkmenistan" },
	    TN: { chars: 24, bban_regexp: "^[0-9]{20}$", name: "Tunisia", IBANRegistry: true },
	    TO: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Tonga" },
	    TR: { chars: 26, bban_regexp: "^[0-9]{5}[A-Z0-9]{17}$", name: "Turkey", IBANRegistry: true },
	    TT: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Trinidad and Tobago" },
	    TV: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Tuvalu" },
	    TW: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Taiwan, Province of China" },
	    TZ: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Tanzania, United republic of" },
	    UA: { chars: 29, bban_regexp: "^[0-9]{6}[A-Z0-9]{19}$", name: "Ukraine", IBANRegistry: true },
	    UG: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Uganda" },
	    UM: { chars: null, bban_regexp: null, IBANRegistry: false, name: "United States Minor Outlying Islands" },
	    US: { chars: null, bban_regexp: null, IBANRegistry: false, name: "United States of America" },
	    UY: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Uruguay" },
	    UZ: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Uzbekistan" },
	    VA: { chars: 22, bban_regexp: "^[0-9]{18}", IBANRegistry: true, name: "Vatican City State" },
	    VC: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Saint Vincent and the Granadines" },
	    VE: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Venezuela, Bolivian Republic of" },
	    VG: { chars: 24, bban_regexp: "^[A-Z0-9]{4}[0-9]{16}$", name: "Virgin Islands, British", IBANRegistry: true },
	    VI: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Virgin Islands, U.S." },
	    VN: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Viet Nam" },
	    VU: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Vanautu" },
	    WF: { chars: 27, bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$", name: "Wallis and Futuna", IBANRegistry: true },
	    WS: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Samoa" },
	    XK: { chars: 20, bban_regexp: "^[0-9]{16}$", name: "Kosovo", IBANRegistry: true },
	    YE: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Yemen" },
	    YT: { chars: 27, bban_regexp: "^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$", name: "Mayotte", IBANRegistry: true },
	    ZA: { chars: null, bban_regexp: null, IBANRegistry: false, name: "South Africa" },
	    ZM: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Zambia" },
	    ZW: { chars: null, bban_regexp: null, IBANRegistry: false, name: "Zimbabwe" },
	};


/***/ }),
/* 830 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function maxValueValidator(max) {
	    return function (c) {
	        var isValid = (c.value == null || c.value.length === 0) || c.value <= max;
	        if (!isValid) {
	            return { 'maxValue': { max: max } };
	        }
	        else {
	            return null;
	        }
	    };
	}
	exports.maxValueValidator = maxValueValidator;
	function maxFieldSizeValidator(max) {
	    return function (c) {
	        var isValid = c.value == null || c.value.length <= max();
	        if (!isValid) {
	            return { maxlength: false };
	        }
	        else {
	            return null;
	        }
	    };
	}
	exports.maxFieldSizeValidator = maxFieldSizeValidator;


/***/ }),
/* 831 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function minValueValidator(min) {
	    return function (c) {
	        var isValid = (c.value == null || c.value.length === 0) || c.value >= min;
	        if (!isValid) {
	            return { 'minValue': { min: min } };
	        }
	        else {
	            return null;
	        }
	    };
	}
	exports.minValueValidator = minValueValidator;
	function minFieldSizeValidator(min) {
	    return function (c) {
	        var isValid = c.value == null || c.value.length >= min();
	        if (!isValid) {
	            return { minlength: false };
	        }
	        else {
	            return null;
	        }
	    };
	}
	exports.minFieldSizeValidator = minFieldSizeValidator;


/***/ }),
/* 832 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function lazyload(url) {
	    // based on https://friendlybit.com/js/lazy-loading-asyncronous-javascript/
	    var scripts = document.getElementsByTagName('script');
	    for (var i = scripts.length; i--;) {
	        if (scripts[i].src.match(url))
	            return true;
	    }
	    var s = document.createElement('script');
	    s.type = 'text/javascript';
	    s.async = true;
	    s.src = url;
	    var x = document.getElementsByTagName('script')[0];
	    x.parentNode.insertBefore(s, x);
	    return true;
	}
	exports.lazyload = lazyload;
	function whenDefined(context, variable, callback) {
	    var _this = this;
	    if (!!context[variable]) {
	        callback();
	    }
	    else {
	        Object.defineProperty(context, variable, {
	            configurable: true,
	            enumerable: true,
	            get: function () { return _this["_" + variable]; },
	            set: function (v) {
	                _this["_" + variable] = v;
	                callback();
	            }
	        });
	    }
	}
	exports.whenDefined = whenDefined;


/***/ }),
/* 833 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var FileUtils = (function () {
	    function FileUtils() {
	    }
	    FileUtils.saveFile = function (filename, body) {
	        var blobURL = window.URL.createObjectURL(body);
	        var anchor = document.createElement('a');
	        anchor.download = filename;
	        anchor.href = blobURL;
	        document.body.appendChild(anchor);
	        anchor.click();
	        document.body.removeChild(anchor);
	        setTimeout(function () {
	            window.URL.revokeObjectURL(blobURL);
	        }, 100);
	    };
	    FileUtils.getFilename = function (response) {
	        var contentDisposition = response.headers.get('content-disposition');
	        return contentDisposition.split(';')[1].trim().split('=')[1].replace(/"/g, '');
	    };
	    return FileUtils;
	}());
	exports.FileUtils = FileUtils;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var browser = __webpack_require__(747);
	var OSUtils = (function () {
	    function OSUtils() {
	    }
	    OSUtils.isMobile = function () {
	        return browser.os === OSUtils.IOS
	            || browser.os === OSUtils.ANDROID
	            || browser.os === OSUtils.BLACKBERRY
	            || browser.os === OSUtils.WIN_MOBILE;
	    };
	    OSUtils.IOS = "iOS";
	    OSUtils.ANDROID = "Android OS";
	    OSUtils.BLACKBERRY = "BlackBerry OS";
	    OSUtils.WIN_MOBILE = "Windows Mobile";
	    OSUtils.AMAZON_OS = "Amazon OS";
	    OSUtils.WIN_3_11 = "Windows 3.11";
	    OSUtils.WIN_95 = "Windows 95";
	    OSUtils.WIN_98 = "Windows 98";
	    OSUtils.WIN_2000 = "Windows 2000";
	    OSUtils.WIN_XP = "Windows XP";
	    OSUtils.WIN_SERVER_2003 = "Windows Server 2003";
	    OSUtils.WIN_VISTA = "Windows Vista";
	    OSUtils.WIN_7 = "Windows 7";
	    OSUtils.WIN_8 = "Windows 8";
	    OSUtils.WIN_8_1 = "Windows 8.1";
	    OSUtils.WIN_10 = "Windows 10";
	    OSUtils.WIN_ME = "Windows ME";
	    OSUtils.OPEN_BSD = "Open BSD";
	    OSUtils.SUN_OS = "Sun OS";
	    OSUtils.LINUX = "Linux";
	    OSUtils.MAC_OS = "Mac OS";
	    OSUtils.QNX = "QNX";
	    OSUtils.BeOS = "BeOS";
	    OSUtils.OS_2 = "OS/2";
	    OSUtils.SEARCH_BOT = "Search Bot";
	    return OSUtils;
	}());
	exports.OSUtils = OSUtils;


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var http_1 = __webpack_require__(836);
	var util_1 = __webpack_require__(743);
	var URLSearchParamsBuilder = (function () {
	    function URLSearchParamsBuilder() {
	        this.search = new http_1.URLSearchParams();
	    }
	    URLSearchParamsBuilder.prototype.append = function (name, value) {
	        if (!util_1.isNullOrUndefined(name) && !util_1.isNullOrUndefined(value)) {
	            this.search.append(name, String(value));
	        }
	        return this;
	    };
	    URLSearchParamsBuilder.prototype.toSearch = function () {
	        return this.search;
	    };
	    return URLSearchParamsBuilder;
	}());
	var HttpUtils = (function () {
	    function HttpUtils() {
	    }
	    HttpUtils.searchParams = function () {
	        return new URLSearchParamsBuilder();
	    };
	    return HttpUtils;
	}());
	exports.HttpUtils = HttpUtils;


/***/ }),
/* 836 */,
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(743);
	var lodash_1 = __webpack_require__(268);
	var moment = __webpack_require__(838);
	var DateUtils = (function () {
	    function DateUtils() {
	    }
	    DateUtils.isDateNearOffset = function (control, offsetMoment) {
	        var valueDate = control && control.value;
	        if (util_1.isNullOrUndefined(valueDate) || lodash_1.isEmpty(valueDate)) {
	            return false;
	        }
	        if (!moment(valueDate, DateUtils.INNER_DATE_FORMAT, true).isValid()) {
	            return false;
	        }
	        var offsetDate = offsetMoment().toDate();
	        return moment(valueDate, DateUtils.INNER_DATE_FORMAT).toDate() <= offsetDate;
	    };
	    DateUtils.isDateNearestOffset = function (control, offset, offsetUnit) {
	        return DateUtils.isDateNearOffset(control, function () { return moment().add(offset, offsetUnit); });
	    };
	    DateUtils.now = function () {
	        return moment();
	    };
	    DateUtils.future = function () {
	        return moment().add(100, 'years');
	    };
	    DateUtils.yearsBefore = function (yearsBefore) {
	        return moment().subtract(yearsBefore, 'years');
	    };
	    DateUtils.past = function () {
	        return moment().subtract(100, 'years');
	    };
	    DateUtils.maxDateOfBirth = function () {
	        return moment().subtract(18, 'years');
	    };
	    DateUtils.INNER_DATE_FORMAT = 'DD.MM.YYYY';
	    return DateUtils;
	}());
	exports.DateUtils = DateUtils;


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key;
	                for (i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i;
	            for (i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
	                    matched,
	                    p1,
	                    p2,
	                    p3,
	                    p4
	                ) {
	                    return p1 || p2 || p3 || p4;
	                })
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
	            '_'
	        ),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(839)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^)]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
	        input,
	        array,
	        config,
	        token
	    ) {
	        var era = config._locale.erasParse(input, token, config._strict);
	        if (era) {
	            getParsingFlags(config).era = era;
	        } else {
	            getParsingFlags(config).invalidEra = input;
	        }
	    });
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(269)(module)))

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./en-au": 840,
		"./en-au.js": 840,
		"./en-ca": 841,
		"./en-ca.js": 841,
		"./en-gb": 842,
		"./en-gb.js": 842,
		"./en-ie": 843,
		"./en-ie.js": 843,
		"./en-il": 844,
		"./en-il.js": 844,
		"./en-in": 845,
		"./en-in.js": 845,
		"./en-nz": 846,
		"./en-nz.js": 846,
		"./en-sg": 847,
		"./en-sg.js": 847
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 839;


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(838)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(838)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(838)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(838)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(838)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(838)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(838)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(838)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var MemoryStorage = __webpack_require__(849);
	var StorageHolder = (function () {
	    function StorageHolder() {
	    }
	    Object.defineProperty(StorageHolder, "localStorage", {
	        get: function () {
	            return StorageHolder._localStorage;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    StorageHolder.createStorage = function () {
	        return new MemoryStorage();
	    };
	    StorageHolder._init = (function () {
	        try {
	            StorageHolder._localStorage = window.localStorage;
	            var test = 'test_localstorage_available_' + Date.now();
	            StorageHolder._localStorage.setItem(test, test);
	            var actual = StorageHolder._localStorage.getItem(test);
	            StorageHolder._localStorage.removeItem(test);
	            if (test !== actual) {
	                StorageHolder._localStorage = StorageHolder.createStorage();
	            }
	        }
	        catch (e) {
	            StorageHolder._localStorage = StorageHolder.createStorage();
	        }
	    })();
	    return StorageHolder;
	}());
	exports.StorageHolder = StorageHolder;


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (u, m, d) {
		if (true) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return (d());}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}
		else if (typeof exports === 'object') {module.exports = d();}
		else {u[m] = d();}
	}(this, 'MemoryStorage', function() {'use strict';
	
	/*! memorystorage.js - A memory-backed implementation of the Web Storage API.
	 *
	 * @copyright Copyright 2016 by Stijn de Witt and contributors. Some rights reserved.
	 * @license Licensed under [Creative Commons Attribution 4.0 International (CC BY 4.0)](https://creativecommons.org/licenses/by/4.0/).
	 */
	
	/**
	 * Creates a new MemoryStorage object implementing the <a href="http://www.w3.org/TR/webstorage/">Web Storage API</a> using memory.
	 *
	 * <p>If no arguments are given, the created memory storage object will read from and write to the
	 * <code>global</code> memory storage. If a string argument is given, the new storage object
	 * will read from and write to it's own segment of memory. Any data written to such a memory
	 * storage object will only show up in other memory storage objects that have been created with
	 * the same id. This data will not show up in the <code>global</code> memory space. As such it
	 * is recommended to always construct a memory storage object with a unique string id as argument.</p>
	 *
	 * @param id Optional string argument used to isolate this memory storage object from others.
	 */
	function MemoryStorage(id) {
		// make sure id is assigned
		id = id || 'global'
		// try to get existing store
		var result = storage[id]
		// return it if found
		if (result) {return result}
	
		// make sure there is no harm in leaving out new in invocations to MemoryStorage
		if (! (this instanceof MemoryStorage)) {return new MemoryStorage(id);}
	
		// create a new store and save a ref to it so we can get it back later
		result = storage[id] = this;
		// create a space to store 'cloaked' key/values: items that have a key
		// that collides with Web Storage API method names.
		var cloak = {};
	
		// Allow client code to read the id
		Object.defineProperty(result, 'id', {enumerable:true, configurable:true, value:id})
	
		// Create the length property
		Object.defineProperty(result, 'length', {enumerable:true, configurable:true, get:function(){
			return enumerableKeys().length
		}})
	
		// Create API methods
		result.getItem = function MemoryStorage_getItem(key) {
			return (key in API ? cloak[key] : this[key]) || null
		}
		result.setItem = function MemoryStorage_setItem(key, val) {
			key in API ? cloak[key] = val : this[key] = val
		}
		result.removeItem = function MemoryStorage_removeItem(key) {
			key in API ? delete cloak[key] : delete this[key]
		}
		result.key = function MemoryStorage_key(idx) {
			var keys = enumerableKeys()
			return idx >= 0 && idx < keys.length ? keys[idx] : null
		}
		result.clear = function MemoryStorage_clear() {
			var keys = uncloakedKeys()
			for (var i=0,key; key=keys[i]; i++) {
				delete this[key]
			}
			keys = cloakedKeys()
			for (var i=0,key; key=keys[i]; i++) {
				delete cloak[key]
			}
		}
	
		// Wrap in ES6 Proxy if available to support Object.keys() on a MemoryStorage object
		return typeof Proxy === 'undefined' ? result : new Proxy(result, {ownKeys: function() {return enumerableKeys()}})
	
		// helper functions
		function uncloakedKeys() {return Object.keys(result).filter(function(x){return !(x in API)})}
		function cloakedKeys() {return Object.keys(cloak)}
		function enumerableKeys(){return uncloakedKeys().concat(cloakedKeys())}
	}
	
	// API methods and properties will be cloaked
	var API = {clear:1, getItem:1, id:1, key:1, length:1, removeItem:1, setItem:1}
	
	// Used to store all memorystorage objects
	var storage = {};
	
	
	return MemoryStorage;
	}));


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var router_1 = __webpack_require__(270);
	var core_1 = __webpack_require__(205);
	var cookies_1 = __webpack_require__(738);
	var StorageHolder_1 = __webpack_require__(848);
	var role_service_1 = __webpack_require__(851);
	var SessionService = (function () {
	    function SessionService(_router, roleService) {
	        this._router = _router;
	        this.roleService = roleService;
	    }
	    SessionService_1 = SessionService;
	    SessionService.prototype.login = function (session) {
	        cookies_1.CookiesManager.setToken(session.token, session.expires);
	        if (cookies_1.CookiesManager.isDestinationURLExists()) {
	            var target = cookies_1.CookiesManager.getDestinationURL();
	            cookies_1.CookiesManager.clearDestinationURL();
	            this._router.navigateByUrl(target);
	        }
	        else {
	            this._router.navigate(['space']);
	        }
	    };
	    SessionService.prototype.logout = function () {
	        this.closeSession(SessionService_1.SESSION_LOGOUT);
	    };
	    SessionService.prototype.expire = function () {
	        this.closeSession(SessionService_1.SESSION_EXPIRED);
	    };
	    SessionService.prototype.setSessionCloseAsExpire = function () {
	        if (!this.isSessionClosedBy(SessionService_1.SESSION_LOGOUT)) {
	            this.setSessionCloseAs(SessionService_1.SESSION_EXPIRED);
	        }
	    };
	    SessionService.prototype.isSessionLogout = function () {
	        return this.isSessionClosedBy(SessionService_1.SESSION_LOGOUT);
	    };
	    SessionService.prototype.isSessionExpired = function () {
	        return this.isSessionClosedBy(SessionService_1.SESSION_EXPIRED);
	    };
	    SessionService.prototype.clearSessionCloseReason = function () {
	        this.removeReason(SessionService_1.SESSION_LOGOUT);
	        this.removeReason(SessionService_1.SESSION_EXPIRED);
	    };
	    SessionService.prototype.closeSession = function (key) {
	        this.setSessionCloseAs(key);
	        cookies_1.CookiesManager.clearToken();
	        this.roleService.resetPermissions();
	        window.location.reload();
	    };
	    SessionService.prototype.setSessionCloseAs = function (key) {
	        StorageHolder_1.StorageHolder.localStorage.setItem(key, JSON.stringify(true));
	    };
	    SessionService.prototype.isSessionClosedBy = function (key) {
	        return JSON.parse(StorageHolder_1.StorageHolder.localStorage.getItem(key));
	    };
	    SessionService.prototype.removeReason = function (key) {
	        StorageHolder_1.StorageHolder.localStorage.removeItem(key);
	    };
	    SessionService.SESSION_LOGOUT = 'SESSION_LOGOUT';
	    SessionService.SESSION_EXPIRED = 'SESSION_EXPIRED';
	    SessionService = SessionService_1 = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [router_1.Router, role_service_1.RoleService])
	    ], SessionService);
	    return SessionService;
	    var SessionService_1;
	}());
	exports.SessionService = SessionService;


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var util_1 = __webpack_require__(743);
	var router_1 = __webpack_require__(270);
	var http_1 = __webpack_require__(852);
	var store_service_1 = __webpack_require__(854);
	var notification_1 = __webpack_require__(264);
	var operators_1 = __webpack_require__(680);
	var Roles;
	(function (Roles) {
	    Roles[Roles["VIEW"] = 0] = "VIEW";
	    Roles[Roles["EDIT"] = 1] = "EDIT";
	})(Roles = exports.Roles || (exports.Roles = {}));
	var RoleService = (function () {
	    function RoleService(router, http, _notificationManager) {
	        this.router = router;
	        this.http = http;
	        this._notificationManager = _notificationManager;
	        this.permissions = [];
	    }
	    RoleService_1 = RoleService;
	    RoleService.prototype.getPermissions = function () {
	        if (this.permissions.length <= 0) {
	            this.permissions = store_service_1.StoreService.getInstance().getValue(RoleService_1.PERMISSIONS);
	        }
	        return this.permissions;
	    };
	    RoleService.prototype.hasElementRoles = function (role, element, route) {
	        if (util_1.isNullOrUndefined(role) || util_1.isNullOrUndefined(element)) {
	            return false;
	        }
	        if (util_1.isNullOrUndefined(route)) {
	            route = this.router.url;
	        }
	        var p = this.getPermission(route);
	        return p.elements.filter(function (el) { return el.id == element && RoleService_1.getRoleFromValue(el.role) == role; }).length > 0;
	    };
	    RoleService.prototype.hasRoles = function (roles, route) {
	        var _this = this;
	        if (util_1.isNullOrUndefined(roles)) {
	            return false;
	        }
	        if (util_1.isNullOrUndefined(route)) {
	            route = this.router.url;
	        }
	        if (Array.isArray(roles)) {
	            return roles.some(function (role) { return _this.hasRole(role, route); });
	        }
	        else {
	            return this.hasRole(roles, route);
	        }
	    };
	    RoleService.prototype.hasAccess = function (route) {
	        if (util_1.isNullOrUndefined(route)) {
	            return false;
	        }
	        var permission = this.getPermission(route);
	        return !util_1.isNullOrUndefined(permission) && !util_1.isNullOrUndefined(permission.role);
	    };
	    /**
	     * Like hasRoles/hasAccess, but against the permission of exactly this menu route (e.g.
	     * '/space/customers/profiles/registered/:id/users'). getPermission() takes the first permission whose route
	     * is a prefix of the URL, so '/space/customers/profiles/registered' (EDIT) wins over a tab granted VIEW only.
	     */
	    RoleService.prototype.hasExactRouteRoles = function (roles, permissionRoute) {
	        if (util_1.isNullOrUndefined(roles)) {
	            return false;
	        }
	        var permission = this.getExactPermission(permissionRoute);
	        if (util_1.isNullOrUndefined(permission) || util_1.isNullOrUndefined(permission.role)) {
	            return false;
	        }
	        var required = Array.isArray(roles) ? roles : [roles];
	        return required.some(function (role) { return permission.role >= RoleService_1.getRoleFromValue(role); });
	    };
	    RoleService.prototype.hasExactRouteAccess = function (permissionRoute) {
	        var permission = this.getExactPermission(permissionRoute);
	        return !util_1.isNullOrUndefined(permission) && !util_1.isNullOrUndefined(permission.role);
	    };
	    RoleService.prototype.getExactPermission = function (permissionRoute) {
	        if (util_1.isNullOrUndefined(permissionRoute)) {
	            return undefined;
	        }
	        return this.dedupePermissionsByRoute(this.getPermissions() || [])
	            .find(function (permission) { return permission.route === permissionRoute; });
	    };
	    RoleService.prototype.getPermission = function (route) {
	        return this.dedupePermissionsByRoute(this.getPermissions())
	            .filter(function (permission, index, arrayPermissions) {
	            var amount = 0;
	            arrayPermissions.forEach(function (perm) {
	                if (!perm.route.includes('/:id')
	                    && perm.route.startsWith(permission.route)) {
	                    amount += 1;
	                }
	            });
	            return amount <= 1;
	        })
	            .find(function (permission) {
	            var permissionRegex = new RegExp('^' + permission.route.replace('/:id', '/[0-9]+'));
	            return permissionRegex.test(route);
	        });
	    };
	    /**
	     * A user can end up with the same route granted more than once (e.g. member of two profiles/roles
	     * that both include the same menu) - the backend then returns duplicate entries for that exact
	     * route. The parent/child prefix filter in getPermission() counts a route against itself via
	     * String.startsWith, so an exact duplicate makes it look like there's a more specific child route
	     * and the entry gets wrongly discarded, denying access despite the permission being granted.
	     * Collapsing to one entry per route (keeping the highest role) before that filter runs fixes it.
	     */
	    RoleService.prototype.dedupePermissionsByRoute = function (permissions) {
	        var byRoute = new Map();
	        permissions.forEach(function (permission) {
	            var existing = byRoute.get(permission.route);
	            if (util_1.isNullOrUndefined(existing) || permission.role > existing.role) {
	                byRoute.set(permission.route, permission);
	            }
	        });
	        return Array.from(byRoute.values());
	    };
	    RoleService.prototype.hasRole = function (role, route) {
	        var permission = this.getPermission(route);
	        if (util_1.isNullOrUndefined(permission)) {
	            return false;
	        }
	        role = RoleService_1.getRoleFromValue(role);
	        return permission.role >= role;
	    };
	    RoleService.prototype.hasMenuAccess = function (route) {
	        if (util_1.isNullOrUndefined(route)) {
	            return false;
	        }
	        var permission = this.getMenuPermission(route);
	        return !util_1.isNullOrUndefined(permission) && !util_1.isNullOrUndefined(permission.role);
	    };
	    RoleService.prototype.getMenuPermission = function (route) {
	        return this.getPermissions().find(function (permission) {
	            return permission.route.startsWith(route);
	        });
	    };
	    RoleService.prototype.hasMenuRole = function (role, route) {
	        var permission = this.getMenuPermission(route);
	        if (util_1.isNullOrUndefined(permission)) {
	            return false;
	        }
	        return permission.role === RoleService_1.getRoleFromValue(role);
	    };
	    RoleService.prototype.hasMenuRoles = function (roles, route) {
	        var _this = this;
	        if (util_1.isNullOrUndefined(roles)) {
	            return false;
	        }
	        if (util_1.isNullOrUndefined(route)) {
	            route = this.router.url;
	        }
	        if (Array.isArray(roles)) {
	            return roles.some(function (role) { return _this.hasMenuRole(role, route); });
	        }
	        else {
	            return this.hasMenuRole(roles, route);
	        }
	    };
	    RoleService.getRoleFromValue = function (role) {
	        if (util_1.isNullOrUndefined(role)) {
	            return null;
	        }
	        if (typeof role === 'string') {
	            return Roles[role.toUpperCase()];
	        }
	        else {
	            return role;
	        }
	    };
	    RoleService.prototype.resetPermissions = function () {
	        this.permissions.length = 0;
	        store_service_1.StoreService.getInstance().deleteValue(RoleService_1.PERMISSIONS);
	    };
	    RoleService.prototype.fetchPermissions = function () {
	        var _this = this;
	        var httpOptions = {
	            headers: new http_1.HttpHeaders({
	                'username': 'admin@admin.com',
	            })
	        };
	        return this.http.get('api/backoffice/menu', httpOptions).pipe(operators_1.map(function (response) {
	            var permissions = response.map(function (permission) {
	                return {
	                    route: permission.route,
	                    role: RoleService_1.getRoleFromValue(permission.role),
	                    elements: permission.elements
	                };
	            });
	            store_service_1.StoreService.getInstance().setValue(RoleService_1.PERMISSIONS, permissions);
	            return permissions;
	        }), operators_1.switchMap(function () {
	            return _this.http.get('api/backoffice/notification/payments', httpOptions);
	        }), operators_1.tap(function (secondResponse) {
	            var messageMap = secondResponse.message;
	            if (messageMap && Object.keys(messageMap).length > 0) {
	                var formattedMessage = "There are payments to review, these are their statuses:<br>" +
	                    Object.keys(messageMap)
	                        .map(function (key) { return "- " + key + ": " + messageMap[key]; })
	                        .join('<br>');
	                _this._notificationManager.error(formattedMessage, 20000);
	            }
	        }), operators_1.map(function (secondResponse) {
	            return secondResponse;
	        }));
	    };
	    RoleService.prototype.arePermissionsLoaded = function () {
	        return !util_1.isNullOrUndefined(store_service_1.StoreService.getInstance().getValue(RoleService_1.PERMISSIONS));
	    };
	    RoleService = RoleService_1 = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [router_1.Router, http_1.HttpClient,
	            notification_1.NotificationManager])
	    ], RoleService);
	    return RoleService;
	    var RoleService_1;
	}());
	exports.RoleService = RoleService;


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(253), __webpack_require__(272), __webpack_require__(297), __webpack_require__(274), __webpack_require__(853), __webpack_require__(246), __webpack_require__(206)) :
		typeof define === 'function' && define.amd ? define('@angular/common/http', ['exports', '@angular/core', 'rxjs/observable/of', 'rxjs/operator/concatMap', 'rxjs/operator/filter', 'rxjs/operator/map', 'tslib', '@angular/common', 'rxjs/Observable'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.common = global.ng.common || {}, global.ng.common.http = {}),global.ng.core,global.Rx.Observable,global.Rx.Observable.prototype,global.Rx.Observable.prototype,global.Rx.Observable.prototype,global.tslib,global.ng.common,global.Rx));
	}(this, (function (exports,_angular_core,rxjs_observable_of,rxjs_operator_concatMap,rxjs_operator_filter,rxjs_operator_map,tslib,_angular_common,rxjs_Observable) { 'use strict';
	
	/**
	 * @license Angular v5.2.11
	 * (c) 2010-2018 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Transforms an `HttpRequest` into a stream of `HttpEvent`s, one of which will likely be a
	 * `HttpResponse`.
	 *
	 * `HttpHandler` is injectable. When injected, the handler instance dispatches requests to the
	 * first interceptor in the chain, which dispatches to the second, etc, eventually reaching the
	 * `HttpBackend`.
	 *
	 * In an `HttpInterceptor`, the `HttpHandler` parameter is the next interceptor in the chain.
	 *
	 * \@stable
	 * @abstract
	 */
	var HttpHandler = /** @class */ (function () {
	    function HttpHandler() {
	    }
	    return HttpHandler;
	}());
	/**
	 * A final `HttpHandler` which will dispatch the request via browser HTTP APIs to a backend.
	 *
	 * Interceptors sit between the `HttpClient` interface and the `HttpBackend`.
	 *
	 * When injected, `HttpBackend` dispatches requests directly to the backend, without going
	 * through the interceptor chain.
	 *
	 * \@stable
	 * @abstract
	 */
	var HttpBackend = /** @class */ (function () {
	    function HttpBackend() {
	    }
	    return HttpBackend;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * @record
	 */
	/**
	 * Immutable set of Http headers, with lazy parsing.
	 * \@stable
	 */
	var HttpHeaders = /** @class */ (function () {
	    function HttpHeaders(headers) {
	        var _this = this;
	        /**
	         * Internal map of lowercased header names to the normalized
	         * form of the name (the form seen first).
	         */
	        this.normalizedNames = new Map();
	        /**
	         * Queued updates to be materialized the next initialization.
	         */
	        this.lazyUpdate = null;
	        if (!headers) {
	            this.headers = new Map();
	        }
	        else if (typeof headers === 'string') {
	            this.lazyInit = function () {
	                _this.headers = new Map();
	                headers.split('\n').forEach(function (line) {
	                    var /** @type {?} */ index = line.indexOf(':');
	                    if (index > 0) {
	                        var /** @type {?} */ name_1 = line.slice(0, index);
	                        var /** @type {?} */ key = name_1.toLowerCase();
	                        var /** @type {?} */ value = line.slice(index + 1).trim();
	                        _this.maybeSetNormalizedName(name_1, key);
	                        if (_this.headers.has(key)) {
	                            /** @type {?} */ ((_this.headers.get(key))).push(value);
	                        }
	                        else {
	                            _this.headers.set(key, [value]);
	                        }
	                    }
	                });
	            };
	        }
	        else {
	            this.lazyInit = function () {
	                _this.headers = new Map();
	                Object.keys(headers).forEach(function (name) {
	                    var /** @type {?} */ values = headers[name];
	                    var /** @type {?} */ key = name.toLowerCase();
	                    if (typeof values === 'string') {
	                        values = [values];
	                    }
	                    if (values.length > 0) {
	                        _this.headers.set(key, values);
	                        _this.maybeSetNormalizedName(name, key);
	                    }
	                });
	            };
	        }
	    }
	    /**
	     * Checks for existence of header by given name.
	     */
	    /**
	     * Checks for existence of header by given name.
	     * @param {?} name
	     * @return {?}
	     */
	    HttpHeaders.prototype.has = /**
	     * Checks for existence of header by given name.
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        this.init();
	        return this.headers.has(name.toLowerCase());
	    };
	    /**
	     * Returns first header that matches given name.
	     */
	    /**
	     * Returns first header that matches given name.
	     * @param {?} name
	     * @return {?}
	     */
	    HttpHeaders.prototype.get = /**
	     * Returns first header that matches given name.
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        this.init();
	        var /** @type {?} */ values = this.headers.get(name.toLowerCase());
	        return values && values.length > 0 ? values[0] : null;
	    };
	    /**
	     * Returns the names of the headers
	     */
	    /**
	     * Returns the names of the headers
	     * @return {?}
	     */
	    HttpHeaders.prototype.keys = /**
	     * Returns the names of the headers
	     * @return {?}
	     */
	    function () {
	        this.init();
	        return Array.from(this.normalizedNames.values());
	    };
	    /**
	     * Returns list of header values for a given name.
	     */
	    /**
	     * Returns list of header values for a given name.
	     * @param {?} name
	     * @return {?}
	     */
	    HttpHeaders.prototype.getAll = /**
	     * Returns list of header values for a given name.
	     * @param {?} name
	     * @return {?}
	     */
	    function (name) {
	        this.init();
	        return this.headers.get(name.toLowerCase()) || null;
	    };
	    /**
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    HttpHeaders.prototype.append = /**
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    function (name, value) {
	        return this.clone({ name: name, value: value, op: 'a' });
	    };
	    /**
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    HttpHeaders.prototype.set = /**
	     * @param {?} name
	     * @param {?} value
	     * @return {?}
	     */
	    function (name, value) {
	        return this.clone({ name: name, value: value, op: 's' });
	    };
	    /**
	     * @param {?} name
	     * @param {?=} value
	     * @return {?}
	     */
	    HttpHeaders.prototype.delete = /**
	     * @param {?} name
	     * @param {?=} value
	     * @return {?}
	     */
	    function (name, value) {
	        return this.clone({ name: name, value: value, op: 'd' });
	    };
	    /**
	     * @param {?} name
	     * @param {?} lcName
	     * @return {?}
	     */
	    HttpHeaders.prototype.maybeSetNormalizedName = /**
	     * @param {?} name
	     * @param {?} lcName
	     * @return {?}
	     */
	    function (name, lcName) {
	        if (!this.normalizedNames.has(lcName)) {
	            this.normalizedNames.set(lcName, name);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    HttpHeaders.prototype.init = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (!!this.lazyInit) {
	            if (this.lazyInit instanceof HttpHeaders) {
	                this.copyFrom(this.lazyInit);
	            }
	            else {
	                this.lazyInit();
	            }
	            this.lazyInit = null;
	            if (!!this.lazyUpdate) {
	                this.lazyUpdate.forEach(function (update) { return _this.applyUpdate(update); });
	                this.lazyUpdate = null;
	            }
	        }
	    };
	    /**
	     * @param {?} other
	     * @return {?}
	     */
	    HttpHeaders.prototype.copyFrom = /**
	     * @param {?} other
	     * @return {?}
	     */
	    function (other) {
	        var _this = this;
	        other.init();
	        Array.from(other.headers.keys()).forEach(function (key) {
	            _this.headers.set(key, /** @type {?} */ ((other.headers.get(key))));
	            _this.normalizedNames.set(key, /** @type {?} */ ((other.normalizedNames.get(key))));
	        });
	    };
	    /**
	     * @param {?} update
	     * @return {?}
	     */
	    HttpHeaders.prototype.clone = /**
	     * @param {?} update
	     * @return {?}
	     */
	    function (update) {
	        var /** @type {?} */ clone = new HttpHeaders();
	        clone.lazyInit =
	            (!!this.lazyInit && this.lazyInit instanceof HttpHeaders) ? this.lazyInit : this;
	        clone.lazyUpdate = (this.lazyUpdate || []).concat([update]);
	        return clone;
	    };
	    /**
	     * @param {?} update
	     * @return {?}
	     */
	    HttpHeaders.prototype.applyUpdate = /**
	     * @param {?} update
	     * @return {?}
	     */
	    function (update) {
	        var /** @type {?} */ key = update.name.toLowerCase();
	        switch (update.op) {
	            case 'a':
	            case 's':
	                var /** @type {?} */ value = /** @type {?} */ ((update.value));
	                if (typeof value === 'string') {
	                    value = [value];
	                }
	                if (value.length === 0) {
	                    return;
	                }
	                this.maybeSetNormalizedName(update.name, key);
	                var /** @type {?} */ base = (update.op === 'a' ? this.headers.get(key) : undefined) || [];
	                base.push.apply(base, value);
	                this.headers.set(key, base);
	                break;
	            case 'd':
	                var /** @type {?} */ toDelete_1 = /** @type {?} */ (update.value);
	                if (!toDelete_1) {
	                    this.headers.delete(key);
	                    this.normalizedNames.delete(key);
	                }
	                else {
	                    var /** @type {?} */ existing = this.headers.get(key);
	                    if (!existing) {
	                        return;
	                    }
	                    existing = existing.filter(function (value) { return toDelete_1.indexOf(value) === -1; });
	                    if (existing.length === 0) {
	                        this.headers.delete(key);
	                        this.normalizedNames.delete(key);
	                    }
	                    else {
	                        this.headers.set(key, existing);
	                    }
	                }
	                break;
	        }
	    };
	    /**
	     * @internal
	     */
	    /**
	     * \@internal
	     * @param {?} fn
	     * @return {?}
	     */
	    HttpHeaders.prototype.forEach = /**
	     * \@internal
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        var _this = this;
	        this.init();
	        Array.from(this.normalizedNames.keys())
	            .forEach(function (key) { return fn(/** @type {?} */ ((_this.normalizedNames.get(key))), /** @type {?} */ ((_this.headers.get(key)))); });
	    };
	    return HttpHeaders;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * A codec for encoding and decoding parameters in URLs.
	 *
	 * Used by `HttpParams`.
	 *
	 * \@stable
	 *
	 * @record
	 */
	
	/**
	 * A `HttpParameterCodec` that uses `encodeURIComponent` and `decodeURIComponent` to
	 * serialize and parse URL parameter keys and values.
	 *
	 * \@stable
	 */
	var HttpUrlEncodingCodec = /** @class */ (function () {
	    function HttpUrlEncodingCodec() {
	    }
	    /**
	     * @param {?} k
	     * @return {?}
	     */
	    HttpUrlEncodingCodec.prototype.encodeKey = /**
	     * @param {?} k
	     * @return {?}
	     */
	    function (k) { return standardEncoding(k); };
	    /**
	     * @param {?} v
	     * @return {?}
	     */
	    HttpUrlEncodingCodec.prototype.encodeValue = /**
	     * @param {?} v
	     * @return {?}
	     */
	    function (v) { return standardEncoding(v); };
	    /**
	     * @param {?} k
	     * @return {?}
	     */
	    HttpUrlEncodingCodec.prototype.decodeKey = /**
	     * @param {?} k
	     * @return {?}
	     */
	    function (k) { return decodeURIComponent(k); };
	    /**
	     * @param {?} v
	     * @return {?}
	     */
	    HttpUrlEncodingCodec.prototype.decodeValue = /**
	     * @param {?} v
	     * @return {?}
	     */
	    function (v) { return decodeURIComponent(v); };
	    return HttpUrlEncodingCodec;
	}());
	/**
	 * @param {?} rawParams
	 * @param {?} codec
	 * @return {?}
	 */
	function paramParser(rawParams, codec) {
	    var /** @type {?} */ map$$1 = new Map();
	    if (rawParams.length > 0) {
	        var /** @type {?} */ params = rawParams.split('&');
	        params.forEach(function (param) {
	            var /** @type {?} */ eqIdx = param.indexOf('=');
	            var _a = eqIdx == -1 ?
	                [codec.decodeKey(param), ''] :
	                [codec.decodeKey(param.slice(0, eqIdx)), codec.decodeValue(param.slice(eqIdx + 1))], key = _a[0], val = _a[1];
	            var /** @type {?} */ list = map$$1.get(key) || [];
	            list.push(val);
	            map$$1.set(key, list);
	        });
	    }
	    return map$$1;
	}
	/**
	 * @param {?} v
	 * @return {?}
	 */
	function standardEncoding(v) {
	    return encodeURIComponent(v)
	        .replace(/%40/gi, '@')
	        .replace(/%3A/gi, ':')
	        .replace(/%24/gi, '$')
	        .replace(/%2C/gi, ',')
	        .replace(/%3B/gi, ';')
	        .replace(/%2B/gi, '+')
	        .replace(/%3D/gi, '=')
	        .replace(/%3F/gi, '?')
	        .replace(/%2F/gi, '/');
	}
	/**
	 * An HTTP request/response body that represents serialized parameters,
	 * per the MIME type `application/x-www-form-urlencoded`.
	 *
	 * This class is immutable - all mutation operations return a new instance.
	 *
	 * \@stable
	 */
	var HttpParams = /** @class */ (function () {
	    function HttpParams(options) {
	        if (options === void 0) { options = /** @type {?} */ ({}); }
	        var _this = this;
	        this.updates = null;
	        this.cloneFrom = null;
	        this.encoder = options.encoder || new HttpUrlEncodingCodec();
	        if (!!options.fromString) {
	            if (!!options.fromObject) {
	                throw new Error("Cannot specify both fromString and fromObject.");
	            }
	            this.map = paramParser(options.fromString, this.encoder);
	        }
	        else if (!!options.fromObject) {
	            this.map = new Map();
	            Object.keys(options.fromObject).forEach(function (key) {
	                var /** @type {?} */ value = (/** @type {?} */ (options.fromObject))[key]; /** @type {?} */
	                ((_this.map)).set(key, Array.isArray(value) ? value : [value]);
	            });
	        }
	        else {
	            this.map = null;
	        }
	    }
	    /**
	     * Check whether the body has one or more values for the given parameter name.
	     */
	    /**
	     * Check whether the body has one or more values for the given parameter name.
	     * @param {?} param
	     * @return {?}
	     */
	    HttpParams.prototype.has = /**
	     * Check whether the body has one or more values for the given parameter name.
	     * @param {?} param
	     * @return {?}
	     */
	    function (param) {
	        this.init();
	        return /** @type {?} */ ((this.map)).has(param);
	    };
	    /**
	     * Get the first value for the given parameter name, or `null` if it's not present.
	     */
	    /**
	     * Get the first value for the given parameter name, or `null` if it's not present.
	     * @param {?} param
	     * @return {?}
	     */
	    HttpParams.prototype.get = /**
	     * Get the first value for the given parameter name, or `null` if it's not present.
	     * @param {?} param
	     * @return {?}
	     */
	    function (param) {
	        this.init();
	        var /** @type {?} */ res = /** @type {?} */ ((this.map)).get(param);
	        return !!res ? res[0] : null;
	    };
	    /**
	     * Get all values for the given parameter name, or `null` if it's not present.
	     */
	    /**
	     * Get all values for the given parameter name, or `null` if it's not present.
	     * @param {?} param
	     * @return {?}
	     */
	    HttpParams.prototype.getAll = /**
	     * Get all values for the given parameter name, or `null` if it's not present.
	     * @param {?} param
	     * @return {?}
	     */
	    function (param) {
	        this.init();
	        return /** @type {?} */ ((this.map)).get(param) || null;
	    };
	    /**
	     * Get all the parameter names for this body.
	     */
	    /**
	     * Get all the parameter names for this body.
	     * @return {?}
	     */
	    HttpParams.prototype.keys = /**
	     * Get all the parameter names for this body.
	     * @return {?}
	     */
	    function () {
	        this.init();
	        return Array.from(/** @type {?} */ ((this.map)).keys());
	    };
	    /**
	     * Construct a new body with an appended value for the given parameter name.
	     */
	    /**
	     * Construct a new body with an appended value for the given parameter name.
	     * @param {?} param
	     * @param {?} value
	     * @return {?}
	     */
	    HttpParams.prototype.append = /**
	     * Construct a new body with an appended value for the given parameter name.
	     * @param {?} param
	     * @param {?} value
	     * @return {?}
	     */
	    function (param, value) { return this.clone({ param: param, value: value, op: 'a' }); };
	    /**
	     * Construct a new body with a new value for the given parameter name.
	     */
	    /**
	     * Construct a new body with a new value for the given parameter name.
	     * @param {?} param
	     * @param {?} value
	     * @return {?}
	     */
	    HttpParams.prototype.set = /**
	     * Construct a new body with a new value for the given parameter name.
	     * @param {?} param
	     * @param {?} value
	     * @return {?}
	     */
	    function (param, value) { return this.clone({ param: param, value: value, op: 's' }); };
	    /**
	     * Construct a new body with either the given value for the given parameter
	     * removed, if a value is given, or all values for the given parameter removed
	     * if not.
	     */
	    /**
	     * Construct a new body with either the given value for the given parameter
	     * removed, if a value is given, or all values for the given parameter removed
	     * if not.
	     * @param {?} param
	     * @param {?=} value
	     * @return {?}
	     */
	    HttpParams.prototype.delete = /**
	     * Construct a new body with either the given value for the given parameter
	     * removed, if a value is given, or all values for the given parameter removed
	     * if not.
	     * @param {?} param
	     * @param {?=} value
	     * @return {?}
	     */
	    function (param, value) { return this.clone({ param: param, value: value, op: 'd' }); };
	    /**
	     * Serialize the body to an encoded string, where key-value pairs (separated by `=`) are
	     * separated by `&`s.
	     */
	    /**
	     * Serialize the body to an encoded string, where key-value pairs (separated by `=`) are
	     * separated by `&`s.
	     * @return {?}
	     */
	    HttpParams.prototype.toString = /**
	     * Serialize the body to an encoded string, where key-value pairs (separated by `=`) are
	     * separated by `&`s.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this.init();
	        return this.keys()
	            .map(function (key) {
	            var /** @type {?} */ eKey = _this.encoder.encodeKey(key);
	            return /** @type {?} */ ((/** @type {?} */ ((_this.map)).get(key))).map(function (value) { return eKey + '=' + _this.encoder.encodeValue(value); }).join('&');
	        })
	            .join('&');
	    };
	    /**
	     * @param {?} update
	     * @return {?}
	     */
	    HttpParams.prototype.clone = /**
	     * @param {?} update
	     * @return {?}
	     */
	    function (update) {
	        var /** @type {?} */ clone = new HttpParams({ encoder: this.encoder });
	        clone.cloneFrom = this.cloneFrom || this;
	        clone.updates = (this.updates || []).concat([update]);
	        return clone;
	    };
	    /**
	     * @return {?}
	     */
	    HttpParams.prototype.init = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this.map === null) {
	            this.map = new Map();
	        }
	        if (this.cloneFrom !== null) {
	            this.cloneFrom.init();
	            this.cloneFrom.keys().forEach(function (key) { return ((_this.map)).set(key, /** @type {?} */ ((/** @type {?} */ ((/** @type {?} */ ((_this.cloneFrom)).map)).get(key)))); }); /** @type {?} */
	            ((this.updates)).forEach(function (update) {
	                switch (update.op) {
	                    case 'a':
	                    case 's':
	                        var /** @type {?} */ base = (update.op === 'a' ? /** @type {?} */ ((_this.map)).get(update.param) : undefined) || [];
	                        base.push(/** @type {?} */ ((update.value))); /** @type {?} */
	                        ((_this.map)).set(update.param, base);
	                        break;
	                    case 'd':
	                        if (update.value !== undefined) {
	                            var /** @type {?} */ base_1 = /** @type {?} */ ((_this.map)).get(update.param) || [];
	                            var /** @type {?} */ idx = base_1.indexOf(update.value);
	                            if (idx !== -1) {
	                                base_1.splice(idx, 1);
	                            }
	                            if (base_1.length > 0) {
	                                /** @type {?} */ ((_this.map)).set(update.param, base_1);
	                            }
	                            else {
	                                /** @type {?} */ ((_this.map)).delete(update.param);
	                            }
	                        }
	                        else {
	                            /** @type {?} */ ((_this.map)).delete(update.param);
	                            break;
	                        }
	                }
	            });
	            this.cloneFrom = null;
	        }
	    };
	    return HttpParams;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Determine whether the given HTTP method may include a body.
	 * @param {?} method
	 * @return {?}
	 */
	function mightHaveBody(method) {
	    switch (method) {
	        case 'DELETE':
	        case 'GET':
	        case 'HEAD':
	        case 'OPTIONS':
	        case 'JSONP':
	            return false;
	        default:
	            return true;
	    }
	}
	/**
	 * Safely assert whether the given value is an ArrayBuffer.
	 *
	 * In some execution environments ArrayBuffer is not defined.
	 * @param {?} value
	 * @return {?}
	 */
	function isArrayBuffer(value) {
	    return typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer;
	}
	/**
	 * Safely assert whether the given value is a Blob.
	 *
	 * In some execution environments Blob is not defined.
	 * @param {?} value
	 * @return {?}
	 */
	function isBlob(value) {
	    return typeof Blob !== 'undefined' && value instanceof Blob;
	}
	/**
	 * Safely assert whether the given value is a FormData instance.
	 *
	 * In some execution environments FormData is not defined.
	 * @param {?} value
	 * @return {?}
	 */
	function isFormData(value) {
	    return typeof FormData !== 'undefined' && value instanceof FormData;
	}
	/**
	 * An outgoing HTTP request with an optional typed body.
	 *
	 * `HttpRequest` represents an outgoing request, including URL, method,
	 * headers, body, and other request configuration options. Instances should be
	 * assumed to be immutable. To modify a `HttpRequest`, the `clone`
	 * method should be used.
	 *
	 * \@stable
	 * @template T
	 */
	var HttpRequest = /** @class */ (function () {
	    function HttpRequest(method, url, third, fourth) {
	        this.url = url;
	        /**
	         * The request body, or `null` if one isn't set.
	         *
	         * Bodies are not enforced to be immutable, as they can include a reference to any
	         * user-defined data type. However, interceptors should take care to preserve
	         * idempotence by treating them as such.
	         */
	        this.body = null;
	        /**
	         * Whether this request should be made in a way that exposes progress events.
	         *
	         * Progress events are expensive (change detection runs on each event) and so
	         * they should only be requested if the consumer intends to monitor them.
	         */
	        this.reportProgress = false;
	        /**
	         * Whether this request should be sent with outgoing credentials (cookies).
	         */
	        this.withCredentials = false;
	        /**
	         * The expected response type of the server.
	         *
	         * This is used to parse the response appropriately before returning it to
	         * the requestee.
	         */
	        this.responseType = 'json';
	        this.method = method.toUpperCase();
	        // Next, need to figure out which argument holds the HttpRequestInit
	        // options, if any.
	        var /** @type {?} */ options;
	        // Check whether a body argument is expected. The only valid way to omit
	        // the body argument is to use a known no-body method like GET.
	        if (mightHaveBody(this.method) || !!fourth) {
	            // Body is the third argument, options are the fourth.
	            this.body = (third !== undefined) ? /** @type {?} */ (third) : null;
	            options = fourth;
	        }
	        else {
	            // No body required, options are the third argument. The body stays null.
	            options = /** @type {?} */ (third);
	        }
	        // If options have been passed, interpret them.
	        if (options) {
	            // Normalize reportProgress and withCredentials.
	            this.reportProgress = !!options.reportProgress;
	            this.withCredentials = !!options.withCredentials;
	            // Override default response type of 'json' if one is provided.
	            if (!!options.responseType) {
	                this.responseType = options.responseType;
	            }
	            // Override headers if they're provided.
	            if (!!options.headers) {
	                this.headers = options.headers;
	            }
	            if (!!options.params) {
	                this.params = options.params;
	            }
	        }
	        // If no headers have been passed in, construct a new HttpHeaders instance.
	        if (!this.headers) {
	            this.headers = new HttpHeaders();
	        }
	        // If no parameters have been passed in, construct a new HttpUrlEncodedParams instance.
	        if (!this.params) {
	            this.params = new HttpParams();
	            this.urlWithParams = url;
	        }
	        else {
	            // Encode the parameters to a string in preparation for inclusion in the URL.
	            var /** @type {?} */ params = this.params.toString();
	            if (params.length === 0) {
	                // No parameters, the visible URL is just the URL given at creation time.
	                this.urlWithParams = url;
	            }
	            else {
	                // Does the URL already have query parameters? Look for '?'.
	                var /** @type {?} */ qIdx = url.indexOf('?');
	                // There are 3 cases to handle:
	                // 1) No existing parameters -> append '?' followed by params.
	                // 2) '?' exists and is followed by existing query string ->
	                //    append '&' followed by params.
	                // 3) '?' exists at the end of the url -> append params directly.
	                // This basically amounts to determining the character, if any, with
	                // which to join the URL and parameters.
	                var /** @type {?} */ sep = qIdx === -1 ? '?' : (qIdx < url.length - 1 ? '&' : '');
	                this.urlWithParams = url + sep + params;
	            }
	        }
	    }
	    /**
	     * Transform the free-form body into a serialized format suitable for
	     * transmission to the server.
	     */
	    /**
	     * Transform the free-form body into a serialized format suitable for
	     * transmission to the server.
	     * @return {?}
	     */
	    HttpRequest.prototype.serializeBody = /**
	     * Transform the free-form body into a serialized format suitable for
	     * transmission to the server.
	     * @return {?}
	     */
	    function () {
	        // If no body is present, no need to serialize it.
	        if (this.body === null) {
	            return null;
	        }
	        // Check whether the body is already in a serialized form. If so,
	        // it can just be returned directly.
	        if (isArrayBuffer(this.body) || isBlob(this.body) || isFormData(this.body) ||
	            typeof this.body === 'string') {
	            return this.body;
	        }
	        // Check whether the body is an instance of HttpUrlEncodedParams.
	        if (this.body instanceof HttpParams) {
	            return this.body.toString();
	        }
	        // Check whether the body is an object or array, and serialize with JSON if so.
	        if (typeof this.body === 'object' || typeof this.body === 'boolean' ||
	            Array.isArray(this.body)) {
	            return JSON.stringify(this.body);
	        }
	        // Fall back on toString() for everything else.
	        return (/** @type {?} */ (this.body)).toString();
	    };
	    /**
	     * Examine the body and attempt to infer an appropriate MIME type
	     * for it.
	     *
	     * If no such type can be inferred, this method will return `null`.
	     */
	    /**
	     * Examine the body and attempt to infer an appropriate MIME type
	     * for it.
	     *
	     * If no such type can be inferred, this method will return `null`.
	     * @return {?}
	     */
	    HttpRequest.prototype.detectContentTypeHeader = /**
	     * Examine the body and attempt to infer an appropriate MIME type
	     * for it.
	     *
	     * If no such type can be inferred, this method will return `null`.
	     * @return {?}
	     */
	    function () {
	        // An empty body has no content type.
	        if (this.body === null) {
	            return null;
	        }
	        // FormData bodies rely on the browser's content type assignment.
	        if (isFormData(this.body)) {
	            return null;
	        }
	        // Blobs usually have their own content type. If it doesn't, then
	        // no type can be inferred.
	        if (isBlob(this.body)) {
	            return this.body.type || null;
	        }
	        // Array buffers have unknown contents and thus no type can be inferred.
	        if (isArrayBuffer(this.body)) {
	            return null;
	        }
	        // Technically, strings could be a form of JSON data, but it's safe enough
	        // to assume they're plain strings.
	        if (typeof this.body === 'string') {
	            return 'text/plain';
	        }
	        // `HttpUrlEncodedParams` has its own content-type.
	        if (this.body instanceof HttpParams) {
	            return 'application/x-www-form-urlencoded;charset=UTF-8';
	        }
	        // Arrays, objects, and numbers will be encoded as JSON.
	        if (typeof this.body === 'object' || typeof this.body === 'number' ||
	            Array.isArray(this.body)) {
	            return 'application/json';
	        }
	        // No type could be inferred.
	        return null;
	    };
	    /**
	     * @param {?=} update
	     * @return {?}
	     */
	    HttpRequest.prototype.clone = /**
	     * @param {?=} update
	     * @return {?}
	     */
	    function (update) {
	        if (update === void 0) { update = {}; }
	        // For method, url, and responseType, take the current value unless
	        // it is overridden in the update hash.
	        var /** @type {?} */ method = update.method || this.method;
	        var /** @type {?} */ url = update.url || this.url;
	        var /** @type {?} */ responseType = update.responseType || this.responseType;
	        // The body is somewhat special - a `null` value in update.body means
	        // whatever current body is present is being overridden with an empty
	        // body, whereas an `undefined` value in update.body implies no
	        // override.
	        var /** @type {?} */ body = (update.body !== undefined) ? update.body : this.body;
	        // Carefully handle the boolean options to differentiate between
	        // `false` and `undefined` in the update args.
	        var /** @type {?} */ withCredentials = (update.withCredentials !== undefined) ? update.withCredentials : this.withCredentials;
	        var /** @type {?} */ reportProgress = (update.reportProgress !== undefined) ? update.reportProgress : this.reportProgress;
	        // Headers and params may be appended to if `setHeaders` or
	        // `setParams` are used.
	        var /** @type {?} */ headers = update.headers || this.headers;
	        var /** @type {?} */ params = update.params || this.params;
	        // Check whether the caller has asked to add headers.
	        if (update.setHeaders !== undefined) {
	            // Set every requested header.
	            headers =
	                Object.keys(update.setHeaders)
	                    .reduce(function (headers, name) { return headers.set(name, /** @type {?} */ ((update.setHeaders))[name]); }, headers);
	        }
	        // Check whether the caller has asked to set params.
	        if (update.setParams) {
	            // Set every requested param.
	            params = Object.keys(update.setParams)
	                .reduce(function (params, param) { return params.set(param, /** @type {?} */ ((update.setParams))[param]); }, params);
	        }
	        // Finally, construct the new HttpRequest using the pieces from above.
	        return new HttpRequest(method, url, body, {
	            params: params, headers: headers, reportProgress: reportProgress, responseType: responseType, withCredentials: withCredentials,
	        });
	    };
	    return HttpRequest;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/** @enum {number} */
	var HttpEventType = {
	    /**
	       * The request was sent out over the wire.
	       */
	    Sent: 0,
	    /**
	       * An upload progress event was received.
	       */
	    UploadProgress: 1,
	    /**
	       * The response status code and headers were received.
	       */
	    ResponseHeader: 2,
	    /**
	       * A download progress event was received.
	       */
	    DownloadProgress: 3,
	    /**
	       * The full response including the body was received.
	       */
	    Response: 4,
	    /**
	       * A custom event from an interceptor or a backend.
	       */
	    User: 5,
	};
	HttpEventType[HttpEventType.Sent] = "Sent";
	HttpEventType[HttpEventType.UploadProgress] = "UploadProgress";
	HttpEventType[HttpEventType.ResponseHeader] = "ResponseHeader";
	HttpEventType[HttpEventType.DownloadProgress] = "DownloadProgress";
	HttpEventType[HttpEventType.Response] = "Response";
	HttpEventType[HttpEventType.User] = "User";
	/**
	 * Base interface for progress events.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * A download progress event.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * An upload progress event.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * An event indicating that the request was sent to the server. Useful
	 * when a request may be retried multiple times, to distinguish between
	 * retries on the final event stream.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * A user-defined event.
	 *
	 * Grouping all custom events under this type ensures they will be handled
	 * and forwarded by all implementations of interceptors.
	 *
	 * \@stable
	 * @record
	 * @template T
	 */
	
	/**
	 * An error that represents a failed attempt to JSON.parse text coming back
	 * from the server.
	 *
	 * It bundles the Error object with the actual response body that failed to parse.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * Base class for both `HttpResponse` and `HttpHeaderResponse`.
	 *
	 * \@stable
	 * @abstract
	 */
	var HttpResponseBase = /** @class */ (function () {
	    /**
	     * Super-constructor for all responses.
	     *
	     * The single parameter accepted is an initialization hash. Any properties
	     * of the response passed there will override the default values.
	     */
	    function HttpResponseBase(init, defaultStatus, defaultStatusText) {
	        if (defaultStatus === void 0) { defaultStatus = 200; }
	        if (defaultStatusText === void 0) { defaultStatusText = 'OK'; }
	        // If the hash has values passed, use them to initialize the response.
	        // Otherwise use the default values.
	        this.headers = init.headers || new HttpHeaders();
	        this.status = init.status !== undefined ? init.status : defaultStatus;
	        this.statusText = init.statusText || defaultStatusText;
	        this.url = init.url || null;
	        // Cache the ok value to avoid defining a getter.
	        this.ok = this.status >= 200 && this.status < 300;
	    }
	    return HttpResponseBase;
	}());
	/**
	 * A partial HTTP response which only includes the status and header data,
	 * but no response body.
	 *
	 * `HttpHeaderResponse` is a `HttpEvent` available on the response
	 * event stream, only when progress events are requested.
	 *
	 * \@stable
	 */
	var HttpHeaderResponse = /** @class */ (function (_super) {
	    tslib.__extends(HttpHeaderResponse, _super);
	    /**
	     * Create a new `HttpHeaderResponse` with the given parameters.
	     */
	    function HttpHeaderResponse(init) {
	        if (init === void 0) { init = {}; }
	        var _this = _super.call(this, init) || this;
	        _this.type = HttpEventType.ResponseHeader;
	        return _this;
	    }
	    /**
	     * Copy this `HttpHeaderResponse`, overriding its contents with the
	     * given parameter hash.
	     */
	    /**
	     * Copy this `HttpHeaderResponse`, overriding its contents with the
	     * given parameter hash.
	     * @param {?=} update
	     * @return {?}
	     */
	    HttpHeaderResponse.prototype.clone = /**
	     * Copy this `HttpHeaderResponse`, overriding its contents with the
	     * given parameter hash.
	     * @param {?=} update
	     * @return {?}
	     */
	    function (update) {
	        if (update === void 0) { update = {}; }
	        // Perform a straightforward initialization of the new HttpHeaderResponse,
	        // overriding the current parameters with new ones if given.
	        return new HttpHeaderResponse({
	            headers: update.headers || this.headers,
	            status: update.status !== undefined ? update.status : this.status,
	            statusText: update.statusText || this.statusText,
	            url: update.url || this.url || undefined,
	        });
	    };
	    return HttpHeaderResponse;
	}(HttpResponseBase));
	/**
	 * A full HTTP response, including a typed response body (which may be `null`
	 * if one was not returned).
	 *
	 * `HttpResponse` is a `HttpEvent` available on the response event
	 * stream.
	 *
	 * \@stable
	 * @template T
	 */
	var HttpResponse = /** @class */ (function (_super) {
	    tslib.__extends(HttpResponse, _super);
	    /**
	     * Construct a new `HttpResponse`.
	     */
	    function HttpResponse(init) {
	        if (init === void 0) { init = {}; }
	        var _this = _super.call(this, init) || this;
	        _this.type = HttpEventType.Response;
	        _this.body = init.body !== undefined ? init.body : null;
	        return _this;
	    }
	    /**
	     * @param {?=} update
	     * @return {?}
	     */
	    HttpResponse.prototype.clone = /**
	     * @param {?=} update
	     * @return {?}
	     */
	    function (update) {
	        if (update === void 0) { update = {}; }
	        return new HttpResponse({
	            body: (update.body !== undefined) ? update.body : this.body,
	            headers: update.headers || this.headers,
	            status: (update.status !== undefined) ? update.status : this.status,
	            statusText: update.statusText || this.statusText,
	            url: update.url || this.url || undefined,
	        });
	    };
	    return HttpResponse;
	}(HttpResponseBase));
	/**
	 * A response that represents an error or failure, either from a
	 * non-successful HTTP status, an error while executing the request,
	 * or some other failure which occurred during the parsing of the response.
	 *
	 * Any error returned on the `Observable` response stream will be
	 * wrapped in an `HttpErrorResponse` to provide additional context about
	 * the state of the HTTP layer when the error occurred. The error property
	 * will contain either a wrapped Error object or the error response returned
	 * from the server.
	 *
	 * \@stable
	 */
	var HttpErrorResponse = /** @class */ (function (_super) {
	    tslib.__extends(HttpErrorResponse, _super);
	    function HttpErrorResponse(init) {
	        var _this = 
	        // Initialize with a default status of 0 / Unknown Error.
	        _super.call(this, init, 0, 'Unknown Error') || this;
	        _this.name = 'HttpErrorResponse';
	        /**
	         * Errors are never okay, even when the status code is in the 2xx success range.
	         */
	        _this.ok = false;
	        // If the response was successful, then this was a parse error. Otherwise, it was
	        // a protocol-level failure of some sort. Either the request failed in transit
	        // or the server returned an unsuccessful status code.
	        if (_this.status >= 200 && _this.status < 300) {
	            _this.message = "Http failure during parsing for " + (init.url || '(unknown url)');
	        }
	        else {
	            _this.message =
	                "Http failure response for " + (init.url || '(unknown url)') + ": " + init.status + " " + init.statusText;
	        }
	        _this.error = init.error || null;
	        return _this;
	    }
	    return HttpErrorResponse;
	}(HttpResponseBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Construct an instance of `HttpRequestOptions<T>` from a source `HttpMethodOptions` and
	 * the given `body`. Basically, this clones the object and adds the body.
	 * @template T
	 * @param {?} options
	 * @param {?} body
	 * @return {?}
	 */
	function addBody(options, body) {
	    return {
	        body: body,
	        headers: options.headers,
	        observe: options.observe,
	        params: options.params,
	        reportProgress: options.reportProgress,
	        responseType: options.responseType,
	        withCredentials: options.withCredentials,
	    };
	}
	/**
	 * Perform HTTP requests.
	 *
	 * `HttpClient` is available as an injectable class, with methods to perform HTTP requests.
	 * Each request method has multiple signatures, and the return type varies according to which
	 * signature is called (mainly the values of `observe` and `responseType`).
	 *
	 * \@stable
	 */
	var HttpClient = /** @class */ (function () {
	    function HttpClient(handler) {
	        this.handler = handler;
	    }
	    /**
	     * Constructs an `Observable` for a particular HTTP request that, when subscribed,
	     * fires the request through the chain of registered interceptors and on to the
	     * server.
	     *
	     * This method can be called in one of two ways. Either an `HttpRequest`
	     * instance can be passed directly as the only parameter, or a method can be
	     * passed as the first parameter, a string URL as the second, and an
	     * options hash as the third.
	     *
	     * If a `HttpRequest` object is passed directly, an `Observable` of the
	     * raw `HttpEvent` stream will be returned.
	     *
	     * If a request is instead built by providing a URL, the options object
	     * determines the return type of `request()`. In addition to configuring
	     * request parameters such as the outgoing headers and/or the body, the options
	     * hash specifies two key pieces of information about the request: the
	     * `responseType` and what to `observe`.
	     *
	     * The `responseType` value determines how a successful response body will be
	     * parsed. If `responseType` is the default `json`, a type interface for the
	     * resulting object may be passed as a type parameter to `request()`.
	     *
	     * The `observe` value determines the return type of `request()`, based on what
	     * the consumer is interested in observing. A value of `events` will return an
	     * `Observable<HttpEvent>` representing the raw `HttpEvent` stream,
	     * including progress events by default. A value of `response` will return an
	     * `Observable<HttpResponse<T>>` where the `T` parameter of `HttpResponse`
	     * depends on the `responseType` and any optionally provided type parameter.
	     * A value of `body` will return an `Observable<T>` with the same `T` body type.
	     */
	    /**
	     * Constructs an `Observable` for a particular HTTP request that, when subscribed,
	     * fires the request through the chain of registered interceptors and on to the
	     * server.
	     *
	     * This method can be called in one of two ways. Either an `HttpRequest`
	     * instance can be passed directly as the only parameter, or a method can be
	     * passed as the first parameter, a string URL as the second, and an
	     * options hash as the third.
	     *
	     * If a `HttpRequest` object is passed directly, an `Observable` of the
	     * raw `HttpEvent` stream will be returned.
	     *
	     * If a request is instead built by providing a URL, the options object
	     * determines the return type of `request()`. In addition to configuring
	     * request parameters such as the outgoing headers and/or the body, the options
	     * hash specifies two key pieces of information about the request: the
	     * `responseType` and what to `observe`.
	     *
	     * The `responseType` value determines how a successful response body will be
	     * parsed. If `responseType` is the default `json`, a type interface for the
	     * resulting object may be passed as a type parameter to `request()`.
	     *
	     * The `observe` value determines the return type of `request()`, based on what
	     * the consumer is interested in observing. A value of `events` will return an
	     * `Observable<HttpEvent>` representing the raw `HttpEvent` stream,
	     * including progress events by default. A value of `response` will return an
	     * `Observable<HttpResponse<T>>` where the `T` parameter of `HttpResponse`
	     * depends on the `responseType` and any optionally provided type parameter.
	     * A value of `body` will return an `Observable<T>` with the same `T` body type.
	     * @param {?} first
	     * @param {?=} url
	     * @param {?=} options
	     * @return {?}
	     */
	    HttpClient.prototype.request = /**
	     * Constructs an `Observable` for a particular HTTP request that, when subscribed,
	     * fires the request through the chain of registered interceptors and on to the
	     * server.
	     *
	     * This method can be called in one of two ways. Either an `HttpRequest`
	     * instance can be passed directly as the only parameter, or a method can be
	     * passed as the first parameter, a string URL as the second, and an
	     * options hash as the third.
	     *
	     * If a `HttpRequest` object is passed directly, an `Observable` of the
	     * raw `HttpEvent` stream will be returned.
	     *
	     * If a request is instead built by providing a URL, the options object
	     * determines the return type of `request()`. In addition to configuring
	     * request parameters such as the outgoing headers and/or the body, the options
	     * hash specifies two key pieces of information about the request: the
	     * `responseType` and what to `observe`.
	     *
	     * The `responseType` value determines how a successful response body will be
	     * parsed. If `responseType` is the default `json`, a type interface for the
	     * resulting object may be passed as a type parameter to `request()`.
	     *
	     * The `observe` value determines the return type of `request()`, based on what
	     * the consumer is interested in observing. A value of `events` will return an
	     * `Observable<HttpEvent>` representing the raw `HttpEvent` stream,
	     * including progress events by default. A value of `response` will return an
	     * `Observable<HttpResponse<T>>` where the `T` parameter of `HttpResponse`
	     * depends on the `responseType` and any optionally provided type parameter.
	     * A value of `body` will return an `Observable<T>` with the same `T` body type.
	     * @param {?} first
	     * @param {?=} url
	     * @param {?=} options
	     * @return {?}
	     */
	    function (first, url, options) {
	        var _this = this;
	        if (options === void 0) { options = {}; }
	        var /** @type {?} */ req;
	        // Firstly, check whether the primary argument is an instance of `HttpRequest`.
	        if (first instanceof HttpRequest) {
	            // It is. The other arguments must be undefined (per the signatures) and can be
	            // ignored.
	            req = /** @type {?} */ (first);
	        }
	        else {
	            // It's a string, so it represents a URL. Construct a request based on it,
	            // and incorporate the remaining arguments (assuming GET unless a method is
	            // provided.
	            // Figure out the headers.
	            var /** @type {?} */ headers = undefined;
	            if (options.headers instanceof HttpHeaders) {
	                headers = options.headers;
	            }
	            else {
	                headers = new HttpHeaders(options.headers);
	            }
	            // Sort out parameters.
	            var /** @type {?} */ params = undefined;
	            if (!!options.params) {
	                if (options.params instanceof HttpParams) {
	                    params = options.params;
	                }
	                else {
	                    params = new HttpParams({ fromObject: options.params });
	                }
	            }
	            // Construct the request.
	            req = new HttpRequest(first, /** @type {?} */ ((url)), (options.body !== undefined ? options.body : null), {
	                headers: headers,
	                params: params,
	                reportProgress: options.reportProgress,
	                // By default, JSON is assumed to be returned for all calls.
	                responseType: options.responseType || 'json',
	                withCredentials: options.withCredentials,
	            });
	        }
	        // Start with an Observable.of() the initial request, and run the handler (which
	        // includes all interceptors) inside a concatMap(). This way, the handler runs
	        // inside an Observable chain, which causes interceptors to be re-run on every
	        // subscription (this also makes retries re-run the handler, including interceptors).
	        var /** @type {?} */ events$ = rxjs_operator_concatMap.concatMap.call(rxjs_observable_of.of(req), function (req) { return _this.handler.handle(req); });
	        // If coming via the API signature which accepts a previously constructed HttpRequest,
	        // the only option is to get the event stream. Otherwise, return the event stream if
	        // that is what was requested.
	        if (first instanceof HttpRequest || options.observe === 'events') {
	            return events$;
	        }
	        // The requested stream contains either the full response or the body. In either
	        // case, the first step is to filter the event stream to extract a stream of
	        // responses(s).
	        var /** @type {?} */ res$ = rxjs_operator_filter.filter.call(events$, function (event) { return event instanceof HttpResponse; });
	        // Decide which stream to return.
	        switch (options.observe || 'body') {
	            case 'body':
	                // The requested stream is the body. Map the response stream to the response
	                // body. This could be done more simply, but a misbehaving interceptor might
	                // transform the response body into a different format and ignore the requested
	                // responseType. Guard against this by validating that the response is of the
	                // requested type.
	                switch (req.responseType) {
	                    case 'arraybuffer':
	                        return rxjs_operator_map.map.call(res$, function (res) {
	                            // Validate that the body is an ArrayBuffer.
	                            if (res.body !== null && !(res.body instanceof ArrayBuffer)) {
	                                throw new Error('Response is not an ArrayBuffer.');
	                            }
	                            return res.body;
	                        });
	                    case 'blob':
	                        return rxjs_operator_map.map.call(res$, function (res) {
	                            // Validate that the body is a Blob.
	                            if (res.body !== null && !(res.body instanceof Blob)) {
	                                throw new Error('Response is not a Blob.');
	                            }
	                            return res.body;
	                        });
	                    case 'text':
	                        return rxjs_operator_map.map.call(res$, function (res) {
	                            // Validate that the body is a string.
	                            if (res.body !== null && typeof res.body !== 'string') {
	                                throw new Error('Response is not a string.');
	                            }
	                            return res.body;
	                        });
	                    case 'json':
	                    default:
	                        // No validation needed for JSON responses, as they can be of any type.
	                        return rxjs_operator_map.map.call(res$, function (res) { return res.body; });
	                }
	            case 'response':
	                // The response stream was requested directly, so return it.
	                return res$;
	            default:
	                // Guard against new future observe types being added.
	                throw new Error("Unreachable: unhandled observe type " + options.observe + "}");
	        }
	    };
	    /**
	     * Constructs an `Observable` which, when subscribed, will cause the configured
	     * DELETE request to be executed on the server. See the individual overloads for
	     * details of `delete()`'s return type based on the provided options.
	     */
	    /**
	     * Constructs an `Observable` which, when subscribed, will cause the configured
	     * DELETE request to be executed on the server. See the individual overloads for
	     * details of `delete()`'s return type based on the provided options.
	     * @param {?} url
	     * @param {?=} options
	     * @return {?}
	     */
	    HttpClient.prototype.delete = /**
	     * Constructs an `Observable` which, when subscribed, will cause the configured
	     * DELETE request to be executed on the server. See the individual overloads for
	     * details of `delete()`'s return type based on the provided options.
	     * @param {?} url
	     * @param {?=} options
	     * @return {?}
	     */
	    function (url, options) {
	        if (options === void 0) { options = {}; }
	        return this.request('DELETE', url, /** @type {?} */ (options));
	    };
	    /**
	     * Constructs an `Observable` which, when subscribed, will cause the configured
	     * GET request to be executed on the server. See the individual overloads for
	     * details of `get()`'s return type based on the provided options.
	     */
	    /**
	     * Constructs an `Observable` which, when subscribed, will cause the configured
	     * GET request to be executed on the server. See the individual overloads for
	     * details of `get()`'s return type based on the provided options.
	     * @param {?} url
	     * @param {?=} options
	     * @return {?}
	     */
	    HttpClient.prototype.get = /**
	     * Constructs an `Observable` which, when subscribed, will cause the configured
	     * GET request to be executed on the server. See the individual overloads for
	     * details of `get()`'s return type based on the provided options.
	     * @param {?} url
	     * @param {?=} options
	     * @return {?}
	     */
	    function (url, options) {
	        if (options === void 0) { options = {}; }
	        return this.request('GET', url, /** @type {?} */ (options));
	    };
	    /**
	     * Constructs an `Observable` which, when subscribed, will cause the configured
	     * HEAD request to be executed on the server. See the individual overloads for
	     * details of `head()`'s return type based on the provided options.
	     */
	    /**
	     * Constructs an `Observable` which, when subscribed, will cause the configured
	     * HEAD request to be executed on the server. See the individual overloads for
	     * details of `head()`'s return type based on the provided options.
	     * @param {?} url
	     * @param {?=} options
	     * @return {?}
	     */
	    HttpClient.prototype.head = /**
	     * Constructs an `Observable` which, when subscribed, will cause the configured
	     * HEAD request to be executed on the server. See the individual overloads for
	     * details of `head()`'s return type based on the provided options.
	     * @param {?} url
	     * @param {?=} options
	     * @return {?}
	     */
	    function (url, options) {
	        if (options === void 0) { options = {}; }
	        return this.request('HEAD', url, /** @type {?} */ (options));
	    };
	    /**
	     * Constructs an `Observable` which, when subscribed, will cause a request
	     * with the special method `JSONP` to be dispatched via the interceptor pipeline.
	     *
	     * A suitable interceptor must be installed (e.g. via the `HttpClientJsonpModule`).
	     * If no such interceptor is reached, then the `JSONP` request will likely be
	     * rejected by the configured backend.
	     */
	    /**
	     * Constructs an `Observable` which, when subscribed, will cause a request
	     * with the special method `JSONP` to be dispatched via the interceptor pipeline.
	     *
	     * A suitable interceptor must be installed (e.g. via the `HttpClientJsonpModule`).
	     * If no such interceptor is reached, then the `JSONP` request will likely be
	     * rejected by the configured backend.
	     * @template T
	     * @param {?} url
	     * @param {?} callbackParam
	     * @return {?}
	     */
	    HttpClient.prototype.jsonp = /**
	     * Constructs an `Observable` which, when subscribed, will cause a request
	     * with the special method `JSONP` to be dispatched via the interceptor pipeline.
	     *
	     * A suitable interceptor must be installed (e.g. via the `HttpClientJsonpModule`).
	     * If no such interceptor is reached, then the `JSONP` request will likely be
	     * rejected by the configured backend.
	     * @template T
	     * @param {?} url
	     * @param {?} callbackParam
	     * @return {?}
	     */
	    function (url, callbackParam) {
	        return this.request('JSONP', url, {
	            params: new HttpParams().append(callbackParam, 'JSONP_CALLBACK'),
	            observe: 'body',
	            responseType: 'json',
	        });
	    };
	    /**
	     * Constructs an `Observable` which, when subscribed, will cause the configured
	     * OPTIONS request to be executed on the server. See the individual overloads for
	     * details of `options()`'s return type based on the provided options.
	     */
	    /**
	     * Constructs an `Observable` which, when subscribed, will cause the configured
	     * OPTIONS request to be executed on the server. See the individual overloads for
	     * details of `options()`'s return type based on the provided options.
	     * @param {?} url
	     * @param {?=} options
	     * @return {?}
	     */
	    HttpClient.prototype.options = /**
	     * Constructs an `Observable` which, when subscribed, will cause the configured
	     * OPTIONS request to be executed on the server. See the individual overloads for
	     * details of `options()`'s return type based on the provided options.
	     * @param {?} url
	     * @param {?=} options
	     * @return {?}
	     */
	    function (url, options) {
	        if (options === void 0) { options = {}; }
	        return this.request('OPTIONS', url, /** @type {?} */ (options));
	    };
	    /**
	     * Constructs an `Observable` which, when subscribed, will cause the configured
	     * PATCH request to be executed on the server. See the individual overloads for
	     * details of `patch()`'s return type based on the provided options.
	     */
	    /**
	     * Constructs an `Observable` which, when subscribed, will cause the configured
	     * PATCH request to be executed on the server. See the individual overloads for
	     * details of `patch()`'s return type based on the provided options.
	     * @param {?} url
	     * @param {?} body
	     * @param {?=} options
	     * @return {?}
	     */
	    HttpClient.prototype.patch = /**
	     * Constructs an `Observable` which, when subscribed, will cause the configured
	     * PATCH request to be executed on the server. See the individual overloads for
	     * details of `patch()`'s return type based on the provided options.
	     * @param {?} url
	     * @param {?} body
	     * @param {?=} options
	     * @return {?}
	     */
	    function (url, body, options) {
	        if (options === void 0) { options = {}; }
	        return this.request('PATCH', url, addBody(options, body));
	    };
	    /**
	     * Constructs an `Observable` which, when subscribed, will cause the configured
	     * POST request to be executed on the server. See the individual overloads for
	     * details of `post()`'s return type based on the provided options.
	     */
	    /**
	     * Constructs an `Observable` which, when subscribed, will cause the configured
	     * POST request to be executed on the server. See the individual overloads for
	     * details of `post()`'s return type based on the provided options.
	     * @param {?} url
	     * @param {?} body
	     * @param {?=} options
	     * @return {?}
	     */
	    HttpClient.prototype.post = /**
	     * Constructs an `Observable` which, when subscribed, will cause the configured
	     * POST request to be executed on the server. See the individual overloads for
	     * details of `post()`'s return type based on the provided options.
	     * @param {?} url
	     * @param {?} body
	     * @param {?=} options
	     * @return {?}
	     */
	    function (url, body, options) {
	        if (options === void 0) { options = {}; }
	        return this.request('POST', url, addBody(options, body));
	    };
	    /**
	     * Constructs an `Observable` which, when subscribed, will cause the configured
	     * POST request to be executed on the server. See the individual overloads for
	     * details of `post()`'s return type based on the provided options.
	     */
	    /**
	     * Constructs an `Observable` which, when subscribed, will cause the configured
	     * POST request to be executed on the server. See the individual overloads for
	     * details of `post()`'s return type based on the provided options.
	     * @param {?} url
	     * @param {?} body
	     * @param {?=} options
	     * @return {?}
	     */
	    HttpClient.prototype.put = /**
	     * Constructs an `Observable` which, when subscribed, will cause the configured
	     * POST request to be executed on the server. See the individual overloads for
	     * details of `post()`'s return type based on the provided options.
	     * @param {?} url
	     * @param {?} body
	     * @param {?=} options
	     * @return {?}
	     */
	    function (url, body, options) {
	        if (options === void 0) { options = {}; }
	        return this.request('PUT', url, addBody(options, body));
	    };
	    HttpClient.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    HttpClient.ctorParameters = function () { return [
	        { type: HttpHandler, },
	    ]; };
	    return HttpClient;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * Intercepts `HttpRequest` and handles them.
	 *
	 * Most interceptors will transform the outgoing request before passing it to the
	 * next interceptor in the chain, by calling `next.handle(transformedReq)`.
	 *
	 * In rare cases, interceptors may wish to completely handle a request themselves,
	 * and not delegate to the remainder of the chain. This behavior is allowed.
	 *
	 * \@stable
	 * @record
	 */
	
	/**
	 * `HttpHandler` which applies an `HttpInterceptor` to an `HttpRequest`.
	 *
	 * \@stable
	 */
	var HttpInterceptorHandler = /** @class */ (function () {
	    function HttpInterceptorHandler(next, interceptor) {
	        this.next = next;
	        this.interceptor = interceptor;
	    }
	    /**
	     * @param {?} req
	     * @return {?}
	     */
	    HttpInterceptorHandler.prototype.handle = /**
	     * @param {?} req
	     * @return {?}
	     */
	    function (req) {
	        return this.interceptor.intercept(req, this.next);
	    };
	    return HttpInterceptorHandler;
	}());
	/**
	 * A multi-provider token which represents the array of `HttpInterceptor`s that
	 * are registered.
	 *
	 * \@stable
	 */
	var HTTP_INTERCEPTORS = new _angular_core.InjectionToken('HTTP_INTERCEPTORS');
	var NoopInterceptor = /** @class */ (function () {
	    function NoopInterceptor() {
	    }
	    /**
	     * @param {?} req
	     * @param {?} next
	     * @return {?}
	     */
	    NoopInterceptor.prototype.intercept = /**
	     * @param {?} req
	     * @param {?} next
	     * @return {?}
	     */
	    function (req, next) {
	        return next.handle(req);
	    };
	    NoopInterceptor.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    NoopInterceptor.ctorParameters = function () { return []; };
	    return NoopInterceptor;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	// Every request made through JSONP needs a callback name that's unique across the
	// whole page. Each request is assigned an id and the callback name is constructed
	// from that. The next id to be assigned is tracked in a global variable here that
	// is shared among all applications on the page.
	var nextRequestId = 0;
	// Error text given when a JSONP script is injected, but doesn't invoke the callback
	// passed in its URL.
	var JSONP_ERR_NO_CALLBACK = 'JSONP injected script did not invoke callback.';
	// Error text given when a request is passed to the JsonpClientBackend that doesn't
	// have a request method JSONP.
	var JSONP_ERR_WRONG_METHOD = 'JSONP requests must use JSONP request method.';
	var JSONP_ERR_WRONG_RESPONSE_TYPE = 'JSONP requests must use Json response type.';
	/**
	 * DI token/abstract type representing a map of JSONP callbacks.
	 *
	 * In the browser, this should always be the `window` object.
	 *
	 * \@stable
	 * @abstract
	 */
	var JsonpCallbackContext = /** @class */ (function () {
	    function JsonpCallbackContext() {
	    }
	    return JsonpCallbackContext;
	}());
	/**
	 * `HttpBackend` that only processes `HttpRequest` with the JSONP method,
	 * by performing JSONP style requests.
	 *
	 * \@stable
	 */
	var JsonpClientBackend = /** @class */ (function () {
	    function JsonpClientBackend(callbackMap, document) {
	        this.callbackMap = callbackMap;
	        this.document = document;
	    }
	    /**
	     * Get the name of the next callback method, by incrementing the global `nextRequestId`.
	     * @return {?}
	     */
	    JsonpClientBackend.prototype.nextCallback = /**
	     * Get the name of the next callback method, by incrementing the global `nextRequestId`.
	     * @return {?}
	     */
	    function () { return "ng_jsonp_callback_" + nextRequestId++; };
	    /**
	     * Process a JSONP request and return an event stream of the results.
	     */
	    /**
	     * Process a JSONP request and return an event stream of the results.
	     * @param {?} req
	     * @return {?}
	     */
	    JsonpClientBackend.prototype.handle = /**
	     * Process a JSONP request and return an event stream of the results.
	     * @param {?} req
	     * @return {?}
	     */
	    function (req) {
	        var _this = this;
	        // Firstly, check both the method and response type. If either doesn't match
	        // then the request was improperly routed here and cannot be handled.
	        if (req.method !== 'JSONP') {
	            throw new Error(JSONP_ERR_WRONG_METHOD);
	        }
	        else if (req.responseType !== 'json') {
	            throw new Error(JSONP_ERR_WRONG_RESPONSE_TYPE);
	        }
	        // Everything else happens inside the Observable boundary.
	        return new rxjs_Observable.Observable(function (observer) {
	            // The first step to make a request is to generate the callback name, and replace the
	            // callback placeholder in the URL with the name. Care has to be taken here to ensure
	            // a trailing &, if matched, gets inserted back into the URL in the correct place.
	            var /** @type {?} */ callback = _this.nextCallback();
	            var /** @type {?} */ url = req.urlWithParams.replace(/=JSONP_CALLBACK(&|$)/, "=" + callback + "$1");
	            // Construct the <script> tag and point it at the URL.
	            var /** @type {?} */ node = _this.document.createElement('script');
	            node.src = url;
	            // A JSONP request requires waiting for multiple callbacks. These variables
	            // are closed over and track state across those callbacks.
	            // The response object, if one has been received, or null otherwise.
	            var /** @type {?} */ body = null;
	            // Whether the response callback has been called.
	            var /** @type {?} */ finished = false;
	            // Whether the request has been cancelled (and thus any other callbacks)
	            // should be ignored.
	            var /** @type {?} */ cancelled = false;
	            // Set the response callback in this.callbackMap (which will be the window
	            // object in the browser. The script being loaded via the <script> tag will
	            // eventually call this callback.
	            // Set the response callback in this.callbackMap (which will be the window
	            // object in the browser. The script being loaded via the <script> tag will
	            // eventually call this callback.
	            _this.callbackMap[callback] = function (data) {
	                // Data has been received from the JSONP script. Firstly, delete this callback.
	                delete _this.callbackMap[callback];
	                // Next, make sure the request wasn't cancelled in the meantime.
	                if (cancelled) {
	                    return;
	                }
	                // Set state to indicate data was received.
	                body = data;
	                finished = true;
	            };
	            // cleanup() is a utility closure that removes the <script> from the page and
	            // the response callback from the window. This logic is used in both the
	            // success, error, and cancellation paths, so it's extracted out for convenience.
	            var /** @type {?} */ cleanup = function () {
	                // Remove the <script> tag if it's still on the page.
	                if (node.parentNode) {
	                    node.parentNode.removeChild(node);
	                }
	                // Remove the response callback from the callbackMap (window object in the
	                // browser).
	                delete _this.callbackMap[callback];
	            };
	            // onLoad() is the success callback which runs after the response callback
	            // if the JSONP script loads successfully. The event itself is unimportant.
	            // If something went wrong, onLoad() may run without the response callback
	            // having been invoked.
	            var /** @type {?} */ onLoad = function (event) {
	                // Do nothing if the request has been cancelled.
	                if (cancelled) {
	                    return;
	                }
	                // Cleanup the page.
	                cleanup();
	                // Check whether the response callback has run.
	                if (!finished) {
	                    // It hasn't, something went wrong with the request. Return an error via
	                    // the Observable error path. All JSONP errors have status 0.
	                    observer.error(new HttpErrorResponse({
	                        url: url,
	                        status: 0,
	                        statusText: 'JSONP Error',
	                        error: new Error(JSONP_ERR_NO_CALLBACK),
	                    }));
	                    return;
	                }
	                // Success. body either contains the response body or null if none was
	                // returned.
	                observer.next(new HttpResponse({
	                    body: body,
	                    status: 200,
	                    statusText: 'OK', url: url,
	                }));
	                // Complete the stream, the response is over.
	                observer.complete();
	            };
	            // onError() is the error callback, which runs if the script returned generates
	            // a Javascript error. It emits the error via the Observable error channel as
	            // a HttpErrorResponse.
	            var /** @type {?} */ onError = function (error) {
	                // If the request was already cancelled, no need to emit anything.
	                if (cancelled) {
	                    return;
	                }
	                cleanup();
	                // Wrap the error in a HttpErrorResponse.
	                observer.error(new HttpErrorResponse({
	                    error: error,
	                    status: 0,
	                    statusText: 'JSONP Error', url: url,
	                }));
	            };
	            // Subscribe to both the success (load) and error events on the <script> tag,
	            // and add it to the page.
	            node.addEventListener('load', onLoad);
	            node.addEventListener('error', onError);
	            _this.document.body.appendChild(node);
	            // The request has now been successfully sent.
	            observer.next({ type: HttpEventType.Sent });
	            // Cancellation handler.
	            return function () {
	                // Track the cancellation so event listeners won't do anything even if already scheduled.
	                cancelled = true;
	                // Remove the event listeners so they won't run if the events later fire.
	                node.removeEventListener('load', onLoad);
	                node.removeEventListener('error', onError);
	                // And finally, clean up the page.
	                cleanup();
	            };
	        });
	    };
	    JsonpClientBackend.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    JsonpClientBackend.ctorParameters = function () { return [
	        { type: JsonpCallbackContext, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    return JsonpClientBackend;
	}());
	/**
	 * An `HttpInterceptor` which identifies requests with the method JSONP and
	 * shifts them to the `JsonpClientBackend`.
	 *
	 * \@stable
	 */
	var JsonpInterceptor = /** @class */ (function () {
	    function JsonpInterceptor(jsonp) {
	        this.jsonp = jsonp;
	    }
	    /**
	     * @param {?} req
	     * @param {?} next
	     * @return {?}
	     */
	    JsonpInterceptor.prototype.intercept = /**
	     * @param {?} req
	     * @param {?} next
	     * @return {?}
	     */
	    function (req, next) {
	        if (req.method === 'JSONP') {
	            return this.jsonp.handle(/** @type {?} */ (req));
	        }
	        // Fall through for normal HTTP requests.
	        return next.handle(req);
	    };
	    JsonpInterceptor.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    JsonpInterceptor.ctorParameters = function () { return [
	        { type: JsonpClientBackend, },
	    ]; };
	    return JsonpInterceptor;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var XSSI_PREFIX = /^\)\]\}',?\n/;
	/**
	 * Determine an appropriate URL for the response, by checking either
	 * XMLHttpRequest.responseURL or the X-Request-URL header.
	 * @param {?} xhr
	 * @return {?}
	 */
	function getResponseUrl(xhr) {
	    if ('responseURL' in xhr && xhr.responseURL) {
	        return xhr.responseURL;
	    }
	    if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	        return xhr.getResponseHeader('X-Request-URL');
	    }
	    return null;
	}
	/**
	 * A wrapper around the `XMLHttpRequest` constructor.
	 *
	 * \@stable
	 * @abstract
	 */
	var XhrFactory = /** @class */ (function () {
	    function XhrFactory() {
	    }
	    return XhrFactory;
	}());
	/**
	 * A factory for \@{link HttpXhrBackend} that uses the `XMLHttpRequest` browser API.
	 *
	 * \@stable
	 */
	var BrowserXhr = /** @class */ (function () {
	    function BrowserXhr() {
	    }
	    /**
	     * @return {?}
	     */
	    BrowserXhr.prototype.build = /**
	     * @return {?}
	     */
	    function () { return /** @type {?} */ ((new XMLHttpRequest())); };
	    BrowserXhr.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    BrowserXhr.ctorParameters = function () { return []; };
	    return BrowserXhr;
	}());
	/**
	 * An `HttpBackend` which uses the XMLHttpRequest API to send
	 * requests to a backend server.
	 *
	 * \@stable
	 */
	var HttpXhrBackend = /** @class */ (function () {
	    function HttpXhrBackend(xhrFactory) {
	        this.xhrFactory = xhrFactory;
	    }
	    /**
	     * Process a request and return a stream of response events.
	     */
	    /**
	     * Process a request and return a stream of response events.
	     * @param {?} req
	     * @return {?}
	     */
	    HttpXhrBackend.prototype.handle = /**
	     * Process a request and return a stream of response events.
	     * @param {?} req
	     * @return {?}
	     */
	    function (req) {
	        var _this = this;
	        // Quick check to give a better error message when a user attempts to use
	        // HttpClient.jsonp() without installing the JsonpClientModule
	        if (req.method === 'JSONP') {
	            throw new Error("Attempted to construct Jsonp request without JsonpClientModule installed.");
	        }
	        // Everything happens on Observable subscription.
	        return new rxjs_Observable.Observable(function (observer) {
	            // Start by setting up the XHR object with request method, URL, and withCredentials flag.
	            var /** @type {?} */ xhr = _this.xhrFactory.build();
	            xhr.open(req.method, req.urlWithParams);
	            if (!!req.withCredentials) {
	                xhr.withCredentials = true;
	            }
	            // Add all the requested headers.
	            req.headers.forEach(function (name, values) { return xhr.setRequestHeader(name, values.join(',')); });
	            // Add an Accept header if one isn't present already.
	            if (!req.headers.has('Accept')) {
	                xhr.setRequestHeader('Accept', 'application/json, text/plain, */*');
	            }
	            // Auto-detect the Content-Type header if one isn't present already.
	            if (!req.headers.has('Content-Type')) {
	                var /** @type {?} */ detectedType = req.detectContentTypeHeader();
	                // Sometimes Content-Type detection fails.
	                if (detectedType !== null) {
	                    xhr.setRequestHeader('Content-Type', detectedType);
	                }
	            }
	            // Set the responseType if one was requested.
	            if (req.responseType) {
	                var /** @type {?} */ responseType = req.responseType.toLowerCase();
	                // JSON responses need to be processed as text. This is because if the server
	                // returns an XSSI-prefixed JSON response, the browser will fail to parse it,
	                // xhr.response will be null, and xhr.responseText cannot be accessed to
	                // retrieve the prefixed JSON data in order to strip the prefix. Thus, all JSON
	                // is parsed by first requesting text and then applying JSON.parse.
	                xhr.responseType = /** @type {?} */ (((responseType !== 'json') ? responseType : 'text'));
	            }
	            // Serialize the request body if one is present. If not, this will be set to null.
	            var /** @type {?} */ reqBody = req.serializeBody();
	            // If progress events are enabled, response headers will be delivered
	            // in two events - the HttpHeaderResponse event and the full HttpResponse
	            // event. However, since response headers don't change in between these
	            // two events, it doesn't make sense to parse them twice. So headerResponse
	            // caches the data extracted from the response whenever it's first parsed,
	            // to ensure parsing isn't duplicated.
	            var /** @type {?} */ headerResponse = null;
	            // partialFromXhr extracts the HttpHeaderResponse from the current XMLHttpRequest
	            // state, and memoizes it into headerResponse.
	            var /** @type {?} */ partialFromXhr = function () {
	                if (headerResponse !== null) {
	                    return headerResponse;
	                }
	                // Read status and normalize an IE9 bug (http://bugs.jquery.com/ticket/1450).
	                var /** @type {?} */ status = xhr.status === 1223 ? 204 : xhr.status;
	                var /** @type {?} */ statusText = xhr.statusText || 'OK';
	                // Parse headers from XMLHttpRequest - this step is lazy.
	                var /** @type {?} */ headers = new HttpHeaders(xhr.getAllResponseHeaders());
	                // Read the response URL from the XMLHttpResponse instance and fall back on the
	                // request URL.
	                var /** @type {?} */ url = getResponseUrl(xhr) || req.url;
	                // Construct the HttpHeaderResponse and memoize it.
	                headerResponse = new HttpHeaderResponse({ headers: headers, status: status, statusText: statusText, url: url });
	                return headerResponse;
	            };
	            // Next, a few closures are defined for the various events which XMLHttpRequest can
	            // emit. This allows them to be unregistered as event listeners later.
	            // First up is the load event, which represents a response being fully available.
	            var /** @type {?} */ onLoad = function () {
	                // Read response state from the memoized partial data.
	                var _a = partialFromXhr(), headers = _a.headers, status = _a.status, statusText = _a.statusText, url = _a.url;
	                // The body will be read out if present.
	                var /** @type {?} */ body = null;
	                if (status !== 204) {
	                    // Use XMLHttpRequest.response if set, responseText otherwise.
	                    body = (typeof xhr.response === 'undefined') ? xhr.responseText : xhr.response;
	                }
	                // Normalize another potential bug (this one comes from CORS).
	                if (status === 0) {
	                    status = !!body ? 200 : 0;
	                }
	                // ok determines whether the response will be transmitted on the event or
	                // error channel. Unsuccessful status codes (not 2xx) will always be errors,
	                // but a successful status code can still result in an error if the user
	                // asked for JSON data and the body cannot be parsed as such.
	                var /** @type {?} */ ok = status >= 200 && status < 300;
	                // Check whether the body needs to be parsed as JSON (in many cases the browser
	                // will have done that already).
	                if (req.responseType === 'json' && typeof body === 'string') {
	                    // Save the original body, before attempting XSSI prefix stripping.
	                    var /** @type {?} */ originalBody = body;
	                    body = body.replace(XSSI_PREFIX, '');
	                    try {
	                        // Attempt the parse. If it fails, a parse error should be delivered to the user.
	                        body = body !== '' ? JSON.parse(body) : null;
	                    }
	                    catch (/** @type {?} */ error) {
	                        // Since the JSON.parse failed, it's reasonable to assume this might not have been a
	                        // JSON response. Restore the original body (including any XSSI prefix) to deliver
	                        // a better error response.
	                        body = originalBody;
	                        // If this was an error request to begin with, leave it as a string, it probably
	                        // just isn't JSON. Otherwise, deliver the parsing error to the user.
	                        if (ok) {
	                            // Even though the response status was 2xx, this is still an error.
	                            ok = false;
	                            // The parse error contains the text of the body that failed to parse.
	                            body = /** @type {?} */ ({ error: error, text: body });
	                        }
	                    }
	                }
	                if (ok) {
	                    // A successful response is delivered on the event stream.
	                    observer.next(new HttpResponse({
	                        body: body,
	                        headers: headers,
	                        status: status,
	                        statusText: statusText,
	                        url: url || undefined,
	                    }));
	                    // The full body has been received and delivered, no further events
	                    // are possible. This request is complete.
	                    observer.complete();
	                }
	                else {
	                    // An unsuccessful request is delivered on the error channel.
	                    observer.error(new HttpErrorResponse({
	                        // The error in this case is the response body (error from the server).
	                        error: body,
	                        headers: headers,
	                        status: status,
	                        statusText: statusText,
	                        url: url || undefined,
	                    }));
	                }
	            };
	            // The onError callback is called when something goes wrong at the network level.
	            // Connection timeout, DNS error, offline, etc. These are actual errors, and are
	            // transmitted on the error channel.
	            var /** @type {?} */ onError = function (error) {
	                var /** @type {?} */ res = new HttpErrorResponse({
	                    error: error,
	                    status: xhr.status || 0,
	                    statusText: xhr.statusText || 'Unknown Error',
	                });
	                observer.error(res);
	            };
	            // The sentHeaders flag tracks whether the HttpResponseHeaders event
	            // has been sent on the stream. This is necessary to track if progress
	            // is enabled since the event will be sent on only the first download
	            // progerss event.
	            var /** @type {?} */ sentHeaders = false;
	            // The download progress event handler, which is only registered if
	            // progress events are enabled.
	            var /** @type {?} */ onDownProgress = function (event) {
	                // Send the HttpResponseHeaders event if it hasn't been sent already.
	                if (!sentHeaders) {
	                    observer.next(partialFromXhr());
	                    sentHeaders = true;
	                }
	                // Start building the download progress event to deliver on the response
	                // event stream.
	                var /** @type {?} */ progressEvent = {
	                    type: HttpEventType.DownloadProgress,
	                    loaded: event.loaded,
	                };
	                // Set the total number of bytes in the event if it's available.
	                if (event.lengthComputable) {
	                    progressEvent.total = event.total;
	                }
	                // If the request was for text content and a partial response is
	                // available on XMLHttpRequest, include it in the progress event
	                // to allow for streaming reads.
	                if (req.responseType === 'text' && !!xhr.responseText) {
	                    progressEvent.partialText = xhr.responseText;
	                }
	                // Finally, fire the event.
	                observer.next(progressEvent);
	            };
	            // The upload progress event handler, which is only registered if
	            // progress events are enabled.
	            var /** @type {?} */ onUpProgress = function (event) {
	                // Upload progress events are simpler. Begin building the progress
	                // event.
	                var /** @type {?} */ progress = {
	                    type: HttpEventType.UploadProgress,
	                    loaded: event.loaded,
	                };
	                // If the total number of bytes being uploaded is available, include
	                // it.
	                if (event.lengthComputable) {
	                    progress.total = event.total;
	                }
	                // Send the event.
	                observer.next(progress);
	            };
	            // By default, register for load and error events.
	            xhr.addEventListener('load', onLoad);
	            xhr.addEventListener('error', onError);
	            // Progress events are only enabled if requested.
	            if (req.reportProgress) {
	                // Download progress is always enabled if requested.
	                xhr.addEventListener('progress', onDownProgress);
	                // Upload progress depends on whether there is a body to upload.
	                if (reqBody !== null && xhr.upload) {
	                    xhr.upload.addEventListener('progress', onUpProgress);
	                }
	            }
	            // Fire the request, and notify the event stream that it was fired.
	            xhr.send(reqBody);
	            observer.next({ type: HttpEventType.Sent });
	            // This is the return from the Observable function, which is the
	            // request cancellation handler.
	            return function () {
	                // On a cancellation, remove all registered event listeners.
	                xhr.removeEventListener('error', onError);
	                xhr.removeEventListener('load', onLoad);
	                if (req.reportProgress) {
	                    xhr.removeEventListener('progress', onDownProgress);
	                    if (reqBody !== null && xhr.upload) {
	                        xhr.upload.removeEventListener('progress', onUpProgress);
	                    }
	                }
	                // Finally, abort the in-flight request.
	                xhr.abort();
	            };
	        });
	    };
	    HttpXhrBackend.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    HttpXhrBackend.ctorParameters = function () { return [
	        { type: XhrFactory, },
	    ]; };
	    return HttpXhrBackend;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	var XSRF_COOKIE_NAME = new _angular_core.InjectionToken('XSRF_COOKIE_NAME');
	var XSRF_HEADER_NAME = new _angular_core.InjectionToken('XSRF_HEADER_NAME');
	/**
	 * Retrieves the current XSRF token to use with the next outgoing request.
	 *
	 * \@stable
	 * @abstract
	 */
	var HttpXsrfTokenExtractor = /** @class */ (function () {
	    function HttpXsrfTokenExtractor() {
	    }
	    return HttpXsrfTokenExtractor;
	}());
	/**
	 * `HttpXsrfTokenExtractor` which retrieves the token from a cookie.
	 */
	var HttpXsrfCookieExtractor = /** @class */ (function () {
	    function HttpXsrfCookieExtractor(doc, platform, cookieName) {
	        this.doc = doc;
	        this.platform = platform;
	        this.cookieName = cookieName;
	        this.lastCookieString = '';
	        this.lastToken = null;
	        /**
	         * \@internal for testing
	         */
	        this.parseCount = 0;
	    }
	    /**
	     * @return {?}
	     */
	    HttpXsrfCookieExtractor.prototype.getToken = /**
	     * @return {?}
	     */
	    function () {
	        if (this.platform === 'server') {
	            return null;
	        }
	        var /** @type {?} */ cookieString = this.doc.cookie || '';
	        if (cookieString !== this.lastCookieString) {
	            this.parseCount++;
	            this.lastToken = _angular_common.ɵparseCookieValue(cookieString, this.cookieName);
	            this.lastCookieString = cookieString;
	        }
	        return this.lastToken;
	    };
	    HttpXsrfCookieExtractor.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    HttpXsrfCookieExtractor.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_core.PLATFORM_ID,] },] },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [XSRF_COOKIE_NAME,] },] },
	    ]; };
	    return HttpXsrfCookieExtractor;
	}());
	/**
	 * `HttpInterceptor` which adds an XSRF token to eligible outgoing requests.
	 */
	var HttpXsrfInterceptor = /** @class */ (function () {
	    function HttpXsrfInterceptor(tokenService, headerName) {
	        this.tokenService = tokenService;
	        this.headerName = headerName;
	    }
	    /**
	     * @param {?} req
	     * @param {?} next
	     * @return {?}
	     */
	    HttpXsrfInterceptor.prototype.intercept = /**
	     * @param {?} req
	     * @param {?} next
	     * @return {?}
	     */
	    function (req, next) {
	        var /** @type {?} */ lcUrl = req.url.toLowerCase();
	        // Skip both non-mutating requests and absolute URLs.
	        // Non-mutating requests don't require a token, and absolute URLs require special handling
	        // anyway as the cookie set
	        // on our origin is not the same as the token expected by another origin.
	        if (req.method === 'GET' || req.method === 'HEAD' || lcUrl.startsWith('http://') ||
	            lcUrl.startsWith('https://')) {
	            return next.handle(req);
	        }
	        var /** @type {?} */ token = this.tokenService.getToken();
	        // Be careful not to overwrite an existing header of the same name.
	        if (token !== null && !req.headers.has(this.headerName)) {
	            req = req.clone({ headers: req.headers.set(this.headerName, token) });
	        }
	        return next.handle(req);
	    };
	    HttpXsrfInterceptor.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    HttpXsrfInterceptor.ctorParameters = function () { return [
	        { type: HttpXsrfTokenExtractor, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [XSRF_HEADER_NAME,] },] },
	    ]; };
	    return HttpXsrfInterceptor;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * An `HttpHandler` that applies a bunch of `HttpInterceptor`s
	 * to a request before passing it to the given `HttpBackend`.
	 *
	 * The interceptors are loaded lazily from the injector, to allow
	 * interceptors to themselves inject classes depending indirectly
	 * on `HttpInterceptingHandler` itself.
	 */
	var HttpInterceptingHandler = /** @class */ (function () {
	    function HttpInterceptingHandler(backend, injector) {
	        this.backend = backend;
	        this.injector = injector;
	        this.chain = null;
	    }
	    /**
	     * @param {?} req
	     * @return {?}
	     */
	    HttpInterceptingHandler.prototype.handle = /**
	     * @param {?} req
	     * @return {?}
	     */
	    function (req) {
	        if (this.chain === null) {
	            var /** @type {?} */ interceptors = this.injector.get(HTTP_INTERCEPTORS, []);
	            this.chain = interceptors.reduceRight(function (next, interceptor) { return new HttpInterceptorHandler(next, interceptor); }, this.backend);
	        }
	        return this.chain.handle(req);
	    };
	    HttpInterceptingHandler.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    HttpInterceptingHandler.ctorParameters = function () { return [
	        { type: HttpBackend, },
	        { type: _angular_core.Injector, },
	    ]; };
	    return HttpInterceptingHandler;
	}());
	/**
	 * Constructs an `HttpHandler` that applies a bunch of `HttpInterceptor`s
	 * to a request before passing it to the given `HttpBackend`.
	 *
	 * Meant to be used as a factory function within `HttpClientModule`.
	 *
	 * \@stable
	 * @param {?} backend
	 * @param {?=} interceptors
	 * @return {?}
	 */
	function interceptingHandler(backend, interceptors) {
	    if (interceptors === void 0) { interceptors = []; }
	    if (!interceptors) {
	        return backend;
	    }
	    return interceptors.reduceRight(function (next, interceptor) { return new HttpInterceptorHandler(next, interceptor); }, backend);
	}
	/**
	 * Factory function that determines where to store JSONP callbacks.
	 *
	 * Ordinarily JSONP callbacks are stored on the `window` object, but this may not exist
	 * in test environments. In that case, callbacks are stored on an anonymous object instead.
	 *
	 * \@stable
	 * @return {?}
	 */
	function jsonpCallbackContext() {
	    if (typeof window === 'object') {
	        return window;
	    }
	    return {};
	}
	/**
	 * `NgModule` which adds XSRF protection support to outgoing requests.
	 *
	 * Provided the server supports a cookie-based XSRF protection system, this
	 * module can be used directly to configure XSRF protection with the correct
	 * cookie and header names.
	 *
	 * If no such names are provided, the default is to use `X-XSRF-TOKEN` for
	 * the header name and `XSRF-TOKEN` for the cookie name.
	 *
	 * \@stable
	 */
	var HttpClientXsrfModule = /** @class */ (function () {
	    function HttpClientXsrfModule() {
	    }
	    /**
	     * Disable the default XSRF protection.
	     */
	    /**
	     * Disable the default XSRF protection.
	     * @return {?}
	     */
	    HttpClientXsrfModule.disable = /**
	     * Disable the default XSRF protection.
	     * @return {?}
	     */
	    function () {
	        return {
	            ngModule: HttpClientXsrfModule,
	            providers: [
	                { provide: HttpXsrfInterceptor, useClass: NoopInterceptor },
	            ],
	        };
	    };
	    /**
	     * Configure XSRF protection to use the given cookie name or header name,
	     * or the default names (as described above) if not provided.
	     */
	    /**
	     * Configure XSRF protection to use the given cookie name or header name,
	     * or the default names (as described above) if not provided.
	     * @param {?=} options
	     * @return {?}
	     */
	    HttpClientXsrfModule.withOptions = /**
	     * Configure XSRF protection to use the given cookie name or header name,
	     * or the default names (as described above) if not provided.
	     * @param {?=} options
	     * @return {?}
	     */
	    function (options) {
	        if (options === void 0) { options = {}; }
	        return {
	            ngModule: HttpClientXsrfModule,
	            providers: [
	                options.cookieName ? { provide: XSRF_COOKIE_NAME, useValue: options.cookieName } : [],
	                options.headerName ? { provide: XSRF_HEADER_NAME, useValue: options.headerName } : [],
	            ],
	        };
	    };
	    HttpClientXsrfModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    providers: [
	                        HttpXsrfInterceptor,
	                        { provide: HTTP_INTERCEPTORS, useExisting: HttpXsrfInterceptor, multi: true },
	                        { provide: HttpXsrfTokenExtractor, useClass: HttpXsrfCookieExtractor },
	                        { provide: XSRF_COOKIE_NAME, useValue: 'XSRF-TOKEN' },
	                        { provide: XSRF_HEADER_NAME, useValue: 'X-XSRF-TOKEN' },
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    HttpClientXsrfModule.ctorParameters = function () { return []; };
	    return HttpClientXsrfModule;
	}());
	/**
	 * `NgModule` which provides the `HttpClient` and associated services.
	 *
	 * Interceptors can be added to the chain behind `HttpClient` by binding them
	 * to the multiprovider for `HTTP_INTERCEPTORS`.
	 *
	 * \@stable
	 */
	var HttpClientModule = /** @class */ (function () {
	    function HttpClientModule() {
	    }
	    HttpClientModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [
	                        HttpClientXsrfModule.withOptions({
	                            cookieName: 'XSRF-TOKEN',
	                            headerName: 'X-XSRF-TOKEN',
	                        }),
	                    ],
	                    providers: [
	                        HttpClient,
	                        { provide: HttpHandler, useClass: HttpInterceptingHandler },
	                        HttpXhrBackend,
	                        { provide: HttpBackend, useExisting: HttpXhrBackend },
	                        BrowserXhr,
	                        { provide: XhrFactory, useExisting: BrowserXhr },
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    HttpClientModule.ctorParameters = function () { return []; };
	    return HttpClientModule;
	}());
	/**
	 * `NgModule` which enables JSONP support in `HttpClient`.
	 *
	 * Without this module, Jsonp requests will reach the backend
	 * with method JSONP, where they'll be rejected.
	 *
	 * \@stable
	 */
	var HttpClientJsonpModule = /** @class */ (function () {
	    function HttpClientJsonpModule() {
	    }
	    HttpClientJsonpModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    providers: [
	                        JsonpClientBackend,
	                        { provide: JsonpCallbackContext, useFactory: jsonpCallbackContext },
	                        { provide: HTTP_INTERCEPTORS, useClass: JsonpInterceptor, multi: true },
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    HttpClientJsonpModule.ctorParameters = function () { return []; };
	    return HttpClientJsonpModule;
	}());
	
	exports.HttpBackend = HttpBackend;
	exports.HttpHandler = HttpHandler;
	exports.HttpClient = HttpClient;
	exports.HttpHeaders = HttpHeaders;
	exports.HTTP_INTERCEPTORS = HTTP_INTERCEPTORS;
	exports.JsonpClientBackend = JsonpClientBackend;
	exports.JsonpInterceptor = JsonpInterceptor;
	exports.HttpClientJsonpModule = HttpClientJsonpModule;
	exports.HttpClientModule = HttpClientModule;
	exports.HttpClientXsrfModule = HttpClientXsrfModule;
	exports.ɵinterceptingHandler = interceptingHandler;
	exports.HttpParams = HttpParams;
	exports.HttpUrlEncodingCodec = HttpUrlEncodingCodec;
	exports.HttpRequest = HttpRequest;
	exports.HttpErrorResponse = HttpErrorResponse;
	exports.HttpEventType = HttpEventType;
	exports.HttpHeaderResponse = HttpHeaderResponse;
	exports.HttpResponse = HttpResponse;
	exports.HttpResponseBase = HttpResponseBase;
	exports.HttpXhrBackend = HttpXhrBackend;
	exports.XhrFactory = XhrFactory;
	exports.HttpXsrfTokenExtractor = HttpXsrfTokenExtractor;
	exports.ɵa = NoopInterceptor;
	exports.ɵb = JsonpCallbackContext;
	exports.ɵc = HttpInterceptingHandler;
	exports.ɵd = jsonpCallbackContext;
	exports.ɵe = BrowserXhr;
	exports.ɵh = HttpXsrfCookieExtractor;
	exports.ɵi = HttpXsrfInterceptor;
	exports.ɵf = XSRF_COOKIE_NAME;
	exports.ɵg = XSRF_HEADER_NAME;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=common-http.umd.js.map


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __createBinding;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __createBinding = function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    };
	
	    __exportStar = function (m, exports) {
	        for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
	    };
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 854 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var StoreService = (function () {
	    function StoreService() {
	        this.store = new Map();
	    }
	    StoreService.getInstance = function () {
	        if (StoreService.instance == null) {
	            StoreService.instance = new StoreService();
	        }
	        return StoreService.instance;
	    };
	    StoreService.prototype.setValue = function (key, value) {
	        this.store.set(key, value);
	    };
	    StoreService.prototype.getValue = function (key) {
	        return this.store.get(key);
	    };
	    StoreService.prototype.deleteValue = function (key) {
	        this.store.delete(key);
	    };
	    StoreService.prototype.clear = function () {
	        this.store.clear();
	    };
	    StoreService.instance = null;
	    return StoreService;
	}());
	exports.StoreService = StoreService;


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var router_1 = __webpack_require__(270);
	var roles_guard_1 = __webpack_require__(856);
	var role_service_1 = __webpack_require__(851);
	var RolesTabsGuard = (function () {
	    function RolesTabsGuard(_router, roleService) {
	        this._router = _router;
	        this.roleService = roleService;
	    }
	    RolesTabsGuard.prototype.canActivate = function (route, state) {
	        var permission = this.getTabPermission(route, state);
	        if (!permission) {
	            permission = this.getNextTabEnable(route);
	            if (permission) {
	                this._router.navigate([permission.route.replace(':id', route.params['id'])]);
	            }
	            else {
	                this._router.navigate([roles_guard_1.RolesGuard.UNAUTHORIZED_PAGE]);
	            }
	            return false;
	        }
	        return true;
	    };
	    RolesTabsGuard.prototype.getTabPermission = function (route, state) {
	        return this.getTabPermissions(route).find(function (permission) {
	            var permissionRegex = new RegExp('^' + permission.route.replace('/:id', '/[0-9]+') + '$');
	            return permissionRegex.test(state.url);
	        });
	    };
	    RolesTabsGuard.prototype.getTabPermissions = function (route) {
	        return this.roleService.getPermissions().filter(function (permission) {
	            var reg = new RegExp(route.routeConfig.path + '.+');
	            return reg.test(permission.route);
	        });
	    };
	    RolesTabsGuard.prototype.getNextTabEnable = function (route) {
	        return this.getTabPermissions(route).find(function (permission) {
	            var child = route.routeConfig.children.find(function (child) {
	                var reg = new RegExp("/" + child.path + ".*");
	                return reg.test(permission.route);
	            });
	            return !!child;
	        });
	    };
	    RolesTabsGuard.prototype.canActivateChild = function (childRoute, state) {
	        var permission = this.roleService.getPermissions().find(function (permission) {
	            var permissionRegex = new RegExp('^' + permission.route.replace('/:id', '/[0-9]+') + '$');
	            return permissionRegex.test(state.url);
	        });
	        if (!permission) {
	            this._router.navigate([roles_guard_1.RolesGuard.UNAUTHORIZED_PAGE]);
	            return false;
	        }
	        return true;
	    };
	    RolesTabsGuard = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [router_1.Router, role_service_1.RoleService])
	    ], RolesTabsGuard);
	    return RolesTabsGuard;
	}());
	exports.RolesTabsGuard = RolesTabsGuard;


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var router_1 = __webpack_require__(270);
	var role_service_1 = __webpack_require__(851);
	var utils_1 = __webpack_require__(740);
	var RolesGuard = (function () {
	    function RolesGuard(_router, roleService) {
	        this._router = _router;
	        this.roleService = roleService;
	    }
	    RolesGuard_1 = RolesGuard;
	    RolesGuard.prototype.canActivateChild = function (childRoute, state) {
	        return this.checkAccess(state);
	    };
	    RolesGuard.prototype.canActivate = function (route, state) {
	        return this.checkAccess(state);
	    };
	    RolesGuard.prototype.checkAccess = function (state) {
	        var granted = utils_1.StringUtils.equalsIgnoreCase(RolesGuard_1.UNAUTHORIZED_PAGE, state.url)
	            || this.roleService.hasAccess(state.url);
	        console.log('checkAccess : ' + state.url + ": " + granted);
	        if (!granted) {
	            this._router.navigate([RolesGuard_1.UNAUTHORIZED_PAGE]);
	        }
	        return granted;
	    };
	    RolesGuard.forRoles = function (roles) {
	        var RolesGuardWithParameters = (function () {
	            function RolesGuardWithParameters(_router, roleService) {
	                this._router = _router;
	                this.roleService = roleService;
	            }
	            RolesGuardWithParameters.prototype.canActivate = function (route, state) {
	                return this.checkRoles(state);
	            };
	            RolesGuardWithParameters.prototype.canActivateChild = function (childRoute, state) {
	                return this.checkRoles(state);
	            };
	            RolesGuardWithParameters.prototype.checkRoles = function (state) {
	                console.log('checkAccess : ' + state.url);
	                var granted = this.roleService.hasRoles(roles, state.url);
	                if (!granted) {
	                    this._router.navigate([RolesGuard_1.UNAUTHORIZED_PAGE]);
	                }
	                return granted;
	            };
	            RolesGuardWithParameters = __decorate([
	                core_1.Injectable(),
	                __metadata("design:paramtypes", [router_1.Router, role_service_1.RoleService])
	            ], RolesGuardWithParameters);
	            return RolesGuardWithParameters;
	        }());
	        RolesGuard_1.guards.push(RolesGuardWithParameters);
	        return RolesGuardWithParameters;
	    };
	    RolesGuard.UNAUTHORIZED_PAGE = '/space/unauthorized';
	    RolesGuard.guards = [];
	    RolesGuard = RolesGuard_1 = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [router_1.Router, role_service_1.RoleService])
	    ], RolesGuard);
	    return RolesGuard;
	    var RolesGuard_1;
	}());
	exports.RolesGuard = RolesGuard;


/***/ }),
/* 857 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Menu routes (core.menu.name) checked exactly with RoleService.hasExactRouteRoles/hasExactRouteAccess. */
	exports.CUSTOMER_USERS_TAB_ROUTE = '/space/customers/profiles/registered/:id/users';
	exports.CUSTOMER_API_ACCESS_TAB_ROUTE = '/space/customers/profiles/registered/:id/api-access';


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(859));
	var notification_component_1 = __webpack_require__(872);
	exports.LOGIN_COMPONENTS = [
	    notification_component_1.NotificationComponent
	];


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var router_1 = __webpack_require__(270);
	var core_1 = __webpack_require__(205);
	var login_service_1 = __webpack_require__(860);
	var cookies_1 = __webpack_require__(738);
	var security_1 = __webpack_require__(736);
	var utils_1 = __webpack_require__(740);
	var LoginComponent = (function () {
	    function LoginComponent(router, _loginService, _sessionService) {
	        this.router = router;
	        this._loginService = _loginService;
	        this._sessionService = _sessionService;
	        this.model = {
	            login: '',
	            password: ''
	        };
	        this.message = null;
	        this.loading = false;
	        this.showLogoutMessage = false;
	        this.showExpiredMessage = false;
	    }
	    LoginComponent.prototype.ngOnInit = function () {
	        if (cookies_1.CookiesManager.isTokenExist()) {
	            this.router.navigate(['space']);
	        }
	        this.showLogoutMessage = this._sessionService.isSessionLogout();
	        this.showExpiredMessage = this._sessionService.isSessionExpired();
	        this._sessionService.clearSessionCloseReason();
	    };
	    LoginComponent.prototype.submit = function (event) {
	        var _this = this;
	        event.preventDefault();
	        this.message = null;
	        this.loading = true;
	        this._loginService
	            .login(this.getCredentials())
	            .subscribe(function (session) { return _this.successLogin(session); }, function (error) { return _this.failureLogin(error); });
	    };
	    LoginComponent.prototype.hasMessage = function () {
	        return this.message !== null;
	    };
	    LoginComponent.prototype.successLogin = function (session) {
	        this._sessionService.login(session);
	    };
	    LoginComponent.prototype.failureLogin = function (error) {
	        this.message = error.message;
	        this.loading = false;
	    };
	    LoginComponent.prototype.getCredentials = function () {
	        return Object.assign({}, this.model, { password: utils_1.HashUtils.sha512(this.model.password) });
	    };
	    LoginComponent = __decorate([
	        core_1.Component({
	            selector: 'login',
	            providers: [login_service_1.LoginService],
	            template: __webpack_require__(871)
	        }),
	        __metadata("design:paramtypes", [router_1.Router,
	            login_service_1.LoginService,
	            security_1.SessionService])
	    ], LoginComponent);
	    return LoginComponent;
	}());
	exports.LoginComponent = LoginComponent;


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var constants_1 = __webpack_require__(861);
	var LoginService = (function () {
	    function LoginService(_http) {
	        this._http = _http;
	    }
	    LoginService.prototype.login = function (credentials) {
	        return this._http.post('/api/backoffice/token', {}, this.getRequestOptions(credentials))
	            .map(function (request) {
	            var token = request.headers.get(constants_1.TOKEN_HEADER);
	            var body = request.json();
	            return {
	                token: token,
	                expires: body.expireTimeMinutes
	            };
	        });
	    };
	    LoginService.prototype.getRequestOptions = function (credentials) {
	        return {
	            headers: new http_1.Headers((_a = {},
	                _a[constants_1.TOKEN_HEADER_USERNAME] = credentials.login,
	                _a[constants_1.TOKEN_HEADER_PASSWORD] = credentials.password,
	                _a))
	        };
	        var _a;
	    };
	    LoginService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], LoginService);
	    return LoginService;
	}());
	exports.LoginService = LoginService;


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(862));
	__export(__webpack_require__(863));
	__export(__webpack_require__(864));
	__export(__webpack_require__(865));
	__export(__webpack_require__(866));
	__export(__webpack_require__(867));
	__export(__webpack_require__(868));
	__export(__webpack_require__(869));
	__export(__webpack_require__(870));


/***/ }),
/* 862 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TEXT = 'text';
	exports.PHONE = 'phone';
	exports.EMAIL = 'email';
	exports.MONEY = 'money';
	exports.DATE = 'date';
	exports.INTEGER = 'integer';
	exports.FLOAT = 'float';
	exports.DOCUMENT = 'document';
	exports.PERCENTAGE = 'percentage';
	exports.PERCENTAGE_DECIMAL = 'percentage-decimal';
	exports.FIRST_LETTER = 'first-letter';


/***/ }),
/* 863 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * Defining constants with dates
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/* Thu, 01 Jan 1970 00:00:00 GMT */
	exports.MIN_DATE_OF_INCORPORATION = new Date(1970);
	exports.MIN_PASSPORT_ISSUE_DATE = new Date(1900, 0, 1);


/***/ }),
/* 864 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TOKEN_HEADER = 'X-Auth-Token';
	exports.TOKEN_HEADER_USERNAME = 'X-Username';
	exports.TOKEN_HEADER_PASSWORD = 'X-Password';


/***/ }),
/* 865 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.HttpStatus = {
	    BAD_REQUEST: 400,
	    UNAUTHORIZED: 401,
	    FORBIDDEN: 403,
	    NOT_FOUND: 404,
	    INTERNAL_SERVER_ERROR: 500,
	    BAD_GATEWAY_ERROR: 502
	};


/***/ }),
/* 866 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CARD_TYPE;
	(function (CARD_TYPE) {
	    CARD_TYPE[CARD_TYPE["MASTER_CARD"] = 1] = "MASTER_CARD";
	    CARD_TYPE[CARD_TYPE["VISA"] = 2] = "VISA";
	})(CARD_TYPE = exports.CARD_TYPE || (exports.CARD_TYPE = {}));
	var CARD_PROVIDER_TYPE;
	(function (CARD_PROVIDER_TYPE) {
	    CARD_PROVIDER_TYPE["INTERCASH"] = "i";
	})(CARD_PROVIDER_TYPE = exports.CARD_PROVIDER_TYPE || (exports.CARD_PROVIDER_TYPE = {}));
	var CARD_TRANSFER_STATE_TYPE;
	(function (CARD_TRANSFER_STATE_TYPE) {
	    CARD_TRANSFER_STATE_TYPE["AUTHORIZED"] = "authorized";
	    CARD_TRANSFER_STATE_TYPE["SETTLED"] = "settled";
	    CARD_TRANSFER_STATE_TYPE["DECLINED"] = "declined";
	})(CARD_TRANSFER_STATE_TYPE = exports.CARD_TRANSFER_STATE_TYPE || (exports.CARD_TRANSFER_STATE_TYPE = {}));
	var CARD_TRANSFER_TYPE;
	(function (CARD_TRANSFER_TYPE) {
	    CARD_TRANSFER_TYPE["PRE_AUTHORIZATION"] = "preAuthorization";
	    CARD_TRANSFER_TYPE["AUTHORIZATION"] = "authorization";
	    CARD_TRANSFER_TYPE["TRANSACTION"] = "transaction";
	})(CARD_TRANSFER_TYPE = exports.CARD_TRANSFER_TYPE || (exports.CARD_TRANSFER_TYPE = {}));


/***/ }),
/* 867 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var PROFILE_STATE;
	(function (PROFILE_STATE) {
	    PROFILE_STATE["ACTIVE"] = "A";
	    PROFILE_STATE["BLOCKED"] = "B";
	    PROFILE_STATE["REJECTED"] = "R";
	    PROFILE_STATE["NEW"] = "N";
	    PROFILE_STATE["PENDING"] = "P";
	    PROFILE_STATE["DECLINED"] = "D";
	    PROFILE_STATE["SUSPENDED"] = "S";
	    PROFILE_STATE["PROCESSING"] = "V";
	    PROFILE_STATE["ON_HOLD"] = "O";
	    PROFILE_STATE["ARCHIVED"] = "C";
	    PROFILE_STATE["CLOSED"] = "F";
	})(PROFILE_STATE = exports.PROFILE_STATE || (exports.PROFILE_STATE = {}));
	var PROFILE_STATE_NAMES;
	(function (PROFILE_STATE_NAMES) {
	    PROFILE_STATE_NAMES["ACTIVE"] = "ACTIVE";
	    PROFILE_STATE_NAMES["BLOCKED"] = "BLOCKED";
	    PROFILE_STATE_NAMES["REJECTED"] = "REJECTED";
	    PROFILE_STATE_NAMES["NEW"] = "NEW";
	    PROFILE_STATE_NAMES["PENDING"] = "PENDING";
	    PROFILE_STATE_NAMES["DECLINED"] = "DECLINED";
	    PROFILE_STATE_NAMES["SUSPENDED"] = "SUSPEND";
	    PROFILE_STATE_NAMES["PROCESSING"] = "PROCESSING";
	    PROFILE_STATE_NAMES["ON_HOLD"] = "ON HOLD";
	    PROFILE_STATE_NAMES["ARCHIVED"] = "ARCHIVED";
	})(PROFILE_STATE_NAMES = exports.PROFILE_STATE_NAMES || (exports.PROFILE_STATE_NAMES = {}));
	var PROFILE_PROVIDERS_NAMES;
	(function (PROFILE_PROVIDERS_NAMES) {
	    PROFILE_PROVIDERS_NAMES["MODULR"] = "MODULR";
	    PROFILE_PROVIDERS_NAMES["MOORWAND"] = "MOORWAND";
	    PROFILE_PROVIDERS_NAMES["AGENT"] = "AGENT";
	    PROFILE_PROVIDERS_NAMES["EMONEY"] = "EMONEY";
	})(PROFILE_PROVIDERS_NAMES = exports.PROFILE_PROVIDERS_NAMES || (exports.PROFILE_PROVIDERS_NAMES = {}));
	var PROFILE_TYPE;
	(function (PROFILE_TYPE) {
	    PROFILE_TYPE[PROFILE_TYPE["PRIVATE"] = 1] = "PRIVATE";
	    PROFILE_TYPE[PROFILE_TYPE["CORPORATE"] = 2] = "CORPORATE";
	})(PROFILE_TYPE = exports.PROFILE_TYPE || (exports.PROFILE_TYPE = {}));
	exports.PROFILE_KIND = {
	    CUSTOMER: 1,
	    AGENT: 2,
	    SALESMAN: 3,
	    SALESMAN_LEAD: 4,
	    WHITE_LABEL: 5,
	    INSTITUTIONAL_CLIENT: 6,
	    SUB_CLIENT: 7
	};
	exports.IDENTIFICATION_STATUS = {
	    VERIFIED: 'VERIFIED',
	    IN_PROGRESS: 'IN_PROGRESS',
	    NOT_VERIFIED: 'NOT_VERIFIED',
	    NEED_VERIFICATION: 'NEED_VERIFICATION',
	    NEED_RE_VERIFICATION: 'NEED_RE_VERIFICATION'
	};
	exports.FOURSTOP_STATUS = {
	    PROCESSED_BY_FOURSTOP: true
	};


/***/ }),
/* 868 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var IbanLocator;
	(function (IbanLocator) {
	    IbanLocator["MASTER"] = "MASTER";
	    IbanLocator["GENERATE"] = "GENERATE";
	    IbanLocator["CUSTOM"] = "CUSTOM";
	})(IbanLocator = exports.IbanLocator || (exports.IbanLocator = {}));


/***/ }),
/* 869 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var TransferScheme;
	(function (TransferScheme) {
	    TransferScheme["SEPA"] = "SEPA";
	    TransferScheme["SWIFT"] = "SWIFT";
	})(TransferScheme = exports.TransferScheme || (exports.TransferScheme = {}));
	var ProcessingModule;
	(function (ProcessingModule) {
	    ProcessingModule["SEPA_MMS_CT"] = "SEPA_MMS_CT";
	    ProcessingModule["SEPA_MMS_CT_INST"] = "SEPA_MMS_CT_INST";
	    ProcessingModule["CURRENCY_CLOUD"] = "CURRENCY_CLOUD";
	})(ProcessingModule = exports.ProcessingModule || (exports.ProcessingModule = {}));
	var OrderType;
	(function (OrderType) {
	    OrderType["CANCEL"] = "CANCEL";
	    OrderType["RETURN"] = "RETURN";
	    OrderType["OUTGOING"] = "OUTGOING";
	    OrderType["INCOMING"] = "INCOMING";
	})(OrderType = exports.OrderType || (exports.OrderType = {}));
	var OrderState;
	(function (OrderState) {
	    OrderState["NEW"] = "NEW";
	    // The backend sends IN_PROGRESS (PaymentProcessingOrderState); PROGRESS is kept for existing code
	    OrderState["PROGRESS"] = "PROGRESS";
	    OrderState["IN_PROGRESS"] = "IN_PROGRESS";
	    OrderState["APPROVED"] = "APPROVED";
	    OrderState["REJECTED"] = "REJECTED";
	    OrderState["ERROR"] = "ERROR";
	    OrderState["SUSPENDED"] = "SUSPENDED";
	    OrderState["ACCEPTED_DELIVERED"] = "ACCEPTED_DELIVERED";
	    OrderState["ACCEPTED_UNDELIVERED"] = "ACCEPTED_UNDELIVERED";
	})(OrderState = exports.OrderState || (exports.OrderState = {}));


/***/ }),
/* 870 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MAX_UPLOAD_FILE_SIZE = 5242880; // 10 MB


/***/ }),
/* 871 */
/***/ (function(module, exports) {

	module.exports = "<div>\n    <bs-login-notification *ngIf=\"showExpiredMessage\" bgClass=\"bg-danger\">\n        <h4 class=\"text-center\">{{ 'LOGIN.EXPIRED_LOGOUT' | translate }}</h4>\n    </bs-login-notification>\n\n    <div class=\"login\">\n        <div class=\"login_wrapper\">\n            <div class=\"animate form login_form\">\n                <section class=\"login_content\">\n                    <form #form=\"ngForm\" (ngSubmit)=\"form.valid && submit($event)\" novalidate>\n                        <div class=\"logo_form_content\">\n                            <div class=\"logo-corp large\"></div>\n                        </div>\n\n                        <div class=\"title_form_content\">\n                            <h3>{{ 'BY_VENDOR.LOGIN.HEADER' | translate }}</h3>\n                        </div>\n\n                        <div class=\"login_form_content\">\n                            <div class=\"item form-group\">\n                                <div>\n                                    <input id=\"login\"\n                                           type=\"email\"\n                                           class=\"form-control\"\n                                           [disabled]=\"loading\"\n                                           placeholder=\"{{ 'LOGIN.USERNAME' | translate }}\"\n                                           required pattern=\"^[a-zA-Z0-9_\\-\\.@]*$\" minlength=\"3\" maxlength=\"50\"\n                                           name=\"login\" #login=\"ngModel\" [(ngModel)]=\"model.login\"/>\n                                </div>\n                                <field-validator for=\"login\">\n                                    <message type=\"required\">\n                                        <div class=\"alert\">{{ 'COMMON.VALIDATION.REQUIRED' | translate }}</div>\n                                    </message>\n                                    <message type=\"email\">\n                                        <div class=\"alert\">{{ 'COMMON.VALIDATION.EMAIL' | translate }}</div>\n                                    </message>\n                                    <message type=\"minlength\">\n                                        <div class=\"alert\">{{ 'LOGIN.LOGIN_MIN_LENGTH' | translate }}</div>\n                                    </message>\n                                    <message type=\"maxlength\">\n                                        <div class=\"alert\">{{ 'LOGIN.LOGIN_MAX_LENGTH' | translate }}</div>\n                                    </message>\n                                </field-validator>\n                            </div>\n\n                            <div class=\"item form-group\">\n                                <div>\n                                    <input id=\"password\"\n                                           type=\"password\"\n                                           class=\"form-control\"\n                                           [disabled]=\"loading\"\n                                           placeholder=\"{{ 'LOGIN.PASSWORD' | translate }}\"\n                                           required maxlength=\"50\"\n                                           name=\"password\" #password=\"ngModel\" [(ngModel)]=\"model.password\"/>\n                                </div>\n                                <field-validator for=\"password\">\n                                    <message type=\"required\">\n                                        <div class=\"alert\">{{ 'COMMON.VALIDATION.REQUIRED' | translate }}</div>\n                                    </message>\n                                    <message type=\"maxlength\">\n                                        <div class=\"alert\">{{ 'LOGIN.PASSWORD_MAX_LENGTH' | translate }}</div>\n                                    </message>\n                                </field-validator>\n                            </div>\n\n                            <div *ngIf=\"message !== null\" class=\"login_form_error text-danger\">\n                                <span id=\"error-message\">{{ message }}</span>\n                            </div>\n\n                            <div>\n                                <button id=\"signin\"\n                                        type=\"submit\"\n                                        [disabled]=\"loading\"\n                                        class=\"btn btn-default submit btn-login\">\n                                    {{ 'LOGIN.LOGIN_BUTTON' | translate }}\n                                </button>\n                            </div>\n                        </div>\n                    </form>\n                </section>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var NotificationComponent = (function () {
	    function NotificationComponent() {
	    }
	    NotificationComponent.prototype.getNotificationClasses = function () {
	        return _a = {
	                'login-notification': true
	            },
	            _a[this.bgClass] = !!this.bgClass,
	            _a;
	        var _a;
	    };
	    __decorate([
	        core_1.Input('bgClass'),
	        __metadata("design:type", String)
	    ], NotificationComponent.prototype, "bgClass", void 0);
	    NotificationComponent = __decorate([
	        core_1.Component({
	            selector: 'bs-login-notification',
	            template: __webpack_require__(873)
	        })
	    ], NotificationComponent);
	    return NotificationComponent;
	}());
	exports.NotificationComponent = NotificationComponent;


/***/ }),
/* 873 */
/***/ (function(module, exports) {

	module.exports = "<div [ngClass]=\"getNotificationClasses()\">\n    <ng-content></ng-content>\n</div>"

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(875));
	var menu_1 = __webpack_require__(878);
	var top_bar_1 = __webpack_require__(887);
	exports.SPACE_COMPONENTS = [
	    menu_1.Menu,
	    top_bar_1.TopBarComponent
	];


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var cookies_1 = __webpack_require__(738);
	var security_1 = __webpack_require__(736);
	var menu_resizer_service_1 = __webpack_require__(876);
	var SpaceComponent = (function () {
	    function SpaceComponent(_sessionService) {
	        this._sessionService = _sessionService;
	    }
	    SpaceComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        if (!this.interval) {
	            this.interval = setInterval(function () { return _this.incrementIdleTimer(); }, 10000);
	        }
	    };
	    SpaceComponent.prototype.ngOnDestroy = function () {
	        if (this.interval) {
	            clearInterval(this.interval);
	        }
	    };
	    SpaceComponent.prototype.incrementIdleTimer = function () {
	        if (!cookies_1.CookiesManager.isTokenExist()) {
	            this._sessionService.expire();
	        }
	    };
	    SpaceComponent = __decorate([
	        core_1.Component({
	            selector: 'space',
	            providers: [menu_resizer_service_1.MenuResizeService],
	            template: __webpack_require__(877)
	        }),
	        __metadata("design:paramtypes", [security_1.SessionService])
	    ], SpaceComponent);
	    return SpaceComponent;
	}());
	exports.SpaceComponent = SpaceComponent;


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var rxjs_1 = __webpack_require__(304);
	var MenuResizeService = (function () {
	    function MenuResizeService() {
	        this._observer = new rxjs_1.BehaviorSubject(true);
	    }
	    MenuResizeService.prototype.onResizeMenuObserver = function () {
	        return this._observer;
	    };
	    MenuResizeService.prototype.changeSize = function (isLarge) {
	        this._observer.next(isLarge);
	    };
	    MenuResizeService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [])
	    ], MenuResizeService);
	    return MenuResizeService;
	}());
	exports.MenuResizeService = MenuResizeService;


/***/ }),
/* 877 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"root-container nav-md\">\n\n    <div class=\"container body\">\n        <div class=\"main_container\">\n            <div class=\"col-md-3 left_col\">\n                <div class=\"left_col scroll-view\">\n                    <div class=\"navbar nav_title\" style=\"border: 0;\">\n                        <a class=\"site_title\">\n                            <div class=\"logo-corp large\"></div>\n                            <span>{{'BY_VENDOR.SPACE.TRADE'|translate}}</span></a>\n                    </div>\n                    <div class=\"clearfix\"></div>\n                    <!-- /menu profile quick info -->\n\n                    <!-- sidebar menu -->\n                    <div id=\"sidebar-menu\" class=\"main_menu_side hidden-print main_menu\">\n                        <div class=\"menu_section\">\n                            <menu-c></menu-c>\n                        </div>\n                    </div>\n                    <!-- /sidebar menu -->\n\n                </div>\n            </div>\n\n            <!-- top navigation -->\n            <bs-top-bar></bs-top-bar>\n            <!-- /top navigation -->\n\n            <!-- page content -->\n            <div class=\"right_col\" role=\"main\">\n                <div class=\"row\">\n                    <div class=\"col-xs-12\">\n                        <router-outlet></router-outlet>\n                    </div>\n                </div>\n\n            </div>\n            <!-- /page content -->\n        </div>\n    </div>\n\n</div>"

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(879));
	__export(__webpack_require__(885));


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(852);
	var router_1 = __webpack_require__(270);
	var menu_resizer_service_1 = __webpack_require__(876);
	var menu_definition_1 = __webpack_require__(880);
	var security_1 = __webpack_require__(736);
	var util_1 = __webpack_require__(743);
	var bo_http_interceptor_1 = __webpack_require__(883);
	var Menu = (function () {
	    function Menu(router, menuResizeService, roleService, httpClient) {
	        this.router = router;
	        this.menuResizeService = menuResizeService;
	        this.roleService = roleService;
	        this.httpClient = httpClient;
	        this.menu = menu_definition_1.MENU;
	        this.menuUpdatedFromPermissions = [];
	        this.counters = {};
	        this.counterDetails = {};
	        this.isLargeMenuView = true;
	        this.counterLoadedAt = {};
	        this.counterListeners = [];
	    }
	    Menu_1 = Menu;
	    Menu.prototype.ngOnInit = function () {
	        var _this = this;
	        this.updateMenuFromPermissions();
	        this.startCounters();
	        // handle change route event
	        this.router.events.subscribe(function () {
	            _this.updateMenuActiveState();
	        });
	        // handle change menu size event
	        this.resizeSubscription = this.menuResizeService.onResizeMenuObserver()
	            .subscribe(function (isLarge) { return _this.updateMenuSize(isLarge); });
	        // call update on component init
	        setTimeout(function () { return _this.updateMenuActiveState(); });
	    };
	    Menu.prototype.updateMenuFromPermissions = function () {
	        var permissionRoutes = [].concat.apply([], this.roleService.getPermissions().map(function (permission) {
	            var route = permission.route.split(':')[0].substring(1);
	            if (route.endsWith('/')) {
	                return route.slice(0, -1);
	            }
	            return route;
	        }));
	        this.menuUpdatedFromPermissions = this.filterMenuItems(this.menu, permissionRoutes);
	    };
	    Menu.prototype.filterMenuItems = function (menuItems, allowedPaths) {
	        var _this = this;
	        return menuItems.filter(function (menuItem) {
	            if (!Array.isArray(menuItem.path[0])) {
	                var hasAllowedPath = allowedPaths.includes(menuItem.path.join('/'));
	                if (hasAllowedPath && menuItem.children) {
	                    menuItem.children = _this.filterMenuItems(menuItem.children, allowedPaths);
	                    return true;
	                }
	                return hasAllowedPath;
	            }
	            else {
	                var hasAllowedPath = false;
	                for (var _i = 0, _a = menuItem.path; _i < _a.length; _i++) {
	                    var path = _a[_i];
	                    var joinedPath = Array.isArray(path) ? path.join('/') : path;
	                    if (allowedPaths.includes(joinedPath)) {
	                        hasAllowedPath = true;
	                        break;
	                    }
	                }
	                if (hasAllowedPath && menuItem.children) {
	                    menuItem.children = _this.filterMenuItems(menuItem.children, allowedPaths);
	                    return true;
	                }
	                return hasAllowedPath;
	            }
	        });
	    };
	    Menu.prototype.ngOnDestroy = function () {
	        this.resizeSubscription.unsubscribe();
	        if (this.navigationSubscription) {
	            this.navigationSubscription.unsubscribe();
	        }
	        this.counterListeners.forEach(function (l) { return window.removeEventListener(l.event, l.handler); });
	    };
	    /** Counters of the visible menu items: loaded now, on navigation and when their page changes them. */
	    Menu.prototype.startCounters = function () {
	        var _this = this;
	        var keys = [];
	        this.menuUpdatedFromPermissions.forEach(function (item) { return (item.children || [])
	            .filter(function (child) { return child.counter && Menu_1.COUNTERS[child.counter] && !_this.isDisabled(child); })
	            .forEach(function (child) { return keys.indexOf(child.counter) < 0 && keys.push(child.counter); }); });
	        if (!keys.length) {
	            return;
	        }
	        keys.forEach(function (key) {
	            var handler = function () { return _this.loadCounter(key); };
	            window.addEventListener(Menu_1.COUNTERS[key].refreshEvent, handler);
	            _this.counterListeners.push({ event: Menu_1.COUNTERS[key].refreshEvent, handler: handler });
	            _this.loadCounter(key);
	        });
	        this.navigationSubscription = this.router.events.subscribe(function (event) {
	            if (event instanceof router_1.NavigationEnd) {
	                keys.filter(function (key) { return Date.now() - (_this.counterLoadedAt[key] || 0) >= Menu_1.COUNTER_MIN_INTERVAL_MS; })
	                    .forEach(function (key) { return _this.loadCounter(key); });
	            }
	        });
	    };
	    Menu.prototype.loadCounter = function (key) {
	        var _this = this;
	        var counter = Menu_1.COUNTERS[key];
	        this.counterLoadedAt[key] = Date.now();
	        // A 403 (no role for the counted list) must not leave the current page
	        var headers = new http_1.HttpHeaders().set(bo_http_interceptor_1.BOHttpClientInterceptor.NO_FORBIDDEN_REDIRECT_HEADER, 'true');
	        this.httpClient.get(counter.url, { headers: headers }).subscribe(function (body) {
	            _this.counters[key] = (body && +body[counter.field]) || 0;
	            _this.counterDetails[key] = Menu_1.counterDetail(counter, body);
	        }, function () {
	            _this.counters[key] = 0;
	            _this.counterDetails[key] = '';
	        });
	    };
	    /** "CLIENT A 3, #125 1" from the per-group list of the counter response. */
	    Menu.counterDetail = function (counter, body) {
	        var rows = counter.detail && body && body[counter.detail.field];
	        if (!Array.isArray(rows)) {
	            return '';
	        }
	        return rows.map(function (row) { return (row[counter.detail.nameField] || ('#' + row[counter.detail.idField]))
	            + ' ' + row[counter.detail.countField]; }).join(', ');
	    };
	    Menu.prototype.counterValue = function (item) {
	        return item.counter ? (this.counters[item.counter] || 0) : 0;
	    };
	    Menu.prototype.counterTitle = function (item) {
	        var counter = item.counter && Menu_1.COUNTERS[item.counter];
	        if (!counter) {
	            return '';
	        }
	        var detail = this.counterDetails[item.counter];
	        return this.counterValue(item) + ' ' + counter.title + (detail ? ' (' + detail + ')' : '');
	    };
	    /** Sum of the children counters, shown on the section title. */
	    Menu.prototype.childrenCount = function (item) {
	        var _this = this;
	        return (item.children || []).reduce(function (sum, child) { return sum + _this.counterValue(child); }, 0);
	    };
	    Menu.prototype.childrenCountTitle = function (item) {
	        var _this = this;
	        return (item.children || []).filter(function (child) { return _this.counterValue(child) > 0; })
	            .map(function (child) { return _this.counterTitle(child); }).join('; ');
	    };
	    /** The counter opens the list it counts. */
	    Menu.prototype.openCounter = function (item, event) {
	        var _this = this;
	        event.stopPropagation();
	        var counter = item.counter && Menu_1.COUNTERS[item.counter];
	        if (!counter || this.isDisabled(item)) {
	            return;
	        }
	        this.router.navigate(item.path, { queryParams: counter.queryParams });
	        setTimeout(function () { return _this.updateMenuActiveState(); }, 1);
	    };
	    Menu.prototype.getMenuItemClasses = function (item) {
	        if (this.hasActiveChildren(item)) {
	            // menu item it has the active child
	            if (this.hasAnotherActive(item)) {
	                // another root item been selected by user, hide current
	                return { active: false, open: false };
	            }
	            else {
	                // activate current, because it has the active child
	                return { active: true, open: item.active };
	            }
	        }
	        else {
	            // menu item do not have the active child, activate if selected
	            return { active: item.active, open: item.active };
	        }
	    };
	    Menu.prototype.getMenuItemAnchorClasses = function (item) {
	        return {
	            'active       ': this.isActive(item),
	            'disabled-item': this.isDisabled(item)
	        };
	    };
	    Menu.prototype.toggleMenuItem = function (item) {
	        if (!this.isDisabled(item)) {
	            for (var _i = 0, _a = this.menuUpdatedFromPermissions; _i < _a.length; _i++) {
	                var menu_item = _a[_i];
	                // toggle for current, false to another
	                menu_item.active = menu_item === item && !menu_item.active;
	            }
	        }
	    };
	    Menu.prototype.handleMenuItemClick = function (item) {
	        var _this = this;
	        console.log('[Menu] handleMenuItemClick called with item:', item);
	        console.log('[Menu] isDisabled:', this.isDisabled(item));
	        if (!this.isDisabled(item)) {
	            var path = item.path;
	            console.log('[Menu] Original path:', path);
	            if (item.path.length > 0 && Array.isArray(item.path[0])) {
	                console.log('[Menu] Path is array of arrays, finding allowed path...');
	                path = item.path.find(function (path) {
	                    var route = '/' + path.join('/');
	                    var hasPermission = _this.hasPathPermissions(item.roles, route);
	                    console.log('[Menu] Checking path:', path, 'route:', route, 'hasPermission:', hasPermission);
	                    return hasPermission;
	                });
	                console.log('[Menu] Selected path:', path);
	            }
	            if (path) {
	                console.log('[Menu] Navigating to:', path);
	                this.router.navigate(path);
	                setTimeout(function () { return _this.updateMenuActiveState(); }, 1);
	            }
	            else {
	                console.error('[Menu] No valid path found for navigation!');
	            }
	        }
	        else {
	            console.warn('[Menu] Menu item is disabled, cannot navigate');
	        }
	    };
	    Menu.prototype.updateMenuActiveState = function () {
	        for (var _i = 0, _a = this.menuUpdatedFromPermissions; _i < _a.length; _i++) {
	            var item = _a[_i];
	            item.active = this.isLargeMenuView && this.hasActiveChildren(item);
	        }
	    };
	    Menu.prototype.updateMenuSize = function (isLarge) {
	        this.isLargeMenuView = isLarge;
	        this.updateMenuActiveState();
	    };
	    Menu.prototype.isActive = function (item) {
	        var _this = this;
	        try {
	            if (item.path.length > 0 && Array.isArray(item.path[0])) {
	                return item.path.some(function (path) {
	                    return _this.router.isActive(_this.router.createUrlTree(path), false);
	                });
	            }
	            else {
	                return this.router.isActive(this.router.createUrlTree(item.path), false);
	            }
	        }
	        catch (err) {
	            // can throw exception if route not found
	            return false;
	        }
	    };
	    Menu.prototype.hasActiveChildren = function (current) {
	        for (var _i = 0, _a = current.children; _i < _a.length; _i++) {
	            var item = _a[_i];
	            if (this.isActive(item)) {
	                return true;
	            }
	        }
	        return false;
	    };
	    Menu.prototype.hasAnotherActive = function (current) {
	        for (var _i = 0, _a = this.menuUpdatedFromPermissions; _i < _a.length; _i++) {
	            var item = _a[_i];
	            if (current !== item && item.active) {
	                return true;
	            }
	        }
	        return false;
	    };
	    Menu.prototype.isDisabled = function (item) {
	        var _this = this;
	        if (item.disabled) {
	            console.log('[Menu] Item is explicitly disabled:', item.id);
	            return true;
	        }
	        if (item.path.length > 0 && Array.isArray(item.path[0])) {
	            var isDisabled = item.path.every(function (path) {
	                var route = '/' + path.join('/');
	                var hasPermission = _this.hasPathPermissions(item.roles, route);
	                console.log('[Menu] Checking permission for path:', path, 'route:', route, 'hasPermission:', hasPermission);
	                return !hasPermission;
	            });
	            console.log('[Menu] Item', item.id, 'isDisabled:', isDisabled);
	            return isDisabled;
	        }
	        else {
	            var route = '/' + item.path.join('/');
	            var hasPermission = this.hasPathPermissions(item.roles, route);
	            console.log('[Menu] Item', item.id, 'route:', route, 'hasPermission:', hasPermission, 'isDisabled:', !hasPermission);
	            return !hasPermission;
	        }
	    };
	    Menu.prototype.hasPathPermissions = function (roles, route) {
	        if (util_1.isNullOrUndefined(roles)) {
	            return this.roleService.hasMenuAccess(route);
	        }
	        else {
	            return this.roleService.hasMenuRoles(roles, route);
	        }
	    };
	    Menu.COUNTERS = {
	        // Same values as FAILED_PAID_VIEW / FAILED_PAID_CHANGED_EVENT of the Open Banking payments page
	        obFailedPaid: {
	            url: '/api/backoffice/open-banking/failed-then-paid/count',
	            field: 'pending',
	            title: 'payments reported as failed and paid afterwards: client not notified yet',
	            detail: { field: 'byClient', nameField: 'clientName', idField: 'clientId', countField: 'pending' },
	            queryParams: { view: 'failed-then-paid' },
	            refreshEvent: 'ob-failed-paid-changed'
	        }
	    };
	    // No timer: a periodic request would renew the BO token and the session would never expire for inactivity.
	    // Counters reload on navigation (at most once per minute) and when their page changes them.
	    Menu.COUNTER_MIN_INTERVAL_MS = 60 * 1000;
	    Menu = Menu_1 = __decorate([
	        core_1.Component({
	            selector: 'menu-c',
	            template: __webpack_require__(884)
	        }),
	        __metadata("design:paramtypes", [router_1.Router, menu_resizer_service_1.MenuResizeService, security_1.RoleService,
	            http_1.HttpClient])
	    ], Menu);
	    return Menu;
	    var Menu_1;
	}());
	exports.Menu = Menu;


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var card_transfer_menu_icon_1 = __webpack_require__(881);
	var security_1 = __webpack_require__(736);
	exports.MENU = [
	    {
	        id: 'accounts',
	        path: ['space', 'accounts'],
	        title: 'SPACE.MENU.ACCOUNTS',
	        icon: {
	            image: 'fa fa-university'
	        },
	        children: [
	            {
	                id: 'customer-accounts',
	                path: ['space', 'accounts', 'customer'],
	                title: 'SPACE.MENU.CUSTOMER_ACCOUNTS'
	            },
	            {
	                id: 'system-accounts',
	                path: ['space', 'accounts', 'system'],
	                title: 'SPACE.MENU.SYSTEM_ACCOUNTS'
	            },
	            {
	                id: 'liquidity-accounts',
	                path: ['space', 'accounts', 'pools'],
	                title: 'SPACE.MENU.LIQUIDITY_ACCOUNTS'
	            },
	            {
	                id: 'daily-balance-report',
	                path: ['space', 'accounts', 'daily-balance-report'],
	                title: 'SPACE.MENU.DAILY_BALANCE_REPORT'
	            }
	        ],
	        active: true
	    },
	    {
	        id: 'outgoing-transfers',
	        path: ['space', 'transfers', 'outgoing'],
	        title: 'SPACE.MENU.OUTGOING.TITLE',
	        icon: {
	            image: 'fa fa-arrow-left'
	        },
	        children: [
	            {
	                id: 'new-outgoing-transfers',
	                path: ['space', 'transfers', 'outgoing', 'new'],
	                title: 'SPACE.MENU.OUTGOING.NEW'
	            }
	        ]
	    },
	    {
	        id: 'card-transfers',
	        path: ['space', 'transfers', 'card'],
	        title: 'SPACE.MENU.REFILL_CARD.TITLE',
	        icon: {
	            componentImage: {
	                type: card_transfer_menu_icon_1.CardTransferMenuIcon,
	                style: 'tfl-card-transfer-menu-icon'
	            }
	        },
	        children: [
	            {
	                id: 'new-card-transfers',
	                path: ['space', 'transfers', 'card', 'new'],
	                title: 'SPACE.MENU.REFILL_CARD.NEW',
	                roles: security_1.Roles.EDIT
	            },
	            {
	                id: 'awaiting-reference-card-transfers',
	                path: ['space', 'transfers', 'card', 'awaiting'],
	                title: 'SPACE.MENU.REFILL_CARD.AWAITING',
	                roles: security_1.Roles.EDIT
	            }
	        ],
	        roles: security_1.Roles.EDIT
	    },
	    {
	        id: 'incoming-transfers',
	        path: ['space', 'transfers', 'incoming'],
	        title: 'SPACE.MENU.INCOMING.TITLE',
	        icon: {
	            image: 'fa fa-arrow-right'
	        },
	        children: [
	            {
	                id: 'transfers-uploading',
	                path: ['space', 'transfers', 'incoming', 'upload'],
	                title: 'SPACE.MENU.INCOMING.UPLOADING',
	                roles: security_1.Roles.EDIT
	            }
	        ],
	        disabled: false,
	        roles: security_1.Roles.EDIT
	    },
	    {
	        id: 'internal-transfers',
	        path: ['space', 'transfers', 'internal'],
	        title: 'SPACE.MENU.INTERNAL.TITLE',
	        icon: {
	            image: 'fa fa-circle-o-notch'
	        },
	        children: [
	            {
	                id: 'new-internal-transfers',
	                path: ['space', 'transfers', 'internal', 'new'],
	                title: 'SPACE.MENU.INTERNAL.NEW'
	            }
	        ]
	    },
	    {
	        id: 'system-transfers',
	        path: ['space', 'transfers', 'system'],
	        title: 'SPACE.MENU.SYSTEM.TITLE',
	        icon: {
	            image: 'fa fa-address-card-o'
	        },
	        children: [
	            {
	                id: 'new-system-to-internal-transfers',
	                path: ['space', 'transfers', 'system', 'revenue-to-internal'],
	                title: 'SPACE.MENU.SYSTEM.REVENUE_TO_INTERNAL',
	                roles: security_1.Roles.EDIT
	            },
	            {
	                id: 'charge-fees',
	                path: ['space', 'transfers', 'system', 'charge-fees'],
	                title: 'SPACE.MENU.SYSTEM.CHARGE_FEES',
	                roles: security_1.Roles.EDIT
	            }
	        ],
	        roles: security_1.Roles.EDIT
	    },
	    {
	        id: 'external-processing-orders',
	        path: ['space', 'processing', 'external-orders'],
	        title: 'SPACE.MENU.PAYMENT_PROCESSING.TITLE.ORDERS',
	        icon: {
	            image: 'fa fa-ticket'
	        },
	        children: [
	            {
	                id: 'payment-processing-refund',
	                path: ['space', 'processing', 'external-orders', 'refund'],
	                title: 'SPACE.MENU.PAYMENT_PROCESSING.REFUND'
	            },
	            {
	                id: 'payment-processing-cancelled',
	                path: ['space', 'processing', 'external-orders', 'cancelled'],
	                title: 'SPACE.MENU.PAYMENT_PROCESSING.CANCELLED'
	            },
	            {
	                id: 'payment-processing-incoming',
	                path: ['space', 'processing', 'external-orders', 'incoming'],
	                title: 'SPACE.MENU.PAYMENT_PROCESSING.INCOMING'
	            },
	        ]
	    },
	    {
	        id: 'manual-payments-control',
	        path: ['space', 'processing', 'manual-controls'],
	        title: 'SPACE.MENU.PAYMENT_PROCESSING.TITLE.PAYMENTS_CONTROL',
	        icon: {
	            image: 'fa fa-hand-o-up'
	        },
	        children: [
	            {
	                id: 'incoming',
	                path: [['space', 'processing', 'manual-controls', 'incoming', 'new'],
	                    ['space', 'processing', 'manual-controls', 'incoming', 'undelivered'],
	                    ['space', 'processing', 'manual-controls', 'incoming', 'rejected'],
	                    ['space', 'processing', 'manual-controls', 'incoming', 'waiting-cancellation'],
	                    ['space', 'processing', 'manual-controls', 'incoming', 'suspended'],],
	                title: 'SPACE.MENU.PAYMENT_PROCESSING.INCOMING'
	            },
	            {
	                id: 'outgoing',
	                path: [['space', 'processing', 'manual-controls', 'outgoing', 'rejected'],
	                    ['space', 'processing', 'manual-controls', 'outgoing', 'returned'],
	                    ['space', 'processing', 'manual-controls', 'outgoing', 'in-progress'],
	                    ['space', 'processing', 'manual-controls', 'outgoing', 'in-error']],
	                title: 'SPACE.MENU.PAYMENT_PROCESSING.OUTGOING'
	            },
	            {
	                id: 'moorwand-payments',
	                path: [['space', 'processing', 'manual-controls', 'moorwand-payments', 'all']],
	                title: 'SPACE.MENU.PAYMENT_PROCESSING.MOORWAND_PAYMENT'
	            },
	            {
	                id: 'moorwand-reconciliation-report',
	                path: [['space', 'processing', 'manual-controls', 'moorwand-reconciliation-report', 'all']],
	                title: 'SPACE.MENU.PAYMENT_PROCESSING.MOORWAND_RECONCILIATION_REPORT'
	            },
	            {
	                id: 'moorwand-black-list',
	                path: [['space', 'processing', 'manual-controls', 'moorwand-black-list', 'all']],
	                title: 'SPACE.MENU.PAYMENT_PROCESSING.MOORWAND_BLACK_LIST'
	            }
	        ]
	    },
	    {
	        id: 'cards',
	        path: ['space', 'cards'],
	        title: 'SPACE.MENU.CARDS.TITLE',
	        icon: {
	            image: 'fa fa-credit-card'
	        },
	        children: [
	            {
	                id: 'new-cards',
	                path: ['space', 'cards', 'new'],
	                title: 'SPACE.MENU.CARDS.NEW'
	            }
	        ]
	    },
	    {
	        id: 'history',
	        path: ['space', 'history'],
	        title: 'SPACE.MENU.HISTORY.TITLE',
	        icon: {
	            image: 'fa fa-history'
	        },
	        children: [
	            {
	                id: 'history-transfers',
	                path: ['space', 'history', 'transfers'],
	                title: 'SPACE.MENU.HISTORY.TRANSFERS'
	            }
	        ]
	    },
	    {
	        // Kraken (Payward) operations. No route here may prefix another: RoleService drops a permission
	        // whose route starts another one's, so e.g. 'setup' and 'setup-x' would lock 'setup' out.
	        id: 'crypto',
	        path: ['space', 'crypto'],
	        title: 'SPACE.MENU.CRYPTO.TITLE',
	        icon: {
	            image: 'fa fa-btc'
	        },
	        children: [
	            {
	                id: 'crypto-transactions',
	                path: ['space', 'crypto', 'transactions'],
	                title: 'SPACE.MENU.CRYPTO.TRANSACTIONS'
	            },
	            {
	                id: 'crypto-conversions',
	                path: ['space', 'crypto', 'conversions'],
	                title: 'SPACE.MENU.CRYPTO.CONVERSIONS'
	            },
	            {
	                id: 'crypto-kyc',
	                path: ['space', 'crypto', 'kyc'],
	                title: 'SPACE.MENU.CRYPTO.KYC'
	            },
	            {
	                id: 'crypto-settlement',
	                path: ['space', 'crypto', 'settlement'],
	                title: 'SPACE.MENU.CRYPTO.SETTLEMENT'
	            },
	            {
	                id: 'crypto-setup',
	                path: ['space', 'crypto', 'setup'],
	                title: 'SPACE.MENU.CRYPTO.SETUP'
	            },
	            {
	                id: 'crypto-access',
	                path: ['space', 'crypto', 'access'],
	                title: 'SPACE.MENU.CRYPTO.ACCESS'
	            },
	            {
	                id: 'crypto-api-console',
	                path: ['space', 'crypto', 'api-console'],
	                title: 'SPACE.MENU.CRYPTO.API_CONSOLE'
	            },
	            {
	                id: 'crypto-tokens',
	                path: ['space', 'crypto', 'tokens'],
	                title: 'SPACE.MENU.CRYPTO.TOKENS'
	            }
	        ]
	    },
	    {
	        id: 'open-banking',
	        path: ['space', 'open-banking'],
	        title: 'SPACE.MENU.OPEN_BANKING.TITLE',
	        icon: {
	            image: 'fa fa-exchange'
	        },
	        children: [
	            // ── FIAT ────────────────────────────────────────────
	            {
	                id: 'open-banking-sep-fiat',
	                path: ['space', 'open-banking', 'clients'],
	                title: 'SPACE.MENU.OPEN_BANKING.FIAT_LABEL',
	                disabled: true
	            },
	            {
	                id: 'open-banking-clients',
	                path: ['space', 'open-banking', 'clients'],
	                title: 'SPACE.MENU.OPEN_BANKING.CLIENTS'
	            },
	            {
	                id: 'open-banking-payments',
	                path: ['space', 'open-banking', 'payments'],
	                title: 'SPACE.MENU.OPEN_BANKING.PAYMENTS'
	            },
	            {
	                id: 'open-banking-settlements',
	                path: ['space', 'open-banking', 'settlements'],
	                title: 'SPACE.MENU.OPEN_BANKING.SETTLEMENTS'
	            },
	            {
	                id: 'open-banking-groups',
	                path: ['space', 'open-banking', 'groups'],
	                title: 'SPACE.MENU.OPEN_BANKING.GROUPS'
	            },
	            {
	                id: 'open-banking-failure-reasons',
	                path: ['space', 'open-banking', 'failure-reasons'],
	                title: 'SPACE.MENU.OPEN_BANKING.FAILURE_REASONS'
	            },
	            {
	                id: 'open-banking-institutions',
	                path: ['space', 'open-banking', 'institutions'],
	                title: 'SPACE.MENU.OPEN_BANKING.INSTITUTIONS'
	            },
	            {
	                id: 'open-banking-notifications',
	                path: ['space', 'open-banking', 'notifications'],
	                title: 'SPACE.MENU.OPEN_BANKING.NOTIFICATIONS'
	            },
	            {
	                id: 'open-banking-analytics',
	                path: ['space', 'open-banking', 'analytics'],
	                title: 'SPACE.MENU.OPEN_BANKING.ANALYTICS'
	            },
	            // ── CRYPTO ──────────────────────────────────────────
	            {
	                id: 'open-banking-sep-crypto',
	                path: ['space', 'open-banking', 'crypto-payments'],
	                title: 'SPACE.MENU.OPEN_BANKING.CRYPTO_LABEL',
	                disabled: true
	            },
	            {
	                id: 'open-banking-crypto-payments',
	                path: ['space', 'open-banking', 'crypto-payments'],
	                title: 'SPACE.MENU.OPEN_BANKING.CRYPTO_PAYMENTS'
	            },
	            {
	                id: 'open-banking-crypto-clients',
	                path: ['space', 'open-banking', 'crypto-clients'],
	                title: 'SPACE.MENU.OPEN_BANKING.CRYPTO_CLIENTS'
	            },
	            {
	                id: 'open-banking-crypto-analytics',
	                path: ['space', 'open-banking', 'crypto-analytics'],
	                title: 'SPACE.MENU.OPEN_BANKING.CRYPTO_ANALYTICS'
	            },
	            {
	                id: 'open-banking-crypto-system',
	                path: ['space', 'open-banking', 'crypto-system'],
	                title: 'SPACE.MENU.OPEN_BANKING.CRYPTO_SYSTEM'
	            },
	            {
	                id: 'open-banking-crypto-settlement-report',
	                path: ['space', 'open-banking', 'crypto-settlement-report'],
	                title: 'SPACE.MENU.OPEN_BANKING.CRYPTO_SETTLEMENT_REPORT'
	            }
	        ]
	    },
	    {
	        id: 'reports',
	        path: ['space', 'reports'],
	        title: 'SPACE.MENU.REPORTS.TITLE',
	        icon: {
	            image: 'fa fa-bar-chart'
	        },
	        children: [
	            {
	                id: 'reports-customer-account-statement',
	                path: ['space', 'reports', 'customer-account-statement'],
	                title: 'SPACE.MENU.REPORTS.CUSTOMER_ACCOUNT_STATEMENT'
	            },
	            {
	                id: 'reports-tx-reconciliation',
	                path: ['space', 'reports', 'tx-reconciliation'],
	                title: 'SPACE.MENU.REPORTS.TX_RECONCILIATION'
	            },
	            {
	                id: 'reports-customer-balances',
	                path: ['space', 'reports', 'customer-balances'],
	                title: 'SPACE.MENU.REPORTS.CUSTOMER_BALANCES'
	            },
	            {
	                id: 'reports-fee-errors',
	                path: ['space', 'reports', 'fee-errors'],
	                title: 'SPACE.MENU.REPORTS.FEE_ERRORS'
	            },
	            {
	                id: 'reports-revenue-account',
	                path: ['space', 'reports', 'revenue-account'],
	                title: 'SPACE.MENU.REPORTS.REVENUE_ACCOUNT'
	            },
	            {
	                id: 'reports-transaction-detail',
	                path: ['space', 'reports', 'transaction-detail'],
	                title: 'SPACE.MENU.REPORTS.TRANSACTION_DETAIL'
	            },
	            {
	                id: 'reports-legacy-config',
	                path: ['space', 'reports', 'legacy-config'],
	                title: 'SPACE.MENU.REPORTS.LEGACY_CONFIG'
	            },
	            {
	                id: 'reports-moorwand-balance-report',
	                path: ['space', 'reports', 'moorwand-balance-report'],
	                title: 'SPACE.MENU.REPORTS.MOORWAND_BALANCE_REPORT'
	            }
	        ]
	    },
	    {
	        id: 'configuration',
	        path: ['space', 'configuration'],
	        title: 'SPACE.MENU.CONFIG.TITLE',
	        icon: {
	            image: 'fa fa-cog'
	        },
	        children: [
	            {
	                id: 'tariffs',
	                path: [['space', 'configuration', 'tariffs', 'customer'],
	                    ['space', 'configuration', 'tariffs', 'bank'],
	                    ['space', 'configuration', 'tariffs', 'card'],
	                    ['space', 'configuration', 'tariffs', 'wl']],
	                title: 'SPACE.MENU.CONFIG.TARIFFS',
	            },
	            {
	                id: 'aml-rules',
	                path: [['space', 'configuration', 'aml-rules', 'all']],
	                title: 'SPACE.MENU.CONFIG.AML_RULES'
	            },
	            {
	                id: 'provider-reports',
	                path: [['space', 'configuration', 'provider-reports', 'all']],
	                title: 'SPACE.MENU.CONFIG.MOORWAND_REPORTS'
	            },
	            {
	                id: 'incoming-balance',
	                path: [['space', 'configuration', 'incoming-balance']],
	                title: 'SPACE.MENU.CONFIG.DEPOSIT_BALANCE'
	            },
	            {
	                id: 'daily-check-pep',
	                path: [['space', 'configuration', 'daily-check-pep', 'all']],
	                title: 'SPACE.MENU.CONFIG.DAILY_CHECK_PEP'
	            },
	            {
	                id: 'client-notifications',
	                path: [['space', 'configuration', 'client-notifications', 'all']],
	                title: 'SPACE.MENU.CONFIG.CLIENT_NOTIFICATIONS'
	            },
	            {
	                id: 'admin-users',
	                path: [['space', 'configuration', 'admin-users', 'all']],
	                title: 'SPACE.MENU.CONFIG.ADMIN_USERS'
	            },
	            {
	                id: 'iban-cache',
	                path: [['space', 'configuration', 'iban-cache']],
	                title: 'SPACE.MENU.CONFIG.IBAN_CACHE'
	            }
	        ],
	    },
	    {
	        id: 'applications',
	        path: ['space', 'applications', 'profiles'],
	        title: 'SPACE.MENU.APPLICATIONS.TITLE',
	        icon: {
	            image: 'fa fa-user-plus'
	        },
	        children: [
	            {
	                id: 'pending',
	                path: ['space', 'applications', 'profiles', 'new'],
	                title: 'SPACE.MENU.APPLICATIONS.NEW'
	            },
	            {
	                id: 'processing',
	                path: ['space', 'applications', 'profiles', 'processing'],
	                title: 'SPACE.MENU.APPLICATIONS.PROCESSING'
	            },
	            {
	                id: 'on_hold',
	                path: ['space', 'applications', 'profiles', 'onhold'],
	                title: 'SPACE.MENU.APPLICATIONS.ON_HOLD'
	            },
	            {
	                id: 'archived',
	                path: ['space', 'applications', 'profiles', 'archived'],
	                title: 'SPACE.MENU.APPLICATIONS.ARCHIVED'
	            },
	            {
	                id: 'declined',
	                path: ['space', 'applications', 'profiles', 'declined'],
	                title: 'SPACE.MENU.APPLICATIONS.DECLINED'
	            },
	            {
	                id: 'manual_review',
	                path: ['space', 'applications', 'profiles', 'manualreview'],
	                title: 'SPACE.MENU.APPLICATIONS.MANUAL_REVIEW'
	            }
	        ]
	    },
	    {
	        id: 'customers',
	        path: ['space', 'customers', 'profiles'],
	        title: 'SPACE.MENU.CUSTOMERS.TITLE',
	        icon: {
	            image: 'fa fa-users'
	        },
	        children: [
	            {
	                id: 'registered',
	                path: ['space', 'customers', 'profiles', 'registered'],
	                title: 'SPACE.MENU.CUSTOMERS.REGISTERED_PROFILES'
	            },
	            {
	                id: 'pending',
	                path: ['space', 'customers', 'profiles', 'pending'],
	                title: 'SPACE.MENU.CUSTOMERS.PENDING_PROFILES'
	            }
	        ]
	    }
	];


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var CardTransferMenuIcon = (function () {
	    function CardTransferMenuIcon() {
	    }
	    CardTransferMenuIcon = __decorate([
	        core_1.Component({
	            template: __webpack_require__(882)
	        })
	    ], CardTransferMenuIcon);
	    return CardTransferMenuIcon;
	}());
	exports.CardTransferMenuIcon = CardTransferMenuIcon;


/***/ }),
/* 882 */
/***/ (function(module, exports) {

	module.exports = "<svg height=\"22px\" width=\"22px\" id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 14.4\">\n    <path d=\"M10.91,44.75a0.4,0.4,0,0,0,.28-0.68l-0.91-.92h4.41a0.4,0.4,0,0,0,0-.8H10.28l0.91-.92a0.4,0.4,0,1,0-.56-0.56L9,42.47A0.39,0.39,0,0,0,9,43l1.6,1.6A0.38,0.38,0,0,0,10.91,44.75Z\"\n          transform=\"translate(-3 -32.55)\"/>\n    <path d=\"M19.5,32.55a1.5,1.5,0,0,1,1.5,1.5v11.4A1.5,1.5,0,0,1,19.5,47H4.5A1.5,1.5,0,0,1,3,45.45V34.05a1.5,1.5,0,0,1,1.5-1.5h15Zm-15,1.2a0.3,0.3,0,0,0-.3.3v2.1H19.8v-2.1a0.31,0.31,0,0,0-.3-0.3H4.5Zm15,12a0.31,0.31,0,0,0,.3-0.3v-5.7H4.2v5.7a0.3,0.3,0,0,0,.3.3h15Z\"\n          transform=\"translate(-3 -32.55)\"/>\n</svg>"

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var http_1 = __webpack_require__(852);
	var rxjs_1 = __webpack_require__(304);
	var operators_1 = __webpack_require__(680);
	var cookies_1 = __webpack_require__(738);
	var constants_1 = __webpack_require__(861);
	var router_1 = __webpack_require__(270);
	var core_1 = __webpack_require__(205);
	var BOHttpClientInterceptor = (function () {
	    function BOHttpClientInterceptor(_router) {
	        this._router = _router;
	    }
	    BOHttpClientInterceptor_1 = BOHttpClientInterceptor;
	    BOHttpClientInterceptor.prototype.intercept = function (req, next) {
	        var redirectOnForbidden = !req.headers.has(BOHttpClientInterceptor_1.NO_FORBIDDEN_REDIRECT_HEADER);
	        return next.handle(this.modifyRequest(req))
	            .pipe(operators_1.map(this.onResponseCallback()), operators_1.catchError(this.onResponseErrorCallback(redirectOnForbidden)));
	    };
	    BOHttpClientInterceptor.prototype.modifyRequest = function (request) {
	        return request.clone({
	            headers: this.setRequestHeaders(request).delete(BOHttpClientInterceptor_1.NO_FORBIDDEN_REDIRECT_HEADER)
	        });
	    };
	    BOHttpClientInterceptor.prototype.onResponseCallback = function () {
	        var _this = this;
	        return function (response) {
	            switch (response.type) {
	                case http_1.HttpEventType.Response:
	                    _this.trySaveTokenHeader(response.headers);
	                    break;
	            }
	            return response;
	        };
	    };
	    BOHttpClientInterceptor.prototype.onResponseErrorCallback = function (redirectOnForbidden) {
	        var _this = this;
	        return function (error) {
	            if (error.status === 403 && redirectOnForbidden) {
	                _this._router.navigate([BOHttpClientInterceptor_1.UNAUTHORIZED_PAGE]);
	            }
	            return rxjs_1.Observable.throw(error);
	        };
	    };
	    BOHttpClientInterceptor.prototype.setRequestHeaders = function (req) {
	        var headers = req.headers;
	        if (cookies_1.CookiesManager.isTokenExist()) {
	            headers = headers.set(constants_1.TOKEN_HEADER, cookies_1.CookiesManager.getToken());
	        }
	        return headers;
	    };
	    BOHttpClientInterceptor.prototype.trySaveTokenHeader = function (headers) {
	        if (headers.has(constants_1.TOKEN_HEADER)) {
	            cookies_1.CookiesManager.setToken(headers.get(constants_1.TOKEN_HEADER));
	        }
	    };
	    BOHttpClientInterceptor.UNAUTHORIZED_PAGE = '/space/unauthorized';
	    /**
	     * Request-only marker (never sent to the server): a 403 on this request reaches the caller's error callback
	     * without leaving the screen. For optional calls of a page (e.g. whether to show an action button).
	     */
	    BOHttpClientInterceptor.NO_FORBIDDEN_REDIRECT_HEADER = 'X-BO-No-Forbidden-Redirect';
	    BOHttpClientInterceptor = BOHttpClientInterceptor_1 = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [router_1.Router])
	    ], BOHttpClientInterceptor);
	    return BOHttpClientInterceptor;
	    var BOHttpClientInterceptor_1;
	}());
	exports.BOHttpClientInterceptor = BOHttpClientInterceptor;


/***/ }),
/* 884 */
/***/ (function(module, exports) {

	module.exports = "<ul class=\"nav side-menu\">\n    <li *ngFor=\"let item of menuUpdatedFromPermissions\" [ngClass]=\"getMenuItemClasses(item)\">\n        <a [id]=\"item.id\" (click)=\"toggleMenuItem(item)\" [class.disabled-item]=\"isDisabled(item)\">\n            <tfl-menu-icon [menu-icon]=\"item.icon\"></tfl-menu-icon>\n            <span class=\"menu-title\">{{ item.title | translate }}</span>\n            <span class=\"menu-counter\" *ngIf=\"childrenCount(item) > 0\" [title]=\"childrenCountTitle(item)\">{{ childrenCount(item) }}</span>\n            <span class=\"fa fa-chevron-down\"></span>\n        </a>\n\n        <ul class=\"nav child_menu\">\n            <li *ngFor=\"let child of item.children\" [ngClass]=\"getMenuItemAnchorClasses(child)\">\n                <a [id]=\"child.id\" (click)=\"handleMenuItemClick(child)\" [class.disabled-item]=\"isDisabled(child)\">\n                    {{ child.title | translate }}\n                    <span class=\"menu-counter\" *ngIf=\"counterValue(child) > 0\" [title]=\"counterTitle(child)\"\n                          (click)=\"openCounter(child, $event)\">{{ counterValue(child) }}</span>\n                </a>\n            </li>\n        </ul>\n    </li>\n</ul>"

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var card_transfer_menu_icon_1 = __webpack_require__(881);
	var MenuIcon = (function () {
	    function MenuIcon(_cd, _cfr) {
	        this._cd = _cd;
	        this._cfr = _cfr;
	    }
	    MenuIcon.prototype.ngOnInit = function () {
	        var _this = this;
	        if (this.isComponentImage()) {
	            setTimeout(function () {
	                var factory = _this._cfr.resolveComponentFactory(_this.icon.componentImage.type);
	                _this._component = _this.content.createComponent(factory, 0).instance;
	                _this._cd.detectChanges();
	            });
	        }
	    };
	    MenuIcon.prototype.isComponentImage = function () {
	        return !!this.icon.componentImage;
	    };
	    __decorate([
	        core_1.Input('menu-icon'),
	        __metadata("design:type", Object)
	    ], MenuIcon.prototype, "icon", void 0);
	    __decorate([
	        core_1.ViewChild('content', { read: core_1.ViewContainerRef }),
	        __metadata("design:type", core_1.ViewContainerRef)
	    ], MenuIcon.prototype, "content", void 0);
	    MenuIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-menu-icon',
	            entryComponents: [
	                card_transfer_menu_icon_1.CardTransferMenuIcon
	            ],
	            template: __webpack_require__(886)
	        }),
	        __metadata("design:paramtypes", [core_1.ChangeDetectorRef,
	            core_1.ComponentFactoryResolver])
	    ], MenuIcon);
	    return MenuIcon;
	}());
	exports.MenuIcon = MenuIcon;


/***/ }),
/* 886 */
/***/ (function(module, exports) {

	module.exports = "<span *ngIf=\"isComponentImage()\" class=\"{{icon.componentImage.style}}\">\n    <i #content></i>\n</span>\n<i *ngIf=\"!isComponentImage()\"\n   class=\"{{icon.image}}\">\n</i>"

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(888));


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var security_1 = __webpack_require__(736);
	var TopBarComponent = (function () {
	    function TopBarComponent(_sessionService) {
	        this._sessionService = _sessionService;
	    }
	    TopBarComponent.prototype.logout = function () {
	        this._sessionService.logout();
	    };
	    TopBarComponent = __decorate([
	        core_1.Component({
	            selector: 'bs-top-bar',
	            template: __webpack_require__(889)
	        }),
	        __metadata("design:paramtypes", [security_1.SessionService])
	    ], TopBarComponent);
	    return TopBarComponent;
	}());
	exports.TopBarComponent = TopBarComponent;


/***/ }),
/* 889 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"top_nav\">\n    <div class=\"nav_menu\">\n        <nav>\n            <div class=\"nav toggle nav-hamburger\">\n                <menu-resizer></menu-resizer>\n            </div>\n\n            <ul class=\"nav navbar-nav navbar-right\">\n                <li>\n                    <a id=\"logout-button\" (click)=\"logout()\">\n                        <i class=\"fa fa-sign-out\"></i>\n                    </a>\n                </li>\n            </ul>\n        </nav>\n    </div>\n</div>"

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(891));
	__export(__webpack_require__(893));


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var ErrorComponent = (function () {
	    function ErrorComponent() {
	    }
	    ErrorComponent.prototype.ngOnInit = function () {
	        console.log('Error component initialized');
	    };
	    ErrorComponent = __decorate([
	        core_1.Component({
	            selector: 'error',
	            encapsulation: core_1.ViewEncapsulation.None,
	            template: __webpack_require__(892)
	        }),
	        __metadata("design:paramtypes", [])
	    ], ErrorComponent);
	    return ErrorComponent;
	}());
	exports.ErrorComponent = ErrorComponent;


/***/ }),
/* 892 */
/***/ (function(module, exports) {

	module.exports = "<thank-you isError=\"true\">\n    <p id=\"common-error-message\">{{'COMMON.ERROR'|translate}}</p>\n</thank-you>\n"

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var UnauthorizedComponent = (function () {
	    function UnauthorizedComponent() {
	    }
	    UnauthorizedComponent.prototype.ngOnInit = function () {
	    };
	    UnauthorizedComponent = __decorate([
	        core_1.Component({
	            selector: 'unauthorized',
	            encapsulation: core_1.ViewEncapsulation.None,
	            template: __webpack_require__(894)
	        }),
	        __metadata("design:paramtypes", [])
	    ], UnauthorizedComponent);
	    return UnauthorizedComponent;
	}());
	exports.UnauthorizedComponent = UnauthorizedComponent;


/***/ }),
/* 894 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"error-page-body\">\n    <i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i>\n    <div class=\"title\">\n        <p>{{'AUTHORIZATION.UNAUTHORIZED_TITLE'|translate}}</p>\n    </div>\n    <div class=\"col-md-10 col-md-offset-1 col-xs-12 content \">\n        <p>{{'AUTHORIZATION.UNAUTHORIZED_MESSAGE'|translate}}</p>\n    </div>\n    <div class=\"col-md-8 col-md-offset-2 col-xs-12\">\n        <button routerLink=\"/\" class=\"btn-link\">\n            <i class=\"fa fa-long-arrow-left\" aria-hidden=\"true\"></i>\n            {{'THANK_YOU_PAGE.HOME'|translate}}\n        </button>\n    </div>\n</div>"

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(896));


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var DashboardComponent = (function () {
	    function DashboardComponent() {
	    }
	    DashboardComponent = __decorate([
	        core_1.Component({
	            selector: 'dashboard',
	            template: __webpack_require__(897)
	        }),
	        __metadata("design:paramtypes", [])
	    ], DashboardComponent);
	    return DashboardComponent;
	}());
	exports.DashboardComponent = DashboardComponent;


/***/ }),
/* 897 */
/***/ (function(module, exports) {

	module.exports = "<div>\n    <div class=\"row tile_count\">\n        <div class=\"col-md-2 col-sm-4 col-xs-6 tile_stats_count\">\n            <span class=\"count_top\"><i class=\"fa fa-user\"></i> Total Users</span>\n            <div class=\"count\">2500</div>\n            <span class=\"count_bottom\"><i class=\"green\">4% </i> From last Week</span>\n        </div>\n        <div class=\"col-md-2 col-sm-4 col-xs-6 tile_stats_count\">\n            <span class=\"count_top\"><i class=\"fa fa-clock-o\"></i> Average Time</span>\n            <div class=\"count\">123.50</div>\n            <span class=\"count_bottom\"><i class=\"green\"><i class=\"fa fa-sort-asc\"></i>3% </i> From last Week</span>\n        </div>\n        <div class=\"col-md-2 col-sm-4 col-xs-6 tile_stats_count\">\n            <span class=\"count_top\"><i class=\"fa fa-user\"></i> Total Males</span>\n            <div class=\"count green\">2,500</div>\n            <span class=\"count_bottom\"><i class=\"green\"><i class=\"fa fa-sort-asc\"></i>34% </i> From last Week</span>\n        </div>\n        <div class=\"col-md-2 col-sm-4 col-xs-6 tile_stats_count\">\n            <span class=\"count_top\"><i class=\"fa fa-user\"></i> Total Females</span>\n            <div class=\"count\">4,567</div>\n            <span class=\"count_bottom\"><i class=\"red\"><i class=\"fa fa-sort-desc\"></i>12% </i> From last Week</span>\n        </div>\n        <div class=\"col-md-2 col-sm-4 col-xs-6 tile_stats_count\">\n            <span class=\"count_top\"><i class=\"fa fa-user\"></i> Total Collections</span>\n            <div class=\"count\">2,315</div>\n            <span class=\"count_bottom\"><i class=\"green\"><i class=\"fa fa-sort-asc\"></i>34% </i> From last Week</span>\n        </div>\n        <div class=\"col-md-2 col-sm-4 col-xs-6 tile_stats_count\">\n            <span class=\"count_top\"><i class=\"fa fa-user\"></i> Total Connections</span>\n            <div class=\"count\">7,325</div>\n            <span class=\"count_bottom\"><i class=\"green\"><i class=\"fa fa-sort-asc\"></i>34% </i> From last Week</span>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var BlankComponent = (function () {
	    function BlankComponent() {
	    }
	    BlankComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-blank-page',
	            template: '<div id="blank-page-element"></div>'
	        })
	    ], BlankComponent);
	    return BlankComponent;
	}());
	exports.BlankComponent = BlankComponent;


/***/ }),
/* 899 */,
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(901));
	__export(__webpack_require__(916));
	__export(__webpack_require__(917));


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var dashboard_http_1 = __webpack_require__(902);
	var providers_1 = __webpack_require__(905);
	var HTTP_CLIENT_PROVIDER = {
	    provide: http_1.Http,
	    useFactory: function (backend, options) { return new dashboard_http_1.DashboardHttp(backend, options); },
	    deps: [http_1.XHRBackend, http_1.RequestOptions]
	};
	var DashboardHttpModule = (function () {
	    function DashboardHttpModule() {
	    }
	    DashboardHttpModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                http_1.HttpModule
	            ],
	            providers: providers_1.COMMON_XHR_BACKEND_PROVIDERS.concat([
	                HTTP_CLIENT_PROVIDER
	            ]),
	            exports: [
	                http_1.HttpModule
	            ]
	        })
	    ], DashboardHttpModule);
	    return DashboardHttpModule;
	}());
	exports.DashboardHttpModule = DashboardHttpModule;


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var cookies_1 = __webpack_require__(738);
	var constants_1 = __webpack_require__(861);
	var http_1 = __webpack_require__(903);
	var http_2 = __webpack_require__(836);
	var DashboardHttp = (function (_super) {
	    __extends(DashboardHttp, _super);
	    function DashboardHttp(backend, defaultOptions) {
	        return _super.call(this, backend, defaultOptions) || this;
	    }
	    DashboardHttp.prototype.modifyOptions = function (options) {
	        if (options == null) {
	            options = new http_2.RequestOptions();
	        }
	        if (options.headers == null) {
	            options.headers = new http_2.Headers();
	        }
	        this.trySetTokenHeader(options.headers);
	        return options;
	    };
	    DashboardHttp.prototype.modifyResponseCallback = function () {
	        return function (response) {
	            if (response && response.headers) {
	                if (response.headers.has(constants_1.TOKEN_HEADER)) {
	                    cookies_1.CookiesManager.setToken(response.headers.get(constants_1.TOKEN_HEADER));
	                }
	            }
	            return response;
	        };
	    };
	    DashboardHttp.prototype.trySetTokenHeader = function (headers) {
	        if (cookies_1.CookiesManager.isTokenExist()) {
	            headers.append(constants_1.TOKEN_HEADER, cookies_1.CookiesManager.getToken());
	        }
	    };
	    DashboardHttp = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_2.ConnectionBackend, http_2.RequestOptions])
	    ], DashboardHttp);
	    return DashboardHttp;
	}(http_1.MutableHttp));
	exports.DashboardHttp = DashboardHttp;


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(904));


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var http_1 = __webpack_require__(836);
	var rxjs_1 = __webpack_require__(304);
	var MutableHttp = (function (_super) {
	    __extends(MutableHttp, _super);
	    function MutableHttp(backend, defaultOptions) {
	        return _super.call(this, backend, defaultOptions) || this;
	    }
	    MutableHttp.prototype.request = function (url, options) {
	        return _super.prototype.request.call(this, url, this.modifyOptions(options))
	            .map(this.modifyResponseCallback())
	            .catch(this.modifyResponseErrorCallback());
	    };
	    MutableHttp.prototype.get = function (url, options) {
	        return _super.prototype.get.call(this, url, this.modifyOptions(options)).map(this.modifyResponseCallback());
	    };
	    MutableHttp.prototype.post = function (url, body, options) {
	        return _super.prototype.post.call(this, url, body, this.modifyOptions(options)).map(this.modifyResponseCallback());
	    };
	    MutableHttp.prototype.put = function (url, body, options) {
	        return _super.prototype.put.call(this, url, body, this.modifyOptions(options)).map(this.modifyResponseCallback());
	    };
	    MutableHttp.prototype.delete = function (url, options) {
	        return _super.prototype.delete.call(this, url, this.modifyOptions(options)).map(this.modifyResponseCallback());
	    };
	    MutableHttp.prototype.patch = function (url, body, options) {
	        return _super.prototype.patch.call(this, url, body, this.modifyOptions(options)).map(this.modifyResponseCallback());
	    };
	    MutableHttp.prototype.modifyResponseCallback = function () {
	        return function (response) { return response; };
	    };
	    MutableHttp.prototype.modifyResponseErrorCallback = function () {
	        return function (response) { return rxjs_1.Observable.throw(response); };
	    };
	    return MutableHttp;
	}(http_1.Http));
	exports.MutableHttp = MutableHttp;


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_xhr_backend_1 = __webpack_require__(906);
	var common_error_resolver_1 = __webpack_require__(913);
	var http_1 = __webpack_require__(836);
	__export(__webpack_require__(915));
	__export(__webpack_require__(906));
	__export(__webpack_require__(913));
	exports.COMMON_XHR_BACKEND_PROVIDERS = [
	    {
	        provide: http_1.XHRBackend,
	        useFactory: function (browser, options, strategy, errorResolver) {
	            return new common_xhr_backend_1.CommonXhrBackend(browser, options, strategy, errorResolver);
	        },
	        deps: [http_1.BrowserXhr, http_1.ResponseOptions, http_1.XSRFStrategy, common_error_resolver_1.CommonErrorResolver]
	    }
	];


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var rxjs_1 = __webpack_require__(304);
	var http_1 = __webpack_require__(836);
	var exception_factory_1 = __webpack_require__(907);
	var CommonXhrBackend = (function (_super) {
	    __extends(CommonXhrBackend, _super);
	    function CommonXhrBackend(browser, options, strategy, _errorResolver) {
	        var _this = _super.call(this, browser, options, strategy) || this;
	        _this._errorResolver = _errorResolver;
	        return _this;
	    }
	    CommonXhrBackend.prototype.createConnection = function (request) {
	        var connection = _super.prototype.createConnection.call(this, request);
	        connection.response = this.wrapObservable(connection.response, request && request.url);
	        return connection;
	    };
	    CommonXhrBackend.prototype.wrapObservable = function (response, url) {
	        var _this = this;
	        return rxjs_1.Observable.create(function (observer) {
	            response.subscribe(function (value) {
	                observer.next(value);
	            }, function (error) {
	                if (_this.handledByScreen(url, error)) {
	                    try {
	                        observer.error(_this._errorResolver.toErrorResponse(error));
	                    }
	                    catch (e) {
	                        var resolved = _this._errorResolver.resolve(error);
	                        throw exception_factory_1.ExceptionFactory.createServerException(resolved.status, resolved.message, resolved.code);
	                    }
	                    return;
	                }
	                var errorResponse = _this._errorResolver.resolve(error);
	                try {
	                    observer.error(errorResponse);
	                }
	                catch (e) {
	                    throw exception_factory_1.ExceptionFactory.createServerException(errorResponse.status, errorResponse.message, errorResponse.code);
	                }
	            }, function () {
	                observer.complete();
	            });
	        });
	    };
	    CommonXhrBackend.prototype.handledByScreen = function (url, error) {
	        if (!url || !error || typeof error.status !== 'number' || error.status === 401 || error.status === 403) {
	            return false;
	        }
	        return CommonXhrBackend.SCREEN_HANDLED_URLS.some(function (prefix) { return url.indexOf(prefix) >= 0; })
	            || CommonXhrBackend.SCREEN_HANDLED_URL_PATTERNS.some(function (pattern) { return pattern.test(url.split('?')[0]); });
	    };
	    /**
	     * Back-office screens that show their own errors (inline message, retry, empty state): for these URLs an HTTP
	     * error reaches the screen's error callback instead of the global handler. Session and permission errors (401,
	     * 403) stay global, and a call without an error callback still goes to the global handler as before.
	     */
	    CommonXhrBackend.SCREEN_HANDLED_URLS = ['/api/backoffice/open-banking/', '/api/backoffice/finxp/errors'];
	    /**
	     * Same, for URLs with ids in the middle: the customer "Users" tab (users, roles, linked accounts and 2FA)
	     * and the customer "API access" tab (eapi consumers).
	     */
	    CommonXhrBackend.SCREEN_HANDLED_URL_PATTERNS = [
	        /api\/backoffice\/customers\/\d+\/(users\/|new-user$|authorised-user$|update\/state$)/,
	        /api\/backoffice\/customers\/\d+\/api-access(\/|$)/,
	        /api\/backoffice\/customers\/(account|delete-account-role|profile-user-role\/details|twoFa)\//,
	        /api\/backoffice\/customers\/profile\/\d+\/role-accounts\//
	    ];
	    return CommonXhrBackend;
	}(http_1.XHRBackend));
	exports.CommonXhrBackend = CommonXhrBackend;


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var entity_1 = __webpack_require__(908);
	var ExceptionFactory = (function () {
	    function ExceptionFactory() {
	    }
	    ExceptionFactory.createServerException = function (status, message, code) {
	        return new entity_1.ServerException(status, message, code);
	    };
	    ExceptionFactory.createSystemException = function (message, error) {
	        return new entity_1.SystemException(message, error);
	    };
	    ExceptionFactory.createUnavailableException = function (message, description) {
	        return new entity_1.UnavailableException(message, description);
	    };
	    return ExceptionFactory;
	}());
	exports.ExceptionFactory = ExceptionFactory;


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(909));
	__export(__webpack_require__(910));
	__export(__webpack_require__(911));
	__export(__webpack_require__(912));


/***/ }),
/* 909 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var WBCommonException = (function () {
	    function WBCommonException(message) {
	        this.message = message;
	    }
	    return WBCommonException;
	}());
	exports.WBCommonException = WBCommonException;


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var exception_1 = __webpack_require__(909);
	var ServerException = (function (_super) {
	    __extends(ServerException, _super);
	    function ServerException(status, message, code) {
	        var _this = _super.call(this, message) || this;
	        _this.status = status;
	        _this.message = message;
	        _this.code = code;
	        _this.name = 'ServerException';
	        return _this;
	    }
	    return ServerException;
	}(exception_1.WBCommonException));
	exports.ServerException = ServerException;


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var exception_1 = __webpack_require__(909);
	var SystemException = (function (_super) {
	    __extends(SystemException, _super);
	    function SystemException(message, error) {
	        var _this = _super.call(this, message) || this;
	        _this.message = message;
	        _this.error = error;
	        _this.name = 'SystemException';
	        return _this;
	    }
	    return SystemException;
	}(exception_1.WBCommonException));
	exports.SystemException = SystemException;


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var exception_1 = __webpack_require__(909);
	var UnavailableException = (function (_super) {
	    __extends(UnavailableException, _super);
	    function UnavailableException(message, description) {
	        var _this = _super.call(this, message) || this;
	        _this.message = message;
	        _this.description = description;
	        _this.name = 'UnavailableException';
	        return _this;
	    }
	    return UnavailableException;
	}(exception_1.WBCommonException));
	exports.UnavailableException = UnavailableException;


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var http_1 = __webpack_require__(836);
	var constants_1 = __webpack_require__(861);
	var core_1 = __webpack_require__(205);
	var exception_1 = __webpack_require__(914);
	var CommonErrorResolver = (function () {
	    function CommonErrorResolver() {
	    }
	    CommonErrorResolver.prototype.resolve = function (error) {
	        if (this.isHTTPError(error)) {
	            return this.resolveHTTPError(error);
	        }
	        else {
	            throw exception_1.ExceptionFactory.createSystemException('Internal system error!', error);
	        }
	    };
	    /** The error as {status, code, message} without resolving it (no exception is thrown). */
	    CommonErrorResolver.prototype.toErrorResponse = function (error) {
	        return this.isHTTPError(error)
	            ? this.httpResponseToErrorResponse(error)
	            : { status: 0, code: undefined, message: 'Internal system error!', messageArgs: undefined };
	    };
	    CommonErrorResolver.prototype.isHTTPError = function (error) {
	        return lodash_1.has(error, 'status');
	    };
	    CommonErrorResolver.prototype.resolveHTTPError = function (error) {
	        switch (error.status) {
	            case constants_1.HttpStatus.BAD_REQUEST:
	                return this.resolveBadRequestErrors(this.httpResponseToErrorResponse(error));
	            case constants_1.HttpStatus.UNAUTHORIZED:
	                return this.resolveAuthorizationErrors(this.httpResponseToErrorResponse(error));
	            case constants_1.HttpStatus.FORBIDDEN:
	                return this.resolveForbiddenErrors(this.httpResponseToErrorResponse(error));
	            case constants_1.HttpStatus.NOT_FOUND:
	                return this.resolveNotFoundError(error);
	            case constants_1.HttpStatus.INTERNAL_SERVER_ERROR:
	                return this.resolveInternalServerError(this.httpResponseToErrorResponse(error));
	            case constants_1.HttpStatus.BAD_GATEWAY_ERROR:
	                return this.resolveUnavailableError(error);
	            default:
	                return this.resolveUndefinedSystemError(this.httpResponseToErrorResponse(error));
	        }
	    };
	    CommonErrorResolver.prototype.resolveBadRequestErrors = function (error) {
	        throw exception_1.ExceptionFactory.createServerException(error.status, error.message, error.code);
	    };
	    CommonErrorResolver.prototype.resolveAuthorizationErrors = function (error) {
	        throw exception_1.ExceptionFactory.createServerException(error.status, error.message);
	    };
	    CommonErrorResolver.prototype.resolveForbiddenErrors = function (error) {
	        throw exception_1.ExceptionFactory.createServerException(error.status, error.message);
	    };
	    CommonErrorResolver.prototype.resolveInternalServerError = function (error) {
	        throw exception_1.ExceptionFactory.createServerException(error.status, error.message);
	    };
	    CommonErrorResolver.prototype.resolveUndefinedSystemError = function (error) {
	        throw exception_1.ExceptionFactory.createServerException(error.status, error.message);
	    };
	    CommonErrorResolver.prototype.resolveUnavailableError = function (error) {
	        throw exception_1.ExceptionFactory.createUnavailableException(lodash_1.get(error, 'statusText', 'Unavailable exception!'));
	    };
	    CommonErrorResolver.prototype.resolveNotFoundError = function (error) {
	        throw exception_1.ExceptionFactory.createUnavailableException(lodash_1.get(error, 'statusText', 'Not found error!'));
	    };
	    CommonErrorResolver.prototype.httpResponseToErrorResponse = function (error) {
	        var code = undefined, message = undefined, messageArgs = undefined, status = error.status;
	        if (error instanceof http_1.Response) {
	            try {
	                var response = error.json();
	                // Check if response is a plain string (backend returned a JSON string like "\"message\"")
	                if (typeof response === 'string') {
	                    message = response;
	                }
	                else {
	                    code = lodash_1.get(response, 'code');
	                    message = lodash_1.get(response, 'message');
	                    messageArgs = lodash_1.get(response, 'messageArgs');
	                }
	            }
	            catch (e) {
	                // If JSON parsing fails, try to get text response
	                try {
	                    message = error.text();
	                }
	                catch (textError) {
	                    message = 'Unknown server error';
	                }
	            }
	        }
	        return { status: status, code: code, message: message, messageArgs: messageArgs };
	    };
	    CommonErrorResolver = __decorate([
	        core_1.Injectable()
	    ], CommonErrorResolver);
	    return CommonErrorResolver;
	}());
	exports.CommonErrorResolver = CommonErrorResolver;


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(908));
	__export(__webpack_require__(907));


/***/ }),
/* 915 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ErrorResponse = (function () {
	    function ErrorResponse() {
	    }
	    return ErrorResponse;
	}());
	exports.ErrorResponse = ErrorResponse;


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(852);
	var bo_http_interceptor_1 = __webpack_require__(883);
	var router_1 = __webpack_require__(270);
	var HTTP_CLIENT_INTERCEPTORS = [
	    {
	        provide: http_1.HTTP_INTERCEPTORS,
	        useClass: bo_http_interceptor_1.BOHttpClientInterceptor,
	        multi: true
	    }
	];
	var BOHttpModule = (function () {
	    function BOHttpModule() {
	    }
	    BOHttpModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                http_1.HttpClientModule,
	                router_1.RouterModule
	            ],
	            providers: [
	                HTTP_CLIENT_INTERCEPTORS
	            ],
	            exports: [
	                http_1.HttpClientModule
	            ]
	        })
	    ], BOHttpModule);
	    return BOHttpModule;
	}());
	exports.BOHttpModule = BOHttpModule;


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var http_1 = __webpack_require__(836);
	var AbstractService = (function () {
	    function AbstractService() {
	    }
	    AbstractService.prototype.searchQuery = function (name, value) {
	        var search = new http_1.URLSearchParams();
	        search.append(name, value);
	        return search;
	    };
	    return AbstractService;
	}());
	exports.AbstractService = AbstractService;


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(919));


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_1 = __webpack_require__(246);
	var router_1 = __webpack_require__(270);
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var core_2 = __webpack_require__(252);
	var ng_select_1 = __webpack_require__(920);
	var components_1 = __webpack_require__(921);
	var pipes_1 = __webpack_require__(1085);
	var api_1 = __webpack_require__(1089);
	var back_button_1 = __webpack_require__(1139);
	var bo_tabs_1 = __webpack_require__(1140);
	var card_box_1 = __webpack_require__(1143);
	var combo_search_1 = __webpack_require__(1160);
	var data_item_1 = __webpack_require__(1163);
	var directives_1 = __webpack_require__(1165);
	var drag_and_drop_1 = __webpack_require__(1168);
	var dropdown_1 = __webpack_require__(1171);
	var filter_1 = __webpack_require__(1174);
	var icons_1 = __webpack_require__(1190);
	var input_1 = __webpack_require__(1221);
	var leave_block_1 = __webpack_require__(1230);
	var modal_1 = __webpack_require__(1237);
	var navigation_1 = __webpack_require__(1157);
	var pagination_1 = __webpack_require__(1243);
	var pipes_2 = __webpack_require__(1246);
	var revenue_1 = __webpack_require__(1251);
	var success_component_1 = __webpack_require__(1274);
	var table_1 = __webpack_require__(1276);
	var transfer_icon_factory_1 = __webpack_require__(1278);
	var components_2 = __webpack_require__(1279);
	var elements_1 = __webpack_require__(1289);
	var account_state_log_1 = __webpack_require__(1294);
	var customer_account_1 = __webpack_require__(1297);
	var chip_component_1 = __webpack_require__(1301);
	var chips_1 = __webpack_require__(1303);
	var icon_1 = __webpack_require__(1306);
	var autocomplete_1 = __webpack_require__(1307);
	var select_1 = __webpack_require__(1311);
	var input_2 = __webpack_require__(1312);
	var http_1 = __webpack_require__(900);
	var security_1 = __webpack_require__(736);
	var profile_user_1 = __webpack_require__(1313);
	var menu_1 = __webpack_require__(1326);
	var option_dialog_1 = __webpack_require__(1317);
	var SharedModule = (function () {
	    function SharedModule() {
	    }
	    SharedModule_1 = SharedModule;
	    SharedModule.forRoot = function () {
	        return {
	            ngModule: SharedModule_1,
	            providers: api_1.SHARED_API_PROVIDERS.concat(filter_1.FILTER_PROVIDERS, leave_block_1.LEAVE_BLOCKABLE_PROVIDERS, modal_1.MODAL_POPUP_PROVIDERS, navigation_1.NAVIGATION_SERVICES, revenue_1.REVENUE_DISTRIBUTION_PROVIDERS)
	        };
	    };
	    SharedModule = SharedModule_1 = __decorate([
	        core_1.NgModule({
	            imports: [
	                common_1.CommonModule,
	                forms_1.FormsModule,
	                forms_1.ReactiveFormsModule,
	                core_2.TranslateModule,
	                components_1.CommonComponentsModule,
	                input_1.DateRangePickerModule,
	                ng_select_1.SelectModule,
	                router_1.RouterModule,
	                pipes_1.DashboardPipesModule,
	                chips_1.MatChipsModule,
	                icon_1.MatIconModule,
	                autocomplete_1.MatAutocompleteModule,
	                select_1.MatSelectModule,
	                input_2.MatInputModule,
	                http_1.BOHttpModule,
	                menu_1.MatMenuModule
	            ],
	            providers: api_1.SHARED_API_PROVIDERS.concat(filter_1.FILTER_PROVIDERS, leave_block_1.LEAVE_BLOCKABLE_PROVIDERS, modal_1.MODAL_POPUP_PROVIDERS, navigation_1.NAVIGATION_SERVICES, revenue_1.REVENUE_DISTRIBUTION_PROVIDERS, components_2.CUSTOM_PROVIDERS, [
	                security_1.RoleService
	            ]),
	            declarations: combo_search_1.COMBO_SEARCH_COMPONENT.concat(card_box_1.CARD_BOX_COMPONENTS, filter_1.FILTER_COMPONENTS, data_item_1.DATA_ITEM_COMPONENTS, leave_block_1.LEAVE_BLOCKABLE_COMPONENTS, modal_1.MODAL_POPUP_COMPONENTS, table_1.TABLE_COMPONENTS, pipes_2.PIPES, drag_and_drop_1.DRAG_AND_DROP_COMPONENTS, directives_1.DIRECTIVES, dropdown_1.DROPDOWN_COMPONENTS, revenue_1.REVENUE_DISTRIBUTION_SETTINGS_COMPONENTS, bo_tabs_1.BO_TAB_COMPONENTS, icons_1.TRANSFER_ICONS, components_2.CUSTOM_COMPONENTS, customer_account_1.SHARED_CUSTOMER_ACCOUNT_COMPONENTS, profile_user_1.SHARED_PROFILE_USER_COMPONENTS, elements_1.CUSTOM_ELEMENTS, option_dialog_1.OPTION_DIALOG_COMPONENTS, [
	                success_component_1.SuccessPageComponent,
	                pagination_1.PaginationComponent,
	                back_button_1.BackButtonComponent,
	                transfer_icon_factory_1.TransferIconFactory,
	                input_1.IbanControlDirective
	            ], account_state_log_1.ACCOUNT_STATE_LOG_COMPONENTS, [
	                chip_component_1.ChipComponent
	            ]),
	            exports: combo_search_1.COMBO_SEARCH_COMPONENT.concat(card_box_1.CARD_BOX_COMPONENTS, filter_1.FILTER_COMPONENTS, data_item_1.DATA_ITEM_COMPONENTS, leave_block_1.LEAVE_BLOCKABLE_COMPONENTS, table_1.TABLE_COMPONENTS, pipes_2.PIPES, modal_1.MODAL_POPUP_COMPONENTS, drag_and_drop_1.DRAG_AND_DROP_COMPONENTS, directives_1.DIRECTIVES, dropdown_1.DROPDOWN_COMPONENTS, revenue_1.REVENUE_DISTRIBUTION_SETTINGS_COMPONENTS, bo_tabs_1.BO_TAB_COMPONENTS, icons_1.TRANSFER_ICONS, components_2.CUSTOM_COMPONENTS, elements_1.CUSTOM_ELEMENTS, customer_account_1.SHARED_CUSTOMER_ACCOUNT_COMPONENTS, profile_user_1.SHARED_PROFILE_USER_COMPONENTS, option_dialog_1.OPTION_DIALOG_COMPONENTS, [
	                pagination_1.PaginationComponent,
	                success_component_1.SuccessPageComponent,
	                back_button_1.BackButtonComponent,
	                transfer_icon_factory_1.TransferIconFactory,
	                input_1.IbanControlDirective,
	                chip_component_1.ChipComponent,
	                common_1.CommonModule,
	                forms_1.FormsModule,
	                forms_1.ReactiveFormsModule,
	                ng_select_1.SelectModule,
	                core_2.TranslateModule,
	                input_1.DateRangePickerModule,
	                components_1.CommonComponentsModule,
	                pipes_1.DashboardPipesModule
	            ], account_state_log_1.ACCOUNT_STATE_LOG_COMPONENTS),
	            entryComponents: [
	                transfer_icon_factory_1.TransferIconFactory
	            ].concat(icons_1.TRANSFER_ICONS)
	        })
	    ], SharedModule);
	    return SharedModule;
	    var SharedModule_1;
	}());
	exports.SharedModule = SharedModule;


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	     true ? factory(exports, __webpack_require__(205), __webpack_require__(246), __webpack_require__(768)) :
	    typeof define === 'function' && define.amd ? define('ng-select', ['exports', '@angular/core', '@angular/common', '@angular/forms'], factory) :
	    (global = global || self, factory(global['ng-select'] = {}, global.ng.core, global.ng.common, global.ng.forms));
	}(this, function (exports, core, common, forms) { 'use strict';
	
	    /*! *****************************************************************************
	    Copyright (c) Microsoft Corporation. All rights reserved.
	    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	    this file except in compliance with the License. You may obtain a copy of the
	    License at http://www.apache.org/licenses/LICENSE-2.0
	
	    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	    MERCHANTABLITY OR NON-INFRINGEMENT.
	
	    See the Apache Version 2.0 License for specific language governing permissions
	    and limitations under the License.
	    ***************************************************************************** */
	
	    function __values(o) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	        if (m) return m.call(o);
	        return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	    }
	
	    /**
	     * @fileoverview added by tsickle
	     * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
	     */
	    var Option = /** @class */ (function () {
	        function Option(option) {
	            this.wrappedOption = option;
	            this.disabled = false;
	            this.highlighted = false;
	            this.selected = false;
	            this.shown = true;
	        }
	        Object.defineProperty(Option.prototype, "value", {
	            get: /**
	             * @return {?}
	             */
	            function () {
	                return this.wrappedOption.value;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(Option.prototype, "label", {
	            get: /**
	             * @return {?}
	             */
	            function () {
	                return this.wrappedOption.label;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        return Option;
	    }());
	
	    /**
	     * @fileoverview added by tsickle
	     * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
	     */
	    var Diacritics = /** @class */ (function () {
	        function Diacritics() {
	        }
	        /**
	         * @param {?} text
	         * @return {?}
	         */
	        Diacritics.strip = /**
	         * @param {?} text
	         * @return {?}
	         */
	        function (text) {
	            var _this = this;
	            /** @type {?} */
	            var match = (/**
	             * @param {?} a
	             * @return {?}
	             */
	            function (a) {
	                return _this.DIACRITICS[a] || a;
	            });
	            return text.replace(/[^\u0000-\u007E]/g, match);
	        };
	        Diacritics.DIACRITICS = {
	            '\u24B6': 'A',
	            '\uFF21': 'A',
	            '\u00C0': 'A',
	            '\u00C1': 'A',
	            '\u00C2': 'A',
	            '\u1EA6': 'A',
	            '\u1EA4': 'A',
	            '\u1EAA': 'A',
	            '\u1EA8': 'A',
	            '\u00C3': 'A',
	            '\u0100': 'A',
	            '\u0102': 'A',
	            '\u1EB0': 'A',
	            '\u1EAE': 'A',
	            '\u1EB4': 'A',
	            '\u1EB2': 'A',
	            '\u0226': 'A',
	            '\u01E0': 'A',
	            '\u00C4': 'A',
	            '\u01DE': 'A',
	            '\u1EA2': 'A',
	            '\u00C5': 'A',
	            '\u01FA': 'A',
	            '\u01CD': 'A',
	            '\u0200': 'A',
	            '\u0202': 'A',
	            '\u1EA0': 'A',
	            '\u1EAC': 'A',
	            '\u1EB6': 'A',
	            '\u1E00': 'A',
	            '\u0104': 'A',
	            '\u023A': 'A',
	            '\u2C6F': 'A',
	            '\uA732': 'AA',
	            '\u00C6': 'AE',
	            '\u01FC': 'AE',
	            '\u01E2': 'AE',
	            '\uA734': 'AO',
	            '\uA736': 'AU',
	            '\uA738': 'AV',
	            '\uA73A': 'AV',
	            '\uA73C': 'AY',
	            '\u24B7': 'B',
	            '\uFF22': 'B',
	            '\u1E02': 'B',
	            '\u1E04': 'B',
	            '\u1E06': 'B',
	            '\u0243': 'B',
	            '\u0182': 'B',
	            '\u0181': 'B',
	            '\u24B8': 'C',
	            '\uFF23': 'C',
	            '\u0106': 'C',
	            '\u0108': 'C',
	            '\u010A': 'C',
	            '\u010C': 'C',
	            '\u00C7': 'C',
	            '\u1E08': 'C',
	            '\u0187': 'C',
	            '\u023B': 'C',
	            '\uA73E': 'C',
	            '\u24B9': 'D',
	            '\uFF24': 'D',
	            '\u1E0A': 'D',
	            '\u010E': 'D',
	            '\u1E0C': 'D',
	            '\u1E10': 'D',
	            '\u1E12': 'D',
	            '\u1E0E': 'D',
	            '\u0110': 'D',
	            '\u018B': 'D',
	            '\u018A': 'D',
	            '\u0189': 'D',
	            '\uA779': 'D',
	            '\u01F1': 'DZ',
	            '\u01C4': 'DZ',
	            '\u01F2': 'Dz',
	            '\u01C5': 'Dz',
	            '\u24BA': 'E',
	            '\uFF25': 'E',
	            '\u00C8': 'E',
	            '\u00C9': 'E',
	            '\u00CA': 'E',
	            '\u1EC0': 'E',
	            '\u1EBE': 'E',
	            '\u1EC4': 'E',
	            '\u1EC2': 'E',
	            '\u1EBC': 'E',
	            '\u0112': 'E',
	            '\u1E14': 'E',
	            '\u1E16': 'E',
	            '\u0114': 'E',
	            '\u0116': 'E',
	            '\u00CB': 'E',
	            '\u1EBA': 'E',
	            '\u011A': 'E',
	            '\u0204': 'E',
	            '\u0206': 'E',
	            '\u1EB8': 'E',
	            '\u1EC6': 'E',
	            '\u0228': 'E',
	            '\u1E1C': 'E',
	            '\u0118': 'E',
	            '\u1E18': 'E',
	            '\u1E1A': 'E',
	            '\u0190': 'E',
	            '\u018E': 'E',
	            '\u24BB': 'F',
	            '\uFF26': 'F',
	            '\u1E1E': 'F',
	            '\u0191': 'F',
	            '\uA77B': 'F',
	            '\u24BC': 'G',
	            '\uFF27': 'G',
	            '\u01F4': 'G',
	            '\u011C': 'G',
	            '\u1E20': 'G',
	            '\u011E': 'G',
	            '\u0120': 'G',
	            '\u01E6': 'G',
	            '\u0122': 'G',
	            '\u01E4': 'G',
	            '\u0193': 'G',
	            '\uA7A0': 'G',
	            '\uA77D': 'G',
	            '\uA77E': 'G',
	            '\u24BD': 'H',
	            '\uFF28': 'H',
	            '\u0124': 'H',
	            '\u1E22': 'H',
	            '\u1E26': 'H',
	            '\u021E': 'H',
	            '\u1E24': 'H',
	            '\u1E28': 'H',
	            '\u1E2A': 'H',
	            '\u0126': 'H',
	            '\u2C67': 'H',
	            '\u2C75': 'H',
	            '\uA78D': 'H',
	            '\u24BE': 'I',
	            '\uFF29': 'I',
	            '\u00CC': 'I',
	            '\u00CD': 'I',
	            '\u00CE': 'I',
	            '\u0128': 'I',
	            '\u012A': 'I',
	            '\u012C': 'I',
	            '\u0130': 'I',
	            '\u00CF': 'I',
	            '\u1E2E': 'I',
	            '\u1EC8': 'I',
	            '\u01CF': 'I',
	            '\u0208': 'I',
	            '\u020A': 'I',
	            '\u1ECA': 'I',
	            '\u012E': 'I',
	            '\u1E2C': 'I',
	            '\u0197': 'I',
	            '\u24BF': 'J',
	            '\uFF2A': 'J',
	            '\u0134': 'J',
	            '\u0248': 'J',
	            '\u24C0': 'K',
	            '\uFF2B': 'K',
	            '\u1E30': 'K',
	            '\u01E8': 'K',
	            '\u1E32': 'K',
	            '\u0136': 'K',
	            '\u1E34': 'K',
	            '\u0198': 'K',
	            '\u2C69': 'K',
	            '\uA740': 'K',
	            '\uA742': 'K',
	            '\uA744': 'K',
	            '\uA7A2': 'K',
	            '\u24C1': 'L',
	            '\uFF2C': 'L',
	            '\u013F': 'L',
	            '\u0139': 'L',
	            '\u013D': 'L',
	            '\u1E36': 'L',
	            '\u1E38': 'L',
	            '\u013B': 'L',
	            '\u1E3C': 'L',
	            '\u1E3A': 'L',
	            '\u0141': 'L',
	            '\u023D': 'L',
	            '\u2C62': 'L',
	            '\u2C60': 'L',
	            '\uA748': 'L',
	            '\uA746': 'L',
	            '\uA780': 'L',
	            '\u01C7': 'LJ',
	            '\u01C8': 'Lj',
	            '\u24C2': 'M',
	            '\uFF2D': 'M',
	            '\u1E3E': 'M',
	            '\u1E40': 'M',
	            '\u1E42': 'M',
	            '\u2C6E': 'M',
	            '\u019C': 'M',
	            '\u24C3': 'N',
	            '\uFF2E': 'N',
	            '\u01F8': 'N',
	            '\u0143': 'N',
	            '\u00D1': 'N',
	            '\u1E44': 'N',
	            '\u0147': 'N',
	            '\u1E46': 'N',
	            '\u0145': 'N',
	            '\u1E4A': 'N',
	            '\u1E48': 'N',
	            '\u0220': 'N',
	            '\u019D': 'N',
	            '\uA790': 'N',
	            '\uA7A4': 'N',
	            '\u01CA': 'NJ',
	            '\u01CB': 'Nj',
	            '\u24C4': 'O',
	            '\uFF2F': 'O',
	            '\u00D2': 'O',
	            '\u00D3': 'O',
	            '\u00D4': 'O',
	            '\u1ED2': 'O',
	            '\u1ED0': 'O',
	            '\u1ED6': 'O',
	            '\u1ED4': 'O',
	            '\u00D5': 'O',
	            '\u1E4C': 'O',
	            '\u022C': 'O',
	            '\u1E4E': 'O',
	            '\u014C': 'O',
	            '\u1E50': 'O',
	            '\u1E52': 'O',
	            '\u014E': 'O',
	            '\u022E': 'O',
	            '\u0230': 'O',
	            '\u00D6': 'O',
	            '\u022A': 'O',
	            '\u1ECE': 'O',
	            '\u0150': 'O',
	            '\u01D1': 'O',
	            '\u020C': 'O',
	            '\u020E': 'O',
	            '\u01A0': 'O',
	            '\u1EDC': 'O',
	            '\u1EDA': 'O',
	            '\u1EE0': 'O',
	            '\u1EDE': 'O',
	            '\u1EE2': 'O',
	            '\u1ECC': 'O',
	            '\u1ED8': 'O',
	            '\u01EA': 'O',
	            '\u01EC': 'O',
	            '\u00D8': 'O',
	            '\u01FE': 'O',
	            '\u0186': 'O',
	            '\u019F': 'O',
	            '\uA74A': 'O',
	            '\uA74C': 'O',
	            '\u01A2': 'OI',
	            '\uA74E': 'OO',
	            '\u0222': 'OU',
	            '\u24C5': 'P',
	            '\uFF30': 'P',
	            '\u1E54': 'P',
	            '\u1E56': 'P',
	            '\u01A4': 'P',
	            '\u2C63': 'P',
	            '\uA750': 'P',
	            '\uA752': 'P',
	            '\uA754': 'P',
	            '\u24C6': 'Q',
	            '\uFF31': 'Q',
	            '\uA756': 'Q',
	            '\uA758': 'Q',
	            '\u024A': 'Q',
	            '\u24C7': 'R',
	            '\uFF32': 'R',
	            '\u0154': 'R',
	            '\u1E58': 'R',
	            '\u0158': 'R',
	            '\u0210': 'R',
	            '\u0212': 'R',
	            '\u1E5A': 'R',
	            '\u1E5C': 'R',
	            '\u0156': 'R',
	            '\u1E5E': 'R',
	            '\u024C': 'R',
	            '\u2C64': 'R',
	            '\uA75A': 'R',
	            '\uA7A6': 'R',
	            '\uA782': 'R',
	            '\u24C8': 'S',
	            '\uFF33': 'S',
	            '\u1E9E': 'S',
	            '\u015A': 'S',
	            '\u1E64': 'S',
	            '\u015C': 'S',
	            '\u1E60': 'S',
	            '\u0160': 'S',
	            '\u1E66': 'S',
	            '\u1E62': 'S',
	            '\u1E68': 'S',
	            '\u0218': 'S',
	            '\u015E': 'S',
	            '\u2C7E': 'S',
	            '\uA7A8': 'S',
	            '\uA784': 'S',
	            '\u24C9': 'T',
	            '\uFF34': 'T',
	            '\u1E6A': 'T',
	            '\u0164': 'T',
	            '\u1E6C': 'T',
	            '\u021A': 'T',
	            '\u0162': 'T',
	            '\u1E70': 'T',
	            '\u1E6E': 'T',
	            '\u0166': 'T',
	            '\u01AC': 'T',
	            '\u01AE': 'T',
	            '\u023E': 'T',
	            '\uA786': 'T',
	            '\uA728': 'TZ',
	            '\u24CA': 'U',
	            '\uFF35': 'U',
	            '\u00D9': 'U',
	            '\u00DA': 'U',
	            '\u00DB': 'U',
	            '\u0168': 'U',
	            '\u1E78': 'U',
	            '\u016A': 'U',
	            '\u1E7A': 'U',
	            '\u016C': 'U',
	            '\u00DC': 'U',
	            '\u01DB': 'U',
	            '\u01D7': 'U',
	            '\u01D5': 'U',
	            '\u01D9': 'U',
	            '\u1EE6': 'U',
	            '\u016E': 'U',
	            '\u0170': 'U',
	            '\u01D3': 'U',
	            '\u0214': 'U',
	            '\u0216': 'U',
	            '\u01AF': 'U',
	            '\u1EEA': 'U',
	            '\u1EE8': 'U',
	            '\u1EEE': 'U',
	            '\u1EEC': 'U',
	            '\u1EF0': 'U',
	            '\u1EE4': 'U',
	            '\u1E72': 'U',
	            '\u0172': 'U',
	            '\u1E76': 'U',
	            '\u1E74': 'U',
	            '\u0244': 'U',
	            '\u24CB': 'V',
	            '\uFF36': 'V',
	            '\u1E7C': 'V',
	            '\u1E7E': 'V',
	            '\u01B2': 'V',
	            '\uA75E': 'V',
	            '\u0245': 'V',
	            '\uA760': 'VY',
	            '\u24CC': 'W',
	            '\uFF37': 'W',
	            '\u1E80': 'W',
	            '\u1E82': 'W',
	            '\u0174': 'W',
	            '\u1E86': 'W',
	            '\u1E84': 'W',
	            '\u1E88': 'W',
	            '\u2C72': 'W',
	            '\u24CD': 'X',
	            '\uFF38': 'X',
	            '\u1E8A': 'X',
	            '\u1E8C': 'X',
	            '\u24CE': 'Y',
	            '\uFF39': 'Y',
	            '\u1EF2': 'Y',
	            '\u00DD': 'Y',
	            '\u0176': 'Y',
	            '\u1EF8': 'Y',
	            '\u0232': 'Y',
	            '\u1E8E': 'Y',
	            '\u0178': 'Y',
	            '\u1EF6': 'Y',
	            '\u1EF4': 'Y',
	            '\u01B3': 'Y',
	            '\u024E': 'Y',
	            '\u1EFE': 'Y',
	            '\u24CF': 'Z',
	            '\uFF3A': 'Z',
	            '\u0179': 'Z',
	            '\u1E90': 'Z',
	            '\u017B': 'Z',
	            '\u017D': 'Z',
	            '\u1E92': 'Z',
	            '\u1E94': 'Z',
	            '\u01B5': 'Z',
	            '\u0224': 'Z',
	            '\u2C7F': 'Z',
	            '\u2C6B': 'Z',
	            '\uA762': 'Z',
	            '\u24D0': 'a',
	            '\uFF41': 'a',
	            '\u1E9A': 'a',
	            '\u00E0': 'a',
	            '\u00E1': 'a',
	            '\u00E2': 'a',
	            '\u1EA7': 'a',
	            '\u1EA5': 'a',
	            '\u1EAB': 'a',
	            '\u1EA9': 'a',
	            '\u00E3': 'a',
	            '\u0101': 'a',
	            '\u0103': 'a',
	            '\u1EB1': 'a',
	            '\u1EAF': 'a',
	            '\u1EB5': 'a',
	            '\u1EB3': 'a',
	            '\u0227': 'a',
	            '\u01E1': 'a',
	            '\u00E4': 'a',
	            '\u01DF': 'a',
	            '\u1EA3': 'a',
	            '\u00E5': 'a',
	            '\u01FB': 'a',
	            '\u01CE': 'a',
	            '\u0201': 'a',
	            '\u0203': 'a',
	            '\u1EA1': 'a',
	            '\u1EAD': 'a',
	            '\u1EB7': 'a',
	            '\u1E01': 'a',
	            '\u0105': 'a',
	            '\u2C65': 'a',
	            '\u0250': 'a',
	            '\uA733': 'aa',
	            '\u00E6': 'ae',
	            '\u01FD': 'ae',
	            '\u01E3': 'ae',
	            '\uA735': 'ao',
	            '\uA737': 'au',
	            '\uA739': 'av',
	            '\uA73B': 'av',
	            '\uA73D': 'ay',
	            '\u24D1': 'b',
	            '\uFF42': 'b',
	            '\u1E03': 'b',
	            '\u1E05': 'b',
	            '\u1E07': 'b',
	            '\u0180': 'b',
	            '\u0183': 'b',
	            '\u0253': 'b',
	            '\u24D2': 'c',
	            '\uFF43': 'c',
	            '\u0107': 'c',
	            '\u0109': 'c',
	            '\u010B': 'c',
	            '\u010D': 'c',
	            '\u00E7': 'c',
	            '\u1E09': 'c',
	            '\u0188': 'c',
	            '\u023C': 'c',
	            '\uA73F': 'c',
	            '\u2184': 'c',
	            '\u24D3': 'd',
	            '\uFF44': 'd',
	            '\u1E0B': 'd',
	            '\u010F': 'd',
	            '\u1E0D': 'd',
	            '\u1E11': 'd',
	            '\u1E13': 'd',
	            '\u1E0F': 'd',
	            '\u0111': 'd',
	            '\u018C': 'd',
	            '\u0256': 'd',
	            '\u0257': 'd',
	            '\uA77A': 'd',
	            '\u01F3': 'dz',
	            '\u01C6': 'dz',
	            '\u24D4': 'e',
	            '\uFF45': 'e',
	            '\u00E8': 'e',
	            '\u00E9': 'e',
	            '\u00EA': 'e',
	            '\u1EC1': 'e',
	            '\u1EBF': 'e',
	            '\u1EC5': 'e',
	            '\u1EC3': 'e',
	            '\u1EBD': 'e',
	            '\u0113': 'e',
	            '\u1E15': 'e',
	            '\u1E17': 'e',
	            '\u0115': 'e',
	            '\u0117': 'e',
	            '\u00EB': 'e',
	            '\u1EBB': 'e',
	            '\u011B': 'e',
	            '\u0205': 'e',
	            '\u0207': 'e',
	            '\u1EB9': 'e',
	            '\u1EC7': 'e',
	            '\u0229': 'e',
	            '\u1E1D': 'e',
	            '\u0119': 'e',
	            '\u1E19': 'e',
	            '\u1E1B': 'e',
	            '\u0247': 'e',
	            '\u025B': 'e',
	            '\u01DD': 'e',
	            '\u24D5': 'f',
	            '\uFF46': 'f',
	            '\u1E1F': 'f',
	            '\u0192': 'f',
	            '\uA77C': 'f',
	            '\u24D6': 'g',
	            '\uFF47': 'g',
	            '\u01F5': 'g',
	            '\u011D': 'g',
	            '\u1E21': 'g',
	            '\u011F': 'g',
	            '\u0121': 'g',
	            '\u01E7': 'g',
	            '\u0123': 'g',
	            '\u01E5': 'g',
	            '\u0260': 'g',
	            '\uA7A1': 'g',
	            '\u1D79': 'g',
	            '\uA77F': 'g',
	            '\u24D7': 'h',
	            '\uFF48': 'h',
	            '\u0125': 'h',
	            '\u1E23': 'h',
	            '\u1E27': 'h',
	            '\u021F': 'h',
	            '\u1E25': 'h',
	            '\u1E29': 'h',
	            '\u1E2B': 'h',
	            '\u1E96': 'h',
	            '\u0127': 'h',
	            '\u2C68': 'h',
	            '\u2C76': 'h',
	            '\u0265': 'h',
	            '\u0195': 'hv',
	            '\u24D8': 'i',
	            '\uFF49': 'i',
	            '\u00EC': 'i',
	            '\u00ED': 'i',
	            '\u00EE': 'i',
	            '\u0129': 'i',
	            '\u012B': 'i',
	            '\u012D': 'i',
	            '\u00EF': 'i',
	            '\u1E2F': 'i',
	            '\u1EC9': 'i',
	            '\u01D0': 'i',
	            '\u0209': 'i',
	            '\u020B': 'i',
	            '\u1ECB': 'i',
	            '\u012F': 'i',
	            '\u1E2D': 'i',
	            '\u0268': 'i',
	            '\u0131': 'i',
	            '\u24D9': 'j',
	            '\uFF4A': 'j',
	            '\u0135': 'j',
	            '\u01F0': 'j',
	            '\u0249': 'j',
	            '\u24DA': 'k',
	            '\uFF4B': 'k',
	            '\u1E31': 'k',
	            '\u01E9': 'k',
	            '\u1E33': 'k',
	            '\u0137': 'k',
	            '\u1E35': 'k',
	            '\u0199': 'k',
	            '\u2C6A': 'k',
	            '\uA741': 'k',
	            '\uA743': 'k',
	            '\uA745': 'k',
	            '\uA7A3': 'k',
	            '\u24DB': 'l',
	            '\uFF4C': 'l',
	            '\u0140': 'l',
	            '\u013A': 'l',
	            '\u013E': 'l',
	            '\u1E37': 'l',
	            '\u1E39': 'l',
	            '\u013C': 'l',
	            '\u1E3D': 'l',
	            '\u1E3B': 'l',
	            '\u017F': 'l',
	            '\u0142': 'l',
	            '\u019A': 'l',
	            '\u026B': 'l',
	            '\u2C61': 'l',
	            '\uA749': 'l',
	            '\uA781': 'l',
	            '\uA747': 'l',
	            '\u01C9': 'lj',
	            '\u24DC': 'm',
	            '\uFF4D': 'm',
	            '\u1E3F': 'm',
	            '\u1E41': 'm',
	            '\u1E43': 'm',
	            '\u0271': 'm',
	            '\u026F': 'm',
	            '\u24DD': 'n',
	            '\uFF4E': 'n',
	            '\u01F9': 'n',
	            '\u0144': 'n',
	            '\u00F1': 'n',
	            '\u1E45': 'n',
	            '\u0148': 'n',
	            '\u1E47': 'n',
	            '\u0146': 'n',
	            '\u1E4B': 'n',
	            '\u1E49': 'n',
	            '\u019E': 'n',
	            '\u0272': 'n',
	            '\u0149': 'n',
	            '\uA791': 'n',
	            '\uA7A5': 'n',
	            '\u01CC': 'nj',
	            '\u24DE': 'o',
	            '\uFF4F': 'o',
	            '\u00F2': 'o',
	            '\u00F3': 'o',
	            '\u00F4': 'o',
	            '\u1ED3': 'o',
	            '\u1ED1': 'o',
	            '\u1ED7': 'o',
	            '\u1ED5': 'o',
	            '\u00F5': 'o',
	            '\u1E4D': 'o',
	            '\u022D': 'o',
	            '\u1E4F': 'o',
	            '\u014D': 'o',
	            '\u1E51': 'o',
	            '\u1E53': 'o',
	            '\u014F': 'o',
	            '\u022F': 'o',
	            '\u0231': 'o',
	            '\u00F6': 'o',
	            '\u022B': 'o',
	            '\u1ECF': 'o',
	            '\u0151': 'o',
	            '\u01D2': 'o',
	            '\u020D': 'o',
	            '\u020F': 'o',
	            '\u01A1': 'o',
	            '\u1EDD': 'o',
	            '\u1EDB': 'o',
	            '\u1EE1': 'o',
	            '\u1EDF': 'o',
	            '\u1EE3': 'o',
	            '\u1ECD': 'o',
	            '\u1ED9': 'o',
	            '\u01EB': 'o',
	            '\u01ED': 'o',
	            '\u00F8': 'o',
	            '\u01FF': 'o',
	            '\u0254': 'o',
	            '\uA74B': 'o',
	            '\uA74D': 'o',
	            '\u0275': 'o',
	            '\u01A3': 'oi',
	            '\u0223': 'ou',
	            '\uA74F': 'oo',
	            '\u24DF': 'p',
	            '\uFF50': 'p',
	            '\u1E55': 'p',
	            '\u1E57': 'p',
	            '\u01A5': 'p',
	            '\u1D7D': 'p',
	            '\uA751': 'p',
	            '\uA753': 'p',
	            '\uA755': 'p',
	            '\u24E0': 'q',
	            '\uFF51': 'q',
	            '\u024B': 'q',
	            '\uA757': 'q',
	            '\uA759': 'q',
	            '\u24E1': 'r',
	            '\uFF52': 'r',
	            '\u0155': 'r',
	            '\u1E59': 'r',
	            '\u0159': 'r',
	            '\u0211': 'r',
	            '\u0213': 'r',
	            '\u1E5B': 'r',
	            '\u1E5D': 'r',
	            '\u0157': 'r',
	            '\u1E5F': 'r',
	            '\u024D': 'r',
	            '\u027D': 'r',
	            '\uA75B': 'r',
	            '\uA7A7': 'r',
	            '\uA783': 'r',
	            '\u24E2': 's',
	            '\uFF53': 's',
	            '\u00DF': 's',
	            '\u015B': 's',
	            '\u1E65': 's',
	            '\u015D': 's',
	            '\u1E61': 's',
	            '\u0161': 's',
	            '\u1E67': 's',
	            '\u1E63': 's',
	            '\u1E69': 's',
	            '\u0219': 's',
	            '\u015F': 's',
	            '\u023F': 's',
	            '\uA7A9': 's',
	            '\uA785': 's',
	            '\u1E9B': 's',
	            '\u24E3': 't',
	            '\uFF54': 't',
	            '\u1E6B': 't',
	            '\u1E97': 't',
	            '\u0165': 't',
	            '\u1E6D': 't',
	            '\u021B': 't',
	            '\u0163': 't',
	            '\u1E71': 't',
	            '\u1E6F': 't',
	            '\u0167': 't',
	            '\u01AD': 't',
	            '\u0288': 't',
	            '\u2C66': 't',
	            '\uA787': 't',
	            '\uA729': 'tz',
	            '\u24E4': 'u',
	            '\uFF55': 'u',
	            '\u00F9': 'u',
	            '\u00FA': 'u',
	            '\u00FB': 'u',
	            '\u0169': 'u',
	            '\u1E79': 'u',
	            '\u016B': 'u',
	            '\u1E7B': 'u',
	            '\u016D': 'u',
	            '\u00FC': 'u',
	            '\u01DC': 'u',
	            '\u01D8': 'u',
	            '\u01D6': 'u',
	            '\u01DA': 'u',
	            '\u1EE7': 'u',
	            '\u016F': 'u',
	            '\u0171': 'u',
	            '\u01D4': 'u',
	            '\u0215': 'u',
	            '\u0217': 'u',
	            '\u01B0': 'u',
	            '\u1EEB': 'u',
	            '\u1EE9': 'u',
	            '\u1EEF': 'u',
	            '\u1EED': 'u',
	            '\u1EF1': 'u',
	            '\u1EE5': 'u',
	            '\u1E73': 'u',
	            '\u0173': 'u',
	            '\u1E77': 'u',
	            '\u1E75': 'u',
	            '\u0289': 'u',
	            '\u24E5': 'v',
	            '\uFF56': 'v',
	            '\u1E7D': 'v',
	            '\u1E7F': 'v',
	            '\u028B': 'v',
	            '\uA75F': 'v',
	            '\u028C': 'v',
	            '\uA761': 'vy',
	            '\u24E6': 'w',
	            '\uFF57': 'w',
	            '\u1E81': 'w',
	            '\u1E83': 'w',
	            '\u0175': 'w',
	            '\u1E87': 'w',
	            '\u1E85': 'w',
	            '\u1E98': 'w',
	            '\u1E89': 'w',
	            '\u2C73': 'w',
	            '\u24E7': 'x',
	            '\uFF58': 'x',
	            '\u1E8B': 'x',
	            '\u1E8D': 'x',
	            '\u24E8': 'y',
	            '\uFF59': 'y',
	            '\u1EF3': 'y',
	            '\u00FD': 'y',
	            '\u0177': 'y',
	            '\u1EF9': 'y',
	            '\u0233': 'y',
	            '\u1E8F': 'y',
	            '\u00FF': 'y',
	            '\u1EF7': 'y',
	            '\u1E99': 'y',
	            '\u1EF5': 'y',
	            '\u01B4': 'y',
	            '\u024F': 'y',
	            '\u1EFF': 'y',
	            '\u24E9': 'z',
	            '\uFF5A': 'z',
	            '\u017A': 'z',
	            '\u1E91': 'z',
	            '\u017C': 'z',
	            '\u017E': 'z',
	            '\u1E93': 'z',
	            '\u1E95': 'z',
	            '\u01B6': 'z',
	            '\u0225': 'z',
	            '\u0240': 'z',
	            '\u2C6C': 'z',
	            '\uA763': 'z',
	            '\u0386': '\u0391',
	            '\u0388': '\u0395',
	            '\u0389': '\u0397',
	            '\u038A': '\u0399',
	            '\u03AA': '\u0399',
	            '\u038C': '\u039F',
	            '\u038E': '\u03A5',
	            '\u03AB': '\u03A5',
	            '\u038F': '\u03A9',
	            '\u03AC': '\u03B1',
	            '\u03AD': '\u03B5',
	            '\u03AE': '\u03B7',
	            '\u03AF': '\u03B9',
	            '\u03CA': '\u03B9',
	            '\u0390': '\u03B9',
	            '\u03CC': '\u03BF',
	            '\u03CD': '\u03C5',
	            '\u03CB': '\u03C5',
	            '\u03B0': '\u03C5',
	            '\u03C9': '\u03C9',
	            '\u03C2': '\u03C3'
	        };
	        return Diacritics;
	    }());
	
	    /**
	     * @fileoverview added by tsickle
	     * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
	     */
	    var OptionList = /** @class */ (function () {
	        function OptionList(options) {
	            /* Consider using these for performance improvement. */
	            // private _selection: Array<Option>;
	            // private _filtered: Array<Option>;
	            // private _value: Array<string>;
	            this._highlightedOption = null;
	            if (typeof options === 'undefined' || options === null) {
	                options = [];
	            }
	            this._options = options.map((/**
	             * @param {?} option
	             * @return {?}
	             */
	            function (option) {
	                /** @type {?} */
	                var o = new Option(option);
	                if (option.disabled) {
	                    o.disabled = true;
	                }
	                return o;
	            }));
	            this._hasShown = this._options.length > 0;
	            this.highlight();
	        }
	        Object.defineProperty(OptionList.prototype, "hasShown", {
	            get: /**
	             * @return {?}
	             */
	            function () {
	                return this._hasShown;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(OptionList.prototype, "hasSelected", {
	            get: /**
	             * @return {?}
	             */
	            function () {
	                return this._hasSelected;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(OptionList.prototype, "options", {
	            /** Options. **/
	            get: /**
	             * Options. *
	             * @return {?}
	             */
	            function () {
	                return this._options;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * @param {?} value
	         * @return {?}
	         */
	        OptionList.prototype.getOptionsByValue = /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            return this.options.filter((/**
	             * @param {?} option
	             * @return {?}
	             */
	            function (option) {
	                return option.value === value;
	            }));
	        };
	        Object.defineProperty(OptionList.prototype, "value", {
	            /** Value. **/
	            get: /**
	             * Value. *
	             * @return {?}
	             */
	            function () {
	                return this.selection.map((/**
	                 * @param {?} option
	                 * @return {?}
	                 */
	                function (option) { return option.value; }));
	            },
	            set: /**
	             * @param {?} v
	             * @return {?}
	             */
	            function (v) {
	                v = typeof v === 'undefined' || v === null ? [] : v;
	                this.options.forEach((/**
	                 * @param {?} option
	                 * @return {?}
	                 */
	                function (option) {
	                    option.selected = v.indexOf(option.value) > -1;
	                }));
	                this.updateHasSelected();
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(OptionList.prototype, "selection", {
	            /** Selection. **/
	            get: /**
	             * Selection. *
	             * @return {?}
	             */
	            function () {
	                return this.options.filter((/**
	                 * @param {?} option
	                 * @return {?}
	                 */
	                function (option) { return option.selected; }));
	            },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * @param {?} option
	         * @param {?} multiple
	         * @return {?}
	         */
	        OptionList.prototype.select = /**
	         * @param {?} option
	         * @param {?} multiple
	         * @return {?}
	         */
	        function (option, multiple) {
	            if (!multiple) {
	                this.clearSelection();
	            }
	            option.selected = true;
	            this.updateHasSelected();
	        };
	        /**
	         * @param {?} option
	         * @return {?}
	         */
	        OptionList.prototype.deselect = /**
	         * @param {?} option
	         * @return {?}
	         */
	        function (option) {
	            option.selected = false;
	            this.updateHasSelected();
	        };
	        /**
	         * @return {?}
	         */
	        OptionList.prototype.clearSelection = /**
	         * @return {?}
	         */
	        function () {
	            this.options.forEach((/**
	             * @param {?} option
	             * @return {?}
	             */
	            function (option) {
	                option.selected = false;
	            }));
	            this._hasSelected = false;
	        };
	        /**
	         * @private
	         * @return {?}
	         */
	        OptionList.prototype.updateHasSelected = /**
	         * @private
	         * @return {?}
	         */
	        function () {
	            this._hasSelected = this.options.some((/**
	             * @param {?} option
	             * @return {?}
	             */
	            function (option) { return option.selected; }));
	        };
	        Object.defineProperty(OptionList.prototype, "filtered", {
	            /** Filter. **/
	            get: /**
	             * Filter. *
	             * @return {?}
	             */
	            function () {
	                return this.options.filter((/**
	                 * @param {?} option
	                 * @return {?}
	                 */
	                function (option) { return option.shown; }));
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(OptionList.prototype, "filteredEnabled", {
	            get: /**
	             * @return {?}
	             */
	            function () {
	                return this.options.filter((/**
	                 * @param {?} option
	                 * @return {?}
	                 */
	                function (option) { return option.shown && !option.disabled; }));
	            },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * @param {?} term
	         * @return {?}
	         */
	        OptionList.prototype.filter = /**
	         * @param {?} term
	         * @return {?}
	         */
	        function (term) {
	            /** @type {?} */
	            var anyShown = false;
	            if (term.trim() === '') {
	                this.resetFilter();
	                anyShown = this.options.length > 0;
	            }
	            else {
	                this.options.forEach((/**
	                 * @param {?} option
	                 * @return {?}
	                 */
	                function (option) {
	                    /** @type {?} */
	                    var l = Diacritics.strip(option.label).toUpperCase();
	                    /** @type {?} */
	                    var t = Diacritics.strip(term).toUpperCase();
	                    option.shown = l.indexOf(t) > -1;
	                    if (option.shown) {
	                        anyShown = true;
	                    }
	                }));
	            }
	            this.highlight();
	            this._hasShown = anyShown;
	            return anyShown;
	        };
	        /**
	         * @private
	         * @return {?}
	         */
	        OptionList.prototype.resetFilter = /**
	         * @private
	         * @return {?}
	         */
	        function () {
	            this.options.forEach((/**
	             * @param {?} option
	             * @return {?}
	             */
	            function (option) {
	                option.shown = true;
	            }));
	        };
	        Object.defineProperty(OptionList.prototype, "highlightedOption", {
	            /** Highlight. **/
	            get: /**
	             * Highlight. *
	             * @return {?}
	             */
	            function () {
	                return this._highlightedOption;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * @return {?}
	         */
	        OptionList.prototype.highlight = /**
	         * @return {?}
	         */
	        function () {
	            /** @type {?} */
	            var option = this.hasShownSelected() ?
	                this.getFirstShownSelected() : this.getFirstShown();
	            this.highlightOption(option);
	        };
	        /**
	         * @param {?} option
	         * @return {?}
	         */
	        OptionList.prototype.highlightOption = /**
	         * @param {?} option
	         * @return {?}
	         */
	        function (option) {
	            this.clearHighlightedOption();
	            if (option !== null) {
	                option.highlighted = true;
	                this._highlightedOption = option;
	            }
	        };
	        /**
	         * @return {?}
	         */
	        OptionList.prototype.highlightNextOption = /**
	         * @return {?}
	         */
	        function () {
	            /** @type {?} */
	            var shownEnabledOptions = this.filteredEnabled;
	            /** @type {?} */
	            var index = this.getHighlightedIndexFromList(shownEnabledOptions);
	            if (index > -1 && index < shownEnabledOptions.length - 1) {
	                this.highlightOption(shownEnabledOptions[index + 1]);
	            }
	        };
	        /**
	         * @return {?}
	         */
	        OptionList.prototype.highlightPreviousOption = /**
	         * @return {?}
	         */
	        function () {
	            /** @type {?} */
	            var shownEnabledOptions = this.filteredEnabled;
	            /** @type {?} */
	            var index = this.getHighlightedIndexFromList(shownEnabledOptions);
	            if (index > 0) {
	                this.highlightOption(shownEnabledOptions[index - 1]);
	            }
	        };
	        /**
	         * @private
	         * @return {?}
	         */
	        OptionList.prototype.clearHighlightedOption = /**
	         * @private
	         * @return {?}
	         */
	        function () {
	            if (this.highlightedOption !== null) {
	                this.highlightedOption.highlighted = false;
	                this._highlightedOption = null;
	            }
	        };
	        /**
	         * @private
	         * @param {?} options
	         * @return {?}
	         */
	        OptionList.prototype.getHighlightedIndexFromList = /**
	         * @private
	         * @param {?} options
	         * @return {?}
	         */
	        function (options) {
	            for (var i = 0; i < options.length; i++) {
	                if (options[i].highlighted) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	        /**
	         * @return {?}
	         */
	        OptionList.prototype.getHighlightedIndex = /**
	         * @return {?}
	         */
	        function () {
	            return this.getHighlightedIndexFromList(this.filtered);
	        };
	        /** Util. **/
	        /**
	         * Util. *
	         * @return {?}
	         */
	        OptionList.prototype.hasShownSelected = /**
	         * Util. *
	         * @return {?}
	         */
	        function () {
	            return this.options.some((/**
	             * @param {?} option
	             * @return {?}
	             */
	            function (option) {
	                return option.shown && option.selected;
	            }));
	        };
	        /**
	         * @private
	         * @return {?}
	         */
	        OptionList.prototype.getFirstShown = /**
	         * @private
	         * @return {?}
	         */
	        function () {
	            var e_1, _a;
	            try {
	                for (var _b = __values(this.options), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var option = _c.value;
	                    if (option.shown) {
	                        return option;
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            return null;
	        };
	        /**
	         * @private
	         * @return {?}
	         */
	        OptionList.prototype.getFirstShownSelected = /**
	         * @private
	         * @return {?}
	         */
	        function () {
	            var e_2, _a;
	            try {
	                for (var _b = __values(this.options), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var option = _c.value;
	                    if (option.shown && option.selected) {
	                        return option;
	                    }
	                }
	            }
	            catch (e_2_1) { e_2 = { error: e_2_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                }
	                finally { if (e_2) throw e_2.error; }
	            }
	            return null;
	        };
	        // v0 and v1 are assumed not to be undefined or null.
	        // v0 and v1 are assumed not to be undefined or null.
	        /**
	         * @param {?} v0
	         * @param {?} v1
	         * @return {?}
	         */
	        OptionList.equalValues = 
	        // v0 and v1 are assumed not to be undefined or null.
	        /**
	         * @param {?} v0
	         * @param {?} v1
	         * @return {?}
	         */
	        function (v0, v1) {
	            if (v0.length !== v1.length) {
	                return false;
	            }
	            /** @type {?} */
	            var a = v0.slice().sort();
	            /** @type {?} */
	            var b = v1.slice().sort();
	            return a.every((/**
	             * @param {?} v
	             * @param {?} i
	             * @return {?}
	             */
	            function (v, i) {
	                return v === b[i];
	            }));
	        };
	        return OptionList;
	    }());
	
	    /**
	     * @fileoverview added by tsickle
	     * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
	     */
	    var SelectDropdownComponent = /** @class */ (function () {
	        function SelectDropdownComponent(hostElement) {
	            this.hostElement = hostElement;
	            this.optionClicked = new core.EventEmitter();
	            this.optionsListClick = new core.EventEmitter();
	            this.singleFilterClick = new core.EventEmitter();
	            this.singleFilterFocus = new core.EventEmitter();
	            this.singleFilterInput = new core.EventEmitter();
	            this.singleFilterKeydown = new core.EventEmitter();
	            this.disabledColor = '#fff';
	            this.disabledTextColor = '9e9e9e';
	        }
	        /** Event handlers. **/
	        /**
	         * Event handlers. *
	         * @return {?}
	         */
	        SelectDropdownComponent.prototype.ngOnInit = /**
	         * Event handlers. *
	         * @return {?}
	         */
	        function () {
	            this.optionsReset();
	        };
	        /**
	         * @param {?} changes
	         * @return {?}
	         */
	        SelectDropdownComponent.prototype.ngOnChanges = /**
	         * @param {?} changes
	         * @return {?}
	         */
	        function (changes) {
	            if (changes.hasOwnProperty('optionList')) {
	                this.optionsReset();
	            }
	        };
	        /**
	         * @return {?}
	         */
	        SelectDropdownComponent.prototype.ngAfterViewInit = /**
	         * @return {?}
	         */
	        function () {
	            this.moveHighlightedIntoView();
	            if (!this.multiple && this.filterEnabled) {
	                this.filterInput.nativeElement.focus();
	            }
	        };
	        /**
	         * @return {?}
	         */
	        SelectDropdownComponent.prototype.onOptionsListClick = /**
	         * @return {?}
	         */
	        function () {
	            this.optionsListClick.emit(null);
	        };
	        /**
	         * @return {?}
	         */
	        SelectDropdownComponent.prototype.onSingleFilterClick = /**
	         * @return {?}
	         */
	        function () {
	            this.singleFilterClick.emit(null);
	        };
	        /**
	         * @param {?} event
	         * @return {?}
	         */
	        SelectDropdownComponent.prototype.onSingleFilterInput = /**
	         * @param {?} event
	         * @return {?}
	         */
	        function (event) {
	            this.singleFilterInput.emit(event.target.value);
	        };
	        /**
	         * @param {?} event
	         * @return {?}
	         */
	        SelectDropdownComponent.prototype.onSingleFilterKeydown = /**
	         * @param {?} event
	         * @return {?}
	         */
	        function (event) {
	            this.singleFilterKeydown.emit(event);
	        };
	        /**
	         * @return {?}
	         */
	        SelectDropdownComponent.prototype.onSingleFilterFocus = /**
	         * @return {?}
	         */
	        function () {
	            this.singleFilterFocus.emit(null);
	        };
	        /**
	         * @param {?} event
	         * @return {?}
	         */
	        SelectDropdownComponent.prototype.onOptionsWheel = /**
	         * @param {?} event
	         * @return {?}
	         */
	        function (event) {
	            this.handleOptionsWheel(event);
	        };
	        /**
	         * @param {?} option
	         * @return {?}
	         */
	        SelectDropdownComponent.prototype.onOptionMouseover = /**
	         * @param {?} option
	         * @return {?}
	         */
	        function (option) {
	            this.optionList.highlightOption(option);
	        };
	        /**
	         * @param {?} option
	         * @return {?}
	         */
	        SelectDropdownComponent.prototype.onOptionClick = /**
	         * @param {?} option
	         * @return {?}
	         */
	        function (option) {
	            this.optionClicked.emit(option);
	        };
	        /** Initialization. **/
	        /**
	         * Initialization. *
	         * @private
	         * @return {?}
	         */
	        SelectDropdownComponent.prototype.optionsReset = /**
	         * Initialization. *
	         * @private
	         * @return {?}
	         */
	        function () {
	            this.optionList.filter('');
	            this.optionList.highlight();
	        };
	        /** View. **/
	        /**
	         * View. *
	         * @param {?} option
	         * @return {?}
	         */
	        SelectDropdownComponent.prototype.getOptionStyle = /**
	         * View. *
	         * @param {?} option
	         * @return {?}
	         */
	        function (option) {
	            if (option.highlighted) {
	                /** @type {?} */
	                var style = {};
	                if (typeof this.highlightColor !== 'undefined') {
	                    style['background-color'] = this.highlightColor;
	                }
	                if (typeof this.highlightTextColor !== 'undefined') {
	                    style['color'] = this.highlightTextColor;
	                }
	                return style;
	            }
	            else {
	                return {};
	            }
	        };
	        /**
	         * @return {?}
	         */
	        SelectDropdownComponent.prototype.moveHighlightedIntoView = /**
	         * @return {?}
	         */
	        function () {
	            /** @type {?} */
	            var list = this.optionsList.nativeElement;
	            /** @type {?} */
	            var listHeight = list.offsetHeight;
	            /** @type {?} */
	            var itemIndex = this.optionList.getHighlightedIndex();
	            if (itemIndex > -1) {
	                /** @type {?} */
	                var item = list.children[0].children[itemIndex];
	                /** @type {?} */
	                var itemHeight = item.offsetHeight;
	                /** @type {?} */
	                var itemTop = itemIndex * itemHeight;
	                /** @type {?} */
	                var itemBottom = itemTop + itemHeight;
	                /** @type {?} */
	                var viewTop = list.scrollTop;
	                /** @type {?} */
	                var viewBottom = viewTop + listHeight;
	                if (itemBottom > viewBottom) {
	                    list.scrollTop = itemBottom - listHeight;
	                }
	                else if (itemTop < viewTop) {
	                    list.scrollTop = itemTop;
	                }
	            }
	        };
	        /**
	         * @private
	         * @param {?} e
	         * @return {?}
	         */
	        SelectDropdownComponent.prototype.handleOptionsWheel = /**
	         * @private
	         * @param {?} e
	         * @return {?}
	         */
	        function (e) {
	            /** @type {?} */
	            var div = this.optionsList.nativeElement;
	            /** @type {?} */
	            var atTop = div.scrollTop === 0;
	            /** @type {?} */
	            var atBottom = div.offsetHeight + div.scrollTop === div.scrollHeight;
	            if (atTop && e.deltaY < 0) {
	                e.preventDefault();
	            }
	            else if (atBottom && e.deltaY > 0) {
	                e.preventDefault();
	            }
	        };
	        SelectDropdownComponent.decorators = [
	            { type: core.Component, args: [{
	                        selector: 'select-dropdown',
	                        template: "<div\n    [ngClass]=\"{'below': isBelow, 'above': !isBelow}\"\n    [ngStyle]=\"{'top.px': top, 'left.px': left, 'width.px': width}\">\n\n    <div class=\"filter\"\n        *ngIf=\"!multiple && filterEnabled\">\n        <input\n            #filterInput\n            autocomplete=\"off\"\n            [placeholder]=\"placeholder\"\n            (click)=\"onSingleFilterClick()\"\n            (input)=\"onSingleFilterInput($event)\"\n            (keydown)=\"onSingleFilterKeydown($event)\"\n            (focus)=\"onSingleFilterFocus()\">\n    </div>\n\n    <div class=\"options\"\n        (click)=\"onOptionsListClick()\"\n        #optionsList>\n        <ul\n            (wheel)=\"onOptionsWheel($event)\">\n            <li *ngFor=\"let option of optionList.filtered\"\n                [ngClass]=\"{'highlighted': option.highlighted, 'selected': option.selected, 'disabled': option.disabled}\"\n                [ngStyle]=\"getOptionStyle(option)\"\n                (click)=\"onOptionClick(option)\"\n                (mouseover)=\"onOptionMouseover(option)\">\n                <ng-container *ngTemplateOutlet=\"optionTemplate; context:{option: option.wrappedOption}\"></ng-container>\n                <span *ngIf=\"!optionTemplate\">{{option.label}}</span>\n            </li>\n            <li\n                *ngIf=\"!optionList.hasShown\"\n                class=\"message\">\n                {{notFoundMsg}}\n            </li>\n        </ul>\n    </div>\n</div>\n",
	                        encapsulation: core.ViewEncapsulation.None,
	                        styles: ["select-dropdown,select-dropdown *{box-sizing:border-box}select-dropdown>div{background-color:#fff;border:1px solid #ccc;box-sizing:border-box;position:absolute;z-index:1}select-dropdown>div.above{border-bottom:none}select-dropdown>div.below{border-top:none}select-dropdown>div .filter{padding:3px;width:100%}select-dropdown>div .filter input{border:1px solid #eee;box-sizing:border-box;padding:4px;width:100%}select-dropdown>div .options{max-height:200px;overflow-y:auto}select-dropdown>div .options ul{list-style:none;margin:0;padding:0}select-dropdown>div .options ul li{padding:4px 8px;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}select-dropdown .selected{background-color:#e0e0e0}select-dropdown .highlighted,select-dropdown .selected.highlighted{background-color:#2196f3;color:#fff}select-dropdown .disabled{background-color:#fff;color:#9e9e9e;cursor:default;pointer-events:none}"]
	                    }] }
	        ];
	        /** @nocollapse */
	        SelectDropdownComponent.ctorParameters = function () { return [
	            { type: core.ElementRef }
	        ]; };
	        SelectDropdownComponent.propDecorators = {
	            filterEnabled: [{ type: core.Input }],
	            highlightColor: [{ type: core.Input }],
	            highlightTextColor: [{ type: core.Input }],
	            left: [{ type: core.Input }],
	            multiple: [{ type: core.Input }],
	            notFoundMsg: [{ type: core.Input }],
	            optionList: [{ type: core.Input }],
	            isBelow: [{ type: core.Input }],
	            top: [{ type: core.Input }],
	            width: [{ type: core.Input }],
	            placeholder: [{ type: core.Input }],
	            optionTemplate: [{ type: core.Input }],
	            optionClicked: [{ type: core.Output }],
	            optionsListClick: [{ type: core.Output }],
	            singleFilterClick: [{ type: core.Output }],
	            singleFilterFocus: [{ type: core.Output }],
	            singleFilterInput: [{ type: core.Output }],
	            singleFilterKeydown: [{ type: core.Output }],
	            filterInput: [{ type: core.ViewChild, args: ['filterInput', { static: false },] }],
	            optionsList: [{ type: core.ViewChild, args: ['optionsList', { static: true },] }]
	        };
	        return SelectDropdownComponent;
	    }());
	
	    /**
	     * @fileoverview added by tsickle
	     * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
	     */
	    /** @type {?} */
	    var SELECT_VALUE_ACCESSOR = {
	        provide: forms.NG_VALUE_ACCESSOR,
	        useExisting: core.forwardRef((/**
	         * @return {?}
	         */
	        function () { return SelectComponent; })),
	        multi: true
	    };
	    var SelectComponent = /** @class */ (function () {
	        function SelectComponent(hostElement) {
	            this.hostElement = hostElement;
	            // Data input.
	            this.options = [];
	            // Functionality settings.
	            this.allowClear = false;
	            this.disabled = false;
	            this.multiple = false;
	            this.noFilter = 0;
	            // Text settings.
	            this.notFoundMsg = 'No results found';
	            this.placeholder = '';
	            this.filterPlaceholder = '';
	            this.label = '';
	            // Output events.
	            this.opened = new core.EventEmitter();
	            this.closed = new core.EventEmitter();
	            this.selected = new core.EventEmitter();
	            this.deselected = new core.EventEmitter();
	            this.focus = new core.EventEmitter();
	            this.blur = new core.EventEmitter();
	            this.noOptionsFound = new core.EventEmitter();
	            this.filterInputChanged = new core.EventEmitter();
	            this._value = [];
	            this.optionList = new OptionList([]);
	            // View state variables.
	            this.hasFocus = false;
	            this.isOpen = false;
	            this.isBelow = true;
	            this.filterEnabled = true;
	            this.filterInputWidth = 1;
	            this.isDisabled = false;
	            this.placeholderView = '';
	            this.clearClicked = false;
	            this.selectContainerClicked = false;
	            this.optionListClicked = false;
	            this.optionClicked = false;
	            this.onChange = (/**
	             * @param {?} _
	             * @return {?}
	             */
	            function (_) { });
	            this.onTouched = (/**
	             * @return {?}
	             */
	            function () { });
	            /**
	             * Keys. *
	             */
	            this.KEYS = {
	                BACKSPACE: 8,
	                TAB: 9,
	                ENTER: 13,
	                ESC: 27,
	                SPACE: 32,
	                UP: 38,
	                DOWN: 40
	            };
	        }
	        /** Event handlers. **/
	        /**
	         * Event handlers. *
	         * @return {?}
	         */
	        SelectComponent.prototype.ngOnInit = /**
	         * Event handlers. *
	         * @return {?}
	         */
	        function () {
	            this.placeholderView = this.placeholder;
	        };
	        /**
	         * @param {?} changes
	         * @return {?}
	         */
	        SelectComponent.prototype.ngOnChanges = /**
	         * @param {?} changes
	         * @return {?}
	         */
	        function (changes) {
	            this.handleInputChanges(changes);
	        };
	        /**
	         * @return {?}
	         */
	        SelectComponent.prototype.ngAfterViewInit = /**
	         * @return {?}
	         */
	        function () {
	            this.updateState();
	        };
	        /**
	         * @return {?}
	         */
	        SelectComponent.prototype.onWindowBlur = /**
	         * @return {?}
	         */
	        function () {
	            this._blur();
	        };
	        /**
	         * @return {?}
	         */
	        SelectComponent.prototype.onWindowClick = /**
	         * @return {?}
	         */
	        function () {
	            if (!this.selectContainerClicked &&
	                (!this.optionListClicked || (this.optionListClicked && this.optionClicked))) {
	                this.closeDropdown(this.optionClicked);
	                if (!this.optionClicked) {
	                    this._blur();
	                }
	            }
	            this.clearClicked = false;
	            this.selectContainerClicked = false;
	            this.optionListClicked = false;
	            this.optionClicked = false;
	        };
	        /**
	         * @return {?}
	         */
	        SelectComponent.prototype.onWindowResize = /**
	         * @return {?}
	         */
	        function () {
	            this.updateWidth();
	        };
	        /**
	         * @param {?} event
	         * @return {?}
	         */
	        SelectComponent.prototype.onSelectContainerClick = /**
	         * @param {?} event
	         * @return {?}
	         */
	        function (event) {
	            this.selectContainerClicked = true;
	            if (!this.clearClicked) {
	                this.toggleDropdown();
	            }
	        };
	        /**
	         * @return {?}
	         */
	        SelectComponent.prototype.onSelectContainerFocus = /**
	         * @return {?}
	         */
	        function () {
	            this._focus();
	        };
	        /**
	         * @param {?} event
	         * @return {?}
	         */
	        SelectComponent.prototype.onSelectContainerKeydown = /**
	         * @param {?} event
	         * @return {?}
	         */
	        function (event) {
	            this.handleSelectContainerKeydown(event);
	        };
	        /**
	         * @return {?}
	         */
	        SelectComponent.prototype.onOptionsListClick = /**
	         * @return {?}
	         */
	        function () {
	            this.optionListClicked = true;
	        };
	        /**
	         * @param {?} option
	         * @return {?}
	         */
	        SelectComponent.prototype.onDropdownOptionClicked = /**
	         * @param {?} option
	         * @return {?}
	         */
	        function (option) {
	            this.optionClicked = true;
	            this.multiple ? this.toggleSelectOption(option) : this.selectOption(option);
	        };
	        /**
	         * @return {?}
	         */
	        SelectComponent.prototype.onSingleFilterClick = /**
	         * @return {?}
	         */
	        function () {
	            this.selectContainerClicked = true;
	        };
	        /**
	         * @return {?}
	         */
	        SelectComponent.prototype.onSingleFilterFocus = /**
	         * @return {?}
	         */
	        function () {
	            this._focus();
	        };
	        /**
	         * @param {?} term
	         * @return {?}
	         */
	        SelectComponent.prototype.onFilterInput = /**
	         * @param {?} term
	         * @return {?}
	         */
	        function (term) {
	            this.filterInputChanged.emit(term);
	            this.filter(term);
	        };
	        /**
	         * @param {?} event
	         * @return {?}
	         */
	        SelectComponent.prototype.onSingleFilterKeydown = /**
	         * @param {?} event
	         * @return {?}
	         */
	        function (event) {
	            this.handleSingleFilterKeydown(event);
	        };
	        /**
	         * @param {?} event
	         * @return {?}
	         */
	        SelectComponent.prototype.onMultipleFilterKeydown = /**
	         * @param {?} event
	         * @return {?}
	         */
	        function (event) {
	            this.handleMultipleFilterKeydown(event);
	        };
	        /**
	         * @return {?}
	         */
	        SelectComponent.prototype.onMultipleFilterFocus = /**
	         * @return {?}
	         */
	        function () {
	            this._focus();
	        };
	        /**
	         * @param {?} event
	         * @return {?}
	         */
	        SelectComponent.prototype.onClearSelectionClick = /**
	         * @param {?} event
	         * @return {?}
	         */
	        function (event) {
	            this.clearClicked = true;
	            this.clearSelection();
	            this.closeDropdown(true);
	        };
	        /**
	         * @param {?} option
	         * @return {?}
	         */
	        SelectComponent.prototype.onDeselectOptionClick = /**
	         * @param {?} option
	         * @return {?}
	         */
	        function (option) {
	            this.clearClicked = true;
	            this.deselectOption(option);
	        };
	        /** API. **/
	        // TODO fix issues with global click/key handler that closes the dropdown.
	        /**
	         * API. *
	         * @return {?}
	         */
	        // TODO fix issues with global click/key handler that closes the dropdown.
	        SelectComponent.prototype.open = /**
	         * API. *
	         * @return {?}
	         */
	        // TODO fix issues with global click/key handler that closes the dropdown.
	        function () {
	            this.openDropdown();
	        };
	        /**
	         * @return {?}
	         */
	        SelectComponent.prototype.close = /**
	         * @return {?}
	         */
	        function () {
	            this.closeDropdown(false);
	        };
	        /**
	         * @return {?}
	         */
	        SelectComponent.prototype.clear = /**
	         * @return {?}
	         */
	        function () {
	            this.clearSelection();
	        };
	        /**
	         * @param {?} value
	         * @return {?}
	         */
	        SelectComponent.prototype.select = /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this.writeValue(value);
	        };
	        /** ControlValueAccessor interface methods. **/
	        /**
	         * ControlValueAccessor interface methods. *
	         * @param {?} value
	         * @return {?}
	         */
	        SelectComponent.prototype.writeValue = /**
	         * ControlValueAccessor interface methods. *
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this.value = value;
	        };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        SelectComponent.prototype.registerOnChange = /**
	         * @param {?} fn
	         * @return {?}
	         */
	        function (fn) {
	            this.onChange = fn;
	        };
	        /**
	         * @param {?} fn
	         * @return {?}
	         */
	        SelectComponent.prototype.registerOnTouched = /**
	         * @param {?} fn
	         * @return {?}
	         */
	        function (fn) {
	            this.onTouched = fn;
	        };
	        /**
	         * @param {?} isDisabled
	         * @return {?}
	         */
	        SelectComponent.prototype.setDisabledState = /**
	         * @param {?} isDisabled
	         * @return {?}
	         */
	        function (isDisabled) {
	            this.disabled = isDisabled;
	        };
	        /** Input change handling. **/
	        /**
	         * Input change handling. *
	         * @private
	         * @param {?} changes
	         * @return {?}
	         */
	        SelectComponent.prototype.handleInputChanges = /**
	         * Input change handling. *
	         * @private
	         * @param {?} changes
	         * @return {?}
	         */
	        function (changes) {
	            /** @type {?} */
	            var optionsChanged = changes.hasOwnProperty('options');
	            /** @type {?} */
	            var noFilterChanged = changes.hasOwnProperty('noFilter');
	            /** @type {?} */
	            var placeholderChanged = changes.hasOwnProperty('placeholder');
	            if (optionsChanged) {
	                this.updateOptionList(changes.options.currentValue);
	                this.updateState();
	            }
	            if (optionsChanged || noFilterChanged) {
	                this.updateFilterEnabled();
	            }
	            if (placeholderChanged) {
	                this.updateState();
	            }
	        };
	        /**
	         * @private
	         * @param {?} options
	         * @return {?}
	         */
	        SelectComponent.prototype.updateOptionList = /**
	         * @private
	         * @param {?} options
	         * @return {?}
	         */
	        function (options) {
	            this.optionList = new OptionList(options);
	            this.optionList.value = this._value;
	        };
	        /**
	         * @private
	         * @return {?}
	         */
	        SelectComponent.prototype.updateFilterEnabled = /**
	         * @private
	         * @return {?}
	         */
	        function () {
	            this.filterEnabled = this.optionList.options.length >= this.noFilter;
	        };
	        Object.defineProperty(SelectComponent.prototype, "value", {
	            /** Value. **/
	            get: /**
	             * Value. *
	             * @return {?}
	             */
	            function () {
	                return this.multiple ? this._value : this._value[0];
	            },
	            set: /**
	             * @param {?} v
	             * @return {?}
	             */
	            function (v) {
	                if (typeof v === 'undefined' || v === null || v === '') {
	                    v = [];
	                }
	                else if (typeof v === 'string') {
	                    v = [v];
	                }
	                else if (!Array.isArray(v)) {
	                    throw new TypeError('Value must be a string or an array.');
	                }
	                this.optionList.value = v;
	                this._value = v;
	                this.updateState();
	            },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * @private
	         * @return {?}
	         */
	        SelectComponent.prototype.valueChanged = /**
	         * @private
	         * @return {?}
	         */
	        function () {
	            this._value = this.optionList.value;
	            this.updateState();
	            this.onChange(this.value);
	        };
	        /**
	         * @private
	         * @return {?}
	         */
	        SelectComponent.prototype.updateState = /**
	         * @private
	         * @return {?}
	         */
	        function () {
	            var _this = this;
	            this.placeholderView = this.optionList.hasSelected ? '' : this.placeholder;
	            setTimeout((/**
	             * @return {?}
	             */
	            function () {
	                _this.updateFilterWidth();
	            }));
	        };
	        /** Select. **/
	        /**
	         * Select. *
	         * @private
	         * @param {?} option
	         * @return {?}
	         */
	        SelectComponent.prototype.selectOption = /**
	         * Select. *
	         * @private
	         * @param {?} option
	         * @return {?}
	         */
	        function (option) {
	            if (!option.selected && !option.disabled) {
	                this.optionList.select(option, this.multiple);
	                this.valueChanged();
	                this.selected.emit(option.wrappedOption);
	            }
	        };
	        /**
	         * @private
	         * @param {?} option
	         * @return {?}
	         */
	        SelectComponent.prototype.deselectOption = /**
	         * @private
	         * @param {?} option
	         * @return {?}
	         */
	        function (option) {
	            var _this = this;
	            if (option.selected) {
	                this.optionList.deselect(option);
	                this.valueChanged();
	                this.deselected.emit(option.wrappedOption);
	                setTimeout((/**
	                 * @return {?}
	                 */
	                function () {
	                    if (_this.multiple) {
	                        _this.updatePosition();
	                        _this.optionList.highlight();
	                        if (_this.isOpen) {
	                            _this.dropdown.moveHighlightedIntoView();
	                        }
	                    }
	                }));
	            }
	        };
	        /**
	         * @private
	         * @return {?}
	         */
	        SelectComponent.prototype.clearSelection = /**
	         * @private
	         * @return {?}
	         */
	        function () {
	            /** @type {?} */
	            var selection = this.optionList.selection;
	            if (selection.length > 0) {
	                this.optionList.clearSelection();
	                this.valueChanged();
	                if (selection.length === 1) {
	                    this.deselected.emit(selection[0].wrappedOption);
	                }
	                else {
	                    this.deselected.emit(selection.map((/**
	                     * @param {?} option
	                     * @return {?}
	                     */
	                    function (option) { return option.wrappedOption; })));
	                }
	            }
	        };
	        /**
	         * @private
	         * @param {?} option
	         * @return {?}
	         */
	        SelectComponent.prototype.toggleSelectOption = /**
	         * @private
	         * @param {?} option
	         * @return {?}
	         */
	        function (option) {
	            option.selected ? this.deselectOption(option) : this.selectOption(option);
	        };
	        /**
	         * @private
	         * @return {?}
	         */
	        SelectComponent.prototype.selectHighlightedOption = /**
	         * @private
	         * @return {?}
	         */
	        function () {
	            /** @type {?} */
	            var option = this.optionList.highlightedOption;
	            if (option !== null) {
	                this.selectOption(option);
	                this.closeDropdown(true);
	            }
	        };
	        /**
	         * @private
	         * @return {?}
	         */
	        SelectComponent.prototype.deselectLast = /**
	         * @private
	         * @return {?}
	         */
	        function () {
	            /** @type {?} */
	            var sel = this.optionList.selection;
	            if (sel.length > 0) {
	                /** @type {?} */
	                var option = sel[sel.length - 1];
	                this.deselectOption(option);
	                this.setMultipleFilterInput(option.label + ' ');
	            }
	        };
	        /** Dropdown. **/
	        /**
	         * Dropdown. *
	         * @private
	         * @return {?}
	         */
	        SelectComponent.prototype.toggleDropdown = /**
	         * Dropdown. *
	         * @private
	         * @return {?}
	         */
	        function () {
	            if (!this.isDisabled) {
	                this.isOpen ? this.closeDropdown(true) : this.openDropdown();
	            }
	        };
	        /**
	         * @private
	         * @return {?}
	         */
	        SelectComponent.prototype.openDropdown = /**
	         * @private
	         * @return {?}
	         */
	        function () {
	            var _this = this;
	            if (!this.isOpen) {
	                this.isOpen = true;
	                this.updateWidth();
	                setTimeout((/**
	                 * @return {?}
	                 */
	                function () {
	                    _this.updatePosition();
	                    if (_this.multiple && _this.filterEnabled) {
	                        _this.filterInput.nativeElement.focus();
	                    }
	                    _this.opened.emit(null);
	                }));
	            }
	        };
	        /**
	         * @private
	         * @param {?} focus
	         * @return {?}
	         */
	        SelectComponent.prototype.closeDropdown = /**
	         * @private
	         * @param {?} focus
	         * @return {?}
	         */
	        function (focus) {
	            if (this.isOpen) {
	                this.clearFilterInput();
	                this.updateFilterWidth();
	                this.isOpen = false;
	                if (focus) {
	                    this._focusSelectContainer();
	                }
	                this.closed.emit(null);
	            }
	        };
	        /** Filter. **/
	        /**
	         * Filter. *
	         * @private
	         * @param {?} term
	         * @return {?}
	         */
	        SelectComponent.prototype.filter = /**
	         * Filter. *
	         * @private
	         * @param {?} term
	         * @return {?}
	         */
	        function (term) {
	            var _this = this;
	            if (this.multiple) {
	                if (!this.isOpen) {
	                    this.openDropdown();
	                }
	                this.updateFilterWidth();
	            }
	            setTimeout((/**
	             * @return {?}
	             */
	            function () {
	                /** @type {?} */
	                var hasShown = _this.optionList.filter(term);
	                if (!hasShown) {
	                    _this.noOptionsFound.emit(term);
	                }
	            }));
	        };
	        /**
	         * @private
	         * @return {?}
	         */
	        SelectComponent.prototype.clearFilterInput = /**
	         * @private
	         * @return {?}
	         */
	        function () {
	            if (this.multiple && this.filterEnabled) {
	                this.filterInput.nativeElement.value = '';
	            }
	        };
	        /**
	         * @private
	         * @param {?} value
	         * @return {?}
	         */
	        SelectComponent.prototype.setMultipleFilterInput = /**
	         * @private
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (this.filterEnabled) {
	                this.filterInput.nativeElement.value = value;
	            }
	        };
	        /**
	         * @private
	         * @param {?} event
	         * @return {?}
	         */
	        SelectComponent.prototype.handleSelectContainerKeydown = /**
	         * @private
	         * @param {?} event
	         * @return {?}
	         */
	        function (event) {
	            var _this = this;
	            /** @type {?} */
	            var key = event.which;
	            if (this.isOpen) {
	                if (key === this.KEYS.ESC || (key === this.KEYS.UP && event.altKey)) {
	                    this.closeDropdown(true);
	                }
	                else if (key === this.KEYS.TAB) {
	                    this.closeDropdown(event.shiftKey);
	                    this._blur();
	                }
	                else if (key === this.KEYS.ENTER) {
	                    this.selectHighlightedOption();
	                }
	                else if (key === this.KEYS.UP) {
	                    this.optionList.highlightPreviousOption();
	                    this.dropdown.moveHighlightedIntoView();
	                    if (!this.filterEnabled) {
	                        event.preventDefault();
	                    }
	                }
	                else if (key === this.KEYS.DOWN) {
	                    this.optionList.highlightNextOption();
	                    this.dropdown.moveHighlightedIntoView();
	                    if (!this.filterEnabled) {
	                        event.preventDefault();
	                    }
	                }
	            }
	            else {
	                // DEPRICATED --> SPACE
	                if (key === this.KEYS.ENTER || key === this.KEYS.SPACE ||
	                    (key === this.KEYS.DOWN && event.altKey)) {
	                    /* FIREFOX HACK:
	                     *
	                     * The setTimeout is added to prevent the enter keydown event
	                     * to be triggered for the filter input field, which causes
	                     * the dropdown to be closed again.
	                     */
	                    setTimeout((/**
	                     * @return {?}
	                     */
	                    function () { _this.openDropdown(); }));
	                }
	                else if (key === this.KEYS.TAB) {
	                    this._blur();
	                }
	            }
	        };
	        /**
	         * @private
	         * @param {?} event
	         * @return {?}
	         */
	        SelectComponent.prototype.handleMultipleFilterKeydown = /**
	         * @private
	         * @param {?} event
	         * @return {?}
	         */
	        function (event) {
	            /** @type {?} */
	            var key = event.which;
	            if (key === this.KEYS.BACKSPACE) {
	                if (this.optionList.hasSelected && this.filterEnabled &&
	                    this.filterInput.nativeElement.value === '') {
	                    this.deselectLast();
	                }
	            }
	        };
	        /**
	         * @private
	         * @param {?} event
	         * @return {?}
	         */
	        SelectComponent.prototype.handleSingleFilterKeydown = /**
	         * @private
	         * @param {?} event
	         * @return {?}
	         */
	        function (event) {
	            /** @type {?} */
	            var key = event.which;
	            if (key === this.KEYS.ESC || key === this.KEYS.TAB
	                || key === this.KEYS.UP || key === this.KEYS.DOWN
	                || key === this.KEYS.ENTER) {
	                this.handleSelectContainerKeydown(event);
	            }
	        };
	        /** View. **/
	        /**
	         * View. *
	         * @return {?}
	         */
	        SelectComponent.prototype._blur = /**
	         * View. *
	         * @return {?}
	         */
	        function () {
	            if (this.hasFocus) {
	                this.hasFocus = false;
	                this.onTouched();
	                this.blur.emit(null);
	            }
	        };
	        /**
	         * @return {?}
	         */
	        SelectComponent.prototype._focus = /**
	         * @return {?}
	         */
	        function () {
	            if (!this.hasFocus) {
	                this.hasFocus = true;
	                this.focus.emit(null);
	            }
	        };
	        /**
	         * @return {?}
	         */
	        SelectComponent.prototype._focusSelectContainer = /**
	         * @return {?}
	         */
	        function () {
	            this.selectionSpan.nativeElement.focus();
	        };
	        /**
	         * @private
	         * @return {?}
	         */
	        SelectComponent.prototype.updateWidth = /**
	         * @private
	         * @return {?}
	         */
	        function () {
	            this.width = this.selectionSpan.nativeElement.getBoundingClientRect().width;
	        };
	        /**
	         * @private
	         * @return {?}
	         */
	        SelectComponent.prototype.updatePosition = /**
	         * @private
	         * @return {?}
	         */
	        function () {
	            if (typeof this.dropdown !== 'undefined') {
	                /** @type {?} */
	                var hostRect = this.hostElement.nativeElement.getBoundingClientRect();
	                /** @type {?} */
	                var spanRect = this.selectionSpan.nativeElement.getBoundingClientRect();
	                /** @type {?} */
	                var dropRect = this.dropdown.hostElement.nativeElement.firstElementChild.getBoundingClientRect();
	                /** @type {?} */
	                var windowHeight = window.innerHeight;
	                /** @type {?} */
	                var top_1 = spanRect.top - hostRect.top;
	                /** @type {?} */
	                var bottom = hostRect.bottom + dropRect.height;
	                this.isBelow = bottom < windowHeight;
	                this.left = spanRect.left - hostRect.left;
	                this.top = this.isBelow ? top_1 + spanRect.height : top_1 - dropRect.height;
	            }
	        };
	        /**
	         * @private
	         * @return {?}
	         */
	        SelectComponent.prototype.updateFilterWidth = /**
	         * @private
	         * @return {?}
	         */
	        function () {
	            if (typeof this.filterInput !== 'undefined') {
	                /** @type {?} */
	                var value = this.filterInput.nativeElement.value;
	                this.filterInputWidth = value.length === 0 ?
	                    1 + this.placeholderView.length * 10 : 1 + value.length * 10;
	            }
	        };
	        SelectComponent.decorators = [
	            { type: core.Component, args: [{
	                        selector: 'ng-select',
	                        template: "<label\n    *ngIf=\"label !== ''\">\n    {{label}}\n</label>\n<div\n    #selection\n    [attr.tabindex]=\"disabled ? null : 0\"\n    [ngClass]=\"{'open': isOpen, 'focus': hasFocus, 'below': isBelow, 'above': !isBelow, 'disabled': disabled}\"\n    (click)=\"onSelectContainerClick($event)\"\n    (focus)=\"onSelectContainerFocus()\"\n    (keydown)=\"onSelectContainerKeydown($event)\">\n\n    <div class=\"single\"\n        *ngIf=\"!multiple\">\n        <div class=\"value\"\n            *ngIf=\"optionList.hasSelected\">\n            <ng-container *ngTemplateOutlet=\"optionTemplate; context:{option: optionList.selection[0].wrappedOption, onDeselectOptionClick: onDeselectOptionClick}\"></ng-container>\n            <span *ngIf=\"!optionTemplate\">{{optionList.selection[0].label}}</span>\n        </div>\n        <div class=\"placeholder\"\n            *ngIf=\"!optionList.hasSelected\">\n            {{placeholderView}}\n        </div>\n        <div class=\"clear\"\n            *ngIf=\"allowClear && optionList.hasSelected\"\n            (click)=\"onClearSelectionClick($event)\">\n            &#x2715;\n        </div>\n        <div class=\"toggle\"\n            *ngIf=\"isOpen\">\n            &#x25B2;\n        </div>\n        <div class=\"toggle\"\n            *ngIf=\"!isOpen\">\n            &#x25BC;\n        </div>\n    </div>\n\n    <div class=\"multiple\"\n        *ngIf=\"multiple\">\n        <div class=\"option\"\n            *ngFor=\"let option of optionList.selection\">\n            <span class=\"deselect-option\"\n                (click)=onDeselectOptionClick(option)>\n                &#x2715;\n            </span>\n            {{option.label}}\n        </div>\n        <div class=\"placeholder\"\n            *ngIf=\"!filterEnabled && !optionList.hasSelected\">\n            {{placeholderView}}\n        </div>\n        <input\n            *ngIf=\"filterEnabled\"\n            #filterInput\n            autocomplete=\"off\"\n            tabindex=\"-1\"\n            [placeholder]=\"placeholderView\"\n            [ngStyle]=\"{'width.px': filterInputWidth}\"\n            (input)=\"onFilterInput($event.target.value)\"\n            (keydown)=\"onMultipleFilterKeydown($event)\"\n            (focus)=\"onMultipleFilterFocus()\"/>\n    </div>\n\n</div>\n<select-dropdown\n    *ngIf=\"isOpen\"\n    #dropdown\n    [multiple]=\"multiple\"\n    [optionList]=\"optionList\"\n    [notFoundMsg]=\"notFoundMsg\"\n    [highlightColor]=\"highlightColor\"\n    [highlightTextColor]=\"highlightTextColor\"\n    [filterEnabled]=\"filterEnabled\"\n    [placeholder]=\"filterPlaceholder\"\n    [isBelow]=\"isBelow\"\n    [width]=\"width\"\n    [top]=\"top\"\n    [left]=\"left\"\n    [optionTemplate]=\"optionTemplate\"\n    (optionClicked)=\"onDropdownOptionClicked($event)\"\n    (optionsListClick)=\"onOptionsListClick()\"\n    (singleFilterClick)=\"onSingleFilterClick()\"\n    (singleFilterFocus)=\"onSingleFilterFocus()\"\n    (singleFilterInput)=\"onFilterInput($event)\"\n    (singleFilterKeydown)=\"onSingleFilterKeydown($event)\">\n</select-dropdown>\n",
	                        providers: [SELECT_VALUE_ACCESSOR],
	                        encapsulation: core.ViewEncapsulation.None,
	                        styles: ["ng-select{display:inline-block;margin:0;position:relative;vertical-align:middle;width:100%}ng-select *{box-sizing:border-box}ng-select>div{border:1px solid #ddd;box-sizing:border-box;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%}ng-select>div.disabled{background-color:#eee;color:#aaa;cursor:default;pointer-events:none}ng-select>div>div.single{display:flex;height:30px;width:100%}ng-select>div>div.single>div.placeholder,ng-select>div>div.single>div.value{flex:1;line-height:30px;overflow:hidden;padding:0 10px;white-space:nowrap}ng-select>div>div.single>div.placeholder{color:#757575}ng-select>div>div.single>div.clear,ng-select>div>div.single>div.toggle{color:#aaa;line-height:30px;text-align:center;width:30px}ng-select>div>div.single>div.clear:hover,ng-select>div>div.single>div.toggle:hover{background-color:#ececec}ng-select>div>div.single>div.clear{font-size:18px}ng-select>div>div.single>div.toggle{font-size:14px}ng-select>div>div.multiple{display:flex;flex-flow:row wrap;height:100%;min-height:30px;padding:0 10px;width:100%}ng-select>div>div.multiple>div.option{background-color:#eee;border:1px solid #aaa;border-radius:4px;color:#333;cursor:default;display:inline-block;flex-shrink:0;font-size:14px;line-height:22px;margin:3px 5px 3px 0;padding:0 4px}ng-select>div>div.multiple>div.option span.deselect-option{color:#aaa;cursor:pointer;font-size:14px;height:20px;line-height:20px}ng-select>div>div.multiple>div.option span.deselect-option:hover{color:#555}ng-select>div>div.multiple input{background-color:transparent;border:none;cursor:pointer;height:30px;line-height:30px;padding:0}ng-select>div>div.multiple input:focus{outline:0}ng-select label{color:rgba(0,0,0,.38);display:block;font-size:13px;padding:4px 0}"]
	                    }] }
	        ];
	        /** @nocollapse */
	        SelectComponent.ctorParameters = function () { return [
	            { type: core.ElementRef }
	        ]; };
	        SelectComponent.propDecorators = {
	            options: [{ type: core.Input }],
	            allowClear: [{ type: core.Input }],
	            disabled: [{ type: core.Input }],
	            multiple: [{ type: core.Input }],
	            noFilter: [{ type: core.Input }],
	            highlightColor: [{ type: core.Input }],
	            highlightTextColor: [{ type: core.Input }],
	            notFoundMsg: [{ type: core.Input }],
	            placeholder: [{ type: core.Input }],
	            filterPlaceholder: [{ type: core.Input }],
	            label: [{ type: core.Input }],
	            opened: [{ type: core.Output }],
	            closed: [{ type: core.Output }],
	            selected: [{ type: core.Output }],
	            deselected: [{ type: core.Output }],
	            focus: [{ type: core.Output }],
	            blur: [{ type: core.Output }],
	            noOptionsFound: [{ type: core.Output }],
	            filterInputChanged: [{ type: core.Output }],
	            selectionSpan: [{ type: core.ViewChild, args: ['selection', { static: true },] }],
	            dropdown: [{ type: core.ViewChild, args: ['dropdown', { static: false },] }],
	            filterInput: [{ type: core.ViewChild, args: ['filterInput', { static: false },] }],
	            optionTemplate: [{ type: core.ContentChild, args: ['optionTemplate', { static: false },] }],
	            onWindowBlur: [{ type: core.HostListener, args: ['window:blur',] }],
	            onWindowClick: [{ type: core.HostListener, args: ['window:click',] }],
	            onWindowResize: [{ type: core.HostListener, args: ['window:resize',] }]
	        };
	        return SelectComponent;
	    }());
	
	    /**
	     * @fileoverview added by tsickle
	     * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
	     */
	
	    /**
	     * @fileoverview added by tsickle
	     * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
	     */
	    var SelectModule = /** @class */ (function () {
	        function SelectModule() {
	        }
	        SelectModule.decorators = [
	            { type: core.NgModule, args: [{
	                        declarations: [
	                            SelectComponent,
	                            SelectDropdownComponent
	                        ],
	                        exports: [
	                            SelectComponent
	                        ],
	                        imports: [
	                            common.CommonModule,
	                            forms.FormsModule
	                        ]
	                    },] }
	        ];
	        return SelectModule;
	    }());
	
	    exports.SELECT_VALUE_ACCESSOR = SELECT_VALUE_ACCESSOR;
	    exports.SelectComponent = SelectComponent;
	    exports.SelectModule = SelectModule;
	    exports.ɵa = SelectDropdownComponent;
	
	    Object.defineProperty(exports, '__esModule', { value: true });
	
	}));
	//# sourceMappingURL=ng-select.umd.js.map


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(922));


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var common_1 = __webpack_require__(246);
	var router_1 = __webpack_require__(270);
	var core_2 = __webpack_require__(252);
	var wizard_1 = __webpack_require__(923);
	var validation_1 = __webpack_require__(933);
	var collapse_1 = __webpack_require__(948);
	var autocomplete_1 = __webpack_require__(958);
	var form_1 = __webpack_require__(967);
	var toggle_1 = __webpack_require__(970);
	var checkbox_1 = __webpack_require__(975);
	var normalizers_1 = __webpack_require__(982);
	var datepicker_1 = __webpack_require__(994);
	var accordion_1 = __webpack_require__(997);
	var loading_1 = __webpack_require__(1022);
	var templates_1 = __webpack_require__(1025);
	var pagination_1 = __webpack_require__(1029);
	var panel_1 = __webpack_require__(1032);
	var click_to_edit_1 = __webpack_require__(1036);
	var load_more_1 = __webpack_require__(1041);
	var icons_1 = __webpack_require__(1044);
	var forms_1 = __webpack_require__(768);
	var amount_1 = __webpack_require__(1060);
	var textarea_1 = __webpack_require__(1063);
	var error_block_1 = __webpack_require__(1065);
	var errorwl_block_1 = __webpack_require__(1066);
	var success_block_1 = __webpack_require__(1067);
	var ngx_pagination_1 = __webpack_require__(1068);
	var trim_directive_1 = __webpack_require__(1069);
	var warning_block_component_1 = __webpack_require__(1070);
	var material_card_component_1 = __webpack_require__(1071);
	var category_checkbox_1 = __webpack_require__(1072);
	var card_1 = __webpack_require__(1074);
	var checkbox_2 = __webpack_require__(1080);
	var chosen_category_service_1 = __webpack_require__(1083);
	var ngx_bootstrap_1 = __webpack_require__(1084);
	var CommonComponentsModule = (function () {
	    function CommonComponentsModule() {
	    }
	    CommonComponentsModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                forms_1.FormsModule,
	                common_1.CommonModule,
	                router_1.RouterModule,
	                core_2.TranslateModule,
	                ngx_pagination_1.NgxPaginationModule,
	                card_1.MatCardModule,
	                checkbox_2.MatCheckboxModule,
	                ngx_bootstrap_1.TooltipModule
	            ],
	            declarations: [
	                trim_directive_1.InputTrimDirective
	            ].concat(wizard_1.WIZARD_COMPONENTS, validation_1.VALIDATION_DIRECTIVES, collapse_1.COLLAPSE_COMPONENTS, autocomplete_1.AUTO_COMPLETE_COMPONENTS, form_1.FORM_DIRECTIVES, toggle_1.TOGGLE_DIRECTIVES, checkbox_1.CHECKBOX_DIRECTIVES, normalizers_1.NORMALIZER_DIRECTIVES, datepicker_1.DATE_PICKER_DIRECTIVES, accordion_1.ACCORDION_DIRECTIVES, loading_1.LOADING_COMPONENTS, templates_1.TEMPLATE_COMPONENTS, pagination_1.PAGINATION_COMPONENTS, panel_1.PANEL_COMPONENTS, click_to_edit_1.CLICK_TO_EDIT_COMPONENTS, load_more_1.LOAD_MORE_COMPONENTS, icons_1.ICONS, amount_1.AMOUNT_RANGE_COMPONENTS, [
	                textarea_1.TextareaAutoresize,
	                error_block_1.ErrorBlock,
	                errorwl_block_1.ErrorWLBlock,
	                success_block_1.SuccessBlock,
	                warning_block_component_1.WarningBlockComponent,
	                material_card_component_1.MaterialCardComponent,
	                category_checkbox_1.CheckboxComponent
	            ]),
	            providers: wizard_1.WIZARD_PROVIDERS.concat(validation_1.VALIDATION_PROVIDERS, collapse_1.COLLAPSE_PROVIDERS, autocomplete_1.AUTO_COMPLETE_PROVIDERS, [
	                chosen_category_service_1.ChosenCategoryService
	            ]),
	            exports: [
	                ngx_pagination_1.NgxPaginationModule,
	                // MdMenuModule,
	                trim_directive_1.InputTrimDirective
	            ].concat(wizard_1.WIZARD_COMPONENTS, validation_1.VALIDATION_DIRECTIVES, collapse_1.COLLAPSE_COMPONENTS, autocomplete_1.AUTO_COMPLETE_COMPONENTS, form_1.FORM_DIRECTIVES, toggle_1.TOGGLE_DIRECTIVES, checkbox_1.CHECKBOX_DIRECTIVES, normalizers_1.NORMALIZER_DIRECTIVES, datepicker_1.DATE_PICKER_DIRECTIVES, accordion_1.ACCORDION_DIRECTIVES, loading_1.LOADING_COMPONENTS, templates_1.TEMPLATE_COMPONENTS, pagination_1.PAGINATION_COMPONENTS, panel_1.PANEL_COMPONENTS, click_to_edit_1.CLICK_TO_EDIT_COMPONENTS, load_more_1.LOAD_MORE_COMPONENTS, icons_1.ICONS, amount_1.AMOUNT_RANGE_COMPONENTS, [
	                textarea_1.TextareaAutoresize,
	                error_block_1.ErrorBlock,
	                errorwl_block_1.ErrorWLBlock,
	                success_block_1.SuccessBlock,
	                warning_block_component_1.WarningBlockComponent,
	                material_card_component_1.MaterialCardComponent,
	                category_checkbox_1.CheckboxComponent
	            ])
	        })
	    ], CommonComponentsModule);
	    return CommonComponentsModule;
	}());
	exports.CommonComponentsModule = CommonComponentsModule;


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(924));
	__export(__webpack_require__(925));
	__export(__webpack_require__(927));
	__export(__webpack_require__(930));
	__export(__webpack_require__(931));
	__export(__webpack_require__(928));
	var wizard_component_1 = __webpack_require__(924);
	var wizard_tab_1 = __webpack_require__(925);
	var wizard_content_1 = __webpack_require__(927);
	var wizard_prev_1 = __webpack_require__(930);
	var wizard_next_1 = __webpack_require__(931);
	var wizard_tab_lifecycle_1 = __webpack_require__(928);
	exports.WIZARD_COMPONENTS = [
	    wizard_component_1.Wizard,
	    wizard_tab_1.WizardTab,
	    wizard_content_1.WizardContent,
	    wizard_prev_1.WizardPrev,
	    wizard_next_1.WizardNext,
	    wizard_tab_lifecycle_1.WizardOnTabActive
	];
	exports.WIZARD_PROVIDERS = [];


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var wizard_tab_1 = __webpack_require__(925);
	var wizard_content_1 = __webpack_require__(927);
	var wizard_prev_1 = __webpack_require__(930);
	var wizard_next_1 = __webpack_require__(931);
	//see wizard.api.html
	//web component for multispeps forms
	var Wizard = (function () {
	    function Wizard() {
	        this.navigationBarHidden = false;
	    }
	    Wizard.prototype.hideNavigationBar = function () {
	        this.navigationBarHidden = true;
	    };
	    Wizard.prototype.ngAfterContentInit = function () {
	        this.setupTabs();
	        this.setupPrevButtons();
	        this.setupNextButtons();
	    };
	    /**
	     * Setup tabs to communicate with wizard
	     */
	    Wizard.prototype.setupTabs = function () {
	        var _this = this;
	        var prevTab;
	        this.tabs.forEach(function (tab) {
	            //setup queue
	            if (prevTab) {
	                prevTab.setNextTab(tab);
	                tab.setPrevTab(prevTab);
	            }
	            //sharing parent object with child tabs
	            tab.setupParent(_this);
	            prevTab = tab;
	            //if tab has default attribute, then select it
	            if (tab.isDefault) {
	                setTimeout(function () {
	                    _this.selectTab(tab);
	                });
	            }
	        });
	    };
	    /**
	     * Setup prev buttons to communicate with wizard
	     */
	    Wizard.prototype.setupPrevButtons = function () {
	        var _this = this;
	        this.prevs.forEach(function (prev) {
	            prev.setupPrevLoader(function () {
	                _this.selectPrevTab();
	            });
	        });
	    };
	    /**
	     * Setup next buttons to communicate with wizard
	     */
	    Wizard.prototype.setupNextButtons = function () {
	        var _this = this;
	        this.nexts.forEach(function (next) {
	            next.setupNextLoader(function () {
	                _this.selectNextTab();
	            });
	        });
	    };
	    /**
	     * Handle tab click
	     * @param selectedTab - clicked tab
	     */
	    Wizard.prototype.handleTabSelected = function (selectedTab) {
	        this.selectTab(selectedTab);
	    };
	    /**
	     * Select tab
	     * @param selectedTab - tab to activate
	     */
	    Wizard.prototype.selectTab = function (selectedTab) {
	        this.currentTab = selectedTab;
	        this.currentTab.isDone = true;
	        this.tabs.forEach(function (tab) {
	            var state = tab === selectedTab;
	            tab.setTabState(state);
	        });
	        this.contents.forEach(function (content) {
	            content.setContentState(content.tabId === selectedTab.tabId);
	        });
	    };
	    /**
	     * Next tab action
	     */
	    Wizard.prototype.selectNextTab = function () {
	        if (this.currentTab && this.currentTab.next) {
	            this.handleTabSelected(this.currentTab.next);
	        }
	    };
	    /**
	     * Prev tab action
	     */
	    Wizard.prototype.selectPrevTab = function () {
	        if (this.currentTab && this.currentTab.prev) {
	            this.handleTabSelected(this.currentTab.prev);
	        }
	    };
	    __decorate([
	        core_1.Input('tabs-alignment'),
	        __metadata("design:type", String)
	    ], Wizard.prototype, "tabsAlignment", void 0);
	    __decorate([
	        core_1.ContentChildren(wizard_tab_1.WizardTab),
	        __metadata("design:type", core_1.QueryList)
	    ], Wizard.prototype, "tabs", void 0);
	    __decorate([
	        core_1.ContentChildren(wizard_content_1.WizardContent),
	        __metadata("design:type", core_1.QueryList)
	    ], Wizard.prototype, "contents", void 0);
	    __decorate([
	        core_1.ContentChildren(wizard_prev_1.WizardPrev),
	        __metadata("design:type", core_1.QueryList)
	    ], Wizard.prototype, "prevs", void 0);
	    __decorate([
	        core_1.ContentChildren(wizard_next_1.WizardNext),
	        __metadata("design:type", core_1.QueryList)
	    ], Wizard.prototype, "nexts", void 0);
	    Wizard = __decorate([
	        core_1.Component({
	            selector: 'wizard',
	            template: __webpack_require__(932)
	        })
	    ], Wizard);
	    return Wizard;
	}());
	exports.Wizard = Wizard;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var lodash_1 = __webpack_require__(268);
	var WizardTab = (function () {
	    function WizardTab() {
	        this.isDone = false;
	        this.isSelected = false;
	    }
	    Object.defineProperty(WizardTab.prototype, "defaultProp", {
	        set: function (attr) {
	            this.isDefault = lodash_1.isString(attr);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    WizardTab.prototype.setPrevTab = function (prevTab) {
	        this.prev = prevTab;
	    };
	    WizardTab.prototype.setNextTab = function (nextTab) {
	        this.next = nextTab;
	    };
	    WizardTab.prototype.selectTab = function () {
	        this.wizardComponent.handleTabSelected(this);
	    };
	    WizardTab.prototype.setTabState = function (isSelected) {
	        this.isSelected = isSelected;
	    };
	    WizardTab.prototype.setupParent = function (parent) {
	        this.wizardComponent = parent;
	    };
	    __decorate([
	        core_1.Input('id'),
	        __metadata("design:type", String)
	    ], WizardTab.prototype, "tabId", void 0);
	    __decorate([
	        core_1.Input('default'),
	        __metadata("design:type", String),
	        __metadata("design:paramtypes", [String])
	    ], WizardTab.prototype, "defaultProp", null);
	    WizardTab = __decorate([
	        core_1.Component({
	            selector: 'wizard-tab',
	            template: __webpack_require__(926)
	        })
	    ], WizardTab);
	    return WizardTab;
	}());
	exports.WizardTab = WizardTab;


/***/ }),
/* 926 */
/***/ (function(module, exports) {

	module.exports = "<!--todo andrey resolve validation wizard problem  (click)=\"selectTab()\" -->\n<li>\n    <a [ngClass]=\"isSelected ? 'selected': (isDone ? 'done' : 'disabled')\" class=\"wizard-link\">\n\n        <span class=\"step_no\">\n            <ng-content select=\".tab-title\"></ng-content>\n        </span>\n\n        <span class=\"step_descr\">\n           <ng-content select=\".tab-description\"></ng-content>\n        </span>\n\n    </a>\n</li>"

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var wizard_tab_lifecycle_1 = __webpack_require__(928);
	var WizardContent = (function () {
	    function WizardContent() {
	        this.contentActive = false;
	    }
	    WizardContent.prototype.setContentState = function (state) {
	        this.contentActive = state;
	        if (!!this.listener && state) {
	            this.listener.activate(this.tabId);
	        }
	    };
	    __decorate([
	        core_1.Input('for'),
	        __metadata("design:type", String)
	    ], WizardContent.prototype, "tabId", void 0);
	    __decorate([
	        core_1.ContentChild(wizard_tab_lifecycle_1.WizardOnTabActive),
	        __metadata("design:type", wizard_tab_lifecycle_1.WizardOnTabActive)
	    ], WizardContent.prototype, "listener", void 0);
	    WizardContent = __decorate([
	        core_1.Component({
	            selector: 'wizard-content',
	            template: __webpack_require__(929)
	        })
	    ], WizardContent);
	    return WizardContent;
	}());
	exports.WizardContent = WizardContent;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var WizardOnTabActive = (function () {
	    function WizardOnTabActive() {
	        this.listener = new core_1.EventEmitter();
	    }
	    WizardOnTabActive.prototype.activate = function (tabId) {
	        this.listener.emit(tabId);
	    };
	    __decorate([
	        core_1.Output('on-tab-active'),
	        __metadata("design:type", core_1.EventEmitter)
	    ], WizardOnTabActive.prototype, "listener", void 0);
	    WizardOnTabActive = __decorate([
	        core_1.Directive({ selector: '[on-tab-active]' })
	    ], WizardOnTabActive);
	    return WizardOnTabActive;
	}());
	exports.WizardOnTabActive = WizardOnTabActive;


/***/ }),
/* 929 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"content\" *ngIf=\"contentActive\">\n    <ng-content></ng-content>\n</div>\n"

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var core_1 = __webpack_require__(205);
	var WizardPrev = (function () {
	    function WizardPrev() {
	    }
	    WizardPrev.prototype.setupPrevLoader = function (loader) {
	        this.prevLoader = loader;
	    };
	    WizardPrev.prototype.onClick = function () {
	        if (lodash_1.isFunction(this.prevLoader)) {
	            this.prevLoader();
	        }
	    };
	    __decorate([
	        core_1.HostListener('click'),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], WizardPrev.prototype, "onClick", null);
	    WizardPrev = __decorate([
	        core_1.Directive({
	            selector: '[wizard-prev]'
	        })
	    ], WizardPrev);
	    return WizardPrev;
	}());
	exports.WizardPrev = WizardPrev;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var core_1 = __webpack_require__(205);
	var WizardNext = (function () {
	    function WizardNext() {
	    }
	    WizardNext.prototype.setupNextLoader = function (loader) {
	        this.nextLoader = loader;
	    };
	    WizardNext.prototype.onClick = function () {
	        if (lodash_1.isFunction(this.nextLoader)) {
	            this.nextLoader();
	        }
	    };
	    __decorate([
	        core_1.HostListener('click'),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], WizardNext.prototype, "onClick", null);
	    WizardNext = __decorate([
	        core_1.Directive({
	            selector: '[wizard-next]'
	        })
	    ], WizardNext);
	    return WizardNext;
	}());
	exports.WizardNext = WizardNext;


/***/ }),
/* 932 */
/***/ (function(module, exports) {

	module.exports = "\n<div class=\"form_wizard wizard_horizontal\">\n\n    <ng-content select=\".wizard-top-content\"></ng-content>\n\n    <ul *ngIf=\"!navigationBarHidden\" class=\"wizard_steps\">\n        <ng-content select=\"wizard-tab\"></ng-content>\n    </ul>\n\n    <div class=\"content-container\">\n        <ng-content select=\"wizard-content\"></ng-content>\n    </div>\n\n    <ng-content select=\".wizard-bottom-content\"></ng-content>\n\n</div>"

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var field_validator_1 = __webpack_require__(934);
	var field_message_1 = __webpack_require__(935);
	var validators_1 = __webpack_require__(769);
	var validate_on_blur_directive_1 = __webpack_require__(937);
	var input_modifiers_1 = __webpack_require__(938);
	exports.VALIDATION_DIRECTIVES = [
	    field_validator_1.FieldValidator,
	    field_message_1.FieldMessage,
	    validators_1.MatchValidator,
	    validators_1.TypeValidator,
	    validators_1.AmountValidator,
	    validators_1.IbanValidator,
	    validate_on_blur_directive_1.ValidateOnBlurDirective,
	    input_modifiers_1.RestrictForbiddenCharacterInputDirective,
	    input_modifiers_1.ToUppercaseDirective,
	    input_modifiers_1.ToUppercaseTdDirective,
	    input_modifiers_1.WhitespacesRemoveDirective,
	    input_modifiers_1.WhitespacesRemoveTdDirective,
	    input_modifiers_1.InputPatternDirective,
	    input_modifiers_1.TrimDirective,
	    input_modifiers_1.InputPatternFormatter
	];
	exports.VALIDATION_PROVIDERS = [input_modifiers_1.InputModifierService];
	__export(__webpack_require__(934));
	__export(__webpack_require__(935));
	__export(__webpack_require__(769));


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var forms_1 = __webpack_require__(768);
	var core_1 = __webpack_require__(205);
	var field_message_1 = __webpack_require__(935);
	var FieldValidator = (function () {
	    function FieldValidator(element, renderer, ngForm) {
	        this.element = element;
	        this.renderer = renderer;
	        this.ngForm = ngForm;
	        this.stateChanged = new core_1.EventEmitter();
	        this.submitted = false;
	    }
	    FieldValidator_1 = FieldValidator;
	    FieldValidator.prototype.setControl = function (control) {
	        var _this = this;
	        if (!control || !!this.control) {
	            return;
	        }
	        this.control = control;
	        this.updateView(control); //init view
	        this.control.valueChanges.subscribe(function () {
	            _this.updateView(_this.control);
	        });
	        //adding/removing error class for form-group
	        this.stateChanged.subscribe(function (state) {
	            var parent = _this.element.nativeElement.closest('.form-group');
	            if (parent && state) {
	                _this.renderer.addClass(parent, 'has-error');
	            }
	            else {
	                _this.renderer.removeClass(parent, 'has-error');
	            }
	        });
	    };
	    FieldValidator.prototype.setSubmitted = function (isSubmitted) {
	        this.submitted = isSubmitted;
	        this.stateChanged.emit(this.getVisibilityState());
	    };
	    FieldValidator.prototype.updateView = function (control) {
	        var type = FieldValidator_1.readControlErrorType(control.errors);
	        this.messages.forEach(function (message) {
	            message.setOpen(message.messageType === type);
	        });
	        this.stateChanged.emit(this.getVisibilityState());
	    };
	    FieldValidator.prototype.getVisibilityState = function () {
	        return !(!!this.control ? !(!this.control.valid && !!this.control.errors && (this.control.touched || this.submitted)) : true);
	    };
	    FieldValidator.readControlErrorType = function (errorsMap) {
	        var type;
	        if (errorsMap) {
	            type = Object.keys(errorsMap)[0];
	        }
	        return type;
	    };
	    ;
	    FieldValidator.prototype.ngAfterContentInit = function () {
	        var _this = this;
	        setTimeout(function () {
	            _this.setControl(_this.findControlInGroup(_this.ngForm.form, _this.controlAlias));
	        });
	        this.ngForm.ngSubmit.subscribe(function () {
	            _this.setSubmitted(_this.ngForm.submitted);
	        });
	    };
	    FieldValidator.prototype.findControlInGroup = function (g, controlAlias) {
	        var result = g.controls[controlAlias];
	        if (result) {
	            return result;
	        }
	        var controlAliases = Object.keys(g.controls);
	        for (var i = 0; i < controlAliases.length; i++) {
	            if (g.controls[controlAliases[i]] instanceof forms_1.FormGroup) {
	                return this.findControlInGroup(g.controls[controlAliases[i]], controlAlias);
	            }
	        }
	        return result;
	    };
	    __decorate([
	        core_1.Input('for'),
	        __metadata("design:type", String)
	    ], FieldValidator.prototype, "controlAlias", void 0);
	    __decorate([
	        core_1.Output('stateChanged'),
	        __metadata("design:type", core_1.EventEmitter)
	    ], FieldValidator.prototype, "stateChanged", void 0);
	    __decorate([
	        core_1.ContentChildren(field_message_1.FieldMessage),
	        __metadata("design:type", core_1.QueryList)
	    ], FieldValidator.prototype, "messages", void 0);
	    FieldValidator = FieldValidator_1 = __decorate([
	        core_1.Component({
	            selector: 'field-validator',
	            template: __webpack_require__(936)
	        }),
	        __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer2, forms_1.NgForm])
	    ], FieldValidator);
	    return FieldValidator;
	    var FieldValidator_1;
	}());
	exports.FieldValidator = FieldValidator;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var FieldMessage = (function () {
	    function FieldMessage(element) {
	        this.element = element;
	    }
	    FieldMessage.prototype.getOpen = function () {
	        return this.isOpen;
	    };
	    FieldMessage.prototype.setOpen = function (isOpen) {
	        this.isOpen = isOpen;
	        this.element.nativeElement.style.display = isOpen ? 'block' : 'none';
	    };
	    __decorate([
	        core_1.Input('type'),
	        __metadata("design:type", String)
	    ], FieldMessage.prototype, "messageType", void 0);
	    FieldMessage = __decorate([
	        core_1.Component({ selector: 'message', template: '<ng-content></ng-content>' }),
	        __metadata("design:paramtypes", [core_1.ElementRef])
	    ], FieldMessage);
	    return FieldMessage;
	}());
	exports.FieldMessage = FieldMessage;


/***/ }),
/* 936 */
/***/ (function(module, exports) {

	module.exports = "<div [hidden]=\"!!control ? !(!control.valid && (control.touched || submitted)) : true\">\n    <ng-content></ng-content>\n</div>"

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var ValidateOnBlurDirective = (function () {
	    function ValidateOnBlurDirective(formControl) {
	        this.formControl = formControl;
	    }
	    ValidateOnBlurDirective.prototype.onBlur = function () {
	        this.formControl.control.updateValueAndValidity();
	    };
	    ValidateOnBlurDirective = __decorate([
	        core_1.Directive({
	            selector: '[ngModel]',
	            host: {
	                '(blur)': 'onBlur($event)'
	            }
	        }),
	        __metadata("design:paramtypes", [forms_1.NgControl])
	    ], ValidateOnBlurDirective);
	    return ValidateOnBlurDirective;
	}());
	exports.ValidateOnBlurDirective = ValidateOnBlurDirective;


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(939));
	__export(__webpack_require__(940));
	__export(__webpack_require__(942));
	__export(__webpack_require__(943));
	__export(__webpack_require__(944));
	__export(__webpack_require__(945));
	__export(__webpack_require__(946));
	__export(__webpack_require__(941));
	__export(__webpack_require__(947));


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var lodash_1 = __webpack_require__(268);
	var RestrictForbiddenCharacterInputDirective = (function () {
	    function RestrictForbiddenCharacterInputDirective() {
	        this.pattern = /^[a-zA-Z0-9\s(\-)+',.\/:]*$/;
	    }
	    Object.defineProperty(RestrictForbiddenCharacterInputDirective.prototype, "newPattern", {
	        set: function (val) {
	            if (lodash_1.isString(val) && !lodash_1.isEmpty(val)) {
	                this.pattern = new RegExp(val);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    RestrictForbiddenCharacterInputDirective.prototype.onKeyDown = function (event) {
	        if (!this.isKeyboardPasteEvent(event) && !this.pattern.test(event.key)) {
	            event.preventDefault();
	        }
	    };
	    RestrictForbiddenCharacterInputDirective.prototype.onPaste = function (event) {
	        if (!this.pattern.test(event.clipboardData.getData('text'))) {
	            event.preventDefault();
	        }
	    };
	    RestrictForbiddenCharacterInputDirective.prototype.onChange = function (event) {
	        if (!this.pattern.test(event.target.value)) {
	            event.target.value = '';
	        }
	    };
	    RestrictForbiddenCharacterInputDirective.prototype.isKeyboardPasteEvent = function (e) {
	        return (e.ctrlKey || e.metaKey) && e.keyCode === 86; // key "v"
	    };
	    __decorate([
	        core_1.Input('restrictForbiddenCharInput'),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [Object])
	    ], RestrictForbiddenCharacterInputDirective.prototype, "newPattern", null);
	    __decorate([
	        core_1.HostListener('keydown', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [KeyboardEvent]),
	        __metadata("design:returntype", void 0)
	    ], RestrictForbiddenCharacterInputDirective.prototype, "onKeyDown", null);
	    __decorate([
	        core_1.HostListener('paste', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [ClipboardEvent]),
	        __metadata("design:returntype", void 0)
	    ], RestrictForbiddenCharacterInputDirective.prototype, "onPaste", null);
	    __decorate([
	        core_1.HostListener('change', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], RestrictForbiddenCharacterInputDirective.prototype, "onChange", null);
	    RestrictForbiddenCharacterInputDirective = __decorate([
	        core_1.Directive({
	            selector: '[restrictForbiddenCharInput]'
	        })
	    ], RestrictForbiddenCharacterInputDirective);
	    return RestrictForbiddenCharacterInputDirective;
	}());
	exports.RestrictForbiddenCharacterInputDirective = RestrictForbiddenCharacterInputDirective;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var input_modifier_service_1 = __webpack_require__(941);
	var ToUppercaseDirective = (function () {
	    function ToUppercaseDirective(_inputModifier) {
	        this._inputModifier = _inputModifier;
	    }
	    ToUppercaseDirective.prototype.onInput = function (event) {
	        this._inputModifier.transformControlValue(input_modifier_service_1.ControlAccessors.forReactiveForm(this.form, this.controlName), event, function (v) { return v.toUpperCase(); });
	    };
	    __decorate([
	        core_1.Input('controlName'),
	        __metadata("design:type", String)
	    ], ToUppercaseDirective.prototype, "controlName", void 0);
	    __decorate([
	        core_1.Input('formGroup'),
	        __metadata("design:type", forms_1.FormGroup)
	    ], ToUppercaseDirective.prototype, "form", void 0);
	    ToUppercaseDirective = __decorate([
	        core_1.Directive({
	            selector: '[formGroup][controlName][toUpperCase]',
	            host: {
	                '(input)': 'onInput($event)'
	            }
	        }),
	        __metadata("design:paramtypes", [input_modifier_service_1.InputModifierService])
	    ], ToUppercaseDirective);
	    return ToUppercaseDirective;
	}());
	exports.ToUppercaseDirective = ToUppercaseDirective;


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var util_1 = __webpack_require__(743);
	var forms_1 = __webpack_require__(768);
	var InputModifierService = (function () {
	    function InputModifierService() {
	    }
	    InputModifierService.prototype.transformControlValue = function (controlSource, domEvent, transformer) {
	        var control = (controlSource instanceof forms_1.AbstractControl ? controlSource : controlSource.getControl());
	        if (!control) {
	            return;
	        }
	        var originalValue = control.value;
	        if (util_1.isNullOrUndefined(originalValue)) {
	            return;
	        }
	        var transformedValue = transformer(originalValue);
	        if (originalValue == transformedValue) {
	            return;
	        }
	        if (!util_1.isNullOrUndefined(transformedValue) && domEvent.target == document.activeElement) {
	            this.updateControlPreservingCaretPosition(control, domEvent.target, originalValue, transformedValue);
	        }
	        else {
	            control.patchValue(transformedValue);
	        }
	    };
	    InputModifierService.prototype.updateControlPreservingCaretPosition = function (control, nativeElement, originalValue, transformedValue) {
	        var start = nativeElement.selectionStart;
	        var end = nativeElement.selectionEnd;
	        var originalLength = originalValue.length;
	        var modifiedLength = transformedValue.length;
	        control.patchValue(transformedValue);
	        var newEnd = end - Math.abs(modifiedLength - originalLength);
	        nativeElement.setSelectionRange(start, newEnd);
	    };
	    InputModifierService = __decorate([
	        core_1.Injectable()
	    ], InputModifierService);
	    return InputModifierService;
	}());
	exports.InputModifierService = InputModifierService;
	var ControlAccessors = (function () {
	    function ControlAccessors() {
	    }
	    ControlAccessors.forReactiveForm = function (formGroup, controlName) {
	        return {
	            getControl: function () {
	                return formGroup.controls[controlName];
	            }
	        };
	    };
	    ControlAccessors.forTemplateDrivenForm = function (model) {
	        return {
	            getControl: function () {
	                return model.control;
	            }
	        };
	    };
	    return ControlAccessors;
	}());
	exports.ControlAccessors = ControlAccessors;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var input_modifier_service_1 = __webpack_require__(941);
	var ToUppercaseTdDirective = (function () {
	    function ToUppercaseTdDirective(_model, _inputModifier) {
	        this._model = _model;
	        this._inputModifier = _inputModifier;
	    }
	    ToUppercaseTdDirective.prototype.onInput = function (event) {
	        this._inputModifier.transformControlValue(input_modifier_service_1.ControlAccessors.forTemplateDrivenForm(this._model), event, function (v) { return v.toUpperCase(); });
	    };
	    ToUppercaseTdDirective = __decorate([
	        core_1.Directive({
	            selector: '[ngModel][toUpperCase]',
	            host: {
	                '(input)': 'onInput($event)'
	            }
	        }),
	        __metadata("design:paramtypes", [forms_1.NgModel, input_modifier_service_1.InputModifierService])
	    ], ToUppercaseTdDirective);
	    return ToUppercaseTdDirective;
	}());
	exports.ToUppercaseTdDirective = ToUppercaseTdDirective;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var input_modifier_service_1 = __webpack_require__(941);
	var WhitespacesRemoveDirective = (function () {
	    function WhitespacesRemoveDirective(_inputModifier) {
	        this._inputModifier = _inputModifier;
	    }
	    WhitespacesRemoveDirective.prototype.onInput = function (event) {
	        this._inputModifier.transformControlValue(input_modifier_service_1.ControlAccessors.forReactiveForm(this.form, this.controlName), event, this.transform);
	    };
	    WhitespacesRemoveDirective.prototype.transform = function (value) {
	        if (!value) {
	            return null;
	        }
	        return value.replace(/\s+/g, '').trim();
	    };
	    __decorate([
	        core_1.Input('controlName'),
	        __metadata("design:type", String)
	    ], WhitespacesRemoveDirective.prototype, "controlName", void 0);
	    __decorate([
	        core_1.Input('formGroup'),
	        __metadata("design:type", forms_1.FormGroup)
	    ], WhitespacesRemoveDirective.prototype, "form", void 0);
	    WhitespacesRemoveDirective = __decorate([
	        core_1.Directive({
	            selector: '[formGroup][controlName][removeWhiteSpaces]',
	            host: {
	                '(input)': 'onInput($event)',
	            }
	        }),
	        __metadata("design:paramtypes", [input_modifier_service_1.InputModifierService])
	    ], WhitespacesRemoveDirective);
	    return WhitespacesRemoveDirective;
	}());
	exports.WhitespacesRemoveDirective = WhitespacesRemoveDirective;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var input_modifier_service_1 = __webpack_require__(941);
	var WhitespacesRemoveTdDirective = (function () {
	    function WhitespacesRemoveTdDirective(_model, _inputModifier) {
	        this._model = _model;
	        this._inputModifier = _inputModifier;
	    }
	    WhitespacesRemoveTdDirective.prototype.onInput = function (event) {
	        this._inputModifier.transformControlValue(input_modifier_service_1.ControlAccessors.forTemplateDrivenForm(this._model), event, this.transform);
	    };
	    WhitespacesRemoveTdDirective.prototype.transform = function (value) {
	        if (!value) {
	            return null;
	        }
	        return value.replace(/\s+/g, '').trim();
	    };
	    WhitespacesRemoveTdDirective = __decorate([
	        core_1.Directive({
	            selector: '[ngModel][removeWhiteSpaces]',
	            host: {
	                '(input)': 'onInput($event)'
	            }
	        }),
	        __metadata("design:paramtypes", [forms_1.NgModel, input_modifier_service_1.InputModifierService])
	    ], WhitespacesRemoveTdDirective);
	    return WhitespacesRemoveTdDirective;
	}());
	exports.WhitespacesRemoveTdDirective = WhitespacesRemoveTdDirective;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var lodash_1 = __webpack_require__(268);
	var InputPatternDirective = (function () {
	    function InputPatternDirective() {
	        this.pattern = /^[a-zA-Z0-9\s(\-)+',.\/:]*$/;
	        this.prevValue = '';
	    }
	    Object.defineProperty(InputPatternDirective.prototype, "newPattern", {
	        set: function (val) {
	            if (lodash_1.isString(val) && !lodash_1.isEmpty(val)) {
	                this.pattern = new RegExp(val);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    InputPatternDirective.prototype.onPaste = function (event) {
	        if (!this.pattern.test(event.clipboardData.getData('text'))) {
	            event.preventDefault();
	        }
	    };
	    InputPatternDirective.prototype.onChanges = function (event) {
	        var control = this.form.controls[this.controlName];
	        var value = event.target.value;
	        if (!value) {
	            this.prevValue = value;
	            control.patchValue(value);
	            return;
	        }
	        if (value !== this.prevValue) {
	            if (this.pattern.test(value)) {
	                control.patchValue(value);
	                this.prevValue = value;
	            }
	            else {
	                control.patchValue(this.prevValue);
	            }
	        }
	    };
	    __decorate([
	        core_1.Input('controlName'),
	        __metadata("design:type", String)
	    ], InputPatternDirective.prototype, "controlName", void 0);
	    __decorate([
	        core_1.Input('formGroup'),
	        __metadata("design:type", forms_1.FormGroup)
	    ], InputPatternDirective.prototype, "form", void 0);
	    __decorate([
	        core_1.Input('valuePattern'),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [Object])
	    ], InputPatternDirective.prototype, "newPattern", null);
	    __decorate([
	        core_1.HostListener('paste', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [ClipboardEvent]),
	        __metadata("design:returntype", void 0)
	    ], InputPatternDirective.prototype, "onPaste", null);
	    __decorate([
	        core_1.HostListener('keyup', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], InputPatternDirective.prototype, "onChanges", null);
	    InputPatternDirective = __decorate([
	        core_1.Directive({
	            selector: '[valuePattern][controlName][formGroup]'
	        })
	    ], InputPatternDirective);
	    return InputPatternDirective;
	}());
	exports.InputPatternDirective = InputPatternDirective;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var input_modifier_service_1 = __webpack_require__(941);
	var TrimDirective = (function () {
	    function TrimDirective(_inputModifier) {
	        this._inputModifier = _inputModifier;
	    }
	    TrimDirective.prototype.onBlur = function (event) {
	        this._inputModifier.transformControlValue(input_modifier_service_1.ControlAccessors.forReactiveForm(this.form, this.controlName), event, this.transform);
	    };
	    TrimDirective.prototype.transform = function (value) {
	        if (!value) {
	            return null;
	        }
	        return value.trim();
	    };
	    __decorate([
	        core_1.Input('controlName'),
	        __metadata("design:type", String)
	    ], TrimDirective.prototype, "controlName", void 0);
	    __decorate([
	        core_1.Input('formGroup'),
	        __metadata("design:type", forms_1.FormGroup)
	    ], TrimDirective.prototype, "form", void 0);
	    TrimDirective = __decorate([
	        core_1.Directive({
	            selector: '[formGroup][controlName][trim]',
	            host: {
	                '(focusout)': 'onBlur($event)'
	            }
	        }),
	        __metadata("design:paramtypes", [input_modifier_service_1.InputModifierService])
	    ], TrimDirective);
	    return TrimDirective;
	}());
	exports.TrimDirective = TrimDirective;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var lodash_1 = __webpack_require__(268);
	var forms_1 = __webpack_require__(768);
	var InputPatternFormatter = (function () {
	    function InputPatternFormatter(ngControl) {
	        this.ngControl = ngControl;
	        this.pattern = /^[a-zA-Z0-9\s(\-)+',.\/:]*$/;
	    }
	    Object.defineProperty(InputPatternFormatter.prototype, "newPattern", {
	        set: function (val) {
	            if (lodash_1.isString(val) && !lodash_1.isEmpty(val)) {
	                this.pattern = new RegExp(val);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    InputPatternFormatter.prototype.onPaste = function () {
	        var actualValue = this.ngControl.value;
	        var newValue = '';
	        for (var i = 0; i < actualValue.length; i++) {
	            if (this.pattern.test(actualValue.charAt(i))) {
	                newValue = newValue.concat(actualValue.charAt(i));
	            }
	        }
	        this.ngControl.control.setValue(newValue);
	    };
	    InputPatternFormatter.prototype.onChanges = function () {
	        var value = this.ngControl.value;
	        var newValue = '';
	        if (!value || value.length === 0 || this.pattern.test(value)) {
	            return;
	        }
	        for (var i = 0; i < value.length; i++) {
	            if (this.pattern.test(value.charAt(i))) {
	                newValue = newValue.concat(value.charAt(i));
	            }
	        }
	        this.ngControl.control.setValue(newValue);
	    };
	    __decorate([
	        core_1.Input('inputPatternFormatter'),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [Object])
	    ], InputPatternFormatter.prototype, "newPattern", null);
	    __decorate([
	        core_1.HostListener('paste', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], InputPatternFormatter.prototype, "onPaste", null);
	    __decorate([
	        core_1.HostListener('keyup', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], InputPatternFormatter.prototype, "onChanges", null);
	    InputPatternFormatter = __decorate([
	        core_1.Directive({
	            selector: '[inputPatternFormatter]'
	        }),
	        __param(0, core_1.Self()),
	        __metadata("design:paramtypes", [forms_1.NgControl])
	    ], InputPatternFormatter);
	    return InputPatternFormatter;
	}());
	exports.InputPatternFormatter = InputPatternFormatter;


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(949));
	__export(__webpack_require__(956));
	var collapse_form_wrapper_component_1 = __webpack_require__(956);
	var child_1 = __webpack_require__(949);
	exports.COLLAPSE_COMPONENTS = [
	    collapse_form_wrapper_component_1.CollapseFormWrapperComponent,
	    child_1.CollapseFormChildComponent,
	    child_1.CollapseFormHeaderComponent
	];
	exports.COLLAPSE_PROVIDERS = [];


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(950));
	__export(__webpack_require__(953));


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(951));


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var CollapseFormHeaderComponent = (function () {
	    function CollapseFormHeaderComponent() {
	    }
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], CollapseFormHeaderComponent.prototype, "id", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], CollapseFormHeaderComponent.prototype, "title", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], CollapseFormHeaderComponent.prototype, "even", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], CollapseFormHeaderComponent.prototype, "disabled", void 0);
	    CollapseFormHeaderComponent = __decorate([
	        core_1.Component({
	            selector: "collapse-form-child-header",
	            template: __webpack_require__(952)
	        })
	    ], CollapseFormHeaderComponent);
	    return CollapseFormHeaderComponent;
	}());
	exports.CollapseFormHeaderComponent = CollapseFormHeaderComponent;


/***/ }),
/* 952 */
/***/ (function(module, exports) {

	module.exports = "<div>\n    <h4 class=\"panel-title\" style=\"padding: 5px;\">\n        <a class=\"title-toggle\" data-toggle=\"collapse\" data-parent=\"#accordion\" [href]=\"!disabled?'#collapse'+id:'#'\">\n            {{title}}\n        </a>\n\n        <div style=\"float: right;\">\n            <ng-content></ng-content>\n        </div>\n    </h4>\n</div>"

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var $ = __webpack_require__(954);
	var CollapseFormChildComponent = (function () {
	    function CollapseFormChildComponent() {
	    }
	    CollapseFormChildComponent.prototype.toggle = function () {
	        $("#collapse" + this.id).collapse('toggle');
	    };
	    CollapseFormChildComponent.prototype.show = function () {
	        $("#collapse" + this.id).collapse('show');
	    };
	    CollapseFormChildComponent.prototype.hide = function () {
	        $("#collapse" + this.id).collapse('hide');
	    };
	    CollapseFormChildComponent.prototype.initEvents = function (events) {
	        $("#collapse" + this.id).on('show.bs.collapse', function (event) {
	            events.onShow.emit(event);
	        }).on('shown.bs.collapse', function (event) {
	            events.onShown.emit(event);
	        }).on('hidden.bs.collapse', function (event) {
	            events.onHidden.emit(event);
	        }).on('hide.bs.collapse', function (event) {
	            events.onHide.emit(event);
	        });
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], CollapseFormChildComponent.prototype, "id", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], CollapseFormChildComponent.prototype, "openByDefault", void 0);
	    CollapseFormChildComponent = __decorate([
	        core_1.Component({
	            selector: 'collapse-form-child',
	            template: __webpack_require__(955)
	        })
	    ], CollapseFormChildComponent);
	    return CollapseFormChildComponent;
	}());
	exports.CollapseFormChildComponent = CollapseFormChildComponent;


/***/ }),
/* 954 */,
/* 955 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel panel-default\">\n    <div class=\"panel-heading\" style=\"cursor: pointer;\">\n        <ng-content select=\"collapse-form-child-header\"></ng-content>\n    </div>\n    <div [id]=\"'collapse'+id\" class=\"panel-collapse collapse\" [ngClass]=\"openByDefault?'in':''\">\n        <div class=\"panel-body\">\n            <ng-content select=\".collapse-body\"></ng-content>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var CollapseFormWrapperComponent = (function () {
	    function CollapseFormWrapperComponent() {
	    }
	    CollapseFormWrapperComponent = __decorate([
	        core_1.Component({
	            selector: 'collapse-form-wrapper',
	            template: __webpack_require__(957)
	        })
	    ], CollapseFormWrapperComponent);
	    return CollapseFormWrapperComponent;
	}());
	exports.CollapseFormWrapperComponent = CollapseFormWrapperComponent;


/***/ }),
/* 957 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel-group\" id=\"accordion\">\n    <ng-content></ng-content>\n</div>"

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(959));
	__export(__webpack_require__(960));
	__export(__webpack_require__(964));
	var autocomplete_directive_1 = __webpack_require__(960);
	var multiple_autocomplete_directive_1 = __webpack_require__(964);
	exports.AUTO_COMPLETE_COMPONENTS = [
	    autocomplete_directive_1.AutoComplete,
	    multiple_autocomplete_directive_1.MultipleAutocomplete
	];
	exports.AUTO_COMPLETE_PROVIDERS = [];


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var lodash_1 = __webpack_require__(268);
	var AutocompleteService = (function () {
	    function AutocompleteService() {
	    }
	    AutocompleteService.prototype.buildSuggestionEngine = function (optionsGetter, suggestionParser, sourceListener) {
	        return function (query, callback) {
	            var matches;
	            // an array that will be populated with substring matches
	            matches = [];
	            // regex used to determine if a string contains the substring `q`
	            var substrRegex = new RegExp(query, 'i');
	            var source = optionsGetter();
	            sourceListener(source);
	            // iterate through the pool of strings and for any string that
	            // contains the substring `q`, add it to the `matches` array
	            if (!lodash_1.isArray(source)) {
	                return;
	            }
	            lodash_1.forEach(source.map(function (item) { return suggestionParser(item); }), function (str) {
	                if (substrRegex.test(str)) {
	                    matches.push(str);
	                }
	            });
	            callback(matches);
	        };
	    };
	    ;
	    AutocompleteService = __decorate([
	        core_1.Injectable()
	    ], AutocompleteService);
	    return AutocompleteService;
	}());
	exports.AutocompleteService = AutocompleteService;


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var lodash_1 = __webpack_require__(268);
	var autocomplete_service_1 = __webpack_require__(959);
	var model_listener_1 = __webpack_require__(961);
	var $ = __webpack_require__(954);
	__webpack_require__(963);
	var PROVIDER = {
	    provide: forms_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return AutoComplete; }),
	    multi: true
	};
	var navigationKeyCodes = [37, 38, 39, 40, 35, 36];
	var AutoComplete = (function (_super) {
	    __extends(AutoComplete, _super);
	    function AutoComplete(el, service) {
	        var _this = _super.call(this) || this;
	        _this.el = el;
	        _this.service = service;
	        _this.onChange = new core_1.EventEmitter();
	        _this.onTouchedCallback = new core_1.EventEmitter();
	        _this.itemsLimit = 5;
	        _this.minQueryLength = 1;
	        _this.menuClass = 'tt-menu';
	        return _this;
	    }
	    AutoComplete.prototype.valueFormatter = function (newValue) {
	        if (!lodash_1.isEmpty(newValue)) {
	            var item = this._keysMap[newValue];
	            if (item && item !== null && item[0] && item[0] !== null) {
	                return item[0][this.valueParam];
	            }
	        }
	        return newValue;
	    };
	    AutoComplete.prototype.keyFormatter = function (newKey) {
	        var valuesMap;
	        if (lodash_1.isNumber(newKey)) {
	            valuesMap = lodash_1.groupBy(this.source, this.keyParam);
	        }
	        if (lodash_1.isString(newKey) && !lodash_1.isEmpty(newKey)) {
	            valuesMap = lodash_1.groupBy(this.source, this.valueParam);
	        }
	        if (!lodash_1.isNil(newKey) && lodash_1.isString(newKey) && !lodash_1.isEmpty(newKey)) {
	            var item = valuesMap[newKey];
	            if (item && item !== null && item[0] && item[0] !== null) {
	                return item[0][this.keyParam];
	            }
	        }
	        else {
	            return lodash_1.isString(newKey) ? null : newKey;
	        }
	    };
	    AutoComplete.prototype.writeValue = function (obj) {
	        _super.prototype.writeValue.call(this, obj);
	        var key = this.keyFormatter(obj);
	        if (!lodash_1.isNil(key)) {
	            var valuesMap = lodash_1.groupBy(this.source, this.keyParam);
	            var item = valuesMap[key];
	            if (!lodash_1.isUndefined(item)) {
	                $(this.el.nativeElement).typeahead('val', item[0][this.valueParam]);
	                return;
	            }
	        }
	        $(this.el.nativeElement).typeahead('val', '');
	    };
	    AutoComplete.prototype.ngOnInit = function () {
	        var _this = this;
	        //todo andrey resolve typescript lazy loading problem
	        //lazy loading outer library
	        //noinspection TypeScriptValidateTypes,TypeScriptUnresolvedFunction
	        $(this.el.nativeElement).typeahead({
	            classNames: {
	                menu: this.menuClass
	            },
	            hint: false,
	            highlight: true,
	            minLength: this.minQueryLength,
	        }, {
	            source: this.service.buildSuggestionEngine(function () { return _this.source; }, function (item) { return item[_this.valueParam]; }, function (source) {
	                _this._keysMap = lodash_1.groupBy(source, _this.keyParam);
	                _this._valuesMap = lodash_1.groupBy(source, _this.valueParam);
	            }),
	            limit: this.itemsLimit
	        })
	            .on('typeahead:select', function (event) {
	            _this.writeValue(event.target.value);
	        })
	            .on('typeahead:change', function (event) {
	            if (!lodash_1.isNil(_this._valuesMap) && lodash_1.isNil(_this._valuesMap[event.target.value])) {
	                _this.writeValue('');
	            }
	        })
	            .on('keyup', function (event) {
	            if (!lodash_1.includes(navigationKeyCodes, event.keyCode)) {
	                if (!lodash_1.isNil(_this._valuesMap) && !lodash_1.isNil(_this._valuesMap[event.target.value])) {
	                    _this.writeValue(event.target.value);
	                }
	            }
	        }).closest('.twitter-typeahead').css('display', 'block');
	        $(this.el.nativeElement).on("blur", function (event) {
	            _this.onTouchedCallback.emit();
	            if (lodash_1.isEmpty(event.target.value)) {
	                _this.writeValue('');
	            }
	        });
	    };
	    __decorate([
	        core_1.Input('ac-source'),
	        __metadata("design:type", Array)
	    ], AutoComplete.prototype, "source", void 0);
	    __decorate([
	        core_1.Input('ac-key'),
	        __metadata("design:type", String)
	    ], AutoComplete.prototype, "keyParam", void 0);
	    __decorate([
	        core_1.Input('ac-value'),
	        __metadata("design:type", String)
	    ], AutoComplete.prototype, "valueParam", void 0);
	    __decorate([
	        core_1.Input('items-limit'),
	        __metadata("design:type", Number)
	    ], AutoComplete.prototype, "itemsLimit", void 0);
	    __decorate([
	        core_1.Input('min-query-length'),
	        __metadata("design:type", Number)
	    ], AutoComplete.prototype, "minQueryLength", void 0);
	    __decorate([
	        core_1.Input('menu-class'),
	        __metadata("design:type", String)
	    ], AutoComplete.prototype, "menuClass", void 0);
	    AutoComplete = __decorate([
	        core_1.Directive({
	            selector: '[bs-autocomplete]',
	            providers: [PROVIDER, autocomplete_service_1.AutocompleteService]
	        }),
	        __metadata("design:paramtypes", [core_1.ElementRef,
	            autocomplete_service_1.AutocompleteService])
	    ], AutoComplete);
	    return AutoComplete;
	}(model_listener_1.ModelListener));
	exports.AutoComplete = AutoComplete;


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(962));


/***/ }),
/* 962 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var noop = function () {
	};
	var ModelListener = (function () {
	    function ModelListener() {
	        //The internal data model
	        this._innerValue = {};
	    }
	    ModelListener.prototype.valueFormatter = function (newValue) {
	        return newValue;
	    };
	    ModelListener.prototype.keyFormatter = function (newKey) {
	        return newKey;
	    };
	    ModelListener.prototype.writeValue = function (obj) {
	        obj = this.keyFormatter(obj);
	        if (obj !== this.innerValue) {
	            this.innerValue = obj;
	        }
	    };
	    //From ControlValueAccessor interface
	    ModelListener.prototype.registerOnChange = function (fn) {
	        this.onChange.subscribe(fn);
	    };
	    //From ControlValueAccessor interface
	    ModelListener.prototype.registerOnTouched = function (fn) {
	        this.onTouchedCallback.subscribe(fn);
	    };
	    Object.defineProperty(ModelListener.prototype, "innerValue", {
	        //get accessor
	        get: function () {
	            return this.valueFormatter(this._innerValue);
	        },
	        //set accessor including call the onchange callback
	        set: function (v) {
	            if (v !== this._innerValue) {
	                this._innerValue = v;
	                this.onChange.emit(this._innerValue);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ;
	    return ModelListener;
	}());
	exports.ModelListener = ModelListener;


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(setImmediate) {/*!
	 * typeahead.js 0.11.1
	 * https://github.com/twitter/typeahead.js
	 * Copyright 2013-2015 Twitter, Inc. and other contributors; Licensed MIT
	 */
	
	(function(root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(954) ], __WEBPACK_AMD_DEFINE_RESULT__ = function(a0) {
	            return root["Bloodhound"] = factory(a0);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === "object") {
	        module.exports = factory(require("jquery"));
	    } else {
	        root["Bloodhound"] = factory(jQuery);
	    }
	})(this, function($) {
	    var _ = function() {
	        "use strict";
	        return {
	            isMsie: function() {
	                return /(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
	            },
	            isBlankString: function(str) {
	                return !str || /^\s*$/.test(str);
	            },
	            escapeRegExChars: function(str) {
	                return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	            },
	            isString: function(obj) {
	                return typeof obj === "string";
	            },
	            isNumber: function(obj) {
	                return typeof obj === "number";
	            },
	            isArray: $.isArray,
	            isFunction: $.isFunction,
	            isObject: $.isPlainObject,
	            isUndefined: function(obj) {
	                return typeof obj === "undefined";
	            },
	            isElement: function(obj) {
	                return !!(obj && obj.nodeType === 1);
	            },
	            isJQuery: function(obj) {
	                return obj instanceof $;
	            },
	            toStr: function toStr(s) {
	                return _.isUndefined(s) || s === null ? "" : s + "";
	            },
	            bind: $.proxy,
	            each: function(collection, cb) {
	                $.each(collection, reverseArgs);
	                function reverseArgs(index, value) {
	                    return cb(value, index);
	                }
	            },
	            map: $.map,
	            filter: $.grep,
	            every: function(obj, test) {
	                var result = true;
	                if (!obj) {
	                    return result;
	                }
	                $.each(obj, function(key, val) {
	                    if (!(result = test.call(null, val, key, obj))) {
	                        return false;
	                    }
	                });
	                return !!result;
	            },
	            some: function(obj, test) {
	                var result = false;
	                if (!obj) {
	                    return result;
	                }
	                $.each(obj, function(key, val) {
	                    if (result = test.call(null, val, key, obj)) {
	                        return false;
	                    }
	                });
	                return !!result;
	            },
	            mixin: $.extend,
	            identity: function(x) {
	                return x;
	            },
	            clone: function(obj) {
	                return $.extend(true, {}, obj);
	            },
	            getIdGenerator: function() {
	                var counter = 0;
	                return function() {
	                    return counter++;
	                };
	            },
	            templatify: function templatify(obj) {
	                return $.isFunction(obj) ? obj : template;
	                function template() {
	                    return String(obj);
	                }
	            },
	            defer: function(fn) {
	                setTimeout(fn, 0);
	            },
	            debounce: function(func, wait, immediate) {
	                var timeout, result;
	                return function() {
	                    var context = this, args = arguments, later, callNow;
	                    later = function() {
	                        timeout = null;
	                        if (!immediate) {
	                            result = func.apply(context, args);
	                        }
	                    };
	                    callNow = immediate && !timeout;
	                    clearTimeout(timeout);
	                    timeout = setTimeout(later, wait);
	                    if (callNow) {
	                        result = func.apply(context, args);
	                    }
	                    return result;
	                };
	            },
	            throttle: function(func, wait) {
	                var context, args, timeout, result, previous, later;
	                previous = 0;
	                later = function() {
	                    previous = new Date();
	                    timeout = null;
	                    result = func.apply(context, args);
	                };
	                return function() {
	                    var now = new Date(), remaining = wait - (now - previous);
	                    context = this;
	                    args = arguments;
	                    if (remaining <= 0) {
	                        clearTimeout(timeout);
	                        timeout = null;
	                        previous = now;
	                        result = func.apply(context, args);
	                    } else if (!timeout) {
	                        timeout = setTimeout(later, remaining);
	                    }
	                    return result;
	                };
	            },
	            stringify: function(val) {
	                return _.isString(val) ? val : JSON.stringify(val);
	            },
	            noop: function() {}
	        };
	    }();
	    var VERSION = "0.11.1";
	    var tokenizers = function() {
	        "use strict";
	        return {
	            nonword: nonword,
	            whitespace: whitespace,
	            obj: {
	                nonword: getObjTokenizer(nonword),
	                whitespace: getObjTokenizer(whitespace)
	            }
	        };
	        function whitespace(str) {
	            str = _.toStr(str);
	            return str ? str.split(/\s+/) : [];
	        }
	        function nonword(str) {
	            str = _.toStr(str);
	            return str ? str.split(/\W+/) : [];
	        }
	        function getObjTokenizer(tokenizer) {
	            return function setKey(keys) {
	                keys = _.isArray(keys) ? keys : [].slice.call(arguments, 0);
	                return function tokenize(o) {
	                    var tokens = [];
	                    _.each(keys, function(k) {
	                        tokens = tokens.concat(tokenizer(_.toStr(o[k])));
	                    });
	                    return tokens;
	                };
	            };
	        }
	    }();
	    var LruCache = function() {
	        "use strict";
	        function LruCache(maxSize) {
	            this.maxSize = _.isNumber(maxSize) ? maxSize : 100;
	            this.reset();
	            if (this.maxSize <= 0) {
	                this.set = this.get = $.noop;
	            }
	        }
	        _.mixin(LruCache.prototype, {
	            set: function set(key, val) {
	                var tailItem = this.list.tail, node;
	                if (this.size >= this.maxSize) {
	                    this.list.remove(tailItem);
	                    delete this.hash[tailItem.key];
	                    this.size--;
	                }
	                if (node = this.hash[key]) {
	                    node.val = val;
	                    this.list.moveToFront(node);
	                } else {
	                    node = new Node(key, val);
	                    this.list.add(node);
	                    this.hash[key] = node;
	                    this.size++;
	                }
	            },
	            get: function get(key) {
	                var node = this.hash[key];
	                if (node) {
	                    this.list.moveToFront(node);
	                    return node.val;
	                }
	            },
	            reset: function reset() {
	                this.size = 0;
	                this.hash = {};
	                this.list = new List();
	            }
	        });
	        function List() {
	            this.head = this.tail = null;
	        }
	        _.mixin(List.prototype, {
	            add: function add(node) {
	                if (this.head) {
	                    node.next = this.head;
	                    this.head.prev = node;
	                }
	                this.head = node;
	                this.tail = this.tail || node;
	            },
	            remove: function remove(node) {
	                node.prev ? node.prev.next = node.next : this.head = node.next;
	                node.next ? node.next.prev = node.prev : this.tail = node.prev;
	            },
	            moveToFront: function(node) {
	                this.remove(node);
	                this.add(node);
	            }
	        });
	        function Node(key, val) {
	            this.key = key;
	            this.val = val;
	            this.prev = this.next = null;
	        }
	        return LruCache;
	    }();
	    var PersistentStorage = function() {
	        "use strict";
	        var LOCAL_STORAGE;
	        try {
	            LOCAL_STORAGE = window.localStorage;
	            LOCAL_STORAGE.setItem("~~~", "!");
	            LOCAL_STORAGE.removeItem("~~~");
	        } catch (err) {
	            LOCAL_STORAGE = null;
	        }
	        function PersistentStorage(namespace, override) {
	            this.prefix = [ "__", namespace, "__" ].join("");
	            this.ttlKey = "__ttl__";
	            this.keyMatcher = new RegExp("^" + _.escapeRegExChars(this.prefix));
	            this.ls = override || LOCAL_STORAGE;
	            !this.ls && this._noop();
	        }
	        _.mixin(PersistentStorage.prototype, {
	            _prefix: function(key) {
	                return this.prefix + key;
	            },
	            _ttlKey: function(key) {
	                return this._prefix(key) + this.ttlKey;
	            },
	            _noop: function() {
	                this.get = this.set = this.remove = this.clear = this.isExpired = _.noop;
	            },
	            _safeSet: function(key, val) {
	                try {
	                    this.ls.setItem(key, val);
	                } catch (err) {
	                    if (err.name === "QuotaExceededError") {
	                        this.clear();
	                        this._noop();
	                    }
	                }
	            },
	            get: function(key) {
	                if (this.isExpired(key)) {
	                    this.remove(key);
	                }
	                return decode(this.ls.getItem(this._prefix(key)));
	            },
	            set: function(key, val, ttl) {
	                if (_.isNumber(ttl)) {
	                    this._safeSet(this._ttlKey(key), encode(now() + ttl));
	                } else {
	                    this.ls.removeItem(this._ttlKey(key));
	                }
	                return this._safeSet(this._prefix(key), encode(val));
	            },
	            remove: function(key) {
	                this.ls.removeItem(this._ttlKey(key));
	                this.ls.removeItem(this._prefix(key));
	                return this;
	            },
	            clear: function() {
	                var i, keys = gatherMatchingKeys(this.keyMatcher);
	                for (i = keys.length; i--; ) {
	                    this.remove(keys[i]);
	                }
	                return this;
	            },
	            isExpired: function(key) {
	                var ttl = decode(this.ls.getItem(this._ttlKey(key)));
	                return _.isNumber(ttl) && now() > ttl ? true : false;
	            }
	        });
	        return PersistentStorage;
	        function now() {
	            return new Date().getTime();
	        }
	        function encode(val) {
	            return JSON.stringify(_.isUndefined(val) ? null : val);
	        }
	        function decode(val) {
	            return $.parseJSON(val);
	        }
	        function gatherMatchingKeys(keyMatcher) {
	            var i, key, keys = [], len = LOCAL_STORAGE.length;
	            for (i = 0; i < len; i++) {
	                if ((key = LOCAL_STORAGE.key(i)).match(keyMatcher)) {
	                    keys.push(key.replace(keyMatcher, ""));
	                }
	            }
	            return keys;
	        }
	    }();
	    var Transport = function() {
	        "use strict";
	        var pendingRequestsCount = 0, pendingRequests = {}, maxPendingRequests = 6, sharedCache = new LruCache(10);
	        function Transport(o) {
	            o = o || {};
	            this.cancelled = false;
	            this.lastReq = null;
	            this._send = o.transport;
	            this._get = o.limiter ? o.limiter(this._get) : this._get;
	            this._cache = o.cache === false ? new LruCache(0) : sharedCache;
	        }
	        Transport.setMaxPendingRequests = function setMaxPendingRequests(num) {
	            maxPendingRequests = num;
	        };
	        Transport.resetCache = function resetCache() {
	            sharedCache.reset();
	        };
	        _.mixin(Transport.prototype, {
	            _fingerprint: function fingerprint(o) {
	                o = o || {};
	                return o.url + o.type + $.param(o.data || {});
	            },
	            _get: function(o, cb) {
	                var that = this, fingerprint, jqXhr;
	                fingerprint = this._fingerprint(o);
	                if (this.cancelled || fingerprint !== this.lastReq) {
	                    return;
	                }
	                if (jqXhr = pendingRequests[fingerprint]) {
	                    jqXhr.done(done).fail(fail);
	                } else if (pendingRequestsCount < maxPendingRequests) {
	                    pendingRequestsCount++;
	                    pendingRequests[fingerprint] = this._send(o).done(done).fail(fail).always(always);
	                } else {
	                    this.onDeckRequestArgs = [].slice.call(arguments, 0);
	                }
	                function done(resp) {
	                    cb(null, resp);
	                    that._cache.set(fingerprint, resp);
	                }
	                function fail() {
	                    cb(true);
	                }
	                function always() {
	                    pendingRequestsCount--;
	                    delete pendingRequests[fingerprint];
	                    if (that.onDeckRequestArgs) {
	                        that._get.apply(that, that.onDeckRequestArgs);
	                        that.onDeckRequestArgs = null;
	                    }
	                }
	            },
	            get: function(o, cb) {
	                var resp, fingerprint;
	                cb = cb || $.noop;
	                o = _.isString(o) ? {
	                    url: o
	                } : o || {};
	                fingerprint = this._fingerprint(o);
	                this.cancelled = false;
	                this.lastReq = fingerprint;
	                if (resp = this._cache.get(fingerprint)) {
	                    cb(null, resp);
	                } else {
	                    this._get(o, cb);
	                }
	            },
	            cancel: function() {
	                this.cancelled = true;
	            }
	        });
	        return Transport;
	    }();
	    var SearchIndex = window.SearchIndex = function() {
	        "use strict";
	        var CHILDREN = "c", IDS = "i";
	        function SearchIndex(o) {
	            o = o || {};
	            if (!o.datumTokenizer || !o.queryTokenizer) {
	                $.error("datumTokenizer and queryTokenizer are both required");
	            }
	            this.identify = o.identify || _.stringify;
	            this.datumTokenizer = o.datumTokenizer;
	            this.queryTokenizer = o.queryTokenizer;
	            this.reset();
	        }
	        _.mixin(SearchIndex.prototype, {
	            bootstrap: function bootstrap(o) {
	                this.datums = o.datums;
	                this.trie = o.trie;
	            },
	            add: function(data) {
	                var that = this;
	                data = _.isArray(data) ? data : [ data ];
	                _.each(data, function(datum) {
	                    var id, tokens;
	                    that.datums[id = that.identify(datum)] = datum;
	                    tokens = normalizeTokens(that.datumTokenizer(datum));
	                    _.each(tokens, function(token) {
	                        var node, chars, ch;
	                        node = that.trie;
	                        chars = token.split("");
	                        while (ch = chars.shift()) {
	                            node = node[CHILDREN][ch] || (node[CHILDREN][ch] = newNode());
	                            node[IDS].push(id);
	                        }
	                    });
	                });
	            },
	            get: function get(ids) {
	                var that = this;
	                return _.map(ids, function(id) {
	                    return that.datums[id];
	                });
	            },
	            search: function search(query) {
	                var that = this, tokens, matches;
	                tokens = normalizeTokens(this.queryTokenizer(query));
	                _.each(tokens, function(token) {
	                    var node, chars, ch, ids;
	                    if (matches && matches.length === 0) {
	                        return false;
	                    }
	                    node = that.trie;
	                    chars = token.split("");
	                    while (node && (ch = chars.shift())) {
	                        node = node[CHILDREN][ch];
	                    }
	                    if (node && chars.length === 0) {
	                        ids = node[IDS].slice(0);
	                        matches = matches ? getIntersection(matches, ids) : ids;
	                    } else {
	                        matches = [];
	                        return false;
	                    }
	                });
	                return matches ? _.map(unique(matches), function(id) {
	                    return that.datums[id];
	                }) : [];
	            },
	            all: function all() {
	                var values = [];
	                for (var key in this.datums) {
	                    values.push(this.datums[key]);
	                }
	                return values;
	            },
	            reset: function reset() {
	                this.datums = {};
	                this.trie = newNode();
	            },
	            serialize: function serialize() {
	                return {
	                    datums: this.datums,
	                    trie: this.trie
	                };
	            }
	        });
	        return SearchIndex;
	        function normalizeTokens(tokens) {
	            tokens = _.filter(tokens, function(token) {
	                return !!token;
	            });
	            tokens = _.map(tokens, function(token) {
	                return token.toLowerCase();
	            });
	            return tokens;
	        }
	        function newNode() {
	            var node = {};
	            node[IDS] = [];
	            node[CHILDREN] = {};
	            return node;
	        }
	        function unique(array) {
	            var seen = {}, uniques = [];
	            for (var i = 0, len = array.length; i < len; i++) {
	                if (!seen[array[i]]) {
	                    seen[array[i]] = true;
	                    uniques.push(array[i]);
	                }
	            }
	            return uniques;
	        }
	        function getIntersection(arrayA, arrayB) {
	            var ai = 0, bi = 0, intersection = [];
	            arrayA = arrayA.sort();
	            arrayB = arrayB.sort();
	            var lenArrayA = arrayA.length, lenArrayB = arrayB.length;
	            while (ai < lenArrayA && bi < lenArrayB) {
	                if (arrayA[ai] < arrayB[bi]) {
	                    ai++;
	                } else if (arrayA[ai] > arrayB[bi]) {
	                    bi++;
	                } else {
	                    intersection.push(arrayA[ai]);
	                    ai++;
	                    bi++;
	                }
	            }
	            return intersection;
	        }
	    }();
	    var Prefetch = function() {
	        "use strict";
	        var keys;
	        keys = {
	            data: "data",
	            protocol: "protocol",
	            thumbprint: "thumbprint"
	        };
	        function Prefetch(o) {
	            this.url = o.url;
	            this.ttl = o.ttl;
	            this.cache = o.cache;
	            this.prepare = o.prepare;
	            this.transform = o.transform;
	            this.transport = o.transport;
	            this.thumbprint = o.thumbprint;
	            this.storage = new PersistentStorage(o.cacheKey);
	        }
	        _.mixin(Prefetch.prototype, {
	            _settings: function settings() {
	                return {
	                    url: this.url,
	                    type: "GET",
	                    dataType: "json"
	                };
	            },
	            store: function store(data) {
	                if (!this.cache) {
	                    return;
	                }
	                this.storage.set(keys.data, data, this.ttl);
	                this.storage.set(keys.protocol, location.protocol, this.ttl);
	                this.storage.set(keys.thumbprint, this.thumbprint, this.ttl);
	            },
	            fromCache: function fromCache() {
	                var stored = {}, isExpired;
	                if (!this.cache) {
	                    return null;
	                }
	                stored.data = this.storage.get(keys.data);
	                stored.protocol = this.storage.get(keys.protocol);
	                stored.thumbprint = this.storage.get(keys.thumbprint);
	                isExpired = stored.thumbprint !== this.thumbprint || stored.protocol !== location.protocol;
	                return stored.data && !isExpired ? stored.data : null;
	            },
	            fromNetwork: function(cb) {
	                var that = this, settings;
	                if (!cb) {
	                    return;
	                }
	                settings = this.prepare(this._settings());
	                this.transport(settings).fail(onError).done(onResponse);
	                function onError() {
	                    cb(true);
	                }
	                function onResponse(resp) {
	                    cb(null, that.transform(resp));
	                }
	            },
	            clear: function clear() {
	                this.storage.clear();
	                return this;
	            }
	        });
	        return Prefetch;
	    }();
	    var Remote = function() {
	        "use strict";
	        function Remote(o) {
	            this.url = o.url;
	            this.prepare = o.prepare;
	            this.transform = o.transform;
	            this.transport = new Transport({
	                cache: o.cache,
	                limiter: o.limiter,
	                transport: o.transport
	            });
	        }
	        _.mixin(Remote.prototype, {
	            _settings: function settings() {
	                return {
	                    url: this.url,
	                    type: "GET",
	                    dataType: "json"
	                };
	            },
	            get: function get(query, cb) {
	                var that = this, settings;
	                if (!cb) {
	                    return;
	                }
	                query = query || "";
	                settings = this.prepare(query, this._settings());
	                return this.transport.get(settings, onResponse);
	                function onResponse(err, resp) {
	                    err ? cb([]) : cb(that.transform(resp));
	                }
	            },
	            cancelLastRequest: function cancelLastRequest() {
	                this.transport.cancel();
	            }
	        });
	        return Remote;
	    }();
	    var oParser = function() {
	        "use strict";
	        return function parse(o) {
	            var defaults, sorter;
	            defaults = {
	                initialize: true,
	                identify: _.stringify,
	                datumTokenizer: null,
	                queryTokenizer: null,
	                sufficient: 5,
	                sorter: null,
	                local: [],
	                prefetch: null,
	                remote: null
	            };
	            o = _.mixin(defaults, o || {});
	            !o.datumTokenizer && $.error("datumTokenizer is required");
	            !o.queryTokenizer && $.error("queryTokenizer is required");
	            sorter = o.sorter;
	            o.sorter = sorter ? function(x) {
	                return x.sort(sorter);
	            } : _.identity;
	            o.local = _.isFunction(o.local) ? o.local() : o.local;
	            o.prefetch = parsePrefetch(o.prefetch);
	            o.remote = parseRemote(o.remote);
	            return o;
	        };
	        function parsePrefetch(o) {
	            var defaults;
	            if (!o) {
	                return null;
	            }
	            defaults = {
	                url: null,
	                ttl: 24 * 60 * 60 * 1e3,
	                cache: true,
	                cacheKey: null,
	                thumbprint: "",
	                prepare: _.identity,
	                transform: _.identity,
	                transport: null
	            };
	            o = _.isString(o) ? {
	                url: o
	            } : o;
	            o = _.mixin(defaults, o);
	            !o.url && $.error("prefetch requires url to be set");
	            o.transform = o.filter || o.transform;
	            o.cacheKey = o.cacheKey || o.url;
	            o.thumbprint = VERSION + o.thumbprint;
	            o.transport = o.transport ? callbackToDeferred(o.transport) : $.ajax;
	            return o;
	        }
	        function parseRemote(o) {
	            var defaults;
	            if (!o) {
	                return;
	            }
	            defaults = {
	                url: null,
	                cache: true,
	                prepare: null,
	                replace: null,
	                wildcard: null,
	                limiter: null,
	                rateLimitBy: "debounce",
	                rateLimitWait: 300,
	                transform: _.identity,
	                transport: null
	            };
	            o = _.isString(o) ? {
	                url: o
	            } : o;
	            o = _.mixin(defaults, o);
	            !o.url && $.error("remote requires url to be set");
	            o.transform = o.filter || o.transform;
	            o.prepare = toRemotePrepare(o);
	            o.limiter = toLimiter(o);
	            o.transport = o.transport ? callbackToDeferred(o.transport) : $.ajax;
	            delete o.replace;
	            delete o.wildcard;
	            delete o.rateLimitBy;
	            delete o.rateLimitWait;
	            return o;
	        }
	        function toRemotePrepare(o) {
	            var prepare, replace, wildcard;
	            prepare = o.prepare;
	            replace = o.replace;
	            wildcard = o.wildcard;
	            if (prepare) {
	                return prepare;
	            }
	            if (replace) {
	                prepare = prepareByReplace;
	            } else if (o.wildcard) {
	                prepare = prepareByWildcard;
	            } else {
	                prepare = idenityPrepare;
	            }
	            return prepare;
	            function prepareByReplace(query, settings) {
	                settings.url = replace(settings.url, query);
	                return settings;
	            }
	            function prepareByWildcard(query, settings) {
	                settings.url = settings.url.replace(wildcard, encodeURIComponent(query));
	                return settings;
	            }
	            function idenityPrepare(query, settings) {
	                return settings;
	            }
	        }
	        function toLimiter(o) {
	            var limiter, method, wait;
	            limiter = o.limiter;
	            method = o.rateLimitBy;
	            wait = o.rateLimitWait;
	            if (!limiter) {
	                limiter = /^throttle$/i.test(method) ? throttle(wait) : debounce(wait);
	            }
	            return limiter;
	            function debounce(wait) {
	                return function debounce(fn) {
	                    return _.debounce(fn, wait);
	                };
	            }
	            function throttle(wait) {
	                return function throttle(fn) {
	                    return _.throttle(fn, wait);
	                };
	            }
	        }
	        function callbackToDeferred(fn) {
	            return function wrapper(o) {
	                var deferred = $.Deferred();
	                fn(o, onSuccess, onError);
	                return deferred;
	                function onSuccess(resp) {
	                    _.defer(function() {
	                        deferred.resolve(resp);
	                    });
	                }
	                function onError(err) {
	                    _.defer(function() {
	                        deferred.reject(err);
	                    });
	                }
	            };
	        }
	    }();
	    var Bloodhound = function() {
	        "use strict";
	        var old;
	        old = window && window.Bloodhound;
	        function Bloodhound(o) {
	            o = oParser(o);
	            this.sorter = o.sorter;
	            this.identify = o.identify;
	            this.sufficient = o.sufficient;
	            this.local = o.local;
	            this.remote = o.remote ? new Remote(o.remote) : null;
	            this.prefetch = o.prefetch ? new Prefetch(o.prefetch) : null;
	            this.index = new SearchIndex({
	                identify: this.identify,
	                datumTokenizer: o.datumTokenizer,
	                queryTokenizer: o.queryTokenizer
	            });
	            o.initialize !== false && this.initialize();
	        }
	        Bloodhound.noConflict = function noConflict() {
	            window && (window.Bloodhound = old);
	            return Bloodhound;
	        };
	        Bloodhound.tokenizers = tokenizers;
	        _.mixin(Bloodhound.prototype, {
	            __ttAdapter: function ttAdapter() {
	                var that = this;
	                return this.remote ? withAsync : withoutAsync;
	                function withAsync(query, sync, async) {
	                    return that.search(query, sync, async);
	                }
	                function withoutAsync(query, sync) {
	                    return that.search(query, sync);
	                }
	            },
	            _loadPrefetch: function loadPrefetch() {
	                var that = this, deferred, serialized;
	                deferred = $.Deferred();
	                if (!this.prefetch) {
	                    deferred.resolve();
	                } else if (serialized = this.prefetch.fromCache()) {
	                    this.index.bootstrap(serialized);
	                    deferred.resolve();
	                } else {
	                    this.prefetch.fromNetwork(done);
	                }
	                return deferred.promise();
	                function done(err, data) {
	                    if (err) {
	                        return deferred.reject();
	                    }
	                    that.add(data);
	                    that.prefetch.store(that.index.serialize());
	                    deferred.resolve();
	                }
	            },
	            _initialize: function initialize() {
	                var that = this, deferred;
	                this.clear();
	                (this.initPromise = this._loadPrefetch()).done(addLocalToIndex);
	                return this.initPromise;
	                function addLocalToIndex() {
	                    that.add(that.local);
	                }
	            },
	            initialize: function initialize(force) {
	                return !this.initPromise || force ? this._initialize() : this.initPromise;
	            },
	            add: function add(data) {
	                this.index.add(data);
	                return this;
	            },
	            get: function get(ids) {
	                ids = _.isArray(ids) ? ids : [].slice.call(arguments);
	                return this.index.get(ids);
	            },
	            search: function search(query, sync, async) {
	                var that = this, local;
	                local = this.sorter(this.index.search(query));
	                sync(this.remote ? local.slice() : local);
	                if (this.remote && local.length < this.sufficient) {
	                    this.remote.get(query, processRemote);
	                } else if (this.remote) {
	                    this.remote.cancelLastRequest();
	                }
	                return this;
	                function processRemote(remote) {
	                    var nonDuplicates = [];
	                    _.each(remote, function(r) {
	                        !_.some(local, function(l) {
	                            return that.identify(r) === that.identify(l);
	                        }) && nonDuplicates.push(r);
	                    });
	                    async && async(nonDuplicates);
	                }
	            },
	            all: function all() {
	                return this.index.all();
	            },
	            clear: function clear() {
	                this.index.reset();
	                return this;
	            },
	            clearPrefetchCache: function clearPrefetchCache() {
	                this.prefetch && this.prefetch.clear();
	                return this;
	            },
	            clearRemoteCache: function clearRemoteCache() {
	                Transport.resetCache();
	                return this;
	            },
	            ttAdapter: function ttAdapter() {
	                return this.__ttAdapter();
	            }
	        });
	        return Bloodhound;
	    }();
	    return Bloodhound;
	});
	
	(function(root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(954) ], __WEBPACK_AMD_DEFINE_RESULT__ = function(a0) {
	            return factory(a0);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === "object") {
	        module.exports = factory(require("jquery"));
	    } else {
	        factory(jQuery);
	    }
	})(this, function($) {
	    var _ = function() {
	        "use strict";
	        return {
	            isMsie: function() {
	                return /(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
	            },
	            isBlankString: function(str) {
	                return !str || /^\s*$/.test(str);
	            },
	            escapeRegExChars: function(str) {
	                return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	            },
	            isString: function(obj) {
	                return typeof obj === "string";
	            },
	            isNumber: function(obj) {
	                return typeof obj === "number";
	            },
	            isArray: $.isArray,
	            isFunction: $.isFunction,
	            isObject: $.isPlainObject,
	            isUndefined: function(obj) {
	                return typeof obj === "undefined";
	            },
	            isElement: function(obj) {
	                return !!(obj && obj.nodeType === 1);
	            },
	            isJQuery: function(obj) {
	                return obj instanceof $;
	            },
	            toStr: function toStr(s) {
	                return _.isUndefined(s) || s === null ? "" : s + "";
	            },
	            bind: $.proxy,
	            each: function(collection, cb) {
	                $.each(collection, reverseArgs);
	                function reverseArgs(index, value) {
	                    return cb(value, index);
	                }
	            },
	            map: $.map,
	            filter: $.grep,
	            every: function(obj, test) {
	                var result = true;
	                if (!obj) {
	                    return result;
	                }
	                $.each(obj, function(key, val) {
	                    if (!(result = test.call(null, val, key, obj))) {
	                        return false;
	                    }
	                });
	                return !!result;
	            },
	            some: function(obj, test) {
	                var result = false;
	                if (!obj) {
	                    return result;
	                }
	                $.each(obj, function(key, val) {
	                    if (result = test.call(null, val, key, obj)) {
	                        return false;
	                    }
	                });
	                return !!result;
	            },
	            mixin: $.extend,
	            identity: function(x) {
	                return x;
	            },
	            clone: function(obj) {
	                return $.extend(true, {}, obj);
	            },
	            getIdGenerator: function() {
	                var counter = 0;
	                return function() {
	                    return counter++;
	                };
	            },
	            templatify: function templatify(obj) {
	                return $.isFunction(obj) ? obj : template;
	                function template() {
	                    return String(obj);
	                }
	            },
	            defer: function(fn) {
	                setTimeout(fn, 0);
	            },
	            debounce: function(func, wait, immediate) {
	                var timeout, result;
	                return function() {
	                    var context = this, args = arguments, later, callNow;
	                    later = function() {
	                        timeout = null;
	                        if (!immediate) {
	                            result = func.apply(context, args);
	                        }
	                    };
	                    callNow = immediate && !timeout;
	                    clearTimeout(timeout);
	                    timeout = setTimeout(later, wait);
	                    if (callNow) {
	                        result = func.apply(context, args);
	                    }
	                    return result;
	                };
	            },
	            throttle: function(func, wait) {
	                var context, args, timeout, result, previous, later;
	                previous = 0;
	                later = function() {
	                    previous = new Date();
	                    timeout = null;
	                    result = func.apply(context, args);
	                };
	                return function() {
	                    var now = new Date(), remaining = wait - (now - previous);
	                    context = this;
	                    args = arguments;
	                    if (remaining <= 0) {
	                        clearTimeout(timeout);
	                        timeout = null;
	                        previous = now;
	                        result = func.apply(context, args);
	                    } else if (!timeout) {
	                        timeout = setTimeout(later, remaining);
	                    }
	                    return result;
	                };
	            },
	            stringify: function(val) {
	                return _.isString(val) ? val : JSON.stringify(val);
	            },
	            noop: function() {}
	        };
	    }();
	    var WWW = function() {
	        "use strict";
	        var defaultClassNames = {
	            wrapper: "twitter-typeahead",
	            input: "tt-input",
	            hint: "tt-hint",
	            menu: "tt-menu",
	            dataset: "tt-dataset",
	            suggestion: "tt-suggestion",
	            selectable: "tt-selectable",
	            empty: "tt-empty",
	            open: "tt-open",
	            cursor: "tt-cursor",
	            highlight: "tt-highlight"
	        };
	        return build;
	        function build(o) {
	            var www, classes;
	            classes = _.mixin({}, defaultClassNames, o);
	            www = {
	                css: buildCss(),
	                classes: classes,
	                html: buildHtml(classes),
	                selectors: buildSelectors(classes)
	            };
	            return {
	                css: www.css,
	                html: www.html,
	                classes: www.classes,
	                selectors: www.selectors,
	                mixin: function(o) {
	                    _.mixin(o, www);
	                }
	            };
	        }
	        function buildHtml(c) {
	            return {
	                wrapper: '<span class="' + c.wrapper + '"></span>',
	                menu: '<div class="' + c.menu + '"></div>'
	            };
	        }
	        function buildSelectors(classes) {
	            var selectors = {};
	            _.each(classes, function(v, k) {
	                selectors[k] = "." + v;
	            });
	            return selectors;
	        }
	        function buildCss() {
	            var css = {
	                wrapper: {
	                    position: "relative",
	                    display: "inline-block"
	                },
	                hint: {
	                    position: "absolute",
	                    top: "0",
	                    left: "0",
	                    borderColor: "transparent",
	                    boxShadow: "none",
	                    opacity: "1"
	                },
	                input: {
	                    position: "relative",
	                    verticalAlign: "top",
	                    backgroundColor: "transparent"
	                },
	                inputWithNoHint: {
	                    position: "relative",
	                    verticalAlign: "top"
	                },
	                menu: {
	                    position: "absolute",
	                    top: "100%",
	                    left: "0",
	                    zIndex: "100",
	                    display: "none"
	                },
	                ltr: {
	                    left: "0",
	                    right: "auto"
	                },
	                rtl: {
	                    left: "auto",
	                    right: " 0"
	                }
	            };
	            if (_.isMsie()) {
	                _.mixin(css.input, {
	                    backgroundImage: "url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)"
	                });
	            }
	            return css;
	        }
	    }();
	    var EventBus = function() {
	        "use strict";
	        var namespace, deprecationMap;
	        namespace = "typeahead:";
	        deprecationMap = {
	            render: "rendered",
	            cursorchange: "cursorchanged",
	            select: "selected",
	            autocomplete: "autocompleted"
	        };
	        function EventBus(o) {
	            if (!o || !o.el) {
	                $.error("EventBus initialized without el");
	            }
	            this.$el = $(o.el);
	        }
	        _.mixin(EventBus.prototype, {
	            _trigger: function(type, args) {
	                var $e;
	                $e = $.Event(namespace + type);
	                (args = args || []).unshift($e);
	                this.$el.trigger.apply(this.$el, args);
	                return $e;
	            },
	            before: function(type) {
	                var args, $e;
	                args = [].slice.call(arguments, 1);
	                $e = this._trigger("before" + type, args);
	                return $e.isDefaultPrevented();
	            },
	            trigger: function(type) {
	                var deprecatedType;
	                this._trigger(type, [].slice.call(arguments, 1));
	                if (deprecatedType = deprecationMap[type]) {
	                    this._trigger(deprecatedType, [].slice.call(arguments, 1));
	                }
	            }
	        });
	        return EventBus;
	    }();
	    var EventEmitter = function() {
	        "use strict";
	        var splitter = /\s+/, nextTick = getNextTick();
	        return {
	            onSync: onSync,
	            onAsync: onAsync,
	            off: off,
	            trigger: trigger
	        };
	        function on(method, types, cb, context) {
	            var type;
	            if (!cb) {
	                return this;
	            }
	            types = types.split(splitter);
	            cb = context ? bindContext(cb, context) : cb;
	            this._callbacks = this._callbacks || {};
	            while (type = types.shift()) {
	                this._callbacks[type] = this._callbacks[type] || {
	                    sync: [],
	                    async: []
	                };
	                this._callbacks[type][method].push(cb);
	            }
	            return this;
	        }
	        function onAsync(types, cb, context) {
	            return on.call(this, "async", types, cb, context);
	        }
	        function onSync(types, cb, context) {
	            return on.call(this, "sync", types, cb, context);
	        }
	        function off(types) {
	            var type;
	            if (!this._callbacks) {
	                return this;
	            }
	            types = types.split(splitter);
	            while (type = types.shift()) {
	                delete this._callbacks[type];
	            }
	            return this;
	        }
	        function trigger(types) {
	            var type, callbacks, args, syncFlush, asyncFlush;
	            if (!this._callbacks) {
	                return this;
	            }
	            types = types.split(splitter);
	            args = [].slice.call(arguments, 1);
	            while ((type = types.shift()) && (callbacks = this._callbacks[type])) {
	                syncFlush = getFlush(callbacks.sync, this, [ type ].concat(args));
	                asyncFlush = getFlush(callbacks.async, this, [ type ].concat(args));
	                syncFlush() && nextTick(asyncFlush);
	            }
	            return this;
	        }
	        function getFlush(callbacks, context, args) {
	            return flush;
	            function flush() {
	                var cancelled;
	                for (var i = 0, len = callbacks.length; !cancelled && i < len; i += 1) {
	                    cancelled = callbacks[i].apply(context, args) === false;
	                }
	                return !cancelled;
	            }
	        }
	        function getNextTick() {
	            var nextTickFn;
	            if (window.setImmediate) {
	                nextTickFn = function nextTickSetImmediate(fn) {
	                    setImmediate(function() {
	                        fn();
	                    });
	                };
	            } else {
	                nextTickFn = function nextTickSetTimeout(fn) {
	                    setTimeout(function() {
	                        fn();
	                    }, 0);
	                };
	            }
	            return nextTickFn;
	        }
	        function bindContext(fn, context) {
	            return fn.bind ? fn.bind(context) : function() {
	                fn.apply(context, [].slice.call(arguments, 0));
	            };
	        }
	    }();
	    var highlight = function(doc) {
	        "use strict";
	        var defaults = {
	            node: null,
	            pattern: null,
	            tagName: "strong",
	            className: null,
	            wordsOnly: false,
	            caseSensitive: false
	        };
	        return function hightlight(o) {
	            var regex;
	            o = _.mixin({}, defaults, o);
	            if (!o.node || !o.pattern) {
	                return;
	            }
	            o.pattern = _.isArray(o.pattern) ? o.pattern : [ o.pattern ];
	            regex = getRegex(o.pattern, o.caseSensitive, o.wordsOnly);
	            traverse(o.node, hightlightTextNode);
	            function hightlightTextNode(textNode) {
	                var match, patternNode, wrapperNode;
	                if (match = regex.exec(textNode.data)) {
	                    wrapperNode = doc.createElement(o.tagName);
	                    o.className && (wrapperNode.className = o.className);
	                    patternNode = textNode.splitText(match.index);
	                    patternNode.splitText(match[0].length);
	                    wrapperNode.appendChild(patternNode.cloneNode(true));
	                    textNode.parentNode.replaceChild(wrapperNode, patternNode);
	                }
	                return !!match;
	            }
	            function traverse(el, hightlightTextNode) {
	                var childNode, TEXT_NODE_TYPE = 3;
	                for (var i = 0; i < el.childNodes.length; i++) {
	                    childNode = el.childNodes[i];
	                    if (childNode.nodeType === TEXT_NODE_TYPE) {
	                        i += hightlightTextNode(childNode) ? 1 : 0;
	                    } else {
	                        traverse(childNode, hightlightTextNode);
	                    }
	                }
	            }
	        };
	        function getRegex(patterns, caseSensitive, wordsOnly) {
	            var escapedPatterns = [], regexStr;
	            for (var i = 0, len = patterns.length; i < len; i++) {
	                escapedPatterns.push(_.escapeRegExChars(patterns[i]));
	            }
	            regexStr = wordsOnly ? "\\b(" + escapedPatterns.join("|") + ")\\b" : "(" + escapedPatterns.join("|") + ")";
	            return caseSensitive ? new RegExp(regexStr) : new RegExp(regexStr, "i");
	        }
	    }(window.document);
	    var Input = function() {
	        "use strict";
	        var specialKeyCodeMap;
	        specialKeyCodeMap = {
	            9: "tab",
	            27: "esc",
	            37: "left",
	            39: "right",
	            13: "enter",
	            38: "up",
	            40: "down"
	        };
	        function Input(o, www) {
	            o = o || {};
	            if (!o.input) {
	                $.error("input is missing");
	            }
	            www.mixin(this);
	            this.$hint = $(o.hint);
	            this.$input = $(o.input);
	            this.query = this.$input.val();
	            this.queryWhenFocused = this.hasFocus() ? this.query : null;
	            this.$overflowHelper = buildOverflowHelper(this.$input);
	            this._checkLanguageDirection();
	            if (this.$hint.length === 0) {
	                this.setHint = this.getHint = this.clearHint = this.clearHintIfInvalid = _.noop;
	            }
	        }
	        Input.normalizeQuery = function(str) {
	            return _.toStr(str).replace(/^\s*/g, "").replace(/\s{2,}/g, " ");
	        };
	        _.mixin(Input.prototype, EventEmitter, {
	            _onBlur: function onBlur() {
	                this.resetInputValue();
	                this.trigger("blurred");
	            },
	            _onFocus: function onFocus() {
	                this.queryWhenFocused = this.query;
	                this.trigger("focused");
	            },
	            _onKeydown: function onKeydown($e) {
	                var keyName = specialKeyCodeMap[$e.which || $e.keyCode];
	                this._managePreventDefault(keyName, $e);
	                if (keyName && this._shouldTrigger(keyName, $e)) {
	                    this.trigger(keyName + "Keyed", $e);
	                }
	            },
	            _onInput: function onInput() {
	                this._setQuery(this.getInputValue());
	                this.clearHintIfInvalid();
	                this._checkLanguageDirection();
	            },
	            _managePreventDefault: function managePreventDefault(keyName, $e) {
	                var preventDefault;
	                switch (keyName) {
	                  case "up":
	                  case "down":
	                    preventDefault = !withModifier($e);
	                    break;
	
	                  default:
	                    preventDefault = false;
	                }
	                preventDefault && $e.preventDefault();
	            },
	            _shouldTrigger: function shouldTrigger(keyName, $e) {
	                var trigger;
	                switch (keyName) {
	                  case "tab":
	                    trigger = !withModifier($e);
	                    break;
	
	                  default:
	                    trigger = true;
	                }
	                return trigger;
	            },
	            _checkLanguageDirection: function checkLanguageDirection() {
	                var dir = (this.$input.css("direction") || "ltr").toLowerCase();
	                if (this.dir !== dir) {
	                    this.dir = dir;
	                    this.$hint.attr("dir", dir);
	                    this.trigger("langDirChanged", dir);
	                }
	            },
	            _setQuery: function setQuery(val, silent) {
	                var areEquivalent, hasDifferentWhitespace;
	                areEquivalent = areQueriesEquivalent(val, this.query);
	                hasDifferentWhitespace = areEquivalent ? this.query.length !== val.length : false;
	                this.query = val;
	                if (!silent && !areEquivalent) {
	                    this.trigger("queryChanged", this.query);
	                } else if (!silent && hasDifferentWhitespace) {
	                    this.trigger("whitespaceChanged", this.query);
	                }
	            },
	            bind: function() {
	                var that = this, onBlur, onFocus, onKeydown, onInput;
	                onBlur = _.bind(this._onBlur, this);
	                onFocus = _.bind(this._onFocus, this);
	                onKeydown = _.bind(this._onKeydown, this);
	                onInput = _.bind(this._onInput, this);
	                this.$input.on("blur.tt", onBlur).on("focus.tt", onFocus).on("keydown.tt", onKeydown);
	                if (!_.isMsie() || _.isMsie() > 9) {
	                    this.$input.on("input.tt", onInput);
	                } else {
	                    this.$input.on("keydown.tt keypress.tt cut.tt paste.tt", function($e) {
	                        if (specialKeyCodeMap[$e.which || $e.keyCode]) {
	                            return;
	                        }
	                        _.defer(_.bind(that._onInput, that, $e));
	                    });
	                }
	                return this;
	            },
	            focus: function focus() {
	                this.$input.focus();
	            },
	            blur: function blur() {
	                this.$input.blur();
	            },
	            getLangDir: function getLangDir() {
	                return this.dir;
	            },
	            getQuery: function getQuery() {
	                return this.query || "";
	            },
	            setQuery: function setQuery(val, silent) {
	                this.setInputValue(val);
	                this._setQuery(val, silent);
	            },
	            hasQueryChangedSinceLastFocus: function hasQueryChangedSinceLastFocus() {
	                return this.query !== this.queryWhenFocused;
	            },
	            getInputValue: function getInputValue() {
	                return this.$input.val();
	            },
	            setInputValue: function setInputValue(value) {
	                this.$input.val(value);
	                this.clearHintIfInvalid();
	                this._checkLanguageDirection();
	            },
	            resetInputValue: function resetInputValue() {
	                this.setInputValue(this.query);
	            },
	            getHint: function getHint() {
	                return this.$hint.val();
	            },
	            setHint: function setHint(value) {
	                this.$hint.val(value);
	            },
	            clearHint: function clearHint() {
	                this.setHint("");
	            },
	            clearHintIfInvalid: function clearHintIfInvalid() {
	                var val, hint, valIsPrefixOfHint, isValid;
	                val = this.getInputValue();
	                hint = this.getHint();
	                valIsPrefixOfHint = val !== hint && hint.indexOf(val) === 0;
	                isValid = val !== "" && valIsPrefixOfHint && !this.hasOverflow();
	                !isValid && this.clearHint();
	            },
	            hasFocus: function hasFocus() {
	                return this.$input.is(":focus");
	            },
	            hasOverflow: function hasOverflow() {
	                var constraint = this.$input.width() - 2;
	                this.$overflowHelper.text(this.getInputValue());
	                return this.$overflowHelper.width() >= constraint;
	            },
	            isCursorAtEnd: function() {
	                var valueLength, selectionStart, range;
	                valueLength = this.$input.val().length;
	                selectionStart = this.$input[0].selectionStart;
	                if (_.isNumber(selectionStart)) {
	                    return selectionStart === valueLength;
	                } else if (document.selection) {
	                    range = document.selection.createRange();
	                    range.moveStart("character", -valueLength);
	                    return valueLength === range.text.length;
	                }
	                return true;
	            },
	            destroy: function destroy() {
	                this.$hint.off(".tt");
	                this.$input.off(".tt");
	                this.$overflowHelper.remove();
	                this.$hint = this.$input = this.$overflowHelper = $("<div>");
	            }
	        });
	        return Input;
	        function buildOverflowHelper($input) {
	            return $('<pre aria-hidden="true"></pre>').css({
	                position: "absolute",
	                visibility: "hidden",
	                whiteSpace: "pre",
	                fontFamily: $input.css("font-family"),
	                fontSize: $input.css("font-size"),
	                fontStyle: $input.css("font-style"),
	                fontVariant: $input.css("font-variant"),
	                fontWeight: $input.css("font-weight"),
	                wordSpacing: $input.css("word-spacing"),
	                letterSpacing: $input.css("letter-spacing"),
	                textIndent: $input.css("text-indent"),
	                textRendering: $input.css("text-rendering"),
	                textTransform: $input.css("text-transform")
	            }).insertAfter($input);
	        }
	        function areQueriesEquivalent(a, b) {
	            return Input.normalizeQuery(a) === Input.normalizeQuery(b);
	        }
	        function withModifier($e) {
	            return $e.altKey || $e.ctrlKey || $e.metaKey || $e.shiftKey;
	        }
	    }();
	    var Dataset = function() {
	        "use strict";
	        var keys, nameGenerator;
	        keys = {
	            val: "tt-selectable-display",
	            obj: "tt-selectable-object"
	        };
	        nameGenerator = _.getIdGenerator();
	        function Dataset(o, www) {
	            o = o || {};
	            o.templates = o.templates || {};
	            o.templates.notFound = o.templates.notFound || o.templates.empty;
	            if (!o.source) {
	                $.error("missing source");
	            }
	            if (!o.node) {
	                $.error("missing node");
	            }
	            if (o.name && !isValidName(o.name)) {
	                $.error("invalid dataset name: " + o.name);
	            }
	            www.mixin(this);
	            this.highlight = !!o.highlight;
	            this.name = o.name || nameGenerator();
	            this.limit = o.limit || 5;
	            this.displayFn = getDisplayFn(o.display || o.displayKey);
	            this.templates = getTemplates(o.templates, this.displayFn);
	            this.source = o.source.__ttAdapter ? o.source.__ttAdapter() : o.source;
	            this.async = _.isUndefined(o.async) ? this.source.length > 2 : !!o.async;
	            this._resetLastSuggestion();
	            this.$el = $(o.node).addClass(this.classes.dataset).addClass(this.classes.dataset + "-" + this.name);
	        }
	        Dataset.extractData = function extractData(el) {
	            var $el = $(el);
	            if ($el.data(keys.obj)) {
	                return {
	                    val: $el.data(keys.val) || "",
	                    obj: $el.data(keys.obj) || null
	                };
	            }
	            return null;
	        };
	        _.mixin(Dataset.prototype, EventEmitter, {
	            _overwrite: function overwrite(query, suggestions) {
	                suggestions = suggestions || [];
	                if (suggestions.length) {
	                    this._renderSuggestions(query, suggestions);
	                } else if (this.async && this.templates.pending) {
	                    this._renderPending(query);
	                } else if (!this.async && this.templates.notFound) {
	                    this._renderNotFound(query);
	                } else {
	                    this._empty();
	                }
	                this.trigger("rendered", this.name, suggestions, false);
	            },
	            _append: function append(query, suggestions) {
	                suggestions = suggestions || [];
	                if (suggestions.length && this.$lastSuggestion.length) {
	                    this._appendSuggestions(query, suggestions);
	                } else if (suggestions.length) {
	                    this._renderSuggestions(query, suggestions);
	                } else if (!this.$lastSuggestion.length && this.templates.notFound) {
	                    this._renderNotFound(query);
	                }
	                this.trigger("rendered", this.name, suggestions, true);
	            },
	            _renderSuggestions: function renderSuggestions(query, suggestions) {
	                var $fragment;
	                $fragment = this._getSuggestionsFragment(query, suggestions);
	                this.$lastSuggestion = $fragment.children().last();
	                this.$el.html($fragment).prepend(this._getHeader(query, suggestions)).append(this._getFooter(query, suggestions));
	            },
	            _appendSuggestions: function appendSuggestions(query, suggestions) {
	                var $fragment, $lastSuggestion;
	                $fragment = this._getSuggestionsFragment(query, suggestions);
	                $lastSuggestion = $fragment.children().last();
	                this.$lastSuggestion.after($fragment);
	                this.$lastSuggestion = $lastSuggestion;
	            },
	            _renderPending: function renderPending(query) {
	                var template = this.templates.pending;
	                this._resetLastSuggestion();
	                template && this.$el.html(template({
	                    query: query,
	                    dataset: this.name
	                }));
	            },
	            _renderNotFound: function renderNotFound(query) {
	                var template = this.templates.notFound;
	                this._resetLastSuggestion();
	                template && this.$el.html(template({
	                    query: query,
	                    dataset: this.name
	                }));
	            },
	            _empty: function empty() {
	                this.$el.empty();
	                this._resetLastSuggestion();
	            },
	            _getSuggestionsFragment: function getSuggestionsFragment(query, suggestions) {
	                var that = this, fragment;
	                fragment = document.createDocumentFragment();
	                _.each(suggestions, function getSuggestionNode(suggestion) {
	                    var $el, context;
	                    context = that._injectQuery(query, suggestion);
	                    $el = $(that.templates.suggestion(context)).data(keys.obj, suggestion).data(keys.val, that.displayFn(suggestion)).addClass(that.classes.suggestion + " " + that.classes.selectable);
	                    fragment.appendChild($el[0]);
	                });
	                this.highlight && highlight({
	                    className: this.classes.highlight,
	                    node: fragment,
	                    pattern: query
	                });
	                return $(fragment);
	            },
	            _getFooter: function getFooter(query, suggestions) {
	                return this.templates.footer ? this.templates.footer({
	                    query: query,
	                    suggestions: suggestions,
	                    dataset: this.name
	                }) : null;
	            },
	            _getHeader: function getHeader(query, suggestions) {
	                return this.templates.header ? this.templates.header({
	                    query: query,
	                    suggestions: suggestions,
	                    dataset: this.name
	                }) : null;
	            },
	            _resetLastSuggestion: function resetLastSuggestion() {
	                this.$lastSuggestion = $();
	            },
	            _injectQuery: function injectQuery(query, obj) {
	                return _.isObject(obj) ? _.mixin({
	                    _query: query
	                }, obj) : obj;
	            },
	            update: function update(query) {
	                var that = this, canceled = false, syncCalled = false, rendered = 0;
	                this.cancel();
	                this.cancel = function cancel() {
	                    canceled = true;
	                    that.cancel = $.noop;
	                    that.async && that.trigger("asyncCanceled", query);
	                };
	                this.source(query, sync, async);
	                !syncCalled && sync([]);
	                function sync(suggestions) {
	                    if (syncCalled) {
	                        return;
	                    }
	                    syncCalled = true;
	                    suggestions = (suggestions || []).slice(0, that.limit);
	                    rendered = suggestions.length;
	                    that._overwrite(query, suggestions);
	                    if (rendered < that.limit && that.async) {
	                        that.trigger("asyncRequested", query);
	                    }
	                }
	                function async(suggestions) {
	                    suggestions = suggestions || [];
	                    if (!canceled && rendered < that.limit) {
	                        that.cancel = $.noop;
	                        rendered += suggestions.length;
	                        that._append(query, suggestions.slice(0, that.limit - rendered));
	                        that.async && that.trigger("asyncReceived", query);
	                    }
	                }
	            },
	            cancel: $.noop,
	            clear: function clear() {
	                this._empty();
	                this.cancel();
	                this.trigger("cleared");
	            },
	            isEmpty: function isEmpty() {
	                return this.$el.is(":empty");
	            },
	            destroy: function destroy() {
	                this.$el = $("<div>");
	            }
	        });
	        return Dataset;
	        function getDisplayFn(display) {
	            display = display || _.stringify;
	            return _.isFunction(display) ? display : displayFn;
	            function displayFn(obj) {
	                return obj[display];
	            }
	        }
	        function getTemplates(templates, displayFn) {
	            return {
	                notFound: templates.notFound && _.templatify(templates.notFound),
	                pending: templates.pending && _.templatify(templates.pending),
	                header: templates.header && _.templatify(templates.header),
	                footer: templates.footer && _.templatify(templates.footer),
	                suggestion: templates.suggestion || suggestionTemplate
	            };
	            function suggestionTemplate(context) {
	                return $("<div>").text(displayFn(context));
	            }
	        }
	        function isValidName(str) {
	            return /^[_a-zA-Z0-9-]+$/.test(str);
	        }
	    }();
	    var Menu = function() {
	        "use strict";
	        function Menu(o, www) {
	            var that = this;
	            o = o || {};
	            if (!o.node) {
	                $.error("node is required");
	            }
	            www.mixin(this);
	            this.$node = $(o.node);
	            this.query = null;
	            this.datasets = _.map(o.datasets, initializeDataset);
	            function initializeDataset(oDataset) {
	                var node = that.$node.find(oDataset.node).first();
	                oDataset.node = node.length ? node : $("<div>").appendTo(that.$node);
	                return new Dataset(oDataset, www);
	            }
	        }
	        _.mixin(Menu.prototype, EventEmitter, {
	            _onSelectableClick: function onSelectableClick($e) {
	                this.trigger("selectableClicked", $($e.currentTarget));
	            },
	            _onRendered: function onRendered(type, dataset, suggestions, async) {
	                this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty());
	                this.trigger("datasetRendered", dataset, suggestions, async);
	            },
	            _onCleared: function onCleared() {
	                this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty());
	                this.trigger("datasetCleared");
	            },
	            _propagate: function propagate() {
	                this.trigger.apply(this, arguments);
	            },
	            _allDatasetsEmpty: function allDatasetsEmpty() {
	                return _.every(this.datasets, isDatasetEmpty);
	                function isDatasetEmpty(dataset) {
	                    return dataset.isEmpty();
	                }
	            },
	            _getSelectables: function getSelectables() {
	                return this.$node.find(this.selectors.selectable);
	            },
	            _removeCursor: function _removeCursor() {
	                var $selectable = this.getActiveSelectable();
	                $selectable && $selectable.removeClass(this.classes.cursor);
	            },
	            _ensureVisible: function ensureVisible($el) {
	                var elTop, elBottom, nodeScrollTop, nodeHeight;
	                elTop = $el.position().top;
	                elBottom = elTop + $el.outerHeight(true);
	                nodeScrollTop = this.$node.scrollTop();
	                nodeHeight = this.$node.height() + parseInt(this.$node.css("paddingTop"), 10) + parseInt(this.$node.css("paddingBottom"), 10);
	                if (elTop < 0) {
	                    this.$node.scrollTop(nodeScrollTop + elTop);
	                } else if (nodeHeight < elBottom) {
	                    this.$node.scrollTop(nodeScrollTop + (elBottom - nodeHeight));
	                }
	            },
	            bind: function() {
	                var that = this, onSelectableClick;
	                onSelectableClick = _.bind(this._onSelectableClick, this);
	                this.$node.on("click.tt", this.selectors.selectable, onSelectableClick);
	                _.each(this.datasets, function(dataset) {
	                    dataset.onSync("asyncRequested", that._propagate, that).onSync("asyncCanceled", that._propagate, that).onSync("asyncReceived", that._propagate, that).onSync("rendered", that._onRendered, that).onSync("cleared", that._onCleared, that);
	                });
	                return this;
	            },
	            isOpen: function isOpen() {
	                return this.$node.hasClass(this.classes.open);
	            },
	            open: function open() {
	                this.$node.addClass(this.classes.open);
	            },
	            close: function close() {
	                this.$node.removeClass(this.classes.open);
	                this._removeCursor();
	            },
	            setLanguageDirection: function setLanguageDirection(dir) {
	                this.$node.attr("dir", dir);
	            },
	            selectableRelativeToCursor: function selectableRelativeToCursor(delta) {
	                var $selectables, $oldCursor, oldIndex, newIndex;
	                $oldCursor = this.getActiveSelectable();
	                $selectables = this._getSelectables();
	                oldIndex = $oldCursor ? $selectables.index($oldCursor) : -1;
	                newIndex = oldIndex + delta;
	                newIndex = (newIndex + 1) % ($selectables.length + 1) - 1;
	                newIndex = newIndex < -1 ? $selectables.length - 1 : newIndex;
	                return newIndex === -1 ? null : $selectables.eq(newIndex);
	            },
	            setCursor: function setCursor($selectable) {
	                this._removeCursor();
	                if ($selectable = $selectable && $selectable.first()) {
	                    $selectable.addClass(this.classes.cursor);
	                    this._ensureVisible($selectable);
	                }
	            },
	            getSelectableData: function getSelectableData($el) {
	                return $el && $el.length ? Dataset.extractData($el) : null;
	            },
	            getActiveSelectable: function getActiveSelectable() {
	                var $selectable = this._getSelectables().filter(this.selectors.cursor).first();
	                return $selectable.length ? $selectable : null;
	            },
	            getTopSelectable: function getTopSelectable() {
	                var $selectable = this._getSelectables().first();
	                return $selectable.length ? $selectable : null;
	            },
	            update: function update(query) {
	                var isValidUpdate = query !== this.query;
	                if (isValidUpdate) {
	                    this.query = query;
	                    _.each(this.datasets, updateDataset);
	                }
	                return isValidUpdate;
	                function updateDataset(dataset) {
	                    dataset.update(query);
	                }
	            },
	            empty: function empty() {
	                _.each(this.datasets, clearDataset);
	                this.query = null;
	                this.$node.addClass(this.classes.empty);
	                function clearDataset(dataset) {
	                    dataset.clear();
	                }
	            },
	            destroy: function destroy() {
	                this.$node.off(".tt");
	                this.$node = $("<div>");
	                _.each(this.datasets, destroyDataset);
	                function destroyDataset(dataset) {
	                    dataset.destroy();
	                }
	            }
	        });
	        return Menu;
	    }();
	    var DefaultMenu = function() {
	        "use strict";
	        var s = Menu.prototype;
	        function DefaultMenu() {
	            Menu.apply(this, [].slice.call(arguments, 0));
	        }
	        _.mixin(DefaultMenu.prototype, Menu.prototype, {
	            open: function open() {
	                !this._allDatasetsEmpty() && this._show();
	                return s.open.apply(this, [].slice.call(arguments, 0));
	            },
	            close: function close() {
	                this._hide();
	                return s.close.apply(this, [].slice.call(arguments, 0));
	            },
	            _onRendered: function onRendered() {
	                if (this._allDatasetsEmpty()) {
	                    this._hide();
	                } else {
	                    this.isOpen() && this._show();
	                }
	                return s._onRendered.apply(this, [].slice.call(arguments, 0));
	            },
	            _onCleared: function onCleared() {
	                if (this._allDatasetsEmpty()) {
	                    this._hide();
	                } else {
	                    this.isOpen() && this._show();
	                }
	                return s._onCleared.apply(this, [].slice.call(arguments, 0));
	            },
	            setLanguageDirection: function setLanguageDirection(dir) {
	                this.$node.css(dir === "ltr" ? this.css.ltr : this.css.rtl);
	                return s.setLanguageDirection.apply(this, [].slice.call(arguments, 0));
	            },
	            _hide: function hide() {
	                this.$node.hide();
	            },
	            _show: function show() {
	                this.$node.css("display", "block");
	            }
	        });
	        return DefaultMenu;
	    }();
	    var Typeahead = function() {
	        "use strict";
	        function Typeahead(o, www) {
	            var onFocused, onBlurred, onEnterKeyed, onTabKeyed, onEscKeyed, onUpKeyed, onDownKeyed, onLeftKeyed, onRightKeyed, onQueryChanged, onWhitespaceChanged;
	            o = o || {};
	            if (!o.input) {
	                $.error("missing input");
	            }
	            if (!o.menu) {
	                $.error("missing menu");
	            }
	            if (!o.eventBus) {
	                $.error("missing event bus");
	            }
	            www.mixin(this);
	            this.eventBus = o.eventBus;
	            this.minLength = _.isNumber(o.minLength) ? o.minLength : 1;
	            this.input = o.input;
	            this.menu = o.menu;
	            this.enabled = true;
	            this.active = false;
	            this.input.hasFocus() && this.activate();
	            this.dir = this.input.getLangDir();
	            this._hacks();
	            this.menu.bind().onSync("selectableClicked", this._onSelectableClicked, this).onSync("asyncRequested", this._onAsyncRequested, this).onSync("asyncCanceled", this._onAsyncCanceled, this).onSync("asyncReceived", this._onAsyncReceived, this).onSync("datasetRendered", this._onDatasetRendered, this).onSync("datasetCleared", this._onDatasetCleared, this);
	            onFocused = c(this, "activate", "open", "_onFocused");
	            onBlurred = c(this, "deactivate", "_onBlurred");
	            onEnterKeyed = c(this, "isActive", "isOpen", "_onEnterKeyed");
	            onTabKeyed = c(this, "isActive", "isOpen", "_onTabKeyed");
	            onEscKeyed = c(this, "isActive", "_onEscKeyed");
	            onUpKeyed = c(this, "isActive", "open", "_onUpKeyed");
	            onDownKeyed = c(this, "isActive", "open", "_onDownKeyed");
	            onLeftKeyed = c(this, "isActive", "isOpen", "_onLeftKeyed");
	            onRightKeyed = c(this, "isActive", "isOpen", "_onRightKeyed");
	            onQueryChanged = c(this, "_openIfActive", "_onQueryChanged");
	            onWhitespaceChanged = c(this, "_openIfActive", "_onWhitespaceChanged");
	            this.input.bind().onSync("focused", onFocused, this).onSync("blurred", onBlurred, this).onSync("enterKeyed", onEnterKeyed, this).onSync("tabKeyed", onTabKeyed, this).onSync("escKeyed", onEscKeyed, this).onSync("upKeyed", onUpKeyed, this).onSync("downKeyed", onDownKeyed, this).onSync("leftKeyed", onLeftKeyed, this).onSync("rightKeyed", onRightKeyed, this).onSync("queryChanged", onQueryChanged, this).onSync("whitespaceChanged", onWhitespaceChanged, this).onSync("langDirChanged", this._onLangDirChanged, this);
	        }
	        _.mixin(Typeahead.prototype, {
	            _hacks: function hacks() {
	                var $input, $menu;
	                $input = this.input.$input || $("<div>");
	                $menu = this.menu.$node || $("<div>");
	                $input.on("blur.tt", function($e) {
	                    var active, isActive, hasActive;
	                    active = document.activeElement;
	                    isActive = $menu.is(active);
	                    hasActive = $menu.has(active).length > 0;
	                    if (_.isMsie() && (isActive || hasActive)) {
	                        $e.preventDefault();
	                        $e.stopImmediatePropagation();
	                        _.defer(function() {
	                            $input.focus();
	                        });
	                    }
	                });
	                $menu.on("mousedown.tt", function($e) {
	                    $e.preventDefault();
	                });
	            },
	            _onSelectableClicked: function onSelectableClicked(type, $el) {
	                this.select($el);
	            },
	            _onDatasetCleared: function onDatasetCleared() {
	                this._updateHint();
	            },
	            _onDatasetRendered: function onDatasetRendered(type, dataset, suggestions, async) {
	                this._updateHint();
	                this.eventBus.trigger("render", suggestions, async, dataset);
	            },
	            _onAsyncRequested: function onAsyncRequested(type, dataset, query) {
	                this.eventBus.trigger("asyncrequest", query, dataset);
	            },
	            _onAsyncCanceled: function onAsyncCanceled(type, dataset, query) {
	                this.eventBus.trigger("asynccancel", query, dataset);
	            },
	            _onAsyncReceived: function onAsyncReceived(type, dataset, query) {
	                this.eventBus.trigger("asyncreceive", query, dataset);
	            },
	            _onFocused: function onFocused() {
	                this._minLengthMet() && this.menu.update(this.input.getQuery());
	            },
	            _onBlurred: function onBlurred() {
	                if (this.input.hasQueryChangedSinceLastFocus()) {
	                    this.eventBus.trigger("change", this.input.getQuery());
	                }
	            },
	            _onEnterKeyed: function onEnterKeyed(type, $e) {
	                var $selectable;
	                if ($selectable = this.menu.getActiveSelectable()) {
	                    this.select($selectable) && $e.preventDefault();
	                }
	            },
	            _onTabKeyed: function onTabKeyed(type, $e) {
	                var $selectable;
	                if ($selectable = this.menu.getActiveSelectable()) {
	                    this.select($selectable) && $e.preventDefault();
	                } else if ($selectable = this.menu.getTopSelectable()) {
	                    this.autocomplete($selectable) && $e.preventDefault();
	                }
	            },
	            _onEscKeyed: function onEscKeyed() {
	                this.close();
	            },
	            _onUpKeyed: function onUpKeyed() {
	                this.moveCursor(-1);
	            },
	            _onDownKeyed: function onDownKeyed() {
	                this.moveCursor(+1);
	            },
	            _onLeftKeyed: function onLeftKeyed() {
	                if (this.dir === "rtl" && this.input.isCursorAtEnd()) {
	                    this.autocomplete(this.menu.getTopSelectable());
	                }
	            },
	            _onRightKeyed: function onRightKeyed() {
	                if (this.dir === "ltr" && this.input.isCursorAtEnd()) {
	                    this.autocomplete(this.menu.getTopSelectable());
	                }
	            },
	            _onQueryChanged: function onQueryChanged(e, query) {
	                this._minLengthMet(query) ? this.menu.update(query) : this.menu.empty();
	            },
	            _onWhitespaceChanged: function onWhitespaceChanged() {
	                this._updateHint();
	            },
	            _onLangDirChanged: function onLangDirChanged(e, dir) {
	                if (this.dir !== dir) {
	                    this.dir = dir;
	                    this.menu.setLanguageDirection(dir);
	                }
	            },
	            _openIfActive: function openIfActive() {
	                this.isActive() && this.open();
	            },
	            _minLengthMet: function minLengthMet(query) {
	                query = _.isString(query) ? query : this.input.getQuery() || "";
	                return query.length >= this.minLength;
	            },
	            _updateHint: function updateHint() {
	                var $selectable, data, val, query, escapedQuery, frontMatchRegEx, match;
	                $selectable = this.menu.getTopSelectable();
	                data = this.menu.getSelectableData($selectable);
	                val = this.input.getInputValue();
	                if (data && !_.isBlankString(val) && !this.input.hasOverflow()) {
	                    query = Input.normalizeQuery(val);
	                    escapedQuery = _.escapeRegExChars(query);
	                    frontMatchRegEx = new RegExp("^(?:" + escapedQuery + ")(.+$)", "i");
	                    match = frontMatchRegEx.exec(data.val);
	                    match && this.input.setHint(val + match[1]);
	                } else {
	                    this.input.clearHint();
	                }
	            },
	            isEnabled: function isEnabled() {
	                return this.enabled;
	            },
	            enable: function enable() {
	                this.enabled = true;
	            },
	            disable: function disable() {
	                this.enabled = false;
	            },
	            isActive: function isActive() {
	                return this.active;
	            },
	            activate: function activate() {
	                if (this.isActive()) {
	                    return true;
	                } else if (!this.isEnabled() || this.eventBus.before("active")) {
	                    return false;
	                } else {
	                    this.active = true;
	                    this.eventBus.trigger("active");
	                    return true;
	                }
	            },
	            deactivate: function deactivate() {
	                if (!this.isActive()) {
	                    return true;
	                } else if (this.eventBus.before("idle")) {
	                    return false;
	                } else {
	                    this.active = false;
	                    this.close();
	                    this.eventBus.trigger("idle");
	                    return true;
	                }
	            },
	            isOpen: function isOpen() {
	                return this.menu.isOpen();
	            },
	            open: function open() {
	                if (!this.isOpen() && !this.eventBus.before("open")) {
	                    this.menu.open();
	                    this._updateHint();
	                    this.eventBus.trigger("open");
	                }
	                return this.isOpen();
	            },
	            close: function close() {
	                if (this.isOpen() && !this.eventBus.before("close")) {
	                    this.menu.close();
	                    this.input.clearHint();
	                    this.input.resetInputValue();
	                    this.eventBus.trigger("close");
	                }
	                return !this.isOpen();
	            },
	            setVal: function setVal(val) {
	                this.input.setQuery(_.toStr(val));
	            },
	            getVal: function getVal() {
	                return this.input.getQuery();
	            },
	            select: function select($selectable) {
	                var data = this.menu.getSelectableData($selectable);
	                if (data && !this.eventBus.before("select", data.obj)) {
	                    this.input.setQuery(data.val, true);
	                    this.eventBus.trigger("select", data.obj);
	                    this.close();
	                    return true;
	                }
	                return false;
	            },
	            autocomplete: function autocomplete($selectable) {
	                var query, data, isValid;
	                query = this.input.getQuery();
	                data = this.menu.getSelectableData($selectable);
	                isValid = data && query !== data.val;
	                if (isValid && !this.eventBus.before("autocomplete", data.obj)) {
	                    this.input.setQuery(data.val);
	                    this.eventBus.trigger("autocomplete", data.obj);
	                    return true;
	                }
	                return false;
	            },
	            moveCursor: function moveCursor(delta) {
	                var query, $candidate, data, payload, cancelMove;
	                query = this.input.getQuery();
	                $candidate = this.menu.selectableRelativeToCursor(delta);
	                data = this.menu.getSelectableData($candidate);
	                payload = data ? data.obj : null;
	                cancelMove = this._minLengthMet() && this.menu.update(query);
	                if (!cancelMove && !this.eventBus.before("cursorchange", payload)) {
	                    this.menu.setCursor($candidate);
	                    if (data) {
	                        this.input.setInputValue(data.val);
	                    } else {
	                        this.input.resetInputValue();
	                        this._updateHint();
	                    }
	                    this.eventBus.trigger("cursorchange", payload);
	                    return true;
	                }
	                return false;
	            },
	            destroy: function destroy() {
	                this.input.destroy();
	                this.menu.destroy();
	            }
	        });
	        return Typeahead;
	        function c(ctx) {
	            var methods = [].slice.call(arguments, 1);
	            return function() {
	                var args = [].slice.call(arguments);
	                _.each(methods, function(method) {
	                    return ctx[method].apply(ctx, args);
	                });
	            };
	        }
	    }();
	    (function() {
	        "use strict";
	        var old, keys, methods;
	        old = $.fn.typeahead;
	        keys = {
	            www: "tt-www",
	            attrs: "tt-attrs",
	            typeahead: "tt-typeahead"
	        };
	        methods = {
	            initialize: function initialize(o, datasets) {
	                var www;
	                datasets = _.isArray(datasets) ? datasets : [].slice.call(arguments, 1);
	                o = o || {};
	                www = WWW(o.classNames);
	                return this.each(attach);
	                function attach() {
	                    var $input, $wrapper, $hint, $menu, defaultHint, defaultMenu, eventBus, input, menu, typeahead, MenuConstructor;
	                    _.each(datasets, function(d) {
	                        d.highlight = !!o.highlight;
	                    });
	                    $input = $(this);
	                    $wrapper = $(www.html.wrapper);
	                    $hint = $elOrNull(o.hint);
	                    $menu = $elOrNull(o.menu);
	                    defaultHint = o.hint !== false && !$hint;
	                    defaultMenu = o.menu !== false && !$menu;
	                    defaultHint && ($hint = buildHintFromInput($input, www));
	                    defaultMenu && ($menu = $(www.html.menu).css(www.css.menu));
	                    $hint && $hint.val("");
	                    $input = prepInput($input, www);
	                    if (defaultHint || defaultMenu) {
	                        $wrapper.css(www.css.wrapper);
	                        $input.css(defaultHint ? www.css.input : www.css.inputWithNoHint);
	                        $input.wrap($wrapper).parent().prepend(defaultHint ? $hint : null).append(defaultMenu ? $menu : null);
	                    }
	                    MenuConstructor = defaultMenu ? DefaultMenu : Menu;
	                    eventBus = new EventBus({
	                        el: $input
	                    });
	                    input = new Input({
	                        hint: $hint,
	                        input: $input
	                    }, www);
	                    menu = new MenuConstructor({
	                        node: $menu,
	                        datasets: datasets
	                    }, www);
	                    typeahead = new Typeahead({
	                        input: input,
	                        menu: menu,
	                        eventBus: eventBus,
	                        minLength: o.minLength
	                    }, www);
	                    $input.data(keys.www, www);
	                    $input.data(keys.typeahead, typeahead);
	                }
	            },
	            isEnabled: function isEnabled() {
	                var enabled;
	                ttEach(this.first(), function(t) {
	                    enabled = t.isEnabled();
	                });
	                return enabled;
	            },
	            enable: function enable() {
	                ttEach(this, function(t) {
	                    t.enable();
	                });
	                return this;
	            },
	            disable: function disable() {
	                ttEach(this, function(t) {
	                    t.disable();
	                });
	                return this;
	            },
	            isActive: function isActive() {
	                var active;
	                ttEach(this.first(), function(t) {
	                    active = t.isActive();
	                });
	                return active;
	            },
	            activate: function activate() {
	                ttEach(this, function(t) {
	                    t.activate();
	                });
	                return this;
	            },
	            deactivate: function deactivate() {
	                ttEach(this, function(t) {
	                    t.deactivate();
	                });
	                return this;
	            },
	            isOpen: function isOpen() {
	                var open;
	                ttEach(this.first(), function(t) {
	                    open = t.isOpen();
	                });
	                return open;
	            },
	            open: function open() {
	                ttEach(this, function(t) {
	                    t.open();
	                });
	                return this;
	            },
	            close: function close() {
	                ttEach(this, function(t) {
	                    t.close();
	                });
	                return this;
	            },
	            select: function select(el) {
	                var success = false, $el = $(el);
	                ttEach(this.first(), function(t) {
	                    success = t.select($el);
	                });
	                return success;
	            },
	            autocomplete: function autocomplete(el) {
	                var success = false, $el = $(el);
	                ttEach(this.first(), function(t) {
	                    success = t.autocomplete($el);
	                });
	                return success;
	            },
	            moveCursor: function moveCursoe(delta) {
	                var success = false;
	                ttEach(this.first(), function(t) {
	                    success = t.moveCursor(delta);
	                });
	                return success;
	            },
	            val: function val(newVal) {
	                var query;
	                if (!arguments.length) {
	                    ttEach(this.first(), function(t) {
	                        query = t.getVal();
	                    });
	                    return query;
	                } else {
	                    ttEach(this, function(t) {
	                        t.setVal(newVal);
	                    });
	                    return this;
	                }
	            },
	            destroy: function destroy() {
	                ttEach(this, function(typeahead, $input) {
	                    revert($input);
	                    typeahead.destroy();
	                });
	                return this;
	            }
	        };
	        $.fn.typeahead = function(method) {
	            if (methods[method]) {
	                return methods[method].apply(this, [].slice.call(arguments, 1));
	            } else {
	                return methods.initialize.apply(this, arguments);
	            }
	        };
	        $.fn.typeahead.noConflict = function noConflict() {
	            $.fn.typeahead = old;
	            return this;
	        };
	        function ttEach($els, fn) {
	            $els.each(function() {
	                var $input = $(this), typeahead;
	                (typeahead = $input.data(keys.typeahead)) && fn(typeahead, $input);
	            });
	        }
	        function buildHintFromInput($input, www) {
	            return $input.clone().addClass(www.classes.hint).removeData().css(www.css.hint).css(getBackgroundStyles($input)).prop("readonly", true).removeAttr("id name placeholder required").attr({
	                autocomplete: "off",
	                spellcheck: "false",
	                tabindex: -1
	            });
	        }
	        function prepInput($input, www) {
	            $input.data(keys.attrs, {
	                dir: $input.attr("dir"),
	                autocomplete: $input.attr("autocomplete"),
	                spellcheck: $input.attr("spellcheck"),
	                style: $input.attr("style")
	            });
	            $input.addClass(www.classes.input).attr({
	                autocomplete: "off",
	                spellcheck: false
	            });
	            try {
	                !$input.attr("dir") && $input.attr("dir", "auto");
	            } catch (e) {}
	            return $input;
	        }
	        function getBackgroundStyles($el) {
	            return {
	                backgroundAttachment: $el.css("background-attachment"),
	                backgroundClip: $el.css("background-clip"),
	                backgroundColor: $el.css("background-color"),
	                backgroundImage: $el.css("background-image"),
	                backgroundOrigin: $el.css("background-origin"),
	                backgroundPosition: $el.css("background-position"),
	                backgroundRepeat: $el.css("background-repeat"),
	                backgroundSize: $el.css("background-size")
	            };
	        }
	        function revert($input) {
	            var www, $wrapper;
	            www = $input.data(keys.www);
	            $wrapper = $input.parent().filter(www.selectors.wrapper);
	            _.each($input.data(keys.attrs), function(val, key) {
	                _.isUndefined(val) ? $input.removeAttr(key) : $input.attr(key, val);
	            });
	            $input.removeData(keys.typeahead).removeData(keys.www).removeData(keys.attr).removeClass(www.classes.input);
	            if ($wrapper.length) {
	                $input.detach().insertAfter($wrapper);
	                $wrapper.remove();
	            }
	        }
	        function $elOrNull(obj) {
	            var isValid, $el;
	            isValid = _.isJQuery(obj) || _.isElement(obj);
	            $el = isValid ? $(obj).first() : [];
	            return $el.length ? $el : null;
	        }
	    })();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(602).setImmediate))

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var lodash_1 = __webpack_require__(268);
	var autocomplete_service_1 = __webpack_require__(959);
	var model_listener_1 = __webpack_require__(961);
	var VALUES_SPLITTER_SHORT = ':::';
	var VALUES_SPLITTER = VALUES_SPLITTER_SHORT + ' ';
	var $ = __webpack_require__(954);
	__webpack_require__(965);
	//TODO andrey refactor directive, add ngModel support
	//Directive that adds multi autocomplete to any element
	var MultipleAutocomplete = (function (_super) {
	    __extends(MultipleAutocomplete, _super);
	    function MultipleAutocomplete(el, formControl, cd, service) {
	        var _this = _super.call(this) || this;
	        _this.el = el;
	        _this.formControl = formControl;
	        _this.cd = cd;
	        _this.service = service;
	        _this.onChange = new core_1.EventEmitter();
	        _this.onTouchedCallback = new core_1.EventEmitter();
	        _this.unique = true;
	        return _this;
	    }
	    MultipleAutocomplete.prototype.isValueIsCorrect = function (value) {
	        return this.valuesMap[value] ? this.valuesMap[value][0] : undefined;
	    };
	    //todo andrey refactor to safe code
	    //todo andrey use lodash parse value
	    //todo andrey move to service
	    MultipleAutocomplete.prototype.modifyInputAfterChanges = function () {
	        var _this = this;
	        var inputVal = this.el.nativeElement.value;
	        if (lodash_1.isEmpty(this.valuesMap) || !lodash_1.isString(inputVal)) {
	            return;
	        }
	        var inputVals = inputVal.split(VALUES_SPLITTER);
	        if (inputVals.length > 0 && !isNaN(parseFloat(inputVals[0]))) {
	            return;
	        }
	        var mappedVals = inputVals.map(function (val) { return _this.isValueIsCorrect(lodash_1.trim(val)); }).filter(function (val) { return !lodash_1.isUndefined(val); });
	        if (!lodash_1.isEmpty(mappedVals)) {
	            var fieldValue = mappedVals.map(function (mappedVal) {
	                return mappedVal[_this.keyParam];
	            });
	            this.writeValue(fieldValue);
	            this.formControl.control.setValue(fieldValue);
	        }
	        else {
	            if (lodash_1.isUndefined(this.innerValue)) {
	                return;
	            }
	            this.writeValue(undefined);
	            this.formControl.control.setValue(undefined);
	        }
	        this.cd.detectChanges();
	    };
	    MultipleAutocomplete.prototype.itemViewParser = function (item) {
	        return item[this.valueParam];
	    };
	    MultipleAutocomplete.prototype.ngOnInit = function () {
	        var _this = this;
	        setTimeout(function () {
	            _this.loadAutocomplete($, function () { return _this.formControl.value; });
	        });
	    };
	    MultipleAutocomplete.prototype.ngOnChange = function () {
	    };
	    MultipleAutocomplete.prototype.loadAutocomplete = function ($, valReader) {
	        var _this = this;
	        var actualizeTokens = function () {
	            var startTokens = readTokens();
	            var curTokens = lodash_1.filter(startTokens, function (item) { return _this.isValueIsCorrect(item); });
	            if (_this.unique) {
	                curTokens = lodash_1.uniq(curTokens);
	            }
	            if (curTokens && startTokens && curTokens.length === startTokens.length) {
	                return;
	            }
	            writeTokens(curTokens);
	            _this.modifyInputAfterChanges();
	        };
	        var readTokens = function () {
	            return $(_this.el.nativeElement).tokenfield('getTokensList', VALUES_SPLITTER_SHORT).split(VALUES_SPLITTER);
	        };
	        var writeTokens = function (tokens) {
	            $(_this.el.nativeElement).tokenfield('setTokens', tokens);
	        };
	        var mapValuesToTokens = function (values) {
	            if (!values)
	                values = [];
	            var tokens = values.map(function (key) {
	                var idx = lodash_1.findIndex(_this.source, function (sourceItem) { return sourceItem[_this.keyParam] === key; });
	                return _this.itemViewParser(_this.source[idx]);
	            });
	            var curTokens = readTokens();
	            if (lodash_1.difference(curTokens, tokens).length === 0) {
	                return;
	            }
	            writeTokens(tokens);
	            _this.el.nativeElement.value = (tokens.join(VALUES_SPLITTER));
	            _this.modifyInputAfterChanges();
	        };
	        if (!$.fn.typeahead) {
	            //noinspection TypeScriptUnresolvedFunction
	            __webpack_require__(963);
	        }
	        $(this.el.nativeElement).tokenfield({
	            delimiter: VALUES_SPLITTER,
	            typeahead: [null, {
	                    source: this.service.buildSuggestionEngine(function () { return _this.source; }, function (item) { return _this.itemViewParser(item); }, function () {
	                        _this.valuesMap = lodash_1.groupBy(_this.source, _this.valueParam);
	                    })
	                }]
	        }).on('tokenfield:createtoken', function () {
	            setTimeout(function () { return _this.modifyInputAfterChanges(); });
	        }).on('tokenfield:removedtoken', function () {
	            setTimeout(function () { return _this.modifyInputAfterChanges(); });
	        }).on('tokenfield:createdtoken', function () {
	            setTimeout(function () { return actualizeTokens(); });
	        }).on('tokenfield:edittoken', function () {
	            setTimeout(function () { return actualizeTokens(); });
	        }).data('bs.tokenfield').$input[0].onblur = function () {
	            $(_this.el.nativeElement).focus();
	            $(_this.el.nativeElement).blur();
	        };
	        setTimeout(function () {
	            mapValuesToTokens(valReader());
	            _this.formControl.control.valueChanges.subscribe(function (val) { return setTimeout(function () { return mapValuesToTokens(val); }); });
	        });
	    };
	    __decorate([
	        core_1.Output('onChange'),
	        __metadata("design:type", core_1.EventEmitter)
	    ], MultipleAutocomplete.prototype, "onChange", void 0);
	    __decorate([
	        core_1.Input('ac-source'),
	        __metadata("design:type", Array)
	    ], MultipleAutocomplete.prototype, "source", void 0);
	    __decorate([
	        core_1.Input('ac-key'),
	        __metadata("design:type", String)
	    ], MultipleAutocomplete.prototype, "keyParam", void 0);
	    __decorate([
	        core_1.Input('ac-value'),
	        __metadata("design:type", String)
	    ], MultipleAutocomplete.prototype, "valueParam", void 0);
	    __decorate([
	        core_1.Input('ac-unique'),
	        __metadata("design:type", Boolean)
	    ], MultipleAutocomplete.prototype, "unique", void 0);
	    MultipleAutocomplete = __decorate([
	        core_1.Directive({
	            selector: '[multiple-autocomplete]',
	            providers: [autocomplete_service_1.AutocompleteService]
	        }),
	        __param(1, core_1.Optional()), __param(1, core_1.Self()),
	        __metadata("design:paramtypes", [core_1.ElementRef,
	            forms_1.NgControl,
	            core_1.ChangeDetectorRef,
	            autocomplete_service_1.AutocompleteService])
	    ], MultipleAutocomplete);
	    return MultipleAutocomplete;
	}(model_listener_1.ModelListener));
	exports.MultipleAutocomplete = MultipleAutocomplete;


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * bootstrap-tokenfield
	 * https://github.com/sliptree/bootstrap-tokenfield
	 * Copyright 2013-2014 Sliptree and other contributors; Licensed MIT
	 */
	
	(function (factory) {
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(966)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // For CommonJS and CommonJS-like environments where a window with jQuery
	    // is present, execute the factory with the jQuery instance from the window object
	    // For environments that do not inherently posses a window with a document
	    // (such as Node.js), expose a Tokenfield-making factory as module.exports
	    // This accentuates the need for the creation of a real window or passing in a jQuery instance
	    // e.g. require("bootstrap-tokenfield")(window); or require("bootstrap-tokenfield")($);
	    module.exports = global.window && global.window.$ ?
	      factory( global.window.$ ) :
	      function( input ) {
	        if ( !input.$ && !input.fn ) {
	          throw new Error( "Tokenfield requires a window object with jQuery or a jQuery instance" );
	        }
	        return factory( input.$ || input );
	      };
	  } else {
	    // Browser globals
	    factory(jQuery);
	  }
	}(function ($, window) {
	
	  "use strict"; // jshint ;_;
	
	 /* TOKENFIELD PUBLIC CLASS DEFINITION
	  * ============================== */
	
	  var Tokenfield = function (element, options) {
	    var _self = this
	
	    this.$element = $(element)
	    this.textDirection = this.$element.css('direction');
	
	    // Extend options
	    this.options = $.extend(true, {}, $.fn.tokenfield.defaults, { tokens: this.$element.val() }, this.$element.data(), options)
	    
	    // Setup delimiters and trigger keys
	    this._delimiters = (typeof this.options.delimiter === 'string') ? [this.options.delimiter] : this.options.delimiter
	    this._triggerKeys = $.map(this._delimiters, function (delimiter) {
	      return delimiter.charCodeAt(0);
	    });
	    this._firstDelimiter = this._delimiters[0];
	
	    // Check for whitespace, dash and special characters
	    var whitespace = $.inArray(' ', this._delimiters)
	      , dash = $.inArray('-', this._delimiters)
	
	    if (whitespace >= 0)
	      this._delimiters[whitespace] = '\\s'
	
	    if (dash >= 0) {
	      delete this._delimiters[dash]
	      this._delimiters.unshift('-')
	    }
	
	    var specialCharacters = ['\\', '$', '[', '{', '^', '.', '|', '?', '*', '+', '(', ')']
	    $.each(this._delimiters, function (index, char) {
	      var pos = $.inArray(char, specialCharacters)
	      if (pos >= 0) _self._delimiters[index] = '\\' + char;
	    });
	
	    // Store original input width
	    var elRules = (window && typeof window.getMatchedCSSRules === 'function') ? window.getMatchedCSSRules( element ) : null
	      , elStyleWidth = element.style.width
	      , elCSSWidth
	      , elWidth = this.$element.width()
	
	    if (elRules) {
	      $.each( elRules, function (i, rule) {
	        if (rule.style.width) {
	          elCSSWidth = rule.style.width;
	        }
	      });
	    }
	
	    // Move original input out of the way
	    var hidingPosition = $('body').css('direction') === 'rtl' ? 'right' : 'left',
	        originalStyles = { position: this.$element.css('position') };
	    originalStyles[hidingPosition] = this.$element.css(hidingPosition);
	    
	    this.$element
	      .data('original-styles', originalStyles)
	      .data('original-tabindex', this.$element.prop('tabindex'))
	      .css('position', 'absolute')
	      .css(hidingPosition, '-10000px')
	      .prop('tabindex', -1)
	
	    // Create a wrapper
	    this.$wrapper = $('<div class="tokenfield form-control" />')
	    if (this.$element.hasClass('input-lg')) this.$wrapper.addClass('input-lg')
	    if (this.$element.hasClass('input-sm')) this.$wrapper.addClass('input-sm')
	    if (this.textDirection === 'rtl') this.$wrapper.addClass('rtl')
	
	    // Create a new input
	    var id = this.$element.prop('id') || new Date().getTime() + '' + Math.floor((1 + Math.random()) * 100)
	    this.$input = $('<input type="text" class="token-input" autocomplete="off" />')
	                    .appendTo( this.$wrapper )
	                    .prop( 'placeholder',  this.$element.prop('placeholder') )
	                    .prop( 'id', id + '-tokenfield' )
	                    .prop( 'tabindex', this.$element.data('original-tabindex') )
	
	    // Re-route original input label to new input
	    var $label = $( 'label[for="' + this.$element.prop('id') + '"]' )
	    if ( $label.length ) {
	      $label.prop( 'for', this.$input.prop('id') )
	    }
	
	    // Set up a copy helper to handle copy & paste
	    this.$copyHelper = $('<input type="text" />').css('position', 'absolute').css(hidingPosition, '-10000px').prop('tabindex', -1).prependTo( this.$wrapper )
	    
	    // Set wrapper width
	    if (elStyleWidth) {
	      this.$wrapper.css('width', elStyleWidth);
	    }
	    else if (elCSSWidth) {
	      this.$wrapper.css('width', elCSSWidth);
	    }
	    // If input is inside inline-form with no width set, set fixed width
	    else if (this.$element.parents('.form-inline').length) {
	      this.$wrapper.width( elWidth )
	    }
	
	    // Set tokenfield disabled, if original or fieldset input is disabled
	    if (this.$element.prop('disabled') || this.$element.parents('fieldset[disabled]').length) {
	      this.disable();
	    }
	
	    // Set tokenfield readonly, if original input is readonly
	    if (this.$element.prop('readonly')) {
	      this.readonly();
	    }
	
	    // Set up mirror for input auto-sizing
	    this.$mirror = $('<span style="position:absolute; top:-999px; left:0; white-space:pre;"/>');
	    this.$input.css('min-width', this.options.minWidth + 'px')
	    $.each([
	        'fontFamily', 
	        'fontSize', 
	        'fontWeight', 
	        'fontStyle', 
	        'letterSpacing', 
	        'textTransform', 
	        'wordSpacing', 
	        'textIndent'
	    ], function (i, val) {
	        _self.$mirror[0].style[val] = _self.$input.css(val);
	    });
	    this.$mirror.appendTo( 'body' )
	
	    // Insert tokenfield to HTML
	    this.$wrapper.insertBefore( this.$element )
	    this.$element.prependTo( this.$wrapper )
	
	    // Calculate inner input width
	    this.update()
	    
	    // Create initial tokens, if any
	    this.setTokens(this.options.tokens, false, false)
	
	    // Start listening to events
	    this.listen()
	
	    // Initialize autocomplete, if necessary
	    if ( ! $.isEmptyObject( this.options.autocomplete ) ) {
	      var side = this.textDirection === 'rtl' ? 'right' : 'left'
	       ,  autocompleteOptions = $.extend({
	            minLength: this.options.showAutocompleteOnFocus ? 0 : null,
	            position: { my: side + " top", at: side + " bottom", of: this.$wrapper }
	          }, this.options.autocomplete )
	      
	      this.$input.autocomplete( autocompleteOptions )
	    }
	
	    // Initialize typeahead, if necessary
	    if ( ! $.isEmptyObject( this.options.typeahead ) ) {
	      
	      var typeaheadOptions = this.options.typeahead
	        , defaults = {
	            minLength: this.options.showAutocompleteOnFocus ? 0 : null
	          }
	        , args = $.isArray( typeaheadOptions ) ? typeaheadOptions : [typeaheadOptions, typeaheadOptions]
	      
	      args[0] = $.extend( {}, defaults, args[0] )
	
	      this.$input.typeahead.apply( this.$input, args )
	      this.typeahead = true
	    }
	
	    this.$element.trigger('tokenfield:initialize')
	  }
	
	  Tokenfield.prototype = {
	
	    constructor: Tokenfield
	
	  , createToken: function (attrs, triggerChange) {
	      var _self = this
	
	      if (typeof attrs === 'string') {
	        attrs = { value: attrs, label: attrs }
	      }
	
	      if (typeof triggerChange === 'undefined') {
	         triggerChange = true
	      }
	
	      // Normalize label and value
	      attrs.value = $.trim(attrs.value);
	      attrs.label = attrs.label && attrs.label.length ? $.trim(attrs.label) : attrs.value
	
	      // Bail out if has no value or label, or label is too short
	      if (!attrs.value.length || !attrs.label.length || attrs.label.length <= this.options.minLength) return
	
	      // Bail out if maximum number of tokens is reached
	      if (this.options.limit && this.getTokens().length >= this.options.limit) return
	
	      // Allow changing token data before creating it
	      var createEvent = $.Event('tokenfield:createtoken', { attrs: attrs })
	      this.$element.trigger(createEvent)
	
	      // Bail out if there if attributes are empty or event was defaultPrevented
	      if (!createEvent.attrs || createEvent.isDefaultPrevented()) return
	
	      var $token = $('<div class="token" />')
	            .attr('data-value', attrs.value)
	            .append('<span class="token-label" />')
	            .append('<a href="#" class="close" tabindex="-1">&times;</a>')
	
	      // Insert token into HTML
	      if (this.$input.hasClass('tt-input')) {
	        // If the input has typeahead enabled, insert token before it's parent
	        this.$input.parent().before( $token )
	      } else {
	        this.$input.before( $token )
	      }
	
	      // Temporarily set input width to minimum
	      this.$input.css('width', this.options.minWidth + 'px')
	
	      var $tokenLabel = $token.find('.token-label')
	        , $closeButton = $token.find('.close')
	
	      // Determine maximum possible token label width
	      if (!this.maxTokenWidth) {
	        this.maxTokenWidth =
	          this.$wrapper.width() - $closeButton.outerWidth() - 
	          parseInt($closeButton.css('margin-left'), 10) -
	          parseInt($closeButton.css('margin-right'), 10) -
	          parseInt($token.css('border-left-width'), 10) -
	          parseInt($token.css('border-right-width'), 10) -
	          parseInt($token.css('padding-left'), 10) -
	          parseInt($token.css('padding-right'), 10)
	          parseInt($tokenLabel.css('border-left-width'), 10) -
	          parseInt($tokenLabel.css('border-right-width'), 10) -
	          parseInt($tokenLabel.css('padding-left'), 10) -
	          parseInt($tokenLabel.css('padding-right'), 10)
	          parseInt($tokenLabel.css('margin-left'), 10) -
	          parseInt($tokenLabel.css('margin-right'), 10)
	      }
	
	      $tokenLabel
	        .text(attrs.label)
	        .css('max-width', this.maxTokenWidth)
	
	      // Listen to events on token
	      $token
	        .on('mousedown',  function (e) {
	          if (_self._disabled || _self._readonly) return false
	          _self.preventDeactivation = true
	        })
	        .on('click',    function (e) {
	          if (_self._disabled || _self._readonly) return false
	          _self.preventDeactivation = false
	
	          if (e.ctrlKey || e.metaKey) {
	            e.preventDefault()
	            return _self.toggle( $token )
	          }
	          
	          _self.activate( $token, e.shiftKey, e.shiftKey )          
	        })
	        .on('dblclick', function (e) {
	          if (_self._disabled || _self._readonly || !_self.options.allowEditing ) return false
	          _self.edit( $token )
	        })
	
	      $closeButton
	          .on('click',  $.proxy(this.remove, this))
	
	      // Trigger createdtoken event on the original field
	      // indicating that the token is now in the DOM
	      this.$element.trigger($.Event('tokenfield:createdtoken', {
	        attrs: attrs,
	        relatedTarget: $token.get(0)
	      }))
	
	      // Trigger change event on the original field
	      if (triggerChange) {
	        this.$element.val( this.getTokensList() ).trigger( $.Event('change', { initiator: 'tokenfield' }) )
	      }
	
	      // Update tokenfield dimensions
	      this.update()
	
	      // Return original element
	      return this.$element.get(0)
	    }    
	
	  , setTokens: function (tokens, add, triggerChange) {
	      if (!tokens) return
	
	      if (!add) this.$wrapper.find('.token').remove()
	
	      if (typeof triggerChange === 'undefined') {
	          triggerChange = true
	      }
	
	      if (typeof tokens === 'string') {
	        if (this._delimiters.length) {
	          // Split based on delimiters
	          tokens = tokens.split( new RegExp( '[' + this._delimiters.join('') + ']' ) )
	        } else {
	          tokens = [tokens];
	        }
	      }
	
	      var _self = this
	      $.each(tokens, function (i, attrs) {
	        _self.createToken(attrs, triggerChange)
	      })
	
	      return this.$element.get(0)
	    }
	
	  , getTokenData: function($token) {
	      var data = $token.map(function() {
	        var $token = $(this);
	        return {
	          value: $token.attr('data-value'),
	          label: $token.find('.token-label').text()
	        }
	      }).get();
	
	      if (data.length == 1) {
	        data = data[0];
	      }
	
	      return data;
	    }
	
	  , getTokens: function(active) {
	      var self = this
	        , tokens = []
	        , activeClass = active ? '.active' : '' // get active tokens only
	      this.$wrapper.find( '.token' + activeClass ).each( function() {
	        tokens.push( self.getTokenData( $(this) ) )
	      })
	      return tokens
	  }
	
	  , getTokensList: function(delimiter, beautify, active) {
	      delimiter = delimiter || this._firstDelimiter
	      beautify = ( typeof beautify !== 'undefined' && beautify !== null ) ? beautify : this.options.beautify
	      
	      var separator = delimiter + ( beautify && delimiter !== ' ' ? ' ' : '')
	      return $.map( this.getTokens(active), function (token) {
	        return token.value
	      }).join(separator)
	  }
	
	  , getInput: function() {
	    return this.$input.val()
	  }
	
	  , listen: function () {
	      var _self = this
	
	      this.$element
	        .on('change',   $.proxy(this.change, this))
	
	      this.$wrapper
	        .on('mousedown',$.proxy(this.focusInput, this))
	
	      this.$input
	        .on('focus',    $.proxy(this.focus, this))
	        .on('blur',     $.proxy(this.blur, this))
	        .on('paste',    $.proxy(this.paste, this))
	        .on('keydown',  $.proxy(this.keydown, this))
	        .on('keypress', $.proxy(this.keypress, this))
	        .on('keyup',    $.proxy(this.keyup, this))
	
	      this.$copyHelper
	        .on('focus',    $.proxy(this.focus, this))
	        .on('blur',     $.proxy(this.blur, this))        
	        .on('keydown',  $.proxy(this.keydown, this))
	        .on('keyup',    $.proxy(this.keyup, this))
	
	      // Secondary listeners for input width calculation
	      this.$input
	        .on('keypress', $.proxy(this.update, this))
	        .on('keyup',    $.proxy(this.update, this))
	
	      this.$input
	        .on('autocompletecreate', function() {
	          // Set minimum autocomplete menu width
	          var $_menuElement = $(this).data('ui-autocomplete').menu.element
	          
	          var minWidth = _self.$wrapper.outerWidth() -
	              parseInt( $_menuElement.css('border-left-width'), 10 ) -
	              parseInt( $_menuElement.css('border-right-width'), 10 )
	
	          $_menuElement.css( 'min-width', minWidth + 'px' )
	        })
	        .on('autocompleteselect', function (e, ui) {
	          if (_self.createToken( ui.item )) {
	            _self.$input.val('')
	            if (_self.$input.data( 'edit' )) {
	              _self.unedit(true)
	            }
	          }
	          return false
	        })
	        .on('typeahead:selected typeahead:autocompleted', function (e, datum, dataset) {
	          // Create token
	          if (_self.createToken( datum )) {
	            _self.$input.typeahead('val', '')
	            if (_self.$input.data( 'edit' )) {
	              _self.unedit(true)
	            }
	          }
	        })
	
	      // Listen to window resize
	      $(window).on('resize', $.proxy(this.update, this ))
	
	    }
	
	  , keydown: function (e) {
	
	      if (!this.focused) return
	
	      var _self = this
	
	      switch(e.keyCode) {
	        case 8: // backspace
	          if (!this.$input.is(document.activeElement)) break
	          this.lastInputValue = this.$input.val()
	          break
	
	        case 37: // left arrow
	          leftRight( this.textDirection === 'rtl' ? 'next': 'prev' )
	          break
	
	        case 38: // up arrow
	          upDown('prev')
	          break
	
	        case 39: // right arrow
	          leftRight( this.textDirection === 'rtl' ? 'prev': 'next' )
	          break
	
	        case 40: // down arrow
	          upDown('next')
	          break        
	
	        case 65: // a (to handle ctrl + a)
	          if (this.$input.val().length > 0 || !(e.ctrlKey || e.metaKey)) break
	          this.activateAll()
	          e.preventDefault()
	          break
	
	        case 9: // tab
	        case 13: // enter     
	
	          // We will handle creating tokens from autocomplete in autocomplete events
	          if (this.$input.data('ui-autocomplete') && this.$input.data('ui-autocomplete').menu.element.find("li:has(a.ui-state-focus)").length) break
	          
	          // We will handle creating tokens from typeahead in typeahead events
	          if (this.$input.hasClass('tt-input') && this.$wrapper.find('.tt-cursor').length ) break
	          if (this.$input.hasClass('tt-input') && this.$wrapper.find('.tt-hint').val().length) break
	          
	          // Create token
	          if (this.$input.is(document.activeElement) && this.$input.val().length || this.$input.data('edit')) {
	            return this.createTokensFromInput(e, this.$input.data('edit'));
	          }
	
	          // Edit token
	          if (e.keyCode === 13) {
	            if (!this.$copyHelper.is(document.activeElement) || this.$wrapper.find('.token.active').length !== 1) break
	            if (!_self.options.allowEditing) break
	            this.edit( this.$wrapper.find('.token.active') )
	          }
	      }
	
	      function leftRight(direction) {
	        if (_self.$input.is(document.activeElement)) {
	          if (_self.$input.val().length > 0) return
	
	          direction += 'All'
	          var $token = _self.$input.hasClass('tt-input') ? _self.$input.parent()[direction]('.token:first') : _self.$input[direction]('.token:first')
	          if (!$token.length) return
	
	          _self.preventInputFocus = true
	          _self.preventDeactivation = true
	
	          _self.activate( $token )
	          e.preventDefault()
	
	        } else {
	          _self[direction]( e.shiftKey )
	          e.preventDefault()
	        }
	      }
	
	      function upDown(direction) {
	        if (!e.shiftKey) return
	
	        if (_self.$input.is(document.activeElement)) {
	          if (_self.$input.val().length > 0) return
	
	          var $token = _self.$input.hasClass('tt-input') ? _self.$input.parent()[direction + 'All']('.token:first') : _self.$input[direction + 'All']('.token:first')
	          if (!$token.length) return
	
	          _self.activate( $token )
	        }
	
	        var opposite = direction === 'prev' ? 'next' : 'prev'
	          , position = direction === 'prev' ? 'first' : 'last'
	
	        _self.firstActiveToken[opposite + 'All']('.token').each(function() {
	          _self.deactivate( $(this) )
	        })
	
	        _self.activate( _self.$wrapper.find('.token:' + position), true, true )
	        e.preventDefault()
	      }
	
	      this.lastKeyDown = e.keyCode
	    }
	
	  , keypress: function(e) {
	      this.lastKeyPressCode = e.keyCode
	      this.lastKeyPressCharCode = e.charCode
	
	      // Comma
	      if ($.inArray( e.charCode, this._triggerKeys) !== -1 && this.$input.is(document.activeElement)) {
	        if (this.$input.val()) {
	          this.createTokensFromInput(e)
	        }
	        return false;
	      }
	    }
	
	  , keyup: function (e) {
	      this.preventInputFocus = false
	
	      if (!this.focused) return
	
	      switch(e.keyCode) {
	        case 8: // backspace
	          if (this.$input.is(document.activeElement)) {
	            if (this.$input.val().length || this.lastInputValue.length && this.lastKeyDown === 8) break
	            
	            this.preventDeactivation = true
	            var $prevToken = this.$input.hasClass('tt-input') ? this.$input.parent().prevAll('.token:first') : this.$input.prevAll('.token:first')
	
	            if (!$prevToken.length) break
	
	            this.activate( $prevToken )
	          } else {
	            this.remove(e)
	          }
	          break
	
	        case 46: // delete
	          this.remove(e, 'next')
	          break
	      }
	      this.lastKeyUp = e.keyCode
	    }
	
	  , focus: function (e) {
	      this.focused = true
	      this.$wrapper.addClass('focus')
	
	      if (this.$input.is(document.activeElement)) {
	        this.$wrapper.find('.active').removeClass('active')
	        this.$firstActiveToken = null
	
	        if (this.options.showAutocompleteOnFocus) {
	          this.search()
	        }
	      }
	    }
	
	  , blur: function (e) {
	
	      this.focused = false
	      this.$wrapper.removeClass('focus')
	
	      if (!this.preventDeactivation && !this.$element.is(document.activeElement)) {
	        this.$wrapper.find('.active').removeClass('active')
	        this.$firstActiveToken = null
	      }
	
	      if (!this.preventCreateTokens && (this.$input.data('edit') && !this.$input.is(document.activeElement) || this.options.createTokensOnBlur )) {
	        this.createTokensFromInput(e) 
	      }
	      
	      this.preventDeactivation = false
	      this.preventCreateTokens = false
	    }
	
	  , paste: function (e) {
	      var _self = this
	      
	      // Add tokens to existing ones
	      setTimeout(function () {
	        _self.createTokensFromInput(e)
	      }, 1)
	    }
	
	  , change: function (e) {
	      if ( e.initiator === 'tokenfield' ) return // Prevent loops
	      
	      this.setTokens( this.$element.val() )
	    }
	
	  , createTokensFromInput: function (e, focus) {
	      if (this.$input.val().length < this.options.minLength)
	        return // No input, simply return
	
	      var tokensBefore = this.getTokensList()
	      this.setTokens( this.$input.val(), true )
	      
	      if (tokensBefore == this.getTokensList() && this.$input.val().length)
	        return false // No tokens were added, do nothing (prevent form submit)
	
	      if (this.$input.hasClass('tt-input')) {
	        // Typeahead acts weird when simply setting input value to empty,
	        // so we set the query to empty instead
	        this.$input.typeahead('val', '')
	      } else {
	        this.$input.val('')
	      }
	
	      if (this.$input.data( 'edit' )) {
	        this.unedit(focus)
	      }
	
	      return false // Prevent form being submitted
	    }  
	
	  , next: function (add) {
	      if (add) {
	        var $firstActiveToken = this.$wrapper.find('.active:first')
	          , deactivate = $firstActiveToken && this.$firstActiveToken ? $firstActiveToken.index() < this.$firstActiveToken.index() : false
	
	        if (deactivate) return this.deactivate( $firstActiveToken )
	      }
	
	      var $lastActiveToken = this.$wrapper.find('.active:last')
	        , $nextToken = $lastActiveToken.nextAll('.token:first')
	
	      if (!$nextToken.length) {
	        this.$input.focus()
	        return
	      }
	
	      this.activate($nextToken, add)
	    }
	
	  , prev: function (add) {
	
	      if (add) {
	        var $lastActiveToken = this.$wrapper.find('.active:last')
	          , deactivate = $lastActiveToken && this.$firstActiveToken ? $lastActiveToken.index() > this.$firstActiveToken.index() : false
	
	        if (deactivate) return this.deactivate( $lastActiveToken )
	      }
	
	      var $firstActiveToken = this.$wrapper.find('.active:first')
	        , $prevToken = $firstActiveToken.prevAll('.token:first')
	
	      if (!$prevToken.length) {
	        $prevToken = this.$wrapper.find('.token:first')
	      }
	
	      if (!$prevToken.length && !add) {
	        this.$input.focus()
	        return
	      }
	
	      this.activate( $prevToken, add )
	    }
	
	  , activate: function ($token, add, multi, remember) {
	
	      if (!$token) return
	
	      if (typeof remember === 'undefined') var remember = true
	
	      if (multi) var add = true
	
	      this.$copyHelper.focus()
	
	      if (!add) {
	        this.$wrapper.find('.active').removeClass('active')
	        if (remember) {
	          this.$firstActiveToken = $token 
	        } else {
	          delete this.$firstActiveToken
	        }
	      }
	
	      if (multi && this.$firstActiveToken) {
	        // Determine first active token and the current tokens indicies
	        // Account for the 1 hidden textarea by subtracting 1 from both
	        var i = this.$firstActiveToken.index() - 2
	          , a = $token.index() - 2
	          , _self = this
	
	        this.$wrapper.find('.token').slice( Math.min(i, a) + 1, Math.max(i, a) ).each( function() {
	          _self.activate( $(this), true )
	        })
	      }
	
	      $token.addClass('active')
	      this.$copyHelper.val( this.getTokensList( null, null, true ) ).select()
	    }
	
	  , activateAll: function() {
	      var _self = this
	
	      this.$wrapper.find('.token').each( function (i) {
	        _self.activate($(this), i !== 0, false, false)
	      })
	    }
	
	  , deactivate: function($token) {
	      if (!$token) return
	
	      $token.removeClass('active')
	      this.$copyHelper.val( this.getTokensList( null, null, true ) ).select()
	    }
	
	  , toggle: function($token) {
	      if (!$token) return
	
	      $token.toggleClass('active')
	      this.$copyHelper.val( this.getTokensList( null, null, true ) ).select()
	    }
	
	  , edit: function ($token) {
	      if (!$token) return
	
	      var attrs = {
	        value: $token.data('value'),
	        label: $token.find('.token-label').text()
	      }
	
	      // Allow changing input value before editing
	      var options = { attrs: attrs, relatedTarget: $token.get(0) }
	      var editEvent = $.Event('tokenfield:edittoken', options)
	      this.$element.trigger( editEvent )
	      
	      // Edit event can be cancelled if default is prevented
	      if (editEvent.isDefaultPrevented()) return
	
	      $token.find('.token-label').text(attrs.value)
	      var tokenWidth = $token.outerWidth()
	
	      var $_input = this.$input.hasClass('tt-input') ? this.$input.parent() : this.$input
	
	      $token.replaceWith( $_input )
	
	      this.preventCreateTokens = true
	
	      this.$input.val( attrs.value )
	                .select()
	                .data( 'edit', true )
	                .width( tokenWidth )
	
	      this.update();
	
	      // Indicate that token in snow being edited, and is replaced with an input field in the DOM
	      this.$element.trigger($.Event('tokenfield:editedtoken', options ))
	    }
	
	  , unedit: function (focus) {
	      var $_input = this.$input.hasClass('tt-input') ? this.$input.parent() : this.$input
	      $_input.appendTo( this.$wrapper )
	      
	      this.$input.data('edit', false)
	      this.$mirror.text('')
	
	      this.update()
	
	      // Because moving the input element around in DOM 
	      // will cause it to lose focus, we provide an option
	      // to re-focus the input after appending it to the wrapper
	      if (focus) {
	        var _self = this
	        setTimeout(function () {
	          _self.$input.focus()
	        }, 1)
	      }
	    }
	
	  , remove: function (e, direction) {
	      if (this.$input.is(document.activeElement) || this._disabled || this._readonly) return
	
	      var $token = (e.type === 'click') ? $(e.target).closest('.token') : this.$wrapper.find('.token.active')
	      
	      if (e.type !== 'click') {
	        if (!direction) var direction = 'prev'
	        this[direction]()
	
	        // Was it the first token?
	        if (direction === 'prev') var firstToken = $token.first().prevAll('.token:first').length === 0
	      }
	
	      // Prepare events and their options
	      var options = { attrs: this.getTokenData( $token ), relatedTarget: $token.get(0) }
	        , removeEvent = $.Event('tokenfield:removetoken', options)
	      
	      this.$element.trigger(removeEvent);
	
	      // Remove event can be intercepted and cancelled
	      if (removeEvent.isDefaultPrevented()) return
	
	      var removedEvent = $.Event('tokenfield:removedtoken', options)
	        , changeEvent = $.Event('change', { initiator: 'tokenfield' })
	
	      // Remove token from DOM
	      $token.remove()
	
	      // Trigger events
	      this.$element.val( this.getTokensList() ).trigger( removedEvent ).trigger( changeEvent )
	
	      // Focus, when necessary:
	      // When there are no more tokens, or if this was the first token
	      // and it was removed with backspace or it was clicked on
	      if (!this.$wrapper.find('.token').length || e.type === 'click' || firstToken) this.$input.focus()
	
	      // Adjust input width
	      this.$input.css('width', this.options.minWidth + 'px')
	      this.update()
	
	      // Cancel original event handlers
	      e.preventDefault()
	      e.stopPropagation()
	    }
	
	    /**
	     * Update tokenfield dimensions
	     */
	  , update: function (e) {
	      var value = this.$input.val()
	        , inputPaddingLeft = parseInt(this.$input.css('padding-left'), 10)
	        , inputPaddingRight = parseInt(this.$input.css('padding-right'), 10)
	        , inputPadding = inputPaddingLeft + inputPaddingRight
	
	      if (this.$input.data('edit')) {
	
	        if (!value) {
	          value = this.$input.prop("placeholder")
	        }
	        if (value === this.$mirror.text()) return
	
	        this.$mirror.text(value)
	        
	        var mirrorWidth = this.$mirror.width() + 10;
	        if ( mirrorWidth > this.$wrapper.width() ) {
	          return this.$input.width( this.$wrapper.width() )
	        }
	
	        this.$input.width( mirrorWidth )
	      }
	      else {
	        this.$input.css( 'width', this.options.minWidth + 'px' )
	        if (this.textDirection === 'rtl') {
	          return this.$input.width( this.$input.offset().left + this.$input.outerWidth() - this.$wrapper.offset().left - parseInt(this.$wrapper.css('padding-left'), 10) - inputPadding - 1 )
	        }
	        this.$input.width( this.$wrapper.offset().left + this.$wrapper.width() + parseInt(this.$wrapper.css('padding-left'), 10) - this.$input.offset().left - inputPadding )
	      }
	    }
	
	  , focusInput: function (e) {
	      if ( $(e.target).closest('.token').length || $(e.target).closest('.token-input').length || $(e.target).closest('.tt-dropdown-menu').length ) return
	      // Focus only after the current call stack has cleared,
	      // otherwise has no effect.
	      // Reason: mousedown is too early - input will lose focus
	      // after mousedown. However, since the input may be moved
	      // in DOM, there may be no click or mouseup event triggered.
	      var _self = this
	      setTimeout(function() {
	        _self.$input.focus()
	      }, 0)
	    }
	
	  , search: function () {
	      if ( this.$input.data('ui-autocomplete') ) {
	        this.$input.autocomplete('search')
	      }
	    }
	
	  , disable: function () {
	      this.setProperty('disabled', true);
	    }
	
	  , enable: function () {
	      this.setProperty('disabled', false);
	    }
	
	  , readonly: function () {
	      this.setProperty('readonly', true);
	    }
	
	  , writeable: function () {
	      this.setProperty('readonly', false);
	    }
	
	  , setProperty: function(property, value) {
	      this['_' + property] = value;
	      this.$input.prop(property, value);
	      this.$element.prop(property, value);
	      this.$wrapper[ value ? 'addClass' : 'removeClass' ](property);
	  }
	
	  , destroy: function() {
	      // Set field value
	      this.$element.val( this.getTokensList() );
	      // Restore styles and properties
	      this.$element.css( this.$element.data('original-styles') );
	      this.$element.prop( 'tabindex', this.$element.data('original-tabindex') );
	      
	      // Re-route tokenfield labele to original input
	      var $label = $( 'label[for="' + this.$input.prop('id') + '"]' )
	      if ( $label.length ) {
	        $label.prop( 'for', this.$element.prop('id') )
	      }
	
	      // Move original element outside of tokenfield wrapper
	      this.$element.insertBefore( this.$wrapper );
	
	      // Remove tokenfield-related data
	      this.$element.removeData('original-styles')
	                   .removeData('original-tabindex')
	                   .removeData('bs.tokenfield');
	
	      // Remove tokenfield from DOM
	      this.$wrapper.remove();
	
	      var $_element = this.$element;
	      delete this;
	
	      return $_element;
	  }
	
	  }
	
	
	 /* TOKENFIELD PLUGIN DEFINITION
	  * ======================== */
	
	  var old = $.fn.tokenfield
	
	  $.fn.tokenfield = function (option, param) {
	    var value
	      , args = []
	    
	    Array.prototype.push.apply( args, arguments );
	
	    var elements = this.each(function () {
	      var $this = $(this)
	        , data = $this.data('bs.tokenfield')
	        , options = typeof option == 'object' && option
	
	      if (typeof option === 'string' && data && data[option]) {
	        args.shift()
	        value = data[option].apply(data, args)
	      } else {
	        if (!data && typeof option !== 'string' && !param) $this.data('bs.tokenfield', (data = new Tokenfield(this, options)))
	      }
	    })
	
	    return typeof value !== 'undefined' ? value : elements;
	  }
	
	  $.fn.tokenfield.defaults = {
	    minWidth: 60,
	    minLength: 0,
	    allowEditing: true,
	    limit: 0,
	    autocomplete: {},
	    typeahead: {},
	    showAutocompleteOnFocus: false,
	    createTokensOnBlur: false,
	    delimiter: ',',
	    beautify: true
	  }
	
	  $.fn.tokenfield.Constructor = Tokenfield
	
	
	 /* TOKENFIELD NO CONFLICT
	  * ================== */
	
	  $.fn.tokenfield.noConflict = function () {
	    $.fn.tokenfield = old
	    return this
	  }
	
	  return Tokenfield;
	
	}));


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v2.2.4
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-05-20T17:23Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//"use strict";
	var arr = [];
	
	var document = window.document;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		version = "2.2.4",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			var realStringObj = obj && obj.toString();
			return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
		},
	
		isPlainObject: function( obj ) {
			var key;
	
			// Not plain objects:
			// - Any object or value whose internal [[Class]] property is not "[object Object]"
			// - DOM nodes
			// - window
			if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			// Not own constructor property must be Object
			if ( obj.constructor &&
					!hasOwn.call( obj, "constructor" ) &&
					!hasOwn.call( obj.constructor.prototype || {}, "isPrototypeOf" ) ) {
				return false;
			}
	
			// Own properties are enumerated firstly, so to speed up,
			// if last one is own, then all properties are own
			for ( key in obj ) {}
	
			return key === undefined || hasOwn.call( obj, key );
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android<4.0, iOS<6 (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			var script,
				indirect = eval;
	
			code = jQuery.trim( code );
	
			if ( code ) {
	
				// If the code includes a valid, prologue position
				// strict mode pragma, execute code by injecting a
				// script tag into the document.
				if ( code.indexOf( "use strict" ) === 1 ) {
					script = document.createElement( "script" );
					script.text = code;
					document.head.appendChild( script ).parentNode.removeChild( script );
				} else {
	
					// Otherwise, avoid the DOM node creation, insertion
					// and removal by using an indirect global eval
	
					indirect( code );
				}
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE9-11+
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	// JSHint would error on this code due to the Symbol not being defined in ES5.
	// Defining this global in .jshintrc would create a danger of using the global
	// unguarded in another place, it seems safer to just disable JSHint for these
	// three lines.
	/* jshint ignore: start */
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	/* jshint ignore: end */
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: iOS 8.2 (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.1
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2015-10-17
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, nidselect, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rescape, "\\$&" );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
						while ( i-- ) {
							groups[i] = nidselect + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( (parent = document.defaultView) && parent.top !== parent ) {
			// Support: IE 11
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( document.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					return m ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( (oldCache = uniqueCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i,
				len = this.length,
				ret = [],
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						// Support: Blackberry 4.6
						// gEBID returns nodes no longer in the document (#6963)
						if ( elem && elem.parentNode ) {
	
							// Inject the element directly into the jQuery object
							this.length = 1;
							this[ 0 ] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
					// Always skip document fragments
					if ( cur.nodeType < 11 && ( pos ?
						pos.index( cur ) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnotwhite = ( /\S+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
	
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this === promise ? newDefer.promise() : this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add( function() {
	
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 ||
					( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred.
				// If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// Add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.progress( updateFunc( i, progressContexts, progressValues ) )
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject );
					} else {
						--remaining;
					}
				}
			}
	
			// If we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	} );
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
	
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	} );
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called
			// after the browser event has already occurred.
			// Support: IE9-10 only
			// Older IE sometimes signals "interactive" too soon
			if ( document.readyState === "complete" ||
				( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				window.setTimeout( jQuery.ready );
	
			} else {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed );
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		/* jshint -W018 */
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		register: function( owner, initial ) {
			var value = initial || {};
	
			// If it is a node unlikely to be stringify-ed or looped over
			// use plain assignment
			if ( owner.nodeType ) {
				owner[ this.expando ] = value;
	
			// Otherwise secure it in a non-enumerable, non-writable property
			// configurability must be true to allow the property to be
			// deleted with the delete operator
			} else {
				Object.defineProperty( owner, this.expando, {
					value: value,
					writable: true,
					configurable: true
				} );
			}
			return owner[ this.expando ];
		},
		cache: function( owner ) {
	
			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( !acceptData( owner ) ) {
				return {};
			}
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			if ( typeof data === "string" ) {
				cache[ data ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ prop ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
				owner[ this.expando ] && owner[ this.expando ][ key ];
		},
		access: function( owner, key, value ) {
			var stored;
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				stored = this.get( owner, key );
	
				return stored !== undefined ?
					stored : this.get( owner, jQuery.camelCase( key ) );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i, name, camel,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key === undefined ) {
				this.register( owner );
	
			} else {
	
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
	
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = key.concat( key.map( jQuery.camelCase ) );
				} else {
					camel = jQuery.camelCase( key );
	
					// Try the string as a key before any manipulation
					if ( key in cache ) {
						name = [ key, camel ];
					} else {
	
						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						name = camel;
						name = name in cache ?
							[ name ] : ( name.match( rnotwhite ) || [] );
					}
				}
	
				i = name.length;
	
				while ( i-- ) {
					delete cache[ name[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <= 35-45+
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://code.google.com/p/chromium/issues/detail?id=378607
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
	
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data, camelKey;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// with the key as-is
					data = dataUser.get( elem, key ) ||
	
						// Try to find dashed key if it exists (gh-2779)
						// This is for 2.2.x only
						dataUser.get( elem, key.replace( rmultiDash, "-$&" ).toLowerCase() );
	
					if ( data !== undefined ) {
						return data;
					}
	
					camelKey = jQuery.camelCase( key );
	
					// Attempt to get data from the cache
					// with the key camelized
					data = dataUser.get( elem, camelKey );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, camelKey, undefined );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				camelKey = jQuery.camelCase( key );
				this.each( function() {
	
					// First, attempt to store a copy or reference of any
					// data that might've been store with a camelCased key.
					var data = dataUser.get( this, camelKey );
	
					// For HTML5 data-* attribute interop, we have to
					// store property names with dashes in a camelCase form.
					// This might not apply to all properties...*
					dataUser.set( this, camelKey, value );
	
					// *... In the case of properties that might _actually_
					// have dashes, we need to also store a copy of that
					// unchanged property.
					if ( key.indexOf( "-" ) > -1 && data !== undefined ) {
						dataUser.set( this, key, value );
					}
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
	
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" ||
				!jQuery.contains( elem.ownerDocument, elem );
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() { return tween.cur(); } :
				function() { return jQuery.css( elem, prop, "" ); },
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([\w:-]+)/ );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE9
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE9-11+
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret = typeof context.getElementsByTagName !== "undefined" ?
				context.getElementsByTagName( tag || "*" ) :
				typeof context.querySelectorAll !== "undefined" ?
					context.querySelectorAll( tag || "*" ) :
				[];
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], ret ) :
			ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0-4.3, Safari<=5.1
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari<=5.1, Android<4.2
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<=11+
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE9
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Support (at least): Chrome, IE9
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			//
			// Support: Firefox<=42+
			// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
			if ( delegateCount && cur.nodeType &&
				( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push( { elem: cur, handlers: matches } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
			"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split( " " ),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: ( "button buttons clientX clientY offsetX offsetY pageX pageY " +
				"screenX screenY toElement" ).split( " " ),
			filter: function( event, original ) {
				var eventDoc, doc, body,
					button = original.button;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX +
						( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
						( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY +
						( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
						( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: Cordova 2.5 (WebKit) (#13255)
			// All events should have a target; Cordova deviceready doesn't
			if ( !event.target ) {
				event.target = document;
			}
	
			// Support: Safari 6.0+, Chrome<28
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android<4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://code.google.com/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
	
		// Support: IE 10-11, Edge 10240+
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName( "tbody" )[ 0 ] ||
				elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android<4.1, PhantomJS<2
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
	
		// Keep domManip exposed until 3.0 (gh-2225)
		domManip: domManip,
	
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: QtWebKit
				// .get() because push.apply(_, arraylike) throws
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	
	
	var iframe,
		elemdisplay = {
	
			// Support: Firefox
			// We have to pre-define these values for FF (#10227)
			HTML: "block",
			BODY: "block"
		};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			display = jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
					.appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = iframe[ 0 ].contentDocument;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var documentElement = document.documentElement;
	
	
	
	( function() {
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE9-11+
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
			div.style.cssText =
	
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
		}
	
		jQuery.extend( support, {
			pixelPosition: function() {
	
				// This test is executed only once but we still do memoizing
				// since we can use the boxSizingReliable pre-computing.
				// No need to check if the test was already performed, though.
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
	
				// Support: Android 4.0-4.3
				// We're checking for boxSizingReliableVal here instead of pixelMarginRightVal
				// since that compresses better and they're computed together anyway.
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
	
				// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return reliableMarginLeftVal;
			},
			reliableMarginRight: function() {
	
				// Support: Android 2.3
				// Check if div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container. (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// This support function is only executed once so no memoizing is needed.
				var ret,
					marginDiv = div.appendChild( document.createElement( "div" ) );
	
				// Reset CSS: box-sizing; display; margin; border; padding
				marginDiv.style.cssText = div.style.cssText =
	
					// Support: Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;box-sizing:content-box;" +
					"display:block;margin:0;border:0;padding:0";
				marginDiv.style.marginRight = marginDiv.style.width = "0";
				div.style.width = "1px";
				documentElement.appendChild( container );
	
				ret = !parseFloat( window.getComputedStyle( marginDiv ).marginRight );
	
				documentElement.removeChild( container );
				div.removeChild( marginDiv );
	
				return ret;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
		ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;
	
		// Support: Opera 12.1x only
		// Fall back to style even without computed
		// computed is undefined for elems on document fragments
		if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}
	
		// Support: IE9
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// http://dev.w3.org/csswg/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE9-11+
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
	
			// If we already have the right measurement, avoid augmentation
			4 :
	
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = dataPriv.get( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
	
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] = dataPriv.access(
						elem,
						"olddisplay",
						defaultDisplay( elem.nodeName )
					);
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display !== "none" || !hidden ) {
					dataPriv.set(
						elem,
						"olddisplay",
						hidden ? display : jQuery.css( elem, "display" )
					);
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// Support: IE9-11+
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					style[ name ] = value;
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
						elem.offsetWidth === 0 ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// Support: Android 2.3
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE9
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
	
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE9-10 do not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				dataPriv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
				style.display = "inline-block";
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show
					// and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", {} );
			}
	
			// Store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done( function() {
					jQuery( elem ).hide();
				} );
			}
			anim.done( function() {
				var prop;
	
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnotwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ?
			opt.duration : opt.duration in jQuery.fx.speeds ?
				jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		window.clearInterval( timerId );
	
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: iOS<=5.1, Android<=4.2+
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE<=11+
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: Android<=2.3
		// Options inside disabled selects are incorrectly marked as disabled
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE<=11+
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
	
						// Set corresponding property to false
						elem[ propName ] = false;
					}
	
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					return tabindex ?
						parseInt( tabindex, 10 ) :
						rfocusable.test( elem.nodeName ) ||
							rclickable.test( elem.nodeName ) && elem.href ?
								0 :
								-1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnotwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + getClass( elem ) + " " ).replace( rclass, " " )
						.indexOf( className ) > -1
				) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g,
		rspaces = /[\x20\t\r\n\f]+/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
	
						// Handle most common string cases
						ret.replace( rreturn, "" ) :
	
						// Handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ?
									!option.disabled : option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome, Safari
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Support: Android 2.3
	// Workaround failure to string-cast null input
	jQuery.parseJSON = function( data ) {
		return JSON.parse( data + "" );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE9
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
			// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// The jqXHR state
				state = 0,
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
	
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" ).replace( rhash, "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE8-11+
				// IE throws exception if url is malformed, e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE8-11+
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( state === 2 ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
	
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapAll( html.call( this, i ) );
				} );
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function() {
			return this.parent().each( function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			} ).end();
		}
	} );
	
	
	jQuery.expr.filters.hidden = function( elem ) {
		return !jQuery.expr.filters.visible( elem );
	};
	jQuery.expr.filters.visible = function( elem ) {
	
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		// Use OR instead of AND as the element is not visible if either is true
		// See tickets #10406 and #13132
		return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem.getClientRects().length > 0;
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
	
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						} ) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE9
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE9
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE9
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = jQuery.trim( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win,
				elem = this[ 0 ],
				box = { top: 0, left: 0 },
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			box = elem.getBoundingClientRect();
			win = getWindow( doc );
			return {
				top: box.top + win.pageYOffset - docElem.clientTop,
				left: box.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari<7-8+, Chrome<37-44+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
		size: function() {
			return this.length;
		}
	} );
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	return jQuery;
	}));


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var form_submitter_1 = __webpack_require__(968);
	var form_trigger_1 = __webpack_require__(969);
	exports.FORM_DIRECTIVES = [
	    form_trigger_1.FormTrigger,
	    form_submitter_1.FormSubmitter
	];
	__export(__webpack_require__(968));


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var $ = __webpack_require__(954);
	var FormSubmitter = (function () {
	    function FormSubmitter(form, el) {
	        this.form = form;
	        this.el = el;
	    }
	    FormSubmitter.prototype.ngOnInit = function () {
	        this.rootEl = $(this.el.nativeElement);
	        this.triggerEl = this.rootEl.find('[type="submit"]');
	    };
	    FormSubmitter.prototype.submit = function () {
	        this.triggerEl.trigger('click');
	    };
	    FormSubmitter = __decorate([
	        core_1.Component({
	            selector: 'form-submitter', template: '<ng-content></ng-content>'
	        }),
	        __metadata("design:paramtypes", [forms_1.NgForm, core_1.ElementRef])
	    ], FormSubmitter);
	    return FormSubmitter;
	}());
	exports.FormSubmitter = FormSubmitter;


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var $ = __webpack_require__(954);
	var FormTrigger = (function () {
	    function FormTrigger(form, el) {
	        this.form = form;
	        this.el = el;
	        this.formTrigger = new core_1.EventEmitter();
	    }
	    FormTrigger.prototype.ngOnInit = function () {
	        this.formEl = $(this.el.nativeElement).closest('form');
	        this.triggerEl = this.formEl.find('[type="submit"]');
	        if (!this.triggerEl.length) {
	            this.triggerEl = $('<input type="submit" hidden/>');
	            this.formEl.append(this.triggerEl);
	        }
	        var that = this;
	        this.triggerEl.eq(this.triggerEl.length - 1).bind('click', function () {
	            that.formTrigger.emit(true);
	        });
	    };
	    __decorate([
	        core_1.Output('form-trigger'),
	        __metadata("design:type", core_1.EventEmitter)
	    ], FormTrigger.prototype, "formTrigger", void 0);
	    FormTrigger = __decorate([
	        core_1.Directive({
	            selector: '[form-trigger]'
	        }),
	        __metadata("design:paramtypes", [forms_1.NgForm, core_1.ElementRef])
	    ], FormTrigger);
	    return FormTrigger;
	}());
	exports.FormTrigger = FormTrigger;


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(971));
	__export(__webpack_require__(973));
	var toggle_button_component_1 = __webpack_require__(971);
	var toggle_item_component_1 = __webpack_require__(973);
	exports.TOGGLE_DIRECTIVES = [
	    toggle_button_component_1.ToggleButtonComponent,
	    toggle_item_component_1.ToggleItemComponent
	];


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var lodash_1 = __webpack_require__(268);
	var CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR = {
	    provide: forms_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return ToggleButtonComponent; }),
	    multi: true
	};
	var noop = function () {
	};
	var ToggleButtonComponent = (function () {
	    function ToggleButtonComponent(el, renderer) {
	        this.el = el;
	        this.renderer = renderer;
	        this.disabled = false;
	        this.onChange = new core_1.EventEmitter();
	        //The internal data model
	        this._innerValue = {};
	        //Placeholders for the callbacks which are later providesd
	        //by the Control Value Accessor
	        this.onTouchedCallback = noop;
	        this.items = new Array();
	        this.autoWidth = true;
	    }
	    ToggleButtonComponent.prototype.writeValue = function (obj) {
	        if (obj !== this.innerValue) {
	            this.innerValue = obj;
	        }
	    };
	    //From ControlValueAccessor interface
	    ToggleButtonComponent.prototype.registerOnChange = function (fn) {
	        this.onChange.subscribe(fn);
	    };
	    //From ControlValueAccessor interface
	    ToggleButtonComponent.prototype.registerOnTouched = function (fn) {
	        this.onTouchedCallback = fn;
	    };
	    Object.defineProperty(ToggleButtonComponent.prototype, "innerValue", {
	        //get accessor
	        get: function () {
	            return this._innerValue;
	        },
	        //set accessor including call the onchange callback
	        set: function (v) {
	            if (v !== this._innerValue) {
	                this._innerValue = v;
	                this.onChange.emit(this._innerValue);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ;
	    ToggleButtonComponent.prototype.ngAfterContentInit = function () {
	        var _this = this;
	        setTimeout(function () {
	            var selectedItem = _this.getItemByValue(_this._innerValue);
	            if (!lodash_1.isUndefined(selectedItem) && selectedItem !== _this.currentItem) {
	                _this.selectItem(selectedItem);
	            }
	        }, 0);
	        this.setupStyles();
	    };
	    //DOM READY
	    ToggleButtonComponent.prototype.ngAfterViewChecked = function () {
	        var _this = this;
	        if (this.autoWidth) {
	            this.items.forEach(function (item) {
	                item.setWidth(100 / _this.items.length + '%');
	                item.updateView();
	            });
	        }
	        else {
	            this.items.forEach(function (item) {
	                item.setWidth('100%');
	                item.updateView();
	            });
	        }
	    };
	    ToggleButtonComponent.prototype.registerChild = function (child) {
	        this.items.push(child);
	    };
	    ToggleButtonComponent.prototype.getItemByValue = function (value) {
	        return lodash_1.find(this.items, function (item) {
	            return item.getValue() === value;
	        });
	    };
	    ToggleButtonComponent.prototype.setupStyles = function () {
	        this.renderer.addClass(this.el.nativeElement, 'btn-group');
	        this.renderer.setStyle(this.el.nativeElement, 'width', '100%');
	    };
	    ToggleButtonComponent.prototype.selectItem = function (item) {
	        this.items.forEach(function (child) {
	            if (child === item) {
	                child.activateItem();
	            }
	            else {
	                child.deactivateItem();
	            }
	        });
	        this.currentItem = item;
	        this.writeValue(item.getValue());
	    };
	    __decorate([
	        core_1.Input('disabled'),
	        __metadata("design:type", Boolean)
	    ], ToggleButtonComponent.prototype, "disabled", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], ToggleButtonComponent.prototype, "onChange", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], ToggleButtonComponent.prototype, "autoWidth", void 0);
	    ToggleButtonComponent = __decorate([
	        core_1.Component({
	            selector: 'toggle-button',
	            template: __webpack_require__(972),
	            providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
	        }),
	        __metadata("design:paramtypes", [core_1.ElementRef,
	            core_1.Renderer2])
	    ], ToggleButtonComponent);
	    return ToggleButtonComponent;
	}());
	exports.ToggleButtonComponent = ToggleButtonComponent;


/***/ }),
/* 972 */
/***/ (function(module, exports) {

	module.exports = "<ng-content></ng-content>"

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var toggle_button_component_1 = __webpack_require__(971);
	var ToggleItemComponent = (function () {
	    function ToggleItemComponent(rootComponent, el, renderer) {
	        this.rootComponent = rootComponent;
	        this.el = el;
	        this.renderer = renderer;
	        this.isActivated = false;
	    }
	    ToggleItemComponent.prototype.ngOnInit = function () {
	        this.rootComponent.registerChild(this);
	    };
	    ToggleItemComponent.prototype.ngAfterContentInit = function () {
	        this.setupStyles();
	        this.updateView();
	    };
	    ToggleItemComponent.prototype.selectItem = function () {
	        if (!this.rootComponent.disabled) {
	            this.rootComponent.selectItem(this);
	        }
	    };
	    ToggleItemComponent.prototype.activateItem = function () {
	        this.isActivated = true;
	        this.updateView();
	    };
	    ToggleItemComponent.prototype.deactivateItem = function () {
	        this.isActivated = false;
	        this.updateView();
	    };
	    ToggleItemComponent.prototype.setWidth = function (width) {
	        this.renderer.setStyle(this.el.nativeElement, 'width', width);
	    };
	    ToggleItemComponent.prototype.updateView = function () {
	        this.setClass('disabled', this.rootComponent.disabled);
	        this.setClass('open', this.isActivated);
	        this.setClass('btn-primary', this.isActivated);
	        this.setClass('btn-default', !this.isActivated);
	    };
	    ToggleItemComponent.prototype.getIsActivated = function () {
	        return this.isActivated;
	    };
	    ToggleItemComponent.prototype.setupStyles = function () {
	        this.renderer.addClass(this.el.nativeElement, 'btn');
	    };
	    ToggleItemComponent.prototype.setClass = function (className, add) {
	        if (!!add) {
	            this.renderer.addClass(this.el.nativeElement, className);
	        }
	        else {
	            this.renderer.removeClass(this.el.nativeElement, className);
	        }
	    };
	    ToggleItemComponent.prototype.getValue = function () {
	        return this.value;
	    };
	    __decorate([
	        core_1.Input('value'),
	        __metadata("design:type", String)
	    ], ToggleItemComponent.prototype, "value", void 0);
	    ToggleItemComponent = __decorate([
	        core_1.Component({
	            selector: 'toggle-item',
	            host: {
	                '(click)': 'selectItem()'
	            },
	            template: __webpack_require__(974)
	        }),
	        __metadata("design:paramtypes", [toggle_button_component_1.ToggleButtonComponent,
	            core_1.ElementRef,
	            core_1.Renderer2])
	    ], ToggleItemComponent);
	    return ToggleItemComponent;
	}());
	exports.ToggleItemComponent = ToggleItemComponent;


/***/ }),
/* 974 */
/***/ (function(module, exports) {

	module.exports = "<ng-content></ng-content>\n"

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var checkbox_item_component_1 = __webpack_require__(976);
	var checkbox_button_component_1 = __webpack_require__(977);
	var i_checkbox_directive_1 = __webpack_require__(980);
	exports.CHECKBOX_DIRECTIVES = [
	    checkbox_button_component_1.CheckboxButtonComponent,
	    checkbox_item_component_1.CheckboxItemComponent,
	    i_checkbox_directive_1.ICheckBoxDirective
	];


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var checkbox_button_component_1 = __webpack_require__(977);
	var CheckboxItemComponent = (function () {
	    function CheckboxItemComponent(el, renderer, checkboxButton, cd) {
	        this.el = el;
	        this.renderer = renderer;
	        this.checkboxButton = checkboxButton;
	        this.cd = cd;
	    }
	    CheckboxItemComponent.prototype.ngOnInit = function () {
	        this.setupStyles();
	        this.checkboxButton.registerComponent(this);
	    };
	    CheckboxItemComponent.prototype.setupStyles = function () {
	        this.renderer.addClass(this.el.nativeElement, 'btn');
	    };
	    CheckboxItemComponent.prototype.updateView = function () {
	        if (!!this.getIsActive()) {
	            this.renderer.addClass(this.el.nativeElement, 'btn-primary');
	            this.renderer.removeClass(this.el.nativeElement, 'btn-default');
	        }
	        else {
	            this.renderer.removeClass(this.el.nativeElement, 'btn-primary');
	            this.renderer.addClass(this.el.nativeElement, 'btn-default');
	        }
	        this.cd.detectChanges();
	    };
	    CheckboxItemComponent.prototype.setWidth = function (width) {
	        this.renderer.setStyle(this.el.nativeElement, 'width', width);
	    };
	    CheckboxItemComponent.prototype.setActive = function (isActive) {
	        this.isActive = isActive;
	        this.updateView();
	    };
	    CheckboxItemComponent.prototype.getIsActive = function () {
	        return this.isActive;
	    };
	    CheckboxItemComponent.prototype.toggle = function () {
	        this.setActive(!this.isActive);
	        this.updateView();
	    };
	    CheckboxItemComponent.prototype.selectItem = function () {
	        this.checkboxButton.selectItem(this);
	    };
	    CheckboxItemComponent.prototype.getValue = function () {
	        return this.value;
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], CheckboxItemComponent.prototype, "value", void 0);
	    CheckboxItemComponent = __decorate([
	        core_1.Component({
	            selector: 'checkbox-item',
	            host: {
	                '(click)': 'selectItem()'
	            },
	            template: __webpack_require__(979)
	        }),
	        __metadata("design:paramtypes", [core_1.ElementRef,
	            core_1.Renderer2,
	            checkbox_button_component_1.CheckboxButtonComponent,
	            core_1.ChangeDetectorRef])
	    ], CheckboxItemComponent);
	    return CheckboxItemComponent;
	}());
	exports.CheckboxItemComponent = CheckboxItemComponent;


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	exports.CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR = {
	    provide: forms_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return CheckboxButtonComponent; }),
	    multi: true
	};
	var noop = function () {
	};
	var CheckboxButtonComponent = (function () {
	    function CheckboxButtonComponent(el, renderer) {
	        this.el = el;
	        this.renderer = renderer;
	        this.onChange = new core_1.EventEmitter();
	        //The internal data model
	        this._innerValue = [];
	        //Placeholders for the callbacks which are later providesd
	        //by the Control Value Accessor
	        this.onTouchedCallback = noop;
	        this.checkboxes = [];
	    }
	    CheckboxButtonComponent.prototype.writeValue = function (obj) {
	        if (obj !== this.innerValue) {
	            this.innerValue = obj;
	        }
	    };
	    //From ControlValueAccessor interface
	    CheckboxButtonComponent.prototype.registerOnChange = function (fn) {
	        this.onChange.subscribe(fn);
	    };
	    //From ControlValueAccessor interface
	    CheckboxButtonComponent.prototype.registerOnTouched = function (fn) {
	        this.onTouchedCallback = fn;
	    };
	    Object.defineProperty(CheckboxButtonComponent.prototype, "innerValue", {
	        //get accessor
	        get: function () {
	            return this._innerValue;
	        },
	        //set accessor including call the onchange callback
	        set: function (v) {
	            if (v !== this._innerValue) {
	                if (!this._innerValue) {
	                    this._innerValue = [];
	                }
	                if (v && !v.shouldRemove) {
	                    this._innerValue.push(v);
	                }
	                else {
	                    this._innerValue = this._innerValue.filter(function (value) {
	                        return value !== v.value;
	                    });
	                    if (this._innerValue.length == 0) {
	                        this._innerValue = null;
	                    }
	                }
	                this.onChange.emit(this._innerValue);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ;
	    CheckboxButtonComponent.prototype.ngAfterViewChecked = function () {
	        var _this = this;
	        this.checkboxes.forEach(function (item) {
	            if (_this.autoWidth) {
	                item.setWidth(100 / _this.checkboxes.length + '%');
	            }
	            item.updateView();
	        });
	    };
	    CheckboxButtonComponent.prototype.registerComponent = function (checkbox) {
	        this.checkboxes.push(checkbox);
	    };
	    CheckboxButtonComponent.prototype.selectItem = function (checkbox) {
	        checkbox.toggle();
	        if (checkbox.getIsActive()) {
	            this.writeValue(checkbox.getValue());
	        }
	        else {
	            this.writeValue({ value: checkbox.getValue(), shouldRemove: true });
	        }
	    };
	    CheckboxButtonComponent.prototype.ngAfterContentInit = function () {
	        this.renderer.addClass(this.el.nativeElement, 'btn-group');
	        this.renderer.setStyle(this.el.nativeElement, 'width', '100%');
	    };
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], CheckboxButtonComponent.prototype, "onChange", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], CheckboxButtonComponent.prototype, "autoWidth", void 0);
	    CheckboxButtonComponent = __decorate([
	        core_1.Component({
	            selector: 'checkbox-button',
	            template: __webpack_require__(978),
	            providers: [exports.CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
	        }),
	        __metadata("design:paramtypes", [core_1.ElementRef,
	            core_1.Renderer2])
	    ], CheckboxButtonComponent);
	    return CheckboxButtonComponent;
	}());
	exports.CheckboxButtonComponent = CheckboxButtonComponent;


/***/ }),
/* 978 */
972,
/* 979 */
972,
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var $ = __webpack_require__(954);
	__webpack_require__(981);
	var ICheckBoxDirective = (function () {
	    function ICheckBoxDirective(el) {
	        this.el = el;
	        this.check = new core_1.EventEmitter();
	        this.checked = false;
	    }
	    ICheckBoxDirective.prototype.ngOnInit = function () {
	        var _this = this;
	        window['jQuery'] = $;
	        setTimeout(function () {
	            $(_this.el.nativeElement).iCheck({
	                checkboxClass: 'icheckbox_flat-green'
	            }).on('ifChecked', function () {
	                _this.check.emit(true);
	            }).on('ifUnchecked', function () {
	                _this.check.emit(false);
	            });
	            if (_this.checked) {
	                $(_this.el.nativeElement).iCheck('check');
	            }
	        }, 5);
	    };
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], ICheckBoxDirective.prototype, "check", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], ICheckBoxDirective.prototype, "checked", void 0);
	    ICheckBoxDirective = __decorate([
	        core_1.Directive({
	            selector: '[i-checkbox]'
	        }),
	        __metadata("design:paramtypes", [core_1.ElementRef])
	    ], ICheckBoxDirective);
	    return ICheckBoxDirective;
	}());
	exports.ICheckBoxDirective = ICheckBoxDirective;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/*!
	 * iCheck v1.0.2, http://git.io/arlzeA
	 * ===================================
	 * Powerful jQuery and Zepto plugin for checkboxes and radio buttons customization
	 *
	 * (c) 2013 Damir Sultanov, http://fronteed.com
	 * MIT Licensed
	 */
	
	(function($) {
	
	  // Cached vars
	  var _iCheck = 'iCheck',
	    _iCheckHelper = _iCheck + '-helper',
	    _checkbox = 'checkbox',
	    _radio = 'radio',
	    _checked = 'checked',
	    _unchecked = 'un' + _checked,
	    _disabled = 'disabled',
	    _determinate = 'determinate',
	    _indeterminate = 'in' + _determinate,
	    _update = 'update',
	    _type = 'type',
	    _click = 'click',
	    _touch = 'touchbegin.i touchend.i',
	    _add = 'addClass',
	    _remove = 'removeClass',
	    _callback = 'trigger',
	    _label = 'label',
	    _cursor = 'cursor',
	    _mobile = /ipad|iphone|ipod|android|blackberry|windows phone|opera mini|silk/i.test(navigator.userAgent);
	
	  // Plugin init
	  $.fn[_iCheck] = function(options, fire) {
	
	    // Walker
	    var handle = 'input[type="' + _checkbox + '"], input[type="' + _radio + '"]',
	      stack = $(),
	      walker = function(object) {
	        object.each(function() {
	          var self = $(this);
	
	          if (self.is(handle)) {
	            stack = stack.add(self);
	          } else {
	            stack = stack.add(self.find(handle));
	          }
	        });
	      };
	
	    // Check if we should operate with some method
	    if (/^(check|uncheck|toggle|indeterminate|determinate|disable|enable|update|destroy)$/i.test(options)) {
	
	      // Normalize method's name
	      options = options.toLowerCase();
	
	      // Find checkboxes and radio buttons
	      walker(this);
	
	      return stack.each(function() {
	        var self = $(this);
	
	        if (options == 'destroy') {
	          tidy(self, 'ifDestroyed');
	        } else {
	          operate(self, true, options);
	        }
	
	        // Fire method's callback
	        if ($.isFunction(fire)) {
	          fire();
	        }
	      });
	
	    // Customization
	    } else if (typeof options == 'object' || !options) {
	
	      // Check if any options were passed
	      var settings = $.extend({
	          checkedClass: _checked,
	          disabledClass: _disabled,
	          indeterminateClass: _indeterminate,
	          labelHover: true
	        }, options),
	
	        selector = settings.handle,
	        hoverClass = settings.hoverClass || 'hover',
	        focusClass = settings.focusClass || 'focus',
	        activeClass = settings.activeClass || 'active',
	        labelHover = !!settings.labelHover,
	        labelHoverClass = settings.labelHoverClass || 'hover',
	
	        // Setup clickable area
	        area = ('' + settings.increaseArea).replace('%', '') | 0;
	
	      // Selector limit
	      if (selector == _checkbox || selector == _radio) {
	        handle = 'input[type="' + selector + '"]';
	      }
	
	      // Clickable area limit
	      if (area < -50) {
	        area = -50;
	      }
	
	      // Walk around the selector
	      walker(this);
	
	      return stack.each(function() {
	        var self = $(this);
	
	        // If already customized
	        tidy(self);
	
	        var node = this,
	          id = node.id,
	
	          // Layer styles
	          offset = -area + '%',
	          size = 100 + (area * 2) + '%',
	          layer = {
	            position: 'absolute',
	            top: offset,
	            left: offset,
	            display: 'block',
	            width: size,
	            height: size,
	            margin: 0,
	            padding: 0,
	            background: '#fff',
	            border: 0,
	            opacity: 0
	          },
	
	          // Choose how to hide input
	          hide = _mobile ? {
	            position: 'absolute',
	            visibility: 'hidden'
	          } : area ? layer : {
	            position: 'absolute',
	            opacity: 0
	          },
	
	          // Get proper class
	          className = node[_type] == _checkbox ? settings.checkboxClass || 'i' + _checkbox : settings.radioClass || 'i' + _radio,
	
	          // Find assigned labels
	          label = $(_label + '[for="' + id + '"]').add(self.closest(_label)),
	
	          // Check ARIA option
	          aria = !!settings.aria,
	
	          // Set ARIA placeholder
	          ariaID = _iCheck + '-' + Math.random().toString(36).substr(2,6),
	
	          // Parent & helper
	          parent = '<div class="' + className + '" ' + (aria ? 'role="' + node[_type] + '" ' : ''),
	          helper;
	
	        // Set ARIA "labelledby"
	        if (aria) {
	          label.each(function() {
	            parent += 'aria-labelledby="';
	
	            if (this.id) {
	              parent += this.id;
	            } else {
	              this.id = ariaID;
	              parent += ariaID;
	            }
	
	            parent += '"';
	          });
	        }
	
	        // Wrap input
	        parent = self.wrap(parent + '/>')[_callback]('ifCreated').parent().append(settings.insert);
	
	        // Layer addition
	        helper = $('<ins class="' + _iCheckHelper + '"/>').css(layer).appendTo(parent);
	
	        // Finalize customization
	        self.data(_iCheck, {o: settings, s: self.attr('style')}).css(hide);
	        !!settings.inheritClass && parent[_add](node.className || '');
	        !!settings.inheritID && id && parent.attr('id', _iCheck + '-' + id);
	        parent.css('position') == 'static' && parent.css('position', 'relative');
	        operate(self, true, _update);
	
	        // Label events
	        if (label.length) {
	          label.on(_click + '.i mouseover.i mouseout.i ' + _touch, function(event) {
	            var type = event[_type],
	              item = $(this);
	
	            // Do nothing if input is disabled
	            if (!node[_disabled]) {
	
	              // Click
	              if (type == _click) {
	                if ($(event.target).is('a')) {
	                  return;
	                }
	                operate(self, false, true);
	
	              // Hover state
	              } else if (labelHover) {
	
	                // mouseout|touchend
	                if (/ut|nd/.test(type)) {
	                  parent[_remove](hoverClass);
	                  item[_remove](labelHoverClass);
	                } else {
	                  parent[_add](hoverClass);
	                  item[_add](labelHoverClass);
	                }
	              }
	
	              if (_mobile) {
	                event.stopPropagation();
	              } else {
	                return false;
	              }
	            }
	          });
	        }
	
	        // Input events
	        self.on(_click + '.i focus.i blur.i keyup.i keydown.i keypress.i', function(event) {
	          var type = event[_type],
	            key = event.keyCode;
	
	          // Click
	          if (type == _click) {
	            return false;
	
	          // Keydown
	          } else if (type == 'keydown' && key == 32) {
	            if (!(node[_type] == _radio && node[_checked])) {
	              if (node[_checked]) {
	                off(self, _checked);
	              } else {
	                on(self, _checked);
	              }
	            }
	
	            return false;
	
	          // Keyup
	          } else if (type == 'keyup' && node[_type] == _radio) {
	            !node[_checked] && on(self, _checked);
	
	          // Focus/blur
	          } else if (/us|ur/.test(type)) {
	            parent[type == 'blur' ? _remove : _add](focusClass);
	          }
	        });
	
	        // Helper events
	        helper.on(_click + ' mousedown mouseup mouseover mouseout ' + _touch, function(event) {
	          var type = event[_type],
	
	            // mousedown|mouseup
	            toggle = /wn|up/.test(type) ? activeClass : hoverClass;
	
	          // Do nothing if input is disabled
	          if (!node[_disabled]) {
	
	            // Click
	            if (type == _click) {
	              operate(self, false, true);
	
	            // Active and hover states
	            } else {
	
	              // State is on
	              if (/wn|er|in/.test(type)) {
	
	                // mousedown|mouseover|touchbegin
	                parent[_add](toggle);
	
	              // State is off
	              } else {
	                parent[_remove](toggle + ' ' + activeClass);
	              }
	
	              // Label hover
	              if (label.length && labelHover && toggle == hoverClass) {
	
	                // mouseout|touchend
	                label[/ut|nd/.test(type) ? _remove : _add](labelHoverClass);
	              }
	            }
	
	            if (_mobile) {
	              event.stopPropagation();
	            } else {
	              return false;
	            }
	          }
	        });
	      });
	    } else {
	      return this;
	    }
	  };
	
	  // Do something with inputs
	  function operate(input, direct, method) {
	    var node = input[0],
	      state = /er/.test(method) ? _indeterminate : /bl/.test(method) ? _disabled : _checked,
	      active = method == _update ? {
	        checked: node[_checked],
	        disabled: node[_disabled],
	        indeterminate: input.attr(_indeterminate) == 'true' || input.attr(_determinate) == 'false'
	      } : node[state];
	
	    // Check, disable or indeterminate
	    if (/^(ch|di|in)/.test(method) && !active) {
	      on(input, state);
	
	    // Uncheck, enable or determinate
	    } else if (/^(un|en|de)/.test(method) && active) {
	      off(input, state);
	
	    // Update
	    } else if (method == _update) {
	
	      // Handle states
	      for (var each in active) {
	        if (active[each]) {
	          on(input, each, true);
	        } else {
	          off(input, each, true);
	        }
	      }
	
	    } else if (!direct || method == 'toggle') {
	
	      // Helper or label was clicked
	      if (!direct) {
	        input[_callback]('ifClicked');
	      }
	
	      // Toggle checked state
	      if (active) {
	        if (node[_type] !== _radio) {
	          off(input, state);
	        }
	      } else {
	        on(input, state);
	      }
	    }
	  }
	
	  // Add checked, disabled or indeterminate state
	  function on(input, state, keep) {
	    var node = input[0],
	      parent = input.parent(),
	      checked = state == _checked,
	      indeterminate = state == _indeterminate,
	      disabled = state == _disabled,
	      callback = indeterminate ? _determinate : checked ? _unchecked : 'enabled',
	      regular = option(input, callback + capitalize(node[_type])),
	      specific = option(input, state + capitalize(node[_type]));
	
	    // Prevent unnecessary actions
	    if (node[state] !== true) {
	
	      // Toggle assigned radio buttons
	      if (!keep && state == _checked && node[_type] == _radio && node.name) {
	        var form = input.closest('form'),
	          inputs = 'input[name="' + node.name + '"]';
	
	        inputs = form.length ? form.find(inputs) : $(inputs);
	
	        inputs.each(function() {
	          if (this !== node && $(this).data(_iCheck)) {
	            off($(this), state);
	          }
	        });
	      }
	
	      // Indeterminate state
	      if (indeterminate) {
	
	        // Add indeterminate state
	        node[state] = true;
	
	        // Remove checked state
	        if (node[_checked]) {
	          off(input, _checked, 'force');
	        }
	
	      // Checked or disabled state
	      } else {
	
	        // Add checked or disabled state
	        if (!keep) {
	          node[state] = true;
	        }
	
	        // Remove indeterminate state
	        if (checked && node[_indeterminate]) {
	          off(input, _indeterminate, false);
	        }
	      }
	
	      // Trigger callbacks
	      callbacks(input, checked, state, keep);
	    }
	
	    // Add proper cursor
	    if (node[_disabled] && !!option(input, _cursor, true)) {
	      parent.find('.' + _iCheckHelper).css(_cursor, 'default');
	    }
	
	    // Add state class
	    parent[_add](specific || option(input, state) || '');
	
	    // Set ARIA attribute
	    if (!!parent.attr('role') && !indeterminate) {
	      parent.attr('aria-' + (disabled ? _disabled : _checked), 'true');
	    }
	
	    // Remove regular state class
	    parent[_remove](regular || option(input, callback) || '');
	  }
	
	  // Remove checked, disabled or indeterminate state
	  function off(input, state, keep) {
	    var node = input[0],
	      parent = input.parent(),
	      checked = state == _checked,
	      indeterminate = state == _indeterminate,
	      disabled = state == _disabled,
	      callback = indeterminate ? _determinate : checked ? _unchecked : 'enabled',
	      regular = option(input, callback + capitalize(node[_type])),
	      specific = option(input, state + capitalize(node[_type]));
	
	    // Prevent unnecessary actions
	    if (node[state] !== false) {
	
	      // Toggle state
	      if (indeterminate || !keep || keep == 'force') {
	        node[state] = false;
	      }
	
	      // Trigger callbacks
	      callbacks(input, checked, callback, keep);
	    }
	
	    // Add proper cursor
	    if (!node[_disabled] && !!option(input, _cursor, true)) {
	      parent.find('.' + _iCheckHelper).css(_cursor, 'pointer');
	    }
	
	    // Remove state class
	    parent[_remove](specific || option(input, state) || '');
	
	    // Set ARIA attribute
	    if (!!parent.attr('role') && !indeterminate) {
	      parent.attr('aria-' + (disabled ? _disabled : _checked), 'false');
	    }
	
	    // Add regular state class
	    parent[_add](regular || option(input, callback) || '');
	  }
	
	  // Remove all traces
	  function tidy(input, callback) {
	    if (input.data(_iCheck)) {
	
	      // Remove everything except input
	      input.parent().html(input.attr('style', input.data(_iCheck).s || ''));
	
	      // Callback
	      if (callback) {
	        input[_callback](callback);
	      }
	
	      // Unbind events
	      input.off('.i').unwrap();
	      $(_label + '[for="' + input[0].id + '"]').add(input.closest(_label)).off('.i');
	    }
	  }
	
	  // Get some option
	  function option(input, state, regular) {
	    if (input.data(_iCheck)) {
	      return input.data(_iCheck).o[state + (regular ? '' : 'Class')];
	    }
	  }
	
	  // Capitalize some string
	  function capitalize(string) {
	    return string.charAt(0).toUpperCase() + string.slice(1);
	  }
	
	  // Executable handlers
	  function callbacks(input, checked, callback, keep) {
	    if (!keep) {
	      if (checked) {
	        input[_callback]('ifToggled');
	      }
	
	      input[_callback]('ifChanged')[_callback]('if' + capitalize(callback));
	    }
	  }
	})(__webpack_provided_window_dot_jQuery || window.Zepto);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(954)))

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(983));
	__export(__webpack_require__(984));
	var normalizer_directive_1 = __webpack_require__(983);
	exports.NORMALIZER_DIRECTIVES = [
	    normalizer_directive_1.TypeNormalizerDirective
	];


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var normalizer_factory_1 = __webpack_require__(984);
	/**
	 * Directive, which adds normalizers by type attribute
	 */
	var TypeNormalizerDirective = (function () {
	    function TypeNormalizerDirective(formControl, cd, element) {
	        this.formControl = formControl;
	        this.cd = cd;
	        this.element = element;
	        this.normalizeOnBlur = true;
	    }
	    TypeNormalizerDirective.prototype.onInputChange = function () {
	        this.normalizeValue();
	    };
	    TypeNormalizerDirective.prototype.onInputBlur = function () {
	        if (this.normalizeOnBlur) {
	            this.onInputChange();
	        }
	    };
	    TypeNormalizerDirective.prototype.normalizeValue = function () {
	        //todo andrey move to constructor and remove listener if not exists
	        this.normalizer = normalizer_factory_1.NormalizerFactory.getNormalizer(this.normalizerType);
	        if (!this.normalizer) {
	            return;
	        }
	        if (this.formControl) {
	            this.currentValue = this.formControl.value;
	            var normalizeValue = this.normalizer.normalize(this.currentValue);
	            this.formControl.control.setValue(normalizeValue);
	        }
	        else if (!this.formControl) {
	            this.currentValue = this.element.nativeElement.value;
	            this.element.nativeElement.value = this.normalizer.normalize(this.currentValue);
	        }
	        else {
	            return;
	        }
	        this.cd.detectChanges();
	    };
	    __decorate([
	        core_1.Input('type'),
	        __metadata("design:type", String)
	    ], TypeNormalizerDirective.prototype, "normalizerType", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], TypeNormalizerDirective.prototype, "normalizeOnBlur", void 0);
	    TypeNormalizerDirective = __decorate([
	        core_1.Directive({
	            selector: 'input[type]',
	            host: {
	                '(keypress)': 'onInputChange()',
	                '(blur)': 'onInputBlur()',
	                '(keyup)': 'onInputChange()',
	            }
	        }),
	        __param(0, core_1.Optional()), __param(0, core_1.Self()),
	        __metadata("design:paramtypes", [forms_1.NgControl, core_1.ChangeDetectorRef, core_1.ElementRef])
	    ], TypeNormalizerDirective);
	    return TypeNormalizerDirective;
	}());
	exports.TypeNormalizerDirective = TypeNormalizerDirective;


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var phone_normalizer_1 = __webpack_require__(985);
	var money_normalizer_1 = __webpack_require__(986);
	var integer_normalizer_1 = __webpack_require__(988);
	var float_normalizer_1 = __webpack_require__(987);
	var date_normalizer_1 = __webpack_require__(989);
	var document_normalizer_1 = __webpack_require__(990);
	var constants_1 = __webpack_require__(861);
	var percentage_normalizer_1 = __webpack_require__(991);
	var input_types_1 = __webpack_require__(862);
	var percentage_decimal_normalizer_1 = __webpack_require__(992);
	var first_letter_normalizer_service_1 = __webpack_require__(993);
	/*
	 Factory to get instance of normalizer by type
	 */
	var NormalizerFactory = (function () {
	    function NormalizerFactory() {
	    }
	    NormalizerFactory.getNormalizer = function (type) {
	        switch (type) {
	            case constants_1.PHONE: {
	                return new phone_normalizer_1.PhoneNormalizer();
	            }
	            case constants_1.MONEY: {
	                return new money_normalizer_1.MoneyNormalizer();
	            }
	            case constants_1.DATE: {
	                return new date_normalizer_1.DateNormalizer();
	            }
	            case constants_1.INTEGER: {
	                return new integer_normalizer_1.IntegerNormalizer();
	            }
	            case constants_1.FLOAT: {
	                return new float_normalizer_1.FloatNormalizer();
	            }
	            case constants_1.DOCUMENT: {
	                return new document_normalizer_1.DocumentNormalizer();
	            }
	            case constants_1.PERCENTAGE: {
	                return new percentage_normalizer_1.PercentageNormalizer();
	            }
	            case input_types_1.PERCENTAGE_DECIMAL: {
	                return new percentage_decimal_normalizer_1.PercentageDecimalNormalizer();
	            }
	            case constants_1.FIRST_LETTER: {
	                return new first_letter_normalizer_service_1.FirstLetterNormalizer();
	            }
	            default: {
	                return null;
	            }
	        }
	    };
	    return NormalizerFactory;
	}());
	exports.NormalizerFactory = NormalizerFactory;


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var PHONE_CONST = {
	    openPhone: '(',
	    closePhone: ')',
	    space: ' ',
	    phoneStart: '+',
	    empty: '',
	    symbolsCount: 13
	};
	var PhoneNormalizer = (function () {
	    function PhoneNormalizer() {
	    }
	    /**
	     * Normalizer for phone type
	     * @param value
	     * @returns {string}
	     * Input value example: 443644563433
	     * Output value example: +44 (364) 456 34 33
	     */
	    PhoneNormalizer.prototype.normalize = function (value) {
	        if (!lodash_1.isString(value) || lodash_1.isEmpty(value)) {
	            return '';
	        }
	        value = PHONE_CONST.phoneStart + value.replace(/[^0-9]/g, PHONE_CONST.empty);
	        if (value.length > 3) {
	            value = value.substring(0, 3) + PHONE_CONST.space + PHONE_CONST.openPhone + value.substring(3, value.length);
	        }
	        if (value.length > 8) {
	            value = value.substring(0, 8) + PHONE_CONST.closePhone + PHONE_CONST.space + value.substring(8, value.length);
	        }
	        if (value.length > 13) {
	            value = value.substring(0, 13) + PHONE_CONST.space + value.substring(13, value.length);
	        }
	        if (value.length > 16) {
	            value = value.substring(0, 16) + PHONE_CONST.space + value.substring(16, value.length);
	        }
	        if (value.length > 19) {
	            value = value.substring(0, 19);
	        }
	        return value;
	    };
	    return PhoneNormalizer;
	}());
	exports.PhoneNormalizer = PhoneNormalizer;


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var float_normalizer_1 = __webpack_require__(987);
	var core_1 = __webpack_require__(205);
	var DOT = '.';
	var EMPTY = '';
	var digitsReg = /[^0-9]/g;
	var MoneyNormalizer = (function (_super) {
	    __extends(MoneyNormalizer, _super);
	    function MoneyNormalizer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Normalizer for money
	     * @param value
	     * @returns {string}
	     * Input value example: sdg24.532dfs.32
	     * Output value example: 24532.32
	     */
	    MoneyNormalizer.prototype.normalize = function (value) {
	        var digits = _super.prototype.normalize.call(this, value);
	        if (!lodash_1.isString(digits)) {
	            if (lodash_1.isNumber(digits)) {
	                value = Number(digits).toString();
	            }
	            else {
	                return EMPTY;
	            }
	        }
	        if (lodash_1.includes(digits, DOT)) {
	            return digits.substr(0, digits.indexOf(DOT) + 3);
	        }
	        else {
	            return digits;
	        }
	    };
	    MoneyNormalizer = __decorate([
	        core_1.Injectable()
	    ], MoneyNormalizer);
	    return MoneyNormalizer;
	}(float_normalizer_1.FloatNormalizer));
	exports.MoneyNormalizer = MoneyNormalizer;


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var DOT = '.';
	var ZERO = '0';
	var EMPTY = '';
	var availableSymbolsReg = /[^0-9.]/g;
	var digitsReg = /[^0-9]/g;
	var FloatNormalizer = (function () {
	    function FloatNormalizer() {
	    }
	    FloatNormalizer.prototype.normalize = function (value) {
	        if (!lodash_1.isString(value)) {
	            if (lodash_1.isNumber(value)) {
	                value = Number(value).toString();
	            }
	            else {
	                return EMPTY;
	            }
	        }
	        var availableSymbols = value.replace(availableSymbolsReg, EMPTY);
	        if (availableSymbols.length > 0) {
	            if (lodash_1.includes(value, DOT)) {
	                var dotIndex = lodash_1.findIndex(availableSymbols, function (val) { return val === '.'; });
	                if (dotIndex == 0) {
	                    availableSymbols = ZERO + DOT
	                        + (availableSymbols.substring(dotIndex + 1, availableSymbols.length).replace(digitsReg, EMPTY));
	                }
	                else {
	                    availableSymbols = availableSymbols.substring(0, dotIndex + 1)
	                        + (availableSymbols.substring(dotIndex + 1, availableSymbols.length).replace(digitsReg, EMPTY));
	                }
	                return availableSymbols;
	            }
	            else {
	                return availableSymbols;
	            }
	        }
	        else {
	            return EMPTY;
	        }
	    };
	    return FloatNormalizer;
	}());
	exports.FloatNormalizer = FloatNormalizer;


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var EMPTY = '';
	var IntegerNormalizer = (function () {
	    function IntegerNormalizer() {
	    }
	    IntegerNormalizer.prototype.normalize = function (value) {
	        if (!lodash_1.isString(value)) {
	            return null;
	        }
	        return value.replace(/[^0-9]/g, EMPTY);
	    };
	    return IntegerNormalizer;
	}());
	exports.IntegerNormalizer = IntegerNormalizer;


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var DATE_CONST = {
	    dot: '.',
	    empty: '',
	    symbolsCount: 13
	};
	var DateNormalizer = (function () {
	    function DateNormalizer() {
	    }
	    DateNormalizer.prototype.normalize = function (value) {
	        if (!lodash_1.isString(value)) {
	            return '';
	        }
	        value = value.replace(/[^0-9]/g, DATE_CONST.empty);
	        if (value.length >= 8) {
	            value = value.substring(0, 2) + DATE_CONST.dot + value.substring(2, 4) + DATE_CONST.dot + value.substring(4, 8);
	        }
	        else if (value.length <= 7 && value.length >= 5) {
	            value = value.substring(0, 2) + DATE_CONST.dot + value.substring(2, 4) + DATE_CONST.dot + value.substring(4, value.length);
	        }
	        else if (value.length <= 4 && value.length >= 3) {
	            value = value.substring(0, 2) + DATE_CONST.dot + value.substring(2, value.length);
	        }
	        return value;
	    };
	    return DateNormalizer;
	}());
	exports.DateNormalizer = DateNormalizer;


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var EMPTY = '';
	var DocumentNormalizer = (function () {
	    function DocumentNormalizer() {
	    }
	    DocumentNormalizer.prototype.normalize = function (value) {
	        if (!lodash_1.isString(value)) {
	            return '';
	        }
	        return value.replace(/[ ]/g, EMPTY);
	    };
	    return DocumentNormalizer;
	}());
	exports.DocumentNormalizer = DocumentNormalizer;


/***/ }),
/* 991 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var PercentageNormalizer = (function () {
	    function PercentageNormalizer() {
	    }
	    PercentageNormalizer.prototype.normalize = function (model) {
	        var percentage = parseInt(model);
	        if (percentage >= 1 && percentage <= 100) {
	            return percentage.toString();
	        }
	        if (percentage < 1) {
	            return '';
	        }
	        if (percentage > 100) {
	            if (model.startsWith('100')) {
	                return model.substring(0, 3);
	            }
	            return model.substring(0, 2);
	        }
	    };
	    return PercentageNormalizer;
	}());
	exports.PercentageNormalizer = PercentageNormalizer;


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var PercentageDecimalNormalizer = (function () {
	    function PercentageDecimalNormalizer() {
	    }
	    PercentageDecimalNormalizer.prototype.normalize = function (model) {
	        model = model.toString();
	        if (((model.indexOf('.') == 1) && (model.length == 2))
	            || ((model.indexOf('.') == 2) && (model.length == 3))) {
	            return model;
	        }
	        if (model.match(/[^.\d]/) ||
	            model.replace(/[^.]/g, "").length > 1 ||
	            model.match(/^0\d/)) {
	            return model.substring(0, model.length - 1);
	        }
	        var percentage = parseFloat(model);
	        if (!lodash_1.isNaN(percentage)) {
	            if (model.length > 5 && (model.indexOf('.') == 2)) {
	                model = model.substring(0, 5);
	            }
	            if (model.length > 4 && (model.indexOf('.') == 1)) {
	                model = model.substring(0, 4);
	            }
	            if (percentage >= 0 && percentage <= 100) {
	                return model;
	            }
	            if (percentage < 0) {
	                return '0';
	            }
	            if (percentage > 100) {
	                if (model.startsWith('100')) {
	                    return '100';
	                }
	                return model.substring(0, 2);
	            }
	        }
	        return model.substring(0, model.length - 1);
	    };
	    return PercentageDecimalNormalizer;
	}());
	exports.PercentageDecimalNormalizer = PercentageDecimalNormalizer;


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var EMPTY = '';
	var FirstLetterNormalizer = (function () {
	    function FirstLetterNormalizer() {
	        this.pattern = /[a-zA-Z]/;
	    }
	    /**
	     * Normalizer for first letter of string
	     * @param value
	     * @returns {string}
	     * Input value example: 5Albania
	     * Output value example: Albania
	     */
	    FirstLetterNormalizer.prototype.normalize = function (value) {
	        if (value) {
	            for (var i = 0; i < value.length; i++) {
	                if (this.pattern.test(value[i])) {
	                    return value.substring(i, value.length);
	                }
	            }
	        }
	        return EMPTY;
	    };
	    FirstLetterNormalizer = __decorate([
	        core_1.Injectable()
	    ], FirstLetterNormalizer);
	    return FirstLetterNormalizer;
	}());
	exports.FirstLetterNormalizer = FirstLetterNormalizer;


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(995));
	var datepicker_directive_1 = __webpack_require__(995);
	exports.DATE_PICKER_DIRECTIVES = [
	    datepicker_directive_1.DatePicker
	];


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var normalizers_1 = __webpack_require__(982);
	var model_listener_1 = __webpack_require__(961);
	var lodash_1 = __webpack_require__(268);
	var constants_1 = __webpack_require__(861);
	var $ = __webpack_require__(954);
	__webpack_require__(996);
	var DEFAULT_FORMAT = 'dd.mm.yyyy';
	exports.CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR = {
	    provide: forms_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return DatePicker; }),
	    multi: true
	};
	//Directive that adds date-picker to any element
	var DatePicker = (function (_super) {
	    __extends(DatePicker, _super);
	    function DatePicker(el) {
	        var _this = _super.call(this) || this;
	        _this.el = el;
	        _this.onChange = new core_1.EventEmitter();
	        _this.onTouchedCallback = new core_1.EventEmitter();
	        _this.normalizer = normalizers_1.NormalizerFactory.getNormalizer(constants_1.DATE);
	        return _this;
	    }
	    Object.defineProperty(DatePicker.prototype, "_dateFormat", {
	        set: function (format) {
	            if (!!format)
	                this.dateFormat = format;
	            else
	                this.dateFormat = DEFAULT_FORMAT;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ;
	    DatePicker.prototype.keyFormatter = function (newKey) {
	        return this.normalizer.normalize(newKey);
	    };
	    DatePicker.prototype.valueFormatter = function (newValue) {
	        return this.normalizer.normalize(newValue);
	    };
	    DatePicker.prototype.writeValue = function (obj, blockEventRaiser) {
	        if (blockEventRaiser === void 0) { blockEventRaiser = false; }
	        if (!lodash_1.isNil(obj)) {
	            _super.prototype.writeValue.call(this, obj);
	            var key = this.keyFormatter(obj);
	            if (!blockEventRaiser)
	                $(this.el.nativeElement).datepicker('setDate', key);
	        }
	        else {
	            _super.prototype.writeValue.call(this, '');
	            if (!blockEventRaiser)
	                $(this.el.nativeElement).datepicker('setDate', '');
	        }
	    };
	    DatePicker.prototype.ngOnInit = function () {
	        //todo andrey resolve typescript lazy loading problem
	        //lazy loading outer library
	        //noinspection TypeScriptValidateTypes,TypeScriptUnresolvedFunction
	        var _this = this;
	        //initializing bootstrap-datepicker
	        $(this.el.nativeElement).datepicker({
	            format: this.dateFormat,
	            autoclose: true,
	            maxViewMode: 2,
	            templates: {
	                leftArrow: '<i class="glyphicon glyphicon-chevron-left"></i>',
	                rightArrow: '<i class="glyphicon glyphicon-chevron-right"></i>',
	            }
	        });
	        //datepicker change detector
	        $(this.el.nativeElement).on('changeDate', function (event) {
	            if (_this.innerValue != (event.target.value)) {
	                _this.writeValue(event.target.value, true);
	            }
	        });
	        $(this.el.nativeElement).on('clearDate', function () {
	            _this.writeValue("", true);
	        });
	        // Set begin date if exists
	        if (this.startDate) {
	            $(this.el.nativeElement).datepicker('setStartDate', this.startDate);
	        }
	        // Set end date if exists
	        if (this.endDate) {
	            $(this.el.nativeElement).datepicker('setEndDate', this.endDate);
	        }
	        $(this.el.nativeElement).on("blur", function () {
	            _this.onTouchedCallback.emit();
	        });
	    };
	    __decorate([
	        core_1.Input('date-format'),
	        __metadata("design:type", String),
	        __metadata("design:paramtypes", [String])
	    ], DatePicker.prototype, "_dateFormat", null);
	    __decorate([
	        core_1.Input('default-date'),
	        __metadata("design:type", Date)
	    ], DatePicker.prototype, "defaultDate", void 0);
	    __decorate([
	        core_1.Input('start-date'),
	        __metadata("design:type", Date)
	    ], DatePicker.prototype, "startDate", void 0);
	    __decorate([
	        core_1.Input('end-date'),
	        __metadata("design:type", Date)
	    ], DatePicker.prototype, "endDate", void 0);
	    DatePicker = __decorate([
	        core_1.Directive({
	            selector: '[date-picker]',
	            providers: [exports.CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
	        }),
	        __metadata("design:paramtypes", [core_1.ElementRef])
	    ], DatePicker);
	    return DatePicker;
	}(model_listener_1.ModelListener));
	exports.DatePicker = DatePicker;


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Datepicker for Bootstrap v1.9.0 (https://github.com/uxsolutions/bootstrap-datepicker)
	 *
	 * Licensed under the Apache License v2.0 (http://www.apache.org/licenses/LICENSE-2.0)
	 */
	
	(function(factory){
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(954)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        factory(require('jquery'));
	    } else {
	        factory(jQuery);
	    }
	}(function($, undefined){
		function UTCDate(){
			return new Date(Date.UTC.apply(Date, arguments));
		}
		function UTCToday(){
			var today = new Date();
			return UTCDate(today.getFullYear(), today.getMonth(), today.getDate());
		}
		function isUTCEquals(date1, date2) {
			return (
				date1.getUTCFullYear() === date2.getUTCFullYear() &&
				date1.getUTCMonth() === date2.getUTCMonth() &&
				date1.getUTCDate() === date2.getUTCDate()
			);
		}
		function alias(method, deprecationMsg){
			return function(){
				if (deprecationMsg !== undefined) {
					$.fn.datepicker.deprecated(deprecationMsg);
				}
	
				return this[method].apply(this, arguments);
			};
		}
		function isValidDate(d) {
			return d && !isNaN(d.getTime());
		}
	
		var DateArray = (function(){
			var extras = {
				get: function(i){
					return this.slice(i)[0];
				},
				contains: function(d){
					// Array.indexOf is not cross-browser;
					// $.inArray doesn't work with Dates
					var val = d && d.valueOf();
					for (var i=0, l=this.length; i < l; i++)
	          // Use date arithmetic to allow dates with different times to match
	          if (0 <= this[i].valueOf() - val && this[i].valueOf() - val < 1000*60*60*24)
							return i;
					return -1;
				},
				remove: function(i){
					this.splice(i,1);
				},
				replace: function(new_array){
					if (!new_array)
						return;
					if (!$.isArray(new_array))
						new_array = [new_array];
					this.clear();
					this.push.apply(this, new_array);
				},
				clear: function(){
					this.length = 0;
				},
				copy: function(){
					var a = new DateArray();
					a.replace(this);
					return a;
				}
			};
	
			return function(){
				var a = [];
				a.push.apply(a, arguments);
				$.extend(a, extras);
				return a;
			};
		})();
	
	
		// Picker object
	
		var Datepicker = function(element, options){
			$.data(element, 'datepicker', this);
	
			this._events = [];
			this._secondaryEvents = [];
	
			this._process_options(options);
	
			this.dates = new DateArray();
			this.viewDate = this.o.defaultViewDate;
			this.focusDate = null;
	
			this.element = $(element);
			this.isInput = this.element.is('input');
			this.inputField = this.isInput ? this.element : this.element.find('input');
			this.component = this.element.hasClass('date') ? this.element.find('.add-on, .input-group-addon, .input-group-append, .input-group-prepend, .btn') : false;
			if (this.component && this.component.length === 0)
				this.component = false;
			this.isInline = !this.component && this.element.is('div');
	
			this.picker = $(DPGlobal.template);
	
			// Checking templates and inserting
			if (this._check_template(this.o.templates.leftArrow)) {
				this.picker.find('.prev').html(this.o.templates.leftArrow);
			}
	
			if (this._check_template(this.o.templates.rightArrow)) {
				this.picker.find('.next').html(this.o.templates.rightArrow);
			}
	
			this._buildEvents();
			this._attachEvents();
	
			if (this.isInline){
				this.picker.addClass('datepicker-inline').appendTo(this.element);
			}
			else {
				this.picker.addClass('datepicker-dropdown dropdown-menu');
			}
	
			if (this.o.rtl){
				this.picker.addClass('datepicker-rtl');
			}
	
			if (this.o.calendarWeeks) {
				this.picker.find('.datepicker-days .datepicker-switch, thead .datepicker-title, tfoot .today, tfoot .clear')
					.attr('colspan', function(i, val){
						return Number(val) + 1;
					});
			}
	
			this._process_options({
				startDate: this._o.startDate,
				endDate: this._o.endDate,
				daysOfWeekDisabled: this.o.daysOfWeekDisabled,
				daysOfWeekHighlighted: this.o.daysOfWeekHighlighted,
				datesDisabled: this.o.datesDisabled
			});
	
			this._allow_update = false;
			this.setViewMode(this.o.startView);
			this._allow_update = true;
	
			this.fillDow();
			this.fillMonths();
	
			this.update();
	
			if (this.isInline){
				this.show();
			}
		};
	
		Datepicker.prototype = {
			constructor: Datepicker,
	
			_resolveViewName: function(view){
				$.each(DPGlobal.viewModes, function(i, viewMode){
					if (view === i || $.inArray(view, viewMode.names) !== -1){
						view = i;
						return false;
					}
				});
	
				return view;
			},
	
			_resolveDaysOfWeek: function(daysOfWeek){
				if (!$.isArray(daysOfWeek))
					daysOfWeek = daysOfWeek.split(/[,\s]*/);
				return $.map(daysOfWeek, Number);
			},
	
			_check_template: function(tmp){
				try {
					// If empty
					if (tmp === undefined || tmp === "") {
						return false;
					}
					// If no html, everything ok
					if ((tmp.match(/[<>]/g) || []).length <= 0) {
						return true;
					}
					// Checking if html is fine
					var jDom = $(tmp);
					return jDom.length > 0;
				}
				catch (ex) {
					return false;
				}
			},
	
			_process_options: function(opts){
				// Store raw options for reference
				this._o = $.extend({}, this._o, opts);
				// Processed options
				var o = this.o = $.extend({}, this._o);
	
				// Check if "de-DE" style date is available, if not language should
				// fallback to 2 letter code eg "de"
				var lang = o.language;
				if (!dates[lang]){
					lang = lang.split('-')[0];
					if (!dates[lang])
						lang = defaults.language;
				}
				o.language = lang;
	
				// Retrieve view index from any aliases
				o.startView = this._resolveViewName(o.startView);
				o.minViewMode = this._resolveViewName(o.minViewMode);
				o.maxViewMode = this._resolveViewName(o.maxViewMode);
	
				// Check view is between min and max
				o.startView = Math.max(this.o.minViewMode, Math.min(this.o.maxViewMode, o.startView));
	
				// true, false, or Number > 0
				if (o.multidate !== true){
					o.multidate = Number(o.multidate) || false;
					if (o.multidate !== false)
						o.multidate = Math.max(0, o.multidate);
				}
				o.multidateSeparator = String(o.multidateSeparator);
	
				o.weekStart %= 7;
				o.weekEnd = (o.weekStart + 6) % 7;
	
				var format = DPGlobal.parseFormat(o.format);
				if (o.startDate !== -Infinity){
					if (!!o.startDate){
						if (o.startDate instanceof Date)
							o.startDate = this._local_to_utc(this._zero_time(o.startDate));
						else
							o.startDate = DPGlobal.parseDate(o.startDate, format, o.language, o.assumeNearbyYear);
					}
					else {
						o.startDate = -Infinity;
					}
				}
				if (o.endDate !== Infinity){
					if (!!o.endDate){
						if (o.endDate instanceof Date)
							o.endDate = this._local_to_utc(this._zero_time(o.endDate));
						else
							o.endDate = DPGlobal.parseDate(o.endDate, format, o.language, o.assumeNearbyYear);
					}
					else {
						o.endDate = Infinity;
					}
				}
	
				o.daysOfWeekDisabled = this._resolveDaysOfWeek(o.daysOfWeekDisabled||[]);
				o.daysOfWeekHighlighted = this._resolveDaysOfWeek(o.daysOfWeekHighlighted||[]);
	
				o.datesDisabled = o.datesDisabled||[];
				if (!$.isArray(o.datesDisabled)) {
					o.datesDisabled = o.datesDisabled.split(',');
				}
				o.datesDisabled = $.map(o.datesDisabled, function(d){
					return DPGlobal.parseDate(d, format, o.language, o.assumeNearbyYear);
				});
	
				var plc = String(o.orientation).toLowerCase().split(/\s+/g),
					_plc = o.orientation.toLowerCase();
				plc = $.grep(plc, function(word){
					return /^auto|left|right|top|bottom$/.test(word);
				});
				o.orientation = {x: 'auto', y: 'auto'};
				if (!_plc || _plc === 'auto')
					; // no action
				else if (plc.length === 1){
					switch (plc[0]){
						case 'top':
						case 'bottom':
							o.orientation.y = plc[0];
							break;
						case 'left':
						case 'right':
							o.orientation.x = plc[0];
							break;
					}
				}
				else {
					_plc = $.grep(plc, function(word){
						return /^left|right$/.test(word);
					});
					o.orientation.x = _plc[0] || 'auto';
	
					_plc = $.grep(plc, function(word){
						return /^top|bottom$/.test(word);
					});
					o.orientation.y = _plc[0] || 'auto';
				}
				if (o.defaultViewDate instanceof Date || typeof o.defaultViewDate === 'string') {
					o.defaultViewDate = DPGlobal.parseDate(o.defaultViewDate, format, o.language, o.assumeNearbyYear);
				} else if (o.defaultViewDate) {
					var year = o.defaultViewDate.year || new Date().getFullYear();
					var month = o.defaultViewDate.month || 0;
					var day = o.defaultViewDate.day || 1;
					o.defaultViewDate = UTCDate(year, month, day);
				} else {
					o.defaultViewDate = UTCToday();
				}
			},
			_applyEvents: function(evs){
				for (var i=0, el, ch, ev; i < evs.length; i++){
					el = evs[i][0];
					if (evs[i].length === 2){
						ch = undefined;
						ev = evs[i][1];
					} else if (evs[i].length === 3){
						ch = evs[i][1];
						ev = evs[i][2];
					}
					el.on(ev, ch);
				}
			},
			_unapplyEvents: function(evs){
				for (var i=0, el, ev, ch; i < evs.length; i++){
					el = evs[i][0];
					if (evs[i].length === 2){
						ch = undefined;
						ev = evs[i][1];
					} else if (evs[i].length === 3){
						ch = evs[i][1];
						ev = evs[i][2];
					}
					el.off(ev, ch);
				}
			},
			_buildEvents: function(){
	            var events = {
	                keyup: $.proxy(function(e){
	                    if ($.inArray(e.keyCode, [27, 37, 39, 38, 40, 32, 13, 9]) === -1)
	                        this.update();
	                }, this),
	                keydown: $.proxy(this.keydown, this),
	                paste: $.proxy(this.paste, this)
	            };
	
	            if (this.o.showOnFocus === true) {
	                events.focus = $.proxy(this.show, this);
	            }
	
	            if (this.isInput) { // single input
	                this._events = [
	                    [this.element, events]
	                ];
	            }
	            // component: input + button
	            else if (this.component && this.inputField.length) {
	                this._events = [
	                    // For components that are not readonly, allow keyboard nav
	                    [this.inputField, events],
	                    [this.component, {
	                        click: $.proxy(this.show, this)
	                    }]
	                ];
	            }
				else {
					this._events = [
						[this.element, {
							click: $.proxy(this.show, this),
							keydown: $.proxy(this.keydown, this)
						}]
					];
				}
				this._events.push(
					// Component: listen for blur on element descendants
					[this.element, '*', {
						blur: $.proxy(function(e){
							this._focused_from = e.target;
						}, this)
					}],
					// Input: listen for blur on element
					[this.element, {
						blur: $.proxy(function(e){
							this._focused_from = e.target;
						}, this)
					}]
				);
	
				if (this.o.immediateUpdates) {
					// Trigger input updates immediately on changed year/month
					this._events.push([this.element, {
						'changeYear changeMonth': $.proxy(function(e){
							this.update(e.date);
						}, this)
					}]);
				}
	
				this._secondaryEvents = [
					[this.picker, {
						click: $.proxy(this.click, this)
					}],
					[this.picker, '.prev, .next', {
						click: $.proxy(this.navArrowsClick, this)
					}],
					[this.picker, '.day:not(.disabled)', {
						click: $.proxy(this.dayCellClick, this)
					}],
					[$(window), {
						resize: $.proxy(this.place, this)
					}],
					[$(document), {
						'mousedown touchstart': $.proxy(function(e){
							// Clicked outside the datepicker, hide it
							if (!(
								this.element.is(e.target) ||
								this.element.find(e.target).length ||
								this.picker.is(e.target) ||
								this.picker.find(e.target).length ||
								this.isInline
							)){
								this.hide();
							}
						}, this)
					}]
				];
			},
			_attachEvents: function(){
				this._detachEvents();
				this._applyEvents(this._events);
			},
			_detachEvents: function(){
				this._unapplyEvents(this._events);
			},
			_attachSecondaryEvents: function(){
				this._detachSecondaryEvents();
				this._applyEvents(this._secondaryEvents);
			},
			_detachSecondaryEvents: function(){
				this._unapplyEvents(this._secondaryEvents);
			},
			_trigger: function(event, altdate){
				var date = altdate || this.dates.get(-1),
					local_date = this._utc_to_local(date);
	
				this.element.trigger({
					type: event,
					date: local_date,
					viewMode: this.viewMode,
					dates: $.map(this.dates, this._utc_to_local),
					format: $.proxy(function(ix, format){
						if (arguments.length === 0){
							ix = this.dates.length - 1;
							format = this.o.format;
						} else if (typeof ix === 'string'){
							format = ix;
							ix = this.dates.length - 1;
						}
						format = format || this.o.format;
						var date = this.dates.get(ix);
						return DPGlobal.formatDate(date, format, this.o.language);
					}, this)
				});
			},
	
			show: function(){
				if (this.inputField.is(':disabled') || (this.inputField.prop('readonly') && this.o.enableOnReadonly === false))
					return;
				if (!this.isInline)
					this.picker.appendTo(this.o.container);
				this.place();
				this.picker.show();
				this._attachSecondaryEvents();
				this._trigger('show');
				if ((window.navigator.msMaxTouchPoints || 'ontouchstart' in document) && this.o.disableTouchKeyboard) {
					$(this.element).blur();
				}
				return this;
			},
	
			hide: function(){
				if (this.isInline || !this.picker.is(':visible'))
					return this;
				this.focusDate = null;
				this.picker.hide().detach();
				this._detachSecondaryEvents();
				this.setViewMode(this.o.startView);
	
				if (this.o.forceParse && this.inputField.val())
					this.setValue();
				this._trigger('hide');
				return this;
			},
	
			destroy: function(){
				this.hide();
				this._detachEvents();
				this._detachSecondaryEvents();
				this.picker.remove();
				delete this.element.data().datepicker;
				if (!this.isInput){
					delete this.element.data().date;
				}
				return this;
			},
	
			paste: function(e){
				var dateString;
				if (e.originalEvent.clipboardData && e.originalEvent.clipboardData.types
					&& $.inArray('text/plain', e.originalEvent.clipboardData.types) !== -1) {
					dateString = e.originalEvent.clipboardData.getData('text/plain');
				} else if (window.clipboardData) {
					dateString = window.clipboardData.getData('Text');
				} else {
					return;
				}
				this.setDate(dateString);
				this.update();
				e.preventDefault();
			},
	
			_utc_to_local: function(utc){
				if (!utc) {
					return utc;
				}
	
				var local = new Date(utc.getTime() + (utc.getTimezoneOffset() * 60000));
	
				if (local.getTimezoneOffset() !== utc.getTimezoneOffset()) {
					local = new Date(utc.getTime() + (local.getTimezoneOffset() * 60000));
				}
	
				return local;
			},
			_local_to_utc: function(local){
				return local && new Date(local.getTime() - (local.getTimezoneOffset()*60000));
			},
			_zero_time: function(local){
				return local && new Date(local.getFullYear(), local.getMonth(), local.getDate());
			},
			_zero_utc_time: function(utc){
				return utc && UTCDate(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate());
			},
	
			getDates: function(){
				return $.map(this.dates, this._utc_to_local);
			},
	
			getUTCDates: function(){
				return $.map(this.dates, function(d){
					return new Date(d);
				});
			},
	
			getDate: function(){
				return this._utc_to_local(this.getUTCDate());
			},
	
			getUTCDate: function(){
				var selected_date = this.dates.get(-1);
				if (selected_date !== undefined) {
					return new Date(selected_date);
				} else {
					return null;
				}
			},
	
			clearDates: function(){
				this.inputField.val('');
				this.update();
				this._trigger('changeDate');
	
				if (this.o.autoclose) {
					this.hide();
				}
			},
	
			setDates: function(){
				var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
				this.update.apply(this, args);
				this._trigger('changeDate');
				this.setValue();
				return this;
			},
	
			setUTCDates: function(){
				var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
				this.setDates.apply(this, $.map(args, this._utc_to_local));
				return this;
			},
	
			setDate: alias('setDates'),
			setUTCDate: alias('setUTCDates'),
			remove: alias('destroy', 'Method `remove` is deprecated and will be removed in version 2.0. Use `destroy` instead'),
	
			setValue: function(){
				var formatted = this.getFormattedDate();
				this.inputField.val(formatted);
				return this;
			},
	
			getFormattedDate: function(format){
				if (format === undefined)
					format = this.o.format;
	
				var lang = this.o.language;
				return $.map(this.dates, function(d){
					return DPGlobal.formatDate(d, format, lang);
				}).join(this.o.multidateSeparator);
			},
	
			getStartDate: function(){
				return this.o.startDate;
			},
	
			setStartDate: function(startDate){
				this._process_options({startDate: startDate});
				this.update();
				this.updateNavArrows();
				return this;
			},
	
			getEndDate: function(){
				return this.o.endDate;
			},
	
			setEndDate: function(endDate){
				this._process_options({endDate: endDate});
				this.update();
				this.updateNavArrows();
				return this;
			},
	
			setDaysOfWeekDisabled: function(daysOfWeekDisabled){
				this._process_options({daysOfWeekDisabled: daysOfWeekDisabled});
				this.update();
				return this;
			},
	
			setDaysOfWeekHighlighted: function(daysOfWeekHighlighted){
				this._process_options({daysOfWeekHighlighted: daysOfWeekHighlighted});
				this.update();
				return this;
			},
	
			setDatesDisabled: function(datesDisabled){
				this._process_options({datesDisabled: datesDisabled});
				this.update();
				return this;
			},
	
			place: function(){
				if (this.isInline)
					return this;
				var calendarWidth = this.picker.outerWidth(),
					calendarHeight = this.picker.outerHeight(),
					visualPadding = 10,
					container = $(this.o.container),
					windowWidth = container.width(),
					scrollTop = this.o.container === 'body' ? $(document).scrollTop() : container.scrollTop(),
					appendOffset = container.offset();
	
				var parentsZindex = [0];
				this.element.parents().each(function(){
					var itemZIndex = $(this).css('z-index');
					if (itemZIndex !== 'auto' && Number(itemZIndex) !== 0) parentsZindex.push(Number(itemZIndex));
				});
				var zIndex = Math.max.apply(Math, parentsZindex) + this.o.zIndexOffset;
				var offset = this.component ? this.component.parent().offset() : this.element.offset();
				var height = this.component ? this.component.outerHeight(true) : this.element.outerHeight(false);
				var width = this.component ? this.component.outerWidth(true) : this.element.outerWidth(false);
				var left = offset.left - appendOffset.left;
				var top = offset.top - appendOffset.top;
	
				if (this.o.container !== 'body') {
					top += scrollTop;
				}
	
				this.picker.removeClass(
					'datepicker-orient-top datepicker-orient-bottom '+
					'datepicker-orient-right datepicker-orient-left'
				);
	
				if (this.o.orientation.x !== 'auto'){
					this.picker.addClass('datepicker-orient-' + this.o.orientation.x);
					if (this.o.orientation.x === 'right')
						left -= calendarWidth - width;
				}
				// auto x orientation is best-placement: if it crosses a window
				// edge, fudge it sideways
				else {
					if (offset.left < 0) {
						// component is outside the window on the left side. Move it into visible range
						this.picker.addClass('datepicker-orient-left');
						left -= offset.left - visualPadding;
					} else if (left + calendarWidth > windowWidth) {
						// the calendar passes the widow right edge. Align it to component right side
						this.picker.addClass('datepicker-orient-right');
						left += width - calendarWidth;
					} else {
						if (this.o.rtl) {
							// Default to right
							this.picker.addClass('datepicker-orient-right');
						} else {
							// Default to left
							this.picker.addClass('datepicker-orient-left');
						}
					}
				}
	
				// auto y orientation is best-situation: top or bottom, no fudging,
				// decision based on which shows more of the calendar
				var yorient = this.o.orientation.y,
					top_overflow;
				if (yorient === 'auto'){
					top_overflow = -scrollTop + top - calendarHeight;
					yorient = top_overflow < 0 ? 'bottom' : 'top';
				}
	
				this.picker.addClass('datepicker-orient-' + yorient);
				if (yorient === 'top')
					top -= calendarHeight + parseInt(this.picker.css('padding-top'));
				else
					top += height;
	
				if (this.o.rtl) {
					var right = windowWidth - (left + width);
					this.picker.css({
						top: top,
						right: right,
						zIndex: zIndex
					});
				} else {
					this.picker.css({
						top: top,
						left: left,
						zIndex: zIndex
					});
				}
				return this;
			},
	
			_allow_update: true,
			update: function(){
				if (!this._allow_update)
					return this;
	
				var oldDates = this.dates.copy(),
					dates = [],
					fromArgs = false;
				if (arguments.length){
					$.each(arguments, $.proxy(function(i, date){
						if (date instanceof Date)
							date = this._local_to_utc(date);
						dates.push(date);
					}, this));
					fromArgs = true;
				} else {
					dates = this.isInput
							? this.element.val()
							: this.element.data('date') || this.inputField.val();
					if (dates && this.o.multidate)
						dates = dates.split(this.o.multidateSeparator);
					else
						dates = [dates];
					delete this.element.data().date;
				}
	
				dates = $.map(dates, $.proxy(function(date){
					return DPGlobal.parseDate(date, this.o.format, this.o.language, this.o.assumeNearbyYear);
				}, this));
				dates = $.grep(dates, $.proxy(function(date){
					return (
						!this.dateWithinRange(date) ||
						!date
					);
				}, this), true);
				this.dates.replace(dates);
	
				if (this.o.updateViewDate) {
					if (this.dates.length)
						this.viewDate = new Date(this.dates.get(-1));
					else if (this.viewDate < this.o.startDate)
						this.viewDate = new Date(this.o.startDate);
					else if (this.viewDate > this.o.endDate)
						this.viewDate = new Date(this.o.endDate);
					else
						this.viewDate = this.o.defaultViewDate;
				}
	
				if (fromArgs){
					// setting date by clicking
					this.setValue();
					this.element.change();
				}
				else if (this.dates.length){
					// setting date by typing
					if (String(oldDates) !== String(this.dates) && fromArgs) {
						this._trigger('changeDate');
						this.element.change();
					}
				}
				if (!this.dates.length && oldDates.length) {
					this._trigger('clearDate');
					this.element.change();
				}
	
				this.fill();
				return this;
			},
	
			fillDow: function(){
	      if (this.o.showWeekDays) {
				var dowCnt = this.o.weekStart,
					html = '<tr>';
				if (this.o.calendarWeeks){
					html += '<th class="cw">&#160;</th>';
				}
				while (dowCnt < this.o.weekStart + 7){
					html += '<th class="dow';
	        if ($.inArray(dowCnt, this.o.daysOfWeekDisabled) !== -1)
	          html += ' disabled';
	        html += '">'+dates[this.o.language].daysMin[(dowCnt++)%7]+'</th>';
				}
				html += '</tr>';
				this.picker.find('.datepicker-days thead').append(html);
	      }
			},
	
			fillMonths: function(){
	      var localDate = this._utc_to_local(this.viewDate);
				var html = '';
				var focused;
				for (var i = 0; i < 12; i++){
					focused = localDate && localDate.getMonth() === i ? ' focused' : '';
					html += '<span class="month' + focused + '">' + dates[this.o.language].monthsShort[i] + '</span>';
				}
				this.picker.find('.datepicker-months td').html(html);
			},
	
			setRange: function(range){
				if (!range || !range.length)
					delete this.range;
				else
					this.range = $.map(range, function(d){
						return d.valueOf();
					});
				this.fill();
			},
	
			getClassNames: function(date){
				var cls = [],
					year = this.viewDate.getUTCFullYear(),
					month = this.viewDate.getUTCMonth(),
					today = UTCToday();
				if (date.getUTCFullYear() < year || (date.getUTCFullYear() === year && date.getUTCMonth() < month)){
					cls.push('old');
				} else if (date.getUTCFullYear() > year || (date.getUTCFullYear() === year && date.getUTCMonth() > month)){
					cls.push('new');
				}
				if (this.focusDate && date.valueOf() === this.focusDate.valueOf())
					cls.push('focused');
				// Compare internal UTC date with UTC today, not local today
				if (this.o.todayHighlight && isUTCEquals(date, today)) {
					cls.push('today');
				}
				if (this.dates.contains(date) !== -1)
					cls.push('active');
				if (!this.dateWithinRange(date)){
					cls.push('disabled');
				}
				if (this.dateIsDisabled(date)){
					cls.push('disabled', 'disabled-date');
				}
				if ($.inArray(date.getUTCDay(), this.o.daysOfWeekHighlighted) !== -1){
					cls.push('highlighted');
				}
	
				if (this.range){
					if (date > this.range[0] && date < this.range[this.range.length-1]){
						cls.push('range');
					}
					if ($.inArray(date.valueOf(), this.range) !== -1){
						cls.push('selected');
					}
					if (date.valueOf() === this.range[0]){
	          cls.push('range-start');
	        }
	        if (date.valueOf() === this.range[this.range.length-1]){
	          cls.push('range-end');
	        }
				}
				return cls;
			},
	
			_fill_yearsView: function(selector, cssClass, factor, year, startYear, endYear, beforeFn){
				var html = '';
				var step = factor / 10;
				var view = this.picker.find(selector);
				var startVal = Math.floor(year / factor) * factor;
				var endVal = startVal + step * 9;
				var focusedVal = Math.floor(this.viewDate.getFullYear() / step) * step;
				var selected = $.map(this.dates, function(d){
					return Math.floor(d.getUTCFullYear() / step) * step;
				});
	
				var classes, tooltip, before;
				for (var currVal = startVal - step; currVal <= endVal + step; currVal += step) {
					classes = [cssClass];
					tooltip = null;
	
					if (currVal === startVal - step) {
						classes.push('old');
					} else if (currVal === endVal + step) {
						classes.push('new');
					}
					if ($.inArray(currVal, selected) !== -1) {
						classes.push('active');
					}
					if (currVal < startYear || currVal > endYear) {
						classes.push('disabled');
					}
					if (currVal === focusedVal) {
					  classes.push('focused');
	        }
	
					if (beforeFn !== $.noop) {
						before = beforeFn(new Date(currVal, 0, 1));
						if (before === undefined) {
							before = {};
						} else if (typeof before === 'boolean') {
							before = {enabled: before};
						} else if (typeof before === 'string') {
							before = {classes: before};
						}
						if (before.enabled === false) {
							classes.push('disabled');
						}
						if (before.classes) {
							classes = classes.concat(before.classes.split(/\s+/));
						}
						if (before.tooltip) {
							tooltip = before.tooltip;
						}
					}
	
					html += '<span class="' + classes.join(' ') + '"' + (tooltip ? ' title="' + tooltip + '"' : '') + '>' + currVal + '</span>';
				}
	
				view.find('.datepicker-switch').text(startVal + '-' + endVal);
				view.find('td').html(html);
			},
	
			fill: function(){
				var d = new Date(this.viewDate),
					year = d.getUTCFullYear(),
					month = d.getUTCMonth(),
					startYear = this.o.startDate !== -Infinity ? this.o.startDate.getUTCFullYear() : -Infinity,
					startMonth = this.o.startDate !== -Infinity ? this.o.startDate.getUTCMonth() : -Infinity,
					endYear = this.o.endDate !== Infinity ? this.o.endDate.getUTCFullYear() : Infinity,
					endMonth = this.o.endDate !== Infinity ? this.o.endDate.getUTCMonth() : Infinity,
					todaytxt = dates[this.o.language].today || dates['en'].today || '',
					cleartxt = dates[this.o.language].clear || dates['en'].clear || '',
	        titleFormat = dates[this.o.language].titleFormat || dates['en'].titleFormat,
	        todayDate = UTCToday(),
	        titleBtnVisible = (this.o.todayBtn === true || this.o.todayBtn === 'linked') && todayDate >= this.o.startDate && todayDate <= this.o.endDate && !this.weekOfDateIsDisabled(todayDate),
					tooltip,
					before;
				if (isNaN(year) || isNaN(month))
					return;
				this.picker.find('.datepicker-days .datepicker-switch')
							.text(DPGlobal.formatDate(d, titleFormat, this.o.language));
				this.picker.find('tfoot .today')
							.text(todaytxt)
	            .css('display', titleBtnVisible ? 'table-cell' : 'none');
				this.picker.find('tfoot .clear')
							.text(cleartxt)
							.css('display', this.o.clearBtn === true ? 'table-cell' : 'none');
				this.picker.find('thead .datepicker-title')
							.text(this.o.title)
							.css('display', typeof this.o.title === 'string' && this.o.title !== '' ? 'table-cell' : 'none');
				this.updateNavArrows();
				this.fillMonths();
				var prevMonth = UTCDate(year, month, 0),
					day = prevMonth.getUTCDate();
				prevMonth.setUTCDate(day - (prevMonth.getUTCDay() - this.o.weekStart + 7)%7);
				var nextMonth = new Date(prevMonth);
				if (prevMonth.getUTCFullYear() < 100){
	        nextMonth.setUTCFullYear(prevMonth.getUTCFullYear());
	      }
				nextMonth.setUTCDate(nextMonth.getUTCDate() + 42);
				nextMonth = nextMonth.valueOf();
				var html = [];
				var weekDay, clsName;
				while (prevMonth.valueOf() < nextMonth){
					weekDay = prevMonth.getUTCDay();
					if (weekDay === this.o.weekStart){
						html.push('<tr>');
						if (this.o.calendarWeeks){
							// ISO 8601: First week contains first thursday.
							// ISO also states week starts on Monday, but we can be more abstract here.
							var
								// Start of current week: based on weekstart/current date
								ws = new Date(+prevMonth + (this.o.weekStart - weekDay - 7) % 7 * 864e5),
								// Thursday of this week
								th = new Date(Number(ws) + (7 + 4 - ws.getUTCDay()) % 7 * 864e5),
								// First Thursday of year, year from thursday
								yth = new Date(Number(yth = UTCDate(th.getUTCFullYear(), 0, 1)) + (7 + 4 - yth.getUTCDay()) % 7 * 864e5),
								// Calendar week: ms between thursdays, div ms per day, div 7 days
								calWeek = (th - yth) / 864e5 / 7 + 1;
							html.push('<td class="cw">'+ calWeek +'</td>');
						}
					}
					clsName = this.getClassNames(prevMonth);
					clsName.push('day');
	
					var content = prevMonth.getUTCDate();
	
					if (this.o.beforeShowDay !== $.noop){
						before = this.o.beforeShowDay(this._utc_to_local(prevMonth));
						if (before === undefined)
							before = {};
						else if (typeof before === 'boolean')
							before = {enabled: before};
						else if (typeof before === 'string')
							before = {classes: before};
						if (before.enabled === false)
							clsName.push('disabled');
						if (before.classes)
							clsName = clsName.concat(before.classes.split(/\s+/));
						if (before.tooltip)
							tooltip = before.tooltip;
						if (before.content)
							content = before.content;
					}
	
					//Check if uniqueSort exists (supported by jquery >=1.12 and >=2.2)
					//Fallback to unique function for older jquery versions
					if ($.isFunction($.uniqueSort)) {
						clsName = $.uniqueSort(clsName);
					} else {
						clsName = $.unique(clsName);
					}
	
					html.push('<td class="'+clsName.join(' ')+'"' + (tooltip ? ' title="'+tooltip+'"' : '') + ' data-date="' + prevMonth.getTime().toString() + '">' + content + '</td>');
					tooltip = null;
					if (weekDay === this.o.weekEnd){
						html.push('</tr>');
					}
					prevMonth.setUTCDate(prevMonth.getUTCDate() + 1);
				}
				this.picker.find('.datepicker-days tbody').html(html.join(''));
	
				var monthsTitle = dates[this.o.language].monthsTitle || dates['en'].monthsTitle || 'Months';
				var months = this.picker.find('.datepicker-months')
							.find('.datepicker-switch')
								.text(this.o.maxViewMode < 2 ? monthsTitle : year)
								.end()
							.find('tbody span').removeClass('active');
	
				$.each(this.dates, function(i, d){
					if (d.getUTCFullYear() === year)
						months.eq(d.getUTCMonth()).addClass('active');
				});
	
				if (year < startYear || year > endYear){
					months.addClass('disabled');
				}
				if (year === startYear){
					months.slice(0, startMonth).addClass('disabled');
				}
				if (year === endYear){
					months.slice(endMonth+1).addClass('disabled');
				}
	
				if (this.o.beforeShowMonth !== $.noop){
					var that = this;
					$.each(months, function(i, month){
	          var moDate = new Date(year, i, 1);
	          var before = that.o.beforeShowMonth(moDate);
						if (before === undefined)
							before = {};
						else if (typeof before === 'boolean')
							before = {enabled: before};
						else if (typeof before === 'string')
							before = {classes: before};
						if (before.enabled === false && !$(month).hasClass('disabled'))
						    $(month).addClass('disabled');
						if (before.classes)
						    $(month).addClass(before.classes);
						if (before.tooltip)
						    $(month).prop('title', before.tooltip);
					});
				}
	
				// Generating decade/years picker
				this._fill_yearsView(
					'.datepicker-years',
					'year',
					10,
					year,
					startYear,
					endYear,
					this.o.beforeShowYear
				);
	
				// Generating century/decades picker
				this._fill_yearsView(
					'.datepicker-decades',
					'decade',
					100,
					year,
					startYear,
					endYear,
					this.o.beforeShowDecade
				);
	
				// Generating millennium/centuries picker
				this._fill_yearsView(
					'.datepicker-centuries',
					'century',
					1000,
					year,
					startYear,
					endYear,
					this.o.beforeShowCentury
				);
			},
	
			updateNavArrows: function(){
				if (!this._allow_update)
					return;
	
				var d = new Date(this.viewDate),
					year = d.getUTCFullYear(),
					month = d.getUTCMonth(),
					startYear = this.o.startDate !== -Infinity ? this.o.startDate.getUTCFullYear() : -Infinity,
					startMonth = this.o.startDate !== -Infinity ? this.o.startDate.getUTCMonth() : -Infinity,
					endYear = this.o.endDate !== Infinity ? this.o.endDate.getUTCFullYear() : Infinity,
					endMonth = this.o.endDate !== Infinity ? this.o.endDate.getUTCMonth() : Infinity,
					prevIsDisabled,
					nextIsDisabled,
					factor = 1;
				switch (this.viewMode){
					case 4:
						factor *= 10;
						/* falls through */
					case 3:
						factor *= 10;
						/* falls through */
					case 2:
						factor *= 10;
						/* falls through */
					case 1:
						prevIsDisabled = Math.floor(year / factor) * factor <= startYear;
						nextIsDisabled = Math.floor(year / factor) * factor + factor > endYear;
						break;
					case 0:
						prevIsDisabled = year <= startYear && month <= startMonth;
						nextIsDisabled = year >= endYear && month >= endMonth;
						break;
				}
	
				this.picker.find('.prev').toggleClass('disabled', prevIsDisabled);
				this.picker.find('.next').toggleClass('disabled', nextIsDisabled);
			},
	
			click: function(e){
				e.preventDefault();
				e.stopPropagation();
	
				var target, dir, day, year, month;
				target = $(e.target);
	
				// Clicked on the switch
				if (target.hasClass('datepicker-switch') && this.viewMode !== this.o.maxViewMode){
					this.setViewMode(this.viewMode + 1);
				}
	
				// Clicked on today button
				if (target.hasClass('today') && !target.hasClass('day')){
					this.setViewMode(0);
					this._setDate(UTCToday(), this.o.todayBtn === 'linked' ? null : 'view');
				}
	
				// Clicked on clear button
				if (target.hasClass('clear')){
					this.clearDates();
				}
	
				if (!target.hasClass('disabled')){
					// Clicked on a month, year, decade, century
					if (target.hasClass('month')
							|| target.hasClass('year')
							|| target.hasClass('decade')
							|| target.hasClass('century')) {
						this.viewDate.setUTCDate(1);
	
						day = 1;
						if (this.viewMode === 1){
							month = target.parent().find('span').index(target);
							year = this.viewDate.getUTCFullYear();
							this.viewDate.setUTCMonth(month);
						} else {
							month = 0;
							year = Number(target.text());
							this.viewDate.setUTCFullYear(year);
						}
	
						this._trigger(DPGlobal.viewModes[this.viewMode - 1].e, this.viewDate);
	
						if (this.viewMode === this.o.minViewMode){
							this._setDate(UTCDate(year, month, day));
						} else {
							this.setViewMode(this.viewMode - 1);
							this.fill();
						}
					}
				}
	
				if (this.picker.is(':visible') && this._focused_from){
					this._focused_from.focus();
				}
				delete this._focused_from;
			},
	
			dayCellClick: function(e){
				var $target = $(e.currentTarget);
				var timestamp = $target.data('date');
				var date = new Date(timestamp);
	
				if (this.o.updateViewDate) {
					if (date.getUTCFullYear() !== this.viewDate.getUTCFullYear()) {
						this._trigger('changeYear', this.viewDate);
					}
	
					if (date.getUTCMonth() !== this.viewDate.getUTCMonth()) {
						this._trigger('changeMonth', this.viewDate);
					}
				}
				this._setDate(date);
			},
	
			// Clicked on prev or next
			navArrowsClick: function(e){
				var $target = $(e.currentTarget);
				var dir = $target.hasClass('prev') ? -1 : 1;
				if (this.viewMode !== 0){
					dir *= DPGlobal.viewModes[this.viewMode].navStep * 12;
				}
				this.viewDate = this.moveMonth(this.viewDate, dir);
				this._trigger(DPGlobal.viewModes[this.viewMode].e, this.viewDate);
				this.fill();
			},
	
			_toggle_multidate: function(date){
				var ix = this.dates.contains(date);
				if (!date){
					this.dates.clear();
				}
	
				if (ix !== -1){
					if (this.o.multidate === true || this.o.multidate > 1 || this.o.toggleActive){
						this.dates.remove(ix);
					}
				} else if (this.o.multidate === false) {
					this.dates.clear();
					this.dates.push(date);
				}
				else {
					this.dates.push(date);
				}
	
				if (typeof this.o.multidate === 'number')
					while (this.dates.length > this.o.multidate)
						this.dates.remove(0);
			},
	
			_setDate: function(date, which){
				if (!which || which === 'date')
					this._toggle_multidate(date && new Date(date));
				if ((!which && this.o.updateViewDate) || which === 'view')
					this.viewDate = date && new Date(date);
	
				this.fill();
				this.setValue();
				if (!which || which !== 'view') {
					this._trigger('changeDate');
				}
				this.inputField.trigger('change');
				if (this.o.autoclose && (!which || which === 'date')){
					this.hide();
				}
			},
	
			moveDay: function(date, dir){
				var newDate = new Date(date);
				newDate.setUTCDate(date.getUTCDate() + dir);
	
				return newDate;
			},
	
			moveWeek: function(date, dir){
				return this.moveDay(date, dir * 7);
			},
	
			moveMonth: function(date, dir){
				if (!isValidDate(date))
					return this.o.defaultViewDate;
				if (!dir)
					return date;
				var new_date = new Date(date.valueOf()),
					day = new_date.getUTCDate(),
					month = new_date.getUTCMonth(),
					mag = Math.abs(dir),
					new_month, test;
				dir = dir > 0 ? 1 : -1;
				if (mag === 1){
					test = dir === -1
						// If going back one month, make sure month is not current month
						// (eg, Mar 31 -> Feb 31 == Feb 28, not Mar 02)
						? function(){
							return new_date.getUTCMonth() === month;
						}
						// If going forward one month, make sure month is as expected
						// (eg, Jan 31 -> Feb 31 == Feb 28, not Mar 02)
						: function(){
							return new_date.getUTCMonth() !== new_month;
						};
					new_month = month + dir;
					new_date.setUTCMonth(new_month);
					// Dec -> Jan (12) or Jan -> Dec (-1) -- limit expected date to 0-11
					new_month = (new_month + 12) % 12;
				}
				else {
					// For magnitudes >1, move one month at a time...
					for (var i=0; i < mag; i++)
						// ...which might decrease the day (eg, Jan 31 to Feb 28, etc)...
						new_date = this.moveMonth(new_date, dir);
					// ...then reset the day, keeping it in the new month
					new_month = new_date.getUTCMonth();
					new_date.setUTCDate(day);
					test = function(){
						return new_month !== new_date.getUTCMonth();
					};
				}
				// Common date-resetting loop -- if date is beyond end of month, make it
				// end of month
				while (test()){
					new_date.setUTCDate(--day);
					new_date.setUTCMonth(new_month);
				}
				return new_date;
			},
	
			moveYear: function(date, dir){
				return this.moveMonth(date, dir*12);
			},
	
			moveAvailableDate: function(date, dir, fn){
				do {
					date = this[fn](date, dir);
	
					if (!this.dateWithinRange(date))
						return false;
	
					fn = 'moveDay';
				}
				while (this.dateIsDisabled(date));
	
				return date;
			},
	
			weekOfDateIsDisabled: function(date){
				return $.inArray(date.getUTCDay(), this.o.daysOfWeekDisabled) !== -1;
			},
	
			dateIsDisabled: function(date){
				return (
					this.weekOfDateIsDisabled(date) ||
					$.grep(this.o.datesDisabled, function(d){
						return isUTCEquals(date, d);
					}).length > 0
				);
			},
	
			dateWithinRange: function(date){
				return date >= this.o.startDate && date <= this.o.endDate;
			},
	
			keydown: function(e){
				if (!this.picker.is(':visible')){
					if (e.keyCode === 40 || e.keyCode === 27) { // allow down to re-show picker
						this.show();
						e.stopPropagation();
	        }
					return;
				}
				var dateChanged = false,
					dir, newViewDate,
					focusDate = this.focusDate || this.viewDate;
				switch (e.keyCode){
					case 27: // escape
						if (this.focusDate){
							this.focusDate = null;
							this.viewDate = this.dates.get(-1) || this.viewDate;
							this.fill();
						}
						else
							this.hide();
						e.preventDefault();
						e.stopPropagation();
						break;
					case 37: // left
					case 38: // up
					case 39: // right
					case 40: // down
						if (!this.o.keyboardNavigation || this.o.daysOfWeekDisabled.length === 7)
							break;
						dir = e.keyCode === 37 || e.keyCode === 38 ? -1 : 1;
	          if (this.viewMode === 0) {
	  					if (e.ctrlKey){
	  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveYear');
	
	  						if (newViewDate)
	  							this._trigger('changeYear', this.viewDate);
	  					} else if (e.shiftKey){
	  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveMonth');
	
	  						if (newViewDate)
	  							this._trigger('changeMonth', this.viewDate);
	  					} else if (e.keyCode === 37 || e.keyCode === 39){
	  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveDay');
	  					} else if (!this.weekOfDateIsDisabled(focusDate)){
	  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveWeek');
	  					}
	          } else if (this.viewMode === 1) {
	            if (e.keyCode === 38 || e.keyCode === 40) {
	              dir = dir * 4;
	            }
	            newViewDate = this.moveAvailableDate(focusDate, dir, 'moveMonth');
	          } else if (this.viewMode === 2) {
	            if (e.keyCode === 38 || e.keyCode === 40) {
	              dir = dir * 4;
	            }
	            newViewDate = this.moveAvailableDate(focusDate, dir, 'moveYear');
	          }
						if (newViewDate){
							this.focusDate = this.viewDate = newViewDate;
							this.setValue();
							this.fill();
							e.preventDefault();
						}
						break;
					case 13: // enter
						if (!this.o.forceParse)
							break;
						focusDate = this.focusDate || this.dates.get(-1) || this.viewDate;
						if (this.o.keyboardNavigation) {
							this._toggle_multidate(focusDate);
							dateChanged = true;
						}
						this.focusDate = null;
						this.viewDate = this.dates.get(-1) || this.viewDate;
						this.setValue();
						this.fill();
						if (this.picker.is(':visible')){
							e.preventDefault();
							e.stopPropagation();
							if (this.o.autoclose)
								this.hide();
						}
						break;
					case 9: // tab
						this.focusDate = null;
						this.viewDate = this.dates.get(-1) || this.viewDate;
						this.fill();
						this.hide();
						break;
				}
				if (dateChanged){
					if (this.dates.length)
						this._trigger('changeDate');
					else
						this._trigger('clearDate');
					this.inputField.trigger('change');
				}
			},
	
			setViewMode: function(viewMode){
				this.viewMode = viewMode;
				this.picker
					.children('div')
					.hide()
					.filter('.datepicker-' + DPGlobal.viewModes[this.viewMode].clsName)
						.show();
				this.updateNavArrows();
	      this._trigger('changeViewMode', new Date(this.viewDate));
			}
		};
	
		var DateRangePicker = function(element, options){
			$.data(element, 'datepicker', this);
			this.element = $(element);
			this.inputs = $.map(options.inputs, function(i){
				return i.jquery ? i[0] : i;
			});
			delete options.inputs;
	
			this.keepEmptyValues = options.keepEmptyValues;
			delete options.keepEmptyValues;
	
			datepickerPlugin.call($(this.inputs), options)
				.on('changeDate', $.proxy(this.dateUpdated, this));
	
			this.pickers = $.map(this.inputs, function(i){
				return $.data(i, 'datepicker');
			});
			this.updateDates();
		};
		DateRangePicker.prototype = {
			updateDates: function(){
				this.dates = $.map(this.pickers, function(i){
					return i.getUTCDate();
				});
				this.updateRanges();
			},
			updateRanges: function(){
				var range = $.map(this.dates, function(d){
					return d.valueOf();
				});
				$.each(this.pickers, function(i, p){
					p.setRange(range);
				});
			},
			clearDates: function(){
				$.each(this.pickers, function(i, p){
					p.clearDates();
				});
			},
			dateUpdated: function(e){
				// `this.updating` is a workaround for preventing infinite recursion
				// between `changeDate` triggering and `setUTCDate` calling.  Until
				// there is a better mechanism.
				if (this.updating)
					return;
				this.updating = true;
	
				var dp = $.data(e.target, 'datepicker');
	
				if (dp === undefined) {
					return;
				}
	
				var new_date = dp.getUTCDate(),
					keep_empty_values = this.keepEmptyValues,
					i = $.inArray(e.target, this.inputs),
					j = i - 1,
					k = i + 1,
					l = this.inputs.length;
				if (i === -1)
					return;
	
				$.each(this.pickers, function(i, p){
					if (!p.getUTCDate() && (p === dp || !keep_empty_values))
						p.setUTCDate(new_date);
				});
	
				if (new_date < this.dates[j]){
					// Date being moved earlier/left
					while (j >= 0 && new_date < this.dates[j]){
						this.pickers[j--].setUTCDate(new_date);
					}
				} else if (new_date > this.dates[k]){
					// Date being moved later/right
					while (k < l && new_date > this.dates[k]){
						this.pickers[k++].setUTCDate(new_date);
					}
				}
				this.updateDates();
	
				delete this.updating;
			},
			destroy: function(){
				$.map(this.pickers, function(p){ p.destroy(); });
				$(this.inputs).off('changeDate', this.dateUpdated);
				delete this.element.data().datepicker;
			},
			remove: alias('destroy', 'Method `remove` is deprecated and will be removed in version 2.0. Use `destroy` instead')
		};
	
		function opts_from_el(el, prefix){
			// Derive options from element data-attrs
			var data = $(el).data(),
				out = {}, inkey,
				replace = new RegExp('^' + prefix.toLowerCase() + '([A-Z])');
			prefix = new RegExp('^' + prefix.toLowerCase());
			function re_lower(_,a){
				return a.toLowerCase();
			}
			for (var key in data)
				if (prefix.test(key)){
					inkey = key.replace(replace, re_lower);
					out[inkey] = data[key];
				}
			return out;
		}
	
		function opts_from_locale(lang){
			// Derive options from locale plugins
			var out = {};
			// Check if "de-DE" style date is available, if not language should
			// fallback to 2 letter code eg "de"
			if (!dates[lang]){
				lang = lang.split('-')[0];
				if (!dates[lang])
					return;
			}
			var d = dates[lang];
			$.each(locale_opts, function(i,k){
				if (k in d)
					out[k] = d[k];
			});
			return out;
		}
	
		var old = $.fn.datepicker;
		var datepickerPlugin = function(option){
			var args = Array.apply(null, arguments);
			args.shift();
			var internal_return;
			this.each(function(){
				var $this = $(this),
					data = $this.data('datepicker'),
					options = typeof option === 'object' && option;
				if (!data){
					var elopts = opts_from_el(this, 'date'),
						// Preliminary otions
						xopts = $.extend({}, defaults, elopts, options),
						locopts = opts_from_locale(xopts.language),
						// Options priority: js args, data-attrs, locales, defaults
						opts = $.extend({}, defaults, locopts, elopts, options);
					if ($this.hasClass('input-daterange') || opts.inputs){
						$.extend(opts, {
							inputs: opts.inputs || $this.find('input').toArray()
						});
						data = new DateRangePicker(this, opts);
					}
					else {
						data = new Datepicker(this, opts);
					}
					$this.data('datepicker', data);
				}
				if (typeof option === 'string' && typeof data[option] === 'function'){
					internal_return = data[option].apply(data, args);
				}
			});
	
			if (
				internal_return === undefined ||
				internal_return instanceof Datepicker ||
				internal_return instanceof DateRangePicker
			)
				return this;
	
			if (this.length > 1)
				throw new Error('Using only allowed for the collection of a single element (' + option + ' function)');
			else
				return internal_return;
		};
		$.fn.datepicker = datepickerPlugin;
	
		var defaults = $.fn.datepicker.defaults = {
			assumeNearbyYear: false,
			autoclose: false,
			beforeShowDay: $.noop,
			beforeShowMonth: $.noop,
			beforeShowYear: $.noop,
			beforeShowDecade: $.noop,
			beforeShowCentury: $.noop,
			calendarWeeks: false,
			clearBtn: false,
			toggleActive: false,
			daysOfWeekDisabled: [],
			daysOfWeekHighlighted: [],
			datesDisabled: [],
			endDate: Infinity,
			forceParse: true,
			format: 'mm/dd/yyyy',
			keepEmptyValues: false,
			keyboardNavigation: true,
			language: 'en',
			minViewMode: 0,
			maxViewMode: 4,
			multidate: false,
			multidateSeparator: ',',
			orientation: "auto",
			rtl: false,
			startDate: -Infinity,
			startView: 0,
			todayBtn: false,
			todayHighlight: false,
			updateViewDate: true,
			weekStart: 0,
			disableTouchKeyboard: false,
			enableOnReadonly: true,
			showOnFocus: true,
			zIndexOffset: 10,
			container: 'body',
			immediateUpdates: false,
			title: '',
			templates: {
				leftArrow: '&#x00AB;',
				rightArrow: '&#x00BB;'
			},
	    showWeekDays: true
		};
		var locale_opts = $.fn.datepicker.locale_opts = [
			'format',
			'rtl',
			'weekStart'
		];
		$.fn.datepicker.Constructor = Datepicker;
		var dates = $.fn.datepicker.dates = {
			en: {
				days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
				daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
				daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
				months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
				monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
				today: "Today",
				clear: "Clear",
				titleFormat: "MM yyyy"
			}
		};
	
		var DPGlobal = {
			viewModes: [
				{
					names: ['days', 'month'],
					clsName: 'days',
					e: 'changeMonth'
				},
				{
					names: ['months', 'year'],
					clsName: 'months',
					e: 'changeYear',
					navStep: 1
				},
				{
					names: ['years', 'decade'],
					clsName: 'years',
					e: 'changeDecade',
					navStep: 10
				},
				{
					names: ['decades', 'century'],
					clsName: 'decades',
					e: 'changeCentury',
					navStep: 100
				},
				{
					names: ['centuries', 'millennium'],
					clsName: 'centuries',
					e: 'changeMillennium',
					navStep: 1000
				}
			],
			validParts: /dd?|DD?|mm?|MM?|yy(?:yy)?/g,
			nonpunctuation: /[^ -\/:-@\u5e74\u6708\u65e5\[-`{-~\t\n\r]+/g,
			parseFormat: function(format){
				if (typeof format.toValue === 'function' && typeof format.toDisplay === 'function')
	                return format;
	            // IE treats \0 as a string end in inputs (truncating the value),
				// so it's a bad format delimiter, anyway
				var separators = format.replace(this.validParts, '\0').split('\0'),
					parts = format.match(this.validParts);
				if (!separators || !separators.length || !parts || parts.length === 0){
					throw new Error("Invalid date format.");
				}
				return {separators: separators, parts: parts};
			},
			parseDate: function(date, format, language, assumeNearby){
				if (!date)
					return undefined;
				if (date instanceof Date)
					return date;
				if (typeof format === 'string')
					format = DPGlobal.parseFormat(format);
				if (format.toValue)
					return format.toValue(date, format, language);
				var fn_map = {
						d: 'moveDay',
						m: 'moveMonth',
						w: 'moveWeek',
						y: 'moveYear'
					},
					dateAliases = {
						yesterday: '-1d',
						today: '+0d',
						tomorrow: '+1d'
					},
					parts, part, dir, i, fn;
				if (date in dateAliases){
					date = dateAliases[date];
				}
				if (/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/i.test(date)){
					parts = date.match(/([\-+]\d+)([dmwy])/gi);
					date = new Date();
					for (i=0; i < parts.length; i++){
						part = parts[i].match(/([\-+]\d+)([dmwy])/i);
						dir = Number(part[1]);
						fn = fn_map[part[2].toLowerCase()];
						date = Datepicker.prototype[fn](date, dir);
					}
					return Datepicker.prototype._zero_utc_time(date);
				}
	
				parts = date && date.match(this.nonpunctuation) || [];
	
				function applyNearbyYear(year, threshold){
					if (threshold === true)
						threshold = 10;
	
					// if year is 2 digits or less, than the user most likely is trying to get a recent century
					if (year < 100){
						year += 2000;
						// if the new year is more than threshold years in advance, use last century
						if (year > ((new Date()).getFullYear()+threshold)){
							year -= 100;
						}
					}
	
					return year;
				}
	
				var parsed = {},
					setters_order = ['yyyy', 'yy', 'M', 'MM', 'm', 'mm', 'd', 'dd'],
					setters_map = {
						yyyy: function(d,v){
							return d.setUTCFullYear(assumeNearby ? applyNearbyYear(v, assumeNearby) : v);
						},
						m: function(d,v){
							if (isNaN(d))
								return d;
							v -= 1;
							while (v < 0) v += 12;
							v %= 12;
							d.setUTCMonth(v);
							while (d.getUTCMonth() !== v)
								d.setUTCDate(d.getUTCDate()-1);
							return d;
						},
						d: function(d,v){
							return d.setUTCDate(v);
						}
					},
					val, filtered;
				setters_map['yy'] = setters_map['yyyy'];
				setters_map['M'] = setters_map['MM'] = setters_map['mm'] = setters_map['m'];
				setters_map['dd'] = setters_map['d'];
				date = UTCToday();
				var fparts = format.parts.slice();
				// Remove noop parts
				if (parts.length !== fparts.length){
					fparts = $(fparts).filter(function(i,p){
						return $.inArray(p, setters_order) !== -1;
					}).toArray();
				}
				// Process remainder
				function match_part(){
					var m = this.slice(0, parts[i].length),
						p = parts[i].slice(0, m.length);
					return m.toLowerCase() === p.toLowerCase();
				}
				if (parts.length === fparts.length){
					var cnt;
					for (i=0, cnt = fparts.length; i < cnt; i++){
						val = parseInt(parts[i], 10);
						part = fparts[i];
						if (isNaN(val)){
							switch (part){
								case 'MM':
									filtered = $(dates[language].months).filter(match_part);
									val = $.inArray(filtered[0], dates[language].months) + 1;
									break;
								case 'M':
									filtered = $(dates[language].monthsShort).filter(match_part);
									val = $.inArray(filtered[0], dates[language].monthsShort) + 1;
									break;
							}
						}
						parsed[part] = val;
					}
					var _date, s;
					for (i=0; i < setters_order.length; i++){
						s = setters_order[i];
						if (s in parsed && !isNaN(parsed[s])){
							_date = new Date(date);
							setters_map[s](_date, parsed[s]);
							if (!isNaN(_date))
								date = _date;
						}
					}
				}
				return date;
			},
			formatDate: function(date, format, language){
				if (!date)
					return '';
				if (typeof format === 'string')
					format = DPGlobal.parseFormat(format);
				if (format.toDisplay)
	                return format.toDisplay(date, format, language);
	            var val = {
					d: date.getUTCDate(),
					D: dates[language].daysShort[date.getUTCDay()],
					DD: dates[language].days[date.getUTCDay()],
					m: date.getUTCMonth() + 1,
					M: dates[language].monthsShort[date.getUTCMonth()],
					MM: dates[language].months[date.getUTCMonth()],
					yy: date.getUTCFullYear().toString().substring(2),
					yyyy: date.getUTCFullYear()
				};
				val.dd = (val.d < 10 ? '0' : '') + val.d;
				val.mm = (val.m < 10 ? '0' : '') + val.m;
				date = [];
				var seps = $.extend([], format.separators);
				for (var i=0, cnt = format.parts.length; i <= cnt; i++){
					if (seps.length)
						date.push(seps.shift());
					date.push(val[format.parts[i]]);
				}
				return date.join('');
			},
			headTemplate: '<thead>'+
				              '<tr>'+
				                '<th colspan="7" class="datepicker-title"></th>'+
				              '</tr>'+
								'<tr>'+
									'<th class="prev">'+defaults.templates.leftArrow+'</th>'+
									'<th colspan="5" class="datepicker-switch"></th>'+
									'<th class="next">'+defaults.templates.rightArrow+'</th>'+
								'</tr>'+
							'</thead>',
			contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>',
			footTemplate: '<tfoot>'+
								'<tr>'+
									'<th colspan="7" class="today"></th>'+
								'</tr>'+
								'<tr>'+
									'<th colspan="7" class="clear"></th>'+
								'</tr>'+
							'</tfoot>'
		};
		DPGlobal.template = '<div class="datepicker">'+
								'<div class="datepicker-days">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										'<tbody></tbody>'+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
								'<div class="datepicker-months">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										DPGlobal.contTemplate+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
								'<div class="datepicker-years">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										DPGlobal.contTemplate+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
								'<div class="datepicker-decades">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										DPGlobal.contTemplate+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
								'<div class="datepicker-centuries">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										DPGlobal.contTemplate+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
							'</div>';
	
		$.fn.datepicker.DPGlobal = DPGlobal;
	
	
		/* DATEPICKER NO CONFLICT
		* =================== */
	
		$.fn.datepicker.noConflict = function(){
			$.fn.datepicker = old;
			return this;
		};
	
		/* DATEPICKER VERSION
		 * =================== */
		$.fn.datepicker.version = '1.9.0';
	
		$.fn.datepicker.deprecated = function(msg){
			var console = window.console;
			if (console && console.warn) {
				console.warn('DEPRECATED: ' + msg);
			}
		};
	
	
		/* DATEPICKER DATA-API
		* ================== */
	
		$(document).on(
			'focus.datepicker.data-api click.datepicker.data-api',
			'[data-provide="datepicker"]',
			function(e){
				var $this = $(this);
				if ($this.data('datepicker'))
					return;
				e.preventDefault();
				// component click requires us to explicitly show it
				datepickerPlugin.call($this, 'show');
			}
		);
		$(function(){
			datepickerPlugin.call($('[data-provide="datepicker-inline"]'));
		});
	
	}));


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var accordion_component_1 = __webpack_require__(998);
	var accordion_group_component_1 = __webpack_require__(1000);
	var accordion_header_component_1 = __webpack_require__(1016);
	var accordion_toggle_component_1 = __webpack_require__(1018);
	var accordion_content_component_1 = __webpack_require__(1020);
	exports.ACCORDION_DIRECTIVES = [
	    accordion_component_1.AccordionComponent,
	    accordion_group_component_1.AccordionGroupComponent,
	    accordion_header_component_1.AccordionHeaderComponent,
	    accordion_toggle_component_1.AccordionToggleComponent,
	    accordion_content_component_1.AccordionContentComponent
	];


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var AccordionComponent = (function () {
	    function AccordionComponent() {
	        this.closeOthers = true;
	        this.showArrows = false;
	        this.expandAll = false;
	        this.groups = [];
	    }
	    AccordionComponent.prototype.ngAfterContentInit = function () {
	        if (this.expandAll) {
	            this.closeOthers = false;
	            this.openAll();
	        }
	    };
	    AccordionComponent.prototype.closeAll = function () {
	        this.setAllGroupsState(false);
	    };
	    AccordionComponent.prototype.openAll = function () {
	        this.setAllGroupsState(true);
	    };
	    AccordionComponent.prototype.setAllGroupsState = function (state) {
	        this.groups.forEach(function (group) {
	            group.isOpened = state;
	        });
	        this.updateGroups();
	    };
	    AccordionComponent.prototype.registerGroup = function (childGroup) {
	        this.groups.push(childGroup);
	        // setTimeout(()=>{
	        if (childGroup.isOpened) {
	            childGroup.isOpened = false;
	            this.selectGroup(childGroup);
	        }
	        else {
	            this.updateGroups();
	        }
	        // });
	    };
	    AccordionComponent.prototype.selectGroup = function (group) {
	        var isOpenedBeforeWeChange = group.isOpened;
	        if (this.closeOthers) {
	            this.closeAll();
	        }
	        group.isOpened = !isOpenedBeforeWeChange;
	        this.updateGroups();
	    };
	    AccordionComponent.prototype.updateGroups = function () {
	        this.groups.forEach(function (group) { return group.updateView(); });
	    };
	    __decorate([
	        core_1.Input('close-others'),
	        __metadata("design:type", Object)
	    ], AccordionComponent.prototype, "closeOthers", void 0);
	    __decorate([
	        core_1.Input('show-arrows'),
	        __metadata("design:type", Object)
	    ], AccordionComponent.prototype, "showArrows", void 0);
	    __decorate([
	        core_1.Input('expand-all'),
	        __metadata("design:type", Object)
	    ], AccordionComponent.prototype, "expandAll", void 0);
	    AccordionComponent = __decorate([
	        core_1.Component({
	            selector: 'accordion',
	            template: __webpack_require__(999)
	        })
	    ], AccordionComponent);
	    return AccordionComponent;
	}());
	exports.AccordionComponent = AccordionComponent;


/***/ }),
/* 999 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel-group\" role=\"tablist\" aria-multiselectable=\"true\">\n    <ng-content></ng-content>\n</div>"

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var accordion_component_1 = __webpack_require__(998);
	__webpack_require__(1001);
	var $ = __webpack_require__(954);
	var AccordionGroupComponent = (function () {
	    function AccordionGroupComponent(accordion, element) {
	        this.accordion = accordion;
	        this.element = element;
	        this.onToggle = new core_1.EventEmitter();
	        this.isOpened = false;
	        this.accordionAnimationInProgress = false;
	    }
	    AccordionGroupComponent.prototype.ngAfterContentInit = function () {
	        var _this = this;
	        this.bodyEl = $(this.element.nativeElement).find('.panel-collapse');
	        this.accordion.registerGroup(this);
	        this.bodyEl.on('show.bs.collapse', function () { return _this.animationProcessingStarted(); });
	        this.bodyEl.on('hide.bs.collapse', function () { return _this.animationProcessingStarted(); });
	        this.bodyEl.on('shown.bs.collapse', function () { return _this.animationProcessingStopped(); });
	        this.bodyEl.on('hidden.bs.collapse', function () { return _this.animationProcessingStopped(); });
	    };
	    AccordionGroupComponent.prototype.toggle = function () {
	        if (!this.accordionAnimationInProgress) {
	            this.accordion.selectGroup(this);
	            this.onToggle.emit(this.isOpened);
	        }
	    };
	    AccordionGroupComponent.prototype.close = function () {
	        if (this.isOpened) {
	            this.toggle();
	        }
	    };
	    AccordionGroupComponent.prototype.open = function () {
	        if (!this.isOpened) {
	            this.toggle();
	        }
	    };
	    AccordionGroupComponent.prototype.updateView = function () {
	        this.bodyEl.collapse(this.isOpened ? 'show' : 'hide');
	    };
	    AccordionGroupComponent.prototype.animationProcessingStarted = function () {
	        this.accordionAnimationInProgress = true;
	    };
	    AccordionGroupComponent.prototype.animationProcessingStopped = function () {
	        this.accordionAnimationInProgress = false;
	    };
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], AccordionGroupComponent.prototype, "onToggle", void 0);
	    __decorate([
	        core_1.Input('heading'),
	        __metadata("design:type", String)
	    ], AccordionGroupComponent.prototype, "heading", void 0);
	    __decorate([
	        core_1.Input('is-opened'),
	        __metadata("design:type", Boolean)
	    ], AccordionGroupComponent.prototype, "isOpened", void 0);
	    AccordionGroupComponent = __decorate([
	        core_1.Component({
	            selector: 'accordion-group',
	            template: __webpack_require__(1015)
	        }),
	        __param(0, core_1.Host()),
	        __metadata("design:paramtypes", [accordion_component_1.AccordionComponent, core_1.ElementRef])
	    ], AccordionGroupComponent);
	    return AccordionGroupComponent;
	}());
	exports.AccordionGroupComponent = AccordionGroupComponent;


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	__webpack_require__(1002);
	__webpack_require__(1003);
	__webpack_require__(1004);
	__webpack_require__(1005);
	__webpack_require__(1006);
	__webpack_require__(1007);
	__webpack_require__(1008);
	__webpack_require__(1009);
	__webpack_require__(1010);
	__webpack_require__(1011);
	__webpack_require__(1012);
	__webpack_require__(1013);
	__webpack_require__(1014);


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: transition.js v3.3.7
	 * http://getbootstrap.com/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      WebkitTransition : 'webkitTransitionEnd',
	      MozTransition    : 'transitionend',
	      OTransition      : 'oTransitionEnd otransitionend',
	      transition       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // http://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false
	    var $el = this
	    $(this).one('bsTransitionEnd', function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	
	    if (!$.support.transition) return
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function (e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
	      }
	    }
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(954)))

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: alert.js v3.3.7
	 * http://getbootstrap.com/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]'
	  var Alert   = function (el) {
	    $(el).on('click', dismiss, this.close)
	  }
	
	  Alert.VERSION = '3.3.7'
	
	  Alert.TRANSITION_DURATION = 150
	
	  Alert.prototype.close = function (e) {
	    var $this    = $(this)
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = $(selector === '#' ? [] : selector)
	
	    if (e) e.preventDefault()
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert')
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'))
	
	    if (e.isDefaultPrevented()) return
	
	    $parent.removeClass('in')
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove()
	    }
	
	    $.support.transition && $parent.hasClass('fade') ?
	      $parent
	        .one('bsTransitionEnd', removeElement)
	        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
	      removeElement()
	  }
	
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.alert')
	
	      if (!data) $this.data('bs.alert', (data = new Alert(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.alert
	
	  $.fn.alert             = Plugin
	  $.fn.alert.Constructor = Alert
	
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old
	    return this
	  }
	
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(954)))

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: button.js v3.3.7
	 * http://getbootstrap.com/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.VERSION  = '3.3.7'
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state += 'Text'
	
	    if (data.resetText == null) $el.data('resetText', $el[val]())
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state])
	
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d).prop(d, true)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d).prop(d, false)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false
	        $parent.find('.active').removeClass('active')
	        this.$element.addClass('active')
	      } else if ($input.prop('type') == 'checkbox') {
	        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
	        this.$element.toggleClass('active')
	      }
	      $input.prop('checked', this.$element.hasClass('active'))
	      if (changed) $input.trigger('change')
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
	      this.$element.toggleClass('active')
	    }
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  var old = $.fn.button
	
	  $.fn.button             = Plugin
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document)
	    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      var $btn = $(e.target).closest('.btn')
	      Plugin.call($btn, 'toggle')
	      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
	        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	        e.preventDefault()
	        // The target component still receive the focus
	        if ($btn.is('input,button')) $btn.trigger('focus')
	        else $btn.find('input:visible,button:visible').first().trigger('focus')
	      }
	    })
	    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
	    })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(954)))

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: carousel.js v3.3.7
	 * http://getbootstrap.com/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      = null
	    this.sliding     = null
	    this.interval    = null
	    this.$active     = null
	    this.$items      = null
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
	      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
	      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
	  }
	
	  Carousel.VERSION  = '3.3.7'
	
	  Carousel.TRANSITION_DURATION = 600
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  }
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return
	    switch (e.which) {
	      case 37: this.prev(); break
	      case 39: this.next(); break
	      default: return
	    }
	
	    e.preventDefault()
	  }
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item')
	    return this.$items.index(item || this.$active)
	  }
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active)
	    var willWrap = (direction == 'prev' && activeIndex === 0)
	                || (direction == 'next' && activeIndex == (this.$items.length - 1))
	    if (willWrap && !this.options.wrap) return active
	    var delta = direction == 'prev' ? -1 : 1
	    var itemIndex = (activeIndex + delta) % this.$items.length
	    return this.$items.eq(itemIndex)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || this.getItemForDirection(type, $active)
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var that      = this
	
	    if ($next.hasClass('active')) return (this.sliding = false)
	
	    var relatedTarget = $next[0]
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    })
	    this.$element.trigger(slideEvent)
	    if (slideEvent.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
	      $nextIndicator && $nextIndicator.addClass('active')
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      $next[0].offsetWidth // force reflow
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one('bsTransitionEnd', function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () {
	            that.$element.trigger(slidEvent)
	          }, 0)
	        })
	        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger(slidEvent)
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  var old = $.fn.carousel
	
	  $.fn.carousel             = Plugin
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function (e) {
	    var href
	    var $this   = $(this)
	    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	    if (!$target.hasClass('carousel')) return
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    Plugin.call($target, options)
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  }
	
	  $(document)
	    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      Plugin.call($carousel, $carousel.data())
	    })
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(954)))

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: collapse.js v3.3.7
	 * http://getbootstrap.com/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.3.7'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(954)))

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: dropdown.js v3.3.7
	 * http://getbootstrap.com/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.3.7'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector && $(selector)
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(954)))

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: modal.js v3.3.7
	 * http://getbootstrap.com/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options             = options
	    this.$body               = $(document.body)
	    this.$element            = $(element)
	    this.$dialog             = this.$element.find('.modal-dialog')
	    this.$backdrop           = null
	    this.isShown             = null
	    this.originalBodyPad     = null
	    this.scrollbarWidth      = 0
	    this.ignoreBackdropClick = false
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.VERSION  = '3.3.7'
	
	  Modal.TRANSITION_DURATION = 300
	  Modal.BACKDROP_TRANSITION_DURATION = 150
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.checkScrollbar()
	    this.setScrollbar()
	    this.$body.addClass('modal-open')
	
	    this.escape()
	    this.resize()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
	      })
	    })
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      that.adjustDialog()
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element.addClass('in')
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$dialog // wait for modal to slide in
	          .one('bsTransitionEnd', function () {
	            that.$element.trigger('focus').trigger(e)
	          })
	          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	        that.$element.trigger('focus').trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	    this.resize()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .off('click.dismiss.bs.modal')
	      .off('mouseup.dismiss.bs.modal')
	
	    this.$dialog.off('mousedown.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (document !== e.target &&
	            this.$element[0] !== e.target &&
	            !this.$element.has(e.target).length) {
	          this.$element.trigger('focus')
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
	    } else {
	      $(window).off('resize.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open')
	      that.resetAdjustments()
	      that.resetScrollbar()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $(document.createElement('div'))
	        .addClass('modal-backdrop ' + animate)
	        .appendTo(this.$body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false
	          return
	        }
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus()
	          : this.hide()
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one('bsTransitionEnd', callback)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      var callbackRemove = function () {
	        that.removeBackdrop()
	        callback && callback()
	      }
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one('bsTransitionEnd', callbackRemove)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callbackRemove()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog()
	  }
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight
	
	    this.$element.css({
	      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    })
	  }
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    })
	  }
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth
	    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect()
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
	    this.scrollbarWidth = this.measureScrollbar()
	  }
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
	    this.originalBodyPad = document.body.style.paddingRight || ''
	    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
	  }
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad)
	  }
	
	  Modal.prototype.measureScrollbar = function () { // thx walsh
	    var scrollDiv = document.createElement('div')
	    scrollDiv.className = 'modal-scrollbar-measure'
	    this.$body.append(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    this.$body[0].removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  var old = $.fn.modal
	
	  $.fn.modal             = Plugin
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
	    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus')
	      })
	    })
	    Plugin.call($target, option, this)
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(954)))

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: tooltip.js v3.3.7
	 * http://getbootstrap.com/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type       = null
	    this.options    = null
	    this.enabled    = null
	    this.timeout    = null
	    this.hoverState = null
	    this.$element   = null
	    this.inState    = null
	
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.VERSION  = '3.3.7'
	
	  Tooltip.TRANSITION_DURATION = 150
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    }
	  }
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled   = true
	    this.type      = type
	    this.$element  = $(element)
	    this.options   = this.getOptions(options)
	    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
	    this.inState   = { click: false, hover: false, focus: false }
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
	    }
	
	    var triggers = this.options.trigger.split(' ')
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i]
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	      } else if (trigger != 'manual') {
	        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'
	
	        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	      }
	    }
	
	    this.options.selector ?
	      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	      this.fixTitle()
	  }
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS
	  }
	
	  Tooltip.prototype.getOptions = function (options) {
	    options = $.extend({}, this.getDefaults(), this.$element.data(), options)
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      }
	    }
	
	    return options
	  }
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options  = {}
	    var defaults = this.getDefaults()
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value
	    })
	
	    return options
	  }
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in'
	      return
	    }
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'in'
	
	    if (!self.options.delay || !self.options.delay.show) return self.show()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show()
	    }, self.options.delay.show)
	  }
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true
	    }
	
	    return false
	  }
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
	    }
	
	    if (self.isInStateTrue()) return
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'out'
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide()
	    }, self.options.delay.hide)
	  }
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type)
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e)
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
	      if (e.isDefaultPrevented() || !inDom) return
	      var that = this
	
	      var $tip = this.tip()
	
	      var tipId = this.getUID(this.type)
	
	      this.setContent()
	      $tip.attr('id', tipId)
	      this.$element.attr('aria-describedby', tipId)
	
	      if (this.options.animation) $tip.addClass('fade')
	
	      var placement = typeof this.options.placement == 'function' ?
	        this.options.placement.call(this, $tip[0], this.$element[0]) :
	        this.options.placement
	
	      var autoToken = /\s?auto?\s?/i
	      var autoPlace = autoToken.test(placement)
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'
	
	      $tip
	        .detach()
	        .css({ top: 0, left: 0, display: 'block' })
	        .addClass(placement)
	        .data('bs.' + this.type, this)
	
	      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
	      this.$element.trigger('inserted.bs.' + this.type)
	
	      var pos          = this.getPosition()
	      var actualWidth  = $tip[0].offsetWidth
	      var actualHeight = $tip[0].offsetHeight
	
	      if (autoPlace) {
	        var orgPlacement = placement
	        var viewportDim = this.getPosition(this.$viewport)
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
	                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
	                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
	                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
	                    placement
	
	        $tip
	          .removeClass(orgPlacement)
	          .addClass(placement)
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)
	
	      this.applyPlacement(calculatedOffset, placement)
	
	      var complete = function () {
	        var prevHoverState = that.hoverState
	        that.$element.trigger('shown.bs.' + that.type)
	        that.hoverState = null
	
	        if (prevHoverState == 'out') that.leave(that)
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        $tip
	          .one('bsTransitionEnd', complete)
	          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	        complete()
	    }
	  }
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip   = this.tip()
	    var width  = $tip[0].offsetWidth
	    var height = $tip[0].offsetHeight
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10)
	    var marginLeft = parseInt($tip.css('margin-left'), 10)
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop))  marginTop  = 0
	    if (isNaN(marginLeft)) marginLeft = 0
	
	    offset.top  += marginTop
	    offset.left += marginLeft
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function (props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        })
	      }
	    }, offset), 0)
	
	    $tip.addClass('in')
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth  = $tip[0].offsetWidth
	    var actualHeight = $tip[0].offsetHeight
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)
	
	    if (delta.left) offset.left += delta.left
	    else offset.top += delta.top
	
	    var isVertical          = /top|bottom/.test(placement)
	    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'
	
	    $tip.offset(offset)
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
	  }
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow()
	      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
	      .css(isVertical ? 'top' : 'left', '')
	  }
	
	  Tooltip.prototype.setContent = function () {
	    var $tip  = this.tip()
	    var title = this.getTitle()
	
	    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
	    $tip.removeClass('fade in top bottom left right')
	  }
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this
	    var $tip = $(this.$tip)
	    var e    = $.Event('hide.bs.' + this.type)
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach()
	      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
	        that.$element
	          .removeAttr('aria-describedby')
	          .trigger('hidden.bs.' + that.type)
	      }
	      callback && callback()
	    }
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    $tip.removeClass('in')
	
	    $.support.transition && $tip.hasClass('fade') ?
	      $tip
	        .one('bsTransitionEnd', complete)
	        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	      complete()
	
	    this.hoverState = null
	
	    return this
	  }
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	    }
	  }
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle()
	  }
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element   = $element || this.$element
	
	    var el     = $element[0]
	    var isBody = el.tagName == 'BODY'
	
	    var elRect    = el.getBoundingClientRect()
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
	    }
	    var isSvg = window.SVGElement && el instanceof window.SVGElement
	    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
	    // See https://github.com/twbs/bootstrap/issues/20280
	    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
	    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset)
	  }
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }
	
	  }
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 }
	    if (!this.$viewport) return delta
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
	    var viewportDimensions = this.getPosition(this.$viewport)
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
	      if (topEdgeOffset < viewportDimensions.top) { // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
	      }
	    } else {
	      var leftEdgeOffset  = pos.left - viewportPadding
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
	      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset
	      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
	      }
	    }
	
	    return delta
	  }
	
	  Tooltip.prototype.getTitle = function () {
	    var title
	    var $e = this.$element
	    var o  = this.options
	
	    title = $e.attr('data-original-title')
	      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	    return title
	  }
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do prefix += ~~(Math.random() * 1000000)
	    while (document.getElementById(prefix))
	    return prefix
	  }
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template)
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
	      }
	    }
	    return this.$tip
	  }
	
	  Tooltip.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
	  }
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true
	  }
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false
	  }
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled
	  }
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type)
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
	        $(e.currentTarget).data('bs.' + this.type, self)
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click
	      if (self.isInStateTrue()) self.enter(self)
	      else self.leave(self)
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
	    }
	  }
	
	  Tooltip.prototype.destroy = function () {
	    var that = this
	    clearTimeout(this.timeout)
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type)
	      if (that.$tip) {
	        that.$tip.detach()
	      }
	      that.$tip = null
	      that.$arrow = null
	      that.$viewport = null
	      that.$element = null
	    })
	  }
	
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.tooltip')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip             = Plugin
	  $.fn.tooltip.Constructor = Tooltip
	
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(954)))

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: popover.js v3.3.7
	 * http://getbootstrap.com/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options)
	  }
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')
	
	  Popover.VERSION  = '3.3.7'
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  })
	
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)
	
	  Popover.prototype.constructor = Popover
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS
	  }
	
	  Popover.prototype.setContent = function () {
	    var $tip    = this.tip()
	    var title   = this.getTitle()
	    var content = this.getContent()
	
	    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
	    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
	      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
	    ](content)
	
	    $tip.removeClass('fade top bottom left right in')
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
	  }
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent()
	  }
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element
	    var o  = this.options
	
	    return $e.attr('data-content')
	      || (typeof o.content == 'function' ?
	            o.content.call($e[0]) :
	            o.content)
	  }
	
	  Popover.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
	  }
	
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.popover')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.popover
	
	  $.fn.popover             = Plugin
	  $.fn.popover.Constructor = Popover
	
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old
	    return this
	  }
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(954)))

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: scrollspy.js v3.3.7
	 * http://getbootstrap.com/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body          = $(document.body)
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
	    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
	    this.selector       = (this.options.target || '') + ' .nav li > a'
	    this.offsets        = []
	    this.targets        = []
	    this.activeTarget   = null
	    this.scrollHeight   = 0
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
	    this.refresh()
	    this.process()
	  }
	
	  ScrollSpy.VERSION  = '3.3.7'
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  }
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	  }
	
	  ScrollSpy.prototype.refresh = function () {
	    var that          = this
	    var offsetMethod  = 'offset'
	    var offsetBase    = 0
	
	    this.offsets      = []
	    this.targets      = []
	    this.scrollHeight = this.getScrollHeight()
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position'
	      offsetBase   = this.$scrollElement.scrollTop()
	    }
	
	    this.$body
	      .find(this.selector)
	      .map(function () {
	        var $el   = $(this)
	        var href  = $el.data('target') || $el.attr('href')
	        var $href = /^#./.test(href) && $(href)
	
	        return ($href
	          && $href.length
	          && $href.is(':visible')
	          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
	      })
	      .sort(function (a, b) { return a[0] - b[0] })
	      .each(function () {
	        that.offsets.push(this[0])
	        that.targets.push(this[1])
	      })
	  }
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
	    var scrollHeight = this.getScrollHeight()
	    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
	    var offsets      = this.offsets
	    var targets      = this.targets
	    var activeTarget = this.activeTarget
	    var i
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh()
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null
	      return this.clear()
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i]
	        && scrollTop >= offsets[i]
	        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
	        && this.activate(targets[i])
	    }
	  }
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target
	
	    this.clear()
	
	    var selector = this.selector +
	      '[data-target="' + target + '"],' +
	      this.selector + '[href="' + target + '"]'
	
	    var active = $(selector)
	      .parents('li')
	      .addClass('active')
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active
	        .closest('li.dropdown')
	        .addClass('active')
	    }
	
	    active.trigger('activate.bs.scrollspy')
	  }
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector)
	      .parentsUntil(this.options.target, '.active')
	      .removeClass('active')
	  }
	
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.scrollspy')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.scrollspy
	
	  $.fn.scrollspy             = Plugin
	  $.fn.scrollspy.Constructor = ScrollSpy
	
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old
	    return this
	  }
	
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this)
	      Plugin.call($spy, $spy.data())
	    })
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(954)))

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: tab.js v3.3.7
	 * http://getbootstrap.com/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element)
	    // jscs:enable requireDollarBeforejQueryAssignment
	  }
	
	  Tab.VERSION = '3.3.7'
	
	  Tab.TRANSITION_DURATION = 150
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var $previous = $ul.find('.active:last a')
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    })
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    })
	
	    $previous.trigger(hideEvent)
	    $this.trigger(showEvent)
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return
	
	    var $target = $(selector)
	
	    this.activate($this.closest('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      })
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	          .removeClass('active')
	        .end()
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', false)
	
	      element
	        .addClass('active')
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', true)
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element
	          .closest('li.dropdown')
	            .addClass('active')
	          .end()
	          .find('[data-toggle="tab"]')
	            .attr('aria-expanded', true)
	      }
	
	      callback && callback()
	    }
	
	    $active.length && transition ?
	      $active
	        .one('bsTransitionEnd', next)
	        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tab
	
	  $.fn.tab             = Plugin
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function (e) {
	    e.preventDefault()
	    Plugin.call($(this), 'show')
	  }
	
	  $(document)
	    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(954)))

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
	 * Bootstrap: affix.js v3.3.7
	 * http://getbootstrap.com/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function (element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options)
	
	    this.$target = $(this.options.target)
	      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
	      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))
	
	    this.$element     = $(element)
	    this.affixed      = null
	    this.unpin        = null
	    this.pinnedOffset = null
	
	    this.checkPosition()
	  }
	
	  Affix.VERSION  = '3.3.7'
	
	  Affix.RESET    = 'affix affix-top affix-bottom'
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  }
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop    = this.$target.scrollTop()
	    var position     = this.$element.offset()
	    var targetHeight = this.$target.height()
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
	      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
	    }
	
	    var initializing   = this.affixed == null
	    var colliderTop    = initializing ? scrollTop : position.top
	    var colliderHeight = initializing ? targetHeight : height
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
	    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'
	
	    return false
	  }
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset
	    this.$element.removeClass(Affix.RESET).addClass('affix')
	    var scrollTop = this.$target.scrollTop()
	    var position  = this.$element.offset()
	    return (this.pinnedOffset = position.top - scrollTop)
	  }
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1)
	  }
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return
	
	    var height       = this.$element.height()
	    var offset       = this.options.offset
	    var offsetTop    = offset.top
	    var offsetBottom = offset.bottom
	    var scrollHeight = Math.max($(document).height(), $(document.body).height())
	
	    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
	    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '')
	
	      var affixType = 'affix' + (affix ? '-' + affix : '')
	      var e         = $.Event(affixType + '.bs.affix')
	
	      this.$element.trigger(e)
	
	      if (e.isDefaultPrevented()) return
	
	      this.affixed = affix
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null
	
	      this.$element
	        .removeClass(Affix.RESET)
	        .addClass(affixType)
	        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      })
	    }
	  }
	
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.affix')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.affix
	
	  $.fn.affix             = Plugin
	  $.fn.affix.Constructor = Affix
	
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old
	    return this
	  }
	
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this)
	      var data = $spy.data()
	
	      data.offset = data.offset || {}
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
	      if (data.offsetTop    != null) data.offset.top    = data.offsetTop
	
	      Plugin.call($spy, data)
	    })
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(954)))

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	 * Bootstrap v3.3.7 (http://getbootstrap.com)
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under the MIT license
	 */
	
	if (typeof jQuery === 'undefined') {
	  throw new Error('Bootstrap\'s JavaScript requires jQuery')
	}
	
	+function ($) {
	  'use strict';
	  var version = $.fn.jquery.split(' ')[0].split('.')
	  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
	    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')
	  }
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: transition.js v3.3.7
	 * http://getbootstrap.com/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      WebkitTransition : 'webkitTransitionEnd',
	      MozTransition    : 'transitionend',
	      OTransition      : 'oTransitionEnd otransitionend',
	      transition       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // http://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false
	    var $el = this
	    $(this).one('bsTransitionEnd', function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	
	    if (!$.support.transition) return
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function (e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
	      }
	    }
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: alert.js v3.3.7
	 * http://getbootstrap.com/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]'
	  var Alert   = function (el) {
	    $(el).on('click', dismiss, this.close)
	  }
	
	  Alert.VERSION = '3.3.7'
	
	  Alert.TRANSITION_DURATION = 150
	
	  Alert.prototype.close = function (e) {
	    var $this    = $(this)
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = $(selector === '#' ? [] : selector)
	
	    if (e) e.preventDefault()
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert')
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'))
	
	    if (e.isDefaultPrevented()) return
	
	    $parent.removeClass('in')
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove()
	    }
	
	    $.support.transition && $parent.hasClass('fade') ?
	      $parent
	        .one('bsTransitionEnd', removeElement)
	        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
	      removeElement()
	  }
	
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.alert')
	
	      if (!data) $this.data('bs.alert', (data = new Alert(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.alert
	
	  $.fn.alert             = Plugin
	  $.fn.alert.Constructor = Alert
	
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old
	    return this
	  }
	
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: button.js v3.3.7
	 * http://getbootstrap.com/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.VERSION  = '3.3.7'
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state += 'Text'
	
	    if (data.resetText == null) $el.data('resetText', $el[val]())
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state])
	
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d).prop(d, true)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d).prop(d, false)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false
	        $parent.find('.active').removeClass('active')
	        this.$element.addClass('active')
	      } else if ($input.prop('type') == 'checkbox') {
	        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
	        this.$element.toggleClass('active')
	      }
	      $input.prop('checked', this.$element.hasClass('active'))
	      if (changed) $input.trigger('change')
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
	      this.$element.toggleClass('active')
	    }
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  var old = $.fn.button
	
	  $.fn.button             = Plugin
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document)
	    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      var $btn = $(e.target).closest('.btn')
	      Plugin.call($btn, 'toggle')
	      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
	        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	        e.preventDefault()
	        // The target component still receive the focus
	        if ($btn.is('input,button')) $btn.trigger('focus')
	        else $btn.find('input:visible,button:visible').first().trigger('focus')
	      }
	    })
	    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
	    })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: carousel.js v3.3.7
	 * http://getbootstrap.com/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      = null
	    this.sliding     = null
	    this.interval    = null
	    this.$active     = null
	    this.$items      = null
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
	      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
	      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
	  }
	
	  Carousel.VERSION  = '3.3.7'
	
	  Carousel.TRANSITION_DURATION = 600
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  }
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return
	    switch (e.which) {
	      case 37: this.prev(); break
	      case 39: this.next(); break
	      default: return
	    }
	
	    e.preventDefault()
	  }
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item')
	    return this.$items.index(item || this.$active)
	  }
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active)
	    var willWrap = (direction == 'prev' && activeIndex === 0)
	                || (direction == 'next' && activeIndex == (this.$items.length - 1))
	    if (willWrap && !this.options.wrap) return active
	    var delta = direction == 'prev' ? -1 : 1
	    var itemIndex = (activeIndex + delta) % this.$items.length
	    return this.$items.eq(itemIndex)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || this.getItemForDirection(type, $active)
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var that      = this
	
	    if ($next.hasClass('active')) return (this.sliding = false)
	
	    var relatedTarget = $next[0]
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    })
	    this.$element.trigger(slideEvent)
	    if (slideEvent.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
	      $nextIndicator && $nextIndicator.addClass('active')
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      $next[0].offsetWidth // force reflow
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one('bsTransitionEnd', function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () {
	            that.$element.trigger(slidEvent)
	          }, 0)
	        })
	        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger(slidEvent)
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  var old = $.fn.carousel
	
	  $.fn.carousel             = Plugin
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function (e) {
	    var href
	    var $this   = $(this)
	    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	    if (!$target.hasClass('carousel')) return
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    Plugin.call($target, options)
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  }
	
	  $(document)
	    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      Plugin.call($carousel, $carousel.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: collapse.js v3.3.7
	 * http://getbootstrap.com/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.3.7'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: dropdown.js v3.3.7
	 * http://getbootstrap.com/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.3.7'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector && $(selector)
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: modal.js v3.3.7
	 * http://getbootstrap.com/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options             = options
	    this.$body               = $(document.body)
	    this.$element            = $(element)
	    this.$dialog             = this.$element.find('.modal-dialog')
	    this.$backdrop           = null
	    this.isShown             = null
	    this.originalBodyPad     = null
	    this.scrollbarWidth      = 0
	    this.ignoreBackdropClick = false
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.VERSION  = '3.3.7'
	
	  Modal.TRANSITION_DURATION = 300
	  Modal.BACKDROP_TRANSITION_DURATION = 150
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.checkScrollbar()
	    this.setScrollbar()
	    this.$body.addClass('modal-open')
	
	    this.escape()
	    this.resize()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
	      })
	    })
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      that.adjustDialog()
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element.addClass('in')
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$dialog // wait for modal to slide in
	          .one('bsTransitionEnd', function () {
	            that.$element.trigger('focus').trigger(e)
	          })
	          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	        that.$element.trigger('focus').trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	    this.resize()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .off('click.dismiss.bs.modal')
	      .off('mouseup.dismiss.bs.modal')
	
	    this.$dialog.off('mousedown.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (document !== e.target &&
	            this.$element[0] !== e.target &&
	            !this.$element.has(e.target).length) {
	          this.$element.trigger('focus')
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
	    } else {
	      $(window).off('resize.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open')
	      that.resetAdjustments()
	      that.resetScrollbar()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $(document.createElement('div'))
	        .addClass('modal-backdrop ' + animate)
	        .appendTo(this.$body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false
	          return
	        }
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus()
	          : this.hide()
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one('bsTransitionEnd', callback)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      var callbackRemove = function () {
	        that.removeBackdrop()
	        callback && callback()
	      }
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one('bsTransitionEnd', callbackRemove)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callbackRemove()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog()
	  }
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight
	
	    this.$element.css({
	      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    })
	  }
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    })
	  }
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth
	    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect()
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
	    this.scrollbarWidth = this.measureScrollbar()
	  }
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
	    this.originalBodyPad = document.body.style.paddingRight || ''
	    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
	  }
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad)
	  }
	
	  Modal.prototype.measureScrollbar = function () { // thx walsh
	    var scrollDiv = document.createElement('div')
	    scrollDiv.className = 'modal-scrollbar-measure'
	    this.$body.append(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    this.$body[0].removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  var old = $.fn.modal
	
	  $.fn.modal             = Plugin
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
	    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus')
	      })
	    })
	    Plugin.call($target, option, this)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tooltip.js v3.3.7
	 * http://getbootstrap.com/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type       = null
	    this.options    = null
	    this.enabled    = null
	    this.timeout    = null
	    this.hoverState = null
	    this.$element   = null
	    this.inState    = null
	
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.VERSION  = '3.3.7'
	
	  Tooltip.TRANSITION_DURATION = 150
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    }
	  }
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled   = true
	    this.type      = type
	    this.$element  = $(element)
	    this.options   = this.getOptions(options)
	    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
	    this.inState   = { click: false, hover: false, focus: false }
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
	    }
	
	    var triggers = this.options.trigger.split(' ')
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i]
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	      } else if (trigger != 'manual') {
	        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'
	
	        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	      }
	    }
	
	    this.options.selector ?
	      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	      this.fixTitle()
	  }
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS
	  }
	
	  Tooltip.prototype.getOptions = function (options) {
	    options = $.extend({}, this.getDefaults(), this.$element.data(), options)
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      }
	    }
	
	    return options
	  }
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options  = {}
	    var defaults = this.getDefaults()
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value
	    })
	
	    return options
	  }
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in'
	      return
	    }
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'in'
	
	    if (!self.options.delay || !self.options.delay.show) return self.show()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show()
	    }, self.options.delay.show)
	  }
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true
	    }
	
	    return false
	  }
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
	    }
	
	    if (self.isInStateTrue()) return
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'out'
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide()
	    }, self.options.delay.hide)
	  }
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type)
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e)
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
	      if (e.isDefaultPrevented() || !inDom) return
	      var that = this
	
	      var $tip = this.tip()
	
	      var tipId = this.getUID(this.type)
	
	      this.setContent()
	      $tip.attr('id', tipId)
	      this.$element.attr('aria-describedby', tipId)
	
	      if (this.options.animation) $tip.addClass('fade')
	
	      var placement = typeof this.options.placement == 'function' ?
	        this.options.placement.call(this, $tip[0], this.$element[0]) :
	        this.options.placement
	
	      var autoToken = /\s?auto?\s?/i
	      var autoPlace = autoToken.test(placement)
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'
	
	      $tip
	        .detach()
	        .css({ top: 0, left: 0, display: 'block' })
	        .addClass(placement)
	        .data('bs.' + this.type, this)
	
	      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
	      this.$element.trigger('inserted.bs.' + this.type)
	
	      var pos          = this.getPosition()
	      var actualWidth  = $tip[0].offsetWidth
	      var actualHeight = $tip[0].offsetHeight
	
	      if (autoPlace) {
	        var orgPlacement = placement
	        var viewportDim = this.getPosition(this.$viewport)
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
	                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
	                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
	                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
	                    placement
	
	        $tip
	          .removeClass(orgPlacement)
	          .addClass(placement)
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)
	
	      this.applyPlacement(calculatedOffset, placement)
	
	      var complete = function () {
	        var prevHoverState = that.hoverState
	        that.$element.trigger('shown.bs.' + that.type)
	        that.hoverState = null
	
	        if (prevHoverState == 'out') that.leave(that)
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        $tip
	          .one('bsTransitionEnd', complete)
	          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	        complete()
	    }
	  }
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip   = this.tip()
	    var width  = $tip[0].offsetWidth
	    var height = $tip[0].offsetHeight
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10)
	    var marginLeft = parseInt($tip.css('margin-left'), 10)
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop))  marginTop  = 0
	    if (isNaN(marginLeft)) marginLeft = 0
	
	    offset.top  += marginTop
	    offset.left += marginLeft
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function (props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        })
	      }
	    }, offset), 0)
	
	    $tip.addClass('in')
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth  = $tip[0].offsetWidth
	    var actualHeight = $tip[0].offsetHeight
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)
	
	    if (delta.left) offset.left += delta.left
	    else offset.top += delta.top
	
	    var isVertical          = /top|bottom/.test(placement)
	    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'
	
	    $tip.offset(offset)
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
	  }
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow()
	      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
	      .css(isVertical ? 'top' : 'left', '')
	  }
	
	  Tooltip.prototype.setContent = function () {
	    var $tip  = this.tip()
	    var title = this.getTitle()
	
	    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
	    $tip.removeClass('fade in top bottom left right')
	  }
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this
	    var $tip = $(this.$tip)
	    var e    = $.Event('hide.bs.' + this.type)
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach()
	      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
	        that.$element
	          .removeAttr('aria-describedby')
	          .trigger('hidden.bs.' + that.type)
	      }
	      callback && callback()
	    }
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    $tip.removeClass('in')
	
	    $.support.transition && $tip.hasClass('fade') ?
	      $tip
	        .one('bsTransitionEnd', complete)
	        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	      complete()
	
	    this.hoverState = null
	
	    return this
	  }
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	    }
	  }
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle()
	  }
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element   = $element || this.$element
	
	    var el     = $element[0]
	    var isBody = el.tagName == 'BODY'
	
	    var elRect    = el.getBoundingClientRect()
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
	    }
	    var isSvg = window.SVGElement && el instanceof window.SVGElement
	    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
	    // See https://github.com/twbs/bootstrap/issues/20280
	    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
	    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset)
	  }
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }
	
	  }
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 }
	    if (!this.$viewport) return delta
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
	    var viewportDimensions = this.getPosition(this.$viewport)
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
	      if (topEdgeOffset < viewportDimensions.top) { // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
	      }
	    } else {
	      var leftEdgeOffset  = pos.left - viewportPadding
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
	      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset
	      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
	      }
	    }
	
	    return delta
	  }
	
	  Tooltip.prototype.getTitle = function () {
	    var title
	    var $e = this.$element
	    var o  = this.options
	
	    title = $e.attr('data-original-title')
	      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	    return title
	  }
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do prefix += ~~(Math.random() * 1000000)
	    while (document.getElementById(prefix))
	    return prefix
	  }
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template)
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
	      }
	    }
	    return this.$tip
	  }
	
	  Tooltip.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
	  }
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true
	  }
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false
	  }
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled
	  }
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type)
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
	        $(e.currentTarget).data('bs.' + this.type, self)
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click
	      if (self.isInStateTrue()) self.enter(self)
	      else self.leave(self)
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
	    }
	  }
	
	  Tooltip.prototype.destroy = function () {
	    var that = this
	    clearTimeout(this.timeout)
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type)
	      if (that.$tip) {
	        that.$tip.detach()
	      }
	      that.$tip = null
	      that.$arrow = null
	      that.$viewport = null
	      that.$element = null
	    })
	  }
	
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.tooltip')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip             = Plugin
	  $.fn.tooltip.Constructor = Tooltip
	
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: popover.js v3.3.7
	 * http://getbootstrap.com/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options)
	  }
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')
	
	  Popover.VERSION  = '3.3.7'
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  })
	
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)
	
	  Popover.prototype.constructor = Popover
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS
	  }
	
	  Popover.prototype.setContent = function () {
	    var $tip    = this.tip()
	    var title   = this.getTitle()
	    var content = this.getContent()
	
	    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
	    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
	      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
	    ](content)
	
	    $tip.removeClass('fade top bottom left right in')
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
	  }
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent()
	  }
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element
	    var o  = this.options
	
	    return $e.attr('data-content')
	      || (typeof o.content == 'function' ?
	            o.content.call($e[0]) :
	            o.content)
	  }
	
	  Popover.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
	  }
	
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.popover')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.popover
	
	  $.fn.popover             = Plugin
	  $.fn.popover.Constructor = Popover
	
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: scrollspy.js v3.3.7
	 * http://getbootstrap.com/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body          = $(document.body)
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
	    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
	    this.selector       = (this.options.target || '') + ' .nav li > a'
	    this.offsets        = []
	    this.targets        = []
	    this.activeTarget   = null
	    this.scrollHeight   = 0
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
	    this.refresh()
	    this.process()
	  }
	
	  ScrollSpy.VERSION  = '3.3.7'
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  }
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	  }
	
	  ScrollSpy.prototype.refresh = function () {
	    var that          = this
	    var offsetMethod  = 'offset'
	    var offsetBase    = 0
	
	    this.offsets      = []
	    this.targets      = []
	    this.scrollHeight = this.getScrollHeight()
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position'
	      offsetBase   = this.$scrollElement.scrollTop()
	    }
	
	    this.$body
	      .find(this.selector)
	      .map(function () {
	        var $el   = $(this)
	        var href  = $el.data('target') || $el.attr('href')
	        var $href = /^#./.test(href) && $(href)
	
	        return ($href
	          && $href.length
	          && $href.is(':visible')
	          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
	      })
	      .sort(function (a, b) { return a[0] - b[0] })
	      .each(function () {
	        that.offsets.push(this[0])
	        that.targets.push(this[1])
	      })
	  }
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
	    var scrollHeight = this.getScrollHeight()
	    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
	    var offsets      = this.offsets
	    var targets      = this.targets
	    var activeTarget = this.activeTarget
	    var i
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh()
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null
	      return this.clear()
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i]
	        && scrollTop >= offsets[i]
	        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
	        && this.activate(targets[i])
	    }
	  }
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target
	
	    this.clear()
	
	    var selector = this.selector +
	      '[data-target="' + target + '"],' +
	      this.selector + '[href="' + target + '"]'
	
	    var active = $(selector)
	      .parents('li')
	      .addClass('active')
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active
	        .closest('li.dropdown')
	        .addClass('active')
	    }
	
	    active.trigger('activate.bs.scrollspy')
	  }
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector)
	      .parentsUntil(this.options.target, '.active')
	      .removeClass('active')
	  }
	
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.scrollspy')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.scrollspy
	
	  $.fn.scrollspy             = Plugin
	  $.fn.scrollspy.Constructor = ScrollSpy
	
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old
	    return this
	  }
	
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this)
	      Plugin.call($spy, $spy.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tab.js v3.3.7
	 * http://getbootstrap.com/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element)
	    // jscs:enable requireDollarBeforejQueryAssignment
	  }
	
	  Tab.VERSION = '3.3.7'
	
	  Tab.TRANSITION_DURATION = 150
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var $previous = $ul.find('.active:last a')
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    })
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    })
	
	    $previous.trigger(hideEvent)
	    $this.trigger(showEvent)
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return
	
	    var $target = $(selector)
	
	    this.activate($this.closest('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      })
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	          .removeClass('active')
	        .end()
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', false)
	
	      element
	        .addClass('active')
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', true)
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element
	          .closest('li.dropdown')
	            .addClass('active')
	          .end()
	          .find('[data-toggle="tab"]')
	            .attr('aria-expanded', true)
	      }
	
	      callback && callback()
	    }
	
	    $active.length && transition ?
	      $active
	        .one('bsTransitionEnd', next)
	        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tab
	
	  $.fn.tab             = Plugin
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function (e) {
	    e.preventDefault()
	    Plugin.call($(this), 'show')
	  }
	
	  $(document)
	    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: affix.js v3.3.7
	 * http://getbootstrap.com/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function (element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options)
	
	    this.$target = $(this.options.target)
	      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
	      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))
	
	    this.$element     = $(element)
	    this.affixed      = null
	    this.unpin        = null
	    this.pinnedOffset = null
	
	    this.checkPosition()
	  }
	
	  Affix.VERSION  = '3.3.7'
	
	  Affix.RESET    = 'affix affix-top affix-bottom'
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  }
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop    = this.$target.scrollTop()
	    var position     = this.$element.offset()
	    var targetHeight = this.$target.height()
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
	      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
	    }
	
	    var initializing   = this.affixed == null
	    var colliderTop    = initializing ? scrollTop : position.top
	    var colliderHeight = initializing ? targetHeight : height
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
	    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'
	
	    return false
	  }
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset
	    this.$element.removeClass(Affix.RESET).addClass('affix')
	    var scrollTop = this.$target.scrollTop()
	    var position  = this.$element.offset()
	    return (this.pinnedOffset = position.top - scrollTop)
	  }
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1)
	  }
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return
	
	    var height       = this.$element.height()
	    var offset       = this.options.offset
	    var offsetTop    = offset.top
	    var offsetBottom = offset.bottom
	    var scrollHeight = Math.max($(document).height(), $(document.body).height())
	
	    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
	    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '')
	
	      var affixType = 'affix' + (affix ? '-' + affix : '')
	      var e         = $.Event(affixType + '.bs.affix')
	
	      this.$element.trigger(e)
	
	      if (e.isDefaultPrevented()) return
	
	      this.affixed = affix
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null
	
	      this.$element
	        .removeClass(Affix.RESET)
	        .addClass(affixType)
	        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      })
	    }
	  }
	
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.affix')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.affix
	
	  $.fn.affix             = Plugin
	  $.fn.affix.Constructor = Affix
	
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old
	    return this
	  }
	
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this)
	      var data = $spy.data()
	
	      data.offset = data.offset || {}
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
	      if (data.offsetTop    != null) data.offset.top    = data.offsetTop
	
	      Plugin.call($spy, data)
	    })
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(954)))

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel panel-default\">\n    <div class=\"panel-heading\" role=\"tab\" style=\"cursor:pointer;\">\n        <h4 class=\"panel-title\" style=\"padding: 5px;\">\n            <a *ngIf=\"heading\" role=\"button\" data-toggle=\"collapse\" [attr.aria-expanded]=\"isOpened\">\n                {{ heading }}\n            </a>\n            <ng-content select=\"accordion-header\"></ng-content>\n            <div class=\"caret\"\n                 [ngStyle]=\"{ display: accordion.showArrows ? '' : 'none', borderTop: isOpened ? '0' : '4px dashed', borderBottom: isOpened ? '4px dashed' : '0' }\">\n            </div>\n        </h4>\n    </div>\n    <div  class=\"panel-collapse collapse\" role=\"tabpanel\" [attr.aria-labelledby]=\"heading\">\n        <div class=\"panel-body\">\n            <ng-content></ng-content>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var AccordionHeaderComponent = (function () {
	    function AccordionHeaderComponent() {
	    }
	    AccordionHeaderComponent = __decorate([
	        core_1.Component({
	            selector: 'accordion-header',
	            template: __webpack_require__(1017)
	        })
	    ], AccordionHeaderComponent);
	    return AccordionHeaderComponent;
	}());
	exports.AccordionHeaderComponent = AccordionHeaderComponent;


/***/ }),
/* 1017 */
972,
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var accordion_group_component_1 = __webpack_require__(1000);
	var AccordionToggleComponent = (function () {
	    function AccordionToggleComponent(accordionGroup) {
	        this.accordionGroup = accordionGroup;
	    }
	    AccordionToggleComponent.prototype.onClick = function () {
	        this.accordionGroup.toggle();
	    };
	    AccordionToggleComponent.prototype.getIconClass = function () {
	        return {
	            'fa': true,
	            'fa-chevron-up': this.accordionGroup.isOpened,
	            'fa-chevron-down': !this.accordionGroup.isOpened
	        };
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], AccordionToggleComponent.prototype, "title", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", core_1.TemplateRef)
	    ], AccordionToggleComponent.prototype, "rightBlockTmpl", void 0);
	    __decorate([
	        core_1.HostListener('click'),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], AccordionToggleComponent.prototype, "onClick", null);
	    AccordionToggleComponent = __decorate([
	        core_1.Component({
	            selector: 'accordion-toggle',
	            template: __webpack_require__(1019)
	        }),
	        __param(0, core_1.Host()),
	        __metadata("design:paramtypes", [accordion_group_component_1.AccordionGroupComponent])
	    ], AccordionToggleComponent);
	    return AccordionToggleComponent;
	}());
	exports.AccordionToggleComponent = AccordionToggleComponent;


/***/ }),
/* 1019 */
/***/ (function(module, exports) {

	module.exports = "<div *ngIf=\"title\" class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 accordion-toggle--header\">\n        <div class=\"accordion-toggle--header-icon\">\n            <i [ngClass]=\"getIconClass()\"></i>\n        </div>\n        <h4 class=\"accordion-toggle--header-text\">\n            {{ title | translate}}\n        </h4>\n        <div *ngIf=\"rightBlockTmpl\"\n             class=\"accordion-toggle--header-right-block\">\n            <ng-container [ngTemplateOutlet]=\"rightBlockTmpl\"></ng-container>\n        </div>\n    </div>\n</div>\n\n<ng-content *ngIf=\"!title\"></ng-content>\n"

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var AccordionContentComponent = (function () {
	    function AccordionContentComponent() {
	    }
	    AccordionContentComponent = __decorate([
	        core_1.Component({
	            selector: 'accordion-content',
	            template: __webpack_require__(1021)
	        })
	    ], AccordionContentComponent);
	    return AccordionContentComponent;
	}());
	exports.AccordionContentComponent = AccordionContentComponent;


/***/ }),
/* 1021 */
972,
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1023));
	var loading_linear_component_1 = __webpack_require__(1023);
	exports.LOADING_COMPONENTS = [
	    loading_linear_component_1.LinearLoadingComponent
	];


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var LinearLoadingComponent = (function () {
	    function LinearLoadingComponent(elementRef, renderer) {
	        this.elementRef = elementRef;
	        this.renderer = renderer;
	        this.loading = false;
	    }
	    LinearLoadingComponent.prototype.ngOnInit = function () {
	        this.renderer.setStyle(this.elementRef.nativeElement.parentElement, 'position', 'relative');
	    };
	    LinearLoadingComponent.prototype.getLoadingClass = function () {
	        if (this.loading) {
	            return 'show';
	        }
	        else {
	            return 'hide';
	        }
	    };
	    __decorate([
	        core_1.Input('loading'),
	        __metadata("design:type", Boolean)
	    ], LinearLoadingComponent.prototype, "loading", void 0);
	    LinearLoadingComponent = __decorate([
	        core_1.Component({
	            selector: 'loading-linear',
	            template: __webpack_require__(1024)
	        }),
	        __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer2])
	    ], LinearLoadingComponent);
	    return LinearLoadingComponent;
	}());
	exports.LinearLoadingComponent = LinearLoadingComponent;


/***/ }),
/* 1024 */
/***/ (function(module, exports) {

	module.exports = "<div *ngIf=\"loading\" id=\"linear-loader\" class=\"linear-loader\"> <!--TODO check if loader already displays-->\n    <div class=\"bar\"></div>\n    <div class=\"bar\"></div>\n    <div class=\"bar\"></div>\n</div>\n<ng-content></ng-content>\n<div class=\"backdrop\" [ngClass]=\"getLoadingClass()\"></div>"

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var thank_you_page_1 = __webpack_require__(1026);
	exports.TEMPLATE_COMPONENTS = [
	    thank_you_page_1.ThankYouComponent
	];


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1027));


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var ThankYouComponent = (function () {
	    function ThankYouComponent() {
	    }
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], ThankYouComponent.prototype, "isError", void 0);
	    ThankYouComponent = __decorate([
	        core_1.Component({
	            selector: 'thank-you',
	            template: __webpack_require__(1028),
	        })
	    ], ThankYouComponent);
	    return ThankYouComponent;
	}());
	exports.ThankYouComponent = ThankYouComponent;


/***/ }),
/* 1028 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"error-page-body\">\n    <i *ngIf=\"!isError\" class=\"fa fa-check-circle\" aria-hidden=\"true\"></i>\n    <i *ngIf=\"isError\" class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n    <div class=\"title\">\n        <p *ngIf=\"!isError\">{{'THANK_YOU_PAGE.SUCCESS'|translate}}</p>\n        <p *ngIf=\"isError\">{{'THANK_YOU_PAGE.ERROR'|translate}}</p>\n    </div>\n    <div class=\"col-md-10 col-md-offset-1 col-xs-12 content \">\n        <ng-content></ng-content>\n    </div>\n    <div class=\"col-md-8 col-md-offset-2 col-xs-12\">\n        <button routerLink=\"/\" class=\"btn-link\">\n            <i class=\"fa fa-long-arrow-left\" aria-hidden=\"true\"></i>\n            {{'THANK_YOU_PAGE.HOME'|translate}}\n        </button>\n    </div>\n</div>"

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var pagination_component_1 = __webpack_require__(1030);
	exports.PAGINATION_COMPONENTS = [
	    pagination_component_1.Pagination
	];


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var Pagination = (function () {
	    function Pagination() {
	        this.onPageChange = new core_1.EventEmitter();
	    }
	    Pagination.prototype.handlePageChange = function (pagination, page) {
	        if (page > 0
	            && page <= pagination.getLastPage()
	            && page !== pagination.getCurrent()) {
	            this.onPageChange.emit(page);
	        }
	    };
	    Pagination.prototype.handleClickPrevious = function (pagination) {
	        if (!pagination.isFirstPage()) {
	            pagination.previous();
	        }
	    };
	    Pagination.prototype.handleClickNext = function (pagination) {
	        if (!pagination.isLastPage()) {
	            pagination.next();
	        }
	    };
	    __decorate([
	        core_1.Output('onPageChange'),
	        __metadata("design:type", core_1.EventEmitter)
	    ], Pagination.prototype, "onPageChange", void 0);
	    __decorate([
	        core_1.Input('onlyArrows'),
	        __metadata("design:type", Boolean)
	    ], Pagination.prototype, "onlyArrows", void 0);
	    Pagination = __decorate([
	        core_1.Component({
	            selector: 'pagination',
	            template: __webpack_require__(1031)
	        })
	    ], Pagination);
	    return Pagination;
	}());
	exports.Pagination = Pagination;


/***/ }),
/* 1031 */
/***/ (function(module, exports) {

	module.exports = "<pagination-template #pagination=\"paginationApi\" (pageChange)=\"handlePageChange(pagination, $event)\">\n    <nav class=\"pagination-controls\">\n        <ul class=\"pagination\">\n            <li [class.disabled]=\"false\">\n                <a (click)=\"handleClickPrevious(pagination)\">\n                    <i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i>\n                </a>\n            </li>\n            <ng-container *ngIf=\"!onlyArrows\">\n                <li *ngFor=\"let page of pagination.pages\"\n                    [class.active]=\"pagination.getCurrent() === page.value\">\n                    <a (click)=\"handlePageChange(pagination, page.value)\">\n                        <span>{{ page.label }}</span>\n                    </a>\n                </li>\n            </ng-container>\n\n            <li [class.disabled]=\"false\">\n                <a (click)=\"handleClickNext(pagination)\">\n                    <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                </a>\n            </li>\n        </ul>\n    </nav>\n</pagination-template>"

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1033));
	var panel_component_1 = __webpack_require__(1033);
	var panel_header_component_1 = __webpack_require__(1035);
	exports.PANEL_COMPONENTS = [
	    panel_component_1.Panel,
	    panel_header_component_1.PanelHeader
	];


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var util_1 = __webpack_require__(743);
	var Panel = (function () {
	    function Panel() {
	    }
	    Panel.prototype.isTitleDefined = function () {
	        return !util_1.isNullOrUndefined(this.title);
	    };
	    __decorate([
	        core_1.Input('title'),
	        __metadata("design:type", String)
	    ], Panel.prototype, "title", void 0);
	    Panel = __decorate([
	        core_1.Component({
	            selector: 'panel',
	            template: __webpack_require__(1034)
	        })
	    ], Panel);
	    return Panel;
	}());
	exports.Panel = Panel;


/***/ }),
/* 1034 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"x_panel\">\n    <div class=\"x_title\">\n        <h3 *ngIf=\"isTitleDefined()\">{{ title }}</h3>\n        <ng-content select=\"panel-header\"></ng-content>\n    </div>\n\n    <div class=\"x_content\">\n        <ng-content></ng-content>\n    </div>\n</div>"

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var PanelHeader = (function () {
	    function PanelHeader() {
	    }
	    PanelHeader = __decorate([
	        core_1.Component({
	            selector: 'panel-header',
	            template: "<ng-content></ng-content>"
	        })
	    ], PanelHeader);
	    return PanelHeader;
	}());
	exports.PanelHeader = PanelHeader;


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1037));
	__export(__webpack_require__(1039));
	__export(__webpack_require__(1040));
	var click_to_edit_component_1 = __webpack_require__(1037);
	var click_to_edit_view_directive_1 = __webpack_require__(1039);
	var click_to_edit_input_directive_1 = __webpack_require__(1040);
	exports.CLICK_TO_EDIT_COMPONENTS = [
	    click_to_edit_component_1.ClickToEdit,
	    click_to_edit_view_directive_1.ClickToEditView,
	    click_to_edit_input_directive_1.ClickToEditInput
	];


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var forms_1 = __webpack_require__(768);
	var core_1 = __webpack_require__(205);
	var ClickToEdit = (function () {
	    function ClickToEdit(ngForm, changeDetectorRef) {
	        this.ngForm = ngForm;
	        this.changeDetectorRef = changeDetectorRef;
	        this.editing = false;
	        this.useChangesHighlight = true;
	        this.disabled = false;
	        this.useCustomHandler = false;
	        this.onChangeValue = new core_1.EventEmitter();
	        this.changed = false;
	    }
	    ClickToEdit.prototype.ngOnInit = function () {
	        this.initializeComponent();
	    };
	    ClickToEdit.prototype.ngOnChanges = function () {
	        this.initializeComponent();
	    };
	    ClickToEdit.prototype.ngAfterViewInit = function () {
	        this.initializeComponent();
	    };
	    ClickToEdit.prototype.initializeComponent = function () {
	        this.viewValue = this.getCurrentValue();
	        this.changeDetectorRef.detectChanges();
	    };
	    ClickToEdit.prototype.compareEvent = function (event) {
	        if (this.track != event && this.editing) {
	            this.cancel();
	        }
	    };
	    ClickToEdit.prototype.trackEvent = function (event) {
	        this.track = event;
	    };
	    ClickToEdit.prototype.changeApplied = function () {
	        var value = this.getCurrentValue();
	        this.changed = false;
	        this.previous = value;
	        this.viewValue = value;
	    };
	    ClickToEdit.prototype.changeExists = function () {
	        return this.changed;
	    };
	    ClickToEdit.prototype.open = function () {
	        if (!this.disabled) {
	            this.editing = true;
	            this.previous = this.getCurrentValue();
	            this.subscribeGlobalClickHandler();
	        }
	    };
	    ClickToEdit.prototype.save = function () {
	        var control = this.getControl();
	        if (!!control && control.valid) {
	            this.viewValue = this.getCurrentValue();
	            this.changed = this.changed || this.viewValue !== this.previous;
	            this.editing = false;
	            if (this.useCustomHandler) {
	                this.onChangeValue.emit(this.viewValue);
	            }
	            this.changeDetectorRef.detectChanges();
	            this.unSubscribeGlobalClickHandler();
	        }
	    };
	    ClickToEdit.prototype.cancel = function () {
	        this.updateValue(this.previous);
	        this.editing = false;
	        this.unSubscribeGlobalClickHandler();
	    };
	    ClickToEdit.prototype.getCurrentValue = function () {
	        return lodash_1.get(this.getControl(), 'value');
	    };
	    ClickToEdit.prototype.getValueClass = function () {
	        return {
	            'click-to-edit-value': true,
	            'click-to-edit-disabled': this.disabled,
	            'has-changes': this.useChangesHighlight && this.changed
	        };
	    };
	    ClickToEdit.prototype.getInputClass = function () {
	        return {
	            'click-to-edit-input': true,
	            'has-error': !lodash_1.get(this.getControl(), 'valid', true)
	        };
	    };
	    ClickToEdit.prototype.getControl = function () {
	        return this.ngForm.controls[this.forName];
	    };
	    ClickToEdit.prototype.updateValue = function (value) {
	        var control = this.getControl();
	        if (control && control != null) {
	            control.setValue(value);
	        }
	    };
	    ClickToEdit.prototype.subscribeGlobalClickHandler = function () {
	        this.callback = this.compareEvent.bind(this);
	        document.addEventListener('click', this.callback);
	    };
	    ClickToEdit.prototype.unSubscribeGlobalClickHandler = function () {
	        document.removeEventListener('click', this.callback);
	        this.callback = undefined;
	    };
	    __decorate([
	        core_1.Input('click-to-edit'),
	        __metadata("design:type", String)
	    ], ClickToEdit.prototype, "forName", void 0);
	    __decorate([
	        core_1.Input('cte-changes-highlight'),
	        __metadata("design:type", Boolean)
	    ], ClickToEdit.prototype, "useChangesHighlight", void 0);
	    __decorate([
	        core_1.Input('cte-disabled'),
	        __metadata("design:type", Boolean)
	    ], ClickToEdit.prototype, "disabled", void 0);
	    __decorate([
	        core_1.Input('use-custom-handler'),
	        __metadata("design:type", Boolean)
	    ], ClickToEdit.prototype, "useCustomHandler", void 0);
	    __decorate([
	        core_1.Output('on-change-value'),
	        __metadata("design:type", core_1.EventEmitter)
	    ], ClickToEdit.prototype, "onChangeValue", void 0);
	    ClickToEdit = __decorate([
	        core_1.Component({
	            selector: '[click-to-edit]',
	            template: __webpack_require__(1038),
	            host: {
	                "(click)": "trackEvent($event)"
	            }
	        }),
	        __param(0, core_1.Optional()),
	        __metadata("design:paramtypes", [forms_1.NgForm,
	            core_1.ChangeDetectorRef])
	    ], ClickToEdit);
	    return ClickToEdit;
	}());
	exports.ClickToEdit = ClickToEdit;


/***/ }),
/* 1038 */
/***/ (function(module, exports) {

	module.exports = "<!-- Show value -->\n<div *ngIf=\"!editing\" [ngClass]=\"getValueClass()\" (dblclick)=\"open()\">\n    <ng-content select=\"[click-to-edit-view]\"></ng-content>\n    <i class=\"fa fa-pencil\" aria-hidden=\"true\" (click)=\"open()\"></i>\n</div>\n\n<!-- Show input field -->\n<div *ngIf=\"editing\" [ngClass]=\"getInputClass()\">\n    <ng-content select=\"[click-to-edit-input]\"></ng-content>\n\n    <div class=\"click-to-edit-buttons\">\n        <div class=\"btn-group\">\n            <button id=\"submit-changes-button\" class=\"btn btn-success\" (click)=\"save()\">\n                <i class=\"fa fa-check\" aria-hidden=\"true\"></i>\n            </button>\n\n            <button id=\"discard-changes-button\" class=\"btn btn-danger\" (click)=\"cancel()\">\n                <i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n            </button>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var ClickToEditView = (function () {
	    function ClickToEditView() {
	    }
	    ClickToEditView = __decorate([
	        core_1.Directive({ selector: '[click-to-edit-view]' })
	    ], ClickToEditView);
	    return ClickToEditView;
	}());
	exports.ClickToEditView = ClickToEditView;


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var ClickToEditInput = (function () {
	    function ClickToEditInput() {
	    }
	    ClickToEditInput = __decorate([
	        core_1.Directive({ selector: '[click-to-edit-input]' })
	    ], ClickToEditInput);
	    return ClickToEditInput;
	}());
	exports.ClickToEditInput = ClickToEditInput;


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var load_more_component_1 = __webpack_require__(1042);
	exports.LOAD_MORE_COMPONENTS = [
	    load_more_component_1.LoadMoreComponent
	];


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var LoadMoreComponent = (function () {
	    function LoadMoreComponent() {
	        this.total_count = 0;
	        this.current_count = -1;
	        this.button_class = 'btn btn-primary';
	        this.button_wrapper_class = 'text-center';
	        this.button_disabled = false;
	        this.onLoadMore = new core_1.EventEmitter();
	    }
	    LoadMoreComponent.prototype.loadMore = function () {
	        this.onLoadMore.emit({});
	    };
	    __decorate([
	        core_1.Input('total-count'),
	        __metadata("design:type", Number)
	    ], LoadMoreComponent.prototype, "total_count", void 0);
	    __decorate([
	        core_1.Input('current-count'),
	        __metadata("design:type", Number)
	    ], LoadMoreComponent.prototype, "current_count", void 0);
	    __decorate([
	        core_1.Input('button-title'),
	        __metadata("design:type", String)
	    ], LoadMoreComponent.prototype, "button_title", void 0);
	    __decorate([
	        core_1.Input('button-class'),
	        __metadata("design:type", String)
	    ], LoadMoreComponent.prototype, "button_class", void 0);
	    __decorate([
	        core_1.Input('button-wrapper-class'),
	        __metadata("design:type", String)
	    ], LoadMoreComponent.prototype, "button_wrapper_class", void 0);
	    __decorate([
	        core_1.Input('button-disabled'),
	        __metadata("design:type", Boolean)
	    ], LoadMoreComponent.prototype, "button_disabled", void 0);
	    __decorate([
	        core_1.Output('on-load-more'),
	        __metadata("design:type", core_1.EventEmitter)
	    ], LoadMoreComponent.prototype, "onLoadMore", void 0);
	    LoadMoreComponent = __decorate([
	        core_1.Component({
	            selector: 'bs-load-more',
	            template: __webpack_require__(1043)
	        })
	    ], LoadMoreComponent);
	    return LoadMoreComponent;
	}());
	exports.LoadMoreComponent = LoadMoreComponent;


/***/ }),
/* 1043 */
/***/ (function(module, exports) {

	module.exports = "<ng-content></ng-content>\n\n<div *ngIf=\"total_count > current_count\"\n     [ngClass]=\"button_wrapper_class\">\n    <button id=\"load-more-button\"\n            type=\"button\"\n            [ngClass]=\"button_class\"\n            (click)=\"loadMore()\"\n            [disabled]=\"button_disabled\">\n        {{ button_title }}\n    </button>\n</div>"

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var complete_icon_1 = __webpack_require__(1045);
	var check_icon_1 = __webpack_require__(1047);
	var arrow_left_icon_1 = __webpack_require__(1048);
	var account_icon_1 = __webpack_require__(1049);
	var card_icon_1 = __webpack_require__(1050);
	var card_transfer_menu_icon_1 = __webpack_require__(881);
	var card_activation_icon_1 = __webpack_require__(1051);
	var leave_page_icon_1 = __webpack_require__(1052);
	var sender_account_icon_1 = __webpack_require__(1053);
	var verify_check_icon_1 = __webpack_require__(1054);
	var warning_icon_1 = __webpack_require__(1055);
	var chevron_right_icon_1 = __webpack_require__(1056);
	var chevron_bottom_icon_1 = __webpack_require__(1057);
	var search_business_category_icon_1 = __webpack_require__(1058);
	var favourite_account_icon_1 = __webpack_require__(1059);
	exports.ICONS = [
	    complete_icon_1.CompleteIcon,
	    check_icon_1.CheckIcon,
	    arrow_left_icon_1.ArrowLeftIcon,
	    account_icon_1.AccountIcon,
	    card_icon_1.CardIcon,
	    card_icon_1.VisaCardIcon,
	    card_icon_1.MasterCardIcon,
	    card_activation_icon_1.CardActivationIcon,
	    card_transfer_menu_icon_1.CardTransferMenuIcon,
	    leave_page_icon_1.LeavePageIcon,
	    sender_account_icon_1.SenderAccountIcon,
	    favourite_account_icon_1.FavouriteAccountIcon,
	    verify_check_icon_1.VerifyCheckIcon,
	    warning_icon_1.WarningIcon,
	    card_transfer_menu_icon_1.CardTransferMenuIcon,
	    chevron_right_icon_1.ChevronRightIcon,
	    chevron_bottom_icon_1.ChevronBottomIcon,
	    search_business_category_icon_1.SearchBusinessCategoryIcon
	];
	__export(__webpack_require__(1050));
	__export(__webpack_require__(1049));


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var CompleteIcon = (function () {
	    function CompleteIcon() {
	    }
	    CompleteIcon = __decorate([
	        core_1.Component({
	            selector: 'bs-complete-icon',
	            template: __webpack_require__(1046)
	        })
	    ], CompleteIcon);
	    return CompleteIcon;
	}());
	exports.CompleteIcon = CompleteIcon;


/***/ }),
/* 1046 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"132\" height=\"132\" viewBox=\"0 0 132 132\">\n    <g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(2 2)\">\n        <circle cx=\"64\" cy=\"64\" r=\"64\" stroke=\"#FFC212\" stroke-width=\"4\"/>\n        <path fill=\"#FFC212\"  stroke=\"#fff\" d=\"M92.502 49.663L58.665 83.5 38.701 63.535l4.46-4.46 15.504 15.503 29.376-29.376 4.46 4.461z\"/>\n    </g>\n</svg>"

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var CheckIcon = (function () {
	    function CheckIcon() {
	    }
	    CheckIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-check-icon',
	            template: "\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n            <g fill=\"none\" fill-rule=\"evenodd\">\n                <path d=\"M0 0h24v24H0z\"/>\n                <path fill=\"#009688\" d=\"M10.364 14.877l-4.773-4.685L4 11.754 10.364 18 21 7.562 19.409 6z\"/>\n            </g>\n        </svg>\n    "
	        })
	    ], CheckIcon);
	    return CheckIcon;
	}());
	exports.CheckIcon = CheckIcon;


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var ArrowLeftIcon = (function () {
	    function ArrowLeftIcon() {
	    }
	    ArrowLeftIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-arrow-left-icon',
	            template: "        \n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"12\" viewBox=\"0 0 18 12\">\n            <path fill=\"#839BA7\" fill-rule=\"evenodd\" d=\"M6.14.349a.586.586 0 0 1 .827.007.577.577 0 0 1 0 .821L2.774 5.372l13.877.034a.586.586 0 0 1 .003 1.173l-13.872-.04 4.21 4.21a.588.588 0 1 1-.83.83L.952 6.372A.591.591 0 0 1 .95 5.54L6.14.349z\"/>\n        </svg>\n    "
	        })
	    ], ArrowLeftIcon);
	    return ArrowLeftIcon;
	}());
	exports.ArrowLeftIcon = ArrowLeftIcon;


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	exports.ACCOUNT_ICON_SVG = "\n    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n        <g fill=\"none\" fill-rule=\"evenodd\">\n            <path d=\"M0 0h24v24H0z\"/>\n            <path fill=\"#9E9E9E\" d=\"M21.92 11.245V7.39a2.123 2.123 0 0 0-2.13-2.11h-1.444l-1.476-2.63a1.281 1.281 0 0 0-1.74-.491L9.465 5.28H4.13A2.122 2.122 0 0 0 2 7.396v12.49A2.123 2.123 0 0 0 4.13 22h15.66a2.122 2.122 0 0 0 2.13-2.115V16.63h1.066V11.25l-1.066-.004zm-2.13-5.12a1.269 1.269 0 0 1 1.268 1.125h-1.606l-.632-1.126h.97zm-4.245-3.228a.436.436 0 0 1 .579.165l2.352 4.188H7.64l7.905-4.353zm4.245 18.249H4.13a1.274 1.274 0 0 1-1.278-1.269V7.391a1.274 1.274 0 0 1 1.279-1.268h3.798L5.885 7.248H4.397a.423.423 0 0 0 0 .846h16.674v3.15h-3.12a2.617 2.617 0 0 0-2.621 2.6v.182a2.616 2.616 0 0 0 2.621 2.599h3.117v3.255a1.276 1.276 0 0 1-1.278 1.266zm2.343-5.364H17.95a1.767 1.767 0 0 1-1.776-1.756v-.181c.006-.975.801-1.761 1.776-1.756h4.183v3.693h-.001zm-2.875-1.812a.941.941 0 1 1-1.881.022.941.941 0 0 1 1.88-.022z\"/>\n        </g>\n    </svg>\n";
	var AccountIcon = (function () {
	    function AccountIcon() {
	    }
	    AccountIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-account-icon',
	            template: exports.ACCOUNT_ICON_SVG
	        })
	    ], AccountIcon);
	    return AccountIcon;
	}());
	exports.AccountIcon = AccountIcon;


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	exports.CARD_ICON_SVG = "\n    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n        <g fill=\"none\" fill-rule=\"evenodd\">\n            <path d=\"M0 0h24v24H0z\"/>\n            <path fill=\"#9E9E9E\" fill-rule=\"nonzero\" d=\"M19.938 5H4.063A2.063 2.063 0 0 0 2 7.063V17.436c0 1.14.923 2.063 2.063 2.063h15.875A2.063 2.063 0 0 0 22 17.437V7.063A2.063 2.063 0 0 0 19.937 5zm1.375 12.094a1.72 1.72 0 0 1-1.72 1.718H4.407c-.949 0-1.718-.77-1.718-1.718V10.5h18.625v6.594zm0-7.282H2.688V7.406c0-.949.769-1.718 1.718-1.718h15.188c.949 0 1.718.77 1.718 1.718v2.407zm-5.157 2.75a.344.344 0 0 1 0-.687h3.438a.344.344 0 0 1 0 .688h-3.438z\"/>\n        </g>\n    </svg>\n";
	exports.MASTER_CARD_ICON_SVG = "\n    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n        <g fill=\"none\" fill-rule=\"evenodd\">\n            <path d=\"M0 0h24v24H0z\"/>\n            <path fill=\"#000\" fill-rule=\"nonzero\" d=\"M5.984 19.205v-.973c0-.373-.227-.616-.616-.616a.64.64 0 0 0-.552.276.567.567 0 0 0-.519-.276.524.524 0 0 0-.454.227v-.194h-.34v1.556h.34v-.86c0-.275.146-.404.373-.404s.34.145.34.405v.86h.341v-.86c0-.276.162-.405.373-.405.227 0 .34.145.34.405v.86h.374zm5.043-1.556h-.551v-.47h-.34v.47h-.309v.308h.308v.713c0 .357.146.568.535.568a.907.907 0 0 0 .422-.114l-.097-.292a.534.534 0 0 1-.292.082c-.162 0-.227-.098-.227-.26v-.697h.551v-.308zm2.887-.033a.457.457 0 0 0-.406.227v-.194h-.34v1.556h.34v-.875c0-.26.114-.406.324-.406a.95.95 0 0 1 .211.033l.098-.325c-.065-.016-.163-.016-.227-.016zm-4.363.162c-.162-.113-.389-.162-.632-.162-.39 0-.649.195-.649.503 0 .26.195.405.535.454l.163.016c.178.033.275.081.275.162 0 .114-.13.195-.357.195a.895.895 0 0 1-.518-.162l-.163.26c.179.129.422.194.665.194.454 0 .714-.211.714-.503 0-.276-.211-.421-.535-.47l-.163-.016c-.145-.017-.259-.049-.259-.146 0-.114.114-.179.292-.179.195 0 .39.081.486.13l.146-.276zm9.049-.162a.457.457 0 0 0-.405.227v-.194h-.34v1.556h.34v-.875c0-.26.113-.406.324-.406a.95.95 0 0 1 .21.033l.098-.325c-.065-.016-.162-.016-.227-.016zm-4.346.811c0 .47.324.81.827.81.227 0 .39-.048.551-.178l-.162-.275a.655.655 0 0 1-.405.146c-.276 0-.47-.195-.47-.503 0-.292.194-.486.47-.503.146 0 .276.049.405.146l.162-.275c-.162-.13-.324-.179-.55-.179-.504 0-.828.34-.828.811zm3.146 0v-.778h-.34v.194a.586.586 0 0 0-.487-.227c-.438 0-.778.34-.778.811 0 .47.34.81.778.81.227 0 .39-.08.486-.226v.194h.341v-.778zm-1.249 0c0-.276.179-.503.47-.503.276 0 .47.211.47.503 0 .276-.194.503-.47.503-.291-.016-.47-.227-.47-.503zm-4.07-.81c-.454 0-.778.324-.778.81 0 .487.324.81.794.81a.992.992 0 0 0 .633-.21l-.162-.243a.775.775 0 0 1-.454.162c-.211 0-.422-.097-.47-.373h1.15v-.13c.017-.502-.275-.827-.713-.827zm0 .291c.21 0 .357.13.39.373h-.812c.033-.21.179-.373.422-.373zm8.449.519v-1.395h-.34v.811a.586.586 0 0 0-.487-.227c-.438 0-.779.34-.779.811 0 .47.34.81.779.81.227 0 .389-.08.486-.226v.194h.34v-.778zm-1.249 0c0-.276.178-.503.47-.503.276 0 .47.211.47.503 0 .276-.194.503-.47.503-.292-.016-.47-.227-.47-.503zm-11.384 0v-.778h-.34v.194a.586.586 0 0 0-.487-.227c-.438 0-.778.34-.778.811 0 .47.34.81.778.81.227 0 .39-.08.487-.226v.194h.34v-.778zm-1.265 0c0-.276.179-.503.47-.503.276 0 .471.211.471.503 0 .276-.195.503-.47.503-.292-.016-.47-.227-.47-.503z\"/>\n            <path fill=\"#FF5F00\" fill-rule=\"nonzero\" d=\"M9.438 5.827h5.108v9.178H9.438z\"/>\n            <path fill=\"#EB001B\" fill-rule=\"nonzero\" d=\"M9.762 10.416c0-1.865.876-3.519 2.222-4.589a5.834 5.834 0 0 0-9.438 4.59 5.834 5.834 0 0 0 9.438 4.588 5.83 5.83 0 0 1-2.222-4.589z\"/>\n            <path fill=\"#F79E1B\" fill-rule=\"nonzero\" d=\"M21.438 10.416A5.834 5.834 0 0 1 12 15.006a5.805 5.805 0 0 0 2.222-4.59A5.853 5.853 0 0 0 12 5.827a5.802 5.802 0 0 1 3.6-1.249 5.845 5.845 0 0 1 5.838 5.838z\"/>\n        </g>\n    </svg>\n";
	exports.VISA_CARD_ICON_SVG = "\n    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n        <g fill=\"none\" fill-rule=\"nonzero\">\n            <path fill=\"#F7B600\" d=\"M.889 16.444H23v1.778H.889z\"/>\n            <path fill=\"#1A1F71\" d=\"M.889 4.889H23v1.778H.889zM9.415 8.554L7.087 14.58H5.57L4.424 9.77c-.069-.295-.13-.404-.34-.53a5.69 5.69 0 0 0-1.417-.512l.033-.175h2.444c.33 0 .611.26.663.614l.605 3.486 1.494-4.097h1.511l-.002-.003zm5.948 4.058c.007-1.59-2.025-1.677-2.012-2.388 0-.216.194-.446.609-.505.486-.05.975.043 1.416.27l.252-1.279a3.604 3.604 0 0 0-1.344-.266c-1.42 0-2.419.82-2.426 1.99-.009.868.713 1.352 1.257 1.64.56.295.747.484.745.748 0 .404-.446.585-.863.585a2.813 2.813 0 0 1-1.475-.38l-.261 1.32c.337.167.956.313 1.597.32 1.51 0 2.497-.81 2.501-2.062l.004.007zm3.753 1.966h1.328l-1.16-6.025h-1.227a.655.655 0 0 0-.612.442l-2.158 5.582h1.51l.3-.9h1.843l.176.9zm-1.605-2.138l.755-2.262.432 2.262H17.51zm-6.043-3.89l-1.187 6.024H8.843L10.03 8.55h1.438z\"/>\n        </g>\n    </svg>\n";
	var CardIcon = (function () {
	    function CardIcon() {
	    }
	    CardIcon = __decorate([
	        core_1.Component({ selector: 'tfl-card-icon', template: exports.CARD_ICON_SVG })
	    ], CardIcon);
	    return CardIcon;
	}());
	exports.CardIcon = CardIcon;
	var MasterCardIcon = (function () {
	    function MasterCardIcon() {
	    }
	    MasterCardIcon = __decorate([
	        core_1.Component({ selector: 'tfl-master-card-icon', template: exports.MASTER_CARD_ICON_SVG })
	    ], MasterCardIcon);
	    return MasterCardIcon;
	}());
	exports.MasterCardIcon = MasterCardIcon;
	var VisaCardIcon = (function () {
	    function VisaCardIcon() {
	    }
	    VisaCardIcon = __decorate([
	        core_1.Component({ selector: 'tfl-visa-card-icon', template: exports.VISA_CARD_ICON_SVG })
	    ], VisaCardIcon);
	    return VisaCardIcon;
	}());
	exports.VisaCardIcon = VisaCardIcon;


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	exports.CARD_ACTIVATION_ICON_SVG = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n    <path fill=\"#009688\" fill-rule=\"evenodd\" d=\"M28.432 5H3.407A2.457 2.457 0 0 0 1 7.5v16.697a2.457 2.457 0 0 0 2.407 2.5h25.025a2.457 2.457 0 0 0 2.407-2.5V7.5A2.457 2.457 0 0 0 28.432 5zM2.066 10.644h27.707v2.434H2.066v-2.434zm26.37 14.979H3.406a1.37 1.37 0 0 1-1.338-1.394V14.185h27.704V24.23a1.37 1.37 0 0 1-1.338 1.394zM2.065 9.538V7.5a1.37 1.37 0 0 1 1.338-1.394h25.028A1.37 1.37 0 0 1 29.77 7.5v2.038H2.066zm1.812 6.343H8.78v1.107H3.881V15.88h-.003zm6.394 0h4.902v1.107h-4.902V15.88zm6.394 0h4.901v1.107h-4.901V15.88zm6.393 0h4.899v1.107h-4.899V15.88z\"/>\n</svg>\n\n";
	var CardActivationIcon = (function () {
	    function CardActivationIcon() {
	    }
	    CardActivationIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-card-activation-icon',
	            template: exports.CARD_ACTIVATION_ICON_SVG
	        })
	    ], CardActivationIcon);
	    return CardActivationIcon;
	}());
	exports.CardActivationIcon = CardActivationIcon;


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var LeavePageIcon = (function () {
	    function LeavePageIcon() {
	    }
	    LeavePageIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-leave-page-icon',
	            template: "\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" style=\"float:left;\">\n            <g fill=\"none\" fill-rule=\"evenodd\">\n                <path fill=\"#000\" fill-rule=\"nonzero\" d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\"/>\n                <path d=\"M0 0h24v24H0z\"/>\n            </g>\n        </svg>\n    "
	        })
	    ], LeavePageIcon);
	    return LeavePageIcon;
	}());
	exports.LeavePageIcon = LeavePageIcon;


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var SenderAccountIcon = (function () {
	    function SenderAccountIcon() {
	    }
	    SenderAccountIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-sender-account-icon',
	            template: "\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n            <g fill=\"none\" fill-rule=\"evenodd\">\n                <path d=\"M0 24h24V0H0z\"/>\n                <path fill=\"#212121\" d=\"M23.001 21.017V23H1v-1.983h22.001zM22 10.109v1.983h-1v5.95h1v1.983H2v-1.983h1v-5.95H2v-1.983H0V8.573L12 1l12 7.573v1.536h-2zm0-.447L12 3.35 2 9.662v.447h4v1.983H5v5.95h3v-5.95H7v-1.983h4v1.983h-1v5.95h1v-2.975h2v2.975h1v-5.95h-1v-1.983h4v1.983h-1v5.95h3v-5.95h-1v-1.983h4v-.447z\"/>\n            </g>\n        </svg>\n    "
	        })
	    ], SenderAccountIcon);
	    return SenderAccountIcon;
	}());
	exports.SenderAccountIcon = SenderAccountIcon;


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var VerifyCheckIcon = (function () {
	    function VerifyCheckIcon() {
	    }
	    VerifyCheckIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-verify-check-icon',
	            template: "\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n            <g fill=\"none\" fill-rule=\"evenodd\">\n                <path d=\"M0 0L24 0 24 24 0 24z\"/>\n                <path fill=\"#4CAF50\" fill-rule=\"nonzero\" d=\"M12 5c-3.864 0-7 3.136-7 7s3.136 7 7 7 7-3.136 7-7-3.136-7-7-7zm-1.4 10.5L7.1 12l.987-.987 2.513 2.506 5.313-5.313.987.994-6.3 6.3z\"/>\n            </g>\n        </svg>\n    "
	        })
	    ], VerifyCheckIcon);
	    return VerifyCheckIcon;
	}());
	exports.VerifyCheckIcon = VerifyCheckIcon;


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var WarningIcon = (function () {
	    function WarningIcon() {
	    }
	    WarningIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-input-warning-icon',
	            template: "\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n            <g fill=\"none\" fill-rule=\"evenodd\">\n                <path stroke=\"#FFC212\" d=\"M.867 22.227L12 2.997l11.133 19.23H.867z\"/>\n                <path fill=\"#FFC212\" d=\"M11 17H13V19H11zM11 11H13V15H11z\"/>\n            </g>\n        </svg>\n    "
	        })
	    ], WarningIcon);
	    return WarningIcon;
	}());
	exports.WarningIcon = WarningIcon;


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var ChevronRightIcon = (function () {
	    function ChevronRightIcon() {
	    }
	    ChevronRightIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-chevron-right',
	            template: "\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n            <path fill=\"#616161\" fill-rule=\"evenodd\" d=\"M9.877 16.617a.328.328 0 0 1-.51 0 .465.465 0 0 1 0-.59l4.491-4.288-4.491-4.287a.465.465 0 0 1 0-.59.327.327 0 0 1 .51 0l4.756 4.581a.465.465 0 0 1 0 .591l-4.756 4.583z\"/>\n        </svg>\n    "
	        })
	    ], ChevronRightIcon);
	    return ChevronRightIcon;
	}());
	exports.ChevronRightIcon = ChevronRightIcon;


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var ChevronBottomIcon = (function () {
	    function ChevronBottomIcon() {
	    }
	    ChevronBottomIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-chevron-bottom',
	            template: "\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"25\" viewBox=\"0 0 24 25\">\n            <path fill=\"#616161\" fill-rule=\"evenodd\" d=\"M16.878 9.616a.328.328 0 0 0 0-.51.465.465 0 0 0-.59 0L12 13.597 7.713 9.106a.465.465 0 0 0-.59 0 .327.327 0 0 0 0 .51l4.581 4.756c.172.141.42.141.591 0l4.583-4.756z\"/>\n        </svg>\n    "
	        })
	    ], ChevronBottomIcon);
	    return ChevronBottomIcon;
	}());
	exports.ChevronBottomIcon = ChevronBottomIcon;


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var SearchBusinessCategoryIcon = (function () {
	    function SearchBusinessCategoryIcon() {
	    }
	    SearchBusinessCategoryIcon = __decorate([
	        core_1.Component({
	            selector: 'search-business-category-icon',
	            template: "\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n            <path fill=\"#000\" fill-rule=\"evenodd\"\n                  d=\"M22 21.202l-.798.798-5.928-5.928a8.8 8.8 0 0 1-1.045.76 6.56 6.56 0 0 1-1.159.57c-.405.152-.83.272-1.273.361a6.862 6.862 0 0 1-1.349.133 7.185 7.185 0 0 1-2.907-.589 7.594 7.594 0 0 1-2.356-1.596 7.534 7.534 0 0 1-1.596-2.375A7.226 7.226 0 0 1 3 10.448c0-.507.044-.994.133-1.463.089-.469.228-.931.418-1.387.19-.456.418-.887.684-1.292.266-.405.576-.785.931-1.14a9.99 9.99 0 0 1 1.14-.912 6.51 6.51 0 0 1 1.273-.684 8.37 8.37 0 0 1 1.387-.418A7.175 7.175 0 0 1 10.448 3c1.013 0 1.976.196 2.888.589a7.534 7.534 0 0 1 2.375 1.596 7.594 7.594 0 0 1 1.596 2.356c.393.9.589 1.868.589 2.907 0 .456-.044.906-.133 1.349a8.198 8.198 0 0 1-.361 1.273 6.56 6.56 0 0 1-.57 1.159 8.8 8.8 0 0 1-.76 1.045L22 21.202zm-11.552-4.446c.861 0 1.672-.171 2.432-.513a6.656 6.656 0 0 0 1.995-1.368 6.38 6.38 0 0 0 1.349-1.995c.33-.76.494-1.57.494-2.432 0-.861-.165-1.678-.494-2.451a6.32 6.32 0 0 0-1.349-2.014 6.38 6.38 0 0 0-1.995-1.349 6.05 6.05 0 0 0-2.432-.494c-.43 0-.849.044-1.254.133a7.456 7.456 0 0 0-1.178.361c-.38.152-.741.342-1.083.57a5.085 5.085 0 0 0-.931.798c-.304.304-.57.627-.798.969a7.297 7.297 0 0 0-.589 1.064 5.137 5.137 0 0 0-.361 1.159 6.791 6.791 0 0 0-.114 1.254c0 .861.165 1.678.494 2.451a6.1 6.1 0 0 0 1.349 1.995 6.768 6.768 0 0 0 2.014 1.349c.773.342 1.59.513 2.451.513z\"/>\n        </svg>\n    "
	        })
	    ], SearchBusinessCategoryIcon);
	    return SearchBusinessCategoryIcon;
	}());
	exports.SearchBusinessCategoryIcon = SearchBusinessCategoryIcon;


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var FavouriteAccountIcon = (function () {
	    function FavouriteAccountIcon() {
	    }
	    FavouriteAccountIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-favourite-account-icon',
	            template: "\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n            <g>\n                <path d=\"M4023 4058 c-6 -7 -41 -74 -78 -148 -49 -99 -72 -137 -88 -141 -12\n-3 -82 -14 -156 -24 -143 -20 -171 -33 -171 -77 0 -16 37 -60 116 -139 l116\n-117 -28 -161 c-27 -156 -27 -161 -9 -181 10 -11 29 -20 43 -20 14 0 87 32\n162 71 l138 71 134 -71 c74 -39 146 -71 160 -71 14 0 33 9 44 21 18 20 18 24\n-9 182 l-28 162 115 110 c101 96 116 115 116 142 0 48 -25 58 -195 82 -82 12\n-151 25 -153 29 -2 4 -35 70 -75 147 -71 138 -73 140 -108 143 -21 2 -40 -2\n-46 -10z\"/>\n                <path d=\"M2 890 l3 -330 28 -27 27 -28 2133 -3 c1507 -2 2143 0 2169 8 67 19\n68 27 68 390 l0 320 -288 0 -288 0 -12 -44 c-8 -32 -22 -53 -48 -73 l-37 -28\n-192 -3 c-126 -3 -206 0 -235 8 -53 14 -95 57 -104 105 l-7 35 -119 0 c-118 0\n-120 0 -120 -22 0 -31 -33 -83 -67 -105 -24 -16 -52 -18 -258 -18 l-232 0 -37\n28 c-26 20 -40 41 -48 73 l-12 44 -108 0 -108 0 0 -30 c0 -39 -51 -97 -98\n-110 -48 -13 -386 -13 -434 0 -47 13 -98 71 -98 110 l0 30 -130 0 c-128 0\n-130 0 -130 -22 0 -31 -33 -83 -67 -105 -23 -15 -54 -19 -207 -21 -99 -2 -200\n-1 -223 3 -60 9 -111 55 -119 106 l-7 39 -299 0 -299 0 3 -330z\"/>\n            </g>\n        </svg>\n    "
	        })
	    ], FavouriteAccountIcon);
	    return FavouriteAccountIcon;
	}());
	exports.FavouriteAccountIcon = FavouriteAccountIcon;


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var amountrangepicker_component_1 = __webpack_require__(1061);
	exports.AMOUNT_RANGE_COMPONENTS = [
	    amountrangepicker_component_1.AmountRangePickerComponent
	];


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var model_listener_1 = __webpack_require__(962);
	var forms_1 = __webpack_require__(768);
	var lodash_1 = __webpack_require__(268);
	exports.CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR = {
	    provide: forms_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return AmountRangePickerComponent; }),
	    multi: true
	};
	var AmountRangePickerComponent = (function (_super) {
	    __extends(AmountRangePickerComponent, _super);
	    function AmountRangePickerComponent() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.onChange = new core_1.EventEmitter();
	        _this.onTouchedCallback = new core_1.EventEmitter();
	        _this.onValueChanged = new core_1.EventEmitter();
	        return _this;
	    }
	    AmountRangePickerComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        setTimeout(function () {
	            _this.writeValue(undefined);
	            _this.minModel.valueChanges.subscribe(function (value) {
	                if (lodash_1.isEmpty(value)) {
	                    value = null;
	                }
	                _this.writeValue(__assign({}, _this._innerValue, { minAmount: value }));
	                if (_this._innerValue.minAmount == null && _this._innerValue.maxAmount == null) {
	                    _this.writeValue(undefined);
	                }
	            });
	            _this.maxModel.valueChanges.subscribe(function (value) {
	                if (lodash_1.isEmpty(value)) {
	                    value = null;
	                }
	                _this.writeValue(__assign({}, _this._innerValue, { maxAmount: value }));
	                if (_this._innerValue.minAmount == null && _this._innerValue.maxAmount == null) {
	                    _this.writeValue(undefined);
	                }
	            });
	        });
	    };
	    AmountRangePickerComponent.prototype.clearValues = function () {
	        this.minAmount = undefined;
	        this.maxAmount = undefined;
	        this.onAmountChange();
	    };
	    AmountRangePickerComponent.prototype.writeValue = function (obj) {
	        if (obj) {
	            _super.prototype.writeValue.call(this, obj);
	        }
	        else {
	            _super.prototype.writeValue.call(this, undefined);
	        }
	    };
	    AmountRangePickerComponent.prototype.onAmountBlur = function (min) {
	        if (this.minAmount && this.maxAmount) {
	            if (Number(this.minAmount) > Number(this.maxAmount)) {
	                if (min) {
	                    this.maxAmount = undefined;
	                }
	                else {
	                    this.minAmount = undefined;
	                }
	            }
	        }
	        this.onAmountChange();
	    };
	    AmountRangePickerComponent.prototype.onAmountChange = function () {
	        this.onValueChanged.emit(this.getValues());
	    };
	    AmountRangePickerComponent.prototype.getValues = function () {
	        return {
	            minAmount: this.minAmount,
	            maxAmount: this.maxAmount,
	        };
	    };
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", Object)
	    ], AmountRangePickerComponent.prototype, "onValueChanged", void 0);
	    __decorate([
	        core_1.ViewChild('minModel'),
	        __metadata("design:type", Object)
	    ], AmountRangePickerComponent.prototype, "minModel", void 0);
	    __decorate([
	        core_1.ViewChild('maxModel'),
	        __metadata("design:type", Object)
	    ], AmountRangePickerComponent.prototype, "maxModel", void 0);
	    AmountRangePickerComponent = __decorate([
	        core_1.Component({
	            selector: 'bs-amountrangepicker',
	            template: __webpack_require__(1062),
	            providers: [exports.CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
	        })
	    ], AmountRangePickerComponent);
	    return AmountRangePickerComponent;
	}(model_listener_1.ModelListener));
	exports.AmountRangePickerComponent = AmountRangePickerComponent;


/***/ }),
/* 1062 */
/***/ (function(module, exports) {

	module.exports = "<input\n        type=\"money\"\n        #minModel=\"ngModel\"\n        [(ngModel)]=\"minAmount\"\n        class=\"form-control\"\n        style=\"width: 100px;margin-left: 10px\"\n        id=\"minAmount\"\n        (blur)=\"onAmountBlur(true)\"\n        (input)=\"onAmountChange()\"\n/>\n<label for=\"maxAmount\" class=\"control-label\">\n    &#9866;\n</label>\n<input\n        #maxModel=\"ngModel\"\n        type=\"money\"\n        class=\"form-control\"\n        style=\"width: 100px\"\n        maxlength=\"50\"\n        id=\"maxAmount\"\n        [(ngModel)]=\"maxAmount\"\n        (blur)=\"onAmountBlur(false)\"\n        (input)=\"onAmountChange()\"\n/>"

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1064));


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var TextareaAutoresize = (function () {
	    function TextareaAutoresize(element) {
	        this.element = element;
	    }
	    TextareaAutoresize.prototype.onInput = function (textArea) {
	        this.adjust();
	    };
	    TextareaAutoresize.prototype.ngAfterContentChecked = function () {
	        this.adjust();
	    };
	    TextareaAutoresize.prototype.adjust = function () {
	        this.element.nativeElement.style.overflow = 'hidden';
	        this.element.nativeElement.style.height = 'auto';
	        this.element.nativeElement.style.height = this.element.nativeElement.scrollHeight + "px";
	    };
	    __decorate([
	        core_1.HostListener('input', ['$event.target']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [HTMLTextAreaElement]),
	        __metadata("design:returntype", void 0)
	    ], TextareaAutoresize.prototype, "onInput", null);
	    TextareaAutoresize = __decorate([
	        core_1.Directive({ selector: 'textarea[bs-autosize]' }),
	        __metadata("design:paramtypes", [core_1.ElementRef])
	    ], TextareaAutoresize);
	    return TextareaAutoresize;
	}());
	exports.TextareaAutoresize = TextareaAutoresize;


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var ErrorBlock = (function () {
	    function ErrorBlock() {
	        this.title = '';
	    }
	    __decorate([
	        core_1.Input('title'),
	        __metadata("design:type", String)
	    ], ErrorBlock.prototype, "title", void 0);
	    ErrorBlock = __decorate([
	        core_1.Component({
	            selector: 'tfl-error-block',
	            template: "\n        <div>\n            <div *ngIf=\"title\" class=\"title\">\n                {{ title }}\n            </div>\n            <div><ng-content></ng-content></div>\n        </div>\n    "
	        })
	    ], ErrorBlock);
	    return ErrorBlock;
	}());
	exports.ErrorBlock = ErrorBlock;


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var ErrorWLBlock = (function () {
	    function ErrorWLBlock() {
	        this.url = '';
	    }
	    __decorate([
	        core_1.Input('url'),
	        __metadata("design:type", String)
	    ], ErrorWLBlock.prototype, "url", void 0);
	    ErrorWLBlock = __decorate([
	        core_1.Component({
	            selector: 'tfl-error-wl-block',
	            template: "\n    <div class=\"col-xs-12 container-wl\">\n                <h1><b>You're Almost in the Right Place!</b></h1>\n                <p><b>It looks like you've reached the wrong user portal.\n                Simply click the button below and we'll guide you straight to the correct sign-in page</b></p>\n                <a href=\"{{url}}\" class=\"btn\">Go to Monetum Pay Login</a>\n    </div>\n        ",
	            styles: ["\n    .container-wl {\n        text-align: center;\n        max-width: 400px;\n        background-color: #56708b;\n        border-radius: 10px;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n        font-weight:bold;\n        font-family: 'Arial', sans-serif;\n    }\n    h1 {\n        font-size: 20px;\n        margin-bottom: 20px;\n        font-weight:500;\n    }\n    p {\n        font-size: 16px;\n        line-height: 1.6;\n        margin-bottom: 25px;\n    }\n    .btn {\n        display: inline-block;\n        padding: 12px 24px;\n        background-color: #6bca98;\n        color: white;\n        text-decoration: none;\n        font-weight: bold;\n        transition: background-color 0.3s;\n        border: none !important;\n    }\n    .btn:hover {\n        background-color: #2980b9;\n    }\n\n        \n        \n        "]
	        })
	    ], ErrorWLBlock);
	    return ErrorWLBlock;
	}());
	exports.ErrorWLBlock = ErrorWLBlock;


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var SuccessBlock = (function () {
	    function SuccessBlock() {
	        this.title = '';
	    }
	    __decorate([
	        core_1.Input('title'),
	        __metadata("design:type", String)
	    ], SuccessBlock.prototype, "title", void 0);
	    SuccessBlock = __decorate([
	        core_1.Component({
	            selector: 'tfl-success-block',
	            template: "\n        <div>\n            <div *ngIf=\"title\" class=\"title\">\n                {{ title }}\n            </div>\n            <div><ng-content></ng-content></div>\n        </div>\n    "
	        })
	    ], SuccessBlock);
	    return SuccessBlock;
	}());
	exports.SuccessBlock = SuccessBlock;


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(246)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@angular/common'], factory) :
		(factory((global.ngxPagination = {}),global.core,global.common));
	}(this, (function (exports,core,common) { 'use strict';
	
	var PaginationService = (function () {
	    function PaginationService() {
	        this.change = new core.EventEmitter();
	        this.instances = {};
	        this.DEFAULT_ID = 'DEFAULT_PAGINATION_ID';
	    }
	    PaginationService.prototype.defaultId = function () { return this.DEFAULT_ID; };
	    PaginationService.prototype.register = function (instance) {
	        if (instance.id == null) {
	            instance.id = this.DEFAULT_ID;
	        }
	        if (!this.instances[instance.id]) {
	            this.instances[instance.id] = instance;
	            this.change.emit(instance.id);
	        }
	        else {
	            var changed = this.updateInstance(instance);
	            if (changed) {
	                this.change.emit(instance.id);
	            }
	        }
	    };
	    /**
	     * Check each property of the instance and update any that have changed. Return
	     * true if any changes were made, else return false.
	     */
	    PaginationService.prototype.updateInstance = function (instance) {
	        var changed = false;
	        for (var prop in this.instances[instance.id]) {
	            if (instance[prop] !== this.instances[instance.id][prop]) {
	                this.instances[instance.id][prop] = instance[prop];
	                changed = true;
	            }
	        }
	        return changed;
	    };
	    /**
	     * Returns the current page number.
	     */
	    PaginationService.prototype.getCurrentPage = function (id) {
	        if (this.instances[id]) {
	            return this.instances[id].currentPage;
	        }
	    };
	    /**
	     * Sets the current page number.
	     */
	    PaginationService.prototype.setCurrentPage = function (id, page) {
	        if (this.instances[id]) {
	            var instance = this.instances[id];
	            var maxPage = Math.ceil(instance.totalItems / instance.itemsPerPage);
	            if (page <= maxPage && 1 <= page) {
	                this.instances[id].currentPage = page;
	                this.change.emit(id);
	            }
	        }
	    };
	    /**
	     * Sets the value of instance.totalItems
	     */
	    PaginationService.prototype.setTotalItems = function (id, totalItems) {
	        if (this.instances[id] && 0 <= totalItems) {
	            this.instances[id].totalItems = totalItems;
	            this.change.emit(id);
	        }
	    };
	    /**
	     * Sets the value of instance.itemsPerPage.
	     */
	    PaginationService.prototype.setItemsPerPage = function (id, itemsPerPage) {
	        if (this.instances[id]) {
	            this.instances[id].itemsPerPage = itemsPerPage;
	            this.change.emit(id);
	        }
	    };
	    /**
	     * Returns a clone of the pagination instance object matching the id. If no
	     * id specified, returns the instance corresponding to the default id.
	     */
	    PaginationService.prototype.getInstance = function (id) {
	        if (id === void 0) { id = this.DEFAULT_ID; }
	        if (this.instances[id]) {
	            return this.clone(this.instances[id]);
	        }
	        return {};
	    };
	    /**
	     * Perform a shallow clone of an object.
	     */
	    PaginationService.prototype.clone = function (obj) {
	        var target = {};
	        for (var i in obj) {
	            if (obj.hasOwnProperty(i)) {
	                target[i] = obj[i];
	            }
	        }
	        return target;
	    };
	    return PaginationService;
	}());
	
	var LARGE_NUMBER = Number.MAX_SAFE_INTEGER;
	var PaginatePipe = (function () {
	    function PaginatePipe(service) {
	        this.service = service;
	        // store the values from the last time the pipe was invoked
	        this.state = {};
	    }
	    PaginatePipe.prototype.transform = function (collection, args) {
	        // When an observable is passed through the AsyncPipe, it will output
	        // `null` until the subscription resolves. In this case, we want to
	        // use the cached data from the `state` object to prevent the NgFor
	        // from flashing empty until the real values arrive.
	        if (!(collection instanceof Array)) {
	            var _id = args.id || this.service.defaultId();
	            if (this.state[_id]) {
	                return this.state[_id].slice;
	            }
	            else {
	                return collection;
	            }
	        }
	        var serverSideMode = args.totalItems && args.totalItems !== collection.length;
	        var instance = this.createInstance(collection, args);
	        var id = instance.id;
	        var start, end;
	        var perPage = instance.itemsPerPage;
	        this.service.register(instance);
	        if (!serverSideMode && collection instanceof Array) {
	            perPage = +perPage || LARGE_NUMBER;
	            start = (instance.currentPage - 1) * perPage;
	            end = start + perPage;
	            var isIdentical = this.stateIsIdentical(id, collection, start, end);
	            if (isIdentical) {
	                return this.state[id].slice;
	            }
	            else {
	                var slice = collection.slice(start, end);
	                this.saveState(id, collection, slice, start, end);
	                this.service.change.emit(id);
	                return slice;
	            }
	        }
	        // save the state for server-side collection to avoid null
	        // flash as new data loads.
	        this.saveState(id, collection, collection, start, end);
	        return collection;
	    };
	    /**
	     * Create an PaginationInstance object, using defaults for any optional properties not supplied.
	     */
	    PaginatePipe.prototype.createInstance = function (collection, config) {
	        this.checkConfig(config);
	        return {
	            id: config.id != null ? config.id : this.service.defaultId(),
	            itemsPerPage: +config.itemsPerPage || 0,
	            currentPage: +config.currentPage || 1,
	            totalItems: +config.totalItems || collection.length
	        };
	    };
	    /**
	     * Ensure the argument passed to the filter contains the required properties.
	     */
	    PaginatePipe.prototype.checkConfig = function (config) {
	        var required = ['itemsPerPage', 'currentPage'];
	        var missing = required.filter(function (prop) { return !(prop in config); });
	        if (0 < missing.length) {
	            throw new Error("PaginatePipe: Argument is missing the following required properties: " + missing.join(', '));
	        }
	    };
	    /**
	     * To avoid returning a brand new array each time the pipe is run, we store the state of the sliced
	     * array for a given id. This means that the next time the pipe is run on this collection & id, we just
	     * need to check that the collection, start and end points are all identical, and if so, return the
	     * last sliced array.
	     */
	    PaginatePipe.prototype.saveState = function (id, collection, slice, start, end) {
	        this.state[id] = {
	            collection: collection,
	            size: collection.length,
	            slice: slice,
	            start: start,
	            end: end
	        };
	    };
	    /**
	     * For a given id, returns true if the collection, size, start and end values are identical.
	     */
	    PaginatePipe.prototype.stateIsIdentical = function (id, collection, start, end) {
	        var state = this.state[id];
	        if (!state) {
	            return false;
	        }
	        var isMetaDataIdentical = state.size === collection.length &&
	            state.start === start &&
	            state.end === end;
	        if (!isMetaDataIdentical) {
	            return false;
	        }
	        return state.slice.every(function (element, index) { return element === collection[start + index]; });
	    };
	    PaginatePipe.decorators = [
	        { type: core.Pipe, args: [{
	                    name: 'paginate',
	                    pure: false
	                },] },
	    ];
	    /** @nocollapse */
	    PaginatePipe.ctorParameters = function () { return [
	        { type: PaginationService, },
	    ]; };
	    return PaginatePipe;
	}());
	
	/**
	 * The default template and styles for the pagination links are borrowed directly
	 * from Zurb Foundation 6: http://foundation.zurb.com/sites/docs/pagination.html
	 */
	var DEFAULT_TEMPLATE = "\n    <pagination-template  #p=\"paginationApi\"\n                         [id]=\"id\"\n                         [maxSize]=\"maxSize\"\n                         (pageChange)=\"pageChange.emit($event)\">\n    <ul class=\"ngx-pagination\" \n        role=\"navigation\" \n        [attr.aria-label]=\"screenReaderPaginationLabel\" \n        [class.responsive]=\"responsive\"\n        *ngIf=\"!(autoHide && p.pages.length <= 1)\">\n\n        <li class=\"pagination-previous\" [class.disabled]=\"p.isFirstPage()\" *ngIf=\"directionLinks\"> \n            <a tabindex=\"0\" *ngIf=\"1 < p.getCurrent()\" (keyup.enter)=\"p.previous()\" (click)=\"p.previous()\" [attr.aria-label]=\"previousLabel + ' ' + screenReaderPageLabel\">\n                {{ previousLabel }} <span class=\"show-for-sr\">{{ screenReaderPageLabel }}</span>\n            </a>\n            <span *ngIf=\"p.isFirstPage()\">\n                {{ previousLabel }} <span class=\"show-for-sr\">{{ screenReaderPageLabel }}</span>\n            </span>\n        </li> \n\n        <li class=\"small-screen\">\n            {{ p.getCurrent() }} / {{ p.getLastPage() }}\n        </li>\n\n        <li [class.current]=\"p.getCurrent() === page.value\" \n            [class.ellipsis]=\"page.label === '...'\"\n            *ngFor=\"let page of p.pages\">\n            <a tabindex=\"0\" (keyup.enter)=\"p.setCurrent(page.value)\" (click)=\"p.setCurrent(page.value)\" *ngIf=\"p.getCurrent() !== page.value\">\n                <span class=\"show-for-sr\">{{ screenReaderPageLabel }} </span>\n                <span>{{ page.label }}</span>\n            </a>\n            <ng-container *ngIf=\"p.getCurrent() === page.value\">\n                <span class=\"show-for-sr\">{{ screenReaderCurrentLabel }} </span>\n                <span>{{ page.label }}</span> \n            </ng-container>\n        </li>\n\n        <li class=\"pagination-next\" [class.disabled]=\"p.isLastPage()\" *ngIf=\"directionLinks\">\n            <a tabindex=\"0\" *ngIf=\"!p.isLastPage()\" (keyup.enter)=\"p.next()\" (click)=\"p.next()\" [attr.aria-label]=\"nextLabel + ' ' + screenReaderPageLabel\">\n                 {{ nextLabel }} <span class=\"show-for-sr\">{{ screenReaderPageLabel }}</span>\n            </a>\n            <span *ngIf=\"p.isLastPage()\">\n                 {{ nextLabel }} <span class=\"show-for-sr\">{{ screenReaderPageLabel }}</span>\n            </span>\n        </li>\n\n    </ul>\n    </pagination-template>\n    ";
	var DEFAULT_STYLES = "\n.ngx-pagination {\n  margin-left: 0;\n  margin-bottom: 1rem; }\n  .ngx-pagination::before, .ngx-pagination::after {\n    content: ' ';\n    display: table; }\n  .ngx-pagination::after {\n    clear: both; }\n  .ngx-pagination li {\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    margin-right: 0.0625rem;\n    border-radius: 0; }\n  .ngx-pagination li {\n    display: inline-block; }\n  .ngx-pagination a,\n  .ngx-pagination button {\n    color: #0a0a0a; \n    display: block;\n    padding: 0.1875rem 0.625rem;\n    border-radius: 0; }\n    .ngx-pagination a:hover,\n    .ngx-pagination button:hover {\n      background: #e6e6e6; }\n  .ngx-pagination .current {\n    padding: 0.1875rem 0.625rem;\n    background: #2199e8;\n    color: #fefefe;\n    cursor: default; }\n  .ngx-pagination .disabled {\n    padding: 0.1875rem 0.625rem;\n    color: #cacaca;\n    cursor: default; } \n    .ngx-pagination .disabled:hover {\n      background: transparent; }\n  .ngx-pagination a, .ngx-pagination button {\n    cursor: pointer; }\n\n.ngx-pagination .pagination-previous a::before,\n.ngx-pagination .pagination-previous.disabled::before { \n  content: '\u00AB';\n  display: inline-block;\n  margin-right: 0.5rem; }\n\n.ngx-pagination .pagination-next a::after,\n.ngx-pagination .pagination-next.disabled::after {\n  content: '\u00BB';\n  display: inline-block;\n  margin-left: 0.5rem; }\n\n.ngx-pagination .show-for-sr {\n  position: absolute !important;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0); }\n.ngx-pagination .small-screen {\n  display: none; }\n@media screen and (max-width: 601px) {\n  .ngx-pagination.responsive .small-screen {\n    display: inline-block; } \n  .ngx-pagination.responsive li:not(.small-screen):not(.pagination-previous):not(.pagination-next) {\n    display: none; }\n}\n  ";
	
	function coerceToBoolean(input) {
	    return !!input && input !== 'false';
	}
	/**
	 * The default pagination controls component. Actually just a default implementation of a custom template.
	 */
	var PaginationControlsComponent = (function () {
	    function PaginationControlsComponent() {
	        this.maxSize = 7;
	        this.previousLabel = 'Previous';
	        this.nextLabel = 'Next';
	        this.screenReaderPaginationLabel = 'Pagination';
	        this.screenReaderPageLabel = 'page';
	        this.screenReaderCurrentLabel = "You're on page";
	        this.pageChange = new core.EventEmitter();
	        this._directionLinks = true;
	        this._autoHide = false;
	        this._responsive = false;
	    }
	    Object.defineProperty(PaginationControlsComponent.prototype, "directionLinks", {
	        get: function () {
	            return this._directionLinks;
	        },
	        set: function (value) {
	            this._directionLinks = coerceToBoolean(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PaginationControlsComponent.prototype, "autoHide", {
	        get: function () {
	            return this._autoHide;
	        },
	        set: function (value) {
	            this._autoHide = coerceToBoolean(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PaginationControlsComponent.prototype, "responsive", {
	        get: function () {
	            return this._responsive;
	        },
	        set: function (value) {
	            this._responsive = coerceToBoolean(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    PaginationControlsComponent.decorators = [
	        { type: core.Component, args: [{
	                    selector: 'pagination-controls',
	                    template: DEFAULT_TEMPLATE,
	                    styles: [DEFAULT_STYLES],
	                    changeDetection: core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: core.ViewEncapsulation.None
	                },] },
	    ];
	    /** @nocollapse */
	    PaginationControlsComponent.ctorParameters = function () { return []; };
	    PaginationControlsComponent.propDecorators = {
	        'id': [{ type: core.Input },],
	        'maxSize': [{ type: core.Input },],
	        'directionLinks': [{ type: core.Input },],
	        'autoHide': [{ type: core.Input },],
	        'responsive': [{ type: core.Input },],
	        'previousLabel': [{ type: core.Input },],
	        'nextLabel': [{ type: core.Input },],
	        'screenReaderPaginationLabel': [{ type: core.Input },],
	        'screenReaderPageLabel': [{ type: core.Input },],
	        'screenReaderCurrentLabel': [{ type: core.Input },],
	        'pageChange': [{ type: core.Output },],
	    };
	    return PaginationControlsComponent;
	}());
	
	/**
	 * This directive is what powers all pagination controls components, including the default one.
	 * It exposes an API which is hooked up to the PaginationService to keep the PaginatePipe in sync
	 * with the pagination controls.
	 */
	var PaginationControlsDirective = (function () {
	    function PaginationControlsDirective(service, changeDetectorRef) {
	        var _this = this;
	        this.service = service;
	        this.changeDetectorRef = changeDetectorRef;
	        this.maxSize = 7;
	        this.pageChange = new core.EventEmitter();
	        this.pages = [];
	        this.changeSub = this.service.change
	            .subscribe(function (id) {
	            if (_this.id === id) {
	                _this.updatePageLinks();
	                _this.changeDetectorRef.markForCheck();
	                _this.changeDetectorRef.detectChanges();
	            }
	        });
	    }
	    PaginationControlsDirective.prototype.ngOnInit = function () {
	        if (this.id === undefined) {
	            this.id = this.service.defaultId();
	        }
	        this.updatePageLinks();
	    };
	    PaginationControlsDirective.prototype.ngOnChanges = function (changes) {
	        this.updatePageLinks();
	    };
	    PaginationControlsDirective.prototype.ngOnDestroy = function () {
	        this.changeSub.unsubscribe();
	    };
	    /**
	     * Go to the previous page
	     */
	    PaginationControlsDirective.prototype.previous = function () {
	        this.checkValidId();
	        this.setCurrent(this.getCurrent() - 1);
	    };
	    /**
	     * Go to the next page
	     */
	    PaginationControlsDirective.prototype.next = function () {
	        this.checkValidId();
	        this.setCurrent(this.getCurrent() + 1);
	    };
	    /**
	     * Returns true if current page is first page
	     */
	    PaginationControlsDirective.prototype.isFirstPage = function () {
	        return this.getCurrent() === 1;
	    };
	    /**
	     * Returns true if current page is last page
	     */
	    PaginationControlsDirective.prototype.isLastPage = function () {
	        return this.getLastPage() === this.getCurrent();
	    };
	    /**
	     * Set the current page number.
	     */
	    PaginationControlsDirective.prototype.setCurrent = function (page) {
	        this.pageChange.emit(page);
	    };
	    /**
	     * Get the current page number.
	     */
	    PaginationControlsDirective.prototype.getCurrent = function () {
	        return this.service.getCurrentPage(this.id);
	    };
	    /**
	     * Returns the last page number
	     */
	    PaginationControlsDirective.prototype.getLastPage = function () {
	        var inst = this.service.getInstance(this.id);
	        if (inst.totalItems < 1) {
	            // when there are 0 or fewer (an error case) items, there are no "pages" as such,
	            // but it makes sense to consider a single, empty page as the last page.
	            return 1;
	        }
	        return Math.ceil(inst.totalItems / inst.itemsPerPage);
	    };
	    PaginationControlsDirective.prototype.getTotalItems = function () {
	        return this.service.getInstance(this.id).totalItems;
	    };
	    PaginationControlsDirective.prototype.checkValidId = function () {
	        if (this.service.getInstance(this.id).id == null) {
	            console.warn("PaginationControlsDirective: the specified id \"" + this.id + "\" does not match any registered PaginationInstance");
	        }
	    };
	    /**
	     * Updates the page links and checks that the current page is valid. Should run whenever the
	     * PaginationService.change stream emits a value matching the current ID, or when any of the
	     * input values changes.
	     */
	    PaginationControlsDirective.prototype.updatePageLinks = function () {
	        var _this = this;
	        var inst = this.service.getInstance(this.id);
	        var correctedCurrentPage = this.outOfBoundCorrection(inst);
	        if (correctedCurrentPage !== inst.currentPage) {
	            setTimeout(function () {
	                _this.setCurrent(correctedCurrentPage);
	                _this.pages = _this.createPageArray(inst.currentPage, inst.itemsPerPage, inst.totalItems, _this.maxSize);
	            });
	        }
	        else {
	            this.pages = this.createPageArray(inst.currentPage, inst.itemsPerPage, inst.totalItems, this.maxSize);
	        }
	    };
	    /**
	     * Checks that the instance.currentPage property is within bounds for the current page range.
	     * If not, return a correct value for currentPage, or the current value if OK.
	     */
	    PaginationControlsDirective.prototype.outOfBoundCorrection = function (instance) {
	        var totalPages = Math.ceil(instance.totalItems / instance.itemsPerPage);
	        if (totalPages < instance.currentPage && 0 < totalPages) {
	            return totalPages;
	        }
	        else if (instance.currentPage < 1) {
	            return 1;
	        }
	        return instance.currentPage;
	    };
	    /**
	     * Returns an array of Page objects to use in the pagination controls.
	     */
	    PaginationControlsDirective.prototype.createPageArray = function (currentPage, itemsPerPage, totalItems, paginationRange) {
	        // paginationRange could be a string if passed from attribute, so cast to number.
	        paginationRange = +paginationRange;
	        var pages = [];
	        var totalPages = Math.ceil(totalItems / itemsPerPage);
	        var halfWay = Math.ceil(paginationRange / 2);
	        var isStart = currentPage <= halfWay;
	        var isEnd = totalPages - halfWay < currentPage;
	        var isMiddle = !isStart && !isEnd;
	        var ellipsesNeeded = paginationRange < totalPages;
	        var i = 1;
	        while (i <= totalPages && i <= paginationRange) {
	            var label = void 0;
	            var pageNumber = this.calculatePageNumber(i, currentPage, paginationRange, totalPages);
	            var openingEllipsesNeeded = (i === 2 && (isMiddle || isEnd));
	            var closingEllipsesNeeded = (i === paginationRange - 1 && (isMiddle || isStart));
	            if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
	                label = '...';
	            }
	            else {
	                label = pageNumber;
	            }
	            pages.push({
	                label: label,
	                value: pageNumber
	            });
	            i++;
	        }
	        return pages;
	    };
	    /**
	     * Given the position in the sequence of pagination links [i],
	     * figure out what page number corresponds to that position.
	     */
	    PaginationControlsDirective.prototype.calculatePageNumber = function (i, currentPage, paginationRange, totalPages) {
	        var halfWay = Math.ceil(paginationRange / 2);
	        if (i === paginationRange) {
	            return totalPages;
	        }
	        else if (i === 1) {
	            return i;
	        }
	        else if (paginationRange < totalPages) {
	            if (totalPages - halfWay < currentPage) {
	                return totalPages - paginationRange + i;
	            }
	            else if (halfWay < currentPage) {
	                return currentPage - halfWay + i;
	            }
	            else {
	                return i;
	            }
	        }
	        else {
	            return i;
	        }
	    };
	    PaginationControlsDirective.decorators = [
	        { type: core.Directive, args: [{
	                    selector: 'pagination-template,[pagination-template]',
	                    exportAs: 'paginationApi'
	                },] },
	    ];
	    /** @nocollapse */
	    PaginationControlsDirective.ctorParameters = function () { return [
	        { type: PaginationService, },
	        { type: core.ChangeDetectorRef, },
	    ]; };
	    PaginationControlsDirective.propDecorators = {
	        'id': [{ type: core.Input },],
	        'maxSize': [{ type: core.Input },],
	        'pageChange': [{ type: core.Output },],
	    };
	    return PaginationControlsDirective;
	}());
	
	var NgxPaginationModule = (function () {
	    function NgxPaginationModule() {
	    }
	    NgxPaginationModule.decorators = [
	        { type: core.NgModule, args: [{
	                    imports: [common.CommonModule],
	                    declarations: [
	                        PaginatePipe,
	                        PaginationControlsComponent,
	                        PaginationControlsDirective
	                    ],
	                    providers: [PaginationService],
	                    exports: [PaginatePipe, PaginationControlsComponent, PaginationControlsDirective]
	                },] },
	    ];
	    /** @nocollapse */
	    NgxPaginationModule.ctorParameters = function () { return []; };
	    return NgxPaginationModule;
	}());
	
	/**
	 * Generated bundle index. Do not edit.
	 */
	
	exports.ɵb = DEFAULT_STYLES;
	exports.ɵa = DEFAULT_TEMPLATE;
	exports.NgxPaginationModule = NgxPaginationModule;
	exports.PaginationService = PaginationService;
	exports.PaginationControlsComponent = PaginationControlsComponent;
	exports.PaginationControlsDirective = PaginationControlsDirective;
	exports.PaginatePipe = PaginatePipe;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var InputTrimDirective = (function (_super) {
	    __extends(InputTrimDirective, _super);
	    function InputTrimDirective(renderer, elementRef, compositionMode) {
	        var _this = _super.call(this, renderer, elementRef, compositionMode) || this;
	        _this._type = 'text';
	        _this._sourceRenderer = renderer;
	        _this._sourceElementRef = elementRef;
	        return _this;
	    }
	    InputTrimDirective_1 = InputTrimDirective;
	    Object.defineProperty(InputTrimDirective.prototype, "type", {
	        get: function () {
	            return this._type;
	        },
	        set: function (value) {
	            this._type = value || 'text';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(InputTrimDirective.prototype, "value", {
	        get: function () {
	            return this._value;
	        },
	        set: function (val) {
	            this.writeValue(val);
	            if (val !== this.value) {
	                this._value = val;
	            }
	            this.onChange(val);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    InputTrimDirective.prototype.onBlur = function (event, value) {
	        if (value.trim() !== this.value) {
	            this.updateValue(event, value);
	        }
	        this.onTouched();
	    };
	    InputTrimDirective.prototype.onInput = function (event, value) {
	        this.updateValue(event, value);
	    };
	    InputTrimDirective.prototype.writeValue = function (value) {
	        if (!this._value) {
	            this._value = value;
	        }
	        this._sourceRenderer.setProperty(this._sourceElementRef.nativeElement, 'value', value);
	        if (this._type !== 'text') {
	            this._sourceRenderer.setAttribute(this._sourceElementRef.nativeElement, 'value', value);
	        }
	    };
	    InputTrimDirective.prototype.updateValue = function (event, value) {
	        this.value = (this.trim !== '' && event !== this.trim) ? value : value.trim();
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], InputTrimDirective.prototype, "trim", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String),
	        __metadata("design:paramtypes", [String])
	    ], InputTrimDirective.prototype, "type", null);
	    __decorate([
	        core_1.HostListener('blur', ['$event.type', '$event.target.value']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [String, String]),
	        __metadata("design:returntype", void 0)
	    ], InputTrimDirective.prototype, "onBlur", null);
	    __decorate([
	        core_1.HostListener('input', ['$event.type', '$event.target.value']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [String, String]),
	        __metadata("design:returntype", void 0)
	    ], InputTrimDirective.prototype, "onInput", null);
	    InputTrimDirective = InputTrimDirective_1 = __decorate([
	        core_1.Directive({
	            selector: 'input[trim], textarea[trim]',
	            providers: [{ provide: forms_1.NG_VALUE_ACCESSOR, useExisting: InputTrimDirective_1, multi: true }]
	        }),
	        __param(0, core_1.Inject(core_1.Renderer2)),
	        __param(1, core_1.Inject(core_1.ElementRef)),
	        __param(2, core_1.Optional()), __param(2, core_1.Inject(forms_1.COMPOSITION_BUFFER_MODE)),
	        __metadata("design:paramtypes", [core_1.Renderer2,
	            core_1.ElementRef, Boolean])
	    ], InputTrimDirective);
	    return InputTrimDirective;
	    var InputTrimDirective_1;
	}(forms_1.DefaultValueAccessor));
	exports.InputTrimDirective = InputTrimDirective;


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var WarningBlockComponent = (function () {
	    function WarningBlockComponent() {
	        this.title = '';
	    }
	    __decorate([
	        core_1.Input('title'),
	        __metadata("design:type", String)
	    ], WarningBlockComponent.prototype, "title", void 0);
	    WarningBlockComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-warning-block',
	            template: "\n        <div>\n            <div class=\"title\">\n                {{ title }}\n            </div>\n            <div><ng-content></ng-content></div>\n        </div>\n    "
	        })
	    ], WarningBlockComponent);
	    return WarningBlockComponent;
	}());
	exports.WarningBlockComponent = WarningBlockComponent;


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var MaterialCardComponent = (function () {
	    function MaterialCardComponent() {
	    }
	    __decorate([
	        core_1.Input('title'),
	        __metadata("design:type", String)
	    ], MaterialCardComponent.prototype, "title", void 0);
	    __decorate([
	        core_1.Input('id'),
	        __metadata("design:type", Number)
	    ], MaterialCardComponent.prototype, "id", void 0);
	    __decorate([
	        core_1.Input('subtitle'),
	        __metadata("design:type", String)
	    ], MaterialCardComponent.prototype, "subtitle", void 0);
	    MaterialCardComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-material-card',
	            template: "\n        <mat-card>\n            <mat-card-header>\n                <mat-card-title  [innerHtml] = \"title\">\n                </mat-card-title>\n                <mat-card-subtitle *ngIf=\"subtitle\"  [innerHtml] = \"subtitle\">\n                </mat-card-subtitle>\n            </mat-card-header>\n            <mat-card-actions>\n                <div class=\"actions-container\">\n                    <ng-content></ng-content>\n                </div>\n            </mat-card-actions>\n        </mat-card>\n    "
	        })
	    ], MaterialCardComponent);
	    return MaterialCardComponent;
	}());
	exports.MaterialCardComponent = MaterialCardComponent;


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1073));


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var CheckboxComponent = (function () {
	    function CheckboxComponent() {
	        this.itemSelected = new core_1.EventEmitter();
	        this.itemDeSelected = new core_1.EventEmitter();
	    }
	    CheckboxComponent.prototype.itemChecked = function (event) {
	        if (event.checked) {
	            this.itemSelected.emit(this.item);
	            return;
	        }
	        this.itemDeSelected.emit(this.item);
	    };
	    __decorate([
	        core_1.Input('item'),
	        __metadata("design:type", Object)
	    ], CheckboxComponent.prototype, "item", void 0);
	    __decorate([
	        core_1.Input('label'),
	        __metadata("design:type", String)
	    ], CheckboxComponent.prototype, "label", void 0);
	    __decorate([
	        core_1.Input('checked'),
	        __metadata("design:type", Boolean)
	    ], CheckboxComponent.prototype, "checked", void 0);
	    __decorate([
	        core_1.Output('itemSelected'),
	        __metadata("design:type", core_1.EventEmitter)
	    ], CheckboxComponent.prototype, "itemSelected", void 0);
	    __decorate([
	        core_1.Output('itemDeSelected'),
	        __metadata("design:type", core_1.EventEmitter)
	    ], CheckboxComponent.prototype, "itemDeSelected", void 0);
	    CheckboxComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-checkbox',
	            template: "\n        <mat-checkbox\n            [(ngModel)]=\"checked\"\n            (change)=\"itemChecked($event)\">\n            {{label}}\n        </mat-checkbox>\n    "
	        })
	    ], CheckboxComponent);
	    return CheckboxComponent;
	}());
	exports.CheckboxComponent = CheckboxComponent;


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(1075)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@angular/material/core'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.material = global.ng.material || {}, global.ng.material.card = global.ng.material.card || {}),global.ng.core,global.ng.material.core));
	}(this, (function (exports,_angular_core,_angular_material_core) { 'use strict';
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Content of a card, needed as it's used as a selector in the API.
	 * \@docs-private
	 */
	var MatCardContent = /** @class */ (function () {
	    function MatCardContent() {
	    }
	    MatCardContent.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-card-content',
	                    host: { 'class': 'mat-card-content' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardContent.ctorParameters = function () { return []; };
	    return MatCardContent;
	}());
	/**
	 * Title of a card, needed as it's used as a selector in the API.
	 * \@docs-private
	 */
	var MatCardTitle = /** @class */ (function () {
	    function MatCardTitle() {
	    }
	    MatCardTitle.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: "mat-card-title, [mat-card-title], [matCardTitle]",
	                    host: {
	                        'class': 'mat-card-title'
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardTitle.ctorParameters = function () { return []; };
	    return MatCardTitle;
	}());
	/**
	 * Sub-title of a card, needed as it's used as a selector in the API.
	 * \@docs-private
	 */
	var MatCardSubtitle = /** @class */ (function () {
	    function MatCardSubtitle() {
	    }
	    MatCardSubtitle.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: "mat-card-subtitle, [mat-card-subtitle], [matCardSubtitle]",
	                    host: {
	                        'class': 'mat-card-subtitle'
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardSubtitle.ctorParameters = function () { return []; };
	    return MatCardSubtitle;
	}());
	/**
	 * Action section of a card, needed as it's used as a selector in the API.
	 * \@docs-private
	 */
	var MatCardActions = /** @class */ (function () {
	    function MatCardActions() {
	        /**
	         * Position of the actions inside the card.
	         */
	        this.align = 'start';
	    }
	    MatCardActions.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-card-actions',
	                    exportAs: 'matCardActions',
	                    host: {
	                        'class': 'mat-card-actions',
	                        '[class.mat-card-actions-align-end]': 'align === "end"',
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardActions.ctorParameters = function () { return []; };
	    MatCardActions.propDecorators = {
	        "align": [{ type: _angular_core.Input },],
	    };
	    return MatCardActions;
	}());
	/**
	 * Footer of a card, needed as it's used as a selector in the API.
	 * \@docs-private
	 */
	var MatCardFooter = /** @class */ (function () {
	    function MatCardFooter() {
	    }
	    MatCardFooter.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-card-footer',
	                    host: { 'class': 'mat-card-footer' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardFooter.ctorParameters = function () { return []; };
	    return MatCardFooter;
	}());
	/**
	 * Image used in a card, needed to add the mat- CSS styling.
	 * \@docs-private
	 */
	var MatCardImage = /** @class */ (function () {
	    function MatCardImage() {
	    }
	    MatCardImage.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-card-image], [matCardImage]',
	                    host: { 'class': 'mat-card-image' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardImage.ctorParameters = function () { return []; };
	    return MatCardImage;
	}());
	/**
	 * Image used in a card, needed to add the mat- CSS styling.
	 * \@docs-private
	 */
	var MatCardSmImage = /** @class */ (function () {
	    function MatCardSmImage() {
	    }
	    MatCardSmImage.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-card-sm-image], [matCardImageSmall]',
	                    host: { 'class': 'mat-card-sm-image' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardSmImage.ctorParameters = function () { return []; };
	    return MatCardSmImage;
	}());
	/**
	 * Image used in a card, needed to add the mat- CSS styling.
	 * \@docs-private
	 */
	var MatCardMdImage = /** @class */ (function () {
	    function MatCardMdImage() {
	    }
	    MatCardMdImage.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-card-md-image], [matCardImageMedium]',
	                    host: { 'class': 'mat-card-md-image' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardMdImage.ctorParameters = function () { return []; };
	    return MatCardMdImage;
	}());
	/**
	 * Image used in a card, needed to add the mat- CSS styling.
	 * \@docs-private
	 */
	var MatCardLgImage = /** @class */ (function () {
	    function MatCardLgImage() {
	    }
	    MatCardLgImage.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-card-lg-image], [matCardImageLarge]',
	                    host: { 'class': 'mat-card-lg-image' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardLgImage.ctorParameters = function () { return []; };
	    return MatCardLgImage;
	}());
	/**
	 * Large image used in a card, needed to add the mat- CSS styling.
	 * \@docs-private
	 */
	var MatCardXlImage = /** @class */ (function () {
	    function MatCardXlImage() {
	    }
	    MatCardXlImage.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-card-xl-image], [matCardImageXLarge]',
	                    host: { 'class': 'mat-card-xl-image' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardXlImage.ctorParameters = function () { return []; };
	    return MatCardXlImage;
	}());
	/**
	 * Avatar image used in a card, needed to add the mat- CSS styling.
	 * \@docs-private
	 */
	var MatCardAvatar = /** @class */ (function () {
	    function MatCardAvatar() {
	    }
	    MatCardAvatar.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-card-avatar], [matCardAvatar]',
	                    host: { 'class': 'mat-card-avatar' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardAvatar.ctorParameters = function () { return []; };
	    return MatCardAvatar;
	}());
	/**
	 * A basic content container component that adds the styles of a Material design card.
	 *
	 * While this component can be used alone, it also provides a number
	 * of preset styles for common card sections, including:
	 * - mat-card-title
	 * - mat-card-subtitle
	 * - mat-card-content
	 * - mat-card-actions
	 * - mat-card-footer
	 */
	var MatCard = /** @class */ (function () {
	    function MatCard() {
	    }
	    MatCard.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-card',
	                    exportAs: 'matCard',
	                    template: "<ng-content></ng-content><ng-content select=\"mat-card-footer\"></ng-content>",
	                    styles: [".mat-card{transition:box-shadow 280ms cubic-bezier(.4,0,.2,1);display:block;position:relative;padding:24px;border-radius:2px}.mat-card:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.mat-card .mat-divider{position:absolute;left:0;width:100%}[dir=rtl] .mat-card .mat-divider{left:auto;right:0}.mat-card .mat-divider.mat-divider-inset{position:static;margin:0}@media screen and (-ms-high-contrast:active){.mat-card{outline:solid 1px}}.mat-card-flat{box-shadow:none}.mat-card-actions,.mat-card-content,.mat-card-subtitle,.mat-card-title{display:block;margin-bottom:16px}.mat-card-actions{margin-left:-16px;margin-right:-16px;padding:8px 0}.mat-card-actions-align-end{display:flex;justify-content:flex-end}.mat-card-image{width:calc(100% + 48px);margin:0 -24px 16px -24px}.mat-card-xl-image{width:240px;height:240px;margin:-8px}.mat-card-footer{display:block;margin:0 -24px -24px -24px}.mat-card-actions .mat-button,.mat-card-actions .mat-raised-button{margin:0 4px}.mat-card-header{display:flex;flex-direction:row}.mat-card-header-text{margin:0 8px}.mat-card-avatar{height:40px;width:40px;border-radius:50%;flex-shrink:0}.mat-card-lg-image,.mat-card-md-image,.mat-card-sm-image{margin:-8px 0}.mat-card-title-group{display:flex;justify-content:space-between;margin:0 -8px}.mat-card-sm-image{width:80px;height:80px}.mat-card-md-image{width:112px;height:112px}.mat-card-lg-image{width:152px;height:152px}@media (max-width:599px){.mat-card{padding:24px 16px}.mat-card-actions{margin-left:-8px;margin-right:-8px}.mat-card-image{width:calc(100% + 32px);margin:16px -16px}.mat-card-title-group{margin:0}.mat-card-xl-image{margin-left:0;margin-right:0}.mat-card-header{margin:-8px 0 0 0}.mat-card-footer{margin-left:-16px;margin-right:-16px}}.mat-card-content>:first-child,.mat-card>:first-child{margin-top:0}.mat-card-content>:last-child:not(.mat-card-footer),.mat-card>:last-child:not(.mat-card-footer){margin-bottom:0}.mat-card-image:first-child{margin-top:-24px}.mat-card>.mat-card-actions:last-child{margin-bottom:-16px;padding-bottom:0}.mat-card-actions .mat-button:first-child,.mat-card-actions .mat-raised-button:first-child{margin-left:0;margin-right:0}.mat-card-subtitle:not(:first-child),.mat-card-title:not(:first-child){margin-top:-4px}.mat-card-header .mat-card-subtitle:not(:first-child){margin-top:-8px}.mat-card>.mat-card-xl-image:first-child{margin-top:-8px}.mat-card>.mat-card-xl-image:last-child{margin-bottom:-8px}"],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    host: { 'class': 'mat-card' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCard.ctorParameters = function () { return []; };
	    return MatCard;
	}());
	/**
	 * Component intended to be used within the `<mat-card>` component. It adds styles for a
	 * preset header section (i.e. a title, subtitle, and avatar layout).
	 * \@docs-private
	 */
	var MatCardHeader = /** @class */ (function () {
	    function MatCardHeader() {
	    }
	    MatCardHeader.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-card-header',
	                    template: "<ng-content select=\"[mat-card-avatar], [matCardAvatar]\"></ng-content><div class=\"mat-card-header-text\"><ng-content select=\"mat-card-title, mat-card-subtitle, [mat-card-title], [mat-card-subtitle], [matCardTitle], [matCardSubtitle]\"></ng-content></div><ng-content></ng-content>",
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    host: { 'class': 'mat-card-header' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardHeader.ctorParameters = function () { return []; };
	    return MatCardHeader;
	}());
	/**
	 * Component intended to be used within the `<mat-card>` component. It adds styles for a preset
	 * layout that groups an image with a title section.
	 * \@docs-private
	 */
	var MatCardTitleGroup = /** @class */ (function () {
	    function MatCardTitleGroup() {
	    }
	    MatCardTitleGroup.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-card-title-group',
	                    template: "<div><ng-content select=\"mat-card-title, mat-card-subtitle, [mat-card-title], [mat-card-subtitle], [matCardTitle], [matCardSubtitle]\"></ng-content></div><ng-content select=\"img\"></ng-content><ng-content></ng-content>",
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    host: { 'class': 'mat-card-title-group' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardTitleGroup.ctorParameters = function () { return []; };
	    return MatCardTitleGroup;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatCardModule = /** @class */ (function () {
	    function MatCardModule() {
	    }
	    MatCardModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [_angular_material_core.MatCommonModule],
	                    exports: [
	                        MatCard,
	                        MatCardHeader,
	                        MatCardTitleGroup,
	                        MatCardContent,
	                        MatCardTitle,
	                        MatCardSubtitle,
	                        MatCardActions,
	                        MatCardFooter,
	                        MatCardSmImage,
	                        MatCardMdImage,
	                        MatCardLgImage,
	                        MatCardImage,
	                        MatCardXlImage,
	                        MatCardAvatar,
	                        _angular_material_core.MatCommonModule,
	                    ],
	                    declarations: [
	                        MatCard, MatCardHeader, MatCardTitleGroup, MatCardContent, MatCardTitle, MatCardSubtitle,
	                        MatCardActions, MatCardFooter, MatCardSmImage, MatCardMdImage, MatCardLgImage, MatCardImage,
	                        MatCardXlImage, MatCardAvatar,
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardModule.ctorParameters = function () { return []; };
	    return MatCardModule;
	}());
	
	exports.MatCardContent = MatCardContent;
	exports.MatCardTitle = MatCardTitle;
	exports.MatCardSubtitle = MatCardSubtitle;
	exports.MatCardActions = MatCardActions;
	exports.MatCardFooter = MatCardFooter;
	exports.MatCardImage = MatCardImage;
	exports.MatCardSmImage = MatCardSmImage;
	exports.MatCardMdImage = MatCardMdImage;
	exports.MatCardLgImage = MatCardLgImage;
	exports.MatCardXlImage = MatCardXlImage;
	exports.MatCardAvatar = MatCardAvatar;
	exports.MatCard = MatCard;
	exports.MatCardHeader = MatCardHeader;
	exports.MatCardTitleGroup = MatCardTitleGroup;
	exports.MatCardModule = MatCardModule;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=material-card.umd.js.map


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(1076), __webpack_require__(1077), __webpack_require__(240), __webpack_require__(206), __webpack_require__(247), __webpack_require__(246), __webpack_require__(1078), __webpack_require__(1079)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@angular/cdk/bidi', '@angular/cdk/coercion', 'rxjs/Subject', 'rxjs/Observable', '@angular/platform-browser', '@angular/common', '@angular/cdk/platform', '@angular/cdk/keycodes'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.material = global.ng.material || {}, global.ng.material.core = global.ng.material.core || {}),global.ng.core,global.ng.cdk.bidi,global.ng.cdk.coercion,global.Rx,global.Rx,global.ng.platformBrowser,global.ng.common,global.ng.cdk.platform,global.ng.cdk.keycodes));
	}(this, (function (exports,_angular_core,_angular_cdk_bidi,_angular_cdk_coercion,rxjs_Subject,rxjs_Observable,_angular_platformBrowser,_angular_common,_angular_cdk_platform,_angular_cdk_keycodes) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = Object.assign || function __assign(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	    }
	    return t;
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 */
	var AnimationCurves = /** @class */ (function () {
	    function AnimationCurves() {
	    }
	    AnimationCurves.STANDARD_CURVE = 'cubic-bezier(0.4,0.0,0.2,1)';
	    AnimationCurves.DECELERATION_CURVE = 'cubic-bezier(0.0,0.0,0.2,1)';
	    AnimationCurves.ACCELERATION_CURVE = 'cubic-bezier(0.4,0.0,1,1)';
	    AnimationCurves.SHARP_CURVE = 'cubic-bezier(0.4,0.0,0.6,1)';
	    return AnimationCurves;
	}());
	/**
	 * \@docs-private
	 */
	var AnimationDurations = /** @class */ (function () {
	    function AnimationDurations() {
	    }
	    AnimationDurations.COMPLEX = '375ms';
	    AnimationDurations.ENTERING = '225ms';
	    AnimationDurations.EXITING = '195ms';
	    return AnimationDurations;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Injection token that configures whether the Material sanity checks are enabled.
	 */
	var MATERIAL_SANITY_CHECKS = new _angular_core.InjectionToken('mat-sanity-checks');
	/**
	 * Module that captures anything that should be loaded and/or run for *all* Angular Material
	 * components. This includes Bidi, etc.
	 *
	 * This module should be imported to each top-level component module (e.g., MatTabsModule).
	 */
	var MatCommonModule = /** @class */ (function () {
	    function MatCommonModule(_sanityChecksEnabled) {
	        this._sanityChecksEnabled = _sanityChecksEnabled;
	        /**
	         * Whether we've done the global sanity checks (e.g. a theme is loaded, there is a doctype).
	         */
	        this._hasDoneGlobalChecks = false;
	        /**
	         * Whether we've already checked for HammerJs availability.
	         */
	        this._hasCheckedHammer = false;
	        /**
	         * Reference to the global `document` object.
	         */
	        this._document = typeof document === 'object' && document ? document : null;
	        /**
	         * Reference to the global 'window' object.
	         */
	        this._window = typeof window === 'object' && window ? window : null;
	        if (this._areChecksEnabled() && !this._hasDoneGlobalChecks) {
	            this._checkDoctypeIsDefined();
	            this._checkThemeIsPresent();
	            this._hasDoneGlobalChecks = true;
	        }
	    }
	    /**
	     * Whether any sanity checks are enabled
	     * @return {?}
	     */
	    MatCommonModule.prototype._areChecksEnabled = /**
	     * Whether any sanity checks are enabled
	     * @return {?}
	     */
	    function () {
	        return this._sanityChecksEnabled && _angular_core.isDevMode() && !this._isTestEnv();
	    };
	    /**
	     * Whether the code is running in tests.
	     * @return {?}
	     */
	    MatCommonModule.prototype._isTestEnv = /**
	     * Whether the code is running in tests.
	     * @return {?}
	     */
	    function () {
	        return this._window && (this._window['__karma__'] || this._window['jasmine']);
	    };
	    /**
	     * @return {?}
	     */
	    MatCommonModule.prototype._checkDoctypeIsDefined = /**
	     * @return {?}
	     */
	    function () {
	        if (this._document && !this._document.doctype) {
	            console.warn('Current document does not have a doctype. This may cause ' +
	                'some Angular Material components not to behave as expected.');
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatCommonModule.prototype._checkThemeIsPresent = /**
	     * @return {?}
	     */
	    function () {
	        if (this._document && typeof getComputedStyle === 'function') {
	            var /** @type {?} */ testElement = this._document.createElement('div');
	            testElement.classList.add('mat-theme-loaded-marker');
	            this._document.body.appendChild(testElement);
	            var /** @type {?} */ computedStyle = getComputedStyle(testElement);
	            // In some situations, the computed style of the test element can be null. For example in
	            // Firefox, the computed style is null if an application is running inside of a hidden iframe.
	            // See: https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	            if (computedStyle && computedStyle.display !== 'none') {
	                console.warn('Could not find Angular Material core theme. Most Material ' +
	                    'components may not work as expected. For more info refer ' +
	                    'to the theming guide: https://material.angular.io/guide/theming');
	            }
	            this._document.body.removeChild(testElement);
	        }
	    };
	    /** Checks whether HammerJS is available. */
	    /**
	     * Checks whether HammerJS is available.
	     * @return {?}
	     */
	    MatCommonModule.prototype._checkHammerIsAvailable = /**
	     * Checks whether HammerJS is available.
	     * @return {?}
	     */
	    function () {
	        if (this._hasCheckedHammer || !this._window) {
	            return;
	        }
	        if (this._areChecksEnabled() && !this._window['Hammer']) {
	            console.warn('Could not find HammerJS. Certain Angular Material components may not work correctly.');
	        }
	        this._hasCheckedHammer = true;
	    };
	    MatCommonModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [_angular_cdk_bidi.BidiModule],
	                    exports: [_angular_cdk_bidi.BidiModule],
	                    providers: [{
	                            provide: MATERIAL_SANITY_CHECKS, useValue: true,
	                        }],
	                },] },
	    ];
	    /** @nocollapse */
	    MatCommonModule.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MATERIAL_SANITY_CHECKS,] },] },
	    ]; };
	    return MatCommonModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * Mixin to augment a directive with a `disabled` property.
	 * @template T
	 * @param {?} base
	 * @return {?}
	 */
	function mixinDisabled(base) {
	    return /** @class */ (function (_super) {
	        __extends(class_1, _super);
	        function class_1() {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var _this = _super.apply(this, args) || this;
	            _this._disabled = false;
	            return _this;
	        }
	        Object.defineProperty(class_1.prototype, "disabled", {
	            get: /**
	             * @return {?}
	             */
	            function () { return this._disabled; },
	            set: /**
	             * @param {?} value
	             * @return {?}
	             */
	            function (value) { this._disabled = _angular_cdk_coercion.coerceBooleanProperty(value); },
	            enumerable: true,
	            configurable: true
	        });
	        return class_1;
	    }(base));
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * Mixin to augment a directive with a `color` property.
	 * @template T
	 * @param {?} base
	 * @param {?=} defaultColor
	 * @return {?}
	 */
	function mixinColor(base, defaultColor) {
	    return /** @class */ (function (_super) {
	        __extends(class_1, _super);
	        function class_1() {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var _this = _super.apply(this, args) || this;
	            // Set the default color that can be specified from the mixin.
	            // Set the default color that can be specified from the mixin.
	            _this.color = defaultColor;
	            return _this;
	        }
	        Object.defineProperty(class_1.prototype, "color", {
	            get: /**
	             * @return {?}
	             */
	            function () { return this._color; },
	            set: /**
	             * @param {?} value
	             * @return {?}
	             */
	            function (value) {
	                var /** @type {?} */ colorPalette = value || defaultColor;
	                if (colorPalette !== this._color) {
	                    if (this._color) {
	                        this._elementRef.nativeElement.classList.remove("mat-" + this._color);
	                    }
	                    if (colorPalette) {
	                        this._elementRef.nativeElement.classList.add("mat-" + colorPalette);
	                    }
	                    this._color = colorPalette;
	                }
	            },
	            enumerable: true,
	            configurable: true
	        });
	        return class_1;
	    }(base));
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * Mixin to augment a directive with a `disableRipple` property.
	 * @template T
	 * @param {?} base
	 * @return {?}
	 */
	function mixinDisableRipple(base) {
	    return /** @class */ (function (_super) {
	        __extends(class_1, _super);
	        function class_1() {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var _this = _super.apply(this, args) || this;
	            _this._disableRipple = false;
	            return _this;
	        }
	        Object.defineProperty(class_1.prototype, "disableRipple", {
	            /** Whether the ripple effect is disabled or not. */
	            get: /**
	             * Whether the ripple effect is disabled or not.
	             * @return {?}
	             */
	            function () { return this._disableRipple; },
	            set: /**
	             * @param {?} value
	             * @return {?}
	             */
	            function (value) { this._disableRipple = _angular_cdk_coercion.coerceBooleanProperty(value); },
	            enumerable: true,
	            configurable: true
	        });
	        return class_1;
	    }(base));
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * Mixin to augment a directive with a `tabIndex` property.
	 * @template T
	 * @param {?} base
	 * @param {?=} defaultTabIndex
	 * @return {?}
	 */
	function mixinTabIndex(base, defaultTabIndex) {
	    if (defaultTabIndex === void 0) { defaultTabIndex = 0; }
	    return /** @class */ (function (_super) {
	        __extends(class_1, _super);
	        function class_1() {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var _this = _super.apply(this, args) || this;
	            _this._tabIndex = defaultTabIndex;
	            return _this;
	        }
	        Object.defineProperty(class_1.prototype, "tabIndex", {
	            get: /**
	             * @return {?}
	             */
	            function () { return this.disabled ? -1 : this._tabIndex; },
	            set: /**
	             * @param {?} value
	             * @return {?}
	             */
	            function (value) {
	                // If the specified tabIndex value is null or undefined, fall back to the default value.
	                this._tabIndex = value != null ? value : defaultTabIndex;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        return class_1;
	    }(base));
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * Mixin to augment a directive with updateErrorState method.
	 * For component with `errorState` and need to update `errorState`.
	 * @template T
	 * @param {?} base
	 * @return {?}
	 */
	function mixinErrorState(base) {
	    return /** @class */ (function (_super) {
	        __extends(class_1, _super);
	        function class_1() {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var _this = _super.apply(this, args) || this;
	            /**
	             * Whether the component is in an error state.
	             */
	            _this.errorState = false;
	            /**
	             * Stream that emits whenever the state of the input changes such that the wrapping
	             * `MatFormField` needs to run change detection.
	             */
	            _this.stateChanges = new rxjs_Subject.Subject();
	            return _this;
	        }
	        /**
	         * @return {?}
	         */
	        class_1.prototype.updateErrorState = /**
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ oldState = this.errorState;
	            var /** @type {?} */ parent = this._parentFormGroup || this._parentForm;
	            var /** @type {?} */ matcher = this.errorStateMatcher || this._defaultErrorStateMatcher;
	            var /** @type {?} */ control = this.ngControl ? /** @type {?} */ (this.ngControl.control) : null;
	            var /** @type {?} */ newState = matcher.isErrorState(control, parent);
	            if (newState !== oldState) {
	                this.errorState = newState;
	                this.stateChanges.next();
	            }
	        };
	        return class_1;
	    }(base));
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Mixin that adds an initialized property to a directive which, when subscribed to, will emit a
	 * value once markInitialized has been called, which should be done during the ngOnInit function.
	 * If the subscription is made after it has already been marked as initialized, then it will trigger
	 * an emit immediately.
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * Mixin to augment a directive with an initialized property that will emits when ngOnInit ends.
	 * @template T
	 * @param {?} base
	 * @return {?}
	 */
	function mixinInitialized(base) {
	    return /** @class */ (function (_super) {
	        __extends(class_1, _super);
	        function class_1() {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var _this = _super.apply(this, args) || this;
	            /**
	             * Whether this directive has been marked as initialized.
	             */
	            _this._isInitialized = false;
	            /**
	             * List of subscribers that subscribed before the directive was initialized. Should be notified
	             * during _markInitialized. Set to null after pending subscribers are notified, and should
	             * not expect to be populated after.
	             */
	            _this._pendingSubscribers = [];
	            /**
	             * Observable stream that emits when the directive initializes. If already initialized, the
	             * subscriber is stored to be notified once _markInitialized is called.
	             */
	            _this.initialized = new rxjs_Observable.Observable(function (subscriber) {
	                // If initialized, immediately notify the subscriber. Otherwise store the subscriber to notify
	                // when _markInitialized is called.
	                if (_this._isInitialized) {
	                    _this._notifySubscriber(subscriber);
	                }
	                else {
	                    /** @type {?} */ ((_this._pendingSubscribers)).push(subscriber);
	                }
	            });
	            return _this;
	        }
	        /**
	         * Marks the state as initialized and notifies pending subscribers. Should be called at the end
	         * of ngOnInit.
	         * @docs-private
	         */
	        /**
	         * Marks the state as initialized and notifies pending subscribers. Should be called at the end
	         * of ngOnInit.
	         * \@docs-private
	         * @return {?}
	         */
	        class_1.prototype._markInitialized = /**
	         * Marks the state as initialized and notifies pending subscribers. Should be called at the end
	         * of ngOnInit.
	         * \@docs-private
	         * @return {?}
	         */
	        function () {
	            if (this._isInitialized) {
	                throw Error('This directive has already been marked as initialized and ' +
	                    'should not be called twice.');
	            }
	            this._isInitialized = true; /** @type {?} */
	            ((this._pendingSubscribers)).forEach(this._notifySubscriber);
	            this._pendingSubscribers = null;
	        };
	        /** Emits and completes the subscriber stream (should only emit once). */
	        /**
	         * Emits and completes the subscriber stream (should only emit once).
	         * @param {?} subscriber
	         * @return {?}
	         */
	        class_1.prototype._notifySubscriber = /**
	         * Emits and completes the subscriber stream (should only emit once).
	         * @param {?} subscriber
	         * @return {?}
	         */
	        function (subscriber) {
	            subscriber.next();
	            subscriber.complete();
	        };
	        return class_1;
	    }(base));
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * InjectionToken for datepicker that can be used to override default locale code.
	 */
	var MAT_DATE_LOCALE = new _angular_core.InjectionToken('MAT_DATE_LOCALE');
	/**
	 * Provider for MAT_DATE_LOCALE injection token.
	 */
	var MAT_DATE_LOCALE_PROVIDER = { provide: MAT_DATE_LOCALE, useExisting: _angular_core.LOCALE_ID };
	/**
	 * Adapts type `D` to be usable as a date by cdk-based components that work with dates.
	 * @abstract
	 */
	var DateAdapter = /** @class */ (function () {
	    function DateAdapter() {
	        this._localeChanges = new rxjs_Subject.Subject();
	    }
	    Object.defineProperty(DateAdapter.prototype, "localeChanges", {
	        /** A stream that emits when the locale changes. */
	        get: /**
	         * A stream that emits when the locale changes.
	         * @return {?}
	         */
	        function () { return this._localeChanges; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Attempts to deserialize a value to a valid date object. This is different from parsing in that
	     * deserialize should only accept non-ambiguous, locale-independent formats (e.g. a ISO 8601
	     * string). The default implementation does not allow any deserialization, it simply checks that
	     * the given value is already a valid date object or null. The `<mat-datepicker>` will call this
	     * method on all of it's `@Input()` properties that accept dates. It is therefore possible to
	     * support passing values from your backend directly to these properties by overriding this method
	     * to also deserialize the format used by your backend.
	     * @param value The value to be deserialized into a date object.
	     * @returns The deserialized date object, either a valid date, null if the value can be
	     *     deserialized into a null date (e.g. the empty string), or an invalid date.
	     */
	    /**
	     * Attempts to deserialize a value to a valid date object. This is different from parsing in that
	     * deserialize should only accept non-ambiguous, locale-independent formats (e.g. a ISO 8601
	     * string). The default implementation does not allow any deserialization, it simply checks that
	     * the given value is already a valid date object or null. The `<mat-datepicker>` will call this
	     * method on all of it's `\@Input()` properties that accept dates. It is therefore possible to
	     * support passing values from your backend directly to these properties by overriding this method
	     * to also deserialize the format used by your backend.
	     * @param {?} value The value to be deserialized into a date object.
	     * @return {?} The deserialized date object, either a valid date, null if the value can be
	     *     deserialized into a null date (e.g. the empty string), or an invalid date.
	     */
	    DateAdapter.prototype.deserialize = /**
	     * Attempts to deserialize a value to a valid date object. This is different from parsing in that
	     * deserialize should only accept non-ambiguous, locale-independent formats (e.g. a ISO 8601
	     * string). The default implementation does not allow any deserialization, it simply checks that
	     * the given value is already a valid date object or null. The `<mat-datepicker>` will call this
	     * method on all of it's `\@Input()` properties that accept dates. It is therefore possible to
	     * support passing values from your backend directly to these properties by overriding this method
	     * to also deserialize the format used by your backend.
	     * @param {?} value The value to be deserialized into a date object.
	     * @return {?} The deserialized date object, either a valid date, null if the value can be
	     *     deserialized into a null date (e.g. the empty string), or an invalid date.
	     */
	    function (value) {
	        if (value == null || this.isDateInstance(value) && this.isValid(value)) {
	            return value;
	        }
	        return this.invalid();
	    };
	    /**
	     * Sets the locale used for all dates.
	     * @param locale The new locale.
	     */
	    /**
	     * Sets the locale used for all dates.
	     * @param {?} locale The new locale.
	     * @return {?}
	     */
	    DateAdapter.prototype.setLocale = /**
	     * Sets the locale used for all dates.
	     * @param {?} locale The new locale.
	     * @return {?}
	     */
	    function (locale) {
	        this.locale = locale;
	        this._localeChanges.next();
	    };
	    /**
	     * Compares two dates.
	     * @param first The first date to compare.
	     * @param second The second date to compare.
	     * @returns 0 if the dates are equal, a number less than 0 if the first date is earlier,
	     *     a number greater than 0 if the first date is later.
	     */
	    /**
	     * Compares two dates.
	     * @param {?} first The first date to compare.
	     * @param {?} second The second date to compare.
	     * @return {?} 0 if the dates are equal, a number less than 0 if the first date is earlier,
	     *     a number greater than 0 if the first date is later.
	     */
	    DateAdapter.prototype.compareDate = /**
	     * Compares two dates.
	     * @param {?} first The first date to compare.
	     * @param {?} second The second date to compare.
	     * @return {?} 0 if the dates are equal, a number less than 0 if the first date is earlier,
	     *     a number greater than 0 if the first date is later.
	     */
	    function (first, second) {
	        return this.getYear(first) - this.getYear(second) ||
	            this.getMonth(first) - this.getMonth(second) ||
	            this.getDate(first) - this.getDate(second);
	    };
	    /**
	     * Checks if two dates are equal.
	     * @param first The first date to check.
	     * @param second The second date to check.
	     * @returns Whether the two dates are equal.
	     *     Null dates are considered equal to other null dates.
	     */
	    /**
	     * Checks if two dates are equal.
	     * @param {?} first The first date to check.
	     * @param {?} second The second date to check.
	     * @return {?} Whether the two dates are equal.
	     *     Null dates are considered equal to other null dates.
	     */
	    DateAdapter.prototype.sameDate = /**
	     * Checks if two dates are equal.
	     * @param {?} first The first date to check.
	     * @param {?} second The second date to check.
	     * @return {?} Whether the two dates are equal.
	     *     Null dates are considered equal to other null dates.
	     */
	    function (first, second) {
	        if (first && second) {
	            var /** @type {?} */ firstValid = this.isValid(first);
	            var /** @type {?} */ secondValid = this.isValid(second);
	            if (firstValid && secondValid) {
	                return !this.compareDate(first, second);
	            }
	            return firstValid == secondValid;
	        }
	        return first == second;
	    };
	    /**
	     * Clamp the given date between min and max dates.
	     * @param date The date to clamp.
	     * @param min The minimum value to allow. If null or omitted no min is enforced.
	     * @param max The maximum value to allow. If null or omitted no max is enforced.
	     * @returns `min` if `date` is less than `min`, `max` if date is greater than `max`,
	     *     otherwise `date`.
	     */
	    /**
	     * Clamp the given date between min and max dates.
	     * @param {?} date The date to clamp.
	     * @param {?=} min The minimum value to allow. If null or omitted no min is enforced.
	     * @param {?=} max The maximum value to allow. If null or omitted no max is enforced.
	     * @return {?} `min` if `date` is less than `min`, `max` if date is greater than `max`,
	     *     otherwise `date`.
	     */
	    DateAdapter.prototype.clampDate = /**
	     * Clamp the given date between min and max dates.
	     * @param {?} date The date to clamp.
	     * @param {?=} min The minimum value to allow. If null or omitted no min is enforced.
	     * @param {?=} max The maximum value to allow. If null or omitted no max is enforced.
	     * @return {?} `min` if `date` is less than `min`, `max` if date is greater than `max`,
	     *     otherwise `date`.
	     */
	    function (date, min, max) {
	        if (min && this.compareDate(date, min) < 0) {
	            return min;
	        }
	        if (max && this.compareDate(date, max) > 0) {
	            return max;
	        }
	        return date;
	    };
	    return DateAdapter;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MAT_DATE_FORMATS = new _angular_core.InjectionToken('mat-date-formats');
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Whether the browser supports the Intl API.
	 */
	var SUPPORTS_INTL_API = typeof Intl != 'undefined';
	/**
	 * The default month names to use if Intl API is not available.
	 */
	var DEFAULT_MONTH_NAMES = {
	    'long': [
	        'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
	        'October', 'November', 'December'
	    ],
	    'short': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	    'narrow': ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D']
	};
	var ɵ0$1 = function (i) { return String(i + 1); };
	/**
	 * The default date names to use if Intl API is not available.
	 */
	var DEFAULT_DATE_NAMES = range(31, ɵ0$1);
	/**
	 * The default day of the week names to use if Intl API is not available.
	 */
	var DEFAULT_DAY_OF_WEEK_NAMES = {
	    'long': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	    'short': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	    'narrow': ['S', 'M', 'T', 'W', 'T', 'F', 'S']
	};
	/**
	 * Matches strings that have the form of a valid RFC 3339 string
	 * (https://tools.ietf.org/html/rfc3339). Note that the string may not actually be a valid date
	 * because the regex will match strings an with out of bounds month, date, etc.
	 */
	var ISO_8601_REGEX = /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|(?:(?:\+|-)\d{2}:\d{2}))?)?$/;
	/**
	 * Creates an array and fills it with values.
	 * @template T
	 * @param {?} length
	 * @param {?} valueFunction
	 * @return {?}
	 */
	function range(length, valueFunction) {
	    var /** @type {?} */ valuesArray = Array(length);
	    for (var /** @type {?} */ i = 0; i < length; i++) {
	        valuesArray[i] = valueFunction(i);
	    }
	    return valuesArray;
	}
	/**
	 * Adapts the native JS Date for use with cdk-based components that work with dates.
	 */
	var NativeDateAdapter = /** @class */ (function (_super) {
	    __extends(NativeDateAdapter, _super);
	    function NativeDateAdapter(matDateLocale) {
	        var _this = _super.call(this) || this;
	        _super.prototype.setLocale.call(_this, matDateLocale);
	        // IE does its own time zone correction, so we disable this on IE.
	        // TODO(mmalerba): replace with checks from PLATFORM, logic currently duplicated to avoid
	        // breaking change from injecting the Platform.
	        var /** @type {?} */ isBrowser = typeof document === 'object' && !!document;
	        var /** @type {?} */ isIE = isBrowser && /(msie|trident)/i.test(navigator.userAgent);
	        _this.useUtcForDisplay = !isIE;
	        _this._clampDate = isIE || (isBrowser && /(edge)/i.test(navigator.userAgent));
	        return _this;
	    }
	    /**
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.getYear = /**
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        return date.getFullYear();
	    };
	    /**
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.getMonth = /**
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        return date.getMonth();
	    };
	    /**
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.getDate = /**
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        return date.getDate();
	    };
	    /**
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.getDayOfWeek = /**
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        return date.getDay();
	    };
	    /**
	     * @param {?} style
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.getMonthNames = /**
	     * @param {?} style
	     * @return {?}
	     */
	    function (style) {
	        var _this = this;
	        if (SUPPORTS_INTL_API) {
	            var /** @type {?} */ dtf_1 = new Intl.DateTimeFormat(this.locale, { month: style, timeZone: 'utc' });
	            return range(12, function (i) {
	                return _this._stripDirectionalityCharacters(_this._format(dtf_1, new Date(2017, i, 1)));
	            });
	        }
	        return DEFAULT_MONTH_NAMES[style];
	    };
	    /**
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.getDateNames = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (SUPPORTS_INTL_API) {
	            var /** @type {?} */ dtf_2 = new Intl.DateTimeFormat(this.locale, { day: 'numeric', timeZone: 'utc' });
	            return range(31, function (i) {
	                return _this._stripDirectionalityCharacters(_this._format(dtf_2, new Date(2017, 0, i + 1)));
	            });
	        }
	        return DEFAULT_DATE_NAMES;
	    };
	    /**
	     * @param {?} style
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.getDayOfWeekNames = /**
	     * @param {?} style
	     * @return {?}
	     */
	    function (style) {
	        var _this = this;
	        if (SUPPORTS_INTL_API) {
	            var /** @type {?} */ dtf_3 = new Intl.DateTimeFormat(this.locale, { weekday: style, timeZone: 'utc' });
	            return range(7, function (i) {
	                return _this._stripDirectionalityCharacters(_this._format(dtf_3, new Date(2017, 0, i + 1)));
	            });
	        }
	        return DEFAULT_DAY_OF_WEEK_NAMES[style];
	    };
	    /**
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.getYearName = /**
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        if (SUPPORTS_INTL_API) {
	            var /** @type {?} */ dtf = new Intl.DateTimeFormat(this.locale, { year: 'numeric', timeZone: 'utc' });
	            return this._stripDirectionalityCharacters(this._format(dtf, date));
	        }
	        return String(this.getYear(date));
	    };
	    /**
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.getFirstDayOfWeek = /**
	     * @return {?}
	     */
	    function () {
	        // We can't tell using native JS Date what the first day of the week is, we default to Sunday.
	        return 0;
	    };
	    /**
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.getNumDaysInMonth = /**
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        return this.getDate(this._createDateWithOverflow(this.getYear(date), this.getMonth(date) + 1, 0));
	    };
	    /**
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.clone = /**
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        return this.createDate(this.getYear(date), this.getMonth(date), this.getDate(date));
	    };
	    /**
	     * @param {?} year
	     * @param {?} month
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.createDate = /**
	     * @param {?} year
	     * @param {?} month
	     * @param {?} date
	     * @return {?}
	     */
	    function (year, month, date) {
	        // Check for invalid month and date (except upper bound on date which we have to check after
	        // creating the Date).
	        if (month < 0 || month > 11) {
	            throw Error("Invalid month index \"" + month + "\". Month index has to be between 0 and 11.");
	        }
	        if (date < 1) {
	            throw Error("Invalid date \"" + date + "\". Date has to be greater than 0.");
	        }
	        var /** @type {?} */ result = this._createDateWithOverflow(year, month, date);
	        // Check that the date wasn't above the upper bound for the month, causing the month to overflow
	        if (result.getMonth() != month) {
	            throw Error("Invalid date \"" + date + "\" for month with index \"" + month + "\".");
	        }
	        return result;
	    };
	    /**
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.today = /**
	     * @return {?}
	     */
	    function () {
	        return new Date();
	    };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.parse = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        // We have no way using the native JS Date to set the parse format or locale, so we ignore these
	        // parameters.
	        if (typeof value == 'number') {
	            return new Date(value);
	        }
	        return value ? new Date(Date.parse(value)) : null;
	    };
	    /**
	     * @param {?} date
	     * @param {?} displayFormat
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.format = /**
	     * @param {?} date
	     * @param {?} displayFormat
	     * @return {?}
	     */
	    function (date, displayFormat) {
	        if (!this.isValid(date)) {
	            throw Error('NativeDateAdapter: Cannot format invalid date.');
	        }
	        if (SUPPORTS_INTL_API) {
	            // On IE and Edge the i18n API will throw a hard error that can crash the entire app
	            // if we attempt to format a date whose year is less than 1 or greater than 9999.
	            if (this._clampDate && (date.getFullYear() < 1 || date.getFullYear() > 9999)) {
	                date = this.clone(date);
	                date.setFullYear(Math.max(1, Math.min(9999, date.getFullYear())));
	            }
	            displayFormat = __assign({}, displayFormat, { timeZone: 'utc' });
	            var /** @type {?} */ dtf = new Intl.DateTimeFormat(this.locale, displayFormat);
	            return this._stripDirectionalityCharacters(this._format(dtf, date));
	        }
	        return this._stripDirectionalityCharacters(date.toDateString());
	    };
	    /**
	     * @param {?} date
	     * @param {?} years
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.addCalendarYears = /**
	     * @param {?} date
	     * @param {?} years
	     * @return {?}
	     */
	    function (date, years) {
	        return this.addCalendarMonths(date, years * 12);
	    };
	    /**
	     * @param {?} date
	     * @param {?} months
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.addCalendarMonths = /**
	     * @param {?} date
	     * @param {?} months
	     * @return {?}
	     */
	    function (date, months) {
	        var /** @type {?} */ newDate = this._createDateWithOverflow(this.getYear(date), this.getMonth(date) + months, this.getDate(date));
	        // It's possible to wind up in the wrong month if the original month has more days than the new
	        // month. In this case we want to go to the last day of the desired month.
	        // Note: the additional + 12 % 12 ensures we end up with a positive number, since JS % doesn't
	        // guarantee this.
	        if (this.getMonth(newDate) != ((this.getMonth(date) + months) % 12 + 12) % 12) {
	            newDate = this._createDateWithOverflow(this.getYear(newDate), this.getMonth(newDate), 0);
	        }
	        return newDate;
	    };
	    /**
	     * @param {?} date
	     * @param {?} days
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.addCalendarDays = /**
	     * @param {?} date
	     * @param {?} days
	     * @return {?}
	     */
	    function (date, days) {
	        return this._createDateWithOverflow(this.getYear(date), this.getMonth(date), this.getDate(date) + days);
	    };
	    /**
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.toIso8601 = /**
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        return [
	            date.getUTCFullYear(),
	            this._2digit(date.getUTCMonth() + 1),
	            this._2digit(date.getUTCDate())
	        ].join('-');
	    };
	    /**
	     * Returns the given value if given a valid Date or null. Deserializes valid ISO 8601 strings
	     * (https://www.ietf.org/rfc/rfc3339.txt) into valid Dates and empty string into null. Returns an
	     * invalid date for all other values.
	     */
	    /**
	     * Returns the given value if given a valid Date or null. Deserializes valid ISO 8601 strings
	     * (https://www.ietf.org/rfc/rfc3339.txt) into valid Dates and empty string into null. Returns an
	     * invalid date for all other values.
	     * @param {?} value
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.deserialize = /**
	     * Returns the given value if given a valid Date or null. Deserializes valid ISO 8601 strings
	     * (https://www.ietf.org/rfc/rfc3339.txt) into valid Dates and empty string into null. Returns an
	     * invalid date for all other values.
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        if (typeof value === 'string') {
	            if (!value) {
	                return null;
	            }
	            // The `Date` constructor accepts formats other than ISO 8601, so we need to make sure the
	            // string is the right format first.
	            if (ISO_8601_REGEX.test(value)) {
	                var /** @type {?} */ date = new Date(value);
	                if (this.isValid(date)) {
	                    return date;
	                }
	            }
	        }
	        return _super.prototype.deserialize.call(this, value);
	    };
	    /**
	     * @param {?} obj
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.isDateInstance = /**
	     * @param {?} obj
	     * @return {?}
	     */
	    function (obj) {
	        return obj instanceof Date;
	    };
	    /**
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.isValid = /**
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        return !isNaN(date.getTime());
	    };
	    /**
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.invalid = /**
	     * @return {?}
	     */
	    function () {
	        return new Date(NaN);
	    };
	    /**
	     * Creates a date but allows the month and date to overflow.
	     * @param {?} year
	     * @param {?} month
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype._createDateWithOverflow = /**
	     * Creates a date but allows the month and date to overflow.
	     * @param {?} year
	     * @param {?} month
	     * @param {?} date
	     * @return {?}
	     */
	    function (year, month, date) {
	        var /** @type {?} */ result = new Date(year, month, date);
	        // We need to correct for the fact that JS native Date treats years in range [0, 99] as
	        // abbreviations for 19xx.
	        if (year >= 0 && year < 100) {
	            result.setFullYear(this.getYear(result) - 1900);
	        }
	        return result;
	    };
	    /**
	     * Pads a number to make it two digits.
	     * @param {?} n The number to pad.
	     * @return {?} The padded number.
	     */
	    NativeDateAdapter.prototype._2digit = /**
	     * Pads a number to make it two digits.
	     * @param {?} n The number to pad.
	     * @return {?} The padded number.
	     */
	    function (n) {
	        return ('00' + n).slice(-2);
	    };
	    /**
	     * Strip out unicode LTR and RTL characters. Edge and IE insert these into formatted dates while
	     * other browsers do not. We remove them to make output consistent and because they interfere with
	     * date parsing.
	     * @param {?} str The string to strip direction characters from.
	     * @return {?} The stripped string.
	     */
	    NativeDateAdapter.prototype._stripDirectionalityCharacters = /**
	     * Strip out unicode LTR and RTL characters. Edge and IE insert these into formatted dates while
	     * other browsers do not. We remove them to make output consistent and because they interfere with
	     * date parsing.
	     * @param {?} str The string to strip direction characters from.
	     * @return {?} The stripped string.
	     */
	    function (str) {
	        return str.replace(/[\u200e\u200f]/g, '');
	    };
	    /**
	     * When converting Date object to string, javascript built-in functions may return wrong
	     * results because it applies its internal DST rules. The DST rules around the world change
	     * very frequently, and the current valid rule is not always valid in previous years though.
	     * We work around this problem building a new Date object which has its internal UTC
	     * representation with the local date and time.
	     * @param {?} dtf Intl.DateTimeFormat object, containg the desired string format. It must have
	     *    timeZone set to 'utc' to work fine.
	     * @param {?} date Date from which we want to get the string representation according to dtf
	     * @return {?} A Date object with its UTC representation based on the passed in date info
	     */
	    NativeDateAdapter.prototype._format = /**
	     * When converting Date object to string, javascript built-in functions may return wrong
	     * results because it applies its internal DST rules. The DST rules around the world change
	     * very frequently, and the current valid rule is not always valid in previous years though.
	     * We work around this problem building a new Date object which has its internal UTC
	     * representation with the local date and time.
	     * @param {?} dtf Intl.DateTimeFormat object, containg the desired string format. It must have
	     *    timeZone set to 'utc' to work fine.
	     * @param {?} date Date from which we want to get the string representation according to dtf
	     * @return {?} A Date object with its UTC representation based on the passed in date info
	     */
	    function (dtf, date) {
	        var /** @type {?} */ d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
	        return dtf.format(d);
	    };
	    NativeDateAdapter.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    NativeDateAdapter.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MAT_DATE_LOCALE,] },] },
	    ]; };
	    return NativeDateAdapter;
	}(DateAdapter));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MAT_NATIVE_DATE_FORMATS = {
	    parse: {
	        dateInput: null,
	    },
	    display: {
	        dateInput: { year: 'numeric', month: 'numeric', day: 'numeric' },
	        monthYearLabel: { year: 'numeric', month: 'short' },
	        dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
	        monthYearA11yLabel: { year: 'numeric', month: 'long' },
	    }
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var NativeDateModule = /** @class */ (function () {
	    function NativeDateModule() {
	    }
	    NativeDateModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    providers: [
	                        { provide: DateAdapter, useClass: NativeDateAdapter },
	                        MAT_DATE_LOCALE_PROVIDER
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    NativeDateModule.ctorParameters = function () { return []; };
	    return NativeDateModule;
	}());
	var ɵ0$$1 = MAT_NATIVE_DATE_FORMATS;
	var MatNativeDateModule = /** @class */ (function () {
	    function MatNativeDateModule() {
	    }
	    MatNativeDateModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [NativeDateModule],
	                    providers: [{ provide: MAT_DATE_FORMATS, useValue: ɵ0$$1 }],
	                },] },
	    ];
	    /** @nocollapse */
	    MatNativeDateModule.ctorParameters = function () { return []; };
	    return MatNativeDateModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Error state matcher that matches when a control is invalid and dirty.
	 */
	var ShowOnDirtyErrorStateMatcher = /** @class */ (function () {
	    function ShowOnDirtyErrorStateMatcher() {
	    }
	    /**
	     * @param {?} control
	     * @param {?} form
	     * @return {?}
	     */
	    ShowOnDirtyErrorStateMatcher.prototype.isErrorState = /**
	     * @param {?} control
	     * @param {?} form
	     * @return {?}
	     */
	    function (control, form) {
	        return !!(control && control.invalid && (control.dirty || (form && form.submitted)));
	    };
	    ShowOnDirtyErrorStateMatcher.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    ShowOnDirtyErrorStateMatcher.ctorParameters = function () { return []; };
	    return ShowOnDirtyErrorStateMatcher;
	}());
	/**
	 * Provider that defines how form controls behave with regards to displaying error messages.
	 */
	var ErrorStateMatcher = /** @class */ (function () {
	    function ErrorStateMatcher() {
	    }
	    /**
	     * @param {?} control
	     * @param {?} form
	     * @return {?}
	     */
	    ErrorStateMatcher.prototype.isErrorState = /**
	     * @param {?} control
	     * @param {?} form
	     * @return {?}
	     */
	    function (control, form) {
	        return !!(control && control.invalid && (control.touched || (form && form.submitted)));
	    };
	    ErrorStateMatcher.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    ErrorStateMatcher.ctorParameters = function () { return []; };
	    return ErrorStateMatcher;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Injection token that can be used to provide options to the Hammerjs instance.
	 * More info at http://hammerjs.github.io/api/.
	 */
	var MAT_HAMMER_OPTIONS = new _angular_core.InjectionToken('MAT_HAMMER_OPTIONS');
	/**
	 * Adjusts configuration of our gesture library, Hammer.
	 */
	var GestureConfig = /** @class */ (function (_super) {
	    __extends(GestureConfig, _super);
	    function GestureConfig(_hammerOptions, commonModule) {
	        var _this = _super.call(this) || this;
	        _this._hammerOptions = _hammerOptions;
	        _this._hammer = typeof window !== 'undefined' ? (/** @type {?} */ (window)).Hammer : null;
	        /**
	         * List of new event names to add to the gesture support list
	         */
	        _this.events = _this._hammer ? [
	            'longpress',
	            'slide',
	            'slidestart',
	            'slideend',
	            'slideright',
	            'slideleft'
	        ] : [];
	        if (commonModule) {
	            commonModule._checkHammerIsAvailable();
	        }
	        return _this;
	    }
	    /**
	     * Builds Hammer instance manually to add custom recognizers that match the Material Design spec.
	     *
	     * Our gesture names come from the Material Design gestures spec:
	     * https://www.google.com/design/spec/patterns/gestures.html#gestures-touch-mechanics
	     *
	     * More information on default recognizers can be found in Hammer docs:
	     * http://hammerjs.github.io/recognizer-pan/
	     * http://hammerjs.github.io/recognizer-press/
	     *
	     * @param element Element to which to assign the new HammerJS gestures.
	     * @returns Newly-created HammerJS instance.
	     */
	    /**
	     * Builds Hammer instance manually to add custom recognizers that match the Material Design spec.
	     *
	     * Our gesture names come from the Material Design gestures spec:
	     * https://www.google.com/design/spec/patterns/gestures.html#gestures-touch-mechanics
	     *
	     * More information on default recognizers can be found in Hammer docs:
	     * http://hammerjs.github.io/recognizer-pan/
	     * http://hammerjs.github.io/recognizer-press/
	     *
	     * @param {?} element Element to which to assign the new HammerJS gestures.
	     * @return {?} Newly-created HammerJS instance.
	     */
	    GestureConfig.prototype.buildHammer = /**
	     * Builds Hammer instance manually to add custom recognizers that match the Material Design spec.
	     *
	     * Our gesture names come from the Material Design gestures spec:
	     * https://www.google.com/design/spec/patterns/gestures.html#gestures-touch-mechanics
	     *
	     * More information on default recognizers can be found in Hammer docs:
	     * http://hammerjs.github.io/recognizer-pan/
	     * http://hammerjs.github.io/recognizer-press/
	     *
	     * @param {?} element Element to which to assign the new HammerJS gestures.
	     * @return {?} Newly-created HammerJS instance.
	     */
	    function (element) {
	        var /** @type {?} */ mc = new this._hammer(element, this._hammerOptions || undefined);
	        // Default Hammer Recognizers.
	        var /** @type {?} */ pan = new this._hammer.Pan();
	        var /** @type {?} */ swipe = new this._hammer.Swipe();
	        var /** @type {?} */ press = new this._hammer.Press();
	        // Notice that a HammerJS recognizer can only depend on one other recognizer once.
	        // Otherwise the previous `recognizeWith` will be dropped.
	        // TODO: Confirm threshold numbers with Material Design UX Team
	        var /** @type {?} */ slide = this._createRecognizer(pan, { event: 'slide', threshold: 0 }, swipe);
	        var /** @type {?} */ longpress = this._createRecognizer(press, { event: 'longpress', time: 500 });
	        // Overwrite the default `pan` event to use the swipe event.
	        pan.recognizeWith(swipe);
	        // Add customized gestures to Hammer manager
	        mc.add([swipe, press, pan, slide, longpress]);
	        return /** @type {?} */ (mc);
	    };
	    /**
	     * Creates a new recognizer, without affecting the default recognizers of HammerJS
	     * @param {?} base
	     * @param {?} options
	     * @param {...?} inheritances
	     * @return {?}
	     */
	    GestureConfig.prototype._createRecognizer = /**
	     * Creates a new recognizer, without affecting the default recognizers of HammerJS
	     * @param {?} base
	     * @param {?} options
	     * @param {...?} inheritances
	     * @return {?}
	     */
	    function (base, options) {
	        var inheritances = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            inheritances[_i - 2] = arguments[_i];
	        }
	        var /** @type {?} */ recognizer = new (/** @type {?} */ (base.constructor))(options);
	        inheritances.push(base);
	        inheritances.forEach(function (item) { return recognizer.recognizeWith(item); });
	        return recognizer;
	    };
	    GestureConfig.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    GestureConfig.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MAT_HAMMER_OPTIONS,] },] },
	        { type: MatCommonModule, decorators: [{ type: _angular_core.Optional },] },
	    ]; };
	    return GestureConfig;
	}(_angular_platformBrowser.HammerGestureConfig));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Shared directive to count lines inside a text area, such as a list item.
	 * Line elements can be extracted with a \@ContentChildren(MatLine) query, then
	 * counted by checking the query list's length.
	 */
	var MatLine = /** @class */ (function () {
	    function MatLine() {
	    }
	    MatLine.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-line], [matLine]',
	                    host: { 'class': 'mat-line' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatLine.ctorParameters = function () { return []; };
	    return MatLine;
	}());
	/**
	 * Helper that takes a query list of lines and sets the correct class on the host.
	 * \@docs-private
	 */
	var MatLineSetter = /** @class */ (function () {
	    function MatLineSetter(_lines, _element) {
	        var _this = this;
	        this._lines = _lines;
	        this._element = _element;
	        this._setLineClass(this._lines.length);
	        this._lines.changes.subscribe(function () {
	            _this._setLineClass(_this._lines.length);
	        });
	    }
	    /**
	     * @param {?} count
	     * @return {?}
	     */
	    MatLineSetter.prototype._setLineClass = /**
	     * @param {?} count
	     * @return {?}
	     */
	    function (count) {
	        this._resetClasses();
	        if (count === 2 || count === 3) {
	            this._setClass("mat-" + count + "-line", true);
	        }
	        else if (count > 3) {
	            this._setClass("mat-multi-line", true);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatLineSetter.prototype._resetClasses = /**
	     * @return {?}
	     */
	    function () {
	        this._setClass('mat-2-line', false);
	        this._setClass('mat-3-line', false);
	        this._setClass('mat-multi-line', false);
	    };
	    /**
	     * @param {?} className
	     * @param {?} isAdd
	     * @return {?}
	     */
	    MatLineSetter.prototype._setClass = /**
	     * @param {?} className
	     * @param {?} isAdd
	     * @return {?}
	     */
	    function (className, isAdd) {
	        if (isAdd) {
	            this._element.nativeElement.classList.add(className);
	        }
	        else {
	            this._element.nativeElement.classList.remove(className);
	        }
	    };
	    return MatLineSetter;
	}());
	var MatLineModule = /** @class */ (function () {
	    function MatLineModule() {
	    }
	    MatLineModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [MatCommonModule],
	                    exports: [MatLine, MatCommonModule],
	                    declarations: [MatLine],
	                },] },
	    ];
	    /** @nocollapse */
	    MatLineModule.ctorParameters = function () { return []; };
	    return MatLineModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/** @enum {number} */
	var RippleState = {
	    FADING_IN: 0,
	    VISIBLE: 1,
	    FADING_OUT: 2,
	    HIDDEN: 3,
	};
	RippleState[RippleState.FADING_IN] = "FADING_IN";
	RippleState[RippleState.VISIBLE] = "VISIBLE";
	RippleState[RippleState.FADING_OUT] = "FADING_OUT";
	RippleState[RippleState.HIDDEN] = "HIDDEN";
	/**
	 * Reference to a previously launched ripple element.
	 */
	var RippleRef = /** @class */ (function () {
	    function RippleRef(_renderer, element, config) {
	        this._renderer = _renderer;
	        this.element = element;
	        this.config = config;
	        /**
	         * Current state of the ripple reference.
	         */
	        this.state = RippleState.HIDDEN;
	    }
	    /** Fades out the ripple element. */
	    /**
	     * Fades out the ripple element.
	     * @return {?}
	     */
	    RippleRef.prototype.fadeOut = /**
	     * Fades out the ripple element.
	     * @return {?}
	     */
	    function () {
	        this._renderer.fadeOutRipple(this);
	    };
	    return RippleRef;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * Interface that describes the configuration for the animation of a ripple.
	 * There are two animation phases with different durations for the ripples.
	 * @record
	 */
	
	/**
	 * Interface that describes the target for launching ripples.
	 * It defines the ripple configuration and disabled state for interaction ripples.
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * Default ripple animation configuration for ripples without an explicit
	 * animation config specified.
	 */
	var defaultRippleAnimationConfig = {
	    enterDuration: 450,
	    exitDuration: 400
	};
	/**
	 * Timeout for ignoring mouse events. Mouse events will be temporary ignored after touch
	 * events to avoid synthetic mouse events.
	 */
	var ignoreMouseEventsTimeout = 800;
	/**
	 * Helper service that performs DOM manipulations. Not intended to be used outside this module.
	 * The constructor takes a reference to the ripple directive's host element and a map of DOM
	 * event handlers to be installed on the element that triggers ripple animations.
	 * This will eventually become a custom renderer once Angular support exists.
	 * \@docs-private
	 */
	var RippleRenderer = /** @class */ (function () {
	    function RippleRenderer(_target, _ngZone, elementRef, platform) {
	        var _this = this;
	        this._target = _target;
	        this._ngZone = _ngZone;
	        /**
	         * Whether the pointer is currently down or not.
	         */
	        this._isPointerDown = false;
	        /**
	         * Events to be registered on the trigger element.
	         */
	        this._triggerEvents = new Map();
	        /**
	         * Set of currently active ripple references.
	         */
	        this._activeRipples = new Set();
	        /**
	         * Options that apply to all the event listeners that are bound by the renderer.
	         */
	        this._eventOptions = _angular_cdk_platform.supportsPassiveEventListeners() ? (/** @type {?} */ ({ passive: true })) : false;
	        /**
	         * Function being called whenever the trigger is being pressed using mouse.
	         */
	        this.onMousedown = function (event) {
	            var /** @type {?} */ isSyntheticEvent = _this._lastTouchStartEvent &&
	                Date.now() < _this._lastTouchStartEvent + ignoreMouseEventsTimeout;
	            if (!_this._target.rippleDisabled && !isSyntheticEvent) {
	                _this._isPointerDown = true;
	                _this.fadeInRipple(event.clientX, event.clientY, _this._target.rippleConfig);
	            }
	        };
	        /**
	         * Function being called whenever the trigger is being pressed using touch.
	         */
	        this.onTouchStart = function (event) {
	            if (!_this._target.rippleDisabled) {
	                // Some browsers fire mouse events after a `touchstart` event. Those synthetic mouse
	                // events will launch a second ripple if we don't ignore mouse events for a specific
	                // time after a touchstart event.
	                // Some browsers fire mouse events after a `touchstart` event. Those synthetic mouse
	                // events will launch a second ripple if we don't ignore mouse events for a specific
	                // time after a touchstart event.
	                _this._lastTouchStartEvent = Date.now();
	                _this._isPointerDown = true;
	                _this.fadeInRipple(event.touches[0].clientX, event.touches[0].clientY, _this._target.rippleConfig);
	            }
	        };
	        /**
	         * Function being called whenever the trigger is being released.
	         */
	        this.onPointerUp = function () {
	            if (!_this._isPointerDown) {
	                return;
	            }
	            _this._isPointerDown = false;
	            // Fade-out all ripples that are visible and not persistent.
	            // Fade-out all ripples that are visible and not persistent.
	            _this._activeRipples.forEach(function (ripple) {
	                // By default, only ripples that are completely visible will fade out on pointer release.
	                // If the `terminateOnPointerUp` option is set, ripples that still fade in will also fade out.
	                var /** @type {?} */ isVisible = ripple.state === RippleState.VISIBLE ||
	                    ripple.config.terminateOnPointerUp && ripple.state === RippleState.FADING_IN;
	                if (!ripple.config.persistent && isVisible) {
	                    ripple.fadeOut();
	                }
	            });
	        };
	        // Only do anything if we're on the browser.
	        if (platform.isBrowser) {
	            this._containerElement = elementRef.nativeElement;
	            // Specify events which need to be registered on the trigger.
	            this._triggerEvents.set('mousedown', this.onMousedown);
	            this._triggerEvents.set('mouseup', this.onPointerUp);
	            this._triggerEvents.set('mouseleave', this.onPointerUp);
	            this._triggerEvents.set('touchstart', this.onTouchStart);
	            this._triggerEvents.set('touchend', this.onPointerUp);
	        }
	    }
	    /**
	     * Fades in a ripple at the given coordinates.
	     * @param x Coordinate within the element, along the X axis at which to start the ripple.
	     * @param y Coordinate within the element, along the Y axis at which to start the ripple.
	     * @param config Extra ripple options.
	     */
	    /**
	     * Fades in a ripple at the given coordinates.
	     * @param {?} x Coordinate within the element, along the X axis at which to start the ripple.
	     * @param {?} y Coordinate within the element, along the Y axis at which to start the ripple.
	     * @param {?=} config Extra ripple options.
	     * @return {?}
	     */
	    RippleRenderer.prototype.fadeInRipple = /**
	     * Fades in a ripple at the given coordinates.
	     * @param {?} x Coordinate within the element, along the X axis at which to start the ripple.
	     * @param {?} y Coordinate within the element, along the Y axis at which to start the ripple.
	     * @param {?=} config Extra ripple options.
	     * @return {?}
	     */
	    function (x, y, config) {
	        var _this = this;
	        if (config === void 0) { config = {}; }
	        var /** @type {?} */ containerRect = this._containerElement.getBoundingClientRect();
	        var /** @type {?} */ animationConfig = __assign({}, defaultRippleAnimationConfig, config.animation);
	        if (config.centered) {
	            x = containerRect.left + containerRect.width / 2;
	            y = containerRect.top + containerRect.height / 2;
	        }
	        var /** @type {?} */ radius = config.radius || distanceToFurthestCorner(x, y, containerRect);
	        var /** @type {?} */ offsetX = x - containerRect.left;
	        var /** @type {?} */ offsetY = y - containerRect.top;
	        var /** @type {?} */ duration = animationConfig.enterDuration / (config.speedFactor || 1);
	        var /** @type {?} */ ripple = document.createElement('div');
	        ripple.classList.add('mat-ripple-element');
	        ripple.style.left = offsetX - radius + "px";
	        ripple.style.top = offsetY - radius + "px";
	        ripple.style.height = radius * 2 + "px";
	        ripple.style.width = radius * 2 + "px";
	        // If the color is not set, the default CSS color will be used.
	        ripple.style.backgroundColor = config.color || null;
	        ripple.style.transitionDuration = duration + "ms";
	        this._containerElement.appendChild(ripple);
	        // By default the browser does not recalculate the styles of dynamically created
	        // ripple elements. This is critical because then the `scale` would not animate properly.
	        enforceStyleRecalculation(ripple);
	        ripple.style.transform = 'scale(1)';
	        // Exposed reference to the ripple that will be returned.
	        var /** @type {?} */ rippleRef = new RippleRef(this, ripple, config);
	        rippleRef.state = RippleState.FADING_IN;
	        // Add the ripple reference to the list of all active ripples.
	        this._activeRipples.add(rippleRef);
	        // Wait for the ripple element to be completely faded in.
	        // Once it's faded in, the ripple can be hidden immediately if the mouse is released.
	        this.runTimeoutOutsideZone(function () {
	            rippleRef.state = RippleState.VISIBLE;
	            if (!config.persistent && !_this._isPointerDown) {
	                rippleRef.fadeOut();
	            }
	        }, duration);
	        return rippleRef;
	    };
	    /** Fades out a ripple reference. */
	    /**
	     * Fades out a ripple reference.
	     * @param {?} rippleRef
	     * @return {?}
	     */
	    RippleRenderer.prototype.fadeOutRipple = /**
	     * Fades out a ripple reference.
	     * @param {?} rippleRef
	     * @return {?}
	     */
	    function (rippleRef) {
	        // For ripples that are not active anymore, don't re-un the fade-out animation.
	        if (!this._activeRipples.delete(rippleRef)) {
	            return;
	        }
	        var /** @type {?} */ rippleEl = rippleRef.element;
	        var /** @type {?} */ animationConfig = __assign({}, defaultRippleAnimationConfig, rippleRef.config.animation);
	        rippleEl.style.transitionDuration = animationConfig.exitDuration + "ms";
	        rippleEl.style.opacity = '0';
	        rippleRef.state = RippleState.FADING_OUT;
	        // Once the ripple faded out, the ripple can be safely removed from the DOM.
	        this.runTimeoutOutsideZone(function () {
	            rippleRef.state = RippleState.HIDDEN; /** @type {?} */
	            ((rippleEl.parentNode)).removeChild(rippleEl);
	        }, animationConfig.exitDuration);
	    };
	    /** Fades out all currently active ripples. */
	    /**
	     * Fades out all currently active ripples.
	     * @return {?}
	     */
	    RippleRenderer.prototype.fadeOutAll = /**
	     * Fades out all currently active ripples.
	     * @return {?}
	     */
	    function () {
	        this._activeRipples.forEach(function (ripple) { return ripple.fadeOut(); });
	    };
	    /** Sets up the trigger event listeners */
	    /**
	     * Sets up the trigger event listeners
	     * @param {?} element
	     * @return {?}
	     */
	    RippleRenderer.prototype.setupTriggerEvents = /**
	     * Sets up the trigger event listeners
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) {
	        var _this = this;
	        if (!element || element === this._triggerElement) {
	            return;
	        }
	        // Remove all previously registered event listeners from the trigger element.
	        this._removeTriggerEvents();
	        this._ngZone.runOutsideAngular(function () {
	            _this._triggerEvents.forEach(function (fn, type) {
	                return element.addEventListener(type, fn, _this._eventOptions);
	            });
	        });
	        this._triggerElement = element;
	    };
	    /**
	     * Runs a timeout outside of the Angular zone to avoid triggering the change detection.
	     * @param {?} fn
	     * @param {?=} delay
	     * @return {?}
	     */
	    RippleRenderer.prototype.runTimeoutOutsideZone = /**
	     * Runs a timeout outside of the Angular zone to avoid triggering the change detection.
	     * @param {?} fn
	     * @param {?=} delay
	     * @return {?}
	     */
	    function (fn, delay) {
	        if (delay === void 0) { delay = 0; }
	        this._ngZone.runOutsideAngular(function () { return setTimeout(fn, delay); });
	    };
	    /** Removes previously registered event listeners from the trigger element. */
	    /**
	     * Removes previously registered event listeners from the trigger element.
	     * @return {?}
	     */
	    RippleRenderer.prototype._removeTriggerEvents = /**
	     * Removes previously registered event listeners from the trigger element.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._triggerElement) {
	            this._triggerEvents.forEach(function (fn, type) {
	                /** @type {?} */ ((_this._triggerElement)).removeEventListener(type, fn, _this._eventOptions);
	            });
	        }
	    };
	    return RippleRenderer;
	}());
	/**
	 * Enforces a style recalculation of a DOM element by computing its styles.
	 * @param {?} element
	 * @return {?}
	 */
	function enforceStyleRecalculation(element) {
	    // Enforce a style recalculation by calling `getComputedStyle` and accessing any property.
	    // Calling `getPropertyValue` is important to let optimizers know that this is not a noop.
	    // See: https://gist.github.com/paulirish/5d52fb081b3570c81e3a
	    window.getComputedStyle(element).getPropertyValue('opacity');
	}
	/**
	 * Returns the distance from the point (x, y) to the furthest corner of a rectangle.
	 * @param {?} x
	 * @param {?} y
	 * @param {?} rect
	 * @return {?}
	 */
	function distanceToFurthestCorner(x, y, rect) {
	    var /** @type {?} */ distX = Math.max(Math.abs(x - rect.left), Math.abs(x - rect.right));
	    var /** @type {?} */ distY = Math.max(Math.abs(y - rect.top), Math.abs(y - rect.bottom));
	    return Math.sqrt(distX * distX + distY * distY);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Configurable options for `matRipple`.
	 * @record
	 */
	
	/**
	 * Injection token that can be used to specify the global ripple options.
	 */
	var MAT_RIPPLE_GLOBAL_OPTIONS = new _angular_core.InjectionToken('mat-ripple-global-options');
	var MatRipple = /** @class */ (function () {
	    function MatRipple(_elementRef, ngZone, platform, globalOptions) {
	        this._elementRef = _elementRef;
	        /**
	         * If set, the radius in pixels of foreground ripples when fully expanded. If unset, the radius
	         * will be the distance from the center of the ripple to the furthest corner of the host element's
	         * bounding rectangle.
	         */
	        this.radius = 0;
	        /**
	         * If set, the normal duration of ripple animations is divided by this value. For example,
	         * setting it to 0.5 will cause the animations to take twice as long.
	         * A changed speedFactor will not modify the fade-out duration of the ripples.
	         * @deprecated Use the [matRippleAnimation] binding instead.
	         * \@deletion-target 7.0.0
	         */
	        this.speedFactor = 1;
	        this._disabled = false;
	        /**
	         * Whether ripple directive is initialized and the input bindings are set.
	         */
	        this._isInitialized = false;
	        this._globalOptions = globalOptions || {};
	        this._rippleRenderer = new RippleRenderer(this, ngZone, _elementRef, platform);
	    }
	    Object.defineProperty(MatRipple.prototype, "disabled", {
	        get: /**
	         * Whether click events will not trigger the ripple. Ripples can be still launched manually
	         * by using the `launch()` method.
	         * @return {?}
	         */
	        function () { return this._disabled; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._disabled = value;
	            this._setupTriggerEventsIfEnabled();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatRipple.prototype, "trigger", {
	        get: /**
	         * The element that triggers the ripple when click events are received.
	         * Defaults to the directive's host element.
	         * @return {?}
	         */
	        function () { return this._trigger || this._elementRef.nativeElement; },
	        set: /**
	         * @param {?} trigger
	         * @return {?}
	         */
	        function (trigger) {
	            this._trigger = trigger;
	            this._setupTriggerEventsIfEnabled();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatRipple.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        this._isInitialized = true;
	        this._setupTriggerEventsIfEnabled();
	    };
	    /**
	     * @return {?}
	     */
	    MatRipple.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._rippleRenderer._removeTriggerEvents();
	    };
	    /** Fades out all currently showing ripple elements. */
	    /**
	     * Fades out all currently showing ripple elements.
	     * @return {?}
	     */
	    MatRipple.prototype.fadeOutAll = /**
	     * Fades out all currently showing ripple elements.
	     * @return {?}
	     */
	    function () {
	        this._rippleRenderer.fadeOutAll();
	    };
	    Object.defineProperty(MatRipple.prototype, "rippleConfig", {
	        /** Ripple configuration from the directive's input values. */
	        get: /**
	         * Ripple configuration from the directive's input values.
	         * @return {?}
	         */
	        function () {
	            return {
	                centered: this.centered,
	                radius: this.radius,
	                color: this.color,
	                animation: __assign({}, this._globalOptions.animation, this.animation),
	                terminateOnPointerUp: this._globalOptions.terminateOnPointerUp,
	                speedFactor: this.speedFactor * (this._globalOptions.baseSpeedFactor || 1),
	            };
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatRipple.prototype, "rippleDisabled", {
	        /** Whether ripples on pointer-down are disabled or not. */
	        get: /**
	         * Whether ripples on pointer-down are disabled or not.
	         * @return {?}
	         */
	        function () {
	            return this.disabled || !!this._globalOptions.disabled;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Sets up the the trigger event listeners if ripples are enabled.
	     * @return {?}
	     */
	    MatRipple.prototype._setupTriggerEventsIfEnabled = /**
	     * Sets up the the trigger event listeners if ripples are enabled.
	     * @return {?}
	     */
	    function () {
	        if (!this.disabled && this._isInitialized) {
	            this._rippleRenderer.setupTriggerEvents(this.trigger);
	        }
	    };
	    /** Launches a manual ripple at the specified coordinated or just by the ripple config. */
	    /**
	     * Launches a manual ripple at the specified coordinated or just by the ripple config.
	     * @param {?} configOrX
	     * @param {?=} y
	     * @param {?=} config
	     * @return {?}
	     */
	    MatRipple.prototype.launch = /**
	     * Launches a manual ripple at the specified coordinated or just by the ripple config.
	     * @param {?} configOrX
	     * @param {?=} y
	     * @param {?=} config
	     * @return {?}
	     */
	    function (configOrX, y, config) {
	        if (y === void 0) { y = 0; }
	        if (typeof configOrX === 'number') {
	            return this._rippleRenderer.fadeInRipple(configOrX, y, __assign({}, this.rippleConfig, config));
	        }
	        else {
	            return this._rippleRenderer.fadeInRipple(0, 0, __assign({}, this.rippleConfig, configOrX));
	        }
	    };
	    MatRipple.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-ripple], [matRipple]',
	                    exportAs: 'matRipple',
	                    host: {
	                        'class': 'mat-ripple',
	                        '[class.mat-ripple-unbounded]': 'unbounded'
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatRipple.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.NgZone, },
	        { type: _angular_cdk_platform.Platform, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MAT_RIPPLE_GLOBAL_OPTIONS,] },] },
	    ]; };
	    MatRipple.propDecorators = {
	        "color": [{ type: _angular_core.Input, args: ['matRippleColor',] },],
	        "unbounded": [{ type: _angular_core.Input, args: ['matRippleUnbounded',] },],
	        "centered": [{ type: _angular_core.Input, args: ['matRippleCentered',] },],
	        "radius": [{ type: _angular_core.Input, args: ['matRippleRadius',] },],
	        "speedFactor": [{ type: _angular_core.Input, args: ['matRippleSpeedFactor',] },],
	        "animation": [{ type: _angular_core.Input, args: ['matRippleAnimation',] },],
	        "disabled": [{ type: _angular_core.Input, args: ['matRippleDisabled',] },],
	        "trigger": [{ type: _angular_core.Input, args: ['matRippleTrigger',] },],
	    };
	    return MatRipple;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatRippleModule = /** @class */ (function () {
	    function MatRippleModule() {
	    }
	    MatRippleModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [MatCommonModule, _angular_cdk_platform.PlatformModule],
	                    exports: [MatRipple, MatCommonModule],
	                    declarations: [MatRipple],
	                },] },
	    ];
	    /** @nocollapse */
	    MatRippleModule.ctorParameters = function () { return []; };
	    return MatRippleModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Component that shows a simplified checkbox without including any kind of "real" checkbox.
	 * Meant to be used when the checkbox is purely decorative and a large number of them will be
	 * included, such as for the options in a multi-select. Uses no SVGs or complex animations.
	 * Note that theming is meant to be handled by the parent element, e.g.
	 * `mat-primary .mat-pseudo-checkbox`.
	 *
	 * Note that this component will be completely invisible to screen-reader users. This is *not*
	 * interchangeable with `<mat-checkbox>` and should *not* be used if the user would directly
	 * interact with the checkbox. The pseudo-checkbox should only be used as an implementation detail
	 * of more complex components that appropriately handle selected / checked state.
	 * \@docs-private
	 */
	var MatPseudoCheckbox = /** @class */ (function () {
	    function MatPseudoCheckbox() {
	        /**
	         * Display state of the checkbox.
	         */
	        this.state = 'unchecked';
	        /**
	         * Whether the checkbox is disabled.
	         */
	        this.disabled = false;
	    }
	    MatPseudoCheckbox.decorators = [
	        { type: _angular_core.Component, args: [{encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    selector: 'mat-pseudo-checkbox',
	                    styles: [".mat-pseudo-checkbox{width:20px;height:20px;border:2px solid;border-radius:2px;cursor:pointer;display:inline-block;vertical-align:middle;box-sizing:border-box;position:relative;flex-shrink:0;transition:border-color 90ms cubic-bezier(0,0,.2,.1),background-color 90ms cubic-bezier(0,0,.2,.1)}.mat-pseudo-checkbox::after{position:absolute;opacity:0;content:'';border-bottom:2px solid currentColor;transition:opacity 90ms cubic-bezier(0,0,.2,.1)}.mat-pseudo-checkbox.mat-pseudo-checkbox-checked,.mat-pseudo-checkbox.mat-pseudo-checkbox-indeterminate{border:none}.mat-pseudo-checkbox-disabled{cursor:default}.mat-pseudo-checkbox-indeterminate::after{top:9px;left:2px;width:16px;opacity:1}.mat-pseudo-checkbox-checked::after{top:5px;left:3px;width:12px;height:5px;border-left:2px solid currentColor;transform:rotate(-45deg);opacity:1}"],
	                    template: '',
	                    host: {
	                        'class': 'mat-pseudo-checkbox',
	                        '[class.mat-pseudo-checkbox-indeterminate]': 'state === "indeterminate"',
	                        '[class.mat-pseudo-checkbox-checked]': 'state === "checked"',
	                        '[class.mat-pseudo-checkbox-disabled]': 'disabled',
	                    },
	                },] },
	    ];
	    /** @nocollapse */
	    MatPseudoCheckbox.ctorParameters = function () { return []; };
	    MatPseudoCheckbox.propDecorators = {
	        "state": [{ type: _angular_core.Input },],
	        "disabled": [{ type: _angular_core.Input },],
	    };
	    return MatPseudoCheckbox;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatPseudoCheckboxModule = /** @class */ (function () {
	    function MatPseudoCheckboxModule() {
	    }
	    MatPseudoCheckboxModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    exports: [MatPseudoCheckbox],
	                    declarations: [MatPseudoCheckbox]
	                },] },
	    ];
	    /** @nocollapse */
	    MatPseudoCheckboxModule.ctorParameters = function () { return []; };
	    return MatPseudoCheckboxModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 */
	var MatOptgroupBase = /** @class */ (function () {
	    function MatOptgroupBase() {
	    }
	    return MatOptgroupBase;
	}());
	var _MatOptgroupMixinBase = mixinDisabled(MatOptgroupBase);
	// Counter for unique group ids.
	var _uniqueOptgroupIdCounter = 0;
	/**
	 * Component that is used to group instances of `mat-option`.
	 */
	var MatOptgroup = /** @class */ (function (_super) {
	    __extends(MatOptgroup, _super);
	    function MatOptgroup() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /**
	         * Unique id for the underlying label.
	         */
	        _this._labelId = "mat-optgroup-label-" + _uniqueOptgroupIdCounter++;
	        return _this;
	    }
	    MatOptgroup.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-optgroup',
	                    exportAs: 'matOptgroup',
	                    template: "<label class=\"mat-optgroup-label\" [id]=\"_labelId\">{{ label }}</label><ng-content select=\"mat-option, ng-container\"></ng-content>",
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    inputs: ['disabled'],
	                    styles: [".mat-optgroup-label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;line-height:48px;height:48px;padding:0 16px;text-align:left;text-decoration:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.mat-optgroup-label[disabled]{cursor:default}[dir=rtl] .mat-optgroup-label{text-align:right}.mat-optgroup-label .mat-icon{margin-right:16px;vertical-align:middle}[dir=rtl] .mat-optgroup-label .mat-icon{margin-left:16px;margin-right:0}"],
	                    host: {
	                        'class': 'mat-optgroup',
	                        'role': 'group',
	                        '[class.mat-optgroup-disabled]': 'disabled',
	                        '[attr.aria-disabled]': 'disabled.toString()',
	                        '[attr.aria-labelledby]': '_labelId',
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatOptgroup.ctorParameters = function () { return []; };
	    MatOptgroup.propDecorators = {
	        "label": [{ type: _angular_core.Input },],
	    };
	    return MatOptgroup;
	}(_MatOptgroupMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Option IDs need to be unique across components, so this counter exists outside of
	 * the component definition.
	 */
	var _uniqueIdCounter = 0;
	/**
	 * Event object emitted by MatOption when selected or deselected.
	 */
	var MatOptionSelectionChange = /** @class */ (function () {
	    function MatOptionSelectionChange(source, isUserInput) {
	        if (isUserInput === void 0) { isUserInput = false; }
	        this.source = source;
	        this.isUserInput = isUserInput;
	    }
	    return MatOptionSelectionChange;
	}());
	/**
	 * Describes a parent component that manages a list of options.
	 * Contains properties that the options can inherit.
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * Injection token used to provide the parent component to options.
	 */
	var MAT_OPTION_PARENT_COMPONENT = new _angular_core.InjectionToken('MAT_OPTION_PARENT_COMPONENT');
	/**
	 * Single option inside of a `<mat-select>` element.
	 */
	var MatOption = /** @class */ (function () {
	    function MatOption(_element, _changeDetectorRef, _parent, group) {
	        this._element = _element;
	        this._changeDetectorRef = _changeDetectorRef;
	        this._parent = _parent;
	        this.group = group;
	        this._selected = false;
	        this._active = false;
	        this._disabled = false;
	        this._id = "mat-option-" + _uniqueIdCounter++;
	        this._mostRecentViewValue = '';
	        /**
	         * Event emitted when the option is selected or deselected.
	         */
	        this.onSelectionChange = new _angular_core.EventEmitter();
	        /**
	         * Emits when the state of the option changes and any parents have to be notified.
	         */
	        this._stateChanges = new rxjs_Subject.Subject();
	    }
	    Object.defineProperty(MatOption.prototype, "multiple", {
	        /** Whether the wrapping component is in multiple selection mode. */
	        get: /**
	         * Whether the wrapping component is in multiple selection mode.
	         * @return {?}
	         */
	        function () { return this._parent && this._parent.multiple; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatOption.prototype, "id", {
	        /** The unique ID of the option. */
	        get: /**
	         * The unique ID of the option.
	         * @return {?}
	         */
	        function () { return this._id; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatOption.prototype, "selected", {
	        /** Whether or not the option is currently selected. */
	        get: /**
	         * Whether or not the option is currently selected.
	         * @return {?}
	         */
	        function () { return this._selected; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatOption.prototype, "disabled", {
	        get: /**
	         * Whether the option is disabled.
	         * @return {?}
	         */
	        function () { return (this.group && this.group.disabled) || this._disabled; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._disabled = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatOption.prototype, "disableRipple", {
	        /** Whether ripples for the option are disabled. */
	        get: /**
	         * Whether ripples for the option are disabled.
	         * @return {?}
	         */
	        function () { return this._parent && this._parent.disableRipple; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatOption.prototype, "active", {
	        /**
	         * Whether or not the option is currently active and ready to be selected.
	         * An active option displays styles as if it is focused, but the
	         * focus is actually retained somewhere else. This comes in handy
	         * for components like autocomplete where focus must remain on the input.
	         */
	        get: /**
	         * Whether or not the option is currently active and ready to be selected.
	         * An active option displays styles as if it is focused, but the
	         * focus is actually retained somewhere else. This comes in handy
	         * for components like autocomplete where focus must remain on the input.
	         * @return {?}
	         */
	        function () {
	            return this._active;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatOption.prototype, "viewValue", {
	        /**
	         * The displayed value of the option. It is necessary to show the selected option in the
	         * select's trigger.
	         */
	        get: /**
	         * The displayed value of the option. It is necessary to show the selected option in the
	         * select's trigger.
	         * @return {?}
	         */
	        function () {
	            // TODO(kara): Add input property alternative for node envs.
	            return (this._getHostElement().textContent || '').trim();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** Selects the option. */
	    /**
	     * Selects the option.
	     * @return {?}
	     */
	    MatOption.prototype.select = /**
	     * Selects the option.
	     * @return {?}
	     */
	    function () {
	        this._selected = true;
	        this._changeDetectorRef.markForCheck();
	        this._emitSelectionChangeEvent();
	    };
	    /** Deselects the option. */
	    /**
	     * Deselects the option.
	     * @return {?}
	     */
	    MatOption.prototype.deselect = /**
	     * Deselects the option.
	     * @return {?}
	     */
	    function () {
	        this._selected = false;
	        this._changeDetectorRef.markForCheck();
	        this._emitSelectionChangeEvent();
	    };
	    /** Sets focus onto this option. */
	    /**
	     * Sets focus onto this option.
	     * @return {?}
	     */
	    MatOption.prototype.focus = /**
	     * Sets focus onto this option.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ element = this._getHostElement();
	        if (typeof element.focus === 'function') {
	            element.focus();
	        }
	    };
	    /**
	     * This method sets display styles on the option to make it appear
	     * active. This is used by the ActiveDescendantKeyManager so key
	     * events will display the proper options as active on arrow key events.
	     */
	    /**
	     * This method sets display styles on the option to make it appear
	     * active. This is used by the ActiveDescendantKeyManager so key
	     * events will display the proper options as active on arrow key events.
	     * @return {?}
	     */
	    MatOption.prototype.setActiveStyles = /**
	     * This method sets display styles on the option to make it appear
	     * active. This is used by the ActiveDescendantKeyManager so key
	     * events will display the proper options as active on arrow key events.
	     * @return {?}
	     */
	    function () {
	        if (!this._active) {
	            this._active = true;
	            this._changeDetectorRef.markForCheck();
	        }
	    };
	    /**
	     * This method removes display styles on the option that made it appear
	     * active. This is used by the ActiveDescendantKeyManager so key
	     * events will display the proper options as active on arrow key events.
	     */
	    /**
	     * This method removes display styles on the option that made it appear
	     * active. This is used by the ActiveDescendantKeyManager so key
	     * events will display the proper options as active on arrow key events.
	     * @return {?}
	     */
	    MatOption.prototype.setInactiveStyles = /**
	     * This method removes display styles on the option that made it appear
	     * active. This is used by the ActiveDescendantKeyManager so key
	     * events will display the proper options as active on arrow key events.
	     * @return {?}
	     */
	    function () {
	        if (this._active) {
	            this._active = false;
	            this._changeDetectorRef.markForCheck();
	        }
	    };
	    /** Gets the label to be used when determining whether the option should be focused. */
	    /**
	     * Gets the label to be used when determining whether the option should be focused.
	     * @return {?}
	     */
	    MatOption.prototype.getLabel = /**
	     * Gets the label to be used when determining whether the option should be focused.
	     * @return {?}
	     */
	    function () {
	        return this.viewValue;
	    };
	    /** Ensures the option is selected when activated from the keyboard. */
	    /**
	     * Ensures the option is selected when activated from the keyboard.
	     * @param {?} event
	     * @return {?}
	     */
	    MatOption.prototype._handleKeydown = /**
	     * Ensures the option is selected when activated from the keyboard.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (event.keyCode === _angular_cdk_keycodes.ENTER || event.keyCode === _angular_cdk_keycodes.SPACE) {
	            this._selectViaInteraction();
	            // Prevent the page from scrolling down and form submits.
	            event.preventDefault();
	        }
	    };
	    /**
	     * `Selects the option while indicating the selection came from the user. Used to
	     * determine if the select's view -> model callback should be invoked.`
	     */
	    /**
	     * `Selects the option while indicating the selection came from the user. Used to
	     * determine if the select's view -> model callback should be invoked.`
	     * @return {?}
	     */
	    MatOption.prototype._selectViaInteraction = /**
	     * `Selects the option while indicating the selection came from the user. Used to
	     * determine if the select's view -> model callback should be invoked.`
	     * @return {?}
	     */
	    function () {
	        if (!this.disabled) {
	            this._selected = this.multiple ? !this._selected : true;
	            this._changeDetectorRef.markForCheck();
	            this._emitSelectionChangeEvent(true);
	        }
	    };
	    /** Returns the correct tabindex for the option depending on disabled state. */
	    /**
	     * Returns the correct tabindex for the option depending on disabled state.
	     * @return {?}
	     */
	    MatOption.prototype._getTabIndex = /**
	     * Returns the correct tabindex for the option depending on disabled state.
	     * @return {?}
	     */
	    function () {
	        return this.disabled ? '-1' : '0';
	    };
	    /** Gets the host DOM element. */
	    /**
	     * Gets the host DOM element.
	     * @return {?}
	     */
	    MatOption.prototype._getHostElement = /**
	     * Gets the host DOM element.
	     * @return {?}
	     */
	    function () {
	        return this._element.nativeElement;
	    };
	    /**
	     * @return {?}
	     */
	    MatOption.prototype.ngAfterViewChecked = /**
	     * @return {?}
	     */
	    function () {
	        // Since parent components could be using the option's label to display the selected values
	        // (e.g. `mat-select`) and they don't have a way of knowing if the option's label has changed
	        // we have to check for changes in the DOM ourselves and dispatch an event. These checks are
	        // relatively cheap, however we still limit them only to selected options in order to avoid
	        // hitting the DOM too often.
	        if (this._selected) {
	            var /** @type {?} */ viewValue = this.viewValue;
	            if (viewValue !== this._mostRecentViewValue) {
	                this._mostRecentViewValue = viewValue;
	                this._stateChanges.next();
	            }
	        }
	    };
	    /**
	     * Emits the selection change event.
	     * @param {?=} isUserInput
	     * @return {?}
	     */
	    MatOption.prototype._emitSelectionChangeEvent = /**
	     * Emits the selection change event.
	     * @param {?=} isUserInput
	     * @return {?}
	     */
	    function (isUserInput) {
	        if (isUserInput === void 0) { isUserInput = false; }
	        this.onSelectionChange.emit(new MatOptionSelectionChange(this, isUserInput));
	    };
	    MatOption.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-option',
	                    exportAs: 'matOption',
	                    host: {
	                        'role': 'option',
	                        '[attr.tabindex]': '_getTabIndex()',
	                        '[class.mat-selected]': 'selected',
	                        '[class.mat-option-multiple]': 'multiple',
	                        '[class.mat-active]': 'active',
	                        '[id]': 'id',
	                        '[attr.aria-selected]': 'selected.toString()',
	                        '[attr.aria-disabled]': 'disabled.toString()',
	                        '[class.mat-option-disabled]': 'disabled',
	                        '(click)': '_selectViaInteraction()',
	                        '(keydown)': '_handleKeydown($event)',
	                        'class': 'mat-option',
	                    },
	                    styles: [".mat-option{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;line-height:48px;height:48px;padding:0 16px;text-align:left;text-decoration:none;position:relative;cursor:pointer;outline:0;display:flex;flex-direction:row;max-width:100%;box-sizing:border-box;align-items:center}.mat-option[disabled]{cursor:default}[dir=rtl] .mat-option{text-align:right}.mat-option .mat-icon{margin-right:16px;vertical-align:middle}[dir=rtl] .mat-option .mat-icon{margin-left:16px;margin-right:0}.mat-option[aria-disabled=true]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.mat-optgroup .mat-option:not(.mat-option-multiple){padding-left:32px}[dir=rtl] .mat-optgroup .mat-option:not(.mat-option-multiple){padding-left:16px;padding-right:32px}.mat-option-text{display:inline-block;flex-grow:1;overflow:hidden;text-overflow:ellipsis}.mat-option-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}@media screen and (-ms-high-contrast:active){.mat-option-ripple{opacity:.5}}.mat-option-pseudo-checkbox{margin-right:8px}[dir=rtl] .mat-option-pseudo-checkbox{margin-left:8px;margin-right:0}"],
	                    template: "<mat-pseudo-checkbox *ngIf=\"multiple\" class=\"mat-option-pseudo-checkbox\" [state]=\"selected ? 'checked' : ''\" [disabled]=\"disabled\"></mat-pseudo-checkbox><span class=\"mat-option-text\"><ng-content></ng-content></span><div class=\"mat-option-ripple\" mat-ripple [matRippleTrigger]=\"_getHostElement()\" [matRippleDisabled]=\"disabled || disableRipple\"></div>",
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatOption.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MAT_OPTION_PARENT_COMPONENT,] },] },
	        { type: MatOptgroup, decorators: [{ type: _angular_core.Optional },] },
	    ]; };
	    MatOption.propDecorators = {
	        "value": [{ type: _angular_core.Input },],
	        "disabled": [{ type: _angular_core.Input },],
	        "onSelectionChange": [{ type: _angular_core.Output },],
	    };
	    return MatOption;
	}());
	/**
	 * Counts the amount of option group labels that precede the specified option.
	 * \@docs-private
	 * @param {?} optionIndex Index of the option at which to start counting.
	 * @param {?} options Flat list of all of the options.
	 * @param {?} optionGroups Flat list of all of the option groups.
	 * @return {?}
	 */
	function _countGroupLabelsBeforeOption(optionIndex, options, optionGroups) {
	    if (optionGroups.length) {
	        var /** @type {?} */ optionsArray = options.toArray();
	        var /** @type {?} */ groups = optionGroups.toArray();
	        var /** @type {?} */ groupCounter = 0;
	        for (var /** @type {?} */ i = 0; i < optionIndex + 1; i++) {
	            if (optionsArray[i].group && optionsArray[i].group === groups[groupCounter]) {
	                groupCounter++;
	            }
	        }
	        return groupCounter;
	    }
	    return 0;
	}
	/**
	 * Determines the position to which to scroll a panel in order for an option to be into view.
	 * \@docs-private
	 * @param {?} optionIndex Index of the option to be scrolled into the view.
	 * @param {?} optionHeight Height of the options.
	 * @param {?} currentScrollPosition Current scroll position of the panel.
	 * @param {?} panelHeight Height of the panel.
	 * @return {?}
	 */
	function _getOptionScrollPosition(optionIndex, optionHeight, currentScrollPosition, panelHeight) {
	    var /** @type {?} */ optionOffset = optionIndex * optionHeight;
	    if (optionOffset < currentScrollPosition) {
	        return optionOffset;
	    }
	    if (optionOffset + optionHeight > currentScrollPosition + panelHeight) {
	        return Math.max(0, optionOffset - panelHeight + optionHeight);
	    }
	    return currentScrollPosition;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatOptionModule = /** @class */ (function () {
	    function MatOptionModule() {
	    }
	    MatOptionModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [MatRippleModule, _angular_common.CommonModule, MatPseudoCheckboxModule],
	                    exports: [MatOption, MatOptgroup],
	                    declarations: [MatOption, MatOptgroup]
	                },] },
	    ];
	    /** @nocollapse */
	    MatOptionModule.ctorParameters = function () { return []; };
	    return MatOptionModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * InjectionToken that can be used to specify the global label options.
	 */
	var MAT_LABEL_GLOBAL_OPTIONS = new _angular_core.InjectionToken('mat-label-global-options');
	/**
	 * Configurable options for floating labels.
	 * @record
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * When constructing a Date, the month is zero-based. This can be confusing, since people are
	 * used to seeing them one-based. So we create these aliases to make writing the tests easier.
	 */
	var JAN = 0;
	var FEB = 1;
	var MAR = 2;
	var APR = 3;
	var MAY = 4;
	var JUN = 5;
	var JUL = 6;
	var AUG = 7;
	var SEP = 8;
	var OCT = 9;
	var NOV = 10;
	var DEC = 11;
	
	exports.MAT_PLACEHOLDER_GLOBAL_OPTIONS = MAT_LABEL_GLOBAL_OPTIONS;
	exports.AnimationCurves = AnimationCurves;
	exports.AnimationDurations = AnimationDurations;
	exports.MatCommonModule = MatCommonModule;
	exports.MATERIAL_SANITY_CHECKS = MATERIAL_SANITY_CHECKS;
	exports.mixinDisabled = mixinDisabled;
	exports.mixinColor = mixinColor;
	exports.mixinDisableRipple = mixinDisableRipple;
	exports.mixinTabIndex = mixinTabIndex;
	exports.mixinErrorState = mixinErrorState;
	exports.mixinInitialized = mixinInitialized;
	exports.NativeDateModule = NativeDateModule;
	exports.MatNativeDateModule = MatNativeDateModule;
	exports.MAT_DATE_LOCALE = MAT_DATE_LOCALE;
	exports.MAT_DATE_LOCALE_PROVIDER = MAT_DATE_LOCALE_PROVIDER;
	exports.DateAdapter = DateAdapter;
	exports.MAT_DATE_FORMATS = MAT_DATE_FORMATS;
	exports.NativeDateAdapter = NativeDateAdapter;
	exports.MAT_NATIVE_DATE_FORMATS = MAT_NATIVE_DATE_FORMATS;
	exports.ShowOnDirtyErrorStateMatcher = ShowOnDirtyErrorStateMatcher;
	exports.ErrorStateMatcher = ErrorStateMatcher;
	exports.MAT_HAMMER_OPTIONS = MAT_HAMMER_OPTIONS;
	exports.GestureConfig = GestureConfig;
	exports.MatLine = MatLine;
	exports.MatLineSetter = MatLineSetter;
	exports.MatLineModule = MatLineModule;
	exports.MatOptionModule = MatOptionModule;
	exports.MatOptionSelectionChange = MatOptionSelectionChange;
	exports.MAT_OPTION_PARENT_COMPONENT = MAT_OPTION_PARENT_COMPONENT;
	exports.MatOption = MatOption;
	exports._countGroupLabelsBeforeOption = _countGroupLabelsBeforeOption;
	exports._getOptionScrollPosition = _getOptionScrollPosition;
	exports.MatOptgroupBase = MatOptgroupBase;
	exports._MatOptgroupMixinBase = _MatOptgroupMixinBase;
	exports.MatOptgroup = MatOptgroup;
	exports.MAT_LABEL_GLOBAL_OPTIONS = MAT_LABEL_GLOBAL_OPTIONS;
	exports.MatRippleModule = MatRippleModule;
	exports.MAT_RIPPLE_GLOBAL_OPTIONS = MAT_RIPPLE_GLOBAL_OPTIONS;
	exports.MatRipple = MatRipple;
	exports.RippleState = RippleState;
	exports.RippleRef = RippleRef;
	exports.defaultRippleAnimationConfig = defaultRippleAnimationConfig;
	exports.RippleRenderer = RippleRenderer;
	exports.MatPseudoCheckboxModule = MatPseudoCheckboxModule;
	exports.MatPseudoCheckbox = MatPseudoCheckbox;
	exports.JAN = JAN;
	exports.FEB = FEB;
	exports.MAR = MAR;
	exports.APR = APR;
	exports.MAY = MAY;
	exports.JUN = JUN;
	exports.JUL = JUL;
	exports.AUG = AUG;
	exports.SEP = SEP;
	exports.OCT = OCT;
	exports.NOV = NOV;
	exports.DEC = DEC;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=material-core.umd.js.map


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(246)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@angular/common'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.cdk = global.ng.cdk || {}, global.ng.cdk.bidi = global.ng.cdk.bidi || {}),global.ng.core,global.ng.common));
	}(this, (function (exports,_angular_core,_angular_common) { 'use strict';
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Injection token used to inject the document into Directionality.
	 * This is used so that the value can be faked in tests.
	 *
	 * We can't use the real document in tests because changing the real `dir` causes geometry-based
	 * tests in Safari to fail.
	 *
	 * We also can't re-provide the DOCUMENT token from platform-brower because the unit tests
	 * themselves use things like `querySelector` in test code.
	 */
	var DIR_DOCUMENT = new _angular_core.InjectionToken('cdk-dir-doc');
	/**
	 * The directionality (LTR / RTL) context for the application (or a subtree of it).
	 * Exposes the current direction and a stream of direction changes.
	 */
	var Directionality = /** @class */ (function () {
	    function Directionality(_document) {
	        /**
	         * The current 'ltr' or 'rtl' value.
	         */
	        this.value = 'ltr';
	        /**
	         * Stream that emits whenever the 'ltr' / 'rtl' state changes.
	         */
	        this.change = new _angular_core.EventEmitter();
	        if (_document) {
	            // TODO: handle 'auto' value -
	            // We still need to account for dir="auto".
	            // It looks like HTMLElemenet.dir is also "auto" when that's set to the attribute,
	            // but getComputedStyle return either "ltr" or "rtl". avoiding getComputedStyle for now
	            var /** @type {?} */ bodyDir = _document.body ? _document.body.dir : null;
	            var /** @type {?} */ htmlDir = _document.documentElement ? _document.documentElement.dir : null;
	            this.value = /** @type {?} */ ((bodyDir || htmlDir || 'ltr'));
	        }
	    }
	    Directionality.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    Directionality.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [DIR_DOCUMENT,] },] },
	    ]; };
	    return Directionality;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Directive to listen for changes of direction of part of the DOM.
	 *
	 * Provides itself as Directionality such that descendant directives only need to ever inject
	 * Directionality to get the closest direction.
	 */
	var Dir = /** @class */ (function () {
	    function Dir() {
	        this._dir = 'ltr';
	        /**
	         * Whether the `value` has been set to its initial value.
	         */
	        this._isInitialized = false;
	        /**
	         * Event emitted when the direction changes.
	         */
	        this.change = new _angular_core.EventEmitter();
	    }
	    Object.defineProperty(Dir.prototype, "dir", {
	        get: /**
	         * \@docs-private
	         * @return {?}
	         */
	        function () { return this._dir; },
	        set: /**
	         * @param {?} v
	         * @return {?}
	         */
	        function (v) {
	            var /** @type {?} */ old = this._dir;
	            this._dir = v;
	            if (old !== this._dir && this._isInitialized) {
	                this.change.emit(this._dir);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Dir.prototype, "value", {
	        /** Current layout direction of the element. */
	        get: /**
	         * Current layout direction of the element.
	         * @return {?}
	         */
	        function () { return this.dir; },
	        enumerable: true,
	        configurable: true
	    });
	    /** Initialize once default value has been set. */
	    /**
	     * Initialize once default value has been set.
	     * @return {?}
	     */
	    Dir.prototype.ngAfterContentInit = /**
	     * Initialize once default value has been set.
	     * @return {?}
	     */
	    function () {
	        this._isInitialized = true;
	    };
	    /**
	     * @return {?}
	     */
	    Dir.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this.change.complete();
	    };
	    Dir.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[dir]',
	                    providers: [{ provide: Directionality, useExisting: Dir }],
	                    host: { '[dir]': 'dir' },
	                    exportAs: 'dir',
	                },] },
	    ];
	    /** @nocollapse */
	    Dir.ctorParameters = function () { return []; };
	    Dir.propDecorators = {
	        "change": [{ type: _angular_core.Output, args: ['dirChange',] },],
	        "dir": [{ type: _angular_core.Input },],
	    };
	    return Dir;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var BidiModule = /** @class */ (function () {
	    function BidiModule() {
	    }
	    BidiModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    exports: [Dir],
	                    declarations: [Dir],
	                    providers: [
	                        { provide: DIR_DOCUMENT, useExisting: _angular_common.DOCUMENT },
	                        Directionality,
	                    ]
	                },] },
	    ];
	    /** @nocollapse */
	    BidiModule.ctorParameters = function () { return []; };
	    return BidiModule;
	}());
	
	exports.Directionality = Directionality;
	exports.DIR_DOCUMENT = DIR_DOCUMENT;
	exports.Dir = Dir;
	exports.BidiModule = BidiModule;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=cdk-bidi.umd.js.map


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.cdk = global.ng.cdk || {}, global.ng.cdk.coercion = global.ng.cdk.coercion || {})));
	}(this, (function (exports) { 'use strict';
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Coerces a data-bound value (typically a string) to a boolean.
	 * @param {?} value
	 * @return {?}
	 */
	function coerceBooleanProperty(value) {
	    return value != null && "" + value !== 'false';
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * @param {?} value
	 * @param {?=} fallbackValue
	 * @return {?}
	 */
	function coerceNumberProperty(value, fallbackValue) {
	    if (fallbackValue === void 0) { fallbackValue = 0; }
	    return _isNumberValue(value) ? Number(value) : fallbackValue;
	}
	/**
	 * Whether the provided value is considered a number.
	 * \@docs-private
	 * @param {?} value
	 * @return {?}
	 */
	function _isNumberValue(value) {
	    // parseFloat(value) handles most of the cases we're interested in (it treats null, empty string,
	    // and other non-number values as NaN, where Number just uses 0) but it considers the string
	    // '123hello' to be a valid number. Therefore we also check if Number(value) is NaN.
	    return !isNaN(parseFloat(/** @type {?} */ (value))) && !isNaN(Number(value));
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Wraps the provided value in an array, unless the provided value is an array.
	 * @template T
	 * @param {?} value
	 * @return {?}
	 */
	function coerceArray(value) {
	    return Array.isArray(value) ? value : [value];
	}
	
	exports.coerceBooleanProperty = coerceBooleanProperty;
	exports.coerceNumberProperty = coerceNumberProperty;
	exports._isNumberValue = _isNumberValue;
	exports.coerceArray = coerceArray;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=cdk-coercion.umd.js.map


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/core'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.cdk = global.ng.cdk || {}, global.ng.cdk.platform = global.ng.cdk.platform || {}),global.ng.core));
	}(this, (function (exports,_angular_core) { 'use strict';
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	// Whether the current platform supports the V8 Break Iterator. The V8 check
	// is necessary to detect all Blink based browsers.
	var hasV8BreakIterator = (typeof Intl !== 'undefined' && (/** @type {?} */ (Intl)).v8BreakIterator);
	/**
	 * Service to detect the current platform by comparing the userAgent strings and
	 * checking browser-specific global properties.
	 */
	var Platform = /** @class */ (function () {
	    function Platform() {
	        /**
	         * Whether the Angular application is being rendered in the browser.
	         */
	        this.isBrowser = typeof document === 'object' && !!document;
	        /**
	         * Whether the current browser is Microsoft Edge.
	         */
	        this.EDGE = this.isBrowser && /(edge)/i.test(navigator.userAgent);
	        /**
	         * Whether the current rendering engine is Microsoft Trident.
	         */
	        this.TRIDENT = this.isBrowser && /(msie|trident)/i.test(navigator.userAgent);
	        /**
	         * Whether the current rendering engine is Blink.
	         */
	        this.BLINK = this.isBrowser && (!!((/** @type {?} */ (window)).chrome || hasV8BreakIterator) &&
	            typeof CSS !== 'undefined' && !this.EDGE && !this.TRIDENT);
	        /**
	         * Whether the current rendering engine is WebKit.
	         */
	        this.WEBKIT = this.isBrowser &&
	            /AppleWebKit/i.test(navigator.userAgent) && !this.BLINK && !this.EDGE && !this.TRIDENT;
	        /**
	         * Whether the current platform is Apple iOS.
	         */
	        this.IOS = this.isBrowser && /iPad|iPhone|iPod/.test(navigator.userAgent) &&
	            !(/** @type {?} */ (window)).MSStream;
	        /**
	         * Whether the current browser is Firefox.
	         */
	        this.FIREFOX = this.isBrowser && /(firefox|minefield)/i.test(navigator.userAgent);
	        /**
	         * Whether the current platform is Android.
	         */
	        this.ANDROID = this.isBrowser && /android/i.test(navigator.userAgent) && !this.TRIDENT;
	        /**
	         * Whether the current browser is Safari.
	         */
	        this.SAFARI = this.isBrowser && /safari/i.test(navigator.userAgent) && this.WEBKIT;
	    }
	    Platform.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    Platform.ctorParameters = function () { return []; };
	    return Platform;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Cached result of whether the user's browser supports passive event listeners.
	 */
	var supportsPassiveEvents;
	/**
	 * Checks whether the user's browser supports passive event listeners.
	 * See: https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
	 * @return {?}
	 */
	function supportsPassiveEventListeners() {
	    if (supportsPassiveEvents == null && typeof window !== 'undefined') {
	        try {
	            window.addEventListener('test', /** @type {?} */ ((null)), Object.defineProperty({}, 'passive', {
	                get: function () { return supportsPassiveEvents = true; }
	            }));
	        }
	        finally {
	            supportsPassiveEvents = supportsPassiveEvents || false;
	        }
	    }
	    return supportsPassiveEvents;
	}
	/**
	 * Cached result Set of input types support by the current browser.
	 */
	var supportedInputTypes;
	/**
	 * Types of `<input>` that *might* be supported.
	 */
	var candidateInputTypes = [
	    'color',
	    'button',
	    'checkbox',
	    'date',
	    'datetime-local',
	    'email',
	    'file',
	    'hidden',
	    'image',
	    'month',
	    'number',
	    'password',
	    'radio',
	    'range',
	    'reset',
	    'search',
	    'submit',
	    'tel',
	    'text',
	    'time',
	    'url',
	    'week',
	];
	/**
	 * @return {?} The input types supported by this browser.
	 */
	function getSupportedInputTypes() {
	    // Result is cached.
	    if (supportedInputTypes) {
	        return supportedInputTypes;
	    }
	    // We can't check if an input type is not supported until we're on the browser, so say that
	    // everything is supported when not on the browser. We don't use `Platform` here since it's
	    // just a helper function and can't inject it.
	    if (typeof document !== 'object' || !document) {
	        supportedInputTypes = new Set(candidateInputTypes);
	        return supportedInputTypes;
	    }
	    var /** @type {?} */ featureTestInput = document.createElement('input');
	    supportedInputTypes = new Set(candidateInputTypes.filter(function (value) {
	        featureTestInput.setAttribute('type', value);
	        return featureTestInput.type === value;
	    }));
	    return supportedInputTypes;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var PlatformModule = /** @class */ (function () {
	    function PlatformModule() {
	    }
	    PlatformModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    providers: [Platform]
	                },] },
	    ];
	    /** @nocollapse */
	    PlatformModule.ctorParameters = function () { return []; };
	    return PlatformModule;
	}());
	
	exports.Platform = Platform;
	exports.supportsPassiveEventListeners = supportsPassiveEventListeners;
	exports.getSupportedInputTypes = getSupportedInputTypes;
	exports.PlatformModule = PlatformModule;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=cdk-platform.umd.js.map


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.cdk = global.ng.cdk || {}, global.ng.cdk.keycodes = global.ng.cdk.keycodes || {})));
	}(this, (function (exports) { 'use strict';
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var UP_ARROW = 38;
	var DOWN_ARROW = 40;
	var RIGHT_ARROW = 39;
	var LEFT_ARROW = 37;
	var PAGE_UP = 33;
	var PAGE_DOWN = 34;
	var HOME = 36;
	var END = 35;
	var ENTER = 13;
	var SPACE = 32;
	var TAB = 9;
	var ESCAPE = 27;
	var BACKSPACE = 8;
	var DELETE = 46;
	var A = 65;
	var Z = 90;
	var ZERO = 48;
	var NINE = 57;
	var COMMA = 188;
	
	exports.UP_ARROW = UP_ARROW;
	exports.DOWN_ARROW = DOWN_ARROW;
	exports.RIGHT_ARROW = RIGHT_ARROW;
	exports.LEFT_ARROW = LEFT_ARROW;
	exports.PAGE_UP = PAGE_UP;
	exports.PAGE_DOWN = PAGE_DOWN;
	exports.HOME = HOME;
	exports.END = END;
	exports.ENTER = ENTER;
	exports.SPACE = SPACE;
	exports.TAB = TAB;
	exports.ESCAPE = ESCAPE;
	exports.BACKSPACE = BACKSPACE;
	exports.DELETE = DELETE;
	exports.A = A;
	exports.Z = Z;
	exports.ZERO = ZERO;
	exports.NINE = NINE;
	exports.COMMA = COMMA;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=cdk-keycodes.umd.js.map


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1081), __webpack_require__(1077), __webpack_require__(205), __webpack_require__(768), __webpack_require__(1075), __webpack_require__(246), __webpack_require__(1082)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/cdk/a11y', '@angular/cdk/coercion', '@angular/core', '@angular/forms', '@angular/material/core', '@angular/common', '@angular/cdk/observers'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.material = global.ng.material || {}, global.ng.material.checkbox = global.ng.material.checkbox || {}),global.ng.cdk.a11y,global.ng.cdk.coercion,global.ng.core,global.ng.forms,global.ng.material.core,global.ng.common,global.ng.cdk.observers));
	}(this, (function (exports,_angular_cdk_a11y,_angular_cdk_coercion,_angular_core,_angular_forms,_angular_material_core,_angular_common,_angular_cdk_observers) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * Injection token that can be used to specify the checkbox click behavior.
	 */
	var MAT_CHECKBOX_CLICK_ACTION = new _angular_core.InjectionToken('mat-checkbox-click-action');
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	// Increasing integer for generating unique ids for checkbox components.
	var nextUniqueId = 0;
	/**
	 * Provider Expression that allows mat-checkbox to register as a ControlValueAccessor.
	 * This allows it to support [(ngModel)].
	 * \@docs-private
	 */
	var MAT_CHECKBOX_CONTROL_VALUE_ACCESSOR = {
	    provide: _angular_forms.NG_VALUE_ACCESSOR,
	    useExisting: _angular_core.forwardRef(function () { return MatCheckbox; }),
	    multi: true
	};
	/** @enum {number} */
	var TransitionCheckState = {
	    /** The initial state of the component before any user interaction. */
	    Init: 0,
	    /** The state representing the component when it's becoming checked. */
	    Checked: 1,
	    /** The state representing the component when it's becoming unchecked. */
	    Unchecked: 2,
	    /** The state representing the component when it's becoming indeterminate. */
	    Indeterminate: 3,
	};
	TransitionCheckState[TransitionCheckState.Init] = "Init";
	TransitionCheckState[TransitionCheckState.Checked] = "Checked";
	TransitionCheckState[TransitionCheckState.Unchecked] = "Unchecked";
	TransitionCheckState[TransitionCheckState.Indeterminate] = "Indeterminate";
	/**
	 * Change event object emitted by MatCheckbox.
	 */
	var MatCheckboxChange = /** @class */ (function () {
	    function MatCheckboxChange() {
	    }
	    return MatCheckboxChange;
	}());
	/**
	 * \@docs-private
	 */
	var MatCheckboxBase = /** @class */ (function () {
	    function MatCheckboxBase(_elementRef) {
	        this._elementRef = _elementRef;
	    }
	    return MatCheckboxBase;
	}());
	var _MatCheckboxMixinBase = _angular_material_core.mixinTabIndex(_angular_material_core.mixinColor(_angular_material_core.mixinDisableRipple(_angular_material_core.mixinDisabled(MatCheckboxBase)), 'accent'));
	/**
	 * A material design checkbox component. Supports all of the functionality of an HTML5 checkbox,
	 * and exposes a similar API. A MatCheckbox can be either checked, unchecked, indeterminate, or
	 * disabled. Note that all additional accessibility attributes are taken care of by the component,
	 * so there is no need to provide them yourself. However, if you want to omit a label and still
	 * have the checkbox be accessible, you may supply an [aria-label] input.
	 * See: https://www.google.com/design/spec/components/selection-controls.html
	 */
	var MatCheckbox = /** @class */ (function (_super) {
	    __extends(MatCheckbox, _super);
	    function MatCheckbox(elementRef, _changeDetectorRef, _focusMonitor, tabIndex, _clickAction) {
	        var _this = _super.call(this, elementRef) || this;
	        _this._changeDetectorRef = _changeDetectorRef;
	        _this._focusMonitor = _focusMonitor;
	        _this._clickAction = _clickAction;
	        /**
	         * Attached to the aria-label attribute of the host element. In most cases, arial-labelledby will
	         * take precedence so this may be omitted.
	         */
	        _this.ariaLabel = '';
	        /**
	         * Users can specify the `aria-labelledby` attribute which will be forwarded to the input element
	         */
	        _this.ariaLabelledby = null;
	        _this._uniqueId = "mat-checkbox-" + ++nextUniqueId;
	        /**
	         * A unique id for the checkbox input. If none is supplied, it will be auto-generated.
	         */
	        _this.id = _this._uniqueId;
	        /**
	         * Whether the label should appear after or before the checkbox. Defaults to 'after'
	         */
	        _this.labelPosition = 'after';
	        /**
	         * Name value will be applied to the input element if present
	         */
	        _this.name = null;
	        /**
	         * Event emitted when the checkbox's `checked` value changes.
	         */
	        _this.change = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when the checkbox's `indeterminate` value changes.
	         */
	        _this.indeterminateChange = new _angular_core.EventEmitter();
	        /**
	         * Called when the checkbox is blurred. Needed to properly implement ControlValueAccessor.
	         * \@docs-private
	         */
	        _this._onTouched = function () { };
	        _this._currentAnimationClass = '';
	        _this._currentCheckState = TransitionCheckState.Init;
	        _this._controlValueAccessorChangeFn = function () { };
	        _this._checked = false;
	        _this._indeterminate = false;
	        _this.tabIndex = parseInt(tabIndex) || 0;
	        return _this;
	    }
	    Object.defineProperty(MatCheckbox.prototype, "inputId", {
	        /** Returns the unique id for the visual hidden input. */
	        get: /**
	         * Returns the unique id for the visual hidden input.
	         * @return {?}
	         */
	        function () { return (this.id || this._uniqueId) + "-input"; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatCheckbox.prototype, "required", {
	        get: /**
	         * Whether the checkbox is required.
	         * @return {?}
	         */
	        function () { return this._required; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._required = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatCheckbox.prototype, "align", {
	        get: /**
	         * Whether or not the checkbox should appear before or after the label.
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () {
	            // align refers to the checkbox relative to the label, while labelPosition refers to the
	            // label relative to the checkbox. As such, they are inverted.
	            return this.labelPosition == 'after' ? 'start' : 'end';
	        },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this.labelPosition = (value == 'start') ? 'after' : 'before';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatCheckbox.prototype.ngAfterViewInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._focusMonitor
	            .monitor(this._inputElement.nativeElement)
	            .subscribe(function (focusOrigin) { return _this._onInputFocusChange(focusOrigin); });
	    };
	    /**
	     * @return {?}
	     */
	    MatCheckbox.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._focusMonitor.stopMonitoring(this._inputElement.nativeElement);
	    };
	    Object.defineProperty(MatCheckbox.prototype, "checked", {
	        get: /**
	         * Whether the checkbox is checked.
	         * @return {?}
	         */
	        function () { return this._checked; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (value != this.checked) {
	                this._checked = value;
	                this._changeDetectorRef.markForCheck();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatCheckbox.prototype, "indeterminate", {
	        get: /**
	         * Whether the checkbox is indeterminate. This is also known as "mixed" mode and can be used to
	         * represent a checkbox with three states, e.g. a checkbox that represents a nested list of
	         * checkable items. Note that whenever checkbox is manually clicked, indeterminate is immediately
	         * set to false.
	         * @return {?}
	         */
	        function () { return this._indeterminate; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            var /** @type {?} */ changed = value != this._indeterminate;
	            this._indeterminate = value;
	            if (changed) {
	                if (this._indeterminate) {
	                    this._transitionCheckState(TransitionCheckState.Indeterminate);
	                }
	                else {
	                    this._transitionCheckState(this.checked ? TransitionCheckState.Checked : TransitionCheckState.Unchecked);
	                }
	                this.indeterminateChange.emit(this._indeterminate);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatCheckbox.prototype._isRippleDisabled = /**
	     * @return {?}
	     */
	    function () {
	        return this.disableRipple || this.disabled;
	    };
	    /** Method being called whenever the label text changes. */
	    /**
	     * Method being called whenever the label text changes.
	     * @return {?}
	     */
	    MatCheckbox.prototype._onLabelTextChange = /**
	     * Method being called whenever the label text changes.
	     * @return {?}
	     */
	    function () {
	        // This method is getting called whenever the label of the checkbox changes.
	        // Since the checkbox uses the OnPush strategy we need to notify it about the change
	        // that has been recognized by the cdkObserveContent directive.
	        this._changeDetectorRef.markForCheck();
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    MatCheckbox.prototype.writeValue = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        this.checked = !!value;
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    MatCheckbox.prototype.registerOnChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._controlValueAccessorChangeFn = fn;
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    MatCheckbox.prototype.registerOnTouched = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._onTouched = fn;
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    MatCheckbox.prototype.setDisabledState = /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    function (isDisabled) {
	        this.disabled = isDisabled;
	        this._changeDetectorRef.markForCheck();
	    };
	    /**
	     * @return {?}
	     */
	    MatCheckbox.prototype._getAriaChecked = /**
	     * @return {?}
	     */
	    function () {
	        return this.checked ? 'true' : (this.indeterminate ? 'mixed' : 'false');
	    };
	    /**
	     * @param {?} newState
	     * @return {?}
	     */
	    MatCheckbox.prototype._transitionCheckState = /**
	     * @param {?} newState
	     * @return {?}
	     */
	    function (newState) {
	        var /** @type {?} */ oldState = this._currentCheckState;
	        var /** @type {?} */ element = this._elementRef.nativeElement;
	        if (oldState === newState) {
	            return;
	        }
	        if (this._currentAnimationClass.length > 0) {
	            element.classList.remove(this._currentAnimationClass);
	        }
	        this._currentAnimationClass = this._getAnimationClassForCheckStateTransition(oldState, newState);
	        this._currentCheckState = newState;
	        if (this._currentAnimationClass.length > 0) {
	            element.classList.add(this._currentAnimationClass);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatCheckbox.prototype._emitChangeEvent = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ event = new MatCheckboxChange();
	        event.source = this;
	        event.checked = this.checked;
	        this._controlValueAccessorChangeFn(this.checked);
	        this.change.emit(event);
	    };
	    /**
	     * Function is called whenever the focus changes for the input element.
	     * @param {?} focusOrigin
	     * @return {?}
	     */
	    MatCheckbox.prototype._onInputFocusChange = /**
	     * Function is called whenever the focus changes for the input element.
	     * @param {?} focusOrigin
	     * @return {?}
	     */
	    function (focusOrigin) {
	        if (!this._focusRipple && focusOrigin === 'keyboard') {
	            this._focusRipple = this.ripple.launch(0, 0, { persistent: true });
	        }
	        else if (!focusOrigin) {
	            this._removeFocusRipple();
	            this._onTouched();
	        }
	    };
	    /** Toggles the `checked` state of the checkbox. */
	    /**
	     * Toggles the `checked` state of the checkbox.
	     * @return {?}
	     */
	    MatCheckbox.prototype.toggle = /**
	     * Toggles the `checked` state of the checkbox.
	     * @return {?}
	     */
	    function () {
	        this.checked = !this.checked;
	    };
	    /**
	     * Event handler for checkbox input element.
	     * Toggles checked state if element is not disabled.
	     * Do not toggle on (change) event since IE doesn't fire change event when
	     *   indeterminate checkbox is clicked.
	     * @param event
	     */
	    /**
	     * Event handler for checkbox input element.
	     * Toggles checked state if element is not disabled.
	     * Do not toggle on (change) event since IE doesn't fire change event when
	     *   indeterminate checkbox is clicked.
	     * @param {?} event
	     * @return {?}
	     */
	    MatCheckbox.prototype._onInputClick = /**
	     * Event handler for checkbox input element.
	     * Toggles checked state if element is not disabled.
	     * Do not toggle on (change) event since IE doesn't fire change event when
	     *   indeterminate checkbox is clicked.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var _this = this;
	        // We have to stop propagation for click events on the visual hidden input element.
	        // By default, when a user clicks on a label element, a generated click event will be
	        // dispatched on the associated input element. Since we are using a label element as our
	        // root container, the click event on the `checkbox` will be executed twice.
	        // The real click event will bubble up, and the generated click event also tries to bubble up.
	        // This will lead to multiple click events.
	        // Preventing bubbling for the second event will solve that issue.
	        event.stopPropagation();
	        // If resetIndeterminate is false, and the current state is indeterminate, do nothing on click
	        if (!this.disabled && this._clickAction !== 'noop') {
	            // When user manually click on the checkbox, `indeterminate` is set to false.
	            if (this.indeterminate && this._clickAction !== 'check') {
	                Promise.resolve().then(function () {
	                    _this._indeterminate = false;
	                    _this.indeterminateChange.emit(_this._indeterminate);
	                });
	            }
	            this.toggle();
	            this._transitionCheckState(this._checked ? TransitionCheckState.Checked : TransitionCheckState.Unchecked);
	            // Emit our custom change event if the native input emitted one.
	            // It is important to only emit it, if the native input triggered one, because
	            // we don't want to trigger a change event, when the `checked` variable changes for example.
	            this._emitChangeEvent();
	        }
	        else if (!this.disabled && this._clickAction === 'noop') {
	            // Reset native input when clicked with noop. The native checkbox becomes checked after
	            // click, reset it to be align with `checked` value of `mat-checkbox`.
	            this._inputElement.nativeElement.checked = this.checked;
	            this._inputElement.nativeElement.indeterminate = this.indeterminate;
	        }
	    };
	    /** Focuses the checkbox. */
	    /**
	     * Focuses the checkbox.
	     * @return {?}
	     */
	    MatCheckbox.prototype.focus = /**
	     * Focuses the checkbox.
	     * @return {?}
	     */
	    function () {
	        this._focusMonitor.focusVia(this._inputElement.nativeElement, 'keyboard');
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    MatCheckbox.prototype._onInteractionEvent = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        // We always have to stop propagation on the change event.
	        // Otherwise the change event, from the input element, will bubble up and
	        // emit its event object to the `change` output.
	        event.stopPropagation();
	    };
	    /**
	     * @param {?} oldState
	     * @param {?} newState
	     * @return {?}
	     */
	    MatCheckbox.prototype._getAnimationClassForCheckStateTransition = /**
	     * @param {?} oldState
	     * @param {?} newState
	     * @return {?}
	     */
	    function (oldState, newState) {
	        var /** @type {?} */ animSuffix = '';
	        switch (oldState) {
	            case TransitionCheckState.Init:
	                // Handle edge case where user interacts with checkbox that does not have [(ngModel)] or
	                // [checked] bound to it.
	                if (newState === TransitionCheckState.Checked) {
	                    animSuffix = 'unchecked-checked';
	                }
	                else if (newState == TransitionCheckState.Indeterminate) {
	                    animSuffix = 'unchecked-indeterminate';
	                }
	                else {
	                    return '';
	                }
	                break;
	            case TransitionCheckState.Unchecked:
	                animSuffix = newState === TransitionCheckState.Checked ?
	                    'unchecked-checked' : 'unchecked-indeterminate';
	                break;
	            case TransitionCheckState.Checked:
	                animSuffix = newState === TransitionCheckState.Unchecked ?
	                    'checked-unchecked' : 'checked-indeterminate';
	                break;
	            case TransitionCheckState.Indeterminate:
	                animSuffix = newState === TransitionCheckState.Checked ?
	                    'indeterminate-checked' : 'indeterminate-unchecked';
	                break;
	        }
	        return "mat-checkbox-anim-" + animSuffix;
	    };
	    /**
	     * Fades out the focus state ripple.
	     * @return {?}
	     */
	    MatCheckbox.prototype._removeFocusRipple = /**
	     * Fades out the focus state ripple.
	     * @return {?}
	     */
	    function () {
	        if (this._focusRipple) {
	            this._focusRipple.fadeOut();
	            this._focusRipple = null;
	        }
	    };
	    MatCheckbox.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-checkbox',
	                    template: "<label [attr.for]=\"inputId\" class=\"mat-checkbox-layout\" #label><div class=\"mat-checkbox-inner-container\" [class.mat-checkbox-inner-container-no-side-margin]=\"!checkboxLabel.textContent || !checkboxLabel.textContent.trim()\"><input #input class=\"mat-checkbox-input cdk-visually-hidden\" type=\"checkbox\" [id]=\"inputId\" [required]=\"required\" [checked]=\"checked\" [attr.value]=\"value\" [disabled]=\"disabled\" [attr.name]=\"name\" [tabIndex]=\"tabIndex\" [indeterminate]=\"indeterminate\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledby\" [attr.aria-checked]=\"_getAriaChecked()\" (change)=\"_onInteractionEvent($event)\" (click)=\"_onInputClick($event)\"><div matRipple class=\"mat-checkbox-ripple\" [matRippleTrigger]=\"label\" [matRippleDisabled]=\"_isRippleDisabled()\" [matRippleRadius]=\"25\" [matRippleCentered]=\"true\" [matRippleAnimation]=\"{enterDuration: 150}\"></div><div class=\"mat-checkbox-frame\"></div><div class=\"mat-checkbox-background\"><svg version=\"1.1\" focusable=\"false\" class=\"mat-checkbox-checkmark\" viewBox=\"0 0 24 24\" xml:space=\"preserve\"><path class=\"mat-checkbox-checkmark-path\" fill=\"none\" stroke=\"white\" d=\"M4.1,12.7 9,17.6 20.3,6.3\"/></svg><div class=\"mat-checkbox-mixedmark\"></div></div></div><span class=\"mat-checkbox-label\" #checkboxLabel (cdkObserveContent)=\"_onLabelTextChange()\"><span style=\"display:none\">&nbsp;</span><ng-content></ng-content></span></label>",
	                    styles: ["@keyframes mat-checkbox-fade-in-background{0%{opacity:0}50%{opacity:1}}@keyframes mat-checkbox-fade-out-background{0%,50%{opacity:1}100%{opacity:0}}@keyframes mat-checkbox-unchecked-checked-checkmark-path{0%,50%{stroke-dashoffset:22.91026}50%{animation-timing-function:cubic-bezier(0,0,.2,.1)}100%{stroke-dashoffset:0}}@keyframes mat-checkbox-unchecked-indeterminate-mixedmark{0%,68.2%{transform:scaleX(0)}68.2%{animation-timing-function:cubic-bezier(0,0,0,1)}100%{transform:scaleX(1)}}@keyframes mat-checkbox-checked-unchecked-checkmark-path{from{animation-timing-function:cubic-bezier(.4,0,1,1);stroke-dashoffset:0}to{stroke-dashoffset:-22.91026}}@keyframes mat-checkbox-checked-indeterminate-checkmark{from{animation-timing-function:cubic-bezier(0,0,.2,.1);opacity:1;transform:rotate(0)}to{opacity:0;transform:rotate(45deg)}}@keyframes mat-checkbox-indeterminate-checked-checkmark{from{animation-timing-function:cubic-bezier(.14,0,0,1);opacity:0;transform:rotate(45deg)}to{opacity:1;transform:rotate(360deg)}}@keyframes mat-checkbox-checked-indeterminate-mixedmark{from{animation-timing-function:cubic-bezier(0,0,.2,.1);opacity:0;transform:rotate(-45deg)}to{opacity:1;transform:rotate(0)}}@keyframes mat-checkbox-indeterminate-checked-mixedmark{from{animation-timing-function:cubic-bezier(.14,0,0,1);opacity:1;transform:rotate(0)}to{opacity:0;transform:rotate(315deg)}}@keyframes mat-checkbox-indeterminate-unchecked-mixedmark{0%{animation-timing-function:linear;opacity:1;transform:scaleX(1)}100%,32.8%{opacity:0;transform:scaleX(0)}}.mat-checkbox-checkmark,.mat-checkbox-mixedmark{width:calc(100% - 4px)}.mat-checkbox-background,.mat-checkbox-frame{top:0;left:0;right:0;bottom:0;position:absolute;border-radius:2px;box-sizing:border-box;pointer-events:none}.mat-checkbox{transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);cursor:pointer}.mat-checkbox-layout{cursor:inherit;align-items:baseline;vertical-align:middle;display:inline-flex;white-space:nowrap}.mat-checkbox-inner-container{display:inline-block;height:20px;line-height:0;margin:auto;margin-right:8px;order:0;position:relative;vertical-align:middle;white-space:nowrap;width:20px;flex-shrink:0}[dir=rtl] .mat-checkbox-inner-container{margin-left:8px;margin-right:auto}.mat-checkbox-inner-container-no-side-margin{margin-left:0;margin-right:0}.mat-checkbox-frame{background-color:transparent;transition:border-color 90ms cubic-bezier(0,0,.2,.1);border-width:2px;border-style:solid}.mat-checkbox-background{align-items:center;display:inline-flex;justify-content:center;transition:background-color 90ms cubic-bezier(0,0,.2,.1),opacity 90ms cubic-bezier(0,0,.2,.1)}.mat-checkbox-checkmark{top:0;left:0;right:0;bottom:0;position:absolute;width:100%}.mat-checkbox-checkmark-path{stroke-dashoffset:22.91026;stroke-dasharray:22.91026;stroke-width:2.66667px}.mat-checkbox-mixedmark{height:2px;opacity:0;transform:scaleX(0) rotate(0)}.mat-checkbox-label-before .mat-checkbox-inner-container{order:1;margin-left:8px;margin-right:auto}[dir=rtl] .mat-checkbox-label-before .mat-checkbox-inner-container{margin-left:auto;margin-right:8px}.mat-checkbox-checked .mat-checkbox-checkmark{opacity:1}.mat-checkbox-checked .mat-checkbox-checkmark-path{stroke-dashoffset:0}.mat-checkbox-checked .mat-checkbox-mixedmark{transform:scaleX(1) rotate(-45deg)}.mat-checkbox-indeterminate .mat-checkbox-checkmark{opacity:0;transform:rotate(45deg)}.mat-checkbox-indeterminate .mat-checkbox-checkmark-path{stroke-dashoffset:0}.mat-checkbox-indeterminate .mat-checkbox-mixedmark{opacity:1;transform:scaleX(1) rotate(0)}.mat-checkbox-unchecked .mat-checkbox-background{background-color:transparent}.mat-checkbox-disabled{cursor:default}.mat-checkbox-anim-unchecked-checked .mat-checkbox-background{animation:180ms linear 0s mat-checkbox-fade-in-background}.mat-checkbox-anim-unchecked-checked .mat-checkbox-checkmark-path{animation:180ms linear 0s mat-checkbox-unchecked-checked-checkmark-path}.mat-checkbox-anim-unchecked-indeterminate .mat-checkbox-background{animation:180ms linear 0s mat-checkbox-fade-in-background}.mat-checkbox-anim-unchecked-indeterminate .mat-checkbox-mixedmark{animation:90ms linear 0s mat-checkbox-unchecked-indeterminate-mixedmark}.mat-checkbox-anim-checked-unchecked .mat-checkbox-background{animation:180ms linear 0s mat-checkbox-fade-out-background}.mat-checkbox-anim-checked-unchecked .mat-checkbox-checkmark-path{animation:90ms linear 0s mat-checkbox-checked-unchecked-checkmark-path}.mat-checkbox-anim-checked-indeterminate .mat-checkbox-checkmark{animation:90ms linear 0s mat-checkbox-checked-indeterminate-checkmark}.mat-checkbox-anim-checked-indeterminate .mat-checkbox-mixedmark{animation:90ms linear 0s mat-checkbox-checked-indeterminate-mixedmark}.mat-checkbox-anim-indeterminate-checked .mat-checkbox-checkmark{animation:.5s linear 0s mat-checkbox-indeterminate-checked-checkmark}.mat-checkbox-anim-indeterminate-checked .mat-checkbox-mixedmark{animation:.5s linear 0s mat-checkbox-indeterminate-checked-mixedmark}.mat-checkbox-anim-indeterminate-unchecked .mat-checkbox-background{animation:180ms linear 0s mat-checkbox-fade-out-background}.mat-checkbox-anim-indeterminate-unchecked .mat-checkbox-mixedmark{animation:.3s linear 0s mat-checkbox-indeterminate-unchecked-mixedmark}.mat-checkbox-input{bottom:0;left:50%}.mat-checkbox-ripple{position:absolute;left:calc(50% - 25px);top:calc(50% - 25px);height:50px;width:50px;z-index:1;pointer-events:none}"],
	                    exportAs: 'matCheckbox',
	                    host: {
	                        'class': 'mat-checkbox',
	                        '[id]': 'id',
	                        '[class.mat-checkbox-indeterminate]': 'indeterminate',
	                        '[class.mat-checkbox-checked]': 'checked',
	                        '[class.mat-checkbox-disabled]': 'disabled',
	                        '[class.mat-checkbox-label-before]': 'labelPosition == "before"',
	                    },
	                    providers: [MAT_CHECKBOX_CONTROL_VALUE_ACCESSOR],
	                    inputs: ['disabled', 'disableRipple', 'color', 'tabIndex'],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush
	                },] },
	    ];
	    /** @nocollapse */
	    MatCheckbox.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: _angular_cdk_a11y.FocusMonitor, },
	        { type: undefined, decorators: [{ type: _angular_core.Attribute, args: ['tabindex',] },] },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MAT_CHECKBOX_CLICK_ACTION,] },] },
	    ]; };
	    MatCheckbox.propDecorators = {
	        "ariaLabel": [{ type: _angular_core.Input, args: ['aria-label',] },],
	        "ariaLabelledby": [{ type: _angular_core.Input, args: ['aria-labelledby',] },],
	        "id": [{ type: _angular_core.Input },],
	        "required": [{ type: _angular_core.Input },],
	        "align": [{ type: _angular_core.Input },],
	        "labelPosition": [{ type: _angular_core.Input },],
	        "name": [{ type: _angular_core.Input },],
	        "change": [{ type: _angular_core.Output },],
	        "indeterminateChange": [{ type: _angular_core.Output },],
	        "value": [{ type: _angular_core.Input },],
	        "_inputElement": [{ type: _angular_core.ViewChild, args: ['input',] },],
	        "ripple": [{ type: _angular_core.ViewChild, args: [_angular_material_core.MatRipple,] },],
	        "checked": [{ type: _angular_core.Input },],
	        "indeterminate": [{ type: _angular_core.Input },],
	    };
	    return MatCheckbox;
	}(_MatCheckboxMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MAT_CHECKBOX_REQUIRED_VALIDATOR = {
	    provide: _angular_forms.NG_VALIDATORS,
	    useExisting: _angular_core.forwardRef(function () { return MatCheckboxRequiredValidator; }),
	    multi: true
	};
	/**
	 * Validator for Material checkbox's required attribute in template-driven checkbox.
	 * Current CheckboxRequiredValidator only work with `input type=checkbox` and does not
	 * work with `mat-checkbox`.
	 */
	var MatCheckboxRequiredValidator = /** @class */ (function (_super) {
	    __extends(MatCheckboxRequiredValidator, _super);
	    function MatCheckboxRequiredValidator() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    MatCheckboxRequiredValidator.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: "mat-checkbox[required][formControlName],\n             mat-checkbox[required][formControl], mat-checkbox[required][ngModel]",
	                    providers: [MAT_CHECKBOX_REQUIRED_VALIDATOR],
	                    host: { '[attr.required]': 'required ? "" : null' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCheckboxRequiredValidator.ctorParameters = function () { return []; };
	    return MatCheckboxRequiredValidator;
	}(_angular_forms.CheckboxRequiredValidator));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatCheckboxModule = /** @class */ (function () {
	    function MatCheckboxModule() {
	    }
	    MatCheckboxModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [_angular_common.CommonModule, _angular_material_core.MatRippleModule, _angular_material_core.MatCommonModule, _angular_cdk_observers.ObserversModule, _angular_cdk_a11y.A11yModule],
	                    exports: [MatCheckbox, MatCheckboxRequiredValidator, _angular_material_core.MatCommonModule],
	                    declarations: [MatCheckbox, MatCheckboxRequiredValidator],
	                },] },
	    ];
	    /** @nocollapse */
	    MatCheckboxModule.ctorParameters = function () { return []; };
	    return MatCheckboxModule;
	}());
	
	exports.MAT_CHECKBOX_CONTROL_VALUE_ACCESSOR = MAT_CHECKBOX_CONTROL_VALUE_ACCESSOR;
	exports.TransitionCheckState = TransitionCheckState;
	exports.MatCheckboxChange = MatCheckboxChange;
	exports.MatCheckboxBase = MatCheckboxBase;
	exports._MatCheckboxMixinBase = _MatCheckboxMixinBase;
	exports.MatCheckbox = MatCheckbox;
	exports.MAT_CHECKBOX_CLICK_ACTION = MAT_CHECKBOX_CLICK_ACTION;
	exports.MatCheckboxModule = MatCheckboxModule;
	exports.MAT_CHECKBOX_REQUIRED_VALIDATOR = MAT_CHECKBOX_REQUIRED_VALIDATOR;
	exports.MatCheckboxRequiredValidator = MatCheckboxRequiredValidator;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=material-checkbox.umd.js.map


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(1077), __webpack_require__(263), __webpack_require__(1078), __webpack_require__(246), __webpack_require__(240), __webpack_require__(211), __webpack_require__(1079), __webpack_require__(428), __webpack_require__(298), __webpack_require__(254), __webpack_require__(449), __webpack_require__(253)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@angular/cdk/coercion', 'rxjs/operators/take', '@angular/cdk/platform', '@angular/common', 'rxjs/Subject', 'rxjs/Subscription', '@angular/cdk/keycodes', 'rxjs/operators/debounceTime', 'rxjs/operators/filter', 'rxjs/operators/map', 'rxjs/operators/tap', 'rxjs/observable/of'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.cdk = global.ng.cdk || {}, global.ng.cdk.a11y = global.ng.cdk.a11y || {}),global.ng.core,global.ng.cdk.coercion,global.Rx.operators,global.ng.cdk.platform,global.ng.common,global.Rx,global.Rx,global.ng.cdk.keycodes,global.Rx.operators,global.Rx.operators,global.Rx.operators,global.Rx.operators,global.Rx.Observable));
	}(this, (function (exports,_angular_core,_angular_cdk_coercion,rxjs_operators_take,_angular_cdk_platform,_angular_common,rxjs_Subject,rxjs_Subscription,_angular_cdk_keycodes,rxjs_operators_debounceTime,rxjs_operators_filter,rxjs_operators_map,rxjs_operators_tap,rxjs_observable_of) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Utility for checking the interactivity of an element, such as whether is is focusable or
	 * tabbable.
	 */
	var InteractivityChecker = /** @class */ (function () {
	    function InteractivityChecker(_platform) {
	        this._platform = _platform;
	    }
	    /**
	     * Gets whether an element is disabled.
	     *
	     * @param element Element to be checked.
	     * @returns Whether the element is disabled.
	     */
	    /**
	     * Gets whether an element is disabled.
	     *
	     * @param {?} element Element to be checked.
	     * @return {?} Whether the element is disabled.
	     */
	    InteractivityChecker.prototype.isDisabled = /**
	     * Gets whether an element is disabled.
	     *
	     * @param {?} element Element to be checked.
	     * @return {?} Whether the element is disabled.
	     */
	    function (element) {
	        // This does not capture some cases, such as a non-form control with a disabled attribute or
	        // a form control inside of a disabled form, but should capture the most common cases.
	        return element.hasAttribute('disabled');
	    };
	    /**
	     * Gets whether an element is visible for the purposes of interactivity.
	     *
	     * This will capture states like `display: none` and `visibility: hidden`, but not things like
	     * being clipped by an `overflow: hidden` parent or being outside the viewport.
	     *
	     * @returns Whether the element is visible.
	     */
	    /**
	     * Gets whether an element is visible for the purposes of interactivity.
	     *
	     * This will capture states like `display: none` and `visibility: hidden`, but not things like
	     * being clipped by an `overflow: hidden` parent or being outside the viewport.
	     *
	     * @param {?} element
	     * @return {?} Whether the element is visible.
	     */
	    InteractivityChecker.prototype.isVisible = /**
	     * Gets whether an element is visible for the purposes of interactivity.
	     *
	     * This will capture states like `display: none` and `visibility: hidden`, but not things like
	     * being clipped by an `overflow: hidden` parent or being outside the viewport.
	     *
	     * @param {?} element
	     * @return {?} Whether the element is visible.
	     */
	    function (element) {
	        return hasGeometry(element) && getComputedStyle(element).visibility === 'visible';
	    };
	    /**
	     * Gets whether an element can be reached via Tab key.
	     * Assumes that the element has already been checked with isFocusable.
	     *
	     * @param element Element to be checked.
	     * @returns Whether the element is tabbable.
	     */
	    /**
	     * Gets whether an element can be reached via Tab key.
	     * Assumes that the element has already been checked with isFocusable.
	     *
	     * @param {?} element Element to be checked.
	     * @return {?} Whether the element is tabbable.
	     */
	    InteractivityChecker.prototype.isTabbable = /**
	     * Gets whether an element can be reached via Tab key.
	     * Assumes that the element has already been checked with isFocusable.
	     *
	     * @param {?} element Element to be checked.
	     * @return {?} Whether the element is tabbable.
	     */
	    function (element) {
	        // Nothing is tabbable on the the server 😎
	        if (!this._platform.isBrowser) {
	            return false;
	        }
	        var /** @type {?} */ frameElement = getFrameElement(getWindow(element));
	        if (frameElement) {
	            var /** @type {?} */ frameType = frameElement && frameElement.nodeName.toLowerCase();
	            // Frame elements inherit their tabindex onto all child elements.
	            if (getTabIndexValue(frameElement) === -1) {
	                return false;
	            }
	            // Webkit and Blink consider anything inside of an <object> element as non-tabbable.
	            if ((this._platform.BLINK || this._platform.WEBKIT) && frameType === 'object') {
	                return false;
	            }
	            // Webkit and Blink disable tabbing to an element inside of an invisible frame.
	            if ((this._platform.BLINK || this._platform.WEBKIT) && !this.isVisible(frameElement)) {
	                return false;
	            }
	        }
	        var /** @type {?} */ nodeName = element.nodeName.toLowerCase();
	        var /** @type {?} */ tabIndexValue = getTabIndexValue(element);
	        if (element.hasAttribute('contenteditable')) {
	            return tabIndexValue !== -1;
	        }
	        if (nodeName === 'iframe') {
	            // The frames may be tabbable depending on content, but it's not possibly to reliably
	            // investigate the content of the frames.
	            return false;
	        }
	        if (nodeName === 'audio') {
	            if (!element.hasAttribute('controls')) {
	                // By default an <audio> element without the controls enabled is not tabbable.
	                return false;
	            }
	            else if (this._platform.BLINK) {
	                // In Blink <audio controls> elements are always tabbable.
	                return true;
	            }
	        }
	        if (nodeName === 'video') {
	            if (!element.hasAttribute('controls') && this._platform.TRIDENT) {
	                // In Trident a <video> element without the controls enabled is not tabbable.
	                return false;
	            }
	            else if (this._platform.BLINK || this._platform.FIREFOX) {
	                // In Chrome and Firefox <video controls> elements are always tabbable.
	                return true;
	            }
	        }
	        if (nodeName === 'object' && (this._platform.BLINK || this._platform.WEBKIT)) {
	            // In all Blink and WebKit based browsers <object> elements are never tabbable.
	            return false;
	        }
	        // In iOS the browser only considers some specific elements as tabbable.
	        if (this._platform.WEBKIT && this._platform.IOS && !isPotentiallyTabbableIOS(element)) {
	            return false;
	        }
	        return element.tabIndex >= 0;
	    };
	    /**
	     * Gets whether an element can be focused by the user.
	     *
	     * @param element Element to be checked.
	     * @returns Whether the element is focusable.
	     */
	    /**
	     * Gets whether an element can be focused by the user.
	     *
	     * @param {?} element Element to be checked.
	     * @return {?} Whether the element is focusable.
	     */
	    InteractivityChecker.prototype.isFocusable = /**
	     * Gets whether an element can be focused by the user.
	     *
	     * @param {?} element Element to be checked.
	     * @return {?} Whether the element is focusable.
	     */
	    function (element) {
	        // Perform checks in order of left to most expensive.
	        // Again, naive approach that does not capture many edge cases and browser quirks.
	        return isPotentiallyFocusable(element) && !this.isDisabled(element) && this.isVisible(element);
	    };
	    InteractivityChecker.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    InteractivityChecker.ctorParameters = function () { return [
	        { type: _angular_cdk_platform.Platform, },
	    ]; };
	    return InteractivityChecker;
	}());
	/**
	 * Returns the frame element from a window object. Since browsers like MS Edge throw errors if
	 * the frameElement property is being accessed from a different host address, this property
	 * should be accessed carefully.
	 * @param {?} window
	 * @return {?}
	 */
	function getFrameElement(window) {
	    try {
	        return /** @type {?} */ (window.frameElement);
	    }
	    catch (/** @type {?} */ e) {
	        return null;
	    }
	}
	/**
	 * Checks whether the specified element has any geometry / rectangles.
	 * @param {?} element
	 * @return {?}
	 */
	function hasGeometry(element) {
	    // Use logic from jQuery to check for an invisible element.
	    // See https://github.com/jquery/jquery/blob/master/src/css/hiddenVisibleSelectors.js#L12
	    return !!(element.offsetWidth || element.offsetHeight ||
	        (typeof element.getClientRects === 'function' && element.getClientRects().length));
	}
	/**
	 * Gets whether an element's
	 * @param {?} element
	 * @return {?}
	 */
	function isNativeFormElement(element) {
	    var /** @type {?} */ nodeName = element.nodeName.toLowerCase();
	    return nodeName === 'input' ||
	        nodeName === 'select' ||
	        nodeName === 'button' ||
	        nodeName === 'textarea';
	}
	/**
	 * Gets whether an element is an `<input type="hidden">`.
	 * @param {?} element
	 * @return {?}
	 */
	function isHiddenInput(element) {
	    return isInputElement(element) && element.type == 'hidden';
	}
	/**
	 * Gets whether an element is an anchor that has an href attribute.
	 * @param {?} element
	 * @return {?}
	 */
	function isAnchorWithHref(element) {
	    return isAnchorElement(element) && element.hasAttribute('href');
	}
	/**
	 * Gets whether an element is an input element.
	 * @param {?} element
	 * @return {?}
	 */
	function isInputElement(element) {
	    return element.nodeName.toLowerCase() == 'input';
	}
	/**
	 * Gets whether an element is an anchor element.
	 * @param {?} element
	 * @return {?}
	 */
	function isAnchorElement(element) {
	    return element.nodeName.toLowerCase() == 'a';
	}
	/**
	 * Gets whether an element has a valid tabindex.
	 * @param {?} element
	 * @return {?}
	 */
	function hasValidTabIndex(element) {
	    if (!element.hasAttribute('tabindex') || element.tabIndex === undefined) {
	        return false;
	    }
	    var /** @type {?} */ tabIndex = element.getAttribute('tabindex');
	    // IE11 parses tabindex="" as the value "-32768"
	    if (tabIndex == '-32768') {
	        return false;
	    }
	    return !!(tabIndex && !isNaN(parseInt(tabIndex, 10)));
	}
	/**
	 * Returns the parsed tabindex from the element attributes instead of returning the
	 * evaluated tabindex from the browsers defaults.
	 * @param {?} element
	 * @return {?}
	 */
	function getTabIndexValue(element) {
	    if (!hasValidTabIndex(element)) {
	        return null;
	    }
	    // See browser issue in Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1128054
	    var /** @type {?} */ tabIndex = parseInt(element.getAttribute('tabindex') || '', 10);
	    return isNaN(tabIndex) ? -1 : tabIndex;
	}
	/**
	 * Checks whether the specified element is potentially tabbable on iOS
	 * @param {?} element
	 * @return {?}
	 */
	function isPotentiallyTabbableIOS(element) {
	    var /** @type {?} */ nodeName = element.nodeName.toLowerCase();
	    var /** @type {?} */ inputType = nodeName === 'input' && (/** @type {?} */ (element)).type;
	    return inputType === 'text'
	        || inputType === 'password'
	        || nodeName === 'select'
	        || nodeName === 'textarea';
	}
	/**
	 * Gets whether an element is potentially focusable without taking current visible/disabled state
	 * into account.
	 * @param {?} element
	 * @return {?}
	 */
	function isPotentiallyFocusable(element) {
	    // Inputs are potentially focusable *unless* they're type="hidden".
	    if (isHiddenInput(element)) {
	        return false;
	    }
	    return isNativeFormElement(element) ||
	        isAnchorWithHref(element) ||
	        element.hasAttribute('contenteditable') ||
	        hasValidTabIndex(element);
	}
	/**
	 * Gets the parent window of a DOM node with regards of being inside of an iframe.
	 * @param {?} node
	 * @return {?}
	 */
	function getWindow(node) {
	    return node.ownerDocument.defaultView || window;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Class that allows for trapping focus within a DOM element.
	 *
	 * This class currently uses a relatively simple approach to focus trapping.
	 * It assumes that the tab order is the same as DOM order, which is not necessarily true.
	 * Things like `tabIndex > 0`, flex `order`, and shadow roots can cause to two to misalign.
	 */
	var FocusTrap = /** @class */ (function () {
	    function FocusTrap(_element, _checker, _ngZone, _document, deferAnchors) {
	        if (deferAnchors === void 0) { deferAnchors = false; }
	        this._element = _element;
	        this._checker = _checker;
	        this._ngZone = _ngZone;
	        this._document = _document;
	        this._enabled = true;
	        if (!deferAnchors) {
	            this.attachAnchors();
	        }
	    }
	    Object.defineProperty(FocusTrap.prototype, "enabled", {
	        /** Whether the focus trap is active. */
	        get: /**
	         * Whether the focus trap is active.
	         * @return {?}
	         */
	        function () { return this._enabled; },
	        set: /**
	         * @param {?} val
	         * @return {?}
	         */
	        function (val) {
	            this._enabled = val;
	            if (this._startAnchor && this._endAnchor) {
	                this._startAnchor.tabIndex = this._endAnchor.tabIndex = this._enabled ? 0 : -1;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** Destroys the focus trap by cleaning up the anchors. */
	    /**
	     * Destroys the focus trap by cleaning up the anchors.
	     * @return {?}
	     */
	    FocusTrap.prototype.destroy = /**
	     * Destroys the focus trap by cleaning up the anchors.
	     * @return {?}
	     */
	    function () {
	        if (this._startAnchor && this._startAnchor.parentNode) {
	            this._startAnchor.parentNode.removeChild(this._startAnchor);
	        }
	        if (this._endAnchor && this._endAnchor.parentNode) {
	            this._endAnchor.parentNode.removeChild(this._endAnchor);
	        }
	        this._startAnchor = this._endAnchor = null;
	    };
	    /**
	     * Inserts the anchors into the DOM. This is usually done automatically
	     * in the constructor, but can be deferred for cases like directives with `*ngIf`.
	     */
	    /**
	     * Inserts the anchors into the DOM. This is usually done automatically
	     * in the constructor, but can be deferred for cases like directives with `*ngIf`.
	     * @return {?}
	     */
	    FocusTrap.prototype.attachAnchors = /**
	     * Inserts the anchors into the DOM. This is usually done automatically
	     * in the constructor, but can be deferred for cases like directives with `*ngIf`.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (!this._startAnchor) {
	            this._startAnchor = this._createAnchor();
	        }
	        if (!this._endAnchor) {
	            this._endAnchor = this._createAnchor();
	        }
	        this._ngZone.runOutsideAngular(function () {
	            /** @type {?} */ ((_this._startAnchor)).addEventListener('focus', function () {
	                _this.focusLastTabbableElement();
	            }); /** @type {?} */
	            ((_this._endAnchor)).addEventListener('focus', function () {
	                _this.focusFirstTabbableElement();
	            });
	            if (_this._element.parentNode) {
	                _this._element.parentNode.insertBefore(/** @type {?} */ ((_this._startAnchor)), _this._element);
	                _this._element.parentNode.insertBefore(/** @type {?} */ ((_this._endAnchor)), _this._element.nextSibling);
	            }
	        });
	    };
	    /**
	     * Waits for the zone to stabilize, then either focuses the first element that the
	     * user specified, or the first tabbable element.
	     * @returns Returns a promise that resolves with a boolean, depending
	     * on whether focus was moved successfuly.
	     */
	    /**
	     * Waits for the zone to stabilize, then either focuses the first element that the
	     * user specified, or the first tabbable element.
	     * @return {?} Returns a promise that resolves with a boolean, depending
	     * on whether focus was moved successfuly.
	     */
	    FocusTrap.prototype.focusInitialElementWhenReady = /**
	     * Waits for the zone to stabilize, then either focuses the first element that the
	     * user specified, or the first tabbable element.
	     * @return {?} Returns a promise that resolves with a boolean, depending
	     * on whether focus was moved successfuly.
	     */
	    function () {
	        var _this = this;
	        return new Promise(function (resolve) {
	            _this._executeOnStable(function () { return resolve(_this.focusInitialElement()); });
	        });
	    };
	    /**
	     * Waits for the zone to stabilize, then focuses
	     * the first tabbable element within the focus trap region.
	     * @returns Returns a promise that resolves with a boolean, depending
	     * on whether focus was moved successfuly.
	     */
	    /**
	     * Waits for the zone to stabilize, then focuses
	     * the first tabbable element within the focus trap region.
	     * @return {?} Returns a promise that resolves with a boolean, depending
	     * on whether focus was moved successfuly.
	     */
	    FocusTrap.prototype.focusFirstTabbableElementWhenReady = /**
	     * Waits for the zone to stabilize, then focuses
	     * the first tabbable element within the focus trap region.
	     * @return {?} Returns a promise that resolves with a boolean, depending
	     * on whether focus was moved successfuly.
	     */
	    function () {
	        var _this = this;
	        return new Promise(function (resolve) {
	            _this._executeOnStable(function () { return resolve(_this.focusFirstTabbableElement()); });
	        });
	    };
	    /**
	     * Waits for the zone to stabilize, then focuses
	     * the last tabbable element within the focus trap region.
	     * @returns Returns a promise that resolves with a boolean, depending
	     * on whether focus was moved successfuly.
	     */
	    /**
	     * Waits for the zone to stabilize, then focuses
	     * the last tabbable element within the focus trap region.
	     * @return {?} Returns a promise that resolves with a boolean, depending
	     * on whether focus was moved successfuly.
	     */
	    FocusTrap.prototype.focusLastTabbableElementWhenReady = /**
	     * Waits for the zone to stabilize, then focuses
	     * the last tabbable element within the focus trap region.
	     * @return {?} Returns a promise that resolves with a boolean, depending
	     * on whether focus was moved successfuly.
	     */
	    function () {
	        var _this = this;
	        return new Promise(function (resolve) {
	            _this._executeOnStable(function () { return resolve(_this.focusLastTabbableElement()); });
	        });
	    };
	    /**
	     * Get the specified boundary element of the trapped region.
	     * @param {?} bound The boundary to get (start or end of trapped region).
	     * @return {?} The boundary element.
	     */
	    FocusTrap.prototype._getRegionBoundary = /**
	     * Get the specified boundary element of the trapped region.
	     * @param {?} bound The boundary to get (start or end of trapped region).
	     * @return {?} The boundary element.
	     */
	    function (bound) {
	        // Contains the deprecated version of selector, for temporary backwards comparability.
	        var /** @type {?} */ markers = /** @type {?} */ (this._element.querySelectorAll("[cdk-focus-region-" + bound + "], " +
	            ("[cdkFocusRegion" + bound + "], ") +
	            ("[cdk-focus-" + bound + "]")));
	        for (var /** @type {?} */ i = 0; i < markers.length; i++) {
	            if (markers[i].hasAttribute("cdk-focus-" + bound)) {
	                console.warn("Found use of deprecated attribute 'cdk-focus-" + bound + "'," +
	                    (" use 'cdkFocusRegion" + bound + "' instead."), markers[i]);
	            }
	            else if (markers[i].hasAttribute("cdk-focus-region-" + bound)) {
	                console.warn("Found use of deprecated attribute 'cdk-focus-region-" + bound + "'," +
	                    (" use 'cdkFocusRegion" + bound + "' instead."), markers[i]);
	            }
	        }
	        if (bound == 'start') {
	            return markers.length ? markers[0] : this._getFirstTabbableElement(this._element);
	        }
	        return markers.length ?
	            markers[markers.length - 1] : this._getLastTabbableElement(this._element);
	    };
	    /**
	     * Focuses the element that should be focused when the focus trap is initialized.
	     * @returns Whether focus was moved successfuly.
	     */
	    /**
	     * Focuses the element that should be focused when the focus trap is initialized.
	     * @return {?} Whether focus was moved successfuly.
	     */
	    FocusTrap.prototype.focusInitialElement = /**
	     * Focuses the element that should be focused when the focus trap is initialized.
	     * @return {?} Whether focus was moved successfuly.
	     */
	    function () {
	        // Contains the deprecated version of selector, for temporary backwards comparability.
	        var /** @type {?} */ redirectToElement = /** @type {?} */ (this._element.querySelector("[cdk-focus-initial], " +
	            "[cdkFocusInitial]"));
	        if (this._element.hasAttribute("cdk-focus-initial")) {
	            console.warn("Found use of deprecated attribute 'cdk-focus-initial'," +
	                " use 'cdkFocusInitial' instead.", this._element);
	        }
	        if (redirectToElement) {
	            redirectToElement.focus();
	            return true;
	        }
	        return this.focusFirstTabbableElement();
	    };
	    /**
	     * Focuses the first tabbable element within the focus trap region.
	     * @returns Whether focus was moved successfuly.
	     */
	    /**
	     * Focuses the first tabbable element within the focus trap region.
	     * @return {?} Whether focus was moved successfuly.
	     */
	    FocusTrap.prototype.focusFirstTabbableElement = /**
	     * Focuses the first tabbable element within the focus trap region.
	     * @return {?} Whether focus was moved successfuly.
	     */
	    function () {
	        var /** @type {?} */ redirectToElement = this._getRegionBoundary('start');
	        if (redirectToElement) {
	            redirectToElement.focus();
	        }
	        return !!redirectToElement;
	    };
	    /**
	     * Focuses the last tabbable element within the focus trap region.
	     * @returns Whether focus was moved successfuly.
	     */
	    /**
	     * Focuses the last tabbable element within the focus trap region.
	     * @return {?} Whether focus was moved successfuly.
	     */
	    FocusTrap.prototype.focusLastTabbableElement = /**
	     * Focuses the last tabbable element within the focus trap region.
	     * @return {?} Whether focus was moved successfuly.
	     */
	    function () {
	        var /** @type {?} */ redirectToElement = this._getRegionBoundary('end');
	        if (redirectToElement) {
	            redirectToElement.focus();
	        }
	        return !!redirectToElement;
	    };
	    /**
	     * Get the first tabbable element from a DOM subtree (inclusive).
	     * @param {?} root
	     * @return {?}
	     */
	    FocusTrap.prototype._getFirstTabbableElement = /**
	     * Get the first tabbable element from a DOM subtree (inclusive).
	     * @param {?} root
	     * @return {?}
	     */
	    function (root) {
	        if (this._checker.isFocusable(root) && this._checker.isTabbable(root)) {
	            return root;
	        }
	        // Iterate in DOM order. Note that IE doesn't have `children` for SVG so we fall
	        // back to `childNodes` which includes text nodes, comments etc.
	        var /** @type {?} */ children = root.children || root.childNodes;
	        for (var /** @type {?} */ i = 0; i < children.length; i++) {
	            var /** @type {?} */ tabbableChild = children[i].nodeType === this._document.ELEMENT_NODE ?
	                this._getFirstTabbableElement(/** @type {?} */ (children[i])) :
	                null;
	            if (tabbableChild) {
	                return tabbableChild;
	            }
	        }
	        return null;
	    };
	    /**
	     * Get the last tabbable element from a DOM subtree (inclusive).
	     * @param {?} root
	     * @return {?}
	     */
	    FocusTrap.prototype._getLastTabbableElement = /**
	     * Get the last tabbable element from a DOM subtree (inclusive).
	     * @param {?} root
	     * @return {?}
	     */
	    function (root) {
	        if (this._checker.isFocusable(root) && this._checker.isTabbable(root)) {
	            return root;
	        }
	        // Iterate in reverse DOM order.
	        var /** @type {?} */ children = root.children || root.childNodes;
	        for (var /** @type {?} */ i = children.length - 1; i >= 0; i--) {
	            var /** @type {?} */ tabbableChild = children[i].nodeType === this._document.ELEMENT_NODE ?
	                this._getLastTabbableElement(/** @type {?} */ (children[i])) :
	                null;
	            if (tabbableChild) {
	                return tabbableChild;
	            }
	        }
	        return null;
	    };
	    /**
	     * Creates an anchor element.
	     * @return {?}
	     */
	    FocusTrap.prototype._createAnchor = /**
	     * Creates an anchor element.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ anchor = this._document.createElement('div');
	        anchor.tabIndex = this._enabled ? 0 : -1;
	        anchor.classList.add('cdk-visually-hidden');
	        anchor.classList.add('cdk-focus-trap-anchor');
	        return anchor;
	    };
	    /**
	     * Executes a function when the zone is stable.
	     * @param {?} fn
	     * @return {?}
	     */
	    FocusTrap.prototype._executeOnStable = /**
	     * Executes a function when the zone is stable.
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        if (this._ngZone.isStable) {
	            fn();
	        }
	        else {
	            this._ngZone.onStable.asObservable().pipe(rxjs_operators_take.take(1)).subscribe(fn);
	        }
	    };
	    return FocusTrap;
	}());
	/**
	 * Factory that allows easy instantiation of focus traps.
	 */
	var FocusTrapFactory = /** @class */ (function () {
	    function FocusTrapFactory(_checker, _ngZone, _document) {
	        this._checker = _checker;
	        this._ngZone = _ngZone;
	        this._document = _document;
	    }
	    /**
	     * Creates a focus-trapped region around the given element.
	     * @param element The element around which focus will be trapped.
	     * @param deferCaptureElements Defers the creation of focus-capturing elements to be done
	     *     manually by the user.
	     * @returns The created focus trap instance.
	     */
	    /**
	     * Creates a focus-trapped region around the given element.
	     * @param {?} element The element around which focus will be trapped.
	     * @param {?=} deferCaptureElements Defers the creation of focus-capturing elements to be done
	     *     manually by the user.
	     * @return {?} The created focus trap instance.
	     */
	    FocusTrapFactory.prototype.create = /**
	     * Creates a focus-trapped region around the given element.
	     * @param {?} element The element around which focus will be trapped.
	     * @param {?=} deferCaptureElements Defers the creation of focus-capturing elements to be done
	     *     manually by the user.
	     * @return {?} The created focus trap instance.
	     */
	    function (element, deferCaptureElements) {
	        if (deferCaptureElements === void 0) { deferCaptureElements = false; }
	        return new FocusTrap(element, this._checker, this._ngZone, this._document, deferCaptureElements);
	    };
	    FocusTrapFactory.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    FocusTrapFactory.ctorParameters = function () { return [
	        { type: InteractivityChecker, },
	        { type: _angular_core.NgZone, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    return FocusTrapFactory;
	}());
	/**
	 * Directive for trapping focus within a region.
	 * \@docs-private
	 * @deprecated
	 * \@deletion-target 6.0.0
	 */
	var FocusTrapDeprecatedDirective = /** @class */ (function () {
	    function FocusTrapDeprecatedDirective(_elementRef, _focusTrapFactory) {
	        this._elementRef = _elementRef;
	        this._focusTrapFactory = _focusTrapFactory;
	        this.focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement, true);
	    }
	    Object.defineProperty(FocusTrapDeprecatedDirective.prototype, "disabled", {
	        get: /**
	         * Whether the focus trap is active.
	         * @return {?}
	         */
	        function () { return !this.focusTrap.enabled; },
	        set: /**
	         * @param {?} val
	         * @return {?}
	         */
	        function (val) {
	            this.focusTrap.enabled = !_angular_cdk_coercion.coerceBooleanProperty(val);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    FocusTrapDeprecatedDirective.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this.focusTrap.destroy();
	    };
	    /**
	     * @return {?}
	     */
	    FocusTrapDeprecatedDirective.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        this.focusTrap.attachAnchors();
	    };
	    FocusTrapDeprecatedDirective.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'cdk-focus-trap',
	                },] },
	    ];
	    /** @nocollapse */
	    FocusTrapDeprecatedDirective.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: FocusTrapFactory, },
	    ]; };
	    FocusTrapDeprecatedDirective.propDecorators = {
	        "disabled": [{ type: _angular_core.Input },],
	    };
	    return FocusTrapDeprecatedDirective;
	}());
	/**
	 * Directive for trapping focus within a region.
	 */
	var CdkTrapFocus = /** @class */ (function () {
	    function CdkTrapFocus(_elementRef, _focusTrapFactory, _document) {
	        this._elementRef = _elementRef;
	        this._focusTrapFactory = _focusTrapFactory;
	        /**
	         * Previously focused element to restore focus to upon destroy when using autoCapture.
	         */
	        this._previouslyFocusedElement = null;
	        this._document = _document;
	        this.focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement, true);
	    }
	    Object.defineProperty(CdkTrapFocus.prototype, "enabled", {
	        get: /**
	         * Whether the focus trap is active.
	         * @return {?}
	         */
	        function () { return this.focusTrap.enabled; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this.focusTrap.enabled = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkTrapFocus.prototype, "autoCapture", {
	        get: /**
	         * Whether the directive should automatially move focus into the trapped region upon
	         * initialization and return focus to the previous activeElement upon destruction.
	         * @return {?}
	         */
	        function () { return this._autoCapture; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._autoCapture = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    CdkTrapFocus.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this.focusTrap.destroy();
	        // If we stored a previously focused element when using autoCapture, return focus to that
	        // element now that the trapped region is being destroyed.
	        if (this._previouslyFocusedElement) {
	            this._previouslyFocusedElement.focus();
	            this._previouslyFocusedElement = null;
	        }
	    };
	    /**
	     * @return {?}
	     */
	    CdkTrapFocus.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        this.focusTrap.attachAnchors();
	        if (this.autoCapture) {
	            this._previouslyFocusedElement = /** @type {?} */ (this._document.activeElement);
	            this.focusTrap.focusInitialElementWhenReady();
	        }
	    };
	    CdkTrapFocus.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[cdkTrapFocus]',
	                    exportAs: 'cdkTrapFocus',
	                },] },
	    ];
	    /** @nocollapse */
	    CdkTrapFocus.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: FocusTrapFactory, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    CdkTrapFocus.propDecorators = {
	        "enabled": [{ type: _angular_core.Input, args: ['cdkTrapFocus',] },],
	        "autoCapture": [{ type: _angular_core.Input, args: ['cdkTrapFocusAutoCapture',] },],
	    };
	    return CdkTrapFocus;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * IDs are deliminated by an empty space, as per the spec.
	 */
	var ID_DELIMINATOR = ' ';
	/**
	 * Adds the given ID to the specified ARIA attribute on an element.
	 * Used for attributes such as aria-labelledby, aria-owns, etc.
	 * @param {?} el
	 * @param {?} attr
	 * @param {?} id
	 * @return {?}
	 */
	function addAriaReferencedId(el, attr, id) {
	    var /** @type {?} */ ids = getAriaReferenceIds(el, attr);
	    if (ids.some(function (existingId) { return existingId.trim() == id.trim(); })) {
	        return;
	    }
	    ids.push(id.trim());
	    el.setAttribute(attr, ids.join(ID_DELIMINATOR));
	}
	/**
	 * Removes the given ID from the specified ARIA attribute on an element.
	 * Used for attributes such as aria-labelledby, aria-owns, etc.
	 * @param {?} el
	 * @param {?} attr
	 * @param {?} id
	 * @return {?}
	 */
	function removeAriaReferencedId(el, attr, id) {
	    var /** @type {?} */ ids = getAriaReferenceIds(el, attr);
	    var /** @type {?} */ filteredIds = ids.filter(function (val) { return val != id.trim(); });
	    el.setAttribute(attr, filteredIds.join(ID_DELIMINATOR));
	}
	/**
	 * Gets the list of IDs referenced by the given ARIA attribute on an element.
	 * Used for attributes such as aria-labelledby, aria-owns, etc.
	 * @param {?} el
	 * @param {?} attr
	 * @return {?}
	 */
	function getAriaReferenceIds(el, attr) {
	    // Get string array of all individual ids (whitespace deliminated) in the attribute value
	    return (el.getAttribute(attr) || '').match(/\S+/g) || [];
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Interface used to register message elements and keep a count of how many registrations have
	 * the same message and the reference to the message element used for the `aria-describedby`.
	 * @record
	 */
	
	/**
	 * ID used for the body container where all messages are appended.
	 */
	var MESSAGES_CONTAINER_ID = 'cdk-describedby-message-container';
	/**
	 * ID prefix used for each created message element.
	 */
	var CDK_DESCRIBEDBY_ID_PREFIX = 'cdk-describedby-message';
	/**
	 * Attribute given to each host element that is described by a message element.
	 */
	var CDK_DESCRIBEDBY_HOST_ATTRIBUTE = 'cdk-describedby-host';
	/**
	 * Global incremental identifier for each registered message element.
	 */
	var nextId = 0;
	/**
	 * Global map of all registered message elements that have been placed into the document.
	 */
	var messageRegistry = new Map();
	/**
	 * Container for all registered messages.
	 */
	var messagesContainer = null;
	/**
	 * Utility that creates visually hidden elements with a message content. Useful for elements that
	 * want to use aria-describedby to further describe themselves without adding additional visual
	 * content.
	 * \@docs-private
	 */
	var AriaDescriber = /** @class */ (function () {
	    function AriaDescriber(_document) {
	        this._document = _document;
	    }
	    /**
	     * Adds to the host element an aria-describedby reference to a hidden element that contains
	     * the message. If the same message has already been registered, then it will reuse the created
	     * message element.
	     */
	    /**
	     * Adds to the host element an aria-describedby reference to a hidden element that contains
	     * the message. If the same message has already been registered, then it will reuse the created
	     * message element.
	     * @param {?} hostElement
	     * @param {?} message
	     * @return {?}
	     */
	    AriaDescriber.prototype.describe = /**
	     * Adds to the host element an aria-describedby reference to a hidden element that contains
	     * the message. If the same message has already been registered, then it will reuse the created
	     * message element.
	     * @param {?} hostElement
	     * @param {?} message
	     * @return {?}
	     */
	    function (hostElement, message) {
	        if (!this._canBeDescribed(hostElement, message)) {
	            return;
	        }
	        if (!messageRegistry.has(message)) {
	            this._createMessageElement(message);
	        }
	        if (!this._isElementDescribedByMessage(hostElement, message)) {
	            this._addMessageReference(hostElement, message);
	        }
	    };
	    /** Removes the host element's aria-describedby reference to the message element. */
	    /**
	     * Removes the host element's aria-describedby reference to the message element.
	     * @param {?} hostElement
	     * @param {?} message
	     * @return {?}
	     */
	    AriaDescriber.prototype.removeDescription = /**
	     * Removes the host element's aria-describedby reference to the message element.
	     * @param {?} hostElement
	     * @param {?} message
	     * @return {?}
	     */
	    function (hostElement, message) {
	        if (!this._canBeDescribed(hostElement, message)) {
	            return;
	        }
	        if (this._isElementDescribedByMessage(hostElement, message)) {
	            this._removeMessageReference(hostElement, message);
	        }
	        var /** @type {?} */ registeredMessage = messageRegistry.get(message);
	        if (registeredMessage && registeredMessage.referenceCount === 0) {
	            this._deleteMessageElement(message);
	        }
	        if (messagesContainer && messagesContainer.childNodes.length === 0) {
	            this._deleteMessagesContainer();
	        }
	    };
	    /** Unregisters all created message elements and removes the message container. */
	    /**
	     * Unregisters all created message elements and removes the message container.
	     * @return {?}
	     */
	    AriaDescriber.prototype.ngOnDestroy = /**
	     * Unregisters all created message elements and removes the message container.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ describedElements = this._document.querySelectorAll("[" + CDK_DESCRIBEDBY_HOST_ATTRIBUTE + "]");
	        for (var /** @type {?} */ i = 0; i < describedElements.length; i++) {
	            this._removeCdkDescribedByReferenceIds(describedElements[i]);
	            describedElements[i].removeAttribute(CDK_DESCRIBEDBY_HOST_ATTRIBUTE);
	        }
	        if (messagesContainer) {
	            this._deleteMessagesContainer();
	        }
	        messageRegistry.clear();
	    };
	    /**
	     * Creates a new element in the visually hidden message container element with the message
	     * as its content and adds it to the message registry.
	     * @param {?} message
	     * @return {?}
	     */
	    AriaDescriber.prototype._createMessageElement = /**
	     * Creates a new element in the visually hidden message container element with the message
	     * as its content and adds it to the message registry.
	     * @param {?} message
	     * @return {?}
	     */
	    function (message) {
	        var /** @type {?} */ messageElement = this._document.createElement('div');
	        messageElement.setAttribute('id', CDK_DESCRIBEDBY_ID_PREFIX + "-" + nextId++);
	        messageElement.appendChild(/** @type {?} */ ((this._document.createTextNode(message))));
	        if (!messagesContainer) {
	            this._createMessagesContainer();
	        } /** @type {?} */
	        ((messagesContainer)).appendChild(messageElement);
	        messageRegistry.set(message, { messageElement: messageElement, referenceCount: 0 });
	    };
	    /**
	     * Deletes the message element from the global messages container.
	     * @param {?} message
	     * @return {?}
	     */
	    AriaDescriber.prototype._deleteMessageElement = /**
	     * Deletes the message element from the global messages container.
	     * @param {?} message
	     * @return {?}
	     */
	    function (message) {
	        var /** @type {?} */ registeredMessage = messageRegistry.get(message);
	        var /** @type {?} */ messageElement = registeredMessage && registeredMessage.messageElement;
	        if (messagesContainer && messageElement) {
	            messagesContainer.removeChild(messageElement);
	        }
	        messageRegistry.delete(message);
	    };
	    /**
	     * Creates the global container for all aria-describedby messages.
	     * @return {?}
	     */
	    AriaDescriber.prototype._createMessagesContainer = /**
	     * Creates the global container for all aria-describedby messages.
	     * @return {?}
	     */
	    function () {
	        messagesContainer = this._document.createElement('div');
	        messagesContainer.setAttribute('id', MESSAGES_CONTAINER_ID);
	        messagesContainer.setAttribute('aria-hidden', 'true');
	        messagesContainer.style.display = 'none';
	        this._document.body.appendChild(messagesContainer);
	    };
	    /**
	     * Deletes the global messages container.
	     * @return {?}
	     */
	    AriaDescriber.prototype._deleteMessagesContainer = /**
	     * Deletes the global messages container.
	     * @return {?}
	     */
	    function () {
	        if (messagesContainer && messagesContainer.parentNode) {
	            messagesContainer.parentNode.removeChild(messagesContainer);
	            messagesContainer = null;
	        }
	    };
	    /**
	     * Removes all cdk-describedby messages that are hosted through the element.
	     * @param {?} element
	     * @return {?}
	     */
	    AriaDescriber.prototype._removeCdkDescribedByReferenceIds = /**
	     * Removes all cdk-describedby messages that are hosted through the element.
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) {
	        // Remove all aria-describedby reference IDs that are prefixed by CDK_DESCRIBEDBY_ID_PREFIX
	        var /** @type {?} */ originalReferenceIds = getAriaReferenceIds(element, 'aria-describedby')
	            .filter(function (id) { return id.indexOf(CDK_DESCRIBEDBY_ID_PREFIX) != 0; });
	        element.setAttribute('aria-describedby', originalReferenceIds.join(' '));
	    };
	    /**
	     * Adds a message reference to the element using aria-describedby and increments the registered
	     * message's reference count.
	     * @param {?} element
	     * @param {?} message
	     * @return {?}
	     */
	    AriaDescriber.prototype._addMessageReference = /**
	     * Adds a message reference to the element using aria-describedby and increments the registered
	     * message's reference count.
	     * @param {?} element
	     * @param {?} message
	     * @return {?}
	     */
	    function (element, message) {
	        var /** @type {?} */ registeredMessage = /** @type {?} */ ((messageRegistry.get(message)));
	        // Add the aria-describedby reference and set the
	        // describedby_host attribute to mark the element.
	        addAriaReferencedId(element, 'aria-describedby', registeredMessage.messageElement.id);
	        element.setAttribute(CDK_DESCRIBEDBY_HOST_ATTRIBUTE, '');
	        registeredMessage.referenceCount++;
	    };
	    /**
	     * Removes a message reference from the element using aria-describedby
	     * and decrements the registered message's reference count.
	     * @param {?} element
	     * @param {?} message
	     * @return {?}
	     */
	    AriaDescriber.prototype._removeMessageReference = /**
	     * Removes a message reference from the element using aria-describedby
	     * and decrements the registered message's reference count.
	     * @param {?} element
	     * @param {?} message
	     * @return {?}
	     */
	    function (element, message) {
	        var /** @type {?} */ registeredMessage = /** @type {?} */ ((messageRegistry.get(message)));
	        registeredMessage.referenceCount--;
	        removeAriaReferencedId(element, 'aria-describedby', registeredMessage.messageElement.id);
	        element.removeAttribute(CDK_DESCRIBEDBY_HOST_ATTRIBUTE);
	    };
	    /**
	     * Returns true if the element has been described by the provided message ID.
	     * @param {?} element
	     * @param {?} message
	     * @return {?}
	     */
	    AriaDescriber.prototype._isElementDescribedByMessage = /**
	     * Returns true if the element has been described by the provided message ID.
	     * @param {?} element
	     * @param {?} message
	     * @return {?}
	     */
	    function (element, message) {
	        var /** @type {?} */ referenceIds = getAriaReferenceIds(element, 'aria-describedby');
	        var /** @type {?} */ registeredMessage = messageRegistry.get(message);
	        var /** @type {?} */ messageId = registeredMessage && registeredMessage.messageElement.id;
	        return !!messageId && referenceIds.indexOf(messageId) != -1;
	    };
	    /**
	     * Determines whether a message can be described on a particular element.
	     * @param {?} element
	     * @param {?} message
	     * @return {?}
	     */
	    AriaDescriber.prototype._canBeDescribed = /**
	     * Determines whether a message can be described on a particular element.
	     * @param {?} element
	     * @param {?} message
	     * @return {?}
	     */
	    function (element, message) {
	        return element.nodeType === this._document.ELEMENT_NODE && message != null &&
	            !!("" + message).trim();
	    };
	    AriaDescriber.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    AriaDescriber.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    return AriaDescriber;
	}());
	/**
	 * \@docs-private
	 * @param {?} parentDispatcher
	 * @param {?} _document
	 * @return {?}
	 */
	function ARIA_DESCRIBER_PROVIDER_FACTORY(parentDispatcher, _document) {
	    return parentDispatcher || new AriaDescriber(_document);
	}
	/**
	 * \@docs-private
	 */
	var ARIA_DESCRIBER_PROVIDER = {
	    // If there is already an AriaDescriber available, use that. Otherwise, provide a new one.
	    provide: AriaDescriber,
	    deps: [
	        [new _angular_core.Optional(), new _angular_core.SkipSelf(), AriaDescriber],
	        /** @type {?} */ (_angular_common.DOCUMENT)
	    ],
	    useFactory: ARIA_DESCRIBER_PROVIDER_FACTORY
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * This interface is for items that can be passed to a ListKeyManager.
	 * @record
	 */
	
	/**
	 * This class manages keyboard events for selectable lists. If you pass it a query list
	 * of items, it will set the active item correctly when arrow events occur.
	 */
	var ListKeyManager = /** @class */ (function () {
	    function ListKeyManager(_items) {
	        var _this = this;
	        this._items = _items;
	        this._activeItemIndex = -1;
	        this._wrap = false;
	        this._letterKeyStream = new rxjs_Subject.Subject();
	        this._typeaheadSubscription = rxjs_Subscription.Subscription.EMPTY;
	        this._vertical = true;
	        /**
	         * Predicate function that can be used to check whether an item should be skipped
	         * by the key manager. By default, disabled items are skipped.
	         */
	        this._skipPredicateFn = function (item) { return item.disabled; };
	        this._pressedLetters = [];
	        /**
	         * Stream that emits any time the TAB key is pressed, so components can react
	         * when focus is shifted off of the list.
	         */
	        this.tabOut = new rxjs_Subject.Subject();
	        /**
	         * Stream that emits whenever the active item of the list manager changes.
	         */
	        this.change = new rxjs_Subject.Subject();
	        _items.changes.subscribe(function (newItems) {
	            if (_this._activeItem) {
	                var /** @type {?} */ itemArray = newItems.toArray();
	                var /** @type {?} */ newIndex = itemArray.indexOf(_this._activeItem);
	                if (newIndex > -1 && newIndex !== _this._activeItemIndex) {
	                    _this._activeItemIndex = newIndex;
	                }
	            }
	        });
	    }
	    /**
	     * Sets the predicate function that determines which items should be skipped by the
	     * list key manager.
	     * @param predicate Function that determines whether the given item should be skipped.
	     */
	    /**
	     * Sets the predicate function that determines which items should be skipped by the
	     * list key manager.
	     * @param {?} predicate Function that determines whether the given item should be skipped.
	     * @return {?}
	     */
	    ListKeyManager.prototype.skipPredicate = /**
	     * Sets the predicate function that determines which items should be skipped by the
	     * list key manager.
	     * @param {?} predicate Function that determines whether the given item should be skipped.
	     * @return {?}
	     */
	    function (predicate) {
	        this._skipPredicateFn = predicate;
	        return this;
	    };
	    /**
	     * Turns on wrapping mode, which ensures that the active item will wrap to
	     * the other end of list when there are no more items in the given direction.
	     */
	    /**
	     * Turns on wrapping mode, which ensures that the active item will wrap to
	     * the other end of list when there are no more items in the given direction.
	     * @return {?}
	     */
	    ListKeyManager.prototype.withWrap = /**
	     * Turns on wrapping mode, which ensures that the active item will wrap to
	     * the other end of list when there are no more items in the given direction.
	     * @return {?}
	     */
	    function () {
	        this._wrap = true;
	        return this;
	    };
	    /**
	     * Configures whether the key manager should be able to move the selection vertically.
	     * @param enabled Whether vertical selection should be enabled.
	     */
	    /**
	     * Configures whether the key manager should be able to move the selection vertically.
	     * @param {?=} enabled Whether vertical selection should be enabled.
	     * @return {?}
	     */
	    ListKeyManager.prototype.withVerticalOrientation = /**
	     * Configures whether the key manager should be able to move the selection vertically.
	     * @param {?=} enabled Whether vertical selection should be enabled.
	     * @return {?}
	     */
	    function (enabled) {
	        if (enabled === void 0) { enabled = true; }
	        this._vertical = enabled;
	        return this;
	    };
	    /**
	     * Configures the key manager to move the selection horizontally.
	     * Passing in `null` will disable horizontal movement.
	     * @param direction Direction in which the selection can be moved.
	     */
	    /**
	     * Configures the key manager to move the selection horizontally.
	     * Passing in `null` will disable horizontal movement.
	     * @param {?} direction Direction in which the selection can be moved.
	     * @return {?}
	     */
	    ListKeyManager.prototype.withHorizontalOrientation = /**
	     * Configures the key manager to move the selection horizontally.
	     * Passing in `null` will disable horizontal movement.
	     * @param {?} direction Direction in which the selection can be moved.
	     * @return {?}
	     */
	    function (direction) {
	        this._horizontal = direction;
	        return this;
	    };
	    /**
	     * Turns on typeahead mode which allows users to set the active item by typing.
	     * @param debounceInterval Time to wait after the last keystroke before setting the active item.
	     */
	    /**
	     * Turns on typeahead mode which allows users to set the active item by typing.
	     * @param {?=} debounceInterval Time to wait after the last keystroke before setting the active item.
	     * @return {?}
	     */
	    ListKeyManager.prototype.withTypeAhead = /**
	     * Turns on typeahead mode which allows users to set the active item by typing.
	     * @param {?=} debounceInterval Time to wait after the last keystroke before setting the active item.
	     * @return {?}
	     */
	    function (debounceInterval) {
	        var _this = this;
	        if (debounceInterval === void 0) { debounceInterval = 200; }
	        if (this._items.length && this._items.some(function (item) { return typeof item.getLabel !== 'function'; })) {
	            throw Error('ListKeyManager items in typeahead mode must implement the `getLabel` method.');
	        }
	        this._typeaheadSubscription.unsubscribe();
	        // Debounce the presses of non-navigational keys, collect the ones that correspond to letters
	        // and convert those letters back into a string. Afterwards find the first item that starts
	        // with that string and select it.
	        this._typeaheadSubscription = this._letterKeyStream.pipe(rxjs_operators_tap.tap(function (keyCode) { return _this._pressedLetters.push(keyCode); }), rxjs_operators_debounceTime.debounceTime(debounceInterval), rxjs_operators_filter.filter(function () { return _this._pressedLetters.length > 0; }), rxjs_operators_map.map(function () { return _this._pressedLetters.join(''); })).subscribe(function (inputString) {
	            var /** @type {?} */ items = _this._items.toArray();
	            // Start at 1 because we want to start searching at the item immediately
	            // following the current active item.
	            for (var /** @type {?} */ i = 1; i < items.length + 1; i++) {
	                var /** @type {?} */ index = (_this._activeItemIndex + i) % items.length;
	                var /** @type {?} */ item = items[index];
	                if (!_this._skipPredicateFn(item) && /** @type {?} */ ((item.getLabel))().toUpperCase().trim().indexOf(inputString) === 0) {
	                    _this.setActiveItem(index);
	                    break;
	                }
	            }
	            _this._pressedLetters = [];
	        });
	        return this;
	    };
	    /**
	     * Sets the active item to the item at the index specified.
	     * @param index The index of the item to be set as active.
	     */
	    /**
	     * Sets the active item to the item at the index specified.
	     * @param {?} index The index of the item to be set as active.
	     * @return {?}
	     */
	    ListKeyManager.prototype.setActiveItem = /**
	     * Sets the active item to the item at the index specified.
	     * @param {?} index The index of the item to be set as active.
	     * @return {?}
	     */
	    function (index) {
	        var /** @type {?} */ previousIndex = this._activeItemIndex;
	        this._activeItemIndex = index;
	        this._activeItem = this._items.toArray()[index];
	        if (this._activeItemIndex !== previousIndex) {
	            this.change.next(index);
	        }
	    };
	    /**
	     * Sets the active item depending on the key event passed in.
	     * @param event Keyboard event to be used for determining which element should be active.
	     */
	    /**
	     * Sets the active item depending on the key event passed in.
	     * @param {?} event Keyboard event to be used for determining which element should be active.
	     * @return {?}
	     */
	    ListKeyManager.prototype.onKeydown = /**
	     * Sets the active item depending on the key event passed in.
	     * @param {?} event Keyboard event to be used for determining which element should be active.
	     * @return {?}
	     */
	    function (event) {
	        var /** @type {?} */ keyCode = event.keyCode;
	        switch (keyCode) {
	            case _angular_cdk_keycodes.TAB:
	                this.tabOut.next();
	                return;
	            case _angular_cdk_keycodes.DOWN_ARROW:
	                if (this._vertical) {
	                    this.setNextItemActive();
	                    break;
	                }
	                else {
	                    return;
	                }
	            case _angular_cdk_keycodes.UP_ARROW:
	                if (this._vertical) {
	                    this.setPreviousItemActive();
	                    break;
	                }
	                else {
	                    return;
	                }
	            case _angular_cdk_keycodes.RIGHT_ARROW:
	                if (this._horizontal === 'ltr') {
	                    this.setNextItemActive();
	                    break;
	                }
	                else if (this._horizontal === 'rtl') {
	                    this.setPreviousItemActive();
	                    break;
	                }
	                else {
	                    return;
	                }
	            case _angular_cdk_keycodes.LEFT_ARROW:
	                if (this._horizontal === 'ltr') {
	                    this.setPreviousItemActive();
	                    break;
	                }
	                else if (this._horizontal === 'rtl') {
	                    this.setNextItemActive();
	                    break;
	                }
	                else {
	                    return;
	                }
	            default:
	                // Attempt to use the `event.key` which also maps it to the user's keyboard language,
	                // otherwise fall back to resolving alphanumeric characters via the keyCode.
	                if (event.key && event.key.length === 1) {
	                    this._letterKeyStream.next(event.key.toLocaleUpperCase());
	                }
	                else if ((keyCode >= _angular_cdk_keycodes.A && keyCode <= _angular_cdk_keycodes.Z) || (keyCode >= _angular_cdk_keycodes.ZERO && keyCode <= _angular_cdk_keycodes.NINE)) {
	                    this._letterKeyStream.next(String.fromCharCode(keyCode));
	                }
	                // Note that we return here, in order to avoid preventing
	                // the default action of non-navigational keys.
	                return;
	        }
	        this._pressedLetters = [];
	        event.preventDefault();
	    };
	    Object.defineProperty(ListKeyManager.prototype, "activeItemIndex", {
	        /** Index of the currently active item. */
	        get: /**
	         * Index of the currently active item.
	         * @return {?}
	         */
	        function () {
	            return this._activeItemIndex;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ListKeyManager.prototype, "activeItem", {
	        /** The active item. */
	        get: /**
	         * The active item.
	         * @return {?}
	         */
	        function () {
	            return this._activeItem;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** Sets the active item to the first enabled item in the list. */
	    /**
	     * Sets the active item to the first enabled item in the list.
	     * @return {?}
	     */
	    ListKeyManager.prototype.setFirstItemActive = /**
	     * Sets the active item to the first enabled item in the list.
	     * @return {?}
	     */
	    function () {
	        this._setActiveItemByIndex(0, 1);
	    };
	    /** Sets the active item to the last enabled item in the list. */
	    /**
	     * Sets the active item to the last enabled item in the list.
	     * @return {?}
	     */
	    ListKeyManager.prototype.setLastItemActive = /**
	     * Sets the active item to the last enabled item in the list.
	     * @return {?}
	     */
	    function () {
	        this._setActiveItemByIndex(this._items.length - 1, -1);
	    };
	    /** Sets the active item to the next enabled item in the list. */
	    /**
	     * Sets the active item to the next enabled item in the list.
	     * @return {?}
	     */
	    ListKeyManager.prototype.setNextItemActive = /**
	     * Sets the active item to the next enabled item in the list.
	     * @return {?}
	     */
	    function () {
	        this._activeItemIndex < 0 ? this.setFirstItemActive() : this._setActiveItemByDelta(1);
	    };
	    /** Sets the active item to a previous enabled item in the list. */
	    /**
	     * Sets the active item to a previous enabled item in the list.
	     * @return {?}
	     */
	    ListKeyManager.prototype.setPreviousItemActive = /**
	     * Sets the active item to a previous enabled item in the list.
	     * @return {?}
	     */
	    function () {
	        this._activeItemIndex < 0 && this._wrap ? this.setLastItemActive()
	            : this._setActiveItemByDelta(-1);
	    };
	    /**
	     * Allows setting of the activeItemIndex without any other effects.
	     * @param index The new activeItemIndex.
	     */
	    /**
	     * Allows setting of the activeItemIndex without any other effects.
	     * @param {?} index The new activeItemIndex.
	     * @return {?}
	     */
	    ListKeyManager.prototype.updateActiveItemIndex = /**
	     * Allows setting of the activeItemIndex without any other effects.
	     * @param {?} index The new activeItemIndex.
	     * @return {?}
	     */
	    function (index) {
	        this._activeItemIndex = index;
	    };
	    /**
	     * This method sets the active item, given a list of items and the delta between the
	     * currently active item and the new active item. It will calculate differently
	     * depending on whether wrap mode is turned on.
	     * @param {?} delta
	     * @param {?=} items
	     * @return {?}
	     */
	    ListKeyManager.prototype._setActiveItemByDelta = /**
	     * This method sets the active item, given a list of items and the delta between the
	     * currently active item and the new active item. It will calculate differently
	     * depending on whether wrap mode is turned on.
	     * @param {?} delta
	     * @param {?=} items
	     * @return {?}
	     */
	    function (delta, items) {
	        if (items === void 0) { items = this._items.toArray(); }
	        this._wrap ? this._setActiveInWrapMode(delta, items)
	            : this._setActiveInDefaultMode(delta, items);
	    };
	    /**
	     * Sets the active item properly given "wrap" mode. In other words, it will continue to move
	     * down the list until it finds an item that is not disabled, and it will wrap if it
	     * encounters either end of the list.
	     * @param {?} delta
	     * @param {?} items
	     * @return {?}
	     */
	    ListKeyManager.prototype._setActiveInWrapMode = /**
	     * Sets the active item properly given "wrap" mode. In other words, it will continue to move
	     * down the list until it finds an item that is not disabled, and it will wrap if it
	     * encounters either end of the list.
	     * @param {?} delta
	     * @param {?} items
	     * @return {?}
	     */
	    function (delta, items) {
	        for (var /** @type {?} */ i = 1; i <= items.length; i++) {
	            var /** @type {?} */ index = (this._activeItemIndex + (delta * i) + items.length) % items.length;
	            var /** @type {?} */ item = items[index];
	            if (!this._skipPredicateFn(item)) {
	                this.setActiveItem(index);
	                return;
	            }
	        }
	    };
	    /**
	     * Sets the active item properly given the default mode. In other words, it will
	     * continue to move down the list until it finds an item that is not disabled. If
	     * it encounters either end of the list, it will stop and not wrap.
	     * @param {?} delta
	     * @param {?} items
	     * @return {?}
	     */
	    ListKeyManager.prototype._setActiveInDefaultMode = /**
	     * Sets the active item properly given the default mode. In other words, it will
	     * continue to move down the list until it finds an item that is not disabled. If
	     * it encounters either end of the list, it will stop and not wrap.
	     * @param {?} delta
	     * @param {?} items
	     * @return {?}
	     */
	    function (delta, items) {
	        this._setActiveItemByIndex(this._activeItemIndex + delta, delta, items);
	    };
	    /**
	     * Sets the active item to the first enabled item starting at the index specified. If the
	     * item is disabled, it will move in the fallbackDelta direction until it either
	     * finds an enabled item or encounters the end of the list.
	     * @param {?} index
	     * @param {?} fallbackDelta
	     * @param {?=} items
	     * @return {?}
	     */
	    ListKeyManager.prototype._setActiveItemByIndex = /**
	     * Sets the active item to the first enabled item starting at the index specified. If the
	     * item is disabled, it will move in the fallbackDelta direction until it either
	     * finds an enabled item or encounters the end of the list.
	     * @param {?} index
	     * @param {?} fallbackDelta
	     * @param {?=} items
	     * @return {?}
	     */
	    function (index, fallbackDelta, items) {
	        if (items === void 0) { items = this._items.toArray(); }
	        if (!items[index]) {
	            return;
	        }
	        while (this._skipPredicateFn(items[index])) {
	            index += fallbackDelta;
	            if (!items[index]) {
	                return;
	            }
	        }
	        this.setActiveItem(index);
	    };
	    return ListKeyManager;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * This is the interface for highlightable items (used by the ActiveDescendantKeyManager).
	 * Each item must know how to style itself as active or inactive and whether or not it is
	 * currently disabled.
	 * @record
	 */
	
	var ActiveDescendantKeyManager = /** @class */ (function (_super) {
	    __extends(ActiveDescendantKeyManager, _super);
	    function ActiveDescendantKeyManager() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * This method sets the active item to the item at the specified index.
	     * It also adds active styles to the newly active item and removes active
	     * styles from the previously active item.
	     */
	    /**
	     * This method sets the active item to the item at the specified index.
	     * It also adds active styles to the newly active item and removes active
	     * styles from the previously active item.
	     * @param {?} index
	     * @return {?}
	     */
	    ActiveDescendantKeyManager.prototype.setActiveItem = /**
	     * This method sets the active item to the item at the specified index.
	     * It also adds active styles to the newly active item and removes active
	     * styles from the previously active item.
	     * @param {?} index
	     * @return {?}
	     */
	    function (index) {
	        if (this.activeItem) {
	            this.activeItem.setInactiveStyles();
	        }
	        _super.prototype.setActiveItem.call(this, index);
	        if (this.activeItem) {
	            this.activeItem.setActiveStyles();
	        }
	    };
	    return ActiveDescendantKeyManager;
	}(ListKeyManager));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * This is the interface for focusable items (used by the FocusKeyManager).
	 * Each item must know how to focus itself, whether or not it is currently disabled
	 * and be able to supply it's label.
	 * @record
	 */
	
	var FocusKeyManager = /** @class */ (function (_super) {
	    __extends(FocusKeyManager, _super);
	    function FocusKeyManager() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._origin = 'program';
	        return _this;
	    }
	    /**
	     * Sets the focus origin that will be passed in to the items for any subsequent `focus` calls.
	     * @param origin Focus origin to be used when focusing items.
	     */
	    /**
	     * Sets the focus origin that will be passed in to the items for any subsequent `focus` calls.
	     * @param {?} origin Focus origin to be used when focusing items.
	     * @return {?}
	     */
	    FocusKeyManager.prototype.setFocusOrigin = /**
	     * Sets the focus origin that will be passed in to the items for any subsequent `focus` calls.
	     * @param {?} origin Focus origin to be used when focusing items.
	     * @return {?}
	     */
	    function (origin) {
	        this._origin = origin;
	        return this;
	    };
	    /**
	     * This method sets the active item to the item at the specified index.
	     * It also adds focuses the newly active item.
	     */
	    /**
	     * This method sets the active item to the item at the specified index.
	     * It also adds focuses the newly active item.
	     * @param {?} index
	     * @return {?}
	     */
	    FocusKeyManager.prototype.setActiveItem = /**
	     * This method sets the active item to the item at the specified index.
	     * It also adds focuses the newly active item.
	     * @param {?} index
	     * @return {?}
	     */
	    function (index) {
	        _super.prototype.setActiveItem.call(this, index);
	        if (this.activeItem) {
	            this.activeItem.focus(this._origin);
	        }
	    };
	    return FocusKeyManager;
	}(ListKeyManager));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var LIVE_ANNOUNCER_ELEMENT_TOKEN = new _angular_core.InjectionToken('liveAnnouncerElement');
	var LiveAnnouncer = /** @class */ (function () {
	    function LiveAnnouncer(elementToken, _document) {
	        this._document = _document;
	        // We inject the live element as `any` because the constructor signature cannot reference
	        // browser globals (HTMLElement) on non-browser environments, since having a class decorator
	        // causes TypeScript to preserve the constructor signature types.
	        this._liveElement = elementToken || this._createLiveElement();
	    }
	    /**
	     * Announces a message to screenreaders.
	     * @param message Message to be announced to the screenreader
	     * @param politeness The politeness of the announcer element
	     * @returns Promise that will be resolved when the message is added to the DOM.
	     */
	    /**
	     * Announces a message to screenreaders.
	     * @param {?} message Message to be announced to the screenreader
	     * @param {?=} politeness The politeness of the announcer element
	     * @return {?} Promise that will be resolved when the message is added to the DOM.
	     */
	    LiveAnnouncer.prototype.announce = /**
	     * Announces a message to screenreaders.
	     * @param {?} message Message to be announced to the screenreader
	     * @param {?=} politeness The politeness of the announcer element
	     * @return {?} Promise that will be resolved when the message is added to the DOM.
	     */
	    function (message, politeness) {
	        var _this = this;
	        if (politeness === void 0) { politeness = 'polite'; }
	        this._liveElement.textContent = '';
	        // TODO: ensure changing the politeness works on all environments we support.
	        this._liveElement.setAttribute('aria-live', politeness);
	        // This 100ms timeout is necessary for some browser + screen-reader combinations:
	        // - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
	        // - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
	        //   second time without clearing and then using a non-zero delay.
	        // (using JAWS 17 at time of this writing).
	        return new Promise(function (resolve) {
	            setTimeout(function () {
	                _this._liveElement.textContent = message;
	                resolve();
	            }, 100);
	        });
	    };
	    /**
	     * @return {?}
	     */
	    LiveAnnouncer.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        if (this._liveElement && this._liveElement.parentNode) {
	            this._liveElement.parentNode.removeChild(this._liveElement);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    LiveAnnouncer.prototype._createLiveElement = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ liveEl = this._document.createElement('div');
	        liveEl.classList.add('cdk-visually-hidden');
	        liveEl.setAttribute('aria-atomic', 'true');
	        liveEl.setAttribute('aria-live', 'polite');
	        this._document.body.appendChild(liveEl);
	        return liveEl;
	    };
	    LiveAnnouncer.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    LiveAnnouncer.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [LIVE_ANNOUNCER_ELEMENT_TOKEN,] },] },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    return LiveAnnouncer;
	}());
	/**
	 * \@docs-private
	 * @param {?} parentDispatcher
	 * @param {?} liveElement
	 * @param {?} _document
	 * @return {?}
	 */
	function LIVE_ANNOUNCER_PROVIDER_FACTORY(parentDispatcher, liveElement, _document) {
	    return parentDispatcher || new LiveAnnouncer(liveElement, _document);
	}
	/**
	 * \@docs-private
	 */
	var LIVE_ANNOUNCER_PROVIDER = {
	    // If there is already a LiveAnnouncer available, use that. Otherwise, provide a new one.
	    provide: LiveAnnouncer,
	    deps: [
	        [new _angular_core.Optional(), new _angular_core.SkipSelf(), LiveAnnouncer],
	        [new _angular_core.Optional(), new _angular_core.Inject(LIVE_ANNOUNCER_ELEMENT_TOKEN)],
	        _angular_common.DOCUMENT,
	    ],
	    useFactory: LIVE_ANNOUNCER_PROVIDER_FACTORY
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	// This is the value used by AngularJS Material. Through trial and error (on iPhone 6S) they found
	// that a value of around 650ms seems appropriate.
	var TOUCH_BUFFER_MS = 650;
	/**
	 * Monitors mouse and keyboard events to determine the cause of focus events.
	 */
	var FocusMonitor = /** @class */ (function () {
	    function FocusMonitor(_ngZone, _platform) {
	        this._ngZone = _ngZone;
	        this._platform = _platform;
	        /**
	         * The focus origin that the next focus event is a result of.
	         */
	        this._origin = null;
	        /**
	         * Whether the window has just been focused.
	         */
	        this._windowFocused = false;
	        /**
	         * Map of elements being monitored to their info.
	         */
	        this._elementInfo = new Map();
	        /**
	         * A map of global objects to lists of current listeners.
	         */
	        this._unregisterGlobalListeners = function () { };
	        /**
	         * The number of elements currently being monitored.
	         */
	        this._monitoredElementCount = 0;
	    }
	    /**
	     * @param {?} element
	     * @param {?=} renderer
	     * @param {?=} checkChildren
	     * @return {?}
	     */
	    FocusMonitor.prototype.monitor = /**
	     * @param {?} element
	     * @param {?=} renderer
	     * @param {?=} checkChildren
	     * @return {?}
	     */
	    function (element, renderer, checkChildren) {
	        var _this = this;
	        // TODO(mmalerba): clean up after deprecated signature is removed.
	        if (!(renderer instanceof _angular_core.Renderer2)) {
	            checkChildren = renderer;
	        }
	        checkChildren = !!checkChildren;
	        // Do nothing if we're not on the browser platform.
	        if (!this._platform.isBrowser) {
	            return rxjs_observable_of.of(null);
	        }
	        // Check if we're already monitoring this element.
	        if (this._elementInfo.has(element)) {
	            var /** @type {?} */ cachedInfo = this._elementInfo.get(element); /** @type {?} */
	            ((cachedInfo)).checkChildren = checkChildren;
	            return /** @type {?} */ ((cachedInfo)).subject.asObservable();
	        }
	        // Create monitored element info.
	        var /** @type {?} */ info = {
	            unlisten: function () { },
	            checkChildren: checkChildren,
	            subject: new rxjs_Subject.Subject()
	        };
	        this._elementInfo.set(element, info);
	        this._incrementMonitoredElementCount();
	        // Start listening. We need to listen in capture phase since focus events don't bubble.
	        var /** @type {?} */ focusListener = function (event) { return _this._onFocus(event, element); };
	        var /** @type {?} */ blurListener = function (event) { return _this._onBlur(event, element); };
	        this._ngZone.runOutsideAngular(function () {
	            element.addEventListener('focus', focusListener, true);
	            element.addEventListener('blur', blurListener, true);
	        });
	        // Create an unlisten function for later.
	        info.unlisten = function () {
	            element.removeEventListener('focus', focusListener, true);
	            element.removeEventListener('blur', blurListener, true);
	        };
	        return info.subject.asObservable();
	    };
	    /**
	     * Stops monitoring an element and removes all focus classes.
	     * @param element The element to stop monitoring.
	     */
	    /**
	     * Stops monitoring an element and removes all focus classes.
	     * @param {?} element The element to stop monitoring.
	     * @return {?}
	     */
	    FocusMonitor.prototype.stopMonitoring = /**
	     * Stops monitoring an element and removes all focus classes.
	     * @param {?} element The element to stop monitoring.
	     * @return {?}
	     */
	    function (element) {
	        var /** @type {?} */ elementInfo = this._elementInfo.get(element);
	        if (elementInfo) {
	            elementInfo.unlisten();
	            elementInfo.subject.complete();
	            this._setClasses(element);
	            this._elementInfo.delete(element);
	            this._decrementMonitoredElementCount();
	        }
	    };
	    /**
	     * Focuses the element via the specified focus origin.
	     * @param element The element to focus.
	     * @param origin The focus origin.
	     */
	    /**
	     * Focuses the element via the specified focus origin.
	     * @param {?} element The element to focus.
	     * @param {?} origin The focus origin.
	     * @return {?}
	     */
	    FocusMonitor.prototype.focusVia = /**
	     * Focuses the element via the specified focus origin.
	     * @param {?} element The element to focus.
	     * @param {?} origin The focus origin.
	     * @return {?}
	     */
	    function (element, origin) {
	        this._setOriginForCurrentEventQueue(origin);
	        element.focus();
	    };
	    /**
	     * @return {?}
	     */
	    FocusMonitor.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._elementInfo.forEach(function (_info, element) { return _this.stopMonitoring(element); });
	    };
	    /**
	     * Register necessary event listeners on the document and window.
	     * @return {?}
	     */
	    FocusMonitor.prototype._registerGlobalListeners = /**
	     * Register necessary event listeners on the document and window.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        // Do nothing if we're not on the browser platform.
	        if (!this._platform.isBrowser) {
	            return;
	        }
	        // On keydown record the origin and clear any touch event that may be in progress.
	        var /** @type {?} */ documentKeydownListener = function () {
	            _this._lastTouchTarget = null;
	            _this._setOriginForCurrentEventQueue('keyboard');
	        };
	        // On mousedown record the origin only if there is not touch target, since a mousedown can
	        // happen as a result of a touch event.
	        var /** @type {?} */ documentMousedownListener = function () {
	            if (!_this._lastTouchTarget) {
	                _this._setOriginForCurrentEventQueue('mouse');
	            }
	        };
	        // When the touchstart event fires the focus event is not yet in the event queue. This means
	        // we can't rely on the trick used above (setting timeout of 0ms). Instead we wait 650ms to
	        // see if a focus happens.
	        var /** @type {?} */ documentTouchstartListener = function (event) {
	            if (_this._touchTimeoutId != null) {
	                clearTimeout(_this._touchTimeoutId);
	            }
	            _this._lastTouchTarget = event.target;
	            _this._touchTimeoutId = setTimeout(function () { return _this._lastTouchTarget = null; }, TOUCH_BUFFER_MS);
	        };
	        // Make a note of when the window regains focus, so we can restore the origin info for the
	        // focused element.
	        var /** @type {?} */ windowFocusListener = function () {
	            _this._windowFocused = true;
	            _this._windowFocusTimeoutId = setTimeout(function () { return _this._windowFocused = false; }, 0);
	        };
	        // Note: we listen to events in the capture phase so we can detect them even if the user stops
	        // propagation.
	        this._ngZone.runOutsideAngular(function () {
	            document.addEventListener('keydown', documentKeydownListener, true);
	            document.addEventListener('mousedown', documentMousedownListener, true);
	            document.addEventListener('touchstart', documentTouchstartListener, _angular_cdk_platform.supportsPassiveEventListeners() ? (/** @type {?} */ ({ passive: true, capture: true })) : true);
	            window.addEventListener('focus', windowFocusListener);
	        });
	        this._unregisterGlobalListeners = function () {
	            document.removeEventListener('keydown', documentKeydownListener, true);
	            document.removeEventListener('mousedown', documentMousedownListener, true);
	            document.removeEventListener('touchstart', documentTouchstartListener, _angular_cdk_platform.supportsPassiveEventListeners() ? (/** @type {?} */ ({ passive: true, capture: true })) : true);
	            window.removeEventListener('focus', windowFocusListener);
	            // Clear timeouts for all potentially pending timeouts to prevent the leaks.
	            clearTimeout(_this._windowFocusTimeoutId);
	            clearTimeout(_this._touchTimeoutId);
	            clearTimeout(_this._originTimeoutId);
	        };
	    };
	    /**
	     * @param {?} element
	     * @param {?} className
	     * @param {?} shouldSet
	     * @return {?}
	     */
	    FocusMonitor.prototype._toggleClass = /**
	     * @param {?} element
	     * @param {?} className
	     * @param {?} shouldSet
	     * @return {?}
	     */
	    function (element, className, shouldSet) {
	        if (shouldSet) {
	            element.classList.add(className);
	        }
	        else {
	            element.classList.remove(className);
	        }
	    };
	    /**
	     * Sets the focus classes on the element based on the given focus origin.
	     * @param {?} element The element to update the classes on.
	     * @param {?=} origin The focus origin.
	     * @return {?}
	     */
	    FocusMonitor.prototype._setClasses = /**
	     * Sets the focus classes on the element based on the given focus origin.
	     * @param {?} element The element to update the classes on.
	     * @param {?=} origin The focus origin.
	     * @return {?}
	     */
	    function (element, origin) {
	        var /** @type {?} */ elementInfo = this._elementInfo.get(element);
	        if (elementInfo) {
	            this._toggleClass(element, 'cdk-focused', !!origin);
	            this._toggleClass(element, 'cdk-touch-focused', origin === 'touch');
	            this._toggleClass(element, 'cdk-keyboard-focused', origin === 'keyboard');
	            this._toggleClass(element, 'cdk-mouse-focused', origin === 'mouse');
	            this._toggleClass(element, 'cdk-program-focused', origin === 'program');
	        }
	    };
	    /**
	     * Sets the origin and schedules an async function to clear it at the end of the event queue.
	     * @param {?} origin The origin to set.
	     * @return {?}
	     */
	    FocusMonitor.prototype._setOriginForCurrentEventQueue = /**
	     * Sets the origin and schedules an async function to clear it at the end of the event queue.
	     * @param {?} origin The origin to set.
	     * @return {?}
	     */
	    function (origin) {
	        var _this = this;
	        this._origin = origin;
	        this._originTimeoutId = setTimeout(function () { return _this._origin = null; }, 0);
	    };
	    /**
	     * Checks whether the given focus event was caused by a touchstart event.
	     * @param {?} event The focus event to check.
	     * @return {?} Whether the event was caused by a touch.
	     */
	    FocusMonitor.prototype._wasCausedByTouch = /**
	     * Checks whether the given focus event was caused by a touchstart event.
	     * @param {?} event The focus event to check.
	     * @return {?} Whether the event was caused by a touch.
	     */
	    function (event) {
	        // Note(mmalerba): This implementation is not quite perfect, there is a small edge case.
	        // Consider the following dom structure:
	        //
	        // <div #parent tabindex="0" cdkFocusClasses>
	        //   <div #child (click)="#parent.focus()"></div>
	        // </div>
	        //
	        // If the user touches the #child element and the #parent is programmatically focused as a
	        // result, this code will still consider it to have been caused by the touch event and will
	        // apply the cdk-touch-focused class rather than the cdk-program-focused class. This is a
	        // relatively small edge-case that can be worked around by using
	        // focusVia(parentEl, 'program') to focus the parent element.
	        //
	        // If we decide that we absolutely must handle this case correctly, we can do so by listening
	        // for the first focus event after the touchstart, and then the first blur event after that
	        // focus event. When that blur event fires we know that whatever follows is not a result of the
	        // touchstart.
	        var /** @type {?} */ focusTarget = event.target;
	        return this._lastTouchTarget instanceof Node && focusTarget instanceof Node &&
	            (focusTarget === this._lastTouchTarget || focusTarget.contains(this._lastTouchTarget));
	    };
	    /**
	     * Handles focus events on a registered element.
	     * @param {?} event The focus event.
	     * @param {?} element The monitored element.
	     * @return {?}
	     */
	    FocusMonitor.prototype._onFocus = /**
	     * Handles focus events on a registered element.
	     * @param {?} event The focus event.
	     * @param {?} element The monitored element.
	     * @return {?}
	     */
	    function (event, element) {
	        // NOTE(mmalerba): We currently set the classes based on the focus origin of the most recent
	        // focus event affecting the monitored element. If we want to use the origin of the first event
	        // instead we should check for the cdk-focused class here and return if the element already has
	        // it. (This only matters for elements that have includesChildren = true).
	        // If we are not counting child-element-focus as focused, make sure that the event target is the
	        // monitored element itself.
	        var /** @type {?} */ elementInfo = this._elementInfo.get(element);
	        if (!elementInfo || (!elementInfo.checkChildren && element !== event.target)) {
	            return;
	        }
	        // If we couldn't detect a cause for the focus event, it's due to one of three reasons:
	        // 1) The window has just regained focus, in which case we want to restore the focused state of
	        //    the element from before the window blurred.
	        // 2) It was caused by a touch event, in which case we mark the origin as 'touch'.
	        // 3) The element was programmatically focused, in which case we should mark the origin as
	        //    'program'.
	        if (!this._origin) {
	            if (this._windowFocused && this._lastFocusOrigin) {
	                this._origin = this._lastFocusOrigin;
	            }
	            else if (this._wasCausedByTouch(event)) {
	                this._origin = 'touch';
	            }
	            else {
	                this._origin = 'program';
	            }
	        }
	        this._setClasses(element, this._origin);
	        elementInfo.subject.next(this._origin);
	        this._lastFocusOrigin = this._origin;
	        this._origin = null;
	    };
	    /**
	     * Handles blur events on a registered element.
	     * @param event The blur event.
	     * @param element The monitored element.
	     */
	    /**
	     * Handles blur events on a registered element.
	     * @param {?} event The blur event.
	     * @param {?} element The monitored element.
	     * @return {?}
	     */
	    FocusMonitor.prototype._onBlur = /**
	     * Handles blur events on a registered element.
	     * @param {?} event The blur event.
	     * @param {?} element The monitored element.
	     * @return {?}
	     */
	    function (event, element) {
	        // If we are counting child-element-focus as focused, make sure that we aren't just blurring in
	        // order to focus another child of the monitored element.
	        var /** @type {?} */ elementInfo = this._elementInfo.get(element);
	        if (!elementInfo || (elementInfo.checkChildren && event.relatedTarget instanceof Node &&
	            element.contains(event.relatedTarget))) {
	            return;
	        }
	        this._setClasses(element);
	        elementInfo.subject.next(null);
	    };
	    /**
	     * @return {?}
	     */
	    FocusMonitor.prototype._incrementMonitoredElementCount = /**
	     * @return {?}
	     */
	    function () {
	        // Register global listeners when first element is monitored.
	        if (++this._monitoredElementCount == 1) {
	            this._registerGlobalListeners();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    FocusMonitor.prototype._decrementMonitoredElementCount = /**
	     * @return {?}
	     */
	    function () {
	        // Unregister global listeners when last element is unmonitored.
	        if (!--this._monitoredElementCount) {
	            this._unregisterGlobalListeners();
	            this._unregisterGlobalListeners = function () { };
	        }
	    };
	    FocusMonitor.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    FocusMonitor.ctorParameters = function () { return [
	        { type: _angular_core.NgZone, },
	        { type: _angular_cdk_platform.Platform, },
	    ]; };
	    return FocusMonitor;
	}());
	/**
	 * Directive that determines how a particular element was focused (via keyboard, mouse, touch, or
	 * programmatically) and adds corresponding classes to the element.
	 *
	 * There are two variants of this directive:
	 * 1) cdkMonitorElementFocus: does not consider an element to be focused if one of its children is
	 *    focused.
	 * 2) cdkMonitorSubtreeFocus: considers an element focused if it or any of its children are focused.
	 */
	var CdkMonitorFocus = /** @class */ (function () {
	    function CdkMonitorFocus(_elementRef, _focusMonitor) {
	        var _this = this;
	        this._elementRef = _elementRef;
	        this._focusMonitor = _focusMonitor;
	        this.cdkFocusChange = new _angular_core.EventEmitter();
	        this._monitorSubscription = this._focusMonitor.monitor(this._elementRef.nativeElement, this._elementRef.nativeElement.hasAttribute('cdkMonitorSubtreeFocus'))
	            .subscribe(function (origin) { return _this.cdkFocusChange.emit(origin); });
	    }
	    /**
	     * @return {?}
	     */
	    CdkMonitorFocus.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._focusMonitor.stopMonitoring(this._elementRef.nativeElement);
	        this._monitorSubscription.unsubscribe();
	    };
	    CdkMonitorFocus.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]',
	                },] },
	    ];
	    /** @nocollapse */
	    CdkMonitorFocus.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: FocusMonitor, },
	    ]; };
	    CdkMonitorFocus.propDecorators = {
	        "cdkFocusChange": [{ type: _angular_core.Output },],
	    };
	    return CdkMonitorFocus;
	}());
	/**
	 * \@docs-private
	 * @param {?} parentDispatcher
	 * @param {?} ngZone
	 * @param {?} platform
	 * @return {?}
	 */
	function FOCUS_MONITOR_PROVIDER_FACTORY(parentDispatcher, ngZone, platform) {
	    return parentDispatcher || new FocusMonitor(ngZone, platform);
	}
	/**
	 * \@docs-private
	 */
	var FOCUS_MONITOR_PROVIDER = {
	    // If there is already a FocusMonitor available, use that. Otherwise, provide a new one.
	    provide: FocusMonitor,
	    deps: [[new _angular_core.Optional(), new _angular_core.SkipSelf(), FocusMonitor], _angular_core.NgZone, _angular_cdk_platform.Platform],
	    useFactory: FOCUS_MONITOR_PROVIDER_FACTORY
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Screenreaders will often fire fake mousedown events when a focusable element
	 * is activated using the keyboard. We can typically distinguish between these faked
	 * mousedown events and real mousedown events using the "buttons" property. While
	 * real mousedowns will indicate the mouse button that was pressed (e.g. "1" for
	 * the left mouse button), faked mousedowns will usually set the property value to 0.
	 * @param {?} event
	 * @return {?}
	 */
	function isFakeMousedownFromScreenReader(event) {
	    return event.buttons === 0;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var A11yModule = /** @class */ (function () {
	    function A11yModule() {
	    }
	    A11yModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [_angular_common.CommonModule, _angular_cdk_platform.PlatformModule],
	                    declarations: [CdkTrapFocus, FocusTrapDeprecatedDirective, CdkMonitorFocus],
	                    exports: [CdkTrapFocus, FocusTrapDeprecatedDirective, CdkMonitorFocus],
	                    providers: [
	                        InteractivityChecker,
	                        FocusTrapFactory,
	                        AriaDescriber,
	                        LIVE_ANNOUNCER_PROVIDER,
	                        ARIA_DESCRIBER_PROVIDER,
	                        FOCUS_MONITOR_PROVIDER,
	                    ]
	                },] },
	    ];
	    /** @nocollapse */
	    A11yModule.ctorParameters = function () { return []; };
	    return A11yModule;
	}());
	
	exports.FocusTrapDirective = CdkTrapFocus;
	exports.MESSAGES_CONTAINER_ID = MESSAGES_CONTAINER_ID;
	exports.CDK_DESCRIBEDBY_ID_PREFIX = CDK_DESCRIBEDBY_ID_PREFIX;
	exports.CDK_DESCRIBEDBY_HOST_ATTRIBUTE = CDK_DESCRIBEDBY_HOST_ATTRIBUTE;
	exports.AriaDescriber = AriaDescriber;
	exports.ARIA_DESCRIBER_PROVIDER_FACTORY = ARIA_DESCRIBER_PROVIDER_FACTORY;
	exports.ARIA_DESCRIBER_PROVIDER = ARIA_DESCRIBER_PROVIDER;
	exports.ActiveDescendantKeyManager = ActiveDescendantKeyManager;
	exports.FocusKeyManager = FocusKeyManager;
	exports.ListKeyManager = ListKeyManager;
	exports.FocusTrap = FocusTrap;
	exports.FocusTrapFactory = FocusTrapFactory;
	exports.FocusTrapDeprecatedDirective = FocusTrapDeprecatedDirective;
	exports.CdkTrapFocus = CdkTrapFocus;
	exports.InteractivityChecker = InteractivityChecker;
	exports.LIVE_ANNOUNCER_ELEMENT_TOKEN = LIVE_ANNOUNCER_ELEMENT_TOKEN;
	exports.LiveAnnouncer = LiveAnnouncer;
	exports.LIVE_ANNOUNCER_PROVIDER_FACTORY = LIVE_ANNOUNCER_PROVIDER_FACTORY;
	exports.LIVE_ANNOUNCER_PROVIDER = LIVE_ANNOUNCER_PROVIDER;
	exports.TOUCH_BUFFER_MS = TOUCH_BUFFER_MS;
	exports.FocusMonitor = FocusMonitor;
	exports.CdkMonitorFocus = CdkMonitorFocus;
	exports.FOCUS_MONITOR_PROVIDER_FACTORY = FOCUS_MONITOR_PROVIDER_FACTORY;
	exports.FOCUS_MONITOR_PROVIDER = FOCUS_MONITOR_PROVIDER;
	exports.isFakeMousedownFromScreenReader = isFakeMousedownFromScreenReader;
	exports.A11yModule = A11yModule;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=cdk-a11y.umd.js.map


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(1077), __webpack_require__(240), __webpack_require__(428)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@angular/cdk/coercion', 'rxjs/Subject', 'rxjs/operators/debounceTime'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.cdk = global.ng.cdk || {}, global.ng.cdk.observers = global.ng.cdk.observers || {}),global.ng.core,global.ng.cdk.coercion,global.Rx,global.Rx.operators));
	}(this, (function (exports,_angular_core,_angular_cdk_coercion,rxjs_Subject,rxjs_operators_debounceTime) { 'use strict';
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Factory that creates a new MutationObserver and allows us to stub it out in unit tests.
	 * \@docs-private
	 */
	var MutationObserverFactory = /** @class */ (function () {
	    function MutationObserverFactory() {
	    }
	    /**
	     * @param {?} callback
	     * @return {?}
	     */
	    MutationObserverFactory.prototype.create = /**
	     * @param {?} callback
	     * @return {?}
	     */
	    function (callback) {
	        return typeof MutationObserver === 'undefined' ? null : new MutationObserver(callback);
	    };
	    MutationObserverFactory.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    MutationObserverFactory.ctorParameters = function () { return []; };
	    return MutationObserverFactory;
	}());
	/**
	 * Directive that triggers a callback whenever the content of
	 * its associated element has changed.
	 */
	var CdkObserveContent = /** @class */ (function () {
	    function CdkObserveContent(_mutationObserverFactory, _elementRef, _ngZone) {
	        this._mutationObserverFactory = _mutationObserverFactory;
	        this._elementRef = _elementRef;
	        this._ngZone = _ngZone;
	        this._disabled = false;
	        /**
	         * Event emitted for each change in the element's content.
	         */
	        this.event = new _angular_core.EventEmitter();
	        /**
	         * Used for debouncing the emitted values to the observeContent event.
	         */
	        this._debouncer = new rxjs_Subject.Subject();
	    }
	    Object.defineProperty(CdkObserveContent.prototype, "disabled", {
	        get: /**
	         * Whether observing content is disabled. This option can be used
	         * to disconnect the underlying MutationObserver until it is needed.
	         * @return {?}
	         */
	        function () { return this._disabled; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._disabled = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    CdkObserveContent.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this.debounce > 0) {
	            this._ngZone.runOutsideAngular(function () {
	                _this._debouncer.pipe(rxjs_operators_debounceTime.debounceTime(_this.debounce))
	                    .subscribe(function (mutations) { return _this.event.emit(mutations); });
	            });
	        }
	        else {
	            this._debouncer.subscribe(function (mutations) { return _this.event.emit(mutations); });
	        }
	        this._observer = this._ngZone.runOutsideAngular(function () {
	            return _this._mutationObserverFactory.create(function (mutations) {
	                _this._debouncer.next(mutations);
	            });
	        });
	        if (!this.disabled) {
	            this._enable();
	        }
	    };
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    CdkObserveContent.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        if (changes['disabled']) {
	            changes['disabled'].currentValue ? this._disable() : this._enable();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    CdkObserveContent.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._disable();
	        this._debouncer.complete();
	    };
	    /**
	     * @return {?}
	     */
	    CdkObserveContent.prototype._disable = /**
	     * @return {?}
	     */
	    function () {
	        if (this._observer) {
	            this._observer.disconnect();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    CdkObserveContent.prototype._enable = /**
	     * @return {?}
	     */
	    function () {
	        if (this._observer) {
	            this._observer.observe(this._elementRef.nativeElement, {
	                characterData: true,
	                childList: true,
	                subtree: true
	            });
	        }
	    };
	    CdkObserveContent.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[cdkObserveContent]',
	                    exportAs: 'cdkObserveContent',
	                },] },
	    ];
	    /** @nocollapse */
	    CdkObserveContent.ctorParameters = function () { return [
	        { type: MutationObserverFactory, },
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.NgZone, },
	    ]; };
	    CdkObserveContent.propDecorators = {
	        "event": [{ type: _angular_core.Output, args: ['cdkObserveContent',] },],
	        "disabled": [{ type: _angular_core.Input, args: ['cdkObserveContentDisabled',] },],
	        "debounce": [{ type: _angular_core.Input },],
	    };
	    return CdkObserveContent;
	}());
	var ObserversModule = /** @class */ (function () {
	    function ObserversModule() {
	    }
	    ObserversModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    exports: [CdkObserveContent],
	                    declarations: [CdkObserveContent],
	                    providers: [MutationObserverFactory]
	                },] },
	    ];
	    /** @nocollapse */
	    ObserversModule.ctorParameters = function () { return []; };
	    return ObserversModule;
	}());
	
	exports.ObserveContent = CdkObserveContent;
	exports.MutationObserverFactory = MutationObserverFactory;
	exports.CdkObserveContent = CdkObserveContent;
	exports.ObserversModule = ObserversModule;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=cdk-observers.umd.js.map


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var rxjs_1 = __webpack_require__(304);
	var ChosenCategoryService = (function () {
	    function ChosenCategoryService() {
	        this.categorySelected = new rxjs_1.Subject();
	        this.categoryDeSelected = new rxjs_1.Subject();
	        this.categoryDeleted = new rxjs_1.Subject();
	        this.categoriesLoaded = new rxjs_1.BehaviorSubject(undefined);
	        this.loadedCategories = [];
	        this.selectedCategoryEvent = this.categorySelected.asObservable();
	        this.deSelectedCategoryEvent = this.categoryDeSelected.asObservable();
	        this.categoryDeletedEvent = this.categoryDeleted.asObservable();
	        this.categoriesLoadedEvent = this.categoriesLoaded.asObservable();
	    }
	    ChosenCategoryService.prototype.selected = function (category) {
	        this.categorySelected.next(category);
	        this.loadedCategories.push(category);
	        this.categoriesLoaded.next(this.loadedCategories);
	    };
	    ChosenCategoryService.prototype.unSelected = function (category) {
	        this.categoryDeSelected.next(category);
	        this.loadedCategories = this.loadedCategories.filter(function (item) { return category.id != item.id; });
	        this.categoriesLoaded.next(this.loadedCategories);
	    };
	    ChosenCategoryService.prototype.deleted = function (category) {
	        this.categoryDeleted.next(category);
	        this.loadedCategories = this.loadedCategories.filter(function (item) { return category.id != item.id; });
	        this.categoriesLoaded.next(this.loadedCategories);
	    };
	    ChosenCategoryService.prototype.loaded = function (categories) {
	        var _this = this;
	        this.categoriesLoaded.next(categories);
	        categories.forEach(function (category) {
	            _this.loadedCategories.push(category);
	        });
	    };
	    ChosenCategoryService = __decorate([
	        core_1.Injectable()
	    ], ChosenCategoryService);
	    return ChosenCategoryService;
	}());
	exports.ChosenCategoryService = ChosenCategoryService;


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(205), __webpack_require__(246), __webpack_require__(768), __webpack_require__(462), __webpack_require__(271), __webpack_require__(206), __webpack_require__(495), __webpack_require__(373), __webpack_require__(442), __webpack_require__(274), __webpack_require__(521), __webpack_require__(384), __webpack_require__(569), __webpack_require__(240), __webpack_require__(370), __webpack_require__(325), __webpack_require__(426), __webpack_require__(609), __webpack_require__(508), __webpack_require__(643));
		else if(typeof define === 'function' && define.amd)
			define(["@angular/core", "@angular/common", "@angular/forms", "rxjs/add/operator/filter", "rxjs/BehaviorSubject", "rxjs/Observable", "rxjs/add/operator/map", "rxjs/util/isDate", "rxjs/operator/distinctUntilChanged", "rxjs/operator/map", "rxjs/operator/observeOn", "rxjs/scheduler/queue", "rxjs/operator/scan", "rxjs/Subject", "rxjs/add/observable/timer", "rxjs/add/observable/from", "rxjs/add/operator/debounceTime", "rxjs/add/operator/switchMap", "rxjs/add/operator/mergeMap", "rxjs/add/operator/toArray"], factory);
		else if(typeof exports === 'object')
			exports["ngx-bootstrap.umd"] = factory(require("@angular/core"), require("@angular/common"), require("@angular/forms"), require("rxjs/add/operator/filter"), require("rxjs/BehaviorSubject"), require("rxjs/Observable"), require("rxjs/add/operator/map"), require("rxjs/util/isDate"), require("rxjs/operator/distinctUntilChanged"), require("rxjs/operator/map"), require("rxjs/operator/observeOn"), require("rxjs/scheduler/queue"), require("rxjs/operator/scan"), require("rxjs/Subject"), require("rxjs/add/observable/timer"), require("rxjs/add/observable/from"), require("rxjs/add/operator/debounceTime"), require("rxjs/add/operator/switchMap"), require("rxjs/add/operator/mergeMap"), require("rxjs/add/operator/toArray"));
		else
			root["ngx-bootstrap.umd"] = factory(root["@angular/core"], root["@angular/common"], root["@angular/forms"], root["rxjs/add/operator/filter"], root["rxjs/BehaviorSubject"], root["rxjs/Observable"], root["rxjs/add/operator/map"], root["rxjs/util/isDate"], root["rxjs/operator/distinctUntilChanged"], root["rxjs/operator/map"], root["rxjs/operator/observeOn"], root["rxjs/scheduler/queue"], root["rxjs/operator/scan"], root["rxjs/Subject"], root["rxjs/add/observable/timer"], root["rxjs/add/observable/from"], root["rxjs/add/operator/debounceTime"], root["rxjs/add/operator/switchMap"], root["rxjs/add/operator/mergeMap"], root["rxjs/add/operator/toArray"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_37__, __WEBPACK_EXTERNAL_MODULE_38__, __WEBPACK_EXTERNAL_MODULE_66__, __WEBPACK_EXTERNAL_MODULE_113__, __WEBPACK_EXTERNAL_MODULE_146__, __WEBPACK_EXTERNAL_MODULE_175__, __WEBPACK_EXTERNAL_MODULE_176__, __WEBPACK_EXTERNAL_MODULE_178__, __WEBPACK_EXTERNAL_MODULE_179__, __WEBPACK_EXTERNAL_MODULE_180__, __WEBPACK_EXTERNAL_MODULE_212__, __WEBPACK_EXTERNAL_MODULE_221__, __WEBPACK_EXTERNAL_MODULE_225__, __WEBPACK_EXTERNAL_MODULE_226__, __WEBPACK_EXTERNAL_MODULE_227__, __WEBPACK_EXTERNAL_MODULE_228__, __WEBPACK_EXTERNAL_MODULE_229__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 139);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["i"] = isString;
	/* harmony export (immutable) */ __webpack_exports__["c"] = isDate;
	/* unused harmony export isBoolean */
	/* harmony export (immutable) */ __webpack_exports__["d"] = isDateValid;
	/* harmony export (immutable) */ __webpack_exports__["e"] = isFunction;
	/* harmony export (immutable) */ __webpack_exports__["f"] = isNumber;
	/* harmony export (immutable) */ __webpack_exports__["b"] = isArray;
	/* harmony export (immutable) */ __webpack_exports__["a"] = hasOwnProp;
	/* harmony export (immutable) */ __webpack_exports__["g"] = isObject;
	/* harmony export (immutable) */ __webpack_exports__["h"] = isObjectEmpty;
	/* harmony export (immutable) */ __webpack_exports__["j"] = isUndefined;
	/* harmony export (immutable) */ __webpack_exports__["k"] = toInt;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(47);
	
	function isString(str) {
	    return typeof str === 'string';
	}
	function isDate(value) {
	    return value instanceof Date || Object.prototype.toString.call(value) === '[object Date]';
	}
	function isBoolean(value) {
	    return value === true || value === false;
	}
	function isDateValid(date) {
	    return date && date.getTime && !isNaN(date.getTime());
	}
	function isFunction(fn) {
	    return (fn instanceof Function ||
	        Object.prototype.toString.call(fn) === '[object Function]');
	}
	function isNumber(value) {
	    return typeof value === 'number' || Object.prototype.toString.call(value) === '[object Number]';
	}
	function isArray(input) {
	    return (input instanceof Array ||
	        Object.prototype.toString.call(input) === '[object Array]');
	}
	function hasOwnProp(a /*object*/, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	function isObject(input /*object*/) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return (input != null && Object.prototype.toString.call(input) === '[object Object]');
	}
	function isObjectEmpty(obj) {
	    if (Object.getOwnPropertyNames) {
	        return (Object.getOwnPropertyNames(obj).length === 0);
	    }
	    var k;
	    for (k in obj) {
	        if (obj.hasOwnProperty(k)) {
	            return false;
	        }
	    }
	    return true;
	}
	function isUndefined(input) {
	    return input === void 0;
	}
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion;
	    var value = 0;
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* absFloor */])(coercedNumber);
	    }
	    return value;
	}
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["e"] = getHours;
	/* harmony export (immutable) */ __webpack_exports__["g"] = getMinutes;
	/* harmony export (immutable) */ __webpack_exports__["i"] = getSeconds;
	/* harmony export (immutable) */ __webpack_exports__["f"] = getMilliseconds;
	/* harmony export (immutable) */ __webpack_exports__["j"] = getTime;
	/* harmony export (immutable) */ __webpack_exports__["b"] = getDay;
	/* harmony export (immutable) */ __webpack_exports__["a"] = getDate;
	/* harmony export (immutable) */ __webpack_exports__["h"] = getMonth;
	/* harmony export (immutable) */ __webpack_exports__["d"] = getFullYear;
	/* unused harmony export getUnixTime */
	/* harmony export (immutable) */ __webpack_exports__["o"] = unix;
	/* harmony export (immutable) */ __webpack_exports__["c"] = getFirstDayOfMonth;
	/* unused harmony export daysInMonth */
	/* unused harmony export _daysInMonth */
	/* harmony export (immutable) */ __webpack_exports__["k"] = isFirstDayOfWeek;
	/* harmony export (immutable) */ __webpack_exports__["m"] = isSameMonth;
	/* harmony export (immutable) */ __webpack_exports__["n"] = isSameYear;
	/* harmony export (immutable) */ __webpack_exports__["l"] = isSameDay;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_date_from_array__ = __webpack_require__(19);
	
	function getHours(date, isUTC) {
	    if (isUTC === void 0) { isUTC = false; }
	    return isUTC ? date.getUTCHours() : date.getHours();
	}
	function getMinutes(date, isUTC) {
	    if (isUTC === void 0) { isUTC = false; }
	    return isUTC ? date.getUTCMinutes() : date.getMinutes();
	}
	function getSeconds(date, isUTC) {
	    if (isUTC === void 0) { isUTC = false; }
	    return isUTC ? date.getUTCSeconds() : date.getSeconds();
	}
	function getMilliseconds(date, isUTC) {
	    if (isUTC === void 0) { isUTC = false; }
	    return isUTC ? date.getUTCMilliseconds() : date.getMilliseconds();
	}
	function getTime(date) {
	    return date.getTime();
	}
	function getDay(date, isUTC) {
	    if (isUTC === void 0) { isUTC = false; }
	    return isUTC ? date.getUTCDay() : date.getDay();
	}
	function getDate(date, isUTC) {
	    if (isUTC === void 0) { isUTC = false; }
	    return isUTC ? date.getUTCDate() : date.getDate();
	}
	function getMonth(date, isUTC) {
	    if (isUTC === void 0) { isUTC = false; }
	    return isUTC ? date.getUTCMonth() : date.getMonth();
	}
	function getFullYear(date, isUTC) {
	    if (isUTC === void 0) { isUTC = false; }
	    return isUTC ? date.getUTCFullYear() : date.getFullYear();
	}
	function getUnixTime(date) {
	    return Math.floor(date.valueOf() / 1000);
	}
	function unix(date) {
	    return Math.floor(date.valueOf() / 1000);
	}
	function getFirstDayOfMonth(date) {
	    return Object(__WEBPACK_IMPORTED_MODULE_0__create_date_from_array__["a" /* createDate */])(date.getFullYear(), date.getMonth(), 1, date.getHours(), date.getMinutes(), date.getSeconds());
	}
	function daysInMonth(date) {
	    return _daysInMonth(date.getFullYear(), date.getMonth());
	}
	function _daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	function isFirstDayOfWeek(date, firstDayOfWeek) {
	    return date.getDay() === firstDayOfWeek;
	}
	function isSameMonth(date1, date2) {
	    if (!date1 || !date2) {
	        return false;
	    }
	    return isSameYear(date1, date2) && getMonth(date1) === getMonth(date2);
	}
	function isSameYear(date1, date2) {
	    if (!date1 || !date2) {
	        return false;
	    }
	    return getFullYear(date1) === getFullYear(date2);
	}
	function isSameDay(date1, date2) {
	    if (!date1 || !date2) {
	        return false;
	    }
	    return (isSameYear(date1, date2) &&
	        isSameMonth(date1, date2) &&
	        getDate(date1) === getDate(date2));
	}
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatFunctions; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatTokenFunctions; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formattingTokens; });
	/* harmony export (immutable) */ __webpack_exports__["a"] = addFormatToken;
	/* harmony export (immutable) */ __webpack_exports__["e"] = makeFormatFunction;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_zero_fill__ = __webpack_require__(46);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_type_checks__ = __webpack_require__(1);
	
	
	var formatFunctions = {};
	var formatTokenFunctions = {};
	// tslint:disable-next-line
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken(token, padded, ordinal, callback) {
	    if (token) {
	        formatTokenFunctions[token] = callback;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return Object(__WEBPACK_IMPORTED_MODULE_0__utils_zero_fill__["a" /* zeroFill */])(callback.apply(null, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function (date, opts) {
	            return opts.locale.ordinal(callback.apply(null, arguments), token);
	        };
	    }
	}
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens);
	    var length = array.length;
	    var formatArr = new Array(length);
	    for (var i = 0; i < length; i++) {
	        formatArr[i] = formatTokenFunctions[array[i]]
	            ? formatTokenFunctions[array[i]]
	            : removeFormattingTokens(array[i]);
	    }
	    return function (date, locale, isUTC, offset) {
	        if (offset === void 0) { offset = 0; }
	        var output = '';
	        for (var j = 0; j < length; j++) {
	            output += Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["e" /* isFunction */])(formatArr[j])
	                ? formatArr[j].call(null, date, { format: format, locale: locale, isUTC: isUTC, offset: offset })
	                : formatArr[j];
	        }
	        return output;
	    };
	}
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return match1; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return match2; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return match3; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return match4; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return match6; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return match1to2; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return match3to4; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return match5to6; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return match1to3; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return match1to4; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return match1to6; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return matchUnsigned; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return matchSigned; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return matchOffset; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return matchShortOffset; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return matchTimestamp; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return matchWord; });
	/* harmony export (immutable) */ __webpack_exports__["a"] = addRegexToken;
	/* harmony export (immutable) */ __webpack_exports__["b"] = getParseRegexForToken;
	/* harmony export (immutable) */ __webpack_exports__["t"] = regexEscape;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_type_checks__ = __webpack_require__(1);
	
	var match1 = /\d/; //       0 - 9
	var match2 = /\d\d/; //      00 - 99
	var match3 = /\d{3}/; //     000 - 999
	var match4 = /\d{4}/; //    0000 - 9999
	var match6 = /[+-]?\d{6}/; // -999999 - 999999
	var match1to2 = /\d\d?/; //       0 - 99
	var match3to4 = /\d\d\d\d?/; //     999 - 9999
	var match5to6 = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3 = /\d{1,3}/; //       0 - 999
	var match1to4 = /\d{1,4}/; //       0 - 9999
	var match1to6 = /[+-]?\d{1,6}/; // -999999 - 999999
	var matchUnsigned = /\d+/; //       0 - inf
	var matchSigned = /[+-]?\d+/; //    -inf - inf
	var matchOffset = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	// tslint:disable-next-line
	var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	var regexes = {};
	function addRegexToken(token, regex, strictRegex) {
	    if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["e" /* isFunction */])(regex)) {
	        regexes[token] = regex;
	        return;
	    }
	    regexes[token] = function (isStrict, locale) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	function getParseRegexForToken(token, locale) {
	    var _strict = false;
	    if (!Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["a" /* hasOwnProp */])(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	    return regexes[token](_strict, locale);
	}
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(str) {
	    // tslint:disable-next-line
	    return regexEscape(str
	        .replace('\\', '')
	        .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) { return p1 || p2 || p3 || p4; }));
	}
	function regexEscape(str) {
	    return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = addParseToken;
	/* harmony export (immutable) */ __webpack_exports__["c"] = addWeekParseToken;
	/* harmony export (immutable) */ __webpack_exports__["b"] = addTimeToArrayFromToken;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_type_checks__ = __webpack_require__(1);
	// tslint:disable:max-line-length
	
	var tokens = {};
	function addParseToken(token, callback) {
	    var _token = Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["i" /* isString */])(token) ? [token] : token;
	    var func = callback;
	    if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["f" /* isNumber */])(callback)) {
	        func = function (input, array, config) {
	            array[callback] = Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["k" /* toInt */])(input);
	            return config;
	        };
	    }
	    if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["b" /* isArray */])(_token) && Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["e" /* isFunction */])(func)) {
	        var i = void 0;
	        for (i = 0; i < _token.length; i++) {
	            tokens[_token[i]] = func;
	        }
	    }
	}
	function addWeekParseToken(token, callback) {
	    addParseToken(token, function (input, array, config, _token) {
	        config._w = config._w || {};
	        return callback(input, config._w, config, _token);
	    });
	}
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["a" /* hasOwnProp */])(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	    return config;
	}
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = addUnitAlias;
	/* harmony export (immutable) */ __webpack_exports__["c"] = normalizeUnits;
	/* harmony export (immutable) */ __webpack_exports__["b"] = normalizeObjectUnits;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_type_checks__ = __webpack_require__(1);
	
	var aliases = {};
	var _mapUnits = {
	    date: 'day',
	    hour: 'hours',
	    minute: 'minutes',
	    second: 'seconds',
	    millisecond: 'milliseconds'
	};
	function addUnitAlias(unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    var _unit = unit;
	    if (lowerCase in _mapUnits) {
	        _unit = _mapUnits[lowerCase];
	    }
	    aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = _unit;
	}
	function normalizeUnits(units) {
	    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["i" /* isString */])(units) ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {};
	    var normalizedProp;
	    var prop;
	    for (prop in inputObject) {
	        if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["a" /* hasOwnProp */])(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	    return normalizedInput;
	}
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["b"] = setTheme;
	/* harmony export (immutable) */ __webpack_exports__["a"] = isBs3;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_browser__ = __webpack_require__(53);
	
	var guessedVersion;
	function _guessBsVersion() {
	    if (typeof document === 'undefined') {
	        return null;
	    }
	    var spanEl = document.createElement('span');
	    spanEl.innerText = 'test bs version';
	    document.body.appendChild(spanEl);
	    spanEl.classList.add('d-none');
	    var rect = spanEl.getBoundingClientRect();
	    document.body.removeChild(spanEl);
	    if (!rect) {
	        return 'bs3';
	    }
	    return rect.top === 0 ? 'bs4' : 'bs3';
	}
	function setTheme(theme) {
	    guessedVersion = theme;
	}
	// todo: in ngx-bootstrap, bs4 will became a default one
	function isBs3() {
	    if (typeof __WEBPACK_IMPORTED_MODULE_0__facade_browser__["b" /* window */] === 'undefined') {
	        return true;
	    }
	    if (typeof __WEBPACK_IMPORTED_MODULE_0__facade_browser__["b" /* window */].__theme === 'undefined') {
	        if (guessedVersion) {
	            return guessedVersion === 'bs3';
	        }
	        guessedVersion = _guessBsVersion();
	        return guessedVersion === 'bs3';
	    }
	    return __WEBPACK_IMPORTED_MODULE_0__facade_browser__["b" /* window */].__theme !== 'bs4';
	}
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_8__;
	
	/***/ }),
	/* 9 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return YEAR; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MONTH; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATE; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HOUR; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MINUTE; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SECOND; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MILLISECOND; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return WEEK; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return WEEKDAY; });
	// place in new Date([array])
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = addUnitPriority;
	var priorities = {};
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	/*
	export function getPrioritizedUnits(unitsObj) {
	  const units = [];
	  let unit;
	  for (unit in unitsObj) {
	    if (unitsObj.hasOwnProperty(unit)) {
	      units.push({ unit, priority: priorities[unit] });
	    }
	  }
	  units.sort(function (a, b) {
	    return a.priority - b.priority;
	  });
	
	  return units;
	}
	*/
	
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_11__;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export mergeConfigs */
	/* harmony export (immutable) */ __webpack_exports__["c"] = getSetGlobalLocale;
	/* harmony export (immutable) */ __webpack_exports__["a"] = defineLocale;
	/* unused harmony export updateLocale */
	/* harmony export (immutable) */ __webpack_exports__["b"] = getLocale;
	/* harmony export (immutable) */ __webpack_exports__["d"] = listLocales;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_class__ = __webpack_require__(34);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale_defaults__ = __webpack_require__(158);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_type_checks__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_compare_arrays__ = __webpack_require__(160);
	// internal storage for locale config files
	
	
	
	
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least,
	// but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var next;
	    var locale;
	    var i = 0;
	    while (i < names.length) {
	        var split = normalizeLocale(names[i]).split('-');
	        var j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && Object(__WEBPACK_IMPORTED_MODULE_3__utils_compare_arrays__["a" /* compareArrays */])(split, next, true) >= j - 1) {
	                // the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	function mergeConfigs(parentConfig, childConfig) {
	    var res = Object.assign({}, parentConfig);
	    for (var childProp in childConfig) {
	        if (!Object(__WEBPACK_IMPORTED_MODULE_2__utils_type_checks__["a" /* hasOwnProp */])(childConfig, childProp)) {
	            continue;
	        }
	        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_type_checks__["g" /* isObject */])(parentConfig[childProp]) && Object(__WEBPACK_IMPORTED_MODULE_2__utils_type_checks__["g" /* isObject */])(childConfig[childProp])) {
	            res[childProp] = {};
	            Object.assign(res[childProp], parentConfig[childProp]);
	            Object.assign(res[childProp], childConfig[childProp]);
	        }
	        else if (childConfig[childProp] != null) {
	            res[childProp] = childConfig[childProp];
	        }
	        else {
	            delete res[childProp];
	        }
	    }
	    var parentProp;
	    for (parentProp in parentConfig) {
	        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_type_checks__["a" /* hasOwnProp */])(parentConfig, parentProp) &&
	            !Object(__WEBPACK_IMPORTED_MODULE_2__utils_type_checks__["a" /* hasOwnProp */])(childConfig, parentProp) &&
	            Object(__WEBPACK_IMPORTED_MODULE_2__utils_type_checks__["g" /* isObject */])(parentConfig[parentProp])) {
	            // make sure changes to properties don't modify parent config
	            res[parentProp] = Object.assign({}, res[parentProp]);
	        }
	    }
	    return res;
	}
	function loadLocale(name) {
	    // no way!
	    /* var oldLocale = null;
	     // TODO: Find a better way to register and load all the locales in Node
	     if (!locales[name] && (typeof module !== 'undefined') &&
	       module && module.exports) {
	       try {
	         oldLocale = globalLocale._abbr;
	         var aliasedRequire = require;
	         aliasedRequire('./locale/' + name);
	         getSetGlobalLocale(oldLocale);
	       } catch (e) {}
	     }*/
	    if (!locales[name]) {
	        // tslint:disable-next-line
	        console.error("Khronos locale error: please load locale \"" + name + "\" before using it");
	        // throw new Error(`Khronos locale error: please load locale "${name}" before using it`);
	    }
	    return locales[name];
	}
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale(key, values) {
	    var data;
	    if (key) {
	        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_type_checks__["j" /* isUndefined */])(values)) {
	            data = getLocale(key);
	        }
	        else if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_type_checks__["i" /* isString */])(key)) {
	            data = defineLocale(key, values);
	        }
	        if (data) {
	            globalLocale = data;
	        }
	    }
	    return globalLocale && globalLocale._abbr;
	}
	function defineLocale(name, config) {
	    if (config === null) {
	        // useful for testing
	        delete locales[name];
	        globalLocale = getLocale('en');
	        return null;
	    }
	    if (!config) {
	        return;
	    }
	    var parentConfig = __WEBPACK_IMPORTED_MODULE_1__locale_defaults__["a" /* baseConfig */];
	    config.abbr = name;
	    if (config.parentLocale != null) {
	        if (locales[config.parentLocale] != null) {
	            parentConfig = locales[config.parentLocale]._config;
	        }
	        else {
	            if (!localeFamilies[config.parentLocale]) {
	                localeFamilies[config.parentLocale] = [];
	            }
	            localeFamilies[config.parentLocale].push({ name: name, config: config });
	            return null;
	        }
	    }
	    locales[name] = new __WEBPACK_IMPORTED_MODULE_0__locale_class__["a" /* Locale */](mergeConfigs(parentConfig, config));
	    if (localeFamilies[name]) {
	        localeFamilies[name].forEach(function (x) {
	            defineLocale(x.name, x.config);
	        });
	    }
	    // backwards compat for now: also set the locale
	    // make sure we set the locale AFTER all child locales have been
	    // created, so we won't end up with the child locale set.
	    getSetGlobalLocale(name);
	    return locales[name];
	}
	function updateLocale(name, config) {
	    var _config = config;
	    if (_config != null) {
	        var parentConfig = __WEBPACK_IMPORTED_MODULE_1__locale_defaults__["a" /* baseConfig */];
	        // MERGE
	        var tmpLocale = loadLocale(name);
	        if (tmpLocale != null) {
	            parentConfig = tmpLocale._config;
	        }
	        _config = mergeConfigs(parentConfig, _config);
	        var locale = new __WEBPACK_IMPORTED_MODULE_0__locale_class__["a" /* Locale */](_config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    }
	    else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            }
	            else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	// returns locale data
	function getLocale(key) {
	    if (!key) {
	        return globalLocale;
	    }
	    // let locale;
	    var _key = Object(__WEBPACK_IMPORTED_MODULE_2__utils_type_checks__["b" /* isArray */])(key) ? key : [key];
	    return chooseLocale(_key);
	}
	function listLocales() {
	    return Object.keys(locales);
	}
	// define default locale
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal: function (num) {
	        var b = num % 10;
	        var output = Object(__WEBPACK_IMPORTED_MODULE_2__utils_type_checks__["k" /* toInt */])((num % 100) / 10) === 1
	            ? 'th'
	            : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
	        return num + output;
	    }
	});
	
	
	/***/ }),
	/* 13 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["j"] = shiftDate;
	/* harmony export (immutable) */ __webpack_exports__["b"] = setFullDate;
	/* harmony export (immutable) */ __webpack_exports__["c"] = setFullYear;
	/* harmony export (immutable) */ __webpack_exports__["g"] = setMonth;
	/* unused harmony export setDay */
	/* harmony export (immutable) */ __webpack_exports__["d"] = setHours;
	/* harmony export (immutable) */ __webpack_exports__["f"] = setMinutes;
	/* harmony export (immutable) */ __webpack_exports__["h"] = setSeconds;
	/* harmony export (immutable) */ __webpack_exports__["e"] = setMilliseconds;
	/* harmony export (immutable) */ __webpack_exports__["a"] = setDate;
	/* harmony export (immutable) */ __webpack_exports__["i"] = setTime;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__units_month__ = __webpack_require__(48);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type_checks__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__date_getters__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__units_year__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__create_date_from_array__ = __webpack_require__(19);
	
	
	
	
	
	var defaultTimeUnit = {
	    year: 0,
	    month: 0,
	    day: 0,
	    hour: 0,
	    minute: 0,
	    seconds: 0
	};
	function shiftDate(date, unit) {
	    var _unit = Object.assign({}, defaultTimeUnit, unit);
	    var year = date.getFullYear() + (_unit.year || 0);
	    var month = date.getMonth() + (_unit.month || 0);
	    var day = date.getDate() + (_unit.day || 0);
	    if (_unit.month && !_unit.day) {
	        day = Math.min(day, Object(__WEBPACK_IMPORTED_MODULE_0__units_month__["a" /* daysInMonth */])(year, month));
	    }
	    return Object(__WEBPACK_IMPORTED_MODULE_4__create_date_from_array__["a" /* createDate */])(year, month, day, date.getHours() + (_unit.hour || 0), date.getMinutes() + (_unit.minute || 0), date.getSeconds() + (_unit.seconds || 0));
	}
	function setFullDate(date, unit) {
	    return Object(__WEBPACK_IMPORTED_MODULE_4__create_date_from_array__["a" /* createDate */])(getNum(date.getFullYear(), unit.year), getNum(date.getMonth(), unit.month), getNum(date.getDate(), unit.day), getNum(date.getHours(), unit.hour), getNum(date.getMinutes(), unit.minute), getNum(date.getSeconds(), unit.seconds), getNum(date.getMilliseconds(), unit.milliseconds));
	}
	function getNum(def, num) {
	    return Object(__WEBPACK_IMPORTED_MODULE_1__type_checks__["f" /* isNumber */])(num) ? num : def;
	}
	function setFullYear(date, value, isUTC) {
	    var _month = Object(__WEBPACK_IMPORTED_MODULE_2__date_getters__["h" /* getMonth */])(date, isUTC);
	    var _date = Object(__WEBPACK_IMPORTED_MODULE_2__date_getters__["a" /* getDate */])(date, isUTC);
	    var _year = Object(__WEBPACK_IMPORTED_MODULE_2__date_getters__["d" /* getFullYear */])(date, isUTC);
	    if (Object(__WEBPACK_IMPORTED_MODULE_3__units_year__["b" /* isLeapYear */])(_year) && _month === 1 && _date === 29) {
	        var _daysInMonth = Object(__WEBPACK_IMPORTED_MODULE_0__units_month__["a" /* daysInMonth */])(value, _month);
	        isUTC ? date.setUTCFullYear(value, _month, _daysInMonth) : date.setFullYear(value, _month, _daysInMonth);
	    }
	    isUTC ? date.setUTCFullYear(value) : date.setFullYear(value);
	    return date;
	}
	function setMonth(date, value, isUTC) {
	    var dayOfMonth = Math.min(Object(__WEBPACK_IMPORTED_MODULE_2__date_getters__["a" /* getDate */])(date), Object(__WEBPACK_IMPORTED_MODULE_0__units_month__["a" /* daysInMonth */])(Object(__WEBPACK_IMPORTED_MODULE_2__date_getters__["d" /* getFullYear */])(date), value));
	    isUTC ? date.setUTCMonth(value, dayOfMonth) : date.setMonth(value, dayOfMonth);
	    return date;
	}
	function setDay(date, value, isUTC) {
	    isUTC ? date.setUTCDate(value) : date.setDate(value);
	    return date;
	}
	function setHours(date, value, isUTC) {
	    isUTC ? date.setUTCHours(value) : date.setHours(value);
	    return date;
	}
	function setMinutes(date, value, isUTC) {
	    isUTC ? date.setUTCMinutes(value) : date.setMinutes(value);
	    return date;
	}
	function setSeconds(date, value, isUTC) {
	    isUTC ? date.setUTCSeconds(value) : date.setSeconds(value);
	    return date;
	}
	function setMilliseconds(date, value, isUTC) {
	    isUTC ? date.setUTCMilliseconds(value) : date.setMilliseconds(value);
	    return date;
	}
	function setDate(date, value, isUTC) {
	    isUTC ? date.setUTCDate(value) : date.setDate(value);
	    return date;
	}
	function setTime(date, value) {
	    date.setTime(value);
	    return date;
	}
	
	
	/***/ }),
	/* 14 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export parseWeekday */
	/* unused harmony export parseIsoWeekday */
	/* unused harmony export getSetDayOfWeek */
	/* harmony export (immutable) */ __webpack_exports__["d"] = setDayOfWeek;
	/* harmony export (immutable) */ __webpack_exports__["a"] = getDayOfWeek;
	/* harmony export (immutable) */ __webpack_exports__["c"] = getLocaleDayOfWeek;
	/* harmony export (immutable) */ __webpack_exports__["f"] = setLocaleDayOfWeek;
	/* harmony export (immutable) */ __webpack_exports__["b"] = getISODayOfWeek;
	/* harmony export (immutable) */ __webpack_exports__["e"] = setISODayOfWeek;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_date_getters__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parse_regex__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aliases__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__priorities__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parse_token__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__create_parsing_flags__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_type_checks__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__moment_add_subtract__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locale_locales__ = __webpack_require__(12);
	
	
	
	
	
	
	
	
	
	
	// FORMATTING
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('d', null, 'do', function (date, opts) {
	    return Object(__WEBPACK_IMPORTED_MODULE_1__utils_date_getters__["b" /* getDay */])(date, opts.isUTC).toString(10);
	});
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('dd', null, null, function (date, opts) {
	    return opts.locale.weekdaysMin(date, opts.format, opts.isUTC);
	});
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('ddd', null, null, function (date, opts) {
	    return opts.locale.weekdaysShort(date, opts.format, opts.isUTC);
	});
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('dddd', null, null, function (date, opts) {
	    return opts.locale.weekdays(date, opts.format, opts.isUTC);
	});
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('e', null, null, function (date, opts) {
	    return getLocaleDayOfWeek(date, opts.locale, opts.isUTC).toString(10);
	    // return getDay(date, opts.isUTC).toString(10);
	});
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('E', null, null, function (date, opts) {
	    return getISODayOfWeek(date, opts.isUTC).toString(10);
	});
	// ALIASES
	Object(__WEBPACK_IMPORTED_MODULE_3__aliases__["a" /* addUnitAlias */])('day', 'd');
	Object(__WEBPACK_IMPORTED_MODULE_3__aliases__["a" /* addUnitAlias */])('weekday', 'e');
	Object(__WEBPACK_IMPORTED_MODULE_3__aliases__["a" /* addUnitAlias */])('isoWeekday', 'E');
	// PRIORITY
	Object(__WEBPACK_IMPORTED_MODULE_4__priorities__["a" /* addUnitPriority */])('day', 11);
	Object(__WEBPACK_IMPORTED_MODULE_4__priorities__["a" /* addUnitPriority */])('weekday', 11);
	Object(__WEBPACK_IMPORTED_MODULE_4__priorities__["a" /* addUnitPriority */])('isoWeekday', 11);
	// PARSING
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('d', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["d" /* match1to2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('e', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["d" /* match1to2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('E', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["d" /* match1to2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('dd', function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('ddd', function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('dddd', function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["c" /* addWeekParseToken */])(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    }
	    else {
	        Object(__WEBPACK_IMPORTED_MODULE_6__create_parsing_flags__["a" /* getParsingFlags */])(config).invalidWeekday = !!input;
	    }
	    return config;
	});
	Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["c" /* addWeekParseToken */])(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = Object(__WEBPACK_IMPORTED_MODULE_7__utils_type_checks__["k" /* toInt */])(input);
	    return config;
	});
	// HELPERS
	function parseWeekday(input, locale) {
	    if (!Object(__WEBPACK_IMPORTED_MODULE_7__utils_type_checks__["i" /* isString */])(input)) {
	        return input;
	    }
	    var _num = parseInt(input, 10);
	    if (!isNaN(_num)) {
	        return _num;
	    }
	    var _weekDay = locale.weekdaysParse(input);
	    if (Object(__WEBPACK_IMPORTED_MODULE_7__utils_type_checks__["f" /* isNumber */])(_weekDay)) {
	        return _weekDay;
	    }
	    return null;
	}
	function parseIsoWeekday(input, locale) {
	    if (locale === void 0) { locale = Object(__WEBPACK_IMPORTED_MODULE_9__locale_locales__["b" /* getLocale */])(); }
	    if (Object(__WEBPACK_IMPORTED_MODULE_7__utils_type_checks__["i" /* isString */])(input)) {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return Object(__WEBPACK_IMPORTED_MODULE_7__utils_type_checks__["f" /* isNumber */])(input) && isNaN(input) ? null : input;
	}
	// MOMENTS
	function getSetDayOfWeek(date, input, opts) {
	    if (!input) {
	        return getDayOfWeek(date, opts.isUTC);
	    }
	    return setDayOfWeek(date, input, opts.locale, opts.isUTC);
	}
	function setDayOfWeek(date, input, locale, isUTC) {
	    if (locale === void 0) { locale = Object(__WEBPACK_IMPORTED_MODULE_9__locale_locales__["b" /* getLocale */])(); }
	    var day = Object(__WEBPACK_IMPORTED_MODULE_1__utils_date_getters__["b" /* getDay */])(date, isUTC);
	    var _input = parseWeekday(input, locale);
	    return Object(__WEBPACK_IMPORTED_MODULE_8__moment_add_subtract__["a" /* add */])(date, _input - day, 'day');
	}
	function getDayOfWeek(date, isUTC) {
	    return Object(__WEBPACK_IMPORTED_MODULE_1__utils_date_getters__["b" /* getDay */])(date, isUTC);
	}
	/********************************************/
	// todo: utc
	// getSetLocaleDayOfWeek
	function getLocaleDayOfWeek(date, locale, isUTC) {
	    if (locale === void 0) { locale = Object(__WEBPACK_IMPORTED_MODULE_9__locale_locales__["b" /* getLocale */])(); }
	    return (Object(__WEBPACK_IMPORTED_MODULE_1__utils_date_getters__["b" /* getDay */])(date, isUTC) + 7 - locale.firstDayOfWeek()) % 7;
	}
	function setLocaleDayOfWeek(date, input, opts) {
	    if (opts === void 0) { opts = {}; }
	    var weekday = getLocaleDayOfWeek(date, opts.locale, opts.isUTC);
	    return Object(__WEBPACK_IMPORTED_MODULE_8__moment_add_subtract__["a" /* add */])(date, input - weekday, 'day');
	}
	// getSetISODayOfWeek
	function getISODayOfWeek(date, isUTC) {
	    return Object(__WEBPACK_IMPORTED_MODULE_1__utils_date_getters__["b" /* getDay */])(date, isUTC) || 7;
	}
	function setISODayOfWeek(date, input, opts) {
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	    if (opts === void 0) { opts = {}; }
	    var weekday = parseIsoWeekday(input, opts.locale);
	    return setDayOfWeek(date, getDayOfWeek(date) % 7 ? weekday : weekday - 7);
	}
	
	
	/***/ }),
	/* 15 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component_loader_class__ = __webpack_require__(105);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__component_loader_class__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_loader_factory__ = __webpack_require__(24);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__component_loader_factory__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__content_ref_class__ = __webpack_require__(107);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__content_ref_class__["a"]; });
	
	
	
	
	
	/***/ }),
	/* 16 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = getParsingFlags;
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty: false,
	        unusedTokens: [],
	        unusedInput: [],
	        overflow: -2,
	        charsLeftOver: 0,
	        nullInput: false,
	        invalidMonth: null,
	        invalidFormat: false,
	        userInvalidated: false,
	        iso: false,
	        parsedDateParts: [],
	        meridiem: null,
	        rfc2822: false,
	        weekdayMismatch: false
	    };
	}
	function getParsingFlags(config) {
	    if (config._pf == null) {
	        config._pf = defaultParsingFlags();
	    }
	    return config._pf;
	}
	
	
	/***/ }),
	/* 17 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["b"] = formatDate;
	/* unused harmony export formatMoment */
	/* harmony export (immutable) */ __webpack_exports__["a"] = expandFormat;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__units_index__ = __webpack_require__(88);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__format_format__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale_locales__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_type_checks__ = __webpack_require__(1);
	// moment.js
	// version : 2.18.1
	// authors : Tim Wood, Iskren Chernev, Moment.js contributors
	// license : MIT
	// momentjs.com
	
	
	
	
	function formatDate(date, format, locale, isUTC, offset) {
	    if (offset === void 0) { offset = 0; }
	    var _locale = Object(__WEBPACK_IMPORTED_MODULE_2__locale_locales__["b" /* getLocale */])(locale || 'en');
	    if (!_locale) {
	        throw new Error("Locale \"" + locale + "\" is not defined, please add it with \"defineLocale(...)\"");
	    }
	    var _format = format || (isUTC ? 'YYYY-MM-DDTHH:mm:ss[Z]' : 'YYYY-MM-DDTHH:mm:ssZ');
	    var output = formatMoment(date, _format, _locale, isUTC, offset);
	    if (!output) {
	        return output;
	    }
	    return _locale.postformat(output);
	}
	// format date using native date object
	function formatMoment(date, _format, locale, isUTC, offset) {
	    if (offset === void 0) { offset = 0; }
	    if (!Object(__WEBPACK_IMPORTED_MODULE_3__utils_type_checks__["d" /* isDateValid */])(date)) {
	        return locale.invalidDate;
	    }
	    var format = expandFormat(_format, locale);
	    __WEBPACK_IMPORTED_MODULE_1__format_format__["b" /* formatFunctions */][format] = __WEBPACK_IMPORTED_MODULE_1__format_format__["b" /* formatFunctions */][format] || Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["e" /* makeFormatFunction */])(format);
	    return __WEBPACK_IMPORTED_MODULE_1__format_format__["b" /* formatFunctions */][format](date, locale, isUTC, offset);
	}
	function expandFormat(_format, locale) {
	    var format = _format;
	    var i = 5;
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	    var replaceLongDateFormatTokens = function (input) {
	        return locale.formatLongDate(input) || input;
	    };
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	    return format;
	}
	
	
	/***/ }),
	/* 18 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDatepickerConfig; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	/**
	 * For date range picker there are `BsDaterangepickerConfig` which inherits all properties,
	 * except `displayMonths`, for range picker it default to `2`
	 */
	var BsDatepickerConfig = (function () {
	    function BsDatepickerConfig() {
	        /** CSS class which will be applied to datepicker container,
	         * usually used to set color theme
	         */
	        this.containerClass = 'theme-green';
	        // DatepickerRenderOptions
	        this.displayMonths = 1;
	        /**
	         * Allows to hide week numbers in datepicker
	         */
	        this.showWeekNumbers = true;
	        this.dateInputFormat = 'L';
	        // range picker
	        this.rangeSeparator = ' - ';
	        /**
	         * Date format for date range input field
	         */
	        this.rangeInputFormat = 'L';
	        // DatepickerFormatOptions
	        this.monthTitle = 'MMMM';
	        this.yearTitle = 'YYYY';
	        this.dayLabel = 'D';
	        this.monthLabel = 'MMMM';
	        this.yearLabel = 'YYYY';
	        this.weekNumbers = 'w';
	    }
	    BsDatepickerConfig = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	    ], BsDatepickerConfig);
	    return BsDatepickerConfig;
	}());
	
	
	
	/***/ }),
	/* 19 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["b"] = createUTCDate;
	/* harmony export (immutable) */ __webpack_exports__["a"] = createDate;
	function createUTCDate(y, m, d) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	function createDate(y, m, d, h, M, s, ms) {
	    if (m === void 0) { m = 0; }
	    if (d === void 0) { d = 1; }
	    if (h === void 0) { h = 0; }
	    if (M === void 0) { M = 0; }
	    if (s === void 0) { s = 0; }
	    if (ms === void 0) { ms = 0; }
	    var date = new Date(y, m, d, h, M, s, ms);
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	
	/***/ }),
	/* 20 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = add;
	/* harmony export (immutable) */ __webpack_exports__["b"] = subtract;
	/* unused harmony export addSubtract */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__duration_create__ = __webpack_require__(86);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_abs_round__ = __webpack_require__(91);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_date_getters__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_date_setters__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__create_clone__ = __webpack_require__(28);
	
	
	
	
	
	function add(date, val, period, isUTC) {
	    var dur = Object(__WEBPACK_IMPORTED_MODULE_0__duration_create__["a" /* createDuration */])(val, period);
	    return addSubtract(date, dur, 1, isUTC);
	}
	function subtract(date, val, period, isUTC) {
	    var dur = Object(__WEBPACK_IMPORTED_MODULE_0__duration_create__["a" /* createDuration */])(val, period);
	    return addSubtract(date, dur, -1, isUTC);
	}
	function addSubtract(date, duration, isAdding, isUTC) {
	    var milliseconds = duration._milliseconds;
	    var days = Object(__WEBPACK_IMPORTED_MODULE_1__utils_abs_round__["a" /* absRound */])(duration._days);
	    var months = Object(__WEBPACK_IMPORTED_MODULE_1__utils_abs_round__["a" /* absRound */])(duration._months);
	    // todo: add timezones support
	    // const _updateOffset = updateOffset == null ? true : updateOffset;
	    if (months) {
	        Object(__WEBPACK_IMPORTED_MODULE_3__utils_date_setters__["g" /* setMonth */])(date, Object(__WEBPACK_IMPORTED_MODULE_2__utils_date_getters__["h" /* getMonth */])(date, isUTC) + months * isAdding, isUTC);
	    }
	    if (days) {
	        Object(__WEBPACK_IMPORTED_MODULE_3__utils_date_setters__["a" /* setDate */])(date, Object(__WEBPACK_IMPORTED_MODULE_2__utils_date_getters__["a" /* getDate */])(date, isUTC) + days * isAdding, isUTC);
	    }
	    if (milliseconds) {
	        Object(__WEBPACK_IMPORTED_MODULE_3__utils_date_setters__["i" /* setTime */])(date, Object(__WEBPACK_IMPORTED_MODULE_2__utils_date_getters__["j" /* getTime */])(date) + milliseconds * isAdding);
	    }
	    return Object(__WEBPACK_IMPORTED_MODULE_4__create_clone__["a" /* cloneDate */])(date);
	    // todo: add timezones support
	    // if (_updateOffset) {
	    //   hooks.updateOffset(date, days || months);
	    // }
	}
	
	
	/***/ }),
	/* 21 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ng_positioning__ = __webpack_require__(108);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__ng_positioning__["b"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ng_positioning__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__positioning_service__ = __webpack_require__(109);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__positioning_service__["b"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__positioning_service__["PositioningOptions"]; });
	
	
	
	
	/***/ }),
	/* 22 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["c"] = parseTwoDigitYear;
	/* harmony export (immutable) */ __webpack_exports__["a"] = daysInYear;
	/* harmony export (immutable) */ __webpack_exports__["b"] = isLeapYear;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_date_getters__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parse_regex__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parse_token__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(9);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_type_checks__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__priorities__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__aliases__ = __webpack_require__(6);
	
	
	
	
	
	
	
	
	// FORMATTING
	function getYear(date, opts) {
	    return Object(__WEBPACK_IMPORTED_MODULE_1__utils_date_getters__["d" /* getFullYear */])(date, opts.isUTC).toString();
	}
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('Y', null, null, function (date, opts) {
	    var y = Object(__WEBPACK_IMPORTED_MODULE_1__utils_date_getters__["d" /* getFullYear */])(date, opts.isUTC);
	    return y <= 9999 ? y.toString(10) : "+" + y;
	});
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])(null, ['YY', 2, false], null, function (date, opts) {
	    return (Object(__WEBPACK_IMPORTED_MODULE_1__utils_date_getters__["d" /* getFullYear */])(date, opts.isUTC) % 100).toString(10);
	});
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])(null, ['YYYY', 4, false], null, getYear);
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])(null, ['YYYYY', 5, false], null, getYear);
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])(null, ['YYYYYY', 6, true], null, getYear);
	// ALIASES
	Object(__WEBPACK_IMPORTED_MODULE_7__aliases__["a" /* addUnitAlias */])('year', 'y');
	// PRIORITIES
	Object(__WEBPACK_IMPORTED_MODULE_6__priorities__["a" /* addUnitPriority */])('year', 1);
	// PARSING
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('Y', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["p" /* matchSigned */]);
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('YY', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_2__parse_regex__["h" /* match2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('YYYY', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["f" /* match1to4 */], __WEBPACK_IMPORTED_MODULE_2__parse_regex__["k" /* match4 */]);
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('YYYYY', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["g" /* match1to6 */], __WEBPACK_IMPORTED_MODULE_2__parse_regex__["m" /* match6 */]);
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('YYYYYY', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["g" /* match1to6 */], __WEBPACK_IMPORTED_MODULE_2__parse_regex__["m" /* match6 */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_token__["a" /* addParseToken */])(['YYYYY', 'YYYYYY'], __WEBPACK_IMPORTED_MODULE_4__constants__["i" /* YEAR */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_token__["a" /* addParseToken */])('YYYY', function (input, array, config) {
	    array[__WEBPACK_IMPORTED_MODULE_4__constants__["i" /* YEAR */]] = input.length === 2 ? parseTwoDigitYear(input) : Object(__WEBPACK_IMPORTED_MODULE_5__utils_type_checks__["k" /* toInt */])(input);
	    return config;
	});
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_token__["a" /* addParseToken */])('YY', function (input, array, config) {
	    array[__WEBPACK_IMPORTED_MODULE_4__constants__["i" /* YEAR */]] = parseTwoDigitYear(input);
	    return config;
	});
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_token__["a" /* addParseToken */])('Y', function (input, array, config) {
	    array[__WEBPACK_IMPORTED_MODULE_4__constants__["i" /* YEAR */]] = parseInt(input, 10);
	    return config;
	});
	function parseTwoDigitYear(input) {
	    return Object(__WEBPACK_IMPORTED_MODULE_5__utils_type_checks__["k" /* toInt */])(input) + (Object(__WEBPACK_IMPORTED_MODULE_5__utils_type_checks__["k" /* toInt */])(input) > 68 ? 1900 : 2000);
	}
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	
	/***/ }),
	/* 23 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = isAfter;
	/* harmony export (immutable) */ __webpack_exports__["b"] = isBefore;
	/* unused harmony export isBetween */
	/* unused harmony export isSame */
	/* unused harmony export isSameOrAfter */
	/* unused harmony export isSameOrBefore */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__start_end_of__ = __webpack_require__(27);
	
	function isAfter(date1, date2, units) {
	    if (units === void 0) { units = 'milliseconds'; }
	    if (!date1 || !date2) {
	        return false;
	    }
	    if (units === 'milliseconds') {
	        return date1.valueOf() > date2.valueOf();
	    }
	    return date2.valueOf() < Object(__WEBPACK_IMPORTED_MODULE_0__start_end_of__["b" /* startOf */])(date1, units).valueOf();
	}
	function isBefore(date1, date2, units) {
	    if (units === void 0) { units = 'milliseconds'; }
	    if (!date1 || !date2) {
	        return false;
	    }
	    if (units === 'milliseconds') {
	        return date1.valueOf() < date2.valueOf();
	    }
	    return Object(__WEBPACK_IMPORTED_MODULE_0__start_end_of__["a" /* endOf */])(date1, units).valueOf() < date2.valueOf();
	}
	function isBetween(date, from, to, units, inclusivity) {
	    if (inclusivity === void 0) { inclusivity = '()'; }
	    var leftBound = inclusivity[0] === '('
	        ? isAfter(date, from, units)
	        : !isBefore(date, from, units);
	    var rightBound = inclusivity[1] === ')'
	        ? isBefore(date, to, units)
	        : !isAfter(date, to, units);
	    return leftBound && rightBound;
	}
	function isSame(date1, date2, units) {
	    if (units === void 0) { units = 'milliseconds'; }
	    if (!date1 || !date2) {
	        return false;
	    }
	    if (units === 'milliseconds') {
	        return date1.valueOf() === date2.valueOf();
	    }
	    var inputMs = date2.valueOf();
	    return (Object(__WEBPACK_IMPORTED_MODULE_0__start_end_of__["b" /* startOf */])(date1, units).valueOf() <= inputMs &&
	        inputMs <= Object(__WEBPACK_IMPORTED_MODULE_0__start_end_of__["a" /* endOf */])(date1, units).valueOf());
	}
	function isSameOrAfter(date1, date2, units) {
	    return isSame(date1, date2, units) || isAfter(date1, date2, units);
	}
	function isSameOrBefore(date1, date2, units) {
	    return isSame(date1, date2, units) || isBefore(date1, date2, units);
	}
	
	
	/***/ }),
	/* 24 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ComponentLoaderFactory; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_loader_class__ = __webpack_require__(105);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__positioning_index__ = __webpack_require__(21);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	var ComponentLoaderFactory = (function () {
	    function ComponentLoaderFactory(_componentFactoryResolver, _ngZone, _injector, _posService, _applicationRef) {
	        this._componentFactoryResolver = _componentFactoryResolver;
	        this._ngZone = _ngZone;
	        this._injector = _injector;
	        this._posService = _posService;
	        this._applicationRef = _applicationRef;
	    }
	    /**
	     *
	     * @param _elementRef
	     * @param _viewContainerRef
	     * @param _renderer
	     * @returns {ComponentLoader}
	     */
	    ComponentLoaderFactory.prototype.createLoader = function (_elementRef, _viewContainerRef, _renderer) {
	        return new __WEBPACK_IMPORTED_MODULE_1__component_loader_class__["a" /* ComponentLoader */](_viewContainerRef, _renderer, _elementRef, this._injector, this._componentFactoryResolver, this._ngZone, this._applicationRef, this._posService);
	    };
	    ComponentLoaderFactory = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_2__positioning_index__["c" /* PositioningService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__positioning_index__["c" /* PositioningService */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ApplicationRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ApplicationRef"]) === "function" && _e || Object])
	    ], ComponentLoaderFactory);
	    return ComponentLoaderFactory;
	    var _a, _b, _c, _d, _e;
	}());
	
	
	
	/***/ }),
	/* 25 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDropdownState; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	var BsDropdownState = (function () {
	    function BsDropdownState() {
	        var _this = this;
	        this.direction = 'down';
	        this.isOpenChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.isDisabledChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.toggleClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.dropdownMenu = new Promise(function (resolve) {
	            _this.resolveDropdownMenu = resolve;
	        });
	    }
	    BsDropdownState = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
	        __metadata("design:paramtypes", [])
	    ], BsDropdownState);
	    return BsDropdownState;
	}());
	
	
	
	/***/ }),
	/* 26 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = dayOfYearFromWeeks;
	/* harmony export (immutable) */ __webpack_exports__["b"] = weekOfYear;
	/* harmony export (immutable) */ __webpack_exports__["c"] = weeksInYear;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_date_from_array__ = __webpack_require__(19);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__year__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__day_of_year__ = __webpack_require__(85);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_date_getters__ = __webpack_require__(2);
	/**
	 *
	 * @param {number} year
	 * @param {number} dow - start-of-first-week
	 * @param {number} doy - start-of-year
	 * @returns {number}
	 */
	
	
	
	
	function firstWeekOffset(year, dow, doy) {
	    // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	    var fwd = dow - doy + 7;
	    // first-week day local weekday -- which local weekday is fwd
	    var fwdlw = (Object(__WEBPACK_IMPORTED_MODULE_0__create_date_from_array__["b" /* createUTCDate */])(year, 0, fwd).getUTCDay() - dow + 7) % 7;
	    return -fwdlw + fwd - 1;
	}
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7;
	    var weekOffset = firstWeekOffset(year, dow, doy);
	    var dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset;
	    var resYear;
	    var resDayOfYear;
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = Object(__WEBPACK_IMPORTED_MODULE_1__year__["a" /* daysInYear */])(resYear) + dayOfYear;
	    }
	    else if (dayOfYear > Object(__WEBPACK_IMPORTED_MODULE_1__year__["a" /* daysInYear */])(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - Object(__WEBPACK_IMPORTED_MODULE_1__year__["a" /* daysInYear */])(year);
	    }
	    else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	function weekOfYear(date, dow, doy) {
	    var weekOffset = firstWeekOffset(Object(__WEBPACK_IMPORTED_MODULE_3__utils_date_getters__["d" /* getFullYear */])(date), dow, doy);
	    var week = Math.floor((Object(__WEBPACK_IMPORTED_MODULE_2__day_of_year__["a" /* getDayOfYear */])(date) - weekOffset - 1) / 7) + 1;
	    var resWeek;
	    var resYear;
	    if (week < 1) {
	        resYear = Object(__WEBPACK_IMPORTED_MODULE_3__utils_date_getters__["d" /* getFullYear */])(date) - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    }
	    else if (week > weeksInYear(Object(__WEBPACK_IMPORTED_MODULE_3__utils_date_getters__["d" /* getFullYear */])(date), dow, doy)) {
	        resWeek = week - weeksInYear(Object(__WEBPACK_IMPORTED_MODULE_3__utils_date_getters__["d" /* getFullYear */])(date), dow, doy);
	        resYear = Object(__WEBPACK_IMPORTED_MODULE_3__utils_date_getters__["d" /* getFullYear */])(date) + 1;
	    }
	    else {
	        resYear = Object(__WEBPACK_IMPORTED_MODULE_3__utils_date_getters__["d" /* getFullYear */])(date);
	        resWeek = week;
	    }
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy);
	    var weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (Object(__WEBPACK_IMPORTED_MODULE_1__year__["a" /* daysInYear */])(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	
	/***/ }),
	/* 27 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["b"] = startOf;
	/* harmony export (immutable) */ __webpack_exports__["a"] = endOf;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__date_setters__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_clone__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__units_day_of_week__ = __webpack_require__(14);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date_getters__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__moment_add_subtract__ = __webpack_require__(20);
	
	
	
	
	
	function startOf(date, unit, isUTC) {
	    var _date = Object(__WEBPACK_IMPORTED_MODULE_1__create_clone__["a" /* cloneDate */])(date);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (unit) {
	        case 'year':
	            Object(__WEBPACK_IMPORTED_MODULE_0__date_setters__["g" /* setMonth */])(_date, 0, isUTC);
	        /* falls through */
	        case 'quarter':
	        case 'month':
	            Object(__WEBPACK_IMPORTED_MODULE_0__date_setters__["a" /* setDate */])(_date, 1, isUTC);
	        /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            Object(__WEBPACK_IMPORTED_MODULE_0__date_setters__["d" /* setHours */])(_date, 0, isUTC);
	        /* falls through */
	        case 'hours':
	            Object(__WEBPACK_IMPORTED_MODULE_0__date_setters__["f" /* setMinutes */])(_date, 0, isUTC);
	        /* falls through */
	        case 'minutes':
	            Object(__WEBPACK_IMPORTED_MODULE_0__date_setters__["h" /* setSeconds */])(_date, 0, isUTC);
	        /* falls through */
	        case 'seconds':
	            Object(__WEBPACK_IMPORTED_MODULE_0__date_setters__["e" /* setMilliseconds */])(_date, 0, isUTC);
	    }
	    // weeks are a special case
	    if (unit === 'week') {
	        Object(__WEBPACK_IMPORTED_MODULE_2__units_day_of_week__["f" /* setLocaleDayOfWeek */])(_date, 0, { isUTC: isUTC });
	    }
	    if (unit === 'isoWeek') {
	        Object(__WEBPACK_IMPORTED_MODULE_2__units_day_of_week__["e" /* setISODayOfWeek */])(_date, 1);
	    }
	    // quarters are also special
	    if (unit === 'quarter') {
	        Object(__WEBPACK_IMPORTED_MODULE_0__date_setters__["g" /* setMonth */])(_date, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_3__date_getters__["h" /* getMonth */])(_date, isUTC) / 3) * 3, isUTC);
	    }
	    return _date;
	}
	function endOf(date, unit, isUTC) {
	    var _unit = unit;
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (_unit === 'date') {
	        _unit = 'day';
	    }
	    var start = startOf(date, _unit, isUTC);
	    var _step = Object(__WEBPACK_IMPORTED_MODULE_4__moment_add_subtract__["a" /* add */])(start, 1, _unit === 'isoWeek' ? 'week' : _unit, isUTC);
	    var res = Object(__WEBPACK_IMPORTED_MODULE_4__moment_add_subtract__["b" /* subtract */])(_step, 1, 'milliseconds', isUTC);
	    return res;
	}
	
	
	/***/ }),
	/* 28 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = cloneDate;
	// fastest way to clone date
	// https://jsperf.com/clone-date-object2
	function cloneDate(date) {
	    return new Date(date.getTime());
	}
	
	
	/***/ }),
	/* 29 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DatePickerInnerComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__date_formatter__ = __webpack_require__(101);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/* tslint:disable:max-file-line-count */
	
	
	// const MIN_DATE:Date = void 0;
	// const MAX_DATE:Date = void 0;
	// const DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	/*
	 const KEYS = {
	 13: 'enter',
	 32: 'space',
	 33: 'pageup',
	 34: 'pagedown',
	 35: 'end',
	 36: 'home',
	 37: 'left',
	 38: 'up',
	 39: 'right',
	 40: 'down'
	 };
	 */
	var DatePickerInnerComponent = (function () {
	    function DatePickerInnerComponent() {
	        this.selectionDone = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"](undefined);
	        this.update = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"](false);
	        this.activeDateChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"](undefined);
	        this.stepDay = {};
	        this.stepMonth = {};
	        this.stepYear = {};
	        this.modes = ['day', 'month', 'year'];
	        this.dateFormatter = new __WEBPACK_IMPORTED_MODULE_1__date_formatter__["a" /* DateFormatter */]();
	    }
	    Object.defineProperty(DatePickerInnerComponent.prototype, "activeDate", {
	        get: function () {
	            return this._activeDate;
	        },
	        set: function (value) {
	            this._activeDate = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // todo: add formatter value to Date object
	    DatePickerInnerComponent.prototype.ngOnInit = function () {
	        // todo: use date for unique value
	        this.uniqueId = "datepicker--" + Math.floor(Math.random() * 10000);
	        if (this.initDate) {
	            this.activeDate = this.initDate;
	            this.selectedDate = new Date(this.activeDate.valueOf());
	            this.update.emit(this.activeDate);
	        }
	        else if (this.activeDate === undefined) {
	            this.activeDate = new Date();
	        }
	    };
	    // this.refreshView should be called here to reflect the changes on the fly
	    // tslint:disable-next-line:no-unused-variable
	    DatePickerInnerComponent.prototype.ngOnChanges = function (changes) {
	        this.refreshView();
	        this.checkIfActiveDateGotUpdated(changes.activeDate);
	    };
	    // Check if activeDate has been update and then emit the activeDateChange with the new date
	    DatePickerInnerComponent.prototype.checkIfActiveDateGotUpdated = function (activeDate) {
	        if (activeDate && !activeDate.firstChange) {
	            var previousValue = activeDate.previousValue;
	            if (previousValue &&
	                previousValue instanceof Date &&
	                previousValue.getTime() !== activeDate.currentValue.getTime()) {
	                this.activeDateChange.emit(this.activeDate);
	            }
	        }
	    };
	    DatePickerInnerComponent.prototype.setCompareHandler = function (handler, type) {
	        if (type === 'day') {
	            this.compareHandlerDay = handler;
	        }
	        if (type === 'month') {
	            this.compareHandlerMonth = handler;
	        }
	        if (type === 'year') {
	            this.compareHandlerYear = handler;
	        }
	    };
	    DatePickerInnerComponent.prototype.compare = function (date1, date2) {
	        if (date1 === undefined || date2 === undefined) {
	            return undefined;
	        }
	        if (this.datepickerMode === 'day' && this.compareHandlerDay) {
	            return this.compareHandlerDay(date1, date2);
	        }
	        if (this.datepickerMode === 'month' && this.compareHandlerMonth) {
	            return this.compareHandlerMonth(date1, date2);
	        }
	        if (this.datepickerMode === 'year' && this.compareHandlerYear) {
	            return this.compareHandlerYear(date1, date2);
	        }
	        return void 0;
	    };
	    DatePickerInnerComponent.prototype.setRefreshViewHandler = function (handler, type) {
	        if (type === 'day') {
	            this.refreshViewHandlerDay = handler;
	        }
	        if (type === 'month') {
	            this.refreshViewHandlerMonth = handler;
	        }
	        if (type === 'year') {
	            this.refreshViewHandlerYear = handler;
	        }
	    };
	    DatePickerInnerComponent.prototype.refreshView = function () {
	        if (this.datepickerMode === 'day' && this.refreshViewHandlerDay) {
	            this.refreshViewHandlerDay();
	        }
	        if (this.datepickerMode === 'month' && this.refreshViewHandlerMonth) {
	            this.refreshViewHandlerMonth();
	        }
	        if (this.datepickerMode === 'year' && this.refreshViewHandlerYear) {
	            this.refreshViewHandlerYear();
	        }
	    };
	    DatePickerInnerComponent.prototype.dateFilter = function (date, format) {
	        return this.dateFormatter.format(date, format, this.locale);
	    };
	    DatePickerInnerComponent.prototype.isActive = function (dateObject) {
	        if (this.compare(dateObject.date, this.activeDate) === 0) {
	            this.activeDateId = dateObject.uid;
	            return true;
	        }
	        return false;
	    };
	    DatePickerInnerComponent.prototype.createDateObject = function (date, format) {
	        var dateObject = {};
	        dateObject.date = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	        dateObject.date = this.fixTimeZone(dateObject.date);
	        dateObject.label = this.dateFilter(date, format);
	        dateObject.selected = this.compare(date, this.selectedDate) === 0;
	        dateObject.disabled = this.isDisabled(date);
	        dateObject.current = this.compare(date, new Date()) === 0;
	        dateObject.customClass = this.getCustomClassForDate(dateObject.date);
	        return dateObject;
	    };
	    DatePickerInnerComponent.prototype.split = function (arr, size) {
	        var arrays = [];
	        while (arr.length > 0) {
	            arrays.push(arr.splice(0, size));
	        }
	        return arrays;
	    };
	    // Fix a hard-reproducible bug with timezones
	    // The bug depends on OS, browser, current timezone and current date
	    // i.e.
	    // var date = new Date(2014, 0, 1);
	    // console.log(date.getFullYear(), date.getMonth(), date.getDate(),
	    // date.getHours()); can result in "2013 11 31 23" because of the bug.
	    DatePickerInnerComponent.prototype.fixTimeZone = function (date) {
	        var hours = date.getHours();
	        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours === 23 ? hours + 2 : 0);
	    };
	    DatePickerInnerComponent.prototype.select = function (date, isManual) {
	        if (isManual === void 0) { isManual = true; }
	        if (this.datepickerMode === this.minMode) {
	            if (!this.activeDate) {
	                this.activeDate = new Date(0, 0, 0, 0, 0, 0, 0);
	            }
	            this.activeDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	            this.activeDate = this.fixTimeZone(this.activeDate);
	            if (isManual) {
	                this.selectionDone.emit(this.activeDate);
	            }
	        }
	        else {
	            this.activeDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	            this.activeDate = this.fixTimeZone(this.activeDate);
	            if (isManual) {
	                this.datepickerMode = this.modes[this.modes.indexOf(this.datepickerMode) - 1];
	            }
	        }
	        this.selectedDate = new Date(this.activeDate.valueOf());
	        this.update.emit(this.activeDate);
	        this.refreshView();
	    };
	    DatePickerInnerComponent.prototype.move = function (direction) {
	        var expectedStep;
	        if (this.datepickerMode === 'day') {
	            expectedStep = this.stepDay;
	        }
	        if (this.datepickerMode === 'month') {
	            expectedStep = this.stepMonth;
	        }
	        if (this.datepickerMode === 'year') {
	            expectedStep = this.stepYear;
	        }
	        if (expectedStep) {
	            var year = this.activeDate.getFullYear() + direction * (expectedStep.years || 0);
	            var month = this.activeDate.getMonth() + direction * (expectedStep.months || 0);
	            this.activeDate = new Date(year, month, 1);
	            this.refreshView();
	            this.activeDateChange.emit(this.activeDate);
	        }
	    };
	    DatePickerInnerComponent.prototype.toggleMode = function (_direction) {
	        var direction = _direction || 1;
	        if ((this.datepickerMode === this.maxMode && direction === 1) ||
	            (this.datepickerMode === this.minMode && direction === -1)) {
	            return;
	        }
	        this.datepickerMode = this.modes[this.modes.indexOf(this.datepickerMode) + direction];
	        this.refreshView();
	    };
	    DatePickerInnerComponent.prototype.getCustomClassForDate = function (date) {
	        var _this = this;
	        if (!this.customClass) {
	            return '';
	        }
	        // todo: build a hash of custom classes, it will work faster
	        var customClassObject = this.customClass.find(function (customClass) {
	            return (customClass.date.valueOf() === date.valueOf() &&
	                customClass.mode === _this.datepickerMode);
	        }, this);
	        return customClassObject === undefined ? '' : customClassObject.clazz;
	    };
	    DatePickerInnerComponent.prototype.compareDateDisabled = function (date1Disabled, date2) {
	        if (date1Disabled === undefined || date2 === undefined) {
	            return undefined;
	        }
	        if (date1Disabled.mode === 'day' && this.compareHandlerDay) {
	            return this.compareHandlerDay(date1Disabled.date, date2);
	        }
	        if (date1Disabled.mode === 'month' && this.compareHandlerMonth) {
	            return this.compareHandlerMonth(date1Disabled.date, date2);
	        }
	        if (date1Disabled.mode === 'year' && this.compareHandlerYear) {
	            return this.compareHandlerYear(date1Disabled.date, date2);
	        }
	        return undefined;
	    };
	    DatePickerInnerComponent.prototype.isDisabled = function (date) {
	        var _this = this;
	        var isDateDisabled = false;
	        if (this.dateDisabled) {
	            this.dateDisabled.forEach(function (disabledDate) {
	                if (_this.compareDateDisabled(disabledDate, date) === 0) {
	                    isDateDisabled = true;
	                }
	            });
	        }
	        if (this.dayDisabled) {
	            isDateDisabled =
	                isDateDisabled ||
	                    this.dayDisabled.indexOf(date.getDay()) > -1;
	        }
	        return (isDateDisabled ||
	            (this.minDate && this.compare(date, this.minDate) < 0) ||
	            (this.maxDate && this.compare(date, this.maxDate) > 0));
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], DatePickerInnerComponent.prototype, "locale", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], DatePickerInnerComponent.prototype, "datepickerMode", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number)
	    ], DatePickerInnerComponent.prototype, "startingDay", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number)
	    ], DatePickerInnerComponent.prototype, "yearRange", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], DatePickerInnerComponent.prototype, "minDate", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], DatePickerInnerComponent.prototype, "maxDate", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], DatePickerInnerComponent.prototype, "minMode", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], DatePickerInnerComponent.prototype, "maxMode", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], DatePickerInnerComponent.prototype, "showWeeks", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], DatePickerInnerComponent.prototype, "formatDay", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], DatePickerInnerComponent.prototype, "formatMonth", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], DatePickerInnerComponent.prototype, "formatYear", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], DatePickerInnerComponent.prototype, "formatDayHeader", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], DatePickerInnerComponent.prototype, "formatDayTitle", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], DatePickerInnerComponent.prototype, "formatMonthTitle", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], DatePickerInnerComponent.prototype, "onlyCurrentMonth", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], DatePickerInnerComponent.prototype, "shortcutPropagation", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Array)
	    ], DatePickerInnerComponent.prototype, "customClass", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number)
	    ], DatePickerInnerComponent.prototype, "monthColLimit", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number)
	    ], DatePickerInnerComponent.prototype, "yearColLimit", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Array)
	    ], DatePickerInnerComponent.prototype, "dateDisabled", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Array)
	    ], DatePickerInnerComponent.prototype, "dayDisabled", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], DatePickerInnerComponent.prototype, "initDate", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
	    ], DatePickerInnerComponent.prototype, "selectionDone", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
	    ], DatePickerInnerComponent.prototype, "update", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _c || Object)
	    ], DatePickerInnerComponent.prototype, "activeDateChange", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [Object])
	    ], DatePickerInnerComponent.prototype, "activeDate", null);
	    DatePickerInnerComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'datepicker-inner',
	            template: "\n    <!--&lt;!&ndash;ng-keydown=\"keydown($event)\"&ndash;&gt;-->\n    <div *ngIf=\"datepickerMode\" class=\"well well-sm bg-faded p-a card\" role=\"application\" >\n      <ng-content></ng-content>\n    </div>\n  "
	        })
	    ], DatePickerInnerComponent);
	    return DatePickerInnerComponent;
	    var _a, _b, _c;
	}());
	
	
	
	/***/ }),
	/* 30 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDatepickerActions; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	var BsDatepickerActions = (function () {
	    function BsDatepickerActions() {
	    }
	    BsDatepickerActions_1 = BsDatepickerActions;
	    BsDatepickerActions.prototype.calculate = function () {
	        return { type: BsDatepickerActions_1.CALCULATE };
	    };
	    BsDatepickerActions.prototype.format = function () {
	        return { type: BsDatepickerActions_1.FORMAT };
	    };
	    BsDatepickerActions.prototype.flag = function () {
	        return { type: BsDatepickerActions_1.FLAG };
	    };
	    BsDatepickerActions.prototype.select = function (date) {
	        return {
	            type: BsDatepickerActions_1.SELECT,
	            payload: date
	        };
	    };
	    BsDatepickerActions.prototype.changeViewMode = function (event) {
	        return {
	            type: BsDatepickerActions_1.CHANGE_VIEWMODE,
	            payload: event
	        };
	    };
	    BsDatepickerActions.prototype.navigateTo = function (event) {
	        return {
	            type: BsDatepickerActions_1.NAVIGATE_TO,
	            payload: event
	        };
	    };
	    BsDatepickerActions.prototype.navigateStep = function (step) {
	        return {
	            type: BsDatepickerActions_1.NAVIGATE_OFFSET,
	            payload: step
	        };
	    };
	    BsDatepickerActions.prototype.setOptions = function (options) {
	        return {
	            type: BsDatepickerActions_1.SET_OPTIONS,
	            payload: options
	        };
	    };
	    // date range picker
	    BsDatepickerActions.prototype.selectRange = function (value) {
	        return {
	            type: BsDatepickerActions_1.SELECT_RANGE,
	            payload: value
	        };
	    };
	    BsDatepickerActions.prototype.hoverDay = function (event) {
	        return {
	            type: BsDatepickerActions_1.HOVER,
	            payload: event.isHovered ? event.cell.date : null
	        };
	    };
	    BsDatepickerActions.prototype.minDate = function (date) {
	        return {
	            type: BsDatepickerActions_1.SET_MIN_DATE,
	            payload: date
	        };
	    };
	    BsDatepickerActions.prototype.maxDate = function (date) {
	        return {
	            type: BsDatepickerActions_1.SET_MAX_DATE,
	            payload: date
	        };
	    };
	    BsDatepickerActions.prototype.isDisabled = function (value) {
	        return {
	            type: BsDatepickerActions_1.SET_IS_DISABLED,
	            payload: value
	        };
	    };
	    BsDatepickerActions.prototype.setLocale = function (locale) {
	        return {
	            type: BsDatepickerActions_1.SET_LOCALE,
	            payload: locale
	        };
	    };
	    BsDatepickerActions.CALCULATE = '[datepicker] calculate dates matrix';
	    BsDatepickerActions.FORMAT = '[datepicker] format datepicker values';
	    BsDatepickerActions.FLAG = '[datepicker] set flags';
	    BsDatepickerActions.SELECT = '[datepicker] select date';
	    BsDatepickerActions.NAVIGATE_OFFSET = '[datepicker] shift view date';
	    BsDatepickerActions.NAVIGATE_TO = '[datepicker] change view date';
	    BsDatepickerActions.SET_OPTIONS = '[datepicker] update render options';
	    BsDatepickerActions.HOVER = '[datepicker] hover date';
	    BsDatepickerActions.CHANGE_VIEWMODE = '[datepicker] switch view mode';
	    BsDatepickerActions.SET_MIN_DATE = '[datepicker] set min date';
	    BsDatepickerActions.SET_MAX_DATE = '[datepicker] set max date';
	    BsDatepickerActions.SET_IS_DISABLED = '[datepicker] set is disabled';
	    BsDatepickerActions.SET_LOCALE = '[datepicker] set datepicker locale';
	    BsDatepickerActions.SELECT_RANGE = '[daterangepicker] select dates range';
	    BsDatepickerActions = BsDatepickerActions_1 = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	    ], BsDatepickerActions);
	    return BsDatepickerActions;
	    var BsDatepickerActions_1;
	}());
	
	
	
	/***/ }),
	/* 31 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsLocaleService; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__ = __webpack_require__(38);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	var BsLocaleService = (function () {
	    function BsLocaleService() {
	        this._defaultLocale = 'en';
	        this._locale = new __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__["BehaviorSubject"](this._defaultLocale);
	        this._localeChange = this._locale.asObservable();
	    }
	    Object.defineProperty(BsLocaleService.prototype, "locale", {
	        get: function () {
	            return this._locale;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BsLocaleService.prototype, "localeChange", {
	        get: function () {
	            return this._localeChange;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BsLocaleService.prototype, "currentLocale", {
	        get: function () {
	            return this._locale.getValue();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BsLocaleService.prototype.use = function (locale) {
	        if (locale === this.currentLocale) {
	            return;
	        }
	        this._locale.next(locale);
	    };
	    BsLocaleService = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	    ], BsLocaleService);
	    return BsLocaleService;
	}());
	
	
	
	/***/ }),
	/* 32 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsNavigationDirection; });
	/** *************** */
	// events
	/** *************** */
	var BsNavigationDirection;
	(function (BsNavigationDirection) {
	    BsNavigationDirection[BsNavigationDirection["UP"] = 0] = "UP";
	    BsNavigationDirection[BsNavigationDirection["DOWN"] = 1] = "DOWN";
	})(BsNavigationDirection || (BsNavigationDirection = {}));
	
	
	/***/ }),
	/* 33 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ModalOptions; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return modalConfigDefaults; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLASS_NAME; });
	/* unused harmony export SELECTOR */
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRANSITION_DURATIONS; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DISMISS_REASONS; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	var ModalOptions = (function () {
	    function ModalOptions() {
	    }
	    ModalOptions = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	    ], ModalOptions);
	    return ModalOptions;
	}());
	
	var modalConfigDefaults = {
	    backdrop: true,
	    keyboard: true,
	    focus: true,
	    show: false,
	    ignoreBackdropClick: false,
	    class: '',
	    animated: true,
	    initialState: {}
	};
	var CLASS_NAME = {
	    SCROLLBAR_MEASURER: 'modal-scrollbar-measure',
	    BACKDROP: 'modal-backdrop',
	    OPEN: 'modal-open',
	    FADE: 'fade',
	    IN: 'in',
	    SHOW: 'show' // bs4
	};
	var SELECTOR = {
	    DIALOG: '.modal-dialog',
	    DATA_TOGGLE: '[data-toggle="modal"]',
	    DATA_DISMISS: '[data-dismiss="modal"]',
	    FIXED_CONTENT: '.navbar-fixed-top, .navbar-fixed-bottom, .is-fixed'
	};
	var TRANSITION_DURATIONS = {
	    MODAL: 300,
	    BACKDROP: 150
	};
	var DISMISS_REASONS = {
	    BACKRDOP: 'backdrop-click',
	    ESC: 'esc'
	};
	
	
	/***/ }),
	/* 34 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return defaultLocaleMonths; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return defaultLocaleMonthsShort; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return defaultLocaleWeekdays; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return defaultLocaleWeekdaysShort; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return defaultLocaleWeekdaysMin; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return defaultLongDateFormat; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return defaultOrdinal; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defaultDayOfMonthOrdinalParse; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Locale; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__units_week_calendar_utils__ = __webpack_require__(26);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_type_checks__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_date_getters__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parse_regex__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__units_day_of_week__ = __webpack_require__(14);
	// tslint:disable:max-file-line-count max-line-length cyclomatic-complexity
	
	
	
	
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	var defaultLongDateFormat = {
	    LTS: 'h:mm:ss A',
	    LT: 'h:mm A',
	    L: 'MM/DD/YYYY',
	    LL: 'MMMM D, YYYY',
	    LLL: 'MMMM D, YYYY h:mm A',
	    LLLL: 'dddd, MMMM D, YYYY h:mm A'
	};
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	var defaultMonthsShortRegex = __WEBPACK_IMPORTED_MODULE_3__parse_regex__["s" /* matchWord */];
	var defaultMonthsRegex = __WEBPACK_IMPORTED_MODULE_3__parse_regex__["s" /* matchWord */];
	var Locale = (function () {
	    function Locale(config) {
	        if (!!config) {
	            this.set(config);
	        }
	    }
	    Locale.prototype.set = function (config) {
	        var confKey;
	        for (confKey in config) {
	            if (!config.hasOwnProperty(confKey)) {
	                continue;
	            }
	            var prop = config[confKey];
	            var key = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["e" /* isFunction */])(prop) ? confKey : "_" + confKey);
	            this[key] = prop;
	        }
	        this._config = config;
	    };
	    Locale.prototype.calendar = function (key, date, now) {
	        var output = this._calendar[key] || this._calendar.sameElse;
	        return Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["e" /* isFunction */])(output) ? output.call(null, date, now) : output;
	    };
	    Locale.prototype.longDateFormat = function (key) {
	        var format = this._longDateFormat[key];
	        var formatUpper = this._longDateFormat[key.toUpperCase()];
	        if (format || !formatUpper) {
	            return format;
	        }
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	        return this._longDateFormat[key];
	    };
	    Object.defineProperty(Locale.prototype, "invalidDate", {
	        get: function () {
	            return this._invalidDate;
	        },
	        set: function (val) {
	            this._invalidDate = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Locale.prototype.ordinal = function (num, token) {
	        return this._ordinal.replace('%d', num.toString(10));
	    };
	    Locale.prototype.preparse = function (str) {
	        return str;
	    };
	    Locale.prototype.postformat = function (str) {
	        return str;
	    };
	    Locale.prototype.relativeTime = function (num, withoutSuffix, str, isFuture) {
	        var output = this._relativeTime[str];
	        return (Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["e" /* isFunction */])(output)) ?
	            output(num, withoutSuffix, str, isFuture) :
	            output.replace(/%d/i, num.toString(10));
	    };
	    Locale.prototype.pastFuture = function (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["e" /* isFunction */])(format) ? format(output) : format.replace(/%s/i, output);
	    };
	    Locale.prototype.months = function (date, format, isUTC) {
	        if (isUTC === void 0) { isUTC = false; }
	        if (!date) {
	            return Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["b" /* isArray */])(this._months)
	                ? this._months
	                : this._months.standalone;
	        }
	        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["b" /* isArray */])(this._months)) {
	            return this._months[Object(__WEBPACK_IMPORTED_MODULE_2__utils_date_getters__["h" /* getMonth */])(date, isUTC)];
	        }
	        var key = (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	            ? 'format'
	            : 'standalone';
	        return this._months[key][Object(__WEBPACK_IMPORTED_MODULE_2__utils_date_getters__["h" /* getMonth */])(date, isUTC)];
	    };
	    Locale.prototype.monthsShort = function (date, format, isUTC) {
	        if (isUTC === void 0) { isUTC = false; }
	        if (!date) {
	            return Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["b" /* isArray */])(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort.standalone;
	        }
	        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["b" /* isArray */])(this._monthsShort)) {
	            return this._monthsShort[Object(__WEBPACK_IMPORTED_MODULE_2__utils_date_getters__["h" /* getMonth */])(date, isUTC)];
	        }
	        var key = MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone';
	        return this._monthsShort[key][Object(__WEBPACK_IMPORTED_MODULE_2__utils_date_getters__["h" /* getMonth */])(date, isUTC)];
	    };
	    Locale.prototype.monthsParse = function (monthName, format, strict) {
	        var date;
	        var regex;
	        if (this._monthsParseExact) {
	            return this.handleMonthStrictParse(monthName, format, strict);
	        }
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        var i;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            date = new Date(Date.UTC(2000, i));
	            if (strict && !this._longMonthsParse[i]) {
	                var _months = this.months(date, '').replace('.', '');
	                var _shortMonths = this.monthsShort(date, '').replace('.', '');
	                this._longMonthsParse[i] = new RegExp("^" + _months + "$", 'i');
	                this._shortMonthsParse[i] = new RegExp("^" + _shortMonths + "$", 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = "^" + this.months(date, '') + "|^" + this.monthsShort(date, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            }
	            if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            }
	            if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    };
	    Locale.prototype.monthsRegex = function (isStrict) {
	        if (this._monthsParseExact) {
	            if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["a" /* hasOwnProp */])(this, '_monthsRegex')) {
	                this.computeMonthsParse();
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            }
	            return this._monthsRegex;
	        }
	        if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["a" /* hasOwnProp */])(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    };
	    Locale.prototype.monthsShortRegex = function (isStrict) {
	        if (this._monthsParseExact) {
	            if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["a" /* hasOwnProp */])(this, '_monthsRegex')) {
	                this.computeMonthsParse();
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            }
	            return this._monthsShortRegex;
	        }
	        if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["a" /* hasOwnProp */])(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    };
	    /** Week */
	    Locale.prototype.week = function (date) {
	        return Object(__WEBPACK_IMPORTED_MODULE_0__units_week_calendar_utils__["b" /* weekOfYear */])(date, this._week.dow, this._week.doy).week;
	    };
	    Locale.prototype.firstDayOfWeek = function () {
	        return this._week.dow;
	    };
	    Locale.prototype.firstDayOfYear = function () {
	        return this._week.doy;
	    };
	    Locale.prototype.weekdays = function (date, format, isUTC) {
	        if (!date) {
	            return Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["b" /* isArray */])(this._weekdays)
	                ? this._weekdays
	                : this._weekdays.standalone;
	        }
	        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["b" /* isArray */])(this._weekdays)) {
	            return this._weekdays[Object(__WEBPACK_IMPORTED_MODULE_2__utils_date_getters__["b" /* getDay */])(date, isUTC)];
	        }
	        var _key = this._weekdays.isFormat.test(format)
	            ? 'format'
	            : 'standalone';
	        return this._weekdays[_key][Object(__WEBPACK_IMPORTED_MODULE_2__utils_date_getters__["b" /* getDay */])(date, isUTC)];
	    };
	    Locale.prototype.weekdaysMin = function (date, format, isUTC) {
	        return date ? this._weekdaysMin[Object(__WEBPACK_IMPORTED_MODULE_2__utils_date_getters__["b" /* getDay */])(date, isUTC)] : this._weekdaysMin;
	    };
	    Locale.prototype.weekdaysShort = function (date, format, isUTC) {
	        return date ? this._weekdaysShort[Object(__WEBPACK_IMPORTED_MODULE_2__utils_date_getters__["b" /* getDay */])(date, isUTC)] : this._weekdaysShort;
	    };
	    // proto.weekdaysParse  =        localeWeekdaysParse;
	    Locale.prototype.weekdaysParse = function (weekdayName, format, strict) {
	        var i;
	        var regex;
	        if (this._weekdaysParseExact) {
	            return this.handleWeekStrictParse(weekdayName, format, strict);
	        }
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            // fix: here is the issue
	            var date = Object(__WEBPACK_IMPORTED_MODULE_4__units_day_of_week__["d" /* setDayOfWeek */])(new Date(Date.UTC(2000, 1)), i, null, true);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(date, '').replace('.', '\.?') + "$", 'i');
	                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(date).replace('.', '\.?') + "$", 'i');
	                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(date).replace('.', '\.?') + "$", 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = "^" + this.weekdays(date, '') + "|^" + this.weekdaysShort(date) + "|^" + this.weekdaysMin(date);
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["b" /* isArray */])(this._fullWeekdaysParse)
	                || !Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["b" /* isArray */])(this._shortWeekdaysParse)
	                || !Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["b" /* isArray */])(this._minWeekdaysParse)
	                || !Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["b" /* isArray */])(this._weekdaysParse)) {
	                return;
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	            else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    };
	    // proto.weekdaysRegex       =        weekdaysRegex;
	    Locale.prototype.weekdaysRegex = function (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["a" /* hasOwnProp */])(this, '_weekdaysRegex')) {
	                this.computeWeekdaysParse();
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            }
	            else {
	                return this._weekdaysRegex;
	            }
	        }
	        else {
	            if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["a" /* hasOwnProp */])(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = __WEBPACK_IMPORTED_MODULE_3__parse_regex__["s" /* matchWord */];
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    };
	    // proto.weekdaysShortRegex  =        weekdaysShortRegex;
	    // proto.weekdaysMinRegex    =        weekdaysMinRegex;
	    Locale.prototype.weekdaysShortRegex = function (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["a" /* hasOwnProp */])(this, '_weekdaysRegex')) {
	                this.computeWeekdaysParse();
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            }
	            else {
	                return this._weekdaysShortRegex;
	            }
	        }
	        else {
	            if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["a" /* hasOwnProp */])(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = __WEBPACK_IMPORTED_MODULE_3__parse_regex__["s" /* matchWord */];
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    };
	    Locale.prototype.weekdaysMinRegex = function (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["a" /* hasOwnProp */])(this, '_weekdaysRegex')) {
	                this.computeWeekdaysParse();
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            }
	            else {
	                return this._weekdaysMinRegex;
	            }
	        }
	        else {
	            if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["a" /* hasOwnProp */])(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = __WEBPACK_IMPORTED_MODULE_3__parse_regex__["s" /* matchWord */];
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    };
	    Locale.prototype.isPM = function (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return input.toLowerCase().charAt(0) === 'p';
	    };
	    Locale.prototype.meridiem = function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        }
	        return isLower ? 'am' : 'AM';
	    };
	    Locale.prototype.formatLongDate = function (key) {
	        this._longDateFormat = this._longDateFormat ? this._longDateFormat : defaultLongDateFormat;
	        var format = this._longDateFormat[key];
	        var formatUpper = this._longDateFormat[key.toUpperCase()];
	        if (format || !formatUpper) {
	            return format;
	        }
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	        return this._longDateFormat[key];
	    };
	    Locale.prototype.handleMonthStrictParse = function (monthName, format, strict) {
	        var llc = monthName.toLocaleLowerCase();
	        var i;
	        var ii;
	        var mom;
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = new Date(2000, i);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	        if (strict) {
	            if (format === 'MMM') {
	                ii = this._shortMonthsParse.indexOf(llc);
	                return ii !== -1 ? ii : null;
	            }
	            ii = this._longMonthsParse.indexOf(llc);
	            return ii !== -1 ? ii : null;
	        }
	        if (format === 'MMM') {
	            ii = this._shortMonthsParse.indexOf(llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = this._longMonthsParse.indexOf(llc);
	            return ii !== -1 ? ii : null;
	        }
	        ii = this._longMonthsParse.indexOf(llc);
	        if (ii !== -1) {
	            return ii;
	        }
	        ii = this._shortMonthsParse.indexOf(llc);
	        return ii !== -1 ? ii : null;
	    };
	    Locale.prototype.handleWeekStrictParse = function (weekdayName, format, strict) {
	        var ii;
	        var llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	            var i = void 0;
	            for (i = 0; i < 7; ++i) {
	                var date = Object(__WEBPACK_IMPORTED_MODULE_4__units_day_of_week__["d" /* setDayOfWeek */])(new Date(Date.UTC(2000, 1)), i, null, true);
	                this._minWeekdaysParse[i] = this.weekdaysMin(date).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(date).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(date, '').toLocaleLowerCase();
	            }
	        }
	        if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["b" /* isArray */])(this._weekdaysParse)
	            || !Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["b" /* isArray */])(this._shortWeekdaysParse)
	            || !Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["b" /* isArray */])(this._minWeekdaysParse)) {
	            return;
	        }
	        if (strict) {
	            if (format === 'dddd') {
	                ii = this._weekdaysParse.indexOf(llc);
	                return ii !== -1 ? ii : null;
	            }
	            else if (format === 'ddd') {
	                ii = this._shortWeekdaysParse.indexOf(llc);
	                return ii !== -1 ? ii : null;
	            }
	            else {
	                ii = this._minWeekdaysParse.indexOf(llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	        else {
	            if (format === 'dddd') {
	                ii = this._weekdaysParse.indexOf(llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = this._shortWeekdaysParse.indexOf(llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = this._minWeekdaysParse.indexOf(llc);
	                return ii !== -1 ? ii : null;
	            }
	            else if (format === 'ddd') {
	                ii = this._shortWeekdaysParse.indexOf(llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = this._weekdaysParse.indexOf(llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = this._minWeekdaysParse.indexOf(llc);
	                return ii !== -1 ? ii : null;
	            }
	            else {
	                ii = this._minWeekdaysParse.indexOf(llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = this._weekdaysParse.indexOf(llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = this._shortWeekdaysParse.indexOf(llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    };
	    Locale.prototype.computeMonthsParse = function () {
	        var shortPieces = [];
	        var longPieces = [];
	        var mixedPieces = [];
	        var date;
	        var i;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            date = new Date(2000, i);
	            shortPieces.push(this.monthsShort(date, ''));
	            longPieces.push(this.months(date, ''));
	            mixedPieces.push(this.months(date, ''));
	            mixedPieces.push(this.monthsShort(date, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["t" /* regexEscape */])(shortPieces[i]);
	            longPieces[i] = Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["t" /* regexEscape */])(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["t" /* regexEscape */])(mixedPieces[i]);
	        }
	        this._monthsRegex = new RegExp("^(" + mixedPieces.join('|') + ")", 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp("^(" + longPieces.join('|') + ")", 'i');
	        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join('|') + ")", 'i');
	    };
	    Locale.prototype.computeWeekdaysParse = function () {
	        var minPieces = [];
	        var shortPieces = [];
	        var longPieces = [];
	        var mixedPieces = [];
	        var i;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            // let mom = createUTC([2000, 1]).day(i);
	            var date = Object(__WEBPACK_IMPORTED_MODULE_4__units_day_of_week__["d" /* setDayOfWeek */])(new Date(Date.UTC(2000, 1)), i, null, true);
	            var minp = this.weekdaysMin(date);
	            var shortp = this.weekdaysShort(date);
	            var longp = this.weekdays(date);
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["t" /* regexEscape */])(shortPieces[i]);
	            longPieces[i] = Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["t" /* regexEscape */])(longPieces[i]);
	            mixedPieces[i] = Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["t" /* regexEscape */])(mixedPieces[i]);
	        }
	        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join('|') + ")", 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join('|') + ")", 'i');
	        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join('|') + ")", 'i');
	        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join('|') + ")", 'i');
	    };
	    return Locale;
	}());
	
	function cmpLenRev(a, b) {
	    return b.length - a.length;
	}
	
	
	/***/ }),
	/* 35 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = parseDate;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__from_anything__ = __webpack_require__(145);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_type_checks__ = __webpack_require__(1);
	
	
	function parseDate(input, format, localeKey, strict, isUTC) {
	    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["c" /* isDate */])(input)) {
	        return input;
	    }
	    var config = Object(__WEBPACK_IMPORTED_MODULE_0__from_anything__["a" /* createLocalOrUTC */])(input, format, localeKey, strict, isUTC);
	    return config._d;
	}
	
	
	/***/ }),
	/* 36 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decorators__ = __webpack_require__(57);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__decorators__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linked_list_class__ = __webpack_require__(168);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__linked_list_class__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme_provider__ = __webpack_require__(7);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__theme_provider__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__trigger_class__ = __webpack_require__(98);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__trigger_class__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_class__ = __webpack_require__(60);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__utils_class__["a"]; });
	/* unused harmony reexport setTheme */
	
	
	
	
	
	
	
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_37__;
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_38__;
	
	/***/ }),
	/* 39 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = getStartingDayOfCalendar;
	/* unused harmony export calculateDateOffset */
	/* harmony export (immutable) */ __webpack_exports__["b"] = isMonthDisabled;
	/* harmony export (immutable) */ __webpack_exports__["c"] = isYearDisabled;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chronos_utils_date_getters__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chronos_utils_date_setters__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chronos_utils_date_compare__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chronos_utils_start_end_of__ = __webpack_require__(27);
	
	
	
	
	function getStartingDayOfCalendar(date, options) {
	    if (Object(__WEBPACK_IMPORTED_MODULE_0__chronos_utils_date_getters__["k" /* isFirstDayOfWeek */])(date, options.firstDayOfWeek)) {
	        return date;
	    }
	    var weekDay = Object(__WEBPACK_IMPORTED_MODULE_0__chronos_utils_date_getters__["b" /* getDay */])(date);
	    var offset = calculateDateOffset(weekDay, options.firstDayOfWeek);
	    return Object(__WEBPACK_IMPORTED_MODULE_1__chronos_utils_date_setters__["j" /* shiftDate */])(date, { day: -offset });
	}
	function calculateDateOffset(weekday, startingDayOffset) {
	    if (startingDayOffset === 0) {
	        return weekday;
	    }
	    var offset = weekday - startingDayOffset % 7;
	    return offset < 0 ? offset + 7 : offset;
	}
	function isMonthDisabled(date, min, max) {
	    var minBound = min && Object(__WEBPACK_IMPORTED_MODULE_2__chronos_utils_date_compare__["b" /* isBefore */])(Object(__WEBPACK_IMPORTED_MODULE_3__chronos_utils_start_end_of__["a" /* endOf */])(date, 'month'), min, 'day');
	    var maxBound = max && Object(__WEBPACK_IMPORTED_MODULE_2__chronos_utils_date_compare__["a" /* isAfter */])(Object(__WEBPACK_IMPORTED_MODULE_3__chronos_utils_start_end_of__["b" /* startOf */])(date, 'month'), max, 'day');
	    return minBound || maxBound;
	}
	function isYearDisabled(date, min, max) {
	    var minBound = min && Object(__WEBPACK_IMPORTED_MODULE_2__chronos_utils_date_compare__["b" /* isBefore */])(Object(__WEBPACK_IMPORTED_MODULE_3__chronos_utils_start_end_of__["a" /* endOf */])(date, 'year'), min, 'day');
	    var maxBound = max && Object(__WEBPACK_IMPORTED_MODULE_2__chronos_utils_date_compare__["a" /* isAfter */])(Object(__WEBPACK_IMPORTED_MODULE_3__chronos_utils_start_end_of__["b" /* startOf */])(date, 'year'), max, 'day');
	    return minBound || maxBound;
	}
	
	
	/***/ }),
	/* 40 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalBackdropComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_options_class__ = __webpack_require__(33);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_theme_provider__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_utils_class__ = __webpack_require__(60);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	
	/** This component will be added as background layout for modals if enabled */
	var ModalBackdropComponent = (function () {
	    function ModalBackdropComponent(element, renderer) {
	        this._isShown = false;
	        this.element = element;
	        this.renderer = renderer;
	    }
	    Object.defineProperty(ModalBackdropComponent.prototype, "isAnimated", {
	        get: function () {
	            return this._isAnimated;
	        },
	        set: function (value) {
	            this._isAnimated = value;
	            // this.renderer.setElementClass(this.element.nativeElement, `${ClassName.FADE}`, value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ModalBackdropComponent.prototype, "isShown", {
	        get: function () {
	            return this._isShown;
	        },
	        set: function (value) {
	            this._isShown = value;
	            if (value) {
	                this.renderer.addClass(this.element.nativeElement, "" + __WEBPACK_IMPORTED_MODULE_1__modal_options_class__["a" /* CLASS_NAME */].IN);
	            }
	            else {
	                this.renderer.removeClass(this.element.nativeElement, "" + __WEBPACK_IMPORTED_MODULE_1__modal_options_class__["a" /* CLASS_NAME */].IN);
	            }
	            if (!Object(__WEBPACK_IMPORTED_MODULE_2__utils_theme_provider__["a" /* isBs3 */])()) {
	                if (value) {
	                    this.renderer.addClass(this.element.nativeElement, "" + __WEBPACK_IMPORTED_MODULE_1__modal_options_class__["a" /* CLASS_NAME */].SHOW);
	                }
	                else {
	                    this.renderer.removeClass(this.element.nativeElement, "" + __WEBPACK_IMPORTED_MODULE_1__modal_options_class__["a" /* CLASS_NAME */].SHOW);
	                }
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ModalBackdropComponent.prototype.ngOnInit = function () {
	        if (this.isAnimated) {
	            this.renderer.addClass(this.element.nativeElement, "" + __WEBPACK_IMPORTED_MODULE_1__modal_options_class__["a" /* CLASS_NAME */].FADE);
	            __WEBPACK_IMPORTED_MODULE_3__utils_utils_class__["a" /* Utils */].reflow(this.element.nativeElement);
	        }
	        this.isShown = true;
	    };
	    ModalBackdropComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'bs-modal-backdrop',
	            template: ' ',
	            host: { class: __WEBPACK_IMPORTED_MODULE_1__modal_options_class__["a" /* CLASS_NAME */].BACKDROP }
	        }),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]) === "function" && _b || Object])
	    ], ModalBackdropComponent);
	    return ModalBackdropComponent;
	    var _a, _b;
	}());
	
	
	
	/***/ }),
	/* 41 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaginationConfig; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	// todo: split
	
	/** Provides default values for Pagination and pager components */
	var PaginationConfig = (function () {
	    function PaginationConfig() {
	        this.main = {
	            maxSize: void 0,
	            itemsPerPage: 10,
	            boundaryLinks: false,
	            directionLinks: true,
	            firstText: 'First',
	            previousText: 'Previous',
	            nextText: 'Next',
	            lastText: 'Last',
	            pageBtnClass: '',
	            rotate: true
	        };
	        this.pager = {
	            itemsPerPage: 15,
	            previousText: '« Previous',
	            nextText: 'Next »',
	            pageBtnClass: '',
	            align: true
	        };
	    }
	    PaginationConfig = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	    ], PaginationConfig);
	    return PaginationConfig;
	}());
	
	
	
	/***/ }),
	/* 42 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimepickerActions; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	var TimepickerActions = (function () {
	    function TimepickerActions() {
	    }
	    TimepickerActions_1 = TimepickerActions;
	    TimepickerActions.prototype.writeValue = function (value) {
	        return {
	            type: TimepickerActions_1.WRITE_VALUE,
	            payload: value
	        };
	    };
	    TimepickerActions.prototype.changeHours = function (event) {
	        return {
	            type: TimepickerActions_1.CHANGE_HOURS,
	            payload: event
	        };
	    };
	    TimepickerActions.prototype.changeMinutes = function (event) {
	        return {
	            type: TimepickerActions_1.CHANGE_MINUTES,
	            payload: event
	        };
	    };
	    TimepickerActions.prototype.changeSeconds = function (event) {
	        return {
	            type: TimepickerActions_1.CHANGE_SECONDS,
	            payload: event
	        };
	    };
	    TimepickerActions.prototype.setTime = function (value) {
	        return {
	            type: TimepickerActions_1.SET_TIME_UNIT,
	            payload: value
	        };
	    };
	    TimepickerActions.prototype.updateControls = function (value) {
	        return {
	            type: TimepickerActions_1.UPDATE_CONTROLS,
	            payload: value
	        };
	    };
	    TimepickerActions.WRITE_VALUE = '[timepicker] write value from ng model';
	    TimepickerActions.CHANGE_HOURS = '[timepicker] change hours';
	    TimepickerActions.CHANGE_MINUTES = '[timepicker] change minutes';
	    TimepickerActions.CHANGE_SECONDS = '[timepicker] change seconds';
	    TimepickerActions.SET_TIME_UNIT = '[timepicker] set time unit';
	    TimepickerActions.UPDATE_CONTROLS = '[timepicker] update controls';
	    TimepickerActions = TimepickerActions_1 = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	    ], TimepickerActions);
	    return TimepickerActions;
	    var TimepickerActions_1;
	}());
	
	
	
	/***/ }),
	/* 43 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimepickerConfig; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	/** Provides default configuration values for timepicker */
	var TimepickerConfig = (function () {
	    function TimepickerConfig() {
	        /** hours change step */
	        this.hourStep = 1;
	        /** hours change step */
	        this.minuteStep = 5;
	        /** seconds changes step */
	        this.secondsStep = 10;
	        /** if true works in 12H mode and displays AM/PM. If false works in 24H mode and hides AM/PM */
	        this.showMeridian = true;
	        /** meridian labels based on locale */
	        this.meridians = ['AM', 'PM'];
	        /** if true hours and minutes fields will be readonly */
	        this.readonlyInput = false;
	        /** if true hours and minutes fields will be disabled */
	        this.disabled = false;
	        /** if true scroll inside hours and minutes inputs will change time */
	        this.mousewheel = true;
	        /** if true up/down arrowkeys inside hours and minutes inputs will change time */
	        this.arrowkeys = true;
	        /** if true spinner arrows above and below the inputs will be shown */
	        this.showSpinners = true;
	        /** show seconds in timepicker */
	        this.showSeconds = false;
	        /** show minutes in timepicker */
	        this.showMinutes = true;
	    }
	    TimepickerConfig = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	    ], TimepickerConfig);
	    return TimepickerConfig;
	}());
	
	
	
	/***/ }),
	/* 44 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TooltipConfig; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	/** Default values provider for tooltip */
	var TooltipConfig = (function () {
	    function TooltipConfig() {
	        /** tooltip placement, supported positions: 'top', 'bottom', 'left', 'right' */
	        this.placement = 'top';
	        /** array of event names which triggers tooltip opening */
	        this.triggers = 'hover focus';
	    }
	    TooltipConfig = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	    ], TooltipConfig);
	    return TooltipConfig;
	}());
	
	
	
	/***/ }),
	/* 45 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopoverConfig; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	/**
	 * Configuration service for the Popover directive.
	 * You can inject this service, typically in your root component, and customize
	 * the values of its properties in order to provide default values for all the
	 * popovers used in the application.
	 */
	var PopoverConfig = (function () {
	    function PopoverConfig() {
	        /**
	         * Placement of a popover. Accepts: "top", "bottom", "left", "right", "auto"
	         */
	        this.placement = 'top';
	        /**
	         * Specifies events that should trigger. Supports a space separated list of
	         * event names.
	         */
	        this.triggers = 'click';
	        this.outsideClick = false;
	    }
	    PopoverConfig = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	    ], PopoverConfig);
	    return PopoverConfig;
	}());
	
	
	
	/***/ }),
	/* 46 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = zeroFill;
	function zeroFill(num, targetLength, forceSign) {
	    var absNumber = "" + Math.abs(num);
	    var zerosToFill = targetLength - absNumber.length;
	    var sign = num >= 0;
	    var _sign = sign ? (forceSign ? '+' : '') : '-';
	    // todo: this is crazy slow
	    var _zeros = Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1);
	    return (_sign + _zeros + absNumber);
	}
	
	
	/***/ }),
	/* 47 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["b"] = mod;
	/* harmony export (immutable) */ __webpack_exports__["a"] = absFloor;
	function mod(n, x) {
	    return (n % x + x) % x;
	}
	function absFloor(num) {
	    return num < 0 ? Math.ceil(num) || 0 : Math.floor(num);
	}
	
	
	/***/ }),
	/* 48 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = daysInMonth;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__year__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(47);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_date_getters__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parse_regex__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parse_token__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(9);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_type_checks__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__priorities__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__aliases__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__create_parsing_flags__ = __webpack_require__(16);
	
	
	
	
	
	
	
	
	
	
	
	// todo: this is duplicate, source in date-getters.ts
	function daysInMonth(year, month) {
	    if (isNaN(year) || isNaN(month)) {
	        return NaN;
	    }
	    var modMonth = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* mod */])(month, 12);
	    var _year = year + (month - modMonth) / 12;
	    return modMonth === 1
	        ? Object(__WEBPACK_IMPORTED_MODULE_1__year__["b" /* isLeapYear */])(_year) ? 29 : 28
	        : (31 - modMonth % 7 % 2);
	}
	// FORMATTING
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('M', ['MM', 2, false], 'Mo', function (date, opts) {
	    return (Object(__WEBPACK_IMPORTED_MODULE_3__utils_date_getters__["h" /* getMonth */])(date, opts.isUTC) + 1).toString(10);
	});
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('MMM', null, null, function (date, opts) {
	    return opts.locale.monthsShort(date, opts.format, opts.isUTC);
	});
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('MMMM', null, null, function (date, opts) {
	    return opts.locale.months(date, opts.format, opts.isUTC);
	});
	// ALIASES
	Object(__WEBPACK_IMPORTED_MODULE_9__aliases__["a" /* addUnitAlias */])('month', 'M');
	// PRIORITY
	Object(__WEBPACK_IMPORTED_MODULE_8__priorities__["a" /* addUnitPriority */])('month', 8);
	// PARSING
	Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('M', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["d" /* match1to2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('MM', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_4__parse_regex__["h" /* match2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('MMM', function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["a" /* addParseToken */])(['M', 'MM'], function (input, array, config) {
	    array[__WEBPACK_IMPORTED_MODULE_6__constants__["e" /* MONTH */]] = Object(__WEBPACK_IMPORTED_MODULE_7__utils_type_checks__["k" /* toInt */])(input) - 1;
	    return config;
	});
	Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["a" /* addParseToken */])(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[__WEBPACK_IMPORTED_MODULE_6__constants__["e" /* MONTH */]] = month;
	    }
	    else {
	        Object(__WEBPACK_IMPORTED_MODULE_10__create_parsing_flags__["a" /* getParsingFlags */])(config).invalidMonth = !!input;
	    }
	    return config;
	});
	
	
	/***/ }),
	/* 49 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["b"] = isValid;
	/* harmony export (immutable) */ __webpack_exports__["a"] = createInvalid;
	/* harmony export (immutable) */ __webpack_exports__["c"] = markInvalid;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parsing_flags__ = __webpack_require__(16);
	
	function isValid(config) {
	    if (config._isValid == null) {
	        var flags = Object(__WEBPACK_IMPORTED_MODULE_0__parsing_flags__["a" /* getParsingFlags */])(config);
	        var parsedParts = Array.prototype.some.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(config._d && config._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.weekdayMismatch &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	        if (config._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	        if (Object.isFrozen == null || !Object.isFrozen(config)) {
	            config._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return config._isValid;
	}
	function createInvalid(config, flags) {
	    config._d = new Date(NaN);
	    Object.assign(Object(__WEBPACK_IMPORTED_MODULE_0__parsing_flags__["a" /* getParsingFlags */])(config), flags || { userInvalidated: true });
	    return config;
	}
	function markInvalid(config) {
	    config._isValid = false;
	    return config;
	}
	
	
	/***/ }),
	/* 50 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export ISO_8601 */
	/* unused harmony export RFC_2822 */
	/* harmony export (immutable) */ __webpack_exports__["a"] = configFromStringAndFormat;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__from_string__ = __webpack_require__(87);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__format__ = __webpack_require__(17);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__format_format__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_type_checks__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parse_regex__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parse_token__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__units_constants__ = __webpack_require__(9);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__from_array__ = __webpack_require__(52);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__parsing_flags__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__check_overflow__ = __webpack_require__(90);
	
	
	
	
	
	
	
	
	
	
	// constant that refers to the ISO standard
	// hooks.ISO_8601 = function () {};
	var ISO_8601 = 'ISO_8601';
	// constant that refers to the RFC 2822 form
	// hooks.RFC_2822 = function () {};
	var RFC_2822 = 'RFC_2822';
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === ISO_8601) {
	        return Object(__WEBPACK_IMPORTED_MODULE_0__from_string__["a" /* configFromISO */])(config);
	    }
	    if (config._f === RFC_2822) {
	        return Object(__WEBPACK_IMPORTED_MODULE_0__from_string__["b" /* configFromRFC2822 */])(config);
	    }
	    config._a = [];
	    Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* getParsingFlags */])(config).empty = true;
	    if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_type_checks__["b" /* isArray */])(config._f) || (!config._i && config._i !== 0)) {
	        return config;
	    }
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var input = config._i.toString();
	    var totalParsedInputLength = 0;
	    var inputLength = input.length;
	    var tokens = Object(__WEBPACK_IMPORTED_MODULE_1__format__["a" /* expandFormat */])(config._f, config._locale).match(__WEBPACK_IMPORTED_MODULE_2__format_format__["d" /* formattingTokens */]) || [];
	    var i;
	    var token;
	    var parsedInput;
	    var skipped;
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (input.match(Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["b" /* getParseRegexForToken */])(token, config._locale)) || [])[0];
	        if (parsedInput) {
	            skipped = input.substr(0, input.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* getParsingFlags */])(config).unusedInput.push(skipped);
	            }
	            input = input.slice(input.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (__WEBPACK_IMPORTED_MODULE_2__format_format__["c" /* formatTokenFunctions */][token]) {
	            if (parsedInput) {
	                Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* getParsingFlags */])(config).empty = false;
	            }
	            else {
	                Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* getParsingFlags */])(config).unusedTokens.push(token);
	            }
	            Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["b" /* addTimeToArrayFromToken */])(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* getParsingFlags */])(config).unusedTokens.push(token);
	        }
	    }
	    // add remaining unparsed input length to the string
	    Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* getParsingFlags */])(config).charsLeftOver = inputLength - totalParsedInputLength;
	    if (input.length > 0) {
	        Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* getParsingFlags */])(config).unusedInput.push(input);
	    }
	    // clear _12h flag if hour is <= 12
	    if (config._a[__WEBPACK_IMPORTED_MODULE_6__units_constants__["b" /* HOUR */]] <= 12 &&
	        Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* getParsingFlags */])(config).bigHour === true &&
	        config._a[__WEBPACK_IMPORTED_MODULE_6__units_constants__["b" /* HOUR */]] > 0) {
	        Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* getParsingFlags */])(config).bigHour = void 0;
	    }
	    Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* getParsingFlags */])(config).parsedDateParts = config._a.slice(0);
	    Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* getParsingFlags */])(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[__WEBPACK_IMPORTED_MODULE_6__units_constants__["b" /* HOUR */]] = meridiemFixWrap(config._locale, config._a[__WEBPACK_IMPORTED_MODULE_6__units_constants__["b" /* HOUR */]], config._meridiem);
	    Object(__WEBPACK_IMPORTED_MODULE_7__from_array__["a" /* configFromArray */])(config);
	    return Object(__WEBPACK_IMPORTED_MODULE_9__check_overflow__["a" /* checkOverflow */])(config);
	}
	function meridiemFixWrap(locale, _hour, meridiem) {
	    var hour = _hour;
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    }
	    if (locale.isPM == null) {
	        // this is not supposed to happen
	        return hour;
	    }
	    // Fallback
	    var isPm = locale.isPM(meridiem);
	    if (isPm && hour < 12) {
	        hour += 12;
	    }
	    if (!isPm && hour === 12) {
	        hour = 0;
	    }
	    return hour;
	}
	
	
	/***/ }),
	/* 51 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export setWeek */
	/* harmony export (immutable) */ __webpack_exports__["b"] = getWeek;
	/* unused harmony export setISOWeek */
	/* harmony export (immutable) */ __webpack_exports__["a"] = getISOWeek;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__week_calendar_utils__ = __webpack_require__(26);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parse_regex__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aliases__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__priorities__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parse_token__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_type_checks__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__locale_locales__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__moment_add_subtract__ = __webpack_require__(20);
	
	
	
	
	
	
	
	
	
	// FORMATTING
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('w', ['ww', 2, false], 'wo', function (date, opts) {
	    return getWeek(date, opts.locale).toString(10);
	});
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('W', ['WW', 2, false], 'Wo', function (date) {
	    return getISOWeek(date).toString(10);
	});
	// ALIASES
	Object(__WEBPACK_IMPORTED_MODULE_3__aliases__["a" /* addUnitAlias */])('week', 'w');
	Object(__WEBPACK_IMPORTED_MODULE_3__aliases__["a" /* addUnitAlias */])('isoWeek', 'W');
	// PRIORITIES
	Object(__WEBPACK_IMPORTED_MODULE_4__priorities__["a" /* addUnitPriority */])('week', 5);
	Object(__WEBPACK_IMPORTED_MODULE_4__priorities__["a" /* addUnitPriority */])('isoWeek', 5);
	// PARSING
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('w', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["d" /* match1to2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('ww', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_2__parse_regex__["h" /* match2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('W', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["d" /* match1to2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('WW', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_2__parse_regex__["h" /* match2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["c" /* addWeekParseToken */])(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = Object(__WEBPACK_IMPORTED_MODULE_6__utils_type_checks__["k" /* toInt */])(input);
	    return config;
	});
	// export function getSetWeek (input) {
	//   var week = this.localeData().week(this);
	//   return input == null ? week : this.add((input - week) * 7, 'd');
	// }
	function setWeek(date, input, locale) {
	    if (locale === void 0) { locale = Object(__WEBPACK_IMPORTED_MODULE_7__locale_locales__["b" /* getLocale */])(); }
	    var week = getWeek(date, locale);
	    return Object(__WEBPACK_IMPORTED_MODULE_8__moment_add_subtract__["a" /* add */])(date, (input - week) * 7, 'day');
	}
	function getWeek(date, locale) {
	    if (locale === void 0) { locale = Object(__WEBPACK_IMPORTED_MODULE_7__locale_locales__["b" /* getLocale */])(); }
	    return locale.week(date);
	}
	// export function getSetISOWeek (input) {
	//   var week = weekOfYear(this, 1, 4).week;
	//   return input == null ? week : this.add((input - week) * 7, 'd');
	// }
	function setISOWeek(date, input) {
	    var week = getISOWeek(date);
	    return Object(__WEBPACK_IMPORTED_MODULE_8__moment_add_subtract__["a" /* add */])(date, (input - week) * 7, 'day');
	}
	function getISOWeek(date) {
	    return Object(__WEBPACK_IMPORTED_MODULE_1__week_calendar_utils__["b" /* weekOfYear */])(date, 1, 4).week;
	}
	
	
	/***/ }),
	/* 52 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = configFromArray;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__units_constants__ = __webpack_require__(9);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__units_year__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parsing_flags__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date_from_array__ = __webpack_require__(19);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__units_week_calendar_utils__ = __webpack_require__(26);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_defaults__ = __webpack_require__(156);
	
	
	
	
	
	
	
	function currentDateArray(config) {
	    var nowValue = new Date();
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray(config) {
	    var input = [];
	    var i;
	    var date;
	    var currentDate;
	    var expectedWeekday;
	    var yearToUse;
	    if (config._d) {
	        return config;
	    }
	    currentDate = currentDateArray(config);
	    // compute day of the year from weeks and weekdays
	    if (config._w && config._a[__WEBPACK_IMPORTED_MODULE_0__units_constants__["a" /* DATE */]] == null && config._a[__WEBPACK_IMPORTED_MODULE_0__units_constants__["e" /* MONTH */]] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	    // if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = Object(__WEBPACK_IMPORTED_MODULE_5__utils_defaults__["a" /* defaults */])(config._a[__WEBPACK_IMPORTED_MODULE_0__units_constants__["i" /* YEAR */]], currentDate[__WEBPACK_IMPORTED_MODULE_0__units_constants__["i" /* YEAR */]]);
	        if (config._dayOfYear > Object(__WEBPACK_IMPORTED_MODULE_1__units_year__["a" /* daysInYear */])(yearToUse) || config._dayOfYear === 0) {
	            Object(__WEBPACK_IMPORTED_MODULE_2__parsing_flags__["a" /* getParsingFlags */])(config)._overflowDayOfYear = true;
	        }
	        date = new Date(Date.UTC(yearToUse, 0, config._dayOfYear));
	        config._a[__WEBPACK_IMPORTED_MODULE_0__units_constants__["e" /* MONTH */]] = date.getUTCMonth();
	        config._a[__WEBPACK_IMPORTED_MODULE_0__units_constants__["a" /* DATE */]] = date.getUTCDate();
	    }
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	    // Check for 24:00:00.000
	    if (config._a[__WEBPACK_IMPORTED_MODULE_0__units_constants__["b" /* HOUR */]] === 24 &&
	        config._a[__WEBPACK_IMPORTED_MODULE_0__units_constants__["d" /* MINUTE */]] === 0 &&
	        config._a[__WEBPACK_IMPORTED_MODULE_0__units_constants__["f" /* SECOND */]] === 0 &&
	        config._a[__WEBPACK_IMPORTED_MODULE_0__units_constants__["c" /* MILLISECOND */]] === 0) {
	        config._nextDay = true;
	        config._a[__WEBPACK_IMPORTED_MODULE_0__units_constants__["b" /* HOUR */]] = 0;
	    }
	    config._d = (config._useUTC ? __WEBPACK_IMPORTED_MODULE_3__date_from_array__["b" /* createUTCDate */] : __WEBPACK_IMPORTED_MODULE_3__date_from_array__["a" /* createDate */]).apply(null, input);
	    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	    if (config._nextDay) {
	        config._a[__WEBPACK_IMPORTED_MODULE_0__units_constants__["b" /* HOUR */]] = 24;
	    }
	    // check for mismatching day of week
	    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	        Object(__WEBPACK_IMPORTED_MODULE_2__parsing_flags__["a" /* getParsingFlags */])(config).weekdayMismatch = true;
	    }
	    return config;
	}
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = Object(__WEBPACK_IMPORTED_MODULE_5__utils_defaults__["a" /* defaults */])(w.GG, config._a[__WEBPACK_IMPORTED_MODULE_0__units_constants__["i" /* YEAR */]], Object(__WEBPACK_IMPORTED_MODULE_4__units_week_calendar_utils__["b" /* weekOfYear */])(new Date(), 1, 4).year);
	        week = Object(__WEBPACK_IMPORTED_MODULE_5__utils_defaults__["a" /* defaults */])(w.W, 1);
	        weekday = Object(__WEBPACK_IMPORTED_MODULE_5__utils_defaults__["a" /* defaults */])(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    }
	    else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	        var curWeek = Object(__WEBPACK_IMPORTED_MODULE_4__units_week_calendar_utils__["b" /* weekOfYear */])(new Date(), dow, doy);
	        weekYear = Object(__WEBPACK_IMPORTED_MODULE_5__utils_defaults__["a" /* defaults */])(w.gg, config._a[__WEBPACK_IMPORTED_MODULE_0__units_constants__["i" /* YEAR */]], curWeek.year);
	        // Default to current week.
	        week = Object(__WEBPACK_IMPORTED_MODULE_5__utils_defaults__["a" /* defaults */])(w.w, curWeek.week);
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        }
	        else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        }
	        else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > Object(__WEBPACK_IMPORTED_MODULE_4__units_week_calendar_utils__["c" /* weeksInYear */])(weekYear, dow, doy)) {
	        Object(__WEBPACK_IMPORTED_MODULE_2__parsing_flags__["a" /* getParsingFlags */])(config)._overflowWeeks = true;
	    }
	    else if (weekdayOverflow != null) {
	        Object(__WEBPACK_IMPORTED_MODULE_2__parsing_flags__["a" /* getParsingFlags */])(config)._overflowWeekday = true;
	    }
	    else {
	        temp = Object(__WEBPACK_IMPORTED_MODULE_4__units_week_calendar_utils__["a" /* dayOfYearFromWeeks */])(weekYear, week, weekday, dow, doy);
	        config._a[__WEBPACK_IMPORTED_MODULE_0__units_constants__["i" /* YEAR */]] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	    return config;
	}
	
	
	/***/ }),
	/* 53 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return win; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return document; });
	/* unused harmony export location */
	/* unused harmony export gc */
	/* unused harmony export performance */
	/* unused harmony export Event */
	/* unused harmony export MouseEvent */
	/* unused harmony export KeyboardEvent */
	/* unused harmony export EventTarget */
	/* unused harmony export History */
	/* unused harmony export Location */
	/* unused harmony export EventListener */
	/*tslint:disable */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	/**
	 * JS version of browser APIs. This library can only run in the browser.
	 */
	var win = (typeof window !== 'undefined' && window) || {};
	
	var document = win.document;
	var location = win.location;
	var gc = win['gc'] ? function () { return win['gc'](); } : function () { return null; };
	var performance = win['performance'] ? win['performance'] : null;
	var Event = win['Event'];
	var MouseEvent = win['MouseEvent'];
	var KeyboardEvent = win['KeyboardEvent'];
	var EventTarget = win['EventTarget'];
	var History = win['History'];
	var Location = win['Location'];
	var EventListener = win['EventListener'];
	
	
	/***/ }),
	/* 54 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accordion_config__ = __webpack_require__(55);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	/** Displays collapsible content panels for presenting information in a limited amount of space. */
	var AccordionComponent = (function () {
	    function AccordionComponent(config) {
	        this.groups = [];
	        Object.assign(this, config);
	    }
	    AccordionComponent.prototype.closeOtherPanels = function (openGroup) {
	        if (!this.closeOthers) {
	            return;
	        }
	        this.groups.forEach(function (group) {
	            if (group !== openGroup) {
	                group.isOpen = false;
	            }
	        });
	    };
	    AccordionComponent.prototype.addGroup = function (group) {
	        this.groups.push(group);
	    };
	    AccordionComponent.prototype.removeGroup = function (group) {
	        var index = this.groups.indexOf(group);
	        if (index !== -1) {
	            this.groups.splice(index, 1);
	        }
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], AccordionComponent.prototype, "closeOthers", void 0);
	    AccordionComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'accordion',
	            template: "<ng-content></ng-content>",
	            host: {
	                '[attr.aria-multiselectable]': 'closeOthers',
	                role: 'tablist',
	                class: 'panel-group',
	                style: 'display: block'
	            }
	        }),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__accordion_config__["a" /* AccordionConfig */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__accordion_config__["a" /* AccordionConfig */]) === "function" && _a || Object])
	    ], AccordionComponent);
	    return AccordionComponent;
	    var _a;
	}());
	
	
	
	/***/ }),
	/* 55 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionConfig; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	/**
	 * Configuration service, provides default values for the AccordionComponent.
	 */
	var AccordionConfig = (function () {
	    function AccordionConfig() {
	        /** Whether the other panels should be closed when a panel is opened */
	        this.closeOthers = false;
	    }
	    AccordionConfig = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	    ], AccordionConfig);
	    return AccordionConfig;
	}());
	
	
	
	/***/ }),
	/* 56 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertConfig; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	var AlertConfig = (function () {
	    function AlertConfig() {
	        /** default alert type */
	        this.type = 'warning';
	        /** is alerts are dismissible by default */
	        this.dismissible = false;
	        /** default time before alert will dismiss */
	        this.dismissOnTimeout = undefined;
	    }
	    AlertConfig = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	    ], AlertConfig);
	    return AlertConfig;
	}());
	
	
	
	/***/ }),
	/* 57 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = OnChange;
	/*tslint:disable:no-invalid-this */
	function OnChange(defaultValue) {
	    var sufix = 'Change';
	    return function OnChangeHandler(target, propertyKey) {
	        var _key = " __" + propertyKey + "Value";
	        Object.defineProperty(target, propertyKey, {
	            get: function () {
	                return this[_key];
	            },
	            set: function (value) {
	                var prevValue = this[_key];
	                this[_key] = value;
	                if (prevValue !== value && this[propertyKey + sufix]) {
	                    this[propertyKey + sufix].emit(value);
	                }
	            }
	        });
	    };
	}
	/* tslint:enable */
	
	
	/***/ }),
	/* 58 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export RADIO_CONTROL_VALUE_ACCESSOR */
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonRadioGroupDirective; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_forms__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	// tslint:disable:no-use-before-declare
	
	
	var RADIO_CONTROL_VALUE_ACCESSOR = {
	    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
	    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return ButtonRadioGroupDirective; }),
	    multi: true
	};
	/**
	 * A group of radio buttons.
	 * A value of a selected button is bound to a variable specified via ngModel.
	 */
	var ButtonRadioGroupDirective = (function () {
	    function ButtonRadioGroupDirective(el, cdr) {
	        this.el = el;
	        this.cdr = cdr;
	        this.onChange = Function.prototype;
	        this.onTouched = Function.prototype;
	    }
	    Object.defineProperty(ButtonRadioGroupDirective.prototype, "value", {
	        get: function () {
	            return this._value;
	        },
	        set: function (value) {
	            this._value = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ButtonRadioGroupDirective.prototype.writeValue = function (value) {
	        this._value = value;
	        this.cdr.markForCheck();
	    };
	    ButtonRadioGroupDirective.prototype.registerOnChange = function (fn) {
	        this.onChange = fn;
	    };
	    ButtonRadioGroupDirective.prototype.registerOnTouched = function (fn) {
	        this.onTouched = fn;
	    };
	    ButtonRadioGroupDirective = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
	            selector: '[btnRadioGroup]',
	            providers: [RADIO_CONTROL_VALUE_ACCESSOR]
	        }),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]) === "function" && _b || Object])
	    ], ButtonRadioGroupDirective);
	    return ButtonRadioGroupDirective;
	    var _a, _b;
	}());
	
	
	
	/***/ }),
	/* 59 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export Direction */
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CarouselComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_index__ = __webpack_require__(36);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__carousel_config__ = __webpack_require__(61);
	// tslint:disable:max-file-line-count
	/***
	 * pause (not yet supported) (?string='hover') - event group name which pauses
	 * the cycling of the carousel, if hover pauses on mouseenter and resumes on
	 * mouseleave keyboard (not yet supported) (?boolean=true) - if false
	 * carousel will not react to keyboard events
	 * note: swiping not yet supported
	 */
	/****
	 * Problems:
	 * 1) if we set an active slide via model changes, .active class remains on a
	 * current slide.
	 * 2) if we have only one slide, we shouldn't show prev/next nav buttons
	 * 3) if first or last slide is active and noWrap is true, there should be
	 * "disabled" class on the nav buttons.
	 * 4) default interval should be equal 5000
	 */
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	var Direction;
	(function (Direction) {
	    Direction[Direction["UNKNOWN"] = 0] = "UNKNOWN";
	    Direction[Direction["NEXT"] = 1] = "NEXT";
	    Direction[Direction["PREV"] = 2] = "PREV";
	})(Direction || (Direction = {}));
	/**
	 * Base element to create carousel
	 */
	var CarouselComponent = (function () {
	    function CarouselComponent(config, ngZone) {
	        this.ngZone = ngZone;
	        /** Will be emitted when active slide has been changed. Part of two-way-bindable [(activeSlide)] property */
	        this.activeSlideChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"](false);
	        this._slides = new __WEBPACK_IMPORTED_MODULE_1__utils_index__["a" /* LinkedList */]();
	        this.destroyed = false;
	        Object.assign(this, config);
	    }
	    Object.defineProperty(CarouselComponent.prototype, "activeSlide", {
	        get: function () {
	            return this._currentActiveSlide;
	        },
	        /** Index of currently displayed slide(started for 0) */
	        set: function (index) {
	            if (this._slides.length && index !== this._currentActiveSlide) {
	                this._select(index);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CarouselComponent.prototype, "interval", {
	        /**
	         * Delay of item cycling in milliseconds. If false, carousel won't cycle
	         * automatically.
	         */
	        get: function () {
	            return this._interval;
	        },
	        set: function (value) {
	            this._interval = value;
	            this.restartTimer();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CarouselComponent.prototype, "slides", {
	        get: function () {
	            return this._slides.toArray();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CarouselComponent.prototype, "isBs4", {
	        get: function () {
	            return !Object(__WEBPACK_IMPORTED_MODULE_1__utils_index__["e" /* isBs3 */])();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CarouselComponent.prototype.ngOnDestroy = function () {
	        this.destroyed = true;
	    };
	    /**
	     * Adds new slide. If this slide is first in collection - set it as active
	     * and starts auto changing
	     * @param slide
	     */
	    CarouselComponent.prototype.addSlide = function (slide) {
	        this._slides.add(slide);
	        if (this._slides.length === 1) {
	            this._currentActiveSlide = void 0;
	            this.activeSlide = 0;
	            this.play();
	        }
	    };
	    /**
	     * Removes specified slide. If this slide is active - will roll to another
	     * slide
	     * @param slide
	     */
	    CarouselComponent.prototype.removeSlide = function (slide) {
	        var _this = this;
	        var remIndex = this._slides.indexOf(slide);
	        if (this._currentActiveSlide === remIndex) {
	            // removing of active slide
	            var nextSlideIndex_1 = void 0;
	            if (this._slides.length > 1) {
	                // if this slide last - will roll to first slide, if noWrap flag is
	                // FALSE or to previous, if noWrap is TRUE in case, if this slide in
	                // middle of collection, index of next slide is same to removed
	                nextSlideIndex_1 = !this.isLast(remIndex)
	                    ? remIndex
	                    : this.noWrap ? remIndex - 1 : 0;
	            }
	            this._slides.remove(remIndex);
	            // prevents exception with changing some value after checking
	            setTimeout(function () {
	                _this._select(nextSlideIndex_1);
	            }, 0);
	        }
	        else {
	            this._slides.remove(remIndex);
	            var currentSlideIndex_1 = this.getCurrentSlideIndex();
	            setTimeout(function () {
	                // after removing, need to actualize index of current active slide
	                _this._currentActiveSlide = currentSlideIndex_1;
	                _this.activeSlideChange.emit(_this._currentActiveSlide);
	            }, 0);
	        }
	    };
	    /**
	     * Rolling to next slide
	     * @param force: {boolean} if true - will ignore noWrap flag
	     */
	    CarouselComponent.prototype.nextSlide = function (force) {
	        if (force === void 0) { force = false; }
	        this.activeSlide = this.findNextSlideIndex(Direction.NEXT, force);
	    };
	    /**
	     * Rolling to previous slide
	     * @param force: {boolean} if true - will ignore noWrap flag
	     */
	    CarouselComponent.prototype.previousSlide = function (force) {
	        if (force === void 0) { force = false; }
	        this.activeSlide = this.findNextSlideIndex(Direction.PREV, force);
	    };
	    /**
	     * Rolling to specified slide
	     * @param index: {number} index of slide, which must be shown
	     */
	    CarouselComponent.prototype.selectSlide = function (index) {
	        this.activeSlide = index;
	    };
	    /**
	     * Starts a auto changing of slides
	     */
	    CarouselComponent.prototype.play = function () {
	        if (!this.isPlaying) {
	            this.isPlaying = true;
	            this.restartTimer();
	        }
	    };
	    /**
	     * Stops a auto changing of slides
	     */
	    CarouselComponent.prototype.pause = function () {
	        if (!this.noPause) {
	            this.isPlaying = false;
	            this.resetTimer();
	        }
	    };
	    /**
	     * Finds and returns index of currently displayed slide
	     * @returns {number}
	     */
	    CarouselComponent.prototype.getCurrentSlideIndex = function () {
	        return this._slides.findIndex(function (slide) { return slide.active; });
	    };
	    /**
	     * Defines, whether the specified index is last in collection
	     * @param index
	     * @returns {boolean}
	     */
	    CarouselComponent.prototype.isLast = function (index) {
	        return index + 1 >= this._slides.length;
	    };
	    /**
	     * Defines next slide index, depending of direction
	     * @param direction: Direction(UNKNOWN|PREV|NEXT)
	     * @param force: {boolean} if TRUE - will ignore noWrap flag, else will
	     *   return undefined if next slide require wrapping
	     * @returns {any}
	     */
	    CarouselComponent.prototype.findNextSlideIndex = function (direction, force) {
	        var nextSlideIndex = 0;
	        if (!force &&
	            (this.isLast(this.activeSlide) &&
	                direction !== Direction.PREV &&
	                this.noWrap)) {
	            return void 0;
	        }
	        switch (direction) {
	            case Direction.NEXT:
	                // if this is last slide, not force, looping is disabled
	                // and need to going forward - select current slide, as a next
	                nextSlideIndex = !this.isLast(this._currentActiveSlide)
	                    ? this._currentActiveSlide + 1
	                    : !force && this.noWrap ? this._currentActiveSlide : 0;
	                break;
	            case Direction.PREV:
	                // if this is first slide, not force, looping is disabled
	                // and need to going backward - select current slide, as a next
	                nextSlideIndex =
	                    this._currentActiveSlide > 0
	                        ? this._currentActiveSlide - 1
	                        : !force && this.noWrap
	                            ? this._currentActiveSlide
	                            : this._slides.length - 1;
	                break;
	            default:
	                throw new Error('Unknown direction');
	        }
	        return nextSlideIndex;
	    };
	    /**
	     * Sets a slide, which specified through index, as active
	     * @param index
	     * @private
	     */
	    CarouselComponent.prototype._select = function (index) {
	        if (isNaN(index)) {
	            this.pause();
	            return;
	        }
	        var currentSlide = this._slides.get(this._currentActiveSlide);
	        if (currentSlide) {
	            currentSlide.active = false;
	        }
	        var nextSlide = this._slides.get(index);
	        if (nextSlide) {
	            this._currentActiveSlide = index;
	            nextSlide.active = true;
	            this.activeSlide = index;
	            this.activeSlideChange.emit(index);
	        }
	    };
	    /**
	     * Starts loop of auto changing of slides
	     */
	    CarouselComponent.prototype.restartTimer = function () {
	        var _this = this;
	        this.resetTimer();
	        var interval = +this.interval;
	        if (!isNaN(interval) && interval > 0) {
	            this.currentInterval = this.ngZone.runOutsideAngular(function () {
	                return setInterval(function () {
	                    var nInterval = +_this.interval;
	                    _this.ngZone.run(function () {
	                        if (_this.isPlaying &&
	                            !isNaN(_this.interval) &&
	                            nInterval > 0 &&
	                            _this.slides.length) {
	                            _this.nextSlide();
	                        }
	                        else {
	                            _this.pause();
	                        }
	                    });
	                }, interval);
	            });
	        }
	    };
	    /**
	     * Stops loop of auto changing of slides
	     */
	    CarouselComponent.prototype.resetTimer = function () {
	        if (this.currentInterval) {
	            clearInterval(this.currentInterval);
	            this.currentInterval = void 0;
	        }
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], CarouselComponent.prototype, "noWrap", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], CarouselComponent.prototype, "noPause", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], CarouselComponent.prototype, "showIndicators", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
	    ], CarouselComponent.prototype, "activeSlideChange", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number),
	        __metadata("design:paramtypes", [Number])
	    ], CarouselComponent.prototype, "activeSlide", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number),
	        __metadata("design:paramtypes", [Number])
	    ], CarouselComponent.prototype, "interval", null);
	    CarouselComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'carousel',
	            template: "<div (mouseenter)=\"pause()\" (mouseleave)=\"play()\" (mouseup)=\"play()\" class=\"carousel slide\"> <ol class=\"carousel-indicators\" *ngIf=\"showIndicators && slides.length > 1\"> <li *ngFor=\"let slidez of slides; let i = index;\" [class.active]=\"slidez.active === true\" (click)=\"selectSlide(i)\"></li> </ol> <div class=\"carousel-inner\"><ng-content></ng-content></div> <a class=\"left carousel-control carousel-control-prev\" [class.disabled]=\"activeSlide === 0 && noWrap\" (click)=\"previousSlide()\" *ngIf=\"slides.length > 1\"> <span class=\"icon-prev carousel-control-prev-icon\" aria-hidden=\"true\"></span> <span *ngIf=\"isBs4\" class=\"sr-only\">Previous</span> </a> <a class=\"right carousel-control carousel-control-next\" (click)=\"nextSlide()\"  [class.disabled]=\"isLast(activeSlide) && noWrap\" *ngIf=\"slides.length > 1\"> <span class=\"icon-next carousel-control-next-icon\" aria-hidden=\"true\"></span> <span class=\"sr-only\">Next</span> </a> </div> "
	        }),
	        __metadata("design:paramtypes", [typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__carousel_config__["a" /* CarouselConfig */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__carousel_config__["a" /* CarouselConfig */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"]) === "function" && _c || Object])
	    ], CarouselComponent);
	    return CarouselComponent;
	    var _a, _b, _c;
	}());
	
	
	
	/***/ }),
	/* 60 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Utils; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_browser__ = __webpack_require__(53);
	
	var Utils = (function () {
	    function Utils() {
	    }
	    Utils.reflow = function (element) {
	        (function (bs) { return bs; })(element.offsetHeight);
	    };
	    // source: https://github.com/jquery/jquery/blob/master/src/css/var/getStyles.js
	    Utils.getStyles = function (elem) {
	        // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
	        // IE throws on elements created in popups
	        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
	        var view = elem.ownerDocument.defaultView;
	        if (!view || !view.opener) {
	            view = __WEBPACK_IMPORTED_MODULE_0__facade_browser__["b" /* window */];
	        }
	        return view.getComputedStyle(elem);
	    };
	    return Utils;
	}());
	
	
	
	/***/ }),
	/* 61 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CarouselConfig; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	var CarouselConfig = (function () {
	    function CarouselConfig() {
	        /** Default interval of auto changing of slides */
	        this.interval = 5000;
	        /** Is loop of auto changing of slides can be paused */
	        this.noPause = false;
	        /** Is slides can wrap from the last to the first slide */
	        this.noWrap = false;
	        /** Show carousel-indicators */
	        this.showIndicators = true;
	    }
	    CarouselConfig = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	    ], CarouselConfig);
	    return CarouselConfig;
	}());
	
	
	
	/***/ }),
	/* 62 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DatepickerConfig; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	var DatepickerConfig = (function () {
	    function DatepickerConfig() {
	        this.locale = 'en';
	        this.datepickerMode = 'day';
	        this.startingDay = 0;
	        this.yearRange = 20;
	        this.minMode = 'day';
	        this.maxMode = 'year';
	        this.showWeeks = true;
	        this.formatDay = 'DD';
	        this.formatMonth = 'MMMM';
	        this.formatYear = 'YYYY';
	        this.formatDayHeader = 'dd';
	        this.formatDayTitle = 'MMMM YYYY';
	        this.formatMonthTitle = 'YYYY';
	        this.onlyCurrentMonth = false;
	        this.monthColLimit = 3;
	        this.yearColLimit = 5;
	        this.shortcutPropagation = false;
	    }
	    DatepickerConfig = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	    ], DatepickerConfig);
	    return DatepickerConfig;
	}());
	
	
	
	/***/ }),
	/* 63 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDatepickerDirective; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_loader_component_loader_factory__ = __webpack_require__(24);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes_bs_bs_datepicker_container_component__ = __webpack_require__(111);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_filter__ = __webpack_require__(37);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_filter__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bs_datepicker_config__ = __webpack_require__(18);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	
	
	var BsDatepickerDirective = (function () {
	    function BsDatepickerDirective(_config, _elementRef, _renderer, _viewContainerRef, cis) {
	        this._config = _config;
	        /**
	         * Placement of a datepicker. Accepts: "top", "bottom", "left", "right"
	         */
	        this.placement = 'bottom';
	        /**
	         * Specifies events that should trigger. Supports a space separated list of
	         * event names.
	         */
	        this.triggers = 'click';
	        /**
	         * Close datepicker on outside click
	         */
	        this.outsideClick = true;
	        /**
	         * A selector specifying the element the datepicker should be appended to.
	         * Currently only supports "body".
	         */
	        this.container = 'body';
	        /**
	         * Emits when datepicker value has been changed
	         */
	        this.bsValueChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this._subs = [];
	        // todo: assign only subset of fields
	        Object.assign(this, this._config);
	        this._datepicker = cis.createLoader(_elementRef, _viewContainerRef, _renderer);
	        this.onShown = this._datepicker.onShown;
	        this.onHidden = this._datepicker.onHidden;
	    }
	    Object.defineProperty(BsDatepickerDirective.prototype, "isOpen", {
	        /**
	         * Returns whether or not the datepicker is currently being shown
	         */
	        get: function () {
	            return this._datepicker.isShown;
	        },
	        set: function (value) {
	            if (value) {
	                this.show();
	            }
	            else {
	                this.hide();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BsDatepickerDirective.prototype, "bsValue", {
	        /**
	         * Initial value of datepicker
	         */
	        set: function (value) {
	            if (this._bsValue === value) {
	                return;
	            }
	            this._bsValue = value;
	            this.bsValueChange.emit(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BsDatepickerDirective.prototype.ngOnInit = function () {
	        var _this = this;
	        this._datepicker.listen({
	            outsideClick: this.outsideClick,
	            triggers: this.triggers,
	            show: function () { return _this.show(); }
	        });
	        this.setConfig();
	    };
	    BsDatepickerDirective.prototype.ngOnChanges = function (changes) {
	        if (!this._datepickerRef || !this._datepickerRef.instance) {
	            return;
	        }
	        if (changes.minDate) {
	            this._datepickerRef.instance.minDate = this.minDate;
	        }
	        if (changes.maxDate) {
	            this._datepickerRef.instance.maxDate = this.maxDate;
	        }
	        if (changes.isDisabled) {
	            this._datepickerRef.instance.isDisabled = this.isDisabled;
	        }
	    };
	    /**
	     * Opens an element’s datepicker. This is considered a “manual” triggering of
	     * the datepicker.
	     */
	    BsDatepickerDirective.prototype.show = function () {
	        var _this = this;
	        if (this._datepicker.isShown) {
	            return;
	        }
	        this.setConfig();
	        this._datepickerRef = this._datepicker
	            .provide({ provide: __WEBPACK_IMPORTED_MODULE_4__bs_datepicker_config__["a" /* BsDatepickerConfig */], useValue: this._config })
	            .attach(__WEBPACK_IMPORTED_MODULE_2__themes_bs_bs_datepicker_container_component__["a" /* BsDatepickerContainerComponent */])
	            .to(this.container)
	            .position({ attachment: this.placement })
	            .show({ placement: this.placement });
	        // if date changes from external source (model -> view)
	        this._subs.push(this.bsValueChange.subscribe(function (value) {
	            _this._datepickerRef.instance.value = value;
	        }));
	        // if date changes from picker (view -> model)
	        this._subs.push(this._datepickerRef.instance.valueChange.subscribe(function (value) {
	            _this.bsValue = value;
	            _this.hide();
	        }));
	    };
	    /**
	     * Closes an element’s datepicker. This is considered a “manual” triggering of
	     * the datepicker.
	     */
	    BsDatepickerDirective.prototype.hide = function () {
	        if (this.isOpen) {
	            this._datepicker.hide();
	        }
	        for (var _i = 0, _a = this._subs; _i < _a.length; _i++) {
	            var sub = _a[_i];
	            sub.unsubscribe();
	        }
	    };
	    /**
	     * Toggles an element’s datepicker. This is considered a “manual” triggering
	     * of the datepicker.
	     */
	    BsDatepickerDirective.prototype.toggle = function () {
	        if (this.isOpen) {
	            return this.hide();
	        }
	        this.show();
	    };
	    /**
	     * Set config for datepicker
	     */
	    BsDatepickerDirective.prototype.setConfig = function () {
	        this._config = Object.assign({}, this._config, this.bsConfig, {
	            value: this._bsValue,
	            isDisabled: this.isDisabled,
	            minDate: this.minDate || this.bsConfig && this.bsConfig.minDate,
	            maxDate: this.maxDate || this.bsConfig && this.bsConfig.maxDate
	        });
	    };
	    BsDatepickerDirective.prototype.ngOnDestroy = function () {
	        this._datepicker.dispose();
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], BsDatepickerDirective.prototype, "placement", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], BsDatepickerDirective.prototype, "triggers", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], BsDatepickerDirective.prototype, "outsideClick", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], BsDatepickerDirective.prototype, "container", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean),
	        __metadata("design:paramtypes", [Boolean])
	    ], BsDatepickerDirective.prototype, "isOpen", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
	    ], BsDatepickerDirective.prototype, "onShown", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
	    ], BsDatepickerDirective.prototype, "onHidden", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [Object])
	    ], BsDatepickerDirective.prototype, "bsValue", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], BsDatepickerDirective.prototype, "bsConfig", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], BsDatepickerDirective.prototype, "isDisabled", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], BsDatepickerDirective.prototype, "minDate", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], BsDatepickerDirective.prototype, "maxDate", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _c || Object)
	    ], BsDatepickerDirective.prototype, "bsValueChange", void 0);
	    BsDatepickerDirective = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
	            selector: '[bsDatepicker]',
	            exportAs: 'bsDatepicker'
	        }),
	        __metadata("design:paramtypes", [typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_4__bs_datepicker_config__["a" /* BsDatepickerConfig */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4__bs_datepicker_config__["a" /* BsDatepickerConfig */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_1__component_loader_component_loader_factory__["a" /* ComponentLoaderFactory */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__component_loader_component_loader_factory__["a" /* ComponentLoaderFactory */]) === "function" && _h || Object])
	    ], BsDatepickerDirective);
	    return BsDatepickerDirective;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	
	
	
	/***/ }),
	/* 64 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDatepickerEffects; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_filter__ = __webpack_require__(37);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_filter__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_map__ = __webpack_require__(113);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_map__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chronos_utils_date_getters__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bs_datepicker_actions__ = __webpack_require__(30);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bs_locale_service__ = __webpack_require__(31);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	
	
	
	var BsDatepickerEffects = (function () {
	    function BsDatepickerEffects(_actions, _localeService) {
	        this._actions = _actions;
	        this._localeService = _localeService;
	        this._subs = [];
	    }
	    BsDatepickerEffects.prototype.init = function (_bsDatepickerStore) {
	        this._store = _bsDatepickerStore;
	        return this;
	    };
	    /** setters */
	    BsDatepickerEffects.prototype.setValue = function (value) {
	        this._store.dispatch(this._actions.select(value));
	    };
	    BsDatepickerEffects.prototype.setRangeValue = function (value) {
	        this._store.dispatch(this._actions.selectRange(value));
	    };
	    BsDatepickerEffects.prototype.setMinDate = function (value) {
	        this._store.dispatch(this._actions.minDate(value));
	        return this;
	    };
	    BsDatepickerEffects.prototype.setMaxDate = function (value) {
	        this._store.dispatch(this._actions.maxDate(value));
	        return this;
	    };
	    BsDatepickerEffects.prototype.setDisabled = function (value) {
	        this._store.dispatch(this._actions.isDisabled(value));
	        return this;
	    };
	    /* Set rendering options */
	    BsDatepickerEffects.prototype.setOptions = function (_config) {
	        var _options = Object.assign({ locale: this._localeService.currentLocale }, _config);
	        this._store.dispatch(this._actions.setOptions(_options));
	        return this;
	    };
	    /** view to mode bindings */
	    BsDatepickerEffects.prototype.setBindings = function (container) {
	        container.daysCalendar = this._store
	            .select(function (state) { return state.flaggedMonths; })
	            .filter(function (months) { return !!months; });
	        // month calendar
	        container.monthsCalendar = this._store
	            .select(function (state) { return state.flaggedMonthsCalendar; })
	            .filter(function (months) { return !!months; });
	        // year calendar
	        container.yearsCalendar = this._store
	            .select(function (state) { return state.yearsCalendarFlagged; })
	            .filter(function (years) { return !!years; });
	        container.viewMode = this._store.select(function (state) { return state.view.mode; });
	        container.options = this._store
	            .select(function (state) { return state.showWeekNumbers; })
	            .map(function (showWeekNumbers) { return ({ showWeekNumbers: showWeekNumbers }); });
	        return this;
	    };
	    /** event handlers */
	    BsDatepickerEffects.prototype.setEventHandlers = function (container) {
	        var _this = this;
	        container.setViewMode = function (event) {
	            _this._store.dispatch(_this._actions.changeViewMode(event));
	        };
	        container.navigateTo = function (event) {
	            _this._store.dispatch(_this._actions.navigateStep(event.step));
	        };
	        container.dayHoverHandler = function (event) {
	            var _cell = event.cell;
	            if (_cell.isOtherMonth || _cell.isDisabled) {
	                return;
	            }
	            _this._store.dispatch(_this._actions.hoverDay(event));
	            _cell.isHovered = event.isHovered;
	        };
	        container.monthHoverHandler = function (event) {
	            event.cell.isHovered = event.isHovered;
	        };
	        container.yearHoverHandler = function (event) {
	            event.cell.isHovered = event.isHovered;
	        };
	        /** select handlers */
	        // container.daySelectHandler = (day: DayViewModel): void => {
	        //   if (day.isOtherMonth || day.isDisabled) {
	        //     return;
	        //   }
	        //   this._store.dispatch(this._actions.select(day.date));
	        // };
	        container.monthSelectHandler = function (event) {
	            if (event.isDisabled) {
	                return;
	            }
	            _this._store.dispatch(_this._actions.navigateTo({
	                unit: { month: Object(__WEBPACK_IMPORTED_MODULE_3__chronos_utils_date_getters__["h" /* getMonth */])(event.date) },
	                viewMode: 'day'
	            }));
	        };
	        container.yearSelectHandler = function (event) {
	            if (event.isDisabled) {
	                return;
	            }
	            _this._store.dispatch(_this._actions.navigateTo({
	                unit: { year: Object(__WEBPACK_IMPORTED_MODULE_3__chronos_utils_date_getters__["d" /* getFullYear */])(event.date) },
	                viewMode: 'month'
	            }));
	        };
	        return this;
	    };
	    BsDatepickerEffects.prototype.registerDatepickerSideEffects = function () {
	        var _this = this;
	        this._subs.push(this._store.select(function (state) { return state.view; }).subscribe(function (view) {
	            _this._store.dispatch(_this._actions.calculate());
	        }));
	        // format calendar values on month model change
	        this._subs.push(this._store
	            .select(function (state) { return state.monthsModel; })
	            .filter(function (monthModel) { return !!monthModel; })
	            .subscribe(function (month) { return _this._store.dispatch(_this._actions.format()); }));
	        // flag day values
	        this._subs.push(this._store
	            .select(function (state) { return state.formattedMonths; })
	            .filter(function (month) { return !!month; })
	            .subscribe(function (month) { return _this._store.dispatch(_this._actions.flag()); }));
	        // flag day values
	        this._subs.push(this._store
	            .select(function (state) { return state.selectedDate; })
	            .filter(function (selectedDate) { return !!selectedDate; })
	            .subscribe(function (selectedDate) { return _this._store.dispatch(_this._actions.flag()); }));
	        // flag for date range picker
	        this._subs.push(this._store
	            .select(function (state) { return state.selectedRange; })
	            .filter(function (selectedRange) { return !!selectedRange; })
	            .subscribe(function (selectedRange) { return _this._store.dispatch(_this._actions.flag()); }));
	        // monthsCalendar
	        this._subs.push(this._store
	            .select(function (state) { return state.monthsCalendar; })
	            .subscribe(function () { return _this._store.dispatch(_this._actions.flag()); }));
	        // years calendar
	        this._subs.push(this._store
	            .select(function (state) { return state.yearsCalendarModel; })
	            .filter(function (state) { return !!state; })
	            .subscribe(function () { return _this._store.dispatch(_this._actions.flag()); }));
	        // on hover
	        this._subs.push(this._store
	            .select(function (state) { return state.hoveredDate; })
	            .filter(function (hoveredDate) { return !!hoveredDate; })
	            .subscribe(function (hoveredDate) { return _this._store.dispatch(_this._actions.flag()); }));
	        // on locale change
	        this._subs.push(this._localeService.localeChange
	            .subscribe(function (locale) { return _this._store.dispatch(_this._actions.setLocale(locale)); }));
	        return this;
	    };
	    BsDatepickerEffects.prototype.destroy = function () {
	        for (var _i = 0, _a = this._subs; _i < _a.length; _i++) {
	            var sub = _a[_i];
	            sub.unsubscribe();
	        }
	    };
	    BsDatepickerEffects = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_4__bs_datepicker_actions__["a" /* BsDatepickerActions */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4__bs_datepicker_actions__["a" /* BsDatepickerActions */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_5__bs_locale_service__["a" /* BsLocaleService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__bs_locale_service__["a" /* BsLocaleService */]) === "function" && _b || Object])
	    ], BsDatepickerEffects);
	    return BsDatepickerEffects;
	    var _a, _b;
	}());
	
	
	
	/***/ }),
	/* 65 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDatepickerStore; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mini_ngrx_store_class__ = __webpack_require__(114);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bs_datepicker_state__ = __webpack_require__(115);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_BehaviorSubject__ = __webpack_require__(38);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_BehaviorSubject__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mini_ngrx_state_class__ = __webpack_require__(116);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bs_datepicker_reducer__ = __webpack_require__(181);
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	
	
	
	var BsDatepickerStore = (function (_super) {
	    __extends(BsDatepickerStore, _super);
	    function BsDatepickerStore() {
	        var _this = this;
	        var _dispatcher = new __WEBPACK_IMPORTED_MODULE_3_rxjs_BehaviorSubject__["BehaviorSubject"]({
	            type: '[datepicker] dispatcher init'
	        });
	        var state = new __WEBPACK_IMPORTED_MODULE_4__mini_ngrx_state_class__["a" /* MiniState */](__WEBPACK_IMPORTED_MODULE_2__bs_datepicker_state__["a" /* initialDatepickerState */], _dispatcher, __WEBPACK_IMPORTED_MODULE_5__bs_datepicker_reducer__["a" /* bsDatepickerReducer */]);
	        _this = _super.call(this, _dispatcher, __WEBPACK_IMPORTED_MODULE_5__bs_datepicker_reducer__["a" /* bsDatepickerReducer */], state) || this;
	        return _this;
	    }
	    BsDatepickerStore = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
	        __metadata("design:paramtypes", [])
	    ], BsDatepickerStore);
	    return BsDatepickerStore;
	}(__WEBPACK_IMPORTED_MODULE_1__mini_ngrx_store_class__["a" /* MiniStore */]));
	
	
	
	/***/ }),
	/* 66 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_66__;
	
	/***/ }),
	/* 67 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = createMatrix;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chronos_utils_date_setters__ = __webpack_require__(13);
	
	function createMatrix(options, fn) {
	    var prevValue = options.initialDate;
	    var matrix = new Array(options.height);
	    for (var i = 0; i < options.height; i++) {
	        matrix[i] = new Array(options.width);
	        for (var j = 0; j < options.width; j++) {
	            matrix[i][j] = fn(prevValue);
	            prevValue = Object(__WEBPACK_IMPORTED_MODULE_0__chronos_utils_date_setters__["j" /* shiftDate */])(prevValue, options.shift);
	        }
	    }
	    return matrix;
	}
	
	
	/***/ }),
	/* 68 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDaterangepickerDirective; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bs_daterangepicker_config__ = __webpack_require__(69);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes_bs_bs_daterangepicker_container_component__ = __webpack_require__(118);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_loader_component_loader_factory__ = __webpack_require__(24);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bs_datepicker_config__ = __webpack_require__(18);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	
	
	var BsDaterangepickerDirective = (function () {
	    function BsDaterangepickerDirective(_config, _elementRef, _renderer, _viewContainerRef, cis) {
	        this._config = _config;
	        /**
	         * Placement of a daterangepicker. Accepts: "top", "bottom", "left", "right"
	         */
	        this.placement = 'bottom';
	        /**
	         * Specifies events that should trigger. Supports a space separated list of
	         * event names.
	         */
	        this.triggers = 'click';
	        /**
	         * Close daterangepicker on outside click
	         */
	        this.outsideClick = true;
	        /**
	         * A selector specifying the element the daterangepicker should be appended
	         * to. Currently only supports "body".
	         */
	        this.container = 'body';
	        /**
	         * Emits when daterangepicker value has been changed
	         */
	        this.bsValueChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this._subs = [];
	        this._datepicker = cis.createLoader(_elementRef, _viewContainerRef, _renderer);
	        Object.assign(this, _config);
	        this.onShown = this._datepicker.onShown;
	        this.onHidden = this._datepicker.onHidden;
	    }
	    Object.defineProperty(BsDaterangepickerDirective.prototype, "isOpen", {
	        /**
	         * Returns whether or not the daterangepicker is currently being shown
	         */
	        get: function () {
	            return this._datepicker.isShown;
	        },
	        set: function (value) {
	            if (value) {
	                this.show();
	            }
	            else {
	                this.hide();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BsDaterangepickerDirective.prototype, "bsValue", {
	        /**
	         * Initial value of daterangepicker
	         */
	        set: function (value) {
	            if (this._bsValue === value) {
	                return;
	            }
	            this._bsValue = value;
	            this.bsValueChange.emit(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BsDaterangepickerDirective.prototype.ngOnInit = function () {
	        var _this = this;
	        this._datepicker.listen({
	            outsideClick: this.outsideClick,
	            triggers: this.triggers,
	            show: function () { return _this.show(); }
	        });
	        this.setConfig();
	    };
	    BsDaterangepickerDirective.prototype.ngOnChanges = function (changes) {
	        if (!this._datepickerRef || !this._datepickerRef.instance) {
	            return;
	        }
	        if (changes.minDate) {
	            this._datepickerRef.instance.minDate = this.minDate;
	        }
	        if (changes.maxDate) {
	            this._datepickerRef.instance.maxDate = this.maxDate;
	        }
	        if (changes.isDisabled) {
	            this._datepickerRef.instance.isDisabled = this.isDisabled;
	        }
	    };
	    /**
	     * Opens an element’s datepicker. This is considered a “manual” triggering of
	     * the datepicker.
	     */
	    BsDaterangepickerDirective.prototype.show = function () {
	        var _this = this;
	        if (this._datepicker.isShown) {
	            return;
	        }
	        this.setConfig();
	        this._datepickerRef = this._datepicker
	            .provide({ provide: __WEBPACK_IMPORTED_MODULE_4__bs_datepicker_config__["a" /* BsDatepickerConfig */], useValue: this._config })
	            .attach(__WEBPACK_IMPORTED_MODULE_2__themes_bs_bs_daterangepicker_container_component__["a" /* BsDaterangepickerContainerComponent */])
	            .to(this.container)
	            .position({ attachment: this.placement })
	            .show({ placement: this.placement });
	        // if date changes from external source (model -> view)
	        this._subs.push(this.bsValueChange.subscribe(function (value) {
	            _this._datepickerRef.instance.value = value;
	        }));
	        // if date changes from picker (view -> model)
	        this._subs.push(this._datepickerRef.instance.valueChange
	            .filter(function (range) { return range && range[0] && !!range[1]; })
	            .subscribe(function (value) {
	            _this.bsValue = value;
	            _this.hide();
	        }));
	    };
	    /**
	     * Set config for daterangepicker
	     */
	    BsDaterangepickerDirective.prototype.setConfig = function () {
	        this._config = Object.assign({}, this._config, this.bsConfig, {
	            value: this._bsValue,
	            isDisabled: this.isDisabled,
	            minDate: this.minDate || this.bsConfig && this.bsConfig.minDate,
	            maxDate: this.maxDate || this.bsConfig && this.bsConfig.maxDate
	        });
	    };
	    /**
	     * Closes an element’s datepicker. This is considered a “manual” triggering of
	     * the datepicker.
	     */
	    BsDaterangepickerDirective.prototype.hide = function () {
	        if (this.isOpen) {
	            this._datepicker.hide();
	        }
	        for (var _i = 0, _a = this._subs; _i < _a.length; _i++) {
	            var sub = _a[_i];
	            sub.unsubscribe();
	        }
	    };
	    /**
	     * Toggles an element’s datepicker. This is considered a “manual” triggering
	     * of the datepicker.
	     */
	    BsDaterangepickerDirective.prototype.toggle = function () {
	        if (this.isOpen) {
	            return this.hide();
	        }
	        this.show();
	    };
	    BsDaterangepickerDirective.prototype.ngOnDestroy = function () {
	        this._datepicker.dispose();
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], BsDaterangepickerDirective.prototype, "placement", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], BsDaterangepickerDirective.prototype, "triggers", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], BsDaterangepickerDirective.prototype, "outsideClick", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], BsDaterangepickerDirective.prototype, "container", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean),
	        __metadata("design:paramtypes", [Boolean])
	    ], BsDaterangepickerDirective.prototype, "isOpen", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
	    ], BsDaterangepickerDirective.prototype, "onShown", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
	    ], BsDaterangepickerDirective.prototype, "onHidden", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Array),
	        __metadata("design:paramtypes", [Array])
	    ], BsDaterangepickerDirective.prototype, "bsValue", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], BsDaterangepickerDirective.prototype, "bsConfig", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], BsDaterangepickerDirective.prototype, "isDisabled", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], BsDaterangepickerDirective.prototype, "minDate", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], BsDaterangepickerDirective.prototype, "maxDate", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _c || Object)
	    ], BsDaterangepickerDirective.prototype, "bsValueChange", void 0);
	    BsDaterangepickerDirective = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
	            selector: '[bsDaterangepicker]',
	            exportAs: 'bsDaterangepicker'
	        }),
	        __metadata("design:paramtypes", [typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_1__bs_daterangepicker_config__["a" /* BsDaterangepickerConfig */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__bs_daterangepicker_config__["a" /* BsDaterangepickerConfig */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_3__component_loader_component_loader_factory__["a" /* ComponentLoaderFactory */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__component_loader_component_loader_factory__["a" /* ComponentLoaderFactory */]) === "function" && _h || Object])
	    ], BsDaterangepickerDirective);
	    return BsDaterangepickerDirective;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	
	
	
	/***/ }),
	/* 69 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDaterangepickerConfig; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bs_datepicker_config__ = __webpack_require__(18);
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	var BsDaterangepickerConfig = (function (_super) {
	    __extends(BsDaterangepickerConfig, _super);
	    function BsDaterangepickerConfig() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        // DatepickerRenderOptions
	        _this.displayMonths = 2;
	        return _this;
	    }
	    BsDaterangepickerConfig = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	    ], BsDaterangepickerConfig);
	    return BsDaterangepickerConfig;
	}(__WEBPACK_IMPORTED_MODULE_1__bs_datepicker_config__["a" /* BsDatepickerConfig */]));
	
	
	
	/***/ }),
	/* 70 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalContainerComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_options_class__ = __webpack_require__(33);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_theme_provider__ = __webpack_require__(7);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	var ModalContainerComponent = (function () {
	    function ModalContainerComponent(options, _element, _renderer) {
	        this._element = _element;
	        this._renderer = _renderer;
	        this.isShown = false;
	        this.isModalHiding = false;
	        this.config = Object.assign({}, options);
	    }
	    ModalContainerComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        if (this.isAnimated) {
	            this._renderer.addClass(this._element.nativeElement, __WEBPACK_IMPORTED_MODULE_1__modal_options_class__["a" /* CLASS_NAME */].FADE);
	        }
	        this._renderer.setStyle(this._element.nativeElement, 'display', 'block');
	        setTimeout(function () {
	            _this.isShown = true;
	            _this._renderer.addClass(_this._element.nativeElement, Object(__WEBPACK_IMPORTED_MODULE_2__utils_theme_provider__["a" /* isBs3 */])() ? __WEBPACK_IMPORTED_MODULE_1__modal_options_class__["a" /* CLASS_NAME */].IN : __WEBPACK_IMPORTED_MODULE_1__modal_options_class__["a" /* CLASS_NAME */].SHOW);
	        }, this.isAnimated ? __WEBPACK_IMPORTED_MODULE_1__modal_options_class__["d" /* TRANSITION_DURATIONS */].BACKDROP : 0);
	        if (document && document.body) {
	            if (this.bsModalService.getModalsCount() === 1) {
	                this.bsModalService.checkScrollbar();
	                this.bsModalService.setScrollbar();
	            }
	            this._renderer.addClass(document.body, __WEBPACK_IMPORTED_MODULE_1__modal_options_class__["a" /* CLASS_NAME */].OPEN);
	        }
	        if (this._element.nativeElement) {
	            this._element.nativeElement.focus();
	        }
	    };
	    ModalContainerComponent.prototype.onClick = function (event) {
	        if (this.config.ignoreBackdropClick ||
	            this.config.backdrop === 'static' ||
	            event.target !== this._element.nativeElement) {
	            return;
	        }
	        this.bsModalService.setDismissReason(__WEBPACK_IMPORTED_MODULE_1__modal_options_class__["b" /* DISMISS_REASONS */].BACKRDOP);
	        this.hide();
	    };
	    ModalContainerComponent.prototype.onEsc = function (event) {
	        if (!this.isShown) {
	            return;
	        }
	        if (event.keyCode === 27) {
	            event.preventDefault();
	        }
	        if (this.config.keyboard &&
	            this.level === this.bsModalService.getModalsCount()) {
	            this.bsModalService.setDismissReason(__WEBPACK_IMPORTED_MODULE_1__modal_options_class__["b" /* DISMISS_REASONS */].ESC);
	            this.hide();
	        }
	    };
	    ModalContainerComponent.prototype.ngOnDestroy = function () {
	        if (this.isShown) {
	            this.hide();
	        }
	    };
	    ModalContainerComponent.prototype.hide = function () {
	        var _this = this;
	        if (this.isModalHiding || !this.isShown) {
	            return;
	        }
	        this.isModalHiding = true;
	        this._renderer.removeClass(this._element.nativeElement, Object(__WEBPACK_IMPORTED_MODULE_2__utils_theme_provider__["a" /* isBs3 */])() ? __WEBPACK_IMPORTED_MODULE_1__modal_options_class__["a" /* CLASS_NAME */].IN : __WEBPACK_IMPORTED_MODULE_1__modal_options_class__["a" /* CLASS_NAME */].SHOW);
	        setTimeout(function () {
	            _this.isShown = false;
	            if (document &&
	                document.body &&
	                _this.bsModalService.getModalsCount() === 1) {
	                _this._renderer.removeClass(document.body, __WEBPACK_IMPORTED_MODULE_1__modal_options_class__["a" /* CLASS_NAME */].OPEN);
	            }
	            _this.bsModalService.hide(_this.level);
	            _this.isModalHiding = false;
	        }, this.isAnimated ? __WEBPACK_IMPORTED_MODULE_1__modal_options_class__["d" /* TRANSITION_DURATIONS */].MODAL : 0);
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('click', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], ModalContainerComponent.prototype, "onClick", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('window:keydown.esc', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], ModalContainerComponent.prototype, "onEsc", null);
	    ModalContainerComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'modal-container',
	            template: "\n    <div [class]=\"'modal-dialog' + (config.class ? ' ' + config.class : '')\" role=\"document\">\n      <div class=\"modal-content\">\n        <ng-content></ng-content>\n      </div>\n    </div>\n  ",
	            host: {
	                class: 'modal',
	                role: 'dialog',
	                tabindex: '-1',
	                '[attr.aria-modal]': 'true'
	            }
	        }),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__modal_options_class__["c" /* ModalOptions */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__modal_options_class__["c" /* ModalOptions */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]) === "function" && _c || Object])
	    ], ModalContainerComponent);
	    return ModalContainerComponent;
	    var _a, _b, _c;
	}());
	
	
	
	/***/ }),
	/* 71 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDropdownConfig; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	/** Default dropdown configuration */
	var BsDropdownConfig = (function () {
	    function BsDropdownConfig() {
	        /** default dropdown auto closing behavior */
	        this.autoClose = true;
	    }
	    BsDropdownConfig = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	    ], BsDropdownConfig);
	    return BsDropdownConfig;
	}());
	
	
	
	/***/ }),
	/* 72 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDropdownContainerComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bs_dropdown_state__ = __webpack_require__(25);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_theme_provider__ = __webpack_require__(7);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	var BsDropdownContainerComponent = (function () {
	    function BsDropdownContainerComponent(_state, cd, _renderer, _element) {
	        var _this = this;
	        this._state = _state;
	        this.cd = cd;
	        this._renderer = _renderer;
	        this.isOpen = false;
	        this._subscription = _state.isOpenChange.subscribe(function (value) {
	            _this.isOpen = value;
	            var dropdown = _element.nativeElement.querySelector('.dropdown-menu');
	            if (dropdown && !Object(__WEBPACK_IMPORTED_MODULE_2__utils_theme_provider__["a" /* isBs3 */])()) {
	                _this._renderer.addClass(dropdown, 'show');
	                if (dropdown.classList.contains('dropdown-menu-right')) {
	                    _this._renderer.setStyle(dropdown, 'left', 'auto');
	                    _this._renderer.setStyle(dropdown, 'right', '0');
	                }
	                if (_this.direction === 'up') {
	                    _this._renderer.setStyle(dropdown, 'top', 'auto');
	                    _this._renderer.setStyle(dropdown, 'transform', 'translateY(-101%)');
	                }
	            }
	            _this.cd.markForCheck();
	            _this.cd.detectChanges();
	        });
	    }
	    Object.defineProperty(BsDropdownContainerComponent.prototype, "direction", {
	        get: function () {
	            return this._state.direction;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BsDropdownContainerComponent.prototype.ngOnDestroy = function () {
	        this._subscription.unsubscribe();
	    };
	    BsDropdownContainerComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'bs-dropdown-container',
	            changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
	            host: {
	                style: 'display:block;position: absolute;'
	            },
	            template: "\n    <div [class.dropup]=\"direction === 'up'\"\n         [class.dropdown]=\"direction === 'down'\"\n         [class.show]=\"isOpen\"\n         [class.open]=\"isOpen\"><ng-content></ng-content></div>\n  "
	        }),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__bs_dropdown_state__["a" /* BsDropdownState */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__bs_dropdown_state__["a" /* BsDropdownState */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _d || Object])
	    ], BsDropdownContainerComponent);
	    return BsDropdownContainerComponent;
	    var _a, _b, _c, _d;
	}());
	
	
	
	/***/ }),
	/* 73 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProgressbarComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progressbar_config__ = __webpack_require__(74);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(36);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	var ProgressbarComponent = (function () {
	    function ProgressbarComponent(config) {
	        this.isStacked = false;
	        this.addClass = true;
	        this.bars = [];
	        this._max = 100;
	        Object.assign(this, config);
	    }
	    Object.defineProperty(ProgressbarComponent.prototype, "value", {
	        /** current value of progress bar. Could be a number or array of objects
	         * like {"value":15,"type":"info","label":"15 %"}
	         */
	        set: function (value) {
	            this.isStacked = Array.isArray(value);
	            this._value = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ProgressbarComponent.prototype, "isBs3", {
	        get: function () {
	            return Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["e" /* isBs3 */])();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ProgressbarComponent.prototype, "max", {
	        /** maximum total value of progress element */
	        get: function () {
	            return this._max;
	        },
	        set: function (v) {
	            this._max = v;
	            this.bars.forEach(function (bar) {
	                bar.recalculatePercentage();
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ProgressbarComponent.prototype.addBar = function (bar) {
	        bar.animate = this.animate;
	        bar.striped = this.striped;
	        this.bars.push(bar);
	    };
	    ProgressbarComponent.prototype.removeBar = function (bar) {
	        this.bars.splice(this.bars.indexOf(bar), 1);
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], ProgressbarComponent.prototype, "animate", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], ProgressbarComponent.prototype, "striped", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], ProgressbarComponent.prototype, "type", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [Object])
	    ], ProgressbarComponent.prototype, "value", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('attr.max'),
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number),
	        __metadata("design:paramtypes", [Number])
	    ], ProgressbarComponent.prototype, "max", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('class.progress'),
	        __metadata("design:type", Object)
	    ], ProgressbarComponent.prototype, "addClass", void 0);
	    ProgressbarComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'progressbar',
	            template: "<bar [type]=\"type\" [value]=\"_value\" *ngIf=\"!isStacked\"> <ng-content></ng-content> </bar> <ng-template [ngIf]=\"isStacked\"> <bar *ngFor=\"let item of _value\" [type]=\"item.type\" [value]=\"item.value\">{{ item.label }}</bar> </ng-template> ",
	            styles: [
	                "\n    :host {\n      width: 100%;\n      display: flex;\n    }\n  "
	            ]
	        }),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__progressbar_config__["a" /* ProgressbarConfig */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__progressbar_config__["a" /* ProgressbarConfig */]) === "function" && _a || Object])
	    ], ProgressbarComponent);
	    return ProgressbarComponent;
	    var _a;
	}());
	
	
	
	/***/ }),
	/* 74 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProgressbarConfig; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	var ProgressbarConfig = (function () {
	    function ProgressbarConfig() {
	        /** if `true` changing value of progress bar will be animated */
	        this.animate = false;
	        /** maximum total value of progress element */
	        this.max = 100;
	    }
	    ProgressbarConfig = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	    ], ProgressbarConfig);
	    return ProgressbarConfig;
	}());
	
	
	
	/***/ }),
	/* 75 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DraggableItemService; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__ = __webpack_require__(212);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	var DraggableItemService = (function () {
	    function DraggableItemService() {
	        this.onCapture = new __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__["Subject"]();
	    }
	    DraggableItemService.prototype.dragStart = function (item) {
	        this.draggableItem = item;
	    };
	    DraggableItemService.prototype.getItem = function () {
	        return this.draggableItem;
	    };
	    DraggableItemService.prototype.captureItem = function (overZoneIndex, newIndex) {
	        if (this.draggableItem.overZoneIndex !== overZoneIndex) {
	            this.draggableItem.lastZoneIndex = this.draggableItem.overZoneIndex;
	            this.draggableItem.overZoneIndex = overZoneIndex;
	            this.onCapture.next(this.draggableItem);
	            this.draggableItem = Object.assign({}, this.draggableItem, {
	                overZoneIndex: overZoneIndex,
	                i: newIndex
	            });
	        }
	        return this.draggableItem;
	    };
	    DraggableItemService.prototype.onCaptureItem = function () {
	        return this.onCapture;
	    };
	    DraggableItemService = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	    ], DraggableItemService);
	    return DraggableItemService;
	}());
	
	
	
	/***/ }),
	/* 76 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabDirective; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabset_component__ = __webpack_require__(77);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	var TabDirective = (function () {
	    function TabDirective(tabset, elementRef, renderer) {
	        this.elementRef = elementRef;
	        this.renderer = renderer;
	        /** fired when tab became active, $event:Tab equals to selected instance of Tab component */
	        this.select = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        /** fired when tab became inactive, $event:Tab equals to deselected instance of Tab component */
	        this.deselect = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        /** fired before tab will be removed, $event:Tab equals to instance of removed tab */
	        this.removed = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.addClass = true;
	        this.tabset = tabset;
	        this.tabset.addTab(this);
	    }
	    Object.defineProperty(TabDirective.prototype, "customClass", {
	        /** if set, will be added to the tab's class attribute. Multiple classes are supported. */
	        get: function () {
	            return this._customClass;
	        },
	        set: function (customClass) {
	            var _this = this;
	            if (this.customClass) {
	                this.customClass.split(' ').forEach(function (cssClass) {
	                    _this.renderer.removeClass(_this.elementRef.nativeElement, cssClass);
	                });
	            }
	            this._customClass = customClass ? customClass.trim() : null;
	            if (this.customClass) {
	                this.customClass.split(' ').forEach(function (cssClass) {
	                    _this.renderer.addClass(_this.elementRef.nativeElement, cssClass);
	                });
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TabDirective.prototype, "active", {
	        /** tab active state toggle */
	        get: function () {
	            return this._active;
	        },
	        set: function (active) {
	            var _this = this;
	            if (this._active === active) {
	                return;
	            }
	            if ((this.disabled && active) || !active) {
	                if (this._active && !active) {
	                    this.deselect.emit(this);
	                    this._active = active;
	                }
	                return;
	            }
	            this._active = active;
	            this.select.emit(this);
	            this.tabset.tabs.forEach(function (tab) {
	                if (tab !== _this) {
	                    tab.active = false;
	                }
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TabDirective.prototype.ngOnInit = function () {
	        this.removable = this.removable;
	    };
	    TabDirective.prototype.ngOnDestroy = function () {
	        this.tabset.removeTab(this, { reselect: false, emit: false });
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], TabDirective.prototype, "heading", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('attr.id'),
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], TabDirective.prototype, "id", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], TabDirective.prototype, "disabled", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], TabDirective.prototype, "removable", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String),
	        __metadata("design:paramtypes", [String])
	    ], TabDirective.prototype, "customClass", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('class.active'),
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean),
	        __metadata("design:paramtypes", [Boolean])
	    ], TabDirective.prototype, "active", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
	    ], TabDirective.prototype, "select", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
	    ], TabDirective.prototype, "deselect", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _c || Object)
	    ], TabDirective.prototype, "removed", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('class.tab-pane'),
	        __metadata("design:type", Object)
	    ], TabDirective.prototype, "addClass", void 0);
	    TabDirective = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({ selector: 'tab, [tab]' }),
	        __metadata("design:paramtypes", [typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_1__tabset_component__["a" /* TabsetComponent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__tabset_component__["a" /* TabsetComponent */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]) === "function" && _f || Object])
	    ], TabDirective);
	    return TabDirective;
	    var _a, _b, _c, _d, _e, _f;
	}());
	
	
	
	/***/ }),
	/* 77 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabsetComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tabset_config__ = __webpack_require__(78);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	// todo: add active event to tab
	// todo: fix? mixing static and dynamic tabs position tabs in order of creation
	var TabsetComponent = (function () {
	    function TabsetComponent(config, renderer) {
	        this.renderer = renderer;
	        this.clazz = true;
	        this.tabs = [];
	        this.classMap = {};
	        Object.assign(this, config);
	    }
	    Object.defineProperty(TabsetComponent.prototype, "vertical", {
	        /** if true tabs will be placed vertically */
	        get: function () {
	            return this._vertical;
	        },
	        set: function (value) {
	            this._vertical = value;
	            this.setClassMap();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TabsetComponent.prototype, "justified", {
	        /** if true tabs fill the container and have a consistent width */
	        get: function () {
	            return this._justified;
	        },
	        set: function (value) {
	            this._justified = value;
	            this.setClassMap();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TabsetComponent.prototype, "type", {
	        /** navigation context class: 'tabs' or 'pills' */
	        get: function () {
	            return this._type;
	        },
	        set: function (value) {
	            this._type = value;
	            this.setClassMap();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TabsetComponent.prototype.ngOnDestroy = function () {
	        this.isDestroyed = true;
	    };
	    TabsetComponent.prototype.addTab = function (tab) {
	        this.tabs.push(tab);
	        tab.active = this.tabs.length === 1 && typeof tab.active === 'undefined';
	    };
	    TabsetComponent.prototype.removeTab = function (tab, options) {
	        if (options === void 0) { options = { reselect: true, emit: true }; }
	        var index = this.tabs.indexOf(tab);
	        if (index === -1 || this.isDestroyed) {
	            return;
	        }
	        // Select a new tab if the tab to be removed is selected and not destroyed
	        if (options.reselect && tab.active && this.hasAvailableTabs(index)) {
	            var newActiveIndex = this.getClosestTabIndex(index);
	            this.tabs[newActiveIndex].active = true;
	        }
	        if (options.emit) {
	            tab.removed.emit(tab);
	        }
	        this.tabs.splice(index, 1);
	        if (tab.elementRef.nativeElement.parentNode) {
	            this.renderer.removeChild(tab.elementRef.nativeElement.parentNode, tab.elementRef.nativeElement);
	        }
	    };
	    TabsetComponent.prototype.getClosestTabIndex = function (index) {
	        var tabsLength = this.tabs.length;
	        if (!tabsLength) {
	            return -1;
	        }
	        for (var step = 1; step <= tabsLength; step += 1) {
	            var prevIndex = index - step;
	            var nextIndex = index + step;
	            if (this.tabs[prevIndex] && !this.tabs[prevIndex].disabled) {
	                return prevIndex;
	            }
	            if (this.tabs[nextIndex] && !this.tabs[nextIndex].disabled) {
	                return nextIndex;
	            }
	        }
	        return -1;
	    };
	    TabsetComponent.prototype.hasAvailableTabs = function (index) {
	        var tabsLength = this.tabs.length;
	        if (!tabsLength) {
	            return false;
	        }
	        for (var i = 0; i < tabsLength; i += 1) {
	            if (!this.tabs[i].disabled && i !== index) {
	                return true;
	            }
	        }
	        return false;
	    };
	    TabsetComponent.prototype.setClassMap = function () {
	        this.classMap = (_a = {
	                'nav-stacked': this.vertical,
	                'flex-column': this.vertical,
	                'nav-justified': this.justified
	            },
	            _a["nav-" + this.type] = true,
	            _a);
	        var _a;
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean),
	        __metadata("design:paramtypes", [Boolean])
	    ], TabsetComponent.prototype, "vertical", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean),
	        __metadata("design:paramtypes", [Boolean])
	    ], TabsetComponent.prototype, "justified", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String),
	        __metadata("design:paramtypes", [String])
	    ], TabsetComponent.prototype, "type", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('class.tab-container'),
	        __metadata("design:type", Object)
	    ], TabsetComponent.prototype, "clazz", void 0);
	    TabsetComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'tabset',
	            template: "<ul class=\"nav\" [ngClass]=\"classMap\" (click)=\"$event.preventDefault()\"> <li *ngFor=\"let tabz of tabs\" [ngClass]=\"['nav-item', tabz.customClass || '']\" [class.active]=\"tabz.active\" [class.disabled]=\"tabz.disabled\"> <a href=\"javascript:void(0);\" class=\"nav-link\" [attr.id]=\"tabz.id ? tabz.id + '-link' : ''\" [class.active]=\"tabz.active\" [class.disabled]=\"tabz.disabled\" (click)=\"tabz.active = true\"> <span [ngTransclude]=\"tabz.headingRef\">{{ tabz.heading }}</span> <span *ngIf=\"tabz.removable\" (click)=\"$event.preventDefault(); removeTab(tabz);\" class=\"bs-remove-tab\"> &#10060;</span> </a> </li> </ul> <div class=\"tab-content\"> <ng-content></ng-content> </div> "
	        }),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__tabset_config__["a" /* TabsetConfig */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__tabset_config__["a" /* TabsetConfig */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]) === "function" && _b || Object])
	    ], TabsetComponent);
	    return TabsetComponent;
	    var _a, _b;
	}());
	
	
	
	/***/ }),
	/* 78 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabsetConfig; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	var TabsetConfig = (function () {
	    function TabsetConfig() {
	        /** provides default navigation context class: 'tabs' or 'pills' */
	        this.type = 'tabs';
	    }
	    TabsetConfig = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	    ], TabsetConfig);
	    return TabsetConfig;
	}());
	
	
	
	/***/ }),
	/* 79 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimepickerStore; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timepicker_reducer__ = __webpack_require__(217);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_BehaviorSubject__ = __webpack_require__(38);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_BehaviorSubject__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mini_ngrx_index__ = __webpack_require__(218);
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	
	var TimepickerStore = (function (_super) {
	    __extends(TimepickerStore, _super);
	    function TimepickerStore() {
	        var _this = this;
	        var _dispatcher = new __WEBPACK_IMPORTED_MODULE_2_rxjs_BehaviorSubject__["BehaviorSubject"]({
	            type: '[mini-ngrx] dispatcher init'
	        });
	        var state = new __WEBPACK_IMPORTED_MODULE_3__mini_ngrx_index__["a" /* MiniState */](__WEBPACK_IMPORTED_MODULE_1__timepicker_reducer__["a" /* initialState */], _dispatcher, __WEBPACK_IMPORTED_MODULE_1__timepicker_reducer__["b" /* timepickerReducer */]);
	        _this = _super.call(this, _dispatcher, __WEBPACK_IMPORTED_MODULE_1__timepicker_reducer__["b" /* timepickerReducer */], state) || this;
	        return _this;
	    }
	    TimepickerStore = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
	        __metadata("design:paramtypes", [])
	    ], TimepickerStore);
	    return TimepickerStore;
	}(__WEBPACK_IMPORTED_MODULE_3__mini_ngrx_index__["b" /* MiniStore */]));
	
	
	
	/***/ }),
	/* 80 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["g"] = isValidDate;
	/* harmony export (immutable) */ __webpack_exports__["h"] = isValidLimit;
	/* unused harmony export toNumber */
	/* unused harmony export isNumber */
	/* unused harmony export parseHours */
	/* unused harmony export parseMinutes */
	/* unused harmony export parseSeconds */
	/* harmony export (immutable) */ __webpack_exports__["j"] = parseTime;
	/* harmony export (immutable) */ __webpack_exports__["a"] = changeTime;
	/* harmony export (immutable) */ __webpack_exports__["k"] = setTime;
	/* unused harmony export createDate */
	/* harmony export (immutable) */ __webpack_exports__["i"] = padNumber;
	/* harmony export (immutable) */ __webpack_exports__["b"] = isHourInputValid;
	/* harmony export (immutable) */ __webpack_exports__["e"] = isMinuteInputValid;
	/* harmony export (immutable) */ __webpack_exports__["f"] = isSecondInputValid;
	/* harmony export (immutable) */ __webpack_exports__["c"] = isInputLimitValid;
	/* harmony export (immutable) */ __webpack_exports__["d"] = isInputValid;
	var dex = 10;
	var hoursPerDay = 24;
	var hoursPerDayHalf = 12;
	var minutesPerHour = 60;
	var secondsPerMinute = 60;
	function isValidDate(value) {
	    if (!value) {
	        return false;
	    }
	    if (value instanceof Date && isNaN(value.getHours())) {
	        return false;
	    }
	    if (typeof value === 'string') {
	        return isValidDate(new Date(value));
	    }
	    return true;
	}
	function isValidLimit(controls, newDate) {
	    if (controls.min && newDate < controls.min) {
	        return false;
	    }
	    if (controls.max && newDate > controls.max) {
	        return false;
	    }
	    return true;
	}
	function toNumber(value) {
	    if (typeof value === 'number') {
	        return value;
	    }
	    return parseInt(value, dex);
	}
	function isNumber(value) {
	    return !isNaN(toNumber(value));
	}
	function parseHours(value, isPM) {
	    if (isPM === void 0) { isPM = false; }
	    var hour = toNumber(value);
	    if (isNaN(hour) ||
	        hour < 0 ||
	        hour > (isPM ? hoursPerDayHalf : hoursPerDay)) {
	        return NaN;
	    }
	    return hour;
	}
	function parseMinutes(value) {
	    var minute = toNumber(value);
	    if (isNaN(minute) || minute < 0 || minute > minutesPerHour) {
	        return NaN;
	    }
	    return minute;
	}
	function parseSeconds(value) {
	    var seconds = toNumber(value);
	    if (isNaN(seconds) || seconds < 0 || seconds > secondsPerMinute) {
	        return NaN;
	    }
	    return seconds;
	}
	function parseTime(value) {
	    if (typeof value === 'string') {
	        return new Date(value);
	    }
	    return value;
	}
	function changeTime(value, diff) {
	    if (!value) {
	        return changeTime(createDate(new Date(), 0, 0, 0), diff);
	    }
	    var hour = value.getHours();
	    var minutes = value.getMinutes();
	    var seconds = value.getSeconds();
	    if (diff.hour) {
	        hour = (hour + toNumber(diff.hour)) % hoursPerDay;
	        if (hour < 0) {
	            hour += hoursPerDay;
	        }
	    }
	    if (diff.minute) {
	        minutes = minutes + toNumber(diff.minute);
	    }
	    if (diff.seconds) {
	        seconds = seconds + toNumber(diff.seconds);
	    }
	    return createDate(value, hour, minutes, seconds);
	}
	function setTime(value, opts) {
	    var hour = parseHours(opts.hour);
	    var minute = parseMinutes(opts.minute);
	    var seconds = parseSeconds(opts.seconds) || 0;
	    if (opts.isPM) {
	        hour += hoursPerDayHalf;
	    }
	    if (!value) {
	        if (!isNaN(hour) && !isNaN(minute)) {
	            return createDate(new Date(), hour, minute, seconds);
	        }
	        return value;
	    }
	    if (isNaN(hour) || isNaN(minute)) {
	        return value;
	    }
	    return createDate(value, hour, minute, seconds);
	}
	function createDate(value, hours, minutes, seconds) {
	    return new Date(value.getFullYear(), value.getMonth(), value.getDate(), hours, minutes, seconds, value.getMilliseconds());
	}
	function padNumber(value) {
	    var _value = value.toString();
	    if (_value.length > 1) {
	        return _value;
	    }
	    return "0" + _value;
	}
	function isHourInputValid(hours, isPM) {
	    return !isNaN(parseHours(hours, isPM));
	}
	function isMinuteInputValid(minutes) {
	    return !isNaN(parseMinutes(minutes));
	}
	function isSecondInputValid(seconds) {
	    return !isNaN(parseSeconds(seconds));
	}
	function isInputLimitValid(diff, max, min) {
	    var newDate = changeTime(new Date(), diff);
	    if (max && newDate > max) {
	        return false;
	    }
	    if (min && newDate < min) {
	        return false;
	    }
	    return true;
	}
	function isInputValid(hours, minutes, seconds, isPM) {
	    if (minutes === void 0) { minutes = '0'; }
	    if (seconds === void 0) { seconds = '0'; }
	    return isHourInputValid(hours, isPM)
	        && isMinuteInputValid(minutes)
	        && isSecondInputValid(seconds);
	}
	
	
	/***/ }),
	/* 81 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TooltipContainerComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tooltip_config__ = __webpack_require__(44);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_theme_provider__ = __webpack_require__(7);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	var TooltipContainerComponent = (function () {
	    function TooltipContainerComponent(config) {
	        Object.assign(this, config);
	    }
	    Object.defineProperty(TooltipContainerComponent.prototype, "isBs3", {
	        get: function () {
	            return Object(__WEBPACK_IMPORTED_MODULE_2__utils_theme_provider__["a" /* isBs3 */])();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TooltipContainerComponent.prototype.ngAfterViewInit = function () {
	        this.classMap = { in: false, fade: false };
	        this.classMap[this.placement] = true;
	        this.classMap["tooltip-" + this.placement] = true;
	        this.classMap.in = true;
	        if (this.animation) {
	            this.classMap.fade = true;
	        }
	        if (this.containerClass) {
	            this.classMap[this.containerClass] = true;
	        }
	    };
	    TooltipContainerComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'bs-tooltip-container',
	            changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
	            // tslint:disable-next-line
	            host: {
	                '[class]': '"tooltip in tooltip-" + placement + " " + "bs-tooltip-" + placement + " " + placement + " " + containerClass',
	                '[class.show]': '!isBs3',
	                role: 'tooltip'
	            },
	            styles: [
	                "\n    :host.tooltip {\n      display: block;\n    }\n    :host.bs-tooltip-top .arrow, :host.bs-tooltip-bottom .arrow {\n      left: 50%;\n      margin-left: -6px;\n    }\n    :host.bs-tooltip-left .arrow, :host.bs-tooltip-right .arrow {\n      top: 50%;\n      margin-top: -6px;\n    }\n  "
	            ],
	            template: "\n    <div class=\"tooltip-arrow arrow\"></div>\n    <div class=\"tooltip-inner\"><ng-content></ng-content></div>\n    "
	        }),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__tooltip_config__["a" /* TooltipConfig */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__tooltip_config__["a" /* TooltipConfig */]) === "function" && _a || Object])
	    ], TooltipContainerComponent);
	    return TooltipContainerComponent;
	    var _a;
	}());
	
	
	
	/***/ }),
	/* 82 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["b"] = latinize;
	/* unused harmony export escapeRegexp */
	/* harmony export (immutable) */ __webpack_exports__["c"] = tokenize;
	/* harmony export (immutable) */ __webpack_exports__["a"] = getValueFromObject;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__latin_map__ = __webpack_require__(135);
	
	function latinize(str) {
	    if (!str) {
	        return '';
	    }
	    return str.replace(/[^A-Za-z0-9\[\] ]/g, function (a) {
	        return __WEBPACK_IMPORTED_MODULE_0__latin_map__["a" /* latinMap */][a] || a;
	    });
	}
	function escapeRegexp(queryToEscape) {
	    // Regex: capture the whole query string and replace it with the string
	    // that will be used to match the results, for example if the capture is
	    // 'a' the result will be \a
	    return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	}
	/* tslint:disable */
	function tokenize(str, wordRegexDelimiters, phraseRegexDelimiters) {
	    if (wordRegexDelimiters === void 0) { wordRegexDelimiters = ' '; }
	    if (phraseRegexDelimiters === void 0) { phraseRegexDelimiters = ''; }
	    /* tslint:enable */
	    var regexStr = "(?:[" + phraseRegexDelimiters + "])([^" + phraseRegexDelimiters + "]+)" +
	        ("(?:[" + phraseRegexDelimiters + "])|([^" + wordRegexDelimiters + "]+)");
	    var preTokenized = str.split(new RegExp(regexStr, 'g'));
	    var result = [];
	    var preTokenizedLength = preTokenized.length;
	    var token;
	    var replacePhraseDelimiters = new RegExp("[" + phraseRegexDelimiters + "]+", 'g');
	    for (var i = 0; i < preTokenizedLength; i += 1) {
	        token = preTokenized[i];
	        if (token && token.length && token !== wordRegexDelimiters) {
	            result.push(token.replace(replacePhraseDelimiters, ''));
	        }
	    }
	    return result;
	}
	function getValueFromObject(object, option) {
	    if (!option || typeof object !== 'object') {
	        return object.toString();
	    }
	    if (option.endsWith('()')) {
	        var functionName = option.slice(0, option.length - 2);
	        return object[functionName]().toString();
	    }
	    var properties = option
	        .replace(/\[(\w+)\]/g, '.$1')
	        .replace(/^\./, '');
	    var propertiesArray = properties.split('.');
	    for (var _i = 0, propertiesArray_1 = propertiesArray; _i < propertiesArray_1.length; _i++) {
	        var property = propertiesArray_1[_i];
	        if (property in object) {
	            // tslint:disable-next-line
	            object = object[property];
	        }
	    }
	    if (!object) {
	        return '';
	    }
	    return object.toString();
	}
	
	
	/***/ }),
	/* 83 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TypeaheadContainerComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(36);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typeahead_utils__ = __webpack_require__(82);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	var TypeaheadContainerComponent = (function () {
	    function TypeaheadContainerComponent(element, renderer) {
	        this.renderer = renderer;
	        this.isFocused = false;
	        this._matches = [];
	        this.isScrolledIntoView = function (elem) {
	            var containerViewTop = this.ulElement.nativeElement.scrollTop;
	            var containerViewBottom = containerViewTop + this.ulElement.nativeElement.offsetHeight;
	            var elemTop = elem.offsetTop;
	            var elemBottom = elemTop + elem.offsetHeight;
	            return ((elemBottom <= containerViewBottom) && (elemTop >= containerViewTop));
	        };
	        this.element = element;
	    }
	    Object.defineProperty(TypeaheadContainerComponent.prototype, "isBs4", {
	        get: function () {
	            return !Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* isBs3 */])();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TypeaheadContainerComponent.prototype, "active", {
	        get: function () {
	            return this._active;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TypeaheadContainerComponent.prototype, "matches", {
	        get: function () {
	            return this._matches;
	        },
	        set: function (value) {
	            var _this = this;
	            this._matches = value;
	            this.needScrollbar = this.typeaheadScrollable && this.typeaheadOptionsInScrollableView < this.matches.length;
	            if (this.typeaheadScrollable) {
	                setTimeout(function () {
	                    _this.setScrollableMode();
	                });
	            }
	            if (this._matches.length > 0) {
	                this._active = this._matches[0];
	                if (this._active.isHeader()) {
	                    this.nextActiveMatch();
	                }
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TypeaheadContainerComponent.prototype, "optionsListTemplate", {
	        get: function () {
	            return this.parent ? this.parent.optionsListTemplate : undefined;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TypeaheadContainerComponent.prototype, "typeaheadScrollable", {
	        get: function () {
	            return this.parent ? this.parent.typeaheadScrollable : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TypeaheadContainerComponent.prototype, "typeaheadOptionsInScrollableView", {
	        get: function () {
	            return this.parent ? this.parent.typeaheadOptionsInScrollableView : 5;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TypeaheadContainerComponent.prototype, "itemTemplate", {
	        get: function () {
	            return this.parent ? this.parent.typeaheadItemTemplate : undefined;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TypeaheadContainerComponent.prototype.selectActiveMatch = function () {
	        this.selectMatch(this._active);
	    };
	    TypeaheadContainerComponent.prototype.prevActiveMatch = function () {
	        var index = this.matches.indexOf(this._active);
	        this._active = this.matches[index - 1 < 0 ? this.matches.length - 1 : index - 1];
	        if (this._active.isHeader()) {
	            this.prevActiveMatch();
	        }
	        if (this.typeaheadScrollable) {
	            this.scrollPrevious(index);
	        }
	    };
	    TypeaheadContainerComponent.prototype.nextActiveMatch = function () {
	        var index = this.matches.indexOf(this._active);
	        this._active = this.matches[index + 1 > this.matches.length - 1 ? 0 : index + 1];
	        if (this._active.isHeader()) {
	            this.nextActiveMatch();
	        }
	        if (this.typeaheadScrollable) {
	            this.scrollNext(index);
	        }
	    };
	    TypeaheadContainerComponent.prototype.selectActive = function (value) {
	        this.isFocused = true;
	        this._active = value;
	    };
	    TypeaheadContainerComponent.prototype.hightlight = function (match, query) {
	        var itemStr = match.value;
	        var itemStrHelper = (this.parent && this.parent.typeaheadLatinize
	            ? Object(__WEBPACK_IMPORTED_MODULE_2__typeahead_utils__["b" /* latinize */])(itemStr)
	            : itemStr).toLowerCase();
	        var startIdx;
	        var tokenLen;
	        // Replaces the capture string with the same string inside of a "strong" tag
	        if (typeof query === 'object') {
	            var queryLen = query.length;
	            for (var i = 0; i < queryLen; i += 1) {
	                // query[i] is already latinized and lower case
	                startIdx = itemStrHelper.indexOf(query[i]);
	                tokenLen = query[i].length;
	                if (startIdx >= 0 && tokenLen > 0) {
	                    itemStr =
	                        itemStr.substring(0, startIdx) + "<strong>" + itemStr.substring(startIdx, startIdx + tokenLen) + "</strong>" +
	                            ("" + itemStr.substring(startIdx + tokenLen));
	                    itemStrHelper =
	                        itemStrHelper.substring(0, startIdx) + "        " + ' '.repeat(tokenLen) + "         " +
	                            ("" + itemStrHelper.substring(startIdx + tokenLen));
	                }
	            }
	        }
	        else if (query) {
	            // query is already latinized and lower case
	            startIdx = itemStrHelper.indexOf(query);
	            tokenLen = query.length;
	            if (startIdx >= 0 && tokenLen > 0) {
	                itemStr =
	                    itemStr.substring(0, startIdx) + "<strong>" + itemStr.substring(startIdx, startIdx + tokenLen) + "</strong>" +
	                        ("" + itemStr.substring(startIdx + tokenLen));
	            }
	        }
	        return itemStr;
	    };
	    TypeaheadContainerComponent.prototype.focusLost = function () {
	        this.isFocused = false;
	    };
	    TypeaheadContainerComponent.prototype.isActive = function (value) {
	        return this._active === value;
	    };
	    TypeaheadContainerComponent.prototype.selectMatch = function (value, e) {
	        var _this = this;
	        if (e === void 0) { e = void 0; }
	        if (e) {
	            e.stopPropagation();
	            e.preventDefault();
	        }
	        this.parent.changeModel(value);
	        setTimeout(function () { return _this.parent.typeaheadOnSelect.emit(value); }, 0);
	        return false;
	    };
	    TypeaheadContainerComponent.prototype.setScrollableMode = function () {
	        if (!this.ulElement) {
	            this.ulElement = this.element;
	        }
	        if (this.liElements.first) {
	            var ulStyles = __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* Utils */].getStyles(this.ulElement.nativeElement);
	            var liStyles = __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* Utils */].getStyles(this.liElements.first.nativeElement);
	            var ulPaddingBottom = parseFloat((ulStyles['padding-bottom'] ? ulStyles['padding-bottom'] : '').replace('px', ''));
	            var ulPaddingTop = parseFloat((ulStyles['padding-top'] ? ulStyles['padding-top'] : '0').replace('px', ''));
	            var optionHeight = parseFloat((liStyles['height'] ? liStyles['height'] : '0').replace('px', ''));
	            var height = this.typeaheadOptionsInScrollableView * optionHeight;
	            this.guiHeight = height + ulPaddingTop + ulPaddingBottom + "px";
	        }
	        this.renderer.setStyle(this.element.nativeElement, 'visibility', 'visible');
	    };
	    TypeaheadContainerComponent.prototype.scrollPrevious = function (index) {
	        if (index === 0) {
	            this.scrollToBottom();
	            return;
	        }
	        if (this.liElements) {
	            var liElement = this.liElements.toArray()[index - 1];
	            if (liElement && !this.isScrolledIntoView(liElement.nativeElement)) {
	                this.ulElement.nativeElement.scrollTop = liElement.nativeElement.offsetTop;
	            }
	        }
	    };
	    TypeaheadContainerComponent.prototype.scrollNext = function (index) {
	        if (index + 1 > this.matches.length - 1) {
	            this.scrollToTop();
	            return;
	        }
	        if (this.liElements) {
	            var liElement = this.liElements.toArray()[index + 1];
	            if (liElement && !this.isScrolledIntoView(liElement.nativeElement)) {
	                this.ulElement.nativeElement.scrollTop =
	                    liElement.nativeElement.offsetTop -
	                        this.ulElement.nativeElement.offsetHeight +
	                        liElement.nativeElement.offsetHeight;
	            }
	        }
	    };
	    TypeaheadContainerComponent.prototype.scrollToBottom = function () {
	        this.ulElement.nativeElement.scrollTop = this.ulElement.nativeElement.scrollHeight;
	    };
	    TypeaheadContainerComponent.prototype.scrollToTop = function () {
	        this.ulElement.nativeElement.scrollTop = 0;
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])('ulElement'),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _a || Object)
	    ], TypeaheadContainerComponent.prototype, "ulElement", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChildren"])('liElements'),
	        __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["QueryList"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["QueryList"]) === "function" && _b || Object)
	    ], TypeaheadContainerComponent.prototype, "liElements", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('mouseleave'),
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('blur'),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], TypeaheadContainerComponent.prototype, "focusLost", null);
	    TypeaheadContainerComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'typeahead-container',
	            // tslint:disable-next-line
	            template: "<!-- inject options list template --> <ng-template [ngTemplateOutlet]=\"optionsListTemplate || (isBs4 ? bs4Template : bs3Template)\" [ngTemplateOutletContext]=\"{matches:matches, itemTemplate:itemTemplate, query:query}\"></ng-template> <!-- default options item template --> <ng-template #bsItemTemplate let-match=\"match\" let-query=\"query\"><span [innerHtml]=\"hightlight(match, query)\"></span> </ng-template> <!-- Bootstrap 3 options list template --> <ng-template #bs3Template> <ul class=\"dropdown-menu\" #ulElement [style.overflow-y]=\"needScrollbar ? 'scroll': 'auto'\" [style.height]=\"needScrollbar ? guiHeight: 'auto'\"> <ng-template ngFor let-match let-i=\"index\" [ngForOf]=\"matches\"> <li #liElements *ngIf=\"match.isHeader()\" class=\"dropdown-header\">{{ match }}</li> <li #liElements *ngIf=\"!match.isHeader()\" [class.active]=\"isActive(match)\" (mouseenter)=\"selectActive(match)\"> <a href=\"#\" (click)=\"selectMatch(match, $event)\" tabindex=\"-1\"> <ng-template [ngTemplateOutlet]=\"itemTemplate || bsItemTemplate\" [ngTemplateOutletContext]=\"{item:match.item, index:i, match:match, query:query}\"></ng-template> </a> </li> </ng-template> </ul> </ng-template> <!-- Bootstrap 4 options list template --> <ng-template #bs4Template> <ng-template ngFor let-match let-i=\"index\" [ngForOf]=\"matches\"> <h6 *ngIf=\"match.isHeader()\" class=\"dropdown-header\">{{ match }}</h6> <ng-template [ngIf]=\"!match.isHeader()\"> <button #liElements class=\"dropdown-item\" (click)=\"selectMatch(match, $event)\" (mouseenter)=\"selectActive(match)\" [class.active]=\"isActive(match)\"> <ng-template [ngTemplateOutlet]=\"itemTemplate || bsItemTemplate\" [ngTemplateOutletContext]=\"{item:match.item, index:i, match:match, query:query}\"></ng-template> </button> </ng-template> </ng-template> </ng-template> ",
	            host: {
	                class: 'dropdown open',
	                '[class.dropdown-menu]': 'isBs4',
	                '[style.overflow-y]': "isBs4 && needScrollbar ? 'scroll': 'visible'",
	                '[style.height]': "isBs4 && needScrollbar ? guiHeight: 'auto'",
	                '[style.visibility]': "typeaheadScrollable ? 'hidden' : 'visible'",
	                '[class.dropup]': 'dropup',
	                style: 'position: absolute;display: block;'
	            }
	        }),
	        __metadata("design:paramtypes", [typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]) === "function" && _d || Object])
	    ], TypeaheadContainerComponent);
	    return TypeaheadContainerComponent;
	    var _a, _b, _c, _d;
	}());
	
	
	
	/***/ }),
	/* 84 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopoverContainerComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popover_config__ = __webpack_require__(45);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_theme_provider__ = __webpack_require__(7);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	var PopoverContainerComponent = (function () {
	    function PopoverContainerComponent(config) {
	        Object.assign(this, config);
	    }
	    Object.defineProperty(PopoverContainerComponent.prototype, "isBs3", {
	        get: function () {
	            return Object(__WEBPACK_IMPORTED_MODULE_2__utils_theme_provider__["a" /* isBs3 */])();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], PopoverContainerComponent.prototype, "placement", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], PopoverContainerComponent.prototype, "title", void 0);
	    PopoverContainerComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'popover-container',
	            changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
	            // tslint:disable-next-line
	            host: {
	                '[class]': '"popover in popover-" + placement + " " + "bs-popover-" + placement + " " + placement + " " + containerClass',
	                '[class.show]': '!isBs3',
	                role: 'tooltip',
	                style: 'display:block;'
	            },
	            styles: [
	                "\n    :host.bs-popover-top .arrow, :host.bs-popover-bottom .arrow {\n      left: 50%;\n      margin-left: -8px;\n    }\n    :host.bs-popover-left .arrow, :host.bs-popover-right .arrow {\n      top: 50%;\n      margin-top: -8px;\n    }\n  "
	            ],
	            template: "<div class=\"popover-arrow arrow\"></div> <h3 class=\"popover-title popover-header\" *ngIf=\"title\">{{ title }}</h3> <div class=\"popover-content popover-body\"> <ng-content></ng-content> </div> "
	        }),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__popover_config__["a" /* PopoverConfig */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__popover_config__["a" /* PopoverConfig */]) === "function" && _a || Object])
	    ], PopoverContainerComponent);
	    return PopoverContainerComponent;
	    var _a;
	}());
	
	
	
	/***/ }),
	/* 85 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = getDayOfYear;
	/* unused harmony export setDayOfYear */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_start_end_of__ = __webpack_require__(27);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parse_regex__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parse_token__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__priorities__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aliases__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_type_checks__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__moment_add_subtract__ = __webpack_require__(20);
	
	
	
	
	
	
	
	
	// FORMATTING
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('DDD', ['DDDD', 3, false], 'DDDo', function (date) {
	    return getDayOfYear(date).toString(10);
	});
	// ALIASES
	Object(__WEBPACK_IMPORTED_MODULE_5__aliases__["a" /* addUnitAlias */])('dayOfYear', 'DDD');
	// PRIORITY
	Object(__WEBPACK_IMPORTED_MODULE_4__priorities__["a" /* addUnitPriority */])('dayOfYear', 4);
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('DDD', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["e" /* match1to3 */]);
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('DDDD', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["i" /* match3 */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_token__["a" /* addParseToken */])(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = Object(__WEBPACK_IMPORTED_MODULE_6__utils_type_checks__["k" /* toInt */])(input);
	    return config;
	});
	function getDayOfYear(date) {
	    var date1 = +Object(__WEBPACK_IMPORTED_MODULE_1__utils_start_end_of__["b" /* startOf */])(date, 'day');
	    var date2 = +Object(__WEBPACK_IMPORTED_MODULE_1__utils_start_end_of__["b" /* startOf */])(date, 'year');
	    var someDate = date1 - date2;
	    var oneDay = 1000 * 60 * 60 * 24;
	    return Math.round(someDate / oneDay) + 1;
	}
	function setDayOfYear(date, input) {
	    var dayOfYear = getDayOfYear(date);
	    return Object(__WEBPACK_IMPORTED_MODULE_7__moment_add_subtract__["a" /* add */])(date, (input - dayOfYear), 'day');
	}
	
	
	/***/ }),
	/* 86 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = createDuration;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constructor__ = __webpack_require__(140);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_type_checks__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__units_constants__ = __webpack_require__(9);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__create_local__ = __webpack_require__(35);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_abs_round__ = __webpack_require__(91);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__units_offset__ = __webpack_require__(89);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_date_compare__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_date_getters__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__moment_add_subtract__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__create_clone__ = __webpack_require__(28);
	// ASP.NET json date format regex
	
	
	
	
	
	
	
	
	
	
	var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	// tslint:disable-next-line
	var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	function createDuration(input, key, config) {
	    if (config === void 0) { config = {}; }
	    var duration = convertDuration(input, key);
	    // matching against regexp is expensive, do it on demand
	    return new __WEBPACK_IMPORTED_MODULE_0__constructor__["a" /* Duration */](duration, config);
	}
	function convertDuration(input, key) {
	    // checks for null or undefined
	    if (input == null) {
	        return {};
	    }
	    if (Object(__WEBPACK_IMPORTED_MODULE_0__constructor__["b" /* isDuration */])(input)) {
	        return {
	            milliseconds: input._milliseconds,
	            day: input._days,
	            month: input._months
	        };
	    }
	    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["f" /* isNumber */])(input)) {
	        // duration = {};
	        return key ? (_a = {}, _a[key] = input, _a) : { milliseconds: input };
	    }
	    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["i" /* isString */])(input)) {
	        var match = aspNetRegex.exec(input);
	        if (match) {
	            var sign = (match[1] === '-') ? -1 : 1;
	            return {
	                year: 0,
	                day: Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["k" /* toInt */])(match[__WEBPACK_IMPORTED_MODULE_2__units_constants__["a" /* DATE */]]) * sign,
	                hours: Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["k" /* toInt */])(match[__WEBPACK_IMPORTED_MODULE_2__units_constants__["b" /* HOUR */]]) * sign,
	                minutes: Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["k" /* toInt */])(match[__WEBPACK_IMPORTED_MODULE_2__units_constants__["d" /* MINUTE */]]) * sign,
	                seconds: Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["k" /* toInt */])(match[__WEBPACK_IMPORTED_MODULE_2__units_constants__["f" /* SECOND */]]) * sign,
	                // the millisecond decimal point is included in the match
	                milliseconds: Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["k" /* toInt */])(Object(__WEBPACK_IMPORTED_MODULE_4__utils_abs_round__["a" /* absRound */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["k" /* toInt */])(match[__WEBPACK_IMPORTED_MODULE_2__units_constants__["c" /* MILLISECOND */]]) * 1000)) * sign
	            };
	        }
	        match = isoRegex.exec(input);
	        if (match) {
	            var sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
	            return {
	                year: parseIso(match[2], sign),
	                month: parseIso(match[3], sign),
	                week: parseIso(match[4], sign),
	                day: parseIso(match[5], sign),
	                hours: parseIso(match[6], sign),
	                minutes: parseIso(match[7], sign),
	                seconds: parseIso(match[8], sign)
	            };
	        }
	    }
	    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["g" /* isObject */])(input) && ('from' in input || 'to' in input)) {
	        var diffRes = momentsDifference(Object(__WEBPACK_IMPORTED_MODULE_3__create_local__["a" /* parseDate */])(input.from), Object(__WEBPACK_IMPORTED_MODULE_3__create_local__["a" /* parseDate */])(input.to));
	        return {
	            milliseconds: diffRes.milliseconds,
	            month: diffRes.months
	        };
	    }
	    return input;
	    var _a;
	}
	// createDuration.fn = Duration.prototype;
	// createDuration.invalid = invalid;
	function parseIso(inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	function positiveMomentsDifference(base, other) {
	    var res = { milliseconds: 0, months: 0 };
	    res.months = Object(__WEBPACK_IMPORTED_MODULE_7__utils_date_getters__["h" /* getMonth */])(other) - Object(__WEBPACK_IMPORTED_MODULE_7__utils_date_getters__["h" /* getMonth */])(base) +
	        (Object(__WEBPACK_IMPORTED_MODULE_7__utils_date_getters__["d" /* getFullYear */])(other) - Object(__WEBPACK_IMPORTED_MODULE_7__utils_date_getters__["d" /* getFullYear */])(base)) * 12;
	    var _basePlus = Object(__WEBPACK_IMPORTED_MODULE_8__moment_add_subtract__["a" /* add */])(Object(__WEBPACK_IMPORTED_MODULE_9__create_clone__["a" /* cloneDate */])(base), res.months, 'month');
	    if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_date_compare__["a" /* isAfter */])(_basePlus, other)) {
	        --res.months;
	    }
	    res.milliseconds = +other - +(Object(__WEBPACK_IMPORTED_MODULE_8__moment_add_subtract__["a" /* add */])(Object(__WEBPACK_IMPORTED_MODULE_9__create_clone__["a" /* cloneDate */])(base), res.months, 'month'));
	    return res;
	}
	function momentsDifference(base, other) {
	    if (!(Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["d" /* isDateValid */])(base) && Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["d" /* isDateValid */])(other))) {
	        return { milliseconds: 0, months: 0 };
	    }
	    var res;
	    var _other = Object(__WEBPACK_IMPORTED_MODULE_5__units_offset__["a" /* cloneWithOffset */])(other, base, { _offset: base.getTimezoneOffset() });
	    if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_date_compare__["b" /* isBefore */])(base, _other)) {
	        res = positiveMomentsDifference(base, _other);
	    }
	    else {
	        res = positiveMomentsDifference(_other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	    return res;
	}
	
	
	/***/ }),
	/* 87 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = configFromISO;
	/* harmony export (immutable) */ __webpack_exports__["b"] = configFromRFC2822;
	/* harmony export (immutable) */ __webpack_exports__["c"] = configFromString;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_locale_class__ = __webpack_require__(34);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_type_checks__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__from_string_and_format__ = __webpack_require__(50);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date_from_array__ = __webpack_require__(19);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__valid__ = __webpack_require__(49);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parsing_flags__ = __webpack_require__(16);
	// tslint:disable-next-line
	
	
	
	
	
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	// tslint:disable-next-line
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	// tslint:disable-next-line
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/, true],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/, true],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/, true],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/, true],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/, true],
	    ['YYYYMMDD', /\d{8}/, true],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/, true],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/, true]
	];
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	var obsOffsets = {
	    UT: 0,
	    GMT: 0,
	    EDT: -4 * 60,
	    EST: -5 * 60,
	    CDT: -5 * 60,
	    CST: -6 * 60,
	    MDT: -6 * 60,
	    MST: -7 * 60,
	    PDT: -7 * 60,
	    PST: -8 * 60
	};
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	// tslint:disable-next-line
	var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	// date from iso format
	function configFromISO(config) {
	    if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["i" /* isString */])(config._i)) {
	        return config;
	    }
	    var input = config._i;
	    var match = extendedIsoRegex.exec(input) || basicIsoRegex.exec(input);
	    var allowTime;
	    var dateFormat;
	    var timeFormat;
	    var tzFormat;
	    if (!match) {
	        config._isValid = false;
	        return config;
	    }
	    // getParsingFlags(config).iso = true;
	    var i;
	    var l;
	    for (i = 0, l = isoDates.length; i < l; i++) {
	        if (isoDates[i][1].exec(match[1])) {
	            dateFormat = isoDates[i][0];
	            allowTime = isoDates[i][2] !== false;
	            break;
	        }
	    }
	    if (dateFormat == null) {
	        config._isValid = false;
	        return config;
	    }
	    if (match[3]) {
	        for (i = 0, l = isoTimes.length; i < l; i++) {
	            if (isoTimes[i][1].exec(match[3])) {
	                // match[2] should be 'T' or space
	                timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                break;
	            }
	        }
	        if (timeFormat == null) {
	            config._isValid = false;
	            return config;
	        }
	    }
	    if (!allowTime && timeFormat != null) {
	        config._isValid = false;
	        return config;
	    }
	    if (match[4]) {
	        if (tzRegex.exec(match[4])) {
	            tzFormat = 'Z';
	        }
	        else {
	            config._isValid = false;
	            return config;
	        }
	    }
	    config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	    return Object(__WEBPACK_IMPORTED_MODULE_2__from_string_and_format__["a" /* configFromStringAndFormat */])(config);
	}
	// tslint:disable-next-line
	function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	    var result = [
	        untruncateYear(yearStr),
	        __WEBPACK_IMPORTED_MODULE_0__locale_locale_class__["e" /* defaultLocaleMonthsShort */].indexOf(monthStr),
	        parseInt(dayStr, 10),
	        parseInt(hourStr, 10),
	        parseInt(minuteStr, 10)
	    ];
	    if (secondStr) {
	        result.push(parseInt(secondStr, 10));
	    }
	    return result;
	}
	function untruncateYear(yearStr) {
	    var year = parseInt(yearStr, 10);
	    return year <= 49 ? year + 2000 : year;
	}
	function preprocessRFC2822(str) {
	    // Remove comments and folding whitespace and replace multiple-spaces with a single space
	    return str
	        .replace(/\([^)]*\)|[\n\t]/g, ' ')
	        .replace(/(\s\s+)/g, ' ').trim();
	}
	function checkWeekday(weekdayStr, parsedInput, config) {
	    if (weekdayStr) {
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        var weekdayProvided = __WEBPACK_IMPORTED_MODULE_0__locale_locale_class__["h" /* defaultLocaleWeekdaysShort */].indexOf(weekdayStr);
	        var weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	        if (weekdayProvided !== weekdayActual) {
	            Object(__WEBPACK_IMPORTED_MODULE_5__parsing_flags__["a" /* getParsingFlags */])(config).weekdayMismatch = true;
	            config._isValid = false;
	            return false;
	        }
	    }
	    return true;
	}
	function calculateOffset(obsOffset, militaryOffset, numOffset) {
	    if (obsOffset) {
	        return obsOffsets[obsOffset];
	    }
	    else if (militaryOffset) {
	        // the only allowed military tz is Z
	        return 0;
	    }
	    else {
	        var hm = parseInt(numOffset, 10);
	        var m = hm % 100;
	        var h = (hm - m) / 100;
	        return h * 60 + m;
	    }
	}
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["i" /* isString */])(config._i)) {
	        return config;
	    }
	    var match = rfc2822.exec(preprocessRFC2822(config._i));
	    if (!match) {
	        return Object(__WEBPACK_IMPORTED_MODULE_4__valid__["c" /* markInvalid */])(config);
	    }
	    var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	    if (!checkWeekday(match[1], parsedArray, config)) {
	        return config;
	    }
	    config._a = parsedArray;
	    config._tzm = calculateOffset(match[8], match[9], match[10]);
	    config._d = __WEBPACK_IMPORTED_MODULE_3__date_from_array__["b" /* createUTCDate */].apply(null, config._a);
	    config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    Object(__WEBPACK_IMPORTED_MODULE_5__parsing_flags__["a" /* getParsingFlags */])(config).rfc2822 = true;
	    return config;
	}
	// date from iso format or fallback
	function configFromString(config) {
	    if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_type_checks__["i" /* isString */])(config._i)) {
	        return config;
	    }
	    var matched = aspNetJsonRegex.exec(config._i);
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return config;
	    }
	    // todo: update logic processing
	    // isISO -> configFromISO
	    // isRFC -> configFromRFC
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    }
	    else {
	        return config;
	    }
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    }
	    else {
	        return config;
	    }
	    // Final attempt, use Input Fallback
	    // hooks.createFromInputFallback(config);
	    return Object(__WEBPACK_IMPORTED_MODULE_4__valid__["a" /* createInvalid */])(config);
	}
	// hooks.createFromInputFallback = deprecate(
	//     'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	//     'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	//     'discouraged and will be removed in an upcoming major release. Please refer to ' +
	//     'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	//     function (config) {
	//         config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	//     }
	// );
	
	
	/***/ }),
	/* 88 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aliases__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(9);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__day_of_month__ = __webpack_require__(148);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__day_of_week__ = __webpack_require__(14);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__day_of_year__ = __webpack_require__(85);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hour__ = __webpack_require__(149);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__millisecond__ = __webpack_require__(150);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__minute__ = __webpack_require__(151);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__month__ = __webpack_require__(48);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__offset__ = __webpack_require__(89);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__priorities__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__quarter__ = __webpack_require__(152);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__second__ = __webpack_require__(153);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__timestamp__ = __webpack_require__(154);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__week__ = __webpack_require__(51);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__week_calendar_utils__ = __webpack_require__(26);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__week_year__ = __webpack_require__(155);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__year__ = __webpack_require__(22);
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	/***/ }),
	/* 89 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = cloneWithOffset;
	/* unused harmony export getDateOffset */
	/* unused harmony export getUTCOffset */
	/* unused harmony export setUTCOffset */
	/* unused harmony export setOffsetToUTC */
	/* unused harmony export isDaylightSavingTime */
	/* unused harmony export setOffsetToParsedOffset */
	/* unused harmony export hasAlignedHourOffset */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_zero_fill__ = __webpack_require__(46);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_type_checks__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parse_regex__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__moment_add_subtract__ = __webpack_require__(20);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parse_token__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__create_clone__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_date_setters__ = __webpack_require__(13);
	// tslint:disable:no-bitwise max-line-length
	// FORMATTING
	
	
	
	
	
	
	
	
	function addOffsetFormatToken(token, separator) {
	    Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])(token, null, null, function (date, config) {
	        var offset = getUTCOffset(date, { _isUTC: config.isUTC, _offset: config.offset });
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + Object(__WEBPACK_IMPORTED_MODULE_1__utils_zero_fill__["a" /* zeroFill */])(~~(offset / 60), 2) + separator + Object(__WEBPACK_IMPORTED_MODULE_1__utils_zero_fill__["a" /* zeroFill */])(~~(offset) % 60, 2);
	    });
	}
	addOffsetFormatToken('Z', ':');
	addOffsetFormatToken('ZZ', '');
	// PARSING
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('Z', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["o" /* matchShortOffset */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('ZZ', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["o" /* matchShortOffset */]);
	Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["a" /* addParseToken */])(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["o" /* matchShortOffset */], input);
	    return config;
	});
	// HELPERS
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	function offsetFromString(matcher, str) {
	    var matches = (str || '').match(matcher);
	    if (matches === null) {
	        return null;
	    }
	    var chunk = matches[matches.length - 1];
	    var parts = chunk.match(chunkOffset) || ['-', '0', '0'];
	    var minutes = parseInt(parts[1], 10) * 60 + Object(__WEBPACK_IMPORTED_MODULE_2__utils_type_checks__["k" /* toInt */])(parts[2]);
	    var _min = parts[0] === '+' ? minutes : -minutes;
	    return minutes === 0 ? 0 : _min;
	}
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, date, config) {
	    if (config === void 0) { config = {}; }
	    if (!config._isUTC) {
	        return input;
	    }
	    var res = Object(__WEBPACK_IMPORTED_MODULE_6__create_clone__["a" /* cloneDate */])(date);
	    // todo: input._d - res._d + ((res._offset || 0) - (input._offset || 0))*60000
	    var offsetDiff = (config._offset || 0) * 60000;
	    var diff = input.valueOf() - res.valueOf() + offsetDiff;
	    // Use low-level api, because this fn is low-level api.
	    res.setTime(res.valueOf() + diff);
	    // todo: add timezone handling
	    // hooks.updateOffset(res, false);
	    return res;
	}
	function getDateOffset(date) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(date.getTimezoneOffset() / 15) * 15;
	}
	// HOOKS
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	// todo: it's from moment timezones
	// hooks.updateOffset = function () {
	// };
	// MOMENTS
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getUTCOffset(date, config) {
	    if (config === void 0) { config = {}; }
	    var _offset = config._offset || 0;
	    return config._isUTC ? _offset : getDateOffset(date);
	}
	function setUTCOffset(date, input, keepLocalTime, keepMinutes, config) {
	    if (config === void 0) { config = {}; }
	    var offset = config._offset || 0;
	    var localAdjust;
	    var _input = input;
	    var _date = date;
	    if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_type_checks__["i" /* isString */])(_input)) {
	        _input = offsetFromString(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["o" /* matchShortOffset */], _input);
	        if (_input === null) {
	            return _date;
	        }
	    }
	    else if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_type_checks__["f" /* isNumber */])(_input) && Math.abs(_input) < 16 && !keepMinutes) {
	        _input = _input * 60;
	    }
	    if (!config._isUTC && keepLocalTime) {
	        localAdjust = getDateOffset(_date);
	    }
	    config._offset = _input;
	    config._isUTC = true;
	    if (localAdjust != null) {
	        _date = Object(__WEBPACK_IMPORTED_MODULE_4__moment_add_subtract__["a" /* add */])(_date, localAdjust, 'minutes');
	    }
	    if (offset !== _input) {
	        if (!keepLocalTime || config._changeInProgress) {
	            _date = Object(__WEBPACK_IMPORTED_MODULE_4__moment_add_subtract__["a" /* add */])(_date, _input - offset, 'minutes', config._isUTC);
	            // addSubtract(this, createDuration(_input - offset, 'm'), 1, false);
	        }
	        else if (!config._changeInProgress) {
	            config._changeInProgress = true;
	            // todo: add timezone handling
	            // hooks.updateOffset(this, true);
	            config._changeInProgress = null;
	        }
	    }
	    return _date;
	}
	/*
	export function getSetZone(input, keepLocalTime) {
	  if (input != null) {
	    if (typeof input !== 'string') {
	      input = -input;
	    }
	
	    this.utcOffset(input, keepLocalTime);
	
	    return this;
	  } else {
	    return -this.utcOffset();
	  }
	}
	*/
	function setOffsetToUTC(date, keepLocalTime) {
	    return setUTCOffset(date, 0, keepLocalTime);
	}
	function isDaylightSavingTime(date) {
	    return (getUTCOffset(date) > getUTCOffset(Object(__WEBPACK_IMPORTED_MODULE_7__utils_date_setters__["g" /* setMonth */])(Object(__WEBPACK_IMPORTED_MODULE_6__create_clone__["a" /* cloneDate */])(date), 0))
	        || getUTCOffset(date) > getUTCOffset(Object(__WEBPACK_IMPORTED_MODULE_7__utils_date_setters__["g" /* setMonth */])(Object(__WEBPACK_IMPORTED_MODULE_6__create_clone__["a" /* cloneDate */])(date), 5)));
	}
	/*export function setOffsetToLocal(date: Date, isUTC?: boolean, keepLocalTime?: boolean) {
	  if (this._isUTC) {
	    this.utcOffset(0, keepLocalTime);
	    this._isUTC = false;
	
	    if (keepLocalTime) {
	      this.subtract(getDateOffset(this), 'm');
	    }
	  }
	  return this;
	}*/
	function setOffsetToParsedOffset(date, input, config) {
	    if (config === void 0) { config = {}; }
	    if (config._tzm != null) {
	        return setUTCOffset(date, config._tzm, false, true, config);
	    }
	    if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_type_checks__["i" /* isString */])(input)) {
	        var tZone = offsetFromString(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["n" /* matchOffset */], input);
	        if (tZone != null) {
	            return setUTCOffset(date, tZone, false, false, config);
	        }
	        return setUTCOffset(date, 0, true, false, config);
	    }
	    return date;
	}
	function hasAlignedHourOffset(date, input) {
	    var _input = input ? getUTCOffset(input, { _isUTC: false }) : 0;
	    return (getUTCOffset(date) - _input) % 60 === 0;
	}
	// DEPRECATED
	/*export function isDaylightSavingTimeShifted() {
	  if (!isUndefined(this._isDSTShifted)) {
	    return this._isDSTShifted;
	  }
	
	  const c = {};
	
	  copyConfig(c, this);
	  c = prepareConfig(c);
	
	  if (c._a) {
	    const other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	    this._isDSTShifted = this.isValid() &&
	      compareArrays(c._a, other.toArray()) > 0;
	  } else {
	    this._isDSTShifted = false;
	  }
	
	  return this._isDSTShifted;
	}*/
	// in Khronos
	/*export function isLocal() {
	  return this.isValid() ? !this._isUTC : false;
	}
	
	export function isUtcOffset() {
	  return this.isValid() ? this._isUTC : false;
	}
	
	export function isUtc() {
	  return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}*/
	
	
	/***/ }),
	/* 90 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = checkOverflow;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parsing_flags__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__units_constants__ = __webpack_require__(9);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__units_month__ = __webpack_require__(48);
	
	
	
	function checkOverflow(config) {
	    var overflow;
	    var a = config._a;
	    if (a && Object(__WEBPACK_IMPORTED_MODULE_0__parsing_flags__["a" /* getParsingFlags */])(config).overflow === -2) {
	        // todo: fix this sh*t
	        overflow =
	            a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["e" /* MONTH */]] < 0 || a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["e" /* MONTH */]] > 11 ? __WEBPACK_IMPORTED_MODULE_1__units_constants__["e" /* MONTH */] :
	                a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["a" /* DATE */]] < 1 || a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["a" /* DATE */]] > Object(__WEBPACK_IMPORTED_MODULE_2__units_month__["a" /* daysInMonth */])(a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["i" /* YEAR */]], a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["e" /* MONTH */]]) ? __WEBPACK_IMPORTED_MODULE_1__units_constants__["a" /* DATE */] :
	                    a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["b" /* HOUR */]] < 0 || a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["b" /* HOUR */]] > 24 || (a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["b" /* HOUR */]] === 24 && (a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["d" /* MINUTE */]] !== 0 || a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["f" /* SECOND */]] !== 0 || a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["c" /* MILLISECOND */]] !== 0)) ? __WEBPACK_IMPORTED_MODULE_1__units_constants__["b" /* HOUR */] :
	                        a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["d" /* MINUTE */]] < 0 || a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["d" /* MINUTE */]] > 59 ? __WEBPACK_IMPORTED_MODULE_1__units_constants__["d" /* MINUTE */] :
	                            a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["f" /* SECOND */]] < 0 || a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["f" /* SECOND */]] > 59 ? __WEBPACK_IMPORTED_MODULE_1__units_constants__["f" /* SECOND */] :
	                                a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["c" /* MILLISECOND */]] < 0 || a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["c" /* MILLISECOND */]] > 999 ? __WEBPACK_IMPORTED_MODULE_1__units_constants__["c" /* MILLISECOND */] :
	                                    -1;
	        if (Object(__WEBPACK_IMPORTED_MODULE_0__parsing_flags__["a" /* getParsingFlags */])(config)._overflowDayOfYear && (overflow < __WEBPACK_IMPORTED_MODULE_1__units_constants__["i" /* YEAR */] || overflow > __WEBPACK_IMPORTED_MODULE_1__units_constants__["a" /* DATE */])) {
	            overflow = __WEBPACK_IMPORTED_MODULE_1__units_constants__["a" /* DATE */];
	        }
	        if (Object(__WEBPACK_IMPORTED_MODULE_0__parsing_flags__["a" /* getParsingFlags */])(config)._overflowWeeks && overflow === -1) {
	            overflow = __WEBPACK_IMPORTED_MODULE_1__units_constants__["g" /* WEEK */];
	        }
	        if (Object(__WEBPACK_IMPORTED_MODULE_0__parsing_flags__["a" /* getParsingFlags */])(config)._overflowWeekday && overflow === -1) {
	            overflow = __WEBPACK_IMPORTED_MODULE_1__units_constants__["h" /* WEEKDAY */];
	        }
	        Object(__WEBPACK_IMPORTED_MODULE_0__parsing_flags__["a" /* getParsingFlags */])(config).overflow = overflow;
	    }
	    return config;
	}
	
	
	/***/ }),
	/* 91 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = absRound;
	function absRound(num) {
	    return num < 0 ? Math.round(num * -1) * -1 : Math.round(num);
	}
	
	
	/***/ }),
	/* 92 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionPanelComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_theme_provider__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accordion_component__ = __webpack_require__(54);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	
	
	
	/**
	 * ### Accordion heading
	 * Instead of using `heading` attribute on the `accordion-group`, you can use
	 * an `accordion-heading` attribute on `any` element inside of a group that
	 * will be used as group's header template.
	 */
	var AccordionPanelComponent = (function () {
	    function AccordionPanelComponent(accordion) {
	        /** Emits when the opened state changes */
	        this.isOpenChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this._isOpen = false;
	        this.accordion = accordion;
	    }
	    Object.defineProperty(AccordionPanelComponent.prototype, "isOpen", {
	        // Questionable, maybe .panel-open should be on child div.panel element?
	        /** Is accordion group open or closed. This property supports two-way binding */
	        get: function () {
	            return this._isOpen;
	        },
	        set: function (value) {
	            var _this = this;
	            if (value !== this.isOpen) {
	                if (value) {
	                    this.accordion.closeOtherPanels(this);
	                }
	                this._isOpen = value;
	                Promise.resolve(null).then(function () {
	                    _this.isOpenChange.emit(value);
	                });
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AccordionPanelComponent.prototype, "isBs3", {
	        get: function () {
	            return Object(__WEBPACK_IMPORTED_MODULE_1__utils_theme_provider__["a" /* isBs3 */])();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AccordionPanelComponent.prototype.ngOnInit = function () {
	        this.panelClass = this.panelClass || 'panel-default';
	        this.accordion.addGroup(this);
	    };
	    AccordionPanelComponent.prototype.ngOnDestroy = function () {
	        this.accordion.removeGroup(this);
	    };
	    AccordionPanelComponent.prototype.toggleOpen = function (event) {
	        if (!this.isDisabled) {
	            this.isOpen = !this.isOpen;
	        }
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], AccordionPanelComponent.prototype, "heading", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], AccordionPanelComponent.prototype, "panelClass", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], AccordionPanelComponent.prototype, "isDisabled", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
	    ], AccordionPanelComponent.prototype, "isOpenChange", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('class.panel-open'),
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean),
	        __metadata("design:paramtypes", [Boolean])
	    ], AccordionPanelComponent.prototype, "isOpen", null);
	    AccordionPanelComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'accordion-group, accordion-panel',
	            template: "<div class=\"panel card\" [ngClass]=\"panelClass\"> <div class=\"panel-heading card-header\" role=\"tab\" (click)=\"toggleOpen($event)\"> <div class=\"panel-title\"> <div role=\"button\" class=\"accordion-toggle\" [attr.aria-expanded]=\"isOpen\"> <div *ngIf=\"heading\" [ngClass]=\"{'text-muted': isDisabled}\"> {{ heading }} </div> <ng-content select=\"[accordion-heading]\"></ng-content> </div> </div> </div> <div class=\"panel-collapse collapse\" role=\"tabpanel\" [collapse]=\"!isOpen\"> <div class=\"panel-body card-block card-body\"> <ng-content></ng-content> </div> </div> </div> ",
	            host: {
	                class: 'panel',
	                style: 'display: block'
	            }
	        }),
	        __param(0, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__accordion_component__["a" /* AccordionComponent */])),
	        __metadata("design:paramtypes", [typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_2__accordion_component__["a" /* AccordionComponent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__accordion_component__["a" /* AccordionComponent */]) === "function" && _b || Object])
	    ], AccordionPanelComponent);
	    return AccordionPanelComponent;
	    var _a, _b;
	}());
	
	
	
	/***/ }),
	/* 93 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CollapseModule; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__collapse_directive__ = __webpack_require__(94);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	var CollapseModule = (function () {
	    function CollapseModule() {
	    }
	    CollapseModule_1 = CollapseModule;
	    CollapseModule.forRoot = function () {
	        return { ngModule: CollapseModule_1, providers: [] };
	    };
	    CollapseModule = CollapseModule_1 = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
	            declarations: [__WEBPACK_IMPORTED_MODULE_1__collapse_directive__["a" /* CollapseDirective */]],
	            exports: [__WEBPACK_IMPORTED_MODULE_1__collapse_directive__["a" /* CollapseDirective */]]
	        })
	    ], CollapseModule);
	    return CollapseModule;
	    var CollapseModule_1;
	}());
	
	
	
	/***/ }),
	/* 94 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CollapseDirective; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	// todo: add animations when https://github.com/angular/angular/issues/9947 solved
	
	var CollapseDirective = (function () {
	    function CollapseDirective(_el, _renderer) {
	        this._el = _el;
	        this._renderer = _renderer;
	        /** This event fires as soon as content collapses */
	        this.collapsed = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        /** This event fires as soon as content becomes visible */
	        this.expanded = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        // shown
	        this.isExpanded = true;
	        // hidden
	        this.isCollapsed = false;
	        // stale state
	        this.isCollapse = true;
	        // animation state
	        this.isCollapsing = false;
	    }
	    Object.defineProperty(CollapseDirective.prototype, "collapse", {
	        get: function () {
	            return this.isExpanded;
	        },
	        /** A flag indicating visibility of content (shown or hidden) */
	        set: function (value) {
	            this.isExpanded = value;
	            this.toggle();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** allows to manually toggle content visibility */
	    CollapseDirective.prototype.toggle = function () {
	        if (this.isExpanded) {
	            this.hide();
	        }
	        else {
	            this.show();
	        }
	    };
	    /** allows to manually hide content */
	    CollapseDirective.prototype.hide = function () {
	        this.isCollapse = false;
	        this.isCollapsing = true;
	        this.isExpanded = false;
	        this.isCollapsed = true;
	        this.isCollapse = true;
	        this.isCollapsing = false;
	        this.display = 'none';
	        this.collapsed.emit(this);
	    };
	    /** allows to manually show collapsed content */
	    CollapseDirective.prototype.show = function () {
	        this.isCollapse = false;
	        this.isCollapsing = true;
	        this.isExpanded = true;
	        this.isCollapsed = false;
	        this.display = 'block';
	        // this.height = 'auto';
	        this.isCollapse = true;
	        this.isCollapsing = false;
	        this._renderer.setStyle(this._el.nativeElement, 'overflow', 'visible');
	        this._renderer.setStyle(this._el.nativeElement, 'height', 'auto');
	        this.expanded.emit(this);
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
	    ], CollapseDirective.prototype, "collapsed", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
	    ], CollapseDirective.prototype, "expanded", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('style.display'),
	        __metadata("design:type", String)
	    ], CollapseDirective.prototype, "display", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('class.in'),
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('class.show'),
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('attr.aria-expanded'),
	        __metadata("design:type", Object)
	    ], CollapseDirective.prototype, "isExpanded", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('attr.aria-hidden'),
	        __metadata("design:type", Object)
	    ], CollapseDirective.prototype, "isCollapsed", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('class.collapse'),
	        __metadata("design:type", Object)
	    ], CollapseDirective.prototype, "isCollapse", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('class.collapsing'),
	        __metadata("design:type", Object)
	    ], CollapseDirective.prototype, "isCollapsing", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean),
	        __metadata("design:paramtypes", [Boolean])
	    ], CollapseDirective.prototype, "collapse", null);
	    CollapseDirective = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
	            selector: '[collapse]',
	            exportAs: 'bs-collapse',
	            host: {
	                '[class.collapse]': 'true'
	            }
	        }),
	        __metadata("design:paramtypes", [typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]) === "function" && _d || Object])
	    ], CollapseDirective);
	    return CollapseDirective;
	    var _a, _b, _c, _d;
	}());
	
	
	
	/***/ }),
	/* 95 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alert_config__ = __webpack_require__(56);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_decorators__ = __webpack_require__(57);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	var AlertComponent = (function () {
	    function AlertComponent(_config, changeDetection) {
	        var _this = this;
	        this.changeDetection = changeDetection;
	        /** Alert type.
	         * Provides one of four bootstrap supported contextual classes:
	         * `success`, `info`, `warning` and `danger`
	         */
	        this.type = 'warning';
	        /** If set, displays an inline "Close" button */
	        this.dismissible = false;
	        /** Is alert visible */
	        this.isOpen = true;
	        /** This event fires immediately after close instance method is called,
	         * $event is an instance of Alert component.
	         */
	        this.onClose = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        /** This event fires when alert closed, $event is an instance of Alert component */
	        this.onClosed = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.classes = '';
	        this.dismissibleChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        Object.assign(this, _config);
	        this.dismissibleChange.subscribe(function (dismissible) {
	            _this.classes = _this.dismissible ? 'alert-dismissible' : '';
	            _this.changeDetection.markForCheck();
	        });
	    }
	    AlertComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        if (this.dismissOnTimeout) {
	            // if dismissOnTimeout used as attr without binding, it will be a string
	            setTimeout(function () { return _this.close(); }, parseInt(this.dismissOnTimeout, 10));
	        }
	    };
	    // todo: animation ` If the .fade and .in classes are present on the element,
	    // the alert will fade out before it is removed`
	    /**
	     * Closes an alert by removing it from the DOM.
	     */
	    AlertComponent.prototype.close = function () {
	        if (!this.isOpen) {
	            return;
	        }
	        this.onClose.emit(this);
	        this.isOpen = false;
	        this.changeDetection.markForCheck();
	        this.onClosed.emit(this);
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], AlertComponent.prototype, "type", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_2__utils_decorators__["a" /* OnChange */])(), Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], AlertComponent.prototype, "dismissible", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], AlertComponent.prototype, "dismissOnTimeout", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], AlertComponent.prototype, "isOpen", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], AlertComponent.prototype, "onClose", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], AlertComponent.prototype, "onClosed", void 0);
	    AlertComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'alert,bs-alert',
	            template: "<ng-template [ngIf]=\"isOpen\"> <div [class]=\"'alert alert-' + type\" role=\"alert\" [ngClass]=\"classes\"> <ng-template [ngIf]=\"dismissible\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"close()\"> <span aria-hidden=\"true\">&times;</span> <span class=\"sr-only\">Close</span> </button> </ng-template> <ng-content></ng-content> </div> </ng-template> ",
	            changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush
	        }),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__alert_config__["a" /* AlertConfig */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__alert_config__["a" /* AlertConfig */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]) === "function" && _b || Object])
	    ], AlertComponent);
	    return AlertComponent;
	    var _a, _b;
	}());
	
	
	
	/***/ }),
	/* 96 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export CHECKBOX_CONTROL_VALUE_ACCESSOR */
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonCheckboxDirective; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_forms__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	// tslint:disable:no-use-before-declare
	
	
	// TODO: config: activeClass - Class to apply to the checked buttons
	var CHECKBOX_CONTROL_VALUE_ACCESSOR = {
	    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
	    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return ButtonCheckboxDirective; }),
	    multi: true
	};
	/**
	 * Add checkbox functionality to any element
	 */
	var ButtonCheckboxDirective = (function () {
	    function ButtonCheckboxDirective() {
	        /** Truthy value, will be set to ngModel */
	        this.btnCheckboxTrue = true;
	        /** Falsy value, will be set to ngModel */
	        this.btnCheckboxFalse = false;
	        this.state = false;
	        this.onChange = Function.prototype;
	        this.onTouched = Function.prototype;
	    }
	    // view -> model
	    ButtonCheckboxDirective.prototype.onClick = function () {
	        if (this.isDisabled) {
	            return;
	        }
	        this.toggle(!this.state);
	        this.onChange(this.value);
	    };
	    ButtonCheckboxDirective.prototype.ngOnInit = function () {
	        this.toggle(this.trueValue === this.value);
	    };
	    Object.defineProperty(ButtonCheckboxDirective.prototype, "trueValue", {
	        get: function () {
	            return typeof this.btnCheckboxTrue !== 'undefined'
	                ? this.btnCheckboxTrue
	                : true;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ButtonCheckboxDirective.prototype, "falseValue", {
	        get: function () {
	            return typeof this.btnCheckboxFalse !== 'undefined'
	                ? this.btnCheckboxFalse
	                : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ButtonCheckboxDirective.prototype.toggle = function (state) {
	        this.state = state;
	        this.value = this.state ? this.trueValue : this.falseValue;
	    };
	    // ControlValueAccessor
	    // model -> view
	    ButtonCheckboxDirective.prototype.writeValue = function (value) {
	        this.state = this.trueValue === value;
	        this.value = value ? this.trueValue : this.falseValue;
	    };
	    ButtonCheckboxDirective.prototype.setDisabledState = function (isDisabled) {
	        this.isDisabled = isDisabled;
	    };
	    ButtonCheckboxDirective.prototype.registerOnChange = function (fn) {
	        this.onChange = fn;
	    };
	    ButtonCheckboxDirective.prototype.registerOnTouched = function (fn) {
	        this.onTouched = fn;
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], ButtonCheckboxDirective.prototype, "btnCheckboxTrue", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], ButtonCheckboxDirective.prototype, "btnCheckboxFalse", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('class.active'),
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('attr.aria-pressed'),
	        __metadata("design:type", Object)
	    ], ButtonCheckboxDirective.prototype, "state", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('click'),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ButtonCheckboxDirective.prototype, "onClick", null);
	    ButtonCheckboxDirective = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
	            selector: '[btnCheckbox]',
	            providers: [CHECKBOX_CONTROL_VALUE_ACCESSOR]
	        })
	    ], ButtonCheckboxDirective);
	    return ButtonCheckboxDirective;
	}());
	
	
	
	/***/ }),
	/* 97 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export RADIO_CONTROL_VALUE_ACCESSOR */
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonRadioDirective; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_forms__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_radio_group_directive__ = __webpack_require__(58);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	// tslint:disable:no-use-before-declare
	
	
	
	var RADIO_CONTROL_VALUE_ACCESSOR = {
	    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
	    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return ButtonRadioDirective; }),
	    multi: true
	};
	/**
	 * Create radio buttons or groups of buttons.
	 * A value of a selected button is bound to a variable specified via ngModel.
	 */
	var ButtonRadioDirective = (function () {
	    function ButtonRadioDirective(el, cdr, group, renderer) {
	        this.el = el;
	        this.cdr = cdr;
	        this.group = group;
	        this.renderer = renderer;
	        this.onChange = Function.prototype;
	        this.onTouched = Function.prototype;
	    }
	    Object.defineProperty(ButtonRadioDirective.prototype, "value", {
	        /** Current value of radio component or group */
	        get: function () {
	            return this.group ? this.group.value : this._value;
	        },
	        set: function (value) {
	            if (this.group) {
	                this.group.value = value;
	                return;
	            }
	            this._value = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ButtonRadioDirective.prototype, "disabled", {
	        /** If `true` — radio button is disabled */
	        get: function () {
	            return this._disabled;
	        },
	        set: function (disabled) {
	            this._disabled = disabled;
	            this.setDisabledState(disabled);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ButtonRadioDirective.prototype, "isActive", {
	        get: function () {
	            return this.btnRadio === this.value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ButtonRadioDirective.prototype.onClick = function () {
	        if (this.el.nativeElement.attributes.disabled || !this.uncheckable && this.btnRadio === this.value) {
	            return;
	        }
	        this.value = this.uncheckable && this.btnRadio === this.value ? undefined : this.btnRadio;
	        this._onChange(this.value);
	    };
	    ButtonRadioDirective.prototype.ngOnInit = function () {
	        this.uncheckable = typeof this.uncheckable !== 'undefined';
	    };
	    ButtonRadioDirective.prototype.onBlur = function () {
	        this.onTouched();
	    };
	    ButtonRadioDirective.prototype._onChange = function (value) {
	        if (this.group) {
	            this.group.onTouched();
	            this.group.onChange(value);
	            return;
	        }
	        this.onTouched();
	        this.onChange(value);
	    };
	    // ControlValueAccessor
	    // model -> view
	    ButtonRadioDirective.prototype.writeValue = function (value) {
	        this.value = value;
	        this.cdr.markForCheck();
	    };
	    ButtonRadioDirective.prototype.registerOnChange = function (fn) {
	        this.onChange = fn;
	    };
	    ButtonRadioDirective.prototype.registerOnTouched = function (fn) {
	        this.onTouched = fn;
	    };
	    ButtonRadioDirective.prototype.setDisabledState = function (disabled) {
	        if (disabled) {
	            this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'disabled');
	            return;
	        }
	        this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], ButtonRadioDirective.prototype, "btnRadio", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], ButtonRadioDirective.prototype, "uncheckable", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [Object])
	    ], ButtonRadioDirective.prototype, "value", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean),
	        __metadata("design:paramtypes", [Boolean])
	    ], ButtonRadioDirective.prototype, "disabled", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('class.active'),
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('attr.aria-pressed'),
	        __metadata("design:type", Boolean),
	        __metadata("design:paramtypes", [])
	    ], ButtonRadioDirective.prototype, "isActive", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('click'),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], ButtonRadioDirective.prototype, "onClick", null);
	    ButtonRadioDirective = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
	            selector: '[btnRadio]',
	            providers: [RADIO_CONTROL_VALUE_ACCESSOR]
	        }),
	        __param(2, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"])()),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_2__button_radio_group_directive__["a" /* ButtonRadioGroupDirective */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__button_radio_group_directive__["a" /* ButtonRadioGroupDirective */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]) === "function" && _d || Object])
	    ], ButtonRadioDirective);
	    return ButtonRadioDirective;
	    var _a, _b, _c, _d;
	}());
	
	
	
	/***/ }),
	/* 98 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Trigger; });
	/**
	 * @copyright Valor Software
	 * @copyright Angular ng-bootstrap team
	 */
	var Trigger = (function () {
	    function Trigger(open, close) {
	        this.open = open;
	        this.close = close || open;
	    }
	    Trigger.prototype.isManual = function () {
	        return this.open === 'manual' || this.close === 'manual';
	    };
	    return Trigger;
	}());
	
	
	
	/***/ }),
	/* 99 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SlideComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__carousel_component__ = __webpack_require__(59);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	var SlideComponent = (function () {
	    function SlideComponent(carousel) {
	        /** Wraps element by appropriate CSS classes */
	        this.addClass = true;
	        this.carousel = carousel;
	    }
	    /** Fires changes in container collection after adding a new slide instance */
	    SlideComponent.prototype.ngOnInit = function () {
	        this.carousel.addSlide(this);
	    };
	    /** Fires changes in container collection after removing of this slide instance */
	    SlideComponent.prototype.ngOnDestroy = function () {
	        this.carousel.removeSlide(this);
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('class.active'),
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], SlideComponent.prototype, "active", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('class.item'),
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('class.carousel-item'),
	        __metadata("design:type", Object)
	    ], SlideComponent.prototype, "addClass", void 0);
	    SlideComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'slide',
	            template: "\n    <div [class.active]=\"active\" class=\"item\">\n      <ng-content></ng-content>\n    </div>\n  ",
	            host: {
	                '[attr.aria-hidden]': '!active'
	            }
	        }),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__carousel_component__["a" /* CarouselComponent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__carousel_component__["a" /* CarouselComponent */]) === "function" && _a || Object])
	    ], SlideComponent);
	    return SlideComponent;
	    var _a;
	}());
	
	
	
	/***/ }),
	/* 100 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export DATEPICKER_CONTROL_VALUE_ACCESSOR */
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DatePickerComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_forms__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__datepicker_inner_component__ = __webpack_require__(29);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__datepicker_config__ = __webpack_require__(62);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	
	var DATEPICKER_CONTROL_VALUE_ACCESSOR = {
	    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
	    // tslint:disable-next-line
	    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return DatePickerComponent; }),
	    multi: true
	};
	/* tslint:disable:component-selector-name component-selector-type */
	var DatePickerComponent = (function () {
	    function DatePickerComponent(config) {
	        /** sets datepicker mode, supports: `day`, `month`, `year` */
	        this.datepickerMode = 'day';
	        /** if false week numbers will be hidden */
	        this.showWeeks = true;
	        this.selectionDone = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"](undefined);
	        /** callback to invoke when the activeDate is changed. */
	        this.activeDateChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"](undefined);
	        this.onChange = Function.prototype;
	        this.onTouched = Function.prototype;
	        this._now = new Date();
	        this.config = config;
	        this.configureOptions();
	    }
	    Object.defineProperty(DatePickerComponent.prototype, "activeDate", {
	        /** currently active date */
	        get: function () {
	            return this._activeDate || this._now;
	        },
	        set: function (value) {
	            this._activeDate = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DatePickerComponent.prototype.configureOptions = function () {
	        Object.assign(this, this.config);
	    };
	    DatePickerComponent.prototype.onUpdate = function (event) {
	        this.activeDate = event;
	        this.onChange(event);
	    };
	    DatePickerComponent.prototype.onSelectionDone = function (event) {
	        this.selectionDone.emit(event);
	    };
	    DatePickerComponent.prototype.onActiveDateChange = function (event) {
	        this.activeDateChange.emit(event);
	    };
	    // todo: support null value
	    DatePickerComponent.prototype.writeValue = function (value) {
	        if (this._datePicker.compare(value, this._activeDate) === 0) {
	            return;
	        }
	        if (value && value instanceof Date) {
	            this.activeDate = value;
	            this._datePicker.select(value, false);
	            return;
	        }
	        this.activeDate = value ? new Date(value) : void 0;
	    };
	    DatePickerComponent.prototype.registerOnChange = function (fn) {
	        this.onChange = fn;
	    };
	    DatePickerComponent.prototype.registerOnTouched = function (fn) {
	        this.onTouched = fn;
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], DatePickerComponent.prototype, "datepickerMode", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], DatePickerComponent.prototype, "initDate", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], DatePickerComponent.prototype, "minDate", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], DatePickerComponent.prototype, "maxDate", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], DatePickerComponent.prototype, "minMode", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], DatePickerComponent.prototype, "maxMode", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], DatePickerComponent.prototype, "showWeeks", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], DatePickerComponent.prototype, "formatDay", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], DatePickerComponent.prototype, "formatMonth", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], DatePickerComponent.prototype, "formatYear", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], DatePickerComponent.prototype, "formatDayHeader", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], DatePickerComponent.prototype, "formatDayTitle", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], DatePickerComponent.prototype, "formatMonthTitle", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number)
	    ], DatePickerComponent.prototype, "startingDay", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number)
	    ], DatePickerComponent.prototype, "yearRange", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], DatePickerComponent.prototype, "onlyCurrentMonth", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], DatePickerComponent.prototype, "shortcutPropagation", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number)
	    ], DatePickerComponent.prototype, "monthColLimit", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number)
	    ], DatePickerComponent.prototype, "yearColLimit", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Array)
	    ], DatePickerComponent.prototype, "customClass", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Array)
	    ], DatePickerComponent.prototype, "dateDisabled", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Array)
	    ], DatePickerComponent.prototype, "dayDisabled", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [Object])
	    ], DatePickerComponent.prototype, "activeDate", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
	    ], DatePickerComponent.prototype, "selectionDone", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
	    ], DatePickerComponent.prototype, "activeDateChange", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"])(__WEBPACK_IMPORTED_MODULE_2__datepicker_inner_component__["a" /* DatePickerInnerComponent */]),
	        __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_2__datepicker_inner_component__["a" /* DatePickerInnerComponent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__datepicker_inner_component__["a" /* DatePickerInnerComponent */]) === "function" && _c || Object)
	    ], DatePickerComponent.prototype, "_datePicker", void 0);
	    DatePickerComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'datepicker',
	            template: "\n    <datepicker-inner [activeDate]=\"activeDate\"\n                      (update)=\"onUpdate($event)\"\n                      [locale]=\"config.locale\"\n                      [datepickerMode]=\"datepickerMode\"\n                      [initDate]=\"initDate\"\n                      [minDate]=\"minDate\"\n                      [maxDate]=\"maxDate\"\n                      [minMode]=\"minMode\"\n                      [maxMode]=\"maxMode\"\n                      [showWeeks]=\"showWeeks\"\n                      [formatDay]=\"formatDay\"\n                      [formatMonth]=\"formatMonth\"\n                      [formatYear]=\"formatYear\"\n                      [formatDayHeader]=\"formatDayHeader\"\n                      [formatDayTitle]=\"formatDayTitle\"\n                      [formatMonthTitle]=\"formatMonthTitle\"\n                      [startingDay]=\"startingDay\"\n                      [yearRange]=\"yearRange\"\n                      [customClass]=\"customClass\"\n                      [dateDisabled]=\"dateDisabled\"\n                      [dayDisabled]=\"dayDisabled\"\n                      [onlyCurrentMonth]=\"onlyCurrentMonth\"\n                      [shortcutPropagation]=\"shortcutPropagation\"\n                      [monthColLimit]=\"monthColLimit\"\n                      [yearColLimit]=\"yearColLimit\"\n                      (selectionDone)=\"onSelectionDone($event)\"\n                      (activeDateChange)=\"onActiveDateChange($event)\">\n      <daypicker tabindex=\"0\"></daypicker>\n      <monthpicker tabindex=\"0\"></monthpicker>\n      <yearpicker tabindex=\"0\"></yearpicker>\n    </datepicker-inner>\n    ",
	            providers: [DATEPICKER_CONTROL_VALUE_ACCESSOR]
	        })
	        /* tslint:enable:component-selector-name component-selector-type */
	        ,
	        __metadata("design:paramtypes", [typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_3__datepicker_config__["a" /* DatepickerConfig */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__datepicker_config__["a" /* DatepickerConfig */]) === "function" && _d || Object])
	    ], DatePickerComponent);
	    return DatePickerComponent;
	    var _a, _b, _c, _d;
	}());
	
	
	
	/***/ }),
	/* 101 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateFormatter; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chronos_format__ = __webpack_require__(17);
	
	var DateFormatter = (function () {
	    function DateFormatter() {
	    }
	    DateFormatter.prototype.format = function (date, format, locale) {
	        return Object(__WEBPACK_IMPORTED_MODULE_0__chronos_format__["b" /* formatDate */])(date, format, locale);
	    };
	    return DateFormatter;
	}());
	
	
	
	/***/ }),
	/* 102 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DayPickerComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_theme_provider__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__datepicker_inner_component__ = __webpack_require__(29);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	// @deprecated
	// tslint:disable
	
	
	
	var DayPickerComponent = (function () {
	    function DayPickerComponent(datePicker) {
	        this.labels = [];
	        this.rows = [];
	        this.weekNumbers = [];
	        this.datePicker = datePicker;
	    }
	    Object.defineProperty(DayPickerComponent.prototype, "isBs4", {
	        get: function () {
	            return !Object(__WEBPACK_IMPORTED_MODULE_1__utils_theme_provider__["a" /* isBs3 */])();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /*protected getDaysInMonth(year:number, month:number) {
	     return ((month === 1) && (year % 4 === 0) &&
	     ((year % 100 !== 0) || (year % 400 === 0))) ? 29 : DAYS_IN_MONTH[month];
	     }*/
	    DayPickerComponent.prototype.ngOnInit = function () {
	        var self = this;
	        this.datePicker.stepDay = { months: 1 };
	        this.datePicker.setRefreshViewHandler(function () {
	            var year = this.activeDate.getFullYear();
	            var month = this.activeDate.getMonth();
	            var firstDayOfMonth = new Date(year, month, 1);
	            var difference = this.startingDay - firstDayOfMonth.getDay();
	            var numDisplayedFromPreviousMonth = difference > 0 ? 7 - difference : -difference;
	            var firstDate = new Date(firstDayOfMonth.getTime());
	            if (numDisplayedFromPreviousMonth > 0) {
	                firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
	            }
	            // 42 is the number of days on a six-week calendar
	            var _days = self.getDates(firstDate, 42);
	            var days = [];
	            for (var i = 0; i < 42; i++) {
	                var _dateObject = this.createDateObject(_days[i], this.formatDay);
	                _dateObject.secondary = _days[i].getMonth() !== month;
	                _dateObject.uid = this.uniqueId + '-' + i;
	                days[i] = _dateObject;
	            }
	            self.labels = [];
	            for (var j = 0; j < 7; j++) {
	                self.labels[j] = {};
	                self.labels[j].abbr = this.dateFilter(days[j].date, this.formatDayHeader);
	                self.labels[j].full = this.dateFilter(days[j].date, 'EEEE');
	            }
	            self.title = this.dateFilter(this.activeDate, this.formatDayTitle);
	            self.rows = this.split(days, 7);
	            if (this.showWeeks) {
	                self.weekNumbers = [];
	                var thursdayIndex = (4 + 7 - this.startingDay) % 7;
	                var numWeeks = self.rows.length;
	                for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
	                    self.weekNumbers.push(self.getISO8601WeekNumber(self.rows[curWeek][thursdayIndex].date));
	                }
	            }
	        }, 'day');
	        this.datePicker.setCompareHandler(function (date1, date2) {
	            var d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
	            var d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	            return d1.getTime() - d2.getTime();
	        }, 'day');
	        this.datePicker.refreshView();
	    };
	    DayPickerComponent.prototype.getDates = function (startDate, n) {
	        var dates = new Array(n);
	        var current = new Date(startDate.getTime());
	        var i = 0;
	        var date;
	        while (i < n) {
	            date = new Date(current.getTime());
	            date = this.datePicker.fixTimeZone(date);
	            dates[i++] = date;
	            current = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
	        }
	        return dates;
	    };
	    DayPickerComponent.prototype.getISO8601WeekNumber = function (date) {
	        var checkDate = new Date(date.getTime());
	        // Thursday
	        checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));
	        var time = checkDate.getTime();
	        // Compare with Jan 1
	        checkDate.setMonth(0);
	        checkDate.setDate(1);
	        return (Math.floor(Math.round((time - checkDate.getTime()) / 86400000) / 7) + 1);
	    };
	    DayPickerComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'daypicker',
	            template: "\n<table *ngIf=\"datePicker.datepickerMode === 'day'\" role=\"grid\" [attr.aria-labelledby]=\"datePicker.uniqueId + '-title'\" aria-activedescendant=\"activeDateId\">\n  <thead>\n    <tr>\n      <th>\n        <button *ngIf=\"!isBs4\"\n                type=\"button\"\n                class=\"btn btn-default btn-secondary btn-sm pull-left float-left\"\n                (click)=\"datePicker.move(-1)\"\n                tabindex=\"-1\">\u2039</button>\n        <button *ngIf=\"isBs4\"\n                type=\"button\"\n                class=\"btn btn-default btn-secondary btn-sm pull-left float-left\"\n                (click)=\"datePicker.move(-1)\"\n                tabindex=\"-1\">&lt;</button>\n      </th>\n      <th [attr.colspan]=\"5 + (datePicker.showWeeks ? 1 : 0)\">\n        <button [id]=\"datePicker.uniqueId + '-title'\"\n                type=\"button\" class=\"btn btn-default btn-secondary btn-sm\"\n                (click)=\"datePicker.toggleMode(0)\"\n                [disabled]=\"datePicker.datepickerMode === datePicker.maxMode\"\n                [ngClass]=\"{disabled: datePicker.datepickerMode === datePicker.maxMode}\" tabindex=\"-1\" style=\"width:100%;\">\n          <strong>{{ title }}</strong>\n        </button>\n      </th>\n      <th>\n        <button *ngIf=\"!isBs4\"\n                type=\"button\"\n                class=\"btn btn-default btn-secondary btn-sm pull-right float-right\"\n                (click)=\"datePicker.move(1)\"\n                tabindex=\"-1\">\u203A</button>\n        <button *ngIf=\"isBs4\"\n                type=\"button\"\n                class=\"btn btn-default btn-secondary btn-sm pull-right float-right\"\n                (click)=\"datePicker.move(1)\"\n                tabindex=\"-1\">&gt;\n        </button>\n      </th>\n    </tr>\n    <tr>\n      <th *ngIf=\"datePicker.showWeeks\"></th>\n      <th *ngFor=\"let labelz of labels\" class=\"text-center\">\n        <small aria-label=\"labelz.full\"><b>{{ labelz.abbr }}</b></small>\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <ng-template ngFor [ngForOf]=\"rows\" let-rowz=\"$implicit\" let-index=\"index\">\n      <tr *ngIf=\"!(datePicker.onlyCurrentMonth && rowz[0].secondary && rowz[6].secondary)\">\n        <td *ngIf=\"datePicker.showWeeks\" class=\"h6\" class=\"text-center\">\n          <em>{{ weekNumbers[index] }}</em>\n        </td>\n        <td *ngFor=\"let dtz of rowz\" class=\"text-center\" role=\"gridcell\" [id]=\"dtz.uid\">\n          <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-sm {{dtz.customClass}}\"\n                  *ngIf=\"!(datePicker.onlyCurrentMonth && dtz.secondary)\"\n                  [ngClass]=\"{'btn-secondary': isBs4 && !dtz.selected && !datePicker.isActive(dtz), 'btn-info': dtz.selected, disabled: dtz.disabled, active: !isBs4 && datePicker.isActive(dtz), 'btn-default': !isBs4}\"\n                  [disabled]=\"dtz.disabled\"\n                  (click)=\"datePicker.select(dtz.date)\" tabindex=\"-1\">\n            <span [ngClass]=\"{'text-muted': dtz.secondary || dtz.current, 'text-info': !isBs4 && dtz.current}\">{{ dtz.label }}</span>\n          </button>\n        </td>\n      </tr>\n    </ng-template>\n  </tbody>\n</table>\n  ",
	            styles: [
	                "\n    :host .btn-secondary {\n      color: #292b2c;\n      background-color: #fff;\n      border-color: #ccc;\n    }\n    :host .btn-info .text-muted {\n      color: #292b2c !important;\n    }\n  "
	            ]
	        }),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__datepicker_inner_component__["a" /* DatePickerInnerComponent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__datepicker_inner_component__["a" /* DatePickerInnerComponent */]) === "function" && _a || Object])
	    ], DayPickerComponent);
	    return DayPickerComponent;
	    var _a;
	}());
	
	
	
	/***/ }),
	/* 103 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MonthPickerComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_theme_provider__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__datepicker_inner_component__ = __webpack_require__(29);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	// @deprecated
	// tslint:disable
	
	
	
	var MonthPickerComponent = (function () {
	    function MonthPickerComponent(datePicker) {
	        this.rows = [];
	        this.datePicker = datePicker;
	    }
	    Object.defineProperty(MonthPickerComponent.prototype, "isBs4", {
	        get: function () {
	            return !Object(__WEBPACK_IMPORTED_MODULE_1__utils_theme_provider__["a" /* isBs3 */])();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    MonthPickerComponent.prototype.ngOnInit = function () {
	        var self = this;
	        this.datePicker.stepMonth = { years: 1 };
	        this.datePicker.setRefreshViewHandler(function () {
	            var months = new Array(12);
	            var year = this.activeDate.getFullYear();
	            var date;
	            for (var i = 0; i < 12; i++) {
	                date = new Date(year, i, 1);
	                date = this.fixTimeZone(date);
	                months[i] = this.createDateObject(date, this.formatMonth);
	                months[i].uid = this.uniqueId + '-' + i;
	            }
	            self.title = this.dateFilter(this.activeDate, this.formatMonthTitle);
	            self.rows = this.split(months, self.datePicker.monthColLimit);
	        }, 'month');
	        this.datePicker.setCompareHandler(function (date1, date2) {
	            var d1 = new Date(date1.getFullYear(), date1.getMonth());
	            var d2 = new Date(date2.getFullYear(), date2.getMonth());
	            return d1.getTime() - d2.getTime();
	        }, 'month');
	        this.datePicker.refreshView();
	    };
	    MonthPickerComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'monthpicker',
	            template: "\n<table *ngIf=\"datePicker.datepickerMode==='month'\" role=\"grid\">\n  <thead>\n    <tr>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-left float-left\"\n                (click)=\"datePicker.move(-1)\" tabindex=\"-1\">\u2039</button></th>\n      <th [attr.colspan]=\"((datePicker.monthColLimit - 2) <= 0) ? 1 : datePicker.monthColLimit - 2\">\n        <button [id]=\"datePicker.uniqueId + '-title'\"\n                type=\"button\" class=\"btn btn-default btn-sm\"\n                (click)=\"datePicker.toggleMode(0)\"\n                [disabled]=\"datePicker.datepickerMode === maxMode\"\n                [ngClass]=\"{disabled: datePicker.datepickerMode === maxMode}\" tabindex=\"-1\" style=\"width:100%;\">\n          <strong>{{ title }}</strong> \n        </button>\n      </th>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-right float-right\"\n                (click)=\"datePicker.move(1)\" tabindex=\"-1\">\u203A</button>\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr *ngFor=\"let rowz of rows\">\n      <td *ngFor=\"let dtz of rowz\" class=\"text-center\" role=\"gridcell\" [attr.id]=\"dtz.uid\" [ngClass]=\"dtz.customClass\">\n        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\"\n                [ngClass]=\"{'btn-link': isBs4 && !dtz.selected && !datePicker.isActive(dtz), 'btn-info': dtz.selected || (isBs4 && !dtz.selected && datePicker.isActive(dtz)), disabled: dtz.disabled, active: !isBs4 && datePicker.isActive(dtz)}\"\n                [disabled]=\"dtz.disabled\"\n                (click)=\"datePicker.select(dtz.date)\" tabindex=\"-1\">\n          <span [ngClass]=\"{'text-success': isBs4 && dtz.current, 'text-info': !isBs4 && dtz.current}\">{{ dtz.label }}</span>\n        </button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n  ",
	            styles: [
	                "\n    :host .btn-info .text-success {\n      color: #fff !important;\n    }\n  "
	            ]
	        }),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__datepicker_inner_component__["a" /* DatePickerInnerComponent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__datepicker_inner_component__["a" /* DatePickerInnerComponent */]) === "function" && _a || Object])
	    ], MonthPickerComponent);
	    return MonthPickerComponent;
	    var _a;
	}());
	
	
	
	/***/ }),
	/* 104 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return YearPickerComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_theme_provider__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__datepicker_inner_component__ = __webpack_require__(29);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	// @deprecated
	// tslint:disable
	
	
	
	var YearPickerComponent = (function () {
	    function YearPickerComponent(datePicker) {
	        this.rows = [];
	        this.datePicker = datePicker;
	    }
	    Object.defineProperty(YearPickerComponent.prototype, "isBs4", {
	        get: function () {
	            return !Object(__WEBPACK_IMPORTED_MODULE_1__utils_theme_provider__["a" /* isBs3 */])();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    YearPickerComponent.prototype.ngOnInit = function () {
	        var self = this;
	        this.datePicker.stepYear = { years: this.datePicker.yearRange };
	        this.datePicker.setRefreshViewHandler(function () {
	            var years = new Array(this.yearRange);
	            var date;
	            var start = self.getStartingYear(this.activeDate.getFullYear());
	            for (var i = 0; i < this.yearRange; i++) {
	                date = new Date(start + i, 0, 1);
	                date = this.fixTimeZone(date);
	                years[i] = this.createDateObject(date, this.formatYear);
	                years[i].uid = this.uniqueId + '-' + i;
	            }
	            self.title = [years[0].label, years[this.yearRange - 1].label].join(' - ');
	            self.rows = this.split(years, self.datePicker.yearColLimit);
	        }, 'year');
	        this.datePicker.setCompareHandler(function (date1, date2) {
	            return date1.getFullYear() - date2.getFullYear();
	        }, 'year');
	        this.datePicker.refreshView();
	    };
	    YearPickerComponent.prototype.getStartingYear = function (year) {
	        // todo: parseInt
	        return ((year - 1) / this.datePicker.yearRange * this.datePicker.yearRange + 1);
	    };
	    YearPickerComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'yearpicker',
	            template: "\n<table *ngIf=\"datePicker.datepickerMode==='year'\" role=\"grid\">\n  <thead>\n    <tr>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-left float-left\"\n                (click)=\"datePicker.move(-1)\" tabindex=\"-1\">\u2039</button>\n      </th>\n      <th [attr.colspan]=\"((datePicker.yearColLimit - 2) <= 0) ? 1 : datePicker.yearColLimit - 2\">\n        <button [id]=\"datePicker.uniqueId + '-title'\" role=\"heading\"\n                type=\"button\" class=\"btn btn-default btn-sm\"\n                (click)=\"datePicker.toggleMode(0)\"\n                [disabled]=\"datePicker.datepickerMode === datePicker.maxMode\"\n                [ngClass]=\"{disabled: datePicker.datepickerMode === datePicker.maxMode}\" tabindex=\"-1\" style=\"width:100%;\">\n          <strong>{{ title }}</strong>\n        </button>\n      </th>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-right float-right\"\n                (click)=\"datePicker.move(1)\" tabindex=\"-1\">\u203A</button>\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr *ngFor=\"let rowz of rows\">\n      <td *ngFor=\"let dtz of rowz\" class=\"text-center\" role=\"gridcell\" [attr.id]=\"dtz.uid\">\n        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\"\n                [ngClass]=\"{'btn-link': isBs4 && !dtz.selected && !datePicker.isActive(dtz), 'btn-info': dtz.selected || (isBs4 && !dtz.selected && datePicker.isActive(dtz)), disabled: dtz.disabled, active: !isBs4 && datePicker.isActive(dtz)}\"\n                [disabled]=\"dtz.disabled\"\n                (click)=\"datePicker.select(dtz.date)\" tabindex=\"-1\">\n          <span [ngClass]=\"{'text-success': isBs4 && dtz.current, 'text-info': !isBs4 && dtz.current}\">{{ dtz.label }}</span>\n        </button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n  ",
	            styles: [
	                "\n    :host .btn-info .text-success {\n      color: #fff !important;\n    }\n  "
	            ]
	        }),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__datepicker_inner_component__["a" /* DatePickerInnerComponent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__datepicker_inner_component__["a" /* DatePickerInnerComponent */]) === "function" && _a || Object])
	    ], YearPickerComponent);
	    return YearPickerComponent;
	    var _a;
	}());
	
	
	
	/***/ }),
	/* 105 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ComponentLoader; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_triggers__ = __webpack_require__(106);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__content_ref_class__ = __webpack_require__(107);
	// tslint:disable:max-file-line-count
	// todo: add delay support
	// todo: merge events onShow, onShown, etc...
	// todo: add global positioning configuration?
	
	
	
	var ComponentLoader = (function () {
	    /**
	     * Do not use this directly, it should be instanced via
	     * `ComponentLoadFactory.attach`
	     * @internal
	     */
	    // tslint:disable-next-line
	    function ComponentLoader(_viewContainerRef, _renderer, _elementRef, _injector, _componentFactoryResolver, _ngZone, _applicationRef, _posService) {
	        this._viewContainerRef = _viewContainerRef;
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        this._injector = _injector;
	        this._componentFactoryResolver = _componentFactoryResolver;
	        this._ngZone = _ngZone;
	        this._applicationRef = _applicationRef;
	        this._posService = _posService;
	        this.onBeforeShow = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.onShown = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.onBeforeHide = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.onHidden = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this._providers = [];
	        this._isHiding = false;
	        this._listenOpts = {};
	        this._globalListener = Function.prototype;
	    }
	    Object.defineProperty(ComponentLoader.prototype, "isShown", {
	        get: function () {
	            if (this._isHiding) {
	                return false;
	            }
	            return !!this._componentRef;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ComponentLoader.prototype.attach = function (compType) {
	        this._componentFactory = this._componentFactoryResolver
	            .resolveComponentFactory(compType);
	        return this;
	    };
	    // todo: add behaviour: to target element, `body`, custom element
	    ComponentLoader.prototype.to = function (container) {
	        this.container = container || this.container;
	        return this;
	    };
	    ComponentLoader.prototype.position = function (opts) {
	        this.attachment = opts.attachment || this.attachment;
	        this._elementRef = opts.target || this._elementRef;
	        return this;
	    };
	    ComponentLoader.prototype.provide = function (provider) {
	        this._providers.push(provider);
	        return this;
	    };
	    // todo: appendChild to element or document.querySelector(this.container)
	    ComponentLoader.prototype.show = function (opts) {
	        if (opts === void 0) { opts = {}; }
	        this._subscribePositioning();
	        this._innerComponent = null;
	        if (!this._componentRef) {
	            this.onBeforeShow.emit();
	            this._contentRef = this._getContentRef(opts.content, opts.context, opts.initialState);
	            var injector = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ReflectiveInjector"].resolveAndCreate(this._providers, this._injector);
	            this._componentRef = this._componentFactory.create(injector, this._contentRef.nodes);
	            this._applicationRef.attachView(this._componentRef.hostView);
	            // this._componentRef = this._viewContainerRef
	            //   .createComponent(this._componentFactory, 0, injector, this._contentRef.nodes);
	            this.instance = this._componentRef.instance;
	            Object.assign(this._componentRef.instance, opts);
	            if (this.container instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) {
	                this.container.nativeElement.appendChild(this._componentRef.location.nativeElement);
	            }
	            if (this.container === 'body' && typeof document !== 'undefined') {
	                document
	                    .querySelector(this.container)
	                    .appendChild(this._componentRef.location.nativeElement);
	            }
	            if (!this.container &&
	                this._elementRef &&
	                this._elementRef.nativeElement.parentElement) {
	                this._elementRef.nativeElement.parentElement.appendChild(this._componentRef.location.nativeElement);
	            }
	            // we need to manually invoke change detection since events registered
	            // via
	            // Renderer::listen() are not picked up by change detection with the
	            // OnPush strategy
	            if (this._contentRef.componentRef) {
	                this._innerComponent = this._contentRef.componentRef.instance;
	                this._contentRef.componentRef.changeDetectorRef.markForCheck();
	                this._contentRef.componentRef.changeDetectorRef.detectChanges();
	            }
	            this._componentRef.changeDetectorRef.markForCheck();
	            this._componentRef.changeDetectorRef.detectChanges();
	            this.onShown.emit(this._componentRef.instance);
	        }
	        this._registerOutsideClick();
	        return this._componentRef;
	    };
	    ComponentLoader.prototype.hide = function () {
	        if (!this._componentRef) {
	            return this;
	        }
	        this.onBeforeHide.emit(this._componentRef.instance);
	        var componentEl = this._componentRef.location.nativeElement;
	        componentEl.parentNode.removeChild(componentEl);
	        if (this._contentRef.componentRef) {
	            this._contentRef.componentRef.destroy();
	        }
	        this._componentRef.destroy();
	        if (this._viewContainerRef && this._contentRef.viewRef) {
	            this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._contentRef.viewRef));
	        }
	        if (this._contentRef.viewRef) {
	            this._contentRef.viewRef.destroy();
	        }
	        // this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._componentRef.hostView));
	        //
	        // if (this._contentRef.viewRef && this._viewContainerRef.indexOf(this._contentRef.viewRef) !== -1) {
	        //   this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._contentRef.viewRef));
	        // }
	        this._contentRef = null;
	        this._componentRef = null;
	        this._removeGlobalListener();
	        this.onHidden.emit();
	        return this;
	    };
	    ComponentLoader.prototype.toggle = function () {
	        if (this.isShown) {
	            this.hide();
	            return;
	        }
	        this.show();
	    };
	    ComponentLoader.prototype.dispose = function () {
	        if (this.isShown) {
	            this.hide();
	        }
	        this._unsubscribePositioning();
	        if (this._unregisterListenersFn) {
	            this._unregisterListenersFn();
	        }
	    };
	    ComponentLoader.prototype.listen = function (listenOpts) {
	        var _this = this;
	        this.triggers = listenOpts.triggers || this.triggers;
	        this._listenOpts.outsideClick = listenOpts.outsideClick;
	        listenOpts.target = listenOpts.target || this._elementRef.nativeElement;
	        var hide = (this._listenOpts.hide = function () {
	            return listenOpts.hide ? listenOpts.hide() : void _this.hide();
	        });
	        var show = (this._listenOpts.show = function (registerHide) {
	            listenOpts.show ? listenOpts.show(registerHide) : _this.show(registerHide);
	            registerHide();
	        });
	        var toggle = function (registerHide) {
	            _this.isShown ? hide() : show(registerHide);
	        };
	        this._unregisterListenersFn = Object(__WEBPACK_IMPORTED_MODULE_1__utils_triggers__["a" /* listenToTriggersV2 */])(this._renderer, {
	            target: listenOpts.target,
	            triggers: listenOpts.triggers,
	            show: show,
	            hide: hide,
	            toggle: toggle
	        });
	        return this;
	    };
	    ComponentLoader.prototype._removeGlobalListener = function () {
	        if (this._globalListener) {
	            this._globalListener();
	            this._globalListener = null;
	        }
	    };
	    ComponentLoader.prototype.attachInline = function (vRef, template) {
	        this._inlineViewRef = vRef.createEmbeddedView(template);
	        return this;
	    };
	    ComponentLoader.prototype._registerOutsideClick = function () {
	        var _this = this;
	        if (!this._componentRef || !this._componentRef.location) {
	            return;
	        }
	        // why: should run after first event bubble
	        if (this._listenOpts.outsideClick) {
	            var target_1 = this._componentRef.location.nativeElement;
	            setTimeout(function () {
	                _this._globalListener = Object(__WEBPACK_IMPORTED_MODULE_1__utils_triggers__["c" /* registerOutsideClick */])(_this._renderer, {
	                    targets: [target_1, _this._elementRef.nativeElement],
	                    outsideClick: _this._listenOpts.outsideClick,
	                    hide: function () { return _this._listenOpts.hide(); }
	                });
	            });
	        }
	    };
	    ComponentLoader.prototype.getInnerComponent = function () {
	        return this._innerComponent;
	    };
	    ComponentLoader.prototype._subscribePositioning = function () {
	        var _this = this;
	        if (this._zoneSubscription || !this.attachment) {
	            return;
	        }
	        this._zoneSubscription = this._ngZone.onStable.subscribe(function () {
	            if (!_this._componentRef) {
	                return;
	            }
	            _this._posService.position({
	                element: _this._componentRef.location,
	                target: _this._elementRef,
	                attachment: _this.attachment,
	                appendToBody: _this.container === 'body'
	            });
	        });
	    };
	    ComponentLoader.prototype._unsubscribePositioning = function () {
	        if (!this._zoneSubscription) {
	            return;
	        }
	        this._zoneSubscription.unsubscribe();
	        this._zoneSubscription = null;
	    };
	    ComponentLoader.prototype._getContentRef = function (content, context, initialState) {
	        if (!content) {
	            return new __WEBPACK_IMPORTED_MODULE_2__content_ref_class__["a" /* ContentRef */]([]);
	        }
	        if (content instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]) {
	            if (this._viewContainerRef) {
	                var _viewRef = this._viewContainerRef
	                    .createEmbeddedView(content, context);
	                _viewRef.markForCheck();
	                return new __WEBPACK_IMPORTED_MODULE_2__content_ref_class__["a" /* ContentRef */]([_viewRef.rootNodes], _viewRef);
	            }
	            var viewRef = content.createEmbeddedView({});
	            this._applicationRef.attachView(viewRef);
	            return new __WEBPACK_IMPORTED_MODULE_2__content_ref_class__["a" /* ContentRef */]([viewRef.rootNodes], viewRef);
	        }
	        if (typeof content === 'function') {
	            var contentCmptFactory = this._componentFactoryResolver.resolveComponentFactory(content);
	            var modalContentInjector = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ReflectiveInjector"].resolveAndCreate(this._providers.slice(), this._injector);
	            var componentRef = contentCmptFactory.create(modalContentInjector);
	            Object.assign(componentRef.instance, initialState);
	            this._applicationRef.attachView(componentRef.hostView);
	            return new __WEBPACK_IMPORTED_MODULE_2__content_ref_class__["a" /* ContentRef */]([[componentRef.location.nativeElement]], componentRef.hostView, componentRef);
	        }
	        return new __WEBPACK_IMPORTED_MODULE_2__content_ref_class__["a" /* ContentRef */]([[this._renderer.createText("" + content)]]);
	    };
	    return ComponentLoader;
	}());
	
	
	
	/***/ }),
	/* 106 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["b"] = parseTriggers;
	/* unused harmony export listenToTriggers */
	/* harmony export (immutable) */ __webpack_exports__["a"] = listenToTriggersV2;
	/* harmony export (immutable) */ __webpack_exports__["c"] = registerOutsideClick;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trigger_class__ = __webpack_require__(98);
	
	var DEFAULT_ALIASES = {
	    hover: ['mouseover', 'mouseout'],
	    focus: ['focusin', 'focusout']
	};
	function parseTriggers(triggers, aliases) {
	    if (aliases === void 0) { aliases = DEFAULT_ALIASES; }
	    var trimmedTriggers = (triggers || '').trim();
	    if (trimmedTriggers.length === 0) {
	        return [];
	    }
	    var parsedTriggers = trimmedTriggers
	        .split(/\s+/)
	        .map(function (trigger) { return trigger.split(':'); })
	        .map(function (triggerPair) {
	        var alias = aliases[triggerPair[0]] || triggerPair;
	        return new __WEBPACK_IMPORTED_MODULE_0__trigger_class__["a" /* Trigger */](alias[0], alias[1]);
	    });
	    var manualTriggers = parsedTriggers.filter(function (triggerPair) {
	        return triggerPair.isManual();
	    });
	    if (manualTriggers.length > 1) {
	        throw new Error('Triggers parse error: only one manual trigger is allowed');
	    }
	    if (manualTriggers.length === 1 && parsedTriggers.length > 1) {
	        throw new Error('Triggers parse error: manual trigger can\'t be mixed with other triggers');
	    }
	    return parsedTriggers;
	}
	function listenToTriggers(renderer, target, triggers, showFn, hideFn, toggleFn) {
	    var parsedTriggers = parseTriggers(triggers);
	    var listeners = [];
	    if (parsedTriggers.length === 1 && parsedTriggers[0].isManual()) {
	        return Function.prototype;
	    }
	    parsedTriggers.forEach(function (trigger) {
	        if (trigger.open === trigger.close) {
	            listeners.push(renderer.listen(target, trigger.open, toggleFn));
	            return;
	        }
	        listeners.push(renderer.listen(target, trigger.open, showFn), renderer.listen(target, trigger.close, hideFn));
	    });
	    return function () {
	        listeners.forEach(function (unsubscribeFn) { return unsubscribeFn(); });
	    };
	}
	function listenToTriggersV2(renderer, options) {
	    var parsedTriggers = parseTriggers(options.triggers);
	    var target = options.target;
	    // do nothing
	    if (parsedTriggers.length === 1 && parsedTriggers[0].isManual()) {
	        return Function.prototype;
	    }
	    // all listeners
	    var listeners = [];
	    // lazy listeners registration
	    var _registerHide = [];
	    var registerHide = function () {
	        // add hide listeners to unregister array
	        _registerHide.forEach(function (fn) { return listeners.push(fn()); });
	        // register hide events only once
	        _registerHide.length = 0;
	    };
	    // register open\close\toggle listeners
	    parsedTriggers.forEach(function (trigger) {
	        var useToggle = trigger.open === trigger.close;
	        var showFn = useToggle ? options.toggle : options.show;
	        if (!useToggle) {
	            _registerHide.push(function () {
	                return renderer.listen(target, trigger.close, options.hide);
	            });
	        }
	        listeners.push(renderer.listen(target, trigger.open, function () { return showFn(registerHide); }));
	    });
	    return function () {
	        listeners.forEach(function (unsubscribeFn) { return unsubscribeFn(); });
	    };
	}
	function registerOutsideClick(renderer, options) {
	    if (!options.outsideClick) {
	        return Function.prototype;
	    }
	    return renderer.listen('document', 'click', function (event) {
	        if (options.target && options.target.contains(event.target)) {
	            return;
	        }
	        if (options.targets &&
	            options.targets.some(function (target) { return target.contains(event.target); })) {
	            return;
	        }
	        options.hide();
	    });
	}
	
	
	/***/ }),
	/* 107 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContentRef; });
	/**
	 * @copyright Valor Software
	 * @copyright Angular ng-bootstrap team
	 */
	var ContentRef = (function () {
	    function ContentRef(nodes, viewRef, componentRef) {
	        this.nodes = nodes;
	        this.viewRef = viewRef;
	        this.componentRef = componentRef;
	    }
	    return ContentRef;
	}());
	
	
	
	/***/ }),
	/* 108 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Positioning; });
	/* harmony export (immutable) */ __webpack_exports__["b"] = positionElements;
	/**
	 * @copyright Valor Software
	 * @copyright Angular ng-bootstrap team
	 */
	// previous version:
	// https://github.com/angular-ui/bootstrap/blob/07c31d0731f7cb068a1932b8e01d2312b796b4ec/src/position/position.js
	// tslint:disable
	var Positioning = (function () {
	    function Positioning() {
	    }
	    Positioning.prototype.position = function (element, round) {
	        if (round === void 0) { round = true; }
	        var elPosition;
	        var parentOffset = {
	            width: 0,
	            height: 0,
	            top: 0,
	            bottom: 0,
	            left: 0,
	            right: 0
	        };
	        if (this.getStyle(element, 'position') === 'fixed') {
	            var bcRect = element.getBoundingClientRect();
	            elPosition = {
	                width: bcRect.width,
	                height: bcRect.height,
	                top: bcRect.top,
	                bottom: bcRect.bottom,
	                left: bcRect.left,
	                right: bcRect.right
	            };
	        }
	        else {
	            var offsetParentEl = this.offsetParent(element);
	            elPosition = this.offset(element, false);
	            if (offsetParentEl !== document.documentElement) {
	                parentOffset = this.offset(offsetParentEl, false);
	            }
	            parentOffset.top += offsetParentEl.clientTop;
	            parentOffset.left += offsetParentEl.clientLeft;
	        }
	        elPosition.top -= parentOffset.top;
	        elPosition.bottom -= parentOffset.top;
	        elPosition.left -= parentOffset.left;
	        elPosition.right -= parentOffset.left;
	        if (round) {
	            elPosition.top = Math.round(elPosition.top);
	            elPosition.bottom = Math.round(elPosition.bottom);
	            elPosition.left = Math.round(elPosition.left);
	            elPosition.right = Math.round(elPosition.right);
	        }
	        return elPosition;
	    };
	    Positioning.prototype.offset = function (element, round) {
	        if (round === void 0) { round = true; }
	        var elBcr = element.getBoundingClientRect();
	        var viewportOffset = {
	            top: window.pageYOffset - document.documentElement.clientTop,
	            left: window.pageXOffset - document.documentElement.clientLeft
	        };
	        var elOffset = {
	            height: elBcr.height || element.offsetHeight,
	            width: elBcr.width || element.offsetWidth,
	            top: elBcr.top + viewportOffset.top,
	            bottom: elBcr.bottom + viewportOffset.top,
	            left: elBcr.left + viewportOffset.left,
	            right: elBcr.right + viewportOffset.left
	        };
	        if (round) {
	            elOffset.height = Math.round(elOffset.height);
	            elOffset.width = Math.round(elOffset.width);
	            elOffset.top = Math.round(elOffset.top);
	            elOffset.bottom = Math.round(elOffset.bottom);
	            elOffset.left = Math.round(elOffset.left);
	            elOffset.right = Math.round(elOffset.right);
	        }
	        return elOffset;
	    };
	    Positioning.prototype.positionElements = function (hostElement, targetElement, placement, appendToBody) {
	        var hostElPosition = appendToBody
	            ? this.offset(hostElement, false)
	            : this.position(hostElement, false);
	        var targetElStyles = this.getAllStyles(targetElement);
	        var shiftWidth = {
	            left: hostElPosition.left,
	            center: hostElPosition.left +
	                hostElPosition.width / 2 -
	                targetElement.offsetWidth / 2,
	            right: hostElPosition.left + hostElPosition.width
	        };
	        var shiftHeight = {
	            top: hostElPosition.top,
	            center: hostElPosition.top +
	                hostElPosition.height / 2 -
	                targetElement.offsetHeight / 2,
	            bottom: hostElPosition.top + hostElPosition.height
	        };
	        var targetElBCR = targetElement.getBoundingClientRect();
	        var placementPrimary = placement.split(' ')[0] || 'top';
	        var placementSecondary = placement.split(' ')[1] || 'center';
	        var targetElPosition = {
	            height: targetElBCR.height || targetElement.offsetHeight,
	            width: targetElBCR.width || targetElement.offsetWidth,
	            top: 0,
	            bottom: targetElBCR.height || targetElement.offsetHeight,
	            left: 0,
	            right: targetElBCR.width || targetElement.offsetWidth
	        };
	        if (placementPrimary === 'auto') {
	            var newPlacementPrimary = this.autoPosition(targetElPosition, hostElPosition, targetElement, placementSecondary);
	            if (!newPlacementPrimary)
	                newPlacementPrimary = this.autoPosition(targetElPosition, hostElPosition, targetElement);
	            if (newPlacementPrimary)
	                placementPrimary = newPlacementPrimary;
	            targetElement.classList.add(placementPrimary);
	        }
	        switch (placementPrimary) {
	            case 'top':
	                targetElPosition.top =
	                    hostElPosition.top -
	                        (targetElement.offsetHeight +
	                            parseFloat(targetElStyles.marginBottom));
	                targetElPosition.bottom +=
	                    hostElPosition.top - targetElement.offsetHeight;
	                targetElPosition.left = shiftWidth[placementSecondary];
	                targetElPosition.right += shiftWidth[placementSecondary];
	                break;
	            case 'bottom':
	                targetElPosition.top = shiftHeight[placementPrimary];
	                targetElPosition.bottom += shiftHeight[placementPrimary];
	                targetElPosition.left = shiftWidth[placementSecondary];
	                targetElPosition.right += shiftWidth[placementSecondary];
	                break;
	            case 'left':
	                targetElPosition.top = shiftHeight[placementSecondary];
	                targetElPosition.bottom += shiftHeight[placementSecondary];
	                targetElPosition.left =
	                    hostElPosition.left -
	                        (targetElement.offsetWidth + parseFloat(targetElStyles.marginRight));
	                targetElPosition.right +=
	                    hostElPosition.left - targetElement.offsetWidth;
	                break;
	            case 'right':
	                targetElPosition.top = shiftHeight[placementSecondary];
	                targetElPosition.bottom += shiftHeight[placementSecondary];
	                targetElPosition.left = shiftWidth[placementPrimary];
	                targetElPosition.right += shiftWidth[placementPrimary];
	                break;
	        }
	        targetElPosition.top = Math.round(targetElPosition.top);
	        targetElPosition.bottom = Math.round(targetElPosition.bottom);
	        targetElPosition.left = Math.round(targetElPosition.left);
	        targetElPosition.right = Math.round(targetElPosition.right);
	        return targetElPosition;
	    };
	    Positioning.prototype.autoPosition = function (targetElPosition, hostElPosition, targetElement, preferredPosition) {
	        if ((!preferredPosition || preferredPosition === 'right') &&
	            targetElPosition.left + hostElPosition.left - targetElement.offsetWidth <
	                0) {
	            return 'right';
	        }
	        else if ((!preferredPosition || preferredPosition === 'top') &&
	            targetElPosition.bottom +
	                hostElPosition.bottom +
	                targetElement.offsetHeight >
	                window.innerHeight) {
	            return 'top';
	        }
	        else if ((!preferredPosition || preferredPosition === 'bottom') &&
	            targetElPosition.top + hostElPosition.top - targetElement.offsetHeight < 0) {
	            return 'bottom';
	        }
	        else if ((!preferredPosition || preferredPosition === 'left') &&
	            targetElPosition.right +
	                hostElPosition.right +
	                targetElement.offsetWidth >
	                window.innerWidth) {
	            return 'left';
	        }
	        return null;
	    };
	    Positioning.prototype.getAllStyles = function (element) {
	        return window.getComputedStyle(element);
	    };
	    Positioning.prototype.getStyle = function (element, prop) {
	        return this.getAllStyles(element)[prop];
	    };
	    Positioning.prototype.isStaticPositioned = function (element) {
	        return (this.getStyle(element, 'position') || 'static') === 'static';
	    };
	    Positioning.prototype.offsetParent = function (element) {
	        var offsetParentEl = element.offsetParent || document.documentElement;
	        while (offsetParentEl &&
	            offsetParentEl !== document.documentElement &&
	            this.isStaticPositioned(offsetParentEl)) {
	            offsetParentEl = offsetParentEl.offsetParent;
	        }
	        return offsetParentEl || document.documentElement;
	    };
	    return Positioning;
	}());
	
	var positionService = new Positioning();
	function positionElements(hostElement, targetElement, placement, appendToBody) {
	    var pos = positionService.positionElements(hostElement, targetElement, placement, appendToBody);
	    targetElement.style.top = pos.top + "px";
	    targetElement.style.left = pos.left + "px";
	}
	
	
	/***/ }),
	/* 109 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PositioningService; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ng_positioning__ = __webpack_require__(108);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	var PositioningService = (function () {
	    function PositioningService() {
	    }
	    PositioningService.prototype.position = function (options) {
	        var element = options.element, target = options.target, attachment = options.attachment, appendToBody = options.appendToBody;
	        Object(__WEBPACK_IMPORTED_MODULE_1__ng_positioning__["b" /* positionElements */])(_getHtmlElement(target), _getHtmlElement(element), attachment, appendToBody);
	    };
	    PositioningService = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	    ], PositioningService);
	    return PositioningService;
	}());
	
	function _getHtmlElement(element) {
	    // it means that we got a selector
	    if (typeof element === 'string') {
	        return document.querySelector(element);
	    }
	    if (element instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) {
	        return element.nativeElement;
	    }
	    return element;
	}
	
	
	/***/ }),
	/* 110 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = warnOnce;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	
	var _messagesHash = {};
	var _hideMsg = typeof console === 'undefined' || !('warn' in console);
	function warnOnce(msg) {
	    if (!Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["isDevMode"])() || _hideMsg || msg in _messagesHash) {
	        return;
	    }
	    _messagesHash[msg] = true;
	    /*tslint:disable-next-line*/
	    console.warn(msg);
	}
	
	
	/***/ }),
	/* 111 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDatepickerContainerComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_bs_datepicker_container__ = __webpack_require__(112);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bs_datepicker_config__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer_bs_datepicker_actions__ = __webpack_require__(30);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer_bs_datepicker_effects__ = __webpack_require__(64);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducer_bs_datepicker_store__ = __webpack_require__(65);
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	
	
	
	var BsDatepickerContainerComponent = (function (_super) {
	    __extends(BsDatepickerContainerComponent, _super);
	    function BsDatepickerContainerComponent(_config, _store, _actions, _effects) {
	        var _this = _super.call(this) || this;
	        _this._config = _config;
	        _this._store = _store;
	        _this._actions = _actions;
	        _this.valueChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        _this._subs = [];
	        _this._effects = _effects;
	        return _this;
	    }
	    Object.defineProperty(BsDatepickerContainerComponent.prototype, "value", {
	        set: function (value) {
	            this._effects.setValue(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BsDatepickerContainerComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.containerClass = this._config.containerClass;
	        this._effects
	            .init(this._store)
	            .setOptions(this._config)
	            .setBindings(this)
	            .setEventHandlers(this)
	            .registerDatepickerSideEffects();
	        // todo: move it somewhere else
	        // on selected date change
	        this._subs.push(this._store
	            .select(function (state) { return state.selectedDate; })
	            .subscribe(function (date) { return _this.valueChange.emit(date); }));
	    };
	    BsDatepickerContainerComponent.prototype.daySelectHandler = function (day) {
	        if (day.isOtherMonth || day.isDisabled) {
	            return;
	        }
	        this._store.dispatch(this._actions.select(day.date));
	    };
	    BsDatepickerContainerComponent.prototype.ngOnDestroy = function () {
	        for (var _i = 0, _a = this._subs; _i < _a.length; _i++) {
	            var sub = _a[_i];
	            sub.unsubscribe();
	        }
	        this._effects.destroy();
	    };
	    BsDatepickerContainerComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'bs-datepicker-container',
	            providers: [__WEBPACK_IMPORTED_MODULE_5__reducer_bs_datepicker_store__["a" /* BsDatepickerStore */], __WEBPACK_IMPORTED_MODULE_4__reducer_bs_datepicker_effects__["a" /* BsDatepickerEffects */]],
	            template: "<!-- days calendar view mode --> <div class=\"bs-datepicker\" [ngClass]=\"containerClass\" *ngIf=\"viewMode | async\"> <div class=\"bs-datepicker-container\"> <!--calendars--> <div class=\"bs-calendar-container\" [ngSwitch]=\"viewMode | async\" role=\"application\"> <!--days calendar--> <div *ngSwitchCase=\"'day'\"> <bs-days-calendar-view *ngFor=\"let calendar of (daysCalendar | async)\" [class.bs-datepicker-multiple]=\"(daysCalendar | async)?.length > 1\" [calendar]=\"calendar\" [options]=\"options | async\" (onNavigate)=\"navigateTo($event)\" (onViewMode)=\"setViewMode($event)\" (onHover)=\"dayHoverHandler($event)\" (onSelect)=\"daySelectHandler($event)\" ></bs-days-calendar-view> </div> <!--months calendar--> <div *ngSwitchCase=\"'month'\"> <bs-month-calendar-view *ngFor=\"let calendar of (monthsCalendar | async)\" [class.bs-datepicker-multiple]=\"(daysCalendar | async)?.length > 1\" [calendar]=\"calendar\" (onNavigate)=\"navigateTo($event)\" (onViewMode)=\"setViewMode($event)\" (onHover)=\"monthHoverHandler($event)\" (onSelect)=\"monthSelectHandler($event)\" ></bs-month-calendar-view> </div> <!--years calendar--> <div *ngSwitchCase=\"'year'\"> <bs-years-calendar-view *ngFor=\"let calendar of (yearsCalendar | async)\" [class.bs-datepicker-multiple]=\"(daysCalendar | async)?.length > 1\" [calendar]=\"calendar\" (onNavigate)=\"navigateTo($event)\" (onViewMode)=\"setViewMode($event)\" (onHover)=\"yearHoverHandler($event)\" (onSelect)=\"yearSelectHandler($event)\" ></bs-years-calendar-view> </div> </div> <!--applycancel buttons--> <div class=\"bs-datepicker-buttons\" *ngIf=\"false\"> <button class=\"btn btn-success\">Apply</button> <button class=\"btn btn-default\">Cancel</button> </div> </div> <!--custom dates or date ranges picker--> <div class=\"bs-datepicker-custom-range\" *ngIf=\"false\"> <bs-custom-date-view [ranges]=\"_customRangesFish\"></bs-custom-date-view> </div> </div> ",
	            host: {
	                '(click)': '_stopPropagation($event)',
	                style: 'position: absolute; display: block;',
	                role: 'dialog',
	                'aria-label': 'calendar'
	            }
	        }),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__bs_datepicker_config__["a" /* BsDatepickerConfig */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__bs_datepicker_config__["a" /* BsDatepickerConfig */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_5__reducer_bs_datepicker_store__["a" /* BsDatepickerStore */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__reducer_bs_datepicker_store__["a" /* BsDatepickerStore */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_3__reducer_bs_datepicker_actions__["a" /* BsDatepickerActions */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__reducer_bs_datepicker_actions__["a" /* BsDatepickerActions */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_4__reducer_bs_datepicker_effects__["a" /* BsDatepickerEffects */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4__reducer_bs_datepicker_effects__["a" /* BsDatepickerEffects */]) === "function" && _d || Object])
	    ], BsDatepickerContainerComponent);
	    return BsDatepickerContainerComponent;
	    var _a, _b, _c, _d;
	}(__WEBPACK_IMPORTED_MODULE_1__base_bs_datepicker_container__["a" /* BsDatepickerAbstractComponent */]));
	
	
	
	/***/ }),
	/* 112 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDatepickerAbstractComponent; });
	var BsDatepickerAbstractComponent = (function () {
	    function BsDatepickerAbstractComponent() {
	        this._customRangesFish = [];
	    }
	    Object.defineProperty(BsDatepickerAbstractComponent.prototype, "minDate", {
	        set: function (value) {
	            this._effects.setMinDate(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BsDatepickerAbstractComponent.prototype, "maxDate", {
	        set: function (value) {
	            this._effects.setMaxDate(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BsDatepickerAbstractComponent.prototype, "isDisabled", {
	        set: function (value) {
	            this._effects.setDisabled(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BsDatepickerAbstractComponent.prototype.setViewMode = function (event) { };
	    BsDatepickerAbstractComponent.prototype.navigateTo = function (event) { };
	    BsDatepickerAbstractComponent.prototype.dayHoverHandler = function (event) { };
	    BsDatepickerAbstractComponent.prototype.monthHoverHandler = function (event) { };
	    BsDatepickerAbstractComponent.prototype.yearHoverHandler = function (event) { };
	    BsDatepickerAbstractComponent.prototype.daySelectHandler = function (day) { };
	    BsDatepickerAbstractComponent.prototype.monthSelectHandler = function (event) { };
	    BsDatepickerAbstractComponent.prototype.yearSelectHandler = function (event) { };
	    BsDatepickerAbstractComponent.prototype._stopPropagation = function (event) {
	        event.stopPropagation();
	    };
	    return BsDatepickerAbstractComponent;
	}());
	
	
	
	/***/ }),
	/* 113 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_113__;
	
	/***/ }),
	/* 114 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MiniStore; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__(66);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_distinctUntilChanged__ = __webpack_require__(175);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_distinctUntilChanged___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_operator_distinctUntilChanged__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_map__ = __webpack_require__(176);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_operator_map__);
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	/**
	 * @copyright ngrx
	 */
	
	
	
	var MiniStore = (function (_super) {
	    __extends(MiniStore, _super);
	    function MiniStore(_dispatcher, _reducer, state$) {
	        var _this = _super.call(this) || this;
	        _this._dispatcher = _dispatcher;
	        _this._reducer = _reducer;
	        _this.source = state$;
	        return _this;
	    }
	    MiniStore.prototype.select = function (pathOrMapFn) {
	        var mapped$ = __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_map__["map"].call(this, pathOrMapFn);
	        return __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_distinctUntilChanged__["distinctUntilChanged"].call(mapped$);
	    };
	    MiniStore.prototype.lift = function (operator) {
	        var store = new MiniStore(this._dispatcher, this._reducer, this);
	        store.operator = operator;
	        return store;
	    };
	    MiniStore.prototype.dispatch = function (action) {
	        this._dispatcher.next(action);
	    };
	    MiniStore.prototype.next = function (action) {
	        this._dispatcher.next(action);
	    };
	    MiniStore.prototype.error = function (err) {
	        this._dispatcher.error(err);
	    };
	    MiniStore.prototype.complete = function () {
	        /*noop*/
	    };
	    return MiniStore;
	}(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"]));
	
	
	
	/***/ }),
	/* 115 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export BsDatepickerState */
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initialDatepickerState; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaults__ = __webpack_require__(177);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bs_datepicker_config__ = __webpack_require__(18);
	
	
	var BsDatepickerState = (function () {
	    function BsDatepickerState() {
	    }
	    return BsDatepickerState;
	}());
	
	var _initialView = { date: new Date(), mode: 'day' };
	var initialDatepickerState = Object.assign(new __WEBPACK_IMPORTED_MODULE_1__bs_datepicker_config__["a" /* BsDatepickerConfig */](), {
	    locale: 'en',
	    view: _initialView,
	    selectedRange: [],
	    monthViewOptions: __WEBPACK_IMPORTED_MODULE_0__defaults__["a" /* defaultMonthOptions */]
	});
	
	
	/***/ }),
	/* 116 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MiniState; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__ = __webpack_require__(38);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_observeOn__ = __webpack_require__(178);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_observeOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_operator_observeOn__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_scheduler_queue__ = __webpack_require__(179);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_scheduler_queue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_scheduler_queue__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_scan__ = __webpack_require__(180);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_scan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_scan__);
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	/**
	 * @copyright ngrx
	 */
	
	
	
	
	var MiniState = (function (_super) {
	    __extends(MiniState, _super);
	    function MiniState(_initialState, actionsDispatcher$, reducer) {
	        var _this = _super.call(this, _initialState) || this;
	        var actionInQueue$ = __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_observeOn__["observeOn"].call(actionsDispatcher$, __WEBPACK_IMPORTED_MODULE_2_rxjs_scheduler_queue__["queue"]);
	        var state$ = __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_scan__["scan"].call(actionInQueue$, function (state, action) {
	            if (!action) {
	                return state;
	            }
	            return reducer(state, action);
	        }, _initialState);
	        state$.subscribe(function (value) { return _this.next(value); });
	        return _this;
	    }
	    return MiniState;
	}(__WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"]));
	
	
	
	/***/ }),
	/* 117 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return yearsPerCalendar; });
	/* harmony export (immutable) */ __webpack_exports__["a"] = formatYearsCalendar;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chronos_utils_date_setters__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chronos_format__ = __webpack_require__(17);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_matrix_utils__ = __webpack_require__(67);
	
	
	
	var height = 4;
	var width = 4;
	var yearsPerCalendar = height * width;
	var initialShift = (Math.floor(yearsPerCalendar / 2) - 1) * -1;
	var shift = { year: 1 };
	function formatYearsCalendar(viewDate, formatOptions) {
	    var initialDate = Object(__WEBPACK_IMPORTED_MODULE_0__chronos_utils_date_setters__["j" /* shiftDate */])(viewDate, { year: initialShift });
	    var matrixOptions = { width: width, height: height, initialDate: initialDate, shift: shift };
	    var yearsMatrix = Object(__WEBPACK_IMPORTED_MODULE_2__utils_matrix_utils__["a" /* createMatrix */])(matrixOptions, function (date) { return ({
	        date: date,
	        label: Object(__WEBPACK_IMPORTED_MODULE_1__chronos_format__["b" /* formatDate */])(date, formatOptions.yearLabel, formatOptions.locale)
	    }); });
	    var yearTitle = formatYearRangeTitle(yearsMatrix, formatOptions);
	    return {
	        years: yearsMatrix,
	        monthTitle: '',
	        yearTitle: yearTitle
	    };
	}
	function formatYearRangeTitle(yearsMatrix, formatOptions) {
	    var from = Object(__WEBPACK_IMPORTED_MODULE_1__chronos_format__["b" /* formatDate */])(yearsMatrix[0][0].date, formatOptions.yearTitle, formatOptions.locale);
	    var to = Object(__WEBPACK_IMPORTED_MODULE_1__chronos_format__["b" /* formatDate */])(yearsMatrix[height - 1][width - 1].date, formatOptions.yearTitle, formatOptions.locale);
	    return from + " - " + to;
	}
	
	
	/***/ }),
	/* 118 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDaterangepickerContainerComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_bs_datepicker_container__ = __webpack_require__(112);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bs_datepicker_config__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer_bs_datepicker_actions__ = __webpack_require__(30);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer_bs_datepicker_effects__ = __webpack_require__(64);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducer_bs_datepicker_store__ = __webpack_require__(65);
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	
	
	
	var BsDaterangepickerContainerComponent = (function (_super) {
	    __extends(BsDaterangepickerContainerComponent, _super);
	    function BsDaterangepickerContainerComponent(_config, _store, _actions, _effects) {
	        var _this = _super.call(this) || this;
	        _this._config = _config;
	        _this._store = _store;
	        _this._actions = _actions;
	        _this.valueChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        _this._rangeStack = [];
	        _this._subs = [];
	        _this._effects = _effects;
	        return _this;
	    }
	    Object.defineProperty(BsDaterangepickerContainerComponent.prototype, "value", {
	        set: function (value) {
	            this._effects.setRangeValue(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BsDaterangepickerContainerComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.containerClass = this._config.containerClass;
	        this._effects
	            .init(this._store)
	            .setOptions(this._config)
	            .setBindings(this)
	            .setEventHandlers(this)
	            .registerDatepickerSideEffects();
	        // todo: move it somewhere else
	        // on selected date change
	        this._subs.push(this._store
	            .select(function (state) { return state.selectedRange; })
	            .subscribe(function (date) { return _this.valueChange.emit(date); }));
	    };
	    BsDaterangepickerContainerComponent.prototype.daySelectHandler = function (day) {
	        if (day.isOtherMonth || day.isDisabled) {
	            return;
	        }
	        // if only one date is already selected
	        // and user clicks on previous date
	        // start selection from new date
	        // but if new date is after initial one
	        // than finish selection
	        if (this._rangeStack.length === 1) {
	            this._rangeStack =
	                day.date >= this._rangeStack[0]
	                    ? [this._rangeStack[0], day.date]
	                    : [day.date];
	        }
	        if (this._rangeStack.length === 0) {
	            this._rangeStack = [day.date];
	        }
	        this._store.dispatch(this._actions.selectRange(this._rangeStack));
	        if (this._rangeStack.length === 2) {
	            this._rangeStack = [];
	        }
	    };
	    BsDaterangepickerContainerComponent.prototype.ngOnDestroy = function () {
	        for (var _i = 0, _a = this._subs; _i < _a.length; _i++) {
	            var sub = _a[_i];
	            sub.unsubscribe();
	        }
	        this._effects.destroy();
	    };
	    BsDaterangepickerContainerComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'bs-daterangepicker-container',
	            providers: [__WEBPACK_IMPORTED_MODULE_5__reducer_bs_datepicker_store__["a" /* BsDatepickerStore */], __WEBPACK_IMPORTED_MODULE_4__reducer_bs_datepicker_effects__["a" /* BsDatepickerEffects */]],
	            template: "<!-- days calendar view mode --> <div class=\"bs-datepicker\" [ngClass]=\"containerClass\" *ngIf=\"viewMode | async\"> <div class=\"bs-datepicker-container\"> <!--calendars--> <div class=\"bs-calendar-container\" [ngSwitch]=\"viewMode | async\" role=\"application\"> <!--days calendar--> <div *ngSwitchCase=\"'day'\"> <bs-days-calendar-view *ngFor=\"let calendar of (daysCalendar | async)\" [class.bs-datepicker-multiple]=\"(daysCalendar | async)?.length > 1\" [calendar]=\"calendar\" [options]=\"options | async\" (onNavigate)=\"navigateTo($event)\" (onViewMode)=\"setViewMode($event)\" (onHover)=\"dayHoverHandler($event)\" (onSelect)=\"daySelectHandler($event)\" ></bs-days-calendar-view> </div> <!--months calendar--> <div *ngSwitchCase=\"'month'\"> <bs-month-calendar-view *ngFor=\"let calendar of (monthsCalendar | async)\" [class.bs-datepicker-multiple]=\"(daysCalendar | async)?.length > 1\" [calendar]=\"calendar\" (onNavigate)=\"navigateTo($event)\" (onViewMode)=\"setViewMode($event)\" (onHover)=\"monthHoverHandler($event)\" (onSelect)=\"monthSelectHandler($event)\" ></bs-month-calendar-view> </div> <!--years calendar--> <div *ngSwitchCase=\"'year'\"> <bs-years-calendar-view *ngFor=\"let calendar of (yearsCalendar | async)\" [class.bs-datepicker-multiple]=\"(daysCalendar | async)?.length > 1\" [calendar]=\"calendar\" (onNavigate)=\"navigateTo($event)\" (onViewMode)=\"setViewMode($event)\" (onHover)=\"yearHoverHandler($event)\" (onSelect)=\"yearSelectHandler($event)\" ></bs-years-calendar-view> </div> </div> <!--applycancel buttons--> <div class=\"bs-datepicker-buttons\" *ngIf=\"false\"> <button class=\"btn btn-success\">Apply</button> <button class=\"btn btn-default\">Cancel</button> </div> </div> <!--custom dates or date ranges picker--> <div class=\"bs-datepicker-custom-range\" *ngIf=\"false\"> <bs-custom-date-view [ranges]=\"_customRangesFish\"></bs-custom-date-view> </div> </div> ",
	            host: {
	                '(click)': '_stopPropagation($event)',
	                style: 'position: absolute; display: block;',
	                role: 'dialog',
	                'aria-label': 'calendar'
	            }
	        }),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__bs_datepicker_config__["a" /* BsDatepickerConfig */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__bs_datepicker_config__["a" /* BsDatepickerConfig */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_5__reducer_bs_datepicker_store__["a" /* BsDatepickerStore */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__reducer_bs_datepicker_store__["a" /* BsDatepickerStore */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_3__reducer_bs_datepicker_actions__["a" /* BsDatepickerActions */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__reducer_bs_datepicker_actions__["a" /* BsDatepickerActions */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_4__reducer_bs_datepicker_effects__["a" /* BsDatepickerEffects */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_4__reducer_bs_datepicker_effects__["a" /* BsDatepickerEffects */]) === "function" && _d || Object])
	    ], BsDaterangepickerContainerComponent);
	    return BsDaterangepickerContainerComponent;
	    var _a, _b, _c, _d;
	}(__WEBPACK_IMPORTED_MODULE_1__base_bs_datepicker_container__["a" /* BsDatepickerAbstractComponent */]));
	
	
	
	/***/ }),
	/* 119 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsModalRef; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	var BsModalRef = (function () {
	    function BsModalRef() {
	        /**
	         * Hides the modal
	         */
	        this.hide = Function;
	    }
	    BsModalRef = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	    ], BsModalRef);
	    return BsModalRef;
	}());
	
	
	
	/***/ }),
	/* 120 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalDirective; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_facade_browser__ = __webpack_require__(53);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_theme_provider__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_utils_class__ = __webpack_require__(60);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_backdrop_component__ = __webpack_require__(40);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal_options_class__ = __webpack_require__(33);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_loader_component_loader_factory__ = __webpack_require__(24);
	/* tslint:disable:max-file-line-count */
	// todo: should we support enforce focus in?
	// todo: in original bs there are was a way to prevent modal from showing
	// todo: original modal had resize events
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	
	
	
	
	var TRANSITION_DURATION = 300;
	var BACKDROP_TRANSITION_DURATION = 150;
	/** Mark any code with directive to show it's content in modal */
	var ModalDirective = (function () {
	    function ModalDirective(_element, _viewContainerRef, _renderer, clf) {
	        this._element = _element;
	        this._renderer = _renderer;
	        /** This event fires immediately when the `show` instance method is called. */
	        this.onShow = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        /** This event is fired when the modal has been made visible to the user
	         * (will wait for CSS transitions to complete)
	         */
	        this.onShown = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        /** This event is fired immediately when
	         * the hide instance method has been called.
	         */
	        this.onHide = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        /** This event is fired when the modal has finished being
	         * hidden from the user (will wait for CSS transitions to complete).
	         */
	        this.onHidden = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this._isShown = false;
	        this.isBodyOverflowing = false;
	        this.originalBodyPadding = 0;
	        this.scrollbarWidth = 0;
	        this.timerHideModal = 0;
	        this.timerRmBackDrop = 0;
	        this.isNested = false;
	        this._backdrop = clf.createLoader(_element, _viewContainerRef, _renderer);
	    }
	    Object.defineProperty(ModalDirective.prototype, "config", {
	        get: function () {
	            return this._config;
	        },
	        /** allows to set modal configuration via element property */
	        set: function (conf) {
	            this._config = this.getConfig(conf);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ModalDirective.prototype, "isShown", {
	        get: function () {
	            return this._isShown;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ModalDirective.prototype.onClick = function (event) {
	        if (this.config.ignoreBackdropClick ||
	            this.config.backdrop === 'static' ||
	            event.target !== this._element.nativeElement) {
	            return;
	        }
	        this.dismissReason = __WEBPACK_IMPORTED_MODULE_5__modal_options_class__["b" /* DISMISS_REASONS */].BACKRDOP;
	        this.hide(event);
	    };
	    // todo: consider preventing default and stopping propagation
	    ModalDirective.prototype.onEsc = function (event) {
	        if (!this._isShown) {
	            return;
	        }
	        if (event.keyCode === 27) {
	            event.preventDefault();
	        }
	        if (this.config.keyboard) {
	            this.dismissReason = __WEBPACK_IMPORTED_MODULE_5__modal_options_class__["b" /* DISMISS_REASONS */].ESC;
	            this.hide();
	        }
	    };
	    ModalDirective.prototype.ngOnDestroy = function () {
	        this.config = void 0;
	        if (this._isShown) {
	            this._isShown = false;
	            this.hideModal();
	            this._backdrop.dispose();
	        }
	    };
	    ModalDirective.prototype.ngOnInit = function () {
	        var _this = this;
	        this._config = this._config || this.getConfig();
	        setTimeout(function () {
	            if (_this._config.show) {
	                _this.show();
	            }
	        }, 0);
	    };
	    /* Public methods */
	    /** Allows to manually toggle modal visibility */
	    ModalDirective.prototype.toggle = function () {
	        return this._isShown ? this.hide() : this.show();
	    };
	    /** Allows to manually open modal */
	    ModalDirective.prototype.show = function () {
	        var _this = this;
	        this.dismissReason = null;
	        this.onShow.emit(this);
	        if (this._isShown) {
	            return;
	        }
	        clearTimeout(this.timerHideModal);
	        clearTimeout(this.timerRmBackDrop);
	        this._isShown = true;
	        this.checkScrollbar();
	        this.setScrollbar();
	        if (__WEBPACK_IMPORTED_MODULE_1__utils_facade_browser__["a" /* document */] && __WEBPACK_IMPORTED_MODULE_1__utils_facade_browser__["a" /* document */].body) {
	            if (__WEBPACK_IMPORTED_MODULE_1__utils_facade_browser__["a" /* document */].body.classList.contains(__WEBPACK_IMPORTED_MODULE_5__modal_options_class__["a" /* CLASS_NAME */].OPEN)) {
	                this.isNested = true;
	            }
	            else {
	                this._renderer.addClass(__WEBPACK_IMPORTED_MODULE_1__utils_facade_browser__["a" /* document */].body, __WEBPACK_IMPORTED_MODULE_5__modal_options_class__["a" /* CLASS_NAME */].OPEN);
	            }
	        }
	        this.showBackdrop(function () {
	            _this.showElement();
	        });
	    };
	    /** Allows to manually close modal */
	    ModalDirective.prototype.hide = function (event) {
	        var _this = this;
	        if (event) {
	            event.preventDefault();
	        }
	        this.onHide.emit(this);
	        // todo: add an option to prevent hiding
	        if (!this._isShown) {
	            return;
	        }
	        clearTimeout(this.timerHideModal);
	        clearTimeout(this.timerRmBackDrop);
	        this._isShown = false;
	        this._renderer.removeClass(this._element.nativeElement, __WEBPACK_IMPORTED_MODULE_5__modal_options_class__["a" /* CLASS_NAME */].IN);
	        if (!Object(__WEBPACK_IMPORTED_MODULE_2__utils_theme_provider__["a" /* isBs3 */])()) {
	            this._renderer.removeClass(this._element.nativeElement, __WEBPACK_IMPORTED_MODULE_5__modal_options_class__["a" /* CLASS_NAME */].SHOW);
	        }
	        // this._addClassIn = false;
	        if (this._config.animated) {
	            this.timerHideModal = setTimeout(function () { return _this.hideModal(); }, TRANSITION_DURATION);
	        }
	        else {
	            this.hideModal();
	        }
	    };
	    /** Private methods @internal */
	    ModalDirective.prototype.getConfig = function (config) {
	        return Object.assign({}, __WEBPACK_IMPORTED_MODULE_5__modal_options_class__["e" /* modalConfigDefaults */], config);
	    };
	    /**
	     *  Show dialog
	     *  @internal
	     */
	    ModalDirective.prototype.showElement = function () {
	        var _this = this;
	        // todo: replace this with component loader usage
	        if (!this._element.nativeElement.parentNode ||
	            this._element.nativeElement.parentNode.nodeType !== Node.ELEMENT_NODE) {
	            // don't move modals dom position
	            if (__WEBPACK_IMPORTED_MODULE_1__utils_facade_browser__["a" /* document */] && __WEBPACK_IMPORTED_MODULE_1__utils_facade_browser__["a" /* document */].body) {
	                __WEBPACK_IMPORTED_MODULE_1__utils_facade_browser__["a" /* document */].body.appendChild(this._element.nativeElement);
	            }
	        }
	        this._renderer.setAttribute(this._element.nativeElement, 'aria-hidden', 'false');
	        this._renderer.setAttribute(this._element.nativeElement, 'aria-modal', 'true');
	        this._renderer.setStyle(this._element.nativeElement, 'display', 'block');
	        this._renderer.setProperty(this._element.nativeElement, 'scrollTop', 0);
	        if (this._config.animated) {
	            __WEBPACK_IMPORTED_MODULE_3__utils_utils_class__["a" /* Utils */].reflow(this._element.nativeElement);
	        }
	        // this._addClassIn = true;
	        this._renderer.addClass(this._element.nativeElement, __WEBPACK_IMPORTED_MODULE_5__modal_options_class__["a" /* CLASS_NAME */].IN);
	        if (!Object(__WEBPACK_IMPORTED_MODULE_2__utils_theme_provider__["a" /* isBs3 */])()) {
	            this._renderer.addClass(this._element.nativeElement, __WEBPACK_IMPORTED_MODULE_5__modal_options_class__["a" /* CLASS_NAME */].SHOW);
	        }
	        var transitionComplete = function () {
	            if (_this._config.focus) {
	                _this._element.nativeElement.focus();
	            }
	            _this.onShown.emit(_this);
	        };
	        if (this._config.animated) {
	            setTimeout(transitionComplete, TRANSITION_DURATION);
	        }
	        else {
	            transitionComplete();
	        }
	    };
	    /** @internal */
	    ModalDirective.prototype.hideModal = function () {
	        var _this = this;
	        this._renderer.setAttribute(this._element.nativeElement, 'aria-hidden', 'true');
	        this._renderer.setStyle(this._element.nativeElement, 'display', 'none');
	        this.showBackdrop(function () {
	            if (!_this.isNested) {
	                if (__WEBPACK_IMPORTED_MODULE_1__utils_facade_browser__["a" /* document */] && __WEBPACK_IMPORTED_MODULE_1__utils_facade_browser__["a" /* document */].body) {
	                    _this._renderer.removeClass(__WEBPACK_IMPORTED_MODULE_1__utils_facade_browser__["a" /* document */].body, __WEBPACK_IMPORTED_MODULE_5__modal_options_class__["a" /* CLASS_NAME */].OPEN);
	                }
	                _this.resetScrollbar();
	            }
	            _this.resetAdjustments();
	            _this.focusOtherModal();
	            _this.onHidden.emit(_this);
	        });
	    };
	    // todo: original show was calling a callback when done, but we can use
	    // promise
	    /** @internal */
	    ModalDirective.prototype.showBackdrop = function (callback) {
	        var _this = this;
	        if (this._isShown &&
	            this.config.backdrop &&
	            (!this.backdrop || !this.backdrop.instance.isShown)) {
	            this.removeBackdrop();
	            this._backdrop
	                .attach(__WEBPACK_IMPORTED_MODULE_4__modal_backdrop_component__["a" /* ModalBackdropComponent */])
	                .to('body')
	                .show({ isAnimated: this._config.animated });
	            this.backdrop = this._backdrop._componentRef;
	            if (!callback) {
	                return;
	            }
	            if (!this._config.animated) {
	                callback();
	                return;
	            }
	            setTimeout(callback, BACKDROP_TRANSITION_DURATION);
	        }
	        else if (!this._isShown && this.backdrop) {
	            this.backdrop.instance.isShown = false;
	            var callbackRemove = function () {
	                _this.removeBackdrop();
	                if (callback) {
	                    callback();
	                }
	            };
	            if (this.backdrop.instance.isAnimated) {
	                this.timerRmBackDrop = setTimeout(callbackRemove, BACKDROP_TRANSITION_DURATION);
	            }
	            else {
	                callbackRemove();
	            }
	        }
	        else if (callback) {
	            callback();
	        }
	    };
	    /** @internal */
	    ModalDirective.prototype.removeBackdrop = function () {
	        this._backdrop.hide();
	    };
	    /** Events tricks */
	    // no need for it
	    // protected setEscapeEvent():void {
	    //   if (this._isShown && this._config.keyboard) {
	    //     $(this._element).on(Event.KEYDOWN_DISMISS, (event) => {
	    //       if (event.which === 27) {
	    //         this.hide()
	    //       }
	    //     })
	    //
	    //   } else if (!this._isShown) {
	    //     $(this._element).off(Event.KEYDOWN_DISMISS)
	    //   }
	    // }
	    // protected setResizeEvent():void {
	    // console.log(this.renderer.listenGlobal('', Event.RESIZE));
	    // if (this._isShown) {
	    //   $(window).on(Event.RESIZE, $.proxy(this._handleUpdate, this))
	    // } else {
	    //   $(window).off(Event.RESIZE)
	    // }
	    // }
	    ModalDirective.prototype.focusOtherModal = function () {
	        if (this._element.nativeElement.parentElement == null)
	            return;
	        var otherOpenedModals = this._element.nativeElement.parentElement.querySelectorAll('.in[bsModal]');
	        if (!otherOpenedModals.length) {
	            return;
	        }
	        otherOpenedModals[otherOpenedModals.length - 1].focus();
	    };
	    /** @internal */
	    ModalDirective.prototype.resetAdjustments = function () {
	        this._renderer.setStyle(this._element.nativeElement, 'paddingLeft', '');
	        this._renderer.setStyle(this._element.nativeElement, 'paddingRight', '');
	    };
	    /** Scroll bar tricks */
	    /** @internal */
	    ModalDirective.prototype.checkScrollbar = function () {
	        this.isBodyOverflowing = __WEBPACK_IMPORTED_MODULE_1__utils_facade_browser__["a" /* document */].body.clientWidth < __WEBPACK_IMPORTED_MODULE_1__utils_facade_browser__["b" /* window */].innerWidth;
	        this.scrollbarWidth = this.getScrollbarWidth();
	    };
	    ModalDirective.prototype.setScrollbar = function () {
	        if (!__WEBPACK_IMPORTED_MODULE_1__utils_facade_browser__["a" /* document */]) {
	            return;
	        }
	        this.originalBodyPadding = parseInt(__WEBPACK_IMPORTED_MODULE_1__utils_facade_browser__["b" /* window */]
	            .getComputedStyle(__WEBPACK_IMPORTED_MODULE_1__utils_facade_browser__["a" /* document */].body)
	            .getPropertyValue('padding-right') || 0, 10);
	        if (this.isBodyOverflowing) {
	            __WEBPACK_IMPORTED_MODULE_1__utils_facade_browser__["a" /* document */].body.style.paddingRight = this.originalBodyPadding +
	                this.scrollbarWidth + "px";
	        }
	    };
	    ModalDirective.prototype.resetScrollbar = function () {
	        __WEBPACK_IMPORTED_MODULE_1__utils_facade_browser__["a" /* document */].body.style.paddingRight = this.originalBodyPadding + 'px';
	    };
	    // thx d.walsh
	    ModalDirective.prototype.getScrollbarWidth = function () {
	        var scrollDiv = this._renderer.createElement('div');
	        this._renderer.addClass(scrollDiv, __WEBPACK_IMPORTED_MODULE_5__modal_options_class__["a" /* CLASS_NAME */].SCROLLBAR_MEASURER);
	        this._renderer.appendChild(__WEBPACK_IMPORTED_MODULE_1__utils_facade_browser__["a" /* document */].body, scrollDiv);
	        var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	        this._renderer.removeChild(__WEBPACK_IMPORTED_MODULE_1__utils_facade_browser__["a" /* document */].body, scrollDiv);
	        return scrollbarWidth;
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_5__modal_options_class__["c" /* ModalOptions */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__modal_options_class__["c" /* ModalOptions */]) === "function" && _a || Object),
	        __metadata("design:paramtypes", [typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_5__modal_options_class__["c" /* ModalOptions */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__modal_options_class__["c" /* ModalOptions */]) === "function" && _b || Object])
	    ], ModalDirective.prototype, "config", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _c || Object)
	    ], ModalDirective.prototype, "onShow", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _d || Object)
	    ], ModalDirective.prototype, "onShown", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _e || Object)
	    ], ModalDirective.prototype, "onHide", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _f || Object)
	    ], ModalDirective.prototype, "onHidden", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('click', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], ModalDirective.prototype, "onClick", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('keydown.esc', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], ModalDirective.prototype, "onEsc", null);
	    ModalDirective = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
	            selector: '[bsModal]',
	            exportAs: 'bs-modal'
	        }),
	        __metadata("design:paramtypes", [typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"]) === "function" && _h || Object, typeof (_j = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]) === "function" && _j || Object, typeof (_k = typeof __WEBPACK_IMPORTED_MODULE_6__component_loader_component_loader_factory__["a" /* ComponentLoaderFactory */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_6__component_loader_component_loader_factory__["a" /* ComponentLoaderFactory */]) === "function" && _k || Object])
	    ], ModalDirective);
	    return ModalDirective;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
	}());
	
	
	
	/***/ }),
	/* 121 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsModalService; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_loader_component_loader_factory__ = __webpack_require__(24);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_backdrop_component__ = __webpack_require__(40);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_container_component__ = __webpack_require__(70);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_options_class__ = __webpack_require__(33);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bs_modal_ref_service__ = __webpack_require__(119);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	
	
	
	var BsModalService = (function () {
	    function BsModalService(rendererFactory, clf) {
	        this.clf = clf;
	        // constructor props
	        this.config = __WEBPACK_IMPORTED_MODULE_4__modal_options_class__["e" /* modalConfigDefaults */];
	        this.onShow = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.onShown = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.onHide = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.onHidden = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.isBodyOverflowing = false;
	        this.originalBodyPadding = 0;
	        this.scrollbarWidth = 0;
	        this.modalsCount = 0;
	        this.lastDismissReason = '';
	        this.loaders = [];
	        this._backdropLoader = this.clf.createLoader(null, null, null);
	        this._renderer = rendererFactory.createRenderer(null, null);
	    }
	    /** Shows a modal */
	    BsModalService.prototype.show = function (content, config) {
	        this.modalsCount++;
	        this._createLoaders();
	        this.config = Object.assign({}, __WEBPACK_IMPORTED_MODULE_4__modal_options_class__["e" /* modalConfigDefaults */], config);
	        this._showBackdrop();
	        this.lastDismissReason = null;
	        return this._showModal(content);
	    };
	    BsModalService.prototype.hide = function (level) {
	        var _this = this;
	        if (this.modalsCount === 1) {
	            this._hideBackdrop();
	            this.resetScrollbar();
	        }
	        this.modalsCount = this.modalsCount >= 1 ? this.modalsCount - 1 : 0;
	        setTimeout(function () {
	            _this._hideModal(level);
	            _this.removeLoaders(level);
	        }, this.config.animated ? __WEBPACK_IMPORTED_MODULE_4__modal_options_class__["d" /* TRANSITION_DURATIONS */].BACKDROP : 0);
	    };
	    BsModalService.prototype._showBackdrop = function () {
	        var isBackdropEnabled = this.config.backdrop || this.config.backdrop === 'static';
	        var isBackdropInDOM = !this.backdropRef || !this.backdropRef.instance.isShown;
	        if (this.modalsCount === 1) {
	            this.removeBackdrop();
	            if (isBackdropEnabled && isBackdropInDOM) {
	                this._backdropLoader
	                    .attach(__WEBPACK_IMPORTED_MODULE_2__modal_backdrop_component__["a" /* ModalBackdropComponent */])
	                    .to('body')
	                    .show({ isAnimated: this.config.animated });
	                this.backdropRef = this._backdropLoader._componentRef;
	            }
	        }
	    };
	    BsModalService.prototype._hideBackdrop = function () {
	        var _this = this;
	        if (!this.backdropRef) {
	            return;
	        }
	        this.backdropRef.instance.isShown = false;
	        var duration = this.config.animated ? __WEBPACK_IMPORTED_MODULE_4__modal_options_class__["d" /* TRANSITION_DURATIONS */].BACKDROP : 0;
	        setTimeout(function () { return _this.removeBackdrop(); }, duration);
	    };
	    BsModalService.prototype._showModal = function (content) {
	        var modalLoader = this.loaders[this.loaders.length - 1];
	        var bsModalRef = new __WEBPACK_IMPORTED_MODULE_5__bs_modal_ref_service__["a" /* BsModalRef */]();
	        var modalContainerRef = modalLoader
	            .provide({ provide: __WEBPACK_IMPORTED_MODULE_4__modal_options_class__["c" /* ModalOptions */], useValue: this.config })
	            .provide({ provide: __WEBPACK_IMPORTED_MODULE_5__bs_modal_ref_service__["a" /* BsModalRef */], useValue: bsModalRef })
	            .attach(__WEBPACK_IMPORTED_MODULE_3__modal_container_component__["a" /* ModalContainerComponent */])
	            .to('body')
	            .show({ content: content, isAnimated: this.config.animated, initialState: this.config.initialState, bsModalService: this });
	        modalContainerRef.instance.level = this.getModalsCount();
	        bsModalRef.hide = function () {
	            modalContainerRef.instance.hide();
	        };
	        bsModalRef.content = modalLoader.getInnerComponent() || null;
	        return bsModalRef;
	    };
	    BsModalService.prototype._hideModal = function (level) {
	        var modalLoader = this.loaders[level - 1];
	        if (modalLoader) {
	            modalLoader.hide();
	        }
	    };
	    BsModalService.prototype.getModalsCount = function () {
	        return this.modalsCount;
	    };
	    BsModalService.prototype.setDismissReason = function (reason) {
	        this.lastDismissReason = reason;
	    };
	    BsModalService.prototype.removeBackdrop = function () {
	        this._backdropLoader.hide();
	        this.backdropRef = null;
	    };
	    /** AFTER PR MERGE MODAL.COMPONENT WILL BE USING THIS CODE */
	    /** Scroll bar tricks */
	    /** @internal */
	    BsModalService.prototype.checkScrollbar = function () {
	        this.isBodyOverflowing = document.body.clientWidth < window.innerWidth;
	        this.scrollbarWidth = this.getScrollbarWidth();
	    };
	    BsModalService.prototype.setScrollbar = function () {
	        if (!document) {
	            return;
	        }
	        this.originalBodyPadding = parseInt(window
	            .getComputedStyle(document.body)
	            .getPropertyValue('padding-right') || '0', 10);
	        if (this.isBodyOverflowing) {
	            document.body.style.paddingRight = this.originalBodyPadding +
	                this.scrollbarWidth + "px";
	        }
	    };
	    BsModalService.prototype.resetScrollbar = function () {
	        document.body.style.paddingRight = this.originalBodyPadding + "px";
	    };
	    // thx d.walsh
	    BsModalService.prototype.getScrollbarWidth = function () {
	        var scrollDiv = this._renderer.createElement('div');
	        this._renderer.addClass(scrollDiv, __WEBPACK_IMPORTED_MODULE_4__modal_options_class__["a" /* CLASS_NAME */].SCROLLBAR_MEASURER);
	        this._renderer.appendChild(document.body, scrollDiv);
	        var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	        this._renderer.removeChild(document.body, scrollDiv);
	        return scrollbarWidth;
	    };
	    BsModalService.prototype._createLoaders = function () {
	        var loader = this.clf.createLoader(null, null, null);
	        this.copyEvent(loader.onBeforeShow, this.onShow);
	        this.copyEvent(loader.onShown, this.onShown);
	        this.copyEvent(loader.onBeforeHide, this.onHide);
	        this.copyEvent(loader.onHidden, this.onHidden);
	        this.loaders.push(loader);
	    };
	    BsModalService.prototype.removeLoaders = function (level) {
	        this.loaders.splice(level - 1, 1);
	        this.loaders.forEach(function (loader, i) {
	            loader.instance.level = i + 1;
	        });
	    };
	    BsModalService.prototype.copyEvent = function (from, to) {
	        var _this = this;
	        from.subscribe(function () {
	            to.emit(_this.lastDismissReason);
	        });
	    };
	    BsModalService = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["RendererFactory2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["RendererFactory2"]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__component_loader_component_loader_factory__["a" /* ComponentLoaderFactory */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__component_loader_component_loader_factory__["a" /* ComponentLoaderFactory */]) === "function" && _b || Object])
	    ], BsModalService);
	    return BsModalService;
	    var _a, _b;
	}());
	
	
	
	/***/ }),
	/* 122 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDropdownDirective; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_filter__ = __webpack_require__(37);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_filter__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_loader_index__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bs_dropdown_config__ = __webpack_require__(71);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bs_dropdown_container_component__ = __webpack_require__(72);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bs_dropdown_state__ = __webpack_require__(25);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_theme_provider__ = __webpack_require__(7);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	// tslint:disable:max-file-line-count
	
	
	
	
	
	
	
	var BsDropdownDirective = (function () {
	    function BsDropdownDirective(_elementRef, _renderer, _viewContainerRef, _cis, _config, _state) {
	        this._elementRef = _elementRef;
	        this._renderer = _renderer;
	        this._viewContainerRef = _viewContainerRef;
	        this._cis = _cis;
	        this._config = _config;
	        this._state = _state;
	        // todo: move to component loader
	        this._isInlineOpen = false;
	        this._subscriptions = [];
	        this._isInited = false;
	        // set initial dropdown state from config
	        this._state.autoClose = this._config.autoClose;
	        // create dropdown component loader
	        this._dropdown = this._cis
	            .createLoader(this._elementRef, this._viewContainerRef, this._renderer)
	            .provide({ provide: __WEBPACK_IMPORTED_MODULE_5__bs_dropdown_state__["a" /* BsDropdownState */], useValue: this._state });
	        this.onShown = this._dropdown.onShown;
	        this.onHidden = this._dropdown.onHidden;
	        this.isOpenChange = this._state.isOpenChange;
	    }
	    Object.defineProperty(BsDropdownDirective.prototype, "autoClose", {
	        get: function () {
	            return this._state.autoClose;
	        },
	        /**
	         * Indicates that dropdown will be closed on item or document click,
	         * and after pressing ESC
	         */
	        set: function (value) {
	            this._state.autoClose = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BsDropdownDirective.prototype, "isDisabled", {
	        get: function () {
	            return this._isDisabled;
	        },
	        /**
	         * Disables dropdown toggle and hides dropdown menu if opened
	         */
	        set: function (value) {
	            this._isDisabled = value;
	            this._state.isDisabledChange.emit(value);
	            if (value) {
	                this.hide();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BsDropdownDirective.prototype, "isOpen", {
	        /**
	         * Returns whether or not the popover is currently being shown
	         */
	        get: function () {
	            if (this._showInline) {
	                return this._isInlineOpen;
	            }
	            return this._dropdown.isShown;
	        },
	        set: function (value) {
	            if (value) {
	                this.show();
	            }
	            else {
	                this.hide();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BsDropdownDirective.prototype, "isBs4", {
	        get: function () {
	            return !Object(__WEBPACK_IMPORTED_MODULE_6__utils_theme_provider__["a" /* isBs3 */])();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BsDropdownDirective.prototype, "_showInline", {
	        get: function () {
	            return !this.container;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BsDropdownDirective.prototype.ngOnInit = function () {
	        var _this = this;
	        // fix: seems there are an issue with `routerLinkActive`
	        // which result in duplicated call ngOnInit without call to ngOnDestroy
	        // read more: https://github.com/valor-software/ngx-bootstrap/issues/1885
	        if (this._isInited) {
	            return;
	        }
	        this._isInited = true;
	        // attach DOM listeners
	        this._dropdown.listen({
	            // because of dropdown inline mode
	            outsideClick: false,
	            triggers: this.triggers,
	            show: function () { return _this.show(); }
	        });
	        // toggle visibility on toggle element click
	        this._subscriptions.push(this._state.toggleClick.subscribe(function (value) { return _this.toggle(value); }));
	        // hide dropdown if set disabled while opened
	        this._subscriptions.push(this._state.isDisabledChange
	            .filter(function (value) { return value; })
	            .subscribe(function (value) { return _this.hide(); }));
	    };
	    /**
	     * Opens an element’s popover. This is considered a “manual” triggering of
	     * the popover.
	     */
	    BsDropdownDirective.prototype.show = function () {
	        var _this = this;
	        if (this.isOpen || this.isDisabled) {
	            return;
	        }
	        if (this._showInline) {
	            if (!this._inlinedMenu) {
	                this._state.dropdownMenu.then(function (dropdownMenu) {
	                    _this._dropdown.attachInline(dropdownMenu.viewContainer, dropdownMenu.templateRef);
	                    _this._inlinedMenu = _this._dropdown._inlineViewRef;
	                    _this.addBs4Polyfills();
	                })
	                    .catch();
	            }
	            this.addBs4Polyfills();
	            this._isInlineOpen = true;
	            this.onShown.emit(true);
	            this._state.isOpenChange.emit(true);
	            return;
	        }
	        this._state.dropdownMenu.then(function (dropdownMenu) {
	            // check direction in which dropdown should be opened
	            var _dropup = _this.dropup ||
	                (typeof _this.dropup !== 'undefined' && _this.dropup);
	            _this._state.direction = _dropup ? 'up' : 'down';
	            var _placement = _this.placement || (_dropup ? 'top left' : 'bottom left');
	            // show dropdown
	            _this._dropdown
	                .attach(__WEBPACK_IMPORTED_MODULE_4__bs_dropdown_container_component__["a" /* BsDropdownContainerComponent */])
	                .to(_this.container)
	                .position({ attachment: _placement })
	                .show({
	                content: dropdownMenu.templateRef,
	                placement: _placement
	            });
	            _this._state.isOpenChange.emit(true);
	        })
	            .catch();
	    };
	    /**
	     * Closes an element’s popover. This is considered a “manual” triggering of
	     * the popover.
	     */
	    BsDropdownDirective.prototype.hide = function () {
	        if (!this.isOpen) {
	            return;
	        }
	        if (this._showInline) {
	            this.removeShowClass();
	            this.removeDropupStyles();
	            this._isInlineOpen = false;
	            this.onHidden.emit(true);
	        }
	        else {
	            this._dropdown.hide();
	        }
	        this._state.isOpenChange.emit(false);
	    };
	    /**
	     * Toggles an element’s popover. This is considered a “manual” triggering of
	     * the popover. With parameter <code>true</code> allows toggling, with parameter <code>false</code>
	     * only hides opened dropdown. Parameter usage will be removed in ngx-bootstrap v3
	     */
	    BsDropdownDirective.prototype.toggle = function (value) {
	        if (this.isOpen || !value) {
	            return this.hide();
	        }
	        return this.show();
	    };
	    BsDropdownDirective.prototype.ngOnDestroy = function () {
	        // clean up subscriptions and destroy dropdown
	        for (var _i = 0, _a = this._subscriptions; _i < _a.length; _i++) {
	            var sub = _a[_i];
	            sub.unsubscribe();
	        }
	        this._dropdown.dispose();
	    };
	    BsDropdownDirective.prototype.addBs4Polyfills = function () {
	        if (!Object(__WEBPACK_IMPORTED_MODULE_6__utils_theme_provider__["a" /* isBs3 */])()) {
	            this.addShowClass();
	            this.checkRightAlignment();
	            this.addDropupStyles();
	        }
	    };
	    BsDropdownDirective.prototype.addShowClass = function () {
	        if (this._inlinedMenu && this._inlinedMenu.rootNodes[0]) {
	            this._renderer.addClass(this._inlinedMenu.rootNodes[0], 'show');
	        }
	    };
	    BsDropdownDirective.prototype.removeShowClass = function () {
	        if (this._inlinedMenu && this._inlinedMenu.rootNodes[0]) {
	            this._renderer.removeClass(this._inlinedMenu.rootNodes[0], 'show');
	        }
	    };
	    BsDropdownDirective.prototype.checkRightAlignment = function () {
	        if (this._inlinedMenu && this._inlinedMenu.rootNodes[0]) {
	            var isRightAligned = this._inlinedMenu.rootNodes[0].classList.contains('dropdown-menu-right');
	            this._renderer.setStyle(this._inlinedMenu.rootNodes[0], 'left', isRightAligned ? 'auto' : '0');
	            this._renderer.setStyle(this._inlinedMenu.rootNodes[0], 'right', isRightAligned ? '0' : 'auto');
	        }
	    };
	    BsDropdownDirective.prototype.addDropupStyles = function () {
	        if (this._inlinedMenu && this._inlinedMenu.rootNodes[0]) {
	            // a little hack to not break support of bootstrap 4 beta
	            this._renderer.setStyle(this._inlinedMenu.rootNodes[0], 'top', this.dropup ? 'auto' : '100%');
	            this._renderer.setStyle(this._inlinedMenu.rootNodes[0], 'transform', this.dropup ? 'translateY(-101%)' : 'translateY(0)');
	        }
	    };
	    BsDropdownDirective.prototype.removeDropupStyles = function () {
	        if (this._inlinedMenu && this._inlinedMenu.rootNodes[0]) {
	            this._renderer.removeStyle(this._inlinedMenu.rootNodes[0], 'top');
	            this._renderer.removeStyle(this._inlinedMenu.rootNodes[0], 'transform');
	        }
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], BsDropdownDirective.prototype, "placement", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], BsDropdownDirective.prototype, "triggers", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], BsDropdownDirective.prototype, "container", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], BsDropdownDirective.prototype, "dropup", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean),
	        __metadata("design:paramtypes", [Boolean])
	    ], BsDropdownDirective.prototype, "autoClose", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean),
	        __metadata("design:paramtypes", [Boolean])
	    ], BsDropdownDirective.prototype, "isDisabled", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean),
	        __metadata("design:paramtypes", [Boolean])
	    ], BsDropdownDirective.prototype, "isOpen", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
	    ], BsDropdownDirective.prototype, "isOpenChange", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
	    ], BsDropdownDirective.prototype, "onShown", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _c || Object)
	    ], BsDropdownDirective.prototype, "onHidden", void 0);
	    BsDropdownDirective = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
	            selector: '[bsDropdown],[dropdown]',
	            exportAs: 'bs-dropdown',
	            providers: [__WEBPACK_IMPORTED_MODULE_5__bs_dropdown_state__["a" /* BsDropdownState */]],
	            host: {
	                '[class.dropup]': 'dropup',
	                '[class.open]': 'isOpen',
	                '[class.show]': 'isOpen && isBs4'
	            }
	        }),
	        __metadata("design:paramtypes", [typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_2__component_loader_index__["b" /* ComponentLoaderFactory */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__component_loader_index__["b" /* ComponentLoaderFactory */]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_3__bs_dropdown_config__["a" /* BsDropdownConfig */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__bs_dropdown_config__["a" /* BsDropdownConfig */]) === "function" && _h || Object, typeof (_j = typeof __WEBPACK_IMPORTED_MODULE_5__bs_dropdown_state__["a" /* BsDropdownState */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__bs_dropdown_state__["a" /* BsDropdownState */]) === "function" && _j || Object])
	    ], BsDropdownDirective);
	    return BsDropdownDirective;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}());
	
	
	
	/***/ }),
	/* 123 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDropdownMenuDirective; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bs_dropdown_state__ = __webpack_require__(25);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	var BsDropdownMenuDirective = (function () {
	    function BsDropdownMenuDirective(_state, _viewContainer, _templateRef) {
	        _state.resolveDropdownMenu({
	            templateRef: _templateRef,
	            viewContainer: _viewContainer
	        });
	    }
	    BsDropdownMenuDirective = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
	            selector: '[bsDropdownMenu],[dropdownMenu]',
	            exportAs: 'bs-dropdown-menu'
	        }),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__bs_dropdown_state__["a" /* BsDropdownState */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__bs_dropdown_state__["a" /* BsDropdownState */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]) === "function" && _c || Object])
	    ], BsDropdownMenuDirective);
	    return BsDropdownMenuDirective;
	    var _a, _b, _c;
	}());
	
	
	
	/***/ }),
	/* 124 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDropdownToggleDirective; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bs_dropdown_state__ = __webpack_require__(25);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	var BsDropdownToggleDirective = (function () {
	    function BsDropdownToggleDirective(_state, _element) {
	        var _this = this;
	        this._state = _state;
	        this._element = _element;
	        this.isDisabled = null;
	        this._subscriptions = [];
	        // sync is open value with state
	        this._subscriptions.push(this._state.isOpenChange.subscribe(function (value) { return (_this.isOpen = value); }));
	        // populate disabled state
	        this._subscriptions.push(this._state.isDisabledChange.subscribe(function (value) { return (_this.isDisabled = value || null); }));
	    }
	    BsDropdownToggleDirective.prototype.onClick = function () {
	        if (this.isDisabled) {
	            return;
	        }
	        this._state.toggleClick.emit(true);
	    };
	    BsDropdownToggleDirective.prototype.onDocumentClick = function (event) {
	        if (this._state.autoClose &&
	            event.button !== 2 &&
	            !this._element.nativeElement.contains(event.target)) {
	            this._state.toggleClick.emit(false);
	        }
	    };
	    BsDropdownToggleDirective.prototype.onEsc = function () {
	        if (this._state.autoClose) {
	            this._state.toggleClick.emit(false);
	        }
	    };
	    BsDropdownToggleDirective.prototype.ngOnDestroy = function () {
	        for (var _i = 0, _a = this._subscriptions; _i < _a.length; _i++) {
	            var sub = _a[_i];
	            sub.unsubscribe();
	        }
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('attr.disabled'),
	        __metadata("design:type", Boolean)
	    ], BsDropdownToggleDirective.prototype, "isDisabled", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('attr.aria-expanded'),
	        __metadata("design:type", Boolean)
	    ], BsDropdownToggleDirective.prototype, "isOpen", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('click', []),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], BsDropdownToggleDirective.prototype, "onClick", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('document:click', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], BsDropdownToggleDirective.prototype, "onDocumentClick", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('keyup.esc'),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], BsDropdownToggleDirective.prototype, "onEsc", null);
	    BsDropdownToggleDirective = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
	            selector: '[bsDropdownToggle],[dropdownToggle]',
	            exportAs: 'bs-dropdown-toggle',
	            host: {
	                '[attr.aria-haspopup]': 'true'
	            }
	        }),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__bs_dropdown_state__["a" /* BsDropdownState */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__bs_dropdown_state__["a" /* BsDropdownState */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _b || Object])
	    ], BsDropdownToggleDirective);
	    return BsDropdownToggleDirective;
	    var _a, _b;
	}());
	
	
	
	/***/ }),
	/* 125 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export PAGER_CONTROL_VALUE_ACCESSOR */
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PagerComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_forms__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pagination_config__ = __webpack_require__(41);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	var PAGER_CONTROL_VALUE_ACCESSOR = {
	    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
	    // tslint:disable-next-line
	    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return PagerComponent; }),
	    multi: true
	};
	var PagerComponent = (function () {
	    function PagerComponent(renderer, elementRef, paginationConfig, changeDetection) {
	        this.renderer = renderer;
	        this.elementRef = elementRef;
	        this.changeDetection = changeDetection;
	        /** fired when total pages count changes, $event:number equals to total pages count */
	        this.numPages = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        /** fired when page was changed, $event:{page, itemsPerPage} equals to
	         * object with current page index and number of items per page
	         */
	        this.pageChanged = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.onChange = Function.prototype;
	        this.onTouched = Function.prototype;
	        this.inited = false;
	        this._page = 1;
	        this.renderer = renderer;
	        this.elementRef = elementRef;
	        if (!this.config) {
	            this.configureOptions(Object.assign({}, paginationConfig.main, paginationConfig.pager));
	        }
	    }
	    Object.defineProperty(PagerComponent.prototype, "itemsPerPage", {
	        /** maximum number of items per page. If value less than 1 will display all items on one page */
	        get: function () {
	            return this._itemsPerPage;
	        },
	        set: function (v) {
	            this._itemsPerPage = v;
	            this.totalPages = this.calculateTotalPages();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PagerComponent.prototype, "totalItems", {
	        /** total number of items in all pages */
	        get: function () {
	            return this._totalItems;
	        },
	        set: function (v) {
	            this._totalItems = v;
	            this.totalPages = this.calculateTotalPages();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PagerComponent.prototype, "totalPages", {
	        get: function () {
	            return this._totalPages;
	        },
	        set: function (v) {
	            this._totalPages = v;
	            this.numPages.emit(v);
	            if (this.inited) {
	                this.selectPage(this.page);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PagerComponent.prototype, "page", {
	        get: function () {
	            return this._page;
	        },
	        set: function (value) {
	            var _previous = this._page;
	            this._page = value > this.totalPages ? this.totalPages : value || 1;
	            this.changeDetection.markForCheck();
	            if (_previous === this._page || typeof _previous === 'undefined') {
	                return;
	            }
	            this.pageChanged.emit({
	                page: this._page,
	                itemsPerPage: this.itemsPerPage
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    PagerComponent.prototype.configureOptions = function (config) {
	        this.config = Object.assign({}, config);
	    };
	    PagerComponent.prototype.ngOnInit = function () {
	        if (typeof window !== 'undefined') {
	            this.classMap = this.elementRef.nativeElement.getAttribute('class') || '';
	        }
	        // watch for maxSize
	        this.maxSize =
	            typeof this.maxSize !== 'undefined' ? this.maxSize : this.config.maxSize;
	        this.rotate =
	            typeof this.rotate !== 'undefined' ? this.rotate : this.config.rotate;
	        this.boundaryLinks =
	            typeof this.boundaryLinks !== 'undefined'
	                ? this.boundaryLinks
	                : this.config.boundaryLinks;
	        this.directionLinks =
	            typeof this.directionLinks !== 'undefined'
	                ? this.directionLinks
	                : this.config.directionLinks;
	        this.pageBtnClass =
	            typeof this.pageBtnClass !== 'undefined'
	                ? this.pageBtnClass
	                : this.config.pageBtnClass;
	        // base class
	        this.itemsPerPage =
	            typeof this.itemsPerPage !== 'undefined'
	                ? this.itemsPerPage
	                : this.config.itemsPerPage;
	        this.totalPages = this.calculateTotalPages();
	        // this class
	        this.pages = this.getPages(this.page, this.totalPages);
	        this.inited = true;
	    };
	    PagerComponent.prototype.writeValue = function (value) {
	        this.page = value;
	        this.pages = this.getPages(this.page, this.totalPages);
	    };
	    PagerComponent.prototype.getText = function (key) {
	        return this[key + "Text"] || this.config[key + "Text"];
	    };
	    PagerComponent.prototype.noPrevious = function () {
	        return this.page === 1;
	    };
	    PagerComponent.prototype.noNext = function () {
	        return this.page === this.totalPages;
	    };
	    PagerComponent.prototype.registerOnChange = function (fn) {
	        this.onChange = fn;
	    };
	    PagerComponent.prototype.registerOnTouched = function (fn) {
	        this.onTouched = fn;
	    };
	    PagerComponent.prototype.selectPage = function (page, event) {
	        if (event) {
	            event.preventDefault();
	        }
	        if (!this.disabled) {
	            if (event && event.target) {
	                var target = event.target;
	                target.blur();
	            }
	            this.writeValue(page);
	            this.onChange(this.page);
	        }
	    };
	    // Create page object used in template
	    PagerComponent.prototype.makePage = function (num, text, active) {
	        return { text: text, number: num, active: active };
	    };
	    PagerComponent.prototype.getPages = function (currentPage, totalPages) {
	        var pages = [];
	        // Default page limits
	        var startPage = 1;
	        var endPage = totalPages;
	        var isMaxSized = typeof this.maxSize !== 'undefined' && this.maxSize < totalPages;
	        // recompute if maxSize
	        if (isMaxSized) {
	            if (this.rotate) {
	                // Current page is displayed in the middle of the visible ones
	                startPage = Math.max(currentPage - Math.floor(this.maxSize / 2), 1);
	                endPage = startPage + this.maxSize - 1;
	                // Adjust if limit is exceeded
	                if (endPage > totalPages) {
	                    endPage = totalPages;
	                    startPage = endPage - this.maxSize + 1;
	                }
	            }
	            else {
	                // Visible pages are paginated with maxSize
	                startPage =
	                    (Math.ceil(currentPage / this.maxSize) - 1) * this.maxSize + 1;
	                // Adjust last page if limit is exceeded
	                endPage = Math.min(startPage + this.maxSize - 1, totalPages);
	            }
	        }
	        // Add page number links
	        for (var num = startPage; num <= endPage; num++) {
	            var page = this.makePage(num, num.toString(), num === currentPage);
	            pages.push(page);
	        }
	        // Add links to move between page sets
	        if (isMaxSized && !this.rotate) {
	            if (startPage > 1) {
	                var previousPageSet = this.makePage(startPage - 1, '...', false);
	                pages.unshift(previousPageSet);
	            }
	            if (endPage < totalPages) {
	                var nextPageSet = this.makePage(endPage + 1, '...', false);
	                pages.push(nextPageSet);
	            }
	        }
	        return pages;
	    };
	    // base class
	    PagerComponent.prototype.calculateTotalPages = function () {
	        var totalPages = this.itemsPerPage < 1
	            ? 1
	            : Math.ceil(this.totalItems / this.itemsPerPage);
	        return Math.max(totalPages || 0, 1);
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], PagerComponent.prototype, "align", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number)
	    ], PagerComponent.prototype, "maxSize", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], PagerComponent.prototype, "boundaryLinks", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], PagerComponent.prototype, "directionLinks", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], PagerComponent.prototype, "firstText", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], PagerComponent.prototype, "previousText", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], PagerComponent.prototype, "nextText", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], PagerComponent.prototype, "lastText", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], PagerComponent.prototype, "rotate", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], PagerComponent.prototype, "pageBtnClass", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], PagerComponent.prototype, "disabled", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
	    ], PagerComponent.prototype, "numPages", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
	    ], PagerComponent.prototype, "pageChanged", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number),
	        __metadata("design:paramtypes", [Number])
	    ], PagerComponent.prototype, "itemsPerPage", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number),
	        __metadata("design:paramtypes", [Number])
	    ], PagerComponent.prototype, "totalItems", null);
	    PagerComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'pager',
	            template: "<ul class=\"pager\"> <li [class.disabled]=\"noPrevious()\" [class.previous]=\"align\" [ngClass]=\"{'pull-right': align, 'float-right': align}\" class=\"{{ pageBtnClass }}\"> <a href (click)=\"selectPage(page - 1, $event)\">{{ getText('previous') }}</a> </li> <li [class.disabled]=\"noNext()\" [class.next]=\"align\" [ngClass]=\"{'pull-right': align, 'float-right': align}\" class=\"{{ pageBtnClass }}\"> <a href (click)=\"selectPage(page + 1, $event)\">{{ getText('next') }}</a> </li> </ul> ",
	            providers: [PAGER_CONTROL_VALUE_ACCESSOR]
	        }),
	        __metadata("design:paramtypes", [typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_2__pagination_config__["a" /* PaginationConfig */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__pagination_config__["a" /* PaginationConfig */]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]) === "function" && _f || Object])
	    ], PagerComponent);
	    return PagerComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	
	
	
	/***/ }),
	/* 126 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export PAGINATION_CONTROL_VALUE_ACCESSOR */
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PaginationComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_forms__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pagination_config__ = __webpack_require__(41);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	var PAGINATION_CONTROL_VALUE_ACCESSOR = {
	    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
	    // tslint:disable-next-line
	    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return PaginationComponent; }),
	    multi: true
	};
	var PaginationComponent = (function () {
	    function PaginationComponent(renderer, elementRef, paginationConfig, changeDetection) {
	        this.renderer = renderer;
	        this.elementRef = elementRef;
	        this.changeDetection = changeDetection;
	        /** fired when total pages count changes, $event:number equals to total pages count */
	        this.numPages = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        /** fired when page was changed, $event:{page, itemsPerPage} equals to object
	         * with current page index and number of items per page
	         */
	        this.pageChanged = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.onChange = Function.prototype;
	        this.onTouched = Function.prototype;
	        this.inited = false;
	        this._page = 1;
	        this.renderer = renderer;
	        this.elementRef = elementRef;
	        if (!this.config) {
	            this.configureOptions(paginationConfig.main);
	        }
	    }
	    Object.defineProperty(PaginationComponent.prototype, "itemsPerPage", {
	        /** maximum number of items per page. If value less than 1 will display all items on one page */
	        get: function () {
	            return this._itemsPerPage;
	        },
	        set: function (v) {
	            this._itemsPerPage = v;
	            this.totalPages = this.calculateTotalPages();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PaginationComponent.prototype, "totalItems", {
	        /** total number of items in all pages */
	        get: function () {
	            return this._totalItems;
	        },
	        set: function (v) {
	            this._totalItems = v;
	            this.totalPages = this.calculateTotalPages();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PaginationComponent.prototype, "totalPages", {
	        get: function () {
	            return this._totalPages;
	        },
	        set: function (v) {
	            this._totalPages = v;
	            this.numPages.emit(v);
	            if (this.inited) {
	                this.selectPage(this.page);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PaginationComponent.prototype, "page", {
	        get: function () {
	            return this._page;
	        },
	        set: function (value) {
	            var _previous = this._page;
	            this._page = value > this.totalPages ? this.totalPages : value || 1;
	            this.changeDetection.markForCheck();
	            if (_previous === this._page || typeof _previous === 'undefined') {
	                return;
	            }
	            this.pageChanged.emit({
	                page: this._page,
	                itemsPerPage: this.itemsPerPage
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    PaginationComponent.prototype.configureOptions = function (config) {
	        this.config = Object.assign({}, config);
	    };
	    PaginationComponent.prototype.ngOnInit = function () {
	        if (typeof window !== 'undefined') {
	            this.classMap = this.elementRef.nativeElement.getAttribute('class') || '';
	        }
	        // watch for maxSize
	        this.maxSize =
	            typeof this.maxSize !== 'undefined' ? this.maxSize : this.config.maxSize;
	        this.rotate =
	            typeof this.rotate !== 'undefined' ? this.rotate : this.config.rotate;
	        this.boundaryLinks =
	            typeof this.boundaryLinks !== 'undefined'
	                ? this.boundaryLinks
	                : this.config.boundaryLinks;
	        this.directionLinks =
	            typeof this.directionLinks !== 'undefined'
	                ? this.directionLinks
	                : this.config.directionLinks;
	        this.pageBtnClass =
	            typeof this.pageBtnClass !== 'undefined'
	                ? this.pageBtnClass
	                : this.config.pageBtnClass;
	        // base class
	        this.itemsPerPage =
	            typeof this.itemsPerPage !== 'undefined'
	                ? this.itemsPerPage
	                : this.config.itemsPerPage;
	        this.totalPages = this.calculateTotalPages();
	        // this class
	        this.pages = this.getPages(this.page, this.totalPages);
	        this.inited = true;
	    };
	    PaginationComponent.prototype.writeValue = function (value) {
	        this.page = value;
	        this.pages = this.getPages(this.page, this.totalPages);
	    };
	    PaginationComponent.prototype.getText = function (key) {
	        return this[key + "Text"] || this.config[key + "Text"];
	    };
	    PaginationComponent.prototype.noPrevious = function () {
	        return this.page === 1;
	    };
	    PaginationComponent.prototype.noNext = function () {
	        return this.page === this.totalPages;
	    };
	    PaginationComponent.prototype.registerOnChange = function (fn) {
	        this.onChange = fn;
	    };
	    PaginationComponent.prototype.registerOnTouched = function (fn) {
	        this.onTouched = fn;
	    };
	    PaginationComponent.prototype.selectPage = function (page, event) {
	        if (event) {
	            event.preventDefault();
	        }
	        if (!this.disabled) {
	            if (event && event.target) {
	                var target = event.target;
	                target.blur();
	            }
	            this.writeValue(page);
	            this.onChange(this.page);
	        }
	    };
	    // Create page object used in template
	    PaginationComponent.prototype.makePage = function (num, text, active) {
	        return { text: text, number: num, active: active };
	    };
	    PaginationComponent.prototype.getPages = function (currentPage, totalPages) {
	        var pages = [];
	        // Default page limits
	        var startPage = 1;
	        var endPage = totalPages;
	        var isMaxSized = typeof this.maxSize !== 'undefined' && this.maxSize < totalPages;
	        // recompute if maxSize
	        if (isMaxSized) {
	            if (this.rotate) {
	                // Current page is displayed in the middle of the visible ones
	                startPage = Math.max(currentPage - Math.floor(this.maxSize / 2), 1);
	                endPage = startPage + this.maxSize - 1;
	                // Adjust if limit is exceeded
	                if (endPage > totalPages) {
	                    endPage = totalPages;
	                    startPage = endPage - this.maxSize + 1;
	                }
	            }
	            else {
	                // Visible pages are paginated with maxSize
	                startPage =
	                    (Math.ceil(currentPage / this.maxSize) - 1) * this.maxSize + 1;
	                // Adjust last page if limit is exceeded
	                endPage = Math.min(startPage + this.maxSize - 1, totalPages);
	            }
	        }
	        // Add page number links
	        for (var num = startPage; num <= endPage; num++) {
	            var page = this.makePage(num, num.toString(), num === currentPage);
	            pages.push(page);
	        }
	        // Add links to move between page sets
	        if (isMaxSized && !this.rotate) {
	            if (startPage > 1) {
	                var previousPageSet = this.makePage(startPage - 1, '...', false);
	                pages.unshift(previousPageSet);
	            }
	            if (endPage < totalPages) {
	                var nextPageSet = this.makePage(endPage + 1, '...', false);
	                pages.push(nextPageSet);
	            }
	        }
	        return pages;
	    };
	    // base class
	    PaginationComponent.prototype.calculateTotalPages = function () {
	        var totalPages = this.itemsPerPage < 1
	            ? 1
	            : Math.ceil(this.totalItems / this.itemsPerPage);
	        return Math.max(totalPages || 0, 1);
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], PaginationComponent.prototype, "align", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number)
	    ], PaginationComponent.prototype, "maxSize", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], PaginationComponent.prototype, "boundaryLinks", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], PaginationComponent.prototype, "directionLinks", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], PaginationComponent.prototype, "firstText", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], PaginationComponent.prototype, "previousText", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], PaginationComponent.prototype, "nextText", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], PaginationComponent.prototype, "lastText", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], PaginationComponent.prototype, "rotate", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], PaginationComponent.prototype, "pageBtnClass", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], PaginationComponent.prototype, "disabled", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
	    ], PaginationComponent.prototype, "numPages", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], PaginationComponent.prototype, "pageChanged", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number),
	        __metadata("design:paramtypes", [Number])
	    ], PaginationComponent.prototype, "itemsPerPage", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number),
	        __metadata("design:paramtypes", [Number])
	    ], PaginationComponent.prototype, "totalItems", null);
	    PaginationComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'pagination',
	            template: "<ul class=\"pagination\" [ngClass]=\"classMap\"> <li class=\"pagination-first page-item\" *ngIf=\"boundaryLinks\" [class.disabled]=\"noPrevious()||disabled\"> <a class=\"page-link\" href (click)=\"selectPage(1, $event)\" [innerHTML]=\"getText('first')\"></a> </li> <li class=\"pagination-prev page-item\" *ngIf=\"directionLinks\" [class.disabled]=\"noPrevious()||disabled\"> <a class=\"page-link\" href (click)=\"selectPage(page - 1, $event)\" [innerHTML]=\"getText('previous')\"></a> </li> <li *ngFor=\"let pg of pages\" [class.active]=\"pg.active\" [class.disabled]=\"disabled&&!pg.active\" class=\"pagination-page page-item\"> <a class=\"page-link\" href (click)=\"selectPage(pg.number, $event)\" [innerHTML]=\"pg.text\"></a> </li> <li class=\"pagination-next page-item\" *ngIf=\"directionLinks\" [class.disabled]=\"noNext()||disabled\"> <a class=\"page-link\" href (click)=\"selectPage(page + 1, $event)\" [innerHTML]=\"getText('next')\"></a></li> <li class=\"pagination-last page-item\" *ngIf=\"boundaryLinks\" [class.disabled]=\"noNext()||disabled\"> <a class=\"page-link\" href (click)=\"selectPage(totalPages, $event)\" [innerHTML]=\"getText('last')\"></a></li> </ul> ",
	            providers: [PAGINATION_CONTROL_VALUE_ACCESSOR]
	        }),
	        __metadata("design:paramtypes", [typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_2__pagination_config__["a" /* PaginationConfig */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__pagination_config__["a" /* PaginationConfig */]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]) === "function" && _e || Object])
	    ], PaginationComponent);
	    return PaginationComponent;
	    var _a, _b, _c, _d, _e;
	}());
	
	
	
	/***/ }),
	/* 127 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BarComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progressbar_component__ = __webpack_require__(73);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_theme_provider__ = __webpack_require__(7);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	
	
	
	// todo: number pipe
	// todo: use query from progress?
	var BarComponent = (function () {
	    function BarComponent(progress) {
	        this.percent = 0;
	        this.progress = progress;
	    }
	    Object.defineProperty(BarComponent.prototype, "value", {
	        /** current value of progress bar */
	        get: function () {
	            return this._value;
	        },
	        set: function (v) {
	            if (!v && v !== 0) {
	                return;
	            }
	            this._value = v;
	            this.recalculatePercentage();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BarComponent.prototype, "setBarWidth", {
	        get: function () {
	            this.recalculatePercentage();
	            return this.percent;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BarComponent.prototype, "isBs3", {
	        get: function () {
	            return Object(__WEBPACK_IMPORTED_MODULE_2__utils_theme_provider__["a" /* isBs3 */])();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BarComponent.prototype.ngOnInit = function () {
	        this.progress.addBar(this);
	    };
	    BarComponent.prototype.ngOnDestroy = function () {
	        this.progress.removeBar(this);
	    };
	    BarComponent.prototype.recalculatePercentage = function () {
	        this.percent = +(this.value / this.progress.max * 100).toFixed(2);
	        var totalPercentage = this.progress.bars
	            .reduce(function (total, bar) {
	            return total + bar.percent;
	        }, 0);
	        if (totalPercentage > 100) {
	            this.percent -= totalPercentage - 100;
	        }
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], BarComponent.prototype, "type", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number),
	        __metadata("design:paramtypes", [Number])
	    ], BarComponent.prototype, "value", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"])('style.width.%'),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [])
	    ], BarComponent.prototype, "setBarWidth", null);
	    BarComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'bar',
	            template: "<ng-content></ng-content> ",
	            host: {
	                role: 'progressbar',
	                'aria-valuemin': '0',
	                '[class]': '"progress-bar " + (type ? "progress-bar-" + type + " bg-" + type : "")',
	                '[class.progress-bar-animated]': '!isBs3 && animate',
	                '[class.progress-bar-striped]': 'striped',
	                '[class.active]': 'isBs3 && animate',
	                '[attr.aria-valuenow]': 'value',
	                '[attr.aria-valuetext]': 'percent ? percent.toFixed(0) + "%" : ""',
	                '[attr.aria-valuemax]': 'max',
	                '[style.height.%]': '"100"'
	            }
	        }),
	        __param(0, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"])()),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__progressbar_component__["a" /* ProgressbarComponent */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__progressbar_component__["a" /* ProgressbarComponent */]) === "function" && _a || Object])
	    ], BarComponent);
	    return BarComponent;
	    var _a;
	}());
	
	
	
	/***/ }),
	/* 128 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export RATING_CONTROL_VALUE_ACCESSOR */
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RatingComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_forms__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	var RATING_CONTROL_VALUE_ACCESSOR = {
	    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
	    // tslint:disable-next-line
	    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return RatingComponent; }),
	    multi: true
	};
	var RatingComponent = (function () {
	    function RatingComponent(changeDetection) {
	        this.changeDetection = changeDetection;
	        /** number of icons */
	        this.max = 5;
	        /** fired when icon selected, $event:number equals to selected rating */
	        this.onHover = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        /** fired when icon selected, $event:number equals to previous rating value */
	        this.onLeave = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.onChange = Function.prototype;
	        this.onTouched = Function.prototype;
	    }
	    RatingComponent.prototype.onKeydown = function (event) {
	        if ([37, 38, 39, 40].indexOf(event.which) === -1) {
	            return;
	        }
	        event.preventDefault();
	        event.stopPropagation();
	        var sign = event.which === 38 || event.which === 39 ? 1 : -1;
	        this.rate(this.value + sign);
	    };
	    RatingComponent.prototype.ngOnInit = function () {
	        this.max = typeof this.max !== 'undefined' ? this.max : 5;
	        this.titles =
	            typeof this.titles !== 'undefined' && this.titles.length > 0
	                ? this.titles
	                : ['one', 'two', 'three', 'four', 'five'];
	        this.range = this.buildTemplateObjects(this.max);
	    };
	    // model -> view
	    RatingComponent.prototype.writeValue = function (value) {
	        if (value % 1 !== value) {
	            this.value = Math.round(value);
	            this.preValue = value;
	            this.changeDetection.markForCheck();
	            return;
	        }
	        this.preValue = value;
	        this.value = value;
	        this.changeDetection.markForCheck();
	    };
	    RatingComponent.prototype.enter = function (value) {
	        if (!this.readonly) {
	            this.value = value;
	            this.changeDetection.markForCheck();
	            this.onHover.emit(value);
	        }
	    };
	    RatingComponent.prototype.reset = function () {
	        this.value = this.preValue;
	        this.changeDetection.markForCheck();
	        this.onLeave.emit(this.value);
	    };
	    RatingComponent.prototype.registerOnChange = function (fn) {
	        this.onChange = fn;
	    };
	    RatingComponent.prototype.registerOnTouched = function (fn) {
	        this.onTouched = fn;
	    };
	    RatingComponent.prototype.rate = function (value) {
	        if (!this.readonly && value >= 0 && value <= this.range.length) {
	            this.writeValue(value);
	            this.onChange(value);
	        }
	    };
	    RatingComponent.prototype.buildTemplateObjects = function (max) {
	        var result = [];
	        for (var i = 0; i < max; i++) {
	            result.push({
	                index: i,
	                title: this.titles[i] || i + 1
	            });
	        }
	        return result;
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], RatingComponent.prototype, "max", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], RatingComponent.prototype, "readonly", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Array)
	    ], RatingComponent.prototype, "titles", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]) === "function" && _a || Object)
	    ], RatingComponent.prototype, "customTemplate", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
	    ], RatingComponent.prototype, "onHover", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _c || Object)
	    ], RatingComponent.prototype, "onLeave", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('keydown', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], RatingComponent.prototype, "onKeydown", null);
	    RatingComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'rating',
	            template: "<span (mouseleave)=\"reset()\" (keydown)=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" [attr.aria-valuemax]=\"range.length\" [attr.aria-valuenow]=\"value\"> <ng-template #star let-value=\"value\" let-index=\"index\">{{index < value ? '&#9733;' : '&#9734;'}}</ng-template> <ng-template ngFor let-r [ngForOf]=\"range\" let-index=\"index\"> <span class=\"sr-only\">({{ index < value ? '*' : ' ' }})</span> <span class=\"bs-rating-star\" (mouseenter)=\"enter(index + 1)\" (click)=\"rate(index + 1)\" [title]=\"r.title\" [style.cursor]=\"readonly ? 'default' : 'pointer'\" [class.active]=\"index < value\"> <ng-template [ngTemplateOutlet]=\"customTemplate || star\" [ngTemplateOutletContext]=\"{index: index, value: value}\"> </ng-template> </span> </ng-template> </span> ",
	            providers: [RATING_CONTROL_VALUE_ACCESSOR],
	            changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush
	        }),
	        __metadata("design:paramtypes", [typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]) === "function" && _d || Object])
	    ], RatingComponent);
	    return RatingComponent;
	    var _a, _b, _c, _d;
	}());
	
	
	
	/***/ }),
	/* 129 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SortableComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_forms__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__draggable_item_service__ = __webpack_require__(75);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	/* tslint:disable */
	var SortableComponent = (function () {
	    function SortableComponent(transfer) {
	        var _this = this;
	        /** class name for items wrapper */
	        this.wrapperClass = '';
	        /** style object for items wrapper */
	        this.wrapperStyle = {};
	        /** class name for item */
	        this.itemClass = '';
	        /** style object for item */
	        this.itemStyle = {};
	        /** class name for active item */
	        this.itemActiveClass = '';
	        /** style object for active item */
	        this.itemActiveStyle = {};
	        /** class name for placeholder */
	        this.placeholderClass = '';
	        /** style object for placeholder */
	        this.placeholderStyle = {};
	        /** placeholder item which will be shown if collection is empty */
	        this.placeholderItem = '';
	        /** fired on array change (reordering, insert, remove), same as <code>ngModelChange</code>.
	         *  Returns new items collection as a payload.
	         */
	        this.onChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.showPlaceholder = false;
	        this.activeItem = -1;
	        this.onTouched = Function.prototype;
	        this.onChanged = Function.prototype;
	        this.transfer = transfer;
	        this.currentZoneIndex = SortableComponent_1.globalZoneIndex++;
	        this.transfer
	            .onCaptureItem()
	            .subscribe(function (item) { return _this.onDrop(item); });
	    }
	    SortableComponent_1 = SortableComponent;
	    Object.defineProperty(SortableComponent.prototype, "items", {
	        get: function () {
	            return this._items;
	        },
	        set: function (value) {
	            this._items = value;
	            var out = this.items.map(function (x) { return x.initData; });
	            this.onChanged(out);
	            this.onChange.emit(out);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SortableComponent.prototype.onItemDragstart = function (event, item, i) {
	        this.initDragstartEvent(event);
	        this.onTouched();
	        this.transfer.dragStart({
	            event: event,
	            item: item,
	            i: i,
	            initialIndex: i,
	            lastZoneIndex: this.currentZoneIndex,
	            overZoneIndex: this.currentZoneIndex
	        });
	    };
	    SortableComponent.prototype.onItemDragover = function (event, i) {
	        if (!this.transfer.getItem()) {
	            return;
	        }
	        event.preventDefault();
	        var dragItem = this.transfer.captureItem(this.currentZoneIndex, this.items.length);
	        var newArray = [];
	        if (!this.items.length) {
	            newArray = [dragItem.item];
	        }
	        else if (dragItem.i > i) {
	            newArray = this.items.slice(0, i).concat([
	                dragItem.item
	            ], this.items.slice(i, dragItem.i), this.items.slice(dragItem.i + 1));
	        }
	        else {
	            // this.draggedItem.i < i
	            newArray = this.items.slice(0, dragItem.i).concat(this.items.slice(dragItem.i + 1, i + 1), [
	                dragItem.item
	            ], this.items.slice(i + 1));
	        }
	        this.items = newArray;
	        dragItem.i = i;
	        this.activeItem = i;
	        this.updatePlaceholderState();
	    };
	    SortableComponent.prototype.cancelEvent = function (event) {
	        if (!this.transfer.getItem() || !event) {
	            return;
	        }
	        event.preventDefault();
	    };
	    SortableComponent.prototype.onDrop = function (item) {
	        if (item &&
	            item.overZoneIndex !== this.currentZoneIndex &&
	            item.lastZoneIndex === this.currentZoneIndex) {
	            this.items = this.items.filter(function (x, i) { return i !== item.i; });
	            this.updatePlaceholderState();
	        }
	        this.resetActiveItem(undefined);
	    };
	    SortableComponent.prototype.resetActiveItem = function (event) {
	        this.cancelEvent(event);
	        this.activeItem = -1;
	    };
	    SortableComponent.prototype.registerOnChange = function (callback) {
	        this.onChanged = callback;
	    };
	    SortableComponent.prototype.registerOnTouched = function (callback) {
	        this.onTouched = callback;
	    };
	    SortableComponent.prototype.writeValue = function (value) {
	        var _this = this;
	        if (value) {
	            this.items = value.map(function (x, i) { return ({
	                id: i,
	                initData: x,
	                value: _this.fieldName ? x[_this.fieldName] : x
	            }); });
	        }
	        else {
	            this.items = [];
	        }
	        this.updatePlaceholderState();
	    };
	    SortableComponent.prototype.updatePlaceholderState = function () {
	        this.showPlaceholder = !this._items.length;
	    };
	    SortableComponent.prototype.getItemStyle = function (isActive) {
	        return isActive
	            ? Object.assign({}, this.itemStyle, this.itemActiveStyle)
	            : this.itemStyle;
	    };
	    // tslint:disable-next-line
	    SortableComponent.prototype.initDragstartEvent = function (event) {
	        // it is necessary for mozilla
	        // data type should be 'Text' instead of 'text/plain' to keep compatibility
	        // with IE
	        event.dataTransfer.setData('Text', 'placeholder');
	    };
	    SortableComponent.globalZoneIndex = 0;
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], SortableComponent.prototype, "fieldName", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], SortableComponent.prototype, "wrapperClass", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], SortableComponent.prototype, "wrapperStyle", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], SortableComponent.prototype, "itemClass", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], SortableComponent.prototype, "itemStyle", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], SortableComponent.prototype, "itemActiveClass", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], SortableComponent.prototype, "itemActiveStyle", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], SortableComponent.prototype, "placeholderClass", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], SortableComponent.prototype, "placeholderStyle", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], SortableComponent.prototype, "placeholderItem", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]) === "function" && _a || Object)
	    ], SortableComponent.prototype, "itemTemplate", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
	    ], SortableComponent.prototype, "onChange", void 0);
	    SortableComponent = SortableComponent_1 = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'bs-sortable',
	            exportAs: 'bs-sortable',
	            template: "\n<div\n    [ngClass]=\"wrapperClass\"\n    [ngStyle]=\"wrapperStyle\"\n    [ngStyle]=\"wrapperStyle\"\n    (dragover)=\"cancelEvent($event)\"\n    (dragenter)=\"cancelEvent($event)\"\n    (drop)=\"resetActiveItem($event)\"\n    (mouseleave)=\"resetActiveItem($event)\">\n  <div\n        *ngIf=\"showPlaceholder\"\n        [ngClass]=\"placeholderClass\"\n        [ngStyle]=\"placeholderStyle\"\n        (dragover)=\"onItemDragover($event, 0)\"\n        (dragenter)=\"cancelEvent($event)\"\n    >{{placeholderItem}}</div>\n    <div\n        *ngFor=\"let item of items; let i=index;\"\n        [ngClass]=\"[ itemClass, i === activeItem ? itemActiveClass : '' ]\"\n        [ngStyle]=\"getItemStyle(i === activeItem)\"\n        draggable=\"true\"\n        (dragstart)=\"onItemDragstart($event, item, i)\"\n        (dragend)=\"resetActiveItem($event)\"\n        (dragover)=\"onItemDragover($event, i)\"\n        (dragenter)=\"cancelEvent($event)\"\n        aria-dropeffect=\"move\"\n        [attr.aria-grabbed]=\"i === activeItem\"\n    ><ng-template [ngTemplateOutlet]=\"itemTemplate || defItemTemplate\"\n  [ngTemplateOutletContext]=\"{item:item, index: i}\"></ng-template></div>\n</div>\n\n<ng-template #defItemTemplate let-item=\"item\">{{item.value}}</ng-template>  \n",
	            providers: [
	                {
	                    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
	                    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return SortableComponent_1; }),
	                    multi: true
	                }
	            ]
	        })
	        /* tslint:enable */
	        ,
	        __metadata("design:paramtypes", [typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_2__draggable_item_service__["a" /* DraggableItemService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__draggable_item_service__["a" /* DraggableItemService */]) === "function" && _c || Object])
	    ], SortableComponent);
	    return SortableComponent;
	    var SortableComponent_1, _a, _b, _c;
	}());
	
	
	
	/***/ }),
	/* 130 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NgTranscludeDirective; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	var NgTranscludeDirective = (function () {
	    function NgTranscludeDirective(viewRef) {
	        this.viewRef = viewRef;
	    }
	    Object.defineProperty(NgTranscludeDirective.prototype, "ngTransclude", {
	        get: function () {
	            return this._ngTransclude;
	        },
	        set: function (templateRef) {
	            this._ngTransclude = templateRef;
	            if (templateRef) {
	                this.viewRef.createEmbeddedView(templateRef);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]) === "function" && _a || Object),
	        __metadata("design:paramtypes", [typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]) === "function" && _b || Object])
	    ], NgTranscludeDirective.prototype, "ngTransclude", null);
	    NgTranscludeDirective = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
	            selector: '[ngTransclude]'
	        }),
	        __metadata("design:paramtypes", [typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"]) === "function" && _c || Object])
	    ], NgTranscludeDirective);
	    return NgTranscludeDirective;
	    var _a, _b, _c;
	}());
	
	
	
	/***/ }),
	/* 131 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabHeadingDirective; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tab_directive__ = __webpack_require__(76);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	/** Should be used to mark <ng-template> element as a template for tab heading */
	var TabHeadingDirective = (function () {
	    function TabHeadingDirective(templateRef, tab) {
	        tab.headingRef = templateRef;
	    }
	    TabHeadingDirective = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({ selector: '[tabHeading]' }),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__tab_directive__["a" /* TabDirective */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__tab_directive__["a" /* TabDirective */]) === "function" && _b || Object])
	    ], TabHeadingDirective);
	    return TabHeadingDirective;
	    var _a, _b;
	}());
	
	
	
	/***/ }),
	/* 132 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export TIMEPICKER_CONTROL_VALUE_ACCESSOR */
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimepickerComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_forms__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer_timepicker_actions__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer_timepicker_store__ = __webpack_require__(79);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__timepicker_controls_util__ = __webpack_require__(133);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__timepicker_config__ = __webpack_require__(43);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__timepicker_utils__ = __webpack_require__(80);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/* tslint:disable:no-forward-ref max-file-line-count */
	
	
	
	
	
	
	
	var TIMEPICKER_CONTROL_VALUE_ACCESSOR = {
	    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
	    // tslint:disable-next-line
	    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return TimepickerComponent; }),
	    multi: true
	};
	var TimepickerComponent = (function () {
	    function TimepickerComponent(_config, _cd, _store, _timepickerActions) {
	        var _this = this;
	        this._store = _store;
	        this._timepickerActions = _timepickerActions;
	        /** emits true if value is a valid date */
	        this.isValid = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        // min\max validation for input fields
	        this.invalidHours = false;
	        this.invalidMinutes = false;
	        this.invalidSeconds = false;
	        // control value accessor methods
	        this.onChange = Function.prototype;
	        this.onTouched = Function.prototype;
	        Object.assign(this, _config);
	        this.timepickerSub = _store.select(function (state) { return state.value; }).subscribe(function (value) {
	            // update UI values if date changed
	            _this._renderTime(value);
	            _this.onChange(value);
	            _this._store.dispatch(_this._timepickerActions.updateControls(Object(__WEBPACK_IMPORTED_MODULE_4__timepicker_controls_util__["e" /* getControlsValue */])(_this)));
	        });
	        _store.select(function (state) { return state.controls; }).subscribe(function (controlsState) {
	            _this.isValid.emit(Object(__WEBPACK_IMPORTED_MODULE_6__timepicker_utils__["d" /* isInputValid */])(_this.hours, _this.minutes, _this.seconds, _this.isPM()));
	            Object.assign(_this, controlsState);
	            _cd.markForCheck();
	        });
	    }
	    Object.defineProperty(TimepickerComponent.prototype, "isSpinnersVisible", {
	        /** @deprecated - please use `isEditable` instead */
	        get: function () {
	            return this.showSpinners && !this.readonlyInput;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TimepickerComponent.prototype, "isEditable", {
	        get: function () {
	            return !(this.readonlyInput || this.disabled);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TimepickerComponent.prototype.resetValidation = function () {
	        this.invalidHours = false;
	        this.invalidMinutes = false;
	        this.invalidSeconds = false;
	    };
	    TimepickerComponent.prototype.isPM = function () {
	        return this.showMeridian && this.meridian === this.meridians[1];
	    };
	    TimepickerComponent.prototype.prevDef = function ($event) {
	        $event.preventDefault();
	    };
	    TimepickerComponent.prototype.wheelSign = function ($event) {
	        return Math.sign($event.deltaY) * -1;
	    };
	    TimepickerComponent.prototype.ngOnChanges = function (changes) {
	        this._store.dispatch(this._timepickerActions.updateControls(Object(__WEBPACK_IMPORTED_MODULE_4__timepicker_controls_util__["e" /* getControlsValue */])(this)));
	    };
	    TimepickerComponent.prototype.changeHours = function (step, source) {
	        if (source === void 0) { source = ''; }
	        this.resetValidation();
	        this._store.dispatch(this._timepickerActions.changeHours({ step: step, source: source }));
	    };
	    TimepickerComponent.prototype.changeMinutes = function (step, source) {
	        if (source === void 0) { source = ''; }
	        this.resetValidation();
	        this._store.dispatch(this._timepickerActions.changeMinutes({ step: step, source: source }));
	    };
	    TimepickerComponent.prototype.changeSeconds = function (step, source) {
	        if (source === void 0) { source = ''; }
	        this.resetValidation();
	        this._store.dispatch(this._timepickerActions.changeSeconds({ step: step, source: source }));
	    };
	    TimepickerComponent.prototype.updateHours = function (hours) {
	        this.resetValidation();
	        this.hours = hours;
	        var isValid = Object(__WEBPACK_IMPORTED_MODULE_6__timepicker_utils__["b" /* isHourInputValid */])(this.hours, this.isPM()) && this.isValidLimit();
	        if (!isValid) {
	            this.invalidHours = true;
	            this.isValid.emit(false);
	            this.onChange(null);
	            return;
	        }
	        this._updateTime();
	    };
	    TimepickerComponent.prototype.updateMinutes = function (minutes) {
	        this.resetValidation();
	        this.minutes = minutes;
	        var isValid = Object(__WEBPACK_IMPORTED_MODULE_6__timepicker_utils__["e" /* isMinuteInputValid */])(this.minutes) && this.isValidLimit();
	        if (!isValid) {
	            this.invalidMinutes = true;
	            this.isValid.emit(false);
	            this.onChange(null);
	            return;
	        }
	        this._updateTime();
	    };
	    TimepickerComponent.prototype.updateSeconds = function (seconds) {
	        this.resetValidation();
	        this.seconds = seconds;
	        var isValid = Object(__WEBPACK_IMPORTED_MODULE_6__timepicker_utils__["f" /* isSecondInputValid */])(this.seconds) && this.isValidLimit();
	        if (!isValid) {
	            this.invalidSeconds = true;
	            this.isValid.emit(false);
	            this.onChange(null);
	            return;
	        }
	        this._updateTime();
	    };
	    TimepickerComponent.prototype.isValidLimit = function () {
	        return Object(__WEBPACK_IMPORTED_MODULE_6__timepicker_utils__["c" /* isInputLimitValid */])({
	            hour: this.hours,
	            minute: this.minutes,
	            seconds: this.seconds,
	            isPM: this.isPM()
	        }, this.max, this.min);
	    };
	    TimepickerComponent.prototype._updateTime = function () {
	        var _seconds = this.showSeconds ? this.seconds : void 0;
	        var _minutes = this.showMinutes ? this.minutes : void 0;
	        if (!Object(__WEBPACK_IMPORTED_MODULE_6__timepicker_utils__["d" /* isInputValid */])(this.hours, _minutes, _seconds, this.isPM())) {
	            this.isValid.emit(false);
	            this.onChange(null);
	            return;
	        }
	        this._store.dispatch(this._timepickerActions.setTime({
	            hour: this.hours,
	            minute: this.minutes,
	            seconds: this.seconds,
	            isPM: this.isPM()
	        }));
	    };
	    TimepickerComponent.prototype.toggleMeridian = function () {
	        if (!this.showMeridian || !this.isEditable) {
	            return;
	        }
	        var _hoursPerDayHalf = 12;
	        this._store.dispatch(this._timepickerActions.changeHours({
	            step: _hoursPerDayHalf,
	            source: ''
	        }));
	    };
	    /**
	     * Write a new value to the element.
	     */
	    TimepickerComponent.prototype.writeValue = function (obj) {
	        if (Object(__WEBPACK_IMPORTED_MODULE_6__timepicker_utils__["g" /* isValidDate */])(obj)) {
	            this._store.dispatch(this._timepickerActions.writeValue(Object(__WEBPACK_IMPORTED_MODULE_6__timepicker_utils__["j" /* parseTime */])(obj)));
	        }
	        else if (obj == null) {
	            this._store.dispatch(this._timepickerActions.writeValue(null));
	        }
	    };
	    /**
	     * Set the function to be called when the control receives a change event.
	     */
	    TimepickerComponent.prototype.registerOnChange = function (fn) {
	        this.onChange = fn;
	    };
	    /**
	     * Set the function to be called when the control receives a touch event.
	     */
	    TimepickerComponent.prototype.registerOnTouched = function (fn) {
	        this.onTouched = fn;
	    };
	    /**
	     * This function is called when the control status changes to or from "disabled".
	     * Depending on the value, it will enable or disable the appropriate DOM element.
	     *
	     * @param isDisabled
	     */
	    TimepickerComponent.prototype.setDisabledState = function (isDisabled) {
	        this.disabled = isDisabled;
	    };
	    TimepickerComponent.prototype.ngOnDestroy = function () {
	        this.timepickerSub.unsubscribe();
	    };
	    TimepickerComponent.prototype._renderTime = function (value) {
	        if (!Object(__WEBPACK_IMPORTED_MODULE_6__timepicker_utils__["g" /* isValidDate */])(value)) {
	            this.hours = '';
	            this.minutes = '';
	            this.seconds = '';
	            this.meridian = this.meridians[0];
	            return;
	        }
	        var _value = Object(__WEBPACK_IMPORTED_MODULE_6__timepicker_utils__["j" /* parseTime */])(value);
	        var _hoursPerDayHalf = 12;
	        var _hours = _value.getHours();
	        if (this.showMeridian) {
	            this.meridian = this.meridians[_hours >= _hoursPerDayHalf ? 1 : 0];
	            _hours = _hours % _hoursPerDayHalf;
	            // should be 12 PM, not 00 PM
	            if (_hours === 0) {
	                _hours = _hoursPerDayHalf;
	            }
	        }
	        this.hours = Object(__WEBPACK_IMPORTED_MODULE_6__timepicker_utils__["i" /* padNumber */])(_hours);
	        this.minutes = Object(__WEBPACK_IMPORTED_MODULE_6__timepicker_utils__["i" /* padNumber */])(_value.getMinutes());
	        this.seconds = Object(__WEBPACK_IMPORTED_MODULE_6__timepicker_utils__["i" /* padNumber */])(_value.getUTCSeconds());
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number)
	    ], TimepickerComponent.prototype, "hourStep", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number)
	    ], TimepickerComponent.prototype, "minuteStep", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number)
	    ], TimepickerComponent.prototype, "secondsStep", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], TimepickerComponent.prototype, "readonlyInput", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], TimepickerComponent.prototype, "disabled", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], TimepickerComponent.prototype, "mousewheel", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], TimepickerComponent.prototype, "arrowkeys", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], TimepickerComponent.prototype, "showSpinners", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], TimepickerComponent.prototype, "showMeridian", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], TimepickerComponent.prototype, "showMinutes", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], TimepickerComponent.prototype, "showSeconds", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Array)
	    ], TimepickerComponent.prototype, "meridians", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], TimepickerComponent.prototype, "min", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], TimepickerComponent.prototype, "max", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], TimepickerComponent.prototype, "isValid", void 0);
	    TimepickerComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'timepicker',
	            changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
	            providers: [TIMEPICKER_CONTROL_VALUE_ACCESSOR, __WEBPACK_IMPORTED_MODULE_3__reducer_timepicker_store__["a" /* TimepickerStore */]],
	            template: "<table> <tbody> <tr class=\"text-center\" [hidden]=\"!showSpinners\"> <!-- increment hours button--> <td> <a class=\"btn btn-link\" [class.disabled]=\"!canIncrementHours || !isEditable\" (click)=\"changeHours(hourStep)\" ><span class=\"bs-chevron bs-chevron-up\"></span></a> </td> <!-- divider --> <td *ngIf=\"showMinutes\">&nbsp;&nbsp;&nbsp;</td> <!-- increment minutes button --> <td *ngIf=\"showMinutes\"> <a class=\"btn btn-link\" [class.disabled]=\"!canIncrementMinutes || !isEditable\" (click)=\"changeMinutes(minuteStep)\" ><span class=\"bs-chevron bs-chevron-up\"></span></a> </td> <!-- divider --> <td *ngIf=\"showSeconds\">&nbsp;</td> <!-- increment seconds button --> <td *ngIf=\"showSeconds\"> <a class=\"btn btn-link\" [class.disabled]=\"!canIncrementSeconds || !isEditable\" (click)=\"changeSeconds(secondsStep)\"> <span class=\"bs-chevron bs-chevron-up\"></span> </a> </td> <!-- space between --> <td *ngIf=\"showMeridian\">&nbsp;&nbsp;&nbsp;</td> <!-- meridian placeholder--> <td *ngIf=\"showMeridian\"></td> </tr> <tr> <!-- hours --> <td class=\"form-group\" [class.has-error]=\"invalidHours\"> <input type=\"text\" [class.is-invalid]=\"invalidHours\" class=\"form-control text-center bs-timepicker-field\" placeholder=\"HH\" maxlength=\"2\" [readonly]=\"readonlyInput\" [disabled]=\"disabled\" [value]=\"hours\" (wheel)=\"prevDef($event);changeHours(hourStep * wheelSign($event), 'wheel')\" (keydown.ArrowUp)=\"changeHours(hourStep, 'key')\" (keydown.ArrowDown)=\"changeHours(-hourStep, 'key')\" (change)=\"updateHours($event.target.value)\"></td> <!-- divider --> <td *ngIf=\"showMinutes\">&nbsp;:&nbsp;</td> <!-- minutes --> <td class=\"form-group\" *ngIf=\"showMinutes\" [class.has-error]=\"invalidMinutes\"> <input type=\"text\" [class.is-invalid]=\"invalidMinutes\" class=\"form-control text-center bs-timepicker-field\" placeholder=\"MM\" maxlength=\"2\" [readonly]=\"readonlyInput\" [disabled]=\"disabled\" [value]=\"minutes\" (wheel)=\"prevDef($event);changeMinutes(minuteStep * wheelSign($event), 'wheel')\" (keydown.ArrowUp)=\"changeMinutes(minuteStep, 'key')\" (keydown.ArrowDown)=\"changeMinutes(-minuteStep, 'key')\" (change)=\"updateMinutes($event.target.value)\"> </td> <!-- divider --> <td *ngIf=\"showSeconds\">&nbsp;:&nbsp;</td> <!-- seconds --> <td class=\"form-group\" *ngIf=\"showSeconds\" [class.has-error]=\"invalidSeconds\"> <input type=\"text\" [class.is-invalid]=\"invalidSeconds\" class=\"form-control text-center bs-timepicker-field\" placeholder=\"SS\" maxlength=\"2\" [readonly]=\"readonlyInput\" [disabled]=\"disabled\" [value]=\"seconds\" (wheel)=\"prevDef($event);changeSeconds(secondsStep * wheelSign($event), 'wheel')\" (keydown.ArrowUp)=\"changeSeconds(secondsStep, 'key')\" (keydown.ArrowDown)=\"changeSeconds(-secondsStep, 'key')\" (change)=\"updateSeconds($event.target.value)\"> </td> <!-- space between --> <td *ngIf=\"showMeridian\">&nbsp;&nbsp;&nbsp;</td> <!-- meridian --> <td *ngIf=\"showMeridian\"> <button type=\"button\" class=\"btn btn-default text-center\" [disabled]=\"!isEditable || !canToggleMeridian\" [class.disabled]=\"!isEditable || !canToggleMeridian\" (click)=\"toggleMeridian()\" >{{ meridian }} </button> </td> </tr> <tr class=\"text-center\" [hidden]=\"!showSpinners\"> <!-- decrement hours button--> <td> <a class=\"btn btn-link\" [class.disabled]=\"!canDecrementHours || !isEditable\" (click)=\"changeHours(-hourStep)\"> <span class=\"bs-chevron bs-chevron-down\"></span> </a> </td> <!-- divider --> <td *ngIf=\"showMinutes\">&nbsp;&nbsp;&nbsp;</td> <!-- decrement minutes button--> <td *ngIf=\"showMinutes\"> <a class=\"btn btn-link\" [class.disabled]=\"!canDecrementMinutes || !isEditable\" (click)=\"changeMinutes(-minuteStep)\"> <span class=\"bs-chevron bs-chevron-down\"></span> </a> </td> <!-- divider --> <td *ngIf=\"showSeconds\">&nbsp;</td> <!-- decrement seconds button--> <td *ngIf=\"showSeconds\"> <a class=\"btn btn-link\" [class.disabled]=\"!canDecrementSeconds || !isEditable\" (click)=\"changeSeconds(-secondsStep)\"> <span class=\"bs-chevron bs-chevron-down\"></span> </a> </td> <!-- space between --> <td *ngIf=\"showMeridian\">&nbsp;&nbsp;&nbsp;</td> <!-- meridian placeholder--> <td *ngIf=\"showMeridian\"></td> </tr> </tbody> </table> ",
	            styles: ["\n    .bs-chevron{\n      border-style: solid;\n      display: block;\n      width: 9px;\n      height: 9px;\n      position: relative;\n      border-width: 3px 0px 0 3px;\n    }\n    .bs-chevron-up{\n      -webkit-transform: rotate(45deg);\n      transform: rotate(45deg);\n      top: 2px;\n    }\n    .bs-chevron-down{\n      -webkit-transform: rotate(-135deg);\n      transform: rotate(-135deg);\n      top: -2px;\n    }\n    .bs-timepicker-field{\n      width: 50px;\n    }\n  "],
	            encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None
	        }),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_5__timepicker_config__["a" /* TimepickerConfig */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_5__timepicker_config__["a" /* TimepickerConfig */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_3__reducer_timepicker_store__["a" /* TimepickerStore */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__reducer_timepicker_store__["a" /* TimepickerStore */]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_2__reducer_timepicker_actions__["a" /* TimepickerActions */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__reducer_timepicker_actions__["a" /* TimepickerActions */]) === "function" && _d || Object])
	    ], TimepickerComponent);
	    return TimepickerComponent;
	    var _a, _b, _c, _d;
	}());
	
	
	
	/***/ }),
	/* 133 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["d"] = canChangeValue;
	/* harmony export (immutable) */ __webpack_exports__["a"] = canChangeHours;
	/* harmony export (immutable) */ __webpack_exports__["b"] = canChangeMinutes;
	/* harmony export (immutable) */ __webpack_exports__["c"] = canChangeSeconds;
	/* harmony export (immutable) */ __webpack_exports__["e"] = getControlsValue;
	/* harmony export (immutable) */ __webpack_exports__["f"] = timepickerControls;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timepicker_utils__ = __webpack_require__(80);
	
	function canChangeValue(state, event) {
	    if (state.readonlyInput || state.disabled) {
	        return false;
	    }
	    if (event) {
	        if (event.source === 'wheel' && !state.mousewheel) {
	            return false;
	        }
	        if (event.source === 'key' && !state.arrowkeys) {
	            return false;
	        }
	    }
	    return true;
	}
	function canChangeHours(event, controls) {
	    if (!event.step) {
	        return false;
	    }
	    if (event.step > 0 && !controls.canIncrementHours) {
	        return false;
	    }
	    if (event.step < 0 && !controls.canDecrementHours) {
	        return false;
	    }
	    return true;
	}
	function canChangeMinutes(event, controls) {
	    if (!event.step) {
	        return false;
	    }
	    if (event.step > 0 && !controls.canIncrementMinutes) {
	        return false;
	    }
	    if (event.step < 0 && !controls.canDecrementMinutes) {
	        return false;
	    }
	    return true;
	}
	function canChangeSeconds(event, controls) {
	    if (!event.step) {
	        return false;
	    }
	    if (event.step > 0 && !controls.canIncrementSeconds) {
	        return false;
	    }
	    if (event.step < 0 && !controls.canDecrementSeconds) {
	        return false;
	    }
	    return true;
	}
	function getControlsValue(state) {
	    var hourStep = state.hourStep, minuteStep = state.minuteStep, secondsStep = state.secondsStep, readonlyInput = state.readonlyInput, disabled = state.disabled, mousewheel = state.mousewheel, arrowkeys = state.arrowkeys, showSpinners = state.showSpinners, showMeridian = state.showMeridian, showSeconds = state.showSeconds, meridians = state.meridians, min = state.min, max = state.max;
	    return {
	        hourStep: hourStep,
	        minuteStep: minuteStep,
	        secondsStep: secondsStep,
	        readonlyInput: readonlyInput,
	        disabled: disabled,
	        mousewheel: mousewheel,
	        arrowkeys: arrowkeys,
	        showSpinners: showSpinners,
	        showMeridian: showMeridian,
	        showSeconds: showSeconds,
	        meridians: meridians,
	        min: min,
	        max: max
	    };
	}
	function timepickerControls(value, state) {
	    var hoursPerDayHalf = 12;
	    var min = state.min, max = state.max, hourStep = state.hourStep, minuteStep = state.minuteStep, secondsStep = state.secondsStep, showSeconds = state.showSeconds;
	    var res = {
	        canIncrementHours: true,
	        canIncrementMinutes: true,
	        canIncrementSeconds: true,
	        canDecrementHours: true,
	        canDecrementMinutes: true,
	        canDecrementSeconds: true,
	        canToggleMeridian: true
	    };
	    if (!value) {
	        return res;
	    }
	    // compare dates
	    if (max) {
	        var _newHour = Object(__WEBPACK_IMPORTED_MODULE_0__timepicker_utils__["a" /* changeTime */])(value, { hour: hourStep });
	        res.canIncrementHours = max > _newHour;
	        if (!res.canIncrementHours) {
	            var _newMinutes = Object(__WEBPACK_IMPORTED_MODULE_0__timepicker_utils__["a" /* changeTime */])(value, { minute: minuteStep });
	            res.canIncrementMinutes = showSeconds
	                ? max > _newMinutes
	                : max >= _newMinutes;
	        }
	        if (!res.canIncrementMinutes) {
	            var _newSeconds = Object(__WEBPACK_IMPORTED_MODULE_0__timepicker_utils__["a" /* changeTime */])(value, { seconds: secondsStep });
	            res.canIncrementSeconds = max >= _newSeconds;
	        }
	        if (value.getHours() < hoursPerDayHalf) {
	            res.canToggleMeridian = Object(__WEBPACK_IMPORTED_MODULE_0__timepicker_utils__["a" /* changeTime */])(value, { hour: hoursPerDayHalf }) < max;
	        }
	    }
	    if (min) {
	        var _newHour = Object(__WEBPACK_IMPORTED_MODULE_0__timepicker_utils__["a" /* changeTime */])(value, { hour: -hourStep });
	        res.canDecrementHours = min < _newHour;
	        if (!res.canDecrementHours) {
	            var _newMinutes = Object(__WEBPACK_IMPORTED_MODULE_0__timepicker_utils__["a" /* changeTime */])(value, { minute: -minuteStep });
	            res.canDecrementMinutes = showSeconds
	                ? min < _newMinutes
	                : min <= _newMinutes;
	        }
	        if (!res.canDecrementMinutes) {
	            var _newSeconds = Object(__WEBPACK_IMPORTED_MODULE_0__timepicker_utils__["a" /* changeTime */])(value, { seconds: -secondsStep });
	            res.canDecrementSeconds = min <= _newSeconds;
	        }
	        if (value.getHours() >= hoursPerDayHalf) {
	            res.canToggleMeridian = Object(__WEBPACK_IMPORTED_MODULE_0__timepicker_utils__["a" /* changeTime */])(value, { hour: -hoursPerDayHalf }) > min;
	        }
	    }
	    return res;
	}
	
	
	/***/ }),
	/* 134 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TooltipDirective; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tooltip_container_component__ = __webpack_require__(81);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tooltip_config__ = __webpack_require__(44);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_loader_index__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_decorators__ = __webpack_require__(57);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warn_once__ = __webpack_require__(110);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_triggers__ = __webpack_require__(106);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_Observable__ = __webpack_require__(66);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_Observable__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_add_observable_timer__ = __webpack_require__(221);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_add_observable_timer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_add_observable_timer__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	// tslint:disable:deprecation
	
	
	
	
	
	
	
	
	
	var TooltipDirective = (function () {
	    function TooltipDirective(_viewContainerRef, _renderer, _elementRef, cis, config) {
	        this._renderer = _renderer;
	        this._elementRef = _elementRef;
	        /** Fired when tooltip content changes */
	        this.tooltipChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        /**
	         * Css class for tooltip container
	         */
	        this.containerClass = '';
	        /** @deprecated - removed, will be added to configuration */
	        this._animation = true;
	        /** @deprecated */
	        this._fadeDuration = 150;
	        /** @deprecated */
	        this.tooltipStateChanged = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this._tooltip = cis
	            .createLoader(this._elementRef, _viewContainerRef, this._renderer)
	            .provide({ provide: __WEBPACK_IMPORTED_MODULE_2__tooltip_config__["a" /* TooltipConfig */], useValue: config });
	        Object.assign(this, config);
	        this.onShown = this._tooltip.onShown;
	        this.onHidden = this._tooltip.onHidden;
	    }
	    Object.defineProperty(TooltipDirective.prototype, "isOpen", {
	        /**
	         * Returns whether or not the tooltip is currently being shown
	         */
	        get: function () {
	            return this._tooltip.isShown;
	        },
	        set: function (value) {
	            if (value) {
	                this.show();
	            }
	            else {
	                this.hide();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TooltipDirective.prototype, "htmlContent", {
	        /** @deprecated - please use `tooltip` instead */
	        set: function (value) {
	            Object(__WEBPACK_IMPORTED_MODULE_5__utils_warn_once__["a" /* warnOnce */])('tooltipHtml was deprecated, please use `tooltip` instead');
	            this.tooltip = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TooltipDirective.prototype, "_placement", {
	        /** @deprecated - please use `placement` instead */
	        set: function (value) {
	            Object(__WEBPACK_IMPORTED_MODULE_5__utils_warn_once__["a" /* warnOnce */])('tooltipPlacement was deprecated, please use `placement` instead');
	            this.placement = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TooltipDirective.prototype, "_isOpen", {
	        get: function () {
	            Object(__WEBPACK_IMPORTED_MODULE_5__utils_warn_once__["a" /* warnOnce */])('tooltipIsOpen was deprecated, please use `isOpen` instead');
	            return this.isOpen;
	        },
	        /** @deprecated - please use `isOpen` instead*/
	        set: function (value) {
	            Object(__WEBPACK_IMPORTED_MODULE_5__utils_warn_once__["a" /* warnOnce */])('tooltipIsOpen was deprecated, please use `isOpen` instead');
	            this.isOpen = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TooltipDirective.prototype, "_enable", {
	        get: function () {
	            Object(__WEBPACK_IMPORTED_MODULE_5__utils_warn_once__["a" /* warnOnce */])('tooltipEnable was deprecated, please use `isDisabled` instead');
	            return this.isDisabled;
	        },
	        /** @deprecated - please use `isDisabled` instead */
	        set: function (value) {
	            Object(__WEBPACK_IMPORTED_MODULE_5__utils_warn_once__["a" /* warnOnce */])('tooltipEnable was deprecated, please use `isDisabled` instead');
	            this.isDisabled = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TooltipDirective.prototype, "_appendToBody", {
	        get: function () {
	            Object(__WEBPACK_IMPORTED_MODULE_5__utils_warn_once__["a" /* warnOnce */])('tooltipAppendToBody was deprecated, please use `container="body"` instead');
	            return this.container === 'body';
	        },
	        /** @deprecated - please use `container="body"` instead */
	        set: function (value) {
	            Object(__WEBPACK_IMPORTED_MODULE_5__utils_warn_once__["a" /* warnOnce */])('tooltipAppendToBody was deprecated, please use `container="body"` instead');
	            this.container = value ? 'body' : this.container;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TooltipDirective.prototype, "_popupClass", {
	        /** @deprecated - will replaced with customClass */
	        set: function (value) {
	            Object(__WEBPACK_IMPORTED_MODULE_5__utils_warn_once__["a" /* warnOnce */])('tooltipClass deprecated');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TooltipDirective.prototype, "_tooltipContext", {
	        /** @deprecated - removed */
	        set: function (value) {
	            Object(__WEBPACK_IMPORTED_MODULE_5__utils_warn_once__["a" /* warnOnce */])('tooltipContext deprecated');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TooltipDirective.prototype, "_tooltipPopupDelay", {
	        /** @deprecated */
	        set: function (value) {
	            Object(__WEBPACK_IMPORTED_MODULE_5__utils_warn_once__["a" /* warnOnce */])('tooltipPopupDelay is deprecated, use `delay` instead');
	            this.delay = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TooltipDirective.prototype, "_tooltipTrigger", {
	        /** @deprecated -  please use `triggers` instead */
	        get: function () {
	            Object(__WEBPACK_IMPORTED_MODULE_5__utils_warn_once__["a" /* warnOnce */])('tooltipTrigger was deprecated, please use `triggers` instead');
	            return this.triggers;
	        },
	        set: function (value) {
	            Object(__WEBPACK_IMPORTED_MODULE_5__utils_warn_once__["a" /* warnOnce */])('tooltipTrigger was deprecated, please use `triggers` instead');
	            this.triggers = (value || '').toString();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TooltipDirective.prototype.ngOnInit = function () {
	        var _this = this;
	        this._tooltip.listen({
	            triggers: this.triggers,
	            show: function () { return _this.show(); }
	        });
	        this.tooltipChange.subscribe(function (value) {
	            if (!value) {
	                _this._tooltip.hide();
	            }
	        });
	    };
	    /**
	     * Toggles an element’s tooltip. This is considered a “manual” triggering of
	     * the tooltip.
	     */
	    TooltipDirective.prototype.toggle = function () {
	        if (this.isOpen) {
	            return this.hide();
	        }
	        this.show();
	    };
	    /**
	     * Opens an element’s tooltip. This is considered a “manual” triggering of
	     * the tooltip.
	     */
	    TooltipDirective.prototype.show = function () {
	        var _this = this;
	        if (this.isOpen ||
	            this.isDisabled ||
	            this._delayTimeoutId ||
	            !this.tooltip) {
	            return;
	        }
	        var showTooltip = function () {
	            if (_this._delayTimeoutId) {
	                _this._delayTimeoutId = undefined;
	            }
	            _this._tooltip
	                .attach(__WEBPACK_IMPORTED_MODULE_1__tooltip_container_component__["a" /* TooltipContainerComponent */])
	                .to(_this.container)
	                .position({ attachment: _this.placement })
	                .show({
	                content: _this.tooltip,
	                placement: _this.placement,
	                containerClass: _this.containerClass
	            });
	        };
	        var cancelDelayedTooltipShowing = function () {
	            if (_this._tooltipCancelShowFn) {
	                _this._tooltipCancelShowFn();
	            }
	        };
	        if (this.delay) {
	            var timer_1 = __WEBPACK_IMPORTED_MODULE_7_rxjs_Observable__["Observable"].timer(this.delay).subscribe(function () {
	                showTooltip();
	                cancelDelayedTooltipShowing();
	            });
	            if (this.triggers) {
	                var triggers = Object(__WEBPACK_IMPORTED_MODULE_6__utils_triggers__["b" /* parseTriggers */])(this.triggers);
	                this._tooltipCancelShowFn = this._renderer.listen(this._elementRef.nativeElement, triggers[0].close, function () {
	                    timer_1.unsubscribe();
	                    cancelDelayedTooltipShowing();
	                });
	            }
	        }
	        else {
	            showTooltip();
	        }
	    };
	    /**
	     * Closes an element’s tooltip. This is considered a “manual” triggering of
	     * the tooltip.
	     */
	    TooltipDirective.prototype.hide = function () {
	        var _this = this;
	        if (this._delayTimeoutId) {
	            clearTimeout(this._delayTimeoutId);
	            this._delayTimeoutId = undefined;
	        }
	        if (!this._tooltip.isShown) {
	            return;
	        }
	        this._tooltip.instance.classMap.in = false;
	        setTimeout(function () {
	            _this._tooltip.hide();
	        }, this._fadeDuration);
	    };
	    TooltipDirective.prototype.ngOnDestroy = function () {
	        this._tooltip.dispose();
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_4__utils_decorators__["a" /* OnChange */])(),
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], TooltipDirective.prototype, "tooltip", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
	    ], TooltipDirective.prototype, "tooltipChange", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], TooltipDirective.prototype, "placement", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], TooltipDirective.prototype, "triggers", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], TooltipDirective.prototype, "container", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean),
	        __metadata("design:paramtypes", [Boolean])
	    ], TooltipDirective.prototype, "isOpen", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], TooltipDirective.prototype, "isDisabled", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], TooltipDirective.prototype, "containerClass", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number)
	    ], TooltipDirective.prototype, "delay", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
	    ], TooltipDirective.prototype, "onShown", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _c || Object)
	    ], TooltipDirective.prototype, "onHidden", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('tooltipHtml'),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [Object])
	    ], TooltipDirective.prototype, "htmlContent", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('tooltipPlacement'),
	        __metadata("design:type", String),
	        __metadata("design:paramtypes", [String])
	    ], TooltipDirective.prototype, "_placement", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('tooltipIsOpen'),
	        __metadata("design:type", Boolean),
	        __metadata("design:paramtypes", [Boolean])
	    ], TooltipDirective.prototype, "_isOpen", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('tooltipEnable'),
	        __metadata("design:type", Boolean),
	        __metadata("design:paramtypes", [Boolean])
	    ], TooltipDirective.prototype, "_enable", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('tooltipAppendToBody'),
	        __metadata("design:type", Boolean),
	        __metadata("design:paramtypes", [Boolean])
	    ], TooltipDirective.prototype, "_appendToBody", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('tooltipAnimation'),
	        __metadata("design:type", Object)
	    ], TooltipDirective.prototype, "_animation", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('tooltipClass'),
	        __metadata("design:type", String),
	        __metadata("design:paramtypes", [String])
	    ], TooltipDirective.prototype, "_popupClass", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('tooltipContext'),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [Object])
	    ], TooltipDirective.prototype, "_tooltipContext", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('tooltipPopupDelay'),
	        __metadata("design:type", Number),
	        __metadata("design:paramtypes", [Number])
	    ], TooltipDirective.prototype, "_tooltipPopupDelay", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('tooltipFadeDuration'),
	        __metadata("design:type", Object)
	    ], TooltipDirective.prototype, "_fadeDuration", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])('tooltipTrigger'),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [Object])
	    ], TooltipDirective.prototype, "_tooltipTrigger", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _d || Object)
	    ], TooltipDirective.prototype, "tooltipStateChanged", void 0);
	    TooltipDirective = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
	            selector: '[tooltip], [tooltipHtml]',
	            exportAs: 'bs-tooltip'
	        }),
	        __metadata("design:paramtypes", [typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_3__component_loader_index__["b" /* ComponentLoaderFactory */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_3__component_loader_index__["b" /* ComponentLoaderFactory */]) === "function" && _h || Object, typeof (_j = typeof __WEBPACK_IMPORTED_MODULE_2__tooltip_config__["a" /* TooltipConfig */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__tooltip_config__["a" /* TooltipConfig */]) === "function" && _j || Object])
	    ], TooltipDirective);
	    return TooltipDirective;
	    var _k, _a, _b, _c, _l, _m, _d, _e, _f, _g, _h, _j;
	}());
	
	
	
	/***/ }),
	/* 135 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return latinMap; });
	/* tslint:disable */
	var latinMap = {
	    'Á': 'A',
	    'Ă': 'A',
	    'Ắ': 'A',
	    'Ặ': 'A',
	    'Ằ': 'A',
	    'Ẳ': 'A',
	    'Ẵ': 'A',
	    'Ǎ': 'A',
	    'Â': 'A',
	    'Ấ': 'A',
	    'Ậ': 'A',
	    'Ầ': 'A',
	    'Ẩ': 'A',
	    'Ẫ': 'A',
	    'Ä': 'A',
	    'Ǟ': 'A',
	    'Ȧ': 'A',
	    'Ǡ': 'A',
	    'Ạ': 'A',
	    'Ȁ': 'A',
	    'À': 'A',
	    'Ả': 'A',
	    'Ȃ': 'A',
	    'Ā': 'A',
	    'Ą': 'A',
	    'Å': 'A',
	    'Ǻ': 'A',
	    'Ḁ': 'A',
	    'Ⱥ': 'A',
	    'Ã': 'A',
	    'Ꜳ': 'AA',
	    'Æ': 'AE',
	    'Ǽ': 'AE',
	    'Ǣ': 'AE',
	    'Ꜵ': 'AO',
	    'Ꜷ': 'AU',
	    'Ꜹ': 'AV',
	    'Ꜻ': 'AV',
	    'Ꜽ': 'AY',
	    'Ḃ': 'B',
	    'Ḅ': 'B',
	    'Ɓ': 'B',
	    'Ḇ': 'B',
	    'Ƀ': 'B',
	    'Ƃ': 'B',
	    'Ć': 'C',
	    'Č': 'C',
	    'Ç': 'C',
	    'Ḉ': 'C',
	    'Ĉ': 'C',
	    'Ċ': 'C',
	    'Ƈ': 'C',
	    'Ȼ': 'C',
	    'Ď': 'D',
	    'Ḑ': 'D',
	    'Ḓ': 'D',
	    'Ḋ': 'D',
	    'Ḍ': 'D',
	    'Ɗ': 'D',
	    'Ḏ': 'D',
	    'ǲ': 'D',
	    'ǅ': 'D',
	    'Đ': 'D',
	    'Ƌ': 'D',
	    'Ǳ': 'DZ',
	    'Ǆ': 'DZ',
	    'É': 'E',
	    'Ĕ': 'E',
	    'Ě': 'E',
	    'Ȩ': 'E',
	    'Ḝ': 'E',
	    'Ê': 'E',
	    'Ế': 'E',
	    'Ệ': 'E',
	    'Ề': 'E',
	    'Ể': 'E',
	    'Ễ': 'E',
	    'Ḙ': 'E',
	    'Ë': 'E',
	    'Ė': 'E',
	    'Ẹ': 'E',
	    'Ȅ': 'E',
	    'È': 'E',
	    'Ẻ': 'E',
	    'Ȇ': 'E',
	    'Ē': 'E',
	    'Ḗ': 'E',
	    'Ḕ': 'E',
	    'Ę': 'E',
	    'Ɇ': 'E',
	    'Ẽ': 'E',
	    'Ḛ': 'E',
	    'Ꝫ': 'ET',
	    'Ḟ': 'F',
	    'Ƒ': 'F',
	    'Ǵ': 'G',
	    'Ğ': 'G',
	    'Ǧ': 'G',
	    'Ģ': 'G',
	    'Ĝ': 'G',
	    'Ġ': 'G',
	    'Ɠ': 'G',
	    'Ḡ': 'G',
	    'Ǥ': 'G',
	    'Ḫ': 'H',
	    'Ȟ': 'H',
	    'Ḩ': 'H',
	    'Ĥ': 'H',
	    'Ⱨ': 'H',
	    'Ḧ': 'H',
	    'Ḣ': 'H',
	    'Ḥ': 'H',
	    'Ħ': 'H',
	    'Í': 'I',
	    'Ĭ': 'I',
	    'Ǐ': 'I',
	    'Î': 'I',
	    'Ï': 'I',
	    'Ḯ': 'I',
	    'İ': 'I',
	    'Ị': 'I',
	    'Ȉ': 'I',
	    'Ì': 'I',
	    'Ỉ': 'I',
	    'Ȋ': 'I',
	    'Ī': 'I',
	    'Į': 'I',
	    'Ɨ': 'I',
	    'Ĩ': 'I',
	    'Ḭ': 'I',
	    'Ꝺ': 'D',
	    'Ꝼ': 'F',
	    'Ᵹ': 'G',
	    'Ꞃ': 'R',
	    'Ꞅ': 'S',
	    'Ꞇ': 'T',
	    'Ꝭ': 'IS',
	    'Ĵ': 'J',
	    'Ɉ': 'J',
	    'Ḱ': 'K',
	    'Ǩ': 'K',
	    'Ķ': 'K',
	    'Ⱪ': 'K',
	    'Ꝃ': 'K',
	    'Ḳ': 'K',
	    'Ƙ': 'K',
	    'Ḵ': 'K',
	    'Ꝁ': 'K',
	    'Ꝅ': 'K',
	    'Ĺ': 'L',
	    'Ƚ': 'L',
	    'Ľ': 'L',
	    'Ļ': 'L',
	    'Ḽ': 'L',
	    'Ḷ': 'L',
	    'Ḹ': 'L',
	    'Ⱡ': 'L',
	    'Ꝉ': 'L',
	    'Ḻ': 'L',
	    'Ŀ': 'L',
	    'Ɫ': 'L',
	    'ǈ': 'L',
	    'Ł': 'L',
	    'Ǉ': 'LJ',
	    'Ḿ': 'M',
	    'Ṁ': 'M',
	    'Ṃ': 'M',
	    'Ɱ': 'M',
	    'Ń': 'N',
	    'Ň': 'N',
	    'Ņ': 'N',
	    'Ṋ': 'N',
	    'Ṅ': 'N',
	    'Ṇ': 'N',
	    'Ǹ': 'N',
	    'Ɲ': 'N',
	    'Ṉ': 'N',
	    'Ƞ': 'N',
	    'ǋ': 'N',
	    'Ñ': 'N',
	    'Ǌ': 'NJ',
	    'Ó': 'O',
	    'Ŏ': 'O',
	    'Ǒ': 'O',
	    'Ô': 'O',
	    'Ố': 'O',
	    'Ộ': 'O',
	    'Ồ': 'O',
	    'Ổ': 'O',
	    'Ỗ': 'O',
	    'Ö': 'O',
	    'Ȫ': 'O',
	    'Ȯ': 'O',
	    'Ȱ': 'O',
	    'Ọ': 'O',
	    'Ő': 'O',
	    'Ȍ': 'O',
	    'Ò': 'O',
	    'Ỏ': 'O',
	    'Ơ': 'O',
	    'Ớ': 'O',
	    'Ợ': 'O',
	    'Ờ': 'O',
	    'Ở': 'O',
	    'Ỡ': 'O',
	    'Ȏ': 'O',
	    'Ꝋ': 'O',
	    'Ꝍ': 'O',
	    'Ō': 'O',
	    'Ṓ': 'O',
	    'Ṑ': 'O',
	    'Ɵ': 'O',
	    'Ǫ': 'O',
	    'Ǭ': 'O',
	    'Ø': 'O',
	    'Ǿ': 'O',
	    'Õ': 'O',
	    'Ṍ': 'O',
	    'Ṏ': 'O',
	    'Ȭ': 'O',
	    'Ƣ': 'OI',
	    'Ꝏ': 'OO',
	    'Ɛ': 'E',
	    'Ɔ': 'O',
	    'Ȣ': 'OU',
	    'Ṕ': 'P',
	    'Ṗ': 'P',
	    'Ꝓ': 'P',
	    'Ƥ': 'P',
	    'Ꝕ': 'P',
	    'Ᵽ': 'P',
	    'Ꝑ': 'P',
	    'Ꝙ': 'Q',
	    'Ꝗ': 'Q',
	    'Ŕ': 'R',
	    'Ř': 'R',
	    'Ŗ': 'R',
	    'Ṙ': 'R',
	    'Ṛ': 'R',
	    'Ṝ': 'R',
	    'Ȑ': 'R',
	    'Ȓ': 'R',
	    'Ṟ': 'R',
	    'Ɍ': 'R',
	    'Ɽ': 'R',
	    'Ꜿ': 'C',
	    'Ǝ': 'E',
	    'Ś': 'S',
	    'Ṥ': 'S',
	    'Š': 'S',
	    'Ṧ': 'S',
	    'Ş': 'S',
	    'Ŝ': 'S',
	    'Ș': 'S',
	    'Ṡ': 'S',
	    'Ṣ': 'S',
	    'Ṩ': 'S',
	    'Ť': 'T',
	    'Ţ': 'T',
	    'Ṱ': 'T',
	    'Ț': 'T',
	    'Ⱦ': 'T',
	    'Ṫ': 'T',
	    'Ṭ': 'T',
	    'Ƭ': 'T',
	    'Ṯ': 'T',
	    'Ʈ': 'T',
	    'Ŧ': 'T',
	    'Ɐ': 'A',
	    'Ꞁ': 'L',
	    'Ɯ': 'M',
	    'Ʌ': 'V',
	    'Ꜩ': 'TZ',
	    'Ú': 'U',
	    'Ŭ': 'U',
	    'Ǔ': 'U',
	    'Û': 'U',
	    'Ṷ': 'U',
	    'Ü': 'U',
	    'Ǘ': 'U',
	    'Ǚ': 'U',
	    'Ǜ': 'U',
	    'Ǖ': 'U',
	    'Ṳ': 'U',
	    'Ụ': 'U',
	    'Ű': 'U',
	    'Ȕ': 'U',
	    'Ù': 'U',
	    'Ủ': 'U',
	    'Ư': 'U',
	    'Ứ': 'U',
	    'Ự': 'U',
	    'Ừ': 'U',
	    'Ử': 'U',
	    'Ữ': 'U',
	    'Ȗ': 'U',
	    'Ū': 'U',
	    'Ṻ': 'U',
	    'Ų': 'U',
	    'Ů': 'U',
	    'Ũ': 'U',
	    'Ṹ': 'U',
	    'Ṵ': 'U',
	    'Ꝟ': 'V',
	    'Ṿ': 'V',
	    'Ʋ': 'V',
	    'Ṽ': 'V',
	    'Ꝡ': 'VY',
	    'Ẃ': 'W',
	    'Ŵ': 'W',
	    'Ẅ': 'W',
	    'Ẇ': 'W',
	    'Ẉ': 'W',
	    'Ẁ': 'W',
	    'Ⱳ': 'W',
	    'Ẍ': 'X',
	    'Ẋ': 'X',
	    'Ý': 'Y',
	    'Ŷ': 'Y',
	    'Ÿ': 'Y',
	    'Ẏ': 'Y',
	    'Ỵ': 'Y',
	    'Ỳ': 'Y',
	    'Ƴ': 'Y',
	    'Ỷ': 'Y',
	    'Ỿ': 'Y',
	    'Ȳ': 'Y',
	    'Ɏ': 'Y',
	    'Ỹ': 'Y',
	    'Ź': 'Z',
	    'Ž': 'Z',
	    'Ẑ': 'Z',
	    'Ⱬ': 'Z',
	    'Ż': 'Z',
	    'Ẓ': 'Z',
	    'Ȥ': 'Z',
	    'Ẕ': 'Z',
	    'Ƶ': 'Z',
	    'Ĳ': 'IJ',
	    'Œ': 'OE',
	    'ᴀ': 'A',
	    'ᴁ': 'AE',
	    'ʙ': 'B',
	    'ᴃ': 'B',
	    'ᴄ': 'C',
	    'ᴅ': 'D',
	    'ᴇ': 'E',
	    'ꜰ': 'F',
	    'ɢ': 'G',
	    'ʛ': 'G',
	    'ʜ': 'H',
	    'ɪ': 'I',
	    'ʁ': 'R',
	    'ᴊ': 'J',
	    'ᴋ': 'K',
	    'ʟ': 'L',
	    'ᴌ': 'L',
	    'ᴍ': 'M',
	    'ɴ': 'N',
	    'ᴏ': 'O',
	    'ɶ': 'OE',
	    'ᴐ': 'O',
	    'ᴕ': 'OU',
	    'ᴘ': 'P',
	    'ʀ': 'R',
	    'ᴎ': 'N',
	    'ᴙ': 'R',
	    'ꜱ': 'S',
	    'ᴛ': 'T',
	    'ⱻ': 'E',
	    'ᴚ': 'R',
	    'ᴜ': 'U',
	    'ᴠ': 'V',
	    'ᴡ': 'W',
	    'ʏ': 'Y',
	    'ᴢ': 'Z',
	    'á': 'a',
	    'ă': 'a',
	    'ắ': 'a',
	    'ặ': 'a',
	    'ằ': 'a',
	    'ẳ': 'a',
	    'ẵ': 'a',
	    'ǎ': 'a',
	    'â': 'a',
	    'ấ': 'a',
	    'ậ': 'a',
	    'ầ': 'a',
	    'ẩ': 'a',
	    'ẫ': 'a',
	    'ä': 'a',
	    'ǟ': 'a',
	    'ȧ': 'a',
	    'ǡ': 'a',
	    'ạ': 'a',
	    'ȁ': 'a',
	    'à': 'a',
	    'ả': 'a',
	    'ȃ': 'a',
	    'ā': 'a',
	    'ą': 'a',
	    'ᶏ': 'a',
	    'ẚ': 'a',
	    'å': 'a',
	    'ǻ': 'a',
	    'ḁ': 'a',
	    'ⱥ': 'a',
	    'ã': 'a',
	    'ꜳ': 'aa',
	    'æ': 'ae',
	    'ǽ': 'ae',
	    'ǣ': 'ae',
	    'ꜵ': 'ao',
	    'ꜷ': 'au',
	    'ꜹ': 'av',
	    'ꜻ': 'av',
	    'ꜽ': 'ay',
	    'ḃ': 'b',
	    'ḅ': 'b',
	    'ɓ': 'b',
	    'ḇ': 'b',
	    'ᵬ': 'b',
	    'ᶀ': 'b',
	    'ƀ': 'b',
	    'ƃ': 'b',
	    'ɵ': 'o',
	    'ć': 'c',
	    'č': 'c',
	    'ç': 'c',
	    'ḉ': 'c',
	    'ĉ': 'c',
	    'ɕ': 'c',
	    'ċ': 'c',
	    'ƈ': 'c',
	    'ȼ': 'c',
	    'ď': 'd',
	    'ḑ': 'd',
	    'ḓ': 'd',
	    'ȡ': 'd',
	    'ḋ': 'd',
	    'ḍ': 'd',
	    'ɗ': 'd',
	    'ᶑ': 'd',
	    'ḏ': 'd',
	    'ᵭ': 'd',
	    'ᶁ': 'd',
	    'đ': 'd',
	    'ɖ': 'd',
	    'ƌ': 'd',
	    'ı': 'i',
	    'ȷ': 'j',
	    'ɟ': 'j',
	    'ʄ': 'j',
	    'ǳ': 'dz',
	    'ǆ': 'dz',
	    'é': 'e',
	    'ĕ': 'e',
	    'ě': 'e',
	    'ȩ': 'e',
	    'ḝ': 'e',
	    'ê': 'e',
	    'ế': 'e',
	    'ệ': 'e',
	    'ề': 'e',
	    'ể': 'e',
	    'ễ': 'e',
	    'ḙ': 'e',
	    'ë': 'e',
	    'ė': 'e',
	    'ẹ': 'e',
	    'ȅ': 'e',
	    'è': 'e',
	    'ẻ': 'e',
	    'ȇ': 'e',
	    'ē': 'e',
	    'ḗ': 'e',
	    'ḕ': 'e',
	    'ⱸ': 'e',
	    'ę': 'e',
	    'ᶒ': 'e',
	    'ɇ': 'e',
	    'ẽ': 'e',
	    'ḛ': 'e',
	    'ꝫ': 'et',
	    'ḟ': 'f',
	    'ƒ': 'f',
	    'ᵮ': 'f',
	    'ᶂ': 'f',
	    'ǵ': 'g',
	    'ğ': 'g',
	    'ǧ': 'g',
	    'ģ': 'g',
	    'ĝ': 'g',
	    'ġ': 'g',
	    'ɠ': 'g',
	    'ḡ': 'g',
	    'ᶃ': 'g',
	    'ǥ': 'g',
	    'ḫ': 'h',
	    'ȟ': 'h',
	    'ḩ': 'h',
	    'ĥ': 'h',
	    'ⱨ': 'h',
	    'ḧ': 'h',
	    'ḣ': 'h',
	    'ḥ': 'h',
	    'ɦ': 'h',
	    'ẖ': 'h',
	    'ħ': 'h',
	    'ƕ': 'hv',
	    'í': 'i',
	    'ĭ': 'i',
	    'ǐ': 'i',
	    'î': 'i',
	    'ï': 'i',
	    'ḯ': 'i',
	    'ị': 'i',
	    'ȉ': 'i',
	    'ì': 'i',
	    'ỉ': 'i',
	    'ȋ': 'i',
	    'ī': 'i',
	    'į': 'i',
	    'ᶖ': 'i',
	    'ɨ': 'i',
	    'ĩ': 'i',
	    'ḭ': 'i',
	    'ꝺ': 'd',
	    'ꝼ': 'f',
	    'ᵹ': 'g',
	    'ꞃ': 'r',
	    'ꞅ': 's',
	    'ꞇ': 't',
	    'ꝭ': 'is',
	    'ǰ': 'j',
	    'ĵ': 'j',
	    'ʝ': 'j',
	    'ɉ': 'j',
	    'ḱ': 'k',
	    'ǩ': 'k',
	    'ķ': 'k',
	    'ⱪ': 'k',
	    'ꝃ': 'k',
	    'ḳ': 'k',
	    'ƙ': 'k',
	    'ḵ': 'k',
	    'ᶄ': 'k',
	    'ꝁ': 'k',
	    'ꝅ': 'k',
	    'ĺ': 'l',
	    'ƚ': 'l',
	    'ɬ': 'l',
	    'ľ': 'l',
	    'ļ': 'l',
	    'ḽ': 'l',
	    'ȴ': 'l',
	    'ḷ': 'l',
	    'ḹ': 'l',
	    'ⱡ': 'l',
	    'ꝉ': 'l',
	    'ḻ': 'l',
	    'ŀ': 'l',
	    'ɫ': 'l',
	    'ᶅ': 'l',
	    'ɭ': 'l',
	    'ł': 'l',
	    'ǉ': 'lj',
	    'ſ': 's',
	    'ẜ': 's',
	    'ẛ': 's',
	    'ẝ': 's',
	    'ḿ': 'm',
	    'ṁ': 'm',
	    'ṃ': 'm',
	    'ɱ': 'm',
	    'ᵯ': 'm',
	    'ᶆ': 'm',
	    'ń': 'n',
	    'ň': 'n',
	    'ņ': 'n',
	    'ṋ': 'n',
	    'ȵ': 'n',
	    'ṅ': 'n',
	    'ṇ': 'n',
	    'ǹ': 'n',
	    'ɲ': 'n',
	    'ṉ': 'n',
	    'ƞ': 'n',
	    'ᵰ': 'n',
	    'ᶇ': 'n',
	    'ɳ': 'n',
	    'ñ': 'n',
	    'ǌ': 'nj',
	    'ó': 'o',
	    'ŏ': 'o',
	    'ǒ': 'o',
	    'ô': 'o',
	    'ố': 'o',
	    'ộ': 'o',
	    'ồ': 'o',
	    'ổ': 'o',
	    'ỗ': 'o',
	    'ö': 'o',
	    'ȫ': 'o',
	    'ȯ': 'o',
	    'ȱ': 'o',
	    'ọ': 'o',
	    'ő': 'o',
	    'ȍ': 'o',
	    'ò': 'o',
	    'ỏ': 'o',
	    'ơ': 'o',
	    'ớ': 'o',
	    'ợ': 'o',
	    'ờ': 'o',
	    'ở': 'o',
	    'ỡ': 'o',
	    'ȏ': 'o',
	    'ꝋ': 'o',
	    'ꝍ': 'o',
	    'ⱺ': 'o',
	    'ō': 'o',
	    'ṓ': 'o',
	    'ṑ': 'o',
	    'ǫ': 'o',
	    'ǭ': 'o',
	    'ø': 'o',
	    'ǿ': 'o',
	    'õ': 'o',
	    'ṍ': 'o',
	    'ṏ': 'o',
	    'ȭ': 'o',
	    'ƣ': 'oi',
	    'ꝏ': 'oo',
	    'ɛ': 'e',
	    'ᶓ': 'e',
	    'ɔ': 'o',
	    'ᶗ': 'o',
	    'ȣ': 'ou',
	    'ṕ': 'p',
	    'ṗ': 'p',
	    'ꝓ': 'p',
	    'ƥ': 'p',
	    'ᵱ': 'p',
	    'ᶈ': 'p',
	    'ꝕ': 'p',
	    'ᵽ': 'p',
	    'ꝑ': 'p',
	    'ꝙ': 'q',
	    'ʠ': 'q',
	    'ɋ': 'q',
	    'ꝗ': 'q',
	    'ŕ': 'r',
	    'ř': 'r',
	    'ŗ': 'r',
	    'ṙ': 'r',
	    'ṛ': 'r',
	    'ṝ': 'r',
	    'ȑ': 'r',
	    'ɾ': 'r',
	    'ᵳ': 'r',
	    'ȓ': 'r',
	    'ṟ': 'r',
	    'ɼ': 'r',
	    'ᵲ': 'r',
	    'ᶉ': 'r',
	    'ɍ': 'r',
	    'ɽ': 'r',
	    'ↄ': 'c',
	    'ꜿ': 'c',
	    'ɘ': 'e',
	    'ɿ': 'r',
	    'ś': 's',
	    'ṥ': 's',
	    'š': 's',
	    'ṧ': 's',
	    'ş': 's',
	    'ŝ': 's',
	    'ș': 's',
	    'ṡ': 's',
	    'ṣ': 's',
	    'ṩ': 's',
	    'ʂ': 's',
	    'ᵴ': 's',
	    'ᶊ': 's',
	    'ȿ': 's',
	    'ɡ': 'g',
	    'ᴑ': 'o',
	    'ᴓ': 'o',
	    'ᴝ': 'u',
	    'ť': 't',
	    'ţ': 't',
	    'ṱ': 't',
	    'ț': 't',
	    'ȶ': 't',
	    'ẗ': 't',
	    'ⱦ': 't',
	    'ṫ': 't',
	    'ṭ': 't',
	    'ƭ': 't',
	    'ṯ': 't',
	    'ᵵ': 't',
	    'ƫ': 't',
	    'ʈ': 't',
	    'ŧ': 't',
	    'ᵺ': 'th',
	    'ɐ': 'a',
	    'ᴂ': 'ae',
	    'ǝ': 'e',
	    'ᵷ': 'g',
	    'ɥ': 'h',
	    'ʮ': 'h',
	    'ʯ': 'h',
	    'ᴉ': 'i',
	    'ʞ': 'k',
	    'ꞁ': 'l',
	    'ɯ': 'm',
	    'ɰ': 'm',
	    'ᴔ': 'oe',
	    'ɹ': 'r',
	    'ɻ': 'r',
	    'ɺ': 'r',
	    'ⱹ': 'r',
	    'ʇ': 't',
	    'ʌ': 'v',
	    'ʍ': 'w',
	    'ʎ': 'y',
	    'ꜩ': 'tz',
	    'ú': 'u',
	    'ŭ': 'u',
	    'ǔ': 'u',
	    'û': 'u',
	    'ṷ': 'u',
	    'ü': 'u',
	    'ǘ': 'u',
	    'ǚ': 'u',
	    'ǜ': 'u',
	    'ǖ': 'u',
	    'ṳ': 'u',
	    'ụ': 'u',
	    'ű': 'u',
	    'ȕ': 'u',
	    'ù': 'u',
	    'ủ': 'u',
	    'ư': 'u',
	    'ứ': 'u',
	    'ự': 'u',
	    'ừ': 'u',
	    'ử': 'u',
	    'ữ': 'u',
	    'ȗ': 'u',
	    'ū': 'u',
	    'ṻ': 'u',
	    'ų': 'u',
	    'ᶙ': 'u',
	    'ů': 'u',
	    'ũ': 'u',
	    'ṹ': 'u',
	    'ṵ': 'u',
	    'ᵫ': 'ue',
	    'ꝸ': 'um',
	    'ⱴ': 'v',
	    'ꝟ': 'v',
	    'ṿ': 'v',
	    'ʋ': 'v',
	    'ᶌ': 'v',
	    'ⱱ': 'v',
	    'ṽ': 'v',
	    'ꝡ': 'vy',
	    'ẃ': 'w',
	    'ŵ': 'w',
	    'ẅ': 'w',
	    'ẇ': 'w',
	    'ẉ': 'w',
	    'ẁ': 'w',
	    'ⱳ': 'w',
	    'ẘ': 'w',
	    'ẍ': 'x',
	    'ẋ': 'x',
	    'ᶍ': 'x',
	    'ý': 'y',
	    'ŷ': 'y',
	    'ÿ': 'y',
	    'ẏ': 'y',
	    'ỵ': 'y',
	    'ỳ': 'y',
	    'ƴ': 'y',
	    'ỷ': 'y',
	    'ỿ': 'y',
	    'ȳ': 'y',
	    'ẙ': 'y',
	    'ɏ': 'y',
	    'ỹ': 'y',
	    'ź': 'z',
	    'ž': 'z',
	    'ẑ': 'z',
	    'ʑ': 'z',
	    'ⱬ': 'z',
	    'ż': 'z',
	    'ẓ': 'z',
	    'ȥ': 'z',
	    'ẕ': 'z',
	    'ᵶ': 'z',
	    'ᶎ': 'z',
	    'ʐ': 'z',
	    'ƶ': 'z',
	    'ɀ': 'z',
	    'ﬀ': 'ff',
	    'ﬃ': 'ffi',
	    'ﬄ': 'ffl',
	    'ﬁ': 'fi',
	    'ﬂ': 'fl',
	    'ĳ': 'ij',
	    'œ': 'oe',
	    'ﬆ': 'st',
	    'ₐ': 'a',
	    'ₑ': 'e',
	    'ᵢ': 'i',
	    'ⱼ': 'j',
	    'ₒ': 'o',
	    'ᵣ': 'r',
	    'ᵤ': 'u',
	    'ᵥ': 'v',
	    'ₓ': 'x'
	};
	
	
	/***/ }),
	/* 136 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TypeaheadMatch; });
	var TypeaheadMatch = (function () {
	    function TypeaheadMatch(item, value, header) {
	        if (value === void 0) { value = item; }
	        if (header === void 0) { header = false; }
	        this.item = item;
	        this.value = value;
	        this.header = header;
	    }
	    TypeaheadMatch.prototype.isHeader = function () {
	        return this.header;
	    };
	    TypeaheadMatch.prototype.toString = function () {
	        return this.value;
	    };
	    return TypeaheadMatch;
	}());
	
	
	
	/***/ }),
	/* 137 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TypeaheadDirective; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_forms__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_from__ = __webpack_require__(225);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_from__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_debounceTime__ = __webpack_require__(226);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_debounceTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_debounceTime__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_filter__ = __webpack_require__(37);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_filter__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_map__ = __webpack_require__(113);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_map__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_switchMap__ = __webpack_require__(227);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_switchMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_switchMap__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_mergeMap__ = __webpack_require__(228);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_mergeMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_mergeMap__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_toArray__ = __webpack_require__(229);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_toArray__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_Observable__ = __webpack_require__(66);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_Observable__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component_loader_index__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__typeahead_container_component__ = __webpack_require__(83);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__typeahead_match_class__ = __webpack_require__(136);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__typeahead_utils__ = __webpack_require__(82);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	/* tslint:disable:max-file-line-count */
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var TypeaheadDirective = (function () {
	    function TypeaheadDirective(ngControl, element, viewContainerRef, renderer, cis, changeDetection) {
	        this.ngControl = ngControl;
	        this.element = element;
	        this.renderer = renderer;
	        this.changeDetection = changeDetection;
	        /** minimal no of characters that needs to be entered before
	         * typeahead kicks-in. When set to 0, typeahead shows on focus with full
	         * list of options (limited as normal by typeaheadOptionsLimit)
	         */
	        this.typeaheadMinLength = void 0;
	        /** should be used only in case of typeahead attribute is array.
	         * If true - loading of options will be async, otherwise - sync.
	         * true make sense if options array is large.
	         */
	        this.typeaheadAsync = void 0;
	        /** match latin symbols.
	         * If true the word súper would match super and vice versa.
	         */
	        this.typeaheadLatinize = true;
	        /** Can be use to search words by inserting a single white space between each characters
	         *  for example 'C a l i f o r n i a' will match 'California'.
	         */
	        this.typeaheadSingleWords = true;
	        /** should be used only in case typeaheadSingleWords attribute is true.
	         * Sets the word delimiter to break words. Defaults to space.
	         */
	        this.typeaheadWordDelimiters = ' ';
	        /** should be used only in case typeaheadSingleWords attribute is true.
	         * Sets the word delimiter to match exact phrase.
	         * Defaults to simple and double quotes.
	         */
	        this.typeaheadPhraseDelimiters = '\'"';
	        /** specifies if typeahead is scrollable  */
	        this.typeaheadScrollable = false;
	        /** specifies number of options to show in scroll view  */
	        this.typeaheadOptionsInScrollableView = 5;
	        /** fired when 'busy' state of this component was changed,
	         * fired on async mode only, returns boolean
	         */
	        this.typeaheadLoading = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        /** fired on every key event and returns true
	         * in case of matches are not detected
	         */
	        this.typeaheadNoResults = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        /** fired when option was selected, return object with data of this option */
	        this.typeaheadOnSelect = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        /** fired when blur event occurres. returns the active item */
	        this.typeaheadOnBlur = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        /** This attribute indicates that the dropdown should be opened upwards */
	        this.dropup = false;
	        this.isTypeaheadOptionsListActive = false;
	        this.keyUpEventEmitter = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.placement = 'bottom-left';
	        this._subscriptions = [];
	        this._typeahead = cis.createLoader(element, viewContainerRef, renderer);
	    }
	    TypeaheadDirective.prototype.ngOnInit = function () {
	        this.typeaheadOptionsLimit = this.typeaheadOptionsLimit || 20;
	        this.typeaheadMinLength =
	            this.typeaheadMinLength === void 0 ? 1 : this.typeaheadMinLength;
	        this.typeaheadWaitMs = this.typeaheadWaitMs || 0;
	        // async should be false in case of array
	        if (this.typeaheadAsync === undefined &&
	            !(this.typeahead instanceof __WEBPACK_IMPORTED_MODULE_9_rxjs_Observable__["Observable"])) {
	            this.typeaheadAsync = false;
	        }
	        if (this.typeahead instanceof __WEBPACK_IMPORTED_MODULE_9_rxjs_Observable__["Observable"]) {
	            this.typeaheadAsync = true;
	        }
	        if (this.typeaheadAsync) {
	            this.asyncActions();
	        }
	        else {
	            this.syncActions();
	        }
	    };
	    TypeaheadDirective.prototype.onInput = function (e) {
	        // For `<input>`s, use the `value` property. For others that don't have a
	        // `value` (such as `<span contenteditable="true">`), use either
	        // `textContent` or `innerText` (depending on which one is supported, i.e.
	        // Firefox or IE).
	        var value = e.target.value !== undefined
	            ? e.target.value
	            : e.target.textContent !== undefined
	                ? e.target.textContent
	                : e.target.innerText;
	        if (value != null && value.trim().length >= this.typeaheadMinLength) {
	            this.typeaheadLoading.emit(true);
	            this.keyUpEventEmitter.emit(e.target.value);
	        }
	        else {
	            this.typeaheadLoading.emit(false);
	            this.typeaheadNoResults.emit(false);
	            this.hide();
	        }
	    };
	    TypeaheadDirective.prototype.onChange = function (e) {
	        if (this._container) {
	            // esc
	            if (e.keyCode === 27) {
	                this.hide();
	                return;
	            }
	            // up
	            if (e.keyCode === 38) {
	                this._container.prevActiveMatch();
	                return;
	            }
	            // down
	            if (e.keyCode === 40) {
	                this._container.nextActiveMatch();
	                return;
	            }
	            // enter, tab
	            if (e.keyCode === 13) {
	                this._container.selectActiveMatch();
	                return;
	            }
	        }
	    };
	    TypeaheadDirective.prototype.onFocus = function () {
	        if (this.typeaheadMinLength === 0) {
	            this.typeaheadLoading.emit(true);
	            this.keyUpEventEmitter.emit(this.element.nativeElement.value || '');
	        }
	    };
	    TypeaheadDirective.prototype.onBlur = function () {
	        if (this._container && !this._container.isFocused) {
	            this.typeaheadOnBlur.emit(this._container.active);
	        }
	    };
	    TypeaheadDirective.prototype.onKeydown = function (e) {
	        // no container - no problems
	        if (!this._container) {
	            return;
	        }
	        // if an item is visible - prevent form submission
	        if (e.keyCode === 13) {
	            e.preventDefault();
	            return;
	        }
	        // if an item is visible - don't change focus
	        if (e.keyCode === 9) {
	            e.preventDefault();
	            this._container.selectActiveMatch();
	            return;
	        }
	    };
	    TypeaheadDirective.prototype.changeModel = function (match) {
	        var valueStr = match.value;
	        this.ngControl.viewToModelUpdate(valueStr);
	        (this.ngControl.control).setValue(valueStr);
	        this.changeDetection.markForCheck();
	        this.hide();
	    };
	    Object.defineProperty(TypeaheadDirective.prototype, "matches", {
	        get: function () {
	            return this._matches;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TypeaheadDirective.prototype.show = function () {
	        var _this = this;
	        this._typeahead
	            .attach(__WEBPACK_IMPORTED_MODULE_11__typeahead_container_component__["a" /* TypeaheadContainerComponent */])
	            .to(this.container)
	            .position({ attachment: (this.dropup ? 'top' : 'bottom') + " left" })
	            .show({
	            typeaheadRef: this,
	            placement: this.placement,
	            animation: false,
	            dropup: this.dropup
	        });
	        this._outsideClickListener = this.renderer.listen('document', 'click', function (e) {
	            if (_this.typeaheadMinLength === 0 && _this.element.nativeElement.contains(e.target)) {
	                return;
	            }
	            _this.onOutsideClick();
	        });
	        this._container = this._typeahead.instance;
	        this._container.parent = this;
	        // This improves the speed as it won't have to be done for each list item
	        var normalizedQuery = (this.typeaheadLatinize
	            ? Object(__WEBPACK_IMPORTED_MODULE_13__typeahead_utils__["b" /* latinize */])(this.ngControl.control.value)
	            : this.ngControl.control.value)
	            .toString()
	            .toLowerCase();
	        this._container.query = this.typeaheadSingleWords
	            ? Object(__WEBPACK_IMPORTED_MODULE_13__typeahead_utils__["c" /* tokenize */])(normalizedQuery, this.typeaheadWordDelimiters, this.typeaheadPhraseDelimiters)
	            : normalizedQuery;
	        this._container.matches = this._matches;
	        this.element.nativeElement.focus();
	    };
	    TypeaheadDirective.prototype.hide = function () {
	        if (this._typeahead.isShown) {
	            this._typeahead.hide();
	            this._outsideClickListener();
	            this._container = null;
	        }
	    };
	    TypeaheadDirective.prototype.onOutsideClick = function () {
	        if (this._container && !this._container.isFocused) {
	            this.hide();
	        }
	    };
	    TypeaheadDirective.prototype.ngOnDestroy = function () {
	        // clean up subscriptions
	        for (var _i = 0, _a = this._subscriptions; _i < _a.length; _i++) {
	            var sub = _a[_i];
	            sub.unsubscribe();
	        }
	        this._typeahead.dispose();
	    };
	    TypeaheadDirective.prototype.asyncActions = function () {
	        var _this = this;
	        this._subscriptions.push(this.keyUpEventEmitter
	            .debounceTime(this.typeaheadWaitMs)
	            .switchMap(function () { return _this.typeahead; })
	            .subscribe(function (matches) {
	            _this.finalizeAsyncCall(matches);
	        }));
	    };
	    TypeaheadDirective.prototype.syncActions = function () {
	        var _this = this;
	        this._subscriptions.push(this.keyUpEventEmitter
	            .debounceTime(this.typeaheadWaitMs)
	            .mergeMap(function (value) {
	            var normalizedQuery = _this.normalizeQuery(value);
	            return __WEBPACK_IMPORTED_MODULE_9_rxjs_Observable__["Observable"].from(_this.typeahead)
	                .filter(function (option) {
	                return (option &&
	                    _this.testMatch(_this.normalizeOption(option), normalizedQuery));
	            })
	                .toArray();
	        })
	            .subscribe(function (matches) {
	            _this.finalizeAsyncCall(matches);
	        }));
	    };
	    TypeaheadDirective.prototype.normalizeOption = function (option) {
	        var optionValue = Object(__WEBPACK_IMPORTED_MODULE_13__typeahead_utils__["a" /* getValueFromObject */])(option, this.typeaheadOptionField);
	        var normalizedOption = this.typeaheadLatinize
	            ? Object(__WEBPACK_IMPORTED_MODULE_13__typeahead_utils__["b" /* latinize */])(optionValue)
	            : optionValue;
	        return normalizedOption.toLowerCase();
	    };
	    TypeaheadDirective.prototype.normalizeQuery = function (value) {
	        // If singleWords, break model here to not be doing extra work on each
	        // iteration
	        var normalizedQuery = (this.typeaheadLatinize
	            ? Object(__WEBPACK_IMPORTED_MODULE_13__typeahead_utils__["b" /* latinize */])(value)
	            : value)
	            .toString()
	            .toLowerCase();
	        normalizedQuery = this.typeaheadSingleWords
	            ? Object(__WEBPACK_IMPORTED_MODULE_13__typeahead_utils__["c" /* tokenize */])(normalizedQuery, this.typeaheadWordDelimiters, this.typeaheadPhraseDelimiters)
	            : normalizedQuery;
	        return normalizedQuery;
	    };
	    TypeaheadDirective.prototype.testMatch = function (match, test) {
	        var spaceLength;
	        if (typeof test === 'object') {
	            spaceLength = test.length;
	            for (var i = 0; i < spaceLength; i += 1) {
	                if (test[i].length > 0 && match.indexOf(test[i]) < 0) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        return match.indexOf(test) >= 0;
	    };
	    TypeaheadDirective.prototype.finalizeAsyncCall = function (matches) {
	        this.prepareMatches(matches);
	        this.typeaheadLoading.emit(false);
	        this.typeaheadNoResults.emit(!this.hasMatches());
	        if (!this.hasMatches()) {
	            this.hide();
	            return;
	        }
	        if (this._container) {
	            // This improves the speed as it won't have to be done for each list item
	            var normalizedQuery = (this.typeaheadLatinize
	                ? Object(__WEBPACK_IMPORTED_MODULE_13__typeahead_utils__["b" /* latinize */])(this.ngControl.control.value)
	                : this.ngControl.control.value)
	                .toString()
	                .toLowerCase();
	            this._container.query = this.typeaheadSingleWords
	                ? Object(__WEBPACK_IMPORTED_MODULE_13__typeahead_utils__["c" /* tokenize */])(normalizedQuery, this.typeaheadWordDelimiters, this.typeaheadPhraseDelimiters)
	                : normalizedQuery;
	            this._container.matches = this._matches;
	        }
	        else {
	            this.show();
	        }
	    };
	    TypeaheadDirective.prototype.prepareMatches = function (options) {
	        var _this = this;
	        var limited = options.slice(0, this.typeaheadOptionsLimit);
	        if (this.typeaheadGroupField) {
	            var matches_1 = [];
	            // extract all group names
	            var groups = limited
	                .map(function (option) {
	                return Object(__WEBPACK_IMPORTED_MODULE_13__typeahead_utils__["a" /* getValueFromObject */])(option, _this.typeaheadGroupField);
	            })
	                .filter(function (v, i, a) { return a.indexOf(v) === i; });
	            groups.forEach(function (group) {
	                // add group header to array of matches
	                matches_1.push(new __WEBPACK_IMPORTED_MODULE_12__typeahead_match_class__["a" /* TypeaheadMatch */](group, group, true));
	                // add each item of group to array of matches
	                matches_1 = matches_1.concat(limited
	                    .filter(function (option) {
	                    return Object(__WEBPACK_IMPORTED_MODULE_13__typeahead_utils__["a" /* getValueFromObject */])(option, _this.typeaheadGroupField) === group;
	                })
	                    .map(function (option) {
	                    return new __WEBPACK_IMPORTED_MODULE_12__typeahead_match_class__["a" /* TypeaheadMatch */](option, Object(__WEBPACK_IMPORTED_MODULE_13__typeahead_utils__["a" /* getValueFromObject */])(option, _this.typeaheadOptionField));
	                }));
	            });
	            this._matches = matches_1;
	        }
	        else {
	            this._matches = limited.map(function (option) {
	                return new __WEBPACK_IMPORTED_MODULE_12__typeahead_match_class__["a" /* TypeaheadMatch */](option, Object(__WEBPACK_IMPORTED_MODULE_13__typeahead_utils__["a" /* getValueFromObject */])(option, _this.typeaheadOptionField));
	            });
	        }
	    };
	    TypeaheadDirective.prototype.hasMatches = function () {
	        return this._matches.length > 0;
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], TypeaheadDirective.prototype, "typeahead", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number)
	    ], TypeaheadDirective.prototype, "typeaheadMinLength", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number)
	    ], TypeaheadDirective.prototype, "typeaheadWaitMs", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Number)
	    ], TypeaheadDirective.prototype, "typeaheadOptionsLimit", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], TypeaheadDirective.prototype, "typeaheadOptionField", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], TypeaheadDirective.prototype, "typeaheadGroupField", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], TypeaheadDirective.prototype, "typeaheadAsync", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], TypeaheadDirective.prototype, "typeaheadLatinize", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], TypeaheadDirective.prototype, "typeaheadSingleWords", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], TypeaheadDirective.prototype, "typeaheadWordDelimiters", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], TypeaheadDirective.prototype, "typeaheadPhraseDelimiters", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]) === "function" && _a || Object)
	    ], TypeaheadDirective.prototype, "typeaheadItemTemplate", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]) === "function" && _b || Object)
	    ], TypeaheadDirective.prototype, "optionsListTemplate", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], TypeaheadDirective.prototype, "typeaheadScrollable", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], TypeaheadDirective.prototype, "typeaheadOptionsInScrollableView", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], TypeaheadDirective.prototype, "typeaheadLoading", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], TypeaheadDirective.prototype, "typeaheadNoResults", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], TypeaheadDirective.prototype, "typeaheadOnSelect", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], TypeaheadDirective.prototype, "typeaheadOnBlur", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], TypeaheadDirective.prototype, "container", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], TypeaheadDirective.prototype, "dropup", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('input', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], TypeaheadDirective.prototype, "onInput", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('keyup', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], TypeaheadDirective.prototype, "onChange", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('click'),
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('focus'),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], TypeaheadDirective.prototype, "onFocus", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('blur'),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], TypeaheadDirective.prototype, "onBlur", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('keydown', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], TypeaheadDirective.prototype, "onKeydown", null);
	    TypeaheadDirective = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({ selector: '[typeahead]', exportAs: 'bs-typeahead' }),
	        __metadata("design:paramtypes", [typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NgControl"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NgControl"]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_10__component_loader_index__["b" /* ComponentLoaderFactory */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_10__component_loader_index__["b" /* ComponentLoaderFactory */]) === "function" && _g || Object, typeof (_h = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]) === "function" && _h || Object])
	    ], TypeaheadDirective);
	    return TypeaheadDirective;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	
	
	
	/***/ }),
	/* 138 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopoverDirective; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popover_config__ = __webpack_require__(45);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_loader_index__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__popover_container_component__ = __webpack_require__(84);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	
	/**
	 * A lightweight, extensible directive for fancy popover creation.
	 */
	var PopoverDirective = (function () {
	    function PopoverDirective(_elementRef, _renderer, _viewContainerRef, _config, cis) {
	        /**
	         * Close popover on outside click
	         */
	        this.outsideClick = false;
	        /**
	         * Css class for popover container
	         */
	        this.containerClass = '';
	        this._isInited = false;
	        this._popover = cis
	            .createLoader(_elementRef, _viewContainerRef, _renderer)
	            .provide({ provide: __WEBPACK_IMPORTED_MODULE_1__popover_config__["a" /* PopoverConfig */], useValue: _config });
	        Object.assign(this, _config);
	        this.onShown = this._popover.onShown;
	        this.onHidden = this._popover.onHidden;
	        // fix: no focus on button on Mac OS #1795
	        if (typeof window !== 'undefined') {
	            _elementRef.nativeElement.addEventListener('click', function () {
	                try {
	                    _elementRef.nativeElement.focus();
	                }
	                catch (err) {
	                    return;
	                }
	            });
	        }
	    }
	    Object.defineProperty(PopoverDirective.prototype, "isOpen", {
	        /**
	         * Returns whether or not the popover is currently being shown
	         */
	        get: function () {
	            return this._popover.isShown;
	        },
	        set: function (value) {
	            if (value) {
	                this.show();
	            }
	            else {
	                this.hide();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Opens an element’s popover. This is considered a “manual” triggering of
	     * the popover.
	     */
	    PopoverDirective.prototype.show = function () {
	        if (this._popover.isShown || !this.popover) {
	            return;
	        }
	        this._popover
	            .attach(__WEBPACK_IMPORTED_MODULE_3__popover_container_component__["a" /* PopoverContainerComponent */])
	            .to(this.container)
	            .position({ attachment: this.placement })
	            .show({
	            content: this.popover,
	            context: this.popoverContext,
	            placement: this.placement,
	            title: this.popoverTitle,
	            containerClass: this.containerClass
	        });
	        this.isOpen = true;
	    };
	    /**
	     * Closes an element’s popover. This is considered a “manual” triggering of
	     * the popover.
	     */
	    PopoverDirective.prototype.hide = function () {
	        if (this.isOpen) {
	            this._popover.hide();
	            this.isOpen = false;
	        }
	    };
	    /**
	     * Toggles an element’s popover. This is considered a “manual” triggering of
	     * the popover.
	     */
	    PopoverDirective.prototype.toggle = function () {
	        if (this.isOpen) {
	            return this.hide();
	        }
	        this.show();
	    };
	    PopoverDirective.prototype.ngOnInit = function () {
	        var _this = this;
	        // fix: seems there are an issue with `routerLinkActive`
	        // which result in duplicated call ngOnInit without call to ngOnDestroy
	        // read more: https://github.com/valor-software/ngx-bootstrap/issues/1885
	        if (this._isInited) {
	            return;
	        }
	        this._isInited = true;
	        this._popover.listen({
	            triggers: this.triggers,
	            outsideClick: this.outsideClick,
	            show: function () { return _this.show(); }
	        });
	    };
	    PopoverDirective.prototype.ngOnDestroy = function () {
	        this._popover.dispose();
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], PopoverDirective.prototype, "popover", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], PopoverDirective.prototype, "popoverContext", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], PopoverDirective.prototype, "popoverTitle", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], PopoverDirective.prototype, "placement", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], PopoverDirective.prototype, "outsideClick", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], PopoverDirective.prototype, "triggers", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], PopoverDirective.prototype, "container", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Object)
	    ], PopoverDirective.prototype, "containerClass", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean),
	        __metadata("design:paramtypes", [Boolean])
	    ], PopoverDirective.prototype, "isOpen", null);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _a || Object)
	    ], PopoverDirective.prototype, "onShown", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]) === "function" && _b || Object)
	    ], PopoverDirective.prototype, "onHidden", void 0);
	    PopoverDirective = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({ selector: '[popover]', exportAs: 'bs-popover' }),
	        __metadata("design:paramtypes", [typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"]) === "function" && _e || Object, typeof (_f = typeof __WEBPACK_IMPORTED_MODULE_1__popover_config__["a" /* PopoverConfig */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__popover_config__["a" /* PopoverConfig */]) === "function" && _f || Object, typeof (_g = typeof __WEBPACK_IMPORTED_MODULE_2__component_loader_index__["b" /* ComponentLoaderFactory */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__component_loader_index__["b" /* ComponentLoaderFactory */]) === "function" && _g || Object])
	    ], PopoverDirective);
	    return PopoverDirective;
	    var _h, _a, _b, _c, _d, _e, _f, _g;
	}());
	
	
	
	/***/ }),
	/* 139 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chronos_locale_locales__ = __webpack_require__(12);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "listLocales", function() { return __WEBPACK_IMPORTED_MODULE_0__chronos_locale_locales__["d"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_theme_provider__ = __webpack_require__(7);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setTheme", function() { return __WEBPACK_IMPORTED_MODULE_1__utils_theme_provider__["b"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accordion_index__ = __webpack_require__(161);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccordionComponent", function() { return __WEBPACK_IMPORTED_MODULE_2__accordion_index__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccordionConfig", function() { return __WEBPACK_IMPORTED_MODULE_2__accordion_index__["b"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccordionModule", function() { return __WEBPACK_IMPORTED_MODULE_2__accordion_index__["c"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccordionPanelComponent", function() { return __WEBPACK_IMPORTED_MODULE_2__accordion_index__["d"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__alert_index__ = __webpack_require__(163);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AlertComponent", function() { return __WEBPACK_IMPORTED_MODULE_3__alert_index__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AlertConfig", function() { return __WEBPACK_IMPORTED_MODULE_3__alert_index__["b"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AlertModule", function() { return __WEBPACK_IMPORTED_MODULE_3__alert_index__["c"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buttons_index__ = __webpack_require__(165);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonCheckboxDirective", function() { return __WEBPACK_IMPORTED_MODULE_4__buttons_index__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonRadioDirective", function() { return __WEBPACK_IMPORTED_MODULE_4__buttons_index__["b"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonsModule", function() { return __WEBPACK_IMPORTED_MODULE_4__buttons_index__["c"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__carousel_index__ = __webpack_require__(167);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselComponent", function() { return __WEBPACK_IMPORTED_MODULE_5__carousel_index__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselConfig", function() { return __WEBPACK_IMPORTED_MODULE_5__carousel_index__["b"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselModule", function() { return __WEBPACK_IMPORTED_MODULE_5__carousel_index__["c"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SlideComponent", function() { return __WEBPACK_IMPORTED_MODULE_5__carousel_index__["d"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__collapse_index__ = __webpack_require__(170);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CollapseDirective", function() { return __WEBPACK_IMPORTED_MODULE_6__collapse_index__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CollapseModule", function() { return __WEBPACK_IMPORTED_MODULE_6__collapse_index__["b"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__datepicker_index__ = __webpack_require__(171);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DateFormatter", function() { return __WEBPACK_IMPORTED_MODULE_7__datepicker_index__["g"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DatePickerComponent", function() { return __WEBPACK_IMPORTED_MODULE_7__datepicker_index__["h"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DatepickerConfig", function() { return __WEBPACK_IMPORTED_MODULE_7__datepicker_index__["i"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DatepickerModule", function() { return __WEBPACK_IMPORTED_MODULE_7__datepicker_index__["j"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DayPickerComponent", function() { return __WEBPACK_IMPORTED_MODULE_7__datepicker_index__["k"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MonthPickerComponent", function() { return __WEBPACK_IMPORTED_MODULE_7__datepicker_index__["l"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "YearPickerComponent", function() { return __WEBPACK_IMPORTED_MODULE_7__datepicker_index__["m"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BsDatepickerModule", function() { return __WEBPACK_IMPORTED_MODULE_7__datepicker_index__["c"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BsDatepickerConfig", function() { return __WEBPACK_IMPORTED_MODULE_7__datepicker_index__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BsDaterangepickerConfig", function() { return __WEBPACK_IMPORTED_MODULE_7__datepicker_index__["d"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BsLocaleService", function() { return __WEBPACK_IMPORTED_MODULE_7__datepicker_index__["f"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BsDaterangepickerDirective", function() { return __WEBPACK_IMPORTED_MODULE_7__datepicker_index__["e"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BsDatepickerDirective", function() { return __WEBPACK_IMPORTED_MODULE_7__datepicker_index__["b"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modal_index__ = __webpack_require__(199);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalDirective", function() { return __WEBPACK_IMPORTED_MODULE_8__modal_index__["e"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalOptions", function() { return __WEBPACK_IMPORTED_MODULE_8__modal_index__["g"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalBackdropOptions", function() { return __WEBPACK_IMPORTED_MODULE_8__modal_index__["d"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalBackdropComponent", function() { return __WEBPACK_IMPORTED_MODULE_8__modal_index__["c"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalModule", function() { return __WEBPACK_IMPORTED_MODULE_8__modal_index__["f"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BsModalRef", function() { return __WEBPACK_IMPORTED_MODULE_8__modal_index__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BsModalService", function() { return __WEBPACK_IMPORTED_MODULE_8__modal_index__["b"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dropdown_index__ = __webpack_require__(202);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BsDropdownModule", function() { return __WEBPACK_IMPORTED_MODULE_9__dropdown_index__["e"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BsDropdownConfig", function() { return __WEBPACK_IMPORTED_MODULE_9__dropdown_index__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BsDropdownState", function() { return __WEBPACK_IMPORTED_MODULE_9__dropdown_index__["f"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BsDropdownContainerComponent", function() { return __WEBPACK_IMPORTED_MODULE_9__dropdown_index__["b"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BsDropdownDirective", function() { return __WEBPACK_IMPORTED_MODULE_9__dropdown_index__["c"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BsDropdownMenuDirective", function() { return __WEBPACK_IMPORTED_MODULE_9__dropdown_index__["d"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BsDropdownToggleDirective", function() { return __WEBPACK_IMPORTED_MODULE_9__dropdown_index__["g"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pagination_index__ = __webpack_require__(204);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PagerComponent", function() { return __WEBPACK_IMPORTED_MODULE_10__pagination_index__["b"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PaginationComponent", function() { return __WEBPACK_IMPORTED_MODULE_10__pagination_index__["c"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PaginationConfig", function() { return __WEBPACK_IMPORTED_MODULE_10__pagination_index__["d"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PaginationModule", function() { return __WEBPACK_IMPORTED_MODULE_10__pagination_index__["e"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PageChangedEvent", function() { return __WEBPACK_IMPORTED_MODULE_10__pagination_index__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__progressbar_index__ = __webpack_require__(206);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BarComponent", function() { return __WEBPACK_IMPORTED_MODULE_11__progressbar_index__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ProgressbarComponent", function() { return __WEBPACK_IMPORTED_MODULE_11__progressbar_index__["b"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ProgressbarConfig", function() { return __WEBPACK_IMPORTED_MODULE_11__progressbar_index__["c"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ProgressbarModule", function() { return __WEBPACK_IMPORTED_MODULE_11__progressbar_index__["d"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__rating_index__ = __webpack_require__(208);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RatingComponent", function() { return __WEBPACK_IMPORTED_MODULE_12__rating_index__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RatingModule", function() { return __WEBPACK_IMPORTED_MODULE_12__rating_index__["b"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sortable_index__ = __webpack_require__(210);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DraggableItem", function() { return __WEBPACK_IMPORTED_MODULE_13__sortable_index__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DraggableItemService", function() { return __WEBPACK_IMPORTED_MODULE_13__sortable_index__["b"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SortableItem", function() { return __WEBPACK_IMPORTED_MODULE_13__sortable_index__["d"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SortableComponent", function() { return __WEBPACK_IMPORTED_MODULE_13__sortable_index__["c"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SortableModule", function() { return __WEBPACK_IMPORTED_MODULE_13__sortable_index__["e"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__tabs_index__ = __webpack_require__(214);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NgTranscludeDirective", function() { return __WEBPACK_IMPORTED_MODULE_14__tabs_index__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabDirective", function() { return __WEBPACK_IMPORTED_MODULE_14__tabs_index__["b"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabHeadingDirective", function() { return __WEBPACK_IMPORTED_MODULE_14__tabs_index__["c"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabsetComponent", function() { return __WEBPACK_IMPORTED_MODULE_14__tabs_index__["e"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabsetConfig", function() { return __WEBPACK_IMPORTED_MODULE_14__tabs_index__["f"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabsModule", function() { return __WEBPACK_IMPORTED_MODULE_14__tabs_index__["d"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__timepicker_index__ = __webpack_require__(216);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TimepickerComponent", function() { return __WEBPACK_IMPORTED_MODULE_15__timepicker_index__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TimepickerConfig", function() { return __WEBPACK_IMPORTED_MODULE_15__timepicker_index__["b"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TimepickerModule", function() { return __WEBPACK_IMPORTED_MODULE_15__timepicker_index__["c"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__tooltip_index__ = __webpack_require__(220);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TooltipConfig", function() { return __WEBPACK_IMPORTED_MODULE_16__tooltip_index__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TooltipContainerComponent", function() { return __WEBPACK_IMPORTED_MODULE_16__tooltip_index__["b"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TooltipDirective", function() { return __WEBPACK_IMPORTED_MODULE_16__tooltip_index__["c"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TooltipModule", function() { return __WEBPACK_IMPORTED_MODULE_16__tooltip_index__["d"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__typeahead_index__ = __webpack_require__(223);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TypeaheadOptions", function() { return __WEBPACK_IMPORTED_MODULE_17__typeahead_index__["e"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TypeaheadContainerComponent", function() { return __WEBPACK_IMPORTED_MODULE_17__typeahead_index__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TypeaheadDirective", function() { return __WEBPACK_IMPORTED_MODULE_17__typeahead_index__["b"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TypeaheadMatch", function() { return __WEBPACK_IMPORTED_MODULE_17__typeahead_index__["c"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TypeaheadModule", function() { return __WEBPACK_IMPORTED_MODULE_17__typeahead_index__["d"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__popover_index__ = __webpack_require__(231);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverConfig", function() { return __WEBPACK_IMPORTED_MODULE_18__popover_index__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverContainerComponent", function() { return __WEBPACK_IMPORTED_MODULE_18__popover_index__["b"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverDirective", function() { return __WEBPACK_IMPORTED_MODULE_18__popover_index__["c"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PopoverModule", function() { return __WEBPACK_IMPORTED_MODULE_18__popover_index__["d"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_index__ = __webpack_require__(36);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "OnChange", function() { return __WEBPACK_IMPORTED_MODULE_19__utils_index__["b"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LinkedList", function() { return __WEBPACK_IMPORTED_MODULE_19__utils_index__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isBs3", function() { return __WEBPACK_IMPORTED_MODULE_19__utils_index__["e"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Trigger", function() { return __WEBPACK_IMPORTED_MODULE_19__utils_index__["c"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Utils", function() { return __WEBPACK_IMPORTED_MODULE_19__utils_index__["d"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__component_loader_index__ = __webpack_require__(15);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentLoader", function() { return __WEBPACK_IMPORTED_MODULE_20__component_loader_index__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentLoaderFactory", function() { return __WEBPACK_IMPORTED_MODULE_20__component_loader_index__["b"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ContentRef", function() { return __WEBPACK_IMPORTED_MODULE_20__component_loader_index__["c"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__positioning_index__ = __webpack_require__(21);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Positioning", function() { return __WEBPACK_IMPORTED_MODULE_21__positioning_index__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PositioningOptions", function() { return __WEBPACK_IMPORTED_MODULE_21__positioning_index__["b"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PositioningService", function() { return __WEBPACK_IMPORTED_MODULE_21__positioning_index__["c"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "positionElements", function() { return __WEBPACK_IMPORTED_MODULE_21__positioning_index__["d"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__chronos_index__ = __webpack_require__(233);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defineLocale", function() { return __WEBPACK_IMPORTED_MODULE_22__chronos_index__["b"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getSetGlobalLocale", function() { return __WEBPACK_IMPORTED_MODULE_22__chronos_index__["c"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LocaleData", function() { return __WEBPACK_IMPORTED_MODULE_22__chronos_index__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__locale__ = __webpack_require__(234);
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "arLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["a"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "csLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["b"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "daLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["c"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "deLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["d"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "enGbLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["e"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "esLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["g"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "esDoLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["f"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "esUsLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["h"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "fiLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["i"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "frLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["j"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "hiLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["m"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "huLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["n"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "idLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["o"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "itLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["p"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "jaLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["q"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "koLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["r"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "mnLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["s"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "nlLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["u"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "nlBeLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["t"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "plLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["v"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ptBrLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["w"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "svLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["A"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ruLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["y"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "roLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["x"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "zhCnLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["D"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "trLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["C"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "heLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["l"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "thLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["B"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "slLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["z"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "glLocale", function() { return __WEBPACK_IMPORTED_MODULE_23__locale__["k"]; });
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	/***/ }),
	/* 140 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Duration; });
	/* harmony export (immutable) */ __webpack_exports__["b"] = isDuration;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_locales__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__valid__ = __webpack_require__(141);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bubble__ = __webpack_require__(142);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__units_aliases__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__humanize__ = __webpack_require__(144);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_type_checks__ = __webpack_require__(1);
	
	
	
	
	
	
	var Duration = (function () {
	    function Duration(duration, config) {
	        if (config === void 0) { config = {}; }
	        this._data = {};
	        this._locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale_locales__["b" /* getLocale */])();
	        this._locale = config && config._locale || Object(__WEBPACK_IMPORTED_MODULE_0__locale_locales__["b" /* getLocale */])();
	        // const normalizedInput = normalizeObjectUnits(duration);
	        var normalizedInput = duration;
	        var years = normalizedInput.year || 0;
	        var quarters = normalizedInput.quarter || 0;
	        var months = normalizedInput.month || 0;
	        var weeks = normalizedInput.week || 0;
	        var days = normalizedInput.day || 0;
	        var hours = normalizedInput.hours || 0;
	        var minutes = normalizedInput.minutes || 0;
	        var seconds = normalizedInput.seconds || 0;
	        var milliseconds = normalizedInput.milliseconds || 0;
	        this._isValid = Object(__WEBPACK_IMPORTED_MODULE_1__valid__["a" /* isDurationValid */])(normalizedInput);
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1000 +
	            minutes * 60 * 1000 +
	            hours * 1000 * 60 * 60; // using 1000 * 60 * 60
	        // instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	        // this._data = {};
	        // this._locale = getLocale();
	        // this._bubble();
	        return Object(__WEBPACK_IMPORTED_MODULE_2__bubble__["a" /* bubble */])(this);
	    }
	    Duration.prototype.isValid = function () {
	        return this._isValid;
	    };
	    Duration.prototype.humanize = function (withSuffix) {
	        // throw new Error(`TODO: implement`);
	        if (!this.isValid()) {
	            return this.localeData().invalidDate;
	        }
	        var locale = this.localeData();
	        var output = Object(__WEBPACK_IMPORTED_MODULE_4__humanize__["a" /* relativeTime */])(this, !withSuffix, locale);
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	        return locale.postformat(output);
	    };
	    Duration.prototype.localeData = function () {
	        return this._locale;
	    };
	    Duration.prototype.locale = function (localeKey) {
	        if (!localeKey) {
	            return this._locale._abbr;
	        }
	        this._locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale_locales__["b" /* getLocale */])(localeKey) || this._locale;
	        return this;
	    };
	    Duration.prototype.abs = function () {
	        var mathAbs = Math.abs;
	        var data = this._data;
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.month = mathAbs(data.month);
	        data.year = mathAbs(data.year);
	        return this;
	    };
	    Duration.prototype.as = function (_units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	        var units = Object(__WEBPACK_IMPORTED_MODULE_3__units_aliases__["c" /* normalizeUnits */])(_units);
	        if (units === 'month' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + Object(__WEBPACK_IMPORTED_MODULE_2__bubble__["b" /* daysToMonths */])(days);
	            return units === 'month' ? months : months / 12;
	        }
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(Object(__WEBPACK_IMPORTED_MODULE_2__bubble__["c" /* monthsToDays */])(this._months));
	        switch (units) {
	            case 'week':
	                return days / 7 + milliseconds / 6048e5;
	            case 'day':
	                return days + milliseconds / 864e5;
	            case 'hours':
	                return days * 24 + milliseconds / 36e5;
	            case 'minutes':
	                return days * 1440 + milliseconds / 6e4;
	            case 'seconds':
	                return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'milliseconds':
	                return Math.floor(days * 864e5) + milliseconds;
	            default:
	                throw new Error("Unknown unit " + units);
	        }
	    };
	    Duration.prototype.valueOf = function () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            Object(__WEBPACK_IMPORTED_MODULE_5__utils_type_checks__["k" /* toInt */])(this._months / 12) * 31536e6);
	    };
	    return Duration;
	}());
	
	function isDuration(obj) {
	    return obj instanceof Duration;
	}
	
	
	/***/ }),
	/* 141 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = isDurationValid;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_type_checks__ = __webpack_require__(1);
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hours', 'minutes', 'seconds', 'milliseconds'];
	var orderingHash = ordering.reduce(function (mem, order) {
	    mem[order] = true;
	    return mem;
	}, {});
	function isDurationValid(duration) {
	    var durationKeys = Object.keys(duration);
	    if (durationKeys
	        .some(function (key) {
	        return (key in orderingHash)
	            && duration[key] === null
	            || isNaN(duration[key]);
	    })) {
	        return false;
	    }
	    // for (let key in duration) {
	    //   if (!(indexOf.call(ordering, key) !== -1 && (duration[key] == null || !isNaN(duration[key])))) {
	    //     return false;
	    //   }
	    // }
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (duration[ordering[i]]) {
	            // only allow non-integers for smallest unit
	            if (unitHasDecimal) {
	                return false;
	            }
	            if (duration[ordering[i]] !== Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["k" /* toInt */])(duration[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	    return true;
	}
	// export function isValid() {
	//   return this._isValid;
	// }
	//
	// export function createInvalid(): Duration {
	//   return createDuration(NaN);
	// }
	
	
	/***/ }),
	/* 142 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = bubble;
	/* harmony export (immutable) */ __webpack_exports__["b"] = daysToMonths;
	/* harmony export (immutable) */ __webpack_exports__["c"] = monthsToDays;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(47);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_abs_ceil__ = __webpack_require__(143);
	
	
	function bubble(dur) {
	    var milliseconds = dur._milliseconds;
	    var days = dur._days;
	    var months = dur._months;
	    var data = dur._data;
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	        (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += Object(__WEBPACK_IMPORTED_MODULE_1__utils_abs_ceil__["a" /* absCeil */])(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	    var seconds = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* absFloor */])(milliseconds / 1000);
	    data.seconds = seconds % 60;
	    var minutes = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* absFloor */])(seconds / 60);
	    data.minutes = minutes % 60;
	    var hours = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* absFloor */])(minutes / 60);
	    data.hours = hours % 24;
	    days += Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* absFloor */])(hours / 24);
	    // convert days to months
	    var monthsFromDays = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* absFloor */])(daysToMonths(days));
	    months += monthsFromDays;
	    days -= Object(__WEBPACK_IMPORTED_MODULE_1__utils_abs_ceil__["a" /* absCeil */])(monthsToDays(monthsFromDays));
	    // 12 months -> 1 year
	    var years = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* absFloor */])(months / 12);
	    months %= 12;
	    data.day = days;
	    data.month = months;
	    data.year = years;
	    return dur;
	}
	function daysToMonths(day) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return day * 4800 / 146097;
	}
	function monthsToDays(month) {
	    // the reverse of daysToMonths
	    return month * 146097 / 4800;
	}
	
	
	/***/ }),
	/* 143 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = absCeil;
	function absCeil(number) {
	    return number < 0 ? Math.floor(number) : Math.ceil(number);
	}
	
	
	/***/ }),
	/* 144 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = relativeTime;
	/* unused harmony export getSetRelativeTimeRounding */
	/* unused harmony export getSetRelativeTimeThreshold */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create__ = __webpack_require__(86);
	// tslint:disable:cyclomatic-complexity
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,
	    s: 45,
	    m: 45,
	    h: 22,
	    d: 26,
	    M: 11 // months to year
	};
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(str, num, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(num || 1, !!withoutSuffix, str, isFuture);
	}
	function relativeTime(posNegDuration, withoutSuffix, locale) {
	    var duration = Object(__WEBPACK_IMPORTED_MODULE_0__create__["a" /* createDuration */])(posNegDuration).abs();
	    var seconds = round(duration.as('s'));
	    var minutes = round(duration.as('m'));
	    var hours = round(duration.as('h'));
	    var days = round(duration.as('d'));
	    var months = round(duration.as('M'));
	    var years = round(duration.as('y'));
	    var a = seconds <= thresholds.ss && ['s', seconds] ||
	        seconds < thresholds.s && ['ss', seconds] ||
	        minutes <= 1 && ['m'] ||
	        minutes < thresholds.m && ['mm', minutes] ||
	        hours <= 1 && ['h'] ||
	        hours < thresholds.h && ['hh', hours] ||
	        days <= 1 && ['d'] ||
	        days < thresholds.d && ['dd', days] ||
	        months <= 1 && ['M'] ||
	        months < thresholds.M && ['MM', months] ||
	        years <= 1 && ['y'] || ['yy', years];
	    var b = [a[0], a[1], withoutSuffix, +posNegDuration > 0, locale];
	    // a[2] = withoutSuffix;
	    // a[3] = +posNegDuration > 0;
	    // a[4] = locale;
	    return substituteTimeAgo.apply(null, b);
	}
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding(roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof (roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold(threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	// export function humanize(withSuffix) {
	//   if (!this.isValid()) {
	//     return this.localeData().invalidDate();
	//   }
	//
	//   const locale = this.localeData();
	//   let output = relativeTime(this, !withSuffix, locale);
	//
	//   if (withSuffix) {
	//     output = locale.pastFuture(+this, output);
	//   }
	//
	//   return locale.postformat(output);
	// }
	
	
	/***/ }),
	/* 145 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export prepareConfig */
	/* harmony export (immutable) */ __webpack_exports__["a"] = createLocalOrUTC;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_type_checks__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale_locales__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__valid__ = __webpack_require__(49);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_util_isDate__ = __webpack_require__(146);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_util_isDate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_util_isDate__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__from_string_and_array__ = __webpack_require__(147);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__from_string_and_format__ = __webpack_require__(50);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__clone__ = __webpack_require__(28);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__from_string__ = __webpack_require__(87);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__from_array__ = __webpack_require__(52);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__from_object__ = __webpack_require__(157);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__check_overflow__ = __webpack_require__(90);
	// tslint:disable:max-line-length
	
	
	
	
	
	
	
	
	
	
	
	function createFromConfig(config) {
	    var res = Object(__WEBPACK_IMPORTED_MODULE_10__check_overflow__["a" /* checkOverflow */])(prepareConfig(config));
	    // todo: remove, in moment.js it's never called cuz of moment constructor
	    res._d = new Date(res._d != null ? res._d.getTime() : NaN);
	    if (!Object(__WEBPACK_IMPORTED_MODULE_2__valid__["b" /* isValid */])(Object.assign({}, res, { _isValid: null }))) {
	        res._d = new Date(NaN);
	    }
	    // todo: update offset
	    /*if (res._nextDay) {
	      // Adding is smart enough around DST
	      res._d = add(res._d, 1, 'day');
	      res._nextDay = undefined;
	    }*/
	    return res;
	}
	function prepareConfig(config) {
	    var input = config._i;
	    var format = config._f;
	    config._locale = config._locale || Object(__WEBPACK_IMPORTED_MODULE_1__locale_locales__["b" /* getLocale */])(config._l);
	    if (input === null || (format === undefined && input === '')) {
	        return Object(__WEBPACK_IMPORTED_MODULE_2__valid__["a" /* createInvalid */])(config, { nullInput: true });
	    }
	    if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["i" /* isString */])(input)) {
	        config._i = input = config._locale.preparse(input);
	    }
	    if (Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_util_isDate__["isDate"])(input)) {
	        config._d = Object(__WEBPACK_IMPORTED_MODULE_6__clone__["a" /* cloneDate */])(input);
	        return config;
	    }
	    // todo: add check for recursion
	    if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["b" /* isArray */])(format)) {
	        Object(__WEBPACK_IMPORTED_MODULE_4__from_string_and_array__["a" /* configFromStringAndArray */])(config);
	    }
	    else if (format) {
	        Object(__WEBPACK_IMPORTED_MODULE_5__from_string_and_format__["a" /* configFromStringAndFormat */])(config);
	    }
	    else {
	        configFromInput(config);
	    }
	    if (!Object(__WEBPACK_IMPORTED_MODULE_2__valid__["b" /* isValid */])(config)) {
	        config._d = null;
	    }
	    return config;
	}
	function configFromInput(config) {
	    var input = config._i;
	    if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["j" /* isUndefined */])(input)) {
	        config._d = new Date();
	    }
	    else if (Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_util_isDate__["isDate"])(input)) {
	        config._d = Object(__WEBPACK_IMPORTED_MODULE_6__clone__["a" /* cloneDate */])(input);
	    }
	    else if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["i" /* isString */])(input)) {
	        Object(__WEBPACK_IMPORTED_MODULE_7__from_string__["c" /* configFromString */])(config);
	    }
	    else if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["b" /* isArray */])(input) && input.length) {
	        var _arr = input.slice(0);
	        config._a = _arr.map(function (obj) { return Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["i" /* isString */])(obj) ? parseInt(obj, 10) : obj; });
	        Object(__WEBPACK_IMPORTED_MODULE_8__from_array__["a" /* configFromArray */])(config);
	    }
	    else if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["g" /* isObject */])(input)) {
	        Object(__WEBPACK_IMPORTED_MODULE_9__from_object__["a" /* configFromObject */])(config);
	    }
	    else if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["f" /* isNumber */])(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    }
	    else {
	        //   hooks.createFromInputFallback(config);
	        return Object(__WEBPACK_IMPORTED_MODULE_2__valid__["a" /* createInvalid */])(config);
	    }
	    return config;
	}
	function createLocalOrUTC(input, format, localeKey, strict, isUTC) {
	    var config = {};
	    var _input = input;
	    // params switch -> skip; test it well
	    // if (localeKey === true || localeKey === false) {
	    //     strict = localeKey;
	    //     localeKey = undefined;
	    // }
	    // todo: fail fast and return not valid date
	    if ((Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["g" /* isObject */])(_input) && Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["h" /* isObjectEmpty */])(_input)) || (Object(__WEBPACK_IMPORTED_MODULE_0__utils_type_checks__["b" /* isArray */])(_input) && _input.length === 0)) {
	        _input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    // config._isAMomentObject = true;
	    config._useUTC = config._isUTC = isUTC;
	    config._l = localeKey;
	    config._i = _input;
	    config._f = format;
	    config._strict = strict;
	    return createFromConfig(config);
	}
	
	
	/***/ }),
	/* 146 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_146__;
	
	/***/ }),
	/* 147 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = configFromStringAndArray;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__valid__ = __webpack_require__(49);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parsing_flags__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__from_string_and_format__ = __webpack_require__(50);
	
	
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig;
	    var bestMoment;
	    var scoreToBeat;
	    var currentScore;
	    if (!config._f || config._f.length === 0) {
	        Object(__WEBPACK_IMPORTED_MODULE_1__parsing_flags__["a" /* getParsingFlags */])(config).invalidFormat = true;
	        return Object(__WEBPACK_IMPORTED_MODULE_0__valid__["a" /* createInvalid */])(config);
	    }
	    var i;
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = Object.assign({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        Object(__WEBPACK_IMPORTED_MODULE_2__from_string_and_format__["a" /* configFromStringAndFormat */])(tempConfig);
	        if (!Object(__WEBPACK_IMPORTED_MODULE_0__valid__["b" /* isValid */])(tempConfig)) {
	            continue;
	        }
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += Object(__WEBPACK_IMPORTED_MODULE_1__parsing_flags__["a" /* getParsingFlags */])(tempConfig).charsLeftOver;
	        // or tokens
	        currentScore += Object(__WEBPACK_IMPORTED_MODULE_1__parsing_flags__["a" /* getParsingFlags */])(tempConfig).unusedTokens.length * 10;
	        Object(__WEBPACK_IMPORTED_MODULE_1__parsing_flags__["a" /* getParsingFlags */])(tempConfig).score = currentScore;
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	    return Object.assign(config, bestMoment || tempConfig);
	}
	
	
	/***/ }),
	/* 148 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_date_getters__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parse_regex__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parse_token__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(9);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_type_checks__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__aliases__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__priorities__ = __webpack_require__(10);
	
	
	
	
	
	
	
	
	// FORMATTING
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('D', ['DD', 2, false], 'Do', function (date, opts) {
	    return Object(__WEBPACK_IMPORTED_MODULE_1__utils_date_getters__["a" /* getDate */])(date, opts.isUTC).toString(10);
	});
	// ALIASES
	Object(__WEBPACK_IMPORTED_MODULE_6__aliases__["a" /* addUnitAlias */])('date', 'D');
	// PRIOROITY
	Object(__WEBPACK_IMPORTED_MODULE_7__priorities__["a" /* addUnitPriority */])('date', 9);
	// PARSING
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('D', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["d" /* match1to2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('DD', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_2__parse_regex__["h" /* match2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('Do', function (isStrict, locale) {
	    return locale._dayOfMonthOrdinalParse || locale._ordinalParse;
	});
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_token__["a" /* addParseToken */])(['D', 'DD'], __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DATE */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_token__["a" /* addParseToken */])('Do', function (input, array, config) {
	    array[__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DATE */]] = Object(__WEBPACK_IMPORTED_MODULE_5__utils_type_checks__["k" /* toInt */])(input.match(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["d" /* match1to2 */])[0]);
	    return config;
	});
	
	
	/***/ }),
	/* 149 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date_getters__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__format_format__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_zero_fill__ = __webpack_require__(46);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parse_regex__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parse_token__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(9);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_type_checks__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__create_parsing_flags__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__priorities__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__aliases__ = __webpack_require__(6);
	
	
	
	
	
	
	
	
	
	
	// FORMATTING
	function hFormat(date, isUTC) {
	    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date, isUTC) % 12 || 12;
	}
	function kFormat(date, isUTC) {
	    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date, isUTC) || 24;
	}
	Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])('H', ['HH', 2, false], null, function (date, opts) {
	    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date, opts.isUTC).toString(10);
	});
	Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])('h', ['hh', 2, false], null, function (date, opts) {
	    return hFormat(date, opts.isUTC).toString(10);
	});
	Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])('k', ['kk', 2, false], null, function (date, opts) {
	    return kFormat(date, opts.isUTC).toString(10);
	});
	Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])('hmm', null, null, function (date, opts) {
	    var _h = hFormat(date, opts.isUTC);
	    var _mm = Object(__WEBPACK_IMPORTED_MODULE_2__utils_zero_fill__["a" /* zeroFill */])(Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["g" /* getMinutes */])(date, opts.isUTC), 2);
	    return "" + _h + _mm;
	});
	Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])('hmmss', null, null, function (date, opts) {
	    var _h = hFormat(date, opts.isUTC);
	    var _mm = Object(__WEBPACK_IMPORTED_MODULE_2__utils_zero_fill__["a" /* zeroFill */])(Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["g" /* getMinutes */])(date, opts.isUTC), 2);
	    var _ss = Object(__WEBPACK_IMPORTED_MODULE_2__utils_zero_fill__["a" /* zeroFill */])(Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["i" /* getSeconds */])(date, opts.isUTC), 2);
	    return "" + _h + _mm + _ss;
	});
	Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])('Hmm', null, null, function (date, opts) {
	    var _H = Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date, opts.isUTC);
	    var _mm = Object(__WEBPACK_IMPORTED_MODULE_2__utils_zero_fill__["a" /* zeroFill */])(Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["g" /* getMinutes */])(date, opts.isUTC), 2);
	    return "" + _H + _mm;
	});
	Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])('Hmmss', null, null, function (date, opts) {
	    var _H = Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date, opts.isUTC);
	    var _mm = Object(__WEBPACK_IMPORTED_MODULE_2__utils_zero_fill__["a" /* zeroFill */])(Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["g" /* getMinutes */])(date, opts.isUTC), 2);
	    var _ss = Object(__WEBPACK_IMPORTED_MODULE_2__utils_zero_fill__["a" /* zeroFill */])(Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["i" /* getSeconds */])(date, opts.isUTC), 2);
	    return "" + _H + _mm + _ss;
	});
	function meridiem(token, lowercase) {
	    Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])(token, null, null, function (date, opts) {
	        return opts.locale.meridiem(Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date, opts.isUTC), Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["g" /* getMinutes */])(date, opts.isUTC), lowercase);
	    });
	}
	meridiem('a', true);
	meridiem('A', false);
	// ALIASES
	Object(__WEBPACK_IMPORTED_MODULE_9__aliases__["a" /* addUnitAlias */])('hour', 'h');
	// PRIORITY
	Object(__WEBPACK_IMPORTED_MODULE_8__priorities__["a" /* addUnitPriority */])('hour', 13);
	// PARSING
	function matchMeridiem(isStrict, locale) {
	    return locale._meridiemParse;
	}
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('a', matchMeridiem);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('A', matchMeridiem);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('H', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["d" /* match1to2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('h', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["d" /* match1to2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('k', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["d" /* match1to2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('HH', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_3__parse_regex__["h" /* match2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('hh', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_3__parse_regex__["h" /* match2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('kk', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_3__parse_regex__["h" /* match2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('hmm', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["j" /* match3to4 */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('hmmss', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["l" /* match5to6 */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('Hmm', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["j" /* match3to4 */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('Hmmss', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["l" /* match5to6 */]);
	Object(__WEBPACK_IMPORTED_MODULE_4__parse_token__["a" /* addParseToken */])(['H', 'HH'], __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* HOUR */]);
	Object(__WEBPACK_IMPORTED_MODULE_4__parse_token__["a" /* addParseToken */])(['k', 'kk'], function (input, array, config) {
	    var kInput = Object(__WEBPACK_IMPORTED_MODULE_6__utils_type_checks__["k" /* toInt */])(input);
	    array[__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* HOUR */]] = kInput === 24 ? 0 : kInput;
	    return config;
	});
	Object(__WEBPACK_IMPORTED_MODULE_4__parse_token__["a" /* addParseToken */])(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	    return config;
	});
	Object(__WEBPACK_IMPORTED_MODULE_4__parse_token__["a" /* addParseToken */])(['h', 'hh'], function (input, array, config) {
	    array[__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* HOUR */]] = Object(__WEBPACK_IMPORTED_MODULE_6__utils_type_checks__["k" /* toInt */])(input);
	    Object(__WEBPACK_IMPORTED_MODULE_7__create_parsing_flags__["a" /* getParsingFlags */])(config).bigHour = true;
	    return config;
	});
	Object(__WEBPACK_IMPORTED_MODULE_4__parse_token__["a" /* addParseToken */])('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* HOUR */]] = Object(__WEBPACK_IMPORTED_MODULE_6__utils_type_checks__["k" /* toInt */])(input.substr(0, pos));
	    array[__WEBPACK_IMPORTED_MODULE_5__constants__["d" /* MINUTE */]] = Object(__WEBPACK_IMPORTED_MODULE_6__utils_type_checks__["k" /* toInt */])(input.substr(pos));
	    Object(__WEBPACK_IMPORTED_MODULE_7__create_parsing_flags__["a" /* getParsingFlags */])(config).bigHour = true;
	    return config;
	});
	Object(__WEBPACK_IMPORTED_MODULE_4__parse_token__["a" /* addParseToken */])('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* HOUR */]] = Object(__WEBPACK_IMPORTED_MODULE_6__utils_type_checks__["k" /* toInt */])(input.substr(0, pos1));
	    array[__WEBPACK_IMPORTED_MODULE_5__constants__["d" /* MINUTE */]] = Object(__WEBPACK_IMPORTED_MODULE_6__utils_type_checks__["k" /* toInt */])(input.substr(pos1, 2));
	    array[__WEBPACK_IMPORTED_MODULE_5__constants__["f" /* SECOND */]] = Object(__WEBPACK_IMPORTED_MODULE_6__utils_type_checks__["k" /* toInt */])(input.substr(pos2));
	    Object(__WEBPACK_IMPORTED_MODULE_7__create_parsing_flags__["a" /* getParsingFlags */])(config).bigHour = true;
	    return config;
	});
	Object(__WEBPACK_IMPORTED_MODULE_4__parse_token__["a" /* addParseToken */])('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* HOUR */]] = Object(__WEBPACK_IMPORTED_MODULE_6__utils_type_checks__["k" /* toInt */])(input.substr(0, pos));
	    array[__WEBPACK_IMPORTED_MODULE_5__constants__["d" /* MINUTE */]] = Object(__WEBPACK_IMPORTED_MODULE_6__utils_type_checks__["k" /* toInt */])(input.substr(pos));
	    return config;
	});
	Object(__WEBPACK_IMPORTED_MODULE_4__parse_token__["a" /* addParseToken */])('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* HOUR */]] = Object(__WEBPACK_IMPORTED_MODULE_6__utils_type_checks__["k" /* toInt */])(input.substr(0, pos1));
	    array[__WEBPACK_IMPORTED_MODULE_5__constants__["d" /* MINUTE */]] = Object(__WEBPACK_IMPORTED_MODULE_6__utils_type_checks__["k" /* toInt */])(input.substr(pos1, 2));
	    array[__WEBPACK_IMPORTED_MODULE_5__constants__["f" /* SECOND */]] = Object(__WEBPACK_IMPORTED_MODULE_6__utils_type_checks__["k" /* toInt */])(input.substr(pos2));
	    return config;
	});
	
	
	/***/ }),
	/* 150 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse_regex__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(9);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_type_checks__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parse_token__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aliases__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__priorities__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_date_getters__ = __webpack_require__(2);
	// tslint:disable:no-bitwise
	// FORMATTING
	
	
	
	
	
	
	
	
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('S', null, null, function (date, opts) {
	    return (~~(Object(__WEBPACK_IMPORTED_MODULE_7__utils_date_getters__["f" /* getMilliseconds */])(date, opts.isUTC) / 100)).toString(10);
	});
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])(null, ['SS', 2, false], null, function (date, opts) {
	    return (~~(Object(__WEBPACK_IMPORTED_MODULE_7__utils_date_getters__["f" /* getMilliseconds */])(date, opts.isUTC) / 10)).toString(10);
	});
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])(null, ['SSS', 3, false], null, function (date, opts) {
	    return (Object(__WEBPACK_IMPORTED_MODULE_7__utils_date_getters__["f" /* getMilliseconds */])(date, opts.isUTC)).toString(10);
	});
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])(null, ['SSSS', 4, false], null, function (date, opts) {
	    return (Object(__WEBPACK_IMPORTED_MODULE_7__utils_date_getters__["f" /* getMilliseconds */])(date, opts.isUTC) * 10).toString(10);
	});
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])(null, ['SSSSS', 5, false], null, function (date, opts) {
	    return (Object(__WEBPACK_IMPORTED_MODULE_7__utils_date_getters__["f" /* getMilliseconds */])(date, opts.isUTC) * 100).toString(10);
	});
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])(null, ['SSSSSS', 6, false], null, function (date, opts) {
	    return (Object(__WEBPACK_IMPORTED_MODULE_7__utils_date_getters__["f" /* getMilliseconds */])(date, opts.isUTC) * 1000).toString(10);
	});
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])(null, ['SSSSSSS', 7, false], null, function (date, opts) {
	    return (Object(__WEBPACK_IMPORTED_MODULE_7__utils_date_getters__["f" /* getMilliseconds */])(date, opts.isUTC) * 10000).toString(10);
	});
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])(null, ['SSSSSSSS', 8, false], null, function (date, opts) {
	    return (Object(__WEBPACK_IMPORTED_MODULE_7__utils_date_getters__["f" /* getMilliseconds */])(date, opts.isUTC) * 100000).toString(10);
	});
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])(null, ['SSSSSSSSS', 9, false], null, function (date, opts) {
	    return (Object(__WEBPACK_IMPORTED_MODULE_7__utils_date_getters__["f" /* getMilliseconds */])(date, opts.isUTC) * 1000000).toString(10);
	});
	// ALIASES
	Object(__WEBPACK_IMPORTED_MODULE_5__aliases__["a" /* addUnitAlias */])('millisecond', 'ms');
	// PRIORITY
	Object(__WEBPACK_IMPORTED_MODULE_6__priorities__["a" /* addUnitPriority */])('millisecond', 16);
	// PARSING
	Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["a" /* addRegexToken */])('S', __WEBPACK_IMPORTED_MODULE_1__parse_regex__["e" /* match1to3 */], __WEBPACK_IMPORTED_MODULE_1__parse_regex__["c" /* match1 */]);
	Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["a" /* addRegexToken */])('SS', __WEBPACK_IMPORTED_MODULE_1__parse_regex__["e" /* match1to3 */], __WEBPACK_IMPORTED_MODULE_1__parse_regex__["h" /* match2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["a" /* addRegexToken */])('SSS', __WEBPACK_IMPORTED_MODULE_1__parse_regex__["e" /* match1to3 */], __WEBPACK_IMPORTED_MODULE_1__parse_regex__["i" /* match3 */]);
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["a" /* addRegexToken */])(token, __WEBPACK_IMPORTED_MODULE_1__parse_regex__["r" /* matchUnsigned */]);
	}
	function parseMs(input, array, config) {
	    array[__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* MILLISECOND */]] = Object(__WEBPACK_IMPORTED_MODULE_3__utils_type_checks__["k" /* toInt */])(parseFloat("0." + input) * 1000);
	    return config;
	}
	for (token = 'S'; token.length <= 9; token += 'S') {
	    Object(__WEBPACK_IMPORTED_MODULE_4__parse_token__["a" /* addParseToken */])(token, parseMs);
	}
	// MOMENTS
	
	
	/***/ }),
	/* 151 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_date_getters__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parse_regex__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parse_token__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(9);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__priorities__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__aliases__ = __webpack_require__(6);
	
	
	
	
	
	
	
	// FORMATTING
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('m', ['mm', 2, false], null, function (date, opts) {
	    return Object(__WEBPACK_IMPORTED_MODULE_1__utils_date_getters__["g" /* getMinutes */])(date, opts.isUTC).toString(10);
	});
	// ALIASES
	Object(__WEBPACK_IMPORTED_MODULE_6__aliases__["a" /* addUnitAlias */])('minute', 'm');
	// PRIORITY
	Object(__WEBPACK_IMPORTED_MODULE_5__priorities__["a" /* addUnitPriority */])('minute', 14);
	// PARSING
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('m', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["d" /* match1to2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('mm', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_2__parse_regex__["h" /* match2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_token__["a" /* addParseToken */])(['m', 'mm'], __WEBPACK_IMPORTED_MODULE_4__constants__["d" /* MINUTE */]);
	
	
	/***/ }),
	/* 152 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export getQuarter */
	/* unused harmony export setQuarter */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse_regex__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parse_token__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(9);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_type_checks__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_date_getters__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__priorities__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__aliases__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_date_setters__ = __webpack_require__(13);
	
	
	
	
	
	
	
	
	
	// FORMATTING
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('Q', null, 'Qo', function (date, opts) {
	    return getQuarter(date, opts.isUTC).toString(10);
	});
	// ALIASES
	Object(__WEBPACK_IMPORTED_MODULE_7__aliases__["a" /* addUnitAlias */])('quarter', 'Q');
	// PRIORITY
	Object(__WEBPACK_IMPORTED_MODULE_6__priorities__["a" /* addUnitPriority */])('quarter', 7);
	// PARSING
	Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["a" /* addRegexToken */])('Q', __WEBPACK_IMPORTED_MODULE_1__parse_regex__["c" /* match1 */]);
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_token__["a" /* addParseToken */])('Q', function (input, array, config) {
	    array[__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* MONTH */]] = (Object(__WEBPACK_IMPORTED_MODULE_4__utils_type_checks__["k" /* toInt */])(input) - 1) * 3;
	    return config;
	});
	// MOMENTS
	function getQuarter(date, isUTC) {
	    if (isUTC === void 0) { isUTC = false; }
	    return Math.ceil((Object(__WEBPACK_IMPORTED_MODULE_5__utils_date_getters__["h" /* getMonth */])(date, isUTC) + 1) / 3);
	}
	function setQuarter(date, quarter, isUTC) {
	    return Object(__WEBPACK_IMPORTED_MODULE_8__utils_date_setters__["g" /* setMonth */])(date, (quarter - 1) * 3 + Object(__WEBPACK_IMPORTED_MODULE_5__utils_date_getters__["h" /* getMonth */])(date, isUTC) % 3, isUTC);
	}
	// export function getSetQuarter(input) {
	//   return input == null
	//     ? Math.ceil((this.month() + 1) / 3)
	//     : this.month((input - 1) * 3 + this.month() % 3);
	// }
	
	
	/***/ }),
	/* 153 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_date_getters__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parse_regex__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parse_token__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(9);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aliases__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__priorities__ = __webpack_require__(10);
	
	
	
	
	
	
	
	// FORMATTING
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('s', ['ss', 2, false], null, function (date, opts) {
	    return Object(__WEBPACK_IMPORTED_MODULE_1__utils_date_getters__["i" /* getSeconds */])(date, opts.isUTC).toString(10);
	});
	// ALIASES
	Object(__WEBPACK_IMPORTED_MODULE_5__aliases__["a" /* addUnitAlias */])('second', 's');
	// PRIORITY
	Object(__WEBPACK_IMPORTED_MODULE_6__priorities__["a" /* addUnitPriority */])('second', 15);
	// PARSING
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('s', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["d" /* match1to2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('ss', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_2__parse_regex__["h" /* match2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_token__["a" /* addParseToken */])(['s', 'ss'], __WEBPACK_IMPORTED_MODULE_4__constants__["f" /* SECOND */]);
	
	
	/***/ }),
	/* 154 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_date_getters__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parse_regex__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parse_token__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_type_checks__ = __webpack_require__(1);
	
	
	
	
	
	// FORMATTING
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('X', null, null, function (date) {
	    return Object(__WEBPACK_IMPORTED_MODULE_1__utils_date_getters__["o" /* unix */])(date).toString(10);
	});
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('x', null, null, function (date) {
	    return date.valueOf().toString(10);
	});
	// PARSING
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('x', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["p" /* matchSigned */]);
	Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["a" /* addRegexToken */])('X', __WEBPACK_IMPORTED_MODULE_2__parse_regex__["q" /* matchTimestamp */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_token__["a" /* addParseToken */])('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input) * 1000);
	    return config;
	});
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_token__["a" /* addParseToken */])('x', function (input, array, config) {
	    config._d = new Date(Object(__WEBPACK_IMPORTED_MODULE_4__utils_type_checks__["k" /* toInt */])(input));
	    return config;
	});
	
	
	/***/ }),
	/* 155 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export getSetWeekYear */
	/* unused harmony export getWeekYear */
	/* unused harmony export getSetISOWeekYear */
	/* unused harmony export getISOWeekYear */
	/* unused harmony export getISOWeeksInYear */
	/* unused harmony export getWeeksInYear */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aliases__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__priorities__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parse_regex__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parse_token__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_type_checks__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__year__ = __webpack_require__(22);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__week_calendar_utils__ = __webpack_require__(26);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__create_date_from_array__ = __webpack_require__(19);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__week__ = __webpack_require__(51);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__day_of_week__ = __webpack_require__(14);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__locale_locales__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_date_setters__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_date_getters__ = __webpack_require__(2);
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	// FORMATTING
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])(null, ['gg', 2, false], null, function (date, opts) {
	    // return this.weekYear() % 100;
	    return (getWeekYear(date, opts.locale) % 100).toString();
	});
	Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])(null, ['GG', 2, false], null, function (date) {
	    // return this.isoWeekYear() % 100;
	    return (getISOWeekYear(date) % 100).toString();
	});
	function addWeekYearFormatToken(token, getter) {
	    Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])(null, [token, token.length, false], null, getter);
	}
	function _getWeekYearFormatCb(date, opts) {
	    return getWeekYear(date, opts.locale).toString();
	}
	function _getISOWeekYearFormatCb(date) {
	    return getISOWeekYear(date).toString();
	}
	addWeekYearFormatToken('gggg', _getWeekYearFormatCb);
	addWeekYearFormatToken('ggggg', _getWeekYearFormatCb);
	addWeekYearFormatToken('GGGG', _getISOWeekYearFormatCb);
	addWeekYearFormatToken('GGGGG', _getISOWeekYearFormatCb);
	// ALIASES
	Object(__WEBPACK_IMPORTED_MODULE_1__aliases__["a" /* addUnitAlias */])('weekYear', 'gg');
	Object(__WEBPACK_IMPORTED_MODULE_1__aliases__["a" /* addUnitAlias */])('isoWeekYear', 'GG');
	// PRIORITY
	Object(__WEBPACK_IMPORTED_MODULE_2__priorities__["a" /* addUnitPriority */])('weekYear', 1);
	Object(__WEBPACK_IMPORTED_MODULE_2__priorities__["a" /* addUnitPriority */])('isoWeekYear', 1);
	// PARSING
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('G', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["p" /* matchSigned */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('g', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["p" /* matchSigned */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('GG', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_3__parse_regex__["h" /* match2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('gg', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_3__parse_regex__["h" /* match2 */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('GGGG', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["f" /* match1to4 */], __WEBPACK_IMPORTED_MODULE_3__parse_regex__["k" /* match4 */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('gggg', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["f" /* match1to4 */], __WEBPACK_IMPORTED_MODULE_3__parse_regex__["k" /* match4 */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('GGGGG', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["g" /* match1to6 */], __WEBPACK_IMPORTED_MODULE_3__parse_regex__["m" /* match6 */]);
	Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('ggggg', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["g" /* match1to6 */], __WEBPACK_IMPORTED_MODULE_3__parse_regex__["m" /* match6 */]);
	Object(__WEBPACK_IMPORTED_MODULE_4__parse_token__["c" /* addWeekParseToken */])(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = Object(__WEBPACK_IMPORTED_MODULE_5__utils_type_checks__["k" /* toInt */])(input);
	    return config;
	});
	Object(__WEBPACK_IMPORTED_MODULE_4__parse_token__["c" /* addWeekParseToken */])(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = Object(__WEBPACK_IMPORTED_MODULE_6__year__["c" /* parseTwoDigitYear */])(input);
	    return config;
	});
	// MOMENTS
	function getSetWeekYear(date, input, locale) {
	    if (locale === void 0) { locale = Object(__WEBPACK_IMPORTED_MODULE_11__locale_locales__["b" /* getLocale */])(); }
	    return getSetWeekYearHelper(date, input, 
	    // this.week(),
	    Object(__WEBPACK_IMPORTED_MODULE_9__week__["b" /* getWeek */])(date, locale), 
	    // this.weekday(),
	    Object(__WEBPACK_IMPORTED_MODULE_10__day_of_week__["c" /* getLocaleDayOfWeek */])(date, locale), locale.firstDayOfWeek(), locale.firstDayOfYear());
	}
	function getWeekYear(date, locale) {
	    if (locale === void 0) { locale = Object(__WEBPACK_IMPORTED_MODULE_11__locale_locales__["b" /* getLocale */])(); }
	    return Object(__WEBPACK_IMPORTED_MODULE_7__week_calendar_utils__["b" /* weekOfYear */])(date, locale.firstDayOfWeek(), locale.firstDayOfYear()).year;
	}
	function getSetISOWeekYear(date, input) {
	    return getSetWeekYearHelper(date, input, Object(__WEBPACK_IMPORTED_MODULE_9__week__["a" /* getISOWeek */])(date), Object(__WEBPACK_IMPORTED_MODULE_10__day_of_week__["b" /* getISODayOfWeek */])(date), 1, 4);
	}
	function getISOWeekYear(date) {
	    return Object(__WEBPACK_IMPORTED_MODULE_7__week_calendar_utils__["b" /* weekOfYear */])(date, 1, 4).year;
	}
	function getISOWeeksInYear(date, isUTC) {
	    return Object(__WEBPACK_IMPORTED_MODULE_7__week_calendar_utils__["c" /* weeksInYear */])(Object(__WEBPACK_IMPORTED_MODULE_13__utils_date_getters__["d" /* getFullYear */])(date, isUTC), 1, 4);
	}
	function getWeeksInYear(date, isUTC, locale) {
	    if (locale === void 0) { locale = Object(__WEBPACK_IMPORTED_MODULE_11__locale_locales__["b" /* getLocale */])(); }
	    return Object(__WEBPACK_IMPORTED_MODULE_7__week_calendar_utils__["c" /* weeksInYear */])(Object(__WEBPACK_IMPORTED_MODULE_13__utils_date_getters__["d" /* getFullYear */])(date, isUTC), locale.firstDayOfWeek(), locale.firstDayOfYear());
	}
	function getSetWeekYearHelper(date, input, week, weekday, dow, doy) {
	    if (!input) {
	        return getWeekYear(date);
	    }
	    var weeksTarget = Object(__WEBPACK_IMPORTED_MODULE_7__week_calendar_utils__["c" /* weeksInYear */])(input, dow, doy);
	    var _week = week > weeksTarget ? weeksTarget : week;
	    return setWeekAll(date, input, _week, weekday, dow, doy);
	}
	function setWeekAll(date, weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = Object(__WEBPACK_IMPORTED_MODULE_7__week_calendar_utils__["a" /* dayOfYearFromWeeks */])(weekYear, week, weekday, dow, doy);
	    var _date = Object(__WEBPACK_IMPORTED_MODULE_8__create_date_from_array__["b" /* createUTCDate */])(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	    Object(__WEBPACK_IMPORTED_MODULE_12__utils_date_setters__["c" /* setFullYear */])(_date, Object(__WEBPACK_IMPORTED_MODULE_13__utils_date_getters__["d" /* getFullYear */])(_date, true));
	    Object(__WEBPACK_IMPORTED_MODULE_12__utils_date_setters__["g" /* setMonth */])(_date, Object(__WEBPACK_IMPORTED_MODULE_13__utils_date_getters__["h" /* getMonth */])(_date, true));
	    Object(__WEBPACK_IMPORTED_MODULE_12__utils_date_setters__["a" /* setDate */])(_date, Object(__WEBPACK_IMPORTED_MODULE_13__utils_date_getters__["a" /* getDate */])(_date, true));
	    return _date;
	}
	
	
	/***/ }),
	/* 156 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = defaults;
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	
	/***/ }),
	/* 157 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = configFromObject;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__units_aliases__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__from_array__ = __webpack_require__(52);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_type_checks__ = __webpack_require__(1);
	
	
	
	function configFromObject(config) {
	    if (config._d) {
	        return config;
	    }
	    var input = config._i;
	    if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_type_checks__["g" /* isObject */])(input)) {
	        var i = Object(__WEBPACK_IMPORTED_MODULE_0__units_aliases__["b" /* normalizeObjectUnits */])(input);
	        config._a = [i.year, i.month, i.day, i.hours, i.minutes, i.seconds, i.milliseconds]
	            .map(function (obj) { return Object(__WEBPACK_IMPORTED_MODULE_2__utils_type_checks__["i" /* isString */])(obj) ? parseInt(obj, 10) : obj; });
	    }
	    return Object(__WEBPACK_IMPORTED_MODULE_1__from_array__["a" /* configFromArray */])(config);
	}
	
	
	/***/ }),
	/* 158 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export defaultInvalidDate */
	/* unused harmony export defaultLocaleWeek */
	/* unused harmony export defaultLocaleMeridiemParse */
	/* unused harmony export defaultRelativeTime */
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baseConfig; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_class__ = __webpack_require__(34);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar__ = __webpack_require__(159);
	
	
	var defaultInvalidDate = 'Invalid date';
	var defaultLocaleWeek = {
	    dow: 0,
	    doy: 6 // The week that contains Jan 1st is the first week of the year.
	};
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	var defaultRelativeTime = {
	    future: 'in %s',
	    past: '%s ago',
	    s: 'a few seconds',
	    ss: '%d seconds',
	    m: 'a minute',
	    mm: '%d minutes',
	    h: 'an hour',
	    hh: '%d hours',
	    d: 'a day',
	    dd: '%d days',
	    M: 'a month',
	    MM: '%d months',
	    y: 'a year',
	    yy: '%d years'
	};
	var baseConfig = {
	    calendar: __WEBPACK_IMPORTED_MODULE_1__calendar__["a" /* defaultCalendar */],
	    longDateFormat: __WEBPACK_IMPORTED_MODULE_0__locale_class__["i" /* defaultLongDateFormat */],
	    invalidDate: defaultInvalidDate,
	    ordinal: __WEBPACK_IMPORTED_MODULE_0__locale_class__["j" /* defaultOrdinal */],
	    dayOfMonthOrdinalParse: __WEBPACK_IMPORTED_MODULE_0__locale_class__["c" /* defaultDayOfMonthOrdinalParse */],
	    relativeTime: defaultRelativeTime,
	    months: __WEBPACK_IMPORTED_MODULE_0__locale_class__["d" /* defaultLocaleMonths */],
	    monthsShort: __WEBPACK_IMPORTED_MODULE_0__locale_class__["e" /* defaultLocaleMonthsShort */],
	    week: defaultLocaleWeek,
	    weekdays: __WEBPACK_IMPORTED_MODULE_0__locale_class__["f" /* defaultLocaleWeekdays */],
	    weekdaysMin: __WEBPACK_IMPORTED_MODULE_0__locale_class__["g" /* defaultLocaleWeekdaysMin */],
	    weekdaysShort: __WEBPACK_IMPORTED_MODULE_0__locale_class__["h" /* defaultLocaleWeekdaysShort */],
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	
	/***/ }),
	/* 159 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultCalendar; });
	var defaultCalendar = {
	    sameDay: '[Today at] LT',
	    nextDay: '[Tomorrow at] LT',
	    nextWeek: 'dddd [at] LT',
	    lastDay: '[Yesterday at] LT',
	    lastWeek: '[Last] dddd [at] LT',
	    sameElse: 'L'
	};
	
	
	/***/ }),
	/* 160 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = compareArrays;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type_checks__ = __webpack_require__(1);
	// compare two arrays, return the number of differences
	
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length);
	    var lengthDiff = Math.abs(array1.length - array2.length);
	    var diffs = 0;
	    var i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i])
	            || (!dontConvert && Object(__WEBPACK_IMPORTED_MODULE_0__type_checks__["k" /* toInt */])(array1[i]) !== Object(__WEBPACK_IMPORTED_MODULE_0__type_checks__["k" /* toInt */])(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	
	/***/ }),
	/* 161 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accordion_group_component__ = __webpack_require__(92);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__accordion_group_component__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accordion_component__ = __webpack_require__(54);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__accordion_component__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accordion_module__ = __webpack_require__(162);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__accordion_module__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__accordion_config__ = __webpack_require__(55);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__accordion_config__["a"]; });
	
	
	
	
	
	
	/***/ }),
	/* 162 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionModule; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_common__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__collapse_collapse_module__ = __webpack_require__(93);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__accordion_group_component__ = __webpack_require__(92);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__accordion_component__ = __webpack_require__(54);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__accordion_config__ = __webpack_require__(55);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	
	
	
	
	var AccordionModule = (function () {
	    function AccordionModule() {
	    }
	    AccordionModule_1 = AccordionModule;
	    AccordionModule.forRoot = function () {
	        return { ngModule: AccordionModule_1, providers: [__WEBPACK_IMPORTED_MODULE_5__accordion_config__["a" /* AccordionConfig */]] };
	    };
	    AccordionModule = AccordionModule_1 = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
	            imports: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["CommonModule"], __WEBPACK_IMPORTED_MODULE_2__collapse_collapse_module__["a" /* CollapseModule */]],
	            declarations: [__WEBPACK_IMPORTED_MODULE_4__accordion_component__["a" /* AccordionComponent */], __WEBPACK_IMPORTED_MODULE_3__accordion_group_component__["a" /* AccordionPanelComponent */]],
	            exports: [__WEBPACK_IMPORTED_MODULE_4__accordion_component__["a" /* AccordionComponent */], __WEBPACK_IMPORTED_MODULE_3__accordion_group_component__["a" /* AccordionPanelComponent */]]
	        })
	    ], AccordionModule);
	    return AccordionModule;
	    var AccordionModule_1;
	}());
	
	
	
	/***/ }),
	/* 163 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alert_component__ = __webpack_require__(95);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__alert_component__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alert_module__ = __webpack_require__(164);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__alert_module__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__alert_config__ = __webpack_require__(56);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__alert_config__["a"]; });
	
	
	
	
	
	/***/ }),
	/* 164 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertModule; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_common__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__alert_component__ = __webpack_require__(95);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__alert_config__ = __webpack_require__(56);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	
	
	var AlertModule = (function () {
	    function AlertModule() {
	    }
	    AlertModule_1 = AlertModule;
	    AlertModule.forRoot = function () {
	        return { ngModule: AlertModule_1, providers: [__WEBPACK_IMPORTED_MODULE_3__alert_config__["a" /* AlertConfig */]] };
	    };
	    AlertModule = AlertModule_1 = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
	            imports: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["CommonModule"]],
	            declarations: [__WEBPACK_IMPORTED_MODULE_2__alert_component__["a" /* AlertComponent */]],
	            exports: [__WEBPACK_IMPORTED_MODULE_2__alert_component__["a" /* AlertComponent */]],
	            entryComponents: [__WEBPACK_IMPORTED_MODULE_2__alert_component__["a" /* AlertComponent */]]
	        })
	    ], AlertModule);
	    return AlertModule;
	    var AlertModule_1;
	}());
	
	
	
	/***/ }),
	/* 165 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button_checkbox_directive__ = __webpack_require__(96);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__button_checkbox_directive__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_radio_group_directive__ = __webpack_require__(58);
	/* unused harmony reexport ButtonRadioGroupDirective */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_radio_directive__ = __webpack_require__(97);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__button_radio_directive__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buttons_module__ = __webpack_require__(166);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__buttons_module__["a"]; });
	
	
	
	
	
	
	/***/ }),
	/* 166 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonsModule; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_checkbox_directive__ = __webpack_require__(96);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_radio_directive__ = __webpack_require__(97);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button_radio_group_directive__ = __webpack_require__(58);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	
	
	var ButtonsModule = (function () {
	    function ButtonsModule() {
	    }
	    ButtonsModule_1 = ButtonsModule;
	    ButtonsModule.forRoot = function () {
	        return { ngModule: ButtonsModule_1, providers: [] };
	    };
	    ButtonsModule = ButtonsModule_1 = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
	            declarations: [__WEBPACK_IMPORTED_MODULE_1__button_checkbox_directive__["a" /* ButtonCheckboxDirective */], __WEBPACK_IMPORTED_MODULE_2__button_radio_directive__["a" /* ButtonRadioDirective */], __WEBPACK_IMPORTED_MODULE_3__button_radio_group_directive__["a" /* ButtonRadioGroupDirective */]],
	            exports: [__WEBPACK_IMPORTED_MODULE_1__button_checkbox_directive__["a" /* ButtonCheckboxDirective */], __WEBPACK_IMPORTED_MODULE_2__button_radio_directive__["a" /* ButtonRadioDirective */], __WEBPACK_IMPORTED_MODULE_3__button_radio_group_directive__["a" /* ButtonRadioGroupDirective */]]
	        })
	    ], ButtonsModule);
	    return ButtonsModule;
	    var ButtonsModule_1;
	}());
	
	
	
	/***/ }),
	/* 167 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__carousel_component__ = __webpack_require__(59);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__carousel_component__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__carousel_module__ = __webpack_require__(169);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__carousel_module__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slide_component__ = __webpack_require__(99);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__slide_component__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__carousel_config__ = __webpack_require__(61);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__carousel_config__["a"]; });
	
	
	
	
	
	
	/***/ }),
	/* 168 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkedList; });
	var LinkedList = (function () {
	    function LinkedList() {
	        this.length = 0;
	        this.asArray = [];
	        // Array methods overriding END
	    }
	    LinkedList.prototype.get = function (position) {
	        if (this.length === 0 || position < 0 || position >= this.length) {
	            return void 0;
	        }
	        var current = this.head;
	        for (var index = 0; index < position; index++) {
	            current = current.next;
	        }
	        return current.value;
	    };
	    LinkedList.prototype.add = function (value, position) {
	        if (position === void 0) { position = this.length; }
	        if (position < 0 || position > this.length) {
	            throw new Error('Position is out of the list');
	        }
	        var node = {
	            value: value,
	            next: undefined,
	            previous: undefined
	        };
	        if (this.length === 0) {
	            this.head = node;
	            this.tail = node;
	            this.current = node;
	        }
	        else {
	            if (position === 0) {
	                // first node
	                node.next = this.head;
	                this.head.previous = node;
	                this.head = node;
	            }
	            else if (position === this.length) {
	                // last node
	                this.tail.next = node;
	                node.previous = this.tail;
	                this.tail = node;
	            }
	            else {
	                // node in middle
	                var currentPreviousNode = this.getNode(position - 1);
	                var currentNextNode = currentPreviousNode.next;
	                currentPreviousNode.next = node;
	                currentNextNode.previous = node;
	                node.previous = currentPreviousNode;
	                node.next = currentNextNode;
	            }
	        }
	        this.length++;
	        this.createInternalArrayRepresentation();
	    };
	    LinkedList.prototype.remove = function (position) {
	        if (position === void 0) { position = 0; }
	        if (this.length === 0 || position < 0 || position >= this.length) {
	            throw new Error('Position is out of the list');
	        }
	        if (position === 0) {
	            // first node
	            this.head = this.head.next;
	            if (this.head) {
	                // there is no second node
	                this.head.previous = undefined;
	            }
	            else {
	                // there is no second node
	                this.tail = undefined;
	            }
	        }
	        else if (position === this.length - 1) {
	            // last node
	            this.tail = this.tail.previous;
	            this.tail.next = undefined;
	        }
	        else {
	            // middle node
	            var removedNode = this.getNode(position);
	            removedNode.next.previous = removedNode.previous;
	            removedNode.previous.next = removedNode.next;
	        }
	        this.length--;
	        this.createInternalArrayRepresentation();
	    };
	    LinkedList.prototype.set = function (position, value) {
	        if (this.length === 0 || position < 0 || position >= this.length) {
	            throw new Error('Position is out of the list');
	        }
	        var node = this.getNode(position);
	        node.value = value;
	        this.createInternalArrayRepresentation();
	    };
	    LinkedList.prototype.toArray = function () {
	        return this.asArray;
	    };
	    LinkedList.prototype.findAll = function (fn) {
	        var current = this.head;
	        var result = [];
	        for (var index = 0; index < this.length; index++) {
	            if (fn(current.value, index)) {
	                result.push({ index: index, value: current.value });
	            }
	            current = current.next;
	        }
	        return result;
	    };
	    // Array methods overriding start
	    LinkedList.prototype.push = function () {
	        var _this = this;
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        args.forEach(function (arg) {
	            _this.add(arg);
	        });
	        return this.length;
	    };
	    LinkedList.prototype.pop = function () {
	        if (this.length === 0) {
	            return undefined;
	        }
	        var last = this.tail;
	        this.remove(this.length - 1);
	        return last.value;
	    };
	    LinkedList.prototype.unshift = function () {
	        var _this = this;
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        args.reverse();
	        args.forEach(function (arg) {
	            _this.add(arg, 0);
	        });
	        return this.length;
	    };
	    LinkedList.prototype.shift = function () {
	        if (this.length === 0) {
	            return undefined;
	        }
	        var lastItem = this.head.value;
	        this.remove();
	        return lastItem;
	    };
	    LinkedList.prototype.forEach = function (fn) {
	        var current = this.head;
	        for (var index = 0; index < this.length; index++) {
	            fn(current.value, index);
	            current = current.next;
	        }
	    };
	    LinkedList.prototype.indexOf = function (value) {
	        var current = this.head;
	        var position = 0;
	        for (var index = 0; index < this.length; index++) {
	            if (current.value === value) {
	                position = index;
	                break;
	            }
	            current = current.next;
	        }
	        return position;
	    };
	    LinkedList.prototype.some = function (fn) {
	        var current = this.head;
	        var result = false;
	        while (current && !result) {
	            if (fn(current.value)) {
	                result = true;
	                break;
	            }
	            current = current.next;
	        }
	        return result;
	    };
	    LinkedList.prototype.every = function (fn) {
	        var current = this.head;
	        var result = true;
	        while (current && result) {
	            if (!fn(current.value)) {
	                result = false;
	            }
	            current = current.next;
	        }
	        return result;
	    };
	    LinkedList.prototype.toString = function () {
	        return '[Linked List]';
	    };
	    LinkedList.prototype.find = function (fn) {
	        var current = this.head;
	        var result;
	        for (var index = 0; index < this.length; index++) {
	            if (fn(current.value, index)) {
	                result = current.value;
	                break;
	            }
	            current = current.next;
	        }
	        return result;
	    };
	    LinkedList.prototype.findIndex = function (fn) {
	        var current = this.head;
	        var result;
	        for (var index = 0; index < this.length; index++) {
	            if (fn(current.value, index)) {
	                result = index;
	                break;
	            }
	            current = current.next;
	        }
	        return result;
	    };
	    LinkedList.prototype.getNode = function (position) {
	        if (this.length === 0 || position < 0 || position >= this.length) {
	            throw new Error('Position is out of the list');
	        }
	        var current = this.head;
	        for (var index = 0; index < position; index++) {
	            current = current.next;
	        }
	        return current;
	    };
	    LinkedList.prototype.createInternalArrayRepresentation = function () {
	        var outArray = [];
	        var current = this.head;
	        while (current) {
	            outArray.push(current.value);
	            current = current.next;
	        }
	        this.asArray = outArray;
	    };
	    return LinkedList;
	}());
	
	
	
	/***/ }),
	/* 169 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CarouselModule; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_common__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__carousel_component__ = __webpack_require__(59);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slide_component__ = __webpack_require__(99);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__carousel_config__ = __webpack_require__(61);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	
	
	
	var CarouselModule = (function () {
	    function CarouselModule() {
	    }
	    CarouselModule_1 = CarouselModule;
	    CarouselModule.forRoot = function () {
	        return { ngModule: CarouselModule_1, providers: [] };
	    };
	    CarouselModule = CarouselModule_1 = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
	            imports: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["CommonModule"]],
	            declarations: [__WEBPACK_IMPORTED_MODULE_3__slide_component__["a" /* SlideComponent */], __WEBPACK_IMPORTED_MODULE_2__carousel_component__["a" /* CarouselComponent */]],
	            exports: [__WEBPACK_IMPORTED_MODULE_3__slide_component__["a" /* SlideComponent */], __WEBPACK_IMPORTED_MODULE_2__carousel_component__["a" /* CarouselComponent */]],
	            providers: [__WEBPACK_IMPORTED_MODULE_4__carousel_config__["a" /* CarouselConfig */]]
	        })
	    ], CarouselModule);
	    return CarouselModule;
	    var CarouselModule_1;
	}());
	
	
	
	/***/ }),
	/* 170 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__collapse_directive__ = __webpack_require__(94);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__collapse_directive__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__collapse_module__ = __webpack_require__(93);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__collapse_module__["a"]; });
	
	
	
	
	/***/ }),
	/* 171 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datepicker_component__ = __webpack_require__(100);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__datepicker_component__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datepicker_module__ = __webpack_require__(172);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__datepicker_module__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__daypicker_component__ = __webpack_require__(102);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_2__daypicker_component__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__monthpicker_component__ = __webpack_require__(103);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_3__monthpicker_component__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__yearpicker_component__ = __webpack_require__(104);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_4__yearpicker_component__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__date_formatter__ = __webpack_require__(101);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__date_formatter__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__datepicker_config__ = __webpack_require__(62);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__datepicker_config__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bs_datepicker_module__ = __webpack_require__(173);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__bs_datepicker_module__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bs_datepicker_component__ = __webpack_require__(63);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__bs_datepicker_component__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__bs_daterangepicker_component__ = __webpack_require__(68);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_9__bs_daterangepicker_component__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__bs_datepicker_config__ = __webpack_require__(18);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_10__bs_datepicker_config__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__bs_daterangepicker_config__ = __webpack_require__(69);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_11__bs_daterangepicker_config__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__bs_locale_service__ = __webpack_require__(31);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_12__bs_locale_service__["a"]; });
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	/***/ }),
	/* 172 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DatepickerModule; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_common__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_forms__ = __webpack_require__(11);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__angular_forms__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__datepicker_inner_component__ = __webpack_require__(29);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__datepicker_component__ = __webpack_require__(100);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__datepicker_config__ = __webpack_require__(62);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__daypicker_component__ = __webpack_require__(102);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__monthpicker_component__ = __webpack_require__(103);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__yearpicker_component__ = __webpack_require__(104);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	
	
	
	
	
	
	
	var DatepickerModule = (function () {
	    function DatepickerModule() {
	    }
	    DatepickerModule_1 = DatepickerModule;
	    DatepickerModule.forRoot = function () {
	        return { ngModule: DatepickerModule_1, providers: [__WEBPACK_IMPORTED_MODULE_5__datepicker_config__["a" /* DatepickerConfig */]] };
	    };
	    DatepickerModule = DatepickerModule_1 = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
	            imports: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["CommonModule"], __WEBPACK_IMPORTED_MODULE_2__angular_forms__["FormsModule"]],
	            declarations: [
	                __WEBPACK_IMPORTED_MODULE_4__datepicker_component__["a" /* DatePickerComponent */],
	                __WEBPACK_IMPORTED_MODULE_3__datepicker_inner_component__["a" /* DatePickerInnerComponent */],
	                __WEBPACK_IMPORTED_MODULE_6__daypicker_component__["a" /* DayPickerComponent */],
	                __WEBPACK_IMPORTED_MODULE_7__monthpicker_component__["a" /* MonthPickerComponent */],
	                __WEBPACK_IMPORTED_MODULE_8__yearpicker_component__["a" /* YearPickerComponent */]
	            ],
	            exports: [
	                __WEBPACK_IMPORTED_MODULE_4__datepicker_component__["a" /* DatePickerComponent */],
	                __WEBPACK_IMPORTED_MODULE_3__datepicker_inner_component__["a" /* DatePickerInnerComponent */],
	                __WEBPACK_IMPORTED_MODULE_6__daypicker_component__["a" /* DayPickerComponent */],
	                __WEBPACK_IMPORTED_MODULE_7__monthpicker_component__["a" /* MonthPickerComponent */],
	                __WEBPACK_IMPORTED_MODULE_8__yearpicker_component__["a" /* YearPickerComponent */]
	            ],
	            entryComponents: [__WEBPACK_IMPORTED_MODULE_4__datepicker_component__["a" /* DatePickerComponent */]]
	        })
	    ], DatepickerModule);
	    return DatepickerModule;
	    var DatepickerModule_1;
	}());
	
	
	
	/***/ }),
	/* 173 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDatepickerModule; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_common__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_loader_component_loader_factory__ = __webpack_require__(24);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__positioning_positioning_service__ = __webpack_require__(109);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warn_once__ = __webpack_require__(110);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bs_datepicker_input_directive__ = __webpack_require__(174);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bs_datepicker_component__ = __webpack_require__(63);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bs_datepicker_config__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bs_daterangepicker_input_directive__ = __webpack_require__(189);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__bs_daterangepicker_component__ = __webpack_require__(68);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__bs_daterangepicker_config__ = __webpack_require__(69);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__bs_locale_service__ = __webpack_require__(31);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__reducer_bs_datepicker_actions__ = __webpack_require__(30);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__reducer_bs_datepicker_effects__ = __webpack_require__(64);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reducer_bs_datepicker_store__ = __webpack_require__(65);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__themes_bs_bs_calendar_layout_component__ = __webpack_require__(190);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__themes_bs_bs_current_date_view_component__ = __webpack_require__(191);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__themes_bs_bs_custom_dates_view_component__ = __webpack_require__(192);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__themes_bs_bs_datepicker_container_component__ = __webpack_require__(111);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__themes_bs_bs_datepicker_day_decorator_directive__ = __webpack_require__(193);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__themes_bs_bs_datepicker_navigation_view_component__ = __webpack_require__(194);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__themes_bs_bs_daterangepicker_container_component__ = __webpack_require__(118);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__themes_bs_bs_days_calendar_view_component__ = __webpack_require__(195);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__themes_bs_bs_months_calendar_view_component__ = __webpack_require__(196);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__themes_bs_bs_timepicker_view_component__ = __webpack_require__(197);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__themes_bs_bs_years_calendar_view_component__ = __webpack_require__(198);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var _exports = [
	    __WEBPACK_IMPORTED_MODULE_18__themes_bs_bs_datepicker_container_component__["a" /* BsDatepickerContainerComponent */],
	    __WEBPACK_IMPORTED_MODULE_21__themes_bs_bs_daterangepicker_container_component__["a" /* BsDaterangepickerContainerComponent */],
	    __WEBPACK_IMPORTED_MODULE_6__bs_datepicker_component__["a" /* BsDatepickerDirective */],
	    __WEBPACK_IMPORTED_MODULE_5__bs_datepicker_input_directive__["a" /* BsDatepickerInputDirective */],
	    __WEBPACK_IMPORTED_MODULE_8__bs_daterangepicker_input_directive__["a" /* BsDaterangepickerInputDirective */],
	    __WEBPACK_IMPORTED_MODULE_9__bs_daterangepicker_component__["a" /* BsDaterangepickerDirective */]
	];
	var BsDatepickerModule = (function () {
	    function BsDatepickerModule() {
	        Object(__WEBPACK_IMPORTED_MODULE_4__utils_warn_once__["a" /* warnOnce */])("BsDatepickerModule is under development,\n      BREAKING CHANGES are possible,\n      PLEASE, read changelog");
	    }
	    BsDatepickerModule_1 = BsDatepickerModule;
	    BsDatepickerModule.forRoot = function () {
	        return {
	            ngModule: BsDatepickerModule_1,
	            providers: [
	                __WEBPACK_IMPORTED_MODULE_2__component_loader_component_loader_factory__["a" /* ComponentLoaderFactory */],
	                __WEBPACK_IMPORTED_MODULE_3__positioning_positioning_service__["b" /* PositioningService */],
	                __WEBPACK_IMPORTED_MODULE_14__reducer_bs_datepicker_store__["a" /* BsDatepickerStore */],
	                __WEBPACK_IMPORTED_MODULE_12__reducer_bs_datepicker_actions__["a" /* BsDatepickerActions */],
	                __WEBPACK_IMPORTED_MODULE_7__bs_datepicker_config__["a" /* BsDatepickerConfig */],
	                __WEBPACK_IMPORTED_MODULE_10__bs_daterangepicker_config__["a" /* BsDaterangepickerConfig */],
	                __WEBPACK_IMPORTED_MODULE_13__reducer_bs_datepicker_effects__["a" /* BsDatepickerEffects */],
	                __WEBPACK_IMPORTED_MODULE_11__bs_locale_service__["a" /* BsLocaleService */]
	            ]
	        };
	    };
	    BsDatepickerModule = BsDatepickerModule_1 = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
	            imports: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["CommonModule"]],
	            declarations: [
	                __WEBPACK_IMPORTED_MODULE_19__themes_bs_bs_datepicker_day_decorator_directive__["a" /* BsDatepickerDayDecoratorComponent */],
	                __WEBPACK_IMPORTED_MODULE_16__themes_bs_bs_current_date_view_component__["a" /* BsCurrentDateViewComponent */],
	                __WEBPACK_IMPORTED_MODULE_20__themes_bs_bs_datepicker_navigation_view_component__["a" /* BsDatepickerNavigationViewComponent */],
	                __WEBPACK_IMPORTED_MODULE_24__themes_bs_bs_timepicker_view_component__["a" /* BsTimepickerViewComponent */],
	                __WEBPACK_IMPORTED_MODULE_15__themes_bs_bs_calendar_layout_component__["a" /* BsCalendarLayoutComponent */],
	                __WEBPACK_IMPORTED_MODULE_22__themes_bs_bs_days_calendar_view_component__["a" /* BsDaysCalendarViewComponent */],
	                __WEBPACK_IMPORTED_MODULE_23__themes_bs_bs_months_calendar_view_component__["a" /* BsMonthCalendarViewComponent */],
	                __WEBPACK_IMPORTED_MODULE_25__themes_bs_bs_years_calendar_view_component__["a" /* BsYearsCalendarViewComponent */],
	                __WEBPACK_IMPORTED_MODULE_17__themes_bs_bs_custom_dates_view_component__["a" /* BsCustomDatesViewComponent */]
	            ].concat(_exports),
	            entryComponents: [
	                __WEBPACK_IMPORTED_MODULE_18__themes_bs_bs_datepicker_container_component__["a" /* BsDatepickerContainerComponent */],
	                __WEBPACK_IMPORTED_MODULE_21__themes_bs_bs_daterangepicker_container_component__["a" /* BsDaterangepickerContainerComponent */]
	            ],
	            exports: _exports
	        }),
	        __metadata("design:paramtypes", [])
	    ], BsDatepickerModule);
	    return BsDatepickerModule;
	    var BsDatepickerModule_1;
	}());
	
	
	
	/***/ }),
	/* 174 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDatepickerInputDirective; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_forms__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chronos_create_local__ = __webpack_require__(35);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chronos_format__ = __webpack_require__(17);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chronos_locale_locales__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chronos_utils_date_compare__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chronos_utils_type_checks__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bs_datepicker_component__ = __webpack_require__(63);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bs_locale_service__ = __webpack_require__(31);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	
	
	
	
	
	
	
	
	
	var BS_DATEPICKER_VALUE_ACCESSOR = {
	    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
	    // tslint:disable-next-line
	    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return BsDatepickerInputDirective; }),
	    multi: true
	};
	var BS_DATEPICKER_VALIDATOR = {
	    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALIDATORS"],
	    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return BsDatepickerInputDirective; }),
	    multi: true
	};
	var BsDatepickerInputDirective = (function () {
	    function BsDatepickerInputDirective(_picker, _localeService, _renderer, _elRef, changeDetection) {
	        var _this = this;
	        this._picker = _picker;
	        this._localeService = _localeService;
	        this._renderer = _renderer;
	        this._elRef = _elRef;
	        this.changeDetection = changeDetection;
	        this._onChange = Function.prototype;
	        this._onTouched = Function.prototype;
	        this._validatorChange = Function.prototype;
	        // update input value on datepicker value update
	        this._picker.bsValueChange.subscribe(function (value) {
	            _this._setInputValue(value);
	            if (_this._value !== value) {
	                _this._value = value;
	                _this._onChange(value);
	                _this._onTouched();
	            }
	            _this.changeDetection.markForCheck();
	        });
	        // update input value on locale change
	        this._localeService.localeChange.subscribe(function () {
	            _this._setInputValue(_this._value);
	        });
	    }
	    BsDatepickerInputDirective.prototype._setInputValue = function (value) {
	        var initialDate = !value ? ''
	            : Object(__WEBPACK_IMPORTED_MODULE_3__chronos_format__["b" /* formatDate */])(value, this._picker._config.dateInputFormat, this._localeService.currentLocale);
	        this._renderer.setProperty(this._elRef.nativeElement, 'value', initialDate);
	    };
	    BsDatepickerInputDirective.prototype.onChange = function (event) {
	        this.writeValue(event.target.value);
	        this._onChange(this._value);
	        this._onTouched();
	    };
	    BsDatepickerInputDirective.prototype.validate = function (c) {
	        var _value = c.value;
	        if (_value === null || _value === undefined || _value === '') {
	            return null;
	        }
	        if (Object(__WEBPACK_IMPORTED_MODULE_6__chronos_utils_type_checks__["c" /* isDate */])(_value)) {
	            var _isDateValid = Object(__WEBPACK_IMPORTED_MODULE_6__chronos_utils_type_checks__["d" /* isDateValid */])(_value);
	            if (!_isDateValid) {
	                return { bsDate: { invalid: _value } };
	            }
	            if (this._picker && this._picker.minDate && Object(__WEBPACK_IMPORTED_MODULE_5__chronos_utils_date_compare__["b" /* isBefore */])(_value, this._picker.minDate, 'date')) {
	                return { bsDate: { minDate: this._picker.minDate } };
	            }
	            if (this._picker && this._picker.maxDate && Object(__WEBPACK_IMPORTED_MODULE_5__chronos_utils_date_compare__["a" /* isAfter */])(_value, this._picker.maxDate, 'date')) {
	                return { bsDate: { maxDate: this._picker.maxDate } };
	            }
	        }
	    };
	    BsDatepickerInputDirective.prototype.registerOnValidatorChange = function (fn) {
	        this._validatorChange = fn;
	    };
	    BsDatepickerInputDirective.prototype.writeValue = function (value) {
	        if (!value) {
	            this._value = null;
	        }
	        else {
	            var _localeKey = this._localeService.currentLocale;
	            var _locale = Object(__WEBPACK_IMPORTED_MODULE_4__chronos_locale_locales__["b" /* getLocale */])(_localeKey);
	            if (!_locale) {
	                throw new Error("Locale \"" + _localeKey + "\" is not defined, please add it with \"defineLocale(...)\"");
	            }
	            this._value = Object(__WEBPACK_IMPORTED_MODULE_2__chronos_create_local__["a" /* parseDate */])(value, this._picker._config.dateInputFormat, this._localeService.currentLocale);
	        }
	        this._picker.bsValue = this._value;
	    };
	    BsDatepickerInputDirective.prototype.setDisabledState = function (isDisabled) {
	        this._picker.isDisabled = isDisabled;
	        if (isDisabled) {
	            this._renderer.setAttribute(this._elRef.nativeElement, 'disabled', 'disabled');
	            return;
	        }
	        this._renderer.removeAttribute(this._elRef.nativeElement, 'disabled');
	    };
	    BsDatepickerInputDirective.prototype.registerOnChange = function (fn) {
	        this._onChange = fn;
	    };
	    BsDatepickerInputDirective.prototype.registerOnTouched = function (fn) {
	        this._onTouched = fn;
	    };
	    BsDatepickerInputDirective.prototype.onBlur = function () {
	        this._onTouched();
	    };
	    BsDatepickerInputDirective.prototype.hide = function () {
	        this._picker.hide();
	    };
	    BsDatepickerInputDirective = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
	            selector: "input[bsDatepicker]",
	            host: {
	                '(change)': 'onChange($event)',
	                '(keyup.esc)': 'hide()',
	                '(blur)': 'onBlur()'
	            },
	            providers: [BS_DATEPICKER_VALUE_ACCESSOR, BS_DATEPICKER_VALIDATOR]
	        }),
	        __param(0, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"])()),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_7__bs_datepicker_component__["a" /* BsDatepickerDirective */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7__bs_datepicker_component__["a" /* BsDatepickerDirective */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_8__bs_locale_service__["a" /* BsLocaleService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_8__bs_locale_service__["a" /* BsLocaleService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]) === "function" && _e || Object])
	    ], BsDatepickerInputDirective);
	    return BsDatepickerInputDirective;
	    var _a, _b, _c, _d, _e;
	}());
	
	
	
	/***/ }),
	/* 175 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_175__;
	
	/***/ }),
	/* 176 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_176__;
	
	/***/ }),
	/* 177 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultMonthOptions; });
	var defaultMonthOptions = {
	    width: 7,
	    height: 6
	};
	
	
	/***/ }),
	/* 178 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_178__;
	
	/***/ }),
	/* 179 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_179__;
	
	/***/ }),
	/* 180 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_180__;
	
	/***/ }),
	/* 181 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = bsDatepickerReducer;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bs_datepicker_state__ = __webpack_require__(115);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bs_datepicker_actions__ = __webpack_require__(30);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__engine_calc_days_calendar__ = __webpack_require__(182);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__engine_format_days_calendar__ = __webpack_require__(183);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__engine_flag_days_calendar__ = __webpack_require__(184);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chronos_utils_date_setters__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__engine_view_mode__ = __webpack_require__(185);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__engine_format_months_calendar__ = __webpack_require__(186);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__engine_flag_months_calendar__ = __webpack_require__(187);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__engine_format_years_calendar__ = __webpack_require__(117);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__engine_flag_years_calendar__ = __webpack_require__(188);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__chronos_utils_type_checks__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__chronos_utils_start_end_of__ = __webpack_require__(27);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__chronos_locale_locales__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__chronos_utils_date_compare__ = __webpack_require__(23);
	// tslint:disable:max-file-line-count
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	function bsDatepickerReducer(state, action) {
	    if (state === void 0) { state = __WEBPACK_IMPORTED_MODULE_0__bs_datepicker_state__["a" /* initialDatepickerState */]; }
	    switch (action.type) {
	        case __WEBPACK_IMPORTED_MODULE_1__bs_datepicker_actions__["a" /* BsDatepickerActions */].CALCULATE: {
	            return calculateReducer(state);
	        }
	        case __WEBPACK_IMPORTED_MODULE_1__bs_datepicker_actions__["a" /* BsDatepickerActions */].FORMAT: {
	            return formatReducer(state, action);
	        }
	        case __WEBPACK_IMPORTED_MODULE_1__bs_datepicker_actions__["a" /* BsDatepickerActions */].FLAG: {
	            return flagReducer(state, action);
	        }
	        case __WEBPACK_IMPORTED_MODULE_1__bs_datepicker_actions__["a" /* BsDatepickerActions */].NAVIGATE_OFFSET: {
	            var date = Object(__WEBPACK_IMPORTED_MODULE_5__chronos_utils_date_setters__["j" /* shiftDate */])(Object(__WEBPACK_IMPORTED_MODULE_12__chronos_utils_start_end_of__["b" /* startOf */])(state.view.date, 'month'), action.payload);
	            var newState = {
	                view: {
	                    mode: state.view.mode,
	                    date: date
	                }
	            };
	            return Object.assign({}, state, newState);
	        }
	        case __WEBPACK_IMPORTED_MODULE_1__bs_datepicker_actions__["a" /* BsDatepickerActions */].NAVIGATE_TO: {
	            var payload = action.payload;
	            var date = Object(__WEBPACK_IMPORTED_MODULE_5__chronos_utils_date_setters__["b" /* setFullDate */])(state.view.date, payload.unit);
	            var mode = payload.viewMode;
	            var newState = { view: { date: date, mode: mode } };
	            return Object.assign({}, state, newState);
	        }
	        case __WEBPACK_IMPORTED_MODULE_1__bs_datepicker_actions__["a" /* BsDatepickerActions */].CHANGE_VIEWMODE: {
	            if (!Object(__WEBPACK_IMPORTED_MODULE_6__engine_view_mode__["a" /* canSwitchMode */])(action.payload)) {
	                return state;
	            }
	            var date = state.view.date;
	            var mode = action.payload;
	            var newState = { view: { date: date, mode: mode } };
	            return Object.assign({}, state, newState);
	        }
	        case __WEBPACK_IMPORTED_MODULE_1__bs_datepicker_actions__["a" /* BsDatepickerActions */].HOVER: {
	            return Object.assign({}, state, { hoveredDate: action.payload });
	        }
	        case __WEBPACK_IMPORTED_MODULE_1__bs_datepicker_actions__["a" /* BsDatepickerActions */].SELECT: {
	            var newState = {
	                selectedDate: action.payload,
	                view: state.view
	            };
	            var mode = state.view.mode;
	            var _date = action.payload || state.view.date;
	            var date = getViewDate(_date, state.minDate, state.maxDate);
	            newState.view = { mode: mode, date: date };
	            return Object.assign({}, state, newState);
	        }
	        case __WEBPACK_IMPORTED_MODULE_1__bs_datepicker_actions__["a" /* BsDatepickerActions */].SET_OPTIONS: {
	            var newState = action.payload;
	            // preserve view mode
	            var mode = state.view.mode;
	            var _viewDate = Object(__WEBPACK_IMPORTED_MODULE_11__chronos_utils_type_checks__["d" /* isDateValid */])(newState.value) && newState.value
	                || Object(__WEBPACK_IMPORTED_MODULE_11__chronos_utils_type_checks__["b" /* isArray */])(newState.value) && Object(__WEBPACK_IMPORTED_MODULE_11__chronos_utils_type_checks__["d" /* isDateValid */])(newState.value[0]) && newState.value[0]
	                || state.view.date;
	            var date = getViewDate(_viewDate, newState.minDate, newState.maxDate);
	            newState.view = { mode: mode, date: date };
	            // update selected value
	            if (newState.value) {
	                // if new value is array we work with date range
	                if (Object(__WEBPACK_IMPORTED_MODULE_11__chronos_utils_type_checks__["b" /* isArray */])(newState.value)) {
	                    newState.selectedRange = newState.value;
	                }
	                // if new value is a date -> datepicker
	                if (newState.value instanceof Date) {
	                    newState.selectedDate = newState.value;
	                }
	                // provided value is not supported :)
	                // need to report it somehow
	            }
	            return Object.assign({}, state, newState);
	        }
	        // date range picker
	        case __WEBPACK_IMPORTED_MODULE_1__bs_datepicker_actions__["a" /* BsDatepickerActions */].SELECT_RANGE: {
	            var newState = {
	                selectedRange: action.payload,
	                view: state.view
	            };
	            var mode = state.view.mode;
	            var _date = action.payload && action.payload[0] || state.view.date;
	            var date = getViewDate(_date, state.minDate, state.maxDate);
	            newState.view = { mode: mode, date: date };
	            return Object.assign({}, state, newState);
	        }
	        case __WEBPACK_IMPORTED_MODULE_1__bs_datepicker_actions__["a" /* BsDatepickerActions */].SET_MIN_DATE: {
	            return Object.assign({}, state, {
	                minDate: action.payload
	            });
	        }
	        case __WEBPACK_IMPORTED_MODULE_1__bs_datepicker_actions__["a" /* BsDatepickerActions */].SET_MAX_DATE: {
	            return Object.assign({}, state, {
	                maxDate: action.payload
	            });
	        }
	        case __WEBPACK_IMPORTED_MODULE_1__bs_datepicker_actions__["a" /* BsDatepickerActions */].SET_IS_DISABLED: {
	            return Object.assign({}, state, {
	                isDisabled: action.payload
	            });
	        }
	        default:
	            return state;
	    }
	}
	function calculateReducer(state) {
	    // how many calendars
	    var displayMonths = state.displayMonths;
	    // use selected date on initial rendering if set
	    var viewDate = state.view.date;
	    if (state.view.mode === 'day') {
	        state.monthViewOptions.firstDayOfWeek = Object(__WEBPACK_IMPORTED_MODULE_13__chronos_locale_locales__["b" /* getLocale */])(state.locale).firstDayOfWeek();
	        var monthsModel = new Array(displayMonths);
	        for (var monthIndex = 0; monthIndex < displayMonths; monthIndex++) {
	            // todo: for unlinked calendars it will be harder
	            monthsModel[monthIndex] = Object(__WEBPACK_IMPORTED_MODULE_2__engine_calc_days_calendar__["a" /* calcDaysCalendar */])(viewDate, state.monthViewOptions);
	            viewDate = Object(__WEBPACK_IMPORTED_MODULE_5__chronos_utils_date_setters__["j" /* shiftDate */])(viewDate, { month: 1 });
	        }
	        return Object.assign({}, state, { monthsModel: monthsModel });
	    }
	    if (state.view.mode === 'month') {
	        var monthsCalendar = new Array(displayMonths);
	        for (var calendarIndex = 0; calendarIndex < displayMonths; calendarIndex++) {
	            // todo: for unlinked calendars it will be harder
	            monthsCalendar[calendarIndex] = Object(__WEBPACK_IMPORTED_MODULE_7__engine_format_months_calendar__["a" /* formatMonthsCalendar */])(viewDate, getFormatOptions(state));
	            viewDate = Object(__WEBPACK_IMPORTED_MODULE_5__chronos_utils_date_setters__["j" /* shiftDate */])(viewDate, { year: 1 });
	        }
	        return Object.assign({}, state, { monthsCalendar: monthsCalendar });
	    }
	    if (state.view.mode === 'year') {
	        var yearsCalendarModel = new Array(displayMonths);
	        for (var calendarIndex = 0; calendarIndex < displayMonths; calendarIndex++) {
	            // todo: for unlinked calendars it will be harder
	            yearsCalendarModel[calendarIndex] = Object(__WEBPACK_IMPORTED_MODULE_9__engine_format_years_calendar__["a" /* formatYearsCalendar */])(viewDate, getFormatOptions(state));
	            viewDate = Object(__WEBPACK_IMPORTED_MODULE_5__chronos_utils_date_setters__["j" /* shiftDate */])(viewDate, { year: __WEBPACK_IMPORTED_MODULE_9__engine_format_years_calendar__["b" /* yearsPerCalendar */] });
	        }
	        return Object.assign({}, state, { yearsCalendarModel: yearsCalendarModel });
	    }
	    return state;
	}
	function formatReducer(state, action) {
	    if (state.view.mode === 'day') {
	        var formattedMonths = state.monthsModel.map(function (month, monthIndex) {
	            return Object(__WEBPACK_IMPORTED_MODULE_3__engine_format_days_calendar__["a" /* formatDaysCalendar */])(month, getFormatOptions(state), monthIndex);
	        });
	        return Object.assign({}, state, { formattedMonths: formattedMonths });
	    }
	    // how many calendars
	    var displayMonths = state.displayMonths;
	    // check initial rendering
	    // use selected date on initial rendering if set
	    var viewDate = state.view.date;
	    if (state.view.mode === 'month') {
	        var monthsCalendar = new Array(displayMonths);
	        for (var calendarIndex = 0; calendarIndex < displayMonths; calendarIndex++) {
	            // todo: for unlinked calendars it will be harder
	            monthsCalendar[calendarIndex] = Object(__WEBPACK_IMPORTED_MODULE_7__engine_format_months_calendar__["a" /* formatMonthsCalendar */])(viewDate, getFormatOptions(state));
	            viewDate = Object(__WEBPACK_IMPORTED_MODULE_5__chronos_utils_date_setters__["j" /* shiftDate */])(viewDate, { year: 1 });
	        }
	        return Object.assign({}, state, { monthsCalendar: monthsCalendar });
	    }
	    if (state.view.mode === 'year') {
	        var yearsCalendarModel = new Array(displayMonths);
	        for (var calendarIndex = 0; calendarIndex < displayMonths; calendarIndex++) {
	            // todo: for unlinked calendars it will be harder
	            yearsCalendarModel[calendarIndex] = Object(__WEBPACK_IMPORTED_MODULE_9__engine_format_years_calendar__["a" /* formatYearsCalendar */])(viewDate, getFormatOptions(state));
	            viewDate = Object(__WEBPACK_IMPORTED_MODULE_5__chronos_utils_date_setters__["j" /* shiftDate */])(viewDate, { year: 16 });
	        }
	        return Object.assign({}, state, { yearsCalendarModel: yearsCalendarModel });
	    }
	    return state;
	}
	function flagReducer(state, action) {
	    if (state.view.mode === 'day') {
	        var flaggedMonths = state.formattedMonths.map(function (formattedMonth, monthIndex) {
	            return Object(__WEBPACK_IMPORTED_MODULE_4__engine_flag_days_calendar__["a" /* flagDaysCalendar */])(formattedMonth, {
	                isDisabled: state.isDisabled,
	                minDate: state.minDate,
	                maxDate: state.maxDate,
	                hoveredDate: state.hoveredDate,
	                selectedDate: state.selectedDate,
	                selectedRange: state.selectedRange,
	                displayMonths: state.displayMonths,
	                monthIndex: monthIndex
	            });
	        });
	        return Object.assign({}, state, { flaggedMonths: flaggedMonths });
	    }
	    if (state.view.mode === 'month') {
	        var flaggedMonthsCalendar = state.monthsCalendar.map(function (formattedMonth, monthIndex) {
	            return Object(__WEBPACK_IMPORTED_MODULE_8__engine_flag_months_calendar__["a" /* flagMonthsCalendar */])(formattedMonth, {
	                isDisabled: state.isDisabled,
	                minDate: state.minDate,
	                maxDate: state.maxDate,
	                hoveredMonth: state.hoveredMonth,
	                displayMonths: state.displayMonths,
	                monthIndex: monthIndex
	            });
	        });
	        return Object.assign({}, state, { flaggedMonthsCalendar: flaggedMonthsCalendar });
	    }
	    if (state.view.mode === 'year') {
	        var yearsCalendarFlagged = state.yearsCalendarModel.map(function (formattedMonth, yearIndex) {
	            return Object(__WEBPACK_IMPORTED_MODULE_10__engine_flag_years_calendar__["a" /* flagYearsCalendar */])(formattedMonth, {
	                isDisabled: state.isDisabled,
	                minDate: state.minDate,
	                maxDate: state.maxDate,
	                hoveredYear: state.hoveredYear,
	                displayMonths: state.displayMonths,
	                yearIndex: yearIndex
	            });
	        });
	        return Object.assign({}, state, { yearsCalendarFlagged: yearsCalendarFlagged });
	    }
	    return state;
	}
	function getFormatOptions(state) {
	    return {
	        locale: state.locale,
	        monthTitle: state.monthTitle,
	        yearTitle: state.yearTitle,
	        dayLabel: state.dayLabel,
	        monthLabel: state.monthLabel,
	        yearLabel: state.yearLabel,
	        weekNumbers: state.weekNumbers
	    };
	}
	/**
	 * if view date is provided (bsValue|ngModel) it should be shown
	 * if view date is not provider:
	 * if minDate>currentDate (default view value), show minDate
	 * if maxDate<currentDate(default view value) show maxDate
	 */
	function getViewDate(viewDate, minDate, maxDate) {
	    var _date = Array.isArray(viewDate) ? viewDate[0] : viewDate;
	    if (minDate && Object(__WEBPACK_IMPORTED_MODULE_14__chronos_utils_date_compare__["a" /* isAfter */])(minDate, _date, 'day')) {
	        return minDate;
	    }
	    if (maxDate && Object(__WEBPACK_IMPORTED_MODULE_14__chronos_utils_date_compare__["b" /* isBefore */])(maxDate, _date, 'day')) {
	        return maxDate;
	    }
	    return _date;
	}
	
	
	/***/ }),
	/* 182 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = calcDaysCalendar;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chronos_utils_date_getters__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_bs_calendar_utils__ = __webpack_require__(39);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_matrix_utils__ = __webpack_require__(67);
	
	
	
	function calcDaysCalendar(startingDate, options) {
	    var firstDay = Object(__WEBPACK_IMPORTED_MODULE_0__chronos_utils_date_getters__["c" /* getFirstDayOfMonth */])(startingDate);
	    var initialDate = Object(__WEBPACK_IMPORTED_MODULE_1__utils_bs_calendar_utils__["a" /* getStartingDayOfCalendar */])(firstDay, options);
	    var matrixOptions = {
	        width: options.width,
	        height: options.height,
	        initialDate: initialDate,
	        shift: { day: 1 }
	    };
	    var daysMatrix = Object(__WEBPACK_IMPORTED_MODULE_2__utils_matrix_utils__["a" /* createMatrix */])(matrixOptions, function (date) { return date; });
	    return {
	        daysMatrix: daysMatrix,
	        month: firstDay
	    };
	}
	
	
	/***/ }),
	/* 183 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = formatDaysCalendar;
	/* unused harmony export getWeekNumbers */
	/* unused harmony export getShiftedWeekdays */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chronos_format__ = __webpack_require__(17);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chronos_locale_locales__ = __webpack_require__(12);
	
	
	function formatDaysCalendar(daysCalendar, formatOptions, monthIndex) {
	    return {
	        month: daysCalendar.month,
	        monthTitle: Object(__WEBPACK_IMPORTED_MODULE_0__chronos_format__["b" /* formatDate */])(daysCalendar.month, formatOptions.monthTitle, formatOptions.locale),
	        yearTitle: Object(__WEBPACK_IMPORTED_MODULE_0__chronos_format__["b" /* formatDate */])(daysCalendar.month, formatOptions.yearTitle, formatOptions.locale),
	        weekNumbers: getWeekNumbers(daysCalendar.daysMatrix, formatOptions.weekNumbers, formatOptions.locale),
	        weekdays: getShiftedWeekdays(formatOptions.locale),
	        weeks: daysCalendar.daysMatrix.map(function (week, weekIndex) { return ({
	            days: week.map(function (date, dayIndex) { return ({
	                date: date,
	                label: Object(__WEBPACK_IMPORTED_MODULE_0__chronos_format__["b" /* formatDate */])(date, formatOptions.dayLabel, formatOptions.locale),
	                monthIndex: monthIndex,
	                weekIndex: weekIndex,
	                dayIndex: dayIndex
	            }); })
	        }); })
	    };
	}
	function getWeekNumbers(daysMatrix, format, locale) {
	    return daysMatrix.map(function (days) { return (days[0] ? Object(__WEBPACK_IMPORTED_MODULE_0__chronos_format__["b" /* formatDate */])(days[0], format, locale) : ''); });
	}
	function getShiftedWeekdays(locale) {
	    var _locale = Object(__WEBPACK_IMPORTED_MODULE_1__chronos_locale_locales__["b" /* getLocale */])(locale);
	    var weekdays = _locale.weekdaysShort();
	    var firstDayOfWeek = _locale.firstDayOfWeek();
	    return weekdays.slice(firstDayOfWeek).concat(weekdays.slice(0, firstDayOfWeek));
	}
	
	
	/***/ }),
	/* 184 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = flagDaysCalendar;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chronos_utils_date_getters__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chronos_utils_date_compare__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_bs_calendar_utils__ = __webpack_require__(39);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chronos_utils_date_setters__ = __webpack_require__(13);
	
	
	
	
	function flagDaysCalendar(formattedMonth, options) {
	    formattedMonth.weeks.forEach(function (week, weekIndex) {
	        week.days.forEach(function (day, dayIndex) {
	            // datepicker
	            var isOtherMonth = !Object(__WEBPACK_IMPORTED_MODULE_0__chronos_utils_date_getters__["m" /* isSameMonth */])(day.date, formattedMonth.month);
	            var isHovered = !isOtherMonth && Object(__WEBPACK_IMPORTED_MODULE_0__chronos_utils_date_getters__["l" /* isSameDay */])(day.date, options.hoveredDate);
	            // date range picker
	            var isSelectionStart = !isOtherMonth &&
	                options.selectedRange &&
	                Object(__WEBPACK_IMPORTED_MODULE_0__chronos_utils_date_getters__["l" /* isSameDay */])(day.date, options.selectedRange[0]);
	            var isSelectionEnd = !isOtherMonth &&
	                options.selectedRange &&
	                Object(__WEBPACK_IMPORTED_MODULE_0__chronos_utils_date_getters__["l" /* isSameDay */])(day.date, options.selectedRange[1]);
	            var isSelected = (!isOtherMonth && Object(__WEBPACK_IMPORTED_MODULE_0__chronos_utils_date_getters__["l" /* isSameDay */])(day.date, options.selectedDate)) ||
	                isSelectionStart ||
	                isSelectionEnd;
	            var isInRange = !isOtherMonth &&
	                options.selectedRange &&
	                isDateInRange(day.date, options.selectedRange, options.hoveredDate);
	            var isDisabled = options.isDisabled ||
	                Object(__WEBPACK_IMPORTED_MODULE_1__chronos_utils_date_compare__["b" /* isBefore */])(day.date, options.minDate, 'day') ||
	                Object(__WEBPACK_IMPORTED_MODULE_1__chronos_utils_date_compare__["a" /* isAfter */])(day.date, options.maxDate, 'day');
	            // decide update or not
	            var newDay = Object.assign({}, day, {
	                isOtherMonth: isOtherMonth,
	                isHovered: isHovered,
	                isSelected: isSelected,
	                isSelectionStart: isSelectionStart,
	                isSelectionEnd: isSelectionEnd,
	                isInRange: isInRange,
	                isDisabled: isDisabled
	            });
	            if (day.isOtherMonth !== newDay.isOtherMonth ||
	                day.isHovered !== newDay.isHovered ||
	                day.isSelected !== newDay.isSelected ||
	                day.isSelectionStart !== newDay.isSelectionStart ||
	                day.isSelectionEnd !== newDay.isSelectionEnd ||
	                day.isDisabled !== newDay.isDisabled ||
	                day.isInRange !== newDay.isInRange) {
	                week.days[dayIndex] = newDay;
	            }
	        });
	    });
	    // todo: add check for linked calendars
	    formattedMonth.hideLeftArrow =
	        options.isDisabled ||
	            (options.monthIndex > 0 && options.monthIndex !== options.displayMonths);
	    formattedMonth.hideRightArrow =
	        options.isDisabled ||
	            (options.monthIndex < options.displayMonths &&
	                options.monthIndex + 1 !== options.displayMonths);
	    formattedMonth.disableLeftArrow = Object(__WEBPACK_IMPORTED_MODULE_2__utils_bs_calendar_utils__["b" /* isMonthDisabled */])(Object(__WEBPACK_IMPORTED_MODULE_3__chronos_utils_date_setters__["j" /* shiftDate */])(formattedMonth.month, { month: -1 }), options.minDate, options.maxDate);
	    formattedMonth.disableRightArrow = Object(__WEBPACK_IMPORTED_MODULE_2__utils_bs_calendar_utils__["b" /* isMonthDisabled */])(Object(__WEBPACK_IMPORTED_MODULE_3__chronos_utils_date_setters__["j" /* shiftDate */])(formattedMonth.month, { month: 1 }), options.minDate, options.maxDate);
	    return formattedMonth;
	}
	function isDateInRange(date, selectedRange, hoveredDate) {
	    if (!date || !selectedRange[0]) {
	        return false;
	    }
	    if (selectedRange[1]) {
	        return date > selectedRange[0] && date <= selectedRange[1];
	    }
	    if (hoveredDate) {
	        return date > selectedRange[0] && date <= hoveredDate;
	    }
	    return false;
	}
	
	
	/***/ }),
	/* 185 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = canSwitchMode;
	function canSwitchMode(mode) {
	    return true;
	}
	
	
	/***/ }),
	/* 186 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = formatMonthsCalendar;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chronos_utils_start_end_of__ = __webpack_require__(27);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chronos_format__ = __webpack_require__(17);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_matrix_utils__ = __webpack_require__(67);
	
	
	
	var height = 4;
	var width = 3;
	var shift = { month: 1 };
	function formatMonthsCalendar(viewDate, formatOptions) {
	    var initialDate = Object(__WEBPACK_IMPORTED_MODULE_0__chronos_utils_start_end_of__["b" /* startOf */])(viewDate, 'year');
	    var matrixOptions = { width: width, height: height, initialDate: initialDate, shift: shift };
	    var monthMatrix = Object(__WEBPACK_IMPORTED_MODULE_2__utils_matrix_utils__["a" /* createMatrix */])(matrixOptions, function (date) { return ({
	        date: date,
	        label: Object(__WEBPACK_IMPORTED_MODULE_1__chronos_format__["b" /* formatDate */])(date, formatOptions.monthLabel, formatOptions.locale)
	    }); });
	    return {
	        months: monthMatrix,
	        monthTitle: '',
	        yearTitle: Object(__WEBPACK_IMPORTED_MODULE_1__chronos_format__["b" /* formatDate */])(viewDate, formatOptions.yearTitle, formatOptions.locale)
	    };
	}
	
	
	/***/ }),
	/* 187 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = flagMonthsCalendar;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chronos_utils_date_getters__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_bs_calendar_utils__ = __webpack_require__(39);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chronos_utils_date_setters__ = __webpack_require__(13);
	
	
	
	function flagMonthsCalendar(monthCalendar, options) {
	    monthCalendar.months.forEach(function (months, rowIndex) {
	        months.forEach(function (month, monthIndex) {
	            var isHovered = Object(__WEBPACK_IMPORTED_MODULE_0__chronos_utils_date_getters__["m" /* isSameMonth */])(month.date, options.hoveredMonth);
	            var isDisabled = options.isDisabled ||
	                Object(__WEBPACK_IMPORTED_MODULE_1__utils_bs_calendar_utils__["b" /* isMonthDisabled */])(month.date, options.minDate, options.maxDate);
	            var newMonth = Object.assign(/*{},*/ month, {
	                isHovered: isHovered,
	                isDisabled: isDisabled
	            });
	            if (month.isHovered !== newMonth.isHovered ||
	                month.isDisabled !== newMonth.isDisabled) {
	                monthCalendar.months[rowIndex][monthIndex] = newMonth;
	            }
	        });
	    });
	    // todo: add check for linked calendars
	    monthCalendar.hideLeftArrow =
	        options.monthIndex > 0 && options.monthIndex !== options.displayMonths;
	    monthCalendar.hideRightArrow =
	        options.monthIndex < options.displayMonths &&
	            options.monthIndex + 1 !== options.displayMonths;
	    monthCalendar.disableLeftArrow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_bs_calendar_utils__["c" /* isYearDisabled */])(Object(__WEBPACK_IMPORTED_MODULE_2__chronos_utils_date_setters__["j" /* shiftDate */])(monthCalendar.months[0][0].date, { year: -1 }), options.minDate, options.maxDate);
	    monthCalendar.disableRightArrow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_bs_calendar_utils__["c" /* isYearDisabled */])(Object(__WEBPACK_IMPORTED_MODULE_2__chronos_utils_date_setters__["j" /* shiftDate */])(monthCalendar.months[0][0].date, { year: 1 }), options.minDate, options.maxDate);
	    return monthCalendar;
	}
	
	
	/***/ }),
	/* 188 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = flagYearsCalendar;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chronos_utils_date_getters__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_bs_calendar_utils__ = __webpack_require__(39);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chronos_utils_date_setters__ = __webpack_require__(13);
	
	
	
	function flagYearsCalendar(yearsCalendar, options) {
	    yearsCalendar.years.forEach(function (years, rowIndex) {
	        years.forEach(function (year, yearIndex) {
	            var isHovered = Object(__WEBPACK_IMPORTED_MODULE_0__chronos_utils_date_getters__["n" /* isSameYear */])(year.date, options.hoveredYear);
	            var isDisabled = options.isDisabled ||
	                Object(__WEBPACK_IMPORTED_MODULE_1__utils_bs_calendar_utils__["c" /* isYearDisabled */])(year.date, options.minDate, options.maxDate);
	            var newMonth = Object.assign(/*{},*/ year, { isHovered: isHovered, isDisabled: isDisabled });
	            if (year.isHovered !== newMonth.isHovered ||
	                year.isDisabled !== newMonth.isDisabled) {
	                yearsCalendar.years[rowIndex][yearIndex] = newMonth;
	            }
	        });
	    });
	    // todo: add check for linked calendars
	    yearsCalendar.hideLeftArrow =
	        options.yearIndex > 0 && options.yearIndex !== options.displayMonths;
	    yearsCalendar.hideRightArrow =
	        options.yearIndex < options.displayMonths &&
	            options.yearIndex + 1 !== options.displayMonths;
	    yearsCalendar.disableLeftArrow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_bs_calendar_utils__["c" /* isYearDisabled */])(Object(__WEBPACK_IMPORTED_MODULE_2__chronos_utils_date_setters__["j" /* shiftDate */])(yearsCalendar.years[0][0].date, { year: -1 }), options.minDate, options.maxDate);
	    var i = yearsCalendar.years.length - 1;
	    var j = yearsCalendar.years[i].length - 1;
	    yearsCalendar.disableRightArrow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_bs_calendar_utils__["c" /* isYearDisabled */])(Object(__WEBPACK_IMPORTED_MODULE_2__chronos_utils_date_setters__["j" /* shiftDate */])(yearsCalendar.years[i][j].date, { year: 1 }), options.minDate, options.maxDate);
	    return yearsCalendar;
	}
	
	
	/***/ }),
	/* 189 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDaterangepickerInputDirective; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(11);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_forms__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chronos_create_local__ = __webpack_require__(35);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chronos_format__ = __webpack_require__(17);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chronos_locale_locales__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chronos_utils_date_compare__ = __webpack_require__(23);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chronos_utils_type_checks__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bs_daterangepicker_component__ = __webpack_require__(68);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bs_locale_service__ = __webpack_require__(31);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	
	
	
	
	
	
	
	
	
	var BS_DATERANGEPICKER_VALUE_ACCESSOR = {
	    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALUE_ACCESSOR"],
	    // tslint:disable-next-line
	    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return BsDaterangepickerInputDirective; }),
	    multi: true
	};
	var BS_DATERANGEPICKER_VALIDATOR = {
	    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["NG_VALIDATORS"],
	    useExisting: Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return BsDaterangepickerInputDirective; }),
	    multi: true
	};
	var BsDaterangepickerInputDirective = (function () {
	    function BsDaterangepickerInputDirective(_picker, _localeService, _renderer, _elRef, changeDetection) {
	        var _this = this;
	        this._picker = _picker;
	        this._localeService = _localeService;
	        this._renderer = _renderer;
	        this._elRef = _elRef;
	        this.changeDetection = changeDetection;
	        this._onChange = Function.prototype;
	        this._onTouched = Function.prototype;
	        this._validatorChange = Function.prototype;
	        // update input value on datepicker value update
	        this._picker.bsValueChange.subscribe(function (value) {
	            _this._setInputValue(value);
	            if (_this._value !== value) {
	                _this._value = value;
	                _this._onChange(value);
	                _this._onTouched();
	            }
	            _this.changeDetection.markForCheck();
	        });
	        // update input value on locale change
	        this._localeService.localeChange.subscribe(function () {
	            _this._setInputValue(_this._value);
	        });
	    }
	    BsDaterangepickerInputDirective.prototype._setInputValue = function (date) {
	        var range = '';
	        if (date) {
	            var start = !date[0] ? ''
	                : Object(__WEBPACK_IMPORTED_MODULE_3__chronos_format__["b" /* formatDate */])(date[0], this._picker._config.rangeInputFormat, this._localeService.currentLocale);
	            var end = !date[1] ? ''
	                : Object(__WEBPACK_IMPORTED_MODULE_3__chronos_format__["b" /* formatDate */])(date[1], this._picker._config.rangeInputFormat, this._localeService.currentLocale);
	            range = (start && end) ? start + this._picker._config.rangeSeparator + end : '';
	        }
	        this._renderer.setProperty(this._elRef.nativeElement, 'value', range);
	    };
	    BsDaterangepickerInputDirective.prototype.onChange = function (event) {
	        this.writeValue(event.target.value);
	        this._onChange(this._value);
	        this._onTouched();
	    };
	    BsDaterangepickerInputDirective.prototype.validate = function (c) {
	        var _value = c.value;
	        if (_value === null || _value === undefined || !Object(__WEBPACK_IMPORTED_MODULE_6__chronos_utils_type_checks__["b" /* isArray */])(_value)) {
	            return null;
	        }
	        var _isDateValid = Object(__WEBPACK_IMPORTED_MODULE_6__chronos_utils_type_checks__["d" /* isDateValid */])(_value[0]) && Object(__WEBPACK_IMPORTED_MODULE_6__chronos_utils_type_checks__["d" /* isDateValid */])(_value[0]);
	        if (!_isDateValid) {
	            return { bsDate: { invalid: _value } };
	        }
	        if (this._picker && this._picker.minDate && Object(__WEBPACK_IMPORTED_MODULE_5__chronos_utils_date_compare__["b" /* isBefore */])(_value[0], this._picker.minDate, 'date')) {
	            return { bsDate: { minDate: this._picker.minDate } };
	        }
	        if (this._picker && this._picker.maxDate && Object(__WEBPACK_IMPORTED_MODULE_5__chronos_utils_date_compare__["a" /* isAfter */])(_value[1], this._picker.maxDate, 'date')) {
	            return { bsDate: { maxDate: this._picker.maxDate } };
	        }
	    };
	    BsDaterangepickerInputDirective.prototype.registerOnValidatorChange = function (fn) {
	        this._validatorChange = fn;
	    };
	    BsDaterangepickerInputDirective.prototype.writeValue = function (value) {
	        var _this = this;
	        if (!value) {
	            this._value = null;
	        }
	        else {
	            var _localeKey = this._localeService.currentLocale;
	            var _locale = Object(__WEBPACK_IMPORTED_MODULE_4__chronos_locale_locales__["b" /* getLocale */])(_localeKey);
	            if (!_locale) {
	                throw new Error("Locale \"" + _localeKey + "\" is not defined, please add it with \"defineLocale(...)\"");
	            }
	            var _input = [];
	            if (typeof value === 'string') {
	                _input = value.split(this._picker._config.rangeSeparator);
	            }
	            if (Array.isArray(value)) {
	                _input = value;
	            }
	            this._value = _input
	                .map(function (_val) {
	                return Object(__WEBPACK_IMPORTED_MODULE_2__chronos_create_local__["a" /* parseDate */])(_val, _this._picker._config.dateInputFormat, _this._localeService.currentLocale);
	            })
	                .map(function (date) { return (isNaN(date.valueOf()) ? null : date); });
	        }
	        this._picker.bsValue = this._value;
	    };
	    BsDaterangepickerInputDirective.prototype.setDisabledState = function (isDisabled) {
	        this._picker.isDisabled = isDisabled;
	        if (isDisabled) {
	            this._renderer.setAttribute(this._elRef.nativeElement, 'disabled', 'disabled');
	            return;
	        }
	        this._renderer.removeAttribute(this._elRef.nativeElement, 'disabled');
	    };
	    BsDaterangepickerInputDirective.prototype.registerOnChange = function (fn) {
	        this._onChange = fn;
	    };
	    BsDaterangepickerInputDirective.prototype.registerOnTouched = function (fn) {
	        this._onTouched = fn;
	    };
	    BsDaterangepickerInputDirective.prototype.onBlur = function () {
	        this._onTouched();
	    };
	    BsDaterangepickerInputDirective.prototype.hide = function () {
	        this._picker.hide();
	    };
	    BsDaterangepickerInputDirective = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
	            selector: "input[bsDaterangepicker]",
	            host: {
	                '(change)': 'onChange($event)',
	                '(keyup.esc)': 'hide()',
	                '(blur)': 'onBlur()'
	            },
	            providers: [BS_DATERANGEPICKER_VALUE_ACCESSOR, BS_DATERANGEPICKER_VALIDATOR]
	        }),
	        __param(0, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"])()),
	        __metadata("design:paramtypes", [typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_7__bs_daterangepicker_component__["a" /* BsDaterangepickerDirective */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_7__bs_daterangepicker_component__["a" /* BsDaterangepickerDirective */]) === "function" && _a || Object, typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_8__bs_locale_service__["a" /* BsLocaleService */] !== "undefined" && __WEBPACK_IMPORTED_MODULE_8__bs_locale_service__["a" /* BsLocaleService */]) === "function" && _b || Object, typeof (_c = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"]) === "function" && _c || Object, typeof (_d = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]) === "function" && _d || Object, typeof (_e = typeof __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]) === "function" && _e || Object])
	    ], BsDaterangepickerInputDirective);
	    return BsDaterangepickerInputDirective;
	    var _a, _b, _c, _d, _e;
	}());
	
	
	
	/***/ }),
	/* 190 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsCalendarLayoutComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	var BsCalendarLayoutComponent = (function () {
	    function BsCalendarLayoutComponent() {
	    }
	    BsCalendarLayoutComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'bs-calendar-layout',
	            template: "\n    <!-- current date, will be added in nearest releases -->\n    <bs-current-date title=\"hey there\" *ngIf=\"false\"></bs-current-date>\n\n    <!--navigation-->\n    <div class=\"bs-datepicker-head\">\n      <ng-content select=\"bs-datepicker-navigation-view\"></ng-content>\n    </div>\n\n    <div class=\"bs-datepicker-body\">\n      <ng-content></ng-content>\n    </div>\n\n    <!--timepicker-->\n    <bs-timepicker *ngIf=\"false\"></bs-timepicker>\n  "
	        })
	    ], BsCalendarLayoutComponent);
	    return BsCalendarLayoutComponent;
	}());
	
	
	
	/***/ }),
	/* 191 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsCurrentDateViewComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	var BsCurrentDateViewComponent = (function () {
	    function BsCurrentDateViewComponent() {
	    }
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", String)
	    ], BsCurrentDateViewComponent.prototype, "title", void 0);
	    BsCurrentDateViewComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'bs-current-date',
	            template: "<div class=\"current-timedate\"><span>{{ title }}</span></div>"
	        })
	    ], BsCurrentDateViewComponent);
	    return BsCurrentDateViewComponent;
	}());
	
	
	
	/***/ }),
	/* 192 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsCustomDatesViewComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	var BsCustomDatesViewComponent = (function () {
	    function BsCustomDatesViewComponent() {
	    }
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Boolean)
	    ], BsCustomDatesViewComponent.prototype, "isCustomRangeShown", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", Array)
	    ], BsCustomDatesViewComponent.prototype, "ranges", void 0);
	    BsCustomDatesViewComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'bs-custom-date-view',
	            template: "\n    <div class=\"bs-datepicker-predefined-btns\">\n      <button *ngFor=\"let range of ranges\">{{ range.label }}</button>\n      <button *ngIf=\"isCustomRangeShown\">Custom Range</button>\n    </div>\n  ",
	            changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush
	        })
	    ], BsCustomDatesViewComponent);
	    return BsCustomDatesViewComponent;
	}());
	
	
	
	/***/ }),
	/* 193 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDatepickerDayDecoratorComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_index__ = __webpack_require__(32);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	var BsDatepickerDayDecoratorComponent = (function () {
	    function BsDatepickerDayDecoratorComponent() {
	    }
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__models_index__["DayViewModel"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__models_index__["DayViewModel"]) === "function" && _a || Object)
	    ], BsDatepickerDayDecoratorComponent.prototype, "day", void 0);
	    BsDatepickerDayDecoratorComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: '[bsDatepickerDayDecorator]',
	            changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
	            host: {
	                '[class.disabled]': 'day.isDisabled',
	                '[class.is-highlighted]': 'day.isHovered',
	                '[class.is-other-month]': 'day.isOtherMonth',
	                '[class.in-range]': 'day.isInRange',
	                '[class.select-start]': 'day.isSelectionStart',
	                '[class.select-end]': 'day.isSelectionEnd',
	                '[class.selected]': 'day.isSelected'
	            },
	            template: "{{ day.label }}"
	        })
	    ], BsDatepickerDayDecoratorComponent);
	    return BsDatepickerDayDecoratorComponent;
	    var _a;
	}());
	
	
	
	/***/ }),
	/* 194 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDatepickerNavigationViewComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_index__ = __webpack_require__(32);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	var BsDatepickerNavigationViewComponent = (function () {
	    function BsDatepickerNavigationViewComponent() {
	        this.onNavigate = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.onViewMode = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	    }
	    BsDatepickerNavigationViewComponent.prototype.navTo = function (down) {
	        this.onNavigate.emit(down ? __WEBPACK_IMPORTED_MODULE_1__models_index__["a" /* BsNavigationDirection */].DOWN : __WEBPACK_IMPORTED_MODULE_1__models_index__["a" /* BsNavigationDirection */].UP);
	    };
	    BsDatepickerNavigationViewComponent.prototype.view = function (viewMode) {
	        this.onViewMode.emit(viewMode);
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__models_index__["DaysCalendarViewModel"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__models_index__["DaysCalendarViewModel"]) === "function" && _a || Object)
	    ], BsDatepickerNavigationViewComponent.prototype, "calendar", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], BsDatepickerNavigationViewComponent.prototype, "onNavigate", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], BsDatepickerNavigationViewComponent.prototype, "onViewMode", void 0);
	    BsDatepickerNavigationViewComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'bs-datepicker-navigation-view',
	            changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
	            template: "\n    <button class=\"previous\"\n            [disabled]=\"calendar.disableLeftArrow\"\n            [style.visibility]=\"calendar.hideLeftArrow ? 'hidden' : 'visible'\"\n            (click)=\"navTo(true)\"><span>&lsaquo;</span>\n    </button>\n\n    <button class=\"current\"\n            *ngIf=\"calendar.monthTitle\"\n            (click)=\"view('month')\"\n    ><span>{{ calendar.monthTitle }}</span>\n    </button>\n\n    <button class=\"current\" (click)=\"view('year')\"\n    ><span>{{ calendar.yearTitle }}</span></button>\n\n    <button class=\"next\"\n            [disabled]=\"calendar.disableRightArrow\"\n            [style.visibility]=\"calendar.hideRightArrow ? 'hidden' : 'visible'\"\n            (click)=\"navTo(false)\"><span>&rsaquo;</span>\n    </button>\n  "
	        })
	    ], BsDatepickerNavigationViewComponent);
	    return BsDatepickerNavigationViewComponent;
	    var _a;
	}());
	
	
	
	/***/ }),
	/* 195 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDaysCalendarViewComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_index__ = __webpack_require__(32);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	var BsDaysCalendarViewComponent = (function () {
	    function BsDaysCalendarViewComponent() {
	        this.onNavigate = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.onViewMode = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.onSelect = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.onHover = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	    }
	    BsDaysCalendarViewComponent.prototype.navigateTo = function (event) {
	        var step = __WEBPACK_IMPORTED_MODULE_1__models_index__["a" /* BsNavigationDirection */].DOWN === event ? -1 : 1;
	        this.onNavigate.emit({ step: { month: step } });
	    };
	    BsDaysCalendarViewComponent.prototype.changeViewMode = function (event) {
	        this.onViewMode.emit(event);
	    };
	    BsDaysCalendarViewComponent.prototype.selectDay = function (event) {
	        this.onSelect.emit(event);
	    };
	    BsDaysCalendarViewComponent.prototype.hoverDay = function (cell, isHovered) {
	        this.onHover.emit({ cell: cell, isHovered: isHovered });
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__models_index__["DaysCalendarViewModel"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__models_index__["DaysCalendarViewModel"]) === "function" && _a || Object)
	    ], BsDaysCalendarViewComponent.prototype, "calendar", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", typeof (_b = typeof __WEBPACK_IMPORTED_MODULE_1__models_index__["DatepickerRenderOptions"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__models_index__["DatepickerRenderOptions"]) === "function" && _b || Object)
	    ], BsDaysCalendarViewComponent.prototype, "options", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], BsDaysCalendarViewComponent.prototype, "onNavigate", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], BsDaysCalendarViewComponent.prototype, "onViewMode", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], BsDaysCalendarViewComponent.prototype, "onSelect", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], BsDaysCalendarViewComponent.prototype, "onHover", void 0);
	    BsDaysCalendarViewComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'bs-days-calendar-view',
	            // changeDetection: ChangeDetectionStrategy.OnPush,
	            template: "\n    <bs-calendar-layout>\n      <bs-datepicker-navigation-view\n        [calendar]=\"calendar\"\n        (onNavigate)=\"navigateTo($event)\"\n        (onViewMode)=\"changeViewMode($event)\"\n      ></bs-datepicker-navigation-view>\n\n      <!--days matrix-->\n      <table role=\"grid\" class=\"days weeks\">\n        <thead>\n        <tr>\n          <!--if show weeks-->\n          <th *ngIf=\"options.showWeekNumbers\"></th>\n          <th *ngFor=\"let weekday of calendar.weekdays; let i = index\"\n              aria-label=\"weekday\">{{ calendar.weekdays[i] }}\n          </th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr *ngFor=\"let week of calendar.weeks; let i = index\">\n          <td class=\"week\" *ngIf=\"options.showWeekNumbers\">\n            <span>{{ calendar.weekNumbers[i] }}</span>\n          </td>\n          <td *ngFor=\"let day of week.days\" role=\"gridcell\">\n          <span bsDatepickerDayDecorator\n                [day]=\"day\"\n                (click)=\"selectDay(day)\"\n                (mouseenter)=\"hoverDay(day, true)\"\n                (mouseleave)=\"hoverDay(day, false)\">{{ day.label }}</span>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n\n    </bs-calendar-layout>\n  "
	        })
	    ], BsDaysCalendarViewComponent);
	    return BsDaysCalendarViewComponent;
	    var _a, _b;
	}());
	
	
	
	/***/ }),
	/* 196 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsMonthCalendarViewComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_index__ = __webpack_require__(32);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	var BsMonthCalendarViewComponent = (function () {
	    function BsMonthCalendarViewComponent() {
	        this.onNavigate = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.onViewMode = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.onSelect = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.onHover = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	    }
	    BsMonthCalendarViewComponent.prototype.navigateTo = function (event) {
	        var step = __WEBPACK_IMPORTED_MODULE_1__models_index__["a" /* BsNavigationDirection */].DOWN === event ? -1 : 1;
	        this.onNavigate.emit({ step: { year: step } });
	    };
	    BsMonthCalendarViewComponent.prototype.viewMonth = function (month) {
	        this.onSelect.emit(month);
	    };
	    BsMonthCalendarViewComponent.prototype.hoverMonth = function (cell, isHovered) {
	        this.onHover.emit({ cell: cell, isHovered: isHovered });
	    };
	    BsMonthCalendarViewComponent.prototype.changeViewMode = function (event) {
	        this.onViewMode.emit(event);
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_1__models_index__["MonthsCalendarViewModel"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_1__models_index__["MonthsCalendarViewModel"]) === "function" && _a || Object)
	    ], BsMonthCalendarViewComponent.prototype, "calendar", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], BsMonthCalendarViewComponent.prototype, "onNavigate", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], BsMonthCalendarViewComponent.prototype, "onViewMode", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], BsMonthCalendarViewComponent.prototype, "onSelect", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], BsMonthCalendarViewComponent.prototype, "onHover", void 0);
	    BsMonthCalendarViewComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'bs-month-calendar-view',
	            template: "\n    <bs-calendar-layout>\n      <bs-datepicker-navigation-view\n        [calendar]=\"calendar\"\n        (onNavigate)=\"navigateTo($event)\"\n        (onViewMode)=\"changeViewMode($event)\"\n      ></bs-datepicker-navigation-view>\n\n      <table role=\"grid\" class=\"months\">\n        <tbody>\n        <tr *ngFor=\"let row of calendar.months\">\n          <td *ngFor=\"let month of row\" role=\"gridcell\"\n              (click)=\"viewMonth(month)\"\n              (mouseenter)=\"hoverMonth(month, true)\"\n              (mouseleave)=\"hoverMonth(month, false)\"\n              [class.disabled]=\"month.isDisabled\"\n              [class.is-highlighted]=\"month.isHovered\">\n            <span>{{ month.label }}</span>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </bs-calendar-layout>\n  "
	        })
	    ], BsMonthCalendarViewComponent);
	    return BsMonthCalendarViewComponent;
	    var _a;
	}());
	
	
	
	/***/ }),
	/* 197 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsTimepickerViewComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	// tslint:disable:max-line-length
	
	var BsTimepickerViewComponent = (function () {
	    function BsTimepickerViewComponent() {
	        this.ampm = 'ok';
	        this.hours = 0;
	        this.minutes = 0;
	    }
	    BsTimepickerViewComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'bs-timepicker',
	            template: "\n    <div class=\"bs-timepicker-container\">\n      <div class=\"bs-timepicker-controls\">\n        <button class=\"bs-decrease\">-</button>\n        <input type=\"text\" [value]=\"hours\" placeholder=\"00\">\n        <button class=\"bs-increase\">+</button>\n      </div>\n      <div class=\"bs-timepicker-controls\">\n        <button class=\"bs-decrease\">-</button>\n        <input type=\"text\" [value]=\"minutes\" placeholder=\"00\">\n        <button class=\"bs-increase\">+</button>\n      </div>\n      <button class=\"switch-time-format\">{{ ampm }}\n        <img\n          src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKCAYAAABi8KSDAAABSElEQVQYV3XQPUvDUBQG4HNuagtVqc6KgouCv6GIuIntYBLB9hcIQpLStCAIV7DYmpTcRWcXqZio3Vwc/UCc/QEqfgyKGbr0I7nS1EiHeqYzPO/h5SD0jaxUZjmSLCB+OFb+UFINFwASAEAdpu9gaGXVyAHHFQBkHpKHc6a9dzECvADyY9sqlAMsK9W0jzxDXqeytr3mhQckxSji27TJJ5/rPmIpwJJq3HrtduriYOurv1a4i1p5HnhkG9OFymi0ReoO05cGwb+ayv4dysVygjeFmsP05f8wpZQ8fsdvfmuY9zjWSNqUtgYFVnOVReILYoBFzdQI5/GGFzNHhGbeZnopDGU29sZbscgldmC99w35VOATTycIMMcBXIfpSVGzZhA6C8hh00conln6VQ9TGgV32OEAKQC4DrBq7CJwd0ggR7Vq/rPrfgB+C3sGypY5DAAAAABJRU5ErkJggg==\"\n          alt=\"\">\n      </button>\n    </div>\n  "
	        })
	    ], BsTimepickerViewComponent);
	    return BsTimepickerViewComponent;
	}());
	
	
	
	/***/ }),
	/* 198 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsYearsCalendarViewComponent; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__engine_format_years_calendar__ = __webpack_require__(117);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_index__ = __webpack_require__(32);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	var BsYearsCalendarViewComponent = (function () {
	    function BsYearsCalendarViewComponent() {
	        this.onNavigate = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.onViewMode = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.onSelect = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this.onHover = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	    }
	    BsYearsCalendarViewComponent.prototype.navigateTo = function (event) {
	        var step = __WEBPACK_IMPORTED_MODULE_2__models_index__["a" /* BsNavigationDirection */].DOWN === event ? -1 : 1;
	        this.onNavigate.emit({ step: { year: step * __WEBPACK_IMPORTED_MODULE_1__engine_format_years_calendar__["b" /* yearsPerCalendar */] } });
	    };
	    BsYearsCalendarViewComponent.prototype.viewYear = function (year) {
	        this.onSelect.emit(year);
	    };
	    BsYearsCalendarViewComponent.prototype.hoverYear = function (cell, isHovered) {
	        this.onHover.emit({ cell: cell, isHovered: isHovered });
	    };
	    BsYearsCalendarViewComponent.prototype.changeViewMode = function (event) {
	        this.onViewMode.emit(event);
	    };
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	        __metadata("design:type", typeof (_a = typeof __WEBPACK_IMPORTED_MODULE_2__models_index__["YearsCalendarViewModel"] !== "undefined" && __WEBPACK_IMPORTED_MODULE_2__models_index__["YearsCalendarViewModel"]) === "function" && _a || Object)
	    ], BsYearsCalendarViewComponent.prototype, "calendar", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], BsYearsCalendarViewComponent.prototype, "onNavigate", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], BsYearsCalendarViewComponent.prototype, "onViewMode", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], BsYearsCalendarViewComponent.prototype, "onSelect", void 0);
	    __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
	        __metadata("design:type", Object)
	    ], BsYearsCalendarViewComponent.prototype, "onHover", void 0);
	    BsYearsCalendarViewComponent = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
	            selector: 'bs-years-calendar-view',
	            template: "\n    <bs-calendar-layout>\n      <bs-datepicker-navigation-view\n        [calendar]=\"calendar\"\n        (onNavigate)=\"navigateTo($event)\"\n        (onViewMode)=\"changeViewMode($event)\"\n      ></bs-datepicker-navigation-view>\n\n      <table role=\"grid\" class=\"years\">\n        <tbody>\n        <tr *ngFor=\"let row of calendar.years\">\n          <td *ngFor=\"let year of row\" role=\"gridcell\"\n              (click)=\"viewYear(year)\"\n              (mouseenter)=\"hoverYear(year, true)\"\n              (mouseleave)=\"hoverYear(year, false)\"\n              [class.disabled]=\"year.isDisabled\"\n              [class.is-highlighted]=\"year.isHovered\">\n            <span>{{ year.label }}</span>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </bs-calendar-layout>\n  "
	        })
	    ], BsYearsCalendarViewComponent);
	    return BsYearsCalendarViewComponent;
	    var _a;
	}());
	
	
	
	/***/ }),
	/* 199 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bs_modal_ref_service__ = __webpack_require__(119);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__bs_modal_ref_service__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_backdrop_options__ = __webpack_require__(200);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__modal_backdrop_options__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_container_component__ = __webpack_require__(70);
	/* unused harmony reexport ModalContainerComponent */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_backdrop_component__ = __webpack_require__(40);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__modal_backdrop_component__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_options_class__ = __webpack_require__(33);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__modal_options_class__["c"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal_directive__ = __webpack_require__(120);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__modal_directive__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modal_module__ = __webpack_require__(201);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__modal_module__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bs_modal_service__ = __webpack_require__(121);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__bs_modal_service__["a"]; });
	
	
	
	
	
	
	
	
	
	
	/***/ }),
	/* 200 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalBackdropOptions; });
	var ModalBackdropOptions = (function () {
	    function ModalBackdropOptions(options) {
	        this.animate = true;
	        Object.assign(this, options);
	    }
	    return ModalBackdropOptions;
	}());
	
	
	
	/***/ }),
	/* 201 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalModule; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_backdrop_component__ = __webpack_require__(40);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_directive__ = __webpack_require__(120);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__positioning_index__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component_loader_index__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal_container_component__ = __webpack_require__(70);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bs_modal_service__ = __webpack_require__(121);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	
	
	
	
	
	var ModalModule = (function () {
	    function ModalModule() {
	    }
	    ModalModule_1 = ModalModule;
	    ModalModule.forRoot = function () {
	        return {
	            ngModule: ModalModule_1,
	            providers: [__WEBPACK_IMPORTED_MODULE_6__bs_modal_service__["a" /* BsModalService */], __WEBPACK_IMPORTED_MODULE_4__component_loader_index__["b" /* ComponentLoaderFactory */], __WEBPACK_IMPORTED_MODULE_3__positioning_index__["c" /* PositioningService */]]
	        };
	    };
	    ModalModule = ModalModule_1 = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
	            declarations: [
	                __WEBPACK_IMPORTED_MODULE_1__modal_backdrop_component__["a" /* ModalBackdropComponent */],
	                __WEBPACK_IMPORTED_MODULE_2__modal_directive__["a" /* ModalDirective */],
	                __WEBPACK_IMPORTED_MODULE_5__modal_container_component__["a" /* ModalContainerComponent */]
	            ],
	            exports: [__WEBPACK_IMPORTED_MODULE_1__modal_backdrop_component__["a" /* ModalBackdropComponent */], __WEBPACK_IMPORTED_MODULE_2__modal_directive__["a" /* ModalDirective */]],
	            entryComponents: [__WEBPACK_IMPORTED_MODULE_1__modal_backdrop_component__["a" /* ModalBackdropComponent */], __WEBPACK_IMPORTED_MODULE_5__modal_container_component__["a" /* ModalContainerComponent */]]
	        })
	    ], ModalModule);
	    return ModalModule;
	    var ModalModule_1;
	}());
	
	
	
	/***/ }),
	/* 202 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bs_dropdown_directive__ = __webpack_require__(122);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__bs_dropdown_directive__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bs_dropdown_menu_directive__ = __webpack_require__(123);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__bs_dropdown_menu_directive__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bs_dropdown_toggle_directive__ = __webpack_require__(124);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__bs_dropdown_toggle_directive__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bs_dropdown_container_component__ = __webpack_require__(72);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__bs_dropdown_container_component__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bs_dropdown_state__ = __webpack_require__(25);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__bs_dropdown_state__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bs_dropdown_config__ = __webpack_require__(71);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__bs_dropdown_config__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bs_dropdown_module__ = __webpack_require__(203);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__bs_dropdown_module__["a"]; });
	
	
	
	
	
	
	
	
	
	/***/ }),
	/* 203 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BsDropdownModule; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_loader_index__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__positioning_index__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bs_dropdown_container_component__ = __webpack_require__(72);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bs_dropdown_menu_directive__ = __webpack_require__(123);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bs_dropdown_toggle_directive__ = __webpack_require__(124);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bs_dropdown_config__ = __webpack_require__(71);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bs_dropdown_directive__ = __webpack_require__(122);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bs_dropdown_state__ = __webpack_require__(25);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	
	
	
	
	
	
	
	var BsDropdownModule = (function () {
	    function BsDropdownModule() {
	    }
	    BsDropdownModule_1 = BsDropdownModule;
	    BsDropdownModule.forRoot = function (config) {
	        return {
	            ngModule: BsDropdownModule_1,
	            providers: [
	                __WEBPACK_IMPORTED_MODULE_1__component_loader_index__["b" /* ComponentLoaderFactory */],
	                __WEBPACK_IMPORTED_MODULE_2__positioning_index__["c" /* PositioningService */],
	                __WEBPACK_IMPORTED_MODULE_8__bs_dropdown_state__["a" /* BsDropdownState */],
	                {
	                    provide: __WEBPACK_IMPORTED_MODULE_6__bs_dropdown_config__["a" /* BsDropdownConfig */],
	                    useValue: config ? config : { autoClose: true }
	                }
	            ]
	        };
	    };
	    BsDropdownModule = BsDropdownModule_1 = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
	            declarations: [
	                __WEBPACK_IMPORTED_MODULE_4__bs_dropdown_menu_directive__["a" /* BsDropdownMenuDirective */],
	                __WEBPACK_IMPORTED_MODULE_5__bs_dropdown_toggle_directive__["a" /* BsDropdownToggleDirective */],
	                __WEBPACK_IMPORTED_MODULE_3__bs_dropdown_container_component__["a" /* BsDropdownContainerComponent */],
	                __WEBPACK_IMPORTED_MODULE_7__bs_dropdown_directive__["a" /* BsDropdownDirective */]
	            ],
	            exports: [
	                __WEBPACK_IMPORTED_MODULE_4__bs_dropdown_menu_directive__["a" /* BsDropdownMenuDirective */],
	                __WEBPACK_IMPORTED_MODULE_5__bs_dropdown_toggle_directive__["a" /* BsDropdownToggleDirective */],
	                __WEBPACK_IMPORTED_MODULE_7__bs_dropdown_directive__["a" /* BsDropdownDirective */]
	            ],
	            entryComponents: [__WEBPACK_IMPORTED_MODULE_3__bs_dropdown_container_component__["a" /* BsDropdownContainerComponent */]]
	        })
	    ], BsDropdownModule);
	    return BsDropdownModule;
	    var BsDropdownModule_1;
	}());
	
	
	
	/***/ }),
	/* 204 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pager_component__ = __webpack_require__(125);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__pager_component__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pagination_component__ = __webpack_require__(126);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__pagination_component__["b"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__pagination_component__["PageChangedEvent"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pagination_module__ = __webpack_require__(205);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__pagination_module__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pagination_config__ = __webpack_require__(41);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__pagination_config__["a"]; });
	
	
	
	
	
	
	/***/ }),
	/* 205 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaginationModule; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_common__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pagination_config__ = __webpack_require__(41);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pager_component__ = __webpack_require__(125);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pagination_component__ = __webpack_require__(126);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	
	
	
	var PaginationModule = (function () {
	    function PaginationModule() {
	    }
	    PaginationModule_1 = PaginationModule;
	    PaginationModule.forRoot = function () {
	        return { ngModule: PaginationModule_1, providers: [__WEBPACK_IMPORTED_MODULE_2__pagination_config__["a" /* PaginationConfig */]] };
	    };
	    PaginationModule = PaginationModule_1 = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
	            imports: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["CommonModule"]],
	            declarations: [__WEBPACK_IMPORTED_MODULE_3__pager_component__["a" /* PagerComponent */], __WEBPACK_IMPORTED_MODULE_4__pagination_component__["b" /* PaginationComponent */]],
	            exports: [__WEBPACK_IMPORTED_MODULE_3__pager_component__["a" /* PagerComponent */], __WEBPACK_IMPORTED_MODULE_4__pagination_component__["b" /* PaginationComponent */]]
	        })
	    ], PaginationModule);
	    return PaginationModule;
	    var PaginationModule_1;
	}());
	
	
	
	/***/ }),
	/* 206 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bar_component__ = __webpack_require__(127);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__bar_component__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progressbar_component__ = __webpack_require__(73);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__progressbar_component__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progressbar_module__ = __webpack_require__(207);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__progressbar_module__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progressbar_config__ = __webpack_require__(74);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__progressbar_config__["a"]; });
	
	
	
	
	
	
	/***/ }),
	/* 207 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProgressbarModule; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_common__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bar_component__ = __webpack_require__(127);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progressbar_component__ = __webpack_require__(73);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progressbar_config__ = __webpack_require__(74);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	
	
	
	var ProgressbarModule = (function () {
	    function ProgressbarModule() {
	    }
	    ProgressbarModule_1 = ProgressbarModule;
	    ProgressbarModule.forRoot = function () {
	        return { ngModule: ProgressbarModule_1, providers: [__WEBPACK_IMPORTED_MODULE_4__progressbar_config__["a" /* ProgressbarConfig */]] };
	    };
	    ProgressbarModule = ProgressbarModule_1 = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
	            imports: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["CommonModule"]],
	            declarations: [__WEBPACK_IMPORTED_MODULE_2__bar_component__["a" /* BarComponent */], __WEBPACK_IMPORTED_MODULE_3__progressbar_component__["a" /* ProgressbarComponent */]],
	            exports: [__WEBPACK_IMPORTED_MODULE_2__bar_component__["a" /* BarComponent */], __WEBPACK_IMPORTED_MODULE_3__progressbar_component__["a" /* ProgressbarComponent */]]
	        })
	    ], ProgressbarModule);
	    return ProgressbarModule;
	    var ProgressbarModule_1;
	}());
	
	
	
	/***/ }),
	/* 208 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rating_component__ = __webpack_require__(128);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__rating_component__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rating_module__ = __webpack_require__(209);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__rating_module__["a"]; });
	
	
	
	
	/***/ }),
	/* 209 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RatingModule; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_common__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rating_component__ = __webpack_require__(128);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	
	var RatingModule = (function () {
	    function RatingModule() {
	    }
	    RatingModule_1 = RatingModule;
	    RatingModule.forRoot = function () {
	        return {
	            ngModule: RatingModule_1,
	            providers: []
	        };
	    };
	    RatingModule = RatingModule_1 = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
	            imports: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["CommonModule"]],
	            declarations: [__WEBPACK_IMPORTED_MODULE_2__rating_component__["a" /* RatingComponent */]],
	            exports: [__WEBPACK_IMPORTED_MODULE_2__rating_component__["a" /* RatingComponent */]]
	        })
	    ], RatingModule);
	    return RatingModule;
	    var RatingModule_1;
	}());
	
	
	
	/***/ }),
	/* 210 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sortable_module__ = __webpack_require__(211);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__sortable_module__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sortable_component__ = __webpack_require__(129);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__sortable_component__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__sortable_component__["SortableItem"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__draggable_item_service__ = __webpack_require__(75);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__draggable_item_service__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__draggable_item__ = __webpack_require__(213);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__draggable_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__draggable_item__);
	/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_3__draggable_item__, "DraggableItem")) __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__draggable_item__["DraggableItem"]; });
	
	
	
	
	
	
	/***/ }),
	/* 211 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SortableModule; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_common__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sortable_component__ = __webpack_require__(129);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__draggable_item_service__ = __webpack_require__(75);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	
	
	var SortableModule = (function () {
	    function SortableModule() {
	    }
	    SortableModule_1 = SortableModule;
	    SortableModule.forRoot = function () {
	        return { ngModule: SortableModule_1, providers: [__WEBPACK_IMPORTED_MODULE_3__draggable_item_service__["a" /* DraggableItemService */]] };
	    };
	    SortableModule = SortableModule_1 = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
	            declarations: [__WEBPACK_IMPORTED_MODULE_2__sortable_component__["a" /* SortableComponent */]],
	            imports: [__WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"]],
	            exports: [__WEBPACK_IMPORTED_MODULE_2__sortable_component__["a" /* SortableComponent */]]
	        })
	    ], SortableModule);
	    return SortableModule;
	    var SortableModule_1;
	}());
	
	
	
	/***/ }),
	/* 212 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_212__;
	
	/***/ }),
	/* 213 */
	/***/ (function(module, exports) {
	
	
	
	/***/ }),
	/* 214 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ng_transclude_directive__ = __webpack_require__(130);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ng_transclude_directive__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tab_directive__ = __webpack_require__(76);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__tab_directive__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tab_heading_directive__ = __webpack_require__(131);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__tab_heading_directive__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tabset_component__ = __webpack_require__(77);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__tabset_component__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tabset_config__ = __webpack_require__(78);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__tabset_config__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tabs_module__ = __webpack_require__(215);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__tabs_module__["a"]; });
	
	
	
	
	
	
	
	
	/***/ }),
	/* 215 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabsModule; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_common__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ng_transclude_directive__ = __webpack_require__(130);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tab_heading_directive__ = __webpack_require__(131);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tab_directive__ = __webpack_require__(76);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tabset_component__ = __webpack_require__(77);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tabset_config__ = __webpack_require__(78);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	
	
	
	
	
	var TabsModule = (function () {
	    function TabsModule() {
	    }
	    TabsModule_1 = TabsModule;
	    TabsModule.forRoot = function () {
	        return {
	            ngModule: TabsModule_1,
	            providers: [__WEBPACK_IMPORTED_MODULE_6__tabset_config__["a" /* TabsetConfig */]]
	        };
	    };
	    TabsModule = TabsModule_1 = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
	            imports: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["CommonModule"]],
	            declarations: [
	                __WEBPACK_IMPORTED_MODULE_2__ng_transclude_directive__["a" /* NgTranscludeDirective */],
	                __WEBPACK_IMPORTED_MODULE_4__tab_directive__["a" /* TabDirective */],
	                __WEBPACK_IMPORTED_MODULE_5__tabset_component__["a" /* TabsetComponent */],
	                __WEBPACK_IMPORTED_MODULE_3__tab_heading_directive__["a" /* TabHeadingDirective */]
	            ],
	            exports: [
	                __WEBPACK_IMPORTED_MODULE_4__tab_directive__["a" /* TabDirective */],
	                __WEBPACK_IMPORTED_MODULE_5__tabset_component__["a" /* TabsetComponent */],
	                __WEBPACK_IMPORTED_MODULE_3__tab_heading_directive__["a" /* TabHeadingDirective */],
	                __WEBPACK_IMPORTED_MODULE_2__ng_transclude_directive__["a" /* NgTranscludeDirective */]
	            ]
	        })
	    ], TabsModule);
	    return TabsModule;
	    var TabsModule_1;
	}());
	
	
	
	/***/ }),
	/* 216 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timepicker_component__ = __webpack_require__(132);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__timepicker_component__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer_timepicker_actions__ = __webpack_require__(42);
	/* unused harmony reexport TimepickerActions */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer_timepicker_store__ = __webpack_require__(79);
	/* unused harmony reexport TimepickerStore */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timepicker_config__ = __webpack_require__(43);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__timepicker_config__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__timepicker_module__ = __webpack_require__(219);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__timepicker_module__["a"]; });
	
	
	
	
	
	
	
	/***/ }),
	/* 217 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* unused harmony export TimepickerState */
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initialState; });
	/* harmony export (immutable) */ __webpack_exports__["b"] = timepickerReducer;
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timepicker_controls_util__ = __webpack_require__(133);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timepicker_config__ = __webpack_require__(43);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timepicker_utils__ = __webpack_require__(80);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timepicker_actions__ = __webpack_require__(42);
	
	
	
	
	var TimepickerState = (function () {
	    function TimepickerState() {
	    }
	    return TimepickerState;
	}());
	
	var initialState = {
	    value: null,
	    config: new __WEBPACK_IMPORTED_MODULE_1__timepicker_config__["a" /* TimepickerConfig */](),
	    controls: {
	        canIncrementHours: true,
	        canIncrementMinutes: true,
	        canIncrementSeconds: true,
	        canDecrementHours: true,
	        canDecrementMinutes: true,
	        canDecrementSeconds: true,
	        canToggleMeridian: true
	    }
	};
	function timepickerReducer(state, action) {
	    if (state === void 0) { state = initialState; }
	    switch (action.type) {
	        case __WEBPACK_IMPORTED_MODULE_3__timepicker_actions__["a" /* TimepickerActions */].WRITE_VALUE: {
	            return Object.assign({}, state, { value: action.payload });
	        }
	        case __WEBPACK_IMPORTED_MODULE_3__timepicker_actions__["a" /* TimepickerActions */].CHANGE_HOURS: {
	            if (!Object(__WEBPACK_IMPORTED_MODULE_0__timepicker_controls_util__["d" /* canChangeValue */])(state.config, action.payload) ||
	                !Object(__WEBPACK_IMPORTED_MODULE_0__timepicker_controls_util__["a" /* canChangeHours */])(action.payload, state.controls)) {
	                return state;
	            }
	            var _newTime = Object(__WEBPACK_IMPORTED_MODULE_2__timepicker_utils__["a" /* changeTime */])(state.value, { hour: action.payload.step });
	            if ((state.config.max || state.config.min) && !Object(__WEBPACK_IMPORTED_MODULE_2__timepicker_utils__["h" /* isValidLimit */])(state.config, _newTime)) {
	                return state;
	            }
	            return Object.assign({}, state, { value: _newTime });
	        }
	        case __WEBPACK_IMPORTED_MODULE_3__timepicker_actions__["a" /* TimepickerActions */].CHANGE_MINUTES: {
	            if (!Object(__WEBPACK_IMPORTED_MODULE_0__timepicker_controls_util__["d" /* canChangeValue */])(state.config, action.payload) ||
	                !Object(__WEBPACK_IMPORTED_MODULE_0__timepicker_controls_util__["b" /* canChangeMinutes */])(action.payload, state.controls)) {
	                return state;
	            }
	            var _newTime = Object(__WEBPACK_IMPORTED_MODULE_2__timepicker_utils__["a" /* changeTime */])(state.value, { minute: action.payload.step });
	            if ((state.config.max || state.config.min) && !Object(__WEBPACK_IMPORTED_MODULE_2__timepicker_utils__["h" /* isValidLimit */])(state.config, _newTime)) {
	                return state;
	            }
	            return Object.assign({}, state, { value: _newTime });
	        }
	        case __WEBPACK_IMPORTED_MODULE_3__timepicker_actions__["a" /* TimepickerActions */].CHANGE_SECONDS: {
	            if (!Object(__WEBPACK_IMPORTED_MODULE_0__timepicker_controls_util__["d" /* canChangeValue */])(state.config, action.payload) ||
	                !Object(__WEBPACK_IMPORTED_MODULE_0__timepicker_controls_util__["c" /* canChangeSeconds */])(action.payload, state.controls)) {
	                return state;
	            }
	            var _newTime = Object(__WEBPACK_IMPORTED_MODULE_2__timepicker_utils__["a" /* changeTime */])(state.value, {
	                seconds: action.payload.step
	            });
	            if ((state.config.max || state.config.min) && !Object(__WEBPACK_IMPORTED_MODULE_2__timepicker_utils__["h" /* isValidLimit */])(state.config, _newTime)) {
	                return state;
	            }
	            return Object.assign({}, state, { value: _newTime });
	        }
	        case __WEBPACK_IMPORTED_MODULE_3__timepicker_actions__["a" /* TimepickerActions */].SET_TIME_UNIT: {
	            if (!Object(__WEBPACK_IMPORTED_MODULE_0__timepicker_controls_util__["d" /* canChangeValue */])(state.config)) {
	                return state;
	            }
	            var _newTime = Object(__WEBPACK_IMPORTED_MODULE_2__timepicker_utils__["k" /* setTime */])(state.value, action.payload);
	            return Object.assign({}, state, { value: _newTime });
	        }
	        case __WEBPACK_IMPORTED_MODULE_3__timepicker_actions__["a" /* TimepickerActions */].UPDATE_CONTROLS: {
	            var _newControlsState = Object(__WEBPACK_IMPORTED_MODULE_0__timepicker_controls_util__["f" /* timepickerControls */])(state.value, action.payload);
	            var _newState = {
	                value: state.value,
	                config: action.payload,
	                controls: _newControlsState
	            };
	            if (state.config.showMeridian !== _newState.config.showMeridian) {
	                if (state.value) {
	                    _newState.value = new Date(state.value);
	                }
	            }
	            return Object.assign({}, state, _newState);
	        }
	        default:
	            return state;
	    }
	}
	
	
	/***/ }),
	/* 218 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_class__ = __webpack_require__(116);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__state_class__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_class__ = __webpack_require__(114);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__store_class__["a"]; });
	
	
	
	
	/***/ }),
	/* 219 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimepickerModule; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_common__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timepicker_component__ = __webpack_require__(132);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer_timepicker_actions__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__timepicker_config__ = __webpack_require__(43);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducer_timepicker_store__ = __webpack_require__(79);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	
	
	
	
	var TimepickerModule = (function () {
	    function TimepickerModule() {
	    }
	    TimepickerModule_1 = TimepickerModule;
	    TimepickerModule.forRoot = function () {
	        return {
	            ngModule: TimepickerModule_1,
	            providers: [__WEBPACK_IMPORTED_MODULE_4__timepicker_config__["a" /* TimepickerConfig */], __WEBPACK_IMPORTED_MODULE_3__reducer_timepicker_actions__["a" /* TimepickerActions */], __WEBPACK_IMPORTED_MODULE_5__reducer_timepicker_store__["a" /* TimepickerStore */]]
	        };
	    };
	    TimepickerModule = TimepickerModule_1 = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
	            imports: [__WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"]],
	            declarations: [__WEBPACK_IMPORTED_MODULE_2__timepicker_component__["a" /* TimepickerComponent */]],
	            exports: [__WEBPACK_IMPORTED_MODULE_2__timepicker_component__["a" /* TimepickerComponent */]]
	        })
	    ], TimepickerModule);
	    return TimepickerModule;
	    var TimepickerModule_1;
	}());
	
	
	
	/***/ }),
	/* 220 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tooltip_container_component__ = __webpack_require__(81);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__tooltip_container_component__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tooltip_directive__ = __webpack_require__(134);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__tooltip_directive__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tooltip_module__ = __webpack_require__(222);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__tooltip_module__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tooltip_config__ = __webpack_require__(44);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__tooltip_config__["a"]; });
	
	
	
	
	
	
	/***/ }),
	/* 221 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_221__;
	
	/***/ }),
	/* 222 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TooltipModule; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_common__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tooltip_container_component__ = __webpack_require__(81);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tooltip_directive__ = __webpack_require__(134);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tooltip_config__ = __webpack_require__(44);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_loader_index__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__positioning_index__ = __webpack_require__(21);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	
	
	
	
	
	var TooltipModule = (function () {
	    function TooltipModule() {
	    }
	    TooltipModule_1 = TooltipModule;
	    TooltipModule.forRoot = function () {
	        return {
	            ngModule: TooltipModule_1,
	            providers: [__WEBPACK_IMPORTED_MODULE_4__tooltip_config__["a" /* TooltipConfig */], __WEBPACK_IMPORTED_MODULE_5__component_loader_index__["b" /* ComponentLoaderFactory */], __WEBPACK_IMPORTED_MODULE_6__positioning_index__["c" /* PositioningService */]]
	        };
	    };
	    TooltipModule = TooltipModule_1 = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
	            imports: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["CommonModule"]],
	            declarations: [__WEBPACK_IMPORTED_MODULE_3__tooltip_directive__["a" /* TooltipDirective */], __WEBPACK_IMPORTED_MODULE_2__tooltip_container_component__["a" /* TooltipContainerComponent */]],
	            exports: [__WEBPACK_IMPORTED_MODULE_3__tooltip_directive__["a" /* TooltipDirective */]],
	            entryComponents: [__WEBPACK_IMPORTED_MODULE_2__tooltip_container_component__["a" /* TooltipContainerComponent */]]
	        })
	    ], TooltipModule);
	    return TooltipModule;
	    var TooltipModule_1;
	}());
	
	
	
	/***/ }),
	/* 223 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__latin_map__ = __webpack_require__(135);
	/* unused harmony reexport latinMap */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typeahead_options_class__ = __webpack_require__(224);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__typeahead_options_class__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typeahead_match_class__ = __webpack_require__(136);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__typeahead_match_class__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typeahead_utils__ = __webpack_require__(82);
	/* unused harmony reexport escapeRegexp */
	/* unused harmony reexport getValueFromObject */
	/* unused harmony reexport tokenize */
	/* unused harmony reexport latinize */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__typeahead_container_component__ = __webpack_require__(83);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__typeahead_container_component__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__typeahead_directive__ = __webpack_require__(137);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__typeahead_directive__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__typeahead_module__ = __webpack_require__(230);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__typeahead_module__["a"]; });
	
	
	
	
	
	
	
	
	
	/***/ }),
	/* 224 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TypeaheadOptions; });
	var TypeaheadOptions = (function () {
	    function TypeaheadOptions(options) {
	        Object.assign(this, options);
	    }
	    return TypeaheadOptions;
	}());
	
	
	
	/***/ }),
	/* 225 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_225__;
	
	/***/ }),
	/* 226 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_226__;
	
	/***/ }),
	/* 227 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_227__;
	
	/***/ }),
	/* 228 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_228__;
	
	/***/ }),
	/* 229 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_229__;
	
	/***/ }),
	/* 230 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TypeaheadModule; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_common__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typeahead_container_component__ = __webpack_require__(83);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typeahead_directive__ = __webpack_require__(137);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component_loader_index__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__positioning_index__ = __webpack_require__(21);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	
	
	
	
	var TypeaheadModule = (function () {
	    function TypeaheadModule() {
	    }
	    TypeaheadModule_1 = TypeaheadModule;
	    TypeaheadModule.forRoot = function () {
	        return {
	            ngModule: TypeaheadModule_1,
	            providers: [__WEBPACK_IMPORTED_MODULE_4__component_loader_index__["b" /* ComponentLoaderFactory */], __WEBPACK_IMPORTED_MODULE_5__positioning_index__["c" /* PositioningService */]]
	        };
	    };
	    TypeaheadModule = TypeaheadModule_1 = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
	            imports: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["CommonModule"]],
	            declarations: [__WEBPACK_IMPORTED_MODULE_2__typeahead_container_component__["a" /* TypeaheadContainerComponent */], __WEBPACK_IMPORTED_MODULE_3__typeahead_directive__["a" /* TypeaheadDirective */]],
	            exports: [__WEBPACK_IMPORTED_MODULE_2__typeahead_container_component__["a" /* TypeaheadContainerComponent */], __WEBPACK_IMPORTED_MODULE_3__typeahead_directive__["a" /* TypeaheadDirective */]],
	            entryComponents: [__WEBPACK_IMPORTED_MODULE_2__typeahead_container_component__["a" /* TypeaheadContainerComponent */]]
	        })
	    ], TypeaheadModule);
	    return TypeaheadModule;
	    var TypeaheadModule_1;
	}());
	
	
	
	/***/ }),
	/* 231 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__popover_directive__ = __webpack_require__(138);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__popover_directive__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popover_module__ = __webpack_require__(232);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__popover_module__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__popover_config__ = __webpack_require__(45);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__popover_config__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__popover_container_component__ = __webpack_require__(84);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__popover_container_component__["a"]; });
	
	
	
	
	
	
	/***/ }),
	/* 232 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopoverModule; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_common__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_loader_index__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__positioning_index__ = __webpack_require__(21);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__popover_config__ = __webpack_require__(45);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__popover_directive__ = __webpack_require__(138);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__popover_container_component__ = __webpack_require__(84);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	
	
	
	
	
	var PopoverModule = (function () {
	    function PopoverModule() {
	    }
	    PopoverModule_1 = PopoverModule;
	    PopoverModule.forRoot = function () {
	        return {
	            ngModule: PopoverModule_1,
	            providers: [__WEBPACK_IMPORTED_MODULE_4__popover_config__["a" /* PopoverConfig */], __WEBPACK_IMPORTED_MODULE_2__component_loader_index__["b" /* ComponentLoaderFactory */], __WEBPACK_IMPORTED_MODULE_3__positioning_index__["c" /* PositioningService */]]
	        };
	    };
	    PopoverModule = PopoverModule_1 = __decorate([
	        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
	            imports: [__WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"]],
	            declarations: [__WEBPACK_IMPORTED_MODULE_5__popover_directive__["a" /* PopoverDirective */], __WEBPACK_IMPORTED_MODULE_6__popover_container_component__["a" /* PopoverContainerComponent */]],
	            exports: [__WEBPACK_IMPORTED_MODULE_5__popover_directive__["a" /* PopoverDirective */]],
	            entryComponents: [__WEBPACK_IMPORTED_MODULE_6__popover_container_component__["a" /* PopoverContainerComponent */]]
	        })
	    ], PopoverModule);
	    return PopoverModule;
	    var PopoverModule_1;
	}());
	
	
	
	/***/ }),
	/* 233 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__units_index__ = __webpack_require__(88);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__moment_add_subtract__ = __webpack_require__(20);
	/* unused harmony reexport add */
	/* unused harmony reexport subtract */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_date_getters__ = __webpack_require__(2);
	/* unused harmony reexport getMonth */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__create_local__ = __webpack_require__(35);
	/* unused harmony reexport parseDate */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__format__ = __webpack_require__(17);
	/* unused harmony reexport formatDate */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__locale_locales__ = __webpack_require__(12);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__locale_locales__["a"]; });
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__locale_locales__["c"]; });
	/* unused harmony reexport listLocales */
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__locale_locale_class__ = __webpack_require__(34);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__locale_locale_class__["LocaleData"]; });
	
	
	
	
	
	
	
	
	
	/***/ }),
	/* 234 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chronos_i18n_ar__ = __webpack_require__(235);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__chronos_i18n_ar__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chronos_i18n_cs__ = __webpack_require__(236);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__chronos_i18n_cs__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chronos_i18n_da__ = __webpack_require__(237);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__chronos_i18n_da__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chronos_i18n_de__ = __webpack_require__(238);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__chronos_i18n_de__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chronos_i18n_en_gb__ = __webpack_require__(239);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__chronos_i18n_en_gb__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chronos_i18n_es__ = __webpack_require__(240);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__chronos_i18n_es__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__chronos_i18n_es_do__ = __webpack_require__(241);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__chronos_i18n_es_do__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chronos_i18n_es_us__ = __webpack_require__(242);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__chronos_i18n_es_us__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chronos_i18n_fi__ = __webpack_require__(243);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__chronos_i18n_fi__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__chronos_i18n_fr__ = __webpack_require__(244);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__chronos_i18n_fr__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__chronos_i18n_hi__ = __webpack_require__(245);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__chronos_i18n_hi__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__chronos_i18n_hu__ = __webpack_require__(246);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_11__chronos_i18n_hu__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__chronos_i18n_id__ = __webpack_require__(247);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_12__chronos_i18n_id__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__chronos_i18n_it__ = __webpack_require__(248);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_13__chronos_i18n_it__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__chronos_i18n_ja__ = __webpack_require__(249);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_14__chronos_i18n_ja__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__chronos_i18n_ko__ = __webpack_require__(250);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_15__chronos_i18n_ko__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__chronos_i18n_mn__ = __webpack_require__(251);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_16__chronos_i18n_mn__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__chronos_i18n_nl__ = __webpack_require__(252);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_17__chronos_i18n_nl__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__chronos_i18n_nl_be__ = __webpack_require__(253);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_18__chronos_i18n_nl_be__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__chronos_i18n_pl__ = __webpack_require__(254);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_19__chronos_i18n_pl__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__chronos_i18n_pt_br__ = __webpack_require__(255);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_20__chronos_i18n_pt_br__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__chronos_i18n_sv__ = __webpack_require__(256);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_21__chronos_i18n_sv__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__chronos_i18n_ru__ = __webpack_require__(257);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_22__chronos_i18n_ru__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__chronos_i18n_ro__ = __webpack_require__(258);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_23__chronos_i18n_ro__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__chronos_i18n_zh_cn__ = __webpack_require__(259);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_24__chronos_i18n_zh_cn__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__chronos_i18n_tr__ = __webpack_require__(260);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_25__chronos_i18n_tr__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__chronos_i18n_he__ = __webpack_require__(261);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_26__chronos_i18n_he__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__chronos_i18n_th__ = __webpack_require__(262);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_27__chronos_i18n_th__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__chronos_i18n_sl__ = __webpack_require__(263);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_28__chronos_i18n_sl__["a"]; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__chronos_i18n_gl__ = __webpack_require__(264);
	/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_29__chronos_i18n_gl__["a"]; });
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	/***/ }),
	/* 235 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return arLocale; });
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	var symbolMap = {
	    1: '١',
	    2: '٢',
	    3: '٣',
	    4: '٤',
	    5: '٥',
	    6: '٦',
	    7: '٧',
	    8: '٨',
	    9: '٩',
	    0: '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (num) {
	    return num === 0 ? 0 : num === 1 ? 1 : num === 2 ? 2 : num % 100 >= 3 && num % 100 <= 10 ? 3 : num % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s: ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m: ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (num, withoutSuffix) {
	        var f = pluralForm(num);
	        var str = plurals[u][pluralForm(num)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, num.toString());
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	var arLocale = {
	    abbr: 'ar',
	    months: months,
	    monthsShort: months,
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'D/\u200FM/\u200FYYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM: function (input) {
	        return 'م' === input;
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        }
	        else {
	            return 'م';
	        }
	    },
	    calendar: {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'بعد %s',
	        past: 'منذ %s',
	        s: pluralize('s'),
	        ss: pluralize('s'),
	        m: pluralize('m'),
	        mm: pluralize('m'),
	        h: pluralize('h'),
	        hh: pluralize('h'),
	        d: pluralize('d'),
	        dd: pluralize('d'),
	        M: pluralize('M'),
	        MM: pluralize('M'),
	        y: pluralize('y'),
	        yy: pluralize('y')
	    },
	    preparse: function (str) {
	        return str.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (str) {
	        return str.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week: {
	        dow: 6,
	        doy: 12 // The week that contains Jan 1st is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 236 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return csLocale; });
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(num) {
	    return (num > 1) && (num < 5) && (~~(num / 10) !== 1);
	}
	function translate(num, withoutSuffix, key, isFuture) {
	    var result = num + ' ';
	    switch (key) {
	        case 's':// a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'ss':// 9 seconds / in 9 seconds / 9 seconds ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(num) ? 'sekundy' : 'sekund');
	            }
	            else {
	                return result + 'sekundami';
	            }
	        // break;
	        case 'm':// a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm':// 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(num) ? 'minuty' : 'minut');
	            }
	            else {
	                return result + 'minutami';
	            }
	        // break;
	        case 'h':// an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh':// 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(num) ? 'hodiny' : 'hodin');
	            }
	            else {
	                return result + 'hodinami';
	            }
	        // break;
	        case 'd':// a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd':// 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(num) ? 'dny' : 'dní');
	            }
	            else {
	                return result + 'dny';
	            }
	        // break;
	        case 'M':// a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM':// 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(num) ? 'měsíce' : 'měsíců');
	            }
	            else {
	                return result + 'měsíci';
	            }
	        // break;
	        case 'y':// a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy':// 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(num) ? 'roky' : 'let');
	            }
	            else {
	                return result + 'lety';
	            }
	    }
	}
	var csLocale = {
	    abbr: 'cs',
	    months: months,
	    monthsShort: monthsShort,
	    monthsParse: (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse: (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse: (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd D. MMMM YYYY H:mm',
	        l: 'D. M. YYYY'
	    },
	    calendar: {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function (dayOfWeek) {
	            switch (dayOfWeek) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function (dayOfWeek) {
	            switch (dayOfWeek) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'za %s',
	        past: 'před %s',
	        s: translate,
	        ss: translate,
	        m: translate,
	        mm: translate,
	        h: translate,
	        hh: translate,
	        d: translate,
	        dd: translate,
	        M: translate,
	        MM: translate,
	        y: translate,
	        yy: translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1,
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 237 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return daLocale; });
	// tslint:disable:comment-format
	//! moment.js locale configuration
	//! locale : Danish (Denmark) [da]
	//! author : Per Hansen : https://github.com/perhp
	var daLocale = {
	    abbr: 'da',
	    months: 'Januar_Februar_Marts_April_Maj_Juni_Juli_August_September_Oktober_November_December'.split('_'),
	    monthsShort: 'Jan_Feb_Mar_Apr_Maj_Jun_Jul_Aug_Sep_Okt_Nov_Dec'.split('_'),
	    weekdays: 'Søndag_Mandag_Tirsdag_Onsdag_Torsdag_Fredag_Lørdag'.split('_'),
	    weekdaysShort: 'Søn_Man_Tir_Ons_Tor_Fre_Lør'.split('_'),
	    weekdaysMin: 'Sø_Ma_Ti_On_To_Fr_Lø'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY HH:mm',
	        LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'på dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[i] dddd[s kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'om %s',
	        past: '%s siden',
	        s: 'få sekunder',
	        m: 'et minut',
	        mm: '%d minutter',
	        h: 'en time',
	        hh: '%d timer',
	        d: 'en dag',
	        dd: '%d dage',
	        M: 'en måned',
	        MM: '%d måneder',
	        y: 'et år',
	        yy: '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1,
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 238 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deLocale; });
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	// tslint:disable:object-literal-key-quotes
	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	function processRelativeTime(num, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [num + ' Tage', num + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [num + ' Monate', num + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [num + ' Jahre', num + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	var deLocale = {
	    abbr: 'de',
	    months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY HH:mm',
	        LLLL: 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime: {
	        future: 'in %s',
	        past: 'vor %s',
	        s: 'ein paar Sekunden',
	        ss: '%d Sekunden',
	        m: processRelativeTime,
	        mm: '%d Minuten',
	        h: processRelativeTime,
	        hh: '%d Stunden',
	        d: processRelativeTime,
	        dd: processRelativeTime,
	        M: processRelativeTime,
	        MM: processRelativeTime,
	        y: processRelativeTime,
	        yy: processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1,
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 239 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return enGbLocale; });
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	var enGbLocale = {
	    abbr: 'en-gb',
	    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal: function (_num) {
	        var num = Number(_num);
	        var b = num % 10, output = (~~(num % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                    (b === 3) ? 'rd' : 'th';
	        return num + output;
	    },
	    week: {
	        dow: 1,
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 240 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return esLocale; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date_getters__ = __webpack_require__(2);
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	
	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'), monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	var esLocale = {
	    abbr: 'es',
	    months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort: function (date, format, isUTC) {
	        if (!date) {
	            return monthsShortDot;
	        }
	        if (/-MMM-/.test(format)) {
	            return monthsShort[Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["h" /* getMonth */])(date, isUTC)];
	        }
	        return monthsShortDot[Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["h" /* getMonth */])(date, isUTC)];
	    },
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse: monthsParse,
	    longMonthsParse: monthsParse,
	    shortMonthsParse: monthsParse,
	    weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D [de] MMMM [de] YYYY',
	        LLL: 'D [de] MMMM [de] YYYY H:mm',
	        LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar: {
	        sameDay: function (date) {
	            return '[hoy a la' + ((Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date) !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay: function (date) {
	            return '[mañana a la' + ((Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date) !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek: function (date) {
	            return 'dddd [a la' + ((Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date) !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay: function (date) {
	            return '[ayer a la' + ((Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date) !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek: function (date) {
	            return '[el] dddd [pasado a la' + ((Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date) !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'en %s',
	        past: 'hace %s',
	        s: 'unos segundos',
	        ss: '%d segundos',
	        m: 'un minuto',
	        mm: '%d minutos',
	        h: 'una hora',
	        hh: '%d horas',
	        d: 'un día',
	        dd: '%d días',
	        M: 'un mes',
	        MM: '%d meses',
	        y: 'un año',
	        yy: '%d años'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week: {
	        dow: 1,
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 241 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return esDoLocale; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date_getters__ = __webpack_require__(2);
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	
	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'), monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	var esDoLocale = {
	    abbr: 'es-do',
	    months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort: function (date, format, isUTC) {
	        if (!date) {
	            return monthsShortDot;
	        }
	        else if (/-MMM-/.test(format)) {
	            return monthsShort[Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["h" /* getMonth */])(date, isUTC)];
	        }
	        else {
	            return monthsShortDot[Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["h" /* getMonth */])(date, isUTC)];
	        }
	    },
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse: monthsParse,
	    longMonthsParse: monthsParse,
	    shortMonthsParse: monthsParse,
	    weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'h:mm A',
	        LTS: 'h:mm:ss A',
	        L: 'DD/MM/YYYY',
	        LL: 'D [de] MMMM [de] YYYY',
	        LLL: 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar: {
	        sameDay: function (date) {
	            return '[hoy a la' + ((Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date) !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay: function (date) {
	            return '[mañana a la' + ((Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date) !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek: function (date) {
	            return 'dddd [a la' + ((Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date) !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay: function (date) {
	            return '[ayer a la' + ((Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date) !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek: function (date) {
	            return '[el] dddd [pasado a la' + ((Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date) !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'en %s',
	        past: 'hace %s',
	        s: 'unos segundos',
	        ss: '%d segundos',
	        m: 'un minuto',
	        mm: '%d minutos',
	        h: 'una hora',
	        hh: '%d horas',
	        d: 'un día',
	        dd: '%d días',
	        M: 'un mes',
	        MM: '%d meses',
	        y: 'un año',
	        yy: '%d años'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week: {
	        dow: 1,
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 242 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return esUsLocale; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date_getters__ = __webpack_require__(2);
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	
	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	var esUsLocale = {
	    abbr: 'es-us',
	    months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort: function (date, format, isUTC) {
	        if (!date) {
	            return monthsShortDot;
	        }
	        else if (/-MMM-/.test(format)) {
	            return monthsShort[Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["h" /* getMonth */])(date, isUTC)];
	        }
	        else {
	            return monthsShortDot[Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["h" /* getMonth */])(date, isUTC)];
	        }
	    },
	    monthsParseExact: true,
	    weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'h:mm A',
	        LTS: 'h:mm:ss A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM [de] D [de] YYYY',
	        LLL: 'MMMM [de] D [de] YYYY h:mm A',
	        LLLL: 'dddd, MMMM [de] D [de] YYYY h:mm A'
	    },
	    calendar: {
	        sameDay: function (date) {
	            return '[hoy a la' + ((Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date) !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay: function (date) {
	            return '[mañana a la' + ((Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date) !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek: function (date) {
	            return 'dddd [a la' + ((Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date) !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay: function (date) {
	            return '[ayer a la' + ((Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date) !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek: function (date) {
	            return '[el] dddd [pasado a la' + ((Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date) !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'en %s',
	        past: 'hace %s',
	        s: 'unos segundos',
	        ss: '%d segundos',
	        m: 'un minuto',
	        mm: '%d minutos',
	        h: 'una hora',
	        hh: '%d horas',
	        d: 'un día',
	        dd: '%d días',
	        M: 'un mes',
	        MM: '%d meses',
	        y: 'un año',
	        yy: '%d años'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week: {
	        dow: 0,
	        doy: 6 // The week that contains Jan 1st is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 243 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fiLocale; });
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	//! moment.js locale configuration
	// https://github.com/moment/moment/blob/develop/locale/fi.js
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '), numbersFuture = [
	    'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	    numbersPast[7], numbersPast[8], numbersPast[9]
	];
	function translate(num, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'ss':
	            return isFuture ? 'sekunnin' : 'sekuntia';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(num, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(num, isFuture) {
	    return num < 10 ? (isFuture ? numbersFuture[num] : numbersPast[num]) : num;
	}
	var fiLocale = {
	    abbr: 'fi',
	    months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat: {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L: 'DD.MM.YYYY',
	        LL: 'Do MMMM[ta] YYYY',
	        LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l: 'D.M.YYYY',
	        ll: 'Do MMM YYYY',
	        lll: 'Do MMM YYYY, [klo] HH.mm',
	        llll: 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar: {
	        sameDay: '[tänään] [klo] LT',
	        nextDay: '[huomenna] [klo] LT',
	        nextWeek: 'dddd [klo] LT',
	        lastDay: '[eilen] [klo] LT',
	        lastWeek: '[viime] dddd[na] [klo] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%s päästä',
	        past: '%s sitten',
	        s: translate,
	        ss: translate,
	        m: translate,
	        mm: translate,
	        h: translate,
	        hh: translate,
	        d: translate,
	        dd: translate,
	        M: translate,
	        MM: translate,
	        y: translate,
	        yy: translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1,
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 244 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return frLocale; });
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	var frLocale = {
	    abbr: 'fr',
	    months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Aujourd’hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'dans %s',
	        past: 'il y a %s',
	        s: 'quelques secondes',
	        ss: '%d secondes',
	        m: 'une minute',
	        mm: '%d minutes',
	        h: 'une heure',
	        hh: '%d heures',
	        d: 'un jour',
	        dd: '%d jours',
	        M: 'un mois',
	        MM: '%d mois',
	        y: 'un an',
	        yy: '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal: function (_num, period) {
	        var num = Number(_num);
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return num + (num === 1 ? 'er' : '');
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return num + (num === 1 ? 'er' : 'e');
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return num + (num === 1 ? 're' : 'e');
	        }
	    },
	    week: {
	        dow: 1,
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 245 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hiLocale; });
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	// tslint:disable:no-parameter-reassignment prefer-switch
	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	var symbolMap = {
	    1: '१',
	    2: '२',
	    3: '३',
	    4: '४',
	    5: '५',
	    6: '६',
	    7: '७',
	    8: '८',
	    9: '९',
	    0: '०'
	}, numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	var hiLocale = {
	    abbr: 'hi',
	    months: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat: {
	        LT: 'A h:mm बजे',
	        LTS: 'A h:mm:ss बजे',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY, A h:mm बजे',
	        LLLL: 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar: {
	        sameDay: '[आज] LT',
	        nextDay: '[कल] LT',
	        nextWeek: 'dddd, LT',
	        lastDay: '[कल] LT',
	        lastWeek: '[पिछले] dddd, LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%s में',
	        past: '%s पहले',
	        s: 'कुछ ही क्षण',
	        ss: '%d सेकंड',
	        m: 'एक मिनट',
	        mm: '%d मिनट',
	        h: 'एक घंटा',
	        hh: '%d घंटे',
	        d: 'एक दिन',
	        dd: '%d दिन',
	        M: 'एक महीने',
	        MM: '%d महीने',
	        y: 'एक वर्ष',
	        yy: '%d वर्ष'
	    },
	    preparse: function (str) {
	        return str.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (str) {
	        return str.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        }
	        else if (meridiem === 'सुबह') {
	            return hour;
	        }
	        else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        }
	        else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        }
	        else if (hour < 10) {
	            return 'सुबह';
	        }
	        else if (hour < 17) {
	            return 'दोपहर';
	        }
	        else if (hour < 20) {
	            return 'शाम';
	        }
	        else {
	            return 'रात';
	        }
	    },
	    week: {
	        dow: 0,
	        doy: 6 // The week that contains Jan 1st is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 246 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return huLocale; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__units_day_of_week__ = __webpack_require__(14);
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	
	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(num, withoutSuffix, key, isFuture) {
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'ss':
	            return num + ((isFuture || withoutSuffix) ? ' másodperc' : ' másodperce');
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(date, isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[Object(__WEBPACK_IMPORTED_MODULE_0__units_day_of_week__["a" /* getDayOfWeek */])(date)] + '] LT[-kor]';
	}
	var huLocale = {
	    abbr: 'hu',
	    months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort: 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'YYYY.MM.DD.',
	        LL: 'YYYY. MMMM D.',
	        LLL: 'YYYY. MMMM D. H:mm',
	        LLLL: 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem: function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        }
	        else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar: {
	        sameDay: '[ma] LT[-kor]',
	        nextDay: '[holnap] LT[-kor]',
	        nextWeek: function (date) {
	            return week(date, true);
	        },
	        lastDay: '[tegnap] LT[-kor]',
	        lastWeek: function (date) {
	            return week(date, false);
	        },
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%s múlva',
	        past: '%s',
	        s: translate,
	        ss: translate,
	        m: translate,
	        mm: translate,
	        h: translate,
	        hh: translate,
	        d: translate,
	        dd: translate,
	        M: translate,
	        MM: translate,
	        y: translate,
	        yy: translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1,
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 247 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return idLocale; });
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	// tslint:disable:no-parameter-reassignment prefer-switch
	//! moment.js locale configuration
	//! locale : Indonesia [id]
	//! author : Romy Kusuma : https://github.com/rkusuma
	//! reference: https://github.com/moment/moment/blob/develop/locale/id.js
	var idLocale = {
	    abbr: 'id',
	    months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat: {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [pukul] HH.mm',
	        LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        }
	        else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        }
	        else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        }
	        else if (hours < 15) {
	            return 'siang';
	        }
	        else if (hours < 19) {
	            return 'sore';
	        }
	        else {
	            return 'malam';
	        }
	    },
	    calendar: {
	        sameDay: '[Hari ini pukul] LT',
	        nextDay: '[Besok pukul] LT',
	        nextWeek: 'dddd [pukul] LT',
	        lastDay: '[Kemarin pukul] LT',
	        lastWeek: 'dddd [lalu pukul] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'dalam %s',
	        past: '%s yang lalu',
	        s: 'beberapa detik',
	        ss: '%d detik',
	        m: 'semenit',
	        mm: '%d menit',
	        h: 'sejam',
	        hh: '%d jam',
	        d: 'sehari',
	        dd: '%d hari',
	        M: 'sebulan',
	        MM: '%d bulan',
	        y: 'setahun',
	        yy: '%d tahun'
	    },
	    week: {
	        dow: 1,
	        doy: 7 // The week that contains Jan 1st is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 248 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return itLocale; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__units_day_of_week__ = __webpack_require__(14);
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	
	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	var itLocale = {
	    abbr: 'it',
	    months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function (date) {
	            switch (Object(__WEBPACK_IMPORTED_MODULE_0__units_day_of_week__["a" /* getDayOfWeek */])(date)) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: function (num) {
	            return ((/^[0-9].+$/).test(num.toString(10)) ? 'tra' : 'in') + ' ' + num;
	        },
	        past: '%s fa',
	        s: 'alcuni secondi',
	        ss: '%d secondi',
	        m: 'un minuto',
	        mm: '%d minuti',
	        h: 'un\'ora',
	        hh: '%d ore',
	        d: 'un giorno',
	        dd: '%d giorni',
	        M: 'un mese',
	        MM: '%d mesi',
	        y: 'un anno',
	        yy: '%d anni'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week: {
	        dow: 1,
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 249 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return jaLocale; });
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	var jaLocale = {
	    abbr: 'ja',
	    months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'YYYY/MM/DD',
	        LL: 'YYYY年M月D日',
	        LLL: 'YYYY年M月D日 HH:mm',
	        LLLL: 'YYYY年M月D日 HH:mm dddd',
	        l: 'YYYY/MM/DD',
	        ll: 'YYYY年M月D日',
	        lll: 'YYYY年M月D日 HH:mm',
	        llll: 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM: function (input) {
	        return input === '午後';
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        }
	        else {
	            return '午後';
	        }
	    },
	    calendar: {
	        sameDay: '[今日] LT',
	        nextDay: '[明日] LT',
	        nextWeek: '[来週]dddd LT',
	        lastDay: '[昨日] LT',
	        lastWeek: '[前週]dddd LT',
	        sameElse: 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}日/,
	    ordinal: function (num, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return num + '日';
	            default:
	                return num.toString(10);
	        }
	    },
	    relativeTime: {
	        future: '%s後',
	        past: '%s前',
	        s: '数秒',
	        ss: '%d秒',
	        m: '1分',
	        mm: '%d分',
	        h: '1時間',
	        hh: '%d時間',
	        d: '1日',
	        dd: '%d日',
	        M: '1ヶ月',
	        MM: '%dヶ月',
	        y: '1年',
	        yy: '%d年'
	    }
	};
	
	
	/***/ }),
	/* 250 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return koLocale; });
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	// tslint:disable:object-literal-shorthand
	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	var koLocale = {
	    abbr: 'ko',
	    months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat: {
	        LT: 'A h:mm',
	        LTS: 'A h:mm:ss',
	        L: 'YYYY.MM.DD',
	        LL: 'YYYY년 MMMM D일',
	        LLL: 'YYYY년 MMMM D일 A h:mm',
	        LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	        l: 'YYYY.MM.DD',
	        ll: 'YYYY년 MMMM D일',
	        lll: 'YYYY년 MMMM D일 A h:mm',
	        llll: 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar: {
	        sameDay: '오늘 LT',
	        nextDay: '내일 LT',
	        nextWeek: 'dddd LT',
	        lastDay: '어제 LT',
	        lastWeek: '지난주 dddd LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%s 후',
	        past: '%s 전',
	        s: '몇 초',
	        ss: '%d초',
	        m: '1분',
	        mm: '%d분',
	        h: '한 시간',
	        hh: '%d시간',
	        d: '하루',
	        dd: '%d일',
	        M: '한 달',
	        MM: '%d달',
	        y: '일 년',
	        yy: '%d년'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	    ordinal: function (num, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return num + '일';
	            case 'M':
	                return num + '월';
	            case 'w':
	            case 'W':
	                return num + '주';
	            default:
	                return num.toString(10);
	        }
	    },
	    meridiemParse: /오전|오후/,
	    isPM: function (token) {
	        return token === '오후';
	    },
	    meridiem: function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	};
	
	
	/***/ }),
	/* 251 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mnLocale; });
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	// tslint:disable:object-literal-shorthand
	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	function translate(num, withoutSuffix, key, isFuture) {
	    switch (key) {
	        case 's':
	            return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	        case 'ss':
	            return num + (withoutSuffix ? ' секунд' : ' секундын');
	        case 'm':
	        case 'mm':
	            return num + (withoutSuffix ? ' минут' : ' минутын');
	        case 'h':
	        case 'hh':
	            return num + (withoutSuffix ? ' цаг' : ' цагийн');
	        case 'd':
	        case 'dd':
	            return num + (withoutSuffix ? ' өдөр' : ' өдрийн');
	        case 'M':
	        case 'MM':
	            return num + (withoutSuffix ? ' сар' : ' сарын');
	        case 'y':
	        case 'yy':
	            return num + (withoutSuffix ? ' жил' : ' жилийн');
	        default:
	            return num.toString(10);
	    }
	}
	var mnLocale = {
	    abbr: 'mn',
	    months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	    monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	    weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	    weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'YYYY-MM-DD',
	        LL: 'YYYY оны MMMMын D',
	        LLL: 'YYYY оны MMMMын D HH:mm',
	        LLLL: 'dddd, YYYY оны MMMMын D HH:mm'
	    },
	    meridiemParse: /ҮӨ|ҮХ/i,
	    isPM: function (input) {
	        return input === 'ҮХ';
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ҮӨ';
	        }
	        else {
	            return 'ҮХ';
	        }
	    },
	    calendar: {
	        sameDay: '[Өнөөдөр] LT',
	        nextDay: '[Маргааш] LT',
	        nextWeek: '[Ирэх] dddd LT',
	        lastDay: '[Өчигдөр] LT',
	        lastWeek: '[Өнгөрсөн] dddd LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%s дараа',
	        past: '%s өмнө',
	        s: translate,
	        ss: translate,
	        m: translate,
	        mm: translate,
	        h: translate,
	        hh: translate,
	        d: translate,
	        dd: translate,
	        M: translate,
	        MM: translate,
	        y: translate,
	        yy: translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	    ordinal: function (num, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return num + ' өдөр';
	            default:
	                return num.toString(10);
	        }
	    }
	};
	
	
	/***/ }),
	/* 252 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return nlLocale; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date_getters__ = __webpack_require__(2);
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	
	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'), monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	var nlLocale = {
	    abbr: 'nl',
	    months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort: function (date, format, isUTC) {
	        if (!date) {
	            return monthsShortWithDots;
	        }
	        else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["h" /* getMonth */])(date, isUTC)];
	        }
	        else {
	            return monthsShortWithDots[Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["h" /* getMonth */])(date, isUTC)];
	        }
	    },
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	    monthsParse: monthsParse,
	    longMonthsParse: monthsParse,
	    shortMonthsParse: monthsParse,
	    weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD-MM-YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'over %s',
	        past: '%s geleden',
	        s: 'een paar seconden',
	        ss: '%d seconden',
	        m: 'één minuut',
	        mm: '%d minuten',
	        h: 'één uur',
	        hh: '%d uur',
	        d: 'één dag',
	        dd: '%d dagen',
	        M: 'één maand',
	        MM: '%d maanden',
	        y: 'één jaar',
	        yy: '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal: function (_num) {
	        var num = Number(_num);
	        return num + ((num === 1 || num === 8 || num >= 20) ? 'ste' : 'de');
	    },
	    week: {
	        dow: 1,
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 253 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return nlBeLocale; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date_getters__ = __webpack_require__(2);
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	
	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	var nlBeLocale = {
	    abbr: 'nl-be',
	    months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort: function (date, format, isUTC) {
	        if (!date) {
	            return monthsShortWithDots;
	        }
	        else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["h" /* getMonth */])(date, isUTC)];
	        }
	        else {
	            return monthsShortWithDots[Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["h" /* getMonth */])(date, isUTC)];
	        }
	    },
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	    monthsParse: monthsParse,
	    longMonthsParse: monthsParse,
	    shortMonthsParse: monthsParse,
	    weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'over %s',
	        past: '%s geleden',
	        s: 'een paar seconden',
	        ss: '%d seconden',
	        m: 'één minuut',
	        mm: '%d minuten',
	        h: 'één uur',
	        hh: '%d uur',
	        d: 'één dag',
	        dd: '%d dagen',
	        M: 'één maand',
	        MM: '%d maanden',
	        y: 'één jaar',
	        yy: '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal: function (_num) {
	        var num = Number(_num);
	        return num + ((num === 1 || num === 8 || num >= 20) ? 'ste' : 'de');
	    },
	    week: {
	        dow: 1,
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 254 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return plLocale; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date_getters__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__units_day_of_week__ = __webpack_require__(14);
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	
	
	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(num) {
	    return (num % 10 < 5) && (num % 10 > 1) && ((~~(num / 10) % 10) !== 1);
	}
	function translate(num, withoutSuffix, key) {
	    var result = num + ' ';
	    switch (key) {
	        case 'ss':
	            return result + (plural(num) ? 'sekundy' : 'sekund');
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(num) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix ? 'godzina' : 'godzinę';
	        case 'hh':
	            return result + (plural(num) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(num) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(num) ? 'lata' : 'lat');
	    }
	}
	var plLocale = {
	    abbr: 'pl',
	    months: function (date, format, isUTC) {
	        if (!date) {
	            return monthsNominative;
	        }
	        else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["h" /* getMonth */])(date, isUTC)] + '|' + monthsNominative[Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["h" /* getMonth */])(date, isUTC)] + ')';
	        }
	        else if (/D MMMM/.test(format)) {
	            return monthsSubjective[Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["h" /* getMonth */])(date, isUTC)];
	        }
	        else {
	            return monthsNominative[Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["h" /* getMonth */])(date, isUTC)];
	        }
	    },
	    monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: function (date) {
	            switch (Object(__WEBPACK_IMPORTED_MODULE_1__units_day_of_week__["a" /* getDayOfWeek */])(date)) {
	                case 0:
	                    return '[W niedzielę o] LT';
	                case 2:
	                    return '[We wtorek o] LT';
	                case 3:
	                    return '[W środę o] LT';
	                case 6:
	                    return '[W sobotę o] LT';
	                default:
	                    return '[W] dddd [o] LT';
	            }
	        },
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function (date) {
	            switch (Object(__WEBPACK_IMPORTED_MODULE_1__units_day_of_week__["a" /* getDayOfWeek */])(date)) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'za %s',
	        past: '%s temu',
	        s: 'kilka sekund',
	        ss: translate,
	        m: translate,
	        mm: translate,
	        h: translate,
	        hh: translate,
	        d: '1 dzień',
	        dd: '%d dni',
	        M: 'miesiąc',
	        MM: translate,
	        y: 'rok',
	        yy: translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1,
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 255 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ptBrLocale; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__units_day_of_week__ = __webpack_require__(14);
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	
	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	var ptBrLocale = {
	    abbr: 'pt-br',
	    months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	    monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D [de] MMMM [de] YYYY',
	        LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar: {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function (date) {
	            return (Object(__WEBPACK_IMPORTED_MODULE_0__units_day_of_week__["a" /* getDayOfWeek */])(date) === 0 || Object(__WEBPACK_IMPORTED_MODULE_0__units_day_of_week__["a" /* getDayOfWeek */])(date) === 6) ?
	                '[Último] dddd [às] LT' :
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'em %s',
	        past: '%s atrás',
	        s: 'poucos segundos',
	        ss: '%d segundos',
	        m: 'um minuto',
	        mm: '%d minutos',
	        h: 'uma hora',
	        hh: '%d horas',
	        d: 'um dia',
	        dd: '%d dias',
	        M: 'um mês',
	        MM: '%d meses',
	        y: 'um ano',
	        yy: '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº'
	};
	
	
	/***/ }),
	/* 256 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return svLocale; });
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	var svLocale = {
	    abbr: 'sv',
	    months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'YYYY-MM-DD',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [kl.] HH:mm',
	        LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll: 'D MMM YYYY HH:mm',
	        llll: 'ddd D MMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'om %s',
	        past: 'för %s sedan',
	        s: 'några sekunder',
	        ss: '%d sekunder',
	        m: 'en minut',
	        mm: '%d minuter',
	        h: 'en timme',
	        hh: '%d timmar',
	        d: 'en dag',
	        dd: '%d dagar',
	        M: 'en månad',
	        MM: '%d månader',
	        y: 'ett år',
	        yy: '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal: function (_num) {
	        var num = Number(_num);
	        var b = num % 10, output = (~~(num % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                    (b === 3) ? 'e' : 'e';
	        return num + output;
	    },
	    week: {
	        dow: 1,
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 257 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ruLocale; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__units_week__ = __webpack_require__(51);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__units_day_of_week__ = __webpack_require__(14);
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	
	
	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(num, withoutSuffix, key) {
	    var format = {
	        ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	        mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        hh: 'час_часа_часов',
	        dd: 'день_дня_дней',
	        MM: 'месяц_месяца_месяцев',
	        yy: 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    return num + ' ' + plural(format[key], +num);
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ruLocale = {
	    abbr: 'ru',
	    months: {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort: {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays: {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse: monthsParse,
	    longMonthsParse: monthsParse,
	    shortMonthsParse: monthsParse,
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D MMMM YYYY г.',
	        LLL: 'D MMMM YYYY г., H:mm',
	        LLLL: 'dddd, D MMMM YYYY г., H:mm'
	    },
	    calendar: {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (date, now) {
	            if (Object(__WEBPACK_IMPORTED_MODULE_0__units_week__["b" /* getWeek */])(now) !== Object(__WEBPACK_IMPORTED_MODULE_0__units_week__["b" /* getWeek */])(date)) {
	                switch (Object(__WEBPACK_IMPORTED_MODULE_1__units_day_of_week__["a" /* getDayOfWeek */])(date)) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            }
	            else {
	                if (Object(__WEBPACK_IMPORTED_MODULE_1__units_day_of_week__["a" /* getDayOfWeek */])(date) === 2) {
	                    return '[Во] dddd [в] LT';
	                }
	                else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (date, now) {
	            if (Object(__WEBPACK_IMPORTED_MODULE_0__units_week__["b" /* getWeek */])(now) !== Object(__WEBPACK_IMPORTED_MODULE_0__units_week__["b" /* getWeek */])(date)) {
	                switch (Object(__WEBPACK_IMPORTED_MODULE_1__units_day_of_week__["a" /* getDayOfWeek */])(date)) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            }
	            else {
	                if (Object(__WEBPACK_IMPORTED_MODULE_1__units_day_of_week__["a" /* getDayOfWeek */])(date) === 2) {
	                    return '[Во] dddd [в] LT';
	                }
	                else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'через %s',
	        past: '%s назад',
	        s: 'несколько секунд',
	        ss: relativeTimeWithPlural,
	        m: relativeTimeWithPlural,
	        mm: relativeTimeWithPlural,
	        h: 'час',
	        hh: relativeTimeWithPlural,
	        d: 'день',
	        dd: relativeTimeWithPlural,
	        M: 'месяц',
	        MM: relativeTimeWithPlural,
	        y: 'год',
	        yy: relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM: function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        }
	        else if (hour < 12) {
	            return 'утра';
	        }
	        else if (hour < 17) {
	            return 'дня';
	        }
	        else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (_num, period) {
	        var num = Number(_num);
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return num + '-й';
	            case 'D':
	                return num + '-го';
	            case 'w':
	            case 'W':
	                return num + '-я';
	            default:
	                return num.toString(10);
	        }
	    },
	    week: {
	        dow: 1,
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 258 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return roLocale; });
	// ! moment.js locale configuration
	// ! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	// ! author : Earle white: https://github.com/5earle
	function relativeTimeWithPlural(num, withoutSuffix, key) {
	    var format = {
	        ss: 'secunde',
	        mm: 'minute',
	        hh: 'ore',
	        dd: 'zile',
	        MM: 'luni',
	        yy: 'ani'
	    };
	    var separator = ' ';
	    if (num % 100 >= 20 || (num >= 100 && num % 100 === 0)) {
	        separator = ' de ';
	    }
	    return num + separator + format[key];
	}
	var roLocale = {
	    abbr: 'ro',
	    months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort: 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY H:mm',
	        LLLL: 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'peste %s',
	        past: '%s în urmă',
	        s: 'câteva secunde',
	        ss: relativeTimeWithPlural,
	        m: 'un minut',
	        mm: relativeTimeWithPlural,
	        h: 'o oră',
	        hh: relativeTimeWithPlural,
	        d: 'o zi',
	        dd: relativeTimeWithPlural,
	        M: 'o lună',
	        MM: relativeTimeWithPlural,
	        y: 'un an',
	        yy: relativeTimeWithPlural
	    },
	    week: {
	        dow: 1,
	        doy: 7 // The week that contains Jan 1st is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 259 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return zhCnLocale; });
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	// tslint:disable:no-parameter-reassignment prefer-switch
	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	var zhCnLocale = {
	    abbr: 'zh-cn',
	    months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'YYYY/MM/DD',
	        LL: 'YYYY年M月D日',
	        LLL: 'YYYY年M月D日Ah点mm分',
	        LLLL: 'YYYY年M月D日ddddAh点mm分',
	        l: 'YYYY/M/D',
	        ll: 'YYYY年M月D日',
	        lll: 'YYYY年M月D日 HH:mm',
	        llll: 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	            meridiem === '上午') {
	            return hour;
	        }
	        else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	        else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        }
	        else if (hm < 900) {
	            return '早上';
	        }
	        else if (hm < 1130) {
	            return '上午';
	        }
	        else if (hm < 1230) {
	            return '中午';
	        }
	        else if (hm < 1800) {
	            return '下午';
	        }
	        else {
	            return '晚上';
	        }
	    },
	    calendar: {
	        sameDay: '[今天]LT',
	        nextDay: '[明天]LT',
	        nextWeek: '[下]ddddLT',
	        lastDay: '[昨天]LT',
	        lastWeek: '[上]ddddLT',
	        sameElse: 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal: function (_num, period) {
	        var num = Number(_num);
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return num + '日';
	            case 'M':
	                return num + '月';
	            case 'w':
	            case 'W':
	                return num + '周';
	            default:
	                return num.toString();
	        }
	    },
	    relativeTime: {
	        future: '%s内',
	        past: '%s前',
	        s: '几秒',
	        ss: '%d 秒',
	        m: '1 分钟',
	        mm: '%d 分钟',
	        h: '1 小时',
	        hh: '%d 小时',
	        d: '1 天',
	        dd: '%d 天',
	        M: '1 个月',
	        MM: '%d 个月',
	        y: '1 年',
	        yy: '%d 年'
	    },
	    week: {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow: 1,
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 260 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trLocale; });
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	var trLocale = {
	    abbr: 'tr',
	    months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[bugün saat] LT',
	        nextDay: '[yarın saat] LT',
	        nextWeek: '[gelecek] dddd [saat] LT',
	        lastDay: '[dün] LT',
	        lastWeek: '[geçen] dddd [saat] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%s sonra',
	        past: '%s önce',
	        s: 'birkaç saniye',
	        ss: '%d saniye',
	        m: 'bir dakika',
	        mm: '%d dakika',
	        h: 'bir saat',
	        hh: '%d saat',
	        d: 'bir gün',
	        dd: '%d gün',
	        M: 'bir ay',
	        MM: '%d ay',
	        y: 'bir yıl',
	        yy: '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal: function (_num) {
	        var num = Number(_num);
	        if (num === 0) {
	            return num + '\'ıncı';
	        }
	        var a = num % 10, b = num % 100 - a, c = num >= 100 ? 100 : null;
	        return num + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week: {
	        dow: 1,
	        doy: 7 // The week that contains Jan 1st is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 261 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return heLocale; });
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	var heLocale = {
	    abbr: 'he',
	    months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D [ב]MMMM YYYY',
	        LLL: 'D [ב]MMMM YYYY HH:mm',
	        LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	        l: 'D/M/YYYY',
	        ll: 'D MMM YYYY',
	        lll: 'D MMM YYYY HH:mm',
	        llll: 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[היום ב־]LT',
	        nextDay: '[מחר ב־]LT',
	        nextWeek: 'dddd [בשעה] LT',
	        lastDay: '[אתמול ב־]LT',
	        lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'בעוד %s',
	        past: 'לפני %s',
	        s: 'מספר שניות',
	        ss: '%d שניות',
	        m: 'דקה',
	        mm: '%d דקות',
	        h: 'שעה',
	        hh: function (num) {
	            if (num === 2) {
	                return 'שעתיים';
	            }
	            return num + ' שעות';
	        },
	        d: 'יום',
	        dd: function (num) {
	            if (num === 2) {
	                return 'יומיים';
	            }
	            return num + ' ימים';
	        },
	        M: 'חודש',
	        MM: function (num) {
	            if (num === 2) {
	                return 'חודשיים';
	            }
	            return num + ' חודשים';
	        },
	        y: 'שנה',
	        yy: function (num) {
	            if (num === 2) {
	                return 'שנתיים';
	            }
	            else if (num % 10 === 0 && num !== 10) {
	                return num + ' שנה';
	            }
	            return num + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM: function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        }
	        else if (hour < 10) {
	            return 'בבוקר';
	        }
	        else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        }
	        else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        }
	        else {
	            return 'בערב';
	        }
	    }
	};
	
	
	/***/ }),
	/* 262 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return thLocale; });
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	var thLocale = {
	    abbr: 'th',
	    months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'),
	    weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY เวลา H:mm',
	        LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        }
	        else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar: {
	        sameDay: '[วันนี้ เวลา] LT',
	        nextDay: '[พรุ่งนี้ เวลา] LT',
	        nextWeek: 'dddd[หน้า เวลา] LT',
	        lastDay: '[เมื่อวานนี้ เวลา] LT',
	        lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'อีก %s',
	        past: '%sที่แล้ว',
	        s: 'ไม่กี่วินาที',
	        ss: '%d วินาที',
	        m: '1 นาที',
	        mm: '%d นาที',
	        h: '1 ชั่วโมง',
	        hh: '%d ชั่วโมง',
	        d: '1 วัน',
	        dd: '%d วัน',
	        M: '1 เดือน',
	        MM: '%d เดือน',
	        y: '1 ปี',
	        yy: '%d ปี'
	    }
	};
	
	
	/***/ }),
	/* 263 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slLocale; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__units_day_of_week__ = __webpack_require__(14);
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	// tslint:disable:object-literal-key-quotes
	
	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : mihan : https://github.com/mihan
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'ss':
	            if (number === 1) {
	                result += withoutSuffix ? 'sekundo' : 'sekundi';
	            }
	            else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	            }
	            else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	            }
	            else {
	                result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            }
	            else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            }
	            else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            }
	            else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            }
	            else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            }
	            else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            }
	            else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            }
	            else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            }
	            else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            }
	            else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            }
	            else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            }
	            else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            }
	            else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            }
	            else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            }
	            else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	var slLocale = {
	    abbr: 'sl',
	    months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danes ob] LT',
	        nextDay: '[jutri ob] LT',
	        nextWeek: function (date) {
	            switch (Object(__WEBPACK_IMPORTED_MODULE_0__units_day_of_week__["a" /* getDayOfWeek */])(date)) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay: '[včeraj ob] LT',
	        lastWeek: function (date) {
	            switch (Object(__WEBPACK_IMPORTED_MODULE_0__units_day_of_week__["a" /* getDayOfWeek */])(date)) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'čez %s',
	        past: 'pred %s',
	        s: processRelativeTime,
	        ss: processRelativeTime,
	        m: processRelativeTime,
	        mm: processRelativeTime,
	        h: processRelativeTime,
	        hh: processRelativeTime,
	        d: processRelativeTime,
	        dd: processRelativeTime,
	        M: processRelativeTime,
	        MM: processRelativeTime,
	        y: processRelativeTime,
	        yy: processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1,
	        doy: 7 // The week that contains Jan 1st is the first week of the year.
	    }
	};
	
	
	/***/ }),
	/* 264 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return glLocale; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_date_getters__ = __webpack_require__(2);
	// tslint:disable:comment-format binary-expression-operand-order max-line-length
	// tslint:disable:no-bitwise prefer-template cyclomatic-complexity
	// tslint:disable:no-shadowed-variable switch-default prefer-const
	// tslint:disable:one-variable-per-declaration newline-before-return
	
	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Darío Beiró : https://github.com/quinobravo
	var monthsShortDot = 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'), monthsShort = 'xan_feb_mar_abr_mai_xuñ_xul_ago_set_out_nov_dec'.split('_');
	var monthsParse = [/^xan/i, /^feb/i, /^mar/i, /^abr/i, /^mai/i, /^xuñ/i, /^xul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro|xan\.?|feb\.?|mar\.?|abr\.?|mai\.?|xuñ\.?|xul\.?|ago\.?|set\.?|out\.?|nov\.?|dec\.?)/i;
	var glLocale = {
	    abbr: 'gl',
	    months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort: function (date, format, isUTC) {
	        if (!date) {
	            return monthsShortDot;
	        }
	        if (/-MMM-/.test(format)) {
	            return monthsShort[Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["h" /* getMonth */])(date, isUTC)];
	        }
	        return monthsShortDot[Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["h" /* getMonth */])(date, isUTC)];
	    },
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i,
	    monthsShortStrictRegex: /^(xan\.?|feb\.?|mar\.?|abr\.?|mai\.?|xuñ\.?|xul\.?|ago\.?|set\.?|out\.?|nov\.?|dec\.?)/i,
	    monthsParse: monthsParse,
	    longMonthsParse: monthsParse,
	    shortMonthsParse: monthsParse,
	    weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D [de] MMMM [de] YYYY',
	        LLL: 'D [de] MMMM [de] YYYY H:mm',
	        LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar: {
	        sameDay: function (date) {
	            return '[hoxe á' + ((Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date) !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay: function (date) {
	            return '[mañan á' + ((Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date) !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek: function (date) {
	            return 'dddd [á' + ((Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date) !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay: function (date) {
	            return '[onte á' + ((Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date) !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek: function (date) {
	            return '[o] dddd [pasado á' + ((Object(__WEBPACK_IMPORTED_MODULE_0__utils_date_getters__["e" /* getHours */])(date) !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'en %s',
	        past: 'fai %s',
	        s: 'uns segundos',
	        ss: '%d segundos',
	        m: 'un minuto',
	        mm: '%d minutos',
	        h: 'unha hora',
	        hh: '%d horas',
	        d: 'un día',
	        dd: '%d días',
	        M: 'un mes',
	        MM: '%d meses',
	        y: 'un ano',
	        yy: '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week: {
	        dow: 1,
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	};
	
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=ngx-bootstrap.umd.js.map

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1086));


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var common_1 = __webpack_require__(246);
	var value_by_key_pipe_1 = __webpack_require__(1087);
	var values_by_keys_pipe_1 = __webpack_require__(1088);
	var DashboardPipesModule = (function () {
	    function DashboardPipesModule() {
	    }
	    DashboardPipesModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                common_1.CommonModule
	            ],
	            declarations: [
	                value_by_key_pipe_1.ValueByKeyPipe,
	                values_by_keys_pipe_1.ValuesByKeysPipe
	            ],
	            exports: [
	                value_by_key_pipe_1.ValueByKeyPipe,
	                values_by_keys_pipe_1.ValuesByKeysPipe
	            ]
	        })
	    ], DashboardPipesModule);
	    return DashboardPipesModule;
	}());
	exports.DashboardPipesModule = DashboardPipesModule;


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var lodash_1 = __webpack_require__(268);
	var ValueByKeyPipe = (function () {
	    function ValueByKeyPipe() {
	    }
	    ValueByKeyPipe.prototype.transform = function (key, array) {
	        if (array === void 0) { array = []; }
	        try {
	            key = parseInt(key);
	            if (lodash_1.isNaN(key)) {
	                return '';
	            }
	            var item = array.find(function (item) { return item.id === key; });
	            return (item) ? item.name : "" + key;
	        }
	        catch (e) {
	            return '';
	        }
	    };
	    ValueByKeyPipe = __decorate([
	        core_1.Pipe({ name: "value_by_key" })
	    ], ValueByKeyPipe);
	    return ValueByKeyPipe;
	}());
	exports.ValueByKeyPipe = ValueByKeyPipe;


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var core_1 = __webpack_require__(205);
	var ValuesByKeysPipe = (function () {
	    function ValuesByKeysPipe() {
	    }
	    ValuesByKeysPipe.prototype.transform = function (keys, array) {
	        if (array === void 0) { array = []; }
	        return array
	            .filter(function (item) { return lodash_1.indexOf(keys, item.id) > -1; })
	            .map(function (item) { return item.name; })
	            .join(', ');
	    };
	    ValuesByKeysPipe = __decorate([
	        core_1.Pipe({ name: "values_by_keys" })
	    ], ValuesByKeysPipe);
	    return ValuesByKeysPipe;
	}());
	exports.ValuesByKeysPipe = ValuesByKeysPipe;


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var service_1 = __webpack_require__(1090);
	var banks_service_1 = __webpack_require__(1101);
	var backoffice_reasons_service_1 = __webpack_require__(1102);
	var backoffice_ranges_service_1 = __webpack_require__(1118);
	var backoffice_purposes_service_1 = __webpack_require__(1120);
	var backoffice_business_type_categories_service_1 = __webpack_require__(1121);
	var backoffice_report_types_service_1 = __webpack_require__(1122);
	__export(__webpack_require__(1127));
	__export(__webpack_require__(1090));
	exports.SHARED_API_PROVIDERS = [
	    service_1.CustomerService,
	    service_1.PoolService,
	    service_1.CardsService,
	    service_1.TransfersService,
	    service_1.LiquidityAccountsService,
	    service_1.TariffsService,
	    banks_service_1.BanksService,
	    service_1.AvailableAccountTypesService,
	    service_1.AccountStateLogService,
	    backoffice_reasons_service_1.BackofficeReasonsService,
	    service_1.CommonCustomerAccountService,
	    backoffice_ranges_service_1.BackofficeRangesService,
	    backoffice_business_type_categories_service_1.BackofficeBusinessTypeCategoriesService,
	    service_1.IBANService,
	    backoffice_purposes_service_1.BackofficePurposesService,
	    backoffice_report_types_service_1.BackofficeReportTypesService
	];


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1091));
	__export(__webpack_require__(1092));
	__export(__webpack_require__(1093));
	__export(__webpack_require__(1094));
	__export(__webpack_require__(1095));
	__export(__webpack_require__(1096));
	__export(__webpack_require__(1097));
	__export(__webpack_require__(1098));
	__export(__webpack_require__(1099));
	__export(__webpack_require__(1100));


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var rxjs_1 = __webpack_require__(304);
	var http_1 = __webpack_require__(836);
	var core_1 = __webpack_require__(205);
	var http_2 = __webpack_require__(900);
	var MIN_SEARCH_QUERY_LENGTH = 3;
	var CustomerService = (function (_super) {
	    __extends(CustomerService, _super);
	    function CustomerService(_http) {
	        var _this = _super.call(this) || this;
	        _this._http = _http;
	        return _this;
	    }
	    CustomerService.prototype.findCustomers = function (name, states) {
	        if (name && name.length >= MIN_SEARCH_QUERY_LENGTH) {
	            var search = new http_1.URLSearchParams;
	            search.append('query', name);
	            if (!!states) {
	                search.append('states', String(states.join(',')));
	            }
	            return this._http
	                .get('/api/backoffice/customers/search', { search: search })
	                .map(function (response) { return response.json(); })
	                .map(function (response) { return lodash_1.get(response, 'records', []); });
	        }
	        else {
	            return rxjs_1.Observable.of([]);
	        }
	    };
	    CustomerService.prototype.findCustomersRevenueInternal = function (name, numberRevenueInternal) {
	        if (name && name.length >= MIN_SEARCH_QUERY_LENGTH) {
	            var search = new http_1.URLSearchParams;
	            var query = name + "|" + numberRevenueInternal;
	            search.append('query', query);
	            return this._http
	                .get('/api/backoffice/customers/search', { search: search })
	                .map(function (response) { return response.json(); })
	                .map(function (response) { return lodash_1.get(response, 'records', []); });
	        }
	        else {
	            return rxjs_1.Observable.of([]);
	        }
	    };
	    CustomerService.prototype.findCustomersById = function (id, apiUrl) {
	        if (!!id) {
	            var search = new http_1.URLSearchParams;
	            search.append('id', String(id));
	            return this._http
	                .get(apiUrl, { search: search })
	                .map(function (response) { return response.json(); })
	                .map(function (response) { return lodash_1.get(response, 'records', []); });
	        }
	        else {
	            return rxjs_1.Observable.of([]);
	        }
	    };
	    CustomerService.prototype.findLightCustomers = function (name, states) {
	        if (name && name.length >= MIN_SEARCH_QUERY_LENGTH) {
	            var search = new http_1.URLSearchParams;
	            search.append('query', name);
	            if (!!states) {
	                search.append('states', String(states.join(',')));
	            }
	            return this._http
	                .get('/api/backoffice/customers/light-search', { search: search })
	                .map(function (response) { return response.json(); })
	                .map(function (response) { return lodash_1.get(response, 'records', []); });
	        }
	        else {
	            return rxjs_1.Observable.of([]);
	        }
	    };
	    CustomerService.prototype.getCustomerAccounts = function (id) {
	        return this._http
	            .get("/api/backoffice/customers/" + id + "/accounts")
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return lodash_1.get(response, 'accounts', []); });
	    };
	    CustomerService.prototype.getCustomerAccountsRevenueInternal = function (id, account) {
	        return this._http
	            .get("/api/backoffice/customers/" + id + "/accounts/" + account + "/revenue_internal")
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return lodash_1.get(response, 'accounts', []); });
	    };
	    CustomerService.prototype.getCustomersForIncomingTransfers = function (id) {
	        return this._http
	            .get("/api/backoffice/customers/" + id + "/accounts?incoming-transfer")
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return lodash_1.get(response, 'accounts', []); });
	    };
	    CustomerService.prototype.getUsersByProfile = function (id) {
	        return this._http.get("/api/backoffice/customers/" + id + "/clients?names").map(function (response) { return response.json(); });
	    };
	    CustomerService.prototype.getResetTokenForUser = function (userId) {
	        return this._http.get("/api/backoffice/customers/clients/" + userId + "/passwords?reset_link")
	            .map(function (response) { return response.json().link; });
	    };
	    CustomerService.prototype.getCustomersType = function () {
	        return this._http.get("/api/backoffice/customers/types")
	            .map(function (response) { return response.json(); });
	    };
	    CustomerService.prototype.getCustomerTariff = function (type) {
	        return this._http.get("/api/backoffice/tariff?" + type)
	            .map(function (response) { return response.json(); });
	    };
	    CustomerService.prototype.getCustomerRiskLevel = function () {
	        return this._http.get("/api/client/dictionary/risk_levels")
	            .map(function (response) { return response.json().riskLevels; });
	    };
	    CustomerService.prototype.getSingleCustomer = function (id) {
	        return this._http.get("/api/backoffice/customers/" + id)
	            .map(function (response) { return response.json(); });
	    };
	    CustomerService.prototype.updateProfileSettings = function (id, profileSettings) {
	        return this._http.patch("/api/backoffice/customers/" + id + "/profile-settings", profileSettings)
	            .map(function (response) { return response.json(); });
	    };
	    CustomerService.prototype.checkNewProfileKindPossibility = function (id, newProfileKindId) {
	        var search = new http_1.URLSearchParams;
	        search.append('kindId', String(newProfileKindId));
	        return this._http.get("/api/backoffice/customers/" + id + "?check", { search: search })
	            .map(function (response) { return response.json(); });
	    };
	    CustomerService.prototype.sendVerificationCode = function (id) {
	        return this._http.get("/api/backoffice/customers/verification/" + id)
	            .map(function (response) { return response.json(); });
	    };
	    CustomerService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], CustomerService);
	    return CustomerService;
	}(http_2.AbstractService));
	exports.CustomerService = CustomerService;


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var LiquidityAccountsService = (function () {
	    function LiquidityAccountsService(http) {
	        this.http = http;
	    }
	    LiquidityAccountsService_1 = LiquidityAccountsService;
	    LiquidityAccountsService.prototype.getLiquidityAccountsByPool = function (poolId) {
	        return this.http
	            .get(LiquidityAccountsService_1.prepareAccountsByPoolURL(poolId))
	            .map(function (response) { return response.json(); });
	    };
	    LiquidityAccountsService.prototype.getLiquidityAccountsByPoolAndCurrency = function (poolId, currencyId) {
	        var search = new http_1.URLSearchParams();
	        search.set('currency', String(currencyId));
	        return this.http
	            .get(LiquidityAccountsService_1.prepareAccountsByPoolURL(poolId), { search: search })
	            .map(function (response) { return response.json(); });
	    };
	    LiquidityAccountsService.prototype.getAppropriateLiquidityAccountsDependOnBalanceForOutgoingTransferGroupedByPools = function (transferPaymentId) {
	        return this.http.get("/api/backoffice/transfers/outgoing/" + transferPaymentId + "/liquidity-accounts")
	            .map(function (response) { return response.json(); })
	            .map(function (json) { return json.data; });
	    };
	    LiquidityAccountsService.prototype.updateLiquidityAccountForNewOutgoingTransfer = function (transferPaymentId, oldLiquidityAccountId, newLiquidityAccountId) {
	        return this.http.patch("/api/backoffice/transfers/outgoing/" + transferPaymentId + "/liquidity-accounts", { value_current: oldLiquidityAccountId, value_new: newLiquidityAccountId })
	            .map(function (response) { return response.json(); });
	    };
	    LiquidityAccountsService.prepareAccountsByPoolURL = function (id) {
	        return "/api/backoffice/pools/" + id + "/liquidity_accounts";
	    };
	    LiquidityAccountsService = LiquidityAccountsService_1 = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], LiquidityAccountsService);
	    return LiquidityAccountsService;
	    var LiquidityAccountsService_1;
	}());
	exports.LiquidityAccountsService = LiquidityAccountsService;


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var PoolService = (function () {
	    function PoolService(http) {
	        this.http = http;
	    }
	    PoolService.prototype.getPoolsInfo = function () {
	        return this.http.get('/api/backoffice/pools')
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return response.map(function (pool) { return ({
	            id: pool.id,
	            name: pool.name,
	            type: pool.type
	        }); }); });
	    };
	    PoolService.prototype.getBankPoolsInfo = function (couldCreateAccountUnderPool) {
	        var search = new http_1.URLSearchParams;
	        search.append('could_create_account', String(couldCreateAccountUnderPool));
	        return this.http.get('/api/backoffice/pools/bank', { search: search })
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return response.map(function (pool) { return ({
	            id: pool.id,
	            name: pool.name,
	            type: pool.type
	        }); }); });
	    };
	    PoolService.prototype.getFullPoolInfo = function (poolId) {
	        return this.http.get("/api/backoffice/pools/" + poolId)
	            .map(function (response) { return response.json(); })
	            .map(function (pool) { return ({
	            name: pool.name,
	            type: pool.type,
	            couldCreateAccountUnderPool: pool.couldCreateAccountUnder,
	            senderInformation: pool.senderInformation
	        }); });
	    };
	    PoolService.prototype.getPoolCurrency = function (poolId) {
	        return this.http.get("/api/backoffice/pools/" + poolId + "/currencies")
	            .map(function (response) { return response.json(); });
	    };
	    PoolService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], PoolService);
	    return PoolService;
	}());
	exports.PoolService = PoolService;


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var lodash_1 = __webpack_require__(268);
	var CardsService = (function () {
	    function CardsService(_http) {
	        this._http = _http;
	    }
	    CardsService.prototype.getNewCards = function (page, limit) {
	        var search = new http_1.URLSearchParams();
	        search.set('page', String(page));
	        search.set('limit', String(limit));
	        return this._http.get('/api/backoffice/cards/new', { search: search })
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return ({
	            page: lodash_1.get(response, 'meta.page', 0),
	            records: lodash_1.get(response, 'meta.records', 0),
	            total_records: lodash_1.get(response, 'meta.total_records', 0),
	            cards: lodash_1.get(response, 'cards', [])
	                .map(function (card) { return ({
	                id: card.id,
	                number: card.number,
	                program: card.program,
	                currency: card.currency,
	                short_number: card.short_number,
	                validity: card.validity
	            }); })
	        }); });
	    };
	    CardsService.prototype.getCardsForProfile = function (profileId) {
	        return this._http.get("/api/backoffice/cards/active-for-profile/" + profileId).map(function (response) { return response.json(); });
	    };
	    CardsService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], CardsService);
	    return CardsService;
	}());
	exports.CardsService = CardsService;


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var TransfersService = (function () {
	    function TransfersService(_http) {
	        this._http = _http;
	    }
	    TransfersService.prototype.exportTransfers = function (liquidityAccountNumber, transfers) {
	        return this._http.post("/api/backoffice/transfers/outgoing/export-batches/" + liquidityAccountNumber + "?export", { transfers: transfers });
	    };
	    TransfersService.prototype.getUploadedOutgoingTransfersSummary = function (page, limit) {
	        var search = this.createPageSearchParams(page, limit);
	        return this._http.get('/api/backoffice/transfers/outgoing/export-files', { search: search })
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return ({
	            page: lodash_1.get(response, 'meta.page', 0),
	            records: lodash_1.get(response, 'meta.records', 0),
	            total_records: lodash_1.get(response, 'meta.total_records'),
	            poolSummaries: lodash_1.get(response, 'poolSummaries', []).map(function (poolSummary) { return ({
	                id: poolSummary.id,
	                name: poolSummary.name,
	                liquidityAccountSummaries: lodash_1.get(poolSummary, 'liquidityAccounts', []).map(function (liquidityAccountSummary) { return ({
	                    id: liquidityAccountSummary.id,
	                    name: liquidityAccountSummary.name,
	                    fileSummaries: lodash_1.get(liquidityAccountSummary, 'fileSummaries', []).map(function (fileSummary) { return ({
	                        transfers: fileSummary.transfers,
	                        totalAmount: fileSummary.totalAmount,
	                        period: fileSummary.period,
	                        fileId: fileSummary.fileId,
	                        fileName: fileSummary.fileName,
	                        state: fileSummary.state,
	                        canDone: fileSummary.canDone
	                    }); })
	                }); })
	            }); })
	        }); });
	    };
	    TransfersService.prototype.getApprovedOutgoingTransfersPoolSummaries = function (page, limit) {
	        var search = this.createPageSearchParams(page, limit);
	        return this._http.get('/api/backoffice/transfers/outgoing/export-batches', { search: search })
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return ({
	            page: lodash_1.get(response, 'meta.page', 0),
	            records: lodash_1.get(response, 'meta.records', 0),
	            total_records: lodash_1.get(response, 'meta.total_records'),
	            poolSummaries: lodash_1.get(response, 'poolSummaries', []).map(function (poolSummary) { return ({
	                id: poolSummary.id,
	                name: poolSummary.name,
	                liquidityAccountSummaries: lodash_1.get(poolSummary, 'liquidityAccounts', []).map(function (liquidityAccountSummary) { return ({
	                    id: liquidityAccountSummary.id,
	                    name: liquidityAccountSummary.name,
	                    number: liquidityAccountSummary.number,
	                    transfers: liquidityAccountSummary.transfers,
	                    totalAmount: liquidityAccountSummary.totalAmount,
	                    period: liquidityAccountSummary.period
	                }); })
	            }); })
	        }); });
	    };
	    TransfersService.prototype.getUploadedOutgoingTransfers = function (fileId, page, limit) {
	        var _this = this;
	        var search = this.createPageSearchParams(page, limit);
	        return this._http.get("/api/backoffice/transfers/outgoing/export-files/" + fileId, { search: search })
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return ({
	            page: lodash_1.get(response, 'meta.page', 0),
	            records: lodash_1.get(response, 'meta.records', 0),
	            total_records: lodash_1.get(response, 'meta.total_records', 0),
	            liquidityAccountName: lodash_1.get(response, 'liquidityAccountName', ''),
	            fileName: lodash_1.get(response, 'fileName', ''),
	            transfers: lodash_1.get(response, 'transfers', []).map(function (transfer) {
	                return _this.mapToUploadedTransfer(transfer);
	            })
	        }); });
	    };
	    TransfersService.prototype.getCreatedOutgoingTransfers = function (page, limit) {
	        var _this = this;
	        return this._http.get('/api/backoffice/transfers/outgoing/authorized', { search: this.createPageSearchParams(page, limit) })
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return ({
	            page: lodash_1.get(response, 'meta.page', 0),
	            records: lodash_1.get(response, 'meta.records', 0),
	            total_records: lodash_1.get(response, 'meta.total_records', 0),
	            transfers: lodash_1.get(response, 'transfers', []).map(function (transfer) {
	                return _this.mapTransfer(transfer);
	            })
	        }); });
	    };
	    TransfersService.prototype.getApprovedOutgoingTransfersByLiquidityAccountNumber = function (liquidityAccountNumber, page, limit) {
	        var _this = this;
	        var search = this.createPageSearchParams(page, limit);
	        return this._http.get("/api/backoffice/transfers/outgoing/export-batches/" + liquidityAccountNumber, { search: search })
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return ({
	            page: lodash_1.get(response, 'meta.page', 0),
	            records: lodash_1.get(response, 'meta.records', 0),
	            total_records: lodash_1.get(response, 'meta.total_records', 0),
	            liquidityAccountName: lodash_1.get(response, 'liquidityAccountName', ''),
	            transfers: lodash_1.get(response, 'transfers', []).map(function (transfer) {
	                return _this.mapTransfer(transfer);
	            })
	        }); });
	    };
	    TransfersService.prototype.markTransfersAsUploaded = function (fileId) {
	        return this._http.patch("/api/backoffice/transfers/outgoing/export-files/" + fileId + "?upload", {})
	            .map(function (response) { return response.json(); });
	    };
	    TransfersService.prototype.markFileAsDone = function (fileId) {
	        return this._http.patch("/api/backoffice/transfers/outgoing/export-files/" + fileId + "?done", {})
	            .map(function (response) { return response.json(); });
	    };
	    TransfersService.prototype.rejectTransfer = function (paymentId, reason) {
	        return this._http.put("/api/backoffice/transfers/" + paymentId + "/reject", { reason: reason });
	    };
	    TransfersService.prototype.approveTransfer = function (paymentId, reason) {
	        return this._http.put("/api/backoffice/transfers/" + paymentId + "/approve", { reason: reason });
	    };
	    TransfersService.prototype.saveTransferReference = function (paymentId, oldReference, newReference) {
	        return this._http.patch("/api/backoffice/transfers/outgoing/" + paymentId + "/reference", {
	            current_reference: oldReference,
	            new_reference: newReference
	        }).map(function (resp) { return resp.json(); });
	    };
	    TransfersService.prototype.saveBankFee = function (paymentId, newBankFee) {
	        return this._http
	            .patch("/api/backoffice/transfers/outgoing/" + paymentId + "/bank-fee", { amount: newBankFee })
	            .map(function (resp) { return resp.json(); });
	    };
	    TransfersService.prototype.confirm = function (paymentId, reference) {
	        var search = new http_1.URLSearchParams();
	        search.set('reference', reference);
	        return this._http
	            .put("/api/backoffice/transfers/" + paymentId + "/confirm", {}, { search: search })
	            .map(function (resp) { return resp.json(); });
	    };
	    TransfersService.prototype.getTransferAttachments = function (transferID) {
	        return this._http
	            .get("/api/backoffice/transfers/" + transferID + "/attachments")
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return response.records; });
	    };
	    TransfersService.prototype.downloadTransferAttachment = function (attachmentID) {
	        return this._http.get("/api/backoffice/documents/" + attachmentID + "/download", { responseType: http_1.ResponseContentType.Blob });
	    };
	    TransfersService.prototype.downloadTransferAttachmentsAsZip = function (transferId) {
	        return this._http.get("/api/backoffice/documents/" + transferId + "/download/all", { responseType: http_1.ResponseContentType.Blob });
	    };
	    TransfersService.prototype.checkAddresses = function (transferId) {
	        return this._http.get("/api/backoffice/transfers/outgoing/" + transferId + "/check-addresses")
	            .map(function (response) { return response.json(); });
	    };
	    TransfersService.prototype.mapTransfer = function (transfer) {
	        return {
	            payment: {
	                id: transfer.payment.id,
	                date: transfer.payment.date,
	                time: transfer.payment.time,
	                narrative: transfer.payment.narrative,
	                state: transfer.payment.state,
	                amount: {
	                    amount: transfer.payment.amount.amount,
	                    currency_code: transfer.payment.amount.currency_code,
	                },
	                isExchange: transfer.payment.isExchange,
	                bankFeeAmount: {
	                    amount: transfer.payment.bankFeeAmount.amount,
	                    currency_code: transfer.payment.bankFeeAmount.currency_code,
	                },
	                isExpress: transfer.payment.isExpress
	            },
	            customer: {
	                id: transfer.customer.id,
	                name: transfer.customer.name,
	                accountNumber: transfer.customer.accountNumber,
	                accountName: transfer.customer.accountName,
	                riskLevel: {
	                    id: transfer.customer.riskLevel.id,
	                    name: transfer.customer.riskLevel.name,
	                    level: transfer.customer.riskLevel.level,
	                    hexColor: transfer.customer.riskLevel.hexColor
	                }
	            },
	            beneficiary: {
	                account: transfer.beneficiary.account,
	                name: transfer.beneficiary.name,
	                bank: {
	                    name: transfer.beneficiary.bank.name,
	                    country: {
	                        id: transfer.beneficiary.bank.country.id,
	                        name: transfer.beneficiary.bank.country.name,
	                        abbreviation: transfer.beneficiary.bank.country.abbreviation
	                    }
	                }
	            },
	            account: {
	                id: transfer.account.id,
	                name: transfer.account.name,
	                number: transfer.account.number,
	                balance: {
	                    amount: transfer.account.balance.amount,
	                    currency_code: transfer.account.balance.currency_code,
	                },
	                iban: transfer.account.iban,
	                refill_date: transfer.account.refill_date,
	                bank_country: transfer.account.bank_country,
	                iban_locator: transfer.account.iban_locator
	            },
	            reason: transfer.reason,
	            approvedReason: transfer.approvedReason
	        };
	    };
	    TransfersService.prototype.mapToUploadedTransfer = function (uploadedTransfer) {
	        var transfer = this.mapTransfer(uploadedTransfer);
	        lodash_1.set(transfer, 'payment.reference', uploadedTransfer.payment.reference);
	        return transfer;
	    };
	    TransfersService.prototype.createPageSearchParams = function (page, limit) {
	        var search = new http_1.URLSearchParams();
	        search.set('page', String(page));
	        search.set('limit', String(limit));
	        return search;
	    };
	    TransfersService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], TransfersService);
	    return TransfersService;
	}());
	exports.TransfersService = TransfersService;


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var constants_1 = __webpack_require__(861);
	var http_1 = __webpack_require__(852);
	var http_2 = __webpack_require__(836);
	var TariffsService = (function () {
	    function TariffsService(_http, http) {
	        this._http = _http;
	        this.http = http;
	    }
	    TariffsService.prototype.getTariffs = function () {
	        return this._http.get('/api/backoffice/tariff');
	    };
	    TariffsService.prototype.getCustomerTariffs = function () {
	        return this._http.get('/api/backoffice/tariff?customer');
	    };
	    TariffsService.prototype.getTariffById = function (id) {
	        return this._http.get("/api/backoffice/tariff/" + id);
	    };
	    TariffsService.prototype.getTariffsAvailableForCustomer = function (customer) {
	        var searchParams = new http_1.HttpParams();
	        if (customer.type === constants_1.PROFILE_TYPE.PRIVATE) {
	            searchParams = searchParams.append('private', '');
	        }
	        else if (customer.type === constants_1.PROFILE_TYPE.CORPORATE) {
	            searchParams = searchParams.append('corporate', '');
	        }
	        return this._http.get('/api/backoffice/tariff', { params: searchParams });
	    };
	    TariffsService.prototype.getWhitelabelTariffs = function () {
	        return this._http.get('/api/backoffice/tariff?whitelabel');
	    };
	    TariffsService.prototype.getBankTariffs = function () {
	        return this._http.get('/api/backoffice/tariff?bank');
	    };
	    TariffsService.prototype.getCardTariffs = function () {
	        return this._http.get('/api/backoffice/tariff?card');
	    };
	    TariffsService.prototype.getTariffSuggestion = function (clientId) {
	        return this._http.get("/api/backoffice/tariff/suggestion?client_id=" + clientId);
	    };
	    TariffsService.prototype.getAllAvailabilities = function () {
	        return this.http.get('/api/client/dictionary/availabilities')
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return response.availabilities; });
	    };
	    TariffsService.prototype.addTariff = function (tariff) {
	        return this.http.patch("/api/backoffice/tariff?new", tariff)
	            .map(function (response) { return response.json(); });
	    };
	    TariffsService.prototype.updateTariff = function (id, tariff) {
	        return this.http.patch("/api/backoffice/tariff/" + id + "/update", tariff)
	            .map(function (response) { return response.json(); });
	    };
	    TariffsService.prototype.getFees = function () {
	        return this._http.get("/api/backoffice/tariff/fees");
	    };
	    TariffsService.prototype.canDelete = function (id) {
	        return this._http.get("/api/backoffice/tariff/" + id + "/canDelete");
	    };
	    TariffsService.prototype.delete = function (id) {
	        return this._http.delete("/api/backoffice/tariff/" + id + "/delete");
	    };
	    TariffsService.prototype.getTariffToUpdate = function (id) {
	        return this._http.get("/api/backoffice/tariff/" + id + "/load/update");
	    };
	    TariffsService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.HttpClient, http_2.Http])
	    ], TariffsService);
	    return TariffsService;
	}());
	exports.TariffsService = TariffsService;


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var http_2 = __webpack_require__(836);
	var AvailableAccountTypesService = (function () {
	    function AvailableAccountTypesService(http) {
	        this.http = http;
	        this.apiUrl = '/api/backoffice/account-types';
	    }
	    AvailableAccountTypesService.prototype.getAvailableAccountsTypes = function (customerId) {
	        var params = new http_2.URLSearchParams();
	        params.set('clientId', String(customerId));
	        return this.http.get(this.apiUrl, { search: params }).map(function (response) { return response.json(); });
	    };
	    AvailableAccountTypesService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], AvailableAccountTypesService);
	    return AvailableAccountTypesService;
	}());
	exports.AvailableAccountTypesService = AvailableAccountTypesService;


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var CommonCustomerAccountService = (function () {
	    function CommonCustomerAccountService(_http) {
	        this._http = _http;
	    }
	    CommonCustomerAccountService.prototype.getCustomerAccount = function (customerAccountId) {
	        return this._http.get("/api/backoffice/customer-accounts/" + customerAccountId)
	            .map(function (response) { return response.json(); });
	    };
	    CommonCustomerAccountService.prototype.saveCustomerToLiquidityAccountLinkOptions = function (customerAccountId, liquidityAccountId, allowIncoming, allowOutgoing) {
	        return this._http.patch("/api/backoffice/customer-accounts/" + customerAccountId + "/liquidity-accounts/" + liquidityAccountId + "?options", {}, {
	            search: {
	                'incoming': allowIncoming,
	                'outgoing': allowOutgoing
	            }
	        }).map(function (response) { return response.json(); });
	    };
	    CommonCustomerAccountService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], CommonCustomerAccountService);
	    return CommonCustomerAccountService;
	}());
	exports.CommonCustomerAccountService = CommonCustomerAccountService;


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var http_1 = __webpack_require__(836);
	var core_1 = __webpack_require__(205);
	var AccountStateLogService = (function () {
	    function AccountStateLogService(_http) {
	        this._http = _http;
	        this.BASE_URL = '/api/backoffice';
	    }
	    AccountStateLogService.prototype.getAccountStateLog = function (accountId) {
	        return this._http.get(this.BASE_URL + "/customer-accounts/" + accountId + "/state-log")
	            .map(function (response) { return response.json(); });
	    };
	    AccountStateLogService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], AccountStateLogService);
	    return AccountStateLogService;
	}());
	exports.AccountStateLogService = AccountStateLogService;


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(852);
	var IBANService = (function () {
	    function IBANService(httpClient) {
	        this.httpClient = httpClient;
	    }
	    IBANService.prototype.getFreeIBANs = function () {
	        return this.httpClient.get('/api/backoffice/ibans/free')
	            .map(function (ibanSuggested) { return ibanSuggested.iban; });
	    };
	    IBANService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.HttpClient])
	    ], IBANService);
	    return IBANService;
	}());
	exports.IBANService = IBANService;


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var http_1 = __webpack_require__(836);
	var core_1 = __webpack_require__(205);
	var Observable_1 = __webpack_require__(206);
	var http_2 = __webpack_require__(836);
	var BanksService = (function () {
	    function BanksService(http) {
	        this.http = http;
	    }
	    BanksService.prototype.getBanks = function () {
	        var _this = this;
	        if (lodash_1.isEmpty(this.banks)) {
	            return this.http.get('/api/backoffice/banks')
	                .map(function (response) { return response.json(); })
	                .map(function (response) {
	                _this.banks = response["banks"];
	                return _this.banks;
	            });
	        }
	        else {
	            return Observable_1.Observable.of(this.banks);
	        }
	    };
	    BanksService.prototype.getBanksByCurrency = function (currency_id) {
	        return this.http.get("/api/backoffice/banks?currency-id=" + currency_id)
	            .map(function (response) { return response.json()["banks"]; });
	    };
	    BanksService.prototype.getBanksByCurrencyAndCouldCreateCurrentAccount = function (currencyId, couldCreateCurrentAccount) {
	        var params = new http_2.URLSearchParams();
	        params.set('currencyId', currencyId.toString());
	        params.set('couldCreateCurrentAccount', couldCreateCurrentAccount.toString());
	        return this.http.get('/api/backoffice/banks', { search: params })
	            .map(function (response) { return response.json()["banks"]; });
	    };
	    BanksService.prototype.getLiquidityByBankAndCurrency = function (data) {
	        return this.http.get("/api/backoffice/customers/liquidity-accounts?bank-id=" + data.bank + "&currency-id=" + data.currency)
	            .map(function (response) { return response.json()['accounts']; });
	    };
	    BanksService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], BanksService);
	    return BanksService;
	}());
	exports.BanksService = BanksService;


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var dictionaries_1 = __webpack_require__(1103);
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(852);
	var BackofficeReasonsService = (function (_super) {
	    __extends(BackofficeReasonsService, _super);
	    function BackofficeReasonsService(http) {
	        return _super.call(this, http, BackofficeReasonsService_1.context) || this;
	    }
	    BackofficeReasonsService_1 = BackofficeReasonsService;
	    BackofficeReasonsService.context = 'backoffice';
	    BackofficeReasonsService = BackofficeReasonsService_1 = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.HttpClient])
	    ], BackofficeReasonsService);
	    return BackofficeReasonsService;
	    var BackofficeReasonsService_1;
	}(dictionaries_1.ReasonsService));
	exports.BackofficeReasonsService = BackofficeReasonsService;


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1104));
	__export(__webpack_require__(1105));
	__export(__webpack_require__(1106));
	__export(__webpack_require__(1107));
	__export(__webpack_require__(1108));
	__export(__webpack_require__(1109));
	__export(__webpack_require__(1110));
	__export(__webpack_require__(1111));
	__export(__webpack_require__(1112));
	__export(__webpack_require__(1113));
	__export(__webpack_require__(1114));
	__export(__webpack_require__(1115));
	__export(__webpack_require__(1116));
	__export(__webpack_require__(1117));


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var Observable_1 = __webpack_require__(206);
	var lodash_1 = __webpack_require__(268);
	var CountriesService = (function () {
	    function CountriesService(http) {
	        this.http = http;
	    }
	    CountriesService.prototype.getCountries = function (clearCache) {
	        if (clearCache === void 0) { clearCache = false; }
	        if (!this.countries$ || clearCache) {
	            this.countries$ = this.getCountriesWithFilter(false)
	                .map(function (countries) { return countries; })
	                .publishReplay(1)
	                .refCount();
	        }
	        return this.countries$;
	    };
	    CountriesService.prototype.getAllowedPaymentsCountries = function () {
	        var _this = this;
	        if (lodash_1.isEmpty(this.allowedCountries)) {
	            return this.getCountriesWithFilter(true)
	                .map(function (countries) {
	                _this.allowedCountries = countries;
	                return _this.allowedCountries;
	            });
	        }
	        else {
	            return Observable_1.Observable.of(this.allowedCountries);
	        }
	    };
	    CountriesService.prototype.getEuropeanCountries = function () {
	        var _this = this;
	        if (lodash_1.isEmpty(this.europeanCountries)) {
	            return this.getEuropeCountries()
	                .map(function (countries) {
	                _this.europeanCountries = countries;
	                return _this.europeanCountries;
	            });
	        }
	        else {
	            return Observable_1.Observable.of(this.europeanCountries);
	        }
	    };
	    CountriesService.prototype.getAvailableCountries = function () {
	        var _this = this;
	        if (lodash_1.isEmpty(this.availableCountries)) {
	            return this.getAllAvailableCountries()
	                .map(function (countries) {
	                _this.availableCountries = countries;
	                return _this.availableCountries;
	            });
	        }
	        else {
	            return Observable_1.Observable.of(this.availableCountries);
	        }
	    };
	    CountriesService.prototype.getAllowedSepaPaymentsCountries = function () {
	        var _this = this;
	        if (lodash_1.isEmpty(this.sepaCountries)) {
	            return this.getSepaCountries()
	                .map(function (countries) {
	                _this.sepaCountries = countries;
	                return _this.sepaCountries;
	            });
	        }
	        else {
	            return Observable_1.Observable.of(this.sepaCountries);
	        }
	    };
	    CountriesService.prototype.getCountriesWithFilter = function (allow) {
	        return this.http.get('/api/client/dictionary/countries', { search: this._buildSearchParam(allow) })
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return response.countries; });
	    };
	    CountriesService.prototype.getCountryById = function (id) {
	        return this.http.get('/api/client/dictionary/country', { search: this._buildSearchParamId(id) })
	            .map(function (response) { return response.json(); });
	    };
	    CountriesService.prototype.getEuropeCountries = function () {
	        return this.http.get('/api/client/dictionary/countries/europe')
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return response.countries; });
	    };
	    CountriesService.prototype.getAllAvailableCountries = function () {
	        return this.http.get('/api/client/dictionary/countries/available')
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return response.countries; });
	    };
	    CountriesService.prototype.getSepaCountries = function () {
	        return this.http.get('/api/client/dictionary/countries/sepa')
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return response.countries; });
	    };
	    CountriesService.prototype.getAllCountries = function () {
	        return this.http.get('/api/client/dictionary/countries/all')
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return response.countries; });
	    };
	    CountriesService.prototype._buildSearchParam = function (allow) {
	        var search = new http_1.URLSearchParams();
	        search.set('allow_pay', String(allow));
	        return search;
	    };
	    CountriesService.prototype._buildSearchParamId = function (id) {
	        var search = new http_1.URLSearchParams();
	        search.set('id', String(id));
	        return search;
	    };
	    CountriesService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], CountriesService);
	    return CountriesService;
	}());
	exports.CountriesService = CountriesService;


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var http_1 = __webpack_require__(836);
	var core_1 = __webpack_require__(205);
	var Observable_1 = __webpack_require__(206);
	var CurrenciesService = (function () {
	    function CurrenciesService(http) {
	        this.http = http;
	    }
	    CurrenciesService.prototype.getCurrencies = function () {
	        var _this = this;
	        if (lodash_1.isEmpty(this.currencies)) {
	            return this._getCurrencies(false)
	                .map(function (currencies) {
	                _this.currencies = currencies;
	                return _this.currencies = currencies;
	            });
	        }
	        else {
	            return Observable_1.Observable.of(this.currencies);
	        }
	    };
	    CurrenciesService.prototype.getAvailableCurrencies = function () {
	        var _this = this;
	        if (lodash_1.isEmpty(this.availableCurrencies)) {
	            return this._getCurrencies(true)
	                .map(function (currencies) {
	                _this.availableCurrencies = currencies;
	                return currencies;
	            });
	        }
	        else {
	            return Observable_1.Observable.of(this.availableCurrencies);
	        }
	    };
	    CurrenciesService.prototype._getCurrencies = function (availableOnly) {
	        return this.http.get('/api/client/dictionary/currencies', { search: this._buildSearchParam(availableOnly) })
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return response.currencies; });
	    };
	    CurrenciesService.prototype._buildSearchParam = function (availableOnly) {
	        var search = new http_1.URLSearchParams();
	        search.set('available_only', String(availableOnly));
	        return search;
	    };
	    CurrenciesService.prototype.getAppreciateCurrencies = function () {
	        return this.http.get('/api/client/dictionary/currencies?appreciate')
	            .map(function (result) { return result.json(); })
	            .map(function (result) { return result.currencies; });
	    };
	    CurrenciesService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], CurrenciesService);
	    return CurrenciesService;
	}());
	exports.CurrenciesService = CurrenciesService;


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var http_1 = __webpack_require__(836);
	var core_1 = __webpack_require__(205);
	var Observable_1 = __webpack_require__(206);
	var BusinessProfileService = (function () {
	    function BusinessProfileService(http) {
	        this.http = http;
	    }
	    BusinessProfileService.prototype.getBusinessProfiles = function () {
	        var _this = this;
	        if (lodash_1.isEmpty(this.businessProfiles)) {
	            return this.http.get('/api/client/dictionary/business_profiles')
	                .map(function (response) { return response.json(); })
	                .map(function (response) {
	                _this.businessProfiles = response.businessProfiles;
	                return _this.businessProfiles;
	            });
	        }
	        else {
	            return Observable_1.Observable.of(this.businessProfiles);
	        }
	    };
	    BusinessProfileService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], BusinessProfileService);
	    return BusinessProfileService;
	}());
	exports.BusinessProfileService = BusinessProfileService;


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var http_1 = __webpack_require__(836);
	var core_1 = __webpack_require__(205);
	var Observable_1 = __webpack_require__(206);
	var BusinessActivityDurationsService = (function () {
	    function BusinessActivityDurationsService(http) {
	        this.http = http;
	    }
	    BusinessActivityDurationsService.prototype.getBusinessActivityDurations = function () {
	        var _this = this;
	        if (lodash_1.isEmpty(this.businessActivityDurationsProfiles)) {
	            return this.http.get('/api/client/dictionary/business_activity_durations')
	                .map(function (response) { return response.json(); })
	                .map(function (response) {
	                _this.businessActivityDurationsProfiles = response.businessActivityDurations;
	                return _this.businessActivityDurationsProfiles;
	            });
	        }
	        else {
	            return Observable_1.Observable.of(this.businessActivityDurationsProfiles);
	        }
	    };
	    BusinessActivityDurationsService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], BusinessActivityDurationsService);
	    return BusinessActivityDurationsService;
	}());
	exports.BusinessActivityDurationsService = BusinessActivityDurationsService;


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var http_1 = __webpack_require__(836);
	var core_1 = __webpack_require__(205);
	var Observable_1 = __webpack_require__(206);
	var KeyFinancialIndicatorsService = (function () {
	    function KeyFinancialIndicatorsService(http) {
	        this.http = http;
	    }
	    KeyFinancialIndicatorsService.prototype.getKeyFinancialIndicators = function () {
	        var _this = this;
	        if (lodash_1.isEmpty(this.keyFinancialIndicators)) {
	            return this.http.get('/api/client/dictionary/key_financial_indicators')
	                .map(function (response) { return response.json(); })
	                .map(function (response) {
	                _this.keyFinancialIndicators = response.keyFinancialIndicators;
	                return _this.keyFinancialIndicators;
	            });
	        }
	        else {
	            return Observable_1.Observable.of(this.keyFinancialIndicators);
	        }
	    };
	    KeyFinancialIndicatorsService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], KeyFinancialIndicatorsService);
	    return KeyFinancialIndicatorsService;
	}());
	exports.KeyFinancialIndicatorsService = KeyFinancialIndicatorsService;


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var http_1 = __webpack_require__(836);
	var core_1 = __webpack_require__(205);
	var Observable_1 = __webpack_require__(206);
	var EmployeesNumbersService = (function () {
	    function EmployeesNumbersService(http) {
	        this.http = http;
	    }
	    EmployeesNumbersService.prototype.getEmployeesNumbers = function () {
	        var _this = this;
	        if (lodash_1.isEmpty(this.employeesNumbers)) {
	            return this.http.get('/api/client/dictionary/employees_numbers')
	                .map(function (response) { return response.json(); })
	                .map(function (response) {
	                _this.employeesNumbers = response.employeesNumbers;
	                return _this.employeesNumbers;
	            });
	        }
	        else {
	            return Observable_1.Observable.of(this.employeesNumbers);
	        }
	    };
	    EmployeesNumbersService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], EmployeesNumbersService);
	    return EmployeesNumbersService;
	}());
	exports.EmployeesNumbersService = EmployeesNumbersService;


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var http_1 = __webpack_require__(836);
	var core_1 = __webpack_require__(205);
	var Observable_1 = __webpack_require__(206);
	var TotalBalancesService = (function () {
	    function TotalBalancesService(http) {
	        this.http = http;
	    }
	    TotalBalancesService.prototype.getTotalBalances = function () {
	        var _this = this;
	        if (lodash_1.isEmpty(this.totalBalances)) {
	            return this.http.get('/api/client/dictionary/total_balances')
	                .map(function (response) { return response.json(); })
	                .map(function (response) {
	                _this.totalBalances = response.totalBalances;
	                return _this.totalBalances;
	            });
	        }
	        else {
	            return Observable_1.Observable.of(this.totalBalances);
	        }
	    };
	    TotalBalancesService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], TotalBalancesService);
	    return TotalBalancesService;
	}());
	exports.TotalBalancesService = TotalBalancesService;


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var http_1 = __webpack_require__(836);
	var core_1 = __webpack_require__(205);
	var Observable_1 = __webpack_require__(206);
	exports.OTHER_PRODUCT = { id: 9, name: "Other", specify: true };
	var ProductsService = (function () {
	    function ProductsService(http) {
	        this.http = http;
	    }
	    ProductsService.prototype.getAllProducts = function () {
	        var _this = this;
	        if (lodash_1.isEmpty(this.allProducts)) {
	            return this.http.get('/api/client/dictionary/products?all')
	                .map(function (response) { return response.json(); })
	                .map(function (responce) {
	                _this.allProducts = responce.products;
	                return _this.allProducts;
	            });
	        }
	        else {
	            return Observable_1.Observable.of(this.allProducts);
	        }
	    };
	    ProductsService.prototype.getPrivateProducts = function () {
	        var _this = this;
	        if (lodash_1.isEmpty(this.products)) {
	            return this.http.get('/api/client/dictionary/products/private')
	                .map(function (response) { return response.json(); })
	                .map(function (response) {
	                _this.products = response.products;
	                return _this.products;
	            });
	        }
	        else {
	            return Observable_1.Observable.of(this.products);
	        }
	    };
	    ProductsService.prototype.getCorporateProducts = function () {
	        var _this = this;
	        if (lodash_1.isEmpty(this.products)) {
	            return this.http.get('/api/client/dictionary/products/corporate')
	                .map(function (response) { return response.json(); })
	                .map(function (response) {
	                _this.products = response.products;
	                return _this.products;
	            });
	        }
	        else {
	            return Observable_1.Observable.of(this.products);
	        }
	    };
	    ProductsService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], ProductsService);
	    return ProductsService;
	}());
	exports.ProductsService = ProductsService;


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(206);
	exports.OTHER_REASON = { id: 4, name: "Other", specify: true };
	exports.REASON_GROUP_ID_REGISTRATION = 0;
	exports.REASON_GROUP_ID_REJECT_APPLICANT = 1;
	exports.REASON_GROUP_ID_ARCHIVED_APPLICANT = 5;
	exports.REASON_GROUP_ID_ON_HOLD_APPLICANT = 6;
	var ReasonsService = (function () {
	    function ReasonsService(_http, context) {
	        this._http = _http;
	        this.context = context;
	        this.allReasonsMap = new Map();
	        this.activeReasonsMap = new Map();
	    }
	    ReasonsService.prototype.getActiveReasonsByGroupId = function (groupId) {
	        return this.getReasons("/api/" + this.context + "/dictionary/reasons/" + groupId, groupId, this.activeReasonsMap);
	    };
	    ReasonsService.prototype.getAllReasonsByGroupId = function (groupId) {
	        return this.getReasons("/api/" + this.context + "/dictionary/reasons/" + groupId + "?all", groupId, this.allReasonsMap);
	    };
	    ReasonsService.prototype.getOtherAsUniqueReason = function () {
	        var otherReasonArray = [];
	        otherReasonArray.push(exports.OTHER_REASON);
	        return Observable_1.Observable.of(otherReasonArray);
	    };
	    ReasonsService.prototype.getReasons = function (url, groupId, cache) {
	        if (cache.has(groupId)) {
	            return Observable_1.Observable.of(cache.get(groupId));
	        }
	        return this._http.get(url)
	            .map(function (response) {
	            var reasons = response.reasons;
	            cache.set(groupId, reasons);
	            return reasons;
	        });
	    };
	    return ReasonsService;
	}());
	exports.ReasonsService = ReasonsService;


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var http_1 = __webpack_require__(836);
	var core_1 = __webpack_require__(205);
	var Observable_1 = __webpack_require__(206);
	exports.OTHER_INFORMATION_SOURCE = { id: 7, name: "Other", specify: true };
	var SourcesService = (function () {
	    function SourcesService(http) {
	        this.http = http;
	    }
	    SourcesService.prototype.getSources = function () {
	        var _this = this;
	        if (lodash_1.isEmpty(this.informationSources)) {
	            return this.http.get('/api/client/dictionary/information_sources')
	                .map(function (response) { return response.json(); })
	                .map(function (response) {
	                _this.informationSources = response.informationSources;
	                return _this.informationSources;
	            });
	        }
	        else {
	            return Observable_1.Observable.of(this.informationSources);
	        }
	    };
	    SourcesService.prototype.getAllInformationSources = function () {
	        var _this = this;
	        if (lodash_1.isEmpty(this.allInformationSources)) {
	            return this.http.get('/api/client/dictionary/information_sources?all')
	                .map(function (response) { return response.json(); })
	                .map(function (response) {
	                _this.allInformationSources = response.informationSources;
	                return _this.allInformationSources;
	            });
	        }
	        else {
	            return Observable_1.Observable.of(this.allInformationSources);
	        }
	    };
	    SourcesService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], SourcesService);
	    return SourcesService;
	}());
	exports.SourcesService = SourcesService;


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(852);
	var PurposesService = (function () {
	    function PurposesService(_http) {
	        this._http = _http;
	    }
	    PurposesService.prototype.getPurposes = function () {
	        return this._http.get("api/client/dictionary/purposes")
	            .map(function (res) { return res.records; });
	    };
	    PurposesService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.HttpClient])
	    ], PurposesService);
	    return PurposesService;
	}());
	exports.PurposesService = PurposesService;


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(852);
	var BusinessTypeCategoriesService = (function () {
	    function BusinessTypeCategoriesService(http, context) {
	        this.http = http;
	        this.context = context;
	        this.URL = "/api/" + this.context + "/dictionary/bussines-type-categories";
	    }
	    BusinessTypeCategoriesService.prototype.getBusinessTypeCategories = function () {
	        return this.http.get(this.URL);
	    };
	    BusinessTypeCategoriesService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.HttpClient, Object])
	    ], BusinessTypeCategoriesService);
	    return BusinessTypeCategoriesService;
	}());
	exports.BusinessTypeCategoriesService = BusinessTypeCategoriesService;


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(206);
	exports.CUSTOMER_STATEMENT_REPORT_GROUP_ID = 0;
	var ReportTypesService = (function () {
	    function ReportTypesService(_http, context) {
	        this._http = _http;
	        this.context = context;
	        this.reportTypesMap = new Map();
	    }
	    ReportTypesService.prototype.getReportTypesByGroupId = function (groupId) {
	        return this.getReasons("/api/" + this.context + "/dictionary/report_types/" + groupId, groupId, this.reportTypesMap);
	    };
	    ReportTypesService.prototype.getReasons = function (url, groupId, cache) {
	        if (cache.has(groupId)) {
	            return Observable_1.Observable.of(cache.get(groupId));
	        }
	        return this._http.get(url)
	            .map(function (response) {
	            var reasons = response.records;
	            cache.set(groupId, reasons);
	            return reasons;
	        });
	    };
	    return ReportTypesService;
	}());
	exports.ReportTypesService = ReportTypesService;


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(852);
	var SepaErrorService = (function () {
	    function SepaErrorService(http) {
	        this.http = http;
	    }
	    SepaErrorService.prototype.getRetentionsErrors = function () {
	        return this.http.get("api/client/dictionary/sepa_error/retention");
	    };
	    SepaErrorService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.HttpClient])
	    ], SepaErrorService);
	    return SepaErrorService;
	}());
	exports.SepaErrorService = SepaErrorService;


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(852);
	var ranges_service_1 = __webpack_require__(1119);
	var BackofficeRangesService = (function (_super) {
	    __extends(BackofficeRangesService, _super);
	    function BackofficeRangesService(http) {
	        return _super.call(this, http, BackofficeRangesService_1.context) || this;
	    }
	    BackofficeRangesService_1 = BackofficeRangesService;
	    BackofficeRangesService.context = 'backoffice';
	    BackofficeRangesService = BackofficeRangesService_1 = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.HttpClient])
	    ], BackofficeRangesService);
	    return BackofficeRangesService;
	    var BackofficeRangesService_1;
	}(ranges_service_1.RangesService));
	exports.BackofficeRangesService = BackofficeRangesService;


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(206);
	var RangesService = (function () {
	    function RangesService(_http, context) {
	        this._http = _http;
	        this.context = context;
	        this.allRangesMap = new Map();
	    }
	    RangesService.prototype.getAllRangesByGroupId = function (groupId) {
	        return this.getRanges("/api/" + this.context + "/dictionary/ranges/" + groupId, groupId, this.allRangesMap);
	    };
	    RangesService.prototype.getRanges = function (url, groupId, cache) {
	        if (cache.has(groupId)) {
	            return Observable_1.Observable.of(cache.get(groupId));
	        }
	        return this._http.get(url)
	            .map(function (response) {
	            var ranges = response.ranges;
	            cache.set(groupId, ranges);
	            return ranges;
	        });
	    };
	    return RangesService;
	}());
	exports.RangesService = RangesService;


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var dictionaries_1 = __webpack_require__(1103);
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(852);
	var BackofficePurposesService = (function (_super) {
	    __extends(BackofficePurposesService, _super);
	    function BackofficePurposesService(http) {
	        return _super.call(this, http) || this;
	    }
	    BackofficePurposesService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.HttpClient])
	    ], BackofficePurposesService);
	    return BackofficePurposesService;
	}(dictionaries_1.PurposesService));
	exports.BackofficePurposesService = BackofficePurposesService;


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(852);
	var business_type_categories_service_1 = __webpack_require__(1115);
	var BackofficeBusinessTypeCategoriesService = (function (_super) {
	    __extends(BackofficeBusinessTypeCategoriesService, _super);
	    function BackofficeBusinessTypeCategoriesService(http) {
	        return _super.call(this, http, BackofficeBusinessTypeCategoriesService_1.context) || this;
	    }
	    BackofficeBusinessTypeCategoriesService_1 = BackofficeBusinessTypeCategoriesService;
	    BackofficeBusinessTypeCategoriesService.context = 'backoffice';
	    BackofficeBusinessTypeCategoriesService = BackofficeBusinessTypeCategoriesService_1 = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.HttpClient])
	    ], BackofficeBusinessTypeCategoriesService);
	    return BackofficeBusinessTypeCategoriesService;
	    var BackofficeBusinessTypeCategoriesService_1;
	}(business_type_categories_service_1.BusinessTypeCategoriesService));
	exports.BackofficeBusinessTypeCategoriesService = BackofficeBusinessTypeCategoriesService;


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var api_1 = __webpack_require__(1123);
	var http_1 = __webpack_require__(852);
	var BackofficeReportTypesService = (function (_super) {
	    __extends(BackofficeReportTypesService, _super);
	    function BackofficeReportTypesService(http) {
	        return _super.call(this, http, BackofficeReportTypesService_1.context) || this;
	    }
	    BackofficeReportTypesService_1 = BackofficeReportTypesService;
	    BackofficeReportTypesService.context = 'backoffice';
	    BackofficeReportTypesService = BackofficeReportTypesService_1 = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.HttpClient])
	    ], BackofficeReportTypesService);
	    return BackofficeReportTypesService;
	    var BackofficeReportTypesService_1;
	}(api_1.ReportTypesService));
	exports.BackofficeReportTypesService = BackofficeReportTypesService;


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1124));
	__export(__webpack_require__(1103));


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var http_1 = __webpack_require__(836);
	var core_1 = __webpack_require__(205);
	var ensure_module_loaded_once_guard_1 = __webpack_require__(1125);
	var dictionaries_1 = __webpack_require__(1103);
	var recall_payment_reason_service_1 = __webpack_require__(1126);
	var DictionaryModule = (function (_super) {
	    __extends(DictionaryModule, _super);
	    //Looks for the module in the parent injector to see if it's already been loaded (only want it loaded once)
	    function DictionaryModule(parent) {
	        return _super.call(this, parent) || this;
	    }
	    DictionaryModule = __decorate([
	        core_1.NgModule({
	            imports: [http_1.HttpModule],
	            providers: [
	                dictionaries_1.BusinessActivityDurationsService,
	                dictionaries_1.BusinessProfileService,
	                dictionaries_1.CountriesService,
	                dictionaries_1.CurrenciesService,
	                dictionaries_1.EmployeesNumbersService,
	                dictionaries_1.KeyFinancialIndicatorsService,
	                dictionaries_1.ProductsService,
	                dictionaries_1.SourcesService,
	                dictionaries_1.TotalBalancesService,
	                dictionaries_1.PurposesService,
	                dictionaries_1.SepaErrorService,
	                recall_payment_reason_service_1.RecallPaymentReasonService
	            ]
	        }),
	        __param(0, core_1.Optional()), __param(0, core_1.SkipSelf()),
	        __metadata("design:paramtypes", [DictionaryModule])
	    ], DictionaryModule);
	    return DictionaryModule;
	}(ensure_module_loaded_once_guard_1.EnsureModuleLoadedOnceGuard));
	exports.DictionaryModule = DictionaryModule;


/***/ }),
/* 1125 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var EnsureModuleLoadedOnceGuard = (function () {
	    function EnsureModuleLoadedOnceGuard(targetModule) {
	        if (targetModule) {
	            throw new Error(targetModule.constructor.name + " has already been loaded. Import this module in the AppModule only.");
	        }
	    }
	    return EnsureModuleLoadedOnceGuard;
	}());
	exports.EnsureModuleLoadedOnceGuard = EnsureModuleLoadedOnceGuard;


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(852);
	var RecallPaymentReasonService = (function () {
	    function RecallPaymentReasonService(http) {
	        this.http = http;
	    }
	    RecallPaymentReasonService.prototype.getRecallPaymentReason = function () {
	        return this.http.get("api/client/dictionary/recall_payment/reason");
	    };
	    RecallPaymentReasonService.prototype.canRecall = function (id) {
	        return this.http.get("/api/backoffice/transfers/" + id + "/can_recall");
	    };
	    RecallPaymentReasonService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.HttpClient])
	    ], RecallPaymentReasonService);
	    return RecallPaymentReasonService;
	}());
	exports.RecallPaymentReasonService = RecallPaymentReasonService;


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1128));
	__export(__webpack_require__(1130));
	__export(__webpack_require__(1132));
	__export(__webpack_require__(1135));
	__export(__webpack_require__(1136));
	__export(__webpack_require__(1137));
	__export(__webpack_require__(1138));


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1129));


/***/ }),
/* 1129 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var PAYMENT_TYPE;
	(function (PAYMENT_TYPE) {
	    PAYMENT_TYPE["INCOMING"] = "incoming";
	    PAYMENT_TYPE["OUTGOING"] = "outgoing";
	    PAYMENT_TYPE["INTERNAL"] = "internal";
	    PAYMENT_TYPE["DELIVERED"] = "delivered";
	    PAYMENT_TYPE["UNDELIVERED"] = "undelivered";
	    PAYMENT_TYPE["REFUND"] = "refund";
	    PAYMENT_TYPE["FEE"] = "fee";
	    PAYMENT_TYPE["CARD"] = "card";
	    PAYMENT_TYPE["SYSTEM"] = "system";
	})(PAYMENT_TYPE = exports.PAYMENT_TYPE || (exports.PAYMENT_TYPE = {}));


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1131));


/***/ }),
/* 1131 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var FileState;
	(function (FileState) {
	    FileState[FileState["CANCELED"] = 1] = "CANCELED";
	    FileState[FileState["NOT_PROCESSED"] = 2] = "NOT_PROCESSED";
	    FileState[FileState["PROCESSED"] = 3] = "PROCESSED";
	    FileState[FileState["NEW"] = 4] = "NEW";
	    FileState[FileState["NOT_RELEVANT"] = 5] = "NOT_RELEVANT";
	})(FileState = exports.FileState || (exports.FileState = {}));


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1133));


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1134));


/***/ }),
/* 1134 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var OutgoingTransferDetail = (function () {
	    function OutgoingTransferDetail() {
	    }
	    return OutgoingTransferDetail;
	}());
	exports.OutgoingTransferDetail = OutgoingTransferDetail;
	var SenderPaymentInfo = (function () {
	    function SenderPaymentInfo() {
	    }
	    return SenderPaymentInfo;
	}());
	exports.SenderPaymentInfo = SenderPaymentInfo;
	var RecipientPaymentInfo = (function () {
	    function RecipientPaymentInfo() {
	    }
	    return RecipientPaymentInfo;
	}());
	exports.RecipientPaymentInfo = RecipientPaymentInfo;
	var Profile = (function () {
	    function Profile() {
	    }
	    return Profile;
	}());
	exports.Profile = Profile;
	var BeneficiaryAddress = (function () {
	    function BeneficiaryAddress() {
	    }
	    return BeneficiaryAddress;
	}());
	exports.BeneficiaryAddress = BeneficiaryAddress;


/***/ }),
/* 1135 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var RiskLevel = (function () {
	    function RiskLevel() {
	    }
	    return RiskLevel;
	}());
	exports.RiskLevel = RiskLevel;


/***/ }),
/* 1136 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var PaginationModel = (function () {
	    function PaginationModel() {
	    }
	    return PaginationModel;
	}());
	exports.PaginationModel = PaginationModel;


/***/ }),
/* 1137 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ACCOUNT_INACTIVE_STATE_ID = 1;
	exports.ACCOUNT_ACTIVE_STATE_ID = 2;


/***/ }),
/* 1138 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var AccountStateLogEntry = (function () {
	    function AccountStateLogEntry() {
	    }
	    return AccountStateLogEntry;
	}());
	exports.AccountStateLogEntry = AccountStateLogEntry;


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var common_1 = __webpack_require__(246);
	var BackButtonComponent = (function () {
	    function BackButtonComponent(location) {
	        this.location = location;
	    }
	    BackButtonComponent.prototype.goBack = function () {
	        this.location.back();
	    };
	    BackButtonComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-back-button',
	            template: "\n        <button class=\"btn-link\" style=\"text-decoration: none\" (click)=\"goBack()\">\n            <i class=\"fa fa-long-arrow-left\" aria-hidden=\"true\"></i>\n            <span>{{'COMMON.BACK'|translate}}</span>\n        </button>\n    ",
	            styles: ["\n        span {\n            vertical-align: super;\n        }\n\n        i {\n            font-size: 2em;\n        }\n    "
	            ]
	        }),
	        __metadata("design:paramtypes", [common_1.Location])
	    ], BackButtonComponent);
	    return BackButtonComponent;
	}());
	exports.BackButtonComponent = BackButtonComponent;


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tab_component_1 = __webpack_require__(1141);
	var tab_holder_component_1 = __webpack_require__(1142);
	exports.BO_TAB_COMPONENTS = [
	    tab_component_1.TabComponent,
	    tab_holder_component_1.DynamicTabHolderComponent
	];


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var TabComponent = (function () {
	    function TabComponent() {
	        this.navigationPoint = [];
	        this.active = false;
	    }
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], TabComponent.prototype, "title", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], TabComponent.prototype, "navigationPoint", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], TabComponent.prototype, "active", void 0);
	    TabComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-tab',
	            template: "\n        <ng-content></ng-content>\n    "
	        })
	    ], TabComponent);
	    return TabComponent;
	}());
	exports.TabComponent = TabComponent;


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var tab_component_1 = __webpack_require__(1141);
	var router_1 = __webpack_require__(270);
	// TODO s.bavykin Add a possibility to support permissions for tab
	var DynamicTabHolderComponent = (function () {
	    function DynamicTabHolderComponent(_router) {
	        this._router = _router;
	    }
	    DynamicTabHolderComponent.prototype.ngAfterContentInit = function () {
	        var _this = this;
	        var activeTabs = this.tabs.filter(function (tab) { return tab.active; });
	        var tabForActivation;
	        // bind tab activation to router path
	        this.path = this._router.url.toString().substring(this._router.url.lastIndexOf('/') + 1);
	        tabForActivation = this.tabs.filter(function (tab) { return tab.title.toLowerCase() == _this.path.replace('-', ' '); })[0];
	        if (activeTabs.length === 0) {
	            this.selectTab(tabForActivation);
	        }
	    };
	    DynamicTabHolderComponent.prototype.selectTab = function (tab) {
	        this.tabs.toArray().forEach(function (t) { return t.active = false; });
	        // activate specified tab
	        if (tab) {
	            tab.active = true;
	            this._router.navigate(tab.navigationPoint);
	        }
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], DynamicTabHolderComponent.prototype, "panelTitle", void 0);
	    __decorate([
	        core_1.ContentChildren(tab_component_1.TabComponent),
	        __metadata("design:type", core_1.QueryList)
	    ], DynamicTabHolderComponent.prototype, "tabs", void 0);
	    DynamicTabHolderComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-dynamic-tab-holder',
	            template: "\n        <panel title=\"{{ panelTitle }}\" class=\"tab-panel\">\n            <div class=\"row tab-headers\">\n                <div class=\"tab-header col-xs-2 text-center\"\n                     *ngFor=\"let tab of tabs\"\n                     (click)=\"selectTab(tab)\" [class.selected]=\"tab.active\">\n                    {{ tab.title }}\n                </div>\n            </div>\n\n            <ng-content></ng-content>\n        </panel>\n    "
	        }),
	        __metadata("design:paramtypes", [router_1.Router])
	    ], DynamicTabHolderComponent);
	    return DynamicTabHolderComponent;
	}());
	exports.DynamicTabHolderComponent = DynamicTabHolderComponent;


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var card_box_component_1 = __webpack_require__(1144);
	var card_box_inline_component_1 = __webpack_require__(1145);
	var card_box_header_component_1 = __webpack_require__(1146);
	var card_box_content_component_1 = __webpack_require__(1147);
	var card_box_action_component_1 = __webpack_require__(1148);
	var card_box_profile_content_resolver_1 = __webpack_require__(1149);
	var card_box_private_content_component_1 = __webpack_require__(1156);
	var card_box_corporate_content_component_1 = __webpack_require__(1159);
	exports.CARD_BOX_COMPONENTS = [
	    card_box_component_1.CardBoxComponent,
	    card_box_inline_component_1.CardBoxComponentInline,
	    card_box_header_component_1.CardBoxHeaderComponent,
	    card_box_action_component_1.CardBoxActionComponent,
	    card_box_content_component_1.CardBoxContentComponent,
	    card_box_profile_content_resolver_1.CardBoxProfileContentResolver,
	    card_box_private_content_component_1.CardBoxPrivateContentComponent,
	    card_box_corporate_content_component_1.CardBoxCorporateContentComponent,
	];


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(743);
	var core_1 = __webpack_require__(205);
	var CardBoxComponent = (function () {
	    function CardBoxComponent() {
	        this.boxColorClass = '';
	        this.cardBoxHeaderClass = 'col-lg-10 col-md-10 col-sm-10 col-xs-12';
	        this.cardBoxContentClass = 'col-lg-10 col-md-10 col-sm-10 col-xs-12';
	        this.cardBoxActionClass = 'col-lg-2 col-md-2 col-sm-2 col-xs-12';
	    }
	    CardBoxComponent.prototype.getBoxColorStyle = function () {
	        if (!util_1.isNullOrUndefined(this.boxColor)) {
	            return {
	                'box-shadow': "-15px 0 0 0 " + this.boxColor
	            };
	        }
	    };
	    __decorate([
	        core_1.Input('box-color'),
	        __metadata("design:type", String)
	    ], CardBoxComponent.prototype, "boxColor", void 0);
	    __decorate([
	        core_1.Input('box-color-class'),
	        __metadata("design:type", String)
	    ], CardBoxComponent.prototype, "boxColorClass", void 0);
	    __decorate([
	        core_1.Input('card-box-header-class'),
	        __metadata("design:type", String)
	    ], CardBoxComponent.prototype, "cardBoxHeaderClass", void 0);
	    __decorate([
	        core_1.Input('card-box-content-class'),
	        __metadata("design:type", String)
	    ], CardBoxComponent.prototype, "cardBoxContentClass", void 0);
	    __decorate([
	        core_1.Input('card-box-action-class'),
	        __metadata("design:type", String)
	    ], CardBoxComponent.prototype, "cardBoxActionClass", void 0);
	    CardBoxComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-card-box',
	            template: "\n        <div class=\"card-box row {{boxColorClass}}\" [ngStyle]=\"getBoxColorStyle()\">\n            <div class=\"card-box-header {{ cardBoxHeaderClass }}\">\n                <ng-content select=\"tfl-bo-card-box-header\"></ng-content>\n            </div>\n            \n            <div class=\"card-box-content {{ cardBoxContentClass }}\">\n                <ng-content select=\"tfl-bo-card-box-content\"></ng-content>\n            </div>\n            \n            <div class=\"card-box-action card-buttons {{ cardBoxActionClass }}\">\n                <ng-content select=\"tfl-bo-card-box-action\"></ng-content>\n            </div>\n        </div>\n    "
	        })
	    ], CardBoxComponent);
	    return CardBoxComponent;
	}());
	exports.CardBoxComponent = CardBoxComponent;


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(743);
	var core_1 = __webpack_require__(205);
	var CardBoxComponentInline = (function () {
	    function CardBoxComponentInline() {
	        this.boxColorClass = '';
	        this.cardBoxHeaderClass = 'col-lg-10 col-md-10 col-sm-10 col-xs-12';
	        this.cardBoxContentClass = 'col-lg-10 col-md-10 col-sm-10 col-xs-12';
	        this.cardBoxActionClass = 'col-lg-1 col-md-2 col-sm-2 col-xs-12';
	    }
	    CardBoxComponentInline.prototype.getBoxColorStyle = function () {
	        if (!util_1.isNullOrUndefined(this.boxColor)) {
	            return {
	                'box-shadow': "-15px 0 0 0 " + this.boxColor
	            };
	        }
	    };
	    __decorate([
	        core_1.Input('box-color'),
	        __metadata("design:type", String)
	    ], CardBoxComponentInline.prototype, "boxColor", void 0);
	    __decorate([
	        core_1.Input('box-color-class'),
	        __metadata("design:type", String)
	    ], CardBoxComponentInline.prototype, "boxColorClass", void 0);
	    __decorate([
	        core_1.Input('card-box-header-class'),
	        __metadata("design:type", String)
	    ], CardBoxComponentInline.prototype, "cardBoxHeaderClass", void 0);
	    __decorate([
	        core_1.Input('card-box-content-class'),
	        __metadata("design:type", String)
	    ], CardBoxComponentInline.prototype, "cardBoxContentClass", void 0);
	    __decorate([
	        core_1.Input('card-box-action-class'),
	        __metadata("design:type", String)
	    ], CardBoxComponentInline.prototype, "cardBoxActionClass", void 0);
	    CardBoxComponentInline = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-card-box-inline',
	            template: "\n        <div class=\"card-box row {{boxColorClass}}\" [ngStyle]=\"getBoxColorStyle()\">\n            <div class=\"card-box-header {{ cardBoxHeaderClass }}\">\n                <ng-content select=\"tfl-bo-card-box-header\"></ng-content>\n            </div>\n            \n            <div class=\"card-box-content {{ cardBoxContentClass }}\">\n                <ng-content select=\"tfl-bo-card-box-content\"></ng-content>\n            </div>\n            \n            <div class=\"card-box-action-inline card-buttons {{ cardBoxActionClass }}\">\n                <ng-content select=\"tfl-bo-card-box-action\"></ng-content>\n            </div>\n        </div>\n    ",
	            styles: ['.btn { margin-bottom: 5px}']
	        })
	    ], CardBoxComponentInline);
	    return CardBoxComponentInline;
	}());
	exports.CardBoxComponentInline = CardBoxComponentInline;


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var CardBoxHeaderComponent = (function () {
	    function CardBoxHeaderComponent() {
	    }
	    CardBoxHeaderComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-card-box-header',
	            template: "\n        <ng-content select=\".card-box-header-icon\"></ng-content>\n       \n        <ng-content select=\".card-box-header-title\"></ng-content>\n\n        <ng-content select=\".card-box-header-content\"></ng-content>\n    "
	        })
	    ], CardBoxHeaderComponent);
	    return CardBoxHeaderComponent;
	}());
	exports.CardBoxHeaderComponent = CardBoxHeaderComponent;


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var CardBoxContentComponent = (function () {
	    function CardBoxContentComponent() {
	    }
	    CardBoxContentComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-card-box-content',
	            template: '<ng-content></ng-content>'
	        })
	    ], CardBoxContentComponent);
	    return CardBoxContentComponent;
	}());
	exports.CardBoxContentComponent = CardBoxContentComponent;


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var CardBoxActionComponent = (function () {
	    function CardBoxActionComponent() {
	    }
	    CardBoxActionComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-card-box-action',
	            template: '<ng-content></ng-content>'
	        })
	    ], CardBoxActionComponent);
	    return CardBoxActionComponent;
	}());
	exports.CardBoxActionComponent = CardBoxActionComponent;


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var entity_1 = __webpack_require__(1150);
	var constants_1 = __webpack_require__(861);
	var CardBoxProfileContentResolver = (function () {
	    function CardBoxProfileContentResolver() {
	        this.TYPE = constants_1.PROFILE_TYPE;
	    }
	    CardBoxProfileContentResolver.prototype.ngOnInit = function () {
	    };
	    __decorate([
	        core_1.Input('customer'),
	        __metadata("design:type", entity_1.CustomerProfile)
	    ], CardBoxProfileContentResolver.prototype, "customer", void 0);
	    CardBoxProfileContentResolver = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-card-box-content-profile-resolver',
	            template: "\n        <div [ngSwitch]=\"true\">\n            <div *ngSwitchCase=\"customer.type == TYPE.PRIVATE\" class=\"row\">\n                <tfb-bo-card-box-private-content [customer]=\"customer\"></tfb-bo-card-box-private-content>\n            </div>\n            <div *ngSwitchCase=\"customer.type == TYPE.CORPORATE\" class=\"row\">\n                <tfb-bo-card-box-corporate-content [customer]=\"customer\"></tfb-bo-card-box-corporate-content>\n            </div>\n        </div>"
	        })
	    ], CardBoxProfileContentResolver);
	    return CardBoxProfileContentResolver;
	}());
	exports.CardBoxProfileContentResolver = CardBoxProfileContentResolver;


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1151));
	__export(__webpack_require__(1152));
	__export(__webpack_require__(1153));
	__export(__webpack_require__(1154));
	__export(__webpack_require__(1155));


/***/ }),
/* 1151 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CustomerProfile = (function () {
	    function CustomerProfile() {
	    }
	    return CustomerProfile;
	}());
	exports.CustomerProfile = CustomerProfile;
	var AmlPepDetails = (function () {
	    function AmlPepDetails() {
	    }
	    return AmlPepDetails;
	}());
	exports.AmlPepDetails = AmlPepDetails;
	var ProfileState = (function () {
	    function ProfileState() {
	    }
	    return ProfileState;
	}());
	exports.ProfileState = ProfileState;
	var ProfileUserState = (function () {
	    function ProfileUserState() {
	    }
	    return ProfileUserState;
	}());
	exports.ProfileUserState = ProfileUserState;
	var ProfileType = (function () {
	    function ProfileType() {
	    }
	    return ProfileType;
	}());
	exports.ProfileType = ProfileType;
	var VerificationStatus = (function () {
	    function VerificationStatus() {
	    }
	    return VerificationStatus;
	}());
	exports.VerificationStatus = VerificationStatus;


/***/ }),
/* 1152 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var UploadedFileResponse = (function () {
	    function UploadedFileResponse() {
	    }
	    return UploadedFileResponse;
	}());
	exports.UploadedFileResponse = UploadedFileResponse;


/***/ }),
/* 1153 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var KYCStatusResult;
	(function (KYCStatusResult) {
	    KYCStatusResult["NOT_VERIFIED"] = "NOT_VERIFIED";
	    KYCStatusResult["IN_PROGRESS"] = "IN_PROGRESS";
	    KYCStatusResult["CLEAR"] = "CLEAR";
	    KYCStatusResult["AML_FOUND"] = "AML found";
	    KYCStatusResult["INVALID"] = "INVALID";
	    KYCStatusResult["INCOMPLETE_DATA"] = "INCOMPLETE_DATA";
	})(KYCStatusResult = exports.KYCStatusResult || (exports.KYCStatusResult = {}));


/***/ }),
/* 1154 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var OnfidoVerificationStatus;
	(function (OnfidoVerificationStatus) {
	    OnfidoVerificationStatus["INVALID"] = "INVALID";
	    OnfidoVerificationStatus["OPEN_TO_UPLOAD_DATA"] = "OPEN_TO_UPLOAD_DATA";
	    OnfidoVerificationStatus["IN_PROGRESS"] = "IN_PROGRESS";
	    OnfidoVerificationStatus["VERIFIED"] = "VERIFIED";
	    OnfidoVerificationStatus["DECLINED"] = "DECLINED";
	    OnfidoVerificationStatus["OUT_OF_VERIFICATION"] = "OUT_OF_VERIFICATION";
	    OnfidoVerificationStatus["CONSIDER"] = "CONSIDER";
	})(OnfidoVerificationStatus = exports.OnfidoVerificationStatus || (exports.OnfidoVerificationStatus = {}));
	var AriadVerificationStatus;
	(function (AriadVerificationStatus) {
	    AriadVerificationStatus["NONE"] = "NONE";
	    AriadVerificationStatus["OBSOLETE"] = "OBSOLETE";
	    AriadVerificationStatus["WARN"] = "WARN";
	    AriadVerificationStatus["ERROR"] = "ERROR";
	    AriadVerificationStatus["OK"] = "OK";
	    AriadVerificationStatus["OUT_OF_VERIFICATION"] = "OUT_OF_VERIFICATION";
	})(AriadVerificationStatus = exports.AriadVerificationStatus || (exports.AriadVerificationStatus = {}));


/***/ }),
/* 1155 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var MailingStatus;
	(function (MailingStatus) {
	    MailingStatus["NOT_SEND"] = "NONE";
	    MailingStatus["SENDING"] = "SENDING";
	    MailingStatus["SUCCESS"] = "SUCCESS";
	    MailingStatus["FAILURE"] = "FAILURE";
	    MailingStatus["DISABLE"] = "DISABLE";
	})(MailingStatus = exports.MailingStatus || (exports.MailingStatus = {}));
	var EmailTypes;
	(function (EmailTypes) {
	    EmailTypes["UNKNOWN"] = "UNKNOWN";
	    EmailTypes["REGISTRATION_LINK"] = "REGISTRATION_LINK";
	    EmailTypes["CONFIRMATION_CODE"] = "CONFIRMATION_CODE";
	    EmailTypes["RESET_PASSWORD_LINK"] = "RESET_PASSWORD_LINK";
	})(EmailTypes = exports.EmailTypes || (exports.EmailTypes = {}));
	var MailingConfig = (function () {
	    function MailingConfig() {
	    }
	    return MailingConfig;
	}());
	exports.MailingConfig = MailingConfig;
	var MailingRequest = (function () {
	    function MailingRequest(emailType, emailData) {
	        if (emailType === void 0) { emailType = EmailTypes.UNKNOWN; }
	        if (emailData === void 0) { emailData = ''; }
	        this.emailType = emailType;
	        this.emailData = emailData;
	    }
	    return MailingRequest;
	}());
	exports.MailingRequest = MailingRequest;
	var MailingResponse = (function () {
	    function MailingResponse() {
	    }
	    return MailingResponse;
	}());
	exports.MailingResponse = MailingResponse;


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var entity_1 = __webpack_require__(1150);
	var constants_1 = __webpack_require__(861);
	var navigation_1 = __webpack_require__(1157);
	var CardBoxPrivateContentComponent = (function () {
	    function CardBoxPrivateContentComponent(_navigation) {
	        this._navigation = _navigation;
	        this.STATE = constants_1.PROFILE_STATE;
	    }
	    CardBoxPrivateContentComponent.prototype.openTariffDetailView = function (id) {
	        this._navigation.configuration.tariff.detail(id);
	    };
	    __decorate([
	        core_1.Input('customer'),
	        __metadata("design:type", entity_1.CustomerProfile)
	    ], CardBoxPrivateContentComponent.prototype, "customer", void 0);
	    CardBoxPrivateContentComponent = __decorate([
	        core_1.Component({
	            selector: 'tfb-bo-card-box-private-content',
	            template: "\n        <!-- First column -->\n        <div class=\"col-sm-4\">\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.NAME\">{{ customer.name }}</tfl-bo-data-item>\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.ADDRESS\">{{ customer.address }}</tfl-bo-data-item>\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.OPENING_DATE\">{{ customer.opening_date }}</tfl-bo-data-item>\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.APPROVING_DATE\">{{ customer.approvingDate }}</tfl-bo-data-item>\n        </div>\n\n        <!-- Second column -->\n        <div class=\"col-sm-4\">\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.PRIVATE_EMAIL\">{{ customer.email }}</tfl-bo-data-item>\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.PRIVATE_PHONE\">{{ customer.phone }}</tfl-bo-data-item>\n        </div>\n\n        <!-- Third column -->\n        <div *ngIf=\"customer.state == STATE.ACTIVE || customer.state == STATE.PENDING\" class=\"col-sm-4\">\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.TARIFF\">\n                <a (click)=\"openTariffDetailView(customer.tariff.id)\">{{ customer.tariff.name }}</a>\n            </tfl-bo-data-item>\n\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.MIN_TOTAL_ASSET\">{{ customer.min_total_asset | money }}</tfl-bo-data-item>\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.INTRODUCER\">{{ customer.actualIntroducer.name}}</tfl-bo-data-item>\n        </div>\n\n        <div *ngIf=\"customer.state == STATE.NEW\" class=\"col-sm-4\">\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.INTRODUCER_FROM_APPLICATION\">{{ customer.applicationIntroducer}}</tfl-bo-data-item>\n            <tfl-bo-data-item *ngIf=\"!customer.actualIntroducer.isSystem\" label=\"CUSTOMER.TABLE.INTRODUCER\">{{ customer.actualIntroducer.name}}</tfl-bo-data-item>\n        </div>\n    "
	        }),
	        __metadata("design:paramtypes", [navigation_1.NavigationService])
	    ], CardBoxPrivateContentComponent);
	    return CardBoxPrivateContentComponent;
	}());
	exports.CardBoxPrivateContentComponent = CardBoxPrivateContentComponent;


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1158));
	var navigation_service_1 = __webpack_require__(1158);
	exports.NAVIGATION_SERVICES = [
	    navigation_service_1.NavigationService
	];


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var router_1 = __webpack_require__(270);
	var NavigationService = (function () {
	    function NavigationService(router) {
	        this.customers = {
	            profiles: {
	                registered: {
	                    list: function () { return router.navigate(['space', 'customers', 'profiles', 'registered']); },
	                    detail: function (id) { return router.navigate(['space', 'customers', 'profiles', 'registered', id]); },
	                    newAccount: function (id) { return router.navigate(['space', 'customers', 'profiles', 'registered', id, 'account', 'new']); },
	                    settings: function (id, tab) { return router.navigate(['space', 'customers', 'profiles', 'registered', id, tab]); },
	                    verification: function (id, tab) { return router.navigate(['space', 'customers', 'profiles', 'registered', id, 'verification', tab]); },
	                    advancedSettings: function (id, tab) { return router.navigate(['space', 'customers', 'profiles', 'registered', id, 'settings', tab]); }
	                },
	                pending: {
	                    list: function () { return router.navigate(['space', 'customers', 'profiles', 'pending']); },
	                    detail: function (id) { return router.navigate(['space', 'customers', 'profiles', 'pending', id]); },
	                    details: function (id, tab) { return router.navigate(['space', 'customers', 'profiles', 'pending', id, tab]); },
	                    newAccount: function (id) { return router.navigate(['space', 'customers', 'profiles', 'pending', id, 'account', 'new']); },
	                    settings: function (id, tab) { return router.navigate(['space', 'customers', 'profiles', 'pending', id, tab]); },
	                    advancedSettings: function (id, tab) { return router.navigate(['space', 'customers', 'profiles', 'pending', id, 'settings', tab]); },
	                    verification: function (id, tab) { return router.navigate(['space', 'customers', 'profiles', 'pending', id, 'verification', tab]); }
	                }
	            }
	        };
	        this.applications = {
	            profiles: {
	                new: {
	                    detail: function (id) { return router.navigate(['space', 'applications', 'profiles', 'new', id]); },
	                    settings: function (id, tab) { return router.navigate(['space', 'applications', 'profiles', 'new', id, tab]); },
	                    verification: function (id, tab) { return router.navigate(['space', 'applications', 'profiles', 'new', id, 'verification', tab]); },
	                    list: function () {
	                        router.navigate(['space', 'applications', 'profiles', 'new']);
	                    },
	                    process: {
	                        form: function (id) { return router.navigate(['space', 'applications', 'profiles', 'new', 'approve', id]); },
	                        success: function (link, code) { return router.navigate(['space', 'applications', 'profiles', 'approve', 'success', link, code]); },
	                    },
	                    decline: function (id) { return router.navigate(['space', 'applications', 'profiles', 'new', 'suspend', id]); }
	                },
	                declined: {
	                    detail: function (id) { return router.navigate(['space', 'applications', 'profiles', 'declined', id]); },
	                    settings: function (id, tab) { return router.navigate(['space', 'applications', 'profiles', 'declined', id, tab]); },
	                    verification: function (id, tab) { return router.navigate(['space', 'applications', 'profiles', 'declined', id, 'verification', tab]); },
	                    list: function () {
	                        router.navigate(['space', 'applications', 'profiles', 'declined']);
	                    },
	                    approve: {
	                        form: function (id) { return router.navigate(['space', 'applications', 'profiles', 'declined', 'approve', id]); },
	                        success: function (link, code) { return router.navigate(['space', 'applications', 'profiles', 'approve', 'success', link, code]); },
	                    },
	                    suspend: function (id) { return router.navigate(['space', 'applications', 'profiles', 'declined', 'suspend', id]); }
	                },
	                processing: {
	                    detail: function (id) { return router.navigate(['space', 'applications', 'profiles', 'processing', id]); },
	                    settings: function (id, tab) { return router.navigate(['space', 'applications', 'profiles', 'processing', id, tab]); },
	                    verification: function (id, tab) { return router.navigate(['space', 'applications', 'profiles', 'processing', id, 'verification', tab]); },
	                    list: function () {
	                        router.navigate(['space', 'applications', 'profiles', 'processing']);
	                    },
	                    approve: {
	                        form: function (id) { return router.navigate(['space', 'applications', 'profiles', 'processing', 'approve', id]); },
	                        success: function (link, code) { return router.navigate(['space', 'applications', 'profiles', 'approve', 'success', link, code]); },
	                    },
	                    decline: function (id) { return router.navigate(['space', 'applications', 'profiles', 'processing', 'suspend', id]); }
	                },
	                onhold: {
	                    detail: function (id) { return router.navigate(['space', 'applications', 'profiles', 'onhold', id]); },
	                    settings: function (id, tab) { return router.navigate(['space', 'applications', 'profiles', 'onhold', id, tab]); },
	                    verification: function (id, tab) { return router.navigate(['space', 'applications', 'profiles', 'onhold', id, 'verification', tab]); },
	                    list: function () {
	                        router.navigate(['space', 'applications', 'profiles', 'onhold']);
	                    },
	                },
	                archived: {
	                    detail: function (id) { return router.navigate(['space', 'applications', 'profiles', 'archived', id]); },
	                    settings: function (id, tab) { return router.navigate(['space', 'applications', 'profiles', 'archived', id, tab]); },
	                    verification: function (id, tab) { return router.navigate(['space', 'applications', 'profiles', 'archived', id, 'verification', tab]); },
	                    list: function () {
	                        router.navigate(['space', 'applications', 'profiles', 'archived']);
	                    },
	                },
	                manualreview: {
	                    detail: function (id) { return router.navigate(['space', 'applications', 'profiles', 'manualreview', id]); },
	                    settings: function (id, tab) { return router.navigate(['space', 'applications', 'profiles', 'manualreview', id, tab]); },
	                    verification: function (id, tab) { return router.navigate(['space', 'applications', 'profiles', 'manualreview', id, 'verification', tab]); },
	                    list: function () {
	                        router.navigate(['space', 'applications', 'profiles', 'manualreview']);
	                    },
	                }
	            }
	        };
	        this.transactions = {
	            history: {
	                detail: function (id) { return router.navigate(['space', 'history', 'transfers', 'details', id]); }
	            },
	            openbanking: {
	                clients: {
	                    detail: function (id) { return router.navigate(['space', 'open-banking', 'clients', 'details', id]); },
	                    newClient: function () { return router.navigate(['space', 'open-banking', 'clients']); },
	                    updateClient: function (id) { return router.navigate(['space', 'open-banking', 'clients', 'update', id]); },
	                    clientPayments: function (id) { return router.navigate(['space', 'open-banking', 'clients', 'payments', id]); }
	                },
	                payments: {
	                    detail: function (id) { return router.navigate(['space', 'open-banking', 'payments', 'details', id]); },
	                    newPayment: function () { return router.navigate(['space', 'open-banking', 'payments']); },
	                    updatePayment: function (id) { return router.navigate(['space', 'open-banking', 'payments', 'update', id]); }
	                }
	            }
	        };
	        this.configuration = {
	            tariff: {
	                list: function () { return router.navigate(['space', 'configuration', 'tariffs']); },
	                detail: function (id) { return router.navigate(['space', 'configuration', 'tariffs', id]); },
	                newTariff: function () { return router.navigate(['space', 'configuration', 'tariffs']); },
	                updateTariff: function (id) { return router.navigate(['space', 'configuration', 'tariffs', 'update', id]); },
	            }
	        };
	    }
	    NavigationService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [router_1.Router])
	    ], NavigationService);
	    return NavigationService;
	}());
	exports.NavigationService = NavigationService;


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var entity_1 = __webpack_require__(1150);
	var constants_1 = __webpack_require__(861);
	var navigation_1 = __webpack_require__(1157);
	var CardBoxCorporateContentComponent = (function () {
	    function CardBoxCorporateContentComponent(_navigation) {
	        this._navigation = _navigation;
	        this.STATE = constants_1.PROFILE_STATE;
	    }
	    CardBoxCorporateContentComponent.prototype.openTariffDetailView = function (id) {
	        this._navigation.configuration.tariff.detail(id);
	    };
	    __decorate([
	        core_1.Input('customer'),
	        __metadata("design:type", entity_1.CustomerProfile)
	    ], CardBoxCorporateContentComponent.prototype, "customer", void 0);
	    CardBoxCorporateContentComponent = __decorate([
	        core_1.Component({
	            selector: 'tfb-bo-card-box-corporate-content',
	            template: "\n        <div class=\"col-sm-4\">\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.NAME\">{{ customer.name }}</tfl-bo-data-item>\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.ADDRESS\">{{ customer.address }}</tfl-bo-data-item>\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.OPENING_DATE\">{{ customer.opening_date }}</tfl-bo-data-item>\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.APPROVING_DATE\">{{ customer.approvingDate }}</tfl-bo-data-item>\n        </div>\n\n        <!-- Second column -->\n        <div class=\"col-sm-4\">\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.SIGNATORY\">{{ customer.authorized_user_name }}</tfl-bo-data-item>\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.EMAIL\">{{ customer.email }}</tfl-bo-data-item>\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.PHONE\">{{ customer.phone }}</tfl-bo-data-item>\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.USER_EMAIL\">{{ customer.userEmail }}</tfl-bo-data-item>\n        </div>\n\n        <!-- Third column -->\n        <div *ngIf=\"customer.state == STATE.ACTIVE || customer.state == STATE.PENDING\" class=\"col-sm-4\">\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.TARIFF\">\n                <a (click)=\"openTariffDetailView(customer.tariff.id)\">{{ customer.tariff.name  }}</a>\n            </tfl-bo-data-item>\n\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.MIN_TOTAL_ASSET\">{{ customer.min_total_asset | money }}</tfl-bo-data-item>\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.INTRODUCER\">{{ customer.actualIntroducer.name}}</tfl-bo-data-item>\n        </div>\n\n        <div *ngIf=\"customer.state == STATE.NEW\" class=\"col-sm-4\">\n            <tfl-bo-data-item label=\"CUSTOMER.TABLE.INTRODUCER_FROM_APPLICATION\">{{ customer.applicationIntroducer}}</tfl-bo-data-item>\n            <tfl-bo-data-item *ngIf=\"!customer.actualIntroducer.isSystem\" label=\"CUSTOMER.TABLE.INTRODUCER\">{{ customer.actualIntroducer.name}}</tfl-bo-data-item>\n        </div>\n    "
	        }),
	        __metadata("design:paramtypes", [navigation_1.NavigationService])
	    ], CardBoxCorporateContentComponent);
	    return CardBoxCorporateContentComponent;
	}());
	exports.CardBoxCorporateContentComponent = CardBoxCorporateContentComponent;


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var combo_search_component_1 = __webpack_require__(1161);
	exports.COMBO_SEARCH_COMPONENT = [
	    combo_search_component_1.ComboSearchComponent
	];


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var KEY = {
	    BACK_SPACE: 8,
	    RETURN: 13,
	    LEFT: 37,
	    UP: 38,
	    RIGHT: 39,
	    DOWN: 40
	};
	exports.CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR = {
	    provide: forms_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return ComboSearchComponent; }),
	    multi: true
	};
	var ComboSearchComponent = (function () {
	    function ComboSearchComponent() {
	        this.selected = undefined;
	        this.searchTimeout = 350;
	        this.maxSearchLength = 100;
	        this.value = "";
	        this.nameDescription = 'name';
	        this.isFirstLetter = false;
	        this.onChange = new core_1.EventEmitter();
	        this.onTouchedCallback = new core_1.EventEmitter();
	        this.searchText = new core_1.EventEmitter();
	        this.hasFocus = false;
	        this.lockFocus = true;
	        this.searched = false;
	        this.toutHiddenTimeout = 200;
	    }
	    ComboSearchComponent.prototype.manageList = function (event) {
	        var key = (event.keyCode || event.which), keys = [KEY.RETURN, KEY.UP, KEY.DOWN];
	        if (this.isOneKeyOf(keys, key)) {
	            event.preventDefault();
	        }
	        if (key == KEY.RETURN) {
	            this.onSelect(this.selected);
	        }
	        var index = this.items.indexOf(this.selected);
	        if (key == KEY.UP && index - 1 >= 0) {
	            this.onSelect(this.items[--index], false);
	        }
	        else if (key == KEY.DOWN && index < this.items.length - 1) {
	            this.onSelect(this.items[++index], false);
	        }
	        if (key == KEY.UP) {
	            this.scrollTop();
	        }
	        else if (key == KEY.DOWN) {
	            this.scrollDown();
	        }
	    };
	    ComboSearchComponent.prototype.showList = function () {
	        var _this = this;
	        clearTimeout(this.toutHiddenList);
	        this.hasFocus = true;
	        this.lockFocus = false;
	        setTimeout(function () {
	            if (_this.items.indexOf(_this.selected) > -1) {
	                _this.scrollTop();
	            }
	        });
	    };
	    ComboSearchComponent.prototype.hideList = function (instantly) {
	        var _this = this;
	        if (instantly === void 0) { instantly = false; }
	        clearTimeout(this.toutHiddenList);
	        if (instantly) {
	            this.hasFocus = false;
	            this.lockFocus = false;
	        }
	        else {
	            var hideInstantly = function () { return _this.hideList(true); };
	            this.toutHiddenList = setTimeout(hideInstantly, this.toutHiddenTimeout);
	        }
	    };
	    ComboSearchComponent.prototype.search = function (text, event) {
	        var _this = this;
	        var keyCode = event.keyCode || event.which;
	        if (keyCode == KEY.RETURN) {
	            event.preventDefault();
	        }
	        else {
	            clearTimeout(this.tout);
	            this.onChange.emit(undefined);
	            if ((keyCode > 46 && keyCode < 112) || keyCode == KEY.BACK_SPACE) {
	                this.tout = setTimeout(function () {
	                    _this.searchText.emit(text);
	                    _this.searched = true;
	                }, this.searchTimeout);
	            }
	        }
	    };
	    ComboSearchComponent.prototype.onSelect = function (item, autoFire) {
	        if (autoFire === void 0) { autoFire = true; }
	        if (item == null)
	            return;
	        this.selected = item;
	        this.onChange.emit(item);
	        if (this.searchInput) {
	            this.searchInput.nativeElement.value = item[this.nameDescription] || '';
	        }
	        if (autoFire) {
	            this.hideList(true);
	            if (this.searchInput) {
	                this.searchInput.nativeElement.blur();
	            }
	        }
	    };
	    ComboSearchComponent.prototype.writeValue = function (item) {
	        this.selected = item;
	        if (!!this.searchInput && !!item) {
	            this.searchInput.nativeElement.value = item[this.nameDescription] || '';
	        }
	    };
	    ComboSearchComponent.prototype.registerOnChange = function (fn) {
	        this.onChange.subscribe(fn);
	    };
	    ComboSearchComponent.prototype.registerOnTouched = function (fn) {
	        this.onTouchedCallback.subscribe(fn);
	    };
	    ComboSearchComponent.prototype.setDisabledState = function (isDisabled) {
	        this.disabled = isDisabled;
	    };
	    ComboSearchComponent.prototype.scrollTop = function () {
	        var index = this.items.indexOf(this.selected);
	        if (this.listOption && this.listOption.nativeElement.children[index]) {
	            this.listOption.nativeElement.scrollTop = this.listOption.nativeElement.offsetTop;
	        }
	    };
	    ComboSearchComponent.prototype.scrollDown = function () {
	        var index = this.items.indexOf(this.selected);
	        if (this.listOption && this.listOption.nativeElement.children[index]) {
	            var _a = this.listOption.nativeElement.children[index], offsetTop = _a.offsetTop, offsetHeight = _a.offsetHeight;
	            this.listOption.nativeElement.scrollTop = offsetTop + offsetHeight - this.listOption.nativeElement.offsetHeight;
	        }
	    };
	    ComboSearchComponent.prototype.isOneKeyOf = function (keys, code) {
	        if (keys === void 0) { keys = []; }
	        return !!keys.filter(function (x) { return x == code; }).length;
	    };
	    ComboSearchComponent.prototype.getType = function () {
	        return this.isFirstLetter ? 'first-letter' : 'text';
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], ComboSearchComponent.prototype, "id", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], ComboSearchComponent.prototype, "items", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], ComboSearchComponent.prototype, "name", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], ComboSearchComponent.prototype, "disabled", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], ComboSearchComponent.prototype, "searchTimeout", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], ComboSearchComponent.prototype, "maxSearchLength", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], ComboSearchComponent.prototype, "placeHolder", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], ComboSearchComponent.prototype, "value", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], ComboSearchComponent.prototype, "emptySearchResultText", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], ComboSearchComponent.prototype, "nameDescription", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], ComboSearchComponent.prototype, "isFirstLetter", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], ComboSearchComponent.prototype, "searchText", void 0);
	    __decorate([
	        core_1.ViewChild('searchInput'),
	        __metadata("design:type", core_1.ElementRef)
	    ], ComboSearchComponent.prototype, "searchInput", void 0);
	    __decorate([
	        core_1.ViewChild('listOption'),
	        __metadata("design:type", core_1.ElementRef)
	    ], ComboSearchComponent.prototype, "listOption", void 0);
	    ComboSearchComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-combo-search',
	            template: __webpack_require__(1162),
	            providers: [exports.CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
	        })
	    ], ComboSearchComponent);
	    return ComboSearchComponent;
	}());
	exports.ComboSearchComponent = ComboSearchComponent;


/***/ }),
/* 1162 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"tfl-combo-search\">\n    <div class=\"combo-search\">\n        <input [id]=\"id\"\n               [type]=\"getType()\"\n               [name]=\"name\"\n               class=\"form-control\"\n               [maxLength]=\"maxSearchLength\"\n               placeholder=\"{{ placeHolder }}\"\n               [disabled]=\"disabled\"\n               [(ngModel)]=\"modelValue\"\n               [value]=\"value\"\n               #searchInput (focus)=\"showList()\" (blur)=\"hideList()\"\n               (keydown)=\"manageList($event)\"\n               (keyup)=\"search(searchInput.value, $event)\">\n\n        <div *ngIf=\"hasFocus\" class=\"list-dropdown\">\n            <ul *ngIf=\"items && items.length > 0\" #listOption>\n                <li (click)=\"onSelect(item);\" *ngFor=\"let item of items\" [ngClass]=\"{active: item == selected}\">\n                    <div>{{ item[nameDescription] }}</div>\n                </li>\n            </ul>\n\n            <div *ngIf=\"searched && (!items || items.length == 0) && (searchInput.value && searchInput.value.length > 0)\"\n                 class=\"combo-search-empty-search\"\n                 (mouseover)=\"lockFocus = true\" (mouseout)=\"lockFocus = false\">\n                {{ emptySearchResultText }}\n            </div>\n        </div>\n    </div>\n\n    <i class=\"glyphicon glyphicon-search\"></i>\n</div>"

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var data_item_component_1 = __webpack_require__(1164);
	exports.DATA_ITEM_COMPONENTS = [
	    data_item_component_1.DataItemComponent
	];


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var DataItemComponent = (function () {
	    function DataItemComponent() {
	    }
	    __decorate([
	        core_1.Input('label'),
	        __metadata("design:type", String)
	    ], DataItemComponent.prototype, "label", void 0);
	    DataItemComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-data-item',
	            template: "\n        <div class=\"data-item\">\n            <span class=\"data-item-label\">{{ label | translate }}: </span>\n            <ng-content></ng-content>\n        </div>\n    "
	        })
	    ], DataItemComponent);
	    return DataItemComponent;
	}());
	exports.DataItemComponent = DataItemComponent;


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var click_outside_directive_1 = __webpack_require__(1166);
	var has_roles_directive_1 = __webpack_require__(1167);
	exports.DIRECTIVES = [
	    click_outside_directive_1.ClickOutsideDirective,
	    has_roles_directive_1.HasRolesDirective
	];


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var ClickOutsideDirective = (function () {
	    function ClickOutsideDirective(_elementRef) {
	        this._elementRef = _elementRef;
	        this.clickOutside = new core_1.EventEmitter();
	    }
	    ClickOutsideDirective.prototype.ngOnInit = function () {
	        var _this = this;
	        setTimeout(function () {
	            document.addEventListener('click', _this.onClick.bind(_this));
	        }, 300);
	    };
	    ClickOutsideDirective.prototype.ngOnDestroy = function () {
	        document.removeEventListener('click', this.onClick);
	    };
	    ClickOutsideDirective.prototype.onClick = function (event) {
	        var targetElement = event.target;
	        if (!targetElement) {
	            return;
	        }
	        var clickedInside = this._elementRef.nativeElement.contains(targetElement);
	        if (!clickedInside) {
	            this.clickOutside.emit(event);
	        }
	    };
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", Object)
	    ], ClickOutsideDirective.prototype, "clickOutside", void 0);
	    ClickOutsideDirective = __decorate([
	        core_1.Directive({
	            selector: '[clickOutside]'
	        }),
	        __metadata("design:paramtypes", [core_1.ElementRef])
	    ], ClickOutsideDirective);
	    return ClickOutsideDirective;
	}());
	exports.ClickOutsideDirective = ClickOutsideDirective;


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var util_1 = __webpack_require__(743);
	var security_1 = __webpack_require__(736);
	var HasRolesDirective = (function () {
	    function HasRolesDirective(templateRef, el, viewContainerRef, roleService) {
	        this.templateRef = templateRef;
	        this.el = el;
	        this.viewContainerRef = viewContainerRef;
	        this.roleService = roleService;
	        this.elementTypes = ['input', 'select', 'button', 'a'];
	    }
	    Object.defineProperty(HasRolesDirective.prototype, "ifHasRoles", {
	        set: function (roles) {
	            this.roles = roles;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HasRolesDirective.prototype, "ifHasRolesHide", {
	        set: function (hide) {
	            this.hide = hide;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(HasRolesDirective.prototype, "ifHasRolesRoute", {
	        /** Optional menu route to check exactly (see RoleService.hasExactRouteRoles) instead of the current URL. */
	        set: function (route) {
	            this.route = route;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    HasRolesDirective.prototype.ngOnDestroy = function () {
	    };
	    HasRolesDirective.prototype.ngOnInit = function () {
	        this.checkPermissions();
	    };
	    HasRolesDirective.prototype.checkPermissions = function () {
	        var allowed = util_1.isNullOrUndefined(this.route)
	            ? this.roleService.hasRoles(this.roles)
	            : this.roleService.hasExactRouteRoles(this.roles, this.route);
	        if (!allowed) {
	            this.hideOrDisabled();
	        }
	        else {
	            this.viewContainerRef.createEmbeddedView(this.templateRef);
	        }
	    };
	    HasRolesDirective.prototype.hideOrDisabled = function () {
	        if (this.hide) {
	            this.hideElements();
	        }
	        else {
	            this.disabledElements();
	        }
	    };
	    HasRolesDirective.prototype.disabledElements = function () {
	        this.viewContainerRef.createEmbeddedView(this.templateRef);
	        if (!!this.el.nativeElement.nextSibling) {
	            this.el.nativeElement.nextSibling.setAttribute('disabled', true);
	            var nodes = this.el.nativeElement.nextSibling.querySelectorAll(this.elementTypes.join(','));
	            if (!util_1.isNullOrUndefined(nodes) && nodes.length > 0) {
	                nodes.forEach(function (node) {
	                    node.setAttribute('disabled', true);
	                });
	            }
	        }
	    };
	    HasRolesDirective.prototype.hideElements = function () {
	        this.viewContainerRef.clear();
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [Object])
	    ], HasRolesDirective.prototype, "ifHasRoles", null);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean),
	        __metadata("design:paramtypes", [Boolean])
	    ], HasRolesDirective.prototype, "ifHasRolesHide", null);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String),
	        __metadata("design:paramtypes", [String])
	    ], HasRolesDirective.prototype, "ifHasRolesRoute", null);
	    HasRolesDirective = __decorate([
	        core_1.Directive({
	            selector: '[ifHasRoles]',
	            providers: [security_1.RoleService]
	        }),
	        __metadata("design:paramtypes", [core_1.TemplateRef,
	            core_1.ElementRef,
	            core_1.ViewContainerRef,
	            security_1.RoleService])
	    ], HasRolesDirective);
	    return HasRolesDirective;
	}());
	exports.HasRolesDirective = HasRolesDirective;


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var draggable_directive_1 = __webpack_require__(1169);
	var drop_zone_directive_1 = __webpack_require__(1170);
	exports.DRAG_AND_DROP_COMPONENTS = [
	    draggable_directive_1.DraggableDirective,
	    drop_zone_directive_1.DropZoneDirective
	];


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var DEFAULT_ZONE_NAME = 'default';
	var DRAG_DATA_TYPE = 'application/tfl-drop-data';
	var DraggableDirective = (function () {
	    function DraggableDirective() {
	    }
	    Object.defineProperty(DraggableDirective.prototype, "draggable", {
	        get: function () {
	            return true;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DraggableDirective.prototype, "tflDraggable", {
	        set: function (options) {
	            if (options) {
	                this.options = options;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DraggableDirective.prototype.onDragStart = function (event) {
	        var data = {
	            data: this.options.data,
	            zone: this.options.targetZone || DEFAULT_ZONE_NAME
	        };
	        event.dataTransfer.setData(DRAG_DATA_TYPE, JSON.stringify(data));
	    };
	    __decorate([
	        core_1.HostBinding('draggable'),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [])
	    ], DraggableDirective.prototype, "draggable", null);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [Object])
	    ], DraggableDirective.prototype, "tflDraggable", null);
	    __decorate([
	        core_1.HostListener('dragstart', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], DraggableDirective.prototype, "onDragStart", null);
	    DraggableDirective = __decorate([
	        core_1.Directive({
	            selector: '[tflDraggable]'
	        })
	    ], DraggableDirective);
	    return DraggableDirective;
	}());
	exports.DraggableDirective = DraggableDirective;


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var util_1 = __webpack_require__(743);
	var DEFAULT_ZONE_NAME = 'default';
	var DRAG_DATA_TYPE = 'application/tfl-drop-data';
	var DropZoneDirective = (function () {
	    function DropZoneDirective() {
	        this.drop = new core_1.EventEmitter();
	    }
	    Object.defineProperty(DropZoneDirective.prototype, "tflDropZone", {
	        set: function (options) {
	            if (!util_1.isNullOrUndefined(options)) {
	                this._name = options.name || DEFAULT_ZONE_NAME;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DropZoneDirective.prototype.onDragOver = function (event) {
	        event.preventDefault();
	    };
	    DropZoneDirective.prototype.onDrop = function (event) {
	        event.preventDefault();
	        if (this.eventHasDropData(event)) {
	            var data = event.dataTransfer.getData(DRAG_DATA_TYPE); //may not work in IE because it does not support custom data types
	            this.drop.next(JSON.parse(data).data);
	        }
	    };
	    DropZoneDirective.prototype.eventHasDropData = function (event) {
	        var data = event.dataTransfer.getData(DRAG_DATA_TYPE);
	        return (!util_1.isNullOrUndefined(data) && data.length > 0) && this.hasValidDestination(data);
	    };
	    DropZoneDirective.prototype.hasValidDestination = function (data) {
	        var zone = JSON.parse(data).zone;
	        return zone === this._name;
	    };
	    __decorate([
	        core_1.Output('tflDrop'),
	        __metadata("design:type", Object)
	    ], DropZoneDirective.prototype, "drop", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [Object])
	    ], DropZoneDirective.prototype, "tflDropZone", null);
	    __decorate([
	        core_1.HostListener('dragover', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], DropZoneDirective.prototype, "onDragOver", null);
	    __decorate([
	        core_1.HostListener('drop', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], DropZoneDirective.prototype, "onDrop", null);
	    DropZoneDirective = __decorate([
	        core_1.Directive({
	            selector: '[tflDropZone]'
	        })
	    ], DropZoneDirective);
	    return DropZoneDirective;
	}());
	exports.DropZoneDirective = DropZoneDirective;


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var dropdown_component_1 = __webpack_require__(1172);
	exports.DROPDOWN_COMPONENTS = [
	    dropdown_component_1.DropdownComponent
	];


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var util_1 = __webpack_require__(743);
	var DropdownComponent = (function () {
	    function DropdownComponent(el) {
	        this.el = el;
	        this.items = [];
	        this.itemSelected = new core_1.EventEmitter();
	        this.isOpenDropdown = false;
	    }
	    DropdownComponent.prototype.onDocumentClick = function (targetEl) {
	        if (this.isOpenDropdown && this.el) {
	            if (!this.el.nativeElement.contains(targetEl)) {
	                this.toggleDropdownVisibility();
	            }
	        }
	    };
	    Object.defineProperty(DropdownComponent.prototype, "hasAtLeastOneEnabledItem", {
	        get: function () {
	            if (this.items) {
	                for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
	                    var it_1 = _a[_i];
	                    if (!it_1.disabled) {
	                        return true;
	                    }
	                }
	            }
	            return false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DropdownComponent.prototype.processListItemClick = function (it) {
	        // this.customChange.emit();
	        if (it.disabled) {
	            return;
	        }
	        this.toggleDropdownVisibility();
	        this.itemSelected.next(it);
	    };
	    DropdownComponent.prototype.onBtnClick = function () {
	        if (this.hasAtLeastOneEnabledItem) {
	            this.toggleDropdownVisibility();
	        }
	    };
	    DropdownComponent.prototype.toggleDropdownVisibility = function (setVisible) {
	        this.isOpenDropdown = (!util_1.isNullOrUndefined(setVisible)) ? setVisible : !this.isOpenDropdown;
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], DropdownComponent.prototype, "items", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], DropdownComponent.prototype, "title", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", Object)
	    ], DropdownComponent.prototype, "itemSelected", void 0);
	    __decorate([
	        core_1.HostListener('document:click', ['$event.target']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], DropdownComponent.prototype, "onDocumentClick", null);
	    DropdownComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-dropdown',
	            template: __webpack_require__(1173)
	        }),
	        __metadata("design:paramtypes", [core_1.ElementRef])
	    ], DropdownComponent);
	    return DropdownComponent;
	}());
	exports.DropdownComponent = DropdownComponent;


/***/ }),
/* 1173 */
/***/ (function(module, exports) {

	module.exports = "<div [ngClass]=\"{'dropdown': true, 'open': isOpenDropdown}\">\n\n    <a class=\"btn btn-primary dropdown-toggle\"\n        (click)=\"onBtnClick()\"\n       [ngClass]=\"{'disabled': !hasAtLeastOneEnabledItem}\">\n        {{title}}\n        <span class=\"caret\"></span>\n    </a>\n\n    <ul class=\"dropdown-menu\">\n        <li *ngFor=\"let item of items\" (click)=\"processListItemClick(item)\" class=\"unselectable\" [ngClass]=\"{'disabled': item.disabled}\">\n            <a>{{item.name}}</a>\n        </li>\n    </ul>\n\n</div>"

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var filter_container_component_1 = __webpack_require__(1175);
	var filter_input_component_1 = __webpack_require__(1177);
	var search_api_observable_service_1 = __webpack_require__(1176);
	var filter_directive_1 = __webpack_require__(1178);
	var filter_url_based_component_1 = __webpack_require__(1179);
	var filter_callback_based_component_1 = __webpack_require__(1183);
	var filter_field_clear_directive_1 = __webpack_require__(1181);
	var filter_field_input_component_1 = __webpack_require__(1184);
	var filter_field_select_component_1 = __webpack_require__(1186);
	var filter_field_daterangepicker_component_1 = __webpack_require__(1187);
	var filter_field_amount_component_1 = __webpack_require__(1188);
	var amount_range_component_1 = __webpack_require__(1189);
	__export(__webpack_require__(1175));
	exports.FILTER_COMPONENTS = [
	    amount_range_component_1.AmountRangeComponent,
	    filter_field_amount_component_1.FilterFieldAmountComponent,
	    filter_container_component_1.FilterContainerComponent,
	    filter_input_component_1.FilterInputComponent,
	    filter_directive_1.FilterDirective,
	    filter_callback_based_component_1.FilterCallbackBasedComponent,
	    filter_url_based_component_1.FilterUrlBasedComponent,
	    filter_field_clear_directive_1.FilterFieldClearDirective,
	    filter_field_input_component_1.FilterFieldInputComponent,
	    filter_field_select_component_1.FilterFieldSelectComponent,
	    filter_field_daterangepicker_component_1.FilterFieldDaterangepickerComponent,
	];
	exports.FILTER_PROVIDERS = [
	    search_api_observable_service_1.SearchApiObservableService
	];


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var search_api_observable_service_1 = __webpack_require__(1176);
	var FilterContainerComponent = (function () {
	    function FilterContainerComponent(_filteringProvider) {
	        this._filteringProvider = _filteringProvider;
	        this.shouldDisableSearchButton = false;
	        this.shouldDisableResetButton = false;
	        this.onSearch = new core_1.EventEmitter();
	        this.onReset = new core_1.EventEmitter();
	        this.visibilityState = true;
	    }
	    FilterContainerComponent.prototype.changeVisibility = function () {
	        this.visibilityState = !this.visibilityState;
	    };
	    FilterContainerComponent.prototype.search = function () {
	        var _this = this;
	        this._filteringProvider
	            .searchRequestForUrl(this.callUrl, this.filterModel)
	            .subscribe(function (jsonResponse) { return _this.onSearch.emit(jsonResponse); });
	    };
	    FilterContainerComponent.prototype.resetFilter = function () {
	        this.onReset.emit();
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], FilterContainerComponent.prototype, "callUrl", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], FilterContainerComponent.prototype, "filterModel", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], FilterContainerComponent.prototype, "shouldDisableSearchButton", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], FilterContainerComponent.prototype, "shouldDisableResetButton", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], FilterContainerComponent.prototype, "onSearch", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], FilterContainerComponent.prototype, "onReset", void 0);
	    FilterContainerComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-filter-container',
	            template: "\n        <div class=\"filter-container\">\n            <div class=\"row\">\n                <div class=\"col-lg-12\">\n                    <div id=\"show-hide-container\" class=\"pull-right\" (click)=\"changeVisibility()\">\n                        <span *ngIf=\"!visibilityState\">{{ 'FILTER.BUTTON.SHOW' | translate }}</span>\n                        <span *ngIf=\"visibilityState\">{{ 'FILTER.BUTTON.HIDE' | translate }}</span>\n                        <i [ngClass]=\"visibilityState ? 'fa fa-chevron-up' : 'fa fa-chevron-down'\" aria-hidden=\"true\"></i>\n                    </div>\n                    \n                    <form *ngIf=\"visibilityState\" class='filter-form form-horizontal' #f=\"ngForm\" autocomplete=\"off\" novalidate\n                          (ngSubmit)=\"f.valid&&search()\">\n    \n                        <div class=\"row\">\n                            <ng-content select=\"tfl-filter-input\"></ng-content>\n                        </div>\n    \n                        <div class=\"pull-right\">\n                            <div>\n                                <button id=\"search-button\"\n                                        class=\"btn btn-primary\"\n                                        [disabled]=\"shouldDisableSearchButton||!f.valid\">\n                                    {{ 'FILTER.BUTTON.SEARCH' | translate }}\n                                </button>\n                                <button type=\"reset\"\n                                        id=\"reset-button\"\n                                        class=\"btn btn-default\"\n                                        [disabled]=\"shouldDisableResetButton\"\n                                        (click)=\"resetFilter()\">\n                                    {{ 'FILTER.BUTTON.RESET' | translate }}\n                                </button>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    ",
	            styles: ["\n        #search-button, #reset-button {\n            margin: 10px 0 10px 10px;\n            width: 100px;\n        }\n\n        #show-hide-container {\n            cursor: pointer;\n        }\n        \n        .filter-container {\n            margin-bottom: 20px;\n        }\n\n        .filter-form {\n            margin-top: 30px;\n        }\n    "]
	        }),
	        __metadata("design:paramtypes", [search_api_observable_service_1.SearchApiObservableService])
	    ], FilterContainerComponent);
	    return FilterContainerComponent;
	}());
	exports.FilterContainerComponent = FilterContainerComponent;


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var Observable_1 = __webpack_require__(206);
	__webpack_require__(403);
	__webpack_require__(367);
	__webpack_require__(495);
	var SearchApiObservableService = (function () {
	    function SearchApiObservableService(_http) {
	        this._http = _http;
	        this.options = new http_1.RequestOptions();
	    }
	    SearchApiObservableService_1 = SearchApiObservableService;
	    SearchApiObservableService.prototype.searchRequestForUrl = function (url, param) {
	        var params = new http_1.URLSearchParams();
	        for (var key in param) {
	            if (param.hasOwnProperty(key)) {
	                var val = param[key];
	                params.set(key, val);
	            }
	        }
	        this.options = new http_1.RequestOptions({ search: params });
	        return this._http.get(url, this.options).map(SearchApiObservableService_1.extractData).catch(SearchApiObservableService_1.handleError);
	    };
	    SearchApiObservableService.extractData = function (res) {
	        var body = res.json();
	        return body || {};
	    };
	    SearchApiObservableService.handleError = function (error) {
	        var errMsg = (error.message) ? error.message :
	            error.status ? error.status + " - " + error.statusText : 'Server error';
	        return Observable_1.Observable.throw(errMsg);
	    };
	    SearchApiObservableService = SearchApiObservableService_1 = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], SearchApiObservableService);
	    return SearchApiObservableService;
	    var SearchApiObservableService_1;
	}());
	exports.SearchApiObservableService = SearchApiObservableService;


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var FilterInputComponent = (function () {
	    function FilterInputComponent() {
	        this.filterDivClass = 'col-sm-4 col-xs-6';
	    }
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], FilterInputComponent.prototype, "filterDivClass", void 0);
	    FilterInputComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-filter-input',
	            template: "\n        <div [ngClass]=\"filterDivClass\">\n            <ng-content select=\"label\"></ng-content>\n            <ng-content select=\"div\"></ng-content>\n        </div>\n    "
	        })
	    ], FilterInputComponent);
	    return FilterInputComponent;
	}());
	exports.FilterInputComponent = FilterInputComponent;


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var FilterDirective = (function () {
	    function FilterDirective() {
	        this.columns = 3;
	        this.verticalAlignment = false;
	    }
	    __decorate([
	        core_1.Input('columns'),
	        __metadata("design:type", Number)
	    ], FilterDirective.prototype, "columns", void 0);
	    __decorate([
	        core_1.Input('verticalAlignment'),
	        __metadata("design:type", Boolean)
	    ], FilterDirective.prototype, "verticalAlignment", void 0);
	    FilterDirective = __decorate([
	        core_1.Directive({
	            selector: 'tfl-url-based-filter,tfl-callback-based-filter'
	        })
	    ], FilterDirective);
	    return FilterDirective;
	}());
	exports.FilterDirective = FilterDirective;


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var forms_1 = __webpack_require__(768);
	var router_1 = __webpack_require__(270);
	var core_1 = __webpack_require__(205);
	var abstract_filter_component_1 = __webpack_require__(1180);
	var filter_field_clear_directive_1 = __webpack_require__(1181);
	var utils_1 = __webpack_require__(740);
	var util_1 = __webpack_require__(743);
	var FilterUrlBasedComponent = (function (_super) {
	    __extends(FilterUrlBasedComponent, _super);
	    function FilterUrlBasedComponent(_router, _activatedRoute) {
	        var _this = _super.call(this) || this;
	        _this._router = _router;
	        _this._activatedRoute = _activatedRoute;
	        _this.columns = 3;
	        _this.verticalAlignment = false;
	        _this.onSearch = new core_1.EventEmitter();
	        return _this;
	    }
	    FilterUrlBasedComponent.prototype.ngAfterContentInit = function () {
	        var _this = this;
	        this._activatedRoute.queryParams.subscribe(function (params) {
	            var search = {};
	            if (!!params.search) {
	                try {
	                    search = JSON.parse(params.search);
	                }
	                catch (e) {
	                    // Catch any parse error
	                    search = {};
	                    console.error(e);
	                }
	            }
	            if (!util_1.isNullOrUndefined(_this.filterFieldComponents)) {
	                _this.filterFieldComponents.forEach(function (field) {
	                    if (!util_1.isNullOrUndefined(search[field.controlName])) {
	                        _this.form.controls[field.controlName].setValue(search[field.controlName]);
	                        utils_1.FormUtils.updateValidity(_this.form, field.controlName);
	                    }
	                });
	            }
	            setTimeout(function () {
	                if (utils_1.FormUtils.isValid(_this.form)) {
	                    _this.onSearch.emit(_this.form.value);
	                }
	            });
	        });
	    };
	    FilterUrlBasedComponent.prototype.submit = function (event, form) {
	        if (utils_1.FormUtils.isValid(form)) {
	            this._router.navigate([], {
	                queryParams: { search: JSON.stringify(form.value) },
	                relativeTo: this._activatedRoute
	            });
	        }
	    };
	    FilterUrlBasedComponent.prototype.reset = function () {
	        var defValues = this.resetFieldsAndReturnDef();
	        this._router.navigate([], {
	            queryParams: { search: JSON.stringify(defValues) },
	            relativeTo: this._activatedRoute
	        });
	    };
	    FilterUrlBasedComponent.prototype.resetFieldsAndReturnDef = function () {
	        var defValues = {};
	        if (!util_1.isNullOrUndefined(this.filterFieldComponents)) {
	            this.filterFieldComponents.forEach(function (field) {
	                defValues = __assign({}, defValues, (_a = {}, _a[field.controlName] = field.defValue, _a));
	                field.reset();
	                var _a;
	            });
	        }
	        return defValues;
	    };
	    __decorate([
	        core_1.Input('form'),
	        __metadata("design:type", forms_1.FormGroup)
	    ], FilterUrlBasedComponent.prototype, "form", void 0);
	    __decorate([
	        core_1.Input('columns'),
	        __metadata("design:type", Number)
	    ], FilterUrlBasedComponent.prototype, "columns", void 0);
	    __decorate([
	        core_1.Input('verticalAlignment'),
	        __metadata("design:type", Boolean)
	    ], FilterUrlBasedComponent.prototype, "verticalAlignment", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], FilterUrlBasedComponent.prototype, "onSearch", void 0);
	    __decorate([
	        core_1.ContentChildren(filter_field_clear_directive_1.FilterFieldClearDirective),
	        __metadata("design:type", core_1.QueryList)
	    ], FilterUrlBasedComponent.prototype, "filterFieldComponents", void 0);
	    FilterUrlBasedComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-url-based-filter',
	            template: __webpack_require__(1182)
	        }),
	        __metadata("design:paramtypes", [router_1.Router,
	            router_1.ActivatedRoute])
	    ], FilterUrlBasedComponent);
	    return FilterUrlBasedComponent;
	}(abstract_filter_component_1.AbstractFilterComponent));
	exports.FilterUrlBasedComponent = FilterUrlBasedComponent;


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var AbstractFilterComponent = (function () {
	    function AbstractFilterComponent() {
	        this.visible = true;
	        this.columns = 3;
	        this.verticalAlignment = false;
	        this.onSearch = new core_1.EventEmitter();
	    }
	    AbstractFilterComponent.prototype.changeVisibility = function () {
	        this.visible = !this.visible;
	    };
	    AbstractFilterComponent.prototype.isFormInvalid = function () {
	        return this.form.pristine && this.form.invalid;
	    };
	    AbstractFilterComponent.prototype.getCurrentFilterValues = function () {
	        return this.form.value;
	    };
	    return AbstractFilterComponent;
	}());
	exports.AbstractFilterComponent = AbstractFilterComponent;


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var util_1 = __webpack_require__(743);
	var FilterFieldClearDirective = (function () {
	    function FilterFieldClearDirective() {
	    }
	    FilterFieldClearDirective.prototype.reset = function () {
	        // controls[], not formGroup[name]: a control named like a FormGroup property (e.g. 'status') broke the reset
	        var control = this.formGroup && this.formGroup.controls[this.controlName];
	        if (!util_1.isNullOrUndefined((control)))
	            control.reset(this.defValue);
	    };
	    __decorate([
	        core_1.Input('formGroup'),
	        __metadata("design:type", forms_1.FormGroup)
	    ], FilterFieldClearDirective.prototype, "formGroup", void 0);
	    __decorate([
	        core_1.Input('controlName'),
	        __metadata("design:type", String)
	    ], FilterFieldClearDirective.prototype, "controlName", void 0);
	    __decorate([
	        core_1.Input('defValue'),
	        __metadata("design:type", Object)
	    ], FilterFieldClearDirective.prototype, "defValue", void 0);
	    FilterFieldClearDirective = __decorate([
	        core_1.Directive({
	            selector: 'tfl-filter-field-input, tfl-filter-field-date-range-picker, tfl-filter-field-select, tfl-filter-field-amount-range'
	        })
	    ], FilterFieldClearDirective);
	    return FilterFieldClearDirective;
	}());
	exports.FilterFieldClearDirective = FilterFieldClearDirective;


/***/ }),
/* 1182 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"filter-container\">\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div id=\"show-hide-container\" class=\"pull-right\" (click)=\"changeVisibility()\">\n                <span *ngIf=\"!visible\">{{ 'FILTER.BUTTON.SHOW' | translate }}</span>\n                <span *ngIf=\"visible\">{{ 'FILTER.BUTTON.HIDE' | translate }}</span>\n                <i [ngClass]=\"visible ? 'fa fa-chevron-up' : 'fa fa-chevron-down'\" aria-hidden=\"true\"></i>\n            </div>\n\n            <form *ngIf=\"visible\"\n                  class='filter-form form-horizontal'\n                  [formGroup]=\"form\"\n                  (ngSubmit)=\"submit($event, form)\"\n                  autocomplete=\"off\" novalidate>\n\n                <div class=\"row\">\n                    <ng-content></ng-content>\n                </div>\n\n                <div class=\"pull-right\">\n                    <div>\n                        <button id=\"search-button\" class=\"btn btn-primary\" [disabled]=\"!form.valid\">\n                            {{ 'FILTER.BUTTON.SEARCH' | translate }}\n                        </button>\n\n                        <button id=\"reset-button\" type=\"reset\" class=\"btn btn-default\" (click)=\"reset()\">\n                            {{ 'FILTER.BUTTON.RESET' | translate }}\n                        </button>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(743);
	var forms_1 = __webpack_require__(768);
	var core_1 = __webpack_require__(205);
	var utils_1 = __webpack_require__(740);
	var filter_field_clear_directive_1 = __webpack_require__(1181);
	var abstract_filter_component_1 = __webpack_require__(1180);
	var FilterCallbackBasedComponent = (function (_super) {
	    __extends(FilterCallbackBasedComponent, _super);
	    function FilterCallbackBasedComponent() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.columns = 3;
	        _this.verticalAlignment = false;
	        _this.onSearch = new core_1.EventEmitter();
	        return _this;
	    }
	    FilterCallbackBasedComponent.prototype.submit = function (event, form) {
	        if (utils_1.FormUtils.isValid(form)) {
	            this.onSearch.emit(form.value);
	        }
	    };
	    FilterCallbackBasedComponent.prototype.reset = function () {
	        var values = {};
	        if (!util_1.isNullOrUndefined(this.filterFieldComponents)) {
	            this.filterFieldComponents.forEach(function (field) {
	                values = __assign({}, values, (_a = {}, _a[field.controlName] = field.defValue, _a));
	                field.reset();
	                var _a;
	            });
	        }
	        this.onSearch.emit(values);
	    };
	    __decorate([
	        core_1.Input('form'),
	        __metadata("design:type", forms_1.FormGroup)
	    ], FilterCallbackBasedComponent.prototype, "form", void 0);
	    __decorate([
	        core_1.Input('columns'),
	        __metadata("design:type", Number)
	    ], FilterCallbackBasedComponent.prototype, "columns", void 0);
	    __decorate([
	        core_1.Input('verticalAlignment'),
	        __metadata("design:type", Boolean)
	    ], FilterCallbackBasedComponent.prototype, "verticalAlignment", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], FilterCallbackBasedComponent.prototype, "onSearch", void 0);
	    __decorate([
	        core_1.ContentChildren(filter_field_clear_directive_1.FilterFieldClearDirective),
	        __metadata("design:type", core_1.QueryList)
	    ], FilterCallbackBasedComponent.prototype, "filterFieldComponents", void 0);
	    FilterCallbackBasedComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-callback-based-filter',
	            template: __webpack_require__(1182)
	        })
	    ], FilterCallbackBasedComponent);
	    return FilterCallbackBasedComponent;
	}(abstract_filter_component_1.AbstractFilterComponent));
	exports.FilterCallbackBasedComponent = FilterCallbackBasedComponent;


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var forms_1 = __webpack_require__(768);
	var core_1 = __webpack_require__(205);
	var filter_field_abstract_1 = __webpack_require__(1185);
	var filter_directive_1 = __webpack_require__(1178);
	var FilterFieldInputComponent = (function (_super) {
	    __extends(FilterFieldInputComponent, _super);
	    function FilterFieldInputComponent(filter) {
	        var _this = _super.call(this) || this;
	        _this.type = 'text';
	        _this.filter = filter;
	        return _this;
	    }
	    __decorate([
	        core_1.Input('id'),
	        __metadata("design:type", String)
	    ], FilterFieldInputComponent.prototype, "id", void 0);
	    __decorate([
	        core_1.Input('type'),
	        __metadata("design:type", String)
	    ], FilterFieldInputComponent.prototype, "type", void 0);
	    __decorate([
	        core_1.Input('label'),
	        __metadata("design:type", String)
	    ], FilterFieldInputComponent.prototype, "label", void 0);
	    __decorate([
	        core_1.Input('placeholder'),
	        __metadata("design:type", String)
	    ], FilterFieldInputComponent.prototype, "placeholder", void 0);
	    __decorate([
	        core_1.Input('formGroup'),
	        __metadata("design:type", forms_1.FormGroup)
	    ], FilterFieldInputComponent.prototype, "formGroup", void 0);
	    __decorate([
	        core_1.Input('controlName'),
	        __metadata("design:type", String)
	    ], FilterFieldInputComponent.prototype, "controlName", void 0);
	    __decorate([
	        core_1.Input('defValue'),
	        __metadata("design:type", String)
	    ], FilterFieldInputComponent.prototype, "defValue", void 0);
	    FilterFieldInputComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-filter-field-input',
	            template: "\n        <div [formGroup]=\"formGroup\"\n             [ngClass]=\"getFormGroupClasses()\">\n\n            <label [for]=\"id\"\n                   [ngClass]=\"getFormLabelClasses()\">\n                {{ label | translate }}:\n            </label>\n\n            <div [ngClass]=\"getFormControlClasses()\">\n                <input [id]=\"id\"\n                       [name]=\"id\"\n                       [type]=\"type\"\n                       class=\"form-control\"\n                       [formControlName]=\"controlName\"\n                       placeholder=\"{{ placeholder | translate }}\"/>\n            </div>\n        </div>\n    "
	        }),
	        __param(0, core_1.Inject(core_1.forwardRef(function () { return filter_directive_1.FilterDirective; }))),
	        __metadata("design:paramtypes", [filter_directive_1.FilterDirective])
	    ], FilterFieldInputComponent);
	    return FilterFieldInputComponent;
	}(filter_field_abstract_1.FilterFieldAbstract));
	exports.FilterFieldInputComponent = FilterFieldInputComponent;


/***/ }),
/* 1185 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var FilterFieldAbstract = (function () {
	    function FilterFieldAbstract() {
	    }
	    Object.defineProperty(FilterFieldAbstract.prototype, "verticalAlignment", {
	        get: function () {
	            return this.filter.verticalAlignment;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FilterFieldAbstract.prototype, "colClass", {
	        get: function () {
	            return "col-xs-" + this.filter.columns;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    FilterFieldAbstract.prototype.getFormGroupClasses = function () {
	        return _a = {},
	            _a[this.colClass] = true,
	            _a['vertical-form-group'] = this.verticalAlignment,
	            _a;
	        var _a;
	    };
	    FilterFieldAbstract.prototype.getFormLabelClasses = function () {
	        return {
	            'control-label': true,
	            'col-xs-4     ': !this.verticalAlignment
	        };
	    };
	    FilterFieldAbstract.prototype.getFormControlClasses = function () {
	        return {
	            'col-xs-8': !this.verticalAlignment
	        };
	    };
	    return FilterFieldAbstract;
	}());
	exports.FilterFieldAbstract = FilterFieldAbstract;


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var forms_1 = __webpack_require__(768);
	var core_1 = __webpack_require__(205);
	var filter_field_abstract_1 = __webpack_require__(1185);
	var filter_directive_1 = __webpack_require__(1178);
	var FilterFieldSelectComponent = (function (_super) {
	    __extends(FilterFieldSelectComponent, _super);
	    function FilterFieldSelectComponent(filter) {
	        var _this = _super.call(this) || this;
	        _this.values = [];
	        _this.keyName = 'id';
	        _this.valueName = 'name';
	        _this.filter = filter;
	        return _this;
	    }
	    // reset() {
	    //     let control: AbstractControl = this.formGroup.controls[this.controlName];
	    //     if (!!control) setTimeout(() => {
	    //         console.info('CLEAR');
	    //         control.reset(this.defValue);
	    //     }, 100)
	    // }
	    /** A reset control is null and "Show all" is undefined: treat both as empty, or the select shows a blank option. */
	    FilterFieldSelectComponent.prototype.sameValue = function (a, b) {
	        return a === b || (a == null && b == null) || (a !== a && b !== b);
	    };
	    FilterFieldSelectComponent.prototype.getKey = function (item) {
	        return item && item[this.keyName];
	    };
	    FilterFieldSelectComponent.prototype.getName = function (item) {
	        return item && item[this.valueName];
	    };
	    __decorate([
	        core_1.Input('id'),
	        __metadata("design:type", String)
	    ], FilterFieldSelectComponent.prototype, "id", void 0);
	    __decorate([
	        core_1.Input('label'),
	        __metadata("design:type", String)
	    ], FilterFieldSelectComponent.prototype, "label", void 0);
	    __decorate([
	        core_1.Input('values'),
	        __metadata("design:type", Array)
	    ], FilterFieldSelectComponent.prototype, "values", void 0);
	    __decorate([
	        core_1.Input('keyName'),
	        __metadata("design:type", String)
	    ], FilterFieldSelectComponent.prototype, "keyName", void 0);
	    __decorate([
	        core_1.Input('valueName'),
	        __metadata("design:type", String)
	    ], FilterFieldSelectComponent.prototype, "valueName", void 0);
	    __decorate([
	        core_1.Input('formGroup'),
	        __metadata("design:type", forms_1.FormGroup)
	    ], FilterFieldSelectComponent.prototype, "formGroup", void 0);
	    __decorate([
	        core_1.Input('controlName'),
	        __metadata("design:type", String)
	    ], FilterFieldSelectComponent.prototype, "controlName", void 0);
	    __decorate([
	        core_1.Input('defValue'),
	        __metadata("design:type", Object)
	    ], FilterFieldSelectComponent.prototype, "defValue", void 0);
	    FilterFieldSelectComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-filter-field-select',
	            template: "\n        <div [formGroup]=\"formGroup\" [ngClass]=\"getFormGroupClasses()\">\n            <label [for]=\"id\" [ngClass]=\"getFormLabelClasses()\">\n                {{ label | translate }}:\n            </label>\n\n            <div [ngClass]=\"getFormControlClasses()\">\n                <select [id]=\"id\" [name]=\"id\" class=\"form-control\" [formControlName]=\"controlName\" [compareWith]=\"sameValue\">\n                    <!-- TODO on select -> reset -->\n                    <option [ngValue]=\"defValue\">\n                        {{ 'COMMON.SHOW_ALL' | translate }}\n                    </option>\n\n                    <option *ngFor=\"let item of values\" [ngValue]=\"getKey(item)\">\n                        {{ getName(item) | translate }}\n                    </option>\n                </select>\n            </div>\n        </div>\n    "
	        }),
	        __param(0, core_1.Inject(core_1.forwardRef(function () { return filter_directive_1.FilterDirective; }))),
	        __metadata("design:paramtypes", [filter_directive_1.FilterDirective])
	    ], FilterFieldSelectComponent);
	    return FilterFieldSelectComponent;
	}(filter_field_abstract_1.FilterFieldAbstract));
	exports.FilterFieldSelectComponent = FilterFieldSelectComponent;


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var forms_1 = __webpack_require__(768);
	var core_1 = __webpack_require__(205);
	var filter_field_abstract_1 = __webpack_require__(1185);
	var filter_directive_1 = __webpack_require__(1178);
	var FilterFieldDaterangepickerComponent = (function (_super) {
	    __extends(FilterFieldDaterangepickerComponent, _super);
	    function FilterFieldDaterangepickerComponent(filter) {
	        var _this = _super.call(this) || this;
	        _this.beginPropName = 'beginDate';
	        _this.endPropName = 'endDate';
	        _this.filter = filter;
	        return _this;
	    }
	    __decorate([
	        core_1.Input('id'),
	        __metadata("design:type", String)
	    ], FilterFieldDaterangepickerComponent.prototype, "id", void 0);
	    __decorate([
	        core_1.Input('label'),
	        __metadata("design:type", String)
	    ], FilterFieldDaterangepickerComponent.prototype, "label", void 0);
	    __decorate([
	        core_1.Input('beginPropName'),
	        __metadata("design:type", String)
	    ], FilterFieldDaterangepickerComponent.prototype, "beginPropName", void 0);
	    __decorate([
	        core_1.Input('endPropName'),
	        __metadata("design:type", String)
	    ], FilterFieldDaterangepickerComponent.prototype, "endPropName", void 0);
	    __decorate([
	        core_1.Input('formGroup'),
	        __metadata("design:type", forms_1.FormGroup)
	    ], FilterFieldDaterangepickerComponent.prototype, "formGroup", void 0);
	    __decorate([
	        core_1.Input('controlName'),
	        __metadata("design:type", String)
	    ], FilterFieldDaterangepickerComponent.prototype, "controlName", void 0);
	    __decorate([
	        core_1.Input('defValue'),
	        __metadata("design:type", Object)
	    ], FilterFieldDaterangepickerComponent.prototype, "defValue", void 0);
	    FilterFieldDaterangepickerComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-filter-field-date-range-picker',
	            template: "\n        <div [formGroup]=\"formGroup\" \n             [ngClass]=\"getFormGroupClasses()\">\n            \n            <label [for]=\"id\" \n                   [ngClass]=\"getFormLabelClasses()\">\n                {{ label | translate }}:\n            </label>\n\n            <div [ngClass]=\"getFormControlClasses()\">\n                <tfl-daterangepicker [id]=\"id\"\n                                     [name]=\"id\"\n                                     [beginPropName]=\"beginPropName\"\n                                     [endPropName]=\"endPropName\"\n                                     [formControlName]=\"controlName\">\n                </tfl-daterangepicker>\n            </div>\n        </div>\n    "
	        }),
	        __param(0, core_1.Inject(core_1.forwardRef(function () { return filter_directive_1.FilterDirective; }))),
	        __metadata("design:paramtypes", [filter_directive_1.FilterDirective])
	    ], FilterFieldDaterangepickerComponent);
	    return FilterFieldDaterangepickerComponent;
	}(filter_field_abstract_1.FilterFieldAbstract));
	exports.FilterFieldDaterangepickerComponent = FilterFieldDaterangepickerComponent;


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var filter_field_abstract_1 = __webpack_require__(1185);
	var filter_directive_1 = __webpack_require__(1178);
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var FilterFieldAmountComponent = (function (_super) {
	    __extends(FilterFieldAmountComponent, _super);
	    function FilterFieldAmountComponent(filter) {
	        var _this = _super.call(this) || this;
	        _this.minValueName = 'minValue';
	        _this.maxValueName = 'maxValue';
	        _this.filter = filter;
	        return _this;
	    }
	    __decorate([
	        core_1.Input('id'),
	        __metadata("design:type", String)
	    ], FilterFieldAmountComponent.prototype, "id", void 0);
	    __decorate([
	        core_1.Input('label'),
	        __metadata("design:type", String)
	    ], FilterFieldAmountComponent.prototype, "label", void 0);
	    __decorate([
	        core_1.Input('controlName'),
	        __metadata("design:type", String)
	    ], FilterFieldAmountComponent.prototype, "controlName", void 0);
	    __decorate([
	        core_1.Input('minValueName'),
	        __metadata("design:type", String)
	    ], FilterFieldAmountComponent.prototype, "minValueName", void 0);
	    __decorate([
	        core_1.Input('maxValueName'),
	        __metadata("design:type", String)
	    ], FilterFieldAmountComponent.prototype, "maxValueName", void 0);
	    __decorate([
	        core_1.Input('formGroup'),
	        __metadata("design:type", forms_1.FormGroup)
	    ], FilterFieldAmountComponent.prototype, "formGroup", void 0);
	    FilterFieldAmountComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-filter-field-amount-range',
	            template: "<div [formGroup]=\"formGroup\"\n     [ngClass]=\"getFormGroupClasses()\">\n\n    <label [for]=\"id\"\n           [ngClass]=\"getFormLabelClasses()\">\n        {{ label | translate }}:\n    </label>\n\n    <div [ngClass]=\"getFormControlClasses()\">\n        <tfl-amount-range\n            id=\"id\"\n            name=\"name\"\n            [minValueName]=\"minValueName\"\n            [maxValueName]=\"maxValueName\"\n            [formControlName]=\"controlName\"\n        >\n        </tfl-amount-range>\n    </div>\n</div>"
	        }),
	        __param(0, core_1.Inject(core_1.forwardRef(function () { return filter_directive_1.FilterDirective; }))),
	        __metadata("design:paramtypes", [filter_directive_1.FilterDirective])
	    ], FilterFieldAmountComponent);
	    return FilterFieldAmountComponent;
	}(filter_field_abstract_1.FilterFieldAbstract));
	exports.FilterFieldAmountComponent = FilterFieldAmountComponent;


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var forms_1 = __webpack_require__(768);
	var core_1 = __webpack_require__(205);
	exports.AMOUNT_RANGE_CONTROL_VALUE_ACCESSOR = {
	    provide: forms_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return AmountRangeComponent; }),
	    multi: true
	};
	var AmountRangeComponent = (function () {
	    function AmountRangeComponent() {
	        this.onChange = new core_1.EventEmitter();
	        this.onTouchedCallback = new core_1.EventEmitter();
	        this.value = {};
	    }
	    AmountRangeComponent.prototype.registerOnChange = function (fn) {
	        this.onChange.subscribe(fn);
	    };
	    AmountRangeComponent.prototype.registerOnTouched = function (fn) {
	        this.onTouchedCallback.subscribe(fn);
	    };
	    AmountRangeComponent.prototype.writeValue = function (obj) {
	        if (obj && obj.hasOwnProperty(this.minValueName) && obj.hasOwnProperty(this.maxValueName)) {
	            this.value = (_a = {},
	                _a[this.maxValueName] = obj[this.maxValueName],
	                _a[this.minValueName] = obj[this.minValueName],
	                _a);
	            if (!!this.maxInput && !!this.minInput) {
	                this.maxInput.nativeElement.value = obj[this.maxValueName];
	                this.minInput.nativeElement.value = obj[this.minValueName];
	            }
	        }
	        else if (!obj) {
	            // Form reset: clear both inputs
	            this.value = {};
	            if (!!this.maxInput && !!this.minInput) {
	                this.maxInput.nativeElement.value = '';
	                this.minInput.nativeElement.value = '';
	            }
	        }
	        var _a;
	    };
	    AmountRangeComponent.prototype.onAmountBlur = function (min) {
	        var minAmount = this.minInput.nativeElement.value;
	        var maxAmount = this.maxInput.nativeElement.value;
	        if (minAmount && maxAmount) {
	            if (Number(minAmount) > Number(maxAmount)) {
	                if (min) {
	                    this.maxInput.nativeElement.value = '';
	                    this.value = {
	                        minValue: this.minInput.nativeElement.value,
	                        maxValue: ''
	                    };
	                    this.onChange.emit(this.value);
	                }
	                else {
	                    this.minInput.nativeElement.value = '';
	                    this.value = {
	                        minValue: '',
	                        maxValue: this.maxInput.nativeElement.value
	                    };
	                    this.onChange.emit(this.value);
	                }
	            }
	        }
	    };
	    AmountRangeComponent.prototype.onInput = function () {
	        this.onChange.emit(this.value = {
	            minValue: this.minInput.nativeElement.value,
	            maxValue: this.maxInput.nativeElement.value
	        });
	    };
	    __decorate([
	        core_1.Input('id'),
	        __metadata("design:type", String)
	    ], AmountRangeComponent.prototype, "id", void 0);
	    __decorate([
	        core_1.Input('name'),
	        __metadata("design:type", String)
	    ], AmountRangeComponent.prototype, "name", void 0);
	    __decorate([
	        core_1.Input('minValueName'),
	        __metadata("design:type", String)
	    ], AmountRangeComponent.prototype, "minValueName", void 0);
	    __decorate([
	        core_1.Input('maxValueName'),
	        __metadata("design:type", String)
	    ], AmountRangeComponent.prototype, "maxValueName", void 0);
	    __decorate([
	        core_1.ViewChild('maxInput'),
	        __metadata("design:type", core_1.ElementRef)
	    ], AmountRangeComponent.prototype, "maxInput", void 0);
	    __decorate([
	        core_1.ViewChild('minInput'),
	        __metadata("design:type", core_1.ElementRef)
	    ], AmountRangeComponent.prototype, "minInput", void 0);
	    AmountRangeComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-amount-range',
	            providers: [exports.AMOUNT_RANGE_CONTROL_VALUE_ACCESSOR],
	            template: "\n    <div style=\"display: flex\">\n        <input #minInput\n            class=\"form-control range-amount\"\n            (input)=\"onInput()\"\n            (blur)=\"onAmountBlur(false)\"\n            style=\"width: 100px;margin-left: 10px\"\n            id=\"minValue\"\n            [name]=\"minValueName\"\n            type=\"money\"\n        />\n        <label for=\"maxAmount\" class=\"control-label\" style=\"margin: 0 5px 0 5px;\">\n            &#9866;\n        </label>\n        <input #maxInput\n               (blur)=\"onAmountBlur(true)\"\n               class=\"form-control range-amount\"\n               style=\"width: 100px\"\n               (input)=\"onInput()\"\n               maxlength=\"50\"\n               id=\"maxValue\"\n               [name]=\"maxValueName\"\n               type=\"money\"\n        />\n    </div>\n    ",
	            styles: ["\n        input {\n            margin:0 !important; \n            width: 50% !important;\n        };\n    "]
	        })
	    ], AmountRangeComponent);
	    return AmountRangeComponent;
	}());
	exports.AmountRangeComponent = AmountRangeComponent;


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var incoming_transfer_icon_1 = __webpack_require__(1191);
	var fee_transfer_icon_1 = __webpack_require__(1193);
	var internal_transfer_icon_1 = __webpack_require__(1195);
	var outgoing_exchange_transfer_icon_1 = __webpack_require__(1197);
	var outgoing_3_transter_icon_1 = __webpack_require__(1199);
	var outgoing_4_transfer_icon_1 = __webpack_require__(1201);
	var deivered_transfer_icon_1 = __webpack_require__(1203);
	var undelivered_transfer_icon_1 = __webpack_require__(1205);
	var incoming_4_transfer_icon_1 = __webpack_require__(1207);
	var refund_transfer_icon_1 = __webpack_require__(1209);
	var outgoing_transfer_icon_1 = __webpack_require__(1211);
	var internal_exchnage_transfer_icon_1 = __webpack_require__(1213);
	var system_transfer_icon_1 = __webpack_require__(1215);
	var system_exchange_transfer_icon_1 = __webpack_require__(1216);
	var card_exchange_transfer_icon_1 = __webpack_require__(1217);
	var card_transfer_icon_1 = __webpack_require__(1219);
	exports.TRANSFER_ICONS = [
	    incoming_transfer_icon_1.IncomingTransferIcon,
	    refund_transfer_icon_1.RefundTransferIcon,
	    incoming_4_transfer_icon_1.Incoming4TransferIcon,
	    undelivered_transfer_icon_1.UndeliveredTransferIcon,
	    deivered_transfer_icon_1.DeliveredTransferIcon,
	    outgoing_4_transfer_icon_1.Outgoing4TransferIcon,
	    outgoing_3_transter_icon_1.Outgoing3TransferIcon,
	    outgoing_exchange_transfer_icon_1.OutgoingExchangeTransferIcon,
	    outgoing_transfer_icon_1.OutgoingTransferIcon,
	    internal_exchnage_transfer_icon_1.InternalExchangeTransferIcon,
	    internal_transfer_icon_1.InternalTransferIcon,
	    fee_transfer_icon_1.FeeTransferIcon,
	    card_exchange_transfer_icon_1.CardExchangeTransferIcon,
	    card_transfer_icon_1.CardTransferIcon,
	    system_transfer_icon_1.SystemTransferIcon,
	    system_exchange_transfer_icon_1.SystemExchangeTransferIcon
	];


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var IncomingTransferIcon = (function () {
	    function IncomingTransferIcon() {
	    }
	    IncomingTransferIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-incoming-transfer-icon',
	            template: __webpack_require__(1192)
	        })
	    ], IncomingTransferIcon);
	    return IncomingTransferIcon;
	}());
	exports.IncomingTransferIcon = IncomingTransferIcon;


/***/ }),
/* 1192 */
/***/ (function(module, exports) {

	module.exports = "<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">\n    <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->\n    <defs></defs>\n    <g id=\"UI-elements\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Artboard-2-Copy-3\" transform=\"translate(-314.000000, -227.000000)\" fill=\"#286090\">\n            <g id=\"Group-5-Copy\" transform=\"translate(39.000000, 194.000000)\">\n                <g id=\"Group-2-Copy-4\" transform=\"translate(275.000000, 33.000000)\">\n                    <path d=\"M9,1.73479406e-14 C4.02943725,1.73479406e-14 0,4.02943725 0,9 C0,13.9705627 4.02943725,18 9,18 C13.9705627,18 18,13.9705627 18,9 C18,4.02943725 13.9705627,0 9,0 L9,1.73479406e-14 Z M9.00011692,17 C5.76446625,17 2.84741858,15.0508911 1.60918868,12.0615396 C0.370958772,9.07218821 1.05539481,5.63129587 3.34334534,3.34334534 C5.63129587,1.05539481 9.07218821,0.370958772 12.0615396,1.60918868 C15.0508911,2.84741858 17,5.76446625 17,9.00011692 C17,13.4183303 13.4183303,17 9.00011692,17 L9.00011692,17 Z\"\n                          id=\"Shape-Copy-67\"></path>\n                    <path d=\"M9.78063367,6.59533599 L11.8606337,8.67533599 C12.047706,8.82252935 12.3152858,8.80662418 12.4836038,8.63830614 C12.6519219,8.46998809 12.667827,8.20240829 12.5206337,8.01533599 L9.64063367,5.13533599 C9.45763535,4.954888 9.163632,4.954888 8.98063367,5.13533599 L6.10063367,8.01533599 C5.95344032,8.20240829 5.96934548,8.46998809 6.13766353,8.63830614 C6.30598157,8.80662418 6.57356137,8.82252935 6.76063367,8.67533599 L8.84063367,6.59533599 L8.84063367,13.035336 C8.81381239,13.2177431 8.89611718,13.398986 9.05111155,13.4988283 C9.20610593,13.5986705 9.40516142,13.5986705 9.5601558,13.4988283 C9.71515017,13.398986 9.79745496,13.2177431 9.77063367,13.035336 L9.78063367,6.59533599 Z\"\n                          id=\"Shape-Copy-68\"\n                          transform=\"translate(9.310634, 9.286855) rotate(180.000000) translate(-9.310634, -9.286855) \"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>"

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var FeeTransferIcon = (function () {
	    function FeeTransferIcon() {
	    }
	    FeeTransferIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-fee-transfer-icon',
	            template: __webpack_require__(1194)
	        })
	    ], FeeTransferIcon);
	    return FeeTransferIcon;
	}());
	exports.FeeTransferIcon = FeeTransferIcon;


/***/ }),
/* 1194 */
/***/ (function(module, exports) {

	module.exports = "<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">\n    <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->\n    <defs></defs>\n    <g id=\"UI-elements\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Artboard-2-Copy-3\" transform=\"translate(-576.000000, -227.000000)\" fill=\"#286090\">\n            <g id=\"Group-5-Copy\" transform=\"translate(39.000000, 194.000000)\">\n                <g id=\"Group-2-Copy-2\" transform=\"translate(537.000000, 33.000000)\">\n                    <path d=\"M9,1.73479406e-14 C4.02943725,1.73479406e-14 0,4.02943725 0,9 C0,13.9705627 4.02943725,18 9,18 C13.9705627,18 18,13.9705627 18,9 C18,4.02943725 13.9705627,0 9,0 L9,1.73479406e-14 Z M9.00011692,17 C5.76446625,17 2.84741858,15.0508911 1.60918868,12.0615396 C0.370958772,9.07218821 1.05539481,5.63129587 3.34334534,3.34334534 C5.63129587,1.05539481 9.07218821,0.370958772 12.0615396,1.60918868 C15.0508911,2.84741858 17,5.76446625 17,9.00011692 C17,13.4183303 13.4183303,17 9.00011692,17 L9.00011692,17 Z\"\n                          id=\"Shape-Copy-67\"></path>\n                    <path d=\"M9.78063367,6.59533599 L11.8606337,8.67533599 C12.047706,8.82252935 12.3152858,8.80662418 12.4836038,8.63830614 C12.6519219,8.46998809 12.667827,8.20240829 12.5206337,8.01533599 L9.64063367,5.13533599 C9.45763535,4.954888 9.163632,4.954888 8.98063367,5.13533599 L6.10063367,8.01533599 C5.95344032,8.20240829 5.96934548,8.46998809 6.13766353,8.63830614 C6.30598157,8.80662418 6.57356137,8.82252935 6.76063367,8.67533599 L8.84063367,6.59533599 L8.84063367,13.035336 C8.81381239,13.2177431 8.89611718,13.398986 9.05111155,13.4988283 C9.20610593,13.5986705 9.40516142,13.5986705 9.5601558,13.4988283 C9.71515017,13.398986 9.79745496,13.2177431 9.77063367,13.035336 L9.78063367,6.59533599 Z\"\n                          id=\"Shape-Copy-68\"\n                          transform=\"translate(9.310634, 9.286855) rotate(90.000000) translate(-9.310634, -9.286855) \"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>"

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var InternalTransferIcon = (function () {
	    function InternalTransferIcon() {
	    }
	    InternalTransferIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-internal-transfer-icon',
	            template: __webpack_require__(1196)
	        })
	    ], InternalTransferIcon);
	    return InternalTransferIcon;
	}());
	exports.InternalTransferIcon = InternalTransferIcon;


/***/ }),
/* 1196 */
/***/ (function(module, exports) {

	module.exports = "<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">\n    <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->\n    <defs></defs>\n    <g id=\"UI-elements\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Artboard-2-Copy-3\" transform=\"translate(-488.000000, -227.000000)\" fill=\"#286090\">\n            <g id=\"Group-5-Copy\" transform=\"translate(39.000000, 194.000000)\">\n                <g id=\"Group-6-Copy-2\" transform=\"translate(449.000000, 33.000000)\">\n                    <path d=\"M9,1.73479406e-14 C4.02943725,1.73479406e-14 0,4.02943725 0,9 C0,13.9705627 4.02943725,18 9,18 C13.9705627,18 18,13.9705627 18,9 C18,4.02943725 13.9705627,0 9,0 L9,1.73479406e-14 Z M1.60918868,12.0615396 C0.370958772,9.07218821 1.05539481,5.63129587 3.34334534,3.34334534 C5.63129587,1.05539481 9.07218821,0.370958772 12.0615396,1.60918868 C15.0508911,2.84741858 17,5.76446625 17,9.00011692 C17,13.4183303 13.4183303,17 9.00011692,17 C5.76446625,17 2.84741858,15.0508911 1.60918868,12.0615396 Z\"\n                          id=\"Shape-Copy-69\"></path>\n                    <path d=\"M11.7806337,9.59533599 L12.8606337,10.675336 C13.047706,10.8225293 13.3152858,10.8066242 13.4836038,10.6383061 C13.6519219,10.4699881 13.667827,10.2024083 13.5206337,10.015336 L11.6406337,8.13533599 C11.4576354,7.954888 11.163632,7.954888 10.9806337,8.13533599 L9.10063367,10.015336 C8.95344032,10.2024083 8.96934548,10.4699881 9.13766353,10.6383061 C9.30598157,10.8066242 9.57356137,10.8225293 9.76063367,10.675336 L10.8406337,9.59533599 L10.8406337,14.035336 C10.8138124,14.2177431 10.8961172,14.398986 11.0511116,14.4988283 C11.2061059,14.5986705 11.4051614,14.5986705 11.5601558,14.4988283 C11.7151502,14.398986 11.797455,14.2177431 11.7706337,14.035336 L11.7806337,9.59533599 Z\"\n                          id=\"Shape-Copy-70\"></path>\n                    <path d=\"M6.78063367,5.59533599 L7.86063367,6.67533599 C8.04770598,6.82252935 8.31528578,6.80662418 8.48360382,6.63830614 C8.65192187,6.46998809 8.66782703,6.20240829 8.52063367,6.01533599 L6.64063367,4.13533599 C6.45763535,3.954888 6.163632,3.954888 5.98063367,4.13533599 L4.10063367,6.01533599 C3.95344032,6.20240829 3.96934548,6.46998809 4.13766353,6.63830614 C4.30598157,6.80662418 4.57356137,6.82252935 4.76063367,6.67533599 L5.84063367,5.59533599 L5.84063367,10.035336 C5.81381239,10.2177431 5.89611718,10.398986 6.05111155,10.4988283 C6.20610593,10.5986705 6.40516142,10.5986705 6.5601558,10.4988283 C6.71515017,10.398986 6.79745496,10.2177431 6.77063367,10.035336 L6.78063367,5.59533599 Z\"\n                          id=\"Shape-Copy-71\"\n                          transform=\"translate(6.310634, 7.286855) rotate(180.000000) translate(-6.310634, -7.286855) \"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>"

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var OutgoingExchangeTransferIcon = (function () {
	    function OutgoingExchangeTransferIcon() {
	    }
	    OutgoingExchangeTransferIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-outgoing-exchange-transfer-icon',
	            template: __webpack_require__(1198)
	        })
	    ], OutgoingExchangeTransferIcon);
	    return OutgoingExchangeTransferIcon;
	}());
	exports.OutgoingExchangeTransferIcon = OutgoingExchangeTransferIcon;


/***/ }),
/* 1198 */
/***/ (function(module, exports) {

	module.exports = "<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">\n    <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->\n    <defs></defs>\n    <g id=\"UI-elements\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Artboard-2-Copy-3\" transform=\"translate(-195.000000, -227.000000)\" fill=\"#286090\">\n            <g id=\"Group-5-Copy\" transform=\"translate(39.000000, 194.000000)\">\n                <g id=\"9\" transform=\"translate(156.000000, 33.000000)\">\n                    <path d=\"M9.43,6.35 L11.51,8.43 C11.6970723,8.57719336 11.9646521,8.56128819 12.1329701,8.39297015 C12.3012882,8.2246521 12.3171934,7.9570723 12.17,7.77 L9.29,4.89 C9.10700168,4.70955201 8.81299832,4.70955201 8.63,4.89 L5.75,7.77 C5.60280664,7.9570723 5.61871181,8.2246521 5.78702985,8.39297015 C5.9553479,8.56128819 6.2229277,8.57719336 6.41,8.43 L8.49,6.35 L8.49,12.79 C8.46317872,12.9724071 8.5454835,13.1536501 8.70047788,13.2534923 C8.85547225,13.3533345 9.05452775,13.3533345 9.20952212,13.2534923 C9.3645165,13.1536501 9.44682128,12.9724071 9.42,12.79 L9.43,6.35 Z\"\n                          id=\"Shape\"></path>\n                    <path d=\"M17.67,6.71 C17.5689964,6.47412842 17.2974863,6.3628538 17.06,6.46 C16.8011398,6.55019221 16.65675,6.8258453 16.73,7.09 C17.5848767,10.5958953 15.9868016,14.2401112 12.828781,15.9862558 C9.67076031,17.7324005 5.73466931,17.1481565 3.22,14.56 L2.99,14.34 L2.83,14.18 L4.11,14.18 C4.2298218,14.2069981 4.35543597,14.178855 4.45228434,14.1033133 C4.54913272,14.0277715 4.60701243,13.9127894 4.61,13.79 C4.60593496,13.6688578 4.54973138,13.5553785 4.45583439,13.4787279 C4.3619374,13.4020773 4.23950352,13.3697301 4.12,13.39 L2.01,13.39 C1.74536251,13.3267576 1.47873317,13.4867352 1.41,13.75 L1.41,16.14 C1.37726771,16.2556303 1.40273169,16.3799548 1.4782877,16.4734057 C1.55384371,16.5668565 1.67007892,16.6177916 1.79,16.61 C1.90883879,16.6242393 2.02744112,16.5816571 2.11008335,16.4950796 C2.19272558,16.408502 2.22974827,16.2880484 2.21,16.17 L2.21,14.97 L2.32,15.11 C4.87434074,17.7516686 8.76681224,18.597829 12.1873193,17.2549957 C15.6078263,15.9121623 17.8850401,12.6438877 17.96,8.97 C17.9696361,8.20680376 17.8720156,7.4460374 17.67,6.71 L17.67,6.71 Z\"\n                          id=\"Shape\"></path>\n                    <path d=\"M5.93869311,1.54517972 C8.95524203,0.314832015 12.4165657,1.03658634 14.69,3.37 L14.92,3.59 L15.08,3.75 L13.8,3.75 C13.6801782,3.72300191 13.554564,3.75114501 13.4577157,3.82668674 C13.3608673,3.90222847 13.3029876,4.01721061 13.3,4.14 C13.304065,4.26114221 13.3602686,4.37462152 13.4541656,4.45127212 C13.5480626,4.52792273 13.6704965,4.56026992 13.79,4.54 L15.96,4.54 C16.2246375,4.6032424 16.4912668,4.44326479 16.56,4.18 L16.56,1.77 C16.5826392,1.65232431 16.5484444,1.53086411 16.4677376,1.44228352 C16.3870308,1.35370294 16.2692691,1.3083815 16.15,1.32 C16.0315893,1.30606426 15.91396,1.35165823 15.835874,1.44175745 C15.757788,1.53185666 15.7293758,1.65477219 15.76,1.77 L15.76,3.01 L15.6,2.78 C13.054617,0.0906590656 8.89627075,-0.65814209 5.68579002,0.583651997 C2.47530928,1.82544608 0.0274339799,5.26712411 0.0119628906,8.97 C-0.0113089464,9.70496373 0.0209507884,10.439385 0.21,11.15 C0.296014525,11.4124303 0.57528924,11.5587171 0.84,11.48 C1.0948789,11.3858546 1.23430885,11.1113519 1.16,10.85 C1.01925856,10.2334414 0.952123195,9.60236903 0.96,8.97 C0.952967647,5.71219807 2.92214419,2.77552742 5.93869311,1.54517972 Z\"\n                          id=\"Shape\"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>"

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var Outgoing3TransferIcon = (function () {
	    function Outgoing3TransferIcon() {
	    }
	    Outgoing3TransferIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-outgoing-3-transfer-icon',
	            template: __webpack_require__(1200)
	        })
	    ], Outgoing3TransferIcon);
	    return Outgoing3TransferIcon;
	}());
	exports.Outgoing3TransferIcon = Outgoing3TransferIcon;


/***/ }),
/* 1200 */
/***/ (function(module, exports) {

	module.exports = "<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">\n    <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->\n    <defs></defs>\n    <g id=\"UI-elements\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Artboard-2-Copy-3\" transform=\"translate(-223.000000, -227.000000)\">\n            <g id=\"Group-5-Copy\" transform=\"translate(39.000000, 194.000000)\">\n                <g id=\"Group-3-Copy-4\" transform=\"translate(184.000000, 33.000000)\">\n                    <path d=\"M9.77338882,1.03732328 C9.45531499,0.645263152 9.08437515,0.297833369 8.67142195,0.00588657037 C8.78046475,0.00197334689 8.89000193,1.73479406e-14 9,1.73479406e-14 L9,0 C13.9705627,0 18,4.02943725 18,9 C18,13.9705627 13.9705627,18 9,18 C4.02943725,18 0,13.9705627 0,9 C0,8.12005699 0.126282267,7.26960878 0.361712432,6.46578974 C0.544287064,6.94272389 0.79135469,7.38774708 1.09224456,7.79018856 C0.875659599,9.20495267 1.03750446,10.6813718 1.60918868,12.0615396 C2.84741858,15.0508911 5.76446625,17 9.00011692,17 C13.4183303,17 17,13.4183303 17,9.00011692 C17,5.76446625 15.0508911,2.84741858 12.0615396,1.60918868 C11.3185067,1.30141436 10.5475767,1.11242625 9.77338882,1.03732328 Z\"\n                          id=\"Combined-Shape\" fill=\"#286090\"></path>\n                    <path d=\"M3.25741774,4.26325641e-15 L2.35647655,1.77635684e-15 C2.15959816,1.77635684e-15 2,0.159598159 2,0.35647655 C2,0.55335494 2.15959816,0.712953099 2.35647655,0.712953099 L3.25740103,0.712953099 C4.84222027,0.712953099 6.10926355,1.20221721 6.10926355,2.78703646 C6.10926355,4.3718557 4.84223698,4.86111981 3.25741774,4.86111981 L3.21711351,4.86111981 L4.03448802,4.0437453 C4.17369986,3.90453347 4.17369986,3.67881344 4.03448802,3.53960161 C3.89527618,3.40038977 3.66955616,3.40038977 3.53034432,3.53960161 L2.1044047,4.96552452 C2.09609978,4.97382943 2.08824603,4.98256882 2.08079333,4.99165911 C2.0675088,5.00942195 2.06358193,5.01438485 2.06003939,5.01968195 C2.04774075,5.03998472 2.04473294,5.04466355 2.04209274,5.04959302 C2.03188287,5.0708984 2.02932622,5.07594485 2.0271372,5.08120853 C2.01926674,5.1028314 2.01711114,5.10837915 2.01537329,5.11412743 C2.00972528,5.13618476 2.00808769,5.14198316 2.00690127,5.14794867 C2.00327518,5.17202792 2.00227257,5.17714121 2.00175456,5.18240489 C1.99944857,5.20579903 1.99944857,5.22937698 2.00175456,5.25277112 C2.00491277,5.27466135 2.00564801,5.28097777 2.00688456,5.28724406 C2.01254928,5.31028729 2.0137357,5.31571807 2.01535658,5.3210653 C2.02321033,5.34335657 2.02496489,5.34873722 2.0271372,5.35400091 C2.03686248,5.3748384 2.03926873,5.3803026 2.04210945,5.38561641 C2.05370626,5.40516723 2.05664724,5.41044762 2.06003939,5.41552749 C2.0744602,5.43507831 2.07740118,5.43942293 2.08079333,5.44355033 C2.0881959,5.45257378 2.09599952,5.46124632 2.1042376,5.4694844 C2.10430444,5.46955124 3.53032761,6.89559112 3.53032761,6.89559112 C3.66953945,7.03480296 3.89525947,7.03480296 4.03447131,6.89559112 C4.17368315,6.75637928 4.17368315,6.53065926 4.03447131,6.39144742 L3.2170968,5.57407291 L3.25740103,5.57407291 C5.23599376,5.57408962 6.82223336,4.76561248 6.82223336,2.78703646 C6.82223336,0.808460432 5.23599376,4.26325641e-15 3.25741774,4.26325641e-15 Z\"\n                          id=\"Shape\" fill=\"#EA8C05\" fill-rule=\"nonzero\"></path>\n                    <path d=\"M9.78063367,6.59533599 L11.8606337,8.67533599 C12.047706,8.82252935 12.3152858,8.80662418 12.4836038,8.63830614 C12.6519219,8.46998809 12.667827,8.20240829 12.5206337,8.01533599 L9.64063367,5.13533599 C9.45763535,4.954888 9.163632,4.954888 8.98063367,5.13533599 L6.10063367,8.01533599 C5.95344032,8.20240829 5.96934548,8.46998809 6.13766353,8.63830614 C6.30598157,8.80662418 6.57356137,8.82252935 6.76063367,8.67533599 L8.84063367,6.59533599 L8.84063367,13.035336 C8.81381239,13.2177431 8.89611718,13.398986 9.05111155,13.4988283 C9.20610593,13.5986705 9.40516142,13.5986705 9.5601558,13.4988283 C9.71515017,13.398986 9.79745496,13.2177431 9.77063367,13.035336 L9.78063367,6.59533599 Z\"\n                          id=\"Shape-Copy-64\" fill=\"#286090\"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>"

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var Outgoing4TransferIcon = (function () {
	    function Outgoing4TransferIcon() {
	    }
	    Outgoing4TransferIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-outgoing-5-transfer-icon',
	            template: __webpack_require__(1202)
	        })
	    ], Outgoing4TransferIcon);
	    return Outgoing4TransferIcon;
	}());
	exports.Outgoing4TransferIcon = Outgoing4TransferIcon;


/***/ }),
/* 1202 */
/***/ (function(module, exports) {

	module.exports = "<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">\n    <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->\n    <defs></defs>\n    <g id=\"UI-elements\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Artboard-2-Copy-3\" transform=\"translate(-250.000000, -227.000000)\">\n            <g id=\"Group-5-Copy\" transform=\"translate(39.000000, 194.000000)\">\n                <g id=\"Group-7-Copy\" transform=\"translate(211.000000, 33.000000)\">\n                    <path d=\"M17.67,6.71 C17.5689964,6.47412842 17.2974863,6.3628538 17.06,6.46 C16.8011398,6.55019221 16.65675,6.8258453 16.73,7.09 C17.5848767,10.5958953 15.9868016,14.2401112 12.828781,15.9862558 C9.67076031,17.7324005 5.73466931,17.1481565 3.22,14.56 L2.99,14.34 L2.83,14.18 L4.11,14.18 C4.2298218,14.2069981 4.35543597,14.178855 4.45228434,14.1033133 C4.54913272,14.0277715 4.60701243,13.9127894 4.61,13.79 C4.60593496,13.6688578 4.54973138,13.5553785 4.45583439,13.4787279 C4.3619374,13.4020773 4.23950352,13.3697301 4.12,13.39 L2.01,13.39 C1.74536251,13.3267576 1.47873317,13.4867352 1.41,13.75 L1.41,16.14 C1.37726771,16.2556303 1.40273169,16.3799548 1.4782877,16.4734057 C1.55384371,16.5668565 1.67007892,16.6177916 1.79,16.61 C1.90883879,16.6242393 2.02744112,16.5816571 2.11008335,16.4950796 C2.19272558,16.408502 2.22974827,16.2880484 2.21,16.17 L2.21,14.97 L2.32,15.11 C4.87434074,17.7516686 8.76681224,18.597829 12.1873193,17.2549957 C15.6078263,15.9121623 17.8850401,12.6438877 17.96,8.97 C17.9696361,8.20680376 17.8720156,7.4460374 17.67,6.71 L17.67,6.71 Z\"\n                          id=\"Shape\" fill=\"#286090\"></path>\n                    <path d=\"M0.963563817,8.71248288 C0.961007853,8.79808073 0.959814204,8.88392829 0.96,8.97 C0.952123195,9.60236903 1.01925856,10.2334414 1.16,10.85 C1.23430885,11.1113519 1.0948789,11.3858546 0.84,11.48 C0.57528924,11.5587171 0.296014525,11.4124303 0.21,11.15 C0.0209507884,10.439385 -0.00978306746,9.70496373 0.0134887695,8.97 C0.0151209677,8.57934701 0.046882025,8.19132505 0.105842297,7.80829802 C0.356838025,8.14115024 0.644776978,8.44457697 0.963563817,8.71248288 Z M7.75701899,0.0676378654 C10.4429782,-0.230229129 13.6029152,0.669967054 15.6,2.78 L15.76,3.01 L15.76,1.77 C15.7293758,1.65477219 15.757788,1.53185666 15.835874,1.44175745 C15.91396,1.35165823 16.0315893,1.30606426 16.15,1.32 C16.2692691,1.3083815 16.3870308,1.35370294 16.4677376,1.44228352 C16.5484444,1.53086411 16.5826392,1.65232431 16.56,1.77 L16.56,4.18 C16.4912668,4.44326479 16.2246375,4.6032424 15.96,4.54 L13.79,4.54 C13.6704965,4.56026992 13.5480626,4.52792273 13.4541656,4.45127212 C13.3602686,4.37462152 13.304065,4.26114221 13.3,4.14 C13.3029876,4.01721061 13.3608673,3.90222847 13.4577157,3.82668674 C13.554564,3.75114501 13.6801782,3.72300191 13.8,3.75 L15.08,3.75 L14.92,3.59 L14.69,3.37 C13.0930122,1.73087939 10.909867,0.887023281 8.7064833,0.956436989 C8.42632657,0.624210695 8.10752874,0.325634595 7.75701899,0.0676378654 Z\"\n                          id=\"Combined-Shape\" fill=\"#286090\"></path>\n                    <path d=\"M9.43,6.35 L11.51,8.43 C11.6970723,8.57719336 11.9646521,8.56128819 12.1329701,8.39297015 C12.3012882,8.2246521 12.3171934,7.9570723 12.17,7.77 L9.29,4.89 C9.10700168,4.70955201 8.81299832,4.70955201 8.63,4.89 L5.75,7.77 C5.60280664,7.9570723 5.61871181,8.2246521 5.78702985,8.39297015 C5.9553479,8.56128819 6.2229277,8.57719336 6.41,8.43 L8.49,6.35 L8.49,12.79 C8.46317872,12.9724071 8.5454835,13.1536501 8.70047788,13.2534923 C8.85547225,13.3533345 9.05452775,13.3533345 9.20952212,13.2534923 C9.3645165,13.1536501 9.44682128,12.9724071 9.42,12.79 L9.43,6.35 Z\"\n                          id=\"Shape\" fill=\"#286090\"></path>\n                    <path d=\"M2.25741774,7.10542736e-16 L1.35647655,-1.77635684e-15 C1.15959816,-1.77635684e-15 1,0.159598159 1,0.35647655 C1,0.55335494 1.15959816,0.712953099 1.35647655,0.712953099 L2.25740103,0.712953099 C3.84222027,0.712953099 5.10926355,1.20221721 5.10926355,2.78703646 C5.10926355,4.3718557 3.84223698,4.86111981 2.25741774,4.86111981 L2.21711351,4.86111981 L3.03448802,4.0437453 C3.17369986,3.90453347 3.17369986,3.67881344 3.03448802,3.53960161 C2.89527618,3.40038977 2.66955616,3.40038977 2.53034432,3.53960161 L1.1044047,4.96552452 C1.09609978,4.97382943 1.08824603,4.98256882 1.08079333,4.99165911 C1.0675088,5.00942195 1.06358193,5.01438485 1.06003939,5.01968195 C1.04774075,5.03998472 1.04473294,5.04466355 1.04209274,5.04959302 C1.03188287,5.0708984 1.02932622,5.07594485 1.0271372,5.08120853 C1.01926674,5.1028314 1.01711114,5.10837915 1.01537329,5.11412743 C1.00972528,5.13618476 1.00808769,5.14198316 1.00690127,5.14794867 C1.00327518,5.17202792 1.00227257,5.17714121 1.00175456,5.18240489 C0.999448567,5.20579903 0.999448567,5.22937698 1.00175456,5.25277112 C1.00491277,5.27466135 1.00564801,5.28097777 1.00688456,5.28724406 C1.01254928,5.31028729 1.0137357,5.31571807 1.01535658,5.3210653 C1.02321033,5.34335657 1.02496489,5.34873722 1.0271372,5.35400091 C1.03686248,5.3748384 1.03926873,5.3803026 1.04210945,5.38561641 C1.05370626,5.40516723 1.05664724,5.41044762 1.06003939,5.41552749 C1.0744602,5.43507831 1.07740118,5.43942293 1.08079333,5.44355033 C1.0881959,5.45257378 1.09599952,5.46124632 1.1042376,5.4694844 C1.10430444,5.46955124 2.53032761,6.89559112 2.53032761,6.89559112 C2.66953945,7.03480296 2.89525947,7.03480296 3.03447131,6.89559112 C3.17368315,6.75637928 3.17368315,6.53065926 3.03447131,6.39144742 L2.2170968,5.57407291 L2.25740103,5.57407291 C4.23599376,5.57408962 5.82223336,4.76561248 5.82223336,2.78703646 C5.82223336,0.808460432 4.23599376,7.10542736e-16 2.25741774,7.10542736e-16 Z\"\n                          id=\"Shape\" fill=\"#EA8C04\" fill-rule=\"nonzero\"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>"

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var DeliveredTransferIcon = (function () {
	    function DeliveredTransferIcon() {
	    }
	    DeliveredTransferIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-delivered-transfer-icon',
	            template: __webpack_require__(1204)
	        })
	    ], DeliveredTransferIcon);
	    return DeliveredTransferIcon;
	}());
	exports.DeliveredTransferIcon = DeliveredTransferIcon;


/***/ }),
/* 1204 */
/***/ (function(module, exports) {

	module.exports = "<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">\n    <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->\n    <defs></defs>\n    <g id=\"UI-elements\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Artboard-2-Copy-3\" transform=\"translate(-428.000000, -227.000000)\" fill=\"#286090\">\n            <g id=\"Group-5-Copy\" transform=\"translate(39.000000, 194.000000)\">\n                <g id=\"Group-2-Copy-5\" transform=\"translate(389.000000, 33.000000)\">\n                    <path d=\"M9,1.73479406e-14 C4.02943725,1.73479406e-14 0,4.02943725 0,9 C0,13.9705627 4.02943725,18 9,18 C13.9705627,18 18,13.9705627 18,9 C18,4.02943725 13.9705627,0 9,0 L9,1.73479406e-14 Z M9.00011692,17 C5.76446625,17 2.84741858,15.0508911 1.60918868,12.0615396 C0.370958772,9.07218821 1.05539481,5.63129587 3.34334534,3.34334534 C5.63129587,1.05539481 9.07218821,0.370958772 12.0615396,1.60918868 C15.0508911,2.84741858 17,5.76446625 17,9.00011692 C17,13.4183303 13.4183303,17 9.00011692,17 L9.00011692,17 Z\"\n                          id=\"Shape-Copy-67\"></path>\n                    <polygon id=\"Rectangle\" points=\"8.83742911 7 9.78544241 7 9.78544241 9 8.83742911 9\"></polygon>\n                    <polygon id=\"Rectangle-Copy\" points=\"8.83742911 4 9.78544241 4 9.78544241 6 8.83742911 6\"></polygon>\n                    <path d=\"M9.78063367,11.3930763 L11.8606337,13.4730763 C12.047706,13.6202696 12.3152858,13.6043645 12.4836038,13.4360464 C12.6519219,13.2677284 12.667827,13.0001486 12.5206337,12.8130763 L9.64063367,9.93307629 C9.45763535,9.7526283 9.163632,9.7526283 8.98063367,9.93307629 L6.10063367,12.8130763 C5.95344032,13.0001486 5.96934548,13.2677284 6.13766353,13.4360464 C6.30598157,13.6043645 6.57356137,13.6202696 6.76063367,13.4730763 L8.84063367,11.3930763 L8.84063367,13.2965686 L9.77063367,13.2965686 L9.78063367,11.3930763 Z\"\n                          id=\"Shape-Copy-68\"\n                          transform=\"translate(9.310634, 11.685725) rotate(180.000000) translate(-9.310634, -11.685725) \"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>"

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var UndeliveredTransferIcon = (function () {
	    function UndeliveredTransferIcon() {
	    }
	    UndeliveredTransferIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-undelivered-transfer-icon',
	            template: __webpack_require__(1206)
	        })
	    ], UndeliveredTransferIcon);
	    return UndeliveredTransferIcon;
	}());
	exports.UndeliveredTransferIcon = UndeliveredTransferIcon;


/***/ }),
/* 1206 */
/***/ (function(module, exports) {

	module.exports = "<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">\n    <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->\n    <defs></defs>\n    <g id=\"UI-elements\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Artboard-2-Copy-3\" transform=\"translate(-370.000000, -227.000000)\">\n            <g id=\"Group-5-Copy\" transform=\"translate(39.000000, 194.000000)\">\n                <g id=\"Group-3-Copy-5\" transform=\"translate(331.000000, 33.000000)\">\n                    <path d=\"M9.48361134,0.0127716132 C14.2293164,0.264049367 18,4.19167951 18,9 C18,13.9705627 13.9705627,18 9,18 C4.02943725,18 0,13.9705627 0,9 C0,8.48829787 0.0427039183,7.98656977 0.124742327,7.49818514 C0.384821361,7.86000489 0.684182965,8.19169126 1.0165848,8.48700191 C0.939391376,9.68422752 1.13079064,10.9065846 1.60918868,12.0615396 C2.84741858,15.0508911 5.76446625,17 9.00011692,17 L9.00011692,17 C13.4183303,17 17,13.4183303 17,9.00011692 C17,5.76446625 15.0508911,2.84741858 12.0615396,1.60918868 C11.4721771,1.36506673 10.8652633,1.19567821 10.253094,1.09857736 C10.0368534,0.707903199 9.77829745,0.343906176 9.48361134,0.0127716132 Z\"\n                          id=\"Combined-Shape\" fill=\"#286090\"></path>\n                    <path d=\"M9.78063367,6.59533599 L11.8606337,8.67533599 C12.047706,8.82252935 12.3152858,8.80662418 12.4836038,8.63830614 C12.6519219,8.46998809 12.667827,8.20240829 12.5206337,8.01533599 L9.64063367,5.13533599 C9.45763535,4.954888 9.163632,4.954888 8.98063367,5.13533599 L6.10063367,8.01533599 C5.95344032,8.20240829 5.96934548,8.46998809 6.13766353,8.63830614 C6.30598157,8.80662418 6.57356137,8.82252935 6.76063367,8.67533599 L8.84063367,6.59533599 L8.84063367,13.035336 C8.81381239,13.2177431 8.89611718,13.398986 9.05111155,13.4988283 C9.20610593,13.5986705 9.40516142,13.5986705 9.5601558,13.4988283 C9.71515017,13.398986 9.79745496,13.2177431 9.77063367,13.035336 L9.78063367,6.59533599 Z\"\n                          id=\"Shape-Copy-64\" fill=\"#286090\"\n                          transform=\"translate(9.310634, 9.286855) rotate(180.000000) translate(-9.310634, -9.286855) \"></path>\n                    <path d=\"M3.67823697,2.9999201 L5.85952632,0.818697563 C6.04682456,0.631402317 6.04682456,0.32776668 5.85952632,0.140471434 C5.67222808,-0.0468238114 5.36858759,-0.0468238114 5.18128935,0.140471434 L3,2.32169397 L0.818710647,0.141110667 C0.631412408,-0.0461845785 0.327771918,-0.0461845785 0.140473679,0.141110667 C-0.0468245597,0.328405913 -0.0468245597,0.63204155 0.140473679,0.819336796 L2.32176303,3.00055933 L0.141112922,5.18114263 C-0.0461853166,5.36843787 -0.0461853166,5.67207351 0.141112922,5.85936876 C0.235081663,5.95269676 0.357177102,6 0.479911784,6 C0.602646467,6 0.725381149,5.953336 0.818710647,5.85936876 L3,3.67814622 L5.18128935,5.85936876 C5.27525809,5.95269676 5.39735353,6 5.52008822,6 C5.6428229,6 5.76555758,5.953336 5.85888708,5.85936876 C6.04618532,5.67207351 6.04618532,5.36843787 5.85888708,5.18114263 L3.67823697,2.9999201 Z\"\n                          id=\"Shape\" fill=\"#F47676\" fill-rule=\"nonzero\"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>"

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var Incoming4TransferIcon = (function () {
	    function Incoming4TransferIcon() {
	    }
	    Incoming4TransferIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-incoming-4-transfer-icon',
	            template: __webpack_require__(1208)
	        })
	    ], Incoming4TransferIcon);
	    return Incoming4TransferIcon;
	}());
	exports.Incoming4TransferIcon = Incoming4TransferIcon;


/***/ }),
/* 1208 */
/***/ (function(module, exports) {

	module.exports = "<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">\n    <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->\n    <defs></defs>\n    <g id=\"UI-elements\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Artboard-2-Copy-3\" transform=\"translate(-400.000000, -227.000000)\">\n            <g id=\"Group-5-Copy\" transform=\"translate(39.000000, 194.000000)\">\n                <g id=\"Group-3-Copy-6\" transform=\"translate(361.000000, 33.000000)\">\n                    <path d=\"M10.4555218,0.117090446 C14.733955,0.812796697 18,4.5249855 18,9 C18,13.9705627 13.9705627,18 9,18 C4.02943725,18 0,13.9705627 0,9 C0,8.45325628 0.0487529488,7.91789941 0.142148713,7.39803954 C0.400396212,7.74433355 0.697024802,8.06434836 1.02636646,8.35285194 C0.92548305,9.59274769 1.11290769,10.8634113 1.60918868,12.0615396 C2.84741858,15.0508911 5.76446625,17 9.00011692,17 C13.4183303,17 17,13.4183303 17,9.00011692 C17,5.76446625 15.0508911,2.84741858 12.0615396,1.60918868 C11.8209779,1.50954476 11.5774921,1.4223518 11.3319183,1.34744349 C11.0945027,0.903523495 10.7993532,0.490620624 10.4555218,0.117090446 Z\"\n                          id=\"Combined-Shape\" fill=\"#286090\"></path>\n                    <path d=\"M9.78063367,6.59533599 L11.8606337,8.67533599 C12.047706,8.82252935 12.3152858,8.80662418 12.4836038,8.63830614 C12.6519219,8.46998809 12.667827,8.20240829 12.5206337,8.01533599 L9.64063367,5.13533599 C9.45763535,4.954888 9.163632,4.954888 8.98063367,5.13533599 L6.10063367,8.01533599 C5.95344032,8.20240829 5.96934548,8.46998809 6.13766353,8.63830614 C6.30598157,8.80662418 6.57356137,8.82252935 6.76063367,8.67533599 L8.84063367,6.59533599 L8.84063367,13.035336 C8.81381239,13.2177431 8.89611718,13.398986 9.05111155,13.4988283 C9.20610593,13.5986705 9.40516142,13.5986705 9.5601558,13.4988283 C9.71515017,13.398986 9.79745496,13.2177431 9.77063367,13.035336 L9.78063367,6.59533599 Z\"\n                          id=\"Shape-Copy-64\" fill=\"#286090\"\n                          transform=\"translate(9.310634, 9.286855) rotate(180.000000) translate(-9.310634, -9.286855) \"></path>\n                    <path d=\"M3.09449916,6 C3.12580924,6 3.15782556,5.98765821 3.18960647,5.98085763 C3.21267705,5.9848876 3.23504139,5.99697752 3.25834739,5.99697752 C3.39371052,5.99697752 3.52530702,5.93426107 3.61758936,5.8254518 L7.86139993,0.863673572 C8.04620002,0.666204899 8.04620002,0.345822052 7.86139993,0.148101505 C7.67683525,-0.0493671683 7.37738847,-0.0493671683 7.19282379,0.148101505 L3.18301487,4.85926579 L0.807176207,2.24815818 C0.622611527,2.05043763 0.323164751,2.05043763 0.138600071,2.24815818 C-0.0462000235,2.44562685 -0.0462000235,2.7660097 0.138600071,2.96373024 L2.71430533,5.78893017 C2.80117315,5.92343051 2.94383411,6 3.09449916,6 Z\"\n                          id=\"Shape\" fill=\"#48CE90\" fill-rule=\"nonzero\"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>"

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var RefundTransferIcon = (function () {
	    function RefundTransferIcon() {
	    }
	    RefundTransferIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-refund-transfer-icon',
	            template: __webpack_require__(1210)
	        })
	    ], RefundTransferIcon);
	    return RefundTransferIcon;
	}());
	exports.RefundTransferIcon = RefundTransferIcon;


/***/ }),
/* 1210 */
/***/ (function(module, exports) {

	module.exports = "<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">\n    <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->\n    <defs></defs>\n    <g id=\"UI-elements\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Artboard-2-Copy-3\" transform=\"translate(-342.000000, -227.000000)\" fill=\"#286090\">\n            <g id=\"Group-5-Copy\" transform=\"translate(39.000000, 194.000000)\">\n                <g id=\"Group-Copy\" transform=\"translate(303.000000, 33.000000)\">\n                    <path d=\"M9,1.73479406e-14 C4.02943725,1.73479406e-14 0,4.02943725 0,9 C0,13.9705627 4.02943725,18 9,18 C13.9705627,18 18,13.9705627 18,9 C18,4.02943725 13.9705627,0 9,0 L9,1.73479406e-14 Z M9.00011692,17 C5.76446625,17 2.84741858,15.0508911 1.60918868,12.0615396 C0.370958772,9.07218821 1.05539481,5.63129587 3.34334534,3.34334534 C5.63129587,1.05539481 9.07218821,0.370958772 12.0615396,1.60918868 C15.0508911,2.84741858 17,5.76446625 17,9.00011692 C17,13.4183303 13.4183303,17 9.00011692,17 L9.00011692,17 Z\"\n                          id=\"Shape-Copy-66\"></path>\n                    <path d=\"M8.41667383,5 L5.45832617,5 C5.20519727,5 5,5.20519727 5,5.45832617 C5,5.71145508 5.20519727,5.91665234 5.45832617,5.91665234 L8.41665234,5.91665234 C10.4542734,5.91665234 12.0833262,6.54570508 12.0833262,8.58332617 C12.0833262,10.6209473 10.4542949,11.25 8.41667383,11.25 L6.56485742,11.25 L7.61576562,10.1990918 C7.79475195,10.0201055 7.79475195,9.72989453 7.61576562,9.5509082 C7.4367793,9.37192188 7.14656836,9.37192188 6.96758203,9.5509082 L5.13423438,11.3842344 C5.12355664,11.3949121 5.11345898,11.4061484 5.10387695,11.4178359 C5.08679688,11.4406738 5.08174805,11.4470547 5.07719336,11.4538652 C5.06138086,11.4799688 5.05751367,11.4859844 5.05411914,11.4923223 C5.04099219,11.5197148 5.03770508,11.5262031 5.03489062,11.5329707 C5.02477148,11.5607715 5.022,11.5679043 5.01976562,11.5752949 C5.01250391,11.6036543 5.01039844,11.6111094 5.00887305,11.6187793 C5.00421094,11.6497383 5.00292188,11.6563125 5.00225586,11.6630801 C4.99929102,11.6931582 4.99929102,11.7234727 5.00225586,11.7535508 C5.00631641,11.7816953 5.00726172,11.7898164 5.00885156,11.797873 C5.01613477,11.8275 5.01766016,11.8344824 5.01974414,11.8413574 C5.0298418,11.8700176 5.03209766,11.8769355 5.03489062,11.8837031 C5.04739453,11.9104941 5.05048828,11.9175195 5.05414062,11.9243516 C5.06905078,11.9494883 5.07283203,11.9562773 5.07719336,11.9628086 C5.09573438,11.9879453 5.09951563,11.9935313 5.10387695,11.9988379 C5.11339453,12.0104395 5.12342773,12.0215898 5.13401953,12.0321816 C5.13410547,12.0322676 6.96756055,13.8657441 6.96756055,13.8657441 C7.14654688,14.0447305 7.43675781,14.0447305 7.61574414,13.8657441 C7.79473047,13.6867578 7.79473047,13.3965469 7.61574414,13.2175605 L6.56483594,12.1666523 L8.41665234,12.1666523 C10.9605527,12.1666738 13,11.1272051 13,8.58332617 C13,6.03944727 10.9605527,5 8.41667383,5 Z\"\n                          id=\"Shape\" fill-rule=\"nonzero\"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>"

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var OutgoingTransferIcon = (function () {
	    function OutgoingTransferIcon() {
	    }
	    OutgoingTransferIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-outgoing-transfer-icon',
	            template: __webpack_require__(1212)
	        })
	    ], OutgoingTransferIcon);
	    return OutgoingTransferIcon;
	}());
	exports.OutgoingTransferIcon = OutgoingTransferIcon;


/***/ }),
/* 1212 */
/***/ (function(module, exports) {

	module.exports = "<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">\n    <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->\n    <defs></defs>\n    <g id=\"UI-elements\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Artboard-2-Copy-3\" transform=\"translate(-166.000000, -227.000000)\" fill=\"#286090\">\n            <g id=\"Group-5-Copy\" transform=\"translate(39.000000, 194.000000)\">\n                <g id=\"Group-8\" transform=\"translate(127.000000, 33.000000)\">\n                    <path d=\"M9,1.73479406e-14 C4.02943725,1.73479406e-14 0,4.02943725 0,9 C0,13.9705627 4.02943725,18 9,18 C13.9705627,18 18,13.9705627 18,9 C18,4.02943725 13.9705627,0 9,0 L9,1.73479406e-14 Z M9.00011692,17 C5.76446625,17 2.84741858,15.0508911 1.60918868,12.0615396 C0.370958772,9.07218821 1.05539481,5.63129587 3.34334534,3.34334534 C5.63129587,1.05539481 9.07218821,0.370958772 12.0615396,1.60918868 C15.0508911,2.84741858 17,5.76446625 17,9.00011692 C17,13.4183303 13.4183303,17 9.00011692,17 L9.00011692,17 Z\"\n                          id=\"Shape-Copy-55\"></path>\n                    <path d=\"M9.78063367,11.595336 L9.78063367,6.59533599 L11.8606337,8.67533599 C12.047706,8.82252935 12.3152858,8.80662418 12.4836038,8.63830614 C12.6519219,8.46998809 12.667827,8.20240829 12.5206337,8.01533599 L9.64063367,5.13533599 C9.45763535,4.954888 9.163632,4.954888 8.98063367,5.13533599 L6.10063367,8.01533599 C5.95344032,8.20240829 5.96934548,8.46998809 6.13766353,8.63830614 C6.30598157,8.80662418 6.57356137,8.82252935 6.76063367,8.67533599 L8.84063367,6.59533599 L8.84063367,13.035336 C8.81381239,13.2177431 8.89611718,13.398986 9.05111155,13.4988283 C9.20610593,13.5986705 9.40516142,13.5986705 9.5601558,13.4988283 C9.71515017,13.398986 9.79745496,13.2177431 9.77063367,13.035336 L9.78063367,11.595336 Z\"\n                          id=\"Shape\"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>"

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var InternalExchangeTransferIcon = (function () {
	    function InternalExchangeTransferIcon() {
	    }
	    InternalExchangeTransferIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-internal-exchange-transfer-icon',
	            template: __webpack_require__(1214)
	        })
	    ], InternalExchangeTransferIcon);
	    return InternalExchangeTransferIcon;
	}());
	exports.InternalExchangeTransferIcon = InternalExchangeTransferIcon;


/***/ }),
/* 1214 */
/***/ (function(module, exports) {

	module.exports = "<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">\n    <!-- Generator: Sketch 42 (36781) - http://www.bohemiancoding.com/sketch -->\n    <defs></defs>\n    <g id=\"UI-elements\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Artboard-2-Copy-3\" transform=\"translate(-517.000000, -227.000000)\" fill=\"#286090\">\n            <g id=\"Group-5-Copy\" transform=\"translate(39.000000, 194.000000)\">\n                <g id=\"9-copy-9\" transform=\"translate(478.000000, 33.000000)\">\n                    <path d=\"M17.67,6.71 C17.5689964,6.47412842 17.2974863,6.3628538 17.06,6.46 C16.8011398,6.55019221 16.65675,6.8258453 16.73,7.09 C17.5848767,10.5958953 15.9868016,14.2401112 12.828781,15.9862558 C9.67076031,17.7324005 5.73466931,17.1481565 3.22,14.56 L2.99,14.34 L2.83,14.18 L4.11,14.18 C4.2298218,14.2069981 4.35543597,14.178855 4.45228434,14.1033133 C4.54913272,14.0277715 4.60701243,13.9127894 4.61,13.79 C4.60593496,13.6688578 4.54973138,13.5553785 4.45583439,13.4787279 C4.3619374,13.4020773 4.23950352,13.3697301 4.12,13.39 L2.01,13.39 C1.74536251,13.3267576 1.47873317,13.4867352 1.41,13.75 L1.41,16.14 C1.37726771,16.2556303 1.40273169,16.3799548 1.4782877,16.4734057 C1.55384371,16.5668565 1.67007892,16.6177916 1.79,16.61 C1.90883879,16.6242393 2.02744112,16.5816571 2.11008335,16.4950796 C2.19272558,16.408502 2.22974827,16.2880484 2.21,16.17 L2.21,14.97 L2.32,15.11 C4.87434074,17.7516686 8.76681224,18.597829 12.1873193,17.2549957 C15.6078263,15.9121623 17.8850401,12.6438877 17.96,8.97 C17.9696361,8.20680376 17.8720156,7.4460374 17.67,6.71 L17.67,6.71 Z\"\n                          id=\"Shape\"></path>\n                    <path d=\"M5.93869311,1.54517972 C8.95524203,0.314832015 12.4165657,1.03658634 14.69,3.37 L14.92,3.59 L15.08,3.75 L13.8,3.75 C13.6801782,3.72300191 13.554564,3.75114501 13.4577157,3.82668674 C13.3608673,3.90222847 13.3029876,4.01721061 13.3,4.14 C13.304065,4.26114221 13.3602686,4.37462152 13.4541656,4.45127212 C13.5480626,4.52792273 13.6704965,4.56026992 13.79,4.54 L15.96,4.54 C16.2246375,4.6032424 16.4912668,4.44326479 16.56,4.18 L16.56,1.77 C16.5826392,1.65232431 16.5484444,1.53086411 16.4677376,1.44228352 C16.3870308,1.35370294 16.2692691,1.3083815 16.15,1.32 C16.0315893,1.30606426 15.91396,1.35165823 15.835874,1.44175745 C15.757788,1.53185666 15.7293758,1.65477219 15.76,1.77 L15.76,3.01 L15.6,2.78 C13.054617,0.0906590656 8.80923462,-0.645172119 5.68579002,0.583651997 C2.56234541,1.81247611 0.0291734818,5.26712411 0.0137023926,8.97 C-0.00956944441,9.70496373 0.0209507884,10.439385 0.21,11.15 C0.296014525,11.4124303 0.57528924,11.5587171 0.84,11.48 C1.0948789,11.3858546 1.23430885,11.1113519 1.16,10.85 C1.01925856,10.2334414 0.952123195,9.60236903 0.96,8.97 C0.952967647,5.71219807 2.92214419,2.77552742 5.93869311,1.54517972 Z\"\n                          id=\"Shape\"></path>\n                    <path d=\"M11.7806337,9.59533599 L12.8606337,10.675336 C13.047706,10.8225293 13.3152858,10.8066242 13.4836038,10.6383061 C13.6519219,10.4699881 13.667827,10.2024083 13.5206337,10.015336 L11.6406337,8.13533599 C11.4576354,7.954888 11.163632,7.954888 10.9806337,8.13533599 L9.10063367,10.015336 C8.95344032,10.2024083 8.96934548,10.4699881 9.13766353,10.6383061 C9.30598157,10.8066242 9.57356137,10.8225293 9.76063367,10.675336 L10.8406337,9.59533599 L10.8406337,14.035336 C10.8138124,14.2177431 10.8961172,14.398986 11.0511116,14.4988283 C11.2061059,14.5986705 11.4051614,14.5986705 11.5601558,14.4988283 C11.7151502,14.398986 11.797455,14.2177431 11.7706337,14.035336 L11.7806337,9.59533599 Z\"\n                          id=\"Shape-Copy-76\"></path>\n                    <path d=\"M6.78063367,5.59533599 L7.86063367,6.67533599 C8.04770598,6.82252935 8.31528578,6.80662418 8.48360382,6.63830614 C8.65192187,6.46998809 8.66782703,6.20240829 8.52063367,6.01533599 L6.64063367,4.13533599 C6.45763535,3.954888 6.163632,3.954888 5.98063367,4.13533599 L4.10063367,6.01533599 C3.95344032,6.20240829 3.96934548,6.46998809 4.13766353,6.63830614 C4.30598157,6.80662418 4.57356137,6.82252935 4.76063367,6.67533599 L5.84063367,5.59533599 L5.84063367,10.035336 C5.81381239,10.2177431 5.89611718,10.398986 6.05111155,10.4988283 C6.20610593,10.5986705 6.40516142,10.5986705 6.5601558,10.4988283 C6.71515017,10.398986 6.79745496,10.2177431 6.77063367,10.035336 L6.78063367,5.59533599 Z\"\n                          id=\"Shape-Copy-77\"\n                          transform=\"translate(6.310634, 7.286855) rotate(180.000000) translate(-6.310634, -7.286855) \"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>"

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var SystemTransferIcon = (function () {
	    function SystemTransferIcon() {
	    }
	    SystemTransferIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-system-transfer-icon',
	            template: "\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\">\n            <g fill=\"none\" fill-rule=\"evenodd\">\n                <g fill=\"#286090\">\n                    <path d=\"M9.773 1.037A5.532 5.532 0 0 0 8.671.006a9 9 0 1 1-8.31 6.46c.183.477.43.922.731 1.324a8 8 0 1 0 8.681-6.753z\"/>\n                    <path d=\"M9.78 6.595l2.08 2.08a.47.47 0 0 0 .66-.66l-2.88-2.88a.47.47 0 0 0-.66 0L6.1 8.015a.47.47 0 0 0 .66.66l2.08-2.08v6.44a.47.47 0 1 0 .93 0l.01-6.44z\"/>\n                </g>\n                <path fill=\"#EA8C05\" d=\"M2 4.368C2.088 5.357 3.066 6 4.483 6 6.012 6 6.98 5.329 6.98 4.277c0-.842-.556-1.303-1.941-1.6l-.7-.16c-.921-.202-1.287-.46-1.287-.909 0-.58.588-.96 1.477-.96.834 0 1.4.349 1.515.936h.839C6.813.66 5.85 0 4.557 0 3.144 0 2.195.66 2.195 1.632c0 .814.523 1.283 1.732 1.545l.857.19c.922.199 1.34.509 1.34.997 0 .568-.663.985-1.562.985-.95 0-1.617-.381-1.719-.981H2z\"/>\n            </g>\n        </svg>\n    "
	        })
	    ], SystemTransferIcon);
	    return SystemTransferIcon;
	}());
	exports.SystemTransferIcon = SystemTransferIcon;


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var SystemExchangeTransferIcon = (function () {
	    function SystemExchangeTransferIcon() {
	    }
	    SystemExchangeTransferIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-system-exchange-transfer-icon',
	            template: "\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\">\n            <g fill=\"none\" fill-rule=\"evenodd\">\n                <path fill=\"#286090\" fill-rule=\"nonzero\" d=\"M17.67 6.71a.47.47 0 0 0-.61-.25.52.52 0 0 0-.33.63 8 8 0 0 1-13.51 7.47l-.23-.22-.16-.16h1.28a.41.41 0 0 0 .5-.39.42.42 0 0 0-.49-.4H2.01a.5.5 0 0 0-.6.36v2.39a.37.37 0 0 0 .38.47.38.38 0 0 0 .42-.44v-1.2l.11.14a9.1 9.1 0 0 0 15.64-6.14 8.15 8.15 0 0 0-.29-2.26zM.964 8.712a8.046 8.046 0 0 0-.004.258 8 8 0 0 0 .2 1.88.52.52 0 0 1-.32.63.51.51 0 0 1-.63-.33c-.189-.71-.22-1.445-.197-2.18a7.85 7.85 0 0 1 .093-1.162c.25.333.539.637.858.904zM7.757.068C10.443-.23 13.603.67 15.6 2.78l.16.23V1.77a.36.36 0 0 1 .39-.45.38.38 0 0 1 .41.45v2.41a.5.5 0 0 1-.6.36h-2.17a.42.42 0 0 1-.49-.4.41.41 0 0 1 .5-.39h1.28l-.16-.16-.23-.22A8 8 0 0 0 8.706.956a5.532 5.532 0 0 0-.949-.888z\"/>\n                <path fill=\"#286090\" fill-rule=\"nonzero\" d=\"M9.43 6.35l2.08 2.08a.47.47 0 0 0 .66-.66L9.29 4.89a.47.47 0 0 0-.66 0L5.75 7.77a.47.47 0 0 0 .66.66l2.08-2.08v6.44a.47.47 0 1 0 .93 0l.01-6.44z\"/>\n                <path fill=\"#EA8C05\" d=\"M0 4.368C.088 5.357 1.066 6 2.483 6 4.012 6 4.98 5.329 4.98 4.277c0-.842-.556-1.303-1.941-1.6l-.7-.16c-.921-.202-1.287-.46-1.287-.909 0-.58.588-.96 1.477-.96.834 0 1.4.349 1.515.936h.839C4.813.66 3.85 0 2.557 0 1.144 0 .195.66.195 1.632c0 .814.523 1.283 1.732 1.545l.857.19c.922.199 1.34.509 1.34.997 0 .568-.663.985-1.562.985-.95 0-1.617-.381-1.719-.981H0z\"/>\n            </g>\n        </svg>\n    "
	        })
	    ], SystemExchangeTransferIcon);
	    return SystemExchangeTransferIcon;
	}());
	exports.SystemExchangeTransferIcon = SystemExchangeTransferIcon;


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var CardExchangeTransferIcon = (function () {
	    function CardExchangeTransferIcon() {
	    }
	    CardExchangeTransferIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-card-exchange-transfer-icon',
	            template: __webpack_require__(1218)
	        })
	    ], CardExchangeTransferIcon);
	    return CardExchangeTransferIcon;
	}());
	exports.CardExchangeTransferIcon = CardExchangeTransferIcon;


/***/ }),
/* 1218 */
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" width=\"28px\" height=\"28px\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.95 17.88\">\n    <defs>\n        <style>.cls-1 {\n            fill: #286090;\n        }\n\n        .cls-2 {\n            fill: #48CE90;\n        }</style>\n    </defs>\n    <path id=\"Shape\" class=\"cls-1\"\n          d=\"M665.8,89.41a0.47,0.47,0,0,0-.61-0.25,0.52,0.52,0,0,0-.33.63,8,8,0,0,1-13.51,7.47L651.12,97,651,96.88h1.28a0.41,0.41,0,0,0,.5-0.39,0.42,0.42,0,0,0-.49-0.4h-2.11a0.5,0.5,0,0,0-.6.36v2.39a0.37,0.37,0,0,0,.38.47,0.38,0.38,0,0,0,.42-0.44v-1.2l0.11,0.14a9.1,9.1,0,0,0,15.64-6.14,8.15,8.15,0,0,0-.29-2.26h0Z\"\n          transform=\"translate(-648.14 -82.7)\"/>\n    <path id=\"Shape-2\" data-name=\"Shape\" class=\"cls-1\"\n          d=\"M654.07,84.24a8,8,0,0,1,8.75,1.82l0.23,0.22,0.16,0.16h-1.28a0.41,0.41,0,0,0-.5.39,0.42,0.42,0,0,0,.49.4h2.17a0.5,0.5,0,0,0,.6-0.36V84.47a0.38,0.38,0,0,0-.41-0.45,0.36,0.36,0,0,0-.39.45v1.24l-0.16-.23a9,9,0,0,0-15.59,6.19,7.51,7.51,0,0,0,.2,2.18,0.51,0.51,0,0,0,.63.33,0.52,0.52,0,0,0,.32-0.63A8.15,8.15,0,0,1,654.07,84.24Z\"\n          transform=\"translate(-648.14 -82.7)\"/>\n    <path class=\"cls-2\"\n          d=\"M656,88.52l0.86,0.86a0.36,0.36,0,0,0,.5,0l0.86-.86,0.56-.56a0.36,0.36,0,0,0-.5-0.5l-0.82.82V86.1a0.36,0.36,0,1,0-.71,0v2.18l-0.82-.82a0.36,0.36,0,0,0-.5.5Z\"\n          transform=\"translate(-648.14 -82.7)\"/>\n    <path class=\"cls-1\"\n          d=\"M661.54,89.1a1,1,0,0,0-.19-0.3,0.85,0.85,0,0,0-.31-0.21,0.94,0.94,0,0,0-.37-0.07h-1.38l-0.53.53-0.34.34h2.25a0.2,0.2,0,0,1,.07.07v0.9h-7.24V89.44l0.06,0h2.25L655.47,89l-0.53-.53h-1.38a0.94,0.94,0,0,0-.37.07,0.86,0.86,0,0,0-.31.21,1,1,0,0,0-.19.29,0.88,0.88,0,0,0-.08.36v5.09a0.87,0.87,0,0,0,.08.36,1,1,0,0,0,.19.29,0.87,0.87,0,0,0,.31.22,1,1,0,0,0,.36.07h7.11a1,1,0,0,0,.36-0.07,0.85,0.85,0,0,0,.31-0.21,1,1,0,0,0,.19-0.3,0.87,0.87,0,0,0,.08-0.36V89.46A0.87,0.87,0,0,0,661.54,89.1Zm-0.8,5.45v0l-0.06,0h-7.1a0.2,0.2,0,0,1-.07-0.07v-2.3h7.24v2.3Z\"\n          transform=\"translate(-648.14 -82.7)\"/>\n</svg>"

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var CardTransferIcon = (function () {
	    function CardTransferIcon() {
	    }
	    CardTransferIcon = __decorate([
	        core_1.Component({
	            selector: 'tfl-card-transfer-icon',
	            template: __webpack_require__(1220)
	        })
	    ], CardTransferIcon);
	    return CardTransferIcon;
	}());
	exports.CardTransferIcon = CardTransferIcon;


/***/ }),
/* 1220 */
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" width=\"28px\" height=\"28px\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\">\n    <defs>\n        <style>.cls-1 {\n            fill: #286090;\n        }\n\n        .cls-2 {\n            fill: #48CE90;\n        }</style>\n    </defs>\n    <path id=\"Shape-Copy-67\" class=\"cls-1\"\n          d=\"M626.92,82.64a9,9,0,1,0,9,9,9,9,0,0,0-9-9h0Zm0,17a8,8,0,1,1,8-8,8,8,0,0,1-8,8h0Z\"\n          transform=\"translate(-617.92 -82.64)\"/>\n    <path class=\"cls-1\" d=\"M626.92,89.48a0.36,0.36,0,0,0,.23-0.09h-0.45A0.36,0.36,0,0,0,626.92,89.48Z\"\n          transform=\"translate(-617.92 -82.64)\"/>\n    <path class=\"cls-2\"\n          d=\"M628,88.52l0.56-.56a0.36,0.36,0,0,0-.5-0.5l-0.82.82V86.1a0.36,0.36,0,1,0-.71,0v2.18l-0.82-.82a0.36,0.36,0,0,0-.5.5l0.56,0.56,0.86,0.86a0.36,0.36,0,0,0,.5,0Z\"\n          transform=\"translate(-617.92 -82.64)\"/>\n    <path class=\"cls-1\"\n          d=\"M631.34,89.1a1,1,0,0,0-.19-0.3,0.85,0.85,0,0,0-.31-0.21,0.94,0.94,0,0,0-.37-0.07h-1.38l-0.53.53-0.34.34h2.25a0.2,0.2,0,0,1,.07.07v0.9H623.3V89.44l0.06,0h2.25L625.27,89l-0.53-.53h-1.38a0.94,0.94,0,0,0-.37.07,0.86,0.86,0,0,0-.31.21,1,1,0,0,0-.19.29,0.88,0.88,0,0,0-.08.36v5.09a0.87,0.87,0,0,0,.08.36,1,1,0,0,0,.19.29,0.87,0.87,0,0,0,.31.22,1,1,0,0,0,.36.07h7.11a1,1,0,0,0,.36-0.07,0.85,0.85,0,0,0,.31-0.21,1,1,0,0,0,.19-0.3,0.87,0.87,0,0,0,.08-0.36V89.46A0.87,0.87,0,0,0,631.34,89.1Zm-0.8,5.45v0l-0.06,0h-7.1a0.2,0.2,0,0,1-.07-0.07v-2.3h7.24v2.3Z\"\n          transform=\"translate(-617.92 -82.64)\"/>\n</svg>"

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1222));
	__export(__webpack_require__(1229));


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var ng2_daterangepicker_1 = __webpack_require__(1223);
	var translate_1 = __webpack_require__(302);
	var date_range_picker_component_1 = __webpack_require__(1228);
	var forms_1 = __webpack_require__(768);
	var common_1 = __webpack_require__(246);
	var core_2 = __webpack_require__(252);
	exports.DATE_FORMAT = 'DD.MM.YYYY';
	var DateRangePickerModule = (function () {
	    function DateRangePickerModule(translations, daterangepickerOptions) {
	        daterangepickerOptions.settings = {
	            opens: 'down',
	            drops: 'down',
	            showDropdowns: true,
	            locale: {
	                format: exports.DATE_FORMAT,
	                firstDay: 1,
	                cancelLabel: translations.getValue('COMMON.CLEAR')
	            },
	            alwaysShowCalendars: false
	        };
	    }
	    DateRangePickerModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                common_1.CommonModule,
	                forms_1.FormsModule,
	                core_2.TranslateModule,
	                ng2_daterangepicker_1.Daterangepicker
	            ],
	            declarations: [
	                date_range_picker_component_1.DateRangePickerComponent
	            ],
	            exports: [
	                ng2_daterangepicker_1.Daterangepicker,
	                date_range_picker_component_1.DateRangePickerComponent
	            ]
	        }),
	        __metadata("design:paramtypes", [translate_1.TranslateManager,
	            ng2_daterangepicker_1.DaterangepickerConfig])
	    ], DateRangePickerModule);
	    return DateRangePickerModule;
	}());
	exports.DateRangePickerModule = DateRangePickerModule;


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	exports.Daterangepicker = __webpack_require__(1224).Daterangepicker;
	exports.DaterangePickerComponent = __webpack_require__(1225).DaterangePickerComponent;
	exports.DaterangepickerConfig = __webpack_require__(1226).DaterangepickerConfig;


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var daterangepicker_component_1 = __webpack_require__(1225);
	var config_service_1 = __webpack_require__(1226);
	var Daterangepicker = (function () {
	    function Daterangepicker() {
	    }
	    Daterangepicker.decorators = [
	        { type: core_1.NgModule, args: [{
	                    declarations: [daterangepicker_component_1.DaterangePickerComponent],
	                    providers: [config_service_1.DaterangepickerConfig],
	                    exports: [daterangepicker_component_1.DaterangePickerComponent]
	                },] },
	    ];
	    Daterangepicker.ctorParameters = function () { return []; };
	    return Daterangepicker;
	}());
	exports.Daterangepicker = Daterangepicker;
	//# sourceMappingURL=daterangepicker.module.js.map

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var core_2 = __webpack_require__(205);
	var config_service_1 = __webpack_require__(1226);
	var $ = __webpack_require__(954);
	__webpack_require__(1227);
	var DaterangePickerComponent = (function () {
	    function DaterangePickerComponent(input, config, differs) {
	        this.input = input;
	        this.config = config;
	        this.differs = differs;
	        this.targetOptions = {};
	        this._differ = {};
	        this.options = {};
	        this.selected = new core_1.EventEmitter();
	        this.cancelDaterangepicker = new core_1.EventEmitter();
	        this.applyDaterangepicker = new core_1.EventEmitter();
	        this.hideCalendarDaterangepicker = new core_1.EventEmitter();
	        this.showCalendarDaterangepicker = new core_1.EventEmitter();
	        this.hideDaterangepicker = new core_1.EventEmitter();
	        this.showDaterangepicker = new core_1.EventEmitter();
	        this._differ['options'] = differs.find(this.options).create(null);
	        this._differ['settings'] = differs.find(this.config.settings).create(null);
	    }
	    DaterangePickerComponent.prototype.ngAfterViewInit = function () {
	        this.config.embedCSS();
	        this.render();
	        this.attachEvents();
	    };
	    DaterangePickerComponent.prototype.render = function () {
	        this.targetOptions = Object.assign({}, this.config.settings, this.options);
	        $(this.input.nativeElement).daterangepicker(this.targetOptions, this.callback.bind(this));
	        this.datePicker = $(this.input.nativeElement).data('daterangepicker');
	    };
	    DaterangePickerComponent.prototype.attachEvents = function () {
	        var _this = this;
	        $(this.input.nativeElement).on('cancel.daterangepicker', function (e, picker) {
	            var event = { event: e, picker: picker };
	            _this.cancelDaterangepicker.emit(event);
	        });
	        $(this.input.nativeElement).on('apply.daterangepicker', function (e, picker) {
	            var event = { event: e, picker: picker };
	            _this.applyDaterangepicker.emit(event);
	        });
	        $(this.input.nativeElement).on('hideCalendar.daterangepicker', function (e, picker) {
	            var event = { event: e, picker: picker };
	            _this.hideCalendarDaterangepicker.emit(event);
	        });
	        $(this.input.nativeElement).on('showCalendar.daterangepicker', function (e, picker) {
	            var event = { event: e, picker: picker };
	            _this.showCalendarDaterangepicker.emit(event);
	        });
	        $(this.input.nativeElement).on('hide.daterangepicker', function (e, picker) {
	            var event = { event: e, picker: picker };
	            _this.hideDaterangepicker.emit(event);
	        });
	        $(this.input.nativeElement).on('show.daterangepicker', function (e, picker) {
	            var event = { event: e, picker: picker };
	            _this.showDaterangepicker.emit(event);
	        });
	    };
	    DaterangePickerComponent.prototype.callback = function (start, end, label) {
	        this.activeRange = {
	            start: start,
	            end: end,
	            label: label
	        };
	        this.selected.emit(this.activeRange);
	    };
	    DaterangePickerComponent.prototype.destroyPicker = function () {
	        try {
	            $(this.input.nativeElement).data('daterangepicker').remove();
	        }
	        catch (e) {
	            console.log(e.message);
	        }
	    };
	    DaterangePickerComponent.prototype.ngOnDestroy = function () {
	        this.destroyPicker();
	    };
	    DaterangePickerComponent.prototype.ngDoCheck = function () {
	        var optionsChanged = this._differ['options'].diff(this.options);
	        var settingsChanged = this._differ['settings'].diff(this.config.settings);
	        if (optionsChanged || settingsChanged) {
	            this.render();
	            this.attachEvents();
	            if (this.activeRange && this.datePicker) {
	                this.datePicker.setStartDate(this.activeRange.start);
	                this.datePicker.setEndDate(this.activeRange.end);
	            }
	        }
	    };
	    DaterangePickerComponent.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[daterangepicker]',
	                },] },
	    ];
	    DaterangePickerComponent.ctorParameters = function () { return [
	        { type: core_2.ElementRef, },
	        { type: config_service_1.DaterangepickerConfig, },
	        { type: core_2.KeyValueDiffers, },
	    ]; };
	    DaterangePickerComponent.propDecorators = {
	        'options': [{ type: core_1.Input },],
	        'selected': [{ type: core_1.Output },],
	        'cancelDaterangepicker': [{ type: core_1.Output },],
	        'applyDaterangepicker': [{ type: core_1.Output },],
	        'hideCalendarDaterangepicker': [{ type: core_1.Output },],
	        'showCalendarDaterangepicker': [{ type: core_1.Output },],
	        'hideDaterangepicker': [{ type: core_1.Output },],
	        'showDaterangepicker': [{ type: core_1.Output },],
	    };
	    return DaterangePickerComponent;
	}());
	exports.DaterangePickerComponent = DaterangePickerComponent;
	//# sourceMappingURL=daterangepicker.component.js.map

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var $ = __webpack_require__(954);
	var DaterangepickerConfig = (function () {
	    function DaterangepickerConfig() {
	        this.skipCSS = false;
	        this.addedCSS = false;
	        this.settings = {};
	    }
	    DaterangepickerConfig.prototype.embedCSS = function () {
	        if (this.addedCSS) {
	            return;
	        }
	        if (this.skipCSS === false) {
	            $('head').append('<style>' +
	                ".daterangepicker.single .calendar,.daterangepicker.single .ranges,.ranges{float:none}.daterangepicker{position:absolute;color:#111;background:#fff;border-radius:4px;width:278px;padding:4px;margin-top:1px;top:100px;left:20px}.daterangepicker:after,.daterangepicker:before{position:absolute;display:inline-block;content:''}.daterangepicker:before{top:-7px;border-right:7px solid transparent;border-left:7px solid transparent;border-bottom:7px solid #ccc}.daterangepicker:after{top:-6px;border-right:6px solid transparent;border-bottom:6px solid #fff;border-left:6px solid transparent}.daterangepicker.opensleft:before{right:9px}.daterangepicker.opensleft:after{right:10px}.daterangepicker.openscenter:after,.daterangepicker.openscenter:before{left:0;right:0;width:0;margin-left:auto;margin-right:auto}.daterangepicker.opensright:before{left:9px}.daterangepicker.opensright:after{left:10px}.daterangepicker.dropup{margin-top:-5px}.daterangepicker.dropup:before{top:initial;bottom:-7px;border-bottom:initial;border-top:7px solid #ccc}.daterangepicker.dropup:after{top:initial;bottom:-6px;border-bottom:initial;border-top:6px solid #fff}.daterangepicker.dropdown-menu{max-width:none;z-index:3001}.daterangepicker.show-calendar .calendar{display:block}.daterangepicker .calendar{display:none;max-width:270px;margin:4px}.daterangepicker .calendar.single .calendar-table{border:none}.daterangepicker .calendar td,.daterangepicker .calendar th{white-space:nowrap;text-align:center;min-width:32px}.daterangepicker .calendar-table{border:1px solid #fff;padding:4px;border-radius:4px;background:#fff}.daterangepicker table{width:100%;margin:0}.daterangepicker td,.daterangepicker th{text-align:center;width:20px;height:20px;border-radius:4px;border:1px solid transparent;white-space:nowrap;cursor:pointer}.daterangepicker td.available:hover,.daterangepicker th.available:hover{background-color:#eee;border-color:transparent;color:inherit}.daterangepicker td.week,.daterangepicker th.week{font-size:80%;color:#ccc}.daterangepicker td.off,.daterangepicker td.off.end-date,.daterangepicker td.off.in-range,.daterangepicker td.off.start-date{background-color:#fff;border-color:transparent;color:#999}.daterangepicker td.in-range{background-color:#ebf4f8;border-color:transparent;color:#000;border-radius:0}.daterangepicker td.start-date{border-radius:4px 0 0 4px}.daterangepicker td.end-date{border-radius:0 4px 4px 0}.daterangepicker td.start-date.end-date{border-radius:4px}.daterangepicker td.active,.daterangepicker td.active:hover{background-color:#357ebd;border-color:transparent;color:#fff}.daterangepicker th.month{width:auto}.daterangepicker option.disabled,.daterangepicker td.disabled{color:#999;cursor:not-allowed;text-decoration:line-through}.daterangepicker select.monthselect,.daterangepicker select.yearselect{font-size:12px;padding:1px;height:auto;margin:0;cursor:default}.daterangepicker select.monthselect{margin-right:2%;width:56%}.daterangepicker select.yearselect{width:40%}.daterangepicker select.ampmselect,.daterangepicker select.hourselect,.daterangepicker select.minuteselect,.daterangepicker select.secondselect{width:50px;margin-bottom:0}.daterangepicker .input-mini{border:1px solid #ccc;border-radius:4px;color:#555;height:30px;line-height:30px;display:block;vertical-align:middle;margin:0 0 5px;padding:0 6px 0 28px;width:100%}.daterangepicker .input-mini.active{border:1px solid #08c;border-radius:4px}.daterangepicker .daterangepicker_input{position:relative}.daterangepicker .daterangepicker_input i{position:absolute;left:8px;top:8px}.daterangepicker.rtl .input-mini{padding-right:28px;padding-left:6px}.daterangepicker.rtl .daterangepicker_input i{left:auto;right:8px}.daterangepicker .calendar-time{text-align:center;margin:5px auto;line-height:30px;position:relative;padding-left:28px}.daterangepicker .calendar-time select.disabled{color:#ccc;cursor:not-allowed}.ranges{font-size:11px;margin:4px;text-align:left}.ranges ul{list-style:none;margin:0 auto;padding:0;width:100%}.ranges li{font-size:13px;background:#f5f5f5;border:1px solid #f5f5f5;border-radius:4px;color:#08c;padding:3px 12px;margin-bottom:8px;cursor:pointer}.ranges li.active,.ranges li:hover{background:#08c;border:1px solid #08c;color:#fff}@media (min-width:564px){.daterangepicker.ltr .calendar.right .calendar-table,.daterangepicker.rtl .calendar.left .calendar-table{border-left:none;border-top-left-radius:0;border-bottom-left-radius:0}.daterangepicker.ltr .calendar.left .calendar-table,.daterangepicker.rtl .calendar.right .calendar-table{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}.daterangepicker{width:auto}.daterangepicker .ranges ul{width:160px}.daterangepicker.single .ranges ul{width:100%}.daterangepicker.single .calendar.left{clear:none}.daterangepicker.single.ltr .calendar,.daterangepicker.single.ltr .ranges{float:left}.daterangepicker.single.rtl .calendar,.daterangepicker.single.rtl .ranges{float:right}.daterangepicker.ltr{direction:ltr;text-align:left}.daterangepicker.ltr .calendar.left{clear:left;margin-right:0}.daterangepicker.ltr .calendar.right{margin-left:0}.daterangepicker.ltr .calendar.left .calendar-table,.daterangepicker.ltr .left .daterangepicker_input{padding-right:12px}.daterangepicker.ltr .calendar,.daterangepicker.ltr .ranges{float:left}.daterangepicker.rtl{direction:rtl;text-align:right}.daterangepicker.rtl .calendar.left{clear:right;margin-left:0}.daterangepicker.rtl .calendar.right{margin-right:0}.daterangepicker.rtl .calendar.left .calendar-table,.daterangepicker.rtl .left .daterangepicker_input{padding-left:12px}.daterangepicker.rtl .calendar,.daterangepicker.rtl .ranges{text-align:right;float:right}}@media (min-width:730px){.daterangepicker .ranges{width:auto}.daterangepicker.ltr .ranges{float:left}.daterangepicker.rtl .ranges{float:right}.daterangepicker .calendar.left{clear:none!important}}"
	                + '</style>');
	        }
	    };
	    DaterangepickerConfig.decorators = [
	        { type: core_1.Injectable },
	    ];
	    DaterangepickerConfig.ctorParameters = function () { return []; };
	    return DaterangepickerConfig;
	}());
	exports.DaterangepickerConfig = DaterangepickerConfig;
	//# sourceMappingURL=config.service.js.map

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	* @version: 2.1.30
	* @author: Dan Grossman http://www.dangrossman.info/
	* @copyright: Copyright (c) 2012-2017 Dan Grossman. All rights reserved.
	* @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
	* @website: http://www.daterangepicker.com/
	*/
	// Follow the UMD template https://github.com/umdjs/umd/blob/master/templates/returnExportsGlobal.js
	(function (root, factory) {
	    if (true) {
	        // AMD. Make globaly available as well
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(838), __webpack_require__(954)], __WEBPACK_AMD_DEFINE_RESULT__ = function (moment, jquery) {
	            if (!jquery.fn) jquery.fn = {}; // webpack server rendering
	            return factory(moment, jquery);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        // Node / Browserify
	        //isomorphic issue
	        var jQuery = (typeof window != 'undefined') ? window.jQuery : undefined;
	        if (!jQuery) {
	            jQuery = require('jquery');
	            if (!jQuery.fn) jQuery.fn = {};
	        }
	        var moment = (typeof window != 'undefined' && typeof window.moment != 'undefined') ? window.moment : require('moment');
	        module.exports = factory(moment, jQuery);
	    } else {
	        // Browser globals
	        root.daterangepicker = factory(root.moment, root.jQuery);
	    }
	}(this, function(moment, $) {
	    var DateRangePicker = function(element, options, cb) {
	
	        //default settings for options
	        this.parentEl = 'body';
	        this.element = $(element);
	        this.startDate = moment().startOf('day');
	        this.endDate = moment().endOf('day');
	        this.minDate = false;
	        this.maxDate = false;
	        this.dateLimit = false;
	        this.autoApply = false;
	        this.singleDatePicker = false;
	        this.showDropdowns = false;
	        this.showWeekNumbers = false;
	        this.showISOWeekNumbers = false;
	        this.showCustomRangeLabel = true;
	        this.timePicker = false;
	        this.timePicker24Hour = false;
	        this.timePickerIncrement = 1;
	        this.timePickerSeconds = false;
	        this.linkedCalendars = true;
	        this.autoUpdateInput = true;
	        this.alwaysShowCalendars = false;
	        this.ranges = {};
	
	        this.opens = 'right';
	        if (this.element.hasClass('pull-right'))
	            this.opens = 'left';
	
	        this.drops = 'down';
	        if (this.element.hasClass('dropup'))
	            this.drops = 'up';
	
	        this.buttonClasses = 'btn btn-sm';
	        this.applyClass = 'btn-success';
	        this.cancelClass = 'btn-default';
	
	        this.locale = {
	            direction: 'ltr',
	            format: moment.localeData().longDateFormat('L'),
	            separator: ' - ',
	            applyLabel: 'Apply',
	            cancelLabel: 'Cancel',
	            weekLabel: 'W',
	            customRangeLabel: 'Custom Range',
	            daysOfWeek: moment.weekdaysMin(),
	            monthNames: moment.monthsShort(),
	            firstDay: moment.localeData().firstDayOfWeek()
	        };
	
	        this.callback = function() { };
	
	        //some state information
	        this.isShowing = false;
	        this.leftCalendar = {};
	        this.rightCalendar = {};
	
	        //custom options from user
	        if (typeof options !== 'object' || options === null)
	            options = {};
	
	        //allow setting options with data attributes
	        //data-api options will be overwritten with custom javascript options
	        options = $.extend(this.element.data(), options);
	
	        //html template for the picker UI
	        if (typeof options.template !== 'string' && !(options.template instanceof $))
	            options.template = '<div class="daterangepicker dropdown-menu">' +
	                '<div class="calendar left">' +
	                    '<div class="daterangepicker_input">' +
	                      '<input class="input-mini form-control" type="text" name="daterangepicker_start" value="" />' +
	                      '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
	                      '<div class="calendar-time">' +
	                        '<div></div>' +
	                        '<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
	                      '</div>' +
	                    '</div>' +
	                    '<div class="calendar-table"></div>' +
	                '</div>' +
	                '<div class="calendar right">' +
	                    '<div class="daterangepicker_input">' +
	                      '<input class="input-mini form-control" type="text" name="daterangepicker_end" value="" />' +
	                      '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
	                      '<div class="calendar-time">' +
	                        '<div></div>' +
	                        '<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
	                      '</div>' +
	                    '</div>' +
	                    '<div class="calendar-table"></div>' +
	                '</div>' +
	                '<div class="ranges">' +
	                    '<div class="range_inputs">' +
	                        '<button class="applyBtn" disabled="disabled" type="button"></button> ' +
	                        '<button class="cancelBtn" type="button"></button>' +
	                    '</div>' +
	                '</div>' +
	            '</div>';
	
	        this.parentEl = (options.parentEl && $(options.parentEl).length) ? $(options.parentEl) : $(this.parentEl);
	        this.container = $(options.template).appendTo(this.parentEl);
	
	        //
	        // handle all the possible options overriding defaults
	        //
	
	        if (typeof options.locale === 'object') {
	
	            if (typeof options.locale.direction === 'string')
	                this.locale.direction = options.locale.direction;
	
	            if (typeof options.locale.format === 'string')
	                this.locale.format = options.locale.format;
	
	            if (typeof options.locale.separator === 'string')
	                this.locale.separator = options.locale.separator;
	
	            if (typeof options.locale.daysOfWeek === 'object')
	                this.locale.daysOfWeek = options.locale.daysOfWeek.slice();
	
	            if (typeof options.locale.monthNames === 'object')
	              this.locale.monthNames = options.locale.monthNames.slice();
	
	            if (typeof options.locale.firstDay === 'number')
	              this.locale.firstDay = options.locale.firstDay;
	
	            if (typeof options.locale.applyLabel === 'string')
	              this.locale.applyLabel = options.locale.applyLabel;
	
	            if (typeof options.locale.cancelLabel === 'string')
	              this.locale.cancelLabel = options.locale.cancelLabel;
	
	            if (typeof options.locale.weekLabel === 'string')
	              this.locale.weekLabel = options.locale.weekLabel;
	
	            if (typeof options.locale.customRangeLabel === 'string'){
	                //Support unicode chars in the custom range name.
	                var elem = document.createElement('textarea');
	                elem.innerHTML = options.locale.customRangeLabel;
	                var rangeHtml = elem.value;
	                this.locale.customRangeLabel = rangeHtml;
	            }
	        }
	        this.container.addClass(this.locale.direction);
	
	        if (typeof options.startDate === 'string')
	            this.startDate = moment(options.startDate, this.locale.format);
	
	        if (typeof options.endDate === 'string')
	            this.endDate = moment(options.endDate, this.locale.format);
	
	        if (typeof options.minDate === 'string')
	            this.minDate = moment(options.minDate, this.locale.format);
	
	        if (typeof options.maxDate === 'string')
	            this.maxDate = moment(options.maxDate, this.locale.format);
	
	        if (typeof options.startDate === 'object')
	            this.startDate = moment(options.startDate);
	
	        if (typeof options.endDate === 'object')
	            this.endDate = moment(options.endDate);
	
	        if (typeof options.minDate === 'object')
	            this.minDate = moment(options.minDate);
	
	        if (typeof options.maxDate === 'object')
	            this.maxDate = moment(options.maxDate);
	
	        // sanity check for bad options
	        if (this.minDate && this.startDate.isBefore(this.minDate))
	            this.startDate = this.minDate.clone();
	
	        // sanity check for bad options
	        if (this.maxDate && this.endDate.isAfter(this.maxDate))
	            this.endDate = this.maxDate.clone();
	
	        if (typeof options.applyClass === 'string')
	            this.applyClass = options.applyClass;
	
	        if (typeof options.cancelClass === 'string')
	            this.cancelClass = options.cancelClass;
	
	        if (typeof options.dateLimit === 'object')
	            this.dateLimit = options.dateLimit;
	
	        if (typeof options.opens === 'string')
	            this.opens = options.opens;
	
	        if (typeof options.drops === 'string')
	            this.drops = options.drops;
	
	        if (typeof options.showWeekNumbers === 'boolean')
	            this.showWeekNumbers = options.showWeekNumbers;
	
	        if (typeof options.showISOWeekNumbers === 'boolean')
	            this.showISOWeekNumbers = options.showISOWeekNumbers;
	
	        if (typeof options.buttonClasses === 'string')
	            this.buttonClasses = options.buttonClasses;
	
	        if (typeof options.buttonClasses === 'object')
	            this.buttonClasses = options.buttonClasses.join(' ');
	
	        if (typeof options.showDropdowns === 'boolean')
	            this.showDropdowns = options.showDropdowns;
	
	        if (typeof options.showCustomRangeLabel === 'boolean')
	            this.showCustomRangeLabel = options.showCustomRangeLabel;
	
	        if (typeof options.singleDatePicker === 'boolean') {
	            this.singleDatePicker = options.singleDatePicker;
	            if (this.singleDatePicker)
	                this.endDate = this.startDate.clone();
	        }
	
	        if (typeof options.timePicker === 'boolean')
	            this.timePicker = options.timePicker;
	
	        if (typeof options.timePickerSeconds === 'boolean')
	            this.timePickerSeconds = options.timePickerSeconds;
	
	        if (typeof options.timePickerIncrement === 'number')
	            this.timePickerIncrement = options.timePickerIncrement;
	
	        if (typeof options.timePicker24Hour === 'boolean')
	            this.timePicker24Hour = options.timePicker24Hour;
	
	        if (typeof options.autoApply === 'boolean')
	            this.autoApply = options.autoApply;
	
	        if (typeof options.autoUpdateInput === 'boolean')
	            this.autoUpdateInput = options.autoUpdateInput;
	
	        if (typeof options.linkedCalendars === 'boolean')
	            this.linkedCalendars = options.linkedCalendars;
	
	        if (typeof options.isInvalidDate === 'function')
	            this.isInvalidDate = options.isInvalidDate;
	
	        if (typeof options.isCustomDate === 'function')
	            this.isCustomDate = options.isCustomDate;
	
	        if (typeof options.alwaysShowCalendars === 'boolean')
	            this.alwaysShowCalendars = options.alwaysShowCalendars;
	
	        // update day names order to firstDay
	        if (this.locale.firstDay != 0) {
	            var iterator = this.locale.firstDay;
	            while (iterator > 0) {
	                this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
	                iterator--;
	            }
	        }
	
	        var start, end, range;
	
	        //if no start/end dates set, check if an input element contains initial values
	        if (typeof options.startDate === 'undefined' && typeof options.endDate === 'undefined') {
	            if ($(this.element).is('input[type=text]')) {
	                var val = $(this.element).val(),
	                    split = val.split(this.locale.separator);
	
	                start = end = null;
	
	                if (split.length == 2) {
	                    start = moment(split[0], this.locale.format);
	                    end = moment(split[1], this.locale.format);
	                } else if (this.singleDatePicker && val !== "") {
	                    start = moment(val, this.locale.format);
	                    end = moment(val, this.locale.format);
	                }
	                if (start !== null && end !== null) {
	                    this.setStartDate(start);
	                    this.setEndDate(end);
	                }
	            }
	        }
	
	        if (typeof options.ranges === 'object') {
	            for (range in options.ranges) {
	
	                if (typeof options.ranges[range][0] === 'string')
	                    start = moment(options.ranges[range][0], this.locale.format);
	                else
	                    start = moment(options.ranges[range][0]);
	
	                if (typeof options.ranges[range][1] === 'string')
	                    end = moment(options.ranges[range][1], this.locale.format);
	                else
	                    end = moment(options.ranges[range][1]);
	
	                // If the start or end date exceed those allowed by the minDate or dateLimit
	                // options, shorten the range to the allowable period.
	                if (this.minDate && start.isBefore(this.minDate))
	                    start = this.minDate.clone();
	
	                var maxDate = this.maxDate;
	                if (this.dateLimit && maxDate && start.clone().add(this.dateLimit).isAfter(maxDate))
	                    maxDate = start.clone().add(this.dateLimit);
	                if (maxDate && end.isAfter(maxDate))
	                    end = maxDate.clone();
	
	                // If the end of the range is before the minimum or the start of the range is
	                // after the maximum, don't display this range option at all.
	                if ((this.minDate && end.isBefore(this.minDate, this.timepicker ? 'minute' : 'day')) 
	                  || (maxDate && start.isAfter(maxDate, this.timepicker ? 'minute' : 'day')))
	                    continue;
	
	                //Support unicode chars in the range names.
	                var elem = document.createElement('textarea');
	                elem.innerHTML = range;
	                var rangeHtml = elem.value;
	
	                this.ranges[rangeHtml] = [start, end];
	            }
	
	            var list = '<ul>';
	            for (range in this.ranges) {
	                list += '<li data-range-key="' + range + '">' + range + '</li>';
	            }
	            if (this.showCustomRangeLabel) {
	                list += '<li data-range-key="' + this.locale.customRangeLabel + '">' + this.locale.customRangeLabel + '</li>';
	            }
	            list += '</ul>';
	            this.container.find('.ranges').prepend(list);
	        }
	
	        if (typeof cb === 'function') {
	            this.callback = cb;
	        }
	
	        if (!this.timePicker) {
	            this.startDate = this.startDate.startOf('day');
	            this.endDate = this.endDate.endOf('day');
	            this.container.find('.calendar-time').hide();
	        }
	
	        //can't be used together for now
	        if (this.timePicker && this.autoApply)
	            this.autoApply = false;
	
	        if (this.autoApply && typeof options.ranges !== 'object') {
	            this.container.find('.ranges').hide();
	        } else if (this.autoApply) {
	            this.container.find('.applyBtn, .cancelBtn').addClass('hide');
	        }
	
	        if (this.singleDatePicker) {
	            this.container.addClass('single');
	            this.container.find('.calendar.left').addClass('single');
	            this.container.find('.calendar.left').show();
	            this.container.find('.calendar.right').hide();
	            this.container.find('.daterangepicker_input input, .daterangepicker_input > i').hide();
	            if (this.timePicker) {
	                this.container.find('.ranges ul').hide();
	            } else {
	                this.container.find('.ranges').hide();
	            }
	        }
	
	        if ((typeof options.ranges === 'undefined' && !this.singleDatePicker) || this.alwaysShowCalendars) {
	            this.container.addClass('show-calendar');
	        }
	
	        this.container.addClass('opens' + this.opens);
	
	        //swap the position of the predefined ranges if opens right
	        if (typeof options.ranges !== 'undefined' && this.opens == 'right') {
	            this.container.find('.ranges').prependTo( this.container.find('.calendar.left').parent() );
	        }
	
	        //apply CSS classes and labels to buttons
	        this.container.find('.applyBtn, .cancelBtn').addClass(this.buttonClasses);
	        if (this.applyClass.length)
	            this.container.find('.applyBtn').addClass(this.applyClass);
	        if (this.cancelClass.length)
	            this.container.find('.cancelBtn').addClass(this.cancelClass);
	        this.container.find('.applyBtn').html(this.locale.applyLabel);
	        this.container.find('.cancelBtn').html(this.locale.cancelLabel);
	
	        //
	        // event listeners
	        //
	
	        this.container.find('.calendar')
	            .on('click.daterangepicker', '.prev', $.proxy(this.clickPrev, this))
	            .on('click.daterangepicker', '.next', $.proxy(this.clickNext, this))
	            .on('mousedown.daterangepicker', 'td.available', $.proxy(this.clickDate, this))
	            .on('mouseenter.daterangepicker', 'td.available', $.proxy(this.hoverDate, this))
	            .on('mouseleave.daterangepicker', 'td.available', $.proxy(this.updateFormInputs, this))
	            .on('change.daterangepicker', 'select.yearselect', $.proxy(this.monthOrYearChanged, this))
	            .on('change.daterangepicker', 'select.monthselect', $.proxy(this.monthOrYearChanged, this))
	            .on('change.daterangepicker', 'select.hourselect,select.minuteselect,select.secondselect,select.ampmselect', $.proxy(this.timeChanged, this))
	            .on('click.daterangepicker', '.daterangepicker_input input', $.proxy(this.showCalendars, this))
	            .on('focus.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsFocused, this))
	            .on('blur.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsBlurred, this))
	            .on('change.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsChanged, this))
	            .on('keydown.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsKeydown, this));
	
	        this.container.find('.ranges')
	            .on('click.daterangepicker', 'button.applyBtn', $.proxy(this.clickApply, this))
	            .on('click.daterangepicker', 'button.cancelBtn', $.proxy(this.clickCancel, this))
	            .on('click.daterangepicker', 'li', $.proxy(this.clickRange, this))
	            .on('mouseenter.daterangepicker', 'li', $.proxy(this.hoverRange, this))
	            .on('mouseleave.daterangepicker', 'li', $.proxy(this.updateFormInputs, this));
	
	        if (this.element.is('input') || this.element.is('button')) {
	            this.element.on({
	                'click.daterangepicker': $.proxy(this.show, this),
	                'focus.daterangepicker': $.proxy(this.show, this),
	                'keyup.daterangepicker': $.proxy(this.elementChanged, this),
	                'keydown.daterangepicker': $.proxy(this.keydown, this) //IE 11 compatibility
	            });
	        } else {
	            this.element.on('click.daterangepicker', $.proxy(this.toggle, this));
	            this.element.on('keydown.daterangepicker', $.proxy(this.toggle, this));
	        }
	
	        //
	        // if attached to a text input, set the initial value
	        //
	
	        if (this.element.is('input') && !this.singleDatePicker && this.autoUpdateInput) {
	            this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
	            this.element.trigger('change');
	        } else if (this.element.is('input') && this.autoUpdateInput) {
	            this.element.val(this.startDate.format(this.locale.format));
	            this.element.trigger('change');
	        }
	
	    };
	
	    DateRangePicker.prototype = {
	
	        constructor: DateRangePicker,
	
	        setStartDate: function(startDate) {
	            if (typeof startDate === 'string')
	                this.startDate = moment(startDate, this.locale.format);
	
	            if (typeof startDate === 'object')
	                this.startDate = moment(startDate);
	
	            if (!this.timePicker)
	                this.startDate = this.startDate.startOf('day');
	
	            if (this.timePicker && this.timePickerIncrement)
	                this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	
	            if (this.minDate && this.startDate.isBefore(this.minDate)) {
	                this.startDate = this.minDate.clone();
	                if (this.timePicker && this.timePickerIncrement)
	                    this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	            }
	
	            if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
	                this.startDate = this.maxDate.clone();
	                if (this.timePicker && this.timePickerIncrement)
	                    this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	            }
	
	            if (!this.isShowing)
	                this.updateElement();
	
	            this.updateMonthsInView();
	        },
	
	        setEndDate: function(endDate) {
	            if (typeof endDate === 'string')
	                this.endDate = moment(endDate, this.locale.format);
	
	            if (typeof endDate === 'object')
	                this.endDate = moment(endDate);
	
	            if (!this.timePicker)
	                this.endDate = this.endDate.add(1,'d').startOf('day').subtract(1,'second');
	
	            if (this.timePicker && this.timePickerIncrement)
	                this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	
	            if (this.endDate.isBefore(this.startDate))
	                this.endDate = this.startDate.clone();
	
	            if (this.maxDate && this.endDate.isAfter(this.maxDate))
	                this.endDate = this.maxDate.clone();
	
	            if (this.dateLimit && this.startDate.clone().add(this.dateLimit).isBefore(this.endDate))
	                this.endDate = this.startDate.clone().add(this.dateLimit);
	
	            this.previousRightTime = this.endDate.clone();
	
	            if (!this.isShowing)
	                this.updateElement();
	
	            this.updateMonthsInView();
	        },
	
	        isInvalidDate: function() {
	            return false;
	        },
	
	        isCustomDate: function() {
	            return false;
	        },
	
	        updateView: function() {
	            if (this.timePicker) {
	                this.renderTimePicker('left');
	                this.renderTimePicker('right');
	                if (!this.endDate) {
	                    this.container.find('.right .calendar-time select').attr('disabled', 'disabled').addClass('disabled');
	                } else {
	                    this.container.find('.right .calendar-time select').removeAttr('disabled').removeClass('disabled');
	                }
	            }
	            if (this.endDate) {
	                this.container.find('input[name="daterangepicker_end"]').removeClass('active');
	                this.container.find('input[name="daterangepicker_start"]').addClass('active');
	            } else {
	                this.container.find('input[name="daterangepicker_end"]').addClass('active');
	                this.container.find('input[name="daterangepicker_start"]').removeClass('active');
	            }
	            this.updateMonthsInView();
	            this.updateCalendars();
	            this.updateFormInputs();
	        },
	
	        updateMonthsInView: function() {
	            if (this.endDate) {
	
	                //if both dates are visible already, do nothing
	                if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month &&
	                    (this.startDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.startDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
	                    &&
	                    (this.endDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.endDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
	                    ) {
	                    return;
	                }
	
	                this.leftCalendar.month = this.startDate.clone().date(2);
	                if (!this.linkedCalendars && (this.endDate.month() != this.startDate.month() || this.endDate.year() != this.startDate.year())) {
	                    this.rightCalendar.month = this.endDate.clone().date(2);
	                } else {
	                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
	                }
	
	            } else {
	                if (this.leftCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM') && this.rightCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM')) {
	                    this.leftCalendar.month = this.startDate.clone().date(2);
	                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
	                }
	            }
	            if (this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate) {
	              this.rightCalendar.month = this.maxDate.clone().date(2);
	              this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, 'month');
	            }
	        },
	
	        updateCalendars: function() {
	
	            if (this.timePicker) {
	                var hour, minute, second;
	                if (this.endDate) {
	                    hour = parseInt(this.container.find('.left .hourselect').val(), 10);
	                    minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
	                    second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
	                    if (!this.timePicker24Hour) {
	                        var ampm = this.container.find('.left .ampmselect').val();
	                        if (ampm === 'PM' && hour < 12)
	                            hour += 12;
	                        if (ampm === 'AM' && hour === 12)
	                            hour = 0;
	                    }
	                } else {
	                    hour = parseInt(this.container.find('.right .hourselect').val(), 10);
	                    minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
	                    second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
	                    if (!this.timePicker24Hour) {
	                        var ampm = this.container.find('.right .ampmselect').val();
	                        if (ampm === 'PM' && hour < 12)
	                            hour += 12;
	                        if (ampm === 'AM' && hour === 12)
	                            hour = 0;
	                    }
	                }
	                this.leftCalendar.month.hour(hour).minute(minute).second(second);
	                this.rightCalendar.month.hour(hour).minute(minute).second(second);
	            }
	
	            this.renderCalendar('left');
	            this.renderCalendar('right');
	
	            //highlight any predefined range matching the current start and end dates
	            this.container.find('.ranges li').removeClass('active');
	            if (this.endDate == null) return;
	
	            this.calculateChosenLabel();
	        },
	
	        renderCalendar: function(side) {
	
	            //
	            // Build the matrix of dates that will populate the calendar
	            //
	
	            var calendar = side == 'left' ? this.leftCalendar : this.rightCalendar;
	            var month = calendar.month.month();
	            var year = calendar.month.year();
	            var hour = calendar.month.hour();
	            var minute = calendar.month.minute();
	            var second = calendar.month.second();
	            var daysInMonth = moment([year, month]).daysInMonth();
	            var firstDay = moment([year, month, 1]);
	            var lastDay = moment([year, month, daysInMonth]);
	            var lastMonth = moment(firstDay).subtract(1, 'month').month();
	            var lastYear = moment(firstDay).subtract(1, 'month').year();
	            var daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth();
	            var dayOfWeek = firstDay.day();
	
	            //initialize a 6 rows x 7 columns array for the calendar
	            var calendar = [];
	            calendar.firstDay = firstDay;
	            calendar.lastDay = lastDay;
	
	            for (var i = 0; i < 6; i++) {
	                calendar[i] = [];
	            }
	
	            //populate the calendar with date objects
	            var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
	            if (startDay > daysInLastMonth)
	                startDay -= 7;
	
	            if (dayOfWeek == this.locale.firstDay)
	                startDay = daysInLastMonth - 6;
	
	            var curDate = moment([lastYear, lastMonth, startDay, 12, minute, second]);
	
	            var col, row;
	            for (var i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = moment(curDate).add(24, 'hour')) {
	                if (i > 0 && col % 7 === 0) {
	                    col = 0;
	                    row++;
	                }
	                calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
	                curDate.hour(12);
	
	                if (this.minDate && calendar[row][col].format('YYYY-MM-DD') == this.minDate.format('YYYY-MM-DD') && calendar[row][col].isBefore(this.minDate) && side == 'left') {
	                    calendar[row][col] = this.minDate.clone();
	                }
	
	                if (this.maxDate && calendar[row][col].format('YYYY-MM-DD') == this.maxDate.format('YYYY-MM-DD') && calendar[row][col].isAfter(this.maxDate) && side == 'right') {
	                    calendar[row][col] = this.maxDate.clone();
	                }
	
	            }
	
	            //make the calendar object available to hoverDate/clickDate
	            if (side == 'left') {
	                this.leftCalendar.calendar = calendar;
	            } else {
	                this.rightCalendar.calendar = calendar;
	            }
	
	            //
	            // Display the calendar
	            //
	
	            var minDate = side == 'left' ? this.minDate : this.startDate;
	            var maxDate = this.maxDate;
	            var selected = side == 'left' ? this.startDate : this.endDate;
	            var arrow = this.locale.direction == 'ltr' ? {left: 'chevron-left', right: 'chevron-right'} : {left: 'chevron-right', right: 'chevron-left'};
	
	            var html = '<table class="table-condensed">';
	            html += '<thead>';
	            html += '<tr>';
	
	            // add empty cell for week number
	            if (this.showWeekNumbers || this.showISOWeekNumbers)
	                html += '<th></th>';
	
	            if ((!minDate || minDate.isBefore(calendar.firstDay)) && (!this.linkedCalendars || side == 'left')) {
	                html += '<th class="prev available"><i class="fa fa-' + arrow.left + ' glyphicon glyphicon-' + arrow.left + '"></i></th>';
	            } else {
	                html += '<th></th>';
	            }
	
	            var dateHtml = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format(" YYYY");
	
	            if (this.showDropdowns) {
	                var currentMonth = calendar[1][1].month();
	                var currentYear = calendar[1][1].year();
	                var maxYear = (maxDate && maxDate.year()) || (currentYear + 5);
	                var minYear = (minDate && minDate.year()) || (currentYear - 50);
	                var inMinYear = currentYear == minYear;
	                var inMaxYear = currentYear == maxYear;
	
	                var monthHtml = '<select class="monthselect">';
	                for (var m = 0; m < 12; m++) {
	                    if ((!inMinYear || m >= minDate.month()) && (!inMaxYear || m <= maxDate.month())) {
	                        monthHtml += "<option value='" + m + "'" +
	                            (m === currentMonth ? " selected='selected'" : "") +
	                            ">" + this.locale.monthNames[m] + "</option>";
	                    } else {
	                        monthHtml += "<option value='" + m + "'" +
	                            (m === currentMonth ? " selected='selected'" : "") +
	                            " disabled='disabled'>" + this.locale.monthNames[m] + "</option>";
	                    }
	                }
	                monthHtml += "</select>";
	
	                var yearHtml = '<select class="yearselect">';
	                for (var y = minYear; y <= maxYear; y++) {
	                    yearHtml += '<option value="' + y + '"' +
	                        (y === currentYear ? ' selected="selected"' : '') +
	                        '>' + y + '</option>';
	                }
	                yearHtml += '</select>';
	
	                dateHtml = monthHtml + yearHtml;
	            }
	
	            html += '<th colspan="5" class="month">' + dateHtml + '</th>';
	            if ((!maxDate || maxDate.isAfter(calendar.lastDay)) && (!this.linkedCalendars || side == 'right' || this.singleDatePicker)) {
	                html += '<th class="next available"><i class="fa fa-' + arrow.right + ' glyphicon glyphicon-' + arrow.right + '"></i></th>';
	            } else {
	                html += '<th></th>';
	            }
	
	            html += '</tr>';
	            html += '<tr>';
	
	            // add week number label
	            if (this.showWeekNumbers || this.showISOWeekNumbers)
	                html += '<th class="week">' + this.locale.weekLabel + '</th>';
	
	            $.each(this.locale.daysOfWeek, function(index, dayOfWeek) {
	                html += '<th>' + dayOfWeek + '</th>';
	            });
	
	            html += '</tr>';
	            html += '</thead>';
	            html += '<tbody>';
	
	            //adjust maxDate to reflect the dateLimit setting in order to
	            //grey out end dates beyond the dateLimit
	            if (this.endDate == null && this.dateLimit) {
	                var maxLimit = this.startDate.clone().add(this.dateLimit).endOf('day');
	                if (!maxDate || maxLimit.isBefore(maxDate)) {
	                    maxDate = maxLimit;
	                }
	            }
	
	            for (var row = 0; row < 6; row++) {
	                html += '<tr>';
	
	                // add week number
	                if (this.showWeekNumbers)
	                    html += '<td class="week">' + calendar[row][0].week() + '</td>';
	                else if (this.showISOWeekNumbers)
	                    html += '<td class="week">' + calendar[row][0].isoWeek() + '</td>';
	
	                for (var col = 0; col < 7; col++) {
	
	                    var classes = [];
	
	                    //highlight today's date
	                    if (calendar[row][col].isSame(new Date(), "day"))
	                        classes.push('today');
	
	                    //highlight weekends
	                    if (calendar[row][col].isoWeekday() > 5)
	                        classes.push('weekend');
	
	                    //grey out the dates in other months displayed at beginning and end of this calendar
	                    if (calendar[row][col].month() != calendar[1][1].month())
	                        classes.push('off');
	
	                    //don't allow selection of dates before the minimum date
	                    if (this.minDate && calendar[row][col].isBefore(this.minDate, 'day'))
	                        classes.push('off', 'disabled');
	
	                    //don't allow selection of dates after the maximum date
	                    if (maxDate && calendar[row][col].isAfter(maxDate, 'day'))
	                        classes.push('off', 'disabled');
	
	                    //don't allow selection of date if a custom function decides it's invalid
	                    if (this.isInvalidDate(calendar[row][col]))
	                        classes.push('off', 'disabled');
	
	                    //highlight the currently selected start date
	                    if (calendar[row][col].format('YYYY-MM-DD') == this.startDate.format('YYYY-MM-DD'))
	                        classes.push('active', 'start-date');
	
	                    //highlight the currently selected end date
	                    if (this.endDate != null && calendar[row][col].format('YYYY-MM-DD') == this.endDate.format('YYYY-MM-DD'))
	                        classes.push('active', 'end-date');
	
	                    //highlight dates in-between the selected dates
	                    if (this.endDate != null && calendar[row][col] > this.startDate && calendar[row][col] < this.endDate)
	                        classes.push('in-range');
	
	                    //apply custom classes for this date
	                    var isCustom = this.isCustomDate(calendar[row][col]);
	                    if (isCustom !== false) {
	                        if (typeof isCustom === 'string')
	                            classes.push(isCustom);
	                        else
	                            Array.prototype.push.apply(classes, isCustom);
	                    }
	
	                    var cname = '', disabled = false;
	                    for (var i = 0; i < classes.length; i++) {
	                        cname += classes[i] + ' ';
	                        if (classes[i] == 'disabled')
	                            disabled = true;
	                    }
	                    if (!disabled)
	                        cname += 'available';
	
	                    html += '<td class="' + cname.replace(/^\s+|\s+$/g, '') + '" data-title="' + 'r' + row + 'c' + col + '">' + calendar[row][col].date() + '</td>';
	
	                }
	                html += '</tr>';
	            }
	
	            html += '</tbody>';
	            html += '</table>';
	
	            this.container.find('.calendar.' + side + ' .calendar-table').html(html);
	
	        },
	
	        renderTimePicker: function(side) {
	
	            // Don't bother updating the time picker if it's currently disabled
	            // because an end date hasn't been clicked yet
	            if (side == 'right' && !this.endDate) return;
	
	            var html, selected, minDate, maxDate = this.maxDate;
	
	            if (this.dateLimit && (!this.maxDate || this.startDate.clone().add(this.dateLimit).isAfter(this.maxDate)))
	                maxDate = this.startDate.clone().add(this.dateLimit);
	
	            if (side == 'left') {
	                selected = this.startDate.clone();
	                minDate = this.minDate;
	            } else if (side == 'right') {
	                selected = this.endDate.clone();
	                minDate = this.startDate;
	
	                //Preserve the time already selected
	                var timeSelector = this.container.find('.calendar.right .calendar-time div');
	                if (timeSelector.html() != '') {
	
	                    selected.hour(timeSelector.find('.hourselect option:selected').val() || selected.hour());
	                    selected.minute(timeSelector.find('.minuteselect option:selected').val() || selected.minute());
	                    selected.second(timeSelector.find('.secondselect option:selected').val() || selected.second());
	
	                    if (!this.timePicker24Hour) {
	                        var ampm = timeSelector.find('.ampmselect option:selected').val();
	                        if (ampm === 'PM' && selected.hour() < 12)
	                            selected.hour(selected.hour() + 12);
	                        if (ampm === 'AM' && selected.hour() === 12)
	                            selected.hour(0);
	                    }
	
	                }
	
	                if (selected.isBefore(this.startDate))
	                    selected = this.startDate.clone();
	
	                if (maxDate && selected.isAfter(maxDate))
	                    selected = maxDate.clone();
	
	            }
	
	            //
	            // hours
	            //
	
	            html = '<select class="hourselect">';
	
	            var start = this.timePicker24Hour ? 0 : 1;
	            var end = this.timePicker24Hour ? 23 : 12;
	
	            for (var i = start; i <= end; i++) {
	                var i_in_24 = i;
	                if (!this.timePicker24Hour)
	                    i_in_24 = selected.hour() >= 12 ? (i == 12 ? 12 : i + 12) : (i == 12 ? 0 : i);
	
	                var time = selected.clone().hour(i_in_24);
	                var disabled = false;
	                if (minDate && time.minute(59).isBefore(minDate))
	                    disabled = true;
	                if (maxDate && time.minute(0).isAfter(maxDate))
	                    disabled = true;
	
	                if (i_in_24 == selected.hour() && !disabled) {
	                    html += '<option value="' + i + '" selected="selected">' + i + '</option>';
	                } else if (disabled) {
	                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + i + '</option>';
	                } else {
	                    html += '<option value="' + i + '">' + i + '</option>';
	                }
	            }
	
	            html += '</select> ';
	
	            //
	            // minutes
	            //
	
	            html += ': <select class="minuteselect">';
	
	            for (var i = 0; i < 60; i += this.timePickerIncrement) {
	                var padded = i < 10 ? '0' + i : i;
	                var time = selected.clone().minute(i);
	
	                var disabled = false;
	                if (minDate && time.second(59).isBefore(minDate))
	                    disabled = true;
	                if (maxDate && time.second(0).isAfter(maxDate))
	                    disabled = true;
	
	                if (selected.minute() == i && !disabled) {
	                    html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
	                } else if (disabled) {
	                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
	                } else {
	                    html += '<option value="' + i + '">' + padded + '</option>';
	                }
	            }
	
	            html += '</select> ';
	
	            //
	            // seconds
	            //
	
	            if (this.timePickerSeconds) {
	                html += ': <select class="secondselect">';
	
	                for (var i = 0; i < 60; i++) {
	                    var padded = i < 10 ? '0' + i : i;
	                    var time = selected.clone().second(i);
	
	                    var disabled = false;
	                    if (minDate && time.isBefore(minDate))
	                        disabled = true;
	                    if (maxDate && time.isAfter(maxDate))
	                        disabled = true;
	
	                    if (selected.second() == i && !disabled) {
	                        html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
	                    } else if (disabled) {
	                        html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
	                    } else {
	                        html += '<option value="' + i + '">' + padded + '</option>';
	                    }
	                }
	
	                html += '</select> ';
	            }
	
	            //
	            // AM/PM
	            //
	
	            if (!this.timePicker24Hour) {
	                html += '<select class="ampmselect">';
	
	                var am_html = '';
	                var pm_html = '';
	
	                if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate))
	                    am_html = ' disabled="disabled" class="disabled"';
	
	                if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate))
	                    pm_html = ' disabled="disabled" class="disabled"';
	
	                if (selected.hour() >= 12) {
	                    html += '<option value="AM"' + am_html + '>AM</option><option value="PM" selected="selected"' + pm_html + '>PM</option>';
	                } else {
	                    html += '<option value="AM" selected="selected"' + am_html + '>AM</option><option value="PM"' + pm_html + '>PM</option>';
	                }
	
	                html += '</select>';
	            }
	
	            this.container.find('.calendar.' + side + ' .calendar-time div').html(html);
	
	        },
	
	        updateFormInputs: function() {
	
	            //ignore mouse movements while an above-calendar text input has focus
	            if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus"))
	                return;
	
	            this.container.find('input[name=daterangepicker_start]').val(this.startDate.format(this.locale.format));
	            if (this.endDate)
	                this.container.find('input[name=daterangepicker_end]').val(this.endDate.format(this.locale.format));
	
	            if (this.singleDatePicker || (this.endDate && (this.startDate.isBefore(this.endDate) || this.startDate.isSame(this.endDate)))) {
	                this.container.find('button.applyBtn').removeAttr('disabled');
	            } else {
	                this.container.find('button.applyBtn').attr('disabled', 'disabled');
	            }
	
	        },
	
	        move: function() {
	            var parentOffset = { top: 0, left: 0 },
	                containerTop;
	            var parentRightEdge = $(window).width();
	            if (!this.parentEl.is('body')) {
	                parentOffset = {
	                    top: this.parentEl.offset().top - this.parentEl.scrollTop(),
	                    left: this.parentEl.offset().left - this.parentEl.scrollLeft()
	                };
	                parentRightEdge = this.parentEl[0].clientWidth + this.parentEl.offset().left;
	            }
	
	            if (this.drops == 'up')
	                containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
	            else
	                containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
	            this.container[this.drops == 'up' ? 'addClass' : 'removeClass']('dropup');
	
	            if (this.opens == 'left') {
	                this.container.css({
	                    top: containerTop,
	                    right: parentRightEdge - this.element.offset().left - this.element.outerWidth(),
	                    left: 'auto'
	                });
	                if (this.container.offset().left < 0) {
	                    this.container.css({
	                        right: 'auto',
	                        left: 9
	                    });
	                }
	            } else if (this.opens == 'center') {
	                this.container.css({
	                    top: containerTop,
	                    left: this.element.offset().left - parentOffset.left + this.element.outerWidth() / 2
	                            - this.container.outerWidth() / 2,
	                    right: 'auto'
	                });
	                if (this.container.offset().left < 0) {
	                    this.container.css({
	                        right: 'auto',
	                        left: 9
	                    });
	                }
	            } else {
	                this.container.css({
	                    top: containerTop,
	                    left: this.element.offset().left - parentOffset.left,
	                    right: 'auto'
	                });
	                if (this.container.offset().left + this.container.outerWidth() > $(window).width()) {
	                    this.container.css({
	                        left: 'auto',
	                        right: 0
	                    });
	                }
	            }
	        },
	
	        show: function(e) {
	            if (this.isShowing) return;
	
	            // Create a click proxy that is private to this instance of datepicker, for unbinding
	            this._outsideClickProxy = $.proxy(function(e) { this.outsideClick(e); }, this);
	
	            // Bind global datepicker mousedown for hiding and
	            $(document)
	              .on('mousedown.daterangepicker', this._outsideClickProxy)
	              // also support mobile devices
	              .on('touchend.daterangepicker', this._outsideClickProxy)
	              // also explicitly play nice with Bootstrap dropdowns, which stopPropagation when clicking them
	              .on('click.daterangepicker', '[data-toggle=dropdown]', this._outsideClickProxy)
	              // and also close when focus changes to outside the picker (eg. tabbing between controls)
	              .on('focusin.daterangepicker', this._outsideClickProxy);
	
	            // Reposition the picker if the window is resized while it's open
	            $(window).on('resize.daterangepicker', $.proxy(function(e) { this.move(e); }, this));
	
	            this.oldStartDate = this.startDate.clone();
	            this.oldEndDate = this.endDate.clone();
	            this.previousRightTime = this.endDate.clone();
	
	            this.updateView();
	            this.container.show();
	            this.move();
	            this.element.trigger('show.daterangepicker', this);
	            this.isShowing = true;
	        },
	
	        hide: function(e) {
	            if (!this.isShowing) return;
	
	            //incomplete date selection, revert to last values
	            if (!this.endDate) {
	                this.startDate = this.oldStartDate.clone();
	                this.endDate = this.oldEndDate.clone();
	            }
	
	            //if a new date range was selected, invoke the user callback function
	            if (!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate))
	                this.callback(this.startDate, this.endDate, this.chosenLabel);
	
	            //if picker is attached to a text input, update it
	            this.updateElement();
	
	            $(document).off('.daterangepicker');
	            $(window).off('.daterangepicker');
	            this.container.hide();
	            this.element.trigger('hide.daterangepicker', this);
	            this.isShowing = false;
	        },
	
	        toggle: function(e) {
	            if (this.isShowing) {
	                this.hide();
	            } else {
	                this.show();
	            }
	        },
	
	        outsideClick: function(e) {
	            var target = $(e.target);
	            // if the page is clicked anywhere except within the daterangerpicker/button
	            // itself then call this.hide()
	            if (
	                // ie modal dialog fix
	                e.type == "focusin" ||
	                target.closest(this.element).length ||
	                target.closest(this.container).length ||
	                target.closest('.calendar-table').length
	                ) return;
	            this.hide();
	            this.element.trigger('outsideClick.daterangepicker', this);
	        },
	
	        showCalendars: function() {
	            this.container.addClass('show-calendar');
	            this.move();
	            this.element.trigger('showCalendar.daterangepicker', this);
	        },
	
	        hideCalendars: function() {
	            this.container.removeClass('show-calendar');
	            this.element.trigger('hideCalendar.daterangepicker', this);
	        },
	
	        hoverRange: function(e) {
	
	            //ignore mouse movements while an above-calendar text input has focus
	            if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus"))
	                return;
	
	            var label = e.target.getAttribute('data-range-key');
	
	            if (label == this.locale.customRangeLabel) {
	                this.updateView();
	            } else {
	                var dates = this.ranges[label];
	                this.container.find('input[name=daterangepicker_start]').val(dates[0].format(this.locale.format));
	                this.container.find('input[name=daterangepicker_end]').val(dates[1].format(this.locale.format));
	            }
	
	        },
	
	        clickRange: function(e) {
	            var label = e.target.getAttribute('data-range-key');
	            this.chosenLabel = label;
	            if (label == this.locale.customRangeLabel) {
	                this.showCalendars();
	            } else {
	                var dates = this.ranges[label];
	                this.startDate = dates[0];
	                this.endDate = dates[1];
	
	                if (!this.timePicker) {
	                    this.startDate.startOf('day');
	                    this.endDate.endOf('day');
	                }
	
	                if (!this.alwaysShowCalendars)
	                    this.hideCalendars();
	                this.clickApply();
	            }
	        },
	
	        clickPrev: function(e) {
	            var cal = $(e.target).parents('.calendar');
	            if (cal.hasClass('left')) {
	                this.leftCalendar.month.subtract(1, 'month');
	                if (this.linkedCalendars)
	                    this.rightCalendar.month.subtract(1, 'month');
	            } else {
	                this.rightCalendar.month.subtract(1, 'month');
	            }
	            this.updateCalendars();
	        },
	
	        clickNext: function(e) {
	            var cal = $(e.target).parents('.calendar');
	            if (cal.hasClass('left')) {
	                this.leftCalendar.month.add(1, 'month');
	            } else {
	                this.rightCalendar.month.add(1, 'month');
	                if (this.linkedCalendars)
	                    this.leftCalendar.month.add(1, 'month');
	            }
	            this.updateCalendars();
	        },
	
	        hoverDate: function(e) {
	
	            //ignore mouse movements while an above-calendar text input has focus
	            //if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus"))
	            //    return;
	
	            //ignore dates that can't be selected
	            if (!$(e.target).hasClass('available')) return;
	
	            //have the text inputs above calendars reflect the date being hovered over
	            var title = $(e.target).attr('data-title');
	            var row = title.substr(1, 1);
	            var col = title.substr(3, 1);
	            var cal = $(e.target).parents('.calendar');
	            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
	
	            if (this.endDate && !this.container.find('input[name=daterangepicker_start]').is(":focus")) {
	                this.container.find('input[name=daterangepicker_start]').val(date.format(this.locale.format));
	            } else if (!this.endDate && !this.container.find('input[name=daterangepicker_end]').is(":focus")) {
	                this.container.find('input[name=daterangepicker_end]').val(date.format(this.locale.format));
	            }
	
	            //highlight the dates between the start date and the date being hovered as a potential end date
	            var leftCalendar = this.leftCalendar;
	            var rightCalendar = this.rightCalendar;
	            var startDate = this.startDate;
	            if (!this.endDate) {
	                this.container.find('.calendar tbody td').each(function(index, el) {
	
	                    //skip week numbers, only look at dates
	                    if ($(el).hasClass('week')) return;
	
	                    var title = $(el).attr('data-title');
	                    var row = title.substr(1, 1);
	                    var col = title.substr(3, 1);
	                    var cal = $(el).parents('.calendar');
	                    var dt = cal.hasClass('left') ? leftCalendar.calendar[row][col] : rightCalendar.calendar[row][col];
	
	                    if ((dt.isAfter(startDate) && dt.isBefore(date)) || dt.isSame(date, 'day')) {
	                        $(el).addClass('in-range');
	                    } else {
	                        $(el).removeClass('in-range');
	                    }
	
	                });
	            }
	
	        },
	
	        clickDate: function(e) {
	
	            if (!$(e.target).hasClass('available')) return;
	
	            var title = $(e.target).attr('data-title');
	            var row = title.substr(1, 1);
	            var col = title.substr(3, 1);
	            var cal = $(e.target).parents('.calendar');
	            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
	
	            //
	            // this function needs to do a few things:
	            // * alternate between selecting a start and end date for the range,
	            // * if the time picker is enabled, apply the hour/minute/second from the select boxes to the clicked date
	            // * if autoapply is enabled, and an end date was chosen, apply the selection
	            // * if single date picker mode, and time picker isn't enabled, apply the selection immediately
	            // * if one of the inputs above the calendars was focused, cancel that manual input
	            //
	
	            if (this.endDate || date.isBefore(this.startDate, 'day')) { //picking start
	                if (this.timePicker) {
	                    var hour = parseInt(this.container.find('.left .hourselect').val(), 10);
	                    if (!this.timePicker24Hour) {
	                        var ampm = this.container.find('.left .ampmselect').val();
	                        if (ampm === 'PM' && hour < 12)
	                            hour += 12;
	                        if (ampm === 'AM' && hour === 12)
	                            hour = 0;
	                    }
	                    var minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
	                    var second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
	                    date = date.clone().hour(hour).minute(minute).second(second);
	                }
	                this.endDate = null;
	                this.setStartDate(date.clone());
	            } else if (!this.endDate && date.isBefore(this.startDate)) {
	                //special case: clicking the same date for start/end,
	                //but the time of the end date is before the start date
	                this.setEndDate(this.startDate.clone());
	            } else { // picking end
	                if (this.timePicker) {
	                    var hour = parseInt(this.container.find('.right .hourselect').val(), 10);
	                    if (!this.timePicker24Hour) {
	                        var ampm = this.container.find('.right .ampmselect').val();
	                        if (ampm === 'PM' && hour < 12)
	                            hour += 12;
	                        if (ampm === 'AM' && hour === 12)
	                            hour = 0;
	                    }
	                    var minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
	                    var second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
	                    date = date.clone().hour(hour).minute(minute).second(second);
	                }
	                this.setEndDate(date.clone());
	                if (this.autoApply) {
	                  this.calculateChosenLabel();
	                  this.clickApply();
	                }
	            }
	
	            if (this.singleDatePicker) {
	                this.setEndDate(this.startDate);
	                if (!this.timePicker)
	                    this.clickApply();
	            }
	
	            this.updateView();
	
	            //This is to cancel the blur event handler if the mouse was in one of the inputs
	            e.stopPropagation();
	
	        },
	
	        calculateChosenLabel: function () {
	            var customRange = true;
	            var i = 0;
	            for (var range in this.ranges) {
	              if (this.timePicker) {
	                    var format = this.timePickerSeconds ? "YYYY-MM-DD hh:mm:ss" : "YYYY-MM-DD hh:mm";
	                    //ignore times when comparing dates if time picker seconds is not enabled
	                    if (this.startDate.format(format) == this.ranges[range][0].format(format) && this.endDate.format(format) == this.ranges[range][1].format(format)) {
	                        customRange = false;
	                        this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').html();
	                        break;
	                    }
	                } else {
	                    //ignore times when comparing dates if time picker is not enabled
	                    if (this.startDate.format('YYYY-MM-DD') == this.ranges[range][0].format('YYYY-MM-DD') && this.endDate.format('YYYY-MM-DD') == this.ranges[range][1].format('YYYY-MM-DD')) {
	                        customRange = false;
	                        this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').html();
	                        break;
	                    }
	                }
	                i++;
	            }
	            if (customRange) {
	                if (this.showCustomRangeLabel) {
	                    this.chosenLabel = this.container.find('.ranges li:last').addClass('active').html();
	                } else {
	                    this.chosenLabel = null;
	                }
	                this.showCalendars();
	            }
	        },
	
	        clickApply: function(e) {
	            this.hide();
	            this.element.trigger('apply.daterangepicker', this);
	        },
	
	        clickCancel: function(e) {
	            this.startDate = this.oldStartDate;
	            this.endDate = this.oldEndDate;
	            this.hide();
	            this.element.trigger('cancel.daterangepicker', this);
	        },
	
	        monthOrYearChanged: function(e) {
	            var isLeft = $(e.target).closest('.calendar').hasClass('left'),
	                leftOrRight = isLeft ? 'left' : 'right',
	                cal = this.container.find('.calendar.'+leftOrRight);
	
	            // Month must be Number for new moment versions
	            var month = parseInt(cal.find('.monthselect').val(), 10);
	            var year = cal.find('.yearselect').val();
	
	            if (!isLeft) {
	                if (year < this.startDate.year() || (year == this.startDate.year() && month < this.startDate.month())) {
	                    month = this.startDate.month();
	                    year = this.startDate.year();
	                }
	            }
	
	            if (this.minDate) {
	                if (year < this.minDate.year() || (year == this.minDate.year() && month < this.minDate.month())) {
	                    month = this.minDate.month();
	                    year = this.minDate.year();
	                }
	            }
	
	            if (this.maxDate) {
	                if (year > this.maxDate.year() || (year == this.maxDate.year() && month > this.maxDate.month())) {
	                    month = this.maxDate.month();
	                    year = this.maxDate.year();
	                }
	            }
	
	            if (isLeft) {
	                this.leftCalendar.month.month(month).year(year);
	                if (this.linkedCalendars)
	                    this.rightCalendar.month = this.leftCalendar.month.clone().add(1, 'month');
	            } else {
	                this.rightCalendar.month.month(month).year(year);
	                if (this.linkedCalendars)
	                    this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, 'month');
	            }
	            this.updateCalendars();
	        },
	
	        timeChanged: function(e) {
	
	            var cal = $(e.target).closest('.calendar'),
	                isLeft = cal.hasClass('left');
	
	            var hour = parseInt(cal.find('.hourselect').val(), 10);
	            var minute = parseInt(cal.find('.minuteselect').val(), 10);
	            var second = this.timePickerSeconds ? parseInt(cal.find('.secondselect').val(), 10) : 0;
	
	            if (!this.timePicker24Hour) {
	                var ampm = cal.find('.ampmselect').val();
	                if (ampm === 'PM' && hour < 12)
	                    hour += 12;
	                if (ampm === 'AM' && hour === 12)
	                    hour = 0;
	            }
	
	            if (isLeft) {
	                var start = this.startDate.clone();
	                start.hour(hour);
	                start.minute(minute);
	                start.second(second);
	                this.setStartDate(start);
	                if (this.singleDatePicker) {
	                    this.endDate = this.startDate.clone();
	                } else if (this.endDate && this.endDate.format('YYYY-MM-DD') == start.format('YYYY-MM-DD') && this.endDate.isBefore(start)) {
	                    this.setEndDate(start.clone());
	                }
	            } else if (this.endDate) {
	                var end = this.endDate.clone();
	                end.hour(hour);
	                end.minute(minute);
	                end.second(second);
	                this.setEndDate(end);
	            }
	
	            //update the calendars so all clickable dates reflect the new time component
	            this.updateCalendars();
	
	            //update the form inputs above the calendars with the new time
	            this.updateFormInputs();
	
	            //re-render the time pickers because changing one selection can affect what's enabled in another
	            this.renderTimePicker('left');
	            this.renderTimePicker('right');
	
	        },
	
	        formInputsChanged: function(e) {
	            var isRight = $(e.target).closest('.calendar').hasClass('right');
	            var start = moment(this.container.find('input[name="daterangepicker_start"]').val(), this.locale.format);
	            var end = moment(this.container.find('input[name="daterangepicker_end"]').val(), this.locale.format);
	
	            if (start.isValid() && end.isValid()) {
	
	                if (isRight && end.isBefore(start))
	                    start = end.clone();
	
	                this.setStartDate(start);
	                this.setEndDate(end);
	
	                if (isRight) {
	                    this.container.find('input[name="daterangepicker_start"]').val(this.startDate.format(this.locale.format));
	                } else {
	                    this.container.find('input[name="daterangepicker_end"]').val(this.endDate.format(this.locale.format));
	                }
	
	            }
	
	            this.updateView();
	        },
	
	        formInputsFocused: function(e) {
	
	            // Highlight the focused input
	            this.container.find('input[name="daterangepicker_start"], input[name="daterangepicker_end"]').removeClass('active');
	            $(e.target).addClass('active');
	
	            // Set the state such that if the user goes back to using a mouse, 
	            // the calendars are aware we're selecting the end of the range, not
	            // the start. This allows someone to edit the end of a date range without
	            // re-selecting the beginning, by clicking on the end date input then
	            // using the calendar.
	            var isRight = $(e.target).closest('.calendar').hasClass('right');
	            if (isRight) {
	                this.endDate = null;
	                this.setStartDate(this.startDate.clone());
	                this.updateView();
	            }
	
	        },
	
	        formInputsBlurred: function(e) {
	
	            // this function has one purpose right now: if you tab from the first
	            // text input to the second in the UI, the endDate is nulled so that
	            // you can click another, but if you tab out without clicking anything
	            // or changing the input value, the old endDate should be retained
	
	            if (!this.endDate) {
	                var val = this.container.find('input[name="daterangepicker_end"]').val();
	                var end = moment(val, this.locale.format);
	                if (end.isValid()) {
	                    this.setEndDate(end);
	                    this.updateView();
	                }
	            }
	
	        },
	
	        formInputsKeydown: function(e) {
	            // This function ensures that if the 'enter' key was pressed in the input, then the calendars
	            // are updated with the startDate and endDate.
	            // This behaviour is automatic in Chrome/Firefox/Edge but not in IE 11 hence why this exists.
	            // Other browsers and versions of IE are untested and the behaviour is unknown.
	            if (e.keyCode === 13) {
	                // Prevent the calendar from being updated twice on Chrome/Firefox/Edge
	                e.preventDefault(); 
	                this.formInputsChanged(e);
	            }
	        },
	
	
	        elementChanged: function() {
	            if (!this.element.is('input')) return;
	            if (!this.element.val().length) return;
	
	            var dateString = this.element.val().split(this.locale.separator),
	                start = null,
	                end = null;
	
	            if (dateString.length === 2) {
	                start = moment(dateString[0], this.locale.format);
	                end = moment(dateString[1], this.locale.format);
	            }
	
	            if (this.singleDatePicker || start === null || end === null) {
	                start = moment(this.element.val(), this.locale.format);
	                end = start;
	            }
	
	            if (!start.isValid() || !end.isValid()) return;
	
	            this.setStartDate(start);
	            this.setEndDate(end);
	            this.updateView();
	        },
	
	        keydown: function(e) {
	            //hide on tab or enter
	            if ((e.keyCode === 9) || (e.keyCode === 13)) {
	                this.hide();
	            }
	
	            //hide on esc and prevent propagation
	            if (e.keyCode === 27) {
	                e.preventDefault();
	                e.stopPropagation();
	
	                this.hide();
	            }
	        },
	
	        updateElement: function() {
	            if (this.element.is('input') && !this.singleDatePicker && this.autoUpdateInput) {
	                this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
	                this.element.trigger('change');
	            } else if (this.element.is('input') && this.autoUpdateInput) {
	                this.element.val(this.startDate.format(this.locale.format));
	                this.element.trigger('change');
	            }
	        },
	
	        remove: function() {
	            this.container.remove();
	            this.element.off('.daterangepicker');
	            this.element.removeData();
	        }
	
	    };
	
	    $.fn.daterangepicker = function(options, callback) {
	        var implementOptions = $.extend(true, {}, $.fn.daterangepicker.defaultOptions, options);
	        this.each(function() {
	            var el = $(this);
	            if (el.data('daterangepicker'))
	                el.data('daterangepicker').remove();
	            el.data('daterangepicker', new DateRangePicker(el, implementOptions, callback));
	        });
	        return this;
	    };
	
	    return DateRangePicker;
	
	}));


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(743);
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var ng2_daterangepicker_1 = __webpack_require__(1223);
	var date_range_picker_module_1 = __webpack_require__(1222);
	var moment = __webpack_require__(838);
	var translate_1 = __webpack_require__(302);
	exports.DATE_RANGE_PICKER_CONTROL_VALUE_ACCESSOR = {
	    provide: forms_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return DateRangePickerComponent; }),
	    multi: true
	};
	var DateRangePickerComponent = (function () {
	    function DateRangePickerComponent(daterangepickerOptions, translations) {
	        this.beginPropName = 'beginDate';
	        this.endPropName = 'endDate';
	        this.value = {};
	        this.onChange = new core_1.EventEmitter();
	        this.onTouchedCallback = new core_1.EventEmitter();
	        // Reset global config on every instantiation so that limits set by other
	        // pages (e.g. dateLimit: { months: 12 } from Directors or Provider Reports)
	        // do not carry over here.
	        daterangepickerOptions.settings = {
	            opens: 'down',
	            drops: 'down',
	            showDropdowns: true,
	            dateLimit: false,
	            minYear: 2000,
	            maxYear: new Date().getFullYear(),
	            locale: {
	                format: date_range_picker_module_1.DATE_FORMAT,
	                firstDay: 1,
	                cancelLabel: translations.getValue('COMMON.CLEAR')
	            },
	            alwaysShowCalendars: false
	        };
	    }
	    DateRangePickerComponent.prototype.writeValue = function (obj) {
	        if (obj
	            && obj.hasOwnProperty(this.beginPropName)
	            && obj.hasOwnProperty(this.endPropName)) {
	            this.value = (_a = {},
	                _a[this.beginPropName] = obj[this.beginPropName],
	                _a[this.endPropName] = obj[this.endPropName],
	                _a);
	            if (!!this.picker && !!this.picker.datePicker) {
	                this.picker.datePicker.setStartDate(obj[this.beginPropName]);
	                this.picker.datePicker.setEndDate(obj[this.endPropName]);
	            }
	        }
	        else {
	            this.value = undefined;
	            if (!!this.picker && !!this.picker.datePicker) {
	                this.picker.datePicker.setStartDate(undefined);
	                this.picker.datePicker.setEndDate(undefined);
	            }
	        }
	        var _a;
	    };
	    DateRangePickerComponent.prototype.registerOnChange = function (fn) {
	        this.onChange.subscribe(fn);
	    };
	    DateRangePickerComponent.prototype.registerOnTouched = function (fn) {
	        this.onTouchedCallback.subscribe(fn);
	    };
	    DateRangePickerComponent.prototype.isEmpty = function () {
	        return this.value === undefined;
	    };
	    DateRangePickerComponent.prototype.getViewValue = function () {
	        if (this.value) {
	            return this.value[this.beginPropName] + " - " + this.value[this.endPropName];
	        }
	        else {
	            return '';
	        }
	    };
	    DateRangePickerComponent.prototype.onDateRangeSelect = function (value) {
	        /* Save and emit new value */
	        this.onChange.emit(this.value = (_a = {},
	            _a[this.beginPropName] = util_1.isNullOrUndefined(value.start) ? undefined : value.start.format(date_range_picker_module_1.DATE_FORMAT),
	            _a[this.endPropName] = util_1.isNullOrUndefined(value.end) ? undefined : value.end.format(date_range_picker_module_1.DATE_FORMAT),
	            _a));
	        var _a;
	    };
	    DateRangePickerComponent.prototype.onDateRangeCancel = function () {
	        /* Save and emit empty value */
	        this.onChange.emit(this.value = undefined);
	    };
	    /**
	     * A period typed by hand ("dd.MM.yyyy - dd.MM.yyyy") is applied on Enter or when leaving the field, as if it had
	     * been picked in the calendar. Anything else that is not empty goes back to the current value.
	     */
	    DateRangePickerComponent.prototype.applyTypedValue = function () {
	        var typed = (this.dateInput.nativeElement.value || '').trim();
	        if (typed === '' || typed === this.getViewValue()) {
	            return;
	        }
	        var parts = typed.split(/\s*-\s*/);
	        var start = parts.length === 2 ? moment(parts[0], date_range_picker_module_1.DATE_FORMAT, true) : null;
	        var end = parts.length === 2 ? moment(parts[1], date_range_picker_module_1.DATE_FORMAT, true) : null;
	        if (!start || !end || !start.isValid() || !end.isValid() || end.isBefore(start)) {
	            this.dateInput.nativeElement.value = this.getViewValue();
	            this.inputValue = this.dateInput.nativeElement.value;
	            return;
	        }
	        if (!!this.picker && !!this.picker.datePicker) {
	            this.picker.datePicker.setStartDate(start);
	            this.picker.datePicker.setEndDate(end);
	        }
	        this.onDateRangeSelect({ start: start, end: end });
	        this.inputValue = this.getViewValue();
	    };
	    DateRangePickerComponent.prototype.checkValue = function () {
	        if (this.inputValue !== this.dateInput.nativeElement.value) {
	            this.inputValue = this.dateInput.nativeElement.value;
	            if (this.inputValue === '') {
	                this.onDateRangeCancel();
	            }
	        }
	    };
	    __decorate([
	        core_1.Input('id'),
	        __metadata("design:type", String)
	    ], DateRangePickerComponent.prototype, "id", void 0);
	    __decorate([
	        core_1.Input('name'),
	        __metadata("design:type", String)
	    ], DateRangePickerComponent.prototype, "name", void 0);
	    __decorate([
	        core_1.Input('beginPropName'),
	        __metadata("design:type", String)
	    ], DateRangePickerComponent.prototype, "beginPropName", void 0);
	    __decorate([
	        core_1.Input('endPropName'),
	        __metadata("design:type", String)
	    ], DateRangePickerComponent.prototype, "endPropName", void 0);
	    __decorate([
	        core_1.ViewChild(ng2_daterangepicker_1.DaterangePickerComponent),
	        __metadata("design:type", ng2_daterangepicker_1.DaterangePickerComponent)
	    ], DateRangePickerComponent.prototype, "picker", void 0);
	    __decorate([
	        core_1.ViewChild('dateInput'),
	        __metadata("design:type", core_1.ElementRef)
	    ], DateRangePickerComponent.prototype, "dateInput", void 0);
	    DateRangePickerComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-daterangepicker',
	            providers: [exports.DATE_RANGE_PICKER_CONTROL_VALUE_ACCESSOR],
	            template: "\n        <div [id]=\"id\"\n             class=\"input-group period-block\"\n             daterangepicker\n             (selected)=\"onDateRangeSelect($event)\"\n             (cancelDaterangepicker)=\"onDateRangeCancel()\">\n\n            <input #dateInput\n                   [name]=\"name\"\n                   class=\"form-control\"\n                   [value]=\"getViewValue()\"\n                   (keyup)=\"checkValue()\"\n                   (keyup.enter)=\"applyTypedValue()\"\n                   (blur)=\"applyTypedValue()\"\n                   placeholder=\"{{ 'TRANSFERS.HISTORY.FILTER.PLACEHOLDER.PERIOD' | translate }}\">\n\n            <span class=\"input-group-btn\">\n                <a type=\"button\" class=\"btn btn-default calendar-button\">\n                    <i class=\"fa fa-calendar\"></i>\n                </a>\n            </span>\n        </div>\n    "
	        }),
	        __metadata("design:paramtypes", [ng2_daterangepicker_1.DaterangepickerConfig, translate_1.TranslateManager])
	    ], DateRangePickerComponent);
	    return DateRangePickerComponent;
	}());
	exports.DateRangePickerComponent = DateRangePickerComponent;


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var util_1 = __webpack_require__(743);
	var IbanControlDirective = (function () {
	    function IbanControlDirective(model) {
	        this.model = model;
	        this.control = model.control;
	    }
	    IbanControlDirective.prototype.onInput = function (value) {
	        var rawValue = value.replace(/\s/g, '');
	        var formattedValue = this.toFormattedValue(rawValue);
	        //
	        this.model.valueAccessor.writeValue(formattedValue);
	        this.model.viewToModelUpdate(rawValue);
	        this.control.markAsTouched();
	        this.control.setValue(rawValue, { emitModelToViewChange: false });
	        this.control.updateValueAndValidity();
	    };
	    IbanControlDirective.prototype.toFormattedValue = function (value) {
	        return (!util_1.isNullOrUndefined(value)) ? value.match(/^$|.{1,4}/g).join(' ') : value;
	    };
	    __decorate([
	        core_1.HostListener('input', ['$event.target.value']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], IbanControlDirective.prototype, "onInput", null);
	    IbanControlDirective = __decorate([
	        core_1.Directive({
	            selector: '[ngModel][ibanControl]'
	        }),
	        __param(0, core_1.Self()),
	        __metadata("design:paramtypes", [forms_1.NgModel])
	    ], IbanControlDirective);
	    return IbanControlDirective;
	}());
	exports.IbanControlDirective = IbanControlDirective;


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var leave_block_component_1 = __webpack_require__(1231);
	var leave_block_guard_1 = __webpack_require__(1236);
	__export(__webpack_require__(1231));
	__export(__webpack_require__(1236));
	exports.LEAVE_BLOCKABLE_COMPONENTS = [
	    leave_block_component_1.LeaveBlockComponent
	];
	exports.LEAVE_BLOCKABLE_PROVIDERS = [
	    leave_block_guard_1.LeaveBlockGuard
	];


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var router_1 = __webpack_require__(270);
	var security_1 = __webpack_require__(736);
	var option_dialog_decorator_1 = __webpack_require__(1232);
	var LeaveBlockComponent = (function () {
	    function LeaveBlockComponent(backBloackable, _sessionService, _changeDetectorRef, _router) {
	        var _this = this;
	        this.backBloackable = backBloackable;
	        this._sessionService = _sessionService;
	        this._changeDetectorRef = _changeDetectorRef;
	        this._router = _router;
	        this.allowedToGo = false;
	        this.nextUrl = '';
	        this.previousUrl = ';';
	        this.onOkModalEvent = new core_1.EventEmitter();
	        _router.events.subscribe(function (event) {
	            if (event instanceof router_1.NavigationStart) {
	                _this.nextUrl = event.url;
	            }
	            if (event instanceof router_1.NavigationEnd) {
	                _this.previousUrl = event.url;
	            }
	        });
	    }
	    LeaveBlockComponent.prototype.onBackPressed = function () {
	        this._router.navigateByUrl(this.previousUrl);
	        this._changeDetectorRef.markForCheck();
	        history.pushState(null, null, this.componentUrl);
	    };
	    LeaveBlockComponent.prototype.ngOnDestroy = function () {
	        window.removeEventListener('popstate', null, false);
	    };
	    LeaveBlockComponent.prototype.showDialogOnNavigateBlock = function () {
	        this.dialog
	            .showConfirmDialog({
	            title: 'COMMON.LEAVE_BLOCK.TITLE',
	            message: 'COMMON.LEAVE_BLOCK.MESSAGE',
	            confirmButtonText: 'COMMON.LEAVE_BLOCK.LEAVE',
	            cancelButtonText: 'COMMON.LEAVE_BLOCK.STAY'
	        })
	            .onConfirmAction(this.handleLeaveAction.bind(this))
	            .onCancelAction(this.handleStayAction.bind(this));
	    };
	    LeaveBlockComponent.prototype.checkAllowedToGo = function () {
	        if (this.checkIsRedirectAfterSessionExpired()) {
	            return true;
	        }
	        if (this.nextUrl == this.componentUrl || this.backBloackable.isComponentAllowedToLeave()) {
	            return this.allowedToGo = true;
	        }
	        else {
	            if (this.allowedToGo) {
	                this.allowedToGo = false;
	                return true;
	            }
	            else {
	                return false;
	            }
	        }
	    };
	    LeaveBlockComponent.prototype.checkIsRedirectAfterSessionExpired = function () {
	        if (this._sessionService.isSessionExpired()) {
	            return true;
	        }
	    };
	    LeaveBlockComponent.prototype.handleLeaveAction = function () {
	        this.allowedToGo = true;
	        this._router.navigateByUrl(this.nextUrl);
	        this.onOkModalEvent.emit();
	    };
	    LeaveBlockComponent.prototype.handleStayAction = function () {
	        this.allowedToGo = false;
	    };
	    __decorate([
	        core_1.Input('componentUrl'),
	        __metadata("design:type", String)
	    ], LeaveBlockComponent.prototype, "componentUrl", void 0);
	    __decorate([
	        core_1.Output('on-ok-modal'),
	        __metadata("design:type", core_1.EventEmitter)
	    ], LeaveBlockComponent.prototype, "onOkModalEvent", void 0);
	    __decorate([
	        option_dialog_decorator_1.InjectOptionDialog('leave-block-dialog'),
	        __metadata("design:type", Object)
	    ], LeaveBlockComponent.prototype, "dialog", void 0);
	    __decorate([
	        core_1.HostListener('window.popstate'),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", []),
	        __metadata("design:returntype", void 0)
	    ], LeaveBlockComponent.prototype, "onBackPressed", null);
	    LeaveBlockComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-leave-block',
	            template: __webpack_require__(1235)
	        }),
	        __param(0, core_1.Inject('LeaveBlockable')),
	        __param(1, core_1.Inject(core_1.forwardRef(function () { return security_1.SessionService; }))),
	        __metadata("design:paramtypes", [Object, security_1.SessionService,
	            core_1.ChangeDetectorRef,
	            router_1.Router])
	    ], LeaveBlockComponent);
	    return LeaveBlockComponent;
	}());
	exports.LeaveBlockComponent = LeaveBlockComponent;


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var option_dialog_accessor_1 = __webpack_require__(1233);
	var OptionDialogResultImpl = (function () {
	    function OptionDialogResultImpl(observable) {
	        var _this = this;
	        observable.subscribe(function (value) { return _this._apply && _this._apply(value); }, function (value) { return _this._cancel && _this._cancel(value); });
	    }
	    OptionDialogResultImpl.prototype.onConfirmAction = function (callback) {
	        this._apply = callback;
	        return this;
	    };
	    OptionDialogResultImpl.prototype.onCancelAction = function (callback) {
	        this._cancel = callback;
	        return this;
	    };
	    return OptionDialogResultImpl;
	}());
	var OptionDialogAccessorDelegate = (function () {
	    function OptionDialogAccessorDelegate(_id) {
	        this._id = _id;
	    }
	    OptionDialogAccessorDelegate.prototype.showConfirmDialog = function (opts) {
	        return new OptionDialogResultImpl(option_dialog_accessor_1.OptionDialogStaticAccessor.showConfirmDialog(this._id, opts));
	    };
	    OptionDialogAccessorDelegate.prototype.showInputDialog = function (opts, inputOpts) {
	        return new OptionDialogResultImpl(option_dialog_accessor_1.OptionDialogStaticAccessor.showInputDialog(this._id, opts, inputOpts));
	    };
	    OptionDialogAccessorDelegate.prototype.showMessageDialog = function (opts) {
	        return new OptionDialogResultImpl(option_dialog_accessor_1.OptionDialogStaticAccessor.showMessageDialog(this._id, opts));
	    };
	    return OptionDialogAccessorDelegate;
	}());
	exports.InjectOptionDialog = function (id) {
	    return function (target, property) {
	        target[property] = new OptionDialogAccessorDelegate(id);
	    };
	};


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Observable_1 = __webpack_require__(206);
	var BehaviorSubject_1 = __webpack_require__(271);
	var option_dialog_1 = __webpack_require__(1234);
	var OptionDialogStaticAccessor = (function () {
	    function OptionDialogStaticAccessor() {
	    }
	    OptionDialogStaticAccessor.showConfirmDialog = function (id, opts) {
	        opts.type = option_dialog_1.OptionDialogType.CONFIRM;
	        return OptionDialogStaticAccessor.emitOptionDialogShow(id, { opts: opts });
	    };
	    OptionDialogStaticAccessor.showInputDialog = function (id, opts, inputOpts) {
	        opts.type = option_dialog_1.OptionDialogType.INPUT;
	        return OptionDialogStaticAccessor.emitOptionDialogShow(id, { opts: opts, inputOpts: inputOpts });
	    };
	    OptionDialogStaticAccessor.showMessageDialog = function (id, opts) {
	        opts.type = option_dialog_1.OptionDialogType.MESSAGE;
	        return OptionDialogStaticAccessor.emitOptionDialogShow(id, { opts: opts });
	    };
	    OptionDialogStaticAccessor.onOptionDialogShow = function (callback) {
	        return this._observer.subscribe(function (opts) { return callback(opts); });
	    };
	    OptionDialogStaticAccessor.emitOptionDialogShow = function (id, opts) {
	        return Observable_1.Observable.create(function (observer) {
	            OptionDialogStaticAccessor._observer.next({
	                id: opts.opts.id || id,
	                opts: opts.opts,
	                inputOpts: opts.inputOpts,
	                onApply: function (value) { return observer.next(value); },
	                onCancel: function (value) { return observer.error(value); }
	            });
	        });
	    };
	    OptionDialogStaticAccessor._observer = new BehaviorSubject_1.BehaviorSubject(undefined);
	    return OptionDialogStaticAccessor;
	}());
	exports.OptionDialogStaticAccessor = OptionDialogStaticAccessor;


/***/ }),
/* 1234 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var OptionDialogType;
	(function (OptionDialogType) {
	    OptionDialogType[OptionDialogType["CONFIRM"] = 1] = "CONFIRM";
	    OptionDialogType[OptionDialogType["INPUT"] = 2] = "INPUT";
	    OptionDialogType[OptionDialogType["MESSAGE"] = 3] = "MESSAGE";
	})(OptionDialogType = exports.OptionDialogType || (exports.OptionDialogType = {}));


/***/ }),
/* 1235 */
/***/ (function(module, exports) {

	module.exports = "<div>\n\n</div>"

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var LeaveBlockGuard = (function () {
	    function LeaveBlockGuard() {
	    }
	    LeaveBlockGuard.prototype.canDeactivate = function (component, route, state) {
	        if (component.getLeaveBlockComponent().checkAllowedToGo()) {
	            return true;
	        }
	        else {
	            component.getLeaveBlockComponent().showDialogOnNavigateBlock();
	            return false;
	        }
	    };
	    return LeaveBlockGuard;
	}());
	exports.LeaveBlockGuard = LeaveBlockGuard;


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var modal_body_component_1 = __webpack_require__(1238);
	var modal_footer_component_1 = __webpack_require__(1239);
	var modal_header_component_1 = __webpack_require__(1240);
	var modal_container_component_1 = __webpack_require__(1241);
	var modal_service_1 = __webpack_require__(1242);
	exports.MODAL_POPUP_COMPONENTS = [
	    modal_container_component_1.GentelellaModalContainerComponent,
	    modal_header_component_1.GentelellaModalHeaderComponent,
	    modal_footer_component_1.GentelellaModalFooterComponent,
	    modal_body_component_1.GentelellaModalBodyComponent
	];
	exports.MODAL_POPUP_PROVIDERS = [
	    modal_service_1.ModalService
	];


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var GentelellaModalBodyComponent = (function () {
	    function GentelellaModalBodyComponent() {
	    }
	    GentelellaModalBodyComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-gentelella-modal-body',
	            template: "\n        <div class=\"modal-body\">\n            <ng-content></ng-content>\n        </div>\n    "
	        })
	    ], GentelellaModalBodyComponent);
	    return GentelellaModalBodyComponent;
	}());
	exports.GentelellaModalBodyComponent = GentelellaModalBodyComponent;


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var translate_manager_1 = __webpack_require__(692);
	var GentelellaModalFooterComponent = (function () {
	    function GentelellaModalFooterComponent(_translateService) {
	        this._translateService = _translateService;
	        this.showDefaultButtons = true;
	    }
	    GentelellaModalFooterComponent.prototype.ngOnInit = function () {
	        if (this.showDefaultButtons) {
	            this.dismissButtonLabel = this.dismissButtonLabel || this._translateService.getValue('MODAL.FOOTER.DISMISS');
	            this.saveButtonLabel = this.saveButtonLabel || this._translateService.getValue('MODAL.FOOTER.SAVE');
	            this.dismissButtonAction = new core_1.EventEmitter();
	            this.saveButtonAction = new core_1.EventEmitter();
	        }
	    };
	    GentelellaModalFooterComponent.prototype.dismiss = function () {
	        if (this.showDefaultButtons) {
	            this.dismissButtonAction.emit();
	        }
	    };
	    GentelellaModalFooterComponent.prototype.save = function () {
	        if (this.showDefaultButtons) {
	            this.saveButtonAction.emit();
	        }
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], GentelellaModalFooterComponent.prototype, "showDefaultButtons", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], GentelellaModalFooterComponent.prototype, "dismissButtonLabel", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], GentelellaModalFooterComponent.prototype, "saveButtonLabel", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], GentelellaModalFooterComponent.prototype, "dismissButtonAction", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], GentelellaModalFooterComponent.prototype, "saveButtonAction", void 0);
	    GentelellaModalFooterComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-gentelella-modal-footer',
	            template: "\n        <div class=\"modal-footer\">\n            <ng-content></ng-content>\n            <button *ngIf=\"showDefaultButtons\" type=\"button\" class=\"btn btn-default\" (click)=\"dismiss()\">\n                {{dismissButtonLabel}}\n            </button>\n            <button *ngIf=\"showDefaultButtons\" type=\"button\" class=\"btn btn-primary\" (click)=\"save()\">\n                {{saveButtonLabel}}\n            </button>\n        </div>\n    "
	        }),
	        __metadata("design:paramtypes", [translate_manager_1.TranslateManager])
	    ], GentelellaModalFooterComponent);
	    return GentelellaModalFooterComponent;
	}());
	exports.GentelellaModalFooterComponent = GentelellaModalFooterComponent;


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var GentelellaModalHeaderComponent = (function () {
	    function GentelellaModalHeaderComponent() {
	        this.showDismiss = false;
	        this.dismissHandler = new core_1.EventEmitter(true);
	    }
	    GentelellaModalHeaderComponent.prototype.dismiss = function () {
	        this.dismissHandler.emit();
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], GentelellaModalHeaderComponent.prototype, "showDismiss", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], GentelellaModalHeaderComponent.prototype, "dismissHandler", void 0);
	    GentelellaModalHeaderComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-gentelella-modal-header',
	            template: "\n        <div class=\"modal-header\">\n            <button *ngIf=\"showDismiss\" type=\"button\" class=\"close\" aria-label=\"Dismiss\" (click)=\"dismiss()\">\n                <span aria-hidden=\"true\">&times;</span>\n            </button>\n            <ng-content></ng-content>\n        </div>\n    "
	        })
	    ], GentelellaModalHeaderComponent);
	    return GentelellaModalHeaderComponent;
	}());
	exports.GentelellaModalHeaderComponent = GentelellaModalHeaderComponent;


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var modal_service_1 = __webpack_require__(1242);
	var GentelellaModalContainerComponent = (function () {
	    function GentelellaModalContainerComponent(_modalService, _el) {
	        this._modalService = _modalService;
	        this._el = _el;
	        this.isLarge = false;
	        this.customContentClass = '';
	        this.dialogClass = '';
	        this.visible = false;
	        this.element = _el;
	    }
	    GentelellaModalContainerComponent.prototype.open = function () {
	        this.visible = true;
	    };
	    GentelellaModalContainerComponent.prototype.close = function () {
	        this.visible = false;
	    };
	    GentelellaModalContainerComponent.prototype.ngOnDestroy = function () {
	        this._modalService.remove(this.id);
	        this.element.nativeElement.parentNode.removeChild(this.element.nativeElement);
	    };
	    GentelellaModalContainerComponent.prototype.ngOnInit = function () {
	        var modal = this;
	        // ensure id attribute exists
	        if (!this.id) {
	            console.error('modal must have an id');
	            return;
	        }
	        // move element to bottom of page (just before </body>) so it can be displayed above everything else
	        document.body.appendChild(this.element.nativeElement);
	        // add self (this modal instance) to the modal service so it's accessible from controllers
	        this._modalService.add(this);
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], GentelellaModalContainerComponent.prototype, "id", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], GentelellaModalContainerComponent.prototype, "isLarge", void 0);
	    __decorate([
	        core_1.Input('custom-content-class'),
	        __metadata("design:type", Object)
	    ], GentelellaModalContainerComponent.prototype, "customContentClass", void 0);
	    __decorate([
	        core_1.Input('dialog-class'),
	        __metadata("design:type", Object)
	    ], GentelellaModalContainerComponent.prototype, "dialogClass", void 0);
	    GentelellaModalContainerComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-gentelella-modal-container',
	            template: "\n        <div *ngIf=\"visible\" class=\"modal fade in\" role=\"dialog\" style=\"display: block;\">\n            <div [ngClass]=\"(isLarge ? 'modal-dialog modal-lg' : 'modal-dialog modal-sm') + (dialogClass ? ' ' + dialogClass : '')\">\n                <div class=\"modal-content\" [ngClass]=\"customContentClass\">\n                    <ng-content></ng-content>\n                </div>\n            </div>\n        </div>\n    "
	        }),
	        __metadata("design:paramtypes", [modal_service_1.ModalService, core_1.ElementRef])
	    ], GentelellaModalContainerComponent);
	    return GentelellaModalContainerComponent;
	}());
	exports.GentelellaModalContainerComponent = GentelellaModalContainerComponent;


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var core_1 = __webpack_require__(205);
	var ModalService = (function () {
	    function ModalService() {
	        this.modals = [];
	    }
	    ModalService.prototype.add = function (modal) {
	        // add modal to array of active modals
	        this.modals.push(modal);
	    };
	    ModalService.prototype.remove = function (id) {
	        // remove modal from array of active modals
	        lodash_1.remove(this.modals, function (item) {
	            return item.id === id;
	        });
	    };
	    ModalService.prototype.open = function (id) {
	        // open modal specified by id
	        var modal = this.modals.find(function (item) {
	            return item.id === id;
	        });
	        modal.open();
	    };
	    ModalService.prototype.close = function (id) {
	        // close modal specified by id
	        var modal = this.modals.find(function (item) {
	            return item.id === id;
	        });
	        modal.close();
	    };
	    ModalService = __decorate([
	        core_1.Injectable()
	    ], ModalService);
	    return ModalService;
	}());
	exports.ModalService = ModalService;


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1244));


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var PaginationComponent = (function () {
	    function PaginationComponent() {
	        this.page = 1;
	        this.limit = 20;
	        this.onlyArrows = false;
	        this.limits = [20, 50, 100, 200, 500];
	        this.onPaginationChange = new core_1.EventEmitter();
	    }
	    PaginationComponent.prototype.ngOnInit = function () {
	        this.model = {
	            page: this.page || 1,
	            limit: this.limit || 20
	        };
	    };
	    PaginationComponent.prototype.ngOnChanges = function (changes) {
	        if (changes['page'] && this.model) {
	            this.model.page = this.page || 1;
	        }
	        if (changes['limit'] && this.model) {
	            this.model.limit = this.limit || 20;
	        }
	    };
	    PaginationComponent.prototype.handleRowPerPageSelected = function (limit) {
	        this.model.limit = Number(limit);
	        this.model.page = 1; // Reset to first page when changing rows per page
	        this.onPaginationChange.emit(this.model);
	    };
	    PaginationComponent.prototype.handlePageChange = function (page) {
	        if (page > 0
	            && page != this.pagination.getCurrent()
	            && page <= this.pagination.getLastPage()) {
	            this.model.page = page;
	            this.onPaginationChange.emit(this.model);
	        }
	    };
	    PaginationComponent.prototype.handleClickPrevious = function (pagination) {
	        if (!pagination.isFirstPage()) {
	            pagination.previous();
	        }
	    };
	    PaginationComponent.prototype.handleClickNext = function (pagination) {
	        if (!pagination.isLastPage()) {
	            pagination.next();
	        }
	    };
	    PaginationComponent.prototype.getPaginationValues = function () {
	        return __assign({}, this.model, { page: this.page });
	    };
	    __decorate([
	        core_1.Input('page'),
	        __metadata("design:type", Number)
	    ], PaginationComponent.prototype, "page", void 0);
	    __decorate([
	        core_1.Input('total'),
	        __metadata("design:type", Number)
	    ], PaginationComponent.prototype, "total", void 0);
	    __decorate([
	        core_1.Input('limit'),
	        __metadata("design:type", Number)
	    ], PaginationComponent.prototype, "limit", void 0);
	    __decorate([
	        core_1.Input('id'),
	        __metadata("design:type", String)
	    ], PaginationComponent.prototype, "id", void 0);
	    __decorate([
	        core_1.Input('onlyArrows'),
	        __metadata("design:type", Boolean)
	    ], PaginationComponent.prototype, "onlyArrows", void 0);
	    __decorate([
	        core_1.Input('limits'),
	        __metadata("design:type", Array)
	    ], PaginationComponent.prototype, "limits", void 0);
	    __decorate([
	        core_1.Output('onPaginationChange'),
	        __metadata("design:type", core_1.EventEmitter)
	    ], PaginationComponent.prototype, "onPaginationChange", void 0);
	    __decorate([
	        core_1.ViewChild('pagination'),
	        __metadata("design:type", Object)
	    ], PaginationComponent.prototype, "pagination", void 0);
	    PaginationComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-pagination',
	            template: __webpack_require__(1245)
	        })
	    ], PaginationComponent);
	    return PaginationComponent;
	}());
	exports.PaginationComponent = PaginationComponent;


/***/ }),
/* 1245 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"filter-container\">\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div class=\"form-horizontal\">\n                <div class=\"row\">\n                    <div class=\"col-sm-4 col-xs-12 text-left\">\n                        <div class=\"form-group\">\n                            <label class=\"control-label col-sm-4 col-xs-12\" style=\"text-align: left; width: 125px\">\n                                {{'COMMON.ROW_PER_PAGE' | translate}}:\n                            </label>\n\n                            <div class=\"col-sm-4 col-xs-12\">\n                                <select id=\"rowSelector\"\n                                        class=\"form-control\"\n                                        name=\"rowSelector\"\n                                        style=\"width: 80px;\"\n                                        [ngModel]=\"model.limit\"\n                                        (ngModelChange)=\"handleRowPerPageSelected($event)\">\n\n                                    <option *ngFor=\"let row of limits\" [value]=\"row\">\n                                        {{ row }}\n                                    </option>\n                                </select>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class=\"col-xs-8 text-right\">\n                        <pagination-template [id]=\"id\" #pagination=\"paginationApi\" (pageChange)=\"handlePageChange($event)\">\n                            <nav class=\"pagination-controls\">\n                                <ul class=\"pagination\">\n                                    <li [class.disabled]=\"pagination.isFirstPage()\">\n                                        <a (click)=\"handleClickPrevious(pagination)\">\n                                            <i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i>\n                                        </a>\n                                    </li>\n                                    <ng-container *ngIf=\"!onlyArrows\">\n                                        <li *ngFor=\"let page of pagination.pages\"\n                                            [class.active]=\"pagination.getCurrent() === page.value\">\n                                            <a (click)=\"pagination.setCurrent(page.value)\">\n                                                <span>{{ page.label }}</span>\n                                            </a>\n                                        </li>\n                                    </ng-container>\n\n                                    <li [class.disabled]=\"pagination.isLastPage()\">\n                                        <a (click)=\"handleClickNext(pagination)\">\n                                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                                        </a>\n                                    </li>\n                                </ul>\n                            </nav>\n                        </pagination-template>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var money_pipe_1 = __webpack_require__(1247);
	var pipes_1 = __webpack_require__(1248);
	var capitalize_pipe_1 = __webpack_require__(1250);
	exports.PIPES = [
	    money_pipe_1.MoneyPipe,
	    pipes_1.KeysPipe,
	    capitalize_pipe_1.CapitalizePipe
	];


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(743);
	var lodash_1 = __webpack_require__(268);
	var core_1 = __webpack_require__(205);
	var MoneyPipe = (function () {
	    function MoneyPipe() {
	    }
	    MoneyPipe.prototype.transform = function (value, currencyFirst) {
	        if (value === undefined) {
	            return '';
	        }
	        return this.isMoney(value)
	            ? this.transformMoney(value, util_1.isNullOrUndefined(currencyFirst) || currencyFirst)
	            : this.transformAmount(value);
	    };
	    MoneyPipe.prototype.isMoney = function (value) {
	        return lodash_1.has(value, 'amount')
	            || lodash_1.has(value, 'currency_code');
	    };
	    MoneyPipe.prototype.transformMoney = function (value, currencyFirst) {
	        var amount = this.transformAmount(value.amount);
	        var currency = this.transformCurrency(value.currency_code);
	        if (currencyFirst) {
	            return currency + ' ' + amount;
	        }
	        return amount + ' ' + currency;
	    };
	    MoneyPipe.prototype.transformAmount = function (value) {
	        var parts = lodash_1.split(String(value), '.');
	        var wholePart = lodash_1.get(parts, '[0]', '0');
	        var fraction = lodash_1.get(parts, '[1]', '0');
	        return wholePart + '.' + lodash_1.padEnd(fraction, 2, '0');
	    };
	    MoneyPipe.prototype.transformCurrency = function (value) {
	        return util_1.isNullOrUndefined(value) ? '' : value;
	    };
	    MoneyPipe = __decorate([
	        core_1.Pipe({ name: 'money' })
	    ], MoneyPipe);
	    return MoneyPipe;
	}());
	exports.MoneyPipe = MoneyPipe;


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1249));


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var KeysPipe = (function () {
	    function KeysPipe() {
	    }
	    KeysPipe.prototype.transform = function (value, args) {
	        if (args === void 0) { args = null; }
	        return Object.keys(value);
	    };
	    KeysPipe = __decorate([
	        core_1.Pipe({ name: 'keys' })
	    ], KeysPipe);
	    return KeysPipe;
	}());
	exports.KeysPipe = KeysPipe;


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var CapitalizePipe = (function () {
	    function CapitalizePipe() {
	    }
	    CapitalizePipe.prototype.transform = function (value, args) {
	        if (value) {
	            return value.charAt(0).toUpperCase() + value.slice(1);
	        }
	    };
	    CapitalizePipe = __decorate([
	        core_1.Pipe({ name: 'capitalize' })
	    ], CapitalizePipe);
	    return CapitalizePipe;
	}());
	exports.CapitalizePipe = CapitalizePipe;


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var profile_settings_revenue_component_1 = __webpack_require__(1252);
	var revenue_distribution_exception_component_1 = __webpack_require__(1256);
	var revenue_distribution_service_1 = __webpack_require__(1262);
	var distribution_rules_component_1 = __webpack_require__(1263);
	var shares_validator_directive_1 = __webpack_require__(1265);
	var edit_distribution_rule_component_1 = __webpack_require__(1266);
	var share_pipe_1 = __webpack_require__(1268);
	var revenue_distribution_exceptions_component_1 = __webpack_require__(1269);
	var unique_id_generator_service_1 = __webpack_require__(1257);
	var exception_validator_directive_1 = __webpack_require__(1270);
	var exception_settings_conflict_validator_directive_1 = __webpack_require__(1271);
	var rule_hover_directive_1 = __webpack_require__(1272);
	var conditions_selector_component_1 = __webpack_require__(1259);
	var invalid_control_notifier_directive_1 = __webpack_require__(1273);
	var exception_type_service_1 = __webpack_require__(1253);
	exports.REVENUE_DISTRIBUTION_SETTINGS_COMPONENTS = [
	    profile_settings_revenue_component_1.ProfileSettingsRevenueComponent,
	    distribution_rules_component_1.DistributionRulesComponent,
	    edit_distribution_rule_component_1.EditRevenueDistributionRuleComponent,
	    revenue_distribution_exception_component_1.RevenueDistributionExceptionComponent,
	    revenue_distribution_exceptions_component_1.RevenueDistributionExceptionsComponent,
	    conditions_selector_component_1.ConditionsSelectorComponent,
	    shares_validator_directive_1.SharesValidatorDirective,
	    exception_validator_directive_1.ExceptionValidatorDirective,
	    exception_settings_conflict_validator_directive_1.ExceptionSettingsConflictValidatorDirective,
	    rule_hover_directive_1.RuleHoverDirective,
	    invalid_control_notifier_directive_1.InvalidControlNotifierDirective,
	    share_pipe_1.SharePipe
	];
	exports.REVENUE_DISTRIBUTION_PROVIDERS = [
	    revenue_distribution_service_1.RevenueDistributionService,
	    unique_id_generator_service_1.UniqueIdGenerator,
	    exception_type_service_1.ExceptionTypeService
	];


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var translate_1 = __webpack_require__(302);
	var exception_type_service_1 = __webpack_require__(1253);
	var forms_1 = __webpack_require__(768);
	var beneficiary_kind_model_1 = __webpack_require__(1254);
	var ProfileSettingsRevenueComponent = (function () {
	    function ProfileSettingsRevenueComponent(_translateManager, _exceptionTypeService, _leaveGuard) {
	        this._translateManager = _translateManager;
	        this._exceptionTypeService = _exceptionTypeService;
	        this._leaveGuard = _leaveGuard;
	        this.loading = false;
	        this.availableFeeServices = [];
	        this.exceptionTypes = [];
	        this.availableProfileKinds = [];
	        this.availableProfiles = [];
	        this.customChange = new core_1.EventEmitter();
	    }
	    ProfileSettingsRevenueComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.ngForm.valueChanges.subscribe(function () {
	            _this._leaveGuard.setComponentAllowedToLeave(_this._leaveGuard.isComponentAllowedToLeave() && _this.ngForm.pristine);
	        });
	        this.changeConditionListener = this._exceptionTypeService.observeAvailabilityChanges().subscribe(function (availability) {
	            _this.exceptionTypes && _this.exceptionTypes.forEach(function (type) {
	                if (type.id === availability.id) {
	                    type.disabled = !availability.available;
	                }
	            });
	        });
	    };
	    ProfileSettingsRevenueComponent.prototype.onChange = function () {
	        this.customChange.emit();
	    };
	    ProfileSettingsRevenueComponent.prototype.ngOnDestroy = function () {
	        this.changeConditionListener.unsubscribe();
	    };
	    ProfileSettingsRevenueComponent.prototype.onExceptionTypeSelected = function (it) {
	        this.exceptionsRulesGroup.unshift(this.createExceptionModel(it.id));
	        this.ngForm.form.markAsDirty();
	    };
	    ProfileSettingsRevenueComponent.prototype.createExceptionModel = function (exceptionType) {
	        return {
	            id: null,
	            availableBeneficiaryKinds: this.defaultRulesGroup.availableBeneficiaryKinds,
	            conditions: {
	                type: exceptionType,
	                profiles: [],
	                profileKinds: []
	            },
	            name: 'New Exception',
	            rules: [{
	                    fee: {
	                        id: undefined,
	                        name: 'All services',
	                    },
	                    mandatory: false,
	                    shares: this.populateShares(this.defaultRulesGroup.rules[0].shares)
	                }]
	        };
	    };
	    ProfileSettingsRevenueComponent.prototype.populateShares = function (template) {
	        return template.map(function (t) { return ({
	            percent: t.beneficiaryKind === beneficiary_kind_model_1.BENEFICIARY_KIND.SYSTEM ? 100 : 0,
	            beneficiaryKind: t.beneficiaryKind,
	            beneficiaryKindId: t.beneficiaryKindId
	        }); });
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], ProfileSettingsRevenueComponent.prototype, "loading", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], ProfileSettingsRevenueComponent.prototype, "defaultRulesGroup", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], ProfileSettingsRevenueComponent.prototype, "exceptionsRulesGroup", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], ProfileSettingsRevenueComponent.prototype, "availableFeeServices", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], ProfileSettingsRevenueComponent.prototype, "exceptionTypes", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], ProfileSettingsRevenueComponent.prototype, "profileId", void 0);
	    __decorate([
	        core_1.Input('form'),
	        __metadata("design:type", forms_1.NgForm)
	    ], ProfileSettingsRevenueComponent.prototype, "ngForm", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], ProfileSettingsRevenueComponent.prototype, "availableProfileKinds", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], ProfileSettingsRevenueComponent.prototype, "availableProfiles", void 0);
	    __decorate([
	        core_1.Output('customChange'),
	        __metadata("design:type", core_1.EventEmitter)
	    ], ProfileSettingsRevenueComponent.prototype, "customChange", void 0);
	    ProfileSettingsRevenueComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-profile-detail-settings-revenue',
	            template: __webpack_require__(1255),
	            viewProviders: [{ provide: forms_1.ControlContainer, useExisting: forms_1.NgForm }]
	        }),
	        __param(2, core_1.Inject('LeaveBlockable')),
	        __metadata("design:paramtypes", [translate_1.TranslateManager,
	            exception_type_service_1.ExceptionTypeService, Object])
	    ], ProfileSettingsRevenueComponent);
	    return ProfileSettingsRevenueComponent;
	}());
	exports.ProfileSettingsRevenueComponent = ProfileSettingsRevenueComponent;


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var BehaviorSubject_1 = __webpack_require__(271);
	var ExceptionTypeService = (function () {
	    function ExceptionTypeService() {
	        this.availabilityChange = new BehaviorSubject_1.BehaviorSubject({
	            id: '',
	            available: false
	        });
	        this._availableConditionsTotal = new Map();
	    }
	    ExceptionTypeService.prototype.updateAvailability = function (kind, available) {
	        this.availabilityChange.next({
	            id: kind,
	            available: available
	        });
	    };
	    ExceptionTypeService.prototype.observeAvailabilityChanges = function () {
	        return this.availabilityChange.asObservable();
	    };
	    ExceptionTypeService.prototype.getAvailableConditionsTotal = function (kind) {
	        return this._availableConditionsTotal.get(kind);
	    };
	    ExceptionTypeService.prototype.updateAvailableConditionsTotal = function (kind, count) {
	        this._availableConditionsTotal.set(kind, count);
	    };
	    ExceptionTypeService = __decorate([
	        core_1.Injectable()
	    ], ExceptionTypeService);
	    return ExceptionTypeService;
	}());
	exports.ExceptionTypeService = ExceptionTypeService;


/***/ }),
/* 1254 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var BENEFICIARY_KIND;
	(function (BENEFICIARY_KIND) {
	    BENEFICIARY_KIND["SYSTEM"] = "system";
	    BENEFICIARY_KIND["WHITELABEL"] = "whitelabel";
	    BENEFICIARY_KIND["SALESMAN_LEAD"] = "salesmanlead";
	    BENEFICIARY_KIND["SALESMAN"] = "salesman";
	    BENEFICIARY_KIND["AGENT"] = "agent";
	})(BENEFICIARY_KIND = exports.BENEFICIARY_KIND || (exports.BENEFICIARY_KIND = {}));


/***/ }),
/* 1255 */
/***/ (function(module, exports) {

	module.exports = "<loading-linear [loading]=\"loading\"></loading-linear>\n<div class=\"row\">\n\n    <div class=\"row\" *ngIf=\"!loading\">\n        <div class=\"col-xs-12\">\n            <div style=\"float:right\">\n                <tfl-bo-dropdown [title]=\"'CUSTOMER.DETAILS.TAB.SETTINGS.ACTIONS.ADD_EXCEPTION' | translate \"\n                                 [items]=\"exceptionTypes\"\n                                 (itemSelected)=\"onExceptionTypeSelected($event)\">\n                </tfl-bo-dropdown>\n            </div>\n            <div class=\"setting-item-header\">\n                {{'CUSTOMER.DETAILS.TAB.SETTINGS.DEFAULT_REVENUE_DISTRIBUTION_RULES' | translate }}\n            </div>\n        </div>\n\n        <div class=\"row col-xs-12\" ngModelGroup=\"editDefaultRules\">\n            <tfl-revenue-distribution-rules (customChange)=\"onChange()\"\n                                            [profile-id]=\"profileId\"\n                                            [available-beneficiary-kinds]=\"defaultRulesGroup.availableBeneficiaryKinds\"\n                                            [rules]=\"defaultRulesGroup.rules\"\n                                            [availableFeeServices]=\"availableFeeServices\">\n            </tfl-revenue-distribution-rules>\n        </div>\n        <tfl-revenue-distribution-exceptions (customChange)=\"onChange()\"\n                                             [profile-id]=\"profileId\"\n                                             [exceptions]=\"exceptionsRulesGroup\"\n                                             [availableFeeServices]=\"availableFeeServices\"\n                                             [availableProfileKinds]=\"availableProfileKinds\"\n                                             [availableProfiles]=\"availableProfiles\">\n\n        </tfl-revenue-distribution-exceptions>\n    </div>\n</div>"

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var util_1 = __webpack_require__(743);
	var translate_1 = __webpack_require__(302);
	var exception_type_service_1 = __webpack_require__(1253);
	var forms_1 = __webpack_require__(768);
	var unique_id_generator_service_1 = __webpack_require__(1257);
	var exception_type_model_1 = __webpack_require__(1258);
	var conditions_selector_component_1 = __webpack_require__(1259);
	var RevenueDistributionExceptionComponent = (function () {
	    function RevenueDistributionExceptionComponent(_translationService, _exceptionTypeService, _idGenerator) {
	        this._translationService = _translationService;
	        this._exceptionTypeService = _exceptionTypeService;
	        this._idGenerator = _idGenerator;
	        this.isCollapsed = false;
	        this.conditionsChanged = new core_1.EventEmitter();
	        this.removed = new core_1.EventEmitter();
	    }
	    RevenueDistributionExceptionComponent.prototype.ngOnInit = function () {
	        this.exceptionType = this.resolveExceptionType();
	    };
	    Object.defineProperty(RevenueDistributionExceptionComponent.prototype, "formGroupId", {
	        get: function () {
	            if (this._formGroupId) {
	                return this._formGroupId;
	            }
	            this._formGroupId = util_1.isNullOrUndefined(this.model.id) ? this._idGenerator.generate()
	                : String(this.model.id);
	            return this._formGroupId;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(RevenueDistributionExceptionComponent.prototype, "availableConditions", {
	        get: function () {
	            switch (this.exceptionType) {
	                case exception_type_model_1.EXCEPTION_TYPE.FOR_PROFILE_KINDS:
	                    return this.availableProfileKinds;
	                case exception_type_model_1.EXCEPTION_TYPE.FOR_PROFILES:
	                    return this.availableProfiles;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(RevenueDistributionExceptionComponent.prototype, "selectedConditions", {
	        get: function () {
	            switch (this.exceptionType) {
	                case exception_type_model_1.EXCEPTION_TYPE.FOR_PROFILES:
	                    return this.model.conditions.profiles;
	                case exception_type_model_1.EXCEPTION_TYPE.FOR_PROFILE_KINDS:
	                    return this.model.conditions.profileKinds;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    RevenueDistributionExceptionComponent.prototype.onRemoved = function () {
	        this.itemsSelector.deselectAll(); //free up shared pool of available items
	        this.removed.next(this.index);
	    };
	    RevenueDistributionExceptionComponent.prototype.isSelectorValid = function () {
	        if (this.group.control) {
	            var selector = this.group.control.get('editConditions-' + this.formGroupId);
	            if (selector) {
	                return selector.valid || !selector.dirty;
	            }
	        }
	        return true;
	    };
	    RevenueDistributionExceptionComponent.prototype.onConditionSelected = function (condition) {
	        if (this.selectedConditions.findIndex(function (it) { return it.id == condition.id; }) < 0) {
	            this.selectedConditions.push(condition);
	        }
	        this.notifyParentComponentOfChanges();
	    };
	    RevenueDistributionExceptionComponent.prototype.notifyParentComponentOfChanges = function () {
	        var _this = this;
	        setTimeout(function () {
	            var available = !util_1.isNullOrUndefined(_this.availableConditions)
	                && _this.availableConditions.length > 0;
	            _this._exceptionTypeService.updateAvailability(_this.exceptionType, available);
	        });
	        this.conditionsChanged.next();
	    };
	    RevenueDistributionExceptionComponent.prototype.onConditionDeselected = function (condition) {
	        var i = this.selectedConditions.findIndex(function (p) { return p.id == condition.id; });
	        this.selectedConditions.splice(i, 1);
	        this.notifyParentComponentOfChanges();
	    };
	    Object.defineProperty(RevenueDistributionExceptionComponent.prototype, "availableConditionsName", {
	        get: function () {
	            switch (this.exceptionType) {
	                case exception_type_model_1.EXCEPTION_TYPE.FOR_PROFILES:
	                    return this._translationService.getValue('CUSTOMER.DETAILS.TAB.SETTINGS.USERS');
	                case exception_type_model_1.EXCEPTION_TYPE.FOR_PROFILE_KINDS:
	                    return this._translationService.getValue('CUSTOMER.DETAILS.TAB.SETTINGS.TYPES_OF_USERS');
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    RevenueDistributionExceptionComponent.prototype.resolveExceptionType = function () {
	        if (this.model.conditions.type) {
	            return this.model.conditions.type;
	        }
	        if (this.conditionIsPresent(this.model.conditions.profiles)) {
	            return exception_type_model_1.EXCEPTION_TYPE.FOR_PROFILES;
	        }
	        if (this.conditionIsPresent(this.model.conditions.profileKinds)) {
	            return exception_type_model_1.EXCEPTION_TYPE.FOR_PROFILE_KINDS;
	        }
	        return undefined;
	    };
	    RevenueDistributionExceptionComponent.prototype.conditionIsPresent = function (condition) {
	        return (!util_1.isNullOrUndefined(condition)) && condition.length > 0;
	    };
	    RevenueDistributionExceptionComponent.prototype.onCollapse = function () {
	        this.isCollapsed = !this.isCollapsed;
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], RevenueDistributionExceptionComponent.prototype, "model", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], RevenueDistributionExceptionComponent.prototype, "index", void 0);
	    __decorate([
	        core_1.Input('profile-id'),
	        __metadata("design:type", Number)
	    ], RevenueDistributionExceptionComponent.prototype, "profileId", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], RevenueDistributionExceptionComponent.prototype, "availableFeeServices", void 0);
	    __decorate([
	        core_1.Input('available-profiles'),
	        __metadata("design:type", Array)
	    ], RevenueDistributionExceptionComponent.prototype, "availableProfiles", void 0);
	    __decorate([
	        core_1.Input('available-profile-kinds'),
	        __metadata("design:type", Object)
	    ], RevenueDistributionExceptionComponent.prototype, "availableProfileKinds", void 0);
	    __decorate([
	        core_1.Input('collapsed'),
	        __metadata("design:type", Object)
	    ], RevenueDistributionExceptionComponent.prototype, "isCollapsed", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", Object)
	    ], RevenueDistributionExceptionComponent.prototype, "conditionsChanged", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", Object)
	    ], RevenueDistributionExceptionComponent.prototype, "removed", void 0);
	    __decorate([
	        core_1.ViewChild(conditions_selector_component_1.ConditionsSelectorComponent),
	        __metadata("design:type", conditions_selector_component_1.ConditionsSelectorComponent)
	    ], RevenueDistributionExceptionComponent.prototype, "itemsSelector", void 0);
	    __decorate([
	        core_1.ViewChild(forms_1.NgModelGroup),
	        __metadata("design:type", forms_1.NgModelGroup)
	    ], RevenueDistributionExceptionComponent.prototype, "group", void 0);
	    RevenueDistributionExceptionComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-revenue-distribution-exception',
	            template: __webpack_require__(1261),
	            viewProviders: [{ provide: forms_1.ControlContainer, useExisting: forms_1.NgModelGroup }]
	        }),
	        __metadata("design:paramtypes", [translate_1.TranslateManager,
	            exception_type_service_1.ExceptionTypeService,
	            unique_id_generator_service_1.UniqueIdGenerator])
	    ], RevenueDistributionExceptionComponent);
	    return RevenueDistributionExceptionComponent;
	}());
	exports.RevenueDistributionExceptionComponent = RevenueDistributionExceptionComponent;


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var UniqueIdGenerator = (function () {
	    function UniqueIdGenerator() {
	    }
	    UniqueIdGenerator.prototype.generate = function () {
	        return "_temp_" + Math.random().toString(36).substr(2, 12);
	    };
	    UniqueIdGenerator = __decorate([
	        core_1.Injectable()
	    ], UniqueIdGenerator);
	    return UniqueIdGenerator;
	}());
	exports.UniqueIdGenerator = UniqueIdGenerator;


/***/ }),
/* 1258 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var EXCEPTION_TYPE;
	(function (EXCEPTION_TYPE) {
	    EXCEPTION_TYPE["FOR_PROFILES"] = "for-profiles";
	    EXCEPTION_TYPE["FOR_PROFILE_KINDS"] = "for-profile-kinds";
	})(EXCEPTION_TYPE = exports.EXCEPTION_TYPE || (exports.EXCEPTION_TYPE = {}));


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var util_1 = __webpack_require__(743);
	function createSelectedItemsValidator() {
	    return function (fc) {
	        if (util_1.isNullOrUndefined(fc.value)) {
	            return null;
	        }
	        if (fc.value.length < 1) {
	            return {
	                atLeastOneItemShouldBeSelected: true,
	            };
	        }
	        return null;
	    };
	}
	exports.createSelectedItemsValidator = createSelectedItemsValidator;
	exports.ITEM_SELECTOR_VALIDATOR = {
	    provide: forms_1.NG_VALIDATORS,
	    useExisting: core_1.forwardRef(function () { return ConditionsSelectorComponent; }),
	    multi: true
	};
	exports.ITEM_SELECTOR_CONTROL_VALUE_ACCESSOR = {
	    provide: forms_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return ConditionsSelectorComponent; }),
	    multi: true
	};
	var ConditionsSelectorComponent = (function () {
	    function ConditionsSelectorComponent() {
	        this.onChange = new core_1.EventEmitter();
	        this.onTouched = new core_1.EventEmitter();
	        this.name = 'default';
	        this.itemSelected = new core_1.EventEmitter();
	        this.itemDeselected = new core_1.EventEmitter();
	    }
	    ConditionsSelectorComponent.prototype.writeValue = function (obj) {
	    };
	    ConditionsSelectorComponent.prototype.registerOnChange = function (fn) {
	        this.onChange.subscribe(fn);
	    };
	    ConditionsSelectorComponent.prototype.registerOnTouched = function (fn) {
	        this.onTouched.subscribe(fn);
	    };
	    Object.defineProperty(ConditionsSelectorComponent.prototype, "selectedDropZoneName", {
	        get: function () {
	            return 'selected-' + this.name;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ConditionsSelectorComponent.prototype, "availableDropZoneName", {
	        get: function () {
	            return 'available-' + this.name;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ConditionsSelectorComponent.prototype.deselectAll = function () {
	        var _this = this;
	        this.selectedItems.forEach(function (it) {
	            _this.availableItems.push(it);
	            _this.itemDeselected.emit(it);
	        });
	    };
	    ConditionsSelectorComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        setTimeout(function () { return _this.selectedItems.forEach(function (it) {
	            _this.makeItemUnavailable(it.id);
	            _this.itemSelected.emit(it);
	        }); });
	    };
	    ConditionsSelectorComponent.prototype.getEitherExceptionItemLabelOrName = function (it) {
	        return it.label || it.name;
	    };
	    ConditionsSelectorComponent.prototype.makeItemUnavailable = function (itemId) {
	        var index = this.availableItems.findIndex(function (ai) { return ai.id === itemId; });
	        if (index >= 0) {
	            this.availableItems.splice(index, 1);
	        }
	    };
	    ConditionsSelectorComponent.prototype.selectItem = function (selectedId) {
	        var selected = this.availableItems.find(function (it) { return it.id === selectedId; });
	        if (selected) {
	            this.makeItemUnavailable(selectedId);
	            this.selectedItems = this.selectedItems.concat(selected);
	            this.itemSelected.emit(selected);
	            this.onChange.emit(this.selectedItems);
	        }
	    };
	    ConditionsSelectorComponent.prototype.deselectItem = function (deselectedId) {
	        var deselected = this.selectedItems.find(function (it) { return it.id === deselectedId; });
	        this.selectedItems = this.selectedItems.filter(function (it) { return it.id !== deselectedId; });
	        this.availableItems.push(deselected);
	        this.itemDeselected.emit(deselected);
	        this.onChange.emit(this.selectedItems);
	    };
	    ConditionsSelectorComponent.prototype.onDropSelected = function (data) {
	        this.onTouched.emit();
	        this.selectItem(data);
	    };
	    ConditionsSelectorComponent.prototype.onDropDeselected = function (data) {
	        this.onTouched.emit();
	        this.deselectItem(data);
	    };
	    ConditionsSelectorComponent.prototype.validate = function (control) {
	        return createSelectedItemsValidator()(control);
	    };
	    __decorate([
	        core_1.Input('available-items'),
	        __metadata("design:type", Array)
	    ], ConditionsSelectorComponent.prototype, "availableItems", void 0);
	    __decorate([
	        core_1.Input('selected-items'),
	        __metadata("design:type", Array)
	    ], ConditionsSelectorComponent.prototype, "selectedItems", void 0);
	    __decorate([
	        core_1.Input('available-items-name'),
	        __metadata("design:type", String)
	    ], ConditionsSelectorComponent.prototype, "availableItemsName", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], ConditionsSelectorComponent.prototype, "name", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", Object)
	    ], ConditionsSelectorComponent.prototype, "itemSelected", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", Object)
	    ], ConditionsSelectorComponent.prototype, "itemDeselected", void 0);
	    ConditionsSelectorComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-conditions-selector',
	            template: __webpack_require__(1260),
	            providers: [exports.ITEM_SELECTOR_VALIDATOR, exports.ITEM_SELECTOR_CONTROL_VALUE_ACCESSOR]
	        })
	    ], ConditionsSelectorComponent);
	    return ConditionsSelectorComponent;
	}());
	exports.ConditionsSelectorComponent = ConditionsSelectorComponent;


/***/ }),
/* 1260 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"exceptions-available\"\n     class=\"conditions-selector-box col-xs-5\"\n     [tflDropZone]=\"{name: availableDropZoneName}\"\n     (tflDrop)=\"onDropDeselected($event)\">\n    <div class=\"box-header\">\n        {{ availableItemsName }}\n    </div>\n    <div class=\"box-content\">\n        <div *ngFor=\"let a of availableItems\" class=\"box-item unselectable\"\n             (dblclick)=\"selectItem(a.id)\"\n             [tflDraggable]=\"{data: a.id, targetZone:selectedDropZoneName}\">\n\n            <span class=\"item-content\">\n                <i class=\"fa fa-bars item-icon\"></i>\n                {{ getEitherExceptionItemLabelOrName(a) | capitalize }}\n            </span>\n        </div>\n    </div>\n</div>\n<div id=\"exceptions-selected\"\n     class=\"conditions-selector-box col-xs-5 col-xs-offset-1\"\n     [tflDropZone]=\"{name: selectedDropZoneName}\"\n     (tflDrop)=\"onDropSelected($event)\">\n    <div class=\"box-header\">\n        {{'CUSTOMER.DETAILS.TAB.SETTINGS.APPLIES_TO' | translate }}\n    </div>\n    <div class=\"box-content\">\n        <div *ngFor=\"let s of selectedItems\" class=\"box-item unselectable\"\n             (dblclick)=\"deselectItem(s.id)\"\n             [tflDraggable]=\"{data: s.id, targetZone:availableDropZoneName}\">\n\n            <span class=\"item-content\">\n                <i class=\"fa fa-bars item-icon\"></i>\n                {{ getEitherExceptionItemLabelOrName(s) | capitalize }}\n            </span>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 1261 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"exception-settings x_panel\"\n     ngModelGroup=\"editExceptionGroup-{{formGroupId}}\"\n     #formGroup=\"ngModelGroup\"\n     [ngClass]=\"{'has-group-error': formGroup.hasError('atLeastOneControlHasError') ||\n                                    formGroup.hasError('settingsConflict') ||\n                                    formGroup.hasError('allConditionsSelected')}\"\n     tflValidException\n     tflValidExceptionSettings>\n    <div class=\"x_title\" (click)=\"onCollapse()\">\n        <h3 style=\"float: left\">{{ model.name }}</h3>\n        <h3 [ngClass]=\"isCollapsed ? 'glyphicon glyphicon-triangle-bottom' : 'glyphicon glyphicon-triangle-top'\" style=\"float: right\">\n        </h3>\n        <hr>\n    </div>\n    <div class=\"x_content\" [ngClass]=\"isCollapsed ? 'collapse' : 'expand'\">\n        <div class=\"row col-xs-12\">\n            <p class=\"text-left\">1. {{'CUSTOMER.DETAILS.TAB.SETTINGS.DESCRIBE_EXCEPTION_RULE' | translate }}</p>\n        </div>\n        <div class=\"row col-xs-12\">\n            <tfl-revenue-distribution-rules [profile-id]=\"profileId\"\n                                            [available-beneficiary-kinds]=\"model.availableBeneficiaryKinds\"\n                                            [rules]=\"model.rules\"\n                                            [form-group-id]=\"formGroupId\"\n                                            [availableFeeServices]=\"availableFeeServices\"\n                                            [disable-new-rows]=\"!formGroup.valid && formGroup.dirty\">\n            </tfl-revenue-distribution-rules>\n        </div>\n        <div class=\"row col-xs-12\" [ngSwitch]=\"exceptionType\">\n            <p *ngSwitchCase=\"'for-profiles'\" class=\"text-left\">2.\n                {{'CUSTOMER.DETAILS.TAB.SETTINGS.SELECT_USERS_TO_APPLY_EXCEPTION' |\n                translate }}</p>\n            <p *ngSwitchCase=\"'for-profile-kinds'\" class=\"text-left\">2.\n                {{'CUSTOMER.DETAILS.TAB.SETTINGS.SELECT_TYPES_OF_USERS_TO_APPLY_EXCEPTION' |\n                translate }}</p>\n        </div>\n        <div class=\"col-xs-12 error-message\" [hidden]=\"formGroup.valid\"\n             *ngIf=\"formGroup.hasError('settingsConflict')\">\n            {{'CUSTOMER.DETAILS.TAB.SETTINGS.VALIDATION.SETTINGS_CONFLICT' | translate}}\n        </div>\n        <div class=\"col-xs-12 error-message\" [hidden]=\"formGroup.valid\"\n             *ngIf=\"formGroup.hasError('allConditionsSelected')\">\n            {{'CUSTOMER.DETAILS.TAB.SETTINGS.VALIDATION.ALL_CONDITIONS_SELECTED' | translate:{exception_name:\n            model.name} }}\n        </div>\n        <div class=\"col-xs-12 form-group\" [ngClass]=\"{'has-error': !isSelectorValid()}\"\n             *ngIf=\"availableConditions\">\n            <tfl-conditions-selector [ngModel]=\"selectedConditions\"\n                                     #se=\"ngModel\"\n                                     name=\"editConditions-{{formGroupId}}\"\n                                     [available-items]=\"availableConditions\"\n                                     [selected-items]=\"selectedConditions\"\n                                     [available-items-name]=\"availableConditionsName\"\n                                     [name]=\"model.name\"\n                                     (itemSelected)=\"onConditionSelected($event)\"\n                                     (itemDeselected)=\"onConditionDeselected($event)\">\n            </tfl-conditions-selector>\n            <div class=\"col-xs-6 error-message pull-right\" [hidden]=\"isSelectorValid()\"\n                 *ngIf=\"se.hasError('atLeastOneItemShouldBeSelected')\">\n                {{'CUSTOMER.DETAILS.TAB.SETTINGS.VALIDATION.AT_LEAST_ONE_CONDITION' | translate}}\n            </div>\n        </div>\n        <button type=\"button\" class=\"btn btn-danger\" style=\"float:left\" (click)=\"onRemoved()\">\n            {{'CUSTOMER.DETAILS.TAB.SETTINGS.ACTIONS.REMOVE' | translate }}\n        </button>\n    </div>\n</div>"

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var http_1 = __webpack_require__(836);
	var core_1 = __webpack_require__(205);
	var lodash_1 = __webpack_require__(268);
	var util_1 = __webpack_require__(743);
	var RevenueDistributionService = (function () {
	    function RevenueDistributionService(_http) {
	        this._http = _http;
	        this.baseUrl = '/api/backoffice';
	    }
	    RevenueDistributionService.prototype.getDefaultRulesGroup = function (profileId) {
	        var _this = this;
	        return this._http.get(this.baseUrl + "/customers/" + profileId + "/sharing-rules")
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return _this.mapDefaultRuleGroup(response); });
	    };
	    RevenueDistributionService.prototype.getDefaultRulesGroupByKindAndIntroducer = function (profileId, kindId, introducerId) {
	        var _this = this;
	        var search = new http_1.URLSearchParams();
	        search.set('kindId', String(kindId));
	        search.set('parentId', !util_1.isNullOrUndefined(introducerId) ? String(introducerId) : "");
	        return this._http.get(this.baseUrl + "/customers/" + profileId + "/sharing-rules/kinds", { search: search })
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return _this.mapDefaultRuleGroup(response); });
	    };
	    RevenueDistributionService.prototype.getExceptionRuleGroups = function (profileId) {
	        var _this = this;
	        return this._http.get(this.baseUrl + "/customers/" + profileId + "/sharing-rules?exceptions")
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return (lodash_1.get(response, 'records', [])
	            .map(function (group) { return (_this.mapExceptionRuleGroup(group)); })); });
	    };
	    RevenueDistributionService.prototype.getAvailableIntroducers = function (profileId, kindId, name) {
	        return this._http.get(this.baseUrl + "/customers/" + profileId + "/introducers?kind-id=" + kindId + "&name=" + name)
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return (lodash_1.get(response, 'items', [])); });
	    };
	    RevenueDistributionService.prototype.getAvailableSubProfiles = function (profileId) {
	        return this._http.get(this.baseUrl + "/customers/" + profileId + "/sharing-rules/profiles")
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return (lodash_1.get(response, 'items', [])); });
	    };
	    RevenueDistributionService.prototype.getAvailableProfileKinds = function (profileId) {
	        return this._http.get(this.baseUrl + "/customers/" + profileId + "/sharing-rules/profiles/kinds")
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return (lodash_1.get(response, 'items', [])); });
	    };
	    RevenueDistributionService.prototype.getProfileKindsForException = function (kindId) {
	        return this._http.get(this.baseUrl + "/customers/sharing-rules?profile-kind=" + kindId)
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return (lodash_1.get(response, 'items', [])); });
	    };
	    RevenueDistributionService.prototype.getAllAvailableProfileKinds = function () {
	        return this._http.get(this.baseUrl + "/dictionary/profile_kinds")
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return (lodash_1.get(response, 'records', [])); });
	    };
	    RevenueDistributionService.prototype.getAvailableFeeServices = function (profileId) {
	        return this._http.get(this.baseUrl + "/customers/" + profileId + "/sharing-rules/fee-services-condition")
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return (lodash_1.get(response, 'items', [])); });
	    };
	    RevenueDistributionService.prototype.getAvailableShares = function (profileId, feeId) {
	        var search = new http_1.URLSearchParams();
	        search.set('kind', 'system');
	        if (!util_1.isNullOrUndefined(feeId)) {
	            search.set('fee_id', String(feeId));
	        }
	        return this._http.get(this.baseUrl + "/customers/" + profileId + "/sharing-rules/fixed-shares", { search: search })
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return (lodash_1.get(response, 'shares', [])); });
	    };
	    RevenueDistributionService.prototype.updateRevenueDistributionSettings = function (profileId, defaultRules, exceptions, intId, kindId, wlTariffId, deletedExceptions) {
	        var _this = this;
	        var mapShare = function (share) { return ({
	            beneficiary_kind: share.beneficiaryKindId,
	            percent: share.percent,
	            amount: share.amount
	        }); };
	        var mapRule = function (rule) { return ({
	            fee_id: rule.fee.id,
	            shares: rule.shares.map(mapShare)
	        }); };
	        var revenueSharingGroups = {
	            default_group: {
	                id: defaultRules.id,
	                rules: defaultRules.rules.map(mapRule)
	            },
	            groups_to_delete: deletedExceptions,
	            exception_groups: exceptions.map(function (exception) { return ({
	                id: exception.id,
	                rules: exception.rules.map(mapRule),
	                condition: {
	                    profiles: exception.conditions.profiles.map(function (p) { return p.id; }),
	                    profile_kinds: exception.conditions.profileKinds.map(function (pk) { return pk.id; })
	                }
	            }); })
	        };
	        var request = {
	            kindId: kindId,
	            introducer: intId,
	            revenueSharingGroups: revenueSharingGroups,
	            wlTariffId: wlTariffId
	        };
	        return this._http.patch(this.baseUrl + "/customers/" + profileId + "/profile-type", request)
	            .map(function (response) { return response.json(); }).map(function (response) { return ({
	            defaultGroup: _this.mapDefaultRuleGroup(response.revenueSharingGroupsResp.default_group),
	            exceptions: (lodash_1.get(response, 'revenueSharingGroupsResp.exception_groups', [])
	                .map(function (g) { return _this.mapExceptionRuleGroup(g); }))
	        }); });
	    };
	    RevenueDistributionService.prototype.mapDefaultRuleGroup = function (group) {
	        return {
	            name: '',
	            id: group.id,
	            availableBeneficiaryKinds: lodash_1.get(group, 'available_beneficiary_kinds', []),
	            rules: this.mapRules(lodash_1.get(group, 'rules', [])),
	            conditions: null
	        };
	    };
	    RevenueDistributionService.prototype.mapExceptionRuleGroup = function (group) {
	        return {
	            name: group.name,
	            id: group.id,
	            availableBeneficiaryKinds: lodash_1.get(group, 'available_beneficiary_kinds', []),
	            rules: this.mapRules(lodash_1.get(group, 'rules', [])),
	            conditions: {
	                profileKinds: lodash_1.get(group, 'applies_to.profile_kinds', []),
	                profiles: lodash_1.get(group, 'applies_to.profiles', [])
	            }
	        };
	    };
	    RevenueDistributionService.prototype.mapRules = function (rules) {
	        var _this = this;
	        return rules.map(function (rule) { return ({
	            feeId: rule.fee_id,
	            feeName: rule.fee_name,
	            fee: {
	                id: rule.fee_id,
	                name: rule.fee_name
	            },
	            mandatory: rule.mandatory,
	            shares: _this.mapShares(lodash_1.get(rule, 'shares', []))
	        }); });
	    };
	    RevenueDistributionService.prototype.mapShares = function (shares) {
	        return shares.map(function (share) { return ({
	            percent: lodash_1.get(share, 'percent', 0),
	            amount: lodash_1.get(share, 'amount', null),
	            beneficiaryKind: share.beneficiary_kind.name,
	            beneficiaryKindId: share.beneficiary_kind.id
	        }); });
	    };
	    RevenueDistributionService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], RevenueDistributionService);
	    return RevenueDistributionService;
	}());
	exports.RevenueDistributionService = RevenueDistributionService;


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var util_1 = __webpack_require__(743);
	var forms_1 = __webpack_require__(768);
	var money_pipe_1 = __webpack_require__(1247);
	var beneficiary_kind_model_1 = __webpack_require__(1254);
	var DistributionRulesComponent = (function () {
	    function DistributionRulesComponent(_lb, _cdr) {
	        this._lb = _lb;
	        this._cdr = _cdr;
	        this.formGroupId = -1;
	        this._availableFeeServices = [];
	        this.customChange = new core_1.EventEmitter();
	        this.lastEditedRowErrors = {};
	    }
	    Object.defineProperty(DistributionRulesComponent.prototype, "isSingleRuleLeft", {
	        get: function () {
	            return this.rules.length <= 1;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DistributionRulesComponent.prototype, "setAvailableFeeServices", {
	        set: function (services) {
	            var _this = this;
	            this._availableFeeServices = services;
	            this.rules.forEach(function (r) {
	                var availableFee = _this._availableFeeServices.find(function (f) {
	                    return f.id === r.fee.id;
	                });
	                if (availableFee) {
	                    r.fee = availableFee;
	                }
	                else {
	                    _this._availableFeeServices.push(r.fee);
	                }
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DistributionRulesComponent.prototype.availableFeeServices = function (fee) {
	        var _this = this;
	        return this._availableFeeServices.filter(function (fs) {
	            return !(_this.rules.find(function (r) {
	                return (!fee || (fee.id !== r.fee.id)) && r.fee.id === fs.id;
	            }));
	        });
	    };
	    DistributionRulesComponent.prototype.hasAvailableFees = function () {
	        return this.availableFeeServices(null).length > 0;
	    };
	    DistributionRulesComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.rules.forEach(function (rule) {
	            _this.availableBeneficiaryKinds.forEach(function (kind) {
	                var share = _this.accessShare(_this.availableBeneficiaryKinds.indexOf(kind), kind, rule);
	                if (util_1.isNullOrUndefined(share)) {
	                    rule.shares.push({
	                        beneficiaryKind: kind,
	                        beneficiaryKindId: null,
	                        percent: 0
	                    });
	                }
	                if (share.beneficiaryKind === beneficiary_kind_model_1.BENEFICIARY_KIND.SYSTEM && util_1.isNullOrUndefined(share.amount)) {
	                    share.amount = { amount: 0, currency_code: 'EUR' };
	                }
	            });
	        });
	    };
	    Object.defineProperty(DistributionRulesComponent.prototype, "canNotAddNewRow", {
	        get: function () {
	            return !this.hasAvailableFees() || this.lastEditedRowNotValid;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DistributionRulesComponent.prototype.accessShare = function (ind, kind, rule) {
	        var result = rule.shares[ind];
	        if (!result) {
	            rule.shares.push({
	                percent: 0,
	                beneficiaryKind: kind,
	                beneficiaryKindId: null
	            });
	        }
	        return result;
	    };
	    DistributionRulesComponent.prototype.onRowUpdated = function (state) {
	        if (util_1.isNullOrUndefined(this.editing)) {
	            return;
	        }
	        this.setRowValidityState(state);
	        this._cdr.detectChanges();
	    };
	    DistributionRulesComponent.prototype.isRemovable = function (rule) {
	        return !rule.mandatory && !this.isSingleRuleLeft;
	    };
	    DistributionRulesComponent.prototype.editRowAt = function (rowIndex) {
	        this.customChange.emit();
	        if (this.lastEditedRowNotValid) {
	            return;
	        }
	        this.editing = rowIndex;
	        this._cdr.detectChanges();
	    };
	    DistributionRulesComponent.prototype.removeRowAt = function (rowIndex) {
	        this.customChange.emit();
	        this.editing = undefined;
	        this.setRowValidityState({ valid: true, isGroupError: false });
	        this.rules.splice(rowIndex, 1);
	        this._lb.setComponentAllowedToLeave(false);
	        this._cdr.detectChanges();
	    };
	    DistributionRulesComponent.prototype.setRowValidityState = function (state) {
	        this.lastEditedRowNotValid = !state.valid;
	        this.lastEditedRowErrors = state.errors ? state.errors : {};
	        this.lastEditedRowHasGroupError = state.isGroupError;
	    };
	    DistributionRulesComponent.prototype.closeEditMode = function () {
	        if (!this.lastEditedRowNotValid) {
	            if (this.group && this.group.control) {
	                this.group.control.enable(); //avoids setting form status to disabled after user leaves the form
	            }
	            this.editing = undefined;
	            this._cdr.detectChanges();
	        }
	    };
	    DistributionRulesComponent.prototype.addRow = function () {
	        if (this.canNotAddNewRow) {
	            return;
	        }
	        this.rules.push(this.createRule());
	        this.editRowAt(this.rules.length - 1);
	        this._lb.setComponentAllowedToLeave(false);
	    };
	    DistributionRulesComponent.prototype.onRuleHover = function (event) {
	        if (event.hovering) {
	            this.hovering = event.index;
	        }
	        else {
	            this.hovering = undefined;
	        }
	    };
	    DistributionRulesComponent.prototype.createRule = function () {
	        return {
	            fee: this.availableFeeServices(null)[0],
	            mandatory: false,
	            shares: this.populateShares(this.rules[0].shares)
	        };
	    };
	    //TODO remove duplication
	    DistributionRulesComponent.prototype.populateShares = function (template) {
	        return template.map(function (t) { return ({
	            percent: t.beneficiaryKind === beneficiary_kind_model_1.BENEFICIARY_KIND.SYSTEM ? 100 : 0,
	            beneficiaryKind: t.beneficiaryKind,
	            beneficiaryKindId: t.beneficiaryKindId
	        }); });
	    };
	    __decorate([
	        core_1.Input('available-beneficiary-kinds'),
	        __metadata("design:type", Array)
	    ], DistributionRulesComponent.prototype, "availableBeneficiaryKinds", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], DistributionRulesComponent.prototype, "rules", void 0);
	    __decorate([
	        core_1.Input('form-group-id'),
	        __metadata("design:type", Number)
	    ], DistributionRulesComponent.prototype, "formGroupId", void 0);
	    __decorate([
	        core_1.Input('disable-new-rows'),
	        __metadata("design:type", Boolean)
	    ], DistributionRulesComponent.prototype, "disableNewRows", void 0);
	    __decorate([
	        core_1.Input('profile-id'),
	        __metadata("design:type", Number)
	    ], DistributionRulesComponent.prototype, "profileId", void 0);
	    __decorate([
	        core_1.Output('customChange'),
	        __metadata("design:type", core_1.EventEmitter)
	    ], DistributionRulesComponent.prototype, "customChange", void 0);
	    __decorate([
	        core_1.ViewChild('fg'),
	        __metadata("design:type", forms_1.NgModelGroup)
	    ], DistributionRulesComponent.prototype, "group", void 0);
	    __decorate([
	        core_1.Input('availableFeeServices'),
	        __metadata("design:type", Array),
	        __metadata("design:paramtypes", [Array])
	    ], DistributionRulesComponent.prototype, "setAvailableFeeServices", null);
	    DistributionRulesComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-revenue-distribution-rules',
	            template: __webpack_require__(1264),
	            viewProviders: [{ provide: forms_1.ControlContainer, useExisting: forms_1.NgModelGroup }],
	            providers: [money_pipe_1.MoneyPipe]
	        }),
	        __param(0, core_1.Inject('LeaveBlockable')),
	        __metadata("design:paramtypes", [Object, core_1.ChangeDetectorRef])
	    ], DistributionRulesComponent);
	    return DistributionRulesComponent;
	}());
	exports.DistributionRulesComponent = DistributionRulesComponent;


/***/ }),
/* 1264 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"rd-rules\" ngModelGroup=\"{{'rulesGroup-' + formGroupId}}\" #fg=\"ngModelGroup\">\n    <table class=\"table table-hover jambo_table rd-rules-table\">\n        <thead>\n        <tr>\n            <th style=\"width: 29%\">{{'CUSTOMER.DETAILS.TAB.SETTINGS.DISTRIBUTION_RULES_TABLE.SERVICE' | translate\n                }}\n            </th>\n            <th [style.width.%]=\"70 / availableBeneficiaryKinds.length\"\n                *ngFor=\"let kind of availableBeneficiaryKinds\">\n                {{'CUSTOMER.DETAILS.TAB.SETTINGS.DISTRIBUTION_RULES_TABLE.'+kind.toUpperCase() | translate }}\n            </th>\n            <th style=\"width: 1%\"></th>\n        </tr>\n        </thead>\n        <tbody>\n        <ng-container *ngFor=\"let rule of rules;let i = index\">\n            <tr *ngIf=\"editing !== i\" class=\"view-row\"\n                [tflRuleHover]=\"i\" (ruleHover)=\"onRuleHover($event)\"\n                (click)=\"editRowAt(i)\">\n                <td>{{ rule.fee.name }}</td>\n                <td *ngFor=\"let kind of availableBeneficiaryKinds; let j = index\">{{ accessShare(j, kind, rule) | tflShare }}</td>\n                <td>\n                                 <span [hidden]=\"!isRemovable(rule) || hovering != i || lastEditedRowNotValid\"\n                                       class=\"btn-remove-row\"\n                                       (click)=\"removeRowAt(i)\">\n                  <i class=\"fa fa-window-close\"></i>\n                </span>\n                </td>\n            </tr>\n            <tr *ngIf=\"editing === i\"\n                [tflRuleHover]=\"i\" (ruleHover)=\"onRuleHover($event)\"\n                tfl-edit-revenue-distribution-rule\n                (clickOutside)=\"closeEditMode()\"\n                [ngClass]=\"{'has-error': lastEditedRowNotValid && lastEditedRowErrors['totalSharesPercentage'],\n                            'edit-row': editing === i}\"\n                [profile-id]=\"profileId\"\n                [row-index]=\"i\"\n                [form-group-id]=\"formGroupId\"\n                [rule]=\"rule\"\n                [available-kinds]=\"availableBeneficiaryKinds\"\n                [available-services]=\"availableFeeServices(rule.fee)\"\n                [removable]=\"!rule.mandatory && !isSingleRuleLeft\"\n                (inputUpdated)=\"onRowUpdated($event)\">\n                <td>\n                    <span [hidden]=\"!isRemovable(rule) || hovering != i\"\n                          class=\"btn-remove-row\"\n                          (click)=\"removeRowAt(i)\">\n                  <i class=\"fa fa-window-close\"></i>\n                </span>\n                </td>\n            </tr>\n        </ng-container>\n        </tbody>\n    </table>\n    <div class=\"btn-add-row\">\n    <span>\n    <i class=\"btn fa fa-plus\" [ngClass]=\"{'disabled': canNotAddNewRow}\" (click)=\"addRow()\"> {{'CUSTOMER.DETAILS.TAB.SETTINGS.ACTIONS.NEW_ROW' | translate}}</i>\n    </span>\n    </div>\n</div>"

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var forms_1 = __webpack_require__(768);
	var core_1 = __webpack_require__(205);
	var util_1 = __webpack_require__(743);
	function revenueSharesValidator() {
	    return function (control) {
	        var formGroup = control;
	        var shareInputAliases = Object.keys(formGroup.controls).filter(function (alias) {
	            return alias.startsWith('editShare');
	        });
	        var shareSelectAliases = Object.keys(formGroup.controls).filter(function (alias) {
	            return alias.startsWith('editSystemShare');
	        });
	        if (shareInputAliases.length == 0 && shareSelectAliases.length == 0) {
	            return null;
	        }
	        var total = 0;
	        shareInputAliases.forEach(function (alias) {
	            total += Math.abs(parseFloat(formGroup.controls[alias].value));
	        });
	        shareSelectAliases.forEach(function (alias) {
	            var value = formGroup.controls[alias].value;
	            if (!util_1.isNullOrUndefined(value) && !util_1.isNullOrUndefined(value.percent)) {
	                total += value.percent;
	            }
	        });
	        if (total == 100.0) {
	            return null;
	        }
	        return {
	            totalSharesPercentage: total,
	        };
	    };
	}
	exports.revenueSharesValidator = revenueSharesValidator;
	var SharesValidatorDirective = (function () {
	    function SharesValidatorDirective() {
	    }
	    SharesValidatorDirective_1 = SharesValidatorDirective;
	    SharesValidatorDirective.prototype.validate = function (control) {
	        return revenueSharesValidator()(control);
	    };
	    SharesValidatorDirective = SharesValidatorDirective_1 = __decorate([
	        core_1.Directive({
	            selector: '[ngModelGroup][tflValidShares]',
	            providers: [{
	                    provide: forms_1.NG_VALIDATORS,
	                    useExisting: SharesValidatorDirective_1,
	                    multi: true
	                }]
	        })
	    ], SharesValidatorDirective);
	    return SharesValidatorDirective;
	    var SharesValidatorDirective_1;
	}());
	exports.SharesValidatorDirective = SharesValidatorDirective;


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var util_1 = __webpack_require__(743);
	var lodash_1 = __webpack_require__(268);
	var beneficiary_kind_model_1 = __webpack_require__(1254);
	var revenue_distribution_service_1 = __webpack_require__(1262);
	var EditRevenueDistributionRuleComponent = (function () {
	    function EditRevenueDistributionRuleComponent(_revenueDistributionService) {
	        this._revenueDistributionService = _revenueDistributionService;
	        this.inputUpdated = new core_1.EventEmitter();
	    }
	    EditRevenueDistributionRuleComponent.prototype.ngOnInit = function () {
	        this.fetchSharePresets();
	    };
	    EditRevenueDistributionRuleComponent.prototype.ngAfterViewChecked = function () {
	        var _this = this;
	        if (util_1.isNullOrUndefined(this._groupStatusChanges) && !util_1.isNullOrUndefined(this.shareInputGroup.statusChanges)) {
	            this._groupStatusChanges = this.shareInputGroup.statusChanges.subscribe(function () {
	                _this.updateRowState();
	            });
	        }
	    };
	    EditRevenueDistributionRuleComponent.prototype.ngOnDestroy = function () {
	        if (!util_1.isNullOrUndefined(this._groupStatusChanges)) {
	            this._groupStatusChanges.unsubscribe();
	        }
	    };
	    EditRevenueDistributionRuleComponent.prototype.isSystemBeneficiaryKind = function (kind) {
	        return kind === beneficiary_kind_model_1.BENEFICIARY_KIND.SYSTEM;
	    };
	    EditRevenueDistributionRuleComponent.prototype.isSelfBeneficiaryKind = function (kind) {
	        return kind === this.availableBeneficiaryKinds.length - 1;
	    };
	    EditRevenueDistributionRuleComponent.prototype.accessShareOf = function (kind) {
	        return this.rule.shares[kind];
	    };
	    EditRevenueDistributionRuleComponent.prototype.onSharePercentChange = function (kind, value) {
	        var newPercentValue = parseFloat(value);
	        if (isNaN(newPercentValue)) {
	            return;
	        }
	        if (kind === this.availableBeneficiaryKinds.length - 1) {
	            return;
	        }
	        this.updateSelfShare();
	    };
	    EditRevenueDistributionRuleComponent.prototype.onSelectedFeeChange = function (service) {
	        this.fetchSharePresets();
	    };
	    EditRevenueDistributionRuleComponent.prototype.onSystemShareChange = function (preset) {
	        if (util_1.isNullOrUndefined(preset)) {
	            return;
	        }
	        var share = this.accessShareOf(0);
	        share.percent = preset.percent;
	        share.amount = preset.amount;
	        var value = preset.percent ? preset.percent : 0;
	        this.onSharePercentChange(0, value.toString()); //keeps in sync shares in the model and user-selected presets
	    };
	    EditRevenueDistributionRuleComponent.prototype.validControlAt = function (index) {
	        if (!this.shareInputGroup || !this.shareInputGroup.control) {
	            return false;
	        }
	        var control = this.shareInputGroup.control.controls["editShare-" + this.formGroupId + "-" + this.rowIndex + "-" + index];
	        return !control || control.disabled || (control.valid || !control.dirty);
	    };
	    EditRevenueDistributionRuleComponent.prototype.calculateTotalSharePercentage = function () {
	        var _this = this;
	        return this.rule.shares.filter(function (share) { return _this.availableBeneficiaryKinds.indexOf(share.beneficiaryKind) >= 0; }) //calculate only available percents
	            .map(function (share) { return share.percent; })
	            .map(Number)
	            .reduce(function (prev, cur) {
	            var prevNum = isNaN(prev) ? 0 : prev;
	            var curNum = isNaN(cur) ? 0 : cur;
	            return prevNum + curNum;
	        }, 0);
	    };
	    EditRevenueDistributionRuleComponent.prototype.fetchSharePresets = function () {
	        var _this = this;
	        this._revenueDistributionService.getAvailableShares(this.profileId, this.rule.fee.id).subscribe(function (result) {
	            _this.sharePresets = result;
	            _this.sharePreset = _this.findSelectedPreset();
	        });
	    };
	    EditRevenueDistributionRuleComponent.prototype.findSelectedPreset = function () {
	        var _this = this;
	        return this.sharePresets.find((function (preset) {
	            var systemShare = _this.rule.shares.find(function (share) {
	                return share.beneficiaryKind === beneficiary_kind_model_1.BENEFICIARY_KIND.SYSTEM;
	            });
	            return !util_1.isNullOrUndefined(systemShare) &&
	                systemShare.percent === preset.percent &&
	                (lodash_1.isEqual(systemShare.amount, preset.amount) ||
	                    _this.isNullOrZero(systemShare.amount) && _this.isNullOrZero(preset.amount));
	        }));
	    };
	    EditRevenueDistributionRuleComponent.prototype.isNullOrZero = function (amount) {
	        return util_1.isNullOrUndefined(amount) || amount.amount == 0;
	    };
	    EditRevenueDistributionRuleComponent.prototype.updateRowState = function () {
	        this.inputUpdated.next({
	            valid: this.shareInputGroup.valid,
	            errors: this.shareInputGroup.errors
	        });
	    };
	    EditRevenueDistributionRuleComponent.prototype.updateSelfShare = function () {
	        var selfShare = this.accessShareOf(this.availableBeneficiaryKinds.length - 1);
	        var total = this.calculateTotalSharePercentage();
	        var remaining = 100 - (total - selfShare.percent);
	        selfShare.percent = parseFloat((remaining < 0 ? 0 : remaining).toFixed(2));
	    };
	    __decorate([
	        core_1.Input('profile-id'),
	        __metadata("design:type", Object)
	    ], EditRevenueDistributionRuleComponent.prototype, "profileId", void 0);
	    __decorate([
	        core_1.Input('row-index'),
	        __metadata("design:type", Object)
	    ], EditRevenueDistributionRuleComponent.prototype, "rowIndex", void 0);
	    __decorate([
	        core_1.Input('form-group-id'),
	        __metadata("design:type", Object)
	    ], EditRevenueDistributionRuleComponent.prototype, "formGroupId", void 0);
	    __decorate([
	        core_1.Input('rule'),
	        __metadata("design:type", Object)
	    ], EditRevenueDistributionRuleComponent.prototype, "rule", void 0);
	    __decorate([
	        core_1.Input('available-services'),
	        __metadata("design:type", Array)
	    ], EditRevenueDistributionRuleComponent.prototype, "availableFeeServices", void 0);
	    __decorate([
	        core_1.Input('available-kinds'),
	        __metadata("design:type", Array)
	    ], EditRevenueDistributionRuleComponent.prototype, "availableBeneficiaryKinds", void 0);
	    __decorate([
	        core_1.Input('removable'),
	        __metadata("design:type", Boolean)
	    ], EditRevenueDistributionRuleComponent.prototype, "removable", void 0);
	    __decorate([
	        core_1.ViewChild('shareInputGroup'),
	        __metadata("design:type", forms_1.NgModelGroup)
	    ], EditRevenueDistributionRuleComponent.prototype, "shareInputGroup", void 0);
	    __decorate([
	        core_1.ViewChildren('shareInput', { read: forms_1.NgModel }),
	        __metadata("design:type", core_1.QueryList)
	    ], EditRevenueDistributionRuleComponent.prototype, "shareInputs", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", Object)
	    ], EditRevenueDistributionRuleComponent.prototype, "inputUpdated", void 0);
	    EditRevenueDistributionRuleComponent = __decorate([
	        core_1.Component({
	            selector: '[tfl-edit-revenue-distribution-rule]',
	            template: __webpack_require__(1267),
	            viewProviders: [{ provide: forms_1.ControlContainer, useExisting: forms_1.NgModelGroup }],
	        }),
	        __metadata("design:paramtypes", [revenue_distribution_service_1.RevenueDistributionService])
	    ], EditRevenueDistributionRuleComponent);
	    return EditRevenueDistributionRuleComponent;
	}());
	exports.EditRevenueDistributionRuleComponent = EditRevenueDistributionRuleComponent;


/***/ }),
/* 1267 */
/***/ (function(module, exports) {

	module.exports = "<td class=\"form-group\"\n    ngModelGroup=\"rulesGroup-{{formGroupId}}-{{rowIndex}}\" #fg=\"ngModelGroup\" tflValidShares>\n    <select [disabled]=\"rule.mandatory\"\n            [(ngModel)]=\"rule.fee\"\n            (ngModelChange)=\"onSelectedFeeChange($event)\"\n            name=\"editFee-{{rowIndex}}\"\n            id=\"editFee-{{rowIndex}}\"\n            class=\"form-control select-fee\">\n        <option *ngFor=\"let fee of availableFeeServices\"\n                [ngValue]=\"fee\">\n            {{ fee.name }}\n        </option>\n    </select>\n    <span class=\"text-danger\" [hidden]=\"!fg.hasError('totalSharesPercentage')\"\n          *ngIf=\"!fg.valid && fg.dirty\">\n                        {{'CUSTOMER.DETAILS.TAB.SETTINGS.VALIDATION.SUM_OF_SHARES_PERCENTAGE' | translate }}\n                    </span>\n</td>\n<td class=\"form-group\"\n    [ngClass]=\"{'has-error': !validControlAt(j)}\"\n    ngModelGroup=\"rulesGroup-{{formGroupId}}-{{rowIndex}}\"\n    #shareInputGroup=\"ngModelGroup\"\n    *ngFor=\"let kind of availableBeneficiaryKinds;let j = index\">\n    <ng-container *ngIf=\"!isSystemBeneficiaryKind(kind)\">\n        <input id=\"editShare-{{formGroupId}}-{{rowIndex+'-'+j}}\"\n               name=\"editShare-{{formGroupId}}-{{rowIndex+'-'+j}}\"\n               class=\"form-control\"\n               type=\"percentage-decimal\"\n               #shareInput=\"ngModel\"\n               [(ngModel)]=\"accessShareOf(j).percent\"\n               (ngModelChange)=\"onSharePercentChange(j, $event)\"\n               [disabled]=\"isSelfBeneficiaryKind(j)\"\n               required>\n        <span class=\"text-danger\"\n              [hidden]=\"!shareInput.hasError('required')\"\n              *ngIf=\"!shareInput.valid && shareInput.dirty\">\n            {{'COMMON.VALIDATION.REQUIRED' | translate}}\n        </span>\n    </ng-container>\n    <select *ngIf=\"isSystemBeneficiaryKind(kind)\"\n            id=\"editSystemShare-{{formGroupId}}-{{rowIndex+'-'+j}}\"\n            name=\"editSystemShare-{{formGroupId}}-{{rowIndex+'-'+j}}\"\n            class=\"form-control\"\n            (ngModelChange)=\"onSystemShareChange($event)\"\n            [(ngModel)]=\"sharePreset\"\n            required>\n        <option *ngFor=\"let preset of sharePresets\"\n                [ngValue]=\"preset\">{{preset | tflShare}}\n        </option>\n    </select>\n</td>\n<ng-content></ng-content>"

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var util_1 = __webpack_require__(743);
	var core_1 = __webpack_require__(205);
	var money_pipe_1 = __webpack_require__(1247);
	var SharePipe = (function () {
	    function SharePipe(_moneyPipe) {
	        this._moneyPipe = _moneyPipe;
	    }
	    SharePipe.prototype.transform = function (value) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        if (util_1.isNullOrUndefined(value)) {
	            return '';
	        }
	        var percentStr = util_1.isNullOrUndefined(value.percent) ? null : value.percent + '%';
	        var amountStr = util_1.isNullOrUndefined(value.amount) ? null : this._moneyPipe.transform(value.amount);
	        return lodash_1.join([amountStr, percentStr].filter(function (str) { return !util_1.isNullOrUndefined(str); }), '/');
	    };
	    SharePipe = __decorate([
	        core_1.Pipe({ name: 'tflShare' }),
	        __metadata("design:paramtypes", [money_pipe_1.MoneyPipe])
	    ], SharePipe);
	    return SharePipe;
	}());
	exports.SharePipe = SharePipe;


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var util_1 = __webpack_require__(743);
	var revenue_distribution_exception_component_1 = __webpack_require__(1256);
	var forms_1 = __webpack_require__(768);
	var RevenueDistributionExceptionsComponent = (function () {
	    function RevenueDistributionExceptionsComponent(_cdr) {
	        this._cdr = _cdr;
	        this.customChange = new core_1.EventEmitter();
	    }
	    RevenueDistributionExceptionsComponent.prototype.onExceptionRemoved = function (index) {
	        if (!util_1.isNullOrUndefined(this.exceptions[index])) {
	            this.exceptions.splice(index, 1);
	            if (this.formGroup.control) {
	                this.formGroup.control.markAsDirty();
	            }
	        }
	        this._cdr.detectChanges();
	    };
	    RevenueDistributionExceptionsComponent.prototype.onConditionChanges = function () {
	        this._cdr.detectChanges();
	    };
	    __decorate([
	        core_1.Input('profile-id'),
	        __metadata("design:type", Object)
	    ], RevenueDistributionExceptionsComponent.prototype, "profileId", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], RevenueDistributionExceptionsComponent.prototype, "exceptions", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], RevenueDistributionExceptionsComponent.prototype, "availableFeeServices", void 0);
	    __decorate([
	        core_1.Input('availableProfileKinds'),
	        __metadata("design:type", Array)
	    ], RevenueDistributionExceptionsComponent.prototype, "availableProfileKinds", void 0);
	    __decorate([
	        core_1.Input('availableProfiles'),
	        __metadata("design:type", Array)
	    ], RevenueDistributionExceptionsComponent.prototype, "availableProfiles", void 0);
	    __decorate([
	        core_1.Output('customChange'),
	        __metadata("design:type", core_1.EventEmitter)
	    ], RevenueDistributionExceptionsComponent.prototype, "customChange", void 0);
	    __decorate([
	        core_1.ViewChildren(revenue_distribution_exception_component_1.RevenueDistributionExceptionComponent),
	        __metadata("design:type", core_1.QueryList)
	    ], RevenueDistributionExceptionsComponent.prototype, "exceptionComponents", void 0);
	    __decorate([
	        core_1.ViewChild('fg'),
	        __metadata("design:type", forms_1.NgModelGroup)
	    ], RevenueDistributionExceptionsComponent.prototype, "formGroup", void 0);
	    RevenueDistributionExceptionsComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-revenue-distribution-exceptions',
	            template: "\n        <div ngModelGroup=\"exceptionsGroup\" #fg=\"ngModelGroup\">\n            <div class=\"row col-xs-12\" *ngFor=\"let e of exceptions;let i = index\">\n                <tfl-revenue-distribution-exception\n                    [profile-id]=\"profileId\"\n                    [index]=\"i\"\n                    [model]=\"e\"\n                    [collapsed]=\"exceptions.length >= 5\"\n                    [available-profile-kinds]=\"availableProfileKinds\"\n                    [available-profiles]=\"availableProfiles\"\n                    [availableFeeServices]=\"availableFeeServices\"\n                    (removed)=\"onExceptionRemoved($event)\"\n                    (conditionsChanged)=\"onConditionChanges()\"\n                >\n                </tfl-revenue-distribution-exception>\n            </div>\n        </div>\n    ",
	            viewProviders: [{ provide: forms_1.ControlContainer, useExisting: forms_1.NgForm }]
	        }),
	        __metadata("design:paramtypes", [core_1.ChangeDetectorRef])
	    ], RevenueDistributionExceptionsComponent);
	    return RevenueDistributionExceptionsComponent;
	}());
	exports.RevenueDistributionExceptionsComponent = RevenueDistributionExceptionsComponent;


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var forms_1 = __webpack_require__(768);
	var core_1 = __webpack_require__(205);
	function exceptionValidator() {
	    return function (control) {
	        var formGroup = control;
	        for (var _i = 0, _a = Object.keys(formGroup.controls); _i < _a.length; _i++) {
	            var controlName = _a[_i];
	            var control_1 = formGroup.get(controlName);
	            if (!control_1.valid && control_1.dirty) {
	                return {
	                    atLeastOneControlHasError: true
	                };
	            }
	        }
	        return null;
	    };
	}
	exports.exceptionValidator = exceptionValidator;
	/**
	 * Invalidates form group when at least one of its controls is dirty and not valid
	 */
	var ExceptionValidatorDirective = (function () {
	    function ExceptionValidatorDirective() {
	    }
	    ExceptionValidatorDirective_1 = ExceptionValidatorDirective;
	    ExceptionValidatorDirective.prototype.validate = function (control) {
	        return exceptionValidator()(control);
	    };
	    ExceptionValidatorDirective = ExceptionValidatorDirective_1 = __decorate([
	        core_1.Directive({
	            selector: '[ngModelGroup][tflValidException]',
	            providers: [{
	                    provide: forms_1.NG_VALIDATORS,
	                    useExisting: ExceptionValidatorDirective_1,
	                    multi: true
	                }]
	        })
	    ], ExceptionValidatorDirective);
	    return ExceptionValidatorDirective;
	    var ExceptionValidatorDirective_1;
	}());
	exports.ExceptionValidatorDirective = ExceptionValidatorDirective;


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var forms_1 = __webpack_require__(768);
	var core_1 = __webpack_require__(205);
	var revenue_distribution_exception_component_1 = __webpack_require__(1256);
	var exception_type_service_1 = __webpack_require__(1253);
	var ExceptionSettingsConflictValidatorDirective = (function () {
	    function ExceptionSettingsConflictValidatorDirective(_host, _exceptionTypeService) {
	        this._host = _host;
	        this._exceptionTypeService = _exceptionTypeService;
	    }
	    ExceptionSettingsConflictValidatorDirective_1 = ExceptionSettingsConflictValidatorDirective;
	    ExceptionSettingsConflictValidatorDirective.prototype.validate = function (control) {
	        var mapLength = function (items) { return items ? items.length : 0; };
	        var total = this._exceptionTypeService.getAvailableConditionsTotal(this._host.exceptionType);
	        var selected = mapLength(this._host.selectedConditions);
	        var left = mapLength(this._host.availableConditions);
	        return this.settingsConflictValidator(total, selected, left)(control);
	    };
	    ExceptionSettingsConflictValidatorDirective.prototype.settingsConflictValidator = function (total, selected, left) {
	        return function (control) {
	            if ((selected + left) === 0) {
	                return {
	                    settingsConflict: true
	                };
	            }
	            if (selected === total) {
	                return {
	                    allConditionsSelected: true
	                };
	            }
	            return null;
	        };
	    };
	    ExceptionSettingsConflictValidatorDirective = ExceptionSettingsConflictValidatorDirective_1 = __decorate([
	        core_1.Directive({
	            selector: '[ngModelGroup][tflValidExceptionSettings]',
	            providers: [{
	                    provide: forms_1.NG_VALIDATORS,
	                    useExisting: ExceptionSettingsConflictValidatorDirective_1,
	                    multi: true
	                }]
	        }),
	        __param(0, core_1.Host()), __param(0, core_1.Inject(core_1.forwardRef(function () { return revenue_distribution_exception_component_1.RevenueDistributionExceptionComponent; }))),
	        __metadata("design:paramtypes", [revenue_distribution_exception_component_1.RevenueDistributionExceptionComponent, exception_type_service_1.ExceptionTypeService])
	    ], ExceptionSettingsConflictValidatorDirective);
	    return ExceptionSettingsConflictValidatorDirective;
	    var ExceptionSettingsConflictValidatorDirective_1;
	}());
	exports.ExceptionSettingsConflictValidatorDirective = ExceptionSettingsConflictValidatorDirective;


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var RuleHoverDirective = (function () {
	    function RuleHoverDirective() {
	        this.hover = new core_1.EventEmitter();
	    }
	    RuleHoverDirective.prototype.onMouseEnter = function ($event) {
	        this.hover.next({
	            index: this.index,
	            hovering: true
	        });
	    };
	    RuleHoverDirective.prototype.onMouseLeave = function ($event) {
	        this.hover.next({
	            index: this.index,
	            hovering: false
	        });
	    };
	    __decorate([
	        core_1.Input('tflRuleHover'),
	        __metadata("design:type", Number)
	    ], RuleHoverDirective.prototype, "index", void 0);
	    __decorate([
	        core_1.Output('ruleHover'),
	        __metadata("design:type", Object)
	    ], RuleHoverDirective.prototype, "hover", void 0);
	    __decorate([
	        core_1.HostListener('mouseenter', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], RuleHoverDirective.prototype, "onMouseEnter", null);
	    __decorate([
	        core_1.HostListener('mouseleave', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], RuleHoverDirective.prototype, "onMouseLeave", null);
	    RuleHoverDirective = __decorate([
	        core_1.Directive({
	            selector: '[tflRuleHover]'
	        })
	    ], RuleHoverDirective);
	    return RuleHoverDirective;
	}());
	exports.RuleHoverDirective = RuleHoverDirective;


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var InvalidControlNotifierDirective = (function () {
	    function InvalidControlNotifierDirective(_form) {
	        this._form = _form;
	    }
	    InvalidControlNotifierDirective.prototype.onSubmit = function (event) {
	        if (!this._form.valid) {
	            this.touchAllControls(this._form.form);
	        }
	    };
	    InvalidControlNotifierDirective.prototype.touchAllControls = function (fg) {
	        var _this = this;
	        Object.keys(fg.controls).forEach(function (controlName) {
	            var control = fg.get(controlName);
	            if (control instanceof forms_1.FormControl) {
	                control.markAsDirty();
	            }
	            else if (control instanceof forms_1.FormGroup) {
	                _this.touchAllControls(control);
	                control.updateValueAndValidity();
	            }
	        });
	    };
	    __decorate([
	        core_1.HostListener('submit', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], InvalidControlNotifierDirective.prototype, "onSubmit", null);
	    InvalidControlNotifierDirective = __decorate([
	        core_1.Directive({
	            selector: 'form [tflInvalidControlNotifier]'
	        }),
	        __metadata("design:paramtypes", [forms_1.NgForm])
	    ], InvalidControlNotifierDirective);
	    return InvalidControlNotifierDirective;
	}());
	exports.InvalidControlNotifierDirective = InvalidControlNotifierDirective;


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var SuccessPageComponent = (function () {
	    function SuccessPageComponent() {
	        this.title = null;
	    }
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], SuccessPageComponent.prototype, "title", void 0);
	    SuccessPageComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-success-page',
	            template: __webpack_require__(1275),
	            styles: ["\n        #success-container {\n            margin-bottom: 20px;\n        }\n        #success-icon {\n            color: #5E9A4F;\n            font-size: 6em;\n        }\n        #success-title {\n            font-size: 34px;\n            font-weight: bold;\n            font-stretch: normal;\n            font-style: normal;\n            line-height: normal;\n        }\n    "]
	        }),
	        __metadata("design:paramtypes", [])
	    ], SuccessPageComponent);
	    return SuccessPageComponent;
	}());
	exports.SuccessPageComponent = SuccessPageComponent;


/***/ }),
/* 1275 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"success-container\" class=\"row\">\n    <div class=\"col-xs-2\" style=\"padding-left: 0;\">\n        <i id=\"success-icon\" class=\"fa fa-check-circle\" aria-hidden=\"true\"></i>\n    </div>\n    <div class=\"col-xs-9\" style=\"padding-left: 0;\">\n        <h2 id=\"success-title\" *ngIf=\"title\">{{ title }}</h2>\n    </div>\n</div>\n"

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var table_additional_component_1 = __webpack_require__(1277);
	exports.TABLE_COMPONENTS = [
	    table_additional_component_1.TableAdditionalComponent
	];


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var TableAdditionalComponent = (function () {
	    function TableAdditionalComponent() {
	        this.empty = false;
	        this.loading = false;
	        this.emptyMessage = 'COMMON.EMPTY_RESULT';
	    }
	    __decorate([
	        core_1.Input('empty'),
	        __metadata("design:type", Boolean)
	    ], TableAdditionalComponent.prototype, "empty", void 0);
	    __decorate([
	        core_1.Input('loading'),
	        __metadata("design:type", Boolean)
	    ], TableAdditionalComponent.prototype, "loading", void 0);
	    __decorate([
	        core_1.Input('columns'),
	        __metadata("design:type", Number)
	    ], TableAdditionalComponent.prototype, "columns", void 0);
	    __decorate([
	        core_1.Input('empty-message'),
	        __metadata("design:type", String)
	    ], TableAdditionalComponent.prototype, "emptyMessage", void 0);
	    TableAdditionalComponent = __decorate([
	        core_1.Component({
	            selector: 'table[tfl-table-additional]',
	            template: "\n        <ng-content select=\"thead\"></ng-content>\n        <ng-content *ngIf=\"!empty && !loading\" select=\"tbody\"></ng-content>\n        \n        <tbody *ngIf=\"empty || loading\">\n            <tr>\n                <td [attr.colspan]=\"columns\" class=\"text-center\">\n                    <i *ngIf=\"loading\" class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i>\n                    <h4 *ngIf=\"!loading && empty\">{{ emptyMessage | translate }}</h4>\n                </td>\n            </tr>\n        </tbody>\n    "
	        })
	    ], TableAdditionalComponent);
	    return TableAdditionalComponent;
	}());
	exports.TableAdditionalComponent = TableAdditionalComponent;


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var constants_1 = __webpack_require__(1128);
	var fee_transfer_icon_1 = __webpack_require__(1193);
	var incoming_transfer_icon_1 = __webpack_require__(1191);
	var refund_transfer_icon_1 = __webpack_require__(1209);
	var deivered_transfer_icon_1 = __webpack_require__(1203);
	var internal_exchnage_transfer_icon_1 = __webpack_require__(1213);
	var system_exchange_transfer_icon_1 = __webpack_require__(1216);
	var system_transfer_icon_1 = __webpack_require__(1215);
	var incoming_4_transfer_icon_1 = __webpack_require__(1207);
	var undelivered_transfer_icon_1 = __webpack_require__(1205);
	var outgoing_4_transfer_icon_1 = __webpack_require__(1201);
	var outgoing_3_transter_icon_1 = __webpack_require__(1199);
	var outgoing_transfer_icon_1 = __webpack_require__(1211);
	var internal_transfer_icon_1 = __webpack_require__(1195);
	var card_exchange_transfer_icon_1 = __webpack_require__(1217);
	var card_transfer_icon_1 = __webpack_require__(1219);
	var outgoing_exchange_transfer_icon_1 = __webpack_require__(1197);
	var TransferIconFactory = (function () {
	    function TransferIconFactory(_componentFactory) {
	        this._componentFactory = _componentFactory;
	    }
	    TransferIconFactory.prototype.ngAfterViewInit = function () {
	        this.createIconComponent(this.getIconComponent());
	    };
	    Object.defineProperty(TransferIconFactory.prototype, "type", {
	        get: function () {
	            return this.transfer.type;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TransferIconFactory.prototype, "isExchange", {
	        get: function () {
	            return this.transfer.exchange;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TransferIconFactory.prototype.mainTypeIs = function (type) {
	        return this.transfer.main_type === type;
	    };
	    TransferIconFactory.prototype.getIconComponent = function () {
	        switch (this.type) {
	            case constants_1.PAYMENT_TYPE.FEE:
	                return fee_transfer_icon_1.FeeTransferIcon;
	            case constants_1.PAYMENT_TYPE.INCOMING:
	                return incoming_transfer_icon_1.IncomingTransferIcon;
	            case constants_1.PAYMENT_TYPE.REFUND:
	                return refund_transfer_icon_1.RefundTransferIcon;
	            case constants_1.PAYMENT_TYPE.DELIVERED:
	                return deivered_transfer_icon_1.DeliveredTransferIcon;
	            case constants_1.PAYMENT_TYPE.INTERNAL:
	                return this.isExchange
	                    ? internal_exchnage_transfer_icon_1.InternalExchangeTransferIcon
	                    : internal_transfer_icon_1.InternalTransferIcon;
	            case constants_1.PAYMENT_TYPE.CARD:
	                return this.isExchange
	                    ? card_exchange_transfer_icon_1.CardExchangeTransferIcon
	                    : card_transfer_icon_1.CardTransferIcon;
	            case constants_1.PAYMENT_TYPE.SYSTEM:
	                return this.isExchange
	                    ? system_exchange_transfer_icon_1.SystemExchangeTransferIcon
	                    : system_transfer_icon_1.SystemTransferIcon;
	            case constants_1.PAYMENT_TYPE.UNDELIVERED:
	                return this.mainTypeIs(constants_1.PAYMENT_TYPE.DELIVERED)
	                    ? incoming_4_transfer_icon_1.Incoming4TransferIcon
	                    : undelivered_transfer_icon_1.UndeliveredTransferIcon;
	            case constants_1.PAYMENT_TYPE.OUTGOING:
	                if (this.isExchange && this.mainTypeIs(constants_1.PAYMENT_TYPE.REFUND)) {
	                    return outgoing_4_transfer_icon_1.Outgoing4TransferIcon;
	                }
	                else if (this.isExchange) {
	                    return outgoing_exchange_transfer_icon_1.OutgoingExchangeTransferIcon;
	                }
	                else if (this.mainTypeIs(constants_1.PAYMENT_TYPE.REFUND)) {
	                    return outgoing_3_transter_icon_1.Outgoing3TransferIcon;
	                }
	                else {
	                    return outgoing_transfer_icon_1.OutgoingTransferIcon;
	                }
	        }
	    };
	    TransferIconFactory.prototype.createIconComponent = function (component) {
	        if (!!component) {
	            var factory = this._componentFactory.resolveComponentFactory(component);
	            this.icon.createComponent(factory, 0).changeDetectorRef.detectChanges();
	        }
	    };
	    __decorate([
	        core_1.Input('transfer'),
	        __metadata("design:type", Object)
	    ], TransferIconFactory.prototype, "transfer", void 0);
	    __decorate([
	        core_1.ViewChild('icon', { read: core_1.ViewContainerRef }),
	        __metadata("design:type", core_1.ViewContainerRef)
	    ], TransferIconFactory.prototype, "icon", void 0);
	    TransferIconFactory = __decorate([
	        core_1.Component({
	            selector: 'tfl-transfer-icon-factory',
	            template: '<div #icon></div>'
	        }),
	        __metadata("design:paramtypes", [core_1.ComponentFactoryResolver])
	    ], TransferIconFactory);
	    return TransferIconFactory;
	}());
	exports.TransferIconFactory = TransferIconFactory;


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var profile_1 = __webpack_require__(1280);
	var dictionary_1 = __webpack_require__(1282);
	var files_download_component_1 = __webpack_require__(1287);
	/**
	 * Package exports high level components, that represents system entities.
	 * */
	exports.CUSTOM_COMPONENTS = [
	    profile_1.ClientProfileComponent,
	    files_download_component_1.FilesDownloadComponent
	].concat(dictionary_1.DICTIONARY_COMPONENTS);
	exports.CUSTOM_PROVIDERS = dictionary_1.DICTIONARY_SERVICES.slice();


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1281));


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var ClientProfileComponent = (function () {
	    function ClientProfileComponent() {
	    }
	    __decorate([
	        core_1.Input('id'),
	        __metadata("design:type", Number)
	    ], ClientProfileComponent.prototype, "id", void 0);
	    __decorate([
	        core_1.Input('name'),
	        __metadata("design:type", String)
	    ], ClientProfileComponent.prototype, "name", void 0);
	    ClientProfileComponent = __decorate([
	        core_1.Component({
	            selector: 'ftl-client-profile',
	            template: "\n        <a *ngIf=\"id\" [routerLink]=\"['/space/customers/profiles/registered', id]\">{{ name }}</a>\n        <span *ngIf=\"!id\">{{ name }}</span>\n    "
	        })
	    ], ClientProfileComponent);
	    return ClientProfileComponent;
	}());
	exports.ClientProfileComponent = ClientProfileComponent;


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var country_1 = __webpack_require__(1283);
	exports.DICTIONARY_COMPONENTS = [
	    country_1.CountryComponent,
	    country_1.CountrySelectDirective
	];
	exports.DICTIONARY_SERVICES = [
	    country_1.CountryService
	];


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1284));
	__export(__webpack_require__(1285));
	__export(__webpack_require__(1286));


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var lodash_1 = __webpack_require__(268);
	var CountryService = (function () {
	    function CountryService(http) {
	        this.http = http;
	    }
	    /** Return all countries. */
	    CountryService.prototype.getCountries = function () {
	        if (!this.countries$) {
	            this.countries$ = this.http
	                .get('/api/client/dictionary/countries')
	                .map(function (response) { return response.json(); })
	                .map(function (response) { return response.countries; })
	                .publishReplay(1)
	                .refCount();
	        }
	        return this.countries$;
	    };
	    /** Return first country by filter */
	    CountryService.prototype.findFirstCountryBy = function (query) {
	        return this.getCountries()
	            .map(function (countries) { return lodash_1.find(countries, query); });
	    };
	    CountryService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], CountryService);
	    return CountryService;
	}());
	exports.CountryService = CountryService;


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var country_service_1 = __webpack_require__(1284);
	var lodash_1 = __webpack_require__(268);
	var CountryComponent = (function () {
	    function CountryComponent(_countryService) {
	        this._countryService = _countryService;
	    }
	    CountryComponent.prototype.ngOnChanges = function (changes) {
	        if (changes.hasOwnProperty('countryId')) {
	            this.update({ id: changes['countryId'].currentValue });
	        }
	        else if (changes.hasOwnProperty('countryCode')) {
	            this.update({ abbreviation: lodash_1.upperCase(changes['countryCode'].currentValue) });
	        }
	    };
	    CountryComponent.prototype.getCountryDescription = function () {
	        if (!!this.country) {
	            return "\n                ISO Code: " + this.country.abbreviation + "\nAllow payment: " + this.country.allow_payment + "\n            ";
	        }
	    };
	    CountryComponent.prototype.update = function (query) {
	        var _this = this;
	        this._countryService
	            .findFirstCountryBy(query)
	            .subscribe(function (country) { return _this.country = country; });
	    };
	    __decorate([
	        core_1.Input('country-id'),
	        __metadata("design:type", Number)
	    ], CountryComponent.prototype, "countryId", void 0);
	    __decorate([
	        core_1.Input('country-code'),
	        __metadata("design:type", String)
	    ], CountryComponent.prototype, "countryCode", void 0);
	    CountryComponent = __decorate([
	        core_1.Component({
	            selector: 'ftl-country',
	            template: "\n        <span [title]=\"getCountryDescription()\">{{ country?.name }}</span>\n    "
	        }),
	        __metadata("design:paramtypes", [country_service_1.CountryService])
	    ], CountryComponent);
	    return CountryComponent;
	}());
	exports.CountryComponent = CountryComponent;


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var lodash_1 = __webpack_require__(268);
	var autocomplete_1 = __webpack_require__(958);
	var model_listener_1 = __webpack_require__(961);
	var country_service_1 = __webpack_require__(1284);
	var $ = __webpack_require__(954);
	__webpack_require__(963);
	var PROVIDER = {
	    provide: forms_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return CountrySelectDirective; }),
	    multi: true
	};
	var navigationKeyCodes = [37, 38, 39, 40, 35, 36];
	/**
	 *  TODO refactor to component
	 * */
	var CountrySelectDirective = (function (_super) {
	    __extends(CountrySelectDirective, _super);
	    function CountrySelectDirective(_el, _countryService, _autocompleteService) {
	        var _this = _super.call(this) || this;
	        _this._el = _el;
	        _this._countryService = _countryService;
	        _this._autocompleteService = _autocompleteService;
	        _this.onChange = new core_1.EventEmitter();
	        _this.onTouchedCallback = new core_1.EventEmitter();
	        _this.keyParam = 'id';
	        _this.valueParam = 'name';
	        _this.itemsLimit = 5;
	        _this.minQueryLength = 1;
	        _this.menuClass = 'tt-menu';
	        _this.countryChangeDetector = new CountryChangeDetector;
	        return _this;
	    }
	    CountrySelectDirective.prototype.valueFormatter = function (newValue) {
	        if (!lodash_1.isEmpty(newValue)) {
	            var item = this._keysMap[newValue];
	            if (item && item[0] && item[0] !== null) {
	                return item[0][this.valueParam];
	            }
	        }
	        return newValue;
	    };
	    CountrySelectDirective.prototype.writeValue = function (obj) {
	        _super.prototype.writeValue.call(this, obj);
	        this.countryChangeDetector.setValue(obj);
	    };
	    CountrySelectDirective.prototype.ngOnInit = function () {
	        var _this = this;
	        this.countryChangeDetector.onChange(function (obj) {
	            var key = _this.keyFormatter(obj);
	            if (!lodash_1.isNil(key)) {
	                var valuesMap = lodash_1.groupBy(_this.countries, _this.keyParam);
	                var item = valuesMap[key];
	                if (!lodash_1.isUndefined(item)) {
	                    $(_this._el.nativeElement).typeahead('val', item[0][_this.valueParam]);
	                    return;
	                }
	            }
	            $(_this._el.nativeElement).typeahead('val', '');
	        });
	        this._countryService.getCountries()
	            .subscribe(function (countries) {
	            _this.countries = countries;
	            _this.buildAutocompleteComponent();
	            _this.countryChangeDetector.setCountries(countries);
	        });
	    };
	    /**
	     * todo andrey resolve typescript lazy loading problem
	     * noinspection TypeScriptValidateTypes,TypeScriptUnresolvedFunction
	     * */
	    CountrySelectDirective.prototype.buildAutocompleteComponent = function () {
	        var design = this.getAutocompleteDesignSettings();
	        var dataSource = this.getAutocompleteDataSourceSettings();
	        $(this._el.nativeElement).typeahead(design, dataSource)
	            .on('typeahead:select', this.onTypeaheadSelect.bind(this))
	            .on('typeahead:change', this.onTypeaheadChange.bind(this))
	            .on('keyup', this.onTypeaheadKeyup.bind(this))
	            .on('blur', this.onTypeaheadBlur.bind(this))
	            .closest('.twitter-typeahead').css('display', 'block');
	    };
	    CountrySelectDirective.prototype.getAutocompleteDesignSettings = function () {
	        return {
	            classNames: {
	                menu: this.menuClass
	            },
	            hint: false,
	            highlight: true,
	            minLength: this.minQueryLength,
	        };
	    };
	    CountrySelectDirective.prototype.getAutocompleteDataSourceSettings = function () {
	        var _this = this;
	        return {
	            source: this._autocompleteService.buildSuggestionEngine(function () { return _this.countries; }, function (item) { return item[_this.valueParam]; }, function (source) {
	                _this._keysMap = lodash_1.groupBy(source, _this.keyParam);
	                _this._valuesMap = lodash_1.groupBy(source, _this.valueParam);
	            }),
	            limit: this.itemsLimit
	        };
	    };
	    CountrySelectDirective.prototype.onTypeaheadSelect = function (event) {
	        var value = this._valuesMap[event.target.value];
	        if (!!value && !!value[0]) {
	            this.writeValue(value[0][this.keyParam]);
	        }
	    };
	    CountrySelectDirective.prototype.onTypeaheadChange = function (event) {
	        if (!lodash_1.isNil(this._valuesMap) && lodash_1.isNil(this._valuesMap[event.target.value])) {
	            this.writeValue('');
	        }
	    };
	    CountrySelectDirective.prototype.onTypeaheadKeyup = function (event) {
	        if (!lodash_1.includes(navigationKeyCodes, event.keyCode)) {
	            if (!lodash_1.isNil(this._valuesMap) && !lodash_1.isNil(this._valuesMap[event.target.value])) {
	                var item = this._valuesMap[event.target.value][0];
	                this.writeValue(item[this.keyParam]);
	            }
	        }
	    };
	    CountrySelectDirective.prototype.onTypeaheadBlur = function () {
	        this.onTouchedCallback.emit();
	    };
	    __decorate([
	        core_1.Input('ac-key'),
	        __metadata("design:type", String)
	    ], CountrySelectDirective.prototype, "keyParam", void 0);
	    __decorate([
	        core_1.Input('ac-value'),
	        __metadata("design:type", String)
	    ], CountrySelectDirective.prototype, "valueParam", void 0);
	    __decorate([
	        core_1.Input('items-limit'),
	        __metadata("design:type", Number)
	    ], CountrySelectDirective.prototype, "itemsLimit", void 0);
	    __decorate([
	        core_1.Input('min-query-length'),
	        __metadata("design:type", Number)
	    ], CountrySelectDirective.prototype, "minQueryLength", void 0);
	    __decorate([
	        core_1.Input('menu-class'),
	        __metadata("design:type", String)
	    ], CountrySelectDirective.prototype, "menuClass", void 0);
	    CountrySelectDirective = __decorate([
	        core_1.Directive({
	            selector: '[ftl-country-select]',
	            providers: [PROVIDER, autocomplete_1.AutocompleteService]
	        }),
	        __metadata("design:paramtypes", [core_1.ElementRef,
	            country_service_1.CountryService,
	            autocomplete_1.AutocompleteService])
	    ], CountrySelectDirective);
	    return CountrySelectDirective;
	}(model_listener_1.ModelListener));
	exports.CountrySelectDirective = CountrySelectDirective;
	var CountryChangeDetector = (function () {
	    function CountryChangeDetector() {
	    }
	    CountryChangeDetector.prototype.setValue = function (value) {
	        this.value = value;
	        this.tryEmitCallback();
	    };
	    CountryChangeDetector.prototype.setCountries = function (countries) {
	        this.countries = countries;
	        this.tryEmitCallback();
	    };
	    CountryChangeDetector.prototype.onChange = function (cb) {
	        this.callback = cb;
	    };
	    CountryChangeDetector.prototype.tryEmitCallback = function () {
	        if (!!this.countries) {
	            this.callback(this.value, this.countries);
	        }
	    };
	    return CountryChangeDetector;
	}());


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var FilesDownloadComponent = (function () {
	    function FilesDownloadComponent() {
	        this.disableSaveAll = false;
	        this.downloadFile = new core_1.EventEmitter();
	        this.downloadFiles = new core_1.EventEmitter();
	    }
	    FilesDownloadComponent.prototype.downloadAttachments = function (typeId) {
	        this.downloadFiles.emit(typeId);
	    };
	    FilesDownloadComponent.prototype.downloadAttachment = function (fileId) {
	        this.downloadFile.emit(fileId);
	    };
	    __decorate([
	        core_1.Input('title'),
	        __metadata("design:type", String)
	    ], FilesDownloadComponent.prototype, "title", void 0);
	    __decorate([
	        core_1.Input('buttonName'),
	        __metadata("design:type", String)
	    ], FilesDownloadComponent.prototype, "buttonName", void 0);
	    __decorate([
	        core_1.Input('attachments'),
	        __metadata("design:type", Array)
	    ], FilesDownloadComponent.prototype, "attachments", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], FilesDownloadComponent.prototype, "disableSaveAll", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", Object)
	    ], FilesDownloadComponent.prototype, "downloadFile", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", Object)
	    ], FilesDownloadComponent.prototype, "downloadFiles", void 0);
	    FilesDownloadComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-files-download',
	            template: __webpack_require__(1288)
	        }),
	        __metadata("design:paramtypes", [])
	    ], FilesDownloadComponent);
	    return FilesDownloadComponent;
	}());
	exports.FilesDownloadComponent = FilesDownloadComponent;


/***/ }),
/* 1288 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n        <div class=\"files-header\">\n            <h4> {{title|translate}} </h4>\n            <button *ngIf=\"attachments.length > 1 && !disableSaveAll\"\n                    (click)=\"downloadAttachments(attachments[0].attachmentTypeId)\"\n                    class=\"btn save-all-files-button pull-right\">\n                {{buttonName|translate}}\n            </button>\n            <div class=\"clearfix\"></div>\n        </div>\n    </div>\n    <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n        <div class=\"file-names\">\n            <div *ngFor=\"let file of attachments\"\n                 class=\"file-name\">\n                <div (click)=\"downloadAttachment(file.id)\">\n                    <i class=\"fa fa-file fa-lg\"></i>\n                    <span>{{file.name}}</span>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var form_1 = __webpack_require__(1290);
	var select_filter_component_1 = __webpack_require__(1293);
	exports.CUSTOM_ELEMENTS = [
	    form_1.FormGroupComponent,
	    form_1.FormGroupCteComponent,
	    select_filter_component_1.SelectFilterComponent
	];


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1291));
	__export(__webpack_require__(1292));


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var FormGroupComponent = (function () {
	    function FormGroupComponent() {
	        this.cte = false;
	        this.large = false;
	    }
	    FormGroupComponent.prototype.getLabelClass = function () {
	        return {
	            'control-label': true,
	            'col-xs-12': true,
	            'col-sm-6': true,
	            'col-lg-3': this.large
	        };
	    };
	    FormGroupComponent.prototype.getContentClass = function () {
	        return {
	            'control-container': !this.cte,
	            'col-xs-12': true,
	            'col-sm-6': true,
	            'col-lg-9': this.large
	        };
	    };
	    __decorate([
	        core_1.Input('id'),
	        __metadata("design:type", String)
	    ], FormGroupComponent.prototype, "id", void 0);
	    __decorate([
	        core_1.Input('label'),
	        __metadata("design:type", String)
	    ], FormGroupComponent.prototype, "label", void 0);
	    __decorate([
	        core_1.Input('is-cte'),
	        __metadata("design:type", Boolean)
	    ], FormGroupComponent.prototype, "cte", void 0);
	    __decorate([
	        core_1.Input('is-large'),
	        __metadata("design:type", Boolean)
	    ], FormGroupComponent.prototype, "large", void 0);
	    FormGroupComponent = __decorate([
	        core_1.Component({
	            selector: 'ftl-form-group',
	            template: "\n        <div class=\"form-group\">\n            <label [ngClass]=\"getLabelClass()\">\n                {{ label }}\n            </label>\n\n            <div [ngClass]=\"getContentClass()\">\n                <ng-content></ng-content>\n            </div>\n        </div>\n    "
	        })
	    ], FormGroupComponent);
	    return FormGroupComponent;
	}());
	exports.FormGroupComponent = FormGroupComponent;


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var FormGroupCteComponent = (function () {
	    function FormGroupCteComponent() {
	        this.labelClass = 'col-xs-12 col-sm-6';
	        this.contentClass = 'col-xs-12 col-sm-6';
	        this.cteDisabled = false;
	    }
	    __decorate([
	        core_1.Input('id'),
	        __metadata("design:type", String)
	    ], FormGroupCteComponent.prototype, "id", void 0);
	    __decorate([
	        core_1.Input('label'),
	        __metadata("design:type", String)
	    ], FormGroupCteComponent.prototype, "label", void 0);
	    __decorate([
	        core_1.Input('label-class'),
	        __metadata("design:type", String)
	    ], FormGroupCteComponent.prototype, "labelClass", void 0);
	    __decorate([
	        core_1.Input('content-class'),
	        __metadata("design:type", String)
	    ], FormGroupCteComponent.prototype, "contentClass", void 0);
	    __decorate([
	        core_1.Input('cte-disabled'),
	        __metadata("design:type", Boolean)
	    ], FormGroupCteComponent.prototype, "cteDisabled", void 0);
	    FormGroupCteComponent = __decorate([
	        core_1.Component({
	            selector: 'ftl-form-group-cte',
	            template: "\n        <div [id]=\"id\" class=\"form-group\">\n            <label [ngClass]=\"['control-label', labelClass]\">\n                {{ label }}\n            </label>\n\n            <div [ngClass]=\"['control-container', contentClass]\" [click-to-edit]=\"id\" [cte-disabled]=\"cteDisabled\">\n                <ng-content></ng-content>\n            </div>\n        </div>\n    "
	        })
	    ], FormGroupCteComponent);
	    return FormGroupCteComponent;
	}());
	exports.FormGroupCteComponent = FormGroupCteComponent;


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var ng_select_1 = __webpack_require__(920);
	var util_1 = __webpack_require__(743);
	var model_listener_1 = __webpack_require__(961);
	var forms_1 = __webpack_require__(768);
	var lodash_1 = __webpack_require__(268);
	var VALUE_ACCESSOR_PROVIDER = {
	    provide: forms_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return SelectFilterComponent; }),
	    multi: true
	};
	var SelectFilterComponent = (function (_super) {
	    __extends(SelectFilterComponent, _super);
	    function SelectFilterComponent() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.placeholder = '';
	        _this.disabled = false;
	        _this.onChange = new core_1.EventEmitter();
	        _this.onTouchedCallback = new core_1.EventEmitter();
	        return _this;
	    }
	    Object.defineProperty(SelectFilterComponent.prototype, "optionTemplate", {
	        set: function (tmpl) {
	            this._optionTmplCompiler = lodash_1.template(tmpl);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SelectFilterComponent.prototype, "setOptions", {
	        set: function (options) {
	            if (util_1.isArray(options)) {
	                this.setInnerOptions(options);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SelectFilterComponent.prototype, "disabledAttr", {
	        get: function () {
	            return this.disabled ? 'disabled' : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SelectFilterComponent.prototype.writeValue = function (val) {
	        if (!util_1.isNullOrUndefined(val)) {
	            this.selectOptionByValue(val);
	        }
	    };
	    SelectFilterComponent.prototype.onSelectOption = function (option) {
	        this.onChange.emit(this.optionsMap.get(option));
	    };
	    SelectFilterComponent.prototype.selectOptionByValue = function (newValue) {
	        var _this = this;
	        if (this.ngSelect) {
	            this.optionsMap.forEach(function (value, option) {
	                if (newValue === value) {
	                    _this.ngSelect.select(option.value);
	                }
	            });
	        }
	    };
	    SelectFilterComponent.prototype.setInnerOptions = function (options) {
	        var _this = this;
	        this.optionsMap = new Map();
	        this.innerOptions = [];
	        options.map(function (o) {
	            var optionLabel = o.label || o.name || '';
	            var newOption = {
	                value: o.value || o.id,
	                label: _this._optionTmplCompiler ? _this._optionTmplCompiler(o) : optionLabel
	            };
	            _this.optionsMap.set(newOption, o);
	            _this.innerOptions.push(newOption);
	        });
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], SelectFilterComponent.prototype, "placeholder", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], SelectFilterComponent.prototype, "disabled", void 0);
	    __decorate([
	        core_1.ViewChild(ng_select_1.SelectComponent),
	        __metadata("design:type", ng_select_1.SelectComponent)
	    ], SelectFilterComponent.prototype, "ngSelect", void 0);
	    __decorate([
	        core_1.Input('optionTmpl'),
	        __metadata("design:type", String),
	        __metadata("design:paramtypes", [String])
	    ], SelectFilterComponent.prototype, "optionTemplate", null);
	    __decorate([
	        core_1.Input('options'),
	        __metadata("design:type", Array),
	        __metadata("design:paramtypes", [Array])
	    ], SelectFilterComponent.prototype, "setOptions", null);
	    __decorate([
	        core_1.HostBinding('attr.disabled'),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [])
	    ], SelectFilterComponent.prototype, "disabledAttr", null);
	    SelectFilterComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-select-filter',
	            template: "\n        <ng-select\n            *ngIf=\"innerOptions\"\n            [options]=\"innerOptions\"\n            [placeholder]=\"placeholder | translate\"\n            [disabled]=\"disabled\"\n            (selected)=\"onSelectOption($event)\"\n        ></ng-select>\n    ",
	            providers: [VALUE_ACCESSOR_PROVIDER]
	        })
	    ], SelectFilterComponent);
	    return SelectFilterComponent;
	}(model_listener_1.ModelListener));
	exports.SelectFilterComponent = SelectFilterComponent;


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var account_state_log_component_1 = __webpack_require__(1295);
	exports.ACCOUNT_STATE_LOG_COMPONENTS = [
	    account_state_log_component_1.AccountStateLogComponent
	];


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var lodash_1 = __webpack_require__(268);
	var service_1 = __webpack_require__(1090);
	var AccountStateLogComponent = (function () {
	    function AccountStateLogComponent(_accountStateLogService) {
	        this._accountStateLogService = _accountStateLogService;
	        this.loading = false;
	        this.stateLogEntryList = [];
	    }
	    AccountStateLogComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.loading = true;
	        this._accountStateLogService.getAccountStateLog(this.accountId)
	            .subscribe(function (response) {
	            _this.stateLogEntryList = response;
	            _this.loading = false;
	        });
	    };
	    AccountStateLogComponent.prototype.isEmptyLog = function () {
	        return !this.stateLogEntryList || !this.stateLogEntryList || lodash_1.isEmpty(this.stateLogEntryList);
	    };
	    __decorate([
	        core_1.Input('account-id'),
	        __metadata("design:type", Number)
	    ], AccountStateLogComponent.prototype, "accountId", void 0);
	    AccountStateLogComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-account-state-log',
	            template: __webpack_require__(1296),
	            providers: [service_1.AccountStateLogService]
	        }),
	        __metadata("design:paramtypes", [service_1.AccountStateLogService])
	    ], AccountStateLogComponent);
	    return AccountStateLogComponent;
	}());
	exports.AccountStateLogComponent = AccountStateLogComponent;


/***/ }),
/* 1296 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"text-center\">\n    <table [id]=\"'account-state-log-table' + accountId\" class=\"table account-state-log-table\"\n           tfl-table-additional columns=\"4\" [empty]=\"isEmptyLog()\" [loading]=\"loading\">\n        <thead>\n        <tr>\n            <th>{{ 'CUSTOMER_ACCOUNTS.STATE_LOG.CHANGE_DATETIME'     | translate }}</th>\n            <th>{{ 'CUSTOMER_ACCOUNTS.STATE_LOG.USER_INITIATOR_NAME' | translate }}</th>\n            <th>{{ 'CUSTOMER_ACCOUNTS.STATE_LOG.STATE' | translate }}</th>\n            <th>{{ 'CUSTOMER_ACCOUNTS.STATE_LOG.REASON' | translate }}</th>\n        </tr>\n        </thead>\n\n        <tbody *ngIf=\"!isEmptyLog()\">\n        <tr *ngFor=\"let logEntry of stateLogEntryList\">\n            <td style=\"text-align: center\">{{ logEntry.changeDateTime }}</td>\n            <td style=\"text-align: center\">{{ logEntry.userInitiatorName }}</td>\n            <td style=\"text-align: center\">{{ logEntry.accountState }}</td>\n            <td style=\"text-align: center\">{{logEntry.reason}}</td>\n        </tr>\n        </tbody>\n\n        <tbody *ngIf=\"isEmptyLog() && !loading\">\n        <tr>\n            <td colspan=\"4\" class=\"text-center\" style=\"min-height: 10px;\">\n                <p></p>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n"

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var customer_account_links_1 = __webpack_require__(1298);
	exports.SHARED_CUSTOMER_ACCOUNT_COMPONENTS = [
	    customer_account_links_1.CustomerAccountLinksComponent
	];


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1299));


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var lodash_1 = __webpack_require__(268);
	var service_1 = __webpack_require__(1090);
	var CustomerAccountLinksComponent = (function () {
	    function CustomerAccountLinksComponent(_customersAccountService) {
	        this._customersAccountService = _customersAccountService;
	        this.changes = {};
	    }
	    CustomerAccountLinksComponent.prototype.ngOnInit = function () {
	        this.getAccountById(this.customerAccountId);
	    };
	    CustomerAccountLinksComponent.prototype.getAccountById = function (accountId) {
	        var _this = this;
	        this._customersAccountService.getCustomerAccount(accountId)
	            .subscribe(function (account) { return _this.customerAccount = account; });
	    };
	    CustomerAccountLinksComponent.prototype.isEmptyLinks = function () {
	        return !this.customerAccount || !this.customerAccount.links || lodash_1.isEmpty(this.customerAccount.links);
	    };
	    CustomerAccountLinksComponent.prototype.isOptionsChanged = function (link) {
	        var linkOptions = this.changes[link.id];
	        if (linkOptions) {
	            return link.allowIncoming !== linkOptions[0]
	                || link.allowOutgoing !== linkOptions[1];
	        }
	        return false;
	    };
	    CustomerAccountLinksComponent.prototype.isIncoming = function (link) {
	        var linkOptions = this.changes[link.id];
	        if (linkOptions) {
	            return linkOptions[0];
	        }
	        return link.allowIncoming;
	    };
	    CustomerAccountLinksComponent.prototype.isOutgoing = function (link) {
	        var linkOptions = this.changes[link.id];
	        if (linkOptions) {
	            return linkOptions[1];
	        }
	        return link.allowOutgoing;
	    };
	    CustomerAccountLinksComponent.prototype.changeIncoming = function (link) {
	        this.changes[link.id] = [!this.isIncoming(link), this.isOutgoing(link)];
	        if (!this.isOptionsChanged(link)) {
	            this.changes[link.id] = undefined;
	        }
	    };
	    CustomerAccountLinksComponent.prototype.changeOutgoing = function (link) {
	        this.changes[link.id] = [this.isIncoming(link), !this.isOutgoing(link)];
	        if (!this.isOptionsChanged(link)) {
	            this.changes[link.id] = undefined;
	        }
	    };
	    CustomerAccountLinksComponent.prototype.saveChanges = function (link) {
	        var _this = this;
	        var incoming = this.isIncoming(link);
	        var outgoing = this.isOutgoing(link);
	        this._customersAccountService.saveCustomerToLiquidityAccountLinkOptions(this.customerAccount.id, link.liquidityAccountId, incoming, outgoing)
	            .subscribe(function (response) {
	            link.allowIncoming = response.allowIncoming;
	            link.allowOutgoing = response.allowOutgoing;
	            _this.changes[link.id] = undefined;
	        }, function (error) { throw error; });
	    };
	    CustomerAccountLinksComponent.prototype.isAnyOptionChanged = function () {
	        var _this = this;
	        var oneOfChangedLinks = this.customerAccount.links.find(function (link) { return _this.isOptionsChanged(link); });
	        return oneOfChangedLinks !== null && oneOfChangedLinks !== undefined;
	    };
	    CustomerAccountLinksComponent.prototype.saveAllChanges = function () {
	        var _this = this;
	        this.customerAccount.links.forEach(function (link) {
	            if (_this.isOptionsChanged(link)) {
	                _this.saveChanges(link);
	            }
	        });
	    };
	    CustomerAccountLinksComponent.prototype.resetAllChanges = function () {
	        var _this = this;
	        this.customerAccount.links.forEach(function (link) { return _this.changes[link.id] = undefined; });
	    };
	    __decorate([
	        core_1.Input('customer-account-id'),
	        __metadata("design:type", Number)
	    ], CustomerAccountLinksComponent.prototype, "customerAccountId", void 0);
	    CustomerAccountLinksComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-customer-account-links',
	            template: __webpack_require__(1300)
	        }),
	        __metadata("design:paramtypes", [service_1.CommonCustomerAccountService])
	    ], CustomerAccountLinksComponent);
	    return CustomerAccountLinksComponent;
	}());
	exports.CustomerAccountLinksComponent = CustomerAccountLinksComponent;


/***/ }),
/* 1300 */
/***/ (function(module, exports) {

	module.exports = "<div>\n    <table [id]=\"'customer-account-links-table-' + customerAccountId\" class=\"table customer-account-links-table\">\n        <thead>\n            <tr>\n                <th colspan=\"3\">{{ 'CUSTOMER_ACCOUNTS.LINKS.POOL' | translate }}</th>\n                <th colspan=\"3\">{{ 'CUSTOMER_ACCOUNTS.LINKS.LIQUIDITY_ACCOUNT' | translate }}</th>\n                <th colspan=\"3\">{{ 'CUSTOMER_ACCOUNTS.LINKS.IBAN' | translate }}</th>\n                <th style=\"text-align: center\">{{ 'CUSTOMER_ACCOUNTS.LINKS.ALLOW_INCOMING' | translate }}</th>\n                <th style=\"text-align: center\">{{ 'CUSTOMER_ACCOUNTS.LINKS.ALLOW_OUTGOING' | translate }}</th>\n            </tr>\n        </thead>\n\n        <tbody *ngIf=\"!isEmptyLinks()\">\n            <tr *ngFor=\"let link of customerAccount.links\" [ngClass]=\"{'option-changed': isOptionsChanged(link)}\">\n                <td colspan=\"3\">{{ link.poolName }}</td>\n                <td colspan=\"3\">{{ link.liquidityAccountName }}</td>\n                <td colspan=\"3\">{{ link.iban }}</td>\n                <td style=\"text-align: center\"><input type=\"checkbox\" [checked]=\"isIncoming(link)\" (click)=\"changeIncoming(link)\" *ifHasRoles=\"'EDIT';\"/></td>\n                <td style=\"text-align: center\"><input type=\"checkbox\" [checked]=\"isOutgoing(link)\" (click)=\"changeOutgoing(link)\" *ifHasRoles=\"'EDIT';\"/></td>\n            </tr>\n            <tr>\n                <td colspan=\"13\" style=\"text-align: right\" *ifHasRoles=\"'EDIT';hide:true\">\n                    <button class=\"btn btn-xs btn-primary\" [disabled]=\"!isAnyOptionChanged()\" (click)=\"saveAllChanges()\">{{ 'CUSTOMER_ACCOUNTS.LINKS.APPLY' | translate }}</button>\n                    <button class=\"btn btn-xs btn-danger\" [disabled]=\"!isAnyOptionChanged()\" (click)=\"resetAllChanges()\">{{ 'CUSTOMER_ACCOUNTS.LINKS.RESET' | translate }}</button>\n                </td>\n            </tr>\n        </tbody>\n\n        <tbody *ngIf=\"isEmptyLinks()\">\n            <tr>\n                <td colspan=\"13\" class=\"text-center\">\n                    <h4>{{ 'CUSTOMER_ACCOUNTS.LINKS.EMPTY_LINKS' | translate }}</h4>\n                </td>\n            </tr>\n        </tbody>\n    </table>\n</div>\n\n"

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var util_1 = __webpack_require__(743);
	var lodash_1 = __webpack_require__(268);
	var rxjs_1 = __webpack_require__(304);
	var ChipAnswer = (function () {
	    function ChipAnswer() {
	    }
	    return ChipAnswer;
	}());
	exports.ChipAnswer = ChipAnswer;
	var ChipComponent = (function () {
	    function ChipComponent() {
	        this.minSearchChars = 1;
	        this.predefinedValues = [];
	        this.chipSelected = new core_1.EventEmitter();
	        this.chipRemoved = new core_1.EventEmitter();
	        this.enteredValues = [];
	    }
	    ChipComponent.prototype.remove = function (entryToRemove) {
	        this.chipRemoved.next(entryToRemove);
	        lodash_1.remove(this.enteredValues, function (value) { return value.id === entryToRemove.id; });
	    };
	    ChipComponent.prototype.selected = function (event) {
	        if (event.option.value) {
	            this.enteredValues.push(event.option.value);
	            this.chipSelected.next(event.option.value);
	        }
	        this.entryInput.nativeElement.value = '';
	    };
	    ChipComponent.prototype.getFilteredValues = function () {
	        var _this = this;
	        var searchWord = this.entryInput.nativeElement.value;
	        if (this.shouldBeEmptyValuesList(searchWord)) {
	            return rxjs_1.Observable.of([]);
	        }
	        var result = this.predefinedValues;
	        if (this.enteredValues.length > 0) {
	            result = lodash_1.filter(this.predefinedValues, function (value) { return util_1.isNullOrUndefined(lodash_1.find(_this.enteredValues, function (pred) { return pred.id === value.id; })); });
	        }
	        return rxjs_1.Observable.of(lodash_1.filter(result, function (value) { return value.name.toLowerCase().indexOf(searchWord.toLowerCase()) >= 0; }));
	    };
	    ChipComponent.prototype.onClick = function (event) {
	        var _this = this;
	        if (this.minSearchChars === 0) {
	            setTimeout(function () {
	                _this.entryInput.nativeElement.blur();
	                _this.entryInput.nativeElement.focus();
	            });
	        }
	    };
	    ChipComponent.prototype.shouldBeEmptyValuesList = function (searchWord) {
	        return util_1.isNullOrUndefined(this.predefinedValues)
	            || (this.minSearchChars > 0
	                && searchWord.length <= this.minSearchChars);
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], ChipComponent.prototype, "minSearchChars", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], ChipComponent.prototype, "predefinedValues", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", Object)
	    ], ChipComponent.prototype, "chipSelected", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", Object)
	    ], ChipComponent.prototype, "chipRemoved", void 0);
	    __decorate([
	        core_1.ViewChild('entryInput'),
	        __metadata("design:type", core_1.ElementRef)
	    ], ChipComponent.prototype, "entryInput", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], ChipComponent.prototype, "enteredValues", void 0);
	    ChipComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-chip',
	            template: __webpack_require__(1302)
	        })
	    ], ChipComponent);
	    return ChipComponent;
	}());
	exports.ChipComponent = ChipComponent;


/***/ }),
/* 1302 */
/***/ (function(module, exports) {

	module.exports = "<mat-form-field class=\"chip-text-container\">\n    <mat-chip-list #chipList aria-label=\"Reason selection\" style=\"width: 100%\"\n                   role=\"combobox\"\n                   aria-orientation=\"horizontal\"\n                   (click)=\"onClick($event)\">\n        <mat-chip class=\"mat-chip-round-boxed\"\n                  *ngFor=\"let val of enteredValues\"\n                  [removable]=\"true\"\n                  (removed)=\"remove(val)\">\n            {{val.name}}\n            <i class=\"fa fa-times-circle\" matChipRemove></i>\n        </mat-chip>\n        <input #entryInput\n               [matAutocomplete]=\"auto\"\n               [matChipInputFor]=\"chipList\"\n               [matChipInputAddOnBlur]=\"true\">\n    </mat-chip-list>\n    <mat-autocomplete #auto=\"matAutocomplete\" (optionSelected)=\"selected($event)\" >\n        <mat-option *ngFor=\"let val of getFilteredValues() | async\" [value]=\"val\">\n            {{val.name}}\n        </mat-option>\n    </mat-autocomplete>\n</mat-form-field>\n\n"

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(1075), __webpack_require__(1081), __webpack_require__(1076), __webpack_require__(1077), __webpack_require__(1304), __webpack_require__(1079), __webpack_require__(594), __webpack_require__(768), __webpack_require__(1305), __webpack_require__(222), __webpack_require__(211), __webpack_require__(240)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@angular/material/core', '@angular/cdk/a11y', '@angular/cdk/bidi', '@angular/cdk/coercion', '@angular/cdk/collections', '@angular/cdk/keycodes', 'rxjs/operators/startWith', '@angular/forms', '@angular/material/form-field', 'rxjs/observable/merge', 'rxjs/Subscription', 'rxjs/Subject'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.material = global.ng.material || {}, global.ng.material.chips = global.ng.material.chips || {}),global.ng.core,global.ng.material.core,global.ng.cdk.a11y,global.ng.cdk.bidi,global.ng.cdk.coercion,global.ng.cdk.collections,global.ng.cdk.keycodes,global.Rx.operators,global.ng.forms,global.ng.material.formField,global.Rx.Observable,global.Rx,global.Rx));
	}(this, (function (exports,_angular_core,_angular_material_core,_angular_cdk_a11y,_angular_cdk_bidi,_angular_cdk_coercion,_angular_cdk_collections,_angular_cdk_keycodes,rxjs_operators_startWith,_angular_forms,_angular_material_formField,rxjs_observable_merge,rxjs_Subscription,rxjs_Subject) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Represents an event fired on an individual `mat-chip`.
	 * @record
	 */
	
	/**
	 * Event object emitted by MatChip when selected or deselected.
	 */
	var MatChipSelectionChange = /** @class */ (function () {
	    function MatChipSelectionChange(source, selected, isUserInput) {
	        if (isUserInput === void 0) { isUserInput = false; }
	        this.source = source;
	        this.selected = selected;
	        this.isUserInput = isUserInput;
	    }
	    return MatChipSelectionChange;
	}());
	/**
	 * \@docs-private
	 */
	var MatChipBase = /** @class */ (function () {
	    function MatChipBase(_elementRef) {
	        this._elementRef = _elementRef;
	    }
	    return MatChipBase;
	}());
	var _MatChipMixinBase = _angular_material_core.mixinColor(_angular_material_core.mixinDisabled(MatChipBase), 'primary');
	/**
	 * Dummy directive to add CSS class to basic chips.
	 * \@docs-private
	 */
	var MatBasicChip = /** @class */ (function () {
	    function MatBasicChip() {
	    }
	    MatBasicChip.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: "mat-basic-chip, [mat-basic-chip]",
	                    host: { 'class': 'mat-basic-chip' },
	                },] },
	    ];
	    /** @nocollapse */
	    MatBasicChip.ctorParameters = function () { return []; };
	    return MatBasicChip;
	}());
	/**
	 * Material design styled Chip component. Used inside the MatChipList component.
	 */
	var MatChip = /** @class */ (function (_super) {
	    __extends(MatChip, _super);
	    function MatChip(_elementRef) {
	        var _this = _super.call(this, _elementRef) || this;
	        _this._elementRef = _elementRef;
	        /**
	         * Whether the chip has focus.
	         */
	        _this._hasFocus = false;
	        _this._selected = false;
	        _this._selectable = true;
	        _this._removable = true;
	        /**
	         * Emits when the chip is focused.
	         */
	        _this._onFocus = new rxjs_Subject.Subject();
	        /**
	         * Emits when the chip is blured.
	         */
	        _this._onBlur = new rxjs_Subject.Subject();
	        /**
	         * Emitted when the chip is selected or deselected.
	         */
	        _this.selectionChange = new _angular_core.EventEmitter();
	        /**
	         * Emitted when the chip is destroyed.
	         */
	        _this.destroyed = new _angular_core.EventEmitter();
	        /**
	         * Emitted when the chip is destroyed.
	         * @deprecated Use 'destroyed' instead.
	         * \@deletion-target 6.0.0
	         */
	        _this.destroy = _this.destroyed;
	        /**
	         * Emitted when a chip is to be removed.
	         */
	        _this.removed = new _angular_core.EventEmitter();
	        /**
	         * Emitted when a chip is to be removed.
	         * @deprecated Use `removed` instead.
	         * \@deletion-target 6.0.0
	         */
	        _this.onRemove = _this.removed;
	        return _this;
	    }
	    Object.defineProperty(MatChip.prototype, "selected", {
	        get: /**
	         * Whether the chip is selected.
	         * @return {?}
	         */
	        function () { return this._selected; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._selected = _angular_cdk_coercion.coerceBooleanProperty(value);
	            this.selectionChange.emit({
	                source: this,
	                isUserInput: false,
	                selected: value
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChip.prototype, "value", {
	        get: /**
	         * The value of the chip. Defaults to the content inside `<mat-chip>` tags.
	         * @return {?}
	         */
	        function () {
	            return this._value != undefined
	                ? this._value
	                : this._elementRef.nativeElement.textContent;
	        },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._value = value; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChip.prototype, "selectable", {
	        get: /**
	         * Whether or not the chips are selectable. When a chip is not selectable,
	         * changes to it's selected state are always ignored.
	         * @return {?}
	         */
	        function () { return this._selectable; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._selectable = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChip.prototype, "removable", {
	        get: /**
	         * Determines whether or not the chip displays the remove styling and emits (remove) events.
	         * @return {?}
	         */
	        function () { return this._removable; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._removable = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChip.prototype, "ariaSelected", {
	        /** The ARIA selected applied to the chip. */
	        get: /**
	         * The ARIA selected applied to the chip.
	         * @return {?}
	         */
	        function () {
	            return this.selectable ? this.selected.toString() : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatChip.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this.destroyed.emit({ chip: this });
	    };
	    /** Selects the chip. */
	    /**
	     * Selects the chip.
	     * @return {?}
	     */
	    MatChip.prototype.select = /**
	     * Selects the chip.
	     * @return {?}
	     */
	    function () {
	        this._selected = true;
	        this.selectionChange.emit({
	            source: this,
	            isUserInput: false,
	            selected: true
	        });
	    };
	    /** Deselects the chip. */
	    /**
	     * Deselects the chip.
	     * @return {?}
	     */
	    MatChip.prototype.deselect = /**
	     * Deselects the chip.
	     * @return {?}
	     */
	    function () {
	        this._selected = false;
	        this.selectionChange.emit({
	            source: this,
	            isUserInput: false,
	            selected: false
	        });
	    };
	    /** Select this chip and emit selected event */
	    /**
	     * Select this chip and emit selected event
	     * @return {?}
	     */
	    MatChip.prototype.selectViaInteraction = /**
	     * Select this chip and emit selected event
	     * @return {?}
	     */
	    function () {
	        this._selected = true;
	        // Emit select event when selected changes.
	        this.selectionChange.emit({
	            source: this,
	            isUserInput: true,
	            selected: true
	        });
	    };
	    /** Toggles the current selected state of this chip. */
	    /**
	     * Toggles the current selected state of this chip.
	     * @param {?=} isUserInput
	     * @return {?}
	     */
	    MatChip.prototype.toggleSelected = /**
	     * Toggles the current selected state of this chip.
	     * @param {?=} isUserInput
	     * @return {?}
	     */
	    function (isUserInput) {
	        if (isUserInput === void 0) { isUserInput = false; }
	        this._selected = !this.selected;
	        this.selectionChange.emit({
	            source: this,
	            isUserInput: isUserInput,
	            selected: this._selected
	        });
	        return this.selected;
	    };
	    /** Allows for programmatic focusing of the chip. */
	    /**
	     * Allows for programmatic focusing of the chip.
	     * @return {?}
	     */
	    MatChip.prototype.focus = /**
	     * Allows for programmatic focusing of the chip.
	     * @return {?}
	     */
	    function () {
	        this._elementRef.nativeElement.focus();
	        this._onFocus.next({ chip: this });
	    };
	    /**
	     * Allows for programmatic removal of the chip. Called by the MatChipList when the DELETE or
	     * BACKSPACE keys are pressed.
	     *
	     * Informs any listeners of the removal request. Does not remove the chip from the DOM.
	     */
	    /**
	     * Allows for programmatic removal of the chip. Called by the MatChipList when the DELETE or
	     * BACKSPACE keys are pressed.
	     *
	     * Informs any listeners of the removal request. Does not remove the chip from the DOM.
	     * @return {?}
	     */
	    MatChip.prototype.remove = /**
	     * Allows for programmatic removal of the chip. Called by the MatChipList when the DELETE or
	     * BACKSPACE keys are pressed.
	     *
	     * Informs any listeners of the removal request. Does not remove the chip from the DOM.
	     * @return {?}
	     */
	    function () {
	        if (this.removable) {
	            this.removed.emit({ chip: this });
	        }
	    };
	    /** Ensures events fire properly upon click. */
	    /**
	     * Ensures events fire properly upon click.
	     * @param {?} event
	     * @return {?}
	     */
	    MatChip.prototype._handleClick = /**
	     * Ensures events fire properly upon click.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        // Check disabled
	        if (this.disabled) {
	            return;
	        }
	        event.preventDefault();
	        event.stopPropagation();
	        this.focus();
	    };
	    /** Handle custom key presses. */
	    /**
	     * Handle custom key presses.
	     * @param {?} event
	     * @return {?}
	     */
	    MatChip.prototype._handleKeydown = /**
	     * Handle custom key presses.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (this.disabled) {
	            return;
	        }
	        switch (event.keyCode) {
	            case _angular_cdk_keycodes.DELETE:
	            case _angular_cdk_keycodes.BACKSPACE:
	                // If we are removable, remove the focused chip
	                this.remove();
	                // Always prevent so page navigation does not occur
	                event.preventDefault();
	                break;
	            case _angular_cdk_keycodes.SPACE:
	                // If we are selectable, toggle the focused chip
	                if (this.selectable) {
	                    this.toggleSelected(true);
	                }
	                // Always prevent space from scrolling the page since the list has focus
	                event.preventDefault();
	                break;
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatChip.prototype._blur = /**
	     * @return {?}
	     */
	    function () {
	        this._hasFocus = false;
	        this._onBlur.next({ chip: this });
	    };
	    MatChip.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]",
	                    inputs: ['color', 'disabled'],
	                    exportAs: 'matChip',
	                    host: {
	                        'class': 'mat-chip',
	                        '[attr.tabindex]': 'disabled ? null : -1',
	                        'role': 'option',
	                        '[class.mat-chip-selected]': 'selected',
	                        '[attr.disabled]': 'disabled || null',
	                        '[attr.aria-disabled]': 'disabled.toString()',
	                        '[attr.aria-selected]': 'ariaSelected',
	                        '(click)': '_handleClick($event)',
	                        '(keydown)': '_handleKeydown($event)',
	                        '(focus)': '_hasFocus = true',
	                        '(blur)': '_blur()',
	                    },
	                },] },
	    ];
	    /** @nocollapse */
	    MatChip.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	    ]; };
	    MatChip.propDecorators = {
	        "selected": [{ type: _angular_core.Input },],
	        "value": [{ type: _angular_core.Input },],
	        "selectable": [{ type: _angular_core.Input },],
	        "removable": [{ type: _angular_core.Input },],
	        "selectionChange": [{ type: _angular_core.Output },],
	        "destroyed": [{ type: _angular_core.Output },],
	        "destroy": [{ type: _angular_core.Output },],
	        "removed": [{ type: _angular_core.Output },],
	        "onRemove": [{ type: _angular_core.Output, args: ['remove',] },],
	    };
	    return MatChip;
	}(_MatChipMixinBase));
	/**
	 * Applies proper (click) support and adds styling for use with the Material Design "cancel" icon
	 * available at https://material.io/icons/#ic_cancel.
	 *
	 * Example:
	 *
	 *     `<mat-chip>
	 *       <mat-icon matChipRemove>cancel</mat-icon>
	 *     </mat-chip>`
	 *
	 * You *may* use a custom icon, but you may need to override the `mat-chip-remove` positioning
	 * styles to properly center the icon within the chip.
	 */
	var MatChipRemove = /** @class */ (function () {
	    function MatChipRemove(_parentChip) {
	        this._parentChip = _parentChip;
	    }
	    /** Calls the parent chip's public `remove()` method if applicable. */
	    /**
	     * Calls the parent chip's public `remove()` method if applicable.
	     * @return {?}
	     */
	    MatChipRemove.prototype._handleClick = /**
	     * Calls the parent chip's public `remove()` method if applicable.
	     * @return {?}
	     */
	    function () {
	        if (this._parentChip.removable) {
	            this._parentChip.remove();
	        }
	    };
	    MatChipRemove.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[matChipRemove]',
	                    host: {
	                        'class': 'mat-chip-remove',
	                        '(click)': '_handleClick()',
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatChipRemove.ctorParameters = function () { return [
	        { type: MatChip, },
	    ]; };
	    return MatChipRemove;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 */
	var MatChipListBase = /** @class */ (function () {
	    function MatChipListBase(_defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) {
	        this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
	        this._parentForm = _parentForm;
	        this._parentFormGroup = _parentFormGroup;
	        this.ngControl = ngControl;
	    }
	    return MatChipListBase;
	}());
	var _MatChipListMixinBase = _angular_material_core.mixinErrorState(MatChipListBase);
	// Increasing integer for generating unique ids for chip-list components.
	var nextUniqueId = 0;
	/**
	 * Change event object that is emitted when the chip list value has changed.
	 */
	var MatChipListChange = /** @class */ (function () {
	    function MatChipListChange(source, value) {
	        this.source = source;
	        this.value = value;
	    }
	    return MatChipListChange;
	}());
	/**
	 * A material design chips component (named ChipList for it's similarity to the List component).
	 */
	var MatChipList = /** @class */ (function (_super) {
	    __extends(MatChipList, _super);
	    function MatChipList(_elementRef, _changeDetectorRef, _dir, _parentForm, _parentFormGroup, _defaultErrorStateMatcher, /** @docs-private */
	        ngControl) {
	        var _this = _super.call(this, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) || this;
	        _this._elementRef = _elementRef;
	        _this._changeDetectorRef = _changeDetectorRef;
	        _this._dir = _dir;
	        _this.ngControl = ngControl;
	        /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         */
	        _this.controlType = 'mat-chip-list';
	        /**
	         * When a chip is destroyed, we track the index so we can focus the appropriate next chip.
	         */
	        _this._lastDestroyedIndex = null;
	        /**
	         * Track which chips we're listening to for focus/destruction.
	         */
	        _this._chipSet = new WeakMap();
	        /**
	         * Subscription to tabbing out from the chip list.
	         */
	        _this._tabOutSubscription = rxjs_Subscription.Subscription.EMPTY;
	        /**
	         * Uid of the chip list
	         */
	        _this._uid = "mat-chip-list-" + nextUniqueId++;
	        /**
	         * Tab index for the chip list.
	         */
	        _this._tabIndex = 0;
	        /**
	         * User defined tab index.
	         * When it is not null, use user defined tab index. Otherwise use _tabIndex
	         */
	        _this._userTabIndex = null;
	        /**
	         * Function when touched
	         */
	        _this._onTouched = function () { };
	        /**
	         * Function when changed
	         */
	        _this._onChange = function () { };
	        _this._multiple = false;
	        _this._compareWith = function (o1, o2) { return o1 === o2; };
	        _this._required = false;
	        _this._disabled = false;
	        /**
	         * Orientation of the chip list.
	         */
	        _this.ariaOrientation = 'horizontal';
	        _this._selectable = true;
	        /**
	         * Event emitted when the selected chip list value has been changed by the user.
	         */
	        _this.change = new _angular_core.EventEmitter();
	        /**
	         * Event that emits whenever the raw value of the chip-list changes. This is here primarily
	         * to facilitate the two-way binding for the `value` input.
	         * \@docs-private
	         */
	        _this.valueChange = new _angular_core.EventEmitter();
	        if (_this.ngControl) {
	            _this.ngControl.valueAccessor = _this;
	        }
	        return _this;
	    }
	    Object.defineProperty(MatChipList.prototype, "selected", {
	        /** The array of selected chips inside chip list. */
	        get: /**
	         * The array of selected chips inside chip list.
	         * @return {?}
	         */
	        function () {
	            return this.multiple ? this._selectionModel.selected : this._selectionModel.selected[0];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "role", {
	        /** The ARIA role applied to the chip list. */
	        get: /**
	         * The ARIA role applied to the chip list.
	         * @return {?}
	         */
	        function () { return this.empty ? null : 'listbox'; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "multiple", {
	        get: /**
	         * Whether the user should be allowed to select multiple chips.
	         * @return {?}
	         */
	        function () { return this._multiple; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._multiple = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "compareWith", {
	        get: /**
	         * A function to compare the option values with the selected values. The first argument
	         * is a value from an option. The second is a value from the selection. A boolean
	         * should be returned.
	         * @return {?}
	         */
	        function () { return this._compareWith; },
	        set: /**
	         * @param {?} fn
	         * @return {?}
	         */
	        function (fn) {
	            this._compareWith = fn;
	            if (this._selectionModel) {
	                // A different comparator means the selection could change.
	                this._initializeSelection();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "value", {
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () { return this._value; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this.writeValue(value);
	            this._value = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "id", {
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () { return this._id || this._uid; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._id = value;
	            this.stateChanges.next();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "required", {
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () { return this._required; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._required = _angular_cdk_coercion.coerceBooleanProperty(value);
	            this.stateChanges.next();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "placeholder", {
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () {
	            return this._chipInput ? this._chipInput.placeholder : this._placeholder;
	        },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._placeholder = value;
	            this.stateChanges.next();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "focused", {
	        /** Whether any chips or the matChipInput inside of this chip-list has focus. */
	        get: /**
	         * Whether any chips or the matChipInput inside of this chip-list has focus.
	         * @return {?}
	         */
	        function () {
	            return this.chips.some(function (chip) { return chip._hasFocus; }) ||
	                (this._chipInput && this._chipInput.focused);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "empty", {
	        /**
	         * Implemented as part of MatFormFieldControl.
	         * @docs-private
	         */
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () {
	            return (!this._chipInput || this._chipInput.empty) && this.chips.length === 0;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "shouldLabelFloat", {
	        /**
	         * Implemented as part of MatFormFieldControl.
	         * @docs-private
	         */
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () { return !this.empty || this.focused; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "disabled", {
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () { return this.ngControl ? !!this.ngControl.disabled : this._disabled; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._disabled = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "selectable", {
	        get: /**
	         * Whether or not this chip is selectable. When a chip is not selectable,
	         * its selected state is always ignored.
	         * @return {?}
	         */
	        function () { return this._selectable; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._selectable = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "tabIndex", {
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._userTabIndex = value;
	            this._tabIndex = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "chipSelectionChanges", {
	        /** Combined stream of all of the child chips' selection change events. */
	        get: /**
	         * Combined stream of all of the child chips' selection change events.
	         * @return {?}
	         */
	        function () {
	            return rxjs_observable_merge.merge.apply(void 0, this.chips.map(function (chip) { return chip.selectionChange; }));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "chipFocusChanges", {
	        /** Combined stream of all of the child chips' focus change events. */
	        get: /**
	         * Combined stream of all of the child chips' focus change events.
	         * @return {?}
	         */
	        function () {
	            return rxjs_observable_merge.merge.apply(void 0, this.chips.map(function (chip) { return chip._onFocus; }));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "chipBlurChanges", {
	        /** Combined stream of all of the child chips' blur change events. */
	        get: /**
	         * Combined stream of all of the child chips' blur change events.
	         * @return {?}
	         */
	        function () {
	            return rxjs_observable_merge.merge.apply(void 0, this.chips.map(function (chip) { return chip._onBlur; }));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "chipRemoveChanges", {
	        /** Combined stream of all of the child chips' remove change events. */
	        get: /**
	         * Combined stream of all of the child chips' remove change events.
	         * @return {?}
	         */
	        function () {
	            return rxjs_observable_merge.merge.apply(void 0, this.chips.map(function (chip) { return chip.destroy; }));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatChipList.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._keyManager = new _angular_cdk_a11y.FocusKeyManager(this.chips)
	            .withWrap()
	            .withVerticalOrientation()
	            .withHorizontalOrientation(this._dir ? this._dir.value : 'ltr');
	        // Prevents the chip list from capturing focus and redirecting
	        // it back to the first chip when the user tabs out.
	        this._tabOutSubscription = this._keyManager.tabOut.subscribe(function () {
	            _this._tabIndex = -1;
	            setTimeout(function () { return _this._tabIndex = _this._userTabIndex || 0; });
	        });
	        // When the list changes, re-subscribe
	        this._changeSubscription = this.chips.changes.pipe(rxjs_operators_startWith.startWith(null)).subscribe(function () {
	            _this._resetChips();
	            // Reset chips selected/deselected status
	            // Reset chips selected/deselected status
	            _this._initializeSelection();
	            // Check to see if we need to update our tab index
	            // Check to see if we need to update our tab index
	            _this._updateTabIndex();
	            // Check to see if we have a destroyed chip and need to refocus
	            // Check to see if we have a destroyed chip and need to refocus
	            _this._updateFocusForDestroyedChips();
	            _this.stateChanges.next();
	        });
	    };
	    /**
	     * @return {?}
	     */
	    MatChipList.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        this._selectionModel = new _angular_cdk_collections.SelectionModel(this.multiple, undefined, false);
	        this.stateChanges.next();
	    };
	    /**
	     * @return {?}
	     */
	    MatChipList.prototype.ngDoCheck = /**
	     * @return {?}
	     */
	    function () {
	        if (this.ngControl) {
	            // We need to re-evaluate this on every change detection cycle, because there are some
	            // error triggers that we can't subscribe to (e.g. parent form submissions). This means
	            // that whatever logic is in here has to be super lean or we risk destroying the performance.
	            this.updateErrorState();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatChipList.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._tabOutSubscription.unsubscribe();
	        if (this._changeSubscription) {
	            this._changeSubscription.unsubscribe();
	        }
	        if (this._chipRemoveSubscription) {
	            this._chipRemoveSubscription.unsubscribe();
	        }
	        this._dropSubscriptions();
	        this.stateChanges.complete();
	    };
	    /** Associates an HTML input element with this chip list. */
	    /**
	     * Associates an HTML input element with this chip list.
	     * @param {?} inputElement
	     * @return {?}
	     */
	    MatChipList.prototype.registerInput = /**
	     * Associates an HTML input element with this chip list.
	     * @param {?} inputElement
	     * @return {?}
	     */
	    function (inputElement) {
	        this._chipInput = inputElement;
	    };
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * @docs-private
	     */
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @param {?} ids
	     * @return {?}
	     */
	    MatChipList.prototype.setDescribedByIds = /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @param {?} ids
	     * @return {?}
	     */
	    function (ids) { this._ariaDescribedby = ids.join(' '); };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    MatChipList.prototype.writeValue = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        if (this.chips) {
	            this._setSelectionByValue(value, false);
	        }
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    MatChipList.prototype.registerOnChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._onChange = fn;
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    MatChipList.prototype.registerOnTouched = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._onTouched = fn;
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    MatChipList.prototype.setDisabledState = /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    function (isDisabled) {
	        this.disabled = isDisabled;
	        this._elementRef.nativeElement.disabled = isDisabled;
	        this.stateChanges.next();
	    };
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * @docs-private
	     */
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @return {?}
	     */
	    MatChipList.prototype.onContainerClick = /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @return {?}
	     */
	    function () { this.focus(); };
	    /**
	     * Focuses the the first non-disabled chip in this chip list, or the associated input when there
	     * are no eligible chips.
	     */
	    /**
	     * Focuses the the first non-disabled chip in this chip list, or the associated input when there
	     * are no eligible chips.
	     * @return {?}
	     */
	    MatChipList.prototype.focus = /**
	     * Focuses the the first non-disabled chip in this chip list, or the associated input when there
	     * are no eligible chips.
	     * @return {?}
	     */
	    function () {
	        // TODO: ARIA says this should focus the first `selected` chip if any are selected.
	        // Focus on first element if there's no chipInput inside chip-list
	        if (this._chipInput && this._chipInput.focused) {
	            // do nothing
	        }
	        else if (this.chips.length > 0) {
	            this._keyManager.setFirstItemActive();
	            this.stateChanges.next();
	        }
	        else {
	            this._focusInput();
	            this.stateChanges.next();
	        }
	    };
	    /** Attempt to focus an input if we have one. */
	    /**
	     * Attempt to focus an input if we have one.
	     * @return {?}
	     */
	    MatChipList.prototype._focusInput = /**
	     * Attempt to focus an input if we have one.
	     * @return {?}
	     */
	    function () {
	        if (this._chipInput) {
	            this._chipInput.focus();
	        }
	    };
	    /**
	     * Pass events to the keyboard manager. Available here for tests.
	     */
	    /**
	     * Pass events to the keyboard manager. Available here for tests.
	     * @param {?} event
	     * @return {?}
	     */
	    MatChipList.prototype._keydown = /**
	     * Pass events to the keyboard manager. Available here for tests.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var /** @type {?} */ target = /** @type {?} */ (event.target);
	        // If they are on an empty input and hit backspace, focus the last chip
	        if (event.keyCode === _angular_cdk_keycodes.BACKSPACE && this._isInputEmpty(target)) {
	            this._keyManager.setLastItemActive();
	            event.preventDefault();
	        }
	        else if (target && target.classList.contains('mat-chip')) {
	            this._keyManager.onKeydown(event);
	            this.stateChanges.next();
	        }
	    };
	    /**
	     * Check the tab index as you should not be allowed to focus an empty list.
	     */
	    /**
	     * Check the tab index as you should not be allowed to focus an empty list.
	     * @return {?}
	     */
	    MatChipList.prototype._updateTabIndex = /**
	     * Check the tab index as you should not be allowed to focus an empty list.
	     * @return {?}
	     */
	    function () {
	        // If we have 0 chips, we should not allow keyboard focus
	        this._tabIndex = this._userTabIndex || (this.chips.length === 0 ? -1 : 0);
	    };
	    /**
	     * Update key manager's active item when chip is deleted.
	     * If the deleted chip is the last chip in chip list, focus the new last chip.
	     * Otherwise focus the next chip in the list.
	     * Save `_lastDestroyedIndex` so we can set the correct focus.
	     */
	    /**
	     * Update key manager's active item when chip is deleted.
	     * If the deleted chip is the last chip in chip list, focus the new last chip.
	     * Otherwise focus the next chip in the list.
	     * Save `_lastDestroyedIndex` so we can set the correct focus.
	     * @param {?} chip
	     * @return {?}
	     */
	    MatChipList.prototype._updateKeyManager = /**
	     * Update key manager's active item when chip is deleted.
	     * If the deleted chip is the last chip in chip list, focus the new last chip.
	     * Otherwise focus the next chip in the list.
	     * Save `_lastDestroyedIndex` so we can set the correct focus.
	     * @param {?} chip
	     * @return {?}
	     */
	    function (chip) {
	        var /** @type {?} */ chipIndex = this.chips.toArray().indexOf(chip);
	        if (this._isValidIndex(chipIndex)) {
	            if (chip._hasFocus) {
	                // Check whether the chip is not the last item
	                if (chipIndex < this.chips.length - 1) {
	                    this._keyManager.setActiveItem(chipIndex);
	                }
	                else if (chipIndex - 1 >= 0) {
	                    this._keyManager.setActiveItem(chipIndex - 1);
	                }
	            }
	            if (this._keyManager.activeItemIndex === chipIndex) {
	                this._lastDestroyedIndex = chipIndex;
	            }
	        }
	    };
	    /**
	     * Checks to see if a focus chip was recently destroyed so that we can refocus the next closest
	     * one.
	     */
	    /**
	     * Checks to see if a focus chip was recently destroyed so that we can refocus the next closest
	     * one.
	     * @return {?}
	     */
	    MatChipList.prototype._updateFocusForDestroyedChips = /**
	     * Checks to see if a focus chip was recently destroyed so that we can refocus the next closest
	     * one.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ chipsArray = this.chips;
	        if (this._lastDestroyedIndex != null && chipsArray.length > 0) {
	            // Check whether the destroyed chip was the last item
	            var /** @type {?} */ newFocusIndex = Math.min(this._lastDestroyedIndex, chipsArray.length - 1);
	            this._keyManager.setActiveItem(newFocusIndex);
	            var /** @type {?} */ focusChip = this._keyManager.activeItem;
	            // Focus the chip
	            if (focusChip) {
	                focusChip.focus();
	            }
	        }
	        // Reset our destroyed index
	        this._lastDestroyedIndex = null;
	    };
	    /**
	     * Utility to ensure all indexes are valid.
	     *
	     * @param {?} index The index to be checked.
	     * @return {?} True if the index is valid for our list of chips.
	     */
	    MatChipList.prototype._isValidIndex = /**
	     * Utility to ensure all indexes are valid.
	     *
	     * @param {?} index The index to be checked.
	     * @return {?} True if the index is valid for our list of chips.
	     */
	    function (index) {
	        return index >= 0 && index < this.chips.length;
	    };
	    /**
	     * @param {?} element
	     * @return {?}
	     */
	    MatChipList.prototype._isInputEmpty = /**
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) {
	        if (element && element.nodeName.toLowerCase() === 'input') {
	            var /** @type {?} */ input = /** @type {?} */ (element);
	            return !input.value;
	        }
	        return false;
	    };
	    /**
	     * @param {?} value
	     * @param {?=} isUserInput
	     * @return {?}
	     */
	    MatChipList.prototype._setSelectionByValue = /**
	     * @param {?} value
	     * @param {?=} isUserInput
	     * @return {?}
	     */
	    function (value, isUserInput) {
	        var _this = this;
	        if (isUserInput === void 0) { isUserInput = true; }
	        this._clearSelection();
	        this.chips.forEach(function (chip) { return chip.deselect(); });
	        if (Array.isArray(value)) {
	            value.forEach(function (currentValue) { return _this._selectValue(currentValue, isUserInput); });
	            this._sortValues();
	        }
	        else {
	            var /** @type {?} */ correspondingChip = this._selectValue(value, isUserInput);
	            // Shift focus to the active item. Note that we shouldn't do this in multiple
	            // mode, because we don't know what chip the user interacted with last.
	            if (correspondingChip) {
	                var /** @type {?} */ correspondingChipIndex = this.chips.toArray().indexOf(correspondingChip);
	                if (isUserInput) {
	                    this._keyManager.setActiveItem(correspondingChipIndex);
	                }
	                else {
	                    this._keyManager.updateActiveItemIndex(correspondingChipIndex);
	                }
	            }
	        }
	    };
	    /**
	     * Finds and selects the chip based on its value.
	     * @param {?} value
	     * @param {?=} isUserInput
	     * @return {?} Chip that has the corresponding value.
	     */
	    MatChipList.prototype._selectValue = /**
	     * Finds and selects the chip based on its value.
	     * @param {?} value
	     * @param {?=} isUserInput
	     * @return {?} Chip that has the corresponding value.
	     */
	    function (value, isUserInput) {
	        var _this = this;
	        if (isUserInput === void 0) { isUserInput = true; }
	        var /** @type {?} */ correspondingChip = this.chips.find(function (chip) {
	            return chip.value != null && _this._compareWith(chip.value, value);
	        });
	        if (correspondingChip) {
	            isUserInput ? correspondingChip.selectViaInteraction() : correspondingChip.select();
	            this._selectionModel.select(correspondingChip);
	        }
	        return correspondingChip;
	    };
	    /**
	     * @return {?}
	     */
	    MatChipList.prototype._initializeSelection = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        // Defer setting the value in order to avoid the "Expression
	        // has changed after it was checked" errors from Angular.
	        Promise.resolve().then(function () {
	            if (_this.ngControl || _this._value) {
	                _this._setSelectionByValue(_this.ngControl ? _this.ngControl.value : _this._value, false);
	                _this.stateChanges.next();
	            }
	        });
	    };
	    /**
	     * Deselects every chip in the list.
	     * @param {?=} skip Chip that should not be deselected.
	     * @return {?}
	     */
	    MatChipList.prototype._clearSelection = /**
	     * Deselects every chip in the list.
	     * @param {?=} skip Chip that should not be deselected.
	     * @return {?}
	     */
	    function (skip) {
	        this._selectionModel.clear();
	        this.chips.forEach(function (chip) {
	            if (chip !== skip) {
	                chip.deselect();
	            }
	        });
	        this.stateChanges.next();
	    };
	    /**
	     * Sorts the model values, ensuring that they keep the same
	     * order that they have in the panel.
	     * @return {?}
	     */
	    MatChipList.prototype._sortValues = /**
	     * Sorts the model values, ensuring that they keep the same
	     * order that they have in the panel.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._multiple) {
	            this._selectionModel.clear();
	            this.chips.forEach(function (chip) {
	                if (chip.selected) {
	                    _this._selectionModel.select(chip);
	                }
	            });
	            this.stateChanges.next();
	        }
	    };
	    /**
	     * Emits change event to set the model value.
	     * @param {?=} fallbackValue
	     * @return {?}
	     */
	    MatChipList.prototype._propagateChanges = /**
	     * Emits change event to set the model value.
	     * @param {?=} fallbackValue
	     * @return {?}
	     */
	    function (fallbackValue) {
	        var /** @type {?} */ valueToEmit = null;
	        if (Array.isArray(this.selected)) {
	            valueToEmit = this.selected.map(function (chip) { return chip.value; });
	        }
	        else {
	            valueToEmit = this.selected ? this.selected.value : fallbackValue;
	        }
	        this._value = valueToEmit;
	        this.change.emit(new MatChipListChange(this, valueToEmit));
	        this.valueChange.emit(valueToEmit);
	        this._onChange(valueToEmit);
	        this._changeDetectorRef.markForCheck();
	    };
	    /** When blurred, mark the field as touched when focus moved outside the chip list. */
	    /**
	     * When blurred, mark the field as touched when focus moved outside the chip list.
	     * @return {?}
	     */
	    MatChipList.prototype._blur = /**
	     * When blurred, mark the field as touched when focus moved outside the chip list.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (!this.disabled) {
	            if (this._chipInput) {
	                // If there's a chip input, we should check whether the focus moved to chip input.
	                // If the focus is not moved to chip input, mark the field as touched. If the focus moved
	                // to chip input, do nothing.
	                // Timeout is needed to wait for the focus() event trigger on chip input.
	                setTimeout(function () {
	                    if (!_this.focused) {
	                        _this._markAsTouched();
	                    }
	                });
	            }
	            else {
	                // If there's no chip input, then mark the field as touched.
	                this._markAsTouched();
	            }
	        }
	    };
	    /** Mark the field as touched */
	    /**
	     * Mark the field as touched
	     * @return {?}
	     */
	    MatChipList.prototype._markAsTouched = /**
	     * Mark the field as touched
	     * @return {?}
	     */
	    function () {
	        this._onTouched();
	        this._changeDetectorRef.markForCheck();
	        this.stateChanges.next();
	    };
	    /**
	     * @return {?}
	     */
	    MatChipList.prototype._resetChips = /**
	     * @return {?}
	     */
	    function () {
	        this._dropSubscriptions();
	        this._listenToChipsFocus();
	        this._listenToChipsSelection();
	        this._listenToChipsRemoved();
	    };
	    /**
	     * @return {?}
	     */
	    MatChipList.prototype._dropSubscriptions = /**
	     * @return {?}
	     */
	    function () {
	        if (this._chipFocusSubscription) {
	            this._chipFocusSubscription.unsubscribe();
	            this._chipFocusSubscription = null;
	        }
	        if (this._chipBlurSubscription) {
	            this._chipBlurSubscription.unsubscribe();
	            this._chipBlurSubscription = null;
	        }
	        if (this._chipSelectionSubscription) {
	            this._chipSelectionSubscription.unsubscribe();
	            this._chipSelectionSubscription = null;
	        }
	    };
	    /**
	     * Listens to user-generated selection events on each chip.
	     * @return {?}
	     */
	    MatChipList.prototype._listenToChipsSelection = /**
	     * Listens to user-generated selection events on each chip.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._chipSelectionSubscription = this.chipSelectionChanges.subscribe(function (event) {
	            event.source.selected
	                ? _this._selectionModel.select(event.source)
	                : _this._selectionModel.deselect(event.source);
	            // For single selection chip list, make sure the deselected value is unselected.
	            if (!_this.multiple) {
	                _this.chips.forEach(function (chip) {
	                    if (!_this._selectionModel.isSelected(chip) && chip.selected) {
	                        chip.deselect();
	                    }
	                });
	            }
	            if (event.isUserInput) {
	                _this._propagateChanges();
	            }
	        });
	    };
	    /**
	     * Listens to user-generated selection events on each chip.
	     * @return {?}
	     */
	    MatChipList.prototype._listenToChipsFocus = /**
	     * Listens to user-generated selection events on each chip.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._chipFocusSubscription = this.chipFocusChanges.subscribe(function (event) {
	            var /** @type {?} */ chipIndex = _this.chips.toArray().indexOf(event.chip);
	            if (_this._isValidIndex(chipIndex)) {
	                _this._keyManager.updateActiveItemIndex(chipIndex);
	            }
	            _this.stateChanges.next();
	        });
	        this._chipBlurSubscription = this.chipBlurChanges.subscribe(function () {
	            _this._blur();
	            _this.stateChanges.next();
	        });
	    };
	    /**
	     * @return {?}
	     */
	    MatChipList.prototype._listenToChipsRemoved = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._chipRemoveSubscription = this.chipRemoveChanges.subscribe(function (event) {
	            _this._updateKeyManager(event.chip);
	        });
	    };
	    MatChipList.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-chip-list',
	                    template: "<div class=\"mat-chip-list-wrapper\"><ng-content></ng-content></div>",
	                    exportAs: 'matChipList',
	                    host: {
	                        '[attr.tabindex]': '_tabIndex',
	                        '[attr.aria-describedby]': '_ariaDescribedby || null',
	                        '[attr.aria-required]': 'required.toString()',
	                        '[attr.aria-disabled]': 'disabled.toString()',
	                        '[attr.aria-invalid]': 'errorState',
	                        '[attr.aria-multiselectable]': 'multiple',
	                        '[attr.role]': 'role',
	                        '[class.mat-chip-list-disabled]': 'disabled',
	                        '[class.mat-chip-list-invalid]': 'errorState',
	                        '[class.mat-chip-list-required]': 'required',
	                        '[attr.aria-orientation]': 'ariaOrientation',
	                        'class': 'mat-chip-list',
	                        '(focus)': 'focus()',
	                        '(blur)': '_blur()',
	                        '(keydown)': '_keydown($event)'
	                    },
	                    providers: [{ provide: _angular_material_formField.MatFormFieldControl, useExisting: MatChipList }],
	                    styles: [".mat-chip-list-wrapper{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.mat-chip:not(.mat-basic-chip){transition:box-shadow 280ms cubic-bezier(.4,0,.2,1);display:inline-flex;padding:7px 12px;border-radius:24px;align-items:center;cursor:default}.mat-chip:not(.mat-basic-chip)+.mat-chip:not(.mat-basic-chip){margin:0 0 0 8px}[dir=rtl] .mat-chip:not(.mat-basic-chip)+.mat-chip:not(.mat-basic-chip){margin:0 8px 0 0}.mat-form-field-prefix .mat-chip:not(.mat-basic-chip):last-child{margin-right:8px}[dir=rtl] .mat-form-field-prefix .mat-chip:not(.mat-basic-chip):last-child{margin-left:8px}.mat-chip:not(.mat-basic-chip) .mat-chip-remove.mat-icon{width:1em;height:1em}.mat-chip:not(.mat-basic-chip):focus{box-shadow:0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12);outline:0}@media screen and (-ms-high-contrast:active){.mat-chip:not(.mat-basic-chip){outline:solid 1px}}.mat-chip-list-stacked .mat-chip-list-wrapper{display:block}.mat-chip-list-stacked .mat-chip-list-wrapper .mat-chip:not(.mat-basic-chip){display:block;margin:0;margin-bottom:8px}[dir=rtl] .mat-chip-list-stacked .mat-chip-list-wrapper .mat-chip:not(.mat-basic-chip){margin:0;margin-bottom:8px}.mat-chip-list-stacked .mat-chip-list-wrapper .mat-chip:not(.mat-basic-chip):last-child,[dir=rtl] .mat-chip-list-stacked .mat-chip-list-wrapper .mat-chip:not(.mat-basic-chip):last-child{margin-bottom:0}.mat-form-field-prefix .mat-chip-list-wrapper{margin-bottom:8px}.mat-chip-remove{margin-right:-4px;margin-left:6px;cursor:pointer}[dir=rtl] .mat-chip-remove{margin-right:6px;margin-left:-4px}input.mat-chip-input{width:150px;margin:3px;flex:1 0 150px}"],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush
	                },] },
	    ];
	    /** @nocollapse */
	    MatChipList.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: _angular_cdk_bidi.Directionality, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_forms.NgForm, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_forms.FormGroupDirective, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_material_core.ErrorStateMatcher, },
	        { type: _angular_forms.NgControl, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self },] },
	    ]; };
	    MatChipList.propDecorators = {
	        "errorStateMatcher": [{ type: _angular_core.Input },],
	        "multiple": [{ type: _angular_core.Input },],
	        "compareWith": [{ type: _angular_core.Input },],
	        "value": [{ type: _angular_core.Input },],
	        "id": [{ type: _angular_core.Input },],
	        "required": [{ type: _angular_core.Input },],
	        "placeholder": [{ type: _angular_core.Input },],
	        "disabled": [{ type: _angular_core.Input },],
	        "ariaOrientation": [{ type: _angular_core.Input, args: ['aria-orientation',] },],
	        "selectable": [{ type: _angular_core.Input },],
	        "tabIndex": [{ type: _angular_core.Input },],
	        "change": [{ type: _angular_core.Output },],
	        "valueChange": [{ type: _angular_core.Output },],
	        "chips": [{ type: _angular_core.ContentChildren, args: [MatChip,] },],
	    };
	    return MatChipList;
	}(_MatChipListMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Represents an input event on a `matChipInput`.
	 * @record
	 */
	
	/**
	 * Directive that adds chip-specific behaviors to an input element inside `<mat-form-field>`.
	 * May be placed inside or outside of an `<mat-chip-list>`.
	 */
	var MatChipInput = /** @class */ (function () {
	    function MatChipInput(_elementRef) {
	        this._elementRef = _elementRef;
	        /**
	         * Whether the control is focused.
	         */
	        this.focused = false;
	        this._addOnBlur = false;
	        /**
	         * The list of key codes that will trigger a chipEnd event.
	         *
	         * Defaults to `[ENTER]`.
	         */
	        this.separatorKeyCodes = [_angular_cdk_keycodes.ENTER];
	        /**
	         * Emitted when a chip is to be added.
	         */
	        this.chipEnd = new _angular_core.EventEmitter();
	        /**
	         * The input's placeholder text.
	         */
	        this.placeholder = '';
	        this._inputElement = /** @type {?} */ (this._elementRef.nativeElement);
	    }
	    Object.defineProperty(MatChipInput.prototype, "chipList", {
	        set: /**
	         * Register input for chip list
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (value) {
	                this._chipList = value;
	                this._chipList.registerInput(this);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipInput.prototype, "addOnBlur", {
	        get: /**
	         * Whether or not the chipEnd event will be emitted when the input is blurred.
	         * @return {?}
	         */
	        function () { return this._addOnBlur; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._addOnBlur = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipInput.prototype, "empty", {
	        /** Whether the input is empty. */
	        get: /**
	         * Whether the input is empty.
	         * @return {?}
	         */
	        function () { return !this._inputElement.value; },
	        enumerable: true,
	        configurable: true
	    });
	    /** Utility method to make host definition/tests more clear. */
	    /**
	     * Utility method to make host definition/tests more clear.
	     * @param {?=} event
	     * @return {?}
	     */
	    MatChipInput.prototype._keydown = /**
	     * Utility method to make host definition/tests more clear.
	     * @param {?=} event
	     * @return {?}
	     */
	    function (event) {
	        this._emitChipEnd(event);
	    };
	    /** Checks to see if the blur should emit the (chipEnd) event. */
	    /**
	     * Checks to see if the blur should emit the (chipEnd) event.
	     * @return {?}
	     */
	    MatChipInput.prototype._blur = /**
	     * Checks to see if the blur should emit the (chipEnd) event.
	     * @return {?}
	     */
	    function () {
	        if (this.addOnBlur) {
	            this._emitChipEnd();
	        }
	        this.focused = false;
	        // Blur the chip list if it is not focused
	        if (!this._chipList.focused) {
	            this._chipList._blur();
	        }
	        this._chipList.stateChanges.next();
	    };
	    /**
	     * @return {?}
	     */
	    MatChipInput.prototype._focus = /**
	     * @return {?}
	     */
	    function () {
	        this.focused = true;
	        this._chipList.stateChanges.next();
	    };
	    /** Checks to see if the (chipEnd) event needs to be emitted. */
	    /**
	     * Checks to see if the (chipEnd) event needs to be emitted.
	     * @param {?=} event
	     * @return {?}
	     */
	    MatChipInput.prototype._emitChipEnd = /**
	     * Checks to see if the (chipEnd) event needs to be emitted.
	     * @param {?=} event
	     * @return {?}
	     */
	    function (event) {
	        if (!this._inputElement.value && !!event) {
	            this._chipList._keydown(event);
	        }
	        if (!event || this.separatorKeyCodes.indexOf(event.keyCode) > -1) {
	            this.chipEnd.emit({ input: this._inputElement, value: this._inputElement.value });
	            if (event) {
	                event.preventDefault();
	            }
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatChipInput.prototype._onInput = /**
	     * @return {?}
	     */
	    function () {
	        // Let chip list know whenever the value changes.
	        this._chipList.stateChanges.next();
	    };
	    /** Focuses the input. */
	    /**
	     * Focuses the input.
	     * @return {?}
	     */
	    MatChipInput.prototype.focus = /**
	     * Focuses the input.
	     * @return {?}
	     */
	    function () { this._inputElement.focus(); };
	    MatChipInput.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'input[matChipInputFor]',
	                    exportAs: 'matChipInput, matChipInputFor',
	                    host: {
	                        'class': 'mat-chip-input mat-input-element',
	                        '(keydown)': '_keydown($event)',
	                        '(blur)': '_blur()',
	                        '(focus)': '_focus()',
	                        '(input)': '_onInput()',
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatChipInput.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	    ]; };
	    MatChipInput.propDecorators = {
	        "chipList": [{ type: _angular_core.Input, args: ['matChipInputFor',] },],
	        "addOnBlur": [{ type: _angular_core.Input, args: ['matChipInputAddOnBlur',] },],
	        "separatorKeyCodes": [{ type: _angular_core.Input, args: ['matChipInputSeparatorKeyCodes',] },],
	        "chipEnd": [{ type: _angular_core.Output, args: ['matChipInputTokenEnd',] },],
	        "placeholder": [{ type: _angular_core.Input },],
	    };
	    return MatChipInput;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatChipsModule = /** @class */ (function () {
	    function MatChipsModule() {
	    }
	    MatChipsModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [],
	                    exports: [MatChipList, MatChip, MatChipInput, MatChipRemove, MatChipRemove, MatBasicChip],
	                    declarations: [MatChipList, MatChip, MatChipInput, MatChipRemove, MatChipRemove, MatBasicChip],
	                    providers: [_angular_material_core.ErrorStateMatcher]
	                },] },
	    ];
	    /** @nocollapse */
	    MatChipsModule.ctorParameters = function () { return []; };
	    return MatChipsModule;
	}());
	
	exports.MatChipsModule = MatChipsModule;
	exports.MatChipListBase = MatChipListBase;
	exports._MatChipListMixinBase = _MatChipListMixinBase;
	exports.MatChipListChange = MatChipListChange;
	exports.MatChipList = MatChipList;
	exports.MatChipSelectionChange = MatChipSelectionChange;
	exports.MatChipBase = MatChipBase;
	exports._MatChipMixinBase = _MatChipMixinBase;
	exports.MatBasicChip = MatBasicChip;
	exports.MatChip = MatChip;
	exports.MatChipRemove = MatChipRemove;
	exports.MatChipInput = MatChipInput;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=material-chips.umd.js.map


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(240), __webpack_require__(205)) :
		typeof define === 'function' && define.amd ? define(['exports', 'rxjs/Subject', '@angular/core'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.cdk = global.ng.cdk || {}, global.ng.cdk.collections = global.ng.cdk.collections || {}),global.Rx,global.ng.core));
	}(this, (function (exports,rxjs_Subject,_angular_core) { 'use strict';
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * @abstract
	 */
	var DataSource = /** @class */ (function () {
	    function DataSource() {
	    }
	    return DataSource;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Class to be used to power selecting one or more options from a list.
	 */
	var SelectionModel = /** @class */ (function () {
	    function SelectionModel(_multiple, initiallySelectedValues, _emitChanges) {
	        if (_multiple === void 0) { _multiple = false; }
	        if (_emitChanges === void 0) { _emitChanges = true; }
	        var _this = this;
	        this._multiple = _multiple;
	        this._emitChanges = _emitChanges;
	        /**
	         * Currently-selected values.
	         */
	        this._selection = new Set();
	        /**
	         * Keeps track of the deselected options that haven't been emitted by the change event.
	         */
	        this._deselectedToEmit = [];
	        /**
	         * Keeps track of the selected options that haven't been emitted by the change event.
	         */
	        this._selectedToEmit = [];
	        /**
	         * Event emitted when the value has changed.
	         */
	        this.onChange = this._emitChanges ? new rxjs_Subject.Subject() : null;
	        if (initiallySelectedValues && initiallySelectedValues.length) {
	            if (_multiple) {
	                initiallySelectedValues.forEach(function (value) { return _this._markSelected(value); });
	            }
	            else {
	                this._markSelected(initiallySelectedValues[0]);
	            }
	            // Clear the array in order to avoid firing the change event for preselected values.
	            this._selectedToEmit.length = 0;
	        }
	    }
	    Object.defineProperty(SelectionModel.prototype, "selected", {
	        /** Selected values. */
	        get: /**
	         * Selected values.
	         * @return {?}
	         */
	        function () {
	            if (!this._selected) {
	                this._selected = Array.from(this._selection.values());
	            }
	            return this._selected;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Selects a value or an array of values.
	     */
	    /**
	     * Selects a value or an array of values.
	     * @param {...?} values
	     * @return {?}
	     */
	    SelectionModel.prototype.select = /**
	     * Selects a value or an array of values.
	     * @param {...?} values
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var values = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            values[_i] = arguments[_i];
	        }
	        this._verifyValueAssignment(values);
	        values.forEach(function (value) { return _this._markSelected(value); });
	        this._emitChangeEvent();
	    };
	    /**
	     * Deselects a value or an array of values.
	     */
	    /**
	     * Deselects a value or an array of values.
	     * @param {...?} values
	     * @return {?}
	     */
	    SelectionModel.prototype.deselect = /**
	     * Deselects a value or an array of values.
	     * @param {...?} values
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var values = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            values[_i] = arguments[_i];
	        }
	        this._verifyValueAssignment(values);
	        values.forEach(function (value) { return _this._unmarkSelected(value); });
	        this._emitChangeEvent();
	    };
	    /**
	     * Toggles a value between selected and deselected.
	     */
	    /**
	     * Toggles a value between selected and deselected.
	     * @param {?} value
	     * @return {?}
	     */
	    SelectionModel.prototype.toggle = /**
	     * Toggles a value between selected and deselected.
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        this.isSelected(value) ? this.deselect(value) : this.select(value);
	    };
	    /**
	     * Clears all of the selected values.
	     */
	    /**
	     * Clears all of the selected values.
	     * @return {?}
	     */
	    SelectionModel.prototype.clear = /**
	     * Clears all of the selected values.
	     * @return {?}
	     */
	    function () {
	        this._unmarkAll();
	        this._emitChangeEvent();
	    };
	    /**
	     * Determines whether a value is selected.
	     */
	    /**
	     * Determines whether a value is selected.
	     * @param {?} value
	     * @return {?}
	     */
	    SelectionModel.prototype.isSelected = /**
	     * Determines whether a value is selected.
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        return this._selection.has(value);
	    };
	    /**
	     * Determines whether the model does not have a value.
	     */
	    /**
	     * Determines whether the model does not have a value.
	     * @return {?}
	     */
	    SelectionModel.prototype.isEmpty = /**
	     * Determines whether the model does not have a value.
	     * @return {?}
	     */
	    function () {
	        return this._selection.size === 0;
	    };
	    /**
	     * Determines whether the model has a value.
	     */
	    /**
	     * Determines whether the model has a value.
	     * @return {?}
	     */
	    SelectionModel.prototype.hasValue = /**
	     * Determines whether the model has a value.
	     * @return {?}
	     */
	    function () {
	        return !this.isEmpty();
	    };
	    /**
	     * Sorts the selected values based on a predicate function.
	     */
	    /**
	     * Sorts the selected values based on a predicate function.
	     * @param {?=} predicate
	     * @return {?}
	     */
	    SelectionModel.prototype.sort = /**
	     * Sorts the selected values based on a predicate function.
	     * @param {?=} predicate
	     * @return {?}
	     */
	    function (predicate) {
	        if (this._multiple && this._selected) {
	            this._selected.sort(predicate);
	        }
	    };
	    /**
	     * Emits a change event and clears the records of selected and deselected values.
	     * @return {?}
	     */
	    SelectionModel.prototype._emitChangeEvent = /**
	     * Emits a change event and clears the records of selected and deselected values.
	     * @return {?}
	     */
	    function () {
	        // Clear the selected values so they can be re-cached.
	        this._selected = null;
	        if (this._selectedToEmit.length || this._deselectedToEmit.length) {
	            if (this.onChange) {
	                this.onChange.next({
	                    source: this,
	                    added: this._selectedToEmit,
	                    removed: this._deselectedToEmit
	                });
	            }
	            this._deselectedToEmit = [];
	            this._selectedToEmit = [];
	        }
	    };
	    /**
	     * Selects a value.
	     * @param {?} value
	     * @return {?}
	     */
	    SelectionModel.prototype._markSelected = /**
	     * Selects a value.
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        if (!this.isSelected(value)) {
	            if (!this._multiple) {
	                this._unmarkAll();
	            }
	            this._selection.add(value);
	            if (this._emitChanges) {
	                this._selectedToEmit.push(value);
	            }
	        }
	    };
	    /**
	     * Deselects a value.
	     * @param {?} value
	     * @return {?}
	     */
	    SelectionModel.prototype._unmarkSelected = /**
	     * Deselects a value.
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        if (this.isSelected(value)) {
	            this._selection.delete(value);
	            if (this._emitChanges) {
	                this._deselectedToEmit.push(value);
	            }
	        }
	    };
	    /**
	     * Clears out the selected values.
	     * @return {?}
	     */
	    SelectionModel.prototype._unmarkAll = /**
	     * Clears out the selected values.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (!this.isEmpty()) {
	            this._selection.forEach(function (value) { return _this._unmarkSelected(value); });
	        }
	    };
	    /**
	     * Verifies the value assignment and throws an error if the specified value array is
	     * including multiple values while the selection model is not supporting multiple values.
	     * @param {?} values
	     * @return {?}
	     */
	    SelectionModel.prototype._verifyValueAssignment = /**
	     * Verifies the value assignment and throws an error if the specified value array is
	     * including multiple values while the selection model is not supporting multiple values.
	     * @param {?} values
	     * @return {?}
	     */
	    function (values) {
	        if (values.length > 1 && !this._multiple) {
	            throw getMultipleValuesInSingleSelectionError();
	        }
	    };
	    return SelectionModel;
	}());
	/**
	 * Event emitted when the value of a MatSelectionModel has changed.
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * Returns an error that reports that multiple values are passed into a selection model
	 * with a single value.
	 * @return {?}
	 */
	function getMultipleValuesInSingleSelectionError() {
	    return Error('Cannot pass multiple values into SelectionModel with single-value mode.');
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Class to coordinate unique selection based on name.
	 * Intended to be consumed as an Angular service.
	 * This service is needed because native radio change events are only fired on the item currently
	 * being selected, and we still need to uncheck the previous selection.
	 *
	 * This service does not *store* any IDs and names because they may change at any time, so it is
	 * less error-prone if they are simply passed through when the events occur.
	 */
	var UniqueSelectionDispatcher = /** @class */ (function () {
	    function UniqueSelectionDispatcher() {
	        this._listeners = [];
	    }
	    /**
	     * Notify other items that selection for the given name has been set.
	     * @param id ID of the item.
	     * @param name Name of the item.
	     */
	    /**
	     * Notify other items that selection for the given name has been set.
	     * @param {?} id ID of the item.
	     * @param {?} name Name of the item.
	     * @return {?}
	     */
	    UniqueSelectionDispatcher.prototype.notify = /**
	     * Notify other items that selection for the given name has been set.
	     * @param {?} id ID of the item.
	     * @param {?} name Name of the item.
	     * @return {?}
	     */
	    function (id, name) {
	        for (var _i = 0, _a = this._listeners; _i < _a.length; _i++) {
	            var listener = _a[_i];
	            listener(id, name);
	        }
	    };
	    /**
	     * Listen for future changes to item selection.
	     * @return Function used to deregister listener
	     */
	    /**
	     * Listen for future changes to item selection.
	     * @param {?} listener
	     * @return {?} Function used to deregister listener
	     */
	    UniqueSelectionDispatcher.prototype.listen = /**
	     * Listen for future changes to item selection.
	     * @param {?} listener
	     * @return {?} Function used to deregister listener
	     */
	    function (listener) {
	        var _this = this;
	        this._listeners.push(listener);
	        return function () {
	            _this._listeners = _this._listeners.filter(function (registered) {
	                return listener !== registered;
	            });
	        };
	    };
	    /**
	     * @return {?}
	     */
	    UniqueSelectionDispatcher.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._listeners = [];
	    };
	    UniqueSelectionDispatcher.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    UniqueSelectionDispatcher.ctorParameters = function () { return []; };
	    return UniqueSelectionDispatcher;
	}());
	/**
	 * \@docs-private
	 * @param {?} parentDispatcher
	 * @return {?}
	 */
	function UNIQUE_SELECTION_DISPATCHER_PROVIDER_FACTORY(parentDispatcher) {
	    return parentDispatcher || new UniqueSelectionDispatcher();
	}
	/**
	 * \@docs-private
	 */
	var UNIQUE_SELECTION_DISPATCHER_PROVIDER = {
	    // If there is already a dispatcher available, use that. Otherwise, provide a new one.
	    provide: UniqueSelectionDispatcher,
	    deps: [[new _angular_core.Optional(), new _angular_core.SkipSelf(), UniqueSelectionDispatcher]],
	    useFactory: UNIQUE_SELECTION_DISPATCHER_PROVIDER_FACTORY
	};
	
	exports.UniqueSelectionDispatcher = UniqueSelectionDispatcher;
	exports.UNIQUE_SELECTION_DISPATCHER_PROVIDER = UNIQUE_SELECTION_DISPATCHER_PROVIDER;
	exports.DataSource = DataSource;
	exports.SelectionModel = SelectionModel;
	exports.getMultipleValuesInSingleSelectionError = getMultipleValuesInSingleSelectionError;
	exports.ɵa = UNIQUE_SELECTION_DISPATCHER_PROVIDER_FACTORY;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=cdk-collections.umd.js.map


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(246), __webpack_require__(205), __webpack_require__(1078), __webpack_require__(1077), __webpack_require__(1075), __webpack_require__(327), __webpack_require__(594), __webpack_require__(263), __webpack_require__(250)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/common', '@angular/core', '@angular/cdk/platform', '@angular/cdk/coercion', '@angular/material/core', 'rxjs/observable/fromEvent', 'rxjs/operators/startWith', 'rxjs/operators/take', '@angular/animations'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.material = global.ng.material || {}, global.ng.material.formField = global.ng.material.formField || {}),global.ng.common,global.ng.core,global.ng.cdk.platform,global.ng.cdk.coercion,global.ng.material.core,global.Rx.Observable,global.Rx.operators,global.Rx.operators,global.ng.animations));
	}(this, (function (exports,_angular_common,_angular_core,_angular_cdk_platform,_angular_cdk_coercion,_angular_material_core,rxjs_observable_fromEvent,rxjs_operators_startWith,rxjs_operators_take,_angular_animations) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var nextUniqueId = 0;
	/**
	 * Single error message to be shown underneath the form field.
	 */
	var MatError = /** @class */ (function () {
	    function MatError() {
	        this.id = "mat-error-" + nextUniqueId++;
	    }
	    MatError.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-error',
	                    host: {
	                        'class': 'mat-error',
	                        'role': 'alert',
	                        '[attr.id]': 'id',
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatError.ctorParameters = function () { return []; };
	    MatError.propDecorators = {
	        "id": [{ type: _angular_core.Input },],
	    };
	    return MatError;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * Animations used by the MatFormField.
	 */
	var matFormFieldAnimations = {
	    /** Animation that transitions the form field's error and hint messages. */
	    transitionMessages: _angular_animations.trigger('transitionMessages', [
	        // TODO(mmalerba): Use angular animations for label animation as well.
	        _angular_animations.state('enter', _angular_animations.style({ opacity: 1, transform: 'translateY(0%)' })),
	        _angular_animations.transition('void => enter', [
	            _angular_animations.style({ opacity: 0, transform: 'translateY(-100%)' }),
	            _angular_animations.animate('300ms cubic-bezier(0.55, 0, 0.55, 0.2)'),
	        ]),
	    ])
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * An interface which allows a control to work inside of a `MatFormField`.
	 * @abstract
	 */
	var MatFormFieldControl = /** @class */ (function () {
	    function MatFormFieldControl() {
	    }
	    return MatFormFieldControl;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 * @return {?}
	 */
	function getMatFormFieldPlaceholderConflictError() {
	    return Error('Placeholder attribute and child element were both specified.');
	}
	/**
	 * \@docs-private
	 * @param {?} align
	 * @return {?}
	 */
	function getMatFormFieldDuplicatedHintError(align) {
	    return Error("A hint was already declared for 'align=\"" + align + "\"'.");
	}
	/**
	 * \@docs-private
	 * @return {?}
	 */
	function getMatFormFieldMissingControlError() {
	    return Error('mat-form-field must contain a MatFormFieldControl.');
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var nextUniqueId$2 = 0;
	/**
	 * Hint text to be shown underneath the form field control.
	 */
	var MatHint = /** @class */ (function () {
	    function MatHint() {
	        /**
	         * Whether to align the hint label at the start or end of the line.
	         */
	        this.align = 'start';
	        /**
	         * Unique ID for the hint. Used for the aria-describedby on the form field control.
	         */
	        this.id = "mat-hint-" + nextUniqueId$2++;
	    }
	    MatHint.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-hint',
	                    host: {
	                        'class': 'mat-hint',
	                        '[class.mat-right]': 'align == "end"',
	                        '[attr.id]': 'id',
	                        // Remove align attribute to prevent it from interfering with layout.
	                        '[attr.align]': 'null',
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatHint.ctorParameters = function () { return []; };
	    MatHint.propDecorators = {
	        "align": [{ type: _angular_core.Input },],
	        "id": [{ type: _angular_core.Input },],
	    };
	    return MatHint;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * The floating label for a `mat-form-field`.
	 */
	var MatLabel = /** @class */ (function () {
	    function MatLabel() {
	    }
	    MatLabel.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-label'
	                },] },
	    ];
	    /** @nocollapse */
	    MatLabel.ctorParameters = function () { return []; };
	    return MatLabel;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * The placeholder text for an `MatFormField`.
	 */
	var MatPlaceholder = /** @class */ (function () {
	    function MatPlaceholder() {
	    }
	    MatPlaceholder.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-placeholder'
	                },] },
	    ];
	    /** @nocollapse */
	    MatPlaceholder.ctorParameters = function () { return []; };
	    return MatPlaceholder;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Prefix to be placed the the front of the form field.
	 */
	var MatPrefix = /** @class */ (function () {
	    function MatPrefix() {
	    }
	    MatPrefix.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[matPrefix]',
	                },] },
	    ];
	    /** @nocollapse */
	    MatPrefix.ctorParameters = function () { return []; };
	    return MatPrefix;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Suffix to be placed at the end of the form field.
	 */
	var MatSuffix = /** @class */ (function () {
	    function MatSuffix() {
	    }
	    MatSuffix.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[matSuffix]',
	                },] },
	    ];
	    /** @nocollapse */
	    MatSuffix.ctorParameters = function () { return []; };
	    return MatSuffix;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 */
	var MatFormFieldBase = /** @class */ (function () {
	    function MatFormFieldBase(_elementRef) {
	        this._elementRef = _elementRef;
	    }
	    return MatFormFieldBase;
	}());
	var _MatFormFieldMixinBase = _angular_material_core.mixinColor(MatFormFieldBase, 'primary');
	var nextUniqueId$1 = 0;
	/**
	 * Container for form controls that applies Material Design styling and behavior.
	 */
	var MatFormField = /** @class */ (function (_super) {
	    __extends(MatFormField, _super);
	    function MatFormField(_elementRef, _changeDetectorRef, labelOptions) {
	        var _this = _super.call(this, _elementRef) || this;
	        _this._elementRef = _elementRef;
	        _this._changeDetectorRef = _changeDetectorRef;
	        /**
	         * Override for the logic that disables the label animation in certain cases.
	         */
	        _this._showAlwaysAnimate = false;
	        /**
	         * State of the mat-hint and mat-error animations.
	         */
	        _this._subscriptAnimationState = '';
	        _this._hintLabel = '';
	        // Unique id for the hint label.
	        _this._hintLabelId = "mat-hint-" + nextUniqueId$1++;
	        _this._labelOptions = labelOptions ? labelOptions : {};
	        _this.floatLabel = _this._labelOptions.float || 'auto';
	        return _this;
	    }
	    Object.defineProperty(MatFormField.prototype, "dividerColor", {
	        get: /**
	         * @deprecated Use `color` instead.
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this.color; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this.color = value; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatFormField.prototype, "hideRequiredMarker", {
	        get: /**
	         * Whether the required marker should be hidden.
	         * @return {?}
	         */
	        function () { return this._hideRequiredMarker; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._hideRequiredMarker = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatFormField.prototype, "_shouldAlwaysFloat", {
	        /** Whether the floating label should always float or not. */
	        get: /**
	         * Whether the floating label should always float or not.
	         * @return {?}
	         */
	        function () {
	            return this._floatLabel === 'always' && !this._showAlwaysAnimate;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatFormField.prototype, "_canLabelFloat", {
	        /** Whether the label can float or not. */
	        get: /**
	         * Whether the label can float or not.
	         * @return {?}
	         */
	        function () { return this._floatLabel !== 'never'; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatFormField.prototype, "hintLabel", {
	        get: /**
	         * Text for the form field hint.
	         * @return {?}
	         */
	        function () { return this._hintLabel; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._hintLabel = value;
	            this._processHints();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatFormField.prototype, "floatPlaceholder", {
	        get: /**
	         * Whether the placeholder should always float, never float or float as the user types.
	         * @deprecated Use floatLabel instead.
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this._floatLabel; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this.floatLabel = value; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatFormField.prototype, "floatLabel", {
	        get: /**
	         * Whether the label should always float, never float or float as the user types.
	         * @return {?}
	         */
	        function () { return this._floatLabel; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (value !== this._floatLabel) {
	                this._floatLabel = value || this._labelOptions.float || 'auto';
	                this._changeDetectorRef.markForCheck();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatFormField.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._validateControlChild();
	        if (this._control.controlType) {
	            this._elementRef.nativeElement.classList
	                .add("mat-form-field-type-" + this._control.controlType);
	        }
	        // Subscribe to changes in the child control state in order to update the form field UI.
	        this._control.stateChanges.pipe(rxjs_operators_startWith.startWith(/** @type {?} */ ((null)))).subscribe(function () {
	            _this._validatePlaceholders();
	            _this._syncDescribedByIds();
	            _this._changeDetectorRef.markForCheck();
	        });
	        var /** @type {?} */ ngControl = this._control.ngControl;
	        if (ngControl && ngControl.valueChanges) {
	            ngControl.valueChanges.subscribe(function () {
	                _this._changeDetectorRef.markForCheck();
	            });
	        }
	        // Re-validate when the number of hints changes.
	        this._hintChildren.changes.pipe(rxjs_operators_startWith.startWith(null)).subscribe(function () {
	            _this._processHints();
	            _this._changeDetectorRef.markForCheck();
	        });
	        // Update the aria-described by when the number of errors changes.
	        this._errorChildren.changes.pipe(rxjs_operators_startWith.startWith(null)).subscribe(function () {
	            _this._syncDescribedByIds();
	            _this._changeDetectorRef.markForCheck();
	        });
	    };
	    /**
	     * @return {?}
	     */
	    MatFormField.prototype.ngAfterContentChecked = /**
	     * @return {?}
	     */
	    function () {
	        this._validateControlChild();
	    };
	    /**
	     * @return {?}
	     */
	    MatFormField.prototype.ngAfterViewInit = /**
	     * @return {?}
	     */
	    function () {
	        // Avoid animations on load.
	        this._subscriptAnimationState = 'enter';
	        this._changeDetectorRef.detectChanges();
	    };
	    /** Determines whether a class from the NgControl should be forwarded to the host element. */
	    /**
	     * Determines whether a class from the NgControl should be forwarded to the host element.
	     * @param {?} prop
	     * @return {?}
	     */
	    MatFormField.prototype._shouldForward = /**
	     * Determines whether a class from the NgControl should be forwarded to the host element.
	     * @param {?} prop
	     * @return {?}
	     */
	    function (prop) {
	        var /** @type {?} */ ngControl = this._control ? this._control.ngControl : null;
	        return ngControl && (/** @type {?} */ (ngControl))[prop];
	    };
	    /**
	     * @return {?}
	     */
	    MatFormField.prototype._hasPlaceholder = /**
	     * @return {?}
	     */
	    function () {
	        return !!(this._control.placeholder || this._placeholderChild);
	    };
	    /**
	     * @return {?}
	     */
	    MatFormField.prototype._hasLabel = /**
	     * @return {?}
	     */
	    function () {
	        return !!this._labelChild;
	    };
	    /**
	     * @return {?}
	     */
	    MatFormField.prototype._shouldLabelFloat = /**
	     * @return {?}
	     */
	    function () {
	        return this._canLabelFloat && (this._control.shouldLabelFloat ||
	            this._control.shouldPlaceholderFloat || this._shouldAlwaysFloat);
	    };
	    /**
	     * @return {?}
	     */
	    MatFormField.prototype._hideControlPlaceholder = /**
	     * @return {?}
	     */
	    function () {
	        return !this._hasLabel() || !this._shouldLabelFloat();
	    };
	    /**
	     * @return {?}
	     */
	    MatFormField.prototype._hasFloatingLabel = /**
	     * @return {?}
	     */
	    function () {
	        return this._hasLabel() || this._hasPlaceholder();
	    };
	    /** Determines whether to display hints or errors. */
	    /**
	     * Determines whether to display hints or errors.
	     * @return {?}
	     */
	    MatFormField.prototype._getDisplayedMessages = /**
	     * Determines whether to display hints or errors.
	     * @return {?}
	     */
	    function () {
	        return (this._errorChildren && this._errorChildren.length > 0 &&
	            this._control.errorState) ? 'error' : 'hint';
	    };
	    /** Animates the placeholder up and locks it in position. */
	    /**
	     * Animates the placeholder up and locks it in position.
	     * @return {?}
	     */
	    MatFormField.prototype._animateAndLockLabel = /**
	     * Animates the placeholder up and locks it in position.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._hasFloatingLabel() && this._canLabelFloat) {
	            this._showAlwaysAnimate = true;
	            this._floatLabel = 'always';
	            rxjs_observable_fromEvent.fromEvent(this._label.nativeElement, 'transitionend').pipe(rxjs_operators_take.take(1)).subscribe(function () {
	                _this._showAlwaysAnimate = false;
	            });
	            this._changeDetectorRef.markForCheck();
	        }
	    };
	    /**
	     * Ensure that there is only one placeholder (either `placeholder` attribute on the child control
	     * or child element with the `mat-placeholder` directive).
	     * @return {?}
	     */
	    MatFormField.prototype._validatePlaceholders = /**
	     * Ensure that there is only one placeholder (either `placeholder` attribute on the child control
	     * or child element with the `mat-placeholder` directive).
	     * @return {?}
	     */
	    function () {
	        if (this._control.placeholder && this._placeholderChild) {
	            throw getMatFormFieldPlaceholderConflictError();
	        }
	    };
	    /**
	     * Does any extra processing that is required when handling the hints.
	     * @return {?}
	     */
	    MatFormField.prototype._processHints = /**
	     * Does any extra processing that is required when handling the hints.
	     * @return {?}
	     */
	    function () {
	        this._validateHints();
	        this._syncDescribedByIds();
	    };
	    /**
	     * Ensure that there is a maximum of one of each `<mat-hint>` alignment specified, with the
	     * attribute being considered as `align="start"`.
	     * @return {?}
	     */
	    MatFormField.prototype._validateHints = /**
	     * Ensure that there is a maximum of one of each `<mat-hint>` alignment specified, with the
	     * attribute being considered as `align="start"`.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._hintChildren) {
	            var /** @type {?} */ startHint_1;
	            var /** @type {?} */ endHint_1;
	            this._hintChildren.forEach(function (hint) {
	                if (hint.align === 'start') {
	                    if (startHint_1 || _this.hintLabel) {
	                        throw getMatFormFieldDuplicatedHintError('start');
	                    }
	                    startHint_1 = hint;
	                }
	                else if (hint.align === 'end') {
	                    if (endHint_1) {
	                        throw getMatFormFieldDuplicatedHintError('end');
	                    }
	                    endHint_1 = hint;
	                }
	            });
	        }
	    };
	    /**
	     * Sets the list of element IDs that describe the child control. This allows the control to update
	     * its `aria-describedby` attribute accordingly.
	     * @return {?}
	     */
	    MatFormField.prototype._syncDescribedByIds = /**
	     * Sets the list of element IDs that describe the child control. This allows the control to update
	     * its `aria-describedby` attribute accordingly.
	     * @return {?}
	     */
	    function () {
	        if (this._control) {
	            var /** @type {?} */ ids = [];
	            if (this._getDisplayedMessages() === 'hint') {
	                var /** @type {?} */ startHint = this._hintChildren ?
	                    this._hintChildren.find(function (hint) { return hint.align === 'start'; }) : null;
	                var /** @type {?} */ endHint = this._hintChildren ?
	                    this._hintChildren.find(function (hint) { return hint.align === 'end'; }) : null;
	                if (startHint) {
	                    ids.push(startHint.id);
	                }
	                else if (this._hintLabel) {
	                    ids.push(this._hintLabelId);
	                }
	                if (endHint) {
	                    ids.push(endHint.id);
	                }
	            }
	            else if (this._errorChildren) {
	                ids = this._errorChildren.map(function (error) { return error.id; });
	            }
	            this._control.setDescribedByIds(ids);
	        }
	    };
	    /** Throws an error if the form field's control is missing. */
	    /**
	     * Throws an error if the form field's control is missing.
	     * @return {?}
	     */
	    MatFormField.prototype._validateControlChild = /**
	     * Throws an error if the form field's control is missing.
	     * @return {?}
	     */
	    function () {
	        if (!this._control) {
	            throw getMatFormFieldMissingControlError();
	        }
	    };
	    MatFormField.decorators = [
	        { type: _angular_core.Component, args: [{// TODO(mmalerba): the input-container selectors and classes are deprecated and will be removed.
	                    selector: 'mat-input-container, mat-form-field',
	                    exportAs: 'matFormField',
	                    template: "<div class=\"mat-input-wrapper mat-form-field-wrapper\"><div class=\"mat-input-flex mat-form-field-flex\" #connectionContainer (click)=\"_control.onContainerClick && _control.onContainerClick($event)\"><div class=\"mat-input-prefix mat-form-field-prefix\" *ngIf=\"_prefixChildren.length\"><ng-content select=\"[matPrefix]\"></ng-content></div><div class=\"mat-input-infix mat-form-field-infix\" #inputContainer><ng-content></ng-content><span class=\"mat-form-field-label-wrapper mat-input-placeholder-wrapper mat-form-field-placeholder-wrapper\"><label class=\"mat-form-field-label mat-input-placeholder mat-form-field-placeholder\" [attr.for]=\"_control.id\" [attr.aria-owns]=\"_control.id\" [class.mat-empty]=\"_control.empty && !_shouldAlwaysFloat\" [class.mat-form-field-empty]=\"_control.empty && !_shouldAlwaysFloat\" [class.mat-accent]=\"color == 'accent'\" [class.mat-warn]=\"color == 'warn'\" #label *ngIf=\"_hasFloatingLabel()\" [ngSwitch]=\"_hasLabel()\"><ng-container *ngSwitchCase=\"false\"><ng-content select=\"mat-placeholder\"></ng-content>{{_control.placeholder}}</ng-container><ng-content select=\"mat-label\" *ngSwitchCase=\"true\"></ng-content><span class=\"mat-placeholder-required mat-form-field-required-marker\" aria-hidden=\"true\" *ngIf=\"!hideRequiredMarker && _control.required && !_control.disabled\">&nbsp;*</span></label></span></div><div class=\"mat-input-suffix mat-form-field-suffix\" *ngIf=\"_suffixChildren.length\"><ng-content select=\"[matSuffix]\"></ng-content></div></div><div class=\"mat-input-underline mat-form-field-underline\" #underline><span class=\"mat-input-ripple mat-form-field-ripple\" [class.mat-accent]=\"color == 'accent'\" [class.mat-warn]=\"color == 'warn'\"></span></div><div class=\"mat-input-subscript-wrapper mat-form-field-subscript-wrapper\" [ngSwitch]=\"_getDisplayedMessages()\"><div *ngSwitchCase=\"'error'\" [@transitionMessages]=\"_subscriptAnimationState\"><ng-content select=\"mat-error\"></ng-content></div><div class=\"mat-input-hint-wrapper mat-form-field-hint-wrapper\" *ngSwitchCase=\"'hint'\" [@transitionMessages]=\"_subscriptAnimationState\"><div *ngIf=\"hintLabel\" [id]=\"_hintLabelId\" class=\"mat-hint\">{{hintLabel}}</div><ng-content select=\"mat-hint:not([align='end'])\"></ng-content><div class=\"mat-input-hint-spacer mat-form-field-hint-spacer\"></div><ng-content select=\"mat-hint[align='end']\"></ng-content></div></div></div>",
	                    // MatInput is a directive and can't have styles, so we need to include its styles here.
	                    // The MatInput styles are fairly minimal so it shouldn't be a big deal for people who
	                    // aren't using MatInput.
	                    styles: [".mat-form-field{display:inline-block;position:relative;text-align:left}[dir=rtl] .mat-form-field{text-align:right}.mat-form-field-wrapper{position:relative}.mat-form-field-flex{display:inline-flex;align-items:baseline;width:100%}.mat-form-field-prefix,.mat-form-field-suffix{white-space:nowrap;flex:none}.mat-form-field-prefix .mat-icon,.mat-form-field-suffix .mat-icon{width:1em}.mat-form-field-prefix .mat-icon-button,.mat-form-field-suffix .mat-icon-button{font:inherit;vertical-align:baseline}.mat-form-field-prefix .mat-icon-button .mat-icon,.mat-form-field-suffix .mat-icon-button .mat-icon{font-size:inherit}.mat-form-field-infix{display:block;position:relative;flex:auto;min-width:0;width:180px}.mat-form-field-label-wrapper{position:absolute;left:0;box-sizing:content-box;width:100%;height:100%;overflow:hidden;pointer-events:none}.mat-form-field-label{position:absolute;left:0;font:inherit;pointer-events:none;width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;transform:perspective(100px);-ms-transform:none;transform-origin:0 0;transition:transform .4s cubic-bezier(.25,.8,.25,1),color .4s cubic-bezier(.25,.8,.25,1),width .4s cubic-bezier(.25,.8,.25,1);display:none}[dir=rtl] .mat-form-field-label{transform-origin:100% 0;left:auto;right:0}.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-empty.mat-form-field-label{display:block}.mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{display:none}.mat-form-field-can-float .mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{display:block;transition:none}.mat-input-server:focus+.mat-form-field-placeholder-wrapper .mat-form-field-placeholder,.mat-input-server[placeholder]:not(:placeholder-shown)+.mat-form-field-placeholder-wrapper .mat-form-field-placeholder{display:none}.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-placeholder-wrapper .mat-form-field-placeholder,.mat-form-field-can-float .mat-input-server[placeholder]:not(:placeholder-shown)+.mat-form-field-placeholder-wrapper .mat-form-field-placeholder{display:block}.mat-form-field-label:not(.mat-form-field-empty){transition:none}.mat-form-field-underline{position:absolute;height:1px;width:100%}.mat-form-field-disabled .mat-form-field-underline{background-position:0;background-color:transparent}.mat-form-field-underline .mat-form-field-ripple{position:absolute;top:0;left:0;width:100%;height:2px;transform-origin:50%;transform:scaleX(.5);visibility:hidden;opacity:0;transition:background-color .3s cubic-bezier(.55,0,.55,.2)}.mat-form-field-invalid:not(.mat-focused) .mat-form-field-underline .mat-form-field-ripple{height:1px}.mat-focused .mat-form-field-underline .mat-form-field-ripple,.mat-form-field-invalid .mat-form-field-underline .mat-form-field-ripple{visibility:visible;opacity:1;transform:scaleX(1);transition:transform .3s cubic-bezier(.25,.8,.25,1),opacity .1s cubic-bezier(.25,.8,.25,1),background-color .3s cubic-bezier(.25,.8,.25,1)}.mat-form-field-subscript-wrapper{position:absolute;width:100%;overflow:hidden}.mat-form-field-label-wrapper .mat-icon,.mat-form-field-subscript-wrapper .mat-icon{width:1em;height:1em;font-size:inherit;vertical-align:baseline}.mat-form-field-hint-wrapper{display:flex}.mat-form-field-hint-spacer{flex:1 0 1em}.mat-error{display:block} .mat-input-element{font:inherit;background:0 0;color:currentColor;border:none;outline:0;padding:0;margin:0;width:100%;max-width:100%;vertical-align:bottom;text-align:inherit}.mat-input-element:-moz-ui-invalid{box-shadow:none}.mat-input-element::-ms-clear,.mat-input-element::-ms-reveal{display:none}.mat-input-element[type=date]::after,.mat-input-element[type=datetime-local]::after,.mat-input-element[type=datetime]::after,.mat-input-element[type=month]::after,.mat-input-element[type=time]::after,.mat-input-element[type=week]::after{content:' ';white-space:pre;width:1px}.mat-input-element::placeholder{transition:color .4s .133s cubic-bezier(.25,.8,.25,1)}.mat-input-element::-moz-placeholder{transition:color .4s .133s cubic-bezier(.25,.8,.25,1)}.mat-input-element::-webkit-input-placeholder{transition:color .4s .133s cubic-bezier(.25,.8,.25,1)}.mat-input-element:-ms-input-placeholder{transition:color .4s .133s cubic-bezier(.25,.8,.25,1)}.mat-form-field-hide-placeholder .mat-input-element::placeholder{color:transparent!important;transition:none}.mat-form-field-hide-placeholder .mat-input-element::-moz-placeholder{color:transparent!important;transition:none}.mat-form-field-hide-placeholder .mat-input-element::-webkit-input-placeholder{color:transparent!important;transition:none}.mat-form-field-hide-placeholder .mat-input-element:-ms-input-placeholder{color:transparent!important;transition:none}textarea.mat-input-element{resize:vertical;overflow:auto}textarea.mat-autosize{resize:none}"],
	                    animations: [matFormFieldAnimations.transitionMessages],
	                    host: {
	                        'class': 'mat-input-container mat-form-field',
	                        '[class.mat-input-invalid]': '_control.errorState',
	                        '[class.mat-form-field-invalid]': '_control.errorState',
	                        '[class.mat-form-field-can-float]': '_canLabelFloat',
	                        '[class.mat-form-field-should-float]': '_shouldLabelFloat()',
	                        '[class.mat-form-field-hide-placeholder]': '_hideControlPlaceholder()',
	                        '[class.mat-form-field-disabled]': '_control.disabled',
	                        '[class.mat-focused]': '_control.focused',
	                        '[class.ng-untouched]': '_shouldForward("untouched")',
	                        '[class.ng-touched]': '_shouldForward("touched")',
	                        '[class.ng-pristine]': '_shouldForward("pristine")',
	                        '[class.ng-dirty]': '_shouldForward("dirty")',
	                        '[class.ng-valid]': '_shouldForward("valid")',
	                        '[class.ng-invalid]': '_shouldForward("invalid")',
	                        '[class.ng-pending]': '_shouldForward("pending")',
	                    },
	                    inputs: ['color'],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatFormField.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [_angular_material_core.MAT_LABEL_GLOBAL_OPTIONS,] },] },
	    ]; };
	    MatFormField.propDecorators = {
	        "dividerColor": [{ type: _angular_core.Input },],
	        "hideRequiredMarker": [{ type: _angular_core.Input },],
	        "hintLabel": [{ type: _angular_core.Input },],
	        "floatPlaceholder": [{ type: _angular_core.Input },],
	        "floatLabel": [{ type: _angular_core.Input },],
	        "underlineRef": [{ type: _angular_core.ViewChild, args: ['underline',] },],
	        "_connectionContainerRef": [{ type: _angular_core.ViewChild, args: ['connectionContainer',] },],
	        "_inputContainerRef": [{ type: _angular_core.ViewChild, args: ['inputContainer',] },],
	        "_label": [{ type: _angular_core.ViewChild, args: ['label',] },],
	        "_control": [{ type: _angular_core.ContentChild, args: [MatFormFieldControl,] },],
	        "_placeholderChild": [{ type: _angular_core.ContentChild, args: [MatPlaceholder,] },],
	        "_labelChild": [{ type: _angular_core.ContentChild, args: [MatLabel,] },],
	        "_errorChildren": [{ type: _angular_core.ContentChildren, args: [MatError,] },],
	        "_hintChildren": [{ type: _angular_core.ContentChildren, args: [MatHint,] },],
	        "_prefixChildren": [{ type: _angular_core.ContentChildren, args: [MatPrefix,] },],
	        "_suffixChildren": [{ type: _angular_core.ContentChildren, args: [MatSuffix,] },],
	    };
	    return MatFormField;
	}(_MatFormFieldMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatFormFieldModule = /** @class */ (function () {
	    function MatFormFieldModule() {
	    }
	    MatFormFieldModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    declarations: [
	                        MatError,
	                        MatHint,
	                        MatFormField,
	                        MatPlaceholder,
	                        MatPrefix,
	                        MatSuffix,
	                        MatLabel,
	                    ],
	                    imports: [
	                        _angular_common.CommonModule,
	                        _angular_cdk_platform.PlatformModule,
	                    ],
	                    exports: [
	                        MatError,
	                        MatHint,
	                        MatFormField,
	                        MatPlaceholder,
	                        MatPrefix,
	                        MatSuffix,
	                        MatLabel,
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    MatFormFieldModule.ctorParameters = function () { return []; };
	    return MatFormFieldModule;
	}());
	
	exports.MatFormFieldModule = MatFormFieldModule;
	exports.MatError = MatError;
	exports.MatFormFieldBase = MatFormFieldBase;
	exports._MatFormFieldMixinBase = _MatFormFieldMixinBase;
	exports.MatFormField = MatFormField;
	exports.MatFormFieldControl = MatFormFieldControl;
	exports.getMatFormFieldPlaceholderConflictError = getMatFormFieldPlaceholderConflictError;
	exports.getMatFormFieldDuplicatedHintError = getMatFormFieldDuplicatedHintError;
	exports.getMatFormFieldMissingControlError = getMatFormFieldMissingControlError;
	exports.MatHint = MatHint;
	exports.MatPlaceholder = MatPlaceholder;
	exports.MatPrefix = MatPrefix;
	exports.MatSuffix = MatSuffix;
	exports.MatLabel = MatLabel;
	exports.matFormFieldAnimations = matFormFieldAnimations;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=material-form-field.umd.js.map


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(1075), __webpack_require__(263), __webpack_require__(284), __webpack_require__(449), __webpack_require__(465), __webpack_require__(254), __webpack_require__(237), __webpack_require__(852), __webpack_require__(247), __webpack_require__(323), __webpack_require__(253), __webpack_require__(368), __webpack_require__(246)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@angular/material/core', 'rxjs/operators/take', 'rxjs/operators/catchError', 'rxjs/operators/tap', 'rxjs/operators/finalize', 'rxjs/operators/map', 'rxjs/operators/share', '@angular/common/http', '@angular/platform-browser', 'rxjs/observable/forkJoin', 'rxjs/observable/of', 'rxjs/observable/throw', '@angular/common'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.material = global.ng.material || {}, global.ng.material.icon = global.ng.material.icon || {}),global.ng.core,global.ng.material.core,global.Rx.operators,global.Rx.operators,global.Rx.operators,global.Rx.operators,global.Rx.operators,global.Rx.operators,global.ng.common.http,global.ng.platformBrowser,global.Rx.Observable,global.Rx.Observable,global.Rx.Observable,global.ng.common));
	}(this, (function (exports,_angular_core,_angular_material_core,rxjs_operators_take,rxjs_operators_catchError,rxjs_operators_tap,rxjs_operators_finalize,rxjs_operators_map,rxjs_operators_share,_angular_common_http,_angular_platformBrowser,rxjs_observable_forkJoin,rxjs_observable_of,rxjs_observable_throw,_angular_common) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Returns an exception to be thrown in the case when attempting to
	 * load an icon with a name that cannot be found.
	 * \@docs-private
	 * @param {?} iconName
	 * @return {?}
	 */
	function getMatIconNameNotFoundError(iconName) {
	    return Error("Unable to find icon with the name \"" + iconName + "\"");
	}
	/**
	 * Returns an exception to be thrown when the consumer attempts to use
	 * `<mat-icon>` without including \@angular/http.
	 * \@docs-private
	 * @return {?}
	 */
	function getMatIconNoHttpProviderError() {
	    return Error('Could not find HttpClient provider for use with Angular Material icons. ' +
	        'Please include the HttpClientModule from @angular/common/http in your ' +
	        'app imports.');
	}
	/**
	 * Returns an exception to be thrown when a URL couldn't be sanitized.
	 * \@docs-private
	 * @param {?} url URL that was attempted to be sanitized.
	 * @return {?}
	 */
	function getMatIconFailedToSanitizeError(url) {
	    return Error("The URL provided to MatIconRegistry was not trusted as a resource URL " +
	        ("via Angular's DomSanitizer. Attempted URL was \"" + url + "\"."));
	}
	/**
	 * Configuration for an icon, including the URL and possibly the cached SVG element.
	 * \@docs-private
	 */
	var SvgIconConfig = /** @class */ (function () {
	    function SvgIconConfig(url) {
	        this.url = url;
	        this.svgElement = null;
	    }
	    return SvgIconConfig;
	}());
	/**
	 * Service to register and display icons used by the `<mat-icon>` component.
	 * - Registers icon URLs by namespace and name.
	 * - Registers icon set URLs by namespace.
	 * - Registers aliases for CSS classes, for use with icon fonts.
	 * - Loads icons from URLs and extracts individual icons from icon sets.
	 */
	var MatIconRegistry = /** @class */ (function () {
	    function MatIconRegistry(_httpClient, _sanitizer, document) {
	        this._httpClient = _httpClient;
	        this._sanitizer = _sanitizer;
	        /**
	         * URLs and cached SVG elements for individual icons. Keys are of the format "[namespace]:[icon]".
	         */
	        this._svgIconConfigs = new Map();
	        /**
	         * SvgIconConfig objects and cached SVG elements for icon sets, keyed by namespace.
	         * Multiple icon sets can be registered under the same namespace.
	         */
	        this._iconSetConfigs = new Map();
	        /**
	         * Cache for icons loaded by direct URLs.
	         */
	        this._cachedIconsByUrl = new Map();
	        /**
	         * In-progress icon fetches. Used to coalesce multiple requests to the same URL.
	         */
	        this._inProgressUrlFetches = new Map();
	        /**
	         * Map from font identifiers to their CSS class names. Used for icon fonts.
	         */
	        this._fontCssClassesByAlias = new Map();
	        /**
	         * The CSS class to apply when an `<mat-icon>` component has no icon name, url, or font specified.
	         * The default 'material-icons' value assumes that the material icon font has been loaded as
	         * described at http://google.github.io/material-design-icons/#icon-font-for-the-web
	         */
	        this._defaultFontSetClass = 'material-icons';
	        // TODO(crisbeto): make _document required next major release.
	        this._document = document;
	    }
	    /**
	     * Registers an icon by URL in the default namespace.
	     * @param iconName Name under which the icon should be registered.
	     * @param url
	     */
	    /**
	     * Registers an icon by URL in the default namespace.
	     * @param {?} iconName Name under which the icon should be registered.
	     * @param {?} url
	     * @return {?}
	     */
	    MatIconRegistry.prototype.addSvgIcon = /**
	     * Registers an icon by URL in the default namespace.
	     * @param {?} iconName Name under which the icon should be registered.
	     * @param {?} url
	     * @return {?}
	     */
	    function (iconName, url) {
	        return this.addSvgIconInNamespace('', iconName, url);
	    };
	    /**
	     * Registers an icon by URL in the specified namespace.
	     * @param namespace Namespace in which the icon should be registered.
	     * @param iconName Name under which the icon should be registered.
	     * @param url
	     */
	    /**
	     * Registers an icon by URL in the specified namespace.
	     * @param {?} namespace Namespace in which the icon should be registered.
	     * @param {?} iconName Name under which the icon should be registered.
	     * @param {?} url
	     * @return {?}
	     */
	    MatIconRegistry.prototype.addSvgIconInNamespace = /**
	     * Registers an icon by URL in the specified namespace.
	     * @param {?} namespace Namespace in which the icon should be registered.
	     * @param {?} iconName Name under which the icon should be registered.
	     * @param {?} url
	     * @return {?}
	     */
	    function (namespace, iconName, url) {
	        var /** @type {?} */ key = iconKey(namespace, iconName);
	        this._svgIconConfigs.set(key, new SvgIconConfig(url));
	        return this;
	    };
	    /**
	     * Registers an icon set by URL in the default namespace.
	     * @param url
	     */
	    /**
	     * Registers an icon set by URL in the default namespace.
	     * @param {?} url
	     * @return {?}
	     */
	    MatIconRegistry.prototype.addSvgIconSet = /**
	     * Registers an icon set by URL in the default namespace.
	     * @param {?} url
	     * @return {?}
	     */
	    function (url) {
	        return this.addSvgIconSetInNamespace('', url);
	    };
	    /**
	     * Registers an icon set by URL in the specified namespace.
	     * @param namespace Namespace in which to register the icon set.
	     * @param url
	     */
	    /**
	     * Registers an icon set by URL in the specified namespace.
	     * @param {?} namespace Namespace in which to register the icon set.
	     * @param {?} url
	     * @return {?}
	     */
	    MatIconRegistry.prototype.addSvgIconSetInNamespace = /**
	     * Registers an icon set by URL in the specified namespace.
	     * @param {?} namespace Namespace in which to register the icon set.
	     * @param {?} url
	     * @return {?}
	     */
	    function (namespace, url) {
	        var /** @type {?} */ config = new SvgIconConfig(url);
	        var /** @type {?} */ configNamespace = this._iconSetConfigs.get(namespace);
	        if (configNamespace) {
	            configNamespace.push(config);
	        }
	        else {
	            this._iconSetConfigs.set(namespace, [config]);
	        }
	        return this;
	    };
	    /**
	     * Defines an alias for a CSS class name to be used for icon fonts. Creating an matIcon
	     * component with the alias as the fontSet input will cause the class name to be applied
	     * to the `<mat-icon>` element.
	     *
	     * @param alias Alias for the font.
	     * @param className Class name override to be used instead of the alias.
	     */
	    /**
	     * Defines an alias for a CSS class name to be used for icon fonts. Creating an matIcon
	     * component with the alias as the fontSet input will cause the class name to be applied
	     * to the `<mat-icon>` element.
	     *
	     * @param {?} alias Alias for the font.
	     * @param {?=} className Class name override to be used instead of the alias.
	     * @return {?}
	     */
	    MatIconRegistry.prototype.registerFontClassAlias = /**
	     * Defines an alias for a CSS class name to be used for icon fonts. Creating an matIcon
	     * component with the alias as the fontSet input will cause the class name to be applied
	     * to the `<mat-icon>` element.
	     *
	     * @param {?} alias Alias for the font.
	     * @param {?=} className Class name override to be used instead of the alias.
	     * @return {?}
	     */
	    function (alias, className) {
	        if (className === void 0) { className = alias; }
	        this._fontCssClassesByAlias.set(alias, className);
	        return this;
	    };
	    /**
	     * Returns the CSS class name associated with the alias by a previous call to
	     * registerFontClassAlias. If no CSS class has been associated, returns the alias unmodified.
	     */
	    /**
	     * Returns the CSS class name associated with the alias by a previous call to
	     * registerFontClassAlias. If no CSS class has been associated, returns the alias unmodified.
	     * @param {?} alias
	     * @return {?}
	     */
	    MatIconRegistry.prototype.classNameForFontAlias = /**
	     * Returns the CSS class name associated with the alias by a previous call to
	     * registerFontClassAlias. If no CSS class has been associated, returns the alias unmodified.
	     * @param {?} alias
	     * @return {?}
	     */
	    function (alias) {
	        return this._fontCssClassesByAlias.get(alias) || alias;
	    };
	    /**
	     * Sets the CSS class name to be used for icon fonts when an `<mat-icon>` component does not
	     * have a fontSet input value, and is not loading an icon by name or URL.
	     *
	     * @param className
	     */
	    /**
	     * Sets the CSS class name to be used for icon fonts when an `<mat-icon>` component does not
	     * have a fontSet input value, and is not loading an icon by name or URL.
	     *
	     * @param {?} className
	     * @return {?}
	     */
	    MatIconRegistry.prototype.setDefaultFontSetClass = /**
	     * Sets the CSS class name to be used for icon fonts when an `<mat-icon>` component does not
	     * have a fontSet input value, and is not loading an icon by name or URL.
	     *
	     * @param {?} className
	     * @return {?}
	     */
	    function (className) {
	        this._defaultFontSetClass = className;
	        return this;
	    };
	    /**
	     * Returns the CSS class name to be used for icon fonts when an `<mat-icon>` component does not
	     * have a fontSet input value, and is not loading an icon by name or URL.
	     */
	    /**
	     * Returns the CSS class name to be used for icon fonts when an `<mat-icon>` component does not
	     * have a fontSet input value, and is not loading an icon by name or URL.
	     * @return {?}
	     */
	    MatIconRegistry.prototype.getDefaultFontSetClass = /**
	     * Returns the CSS class name to be used for icon fonts when an `<mat-icon>` component does not
	     * have a fontSet input value, and is not loading an icon by name or URL.
	     * @return {?}
	     */
	    function () {
	        return this._defaultFontSetClass;
	    };
	    /**
	     * Returns an Observable that produces the icon (as an `<svg>` DOM element) from the given URL.
	     * The response from the URL may be cached so this will not always cause an HTTP request, but
	     * the produced element will always be a new copy of the originally fetched icon. (That is,
	     * it will not contain any modifications made to elements previously returned).
	     *
	     * @param safeUrl URL from which to fetch the SVG icon.
	     */
	    /**
	     * Returns an Observable that produces the icon (as an `<svg>` DOM element) from the given URL.
	     * The response from the URL may be cached so this will not always cause an HTTP request, but
	     * the produced element will always be a new copy of the originally fetched icon. (That is,
	     * it will not contain any modifications made to elements previously returned).
	     *
	     * @param {?} safeUrl URL from which to fetch the SVG icon.
	     * @return {?}
	     */
	    MatIconRegistry.prototype.getSvgIconFromUrl = /**
	     * Returns an Observable that produces the icon (as an `<svg>` DOM element) from the given URL.
	     * The response from the URL may be cached so this will not always cause an HTTP request, but
	     * the produced element will always be a new copy of the originally fetched icon. (That is,
	     * it will not contain any modifications made to elements previously returned).
	     *
	     * @param {?} safeUrl URL from which to fetch the SVG icon.
	     * @return {?}
	     */
	    function (safeUrl) {
	        var _this = this;
	        var /** @type {?} */ url = this._sanitizer.sanitize(_angular_core.SecurityContext.RESOURCE_URL, safeUrl);
	        if (!url) {
	            throw getMatIconFailedToSanitizeError(safeUrl);
	        }
	        var /** @type {?} */ cachedIcon = this._cachedIconsByUrl.get(url);
	        if (cachedIcon) {
	            return rxjs_observable_of.of(cloneSvg(cachedIcon));
	        }
	        return this._loadSvgIconFromConfig(new SvgIconConfig(safeUrl)).pipe(rxjs_operators_tap.tap(function (svg) { return _this._cachedIconsByUrl.set(/** @type {?} */ ((url)), svg); }), rxjs_operators_map.map(function (svg) { return cloneSvg(svg); }));
	    };
	    /**
	     * Returns an Observable that produces the icon (as an `<svg>` DOM element) with the given name
	     * and namespace. The icon must have been previously registered with addIcon or addIconSet;
	     * if not, the Observable will throw an error.
	     *
	     * @param name Name of the icon to be retrieved.
	     * @param namespace Namespace in which to look for the icon.
	     */
	    /**
	     * Returns an Observable that produces the icon (as an `<svg>` DOM element) with the given name
	     * and namespace. The icon must have been previously registered with addIcon or addIconSet;
	     * if not, the Observable will throw an error.
	     *
	     * @param {?} name Name of the icon to be retrieved.
	     * @param {?=} namespace Namespace in which to look for the icon.
	     * @return {?}
	     */
	    MatIconRegistry.prototype.getNamedSvgIcon = /**
	     * Returns an Observable that produces the icon (as an `<svg>` DOM element) with the given name
	     * and namespace. The icon must have been previously registered with addIcon or addIconSet;
	     * if not, the Observable will throw an error.
	     *
	     * @param {?} name Name of the icon to be retrieved.
	     * @param {?=} namespace Namespace in which to look for the icon.
	     * @return {?}
	     */
	    function (name, namespace) {
	        if (namespace === void 0) { namespace = ''; }
	        // Return (copy of) cached icon if possible.
	        var /** @type {?} */ key = iconKey(namespace, name);
	        var /** @type {?} */ config = this._svgIconConfigs.get(key);
	        if (config) {
	            return this._getSvgFromConfig(config);
	        }
	        // See if we have any icon sets registered for the namespace.
	        var /** @type {?} */ iconSetConfigs = this._iconSetConfigs.get(namespace);
	        if (iconSetConfigs) {
	            return this._getSvgFromIconSetConfigs(name, iconSetConfigs);
	        }
	        return rxjs_observable_throw._throw(getMatIconNameNotFoundError(key));
	    };
	    /**
	     * Returns the cached icon for a SvgIconConfig if available, or fetches it from its URL if not.
	     * @param {?} config
	     * @return {?}
	     */
	    MatIconRegistry.prototype._getSvgFromConfig = /**
	     * Returns the cached icon for a SvgIconConfig if available, or fetches it from its URL if not.
	     * @param {?} config
	     * @return {?}
	     */
	    function (config) {
	        if (config.svgElement) {
	            // We already have the SVG element for this icon, return a copy.
	            return rxjs_observable_of.of(cloneSvg(config.svgElement));
	        }
	        else {
	            // Fetch the icon from the config's URL, cache it, and return a copy.
	            return this._loadSvgIconFromConfig(config).pipe(rxjs_operators_tap.tap(function (svg) { return config.svgElement = svg; }), rxjs_operators_map.map(function (svg) { return cloneSvg(svg); }));
	        }
	    };
	    /**
	     * Attempts to find an icon with the specified name in any of the SVG icon sets.
	     * First searches the available cached icons for a nested element with a matching name, and
	     * if found copies the element to a new `<svg>` element. If not found, fetches all icon sets
	     * that have not been cached, and searches again after all fetches are completed.
	     * The returned Observable produces the SVG element if possible, and throws
	     * an error if no icon with the specified name can be found.
	     * @param {?} name
	     * @param {?} iconSetConfigs
	     * @return {?}
	     */
	    MatIconRegistry.prototype._getSvgFromIconSetConfigs = /**
	     * Attempts to find an icon with the specified name in any of the SVG icon sets.
	     * First searches the available cached icons for a nested element with a matching name, and
	     * if found copies the element to a new `<svg>` element. If not found, fetches all icon sets
	     * that have not been cached, and searches again after all fetches are completed.
	     * The returned Observable produces the SVG element if possible, and throws
	     * an error if no icon with the specified name can be found.
	     * @param {?} name
	     * @param {?} iconSetConfigs
	     * @return {?}
	     */
	    function (name, iconSetConfigs) {
	        var _this = this;
	        // For all the icon set SVG elements we've fetched, see if any contain an icon with the
	        // requested name.
	        var /** @type {?} */ namedIcon = this._extractIconWithNameFromAnySet(name, iconSetConfigs);
	        if (namedIcon) {
	            // We could cache namedIcon in _svgIconConfigs, but since we have to make a copy every
	            // time anyway, there's probably not much advantage compared to just always extracting
	            // it from the icon set.
	            return rxjs_observable_of.of(namedIcon);
	        }
	        // Not found in any cached icon sets. If there are icon sets with URLs that we haven't
	        // fetched, fetch them now and look for iconName in the results.
	        var /** @type {?} */ iconSetFetchRequests = iconSetConfigs
	            .filter(function (iconSetConfig) { return !iconSetConfig.svgElement; })
	            .map(function (iconSetConfig) {
	            return _this._loadSvgIconSetFromConfig(iconSetConfig).pipe(rxjs_operators_catchError.catchError(function (err) {
	                var /** @type {?} */ url = _this._sanitizer.sanitize(_angular_core.SecurityContext.RESOURCE_URL, iconSetConfig.url);
	                // Swallow errors fetching individual URLs so the combined Observable won't
	                // necessarily fail.
	                console.log("Loading icon set URL: " + url + " failed: " + err);
	                return rxjs_observable_of.of(null);
	            }));
	        });
	        // Fetch all the icon set URLs. When the requests complete, every IconSet should have a
	        // cached SVG element (unless the request failed), and we can check again for the icon.
	        return rxjs_observable_forkJoin.forkJoin(iconSetFetchRequests).pipe(rxjs_operators_map.map(function () {
	            var /** @type {?} */ foundIcon = _this._extractIconWithNameFromAnySet(name, iconSetConfigs);
	            if (!foundIcon) {
	                throw getMatIconNameNotFoundError(name);
	            }
	            return foundIcon;
	        }));
	    };
	    /**
	     * Searches the cached SVG elements for the given icon sets for a nested icon element whose "id"
	     * tag matches the specified name. If found, copies the nested element to a new SVG element and
	     * returns it. Returns null if no matching element is found.
	     * @param {?} iconName
	     * @param {?} iconSetConfigs
	     * @return {?}
	     */
	    MatIconRegistry.prototype._extractIconWithNameFromAnySet = /**
	     * Searches the cached SVG elements for the given icon sets for a nested icon element whose "id"
	     * tag matches the specified name. If found, copies the nested element to a new SVG element and
	     * returns it. Returns null if no matching element is found.
	     * @param {?} iconName
	     * @param {?} iconSetConfigs
	     * @return {?}
	     */
	    function (iconName, iconSetConfigs) {
	        // Iterate backwards, so icon sets added later have precedence.
	        for (var /** @type {?} */ i = iconSetConfigs.length - 1; i >= 0; i--) {
	            var /** @type {?} */ config = iconSetConfigs[i];
	            if (config.svgElement) {
	                var /** @type {?} */ foundIcon = this._extractSvgIconFromSet(config.svgElement, iconName);
	                if (foundIcon) {
	                    return foundIcon;
	                }
	            }
	        }
	        return null;
	    };
	    /**
	     * Loads the content of the icon URL specified in the SvgIconConfig and creates an SVG element
	     * from it.
	     * @param {?} config
	     * @return {?}
	     */
	    MatIconRegistry.prototype._loadSvgIconFromConfig = /**
	     * Loads the content of the icon URL specified in the SvgIconConfig and creates an SVG element
	     * from it.
	     * @param {?} config
	     * @return {?}
	     */
	    function (config) {
	        var _this = this;
	        return this._fetchUrl(config.url)
	            .pipe(rxjs_operators_map.map(function (svgText) { return _this._createSvgElementForSingleIcon(svgText); }));
	    };
	    /**
	     * Loads the content of the icon set URL specified in the SvgIconConfig and creates an SVG element
	     * from it.
	     * @param {?} config
	     * @return {?}
	     */
	    MatIconRegistry.prototype._loadSvgIconSetFromConfig = /**
	     * Loads the content of the icon set URL specified in the SvgIconConfig and creates an SVG element
	     * from it.
	     * @param {?} config
	     * @return {?}
	     */
	    function (config) {
	        var _this = this;
	        // If the SVG for this icon set has already been parsed, do nothing.
	        if (config.svgElement) {
	            return rxjs_observable_of.of(config.svgElement);
	        }
	        return this._fetchUrl(config.url).pipe(rxjs_operators_map.map(function (svgText) {
	            // It is possible that the icon set was parsed and cached by an earlier request, so parsing
	            // only needs to occur if the cache is yet unset.
	            if (!config.svgElement) {
	                config.svgElement = _this._svgElementFromString(svgText);
	            }
	            return config.svgElement;
	        }));
	    };
	    /**
	     * Creates a DOM element from the given SVG string, and adds default attributes.
	     * @param {?} responseText
	     * @return {?}
	     */
	    MatIconRegistry.prototype._createSvgElementForSingleIcon = /**
	     * Creates a DOM element from the given SVG string, and adds default attributes.
	     * @param {?} responseText
	     * @return {?}
	     */
	    function (responseText) {
	        var /** @type {?} */ svg = this._svgElementFromString(responseText);
	        this._setSvgAttributes(svg);
	        return svg;
	    };
	    /**
	     * Searches the cached element of the given SvgIconConfig for a nested icon element whose "id"
	     * tag matches the specified name. If found, copies the nested element to a new SVG element and
	     * returns it. Returns null if no matching element is found.
	     * @param {?} iconSet
	     * @param {?} iconName
	     * @return {?}
	     */
	    MatIconRegistry.prototype._extractSvgIconFromSet = /**
	     * Searches the cached element of the given SvgIconConfig for a nested icon element whose "id"
	     * tag matches the specified name. If found, copies the nested element to a new SVG element and
	     * returns it. Returns null if no matching element is found.
	     * @param {?} iconSet
	     * @param {?} iconName
	     * @return {?}
	     */
	    function (iconSet, iconName) {
	        var /** @type {?} */ iconSource = iconSet.querySelector('#' + iconName);
	        if (!iconSource) {
	            return null;
	        }
	        // Clone the element and remove the ID to prevent multiple elements from being added
	        // to the page with the same ID.
	        var /** @type {?} */ iconElement = /** @type {?} */ (iconSource.cloneNode(true));
	        iconElement.id = '';
	        // If the icon node is itself an <svg> node, clone and return it directly. If not, set it as
	        // the content of a new <svg> node.
	        if (iconElement.nodeName.toLowerCase() === 'svg') {
	            return this._setSvgAttributes(/** @type {?} */ (iconElement));
	        }
	        // If the node is a <symbol>, it won't be rendered so we have to convert it into <svg>. Note
	        // that the same could be achieved by referring to it via <use href="#id">, however the <use>
	        // tag is problematic on Firefox, because it needs to include the current page path.
	        if (iconElement.nodeName.toLowerCase() === 'symbol') {
	            return this._setSvgAttributes(this._toSvgElement(iconElement));
	        }
	        // createElement('SVG') doesn't work as expected; the DOM ends up with
	        // the correct nodes, but the SVG content doesn't render. Instead we
	        // have to create an empty SVG node using innerHTML and append its content.
	        // Elements created using DOMParser.parseFromString have the same problem.
	        // http://stackoverflow.com/questions/23003278/svg-innerhtml-in-firefox-can-not-display
	        var /** @type {?} */ svg = this._svgElementFromString('<svg></svg>');
	        // Clone the node so we don't remove it from the parent icon set element.
	        svg.appendChild(iconElement);
	        return this._setSvgAttributes(svg);
	    };
	    /**
	     * Creates a DOM element from the given SVG string.
	     * @param {?} str
	     * @return {?}
	     */
	    MatIconRegistry.prototype._svgElementFromString = /**
	     * Creates a DOM element from the given SVG string.
	     * @param {?} str
	     * @return {?}
	     */
	    function (str) {
	        if (this._document || typeof document !== 'undefined') {
	            var /** @type {?} */ div = (this._document || document).createElement('DIV');
	            div.innerHTML = str;
	            var /** @type {?} */ svg = /** @type {?} */ (div.querySelector('svg'));
	            if (!svg) {
	                throw Error('<svg> tag not found');
	            }
	            return svg;
	        }
	        throw new Error('MatIconRegistry could not resolve document.');
	    };
	    /**
	     * Converts an element into an SVG node by cloning all of its children.
	     * @param {?} element
	     * @return {?}
	     */
	    MatIconRegistry.prototype._toSvgElement = /**
	     * Converts an element into an SVG node by cloning all of its children.
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) {
	        var /** @type {?} */ svg = this._svgElementFromString('<svg></svg>');
	        for (var /** @type {?} */ i = 0; i < element.childNodes.length; i++) {
	            if (element.childNodes[i].nodeType === this._document.ELEMENT_NODE) {
	                svg.appendChild(element.childNodes[i].cloneNode(true));
	            }
	        }
	        return svg;
	    };
	    /**
	     * Sets the default attributes for an SVG element to be used as an icon.
	     * @param {?} svg
	     * @return {?}
	     */
	    MatIconRegistry.prototype._setSvgAttributes = /**
	     * Sets the default attributes for an SVG element to be used as an icon.
	     * @param {?} svg
	     * @return {?}
	     */
	    function (svg) {
	        if (!svg.getAttribute('xmlns')) {
	            svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
	        }
	        svg.setAttribute('fit', '');
	        svg.setAttribute('height', '100%');
	        svg.setAttribute('width', '100%');
	        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
	        svg.setAttribute('focusable', 'false'); // Disable IE11 default behavior to make SVGs focusable.
	        return svg;
	    };
	    /**
	     * Returns an Observable which produces the string contents of the given URL. Results may be
	     * cached, so future calls with the same URL may not cause another HTTP request.
	     * @param {?} safeUrl
	     * @return {?}
	     */
	    MatIconRegistry.prototype._fetchUrl = /**
	     * Returns an Observable which produces the string contents of the given URL. Results may be
	     * cached, so future calls with the same URL may not cause another HTTP request.
	     * @param {?} safeUrl
	     * @return {?}
	     */
	    function (safeUrl) {
	        var _this = this;
	        if (!this._httpClient) {
	            throw getMatIconNoHttpProviderError();
	        }
	        var /** @type {?} */ url = this._sanitizer.sanitize(_angular_core.SecurityContext.RESOURCE_URL, safeUrl);
	        if (!url) {
	            throw getMatIconFailedToSanitizeError(safeUrl);
	        }
	        // Store in-progress fetches to avoid sending a duplicate request for a URL when there is
	        // already a request in progress for that URL. It's necessary to call share() on the
	        // Observable returned by http.get() so that multiple subscribers don't cause multiple XHRs.
	        var /** @type {?} */ inProgressFetch = this._inProgressUrlFetches.get(url);
	        if (inProgressFetch) {
	            return inProgressFetch;
	        }
	        // TODO(jelbourn): for some reason, the `finally` operator "loses" the generic type on the
	        // Observable. Figure out why and fix it.
	        var /** @type {?} */ req = this._httpClient.get(url, { responseType: 'text' }).pipe(rxjs_operators_finalize.finalize(function () { return _this._inProgressUrlFetches.delete(url); }), rxjs_operators_share.share());
	        this._inProgressUrlFetches.set(url, req);
	        return req;
	    };
	    MatIconRegistry.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    MatIconRegistry.ctorParameters = function () { return [
	        { type: _angular_common_http.HttpClient, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_platformBrowser.DomSanitizer, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    return MatIconRegistry;
	}());
	/**
	 * \@docs-private
	 * @param {?} parentRegistry
	 * @param {?} httpClient
	 * @param {?} sanitizer
	 * @param {?=} document
	 * @return {?}
	 */
	function ICON_REGISTRY_PROVIDER_FACTORY(parentRegistry, httpClient, sanitizer, document) {
	    return parentRegistry || new MatIconRegistry(httpClient, sanitizer, document);
	}
	/**
	 * \@docs-private
	 */
	var ICON_REGISTRY_PROVIDER = {
	    // If there is already an MatIconRegistry available, use that. Otherwise, provide a new one.
	    provide: MatIconRegistry,
	    deps: [
	        [new _angular_core.Optional(), new _angular_core.SkipSelf(), MatIconRegistry],
	        [new _angular_core.Optional(), _angular_common_http.HttpClient],
	        _angular_platformBrowser.DomSanitizer,
	        [new _angular_core.Optional(), /** @type {?} */ (_angular_common.DOCUMENT)],
	    ],
	    useFactory: ICON_REGISTRY_PROVIDER_FACTORY,
	};
	/**
	 * Clones an SVGElement while preserving type information.
	 * @param {?} svg
	 * @return {?}
	 */
	function cloneSvg(svg) {
	    return /** @type {?} */ (svg.cloneNode(true));
	}
	/**
	 * Returns the cache key to use for an icon namespace and name.
	 * @param {?} namespace
	 * @param {?} name
	 * @return {?}
	 */
	function iconKey(namespace, name) {
	    return namespace + ':' + name;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 */
	var MatIconBase = /** @class */ (function () {
	    function MatIconBase(_elementRef) {
	        this._elementRef = _elementRef;
	    }
	    return MatIconBase;
	}());
	var _MatIconMixinBase = _angular_material_core.mixinColor(MatIconBase);
	/**
	 * Component to display an icon. It can be used in the following ways:
	 *
	 * - Specify the svgIcon input to load an SVG icon from a URL previously registered with the
	 *   addSvgIcon, addSvgIconInNamespace, addSvgIconSet, or addSvgIconSetInNamespace methods of
	 *   MatIconRegistry. If the svgIcon value contains a colon it is assumed to be in the format
	 *   "[namespace]:[name]", if not the value will be the name of an icon in the default namespace.
	 *   Examples:
	 *     `<mat-icon svgIcon="left-arrow"></mat-icon>
	 *     <mat-icon svgIcon="animals:cat"></mat-icon>`
	 *
	 * - Use a font ligature as an icon by putting the ligature text in the content of the `<mat-icon>`
	 *   component. By default the Material icons font is used as described at
	 *   http://google.github.io/material-design-icons/#icon-font-for-the-web. You can specify an
	 *   alternate font by setting the fontSet input to either the CSS class to apply to use the
	 *   desired font, or to an alias previously registered with MatIconRegistry.registerFontClassAlias.
	 *   Examples:
	 *     `<mat-icon>home</mat-icon>
	 *     <mat-icon fontSet="myfont">sun</mat-icon>`
	 *
	 * - Specify a font glyph to be included via CSS rules by setting the fontSet input to specify the
	 *   font, and the fontIcon input to specify the icon. Typically the fontIcon will specify a
	 *   CSS class which causes the glyph to be displayed via a :before selector, as in
	 *   https://fortawesome.github.io/Font-Awesome/examples/
	 *   Example:
	 *     `<mat-icon fontSet="fa" fontIcon="alarm"></mat-icon>`
	 */
	var MatIcon = /** @class */ (function (_super) {
	    __extends(MatIcon, _super);
	    function MatIcon(elementRef, _iconRegistry, ariaHidden) {
	        var _this = _super.call(this, elementRef) || this;
	        _this._iconRegistry = _iconRegistry;
	        // If the user has not explicitly set aria-hidden, mark the icon as hidden, as this is
	        // the right thing to do for the majority of icon use-cases.
	        if (!ariaHidden) {
	            elementRef.nativeElement.setAttribute('aria-hidden', 'true');
	        }
	        return _this;
	    }
	    Object.defineProperty(MatIcon.prototype, "fontSet", {
	        get: /**
	         * Font set that the icon is a part of.
	         * @return {?}
	         */
	        function () { return this._fontSet; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._fontSet = this._cleanupFontValue(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatIcon.prototype, "fontIcon", {
	        get: /**
	         * Name of an icon within a font set.
	         * @return {?}
	         */
	        function () { return this._fontIcon; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._fontIcon = this._cleanupFontValue(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Splits an svgIcon binding value into its icon set and icon name components.
	     * Returns a 2-element array of [(icon set), (icon name)].
	     * The separator for the two fields is ':'. If there is no separator, an empty
	     * string is returned for the icon set and the entire value is returned for
	     * the icon name. If the argument is falsy, returns an array of two empty strings.
	     * Throws an error if the name contains two or more ':' separators.
	     * Examples:
	     *   `'social:cake' -> ['social', 'cake']
	     *   'penguin' -> ['', 'penguin']
	     *   null -> ['', '']
	     *   'a:b:c' -> (throws Error)`
	     * @param {?} iconName
	     * @return {?}
	     */
	    MatIcon.prototype._splitIconName = /**
	     * Splits an svgIcon binding value into its icon set and icon name components.
	     * Returns a 2-element array of [(icon set), (icon name)].
	     * The separator for the two fields is ':'. If there is no separator, an empty
	     * string is returned for the icon set and the entire value is returned for
	     * the icon name. If the argument is falsy, returns an array of two empty strings.
	     * Throws an error if the name contains two or more ':' separators.
	     * Examples:
	     *   `'social:cake' -> ['social', 'cake']
	     *   'penguin' -> ['', 'penguin']
	     *   null -> ['', '']
	     *   'a:b:c' -> (throws Error)`
	     * @param {?} iconName
	     * @return {?}
	     */
	    function (iconName) {
	        if (!iconName) {
	            return ['', ''];
	        }
	        var /** @type {?} */ parts = iconName.split(':');
	        switch (parts.length) {
	            case 1: return ['', parts[0]]; // Use default namespace.
	            case 2: return /** @type {?} */ (parts);
	            default: throw Error("Invalid icon name: \"" + iconName + "\"");
	        }
	    };
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    MatIcon.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        var _this = this;
	        // Only update the inline SVG icon if the inputs changed, to avoid unnecessary DOM operations.
	        if (changes["svgIcon"]) {
	            if (this.svgIcon) {
	                var _a = this._splitIconName(this.svgIcon), namespace = _a[0], iconName = _a[1];
	                this._iconRegistry.getNamedSvgIcon(iconName, namespace).pipe(rxjs_operators_take.take(1)).subscribe(function (svg) { return _this._setSvgElement(svg); }, function (err) { return console.log("Error retrieving icon: " + err.message); });
	            }
	            else {
	                this._clearSvgElement();
	            }
	        }
	        if (this._usingFontIcon()) {
	            this._updateFontIconClasses();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatIcon.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        // Update font classes because ngOnChanges won't be called if none of the inputs are present,
	        // e.g. <mat-icon>arrow</mat-icon> In this case we need to add a CSS class for the default font.
	        if (this._usingFontIcon()) {
	            this._updateFontIconClasses();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatIcon.prototype._usingFontIcon = /**
	     * @return {?}
	     */
	    function () {
	        return !this.svgIcon;
	    };
	    /**
	     * @param {?} svg
	     * @return {?}
	     */
	    MatIcon.prototype._setSvgElement = /**
	     * @param {?} svg
	     * @return {?}
	     */
	    function (svg) {
	        this._clearSvgElement();
	        this._elementRef.nativeElement.appendChild(svg);
	    };
	    /**
	     * @return {?}
	     */
	    MatIcon.prototype._clearSvgElement = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ layoutElement = this._elementRef.nativeElement;
	        var /** @type {?} */ childCount = layoutElement.childNodes.length;
	        // Remove existing child nodes and add the new SVG element. Note that we can't
	        // use innerHTML, because IE will throw if the element has a data binding.
	        for (var /** @type {?} */ i = 0; i < childCount; i++) {
	            layoutElement.removeChild(layoutElement.childNodes[i]);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatIcon.prototype._updateFontIconClasses = /**
	     * @return {?}
	     */
	    function () {
	        if (!this._usingFontIcon()) {
	            return;
	        }
	        var /** @type {?} */ elem = this._elementRef.nativeElement;
	        var /** @type {?} */ fontSetClass = this.fontSet ?
	            this._iconRegistry.classNameForFontAlias(this.fontSet) :
	            this._iconRegistry.getDefaultFontSetClass();
	        if (fontSetClass != this._previousFontSetClass) {
	            if (this._previousFontSetClass) {
	                elem.classList.remove(this._previousFontSetClass);
	            }
	            if (fontSetClass) {
	                elem.classList.add(fontSetClass);
	            }
	            this._previousFontSetClass = fontSetClass;
	        }
	        if (this.fontIcon != this._previousFontIconClass) {
	            if (this._previousFontIconClass) {
	                elem.classList.remove(this._previousFontIconClass);
	            }
	            if (this.fontIcon) {
	                elem.classList.add(this.fontIcon);
	            }
	            this._previousFontIconClass = this.fontIcon;
	        }
	    };
	    /**
	     * Cleans up a value to be used as a fontIcon or fontSet.
	     * Since the value ends up being assigned as a CSS class, we
	     * have to trim the value and omit space-separated values.
	     * @param {?} value
	     * @return {?}
	     */
	    MatIcon.prototype._cleanupFontValue = /**
	     * Cleans up a value to be used as a fontIcon or fontSet.
	     * Since the value ends up being assigned as a CSS class, we
	     * have to trim the value and omit space-separated values.
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        return typeof value === 'string' ? value.trim().split(' ')[0] : value;
	    };
	    MatIcon.decorators = [
	        { type: _angular_core.Component, args: [{template: '<ng-content></ng-content>',
	                    selector: 'mat-icon',
	                    exportAs: 'matIcon',
	                    styles: [".mat-icon{background-repeat:no-repeat;display:inline-block;fill:currentColor;height:24px;width:24px}"],
	                    inputs: ['color'],
	                    host: {
	                        'role': 'img',
	                        'class': 'mat-icon',
	                    },
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatIcon.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: MatIconRegistry, },
	        { type: undefined, decorators: [{ type: _angular_core.Attribute, args: ['aria-hidden',] },] },
	    ]; };
	    MatIcon.propDecorators = {
	        "svgIcon": [{ type: _angular_core.Input },],
	        "fontSet": [{ type: _angular_core.Input },],
	        "fontIcon": [{ type: _angular_core.Input },],
	    };
	    return MatIcon;
	}(_MatIconMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatIconModule = /** @class */ (function () {
	    function MatIconModule() {
	    }
	    MatIconModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [_angular_material_core.MatCommonModule],
	                    exports: [MatIcon, _angular_material_core.MatCommonModule],
	                    declarations: [MatIcon],
	                    providers: [ICON_REGISTRY_PROVIDER],
	                },] },
	    ];
	    /** @nocollapse */
	    MatIconModule.ctorParameters = function () { return []; };
	    return MatIconModule;
	}());
	
	exports.MatIconModule = MatIconModule;
	exports.MatIconBase = MatIconBase;
	exports._MatIconMixinBase = _MatIconMixinBase;
	exports.MatIcon = MatIcon;
	exports.getMatIconNameNotFoundError = getMatIconNameNotFoundError;
	exports.getMatIconNoHttpProviderError = getMatIconNoHttpProviderError;
	exports.getMatIconFailedToSanitizeError = getMatIconFailedToSanitizeError;
	exports.MatIconRegistry = MatIconRegistry;
	exports.ICON_REGISTRY_PROVIDER_FACTORY = ICON_REGISTRY_PROVIDER_FACTORY;
	exports.ICON_REGISTRY_PROVIDER = ICON_REGISTRY_PROVIDER;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=material-icon.umd.js.map


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(1075), __webpack_require__(1081), __webpack_require__(1077), __webpack_require__(246), __webpack_require__(1308), __webpack_require__(1076), __webpack_require__(1079), __webpack_require__(1310), __webpack_require__(298), __webpack_require__(263), __webpack_require__(256), __webpack_require__(449), __webpack_require__(433), __webpack_require__(768), __webpack_require__(1305), __webpack_require__(240), __webpack_require__(318), __webpack_require__(327), __webpack_require__(222), __webpack_require__(253)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@angular/material/core', '@angular/cdk/a11y', '@angular/cdk/coercion', '@angular/common', '@angular/cdk/overlay', '@angular/cdk/bidi', '@angular/cdk/keycodes', '@angular/cdk/portal', 'rxjs/operators/filter', 'rxjs/operators/take', 'rxjs/operators/switchMap', 'rxjs/operators/tap', 'rxjs/operators/delay', '@angular/forms', '@angular/material/form-field', 'rxjs/Subject', 'rxjs/observable/defer', 'rxjs/observable/fromEvent', 'rxjs/observable/merge', 'rxjs/observable/of'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.material = global.ng.material || {}, global.ng.material.autocomplete = global.ng.material.autocomplete || {}),global.ng.core,global.ng.material.core,global.ng.cdk.a11y,global.ng.cdk.coercion,global.ng.common,global.ng.cdk.overlay,global.ng.cdk.bidi,global.ng.cdk.keycodes,global.ng.cdk.portal,global.Rx.operators,global.Rx.operators,global.Rx.operators,global.Rx.operators,global.Rx.operators,global.ng.forms,global.ng.material.formField,global.Rx,global.Rx.Observable,global.Rx.Observable,global.Rx.Observable,global.Rx.Observable));
	}(this, (function (exports,_angular_core,_angular_material_core,_angular_cdk_a11y,_angular_cdk_coercion,_angular_common,_angular_cdk_overlay,_angular_cdk_bidi,_angular_cdk_keycodes,_angular_cdk_portal,rxjs_operators_filter,rxjs_operators_take,rxjs_operators_switchMap,rxjs_operators_tap,rxjs_operators_delay,_angular_forms,_angular_material_formField,rxjs_Subject,rxjs_observable_defer,rxjs_observable_fromEvent,rxjs_observable_merge,rxjs_observable_of) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * Autocomplete IDs need to be unique across components, so this counter exists outside of
	 * the component definition.
	 */
	var _uniqueAutocompleteIdCounter = 0;
	/**
	 * Event object that is emitted when an autocomplete option is selected.
	 */
	var MatAutocompleteSelectedEvent = /** @class */ (function () {
	    function MatAutocompleteSelectedEvent(source, option) {
	        this.source = source;
	        this.option = option;
	    }
	    return MatAutocompleteSelectedEvent;
	}());
	/**
	 * \@docs-private
	 */
	var MatAutocompleteBase = /** @class */ (function () {
	    function MatAutocompleteBase() {
	    }
	    return MatAutocompleteBase;
	}());
	var _MatAutocompleteMixinBase = _angular_material_core.mixinDisableRipple(MatAutocompleteBase);
	/**
	 * Default `mat-autocomplete` options that can be overridden.
	 * @record
	 */
	
	/**
	 * Injection token to be used to override the default options for `mat-autocomplete`.
	 */
	var MAT_AUTOCOMPLETE_DEFAULT_OPTIONS = new _angular_core.InjectionToken('mat-autocomplete-default-options');
	var MatAutocomplete = /** @class */ (function (_super) {
	    __extends(MatAutocomplete, _super);
	    function MatAutocomplete(_changeDetectorRef, _elementRef, 
	        // @deletion-target Turn into required param in 6.0.0
	        defaults) {
	        var _this = _super.call(this) || this;
	        _this._changeDetectorRef = _changeDetectorRef;
	        _this._elementRef = _elementRef;
	        /**
	         * Whether the autocomplete panel should be visible, depending on option length.
	         */
	        _this.showPanel = false;
	        _this._isOpen = false;
	        /**
	         * Function that maps an option's control value to its display value in the trigger.
	         */
	        _this.displayWith = null;
	        /**
	         * Event that is emitted whenever an option from the list is selected.
	         */
	        _this.optionSelected = new _angular_core.EventEmitter();
	        _this._classList = {};
	        /**
	         * Unique ID to be used by autocomplete trigger's "aria-owns" property.
	         */
	        _this.id = "mat-autocomplete-" + _uniqueAutocompleteIdCounter++;
	        _this._autoActiveFirstOption = defaults &&
	            typeof defaults.autoActiveFirstOption !== 'undefined' ?
	            defaults.autoActiveFirstOption :
	            false;
	        return _this;
	    }
	    Object.defineProperty(MatAutocomplete.prototype, "isOpen", {
	        /** Whether the autocomplete panel is open. */
	        get: /**
	         * Whether the autocomplete panel is open.
	         * @return {?}
	         */
	        function () { return this._isOpen && this.showPanel; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatAutocomplete.prototype, "autoActiveFirstOption", {
	        get: /**
	         * Whether the first option should be highlighted when the autocomplete panel is opened.
	         * Can be configured globally through the `MAT_AUTOCOMPLETE_DEFAULT_OPTIONS` token.
	         * @return {?}
	         */
	        function () { return this._autoActiveFirstOption; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._autoActiveFirstOption = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatAutocomplete.prototype, "classList", {
	        set: /**
	         * Takes classes set on the host mat-autocomplete element and applies them to the panel
	         * inside the overlay container to allow for easy styling.
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            var _this = this;
	            if (value && value.length) {
	                value.split(' ').forEach(function (className) { return _this._classList[className.trim()] = true; });
	                this._elementRef.nativeElement.className = '';
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatAutocomplete.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        this._keyManager = new _angular_cdk_a11y.ActiveDescendantKeyManager(this.options).withWrap();
	        // Set the initial visibiity state.
	        this._setVisibility();
	    };
	    /**
	     * Sets the panel scrollTop. This allows us to manually scroll to display options
	     * above or below the fold, as they are not actually being focused when active.
	     */
	    /**
	     * Sets the panel scrollTop. This allows us to manually scroll to display options
	     * above or below the fold, as they are not actually being focused when active.
	     * @param {?} scrollTop
	     * @return {?}
	     */
	    MatAutocomplete.prototype._setScrollTop = /**
	     * Sets the panel scrollTop. This allows us to manually scroll to display options
	     * above or below the fold, as they are not actually being focused when active.
	     * @param {?} scrollTop
	     * @return {?}
	     */
	    function (scrollTop) {
	        if (this.panel) {
	            this.panel.nativeElement.scrollTop = scrollTop;
	        }
	    };
	    /** Returns the panel's scrollTop. */
	    /**
	     * Returns the panel's scrollTop.
	     * @return {?}
	     */
	    MatAutocomplete.prototype._getScrollTop = /**
	     * Returns the panel's scrollTop.
	     * @return {?}
	     */
	    function () {
	        return this.panel ? this.panel.nativeElement.scrollTop : 0;
	    };
	    /** Panel should hide itself when the option list is empty. */
	    /**
	     * Panel should hide itself when the option list is empty.
	     * @return {?}
	     */
	    MatAutocomplete.prototype._setVisibility = /**
	     * Panel should hide itself when the option list is empty.
	     * @return {?}
	     */
	    function () {
	        this.showPanel = !!this.options.length;
	        this._classList['mat-autocomplete-visible'] = this.showPanel;
	        this._classList['mat-autocomplete-hidden'] = !this.showPanel;
	        this._changeDetectorRef.markForCheck();
	    };
	    /** Emits the `select` event. */
	    /**
	     * Emits the `select` event.
	     * @param {?} option
	     * @return {?}
	     */
	    MatAutocomplete.prototype._emitSelectEvent = /**
	     * Emits the `select` event.
	     * @param {?} option
	     * @return {?}
	     */
	    function (option) {
	        var /** @type {?} */ event = new MatAutocompleteSelectedEvent(this, option);
	        this.optionSelected.emit(event);
	    };
	    MatAutocomplete.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-autocomplete',
	                    template: "<ng-template><div class=\"mat-autocomplete-panel\" role=\"listbox\" [id]=\"id\" [ngClass]=\"_classList\" #panel><ng-content></ng-content></div></ng-template>",
	                    styles: [".mat-autocomplete-panel{min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;visibility:hidden;max-width:none;max-height:256px;position:relative}.mat-autocomplete-panel:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.mat-autocomplete-panel.mat-autocomplete-visible{visibility:visible}.mat-autocomplete-panel.mat-autocomplete-hidden{visibility:hidden}"],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    exportAs: 'matAutocomplete',
	                    inputs: ['disableRipple'],
	                    host: {
	                        'class': 'mat-autocomplete'
	                    },
	                    providers: [
	                        { provide: _angular_material_core.MAT_OPTION_PARENT_COMPONENT, useExisting: MatAutocomplete }
	                    ]
	                },] },
	    ];
	    /** @nocollapse */
	    MatAutocomplete.ctorParameters = function () { return [
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: _angular_core.ElementRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,] },] },
	    ]; };
	    MatAutocomplete.propDecorators = {
	        "template": [{ type: _angular_core.ViewChild, args: [_angular_core.TemplateRef,] },],
	        "panel": [{ type: _angular_core.ViewChild, args: ['panel',] },],
	        "options": [{ type: _angular_core.ContentChildren, args: [_angular_material_core.MatOption, { descendants: true },] },],
	        "optionGroups": [{ type: _angular_core.ContentChildren, args: [_angular_material_core.MatOptgroup,] },],
	        "displayWith": [{ type: _angular_core.Input },],
	        "autoActiveFirstOption": [{ type: _angular_core.Input },],
	        "optionSelected": [{ type: _angular_core.Output },],
	        "classList": [{ type: _angular_core.Input, args: ['class',] },],
	    };
	    return MatAutocomplete;
	}(_MatAutocompleteMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * The height of each autocomplete option.
	 */
	var AUTOCOMPLETE_OPTION_HEIGHT = 48;
	/**
	 * The total height of the autocomplete panel.
	 */
	var AUTOCOMPLETE_PANEL_HEIGHT = 256;
	/**
	 * Injection token that determines the scroll handling while the autocomplete panel is open.
	 */
	var MAT_AUTOCOMPLETE_SCROLL_STRATEGY = new _angular_core.InjectionToken('mat-autocomplete-scroll-strategy');
	/**
	 * \@docs-private
	 * @param {?} overlay
	 * @return {?}
	 */
	function MAT_AUTOCOMPLETE_SCROLL_STRATEGY_PROVIDER_FACTORY(overlay) {
	    return function () { return overlay.scrollStrategies.reposition(); };
	}
	/**
	 * \@docs-private
	 */
	var MAT_AUTOCOMPLETE_SCROLL_STRATEGY_PROVIDER = {
	    provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
	    deps: [_angular_cdk_overlay.Overlay],
	    useFactory: MAT_AUTOCOMPLETE_SCROLL_STRATEGY_PROVIDER_FACTORY,
	};
	/**
	 * Provider that allows the autocomplete to register as a ControlValueAccessor.
	 * \@docs-private
	 */
	var MAT_AUTOCOMPLETE_VALUE_ACCESSOR = {
	    provide: _angular_forms.NG_VALUE_ACCESSOR,
	    useExisting: _angular_core.forwardRef(function () { return MatAutocompleteTrigger; }),
	    multi: true
	};
	/**
	 * Creates an error to be thrown when attempting to use an autocomplete trigger without a panel.
	 * @return {?}
	 */
	function getMatAutocompleteMissingPanelError() {
	    return Error('Attempting to open an undefined instance of `mat-autocomplete`. ' +
	        'Make sure that the id passed to the `matAutocomplete` is correct and that ' +
	        'you\'re attempting to open it after the ngAfterContentInit hook.');
	}
	var MatAutocompleteTrigger = /** @class */ (function () {
	    function MatAutocompleteTrigger(_element, _overlay, _viewContainerRef, _zone, _changeDetectorRef, _scrollStrategy, _dir, _formField, _document) {
	        var _this = this;
	        this._element = _element;
	        this._overlay = _overlay;
	        this._viewContainerRef = _viewContainerRef;
	        this._zone = _zone;
	        this._changeDetectorRef = _changeDetectorRef;
	        this._scrollStrategy = _scrollStrategy;
	        this._dir = _dir;
	        this._formField = _formField;
	        this._document = _document;
	        this._componentDestroyed = false;
	        /**
	         * Whether or not the label state is being overridden.
	         */
	        this._manuallyFloatingLabel = false;
	        /**
	         * Stream of keyboard events that can close the panel.
	         */
	        this._closeKeyEventStream = new rxjs_Subject.Subject();
	        /**
	         * `View -> model callback called when value changes`
	         */
	        this._onChange = function () { };
	        /**
	         * `View -> model callback called when autocomplete has been touched`
	         */
	        this._onTouched = function () { };
	        this._panelOpen = false;
	        /**
	         * Stream of autocomplete option selections.
	         */
	        this.optionSelections = rxjs_observable_defer.defer(function () {
	            if (_this.autocomplete && _this.autocomplete.options) {
	                return rxjs_observable_merge.merge.apply(void 0, _this.autocomplete.options.map(function (option) { return option.onSelectionChange; }));
	            }
	            // If there are any subscribers before `ngAfterViewInit`, the `autocomplete` will be undefined.
	            // Return a stream that we'll replace with the real one once everything is in place.
	            return _this._zone.onStable
	                .asObservable()
	                .pipe(rxjs_operators_take.take(1), rxjs_operators_switchMap.switchMap(function () { return _this.optionSelections; }));
	        });
	    }
	    /**
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._componentDestroyed = true;
	        this._destroyPanel();
	        this._closeKeyEventStream.complete();
	    };
	    Object.defineProperty(MatAutocompleteTrigger.prototype, "panelOpen", {
	        /** Whether or not the autocomplete panel is open. */
	        get: /**
	         * Whether or not the autocomplete panel is open.
	         * @return {?}
	         */
	        function () { return this._panelOpen && this.autocomplete.showPanel; },
	        enumerable: true,
	        configurable: true
	    });
	    /** Opens the autocomplete suggestion panel. */
	    /**
	     * Opens the autocomplete suggestion panel.
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype.openPanel = /**
	     * Opens the autocomplete suggestion panel.
	     * @return {?}
	     */
	    function () {
	        this._attachOverlay();
	        this._floatLabel();
	    };
	    /** Closes the autocomplete suggestion panel. */
	    /**
	     * Closes the autocomplete suggestion panel.
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype.closePanel = /**
	     * Closes the autocomplete suggestion panel.
	     * @return {?}
	     */
	    function () {
	        this._resetLabel();
	        if (this._panelOpen) {
	            this.autocomplete._isOpen = this._panelOpen = false;
	            if (this._overlayRef && this._overlayRef.hasAttached()) {
	                this._overlayRef.detach();
	                this._closingActionsSubscription.unsubscribe();
	            }
	            // Note that in some cases this can end up being called after the component is destroyed.
	            // Add a check to ensure that we don't try to run change detection on a destroyed view.
	            if (!this._componentDestroyed) {
	                // We need to trigger change detection manually, because
	                // `fromEvent` doesn't seem to do it at the proper time.
	                // This ensures that the label is reset when the
	                // user clicks outside.
	                this._changeDetectorRef.detectChanges();
	            }
	        }
	    };
	    Object.defineProperty(MatAutocompleteTrigger.prototype, "panelClosingActions", {
	        /**
	         * A stream of actions that should close the autocomplete panel, including
	         * when an option is selected, on blur, and when TAB is pressed.
	         */
	        get: /**
	         * A stream of actions that should close the autocomplete panel, including
	         * when an option is selected, on blur, and when TAB is pressed.
	         * @return {?}
	         */
	        function () {
	            var _this = this;
	            return rxjs_observable_merge.merge(this.optionSelections, this.autocomplete._keyManager.tabOut.pipe(rxjs_operators_filter.filter(function () { return _this._panelOpen; })), this._closeKeyEventStream, this._outsideClickStream, this._overlayRef ?
	                this._overlayRef.detachments().pipe(rxjs_operators_filter.filter(function () { return _this._panelOpen; })) :
	                rxjs_observable_of.of());
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatAutocompleteTrigger.prototype, "activeOption", {
	        /** The currently active option, coerced to MatOption type. */
	        get: /**
	         * The currently active option, coerced to MatOption type.
	         * @return {?}
	         */
	        function () {
	            if (this.autocomplete && this.autocomplete._keyManager) {
	                return this.autocomplete._keyManager.activeItem;
	            }
	            return null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatAutocompleteTrigger.prototype, "_outsideClickStream", {
	        get: /**
	         * Stream of clicks outside of the autocomplete panel.
	         * @return {?}
	         */
	        function () {
	            var _this = this;
	            if (!this._document) {
	                return rxjs_observable_of.of(null);
	            }
	            return rxjs_observable_merge.merge(rxjs_observable_fromEvent.fromEvent(this._document, 'click'), rxjs_observable_fromEvent.fromEvent(this._document, 'touchend'))
	                .pipe(rxjs_operators_filter.filter(function (event) {
	                var /** @type {?} */ clickTarget = /** @type {?} */ (event.target);
	                var /** @type {?} */ formField = _this._formField ?
	                    _this._formField._elementRef.nativeElement : null;
	                return _this._panelOpen &&
	                    clickTarget !== _this._element.nativeElement &&
	                    (!formField || !formField.contains(clickTarget)) &&
	                    (!!_this._overlayRef && !_this._overlayRef.overlayElement.contains(clickTarget));
	            }));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype.writeValue = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        var _this = this;
	        Promise.resolve(null).then(function () { return _this._setTriggerValue(value); });
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype.registerOnChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._onChange = fn;
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype.registerOnTouched = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._onTouched = fn;
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype.setDisabledState = /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    function (isDisabled) {
	        this._element.nativeElement.disabled = isDisabled;
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._handleKeydown = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var /** @type {?} */ keyCode = event.keyCode;
	        // Prevent the default action on all escape key presses. This is here primarily to bring IE
	        // in line with other browsers. By default, pressing escape on IE will cause it to revert
	        // the input value to the one that it had on focus, however it won't dispatch any events
	        // which means that the model value will be out of sync with the view.
	        if (keyCode === _angular_cdk_keycodes.ESCAPE) {
	            event.preventDefault();
	        }
	        // Close when pressing ESCAPE or ALT + UP_ARROW, based on the a11y guidelines.
	        // See: https://www.w3.org/TR/wai-aria-practices-1.1/#textbox-keyboard-interaction
	        if (this.panelOpen && (keyCode === _angular_cdk_keycodes.ESCAPE || (keyCode === _angular_cdk_keycodes.UP_ARROW && event.altKey))) {
	            this._resetActiveItem();
	            this._closeKeyEventStream.next();
	            event.stopPropagation();
	        }
	        else if (this.activeOption && keyCode === _angular_cdk_keycodes.ENTER && this.panelOpen) {
	            this.activeOption._selectViaInteraction();
	            this._resetActiveItem();
	            event.preventDefault();
	        }
	        else {
	            var /** @type {?} */ prevActiveItem = this.autocomplete._keyManager.activeItem;
	            var /** @type {?} */ isArrowKey = keyCode === _angular_cdk_keycodes.UP_ARROW || keyCode === _angular_cdk_keycodes.DOWN_ARROW;
	            if (this.panelOpen || keyCode === _angular_cdk_keycodes.TAB) {
	                this.autocomplete._keyManager.onKeydown(event);
	            }
	            else if (isArrowKey && this._canOpen()) {
	                this.openPanel();
	            }
	            if (isArrowKey || this.autocomplete._keyManager.activeItem !== prevActiveItem) {
	                this._scrollToOption();
	            }
	        }
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._handleInput = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var /** @type {?} */ target = /** @type {?} */ (event.target);
	        var /** @type {?} */ value = target.value;
	        // Based on `NumberValueAccessor` from forms.
	        if (target.type === 'number') {
	            value = value == '' ? null : parseFloat(value);
	        }
	        // If the input has a placeholder, IE will fire the `input` event on page load,
	        // focus and blur, in addition to when the user actually changed the value. To
	        // filter out all of the extra events, we save the value on focus and between
	        // `input` events, and we check whether it changed.
	        // See: https://connect.microsoft.com/IE/feedback/details/885747/
	        if (this._canOpen() && this._previousValue !== value &&
	            document.activeElement === event.target) {
	            this._previousValue = value;
	            this._onChange(value);
	            this.openPanel();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._handleFocus = /**
	     * @return {?}
	     */
	    function () {
	        if (this._canOpen()) {
	            this._previousValue = this._element.nativeElement.value;
	            this._attachOverlay();
	            this._floatLabel(true);
	        }
	    };
	    /**
	     * In "auto" mode, the label will animate down as soon as focus is lost.
	     * This causes the value to jump when selecting an option with the mouse.
	     * This method manually floats the label until the panel can be closed.
	     * @param {?=} shouldAnimate Whether the label should be animated when it is floated.
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._floatLabel = /**
	     * In "auto" mode, the label will animate down as soon as focus is lost.
	     * This causes the value to jump when selecting an option with the mouse.
	     * This method manually floats the label until the panel can be closed.
	     * @param {?=} shouldAnimate Whether the label should be animated when it is floated.
	     * @return {?}
	     */
	    function (shouldAnimate) {
	        if (shouldAnimate === void 0) { shouldAnimate = false; }
	        if (this._formField && this._formField.floatLabel === 'auto') {
	            if (shouldAnimate) {
	                this._formField._animateAndLockLabel();
	            }
	            else {
	                this._formField.floatLabel = 'always';
	            }
	            this._manuallyFloatingLabel = true;
	        }
	    };
	    /**
	     * If the label has been manually elevated, return it to its normal state.
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._resetLabel = /**
	     * If the label has been manually elevated, return it to its normal state.
	     * @return {?}
	     */
	    function () {
	        if (this._manuallyFloatingLabel) {
	            this._formField.floatLabel = 'auto';
	            this._manuallyFloatingLabel = false;
	        }
	    };
	    /**
	     * Given that we are not actually focusing active options, we must manually adjust scroll
	     * to reveal options below the fold. First, we find the offset of the option from the top
	     * of the panel. If that offset is below the fold, the new scrollTop will be the offset -
	     * the panel height + the option height, so the active option will be just visible at the
	     * bottom of the panel. If that offset is above the top of the visible panel, the new scrollTop
	     * will become the offset. If that offset is visible within the panel already, the scrollTop is
	     * not adjusted.
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._scrollToOption = /**
	     * Given that we are not actually focusing active options, we must manually adjust scroll
	     * to reveal options below the fold. First, we find the offset of the option from the top
	     * of the panel. If that offset is below the fold, the new scrollTop will be the offset -
	     * the panel height + the option height, so the active option will be just visible at the
	     * bottom of the panel. If that offset is above the top of the visible panel, the new scrollTop
	     * will become the offset. If that offset is visible within the panel already, the scrollTop is
	     * not adjusted.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ index = this.autocomplete._keyManager.activeItemIndex || 0;
	        var /** @type {?} */ labelCount = _angular_material_core._countGroupLabelsBeforeOption(index, this.autocomplete.options, this.autocomplete.optionGroups);
	        var /** @type {?} */ newScrollPosition = _angular_material_core._getOptionScrollPosition(index + labelCount, AUTOCOMPLETE_OPTION_HEIGHT, this.autocomplete._getScrollTop(), AUTOCOMPLETE_PANEL_HEIGHT);
	        this.autocomplete._setScrollTop(newScrollPosition);
	    };
	    /**
	     * This method listens to a stream of panel closing actions and resets the
	     * stream every time the option list changes.
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._subscribeToClosingActions = /**
	     * This method listens to a stream of panel closing actions and resets the
	     * stream every time the option list changes.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ firstStable = this._zone.onStable.asObservable().pipe(rxjs_operators_take.take(1));
	        var /** @type {?} */ optionChanges = this.autocomplete.options.changes.pipe(rxjs_operators_tap.tap(function () { return _this._positionStrategy.recalculateLastPosition(); }), 
	        // Defer emitting to the stream until the next tick, because changing
	        // bindings in here will cause "changed after checked" errors.
	        rxjs_operators_delay.delay(0));
	        // When the zone is stable initially, and when the option list changes...
	        return rxjs_observable_merge.merge(firstStable, optionChanges)
	            .pipe(
	        // create a new stream of panelClosingActions, replacing any previous streams
	        // that were created, and flatten it so our stream only emits closing events...
	        rxjs_operators_switchMap.switchMap(function () {
	            _this._resetActiveItem();
	            _this.autocomplete._setVisibility();
	            return _this.panelClosingActions;
	        }), 
	        // when the first closing event occurs...
	        rxjs_operators_take.take(1))
	            .subscribe(function (event) { return _this._setValueAndClose(event); });
	    };
	    /**
	     * Destroys the autocomplete suggestion panel.
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._destroyPanel = /**
	     * Destroys the autocomplete suggestion panel.
	     * @return {?}
	     */
	    function () {
	        if (this._overlayRef) {
	            this.closePanel();
	            this._overlayRef.dispose();
	            this._overlayRef = null;
	        }
	    };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._setTriggerValue = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        var /** @type {?} */ toDisplay = this.autocomplete && this.autocomplete.displayWith ?
	            this.autocomplete.displayWith(value) :
	            value;
	        // Simply falling back to an empty string if the display value is falsy does not work properly.
	        // The display value can also be the number zero and shouldn't fall back to an empty string.
	        var /** @type {?} */ inputValue = toDisplay != null ? toDisplay : '';
	        // If it's used within a `MatFormField`, we should set it through the property so it can go
	        // through change detection.
	        if (this._formField) {
	            this._formField._control.value = inputValue;
	        }
	        else {
	            this._element.nativeElement.value = inputValue;
	        }
	    };
	    /**
	     * This method closes the panel, and if a value is specified, also sets the associated
	     * control to that value. It will also mark the control as dirty if this interaction
	     * stemmed from the user.
	     * @param {?} event
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._setValueAndClose = /**
	     * This method closes the panel, and if a value is specified, also sets the associated
	     * control to that value. It will also mark the control as dirty if this interaction
	     * stemmed from the user.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (event && event.source) {
	            this._clearPreviousSelectedOption(event.source);
	            this._setTriggerValue(event.source.value);
	            this._onChange(event.source.value);
	            this._element.nativeElement.focus();
	            this.autocomplete._emitSelectEvent(event.source);
	        }
	        this.closePanel();
	    };
	    /**
	     * Clear any previous selected option and emit a selection change event for this option
	     * @param {?} skip
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._clearPreviousSelectedOption = /**
	     * Clear any previous selected option and emit a selection change event for this option
	     * @param {?} skip
	     * @return {?}
	     */
	    function (skip) {
	        this.autocomplete.options.forEach(function (option) {
	            if (option != skip && option.selected) {
	                option.deselect();
	            }
	        });
	    };
	    /**
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._attachOverlay = /**
	     * @return {?}
	     */
	    function () {
	        if (!this.autocomplete) {
	            throw getMatAutocompleteMissingPanelError();
	        }
	        if (!this._overlayRef) {
	            this._portal = new _angular_cdk_portal.TemplatePortal(this.autocomplete.template, this._viewContainerRef);
	            this._overlayRef = this._overlay.create(this._getOverlayConfig());
	        }
	        else {
	            /** Update the panel width, in case the host width has changed */
	            this._overlayRef.updateSize({ width: this._getHostWidth() });
	        }
	        if (this._overlayRef && !this._overlayRef.hasAttached()) {
	            this._overlayRef.attach(this._portal);
	            this._closingActionsSubscription = this._subscribeToClosingActions();
	        }
	        this.autocomplete._setVisibility();
	        this.autocomplete._isOpen = this._panelOpen = true;
	    };
	    /**
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._getOverlayConfig = /**
	     * @return {?}
	     */
	    function () {
	        return new _angular_cdk_overlay.OverlayConfig({
	            positionStrategy: this._getOverlayPosition(),
	            scrollStrategy: this._scrollStrategy(),
	            width: this._getHostWidth(),
	            direction: this._dir ? this._dir.value : 'ltr'
	        });
	    };
	    /**
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._getOverlayPosition = /**
	     * @return {?}
	     */
	    function () {
	        this._positionStrategy = this._overlay.position().connectedTo(this._getConnectedElement(), { originX: 'start', originY: 'bottom' }, { overlayX: 'start', overlayY: 'top' })
	            .withFallbackPosition({ originX: 'start', originY: 'top' }, { overlayX: 'start', overlayY: 'bottom' });
	        return this._positionStrategy;
	    };
	    /**
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._getConnectedElement = /**
	     * @return {?}
	     */
	    function () {
	        return this._formField ? this._formField._connectionContainerRef : this._element;
	    };
	    /**
	     * Returns the width of the input element, so the panel width can match it.
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._getHostWidth = /**
	     * Returns the width of the input element, so the panel width can match it.
	     * @return {?}
	     */
	    function () {
	        return this._getConnectedElement().nativeElement.getBoundingClientRect().width;
	    };
	    /**
	     * Resets the active item to -1 so arrow events will activate the
	     * correct options, or to 0 if the consumer opted into it.
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._resetActiveItem = /**
	     * Resets the active item to -1 so arrow events will activate the
	     * correct options, or to 0 if the consumer opted into it.
	     * @return {?}
	     */
	    function () {
	        this.autocomplete._keyManager.setActiveItem(this.autocomplete.autoActiveFirstOption ? 0 : -1);
	    };
	    /**
	     * Determines whether the panel can be opened.
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._canOpen = /**
	     * Determines whether the panel can be opened.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ element = this._element.nativeElement;
	        return !element.readOnly && !element.disabled;
	    };
	    MatAutocompleteTrigger.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: "input[matAutocomplete], textarea[matAutocomplete]",
	                    host: {
	                        'role': 'combobox',
	                        'autocomplete': 'off',
	                        'aria-autocomplete': 'list',
	                        '[attr.aria-activedescendant]': 'activeOption?.id',
	                        '[attr.aria-expanded]': 'panelOpen.toString()',
	                        '[attr.aria-owns]': 'autocomplete?.id',
	                        // Note: we use `focusin`, as opposed to `focus`, in order to open the panel
	                        // a little earlier. This avoids issues where IE delays the focusing of the input.
	                        '(focusin)': '_handleFocus()',
	                        '(blur)': '_onTouched()',
	                        '(input)': '_handleInput($event)',
	                        '(keydown)': '_handleKeydown($event)',
	                    },
	                    exportAs: 'matAutocompleteTrigger',
	                    providers: [MAT_AUTOCOMPLETE_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    MatAutocompleteTrigger.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_overlay.Overlay, },
	        { type: _angular_core.ViewContainerRef, },
	        { type: _angular_core.NgZone, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [MAT_AUTOCOMPLETE_SCROLL_STRATEGY,] },] },
	        { type: _angular_cdk_bidi.Directionality, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_material_formField.MatFormField, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host },] },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    MatAutocompleteTrigger.propDecorators = {
	        "autocomplete": [{ type: _angular_core.Input, args: ['matAutocomplete',] },],
	    };
	    return MatAutocompleteTrigger;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatAutocompleteModule = /** @class */ (function () {
	    function MatAutocompleteModule() {
	    }
	    MatAutocompleteModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [_angular_material_core.MatOptionModule, _angular_cdk_overlay.OverlayModule, _angular_material_core.MatCommonModule, _angular_common.CommonModule],
	                    exports: [MatAutocomplete, _angular_material_core.MatOptionModule, MatAutocompleteTrigger, _angular_material_core.MatCommonModule],
	                    declarations: [MatAutocomplete, MatAutocompleteTrigger],
	                    providers: [MAT_AUTOCOMPLETE_SCROLL_STRATEGY_PROVIDER],
	                },] },
	    ];
	    /** @nocollapse */
	    MatAutocompleteModule.ctorParameters = function () { return []; };
	    return MatAutocompleteModule;
	}());
	
	exports.MatAutocompleteSelectedEvent = MatAutocompleteSelectedEvent;
	exports.MatAutocompleteBase = MatAutocompleteBase;
	exports._MatAutocompleteMixinBase = _MatAutocompleteMixinBase;
	exports.MAT_AUTOCOMPLETE_DEFAULT_OPTIONS = MAT_AUTOCOMPLETE_DEFAULT_OPTIONS;
	exports.MatAutocomplete = MatAutocomplete;
	exports.MatAutocompleteModule = MatAutocompleteModule;
	exports.AUTOCOMPLETE_OPTION_HEIGHT = AUTOCOMPLETE_OPTION_HEIGHT;
	exports.AUTOCOMPLETE_PANEL_HEIGHT = AUTOCOMPLETE_PANEL_HEIGHT;
	exports.MAT_AUTOCOMPLETE_SCROLL_STRATEGY = MAT_AUTOCOMPLETE_SCROLL_STRATEGY;
	exports.MAT_AUTOCOMPLETE_SCROLL_STRATEGY_PROVIDER_FACTORY = MAT_AUTOCOMPLETE_SCROLL_STRATEGY_PROVIDER_FACTORY;
	exports.MAT_AUTOCOMPLETE_SCROLL_STRATEGY_PROVIDER = MAT_AUTOCOMPLETE_SCROLL_STRATEGY_PROVIDER;
	exports.MAT_AUTOCOMPLETE_VALUE_ACCESSOR = MAT_AUTOCOMPLETE_VALUE_ACCESSOR;
	exports.getMatAutocompleteMissingPanelError = getMatAutocompleteMissingPanelError;
	exports.MatAutocompleteTrigger = MatAutocompleteTrigger;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=material-autocomplete.umd.js.map


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(1309), __webpack_require__(246), __webpack_require__(1076), __webpack_require__(1310), __webpack_require__(263), __webpack_require__(240), __webpack_require__(211), __webpack_require__(298), __webpack_require__(327), __webpack_require__(1077), __webpack_require__(1079)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@angular/cdk/scrolling', '@angular/common', '@angular/cdk/bidi', '@angular/cdk/portal', 'rxjs/operators/take', 'rxjs/Subject', 'rxjs/Subscription', 'rxjs/operators/filter', 'rxjs/observable/fromEvent', '@angular/cdk/coercion', '@angular/cdk/keycodes'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.cdk = global.ng.cdk || {}, global.ng.cdk.overlay = global.ng.cdk.overlay || {}),global.ng.core,global.ng.cdk.scrolling,global.ng.common,global.ng.cdk.bidi,global.ng.cdk.portal,global.Rx.operators,global.Rx,global.Rx,global.Rx.operators,global.Rx.Observable,global.ng.cdk.coercion,global.ng.cdk.keycodes));
	}(this, (function (exports,_angular_core,_angular_cdk_scrolling,_angular_common,_angular_cdk_bidi,_angular_cdk_portal,rxjs_operators_take,rxjs_Subject,rxjs_Subscription,rxjs_operators_filter,rxjs_observable_fromEvent,_angular_cdk_coercion,_angular_cdk_keycodes) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = Object.assign || function __assign(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	    }
	    return t;
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Scroll strategy that doesn't do anything.
	 */
	var NoopScrollStrategy = /** @class */ (function () {
	    function NoopScrollStrategy() {
	    }
	    /** Does nothing, as this scroll strategy is a no-op. */
	    /**
	     * Does nothing, as this scroll strategy is a no-op.
	     * @return {?}
	     */
	    NoopScrollStrategy.prototype.enable = /**
	     * Does nothing, as this scroll strategy is a no-op.
	     * @return {?}
	     */
	    function () { };
	    /** Does nothing, as this scroll strategy is a no-op. */
	    /**
	     * Does nothing, as this scroll strategy is a no-op.
	     * @return {?}
	     */
	    NoopScrollStrategy.prototype.disable = /**
	     * Does nothing, as this scroll strategy is a no-op.
	     * @return {?}
	     */
	    function () { };
	    /** Does nothing, as this scroll strategy is a no-op. */
	    /**
	     * Does nothing, as this scroll strategy is a no-op.
	     * @return {?}
	     */
	    NoopScrollStrategy.prototype.attach = /**
	     * Does nothing, as this scroll strategy is a no-op.
	     * @return {?}
	     */
	    function () { };
	    return NoopScrollStrategy;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Initial configuration used when creating an overlay.
	 */
	var OverlayConfig = /** @class */ (function () {
	    function OverlayConfig(config) {
	        var _this = this;
	        /**
	         * Strategy to be used when handling scroll events while the overlay is open.
	         */
	        this.scrollStrategy = new NoopScrollStrategy();
	        /**
	         * Custom class to add to the overlay pane.
	         */
	        this.panelClass = '';
	        /**
	         * Whether the overlay has a backdrop.
	         */
	        this.hasBackdrop = false;
	        /**
	         * Custom class to add to the backdrop
	         */
	        this.backdropClass = 'cdk-overlay-dark-backdrop';
	        /**
	         * The direction of the text in the overlay panel.
	         */
	        this.direction = 'ltr';
	        if (config) {
	            Object.keys(config)
	                .filter(function (key) { return typeof config[key] !== 'undefined'; })
	                .forEach(function (key) { return _this[key] = config[key]; });
	        }
	    }
	    return OverlayConfig;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * A connection point on the origin element.
	 * @record
	 */
	
	/**
	 * A connection point on the overlay element.
	 * @record
	 */
	
	/**
	 * The points of the origin element and the overlay element to connect.
	 */
	var ConnectionPositionPair = /** @class */ (function () {
	    function ConnectionPositionPair(origin, overlay, offsetX, offsetY) {
	        this.offsetX = offsetX;
	        this.offsetY = offsetY;
	        this.originX = origin.originX;
	        this.originY = origin.originY;
	        this.overlayX = overlay.overlayX;
	        this.overlayY = overlay.overlayY;
	    }
	    return ConnectionPositionPair;
	}());
	/**
	 * Set of properties regarding the position of the origin and overlay relative to the viewport
	 * with respect to the containing Scrollable elements.
	 *
	 * The overlay and origin are clipped if any part of their bounding client rectangle exceeds the
	 * bounds of any one of the strategy's Scrollable's bounding client rectangle.
	 *
	 * The overlay and origin are outside view if there is no overlap between their bounding client
	 * rectangle and any one of the strategy's Scrollable's bounding client rectangle.
	 *
	 *       -----------                    -----------
	 *       | outside |                    | clipped |
	 *       |  view   |              --------------------------
	 *       |         |              |     |         |        |
	 *       ----------               |     -----------        |
	 *  --------------------------    |                        |
	 *  |                        |    |      Scrollable        |
	 *  |                        |    |                        |
	 *  |                        |     --------------------------
	 *  |      Scrollable        |
	 *  |                        |
	 *  --------------------------
	 *
	 *  \@docs-private
	 */
	var ScrollingVisibility = /** @class */ (function () {
	    function ScrollingVisibility() {
	    }
	    return ScrollingVisibility;
	}());
	/**
	 * The change event emitted by the strategy when a fallback position is used.
	 */
	var ConnectedOverlayPositionChange = /** @class */ (function () {
	    function ConnectedOverlayPositionChange(connectionPair, /** @docs-private */
	        scrollableViewProperties) {
	        this.connectionPair = connectionPair;
	        this.scrollableViewProperties = scrollableViewProperties;
	    }
	    /** @nocollapse */
	    ConnectedOverlayPositionChange.ctorParameters = function () { return [
	        { type: ConnectionPositionPair, },
	        { type: ScrollingVisibility, decorators: [{ type: _angular_core.Optional },] },
	    ]; };
	    return ConnectedOverlayPositionChange;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Describes a strategy that will be used by an overlay to handle scroll events while it is open.
	 * @record
	 */
	
	/**
	 * Returns an error to be thrown when attempting to attach an already-attached scroll strategy.
	 * @return {?}
	 */
	function getMatScrollStrategyAlreadyAttachedError() {
	    return Error("Scroll strategy has already been attached.");
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * Config options for the CloseScrollStrategy.
	 * @record
	 */
	
	/**
	 * Strategy that will close the overlay as soon as the user starts scrolling.
	 */
	var CloseScrollStrategy = /** @class */ (function () {
	    function CloseScrollStrategy(_scrollDispatcher, _ngZone, _viewportRuler, _config) {
	        var _this = this;
	        this._scrollDispatcher = _scrollDispatcher;
	        this._ngZone = _ngZone;
	        this._viewportRuler = _viewportRuler;
	        this._config = _config;
	        this._scrollSubscription = null;
	        /**
	         * Detaches the overlay ref and disables the scroll strategy.
	         */
	        this._detach = function () {
	            _this.disable();
	            if (_this._overlayRef.hasAttached()) {
	                _this._ngZone.run(function () { return _this._overlayRef.detach(); });
	            }
	        };
	    }
	    /** Attaches this scroll strategy to an overlay. */
	    /**
	     * Attaches this scroll strategy to an overlay.
	     * @param {?} overlayRef
	     * @return {?}
	     */
	    CloseScrollStrategy.prototype.attach = /**
	     * Attaches this scroll strategy to an overlay.
	     * @param {?} overlayRef
	     * @return {?}
	     */
	    function (overlayRef) {
	        if (this._overlayRef) {
	            throw getMatScrollStrategyAlreadyAttachedError();
	        }
	        this._overlayRef = overlayRef;
	    };
	    /** Enables the closing of the attached overlay on scroll. */
	    /**
	     * Enables the closing of the attached overlay on scroll.
	     * @return {?}
	     */
	    CloseScrollStrategy.prototype.enable = /**
	     * Enables the closing of the attached overlay on scroll.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._scrollSubscription) {
	            return;
	        }
	        var /** @type {?} */ stream = this._scrollDispatcher.scrolled(0);
	        if (this._config && this._config.threshold && this._config.threshold > 1) {
	            this._initialScrollPosition = this._viewportRuler.getViewportScrollPosition().top;
	            this._scrollSubscription = stream.subscribe(function () {
	                var /** @type {?} */ scrollPosition = _this._viewportRuler.getViewportScrollPosition().top;
	                if (Math.abs(scrollPosition - _this._initialScrollPosition) > /** @type {?} */ ((/** @type {?} */ ((_this._config)).threshold))) {
	                    _this._detach();
	                }
	                else {
	                    _this._overlayRef.updatePosition();
	                }
	            });
	        }
	        else {
	            this._scrollSubscription = stream.subscribe(this._detach);
	        }
	    };
	    /** Disables the closing the attached overlay on scroll. */
	    /**
	     * Disables the closing the attached overlay on scroll.
	     * @return {?}
	     */
	    CloseScrollStrategy.prototype.disable = /**
	     * Disables the closing the attached overlay on scroll.
	     * @return {?}
	     */
	    function () {
	        if (this._scrollSubscription) {
	            this._scrollSubscription.unsubscribe();
	            this._scrollSubscription = null;
	        }
	    };
	    return CloseScrollStrategy;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Strategy that will prevent the user from scrolling while the overlay is visible.
	 */
	var BlockScrollStrategy = /** @class */ (function () {
	    function BlockScrollStrategy(_viewportRuler, document) {
	        this._viewportRuler = _viewportRuler;
	        this._previousHTMLStyles = { top: '', left: '' };
	        this._isEnabled = false;
	        this._document = document;
	    }
	    /** Attaches this scroll strategy to an overlay. */
	    /**
	     * Attaches this scroll strategy to an overlay.
	     * @return {?}
	     */
	    BlockScrollStrategy.prototype.attach = /**
	     * Attaches this scroll strategy to an overlay.
	     * @return {?}
	     */
	    function () { };
	    /** Blocks page-level scroll while the attached overlay is open. */
	    /**
	     * Blocks page-level scroll while the attached overlay is open.
	     * @return {?}
	     */
	    BlockScrollStrategy.prototype.enable = /**
	     * Blocks page-level scroll while the attached overlay is open.
	     * @return {?}
	     */
	    function () {
	        if (this._canBeEnabled()) {
	            var /** @type {?} */ root = this._document.documentElement;
	            this._previousScrollPosition = this._viewportRuler.getViewportScrollPosition();
	            // Cache the previous inline styles in case the user had set them.
	            this._previousHTMLStyles.left = root.style.left || '';
	            this._previousHTMLStyles.top = root.style.top || '';
	            // Note: we're using the `html` node, instead of the `body`, because the `body` may
	            // have the user agent margin, whereas the `html` is guaranteed not to have one.
	            root.style.left = -this._previousScrollPosition.left + "px";
	            root.style.top = -this._previousScrollPosition.top + "px";
	            root.classList.add('cdk-global-scrollblock');
	            this._isEnabled = true;
	        }
	    };
	    /** Unblocks page-level scroll while the attached overlay is open. */
	    /**
	     * Unblocks page-level scroll while the attached overlay is open.
	     * @return {?}
	     */
	    BlockScrollStrategy.prototype.disable = /**
	     * Unblocks page-level scroll while the attached overlay is open.
	     * @return {?}
	     */
	    function () {
	        if (this._isEnabled) {
	            var /** @type {?} */ html = this._document.documentElement;
	            var /** @type {?} */ body = this._document.body;
	            var /** @type {?} */ previousHtmlScrollBehavior = html.style['scrollBehavior'] || '';
	            var /** @type {?} */ previousBodyScrollBehavior = body.style['scrollBehavior'] || '';
	            this._isEnabled = false;
	            html.style.left = this._previousHTMLStyles.left;
	            html.style.top = this._previousHTMLStyles.top;
	            html.classList.remove('cdk-global-scrollblock');
	            // Disable user-defined smooth scrolling temporarily while we restore the scroll position.
	            // See https://developer.mozilla.org/en-US/docs/Web/CSS/scroll-behavior
	            html.style['scrollBehavior'] = body.style['scrollBehavior'] = 'auto';
	            window.scroll(this._previousScrollPosition.left, this._previousScrollPosition.top);
	            html.style['scrollBehavior'] = previousHtmlScrollBehavior;
	            body.style['scrollBehavior'] = previousBodyScrollBehavior;
	        }
	    };
	    /**
	     * @return {?}
	     */
	    BlockScrollStrategy.prototype._canBeEnabled = /**
	     * @return {?}
	     */
	    function () {
	        // Since the scroll strategies can't be singletons, we have to use a global CSS class
	        // (`cdk-global-scrollblock`) to make sure that we don't try to disable global
	        // scrolling multiple times.
	        var /** @type {?} */ html = this._document.documentElement;
	        if (html.classList.contains('cdk-global-scrollblock') || this._isEnabled) {
	            return false;
	        }
	        var /** @type {?} */ body = this._document.body;
	        var /** @type {?} */ viewport = this._viewportRuler.getViewportSize();
	        return body.scrollHeight > viewport.height || body.scrollWidth > viewport.width;
	    };
	    return BlockScrollStrategy;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	// TODO(jelbourn): move this to live with the rest of the scrolling code
	// TODO(jelbourn): someday replace this with IntersectionObservers
	/**
	 * Gets whether an element is scrolled outside of view by any of its parent scrolling containers.
	 * \@docs-private
	 * @param {?} element Dimensions of the element (from getBoundingClientRect)
	 * @param {?} scrollContainers Dimensions of element's scrolling containers (from getBoundingClientRect)
	 * @return {?} Whether the element is scrolled out of view
	 */
	function isElementScrolledOutsideView(element, scrollContainers) {
	    return scrollContainers.some(function (containerBounds) {
	        var /** @type {?} */ outsideAbove = element.bottom < containerBounds.top;
	        var /** @type {?} */ outsideBelow = element.top > containerBounds.bottom;
	        var /** @type {?} */ outsideLeft = element.right < containerBounds.left;
	        var /** @type {?} */ outsideRight = element.left > containerBounds.right;
	        return outsideAbove || outsideBelow || outsideLeft || outsideRight;
	    });
	}
	/**
	 * Gets whether an element is clipped by any of its scrolling containers.
	 * \@docs-private
	 * @param {?} element Dimensions of the element (from getBoundingClientRect)
	 * @param {?} scrollContainers Dimensions of element's scrolling containers (from getBoundingClientRect)
	 * @return {?} Whether the element is clipped
	 */
	function isElementClippedByScrolling(element, scrollContainers) {
	    return scrollContainers.some(function (scrollContainerRect) {
	        var /** @type {?} */ clippedAbove = element.top < scrollContainerRect.top;
	        var /** @type {?} */ clippedBelow = element.bottom > scrollContainerRect.bottom;
	        var /** @type {?} */ clippedLeft = element.left < scrollContainerRect.left;
	        var /** @type {?} */ clippedRight = element.right > scrollContainerRect.right;
	        return clippedAbove || clippedBelow || clippedLeft || clippedRight;
	    });
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Config options for the RepositionScrollStrategy.
	 * @record
	 */
	
	/**
	 * Strategy that will update the element position as the user is scrolling.
	 */
	var RepositionScrollStrategy = /** @class */ (function () {
	    function RepositionScrollStrategy(_scrollDispatcher, _viewportRuler, _ngZone, _config) {
	        this._scrollDispatcher = _scrollDispatcher;
	        this._viewportRuler = _viewportRuler;
	        this._ngZone = _ngZone;
	        this._config = _config;
	        this._scrollSubscription = null;
	    }
	    /** Attaches this scroll strategy to an overlay. */
	    /**
	     * Attaches this scroll strategy to an overlay.
	     * @param {?} overlayRef
	     * @return {?}
	     */
	    RepositionScrollStrategy.prototype.attach = /**
	     * Attaches this scroll strategy to an overlay.
	     * @param {?} overlayRef
	     * @return {?}
	     */
	    function (overlayRef) {
	        if (this._overlayRef) {
	            throw getMatScrollStrategyAlreadyAttachedError();
	        }
	        this._overlayRef = overlayRef;
	    };
	    /** Enables repositioning of the attached overlay on scroll. */
	    /**
	     * Enables repositioning of the attached overlay on scroll.
	     * @return {?}
	     */
	    RepositionScrollStrategy.prototype.enable = /**
	     * Enables repositioning of the attached overlay on scroll.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (!this._scrollSubscription) {
	            var /** @type {?} */ throttle = this._config ? this._config.scrollThrottle : 0;
	            this._scrollSubscription = this._scrollDispatcher.scrolled(throttle).subscribe(function () {
	                _this._overlayRef.updatePosition();
	                // TODO(crisbeto): make `close` on by default once all components can handle it.
	                if (_this._config && _this._config.autoClose) {
	                    var /** @type {?} */ overlayRect = _this._overlayRef.overlayElement.getBoundingClientRect();
	                    var _a = _this._viewportRuler.getViewportSize(), width = _a.width, height = _a.height;
	                    // TODO(crisbeto): include all ancestor scroll containers here once
	                    // we have a way of exposing the trigger element to the scroll strategy.
	                    var /** @type {?} */ parentRects = [{ width: width, height: height, bottom: height, right: width, top: 0, left: 0 }];
	                    if (isElementScrolledOutsideView(overlayRect, parentRects)) {
	                        _this.disable();
	                        _this._ngZone.run(function () { return _this._overlayRef.detach(); });
	                    }
	                }
	            });
	        }
	    };
	    /** Disables repositioning of the attached overlay on scroll. */
	    /**
	     * Disables repositioning of the attached overlay on scroll.
	     * @return {?}
	     */
	    RepositionScrollStrategy.prototype.disable = /**
	     * Disables repositioning of the attached overlay on scroll.
	     * @return {?}
	     */
	    function () {
	        if (this._scrollSubscription) {
	            this._scrollSubscription.unsubscribe();
	            this._scrollSubscription = null;
	        }
	    };
	    return RepositionScrollStrategy;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * Options for how an overlay will handle scrolling.
	 *
	 * Users can provide a custom value for `ScrollStrategyOptions` to replace the default
	 * behaviors. This class primarily acts as a factory for ScrollStrategy instances.
	 */
	var ScrollStrategyOptions = /** @class */ (function () {
	    function ScrollStrategyOptions(_scrollDispatcher, _viewportRuler, _ngZone, document) {
	        var _this = this;
	        this._scrollDispatcher = _scrollDispatcher;
	        this._viewportRuler = _viewportRuler;
	        this._ngZone = _ngZone;
	        /**
	         * Do nothing on scroll.
	         */
	        this.noop = function () { return new NoopScrollStrategy(); };
	        /**
	         * Close the overlay as soon as the user scrolls.
	         * @param config Configuration to be used inside the scroll strategy.
	         */
	        this.close = function (config) {
	            return new CloseScrollStrategy(_this._scrollDispatcher, _this._ngZone, _this._viewportRuler, config);
	        };
	        /**
	         * Block scrolling.
	         */
	        this.block = function () { return new BlockScrollStrategy(_this._viewportRuler, _this._document); };
	        /**
	         * Update the overlay's position on scroll.
	         * @param config Configuration to be used inside the scroll strategy.
	         * Allows debouncing the reposition calls.
	         */
	        this.reposition = function (config) {
	            return new RepositionScrollStrategy(_this._scrollDispatcher, _this._viewportRuler, _this._ngZone, config);
	        };
	        this._document = document;
	    }
	    ScrollStrategyOptions.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    ScrollStrategyOptions.ctorParameters = function () { return [
	        { type: _angular_cdk_scrolling.ScrollDispatcher, },
	        { type: _angular_cdk_scrolling.ViewportRuler, },
	        { type: _angular_core.NgZone, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    return ScrollStrategyOptions;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Reference to an overlay that has been created with the Overlay service.
	 * Used to manipulate or dispose of said overlay.
	 */
	var OverlayRef = /** @class */ (function () {
	    function OverlayRef(_portalOutlet, _pane, _config, _ngZone, _keyboardDispatcher, _document) {
	        this._portalOutlet = _portalOutlet;
	        this._pane = _pane;
	        this._config = _config;
	        this._ngZone = _ngZone;
	        this._keyboardDispatcher = _keyboardDispatcher;
	        this._document = _document;
	        this._backdropElement = null;
	        this._backdropClick = new rxjs_Subject.Subject();
	        this._attachments = new rxjs_Subject.Subject();
	        this._detachments = new rxjs_Subject.Subject();
	        /**
	         * Stream of keydown events dispatched to this overlay.
	         */
	        this._keydownEvents = new rxjs_Subject.Subject();
	        if (_config.scrollStrategy) {
	            _config.scrollStrategy.attach(this);
	        }
	    }
	    Object.defineProperty(OverlayRef.prototype, "overlayElement", {
	        /** The overlay's HTML element */
	        get: /**
	         * The overlay's HTML element
	         * @return {?}
	         */
	        function () {
	            return this._pane;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(OverlayRef.prototype, "backdropElement", {
	        /** The overlay's backdrop HTML element. */
	        get: /**
	         * The overlay's backdrop HTML element.
	         * @return {?}
	         */
	        function () {
	            return this._backdropElement;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Attaches content, given via a Portal, to the overlay.
	     * If the overlay is configured to have a backdrop, it will be created.
	     *
	     * @param portal Portal instance to which to attach the overlay.
	     * @returns The portal attachment result.
	     */
	    /**
	     * Attaches content, given via a Portal, to the overlay.
	     * If the overlay is configured to have a backdrop, it will be created.
	     *
	     * @param {?} portal Portal instance to which to attach the overlay.
	     * @return {?} The portal attachment result.
	     */
	    OverlayRef.prototype.attach = /**
	     * Attaches content, given via a Portal, to the overlay.
	     * If the overlay is configured to have a backdrop, it will be created.
	     *
	     * @param {?} portal Portal instance to which to attach the overlay.
	     * @return {?} The portal attachment result.
	     */
	    function (portal) {
	        var _this = this;
	        var /** @type {?} */ attachResult = this._portalOutlet.attach(portal);
	        if (this._config.positionStrategy) {
	            this._config.positionStrategy.attach(this);
	        }
	        // Update the pane element with the given configuration.
	        this._updateStackingOrder();
	        this._updateElementSize();
	        this._updateElementDirection();
	        if (this._config.scrollStrategy) {
	            this._config.scrollStrategy.enable();
	        }
	        // Update the position once the zone is stable so that the overlay will be fully rendered
	        // before attempting to position it, as the position may depend on the size of the rendered
	        // content.
	        this._ngZone.onStable.asObservable().pipe(rxjs_operators_take.take(1)).subscribe(function () {
	            // The overlay could've been detached before the zone has stabilized.
	            if (_this.hasAttached()) {
	                _this.updatePosition();
	            }
	        });
	        // Enable pointer events for the overlay pane element.
	        this._togglePointerEvents(true);
	        if (this._config.hasBackdrop) {
	            this._attachBackdrop();
	        }
	        if (this._config.panelClass) {
	            // We can't do a spread here, because IE doesn't support setting multiple classes.
	            if (Array.isArray(this._config.panelClass)) {
	                this._config.panelClass.forEach(function (cls) { return _this._pane.classList.add(cls); });
	            }
	            else {
	                this._pane.classList.add(this._config.panelClass);
	            }
	        }
	        // Only emit the `attachments` event once all other setup is done.
	        this._attachments.next();
	        // Track this overlay by the keyboard dispatcher
	        this._keyboardDispatcher.add(this);
	        return attachResult;
	    };
	    /**
	     * Detaches an overlay from a portal.
	     * @returns The portal detachment result.
	     */
	    /**
	     * Detaches an overlay from a portal.
	     * @return {?} The portal detachment result.
	     */
	    OverlayRef.prototype.detach = /**
	     * Detaches an overlay from a portal.
	     * @return {?} The portal detachment result.
	     */
	    function () {
	        if (!this.hasAttached()) {
	            return;
	        }
	        this.detachBackdrop();
	        // When the overlay is detached, the pane element should disable pointer events.
	        // This is necessary because otherwise the pane element will cover the page and disable
	        // pointer events therefore. Depends on the position strategy and the applied pane boundaries.
	        this._togglePointerEvents(false);
	        if (this._config.positionStrategy && this._config.positionStrategy.detach) {
	            this._config.positionStrategy.detach();
	        }
	        if (this._config.scrollStrategy) {
	            this._config.scrollStrategy.disable();
	        }
	        var /** @type {?} */ detachmentResult = this._portalOutlet.detach();
	        // Only emit after everything is detached.
	        this._detachments.next();
	        // Remove this overlay from keyboard dispatcher tracking
	        this._keyboardDispatcher.remove(this);
	        return detachmentResult;
	    };
	    /** Cleans up the overlay from the DOM. */
	    /**
	     * Cleans up the overlay from the DOM.
	     * @return {?}
	     */
	    OverlayRef.prototype.dispose = /**
	     * Cleans up the overlay from the DOM.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ isAttached = this.hasAttached();
	        if (this._config.positionStrategy) {
	            this._config.positionStrategy.dispose();
	        }
	        if (this._config.scrollStrategy) {
	            this._config.scrollStrategy.disable();
	        }
	        this.detachBackdrop();
	        this._keyboardDispatcher.remove(this);
	        this._portalOutlet.dispose();
	        this._attachments.complete();
	        this._backdropClick.complete();
	        this._keydownEvents.complete();
	        if (isAttached) {
	            this._detachments.next();
	        }
	        this._detachments.complete();
	    };
	    /** Whether the overlay has attached content. */
	    /**
	     * Whether the overlay has attached content.
	     * @return {?}
	     */
	    OverlayRef.prototype.hasAttached = /**
	     * Whether the overlay has attached content.
	     * @return {?}
	     */
	    function () {
	        return this._portalOutlet.hasAttached();
	    };
	    /** Gets an observable that emits when the backdrop has been clicked. */
	    /**
	     * Gets an observable that emits when the backdrop has been clicked.
	     * @return {?}
	     */
	    OverlayRef.prototype.backdropClick = /**
	     * Gets an observable that emits when the backdrop has been clicked.
	     * @return {?}
	     */
	    function () {
	        return this._backdropClick.asObservable();
	    };
	    /** Gets an observable that emits when the overlay has been attached. */
	    /**
	     * Gets an observable that emits when the overlay has been attached.
	     * @return {?}
	     */
	    OverlayRef.prototype.attachments = /**
	     * Gets an observable that emits when the overlay has been attached.
	     * @return {?}
	     */
	    function () {
	        return this._attachments.asObservable();
	    };
	    /** Gets an observable that emits when the overlay has been detached. */
	    /**
	     * Gets an observable that emits when the overlay has been detached.
	     * @return {?}
	     */
	    OverlayRef.prototype.detachments = /**
	     * Gets an observable that emits when the overlay has been detached.
	     * @return {?}
	     */
	    function () {
	        return this._detachments.asObservable();
	    };
	    /** Gets an observable of keydown events targeted to this overlay. */
	    /**
	     * Gets an observable of keydown events targeted to this overlay.
	     * @return {?}
	     */
	    OverlayRef.prototype.keydownEvents = /**
	     * Gets an observable of keydown events targeted to this overlay.
	     * @return {?}
	     */
	    function () {
	        return this._keydownEvents.asObservable();
	    };
	    /** Gets the the current overlay configuration, which is immutable. */
	    /**
	     * Gets the the current overlay configuration, which is immutable.
	     * @return {?}
	     */
	    OverlayRef.prototype.getConfig = /**
	     * Gets the the current overlay configuration, which is immutable.
	     * @return {?}
	     */
	    function () {
	        return this._config;
	    };
	    /** Updates the position of the overlay based on the position strategy. */
	    /**
	     * Updates the position of the overlay based on the position strategy.
	     * @return {?}
	     */
	    OverlayRef.prototype.updatePosition = /**
	     * Updates the position of the overlay based on the position strategy.
	     * @return {?}
	     */
	    function () {
	        if (this._config.positionStrategy) {
	            this._config.positionStrategy.apply();
	        }
	    };
	    /** Update the size properties of the overlay. */
	    /**
	     * Update the size properties of the overlay.
	     * @param {?} sizeConfig
	     * @return {?}
	     */
	    OverlayRef.prototype.updateSize = /**
	     * Update the size properties of the overlay.
	     * @param {?} sizeConfig
	     * @return {?}
	     */
	    function (sizeConfig) {
	        this._config = __assign({}, this._config, sizeConfig);
	        this._updateElementSize();
	    };
	    /** Sets the LTR/RTL direction for the overlay. */
	    /**
	     * Sets the LTR/RTL direction for the overlay.
	     * @param {?} dir
	     * @return {?}
	     */
	    OverlayRef.prototype.setDirection = /**
	     * Sets the LTR/RTL direction for the overlay.
	     * @param {?} dir
	     * @return {?}
	     */
	    function (dir) {
	        this._config = __assign({}, this._config, { direction: dir });
	        this._updateElementDirection();
	    };
	    /**
	     * Updates the text direction of the overlay panel.
	     * @return {?}
	     */
	    OverlayRef.prototype._updateElementDirection = /**
	     * Updates the text direction of the overlay panel.
	     * @return {?}
	     */
	    function () {
	        this._pane.setAttribute('dir', /** @type {?} */ ((this._config.direction)));
	    };
	    /**
	     * Updates the size of the overlay element based on the overlay config.
	     * @return {?}
	     */
	    OverlayRef.prototype._updateElementSize = /**
	     * Updates the size of the overlay element based on the overlay config.
	     * @return {?}
	     */
	    function () {
	        if (this._config.width || this._config.width === 0) {
	            this._pane.style.width = formatCssUnit(this._config.width);
	        }
	        if (this._config.height || this._config.height === 0) {
	            this._pane.style.height = formatCssUnit(this._config.height);
	        }
	        if (this._config.minWidth || this._config.minWidth === 0) {
	            this._pane.style.minWidth = formatCssUnit(this._config.minWidth);
	        }
	        if (this._config.minHeight || this._config.minHeight === 0) {
	            this._pane.style.minHeight = formatCssUnit(this._config.minHeight);
	        }
	        if (this._config.maxWidth || this._config.maxWidth === 0) {
	            this._pane.style.maxWidth = formatCssUnit(this._config.maxWidth);
	        }
	        if (this._config.maxHeight || this._config.maxHeight === 0) {
	            this._pane.style.maxHeight = formatCssUnit(this._config.maxHeight);
	        }
	    };
	    /**
	     * Toggles the pointer events for the overlay pane element.
	     * @param {?} enablePointer
	     * @return {?}
	     */
	    OverlayRef.prototype._togglePointerEvents = /**
	     * Toggles the pointer events for the overlay pane element.
	     * @param {?} enablePointer
	     * @return {?}
	     */
	    function (enablePointer) {
	        this._pane.style.pointerEvents = enablePointer ? 'auto' : 'none';
	    };
	    /**
	     * Attaches a backdrop for this overlay.
	     * @return {?}
	     */
	    OverlayRef.prototype._attachBackdrop = /**
	     * Attaches a backdrop for this overlay.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ showingClass = 'cdk-overlay-backdrop-showing';
	        this._backdropElement = this._document.createElement('div');
	        this._backdropElement.classList.add('cdk-overlay-backdrop');
	        if (this._config.backdropClass) {
	            this._backdropElement.classList.add(this._config.backdropClass);
	        } /** @type {?} */
	        ((
	        // Insert the backdrop before the pane in the DOM order,
	        // in order to handle stacked overlays properly.
	        this._pane.parentElement)).insertBefore(this._backdropElement, this._pane);
	        // Forward backdrop clicks such that the consumer of the overlay can perform whatever
	        // action desired when such a click occurs (usually closing the overlay).
	        this._backdropElement.addEventListener('click', function (event) { return _this._backdropClick.next(event); });
	        // Add class to fade-in the backdrop after one frame.
	        if (typeof requestAnimationFrame !== 'undefined') {
	            this._ngZone.runOutsideAngular(function () {
	                requestAnimationFrame(function () {
	                    if (_this._backdropElement) {
	                        _this._backdropElement.classList.add(showingClass);
	                    }
	                });
	            });
	        }
	        else {
	            this._backdropElement.classList.add(showingClass);
	        }
	    };
	    /**
	     * Updates the stacking order of the element, moving it to the top if necessary.
	     * This is required in cases where one overlay was detached, while another one,
	     * that should be behind it, was destroyed. The next time both of them are opened,
	     * the stacking will be wrong, because the detached element's pane will still be
	     * in its original DOM position.
	     * @return {?}
	     */
	    OverlayRef.prototype._updateStackingOrder = /**
	     * Updates the stacking order of the element, moving it to the top if necessary.
	     * This is required in cases where one overlay was detached, while another one,
	     * that should be behind it, was destroyed. The next time both of them are opened,
	     * the stacking will be wrong, because the detached element's pane will still be
	     * in its original DOM position.
	     * @return {?}
	     */
	    function () {
	        if (this._pane.nextSibling) {
	            /** @type {?} */ ((this._pane.parentNode)).appendChild(this._pane);
	        }
	    };
	    /** Detaches the backdrop (if any) associated with the overlay. */
	    /**
	     * Detaches the backdrop (if any) associated with the overlay.
	     * @return {?}
	     */
	    OverlayRef.prototype.detachBackdrop = /**
	     * Detaches the backdrop (if any) associated with the overlay.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ backdropToDetach = this._backdropElement;
	        if (backdropToDetach) {
	            var /** @type {?} */ finishDetach_1 = function () {
	                // It may not be attached to anything in certain cases (e.g. unit tests).
	                if (backdropToDetach && backdropToDetach.parentNode) {
	                    backdropToDetach.parentNode.removeChild(backdropToDetach);
	                }
	                // It is possible that a new portal has been attached to this overlay since we started
	                // removing the backdrop. If that is the case, only clear the backdrop reference if it
	                // is still the same instance that we started to remove.
	                if (_this._backdropElement == backdropToDetach) {
	                    _this._backdropElement = null;
	                }
	            };
	            backdropToDetach.classList.remove('cdk-overlay-backdrop-showing');
	            if (this._config.backdropClass) {
	                backdropToDetach.classList.remove(this._config.backdropClass);
	            }
	            backdropToDetach.addEventListener('transitionend', finishDetach_1);
	            // If the backdrop doesn't have a transition, the `transitionend` event won't fire.
	            // In this case we make it unclickable and we try to remove it after a delay.
	            backdropToDetach.style.pointerEvents = 'none';
	            // Run this outside the Angular zone because there's nothing that Angular cares about.
	            // If it were to run inside the Angular zone, every test that used Overlay would have to be
	            // either async or fakeAsync.
	            this._ngZone.runOutsideAngular(function () {
	                setTimeout(finishDetach_1, 500);
	            });
	        }
	    };
	    return OverlayRef;
	}());
	/**
	 * @param {?} value
	 * @return {?}
	 */
	function formatCssUnit(value) {
	    return typeof value === 'string' ? /** @type {?} */ (value) : value + "px";
	}
	/**
	 * Size properties for an overlay.
	 * @record
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * A strategy for positioning overlays. Using this strategy, an overlay is given an
	 * implicit position relative some origin element. The relative position is defined in terms of
	 * a point on the origin element that is connected to a point on the overlay element. For example,
	 * a basic dropdown is connecting the bottom-left corner of the origin to the top-left corner
	 * of the overlay.
	 */
	var ConnectedPositionStrategy = /** @class */ (function () {
	    function ConnectedPositionStrategy(originPos, overlayPos, _connectedTo, _viewportRuler, _document) {
	        this._connectedTo = _connectedTo;
	        this._viewportRuler = _viewportRuler;
	        this._document = _document;
	        /**
	         * Layout direction of the position strategy.
	         */
	        this._dir = 'ltr';
	        /**
	         * The offset in pixels for the overlay connection point on the x-axis
	         */
	        this._offsetX = 0;
	        /**
	         * The offset in pixels for the overlay connection point on the y-axis
	         */
	        this._offsetY = 0;
	        /**
	         * The Scrollable containers used to check scrollable view properties on position change.
	         */
	        this.scrollables = [];
	        /**
	         * Subscription to viewport resize events.
	         */
	        this._resizeSubscription = rxjs_Subscription.Subscription.EMPTY;
	        /**
	         * Ordered list of preferred positions, from most to least desirable.
	         */
	        this._preferredPositions = [];
	        /**
	         * Whether the position strategy is applied currently.
	         */
	        this._applied = false;
	        /**
	         * Whether the overlay position is locked.
	         */
	        this._positionLocked = false;
	        this._onPositionChange = new rxjs_Subject.Subject();
	        this._origin = this._connectedTo.nativeElement;
	        this.withFallbackPosition(originPos, overlayPos);
	    }
	    Object.defineProperty(ConnectedPositionStrategy.prototype, "_isRtl", {
	        /** Whether the we're dealing with an RTL context */
	        get: /**
	         * Whether the we're dealing with an RTL context
	         * @return {?}
	         */
	        function () {
	            return this._dir === 'rtl';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ConnectedPositionStrategy.prototype, "onPositionChange", {
	        /** Emits an event when the connection point changes. */
	        get: /**
	         * Emits an event when the connection point changes.
	         * @return {?}
	         */
	        function () {
	            return this._onPositionChange.asObservable();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ConnectedPositionStrategy.prototype, "positions", {
	        /** Ordered list of preferred positions, from most to least desirable. */
	        get: /**
	         * Ordered list of preferred positions, from most to least desirable.
	         * @return {?}
	         */
	        function () {
	            return this._preferredPositions;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** Attach this position strategy to an overlay. */
	    /**
	     * Attach this position strategy to an overlay.
	     * @param {?} overlayRef
	     * @return {?}
	     */
	    ConnectedPositionStrategy.prototype.attach = /**
	     * Attach this position strategy to an overlay.
	     * @param {?} overlayRef
	     * @return {?}
	     */
	    function (overlayRef) {
	        var _this = this;
	        this._pane = overlayRef.overlayElement;
	        this._resizeSubscription.unsubscribe();
	        this._resizeSubscription = this._viewportRuler.change().subscribe(function () { return _this.apply(); });
	    };
	    /** Disposes all resources used by the position strategy. */
	    /**
	     * Disposes all resources used by the position strategy.
	     * @return {?}
	     */
	    ConnectedPositionStrategy.prototype.dispose = /**
	     * Disposes all resources used by the position strategy.
	     * @return {?}
	     */
	    function () {
	        this._applied = false;
	        this._resizeSubscription.unsubscribe();
	        this._onPositionChange.complete();
	    };
	    /** @docs-private */
	    /**
	     * \@docs-private
	     * @return {?}
	     */
	    ConnectedPositionStrategy.prototype.detach = /**
	     * \@docs-private
	     * @return {?}
	     */
	    function () {
	        this._applied = false;
	        this._resizeSubscription.unsubscribe();
	    };
	    /**
	     * Updates the position of the overlay element, using whichever preferred position relative
	     * to the origin fits on-screen.
	     * @docs-private
	     */
	    /**
	     * Updates the position of the overlay element, using whichever preferred position relative
	     * to the origin fits on-screen.
	     * \@docs-private
	     * @return {?}
	     */
	    ConnectedPositionStrategy.prototype.apply = /**
	     * Updates the position of the overlay element, using whichever preferred position relative
	     * to the origin fits on-screen.
	     * \@docs-private
	     * @return {?}
	     */
	    function () {
	        // If the position has been applied already (e.g. when the overlay was opened) and the
	        // consumer opted into locking in the position, re-use the  old position, in order to
	        // prevent the overlay from jumping around.
	        if (this._applied && this._positionLocked && this._lastConnectedPosition) {
	            this.recalculateLastPosition();
	            return;
	        }
	        this._applied = true;
	        // We need the bounding rects for the origin and the overlay to determine how to position
	        // the overlay relative to the origin.
	        var /** @type {?} */ element = this._pane;
	        var /** @type {?} */ originRect = this._origin.getBoundingClientRect();
	        var /** @type {?} */ overlayRect = element.getBoundingClientRect();
	        // We use the viewport size to determine whether a position would go off-screen.
	        var /** @type {?} */ viewportSize = this._viewportRuler.getViewportSize();
	        // Fallback point if none of the fallbacks fit into the viewport.
	        var /** @type {?} */ fallbackPoint;
	        var /** @type {?} */ fallbackPosition;
	        // We want to place the overlay in the first of the preferred positions such that the
	        // overlay fits on-screen.
	        for (var _i = 0, _a = this._preferredPositions; _i < _a.length; _i++) {
	            var pos = _a[_i];
	            // Get the (x, y) point of connection on the origin, and then use that to get the
	            // (top, left) coordinate for the overlay at `pos`.
	            var /** @type {?} */ originPoint = this._getOriginConnectionPoint(originRect, pos);
	            var /** @type {?} */ overlayPoint = this._getOverlayPoint(originPoint, overlayRect, viewportSize, pos);
	            // If the overlay in the calculated position fits on-screen, put it there and we're done.
	            if (overlayPoint.fitsInViewport) {
	                this._setElementPosition(element, overlayRect, overlayPoint, pos);
	                // Save the last connected position in case the position needs to be re-calculated.
	                this._lastConnectedPosition = pos;
	                return;
	            }
	            else if (!fallbackPoint || fallbackPoint.visibleArea < overlayPoint.visibleArea) {
	                fallbackPoint = overlayPoint;
	                fallbackPosition = pos;
	            }
	        }
	        // If none of the preferred positions were in the viewport, take the one
	        // with the largest visible area.
	        this._setElementPosition(element, overlayRect, /** @type {?} */ ((fallbackPoint)), /** @type {?} */ ((fallbackPosition)));
	    };
	    /**
	     * Re-positions the overlay element with the trigger in its last calculated position,
	     * even if a position higher in the "preferred positions" list would now fit. This
	     * allows one to re-align the panel without changing the orientation of the panel.
	     */
	    /**
	     * Re-positions the overlay element with the trigger in its last calculated position,
	     * even if a position higher in the "preferred positions" list would now fit. This
	     * allows one to re-align the panel without changing the orientation of the panel.
	     * @return {?}
	     */
	    ConnectedPositionStrategy.prototype.recalculateLastPosition = /**
	     * Re-positions the overlay element with the trigger in its last calculated position,
	     * even if a position higher in the "preferred positions" list would now fit. This
	     * allows one to re-align the panel without changing the orientation of the panel.
	     * @return {?}
	     */
	    function () {
	        // If the overlay has never been positioned before, do nothing.
	        if (!this._lastConnectedPosition) {
	            return;
	        }
	        var /** @type {?} */ originRect = this._origin.getBoundingClientRect();
	        var /** @type {?} */ overlayRect = this._pane.getBoundingClientRect();
	        var /** @type {?} */ viewportSize = this._viewportRuler.getViewportSize();
	        var /** @type {?} */ lastPosition = this._lastConnectedPosition || this._preferredPositions[0];
	        var /** @type {?} */ originPoint = this._getOriginConnectionPoint(originRect, lastPosition);
	        var /** @type {?} */ overlayPoint = this._getOverlayPoint(originPoint, overlayRect, viewportSize, lastPosition);
	        this._setElementPosition(this._pane, overlayRect, overlayPoint, lastPosition);
	    };
	    /**
	     * Sets the list of Scrollable containers that host the origin element so that
	     * on reposition we can evaluate if it or the overlay has been clipped or outside view. Every
	     * Scrollable must be an ancestor element of the strategy's origin element.
	     */
	    /**
	     * Sets the list of Scrollable containers that host the origin element so that
	     * on reposition we can evaluate if it or the overlay has been clipped or outside view. Every
	     * Scrollable must be an ancestor element of the strategy's origin element.
	     * @param {?} scrollables
	     * @return {?}
	     */
	    ConnectedPositionStrategy.prototype.withScrollableContainers = /**
	     * Sets the list of Scrollable containers that host the origin element so that
	     * on reposition we can evaluate if it or the overlay has been clipped or outside view. Every
	     * Scrollable must be an ancestor element of the strategy's origin element.
	     * @param {?} scrollables
	     * @return {?}
	     */
	    function (scrollables) {
	        this.scrollables = scrollables;
	    };
	    /**
	     * Adds a new preferred fallback position.
	     * @param originPos
	     * @param overlayPos
	     */
	    /**
	     * Adds a new preferred fallback position.
	     * @param {?} originPos
	     * @param {?} overlayPos
	     * @param {?=} offsetX
	     * @param {?=} offsetY
	     * @return {?}
	     */
	    ConnectedPositionStrategy.prototype.withFallbackPosition = /**
	     * Adds a new preferred fallback position.
	     * @param {?} originPos
	     * @param {?} overlayPos
	     * @param {?=} offsetX
	     * @param {?=} offsetY
	     * @return {?}
	     */
	    function (originPos, overlayPos, offsetX, offsetY) {
	        var /** @type {?} */ position = new ConnectionPositionPair(originPos, overlayPos, offsetX, offsetY);
	        this._preferredPositions.push(position);
	        return this;
	    };
	    /**
	     * Sets the layout direction so the overlay's position can be adjusted to match.
	     * @param dir New layout direction.
	     */
	    /**
	     * Sets the layout direction so the overlay's position can be adjusted to match.
	     * @param {?} dir New layout direction.
	     * @return {?}
	     */
	    ConnectedPositionStrategy.prototype.withDirection = /**
	     * Sets the layout direction so the overlay's position can be adjusted to match.
	     * @param {?} dir New layout direction.
	     * @return {?}
	     */
	    function (dir) {
	        this._dir = dir;
	        return this;
	    };
	    /**
	     * Sets an offset for the overlay's connection point on the x-axis
	     * @param offset New offset in the X axis.
	     */
	    /**
	     * Sets an offset for the overlay's connection point on the x-axis
	     * @param {?} offset New offset in the X axis.
	     * @return {?}
	     */
	    ConnectedPositionStrategy.prototype.withOffsetX = /**
	     * Sets an offset for the overlay's connection point on the x-axis
	     * @param {?} offset New offset in the X axis.
	     * @return {?}
	     */
	    function (offset) {
	        this._offsetX = offset;
	        return this;
	    };
	    /**
	     * Sets an offset for the overlay's connection point on the y-axis
	     * @param  offset New offset in the Y axis.
	     */
	    /**
	     * Sets an offset for the overlay's connection point on the y-axis
	     * @param {?} offset New offset in the Y axis.
	     * @return {?}
	     */
	    ConnectedPositionStrategy.prototype.withOffsetY = /**
	     * Sets an offset for the overlay's connection point on the y-axis
	     * @param {?} offset New offset in the Y axis.
	     * @return {?}
	     */
	    function (offset) {
	        this._offsetY = offset;
	        return this;
	    };
	    /**
	     * Sets whether the overlay's position should be locked in after it is positioned
	     * initially. When an overlay is locked in, it won't attempt to reposition itself
	     * when the position is re-applied (e.g. when the user scrolls away).
	     * @param isLocked Whether the overlay should locked in.
	     */
	    /**
	     * Sets whether the overlay's position should be locked in after it is positioned
	     * initially. When an overlay is locked in, it won't attempt to reposition itself
	     * when the position is re-applied (e.g. when the user scrolls away).
	     * @param {?} isLocked Whether the overlay should locked in.
	     * @return {?}
	     */
	    ConnectedPositionStrategy.prototype.withLockedPosition = /**
	     * Sets whether the overlay's position should be locked in after it is positioned
	     * initially. When an overlay is locked in, it won't attempt to reposition itself
	     * when the position is re-applied (e.g. when the user scrolls away).
	     * @param {?} isLocked Whether the overlay should locked in.
	     * @return {?}
	     */
	    function (isLocked) {
	        this._positionLocked = isLocked;
	        return this;
	    };
	    /**
	     * Overwrites the current set of positions with an array of new ones.
	     * @param positions Position pairs to be set on the strategy.
	     */
	    /**
	     * Overwrites the current set of positions with an array of new ones.
	     * @param {?} positions Position pairs to be set on the strategy.
	     * @return {?}
	     */
	    ConnectedPositionStrategy.prototype.withPositions = /**
	     * Overwrites the current set of positions with an array of new ones.
	     * @param {?} positions Position pairs to be set on the strategy.
	     * @return {?}
	     */
	    function (positions) {
	        this._preferredPositions = positions.slice();
	        return this;
	    };
	    /**
	     * Sets the origin element, relative to which to position the overlay.
	     * @param origin Reference to the new origin element.
	     */
	    /**
	     * Sets the origin element, relative to which to position the overlay.
	     * @param {?} origin Reference to the new origin element.
	     * @return {?}
	     */
	    ConnectedPositionStrategy.prototype.setOrigin = /**
	     * Sets the origin element, relative to which to position the overlay.
	     * @param {?} origin Reference to the new origin element.
	     * @return {?}
	     */
	    function (origin) {
	        this._origin = origin.nativeElement;
	        return this;
	    };
	    /**
	     * Gets the horizontal (x) "start" dimension based on whether the overlay is in an RTL context.
	     * @param {?} rect
	     * @return {?}
	     */
	    ConnectedPositionStrategy.prototype._getStartX = /**
	     * Gets the horizontal (x) "start" dimension based on whether the overlay is in an RTL context.
	     * @param {?} rect
	     * @return {?}
	     */
	    function (rect) {
	        return this._isRtl ? rect.right : rect.left;
	    };
	    /**
	     * Gets the horizontal (x) "end" dimension based on whether the overlay is in an RTL context.
	     * @param {?} rect
	     * @return {?}
	     */
	    ConnectedPositionStrategy.prototype._getEndX = /**
	     * Gets the horizontal (x) "end" dimension based on whether the overlay is in an RTL context.
	     * @param {?} rect
	     * @return {?}
	     */
	    function (rect) {
	        return this._isRtl ? rect.left : rect.right;
	    };
	    /**
	     * Gets the (x, y) coordinate of a connection point on the origin based on a relative position.
	     * @param {?} originRect
	     * @param {?} pos
	     * @return {?}
	     */
	    ConnectedPositionStrategy.prototype._getOriginConnectionPoint = /**
	     * Gets the (x, y) coordinate of a connection point on the origin based on a relative position.
	     * @param {?} originRect
	     * @param {?} pos
	     * @return {?}
	     */
	    function (originRect, pos) {
	        var /** @type {?} */ originStartX = this._getStartX(originRect);
	        var /** @type {?} */ originEndX = this._getEndX(originRect);
	        var /** @type {?} */ x;
	        if (pos.originX == 'center') {
	            x = originStartX + (originRect.width / 2);
	        }
	        else {
	            x = pos.originX == 'start' ? originStartX : originEndX;
	        }
	        var /** @type {?} */ y;
	        if (pos.originY == 'center') {
	            y = originRect.top + (originRect.height / 2);
	        }
	        else {
	            y = pos.originY == 'top' ? originRect.top : originRect.bottom;
	        }
	        return { x: x, y: y };
	    };
	    /**
	     * Gets the (x, y) coordinate of the top-left corner of the overlay given a given position and
	     * origin point to which the overlay should be connected, as well as how much of the element
	     * would be inside the viewport at that position.
	     * @param {?} originPoint
	     * @param {?} overlayRect
	     * @param {?} viewportSize
	     * @param {?} pos
	     * @return {?}
	     */
	    ConnectedPositionStrategy.prototype._getOverlayPoint = /**
	     * Gets the (x, y) coordinate of the top-left corner of the overlay given a given position and
	     * origin point to which the overlay should be connected, as well as how much of the element
	     * would be inside the viewport at that position.
	     * @param {?} originPoint
	     * @param {?} overlayRect
	     * @param {?} viewportSize
	     * @param {?} pos
	     * @return {?}
	     */
	    function (originPoint, overlayRect, viewportSize, pos) {
	        // Calculate the (overlayStartX, overlayStartY), the start of the potential overlay position
	        // relative to the origin point.
	        var /** @type {?} */ overlayStartX;
	        if (pos.overlayX == 'center') {
	            overlayStartX = -overlayRect.width / 2;
	        }
	        else if (pos.overlayX === 'start') {
	            overlayStartX = this._isRtl ? -overlayRect.width : 0;
	        }
	        else {
	            overlayStartX = this._isRtl ? 0 : -overlayRect.width;
	        }
	        var /** @type {?} */ overlayStartY;
	        if (pos.overlayY == 'center') {
	            overlayStartY = -overlayRect.height / 2;
	        }
	        else {
	            overlayStartY = pos.overlayY == 'top' ? 0 : -overlayRect.height;
	        }
	        // The (x, y) offsets of the overlay based on the current position.
	        var /** @type {?} */ offsetX = typeof pos.offsetX === 'undefined' ? this._offsetX : pos.offsetX;
	        var /** @type {?} */ offsetY = typeof pos.offsetY === 'undefined' ? this._offsetY : pos.offsetY;
	        // The (x, y) coordinates of the overlay.
	        var /** @type {?} */ x = originPoint.x + overlayStartX + offsetX;
	        var /** @type {?} */ y = originPoint.y + overlayStartY + offsetY;
	        // How much the overlay would overflow at this position, on each side.
	        var /** @type {?} */ leftOverflow = 0 - x;
	        var /** @type {?} */ rightOverflow = (x + overlayRect.width) - viewportSize.width;
	        var /** @type {?} */ topOverflow = 0 - y;
	        var /** @type {?} */ bottomOverflow = (y + overlayRect.height) - viewportSize.height;
	        // Visible parts of the element on each axis.
	        var /** @type {?} */ visibleWidth = this._subtractOverflows(overlayRect.width, leftOverflow, rightOverflow);
	        var /** @type {?} */ visibleHeight = this._subtractOverflows(overlayRect.height, topOverflow, bottomOverflow);
	        // The area of the element that's within the viewport.
	        var /** @type {?} */ visibleArea = visibleWidth * visibleHeight;
	        var /** @type {?} */ fitsInViewport = (overlayRect.width * overlayRect.height) === visibleArea;
	        return { x: x, y: y, fitsInViewport: fitsInViewport, visibleArea: visibleArea };
	    };
	    /**
	     * Gets the view properties of the trigger and overlay, including whether they are clipped
	     * or completely outside the view of any of the strategy's scrollables.
	     * @param {?} overlay
	     * @return {?}
	     */
	    ConnectedPositionStrategy.prototype._getScrollVisibility = /**
	     * Gets the view properties of the trigger and overlay, including whether they are clipped
	     * or completely outside the view of any of the strategy's scrollables.
	     * @param {?} overlay
	     * @return {?}
	     */
	    function (overlay) {
	        var /** @type {?} */ originBounds = this._origin.getBoundingClientRect();
	        var /** @type {?} */ overlayBounds = overlay.getBoundingClientRect();
	        var /** @type {?} */ scrollContainerBounds = this.scrollables.map(function (s) { return s.getElementRef().nativeElement.getBoundingClientRect(); });
	        return {
	            isOriginClipped: isElementClippedByScrolling(originBounds, scrollContainerBounds),
	            isOriginOutsideView: isElementScrolledOutsideView(originBounds, scrollContainerBounds),
	            isOverlayClipped: isElementClippedByScrolling(overlayBounds, scrollContainerBounds),
	            isOverlayOutsideView: isElementScrolledOutsideView(overlayBounds, scrollContainerBounds),
	        };
	    };
	    /**
	     * Physically positions the overlay element to the given coordinate.
	     * @param {?} element
	     * @param {?} overlayRect
	     * @param {?} overlayPoint
	     * @param {?} pos
	     * @return {?}
	     */
	    ConnectedPositionStrategy.prototype._setElementPosition = /**
	     * Physically positions the overlay element to the given coordinate.
	     * @param {?} element
	     * @param {?} overlayRect
	     * @param {?} overlayPoint
	     * @param {?} pos
	     * @return {?}
	     */
	    function (element, overlayRect, overlayPoint, pos) {
	        // We want to set either `top` or `bottom` based on whether the overlay wants to appear above
	        // or below the origin and the direction in which the element will expand.
	        var /** @type {?} */ verticalStyleProperty = pos.overlayY === 'bottom' ? 'bottom' : 'top';
	        // When using `bottom`, we adjust the y position such that it is the distance
	        // from the bottom of the viewport rather than the top.
	        var /** @type {?} */ y = verticalStyleProperty === 'top' ?
	            overlayPoint.y :
	            this._document.documentElement.clientHeight - (overlayPoint.y + overlayRect.height);
	        // We want to set either `left` or `right` based on whether the overlay wants to appear "before"
	        // or "after" the origin, which determines the direction in which the element will expand.
	        // For the horizontal axis, the meaning of "before" and "after" change based on whether the
	        // page is in RTL or LTR.
	        var /** @type {?} */ horizontalStyleProperty;
	        if (this._dir === 'rtl') {
	            horizontalStyleProperty = pos.overlayX === 'end' ? 'left' : 'right';
	        }
	        else {
	            horizontalStyleProperty = pos.overlayX === 'end' ? 'right' : 'left';
	        }
	        // When we're setting `right`, we adjust the x position such that it is the distance
	        // from the right edge of the viewport rather than the left edge.
	        var /** @type {?} */ x = horizontalStyleProperty === 'left' ?
	            overlayPoint.x :
	            this._document.documentElement.clientWidth - (overlayPoint.x + overlayRect.width);
	        // Reset any existing styles. This is necessary in case the preferred position has
	        // changed since the last `apply`.
	        ['top', 'bottom', 'left', 'right'].forEach(function (p) { return element.style[p] = null; });
	        element.style[verticalStyleProperty] = y + "px";
	        element.style[horizontalStyleProperty] = x + "px";
	        // Notify that the position has been changed along with its change properties.
	        var /** @type {?} */ scrollableViewProperties = this._getScrollVisibility(element);
	        var /** @type {?} */ positionChange = new ConnectedOverlayPositionChange(pos, scrollableViewProperties);
	        this._onPositionChange.next(positionChange);
	    };
	    /**
	     * Subtracts the amount that an element is overflowing on an axis from it's length.
	     * @param {?} length
	     * @param {...?} overflows
	     * @return {?}
	     */
	    ConnectedPositionStrategy.prototype._subtractOverflows = /**
	     * Subtracts the amount that an element is overflowing on an axis from it's length.
	     * @param {?} length
	     * @param {...?} overflows
	     * @return {?}
	     */
	    function (length) {
	        var overflows = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            overflows[_i - 1] = arguments[_i];
	        }
	        return overflows.reduce(function (currentValue, currentOverflow) {
	            return currentValue - Math.max(currentOverflow, 0);
	        }, length);
	    };
	    return ConnectedPositionStrategy;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * A strategy for positioning overlays. Using this strategy, an overlay is given an
	 * explicit position relative to the browser's viewport. We use flexbox, instead of
	 * transforms, in order to avoid issues with subpixel rendering which can cause the
	 * element to become blurry.
	 */
	var GlobalPositionStrategy = /** @class */ (function () {
	    function GlobalPositionStrategy(_document) {
	        this._document = _document;
	        this._cssPosition = 'static';
	        this._topOffset = '';
	        this._bottomOffset = '';
	        this._leftOffset = '';
	        this._rightOffset = '';
	        this._alignItems = '';
	        this._justifyContent = '';
	        this._width = '';
	        this._height = '';
	        /**
	         * A lazily-created wrapper for the overlay element that is used as a flex container.
	         */
	        this._wrapper = null;
	    }
	    /**
	     * @param {?} overlayRef
	     * @return {?}
	     */
	    GlobalPositionStrategy.prototype.attach = /**
	     * @param {?} overlayRef
	     * @return {?}
	     */
	    function (overlayRef) {
	        var /** @type {?} */ config = overlayRef.getConfig();
	        this._overlayRef = overlayRef;
	        if (this._width && !config.width) {
	            overlayRef.updateSize({ width: this._width });
	        }
	        if (this._height && !config.height) {
	            overlayRef.updateSize({ height: this._height });
	        }
	    };
	    /**
	     * Sets the top position of the overlay. Clears any previously set vertical position.
	     * @param value New top offset.
	     */
	    /**
	     * Sets the top position of the overlay. Clears any previously set vertical position.
	     * @param {?=} value New top offset.
	     * @return {?}
	     */
	    GlobalPositionStrategy.prototype.top = /**
	     * Sets the top position of the overlay. Clears any previously set vertical position.
	     * @param {?=} value New top offset.
	     * @return {?}
	     */
	    function (value) {
	        if (value === void 0) { value = ''; }
	        this._bottomOffset = '';
	        this._topOffset = value;
	        this._alignItems = 'flex-start';
	        return this;
	    };
	    /**
	     * Sets the left position of the overlay. Clears any previously set horizontal position.
	     * @param value New left offset.
	     */
	    /**
	     * Sets the left position of the overlay. Clears any previously set horizontal position.
	     * @param {?=} value New left offset.
	     * @return {?}
	     */
	    GlobalPositionStrategy.prototype.left = /**
	     * Sets the left position of the overlay. Clears any previously set horizontal position.
	     * @param {?=} value New left offset.
	     * @return {?}
	     */
	    function (value) {
	        if (value === void 0) { value = ''; }
	        this._rightOffset = '';
	        this._leftOffset = value;
	        this._justifyContent = 'flex-start';
	        return this;
	    };
	    /**
	     * Sets the bottom position of the overlay. Clears any previously set vertical position.
	     * @param value New bottom offset.
	     */
	    /**
	     * Sets the bottom position of the overlay. Clears any previously set vertical position.
	     * @param {?=} value New bottom offset.
	     * @return {?}
	     */
	    GlobalPositionStrategy.prototype.bottom = /**
	     * Sets the bottom position of the overlay. Clears any previously set vertical position.
	     * @param {?=} value New bottom offset.
	     * @return {?}
	     */
	    function (value) {
	        if (value === void 0) { value = ''; }
	        this._topOffset = '';
	        this._bottomOffset = value;
	        this._alignItems = 'flex-end';
	        return this;
	    };
	    /**
	     * Sets the right position of the overlay. Clears any previously set horizontal position.
	     * @param value New right offset.
	     */
	    /**
	     * Sets the right position of the overlay. Clears any previously set horizontal position.
	     * @param {?=} value New right offset.
	     * @return {?}
	     */
	    GlobalPositionStrategy.prototype.right = /**
	     * Sets the right position of the overlay. Clears any previously set horizontal position.
	     * @param {?=} value New right offset.
	     * @return {?}
	     */
	    function (value) {
	        if (value === void 0) { value = ''; }
	        this._leftOffset = '';
	        this._rightOffset = value;
	        this._justifyContent = 'flex-end';
	        return this;
	    };
	    /**
	     * Sets the overlay width and clears any previously set width.
	     * @param value New width for the overlay
	     * @deprecated Pass the `width` through the `OverlayConfig`.
	     * @deletion-target 7.0.0
	     */
	    /**
	     * Sets the overlay width and clears any previously set width.
	     * @deprecated Pass the `width` through the `OverlayConfig`.
	     * \@deletion-target 7.0.0
	     * @param {?=} value New width for the overlay
	     * @return {?}
	     */
	    GlobalPositionStrategy.prototype.width = /**
	     * Sets the overlay width and clears any previously set width.
	     * @deprecated Pass the `width` through the `OverlayConfig`.
	     * \@deletion-target 7.0.0
	     * @param {?=} value New width for the overlay
	     * @return {?}
	     */
	    function (value) {
	        if (value === void 0) { value = ''; }
	        if (this._overlayRef) {
	            this._overlayRef.updateSize({ width: value });
	        }
	        else {
	            this._width = value;
	        }
	        return this;
	    };
	    /**
	     * Sets the overlay height and clears any previously set height.
	     * @param value New height for the overlay
	     * @deprecated Pass the `height` through the `OverlayConfig`.
	     * @deletion-target 7.0.0
	     */
	    /**
	     * Sets the overlay height and clears any previously set height.
	     * @deprecated Pass the `height` through the `OverlayConfig`.
	     * \@deletion-target 7.0.0
	     * @param {?=} value New height for the overlay
	     * @return {?}
	     */
	    GlobalPositionStrategy.prototype.height = /**
	     * Sets the overlay height and clears any previously set height.
	     * @deprecated Pass the `height` through the `OverlayConfig`.
	     * \@deletion-target 7.0.0
	     * @param {?=} value New height for the overlay
	     * @return {?}
	     */
	    function (value) {
	        if (value === void 0) { value = ''; }
	        if (this._overlayRef) {
	            this._overlayRef.updateSize({ height: value });
	        }
	        else {
	            this._height = value;
	        }
	        return this;
	    };
	    /**
	     * Centers the overlay horizontally with an optional offset.
	     * Clears any previously set horizontal position.
	     *
	     * @param offset Overlay offset from the horizontal center.
	     */
	    /**
	     * Centers the overlay horizontally with an optional offset.
	     * Clears any previously set horizontal position.
	     *
	     * @param {?=} offset Overlay offset from the horizontal center.
	     * @return {?}
	     */
	    GlobalPositionStrategy.prototype.centerHorizontally = /**
	     * Centers the overlay horizontally with an optional offset.
	     * Clears any previously set horizontal position.
	     *
	     * @param {?=} offset Overlay offset from the horizontal center.
	     * @return {?}
	     */
	    function (offset) {
	        if (offset === void 0) { offset = ''; }
	        this.left(offset);
	        this._justifyContent = 'center';
	        return this;
	    };
	    /**
	     * Centers the overlay vertically with an optional offset.
	     * Clears any previously set vertical position.
	     *
	     * @param offset Overlay offset from the vertical center.
	     */
	    /**
	     * Centers the overlay vertically with an optional offset.
	     * Clears any previously set vertical position.
	     *
	     * @param {?=} offset Overlay offset from the vertical center.
	     * @return {?}
	     */
	    GlobalPositionStrategy.prototype.centerVertically = /**
	     * Centers the overlay vertically with an optional offset.
	     * Clears any previously set vertical position.
	     *
	     * @param {?=} offset Overlay offset from the vertical center.
	     * @return {?}
	     */
	    function (offset) {
	        if (offset === void 0) { offset = ''; }
	        this.top(offset);
	        this._alignItems = 'center';
	        return this;
	    };
	    /**
	     * Apply the position to the element.
	     * @docs-private
	     *
	     * @returns Resolved when the styles have been applied.
	     */
	    /**
	     * Apply the position to the element.
	     * \@docs-private
	     *
	     * @return {?} Resolved when the styles have been applied.
	     */
	    GlobalPositionStrategy.prototype.apply = /**
	     * Apply the position to the element.
	     * \@docs-private
	     *
	     * @return {?} Resolved when the styles have been applied.
	     */
	    function () {
	        // Since the overlay ref applies the strategy asynchronously, it could
	        // have been disposed before it ends up being applied. If that is the
	        // case, we shouldn't do anything.
	        if (!this._overlayRef.hasAttached()) {
	            return;
	        }
	        var /** @type {?} */ element = this._overlayRef.overlayElement;
	        if (!this._wrapper && element.parentNode) {
	            this._wrapper = this._document.createElement('div'); /** @type {?} */
	            ((this._wrapper)).classList.add('cdk-global-overlay-wrapper');
	            element.parentNode.insertBefore(/** @type {?} */ ((this._wrapper)), element); /** @type {?} */
	            ((this._wrapper)).appendChild(element);
	        }
	        var /** @type {?} */ styles = element.style;
	        var /** @type {?} */ parentStyles = (/** @type {?} */ (element.parentNode)).style;
	        var /** @type {?} */ config = this._overlayRef.getConfig();
	        styles.position = this._cssPosition;
	        styles.marginLeft = config.width === '100%' ? '0' : this._leftOffset;
	        styles.marginTop = config.height === '100%' ? '0' : this._topOffset;
	        styles.marginBottom = this._bottomOffset;
	        styles.marginRight = this._rightOffset;
	        parentStyles.justifyContent = config.width === '100%' ? 'flex-start' : this._justifyContent;
	        parentStyles.alignItems = config.height === '100%' ? 'flex-start' : this._alignItems;
	    };
	    /** Removes the wrapper element from the DOM. */
	    /**
	     * Removes the wrapper element from the DOM.
	     * @return {?}
	     */
	    GlobalPositionStrategy.prototype.dispose = /**
	     * Removes the wrapper element from the DOM.
	     * @return {?}
	     */
	    function () {
	        if (this._wrapper && this._wrapper.parentNode) {
	            this._wrapper.parentNode.removeChild(this._wrapper);
	            this._wrapper = null;
	        }
	    };
	    return GlobalPositionStrategy;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Builder for overlay position strategy.
	 */
	var OverlayPositionBuilder = /** @class */ (function () {
	    function OverlayPositionBuilder(_viewportRuler, _document) {
	        this._viewportRuler = _viewportRuler;
	        this._document = _document;
	    }
	    /**
	     * Creates a global position strategy.
	     */
	    /**
	     * Creates a global position strategy.
	     * @return {?}
	     */
	    OverlayPositionBuilder.prototype.global = /**
	     * Creates a global position strategy.
	     * @return {?}
	     */
	    function () {
	        return new GlobalPositionStrategy(this._document);
	    };
	    /**
	     * Creates a relative position strategy.
	     * @param elementRef
	     * @param originPos
	     * @param overlayPos
	     */
	    /**
	     * Creates a relative position strategy.
	     * @param {?} elementRef
	     * @param {?} originPos
	     * @param {?} overlayPos
	     * @return {?}
	     */
	    OverlayPositionBuilder.prototype.connectedTo = /**
	     * Creates a relative position strategy.
	     * @param {?} elementRef
	     * @param {?} originPos
	     * @param {?} overlayPos
	     * @return {?}
	     */
	    function (elementRef, originPos, overlayPos) {
	        return new ConnectedPositionStrategy(originPos, overlayPos, elementRef, this._viewportRuler, this._document);
	    };
	    OverlayPositionBuilder.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    OverlayPositionBuilder.ctorParameters = function () { return [
	        { type: _angular_cdk_scrolling.ViewportRuler, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    return OverlayPositionBuilder;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Service for dispatching keyboard events that land on the body to appropriate overlay ref,
	 * if any. It maintains a list of attached overlays to determine best suited overlay based
	 * on event target and order of overlay opens.
	 */
	var OverlayKeyboardDispatcher = /** @class */ (function () {
	    function OverlayKeyboardDispatcher(_document) {
	        this._document = _document;
	        /**
	         * Currently attached overlays in the order they were attached.
	         */
	        this._attachedOverlays = [];
	    }
	    /**
	     * @return {?}
	     */
	    OverlayKeyboardDispatcher.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._unsubscribeFromKeydownEvents();
	    };
	    /** Add a new overlay to the list of attached overlay refs. */
	    /**
	     * Add a new overlay to the list of attached overlay refs.
	     * @param {?} overlayRef
	     * @return {?}
	     */
	    OverlayKeyboardDispatcher.prototype.add = /**
	     * Add a new overlay to the list of attached overlay refs.
	     * @param {?} overlayRef
	     * @return {?}
	     */
	    function (overlayRef) {
	        // Lazily start dispatcher once first overlay is added
	        if (!this._keydownEventSubscription) {
	            this._subscribeToKeydownEvents();
	        }
	        this._attachedOverlays.push(overlayRef);
	    };
	    /** Remove an overlay from the list of attached overlay refs. */
	    /**
	     * Remove an overlay from the list of attached overlay refs.
	     * @param {?} overlayRef
	     * @return {?}
	     */
	    OverlayKeyboardDispatcher.prototype.remove = /**
	     * Remove an overlay from the list of attached overlay refs.
	     * @param {?} overlayRef
	     * @return {?}
	     */
	    function (overlayRef) {
	        var /** @type {?} */ index = this._attachedOverlays.indexOf(overlayRef);
	        if (index > -1) {
	            this._attachedOverlays.splice(index, 1);
	        }
	        // Remove the global listener once there are no more overlays.
	        if (this._attachedOverlays.length === 0) {
	            this._unsubscribeFromKeydownEvents();
	        }
	    };
	    /**
	     * Subscribe to keydown events that land on the body and dispatch those
	     * events to the appropriate overlay.
	     * @return {?}
	     */
	    OverlayKeyboardDispatcher.prototype._subscribeToKeydownEvents = /**
	     * Subscribe to keydown events that land on the body and dispatch those
	     * events to the appropriate overlay.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ bodyKeydownEvents = rxjs_observable_fromEvent.fromEvent(this._document.body, 'keydown', true);
	        this._keydownEventSubscription = bodyKeydownEvents.pipe(rxjs_operators_filter.filter(function () { return !!_this._attachedOverlays.length; })).subscribe(function (event) {
	            // Dispatch keydown event to the correct overlay.
	            // Dispatch keydown event to the correct overlay.
	            _this._selectOverlayFromEvent(event)._keydownEvents.next(event);
	        });
	    };
	    /**
	     * Removes the global keydown subscription.
	     * @return {?}
	     */
	    OverlayKeyboardDispatcher.prototype._unsubscribeFromKeydownEvents = /**
	     * Removes the global keydown subscription.
	     * @return {?}
	     */
	    function () {
	        if (this._keydownEventSubscription) {
	            this._keydownEventSubscription.unsubscribe();
	            this._keydownEventSubscription = null;
	        }
	    };
	    /**
	     * Select the appropriate overlay from a keydown event.
	     * @param {?} event
	     * @return {?}
	     */
	    OverlayKeyboardDispatcher.prototype._selectOverlayFromEvent = /**
	     * Select the appropriate overlay from a keydown event.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        // Check if any overlays contain the event
	        var /** @type {?} */ targetedOverlay = this._attachedOverlays.find(function (overlay) {
	            return overlay.overlayElement === event.target ||
	                overlay.overlayElement.contains(/** @type {?} */ (event.target));
	        });
	        // Use the overlay if it exists, otherwise choose the most recently attached one
	        return targetedOverlay || this._attachedOverlays[this._attachedOverlays.length - 1];
	    };
	    OverlayKeyboardDispatcher.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    OverlayKeyboardDispatcher.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    return OverlayKeyboardDispatcher;
	}());
	/**
	 * \@docs-private
	 * @param {?} dispatcher
	 * @param {?} _document
	 * @return {?}
	 */
	function OVERLAY_KEYBOARD_DISPATCHER_PROVIDER_FACTORY(dispatcher, _document) {
	    return dispatcher || new OverlayKeyboardDispatcher(_document);
	}
	/**
	 * \@docs-private
	 */
	var OVERLAY_KEYBOARD_DISPATCHER_PROVIDER = {
	    // If there is already an OverlayKeyboardDispatcher available, use that.
	    // Otherwise, provide a new one.
	    provide: OverlayKeyboardDispatcher,
	    deps: [
	        [new _angular_core.Optional(), new _angular_core.SkipSelf(), OverlayKeyboardDispatcher],
	        /** @type {?} */ (
	        // Coerce to `InjectionToken` so that the `deps` match the "shape"
	        // of the type expected by Angular
	        _angular_common.DOCUMENT)
	    ],
	    useFactory: OVERLAY_KEYBOARD_DISPATCHER_PROVIDER_FACTORY
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Container inside which all overlays will render.
	 */
	var OverlayContainer = /** @class */ (function () {
	    function OverlayContainer(_document) {
	        this._document = _document;
	    }
	    /**
	     * @return {?}
	     */
	    OverlayContainer.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        if (this._containerElement && this._containerElement.parentNode) {
	            this._containerElement.parentNode.removeChild(this._containerElement);
	        }
	    };
	    /**
	     * This method returns the overlay container element. It will lazily
	     * create the element the first time  it is called to facilitate using
	     * the container in non-browser environments.
	     * @returns the container element
	     */
	    /**
	     * This method returns the overlay container element. It will lazily
	     * create the element the first time  it is called to facilitate using
	     * the container in non-browser environments.
	     * @return {?} the container element
	     */
	    OverlayContainer.prototype.getContainerElement = /**
	     * This method returns the overlay container element. It will lazily
	     * create the element the first time  it is called to facilitate using
	     * the container in non-browser environments.
	     * @return {?} the container element
	     */
	    function () {
	        if (!this._containerElement) {
	            this._createContainer();
	        }
	        return this._containerElement;
	    };
	    /**
	     * Create the overlay container element, which is simply a div
	     * with the 'cdk-overlay-container' class on the document body.
	     */
	    /**
	     * Create the overlay container element, which is simply a div
	     * with the 'cdk-overlay-container' class on the document body.
	     * @return {?}
	     */
	    OverlayContainer.prototype._createContainer = /**
	     * Create the overlay container element, which is simply a div
	     * with the 'cdk-overlay-container' class on the document body.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ container = this._document.createElement('div');
	        container.classList.add('cdk-overlay-container');
	        this._document.body.appendChild(container);
	        this._containerElement = container;
	    };
	    OverlayContainer.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    OverlayContainer.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    return OverlayContainer;
	}());
	/**
	 * \@docs-private
	 * @param {?} parentContainer
	 * @param {?} _document
	 * @return {?}
	 */
	function OVERLAY_CONTAINER_PROVIDER_FACTORY(parentContainer, _document) {
	    return parentContainer || new OverlayContainer(_document);
	}
	/**
	 * \@docs-private
	 */
	var OVERLAY_CONTAINER_PROVIDER = {
	    // If there is already an OverlayContainer available, use that. Otherwise, provide a new one.
	    provide: OverlayContainer,
	    deps: [
	        [new _angular_core.Optional(), new _angular_core.SkipSelf(), OverlayContainer],
	        /** @type {?} */ (_angular_common.DOCUMENT // We need to use the InjectionToken somewhere to keep TS happy
	        ) // We need to use the InjectionToken somewhere to keep TS happy
	    ],
	    useFactory: OVERLAY_CONTAINER_PROVIDER_FACTORY
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Next overlay unique ID.
	 */
	var nextUniqueId = 0;
	/**
	 * Service to create Overlays. Overlays are dynamically added pieces of floating UI, meant to be
	 * used as a low-level building block for other components. Dialogs, tooltips, menus,
	 * selects, etc. can all be built using overlays. The service should primarily be used by authors
	 * of re-usable components rather than developers building end-user applications.
	 *
	 * An overlay *is* a PortalOutlet, so any kind of Portal can be loaded into one.
	 */
	var Overlay = /** @class */ (function () {
	    function Overlay(scrollStrategies, _overlayContainer, _componentFactoryResolver, _positionBuilder, _keyboardDispatcher, _appRef, _injector, _ngZone, _document) {
	        this.scrollStrategies = scrollStrategies;
	        this._overlayContainer = _overlayContainer;
	        this._componentFactoryResolver = _componentFactoryResolver;
	        this._positionBuilder = _positionBuilder;
	        this._keyboardDispatcher = _keyboardDispatcher;
	        this._appRef = _appRef;
	        this._injector = _injector;
	        this._ngZone = _ngZone;
	        this._document = _document;
	    }
	    /**
	     * Creates an overlay.
	     * @param config Configuration applied to the overlay.
	     * @returns Reference to the created overlay.
	     */
	    /**
	     * Creates an overlay.
	     * @param {?=} config Configuration applied to the overlay.
	     * @return {?} Reference to the created overlay.
	     */
	    Overlay.prototype.create = /**
	     * Creates an overlay.
	     * @param {?=} config Configuration applied to the overlay.
	     * @return {?} Reference to the created overlay.
	     */
	    function (config) {
	        var /** @type {?} */ pane = this._createPaneElement();
	        var /** @type {?} */ portalOutlet = this._createPortalOutlet(pane);
	        return new OverlayRef(portalOutlet, pane, new OverlayConfig(config), this._ngZone, this._keyboardDispatcher, this._document);
	    };
	    /**
	     * Gets a position builder that can be used, via fluent API,
	     * to construct and configure a position strategy.
	     * @returns An overlay position builder.
	     */
	    /**
	     * Gets a position builder that can be used, via fluent API,
	     * to construct and configure a position strategy.
	     * @return {?} An overlay position builder.
	     */
	    Overlay.prototype.position = /**
	     * Gets a position builder that can be used, via fluent API,
	     * to construct and configure a position strategy.
	     * @return {?} An overlay position builder.
	     */
	    function () {
	        return this._positionBuilder;
	    };
	    /**
	     * Creates the DOM element for an overlay and appends it to the overlay container.
	     * @return {?} Newly-created pane element
	     */
	    Overlay.prototype._createPaneElement = /**
	     * Creates the DOM element for an overlay and appends it to the overlay container.
	     * @return {?} Newly-created pane element
	     */
	    function () {
	        var /** @type {?} */ pane = this._document.createElement('div');
	        pane.id = "cdk-overlay-" + nextUniqueId++;
	        pane.classList.add('cdk-overlay-pane');
	        this._overlayContainer.getContainerElement().appendChild(pane);
	        return pane;
	    };
	    /**
	     * Create a DomPortalOutlet into which the overlay content can be loaded.
	     * @param {?} pane The DOM element to turn into a portal outlet.
	     * @return {?} A portal outlet for the given DOM element.
	     */
	    Overlay.prototype._createPortalOutlet = /**
	     * Create a DomPortalOutlet into which the overlay content can be loaded.
	     * @param {?} pane The DOM element to turn into a portal outlet.
	     * @return {?} A portal outlet for the given DOM element.
	     */
	    function (pane) {
	        return new _angular_cdk_portal.DomPortalOutlet(pane, this._componentFactoryResolver, this._appRef, this._injector);
	    };
	    Overlay.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    Overlay.ctorParameters = function () { return [
	        { type: ScrollStrategyOptions, },
	        { type: OverlayContainer, },
	        { type: _angular_core.ComponentFactoryResolver, },
	        { type: OverlayPositionBuilder, },
	        { type: OverlayKeyboardDispatcher, },
	        { type: _angular_core.ApplicationRef, },
	        { type: _angular_core.Injector, },
	        { type: _angular_core.NgZone, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    return Overlay;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Default set of positions for the overlay. Follows the behavior of a dropdown.
	 */
	var defaultPositionList = [
	    new ConnectionPositionPair({ originX: 'start', originY: 'bottom' }, { overlayX: 'start', overlayY: 'top' }),
	    new ConnectionPositionPair({ originX: 'start', originY: 'top' }, { overlayX: 'start', overlayY: 'bottom' }),
	    new ConnectionPositionPair({ originX: 'end', originY: 'top' }, { overlayX: 'end', overlayY: 'bottom' }),
	    new ConnectionPositionPair({ originX: 'end', originY: 'bottom' }, { overlayX: 'end', overlayY: 'top' }),
	];
	/**
	 * Injection token that determines the scroll handling while the connected overlay is open.
	 */
	var CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY = new _angular_core.InjectionToken('cdk-connected-overlay-scroll-strategy');
	/**
	 * \@docs-private
	 * @param {?} overlay
	 * @return {?}
	 */
	function CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY_PROVIDER_FACTORY(overlay) {
	    return function () { return overlay.scrollStrategies.reposition(); };
	}
	/**
	 * \@docs-private
	 */
	var CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY_PROVIDER = {
	    provide: CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY,
	    deps: [Overlay],
	    useFactory: CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY_PROVIDER_FACTORY,
	};
	/**
	 * Directive applied to an element to make it usable as an origin for an Overlay using a
	 * ConnectedPositionStrategy.
	 */
	var CdkOverlayOrigin = /** @class */ (function () {
	    function CdkOverlayOrigin(elementRef) {
	        this.elementRef = elementRef;
	    }
	    CdkOverlayOrigin.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]',
	                    exportAs: 'cdkOverlayOrigin',
	                },] },
	    ];
	    /** @nocollapse */
	    CdkOverlayOrigin.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	    ]; };
	    return CdkOverlayOrigin;
	}());
	/**
	 * Directive to facilitate declarative creation of an Overlay using a ConnectedPositionStrategy.
	 */
	var CdkConnectedOverlay = /** @class */ (function () {
	    // TODO(jelbourn): inputs for size, scroll behavior, animation, etc.
	    function CdkConnectedOverlay(_overlay, templateRef, viewContainerRef, _scrollStrategy, _dir) {
	        this._overlay = _overlay;
	        this._scrollStrategy = _scrollStrategy;
	        this._dir = _dir;
	        this._hasBackdrop = false;
	        this._lockPosition = false;
	        this._backdropSubscription = rxjs_Subscription.Subscription.EMPTY;
	        this._offsetX = 0;
	        this._offsetY = 0;
	        /**
	         * Strategy to be used when handling scroll events while the overlay is open.
	         */
	        this.scrollStrategy = this._scrollStrategy();
	        /**
	         * Whether the overlay is open.
	         */
	        this.open = false;
	        /**
	         * Event emitted when the backdrop is clicked.
	         */
	        this.backdropClick = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when the position has changed.
	         */
	        this.positionChange = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when the overlay has been attached.
	         */
	        this.attach = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when the overlay has been detached.
	         */
	        this.detach = new _angular_core.EventEmitter();
	        this._templatePortal = new _angular_cdk_portal.TemplatePortal(templateRef, viewContainerRef);
	    }
	    Object.defineProperty(CdkConnectedOverlay.prototype, "offsetX", {
	        get: /**
	         * The offset in pixels for the overlay connection point on the x-axis
	         * @return {?}
	         */
	        function () { return this._offsetX; },
	        set: /**
	         * @param {?} offsetX
	         * @return {?}
	         */
	        function (offsetX) {
	            this._offsetX = offsetX;
	            if (this._position) {
	                this._position.withOffsetX(offsetX);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkConnectedOverlay.prototype, "offsetY", {
	        get: /**
	         * The offset in pixels for the overlay connection point on the y-axis
	         * @return {?}
	         */
	        function () { return this._offsetY; },
	        set: /**
	         * @param {?} offsetY
	         * @return {?}
	         */
	        function (offsetY) {
	            this._offsetY = offsetY;
	            if (this._position) {
	                this._position.withOffsetY(offsetY);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkConnectedOverlay.prototype, "hasBackdrop", {
	        get: /**
	         * Whether or not the overlay should attach a backdrop.
	         * @return {?}
	         */
	        function () { return this._hasBackdrop; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._hasBackdrop = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkConnectedOverlay.prototype, "lockPosition", {
	        get: /**
	         * Whether or not the overlay should be locked when scrolling.
	         * @return {?}
	         */
	        function () { return this._lockPosition; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._lockPosition = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkConnectedOverlay.prototype, "_deprecatedOrigin", {
	        get: /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this.origin; },
	        set: /**
	         * @param {?} _origin
	         * @return {?}
	         */
	        function (_origin) { this.origin = _origin; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkConnectedOverlay.prototype, "_deprecatedPositions", {
	        get: /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this.positions; },
	        set: /**
	         * @param {?} _positions
	         * @return {?}
	         */
	        function (_positions) { this.positions = _positions; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkConnectedOverlay.prototype, "_deprecatedOffsetX", {
	        get: /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this.offsetX; },
	        set: /**
	         * @param {?} _offsetX
	         * @return {?}
	         */
	        function (_offsetX) { this.offsetX = _offsetX; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkConnectedOverlay.prototype, "_deprecatedOffsetY", {
	        get: /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this.offsetY; },
	        set: /**
	         * @param {?} _offsetY
	         * @return {?}
	         */
	        function (_offsetY) { this.offsetY = _offsetY; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkConnectedOverlay.prototype, "_deprecatedWidth", {
	        get: /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this.width; },
	        set: /**
	         * @param {?} _width
	         * @return {?}
	         */
	        function (_width) { this.width = _width; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkConnectedOverlay.prototype, "_deprecatedHeight", {
	        get: /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this.height; },
	        set: /**
	         * @param {?} _height
	         * @return {?}
	         */
	        function (_height) { this.height = _height; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkConnectedOverlay.prototype, "_deprecatedMinWidth", {
	        get: /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this.minWidth; },
	        set: /**
	         * @param {?} _minWidth
	         * @return {?}
	         */
	        function (_minWidth) { this.minWidth = _minWidth; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkConnectedOverlay.prototype, "_deprecatedMinHeight", {
	        get: /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this.minHeight; },
	        set: /**
	         * @param {?} _minHeight
	         * @return {?}
	         */
	        function (_minHeight) { this.minHeight = _minHeight; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkConnectedOverlay.prototype, "_deprecatedBackdropClass", {
	        get: /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this.backdropClass; },
	        set: /**
	         * @param {?} _backdropClass
	         * @return {?}
	         */
	        function (_backdropClass) { this.backdropClass = _backdropClass; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkConnectedOverlay.prototype, "_deprecatedScrollStrategy", {
	        get: /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this.scrollStrategy; },
	        set: /**
	         * @param {?} _scrollStrategy
	         * @return {?}
	         */
	        function (_scrollStrategy) {
	            this.scrollStrategy = _scrollStrategy;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkConnectedOverlay.prototype, "_deprecatedOpen", {
	        get: /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this.open; },
	        set: /**
	         * @param {?} _open
	         * @return {?}
	         */
	        function (_open) { this.open = _open; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkConnectedOverlay.prototype, "_deprecatedHasBackdrop", {
	        get: /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this.hasBackdrop; },
	        set: /**
	         * @param {?} _hasBackdrop
	         * @return {?}
	         */
	        function (_hasBackdrop) { this.hasBackdrop = _hasBackdrop; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkConnectedOverlay.prototype, "overlayRef", {
	        /** The associated overlay reference. */
	        get: /**
	         * The associated overlay reference.
	         * @return {?}
	         */
	        function () {
	            return this._overlayRef;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkConnectedOverlay.prototype, "dir", {
	        /** The element's layout direction. */
	        get: /**
	         * The element's layout direction.
	         * @return {?}
	         */
	        function () {
	            return this._dir ? this._dir.value : 'ltr';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    CdkConnectedOverlay.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._destroyOverlay();
	    };
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    CdkConnectedOverlay.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        if (this._position) {
	            if (changes['positions'] || changes['_deprecatedPositions']) {
	                this._position.withPositions(this.positions);
	            }
	            if (changes['lockPosition']) {
	                this._position.withLockedPosition(this.lockPosition);
	            }
	            if (changes['origin'] || changes['_deprecatedOrigin']) {
	                this._position.setOrigin(this.origin.elementRef);
	                if (this.open) {
	                    this._position.apply();
	                }
	            }
	        }
	        if (changes['open'] || changes['_deprecatedOpen']) {
	            this.open ? this._attachOverlay() : this._detachOverlay();
	        }
	    };
	    /**
	     * Creates an overlay
	     * @return {?}
	     */
	    CdkConnectedOverlay.prototype._createOverlay = /**
	     * Creates an overlay
	     * @return {?}
	     */
	    function () {
	        if (!this.positions || !this.positions.length) {
	            this.positions = defaultPositionList;
	        }
	        this._overlayRef = this._overlay.create(this._buildConfig());
	    };
	    /**
	     * Builds the overlay config based on the directive's inputs
	     * @return {?}
	     */
	    CdkConnectedOverlay.prototype._buildConfig = /**
	     * Builds the overlay config based on the directive's inputs
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ positionStrategy = this._position = this._createPositionStrategy();
	        var /** @type {?} */ overlayConfig = new OverlayConfig({
	            positionStrategy: positionStrategy,
	            scrollStrategy: this.scrollStrategy,
	            hasBackdrop: this.hasBackdrop
	        });
	        if (this.width || this.width === 0) {
	            overlayConfig.width = this.width;
	        }
	        if (this.height || this.height === 0) {
	            overlayConfig.height = this.height;
	        }
	        if (this.minWidth || this.minWidth === 0) {
	            overlayConfig.minWidth = this.minWidth;
	        }
	        if (this.minHeight || this.minHeight === 0) {
	            overlayConfig.minHeight = this.minHeight;
	        }
	        if (this.backdropClass) {
	            overlayConfig.backdropClass = this.backdropClass;
	        }
	        return overlayConfig;
	    };
	    /**
	     * Returns the position strategy of the overlay to be set on the overlay config
	     * @return {?}
	     */
	    CdkConnectedOverlay.prototype._createPositionStrategy = /**
	     * Returns the position strategy of the overlay to be set on the overlay config
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ primaryPosition = this.positions[0];
	        var /** @type {?} */ originPoint = { originX: primaryPosition.originX, originY: primaryPosition.originY };
	        var /** @type {?} */ overlayPoint = { overlayX: primaryPosition.overlayX, overlayY: primaryPosition.overlayY };
	        var /** @type {?} */ strategy = this._overlay.position()
	            .connectedTo(this.origin.elementRef, originPoint, overlayPoint)
	            .withOffsetX(this.offsetX)
	            .withOffsetY(this.offsetY)
	            .withLockedPosition(this.lockPosition);
	        for (var /** @type {?} */ i = 1; i < this.positions.length; i++) {
	            strategy.withFallbackPosition({ originX: this.positions[i].originX, originY: this.positions[i].originY }, { overlayX: this.positions[i].overlayX, overlayY: this.positions[i].overlayY });
	        }
	        strategy.onPositionChange.subscribe(function (pos) { return _this.positionChange.emit(pos); });
	        return strategy;
	    };
	    /**
	     * Attaches the overlay and subscribes to backdrop clicks if backdrop exists
	     * @return {?}
	     */
	    CdkConnectedOverlay.prototype._attachOverlay = /**
	     * Attaches the overlay and subscribes to backdrop clicks if backdrop exists
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (!this._overlayRef) {
	            this._createOverlay(); /** @type {?} */
	            ((this._overlayRef)).keydownEvents().subscribe(function (event) {
	                if (event.keyCode === _angular_cdk_keycodes.ESCAPE) {
	                    _this._detachOverlay();
	                }
	            });
	        }
	        else {
	            // Update the overlay size, in case the directive's inputs have changed
	            this._overlayRef.updateSize({
	                width: this.width,
	                minWidth: this.minWidth,
	                height: this.height,
	                minHeight: this.minHeight,
	            });
	        }
	        this._position.withDirection(this.dir);
	        this._overlayRef.setDirection(this.dir);
	        if (!this._overlayRef.hasAttached()) {
	            this._overlayRef.attach(this._templatePortal);
	            this.attach.emit();
	        }
	        if (this.hasBackdrop) {
	            this._backdropSubscription = this._overlayRef.backdropClick().subscribe(function (event) {
	                _this.backdropClick.emit(event);
	            });
	        }
	    };
	    /**
	     * Detaches the overlay and unsubscribes to backdrop clicks if backdrop exists
	     * @return {?}
	     */
	    CdkConnectedOverlay.prototype._detachOverlay = /**
	     * Detaches the overlay and unsubscribes to backdrop clicks if backdrop exists
	     * @return {?}
	     */
	    function () {
	        if (this._overlayRef) {
	            this._overlayRef.detach();
	            this.detach.emit();
	        }
	        this._backdropSubscription.unsubscribe();
	    };
	    /**
	     * Destroys the overlay created by this directive.
	     * @return {?}
	     */
	    CdkConnectedOverlay.prototype._destroyOverlay = /**
	     * Destroys the overlay created by this directive.
	     * @return {?}
	     */
	    function () {
	        if (this._overlayRef) {
	            this._overlayRef.dispose();
	        }
	        this._backdropSubscription.unsubscribe();
	    };
	    CdkConnectedOverlay.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[cdk-connected-overlay], [connected-overlay], [cdkConnectedOverlay]',
	                    exportAs: 'cdkConnectedOverlay'
	                },] },
	    ];
	    /** @nocollapse */
	    CdkConnectedOverlay.ctorParameters = function () { return [
	        { type: Overlay, },
	        { type: _angular_core.TemplateRef, },
	        { type: _angular_core.ViewContainerRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY,] },] },
	        { type: _angular_cdk_bidi.Directionality, decorators: [{ type: _angular_core.Optional },] },
	    ]; };
	    CdkConnectedOverlay.propDecorators = {
	        "origin": [{ type: _angular_core.Input, args: ['cdkConnectedOverlayOrigin',] },],
	        "positions": [{ type: _angular_core.Input, args: ['cdkConnectedOverlayPositions',] },],
	        "offsetX": [{ type: _angular_core.Input, args: ['cdkConnectedOverlayOffsetX',] },],
	        "offsetY": [{ type: _angular_core.Input, args: ['cdkConnectedOverlayOffsetY',] },],
	        "width": [{ type: _angular_core.Input, args: ['cdkConnectedOverlayWidth',] },],
	        "height": [{ type: _angular_core.Input, args: ['cdkConnectedOverlayHeight',] },],
	        "minWidth": [{ type: _angular_core.Input, args: ['cdkConnectedOverlayMinWidth',] },],
	        "minHeight": [{ type: _angular_core.Input, args: ['cdkConnectedOverlayMinHeight',] },],
	        "backdropClass": [{ type: _angular_core.Input, args: ['cdkConnectedOverlayBackdropClass',] },],
	        "scrollStrategy": [{ type: _angular_core.Input, args: ['cdkConnectedOverlayScrollStrategy',] },],
	        "open": [{ type: _angular_core.Input, args: ['cdkConnectedOverlayOpen',] },],
	        "hasBackdrop": [{ type: _angular_core.Input, args: ['cdkConnectedOverlayHasBackdrop',] },],
	        "lockPosition": [{ type: _angular_core.Input, args: ['cdkConnectedOverlayLockPosition',] },],
	        "_deprecatedOrigin": [{ type: _angular_core.Input, args: ['origin',] },],
	        "_deprecatedPositions": [{ type: _angular_core.Input, args: ['positions',] },],
	        "_deprecatedOffsetX": [{ type: _angular_core.Input, args: ['offsetX',] },],
	        "_deprecatedOffsetY": [{ type: _angular_core.Input, args: ['offsetY',] },],
	        "_deprecatedWidth": [{ type: _angular_core.Input, args: ['width',] },],
	        "_deprecatedHeight": [{ type: _angular_core.Input, args: ['height',] },],
	        "_deprecatedMinWidth": [{ type: _angular_core.Input, args: ['minWidth',] },],
	        "_deprecatedMinHeight": [{ type: _angular_core.Input, args: ['minHeight',] },],
	        "_deprecatedBackdropClass": [{ type: _angular_core.Input, args: ['backdropClass',] },],
	        "_deprecatedScrollStrategy": [{ type: _angular_core.Input, args: ['scrollStrategy',] },],
	        "_deprecatedOpen": [{ type: _angular_core.Input, args: ['open',] },],
	        "_deprecatedHasBackdrop": [{ type: _angular_core.Input, args: ['hasBackdrop',] },],
	        "backdropClick": [{ type: _angular_core.Output },],
	        "positionChange": [{ type: _angular_core.Output },],
	        "attach": [{ type: _angular_core.Output },],
	        "detach": [{ type: _angular_core.Output },],
	    };
	    return CdkConnectedOverlay;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var OVERLAY_PROVIDERS = [
	    Overlay,
	    OverlayPositionBuilder,
	    OVERLAY_KEYBOARD_DISPATCHER_PROVIDER,
	    _angular_cdk_scrolling.VIEWPORT_RULER_PROVIDER,
	    OVERLAY_CONTAINER_PROVIDER,
	    CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY_PROVIDER,
	];
	var OverlayModule = /** @class */ (function () {
	    function OverlayModule() {
	    }
	    OverlayModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [_angular_cdk_bidi.BidiModule, _angular_cdk_portal.PortalModule, _angular_cdk_scrolling.ScrollDispatchModule],
	                    exports: [CdkConnectedOverlay, CdkOverlayOrigin, _angular_cdk_scrolling.ScrollDispatchModule],
	                    declarations: [CdkConnectedOverlay, CdkOverlayOrigin],
	                    providers: [OVERLAY_PROVIDERS, ScrollStrategyOptions],
	                },] },
	    ];
	    /** @nocollapse */
	    OverlayModule.ctorParameters = function () { return []; };
	    return OverlayModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Alternative to OverlayContainer that supports correct displaying of overlay elements in
	 * Fullscreen mode
	 * https://developer.mozilla.org/en-US/docs/Web/API/Element/requestFullScreen
	 *
	 * Should be provided in the root component.
	 */
	var FullscreenOverlayContainer = /** @class */ (function (_super) {
	    __extends(FullscreenOverlayContainer, _super);
	    function FullscreenOverlayContainer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @return {?}
	     */
	    FullscreenOverlayContainer.prototype._createContainer = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        _super.prototype._createContainer.call(this);
	        this._adjustParentForFullscreenChange();
	        this._addFullscreenChangeListener(function () { return _this._adjustParentForFullscreenChange(); });
	    };
	    /**
	     * @return {?}
	     */
	    FullscreenOverlayContainer.prototype._adjustParentForFullscreenChange = /**
	     * @return {?}
	     */
	    function () {
	        if (!this._containerElement) {
	            return;
	        }
	        var /** @type {?} */ fullscreenElement = this.getFullscreenElement();
	        var /** @type {?} */ parent = fullscreenElement || document.body;
	        parent.appendChild(this._containerElement);
	    };
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    FullscreenOverlayContainer.prototype._addFullscreenChangeListener = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        if (document.fullscreenEnabled) {
	            document.addEventListener('fullscreenchange', fn);
	        }
	        else if (document.webkitFullscreenEnabled) {
	            document.addEventListener('webkitfullscreenchange', fn);
	        }
	        else if ((/** @type {?} */ (document)).mozFullScreenEnabled) {
	            document.addEventListener('mozfullscreenchange', fn);
	        }
	        else if ((/** @type {?} */ (document)).msFullscreenEnabled) {
	            document.addEventListener('MSFullscreenChange', fn);
	        }
	    };
	    /**
	     * When the page is put into fullscreen mode, a specific element is specified.
	     * Only that element and its children are visible when in fullscreen mode.
	     */
	    /**
	     * When the page is put into fullscreen mode, a specific element is specified.
	     * Only that element and its children are visible when in fullscreen mode.
	     * @return {?}
	     */
	    FullscreenOverlayContainer.prototype.getFullscreenElement = /**
	     * When the page is put into fullscreen mode, a specific element is specified.
	     * Only that element and its children are visible when in fullscreen mode.
	     * @return {?}
	     */
	    function () {
	        return document.fullscreenElement ||
	            document.webkitFullscreenElement ||
	            (/** @type {?} */ (document)).mozFullScreenElement ||
	            (/** @type {?} */ (document)).msFullscreenElement ||
	            null;
	    };
	    FullscreenOverlayContainer.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    FullscreenOverlayContainer.ctorParameters = function () { return []; };
	    return FullscreenOverlayContainer;
	}(OverlayContainer));
	
	exports.Overlay = Overlay;
	exports.OverlayContainer = OverlayContainer;
	exports.CdkOverlayOrigin = CdkOverlayOrigin;
	exports.CdkConnectedOverlay = CdkConnectedOverlay;
	exports.FullscreenOverlayContainer = FullscreenOverlayContainer;
	exports.OverlayRef = OverlayRef;
	exports.ViewportRuler = _angular_cdk_scrolling.ViewportRuler;
	exports.OverlayKeyboardDispatcher = OverlayKeyboardDispatcher;
	exports.OverlayPositionBuilder = OverlayPositionBuilder;
	exports.GlobalPositionStrategy = GlobalPositionStrategy;
	exports.ConnectedPositionStrategy = ConnectedPositionStrategy;
	exports.VIEWPORT_RULER_PROVIDER = _angular_cdk_scrolling.VIEWPORT_RULER_PROVIDER;
	exports.ConnectedOverlayDirective = CdkConnectedOverlay;
	exports.OverlayOrigin = CdkOverlayOrigin;
	exports.OverlayConfig = OverlayConfig;
	exports.ConnectionPositionPair = ConnectionPositionPair;
	exports.ScrollingVisibility = ScrollingVisibility;
	exports.ConnectedOverlayPositionChange = ConnectedOverlayPositionChange;
	exports.CdkScrollable = _angular_cdk_scrolling.CdkScrollable;
	exports.ScrollDispatcher = _angular_cdk_scrolling.ScrollDispatcher;
	exports.ScrollStrategyOptions = ScrollStrategyOptions;
	exports.RepositionScrollStrategy = RepositionScrollStrategy;
	exports.CloseScrollStrategy = CloseScrollStrategy;
	exports.NoopScrollStrategy = NoopScrollStrategy;
	exports.BlockScrollStrategy = BlockScrollStrategy;
	exports.OVERLAY_PROVIDERS = OVERLAY_PROVIDERS;
	exports.OverlayModule = OverlayModule;
	exports.ɵg = OVERLAY_KEYBOARD_DISPATCHER_PROVIDER;
	exports.ɵf = OVERLAY_KEYBOARD_DISPATCHER_PROVIDER_FACTORY;
	exports.ɵb = OVERLAY_CONTAINER_PROVIDER;
	exports.ɵa = OVERLAY_CONTAINER_PROVIDER_FACTORY;
	exports.ɵc = CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY;
	exports.ɵe = CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY_PROVIDER;
	exports.ɵd = CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY_PROVIDER_FACTORY;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=cdk-overlay.umd.js.map


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(1078), __webpack_require__(240), __webpack_require__(206), __webpack_require__(253), __webpack_require__(327), __webpack_require__(490), __webpack_require__(298), __webpack_require__(222)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@angular/cdk/platform', 'rxjs/Subject', 'rxjs/Observable', 'rxjs/observable/of', 'rxjs/observable/fromEvent', 'rxjs/operators/auditTime', 'rxjs/operators/filter', 'rxjs/observable/merge'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.cdk = global.ng.cdk || {}, global.ng.cdk.scrolling = global.ng.cdk.scrolling || {}),global.ng.core,global.ng.cdk.platform,global.Rx,global.Rx,global.Rx.Observable,global.Rx.Observable,global.Rx.operators,global.Rx.operators,global.Rx.Observable));
	}(this, (function (exports,_angular_core,_angular_cdk_platform,rxjs_Subject,rxjs_Observable,rxjs_observable_of,rxjs_observable_fromEvent,rxjs_operators_auditTime,rxjs_operators_filter,rxjs_observable_merge) { 'use strict';
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Time in ms to throttle the scrolling events by default.
	 */
	var DEFAULT_SCROLL_TIME = 20;
	/**
	 * Service contained all registered Scrollable references and emits an event when any one of the
	 * Scrollable references emit a scrolled event.
	 */
	var ScrollDispatcher = /** @class */ (function () {
	    function ScrollDispatcher(_ngZone, _platform) {
	        this._ngZone = _ngZone;
	        this._platform = _platform;
	        /**
	         * Subject for notifying that a registered scrollable reference element has been scrolled.
	         */
	        this._scrolled = new rxjs_Subject.Subject();
	        /**
	         * Keeps track of the global `scroll` and `resize` subscriptions.
	         */
	        this._globalSubscription = null;
	        /**
	         * Keeps track of the amount of subscriptions to `scrolled`. Used for cleaning up afterwards.
	         */
	        this._scrolledCount = 0;
	        /**
	         * Map of all the scrollable references that are registered with the service and their
	         * scroll event subscriptions.
	         */
	        this.scrollContainers = new Map();
	    }
	    /**
	     * Registers a scrollable instance with the service and listens for its scrolled events. When the
	     * scrollable is scrolled, the service emits the event to its scrolled observable.
	     * @param scrollable Scrollable instance to be registered.
	     */
	    /**
	     * Registers a scrollable instance with the service and listens for its scrolled events. When the
	     * scrollable is scrolled, the service emits the event to its scrolled observable.
	     * @param {?} scrollable Scrollable instance to be registered.
	     * @return {?}
	     */
	    ScrollDispatcher.prototype.register = /**
	     * Registers a scrollable instance with the service and listens for its scrolled events. When the
	     * scrollable is scrolled, the service emits the event to its scrolled observable.
	     * @param {?} scrollable Scrollable instance to be registered.
	     * @return {?}
	     */
	    function (scrollable) {
	        var _this = this;
	        var /** @type {?} */ scrollSubscription = scrollable.elementScrolled()
	            .subscribe(function () { return _this._scrolled.next(scrollable); });
	        this.scrollContainers.set(scrollable, scrollSubscription);
	    };
	    /**
	     * Deregisters a Scrollable reference and unsubscribes from its scroll event observable.
	     * @param scrollable Scrollable instance to be deregistered.
	     */
	    /**
	     * Deregisters a Scrollable reference and unsubscribes from its scroll event observable.
	     * @param {?} scrollable Scrollable instance to be deregistered.
	     * @return {?}
	     */
	    ScrollDispatcher.prototype.deregister = /**
	     * Deregisters a Scrollable reference and unsubscribes from its scroll event observable.
	     * @param {?} scrollable Scrollable instance to be deregistered.
	     * @return {?}
	     */
	    function (scrollable) {
	        var /** @type {?} */ scrollableReference = this.scrollContainers.get(scrollable);
	        if (scrollableReference) {
	            scrollableReference.unsubscribe();
	            this.scrollContainers.delete(scrollable);
	        }
	    };
	    /**
	     * Returns an observable that emits an event whenever any of the registered Scrollable
	     * references (or window, document, or body) fire a scrolled event. Can provide a time in ms
	     * to override the default "throttle" time.
	     *
	     * **Note:** in order to avoid hitting change detection for every scroll event,
	     * all of the events emitted from this stream will be run outside the Angular zone.
	     * If you need to update any data bindings as a result of a scroll event, you have
	     * to run the callback using `NgZone.run`.
	     */
	    /**
	     * Returns an observable that emits an event whenever any of the registered Scrollable
	     * references (or window, document, or body) fire a scrolled event. Can provide a time in ms
	     * to override the default "throttle" time.
	     *
	     * **Note:** in order to avoid hitting change detection for every scroll event,
	     * all of the events emitted from this stream will be run outside the Angular zone.
	     * If you need to update any data bindings as a result of a scroll event, you have
	     * to run the callback using `NgZone.run`.
	     * @param {?=} auditTimeInMs
	     * @return {?}
	     */
	    ScrollDispatcher.prototype.scrolled = /**
	     * Returns an observable that emits an event whenever any of the registered Scrollable
	     * references (or window, document, or body) fire a scrolled event. Can provide a time in ms
	     * to override the default "throttle" time.
	     *
	     * **Note:** in order to avoid hitting change detection for every scroll event,
	     * all of the events emitted from this stream will be run outside the Angular zone.
	     * If you need to update any data bindings as a result of a scroll event, you have
	     * to run the callback using `NgZone.run`.
	     * @param {?=} auditTimeInMs
	     * @return {?}
	     */
	    function (auditTimeInMs) {
	        var _this = this;
	        if (auditTimeInMs === void 0) { auditTimeInMs = DEFAULT_SCROLL_TIME; }
	        return this._platform.isBrowser ? rxjs_Observable.Observable.create(function (observer) {
	            if (!_this._globalSubscription) {
	                _this._addGlobalListener();
	            }
	            // In the case of a 0ms delay, use an observable without auditTime
	            // since it does add a perceptible delay in processing overhead.
	            var /** @type {?} */ subscription = auditTimeInMs > 0 ?
	                _this._scrolled.pipe(rxjs_operators_auditTime.auditTime(auditTimeInMs)).subscribe(observer) :
	                _this._scrolled.subscribe(observer);
	            _this._scrolledCount++;
	            return function () {
	                subscription.unsubscribe();
	                _this._scrolledCount--;
	                if (!_this._scrolledCount) {
	                    _this._removeGlobalListener();
	                }
	            };
	        }) : rxjs_observable_of.of();
	    };
	    /**
	     * @return {?}
	     */
	    ScrollDispatcher.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._removeGlobalListener();
	        this.scrollContainers.forEach(function (_, container) { return _this.deregister(container); });
	    };
	    /**
	     * Returns an observable that emits whenever any of the
	     * scrollable ancestors of an element are scrolled.
	     * @param elementRef Element whose ancestors to listen for.
	     * @param auditTimeInMs Time to throttle the scroll events.
	     */
	    /**
	     * Returns an observable that emits whenever any of the
	     * scrollable ancestors of an element are scrolled.
	     * @param {?} elementRef Element whose ancestors to listen for.
	     * @param {?=} auditTimeInMs Time to throttle the scroll events.
	     * @return {?}
	     */
	    ScrollDispatcher.prototype.ancestorScrolled = /**
	     * Returns an observable that emits whenever any of the
	     * scrollable ancestors of an element are scrolled.
	     * @param {?} elementRef Element whose ancestors to listen for.
	     * @param {?=} auditTimeInMs Time to throttle the scroll events.
	     * @return {?}
	     */
	    function (elementRef, auditTimeInMs) {
	        var /** @type {?} */ ancestors = this.getAncestorScrollContainers(elementRef);
	        return this.scrolled(auditTimeInMs).pipe(rxjs_operators_filter.filter(function (target) {
	            return !target || ancestors.indexOf(target) > -1;
	        }));
	    };
	    /** Returns all registered Scrollables that contain the provided element. */
	    /**
	     * Returns all registered Scrollables that contain the provided element.
	     * @param {?} elementRef
	     * @return {?}
	     */
	    ScrollDispatcher.prototype.getAncestorScrollContainers = /**
	     * Returns all registered Scrollables that contain the provided element.
	     * @param {?} elementRef
	     * @return {?}
	     */
	    function (elementRef) {
	        var _this = this;
	        var /** @type {?} */ scrollingContainers = [];
	        this.scrollContainers.forEach(function (_subscription, scrollable) {
	            if (_this._scrollableContainsElement(scrollable, elementRef)) {
	                scrollingContainers.push(scrollable);
	            }
	        });
	        return scrollingContainers;
	    };
	    /**
	     * Returns true if the element is contained within the provided Scrollable.
	     * @param {?} scrollable
	     * @param {?} elementRef
	     * @return {?}
	     */
	    ScrollDispatcher.prototype._scrollableContainsElement = /**
	     * Returns true if the element is contained within the provided Scrollable.
	     * @param {?} scrollable
	     * @param {?} elementRef
	     * @return {?}
	     */
	    function (scrollable, elementRef) {
	        var /** @type {?} */ element = elementRef.nativeElement;
	        var /** @type {?} */ scrollableElement = scrollable.getElementRef().nativeElement;
	        // Traverse through the element parents until we reach null, checking if any of the elements
	        // are the scrollable's element.
	        do {
	            if (element == scrollableElement) {
	                return true;
	            }
	        } while (element = element.parentElement);
	        return false;
	    };
	    /**
	     * Sets up the global scroll listeners.
	     * @return {?}
	     */
	    ScrollDispatcher.prototype._addGlobalListener = /**
	     * Sets up the global scroll listeners.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._globalSubscription = this._ngZone.runOutsideAngular(function () {
	            return rxjs_observable_fromEvent.fromEvent(window.document, 'scroll').subscribe(function () { return _this._scrolled.next(); });
	        });
	    };
	    /**
	     * Cleans up the global scroll listener.
	     * @return {?}
	     */
	    ScrollDispatcher.prototype._removeGlobalListener = /**
	     * Cleans up the global scroll listener.
	     * @return {?}
	     */
	    function () {
	        if (this._globalSubscription) {
	            this._globalSubscription.unsubscribe();
	            this._globalSubscription = null;
	        }
	    };
	    ScrollDispatcher.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    ScrollDispatcher.ctorParameters = function () { return [
	        { type: _angular_core.NgZone, },
	        { type: _angular_cdk_platform.Platform, },
	    ]; };
	    return ScrollDispatcher;
	}());
	/**
	 * \@docs-private
	 * @param {?} parentDispatcher
	 * @param {?} ngZone
	 * @param {?} platform
	 * @return {?}
	 */
	function SCROLL_DISPATCHER_PROVIDER_FACTORY(parentDispatcher, ngZone, platform) {
	    return parentDispatcher || new ScrollDispatcher(ngZone, platform);
	}
	/**
	 * \@docs-private
	 */
	var SCROLL_DISPATCHER_PROVIDER = {
	    // If there is already a ScrollDispatcher available, use that. Otherwise, provide a new one.
	    provide: ScrollDispatcher,
	    deps: [[new _angular_core.Optional(), new _angular_core.SkipSelf(), ScrollDispatcher], _angular_core.NgZone, _angular_cdk_platform.Platform],
	    useFactory: SCROLL_DISPATCHER_PROVIDER_FACTORY
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Sends an event when the directive's element is scrolled. Registers itself with the
	 * ScrollDispatcher service to include itself as part of its collection of scrolling events that it
	 * can be listened to through the service.
	 */
	var CdkScrollable = /** @class */ (function () {
	    function CdkScrollable(_elementRef, _scroll, _ngZone) {
	        var _this = this;
	        this._elementRef = _elementRef;
	        this._scroll = _scroll;
	        this._ngZone = _ngZone;
	        this._elementScrolled = new rxjs_Subject.Subject();
	        this._scrollListener = function (event) { return _this._elementScrolled.next(event); };
	    }
	    /**
	     * @return {?}
	     */
	    CdkScrollable.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._ngZone.runOutsideAngular(function () {
	            _this.getElementRef().nativeElement.addEventListener('scroll', _this._scrollListener);
	        });
	        this._scroll.register(this);
	    };
	    /**
	     * @return {?}
	     */
	    CdkScrollable.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._scroll.deregister(this);
	        if (this._scrollListener) {
	            this.getElementRef().nativeElement.removeEventListener('scroll', this._scrollListener);
	        }
	    };
	    /**
	     * Returns observable that emits when a scroll event is fired on the host element.
	     */
	    /**
	     * Returns observable that emits when a scroll event is fired on the host element.
	     * @return {?}
	     */
	    CdkScrollable.prototype.elementScrolled = /**
	     * Returns observable that emits when a scroll event is fired on the host element.
	     * @return {?}
	     */
	    function () {
	        return this._elementScrolled.asObservable();
	    };
	    /**
	     * @return {?}
	     */
	    CdkScrollable.prototype.getElementRef = /**
	     * @return {?}
	     */
	    function () {
	        return this._elementRef;
	    };
	    CdkScrollable.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[cdk-scrollable], [cdkScrollable]'
	                },] },
	    ];
	    /** @nocollapse */
	    CdkScrollable.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: ScrollDispatcher, },
	        { type: _angular_core.NgZone, },
	    ]; };
	    return CdkScrollable;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Time in ms to throttle the resize events by default.
	 */
	var DEFAULT_RESIZE_TIME = 20;
	/**
	 * Simple utility for getting the bounds of the browser viewport.
	 * \@docs-private
	 */
	var ViewportRuler = /** @class */ (function () {
	    function ViewportRuler(_platform, ngZone) {
	        var _this = this;
	        this._platform = _platform;
	        this._change = _platform.isBrowser ? ngZone.runOutsideAngular(function () {
	            return rxjs_observable_merge.merge(rxjs_observable_fromEvent.fromEvent(window, 'resize'), rxjs_observable_fromEvent.fromEvent(window, 'orientationchange'));
	        }) : rxjs_observable_of.of();
	        this._invalidateCache = this.change().subscribe(function () { return _this._updateViewportSize(); });
	    }
	    /**
	     * @return {?}
	     */
	    ViewportRuler.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._invalidateCache.unsubscribe();
	    };
	    /** Returns the viewport's width and height. */
	    /**
	     * Returns the viewport's width and height.
	     * @return {?}
	     */
	    ViewportRuler.prototype.getViewportSize = /**
	     * Returns the viewport's width and height.
	     * @return {?}
	     */
	    function () {
	        if (!this._viewportSize) {
	            this._updateViewportSize();
	        }
	        var /** @type {?} */ output = { width: this._viewportSize.width, height: this._viewportSize.height };
	        // If we're not on a browser, don't cache the size since it'll be mocked out anyway.
	        if (!this._platform.isBrowser) {
	            this._viewportSize = /** @type {?} */ ((null));
	        }
	        return output;
	    };
	    /** Gets a ClientRect for the viewport's bounds. */
	    /**
	     * Gets a ClientRect for the viewport's bounds.
	     * @return {?}
	     */
	    ViewportRuler.prototype.getViewportRect = /**
	     * Gets a ClientRect for the viewport's bounds.
	     * @return {?}
	     */
	    function () {
	        // Use the document element's bounding rect rather than the window scroll properties
	        // (e.g. pageYOffset, scrollY) due to in issue in Chrome and IE where window scroll
	        // properties and client coordinates (boundingClientRect, clientX/Y, etc.) are in different
	        // conceptual viewports. Under most circumstances these viewports are equivalent, but they
	        // can disagree when the page is pinch-zoomed (on devices that support touch).
	        // See https://bugs.chromium.org/p/chromium/issues/detail?id=489206#c4
	        // We use the documentElement instead of the body because, by default (without a css reset)
	        // browsers typically give the document body an 8px margin, which is not included in
	        // getBoundingClientRect().
	        var /** @type {?} */ scrollPosition = this.getViewportScrollPosition();
	        var _a = this.getViewportSize(), width = _a.width, height = _a.height;
	        return {
	            top: scrollPosition.top,
	            left: scrollPosition.left,
	            bottom: scrollPosition.top + height,
	            right: scrollPosition.left + width,
	            height: height,
	            width: width,
	        };
	    };
	    /** Gets the (top, left) scroll position of the viewport. */
	    /**
	     * Gets the (top, left) scroll position of the viewport.
	     * @return {?}
	     */
	    ViewportRuler.prototype.getViewportScrollPosition = /**
	     * Gets the (top, left) scroll position of the viewport.
	     * @return {?}
	     */
	    function () {
	        // While we can get a reference to the fake document
	        // during SSR, it doesn't have getBoundingClientRect.
	        if (!this._platform.isBrowser) {
	            return { top: 0, left: 0 };
	        }
	        // The top-left-corner of the viewport is determined by the scroll position of the document
	        // body, normally just (scrollLeft, scrollTop). However, Chrome and Firefox disagree about
	        // whether `document.body` or `document.documentElement` is the scrolled element, so reading
	        // `scrollTop` and `scrollLeft` is inconsistent. However, using the bounding rect of
	        // `document.documentElement` works consistently, where the `top` and `left` values will
	        // equal negative the scroll position.
	        var /** @type {?} */ documentRect = document.documentElement.getBoundingClientRect();
	        var /** @type {?} */ top = -documentRect.top || document.body.scrollTop || window.scrollY ||
	            document.documentElement.scrollTop || 0;
	        var /** @type {?} */ left = -documentRect.left || document.body.scrollLeft || window.scrollX ||
	            document.documentElement.scrollLeft || 0;
	        return { top: top, left: left };
	    };
	    /**
	     * Returns a stream that emits whenever the size of the viewport changes.
	     * @param throttle Time in milliseconds to throttle the stream.
	     */
	    /**
	     * Returns a stream that emits whenever the size of the viewport changes.
	     * @param {?=} throttleTime
	     * @return {?}
	     */
	    ViewportRuler.prototype.change = /**
	     * Returns a stream that emits whenever the size of the viewport changes.
	     * @param {?=} throttleTime
	     * @return {?}
	     */
	    function (throttleTime) {
	        if (throttleTime === void 0) { throttleTime = DEFAULT_RESIZE_TIME; }
	        return throttleTime > 0 ? this._change.pipe(rxjs_operators_auditTime.auditTime(throttleTime)) : this._change;
	    };
	    /**
	     * Updates the cached viewport size.
	     * @return {?}
	     */
	    ViewportRuler.prototype._updateViewportSize = /**
	     * Updates the cached viewport size.
	     * @return {?}
	     */
	    function () {
	        this._viewportSize = this._platform.isBrowser ?
	            { width: window.innerWidth, height: window.innerHeight } :
	            { width: 0, height: 0 };
	    };
	    ViewportRuler.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    ViewportRuler.ctorParameters = function () { return [
	        { type: _angular_cdk_platform.Platform, },
	        { type: _angular_core.NgZone, },
	    ]; };
	    return ViewportRuler;
	}());
	/**
	 * \@docs-private
	 * @param {?} parentRuler
	 * @param {?} platform
	 * @param {?} ngZone
	 * @return {?}
	 */
	function VIEWPORT_RULER_PROVIDER_FACTORY(parentRuler, platform, ngZone) {
	    return parentRuler || new ViewportRuler(platform, ngZone);
	}
	/**
	 * \@docs-private
	 */
	var VIEWPORT_RULER_PROVIDER = {
	    // If there is already a ViewportRuler available, use that. Otherwise, provide a new one.
	    provide: ViewportRuler,
	    deps: [[new _angular_core.Optional(), new _angular_core.SkipSelf(), ViewportRuler], _angular_cdk_platform.Platform, _angular_core.NgZone],
	    useFactory: VIEWPORT_RULER_PROVIDER_FACTORY
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var ScrollDispatchModule = /** @class */ (function () {
	    function ScrollDispatchModule() {
	    }
	    ScrollDispatchModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [_angular_cdk_platform.PlatformModule],
	                    exports: [CdkScrollable],
	                    declarations: [CdkScrollable],
	                    providers: [SCROLL_DISPATCHER_PROVIDER],
	                },] },
	    ];
	    /** @nocollapse */
	    ScrollDispatchModule.ctorParameters = function () { return []; };
	    return ScrollDispatchModule;
	}());
	
	exports.DEFAULT_SCROLL_TIME = DEFAULT_SCROLL_TIME;
	exports.ScrollDispatcher = ScrollDispatcher;
	exports.SCROLL_DISPATCHER_PROVIDER_FACTORY = SCROLL_DISPATCHER_PROVIDER_FACTORY;
	exports.SCROLL_DISPATCHER_PROVIDER = SCROLL_DISPATCHER_PROVIDER;
	exports.CdkScrollable = CdkScrollable;
	exports.DEFAULT_RESIZE_TIME = DEFAULT_RESIZE_TIME;
	exports.ViewportRuler = ViewportRuler;
	exports.VIEWPORT_RULER_PROVIDER_FACTORY = VIEWPORT_RULER_PROVIDER_FACTORY;
	exports.VIEWPORT_RULER_PROVIDER = VIEWPORT_RULER_PROVIDER;
	exports.ScrollDispatchModule = ScrollDispatchModule;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=cdk-scrolling.umd.js.map


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/core'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.cdk = global.ng.cdk || {}, global.ng.cdk.portal = global.ng.cdk.portal || {}),global.ng.core));
	}(this, (function (exports,_angular_core) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Throws an exception when attempting to attach a null portal to a host.
	 * \@docs-private
	 * @return {?}
	 */
	function throwNullPortalError() {
	    throw Error('Must provide a portal to attach');
	}
	/**
	 * Throws an exception when attempting to attach a portal to a host that is already attached.
	 * \@docs-private
	 * @return {?}
	 */
	function throwPortalAlreadyAttachedError() {
	    throw Error('Host already has a portal attached');
	}
	/**
	 * Throws an exception when attempting to attach a portal to an already-disposed host.
	 * \@docs-private
	 * @return {?}
	 */
	function throwPortalOutletAlreadyDisposedError() {
	    throw Error('This PortalOutlet has already been disposed');
	}
	/**
	 * Throws an exception when attempting to attach an unknown portal type.
	 * \@docs-private
	 * @return {?}
	 */
	function throwUnknownPortalTypeError() {
	    throw Error('Attempting to attach an unknown Portal type. BasePortalOutlet accepts either ' +
	        'a ComponentPortal or a TemplatePortal.');
	}
	/**
	 * Throws an exception when attempting to attach a portal to a null host.
	 * \@docs-private
	 * @return {?}
	 */
	function throwNullPortalOutletError() {
	    throw Error('Attempting to attach a portal to a null PortalOutlet');
	}
	/**
	 * Throws an exception when attempting to detach a portal that is not attached.
	 * \@docs-private
	 * @return {?}
	 */
	function throwNoPortalAttachedError() {
	    throw Error('Attempting to detach a portal that is not attached to a host');
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Interface that can be used to generically type a class.
	 * @record
	 */
	
	/**
	 * A `Portal` is something that you want to render somewhere else.
	 * It can be attach to / detached from a `PortalOutlet`.
	 * @abstract
	 */
	var Portal = /** @class */ (function () {
	    function Portal() {
	    }
	    /** Attach this portal to a host. */
	    /**
	     * Attach this portal to a host.
	     * @param {?} host
	     * @return {?}
	     */
	    Portal.prototype.attach = /**
	     * Attach this portal to a host.
	     * @param {?} host
	     * @return {?}
	     */
	    function (host) {
	        if (host == null) {
	            throwNullPortalOutletError();
	        }
	        if (host.hasAttached()) {
	            throwPortalAlreadyAttachedError();
	        }
	        this._attachedHost = host;
	        return /** @type {?} */ (host.attach(this));
	    };
	    /** Detach this portal from its host */
	    /**
	     * Detach this portal from its host
	     * @return {?}
	     */
	    Portal.prototype.detach = /**
	     * Detach this portal from its host
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ host = this._attachedHost;
	        if (host == null) {
	            throwNoPortalAttachedError();
	        }
	        else {
	            this._attachedHost = null;
	            host.detach();
	        }
	    };
	    Object.defineProperty(Portal.prototype, "isAttached", {
	        /** Whether this portal is attached to a host. */
	        get: /**
	         * Whether this portal is attached to a host.
	         * @return {?}
	         */
	        function () {
	            return this._attachedHost != null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Sets the PortalOutlet reference without performing `attach()`. This is used directly by
	     * the PortalOutlet when it is performing an `attach()` or `detach()`.
	     */
	    /**
	     * Sets the PortalOutlet reference without performing `attach()`. This is used directly by
	     * the PortalOutlet when it is performing an `attach()` or `detach()`.
	     * @param {?} host
	     * @return {?}
	     */
	    Portal.prototype.setAttachedHost = /**
	     * Sets the PortalOutlet reference without performing `attach()`. This is used directly by
	     * the PortalOutlet when it is performing an `attach()` or `detach()`.
	     * @param {?} host
	     * @return {?}
	     */
	    function (host) {
	        this._attachedHost = host;
	    };
	    return Portal;
	}());
	/**
	 * A `ComponentPortal` is a portal that instantiates some Component upon attachment.
	 */
	var ComponentPortal = /** @class */ (function (_super) {
	    __extends(ComponentPortal, _super);
	    function ComponentPortal(component, viewContainerRef, injector) {
	        var _this = _super.call(this) || this;
	        _this.component = component;
	        _this.viewContainerRef = viewContainerRef;
	        _this.injector = injector;
	        return _this;
	    }
	    return ComponentPortal;
	}(Portal));
	/**
	 * A `TemplatePortal` is a portal that represents some embedded template (TemplateRef).
	 */
	var TemplatePortal = /** @class */ (function (_super) {
	    __extends(TemplatePortal, _super);
	    function TemplatePortal(template, viewContainerRef, context) {
	        var _this = _super.call(this) || this;
	        _this.templateRef = template;
	        _this.viewContainerRef = viewContainerRef;
	        _this.context = context;
	        return _this;
	    }
	    Object.defineProperty(TemplatePortal.prototype, "origin", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return this.templateRef.elementRef;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Attach the the portal to the provided `PortalOutlet`.
	     * When a context is provided it will override the `context` property of the `TemplatePortal`
	     * instance.
	     */
	    /**
	     * Attach the the portal to the provided `PortalOutlet`.
	     * When a context is provided it will override the `context` property of the `TemplatePortal`
	     * instance.
	     * @param {?} host
	     * @param {?=} context
	     * @return {?}
	     */
	    TemplatePortal.prototype.attach = /**
	     * Attach the the portal to the provided `PortalOutlet`.
	     * When a context is provided it will override the `context` property of the `TemplatePortal`
	     * instance.
	     * @param {?} host
	     * @param {?=} context
	     * @return {?}
	     */
	    function (host, context) {
	        if (context === void 0) { context = this.context; }
	        this.context = context;
	        return _super.prototype.attach.call(this, host);
	    };
	    /**
	     * @return {?}
	     */
	    TemplatePortal.prototype.detach = /**
	     * @return {?}
	     */
	    function () {
	        this.context = undefined;
	        return _super.prototype.detach.call(this);
	    };
	    return TemplatePortal;
	}(Portal));
	/**
	 * A `PortalOutlet` is an space that can contain a single `Portal`.
	 * @record
	 */
	
	/**
	 * Partial implementation of PortalOutlet that handles attaching
	 * ComponentPortal and TemplatePortal.
	 * @abstract
	 */
	var BasePortalOutlet = /** @class */ (function () {
	    function BasePortalOutlet() {
	        /**
	         * Whether this host has already been permanently disposed.
	         */
	        this._isDisposed = false;
	    }
	    /** Whether this host has an attached portal. */
	    /**
	     * Whether this host has an attached portal.
	     * @return {?}
	     */
	    BasePortalOutlet.prototype.hasAttached = /**
	     * Whether this host has an attached portal.
	     * @return {?}
	     */
	    function () {
	        return !!this._attachedPortal;
	    };
	    /** Attaches a portal. */
	    /**
	     * Attaches a portal.
	     * @param {?} portal
	     * @return {?}
	     */
	    BasePortalOutlet.prototype.attach = /**
	     * Attaches a portal.
	     * @param {?} portal
	     * @return {?}
	     */
	    function (portal) {
	        if (!portal) {
	            throwNullPortalError();
	        }
	        if (this.hasAttached()) {
	            throwPortalAlreadyAttachedError();
	        }
	        if (this._isDisposed) {
	            throwPortalOutletAlreadyDisposedError();
	        }
	        if (portal instanceof ComponentPortal) {
	            this._attachedPortal = portal;
	            return this.attachComponentPortal(portal);
	        }
	        else if (portal instanceof TemplatePortal) {
	            this._attachedPortal = portal;
	            return this.attachTemplatePortal(portal);
	        }
	        throwUnknownPortalTypeError();
	    };
	    /** Detaches a previously attached portal. */
	    /**
	     * Detaches a previously attached portal.
	     * @return {?}
	     */
	    BasePortalOutlet.prototype.detach = /**
	     * Detaches a previously attached portal.
	     * @return {?}
	     */
	    function () {
	        if (this._attachedPortal) {
	            this._attachedPortal.setAttachedHost(null);
	            this._attachedPortal = null;
	        }
	        this._invokeDisposeFn();
	    };
	    /** Permanently dispose of this portal host. */
	    /**
	     * Permanently dispose of this portal host.
	     * @return {?}
	     */
	    BasePortalOutlet.prototype.dispose = /**
	     * Permanently dispose of this portal host.
	     * @return {?}
	     */
	    function () {
	        if (this.hasAttached()) {
	            this.detach();
	        }
	        this._invokeDisposeFn();
	        this._isDisposed = true;
	    };
	    /** @docs-private */
	    /**
	     * \@docs-private
	     * @param {?} fn
	     * @return {?}
	     */
	    BasePortalOutlet.prototype.setDisposeFn = /**
	     * \@docs-private
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._disposeFn = fn;
	    };
	    /**
	     * @return {?}
	     */
	    BasePortalOutlet.prototype._invokeDisposeFn = /**
	     * @return {?}
	     */
	    function () {
	        if (this._disposeFn) {
	            this._disposeFn();
	            this._disposeFn = null;
	        }
	    };
	    return BasePortalOutlet;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * A PortalOutlet for attaching portals to an arbitrary DOM element outside of the Angular
	 * application context.
	 */
	var DomPortalOutlet = /** @class */ (function (_super) {
	    __extends(DomPortalOutlet, _super);
	    function DomPortalOutlet(outletElement, _componentFactoryResolver, _appRef, _defaultInjector) {
	        var _this = _super.call(this) || this;
	        _this.outletElement = outletElement;
	        _this._componentFactoryResolver = _componentFactoryResolver;
	        _this._appRef = _appRef;
	        _this._defaultInjector = _defaultInjector;
	        return _this;
	    }
	    /**
	     * Attach the given ComponentPortal to DOM element using the ComponentFactoryResolver.
	     * @param portal Portal to be attached
	     * @returns Reference to the created component.
	     */
	    /**
	     * Attach the given ComponentPortal to DOM element using the ComponentFactoryResolver.
	     * @template T
	     * @param {?} portal Portal to be attached
	     * @return {?} Reference to the created component.
	     */
	    DomPortalOutlet.prototype.attachComponentPortal = /**
	     * Attach the given ComponentPortal to DOM element using the ComponentFactoryResolver.
	     * @template T
	     * @param {?} portal Portal to be attached
	     * @return {?} Reference to the created component.
	     */
	    function (portal) {
	        var _this = this;
	        var /** @type {?} */ componentFactory = this._componentFactoryResolver.resolveComponentFactory(portal.component);
	        var /** @type {?} */ componentRef;
	        // If the portal specifies a ViewContainerRef, we will use that as the attachment point
	        // for the component (in terms of Angular's component tree, not rendering).
	        // When the ViewContainerRef is missing, we use the factory to create the component directly
	        // and then manually attach the view to the application.
	        if (portal.viewContainerRef) {
	            componentRef = portal.viewContainerRef.createComponent(componentFactory, portal.viewContainerRef.length, portal.injector || portal.viewContainerRef.parentInjector);
	            this.setDisposeFn(function () { return componentRef.destroy(); });
	        }
	        else {
	            componentRef = componentFactory.create(portal.injector || this._defaultInjector);
	            this._appRef.attachView(componentRef.hostView);
	            this.setDisposeFn(function () {
	                _this._appRef.detachView(componentRef.hostView);
	                componentRef.destroy();
	            });
	        }
	        // At this point the component has been instantiated, so we move it to the location in the DOM
	        // where we want it to be rendered.
	        this.outletElement.appendChild(this._getComponentRootNode(componentRef));
	        return componentRef;
	    };
	    /**
	     * Attaches a template portal to the DOM as an embedded view.
	     * @param portal Portal to be attached.
	     * @returns Reference to the created embedded view.
	     */
	    /**
	     * Attaches a template portal to the DOM as an embedded view.
	     * @template C
	     * @param {?} portal Portal to be attached.
	     * @return {?} Reference to the created embedded view.
	     */
	    DomPortalOutlet.prototype.attachTemplatePortal = /**
	     * Attaches a template portal to the DOM as an embedded view.
	     * @template C
	     * @param {?} portal Portal to be attached.
	     * @return {?} Reference to the created embedded view.
	     */
	    function (portal) {
	        var _this = this;
	        var /** @type {?} */ viewContainer = portal.viewContainerRef;
	        var /** @type {?} */ viewRef = viewContainer.createEmbeddedView(portal.templateRef, portal.context);
	        viewRef.detectChanges();
	        // The method `createEmbeddedView` will add the view as a child of the viewContainer.
	        // But for the DomPortalOutlet the view can be added everywhere in the DOM
	        // (e.g Overlay Container) To move the view to the specified host element. We just
	        // re-append the existing root nodes.
	        viewRef.rootNodes.forEach(function (rootNode) { return _this.outletElement.appendChild(rootNode); });
	        this.setDisposeFn((function () {
	            var /** @type {?} */ index = viewContainer.indexOf(viewRef);
	            if (index !== -1) {
	                viewContainer.remove(index);
	            }
	        }));
	        // TODO(jelbourn): Return locals from view.
	        return viewRef;
	    };
	    /**
	     * Clears out a portal from the DOM.
	     */
	    /**
	     * Clears out a portal from the DOM.
	     * @return {?}
	     */
	    DomPortalOutlet.prototype.dispose = /**
	     * Clears out a portal from the DOM.
	     * @return {?}
	     */
	    function () {
	        _super.prototype.dispose.call(this);
	        if (this.outletElement.parentNode != null) {
	            this.outletElement.parentNode.removeChild(this.outletElement);
	        }
	    };
	    /**
	     * Gets the root HTMLElement for an instantiated component.
	     * @param {?} componentRef
	     * @return {?}
	     */
	    DomPortalOutlet.prototype._getComponentRootNode = /**
	     * Gets the root HTMLElement for an instantiated component.
	     * @param {?} componentRef
	     * @return {?}
	     */
	    function (componentRef) {
	        return /** @type {?} */ ((/** @type {?} */ (componentRef.hostView)).rootNodes[0]);
	    };
	    return DomPortalOutlet;
	}(BasePortalOutlet));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Directive version of a `TemplatePortal`. Because the directive *is* a TemplatePortal,
	 * the directive instance itself can be attached to a host, enabling declarative use of portals.
	 */
	var CdkPortal = /** @class */ (function (_super) {
	    __extends(CdkPortal, _super);
	    function CdkPortal(templateRef, viewContainerRef) {
	        return _super.call(this, templateRef, viewContainerRef) || this;
	    }
	    CdkPortal.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[cdk-portal], [cdkPortal], [portal]',
	                    exportAs: 'cdkPortal',
	                },] },
	    ];
	    /** @nocollapse */
	    CdkPortal.ctorParameters = function () { return [
	        { type: _angular_core.TemplateRef, },
	        { type: _angular_core.ViewContainerRef, },
	    ]; };
	    return CdkPortal;
	}(TemplatePortal));
	/**
	 * Directive version of a PortalOutlet. Because the directive *is* a PortalOutlet, portals can be
	 * directly attached to it, enabling declarative use.
	 *
	 * Usage:
	 * `<ng-template [cdkPortalOutlet]="greeting"></ng-template>`
	 */
	var CdkPortalOutlet = /** @class */ (function (_super) {
	    __extends(CdkPortalOutlet, _super);
	    function CdkPortalOutlet(_componentFactoryResolver, _viewContainerRef) {
	        var _this = _super.call(this) || this;
	        _this._componentFactoryResolver = _componentFactoryResolver;
	        _this._viewContainerRef = _viewContainerRef;
	        /**
	         * Whether the portal component is initialized.
	         */
	        _this._isInitialized = false;
	        _this.attached = new _angular_core.EventEmitter();
	        return _this;
	    }
	    Object.defineProperty(CdkPortalOutlet.prototype, "_deprecatedPortal", {
	        get: /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this.portal; },
	        set: /**
	         * @param {?} v
	         * @return {?}
	         */
	        function (v) { this.portal = v; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkPortalOutlet.prototype, "_deprecatedPortalHost", {
	        get: /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this.portal; },
	        set: /**
	         * @param {?} v
	         * @return {?}
	         */
	        function (v) { this.portal = v; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkPortalOutlet.prototype, "portal", {
	        /** Portal associated with the Portal outlet. */
	        get: /**
	         * Portal associated with the Portal outlet.
	         * @return {?}
	         */
	        function () {
	            return this._attachedPortal;
	        },
	        set: /**
	         * @param {?} portal
	         * @return {?}
	         */
	        function (portal) {
	            // Ignore the cases where the `portal` is set to a falsy value before the lifecycle hooks have
	            // run. This handles the cases where the user might do something like `<div cdkPortalOutlet>`
	            // and attach a portal programmatically in the parent component. When Angular does the first CD
	            // round, it will fire the setter with empty string, causing the user's content to be cleared.
	            if (this.hasAttached() && !portal && !this._isInitialized) {
	                return;
	            }
	            if (this.hasAttached()) {
	                _super.prototype.detach.call(this);
	            }
	            if (portal) {
	                _super.prototype.attach.call(this, portal);
	            }
	            this._attachedPortal = portal;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkPortalOutlet.prototype, "attachedRef", {
	        /** Component or view reference that is attached to the portal. */
	        get: /**
	         * Component or view reference that is attached to the portal.
	         * @return {?}
	         */
	        function () {
	            return this._attachedRef;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    CdkPortalOutlet.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        this._isInitialized = true;
	    };
	    /**
	     * @return {?}
	     */
	    CdkPortalOutlet.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        _super.prototype.dispose.call(this);
	        this._attachedPortal = null;
	        this._attachedRef = null;
	    };
	    /**
	     * Attach the given ComponentPortal to this PortalOutlet using the ComponentFactoryResolver.
	     *
	     * @param portal Portal to be attached to the portal outlet.
	     * @returns Reference to the created component.
	     */
	    /**
	     * Attach the given ComponentPortal to this PortalOutlet using the ComponentFactoryResolver.
	     *
	     * @template T
	     * @param {?} portal Portal to be attached to the portal outlet.
	     * @return {?} Reference to the created component.
	     */
	    CdkPortalOutlet.prototype.attachComponentPortal = /**
	     * Attach the given ComponentPortal to this PortalOutlet using the ComponentFactoryResolver.
	     *
	     * @template T
	     * @param {?} portal Portal to be attached to the portal outlet.
	     * @return {?} Reference to the created component.
	     */
	    function (portal) {
	        portal.setAttachedHost(this);
	        // If the portal specifies an origin, use that as the logical location of the component
	        // in the application tree. Otherwise use the location of this PortalOutlet.
	        var /** @type {?} */ viewContainerRef = portal.viewContainerRef != null ?
	            portal.viewContainerRef :
	            this._viewContainerRef;
	        var /** @type {?} */ componentFactory = this._componentFactoryResolver.resolveComponentFactory(portal.component);
	        var /** @type {?} */ ref = viewContainerRef.createComponent(componentFactory, viewContainerRef.length, portal.injector || viewContainerRef.parentInjector);
	        _super.prototype.setDisposeFn.call(this, function () { return ref.destroy(); });
	        this._attachedPortal = portal;
	        this._attachedRef = ref;
	        this.attached.emit(ref);
	        return ref;
	    };
	    /**
	     * Attach the given TemplatePortal to this PortlHost as an embedded View.
	     * @param portal Portal to be attached.
	     * @returns Reference to the created embedded view.
	     */
	    /**
	     * Attach the given TemplatePortal to this PortlHost as an embedded View.
	     * @template C
	     * @param {?} portal Portal to be attached.
	     * @return {?} Reference to the created embedded view.
	     */
	    CdkPortalOutlet.prototype.attachTemplatePortal = /**
	     * Attach the given TemplatePortal to this PortlHost as an embedded View.
	     * @template C
	     * @param {?} portal Portal to be attached.
	     * @return {?} Reference to the created embedded view.
	     */
	    function (portal) {
	        var _this = this;
	        portal.setAttachedHost(this);
	        var /** @type {?} */ viewRef = this._viewContainerRef.createEmbeddedView(portal.templateRef, portal.context);
	        _super.prototype.setDisposeFn.call(this, function () { return _this._viewContainerRef.clear(); });
	        this._attachedPortal = portal;
	        this._attachedRef = viewRef;
	        this.attached.emit(viewRef);
	        return viewRef;
	    };
	    CdkPortalOutlet.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[cdkPortalOutlet], [cdkPortalHost], [portalHost]',
	                    exportAs: 'cdkPortalOutlet, cdkPortalHost',
	                    inputs: ['portal: cdkPortalOutlet']
	                },] },
	    ];
	    /** @nocollapse */
	    CdkPortalOutlet.ctorParameters = function () { return [
	        { type: _angular_core.ComponentFactoryResolver, },
	        { type: _angular_core.ViewContainerRef, },
	    ]; };
	    CdkPortalOutlet.propDecorators = {
	        "_deprecatedPortal": [{ type: _angular_core.Input, args: ['portalHost',] },],
	        "_deprecatedPortalHost": [{ type: _angular_core.Input, args: ['cdkPortalHost',] },],
	        "attached": [{ type: _angular_core.Output, args: ['attached',] },],
	    };
	    return CdkPortalOutlet;
	}(BasePortalOutlet));
	var PortalModule = /** @class */ (function () {
	    function PortalModule() {
	    }
	    PortalModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    exports: [CdkPortal, CdkPortalOutlet],
	                    declarations: [CdkPortal, CdkPortalOutlet],
	                },] },
	    ];
	    /** @nocollapse */
	    PortalModule.ctorParameters = function () { return []; };
	    return PortalModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Custom injector to be used when providing custom
	 * injection tokens to components inside a portal.
	 * \@docs-private
	 */
	var PortalInjector = /** @class */ (function () {
	    function PortalInjector(_parentInjector, _customTokens) {
	        this._parentInjector = _parentInjector;
	        this._customTokens = _customTokens;
	    }
	    /**
	     * @param {?} token
	     * @param {?=} notFoundValue
	     * @return {?}
	     */
	    PortalInjector.prototype.get = /**
	     * @param {?} token
	     * @param {?=} notFoundValue
	     * @return {?}
	     */
	    function (token, notFoundValue) {
	        var /** @type {?} */ value = this._customTokens.get(token);
	        if (typeof value !== 'undefined') {
	            return value;
	        }
	        return this._parentInjector.get(token, notFoundValue);
	    };
	    return PortalInjector;
	}());
	
	exports.DomPortalHost = DomPortalOutlet;
	exports.PortalHostDirective = CdkPortalOutlet;
	exports.TemplatePortalDirective = CdkPortal;
	exports.BasePortalHost = BasePortalOutlet;
	exports.Portal = Portal;
	exports.ComponentPortal = ComponentPortal;
	exports.TemplatePortal = TemplatePortal;
	exports.BasePortalOutlet = BasePortalOutlet;
	exports.DomPortalOutlet = DomPortalOutlet;
	exports.CdkPortal = CdkPortal;
	exports.CdkPortalOutlet = CdkPortalOutlet;
	exports.PortalModule = PortalModule;
	exports.PortalInjector = PortalInjector;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=cdk-portal.umd.js.map


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(246), __webpack_require__(1081), __webpack_require__(1076), __webpack_require__(1077), __webpack_require__(1304), __webpack_require__(1079), __webpack_require__(1308), __webpack_require__(298), __webpack_require__(263), __webpack_require__(254), __webpack_require__(256), __webpack_require__(594), __webpack_require__(620), __webpack_require__(768), __webpack_require__(1075), __webpack_require__(1305), __webpack_require__(206), __webpack_require__(222), __webpack_require__(240), __webpack_require__(318), __webpack_require__(250)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@angular/common', '@angular/cdk/a11y', '@angular/cdk/bidi', '@angular/cdk/coercion', '@angular/cdk/collections', '@angular/cdk/keycodes', '@angular/cdk/overlay', 'rxjs/operators/filter', 'rxjs/operators/take', 'rxjs/operators/map', 'rxjs/operators/switchMap', 'rxjs/operators/startWith', 'rxjs/operators/takeUntil', '@angular/forms', '@angular/material/core', '@angular/material/form-field', 'rxjs/Observable', 'rxjs/observable/merge', 'rxjs/Subject', 'rxjs/observable/defer', '@angular/animations'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.material = global.ng.material || {}, global.ng.material.select = global.ng.material.select || {}),global.ng.core,global.ng.common,global.ng.cdk.a11y,global.ng.cdk.bidi,global.ng.cdk.coercion,global.ng.cdk.collections,global.ng.cdk.keycodes,global.ng.cdk.overlay,global.Rx.operators,global.Rx.operators,global.Rx.operators,global.Rx.operators,global.Rx.operators,global.Rx.operators,global.ng.forms,global.ng.material.core,global.ng.material.formField,global.Rx,global.Rx.Observable,global.Rx,global.Rx.Observable,global.ng.animations));
	}(this, (function (exports,_angular_core,_angular_common,_angular_cdk_a11y,_angular_cdk_bidi,_angular_cdk_coercion,_angular_cdk_collections,_angular_cdk_keycodes,_angular_cdk_overlay,rxjs_operators_filter,rxjs_operators_take,rxjs_operators_map,rxjs_operators_switchMap,rxjs_operators_startWith,rxjs_operators_takeUntil,_angular_forms,_angular_material_core,_angular_material_formField,rxjs_Observable,rxjs_observable_merge,rxjs_Subject,rxjs_observable_defer,_angular_animations) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * The following are all the animations for the mat-select component, with each
	 * const containing the metadata for one animation.
	 *
	 * The values below match the implementation of the AngularJS Material mat-select animation.
	 */
	var matSelectAnimations = {
	    /**
	       * This animation transforms the select's overlay panel on and off the page.
	       *
	       * When the panel is attached to the DOM, it expands its width by the amount of padding, scales it
	       * up to 100% on the Y axis, fades in its border, and translates slightly up and to the
	       * side to ensure the option text correctly overlaps the trigger text.
	       *
	       * When the panel is removed from the DOM, it simply fades out linearly.
	       */
	    transformPanel: _angular_animations.trigger('transformPanel', [
	        _angular_animations.state('showing', _angular_animations.style({
	            opacity: 1,
	            minWidth: 'calc(100% + 32px)',
	            // 32px = 2 * 16px padding
	            transform: 'scaleY(1)'
	        })),
	        _angular_animations.state('showing-multiple', _angular_animations.style({
	            opacity: 1,
	            minWidth: 'calc(100% + 64px)',
	            // 64px = 48px padding on the left + 16px padding on the right
	            transform: 'scaleY(1)'
	        })),
	        _angular_animations.transition('void => *', [
	            _angular_animations.style({
	                opacity: 0,
	                minWidth: '100%',
	                transform: 'scaleY(0)'
	            }),
	            _angular_animations.animate('150ms cubic-bezier(0.25, 0.8, 0.25, 1)')
	        ]),
	        _angular_animations.transition('* => void', [
	            _angular_animations.animate('250ms 100ms linear', _angular_animations.style({ opacity: 0 }))
	        ])
	    ]),
	    /**
	       * This animation fades in the background color and text content of the
	       * select's options. It is time delayed to occur 100ms after the overlay
	       * panel has transformed in.
	       */
	    fadeInContent: _angular_animations.trigger('fadeInContent', [
	        _angular_animations.state('showing', _angular_animations.style({ opacity: 1 })),
	        _angular_animations.transition('void => showing', [
	            _angular_animations.style({ opacity: 0 }),
	            _angular_animations.animate('150ms 100ms cubic-bezier(0.55, 0, 0.55, 0.2)')
	        ])
	    ])
	};
	/**
	 * @deprecated
	 * \@deletion-target 7.0.0
	 */
	var transformPanel = matSelectAnimations.transformPanel;
	/**
	 * @deprecated
	 * \@deletion-target 7.0.0
	 */
	var fadeInContent = matSelectAnimations.fadeInContent;
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Returns an exception to be thrown when attempting to change a select's `multiple` option
	 * after initialization.
	 * \@docs-private
	 * @return {?}
	 */
	function getMatSelectDynamicMultipleError() {
	    return Error('Cannot change `multiple` mode of select after initialization.');
	}
	/**
	 * Returns an exception to be thrown when attempting to assign a non-array value to a select
	 * in `multiple` mode. Note that `undefined` and `null` are still valid values to allow for
	 * resetting the value.
	 * \@docs-private
	 * @return {?}
	 */
	function getMatSelectNonArrayValueError() {
	    return Error('Value must be an array in multiple-selection mode.');
	}
	/**
	 * Returns an exception to be thrown when assigning a non-function value to the comparator
	 * used to determine if a value corresponds to an option. Note that whether the function
	 * actually takes two values and returns a boolean is not checked.
	 * @return {?}
	 */
	function getMatSelectNonFunctionValueError() {
	    return Error('`compareWith` must be a function.');
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var nextUniqueId = 0;
	/**
	 * The max height of the select's overlay panel
	 */
	var SELECT_PANEL_MAX_HEIGHT = 256;
	/**
	 * The panel's padding on the x-axis
	 */
	var SELECT_PANEL_PADDING_X = 16;
	/**
	 * The panel's x axis padding if it is indented (e.g. there is an option group).
	 */
	var SELECT_PANEL_INDENT_PADDING_X = SELECT_PANEL_PADDING_X * 2;
	/**
	 * The height of the select items in `em` units.
	 */
	var SELECT_ITEM_HEIGHT_EM = 3;
	/**
	 * Distance between the panel edge and the option text in
	 * multi-selection mode.
	 *
	 * (SELECT_PANEL_PADDING_X * 1.5) + 20 = 44
	 * The padding is multiplied by 1.5 because the checkbox's margin is half the padding.
	 * The checkbox width is 20px.
	 */
	var SELECT_MULTIPLE_PANEL_PADDING_X = SELECT_PANEL_PADDING_X * 1.5 + 20;
	/**
	 * The select panel will only "fit" inside the viewport if it is positioned at
	 * this value or more away from the viewport boundary.
	 */
	var SELECT_PANEL_VIEWPORT_PADDING = 8;
	/**
	 * Injection token that determines the scroll handling while a select is open.
	 */
	var MAT_SELECT_SCROLL_STRATEGY = new _angular_core.InjectionToken('mat-select-scroll-strategy');
	/**
	 * \@docs-private
	 * @param {?} overlay
	 * @return {?}
	 */
	function MAT_SELECT_SCROLL_STRATEGY_PROVIDER_FACTORY(overlay) {
	    return function () { return overlay.scrollStrategies.reposition(); };
	}
	/**
	 * \@docs-private
	 */
	var MAT_SELECT_SCROLL_STRATEGY_PROVIDER = {
	    provide: MAT_SELECT_SCROLL_STRATEGY,
	    deps: [_angular_cdk_overlay.Overlay],
	    useFactory: MAT_SELECT_SCROLL_STRATEGY_PROVIDER_FACTORY,
	};
	/**
	 * Change event object that is emitted when the select value has changed.
	 */
	var MatSelectChange = /** @class */ (function () {
	    function MatSelectChange(source, value) {
	        this.source = source;
	        this.value = value;
	    }
	    return MatSelectChange;
	}());
	/**
	 * \@docs-private
	 */
	var MatSelectBase = /** @class */ (function () {
	    function MatSelectBase(_elementRef, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) {
	        this._elementRef = _elementRef;
	        this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
	        this._parentForm = _parentForm;
	        this._parentFormGroup = _parentFormGroup;
	        this.ngControl = ngControl;
	    }
	    return MatSelectBase;
	}());
	var _MatSelectMixinBase = _angular_material_core.mixinDisableRipple(_angular_material_core.mixinTabIndex(_angular_material_core.mixinDisabled(_angular_material_core.mixinErrorState(MatSelectBase))));
	/**
	 * Allows the user to customize the trigger that is displayed when the select has a value.
	 */
	var MatSelectTrigger = /** @class */ (function () {
	    function MatSelectTrigger() {
	    }
	    MatSelectTrigger.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-select-trigger'
	                },] },
	    ];
	    /** @nocollapse */
	    MatSelectTrigger.ctorParameters = function () { return []; };
	    return MatSelectTrigger;
	}());
	var MatSelect = /** @class */ (function (_super) {
	    __extends(MatSelect, _super);
	    function MatSelect(_viewportRuler, _changeDetectorRef, _ngZone, _defaultErrorStateMatcher, elementRef, _dir, _parentForm, _parentFormGroup, _parentFormField, ngControl, tabIndex, _scrollStrategyFactory) {
	        var _this = _super.call(this, elementRef, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) || this;
	        _this._viewportRuler = _viewportRuler;
	        _this._changeDetectorRef = _changeDetectorRef;
	        _this._ngZone = _ngZone;
	        _this._dir = _dir;
	        _this._parentFormField = _parentFormField;
	        _this.ngControl = ngControl;
	        _this._scrollStrategyFactory = _scrollStrategyFactory;
	        /**
	         * Whether or not the overlay panel is open.
	         */
	        _this._panelOpen = false;
	        /**
	         * Whether filling out the select is required in the form.
	         */
	        _this._required = false;
	        /**
	         * The scroll position of the overlay panel, calculated to center the selected option.
	         */
	        _this._scrollTop = 0;
	        /**
	         * Whether the component is in multiple selection mode.
	         */
	        _this._multiple = false;
	        /**
	         * Comparison function to specify which option is displayed. Defaults to object equality.
	         */
	        _this._compareWith = function (o1, o2) { return o1 === o2; };
	        /**
	         * Unique id for this input.
	         */
	        _this._uid = "mat-select-" + nextUniqueId++;
	        /**
	         * Emits whenever the component is destroyed.
	         */
	        _this._destroy = new rxjs_Subject.Subject();
	        /**
	         * The cached font-size of the trigger element.
	         */
	        _this._triggerFontSize = 0;
	        /**
	         * `View -> model callback called when value changes`
	         */
	        _this._onChange = function () { };
	        /**
	         * `View -> model callback called when select has been touched`
	         */
	        _this._onTouched = function () { };
	        /**
	         * The IDs of child options to be passed to the aria-owns attribute.
	         */
	        _this._optionIds = '';
	        /**
	         * The value of the select panel's transform-origin property.
	         */
	        _this._transformOrigin = 'top';
	        /**
	         * Whether the panel's animation is done.
	         */
	        _this._panelDoneAnimating = false;
	        /**
	         * Strategy that will be used to handle scrolling while the select panel is open.
	         */
	        _this._scrollStrategy = _this._scrollStrategyFactory();
	        /**
	         * The y-offset of the overlay panel in relation to the trigger's top start corner.
	         * This must be adjusted to align the selected option text over the trigger text.
	         * when the panel opens. Will change based on the y-position of the selected option.
	         */
	        _this._offsetY = 0;
	        /**
	         * This position config ensures that the top "start" corner of the overlay
	         * is aligned with with the top "start" of the origin by default (overlapping
	         * the trigger completely). If the panel cannot fit below the trigger, it
	         * will fall back to a position above the trigger.
	         */
	        _this._positions = [
	            {
	                originX: 'start',
	                originY: 'top',
	                overlayX: 'start',
	                overlayY: 'top',
	            },
	            {
	                originX: 'start',
	                originY: 'bottom',
	                overlayX: 'start',
	                overlayY: 'bottom',
	            },
	        ];
	        /**
	         * Whether the select is focused.
	         */
	        _this.focused = false;
	        /**
	         * A name for this control that can be used by `mat-form-field`.
	         */
	        _this.controlType = 'mat-select';
	        /**
	         * Aria label of the select. If not specified, the placeholder will be used as label.
	         */
	        _this.ariaLabel = '';
	        /**
	         * Combined stream of all of the child options' change events.
	         */
	        _this.optionSelectionChanges = rxjs_observable_defer.defer(function () {
	            if (_this.options) {
	                return rxjs_observable_merge.merge.apply(void 0, _this.options.map(function (option) { return option.onSelectionChange; }));
	            }
	            return _this._ngZone.onStable
	                .asObservable()
	                .pipe(rxjs_operators_take.take(1), rxjs_operators_switchMap.switchMap(function () { return _this.optionSelectionChanges; }));
	        });
	        /**
	         * Event emitted when the select panel has been toggled.
	         */
	        _this.openedChange = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when the select has been opened.
	         * @deprecated Use `openedChange` instead.
	         * \@deletion-target 6.0.0
	         */
	        _this.onOpen = _this._openedStream;
	        /**
	         * Event emitted when the select has been closed.
	         * @deprecated Use `openedChange` instead.
	         * \@deletion-target 6.0.0
	         */
	        _this.onClose = _this._closedStream;
	        /**
	         * Event emitted when the selected value has been changed by the user.
	         */
	        _this.selectionChange = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when the selected value has been changed by the user.
	         * @deprecated Use `selectionChange` instead.
	         * \@deletion-target 6.0.0
	         */
	        _this.change = _this.selectionChange;
	        /**
	         * Event that emits whenever the raw value of the select changes. This is here primarily
	         * to facilitate the two-way binding for the `value` input.
	         * \@docs-private
	         */
	        _this.valueChange = new _angular_core.EventEmitter();
	        if (_this.ngControl) {
	            // Note: we provide the value accessor through here, instead of
	            // the `providers` to avoid running into a circular import.
	            // Note: we provide the value accessor through here, instead of
	            // the `providers` to avoid running into a circular import.
	            _this.ngControl.valueAccessor = _this;
	        }
	        _this.tabIndex = parseInt(tabIndex) || 0;
	        // Force setter to be called in case id was not specified.
	        // Force setter to be called in case id was not specified.
	        _this.id = _this.id;
	        return _this;
	    }
	    Object.defineProperty(MatSelect.prototype, "placeholder", {
	        get: /**
	         * Placeholder to be shown if no value has been selected.
	         * @return {?}
	         */
	        function () { return this._placeholder; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._placeholder = value;
	            this.stateChanges.next();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSelect.prototype, "required", {
	        get: /**
	         * Whether the component is required.
	         * @return {?}
	         */
	        function () { return this._required; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._required = _angular_cdk_coercion.coerceBooleanProperty(value);
	            this.stateChanges.next();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSelect.prototype, "multiple", {
	        get: /**
	         * Whether the user should be allowed to select multiple options.
	         * @return {?}
	         */
	        function () { return this._multiple; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (this._selectionModel) {
	                throw getMatSelectDynamicMultipleError();
	            }
	            this._multiple = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSelect.prototype, "compareWith", {
	        get: /**
	         * A function to compare the option values with the selected values. The first argument
	         * is a value from an option. The second is a value from the selection. A boolean
	         * should be returned.
	         * @return {?}
	         */
	        function () { return this._compareWith; },
	        set: /**
	         * @param {?} fn
	         * @return {?}
	         */
	        function (fn) {
	            if (typeof fn !== 'function') {
	                throw getMatSelectNonFunctionValueError();
	            }
	            this._compareWith = fn;
	            if (this._selectionModel) {
	                // A different comparator means the selection could change.
	                this._initializeSelection();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSelect.prototype, "value", {
	        get: /**
	         * Value of the select control.
	         * @return {?}
	         */
	        function () { return this._value; },
	        set: /**
	         * @param {?} newValue
	         * @return {?}
	         */
	        function (newValue) {
	            if (newValue !== this._value) {
	                this.writeValue(newValue);
	                this._value = newValue;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSelect.prototype, "id", {
	        get: /**
	         * Unique id of the element.
	         * @return {?}
	         */
	        function () { return this._id; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._id = value || this._uid;
	            this.stateChanges.next();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSelect.prototype, "_openedStream", {
	        get: /**
	         * Event emitted when the select has been opened.
	         * @return {?}
	         */
	        function () {
	            return this.openedChange.pipe(rxjs_operators_filter.filter(function (o) { return o; }), rxjs_operators_map.map(function () { }));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSelect.prototype, "_closedStream", {
	        get: /**
	         * Event emitted when the select has been closed.
	         * @return {?}
	         */
	        function () {
	            return this.openedChange.pipe(rxjs_operators_filter.filter(function (o) { return !o; }), rxjs_operators_map.map(function () { }));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatSelect.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        this._selectionModel = new _angular_cdk_collections.SelectionModel(this.multiple, undefined, false);
	        this.stateChanges.next();
	    };
	    /**
	     * @return {?}
	     */
	    MatSelect.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._initKeyManager();
	        this.options.changes.pipe(rxjs_operators_startWith.startWith(null), rxjs_operators_takeUntil.takeUntil(this._destroy)).subscribe(function () {
	            _this._resetOptions();
	            _this._initializeSelection();
	        });
	    };
	    /**
	     * @return {?}
	     */
	    MatSelect.prototype.ngDoCheck = /**
	     * @return {?}
	     */
	    function () {
	        if (this.ngControl) {
	            this.updateErrorState();
	        }
	    };
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    MatSelect.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        // Updating the disabled state is handled by `mixinDisabled`, but we need to additionally let
	        // the parent form field know to run change detection when the disabled state changes.
	        if (changes["disabled"]) {
	            this.stateChanges.next();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatSelect.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._destroy.next();
	        this._destroy.complete();
	        this.stateChanges.complete();
	    };
	    /** Toggles the overlay panel open or closed. */
	    /**
	     * Toggles the overlay panel open or closed.
	     * @return {?}
	     */
	    MatSelect.prototype.toggle = /**
	     * Toggles the overlay panel open or closed.
	     * @return {?}
	     */
	    function () {
	        this.panelOpen ? this.close() : this.open();
	    };
	    /** Opens the overlay panel. */
	    /**
	     * Opens the overlay panel.
	     * @return {?}
	     */
	    MatSelect.prototype.open = /**
	     * Opens the overlay panel.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this.disabled || !this.options || !this.options.length) {
	            return;
	        }
	        this._triggerRect = this.trigger.nativeElement.getBoundingClientRect();
	        // Note: The computed font-size will be a string pixel value (e.g. "16px").
	        // `parseInt` ignores the trailing 'px' and converts this to a number.
	        this._triggerFontSize = parseInt(getComputedStyle(this.trigger.nativeElement)['font-size']);
	        this._panelOpen = true;
	        this._keyManager.withHorizontalOrientation(null);
	        this._calculateOverlayPosition();
	        this._highlightCorrectOption();
	        this._changeDetectorRef.markForCheck();
	        // Set the font size on the panel element once it exists.
	        this._ngZone.onStable.asObservable().pipe(rxjs_operators_take.take(1)).subscribe(function () {
	            if (_this._triggerFontSize && _this.overlayDir.overlayRef &&
	                _this.overlayDir.overlayRef.overlayElement) {
	                _this.overlayDir.overlayRef.overlayElement.style.fontSize = _this._triggerFontSize + "px";
	            }
	        });
	    };
	    /** Closes the overlay panel and focuses the host element. */
	    /**
	     * Closes the overlay panel and focuses the host element.
	     * @return {?}
	     */
	    MatSelect.prototype.close = /**
	     * Closes the overlay panel and focuses the host element.
	     * @return {?}
	     */
	    function () {
	        if (this._panelOpen) {
	            this._panelOpen = false;
	            this._keyManager.withHorizontalOrientation(this._isRtl() ? 'rtl' : 'ltr');
	            this._changeDetectorRef.markForCheck();
	            this._onTouched();
	        }
	    };
	    /**
	     * Sets the select's value. Part of the ControlValueAccessor interface
	     * required to integrate with Angular's core forms API.
	     *
	     * @param value New value to be written to the model.
	     */
	    /**
	     * Sets the select's value. Part of the ControlValueAccessor interface
	     * required to integrate with Angular's core forms API.
	     *
	     * @param {?} value New value to be written to the model.
	     * @return {?}
	     */
	    MatSelect.prototype.writeValue = /**
	     * Sets the select's value. Part of the ControlValueAccessor interface
	     * required to integrate with Angular's core forms API.
	     *
	     * @param {?} value New value to be written to the model.
	     * @return {?}
	     */
	    function (value) {
	        if (this.options) {
	            this._setSelectionByValue(value);
	        }
	    };
	    /**
	     * Saves a callback function to be invoked when the select's value
	     * changes from user input. Part of the ControlValueAccessor interface
	     * required to integrate with Angular's core forms API.
	     *
	     * @param fn Callback to be triggered when the value changes.
	     */
	    /**
	     * Saves a callback function to be invoked when the select's value
	     * changes from user input. Part of the ControlValueAccessor interface
	     * required to integrate with Angular's core forms API.
	     *
	     * @param {?} fn Callback to be triggered when the value changes.
	     * @return {?}
	     */
	    MatSelect.prototype.registerOnChange = /**
	     * Saves a callback function to be invoked when the select's value
	     * changes from user input. Part of the ControlValueAccessor interface
	     * required to integrate with Angular's core forms API.
	     *
	     * @param {?} fn Callback to be triggered when the value changes.
	     * @return {?}
	     */
	    function (fn) {
	        this._onChange = fn;
	    };
	    /**
	     * Saves a callback function to be invoked when the select is blurred
	     * by the user. Part of the ControlValueAccessor interface required
	     * to integrate with Angular's core forms API.
	     *
	     * @param fn Callback to be triggered when the component has been touched.
	     */
	    /**
	     * Saves a callback function to be invoked when the select is blurred
	     * by the user. Part of the ControlValueAccessor interface required
	     * to integrate with Angular's core forms API.
	     *
	     * @param {?} fn Callback to be triggered when the component has been touched.
	     * @return {?}
	     */
	    MatSelect.prototype.registerOnTouched = /**
	     * Saves a callback function to be invoked when the select is blurred
	     * by the user. Part of the ControlValueAccessor interface required
	     * to integrate with Angular's core forms API.
	     *
	     * @param {?} fn Callback to be triggered when the component has been touched.
	     * @return {?}
	     */
	    function (fn) {
	        this._onTouched = fn;
	    };
	    /**
	     * Disables the select. Part of the ControlValueAccessor interface required
	     * to integrate with Angular's core forms API.
	     *
	     * @param isDisabled Sets whether the component is disabled.
	     */
	    /**
	     * Disables the select. Part of the ControlValueAccessor interface required
	     * to integrate with Angular's core forms API.
	     *
	     * @param {?} isDisabled Sets whether the component is disabled.
	     * @return {?}
	     */
	    MatSelect.prototype.setDisabledState = /**
	     * Disables the select. Part of the ControlValueAccessor interface required
	     * to integrate with Angular's core forms API.
	     *
	     * @param {?} isDisabled Sets whether the component is disabled.
	     * @return {?}
	     */
	    function (isDisabled) {
	        this.disabled = isDisabled;
	        this._changeDetectorRef.markForCheck();
	        this.stateChanges.next();
	    };
	    Object.defineProperty(MatSelect.prototype, "panelOpen", {
	        /** Whether or not the overlay panel is open. */
	        get: /**
	         * Whether or not the overlay panel is open.
	         * @return {?}
	         */
	        function () {
	            return this._panelOpen;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSelect.prototype, "selected", {
	        /** The currently selected option. */
	        get: /**
	         * The currently selected option.
	         * @return {?}
	         */
	        function () {
	            return this.multiple ? this._selectionModel.selected : this._selectionModel.selected[0];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSelect.prototype, "triggerValue", {
	        /** The value displayed in the trigger. */
	        get: /**
	         * The value displayed in the trigger.
	         * @return {?}
	         */
	        function () {
	            if (this.empty) {
	                return '';
	            }
	            if (this._multiple) {
	                var /** @type {?} */ selectedOptions = this._selectionModel.selected.map(function (option) { return option.viewValue; });
	                if (this._isRtl()) {
	                    selectedOptions.reverse();
	                }
	                // TODO(crisbeto): delimiter should be configurable for proper localization.
	                return selectedOptions.join(', ');
	            }
	            return this._selectionModel.selected[0].viewValue;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** Whether the element is in RTL mode. */
	    /**
	     * Whether the element is in RTL mode.
	     * @return {?}
	     */
	    MatSelect.prototype._isRtl = /**
	     * Whether the element is in RTL mode.
	     * @return {?}
	     */
	    function () {
	        return this._dir ? this._dir.value === 'rtl' : false;
	    };
	    /** Handles all keydown events on the select. */
	    /**
	     * Handles all keydown events on the select.
	     * @param {?} event
	     * @return {?}
	     */
	    MatSelect.prototype._handleKeydown = /**
	     * Handles all keydown events on the select.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (!this.disabled) {
	            this.panelOpen ? this._handleOpenKeydown(event) : this._handleClosedKeydown(event);
	        }
	    };
	    /**
	     * Handles keyboard events while the select is closed.
	     * @param {?} event
	     * @return {?}
	     */
	    MatSelect.prototype._handleClosedKeydown = /**
	     * Handles keyboard events while the select is closed.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var /** @type {?} */ keyCode = event.keyCode;
	        var /** @type {?} */ isArrowKey = keyCode === _angular_cdk_keycodes.DOWN_ARROW || keyCode === _angular_cdk_keycodes.UP_ARROW ||
	            keyCode === _angular_cdk_keycodes.LEFT_ARROW || keyCode === _angular_cdk_keycodes.RIGHT_ARROW;
	        var /** @type {?} */ isOpenKey = keyCode === _angular_cdk_keycodes.ENTER || keyCode === _angular_cdk_keycodes.SPACE;
	        // Open the select on ALT + arrow key to match the native <select>
	        if (isOpenKey || ((this.multiple || event.altKey) && isArrowKey)) {
	            event.preventDefault(); // prevents the page from scrolling down when pressing space
	            this.open();
	        }
	        else if (!this.multiple) {
	            this._keyManager.onKeydown(event);
	        }
	    };
	    /**
	     * Handles keyboard events when the selected is open.
	     * @param {?} event
	     * @return {?}
	     */
	    MatSelect.prototype._handleOpenKeydown = /**
	     * Handles keyboard events when the selected is open.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var /** @type {?} */ keyCode = event.keyCode;
	        var /** @type {?} */ isArrowKey = keyCode === _angular_cdk_keycodes.DOWN_ARROW || keyCode === _angular_cdk_keycodes.UP_ARROW;
	        var /** @type {?} */ manager = this._keyManager;
	        if (keyCode === _angular_cdk_keycodes.HOME || keyCode === _angular_cdk_keycodes.END) {
	            event.preventDefault();
	            keyCode === _angular_cdk_keycodes.HOME ? manager.setFirstItemActive() : manager.setLastItemActive();
	        }
	        else if (isArrowKey && event.altKey) {
	            // Close the select on ALT + arrow key to match the native <select>
	            event.preventDefault();
	            this.close();
	        }
	        else if ((keyCode === _angular_cdk_keycodes.ENTER || keyCode === _angular_cdk_keycodes.SPACE) && manager.activeItem) {
	            event.preventDefault();
	            manager.activeItem._selectViaInteraction();
	        }
	        else {
	            var /** @type {?} */ previouslyFocusedIndex = manager.activeItemIndex;
	            manager.onKeydown(event);
	            if (this._multiple && isArrowKey && event.shiftKey && manager.activeItem &&
	                manager.activeItemIndex !== previouslyFocusedIndex) {
	                manager.activeItem._selectViaInteraction();
	            }
	        }
	    };
	    /**
	     * When the panel element is finished transforming in (though not fading in), it
	     * emits an event and focuses an option if the panel is open.
	     */
	    /**
	     * When the panel element is finished transforming in (though not fading in), it
	     * emits an event and focuses an option if the panel is open.
	     * @return {?}
	     */
	    MatSelect.prototype._onPanelDone = /**
	     * When the panel element is finished transforming in (though not fading in), it
	     * emits an event and focuses an option if the panel is open.
	     * @return {?}
	     */
	    function () {
	        if (this.panelOpen) {
	            this._scrollTop = 0;
	            this.openedChange.emit(true);
	        }
	        else {
	            this.openedChange.emit(false);
	            this._panelDoneAnimating = false;
	            this.overlayDir.offsetX = 0;
	            this._changeDetectorRef.markForCheck();
	        }
	    };
	    /**
	     * When the panel content is done fading in, the _panelDoneAnimating property is
	     * set so the proper class can be added to the panel.
	     */
	    /**
	     * When the panel content is done fading in, the _panelDoneAnimating property is
	     * set so the proper class can be added to the panel.
	     * @return {?}
	     */
	    MatSelect.prototype._onFadeInDone = /**
	     * When the panel content is done fading in, the _panelDoneAnimating property is
	     * set so the proper class can be added to the panel.
	     * @return {?}
	     */
	    function () {
	        this._panelDoneAnimating = this.panelOpen;
	        this._changeDetectorRef.markForCheck();
	    };
	    /**
	     * @return {?}
	     */
	    MatSelect.prototype._onFocus = /**
	     * @return {?}
	     */
	    function () {
	        if (!this.disabled) {
	            this.focused = true;
	            this.stateChanges.next();
	        }
	    };
	    /**
	     * Calls the touched callback only if the panel is closed. Otherwise, the trigger will
	     * "blur" to the panel when it opens, causing a false positive.
	     */
	    /**
	     * Calls the touched callback only if the panel is closed. Otherwise, the trigger will
	     * "blur" to the panel when it opens, causing a false positive.
	     * @return {?}
	     */
	    MatSelect.prototype._onBlur = /**
	     * Calls the touched callback only if the panel is closed. Otherwise, the trigger will
	     * "blur" to the panel when it opens, causing a false positive.
	     * @return {?}
	     */
	    function () {
	        this.focused = false;
	        if (!this.disabled && !this.panelOpen) {
	            this._onTouched();
	            this._changeDetectorRef.markForCheck();
	            this.stateChanges.next();
	        }
	    };
	    /**
	     * Callback that is invoked when the overlay panel has been attached.
	     */
	    /**
	     * Callback that is invoked when the overlay panel has been attached.
	     * @return {?}
	     */
	    MatSelect.prototype._onAttached = /**
	     * Callback that is invoked when the overlay panel has been attached.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this.overlayDir.positionChange.pipe(rxjs_operators_take.take(1)).subscribe(function () {
	            _this._changeDetectorRef.detectChanges();
	            _this._calculateOverlayOffsetX();
	            _this.panel.nativeElement.scrollTop = _this._scrollTop;
	        });
	    };
	    /** Returns the theme to be used on the panel. */
	    /**
	     * Returns the theme to be used on the panel.
	     * @return {?}
	     */
	    MatSelect.prototype._getPanelTheme = /**
	     * Returns the theme to be used on the panel.
	     * @return {?}
	     */
	    function () {
	        return this._parentFormField ? "mat-" + this._parentFormField.color : '';
	    };
	    Object.defineProperty(MatSelect.prototype, "empty", {
	        /** Whether the select has a value. */
	        get: /**
	         * Whether the select has a value.
	         * @return {?}
	         */
	        function () {
	            return !this._selectionModel || this._selectionModel.isEmpty();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatSelect.prototype._initializeSelection = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        // Defer setting the value in order to avoid the "Expression
	        // has changed after it was checked" errors from Angular.
	        Promise.resolve().then(function () {
	            _this._setSelectionByValue(_this.ngControl ? _this.ngControl.value : _this._value);
	        });
	    };
	    /**
	     * Sets the selected option based on a value. If no option can be
	     * found with the designated value, the select trigger is cleared.
	     * @param {?} value
	     * @param {?=} isUserInput
	     * @return {?}
	     */
	    MatSelect.prototype._setSelectionByValue = /**
	     * Sets the selected option based on a value. If no option can be
	     * found with the designated value, the select trigger is cleared.
	     * @param {?} value
	     * @param {?=} isUserInput
	     * @return {?}
	     */
	    function (value, isUserInput) {
	        var _this = this;
	        if (isUserInput === void 0) { isUserInput = false; }
	        if (this.multiple && value) {
	            if (!Array.isArray(value)) {
	                throw getMatSelectNonArrayValueError();
	            }
	            this._clearSelection();
	            value.forEach(function (currentValue) { return _this._selectValue(currentValue, isUserInput); });
	            this._sortValues();
	        }
	        else {
	            this._clearSelection();
	            var /** @type {?} */ correspondingOption = this._selectValue(value, isUserInput);
	            // Shift focus to the active item. Note that we shouldn't do this in multiple
	            // mode, because we don't know what option the user interacted with last.
	            if (correspondingOption) {
	                this._keyManager.setActiveItem(this.options.toArray().indexOf(correspondingOption));
	            }
	        }
	        this._changeDetectorRef.markForCheck();
	    };
	    /**
	     * Finds and selects and option based on its value.
	     * @param {?} value
	     * @param {?=} isUserInput
	     * @return {?} Option that has the corresponding value.
	     */
	    MatSelect.prototype._selectValue = /**
	     * Finds and selects and option based on its value.
	     * @param {?} value
	     * @param {?=} isUserInput
	     * @return {?} Option that has the corresponding value.
	     */
	    function (value, isUserInput) {
	        var _this = this;
	        if (isUserInput === void 0) { isUserInput = false; }
	        var /** @type {?} */ correspondingOption = this.options.find(function (option) {
	            try {
	                // Treat null as a special reset value.
	                return option.value != null && _this._compareWith(option.value, value);
	            }
	            catch (/** @type {?} */ error) {
	                if (_angular_core.isDevMode()) {
	                    // Notify developers of errors in their comparator.
	                    console.warn(error);
	                }
	                return false;
	            }
	        });
	        if (correspondingOption) {
	            isUserInput ? correspondingOption._selectViaInteraction() : correspondingOption.select();
	            this._selectionModel.select(correspondingOption);
	            this.stateChanges.next();
	        }
	        return correspondingOption;
	    };
	    /**
	     * Clears the select trigger and deselects every option in the list.
	     * @param {?=} skip Option that should not be deselected.
	     * @return {?}
	     */
	    MatSelect.prototype._clearSelection = /**
	     * Clears the select trigger and deselects every option in the list.
	     * @param {?=} skip Option that should not be deselected.
	     * @return {?}
	     */
	    function (skip) {
	        this._selectionModel.clear();
	        this.options.forEach(function (option) {
	            if (option !== skip) {
	                option.deselect();
	            }
	        });
	        this.stateChanges.next();
	    };
	    /**
	     * Sets up a key manager to listen to keyboard events on the overlay panel.
	     * @return {?}
	     */
	    MatSelect.prototype._initKeyManager = /**
	     * Sets up a key manager to listen to keyboard events on the overlay panel.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._keyManager = new _angular_cdk_a11y.ActiveDescendantKeyManager(this.options)
	            .withTypeAhead()
	            .withVerticalOrientation()
	            .withHorizontalOrientation(this._isRtl() ? 'rtl' : 'ltr');
	        this._keyManager.tabOut.pipe(rxjs_operators_takeUntil.takeUntil(this._destroy)).subscribe(function () { return _this.close(); });
	        this._keyManager.change.pipe(rxjs_operators_takeUntil.takeUntil(this._destroy)).subscribe(function () {
	            if (_this._panelOpen && _this.panel) {
	                _this._scrollActiveOptionIntoView();
	            }
	            else if (!_this._panelOpen && !_this.multiple && _this._keyManager.activeItem) {
	                _this._keyManager.activeItem._selectViaInteraction();
	            }
	        });
	    };
	    /**
	     * Drops current option subscriptions and IDs and resets from scratch.
	     * @return {?}
	     */
	    MatSelect.prototype._resetOptions = /**
	     * Drops current option subscriptions and IDs and resets from scratch.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ changedOrDestroyed = rxjs_observable_merge.merge(this.options.changes, this._destroy);
	        this.optionSelectionChanges
	            .pipe(rxjs_operators_takeUntil.takeUntil(changedOrDestroyed), rxjs_operators_filter.filter(function (event) { return event.isUserInput; }))
	            .subscribe(function (event) {
	            _this._onSelect(event.source);
	            if (!_this.multiple && _this._panelOpen) {
	                _this.close();
	                _this.focus();
	            }
	        });
	        // Listen to changes in the internal state of the options and react accordingly.
	        // Handles cases like the labels of the selected options changing.
	        rxjs_observable_merge.merge.apply(void 0, this.options.map(function (option) { return option._stateChanges; })).pipe(rxjs_operators_takeUntil.takeUntil(changedOrDestroyed))
	            .subscribe(function () {
	            _this._changeDetectorRef.markForCheck();
	            _this.stateChanges.next();
	        });
	        this._setOptionIds();
	    };
	    /**
	     * Invoked when an option is clicked.
	     * @param {?} option
	     * @return {?}
	     */
	    MatSelect.prototype._onSelect = /**
	     * Invoked when an option is clicked.
	     * @param {?} option
	     * @return {?}
	     */
	    function (option) {
	        var /** @type {?} */ wasSelected = this._selectionModel.isSelected(option);
	        // TODO(crisbeto): handle blank/null options inside multi-select.
	        if (this.multiple) {
	            this._selectionModel.toggle(option);
	            this.stateChanges.next();
	            wasSelected ? option.deselect() : option.select();
	            this._keyManager.setActiveItem(/** @type {?} */ ((this._getOptionIndex(option))));
	            this._sortValues();
	        }
	        else {
	            this._clearSelection(option.value == null ? undefined : option);
	            if (option.value == null) {
	                this._propagateChanges(option.value);
	            }
	            else {
	                this._selectionModel.select(option);
	                this.stateChanges.next();
	            }
	        }
	        if (wasSelected !== this._selectionModel.isSelected(option)) {
	            this._propagateChanges();
	        }
	    };
	    /**
	     * Sorts the model values, ensuring that they keep the same
	     * order that they have in the panel.
	     * @return {?}
	     */
	    MatSelect.prototype._sortValues = /**
	     * Sorts the model values, ensuring that they keep the same
	     * order that they have in the panel.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._multiple) {
	            this._selectionModel.clear();
	            this.options.forEach(function (option) {
	                if (option.selected) {
	                    _this._selectionModel.select(option);
	                }
	            });
	            this.stateChanges.next();
	        }
	    };
	    /**
	     * Emits change event to set the model value.
	     * @param {?=} fallbackValue
	     * @return {?}
	     */
	    MatSelect.prototype._propagateChanges = /**
	     * Emits change event to set the model value.
	     * @param {?=} fallbackValue
	     * @return {?}
	     */
	    function (fallbackValue) {
	        var /** @type {?} */ valueToEmit = null;
	        if (this.multiple) {
	            valueToEmit = (/** @type {?} */ (this.selected)).map(function (option) { return option.value; });
	        }
	        else {
	            valueToEmit = this.selected ? (/** @type {?} */ (this.selected)).value : fallbackValue;
	        }
	        this._value = valueToEmit;
	        this.valueChange.emit(valueToEmit);
	        this._onChange(valueToEmit);
	        this.selectionChange.emit(new MatSelectChange(this, valueToEmit));
	        this._changeDetectorRef.markForCheck();
	    };
	    /**
	     * Records option IDs to pass to the aria-owns property.
	     * @return {?}
	     */
	    MatSelect.prototype._setOptionIds = /**
	     * Records option IDs to pass to the aria-owns property.
	     * @return {?}
	     */
	    function () {
	        this._optionIds = this.options.map(function (option) { return option.id; }).join(' ');
	    };
	    /**
	     * Highlights the selected item. If no option is selected, it will highlight
	     * the first item instead.
	     * @return {?}
	     */
	    MatSelect.prototype._highlightCorrectOption = /**
	     * Highlights the selected item. If no option is selected, it will highlight
	     * the first item instead.
	     * @return {?}
	     */
	    function () {
	        if (this._keyManager) {
	            if (this.empty) {
	                this._keyManager.setFirstItemActive();
	            }
	            else {
	                this._keyManager.setActiveItem(/** @type {?} */ ((this._getOptionIndex(this._selectionModel.selected[0]))));
	            }
	        }
	    };
	    /**
	     * Scrolls the active option into view.
	     * @return {?}
	     */
	    MatSelect.prototype._scrollActiveOptionIntoView = /**
	     * Scrolls the active option into view.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ activeOptionIndex = this._keyManager.activeItemIndex || 0;
	        var /** @type {?} */ labelCount = _angular_material_core._countGroupLabelsBeforeOption(activeOptionIndex, this.options, this.optionGroups);
	        this.panel.nativeElement.scrollTop = _angular_material_core._getOptionScrollPosition(activeOptionIndex + labelCount, this._getItemHeight(), this.panel.nativeElement.scrollTop, SELECT_PANEL_MAX_HEIGHT);
	    };
	    /** Focuses the select element. */
	    /**
	     * Focuses the select element.
	     * @return {?}
	     */
	    MatSelect.prototype.focus = /**
	     * Focuses the select element.
	     * @return {?}
	     */
	    function () {
	        this._elementRef.nativeElement.focus();
	    };
	    /**
	     * Gets the index of the provided option in the option list.
	     * @param {?} option
	     * @return {?}
	     */
	    MatSelect.prototype._getOptionIndex = /**
	     * Gets the index of the provided option in the option list.
	     * @param {?} option
	     * @return {?}
	     */
	    function (option) {
	        return this.options.reduce(function (result, current, index) {
	            return result === undefined ? (option === current ? index : undefined) : result;
	        }, undefined);
	    };
	    /**
	     * Calculates the scroll position and x- and y-offsets of the overlay panel.
	     * @return {?}
	     */
	    MatSelect.prototype._calculateOverlayPosition = /**
	     * Calculates the scroll position and x- and y-offsets of the overlay panel.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ itemHeight = this._getItemHeight();
	        var /** @type {?} */ items = this._getItemCount();
	        var /** @type {?} */ panelHeight = Math.min(items * itemHeight, SELECT_PANEL_MAX_HEIGHT);
	        var /** @type {?} */ scrollContainerHeight = items * itemHeight;
	        // The farthest the panel can be scrolled before it hits the bottom
	        var /** @type {?} */ maxScroll = scrollContainerHeight - panelHeight;
	        // If no value is selected we open the popup to the first item.
	        var /** @type {?} */ selectedOptionOffset = this.empty ? 0 : /** @type {?} */ ((this._getOptionIndex(this._selectionModel.selected[0])));
	        selectedOptionOffset += _angular_material_core._countGroupLabelsBeforeOption(selectedOptionOffset, this.options, this.optionGroups);
	        // We must maintain a scroll buffer so the selected option will be scrolled to the
	        // center of the overlay panel rather than the top.
	        var /** @type {?} */ scrollBuffer = panelHeight / 2;
	        this._scrollTop = this._calculateOverlayScroll(selectedOptionOffset, scrollBuffer, maxScroll);
	        this._offsetY = this._calculateOverlayOffsetY(selectedOptionOffset, scrollBuffer, maxScroll);
	        this._checkOverlayWithinViewport(maxScroll);
	    };
	    /**
	     * Calculates the scroll position of the select's overlay panel.
	     *
	     * Attempts to center the selected option in the panel. If the option is
	     * too high or too low in the panel to be scrolled to the center, it clamps the
	     * scroll position to the min or max scroll positions respectively.
	     */
	    /**
	     * Calculates the scroll position of the select's overlay panel.
	     *
	     * Attempts to center the selected option in the panel. If the option is
	     * too high or too low in the panel to be scrolled to the center, it clamps the
	     * scroll position to the min or max scroll positions respectively.
	     * @param {?} selectedIndex
	     * @param {?} scrollBuffer
	     * @param {?} maxScroll
	     * @return {?}
	     */
	    MatSelect.prototype._calculateOverlayScroll = /**
	     * Calculates the scroll position of the select's overlay panel.
	     *
	     * Attempts to center the selected option in the panel. If the option is
	     * too high or too low in the panel to be scrolled to the center, it clamps the
	     * scroll position to the min or max scroll positions respectively.
	     * @param {?} selectedIndex
	     * @param {?} scrollBuffer
	     * @param {?} maxScroll
	     * @return {?}
	     */
	    function (selectedIndex, scrollBuffer, maxScroll) {
	        var /** @type {?} */ itemHeight = this._getItemHeight();
	        var /** @type {?} */ optionOffsetFromScrollTop = itemHeight * selectedIndex;
	        var /** @type {?} */ halfOptionHeight = itemHeight / 2;
	        // Starts at the optionOffsetFromScrollTop, which scrolls the option to the top of the
	        // scroll container, then subtracts the scroll buffer to scroll the option down to
	        // the center of the overlay panel. Half the option height must be re-added to the
	        // scrollTop so the option is centered based on its middle, not its top edge.
	        var /** @type {?} */ optimalScrollPosition = optionOffsetFromScrollTop - scrollBuffer + halfOptionHeight;
	        return Math.min(Math.max(0, optimalScrollPosition), maxScroll);
	    };
	    Object.defineProperty(MatSelect.prototype, "_ariaLabel", {
	        /** Returns the aria-label of the select component. */
	        get: /**
	         * Returns the aria-label of the select component.
	         * @return {?}
	         */
	        function () {
	            // If an ariaLabelledby value has been set, the select should not overwrite the
	            // `aria-labelledby` value by setting the ariaLabel to the placeholder.
	            return this.ariaLabelledby ? null : this.ariaLabel || this.placeholder;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** Determines the `aria-activedescendant` to be set on the host. */
	    /**
	     * Determines the `aria-activedescendant` to be set on the host.
	     * @return {?}
	     */
	    MatSelect.prototype._getAriaActiveDescendant = /**
	     * Determines the `aria-activedescendant` to be set on the host.
	     * @return {?}
	     */
	    function () {
	        if (this.panelOpen && this._keyManager && this._keyManager.activeItem) {
	            return this._keyManager.activeItem.id;
	        }
	        return null;
	    };
	    /**
	     * Sets the x-offset of the overlay panel in relation to the trigger's top start corner.
	     * This must be adjusted to align the selected option text over the trigger text when
	     * the panel opens. Will change based on LTR or RTL text direction. Note that the offset
	     * can't be calculated until the panel has been attached, because we need to know the
	     * content width in order to constrain the panel within the viewport.
	     * @return {?}
	     */
	    MatSelect.prototype._calculateOverlayOffsetX = /**
	     * Sets the x-offset of the overlay panel in relation to the trigger's top start corner.
	     * This must be adjusted to align the selected option text over the trigger text when
	     * the panel opens. Will change based on LTR or RTL text direction. Note that the offset
	     * can't be calculated until the panel has been attached, because we need to know the
	     * content width in order to constrain the panel within the viewport.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ overlayRect = this.overlayDir.overlayRef.overlayElement.getBoundingClientRect();
	        var /** @type {?} */ viewportSize = this._viewportRuler.getViewportSize();
	        var /** @type {?} */ isRtl = this._isRtl();
	        var /** @type {?} */ paddingWidth = this.multiple ? SELECT_MULTIPLE_PANEL_PADDING_X + SELECT_PANEL_PADDING_X :
	            SELECT_PANEL_PADDING_X * 2;
	        var /** @type {?} */ offsetX;
	        // Adjust the offset, depending on the option padding.
	        if (this.multiple) {
	            offsetX = SELECT_MULTIPLE_PANEL_PADDING_X;
	        }
	        else {
	            var /** @type {?} */ selected = this._selectionModel.selected[0] || this.options.first;
	            offsetX = selected && selected.group ? SELECT_PANEL_INDENT_PADDING_X : SELECT_PANEL_PADDING_X;
	        }
	        // Invert the offset in LTR.
	        if (!isRtl) {
	            offsetX *= -1;
	        }
	        // Determine how much the select overflows on each side.
	        var /** @type {?} */ leftOverflow = 0 - (overlayRect.left + offsetX - (isRtl ? paddingWidth : 0));
	        var /** @type {?} */ rightOverflow = overlayRect.right + offsetX - viewportSize.width
	            + (isRtl ? 0 : paddingWidth);
	        // If the element overflows on either side, reduce the offset to allow it to fit.
	        if (leftOverflow > 0) {
	            offsetX += leftOverflow + SELECT_PANEL_VIEWPORT_PADDING;
	        }
	        else if (rightOverflow > 0) {
	            offsetX -= rightOverflow + SELECT_PANEL_VIEWPORT_PADDING;
	        }
	        // Set the offset directly in order to avoid having to go through change detection and
	        // potentially triggering "changed after it was checked" errors.
	        this.overlayDir.offsetX = offsetX;
	        this.overlayDir.overlayRef.updatePosition();
	    };
	    /**
	     * Calculates the y-offset of the select's overlay panel in relation to the
	     * top start corner of the trigger. It has to be adjusted in order for the
	     * selected option to be aligned over the trigger when the panel opens.
	     * @param {?} selectedIndex
	     * @param {?} scrollBuffer
	     * @param {?} maxScroll
	     * @return {?}
	     */
	    MatSelect.prototype._calculateOverlayOffsetY = /**
	     * Calculates the y-offset of the select's overlay panel in relation to the
	     * top start corner of the trigger. It has to be adjusted in order for the
	     * selected option to be aligned over the trigger when the panel opens.
	     * @param {?} selectedIndex
	     * @param {?} scrollBuffer
	     * @param {?} maxScroll
	     * @return {?}
	     */
	    function (selectedIndex, scrollBuffer, maxScroll) {
	        var /** @type {?} */ itemHeight = this._getItemHeight();
	        var /** @type {?} */ optionHeightAdjustment = (itemHeight - this._triggerRect.height) / 2;
	        var /** @type {?} */ maxOptionsDisplayed = Math.floor(SELECT_PANEL_MAX_HEIGHT / itemHeight);
	        var /** @type {?} */ optionOffsetFromPanelTop;
	        if (this._scrollTop === 0) {
	            optionOffsetFromPanelTop = selectedIndex * itemHeight;
	        }
	        else if (this._scrollTop === maxScroll) {
	            var /** @type {?} */ firstDisplayedIndex = this._getItemCount() - maxOptionsDisplayed;
	            var /** @type {?} */ selectedDisplayIndex = selectedIndex - firstDisplayedIndex;
	            // The first item is partially out of the viewport. Therefore we need to calculate what
	            // portion of it is shown in the viewport and account for it in our offset.
	            var /** @type {?} */ partialItemHeight = itemHeight - (this._getItemCount() * itemHeight - SELECT_PANEL_MAX_HEIGHT) % itemHeight;
	            // Because the panel height is longer than the height of the options alone,
	            // there is always extra padding at the top or bottom of the panel. When
	            // scrolled to the very bottom, this padding is at the top of the panel and
	            // must be added to the offset.
	            optionOffsetFromPanelTop = selectedDisplayIndex * itemHeight + partialItemHeight;
	        }
	        else {
	            // If the option was scrolled to the middle of the panel using a scroll buffer,
	            // its offset will be the scroll buffer minus the half height that was added to
	            // center it.
	            optionOffsetFromPanelTop = scrollBuffer - itemHeight / 2;
	        }
	        // The final offset is the option's offset from the top, adjusted for the height
	        // difference, multiplied by -1 to ensure that the overlay moves in the correct
	        // direction up the page.
	        return optionOffsetFromPanelTop * -1 - optionHeightAdjustment;
	    };
	    /**
	     * Checks that the attempted overlay position will fit within the viewport.
	     * If it will not fit, tries to adjust the scroll position and the associated
	     * y-offset so the panel can open fully on-screen. If it still won't fit,
	     * sets the offset back to 0 to allow the fallback position to take over.
	     * @param {?} maxScroll
	     * @return {?}
	     */
	    MatSelect.prototype._checkOverlayWithinViewport = /**
	     * Checks that the attempted overlay position will fit within the viewport.
	     * If it will not fit, tries to adjust the scroll position and the associated
	     * y-offset so the panel can open fully on-screen. If it still won't fit,
	     * sets the offset back to 0 to allow the fallback position to take over.
	     * @param {?} maxScroll
	     * @return {?}
	     */
	    function (maxScroll) {
	        var /** @type {?} */ itemHeight = this._getItemHeight();
	        var /** @type {?} */ viewportSize = this._viewportRuler.getViewportSize();
	        var /** @type {?} */ topSpaceAvailable = this._triggerRect.top - SELECT_PANEL_VIEWPORT_PADDING;
	        var /** @type {?} */ bottomSpaceAvailable = viewportSize.height - this._triggerRect.bottom - SELECT_PANEL_VIEWPORT_PADDING;
	        var /** @type {?} */ panelHeightTop = Math.abs(this._offsetY);
	        var /** @type {?} */ totalPanelHeight = Math.min(this._getItemCount() * itemHeight, SELECT_PANEL_MAX_HEIGHT);
	        var /** @type {?} */ panelHeightBottom = totalPanelHeight - panelHeightTop - this._triggerRect.height;
	        if (panelHeightBottom > bottomSpaceAvailable) {
	            this._adjustPanelUp(panelHeightBottom, bottomSpaceAvailable);
	        }
	        else if (panelHeightTop > topSpaceAvailable) {
	            this._adjustPanelDown(panelHeightTop, topSpaceAvailable, maxScroll);
	        }
	        else {
	            this._transformOrigin = this._getOriginBasedOnOption();
	        }
	    };
	    /**
	     * Adjusts the overlay panel up to fit in the viewport.
	     * @param {?} panelHeightBottom
	     * @param {?} bottomSpaceAvailable
	     * @return {?}
	     */
	    MatSelect.prototype._adjustPanelUp = /**
	     * Adjusts the overlay panel up to fit in the viewport.
	     * @param {?} panelHeightBottom
	     * @param {?} bottomSpaceAvailable
	     * @return {?}
	     */
	    function (panelHeightBottom, bottomSpaceAvailable) {
	        // Browsers ignore fractional scroll offsets, so we need to round.
	        var /** @type {?} */ distanceBelowViewport = Math.round(panelHeightBottom - bottomSpaceAvailable);
	        // Scrolls the panel up by the distance it was extending past the boundary, then
	        // adjusts the offset by that amount to move the panel up into the viewport.
	        this._scrollTop -= distanceBelowViewport;
	        this._offsetY -= distanceBelowViewport;
	        this._transformOrigin = this._getOriginBasedOnOption();
	        // If the panel is scrolled to the very top, it won't be able to fit the panel
	        // by scrolling, so set the offset to 0 to allow the fallback position to take
	        // effect.
	        if (this._scrollTop <= 0) {
	            this._scrollTop = 0;
	            this._offsetY = 0;
	            this._transformOrigin = "50% bottom 0px";
	        }
	    };
	    /**
	     * Adjusts the overlay panel down to fit in the viewport.
	     * @param {?} panelHeightTop
	     * @param {?} topSpaceAvailable
	     * @param {?} maxScroll
	     * @return {?}
	     */
	    MatSelect.prototype._adjustPanelDown = /**
	     * Adjusts the overlay panel down to fit in the viewport.
	     * @param {?} panelHeightTop
	     * @param {?} topSpaceAvailable
	     * @param {?} maxScroll
	     * @return {?}
	     */
	    function (panelHeightTop, topSpaceAvailable, maxScroll) {
	        // Browsers ignore fractional scroll offsets, so we need to round.
	        var /** @type {?} */ distanceAboveViewport = Math.round(panelHeightTop - topSpaceAvailable);
	        // Scrolls the panel down by the distance it was extending past the boundary, then
	        // adjusts the offset by that amount to move the panel down into the viewport.
	        this._scrollTop += distanceAboveViewport;
	        this._offsetY += distanceAboveViewport;
	        this._transformOrigin = this._getOriginBasedOnOption();
	        // If the panel is scrolled to the very bottom, it won't be able to fit the
	        // panel by scrolling, so set the offset to 0 to allow the fallback position
	        // to take effect.
	        if (this._scrollTop >= maxScroll) {
	            this._scrollTop = maxScroll;
	            this._offsetY = 0;
	            this._transformOrigin = "50% top 0px";
	            return;
	        }
	    };
	    /**
	     * Sets the transform origin point based on the selected option.
	     * @return {?}
	     */
	    MatSelect.prototype._getOriginBasedOnOption = /**
	     * Sets the transform origin point based on the selected option.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ itemHeight = this._getItemHeight();
	        var /** @type {?} */ optionHeightAdjustment = (itemHeight - this._triggerRect.height) / 2;
	        var /** @type {?} */ originY = Math.abs(this._offsetY) - optionHeightAdjustment + itemHeight / 2;
	        return "50% " + originY + "px 0px";
	    };
	    /**
	     * Calculates the amount of items in the select. This includes options and group labels.
	     * @return {?}
	     */
	    MatSelect.prototype._getItemCount = /**
	     * Calculates the amount of items in the select. This includes options and group labels.
	     * @return {?}
	     */
	    function () {
	        return this.options.length + this.optionGroups.length;
	    };
	    /**
	     * Calculates the height of the select's options.
	     * @return {?}
	     */
	    MatSelect.prototype._getItemHeight = /**
	     * Calculates the height of the select's options.
	     * @return {?}
	     */
	    function () {
	        return this._triggerFontSize * SELECT_ITEM_HEIGHT_EM;
	    };
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * @docs-private
	     */
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @param {?} ids
	     * @return {?}
	     */
	    MatSelect.prototype.setDescribedByIds = /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @param {?} ids
	     * @return {?}
	     */
	    function (ids) {
	        this._ariaDescribedby = ids.join(' ');
	    };
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * @docs-private
	     */
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @return {?}
	     */
	    MatSelect.prototype.onContainerClick = /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @return {?}
	     */
	    function () {
	        this.focus();
	        this.open();
	    };
	    Object.defineProperty(MatSelect.prototype, "shouldPlaceholderFloat", {
	        /**
	         * Implemented as part of MatFormFieldControl.
	         * @docs-private
	         */
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () {
	            return this._panelOpen || !this.empty;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    MatSelect.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-select',
	                    exportAs: 'matSelect',
	                    template: "<div cdk-overlay-origin class=\"mat-select-trigger\" aria-hidden=\"true\" (click)=\"toggle()\" #origin=\"cdkOverlayOrigin\" #trigger><div class=\"mat-select-value\" [ngSwitch]=\"empty\"><span class=\"mat-select-placeholder\" *ngSwitchCase=\"true\">{{placeholder || '\u00A0'}}</span> <span class=\"mat-select-value-text\" *ngSwitchCase=\"false\" [ngSwitch]=\"!!customTrigger\"><span *ngSwitchDefault>{{triggerValue}}</span><ng-content select=\"mat-select-trigger\" *ngSwitchCase=\"true\"></ng-content></span></div><div class=\"mat-select-arrow-wrapper\"><div class=\"mat-select-arrow\"></div></div></div><ng-template cdk-connected-overlay hasBackdrop cdkConnectedOverlayLockPosition backdropClass=\"cdk-overlay-transparent-backdrop\" [scrollStrategy]=\"_scrollStrategy\" [origin]=\"origin\" [open]=\"panelOpen\" [positions]=\"_positions\" [minWidth]=\"_triggerRect?.width\" [offsetY]=\"_offsetY\" (backdropClick)=\"close()\" (attach)=\"_onAttached()\" (detach)=\"close()\"><div #panel class=\"mat-select-panel {{ _getPanelTheme() }}\" [ngClass]=\"panelClass\" [@transformPanel]=\"multiple ? 'showing-multiple' : 'showing'\" (@transformPanel.done)=\"_onPanelDone()\" [style.transformOrigin]=\"_transformOrigin\" [class.mat-select-panel-done-animating]=\"_panelDoneAnimating\" [style.font-size.px]=\"_triggerFontSize\" (keydown)=\"_handleKeydown($event)\"><div class=\"mat-select-content\" [@fadeInContent]=\"'showing'\" (@fadeInContent.done)=\"_onFadeInDone()\"><ng-content></ng-content></div></div></ng-template>",
	                    styles: [".mat-select{display:inline-block;width:100%;outline:0}.mat-select-trigger{display:inline-table;cursor:pointer;position:relative;box-sizing:border-box}.mat-select-disabled .mat-select-trigger{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.mat-select-value{display:table-cell;max-width:0;width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mat-select-value-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.mat-select-arrow-wrapper{display:table-cell;vertical-align:middle}.mat-select-arrow{width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid;margin:0 4px}.mat-select-panel{min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;padding-top:0;padding-bottom:0;max-height:256px;min-width:100%}.mat-select-panel:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}@media screen and (-ms-high-contrast:active){.mat-select-panel{outline:solid 1px}}.mat-select-panel .mat-optgroup-label,.mat-select-panel .mat-option{font-size:inherit;line-height:3em;height:3em}.mat-form-field-type-mat-select:not(.mat-form-field-disabled) .mat-form-field-flex{cursor:pointer}.mat-form-field-type-mat-select .mat-form-field-label{width:calc(100% - 18px)}.mat-select-placeholder{transition:color .4s .133s cubic-bezier(.25,.8,.25,1)}.mat-form-field-hide-placeholder .mat-select-placeholder{color:transparent;transition:none}"],
	                    inputs: ['disabled', 'disableRipple', 'tabIndex'],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    host: {
	                        'role': 'listbox',
	                        '[attr.id]': 'id',
	                        '[attr.tabindex]': 'tabIndex',
	                        '[attr.aria-label]': '_ariaLabel',
	                        '[attr.aria-labelledby]': 'ariaLabelledby',
	                        '[attr.aria-required]': 'required.toString()',
	                        '[attr.aria-disabled]': 'disabled.toString()',
	                        '[attr.aria-invalid]': 'errorState',
	                        '[attr.aria-owns]': 'panelOpen ? _optionIds : null',
	                        '[attr.aria-multiselectable]': 'multiple',
	                        '[attr.aria-describedby]': '_ariaDescribedby || null',
	                        '[attr.aria-activedescendant]': '_getAriaActiveDescendant()',
	                        '[class.mat-select-disabled]': 'disabled',
	                        '[class.mat-select-invalid]': 'errorState',
	                        '[class.mat-select-required]': 'required',
	                        'class': 'mat-select',
	                        '(keydown)': '_handleKeydown($event)',
	                        '(focus)': '_onFocus()',
	                        '(blur)': '_onBlur()',
	                    },
	                    animations: [
	                        matSelectAnimations.transformPanel,
	                        matSelectAnimations.fadeInContent
	                    ],
	                    providers: [
	                        { provide: _angular_material_formField.MatFormFieldControl, useExisting: MatSelect },
	                        { provide: _angular_material_core.MAT_OPTION_PARENT_COMPONENT, useExisting: MatSelect }
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    MatSelect.ctorParameters = function () { return [
	        { type: _angular_cdk_overlay.ViewportRuler, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: _angular_core.NgZone, },
	        { type: _angular_material_core.ErrorStateMatcher, },
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_bidi.Directionality, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_forms.NgForm, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_forms.FormGroupDirective, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_material_formField.MatFormField, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_forms.NgControl, decorators: [{ type: _angular_core.Self }, { type: _angular_core.Optional },] },
	        { type: undefined, decorators: [{ type: _angular_core.Attribute, args: ['tabindex',] },] },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [MAT_SELECT_SCROLL_STRATEGY,] },] },
	    ]; };
	    MatSelect.propDecorators = {
	        "trigger": [{ type: _angular_core.ViewChild, args: ['trigger',] },],
	        "panel": [{ type: _angular_core.ViewChild, args: ['panel',] },],
	        "overlayDir": [{ type: _angular_core.ViewChild, args: [_angular_cdk_overlay.CdkConnectedOverlay,] },],
	        "options": [{ type: _angular_core.ContentChildren, args: [_angular_material_core.MatOption, { descendants: true },] },],
	        "optionGroups": [{ type: _angular_core.ContentChildren, args: [_angular_material_core.MatOptgroup,] },],
	        "panelClass": [{ type: _angular_core.Input },],
	        "customTrigger": [{ type: _angular_core.ContentChild, args: [MatSelectTrigger,] },],
	        "placeholder": [{ type: _angular_core.Input },],
	        "required": [{ type: _angular_core.Input },],
	        "multiple": [{ type: _angular_core.Input },],
	        "compareWith": [{ type: _angular_core.Input },],
	        "value": [{ type: _angular_core.Input },],
	        "ariaLabel": [{ type: _angular_core.Input, args: ['aria-label',] },],
	        "ariaLabelledby": [{ type: _angular_core.Input, args: ['aria-labelledby',] },],
	        "errorStateMatcher": [{ type: _angular_core.Input },],
	        "id": [{ type: _angular_core.Input },],
	        "openedChange": [{ type: _angular_core.Output },],
	        "_openedStream": [{ type: _angular_core.Output, args: ['opened',] },],
	        "_closedStream": [{ type: _angular_core.Output, args: ['closed',] },],
	        "onOpen": [{ type: _angular_core.Output },],
	        "onClose": [{ type: _angular_core.Output },],
	        "selectionChange": [{ type: _angular_core.Output },],
	        "change": [{ type: _angular_core.Output },],
	        "valueChange": [{ type: _angular_core.Output },],
	    };
	    return MatSelect;
	}(_MatSelectMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var MatSelectModule = /** @class */ (function () {
	    function MatSelectModule() {
	    }
	    MatSelectModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [
	                        _angular_common.CommonModule,
	                        _angular_cdk_overlay.OverlayModule,
	                        _angular_material_core.MatOptionModule,
	                        _angular_material_core.MatCommonModule,
	                    ],
	                    exports: [_angular_material_formField.MatFormFieldModule, MatSelect, MatSelectTrigger, _angular_material_core.MatOptionModule, _angular_material_core.MatCommonModule],
	                    declarations: [MatSelect, MatSelectTrigger],
	                    providers: [MAT_SELECT_SCROLL_STRATEGY_PROVIDER, _angular_material_core.ErrorStateMatcher]
	                },] },
	    ];
	    /** @nocollapse */
	    MatSelectModule.ctorParameters = function () { return []; };
	    return MatSelectModule;
	}());
	
	exports.MatSelectModule = MatSelectModule;
	exports.SELECT_PANEL_MAX_HEIGHT = SELECT_PANEL_MAX_HEIGHT;
	exports.SELECT_PANEL_PADDING_X = SELECT_PANEL_PADDING_X;
	exports.SELECT_PANEL_INDENT_PADDING_X = SELECT_PANEL_INDENT_PADDING_X;
	exports.SELECT_ITEM_HEIGHT_EM = SELECT_ITEM_HEIGHT_EM;
	exports.SELECT_MULTIPLE_PANEL_PADDING_X = SELECT_MULTIPLE_PANEL_PADDING_X;
	exports.SELECT_PANEL_VIEWPORT_PADDING = SELECT_PANEL_VIEWPORT_PADDING;
	exports.MAT_SELECT_SCROLL_STRATEGY = MAT_SELECT_SCROLL_STRATEGY;
	exports.MAT_SELECT_SCROLL_STRATEGY_PROVIDER_FACTORY = MAT_SELECT_SCROLL_STRATEGY_PROVIDER_FACTORY;
	exports.MAT_SELECT_SCROLL_STRATEGY_PROVIDER = MAT_SELECT_SCROLL_STRATEGY_PROVIDER;
	exports.MatSelectChange = MatSelectChange;
	exports.MatSelectBase = MatSelectBase;
	exports._MatSelectMixinBase = _MatSelectMixinBase;
	exports.MatSelectTrigger = MatSelectTrigger;
	exports.MatSelect = MatSelect;
	exports.matSelectAnimations = matSelectAnimations;
	exports.transformPanel = transformPanel;
	exports.fadeInContent = fadeInContent;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=material-select.umd.js.map


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1078), __webpack_require__(246), __webpack_require__(205), __webpack_require__(1305), __webpack_require__(327), __webpack_require__(490), __webpack_require__(620), __webpack_require__(240), __webpack_require__(1077), __webpack_require__(768), __webpack_require__(1075)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/cdk/platform', '@angular/common', '@angular/core', '@angular/material/form-field', 'rxjs/observable/fromEvent', 'rxjs/operators/auditTime', 'rxjs/operators/takeUntil', 'rxjs/Subject', '@angular/cdk/coercion', '@angular/forms', '@angular/material/core'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.material = global.ng.material || {}, global.ng.material.input = global.ng.material.input || {}),global.ng.cdk.platform,global.ng.common,global.ng.core,global.ng.material.formField,global.Rx.Observable,global.Rx.operators,global.Rx.operators,global.Rx,global.ng.cdk.coercion,global.ng.forms,global.ng.material.core));
	}(this, (function (exports,_angular_cdk_platform,_angular_common,_angular_core,_angular_material_formField,rxjs_observable_fromEvent,rxjs_operators_auditTime,rxjs_operators_takeUntil,rxjs_Subject,_angular_cdk_coercion,_angular_forms,_angular_material_core) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Directive to automatically resize a textarea to fit its content.
	 */
	var MatTextareaAutosize = /** @class */ (function () {
	    function MatTextareaAutosize(_elementRef, _platform, _ngZone) {
	        this._elementRef = _elementRef;
	        this._platform = _platform;
	        this._ngZone = _ngZone;
	        this._destroyed = new rxjs_Subject.Subject();
	    }
	    Object.defineProperty(MatTextareaAutosize.prototype, "minRows", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._minRows; },
	        set: /**
	         * Minimum amount of rows in the textarea.
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._minRows = value;
	            this._setMinHeight();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatTextareaAutosize.prototype, "maxRows", {
	        get: /**
	         * Maximum amount of rows in the textarea.
	         * @return {?}
	         */
	        function () { return this._maxRows; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._maxRows = value;
	            this._setMaxHeight();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // TODO(crisbeto): make the `_ngZone` a required param in the next major version.
	    /** Sets the minimum height of the textarea as determined by minRows. */
	    /**
	     * Sets the minimum height of the textarea as determined by minRows.
	     * @return {?}
	     */
	    MatTextareaAutosize.prototype._setMinHeight = /**
	     * Sets the minimum height of the textarea as determined by minRows.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ minHeight = this.minRows && this._cachedLineHeight ?
	            this.minRows * this._cachedLineHeight + "px" : null;
	        if (minHeight) {
	            this._setTextareaStyle('minHeight', minHeight);
	        }
	    };
	    /** Sets the maximum height of the textarea as determined by maxRows. */
	    /**
	     * Sets the maximum height of the textarea as determined by maxRows.
	     * @return {?}
	     */
	    MatTextareaAutosize.prototype._setMaxHeight = /**
	     * Sets the maximum height of the textarea as determined by maxRows.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ maxHeight = this.maxRows && this._cachedLineHeight ?
	            this.maxRows * this._cachedLineHeight + "px" : null;
	        if (maxHeight) {
	            this._setTextareaStyle('maxHeight', maxHeight);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatTextareaAutosize.prototype.ngAfterViewInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._platform.isBrowser) {
	            this.resizeToFitContent();
	            if (this._ngZone) {
	                this._ngZone.runOutsideAngular(function () {
	                    rxjs_observable_fromEvent.fromEvent(window, 'resize')
	                        .pipe(rxjs_operators_auditTime.auditTime(16), rxjs_operators_takeUntil.takeUntil(_this._destroyed))
	                        .subscribe(function () { return _this.resizeToFitContent(true); });
	                });
	            }
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatTextareaAutosize.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._destroyed.next();
	        this._destroyed.complete();
	    };
	    /**
	     * Sets a style property on the textarea element.
	     * @param {?} property
	     * @param {?} value
	     * @return {?}
	     */
	    MatTextareaAutosize.prototype._setTextareaStyle = /**
	     * Sets a style property on the textarea element.
	     * @param {?} property
	     * @param {?} value
	     * @return {?}
	     */
	    function (property, value) {
	        var /** @type {?} */ textarea = /** @type {?} */ (this._elementRef.nativeElement);
	        textarea.style[property] = value;
	    };
	    /**
	     * Cache the height of a single-row textarea if it has not already been cached.
	     *
	     * We need to know how large a single "row" of a textarea is in order to apply minRows and
	     * maxRows. For the initial version, we will assume that the height of a single line in the
	     * textarea does not ever change.
	     * @return {?}
	     */
	    MatTextareaAutosize.prototype._cacheTextareaLineHeight = /**
	     * Cache the height of a single-row textarea if it has not already been cached.
	     *
	     * We need to know how large a single "row" of a textarea is in order to apply minRows and
	     * maxRows. For the initial version, we will assume that the height of a single line in the
	     * textarea does not ever change.
	     * @return {?}
	     */
	    function () {
	        if (this._cachedLineHeight) {
	            return;
	        }
	        var /** @type {?} */ textarea = /** @type {?} */ (this._elementRef.nativeElement);
	        // Use a clone element because we have to override some styles.
	        var /** @type {?} */ textareaClone = /** @type {?} */ (textarea.cloneNode(false));
	        textareaClone.rows = 1;
	        // Use `position: absolute` so that this doesn't cause a browser layout and use
	        // `visibility: hidden` so that nothing is rendered. Clear any other styles that
	        // would affect the height.
	        textareaClone.style.position = 'absolute';
	        textareaClone.style.visibility = 'hidden';
	        textareaClone.style.border = 'none';
	        textareaClone.style.padding = '0';
	        textareaClone.style.height = '';
	        textareaClone.style.minHeight = '';
	        textareaClone.style.maxHeight = '';
	        // In Firefox it happens that textarea elements are always bigger than the specified amount
	        // of rows. This is because Firefox tries to add extra space for the horizontal scrollbar.
	        // As a workaround that removes the extra space for the scrollbar, we can just set overflow
	        // to hidden. This ensures that there is no invalid calculation of the line height.
	        // See Firefox bug report: https://bugzilla.mozilla.org/show_bug.cgi?id=33654
	        textareaClone.style.overflow = 'hidden'; /** @type {?} */
	        ((textarea.parentNode)).appendChild(textareaClone);
	        this._cachedLineHeight = textareaClone.clientHeight; /** @type {?} */
	        ((textarea.parentNode)).removeChild(textareaClone);
	        // Min and max heights have to be re-calculated if the cached line height changes
	        this._setMinHeight();
	        this._setMaxHeight();
	    };
	    /**
	     * @return {?}
	     */
	    MatTextareaAutosize.prototype.ngDoCheck = /**
	     * @return {?}
	     */
	    function () {
	        if (this._platform.isBrowser) {
	            this.resizeToFitContent();
	        }
	    };
	    /**
	     * Resize the textarea to fit its content.
	     * @param force Whether to force a height recalculation. By default the height will be
	     *    recalculated only if the value changed since the last call.
	     */
	    /**
	     * Resize the textarea to fit its content.
	     * @param {?=} force Whether to force a height recalculation. By default the height will be
	     *    recalculated only if the value changed since the last call.
	     * @return {?}
	     */
	    MatTextareaAutosize.prototype.resizeToFitContent = /**
	     * Resize the textarea to fit its content.
	     * @param {?=} force Whether to force a height recalculation. By default the height will be
	     *    recalculated only if the value changed since the last call.
	     * @return {?}
	     */
	    function (force) {
	        if (force === void 0) { force = false; }
	        this._cacheTextareaLineHeight();
	        // If we haven't determined the line-height yet, we know we're still hidden and there's no point
	        // in checking the height of the textarea.
	        if (!this._cachedLineHeight) {
	            return;
	        }
	        var /** @type {?} */ textarea = /** @type {?} */ (this._elementRef.nativeElement);
	        var /** @type {?} */ value = textarea.value;
	        // Only resize of the value changed since these calculations can be expensive.
	        if (value === this._previousValue && !force) {
	            return;
	        }
	        var /** @type {?} */ placeholderText = textarea.placeholder;
	        // Reset the textarea height to auto in order to shrink back to its default size.
	        // Also temporarily force overflow:hidden, so scroll bars do not interfere with calculations.
	        // Long placeholders that are wider than the textarea width may lead to a bigger scrollHeight
	        // value. To ensure that the scrollHeight is not bigger than the content, the placeholders
	        // need to be removed temporarily.
	        textarea.style.height = 'auto';
	        textarea.style.overflow = 'hidden';
	        textarea.placeholder = '';
	        // Use the scrollHeight to know how large the textarea *would* be if fit its entire value.
	        textarea.style.height = textarea.scrollHeight + "px";
	        textarea.style.overflow = '';
	        textarea.placeholder = placeholderText;
	        this._previousValue = value;
	    };
	    MatTextareaAutosize.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: "textarea[mat-autosize], textarea[matTextareaAutosize]",
	                    exportAs: 'matTextareaAutosize',
	                    host: {
	                        'class': 'mat-autosize',
	                        // Textarea elements that have the directive applied should have a single row by default.
	                        // Browsers normally show two rows by default and therefore this limits the minRows binding.
	                        'rows': '1',
	                    },
	                },] },
	    ];
	    /** @nocollapse */
	    MatTextareaAutosize.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_platform.Platform, },
	        { type: _angular_core.NgZone, },
	    ]; };
	    MatTextareaAutosize.propDecorators = {
	        "minRows": [{ type: _angular_core.Input, args: ['matAutosizeMinRows',] },],
	        "maxRows": [{ type: _angular_core.Input, args: ['matAutosizeMaxRows',] },],
	    };
	    return MatTextareaAutosize;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 * @param {?} type
	 * @return {?}
	 */
	function getMatInputUnsupportedTypeError(type) {
	    return Error("Input type \"" + type + "\" isn't supported by matInput.");
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * This token is used to inject the object whose value should be set into `MatInput`. If none is
	 * provided, the native `HTMLInputElement` is used. Directives like `MatDatepickerInput` can provide
	 * themselves for this token, in order to make `MatInput` delegate the getting and setting of the
	 * value to them.
	 */
	var MAT_INPUT_VALUE_ACCESSOR = new _angular_core.InjectionToken('MAT_INPUT_VALUE_ACCESSOR');
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	// Invalid input type. Using one of these will throw an MatInputUnsupportedTypeError.
	var MAT_INPUT_INVALID_TYPES = [
	    'button',
	    'checkbox',
	    'file',
	    'hidden',
	    'image',
	    'radio',
	    'range',
	    'reset',
	    'submit'
	];
	var nextUniqueId = 0;
	/**
	 * \@docs-private
	 */
	var MatInputBase = /** @class */ (function () {
	    function MatInputBase(_defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) {
	        this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
	        this._parentForm = _parentForm;
	        this._parentFormGroup = _parentFormGroup;
	        this.ngControl = ngControl;
	    }
	    return MatInputBase;
	}());
	var _MatInputMixinBase = _angular_material_core.mixinErrorState(MatInputBase);
	/**
	 * Directive that allows a native input to work inside a `MatFormField`.
	 */
	var MatInput = /** @class */ (function (_super) {
	    __extends(MatInput, _super);
	    function MatInput(_elementRef, _platform, /** @docs-private */
	        ngControl, _parentForm, _parentFormGroup, _defaultErrorStateMatcher, inputValueAccessor) {
	        var _this = _super.call(this, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) || this;
	        _this._elementRef = _elementRef;
	        _this._platform = _platform;
	        _this.ngControl = ngControl;
	        _this._uid = "mat-input-" + nextUniqueId++;
	        /**
	         * Whether the component is being rendered on the server.
	         */
	        _this._isServer = false;
	        /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         */
	        _this.focused = false;
	        /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         */
	        _this.stateChanges = new rxjs_Subject.Subject();
	        /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         */
	        _this.controlType = 'mat-input';
	        _this._disabled = false;
	        /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         */
	        _this.placeholder = '';
	        _this._required = false;
	        _this._type = 'text';
	        _this._readonly = false;
	        _this._neverEmptyInputTypes = [
	            'date',
	            'datetime',
	            'datetime-local',
	            'month',
	            'time',
	            'week'
	        ].filter(function (t) { return _angular_cdk_platform.getSupportedInputTypes().has(t); });
	        // If no input value accessor was explicitly specified, use the element as the input value
	        // accessor.
	        // If no input value accessor was explicitly specified, use the element as the input value
	        // accessor.
	        _this._inputValueAccessor = inputValueAccessor || _this._elementRef.nativeElement;
	        _this._previousNativeValue = _this.value;
	        // Force setter to be called in case id was not specified.
	        // Force setter to be called in case id was not specified.
	        _this.id = _this.id;
	        // On some versions of iOS the caret gets stuck in the wrong place when holding down the delete
	        // key. In order to get around this we need to "jiggle" the caret loose. Since this bug only
	        // exists on iOS, we only bother to install the listener on iOS.
	        if (_platform.IOS) {
	            _elementRef.nativeElement.addEventListener('keyup', function (event) {
	                var /** @type {?} */ el = /** @type {?} */ (event.target);
	                if (!el.value && !el.selectionStart && !el.selectionEnd) {
	                    // Note: Just setting `0, 0` doesn't fix the issue. Setting `1, 1` fixes it for the first
	                    // time that you type text and then hold delete. Toggling to `1, 1` and then back to
	                    // `0, 0` seems to completely fix it.
	                    el.setSelectionRange(1, 1);
	                    el.setSelectionRange(0, 0);
	                }
	            });
	        }
	        _this._isServer = !_this._platform.isBrowser;
	        return _this;
	    }
	    Object.defineProperty(MatInput.prototype, "disabled", {
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () {
	            if (this.ngControl && this.ngControl.disabled !== null) {
	                return this.ngControl.disabled;
	            }
	            return this._disabled;
	        },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._disabled = _angular_cdk_coercion.coerceBooleanProperty(value);
	            // Browsers may not fire the blur event if the input is disabled too quickly.
	            // Reset from here to ensure that the element doesn't become stuck.
	            if (this.focused) {
	                this.focused = false;
	                this.stateChanges.next();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatInput.prototype, "id", {
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () { return this._id; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._id = value || this._uid; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatInput.prototype, "required", {
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () { return this._required; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._required = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatInput.prototype, "type", {
	        get: /**
	         * Input type of the element.
	         * @return {?}
	         */
	        function () { return this._type; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._type = value || 'text';
	            this._validateType();
	            // When using Angular inputs, developers are no longer able to set the properties on the native
	            // input element. To ensure that bindings for `type` work, we need to sync the setter
	            // with the native property. Textarea elements don't support the type property or attribute.
	            if (!this._isTextarea() && _angular_cdk_platform.getSupportedInputTypes().has(this._type)) {
	                this._elementRef.nativeElement.type = this._type;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatInput.prototype, "value", {
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () { return this._inputValueAccessor.value; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (value !== this.value) {
	                this._inputValueAccessor.value = value;
	                this.stateChanges.next();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatInput.prototype, "readonly", {
	        get: /**
	         * Whether the element is readonly.
	         * @return {?}
	         */
	        function () { return this._readonly; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._readonly = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatInput.prototype.ngOnChanges = /**
	     * @return {?}
	     */
	    function () {
	        this.stateChanges.next();
	    };
	    /**
	     * @return {?}
	     */
	    MatInput.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this.stateChanges.complete();
	    };
	    /**
	     * @return {?}
	     */
	    MatInput.prototype.ngDoCheck = /**
	     * @return {?}
	     */
	    function () {
	        if (this.ngControl) {
	            // We need to re-evaluate this on every change detection cycle, because there are some
	            // error triggers that we can't subscribe to (e.g. parent form submissions). This means
	            // that whatever logic is in here has to be super lean or we risk destroying the performance.
	            this.updateErrorState();
	        }
	        // We need to dirty-check the native element's value, because there are some cases where
	        // we won't be notified when it changes (e.g. the consumer isn't using forms or they're
	        // updating the value using `emitEvent: false`).
	        this._dirtyCheckNativeValue();
	    };
	    /** Focuses the input. */
	    /**
	     * Focuses the input.
	     * @return {?}
	     */
	    MatInput.prototype.focus = /**
	     * Focuses the input.
	     * @return {?}
	     */
	    function () { this._elementRef.nativeElement.focus(); };
	    /** Callback for the cases where the focused state of the input changes. */
	    /**
	     * Callback for the cases where the focused state of the input changes.
	     * @param {?} isFocused
	     * @return {?}
	     */
	    MatInput.prototype._focusChanged = /**
	     * Callback for the cases where the focused state of the input changes.
	     * @param {?} isFocused
	     * @return {?}
	     */
	    function (isFocused) {
	        if (isFocused !== this.focused && !this.readonly) {
	            this.focused = isFocused;
	            this.stateChanges.next();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatInput.prototype._onInput = /**
	     * @return {?}
	     */
	    function () {
	        // This is a noop function and is used to let Angular know whenever the value changes.
	        // Angular will run a new change detection each time the `input` event has been dispatched.
	        // It's necessary that Angular recognizes the value change, because when floatingLabel
	        // is set to false and Angular forms aren't used, the placeholder won't recognize the
	        // value changes and will not disappear.
	        // Listening to the input event wouldn't be necessary when the input is using the
	        // FormsModule or ReactiveFormsModule, because Angular forms also listens to input events.
	    };
	    /** Does some manual dirty checking on the native input `value` property. */
	    /**
	     * Does some manual dirty checking on the native input `value` property.
	     * @return {?}
	     */
	    MatInput.prototype._dirtyCheckNativeValue = /**
	     * Does some manual dirty checking on the native input `value` property.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ newValue = this.value;
	        if (this._previousNativeValue !== newValue) {
	            this._previousNativeValue = newValue;
	            this.stateChanges.next();
	        }
	    };
	    /** Make sure the input is a supported type. */
	    /**
	     * Make sure the input is a supported type.
	     * @return {?}
	     */
	    MatInput.prototype._validateType = /**
	     * Make sure the input is a supported type.
	     * @return {?}
	     */
	    function () {
	        if (MAT_INPUT_INVALID_TYPES.indexOf(this._type) > -1) {
	            throw getMatInputUnsupportedTypeError(this._type);
	        }
	    };
	    /** Checks whether the input type is one of the types that are never empty. */
	    /**
	     * Checks whether the input type is one of the types that are never empty.
	     * @return {?}
	     */
	    MatInput.prototype._isNeverEmpty = /**
	     * Checks whether the input type is one of the types that are never empty.
	     * @return {?}
	     */
	    function () {
	        return this._neverEmptyInputTypes.indexOf(this._type) > -1;
	    };
	    /** Checks whether the input is invalid based on the native validation. */
	    /**
	     * Checks whether the input is invalid based on the native validation.
	     * @return {?}
	     */
	    MatInput.prototype._isBadInput = /**
	     * Checks whether the input is invalid based on the native validation.
	     * @return {?}
	     */
	    function () {
	        // The `validity` property won't be present on platform-server.
	        var /** @type {?} */ validity = (/** @type {?} */ (this._elementRef.nativeElement)).validity;
	        return validity && validity.badInput;
	    };
	    /** Determines if the component host is a textarea. If not recognizable it returns false. */
	    /**
	     * Determines if the component host is a textarea. If not recognizable it returns false.
	     * @return {?}
	     */
	    MatInput.prototype._isTextarea = /**
	     * Determines if the component host is a textarea. If not recognizable it returns false.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ nativeElement = this._elementRef.nativeElement;
	        // In Universal, we don't have access to `nodeName`, but the same can be achieved with `name`.
	        // Note that this shouldn't be necessary once Angular switches to an API that resembles the
	        // DOM closer.
	        var /** @type {?} */ nodeName = this._platform.isBrowser ? nativeElement.nodeName : nativeElement.name;
	        return nodeName ? nodeName.toLowerCase() === 'textarea' : false;
	    };
	    Object.defineProperty(MatInput.prototype, "empty", {
	        /**
	         * Implemented as part of MatFormFieldControl.
	         * @docs-private
	         */
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () {
	            return !this._isNeverEmpty() && !this._elementRef.nativeElement.value && !this._isBadInput();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatInput.prototype, "shouldLabelFloat", {
	        /**
	         * Implemented as part of MatFormFieldControl.
	         * @docs-private
	         */
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () { return this.focused || !this.empty; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * @docs-private
	     */
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @param {?} ids
	     * @return {?}
	     */
	    MatInput.prototype.setDescribedByIds = /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @param {?} ids
	     * @return {?}
	     */
	    function (ids) { this._ariaDescribedby = ids.join(' '); };
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * @docs-private
	     */
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @return {?}
	     */
	    MatInput.prototype.onContainerClick = /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @return {?}
	     */
	    function () { this.focus(); };
	    MatInput.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: "input[matInput], textarea[matInput]",
	                    exportAs: 'matInput',
	                    host: {
	                        'class': 'mat-input-element mat-form-field-autofill-control',
	                        '[class.mat-input-server]': '_isServer',
	                        // Native input properties that are overwritten by Angular inputs need to be synced with
	                        // the native input element. Otherwise property bindings for those don't work.
	                        '[attr.id]': 'id',
	                        '[placeholder]': 'placeholder',
	                        '[disabled]': 'disabled',
	                        '[required]': 'required',
	                        '[readonly]': 'readonly',
	                        '[attr.aria-describedby]': '_ariaDescribedby || null',
	                        '[attr.aria-invalid]': 'errorState',
	                        '[attr.aria-required]': 'required.toString()',
	                        '(blur)': '_focusChanged(false)',
	                        '(focus)': '_focusChanged(true)',
	                        '(input)': '_onInput()',
	                    },
	                    providers: [{ provide: _angular_material_formField.MatFormFieldControl, useExisting: MatInput }],
	                },] },
	    ];
	    /** @nocollapse */
	    MatInput.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_platform.Platform, },
	        { type: _angular_forms.NgControl, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self },] },
	        { type: _angular_forms.NgForm, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_forms.FormGroupDirective, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_material_core.ErrorStateMatcher, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [MAT_INPUT_VALUE_ACCESSOR,] },] },
	    ]; };
	    MatInput.propDecorators = {
	        "disabled": [{ type: _angular_core.Input },],
	        "id": [{ type: _angular_core.Input },],
	        "placeholder": [{ type: _angular_core.Input },],
	        "required": [{ type: _angular_core.Input },],
	        "type": [{ type: _angular_core.Input },],
	        "errorStateMatcher": [{ type: _angular_core.Input },],
	        "value": [{ type: _angular_core.Input },],
	        "readonly": [{ type: _angular_core.Input },],
	    };
	    return MatInput;
	}(_MatInputMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatInputModule = /** @class */ (function () {
	    function MatInputModule() {
	    }
	    MatInputModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    declarations: [
	                        MatInput,
	                        MatTextareaAutosize,
	                    ],
	                    imports: [
	                        _angular_common.CommonModule,
	                        _angular_material_formField.MatFormFieldModule,
	                        _angular_cdk_platform.PlatformModule,
	                    ],
	                    exports: [
	                        _angular_material_formField.MatFormFieldModule,
	                        MatInput,
	                        MatTextareaAutosize,
	                    ],
	                    providers: [_angular_material_core.ErrorStateMatcher],
	                },] },
	    ];
	    /** @nocollapse */
	    MatInputModule.ctorParameters = function () { return []; };
	    return MatInputModule;
	}());
	
	exports.MatInputModule = MatInputModule;
	exports.MatTextareaAutosize = MatTextareaAutosize;
	exports.MatInputBase = MatInputBase;
	exports._MatInputMixinBase = _MatInputMixinBase;
	exports.MatInput = MatInput;
	exports.getMatInputUnsupportedTypeError = getMatInputUnsupportedTypeError;
	exports.MAT_INPUT_VALUE_ACCESSOR = MAT_INPUT_VALUE_ACCESSOR;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=material-input.umd.js.map


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var profile_user_details_1 = __webpack_require__(1314);
	var profile_user_role_details_1 = __webpack_require__(1320);
	var profile_user_role_accounts_details_1 = __webpack_require__(1323);
	exports.SHARED_PROFILE_USER_COMPONENTS = [
	    profile_user_details_1.ProfileUserDetailsComponent,
	    profile_user_role_details_1.ProfileUserRoleDetailsComponent,
	    profile_user_role_accounts_details_1.ProfileUserRoleAccountsDetailsComponent
	];


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1315));


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var customer_profile_users_service_1 = __webpack_require__(1316);
	var notification_1 = __webpack_require__(264);
	var translate_1 = __webpack_require__(302);
	var option_dialog_1 = __webpack_require__(1317);
	var security_1 = __webpack_require__(736);
	var DETAILS_SHOW_KEY = 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.SHOW_ROLE_DETAILS';
	var DETAILS_HIDE_KEY = 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.HIDE_ROLE_DETAILS';
	var KEYS = 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.';
	// Enabling 2FA goes through a queue: the authenticator needs a moment before the new state can be read
	var TWO_FA_REFRESH_DELAY_MS = 3000;
	var ProfileUserDetailsComponent = (function () {
	    function ProfileUserDetailsComponent(_customerProfileUsersService, _notificationManager, _translateManager) {
	        this._customerProfileUsersService = _customerProfileUsersService;
	        this._notificationManager = _notificationManager;
	        this._translateManager = _translateManager;
	        this.usersTabRoute = security_1.CUSTOMER_USERS_TAB_ROUTE;
	        // The users list shows the role too: tell it when it changes (own role, make/remove administrator)
	        this.roleChanged = new core_1.EventEmitter();
	        this.loadError = null;
	        this.twoFaBusy = false;
	        this.adminBusy = false;
	        this.selectedProfileUser = null;
	        this.securityActivity = null;
	        this.showSecurityActivity = false;
	        this.loadingSecurityActivity = false;
	        this.phoneEditMode = false;
	        this.phoneValue = '';
	        this.savingPhone = false;
	        this.phoneError = null;
	        this.phoneSaved = false;
	    }
	    ProfileUserDetailsComponent.prototype.ngOnInit = function () {
	        this.showDetails();
	    };
	    ProfileUserDetailsComponent.prototype.showDetails = function (reopenRoleDetails) {
	        var _this = this;
	        if (reopenRoleDetails === void 0) { reopenRoleDetails = false; }
	        this.loadError = null;
	        this._customerProfileUsersService.getProfileUserDetail(this.profileId, this.profileUserId)
	            .subscribe(function (profileUser) {
	            var roleWasOpen = !!(_this.selectedProfileUser && _this.selectedProfileUser.showDetails);
	            var previousRole = _this.profileUser ? _this.profileUser.userRelatedRole : undefined;
	            _this.profileUser = profileUser;
	            if (previousRole !== undefined && previousRole !== profileUser.userRelatedRole) {
	                _this.roleChanged.emit(profileUser.userRelatedRole);
	            }
	            _this.selectedProfileUser = null;
	            if ((roleWasOpen || reopenRoleDetails) && profileUser.userRelatedRoleId) {
	                _this.toggleRoleDetails(profileUser);
	            }
	        }, function (error) { return _this.loadError = _this.errorMessage(error); });
	    };
	    ProfileUserDetailsComponent.prototype.onOwnRoleCreated = function () {
	        // Close the role section first so it is rebuilt with the new role once the user is reloaded
	        this.selectedProfileUser = null;
	        this.showDetails(true);
	    };
	    Object.defineProperty(ProfileUserDetailsComponent.prototype, "isAdministrator", {
	        get: function () {
	            return !!this.profileUser && (this.profileUser.userRelatedRole || '').toUpperCase() === 'ADMIN_ROLE';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ProfileUserDetailsComponent.prototype.changeAdministrator = function () {
	        var _this = this;
	        if (this.adminBusy || !this.profileUser) {
	            return;
	        }
	        var removing = this.isAdministrator;
	        var dialogKey = KEYS + (removing ? 'REMOVE_ADMIN_DIALOG.MESSAGE' : 'MAKE_ADMIN_DIALOG.MESSAGE');
	        this.dialog
	            .showConfirmDialog({
	            title: KEYS + 'ADMIN_DIALOG_TITLE',
	            descriptionLines: [{ key: dialogKey, params: { user: this.profileUser.userName, id: this.profileUser.id } }],
	            confirmButtonText: KEYS + (removing ? 'REMOVE_ADMIN' : 'MAKE_ADMIN'),
	            cancelButtonText: 'CUSTOMER.DETAILS.TAB.USERS.CANCEL',
	            confirmButtonClass: removing ? 'btn-danger' : 'btn-primary'
	        })
	            .onConfirmAction(function () {
	            _this.adminBusy = true;
	            var request = removing
	                ? _this._customerProfileUsersService.removeAdministrator(_this.profileId, _this.profileUserId)
	                : _this._customerProfileUsersService.makeAdministrator(_this.profileId, _this.profileUserId);
	            request.subscribe(function (response) {
	                _this.adminBusy = false;
	                _this._notificationManager.success(response && response.message, 5000);
	                _this.onOwnRoleCreated();
	            }, function (error) {
	                _this.adminBusy = false;
	                _this._notificationManager.error(_this.errorMessage(error));
	            });
	        });
	    };
	    ProfileUserDetailsComponent.prototype.toggleRoleDetails = function (profileUser) {
	        if (this.selectedProfileUser && this.selectedProfileUser.id === profileUser.id) {
	            this.selectedProfileUser.showDetails = !this.selectedProfileUser.showDetails;
	        }
	        else {
	            if (this.selectedProfileUser) {
	                this.selectedProfileUser.showDetails = false;
	            }
	            profileUser.showDetails = true;
	            this.selectedProfileUser = profileUser;
	        }
	    };
	    ProfileUserDetailsComponent.prototype.getActionProfileUserRoleDetailText = function (showDetails) {
	        return showDetails ? DETAILS_HIDE_KEY : DETAILS_SHOW_KEY;
	    };
	    ProfileUserDetailsComponent.prototype.active2FA = function (profileUserId) {
	        var _this = this;
	        this.twoFaBusy = true;
	        this._customerProfileUsersService.active2FA(profileUserId)
	            .subscribe(function () {
	            _this._notificationManager.success(_this._translateManager.getValue(KEYS + 'TWO_FA_REQUESTED'), 5000);
	            _this.afterTwoFaChange(TWO_FA_REFRESH_DELAY_MS);
	        }, function (error) { return _this.onTwoFaError(error); });
	    };
	    ProfileUserDetailsComponent.prototype.disable2FA = function (profileUserId) {
	        var _this = this;
	        this.confirmTwoFaChange(KEYS + 'DISABLE_2FA_DIALOG.MESSAGE', KEYS + 'DISABLE_2FA', function () {
	            return _this._customerProfileUsersService.disable2FA(profileUserId)
	                .subscribe(function () { return _this.afterTwoFaChange(0); }, function (error) { return _this.onTwoFaError(error); });
	        });
	    };
	    ProfileUserDetailsComponent.prototype.disableTotp = function (profileUserId) {
	        var _this = this;
	        this.confirmTwoFaChange(KEYS + 'DISABLE_TOTP_DIALOG.MESSAGE', KEYS + 'DISABLE_TOTP', function () {
	            return _this._customerProfileUsersService.disableTotp(profileUserId)
	                .subscribe(function () { return _this.afterTwoFaChange(0); }, function (error) { return _this.onTwoFaError(error); });
	        });
	    };
	    ProfileUserDetailsComponent.prototype.confirmTwoFaChange = function (messageKey, confirmKey, action) {
	        var _this = this;
	        this.dialog
	            .showConfirmDialog({
	            title: KEYS + 'TWO_FA_DIALOG_TITLE',
	            descriptionLines: [{ key: messageKey, params: { user: this.profileUser && this.profileUser.userName } }],
	            confirmButtonText: confirmKey,
	            cancelButtonText: 'CUSTOMER.DETAILS.TAB.USERS.CANCEL',
	            confirmButtonClass: 'btn-danger'
	        })
	            .onConfirmAction(function () {
	            _this.twoFaBusy = true;
	            action();
	        });
	    };
	    ProfileUserDetailsComponent.prototype.afterTwoFaChange = function (delayMs) {
	        var _this = this;
	        // The security panel is cached: drop it so it shows the new state next time it is opened
	        this.securityActivity = null;
	        this.showSecurityActivity = false;
	        setTimeout(function () {
	            _this.twoFaBusy = false;
	            _this.showDetails();
	        }, delayMs);
	    };
	    ProfileUserDetailsComponent.prototype.onTwoFaError = function (error) {
	        this.twoFaBusy = false;
	        this._notificationManager.error(this.errorMessage(error));
	    };
	    ProfileUserDetailsComponent.prototype.errorMessage = function (error) {
	        return (error && error.message) || this._translateManager.getValue(KEYS + 'ACTION_ERROR');
	    };
	    ProfileUserDetailsComponent.prototype.get2FATypeLabel = function () {
	        if (!this.profileUser) {
	            return this._translateManager.getValue(KEYS + 'NONE');
	        }
	        var types = [];
	        if (this.profileUser.totpEnabled) {
	            types.push('TOTP (App)');
	        }
	        if (this.profileUser.emailSmsEnabled) {
	            types.push('Email + SMS');
	        }
	        return types.length > 0 ? types.join(', ') : this._translateManager.getValue(KEYS + 'NONE');
	    };
	    ProfileUserDetailsComponent.prototype.toggleSecurityActivity = function () {
	        var _this = this;
	        if (this.showSecurityActivity) {
	            this.showSecurityActivity = false;
	            return;
	        }
	        if (this.securityActivity) {
	            this.showSecurityActivity = true;
	            return;
	        }
	        this.loadingSecurityActivity = true;
	        this._customerProfileUsersService.getSecurityActivity(this.profileId, this.profileUserId)
	            .subscribe(function (data) {
	            _this.securityActivity = data;
	            _this.showSecurityActivity = true;
	            _this.loadingSecurityActivity = false;
	        }, function (error) {
	            _this.loadingSecurityActivity = false;
	            _this._notificationManager.error(_this.errorMessage(error));
	        });
	    };
	    ProfileUserDetailsComponent.prototype.startPhoneEdit = function () {
	        this.phoneValue = '';
	        this.phoneError = null;
	        this.phoneSaved = false;
	        this.phoneEditMode = true;
	    };
	    ProfileUserDetailsComponent.prototype.cancelPhoneEdit = function () {
	        this.phoneEditMode = false;
	        this.phoneError = null;
	    };
	    ProfileUserDetailsComponent.prototype.savePhone = function () {
	        var _this = this;
	        if (!this.phoneValue || !this.phoneValue.trim()) {
	            this.phoneError = this._translateManager.getValue(KEYS + 'PHONE_EMPTY');
	            return;
	        }
	        this.savingPhone = true;
	        this.phoneError = null;
	        this._customerProfileUsersService.updateUserPhone(this.profileId, this.profileUserId, this.phoneValue.trim())
	            .subscribe(function () {
	            _this.savingPhone = false;
	            _this.phoneEditMode = false;
	            _this.phoneSaved = true;
	            // Update the displayed phone in the security panel
	            if (_this.securityActivity) {
	                _this.securityActivity.currentPhone = _this.phoneValue.trim();
	            }
	        }, function (error) {
	            _this.savingPhone = false;
	            _this.phoneError = (error && error.message) || _this._translateManager.getValue(KEYS + 'PHONE_SAVE_ERROR');
	        });
	    };
	    ProfileUserDetailsComponent.prototype.getLastLogin = function () {
	        if (!this.securityActivity || !this.securityActivity.loginHistory) {
	            return null;
	        }
	        for (var i = 0; i < this.securityActivity.loginHistory.length; i++) {
	            if (this.securityActivity.loginHistory[i].actionCode === 'LOG_IN') {
	                return this.securityActivity.loginHistory[i];
	            }
	        }
	        return null;
	    };
	    ProfileUserDetailsComponent.prototype.getActionCodeClass = function (code) {
	        switch (code) {
	            case 'LOG_IN': return 'label-success';
	            case 'LOG_OUT': return 'label-default';
	            case 'LOG_IN_FAILED': return 'label-warning';
	            case 'LOG_IN_BLOCKED': return 'label-danger';
	            case 'TWO_FA_SUCCESS': return 'label-info';
	            case 'TWO_FA_FAILED': return 'label-danger';
	            default: return 'label-default';
	        }
	    };
	    __decorate([
	        core_1.Input('profile-user-id'),
	        __metadata("design:type", Number)
	    ], ProfileUserDetailsComponent.prototype, "profileUserId", void 0);
	    __decorate([
	        core_1.Input('profile-id'),
	        __metadata("design:type", Number)
	    ], ProfileUserDetailsComponent.prototype, "profileId", void 0);
	    __decorate([
	        core_1.Input('profile-user-role-id'),
	        __metadata("design:type", Number)
	    ], ProfileUserDetailsComponent.prototype, "profileUserRoleId", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", Object)
	    ], ProfileUserDetailsComponent.prototype, "roleChanged", void 0);
	    __decorate([
	        option_dialog_1.InjectOptionDialog(),
	        __metadata("design:type", Object)
	    ], ProfileUserDetailsComponent.prototype, "dialog", void 0);
	    ProfileUserDetailsComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-profile-user-details',
	            template: __webpack_require__(1319)
	        }),
	        __metadata("design:paramtypes", [customer_profile_users_service_1.CustomerProfileUsersService,
	            notification_1.NotificationManager,
	            translate_1.TranslateManager])
	    ], ProfileUserDetailsComponent);
	    return ProfileUserDetailsComponent;
	}());
	exports.ProfileUserDetailsComponent = ProfileUserDetailsComponent;


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var http_1 = __webpack_require__(836);
	var core_1 = __webpack_require__(205);
	var search_api_observable_service_1 = __webpack_require__(1176);
	var CustomerProfileUsersService = (function () {
	    function CustomerProfileUsersService(_http, _searchApiObservableService) {
	        this._http = _http;
	        this._searchApiObservableService = _searchApiObservableService;
	    }
	    CustomerProfileUsersService.prototype.getProfileStatesForRegisteredClients = function () {
	        return this._http.get('/api/backoffice/customers/registered/users/states').map(function (response) { return response.json(); });
	    };
	    CustomerProfileUsersService.prototype.getAllProfileUsers = function (profileId, filterModel) {
	        return this._searchApiObservableService
	            .searchRequestForUrl("/api/backoffice/customers/" + profileId + "/users/search", filterModel);
	    };
	    CustomerProfileUsersService.prototype.getProfileUserDetail = function (profileId, profileUserId) {
	        return this._http.get("/api/backoffice/customers/" + profileId + "/users/" + profileUserId + "/details").map(function (response) { return response.json(); });
	    };
	    CustomerProfileUsersService.prototype.getProfileUserRoleDetail = function (profileUserRoleId) {
	        return this._http.get("/api/backoffice/customers/profile-user-role/details/" + profileUserRoleId).map(function (response) { return response.json(); });
	    };
	    CustomerProfileUsersService.prototype.getProfileUserRoleAccounts = function (profileId, profileUserRoleId) {
	        return this._http.get("/api/backoffice/customers/profile/" + profileId + "/role-accounts/" + profileUserRoleId).map(function (response) { return response.json(); });
	    };
	    CustomerProfileUsersService.prototype.addAccount = function (profileUserRoleId, accountId) {
	        return this._http.post('api/backoffice/customers/account/' + profileUserRoleId + '/' + accountId, {})
	            .map(function (request) {
	            var body = request.json();
	            return {
	                message: body.message.toString(),
	            };
	        });
	    };
	    CustomerProfileUsersService.prototype.deleteAccountFromRole = function (profileUserRoleId, accountId) {
	        return this._http.post('api/backoffice/customers/delete-account-role/' + profileUserRoleId + '/' + accountId, {})
	            .map(function (request) {
	            var body = request.json();
	            return {
	                message: body.message.toString(),
	            };
	        });
	    };
	    // Moves the user from a role shared with other users to a copy of it of its own (same permissions and accounts)
	    CustomerProfileUsersService.prototype.giveOwnRole = function (profileId, profileUserId) {
	        return this._http.post("/api/backoffice/customers/" + profileId + "/users/" + profileUserId + "/own-role", {})
	            .map(function (response) { return response.json(); });
	    };
	    // ADMIN_ROLE: every account of the customer, full permissions and the CO admin section
	    CustomerProfileUsersService.prototype.makeAdministrator = function (profileId, profileUserId) {
	        return this._http.post("/api/backoffice/customers/" + profileId + "/users/" + profileUserId + "/admin-role", {})
	            .map(function (response) { return response.json(); });
	    };
	    // The user goes back to a role of their own (USER_<id>)
	    CustomerProfileUsersService.prototype.removeAdministrator = function (profileId, profileUserId) {
	        return this._http.post("/api/backoffice/customers/" + profileId + "/users/" + profileUserId + "/remove-admin-role", {})
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileUsersService.prototype.active2FA = function (profileUserId) {
	        return this._http.post('api/backoffice/customers/twoFa/enable/' + profileUserId, {})
	            .map(function () { return ({}); });
	    };
	    CustomerProfileUsersService.prototype.disable2FA = function (profileUserId) {
	        return this._http.post('api/backoffice/customers/twoFa/disable/' + profileUserId, {})
	            .map(function () { return ({}); });
	    };
	    CustomerProfileUsersService.prototype.disableTotp = function (profileUserId) {
	        return this._http.post("api/backoffice/customers/twoFa/totp/disable/" + profileUserId, {})
	            .map(function () { return ({}); });
	    };
	    CustomerProfileUsersService.prototype.get2FAStatus = function (profileUserId) {
	        return this._http.get("api/backoffice/customers/twoFa/status/" + profileUserId)
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileUsersService.prototype.getSecurityActivity = function (profileId, profileUserId) {
	        return this._http.get("/api/backoffice/customers/" + profileId + "/users/" + profileUserId + "/security-activity")
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileUsersService.prototype.updateUserPhone = function (profileId, profileUserId, phone) {
	        return this._http.put("/api/backoffice/customers/" + profileId + "/users/" + profileUserId + "/phone", { phone: phone })
	            .map(function () { return ({}); });
	    };
	    CustomerProfileUsersService.prototype.changeProfileUserState = function (userId, state) {
	        return this._http
	            .patch("/api/backoffice/customers/" + userId + "/update/state", { state: state })
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileUsersService.prototype.addUser = function (email, profileId) {
	        return this._http.patch("api/backoffice/customers/" + profileId + "/new-user", {
	            email: email
	        })
	            .map(function (request) {
	            var body = request.json();
	        });
	    };
	    // Manual creation of an authorised (secondary) user, collecting the same mandatory data the
	    // invitation form would collect. Returns the generated credentials { email, password, userId }.
	    CustomerProfileUsersService.prototype.createAuthorisedUserManually = function (profileId, request) {
	        return this._http
	            .post("/api/backoffice/customers/" + profileId + "/authorised-user", request)
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileUsersService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http,
	            search_api_observable_service_1.SearchApiObservableService])
	    ], CustomerProfileUsersService);
	    return CustomerProfileUsersService;
	}());
	exports.CustomerProfileUsersService = CustomerProfileUsersService;


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var option_dialog_component_1 = __webpack_require__(1318);
	__export(__webpack_require__(1234));
	__export(__webpack_require__(1232));
	exports.OPTION_DIALOG_COMPONENTS = [
	    option_dialog_component_1.OptionDialogComponent
	];


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var util_1 = __webpack_require__(743);
	var core_1 = __webpack_require__(205);
	var option_dialog_accessor_1 = __webpack_require__(1233);
	var option_dialog_1 = __webpack_require__(1234);
	var OptionDialogComponent = (function () {
	    function OptionDialogComponent(_cdr) {
	        this._cdr = _cdr;
	        this.descriptionLines = [];
	        this.visible = false;
	        this.confirmButtonClass = "btn-danger";
	        this.minlength = 1;
	        this.maxlength = 150;
	    }
	    OptionDialogComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._subscription = option_dialog_accessor_1.OptionDialogStaticAccessor.onOptionDialogShow(function (controller) {
	            // Only respond if this dialog instance matches the requested ID
	            // or if no specific ID was set on this component (backward compatibility)
	            if (!!controller && (!_this.id || controller.id === _this.id)) {
	                _this.value = controller.opts.value;
	                _this.controller = controller;
	                _this.dialogId = controller.id;
	                _this.title = controller.opts.title;
	                _this.message = controller.opts.message;
	                _this.descriptionLines = controller.opts.descriptionLines || [];
	                _this.warning = controller.opts.warning;
	                _this.confirmButtonText = controller.opts.confirmButtonText || 'COMMON.CONFIRM';
	                _this.cancelButtonText = controller.opts.cancelButtonText || 'COMMON.CANCEL';
	                _this.confirmButtonClass = controller.opts.confirmButtonClass || _this.confirmButtonClass;
	                _this.minlength = lodash_1.get(controller, 'inputOpts.minlength', 1);
	                _this.maxlength = lodash_1.get(controller, 'inputOpts.maxlength', 150);
	                _this.visible = true;
	                _this._cdr.detectChanges();
	            }
	        });
	    };
	    OptionDialogComponent.prototype.ngOnDestroy = function () {
	        if (!!this._subscription) {
	            this._subscription.unsubscribe();
	        }
	    };
	    OptionDialogComponent.prototype.apply = function () {
	        this.controller.onApply(this.value);
	        this.visible = false;
	        this._cdr.detectChanges();
	    };
	    OptionDialogComponent.prototype.cancel = function () {
	        this.controller.onCancel(this.value);
	        this.visible = false;
	        this._cdr.detectChanges();
	    };
	    OptionDialogComponent.prototype.isEmptyData = function () {
	        if (this.isInputDialogType()) {
	            return util_1.isNullOrUndefined(this.value)
	                || lodash_1.trim(this.value).length < this.minlength;
	        }
	        return false;
	    };
	    OptionDialogComponent.prototype.isConfirmDialogType = function () {
	        return this.controller.opts.type === option_dialog_1.OptionDialogType.CONFIRM;
	    };
	    OptionDialogComponent.prototype.isInputDialogType = function () {
	        return this.controller.opts.type === option_dialog_1.OptionDialogType.INPUT;
	    };
	    OptionDialogComponent.prototype.isMessageDialogType = function () {
	        return this.controller.opts.type === option_dialog_1.OptionDialogType.MESSAGE;
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], OptionDialogComponent.prototype, "id", void 0);
	    OptionDialogComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-option-dialog',
	            template: "\n        <div *ngIf=\"visible\" [id]=\"dialogId\" class=\"modal fade in\" role=\"dialog\" style=\"display: block;\">\n            <div class=\"modal-dialog\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header\">\n                        <h4 class=\"modal-title\">{{ title | translate }}</h4>\n                    </div>\n\n                    <div class=\"modal-body\">\n                        <p *ngFor=\"let line of descriptionLines\" class=\"option-dialog-description\">\n                            {{ line.key | translate:line.params }}\n                        </p>\n\n                        <h5 [innerHtml]=\"message | translate\"></h5>\n\n                        <div *ngIf=\"warning\" class=\"alert alert-warning option-dialog-warning\">\n                            {{ warning.key | translate:warning.params }}\n                        </div>\n\n                        <div *ngIf=\"isInputDialogType()\">\n                            <!-- TODO Mikhail add input field customization -->\n                            <input id=\"{{ dialogId + '-input' }}\" class=\"form-control\" type=\"text\" [(ngModel)]=\"value\"\n                                   required maxlength=\"{{maxlength}}\" autocomplete=\"off\"/>\n                        </div>\n                    </div>\n\n                    <div class=\"modal-footer\">\n                        <button id=\"{{ dialogId + '-confirm' }}\"\n                                type=\"button\" class=\"btn\"\n                                [ngClass]=\"confirmButtonClass\"\n                                (click)=\"apply()\" [disabled]=\"isEmptyData()\">\n                            {{ confirmButtonText | translate }}\n                        </button>\n\n                        <button id=\"{{ dialogId + '-cancel' }}\"\n                                *ngIf=\"!isMessageDialogType()\"\n                                type=\"button\" class=\"btn btn-default\" (click)=\"cancel()\">\n                            {{ cancelButtonText | translate }}\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    "
	        }),
	        __metadata("design:paramtypes", [core_1.ChangeDetectorRef])
	    ], OptionDialogComponent);
	    return OptionDialogComponent;
	}());
	exports.OptionDialogComponent = OptionDialogComponent;


/***/ }),
/* 1319 */
/***/ (function(module, exports) {

	module.exports = "<div>\n    <table [id]=\"'profile-user-details-table-' + profileUserId\" class=\"table profile-user-details-table\">\n        <thead>\n        <tr>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.ID' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.FULL_NAME' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.FIRST_NAME' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.LAST_NAME' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.USER_NAME' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.CREATE_TIME' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.STATE' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.USER_RELATED_ROLE' | translate }}</th>\n            <th *ngIf=\"profileUser?.userRelatedRole\">{{ 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.ACTION' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.TWO_FA_TITLE' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.TWO_FA_ACTIONS' | translate }}</th>\n        </tr>\n        </thead>\n        <tbody *ngIf=\"profileUser\">\n        <tr>\n            <td>{{ profileUser.id }}</td>\n            <td>{{ profileUser.fullName }}</td>\n            <td>{{ profileUser.firstName }}</td>\n            <td>{{ profileUser.lastName }}</td>\n            <td>{{ profileUser.userName }}</td>\n            <td>{{ profileUser.createTime }}</td>\n            <td>{{ profileUser.state }}</td>\n            <td>\n                {{ profileUser.userRelatedRole || ('CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.NO_ROLES_ASSOCIATED' | translate) }}\n                <div *ifHasRoles=\"'EDIT';hide:true;route:usersTabRoute\">\n                    <span *ngIf=\"adminBusy\"><i class=\"fa fa-spinner fa-spin\"></i></span>\n                    <a *ngIf=\"!adminBusy\" href=\"javascript:void(0)\" class=\"action-associate\"\n                       [style.color]=\"isAdministrator ? '#c9302c' : null\"\n                       (click)=\"changeAdministrator()\">\n                        {{ (isAdministrator ? 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.REMOVE_ADMIN'\n                                            : 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.MAKE_ADMIN') | translate }}\n                    </a>\n                </div>\n            </td>\n            <td *ngIf=\"profileUser.userRelatedRole\">\n                <a href=\"javascript:void(0)\" class=\"view-details-link\" style=\"margin-left: 10px;\"\n                   (click)=\"toggleRoleDetails(profileUser)\">\n                    {{ getActionProfileUserRoleDetailText(profileUser.showDetails) | translate }}\n                </a>\n            </td>\n            <td>\n                <div class=\"twofa-status-badges\">\n                    <span *ngIf=\"!profileUser.active2FA\"\n                          class=\"label label-default\">\n                        {{ 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.NONE' | translate }}\n                    </span>\n                    <span *ngIf=\"profileUser.totpEnabled\"\n                          class=\"label label-success\"\n                          title=\"Google Authenticator / TOTP App\">\n                        TOTP (App)\n                    </span>\n                    <span *ngIf=\"profileUser.emailSmsEnabled\"\n                          class=\"label label-info\"\n                          title=\"Email + SMS verification codes\">\n                        Email + SMS\n                    </span>\n                </div>\n            </td>\n            <td>\n                <div class=\"twofa-actions\" *ifHasRoles=\"'EDIT';hide:true;route:usersTabRoute\">\n                    <span *ngIf=\"twoFaBusy\"><i class=\"fa fa-spinner fa-spin\"></i></span>\n                    <ng-container *ngIf=\"!twoFaBusy\">\n                        <a *ngIf=\"!profileUser.active2FA\"\n                           href=\"javascript:void(0)\"\n                           (click)=\"active2FA(profileUser.id)\"\n                           class=\"action-associate\"\n                           title=\"Enable Email+SMS 2FA for this user\">\n                            {{ 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.ACTIVE_2FA' | translate }}\n                        </a>\n                        <a *ngIf=\"profileUser.totpEnabled\"\n                           href=\"javascript:void(0)\"\n                           (click)=\"disableTotp(profileUser.id)\"\n                           class=\"action-associate\"\n                           style=\"color: #d9534f; display: block; margin-bottom: 4px;\"\n                           title=\"Disable TOTP (Google Authenticator) for this user\">\n                            {{ 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.DISABLE_TOTP' | translate }}\n                        </a>\n                        <a *ngIf=\"profileUser.active2FA\"\n                           href=\"javascript:void(0)\"\n                           (click)=\"disable2FA(profileUser.id)\"\n                           class=\"action-associate\"\n                           style=\"color: #c9302c; display: block;\"\n                           title=\"Disable ALL 2FA methods for this user\">\n                            {{ 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.DISABLE_2FA' | translate }}\n                        </a>\n                    </ng-container>\n                </div>\n            </td>\n        </tr>\n        </tbody>\n        <tbody *ngIf=\"!profileUser\">\n        <tr>\n            <td colspan=\"11\" class=\"text-center\">\n                <h4 *ngIf=\"loadError\" class=\"text-danger\">{{ loadError }}</h4>\n                <h4 *ngIf=\"!loadError\">{{ 'CUSTOMER.DETAILS.TAB.USERS.LOADING' | translate }}</h4>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n\n    <div class=\"row\" *ngIf=\"selectedProfileUser?.showDetails\">\n        <div class=\"col-xs-12 profile-user-role-details\">\n            <strong>{{ 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.USER_RELATED_ROLE_DETAILS' | translate }}</strong>\n            <tfl-profile-user-role-details\n                *ngIf=\"selectedProfileUser.showDetails\"\n                [profile-user-role-id]=\"selectedProfileUser.userRelatedRoleId\"\n                [profile-user-id]=\"profileUserId\"\n                [profile-id]=\"profileId\"\n                (ownRoleCreated)=\"onOwnRoleCreated()\">\n            </tfl-profile-user-role-details>\n        </div>\n    </div>\n\n    <!-- 2FA & Login Activity Toggle -->\n    <div class=\"row\" style=\"margin-top: 12px;\" *ngIf=\"profileUser\">\n        <div class=\"col-xs-12\">\n            <button class=\"btn btn-sm btn-default\" (click)=\"toggleSecurityActivity()\" [disabled]=\"loadingSecurityActivity\">\n                <span *ngIf=\"loadingSecurityActivity\"><i class=\"fa fa-spinner fa-spin\"></i>\n                    {{ 'CUSTOMER.DETAILS.TAB.USERS.LOADING' | translate }}</span>\n                <span *ngIf=\"!loadingSecurityActivity\">\n                    <i class=\"fa\" [ngClass]=\"showSecurityActivity ? 'fa-chevron-up' : 'fa-shield'\"></i>\n                    {{ (showSecurityActivity ? 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.SECURITY_HIDE'\n                        : 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.SECURITY_SHOW') | translate }}\n                </span>\n            </button>\n        </div>\n    </div>\n\n    <!-- 2FA & Login Activity Panel -->\n    <div *ngIf=\"showSecurityActivity && securityActivity\" style=\"margin-top: 16px; border: 1px solid #ddd; border-radius: 4px; padding: 16px; background: #fafafa;\">\n\n        <!-- Last Seen Summary -->\n        <div *ngIf=\"getLastLogin()\" style=\"background: #e8f4fd; border: 1px solid #bde0f5; border-radius: 4px; padding: 10px 14px; margin-bottom: 14px; display: flex; align-items: center; gap: 8px; font-size: 12px;\">\n            <i class=\"fa fa-clock-o\" style=\"color: #2980b9;\"></i>\n            <strong style=\"color: #2c3e50;\">Last seen:</strong>\n            <span style=\"color: #555;\">{{ getLastLogin().timestamp }}</span>\n            <span style=\"color: #999;\">from</span>\n            <code style=\"font-size: 11px; color: #2980b9;\">{{ getLastLogin().ipAddress || '—' }}</code>\n            <span style=\"color: #999;\" *ngIf=\"getLastLogin().browser\">via {{ getLastLogin().browser }}\n                <span *ngIf=\"getLastLogin().os\"> / {{ getLastLogin().os }}</span>\n            </span>\n        </div>\n\n        <!-- Status Cards — Row 1 -->\n        <div class=\"row\" style=\"margin-bottom: 10px;\">\n            <div class=\"col-xs-12 col-sm-4\">\n                <div style=\"background: #fff; border: 1px solid #e0e0e0; border-radius: 4px; padding: 12px; text-align: center;\">\n                    <div style=\"font-size: 11px; text-transform: uppercase; color: #888; margin-bottom: 4px;\">Account Status</div>\n                    <span *ngIf=\"securityActivity.accountLocked\" class=\"label label-danger\" style=\"font-size: 13px; padding: 5px 10px;\">\n                        <i class=\"fa fa-lock\"></i> LOCKED\n                    </span>\n                    <span *ngIf=\"!securityActivity.accountLocked\" class=\"label label-success\" style=\"font-size: 13px; padding: 5px 10px;\">\n                        <i class=\"fa fa-unlock\"></i> ACTIVE\n                    </span>\n                    <div *ngIf=\"securityActivity.hackAttempts > 0\" style=\"margin-top: 6px; font-size: 12px; color: #c0392b;\">\n                        {{ securityActivity.hackAttempts }} failed attempt(s)\n                    </div>\n                    <div *ngIf=\"securityActivity.lockTime\" style=\"font-size: 11px; color: #888; margin-top: 4px;\">\n                        Lock set: {{ securityActivity.lockTime }}\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-xs-12 col-sm-4\">\n                <div style=\"background: #fff; border: 1px solid #e0e0e0; border-radius: 4px; padding: 12px; text-align: center;\">\n                    <div style=\"font-size: 11px; text-transform: uppercase; color: #888; margin-bottom: 6px;\">2FA Methods</div>\n                    <div>\n                        <span *ngIf=\"!securityActivity.totpEnabled && !securityActivity.emailSmsEnabled\" class=\"label label-default\">None</span>\n                        <span *ngIf=\"securityActivity.totpEnabled\" class=\"label label-success\" style=\"margin-right: 4px; display: inline-block; margin-bottom: 3px;\">\n                            <i class=\"fa fa-mobile\"></i> TOTP (App)\n                        </span>\n                        <span *ngIf=\"securityActivity.emailSmsEnabled\" class=\"label label-info\" style=\"display: inline-block; margin-bottom: 3px;\">\n                            <i class=\"fa fa-envelope\"></i> Email + SMS\n                        </span>\n                    </div>\n                    <div *ngIf=\"securityActivity.preferredChannel\" style=\"margin-top: 6px; font-size: 11px; color: #555;\">\n                        Preferred: <span class=\"label label-warning\" style=\"font-size: 10px;\">{{ securityActivity.preferredChannel }}</span>\n                    </div>\n                    <div *ngIf=\"!securityActivity.preferredChannel && securityActivity.emailSmsEnabled\" style=\"margin-top: 6px; font-size: 11px; color: #888;\">\n                        (both channels)\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-xs-12 col-sm-4\">\n                <div style=\"background: #fff; border: 1px solid #e0e0e0; border-radius: 4px; padding: 12px; text-align: center; min-height: 90px;\">\n                    <div style=\"font-size: 11px; text-transform: uppercase; color: #888; margin-bottom: 4px;\">SMS Phone</div>\n                    <div *ngIf=\"!phoneEditMode\">\n                        <span *ngIf=\"securityActivity.currentPhone\" style=\"font-size: 13px; font-weight: bold; color: #27ae60; display: block; margin-bottom: 4px;\">\n                            <i class=\"fa fa-phone\"></i> {{ securityActivity.currentPhone }}\n                        </span>\n                        <span *ngIf=\"!securityActivity.currentPhone\" class=\"label label-danger\" style=\"display: inline-block; margin-bottom: 6px; font-size: 12px;\">\n                            <i class=\"fa fa-exclamation-triangle\"></i> No phone set\n                        </span>\n                        <div *ifHasRoles=\"'EDIT';hide:true;route:usersTabRoute\">\n                            <a href=\"javascript:void(0)\" (click)=\"startPhoneEdit()\" class=\"action-associate\" style=\"font-size: 11px;\">\n                                <i class=\"fa fa-pencil\"></i> {{ securityActivity.currentPhone ? 'Change' : 'Set phone' }}\n                            </a>\n                        </div>\n                        <span *ngIf=\"phoneSaved\" style=\"font-size: 11px; color: #27ae60;\"><i class=\"fa fa-check\"></i> Saved</span>\n                    </div>\n                    <div *ngIf=\"phoneEditMode\" style=\"text-align: left;\">\n                        <input type=\"text\" class=\"form-control input-sm\" placeholder=\"+34 600 000 000\" [(ngModel)]=\"phoneValue\" style=\"margin-bottom: 4px;\" />\n                        <div *ngIf=\"phoneError\" style=\"font-size: 11px; color: #c0392b; margin-bottom: 4px;\">{{ phoneError }}</div>\n                        <a href=\"javascript:void(0)\" (click)=\"savePhone()\" class=\"btn btn-xs btn-success\" [class.disabled]=\"savingPhone\" style=\"margin-right: 4px;\">\n                            <i class=\"fa\" [ngClass]=\"savingPhone ? 'fa-spinner fa-spin' : 'fa-save'\"></i> Save\n                        </a>\n                        <a href=\"javascript:void(0)\" (click)=\"cancelPhoneEdit()\" class=\"btn btn-xs btn-default\">Cancel</a>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <!-- Status Cards — Row 2 -->\n        <div class=\"row\" style=\"margin-bottom: 16px;\">\n            <div class=\"col-xs-12 col-sm-6\">\n                <div style=\"background: #fff; border: 1px solid #e0e0e0; border-radius: 4px; padding: 12px;\">\n                    <div style=\"font-size: 11px; text-transform: uppercase; color: #888; margin-bottom: 6px;\">\n                        <i class=\"fa fa-envelope\" style=\"color: #3498db;\"></i> Email for OTP\n                    </div>\n                    <span *ngIf=\"securityActivity.username\" style=\"font-size: 13px; color: #2c3e50; word-break: break-all;\">\n                        <i class=\"fa fa-at\" style=\"color: #3498db; margin-right: 4px;\"></i>{{ securityActivity.username }}\n                    </span>\n                    <span *ngIf=\"!securityActivity.username\" class=\"text-muted\" style=\"font-size: 12px;\">—</span>\n                    <div style=\"font-size: 10px; color: #aaa; margin-top: 4px;\">\n                        Email verification codes will be sent to this address\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-xs-12 col-sm-6\">\n                <div style=\"background: #fff; border: 1px solid #e0e0e0; border-radius: 4px; padding: 12px;\">\n                    <div style=\"font-size: 11px; text-transform: uppercase; color: #888; margin-bottom: 6px;\">\n                        <i class=\"fa fa-cog\" style=\"color: #95a5a6;\"></i> Email+SMS Service ID\n                        <span title=\"Internal registration ID in the external authenticator service. Present only when Email+SMS 2FA is active.\"\n                              style=\"cursor: help; color: #bbb; margin-left: 4px;\">\n                            <i class=\"fa fa-question-circle\"></i>\n                        </span>\n                    </div>\n                    <code style=\"font-size: 10px; word-break: break-all; color: #555;\">\n                        {{ securityActivity.authenticatorUserUuid || '—' }}\n                    </code>\n                    <div style=\"font-size: 10px; color: #aaa; margin-top: 4px;\">\n                        <span *ngIf=\"securityActivity.authenticatorUserUuid\" class=\"label label-success\" style=\"font-size: 9px;\">Registered</span>\n                        <span *ngIf=\"!securityActivity.authenticatorUserUuid\" class=\"label label-default\" style=\"font-size: 9px;\">Not registered</span>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <!-- Login History Table -->\n        <h5 style=\"border-bottom: 1px solid #eee; padding-bottom: 6px; margin-bottom: 8px;\">\n            <i class=\"fa fa-history\"></i> Login &amp; 2FA Event History\n            <small>(last 100)</small>\n        </h5>\n        <div style=\"overflow-x: auto; max-height: 320px; overflow-y: auto;\">\n            <table class=\"table table-condensed table-hover\" style=\"font-size: 12px; margin-bottom: 0;\">\n                <thead style=\"position: sticky; top: 0; background: #f5f5f5; z-index: 1;\">\n                <tr>\n                    <th style=\"white-space: nowrap;\">Date &amp; Time</th>\n                    <th>Event</th>\n                    <th>IP Address</th>\n                    <th>Browser</th>\n                    <th>OS</th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr *ngFor=\"let entry of securityActivity.loginHistory\">\n                    <td style=\"white-space: nowrap; color: #555;\">{{ entry.timestamp }}</td>\n                    <td>\n                        <span class=\"label\" [ngClass]=\"getActionCodeClass(entry.actionCode)\">\n                            {{ entry.action }}\n                        </span>\n                    </td>\n                    <td><code style=\"font-size: 11px;\">{{ entry.ipAddress || '—' }}</code></td>\n                    <td style=\"color: #666;\">{{ entry.browser || '—' }}</td>\n                    <td style=\"color: #666;\">{{ entry.os || '—' }}</td>\n                </tr>\n                <tr *ngIf=\"!securityActivity.loginHistory || securityActivity.loginHistory.length === 0\">\n                    <td colspan=\"5\" class=\"text-center text-muted\">No login history found</td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n\n        <!-- 2FA Reset History Table -->\n        <h5 style=\"border-bottom: 1px solid #eee; padding-bottom: 6px; margin-top: 20px; margin-bottom: 8px;\">\n            <i class=\"fa fa-key\"></i> 2FA Reset Requests\n            <small>(last 20)</small>\n        </h5>\n        <div *ngIf=\"!securityActivity.resetHistory || securityActivity.resetHistory.length === 0\" class=\"text-muted\" style=\"font-size: 12px; padding: 8px 0;\">\n            No 2FA reset requests found.\n        </div>\n        <div *ngIf=\"securityActivity.resetHistory && securityActivity.resetHistory.length > 0\" style=\"overflow-x: auto;\">\n            <table class=\"table table-condensed table-hover\" style=\"font-size: 12px; margin-bottom: 0;\">\n                <thead style=\"background: #f5f5f5;\">\n                <tr>\n                    <th>Requested At</th>\n                    <th>Expires At</th>\n                    <th>Type</th>\n                    <th>Status</th>\n                    <th>Email sent to</th>\n                    <th>SMS sent to</th>\n                    <th>Email OTP</th>\n                    <th>SMS OTP</th>\n                    <th>Attempts</th>\n                    <th>IP Address</th>\n                    <th>Completed At</th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr *ngFor=\"let reset of securityActivity.resetHistory\">\n                    <td style=\"white-space: nowrap; color: #555;\">{{ reset.createdAt }}</td>\n                    <td style=\"white-space: nowrap; color: #888; font-size: 11px;\">{{ reset.expiresAt || '—' }}</td>\n                    <td><span class=\"label label-default\">{{ reset.resetType || '—' }}</span></td>\n                    <td>\n                        <span *ngIf=\"reset.completed\" class=\"label label-success\">Completed</span>\n                        <span *ngIf=\"reset.expired && !reset.completed\" class=\"label label-danger\">Expired</span>\n                        <span *ngIf=\"!reset.completed && !reset.expired\" class=\"label label-warning\">Pending</span>\n                    </td>\n                    <td style=\"font-size: 11px; color: #555; max-width: 140px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\" title=\"{{ reset.email }}\">\n                        <i class=\"fa fa-envelope-o\" style=\"color: #888; margin-right: 3px;\"></i>{{ reset.email || '—' }}\n                    </td>\n                    <td style=\"font-size: 11px; color: #555;\">\n                        <span *ngIf=\"reset.phone\">\n                            <i class=\"fa fa-phone\" style=\"color: #27ae60; margin-right: 3px;\"></i>{{ reset.phone }}\n                        </span>\n                        <span *ngIf=\"!reset.phone\" class=\"text-muted\" title=\"No phone configured at the time of request\">\n                            <i class=\"fa fa-ban\"></i> —\n                        </span>\n                    </td>\n                    <td>\n                        <i class=\"fa\" [ngClass]=\"reset.emailOtpVerified ? 'fa-check-circle text-success' : 'fa-times-circle text-danger'\"></i>\n                    </td>\n                    <td>\n                        <i class=\"fa\" [ngClass]=\"reset.smsOtpVerified ? 'fa-check-circle text-success' : (reset.phone ? 'fa-times-circle text-danger' : 'fa-minus-circle text-muted')\" [title]=\"reset.phone ? '' : 'SMS not available (no phone)'\"></i>\n                    </td>\n                    <td>{{ reset.verificationAttempts }}</td>\n                    <td><code style=\"font-size: 11px;\">{{ reset.ipAddress || '—' }}</code></td>\n                    <td style=\"white-space: nowrap; color: #555;\">{{ reset.completedAt || '—' }}</td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1321));


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var customer_profile_users_service_1 = __webpack_require__(1316);
	var DETAILS_SHOW_KEY = 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.SHOW_ROLE_ACCOUNT_DETAILS';
	var DETAILS_HIDE_KEY = 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.HIDE_ROLE_ACCOUNT_DETAILS';
	var ProfileUserRoleDetailsComponent = (function () {
	    function ProfileUserRoleDetailsComponent(_customerProfileUsersService) {
	        this._customerProfileUsersService = _customerProfileUsersService;
	        this.ownRoleCreated = new core_1.EventEmitter();
	        this.loadError = null;
	        this.showAccountsTable = null;
	        this.associatedAccountsCount = 0;
	    }
	    ProfileUserRoleDetailsComponent.prototype.ngOnInit = function () {
	        this.showDetails();
	    };
	    ProfileUserRoleDetailsComponent.prototype.showDetails = function () {
	        var _this = this;
	        this.loadError = null;
	        this._customerProfileUsersService.getProfileUserRoleDetail(this.profileUserRoleId)
	            .subscribe(function (profileUserRole) {
	            _this.profileUserRole = profileUserRole;
	            // The admin role sees every account even without links: the table shows the real number
	            _this.associatedAccountsCount = (profileUserRole.accounts || []).length;
	        }, function (error) { return _this.loadError = (error && error.message) || 'Error'; });
	    };
	    ProfileUserRoleDetailsComponent.prototype.toggleAccountsTable = function (profileUserRole) {
	        if (this.showAccountsTable && this.showAccountsTable.id === profileUserRole.id) {
	            this.showAccountsTable.showDetails = !this.showAccountsTable.showDetails;
	        }
	        else {
	            if (this.showAccountsTable) {
	                this.showAccountsTable.showDetails = false;
	            }
	            profileUserRole.showDetails = true;
	            this.showAccountsTable = profileUserRole;
	        }
	    };
	    ProfileUserRoleDetailsComponent.prototype.getActionProfileUserRoleAccountDetailText = function (showDetails) {
	        return showDetails ? DETAILS_HIDE_KEY : DETAILS_SHOW_KEY;
	    };
	    Object.defineProperty(ProfileUserRoleDetailsComponent.prototype, "roleUserNames", {
	        get: function () {
	            return ((this.profileUserRole && this.profileUserRole.users) || []).map(function (user) { return user.userName; }).join(', ');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ProfileUserRoleDetailsComponent.prototype.updateAssociatedAccountsCount = function (count) {
	        this.associatedAccountsCount = count;
	    };
	    __decorate([
	        core_1.Input('profile-id'),
	        __metadata("design:type", Number)
	    ], ProfileUserRoleDetailsComponent.prototype, "profileId", void 0);
	    __decorate([
	        core_1.Input('profile-user-role-id'),
	        __metadata("design:type", Number)
	    ], ProfileUserRoleDetailsComponent.prototype, "profileUserRoleId", void 0);
	    __decorate([
	        core_1.Input('profile-user-id'),
	        __metadata("design:type", Number)
	    ], ProfileUserRoleDetailsComponent.prototype, "profileUserId", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", Object)
	    ], ProfileUserRoleDetailsComponent.prototype, "ownRoleCreated", void 0);
	    ProfileUserRoleDetailsComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-profile-user-role-details',
	            template: __webpack_require__(1322)
	        }),
	        __metadata("design:paramtypes", [customer_profile_users_service_1.CustomerProfileUsersService])
	    ], ProfileUserRoleDetailsComponent);
	    return ProfileUserRoleDetailsComponent;
	}());
	exports.ProfileUserRoleDetailsComponent = ProfileUserRoleDetailsComponent;


/***/ }),
/* 1322 */
/***/ (function(module, exports) {

	module.exports = "<div>\n    <table [id]=\"'profile-user-role-details-table-' + profileUserRoleId\" class=\"table profile-user-role-details-table\">\n        <thead>\n        <tr>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.ID' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.ROLE_NAME' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.USERS_WITH_ROLE' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.CREATE_TIME' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.CREATE_PAYMENT' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.AUTHORIZE_PAYMENT' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.STATEMENTS' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.HISTORY' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.PAYMENT_AMOUNT' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.AUTHORIZE_AMOUNT' | translate }}</th>\n            <th>\n                {{ 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.ASSOCIATED_ACCOUNTS' | translate }}\n                <span *ngIf=\"!profileUserRole?.isAdminRole\">({{ associatedAccountsCount }})</span>\n            </th>\n        </tr>\n        </thead>\n        <tbody *ngIf=\"profileUserRole\">\n        <tr>\n            <td>{{ profileUserRole.id }}</td>\n            <td>{{ profileUserRole.roleName }}</td>\n            <td>\n                <span class=\"label\" [ngClass]=\"profileUserRole.users?.length > 1 ? 'label-warning' : 'label-default'\"\n                      [title]=\"roleUserNames\">\n                    {{ profileUserRole.users?.length || 0 }}\n                </span>\n                <small class=\"text-muted\">{{ roleUserNames }}</small>\n            </td>\n            <td>{{ profileUserRole.createTime }}</td>\n            <td>{{ (profileUserRole.createPayment ? 'CUSTOMER.DETAILS.TAB.USERS.YES' : 'CUSTOMER.DETAILS.TAB.USERS.NO') | translate }}</td>\n            <td>{{ (profileUserRole.authorizePayment ? 'CUSTOMER.DETAILS.TAB.USERS.YES' : 'CUSTOMER.DETAILS.TAB.USERS.NO') | translate }}</td>\n            <td>{{ (profileUserRole.statements ? 'CUSTOMER.DETAILS.TAB.USERS.YES' : 'CUSTOMER.DETAILS.TAB.USERS.NO') | translate }}</td>\n            <td>{{ (profileUserRole.history ? 'CUSTOMER.DETAILS.TAB.USERS.YES' : 'CUSTOMER.DETAILS.TAB.USERS.NO') | translate }}</td>\n            <td>{{ profileUserRole.paymentAmount }}</td>\n            <td>{{ profileUserRole.authorizeAmount }}</td>\n            <td>\n                <span *ngIf=\"profileUserRole.isAdminRole\" class=\"label label-info\">\n                    {{ 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.ALL_ACCOUNTS' | translate }}\n                </span>\n                <a href=\"javascript:void(0)\" class=\"view-details-link\" style=\"margin-left: 10px;\"\n                   (click)=\"toggleAccountsTable(profileUserRole)\">\n                    {{ getActionProfileUserRoleAccountDetailText(profileUserRole.showDetails) | translate }}\n                </a>\n            </td>\n        </tr>\n        </tbody>\n        <tbody *ngIf=\"!profileUserRole\">\n        <tr>\n            <td colspan=\"11\" class=\"text-center\">\n                <h4 *ngIf=\"loadError\" class=\"text-danger\">{{ loadError }}</h4>\n                <h4 *ngIf=\"!loadError\">{{ 'CUSTOMER.DETAILS.TAB.USERS.LOADING' | translate }}</h4>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n\n    <div class=\"row\" *ngIf=\"showAccountsTable?.showDetails\">\n        <div class=\"col-xs-12 profile-user-role-details\">\n            <tfl-profile-user-role-accounts-details\n                *ngIf=\"showAccountsTable.showDetails\"\n                [profile-user-role-id]=\"profileUserRole.id\"\n                [profile-id]=\"profileId\"\n                [profile-user-id]=\"profileUserId\"\n                (accountsCountChange)=\"updateAssociatedAccountsCount($event)\"\n                (ownRoleCreated)=\"ownRoleCreated.emit()\">\n            </tfl-profile-user-role-accounts-details>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1324));


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var customer_profile_users_service_1 = __webpack_require__(1316);
	var notification_1 = __webpack_require__(264);
	var translate_1 = __webpack_require__(302);
	var option_dialog_1 = __webpack_require__(1317);
	var security_1 = __webpack_require__(736);
	var KEYS = 'CUSTOMER.DETAILS.TAB.USERS.ROLE_ACCOUNTS.';
	var ProfileUserRoleAccountsDetailsComponent = (function () {
	    function ProfileUserRoleAccountsDetailsComponent(_customerProfileUsersService, _notificationManager, _translateManager) {
	        this._customerProfileUsersService = _customerProfileUsersService;
	        this._notificationManager = _notificationManager;
	        this._translateManager = _translateManager;
	        this.usersTabRoute = security_1.CUSTOMER_USERS_TAB_ROUTE;
	        this.accountsCountChange = new core_1.EventEmitter();
	        this.ownRoleCreated = new core_1.EventEmitter();
	        this.accounts = [];
	        this.loading = false;
	        this.loadError = null;
	        // Account being linked or unlinked: blocks the buttons until the server answers (no double clicks)
	        this.busyAccountId = null;
	        this.givingOwnRole = false;
	    }
	    ProfileUserRoleAccountsDetailsComponent.prototype.ngOnInit = function () {
	        this.loadAccounts();
	    };
	    Object.defineProperty(ProfileUserRoleAccountsDetailsComponent.prototype, "roleUsers", {
	        get: function () {
	            return (this.profileRoleFull && this.profileRoleFull.users) || [];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ProfileUserRoleAccountsDetailsComponent.prototype, "isShared", {
	        get: function () {
	            return this.roleUsers.length > 1;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ProfileUserRoleAccountsDetailsComponent.prototype, "otherUserNames", {
	        get: function () {
	            return this.roleUsers.map(function (user) { return user.userName; }).join(', ');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ProfileUserRoleAccountsDetailsComponent.prototype, "linkedCount", {
	        get: function () {
	            return this.accounts.filter(function (account) { return account.associated; }).length;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ProfileUserRoleAccountsDetailsComponent.prototype.loadAccounts = function () {
	        var _this = this;
	        this.loading = true;
	        this.loadError = null;
	        this._customerProfileUsersService.getProfileUserRoleAccounts(this.profileId, this.profileUserRoleId)
	            .subscribe(function (profileUserRole) {
	            _this.loading = false;
	            _this.accounts = profileUserRole.accounts || [];
	            _this.profileRoleFull = profileUserRole;
	            _this.accountsCountChange.emit(_this.linkedCount);
	        }, function (error) {
	            _this.loading = false;
	            _this.loadError = _this.errorMessage(error, KEYS + 'LOAD_ERROR');
	        });
	    };
	    ProfileUserRoleAccountsDetailsComponent.prototype.associateAccount = function (account) {
	        var _this = this;
	        if (this.busyAccountId !== null) {
	            return;
	        }
	        this.busyAccountId = +account.id;
	        this._customerProfileUsersService.addAccount(this.profileUserRoleId, +account.id)
	            .subscribe(function () {
	            _this.busyAccountId = null;
	            _this._notificationManager.success(_this._translateManager.getValue(KEYS + 'LINKED_MESSAGE'), 4000);
	            _this.loadAccounts();
	        }, function (error) { return _this.onActionError(error); });
	    };
	    ProfileUserRoleAccountsDetailsComponent.prototype.removeAccount = function (account) {
	        var _this = this;
	        if (this.busyAccountId !== null) {
	            return;
	        }
	        var params = { account: account.name || account.number, role: this.profileRoleFull.roleName };
	        this.dialog
	            .showConfirmDialog({
	            title: KEYS + 'UNLINK_DIALOG.TITLE',
	            descriptionLines: [{ key: KEYS + 'UNLINK_DIALOG.MESSAGE', params: params }],
	            warning: this.isShared
	                ? { key: KEYS + 'SHARED_WARNING', params: { count: this.roleUsers.length, users: this.otherUserNames } }
	                : undefined,
	            confirmButtonText: KEYS + 'UNLINK',
	            cancelButtonText: KEYS + 'CANCEL',
	            confirmButtonClass: 'btn-danger'
	        })
	            .onConfirmAction(function () {
	            _this.busyAccountId = +account.id;
	            _this._customerProfileUsersService.deleteAccountFromRole(_this.profileUserRoleId, +account.id)
	                .subscribe(function () {
	                _this.busyAccountId = null;
	                _this._notificationManager.success(_this._translateManager.getValue(KEYS + 'UNLINKED_MESSAGE'), 4000);
	                _this.loadAccounts();
	            }, function (error) { return _this.onActionError(error); });
	        });
	    };
	    ProfileUserRoleAccountsDetailsComponent.prototype.giveOwnRole = function () {
	        var _this = this;
	        if (this.givingOwnRole || !this.profileUserId) {
	            return;
	        }
	        this.dialog
	            .showConfirmDialog({
	            title: KEYS + 'GIVE_OWN_ROLE_DIALOG.TITLE',
	            descriptionLines: [{
	                    key: KEYS + 'GIVE_OWN_ROLE_DIALOG.MESSAGE',
	                    params: { id: this.profileUserId, role: this.profileRoleFull.roleName }
	                }],
	            confirmButtonText: KEYS + 'GIVE_OWN_ROLE',
	            cancelButtonText: KEYS + 'CANCEL',
	            confirmButtonClass: 'btn-primary'
	        })
	            .onConfirmAction(function () {
	            _this.givingOwnRole = true;
	            _this._customerProfileUsersService.giveOwnRole(_this.profileId, _this.profileUserId)
	                .subscribe(function (response) {
	                _this.givingOwnRole = false;
	                _this._notificationManager.success(response && response.message, 5000);
	                _this.ownRoleCreated.emit();
	            }, function (error) {
	                _this.givingOwnRole = false;
	                _this._notificationManager.error(_this.errorMessage(error, KEYS + 'ACTION_ERROR'));
	            });
	        });
	    };
	    ProfileUserRoleAccountsDetailsComponent.prototype.onActionError = function (error) {
	        this.busyAccountId = null;
	        this._notificationManager.error(this.errorMessage(error, KEYS + 'ACTION_ERROR'));
	        // The list may have changed meanwhile (another user, another tab): show the real state
	        this.loadAccounts();
	    };
	    ProfileUserRoleAccountsDetailsComponent.prototype.errorMessage = function (error, fallbackKey) {
	        return (error && error.message) || this._translateManager.getValue(fallbackKey);
	    };
	    __decorate([
	        core_1.Input('profile-id'),
	        __metadata("design:type", Number)
	    ], ProfileUserRoleAccountsDetailsComponent.prototype, "profileId", void 0);
	    __decorate([
	        core_1.Input('profile-user-role-id'),
	        __metadata("design:type", Number)
	    ], ProfileUserRoleAccountsDetailsComponent.prototype, "profileUserRoleId", void 0);
	    __decorate([
	        core_1.Input('profile-user-id'),
	        __metadata("design:type", Number)
	    ], ProfileUserRoleAccountsDetailsComponent.prototype, "profileUserId", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", Object)
	    ], ProfileUserRoleAccountsDetailsComponent.prototype, "accountsCountChange", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", Object)
	    ], ProfileUserRoleAccountsDetailsComponent.prototype, "ownRoleCreated", void 0);
	    __decorate([
	        option_dialog_1.InjectOptionDialog(),
	        __metadata("design:type", Object)
	    ], ProfileUserRoleAccountsDetailsComponent.prototype, "dialog", void 0);
	    ProfileUserRoleAccountsDetailsComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-profile-user-role-accounts-details',
	            template: __webpack_require__(1325)
	        }),
	        __metadata("design:paramtypes", [customer_profile_users_service_1.CustomerProfileUsersService,
	            notification_1.NotificationManager,
	            translate_1.TranslateManager])
	    ], ProfileUserRoleAccountsDetailsComponent);
	    return ProfileUserRoleAccountsDetailsComponent;
	}());
	exports.ProfileUserRoleAccountsDetailsComponent = ProfileUserRoleAccountsDetailsComponent;


/***/ }),
/* 1325 */
/***/ (function(module, exports) {

	module.exports = "<div>\n    <div class=\"role-accounts-header\" *ngIf=\"profileRoleFull\">\n        <span class=\"role-accounts-title\">\n            {{ 'CUSTOMER.DETAILS.TAB.USERS.ROLE_ACCOUNTS.TITLE' | translate:{role: profileRoleFull.roleName} }}\n        </span>\n        <span class=\"label label-success\">\n            {{ 'CUSTOMER.DETAILS.TAB.USERS.ROLE_ACCOUNTS.LINKED_COUNT' | translate:{count: linkedCount, total: accounts.length} }}\n        </span>\n    </div>\n\n    <!-- Admin role: it always sees every account, nothing to link -->\n    <div class=\"alert alert-info role-accounts-notice\" *ngIf=\"profileRoleFull?.isAdminRole\">\n        {{ 'CUSTOMER.DETAILS.TAB.USERS.ROLE_ACCOUNTS.ADMIN_INFO' | translate }}\n    </div>\n\n    <!-- Shared role: any change applies to every user with it -->\n    <div class=\"alert alert-warning role-accounts-notice\" *ngIf=\"profileRoleFull && !profileRoleFull.isAdminRole && isShared\">\n        <i class=\"fa fa-users\"></i>\n        {{ 'CUSTOMER.DETAILS.TAB.USERS.ROLE_ACCOUNTS.SHARED_WARNING' | translate:{count: roleUsers.length, users: otherUserNames} }}\n        <div *ngIf=\"profileUserId\" style=\"margin-top: 8px;\">\n            <button *ifHasRoles=\"'EDIT';hide:true;route:usersTabRoute\"\n                    type=\"button\" class=\"btn btn-sm btn-primary\"\n                    [disabled]=\"givingOwnRole\"\n                    (click)=\"giveOwnRole()\">\n                <i class=\"fa\" [ngClass]=\"givingOwnRole ? 'fa-spinner fa-spin' : 'fa-user'\"></i>\n                {{ 'CUSTOMER.DETAILS.TAB.USERS.ROLE_ACCOUNTS.GIVE_OWN_ROLE' | translate }}\n            </button>\n        </div>\n    </div>\n    <div class=\"text-muted role-accounts-notice\" *ngIf=\"profileRoleFull && !profileRoleFull.isAdminRole && !isShared\">\n        <i class=\"fa fa-user\"></i> {{ 'CUSTOMER.DETAILS.TAB.USERS.ROLE_ACCOUNTS.NOT_SHARED' | translate }}\n    </div>\n\n    <div class=\"alert alert-danger role-accounts-notice\" *ngIf=\"loadError\">\n        {{ loadError }}\n        <a href=\"javascript:void(0)\" (click)=\"loadAccounts()\">{{ 'CUSTOMER.DETAILS.TAB.USERS.ROLE_ACCOUNTS.RETRY' | translate }}</a>\n    </div>\n\n    <table [id]=\"'profile-user-role-accounts-details-table-' + profileUserRoleId\"\n           class=\"table profile-user-role-accounts-details-table\">\n        <thead>\n        <tr>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.ACCOUNT_NAME' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.ACCOUNT_IBAN' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.ACCOUNT_NUMBER' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.ROLE_ACCOUNTS.CURRENCY' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.ROLE_ACCOUNTS.STATE' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.POOL_NAME' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.LIQUIDITY_NAME' | translate }}</th>\n            <th>{{ 'CUSTOMER.DETAILS.TAB.USERS.USER_RELATED_ROLE_DETAILS.ASSOCIATED' | translate }}</th>\n        </tr>\n        </thead>\n        <tbody *ngIf=\"accounts.length > 0\">\n        <tr *ngFor=\"let account of accounts\"\n            [class.account-linked]=\"account.associated\"\n            [class.account-inactive]=\"!account.active\">\n            <td>{{ account.name }}</td>\n            <td>{{ account.iban || '-' }}</td>\n            <td>{{ account.number }}</td>\n            <td>{{ account.currency || '-' }}</td>\n            <td>\n                <span class=\"label\" [ngClass]=\"account.active ? 'label-success' : 'label-default'\">{{ account.state }}</span>\n            </td>\n            <td>{{ account.poolName || '-' }}</td>\n            <td>{{ account.liquidityAccountName || '-' }}</td>\n            <td class=\"account-actions text-nowrap\">\n                <span class=\"label\" [ngClass]=\"account.associated ? 'label-success' : 'label-default'\">\n                    {{ (account.associated ? 'CUSTOMER.DETAILS.TAB.USERS.ROLE_ACCOUNTS.LINKED'\n                        : 'CUSTOMER.DETAILS.TAB.USERS.ROLE_ACCOUNTS.NOT_LINKED') | translate }}\n                </span>\n                <ng-container *ngIf=\"!profileRoleFull?.isAdminRole\">\n                    <button *ifHasRoles=\"'EDIT';hide:true;route:usersTabRoute\"\n                            type=\"button\"\n                            class=\"btn btn-xs\"\n                            [ngClass]=\"account.associated ? 'btn-default action-remove' : 'btn-success action-associate'\"\n                            [disabled]=\"busyAccountId !== null || (!account.associated && !account.active)\"\n                            (click)=\"account.associated ? removeAccount(account) : associateAccount(account)\">\n                        <i *ngIf=\"busyAccountId === +account.id\" class=\"fa fa-spinner fa-spin\"></i>\n                        {{ (account.associated ? 'CUSTOMER.DETAILS.TAB.USERS.ROLE_ACCOUNTS.UNLINK'\n                            : 'CUSTOMER.DETAILS.TAB.USERS.ROLE_ACCOUNTS.LINK') | translate }}\n                    </button>\n                </ng-container>\n            </td>\n        </tr>\n        </tbody>\n        <tbody *ngIf=\"accounts.length === 0\">\n        <tr>\n            <td colspan=\"8\" class=\"text-center\">\n                <h4 *ngIf=\"loading\">{{ 'CUSTOMER.DETAILS.TAB.USERS.ROLE_ACCOUNTS.LOADING' | translate }}</h4>\n                <h4 *ngIf=\"!loading\">{{ 'CUSTOMER.DETAILS.TAB.USERS.ROLE_ACCOUNTS.EMPTY' | translate }}</h4>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n"

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1081), __webpack_require__(1308), __webpack_require__(246), __webpack_require__(205), __webpack_require__(1075), __webpack_require__(1310), __webpack_require__(1079), __webpack_require__(594), __webpack_require__(256), __webpack_require__(263), __webpack_require__(222), __webpack_require__(211), __webpack_require__(250), __webpack_require__(240), __webpack_require__(1077), __webpack_require__(1076), __webpack_require__(298), __webpack_require__(253)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/cdk/a11y', '@angular/cdk/overlay', '@angular/common', '@angular/core', '@angular/material/core', '@angular/cdk/portal', '@angular/cdk/keycodes', 'rxjs/operators/startWith', 'rxjs/operators/switchMap', 'rxjs/operators/take', 'rxjs/observable/merge', 'rxjs/Subscription', '@angular/animations', 'rxjs/Subject', '@angular/cdk/coercion', '@angular/cdk/bidi', 'rxjs/operators/filter', 'rxjs/observable/of'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.material = global.ng.material || {}, global.ng.material.menu = global.ng.material.menu || {}),global.ng.cdk.a11y,global.ng.cdk.overlay,global.ng.common,global.ng.core,global.ng.material.core,global.ng.cdk.portal,global.ng.cdk.keycodes,global.Rx.operators,global.Rx.operators,global.Rx.operators,global.Rx.Observable,global.Rx,global.ng.animations,global.Rx,global.ng.cdk.coercion,global.ng.cdk.bidi,global.Rx.operators,global.Rx.Observable));
	}(this, (function (exports,_angular_cdk_a11y,_angular_cdk_overlay,_angular_common,_angular_core,_angular_material_core,_angular_cdk_portal,_angular_cdk_keycodes,rxjs_operators_startWith,rxjs_operators_switchMap,rxjs_operators_take,rxjs_observable_merge,rxjs_Subscription,_angular_animations,rxjs_Subject,_angular_cdk_coercion,_angular_cdk_bidi,rxjs_operators_filter,rxjs_observable_of) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Animations used by the mat-menu component.
	 * Animation duration and timing values are based on:
	 * https://material.io/guidelines/components/menus.html#menus-usage
	 */
	var matMenuAnimations = {
	    /**
	       * This animation controls the menu panel's entry and exit from the page.
	       *
	       * When the menu panel is added to the DOM, it scales in and fades in its border.
	       *
	       * When the menu panel is removed from the DOM, it simply fades out after a brief
	       * delay to display the ripple.
	       */
	    transformMenu: _angular_animations.trigger('transformMenu', [
	        // TODO(kara): switch to :enter and :leave once Mobile Safari is sorted out.
	        _angular_animations.state('void', _angular_animations.style({
	            opacity: 0,
	            // This starts off from 0.01, instead of 0, because there's an issue in the Angular animations
	            // as of 4.2, which causes the animation to be skipped if it starts from 0.
	            transform: 'scale(0.01, 0.01)'
	        })),
	        _angular_animations.state('enter-start', _angular_animations.style({
	            opacity: 1,
	            transform: 'scale(1, 0.5)'
	        })),
	        _angular_animations.state('enter', _angular_animations.style({
	            transform: 'scale(1, 1)'
	        })),
	        _angular_animations.transition('void => enter-start', _angular_animations.animate('100ms linear')),
	        _angular_animations.transition('enter-start => enter', _angular_animations.animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)')),
	        _angular_animations.transition('* => void', _angular_animations.animate('150ms 50ms linear', _angular_animations.style({ opacity: 0 })))
	    ]),
	    /**
	       * This animation fades in the background color and content of the menu panel
	       * after its containing element is scaled in.
	       */
	    fadeInItems: _angular_animations.trigger('fadeInItems', [
	        _angular_animations.state('showing', _angular_animations.style({ opacity: 1 })),
	        _angular_animations.transition('void => *', [
	            _angular_animations.style({ opacity: 0 }),
	            _angular_animations.animate('400ms 100ms cubic-bezier(0.55, 0, 0.55, 0.2)')
	        ])
	    ])
	};
	/**
	 * @deprecated
	 * \@deletion-target 7.0.0
	 */
	var fadeInItems = matMenuAnimations.fadeInItems;
	/**
	 * @deprecated
	 * \@deletion-target 7.0.0
	 */
	var transformMenu = matMenuAnimations.transformMenu;
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Throws an exception for the case when menu trigger doesn't have a valid mat-menu instance
	 * \@docs-private
	 * @return {?}
	 */
	function throwMatMenuMissingError() {
	    throw Error("mat-menu-trigger: must pass in an mat-menu instance.\n\n    Example:\n      <mat-menu #menu=\"matMenu\"></mat-menu>\n      <button [matMenuTriggerFor]=\"menu\"></button>");
	}
	/**
	 * Throws an exception for the case when menu's x-position value isn't valid.
	 * In other words, it doesn't match 'before' or 'after'.
	 * \@docs-private
	 * @return {?}
	 */
	function throwMatMenuInvalidPositionX() {
	    throw Error("x-position value must be either 'before' or after'.\n      Example: <mat-menu x-position=\"before\" #menu=\"matMenu\"></mat-menu>");
	}
	/**
	 * Throws an exception for the case when menu's y-position value isn't valid.
	 * In other words, it doesn't match 'above' or 'below'.
	 * \@docs-private
	 * @return {?}
	 */
	function throwMatMenuInvalidPositionY() {
	    throw Error("y-position value must be either 'above' or below'.\n      Example: <mat-menu y-position=\"above\" #menu=\"matMenu\"></mat-menu>");
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 */
	var MatMenuItemBase = /** @class */ (function () {
	    function MatMenuItemBase() {
	    }
	    return MatMenuItemBase;
	}());
	var _MatMenuItemMixinBase = _angular_material_core.mixinDisableRipple(_angular_material_core.mixinDisabled(MatMenuItemBase));
	/**
	 * This directive is intended to be used inside an mat-menu tag.
	 * It exists mostly to set the role attribute.
	 */
	var MatMenuItem = /** @class */ (function (_super) {
	    __extends(MatMenuItem, _super);
	    function MatMenuItem(_elementRef, document, _focusMonitor) {
	        var _this = 
	        // @deletion-target 6.0.0 make `_focusMonitor` and `document` required params.
	        _super.call(this) || this;
	        _this._elementRef = _elementRef;
	        _this._focusMonitor = _focusMonitor;
	        /**
	         * Stream that emits when the menu item is hovered.
	         */
	        _this._hovered = new rxjs_Subject.Subject();
	        /**
	         * Whether the menu item is highlighted.
	         */
	        _this._highlighted = false;
	        /**
	         * Whether the menu item acts as a trigger for a sub-menu.
	         */
	        _this._triggersSubmenu = false;
	        if (_focusMonitor) {
	            // Start monitoring the element so it gets the appropriate focused classes. We want
	            // to show the focus style for menu items only when the focus was not caused by a
	            // mouse or touch interaction.
	            _focusMonitor.monitor(_this._getHostElement(), false);
	        }
	        _this._document = document;
	        return _this;
	    }
	    /** Focuses the menu item. */
	    /**
	     * Focuses the menu item.
	     * @param {?=} origin
	     * @return {?}
	     */
	    MatMenuItem.prototype.focus = /**
	     * Focuses the menu item.
	     * @param {?=} origin
	     * @return {?}
	     */
	    function (origin) {
	        if (origin === void 0) { origin = 'program'; }
	        if (this._focusMonitor) {
	            this._focusMonitor.focusVia(this._getHostElement(), origin);
	        }
	        else {
	            this._getHostElement().focus();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatMenuItem.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        if (this._focusMonitor) {
	            this._focusMonitor.stopMonitoring(this._getHostElement());
	        }
	        this._hovered.complete();
	    };
	    /** Used to set the `tabindex`. */
	    /**
	     * Used to set the `tabindex`.
	     * @return {?}
	     */
	    MatMenuItem.prototype._getTabIndex = /**
	     * Used to set the `tabindex`.
	     * @return {?}
	     */
	    function () {
	        return this.disabled ? '-1' : '0';
	    };
	    /** Returns the host DOM element. */
	    /**
	     * Returns the host DOM element.
	     * @return {?}
	     */
	    MatMenuItem.prototype._getHostElement = /**
	     * Returns the host DOM element.
	     * @return {?}
	     */
	    function () {
	        return this._elementRef.nativeElement;
	    };
	    /** Prevents the default element actions if it is disabled. */
	    /**
	     * Prevents the default element actions if it is disabled.
	     * @param {?} event
	     * @return {?}
	     */
	    MatMenuItem.prototype._checkDisabled = /**
	     * Prevents the default element actions if it is disabled.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (this.disabled) {
	            event.preventDefault();
	            event.stopPropagation();
	        }
	    };
	    /** Emits to the hover stream. */
	    /**
	     * Emits to the hover stream.
	     * @return {?}
	     */
	    MatMenuItem.prototype._emitHoverEvent = /**
	     * Emits to the hover stream.
	     * @return {?}
	     */
	    function () {
	        if (!this.disabled) {
	            this._hovered.next(this);
	        }
	    };
	    /** Gets the label to be used when determining whether the option should be focused. */
	    /**
	     * Gets the label to be used when determining whether the option should be focused.
	     * @return {?}
	     */
	    MatMenuItem.prototype.getLabel = /**
	     * Gets the label to be used when determining whether the option should be focused.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ element = this._elementRef.nativeElement;
	        var /** @type {?} */ textNodeType = this._document ? this._document.TEXT_NODE : 3;
	        var /** @type {?} */ output = '';
	        if (element.childNodes) {
	            var /** @type {?} */ length_1 = element.childNodes.length;
	            // Go through all the top-level text nodes and extract their text.
	            // We skip anything that's not a text node to prevent the text from
	            // being thrown off by something like an icon.
	            for (var /** @type {?} */ i = 0; i < length_1; i++) {
	                if (element.childNodes[i].nodeType === textNodeType) {
	                    output += element.childNodes[i].textContent;
	                }
	            }
	        }
	        return output.trim();
	    };
	    MatMenuItem.decorators = [
	        { type: _angular_core.Component, args: [{selector: '[mat-menu-item]',
	                    exportAs: 'matMenuItem',
	                    inputs: ['disabled', 'disableRipple'],
	                    host: {
	                        'role': 'menuitem',
	                        'class': 'mat-menu-item',
	                        '[class.mat-menu-item-highlighted]': '_highlighted',
	                        '[class.mat-menu-item-submenu-trigger]': '_triggersSubmenu',
	                        '[attr.tabindex]': '_getTabIndex()',
	                        '[attr.aria-disabled]': 'disabled.toString()',
	                        '[attr.disabled]': 'disabled || null',
	                        '(click)': '_checkDisabled($event)',
	                        '(mouseenter)': '_emitHoverEvent()',
	                    },
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    template: "<ng-content></ng-content><div class=\"mat-menu-ripple\" matRipple [matRippleDisabled]=\"disableRipple || disabled\" [matRippleTrigger]=\"_getHostElement()\"></div>",
	                },] },
	    ];
	    /** @nocollapse */
	    MatMenuItem.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	        { type: _angular_cdk_a11y.FocusMonitor, },
	    ]; };
	    return MatMenuItem;
	}(_MatMenuItemMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Menu content that will be rendered lazily once the menu is opened.
	 */
	var MatMenuContent = /** @class */ (function () {
	    function MatMenuContent(_template, _componentFactoryResolver, _appRef, _injector, _viewContainerRef, _document) {
	        this._template = _template;
	        this._componentFactoryResolver = _componentFactoryResolver;
	        this._appRef = _appRef;
	        this._injector = _injector;
	        this._viewContainerRef = _viewContainerRef;
	        this._document = _document;
	    }
	    /**
	     * Attaches the content with a particular context.
	     * @docs-private
	     */
	    /**
	     * Attaches the content with a particular context.
	     * \@docs-private
	     * @param {?=} context
	     * @return {?}
	     */
	    MatMenuContent.prototype.attach = /**
	     * Attaches the content with a particular context.
	     * \@docs-private
	     * @param {?=} context
	     * @return {?}
	     */
	    function (context) {
	        if (context === void 0) { context = {}; }
	        if (!this._portal) {
	            this._portal = new _angular_cdk_portal.TemplatePortal(this._template, this._viewContainerRef);
	        }
	        else if (this._portal.isAttached) {
	            this._portal.detach();
	        }
	        if (!this._outlet) {
	            this._outlet = new _angular_cdk_portal.DomPortalOutlet(this._document.createElement('div'), this._componentFactoryResolver, this._appRef, this._injector);
	        }
	        var /** @type {?} */ element = this._template.elementRef.nativeElement; /** @type {?} */
	        ((
	        // Because we support opening the same menu from different triggers (which in turn have their
	        // own `OverlayRef` panel), we have to re-insert the host element every time, otherwise we
	        // risk it staying attached to a pane that's no longer in the DOM.
	        element.parentNode)).insertBefore(this._outlet.outletElement, element);
	        this._portal.attach(this._outlet, context);
	    };
	    /**
	     * @return {?}
	     */
	    MatMenuContent.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        if (this._outlet) {
	            this._outlet.dispose();
	        }
	    };
	    MatMenuContent.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'ng-template[matMenuContent]'
	                },] },
	    ];
	    /** @nocollapse */
	    MatMenuContent.ctorParameters = function () { return [
	        { type: _angular_core.TemplateRef, },
	        { type: _angular_core.ComponentFactoryResolver, },
	        { type: _angular_core.ApplicationRef, },
	        { type: _angular_core.Injector, },
	        { type: _angular_core.ViewContainerRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    return MatMenuContent;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Default `mat-menu` options that can be overridden.
	 * @record
	 */
	
	/**
	 * Injection token to be used to override the default options for `mat-menu`.
	 */
	var MAT_MENU_DEFAULT_OPTIONS = new _angular_core.InjectionToken('mat-menu-default-options');
	/**
	 * Start elevation for the menu panel.
	 * \@docs-private
	 */
	var MAT_MENU_BASE_ELEVATION = 2;
	var MatMenu = /** @class */ (function () {
	    function MatMenu(_elementRef, _ngZone, _defaultOptions) {
	        this._elementRef = _elementRef;
	        this._ngZone = _ngZone;
	        this._defaultOptions = _defaultOptions;
	        this._xPosition = this._defaultOptions.xPosition;
	        this._yPosition = this._defaultOptions.yPosition;
	        /**
	         * Subscription to tab events on the menu panel
	         */
	        this._tabSubscription = rxjs_Subscription.Subscription.EMPTY;
	        /**
	         * Config object to be passed into the menu's ngClass
	         */
	        this._classList = {};
	        /**
	         * Current state of the panel animation.
	         */
	        this._panelAnimationState = 'void';
	        this._overlapTrigger = this._defaultOptions.overlapTrigger;
	        /**
	         * Event emitted when the menu is closed.
	         */
	        this.closed = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when the menu is closed.
	         * @deprecated Switch to `closed` instead
	         * \@deletion-target 6.0.0
	         */
	        this.close = this.closed;
	    }
	    Object.defineProperty(MatMenu.prototype, "xPosition", {
	        get: /**
	         * Position of the menu in the X axis.
	         * @return {?}
	         */
	        function () { return this._xPosition; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (value !== 'before' && value !== 'after') {
	                throwMatMenuInvalidPositionX();
	            }
	            this._xPosition = value;
	            this.setPositionClasses();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatMenu.prototype, "yPosition", {
	        get: /**
	         * Position of the menu in the Y axis.
	         * @return {?}
	         */
	        function () { return this._yPosition; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (value !== 'above' && value !== 'below') {
	                throwMatMenuInvalidPositionY();
	            }
	            this._yPosition = value;
	            this.setPositionClasses();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatMenu.prototype, "overlapTrigger", {
	        get: /**
	         * Whether the menu should overlap its trigger.
	         * @return {?}
	         */
	        function () { return this._overlapTrigger; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._overlapTrigger = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatMenu.prototype, "panelClass", {
	        set: /**
	         * This method takes classes set on the host mat-menu element and applies them on the
	         * menu template that displays in the overlay container.  Otherwise, it's difficult
	         * to style the containing menu from outside the component.
	         * @param {?} classes list of class names
	         * @return {?}
	         */
	        function (classes) {
	            if (classes && classes.length) {
	                this._classList = classes.split(' ').reduce(function (obj, className) {
	                    obj[className] = true;
	                    return obj;
	                }, {});
	                this._elementRef.nativeElement.className = '';
	                this.setPositionClasses();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatMenu.prototype, "classList", {
	        get: /**
	         * This method takes classes set on the host mat-menu element and applies them on the
	         * menu template that displays in the overlay container.  Otherwise, it's difficult
	         * to style the containing menu from outside the component.
	         * @deprecated Use `panelClass` instead.
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this.panelClass; },
	        set: /**
	         * @param {?} classes
	         * @return {?}
	         */
	        function (classes) { this.panelClass = classes; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatMenu.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._keyManager = new _angular_cdk_a11y.FocusKeyManager(this.items).withWrap().withTypeAhead();
	        this._tabSubscription = this._keyManager.tabOut.subscribe(function () { return _this.close.emit('keydown'); });
	    };
	    /**
	     * @return {?}
	     */
	    MatMenu.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._tabSubscription.unsubscribe();
	        this.closed.complete();
	    };
	    /** Stream that emits whenever the hovered menu item changes. */
	    /**
	     * Stream that emits whenever the hovered menu item changes.
	     * @return {?}
	     */
	    MatMenu.prototype._hovered = /**
	     * Stream that emits whenever the hovered menu item changes.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this.items) {
	            return this.items.changes.pipe(rxjs_operators_startWith.startWith(this.items), rxjs_operators_switchMap.switchMap(function (items) { return rxjs_observable_merge.merge.apply(void 0, items.map(function (item) { return item._hovered; })); }));
	        }
	        return this._ngZone.onStable
	            .asObservable()
	            .pipe(rxjs_operators_take.take(1), rxjs_operators_switchMap.switchMap(function () { return _this._hovered(); }));
	    };
	    /** Handle a keyboard event from the menu, delegating to the appropriate action. */
	    /**
	     * Handle a keyboard event from the menu, delegating to the appropriate action.
	     * @param {?} event
	     * @return {?}
	     */
	    MatMenu.prototype._handleKeydown = /**
	     * Handle a keyboard event from the menu, delegating to the appropriate action.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        switch (event.keyCode) {
	            case _angular_cdk_keycodes.ESCAPE:
	                this.closed.emit('keydown');
	                event.stopPropagation();
	                break;
	            case _angular_cdk_keycodes.LEFT_ARROW:
	                if (this.parentMenu && this.direction === 'ltr') {
	                    this.closed.emit('keydown');
	                }
	                break;
	            case _angular_cdk_keycodes.RIGHT_ARROW:
	                if (this.parentMenu && this.direction === 'rtl') {
	                    this.closed.emit('keydown');
	                }
	                break;
	            default:
	                this._keyManager.onKeydown(event);
	        }
	    };
	    /**
	     * Focus the first item in the menu.
	     * @param origin Action from which the focus originated. Used to set the correct styling.
	     */
	    /**
	     * Focus the first item in the menu.
	     * @param {?=} origin Action from which the focus originated. Used to set the correct styling.
	     * @return {?}
	     */
	    MatMenu.prototype.focusFirstItem = /**
	     * Focus the first item in the menu.
	     * @param {?=} origin Action from which the focus originated. Used to set the correct styling.
	     * @return {?}
	     */
	    function (origin) {
	        var _this = this;
	        if (origin === void 0) { origin = 'program'; }
	        // When the content is rendered lazily, it takes a bit before the items are inside the DOM.
	        if (this.lazyContent) {
	            this._ngZone.onStable.asObservable()
	                .pipe(rxjs_operators_take.take(1))
	                .subscribe(function () { return _this._keyManager.setFocusOrigin(origin).setFirstItemActive(); });
	        }
	        else {
	            this._keyManager.setFocusOrigin(origin).setFirstItemActive();
	        }
	    };
	    /**
	     * Resets the active item in the menu. This is used when the menu is opened, allowing
	     * the user to start from the first option when pressing the down arrow.
	     */
	    /**
	     * Resets the active item in the menu. This is used when the menu is opened, allowing
	     * the user to start from the first option when pressing the down arrow.
	     * @return {?}
	     */
	    MatMenu.prototype.resetActiveItem = /**
	     * Resets the active item in the menu. This is used when the menu is opened, allowing
	     * the user to start from the first option when pressing the down arrow.
	     * @return {?}
	     */
	    function () {
	        this._keyManager.setActiveItem(-1);
	    };
	    /**
	     * It's necessary to set position-based classes to ensure the menu panel animation
	     * folds out from the correct direction.
	     */
	    /**
	     * It's necessary to set position-based classes to ensure the menu panel animation
	     * folds out from the correct direction.
	     * @param {?=} posX
	     * @param {?=} posY
	     * @return {?}
	     */
	    MatMenu.prototype.setPositionClasses = /**
	     * It's necessary to set position-based classes to ensure the menu panel animation
	     * folds out from the correct direction.
	     * @param {?=} posX
	     * @param {?=} posY
	     * @return {?}
	     */
	    function (posX, posY) {
	        if (posX === void 0) { posX = this.xPosition; }
	        if (posY === void 0) { posY = this.yPosition; }
	        this._classList['mat-menu-before'] = posX === 'before';
	        this._classList['mat-menu-after'] = posX === 'after';
	        this._classList['mat-menu-above'] = posY === 'above';
	        this._classList['mat-menu-below'] = posY === 'below';
	    };
	    /**
	     * Sets the menu panel elevation.
	     * @param depth Number of parent menus that come before the menu.
	     */
	    /**
	     * Sets the menu panel elevation.
	     * @param {?} depth Number of parent menus that come before the menu.
	     * @return {?}
	     */
	    MatMenu.prototype.setElevation = /**
	     * Sets the menu panel elevation.
	     * @param {?} depth Number of parent menus that come before the menu.
	     * @return {?}
	     */
	    function (depth) {
	        // The elevation starts at the base and increases by one for each level.
	        var /** @type {?} */ newElevation = "mat-elevation-z" + (MAT_MENU_BASE_ELEVATION + depth);
	        var /** @type {?} */ customElevation = Object.keys(this._classList).find(function (c) { return c.startsWith('mat-elevation-z'); });
	        if (!customElevation || customElevation === this._previousElevation) {
	            if (this._previousElevation) {
	                this._classList[this._previousElevation] = false;
	            }
	            this._classList[newElevation] = true;
	            this._previousElevation = newElevation;
	        }
	    };
	    /** Starts the enter animation. */
	    /**
	     * Starts the enter animation.
	     * @return {?}
	     */
	    MatMenu.prototype._startAnimation = /**
	     * Starts the enter animation.
	     * @return {?}
	     */
	    function () {
	        this._panelAnimationState = 'enter-start';
	    };
	    /** Resets the panel animation to its initial state. */
	    /**
	     * Resets the panel animation to its initial state.
	     * @return {?}
	     */
	    MatMenu.prototype._resetAnimation = /**
	     * Resets the panel animation to its initial state.
	     * @return {?}
	     */
	    function () {
	        this._panelAnimationState = 'void';
	    };
	    /** Callback that is invoked when the panel animation completes. */
	    /**
	     * Callback that is invoked when the panel animation completes.
	     * @param {?} event
	     * @return {?}
	     */
	    MatMenu.prototype._onAnimationDone = /**
	     * Callback that is invoked when the panel animation completes.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        // After the initial expansion is done, trigger the second phase of the enter animation.
	        if (event.toState === 'enter-start') {
	            this._panelAnimationState = 'enter';
	        }
	    };
	    MatMenu.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-menu',
	                    template: "<ng-template><div class=\"mat-menu-panel\" [ngClass]=\"_classList\" (keydown)=\"_handleKeydown($event)\" (click)=\"closed.emit('click')\" [@transformMenu]=\"_panelAnimationState\" (@transformMenu.done)=\"_onAnimationDone($event)\" tabindex=\"-1\" role=\"menu\"><div class=\"mat-menu-content\" [@fadeInItems]=\"'showing'\"><ng-content></ng-content></div></div></ng-template>",
	                    styles: [".mat-menu-panel{min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;max-height:calc(100vh - 48px);border-radius:2px;outline:0}.mat-menu-panel:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.mat-menu-panel.mat-menu-after.mat-menu-below{transform-origin:left top}.mat-menu-panel.mat-menu-after.mat-menu-above{transform-origin:left bottom}.mat-menu-panel.mat-menu-before.mat-menu-below{transform-origin:right top}.mat-menu-panel.mat-menu-before.mat-menu-above{transform-origin:right bottom}[dir=rtl] .mat-menu-panel.mat-menu-after.mat-menu-below{transform-origin:right top}[dir=rtl] .mat-menu-panel.mat-menu-after.mat-menu-above{transform-origin:right bottom}[dir=rtl] .mat-menu-panel.mat-menu-before.mat-menu-below{transform-origin:left top}[dir=rtl] .mat-menu-panel.mat-menu-before.mat-menu-above{transform-origin:left bottom}.mat-menu-panel.ng-animating{pointer-events:none}@media screen and (-ms-high-contrast:active){.mat-menu-panel{outline:solid 1px}}.mat-menu-content{padding-top:8px;padding-bottom:8px}.mat-menu-item{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;line-height:48px;height:48px;padding:0 16px;text-align:left;text-decoration:none;position:relative}.mat-menu-item[disabled]{cursor:default}[dir=rtl] .mat-menu-item{text-align:right}.mat-menu-item .mat-icon{margin-right:16px;vertical-align:middle}[dir=rtl] .mat-menu-item .mat-icon{margin-left:16px;margin-right:0}.mat-menu-item-submenu-trigger{padding-right:32px}.mat-menu-item-submenu-trigger::after{width:0;height:0;border-style:solid;border-width:5px 0 5px 5px;border-color:transparent transparent transparent currentColor;content:'';display:inline-block;position:absolute;top:50%;right:16px;transform:translateY(-50%)}[dir=rtl] .mat-menu-item-submenu-trigger{padding-right:16px;padding-left:32px}[dir=rtl] .mat-menu-item-submenu-trigger::after{right:auto;left:16px;transform:rotateY(180deg) translateY(-50%)}button.mat-menu-item{width:100%}.mat-menu-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}"],
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    animations: [
	                        matMenuAnimations.transformMenu,
	                        matMenuAnimations.fadeInItems
	                    ],
	                    exportAs: 'matMenu'
	                },] },
	    ];
	    /** @nocollapse */
	    MatMenu.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.NgZone, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [MAT_MENU_DEFAULT_OPTIONS,] },] },
	    ]; };
	    MatMenu.propDecorators = {
	        "xPosition": [{ type: _angular_core.Input },],
	        "yPosition": [{ type: _angular_core.Input },],
	        "templateRef": [{ type: _angular_core.ViewChild, args: [_angular_core.TemplateRef,] },],
	        "items": [{ type: _angular_core.ContentChildren, args: [MatMenuItem,] },],
	        "lazyContent": [{ type: _angular_core.ContentChild, args: [MatMenuContent,] },],
	        "overlapTrigger": [{ type: _angular_core.Input },],
	        "panelClass": [{ type: _angular_core.Input, args: ['class',] },],
	        "classList": [{ type: _angular_core.Input },],
	        "closed": [{ type: _angular_core.Output },],
	        "close": [{ type: _angular_core.Output },],
	    };
	    return MatMenu;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Injection token that determines the scroll handling while the menu is open.
	 */
	var MAT_MENU_SCROLL_STRATEGY = new _angular_core.InjectionToken('mat-menu-scroll-strategy');
	/**
	 * \@docs-private
	 * @param {?} overlay
	 * @return {?}
	 */
	function MAT_MENU_SCROLL_STRATEGY_PROVIDER_FACTORY(overlay) {
	    return function () { return overlay.scrollStrategies.reposition(); };
	}
	/**
	 * \@docs-private
	 */
	var MAT_MENU_SCROLL_STRATEGY_PROVIDER = {
	    provide: MAT_MENU_SCROLL_STRATEGY,
	    deps: [_angular_cdk_overlay.Overlay],
	    useFactory: MAT_MENU_SCROLL_STRATEGY_PROVIDER_FACTORY,
	};
	/**
	 * Default top padding of the menu panel.
	 */
	var MENU_PANEL_TOP_PADDING = 8;
	/**
	 * This directive is intended to be used in conjunction with an mat-menu tag.  It is
	 * responsible for toggling the display of the provided menu instance.
	 */
	var MatMenuTrigger = /** @class */ (function () {
	    function MatMenuTrigger(_overlay, _element, _viewContainerRef, _scrollStrategy, _parentMenu, _menuItemInstance, _dir, _focusMonitor) {
	        this._overlay = _overlay;
	        this._element = _element;
	        this._viewContainerRef = _viewContainerRef;
	        this._scrollStrategy = _scrollStrategy;
	        this._parentMenu = _parentMenu;
	        this._menuItemInstance = _menuItemInstance;
	        this._dir = _dir;
	        this._focusMonitor = _focusMonitor;
	        this._overlayRef = null;
	        this._menuOpen = false;
	        this._closeSubscription = rxjs_Subscription.Subscription.EMPTY;
	        this._hoverSubscription = rxjs_Subscription.Subscription.EMPTY;
	        this._openedByMouse = false;
	        /**
	         * Event emitted when the associated menu is opened.
	         */
	        this.menuOpened = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when the associated menu is opened.
	         * @deprecated Switch to `menuOpened` instead
	         * \@deletion-target 6.0.0
	         */
	        this.onMenuOpen = this.menuOpened;
	        /**
	         * Event emitted when the associated menu is closed.
	         */
	        this.menuClosed = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when the associated menu is closed.
	         * @deprecated Switch to `menuClosed` instead
	         * \@deletion-target 6.0.0
	         */
	        this.onMenuClose = this.menuClosed;
	        if (_menuItemInstance) {
	            _menuItemInstance._triggersSubmenu = this.triggersSubmenu();
	        }
	    }
	    Object.defineProperty(MatMenuTrigger.prototype, "_deprecatedMatMenuTriggerFor", {
	        get: /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () {
	            return this.menu;
	        },
	        set: /**
	         * @param {?} v
	         * @return {?}
	         */
	        function (v) {
	            this.menu = v;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatMenuTrigger.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._checkMenu();
	        this.menu.close.subscribe(function (reason) {
	            _this._destroyMenu();
	            // If a click closed the menu, we should close the entire chain of nested menus.
	            if (reason === 'click' && _this._parentMenu) {
	                _this._parentMenu.closed.emit(reason);
	            }
	        });
	        if (this.triggersSubmenu()) {
	            // Subscribe to changes in the hovered item in order to toggle the panel.
	            this._hoverSubscription = this._parentMenu._hovered()
	                .pipe(rxjs_operators_filter.filter(function (active) { return active === _this._menuItemInstance; }))
	                .subscribe(function () {
	                _this._openedByMouse = true;
	                _this.openMenu();
	            });
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatMenuTrigger.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        if (this._overlayRef) {
	            this._overlayRef.dispose();
	            this._overlayRef = null;
	        }
	        this._cleanUpSubscriptions();
	    };
	    Object.defineProperty(MatMenuTrigger.prototype, "menuOpen", {
	        /** Whether the menu is open. */
	        get: /**
	         * Whether the menu is open.
	         * @return {?}
	         */
	        function () {
	            return this._menuOpen;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatMenuTrigger.prototype, "dir", {
	        /** The text direction of the containing app. */
	        get: /**
	         * The text direction of the containing app.
	         * @return {?}
	         */
	        function () {
	            return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** Whether the menu triggers a sub-menu or a top-level one. */
	    /**
	     * Whether the menu triggers a sub-menu or a top-level one.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype.triggersSubmenu = /**
	     * Whether the menu triggers a sub-menu or a top-level one.
	     * @return {?}
	     */
	    function () {
	        return !!(this._menuItemInstance && this._parentMenu);
	    };
	    /** Toggles the menu between the open and closed states. */
	    /**
	     * Toggles the menu between the open and closed states.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype.toggleMenu = /**
	     * Toggles the menu between the open and closed states.
	     * @return {?}
	     */
	    function () {
	        return this._menuOpen ? this.closeMenu() : this.openMenu();
	    };
	    /** Opens the menu. */
	    /**
	     * Opens the menu.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype.openMenu = /**
	     * Opens the menu.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._menuOpen) {
	            return;
	        }
	        this._createOverlay().attach(this._portal);
	        if (this.menu.lazyContent) {
	            this.menu.lazyContent.attach(this.menuData);
	        }
	        this._closeSubscription = this._menuClosingActions().subscribe(function () { return _this.closeMenu(); });
	        this._initMenu();
	        if (this.menu instanceof MatMenu) {
	            this.menu._startAnimation();
	        }
	    };
	    /** Closes the menu. */
	    /**
	     * Closes the menu.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype.closeMenu = /**
	     * Closes the menu.
	     * @return {?}
	     */
	    function () {
	        this.menu.close.emit();
	    };
	    /**
	     * Focuses the menu trigger.
	     * @param origin Source of the menu trigger's focus.
	     */
	    /**
	     * Focuses the menu trigger.
	     * @param {?=} origin Source of the menu trigger's focus.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype.focus = /**
	     * Focuses the menu trigger.
	     * @param {?=} origin Source of the menu trigger's focus.
	     * @return {?}
	     */
	    function (origin) {
	        if (origin === void 0) { origin = 'program'; }
	        if (this._focusMonitor) {
	            this._focusMonitor.focusVia(this._element.nativeElement, origin);
	        }
	        else {
	            this._element.nativeElement.focus();
	        }
	    };
	    /**
	     * Closes the menu and does the necessary cleanup.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._destroyMenu = /**
	     * Closes the menu and does the necessary cleanup.
	     * @return {?}
	     */
	    function () {
	        if (this._overlayRef && this.menuOpen) {
	            this._resetMenu();
	            this._closeSubscription.unsubscribe();
	            this._overlayRef.detach();
	            if (this.menu instanceof MatMenu) {
	                this.menu._resetAnimation();
	            }
	        }
	    };
	    /**
	     * This method sets the menu state to open and focuses the first item if
	     * the menu was opened via the keyboard.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._initMenu = /**
	     * This method sets the menu state to open and focuses the first item if
	     * the menu was opened via the keyboard.
	     * @return {?}
	     */
	    function () {
	        this.menu.parentMenu = this.triggersSubmenu() ? this._parentMenu : undefined;
	        this.menu.direction = this.dir;
	        this._setMenuElevation();
	        this._setIsMenuOpen(true);
	        this.menu.focusFirstItem(this._openedByMouse ? 'mouse' : 'program');
	    };
	    /**
	     * Updates the menu elevation based on the amount of parent menus that it has.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._setMenuElevation = /**
	     * Updates the menu elevation based on the amount of parent menus that it has.
	     * @return {?}
	     */
	    function () {
	        if (this.menu.setElevation) {
	            var /** @type {?} */ depth = 0;
	            var /** @type {?} */ parentMenu = this.menu.parentMenu;
	            while (parentMenu) {
	                depth++;
	                parentMenu = parentMenu.parentMenu;
	            }
	            this.menu.setElevation(depth);
	        }
	    };
	    /**
	     * This method resets the menu when it's closed, most importantly restoring
	     * focus to the menu trigger if the menu was opened via the keyboard.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._resetMenu = /**
	     * This method resets the menu when it's closed, most importantly restoring
	     * focus to the menu trigger if the menu was opened via the keyboard.
	     * @return {?}
	     */
	    function () {
	        this._setIsMenuOpen(false);
	        // We should reset focus if the user is navigating using a keyboard or
	        // if we have a top-level trigger which might cause focus to be lost
	        // when clicking on the backdrop.
	        if (!this._openedByMouse) {
	            // Note that the focus style will show up both for `program` and
	            // `keyboard` so we don't have to specify which one it is.
	            this.focus();
	        }
	        else if (!this.triggersSubmenu()) {
	            this.focus('mouse');
	        }
	        this._openedByMouse = false;
	    };
	    /**
	     * @param {?} isOpen
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._setIsMenuOpen = /**
	     * @param {?} isOpen
	     * @return {?}
	     */
	    function (isOpen) {
	        this._menuOpen = isOpen;
	        this._menuOpen ? this.menuOpened.emit() : this.menuClosed.emit();
	        if (this.triggersSubmenu()) {
	            this._menuItemInstance._highlighted = isOpen;
	        }
	    };
	    /**
	     * This method checks that a valid instance of MatMenu has been passed into
	     * matMenuTriggerFor. If not, an exception is thrown.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._checkMenu = /**
	     * This method checks that a valid instance of MatMenu has been passed into
	     * matMenuTriggerFor. If not, an exception is thrown.
	     * @return {?}
	     */
	    function () {
	        if (!this.menu) {
	            throwMatMenuMissingError();
	        }
	    };
	    /**
	     * This method creates the overlay from the provided menu's template and saves its
	     * OverlayRef so that it can be attached to the DOM when openMenu is called.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._createOverlay = /**
	     * This method creates the overlay from the provided menu's template and saves its
	     * OverlayRef so that it can be attached to the DOM when openMenu is called.
	     * @return {?}
	     */
	    function () {
	        if (!this._overlayRef) {
	            this._portal = new _angular_cdk_portal.TemplatePortal(this.menu.templateRef, this._viewContainerRef);
	            var /** @type {?} */ config = this._getOverlayConfig();
	            this._subscribeToPositions(/** @type {?} */ (config.positionStrategy));
	            this._overlayRef = this._overlay.create(config);
	        }
	        return this._overlayRef;
	    };
	    /**
	     * This method builds the configuration object needed to create the overlay, the OverlayState.
	     * @return {?} OverlayConfig
	     */
	    MatMenuTrigger.prototype._getOverlayConfig = /**
	     * This method builds the configuration object needed to create the overlay, the OverlayState.
	     * @return {?} OverlayConfig
	     */
	    function () {
	        return new _angular_cdk_overlay.OverlayConfig({
	            positionStrategy: this._getPosition(),
	            hasBackdrop: !this.triggersSubmenu(),
	            backdropClass: 'cdk-overlay-transparent-backdrop',
	            direction: this.dir,
	            scrollStrategy: this._scrollStrategy()
	        });
	    };
	    /**
	     * Listens to changes in the position of the overlay and sets the correct classes
	     * on the menu based on the new position. This ensures the animation origin is always
	     * correct, even if a fallback position is used for the overlay.
	     * @param {?} position
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._subscribeToPositions = /**
	     * Listens to changes in the position of the overlay and sets the correct classes
	     * on the menu based on the new position. This ensures the animation origin is always
	     * correct, even if a fallback position is used for the overlay.
	     * @param {?} position
	     * @return {?}
	     */
	    function (position) {
	        var _this = this;
	        position.onPositionChange.subscribe(function (change) {
	            var /** @type {?} */ posX = change.connectionPair.overlayX === 'start' ? 'after' : 'before';
	            var /** @type {?} */ posY = change.connectionPair.overlayY === 'top' ? 'below' : 'above';
	            _this.menu.setPositionClasses(posX, posY);
	        });
	    };
	    /**
	     * This method builds the position strategy for the overlay, so the menu is properly connected
	     * to the trigger.
	     * @return {?} ConnectedPositionStrategy
	     */
	    MatMenuTrigger.prototype._getPosition = /**
	     * This method builds the position strategy for the overlay, so the menu is properly connected
	     * to the trigger.
	     * @return {?} ConnectedPositionStrategy
	     */
	    function () {
	        var _a = this.menu.xPosition === 'before' ? ['end', 'start'] : ['start', 'end'], originX = _a[0], originFallbackX = _a[1];
	        var _b = this.menu.yPosition === 'above' ? ['bottom', 'top'] : ['top', 'bottom'], overlayY = _b[0], overlayFallbackY = _b[1];
	        var _c = [overlayY, overlayFallbackY], originY = _c[0], originFallbackY = _c[1];
	        var _d = [originX, originFallbackX], overlayX = _d[0], overlayFallbackX = _d[1];
	        var /** @type {?} */ offsetY = 0;
	        if (this.triggersSubmenu()) {
	            // When the menu is a sub-menu, it should always align itself
	            // to the edges of the trigger, instead of overlapping it.
	            overlayFallbackX = originX = this.menu.xPosition === 'before' ? 'start' : 'end';
	            originFallbackX = overlayX = originX === 'end' ? 'start' : 'end';
	            offsetY = overlayY === 'bottom' ? MENU_PANEL_TOP_PADDING : -MENU_PANEL_TOP_PADDING;
	        }
	        else if (!this.menu.overlapTrigger) {
	            originY = overlayY === 'top' ? 'bottom' : 'top';
	            originFallbackY = overlayFallbackY === 'top' ? 'bottom' : 'top';
	        }
	        return this._overlay.position()
	            .connectedTo(this._element, { originX: originX, originY: originY }, { overlayX: overlayX, overlayY: overlayY })
	            .withDirection(this.dir)
	            .withOffsetY(offsetY)
	            .withFallbackPosition({ originX: originFallbackX, originY: originY }, { overlayX: overlayFallbackX, overlayY: overlayY })
	            .withFallbackPosition({ originX: originX, originY: originFallbackY }, { overlayX: overlayX, overlayY: overlayFallbackY }, undefined, -offsetY)
	            .withFallbackPosition({ originX: originFallbackX, originY: originFallbackY }, { overlayX: overlayFallbackX, overlayY: overlayFallbackY }, undefined, -offsetY);
	    };
	    /**
	     * Cleans up the active subscriptions.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._cleanUpSubscriptions = /**
	     * Cleans up the active subscriptions.
	     * @return {?}
	     */
	    function () {
	        this._closeSubscription.unsubscribe();
	        this._hoverSubscription.unsubscribe();
	    };
	    /**
	     * Returns a stream that emits whenever an action that should close the menu occurs.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._menuClosingActions = /**
	     * Returns a stream that emits whenever an action that should close the menu occurs.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ backdrop = /** @type {?} */ ((this._overlayRef)).backdropClick();
	        var /** @type {?} */ detachments = /** @type {?} */ ((this._overlayRef)).detachments();
	        var /** @type {?} */ parentClose = this._parentMenu ? this._parentMenu.close : rxjs_observable_of.of();
	        var /** @type {?} */ hover = this._parentMenu ? this._parentMenu._hovered().pipe(rxjs_operators_filter.filter(function (active) { return active !== _this._menuItemInstance; }), rxjs_operators_filter.filter(function () { return _this._menuOpen; })) : rxjs_observable_of.of();
	        return rxjs_observable_merge.merge(backdrop, parentClose, hover, detachments);
	    };
	    /** Handles mouse presses on the trigger. */
	    /**
	     * Handles mouse presses on the trigger.
	     * @param {?} event
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._handleMousedown = /**
	     * Handles mouse presses on the trigger.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (!_angular_cdk_a11y.isFakeMousedownFromScreenReader(event)) {
	            this._openedByMouse = true;
	            // Since clicking on the trigger won't close the menu if it opens a sub-menu,
	            // we should prevent focus from moving onto it via click to avoid the
	            // highlight from lingering on the menu item.
	            if (this.triggersSubmenu()) {
	                event.preventDefault();
	            }
	        }
	    };
	    /** Handles key presses on the trigger. */
	    /**
	     * Handles key presses on the trigger.
	     * @param {?} event
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._handleKeydown = /**
	     * Handles key presses on the trigger.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var /** @type {?} */ keyCode = event.keyCode;
	        if (this.triggersSubmenu() && ((keyCode === _angular_cdk_keycodes.RIGHT_ARROW && this.dir === 'ltr') ||
	            (keyCode === _angular_cdk_keycodes.LEFT_ARROW && this.dir === 'rtl'))) {
	            this.openMenu();
	        }
	    };
	    /** Handles click events on the trigger. */
	    /**
	     * Handles click events on the trigger.
	     * @param {?} event
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._handleClick = /**
	     * Handles click events on the trigger.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (this.triggersSubmenu()) {
	            // Stop event propagation to avoid closing the parent menu.
	            event.stopPropagation();
	            this.openMenu();
	        }
	        else {
	            this.toggleMenu();
	        }
	    };
	    MatMenuTrigger.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: "[mat-menu-trigger-for], [matMenuTriggerFor]",
	                    host: {
	                        'aria-haspopup': 'true',
	                        '(mousedown)': '_handleMousedown($event)',
	                        '(keydown)': '_handleKeydown($event)',
	                        '(click)': '_handleClick($event)',
	                    },
	                    exportAs: 'matMenuTrigger'
	                },] },
	    ];
	    /** @nocollapse */
	    MatMenuTrigger.ctorParameters = function () { return [
	        { type: _angular_cdk_overlay.Overlay, },
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.ViewContainerRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [MAT_MENU_SCROLL_STRATEGY,] },] },
	        { type: MatMenu, decorators: [{ type: _angular_core.Optional },] },
	        { type: MatMenuItem, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self },] },
	        { type: _angular_cdk_bidi.Directionality, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_cdk_a11y.FocusMonitor, },
	    ]; };
	    MatMenuTrigger.propDecorators = {
	        "_deprecatedMatMenuTriggerFor": [{ type: _angular_core.Input, args: ['mat-menu-trigger-for',] },],
	        "menu": [{ type: _angular_core.Input, args: ['matMenuTriggerFor',] },],
	        "menuData": [{ type: _angular_core.Input, args: ['matMenuTriggerData',] },],
	        "menuOpened": [{ type: _angular_core.Output },],
	        "onMenuOpen": [{ type: _angular_core.Output },],
	        "menuClosed": [{ type: _angular_core.Output },],
	        "onMenuClose": [{ type: _angular_core.Output },],
	    };
	    return MatMenuTrigger;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var ɵ0 = {
	    overlapTrigger: true,
	    xPosition: 'after',
	    yPosition: 'below',
	};
	var MatMenuModule = /** @class */ (function () {
	    function MatMenuModule() {
	    }
	    MatMenuModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [
	                        _angular_cdk_a11y.A11yModule,
	                        _angular_common.CommonModule,
	                        _angular_material_core.MatCommonModule,
	                        _angular_material_core.MatRippleModule,
	                        _angular_cdk_overlay.OverlayModule,
	                        _angular_cdk_portal.PortalModule,
	                    ],
	                    exports: [MatMenu, MatMenuItem, MatMenuTrigger, MatMenuContent, _angular_material_core.MatCommonModule],
	                    declarations: [MatMenu, MatMenuItem, MatMenuTrigger, MatMenuContent],
	                    providers: [
	                        MAT_MENU_SCROLL_STRATEGY_PROVIDER,
	                        {
	                            provide: MAT_MENU_DEFAULT_OPTIONS,
	                            useValue: ɵ0,
	                        }
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    MatMenuModule.ctorParameters = function () { return []; };
	    return MatMenuModule;
	}());
	
	exports.MAT_MENU_SCROLL_STRATEGY = MAT_MENU_SCROLL_STRATEGY;
	exports.MatMenuModule = MatMenuModule;
	exports.MatMenu = MatMenu;
	exports.MAT_MENU_DEFAULT_OPTIONS = MAT_MENU_DEFAULT_OPTIONS;
	exports.MatMenuItem = MatMenuItem;
	exports.MatMenuTrigger = MatMenuTrigger;
	exports.matMenuAnimations = matMenuAnimations;
	exports.fadeInItems = fadeInItems;
	exports.transformMenu = transformMenu;
	exports.MatMenuContent = MatMenuContent;
	exports.ɵa20 = MatMenuItemBase;
	exports.ɵb20 = _MatMenuItemMixinBase;
	exports.ɵd20 = MAT_MENU_SCROLL_STRATEGY_PROVIDER;
	exports.ɵc20 = MAT_MENU_SCROLL_STRATEGY_PROVIDER_FACTORY;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=material-menu.umd.js.map


/***/ }),
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1332));
	__export(__webpack_require__(1150));


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1333));
	__export(__webpack_require__(1334));
	__export(__webpack_require__(1335));
	__export(__webpack_require__(1336));
	__export(__webpack_require__(1337));
	__export(__webpack_require__(1338));
	__export(__webpack_require__(1339));
	__export(__webpack_require__(1340));
	__export(__webpack_require__(1341));


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var http_1 = __webpack_require__(836);
	var core_1 = __webpack_require__(205);
	var utils_1 = __webpack_require__(740);
	var CustomerProfileService = (function () {
	    function CustomerProfileService(_http) {
	        this._http = _http;
	    }
	    CustomerProfileService.prototype.getCustomerProfile = function (id) {
	        return this._http.get("/api/backoffice/customers?id=" + id)
	            .map(function (response) { return response.json().records[0]; });
	    };
	    CustomerProfileService.prototype.searchCustomerProfileById = function (id) {
	        return this._http.get("/api/backoffice/customers/" + id)
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileService.prototype.getNewCustomerProfile = function (id) {
	        return this._http.get("/api/backoffice/customers?new&id=" + id)
	            .map(function (response) { return response.json().records[0]; });
	    };
	    CustomerProfileService.prototype.getProcessingCustomerProfile = function (id) {
	        return this._http.get("/api/backoffice/customers?processing&id=" + id)
	            .map(function (response) { return response.json().records[0]; });
	    };
	    CustomerProfileService.prototype.getDeclinedCustomerProfile = function (id) {
	        return this._http.get("/api/backoffice/customers?declined&id=" + id)
	            .map(function (response) { return response.json().records[0]; });
	    };
	    CustomerProfileService.prototype.getPendingCustomerProfile = function (id) {
	        return this._http.get("/api/backoffice/customers?pending&id=" + id)
	            .map(function (response) { return response.json().records[0]; });
	    };
	    CustomerProfileService.prototype.findCustomerProfile = function (id, status) {
	        return this._http.get("/api/backoffice/customers/profiles/" + status + "?id=" + id)
	            .map(function (response) { return response.json().records[0]; });
	    };
	    CustomerProfileService.prototype.getNewCustomerProfiles = function (filter, pagination) {
	        var search = utils_1.HttpUtils.searchParams()
	            .append('id', filter.id)
	            .append('customerName', filter.customerName)
	            .append('email', filter.email)
	            .append('introducerName', filter.introducerName)
	            .append('accountTypeId', filter.accountTypeId)
	            .append('accountOpeningDateFrom', filter.period && filter.period.beginDate)
	            .append('accountOpeningDateTo', filter.period && filter.period.endDate)
	            .append('page', pagination.page)
	            .append('limit', pagination.limit)
	            .toSearch();
	        return this._http.get('/api/backoffice/customers?new', { search: search })
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileService.prototype.getDeclinedCustomerProfiles = function (filter, pagination) {
	        var search = utils_1.HttpUtils.searchParams()
	            .append('id', filter.id)
	            .append('customerName', filter.customerName)
	            .append('email', filter.email)
	            .append('introducerName', filter.introducerName)
	            .append('accountTypeId', filter.accountTypeId)
	            .append('accountOpeningDateFrom', filter.period && filter.period.beginDate)
	            .append('accountOpeningDateTo', filter.period && filter.period.endDate)
	            .append('page', pagination.page)
	            .append('limit', pagination.limit)
	            .toSearch();
	        return this._http.get('/api/backoffice/customers?declined', { search: search })
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileService.prototype.getProcessingCustomerProfiles = function (filter, pagination) {
	        var search = utils_1.HttpUtils.searchParams()
	            .append('id', filter.id)
	            .append('customerName', filter.customerName)
	            .append('email', filter.email)
	            .append('introducerName', filter.introducerName)
	            .append('accountTypeId', filter.accountTypeId)
	            .append('accountOpeningDateFrom', filter.period && filter.period.beginDate)
	            .append('accountOpeningDateTo', filter.period && filter.period.endDate)
	            .append('page', pagination.page)
	            .append('limit', pagination.limit)
	            .toSearch();
	        return this._http.get('/api/backoffice/customers?processing', { search: search })
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileService.prototype.getCustomerProfiles = function (filter, pagination, status) {
	        var search = utils_1.HttpUtils.searchParams()
	            .append('id', filter.id)
	            .append('customerName', filter.customerName)
	            .append('email', filter.email)
	            .append('introducerName', filter.introducerName)
	            .append('accountTypeId', filter.accountTypeId)
	            .append('accountOpeningDateFrom', filter.period && filter.period.beginDate)
	            .append('accountOpeningDateTo', filter.period && filter.period.endDate)
	            .append('page', pagination.page)
	            .append('limit', pagination.limit)
	            .toSearch();
	        return this._http.get("/api/backoffice/customers/profiles/" + status, { search: search })
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileService.prototype.getProfileStatesForRegisteredClients = function () {
	        return this._http.get('/api/backoffice/customers/registered/states').map(function (response) { return response.json(); });
	    };
	    CustomerProfileService.prototype.getProfileTypes = function () {
	        return this._http.get('/api/backoffice/customers/types').map(function (response) { return response.json(); });
	    };
	    CustomerProfileService.prototype.getProfileKinds = function () {
	        return this._http.get('/api/backoffice/dictionary/profile_kinds')
	            .map(function (response) { return response.json().records; });
	    };
	    CustomerProfileService.prototype.getProductCode = function () {
	        return this._http.get('/api/backoffice/dictionary/product_code')
	            .map(function (response) { return response.json().records; });
	    };
	    CustomerProfileService.prototype.declineCustomerProfileRegistration = function (customerId, declinedReasonsIds, declinedCustomReason) {
	        return this._http.patch("/api/backoffice/customers/" + customerId + "?decline", { reasonsIds: declinedReasonsIds, customReason: declinedCustomReason }).map(function (response) { return response.json(); });
	    };
	    CustomerProfileService.prototype.closeCustomerProfile = function (customerId, closeReasonsIds, closeCustomReason) {
	        return this._http.patch("/api/backoffice/customers/" + customerId + "?close", { reasonsIds: closeReasonsIds, customReason: closeCustomReason }).map(function (response) { return response; });
	    };
	    CustomerProfileService.prototype.suspendCustomerProfile = function (customerId, suspendedReasonsIds, suspendedCustomReason) {
	        return this._http.patch("/api/backoffice/customers/" + customerId + "?suspend", { reasonsIds: suspendedReasonsIds, customReason: suspendedCustomReason }).map(function (response) { return response; });
	    };
	    CustomerProfileService.prototype.unSuspendCustomerProfile = function (customerId) {
	        return this._http.patch("/api/backoffice/customers/" + customerId + "?unsuspend", {}).map(function (response) { return response; });
	    };
	    CustomerProfileService.prototype.getProfileVerificationStatuses = function () {
	        return this._http.get('/api/backoffice/customers/verification-statuses').map(function (response) { return response.json().items; });
	    };
	    CustomerProfileService.prototype.getDeclinedCustomerProfileReasons = function (id) {
	        return this._http.get("/api/backoffice/customers/" + id + "?declinedProfile")
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileService.prototype.getCustomerProfileReasons = function (id, profileState) {
	        return this._http.get("/api/backoffice/customers/reasons?id=" + id + "&status=" + profileState)
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileService.prototype.processCustomerProfile = function (customerId, productCode) {
	        var body = { productCode: productCode };
	        return this._http.post("/api/backoffice/customers/" + customerId + "/process", body)
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileService.prototype.processAgentCustomerProfile = function (customerId) {
	        return this._http.post("/api/backoffice/customers/" + customerId + "/process/agent", {})
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileService.prototype.processMoonwardCustomerProfile = function (customerId) {
	        return this._http.post("/api/backoffice/customers/" + customerId + "/process/moorwand", {})
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileService.prototype.processFinXpCustomerProfile = function (customerId) {
	        return this._http.post("/api/backoffice/customers/" + customerId + "/process/finxp", {})
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileService.prototype.processEmoneyCustomerProfile = function (customerId) {
	        return this._http.post("/api/backoffice/customers/" + customerId + "/process/emoney", {})
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileService.prototype.updateCustomerProfile = function (customerId, currentProfileState, newProfileState) {
	        return this._http.post("/api/backoffice/customers/" + customerId + "/updateProfileState", { currentProfileState: currentProfileState, newProfileState: newProfileState })
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileService.prototype.updateCustomerProfileWithReason = function (customerId, status, reasonsIds, customReason) {
	        return this._http.patch("/api/backoffice/customers/" + customerId + "/updateProfileState", { newProfileState: status, reasonsIds: reasonsIds, customReason: customReason }).map(function (response) { return response.json(); });
	    };
	    CustomerProfileService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], CustomerProfileService);
	    return CustomerProfileService;
	}());
	exports.CustomerProfileService = CustomerProfileService;


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var http_1 = __webpack_require__(836);
	var core_1 = __webpack_require__(205);
	var search_api_observable_service_1 = __webpack_require__(1176);
	var CustomerAccountsService = (function () {
	    function CustomerAccountsService(_http, _searchApiObservableService) {
	        this._http = _http;
	        this._searchApiObservableService = _searchApiObservableService;
	    }
	    CustomerAccountsService.prototype.getProfileStatesForRegisteredClients = function () {
	        return this._http.get('/api/backoffice/customers/registered/account/states').map(function (response) { return response.json(); });
	    };
	    CustomerAccountsService.prototype.getCurrencies = function () {
	        return this._http.get('/api/client/dictionary/currencies')
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return lodash_1.get(response, 'currencies', []); });
	    };
	    CustomerAccountsService.prototype.searchAccounts = function (filterModel, profileId) {
	        return this._searchApiObservableService
	            .searchRequestForUrl("/api/backoffice/customers/" + profileId + "/accounts/search", filterModel)
	            .map(function (response) { return lodash_1.get(response, 'accounts', []); });
	    };
	    CustomerAccountsService.prototype.getClientUser = function (prifileId, userName) {
	        var encodedUserName = encodeURIComponent(userName);
	        return this._http
	            .get("/api/backoffice/customers/" + prifileId + "/client?username=" + encodedUserName)
	            .map(function (response) { return response.json(); });
	    };
	    CustomerAccountsService.prototype.changeAccountState = function (accountId, state, reason) {
	        var requestBody = {
	            state: "" + state
	        };
	        if (reason) {
	            requestBody['reason'] = reason;
	        }
	        return this._http
	            .patch("/api/backoffice/customers/" + accountId + "/state", requestBody)
	            .map(function (response) { return response.json(); });
	    };
	    CustomerAccountsService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http,
	            search_api_observable_service_1.SearchApiObservableService])
	    ], CustomerAccountsService);
	    return CustomerAccountsService;
	}());
	exports.CustomerAccountsService = CustomerAccountsService;


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var CorporateAccountsService = (function () {
	    function CorporateAccountsService(_http) {
	        this._http = _http;
	    }
	    CorporateAccountsService.prototype.getCorporateAccount = function (id) {
	        return this._http.get('/api/backoffice/corporate-accounts/' + id)
	            .map(function (response) { return response.json(); });
	    };
	    CorporateAccountsService.prototype.getCorporateAccountAttachments = function (id) {
	        return this._http.get("/api/backoffice/corporate-accounts/" + id + "/attachments")
	            .map(function (response) { return response.json(); });
	    };
	    CorporateAccountsService.prototype.getCorporateProfileAttachments = function (profileId) {
	        return this._http.get("/api/backoffice/corporate-accounts/" + profileId + "/attachments/all")
	            .map(function (response) { return response.json(); });
	    };
	    CorporateAccountsService.prototype.updateBusinessCustomerInformation = function (profileId, businessCustomerInformation) {
	        return this._http.patch("/api/backoffice/corporate-accounts/" + profileId + "/business-customer-information", businessCustomerInformation)
	            .map(function (response) { return response.json(); });
	    };
	    CorporateAccountsService.prototype.updateRegisteredOfficeAddress = function (profileId, registeredOfficeAddress) {
	        return this._http.patch("/api/backoffice/corporate-accounts/" + profileId + "/registered-office-address", registeredOfficeAddress)
	            .map(function (response) { return response.json(); });
	    };
	    CorporateAccountsService.prototype.updateOfficialBusinessLocation = function (profileId, officialBusinessLocation) {
	        return this._http.patch("/api/backoffice/corporate-accounts/" + profileId + "/official-business-location", officialBusinessLocation)
	            .map(function (response) { return response.json(); });
	    };
	    CorporateAccountsService.prototype.updateContactInformation = function (profileId, contactInformation) {
	        return this._http.patch("/api/backoffice/corporate-accounts/" + profileId + "/contact-information", contactInformation)
	            .map(function (response) { return response.json(); });
	    };
	    CorporateAccountsService.prototype.updateStatementAffairs = function (profileId, statementAffairs) {
	        return this._http.patch("/api/backoffice/corporate-accounts/" + profileId + "/statement-of-affairs", statementAffairs)
	            .map(function (response) { return response.json(); });
	    };
	    CorporateAccountsService.prototype.updateInitialDeposit = function (profileId, initialDeposits) {
	        return this._http.patch("/api/backoffice/corporate-accounts/" + profileId + "/initial-deposit", initialDeposits)
	            .map(function (response) { return response.json(); });
	    };
	    CorporateAccountsService.prototype.updateExpectedTurnover = function (profileId, expectedTurnover) {
	        return this._http.patch("/api/backoffice/corporate-accounts/" + profileId + "/expected-turnover", expectedTurnover)
	            .map(function (response) { return response.json(); });
	    };
	    CorporateAccountsService.prototype.updateAuthorisedSignatory = function (profileId, authorisedSignatory) {
	        return this._http.patch("/api/backoffice/corporate-accounts/" + profileId + "/authorised-signatory", authorisedSignatory)
	            .map(function (response) { return response.json(); });
	    };
	    CorporateAccountsService.prototype.updateDirectors = function (profileId, directors) {
	        return this._http.patch("/api/backoffice/corporate-accounts/" + profileId + "/directors", directors)
	            .map(function (response) { return response.json(); });
	    };
	    CorporateAccountsService.prototype.updateShareholders = function (profileId, shareholders) {
	        return this._http.patch("/api/backoffice/corporate-accounts/" + profileId + "/shareholders", shareholders)
	            .map(function (response) { return response.json(); });
	    };
	    CorporateAccountsService.prototype.updateIntroducer = function (profileId, introducer) {
	        return this._http.patch("/api/backoffice/corporate-accounts/" + profileId + "/introducer", introducer)
	            .map(function (response) { return response.json(); });
	    };
	    CorporateAccountsService.prototype.updateAccountCurrencies = function (profileId, accountCurrencies) {
	        return this._http.patch("/api/backoffice/corporate-accounts/" + profileId + "/account-currencies", accountCurrencies)
	            .map(function (response) { return response.json(); });
	    };
	    CorporateAccountsService.prototype.updateUsageReferral = function (profileId, usageReferral) {
	        return this._http.patch("/api/backoffice/corporate-accounts/" + profileId + "/usage-and-referral", usageReferral)
	            .map(function (response) { return response.json(); });
	    };
	    CorporateAccountsService.prototype.updateLegalDocStatus = function (idDB, status) {
	        return this._http.patch("/api/backoffice/corporate-accounts/update-doc-status", {
	            idDB: idDB,
	            status: status
	        })
	            .map(function (response) { return response.json(); });
	    };
	    CorporateAccountsService.prototype.getLegalDocStatus = function (idDb) {
	        return this._http.get("/api/backoffice/corporate-accounts/" + idDb + "/get-doc-status")
	            .map(function (response) { return response.json(); });
	    };
	    CorporateAccountsService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], CorporateAccountsService);
	    return CorporateAccountsService;
	}());
	exports.CorporateAccountsService = CorporateAccountsService;


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var http_1 = __webpack_require__(836);
	var core_1 = __webpack_require__(205);
	var lodash_1 = __webpack_require__(268);
	var FileDownloadService = (function () {
	    function FileDownloadService(_http) {
	        this._http = _http;
	        this.BO_API_PATH = '/api/backoffice';
	    }
	    FileDownloadService.prototype.getApiRootPath = function () {
	        return this.BO_API_PATH;
	    };
	    FileDownloadService.prototype.downloadFile = function (fileId) {
	        return this._http.get(this.getApiRootPath() + "/download/attachment/" + fileId, { responseType: http_1.ResponseContentType.Blob });
	    };
	    FileDownloadService.prototype.downloadAttachmentsFile = function (fileIds, fileName) {
	        return this._http.get(this.getApiRootPath() + "/download/attachment-items/" + fileIds + "/attachments-name/" + fileName, { responseType: http_1.ResponseContentType.Blob });
	    };
	    FileDownloadService.prototype.downloadAllCorporateAttachmentsFile = function (profileId, fileName) {
	        return this._http.get(this.getApiRootPath() + "/corporate-accounts/" + profileId + "/attachments?all&download", {
	            params: { fileName: fileName },
	            responseType: http_1.ResponseContentType.Blob
	        });
	    };
	    FileDownloadService.prototype.downloadCRAFile = function (profileId, fileName) {
	        return this._http.get(this.getApiRootPath() + "/download/cra/" + profileId, {
	            responseType: http_1.ResponseContentType.Blob
	        });
	    };
	    FileDownloadService.prototype.downloadNeocheckReport = function (profileId) {
	        return this._http.get(this.getApiRootPath() + "/verification/report/" + profileId, {
	            responseType: http_1.ResponseContentType.Blob
	        });
	    };
	    FileDownloadService.prototype.downloadNeocheckDirectorsShareholdersReport = function (id, type) {
	        return this._http.get(this.getApiRootPath() + "/verification/director-shareholder/" + id + "/report/" + type, {
	            responseType: http_1.ResponseContentType.Blob
	        });
	    };
	    FileDownloadService.prototype.downloadDailyBalanceReport = function () {
	        return this._http.get(this.getApiRootPath() + "/customers/balance/report/", {
	            responseType: http_1.ResponseContentType.Blob
	        });
	    };
	    FileDownloadService.prototype.downloadDailyBalanceFilterReport = function (model) {
	        var from = lodash_1.get(model, 'date.from', null);
	        var to = lodash_1.get(model, 'date.to', null);
	        var DATE_PATTERN = /^\d{2}\.\d{2}\.\d{4}$/;
	        if (!from || !to || !DATE_PATTERN.test(from) || !DATE_PATTERN.test(to)) {
	            throw new Error('Invalid date format in balance report filter');
	        }
	        return this._http.post(this.getApiRootPath() + "/customers/balance/report/filter", {
	            period: { from: from, to: to }
	        }, {
	            responseType: http_1.ResponseContentType.Blob
	        });
	    };
	    FileDownloadService.prototype.downloadPaymentReport = function () {
	        return this._http.get(this.getApiRootPath() + "/transfers/outgoing/report/outgoing", {
	            responseType: http_1.ResponseContentType.Blob
	        });
	    };
	    FileDownloadService.prototype.downloadAmlRulesPaymentReport = function (filterModel) {
	        return this._http.get(this.getApiRootPath() + "/aml-rules/aml/report", {
	            params: filterModel,
	            responseType: http_1.ResponseContentType.Blob
	        });
	    };
	    FileDownloadService.prototype.downloadCustomReport = function (ruleId) {
	        return this._http.get(this.getApiRootPath() + "/aml-rules/aml/report/" + ruleId, {
	            responseType: http_1.ResponseContentType.Blob
	        });
	    };
	    FileDownloadService.prototype.downloadProviderReport = function (filterModel) {
	        return this._http.post(this.getApiRootPath() + "/provider-reports/report", filterModel, {
	            responseType: http_1.ResponseContentType.Blob
	        });
	    };
	    FileDownloadService.prototype.generateProviderMIReport = function (filterModel) {
	        return this._http.patch(this.getApiRootPath() + "/provider-reports/report/", filterModel, {});
	    };
	    FileDownloadService.prototype.downloadMoorwandPaymentsExcel = function (payments) {
	        return this._http.post(this.getApiRootPath() + "/provider-reports/moorwand-payments/excel", payments, {
	            responseType: http_1.ResponseContentType.Blob
	        });
	    };
	    FileDownloadService.prototype.downloadMoorwandReconciliationReportExcel = function (payments) {
	        return this._http.post(this.getApiRootPath() + "/provider-reports/moorwand-reconciliation-report/excel", payments, {
	            responseType: http_1.ResponseContentType.Blob
	        });
	    };
	    FileDownloadService.prototype.validateProviderFullTransactionReport = function (reportFilter) {
	        return this._http.post(this.getApiRootPath() + "/provider-reports/report/check-full-trans-hist", reportFilter)
	            .map(function (response) { return response.json(); });
	    };
	    FileDownloadService.prototype.downloadDailyChechPepReport = function (fileName) {
	        return this._http.post(this.getApiRootPath() + "/check-pep/pep-reports/download", {
	            fileName: fileName
	        }, {
	            responseType: http_1.ResponseContentType.Blob
	        });
	    };
	    FileDownloadService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], FileDownloadService);
	    return FileDownloadService;
	}());
	exports.FileDownloadService = FileDownloadService;


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var http_1 = __webpack_require__(836);
	var core_1 = __webpack_require__(205);
	var ATTACHMENT_TYPE_URL = '/api/client/dictionary/attachment-type';
	var AttachmentTypeService = (function () {
	    function AttachmentTypeService(_http) {
	        this._http = _http;
	    }
	    AttachmentTypeService.prototype.getAttachmentSubTypes = function (type) {
	        var URL = ATTACHMENT_TYPE_URL + "/?type=" + type;
	        return this._http.get(URL)
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return response.attachmentTypes; });
	    };
	    AttachmentTypeService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], AttachmentTypeService);
	    return AttachmentTypeService;
	}());
	exports.AttachmentTypeService = AttachmentTypeService;


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var KycService = (function () {
	    function KycService(_http) {
	        this._http = _http;
	    }
	    KycService.prototype.getResult = function (profileId) {
	        return this._http.get("/api/backoffice/verification/kyc/" + profileId)
	            .map(function (response) { return response.json(); });
	    };
	    KycService.prototype.verifyOrUpdateProfile = function (profileId) {
	        return this._http.post("/api/backoffice/verification/kyc", { clientProfileId: profileId });
	    };
	    KycService.prototype.getCRAFile = function (profileId) {
	        return this._http.get("/api/backoffice/download/cra/" + profileId)
	            .map(function (response) { return response.json(); });
	    };
	    KycService.prototype.downloadFile = function (data) {
	        var blob = new Blob([data], { type: 'text/csv' });
	        var url = window.URL.createObjectURL(blob);
	        window.open(url);
	    };
	    KycService.prototype.getAOB = function (profileId) {
	        return this._http.get("/api/backoffice/verification/aob/" + profileId)
	            .map(function (response) { return response.text(); });
	    };
	    KycService.prototype.saveReason = function (profileId, reason) {
	        return this._http.post("/api/backoffice/verification/kyc/approval", {
	            clientProfileId: profileId,
	            reason: reason
	        });
	    };
	    KycService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], KycService);
	    return KycService;
	}());
	exports.KycService = KycService;


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var OnfidoService = (function () {
	    function OnfidoService(_http) {
	        this._http = _http;
	    }
	    OnfidoService.prototype.getResult = function (profileId) {
	        return this._http.get("/api/backoffice/verification/onfido/" + profileId)
	            .map(function (response) { return response.json(); });
	    };
	    OnfidoService.prototype.createApplicant = function (profileId) {
	        return this._http.post("/api/backoffice/verification/onfido", { clientProfileId: profileId });
	    };
	    OnfidoService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], OnfidoService);
	    return OnfidoService;
	}());
	exports.OnfidoService = OnfidoService;


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var IntegrationModuleService = (function () {
	    function IntegrationModuleService(_http) {
	        this._http = _http;
	    }
	    IntegrationModuleService.prototype.getAvailabilityForClientProfile = function (profileId) {
	        return this._http
	            .get("/api/backoffice/customers/" + profileId + "/integration-modules")
	            .map(function (response) { return response.json(); });
	    };
	    IntegrationModuleService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], IntegrationModuleService);
	    return IntegrationModuleService;
	}());
	exports.IntegrationModuleService = IntegrationModuleService;


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var http_1 = __webpack_require__(836);
	var core_1 = __webpack_require__(205);
	var AriadnextService = (function () {
	    function AriadnextService(_http) {
	        this._http = _http;
	    }
	    AriadnextService.prototype.getResultByProfile = function (profileId) {
	        return this._http.get("/api/backoffice/verification/ariadnext/" + profileId)
	            .map(function (response) { return response.json(); });
	    };
	    AriadnextService.prototype.getResultByUser = function (profileId, userId) {
	        return this._http.get("/api/backoffice/verification/ariadnext/" + profileId + "/users/" + userId)
	            .map(function (response) { return response.json(); });
	    };
	    AriadnextService.prototype.createApplicant = function (profileId, userId, byPhone) {
	        return this._http.post("/api/backoffice/verification/ariadnext/" + profileId, { clientUserId: userId, sendLinkApproach: byPhone ? 'PHONE' : 'EMAIL' });
	    };
	    AriadnextService.prototype.verify = function (profileId, userId) {
	        return this._http.patch("/api/backoffice/verification/ariadnext/" + profileId, {
	            userId: userId,
	            status: 'verify'
	        });
	    };
	    AriadnextService.prototype.decline = function (profileId, userId) {
	        return this._http.patch("/api/backoffice/verification/ariadnext/" + profileId, {
	            userId: userId,
	            status: 'decline'
	        });
	    };
	    AriadnextService.prototype.downloadDocument = function (fileUid) {
	        return this._http.get("/api/backoffice/verification/ariadnext/documents/" + fileUid, { responseType: http_1.ResponseContentType.Blob });
	    };
	    AriadnextService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], AriadnextService);
	    return AriadnextService;
	}());
	exports.AriadnextService = AriadnextService;


/***/ }),
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var PrivateAccountsService = (function () {
	    function PrivateAccountsService(_http) {
	        this._http = _http;
	    }
	    PrivateAccountsService.prototype.getPrivateAccount = function (id) {
	        return this._http.get('/api/backoffice/private_accounts/' + id)
	            .map(function (response) { return response.json(); });
	    };
	    PrivateAccountsService.prototype.getPrivateAccountAttachments = function (id) {
	        return this._http.get("/api/backoffice/private_accounts/" + id)
	            .map(function (response) { return response.json(); });
	    };
	    PrivateAccountsService.prototype.updatePersonInformation = function (id, model) {
	        return this._http.patch("/api/backoffice/private_accounts/" + id + "/usage-and-referral", model)
	            .map(function (response) { return response.json(); });
	    };
	    PrivateAccountsService.prototype.updateApplicantInformation = function (id, model) {
	        return this._http.patch("/api/backoffice/private_accounts/" + id + "/applicant", model)
	            .map(function (response) { return response.json(); });
	    };
	    PrivateAccountsService.prototype.updateRegisteredClientApplicantInformation = function (id, model) {
	        return this._http.patch("/api/backoffice/private_accounts/" + id + "/applicant/registered", model)
	            .map(function (response) { return response.json(); });
	    };
	    PrivateAccountsService.prototype.updateEmploymentInformation = function (id, model) {
	        return this._http.patch("/api/backoffice/private_accounts/" + id + "/employment", model)
	            .map(function (response) { return response.json(); });
	    };
	    PrivateAccountsService.prototype.updateFundsInformation = function (id, model) {
	        return this._http.patch("/api/backoffice/private_accounts/" + id + "/funds", model)
	            .map(function (response) { return response.json(); });
	    };
	    PrivateAccountsService.prototype.updateIntroducerInformation = function (id, model) {
	        return this._http.patch("/api/backoffice/private_accounts/" + id + "/introducer", model)
	            .map(function (response) { return response.json(); });
	    };
	    PrivateAccountsService.prototype.updateLitigationInformation = function (id, model) {
	        return this._http.patch("/api/backoffice/private_accounts/" + id + "/litigation", model)
	            .map(function (response) { return response.json(); });
	    };
	    PrivateAccountsService.prototype.updateMasterAccountCurrencyInformation = function (id, model) {
	        return this._http.patch("/api/backoffice/private_accounts/" + id + "/account-currency", model)
	            .map(function (response) { return response.json(); });
	    };
	    PrivateAccountsService.prototype.updatePositionInformation = function (id, model) {
	        return this._http.patch("/api/backoffice/private_accounts/" + id + "/position", model)
	            .map(function (response) { return response.json(); });
	    };
	    PrivateAccountsService.prototype.upload = function (file, type) {
	        var formData = new FormData();
	        formData.append('file', file, file.name.replace(/\.[^/.]+$/, ''));
	        return this._http.post("/api/backoffice/files?type=" + type, formData)
	            .map(function (response) { return response.json(); });
	    };
	    PrivateAccountsService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], PrivateAccountsService);
	    return PrivateAccountsService;
	}());
	exports.PrivateAccountsService = PrivateAccountsService;


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1407));
	__export(__webpack_require__(1410));
	__export(__webpack_require__(1414));
	__export(__webpack_require__(1425));
	__export(__webpack_require__(1426));
	__export(__webpack_require__(1427));


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1408));
	__export(__webpack_require__(1409));


/***/ }),
/* 1408 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var PrivateAccountModel = (function () {
	    function PrivateAccountModel() {
	    }
	    return PrivateAccountModel;
	}());
	exports.PrivateAccountModel = PrivateAccountModel;


/***/ }),
/* 1409 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var RegistrationType;
	(function (RegistrationType) {
	    RegistrationType[RegistrationType["CORPORATE"] = 0] = "CORPORATE";
	    RegistrationType[RegistrationType["PRIVATE"] = 1] = "PRIVATE";
	    RegistrationType[RegistrationType["AUTHORISED"] = 2] = "AUTHORISED";
	    RegistrationType[RegistrationType["AUTHORISED_KYC"] = 3] = "AUTHORISED_KYC";
	})(RegistrationType = exports.RegistrationType || (exports.RegistrationType = {}));


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1411));
	__export(__webpack_require__(1412));
	__export(__webpack_require__(1413));


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var PersonalTitlesService = (function () {
	    function PersonalTitlesService(http) {
	        this.http = http;
	    }
	    PersonalTitlesService.prototype.getTitles = function () {
	        return this.http.get('/api/client/dictionary/titles').map(function (result) { return result.json(); })
	            .map(function (result) {
	            return result.titles.map(function (title) {
	                return ({
	                    id: title.id,
	                    name: title.name
	                });
	            });
	        });
	    };
	    PersonalTitlesService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], PersonalTitlesService);
	    return PersonalTitlesService;
	}());
	exports.PersonalTitlesService = PersonalTitlesService;


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	exports.OTHER_OCCUPATION = { id: 6, name: "Other", specify: true };
	var OccupationService = (function () {
	    function OccupationService(http) {
	        this.http = http;
	    }
	    OccupationService.prototype.getOccupations = function () {
	        return this.http.get('/api/client/dictionary/occupations').map(function (result) { return result.json(); })
	            .map(function (result) {
	            return result.occupations.map(function (occupation) {
	                return ({
	                    id: occupation.id,
	                    name: occupation.name,
	                    specify: occupation.specify
	                });
	            });
	        });
	    };
	    OccupationService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], OccupationService);
	    return OccupationService;
	}());
	exports.OccupationService = OccupationService;


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var CompanyTypeService = (function () {
	    function CompanyTypeService(http) {
	        this.http = http;
	    }
	    CompanyTypeService.prototype.getAllCompanyTypes = function () {
	        return this.http.get('/api/client/dictionary/company-types').map(function (result) { return result.json(); })
	            .map(function (result) {
	            return result.types.map(function (type) {
	                return ({
	                    id: type.id,
	                    name: type.name,
	                    specify: true
	                });
	            });
	        });
	    };
	    CompanyTypeService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], CompanyTypeService);
	    return CompanyTypeService;
	}());
	exports.CompanyTypeService = CompanyTypeService;


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var rxjs_1 = __webpack_require__(304);
	var translate_1 = __webpack_require__(302);
	var http_2 = __webpack_require__(1415);
	var UPLOAD_URL = '/api/client/file_import/provide';
	var ATTACHMENT_TYPE_URL = '/api/client/dictionary/attachment-type';
	var AttachmentType;
	(function (AttachmentType) {
	    AttachmentType["PASSPORT"] = "PASSPORT";
	    AttachmentType["SELFIE"] = "SELFIE";
	    AttachmentType["ADDRESS"] = "ADDRESS";
	    AttachmentType["DOCUMENT"] = "DOCUMENT";
	    AttachmentType["BUSINESS_ADDRESS"] = "BUSINESS_ADDRESS";
	    AttachmentType["PROOF"] = "PROOF";
	    AttachmentType["CORPORATE_STRUCTURE"] = "CORPORATE_STRUCTURE";
	})(AttachmentType = exports.AttachmentType || (exports.AttachmentType = {}));
	var AttachmentTypeID;
	(function (AttachmentTypeID) {
	    AttachmentTypeID[AttachmentTypeID["PASSPORT"] = 1] = "PASSPORT";
	    AttachmentTypeID[AttachmentTypeID["SELFIE"] = 2] = "SELFIE";
	    AttachmentTypeID[AttachmentTypeID["ADDRESS"] = 3] = "ADDRESS";
	    AttachmentTypeID[AttachmentTypeID["DOCUMENT"] = 4] = "DOCUMENT";
	    AttachmentTypeID[AttachmentTypeID["BUSINESS_ADDRESS"] = 5] = "BUSINESS_ADDRESS";
	    AttachmentTypeID[AttachmentTypeID["PROOF"] = 6] = "PROOF";
	    AttachmentTypeID[AttachmentTypeID["CORPORATE_STRUCTURE"] = 7] = "CORPORATE_STRUCTURE";
	})(AttachmentTypeID = exports.AttachmentTypeID || (exports.AttachmentTypeID = {}));
	var AttachmentService = (function () {
	    function AttachmentService(_http, _translate) {
	        this._http = _http;
	        this._translate = _translate;
	    }
	    AttachmentService.prototype.attach = function (file, attachmentType, progressSubscriber) {
	        var _this = this;
	        console.log('estamos llamando a attach');
	        return rxjs_1.Observable.create(function (observer) {
	            var xhr = new XMLHttpRequest(), formData = new FormData();
	            formData.append('file', file, file.name);
	            xhr.onreadystatechange = function () {
	                if (xhr.readyState === 4) {
	                    if (xhr.status === 200) {
	                        observer.next(JSON.parse(xhr.response));
	                        observer.complete();
	                    }
	                    else {
	                        var clientErrorResponse = new http_2.ClientErrorResponse();
	                        try {
	                            clientErrorResponse = http_2.getClientErrorResponseFromJson(JSON.parse(xhr.response));
	                        }
	                        catch (e) {
	                            clientErrorResponse.status = 500;
	                            clientErrorResponse.type = http_2.getClientErrorTypeByStatus(500);
	                            clientErrorResponse.errorCode = http_2.getClientErrorCodeByServerCode('ERR001');
	                            clientErrorResponse.errorMessage = _this._translate.getValue('COMMON.ERROR.SYSTEM');
	                        }
	                        observer.error(clientErrorResponse);
	                    }
	                }
	            };
	            xhr.upload.onprogress = function (event) {
	                progressSubscriber.next({
	                    progressInPercent: Math.round(event.loaded / event.total * 100),
	                    progressInBytes: event.loaded
	                });
	            };
	            xhr.open('POST', UPLOAD_URL + "?type=" + attachmentType, true);
	            xhr.send(formData);
	        });
	    };
	    AttachmentService.prototype.getAttachmentTypes = function (type) {
	        var URL = ATTACHMENT_TYPE_URL + "/?type=" + type;
	        return this._http.get(URL)
	            .map(function (response) { return response.json(); })
	            .map(function (response) { return response.attachmentTypes; });
	    };
	    AttachmentService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http,
	            translate_1.TranslateManager])
	    ], AttachmentService);
	    return AttachmentService;
	}());
	exports.AttachmentService = AttachmentService;


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1416));
	__export(__webpack_require__(1424));
	__export(__webpack_require__(1422));
	__export(__webpack_require__(1421));
	__export(__webpack_require__(1420));
	__export(__webpack_require__(1423));


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var client_http_1 = __webpack_require__(1417);
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var client_xhr_backend_1 = __webpack_require__(1419);
	var HTTP_CLIENT_PROVIDER = {
	    provide: http_1.Http,
	    useFactory: function (backend, options) { return new client_http_1.ClientHttp(backend, options); },
	    deps: [http_1.XHRBackend, http_1.RequestOptions]
	};
	var CLIENT_XHR_BACKEND_PROVIDER = {
	    provide: http_1.XHRBackend,
	    useFactory: function (browser, options, strategy) {
	        return new client_xhr_backend_1.ClientXhrBackend(browser, options, strategy);
	    },
	    deps: [http_1.BrowserXhr, http_1.ResponseOptions, http_1.XSRFStrategy]
	};
	var ClientHttpModule = (function () {
	    function ClientHttpModule() {
	    }
	    ClientHttpModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                http_1.HttpModule
	            ],
	            providers: [
	                CLIENT_XHR_BACKEND_PROVIDER,
	                HTTP_CLIENT_PROVIDER
	            ],
	            exports: [
	                http_1.HttpModule
	            ]
	        })
	    ], ClientHttpModule);
	    return ClientHttpModule;
	}());
	exports.ClientHttpModule = ClientHttpModule;


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(903);
	var cookies_manager_1 = __webpack_require__(1418);
	var constants_1 = __webpack_require__(861);
	var http_2 = __webpack_require__(836);
	var ClientHttp = (function (_super) {
	    __extends(ClientHttp, _super);
	    function ClientHttp(backend, defaultOptions) {
	        return _super.call(this, backend, defaultOptions) || this;
	    }
	    ClientHttp.prototype.modifyOptions = function (options) {
	        if (options == null) {
	            options = new http_2.RequestOptions();
	        }
	        if (options.headers == null) {
	            options.headers = new http_2.Headers();
	        }
	        this.trySetTokenHeader(options.headers);
	        return options;
	    };
	    ClientHttp.prototype.modifyResponseCallback = function () {
	        return function (response) {
	            if (response && response.headers) {
	                if (response.headers.has(constants_1.TOKEN_HEADER)) {
	                    cookies_manager_1.CookiesManager.setToken(response.headers.get(constants_1.TOKEN_HEADER));
	                }
	            }
	            return response;
	        };
	    };
	    ClientHttp.prototype.trySetTokenHeader = function (headers) {
	        if (cookies_manager_1.CookiesManager.isTokenExist()) {
	            headers.append(constants_1.TOKEN_HEADER, cookies_manager_1.CookiesManager.getToken());
	        }
	    };
	    ClientHttp = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_2.ConnectionBackend, http_2.RequestOptions])
	    ], ClientHttp);
	    return ClientHttp;
	}(http_1.MutableHttp));
	exports.ClientHttp = ClientHttp;


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(740);
	var StorageHolder_1 = __webpack_require__(848);
	var CookiesManager = (function () {
	    function CookiesManager() {
	    }
	    CookiesManager.isTokenExist = function () {
	        return utils_1.CookieUtils.check(CookiesManager.TOKEN_COOKIE);
	    };
	    CookiesManager.isTokenExpiresExist = function () {
	        return utils_1.CookieUtils.check(CookiesManager.TOKEN_EXPIRES);
	    };
	    CookiesManager.getToken = function () {
	        return utils_1.CookieUtils.get(CookiesManager.TOKEN_COOKIE);
	    };
	    CookiesManager.getTokenExpireMinutes = function () {
	        return JSON.parse(StorageHolder_1.StorageHolder.localStorage.getItem(CookiesManager.TOKEN_EXPIRES));
	    };
	    CookiesManager.setToken = function (token, expires) {
	        if (expires)
	            StorageHolder_1.StorageHolder.localStorage.setItem(CookiesManager.TOKEN_EXPIRES, JSON.stringify(expires));
	        var seconds = CookiesManager.getTokenExpireMinutes() * 60;
	        utils_1.CookieUtils.set(CookiesManager.TOKEN_COOKIE, token, CookiesManager.getTokenExpireDate(seconds));
	        utils_1.CookieUtils.set(CookiesManager.TOKEN_EXPIRES, JSON.stringify(expires), CookiesManager.getTokenExpireDate(20));
	    };
	    CookiesManager.updateTokenExpires = function () {
	        if (CookiesManager.isTokenExist()) {
	            var expires = JSON.stringify(CookiesManager.getTokenExpireMinutes());
	            utils_1.CookieUtils.set(CookiesManager.TOKEN_EXPIRES, expires, CookiesManager.getTokenExpireDate(20));
	        }
	    };
	    CookiesManager.clearToken = function () {
	        utils_1.CookieUtils.remove(CookiesManager.TOKEN_COOKIE);
	        utils_1.CookieUtils.remove(CookiesManager.TOKEN_EXPIRES);
	    };
	    CookiesManager.isDestinationURLExists = function () {
	        return utils_1.CookieUtils.check(CookiesManager.DESTINATION_URL_COOKIE);
	    };
	    CookiesManager.getDestinationURL = function () {
	        return utils_1.CookieUtils.get(CookiesManager.DESTINATION_URL_COOKIE);
	    };
	    CookiesManager.setDestinationURL = function (url) {
	        utils_1.CookieUtils.set(CookiesManager.DESTINATION_URL_COOKIE, url);
	    };
	    CookiesManager.getRefCode = function () {
	        return utils_1.CookieUtils.get(CookiesManager.NEXYIU_REF_CODE);
	    };
	    CookiesManager.setRefCode = function (refCode) {
	        utils_1.CookieUtils.set(CookiesManager.NEXYIU_REF_CODE, refCode);
	    };
	    CookiesManager.getManualCode = function () {
	        return utils_1.CookieUtils.get(CookiesManager.CUSTOMER_MANUAL_CODE);
	    };
	    CookiesManager.setManualCode = function (refCode) {
	        utils_1.CookieUtils.set(CookiesManager.CUSTOMER_MANUAL_CODE, refCode);
	    };
	    CookiesManager.clearManualCode = function () {
	        utils_1.CookieUtils.remove(CookiesManager.CUSTOMER_MANUAL_CODE);
	    };
	    CookiesManager.getConsentId = function () {
	        return utils_1.CookieUtils.get(CookiesManager.CONSENT_ID);
	    };
	    CookiesManager.setConsentId = function (consentId) {
	        utils_1.CookieUtils.set(CookiesManager.CONSENT_ID, consentId);
	    };
	    CookiesManager.getCallbackURL = function () {
	        return utils_1.CookieUtils.get(CookiesManager.CALL_BACK_URL);
	    };
	    CookiesManager.setCallbackURL = function (callbackURL) {
	        utils_1.CookieUtils.set(CookiesManager.CALL_BACK_URL, callbackURL);
	    };
	    CookiesManager.clearOpenBank = function () {
	        utils_1.CookieUtils.remove(CookiesManager.CONSENT_ID);
	        utils_1.CookieUtils.remove(CookiesManager.CALL_BACK_URL);
	    };
	    CookiesManager.clearDestinationURL = function () {
	        utils_1.CookieUtils.remove(CookiesManager.DESTINATION_URL_COOKIE);
	    };
	    CookiesManager.getExpressAllowed = function () {
	        return utils_1.CookieUtils.get(CookiesManager.PAYMENT_EXPRESS_ALLOWED);
	    };
	    CookiesManager.setExpressAllowed = function (allowed) {
	        utils_1.CookieUtils.set(CookiesManager.PAYMENT_EXPRESS_ALLOWED, allowed);
	    };
	    CookiesManager.getFeeValue = function () {
	        return utils_1.CookieUtils.get(CookiesManager.FEE_VALUE);
	    };
	    CookiesManager.setFeeValue = function (allowed) {
	        utils_1.CookieUtils.set(CookiesManager.FEE_VALUE, allowed);
	    };
	    CookiesManager.getTokenExpireDate = function (seconds) {
	        return new Date(new Date().getTime() + seconds * 1000);
	    };
	    CookiesManager.TOKEN_COOKIE = 'COToken';
	    CookiesManager.TOKEN_EXPIRES = 'COToken-expires';
	    CookiesManager.DESTINATION_URL_COOKIE = 'CODURL';
	    CookiesManager.NEXYIU_REF_CODE = 'refCode';
	    CookiesManager.PAYMENT_EXPRESS_ALLOWED = 'payment_express_allowed';
	    CookiesManager.FEE_VALUE = 'fee_value';
	    CookiesManager.CONSENT_ID = 'consentId';
	    CookiesManager.CALL_BACK_URL = 'callbackURL';
	    CookiesManager.CUSTOMER_MANUAL_CODE = 'manualCode';
	    return CookiesManager;
	}());
	exports.CookiesManager = CookiesManager;


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var rxjs_1 = __webpack_require__(304);
	var http_1 = __webpack_require__(836);
	var client_error_factory_1 = __webpack_require__(1420);
	var ClientXhrBackend = (function (_super) {
	    __extends(ClientXhrBackend, _super);
	    function ClientXhrBackend(browser, options, strategy) {
	        return _super.call(this, browser, options, strategy) || this;
	    }
	    ClientXhrBackend.prototype.createConnection = function (request) {
	        var connection = _super.prototype.createConnection.call(this, request);
	        connection.response = this.wrapObservable(connection.response);
	        return connection;
	    };
	    ClientXhrBackend.prototype.wrapObservable = function (response) {
	        return rxjs_1.Observable.create(function (observer) {
	            response.subscribe(function (value) {
	                observer.next(value);
	            }, function (error) {
	                observer.error(client_error_factory_1.getClientErrorResponse(error));
	            }, function () {
	                observer.complete();
	            });
	        });
	    };
	    return ClientXhrBackend;
	}(http_1.XHRBackend));
	exports.ClientXhrBackend = ClientXhrBackend;


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var client_error_type_1 = __webpack_require__(1421);
	var client_error_code_1 = __webpack_require__(1422);
	var client_error_response_1 = __webpack_require__(1423);
	function getClientErrorResponse(error) {
	    var clientErrorResponse = new client_error_response_1.ClientErrorResponse;
	    clientErrorResponse.status = error.status;
	    clientErrorResponse.type = client_error_type_1.getClientErrorTypeByStatus(error.status);
	    try {
	        var response = error.json();
	        clientErrorResponse.errorCode = client_error_code_1.getClientErrorCodeByServerCode(lodash_1.get(response, 'code'));
	        clientErrorResponse.errorMessage = lodash_1.get(response, 'message');
	        clientErrorResponse.errorArguments = lodash_1.get(response, 'messageArgs');
	    }
	    catch (e) {
	        clientErrorResponse.errorCode = client_error_code_1.ClientErrorCode.ERR001;
	        clientErrorResponse.errorMessage = "Unexpected system error!";
	        clientErrorResponse.errorArguments = {};
	    }
	    return clientErrorResponse;
	}
	exports.getClientErrorResponse = getClientErrorResponse;
	function getClientErrorResponseFromJson(error) {
	    var clientErrorResponse = new client_error_response_1.ClientErrorResponse;
	    clientErrorResponse.status = error.status;
	    clientErrorResponse.type = client_error_type_1.getClientErrorTypeByStatus(error.status);
	    try {
	        clientErrorResponse.errorCode = client_error_code_1.getClientErrorCodeByServerCode(lodash_1.get(error, 'code'));
	        clientErrorResponse.errorMessage = lodash_1.get(error, 'message');
	        clientErrorResponse.errorArguments = lodash_1.get(error, 'messageArgs');
	    }
	    catch (e) {
	        clientErrorResponse.errorCode = client_error_code_1.ClientErrorCode.ERR001;
	        clientErrorResponse.errorMessage = "Unexpected system error!";
	        clientErrorResponse.errorArguments = {};
	    }
	    return clientErrorResponse;
	}
	exports.getClientErrorResponseFromJson = getClientErrorResponseFromJson;


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(743);
	var ClientErrorType;
	(function (ClientErrorType) {
	    ClientErrorType[ClientErrorType["BAD_REQUEST"] = 400] = "BAD_REQUEST";
	    ClientErrorType[ClientErrorType["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
	    ClientErrorType[ClientErrorType["FORBIDDEN"] = 403] = "FORBIDDEN";
	    ClientErrorType[ClientErrorType["NOT_FOUND"] = 404] = "NOT_FOUND";
	    ClientErrorType[ClientErrorType["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
	    ClientErrorType[ClientErrorType["BAD_GATEWAY_ERROR"] = 502] = "BAD_GATEWAY_ERROR";
	    ClientErrorType[ClientErrorType["UNEXPECTED_SERVER_ERROR"] = 9999] = "UNEXPECTED_SERVER_ERROR";
	})(ClientErrorType = exports.ClientErrorType || (exports.ClientErrorType = {}));
	function getClientErrorTypeByStatus(status) {
	    var clientErrorType = ClientErrorType[ClientErrorType[status]];
	    return util_1.isNullOrUndefined(clientErrorType)
	        ? ClientErrorType.UNEXPECTED_SERVER_ERROR
	        : clientErrorType;
	}
	exports.getClientErrorTypeByStatus = getClientErrorTypeByStatus;


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(743);
	var ClientErrorCode;
	(function (ClientErrorCode) {
	    ClientErrorCode[ClientErrorCode["ERR001"] = 0] = "ERR001";
	    ClientErrorCode[ClientErrorCode["ERR004"] = 1] = "ERR004";
	    ClientErrorCode[ClientErrorCode["ERR005"] = 2] = "ERR005";
	    ClientErrorCode[ClientErrorCode["ERR010"] = 3] = "ERR010";
	    ClientErrorCode[ClientErrorCode["ERR012"] = 4] = "ERR012";
	    ClientErrorCode[ClientErrorCode["ERR025"] = 5] = "ERR025";
	    ClientErrorCode[ClientErrorCode["ERR028"] = 6] = "ERR028";
	    ClientErrorCode[ClientErrorCode["ERR044"] = 7] = "ERR044";
	    ClientErrorCode[ClientErrorCode["ERR045"] = 8] = "ERR045";
	    ClientErrorCode[ClientErrorCode["ERR070"] = 9] = "ERR070";
	    ClientErrorCode[ClientErrorCode["ERR074"] = 10] = "ERR074";
	    ClientErrorCode[ClientErrorCode["ERR080"] = 11] = "ERR080";
	    ClientErrorCode[ClientErrorCode["ERR084"] = 12] = "ERR084";
	    ClientErrorCode[ClientErrorCode["ERR089"] = 13] = "ERR089";
	    ClientErrorCode[ClientErrorCode["ERR104"] = 14] = "ERR104";
	    ClientErrorCode[ClientErrorCode["ERR105"] = 15] = "ERR105";
	    ClientErrorCode[ClientErrorCode["ERR114"] = 16] = "ERR114";
	    ClientErrorCode[ClientErrorCode["ERR115"] = 17] = "ERR115";
	    ClientErrorCode[ClientErrorCode["ERR121"] = 18] = "ERR121";
	    ClientErrorCode[ClientErrorCode["ERR124"] = 19] = "ERR124";
	    ClientErrorCode[ClientErrorCode["ERR314"] = 20] = "ERR314";
	    ClientErrorCode[ClientErrorCode["ERR315"] = 21] = "ERR315";
	    ClientErrorCode[ClientErrorCode["ERR316"] = 22] = "ERR316";
	    ClientErrorCode[ClientErrorCode["ERR317"] = 23] = "ERR317";
	    ClientErrorCode[ClientErrorCode["ERR319"] = 24] = "ERR319";
	    ClientErrorCode[ClientErrorCode["ERR321"] = 25] = "ERR321";
	    ClientErrorCode[ClientErrorCode["ERR323"] = 26] = "ERR323";
	    ClientErrorCode[ClientErrorCode["ERR353"] = 27] = "ERR353";
	    ClientErrorCode[ClientErrorCode["ERR354"] = 28] = "ERR354";
	    ClientErrorCode[ClientErrorCode["ERR364"] = 29] = "ERR364";
	    ClientErrorCode[ClientErrorCode["ERR372"] = 30] = "ERR372";
	    ClientErrorCode[ClientErrorCode["ERR375"] = 31] = "ERR375";
	    ClientErrorCode[ClientErrorCode["ERR376"] = 32] = "ERR376";
	    ClientErrorCode[ClientErrorCode["ERR378"] = 33] = "ERR378";
	    ClientErrorCode[ClientErrorCode["ERR379"] = 34] = "ERR379";
	    ClientErrorCode[ClientErrorCode["ERR382"] = 35] = "ERR382";
	    ClientErrorCode[ClientErrorCode["ERR103"] = 36] = "ERR103";
	})(ClientErrorCode = exports.ClientErrorCode || (exports.ClientErrorCode = {}));
	function getClientErrorCodeByServerCode(code) {
	    var clientErrorCode = ClientErrorCode[code];
	    return util_1.isNullOrUndefined(clientErrorCode)
	        ? ClientErrorCode.ERR001
	        : clientErrorCode;
	}
	exports.getClientErrorCodeByServerCode = getClientErrorCodeByServerCode;


/***/ }),
/* 1423 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ClientErrorResponse = (function () {
	    function ClientErrorResponse() {
	    }
	    Object.defineProperty(ClientErrorResponse.prototype, "emailws", {
	        get: function () {
	            return this._emailws;
	        },
	        set: function (value) {
	            this._emailws = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ClientErrorResponse.prototype, "type", {
	        get: function () {
	            return this._type;
	        },
	        set: function (value) {
	            this._type = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ClientErrorResponse.prototype, "status", {
	        get: function () {
	            return this._status;
	        },
	        set: function (value) {
	            this._status = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ClientErrorResponse.prototype, "errorCode", {
	        get: function () {
	            return this._errorCode;
	        },
	        set: function (value) {
	            this._errorCode = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ClientErrorResponse.prototype, "errorMessage", {
	        get: function () {
	            return this._errorMessage;
	        },
	        set: function (value) {
	            this._errorMessage = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ClientErrorResponse.prototype, "errorArguments", {
	        get: function () {
	            return this._errorArguments;
	        },
	        set: function (value) {
	            this._errorArguments = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return ClientErrorResponse;
	}());
	exports.ClientErrorResponse = ClientErrorResponse;


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var http_1 = __webpack_require__(836);
	var URLSearch = (function () {
	    function URLSearch($search) {
	        this.$search = $search;
	    }
	    URLSearch.builder = function () {
	        return new URLSearch(new http_1.URLSearchParams());
	    };
	    URLSearch.toSearch = function (data) {
	        var builder = URLSearch.builder();
	        if (!lodash_1.isUndefined(data)) {
	            for (var key in data) {
	                if (data.hasOwnProperty(key)) {
	                    builder.append(key, data[key]);
	                }
	            }
	        }
	        return builder.build();
	    };
	    URLSearch.prototype.append = function (name, value) {
	        this.$search.append(name, value);
	        return this;
	    };
	    URLSearch.prototype.build = function () {
	        return this.$search;
	    };
	    return URLSearch;
	}());
	exports.URLSearch = URLSearch;


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var PrivateAccountService = (function () {
	    function PrivateAccountService(_http) {
	        this._http = _http;
	    }
	    PrivateAccountService.prototype.createAccount = function (account, refCode, inviteToken) {
	        var params = new http_1.URLSearchParams();
	        params.set('ref', refCode);
	        params.set('inviteToken', inviteToken);
	        return this._http.post('/api/client/private/register', account, { params: params });
	    };
	    PrivateAccountService.prototype.createUser = function (user) {
	        return this._http.post('/api/client/admin/register', user);
	    };
	    PrivateAccountService.prototype.checkEmail = function (email) {
	        var headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        var params = new http_1.URLSearchParams();
	        var body = {
	            email: email
	        };
	        return this._http.post('/api/client/private/checkEmail', body, {
	            headers: headers,
	            params: params
	        });
	    };
	    PrivateAccountService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], PrivateAccountService);
	    return PrivateAccountService;
	}());
	exports.PrivateAccountService = PrivateAccountService;


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var platform_browser_1 = __webpack_require__(247);
	var entity_1 = __webpack_require__(1407);
	var RegistrationAnalyticService = (function () {
	    function RegistrationAnalyticService(regType, document) {
	        this.document = document;
	        this.isGtagLoaded = false;
	        this.isClarityLoaded = false;
	        this.GA4_ID = 'G-8MM8JB5DZ3';
	        this.AW_ID = 'AW-16733943673';
	        this.regType = regType;
	        this.initializeAnalytics();
	    }
	    RegistrationAnalyticService.prototype.setComponentSpecificGtagId = function (id) {
	        this.componentSpecificGtagId = id;
	    };
	    RegistrationAnalyticService.prototype.initializeAnalytics = function () {
	        this.loadGoogleAnalytics();
	        this.loadClarity();
	    };
	    RegistrationAnalyticService.prototype.loadGoogleAnalytics = function () {
	        var _this = this;
	        if (this.isGtagLoaded)
	            return;
	        // Cargar el script base de gtag.js
	        var script = this.document.createElement('script');
	        script.async = true;
	        // Usamos el ID de GA4 como ID principal para cargar gtag.js
	        script.src = "https://www.googletagmanager.com/gtag/js?id=" + this.GA4_ID;
	        var inlineScript = this.document.createElement('script');
	        inlineScript.textContent = "\n      window.dataLayer = window.dataLayer || [];\n      function gtag(){dataLayer.push(arguments);}\n      gtag('js', new Date());\n      \n      // Configurar GA4\n      gtag('config', '" + this.GA4_ID + "');\n      \n      // Configurar Google Ads\n      gtag('config', '" + this.AW_ID + "');\n\n      // Configurar el identificador espec\u00EDfico del componente si est\u00E1 definido\n      " + (this.componentSpecificGtagId ? "gtag('config', '" + this.componentSpecificGtagId + "');" : '') + "\n    ";
	        script.onload = function () {
	            _this.isGtagLoaded = true;
	            _this.document.head.appendChild(inlineScript);
	        };
	        this.document.head.appendChild(script);
	    };
	    RegistrationAnalyticService.prototype.loadClarity = function () {
	        var _this = this;
	        if (this.isClarityLoaded)
	            return;
	        var script = this.document.createElement('script');
	        script.textContent = "\n      (function(c,l,a,r,i,t,y){\n        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};\n        t=l.createElement(r);t.async=1;t.src=\"https://www.clarity.ms/tag/\"+i;\n        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);\n      })(window, document, \"clarity\", \"script\", \"n47qkve4nb\");\n    ";
	        script.onload = function () {
	            _this.isClarityLoaded = true;
	        };
	        this.document.head.appendChild(script);
	    };
	    RegistrationAnalyticService.prototype.stepCompleted = function (stepId) {
	        var eventCategory;
	        switch (this.regType) {
	            case entity_1.RegistrationType.PRIVATE:
	                eventCategory = 'Registration Private';
	                break;
	            case entity_1.RegistrationType.CORPORATE:
	                eventCategory = 'Registration Corporate';
	                break;
	        }
	        var eventObj = {
	            event_category: eventCategory,
	            event_action: 'click',
	            event_label: "Completed Step " + ++stepId
	        };
	        this.trackEvent('step_completed', eventObj);
	    };
	    RegistrationAnalyticService.prototype.trackEvent = function (eventName, eventParams) {
	        if (this.isGtagLoaded) {
	            var w = window;
	            // Enviar evento a GA4
	            w.gtag('event', eventName, __assign({}, eventParams, { send_to: this.GA4_ID }));
	            // Enviar evento a Google Ads si es necesario
	            w.gtag('event', eventName, __assign({}, eventParams, { send_to: this.AW_ID }));
	        }
	        if (this.isClarityLoaded) {
	            var w = window;
	            if (w.clarity) {
	                w.clarity('event', eventName, eventParams);
	            }
	        }
	    };
	    RegistrationAnalyticService.prototype.pageView = function (path) {
	        if (this.isGtagLoaded) {
	            var w = window;
	            // Registrar pageview en GA4
	            w.gtag('config', this.GA4_ID, { page_path: path });
	            // Registrar pageview en Google Ads
	            w.gtag('config', this.AW_ID, { page_path: path });
	        }
	    };
	    // Método específico para conversiones de Google Ads
	    RegistrationAnalyticService.prototype.trackConversion = function (conversionLabel, value) {
	        if (this.isGtagLoaded) {
	            var w = window;
	            var eventParams = {
	                send_to: this.AW_ID + "/" + conversionLabel
	            };
	            if (value !== undefined) {
	                eventParams.value = value;
	                eventParams.currency = 'EUR'; // O la moneda que corresponda
	            }
	            w.gtag('event', 'conversion', eventParams);
	            // Agregar la conversión específica solicitada
	            if (conversionLabel === 'P__7CJCZvqcaEPnurqs-') {
	                w.gtag('event', 'conversion', {
	                    send_to: this.AW_ID + "/P__7CJCZvqcaEPnurqs-"
	                });
	            }
	        }
	    };
	    RegistrationAnalyticService = __decorate([
	        core_1.Injectable(),
	        __param(1, core_1.Inject(platform_browser_1.DOCUMENT)),
	        __metadata("design:paramtypes", [Number, Object])
	    ], RegistrationAnalyticService);
	    return RegistrationAnalyticService;
	}());
	exports.RegistrationAnalyticService = RegistrationAnalyticService;


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var NeocheckService = (function () {
	    function NeocheckService(_http) {
	        this._http = _http;
	    }
	    NeocheckService.prototype.getUrlPlugin = function (lang) {
	        return this._http.get('/api/client/private/getPluginUrl?language=' + lang).map(function (response) { return response.json(); });
	    };
	    NeocheckService.prototype.getResult = function (neocheckToken) {
	        return this._http.get('/api/client/private/getResult/?token=' + neocheckToken).map(function (response) { return response.text(); });
	    };
	    NeocheckService.prototype.checkAddress = function (obj, attachments) {
	        var body = {
	            streetName: obj.address,
	            city: obj.city,
	            country: obj.country,
	            state: obj.countyOrRegion,
	            postalCode: obj.zipCode,
	            documentImagesBase64: attachments
	        };
	        return this._http.post('api/client/private/check_address', body);
	    };
	    NeocheckService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], NeocheckService);
	    return NeocheckService;
	}());
	exports.NeocheckService = NeocheckService;


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, process) {/*!
	 * https://github.com/paulmillr/es6-shim
	 * @license es6-shim Copyright 2013-2016 by Paul Miller (http://paulmillr.com)
	 *   and contributors,  MIT License
	 * es6-shim: v0.35.4
	 * see https://github.com/paulmillr/es6-shim/blob/0.35.3/LICENSE
	 * Details and documentation:
	 * https://github.com/paulmillr/es6-shim/
	 */
	
	// UMD (Universal Module Definition)
	// see https://github.com/umdjs/umd/blob/master/returnExports.js
	(function (root, factory) {
	  /*global define */
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.returnExports = factory();
	  }
	}(this, function () {
	  'use strict';
	
	  var _apply = Function.call.bind(Function.apply);
	  var _call = Function.call.bind(Function.call);
	  var isArray = Array.isArray;
	  var keys = Object.keys;
	
	  var not = function notThunker(func) {
	    return function notThunk() {
	      return !_apply(func, this, arguments);
	    };
	  };
	  var throwsError = function (func) {
	    try {
	      func();
	      return false;
	    } catch (e) {
	      return true;
	    }
	  };
	  var valueOrFalseIfThrows = function valueOrFalseIfThrows(func) {
	    try {
	      return func();
	    } catch (e) {
	      return false;
	    }
	  };
	
	  var isCallableWithoutNew = not(throwsError);
	  var arePropertyDescriptorsSupported = function () {
	    // if Object.defineProperty exists but throws, it's IE 8
	    return !throwsError(function () {
	      return Object.defineProperty({}, 'x', { get: function () { } }); // eslint-disable-line getter-return
	    });
	  };
	  var supportsDescriptors = !!Object.defineProperty && arePropertyDescriptorsSupported();
	  var functionsHaveNames = (function foo() {}).name === 'foo'; // eslint-disable-line no-extra-parens
	
	  var _forEach = Function.call.bind(Array.prototype.forEach);
	  var _reduce = Function.call.bind(Array.prototype.reduce);
	  var _filter = Function.call.bind(Array.prototype.filter);
	  var _some = Function.call.bind(Array.prototype.some);
	
	  var defineProperty = function (object, name, value, force) {
	    if (!force && name in object) { return; }
	    if (supportsDescriptors) {
	      Object.defineProperty(object, name, {
	        configurable: true,
	        enumerable: false,
	        writable: true,
	        value: value
	      });
	    } else {
	      object[name] = value;
	    }
	  };
	
	  // Define configurable, writable and non-enumerable props
	  // if they don’t exist.
	  var defineProperties = function (object, map, forceOverride) {
	    _forEach(keys(map), function (name) {
	      var method = map[name];
	      defineProperty(object, name, method, !!forceOverride);
	    });
	  };
	
	  var _toString = Function.call.bind(Object.prototype.toString);
	  var isCallable =  false ? function IsCallableSlow(x) {
	    // Some old browsers (IE, FF) say that typeof /abc/ === 'function'
	    return typeof x === 'function' && _toString(x) === '[object Function]';
	  } : function IsCallableFast(x) { return typeof x === 'function'; };
	
	  var Value = {
	    getter: function (object, name, getter) {
	      if (!supportsDescriptors) {
	        throw new TypeError('getters require true ES5 support');
	      }
	      Object.defineProperty(object, name, {
	        configurable: true,
	        enumerable: false,
	        get: getter
	      });
	    },
	    proxy: function (originalObject, key, targetObject) {
	      if (!supportsDescriptors) {
	        throw new TypeError('getters require true ES5 support');
	      }
	      var originalDescriptor = Object.getOwnPropertyDescriptor(originalObject, key);
	      Object.defineProperty(targetObject, key, {
	        configurable: originalDescriptor.configurable,
	        enumerable: originalDescriptor.enumerable,
	        get: function getKey() { return originalObject[key]; },
	        set: function setKey(value) { originalObject[key] = value; }
	      });
	    },
	    redefine: function (object, property, newValue) {
	      if (supportsDescriptors) {
	        var descriptor = Object.getOwnPropertyDescriptor(object, property);
	        descriptor.value = newValue;
	        Object.defineProperty(object, property, descriptor);
	      } else {
	        object[property] = newValue;
	      }
	    },
	    defineByDescriptor: function (object, property, descriptor) {
	      if (supportsDescriptors) {
	        Object.defineProperty(object, property, descriptor);
	      } else if ('value' in descriptor) {
	        object[property] = descriptor.value;
	      }
	    },
	    preserveToString: function (target, source) {
	      if (source && isCallable(source.toString)) {
	        defineProperty(target, 'toString', source.toString.bind(source), true);
	      }
	    }
	  };
	
	  // Simple shim for Object.create on ES3 browsers
	  // (unlike real shim, no attempt to support `prototype === null`)
	  var create = Object.create || function (prototype, properties) {
	    var Prototype = function Prototype() {};
	    Prototype.prototype = prototype;
	    var object = new Prototype();
	    if (typeof properties !== 'undefined') {
	      keys(properties).forEach(function (key) {
	        Value.defineByDescriptor(object, key, properties[key]);
	      });
	    }
	    return object;
	  };
	
	  var supportsSubclassing = function (C, f) {
	    if (!Object.setPrototypeOf) { return false; /* skip test on IE < 11 */ }
	    return valueOrFalseIfThrows(function () {
	      var Sub = function Subclass(arg) {
	        var o = new C(arg);
	        Object.setPrototypeOf(o, Subclass.prototype);
	        return o;
	      };
	      Object.setPrototypeOf(Sub, C);
	      Sub.prototype = create(C.prototype, {
	        constructor: { value: Sub }
	      });
	      return f(Sub);
	    });
	  };
	
	  var getGlobal = function () {
	    /* global self, window */
	    // the only reliable means to get the global object is
	    // `Function('return this')()`
	    // However, this causes CSP violations in Chrome apps.
	    if (typeof self !== 'undefined') { return self; }
	    if (typeof window !== 'undefined') { return window; }
	    if (typeof global !== 'undefined') { return global; }
	    throw new Error('unable to locate global object');
	  };
	
	  var globals = getGlobal();
	  var globalIsFinite = globals.isFinite;
	  var _indexOf = Function.call.bind(String.prototype.indexOf);
	  var _arrayIndexOfApply = Function.apply.bind(Array.prototype.indexOf);
	  var _concat = Function.call.bind(Array.prototype.concat);
	  // var _sort = Function.call.bind(Array.prototype.sort);
	  var _strSlice = Function.call.bind(String.prototype.slice);
	  var _push = Function.call.bind(Array.prototype.push);
	  var _pushApply = Function.apply.bind(Array.prototype.push);
	  var _join = Function.call.bind(Array.prototype.join);
	  var _shift = Function.call.bind(Array.prototype.shift);
	  var _max = Math.max;
	  var _min = Math.min;
	  var _floor = Math.floor;
	  var _abs = Math.abs;
	  var _exp = Math.exp;
	  var _log = Math.log;
	  var _sqrt = Math.sqrt;
	  var _hasOwnProperty = Function.call.bind(Object.prototype.hasOwnProperty);
	  var ArrayIterator; // make our implementation private
	  var noop = function () {};
	
	  var OrigMap = globals.Map;
	  var origMapDelete = OrigMap && OrigMap.prototype['delete'];
	  var origMapGet = OrigMap && OrigMap.prototype.get;
	  var origMapHas = OrigMap && OrigMap.prototype.has;
	  var origMapSet = OrigMap && OrigMap.prototype.set;
	
	  var Symbol = globals.Symbol || {};
	  var symbolSpecies = Symbol.species || '@@species';
	
	  var numberIsNaN = Number.isNaN || function isNaN(value) {
	    // NaN !== NaN, but they are identical.
	    // NaNs are the only non-reflexive value, i.e., if x !== x,
	    // then x is NaN.
	    // isNaN is broken: it converts its argument to number, so
	    // isNaN('foo') => true
	    return value !== value;
	  };
	  var numberIsFinite = Number.isFinite || function isFinite(value) {
	    return typeof value === 'number' && globalIsFinite(value);
	  };
	  var _sign = isCallable(Math.sign) ? Math.sign : function sign(value) {
	    var number = Number(value);
	    if (number === 0) { return number; }
	    if (numberIsNaN(number)) { return number; }
	    return number < 0 ? -1 : 1;
	  };
	  var _log1p = function log1p(value) {
	    var x = Number(value);
	    if (x < -1 || numberIsNaN(x)) { return NaN; }
	    if (x === 0 || x === Infinity) { return x; }
	    if (x === -1) { return -Infinity; }
	
	    return (1 + x) - 1 === 0 ? x : x * (_log(1 + x) / ((1 + x) - 1));
	  };
	
	  // taken directly from https://github.com/ljharb/is-arguments/blob/master/index.js
	  // can be replaced with require('is-arguments') if we ever use a build process instead
	  var isStandardArguments = function isArguments(value) {
	    return _toString(value) === '[object Arguments]';
	  };
	  var isLegacyArguments = function isArguments(value) {
	    return value !== null &&
	      typeof value === 'object' &&
	      typeof value.length === 'number' &&
	      value.length >= 0 &&
	      _toString(value) !== '[object Array]' &&
	      _toString(value.callee) === '[object Function]';
	  };
	  var isArguments = isStandardArguments(arguments) ? isStandardArguments : isLegacyArguments;
	
	  var Type = {
	    primitive: function (x) { return x === null || (typeof x !== 'function' && typeof x !== 'object'); },
	    string: function (x) { return _toString(x) === '[object String]'; },
	    regex: function (x) { return _toString(x) === '[object RegExp]'; },
	    symbol: function (x) {
	      return typeof globals.Symbol === 'function' && typeof x === 'symbol';
	    }
	  };
	
	  var overrideNative = function overrideNative(object, property, replacement) {
	    var original = object[property];
	    defineProperty(object, property, replacement, true);
	    Value.preserveToString(object[property], original);
	  };
	
	  // eslint-disable-next-line no-restricted-properties
	  var hasSymbols = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' && Type.symbol(Symbol());
	
	  // This is a private name in the es6 spec, equal to '[Symbol.iterator]'
	  // we're going to use an arbitrary _-prefixed name to make our shims
	  // work properly with each other, even though we don't have full Iterator
	  // support.  That is, `Array.from(map.keys())` will work, but we don't
	  // pretend to export a "real" Iterator interface.
	  var $iterator$ = Type.symbol(Symbol.iterator) ? Symbol.iterator : '_es6-shim iterator_';
	  // Firefox ships a partial implementation using the name @@iterator.
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=907077#c14
	  // So use that name if we detect it.
	  if (globals.Set && typeof new globals.Set()['@@iterator'] === 'function') {
	    $iterator$ = '@@iterator';
	  }
	
	  // Reflect
	  if (!globals.Reflect) {
	    defineProperty(globals, 'Reflect', {}, true);
	  }
	  var Reflect = globals.Reflect;
	
	  var $String = String;
	
	  /* global document */
	  var domAll = (typeof document === 'undefined' || !document) ? null : document.all;
	  var isNullOrUndefined = domAll == null ? function isNullOrUndefined(x) {
	    return x == null;
	  } : function isNullOrUndefinedAndNotDocumentAll(x) {
	    return x == null && x !== domAll;
	  };
	
	  var ES = {
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-call
	    Call: function Call(F, V) {
	      var args = arguments.length > 2 ? arguments[2] : [];
	      if (!ES.IsCallable(F)) {
	        throw new TypeError(F + ' is not a function');
	      }
	      return _apply(F, V, args);
	    },
	
	    RequireObjectCoercible: function (x, optMessage) {
	      if (isNullOrUndefined(x)) {
	        throw new TypeError(optMessage || 'Cannot call method on ' + x);
	      }
	      return x;
	    },
	
	    // This might miss the "(non-standard exotic and does not implement
	    // [[Call]])" case from
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-typeof-operator-runtime-semantics-evaluation
	    // but we can't find any evidence these objects exist in practice.
	    // If we find some in the future, you could test `Object(x) === x`,
	    // which is reliable according to
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toobject
	    // but is not well optimized by runtimes and creates an object
	    // whenever it returns false, and thus is very slow.
	    TypeIsObject: function (x) {
	      if (x === void 0 || x === null || x === true || x === false) {
	        return false;
	      }
	      return typeof x === 'function' || typeof x === 'object' || x === domAll;
	    },
	
	    ToObject: function (o, optMessage) {
	      return Object(ES.RequireObjectCoercible(o, optMessage));
	    },
	
	    IsCallable: isCallable,
	
	    IsConstructor: function (x) {
	      // We can't tell callables from constructors in ES5
	      return ES.IsCallable(x);
	    },
	
	    ToInt32: function (x) {
	      return ES.ToNumber(x) >> 0;
	    },
	
	    ToUint32: function (x) {
	      return ES.ToNumber(x) >>> 0;
	    },
	
	    ToNumber: function (value) {
	      if (hasSymbols && _toString(value) === '[object Symbol]') {
	        throw new TypeError('Cannot convert a Symbol value to a number');
	      }
	      return +value;
	    },
	
	    ToInteger: function (value) {
	      var number = ES.ToNumber(value);
	      if (numberIsNaN(number)) { return 0; }
	      if (number === 0 || !numberIsFinite(number)) { return number; }
	      return (number > 0 ? 1 : -1) * _floor(_abs(number));
	    },
	
	    ToLength: function (value) {
	      var len = ES.ToInteger(value);
	      if (len <= 0) { return 0; } // includes converting -0 to +0
	      if (len > Number.MAX_SAFE_INTEGER) { return Number.MAX_SAFE_INTEGER; }
	      return len;
	    },
	
	    SameValue: function (a, b) {
	      if (a === b) {
	        // 0 === -0, but they are not identical.
	        if (a === 0) { return 1 / a === 1 / b; }
	        return true;
	      }
	      return numberIsNaN(a) && numberIsNaN(b);
	    },
	
	    SameValueZero: function (a, b) {
	      // same as SameValue except for SameValueZero(+0, -0) == true
	      return (a === b) || (numberIsNaN(a) && numberIsNaN(b));
	    },
	
	    IsIterable: function (o) {
	      return ES.TypeIsObject(o) && (typeof o[$iterator$] !== 'undefined' || isArguments(o));
	    },
	
	    GetIterator: function (o) {
	      if (isArguments(o)) {
	        // special case support for `arguments`
	        return new ArrayIterator(o, 'value');
	      }
	      var itFn = ES.GetMethod(o, $iterator$);
	      if (!ES.IsCallable(itFn)) {
	        // Better diagnostics if itFn is null or undefined
	        throw new TypeError('value is not an iterable');
	      }
	      var it = ES.Call(itFn, o);
	      if (!ES.TypeIsObject(it)) {
	        throw new TypeError('bad iterator');
	      }
	      return it;
	    },
	
	    GetMethod: function (o, p) {
	      var func = ES.ToObject(o)[p];
	      if (isNullOrUndefined(func)) {
	        return void 0;
	      }
	      if (!ES.IsCallable(func)) {
	        throw new TypeError('Method not callable: ' + p);
	      }
	      return func;
	    },
	
	    IteratorComplete: function (iterResult) {
	      return !!iterResult.done;
	    },
	
	    IteratorClose: function (iterator, completionIsThrow) {
	      var returnMethod = ES.GetMethod(iterator, 'return');
	      if (returnMethod === void 0) {
	        return;
	      }
	      var innerResult, innerException;
	      try {
	        innerResult = ES.Call(returnMethod, iterator);
	      } catch (e) {
	        innerException = e;
	      }
	      if (completionIsThrow) {
	        return;
	      }
	      if (innerException) {
	        throw innerException;
	      }
	      if (!ES.TypeIsObject(innerResult)) {
	        throw new TypeError("Iterator's return method returned a non-object.");
	      }
	    },
	
	    IteratorNext: function (it) {
	      var result = arguments.length > 1 ? it.next(arguments[1]) : it.next();
	      if (!ES.TypeIsObject(result)) {
	        throw new TypeError('bad iterator');
	      }
	      return result;
	    },
	
	    IteratorStep: function (it) {
	      var result = ES.IteratorNext(it);
	      var done = ES.IteratorComplete(result);
	      return done ? false : result;
	    },
	
	    Construct: function (C, args, newTarget, isES6internal) {
	      var target = typeof newTarget === 'undefined' ? C : newTarget;
	
	      if (!isES6internal && Reflect.construct) {
	        // Try to use Reflect.construct if available
	        return Reflect.construct(C, args, target);
	      }
	      // OK, we have to fake it.  This will only work if the
	      // C.[[ConstructorKind]] == "base" -- but that's the only
	      // kind we can make in ES5 code anyway.
	
	      // OrdinaryCreateFromConstructor(target, "%ObjectPrototype%")
	      var proto = target.prototype;
	      if (!ES.TypeIsObject(proto)) {
	        proto = Object.prototype;
	      }
	      var obj = create(proto);
	      // Call the constructor.
	      var result = ES.Call(C, obj, args);
	      return ES.TypeIsObject(result) ? result : obj;
	    },
	
	    SpeciesConstructor: function (O, defaultConstructor) {
	      var C = O.constructor;
	      if (C === void 0) {
	        return defaultConstructor;
	      }
	      if (!ES.TypeIsObject(C)) {
	        throw new TypeError('Bad constructor');
	      }
	      var S = C[symbolSpecies];
	      if (isNullOrUndefined(S)) {
	        return defaultConstructor;
	      }
	      if (!ES.IsConstructor(S)) {
	        throw new TypeError('Bad @@species');
	      }
	      return S;
	    },
	
	    CreateHTML: function (string, tag, attribute, value) {
	      var S = ES.ToString(string);
	      var p1 = '<' + tag;
	      if (attribute !== '') {
	        var V = ES.ToString(value);
	        var escapedV = V.replace(/"/g, '&quot;');
	        p1 += ' ' + attribute + '="' + escapedV + '"';
	      }
	      var p2 = p1 + '>';
	      var p3 = p2 + S;
	      return p3 + '</' + tag + '>';
	    },
	
	    IsRegExp: function IsRegExp(argument) {
	      if (!ES.TypeIsObject(argument)) {
	        return false;
	      }
	      var isRegExp = argument[Symbol.match];
	      if (typeof isRegExp !== 'undefined') {
	        return !!isRegExp;
	      }
	      return Type.regex(argument);
	    },
	
	    ToString: function ToString(string) {
	      if (hasSymbols && _toString(string) === '[object Symbol]') {
	        throw new TypeError('Cannot convert a Symbol value to a number');
	      }
	      return $String(string);
	    }
	  };
	
	  // Well-known Symbol shims
	  if (supportsDescriptors && hasSymbols) {
	    var defineWellKnownSymbol = function defineWellKnownSymbol(name) {
	      if (Type.symbol(Symbol[name])) {
	        return Symbol[name];
	      }
	      // eslint-disable-next-line no-restricted-properties
	      var sym = Symbol['for']('Symbol.' + name);
	      Object.defineProperty(Symbol, name, {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: sym
	      });
	      return sym;
	    };
	    if (!Type.symbol(Symbol.search)) {
	      var symbolSearch = defineWellKnownSymbol('search');
	      var originalSearch = String.prototype.search;
	      defineProperty(RegExp.prototype, symbolSearch, function search(string) {
	        return ES.Call(originalSearch, string, [this]);
	      });
	      var searchShim = function search(regexp) {
	        var O = ES.RequireObjectCoercible(this);
	        if (!isNullOrUndefined(regexp)) {
	          var searcher = ES.GetMethod(regexp, symbolSearch);
	          if (typeof searcher !== 'undefined') {
	            return ES.Call(searcher, regexp, [O]);
	          }
	        }
	        return ES.Call(originalSearch, O, [ES.ToString(regexp)]);
	      };
	      overrideNative(String.prototype, 'search', searchShim);
	    }
	    if (!Type.symbol(Symbol.replace)) {
	      var symbolReplace = defineWellKnownSymbol('replace');
	      var originalReplace = String.prototype.replace;
	      defineProperty(RegExp.prototype, symbolReplace, function replace(string, replaceValue) {
	        return ES.Call(originalReplace, string, [this, replaceValue]);
	      });
	      var replaceShim = function replace(searchValue, replaceValue) {
	        var O = ES.RequireObjectCoercible(this);
	        if (!isNullOrUndefined(searchValue)) {
	          var replacer = ES.GetMethod(searchValue, symbolReplace);
	          if (typeof replacer !== 'undefined') {
	            return ES.Call(replacer, searchValue, [O, replaceValue]);
	          }
	        }
	        return ES.Call(originalReplace, O, [ES.ToString(searchValue), replaceValue]);
	      };
	      overrideNative(String.prototype, 'replace', replaceShim);
	    }
	    if (!Type.symbol(Symbol.split)) {
	      var symbolSplit = defineWellKnownSymbol('split');
	      var originalSplit = String.prototype.split;
	      defineProperty(RegExp.prototype, symbolSplit, function split(string, limit) {
	        return ES.Call(originalSplit, string, [this, limit]);
	      });
	      var splitShim = function split(separator, limit) {
	        var O = ES.RequireObjectCoercible(this);
	        if (!isNullOrUndefined(separator)) {
	          var splitter = ES.GetMethod(separator, symbolSplit);
	          if (typeof splitter !== 'undefined') {
	            return ES.Call(splitter, separator, [O, limit]);
	          }
	        }
	        return ES.Call(originalSplit, O, [ES.ToString(separator), limit]);
	      };
	      overrideNative(String.prototype, 'split', splitShim);
	    }
	    var symbolMatchExists = Type.symbol(Symbol.match);
	    var stringMatchIgnoresSymbolMatch = symbolMatchExists && (function () {
	      // Firefox 41, through Nightly 45 has Symbol.match, but String#match ignores it.
	      // Firefox 40 and below have Symbol.match but String#match works fine.
	      var o = {};
	      o[Symbol.match] = function () { return 42; };
	      return 'a'.match(o) !== 42;
	    }());
	    if (!symbolMatchExists || stringMatchIgnoresSymbolMatch) {
	      var symbolMatch = defineWellKnownSymbol('match');
	
	      var originalMatch = String.prototype.match;
	      defineProperty(RegExp.prototype, symbolMatch, function match(string) {
	        return ES.Call(originalMatch, string, [this]);
	      });
	
	      var matchShim = function match(regexp) {
	        var O = ES.RequireObjectCoercible(this);
	        if (!isNullOrUndefined(regexp)) {
	          var matcher = ES.GetMethod(regexp, symbolMatch);
	          if (typeof matcher !== 'undefined') {
	            return ES.Call(matcher, regexp, [O]);
	          }
	        }
	        return ES.Call(originalMatch, O, [ES.ToString(regexp)]);
	      };
	      overrideNative(String.prototype, 'match', matchShim);
	    }
	  }
	
	  var wrapConstructor = function wrapConstructor(original, replacement, keysToSkip) {
	    Value.preserveToString(replacement, original);
	    if (Object.setPrototypeOf) {
	      // sets up proper prototype chain where possible
	      Object.setPrototypeOf(original, replacement);
	    }
	    if (supportsDescriptors) {
	      _forEach(Object.getOwnPropertyNames(original), function (key) {
	        if (key in noop || keysToSkip[key]) { return; }
	        Value.proxy(original, key, replacement);
	      });
	    } else {
	      _forEach(Object.keys(original), function (key) {
	        if (key in noop || keysToSkip[key]) { return; }
	        replacement[key] = original[key];
	      });
	    }
	    replacement.prototype = original.prototype;
	    Value.redefine(original.prototype, 'constructor', replacement);
	  };
	
	  var defaultSpeciesGetter = function () { return this; };
	  var addDefaultSpecies = function (C) {
	    if (supportsDescriptors && !_hasOwnProperty(C, symbolSpecies)) {
	      Value.getter(C, symbolSpecies, defaultSpeciesGetter);
	    }
	  };
	
	  var addIterator = function (prototype, impl) {
	    var implementation = impl || function iterator() { return this; };
	    defineProperty(prototype, $iterator$, implementation);
	    if (!prototype[$iterator$] && Type.symbol($iterator$)) {
	      // implementations are buggy when $iterator$ is a Symbol
	      prototype[$iterator$] = implementation;
	    }
	  };
	
	  var createDataProperty = function createDataProperty(object, name, value) {
	    if (supportsDescriptors) {
	      Object.defineProperty(object, name, {
	        configurable: true,
	        enumerable: true,
	        writable: true,
	        value: value
	      });
	    } else {
	      object[name] = value;
	    }
	  };
	  var createDataPropertyOrThrow = function createDataPropertyOrThrow(object, name, value) {
	    createDataProperty(object, name, value);
	    if (!ES.SameValue(object[name], value)) {
	      throw new TypeError('property is nonconfigurable');
	    }
	  };
	
	  var emulateES6construct = function (o, defaultNewTarget, defaultProto, slots) {
	    // This is an es5 approximation to es6 construct semantics.  in es6,
	    // 'new Foo' invokes Foo.[[Construct]] which (for almost all objects)
	    // just sets the internal variable NewTarget (in es6 syntax `new.target`)
	    // to Foo and then returns Foo().
	
	    // Many ES6 object then have constructors of the form:
	    // 1. If NewTarget is undefined, throw a TypeError exception
	    // 2. Let xxx by OrdinaryCreateFromConstructor(NewTarget, yyy, zzz)
	
	    // So we're going to emulate those first two steps.
	    if (!ES.TypeIsObject(o)) {
	      throw new TypeError('Constructor requires `new`: ' + defaultNewTarget.name);
	    }
	    var proto = defaultNewTarget.prototype;
	    if (!ES.TypeIsObject(proto)) {
	      proto = defaultProto;
	    }
	    var obj = create(proto);
	    for (var name in slots) {
	      if (_hasOwnProperty(slots, name)) {
	        var value = slots[name];
	        defineProperty(obj, name, value, true);
	      }
	    }
	    return obj;
	  };
	
	  // Firefox 31 reports this function's length as 0
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=1062484
	  if (String.fromCodePoint && String.fromCodePoint.length !== 1) {
	    var originalFromCodePoint = String.fromCodePoint;
	    overrideNative(String, 'fromCodePoint', function fromCodePoint(codePoints) {
	      return ES.Call(originalFromCodePoint, this, arguments);
	    });
	  }
	
	  var StringShims = {
	    fromCodePoint: function fromCodePoint(codePoints) {
	      var result = [];
	      var next;
	      for (var i = 0, length = arguments.length; i < length; i++) {
	        next = Number(arguments[i]);
	        if (!ES.SameValue(next, ES.ToInteger(next)) || next < 0 || next > 0x10FFFF) {
	          throw new RangeError('Invalid code point ' + next);
	        }
	
	        if (next < 0x10000) {
	          _push(result, String.fromCharCode(next));
	        } else {
	          next -= 0x10000;
	          _push(result, String.fromCharCode((next >> 10) + 0xD800));
	          _push(result, String.fromCharCode((next % 0x400) + 0xDC00));
	        }
	      }
	      return _join(result, '');
	    },
	
	    raw: function raw(template) {
	      var numberOfSubstitutions = arguments.length - 1;
	      var cooked = ES.ToObject(template, 'bad template');
	      var raw = ES.ToObject(cooked.raw, 'bad raw value');
	      var len = raw.length;
	      var literalSegments = ES.ToLength(len);
	      if (literalSegments <= 0) {
	        return '';
	      }
	
	      var stringElements = [];
	      var nextIndex = 0;
	      var nextKey, next, nextSeg, nextSub;
	      while (nextIndex < literalSegments) {
	        nextKey = ES.ToString(nextIndex);
	        nextSeg = ES.ToString(raw[nextKey]);
	        _push(stringElements, nextSeg);
	        if (nextIndex + 1 >= literalSegments) {
	          break;
	        }
	        next = nextIndex + 1 < arguments.length ? arguments[nextIndex + 1] : '';
	        nextSub = ES.ToString(next);
	        _push(stringElements, nextSub);
	        nextIndex += 1;
	      }
	      return _join(stringElements, '');
	    }
	  };
	  if (String.raw && String.raw({ raw: { 0: 'x', 1: 'y', length: 2 } }) !== 'xy') {
	    // IE 11 TP has a broken String.raw implementation
	    overrideNative(String, 'raw', StringShims.raw);
	  }
	  defineProperties(String, StringShims);
	
	  // Fast repeat, uses the `Exponentiation by squaring` algorithm.
	  // Perf: http://jsperf.com/string-repeat2/2
	  var stringRepeat = function repeat(s, times) {
	    if (times < 1) { return ''; }
	    if (times % 2) { return repeat(s, times - 1) + s; }
	    var half = repeat(s, times / 2);
	    return half + half;
	  };
	  var stringMaxLength = Infinity;
	
	  var StringPrototypeShims = {
	    repeat: function repeat(times) {
	      var thisStr = ES.ToString(ES.RequireObjectCoercible(this));
	      var numTimes = ES.ToInteger(times);
	      if (numTimes < 0 || numTimes >= stringMaxLength) {
	        throw new RangeError('repeat count must be less than infinity and not overflow maximum string size');
	      }
	      return stringRepeat(thisStr, numTimes);
	    },
	
	    startsWith: function startsWith(searchString) {
	      var S = ES.ToString(ES.RequireObjectCoercible(this));
	      if (ES.IsRegExp(searchString)) {
	        throw new TypeError('Cannot call method "startsWith" with a regex');
	      }
	      var searchStr = ES.ToString(searchString);
	      var position;
	      if (arguments.length > 1) {
	        position = arguments[1];
	      }
	      var start = _max(ES.ToInteger(position), 0);
	      return _strSlice(S, start, start + searchStr.length) === searchStr;
	    },
	
	    endsWith: function endsWith(searchString) {
	      var S = ES.ToString(ES.RequireObjectCoercible(this));
	      if (ES.IsRegExp(searchString)) {
	        throw new TypeError('Cannot call method "endsWith" with a regex');
	      }
	      var searchStr = ES.ToString(searchString);
	      var len = S.length;
	      var endPosition;
	      if (arguments.length > 1) {
	        endPosition = arguments[1];
	      }
	      var pos = typeof endPosition === 'undefined' ? len : ES.ToInteger(endPosition);
	      var end = _min(_max(pos, 0), len);
	      return _strSlice(S, end - searchStr.length, end) === searchStr;
	    },
	
	    includes: function includes(searchString) {
	      if (ES.IsRegExp(searchString)) {
	        throw new TypeError('"includes" does not accept a RegExp');
	      }
	      var searchStr = ES.ToString(searchString);
	      var position;
	      if (arguments.length > 1) {
	        position = arguments[1];
	      }
	      // Somehow this trick makes method 100% compat with the spec.
	      return _indexOf(this, searchStr, position) !== -1;
	    },
	
	    codePointAt: function codePointAt(pos) {
	      var thisStr = ES.ToString(ES.RequireObjectCoercible(this));
	      var position = ES.ToInteger(pos);
	      var length = thisStr.length;
	      if (position >= 0 && position < length) {
	        var first = thisStr.charCodeAt(position);
	        var isEnd = position + 1 === length;
	        if (first < 0xD800 || first > 0xDBFF || isEnd) { return first; }
	        var second = thisStr.charCodeAt(position + 1);
	        if (second < 0xDC00 || second > 0xDFFF) { return first; }
	        return ((first - 0xD800) * 1024) + (second - 0xDC00) + 0x10000;
	      }
	    }
	  };
	  if (String.prototype.includes && 'a'.includes('a', Infinity) !== false) {
	    overrideNative(String.prototype, 'includes', StringPrototypeShims.includes);
	  }
	
	  if (String.prototype.startsWith && String.prototype.endsWith) {
	    var startsWithRejectsRegex = throwsError(function () {
	      /* throws if spec-compliant */
	      return '/a/'.startsWith(/a/);
	    });
	    var startsWithHandlesInfinity = valueOrFalseIfThrows(function () {
	      return 'abc'.startsWith('a', Infinity) === false;
	    });
	    if (!startsWithRejectsRegex || !startsWithHandlesInfinity) {
	      // Firefox (< 37?) and IE 11 TP have a noncompliant startsWith implementation
	      overrideNative(String.prototype, 'startsWith', StringPrototypeShims.startsWith);
	      overrideNative(String.prototype, 'endsWith', StringPrototypeShims.endsWith);
	    }
	  }
	  if (hasSymbols) {
	    var startsWithSupportsSymbolMatch = valueOrFalseIfThrows(function () {
	      var re = /a/;
	      re[Symbol.match] = false;
	      return '/a/'.startsWith(re);
	    });
	    if (!startsWithSupportsSymbolMatch) {
	      overrideNative(String.prototype, 'startsWith', StringPrototypeShims.startsWith);
	    }
	    var endsWithSupportsSymbolMatch = valueOrFalseIfThrows(function () {
	      var re = /a/;
	      re[Symbol.match] = false;
	      return '/a/'.endsWith(re);
	    });
	    if (!endsWithSupportsSymbolMatch) {
	      overrideNative(String.prototype, 'endsWith', StringPrototypeShims.endsWith);
	    }
	    var includesSupportsSymbolMatch = valueOrFalseIfThrows(function () {
	      var re = /a/;
	      re[Symbol.match] = false;
	      return '/a/'.includes(re);
	    });
	    if (!includesSupportsSymbolMatch) {
	      overrideNative(String.prototype, 'includes', StringPrototypeShims.includes);
	    }
	  }
	
	  defineProperties(String.prototype, StringPrototypeShims);
	
	  // whitespace from: http://es5.github.io/#x15.5.4.20
	  // implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
	  var ws = [
	    '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	    '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	    '\u2029\uFEFF'
	  ].join('');
	  var trimRegexp = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
	  var trimShim = function trim() {
	    return ES.ToString(ES.RequireObjectCoercible(this)).replace(trimRegexp, '');
	  };
	  var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
	  var nonWSregex = new RegExp('[' + nonWS + ']', 'g');
	  var isBadHexRegex = /^[-+]0x[0-9a-f]+$/i;
	  var hasStringTrimBug = nonWS.trim().length !== nonWS.length;
	  defineProperty(String.prototype, 'trim', trimShim, hasStringTrimBug);
	
	  // Given an argument x, it will return an IteratorResult object,
	  // with value set to x and done to false.
	  // Given no arguments, it will return an iterator completion object.
	  var iteratorResult = function (x) {
	    return { value: x, done: arguments.length === 0 };
	  };
	
	  // see http://www.ecma-international.org/ecma-262/6.0/#sec-string.prototype-@@iterator
	  var StringIterator = function (s) {
	    ES.RequireObjectCoercible(s);
	    this._s = ES.ToString(s);
	    this._i = 0;
	  };
	  StringIterator.prototype.next = function () {
	    var s = this._s;
	    var i = this._i;
	    if (typeof s === 'undefined' || i >= s.length) {
	      this._s = void 0;
	      return iteratorResult();
	    }
	    var first = s.charCodeAt(i);
	    var second, len;
	    if (first < 0xD800 || first > 0xDBFF || (i + 1) === s.length) {
	      len = 1;
	    } else {
	      second = s.charCodeAt(i + 1);
	      len = (second < 0xDC00 || second > 0xDFFF) ? 1 : 2;
	    }
	    this._i = i + len;
	    return iteratorResult(s.substr(i, len));
	  };
	  addIterator(StringIterator.prototype);
	  addIterator(String.prototype, function () {
	    return new StringIterator(this);
	  });
	
	  var ArrayShims = {
	    from: function from(items) {
	      var C = this;
	      var mapFn;
	      if (arguments.length > 1) {
	        mapFn = arguments[1];
	      }
	      var mapping, T;
	      if (typeof mapFn === 'undefined') {
	        mapping = false;
	      } else {
	        if (!ES.IsCallable(mapFn)) {
	          throw new TypeError('Array.from: when provided, the second argument must be a function');
	        }
	        if (arguments.length > 2) {
	          T = arguments[2];
	        }
	        mapping = true;
	      }
	
	      // Note that that Arrays will use ArrayIterator:
	      // https://bugs.ecmascript.org/show_bug.cgi?id=2416
	      var usingIterator = typeof (isArguments(items) || ES.GetMethod(items, $iterator$)) !== 'undefined';
	
	      var length, result, i;
	      if (usingIterator) {
	        result = ES.IsConstructor(C) ? Object(new C()) : [];
	        var iterator = ES.GetIterator(items);
	        var next, nextValue;
	
	        i = 0;
	        while (true) {
	          next = ES.IteratorStep(iterator);
	          if (next === false) {
	            break;
	          }
	          nextValue = next.value;
	          try {
	            if (mapping) {
	              nextValue = typeof T === 'undefined' ? mapFn(nextValue, i) : _call(mapFn, T, nextValue, i);
	            }
	            result[i] = nextValue;
	          } catch (e) {
	            ES.IteratorClose(iterator, true);
	            throw e;
	          }
	          i += 1;
	        }
	        length = i;
	      } else {
	        var arrayLike = ES.ToObject(items);
	        length = ES.ToLength(arrayLike.length);
	        result = ES.IsConstructor(C) ? Object(new C(length)) : new Array(length);
	        var value;
	        for (i = 0; i < length; ++i) {
	          value = arrayLike[i];
	          if (mapping) {
	            value = typeof T === 'undefined' ? mapFn(value, i) : _call(mapFn, T, value, i);
	          }
	          createDataPropertyOrThrow(result, i, value);
	        }
	      }
	
	      result.length = length;
	      return result;
	    },
	
	    of: function of() {
	      var len = arguments.length;
	      var C = this;
	      var A = isArray(C) || !ES.IsCallable(C) ? new Array(len) : ES.Construct(C, [len]);
	      for (var k = 0; k < len; ++k) {
	        createDataPropertyOrThrow(A, k, arguments[k]);
	      }
	      A.length = len;
	      return A;
	    }
	  };
	  defineProperties(Array, ArrayShims);
	  addDefaultSpecies(Array);
	
	  // Our ArrayIterator is private; see
	  // https://github.com/paulmillr/es6-shim/issues/252
	  ArrayIterator = function (array, kind) {
	    this.i = 0;
	    this.array = array;
	    this.kind = kind;
	  };
	
	  defineProperties(ArrayIterator.prototype, {
	    next: function () {
	      var i = this.i;
	      var array = this.array;
	      if (!(this instanceof ArrayIterator)) {
	        throw new TypeError('Not an ArrayIterator');
	      }
	      if (typeof array !== 'undefined') {
	        var len = ES.ToLength(array.length);
	        if (i < len) {
	        //for (; i < len; i++) {
	          var kind = this.kind;
	          var retval;
	          if (kind === 'key') {
	            retval = i;
	          } else if (kind === 'value') {
	            retval = array[i];
	          } else if (kind === 'entry') {
	            retval = [i, array[i]];
	          }
	          this.i = i + 1;
	          return iteratorResult(retval);
	        }
	      }
	      this.array = void 0;
	      return iteratorResult();
	    }
	  });
	  addIterator(ArrayIterator.prototype);
	
	  /*
	  var orderKeys = function orderKeys(a, b) {
	    var aNumeric = String(ES.ToInteger(a)) === a;
	    var bNumeric = String(ES.ToInteger(b)) === b;
	    if (aNumeric && bNumeric) {
	      return b - a;
	    } else if (aNumeric && !bNumeric) {
	      return -1;
	    } else if (!aNumeric && bNumeric) {
	      return 1;
	    } else {
	      return a.localeCompare(b);
	    }
	  };
	
	  var getAllKeys = function getAllKeys(object) {
	    var ownKeys = [];
	    var keys = [];
	
	    for (var key in object) {
	      _push(_hasOwnProperty(object, key) ? ownKeys : keys, key);
	    }
	    _sort(ownKeys, orderKeys);
	    _sort(keys, orderKeys);
	
	    return _concat(ownKeys, keys);
	  };
	  */
	
	  // note: this is positioned here because it depends on ArrayIterator
	  var arrayOfSupportsSubclassing = Array.of === ArrayShims.of || (function () {
	    // Detects a bug in Webkit nightly r181886
	    var Foo = function Foo(len) { this.length = len; };
	    Foo.prototype = [];
	    var fooArr = Array.of.apply(Foo, [1, 2]);
	    return fooArr instanceof Foo && fooArr.length === 2;
	  }());
	  if (!arrayOfSupportsSubclassing) {
	    overrideNative(Array, 'of', ArrayShims.of);
	  }
	
	  var ArrayPrototypeShims = {
	    copyWithin: function copyWithin(target, start) {
	      var o = ES.ToObject(this);
	      var len = ES.ToLength(o.length);
	      var relativeTarget = ES.ToInteger(target);
	      var relativeStart = ES.ToInteger(start);
	      var to = relativeTarget < 0 ? _max(len + relativeTarget, 0) : _min(relativeTarget, len);
	      var from = relativeStart < 0 ? _max(len + relativeStart, 0) : _min(relativeStart, len);
	      var end;
	      if (arguments.length > 2) {
	        end = arguments[2];
	      }
	      var relativeEnd = typeof end === 'undefined' ? len : ES.ToInteger(end);
	      var finalItem = relativeEnd < 0 ? _max(len + relativeEnd, 0) : _min(relativeEnd, len);
	      var count = _min(finalItem - from, len - to);
	      var direction = 1;
	      if (from < to && to < (from + count)) {
	        direction = -1;
	        from += count - 1;
	        to += count - 1;
	      }
	      while (count > 0) {
	        if (from in o) {
	          o[to] = o[from];
	        } else {
	          delete o[to];
	        }
	        from += direction;
	        to += direction;
	        count -= 1;
	      }
	      return o;
	    },
	
	    fill: function fill(value) {
	      var start;
	      if (arguments.length > 1) {
	        start = arguments[1];
	      }
	      var end;
	      if (arguments.length > 2) {
	        end = arguments[2];
	      }
	      var O = ES.ToObject(this);
	      var len = ES.ToLength(O.length);
	      start = ES.ToInteger(typeof start === 'undefined' ? 0 : start);
	      end = ES.ToInteger(typeof end === 'undefined' ? len : end);
	
	      var relativeStart = start < 0 ? _max(len + start, 0) : _min(start, len);
	      var relativeEnd = end < 0 ? len + end : end;
	
	      for (var i = relativeStart; i < len && i < relativeEnd; ++i) {
	        O[i] = value;
	      }
	      return O;
	    },
	
	    find: function find(predicate) {
	      var list = ES.ToObject(this);
	      var length = ES.ToLength(list.length);
	      if (!ES.IsCallable(predicate)) {
	        throw new TypeError('Array#find: predicate must be a function');
	      }
	      var thisArg = arguments.length > 1 ? arguments[1] : null;
	      for (var i = 0, value; i < length; i++) {
	        value = list[i];
	        if (thisArg) {
	          if (_call(predicate, thisArg, value, i, list)) {
	            return value;
	          }
	        } else if (predicate(value, i, list)) {
	          return value;
	        }
	      }
	    },
	
	    findIndex: function findIndex(predicate) {
	      var list = ES.ToObject(this);
	      var length = ES.ToLength(list.length);
	      if (!ES.IsCallable(predicate)) {
	        throw new TypeError('Array#findIndex: predicate must be a function');
	      }
	      var thisArg = arguments.length > 1 ? arguments[1] : null;
	      for (var i = 0; i < length; i++) {
	        if (thisArg) {
	          if (_call(predicate, thisArg, list[i], i, list)) {
	            return i;
	          }
	        } else if (predicate(list[i], i, list)) {
	          return i;
	        }
	      }
	      return -1;
	    },
	
	    keys: function keys() {
	      return new ArrayIterator(this, 'key');
	    },
	
	    values: function values() {
	      return new ArrayIterator(this, 'value');
	    },
	
	    entries: function entries() {
	      return new ArrayIterator(this, 'entry');
	    }
	  };
	  // Safari 7.1 defines Array#keys and Array#entries natively,
	  // but the resulting ArrayIterator objects don't have a "next" method.
	  if (Array.prototype.keys && !ES.IsCallable([1].keys().next)) {
	    delete Array.prototype.keys;
	  }
	  if (Array.prototype.entries && !ES.IsCallable([1].entries().next)) {
	    delete Array.prototype.entries;
	  }
	
	  // Chrome 38 defines Array#keys and Array#entries, and Array#@@iterator, but not Array#values
	  if (Array.prototype.keys && Array.prototype.entries && !Array.prototype.values && Array.prototype[$iterator$]) {
	    defineProperties(Array.prototype, {
	      values: Array.prototype[$iterator$]
	    });
	    if (Type.symbol(Symbol.unscopables)) {
	      Array.prototype[Symbol.unscopables].values = true;
	    }
	  }
	  // Chrome 40 defines Array#values with the incorrect name, although Array#{keys,entries} have the correct name
	  if (functionsHaveNames && Array.prototype.values && Array.prototype.values.name !== 'values') {
	    var originalArrayPrototypeValues = Array.prototype.values;
	    overrideNative(Array.prototype, 'values', function values() { return ES.Call(originalArrayPrototypeValues, this, arguments); });
	    defineProperty(Array.prototype, $iterator$, Array.prototype.values, true);
	  }
	  defineProperties(Array.prototype, ArrayPrototypeShims);
	
	  if (1 / [true].indexOf(true, -0) < 0) {
	    // indexOf when given a position arg of -0 should return +0.
	    // https://github.com/tc39/ecma262/pull/316
	    defineProperty(Array.prototype, 'indexOf', function indexOf(searchElement) {
	      var value = _arrayIndexOfApply(this, arguments);
	      if (value === 0 && (1 / value) < 0) {
	        return 0;
	      }
	      return value;
	    }, true);
	  }
	
	  addIterator(Array.prototype, function () { return this.values(); });
	  // Chrome defines keys/values/entries on Array, but doesn't give us
	  // any way to identify its iterator.  So add our own shimmed field.
	  if (Object.getPrototypeOf) {
	    addIterator(Object.getPrototypeOf([].values()));
	  }
	
	  // note: this is positioned here because it relies on Array#entries
	  var arrayFromSwallowsNegativeLengths = (function () {
	    // Detects a Firefox bug in v32
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=1063993
	    return valueOrFalseIfThrows(function () {
	      return Array.from({ length: -1 }).length === 0;
	    });
	  }());
	  var arrayFromHandlesIterables = (function () {
	    // Detects a bug in Webkit nightly r181886
	    var arr = Array.from([0].entries());
	    return arr.length === 1 && isArray(arr[0]) && arr[0][0] === 0 && arr[0][1] === 0;
	  }());
	  if (!arrayFromSwallowsNegativeLengths || !arrayFromHandlesIterables) {
	    overrideNative(Array, 'from', ArrayShims.from);
	  }
	  var arrayFromHandlesUndefinedMapFunction = (function () {
	    // Microsoft Edge v0.11 throws if the mapFn argument is *provided* but undefined,
	    // but the spec doesn't care if it's provided or not - undefined doesn't throw.
	    return valueOrFalseIfThrows(function () {
	      return Array.from([0], void 0);
	    });
	  }());
	  if (!arrayFromHandlesUndefinedMapFunction) {
	    var origArrayFrom = Array.from;
	    overrideNative(Array, 'from', function from(items) {
	      if (arguments.length > 1 && typeof arguments[1] !== 'undefined') {
	        return ES.Call(origArrayFrom, this, arguments);
	      } else {
	        return _call(origArrayFrom, this, items);
	      }
	    });
	  }
	
	  var int32sAsOne = -(Math.pow(2, 32) - 1);
	  var toLengthsCorrectly = function (method, reversed) {
	    var obj = { length: int32sAsOne };
	    obj[reversed ? (obj.length >>> 0) - 1 : 0] = true;
	    return valueOrFalseIfThrows(function () {
	      _call(method, obj, function () {
	        // note: in nonconforming browsers, this will be called
	        // -1 >>> 0 times, which is 4294967295, so the throw matters.
	        throw new RangeError('should not reach here');
	      }, []);
	      return true;
	    });
	  };
	  if (!toLengthsCorrectly(Array.prototype.forEach)) {
	    var originalForEach = Array.prototype.forEach;
	    overrideNative(Array.prototype, 'forEach', function forEach(callbackFn) {
	      return ES.Call(originalForEach, this.length >= 0 ? this : [], arguments);
	    });
	  }
	  if (!toLengthsCorrectly(Array.prototype.map)) {
	    var originalMap = Array.prototype.map;
	    overrideNative(Array.prototype, 'map', function map(callbackFn) {
	      return ES.Call(originalMap, this.length >= 0 ? this : [], arguments);
	    });
	  }
	  if (!toLengthsCorrectly(Array.prototype.filter)) {
	    var originalFilter = Array.prototype.filter;
	    overrideNative(Array.prototype, 'filter', function filter(callbackFn) {
	      return ES.Call(originalFilter, this.length >= 0 ? this : [], arguments);
	    });
	  }
	  if (!toLengthsCorrectly(Array.prototype.some)) {
	    var originalSome = Array.prototype.some;
	    overrideNative(Array.prototype, 'some', function some(callbackFn) {
	      return ES.Call(originalSome, this.length >= 0 ? this : [], arguments);
	    });
	  }
	  if (!toLengthsCorrectly(Array.prototype.every)) {
	    var originalEvery = Array.prototype.every;
	    overrideNative(Array.prototype, 'every', function every(callbackFn) {
	      return ES.Call(originalEvery, this.length >= 0 ? this : [], arguments);
	    });
	  }
	  if (!toLengthsCorrectly(Array.prototype.reduce)) {
	    var originalReduce = Array.prototype.reduce;
	    overrideNative(Array.prototype, 'reduce', function reduce(callbackFn) {
	      return ES.Call(originalReduce, this.length >= 0 ? this : [], arguments);
	    });
	  }
	  if (!toLengthsCorrectly(Array.prototype.reduceRight, true)) {
	    var originalReduceRight = Array.prototype.reduceRight;
	    overrideNative(Array.prototype, 'reduceRight', function reduceRight(callbackFn) {
	      return ES.Call(originalReduceRight, this.length >= 0 ? this : [], arguments);
	    });
	  }
	
	  var lacksOctalSupport = Number('0o10') !== 8;
	  var lacksBinarySupport = Number('0b10') !== 2;
	  var trimsNonWhitespace = _some(nonWS, function (c) {
	    return Number(c + 0 + c) === 0;
	  });
	  if (lacksOctalSupport || lacksBinarySupport || trimsNonWhitespace) {
	    var OrigNumber = Number;
	    var binaryRegex = /^0b[01]+$/i;
	    var octalRegex = /^0o[0-7]+$/i;
	    // Note that in IE 8, RegExp.prototype.test doesn't seem to exist: ie, "test" is an own property of regexes. wtf.
	    var isBinary = binaryRegex.test.bind(binaryRegex);
	    var isOctal = octalRegex.test.bind(octalRegex);
	    var toPrimitive = function (O, hint) { // need to replace this with `es-to-primitive/es6`
	      var result;
	      if (typeof O.valueOf === 'function') {
	        result = O.valueOf();
	        if (Type.primitive(result)) {
	          return result;
	        }
	      }
	      if (typeof O.toString === 'function') {
	        result = O.toString();
	        if (Type.primitive(result)) {
	          return result;
	        }
	      }
	      throw new TypeError('No default value');
	    };
	    var hasNonWS = nonWSregex.test.bind(nonWSregex);
	    var isBadHex = isBadHexRegex.test.bind(isBadHexRegex);
	    var NumberShim = (function () {
	      // this is wrapped in an IIFE because of IE 6-8's wacky scoping issues with named function expressions.
	      var NumberShim = function Number(value) {
	        var primValue;
	        if (arguments.length > 0) {
	          primValue = Type.primitive(value) ? value : toPrimitive(value, 'number');
	        } else {
	          primValue = 0;
	        }
	        if (typeof primValue === 'string') {
	          primValue = ES.Call(trimShim, primValue);
	          if (isBinary(primValue)) {
	            primValue = parseInt(_strSlice(primValue, 2), 2);
	          } else if (isOctal(primValue)) {
	            primValue = parseInt(_strSlice(primValue, 2), 8);
	          } else if (hasNonWS(primValue) || isBadHex(primValue)) {
	            primValue = NaN;
	          }
	        }
	        var receiver = this;
	        var valueOfSucceeds = valueOrFalseIfThrows(function () {
	          OrigNumber.prototype.valueOf.call(receiver);
	          return true;
	        });
	        if (receiver instanceof NumberShim && !valueOfSucceeds) {
	          return new OrigNumber(primValue);
	        }
	        return OrigNumber(primValue);
	      };
	      return NumberShim;
	    }());
	    wrapConstructor(OrigNumber, NumberShim, {});
	    // this is necessary for ES3 browsers, where these properties are non-enumerable.
	    defineProperties(NumberShim, {
	      NaN: OrigNumber.NaN,
	      MAX_VALUE: OrigNumber.MAX_VALUE,
	      MIN_VALUE: OrigNumber.MIN_VALUE,
	      NEGATIVE_INFINITY: OrigNumber.NEGATIVE_INFINITY,
	      POSITIVE_INFINITY: OrigNumber.POSITIVE_INFINITY
	    });
	    /* eslint-disable no-undef, no-global-assign */
	    Number = NumberShim;
	    Value.redefine(globals, 'Number', NumberShim);
	    /* eslint-enable no-undef, no-global-assign */
	  }
	
	  var maxSafeInteger = Math.pow(2, 53) - 1;
	  defineProperties(Number, {
	    MAX_SAFE_INTEGER: maxSafeInteger,
	    MIN_SAFE_INTEGER: -maxSafeInteger,
	    EPSILON: 2.220446049250313e-16,
	
	    parseInt: globals.parseInt,
	    parseFloat: globals.parseFloat,
	
	    isFinite: numberIsFinite,
	
	    isInteger: function isInteger(value) {
	      return numberIsFinite(value) && ES.ToInteger(value) === value;
	    },
	
	    isSafeInteger: function isSafeInteger(value) {
	      return Number.isInteger(value) && _abs(value) <= Number.MAX_SAFE_INTEGER;
	    },
	
	    isNaN: numberIsNaN
	  });
	  // Firefox 37 has a conforming Number.parseInt, but it's not === to the global parseInt (fixed in v40)
	  defineProperty(Number, 'parseInt', globals.parseInt, Number.parseInt !== globals.parseInt);
	
	  // Work around bugs in Array#find and Array#findIndex -- early
	  // implementations skipped holes in sparse arrays. (Note that the
	  // implementations of find/findIndex indirectly use shimmed
	  // methods of Number, so this test has to happen down here.)
	  /* eslint-disable no-sparse-arrays */
	  if ([, 1].find(function () { return true; }) === 1) {
	    overrideNative(Array.prototype, 'find', ArrayPrototypeShims.find);
	  }
	  if ([, 1].findIndex(function () { return true; }) !== 0) {
	    overrideNative(Array.prototype, 'findIndex', ArrayPrototypeShims.findIndex);
	  }
	  /* eslint-enable no-sparse-arrays */
	
	  var isEnumerableOn = Function.bind.call(Function.bind, Object.prototype.propertyIsEnumerable);
	  var ensureEnumerable = function ensureEnumerable(obj, prop) {
	    if (supportsDescriptors && isEnumerableOn(obj, prop)) {
	      Object.defineProperty(obj, prop, { enumerable: false });
	    }
	  };
	  var sliceArgs = function sliceArgs() {
	    // per https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	    // and https://gist.github.com/WebReflection/4327762cb87a8c634a29
	    var initial = Number(this);
	    var len = arguments.length;
	    var desiredArgCount = len - initial;
	    var args = new Array(desiredArgCount < 0 ? 0 : desiredArgCount);
	    for (var i = initial; i < len; ++i) {
	      args[i - initial] = arguments[i];
	    }
	    return args;
	  };
	  var assignTo = function assignTo(source) {
	    return function assignToSource(target, key) {
	      target[key] = source[key];
	      return target;
	    };
	  };
	  var assignReducer = function (target, source) {
	    var sourceKeys = keys(Object(source));
	    var symbols;
	    if (ES.IsCallable(Object.getOwnPropertySymbols)) {
	      symbols = _filter(Object.getOwnPropertySymbols(Object(source)), isEnumerableOn(source));
	    }
	    return _reduce(_concat(sourceKeys, symbols || []), assignTo(source), target);
	  };
	
	  var ObjectShims = {
	    // 19.1.3.1
	    assign: function (target, source) {
	      var to = ES.ToObject(target, 'Cannot convert undefined or null to object');
	      return _reduce(ES.Call(sliceArgs, 1, arguments), assignReducer, to);
	    },
	
	    // Added in WebKit in https://bugs.webkit.org/show_bug.cgi?id=143865
	    is: function is(a, b) {
	      return ES.SameValue(a, b);
	    }
	  };
	  var assignHasPendingExceptions = Object.assign && Object.preventExtensions && (function () {
	    // Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	    // which is 72% slower than our shim, and Firefox 40's native implementation.
	    var thrower = Object.preventExtensions({ 1: 2 });
	    try {
	      Object.assign(thrower, 'xy');
	    } catch (e) {
	      return thrower[1] === 'y';
	    }
	  }());
	  if (assignHasPendingExceptions) {
	    overrideNative(Object, 'assign', ObjectShims.assign);
	  }
	  defineProperties(Object, ObjectShims);
	
	  if (supportsDescriptors) {
	    var ES5ObjectShims = {
	      // 19.1.3.9
	      // shim from https://gist.github.com/WebReflection/5593554
	      setPrototypeOf: (function (Object, magic) {
	        var set;
	
	        var checkArgs = function (O, proto) {
	          if (!ES.TypeIsObject(O)) {
	            throw new TypeError('cannot set prototype on a non-object');
	          }
	          if (!(proto === null || ES.TypeIsObject(proto))) {
	            throw new TypeError('can only set prototype to an object or null' + proto);
	          }
	        };
	
	        var setPrototypeOf = function (O, proto) {
	          checkArgs(O, proto);
	          _call(set, O, proto);
	          return O;
	        };
	
	        try {
	          // this works already in Firefox and Safari
	          set = Object.getOwnPropertyDescriptor(Object.prototype, magic).set;
	          _call(set, {}, null);
	        } catch (e) {
	          if (Object.prototype !== {}[magic]) {
	            // IE < 11 cannot be shimmed
	            return;
	          }
	          // probably Chrome or some old Mobile stock browser
	          set = function (proto) {
	            this[magic] = proto;
	          };
	          // please note that this will **not** work
	          // in those browsers that do not inherit
	          // __proto__ by mistake from Object.prototype
	          // in these cases we should probably throw an error
	          // or at least be informed about the issue
	          setPrototypeOf.polyfill = setPrototypeOf(
	            setPrototypeOf({}, null),
	            Object.prototype
	          ) instanceof Object;
	          // setPrototypeOf.polyfill === true means it works as meant
	          // setPrototypeOf.polyfill === false means it's not 100% reliable
	          // setPrototypeOf.polyfill === undefined
	          // or
	          // setPrototypeOf.polyfill ==  null means it's not a polyfill
	          // which means it works as expected
	          // we can even delete Object.prototype.__proto__;
	        }
	        return setPrototypeOf;
	      }(Object, '__proto__'))
	    };
	
	    defineProperties(Object, ES5ObjectShims);
	  }
	
	  // Workaround bug in Opera 12 where setPrototypeOf(x, null) doesn't work,
	  // but Object.create(null) does.
	  if (Object.setPrototypeOf && Object.getPrototypeOf &&
	      Object.getPrototypeOf(Object.setPrototypeOf({}, null)) !== null &&
	      Object.getPrototypeOf(Object.create(null)) === null) {
	    (function () {
	      var FAKENULL = Object.create(null);
	      var gpo = Object.getPrototypeOf;
	      var spo = Object.setPrototypeOf;
	      Object.getPrototypeOf = function (o) {
	        var result = gpo(o);
	        return result === FAKENULL ? null : result;
	      };
	      Object.setPrototypeOf = function (o, p) {
	        var proto = p === null ? FAKENULL : p;
	        return spo(o, proto);
	      };
	      Object.setPrototypeOf.polyfill = false;
	    }());
	  }
	
	  var objectKeysAcceptsPrimitives = !throwsError(function () { return Object.keys('foo'); });
	  if (!objectKeysAcceptsPrimitives) {
	    var originalObjectKeys = Object.keys;
	    overrideNative(Object, 'keys', function keys(value) {
	      return originalObjectKeys(ES.ToObject(value));
	    });
	    keys = Object.keys;
	  }
	  var objectKeysRejectsRegex = throwsError(function () { return Object.keys(/a/g); });
	  if (objectKeysRejectsRegex) {
	    var regexRejectingObjectKeys = Object.keys;
	    overrideNative(Object, 'keys', function keys(value) {
	      if (Type.regex(value)) {
	        var regexKeys = [];
	        for (var k in value) {
	          if (_hasOwnProperty(value, k)) {
	            _push(regexKeys, k);
	          }
	        }
	        return regexKeys;
	      }
	      return regexRejectingObjectKeys(value);
	    });
	    keys = Object.keys;
	  }
	
	  if (Object.getOwnPropertyNames) {
	    var objectGOPNAcceptsPrimitives = !throwsError(function () { return Object.getOwnPropertyNames('foo'); });
	    if (!objectGOPNAcceptsPrimitives) {
	      var cachedWindowNames = typeof window === 'object' ? Object.getOwnPropertyNames(window) : [];
	      var originalObjectGetOwnPropertyNames = Object.getOwnPropertyNames;
	      overrideNative(Object, 'getOwnPropertyNames', function getOwnPropertyNames(value) {
	        var val = ES.ToObject(value);
	        if (_toString(val) === '[object Window]') {
	          try {
	            return originalObjectGetOwnPropertyNames(val);
	          } catch (e) {
	            // IE bug where layout engine calls userland gOPN for cross-domain `window` objects
	            return _concat([], cachedWindowNames);
	          }
	        }
	        return originalObjectGetOwnPropertyNames(val);
	      });
	    }
	  }
	  if (Object.getOwnPropertyDescriptor) {
	    var objectGOPDAcceptsPrimitives = !throwsError(function () { return Object.getOwnPropertyDescriptor('foo', 'bar'); });
	    if (!objectGOPDAcceptsPrimitives) {
	      var originalObjectGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	      overrideNative(Object, 'getOwnPropertyDescriptor', function getOwnPropertyDescriptor(value, property) {
	        return originalObjectGetOwnPropertyDescriptor(ES.ToObject(value), property);
	      });
	    }
	  }
	  if (Object.seal) {
	    var objectSealAcceptsPrimitives = !throwsError(function () { return Object.seal('foo'); });
	    if (!objectSealAcceptsPrimitives) {
	      var originalObjectSeal = Object.seal;
	      overrideNative(Object, 'seal', function seal(value) {
	        if (!ES.TypeIsObject(value)) { return value; }
	        return originalObjectSeal(value);
	      });
	    }
	  }
	  if (Object.isSealed) {
	    var objectIsSealedAcceptsPrimitives = !throwsError(function () { return Object.isSealed('foo'); });
	    if (!objectIsSealedAcceptsPrimitives) {
	      var originalObjectIsSealed = Object.isSealed;
	      overrideNative(Object, 'isSealed', function isSealed(value) {
	        if (!ES.TypeIsObject(value)) { return true; }
	        return originalObjectIsSealed(value);
	      });
	    }
	  }
	  if (Object.freeze) {
	    var objectFreezeAcceptsPrimitives = !throwsError(function () { return Object.freeze('foo'); });
	    if (!objectFreezeAcceptsPrimitives) {
	      var originalObjectFreeze = Object.freeze;
	      overrideNative(Object, 'freeze', function freeze(value) {
	        if (!ES.TypeIsObject(value)) { return value; }
	        return originalObjectFreeze(value);
	      });
	    }
	  }
	  if (Object.isFrozen) {
	    var objectIsFrozenAcceptsPrimitives = !throwsError(function () { return Object.isFrozen('foo'); });
	    if (!objectIsFrozenAcceptsPrimitives) {
	      var originalObjectIsFrozen = Object.isFrozen;
	      overrideNative(Object, 'isFrozen', function isFrozen(value) {
	        if (!ES.TypeIsObject(value)) { return true; }
	        return originalObjectIsFrozen(value);
	      });
	    }
	  }
	  if (Object.preventExtensions) {
	    var objectPreventExtensionsAcceptsPrimitives = !throwsError(function () { return Object.preventExtensions('foo'); });
	    if (!objectPreventExtensionsAcceptsPrimitives) {
	      var originalObjectPreventExtensions = Object.preventExtensions;
	      overrideNative(Object, 'preventExtensions', function preventExtensions(value) {
	        if (!ES.TypeIsObject(value)) { return value; }
	        return originalObjectPreventExtensions(value);
	      });
	    }
	  }
	  if (Object.isExtensible) {
	    var objectIsExtensibleAcceptsPrimitives = !throwsError(function () { return Object.isExtensible('foo'); });
	    if (!objectIsExtensibleAcceptsPrimitives) {
	      var originalObjectIsExtensible = Object.isExtensible;
	      overrideNative(Object, 'isExtensible', function isExtensible(value) {
	        if (!ES.TypeIsObject(value)) { return false; }
	        return originalObjectIsExtensible(value);
	      });
	    }
	  }
	  if (Object.getPrototypeOf) {
	    var objectGetProtoAcceptsPrimitives = !throwsError(function () { return Object.getPrototypeOf('foo'); });
	    if (!objectGetProtoAcceptsPrimitives) {
	      var originalGetProto = Object.getPrototypeOf;
	      overrideNative(Object, 'getPrototypeOf', function getPrototypeOf(value) {
	        return originalGetProto(ES.ToObject(value));
	      });
	    }
	  }
	
	  var hasFlags = supportsDescriptors && (function () {
	    var desc = Object.getOwnPropertyDescriptor(RegExp.prototype, 'flags');
	    return desc && ES.IsCallable(desc.get);
	  }());
	  if (supportsDescriptors && !hasFlags) {
	    var regExpFlagsGetter = function flags() {
	      if (!ES.TypeIsObject(this)) {
	        throw new TypeError('Method called on incompatible type: must be an object.');
	      }
	      var result = '';
	      if (this.global) {
	        result += 'g';
	      }
	      if (this.ignoreCase) {
	        result += 'i';
	      }
	      if (this.multiline) {
	        result += 'm';
	      }
	      if (this.unicode) {
	        result += 'u';
	      }
	      if (this.sticky) {
	        result += 'y';
	      }
	      return result;
	    };
	
	    Value.getter(RegExp.prototype, 'flags', regExpFlagsGetter);
	  }
	
	  var regExpSupportsFlagsWithRegex = supportsDescriptors && valueOrFalseIfThrows(function () {
	    return String(new RegExp(/a/g, 'i')) === '/a/i';
	  });
	  var regExpNeedsToSupportSymbolMatch = hasSymbols && supportsDescriptors && (function () {
	    // Edge 0.12 supports flags fully, but does not support Symbol.match
	    var regex = /./;
	    regex[Symbol.match] = false;
	    return RegExp(regex) === regex;
	  }());
	
	  var regexToStringIsGeneric = valueOrFalseIfThrows(function () {
	    return RegExp.prototype.toString.call({ source: 'abc' }) === '/abc/';
	  });
	  var regexToStringSupportsGenericFlags = regexToStringIsGeneric && valueOrFalseIfThrows(function () {
	    return RegExp.prototype.toString.call({ source: 'a', flags: 'b' }) === '/a/b';
	  });
	  if (!regexToStringIsGeneric || !regexToStringSupportsGenericFlags) {
	    var origRegExpToString = RegExp.prototype.toString;
	    defineProperty(RegExp.prototype, 'toString', function toString() {
	      var R = ES.RequireObjectCoercible(this);
	      if (Type.regex(R)) {
	        return _call(origRegExpToString, R);
	      }
	      var pattern = $String(R.source);
	      var flags = $String(R.flags);
	      return '/' + pattern + '/' + flags;
	    }, true);
	    Value.preserveToString(RegExp.prototype.toString, origRegExpToString);
	  }
	
	  if (supportsDescriptors && (!regExpSupportsFlagsWithRegex || regExpNeedsToSupportSymbolMatch)) {
	    var flagsGetter = Object.getOwnPropertyDescriptor(RegExp.prototype, 'flags').get;
	    var sourceDesc = Object.getOwnPropertyDescriptor(RegExp.prototype, 'source') || {};
	    var legacySourceGetter = function () {
	      // prior to it being a getter, it's own + nonconfigurable
	      return this.source;
	    };
	    var sourceGetter = ES.IsCallable(sourceDesc.get) ? sourceDesc.get : legacySourceGetter;
	
	    var OrigRegExp = RegExp;
	    var RegExpShim = (function () {
	      return function RegExp(pattern, flags) {
	        var patternIsRegExp = ES.IsRegExp(pattern);
	        var calledWithNew = this instanceof RegExp;
	        if (!calledWithNew && patternIsRegExp && typeof flags === 'undefined' && pattern.constructor === RegExp) {
	          return pattern;
	        }
	
	        var P = pattern;
	        var F = flags;
	        if (Type.regex(pattern)) {
	          P = ES.Call(sourceGetter, pattern);
	          F = typeof flags === 'undefined' ? ES.Call(flagsGetter, pattern) : flags;
	          return new RegExp(P, F);
	        } else if (patternIsRegExp) {
	          P = pattern.source;
	          F = typeof flags === 'undefined' ? pattern.flags : flags;
	        }
	        return new OrigRegExp(pattern, flags);
	      };
	    }());
	    wrapConstructor(OrigRegExp, RegExpShim, {
	      $input: true // Chrome < v39 & Opera < 26 have a nonstandard "$input" property
	    });
	    /* eslint-disable no-undef, no-global-assign */
	    RegExp = RegExpShim;
	    Value.redefine(globals, 'RegExp', RegExpShim);
	    /* eslint-enable no-undef, no-global-assign */
	  }
	
	  if (supportsDescriptors) {
	    var regexGlobals = {
	      input: '$_',
	      lastMatch: '$&',
	      lastParen: '$+',
	      leftContext: '$`',
	      rightContext: '$\''
	    };
	    _forEach(keys(regexGlobals), function (prop) {
	      if (prop in RegExp && !(regexGlobals[prop] in RegExp)) {
	        Value.getter(RegExp, regexGlobals[prop], function get() {
	          return RegExp[prop];
	        });
	      }
	    });
	  }
	  addDefaultSpecies(RegExp);
	
	  var inverseEpsilon = 1 / Number.EPSILON;
	  var roundTiesToEven = function roundTiesToEven(n) {
	    // Even though this reduces down to `return n`, it takes advantage of built-in rounding.
	    return (n + inverseEpsilon) - inverseEpsilon;
	  };
	  var BINARY_32_EPSILON = Math.pow(2, -23);
	  var BINARY_32_MAX_VALUE = Math.pow(2, 127) * (2 - BINARY_32_EPSILON);
	  var BINARY_32_MIN_VALUE = Math.pow(2, -126);
	  var E = Math.E;
	  var LOG2E = Math.LOG2E;
	  var LOG10E = Math.LOG10E;
	  var numberCLZ = Number.prototype.clz;
	  delete Number.prototype.clz; // Safari 8 has Number#clz
	
	  var MathShims = {
	    acosh: function acosh(value) {
	      var x = Number(value);
	      if (numberIsNaN(x) || value < 1) { return NaN; }
	      if (x === 1) { return 0; }
	      if (x === Infinity) { return x; }
	
	      var xInvSquared = 1 / (x * x);
	      if (x < 2) {
	        return _log1p(x - 1 + (_sqrt(1 - xInvSquared) * x));
	      }
	      var halfX = x / 2;
	      return _log1p(halfX + (_sqrt(1 - xInvSquared) * halfX) - 1) + (1 / LOG2E);
	    },
	
	    asinh: function asinh(value) {
	      var x = Number(value);
	      if (x === 0 || !globalIsFinite(x)) {
	        return x;
	      }
	
	      var a = _abs(x);
	      var aSquared = a * a;
	      var s = _sign(x);
	      if (a < 1) {
	        return s * _log1p(a + (aSquared / (_sqrt(aSquared + 1) + 1)));
	      }
	      return s * (_log1p((a / 2) + (_sqrt(1 + (1 / aSquared)) * a / 2) - 1) + (1 / LOG2E));
	    },
	
	    atanh: function atanh(value) {
	      var x = Number(value);
	
	      if (x === 0) { return x; }
	      if (x === -1) { return -Infinity; }
	      if (x === 1) { return Infinity; }
	      if (numberIsNaN(x) || x < -1 || x > 1) {
	        return NaN;
	      }
	
	      var a = _abs(x);
	      return _sign(x) * _log1p(2 * a / (1 - a)) / 2;
	    },
	
	    cbrt: function cbrt(value) {
	      var x = Number(value);
	      if (x === 0) { return x; }
	      var negate = x < 0;
	      var result;
	      if (negate) { x = -x; }
	      if (x === Infinity) {
	        result = Infinity;
	      } else {
	        result = _exp(_log(x) / 3);
	        // from http://en.wikipedia.org/wiki/Cube_root#Numerical_methods
	        result = ((x / (result * result)) + (2 * result)) / 3;
	      }
	      return negate ? -result : result;
	    },
	
	    clz32: function clz32(value) {
	      // See https://bugs.ecmascript.org/show_bug.cgi?id=2465
	      var x = Number(value);
	      var number = ES.ToUint32(x);
	      if (number === 0) {
	        return 32;
	      }
	      return numberCLZ ? ES.Call(numberCLZ, number) : 31 - _floor(_log(number + 0.5) * LOG2E);
	    },
	
	    cosh: function cosh(value) {
	      var x = Number(value);
	      if (x === 0) { return 1; } // +0 or -0
	      if (numberIsNaN(x)) { return NaN; }
	      if (!globalIsFinite(x)) { return Infinity; }
	
	      var t = _exp(_abs(x) - 1);
	      return (t + (1 / (t * E * E))) * (E / 2);
	    },
	
	    expm1: function expm1(value) {
	      var x = Number(value);
	      if (x === -Infinity) { return -1; }
	      if (!globalIsFinite(x) || x === 0) { return x; }
	      if (_abs(x) > 0.5) {
	        return _exp(x) - 1;
	      }
	      // A more precise approximation using Taylor series expansion
	      // from https://github.com/paulmillr/es6-shim/issues/314#issuecomment-70293986
	      var t = x;
	      var sum = 0;
	      var n = 1;
	      while (sum + t !== sum) {
	        sum += t;
	        n += 1;
	        t *= x / n;
	      }
	      return sum;
	    },
	
	    hypot: function hypot(x, y) {
	      var result = 0;
	      var largest = 0;
	      for (var i = 0; i < arguments.length; ++i) {
	        var value = _abs(Number(arguments[i]));
	        if (largest < value) {
	          result *= (largest / value) * (largest / value);
	          result += 1;
	          largest = value;
	        } else {
	          result += value > 0 ? (value / largest) * (value / largest) : value;
	        }
	      }
	      return largest === Infinity ? Infinity : largest * _sqrt(result);
	    },
	
	    log2: function log2(value) {
	      return _log(value) * LOG2E;
	    },
	
	    log10: function log10(value) {
	      return _log(value) * LOG10E;
	    },
	
	    log1p: _log1p,
	
	    sign: _sign,
	
	    sinh: function sinh(value) {
	      var x = Number(value);
	      if (!globalIsFinite(x) || x === 0) { return x; }
	
	      var a = _abs(x);
	      if (a < 1) {
	        var u = Math.expm1(a);
	        return _sign(x) * u * (1 + (1 / (u + 1))) / 2;
	      }
	      var t = _exp(a - 1);
	      return _sign(x) * (t - (1 / (t * E * E))) * (E / 2);
	    },
	
	    tanh: function tanh(value) {
	      var x = Number(value);
	      if (numberIsNaN(x) || x === 0) { return x; }
	      // can exit early at +-20 as JS loses precision for true value at this integer
	      if (x >= 20) { return 1; }
	      if (x <= -20) { return -1; }
	
	      return (Math.expm1(x) - Math.expm1(-x)) / (_exp(x) + _exp(-x));
	    },
	
	    trunc: function trunc(value) {
	      var x = Number(value);
	      return x < 0 ? -_floor(-x) : _floor(x);
	    },
	
	    imul: function imul(x, y) {
	      // taken from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/imul
	      var a = ES.ToUint32(x);
	      var b = ES.ToUint32(y);
	      var ah = (a >>> 16) & 0xffff;
	      var al = a & 0xffff;
	      var bh = (b >>> 16) & 0xffff;
	      var bl = b & 0xffff;
	      // the shift by 0 fixes the sign on the high part
	      // the final |0 converts the unsigned value into a signed value
	      return (al * bl) + ((((ah * bl) + (al * bh)) << 16) >>> 0) | 0;
	    },
	
	    fround: function fround(x) {
	      var v = Number(x);
	      if (v === 0 || v === Infinity || v === -Infinity || numberIsNaN(v)) {
	        return v;
	      }
	      var sign = _sign(v);
	      var abs = _abs(v);
	      if (abs < BINARY_32_MIN_VALUE) {
	        return sign * roundTiesToEven(abs / BINARY_32_MIN_VALUE / BINARY_32_EPSILON) * BINARY_32_MIN_VALUE * BINARY_32_EPSILON;
	      }
	      // Veltkamp's splitting (?)
	      var a = (1 + (BINARY_32_EPSILON / Number.EPSILON)) * abs;
	      var result = a - (a - abs);
	      if (result > BINARY_32_MAX_VALUE || numberIsNaN(result)) {
	        return sign * Infinity;
	      }
	      return sign * result;
	    }
	  };
	
	  var withinULPDistance = function withinULPDistance(result, expected, distance) {
	    return _abs(1 - (result / expected)) / Number.EPSILON < (distance || 8);
	  };
	
	  defineProperties(Math, MathShims);
	  // Chrome < 40 sinh returns ∞ for large numbers
	  defineProperty(Math, 'sinh', MathShims.sinh, Math.sinh(710) === Infinity);
	  // Chrome < 40 cosh returns ∞ for large numbers
	  defineProperty(Math, 'cosh', MathShims.cosh, Math.cosh(710) === Infinity);
	  // IE 11 TP has an imprecise log1p: reports Math.log1p(-1e-17) as 0
	  defineProperty(Math, 'log1p', MathShims.log1p, Math.log1p(-1e-17) !== -1e-17);
	  // IE 11 TP has an imprecise asinh: reports Math.asinh(-1e7) as not exactly equal to -Math.asinh(1e7)
	  defineProperty(Math, 'asinh', MathShims.asinh, Math.asinh(-1e7) !== -Math.asinh(1e7));
	  // Chrome < 54 asinh returns ∞ for large numbers and should not
	  defineProperty(Math, 'asinh', MathShims.asinh, Math.asinh(1e+300) === Infinity);
	  // Chrome < 54 atanh incorrectly returns 0 for large numbers
	  defineProperty(Math, 'atanh', MathShims.atanh, Math.atanh(1e-300) === 0);
	  // Chrome 40 has an imprecise Math.tanh with very small numbers
	  defineProperty(Math, 'tanh', MathShims.tanh, Math.tanh(-2e-17) !== -2e-17);
	  // Chrome 40 loses Math.acosh precision with high numbers
	  defineProperty(Math, 'acosh', MathShims.acosh, Math.acosh(Number.MAX_VALUE) === Infinity);
	  // Chrome < 54 has an inaccurate acosh for EPSILON deltas
	  defineProperty(Math, 'acosh', MathShims.acosh, !withinULPDistance(Math.acosh(1 + Number.EPSILON), Math.sqrt(2 * Number.EPSILON)));
	  // Firefox 38 on Windows
	  defineProperty(Math, 'cbrt', MathShims.cbrt, !withinULPDistance(Math.cbrt(1e-300), 1e-100));
	  // node 0.11 has an imprecise Math.sinh with very small numbers
	  defineProperty(Math, 'sinh', MathShims.sinh, Math.sinh(-2e-17) !== -2e-17);
	  // FF 35 on Linux reports 22025.465794806725 for Math.expm1(10)
	  var expm1OfTen = Math.expm1(10);
	  defineProperty(Math, 'expm1', MathShims.expm1, expm1OfTen > 22025.465794806719 || expm1OfTen < 22025.4657948067165168);
	  // node v12.11 - v12.15 report NaN
	  defineProperty(Math, 'hypot', MathShims.hypot, Math.hypot(Infinity, NaN) !== Infinity);
	
	  var origMathRound = Math.round;
	  // breaks in e.g. Safari 8, Internet Explorer 11, Opera 12
	  var roundHandlesBoundaryConditions = Math.round(0.5 - (Number.EPSILON / 4)) === 0 &&
	    Math.round(-0.5 + (Number.EPSILON / 3.99)) === 1;
	
	  // When engines use Math.floor(x + 0.5) internally, Math.round can be buggy for large integers.
	  // This behavior should be governed by "round to nearest, ties to even mode"
	  // see http://www.ecma-international.org/ecma-262/6.0/#sec-terms-and-definitions-number-type
	  // These are the boundary cases where it breaks.
	  var smallestPositiveNumberWhereRoundBreaks = inverseEpsilon + 1;
	  var largestPositiveNumberWhereRoundBreaks = (2 * inverseEpsilon) - 1;
	  var roundDoesNotIncreaseIntegers = [
	    smallestPositiveNumberWhereRoundBreaks,
	    largestPositiveNumberWhereRoundBreaks
	  ].every(function (num) {
	    return Math.round(num) === num;
	  });
	  defineProperty(Math, 'round', function round(x) {
	    var floor = _floor(x);
	    var ceil = floor === -1 ? -0 : floor + 1;
	    return x - floor < 0.5 ? floor : ceil;
	  }, !roundHandlesBoundaryConditions || !roundDoesNotIncreaseIntegers);
	  Value.preserveToString(Math.round, origMathRound);
	
	  var origImul = Math.imul;
	  if (Math.imul(0xffffffff, 5) !== -5) {
	    // Safari 6.1, at least, reports "0" for this value
	    Math.imul = MathShims.imul;
	    Value.preserveToString(Math.imul, origImul);
	  }
	  if (Math.imul.length !== 2) {
	    // Safari 8.0.4 has a length of 1
	    // fixed in https://bugs.webkit.org/show_bug.cgi?id=143658
	    overrideNative(Math, 'imul', function imul(x, y) {
	      return ES.Call(origImul, Math, arguments);
	    });
	  }
	
	  // Promises
	  // Simplest possible implementation; use a 3rd-party library if you
	  // want the best possible speed and/or long stack traces.
	  var PromiseShim = (function () {
	    var setTimeout = globals.setTimeout;
	    // some environments don't have setTimeout - no way to shim here.
	    if (typeof setTimeout !== 'function' && typeof setTimeout !== 'object') { return; }
	
	    ES.IsPromise = function (promise) {
	      if (!ES.TypeIsObject(promise)) {
	        return false;
	      }
	      if (typeof promise._promise === 'undefined') {
	        return false; // uninitialized, or missing our hidden field.
	      }
	      return true;
	    };
	
	    // "PromiseCapability" in the spec is what most promise implementations
	    // call a "deferred".
	    var PromiseCapability = function (C) {
	      if (!ES.IsConstructor(C)) {
	        throw new TypeError('Bad promise constructor');
	      }
	      var capability = this;
	      var resolver = function (resolve, reject) {
	        if (capability.resolve !== void 0 || capability.reject !== void 0) {
	          throw new TypeError('Bad Promise implementation!');
	        }
	        capability.resolve = resolve;
	        capability.reject = reject;
	      };
	      // Initialize fields to inform optimizers about the object shape.
	      capability.resolve = void 0;
	      capability.reject = void 0;
	      capability.promise = new C(resolver);
	      if (!(ES.IsCallable(capability.resolve) && ES.IsCallable(capability.reject))) {
	        throw new TypeError('Bad promise constructor');
	      }
	    };
	
	    // find an appropriate setImmediate-alike
	    var makeZeroTimeout;
	    if (typeof window !== 'undefined' && ES.IsCallable(window.postMessage)) {
	      makeZeroTimeout = function () {
	        // from http://dbaron.org/log/20100309-faster-timeouts
	        var timeouts = [];
	        var messageName = 'zero-timeout-message';
	        var setZeroTimeout = function (fn) {
	          _push(timeouts, fn);
	          window.postMessage(messageName, '*');
	        };
	        var handleMessage = function (event) {
	          if (event.source === window && event.data === messageName) {
	            event.stopPropagation();
	            if (timeouts.length === 0) { return; }
	            var fn = _shift(timeouts);
	            fn();
	          }
	        };
	        window.addEventListener('message', handleMessage, true);
	        return setZeroTimeout;
	      };
	    }
	    var makePromiseAsap = function () {
	      // An efficient task-scheduler based on a pre-existing Promise
	      // implementation, which we can use even if we override the
	      // global Promise below (in order to workaround bugs)
	      // https://github.com/Raynos/observ-hash/issues/2#issuecomment-35857671
	      var P = globals.Promise;
	      var pr = P && P.resolve && P.resolve();
	      return pr && function (task) {
	        return pr.then(task);
	      };
	    };
	    var enqueue = ES.IsCallable(globals.setImmediate) ?
	      globals.setImmediate :
	      typeof process === 'object' && process.nextTick ? process.nextTick : makePromiseAsap() ||
	      (ES.IsCallable(makeZeroTimeout) ? makeZeroTimeout() : function (task) { setTimeout(task, 0); }); // fallback
	
	    // Constants for Promise implementation
	    var PROMISE_IDENTITY = function (x) { return x; };
	    var PROMISE_THROWER = function (e) { throw e; };
	    var PROMISE_PENDING = 0;
	    var PROMISE_FULFILLED = 1;
	    var PROMISE_REJECTED = 2;
	    // We store fulfill/reject handlers and capabilities in a single array.
	    var PROMISE_FULFILL_OFFSET = 0;
	    var PROMISE_REJECT_OFFSET = 1;
	    var PROMISE_CAPABILITY_OFFSET = 2;
	    // This is used in an optimization for chaining promises via then.
	    var PROMISE_FAKE_CAPABILITY = {};
	
	    var enqueuePromiseReactionJob = function (handler, capability, argument) {
	      enqueue(function () {
	        promiseReactionJob(handler, capability, argument);
	      });
	    };
	
	    var promiseReactionJob = function (handler, promiseCapability, argument) {
	      var handlerResult, f;
	      if (promiseCapability === PROMISE_FAKE_CAPABILITY) {
	        // Fast case, when we don't actually need to chain through to a
	        // (real) promiseCapability.
	        return handler(argument);
	      }
	      try {
	        handlerResult = handler(argument);
	        f = promiseCapability.resolve;
	      } catch (e) {
	        handlerResult = e;
	        f = promiseCapability.reject;
	      }
	      f(handlerResult);
	    };
	
	    var fulfillPromise = function (promise, value) {
	      var _promise = promise._promise;
	      var length = _promise.reactionLength;
	      if (length > 0) {
	        enqueuePromiseReactionJob(
	          _promise.fulfillReactionHandler0,
	          _promise.reactionCapability0,
	          value
	        );
	        _promise.fulfillReactionHandler0 = void 0;
	        _promise.rejectReactions0 = void 0;
	        _promise.reactionCapability0 = void 0;
	        if (length > 1) {
	          for (var i = 1, idx = 0; i < length; i++, idx += 3) {
	            enqueuePromiseReactionJob(
	              _promise[idx + PROMISE_FULFILL_OFFSET],
	              _promise[idx + PROMISE_CAPABILITY_OFFSET],
	              value
	            );
	            promise[idx + PROMISE_FULFILL_OFFSET] = void 0;
	            promise[idx + PROMISE_REJECT_OFFSET] = void 0;
	            promise[idx + PROMISE_CAPABILITY_OFFSET] = void 0;
	          }
	        }
	      }
	      _promise.result = value;
	      _promise.state = PROMISE_FULFILLED;
	      _promise.reactionLength = 0;
	    };
	
	    var rejectPromise = function (promise, reason) {
	      var _promise = promise._promise;
	      var length = _promise.reactionLength;
	      if (length > 0) {
	        enqueuePromiseReactionJob(
	          _promise.rejectReactionHandler0,
	          _promise.reactionCapability0,
	          reason
	        );
	        _promise.fulfillReactionHandler0 = void 0;
	        _promise.rejectReactions0 = void 0;
	        _promise.reactionCapability0 = void 0;
	        if (length > 1) {
	          for (var i = 1, idx = 0; i < length; i++, idx += 3) {
	            enqueuePromiseReactionJob(
	              _promise[idx + PROMISE_REJECT_OFFSET],
	              _promise[idx + PROMISE_CAPABILITY_OFFSET],
	              reason
	            );
	            promise[idx + PROMISE_FULFILL_OFFSET] = void 0;
	            promise[idx + PROMISE_REJECT_OFFSET] = void 0;
	            promise[idx + PROMISE_CAPABILITY_OFFSET] = void 0;
	          }
	        }
	      }
	      _promise.result = reason;
	      _promise.state = PROMISE_REJECTED;
	      _promise.reactionLength = 0;
	    };
	
	    var createResolvingFunctions = function (promise) {
	      var alreadyResolved = false;
	      var resolve = function (resolution) {
	        var then;
	        if (alreadyResolved) { return; }
	        alreadyResolved = true;
	        if (resolution === promise) {
	          return rejectPromise(promise, new TypeError('Self resolution'));
	        }
	        if (!ES.TypeIsObject(resolution)) {
	          return fulfillPromise(promise, resolution);
	        }
	        try {
	          then = resolution.then;
	        } catch (e) {
	          return rejectPromise(promise, e);
	        }
	        if (!ES.IsCallable(then)) {
	          return fulfillPromise(promise, resolution);
	        }
	        enqueue(function () {
	          promiseResolveThenableJob(promise, resolution, then);
	        });
	      };
	      var reject = function (reason) {
	        if (alreadyResolved) { return; }
	        alreadyResolved = true;
	        return rejectPromise(promise, reason);
	      };
	      return { resolve: resolve, reject: reject };
	    };
	
	    var optimizedThen = function (then, thenable, resolve, reject) {
	      // Optimization: since we discard the result, we can pass our
	      // own then implementation a special hint to let it know it
	      // doesn't have to create it.  (The PROMISE_FAKE_CAPABILITY
	      // object is local to this implementation and unforgeable outside.)
	      if (then === Promise$prototype$then) {
	        _call(then, thenable, resolve, reject, PROMISE_FAKE_CAPABILITY);
	      } else {
	        _call(then, thenable, resolve, reject);
	      }
	    };
	    var promiseResolveThenableJob = function (promise, thenable, then) {
	      var resolvingFunctions = createResolvingFunctions(promise);
	      var resolve = resolvingFunctions.resolve;
	      var reject = resolvingFunctions.reject;
	      try {
	        optimizedThen(then, thenable, resolve, reject);
	      } catch (e) {
	        reject(e);
	      }
	    };
	
	    var Promise$prototype, Promise$prototype$then;
	    var Promise = (function () {
	      var PromiseShim = function Promise(resolver) {
	        if (!(this instanceof PromiseShim)) {
	          throw new TypeError('Constructor Promise requires "new"');
	        }
	        if (this && this._promise) {
	          throw new TypeError('Bad construction');
	        }
	        // see https://bugs.ecmascript.org/show_bug.cgi?id=2482
	        if (!ES.IsCallable(resolver)) {
	          throw new TypeError('not a valid resolver');
	        }
	        var promise = emulateES6construct(this, PromiseShim, Promise$prototype, {
	          _promise: {
	            result: void 0,
	            state: PROMISE_PENDING,
	            // The first member of the "reactions" array is inlined here,
	            // since most promises only have one reaction.
	            // We've also exploded the 'reaction' object to inline the
	            // "handler" and "capability" fields, since both fulfill and
	            // reject reactions share the same capability.
	            reactionLength: 0,
	            fulfillReactionHandler0: void 0,
	            rejectReactionHandler0: void 0,
	            reactionCapability0: void 0
	          }
	        });
	        var resolvingFunctions = createResolvingFunctions(promise);
	        var reject = resolvingFunctions.reject;
	        try {
	          resolver(resolvingFunctions.resolve, reject);
	        } catch (e) {
	          reject(e);
	        }
	        return promise;
	      };
	      return PromiseShim;
	    }());
	    Promise$prototype = Promise.prototype;
	
	    var _promiseAllResolver = function (index, values, capability, remaining) {
	      var alreadyCalled = false;
	      return function (x) {
	        if (alreadyCalled) { return; }
	        alreadyCalled = true;
	        values[index] = x;
	        if ((--remaining.count) === 0) {
	          var resolve = capability.resolve;
	          resolve(values); // call w/ this===undefined
	        }
	      };
	    };
	
	    var performPromiseAll = function (iteratorRecord, C, resultCapability) {
	      var it = iteratorRecord.iterator;
	      var values = [];
	      var remaining = { count: 1 };
	      var next, nextValue;
	      var index = 0;
	      while (true) {
	        try {
	          next = ES.IteratorStep(it);
	          if (next === false) {
	            iteratorRecord.done = true;
	            break;
	          }
	          nextValue = next.value;
	        } catch (e) {
	          iteratorRecord.done = true;
	          throw e;
	        }
	        values[index] = void 0;
	        var nextPromise = C.resolve(nextValue);
	        var resolveElement = _promiseAllResolver(
	          index,
	          values,
	          resultCapability,
	          remaining
	        );
	        remaining.count += 1;
	        optimizedThen(nextPromise.then, nextPromise, resolveElement, resultCapability.reject);
	        index += 1;
	      }
	      if ((--remaining.count) === 0) {
	        var resolve = resultCapability.resolve;
	        resolve(values); // call w/ this===undefined
	      }
	      return resultCapability.promise;
	    };
	
	    var performPromiseRace = function (iteratorRecord, C, resultCapability) {
	      var it = iteratorRecord.iterator;
	      var next, nextValue, nextPromise;
	      while (true) {
	        try {
	          next = ES.IteratorStep(it);
	          if (next === false) {
	            // NOTE: If iterable has no items, resulting promise will never
	            // resolve; see:
	            // https://github.com/domenic/promises-unwrapping/issues/75
	            // https://bugs.ecmascript.org/show_bug.cgi?id=2515
	            iteratorRecord.done = true;
	            break;
	          }
	          nextValue = next.value;
	        } catch (e) {
	          iteratorRecord.done = true;
	          throw e;
	        }
	        nextPromise = C.resolve(nextValue);
	        optimizedThen(nextPromise.then, nextPromise, resultCapability.resolve, resultCapability.reject);
	      }
	      return resultCapability.promise;
	    };
	
	    defineProperties(Promise, {
	      all: function all(iterable) {
	        var C = this;
	        if (!ES.TypeIsObject(C)) {
	          throw new TypeError('Promise is not object');
	        }
	        var capability = new PromiseCapability(C);
	        var iterator, iteratorRecord;
	        try {
	          iterator = ES.GetIterator(iterable);
	          iteratorRecord = { iterator: iterator, done: false };
	          return performPromiseAll(iteratorRecord, C, capability);
	        } catch (e) {
	          var exception = e;
	          if (iteratorRecord && !iteratorRecord.done) {
	            try {
	              ES.IteratorClose(iterator, true);
	            } catch (ee) {
	              exception = ee;
	            }
	          }
	          var reject = capability.reject;
	          reject(exception);
	          return capability.promise;
	        }
	      },
	
	      race: function race(iterable) {
	        var C = this;
	        if (!ES.TypeIsObject(C)) {
	          throw new TypeError('Promise is not object');
	        }
	        var capability = new PromiseCapability(C);
	        var iterator, iteratorRecord;
	        try {
	          iterator = ES.GetIterator(iterable);
	          iteratorRecord = { iterator: iterator, done: false };
	          return performPromiseRace(iteratorRecord, C, capability);
	        } catch (e) {
	          var exception = e;
	          if (iteratorRecord && !iteratorRecord.done) {
	            try {
	              ES.IteratorClose(iterator, true);
	            } catch (ee) {
	              exception = ee;
	            }
	          }
	          var reject = capability.reject;
	          reject(exception);
	          return capability.promise;
	        }
	      },
	
	      reject: function reject(reason) {
	        var C = this;
	        if (!ES.TypeIsObject(C)) {
	          throw new TypeError('Bad promise constructor');
	        }
	        var capability = new PromiseCapability(C);
	        var rejectFunc = capability.reject;
	        rejectFunc(reason); // call with this===undefined
	        return capability.promise;
	      },
	
	      resolve: function resolve(v) {
	        // See https://esdiscuss.org/topic/fixing-promise-resolve for spec
	        var C = this;
	        if (!ES.TypeIsObject(C)) {
	          throw new TypeError('Bad promise constructor');
	        }
	        if (ES.IsPromise(v)) {
	          var constructor = v.constructor;
	          if (constructor === C) {
	            return v;
	          }
	        }
	        var capability = new PromiseCapability(C);
	        var resolveFunc = capability.resolve;
	        resolveFunc(v); // call with this===undefined
	        return capability.promise;
	      }
	    });
	
	    defineProperties(Promise$prototype, {
	      'catch': function (onRejected) {
	        return this.then(null, onRejected);
	      },
	
	      then: function then(onFulfilled, onRejected) {
	        var promise = this;
	        if (!ES.IsPromise(promise)) { throw new TypeError('not a promise'); }
	        var C = ES.SpeciesConstructor(promise, Promise);
	        var resultCapability;
	        var returnValueIsIgnored = arguments.length > 2 && arguments[2] === PROMISE_FAKE_CAPABILITY;
	        if (returnValueIsIgnored && C === Promise) {
	          resultCapability = PROMISE_FAKE_CAPABILITY;
	        } else {
	          resultCapability = new PromiseCapability(C);
	        }
	        // PerformPromiseThen(promise, onFulfilled, onRejected, resultCapability)
	        // Note that we've split the 'reaction' object into its two
	        // components, "capabilities" and "handler"
	        // "capabilities" is always equal to `resultCapability`
	        var fulfillReactionHandler = ES.IsCallable(onFulfilled) ? onFulfilled : PROMISE_IDENTITY;
	        var rejectReactionHandler = ES.IsCallable(onRejected) ? onRejected : PROMISE_THROWER;
	        var _promise = promise._promise;
	        var value;
	        if (_promise.state === PROMISE_PENDING) {
	          if (_promise.reactionLength === 0) {
	            _promise.fulfillReactionHandler0 = fulfillReactionHandler;
	            _promise.rejectReactionHandler0 = rejectReactionHandler;
	            _promise.reactionCapability0 = resultCapability;
	          } else {
	            var idx = 3 * (_promise.reactionLength - 1);
	            _promise[idx + PROMISE_FULFILL_OFFSET] = fulfillReactionHandler;
	            _promise[idx + PROMISE_REJECT_OFFSET] = rejectReactionHandler;
	            _promise[idx + PROMISE_CAPABILITY_OFFSET] = resultCapability;
	          }
	          _promise.reactionLength += 1;
	        } else if (_promise.state === PROMISE_FULFILLED) {
	          value = _promise.result;
	          enqueuePromiseReactionJob(
	            fulfillReactionHandler,
	            resultCapability,
	            value
	          );
	        } else if (_promise.state === PROMISE_REJECTED) {
	          value = _promise.result;
	          enqueuePromiseReactionJob(
	            rejectReactionHandler,
	            resultCapability,
	            value
	          );
	        } else {
	          throw new TypeError('unexpected Promise state');
	        }
	        return resultCapability.promise;
	      }
	    });
	    // This helps the optimizer by ensuring that methods which take
	    // capabilities aren't polymorphic.
	    PROMISE_FAKE_CAPABILITY = new PromiseCapability(Promise);
	    Promise$prototype$then = Promise$prototype.then;
	
	    return Promise;
	  }());
	
	  // Chrome's native Promise has extra methods that it shouldn't have. Let's remove them.
	  if (globals.Promise) {
	    delete globals.Promise.accept;
	    delete globals.Promise.defer;
	    delete globals.Promise.prototype.chain;
	  }
	
	  if (typeof PromiseShim === 'function') {
	    // export the Promise constructor.
	    defineProperties(globals, { Promise: PromiseShim });
	    // In Chrome 33 (and thereabouts) Promise is defined, but the
	    // implementation is buggy in a number of ways.  Let's check subclassing
	    // support to see if we have a buggy implementation.
	    var promiseSupportsSubclassing = supportsSubclassing(globals.Promise, function (S) {
	      return S.resolve(42).then(function () {}) instanceof S;
	    });
	    var promiseIgnoresNonFunctionThenCallbacks = !throwsError(function () {
	      return globals.Promise.reject(42).then(null, 5).then(null, noop);
	    });
	    var promiseRequiresObjectContext = throwsError(function () { return globals.Promise.call(3, noop); });
	    // Promise.resolve() was errata'ed late in the ES6 process.
	    // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1170742
	    //      https://code.google.com/p/v8/issues/detail?id=4161
	    // It serves as a proxy for a number of other bugs in early Promise
	    // implementations.
	    var promiseResolveBroken = (function (Promise) {
	      var p = Promise.resolve(5);
	      p.constructor = {};
	      var p2 = Promise.resolve(p);
	      try {
	        p2.then(null, noop).then(null, noop); // avoid "uncaught rejection" warnings in console
	      } catch (e) {
	        return true; // v8 native Promises break here https://code.google.com/p/chromium/issues/detail?id=575314
	      }
	      return p === p2; // This *should* be false!
	    }(globals.Promise));
	
	    // Chrome 46 (probably older too) does not retrieve a thenable's .then synchronously
	    var getsThenSynchronously = supportsDescriptors && (function () {
	      var count = 0;
	      // eslint-disable-next-line getter-return
	      var thenable = Object.defineProperty({}, 'then', { get: function () { count += 1; } });
	      Promise.resolve(thenable);
	      return count === 1;
	    }());
	
	    var BadResolverPromise = function BadResolverPromise(executor) {
	      var p = new Promise(executor);
	      executor(3, function () {});
	      this.then = p.then;
	      this.constructor = BadResolverPromise;
	    };
	    BadResolverPromise.prototype = Promise.prototype;
	    BadResolverPromise.all = Promise.all;
	    // Chrome Canary 49 (probably older too) has some implementation bugs
	    var hasBadResolverPromise = valueOrFalseIfThrows(function () {
	      return !!BadResolverPromise.all([1, 2]);
	    });
	
	    if (!promiseSupportsSubclassing || !promiseIgnoresNonFunctionThenCallbacks ||
	        !promiseRequiresObjectContext || promiseResolveBroken ||
	        !getsThenSynchronously || hasBadResolverPromise) {
	      /* globals Promise: true */
	      /* eslint-disable no-undef, no-global-assign */
	      Promise = PromiseShim;
	      /* eslint-enable no-undef, no-global-assign */
	      overrideNative(globals, 'Promise', PromiseShim);
	    }
	    if (Promise.all.length !== 1) {
	      var origAll = Promise.all;
	      overrideNative(Promise, 'all', function all(iterable) {
	        return ES.Call(origAll, this, arguments);
	      });
	    }
	    if (Promise.race.length !== 1) {
	      var origRace = Promise.race;
	      overrideNative(Promise, 'race', function race(iterable) {
	        return ES.Call(origRace, this, arguments);
	      });
	    }
	    if (Promise.resolve.length !== 1) {
	      var origResolve = Promise.resolve;
	      overrideNative(Promise, 'resolve', function resolve(x) {
	        return ES.Call(origResolve, this, arguments);
	      });
	    }
	    if (Promise.reject.length !== 1) {
	      var origReject = Promise.reject;
	      overrideNative(Promise, 'reject', function reject(r) {
	        return ES.Call(origReject, this, arguments);
	      });
	    }
	    ensureEnumerable(Promise, 'all');
	    ensureEnumerable(Promise, 'race');
	    ensureEnumerable(Promise, 'resolve');
	    ensureEnumerable(Promise, 'reject');
	    addDefaultSpecies(Promise);
	  }
	
	  // Map and Set require a true ES5 environment
	  // Their fast path also requires that the environment preserve
	  // property insertion order, which is not guaranteed by the spec.
	  var testOrder = function (a) {
	    var b = keys(_reduce(a, function (o, k) {
	      o[k] = true;
	      return o;
	    }, {}));
	    return a.join(':') === b.join(':');
	  };
	  var preservesInsertionOrder = testOrder(['z', 'a', 'bb']);
	  // some engines (eg, Chrome) only preserve insertion order for string keys
	  var preservesNumericInsertionOrder = testOrder(['z', 1, 'a', '3', 2]);
	
	  if (supportsDescriptors) {
	
	    var fastkey = function fastkey(key, skipInsertionOrderCheck) {
	      if (!skipInsertionOrderCheck && !preservesInsertionOrder) {
	        return null;
	      }
	      if (isNullOrUndefined(key)) {
	        return '^' + ES.ToString(key);
	      } else if (typeof key === 'string') {
	        return '$' + key;
	      } else if (typeof key === 'number') {
	        // note that -0 will get coerced to "0" when used as a property key
	        if (!preservesNumericInsertionOrder) {
	          return 'n' + key;
	        }
	        return key;
	      } else if (typeof key === 'boolean') {
	        return 'b' + key;
	      }
	      return null;
	    };
	
	    var emptyObject = function emptyObject() {
	      // accomodate some older not-quite-ES5 browsers
	      return Object.create ? Object.create(null) : {};
	    };
	
	    var addIterableToMap = function addIterableToMap(MapConstructor, map, iterable) {
	      if (isArray(iterable) || Type.string(iterable)) {
	        _forEach(iterable, function (entry) {
	          if (!ES.TypeIsObject(entry)) {
	            throw new TypeError('Iterator value ' + entry + ' is not an entry object');
	          }
	          map.set(entry[0], entry[1]);
	        });
	      } else if (iterable instanceof MapConstructor) {
	        _call(MapConstructor.prototype.forEach, iterable, function (value, key) {
	          map.set(key, value);
	        });
	      } else {
	        var iter, adder;
	        if (!isNullOrUndefined(iterable)) {
	          adder = map.set;
	          if (!ES.IsCallable(adder)) { throw new TypeError('bad map'); }
	          iter = ES.GetIterator(iterable);
	        }
	        if (typeof iter !== 'undefined') {
	          while (true) {
	            var next = ES.IteratorStep(iter);
	            if (next === false) { break; }
	            var nextItem = next.value;
	            try {
	              if (!ES.TypeIsObject(nextItem)) {
	                throw new TypeError('Iterator value ' + nextItem + ' is not an entry object');
	              }
	              _call(adder, map, nextItem[0], nextItem[1]);
	            } catch (e) {
	              ES.IteratorClose(iter, true);
	              throw e;
	            }
	          }
	        }
	      }
	    };
	    var addIterableToSet = function addIterableToSet(SetConstructor, set, iterable) {
	      if (isArray(iterable) || Type.string(iterable)) {
	        _forEach(iterable, function (value) {
	          set.add(value);
	        });
	      } else if (iterable instanceof SetConstructor) {
	        _call(SetConstructor.prototype.forEach, iterable, function (value) {
	          set.add(value);
	        });
	      } else {
	        var iter, adder;
	        if (!isNullOrUndefined(iterable)) {
	          adder = set.add;
	          if (!ES.IsCallable(adder)) { throw new TypeError('bad set'); }
	          iter = ES.GetIterator(iterable);
	        }
	        if (typeof iter !== 'undefined') {
	          while (true) {
	            var next = ES.IteratorStep(iter);
	            if (next === false) { break; }
	            var nextValue = next.value;
	            try {
	              _call(adder, set, nextValue);
	            } catch (e) {
	              ES.IteratorClose(iter, true);
	              throw e;
	            }
	          }
	        }
	      }
	    };
	
	    var collectionShims = {
	      Map: (function () {
	
	        var empty = {};
	
	        var MapEntry = function MapEntry(key, value) {
	          this.key = key;
	          this.value = value;
	          this.next = null;
	          this.prev = null;
	        };
	
	        MapEntry.prototype.isRemoved = function isRemoved() {
	          return this.key === empty;
	        };
	
	        var isMap = function isMap(map) {
	          return !!map._es6map;
	        };
	
	        var requireMapSlot = function requireMapSlot(map, method) {
	          if (!ES.TypeIsObject(map) || !isMap(map)) {
	            throw new TypeError('Method Map.prototype.' + method + ' called on incompatible receiver ' + ES.ToString(map));
	          }
	        };
	
	        var MapIterator = function MapIterator(map, kind) {
	          requireMapSlot(map, '[[MapIterator]]');
	          this.head = map._head;
	          this.i = this.head;
	          this.kind = kind;
	        };
	
	        MapIterator.prototype = {
	          isMapIterator: true,
	          next: function next() {
	            if (!this.isMapIterator) {
	              throw new TypeError('Not a MapIterator');
	            }
	            var i = this.i;
	            var kind = this.kind;
	            var head = this.head;
	            if (typeof this.i === 'undefined') {
	              return iteratorResult();
	            }
	            while (i.isRemoved() && i !== head) {
	              // back up off of removed entries
	              i = i.prev;
	            }
	            // advance to next unreturned element.
	            var result;
	            while (i.next !== head) {
	              i = i.next;
	              if (!i.isRemoved()) {
	                if (kind === 'key') {
	                  result = i.key;
	                } else if (kind === 'value') {
	                  result = i.value;
	                } else {
	                  result = [i.key, i.value];
	                }
	                this.i = i;
	                return iteratorResult(result);
	              }
	            }
	            // once the iterator is done, it is done forever.
	            this.i = void 0;
	            return iteratorResult();
	          }
	        };
	        addIterator(MapIterator.prototype);
	
	        var Map$prototype;
	        var MapShim = function Map() {
	          if (!(this instanceof Map)) {
	            throw new TypeError('Constructor Map requires "new"');
	          }
	          if (this && this._es6map) {
	            throw new TypeError('Bad construction');
	          }
	          var map = emulateES6construct(this, Map, Map$prototype, {
	            _es6map: true,
	            _head: null,
	            _map: OrigMap ? new OrigMap() : null,
	            _size: 0,
	            _storage: emptyObject()
	          });
	
	          var head = new MapEntry(null, null);
	          // circular doubly-linked list.
	          /* eslint no-multi-assign: 1 */
	          head.next = head.prev = head;
	          map._head = head;
	
	          // Optionally initialize map from iterable
	          if (arguments.length > 0) {
	            addIterableToMap(Map, map, arguments[0]);
	          }
	          return map;
	        };
	        Map$prototype = MapShim.prototype;
	
	        Value.getter(Map$prototype, 'size', function () {
	          if (typeof this._size === 'undefined') {
	            throw new TypeError('size method called on incompatible Map');
	          }
	          return this._size;
	        });
	
	        defineProperties(Map$prototype, {
	          get: function get(key) {
	            requireMapSlot(this, 'get');
	            var entry;
	            var fkey = fastkey(key, true);
	            if (fkey !== null) {
	              // fast O(1) path
	              entry = this._storage[fkey];
	              if (entry) {
	                return entry.value;
	              } else {
	                return;
	              }
	            }
	            if (this._map) {
	              // fast object key path
	              entry = origMapGet.call(this._map, key);
	              if (entry) {
	                return entry.value;
	              } else {
	                return;
	              }
	            }
	            var head = this._head;
	            var i = head;
	            while ((i = i.next) !== head) {
	              if (ES.SameValueZero(i.key, key)) {
	                return i.value;
	              }
	            }
	          },
	
	          has: function has(key) {
	            requireMapSlot(this, 'has');
	            var fkey = fastkey(key, true);
	            if (fkey !== null) {
	              // fast O(1) path
	              return typeof this._storage[fkey] !== 'undefined';
	            }
	            if (this._map) {
	              // fast object key path
	              return origMapHas.call(this._map, key);
	            }
	            var head = this._head;
	            var i = head;
	            while ((i = i.next) !== head) {
	              if (ES.SameValueZero(i.key, key)) {
	                return true;
	              }
	            }
	            return false;
	          },
	
	          set: function set(key, value) {
	            requireMapSlot(this, 'set');
	            var head = this._head;
	            var i = head;
	            var entry;
	            var fkey = fastkey(key, true);
	            if (fkey !== null) {
	              // fast O(1) path
	              if (typeof this._storage[fkey] !== 'undefined') {
	                this._storage[fkey].value = value;
	                return this;
	              } else {
	                entry = this._storage[fkey] = new MapEntry(key, value); /* eslint no-multi-assign: 1 */
	                i = head.prev;
	                // fall through
	              }
	            } else if (this._map) {
	              // fast object key path
	              if (origMapHas.call(this._map, key)) {
	                origMapGet.call(this._map, key).value = value;
	              } else {
	                entry = new MapEntry(key, value);
	                origMapSet.call(this._map, key, entry);
	                i = head.prev;
	                // fall through
	              }
	            }
	            while ((i = i.next) !== head) {
	              if (ES.SameValueZero(i.key, key)) {
	                i.value = value;
	                return this;
	              }
	            }
	            entry = entry || new MapEntry(key, value);
	            if (ES.SameValue(-0, key)) {
	              entry.key = +0; // coerce -0 to +0 in entry
	            }
	            entry.next = this._head;
	            entry.prev = this._head.prev;
	            entry.prev.next = entry;
	            entry.next.prev = entry;
	            this._size += 1;
	            return this;
	          },
	
	          'delete': function (key) {
	            requireMapSlot(this, 'delete');
	            var head = this._head;
	            var i = head;
	            var fkey = fastkey(key, true);
	            if (fkey !== null) {
	              // fast O(1) path
	              if (typeof this._storage[fkey] === 'undefined') {
	                return false;
	              }
	              i = this._storage[fkey].prev;
	              delete this._storage[fkey];
	              // fall through
	            } else if (this._map) {
	              // fast object key path
	              if (!origMapHas.call(this._map, key)) {
	                return false;
	              }
	              i = origMapGet.call(this._map, key).prev;
	              origMapDelete.call(this._map, key);
	              // fall through
	            }
	            while ((i = i.next) !== head) {
	              if (ES.SameValueZero(i.key, key)) {
	                i.key = empty;
	                i.value = empty;
	                i.prev.next = i.next;
	                i.next.prev = i.prev;
	                this._size -= 1;
	                return true;
	              }
	            }
	            return false;
	          },
	
	          clear: function clear() {
	            /* eslint no-multi-assign: 1 */
	            requireMapSlot(this, 'clear');
	            this._map = OrigMap ? new OrigMap() : null;
	            this._size = 0;
	            this._storage = emptyObject();
	            var head = this._head;
	            var i = head;
	            var p = i.next;
	            while ((i = p) !== head) {
	              i.key = empty;
	              i.value = empty;
	              p = i.next;
	              i.next = i.prev = head;
	            }
	            head.next = head.prev = head;
	          },
	
	          keys: function keys() {
	            requireMapSlot(this, 'keys');
	            return new MapIterator(this, 'key');
	          },
	
	          values: function values() {
	            requireMapSlot(this, 'values');
	            return new MapIterator(this, 'value');
	          },
	
	          entries: function entries() {
	            requireMapSlot(this, 'entries');
	            return new MapIterator(this, 'key+value');
	          },
	
	          forEach: function forEach(callback) {
	            requireMapSlot(this, 'forEach');
	            var context = arguments.length > 1 ? arguments[1] : null;
	            var it = this.entries();
	            for (var entry = it.next(); !entry.done; entry = it.next()) {
	              if (context) {
	                _call(callback, context, entry.value[1], entry.value[0], this);
	              } else {
	                callback(entry.value[1], entry.value[0], this);
	              }
	            }
	          }
	        });
	        addIterator(Map$prototype, Map$prototype.entries);
	
	        return MapShim;
	      }()),
	
	      Set: (function () {
	        var isSet = function isSet(set) {
	          return set._es6set && typeof set._storage !== 'undefined';
	        };
	        var requireSetSlot = function requireSetSlot(set, method) {
	          if (!ES.TypeIsObject(set) || !isSet(set)) {
	            // https://github.com/paulmillr/es6-shim/issues/176
	            throw new TypeError('Set.prototype.' + method + ' called on incompatible receiver ' + ES.ToString(set));
	          }
	        };
	
	        // Creating a Map is expensive.  To speed up the common case of
	        // Sets containing only string or numeric keys, we use an object
	        // as backing storage and lazily create a full Map only when
	        // required.
	        var Set$prototype;
	        var SetShim = function Set() {
	          if (!(this instanceof Set)) {
	            throw new TypeError('Constructor Set requires "new"');
	          }
	          if (this && this._es6set) {
	            throw new TypeError('Bad construction');
	          }
	          var set = emulateES6construct(this, Set, Set$prototype, {
	            _es6set: true,
	            '[[SetData]]': null,
	            _storage: emptyObject()
	          });
	          if (!set._es6set) {
	            throw new TypeError('bad set');
	          }
	
	          // Optionally initialize Set from iterable
	          if (arguments.length > 0) {
	            addIterableToSet(Set, set, arguments[0]);
	          }
	          return set;
	        };
	        Set$prototype = SetShim.prototype;
	
	        var decodeKey = function (key) {
	          var k = key;
	          if (k === '^null') {
	            return null;
	          } else if (k === '^undefined') {
	            return void 0;
	          } else {
	            var first = k.charAt(0);
	            if (first === '$') {
	              return _strSlice(k, 1);
	            } else if (first === 'n') {
	              return +_strSlice(k, 1);
	            } else if (first === 'b') {
	              return k === 'btrue';
	            }
	          }
	          return +k;
	        };
	        // Switch from the object backing storage to a full Map.
	        var ensureMap = function ensureMap(set) {
	          if (!set['[[SetData]]']) {
	            var m = new collectionShims.Map();
	            set['[[SetData]]'] = m;
	            _forEach(keys(set._storage), function (key) {
	              var k = decodeKey(key);
	              m.set(k, k);
	            });
	            set['[[SetData]]'] = m;
	          }
	          set._storage = null; // free old backing storage
	        };
	
	        Value.getter(SetShim.prototype, 'size', function () {
	          requireSetSlot(this, 'size');
	          if (this._storage) {
	            return keys(this._storage).length;
	          }
	          ensureMap(this);
	          return this['[[SetData]]'].size;
	        });
	
	        defineProperties(SetShim.prototype, {
	          has: function has(key) {
	            requireSetSlot(this, 'has');
	            var fkey;
	            if (this._storage && (fkey = fastkey(key)) !== null) {
	              return !!this._storage[fkey];
	            }
	            ensureMap(this);
	            return this['[[SetData]]'].has(key);
	          },
	
	          add: function add(key) {
	            requireSetSlot(this, 'add');
	            var fkey;
	            if (this._storage && (fkey = fastkey(key)) !== null) {
	              this._storage[fkey] = true;
	              return this;
	            }
	            ensureMap(this);
	            this['[[SetData]]'].set(key, key);
	            return this;
	          },
	
	          'delete': function (key) {
	            requireSetSlot(this, 'delete');
	            var fkey;
	            if (this._storage && (fkey = fastkey(key)) !== null) {
	              var hasFKey = _hasOwnProperty(this._storage, fkey);
	              return (delete this._storage[fkey]) && hasFKey;
	            }
	            ensureMap(this);
	            return this['[[SetData]]']['delete'](key);
	          },
	
	          clear: function clear() {
	            requireSetSlot(this, 'clear');
	            if (this._storage) {
	              this._storage = emptyObject();
	            }
	            if (this['[[SetData]]']) {
	              this['[[SetData]]'].clear();
	            }
	          },
	
	          values: function values() {
	            requireSetSlot(this, 'values');
	            ensureMap(this);
	            return new SetIterator(this['[[SetData]]'].values());
	          },
	
	          entries: function entries() {
	            requireSetSlot(this, 'entries');
	            ensureMap(this);
	            return new SetIterator(this['[[SetData]]'].entries());
	          },
	
	          forEach: function forEach(callback) {
	            requireSetSlot(this, 'forEach');
	            var context = arguments.length > 1 ? arguments[1] : null;
	            var entireSet = this;
	            ensureMap(entireSet);
	            this['[[SetData]]'].forEach(function (value, key) {
	              if (context) {
	                _call(callback, context, key, key, entireSet);
	              } else {
	                callback(key, key, entireSet);
	              }
	            });
	          }
	        });
	        defineProperty(SetShim.prototype, 'keys', SetShim.prototype.values, true);
	        addIterator(SetShim.prototype, SetShim.prototype.values);
	
	        var SetIterator = function SetIterator(it) {
	          this.it = it;
	        };
	        SetIterator.prototype = {
	          isSetIterator: true,
	          next: function next() {
	            if (!this.isSetIterator) {
	              throw new TypeError('Not a SetIterator');
	            }
	            return this.it.next();
	          }
	        };
	        addIterator(SetIterator.prototype);
	
	        return SetShim;
	      }())
	    };
	
	    var isGoogleTranslate = globals.Set && !Set.prototype['delete'] && Set.prototype.remove && Set.prototype.items && Set.prototype.map && Array.isArray(new Set().keys);
	    if (isGoogleTranslate) {
	      // special-case force removal of wildly invalid Set implementation in Google Translate iframes
	      // see https://github.com/paulmillr/es6-shim/issues/438 / https://twitter.com/ljharb/status/849335573114363904
	      globals.Set = collectionShims.Set;
	    }
	    if (globals.Map || globals.Set) {
	      // Safari 8, for example, doesn't accept an iterable.
	      var mapAcceptsArguments = valueOrFalseIfThrows(function () { return new Map([[1, 2]]).get(1) === 2; });
	      if (!mapAcceptsArguments) {
	        globals.Map = function Map() {
	          if (!(this instanceof Map)) {
	            throw new TypeError('Constructor Map requires "new"');
	          }
	          var m = new OrigMap();
	          if (arguments.length > 0) {
	            addIterableToMap(Map, m, arguments[0]);
	          }
	          delete m.constructor;
	          Object.setPrototypeOf(m, globals.Map.prototype);
	          return m;
	        };
	        globals.Map.prototype = create(OrigMap.prototype);
	        defineProperty(globals.Map.prototype, 'constructor', globals.Map, true);
	        Value.preserveToString(globals.Map, OrigMap);
	      }
	      var testMap = new Map();
	      var mapUsesSameValueZero = (function () {
	        // Chrome 38-42, node 0.11/0.12, iojs 1/2 also have a bug when the Map has a size > 4
	        var m = new Map([[1, 0], [2, 0], [3, 0], [4, 0]]);
	        m.set(-0, m);
	        return m.get(0) === m && m.get(-0) === m && m.has(0) && m.has(-0);
	      }());
	      var mapSupportsChaining = testMap.set(1, 2) === testMap;
	      if (!mapUsesSameValueZero || !mapSupportsChaining) {
	        overrideNative(Map.prototype, 'set', function set(k, v) {
	          _call(origMapSet, this, k === 0 ? 0 : k, v);
	          return this;
	        });
	      }
	      if (!mapUsesSameValueZero) {
	        defineProperties(Map.prototype, {
	          get: function get(k) {
	            return _call(origMapGet, this, k === 0 ? 0 : k);
	          },
	          has: function has(k) {
	            return _call(origMapHas, this, k === 0 ? 0 : k);
	          }
	        }, true);
	        Value.preserveToString(Map.prototype.get, origMapGet);
	        Value.preserveToString(Map.prototype.has, origMapHas);
	      }
	      var testSet = new Set();
	      var setUsesSameValueZero = Set.prototype['delete'] && Set.prototype.add && Set.prototype.has && (function (s) {
	        s['delete'](0);
	        s.add(-0);
	        return !s.has(0);
	      }(testSet));
	      var setSupportsChaining = testSet.add(1) === testSet;
	      if (!setUsesSameValueZero || !setSupportsChaining) {
	        var origSetAdd = Set.prototype.add;
	        Set.prototype.add = function add(v) {
	          _call(origSetAdd, this, v === 0 ? 0 : v);
	          return this;
	        };
	        Value.preserveToString(Set.prototype.add, origSetAdd);
	      }
	      if (!setUsesSameValueZero) {
	        var origSetHas = Set.prototype.has;
	        Set.prototype.has = function has(v) {
	          return _call(origSetHas, this, v === 0 ? 0 : v);
	        };
	        Value.preserveToString(Set.prototype.has, origSetHas);
	        var origSetDel = Set.prototype['delete'];
	        Set.prototype['delete'] = function SetDelete(v) {
	          return _call(origSetDel, this, v === 0 ? 0 : v);
	        };
	        Value.preserveToString(Set.prototype['delete'], origSetDel);
	      }
	      var mapSupportsSubclassing = supportsSubclassing(globals.Map, function (M) {
	        var m = new M([]);
	        // Firefox 32 is ok with the instantiating the subclass but will
	        // throw when the map is used.
	        m.set(42, 42);
	        return m instanceof M;
	      });
	      // without Object.setPrototypeOf, subclassing is not possible
	      var mapFailsToSupportSubclassing = Object.setPrototypeOf && !mapSupportsSubclassing;
	      var mapRequiresNew = (function () {
	        try {
	          return !(globals.Map() instanceof globals.Map);
	        } catch (e) {
	          return e instanceof TypeError;
	        }
	      }());
	      if (globals.Map.length !== 0 || mapFailsToSupportSubclassing || !mapRequiresNew) {
	        globals.Map = function Map() {
	          if (!(this instanceof Map)) {
	            throw new TypeError('Constructor Map requires "new"');
	          }
	          var m = new OrigMap();
	          if (arguments.length > 0) {
	            addIterableToMap(Map, m, arguments[0]);
	          }
	          delete m.constructor;
	          Object.setPrototypeOf(m, Map.prototype);
	          return m;
	        };
	        globals.Map.prototype = OrigMap.prototype;
	        defineProperty(globals.Map.prototype, 'constructor', globals.Map, true);
	        Value.preserveToString(globals.Map, OrigMap);
	      }
	      var setSupportsSubclassing = supportsSubclassing(globals.Set, function (S) {
	        var s = new S([]);
	        s.add(42, 42);
	        return s instanceof S;
	      });
	      // without Object.setPrototypeOf, subclassing is not possible
	      var setFailsToSupportSubclassing = Object.setPrototypeOf && !setSupportsSubclassing;
	      var setRequiresNew = (function () {
	        try {
	          return !(globals.Set() instanceof globals.Set);
	        } catch (e) {
	          return e instanceof TypeError;
	        }
	      }());
	      if (globals.Set.length !== 0 || setFailsToSupportSubclassing || !setRequiresNew) {
	        var OrigSet = globals.Set;
	        globals.Set = function Set() {
	          if (!(this instanceof Set)) {
	            throw new TypeError('Constructor Set requires "new"');
	          }
	          var s = new OrigSet();
	          if (arguments.length > 0) {
	            addIterableToSet(Set, s, arguments[0]);
	          }
	          delete s.constructor;
	          Object.setPrototypeOf(s, Set.prototype);
	          return s;
	        };
	        globals.Set.prototype = OrigSet.prototype;
	        defineProperty(globals.Set.prototype, 'constructor', globals.Set, true);
	        Value.preserveToString(globals.Set, OrigSet);
	      }
	      var newMap = new globals.Map();
	      var mapIterationThrowsStopIterator = !valueOrFalseIfThrows(function () {
	        return newMap.keys().next().done;
	      });
	      /*
	        - In Firefox < 23, Map#size is a function.
	        - In all current Firefox, Set#entries/keys/values & Map#clear do not exist
	        - https://bugzilla.mozilla.org/show_bug.cgi?id=869996
	        - In Firefox 24, Map and Set do not implement forEach
	        - In Firefox 25 at least, Map and Set are callable without "new"
	      */
	      if (
	        typeof globals.Map.prototype.clear !== 'function' ||
	        new globals.Set().size !== 0 ||
	        newMap.size !== 0 ||
	        typeof globals.Map.prototype.keys !== 'function' ||
	        typeof globals.Set.prototype.keys !== 'function' ||
	        typeof globals.Map.prototype.forEach !== 'function' ||
	        typeof globals.Set.prototype.forEach !== 'function' ||
	        isCallableWithoutNew(globals.Map) ||
	        isCallableWithoutNew(globals.Set) ||
	        typeof newMap.keys().next !== 'function' || // Safari 8
	        mapIterationThrowsStopIterator || // Firefox 25
	        !mapSupportsSubclassing
	      ) {
	        defineProperties(globals, {
	          Map: collectionShims.Map,
	          Set: collectionShims.Set
	        }, true);
	      }
	
	      if (globals.Set.prototype.keys !== globals.Set.prototype.values) {
	        // Fixed in WebKit with https://bugs.webkit.org/show_bug.cgi?id=144190
	        defineProperty(globals.Set.prototype, 'keys', globals.Set.prototype.values, true);
	      }
	
	      // Shim incomplete iterator implementations.
	      addIterator(Object.getPrototypeOf((new globals.Map()).keys()));
	      addIterator(Object.getPrototypeOf((new globals.Set()).keys()));
	
	      if (functionsHaveNames && globals.Set.prototype.has.name !== 'has') {
	        // Microsoft Edge v0.11.10074.0 is missing a name on Set#has
	        var anonymousSetHas = globals.Set.prototype.has;
	        overrideNative(globals.Set.prototype, 'has', function has(key) {
	          return _call(anonymousSetHas, this, key);
	        });
	      }
	    }
	    defineProperties(globals, collectionShims);
	    addDefaultSpecies(globals.Map);
	    addDefaultSpecies(globals.Set);
	  }
	
	  var throwUnlessTargetIsObject = function throwUnlessTargetIsObject(target) {
	    if (!ES.TypeIsObject(target)) {
	      throw new TypeError('target must be an object');
	    }
	  };
	
	  // Some Reflect methods are basically the same as
	  // those on the Object global, except that a TypeError is thrown if
	  // target isn't an object. As well as returning a boolean indicating
	  // the success of the operation.
	  var ReflectShims = {
	    // Apply method in a functional form.
	    apply: function apply() {
	      return ES.Call(ES.Call, null, arguments);
	    },
	
	    // New operator in a functional form.
	    construct: function construct(constructor, args) {
	      if (!ES.IsConstructor(constructor)) {
	        throw new TypeError('First argument must be a constructor.');
	      }
	      var newTarget = arguments.length > 2 ? arguments[2] : constructor;
	      if (!ES.IsConstructor(newTarget)) {
	        throw new TypeError('new.target must be a constructor.');
	      }
	      return ES.Construct(constructor, args, newTarget, 'internal');
	    },
	
	    // When deleting a non-existent or configurable property,
	    // true is returned.
	    // When attempting to delete a non-configurable property,
	    // it will return false.
	    deleteProperty: function deleteProperty(target, key) {
	      throwUnlessTargetIsObject(target);
	      if (supportsDescriptors) {
	        var desc = Object.getOwnPropertyDescriptor(target, key);
	
	        if (desc && !desc.configurable) {
	          return false;
	        }
	      }
	
	      // Will return true.
	      return delete target[key];
	    },
	
	    has: function has(target, key) {
	      throwUnlessTargetIsObject(target);
	      return key in target;
	    }
	  };
	
	  if (Object.getOwnPropertyNames) {
	    Object.assign(ReflectShims, {
	      // Basically the result of calling the internal [[OwnPropertyKeys]].
	      // Concatenating propertyNames and propertySymbols should do the trick.
	      // This should continue to work together with a Symbol shim
	      // which overrides Object.getOwnPropertyNames and implements
	      // Object.getOwnPropertySymbols.
	      ownKeys: function ownKeys(target) {
	        throwUnlessTargetIsObject(target);
	        var keys = Object.getOwnPropertyNames(target);
	
	        if (ES.IsCallable(Object.getOwnPropertySymbols)) {
	          _pushApply(keys, Object.getOwnPropertySymbols(target));
	        }
	
	        return keys;
	      }
	    });
	  }
	
	  var callAndCatchException = function ConvertExceptionToBoolean(func) {
	    return !throwsError(func);
	  };
	
	  if (Object.preventExtensions) {
	    Object.assign(ReflectShims, {
	      isExtensible: function isExtensible(target) {
	        throwUnlessTargetIsObject(target);
	        return Object.isExtensible(target);
	      },
	      preventExtensions: function preventExtensions(target) {
	        throwUnlessTargetIsObject(target);
	        return callAndCatchException(function () {
	          return Object.preventExtensions(target);
	        });
	      }
	    });
	  }
	
	  if (supportsDescriptors) {
	    var internalGet = function get(target, key, receiver) {
	      var desc = Object.getOwnPropertyDescriptor(target, key);
	
	      if (!desc) {
	        var parent = Object.getPrototypeOf(target);
	
	        if (parent === null) {
	          return void 0;
	        }
	
	        return internalGet(parent, key, receiver);
	      }
	
	      if ('value' in desc) {
	        return desc.value;
	      }
	
	      if (desc.get) {
	        return ES.Call(desc.get, receiver);
	      }
	
	      return void 0;
	    };
	
	    var internalSet = function set(target, key, value, receiver) {
	      var desc = Object.getOwnPropertyDescriptor(target, key);
	
	      if (!desc) {
	        var parent = Object.getPrototypeOf(target);
	
	        if (parent !== null) {
	          return internalSet(parent, key, value, receiver);
	        }
	
	        desc = {
	          value: void 0,
	          writable: true,
	          enumerable: true,
	          configurable: true
	        };
	      }
	
	      if ('value' in desc) {
	        if (!desc.writable) {
	          return false;
	        }
	
	        if (!ES.TypeIsObject(receiver)) {
	          return false;
	        }
	
	        var existingDesc = Object.getOwnPropertyDescriptor(receiver, key);
	
	        if (existingDesc) {
	          return Reflect.defineProperty(receiver, key, {
	            value: value
	          });
	        } else {
	          return Reflect.defineProperty(receiver, key, {
	            value: value,
	            writable: true,
	            enumerable: true,
	            configurable: true
	          });
	        }
	      }
	
	      if (desc.set) {
	        _call(desc.set, receiver, value);
	        return true;
	      }
	
	      return false;
	    };
	
	    Object.assign(ReflectShims, {
	      defineProperty: function defineProperty(target, propertyKey, attributes) {
	        throwUnlessTargetIsObject(target);
	        return callAndCatchException(function () {
	          return Object.defineProperty(target, propertyKey, attributes);
	        });
	      },
	
	      getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	        throwUnlessTargetIsObject(target);
	        return Object.getOwnPropertyDescriptor(target, propertyKey);
	      },
	
	      // Syntax in a functional form.
	      get: function get(target, key) {
	        throwUnlessTargetIsObject(target);
	        var receiver = arguments.length > 2 ? arguments[2] : target;
	
	        return internalGet(target, key, receiver);
	      },
	
	      set: function set(target, key, value) {
	        throwUnlessTargetIsObject(target);
	        var receiver = arguments.length > 3 ? arguments[3] : target;
	
	        return internalSet(target, key, value, receiver);
	      }
	    });
	  }
	
	  if (Object.getPrototypeOf) {
	    var objectDotGetPrototypeOf = Object.getPrototypeOf;
	    ReflectShims.getPrototypeOf = function getPrototypeOf(target) {
	      throwUnlessTargetIsObject(target);
	      return objectDotGetPrototypeOf(target);
	    };
	  }
	
	  if (Object.setPrototypeOf && ReflectShims.getPrototypeOf) {
	    var willCreateCircularPrototype = function (object, lastProto) {
	      var proto = lastProto;
	      while (proto) {
	        if (object === proto) {
	          return true;
	        }
	        proto = ReflectShims.getPrototypeOf(proto);
	      }
	      return false;
	    };
	
	    Object.assign(ReflectShims, {
	      // Sets the prototype of the given object.
	      // Returns true on success, otherwise false.
	      setPrototypeOf: function setPrototypeOf(object, proto) {
	        throwUnlessTargetIsObject(object);
	        if (proto !== null && !ES.TypeIsObject(proto)) {
	          throw new TypeError('proto must be an object or null');
	        }
	
	        // If they already are the same, we're done.
	        if (proto === Reflect.getPrototypeOf(object)) {
	          return true;
	        }
	
	        // Cannot alter prototype if object not extensible.
	        if (Reflect.isExtensible && !Reflect.isExtensible(object)) {
	          return false;
	        }
	
	        // Ensure that we do not create a circular prototype chain.
	        if (willCreateCircularPrototype(object, proto)) {
	          return false;
	        }
	
	        Object.setPrototypeOf(object, proto);
	
	        return true;
	      }
	    });
	  }
	  var defineOrOverrideReflectProperty = function (key, shim) {
	    if (!ES.IsCallable(globals.Reflect[key])) {
	      defineProperty(globals.Reflect, key, shim);
	    } else {
	      var acceptsPrimitives = valueOrFalseIfThrows(function () {
	        globals.Reflect[key](1);
	        globals.Reflect[key](NaN);
	        globals.Reflect[key](true);
	        return true;
	      });
	      if (acceptsPrimitives) {
	        overrideNative(globals.Reflect, key, shim);
	      }
	    }
	  };
	  Object.keys(ReflectShims).forEach(function (key) {
	    defineOrOverrideReflectProperty(key, ReflectShims[key]);
	  });
	  var originalReflectGetProto = globals.Reflect.getPrototypeOf;
	  if (functionsHaveNames && originalReflectGetProto && originalReflectGetProto.name !== 'getPrototypeOf') {
	    overrideNative(globals.Reflect, 'getPrototypeOf', function getPrototypeOf(target) {
	      return _call(originalReflectGetProto, globals.Reflect, target);
	    });
	  }
	  if (globals.Reflect.setPrototypeOf) {
	    if (valueOrFalseIfThrows(function () {
	      globals.Reflect.setPrototypeOf(1, {});
	      return true;
	    })) {
	      overrideNative(globals.Reflect, 'setPrototypeOf', ReflectShims.setPrototypeOf);
	    }
	  }
	  if (globals.Reflect.defineProperty) {
	    if (!valueOrFalseIfThrows(function () {
	      var basic = !globals.Reflect.defineProperty(1, 'test', { value: 1 });
	      // "extensible" fails on Edge 0.12
	      var extensible = typeof Object.preventExtensions !== 'function' || !globals.Reflect.defineProperty(Object.preventExtensions({}), 'test', {});
	      return basic && extensible;
	    })) {
	      overrideNative(globals.Reflect, 'defineProperty', ReflectShims.defineProperty);
	    }
	  }
	  if (globals.Reflect.construct) {
	    if (!valueOrFalseIfThrows(function () {
	      var F = function F() {};
	      return globals.Reflect.construct(function () {}, [], F) instanceof F;
	    })) {
	      overrideNative(globals.Reflect, 'construct', ReflectShims.construct);
	    }
	  }
	
	  if (String(new Date(NaN)) !== 'Invalid Date') {
	    var dateToString = Date.prototype.toString;
	    var shimmedDateToString = function toString() {
	      var valueOf = +this;
	      if (valueOf !== valueOf) {
	        return 'Invalid Date';
	      }
	      return ES.Call(dateToString, this);
	    };
	    overrideNative(Date.prototype, 'toString', shimmedDateToString);
	  }
	
	  // Annex B HTML methods
	  // http://www.ecma-international.org/ecma-262/6.0/#sec-additional-properties-of-the-string.prototype-object
	  var stringHTMLshims = {
	    anchor: function anchor(name) { return ES.CreateHTML(this, 'a', 'name', name); },
	    big: function big() { return ES.CreateHTML(this, 'big', '', ''); },
	    blink: function blink() { return ES.CreateHTML(this, 'blink', '', ''); },
	    bold: function bold() { return ES.CreateHTML(this, 'b', '', ''); },
	    fixed: function fixed() { return ES.CreateHTML(this, 'tt', '', ''); },
	    fontcolor: function fontcolor(color) { return ES.CreateHTML(this, 'font', 'color', color); },
	    fontsize: function fontsize(size) { return ES.CreateHTML(this, 'font', 'size', size); },
	    italics: function italics() { return ES.CreateHTML(this, 'i', '', ''); },
	    link: function link(url) { return ES.CreateHTML(this, 'a', 'href', url); },
	    small: function small() { return ES.CreateHTML(this, 'small', '', ''); },
	    strike: function strike() { return ES.CreateHTML(this, 'strike', '', ''); },
	    sub: function sub() { return ES.CreateHTML(this, 'sub', '', ''); },
	    sup: function sub() { return ES.CreateHTML(this, 'sup', '', ''); }
	  };
	  _forEach(Object.keys(stringHTMLshims), function (key) {
	    var method = String.prototype[key];
	    var shouldOverwrite = false;
	    if (ES.IsCallable(method)) {
	      var output = _call(method, '', ' " ');
	      var quotesCount = _concat([], output.match(/"/g)).length;
	      shouldOverwrite = output !== output.toLowerCase() || quotesCount > 2;
	    } else {
	      shouldOverwrite = true;
	    }
	    if (shouldOverwrite) {
	      overrideNative(String.prototype, key, stringHTMLshims[key]);
	    }
	  });
	
	  var JSONstringifiesSymbols = (function () {
	    // Microsoft Edge v0.12 stringifies Symbols incorrectly
	    if (!hasSymbols) { return false; } // Symbols are not supported
	    var stringify = typeof JSON === 'object' && typeof JSON.stringify === 'function' ? JSON.stringify : null;
	    if (!stringify) { return false; } // JSON.stringify is not supported
	    if (typeof stringify(Symbol()) !== 'undefined') { return true; } // Symbols should become `undefined`
	    if (stringify([Symbol()]) !== '[null]') { return true; } // Symbols in arrays should become `null`
	    var obj = { a: Symbol() };
	    obj[Symbol()] = true;
	    if (stringify(obj) !== '{}') { return true; } // Symbol-valued keys *and* Symbol-valued properties should be omitted
	    return false;
	  }());
	  var JSONstringifyAcceptsObjectSymbol = valueOrFalseIfThrows(function () {
	    // Chrome 45 throws on stringifying object symbols
	    if (!hasSymbols) { return true; } // Symbols are not supported
	    return JSON.stringify(Object(Symbol())) === '{}' && JSON.stringify([Object(Symbol())]) === '[{}]';
	  });
	  if (JSONstringifiesSymbols || !JSONstringifyAcceptsObjectSymbol) {
	    var origStringify = JSON.stringify;
	    overrideNative(JSON, 'stringify', function stringify(value) {
	      if (typeof value === 'symbol') { return; }
	      var replacer;
	      if (arguments.length > 1) {
	        replacer = arguments[1];
	      }
	      var args = [value];
	      if (!isArray(replacer)) {
	        var replaceFn = ES.IsCallable(replacer) ? replacer : null;
	        var wrappedReplacer = function (key, val) {
	          var parsedValue = replaceFn ? _call(replaceFn, this, key, val) : val;
	          if (typeof parsedValue !== 'symbol') {
	            if (Type.symbol(parsedValue)) {
	              return assignTo({})(parsedValue);
	            } else {
	              return parsedValue;
	            }
	          }
	        };
	        args.push(wrappedReplacer);
	      } else {
	        // create wrapped replacer that handles an array replacer?
	        args.push(replacer);
	      }
	      if (arguments.length > 2) {
	        args.push(arguments[2]);
	      }
	      return origStringify.apply(this, args);
	    });
	  }
	
	  return globals;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(604)))

/***/ }),
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var kyc_status_badge_component_1 = __webpack_require__(1445);
	var kyc_verification_component_1 = __webpack_require__(1446);
	var results_1 = __webpack_require__(1447);
	__export(__webpack_require__(1446));
	exports.KYC_VERIFICATION_COMPONENTS = [
	    kyc_verification_component_1.KYCVerificationComponent,
	    kyc_status_badge_component_1.KYCStatusBadgeComponent,
	    results_1.KYC_VERIFICATION_RESULTS_COMPONENTS
	];


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var kyc_verification_1 = __webpack_require__(1153);
	var KYCStatusBadgeComponent = (function () {
	    function KYCStatusBadgeComponent() {
	        this.explanation = null;
	        this.statusType = kyc_verification_1.KYCStatusResult;
	    }
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], KYCStatusBadgeComponent.prototype, "status", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], KYCStatusBadgeComponent.prototype, "explanation", void 0);
	    KYCStatusBadgeComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-kyc-status-badge',
	            template: "\n        <ng-container [ngSwitch]=\"status\">\n            <span *ngSwitchCase=\"statusType.CLEAR\" class=\"label label-success\">\n                <small *ngIf=\"explanation\" class=\"explanation\">{{ explanation }}</small>\n                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.CLEAR' | translate }}\n            </span>\n            <span *ngSwitchCase=\"statusType.AML_FOUND\" class=\"label label-danger\">\n                <small *ngIf=\"explanation\" class=\"explanation\">{{ explanation }}</small>\n                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.AML_FOUND' | translate }}\n            </span>\n            <span *ngSwitchCase=\"statusType.NOT_VERIFIED\" class=\"label label-default\">\n                <small *ngIf=\"explanation\" class=\"explanation\">{{ explanation }}</small>\n                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.NOT_VERIFIED' | translate }}\n            </span>\n            <span *ngSwitchCase=\"statusType.IN_PROGRESS\" class=\"label label-info\">\n                <small *ngIf=\"explanation\" class=\"explanation\">{{ explanation }}</small>\n                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.IN_PROGRESS' | translate }}\n            </span>\n            <span *ngSwitchCase=\"statusType.INVALID\" class=\"label label-warning\">\n                <small *ngIf=\"explanation\" class=\"explanation\">{{ explanation }}</small>\n                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.INVALID' | translate }}\n            </span>\n            <span *ngSwitchCase=\"statusType.INCOMPLETE_DATA\" class=\"label label-danger\">\n                <small *ngIf=\"explanation\" class=\"explanation\">{{ explanation }}</small>\n                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.INCOMPLETE_DATA' | translate }}\n            </span>\n        </ng-container>\n    ",
	            styles: ["\n        .explanation {\n            color: #ffffff;\n        }\n    "]
	        })
	    ], KYCStatusBadgeComponent);
	    return KYCStatusBadgeComponent;
	}());
	exports.KYCStatusBadgeComponent = KYCStatusBadgeComponent;


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var kyc_verification_1 = __webpack_require__(1153);
	var kyc_service_1 = __webpack_require__(1338);
	var router_1 = __webpack_require__(270);
	var Observable_1 = __webpack_require__(206);
	var api_1 = __webpack_require__(1331);
	var utils_1 = __webpack_require__(740);
	var option_dialog_1 = __webpack_require__(1317);
	var lodash_1 = __webpack_require__(268);
	var KYCVerificationComponent = (function () {
	    function KYCVerificationComponent(_kycService, _activatedRoute, _fileDownloadService, _customerProfileService) {
	        this._kycService = _kycService;
	        this._activatedRoute = _activatedRoute;
	        this._fileDownloadService = _fileDownloadService;
	        this._customerProfileService = _customerProfileService;
	        this.loading = false;
	        this.kycStatusResult = kyc_verification_1.KYCStatusResult;
	    }
	    KYCVerificationComponent_1 = KYCVerificationComponent;
	    KYCVerificationComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._activatedRoute.parent.parent.params.subscribe(function (params) {
	            _this.loading = true;
	            _this.profileId = +params['id'];
	            _this.checkProfileState();
	            _this._kycService.getAOB(_this.profileId).subscribe(function (response) {
	                var values = response.replace("; ;", ";").split(";");
	                var cra = '';
	                _this.craValid = true;
	                if (values.length === 0) {
	                    _this.craValid = false;
	                }
	                if (values.length === 3) {
	                    cra = values[1];
	                    _this.craValid = false;
	                }
	                if (values.length === 2) {
	                    _this.craValid = true;
	                }
	                _this.AOBStatus = "Documents: " + values[0] + ", CRA: " + cra + ", POA: " + values[values.length - 1];
	                _this.loading = false;
	            });
	        });
	    };
	    KYCVerificationComponent.prototype.checkCRA = function () {
	        return !this.craValid;
	    };
	    KYCVerificationComponent.prototype.checkProfileState = function () {
	        var _this = this;
	        this._customerProfileService.searchCustomerProfileById(this.profileId)
	            .subscribe(function (res) {
	            _this.profileStatus = res.state;
	            if (res.amlReasons && res.amlReasons.length > 0 && res.amlReasons[0] !== '') {
	                _this.amlReasons = res.amlReasons;
	            }
	            _this.amlPepDetails = res.amlPepDetails;
	            _this.profileType = res.type;
	        });
	    };
	    KYCVerificationComponent.prototype.isAOBVerified = function () {
	        return this.AOBStatus != null;
	    };
	    KYCVerificationComponent.prototype.hasAmlErrors = function () {
	        return !lodash_1.isEmpty(this.amlReasons) || !lodash_1.isEmpty(this.amlPepDetails);
	    };
	    KYCVerificationComponent.prototype.isPrivate = function () {
	        switch (this.profileType) {
	            case 1:
	                return true;
	            case 2:
	                return false;
	        }
	    };
	    KYCVerificationComponent.prototype.onClickButton = function () {
	        this.verifyClientProfile();
	    };
	    KYCVerificationComponent.prototype.downloadCRAFile = function () {
	        this._fileDownloadService.downloadCRAFile(this.profileId, 'CRA_' + this.profileId).subscribe(function (response) {
	            utils_1.FileUtils.saveFile(utils_1.FileUtils.getFilename(response), response.blob());
	        });
	    };
	    KYCVerificationComponent.prototype.downloadReport = function () {
	        this._fileDownloadService.downloadNeocheckReport(this.profileId).subscribe(function (response) {
	            utils_1.FileUtils.saveFile(utils_1.FileUtils.getFilename(response), response.blob());
	        });
	    };
	    KYCVerificationComponent.prototype.kycApproved = function () {
	        var _this = this;
	        var kycApproval = function (reason) {
	            _this._kycService.saveReason(_this.profileId, reason)
	                .subscribe(function (error) {
	                throw error;
	            });
	        };
	        this.reasonDialog
	            .showInputDialog({ id: 'reason-dialog', title: 'TRANSFERS.DIALOG.REJECT' })
	            .onConfirmAction(function (reason) { return kycApproval(reason); });
	    };
	    KYCVerificationComponent.prototype.isUpdateButton = function () {
	        return (this.profileStatusResult == this.kycStatusResult.AML_FOUND
	            || this.profileStatusResult == this.kycStatusResult.CLEAR
	            || this.profileStatusResult == this.kycStatusResult.INCOMPLETE_DATA);
	    };
	    KYCVerificationComponent.prototype.isNotVerified = function () {
	        return this.profileStatusResult == kyc_verification_1.KYCStatusResult.NOT_VERIFIED;
	    };
	    KYCVerificationComponent.prototype.verifyClientProfile = function () {
	        var _this = this;
	        this.loading = true;
	        this._kycService
	            .verifyOrUpdateProfile(this.profileId)
	            .subscribe(function (_) { return _this.fetchCompletedVerificationResults(); }, function (error) {
	            throw error;
	        });
	    };
	    KYCVerificationComponent.prototype.fetchVerificationResults = function () {
	        var _this = this;
	        this.loading = true;
	        this.httpDetailsSubscription = Observable_1.Observable
	            .interval(1000 * 7)
	            .takeWhile(function () { return _this.loading; })
	            .subscribe(function (_) {
	            _this._kycService.getResult(_this.profileId)
	                .subscribe(function (results) {
	                var isVerificationInProgress = KYCVerificationComponent_1.checkIsVerificationInProgress(results);
	                if (!isVerificationInProgress) {
	                    _this.kycProfile = results;
	                    _this.loading = false;
	                    _this.profileStatusResult = results.summary_status.result;
	                    return;
	                }
	            });
	        });
	    };
	    KYCVerificationComponent.prototype.fetchCompletedVerificationResults = function () {
	        var _this = this;
	        this.loading = true;
	        this.httpDetailsSubscription = Observable_1.Observable
	            .interval(1000 * 7)
	            .takeWhile(function () { return _this.loading; })
	            .subscribe(function (_) {
	            _this._kycService.getResult(_this.profileId)
	                .subscribe(function (results) {
	                var isVerificationComplete = KYCVerificationComponent_1.checkIsVerificationComplete(results);
	                if (isVerificationComplete) {
	                    _this.kycProfile = results;
	                    _this.loading = false;
	                    _this.profileStatusResult = results.summary_status.result;
	                    return;
	                }
	            });
	        });
	    };
	    KYCVerificationComponent.checkIsVerificationComplete = function (profile) {
	        var summaryStatusResult = profile.summary_status.result;
	        return summaryStatusResult.toString() !== kyc_verification_1.KYCStatusResult.NOT_VERIFIED.toString() && summaryStatusResult.toString() !== kyc_verification_1.KYCStatusResult.IN_PROGRESS.toString();
	    };
	    KYCVerificationComponent.checkIsVerificationInProgress = function (profile) {
	        var summaryStatusResult = profile.summary_status.result;
	        return summaryStatusResult.toString() === kyc_verification_1.KYCStatusResult.IN_PROGRESS.toString();
	    };
	    __decorate([
	        option_dialog_1.InjectOptionDialog('reason-dialog'),
	        __metadata("design:type", Object)
	    ], KYCVerificationComponent.prototype, "reasonDialog", void 0);
	    KYCVerificationComponent = KYCVerificationComponent_1 = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-kyc-verification',
	            template: "\n        <loading-linear [loading]=\"loading\"></loading-linear>\n        <h3>\n            <!--            <button (click)=\"onClickButton()\"-->\n            <!--                    [disabled]=\"profileStatusResult == kycStatusResult.IN_PROGRESS || loading\"-->\n            <!--                    class=\"btn verify-btn-box pull-right btn-primary\"-->\n            <!--                    [ngClass]=\"{'btn-primary': !isUpdateButton(),-->\n            <!--                            'btn-success': isUpdateButton()}\">-->\n            <!--                <ng-container-->\n            <!--                    *ngIf=\"!isUpdateButton()\">{{ 'CUSTOMER.VERIFICATION.VERIFY_BUTTON' | translate }}-->\n            <!--                </ng-container>-->\n            <!--                <ng-container-->\n            <!--                    *ngIf=\"isUpdateButton()\">{{ 'CUSTOMER.VERIFICATION.UPDATE_BUTTON' | translate }}-->\n            <!--                </ng-container>-->\n            <!--            </button>-->\n\n\n            <!--            <button (click)=\"downloadCRAFile()\"-->\n            <!--                    class=\"btn verify-btn-box pull-right btn-primary\">-->\n\n            <!--                <ng-container>{{ 'CUSTOMER.VERIFICATION.KYC.CAR' | translate }}-->\n            <!--                </ng-container>-->\n            <!--            </button>-->\n\n            <button (click)=\"downloadReport()\"\n                    class=\"btn verify-btn-box pull-right btn-primary\">\n\n                <ng-container>REPORT\n                </ng-container>\n            </button>\n\n            <!--            <div *ngIf=\"profileStatus === 'M' || profileStatus === 'O'\">-->\n            <!--                <button (click)=\"kycApproved()\"-->\n            <!--                        [disabled]=\"checkCRA()\"-->\n            <!--                        class=\"btn verify-btn-box pull-right btn-primary\">-->\n\n            <!--                    <ng-container>KYC Approved-->\n            <!--                    </ng-container>-->\n            <!--                </button>-->\n            <!--            </div>-->\n\n            {{ 'CUSTOMER.VERIFICATION.KYC.TITLE' | translate }}\n\n            <tfl-bo-kyc-status-badge\n                    explanation=\"{{ 'CUSTOMER.VERIFICATION.KYC.OVERALL' | translate }}\"\n                    [status]=\"profileStatusResult\"\n                    class=\"pull-right\">\n            </tfl-bo-kyc-status-badge>\n        </h3>\n\n        <hr/>\n\n        <div class=\"row\" *ngIf=\"hasAmlErrors()\">\n            {{ 'CUSTOMER.VERIFICATION.AML.TITLE' | translate }}\n            <div *ngIf=\"amlReasons\">\n                {{ 'CUSTOMER.VERIFICATION.AML.AML_REASON_FIELDS' | translate }}\n                <ul id=\"reasons\" style=\"list-style-type: disc\">\n                    <li *ngFor=\"let reason of amlReasons\">\n                        {{ reason }}\n                    </li>\n                </ul>\n            </div>\n            <div>\n                <div *ngIf=\"isPrivate() && amlPepDetails\">\n                    {{ 'CUSTOMER.VERIFICATION.AML.AML_DETAILS_PEP' | translate }}\n                    <ul id=\"details\" style=\"list-style-type: circle\">\n                        <li *ngFor=\"let details of amlPepDetails[0]?.amlPepDetailsList\">\n                            {{ details }} <br>\n                        </li>\n                    </ul>\n                </div>\n                <ul id=\"pepDetails\" style=\"list-style-type: circle\" *ngIf=\"!isPrivate() && amlPepDetails\">\n                    <li *ngFor=\"let pep of amlPepDetails\">\n                        {{ pep.name }} <br>\n                        {{ pep.type }} <br>\n                        <ul id=\"details\" style=\"list-style-type: square\">\n                            <li *ngFor=\"let details of pep.amlPepDetailsList\">\n                                {{ details }} <br>\n                            </li>\n                        </ul>\n                    </li>\n                </ul>\n            </div>\n        </div>\n\n        <div *ngIf=\"isAOBVerified()\" class=\"row\">\n            <div class=\"col-xs-12\">\n                <h3 class=\"text-center\">\n                    {{ AOBStatus }}\n                </h3>\n            </div>\n        </div>\n        <div *ngIf=\"isNotVerified()\" class=\"row\">\n            <div class=\"col-xs-12\">\n                <h3 class=\"text-center\">\n                    {{ 'CUSTOMER.VERIFICATION.KYC.EMPTY_PROFILE' | translate }}\n                </h3>\n            </div>\n        </div>\n        <tfl-bo-kyc-results-corporate\n                *ngIf=\"kycProfile?.corporate_profile\"\n                [results]=\"kycProfile.corporate_profile\"\n                [summaryStatus]=\"kycProfile.summary_status\">\n        </tfl-bo-kyc-results-corporate>\n        <tfl-bo-kyc-results-private\n                *ngIf=\"kycProfile?.private_profile\"\n                [results]=\"kycProfile.private_profile\"\n                [summaryStatus]=\"kycProfile.summary_status\">\n        </tfl-bo-kyc-results-private>\n    "
	        }),
	        __metadata("design:paramtypes", [kyc_service_1.KycService,
	            router_1.ActivatedRoute,
	            api_1.FileDownloadService,
	            api_1.CustomerProfileService])
	    ], KYCVerificationComponent);
	    return KYCVerificationComponent;
	    var KYCVerificationComponent_1;
	}());
	exports.KYCVerificationComponent = KYCVerificationComponent;


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var kyc_results_block_component_1 = __webpack_require__(1448);
	var kyc_results_corporate_component_1 = __webpack_require__(1449);
	var kyc_results_private_component_1 = __webpack_require__(1450);
	exports.KYC_VERIFICATION_RESULTS_COMPONENTS = [
	    kyc_results_corporate_component_1.KYCResultsCorporateComponent,
	    kyc_results_private_component_1.KYCResultsPrivateComponent,
	    kyc_results_block_component_1.KycResultsBlockComponent
	];


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var util_1 = __webpack_require__(743);
	var constants_1 = __webpack_require__(861);
	var KycResultsBlockComponent = (function () {
	    function KycResultsBlockComponent() {
	        this.profileBadge = false;
	        this.PROFILE_TYPE = constants_1.PROFILE_TYPE;
	    }
	    KycResultsBlockComponent.prototype.ngOnInit = function () {
	        if (this.result) {
	            this.profileType = this.getProfileType();
	            this.initFields();
	        }
	    };
	    KycResultsBlockComponent.prototype.getDetailsLink = function () {
	        var profile = this.result.person || this.result.company;
	        return profile.link || '';
	    };
	    KycResultsBlockComponent.prototype.initFields = function () {
	        if (this.profileType == constants_1.PROFILE_TYPE.CORPORATE) {
	            this.fields = [
	                { translateKey: 'COMPANY_NAME', value: this.result.company.name },
	                { translateKey: 'REG_NUMBER', value: this.result.company.registration_number },
	                { translateKey: 'COMPANY_TYPE', value: this.result.company.type },
	                { translateKey: 'REG_OFFICE_COUNTRY', value: this.result.company.registered_office_country },
	                { translateKey: 'VERIFICATION_DATE', value: this.result.status.verification_date }
	            ];
	        }
	        if (this.profileType == constants_1.PROFILE_TYPE.PRIVATE) {
	            this.fields = [
	                { translateKey: 'FIRST_NAME', value: this.result.person.first_name },
	                { translateKey: 'DOB', value: this.result.person.dob },
	                { translateKey: 'LAST_NAME', value: this.result.person.last_name },
	                { translateKey: 'NATIONALITY', value: this.result.person.nationality },
	                { translateKey: 'VERIFICATION_DATE', value: this.result.status.verification_date },
	                { translateKey: 'ADDRESS', value: this.result.person.address }
	            ];
	        }
	    };
	    KycResultsBlockComponent.prototype.getProfileType = function () {
	        return !util_1.isNullOrUndefined(this.result.company) ? this.PROFILE_TYPE.CORPORATE :
	            !util_1.isNullOrUndefined(this.result.person) ? this.PROFILE_TYPE.PRIVATE : undefined;
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], KycResultsBlockComponent.prototype, "title", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], KycResultsBlockComponent.prototype, "result", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], KycResultsBlockComponent.prototype, "profileBadge", void 0);
	    KycResultsBlockComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-kyc-results-block',
	            host: { 'class': 'verification-results-block' },
	            template: "\n        <div class=\"row\">\n            <div class=\"col-sm-12\">\n                <div class=\"x_panel\">\n\n                    <div class=\"x_title\">\n                        <h4>{{ title }}\n                            <ng-container *ngIf=\"profileBadge\" [ngSwitch]=\"profileType\">\n                                <span *ngSwitchCase=\"PROFILE_TYPE.CORPORATE\"\n                                      class=\"label label-primary\">\n                                    {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.CORPORATE' | translate }}\n                                </span>\n                                <span *ngSwitchCase=\"PROFILE_TYPE.PRIVATE\"\n                                      class=\"label label-success\">\n                                    {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.INDIVIDUAL' | translate }}\n                                </span>\n                            </ng-container>\n                        </h4>\n\n                        <tfl-bo-kyc-status-badge\n                            *ngIf=\"result\"\n                            [status]=\"result.status.result\">\n                        </tfl-bo-kyc-status-badge>\n                    </div>\n\n                    <div *ngIf=\"fields\" class=\"x_content\">\n                        <div class=\"row\">\n                            <div *ngFor=\"let field of fields\" class=\"col-xs-12 col-md-6\">\n                                <div class=\"row\">\n                                    <div class=\"col-xs-6 result-field-title\">\n                                        {{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.' + field.translateKey | translate }}:\n                                    </div>\n                                    <div class=\"col-xs-6\">{{ field.value }}</div>\n                                </div>\n                            </div>\n                        </div>\n                        <a [href]=\"getDetailsLink()\" class=\"result-details-link\" target=\"_blank\">\n                            {{ 'CUSTOMER.VERIFICATION.BLOCK.DETAILS' | translate }}\n                        </a>\n                    </div>\n\n                    <div *ngIf=\"!fields\" class=\"verification-results-block-inner\">\n                        <ng-content></ng-content>\n                    </div>\n                </div>\n            </div>\n        </div>\n    "
	        })
	    ], KycResultsBlockComponent);
	    return KycResultsBlockComponent;
	}());
	exports.KycResultsBlockComponent = KycResultsBlockComponent;


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var KYCResultsCorporateComponent = (function () {
	    function KYCResultsCorporateComponent() {
	    }
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], KYCResultsCorporateComponent.prototype, "results", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], KYCResultsCorporateComponent.prototype, "summaryStatus", void 0);
	    KYCResultsCorporateComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-kyc-results-corporate',
	            template: "\n        <tfl-bo-kyc-results-block\n            title=\"{{ 'CUSTOMER.VERIFICATION.BLOCK.TITLE.COMPANY' | translate }}\"\n            [result]=\"{status: results.company_status, company: results.company}\">\n        </tfl-bo-kyc-results-block>\n\n        <tfl-bo-kyc-results-block\n            *ngFor=\"let signatory of results.signatories\"\n                title=\"{{ 'CUSTOMER.VERIFICATION.BLOCK.TITLE.SIGNATORY' | translate }}\"\n                [result]=\"signatory\">\n        </tfl-bo-kyc-results-block>\n\n        <tfl-bo-kyc-results-block\n            title=\"{{ 'CUSTOMER.VERIFICATION.BLOCK.TITLE.DIRECTORS' | translate }}\">\n            <tfl-bo-kyc-results-block\n                *ngFor=\"let item of results.directors; let i=index;\"\n                [profileBadge]=\"true\"\n                title=\"{{ 'CUSTOMER.VERIFICATION.BLOCK.TITLE.DIRECTOR' | translate }} {{i + 1}}\"\n                [result]=\"item\">\n            </tfl-bo-kyc-results-block>\n        </tfl-bo-kyc-results-block>\n\n        <tfl-bo-kyc-results-block\n            title=\"{{ 'CUSTOMER.VERIFICATION.BLOCK.TITLE.SHAREHOLDERS' | translate }}\">\n            <tfl-bo-kyc-results-block\n                *ngFor=\"let item of results.shareholders; let i=index;\"\n                [profileBadge]=\"true\"\n                title=\"{{ 'CUSTOMER.VERIFICATION.BLOCK.TITLE.SHAREHOLDER' | translate }} {{i + 1}}\"\n                [result]=\"item\">\n            </tfl-bo-kyc-results-block>\n        </tfl-bo-kyc-results-block>\n    "
	        })
	    ], KYCResultsCorporateComponent);
	    return KYCResultsCorporateComponent;
	}());
	exports.KYCResultsCorporateComponent = KYCResultsCorporateComponent;


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var KYCResultsPrivateComponent = (function () {
	    function KYCResultsPrivateComponent() {
	    }
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], KYCResultsPrivateComponent.prototype, "results", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], KYCResultsPrivateComponent.prototype, "summaryStatus", void 0);
	    KYCResultsPrivateComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-kyc-results-private',
	            template: "\n        <tfl-bo-kyc-results-block\n            title=\"{{ 'CUSTOMER.VERIFICATION.BLOCK.TITLE.PROFILE' | translate }}\"\n            [result]=\"{status: summaryStatus, person: results.person}\">\n        </tfl-bo-kyc-results-block>\n    "
	        })
	    ], KYCResultsPrivateComponent);
	    return KYCResultsPrivateComponent;
	}());
	exports.KYCResultsPrivateComponent = KYCResultsPrivateComponent;


/***/ }),
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1470));


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var material_1 = __webpack_require__(1471);
	var components_1 = __webpack_require__(1476);
	var service_1 = __webpack_require__(1332);
	var core_2 = __webpack_require__(252);
	var common_1 = __webpack_require__(246);
	var forms_1 = __webpack_require__(768);
	var shared_1 = __webpack_require__(918);
	var customer_email_service_1 = __webpack_require__(1532);
	var progress_spinner_1 = __webpack_require__(1552);
	var range_radio_group_1 = __webpack_require__(1553);
	var funds_information_1 = __webpack_require__(1556);
	var expected_turnover_1 = __webpack_require__(1559);
	var business_categories_1 = __webpack_require__(1562);
	var chosen_category_service_1 = __webpack_require__(1083);
	var ngx_clipboard_1 = __webpack_require__(1574);
	var CustomerProfilesSharedModule = (function () {
	    function CustomerProfilesSharedModule() {
	    }
	    CustomerProfilesSharedModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                forms_1.FormsModule,
	                forms_1.ReactiveFormsModule,
	                common_1.CommonModule,
	                core_2.TranslateModule,
	                material_1.MatMenuModule,
	                shared_1.SharedModule,
	                progress_spinner_1.MatProgressSpinnerModule,
	                material_1.MatExpansionModule,
	                ngx_clipboard_1.ClipboardModule
	            ],
	            declarations: components_1.PROFILE_SHARED_COMPONENTS.concat(range_radio_group_1.RANGE_RADIO_GROUP_COMPONENTS, funds_information_1.FUNDS_INFORMATION_COMPONENTS, expected_turnover_1.EXPECTED_TURNOVER_COMPONENTS, business_categories_1.BUSINESS_TYPE_CATEGORIES),
	            providers: [
	                service_1.CustomerProfileService,
	                service_1.KycService,
	                service_1.OnfidoService,
	                service_1.IntegrationModuleService,
	                service_1.AriadnextService,
	                customer_email_service_1.CustomerEmailService,
	                chosen_category_service_1.ChosenCategoryService,
	            ],
	            exports: components_1.PROFILE_SHARED_COMPONENTS.concat(range_radio_group_1.RANGE_RADIO_GROUP_COMPONENTS, funds_information_1.FUNDS_INFORMATION_COMPONENTS, expected_turnover_1.EXPECTED_TURNOVER_COMPONENTS, business_categories_1.BUSINESS_TYPE_CATEGORIES)
	        })
	    ], CustomerProfilesSharedModule);
	    return CustomerProfilesSharedModule;
	}());
	exports.CustomerProfilesSharedModule = CustomerProfilesSharedModule;


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(1076), __webpack_require__(1077), __webpack_require__(240), __webpack_require__(206), __webpack_require__(247), __webpack_require__(246), __webpack_require__(1078), __webpack_require__(1079), __webpack_require__(1081), __webpack_require__(1308), __webpack_require__(1310), __webpack_require__(298), __webpack_require__(263), __webpack_require__(256), __webpack_require__(449), __webpack_require__(433), __webpack_require__(768), __webpack_require__(327), __webpack_require__(594), __webpack_require__(250), __webpack_require__(318), __webpack_require__(222), __webpack_require__(253), __webpack_require__(1304), __webpack_require__(1082), __webpack_require__(211), __webpack_require__(490), __webpack_require__(620), __webpack_require__(1472), __webpack_require__(284), __webpack_require__(465), __webpack_require__(254), __webpack_require__(237), __webpack_require__(852), __webpack_require__(323), __webpack_require__(368), __webpack_require__(1473), __webpack_require__(1309), __webpack_require__(428), __webpack_require__(1474), __webpack_require__(1475), __webpack_require__(271), __webpack_require__(314), __webpack_require__(321)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@angular/cdk/bidi', '@angular/cdk/coercion', 'rxjs/Subject', 'rxjs/Observable', '@angular/platform-browser', '@angular/common', '@angular/cdk/platform', '@angular/cdk/keycodes', '@angular/cdk/a11y', '@angular/cdk/overlay', '@angular/cdk/portal', 'rxjs/operators/filter', 'rxjs/operators/take', 'rxjs/operators/switchMap', 'rxjs/operators/tap', 'rxjs/operators/delay', '@angular/forms', 'rxjs/observable/fromEvent', 'rxjs/operators/startWith', '@angular/animations', 'rxjs/observable/defer', 'rxjs/observable/merge', 'rxjs/observable/of', '@angular/cdk/collections', '@angular/cdk/observers', 'rxjs/Subscription', 'rxjs/operators/auditTime', 'rxjs/operators/takeUntil', '@angular/cdk/accordion', 'rxjs/operators/catchError', 'rxjs/operators/finalize', 'rxjs/operators/map', 'rxjs/operators/share', '@angular/common/http', 'rxjs/observable/forkJoin', 'rxjs/observable/throw', '@angular/cdk/layout', '@angular/cdk/scrolling', 'rxjs/operators/debounceTime', '@angular/cdk/table', '@angular/cdk/stepper', 'rxjs/BehaviorSubject', 'rxjs/operators/combineLatest', 'rxjs/observable/empty'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.material = global.ng.material || {}),global.ng.core,global.ng.cdk.bidi,global.ng.cdk.coercion,global.Rx,global.Rx,global.ng.platformBrowser,global.ng.common,global.ng.cdk.platform,global.ng.cdk.keycodes,global.ng.cdk.a11y,global.ng.cdk.overlay,global.ng.cdk.portal,global.Rx.operators,global.Rx.operators,global.Rx.operators,global.Rx.operators,global.Rx.operators,global.ng.forms,global.Rx.Observable,global.Rx.operators,global.ng.animations,global.Rx.Observable,global.Rx.Observable,global.Rx.Observable,global.ng.cdk.collections,global.ng.cdk.observers,global.Rx,global.Rx.operators,global.Rx.operators,global.ng.cdk.accordion,global.Rx.operators,global.Rx.operators,global.Rx.operators,global.Rx.operators,global.ng.common.http,global.Rx.Observable,global.Rx.Observable,global.ng.cdk.layout,global.ng.cdk.scrolling,global.Rx.operators,global.ng.cdk.table,global.ng.cdk.stepper,global.Rx,global.Rx.operators,global.Rx.Observable));
	}(this, (function (exports,_angular_core,_angular_cdk_bidi,_angular_cdk_coercion,rxjs_Subject,rxjs_Observable,_angular_platformBrowser,_angular_common,_angular_cdk_platform,_angular_cdk_keycodes,_angular_cdk_a11y,_angular_cdk_overlay,_angular_cdk_portal,rxjs_operators_filter,rxjs_operators_take,rxjs_operators_switchMap,rxjs_operators_tap,rxjs_operators_delay,_angular_forms,rxjs_observable_fromEvent,rxjs_operators_startWith,_angular_animations,rxjs_observable_defer,rxjs_observable_merge,rxjs_observable_of,_angular_cdk_collections,_angular_cdk_observers,rxjs_Subscription,rxjs_operators_auditTime,rxjs_operators_takeUntil,_angular_cdk_accordion,rxjs_operators_catchError,rxjs_operators_finalize,rxjs_operators_map,rxjs_operators_share,_angular_common_http,rxjs_observable_forkJoin,rxjs_observable_throw,_angular_cdk_layout,_angular_cdk_scrolling,rxjs_operators_debounceTime,_angular_cdk_table,_angular_cdk_stepper,rxjs_BehaviorSubject,rxjs_operators_combineLatest,rxjs_observable_empty) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = Object.assign || function __assign(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	    }
	    return t;
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 */
	var AnimationCurves = /** @class */ (function () {
	    function AnimationCurves() {
	    }
	    AnimationCurves.STANDARD_CURVE = 'cubic-bezier(0.4,0.0,0.2,1)';
	    AnimationCurves.DECELERATION_CURVE = 'cubic-bezier(0.0,0.0,0.2,1)';
	    AnimationCurves.ACCELERATION_CURVE = 'cubic-bezier(0.4,0.0,1,1)';
	    AnimationCurves.SHARP_CURVE = 'cubic-bezier(0.4,0.0,0.6,1)';
	    return AnimationCurves;
	}());
	/**
	 * \@docs-private
	 */
	var AnimationDurations = /** @class */ (function () {
	    function AnimationDurations() {
	    }
	    AnimationDurations.COMPLEX = '375ms';
	    AnimationDurations.ENTERING = '225ms';
	    AnimationDurations.EXITING = '195ms';
	    return AnimationDurations;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Injection token that configures whether the Material sanity checks are enabled.
	 */
	var MATERIAL_SANITY_CHECKS = new _angular_core.InjectionToken('mat-sanity-checks');
	/**
	 * Module that captures anything that should be loaded and/or run for *all* Angular Material
	 * components. This includes Bidi, etc.
	 *
	 * This module should be imported to each top-level component module (e.g., MatTabsModule).
	 */
	var MatCommonModule = /** @class */ (function () {
	    function MatCommonModule(_sanityChecksEnabled) {
	        this._sanityChecksEnabled = _sanityChecksEnabled;
	        /**
	         * Whether we've done the global sanity checks (e.g. a theme is loaded, there is a doctype).
	         */
	        this._hasDoneGlobalChecks = false;
	        /**
	         * Whether we've already checked for HammerJs availability.
	         */
	        this._hasCheckedHammer = false;
	        /**
	         * Reference to the global `document` object.
	         */
	        this._document = typeof document === 'object' && document ? document : null;
	        /**
	         * Reference to the global 'window' object.
	         */
	        this._window = typeof window === 'object' && window ? window : null;
	        if (this._areChecksEnabled() && !this._hasDoneGlobalChecks) {
	            this._checkDoctypeIsDefined();
	            this._checkThemeIsPresent();
	            this._hasDoneGlobalChecks = true;
	        }
	    }
	    /**
	     * Whether any sanity checks are enabled
	     * @return {?}
	     */
	    MatCommonModule.prototype._areChecksEnabled = /**
	     * Whether any sanity checks are enabled
	     * @return {?}
	     */
	    function () {
	        return this._sanityChecksEnabled && _angular_core.isDevMode() && !this._isTestEnv();
	    };
	    /**
	     * Whether the code is running in tests.
	     * @return {?}
	     */
	    MatCommonModule.prototype._isTestEnv = /**
	     * Whether the code is running in tests.
	     * @return {?}
	     */
	    function () {
	        return this._window && (this._window['__karma__'] || this._window['jasmine']);
	    };
	    /**
	     * @return {?}
	     */
	    MatCommonModule.prototype._checkDoctypeIsDefined = /**
	     * @return {?}
	     */
	    function () {
	        if (this._document && !this._document.doctype) {
	            console.warn('Current document does not have a doctype. This may cause ' +
	                'some Angular Material components not to behave as expected.');
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatCommonModule.prototype._checkThemeIsPresent = /**
	     * @return {?}
	     */
	    function () {
	        if (this._document && typeof getComputedStyle === 'function') {
	            var /** @type {?} */ testElement = this._document.createElement('div');
	            testElement.classList.add('mat-theme-loaded-marker');
	            this._document.body.appendChild(testElement);
	            var /** @type {?} */ computedStyle = getComputedStyle(testElement);
	            // In some situations, the computed style of the test element can be null. For example in
	            // Firefox, the computed style is null if an application is running inside of a hidden iframe.
	            // See: https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	            if (computedStyle && computedStyle.display !== 'none') {
	                console.warn('Could not find Angular Material core theme. Most Material ' +
	                    'components may not work as expected. For more info refer ' +
	                    'to the theming guide: https://material.angular.io/guide/theming');
	            }
	            this._document.body.removeChild(testElement);
	        }
	    };
	    /** Checks whether HammerJS is available. */
	    /**
	     * Checks whether HammerJS is available.
	     * @return {?}
	     */
	    MatCommonModule.prototype._checkHammerIsAvailable = /**
	     * Checks whether HammerJS is available.
	     * @return {?}
	     */
	    function () {
	        if (this._hasCheckedHammer || !this._window) {
	            return;
	        }
	        if (this._areChecksEnabled() && !this._window['Hammer']) {
	            console.warn('Could not find HammerJS. Certain Angular Material components may not work correctly.');
	        }
	        this._hasCheckedHammer = true;
	    };
	    MatCommonModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [_angular_cdk_bidi.BidiModule],
	                    exports: [_angular_cdk_bidi.BidiModule],
	                    providers: [{
	                            provide: MATERIAL_SANITY_CHECKS, useValue: true,
	                        }],
	                },] },
	    ];
	    /** @nocollapse */
	    MatCommonModule.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MATERIAL_SANITY_CHECKS,] },] },
	    ]; };
	    return MatCommonModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * Mixin to augment a directive with a `disabled` property.
	 * @template T
	 * @param {?} base
	 * @return {?}
	 */
	function mixinDisabled(base) {
	    return /** @class */ (function (_super) {
	        __extends(class_1, _super);
	        function class_1() {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var _this = _super.apply(this, args) || this;
	            _this._disabled = false;
	            return _this;
	        }
	        Object.defineProperty(class_1.prototype, "disabled", {
	            get: /**
	             * @return {?}
	             */
	            function () { return this._disabled; },
	            set: /**
	             * @param {?} value
	             * @return {?}
	             */
	            function (value) { this._disabled = _angular_cdk_coercion.coerceBooleanProperty(value); },
	            enumerable: true,
	            configurable: true
	        });
	        return class_1;
	    }(base));
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * Mixin to augment a directive with a `color` property.
	 * @template T
	 * @param {?} base
	 * @param {?=} defaultColor
	 * @return {?}
	 */
	function mixinColor(base, defaultColor) {
	    return /** @class */ (function (_super) {
	        __extends(class_1, _super);
	        function class_1() {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var _this = _super.apply(this, args) || this;
	            // Set the default color that can be specified from the mixin.
	            // Set the default color that can be specified from the mixin.
	            _this.color = defaultColor;
	            return _this;
	        }
	        Object.defineProperty(class_1.prototype, "color", {
	            get: /**
	             * @return {?}
	             */
	            function () { return this._color; },
	            set: /**
	             * @param {?} value
	             * @return {?}
	             */
	            function (value) {
	                var /** @type {?} */ colorPalette = value || defaultColor;
	                if (colorPalette !== this._color) {
	                    if (this._color) {
	                        this._elementRef.nativeElement.classList.remove("mat-" + this._color);
	                    }
	                    if (colorPalette) {
	                        this._elementRef.nativeElement.classList.add("mat-" + colorPalette);
	                    }
	                    this._color = colorPalette;
	                }
	            },
	            enumerable: true,
	            configurable: true
	        });
	        return class_1;
	    }(base));
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * Mixin to augment a directive with a `disableRipple` property.
	 * @template T
	 * @param {?} base
	 * @return {?}
	 */
	function mixinDisableRipple(base) {
	    return /** @class */ (function (_super) {
	        __extends(class_1, _super);
	        function class_1() {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var _this = _super.apply(this, args) || this;
	            _this._disableRipple = false;
	            return _this;
	        }
	        Object.defineProperty(class_1.prototype, "disableRipple", {
	            /** Whether the ripple effect is disabled or not. */
	            get: /**
	             * Whether the ripple effect is disabled or not.
	             * @return {?}
	             */
	            function () { return this._disableRipple; },
	            set: /**
	             * @param {?} value
	             * @return {?}
	             */
	            function (value) { this._disableRipple = _angular_cdk_coercion.coerceBooleanProperty(value); },
	            enumerable: true,
	            configurable: true
	        });
	        return class_1;
	    }(base));
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * Mixin to augment a directive with a `tabIndex` property.
	 * @template T
	 * @param {?} base
	 * @param {?=} defaultTabIndex
	 * @return {?}
	 */
	function mixinTabIndex(base, defaultTabIndex) {
	    if (defaultTabIndex === void 0) { defaultTabIndex = 0; }
	    return /** @class */ (function (_super) {
	        __extends(class_1, _super);
	        function class_1() {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var _this = _super.apply(this, args) || this;
	            _this._tabIndex = defaultTabIndex;
	            return _this;
	        }
	        Object.defineProperty(class_1.prototype, "tabIndex", {
	            get: /**
	             * @return {?}
	             */
	            function () { return this.disabled ? -1 : this._tabIndex; },
	            set: /**
	             * @param {?} value
	             * @return {?}
	             */
	            function (value) {
	                // If the specified tabIndex value is null or undefined, fall back to the default value.
	                this._tabIndex = value != null ? value : defaultTabIndex;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        return class_1;
	    }(base));
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * Mixin to augment a directive with updateErrorState method.
	 * For component with `errorState` and need to update `errorState`.
	 * @template T
	 * @param {?} base
	 * @return {?}
	 */
	function mixinErrorState(base) {
	    return /** @class */ (function (_super) {
	        __extends(class_1, _super);
	        function class_1() {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var _this = _super.apply(this, args) || this;
	            /**
	             * Whether the component is in an error state.
	             */
	            _this.errorState = false;
	            /**
	             * Stream that emits whenever the state of the input changes such that the wrapping
	             * `MatFormField` needs to run change detection.
	             */
	            _this.stateChanges = new rxjs_Subject.Subject();
	            return _this;
	        }
	        /**
	         * @return {?}
	         */
	        class_1.prototype.updateErrorState = /**
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ oldState = this.errorState;
	            var /** @type {?} */ parent = this._parentFormGroup || this._parentForm;
	            var /** @type {?} */ matcher = this.errorStateMatcher || this._defaultErrorStateMatcher;
	            var /** @type {?} */ control = this.ngControl ? /** @type {?} */ (this.ngControl.control) : null;
	            var /** @type {?} */ newState = matcher.isErrorState(control, parent);
	            if (newState !== oldState) {
	                this.errorState = newState;
	                this.stateChanges.next();
	            }
	        };
	        return class_1;
	    }(base));
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Mixin that adds an initialized property to a directive which, when subscribed to, will emit a
	 * value once markInitialized has been called, which should be done during the ngOnInit function.
	 * If the subscription is made after it has already been marked as initialized, then it will trigger
	 * an emit immediately.
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * Mixin to augment a directive with an initialized property that will emits when ngOnInit ends.
	 * @template T
	 * @param {?} base
	 * @return {?}
	 */
	function mixinInitialized(base) {
	    return /** @class */ (function (_super) {
	        __extends(class_1, _super);
	        function class_1() {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var _this = _super.apply(this, args) || this;
	            /**
	             * Whether this directive has been marked as initialized.
	             */
	            _this._isInitialized = false;
	            /**
	             * List of subscribers that subscribed before the directive was initialized. Should be notified
	             * during _markInitialized. Set to null after pending subscribers are notified, and should
	             * not expect to be populated after.
	             */
	            _this._pendingSubscribers = [];
	            /**
	             * Observable stream that emits when the directive initializes. If already initialized, the
	             * subscriber is stored to be notified once _markInitialized is called.
	             */
	            _this.initialized = new rxjs_Observable.Observable(function (subscriber) {
	                // If initialized, immediately notify the subscriber. Otherwise store the subscriber to notify
	                // when _markInitialized is called.
	                if (_this._isInitialized) {
	                    _this._notifySubscriber(subscriber);
	                }
	                else {
	                    /** @type {?} */ ((_this._pendingSubscribers)).push(subscriber);
	                }
	            });
	            return _this;
	        }
	        /**
	         * Marks the state as initialized and notifies pending subscribers. Should be called at the end
	         * of ngOnInit.
	         * @docs-private
	         */
	        /**
	         * Marks the state as initialized and notifies pending subscribers. Should be called at the end
	         * of ngOnInit.
	         * \@docs-private
	         * @return {?}
	         */
	        class_1.prototype._markInitialized = /**
	         * Marks the state as initialized and notifies pending subscribers. Should be called at the end
	         * of ngOnInit.
	         * \@docs-private
	         * @return {?}
	         */
	        function () {
	            if (this._isInitialized) {
	                throw Error('This directive has already been marked as initialized and ' +
	                    'should not be called twice.');
	            }
	            this._isInitialized = true; /** @type {?} */
	            ((this._pendingSubscribers)).forEach(this._notifySubscriber);
	            this._pendingSubscribers = null;
	        };
	        /** Emits and completes the subscriber stream (should only emit once). */
	        /**
	         * Emits and completes the subscriber stream (should only emit once).
	         * @param {?} subscriber
	         * @return {?}
	         */
	        class_1.prototype._notifySubscriber = /**
	         * Emits and completes the subscriber stream (should only emit once).
	         * @param {?} subscriber
	         * @return {?}
	         */
	        function (subscriber) {
	            subscriber.next();
	            subscriber.complete();
	        };
	        return class_1;
	    }(base));
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * InjectionToken for datepicker that can be used to override default locale code.
	 */
	var MAT_DATE_LOCALE = new _angular_core.InjectionToken('MAT_DATE_LOCALE');
	/**
	 * Provider for MAT_DATE_LOCALE injection token.
	 */
	var MAT_DATE_LOCALE_PROVIDER = { provide: MAT_DATE_LOCALE, useExisting: _angular_core.LOCALE_ID };
	/**
	 * Adapts type `D` to be usable as a date by cdk-based components that work with dates.
	 * @abstract
	 */
	var DateAdapter = /** @class */ (function () {
	    function DateAdapter() {
	        this._localeChanges = new rxjs_Subject.Subject();
	    }
	    Object.defineProperty(DateAdapter.prototype, "localeChanges", {
	        /** A stream that emits when the locale changes. */
	        get: /**
	         * A stream that emits when the locale changes.
	         * @return {?}
	         */
	        function () { return this._localeChanges; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Attempts to deserialize a value to a valid date object. This is different from parsing in that
	     * deserialize should only accept non-ambiguous, locale-independent formats (e.g. a ISO 8601
	     * string). The default implementation does not allow any deserialization, it simply checks that
	     * the given value is already a valid date object or null. The `<mat-datepicker>` will call this
	     * method on all of it's `@Input()` properties that accept dates. It is therefore possible to
	     * support passing values from your backend directly to these properties by overriding this method
	     * to also deserialize the format used by your backend.
	     * @param value The value to be deserialized into a date object.
	     * @returns The deserialized date object, either a valid date, null if the value can be
	     *     deserialized into a null date (e.g. the empty string), or an invalid date.
	     */
	    /**
	     * Attempts to deserialize a value to a valid date object. This is different from parsing in that
	     * deserialize should only accept non-ambiguous, locale-independent formats (e.g. a ISO 8601
	     * string). The default implementation does not allow any deserialization, it simply checks that
	     * the given value is already a valid date object or null. The `<mat-datepicker>` will call this
	     * method on all of it's `\@Input()` properties that accept dates. It is therefore possible to
	     * support passing values from your backend directly to these properties by overriding this method
	     * to also deserialize the format used by your backend.
	     * @param {?} value The value to be deserialized into a date object.
	     * @return {?} The deserialized date object, either a valid date, null if the value can be
	     *     deserialized into a null date (e.g. the empty string), or an invalid date.
	     */
	    DateAdapter.prototype.deserialize = /**
	     * Attempts to deserialize a value to a valid date object. This is different from parsing in that
	     * deserialize should only accept non-ambiguous, locale-independent formats (e.g. a ISO 8601
	     * string). The default implementation does not allow any deserialization, it simply checks that
	     * the given value is already a valid date object or null. The `<mat-datepicker>` will call this
	     * method on all of it's `\@Input()` properties that accept dates. It is therefore possible to
	     * support passing values from your backend directly to these properties by overriding this method
	     * to also deserialize the format used by your backend.
	     * @param {?} value The value to be deserialized into a date object.
	     * @return {?} The deserialized date object, either a valid date, null if the value can be
	     *     deserialized into a null date (e.g. the empty string), or an invalid date.
	     */
	    function (value) {
	        if (value == null || this.isDateInstance(value) && this.isValid(value)) {
	            return value;
	        }
	        return this.invalid();
	    };
	    /**
	     * Sets the locale used for all dates.
	     * @param locale The new locale.
	     */
	    /**
	     * Sets the locale used for all dates.
	     * @param {?} locale The new locale.
	     * @return {?}
	     */
	    DateAdapter.prototype.setLocale = /**
	     * Sets the locale used for all dates.
	     * @param {?} locale The new locale.
	     * @return {?}
	     */
	    function (locale) {
	        this.locale = locale;
	        this._localeChanges.next();
	    };
	    /**
	     * Compares two dates.
	     * @param first The first date to compare.
	     * @param second The second date to compare.
	     * @returns 0 if the dates are equal, a number less than 0 if the first date is earlier,
	     *     a number greater than 0 if the first date is later.
	     */
	    /**
	     * Compares two dates.
	     * @param {?} first The first date to compare.
	     * @param {?} second The second date to compare.
	     * @return {?} 0 if the dates are equal, a number less than 0 if the first date is earlier,
	     *     a number greater than 0 if the first date is later.
	     */
	    DateAdapter.prototype.compareDate = /**
	     * Compares two dates.
	     * @param {?} first The first date to compare.
	     * @param {?} second The second date to compare.
	     * @return {?} 0 if the dates are equal, a number less than 0 if the first date is earlier,
	     *     a number greater than 0 if the first date is later.
	     */
	    function (first, second) {
	        return this.getYear(first) - this.getYear(second) ||
	            this.getMonth(first) - this.getMonth(second) ||
	            this.getDate(first) - this.getDate(second);
	    };
	    /**
	     * Checks if two dates are equal.
	     * @param first The first date to check.
	     * @param second The second date to check.
	     * @returns Whether the two dates are equal.
	     *     Null dates are considered equal to other null dates.
	     */
	    /**
	     * Checks if two dates are equal.
	     * @param {?} first The first date to check.
	     * @param {?} second The second date to check.
	     * @return {?} Whether the two dates are equal.
	     *     Null dates are considered equal to other null dates.
	     */
	    DateAdapter.prototype.sameDate = /**
	     * Checks if two dates are equal.
	     * @param {?} first The first date to check.
	     * @param {?} second The second date to check.
	     * @return {?} Whether the two dates are equal.
	     *     Null dates are considered equal to other null dates.
	     */
	    function (first, second) {
	        if (first && second) {
	            var /** @type {?} */ firstValid = this.isValid(first);
	            var /** @type {?} */ secondValid = this.isValid(second);
	            if (firstValid && secondValid) {
	                return !this.compareDate(first, second);
	            }
	            return firstValid == secondValid;
	        }
	        return first == second;
	    };
	    /**
	     * Clamp the given date between min and max dates.
	     * @param date The date to clamp.
	     * @param min The minimum value to allow. If null or omitted no min is enforced.
	     * @param max The maximum value to allow. If null or omitted no max is enforced.
	     * @returns `min` if `date` is less than `min`, `max` if date is greater than `max`,
	     *     otherwise `date`.
	     */
	    /**
	     * Clamp the given date between min and max dates.
	     * @param {?} date The date to clamp.
	     * @param {?=} min The minimum value to allow. If null or omitted no min is enforced.
	     * @param {?=} max The maximum value to allow. If null or omitted no max is enforced.
	     * @return {?} `min` if `date` is less than `min`, `max` if date is greater than `max`,
	     *     otherwise `date`.
	     */
	    DateAdapter.prototype.clampDate = /**
	     * Clamp the given date between min and max dates.
	     * @param {?} date The date to clamp.
	     * @param {?=} min The minimum value to allow. If null or omitted no min is enforced.
	     * @param {?=} max The maximum value to allow. If null or omitted no max is enforced.
	     * @return {?} `min` if `date` is less than `min`, `max` if date is greater than `max`,
	     *     otherwise `date`.
	     */
	    function (date, min, max) {
	        if (min && this.compareDate(date, min) < 0) {
	            return min;
	        }
	        if (max && this.compareDate(date, max) > 0) {
	            return max;
	        }
	        return date;
	    };
	    return DateAdapter;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MAT_DATE_FORMATS = new _angular_core.InjectionToken('mat-date-formats');
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Whether the browser supports the Intl API.
	 */
	var SUPPORTS_INTL_API = typeof Intl != 'undefined';
	/**
	 * The default month names to use if Intl API is not available.
	 */
	var DEFAULT_MONTH_NAMES = {
	    'long': [
	        'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
	        'October', 'November', 'December'
	    ],
	    'short': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	    'narrow': ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D']
	};
	var ɵ0$1 = function (i) { return String(i + 1); };
	/**
	 * The default date names to use if Intl API is not available.
	 */
	var DEFAULT_DATE_NAMES = range(31, ɵ0$1);
	/**
	 * The default day of the week names to use if Intl API is not available.
	 */
	var DEFAULT_DAY_OF_WEEK_NAMES = {
	    'long': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	    'short': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	    'narrow': ['S', 'M', 'T', 'W', 'T', 'F', 'S']
	};
	/**
	 * Matches strings that have the form of a valid RFC 3339 string
	 * (https://tools.ietf.org/html/rfc3339). Note that the string may not actually be a valid date
	 * because the regex will match strings an with out of bounds month, date, etc.
	 */
	var ISO_8601_REGEX = /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|(?:(?:\+|-)\d{2}:\d{2}))?)?$/;
	/**
	 * Creates an array and fills it with values.
	 * @template T
	 * @param {?} length
	 * @param {?} valueFunction
	 * @return {?}
	 */
	function range(length, valueFunction) {
	    var /** @type {?} */ valuesArray = Array(length);
	    for (var /** @type {?} */ i = 0; i < length; i++) {
	        valuesArray[i] = valueFunction(i);
	    }
	    return valuesArray;
	}
	/**
	 * Adapts the native JS Date for use with cdk-based components that work with dates.
	 */
	var NativeDateAdapter = /** @class */ (function (_super) {
	    __extends(NativeDateAdapter, _super);
	    function NativeDateAdapter(matDateLocale) {
	        var _this = _super.call(this) || this;
	        _super.prototype.setLocale.call(_this, matDateLocale);
	        // IE does its own time zone correction, so we disable this on IE.
	        // TODO(mmalerba): replace with checks from PLATFORM, logic currently duplicated to avoid
	        // breaking change from injecting the Platform.
	        var /** @type {?} */ isBrowser = typeof document === 'object' && !!document;
	        var /** @type {?} */ isIE = isBrowser && /(msie|trident)/i.test(navigator.userAgent);
	        _this.useUtcForDisplay = !isIE;
	        _this._clampDate = isIE || (isBrowser && /(edge)/i.test(navigator.userAgent));
	        return _this;
	    }
	    /**
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.getYear = /**
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        return date.getFullYear();
	    };
	    /**
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.getMonth = /**
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        return date.getMonth();
	    };
	    /**
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.getDate = /**
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        return date.getDate();
	    };
	    /**
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.getDayOfWeek = /**
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        return date.getDay();
	    };
	    /**
	     * @param {?} style
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.getMonthNames = /**
	     * @param {?} style
	     * @return {?}
	     */
	    function (style$$1) {
	        var _this = this;
	        if (SUPPORTS_INTL_API) {
	            var /** @type {?} */ dtf_1 = new Intl.DateTimeFormat(this.locale, { month: style$$1, timeZone: 'utc' });
	            return range(12, function (i) {
	                return _this._stripDirectionalityCharacters(_this._format(dtf_1, new Date(2017, i, 1)));
	            });
	        }
	        return DEFAULT_MONTH_NAMES[style$$1];
	    };
	    /**
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.getDateNames = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (SUPPORTS_INTL_API) {
	            var /** @type {?} */ dtf_2 = new Intl.DateTimeFormat(this.locale, { day: 'numeric', timeZone: 'utc' });
	            return range(31, function (i) {
	                return _this._stripDirectionalityCharacters(_this._format(dtf_2, new Date(2017, 0, i + 1)));
	            });
	        }
	        return DEFAULT_DATE_NAMES;
	    };
	    /**
	     * @param {?} style
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.getDayOfWeekNames = /**
	     * @param {?} style
	     * @return {?}
	     */
	    function (style$$1) {
	        var _this = this;
	        if (SUPPORTS_INTL_API) {
	            var /** @type {?} */ dtf_3 = new Intl.DateTimeFormat(this.locale, { weekday: style$$1, timeZone: 'utc' });
	            return range(7, function (i) {
	                return _this._stripDirectionalityCharacters(_this._format(dtf_3, new Date(2017, 0, i + 1)));
	            });
	        }
	        return DEFAULT_DAY_OF_WEEK_NAMES[style$$1];
	    };
	    /**
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.getYearName = /**
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        if (SUPPORTS_INTL_API) {
	            var /** @type {?} */ dtf = new Intl.DateTimeFormat(this.locale, { year: 'numeric', timeZone: 'utc' });
	            return this._stripDirectionalityCharacters(this._format(dtf, date));
	        }
	        return String(this.getYear(date));
	    };
	    /**
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.getFirstDayOfWeek = /**
	     * @return {?}
	     */
	    function () {
	        // We can't tell using native JS Date what the first day of the week is, we default to Sunday.
	        return 0;
	    };
	    /**
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.getNumDaysInMonth = /**
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        return this.getDate(this._createDateWithOverflow(this.getYear(date), this.getMonth(date) + 1, 0));
	    };
	    /**
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.clone = /**
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        return this.createDate(this.getYear(date), this.getMonth(date), this.getDate(date));
	    };
	    /**
	     * @param {?} year
	     * @param {?} month
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.createDate = /**
	     * @param {?} year
	     * @param {?} month
	     * @param {?} date
	     * @return {?}
	     */
	    function (year, month, date) {
	        // Check for invalid month and date (except upper bound on date which we have to check after
	        // creating the Date).
	        if (month < 0 || month > 11) {
	            throw Error("Invalid month index \"" + month + "\". Month index has to be between 0 and 11.");
	        }
	        if (date < 1) {
	            throw Error("Invalid date \"" + date + "\". Date has to be greater than 0.");
	        }
	        var /** @type {?} */ result = this._createDateWithOverflow(year, month, date);
	        // Check that the date wasn't above the upper bound for the month, causing the month to overflow
	        if (result.getMonth() != month) {
	            throw Error("Invalid date \"" + date + "\" for month with index \"" + month + "\".");
	        }
	        return result;
	    };
	    /**
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.today = /**
	     * @return {?}
	     */
	    function () {
	        return new Date();
	    };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.parse = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        // We have no way using the native JS Date to set the parse format or locale, so we ignore these
	        // parameters.
	        if (typeof value == 'number') {
	            return new Date(value);
	        }
	        return value ? new Date(Date.parse(value)) : null;
	    };
	    /**
	     * @param {?} date
	     * @param {?} displayFormat
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.format = /**
	     * @param {?} date
	     * @param {?} displayFormat
	     * @return {?}
	     */
	    function (date, displayFormat) {
	        if (!this.isValid(date)) {
	            throw Error('NativeDateAdapter: Cannot format invalid date.');
	        }
	        if (SUPPORTS_INTL_API) {
	            // On IE and Edge the i18n API will throw a hard error that can crash the entire app
	            // if we attempt to format a date whose year is less than 1 or greater than 9999.
	            if (this._clampDate && (date.getFullYear() < 1 || date.getFullYear() > 9999)) {
	                date = this.clone(date);
	                date.setFullYear(Math.max(1, Math.min(9999, date.getFullYear())));
	            }
	            displayFormat = __assign({}, displayFormat, { timeZone: 'utc' });
	            var /** @type {?} */ dtf = new Intl.DateTimeFormat(this.locale, displayFormat);
	            return this._stripDirectionalityCharacters(this._format(dtf, date));
	        }
	        return this._stripDirectionalityCharacters(date.toDateString());
	    };
	    /**
	     * @param {?} date
	     * @param {?} years
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.addCalendarYears = /**
	     * @param {?} date
	     * @param {?} years
	     * @return {?}
	     */
	    function (date, years) {
	        return this.addCalendarMonths(date, years * 12);
	    };
	    /**
	     * @param {?} date
	     * @param {?} months
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.addCalendarMonths = /**
	     * @param {?} date
	     * @param {?} months
	     * @return {?}
	     */
	    function (date, months) {
	        var /** @type {?} */ newDate = this._createDateWithOverflow(this.getYear(date), this.getMonth(date) + months, this.getDate(date));
	        // It's possible to wind up in the wrong month if the original month has more days than the new
	        // month. In this case we want to go to the last day of the desired month.
	        // Note: the additional + 12 % 12 ensures we end up with a positive number, since JS % doesn't
	        // guarantee this.
	        if (this.getMonth(newDate) != ((this.getMonth(date) + months) % 12 + 12) % 12) {
	            newDate = this._createDateWithOverflow(this.getYear(newDate), this.getMonth(newDate), 0);
	        }
	        return newDate;
	    };
	    /**
	     * @param {?} date
	     * @param {?} days
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.addCalendarDays = /**
	     * @param {?} date
	     * @param {?} days
	     * @return {?}
	     */
	    function (date, days) {
	        return this._createDateWithOverflow(this.getYear(date), this.getMonth(date), this.getDate(date) + days);
	    };
	    /**
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.toIso8601 = /**
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        return [
	            date.getUTCFullYear(),
	            this._2digit(date.getUTCMonth() + 1),
	            this._2digit(date.getUTCDate())
	        ].join('-');
	    };
	    /**
	     * Returns the given value if given a valid Date or null. Deserializes valid ISO 8601 strings
	     * (https://www.ietf.org/rfc/rfc3339.txt) into valid Dates and empty string into null. Returns an
	     * invalid date for all other values.
	     */
	    /**
	     * Returns the given value if given a valid Date or null. Deserializes valid ISO 8601 strings
	     * (https://www.ietf.org/rfc/rfc3339.txt) into valid Dates and empty string into null. Returns an
	     * invalid date for all other values.
	     * @param {?} value
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.deserialize = /**
	     * Returns the given value if given a valid Date or null. Deserializes valid ISO 8601 strings
	     * (https://www.ietf.org/rfc/rfc3339.txt) into valid Dates and empty string into null. Returns an
	     * invalid date for all other values.
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        if (typeof value === 'string') {
	            if (!value) {
	                return null;
	            }
	            // The `Date` constructor accepts formats other than ISO 8601, so we need to make sure the
	            // string is the right format first.
	            if (ISO_8601_REGEX.test(value)) {
	                var /** @type {?} */ date = new Date(value);
	                if (this.isValid(date)) {
	                    return date;
	                }
	            }
	        }
	        return _super.prototype.deserialize.call(this, value);
	    };
	    /**
	     * @param {?} obj
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.isDateInstance = /**
	     * @param {?} obj
	     * @return {?}
	     */
	    function (obj) {
	        return obj instanceof Date;
	    };
	    /**
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.isValid = /**
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        return !isNaN(date.getTime());
	    };
	    /**
	     * @return {?}
	     */
	    NativeDateAdapter.prototype.invalid = /**
	     * @return {?}
	     */
	    function () {
	        return new Date(NaN);
	    };
	    /**
	     * Creates a date but allows the month and date to overflow.
	     * @param {?} year
	     * @param {?} month
	     * @param {?} date
	     * @return {?}
	     */
	    NativeDateAdapter.prototype._createDateWithOverflow = /**
	     * Creates a date but allows the month and date to overflow.
	     * @param {?} year
	     * @param {?} month
	     * @param {?} date
	     * @return {?}
	     */
	    function (year, month, date) {
	        var /** @type {?} */ result = new Date(year, month, date);
	        // We need to correct for the fact that JS native Date treats years in range [0, 99] as
	        // abbreviations for 19xx.
	        if (year >= 0 && year < 100) {
	            result.setFullYear(this.getYear(result) - 1900);
	        }
	        return result;
	    };
	    /**
	     * Pads a number to make it two digits.
	     * @param {?} n The number to pad.
	     * @return {?} The padded number.
	     */
	    NativeDateAdapter.prototype._2digit = /**
	     * Pads a number to make it two digits.
	     * @param {?} n The number to pad.
	     * @return {?} The padded number.
	     */
	    function (n) {
	        return ('00' + n).slice(-2);
	    };
	    /**
	     * Strip out unicode LTR and RTL characters. Edge and IE insert these into formatted dates while
	     * other browsers do not. We remove them to make output consistent and because they interfere with
	     * date parsing.
	     * @param {?} str The string to strip direction characters from.
	     * @return {?} The stripped string.
	     */
	    NativeDateAdapter.prototype._stripDirectionalityCharacters = /**
	     * Strip out unicode LTR and RTL characters. Edge and IE insert these into formatted dates while
	     * other browsers do not. We remove them to make output consistent and because they interfere with
	     * date parsing.
	     * @param {?} str The string to strip direction characters from.
	     * @return {?} The stripped string.
	     */
	    function (str) {
	        return str.replace(/[\u200e\u200f]/g, '');
	    };
	    /**
	     * When converting Date object to string, javascript built-in functions may return wrong
	     * results because it applies its internal DST rules. The DST rules around the world change
	     * very frequently, and the current valid rule is not always valid in previous years though.
	     * We work around this problem building a new Date object which has its internal UTC
	     * representation with the local date and time.
	     * @param {?} dtf Intl.DateTimeFormat object, containg the desired string format. It must have
	     *    timeZone set to 'utc' to work fine.
	     * @param {?} date Date from which we want to get the string representation according to dtf
	     * @return {?} A Date object with its UTC representation based on the passed in date info
	     */
	    NativeDateAdapter.prototype._format = /**
	     * When converting Date object to string, javascript built-in functions may return wrong
	     * results because it applies its internal DST rules. The DST rules around the world change
	     * very frequently, and the current valid rule is not always valid in previous years though.
	     * We work around this problem building a new Date object which has its internal UTC
	     * representation with the local date and time.
	     * @param {?} dtf Intl.DateTimeFormat object, containg the desired string format. It must have
	     *    timeZone set to 'utc' to work fine.
	     * @param {?} date Date from which we want to get the string representation according to dtf
	     * @return {?} A Date object with its UTC representation based on the passed in date info
	     */
	    function (dtf, date) {
	        var /** @type {?} */ d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
	        return dtf.format(d);
	    };
	    NativeDateAdapter.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    NativeDateAdapter.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MAT_DATE_LOCALE,] },] },
	    ]; };
	    return NativeDateAdapter;
	}(DateAdapter));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MAT_NATIVE_DATE_FORMATS = {
	    parse: {
	        dateInput: null,
	    },
	    display: {
	        dateInput: { year: 'numeric', month: 'numeric', day: 'numeric' },
	        monthYearLabel: { year: 'numeric', month: 'short' },
	        dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
	        monthYearA11yLabel: { year: 'numeric', month: 'long' },
	    }
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var NativeDateModule = /** @class */ (function () {
	    function NativeDateModule() {
	    }
	    NativeDateModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    providers: [
	                        { provide: DateAdapter, useClass: NativeDateAdapter },
	                        MAT_DATE_LOCALE_PROVIDER
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    NativeDateModule.ctorParameters = function () { return []; };
	    return NativeDateModule;
	}());
	var ɵ0$$1 = MAT_NATIVE_DATE_FORMATS;
	var MatNativeDateModule = /** @class */ (function () {
	    function MatNativeDateModule() {
	    }
	    MatNativeDateModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [NativeDateModule],
	                    providers: [{ provide: MAT_DATE_FORMATS, useValue: ɵ0$$1 }],
	                },] },
	    ];
	    /** @nocollapse */
	    MatNativeDateModule.ctorParameters = function () { return []; };
	    return MatNativeDateModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Error state matcher that matches when a control is invalid and dirty.
	 */
	var ShowOnDirtyErrorStateMatcher = /** @class */ (function () {
	    function ShowOnDirtyErrorStateMatcher() {
	    }
	    /**
	     * @param {?} control
	     * @param {?} form
	     * @return {?}
	     */
	    ShowOnDirtyErrorStateMatcher.prototype.isErrorState = /**
	     * @param {?} control
	     * @param {?} form
	     * @return {?}
	     */
	    function (control, form) {
	        return !!(control && control.invalid && (control.dirty || (form && form.submitted)));
	    };
	    ShowOnDirtyErrorStateMatcher.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    ShowOnDirtyErrorStateMatcher.ctorParameters = function () { return []; };
	    return ShowOnDirtyErrorStateMatcher;
	}());
	/**
	 * Provider that defines how form controls behave with regards to displaying error messages.
	 */
	var ErrorStateMatcher = /** @class */ (function () {
	    function ErrorStateMatcher() {
	    }
	    /**
	     * @param {?} control
	     * @param {?} form
	     * @return {?}
	     */
	    ErrorStateMatcher.prototype.isErrorState = /**
	     * @param {?} control
	     * @param {?} form
	     * @return {?}
	     */
	    function (control, form) {
	        return !!(control && control.invalid && (control.touched || (form && form.submitted)));
	    };
	    ErrorStateMatcher.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    ErrorStateMatcher.ctorParameters = function () { return []; };
	    return ErrorStateMatcher;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Injection token that can be used to provide options to the Hammerjs instance.
	 * More info at http://hammerjs.github.io/api/.
	 */
	var MAT_HAMMER_OPTIONS = new _angular_core.InjectionToken('MAT_HAMMER_OPTIONS');
	/**
	 * Adjusts configuration of our gesture library, Hammer.
	 */
	var GestureConfig = /** @class */ (function (_super) {
	    __extends(GestureConfig, _super);
	    function GestureConfig(_hammerOptions, commonModule) {
	        var _this = _super.call(this) || this;
	        _this._hammerOptions = _hammerOptions;
	        _this._hammer = typeof window !== 'undefined' ? (/** @type {?} */ (window)).Hammer : null;
	        /**
	         * List of new event names to add to the gesture support list
	         */
	        _this.events = _this._hammer ? [
	            'longpress',
	            'slide',
	            'slidestart',
	            'slideend',
	            'slideright',
	            'slideleft'
	        ] : [];
	        if (commonModule) {
	            commonModule._checkHammerIsAvailable();
	        }
	        return _this;
	    }
	    /**
	     * Builds Hammer instance manually to add custom recognizers that match the Material Design spec.
	     *
	     * Our gesture names come from the Material Design gestures spec:
	     * https://www.google.com/design/spec/patterns/gestures.html#gestures-touch-mechanics
	     *
	     * More information on default recognizers can be found in Hammer docs:
	     * http://hammerjs.github.io/recognizer-pan/
	     * http://hammerjs.github.io/recognizer-press/
	     *
	     * @param element Element to which to assign the new HammerJS gestures.
	     * @returns Newly-created HammerJS instance.
	     */
	    /**
	     * Builds Hammer instance manually to add custom recognizers that match the Material Design spec.
	     *
	     * Our gesture names come from the Material Design gestures spec:
	     * https://www.google.com/design/spec/patterns/gestures.html#gestures-touch-mechanics
	     *
	     * More information on default recognizers can be found in Hammer docs:
	     * http://hammerjs.github.io/recognizer-pan/
	     * http://hammerjs.github.io/recognizer-press/
	     *
	     * @param {?} element Element to which to assign the new HammerJS gestures.
	     * @return {?} Newly-created HammerJS instance.
	     */
	    GestureConfig.prototype.buildHammer = /**
	     * Builds Hammer instance manually to add custom recognizers that match the Material Design spec.
	     *
	     * Our gesture names come from the Material Design gestures spec:
	     * https://www.google.com/design/spec/patterns/gestures.html#gestures-touch-mechanics
	     *
	     * More information on default recognizers can be found in Hammer docs:
	     * http://hammerjs.github.io/recognizer-pan/
	     * http://hammerjs.github.io/recognizer-press/
	     *
	     * @param {?} element Element to which to assign the new HammerJS gestures.
	     * @return {?} Newly-created HammerJS instance.
	     */
	    function (element) {
	        var /** @type {?} */ mc = new this._hammer(element, this._hammerOptions || undefined);
	        // Default Hammer Recognizers.
	        var /** @type {?} */ pan = new this._hammer.Pan();
	        var /** @type {?} */ swipe = new this._hammer.Swipe();
	        var /** @type {?} */ press = new this._hammer.Press();
	        // Notice that a HammerJS recognizer can only depend on one other recognizer once.
	        // Otherwise the previous `recognizeWith` will be dropped.
	        // TODO: Confirm threshold numbers with Material Design UX Team
	        var /** @type {?} */ slide = this._createRecognizer(pan, { event: 'slide', threshold: 0 }, swipe);
	        var /** @type {?} */ longpress = this._createRecognizer(press, { event: 'longpress', time: 500 });
	        // Overwrite the default `pan` event to use the swipe event.
	        pan.recognizeWith(swipe);
	        // Add customized gestures to Hammer manager
	        mc.add([swipe, press, pan, slide, longpress]);
	        return /** @type {?} */ (mc);
	    };
	    /**
	     * Creates a new recognizer, without affecting the default recognizers of HammerJS
	     * @param {?} base
	     * @param {?} options
	     * @param {...?} inheritances
	     * @return {?}
	     */
	    GestureConfig.prototype._createRecognizer = /**
	     * Creates a new recognizer, without affecting the default recognizers of HammerJS
	     * @param {?} base
	     * @param {?} options
	     * @param {...?} inheritances
	     * @return {?}
	     */
	    function (base, options) {
	        var inheritances = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            inheritances[_i - 2] = arguments[_i];
	        }
	        var /** @type {?} */ recognizer = new (/** @type {?} */ (base.constructor))(options);
	        inheritances.push(base);
	        inheritances.forEach(function (item) { return recognizer.recognizeWith(item); });
	        return recognizer;
	    };
	    GestureConfig.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    GestureConfig.ctorParameters = function () { return [
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MAT_HAMMER_OPTIONS,] },] },
	        { type: MatCommonModule, decorators: [{ type: _angular_core.Optional },] },
	    ]; };
	    return GestureConfig;
	}(_angular_platformBrowser.HammerGestureConfig));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Shared directive to count lines inside a text area, such as a list item.
	 * Line elements can be extracted with a \@ContentChildren(MatLine) query, then
	 * counted by checking the query list's length.
	 */
	var MatLine = /** @class */ (function () {
	    function MatLine() {
	    }
	    MatLine.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-line], [matLine]',
	                    host: { 'class': 'mat-line' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatLine.ctorParameters = function () { return []; };
	    return MatLine;
	}());
	/**
	 * Helper that takes a query list of lines and sets the correct class on the host.
	 * \@docs-private
	 */
	var MatLineSetter = /** @class */ (function () {
	    function MatLineSetter(_lines, _element) {
	        var _this = this;
	        this._lines = _lines;
	        this._element = _element;
	        this._setLineClass(this._lines.length);
	        this._lines.changes.subscribe(function () {
	            _this._setLineClass(_this._lines.length);
	        });
	    }
	    /**
	     * @param {?} count
	     * @return {?}
	     */
	    MatLineSetter.prototype._setLineClass = /**
	     * @param {?} count
	     * @return {?}
	     */
	    function (count) {
	        this._resetClasses();
	        if (count === 2 || count === 3) {
	            this._setClass("mat-" + count + "-line", true);
	        }
	        else if (count > 3) {
	            this._setClass("mat-multi-line", true);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatLineSetter.prototype._resetClasses = /**
	     * @return {?}
	     */
	    function () {
	        this._setClass('mat-2-line', false);
	        this._setClass('mat-3-line', false);
	        this._setClass('mat-multi-line', false);
	    };
	    /**
	     * @param {?} className
	     * @param {?} isAdd
	     * @return {?}
	     */
	    MatLineSetter.prototype._setClass = /**
	     * @param {?} className
	     * @param {?} isAdd
	     * @return {?}
	     */
	    function (className, isAdd) {
	        if (isAdd) {
	            this._element.nativeElement.classList.add(className);
	        }
	        else {
	            this._element.nativeElement.classList.remove(className);
	        }
	    };
	    return MatLineSetter;
	}());
	var MatLineModule = /** @class */ (function () {
	    function MatLineModule() {
	    }
	    MatLineModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [MatCommonModule],
	                    exports: [MatLine, MatCommonModule],
	                    declarations: [MatLine],
	                },] },
	    ];
	    /** @nocollapse */
	    MatLineModule.ctorParameters = function () { return []; };
	    return MatLineModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/** @enum {number} */
	var RippleState = {
	    FADING_IN: 0,
	    VISIBLE: 1,
	    FADING_OUT: 2,
	    HIDDEN: 3,
	};
	RippleState[RippleState.FADING_IN] = "FADING_IN";
	RippleState[RippleState.VISIBLE] = "VISIBLE";
	RippleState[RippleState.FADING_OUT] = "FADING_OUT";
	RippleState[RippleState.HIDDEN] = "HIDDEN";
	/**
	 * Reference to a previously launched ripple element.
	 */
	var RippleRef = /** @class */ (function () {
	    function RippleRef(_renderer, element, config) {
	        this._renderer = _renderer;
	        this.element = element;
	        this.config = config;
	        /**
	         * Current state of the ripple reference.
	         */
	        this.state = RippleState.HIDDEN;
	    }
	    /** Fades out the ripple element. */
	    /**
	     * Fades out the ripple element.
	     * @return {?}
	     */
	    RippleRef.prototype.fadeOut = /**
	     * Fades out the ripple element.
	     * @return {?}
	     */
	    function () {
	        this._renderer.fadeOutRipple(this);
	    };
	    return RippleRef;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * Interface that describes the configuration for the animation of a ripple.
	 * There are two animation phases with different durations for the ripples.
	 * @record
	 */
	
	/**
	 * Interface that describes the target for launching ripples.
	 * It defines the ripple configuration and disabled state for interaction ripples.
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * Default ripple animation configuration for ripples without an explicit
	 * animation config specified.
	 */
	var defaultRippleAnimationConfig = {
	    enterDuration: 450,
	    exitDuration: 400
	};
	/**
	 * Timeout for ignoring mouse events. Mouse events will be temporary ignored after touch
	 * events to avoid synthetic mouse events.
	 */
	var ignoreMouseEventsTimeout = 800;
	/**
	 * Helper service that performs DOM manipulations. Not intended to be used outside this module.
	 * The constructor takes a reference to the ripple directive's host element and a map of DOM
	 * event handlers to be installed on the element that triggers ripple animations.
	 * This will eventually become a custom renderer once Angular support exists.
	 * \@docs-private
	 */
	var RippleRenderer = /** @class */ (function () {
	    function RippleRenderer(_target, _ngZone, elementRef, platform) {
	        var _this = this;
	        this._target = _target;
	        this._ngZone = _ngZone;
	        /**
	         * Whether the pointer is currently down or not.
	         */
	        this._isPointerDown = false;
	        /**
	         * Events to be registered on the trigger element.
	         */
	        this._triggerEvents = new Map();
	        /**
	         * Set of currently active ripple references.
	         */
	        this._activeRipples = new Set();
	        /**
	         * Options that apply to all the event listeners that are bound by the renderer.
	         */
	        this._eventOptions = _angular_cdk_platform.supportsPassiveEventListeners() ? (/** @type {?} */ ({ passive: true })) : false;
	        /**
	         * Function being called whenever the trigger is being pressed using mouse.
	         */
	        this.onMousedown = function (event) {
	            var /** @type {?} */ isSyntheticEvent = _this._lastTouchStartEvent &&
	                Date.now() < _this._lastTouchStartEvent + ignoreMouseEventsTimeout;
	            if (!_this._target.rippleDisabled && !isSyntheticEvent) {
	                _this._isPointerDown = true;
	                _this.fadeInRipple(event.clientX, event.clientY, _this._target.rippleConfig);
	            }
	        };
	        /**
	         * Function being called whenever the trigger is being pressed using touch.
	         */
	        this.onTouchStart = function (event) {
	            if (!_this._target.rippleDisabled) {
	                // Some browsers fire mouse events after a `touchstart` event. Those synthetic mouse
	                // events will launch a second ripple if we don't ignore mouse events for a specific
	                // time after a touchstart event.
	                // Some browsers fire mouse events after a `touchstart` event. Those synthetic mouse
	                // events will launch a second ripple if we don't ignore mouse events for a specific
	                // time after a touchstart event.
	                _this._lastTouchStartEvent = Date.now();
	                _this._isPointerDown = true;
	                _this.fadeInRipple(event.touches[0].clientX, event.touches[0].clientY, _this._target.rippleConfig);
	            }
	        };
	        /**
	         * Function being called whenever the trigger is being released.
	         */
	        this.onPointerUp = function () {
	            if (!_this._isPointerDown) {
	                return;
	            }
	            _this._isPointerDown = false;
	            // Fade-out all ripples that are visible and not persistent.
	            // Fade-out all ripples that are visible and not persistent.
	            _this._activeRipples.forEach(function (ripple) {
	                // By default, only ripples that are completely visible will fade out on pointer release.
	                // If the `terminateOnPointerUp` option is set, ripples that still fade in will also fade out.
	                var /** @type {?} */ isVisible = ripple.state === RippleState.VISIBLE ||
	                    ripple.config.terminateOnPointerUp && ripple.state === RippleState.FADING_IN;
	                if (!ripple.config.persistent && isVisible) {
	                    ripple.fadeOut();
	                }
	            });
	        };
	        // Only do anything if we're on the browser.
	        if (platform.isBrowser) {
	            this._containerElement = elementRef.nativeElement;
	            // Specify events which need to be registered on the trigger.
	            this._triggerEvents.set('mousedown', this.onMousedown);
	            this._triggerEvents.set('mouseup', this.onPointerUp);
	            this._triggerEvents.set('mouseleave', this.onPointerUp);
	            this._triggerEvents.set('touchstart', this.onTouchStart);
	            this._triggerEvents.set('touchend', this.onPointerUp);
	        }
	    }
	    /**
	     * Fades in a ripple at the given coordinates.
	     * @param x Coordinate within the element, along the X axis at which to start the ripple.
	     * @param y Coordinate within the element, along the Y axis at which to start the ripple.
	     * @param config Extra ripple options.
	     */
	    /**
	     * Fades in a ripple at the given coordinates.
	     * @param {?} x Coordinate within the element, along the X axis at which to start the ripple.
	     * @param {?} y Coordinate within the element, along the Y axis at which to start the ripple.
	     * @param {?=} config Extra ripple options.
	     * @return {?}
	     */
	    RippleRenderer.prototype.fadeInRipple = /**
	     * Fades in a ripple at the given coordinates.
	     * @param {?} x Coordinate within the element, along the X axis at which to start the ripple.
	     * @param {?} y Coordinate within the element, along the Y axis at which to start the ripple.
	     * @param {?=} config Extra ripple options.
	     * @return {?}
	     */
	    function (x, y, config) {
	        var _this = this;
	        if (config === void 0) { config = {}; }
	        var /** @type {?} */ containerRect = this._containerElement.getBoundingClientRect();
	        var /** @type {?} */ animationConfig = __assign({}, defaultRippleAnimationConfig, config.animation);
	        if (config.centered) {
	            x = containerRect.left + containerRect.width / 2;
	            y = containerRect.top + containerRect.height / 2;
	        }
	        var /** @type {?} */ radius = config.radius || distanceToFurthestCorner(x, y, containerRect);
	        var /** @type {?} */ offsetX = x - containerRect.left;
	        var /** @type {?} */ offsetY = y - containerRect.top;
	        var /** @type {?} */ duration = animationConfig.enterDuration / (config.speedFactor || 1);
	        var /** @type {?} */ ripple = document.createElement('div');
	        ripple.classList.add('mat-ripple-element');
	        ripple.style.left = offsetX - radius + "px";
	        ripple.style.top = offsetY - radius + "px";
	        ripple.style.height = radius * 2 + "px";
	        ripple.style.width = radius * 2 + "px";
	        // If the color is not set, the default CSS color will be used.
	        ripple.style.backgroundColor = config.color || null;
	        ripple.style.transitionDuration = duration + "ms";
	        this._containerElement.appendChild(ripple);
	        // By default the browser does not recalculate the styles of dynamically created
	        // ripple elements. This is critical because then the `scale` would not animate properly.
	        enforceStyleRecalculation(ripple);
	        ripple.style.transform = 'scale(1)';
	        // Exposed reference to the ripple that will be returned.
	        var /** @type {?} */ rippleRef = new RippleRef(this, ripple, config);
	        rippleRef.state = RippleState.FADING_IN;
	        // Add the ripple reference to the list of all active ripples.
	        this._activeRipples.add(rippleRef);
	        // Wait for the ripple element to be completely faded in.
	        // Once it's faded in, the ripple can be hidden immediately if the mouse is released.
	        this.runTimeoutOutsideZone(function () {
	            rippleRef.state = RippleState.VISIBLE;
	            if (!config.persistent && !_this._isPointerDown) {
	                rippleRef.fadeOut();
	            }
	        }, duration);
	        return rippleRef;
	    };
	    /** Fades out a ripple reference. */
	    /**
	     * Fades out a ripple reference.
	     * @param {?} rippleRef
	     * @return {?}
	     */
	    RippleRenderer.prototype.fadeOutRipple = /**
	     * Fades out a ripple reference.
	     * @param {?} rippleRef
	     * @return {?}
	     */
	    function (rippleRef) {
	        // For ripples that are not active anymore, don't re-un the fade-out animation.
	        if (!this._activeRipples.delete(rippleRef)) {
	            return;
	        }
	        var /** @type {?} */ rippleEl = rippleRef.element;
	        var /** @type {?} */ animationConfig = __assign({}, defaultRippleAnimationConfig, rippleRef.config.animation);
	        rippleEl.style.transitionDuration = animationConfig.exitDuration + "ms";
	        rippleEl.style.opacity = '0';
	        rippleRef.state = RippleState.FADING_OUT;
	        // Once the ripple faded out, the ripple can be safely removed from the DOM.
	        this.runTimeoutOutsideZone(function () {
	            rippleRef.state = RippleState.HIDDEN; /** @type {?} */
	            ((rippleEl.parentNode)).removeChild(rippleEl);
	        }, animationConfig.exitDuration);
	    };
	    /** Fades out all currently active ripples. */
	    /**
	     * Fades out all currently active ripples.
	     * @return {?}
	     */
	    RippleRenderer.prototype.fadeOutAll = /**
	     * Fades out all currently active ripples.
	     * @return {?}
	     */
	    function () {
	        this._activeRipples.forEach(function (ripple) { return ripple.fadeOut(); });
	    };
	    /** Sets up the trigger event listeners */
	    /**
	     * Sets up the trigger event listeners
	     * @param {?} element
	     * @return {?}
	     */
	    RippleRenderer.prototype.setupTriggerEvents = /**
	     * Sets up the trigger event listeners
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) {
	        var _this = this;
	        if (!element || element === this._triggerElement) {
	            return;
	        }
	        // Remove all previously registered event listeners from the trigger element.
	        this._removeTriggerEvents();
	        this._ngZone.runOutsideAngular(function () {
	            _this._triggerEvents.forEach(function (fn, type) {
	                return element.addEventListener(type, fn, _this._eventOptions);
	            });
	        });
	        this._triggerElement = element;
	    };
	    /**
	     * Runs a timeout outside of the Angular zone to avoid triggering the change detection.
	     * @param {?} fn
	     * @param {?=} delay
	     * @return {?}
	     */
	    RippleRenderer.prototype.runTimeoutOutsideZone = /**
	     * Runs a timeout outside of the Angular zone to avoid triggering the change detection.
	     * @param {?} fn
	     * @param {?=} delay
	     * @return {?}
	     */
	    function (fn, delay$$1) {
	        if (delay$$1 === void 0) { delay$$1 = 0; }
	        this._ngZone.runOutsideAngular(function () { return setTimeout(fn, delay$$1); });
	    };
	    /** Removes previously registered event listeners from the trigger element. */
	    /**
	     * Removes previously registered event listeners from the trigger element.
	     * @return {?}
	     */
	    RippleRenderer.prototype._removeTriggerEvents = /**
	     * Removes previously registered event listeners from the trigger element.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._triggerElement) {
	            this._triggerEvents.forEach(function (fn, type) {
	                /** @type {?} */ ((_this._triggerElement)).removeEventListener(type, fn, _this._eventOptions);
	            });
	        }
	    };
	    return RippleRenderer;
	}());
	/**
	 * Enforces a style recalculation of a DOM element by computing its styles.
	 * @param {?} element
	 * @return {?}
	 */
	function enforceStyleRecalculation(element) {
	    // Enforce a style recalculation by calling `getComputedStyle` and accessing any property.
	    // Calling `getPropertyValue` is important to let optimizers know that this is not a noop.
	    // See: https://gist.github.com/paulirish/5d52fb081b3570c81e3a
	    window.getComputedStyle(element).getPropertyValue('opacity');
	}
	/**
	 * Returns the distance from the point (x, y) to the furthest corner of a rectangle.
	 * @param {?} x
	 * @param {?} y
	 * @param {?} rect
	 * @return {?}
	 */
	function distanceToFurthestCorner(x, y, rect) {
	    var /** @type {?} */ distX = Math.max(Math.abs(x - rect.left), Math.abs(x - rect.right));
	    var /** @type {?} */ distY = Math.max(Math.abs(y - rect.top), Math.abs(y - rect.bottom));
	    return Math.sqrt(distX * distX + distY * distY);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Configurable options for `matRipple`.
	 * @record
	 */
	
	/**
	 * Injection token that can be used to specify the global ripple options.
	 */
	var MAT_RIPPLE_GLOBAL_OPTIONS = new _angular_core.InjectionToken('mat-ripple-global-options');
	var MatRipple = /** @class */ (function () {
	    function MatRipple(_elementRef, ngZone, platform, globalOptions) {
	        this._elementRef = _elementRef;
	        /**
	         * If set, the radius in pixels of foreground ripples when fully expanded. If unset, the radius
	         * will be the distance from the center of the ripple to the furthest corner of the host element's
	         * bounding rectangle.
	         */
	        this.radius = 0;
	        /**
	         * If set, the normal duration of ripple animations is divided by this value. For example,
	         * setting it to 0.5 will cause the animations to take twice as long.
	         * A changed speedFactor will not modify the fade-out duration of the ripples.
	         * @deprecated Use the [matRippleAnimation] binding instead.
	         * \@deletion-target 7.0.0
	         */
	        this.speedFactor = 1;
	        this._disabled = false;
	        /**
	         * Whether ripple directive is initialized and the input bindings are set.
	         */
	        this._isInitialized = false;
	        this._globalOptions = globalOptions || {};
	        this._rippleRenderer = new RippleRenderer(this, ngZone, _elementRef, platform);
	    }
	    Object.defineProperty(MatRipple.prototype, "disabled", {
	        get: /**
	         * Whether click events will not trigger the ripple. Ripples can be still launched manually
	         * by using the `launch()` method.
	         * @return {?}
	         */
	        function () { return this._disabled; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._disabled = value;
	            this._setupTriggerEventsIfEnabled();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatRipple.prototype, "trigger", {
	        get: /**
	         * The element that triggers the ripple when click events are received.
	         * Defaults to the directive's host element.
	         * @return {?}
	         */
	        function () { return this._trigger || this._elementRef.nativeElement; },
	        set: /**
	         * @param {?} trigger
	         * @return {?}
	         */
	        function (trigger$$1) {
	            this._trigger = trigger$$1;
	            this._setupTriggerEventsIfEnabled();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatRipple.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        this._isInitialized = true;
	        this._setupTriggerEventsIfEnabled();
	    };
	    /**
	     * @return {?}
	     */
	    MatRipple.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._rippleRenderer._removeTriggerEvents();
	    };
	    /** Fades out all currently showing ripple elements. */
	    /**
	     * Fades out all currently showing ripple elements.
	     * @return {?}
	     */
	    MatRipple.prototype.fadeOutAll = /**
	     * Fades out all currently showing ripple elements.
	     * @return {?}
	     */
	    function () {
	        this._rippleRenderer.fadeOutAll();
	    };
	    Object.defineProperty(MatRipple.prototype, "rippleConfig", {
	        /** Ripple configuration from the directive's input values. */
	        get: /**
	         * Ripple configuration from the directive's input values.
	         * @return {?}
	         */
	        function () {
	            return {
	                centered: this.centered,
	                radius: this.radius,
	                color: this.color,
	                animation: __assign({}, this._globalOptions.animation, this.animation),
	                terminateOnPointerUp: this._globalOptions.terminateOnPointerUp,
	                speedFactor: this.speedFactor * (this._globalOptions.baseSpeedFactor || 1),
	            };
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatRipple.prototype, "rippleDisabled", {
	        /** Whether ripples on pointer-down are disabled or not. */
	        get: /**
	         * Whether ripples on pointer-down are disabled or not.
	         * @return {?}
	         */
	        function () {
	            return this.disabled || !!this._globalOptions.disabled;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Sets up the the trigger event listeners if ripples are enabled.
	     * @return {?}
	     */
	    MatRipple.prototype._setupTriggerEventsIfEnabled = /**
	     * Sets up the the trigger event listeners if ripples are enabled.
	     * @return {?}
	     */
	    function () {
	        if (!this.disabled && this._isInitialized) {
	            this._rippleRenderer.setupTriggerEvents(this.trigger);
	        }
	    };
	    /** Launches a manual ripple at the specified coordinated or just by the ripple config. */
	    /**
	     * Launches a manual ripple at the specified coordinated or just by the ripple config.
	     * @param {?} configOrX
	     * @param {?=} y
	     * @param {?=} config
	     * @return {?}
	     */
	    MatRipple.prototype.launch = /**
	     * Launches a manual ripple at the specified coordinated or just by the ripple config.
	     * @param {?} configOrX
	     * @param {?=} y
	     * @param {?=} config
	     * @return {?}
	     */
	    function (configOrX, y, config) {
	        if (y === void 0) { y = 0; }
	        if (typeof configOrX === 'number') {
	            return this._rippleRenderer.fadeInRipple(configOrX, y, __assign({}, this.rippleConfig, config));
	        }
	        else {
	            return this._rippleRenderer.fadeInRipple(0, 0, __assign({}, this.rippleConfig, configOrX));
	        }
	    };
	    MatRipple.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-ripple], [matRipple]',
	                    exportAs: 'matRipple',
	                    host: {
	                        'class': 'mat-ripple',
	                        '[class.mat-ripple-unbounded]': 'unbounded'
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatRipple.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.NgZone, },
	        { type: _angular_cdk_platform.Platform, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MAT_RIPPLE_GLOBAL_OPTIONS,] },] },
	    ]; };
	    MatRipple.propDecorators = {
	        "color": [{ type: _angular_core.Input, args: ['matRippleColor',] },],
	        "unbounded": [{ type: _angular_core.Input, args: ['matRippleUnbounded',] },],
	        "centered": [{ type: _angular_core.Input, args: ['matRippleCentered',] },],
	        "radius": [{ type: _angular_core.Input, args: ['matRippleRadius',] },],
	        "speedFactor": [{ type: _angular_core.Input, args: ['matRippleSpeedFactor',] },],
	        "animation": [{ type: _angular_core.Input, args: ['matRippleAnimation',] },],
	        "disabled": [{ type: _angular_core.Input, args: ['matRippleDisabled',] },],
	        "trigger": [{ type: _angular_core.Input, args: ['matRippleTrigger',] },],
	    };
	    return MatRipple;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatRippleModule = /** @class */ (function () {
	    function MatRippleModule() {
	    }
	    MatRippleModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [MatCommonModule, _angular_cdk_platform.PlatformModule],
	                    exports: [MatRipple, MatCommonModule],
	                    declarations: [MatRipple],
	                },] },
	    ];
	    /** @nocollapse */
	    MatRippleModule.ctorParameters = function () { return []; };
	    return MatRippleModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Component that shows a simplified checkbox without including any kind of "real" checkbox.
	 * Meant to be used when the checkbox is purely decorative and a large number of them will be
	 * included, such as for the options in a multi-select. Uses no SVGs or complex animations.
	 * Note that theming is meant to be handled by the parent element, e.g.
	 * `mat-primary .mat-pseudo-checkbox`.
	 *
	 * Note that this component will be completely invisible to screen-reader users. This is *not*
	 * interchangeable with `<mat-checkbox>` and should *not* be used if the user would directly
	 * interact with the checkbox. The pseudo-checkbox should only be used as an implementation detail
	 * of more complex components that appropriately handle selected / checked state.
	 * \@docs-private
	 */
	var MatPseudoCheckbox = /** @class */ (function () {
	    function MatPseudoCheckbox() {
	        /**
	         * Display state of the checkbox.
	         */
	        this.state = 'unchecked';
	        /**
	         * Whether the checkbox is disabled.
	         */
	        this.disabled = false;
	    }
	    MatPseudoCheckbox.decorators = [
	        { type: _angular_core.Component, args: [{encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    selector: 'mat-pseudo-checkbox',
	                    styles: [".mat-pseudo-checkbox{width:20px;height:20px;border:2px solid;border-radius:2px;cursor:pointer;display:inline-block;vertical-align:middle;box-sizing:border-box;position:relative;flex-shrink:0;transition:border-color 90ms cubic-bezier(0,0,.2,.1),background-color 90ms cubic-bezier(0,0,.2,.1)}.mat-pseudo-checkbox::after{position:absolute;opacity:0;content:'';border-bottom:2px solid currentColor;transition:opacity 90ms cubic-bezier(0,0,.2,.1)}.mat-pseudo-checkbox.mat-pseudo-checkbox-checked,.mat-pseudo-checkbox.mat-pseudo-checkbox-indeterminate{border:none}.mat-pseudo-checkbox-disabled{cursor:default}.mat-pseudo-checkbox-indeterminate::after{top:9px;left:2px;width:16px;opacity:1}.mat-pseudo-checkbox-checked::after{top:5px;left:3px;width:12px;height:5px;border-left:2px solid currentColor;transform:rotate(-45deg);opacity:1}"],
	                    template: '',
	                    host: {
	                        'class': 'mat-pseudo-checkbox',
	                        '[class.mat-pseudo-checkbox-indeterminate]': 'state === "indeterminate"',
	                        '[class.mat-pseudo-checkbox-checked]': 'state === "checked"',
	                        '[class.mat-pseudo-checkbox-disabled]': 'disabled',
	                    },
	                },] },
	    ];
	    /** @nocollapse */
	    MatPseudoCheckbox.ctorParameters = function () { return []; };
	    MatPseudoCheckbox.propDecorators = {
	        "state": [{ type: _angular_core.Input },],
	        "disabled": [{ type: _angular_core.Input },],
	    };
	    return MatPseudoCheckbox;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatPseudoCheckboxModule = /** @class */ (function () {
	    function MatPseudoCheckboxModule() {
	    }
	    MatPseudoCheckboxModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    exports: [MatPseudoCheckbox],
	                    declarations: [MatPseudoCheckbox]
	                },] },
	    ];
	    /** @nocollapse */
	    MatPseudoCheckboxModule.ctorParameters = function () { return []; };
	    return MatPseudoCheckboxModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 */
	var MatOptgroupBase = /** @class */ (function () {
	    function MatOptgroupBase() {
	    }
	    return MatOptgroupBase;
	}());
	var _MatOptgroupMixinBase = mixinDisabled(MatOptgroupBase);
	// Counter for unique group ids.
	var _uniqueOptgroupIdCounter = 0;
	/**
	 * Component that is used to group instances of `mat-option`.
	 */
	var MatOptgroup = /** @class */ (function (_super) {
	    __extends(MatOptgroup, _super);
	    function MatOptgroup() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /**
	         * Unique id for the underlying label.
	         */
	        _this._labelId = "mat-optgroup-label-" + _uniqueOptgroupIdCounter++;
	        return _this;
	    }
	    MatOptgroup.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-optgroup',
	                    exportAs: 'matOptgroup',
	                    template: "<label class=\"mat-optgroup-label\" [id]=\"_labelId\">{{ label }}</label><ng-content select=\"mat-option, ng-container\"></ng-content>",
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    inputs: ['disabled'],
	                    styles: [".mat-optgroup-label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;line-height:48px;height:48px;padding:0 16px;text-align:left;text-decoration:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.mat-optgroup-label[disabled]{cursor:default}[dir=rtl] .mat-optgroup-label{text-align:right}.mat-optgroup-label .mat-icon{margin-right:16px;vertical-align:middle}[dir=rtl] .mat-optgroup-label .mat-icon{margin-left:16px;margin-right:0}"],
	                    host: {
	                        'class': 'mat-optgroup',
	                        'role': 'group',
	                        '[class.mat-optgroup-disabled]': 'disabled',
	                        '[attr.aria-disabled]': 'disabled.toString()',
	                        '[attr.aria-labelledby]': '_labelId',
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatOptgroup.ctorParameters = function () { return []; };
	    MatOptgroup.propDecorators = {
	        "label": [{ type: _angular_core.Input },],
	    };
	    return MatOptgroup;
	}(_MatOptgroupMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Option IDs need to be unique across components, so this counter exists outside of
	 * the component definition.
	 */
	var _uniqueIdCounter = 0;
	/**
	 * Event object emitted by MatOption when selected or deselected.
	 */
	var MatOptionSelectionChange = /** @class */ (function () {
	    function MatOptionSelectionChange(source, isUserInput) {
	        if (isUserInput === void 0) { isUserInput = false; }
	        this.source = source;
	        this.isUserInput = isUserInput;
	    }
	    return MatOptionSelectionChange;
	}());
	/**
	 * Describes a parent component that manages a list of options.
	 * Contains properties that the options can inherit.
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * Injection token used to provide the parent component to options.
	 */
	var MAT_OPTION_PARENT_COMPONENT = new _angular_core.InjectionToken('MAT_OPTION_PARENT_COMPONENT');
	/**
	 * Single option inside of a `<mat-select>` element.
	 */
	var MatOption = /** @class */ (function () {
	    function MatOption(_element, _changeDetectorRef, _parent, group) {
	        this._element = _element;
	        this._changeDetectorRef = _changeDetectorRef;
	        this._parent = _parent;
	        this.group = group;
	        this._selected = false;
	        this._active = false;
	        this._disabled = false;
	        this._id = "mat-option-" + _uniqueIdCounter++;
	        this._mostRecentViewValue = '';
	        /**
	         * Event emitted when the option is selected or deselected.
	         */
	        this.onSelectionChange = new _angular_core.EventEmitter();
	        /**
	         * Emits when the state of the option changes and any parents have to be notified.
	         */
	        this._stateChanges = new rxjs_Subject.Subject();
	    }
	    Object.defineProperty(MatOption.prototype, "multiple", {
	        /** Whether the wrapping component is in multiple selection mode. */
	        get: /**
	         * Whether the wrapping component is in multiple selection mode.
	         * @return {?}
	         */
	        function () { return this._parent && this._parent.multiple; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatOption.prototype, "id", {
	        /** The unique ID of the option. */
	        get: /**
	         * The unique ID of the option.
	         * @return {?}
	         */
	        function () { return this._id; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatOption.prototype, "selected", {
	        /** Whether or not the option is currently selected. */
	        get: /**
	         * Whether or not the option is currently selected.
	         * @return {?}
	         */
	        function () { return this._selected; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatOption.prototype, "disabled", {
	        get: /**
	         * Whether the option is disabled.
	         * @return {?}
	         */
	        function () { return (this.group && this.group.disabled) || this._disabled; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._disabled = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatOption.prototype, "disableRipple", {
	        /** Whether ripples for the option are disabled. */
	        get: /**
	         * Whether ripples for the option are disabled.
	         * @return {?}
	         */
	        function () { return this._parent && this._parent.disableRipple; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatOption.prototype, "active", {
	        /**
	         * Whether or not the option is currently active and ready to be selected.
	         * An active option displays styles as if it is focused, but the
	         * focus is actually retained somewhere else. This comes in handy
	         * for components like autocomplete where focus must remain on the input.
	         */
	        get: /**
	         * Whether or not the option is currently active and ready to be selected.
	         * An active option displays styles as if it is focused, but the
	         * focus is actually retained somewhere else. This comes in handy
	         * for components like autocomplete where focus must remain on the input.
	         * @return {?}
	         */
	        function () {
	            return this._active;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatOption.prototype, "viewValue", {
	        /**
	         * The displayed value of the option. It is necessary to show the selected option in the
	         * select's trigger.
	         */
	        get: /**
	         * The displayed value of the option. It is necessary to show the selected option in the
	         * select's trigger.
	         * @return {?}
	         */
	        function () {
	            // TODO(kara): Add input property alternative for node envs.
	            return (this._getHostElement().textContent || '').trim();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** Selects the option. */
	    /**
	     * Selects the option.
	     * @return {?}
	     */
	    MatOption.prototype.select = /**
	     * Selects the option.
	     * @return {?}
	     */
	    function () {
	        this._selected = true;
	        this._changeDetectorRef.markForCheck();
	        this._emitSelectionChangeEvent();
	    };
	    /** Deselects the option. */
	    /**
	     * Deselects the option.
	     * @return {?}
	     */
	    MatOption.prototype.deselect = /**
	     * Deselects the option.
	     * @return {?}
	     */
	    function () {
	        this._selected = false;
	        this._changeDetectorRef.markForCheck();
	        this._emitSelectionChangeEvent();
	    };
	    /** Sets focus onto this option. */
	    /**
	     * Sets focus onto this option.
	     * @return {?}
	     */
	    MatOption.prototype.focus = /**
	     * Sets focus onto this option.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ element = this._getHostElement();
	        if (typeof element.focus === 'function') {
	            element.focus();
	        }
	    };
	    /**
	     * This method sets display styles on the option to make it appear
	     * active. This is used by the ActiveDescendantKeyManager so key
	     * events will display the proper options as active on arrow key events.
	     */
	    /**
	     * This method sets display styles on the option to make it appear
	     * active. This is used by the ActiveDescendantKeyManager so key
	     * events will display the proper options as active on arrow key events.
	     * @return {?}
	     */
	    MatOption.prototype.setActiveStyles = /**
	     * This method sets display styles on the option to make it appear
	     * active. This is used by the ActiveDescendantKeyManager so key
	     * events will display the proper options as active on arrow key events.
	     * @return {?}
	     */
	    function () {
	        if (!this._active) {
	            this._active = true;
	            this._changeDetectorRef.markForCheck();
	        }
	    };
	    /**
	     * This method removes display styles on the option that made it appear
	     * active. This is used by the ActiveDescendantKeyManager so key
	     * events will display the proper options as active on arrow key events.
	     */
	    /**
	     * This method removes display styles on the option that made it appear
	     * active. This is used by the ActiveDescendantKeyManager so key
	     * events will display the proper options as active on arrow key events.
	     * @return {?}
	     */
	    MatOption.prototype.setInactiveStyles = /**
	     * This method removes display styles on the option that made it appear
	     * active. This is used by the ActiveDescendantKeyManager so key
	     * events will display the proper options as active on arrow key events.
	     * @return {?}
	     */
	    function () {
	        if (this._active) {
	            this._active = false;
	            this._changeDetectorRef.markForCheck();
	        }
	    };
	    /** Gets the label to be used when determining whether the option should be focused. */
	    /**
	     * Gets the label to be used when determining whether the option should be focused.
	     * @return {?}
	     */
	    MatOption.prototype.getLabel = /**
	     * Gets the label to be used when determining whether the option should be focused.
	     * @return {?}
	     */
	    function () {
	        return this.viewValue;
	    };
	    /** Ensures the option is selected when activated from the keyboard. */
	    /**
	     * Ensures the option is selected when activated from the keyboard.
	     * @param {?} event
	     * @return {?}
	     */
	    MatOption.prototype._handleKeydown = /**
	     * Ensures the option is selected when activated from the keyboard.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (event.keyCode === _angular_cdk_keycodes.ENTER || event.keyCode === _angular_cdk_keycodes.SPACE) {
	            this._selectViaInteraction();
	            // Prevent the page from scrolling down and form submits.
	            event.preventDefault();
	        }
	    };
	    /**
	     * `Selects the option while indicating the selection came from the user. Used to
	     * determine if the select's view -> model callback should be invoked.`
	     */
	    /**
	     * `Selects the option while indicating the selection came from the user. Used to
	     * determine if the select's view -> model callback should be invoked.`
	     * @return {?}
	     */
	    MatOption.prototype._selectViaInteraction = /**
	     * `Selects the option while indicating the selection came from the user. Used to
	     * determine if the select's view -> model callback should be invoked.`
	     * @return {?}
	     */
	    function () {
	        if (!this.disabled) {
	            this._selected = this.multiple ? !this._selected : true;
	            this._changeDetectorRef.markForCheck();
	            this._emitSelectionChangeEvent(true);
	        }
	    };
	    /** Returns the correct tabindex for the option depending on disabled state. */
	    /**
	     * Returns the correct tabindex for the option depending on disabled state.
	     * @return {?}
	     */
	    MatOption.prototype._getTabIndex = /**
	     * Returns the correct tabindex for the option depending on disabled state.
	     * @return {?}
	     */
	    function () {
	        return this.disabled ? '-1' : '0';
	    };
	    /** Gets the host DOM element. */
	    /**
	     * Gets the host DOM element.
	     * @return {?}
	     */
	    MatOption.prototype._getHostElement = /**
	     * Gets the host DOM element.
	     * @return {?}
	     */
	    function () {
	        return this._element.nativeElement;
	    };
	    /**
	     * @return {?}
	     */
	    MatOption.prototype.ngAfterViewChecked = /**
	     * @return {?}
	     */
	    function () {
	        // Since parent components could be using the option's label to display the selected values
	        // (e.g. `mat-select`) and they don't have a way of knowing if the option's label has changed
	        // we have to check for changes in the DOM ourselves and dispatch an event. These checks are
	        // relatively cheap, however we still limit them only to selected options in order to avoid
	        // hitting the DOM too often.
	        if (this._selected) {
	            var /** @type {?} */ viewValue = this.viewValue;
	            if (viewValue !== this._mostRecentViewValue) {
	                this._mostRecentViewValue = viewValue;
	                this._stateChanges.next();
	            }
	        }
	    };
	    /**
	     * Emits the selection change event.
	     * @param {?=} isUserInput
	     * @return {?}
	     */
	    MatOption.prototype._emitSelectionChangeEvent = /**
	     * Emits the selection change event.
	     * @param {?=} isUserInput
	     * @return {?}
	     */
	    function (isUserInput) {
	        if (isUserInput === void 0) { isUserInput = false; }
	        this.onSelectionChange.emit(new MatOptionSelectionChange(this, isUserInput));
	    };
	    MatOption.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-option',
	                    exportAs: 'matOption',
	                    host: {
	                        'role': 'option',
	                        '[attr.tabindex]': '_getTabIndex()',
	                        '[class.mat-selected]': 'selected',
	                        '[class.mat-option-multiple]': 'multiple',
	                        '[class.mat-active]': 'active',
	                        '[id]': 'id',
	                        '[attr.aria-selected]': 'selected.toString()',
	                        '[attr.aria-disabled]': 'disabled.toString()',
	                        '[class.mat-option-disabled]': 'disabled',
	                        '(click)': '_selectViaInteraction()',
	                        '(keydown)': '_handleKeydown($event)',
	                        'class': 'mat-option',
	                    },
	                    styles: [".mat-option{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;line-height:48px;height:48px;padding:0 16px;text-align:left;text-decoration:none;position:relative;cursor:pointer;outline:0;display:flex;flex-direction:row;max-width:100%;box-sizing:border-box;align-items:center}.mat-option[disabled]{cursor:default}[dir=rtl] .mat-option{text-align:right}.mat-option .mat-icon{margin-right:16px;vertical-align:middle}[dir=rtl] .mat-option .mat-icon{margin-left:16px;margin-right:0}.mat-option[aria-disabled=true]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.mat-optgroup .mat-option:not(.mat-option-multiple){padding-left:32px}[dir=rtl] .mat-optgroup .mat-option:not(.mat-option-multiple){padding-left:16px;padding-right:32px}.mat-option-text{display:inline-block;flex-grow:1;overflow:hidden;text-overflow:ellipsis}.mat-option-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}@media screen and (-ms-high-contrast:active){.mat-option-ripple{opacity:.5}}.mat-option-pseudo-checkbox{margin-right:8px}[dir=rtl] .mat-option-pseudo-checkbox{margin-left:8px;margin-right:0}"],
	                    template: "<mat-pseudo-checkbox *ngIf=\"multiple\" class=\"mat-option-pseudo-checkbox\" [state]=\"selected ? 'checked' : ''\" [disabled]=\"disabled\"></mat-pseudo-checkbox><span class=\"mat-option-text\"><ng-content></ng-content></span><div class=\"mat-option-ripple\" mat-ripple [matRippleTrigger]=\"_getHostElement()\" [matRippleDisabled]=\"disabled || disableRipple\"></div>",
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatOption.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MAT_OPTION_PARENT_COMPONENT,] },] },
	        { type: MatOptgroup, decorators: [{ type: _angular_core.Optional },] },
	    ]; };
	    MatOption.propDecorators = {
	        "value": [{ type: _angular_core.Input },],
	        "disabled": [{ type: _angular_core.Input },],
	        "onSelectionChange": [{ type: _angular_core.Output },],
	    };
	    return MatOption;
	}());
	/**
	 * Counts the amount of option group labels that precede the specified option.
	 * \@docs-private
	 * @param {?} optionIndex Index of the option at which to start counting.
	 * @param {?} options Flat list of all of the options.
	 * @param {?} optionGroups Flat list of all of the option groups.
	 * @return {?}
	 */
	function _countGroupLabelsBeforeOption(optionIndex, options, optionGroups) {
	    if (optionGroups.length) {
	        var /** @type {?} */ optionsArray = options.toArray();
	        var /** @type {?} */ groups = optionGroups.toArray();
	        var /** @type {?} */ groupCounter = 0;
	        for (var /** @type {?} */ i = 0; i < optionIndex + 1; i++) {
	            if (optionsArray[i].group && optionsArray[i].group === groups[groupCounter]) {
	                groupCounter++;
	            }
	        }
	        return groupCounter;
	    }
	    return 0;
	}
	/**
	 * Determines the position to which to scroll a panel in order for an option to be into view.
	 * \@docs-private
	 * @param {?} optionIndex Index of the option to be scrolled into the view.
	 * @param {?} optionHeight Height of the options.
	 * @param {?} currentScrollPosition Current scroll position of the panel.
	 * @param {?} panelHeight Height of the panel.
	 * @return {?}
	 */
	function _getOptionScrollPosition(optionIndex, optionHeight, currentScrollPosition, panelHeight) {
	    var /** @type {?} */ optionOffset = optionIndex * optionHeight;
	    if (optionOffset < currentScrollPosition) {
	        return optionOffset;
	    }
	    if (optionOffset + optionHeight > currentScrollPosition + panelHeight) {
	        return Math.max(0, optionOffset - panelHeight + optionHeight);
	    }
	    return currentScrollPosition;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatOptionModule = /** @class */ (function () {
	    function MatOptionModule() {
	    }
	    MatOptionModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [MatRippleModule, _angular_common.CommonModule, MatPseudoCheckboxModule],
	                    exports: [MatOption, MatOptgroup],
	                    declarations: [MatOption, MatOptgroup]
	                },] },
	    ];
	    /** @nocollapse */
	    MatOptionModule.ctorParameters = function () { return []; };
	    return MatOptionModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * InjectionToken that can be used to specify the global label options.
	 */
	var MAT_LABEL_GLOBAL_OPTIONS = new _angular_core.InjectionToken('mat-label-global-options');
	/**
	 * Configurable options for floating labels.
	 * @record
	 */
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * When constructing a Date, the month is zero-based. This can be confusing, since people are
	 * used to seeing them one-based. So we create these aliases to make writing the tests easier.
	 */
	var JAN = 0;
	var FEB = 1;
	var MAR = 2;
	var APR = 3;
	var MAY = 4;
	var JUN = 5;
	var JUL = 6;
	var AUG = 7;
	var SEP = 8;
	var OCT = 9;
	var NOV = 10;
	var DEC = 11;
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var nextUniqueId = 0;
	/**
	 * Single error message to be shown underneath the form field.
	 */
	var MatError = /** @class */ (function () {
	    function MatError() {
	        this.id = "mat-error-" + nextUniqueId++;
	    }
	    MatError.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-error',
	                    host: {
	                        'class': 'mat-error',
	                        'role': 'alert',
	                        '[attr.id]': 'id',
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatError.ctorParameters = function () { return []; };
	    MatError.propDecorators = {
	        "id": [{ type: _angular_core.Input },],
	    };
	    return MatError;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * Animations used by the MatFormField.
	 */
	var matFormFieldAnimations = {
	    /** Animation that transitions the form field's error and hint messages. */
	    transitionMessages: _angular_animations.trigger('transitionMessages', [
	        // TODO(mmalerba): Use angular animations for label animation as well.
	        _angular_animations.state('enter', _angular_animations.style({ opacity: 1, transform: 'translateY(0%)' })),
	        _angular_animations.transition('void => enter', [
	            _angular_animations.style({ opacity: 0, transform: 'translateY(-100%)' }),
	            _angular_animations.animate('300ms cubic-bezier(0.55, 0, 0.55, 0.2)'),
	        ]),
	    ])
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * An interface which allows a control to work inside of a `MatFormField`.
	 * @abstract
	 */
	var MatFormFieldControl = /** @class */ (function () {
	    function MatFormFieldControl() {
	    }
	    return MatFormFieldControl;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 * @return {?}
	 */
	function getMatFormFieldPlaceholderConflictError() {
	    return Error('Placeholder attribute and child element were both specified.');
	}
	/**
	 * \@docs-private
	 * @param {?} align
	 * @return {?}
	 */
	function getMatFormFieldDuplicatedHintError(align) {
	    return Error("A hint was already declared for 'align=\"" + align + "\"'.");
	}
	/**
	 * \@docs-private
	 * @return {?}
	 */
	function getMatFormFieldMissingControlError() {
	    return Error('mat-form-field must contain a MatFormFieldControl.');
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var nextUniqueId$2 = 0;
	/**
	 * Hint text to be shown underneath the form field control.
	 */
	var MatHint = /** @class */ (function () {
	    function MatHint() {
	        /**
	         * Whether to align the hint label at the start or end of the line.
	         */
	        this.align = 'start';
	        /**
	         * Unique ID for the hint. Used for the aria-describedby on the form field control.
	         */
	        this.id = "mat-hint-" + nextUniqueId$2++;
	    }
	    MatHint.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-hint',
	                    host: {
	                        'class': 'mat-hint',
	                        '[class.mat-right]': 'align == "end"',
	                        '[attr.id]': 'id',
	                        // Remove align attribute to prevent it from interfering with layout.
	                        '[attr.align]': 'null',
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatHint.ctorParameters = function () { return []; };
	    MatHint.propDecorators = {
	        "align": [{ type: _angular_core.Input },],
	        "id": [{ type: _angular_core.Input },],
	    };
	    return MatHint;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * The floating label for a `mat-form-field`.
	 */
	var MatLabel = /** @class */ (function () {
	    function MatLabel() {
	    }
	    MatLabel.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-label'
	                },] },
	    ];
	    /** @nocollapse */
	    MatLabel.ctorParameters = function () { return []; };
	    return MatLabel;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * The placeholder text for an `MatFormField`.
	 */
	var MatPlaceholder = /** @class */ (function () {
	    function MatPlaceholder() {
	    }
	    MatPlaceholder.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-placeholder'
	                },] },
	    ];
	    /** @nocollapse */
	    MatPlaceholder.ctorParameters = function () { return []; };
	    return MatPlaceholder;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Prefix to be placed the the front of the form field.
	 */
	var MatPrefix = /** @class */ (function () {
	    function MatPrefix() {
	    }
	    MatPrefix.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[matPrefix]',
	                },] },
	    ];
	    /** @nocollapse */
	    MatPrefix.ctorParameters = function () { return []; };
	    return MatPrefix;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Suffix to be placed at the end of the form field.
	 */
	var MatSuffix = /** @class */ (function () {
	    function MatSuffix() {
	    }
	    MatSuffix.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[matSuffix]',
	                },] },
	    ];
	    /** @nocollapse */
	    MatSuffix.ctorParameters = function () { return []; };
	    return MatSuffix;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 */
	var MatFormFieldBase = /** @class */ (function () {
	    function MatFormFieldBase(_elementRef) {
	        this._elementRef = _elementRef;
	    }
	    return MatFormFieldBase;
	}());
	var _MatFormFieldMixinBase = mixinColor(MatFormFieldBase, 'primary');
	var nextUniqueId$1 = 0;
	/**
	 * Container for form controls that applies Material Design styling and behavior.
	 */
	var MatFormField = /** @class */ (function (_super) {
	    __extends(MatFormField, _super);
	    function MatFormField(_elementRef, _changeDetectorRef, labelOptions) {
	        var _this = _super.call(this, _elementRef) || this;
	        _this._elementRef = _elementRef;
	        _this._changeDetectorRef = _changeDetectorRef;
	        /**
	         * Override for the logic that disables the label animation in certain cases.
	         */
	        _this._showAlwaysAnimate = false;
	        /**
	         * State of the mat-hint and mat-error animations.
	         */
	        _this._subscriptAnimationState = '';
	        _this._hintLabel = '';
	        // Unique id for the hint label.
	        _this._hintLabelId = "mat-hint-" + nextUniqueId$1++;
	        _this._labelOptions = labelOptions ? labelOptions : {};
	        _this.floatLabel = _this._labelOptions.float || 'auto';
	        return _this;
	    }
	    Object.defineProperty(MatFormField.prototype, "dividerColor", {
	        get: /**
	         * @deprecated Use `color` instead.
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this.color; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this.color = value; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatFormField.prototype, "hideRequiredMarker", {
	        get: /**
	         * Whether the required marker should be hidden.
	         * @return {?}
	         */
	        function () { return this._hideRequiredMarker; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._hideRequiredMarker = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatFormField.prototype, "_shouldAlwaysFloat", {
	        /** Whether the floating label should always float or not. */
	        get: /**
	         * Whether the floating label should always float or not.
	         * @return {?}
	         */
	        function () {
	            return this._floatLabel === 'always' && !this._showAlwaysAnimate;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatFormField.prototype, "_canLabelFloat", {
	        /** Whether the label can float or not. */
	        get: /**
	         * Whether the label can float or not.
	         * @return {?}
	         */
	        function () { return this._floatLabel !== 'never'; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatFormField.prototype, "hintLabel", {
	        get: /**
	         * Text for the form field hint.
	         * @return {?}
	         */
	        function () { return this._hintLabel; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._hintLabel = value;
	            this._processHints();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatFormField.prototype, "floatPlaceholder", {
	        get: /**
	         * Whether the placeholder should always float, never float or float as the user types.
	         * @deprecated Use floatLabel instead.
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this._floatLabel; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this.floatLabel = value; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatFormField.prototype, "floatLabel", {
	        get: /**
	         * Whether the label should always float, never float or float as the user types.
	         * @return {?}
	         */
	        function () { return this._floatLabel; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (value !== this._floatLabel) {
	                this._floatLabel = value || this._labelOptions.float || 'auto';
	                this._changeDetectorRef.markForCheck();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatFormField.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._validateControlChild();
	        if (this._control.controlType) {
	            this._elementRef.nativeElement.classList
	                .add("mat-form-field-type-" + this._control.controlType);
	        }
	        // Subscribe to changes in the child control state in order to update the form field UI.
	        this._control.stateChanges.pipe(rxjs_operators_startWith.startWith(/** @type {?} */ ((null)))).subscribe(function () {
	            _this._validatePlaceholders();
	            _this._syncDescribedByIds();
	            _this._changeDetectorRef.markForCheck();
	        });
	        var /** @type {?} */ ngControl = this._control.ngControl;
	        if (ngControl && ngControl.valueChanges) {
	            ngControl.valueChanges.subscribe(function () {
	                _this._changeDetectorRef.markForCheck();
	            });
	        }
	        // Re-validate when the number of hints changes.
	        this._hintChildren.changes.pipe(rxjs_operators_startWith.startWith(null)).subscribe(function () {
	            _this._processHints();
	            _this._changeDetectorRef.markForCheck();
	        });
	        // Update the aria-described by when the number of errors changes.
	        this._errorChildren.changes.pipe(rxjs_operators_startWith.startWith(null)).subscribe(function () {
	            _this._syncDescribedByIds();
	            _this._changeDetectorRef.markForCheck();
	        });
	    };
	    /**
	     * @return {?}
	     */
	    MatFormField.prototype.ngAfterContentChecked = /**
	     * @return {?}
	     */
	    function () {
	        this._validateControlChild();
	    };
	    /**
	     * @return {?}
	     */
	    MatFormField.prototype.ngAfterViewInit = /**
	     * @return {?}
	     */
	    function () {
	        // Avoid animations on load.
	        this._subscriptAnimationState = 'enter';
	        this._changeDetectorRef.detectChanges();
	    };
	    /** Determines whether a class from the NgControl should be forwarded to the host element. */
	    /**
	     * Determines whether a class from the NgControl should be forwarded to the host element.
	     * @param {?} prop
	     * @return {?}
	     */
	    MatFormField.prototype._shouldForward = /**
	     * Determines whether a class from the NgControl should be forwarded to the host element.
	     * @param {?} prop
	     * @return {?}
	     */
	    function (prop) {
	        var /** @type {?} */ ngControl = this._control ? this._control.ngControl : null;
	        return ngControl && (/** @type {?} */ (ngControl))[prop];
	    };
	    /**
	     * @return {?}
	     */
	    MatFormField.prototype._hasPlaceholder = /**
	     * @return {?}
	     */
	    function () {
	        return !!(this._control.placeholder || this._placeholderChild);
	    };
	    /**
	     * @return {?}
	     */
	    MatFormField.prototype._hasLabel = /**
	     * @return {?}
	     */
	    function () {
	        return !!this._labelChild;
	    };
	    /**
	     * @return {?}
	     */
	    MatFormField.prototype._shouldLabelFloat = /**
	     * @return {?}
	     */
	    function () {
	        return this._canLabelFloat && (this._control.shouldLabelFloat ||
	            this._control.shouldPlaceholderFloat || this._shouldAlwaysFloat);
	    };
	    /**
	     * @return {?}
	     */
	    MatFormField.prototype._hideControlPlaceholder = /**
	     * @return {?}
	     */
	    function () {
	        return !this._hasLabel() || !this._shouldLabelFloat();
	    };
	    /**
	     * @return {?}
	     */
	    MatFormField.prototype._hasFloatingLabel = /**
	     * @return {?}
	     */
	    function () {
	        return this._hasLabel() || this._hasPlaceholder();
	    };
	    /** Determines whether to display hints or errors. */
	    /**
	     * Determines whether to display hints or errors.
	     * @return {?}
	     */
	    MatFormField.prototype._getDisplayedMessages = /**
	     * Determines whether to display hints or errors.
	     * @return {?}
	     */
	    function () {
	        return (this._errorChildren && this._errorChildren.length > 0 &&
	            this._control.errorState) ? 'error' : 'hint';
	    };
	    /** Animates the placeholder up and locks it in position. */
	    /**
	     * Animates the placeholder up and locks it in position.
	     * @return {?}
	     */
	    MatFormField.prototype._animateAndLockLabel = /**
	     * Animates the placeholder up and locks it in position.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._hasFloatingLabel() && this._canLabelFloat) {
	            this._showAlwaysAnimate = true;
	            this._floatLabel = 'always';
	            rxjs_observable_fromEvent.fromEvent(this._label.nativeElement, 'transitionend').pipe(rxjs_operators_take.take(1)).subscribe(function () {
	                _this._showAlwaysAnimate = false;
	            });
	            this._changeDetectorRef.markForCheck();
	        }
	    };
	    /**
	     * Ensure that there is only one placeholder (either `placeholder` attribute on the child control
	     * or child element with the `mat-placeholder` directive).
	     * @return {?}
	     */
	    MatFormField.prototype._validatePlaceholders = /**
	     * Ensure that there is only one placeholder (either `placeholder` attribute on the child control
	     * or child element with the `mat-placeholder` directive).
	     * @return {?}
	     */
	    function () {
	        if (this._control.placeholder && this._placeholderChild) {
	            throw getMatFormFieldPlaceholderConflictError();
	        }
	    };
	    /**
	     * Does any extra processing that is required when handling the hints.
	     * @return {?}
	     */
	    MatFormField.prototype._processHints = /**
	     * Does any extra processing that is required when handling the hints.
	     * @return {?}
	     */
	    function () {
	        this._validateHints();
	        this._syncDescribedByIds();
	    };
	    /**
	     * Ensure that there is a maximum of one of each `<mat-hint>` alignment specified, with the
	     * attribute being considered as `align="start"`.
	     * @return {?}
	     */
	    MatFormField.prototype._validateHints = /**
	     * Ensure that there is a maximum of one of each `<mat-hint>` alignment specified, with the
	     * attribute being considered as `align="start"`.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._hintChildren) {
	            var /** @type {?} */ startHint_1;
	            var /** @type {?} */ endHint_1;
	            this._hintChildren.forEach(function (hint) {
	                if (hint.align === 'start') {
	                    if (startHint_1 || _this.hintLabel) {
	                        throw getMatFormFieldDuplicatedHintError('start');
	                    }
	                    startHint_1 = hint;
	                }
	                else if (hint.align === 'end') {
	                    if (endHint_1) {
	                        throw getMatFormFieldDuplicatedHintError('end');
	                    }
	                    endHint_1 = hint;
	                }
	            });
	        }
	    };
	    /**
	     * Sets the list of element IDs that describe the child control. This allows the control to update
	     * its `aria-describedby` attribute accordingly.
	     * @return {?}
	     */
	    MatFormField.prototype._syncDescribedByIds = /**
	     * Sets the list of element IDs that describe the child control. This allows the control to update
	     * its `aria-describedby` attribute accordingly.
	     * @return {?}
	     */
	    function () {
	        if (this._control) {
	            var /** @type {?} */ ids = [];
	            if (this._getDisplayedMessages() === 'hint') {
	                var /** @type {?} */ startHint = this._hintChildren ?
	                    this._hintChildren.find(function (hint) { return hint.align === 'start'; }) : null;
	                var /** @type {?} */ endHint = this._hintChildren ?
	                    this._hintChildren.find(function (hint) { return hint.align === 'end'; }) : null;
	                if (startHint) {
	                    ids.push(startHint.id);
	                }
	                else if (this._hintLabel) {
	                    ids.push(this._hintLabelId);
	                }
	                if (endHint) {
	                    ids.push(endHint.id);
	                }
	            }
	            else if (this._errorChildren) {
	                ids = this._errorChildren.map(function (error) { return error.id; });
	            }
	            this._control.setDescribedByIds(ids);
	        }
	    };
	    /** Throws an error if the form field's control is missing. */
	    /**
	     * Throws an error if the form field's control is missing.
	     * @return {?}
	     */
	    MatFormField.prototype._validateControlChild = /**
	     * Throws an error if the form field's control is missing.
	     * @return {?}
	     */
	    function () {
	        if (!this._control) {
	            throw getMatFormFieldMissingControlError();
	        }
	    };
	    MatFormField.decorators = [
	        { type: _angular_core.Component, args: [{// TODO(mmalerba): the input-container selectors and classes are deprecated and will be removed.
	                    selector: 'mat-input-container, mat-form-field',
	                    exportAs: 'matFormField',
	                    template: "<div class=\"mat-input-wrapper mat-form-field-wrapper\"><div class=\"mat-input-flex mat-form-field-flex\" #connectionContainer (click)=\"_control.onContainerClick && _control.onContainerClick($event)\"><div class=\"mat-input-prefix mat-form-field-prefix\" *ngIf=\"_prefixChildren.length\"><ng-content select=\"[matPrefix]\"></ng-content></div><div class=\"mat-input-infix mat-form-field-infix\" #inputContainer><ng-content></ng-content><span class=\"mat-form-field-label-wrapper mat-input-placeholder-wrapper mat-form-field-placeholder-wrapper\"><label class=\"mat-form-field-label mat-input-placeholder mat-form-field-placeholder\" [attr.for]=\"_control.id\" [attr.aria-owns]=\"_control.id\" [class.mat-empty]=\"_control.empty && !_shouldAlwaysFloat\" [class.mat-form-field-empty]=\"_control.empty && !_shouldAlwaysFloat\" [class.mat-accent]=\"color == 'accent'\" [class.mat-warn]=\"color == 'warn'\" #label *ngIf=\"_hasFloatingLabel()\" [ngSwitch]=\"_hasLabel()\"><ng-container *ngSwitchCase=\"false\"><ng-content select=\"mat-placeholder\"></ng-content>{{_control.placeholder}}</ng-container><ng-content select=\"mat-label\" *ngSwitchCase=\"true\"></ng-content><span class=\"mat-placeholder-required mat-form-field-required-marker\" aria-hidden=\"true\" *ngIf=\"!hideRequiredMarker && _control.required && !_control.disabled\">&nbsp;*</span></label></span></div><div class=\"mat-input-suffix mat-form-field-suffix\" *ngIf=\"_suffixChildren.length\"><ng-content select=\"[matSuffix]\"></ng-content></div></div><div class=\"mat-input-underline mat-form-field-underline\" #underline><span class=\"mat-input-ripple mat-form-field-ripple\" [class.mat-accent]=\"color == 'accent'\" [class.mat-warn]=\"color == 'warn'\"></span></div><div class=\"mat-input-subscript-wrapper mat-form-field-subscript-wrapper\" [ngSwitch]=\"_getDisplayedMessages()\"><div *ngSwitchCase=\"'error'\" [@transitionMessages]=\"_subscriptAnimationState\"><ng-content select=\"mat-error\"></ng-content></div><div class=\"mat-input-hint-wrapper mat-form-field-hint-wrapper\" *ngSwitchCase=\"'hint'\" [@transitionMessages]=\"_subscriptAnimationState\"><div *ngIf=\"hintLabel\" [id]=\"_hintLabelId\" class=\"mat-hint\">{{hintLabel}}</div><ng-content select=\"mat-hint:not([align='end'])\"></ng-content><div class=\"mat-input-hint-spacer mat-form-field-hint-spacer\"></div><ng-content select=\"mat-hint[align='end']\"></ng-content></div></div></div>",
	                    // MatInput is a directive and can't have styles, so we need to include its styles here.
	                    // The MatInput styles are fairly minimal so it shouldn't be a big deal for people who
	                    // aren't using MatInput.
	                    styles: [".mat-form-field{display:inline-block;position:relative;text-align:left}[dir=rtl] .mat-form-field{text-align:right}.mat-form-field-wrapper{position:relative}.mat-form-field-flex{display:inline-flex;align-items:baseline;width:100%}.mat-form-field-prefix,.mat-form-field-suffix{white-space:nowrap;flex:none}.mat-form-field-prefix .mat-icon,.mat-form-field-suffix .mat-icon{width:1em}.mat-form-field-prefix .mat-icon-button,.mat-form-field-suffix .mat-icon-button{font:inherit;vertical-align:baseline}.mat-form-field-prefix .mat-icon-button .mat-icon,.mat-form-field-suffix .mat-icon-button .mat-icon{font-size:inherit}.mat-form-field-infix{display:block;position:relative;flex:auto;min-width:0;width:180px}.mat-form-field-label-wrapper{position:absolute;left:0;box-sizing:content-box;width:100%;height:100%;overflow:hidden;pointer-events:none}.mat-form-field-label{position:absolute;left:0;font:inherit;pointer-events:none;width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;transform:perspective(100px);-ms-transform:none;transform-origin:0 0;transition:transform .4s cubic-bezier(.25,.8,.25,1),color .4s cubic-bezier(.25,.8,.25,1),width .4s cubic-bezier(.25,.8,.25,1);display:none}[dir=rtl] .mat-form-field-label{transform-origin:100% 0;left:auto;right:0}.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-empty.mat-form-field-label{display:block}.mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{display:none}.mat-form-field-can-float .mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{display:block;transition:none}.mat-input-server:focus+.mat-form-field-placeholder-wrapper .mat-form-field-placeholder,.mat-input-server[placeholder]:not(:placeholder-shown)+.mat-form-field-placeholder-wrapper .mat-form-field-placeholder{display:none}.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-placeholder-wrapper .mat-form-field-placeholder,.mat-form-field-can-float .mat-input-server[placeholder]:not(:placeholder-shown)+.mat-form-field-placeholder-wrapper .mat-form-field-placeholder{display:block}.mat-form-field-label:not(.mat-form-field-empty){transition:none}.mat-form-field-underline{position:absolute;height:1px;width:100%}.mat-form-field-disabled .mat-form-field-underline{background-position:0;background-color:transparent}.mat-form-field-underline .mat-form-field-ripple{position:absolute;top:0;left:0;width:100%;height:2px;transform-origin:50%;transform:scaleX(.5);visibility:hidden;opacity:0;transition:background-color .3s cubic-bezier(.55,0,.55,.2)}.mat-form-field-invalid:not(.mat-focused) .mat-form-field-underline .mat-form-field-ripple{height:1px}.mat-focused .mat-form-field-underline .mat-form-field-ripple,.mat-form-field-invalid .mat-form-field-underline .mat-form-field-ripple{visibility:visible;opacity:1;transform:scaleX(1);transition:transform .3s cubic-bezier(.25,.8,.25,1),opacity .1s cubic-bezier(.25,.8,.25,1),background-color .3s cubic-bezier(.25,.8,.25,1)}.mat-form-field-subscript-wrapper{position:absolute;width:100%;overflow:hidden}.mat-form-field-label-wrapper .mat-icon,.mat-form-field-subscript-wrapper .mat-icon{width:1em;height:1em;font-size:inherit;vertical-align:baseline}.mat-form-field-hint-wrapper{display:flex}.mat-form-field-hint-spacer{flex:1 0 1em}.mat-error{display:block} .mat-input-element{font:inherit;background:0 0;color:currentColor;border:none;outline:0;padding:0;margin:0;width:100%;max-width:100%;vertical-align:bottom;text-align:inherit}.mat-input-element:-moz-ui-invalid{box-shadow:none}.mat-input-element::-ms-clear,.mat-input-element::-ms-reveal{display:none}.mat-input-element[type=date]::after,.mat-input-element[type=datetime-local]::after,.mat-input-element[type=datetime]::after,.mat-input-element[type=month]::after,.mat-input-element[type=time]::after,.mat-input-element[type=week]::after{content:' ';white-space:pre;width:1px}.mat-input-element::placeholder{transition:color .4s .133s cubic-bezier(.25,.8,.25,1)}.mat-input-element::-moz-placeholder{transition:color .4s .133s cubic-bezier(.25,.8,.25,1)}.mat-input-element::-webkit-input-placeholder{transition:color .4s .133s cubic-bezier(.25,.8,.25,1)}.mat-input-element:-ms-input-placeholder{transition:color .4s .133s cubic-bezier(.25,.8,.25,1)}.mat-form-field-hide-placeholder .mat-input-element::placeholder{color:transparent!important;transition:none}.mat-form-field-hide-placeholder .mat-input-element::-moz-placeholder{color:transparent!important;transition:none}.mat-form-field-hide-placeholder .mat-input-element::-webkit-input-placeholder{color:transparent!important;transition:none}.mat-form-field-hide-placeholder .mat-input-element:-ms-input-placeholder{color:transparent!important;transition:none}textarea.mat-input-element{resize:vertical;overflow:auto}textarea.mat-autosize{resize:none}"],
	                    animations: [matFormFieldAnimations.transitionMessages],
	                    host: {
	                        'class': 'mat-input-container mat-form-field',
	                        '[class.mat-input-invalid]': '_control.errorState',
	                        '[class.mat-form-field-invalid]': '_control.errorState',
	                        '[class.mat-form-field-can-float]': '_canLabelFloat',
	                        '[class.mat-form-field-should-float]': '_shouldLabelFloat()',
	                        '[class.mat-form-field-hide-placeholder]': '_hideControlPlaceholder()',
	                        '[class.mat-form-field-disabled]': '_control.disabled',
	                        '[class.mat-focused]': '_control.focused',
	                        '[class.ng-untouched]': '_shouldForward("untouched")',
	                        '[class.ng-touched]': '_shouldForward("touched")',
	                        '[class.ng-pristine]': '_shouldForward("pristine")',
	                        '[class.ng-dirty]': '_shouldForward("dirty")',
	                        '[class.ng-valid]': '_shouldForward("valid")',
	                        '[class.ng-invalid]': '_shouldForward("invalid")',
	                        '[class.ng-pending]': '_shouldForward("pending")',
	                    },
	                    inputs: ['color'],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatFormField.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MAT_LABEL_GLOBAL_OPTIONS,] },] },
	    ]; };
	    MatFormField.propDecorators = {
	        "dividerColor": [{ type: _angular_core.Input },],
	        "hideRequiredMarker": [{ type: _angular_core.Input },],
	        "hintLabel": [{ type: _angular_core.Input },],
	        "floatPlaceholder": [{ type: _angular_core.Input },],
	        "floatLabel": [{ type: _angular_core.Input },],
	        "underlineRef": [{ type: _angular_core.ViewChild, args: ['underline',] },],
	        "_connectionContainerRef": [{ type: _angular_core.ViewChild, args: ['connectionContainer',] },],
	        "_inputContainerRef": [{ type: _angular_core.ViewChild, args: ['inputContainer',] },],
	        "_label": [{ type: _angular_core.ViewChild, args: ['label',] },],
	        "_control": [{ type: _angular_core.ContentChild, args: [MatFormFieldControl,] },],
	        "_placeholderChild": [{ type: _angular_core.ContentChild, args: [MatPlaceholder,] },],
	        "_labelChild": [{ type: _angular_core.ContentChild, args: [MatLabel,] },],
	        "_errorChildren": [{ type: _angular_core.ContentChildren, args: [MatError,] },],
	        "_hintChildren": [{ type: _angular_core.ContentChildren, args: [MatHint,] },],
	        "_prefixChildren": [{ type: _angular_core.ContentChildren, args: [MatPrefix,] },],
	        "_suffixChildren": [{ type: _angular_core.ContentChildren, args: [MatSuffix,] },],
	    };
	    return MatFormField;
	}(_MatFormFieldMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatFormFieldModule = /** @class */ (function () {
	    function MatFormFieldModule() {
	    }
	    MatFormFieldModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    declarations: [
	                        MatError,
	                        MatHint,
	                        MatFormField,
	                        MatPlaceholder,
	                        MatPrefix,
	                        MatSuffix,
	                        MatLabel,
	                    ],
	                    imports: [
	                        _angular_common.CommonModule,
	                        _angular_cdk_platform.PlatformModule,
	                    ],
	                    exports: [
	                        MatError,
	                        MatHint,
	                        MatFormField,
	                        MatPlaceholder,
	                        MatPrefix,
	                        MatSuffix,
	                        MatLabel,
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    MatFormFieldModule.ctorParameters = function () { return []; };
	    return MatFormFieldModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * Autocomplete IDs need to be unique across components, so this counter exists outside of
	 * the component definition.
	 */
	var _uniqueAutocompleteIdCounter = 0;
	/**
	 * Event object that is emitted when an autocomplete option is selected.
	 */
	var MatAutocompleteSelectedEvent = /** @class */ (function () {
	    function MatAutocompleteSelectedEvent(source, option) {
	        this.source = source;
	        this.option = option;
	    }
	    return MatAutocompleteSelectedEvent;
	}());
	/**
	 * \@docs-private
	 */
	var MatAutocompleteBase = /** @class */ (function () {
	    function MatAutocompleteBase() {
	    }
	    return MatAutocompleteBase;
	}());
	var _MatAutocompleteMixinBase = mixinDisableRipple(MatAutocompleteBase);
	/**
	 * Default `mat-autocomplete` options that can be overridden.
	 * @record
	 */
	
	/**
	 * Injection token to be used to override the default options for `mat-autocomplete`.
	 */
	var MAT_AUTOCOMPLETE_DEFAULT_OPTIONS = new _angular_core.InjectionToken('mat-autocomplete-default-options');
	var MatAutocomplete = /** @class */ (function (_super) {
	    __extends(MatAutocomplete, _super);
	    function MatAutocomplete(_changeDetectorRef, _elementRef, 
	        // @deletion-target Turn into required param in 6.0.0
	        defaults) {
	        var _this = _super.call(this) || this;
	        _this._changeDetectorRef = _changeDetectorRef;
	        _this._elementRef = _elementRef;
	        /**
	         * Whether the autocomplete panel should be visible, depending on option length.
	         */
	        _this.showPanel = false;
	        _this._isOpen = false;
	        /**
	         * Function that maps an option's control value to its display value in the trigger.
	         */
	        _this.displayWith = null;
	        /**
	         * Event that is emitted whenever an option from the list is selected.
	         */
	        _this.optionSelected = new _angular_core.EventEmitter();
	        _this._classList = {};
	        /**
	         * Unique ID to be used by autocomplete trigger's "aria-owns" property.
	         */
	        _this.id = "mat-autocomplete-" + _uniqueAutocompleteIdCounter++;
	        _this._autoActiveFirstOption = defaults &&
	            typeof defaults.autoActiveFirstOption !== 'undefined' ?
	            defaults.autoActiveFirstOption :
	            false;
	        return _this;
	    }
	    Object.defineProperty(MatAutocomplete.prototype, "isOpen", {
	        /** Whether the autocomplete panel is open. */
	        get: /**
	         * Whether the autocomplete panel is open.
	         * @return {?}
	         */
	        function () { return this._isOpen && this.showPanel; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatAutocomplete.prototype, "autoActiveFirstOption", {
	        get: /**
	         * Whether the first option should be highlighted when the autocomplete panel is opened.
	         * Can be configured globally through the `MAT_AUTOCOMPLETE_DEFAULT_OPTIONS` token.
	         * @return {?}
	         */
	        function () { return this._autoActiveFirstOption; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._autoActiveFirstOption = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatAutocomplete.prototype, "classList", {
	        set: /**
	         * Takes classes set on the host mat-autocomplete element and applies them to the panel
	         * inside the overlay container to allow for easy styling.
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            var _this = this;
	            if (value && value.length) {
	                value.split(' ').forEach(function (className) { return _this._classList[className.trim()] = true; });
	                this._elementRef.nativeElement.className = '';
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatAutocomplete.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        this._keyManager = new _angular_cdk_a11y.ActiveDescendantKeyManager(this.options).withWrap();
	        // Set the initial visibiity state.
	        this._setVisibility();
	    };
	    /**
	     * Sets the panel scrollTop. This allows us to manually scroll to display options
	     * above or below the fold, as they are not actually being focused when active.
	     */
	    /**
	     * Sets the panel scrollTop. This allows us to manually scroll to display options
	     * above or below the fold, as they are not actually being focused when active.
	     * @param {?} scrollTop
	     * @return {?}
	     */
	    MatAutocomplete.prototype._setScrollTop = /**
	     * Sets the panel scrollTop. This allows us to manually scroll to display options
	     * above or below the fold, as they are not actually being focused when active.
	     * @param {?} scrollTop
	     * @return {?}
	     */
	    function (scrollTop) {
	        if (this.panel) {
	            this.panel.nativeElement.scrollTop = scrollTop;
	        }
	    };
	    /** Returns the panel's scrollTop. */
	    /**
	     * Returns the panel's scrollTop.
	     * @return {?}
	     */
	    MatAutocomplete.prototype._getScrollTop = /**
	     * Returns the panel's scrollTop.
	     * @return {?}
	     */
	    function () {
	        return this.panel ? this.panel.nativeElement.scrollTop : 0;
	    };
	    /** Panel should hide itself when the option list is empty. */
	    /**
	     * Panel should hide itself when the option list is empty.
	     * @return {?}
	     */
	    MatAutocomplete.prototype._setVisibility = /**
	     * Panel should hide itself when the option list is empty.
	     * @return {?}
	     */
	    function () {
	        this.showPanel = !!this.options.length;
	        this._classList['mat-autocomplete-visible'] = this.showPanel;
	        this._classList['mat-autocomplete-hidden'] = !this.showPanel;
	        this._changeDetectorRef.markForCheck();
	    };
	    /** Emits the `select` event. */
	    /**
	     * Emits the `select` event.
	     * @param {?} option
	     * @return {?}
	     */
	    MatAutocomplete.prototype._emitSelectEvent = /**
	     * Emits the `select` event.
	     * @param {?} option
	     * @return {?}
	     */
	    function (option) {
	        var /** @type {?} */ event = new MatAutocompleteSelectedEvent(this, option);
	        this.optionSelected.emit(event);
	    };
	    MatAutocomplete.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-autocomplete',
	                    template: "<ng-template><div class=\"mat-autocomplete-panel\" role=\"listbox\" [id]=\"id\" [ngClass]=\"_classList\" #panel><ng-content></ng-content></div></ng-template>",
	                    styles: [".mat-autocomplete-panel{min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;visibility:hidden;max-width:none;max-height:256px;position:relative}.mat-autocomplete-panel:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.mat-autocomplete-panel.mat-autocomplete-visible{visibility:visible}.mat-autocomplete-panel.mat-autocomplete-hidden{visibility:hidden}"],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    exportAs: 'matAutocomplete',
	                    inputs: ['disableRipple'],
	                    host: {
	                        'class': 'mat-autocomplete'
	                    },
	                    providers: [
	                        { provide: MAT_OPTION_PARENT_COMPONENT, useExisting: MatAutocomplete }
	                    ]
	                },] },
	    ];
	    /** @nocollapse */
	    MatAutocomplete.ctorParameters = function () { return [
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: _angular_core.ElementRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,] },] },
	    ]; };
	    MatAutocomplete.propDecorators = {
	        "template": [{ type: _angular_core.ViewChild, args: [_angular_core.TemplateRef,] },],
	        "panel": [{ type: _angular_core.ViewChild, args: ['panel',] },],
	        "options": [{ type: _angular_core.ContentChildren, args: [MatOption, { descendants: true },] },],
	        "optionGroups": [{ type: _angular_core.ContentChildren, args: [MatOptgroup,] },],
	        "displayWith": [{ type: _angular_core.Input },],
	        "autoActiveFirstOption": [{ type: _angular_core.Input },],
	        "optionSelected": [{ type: _angular_core.Output },],
	        "classList": [{ type: _angular_core.Input, args: ['class',] },],
	    };
	    return MatAutocomplete;
	}(_MatAutocompleteMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * The height of each autocomplete option.
	 */
	var AUTOCOMPLETE_OPTION_HEIGHT = 48;
	/**
	 * The total height of the autocomplete panel.
	 */
	var AUTOCOMPLETE_PANEL_HEIGHT = 256;
	/**
	 * Injection token that determines the scroll handling while the autocomplete panel is open.
	 */
	var MAT_AUTOCOMPLETE_SCROLL_STRATEGY = new _angular_core.InjectionToken('mat-autocomplete-scroll-strategy');
	/**
	 * \@docs-private
	 * @param {?} overlay
	 * @return {?}
	 */
	function MAT_AUTOCOMPLETE_SCROLL_STRATEGY_PROVIDER_FACTORY(overlay) {
	    return function () { return overlay.scrollStrategies.reposition(); };
	}
	/**
	 * \@docs-private
	 */
	var MAT_AUTOCOMPLETE_SCROLL_STRATEGY_PROVIDER = {
	    provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
	    deps: [_angular_cdk_overlay.Overlay],
	    useFactory: MAT_AUTOCOMPLETE_SCROLL_STRATEGY_PROVIDER_FACTORY,
	};
	/**
	 * Provider that allows the autocomplete to register as a ControlValueAccessor.
	 * \@docs-private
	 */
	var MAT_AUTOCOMPLETE_VALUE_ACCESSOR = {
	    provide: _angular_forms.NG_VALUE_ACCESSOR,
	    useExisting: _angular_core.forwardRef(function () { return MatAutocompleteTrigger; }),
	    multi: true
	};
	/**
	 * Creates an error to be thrown when attempting to use an autocomplete trigger without a panel.
	 * @return {?}
	 */
	function getMatAutocompleteMissingPanelError() {
	    return Error('Attempting to open an undefined instance of `mat-autocomplete`. ' +
	        'Make sure that the id passed to the `matAutocomplete` is correct and that ' +
	        'you\'re attempting to open it after the ngAfterContentInit hook.');
	}
	var MatAutocompleteTrigger = /** @class */ (function () {
	    function MatAutocompleteTrigger(_element, _overlay, _viewContainerRef, _zone, _changeDetectorRef, _scrollStrategy, _dir, _formField, _document) {
	        var _this = this;
	        this._element = _element;
	        this._overlay = _overlay;
	        this._viewContainerRef = _viewContainerRef;
	        this._zone = _zone;
	        this._changeDetectorRef = _changeDetectorRef;
	        this._scrollStrategy = _scrollStrategy;
	        this._dir = _dir;
	        this._formField = _formField;
	        this._document = _document;
	        this._componentDestroyed = false;
	        /**
	         * Whether or not the label state is being overridden.
	         */
	        this._manuallyFloatingLabel = false;
	        /**
	         * Stream of keyboard events that can close the panel.
	         */
	        this._closeKeyEventStream = new rxjs_Subject.Subject();
	        /**
	         * `View -> model callback called when value changes`
	         */
	        this._onChange = function () { };
	        /**
	         * `View -> model callback called when autocomplete has been touched`
	         */
	        this._onTouched = function () { };
	        this._panelOpen = false;
	        /**
	         * Stream of autocomplete option selections.
	         */
	        this.optionSelections = rxjs_observable_defer.defer(function () {
	            if (_this.autocomplete && _this.autocomplete.options) {
	                return rxjs_observable_merge.merge.apply(void 0, _this.autocomplete.options.map(function (option) { return option.onSelectionChange; }));
	            }
	            // If there are any subscribers before `ngAfterViewInit`, the `autocomplete` will be undefined.
	            // Return a stream that we'll replace with the real one once everything is in place.
	            return _this._zone.onStable
	                .asObservable()
	                .pipe(rxjs_operators_take.take(1), rxjs_operators_switchMap.switchMap(function () { return _this.optionSelections; }));
	        });
	    }
	    /**
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._componentDestroyed = true;
	        this._destroyPanel();
	        this._closeKeyEventStream.complete();
	    };
	    Object.defineProperty(MatAutocompleteTrigger.prototype, "panelOpen", {
	        /** Whether or not the autocomplete panel is open. */
	        get: /**
	         * Whether or not the autocomplete panel is open.
	         * @return {?}
	         */
	        function () { return this._panelOpen && this.autocomplete.showPanel; },
	        enumerable: true,
	        configurable: true
	    });
	    /** Opens the autocomplete suggestion panel. */
	    /**
	     * Opens the autocomplete suggestion panel.
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype.openPanel = /**
	     * Opens the autocomplete suggestion panel.
	     * @return {?}
	     */
	    function () {
	        this._attachOverlay();
	        this._floatLabel();
	    };
	    /** Closes the autocomplete suggestion panel. */
	    /**
	     * Closes the autocomplete suggestion panel.
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype.closePanel = /**
	     * Closes the autocomplete suggestion panel.
	     * @return {?}
	     */
	    function () {
	        this._resetLabel();
	        if (this._panelOpen) {
	            this.autocomplete._isOpen = this._panelOpen = false;
	            if (this._overlayRef && this._overlayRef.hasAttached()) {
	                this._overlayRef.detach();
	                this._closingActionsSubscription.unsubscribe();
	            }
	            // Note that in some cases this can end up being called after the component is destroyed.
	            // Add a check to ensure that we don't try to run change detection on a destroyed view.
	            if (!this._componentDestroyed) {
	                // We need to trigger change detection manually, because
	                // `fromEvent` doesn't seem to do it at the proper time.
	                // This ensures that the label is reset when the
	                // user clicks outside.
	                this._changeDetectorRef.detectChanges();
	            }
	        }
	    };
	    Object.defineProperty(MatAutocompleteTrigger.prototype, "panelClosingActions", {
	        /**
	         * A stream of actions that should close the autocomplete panel, including
	         * when an option is selected, on blur, and when TAB is pressed.
	         */
	        get: /**
	         * A stream of actions that should close the autocomplete panel, including
	         * when an option is selected, on blur, and when TAB is pressed.
	         * @return {?}
	         */
	        function () {
	            var _this = this;
	            return rxjs_observable_merge.merge(this.optionSelections, this.autocomplete._keyManager.tabOut.pipe(rxjs_operators_filter.filter(function () { return _this._panelOpen; })), this._closeKeyEventStream, this._outsideClickStream, this._overlayRef ?
	                this._overlayRef.detachments().pipe(rxjs_operators_filter.filter(function () { return _this._panelOpen; })) :
	                rxjs_observable_of.of());
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatAutocompleteTrigger.prototype, "activeOption", {
	        /** The currently active option, coerced to MatOption type. */
	        get: /**
	         * The currently active option, coerced to MatOption type.
	         * @return {?}
	         */
	        function () {
	            if (this.autocomplete && this.autocomplete._keyManager) {
	                return this.autocomplete._keyManager.activeItem;
	            }
	            return null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatAutocompleteTrigger.prototype, "_outsideClickStream", {
	        get: /**
	         * Stream of clicks outside of the autocomplete panel.
	         * @return {?}
	         */
	        function () {
	            var _this = this;
	            if (!this._document) {
	                return rxjs_observable_of.of(null);
	            }
	            return rxjs_observable_merge.merge(rxjs_observable_fromEvent.fromEvent(this._document, 'click'), rxjs_observable_fromEvent.fromEvent(this._document, 'touchend'))
	                .pipe(rxjs_operators_filter.filter(function (event) {
	                var /** @type {?} */ clickTarget = /** @type {?} */ (event.target);
	                var /** @type {?} */ formField = _this._formField ?
	                    _this._formField._elementRef.nativeElement : null;
	                return _this._panelOpen &&
	                    clickTarget !== _this._element.nativeElement &&
	                    (!formField || !formField.contains(clickTarget)) &&
	                    (!!_this._overlayRef && !_this._overlayRef.overlayElement.contains(clickTarget));
	            }));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype.writeValue = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        var _this = this;
	        Promise.resolve(null).then(function () { return _this._setTriggerValue(value); });
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype.registerOnChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._onChange = fn;
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype.registerOnTouched = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._onTouched = fn;
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype.setDisabledState = /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    function (isDisabled) {
	        this._element.nativeElement.disabled = isDisabled;
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._handleKeydown = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var /** @type {?} */ keyCode = event.keyCode;
	        // Prevent the default action on all escape key presses. This is here primarily to bring IE
	        // in line with other browsers. By default, pressing escape on IE will cause it to revert
	        // the input value to the one that it had on focus, however it won't dispatch any events
	        // which means that the model value will be out of sync with the view.
	        if (keyCode === _angular_cdk_keycodes.ESCAPE) {
	            event.preventDefault();
	        }
	        // Close when pressing ESCAPE or ALT + UP_ARROW, based on the a11y guidelines.
	        // See: https://www.w3.org/TR/wai-aria-practices-1.1/#textbox-keyboard-interaction
	        if (this.panelOpen && (keyCode === _angular_cdk_keycodes.ESCAPE || (keyCode === _angular_cdk_keycodes.UP_ARROW && event.altKey))) {
	            this._resetActiveItem();
	            this._closeKeyEventStream.next();
	            event.stopPropagation();
	        }
	        else if (this.activeOption && keyCode === _angular_cdk_keycodes.ENTER && this.panelOpen) {
	            this.activeOption._selectViaInteraction();
	            this._resetActiveItem();
	            event.preventDefault();
	        }
	        else {
	            var /** @type {?} */ prevActiveItem = this.autocomplete._keyManager.activeItem;
	            var /** @type {?} */ isArrowKey = keyCode === _angular_cdk_keycodes.UP_ARROW || keyCode === _angular_cdk_keycodes.DOWN_ARROW;
	            if (this.panelOpen || keyCode === _angular_cdk_keycodes.TAB) {
	                this.autocomplete._keyManager.onKeydown(event);
	            }
	            else if (isArrowKey && this._canOpen()) {
	                this.openPanel();
	            }
	            if (isArrowKey || this.autocomplete._keyManager.activeItem !== prevActiveItem) {
	                this._scrollToOption();
	            }
	        }
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._handleInput = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var /** @type {?} */ target = /** @type {?} */ (event.target);
	        var /** @type {?} */ value = target.value;
	        // Based on `NumberValueAccessor` from forms.
	        if (target.type === 'number') {
	            value = value == '' ? null : parseFloat(value);
	        }
	        // If the input has a placeholder, IE will fire the `input` event on page load,
	        // focus and blur, in addition to when the user actually changed the value. To
	        // filter out all of the extra events, we save the value on focus and between
	        // `input` events, and we check whether it changed.
	        // See: https://connect.microsoft.com/IE/feedback/details/885747/
	        if (this._canOpen() && this._previousValue !== value &&
	            document.activeElement === event.target) {
	            this._previousValue = value;
	            this._onChange(value);
	            this.openPanel();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._handleFocus = /**
	     * @return {?}
	     */
	    function () {
	        if (this._canOpen()) {
	            this._previousValue = this._element.nativeElement.value;
	            this._attachOverlay();
	            this._floatLabel(true);
	        }
	    };
	    /**
	     * In "auto" mode, the label will animate down as soon as focus is lost.
	     * This causes the value to jump when selecting an option with the mouse.
	     * This method manually floats the label until the panel can be closed.
	     * @param {?=} shouldAnimate Whether the label should be animated when it is floated.
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._floatLabel = /**
	     * In "auto" mode, the label will animate down as soon as focus is lost.
	     * This causes the value to jump when selecting an option with the mouse.
	     * This method manually floats the label until the panel can be closed.
	     * @param {?=} shouldAnimate Whether the label should be animated when it is floated.
	     * @return {?}
	     */
	    function (shouldAnimate) {
	        if (shouldAnimate === void 0) { shouldAnimate = false; }
	        if (this._formField && this._formField.floatLabel === 'auto') {
	            if (shouldAnimate) {
	                this._formField._animateAndLockLabel();
	            }
	            else {
	                this._formField.floatLabel = 'always';
	            }
	            this._manuallyFloatingLabel = true;
	        }
	    };
	    /**
	     * If the label has been manually elevated, return it to its normal state.
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._resetLabel = /**
	     * If the label has been manually elevated, return it to its normal state.
	     * @return {?}
	     */
	    function () {
	        if (this._manuallyFloatingLabel) {
	            this._formField.floatLabel = 'auto';
	            this._manuallyFloatingLabel = false;
	        }
	    };
	    /**
	     * Given that we are not actually focusing active options, we must manually adjust scroll
	     * to reveal options below the fold. First, we find the offset of the option from the top
	     * of the panel. If that offset is below the fold, the new scrollTop will be the offset -
	     * the panel height + the option height, so the active option will be just visible at the
	     * bottom of the panel. If that offset is above the top of the visible panel, the new scrollTop
	     * will become the offset. If that offset is visible within the panel already, the scrollTop is
	     * not adjusted.
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._scrollToOption = /**
	     * Given that we are not actually focusing active options, we must manually adjust scroll
	     * to reveal options below the fold. First, we find the offset of the option from the top
	     * of the panel. If that offset is below the fold, the new scrollTop will be the offset -
	     * the panel height + the option height, so the active option will be just visible at the
	     * bottom of the panel. If that offset is above the top of the visible panel, the new scrollTop
	     * will become the offset. If that offset is visible within the panel already, the scrollTop is
	     * not adjusted.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ index = this.autocomplete._keyManager.activeItemIndex || 0;
	        var /** @type {?} */ labelCount = _countGroupLabelsBeforeOption(index, this.autocomplete.options, this.autocomplete.optionGroups);
	        var /** @type {?} */ newScrollPosition = _getOptionScrollPosition(index + labelCount, AUTOCOMPLETE_OPTION_HEIGHT, this.autocomplete._getScrollTop(), AUTOCOMPLETE_PANEL_HEIGHT);
	        this.autocomplete._setScrollTop(newScrollPosition);
	    };
	    /**
	     * This method listens to a stream of panel closing actions and resets the
	     * stream every time the option list changes.
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._subscribeToClosingActions = /**
	     * This method listens to a stream of panel closing actions and resets the
	     * stream every time the option list changes.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ firstStable = this._zone.onStable.asObservable().pipe(rxjs_operators_take.take(1));
	        var /** @type {?} */ optionChanges = this.autocomplete.options.changes.pipe(rxjs_operators_tap.tap(function () { return _this._positionStrategy.recalculateLastPosition(); }), 
	        // Defer emitting to the stream until the next tick, because changing
	        // bindings in here will cause "changed after checked" errors.
	        rxjs_operators_delay.delay(0));
	        // When the zone is stable initially, and when the option list changes...
	        return rxjs_observable_merge.merge(firstStable, optionChanges)
	            .pipe(
	        // create a new stream of panelClosingActions, replacing any previous streams
	        // that were created, and flatten it so our stream only emits closing events...
	        rxjs_operators_switchMap.switchMap(function () {
	            _this._resetActiveItem();
	            _this.autocomplete._setVisibility();
	            return _this.panelClosingActions;
	        }), 
	        // when the first closing event occurs...
	        rxjs_operators_take.take(1))
	            .subscribe(function (event) { return _this._setValueAndClose(event); });
	    };
	    /**
	     * Destroys the autocomplete suggestion panel.
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._destroyPanel = /**
	     * Destroys the autocomplete suggestion panel.
	     * @return {?}
	     */
	    function () {
	        if (this._overlayRef) {
	            this.closePanel();
	            this._overlayRef.dispose();
	            this._overlayRef = null;
	        }
	    };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._setTriggerValue = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        var /** @type {?} */ toDisplay = this.autocomplete && this.autocomplete.displayWith ?
	            this.autocomplete.displayWith(value) :
	            value;
	        // Simply falling back to an empty string if the display value is falsy does not work properly.
	        // The display value can also be the number zero and shouldn't fall back to an empty string.
	        var /** @type {?} */ inputValue = toDisplay != null ? toDisplay : '';
	        // If it's used within a `MatFormField`, we should set it through the property so it can go
	        // through change detection.
	        if (this._formField) {
	            this._formField._control.value = inputValue;
	        }
	        else {
	            this._element.nativeElement.value = inputValue;
	        }
	    };
	    /**
	     * This method closes the panel, and if a value is specified, also sets the associated
	     * control to that value. It will also mark the control as dirty if this interaction
	     * stemmed from the user.
	     * @param {?} event
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._setValueAndClose = /**
	     * This method closes the panel, and if a value is specified, also sets the associated
	     * control to that value. It will also mark the control as dirty if this interaction
	     * stemmed from the user.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (event && event.source) {
	            this._clearPreviousSelectedOption(event.source);
	            this._setTriggerValue(event.source.value);
	            this._onChange(event.source.value);
	            this._element.nativeElement.focus();
	            this.autocomplete._emitSelectEvent(event.source);
	        }
	        this.closePanel();
	    };
	    /**
	     * Clear any previous selected option and emit a selection change event for this option
	     * @param {?} skip
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._clearPreviousSelectedOption = /**
	     * Clear any previous selected option and emit a selection change event for this option
	     * @param {?} skip
	     * @return {?}
	     */
	    function (skip) {
	        this.autocomplete.options.forEach(function (option) {
	            if (option != skip && option.selected) {
	                option.deselect();
	            }
	        });
	    };
	    /**
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._attachOverlay = /**
	     * @return {?}
	     */
	    function () {
	        if (!this.autocomplete) {
	            throw getMatAutocompleteMissingPanelError();
	        }
	        if (!this._overlayRef) {
	            this._portal = new _angular_cdk_portal.TemplatePortal(this.autocomplete.template, this._viewContainerRef);
	            this._overlayRef = this._overlay.create(this._getOverlayConfig());
	        }
	        else {
	            /** Update the panel width, in case the host width has changed */
	            this._overlayRef.updateSize({ width: this._getHostWidth() });
	        }
	        if (this._overlayRef && !this._overlayRef.hasAttached()) {
	            this._overlayRef.attach(this._portal);
	            this._closingActionsSubscription = this._subscribeToClosingActions();
	        }
	        this.autocomplete._setVisibility();
	        this.autocomplete._isOpen = this._panelOpen = true;
	    };
	    /**
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._getOverlayConfig = /**
	     * @return {?}
	     */
	    function () {
	        return new _angular_cdk_overlay.OverlayConfig({
	            positionStrategy: this._getOverlayPosition(),
	            scrollStrategy: this._scrollStrategy(),
	            width: this._getHostWidth(),
	            direction: this._dir ? this._dir.value : 'ltr'
	        });
	    };
	    /**
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._getOverlayPosition = /**
	     * @return {?}
	     */
	    function () {
	        this._positionStrategy = this._overlay.position().connectedTo(this._getConnectedElement(), { originX: 'start', originY: 'bottom' }, { overlayX: 'start', overlayY: 'top' })
	            .withFallbackPosition({ originX: 'start', originY: 'top' }, { overlayX: 'start', overlayY: 'bottom' });
	        return this._positionStrategy;
	    };
	    /**
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._getConnectedElement = /**
	     * @return {?}
	     */
	    function () {
	        return this._formField ? this._formField._connectionContainerRef : this._element;
	    };
	    /**
	     * Returns the width of the input element, so the panel width can match it.
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._getHostWidth = /**
	     * Returns the width of the input element, so the panel width can match it.
	     * @return {?}
	     */
	    function () {
	        return this._getConnectedElement().nativeElement.getBoundingClientRect().width;
	    };
	    /**
	     * Resets the active item to -1 so arrow events will activate the
	     * correct options, or to 0 if the consumer opted into it.
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._resetActiveItem = /**
	     * Resets the active item to -1 so arrow events will activate the
	     * correct options, or to 0 if the consumer opted into it.
	     * @return {?}
	     */
	    function () {
	        this.autocomplete._keyManager.setActiveItem(this.autocomplete.autoActiveFirstOption ? 0 : -1);
	    };
	    /**
	     * Determines whether the panel can be opened.
	     * @return {?}
	     */
	    MatAutocompleteTrigger.prototype._canOpen = /**
	     * Determines whether the panel can be opened.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ element = this._element.nativeElement;
	        return !element.readOnly && !element.disabled;
	    };
	    MatAutocompleteTrigger.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: "input[matAutocomplete], textarea[matAutocomplete]",
	                    host: {
	                        'role': 'combobox',
	                        'autocomplete': 'off',
	                        'aria-autocomplete': 'list',
	                        '[attr.aria-activedescendant]': 'activeOption?.id',
	                        '[attr.aria-expanded]': 'panelOpen.toString()',
	                        '[attr.aria-owns]': 'autocomplete?.id',
	                        // Note: we use `focusin`, as opposed to `focus`, in order to open the panel
	                        // a little earlier. This avoids issues where IE delays the focusing of the input.
	                        '(focusin)': '_handleFocus()',
	                        '(blur)': '_onTouched()',
	                        '(input)': '_handleInput($event)',
	                        '(keydown)': '_handleKeydown($event)',
	                    },
	                    exportAs: 'matAutocompleteTrigger',
	                    providers: [MAT_AUTOCOMPLETE_VALUE_ACCESSOR]
	                },] },
	    ];
	    /** @nocollapse */
	    MatAutocompleteTrigger.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_overlay.Overlay, },
	        { type: _angular_core.ViewContainerRef, },
	        { type: _angular_core.NgZone, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [MAT_AUTOCOMPLETE_SCROLL_STRATEGY,] },] },
	        { type: _angular_cdk_bidi.Directionality, decorators: [{ type: _angular_core.Optional },] },
	        { type: MatFormField, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host },] },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    MatAutocompleteTrigger.propDecorators = {
	        "autocomplete": [{ type: _angular_core.Input, args: ['matAutocomplete',] },],
	    };
	    return MatAutocompleteTrigger;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatAutocompleteModule = /** @class */ (function () {
	    function MatAutocompleteModule() {
	    }
	    MatAutocompleteModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [MatOptionModule, _angular_cdk_overlay.OverlayModule, MatCommonModule, _angular_common.CommonModule],
	                    exports: [MatAutocomplete, MatOptionModule, MatAutocompleteTrigger, MatCommonModule],
	                    declarations: [MatAutocomplete, MatAutocompleteTrigger],
	                    providers: [MAT_AUTOCOMPLETE_SCROLL_STRATEGY_PROVIDER],
	                },] },
	    ];
	    /** @nocollapse */
	    MatAutocompleteModule.ctorParameters = function () { return []; };
	    return MatAutocompleteModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Default color palette for round buttons (mat-fab and mat-mini-fab)
	 */
	var DEFAULT_ROUND_BUTTON_COLOR = 'accent';
	/**
	 * Default color palette for flat buttons (mat-flat-button)
	 */
	var DEFAULT_FLAT_BUTTON_COLOR = 'primary';
	/**
	 * List of classes to add to MatButton instances based on host attributes to
	 * style as different variants.
	 */
	var BUTTON_HOST_ATTRIBUTES = [
	    'mat-button',
	    'mat-flat-button',
	    'mat-icon-button',
	    'mat-raised-button',
	    'mat-stroked-button',
	    'mat-mini-fab',
	    'mat-fab',
	];
	/**
	 * \@docs-private
	 */
	var MatButtonBase = /** @class */ (function () {
	    function MatButtonBase(_elementRef) {
	        this._elementRef = _elementRef;
	    }
	    return MatButtonBase;
	}());
	var _MatButtonMixinBase = mixinColor(mixinDisabled(mixinDisableRipple(MatButtonBase)));
	/**
	 * Material design button.
	 */
	var MatButton = /** @class */ (function (_super) {
	    __extends(MatButton, _super);
	    function MatButton(elementRef, _platform, _focusMonitor) {
	        var _this = _super.call(this, elementRef) || this;
	        _this._platform = _platform;
	        _this._focusMonitor = _focusMonitor;
	        /**
	         * Whether the button is round.
	         */
	        _this._isRoundButton = _this._hasHostAttributes('mat-fab', 'mat-mini-fab');
	        /**
	         * Whether the button is icon button.
	         */
	        _this._isIconButton = _this._hasHostAttributes('mat-icon-button');
	        // For each of the variant selectors that is prevent in the button's host
	        // attributes, add the correct corresponding class.
	        for (var _i = 0, BUTTON_HOST_ATTRIBUTES_1 = BUTTON_HOST_ATTRIBUTES; _i < BUTTON_HOST_ATTRIBUTES_1.length; _i++) {
	            var attr = BUTTON_HOST_ATTRIBUTES_1[_i];
	            if (_this._hasHostAttributes(attr)) {
	                (/** @type {?} */ (elementRef.nativeElement)).classList.add(attr);
	            }
	        }
	        _this._focusMonitor.monitor(_this._elementRef.nativeElement, true);
	        if (_this._isRoundButton) {
	            _this.color = DEFAULT_ROUND_BUTTON_COLOR;
	        }
	        else if (_this._hasHostAttributes('mat-flat-button')) {
	            _this.color = DEFAULT_FLAT_BUTTON_COLOR;
	        }
	        return _this;
	    }
	    /**
	     * @return {?}
	     */
	    MatButton.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._focusMonitor.stopMonitoring(this._elementRef.nativeElement);
	    };
	    /** Focuses the button. */
	    /**
	     * Focuses the button.
	     * @return {?}
	     */
	    MatButton.prototype.focus = /**
	     * Focuses the button.
	     * @return {?}
	     */
	    function () {
	        this._getHostElement().focus();
	    };
	    /**
	     * @return {?}
	     */
	    MatButton.prototype._getHostElement = /**
	     * @return {?}
	     */
	    function () {
	        return this._elementRef.nativeElement;
	    };
	    /**
	     * @return {?}
	     */
	    MatButton.prototype._isRippleDisabled = /**
	     * @return {?}
	     */
	    function () {
	        return this.disableRipple || this.disabled;
	    };
	    /** Gets whether the button has one of the given attributes. */
	    /**
	     * Gets whether the button has one of the given attributes.
	     * @param {...?} attributes
	     * @return {?}
	     */
	    MatButton.prototype._hasHostAttributes = /**
	     * Gets whether the button has one of the given attributes.
	     * @param {...?} attributes
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var attributes = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            attributes[_i] = arguments[_i];
	        }
	        // If not on the browser, say that there are none of the attributes present.
	        // Since these only affect how the ripple displays (and ripples only happen on the client),
	        // detecting these attributes isn't necessary when not on the browser.
	        if (!this._platform.isBrowser) {
	            return false;
	        }
	        return attributes.some(function (attribute) { return _this._getHostElement().hasAttribute(attribute); });
	    };
	    MatButton.decorators = [
	        { type: _angular_core.Component, args: [{selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],\n             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],\n             button[mat-flat-button]",
	                    exportAs: 'matButton',
	                    host: {
	                        '[disabled]': 'disabled || null',
	                    },
	                    template: "<span class=\"mat-button-wrapper\"><ng-content></ng-content></span><div matRipple class=\"mat-button-ripple\" [class.mat-button-ripple-round]=\"_isRoundButton || _isIconButton\" [matRippleDisabled]=\"_isRippleDisabled()\" [matRippleCentered]=\"_isIconButton\" [matRippleTrigger]=\"_getHostElement()\"></div><div class=\"mat-button-focus-overlay\"></div>",
	                    styles: [".mat-button,.mat-flat-button,.mat-icon-button,.mat-stroked-button{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0 16px;border-radius:2px}.mat-button[disabled],.mat-flat-button[disabled],.mat-icon-button[disabled],.mat-stroked-button[disabled]{cursor:default}.mat-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-button.cdk-program-focused .mat-button-focus-overlay,.mat-flat-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-flat-button.cdk-program-focused .mat-button-focus-overlay,.mat-icon-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-icon-button.cdk-program-focused .mat-button-focus-overlay,.mat-stroked-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-stroked-button.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-button::-moz-focus-inner,.mat-flat-button::-moz-focus-inner,.mat-icon-button::-moz-focus-inner,.mat-stroked-button::-moz-focus-inner{border:0}.mat-button .mat-button-focus-overlay,.mat-icon-button .mat-button-focus-overlay{transition:none;opacity:0}.mat-button:hover .mat-button-focus-overlay,.mat-stroked-button:hover .mat-button-focus-overlay{opacity:1}.mat-raised-button{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0 16px;border-radius:2px;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1)}.mat-raised-button[disabled]{cursor:default}.mat-raised-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-raised-button.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-raised-button::-moz-focus-inner{border:0}.mat-raised-button:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.mat-raised-button:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.mat-raised-button[disabled]{box-shadow:none}.mat-stroked-button{border:1px solid currentColor;padding:0 15px;line-height:34px}.mat-stroked-button:not([class*=mat-elevation-z]){box-shadow:0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)}.mat-flat-button:not([class*=mat-elevation-z]){box-shadow:0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)}.mat-fab{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0 16px;border-radius:2px;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);min-width:0;border-radius:50%;width:56px;height:56px;padding:0;flex-shrink:0}.mat-fab[disabled]{cursor:default}.mat-fab.cdk-keyboard-focused .mat-button-focus-overlay,.mat-fab.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-fab::-moz-focus-inner{border:0}.mat-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.mat-fab:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.mat-fab[disabled]{box-shadow:none}.mat-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)}.mat-fab:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)}.mat-fab .mat-button-wrapper{padding:16px 0;display:inline-block;line-height:24px}.mat-mini-fab{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0 16px;border-radius:2px;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);min-width:0;border-radius:50%;width:40px;height:40px;padding:0;flex-shrink:0}.mat-mini-fab[disabled]{cursor:default}.mat-mini-fab.cdk-keyboard-focused .mat-button-focus-overlay,.mat-mini-fab.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-mini-fab::-moz-focus-inner{border:0}.mat-mini-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.mat-mini-fab:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.mat-mini-fab[disabled]{box-shadow:none}.mat-mini-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)}.mat-mini-fab:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)}.mat-mini-fab .mat-button-wrapper{padding:8px 0;display:inline-block;line-height:24px}.mat-icon-button{padding:0;min-width:0;width:40px;height:40px;flex-shrink:0;line-height:40px;border-radius:50%}.mat-icon-button .mat-icon,.mat-icon-button i{line-height:24px}.mat-button,.mat-fab,.mat-icon-button,.mat-mini-fab,.mat-raised-button{color:currentColor}.mat-button .mat-button-wrapper>*,.mat-fab .mat-button-wrapper>*,.mat-icon-button .mat-button-wrapper>*,.mat-mini-fab .mat-button-wrapper>*,.mat-raised-button .mat-button-wrapper>*{vertical-align:middle}.mat-button-focus-overlay,.mat-button-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-button-focus-overlay{background-color:rgba(0,0,0,.12);border-radius:inherit;opacity:0;transition:opacity .2s cubic-bezier(.35,0,.25,1),background-color .2s cubic-bezier(.35,0,.25,1)}@media screen and (-ms-high-contrast:active){.mat-button-focus-overlay{background-color:rgba(255,255,255,.5)}}.mat-button-ripple-round{border-radius:50%;z-index:1}@media screen and (-ms-high-contrast:active){.mat-button,.mat-fab,.mat-flat-button,.mat-icon-button,.mat-mini-fab,.mat-raised-button{outline:solid 1px}}"],
	                    inputs: ['disabled', 'disableRipple', 'color'],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatButton.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_platform.Platform, },
	        { type: _angular_cdk_a11y.FocusMonitor, },
	    ]; };
	    MatButton.propDecorators = {
	        "ripple": [{ type: _angular_core.ViewChild, args: [MatRipple,] },],
	    };
	    return MatButton;
	}(_MatButtonMixinBase));
	/**
	 * Raised Material design button.
	 */
	var MatAnchor = /** @class */ (function (_super) {
	    __extends(MatAnchor, _super);
	    function MatAnchor(platform, focusMonitor, elementRef) {
	        return _super.call(this, elementRef, platform, focusMonitor) || this;
	    }
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    MatAnchor.prototype._haltDisabledEvents = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        // A disabled button shouldn't apply any actions
	        if (this.disabled) {
	            event.preventDefault();
	            event.stopImmediatePropagation();
	        }
	    };
	    MatAnchor.decorators = [
	        { type: _angular_core.Component, args: [{selector: "a[mat-button], a[mat-raised-button], a[mat-icon-button], a[mat-fab],\n             a[mat-mini-fab], a[mat-stroked-button], a[mat-flat-button]",
	                    exportAs: 'matButton, matAnchor',
	                    host: {
	                        '[attr.tabindex]': 'disabled ? -1 : 0',
	                        '[attr.disabled]': 'disabled || null',
	                        '[attr.aria-disabled]': 'disabled.toString()',
	                        '(click)': '_haltDisabledEvents($event)',
	                    },
	                    inputs: ['disabled', 'disableRipple', 'color'],
	                    template: "<span class=\"mat-button-wrapper\"><ng-content></ng-content></span><div matRipple class=\"mat-button-ripple\" [class.mat-button-ripple-round]=\"_isRoundButton || _isIconButton\" [matRippleDisabled]=\"_isRippleDisabled()\" [matRippleCentered]=\"_isIconButton\" [matRippleTrigger]=\"_getHostElement()\"></div><div class=\"mat-button-focus-overlay\"></div>",
	                    styles: [".mat-button,.mat-flat-button,.mat-icon-button,.mat-stroked-button{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0 16px;border-radius:2px}.mat-button[disabled],.mat-flat-button[disabled],.mat-icon-button[disabled],.mat-stroked-button[disabled]{cursor:default}.mat-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-button.cdk-program-focused .mat-button-focus-overlay,.mat-flat-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-flat-button.cdk-program-focused .mat-button-focus-overlay,.mat-icon-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-icon-button.cdk-program-focused .mat-button-focus-overlay,.mat-stroked-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-stroked-button.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-button::-moz-focus-inner,.mat-flat-button::-moz-focus-inner,.mat-icon-button::-moz-focus-inner,.mat-stroked-button::-moz-focus-inner{border:0}.mat-button .mat-button-focus-overlay,.mat-icon-button .mat-button-focus-overlay{transition:none;opacity:0}.mat-button:hover .mat-button-focus-overlay,.mat-stroked-button:hover .mat-button-focus-overlay{opacity:1}.mat-raised-button{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0 16px;border-radius:2px;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1)}.mat-raised-button[disabled]{cursor:default}.mat-raised-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-raised-button.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-raised-button::-moz-focus-inner{border:0}.mat-raised-button:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.mat-raised-button:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.mat-raised-button[disabled]{box-shadow:none}.mat-stroked-button{border:1px solid currentColor;padding:0 15px;line-height:34px}.mat-stroked-button:not([class*=mat-elevation-z]){box-shadow:0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)}.mat-flat-button:not([class*=mat-elevation-z]){box-shadow:0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)}.mat-fab{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0 16px;border-radius:2px;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);min-width:0;border-radius:50%;width:56px;height:56px;padding:0;flex-shrink:0}.mat-fab[disabled]{cursor:default}.mat-fab.cdk-keyboard-focused .mat-button-focus-overlay,.mat-fab.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-fab::-moz-focus-inner{border:0}.mat-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.mat-fab:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.mat-fab[disabled]{box-shadow:none}.mat-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)}.mat-fab:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)}.mat-fab .mat-button-wrapper{padding:16px 0;display:inline-block;line-height:24px}.mat-mini-fab{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0 16px;border-radius:2px;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);min-width:0;border-radius:50%;width:40px;height:40px;padding:0;flex-shrink:0}.mat-mini-fab[disabled]{cursor:default}.mat-mini-fab.cdk-keyboard-focused .mat-button-focus-overlay,.mat-mini-fab.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-mini-fab::-moz-focus-inner{border:0}.mat-mini-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.mat-mini-fab:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.mat-mini-fab[disabled]{box-shadow:none}.mat-mini-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)}.mat-mini-fab:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)}.mat-mini-fab .mat-button-wrapper{padding:8px 0;display:inline-block;line-height:24px}.mat-icon-button{padding:0;min-width:0;width:40px;height:40px;flex-shrink:0;line-height:40px;border-radius:50%}.mat-icon-button .mat-icon,.mat-icon-button i{line-height:24px}.mat-button,.mat-fab,.mat-icon-button,.mat-mini-fab,.mat-raised-button{color:currentColor}.mat-button .mat-button-wrapper>*,.mat-fab .mat-button-wrapper>*,.mat-icon-button .mat-button-wrapper>*,.mat-mini-fab .mat-button-wrapper>*,.mat-raised-button .mat-button-wrapper>*{vertical-align:middle}.mat-button-focus-overlay,.mat-button-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-button-focus-overlay{background-color:rgba(0,0,0,.12);border-radius:inherit;opacity:0;transition:opacity .2s cubic-bezier(.35,0,.25,1),background-color .2s cubic-bezier(.35,0,.25,1)}@media screen and (-ms-high-contrast:active){.mat-button-focus-overlay{background-color:rgba(255,255,255,.5)}}.mat-button-ripple-round{border-radius:50%;z-index:1}@media screen and (-ms-high-contrast:active){.mat-button,.mat-fab,.mat-flat-button,.mat-icon-button,.mat-mini-fab,.mat-raised-button{outline:solid 1px}}"],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatAnchor.ctorParameters = function () { return [
	        { type: _angular_cdk_platform.Platform, },
	        { type: _angular_cdk_a11y.FocusMonitor, },
	        { type: _angular_core.ElementRef, },
	    ]; };
	    return MatAnchor;
	}(MatButton));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatButtonModule = /** @class */ (function () {
	    function MatButtonModule() {
	    }
	    MatButtonModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [
	                        _angular_common.CommonModule,
	                        MatRippleModule,
	                        MatCommonModule,
	                        _angular_cdk_a11y.A11yModule,
	                    ],
	                    exports: [
	                        MatButton,
	                        MatAnchor,
	                        MatCommonModule,
	                    ],
	                    declarations: [
	                        MatButton,
	                        MatAnchor,
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    MatButtonModule.ctorParameters = function () { return []; };
	    return MatButtonModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 */
	var MatButtonToggleGroupBase = /** @class */ (function () {
	    function MatButtonToggleGroupBase() {
	    }
	    return MatButtonToggleGroupBase;
	}());
	var _MatButtonToggleGroupMixinBase = mixinDisabled(MatButtonToggleGroupBase);
	/**
	 * Provider Expression that allows mat-button-toggle-group to register as a ControlValueAccessor.
	 * This allows it to support [(ngModel)].
	 * \@docs-private
	 */
	var MAT_BUTTON_TOGGLE_GROUP_VALUE_ACCESSOR = {
	    provide: _angular_forms.NG_VALUE_ACCESSOR,
	    useExisting: _angular_core.forwardRef(function () { return MatButtonToggleGroup; }),
	    multi: true
	};
	var _uniqueIdCounter$1 = 0;
	/**
	 * Change event object emitted by MatButtonToggle.
	 */
	var MatButtonToggleChange = /** @class */ (function () {
	    function MatButtonToggleChange() {
	    }
	    return MatButtonToggleChange;
	}());
	/**
	 * Exclusive selection button toggle group that behaves like a radio-button group.
	 */
	var MatButtonToggleGroup = /** @class */ (function (_super) {
	    __extends(MatButtonToggleGroup, _super);
	    function MatButtonToggleGroup(_changeDetector) {
	        var _this = _super.call(this) || this;
	        _this._changeDetector = _changeDetector;
	        /**
	         * The method to be called in order to update ngModel.
	         * Now `ngModel` binding is not supported in multiple selection mode.
	         */
	        _this._controlValueAccessorChangeFn = function () { };
	        /**
	         * onTouch function registered via registerOnTouch (ControlValueAccessor).
	         */
	        _this._onTouched = function () { };
	        _this._name = "mat-button-toggle-group-" + _uniqueIdCounter$1++;
	        _this._vertical = false;
	        _this._value = null;
	        /**
	         * Event that emits whenever the value of the group changes.
	         * Used to facilitate two-way data binding.
	         * \@docs-private
	         */
	        _this.valueChange = new _angular_core.EventEmitter();
	        _this._selected = null;
	        /**
	         * Event emitted when the group's value changes.
	         */
	        _this.change = new _angular_core.EventEmitter();
	        return _this;
	    }
	    Object.defineProperty(MatButtonToggleGroup.prototype, "name", {
	        get: /**
	         * `name` attribute for the underlying `input` element.
	         * @return {?}
	         */
	        function () { return this._name; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._name = value;
	            this._updateButtonToggleNames();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatButtonToggleGroup.prototype, "vertical", {
	        get: /**
	         * Whether the toggle group is vertical.
	         * @return {?}
	         */
	        function () { return this._vertical; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._vertical = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatButtonToggleGroup.prototype, "value", {
	        get: /**
	         * Value of the toggle group.
	         * @return {?}
	         */
	        function () { return this._value; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (this._value != value) {
	                this._value = value;
	                this.valueChange.emit(value);
	                this._updateSelectedButtonToggleFromValue();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatButtonToggleGroup.prototype, "selected", {
	        get: /**
	         * The currently selected button toggle, should match the value.
	         * @return {?}
	         */
	        function () { return this._selected; },
	        set: /**
	         * @param {?} selected
	         * @return {?}
	         */
	        function (selected) {
	            this._selected = selected;
	            this.value = selected ? selected.value : null;
	            if (selected && !selected.checked) {
	                selected.checked = true;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatButtonToggleGroup.prototype._updateButtonToggleNames = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._buttonToggles) {
	            this._buttonToggles.forEach(function (toggle) {
	                toggle.name = _this._name;
	            });
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatButtonToggleGroup.prototype._updateSelectedButtonToggleFromValue = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ isAlreadySelected = this._selected != null && this._selected.value == this._value;
	        if (this._buttonToggles != null && !isAlreadySelected) {
	            var /** @type {?} */ matchingButtonToggle = this._buttonToggles.filter(function (buttonToggle) { return buttonToggle.value == _this._value; })[0];
	            if (matchingButtonToggle) {
	                this.selected = matchingButtonToggle;
	            }
	            else if (this.value == null) {
	                this.selected = null;
	                this._buttonToggles.forEach(function (buttonToggle) {
	                    buttonToggle.checked = false;
	                });
	            }
	        }
	    };
	    /** Dispatch change event with current selection and group value. */
	    /**
	     * Dispatch change event with current selection and group value.
	     * @return {?}
	     */
	    MatButtonToggleGroup.prototype._emitChangeEvent = /**
	     * Dispatch change event with current selection and group value.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ event = new MatButtonToggleChange();
	        event.source = this._selected;
	        event.value = this._value;
	        this._controlValueAccessorChangeFn(event.value);
	        this.change.emit(event);
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    MatButtonToggleGroup.prototype.writeValue = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        this.value = value;
	        this._changeDetector.markForCheck();
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    MatButtonToggleGroup.prototype.registerOnChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._controlValueAccessorChangeFn = fn;
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    MatButtonToggleGroup.prototype.registerOnTouched = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._onTouched = fn;
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    MatButtonToggleGroup.prototype.setDisabledState = /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    function (isDisabled) {
	        this.disabled = isDisabled;
	        this._markButtonTogglesForCheck();
	    };
	    /**
	     * @return {?}
	     */
	    MatButtonToggleGroup.prototype._markButtonTogglesForCheck = /**
	     * @return {?}
	     */
	    function () {
	        if (this._buttonToggles) {
	            this._buttonToggles.forEach(function (toggle) { return toggle._markForCheck(); });
	        }
	    };
	    MatButtonToggleGroup.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-button-toggle-group:not([multiple])',
	                    providers: [MAT_BUTTON_TOGGLE_GROUP_VALUE_ACCESSOR],
	                    inputs: ['disabled'],
	                    host: {
	                        'role': 'radiogroup',
	                        'class': 'mat-button-toggle-group',
	                        '[class.mat-button-toggle-vertical]': 'vertical'
	                    },
	                    exportAs: 'matButtonToggleGroup',
	                },] },
	    ];
	    /** @nocollapse */
	    MatButtonToggleGroup.ctorParameters = function () { return [
	        { type: _angular_core.ChangeDetectorRef, },
	    ]; };
	    MatButtonToggleGroup.propDecorators = {
	        "_buttonToggles": [{ type: _angular_core.ContentChildren, args: [_angular_core.forwardRef(function () { return MatButtonToggle; }),] },],
	        "name": [{ type: _angular_core.Input },],
	        "vertical": [{ type: _angular_core.Input },],
	        "value": [{ type: _angular_core.Input },],
	        "valueChange": [{ type: _angular_core.Output },],
	        "selected": [{ type: _angular_core.Input },],
	        "change": [{ type: _angular_core.Output },],
	    };
	    return MatButtonToggleGroup;
	}(_MatButtonToggleGroupMixinBase));
	/**
	 * Multiple selection button-toggle group. `ngModel` is not supported in this mode.
	 */
	var MatButtonToggleGroupMultiple = /** @class */ (function (_super) {
	    __extends(MatButtonToggleGroupMultiple, _super);
	    function MatButtonToggleGroupMultiple() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._vertical = false;
	        return _this;
	    }
	    Object.defineProperty(MatButtonToggleGroupMultiple.prototype, "vertical", {
	        get: /**
	         * Whether the toggle group is vertical.
	         * @return {?}
	         */
	        function () { return this._vertical; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._vertical = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    MatButtonToggleGroupMultiple.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-button-toggle-group[multiple]',
	                    exportAs: 'matButtonToggleGroup',
	                    inputs: ['disabled'],
	                    host: {
	                        'class': 'mat-button-toggle-group',
	                        '[class.mat-button-toggle-vertical]': 'vertical',
	                        'role': 'group'
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatButtonToggleGroupMultiple.ctorParameters = function () { return []; };
	    MatButtonToggleGroupMultiple.propDecorators = {
	        "vertical": [{ type: _angular_core.Input },],
	    };
	    return MatButtonToggleGroupMultiple;
	}(_MatButtonToggleGroupMixinBase));
	/**
	 * Single button inside of a toggle group.
	 */
	var MatButtonToggle = /** @class */ (function () {
	    function MatButtonToggle(toggleGroup, toggleGroupMultiple, _changeDetectorRef, _buttonToggleDispatcher, _elementRef, _focusMonitor) {
	        var _this = this;
	        this._changeDetectorRef = _changeDetectorRef;
	        this._buttonToggleDispatcher = _buttonToggleDispatcher;
	        this._elementRef = _elementRef;
	        this._focusMonitor = _focusMonitor;
	        /**
	         * Attached to the aria-label attribute of the host element. In most cases, arial-labelledby will
	         * take precedence so this may be omitted.
	         */
	        this.ariaLabel = '';
	        /**
	         * Users can specify the `aria-labelledby` attribute which will be forwarded to the input element
	         */
	        this.ariaLabelledby = null;
	        /**
	         * Whether or not the button toggle is a single selection.
	         */
	        this._isSingleSelector = false;
	        /**
	         * Unregister function for _buttonToggleDispatcher
	         */
	        this._removeUniqueSelectionListener = function () { };
	        this._checked = false;
	        this._value = null;
	        this._disabled = false;
	        /**
	         * Event emitted when the group value changes.
	         */
	        this.change = new _angular_core.EventEmitter();
	        this.buttonToggleGroup = toggleGroup;
	        this.buttonToggleGroupMultiple = toggleGroupMultiple;
	        if (this.buttonToggleGroup) {
	            this._removeUniqueSelectionListener =
	                _buttonToggleDispatcher.listen(function (id, name) {
	                    if (id != _this.id && name == _this.name) {
	                        _this.checked = false;
	                        _this._changeDetectorRef.markForCheck();
	                    }
	                });
	            this._type = 'radio';
	            this.name = this.buttonToggleGroup.name;
	            this._isSingleSelector = true;
	        }
	        else {
	            // Even if there is no group at all, treat the button toggle as a checkbox so it can be
	            // toggled on or off.
	            this._type = 'checkbox';
	            this._isSingleSelector = false;
	        }
	    }
	    Object.defineProperty(MatButtonToggle.prototype, "inputId", {
	        /** Unique ID for the underlying `input` element. */
	        get: /**
	         * Unique ID for the underlying `input` element.
	         * @return {?}
	         */
	        function () { return this.id + "-input"; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatButtonToggle.prototype, "checked", {
	        get: /**
	         * Whether the button is checked.
	         * @return {?}
	         */
	        function () { return this._checked; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (this._isSingleSelector && value) {
	                // Notify all button toggles with the same name (in the same group) to un-check.
	                this._buttonToggleDispatcher.notify(this.id, this.name);
	                this._changeDetectorRef.markForCheck();
	            }
	            this._checked = value;
	            if (value && this._isSingleSelector && this.buttonToggleGroup.value != this.value) {
	                this.buttonToggleGroup.selected = this;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatButtonToggle.prototype, "value", {
	        get: /**
	         * MatButtonToggleGroup reads this to assign its own value.
	         * @return {?}
	         */
	        function () { return this._value; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (this._value != value) {
	                if (this.buttonToggleGroup != null && this.checked) {
	                    this.buttonToggleGroup.value = value;
	                }
	                this._value = value;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatButtonToggle.prototype, "disabled", {
	        get: /**
	         * Whether the button is disabled.
	         * @return {?}
	         */
	        function () {
	            return this._disabled || (this.buttonToggleGroup != null && this.buttonToggleGroup.disabled) ||
	                (this.buttonToggleGroupMultiple != null && this.buttonToggleGroupMultiple.disabled);
	        },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._disabled = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatButtonToggle.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        if (this.id == null) {
	            this.id = "mat-button-toggle-" + _uniqueIdCounter$1++;
	        }
	        if (this.buttonToggleGroup && this._value == this.buttonToggleGroup.value) {
	            this._checked = true;
	        }
	        this._focusMonitor.monitor(this._elementRef.nativeElement, true);
	    };
	    /** Focuses the button. */
	    /**
	     * Focuses the button.
	     * @return {?}
	     */
	    MatButtonToggle.prototype.focus = /**
	     * Focuses the button.
	     * @return {?}
	     */
	    function () {
	        this._inputElement.nativeElement.focus();
	    };
	    /**
	     * Toggle the state of the current button toggle.
	     * @return {?}
	     */
	    MatButtonToggle.prototype._toggle = /**
	     * Toggle the state of the current button toggle.
	     * @return {?}
	     */
	    function () {
	        this.checked = !this.checked;
	    };
	    /** Checks the button toggle due to an interaction with the underlying native input. */
	    /**
	     * Checks the button toggle due to an interaction with the underlying native input.
	     * @param {?} event
	     * @return {?}
	     */
	    MatButtonToggle.prototype._onInputChange = /**
	     * Checks the button toggle due to an interaction with the underlying native input.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        event.stopPropagation();
	        if (this._isSingleSelector) {
	            // Propagate the change one-way via the group, which will in turn mark this
	            // button toggle as checked.
	            var /** @type {?} */ groupValueChanged = this.buttonToggleGroup.selected != this;
	            this.checked = true;
	            this.buttonToggleGroup.selected = this;
	            this.buttonToggleGroup._onTouched();
	            if (groupValueChanged) {
	                this.buttonToggleGroup._emitChangeEvent();
	            }
	        }
	        else {
	            this._toggle();
	        }
	        // Emit a change event when the native input does.
	        this._emitChangeEvent();
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    MatButtonToggle.prototype._onInputClick = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        // We have to stop propagation for click events on the visual hidden input element.
	        // By default, when a user clicks on a label element, a generated click event will be
	        // dispatched on the associated input element. Since we are using a label element as our
	        // root container, the click event on the `slide-toggle` will be executed twice.
	        // The real click event will bubble up, and the generated click event also tries to bubble up.
	        // This will lead to multiple click events.
	        // Preventing bubbling for the second event will solve that issue.
	        event.stopPropagation();
	    };
	    /**
	     * Dispatch change event with current value.
	     * @return {?}
	     */
	    MatButtonToggle.prototype._emitChangeEvent = /**
	     * Dispatch change event with current value.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ event = new MatButtonToggleChange();
	        event.source = this;
	        event.value = this._value;
	        this.change.emit(event);
	    };
	    // Unregister buttonToggleDispatcherListener on destroy
	    /**
	     * @return {?}
	     */
	    MatButtonToggle.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._removeUniqueSelectionListener();
	    };
	    /**
	     * Marks the button toggle as needing checking for change detection.
	     * This method is exposed because the parent button toggle group will directly
	     * update bound properties of the radio button.
	     */
	    /**
	     * Marks the button toggle as needing checking for change detection.
	     * This method is exposed because the parent button toggle group will directly
	     * update bound properties of the radio button.
	     * @return {?}
	     */
	    MatButtonToggle.prototype._markForCheck = /**
	     * Marks the button toggle as needing checking for change detection.
	     * This method is exposed because the parent button toggle group will directly
	     * update bound properties of the radio button.
	     * @return {?}
	     */
	    function () {
	        // When group value changes, the button will not be notified. Use `markForCheck` to explicit
	        // update button toggle's status
	        this._changeDetectorRef.markForCheck();
	    };
	    MatButtonToggle.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-button-toggle',
	                    template: "<label [attr.for]=\"inputId\" class=\"mat-button-toggle-label\"><input #input class=\"mat-button-toggle-input cdk-visually-hidden\" [type]=\"_type\" [id]=\"inputId\" [checked]=\"checked\" [disabled]=\"disabled || null\" [attr.name]=\"name\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledby\" (change)=\"_onInputChange($event)\" (click)=\"_onInputClick($event)\"><div class=\"mat-button-toggle-label-content\"><ng-content></ng-content></div></label><div class=\"mat-button-toggle-focus-overlay\"></div>",
	                    styles: [".mat-button-toggle-group,.mat-button-toggle-standalone{box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);position:relative;display:inline-flex;flex-direction:row;border-radius:2px;cursor:pointer;white-space:nowrap;overflow:hidden}.mat-button-toggle-vertical{flex-direction:column}.mat-button-toggle-vertical .mat-button-toggle-label-content{display:block}.mat-button-toggle-disabled .mat-button-toggle-label-content{cursor:default}.mat-button-toggle{white-space:nowrap;position:relative}.mat-button-toggle.cdk-keyboard-focused .mat-button-toggle-focus-overlay,.mat-button-toggle.cdk-program-focused .mat-button-toggle-focus-overlay{opacity:1}.mat-button-toggle-label-content{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:inline-block;line-height:36px;padding:0 16px;cursor:pointer}.mat-button-toggle-label-content>*{vertical-align:middle}.mat-button-toggle-focus-overlay{border-radius:inherit;pointer-events:none;opacity:0;top:0;left:0;right:0;bottom:0;position:absolute}"],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    exportAs: 'matButtonToggle',
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    host: {
	                        '[class.mat-button-toggle-standalone]': '!buttonToggleGroup && !buttonToggleGroupMultiple',
	                        '[class.mat-button-toggle-checked]': 'checked',
	                        '[class.mat-button-toggle-disabled]': 'disabled',
	                        'class': 'mat-button-toggle',
	                        '[attr.id]': 'id',
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatButtonToggle.ctorParameters = function () { return [
	        { type: MatButtonToggleGroup, decorators: [{ type: _angular_core.Optional },] },
	        { type: MatButtonToggleGroupMultiple, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: _angular_cdk_collections.UniqueSelectionDispatcher, },
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_a11y.FocusMonitor, },
	    ]; };
	    MatButtonToggle.propDecorators = {
	        "ariaLabel": [{ type: _angular_core.Input, args: ['aria-label',] },],
	        "ariaLabelledby": [{ type: _angular_core.Input, args: ['aria-labelledby',] },],
	        "_inputElement": [{ type: _angular_core.ViewChild, args: ['input',] },],
	        "id": [{ type: _angular_core.Input },],
	        "name": [{ type: _angular_core.Input },],
	        "checked": [{ type: _angular_core.Input },],
	        "value": [{ type: _angular_core.Input },],
	        "disabled": [{ type: _angular_core.Input },],
	        "change": [{ type: _angular_core.Output },],
	    };
	    return MatButtonToggle;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatButtonToggleModule = /** @class */ (function () {
	    function MatButtonToggleModule() {
	    }
	    MatButtonToggleModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [MatCommonModule, _angular_cdk_a11y.A11yModule],
	                    exports: [
	                        MatButtonToggleGroup,
	                        MatButtonToggleGroupMultiple,
	                        MatButtonToggle,
	                        MatCommonModule,
	                    ],
	                    declarations: [MatButtonToggleGroup, MatButtonToggleGroupMultiple, MatButtonToggle],
	                    providers: [_angular_cdk_collections.UNIQUE_SELECTION_DISPATCHER_PROVIDER]
	                },] },
	    ];
	    /** @nocollapse */
	    MatButtonToggleModule.ctorParameters = function () { return []; };
	    return MatButtonToggleModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Content of a card, needed as it's used as a selector in the API.
	 * \@docs-private
	 */
	var MatCardContent = /** @class */ (function () {
	    function MatCardContent() {
	    }
	    MatCardContent.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-card-content',
	                    host: { 'class': 'mat-card-content' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardContent.ctorParameters = function () { return []; };
	    return MatCardContent;
	}());
	/**
	 * Title of a card, needed as it's used as a selector in the API.
	 * \@docs-private
	 */
	var MatCardTitle = /** @class */ (function () {
	    function MatCardTitle() {
	    }
	    MatCardTitle.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: "mat-card-title, [mat-card-title], [matCardTitle]",
	                    host: {
	                        'class': 'mat-card-title'
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardTitle.ctorParameters = function () { return []; };
	    return MatCardTitle;
	}());
	/**
	 * Sub-title of a card, needed as it's used as a selector in the API.
	 * \@docs-private
	 */
	var MatCardSubtitle = /** @class */ (function () {
	    function MatCardSubtitle() {
	    }
	    MatCardSubtitle.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: "mat-card-subtitle, [mat-card-subtitle], [matCardSubtitle]",
	                    host: {
	                        'class': 'mat-card-subtitle'
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardSubtitle.ctorParameters = function () { return []; };
	    return MatCardSubtitle;
	}());
	/**
	 * Action section of a card, needed as it's used as a selector in the API.
	 * \@docs-private
	 */
	var MatCardActions = /** @class */ (function () {
	    function MatCardActions() {
	        /**
	         * Position of the actions inside the card.
	         */
	        this.align = 'start';
	    }
	    MatCardActions.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-card-actions',
	                    exportAs: 'matCardActions',
	                    host: {
	                        'class': 'mat-card-actions',
	                        '[class.mat-card-actions-align-end]': 'align === "end"',
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardActions.ctorParameters = function () { return []; };
	    MatCardActions.propDecorators = {
	        "align": [{ type: _angular_core.Input },],
	    };
	    return MatCardActions;
	}());
	/**
	 * Footer of a card, needed as it's used as a selector in the API.
	 * \@docs-private
	 */
	var MatCardFooter = /** @class */ (function () {
	    function MatCardFooter() {
	    }
	    MatCardFooter.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-card-footer',
	                    host: { 'class': 'mat-card-footer' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardFooter.ctorParameters = function () { return []; };
	    return MatCardFooter;
	}());
	/**
	 * Image used in a card, needed to add the mat- CSS styling.
	 * \@docs-private
	 */
	var MatCardImage = /** @class */ (function () {
	    function MatCardImage() {
	    }
	    MatCardImage.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-card-image], [matCardImage]',
	                    host: { 'class': 'mat-card-image' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardImage.ctorParameters = function () { return []; };
	    return MatCardImage;
	}());
	/**
	 * Image used in a card, needed to add the mat- CSS styling.
	 * \@docs-private
	 */
	var MatCardSmImage = /** @class */ (function () {
	    function MatCardSmImage() {
	    }
	    MatCardSmImage.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-card-sm-image], [matCardImageSmall]',
	                    host: { 'class': 'mat-card-sm-image' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardSmImage.ctorParameters = function () { return []; };
	    return MatCardSmImage;
	}());
	/**
	 * Image used in a card, needed to add the mat- CSS styling.
	 * \@docs-private
	 */
	var MatCardMdImage = /** @class */ (function () {
	    function MatCardMdImage() {
	    }
	    MatCardMdImage.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-card-md-image], [matCardImageMedium]',
	                    host: { 'class': 'mat-card-md-image' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardMdImage.ctorParameters = function () { return []; };
	    return MatCardMdImage;
	}());
	/**
	 * Image used in a card, needed to add the mat- CSS styling.
	 * \@docs-private
	 */
	var MatCardLgImage = /** @class */ (function () {
	    function MatCardLgImage() {
	    }
	    MatCardLgImage.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-card-lg-image], [matCardImageLarge]',
	                    host: { 'class': 'mat-card-lg-image' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardLgImage.ctorParameters = function () { return []; };
	    return MatCardLgImage;
	}());
	/**
	 * Large image used in a card, needed to add the mat- CSS styling.
	 * \@docs-private
	 */
	var MatCardXlImage = /** @class */ (function () {
	    function MatCardXlImage() {
	    }
	    MatCardXlImage.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-card-xl-image], [matCardImageXLarge]',
	                    host: { 'class': 'mat-card-xl-image' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardXlImage.ctorParameters = function () { return []; };
	    return MatCardXlImage;
	}());
	/**
	 * Avatar image used in a card, needed to add the mat- CSS styling.
	 * \@docs-private
	 */
	var MatCardAvatar = /** @class */ (function () {
	    function MatCardAvatar() {
	    }
	    MatCardAvatar.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-card-avatar], [matCardAvatar]',
	                    host: { 'class': 'mat-card-avatar' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardAvatar.ctorParameters = function () { return []; };
	    return MatCardAvatar;
	}());
	/**
	 * A basic content container component that adds the styles of a Material design card.
	 *
	 * While this component can be used alone, it also provides a number
	 * of preset styles for common card sections, including:
	 * - mat-card-title
	 * - mat-card-subtitle
	 * - mat-card-content
	 * - mat-card-actions
	 * - mat-card-footer
	 */
	var MatCard = /** @class */ (function () {
	    function MatCard() {
	    }
	    MatCard.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-card',
	                    exportAs: 'matCard',
	                    template: "<ng-content></ng-content><ng-content select=\"mat-card-footer\"></ng-content>",
	                    styles: [".mat-card{transition:box-shadow 280ms cubic-bezier(.4,0,.2,1);display:block;position:relative;padding:24px;border-radius:2px}.mat-card:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.mat-card .mat-divider{position:absolute;left:0;width:100%}[dir=rtl] .mat-card .mat-divider{left:auto;right:0}.mat-card .mat-divider.mat-divider-inset{position:static;margin:0}@media screen and (-ms-high-contrast:active){.mat-card{outline:solid 1px}}.mat-card-flat{box-shadow:none}.mat-card-actions,.mat-card-content,.mat-card-subtitle,.mat-card-title{display:block;margin-bottom:16px}.mat-card-actions{margin-left:-16px;margin-right:-16px;padding:8px 0}.mat-card-actions-align-end{display:flex;justify-content:flex-end}.mat-card-image{width:calc(100% + 48px);margin:0 -24px 16px -24px}.mat-card-xl-image{width:240px;height:240px;margin:-8px}.mat-card-footer{display:block;margin:0 -24px -24px -24px}.mat-card-actions .mat-button,.mat-card-actions .mat-raised-button{margin:0 4px}.mat-card-header{display:flex;flex-direction:row}.mat-card-header-text{margin:0 8px}.mat-card-avatar{height:40px;width:40px;border-radius:50%;flex-shrink:0}.mat-card-lg-image,.mat-card-md-image,.mat-card-sm-image{margin:-8px 0}.mat-card-title-group{display:flex;justify-content:space-between;margin:0 -8px}.mat-card-sm-image{width:80px;height:80px}.mat-card-md-image{width:112px;height:112px}.mat-card-lg-image{width:152px;height:152px}@media (max-width:599px){.mat-card{padding:24px 16px}.mat-card-actions{margin-left:-8px;margin-right:-8px}.mat-card-image{width:calc(100% + 32px);margin:16px -16px}.mat-card-title-group{margin:0}.mat-card-xl-image{margin-left:0;margin-right:0}.mat-card-header{margin:-8px 0 0 0}.mat-card-footer{margin-left:-16px;margin-right:-16px}}.mat-card-content>:first-child,.mat-card>:first-child{margin-top:0}.mat-card-content>:last-child:not(.mat-card-footer),.mat-card>:last-child:not(.mat-card-footer){margin-bottom:0}.mat-card-image:first-child{margin-top:-24px}.mat-card>.mat-card-actions:last-child{margin-bottom:-16px;padding-bottom:0}.mat-card-actions .mat-button:first-child,.mat-card-actions .mat-raised-button:first-child{margin-left:0;margin-right:0}.mat-card-subtitle:not(:first-child),.mat-card-title:not(:first-child){margin-top:-4px}.mat-card-header .mat-card-subtitle:not(:first-child){margin-top:-8px}.mat-card>.mat-card-xl-image:first-child{margin-top:-8px}.mat-card>.mat-card-xl-image:last-child{margin-bottom:-8px}"],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    host: { 'class': 'mat-card' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCard.ctorParameters = function () { return []; };
	    return MatCard;
	}());
	/**
	 * Component intended to be used within the `<mat-card>` component. It adds styles for a
	 * preset header section (i.e. a title, subtitle, and avatar layout).
	 * \@docs-private
	 */
	var MatCardHeader = /** @class */ (function () {
	    function MatCardHeader() {
	    }
	    MatCardHeader.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-card-header',
	                    template: "<ng-content select=\"[mat-card-avatar], [matCardAvatar]\"></ng-content><div class=\"mat-card-header-text\"><ng-content select=\"mat-card-title, mat-card-subtitle, [mat-card-title], [mat-card-subtitle], [matCardTitle], [matCardSubtitle]\"></ng-content></div><ng-content></ng-content>",
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    host: { 'class': 'mat-card-header' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardHeader.ctorParameters = function () { return []; };
	    return MatCardHeader;
	}());
	/**
	 * Component intended to be used within the `<mat-card>` component. It adds styles for a preset
	 * layout that groups an image with a title section.
	 * \@docs-private
	 */
	var MatCardTitleGroup = /** @class */ (function () {
	    function MatCardTitleGroup() {
	    }
	    MatCardTitleGroup.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-card-title-group',
	                    template: "<div><ng-content select=\"mat-card-title, mat-card-subtitle, [mat-card-title], [mat-card-subtitle], [matCardTitle], [matCardSubtitle]\"></ng-content></div><ng-content select=\"img\"></ng-content><ng-content></ng-content>",
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    host: { 'class': 'mat-card-title-group' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardTitleGroup.ctorParameters = function () { return []; };
	    return MatCardTitleGroup;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatCardModule = /** @class */ (function () {
	    function MatCardModule() {
	    }
	    MatCardModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [MatCommonModule],
	                    exports: [
	                        MatCard,
	                        MatCardHeader,
	                        MatCardTitleGroup,
	                        MatCardContent,
	                        MatCardTitle,
	                        MatCardSubtitle,
	                        MatCardActions,
	                        MatCardFooter,
	                        MatCardSmImage,
	                        MatCardMdImage,
	                        MatCardLgImage,
	                        MatCardImage,
	                        MatCardXlImage,
	                        MatCardAvatar,
	                        MatCommonModule,
	                    ],
	                    declarations: [
	                        MatCard, MatCardHeader, MatCardTitleGroup, MatCardContent, MatCardTitle, MatCardSubtitle,
	                        MatCardActions, MatCardFooter, MatCardSmImage, MatCardMdImage, MatCardLgImage, MatCardImage,
	                        MatCardXlImage, MatCardAvatar,
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    MatCardModule.ctorParameters = function () { return []; };
	    return MatCardModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * Injection token that can be used to specify the checkbox click behavior.
	 */
	var MAT_CHECKBOX_CLICK_ACTION = new _angular_core.InjectionToken('mat-checkbox-click-action');
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	// Increasing integer for generating unique ids for checkbox components.
	var nextUniqueId$1$1 = 0;
	/**
	 * Provider Expression that allows mat-checkbox to register as a ControlValueAccessor.
	 * This allows it to support [(ngModel)].
	 * \@docs-private
	 */
	var MAT_CHECKBOX_CONTROL_VALUE_ACCESSOR = {
	    provide: _angular_forms.NG_VALUE_ACCESSOR,
	    useExisting: _angular_core.forwardRef(function () { return MatCheckbox; }),
	    multi: true
	};
	/** @enum {number} */
	var TransitionCheckState = {
	    /** The initial state of the component before any user interaction. */
	    Init: 0,
	    /** The state representing the component when it's becoming checked. */
	    Checked: 1,
	    /** The state representing the component when it's becoming unchecked. */
	    Unchecked: 2,
	    /** The state representing the component when it's becoming indeterminate. */
	    Indeterminate: 3,
	};
	TransitionCheckState[TransitionCheckState.Init] = "Init";
	TransitionCheckState[TransitionCheckState.Checked] = "Checked";
	TransitionCheckState[TransitionCheckState.Unchecked] = "Unchecked";
	TransitionCheckState[TransitionCheckState.Indeterminate] = "Indeterminate";
	/**
	 * Change event object emitted by MatCheckbox.
	 */
	var MatCheckboxChange = /** @class */ (function () {
	    function MatCheckboxChange() {
	    }
	    return MatCheckboxChange;
	}());
	/**
	 * \@docs-private
	 */
	var MatCheckboxBase = /** @class */ (function () {
	    function MatCheckboxBase(_elementRef) {
	        this._elementRef = _elementRef;
	    }
	    return MatCheckboxBase;
	}());
	var _MatCheckboxMixinBase = mixinTabIndex(mixinColor(mixinDisableRipple(mixinDisabled(MatCheckboxBase)), 'accent'));
	/**
	 * A material design checkbox component. Supports all of the functionality of an HTML5 checkbox,
	 * and exposes a similar API. A MatCheckbox can be either checked, unchecked, indeterminate, or
	 * disabled. Note that all additional accessibility attributes are taken care of by the component,
	 * so there is no need to provide them yourself. However, if you want to omit a label and still
	 * have the checkbox be accessible, you may supply an [aria-label] input.
	 * See: https://www.google.com/design/spec/components/selection-controls.html
	 */
	var MatCheckbox = /** @class */ (function (_super) {
	    __extends(MatCheckbox, _super);
	    function MatCheckbox(elementRef, _changeDetectorRef, _focusMonitor, tabIndex, _clickAction) {
	        var _this = _super.call(this, elementRef) || this;
	        _this._changeDetectorRef = _changeDetectorRef;
	        _this._focusMonitor = _focusMonitor;
	        _this._clickAction = _clickAction;
	        /**
	         * Attached to the aria-label attribute of the host element. In most cases, arial-labelledby will
	         * take precedence so this may be omitted.
	         */
	        _this.ariaLabel = '';
	        /**
	         * Users can specify the `aria-labelledby` attribute which will be forwarded to the input element
	         */
	        _this.ariaLabelledby = null;
	        _this._uniqueId = "mat-checkbox-" + ++nextUniqueId$1$1;
	        /**
	         * A unique id for the checkbox input. If none is supplied, it will be auto-generated.
	         */
	        _this.id = _this._uniqueId;
	        /**
	         * Whether the label should appear after or before the checkbox. Defaults to 'after'
	         */
	        _this.labelPosition = 'after';
	        /**
	         * Name value will be applied to the input element if present
	         */
	        _this.name = null;
	        /**
	         * Event emitted when the checkbox's `checked` value changes.
	         */
	        _this.change = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when the checkbox's `indeterminate` value changes.
	         */
	        _this.indeterminateChange = new _angular_core.EventEmitter();
	        /**
	         * Called when the checkbox is blurred. Needed to properly implement ControlValueAccessor.
	         * \@docs-private
	         */
	        _this._onTouched = function () { };
	        _this._currentAnimationClass = '';
	        _this._currentCheckState = TransitionCheckState.Init;
	        _this._controlValueAccessorChangeFn = function () { };
	        _this._checked = false;
	        _this._indeterminate = false;
	        _this.tabIndex = parseInt(tabIndex) || 0;
	        return _this;
	    }
	    Object.defineProperty(MatCheckbox.prototype, "inputId", {
	        /** Returns the unique id for the visual hidden input. */
	        get: /**
	         * Returns the unique id for the visual hidden input.
	         * @return {?}
	         */
	        function () { return (this.id || this._uniqueId) + "-input"; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatCheckbox.prototype, "required", {
	        get: /**
	         * Whether the checkbox is required.
	         * @return {?}
	         */
	        function () { return this._required; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._required = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatCheckbox.prototype, "align", {
	        get: /**
	         * Whether or not the checkbox should appear before or after the label.
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () {
	            // align refers to the checkbox relative to the label, while labelPosition refers to the
	            // label relative to the checkbox. As such, they are inverted.
	            return this.labelPosition == 'after' ? 'start' : 'end';
	        },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this.labelPosition = (value == 'start') ? 'after' : 'before';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatCheckbox.prototype.ngAfterViewInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._focusMonitor
	            .monitor(this._inputElement.nativeElement)
	            .subscribe(function (focusOrigin) { return _this._onInputFocusChange(focusOrigin); });
	    };
	    /**
	     * @return {?}
	     */
	    MatCheckbox.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._focusMonitor.stopMonitoring(this._inputElement.nativeElement);
	    };
	    Object.defineProperty(MatCheckbox.prototype, "checked", {
	        get: /**
	         * Whether the checkbox is checked.
	         * @return {?}
	         */
	        function () { return this._checked; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (value != this.checked) {
	                this._checked = value;
	                this._changeDetectorRef.markForCheck();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatCheckbox.prototype, "indeterminate", {
	        get: /**
	         * Whether the checkbox is indeterminate. This is also known as "mixed" mode and can be used to
	         * represent a checkbox with three states, e.g. a checkbox that represents a nested list of
	         * checkable items. Note that whenever checkbox is manually clicked, indeterminate is immediately
	         * set to false.
	         * @return {?}
	         */
	        function () { return this._indeterminate; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            var /** @type {?} */ changed = value != this._indeterminate;
	            this._indeterminate = value;
	            if (changed) {
	                if (this._indeterminate) {
	                    this._transitionCheckState(TransitionCheckState.Indeterminate);
	                }
	                else {
	                    this._transitionCheckState(this.checked ? TransitionCheckState.Checked : TransitionCheckState.Unchecked);
	                }
	                this.indeterminateChange.emit(this._indeterminate);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatCheckbox.prototype._isRippleDisabled = /**
	     * @return {?}
	     */
	    function () {
	        return this.disableRipple || this.disabled;
	    };
	    /** Method being called whenever the label text changes. */
	    /**
	     * Method being called whenever the label text changes.
	     * @return {?}
	     */
	    MatCheckbox.prototype._onLabelTextChange = /**
	     * Method being called whenever the label text changes.
	     * @return {?}
	     */
	    function () {
	        // This method is getting called whenever the label of the checkbox changes.
	        // Since the checkbox uses the OnPush strategy we need to notify it about the change
	        // that has been recognized by the cdkObserveContent directive.
	        this._changeDetectorRef.markForCheck();
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    MatCheckbox.prototype.writeValue = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        this.checked = !!value;
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    MatCheckbox.prototype.registerOnChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._controlValueAccessorChangeFn = fn;
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    MatCheckbox.prototype.registerOnTouched = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._onTouched = fn;
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    MatCheckbox.prototype.setDisabledState = /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    function (isDisabled) {
	        this.disabled = isDisabled;
	        this._changeDetectorRef.markForCheck();
	    };
	    /**
	     * @return {?}
	     */
	    MatCheckbox.prototype._getAriaChecked = /**
	     * @return {?}
	     */
	    function () {
	        return this.checked ? 'true' : (this.indeterminate ? 'mixed' : 'false');
	    };
	    /**
	     * @param {?} newState
	     * @return {?}
	     */
	    MatCheckbox.prototype._transitionCheckState = /**
	     * @param {?} newState
	     * @return {?}
	     */
	    function (newState) {
	        var /** @type {?} */ oldState = this._currentCheckState;
	        var /** @type {?} */ element = this._elementRef.nativeElement;
	        if (oldState === newState) {
	            return;
	        }
	        if (this._currentAnimationClass.length > 0) {
	            element.classList.remove(this._currentAnimationClass);
	        }
	        this._currentAnimationClass = this._getAnimationClassForCheckStateTransition(oldState, newState);
	        this._currentCheckState = newState;
	        if (this._currentAnimationClass.length > 0) {
	            element.classList.add(this._currentAnimationClass);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatCheckbox.prototype._emitChangeEvent = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ event = new MatCheckboxChange();
	        event.source = this;
	        event.checked = this.checked;
	        this._controlValueAccessorChangeFn(this.checked);
	        this.change.emit(event);
	    };
	    /**
	     * Function is called whenever the focus changes for the input element.
	     * @param {?} focusOrigin
	     * @return {?}
	     */
	    MatCheckbox.prototype._onInputFocusChange = /**
	     * Function is called whenever the focus changes for the input element.
	     * @param {?} focusOrigin
	     * @return {?}
	     */
	    function (focusOrigin) {
	        if (!this._focusRipple && focusOrigin === 'keyboard') {
	            this._focusRipple = this.ripple.launch(0, 0, { persistent: true });
	        }
	        else if (!focusOrigin) {
	            this._removeFocusRipple();
	            this._onTouched();
	        }
	    };
	    /** Toggles the `checked` state of the checkbox. */
	    /**
	     * Toggles the `checked` state of the checkbox.
	     * @return {?}
	     */
	    MatCheckbox.prototype.toggle = /**
	     * Toggles the `checked` state of the checkbox.
	     * @return {?}
	     */
	    function () {
	        this.checked = !this.checked;
	    };
	    /**
	     * Event handler for checkbox input element.
	     * Toggles checked state if element is not disabled.
	     * Do not toggle on (change) event since IE doesn't fire change event when
	     *   indeterminate checkbox is clicked.
	     * @param event
	     */
	    /**
	     * Event handler for checkbox input element.
	     * Toggles checked state if element is not disabled.
	     * Do not toggle on (change) event since IE doesn't fire change event when
	     *   indeterminate checkbox is clicked.
	     * @param {?} event
	     * @return {?}
	     */
	    MatCheckbox.prototype._onInputClick = /**
	     * Event handler for checkbox input element.
	     * Toggles checked state if element is not disabled.
	     * Do not toggle on (change) event since IE doesn't fire change event when
	     *   indeterminate checkbox is clicked.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var _this = this;
	        // We have to stop propagation for click events on the visual hidden input element.
	        // By default, when a user clicks on a label element, a generated click event will be
	        // dispatched on the associated input element. Since we are using a label element as our
	        // root container, the click event on the `checkbox` will be executed twice.
	        // The real click event will bubble up, and the generated click event also tries to bubble up.
	        // This will lead to multiple click events.
	        // Preventing bubbling for the second event will solve that issue.
	        event.stopPropagation();
	        // If resetIndeterminate is false, and the current state is indeterminate, do nothing on click
	        if (!this.disabled && this._clickAction !== 'noop') {
	            // When user manually click on the checkbox, `indeterminate` is set to false.
	            if (this.indeterminate && this._clickAction !== 'check') {
	                Promise.resolve().then(function () {
	                    _this._indeterminate = false;
	                    _this.indeterminateChange.emit(_this._indeterminate);
	                });
	            }
	            this.toggle();
	            this._transitionCheckState(this._checked ? TransitionCheckState.Checked : TransitionCheckState.Unchecked);
	            // Emit our custom change event if the native input emitted one.
	            // It is important to only emit it, if the native input triggered one, because
	            // we don't want to trigger a change event, when the `checked` variable changes for example.
	            this._emitChangeEvent();
	        }
	        else if (!this.disabled && this._clickAction === 'noop') {
	            // Reset native input when clicked with noop. The native checkbox becomes checked after
	            // click, reset it to be align with `checked` value of `mat-checkbox`.
	            this._inputElement.nativeElement.checked = this.checked;
	            this._inputElement.nativeElement.indeterminate = this.indeterminate;
	        }
	    };
	    /** Focuses the checkbox. */
	    /**
	     * Focuses the checkbox.
	     * @return {?}
	     */
	    MatCheckbox.prototype.focus = /**
	     * Focuses the checkbox.
	     * @return {?}
	     */
	    function () {
	        this._focusMonitor.focusVia(this._inputElement.nativeElement, 'keyboard');
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    MatCheckbox.prototype._onInteractionEvent = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        // We always have to stop propagation on the change event.
	        // Otherwise the change event, from the input element, will bubble up and
	        // emit its event object to the `change` output.
	        event.stopPropagation();
	    };
	    /**
	     * @param {?} oldState
	     * @param {?} newState
	     * @return {?}
	     */
	    MatCheckbox.prototype._getAnimationClassForCheckStateTransition = /**
	     * @param {?} oldState
	     * @param {?} newState
	     * @return {?}
	     */
	    function (oldState, newState) {
	        var /** @type {?} */ animSuffix = '';
	        switch (oldState) {
	            case TransitionCheckState.Init:
	                // Handle edge case where user interacts with checkbox that does not have [(ngModel)] or
	                // [checked] bound to it.
	                if (newState === TransitionCheckState.Checked) {
	                    animSuffix = 'unchecked-checked';
	                }
	                else if (newState == TransitionCheckState.Indeterminate) {
	                    animSuffix = 'unchecked-indeterminate';
	                }
	                else {
	                    return '';
	                }
	                break;
	            case TransitionCheckState.Unchecked:
	                animSuffix = newState === TransitionCheckState.Checked ?
	                    'unchecked-checked' : 'unchecked-indeterminate';
	                break;
	            case TransitionCheckState.Checked:
	                animSuffix = newState === TransitionCheckState.Unchecked ?
	                    'checked-unchecked' : 'checked-indeterminate';
	                break;
	            case TransitionCheckState.Indeterminate:
	                animSuffix = newState === TransitionCheckState.Checked ?
	                    'indeterminate-checked' : 'indeterminate-unchecked';
	                break;
	        }
	        return "mat-checkbox-anim-" + animSuffix;
	    };
	    /**
	     * Fades out the focus state ripple.
	     * @return {?}
	     */
	    MatCheckbox.prototype._removeFocusRipple = /**
	     * Fades out the focus state ripple.
	     * @return {?}
	     */
	    function () {
	        if (this._focusRipple) {
	            this._focusRipple.fadeOut();
	            this._focusRipple = null;
	        }
	    };
	    MatCheckbox.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-checkbox',
	                    template: "<label [attr.for]=\"inputId\" class=\"mat-checkbox-layout\" #label><div class=\"mat-checkbox-inner-container\" [class.mat-checkbox-inner-container-no-side-margin]=\"!checkboxLabel.textContent || !checkboxLabel.textContent.trim()\"><input #input class=\"mat-checkbox-input cdk-visually-hidden\" type=\"checkbox\" [id]=\"inputId\" [required]=\"required\" [checked]=\"checked\" [attr.value]=\"value\" [disabled]=\"disabled\" [attr.name]=\"name\" [tabIndex]=\"tabIndex\" [indeterminate]=\"indeterminate\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledby\" [attr.aria-checked]=\"_getAriaChecked()\" (change)=\"_onInteractionEvent($event)\" (click)=\"_onInputClick($event)\"><div matRipple class=\"mat-checkbox-ripple\" [matRippleTrigger]=\"label\" [matRippleDisabled]=\"_isRippleDisabled()\" [matRippleRadius]=\"25\" [matRippleCentered]=\"true\" [matRippleAnimation]=\"{enterDuration: 150}\"></div><div class=\"mat-checkbox-frame\"></div><div class=\"mat-checkbox-background\"><svg version=\"1.1\" focusable=\"false\" class=\"mat-checkbox-checkmark\" viewBox=\"0 0 24 24\" xml:space=\"preserve\"><path class=\"mat-checkbox-checkmark-path\" fill=\"none\" stroke=\"white\" d=\"M4.1,12.7 9,17.6 20.3,6.3\"/></svg><div class=\"mat-checkbox-mixedmark\"></div></div></div><span class=\"mat-checkbox-label\" #checkboxLabel (cdkObserveContent)=\"_onLabelTextChange()\"><span style=\"display:none\">&nbsp;</span><ng-content></ng-content></span></label>",
	                    styles: ["@keyframes mat-checkbox-fade-in-background{0%{opacity:0}50%{opacity:1}}@keyframes mat-checkbox-fade-out-background{0%,50%{opacity:1}100%{opacity:0}}@keyframes mat-checkbox-unchecked-checked-checkmark-path{0%,50%{stroke-dashoffset:22.91026}50%{animation-timing-function:cubic-bezier(0,0,.2,.1)}100%{stroke-dashoffset:0}}@keyframes mat-checkbox-unchecked-indeterminate-mixedmark{0%,68.2%{transform:scaleX(0)}68.2%{animation-timing-function:cubic-bezier(0,0,0,1)}100%{transform:scaleX(1)}}@keyframes mat-checkbox-checked-unchecked-checkmark-path{from{animation-timing-function:cubic-bezier(.4,0,1,1);stroke-dashoffset:0}to{stroke-dashoffset:-22.91026}}@keyframes mat-checkbox-checked-indeterminate-checkmark{from{animation-timing-function:cubic-bezier(0,0,.2,.1);opacity:1;transform:rotate(0)}to{opacity:0;transform:rotate(45deg)}}@keyframes mat-checkbox-indeterminate-checked-checkmark{from{animation-timing-function:cubic-bezier(.14,0,0,1);opacity:0;transform:rotate(45deg)}to{opacity:1;transform:rotate(360deg)}}@keyframes mat-checkbox-checked-indeterminate-mixedmark{from{animation-timing-function:cubic-bezier(0,0,.2,.1);opacity:0;transform:rotate(-45deg)}to{opacity:1;transform:rotate(0)}}@keyframes mat-checkbox-indeterminate-checked-mixedmark{from{animation-timing-function:cubic-bezier(.14,0,0,1);opacity:1;transform:rotate(0)}to{opacity:0;transform:rotate(315deg)}}@keyframes mat-checkbox-indeterminate-unchecked-mixedmark{0%{animation-timing-function:linear;opacity:1;transform:scaleX(1)}100%,32.8%{opacity:0;transform:scaleX(0)}}.mat-checkbox-checkmark,.mat-checkbox-mixedmark{width:calc(100% - 4px)}.mat-checkbox-background,.mat-checkbox-frame{top:0;left:0;right:0;bottom:0;position:absolute;border-radius:2px;box-sizing:border-box;pointer-events:none}.mat-checkbox{transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);cursor:pointer}.mat-checkbox-layout{cursor:inherit;align-items:baseline;vertical-align:middle;display:inline-flex;white-space:nowrap}.mat-checkbox-inner-container{display:inline-block;height:20px;line-height:0;margin:auto;margin-right:8px;order:0;position:relative;vertical-align:middle;white-space:nowrap;width:20px;flex-shrink:0}[dir=rtl] .mat-checkbox-inner-container{margin-left:8px;margin-right:auto}.mat-checkbox-inner-container-no-side-margin{margin-left:0;margin-right:0}.mat-checkbox-frame{background-color:transparent;transition:border-color 90ms cubic-bezier(0,0,.2,.1);border-width:2px;border-style:solid}.mat-checkbox-background{align-items:center;display:inline-flex;justify-content:center;transition:background-color 90ms cubic-bezier(0,0,.2,.1),opacity 90ms cubic-bezier(0,0,.2,.1)}.mat-checkbox-checkmark{top:0;left:0;right:0;bottom:0;position:absolute;width:100%}.mat-checkbox-checkmark-path{stroke-dashoffset:22.91026;stroke-dasharray:22.91026;stroke-width:2.66667px}.mat-checkbox-mixedmark{height:2px;opacity:0;transform:scaleX(0) rotate(0)}.mat-checkbox-label-before .mat-checkbox-inner-container{order:1;margin-left:8px;margin-right:auto}[dir=rtl] .mat-checkbox-label-before .mat-checkbox-inner-container{margin-left:auto;margin-right:8px}.mat-checkbox-checked .mat-checkbox-checkmark{opacity:1}.mat-checkbox-checked .mat-checkbox-checkmark-path{stroke-dashoffset:0}.mat-checkbox-checked .mat-checkbox-mixedmark{transform:scaleX(1) rotate(-45deg)}.mat-checkbox-indeterminate .mat-checkbox-checkmark{opacity:0;transform:rotate(45deg)}.mat-checkbox-indeterminate .mat-checkbox-checkmark-path{stroke-dashoffset:0}.mat-checkbox-indeterminate .mat-checkbox-mixedmark{opacity:1;transform:scaleX(1) rotate(0)}.mat-checkbox-unchecked .mat-checkbox-background{background-color:transparent}.mat-checkbox-disabled{cursor:default}.mat-checkbox-anim-unchecked-checked .mat-checkbox-background{animation:180ms linear 0s mat-checkbox-fade-in-background}.mat-checkbox-anim-unchecked-checked .mat-checkbox-checkmark-path{animation:180ms linear 0s mat-checkbox-unchecked-checked-checkmark-path}.mat-checkbox-anim-unchecked-indeterminate .mat-checkbox-background{animation:180ms linear 0s mat-checkbox-fade-in-background}.mat-checkbox-anim-unchecked-indeterminate .mat-checkbox-mixedmark{animation:90ms linear 0s mat-checkbox-unchecked-indeterminate-mixedmark}.mat-checkbox-anim-checked-unchecked .mat-checkbox-background{animation:180ms linear 0s mat-checkbox-fade-out-background}.mat-checkbox-anim-checked-unchecked .mat-checkbox-checkmark-path{animation:90ms linear 0s mat-checkbox-checked-unchecked-checkmark-path}.mat-checkbox-anim-checked-indeterminate .mat-checkbox-checkmark{animation:90ms linear 0s mat-checkbox-checked-indeterminate-checkmark}.mat-checkbox-anim-checked-indeterminate .mat-checkbox-mixedmark{animation:90ms linear 0s mat-checkbox-checked-indeterminate-mixedmark}.mat-checkbox-anim-indeterminate-checked .mat-checkbox-checkmark{animation:.5s linear 0s mat-checkbox-indeterminate-checked-checkmark}.mat-checkbox-anim-indeterminate-checked .mat-checkbox-mixedmark{animation:.5s linear 0s mat-checkbox-indeterminate-checked-mixedmark}.mat-checkbox-anim-indeterminate-unchecked .mat-checkbox-background{animation:180ms linear 0s mat-checkbox-fade-out-background}.mat-checkbox-anim-indeterminate-unchecked .mat-checkbox-mixedmark{animation:.3s linear 0s mat-checkbox-indeterminate-unchecked-mixedmark}.mat-checkbox-input{bottom:0;left:50%}.mat-checkbox-ripple{position:absolute;left:calc(50% - 25px);top:calc(50% - 25px);height:50px;width:50px;z-index:1;pointer-events:none}"],
	                    exportAs: 'matCheckbox',
	                    host: {
	                        'class': 'mat-checkbox',
	                        '[id]': 'id',
	                        '[class.mat-checkbox-indeterminate]': 'indeterminate',
	                        '[class.mat-checkbox-checked]': 'checked',
	                        '[class.mat-checkbox-disabled]': 'disabled',
	                        '[class.mat-checkbox-label-before]': 'labelPosition == "before"',
	                    },
	                    providers: [MAT_CHECKBOX_CONTROL_VALUE_ACCESSOR],
	                    inputs: ['disabled', 'disableRipple', 'color', 'tabIndex'],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush
	                },] },
	    ];
	    /** @nocollapse */
	    MatCheckbox.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: _angular_cdk_a11y.FocusMonitor, },
	        { type: undefined, decorators: [{ type: _angular_core.Attribute, args: ['tabindex',] },] },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MAT_CHECKBOX_CLICK_ACTION,] },] },
	    ]; };
	    MatCheckbox.propDecorators = {
	        "ariaLabel": [{ type: _angular_core.Input, args: ['aria-label',] },],
	        "ariaLabelledby": [{ type: _angular_core.Input, args: ['aria-labelledby',] },],
	        "id": [{ type: _angular_core.Input },],
	        "required": [{ type: _angular_core.Input },],
	        "align": [{ type: _angular_core.Input },],
	        "labelPosition": [{ type: _angular_core.Input },],
	        "name": [{ type: _angular_core.Input },],
	        "change": [{ type: _angular_core.Output },],
	        "indeterminateChange": [{ type: _angular_core.Output },],
	        "value": [{ type: _angular_core.Input },],
	        "_inputElement": [{ type: _angular_core.ViewChild, args: ['input',] },],
	        "ripple": [{ type: _angular_core.ViewChild, args: [MatRipple,] },],
	        "checked": [{ type: _angular_core.Input },],
	        "indeterminate": [{ type: _angular_core.Input },],
	    };
	    return MatCheckbox;
	}(_MatCheckboxMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MAT_CHECKBOX_REQUIRED_VALIDATOR = {
	    provide: _angular_forms.NG_VALIDATORS,
	    useExisting: _angular_core.forwardRef(function () { return MatCheckboxRequiredValidator; }),
	    multi: true
	};
	/**
	 * Validator for Material checkbox's required attribute in template-driven checkbox.
	 * Current CheckboxRequiredValidator only work with `input type=checkbox` and does not
	 * work with `mat-checkbox`.
	 */
	var MatCheckboxRequiredValidator = /** @class */ (function (_super) {
	    __extends(MatCheckboxRequiredValidator, _super);
	    function MatCheckboxRequiredValidator() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    MatCheckboxRequiredValidator.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: "mat-checkbox[required][formControlName],\n             mat-checkbox[required][formControl], mat-checkbox[required][ngModel]",
	                    providers: [MAT_CHECKBOX_REQUIRED_VALIDATOR],
	                    host: { '[attr.required]': 'required ? "" : null' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatCheckboxRequiredValidator.ctorParameters = function () { return []; };
	    return MatCheckboxRequiredValidator;
	}(_angular_forms.CheckboxRequiredValidator));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatCheckboxModule = /** @class */ (function () {
	    function MatCheckboxModule() {
	    }
	    MatCheckboxModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [_angular_common.CommonModule, MatRippleModule, MatCommonModule, _angular_cdk_observers.ObserversModule, _angular_cdk_a11y.A11yModule],
	                    exports: [MatCheckbox, MatCheckboxRequiredValidator, MatCommonModule],
	                    declarations: [MatCheckbox, MatCheckboxRequiredValidator],
	                },] },
	    ];
	    /** @nocollapse */
	    MatCheckboxModule.ctorParameters = function () { return []; };
	    return MatCheckboxModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Represents an event fired on an individual `mat-chip`.
	 * @record
	 */
	
	/**
	 * Event object emitted by MatChip when selected or deselected.
	 */
	var MatChipSelectionChange = /** @class */ (function () {
	    function MatChipSelectionChange(source, selected, isUserInput) {
	        if (isUserInput === void 0) { isUserInput = false; }
	        this.source = source;
	        this.selected = selected;
	        this.isUserInput = isUserInput;
	    }
	    return MatChipSelectionChange;
	}());
	/**
	 * \@docs-private
	 */
	var MatChipBase = /** @class */ (function () {
	    function MatChipBase(_elementRef) {
	        this._elementRef = _elementRef;
	    }
	    return MatChipBase;
	}());
	var _MatChipMixinBase = mixinColor(mixinDisabled(MatChipBase), 'primary');
	/**
	 * Dummy directive to add CSS class to basic chips.
	 * \@docs-private
	 */
	var MatBasicChip = /** @class */ (function () {
	    function MatBasicChip() {
	    }
	    MatBasicChip.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: "mat-basic-chip, [mat-basic-chip]",
	                    host: { 'class': 'mat-basic-chip' },
	                },] },
	    ];
	    /** @nocollapse */
	    MatBasicChip.ctorParameters = function () { return []; };
	    return MatBasicChip;
	}());
	/**
	 * Material design styled Chip component. Used inside the MatChipList component.
	 */
	var MatChip = /** @class */ (function (_super) {
	    __extends(MatChip, _super);
	    function MatChip(_elementRef) {
	        var _this = _super.call(this, _elementRef) || this;
	        _this._elementRef = _elementRef;
	        /**
	         * Whether the chip has focus.
	         */
	        _this._hasFocus = false;
	        _this._selected = false;
	        _this._selectable = true;
	        _this._removable = true;
	        /**
	         * Emits when the chip is focused.
	         */
	        _this._onFocus = new rxjs_Subject.Subject();
	        /**
	         * Emits when the chip is blured.
	         */
	        _this._onBlur = new rxjs_Subject.Subject();
	        /**
	         * Emitted when the chip is selected or deselected.
	         */
	        _this.selectionChange = new _angular_core.EventEmitter();
	        /**
	         * Emitted when the chip is destroyed.
	         */
	        _this.destroyed = new _angular_core.EventEmitter();
	        /**
	         * Emitted when the chip is destroyed.
	         * @deprecated Use 'destroyed' instead.
	         * \@deletion-target 6.0.0
	         */
	        _this.destroy = _this.destroyed;
	        /**
	         * Emitted when a chip is to be removed.
	         */
	        _this.removed = new _angular_core.EventEmitter();
	        /**
	         * Emitted when a chip is to be removed.
	         * @deprecated Use `removed` instead.
	         * \@deletion-target 6.0.0
	         */
	        _this.onRemove = _this.removed;
	        return _this;
	    }
	    Object.defineProperty(MatChip.prototype, "selected", {
	        get: /**
	         * Whether the chip is selected.
	         * @return {?}
	         */
	        function () { return this._selected; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._selected = _angular_cdk_coercion.coerceBooleanProperty(value);
	            this.selectionChange.emit({
	                source: this,
	                isUserInput: false,
	                selected: value
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChip.prototype, "value", {
	        get: /**
	         * The value of the chip. Defaults to the content inside `<mat-chip>` tags.
	         * @return {?}
	         */
	        function () {
	            return this._value != undefined
	                ? this._value
	                : this._elementRef.nativeElement.textContent;
	        },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._value = value; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChip.prototype, "selectable", {
	        get: /**
	         * Whether or not the chips are selectable. When a chip is not selectable,
	         * changes to it's selected state are always ignored.
	         * @return {?}
	         */
	        function () { return this._selectable; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._selectable = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChip.prototype, "removable", {
	        get: /**
	         * Determines whether or not the chip displays the remove styling and emits (remove) events.
	         * @return {?}
	         */
	        function () { return this._removable; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._removable = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChip.prototype, "ariaSelected", {
	        /** The ARIA selected applied to the chip. */
	        get: /**
	         * The ARIA selected applied to the chip.
	         * @return {?}
	         */
	        function () {
	            return this.selectable ? this.selected.toString() : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatChip.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this.destroyed.emit({ chip: this });
	    };
	    /** Selects the chip. */
	    /**
	     * Selects the chip.
	     * @return {?}
	     */
	    MatChip.prototype.select = /**
	     * Selects the chip.
	     * @return {?}
	     */
	    function () {
	        this._selected = true;
	        this.selectionChange.emit({
	            source: this,
	            isUserInput: false,
	            selected: true
	        });
	    };
	    /** Deselects the chip. */
	    /**
	     * Deselects the chip.
	     * @return {?}
	     */
	    MatChip.prototype.deselect = /**
	     * Deselects the chip.
	     * @return {?}
	     */
	    function () {
	        this._selected = false;
	        this.selectionChange.emit({
	            source: this,
	            isUserInput: false,
	            selected: false
	        });
	    };
	    /** Select this chip and emit selected event */
	    /**
	     * Select this chip and emit selected event
	     * @return {?}
	     */
	    MatChip.prototype.selectViaInteraction = /**
	     * Select this chip and emit selected event
	     * @return {?}
	     */
	    function () {
	        this._selected = true;
	        // Emit select event when selected changes.
	        this.selectionChange.emit({
	            source: this,
	            isUserInput: true,
	            selected: true
	        });
	    };
	    /** Toggles the current selected state of this chip. */
	    /**
	     * Toggles the current selected state of this chip.
	     * @param {?=} isUserInput
	     * @return {?}
	     */
	    MatChip.prototype.toggleSelected = /**
	     * Toggles the current selected state of this chip.
	     * @param {?=} isUserInput
	     * @return {?}
	     */
	    function (isUserInput) {
	        if (isUserInput === void 0) { isUserInput = false; }
	        this._selected = !this.selected;
	        this.selectionChange.emit({
	            source: this,
	            isUserInput: isUserInput,
	            selected: this._selected
	        });
	        return this.selected;
	    };
	    /** Allows for programmatic focusing of the chip. */
	    /**
	     * Allows for programmatic focusing of the chip.
	     * @return {?}
	     */
	    MatChip.prototype.focus = /**
	     * Allows for programmatic focusing of the chip.
	     * @return {?}
	     */
	    function () {
	        this._elementRef.nativeElement.focus();
	        this._onFocus.next({ chip: this });
	    };
	    /**
	     * Allows for programmatic removal of the chip. Called by the MatChipList when the DELETE or
	     * BACKSPACE keys are pressed.
	     *
	     * Informs any listeners of the removal request. Does not remove the chip from the DOM.
	     */
	    /**
	     * Allows for programmatic removal of the chip. Called by the MatChipList when the DELETE or
	     * BACKSPACE keys are pressed.
	     *
	     * Informs any listeners of the removal request. Does not remove the chip from the DOM.
	     * @return {?}
	     */
	    MatChip.prototype.remove = /**
	     * Allows for programmatic removal of the chip. Called by the MatChipList when the DELETE or
	     * BACKSPACE keys are pressed.
	     *
	     * Informs any listeners of the removal request. Does not remove the chip from the DOM.
	     * @return {?}
	     */
	    function () {
	        if (this.removable) {
	            this.removed.emit({ chip: this });
	        }
	    };
	    /** Ensures events fire properly upon click. */
	    /**
	     * Ensures events fire properly upon click.
	     * @param {?} event
	     * @return {?}
	     */
	    MatChip.prototype._handleClick = /**
	     * Ensures events fire properly upon click.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        // Check disabled
	        if (this.disabled) {
	            return;
	        }
	        event.preventDefault();
	        event.stopPropagation();
	        this.focus();
	    };
	    /** Handle custom key presses. */
	    /**
	     * Handle custom key presses.
	     * @param {?} event
	     * @return {?}
	     */
	    MatChip.prototype._handleKeydown = /**
	     * Handle custom key presses.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (this.disabled) {
	            return;
	        }
	        switch (event.keyCode) {
	            case _angular_cdk_keycodes.DELETE:
	            case _angular_cdk_keycodes.BACKSPACE:
	                // If we are removable, remove the focused chip
	                this.remove();
	                // Always prevent so page navigation does not occur
	                event.preventDefault();
	                break;
	            case _angular_cdk_keycodes.SPACE:
	                // If we are selectable, toggle the focused chip
	                if (this.selectable) {
	                    this.toggleSelected(true);
	                }
	                // Always prevent space from scrolling the page since the list has focus
	                event.preventDefault();
	                break;
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatChip.prototype._blur = /**
	     * @return {?}
	     */
	    function () {
	        this._hasFocus = false;
	        this._onBlur.next({ chip: this });
	    };
	    MatChip.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]",
	                    inputs: ['color', 'disabled'],
	                    exportAs: 'matChip',
	                    host: {
	                        'class': 'mat-chip',
	                        '[attr.tabindex]': 'disabled ? null : -1',
	                        'role': 'option',
	                        '[class.mat-chip-selected]': 'selected',
	                        '[attr.disabled]': 'disabled || null',
	                        '[attr.aria-disabled]': 'disabled.toString()',
	                        '[attr.aria-selected]': 'ariaSelected',
	                        '(click)': '_handleClick($event)',
	                        '(keydown)': '_handleKeydown($event)',
	                        '(focus)': '_hasFocus = true',
	                        '(blur)': '_blur()',
	                    },
	                },] },
	    ];
	    /** @nocollapse */
	    MatChip.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	    ]; };
	    MatChip.propDecorators = {
	        "selected": [{ type: _angular_core.Input },],
	        "value": [{ type: _angular_core.Input },],
	        "selectable": [{ type: _angular_core.Input },],
	        "removable": [{ type: _angular_core.Input },],
	        "selectionChange": [{ type: _angular_core.Output },],
	        "destroyed": [{ type: _angular_core.Output },],
	        "destroy": [{ type: _angular_core.Output },],
	        "removed": [{ type: _angular_core.Output },],
	        "onRemove": [{ type: _angular_core.Output, args: ['remove',] },],
	    };
	    return MatChip;
	}(_MatChipMixinBase));
	/**
	 * Applies proper (click) support and adds styling for use with the Material Design "cancel" icon
	 * available at https://material.io/icons/#ic_cancel.
	 *
	 * Example:
	 *
	 *     `<mat-chip>
	 *       <mat-icon matChipRemove>cancel</mat-icon>
	 *     </mat-chip>`
	 *
	 * You *may* use a custom icon, but you may need to override the `mat-chip-remove` positioning
	 * styles to properly center the icon within the chip.
	 */
	var MatChipRemove = /** @class */ (function () {
	    function MatChipRemove(_parentChip) {
	        this._parentChip = _parentChip;
	    }
	    /** Calls the parent chip's public `remove()` method if applicable. */
	    /**
	     * Calls the parent chip's public `remove()` method if applicable.
	     * @return {?}
	     */
	    MatChipRemove.prototype._handleClick = /**
	     * Calls the parent chip's public `remove()` method if applicable.
	     * @return {?}
	     */
	    function () {
	        if (this._parentChip.removable) {
	            this._parentChip.remove();
	        }
	    };
	    MatChipRemove.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[matChipRemove]',
	                    host: {
	                        'class': 'mat-chip-remove',
	                        '(click)': '_handleClick()',
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatChipRemove.ctorParameters = function () { return [
	        { type: MatChip, },
	    ]; };
	    return MatChipRemove;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 */
	var MatChipListBase = /** @class */ (function () {
	    function MatChipListBase(_defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) {
	        this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
	        this._parentForm = _parentForm;
	        this._parentFormGroup = _parentFormGroup;
	        this.ngControl = ngControl;
	    }
	    return MatChipListBase;
	}());
	var _MatChipListMixinBase = mixinErrorState(MatChipListBase);
	// Increasing integer for generating unique ids for chip-list components.
	var nextUniqueId$2$1 = 0;
	/**
	 * Change event object that is emitted when the chip list value has changed.
	 */
	var MatChipListChange = /** @class */ (function () {
	    function MatChipListChange(source, value) {
	        this.source = source;
	        this.value = value;
	    }
	    return MatChipListChange;
	}());
	/**
	 * A material design chips component (named ChipList for it's similarity to the List component).
	 */
	var MatChipList = /** @class */ (function (_super) {
	    __extends(MatChipList, _super);
	    function MatChipList(_elementRef, _changeDetectorRef, _dir, _parentForm, _parentFormGroup, _defaultErrorStateMatcher, /** @docs-private */
	        ngControl) {
	        var _this = _super.call(this, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) || this;
	        _this._elementRef = _elementRef;
	        _this._changeDetectorRef = _changeDetectorRef;
	        _this._dir = _dir;
	        _this.ngControl = ngControl;
	        /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         */
	        _this.controlType = 'mat-chip-list';
	        /**
	         * When a chip is destroyed, we track the index so we can focus the appropriate next chip.
	         */
	        _this._lastDestroyedIndex = null;
	        /**
	         * Track which chips we're listening to for focus/destruction.
	         */
	        _this._chipSet = new WeakMap();
	        /**
	         * Subscription to tabbing out from the chip list.
	         */
	        _this._tabOutSubscription = rxjs_Subscription.Subscription.EMPTY;
	        /**
	         * Uid of the chip list
	         */
	        _this._uid = "mat-chip-list-" + nextUniqueId$2$1++;
	        /**
	         * Tab index for the chip list.
	         */
	        _this._tabIndex = 0;
	        /**
	         * User defined tab index.
	         * When it is not null, use user defined tab index. Otherwise use _tabIndex
	         */
	        _this._userTabIndex = null;
	        /**
	         * Function when touched
	         */
	        _this._onTouched = function () { };
	        /**
	         * Function when changed
	         */
	        _this._onChange = function () { };
	        _this._multiple = false;
	        _this._compareWith = function (o1, o2) { return o1 === o2; };
	        _this._required = false;
	        _this._disabled = false;
	        /**
	         * Orientation of the chip list.
	         */
	        _this.ariaOrientation = 'horizontal';
	        _this._selectable = true;
	        /**
	         * Event emitted when the selected chip list value has been changed by the user.
	         */
	        _this.change = new _angular_core.EventEmitter();
	        /**
	         * Event that emits whenever the raw value of the chip-list changes. This is here primarily
	         * to facilitate the two-way binding for the `value` input.
	         * \@docs-private
	         */
	        _this.valueChange = new _angular_core.EventEmitter();
	        if (_this.ngControl) {
	            _this.ngControl.valueAccessor = _this;
	        }
	        return _this;
	    }
	    Object.defineProperty(MatChipList.prototype, "selected", {
	        /** The array of selected chips inside chip list. */
	        get: /**
	         * The array of selected chips inside chip list.
	         * @return {?}
	         */
	        function () {
	            return this.multiple ? this._selectionModel.selected : this._selectionModel.selected[0];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "role", {
	        /** The ARIA role applied to the chip list. */
	        get: /**
	         * The ARIA role applied to the chip list.
	         * @return {?}
	         */
	        function () { return this.empty ? null : 'listbox'; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "multiple", {
	        get: /**
	         * Whether the user should be allowed to select multiple chips.
	         * @return {?}
	         */
	        function () { return this._multiple; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._multiple = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "compareWith", {
	        get: /**
	         * A function to compare the option values with the selected values. The first argument
	         * is a value from an option. The second is a value from the selection. A boolean
	         * should be returned.
	         * @return {?}
	         */
	        function () { return this._compareWith; },
	        set: /**
	         * @param {?} fn
	         * @return {?}
	         */
	        function (fn) {
	            this._compareWith = fn;
	            if (this._selectionModel) {
	                // A different comparator means the selection could change.
	                this._initializeSelection();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "value", {
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () { return this._value; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this.writeValue(value);
	            this._value = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "id", {
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () { return this._id || this._uid; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._id = value;
	            this.stateChanges.next();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "required", {
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () { return this._required; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._required = _angular_cdk_coercion.coerceBooleanProperty(value);
	            this.stateChanges.next();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "placeholder", {
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () {
	            return this._chipInput ? this._chipInput.placeholder : this._placeholder;
	        },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._placeholder = value;
	            this.stateChanges.next();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "focused", {
	        /** Whether any chips or the matChipInput inside of this chip-list has focus. */
	        get: /**
	         * Whether any chips or the matChipInput inside of this chip-list has focus.
	         * @return {?}
	         */
	        function () {
	            return this.chips.some(function (chip) { return chip._hasFocus; }) ||
	                (this._chipInput && this._chipInput.focused);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "empty", {
	        /**
	         * Implemented as part of MatFormFieldControl.
	         * @docs-private
	         */
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () {
	            return (!this._chipInput || this._chipInput.empty) && this.chips.length === 0;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "shouldLabelFloat", {
	        /**
	         * Implemented as part of MatFormFieldControl.
	         * @docs-private
	         */
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () { return !this.empty || this.focused; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "disabled", {
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () { return this.ngControl ? !!this.ngControl.disabled : this._disabled; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._disabled = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "selectable", {
	        get: /**
	         * Whether or not this chip is selectable. When a chip is not selectable,
	         * its selected state is always ignored.
	         * @return {?}
	         */
	        function () { return this._selectable; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._selectable = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "tabIndex", {
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._userTabIndex = value;
	            this._tabIndex = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "chipSelectionChanges", {
	        /** Combined stream of all of the child chips' selection change events. */
	        get: /**
	         * Combined stream of all of the child chips' selection change events.
	         * @return {?}
	         */
	        function () {
	            return rxjs_observable_merge.merge.apply(void 0, this.chips.map(function (chip) { return chip.selectionChange; }));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "chipFocusChanges", {
	        /** Combined stream of all of the child chips' focus change events. */
	        get: /**
	         * Combined stream of all of the child chips' focus change events.
	         * @return {?}
	         */
	        function () {
	            return rxjs_observable_merge.merge.apply(void 0, this.chips.map(function (chip) { return chip._onFocus; }));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "chipBlurChanges", {
	        /** Combined stream of all of the child chips' blur change events. */
	        get: /**
	         * Combined stream of all of the child chips' blur change events.
	         * @return {?}
	         */
	        function () {
	            return rxjs_observable_merge.merge.apply(void 0, this.chips.map(function (chip) { return chip._onBlur; }));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipList.prototype, "chipRemoveChanges", {
	        /** Combined stream of all of the child chips' remove change events. */
	        get: /**
	         * Combined stream of all of the child chips' remove change events.
	         * @return {?}
	         */
	        function () {
	            return rxjs_observable_merge.merge.apply(void 0, this.chips.map(function (chip) { return chip.destroy; }));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatChipList.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._keyManager = new _angular_cdk_a11y.FocusKeyManager(this.chips)
	            .withWrap()
	            .withVerticalOrientation()
	            .withHorizontalOrientation(this._dir ? this._dir.value : 'ltr');
	        // Prevents the chip list from capturing focus and redirecting
	        // it back to the first chip when the user tabs out.
	        this._tabOutSubscription = this._keyManager.tabOut.subscribe(function () {
	            _this._tabIndex = -1;
	            setTimeout(function () { return _this._tabIndex = _this._userTabIndex || 0; });
	        });
	        // When the list changes, re-subscribe
	        this._changeSubscription = this.chips.changes.pipe(rxjs_operators_startWith.startWith(null)).subscribe(function () {
	            _this._resetChips();
	            // Reset chips selected/deselected status
	            // Reset chips selected/deselected status
	            _this._initializeSelection();
	            // Check to see if we need to update our tab index
	            // Check to see if we need to update our tab index
	            _this._updateTabIndex();
	            // Check to see if we have a destroyed chip and need to refocus
	            // Check to see if we have a destroyed chip and need to refocus
	            _this._updateFocusForDestroyedChips();
	            _this.stateChanges.next();
	        });
	    };
	    /**
	     * @return {?}
	     */
	    MatChipList.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        this._selectionModel = new _angular_cdk_collections.SelectionModel(this.multiple, undefined, false);
	        this.stateChanges.next();
	    };
	    /**
	     * @return {?}
	     */
	    MatChipList.prototype.ngDoCheck = /**
	     * @return {?}
	     */
	    function () {
	        if (this.ngControl) {
	            // We need to re-evaluate this on every change detection cycle, because there are some
	            // error triggers that we can't subscribe to (e.g. parent form submissions). This means
	            // that whatever logic is in here has to be super lean or we risk destroying the performance.
	            this.updateErrorState();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatChipList.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._tabOutSubscription.unsubscribe();
	        if (this._changeSubscription) {
	            this._changeSubscription.unsubscribe();
	        }
	        if (this._chipRemoveSubscription) {
	            this._chipRemoveSubscription.unsubscribe();
	        }
	        this._dropSubscriptions();
	        this.stateChanges.complete();
	    };
	    /** Associates an HTML input element with this chip list. */
	    /**
	     * Associates an HTML input element with this chip list.
	     * @param {?} inputElement
	     * @return {?}
	     */
	    MatChipList.prototype.registerInput = /**
	     * Associates an HTML input element with this chip list.
	     * @param {?} inputElement
	     * @return {?}
	     */
	    function (inputElement) {
	        this._chipInput = inputElement;
	    };
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * @docs-private
	     */
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @param {?} ids
	     * @return {?}
	     */
	    MatChipList.prototype.setDescribedByIds = /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @param {?} ids
	     * @return {?}
	     */
	    function (ids) { this._ariaDescribedby = ids.join(' '); };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    MatChipList.prototype.writeValue = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        if (this.chips) {
	            this._setSelectionByValue(value, false);
	        }
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    MatChipList.prototype.registerOnChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._onChange = fn;
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    MatChipList.prototype.registerOnTouched = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._onTouched = fn;
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    MatChipList.prototype.setDisabledState = /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    function (isDisabled) {
	        this.disabled = isDisabled;
	        this._elementRef.nativeElement.disabled = isDisabled;
	        this.stateChanges.next();
	    };
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * @docs-private
	     */
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @return {?}
	     */
	    MatChipList.prototype.onContainerClick = /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @return {?}
	     */
	    function () { this.focus(); };
	    /**
	     * Focuses the the first non-disabled chip in this chip list, or the associated input when there
	     * are no eligible chips.
	     */
	    /**
	     * Focuses the the first non-disabled chip in this chip list, or the associated input when there
	     * are no eligible chips.
	     * @return {?}
	     */
	    MatChipList.prototype.focus = /**
	     * Focuses the the first non-disabled chip in this chip list, or the associated input when there
	     * are no eligible chips.
	     * @return {?}
	     */
	    function () {
	        // TODO: ARIA says this should focus the first `selected` chip if any are selected.
	        // Focus on first element if there's no chipInput inside chip-list
	        if (this._chipInput && this._chipInput.focused) {
	            // do nothing
	        }
	        else if (this.chips.length > 0) {
	            this._keyManager.setFirstItemActive();
	            this.stateChanges.next();
	        }
	        else {
	            this._focusInput();
	            this.stateChanges.next();
	        }
	    };
	    /** Attempt to focus an input if we have one. */
	    /**
	     * Attempt to focus an input if we have one.
	     * @return {?}
	     */
	    MatChipList.prototype._focusInput = /**
	     * Attempt to focus an input if we have one.
	     * @return {?}
	     */
	    function () {
	        if (this._chipInput) {
	            this._chipInput.focus();
	        }
	    };
	    /**
	     * Pass events to the keyboard manager. Available here for tests.
	     */
	    /**
	     * Pass events to the keyboard manager. Available here for tests.
	     * @param {?} event
	     * @return {?}
	     */
	    MatChipList.prototype._keydown = /**
	     * Pass events to the keyboard manager. Available here for tests.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var /** @type {?} */ target = /** @type {?} */ (event.target);
	        // If they are on an empty input and hit backspace, focus the last chip
	        if (event.keyCode === _angular_cdk_keycodes.BACKSPACE && this._isInputEmpty(target)) {
	            this._keyManager.setLastItemActive();
	            event.preventDefault();
	        }
	        else if (target && target.classList.contains('mat-chip')) {
	            this._keyManager.onKeydown(event);
	            this.stateChanges.next();
	        }
	    };
	    /**
	     * Check the tab index as you should not be allowed to focus an empty list.
	     */
	    /**
	     * Check the tab index as you should not be allowed to focus an empty list.
	     * @return {?}
	     */
	    MatChipList.prototype._updateTabIndex = /**
	     * Check the tab index as you should not be allowed to focus an empty list.
	     * @return {?}
	     */
	    function () {
	        // If we have 0 chips, we should not allow keyboard focus
	        this._tabIndex = this._userTabIndex || (this.chips.length === 0 ? -1 : 0);
	    };
	    /**
	     * Update key manager's active item when chip is deleted.
	     * If the deleted chip is the last chip in chip list, focus the new last chip.
	     * Otherwise focus the next chip in the list.
	     * Save `_lastDestroyedIndex` so we can set the correct focus.
	     */
	    /**
	     * Update key manager's active item when chip is deleted.
	     * If the deleted chip is the last chip in chip list, focus the new last chip.
	     * Otherwise focus the next chip in the list.
	     * Save `_lastDestroyedIndex` so we can set the correct focus.
	     * @param {?} chip
	     * @return {?}
	     */
	    MatChipList.prototype._updateKeyManager = /**
	     * Update key manager's active item when chip is deleted.
	     * If the deleted chip is the last chip in chip list, focus the new last chip.
	     * Otherwise focus the next chip in the list.
	     * Save `_lastDestroyedIndex` so we can set the correct focus.
	     * @param {?} chip
	     * @return {?}
	     */
	    function (chip) {
	        var /** @type {?} */ chipIndex = this.chips.toArray().indexOf(chip);
	        if (this._isValidIndex(chipIndex)) {
	            if (chip._hasFocus) {
	                // Check whether the chip is not the last item
	                if (chipIndex < this.chips.length - 1) {
	                    this._keyManager.setActiveItem(chipIndex);
	                }
	                else if (chipIndex - 1 >= 0) {
	                    this._keyManager.setActiveItem(chipIndex - 1);
	                }
	            }
	            if (this._keyManager.activeItemIndex === chipIndex) {
	                this._lastDestroyedIndex = chipIndex;
	            }
	        }
	    };
	    /**
	     * Checks to see if a focus chip was recently destroyed so that we can refocus the next closest
	     * one.
	     */
	    /**
	     * Checks to see if a focus chip was recently destroyed so that we can refocus the next closest
	     * one.
	     * @return {?}
	     */
	    MatChipList.prototype._updateFocusForDestroyedChips = /**
	     * Checks to see if a focus chip was recently destroyed so that we can refocus the next closest
	     * one.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ chipsArray = this.chips;
	        if (this._lastDestroyedIndex != null && chipsArray.length > 0) {
	            // Check whether the destroyed chip was the last item
	            var /** @type {?} */ newFocusIndex = Math.min(this._lastDestroyedIndex, chipsArray.length - 1);
	            this._keyManager.setActiveItem(newFocusIndex);
	            var /** @type {?} */ focusChip = this._keyManager.activeItem;
	            // Focus the chip
	            if (focusChip) {
	                focusChip.focus();
	            }
	        }
	        // Reset our destroyed index
	        this._lastDestroyedIndex = null;
	    };
	    /**
	     * Utility to ensure all indexes are valid.
	     *
	     * @param {?} index The index to be checked.
	     * @return {?} True if the index is valid for our list of chips.
	     */
	    MatChipList.prototype._isValidIndex = /**
	     * Utility to ensure all indexes are valid.
	     *
	     * @param {?} index The index to be checked.
	     * @return {?} True if the index is valid for our list of chips.
	     */
	    function (index) {
	        return index >= 0 && index < this.chips.length;
	    };
	    /**
	     * @param {?} element
	     * @return {?}
	     */
	    MatChipList.prototype._isInputEmpty = /**
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) {
	        if (element && element.nodeName.toLowerCase() === 'input') {
	            var /** @type {?} */ input = /** @type {?} */ (element);
	            return !input.value;
	        }
	        return false;
	    };
	    /**
	     * @param {?} value
	     * @param {?=} isUserInput
	     * @return {?}
	     */
	    MatChipList.prototype._setSelectionByValue = /**
	     * @param {?} value
	     * @param {?=} isUserInput
	     * @return {?}
	     */
	    function (value, isUserInput) {
	        var _this = this;
	        if (isUserInput === void 0) { isUserInput = true; }
	        this._clearSelection();
	        this.chips.forEach(function (chip) { return chip.deselect(); });
	        if (Array.isArray(value)) {
	            value.forEach(function (currentValue) { return _this._selectValue(currentValue, isUserInput); });
	            this._sortValues();
	        }
	        else {
	            var /** @type {?} */ correspondingChip = this._selectValue(value, isUserInput);
	            // Shift focus to the active item. Note that we shouldn't do this in multiple
	            // mode, because we don't know what chip the user interacted with last.
	            if (correspondingChip) {
	                var /** @type {?} */ correspondingChipIndex = this.chips.toArray().indexOf(correspondingChip);
	                if (isUserInput) {
	                    this._keyManager.setActiveItem(correspondingChipIndex);
	                }
	                else {
	                    this._keyManager.updateActiveItemIndex(correspondingChipIndex);
	                }
	            }
	        }
	    };
	    /**
	     * Finds and selects the chip based on its value.
	     * @param {?} value
	     * @param {?=} isUserInput
	     * @return {?} Chip that has the corresponding value.
	     */
	    MatChipList.prototype._selectValue = /**
	     * Finds and selects the chip based on its value.
	     * @param {?} value
	     * @param {?=} isUserInput
	     * @return {?} Chip that has the corresponding value.
	     */
	    function (value, isUserInput) {
	        var _this = this;
	        if (isUserInput === void 0) { isUserInput = true; }
	        var /** @type {?} */ correspondingChip = this.chips.find(function (chip) {
	            return chip.value != null && _this._compareWith(chip.value, value);
	        });
	        if (correspondingChip) {
	            isUserInput ? correspondingChip.selectViaInteraction() : correspondingChip.select();
	            this._selectionModel.select(correspondingChip);
	        }
	        return correspondingChip;
	    };
	    /**
	     * @return {?}
	     */
	    MatChipList.prototype._initializeSelection = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        // Defer setting the value in order to avoid the "Expression
	        // has changed after it was checked" errors from Angular.
	        Promise.resolve().then(function () {
	            if (_this.ngControl || _this._value) {
	                _this._setSelectionByValue(_this.ngControl ? _this.ngControl.value : _this._value, false);
	                _this.stateChanges.next();
	            }
	        });
	    };
	    /**
	     * Deselects every chip in the list.
	     * @param {?=} skip Chip that should not be deselected.
	     * @return {?}
	     */
	    MatChipList.prototype._clearSelection = /**
	     * Deselects every chip in the list.
	     * @param {?=} skip Chip that should not be deselected.
	     * @return {?}
	     */
	    function (skip) {
	        this._selectionModel.clear();
	        this.chips.forEach(function (chip) {
	            if (chip !== skip) {
	                chip.deselect();
	            }
	        });
	        this.stateChanges.next();
	    };
	    /**
	     * Sorts the model values, ensuring that they keep the same
	     * order that they have in the panel.
	     * @return {?}
	     */
	    MatChipList.prototype._sortValues = /**
	     * Sorts the model values, ensuring that they keep the same
	     * order that they have in the panel.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._multiple) {
	            this._selectionModel.clear();
	            this.chips.forEach(function (chip) {
	                if (chip.selected) {
	                    _this._selectionModel.select(chip);
	                }
	            });
	            this.stateChanges.next();
	        }
	    };
	    /**
	     * Emits change event to set the model value.
	     * @param {?=} fallbackValue
	     * @return {?}
	     */
	    MatChipList.prototype._propagateChanges = /**
	     * Emits change event to set the model value.
	     * @param {?=} fallbackValue
	     * @return {?}
	     */
	    function (fallbackValue) {
	        var /** @type {?} */ valueToEmit = null;
	        if (Array.isArray(this.selected)) {
	            valueToEmit = this.selected.map(function (chip) { return chip.value; });
	        }
	        else {
	            valueToEmit = this.selected ? this.selected.value : fallbackValue;
	        }
	        this._value = valueToEmit;
	        this.change.emit(new MatChipListChange(this, valueToEmit));
	        this.valueChange.emit(valueToEmit);
	        this._onChange(valueToEmit);
	        this._changeDetectorRef.markForCheck();
	    };
	    /** When blurred, mark the field as touched when focus moved outside the chip list. */
	    /**
	     * When blurred, mark the field as touched when focus moved outside the chip list.
	     * @return {?}
	     */
	    MatChipList.prototype._blur = /**
	     * When blurred, mark the field as touched when focus moved outside the chip list.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (!this.disabled) {
	            if (this._chipInput) {
	                // If there's a chip input, we should check whether the focus moved to chip input.
	                // If the focus is not moved to chip input, mark the field as touched. If the focus moved
	                // to chip input, do nothing.
	                // Timeout is needed to wait for the focus() event trigger on chip input.
	                setTimeout(function () {
	                    if (!_this.focused) {
	                        _this._markAsTouched();
	                    }
	                });
	            }
	            else {
	                // If there's no chip input, then mark the field as touched.
	                this._markAsTouched();
	            }
	        }
	    };
	    /** Mark the field as touched */
	    /**
	     * Mark the field as touched
	     * @return {?}
	     */
	    MatChipList.prototype._markAsTouched = /**
	     * Mark the field as touched
	     * @return {?}
	     */
	    function () {
	        this._onTouched();
	        this._changeDetectorRef.markForCheck();
	        this.stateChanges.next();
	    };
	    /**
	     * @return {?}
	     */
	    MatChipList.prototype._resetChips = /**
	     * @return {?}
	     */
	    function () {
	        this._dropSubscriptions();
	        this._listenToChipsFocus();
	        this._listenToChipsSelection();
	        this._listenToChipsRemoved();
	    };
	    /**
	     * @return {?}
	     */
	    MatChipList.prototype._dropSubscriptions = /**
	     * @return {?}
	     */
	    function () {
	        if (this._chipFocusSubscription) {
	            this._chipFocusSubscription.unsubscribe();
	            this._chipFocusSubscription = null;
	        }
	        if (this._chipBlurSubscription) {
	            this._chipBlurSubscription.unsubscribe();
	            this._chipBlurSubscription = null;
	        }
	        if (this._chipSelectionSubscription) {
	            this._chipSelectionSubscription.unsubscribe();
	            this._chipSelectionSubscription = null;
	        }
	    };
	    /**
	     * Listens to user-generated selection events on each chip.
	     * @return {?}
	     */
	    MatChipList.prototype._listenToChipsSelection = /**
	     * Listens to user-generated selection events on each chip.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._chipSelectionSubscription = this.chipSelectionChanges.subscribe(function (event) {
	            event.source.selected
	                ? _this._selectionModel.select(event.source)
	                : _this._selectionModel.deselect(event.source);
	            // For single selection chip list, make sure the deselected value is unselected.
	            if (!_this.multiple) {
	                _this.chips.forEach(function (chip) {
	                    if (!_this._selectionModel.isSelected(chip) && chip.selected) {
	                        chip.deselect();
	                    }
	                });
	            }
	            if (event.isUserInput) {
	                _this._propagateChanges();
	            }
	        });
	    };
	    /**
	     * Listens to user-generated selection events on each chip.
	     * @return {?}
	     */
	    MatChipList.prototype._listenToChipsFocus = /**
	     * Listens to user-generated selection events on each chip.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._chipFocusSubscription = this.chipFocusChanges.subscribe(function (event) {
	            var /** @type {?} */ chipIndex = _this.chips.toArray().indexOf(event.chip);
	            if (_this._isValidIndex(chipIndex)) {
	                _this._keyManager.updateActiveItemIndex(chipIndex);
	            }
	            _this.stateChanges.next();
	        });
	        this._chipBlurSubscription = this.chipBlurChanges.subscribe(function () {
	            _this._blur();
	            _this.stateChanges.next();
	        });
	    };
	    /**
	     * @return {?}
	     */
	    MatChipList.prototype._listenToChipsRemoved = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._chipRemoveSubscription = this.chipRemoveChanges.subscribe(function (event) {
	            _this._updateKeyManager(event.chip);
	        });
	    };
	    MatChipList.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-chip-list',
	                    template: "<div class=\"mat-chip-list-wrapper\"><ng-content></ng-content></div>",
	                    exportAs: 'matChipList',
	                    host: {
	                        '[attr.tabindex]': '_tabIndex',
	                        '[attr.aria-describedby]': '_ariaDescribedby || null',
	                        '[attr.aria-required]': 'required.toString()',
	                        '[attr.aria-disabled]': 'disabled.toString()',
	                        '[attr.aria-invalid]': 'errorState',
	                        '[attr.aria-multiselectable]': 'multiple',
	                        '[attr.role]': 'role',
	                        '[class.mat-chip-list-disabled]': 'disabled',
	                        '[class.mat-chip-list-invalid]': 'errorState',
	                        '[class.mat-chip-list-required]': 'required',
	                        '[attr.aria-orientation]': 'ariaOrientation',
	                        'class': 'mat-chip-list',
	                        '(focus)': 'focus()',
	                        '(blur)': '_blur()',
	                        '(keydown)': '_keydown($event)'
	                    },
	                    providers: [{ provide: MatFormFieldControl, useExisting: MatChipList }],
	                    styles: [".mat-chip-list-wrapper{display:flex;flex-direction:row;flex-wrap:wrap;align-items:baseline}.mat-chip:not(.mat-basic-chip){transition:box-shadow 280ms cubic-bezier(.4,0,.2,1);display:inline-flex;padding:7px 12px;border-radius:24px;align-items:center;cursor:default}.mat-chip:not(.mat-basic-chip)+.mat-chip:not(.mat-basic-chip){margin:0 0 0 8px}[dir=rtl] .mat-chip:not(.mat-basic-chip)+.mat-chip:not(.mat-basic-chip){margin:0 8px 0 0}.mat-form-field-prefix .mat-chip:not(.mat-basic-chip):last-child{margin-right:8px}[dir=rtl] .mat-form-field-prefix .mat-chip:not(.mat-basic-chip):last-child{margin-left:8px}.mat-chip:not(.mat-basic-chip) .mat-chip-remove.mat-icon{width:1em;height:1em}.mat-chip:not(.mat-basic-chip):focus{box-shadow:0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12);outline:0}@media screen and (-ms-high-contrast:active){.mat-chip:not(.mat-basic-chip){outline:solid 1px}}.mat-chip-list-stacked .mat-chip-list-wrapper{display:block}.mat-chip-list-stacked .mat-chip-list-wrapper .mat-chip:not(.mat-basic-chip){display:block;margin:0;margin-bottom:8px}[dir=rtl] .mat-chip-list-stacked .mat-chip-list-wrapper .mat-chip:not(.mat-basic-chip){margin:0;margin-bottom:8px}.mat-chip-list-stacked .mat-chip-list-wrapper .mat-chip:not(.mat-basic-chip):last-child,[dir=rtl] .mat-chip-list-stacked .mat-chip-list-wrapper .mat-chip:not(.mat-basic-chip):last-child{margin-bottom:0}.mat-form-field-prefix .mat-chip-list-wrapper{margin-bottom:8px}.mat-chip-remove{margin-right:-4px;margin-left:6px;cursor:pointer}[dir=rtl] .mat-chip-remove{margin-right:6px;margin-left:-4px}input.mat-chip-input{width:150px;margin:3px;flex:1 0 150px}"],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush
	                },] },
	    ];
	    /** @nocollapse */
	    MatChipList.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: _angular_cdk_bidi.Directionality, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_forms.NgForm, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_forms.FormGroupDirective, decorators: [{ type: _angular_core.Optional },] },
	        { type: ErrorStateMatcher, },
	        { type: _angular_forms.NgControl, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self },] },
	    ]; };
	    MatChipList.propDecorators = {
	        "errorStateMatcher": [{ type: _angular_core.Input },],
	        "multiple": [{ type: _angular_core.Input },],
	        "compareWith": [{ type: _angular_core.Input },],
	        "value": [{ type: _angular_core.Input },],
	        "id": [{ type: _angular_core.Input },],
	        "required": [{ type: _angular_core.Input },],
	        "placeholder": [{ type: _angular_core.Input },],
	        "disabled": [{ type: _angular_core.Input },],
	        "ariaOrientation": [{ type: _angular_core.Input, args: ['aria-orientation',] },],
	        "selectable": [{ type: _angular_core.Input },],
	        "tabIndex": [{ type: _angular_core.Input },],
	        "change": [{ type: _angular_core.Output },],
	        "valueChange": [{ type: _angular_core.Output },],
	        "chips": [{ type: _angular_core.ContentChildren, args: [MatChip,] },],
	    };
	    return MatChipList;
	}(_MatChipListMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Represents an input event on a `matChipInput`.
	 * @record
	 */
	
	/**
	 * Directive that adds chip-specific behaviors to an input element inside `<mat-form-field>`.
	 * May be placed inside or outside of an `<mat-chip-list>`.
	 */
	var MatChipInput = /** @class */ (function () {
	    function MatChipInput(_elementRef) {
	        this._elementRef = _elementRef;
	        /**
	         * Whether the control is focused.
	         */
	        this.focused = false;
	        this._addOnBlur = false;
	        /**
	         * The list of key codes that will trigger a chipEnd event.
	         *
	         * Defaults to `[ENTER]`.
	         */
	        this.separatorKeyCodes = [_angular_cdk_keycodes.ENTER];
	        /**
	         * Emitted when a chip is to be added.
	         */
	        this.chipEnd = new _angular_core.EventEmitter();
	        /**
	         * The input's placeholder text.
	         */
	        this.placeholder = '';
	        this._inputElement = /** @type {?} */ (this._elementRef.nativeElement);
	    }
	    Object.defineProperty(MatChipInput.prototype, "chipList", {
	        set: /**
	         * Register input for chip list
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (value) {
	                this._chipList = value;
	                this._chipList.registerInput(this);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipInput.prototype, "addOnBlur", {
	        get: /**
	         * Whether or not the chipEnd event will be emitted when the input is blurred.
	         * @return {?}
	         */
	        function () { return this._addOnBlur; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._addOnBlur = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatChipInput.prototype, "empty", {
	        /** Whether the input is empty. */
	        get: /**
	         * Whether the input is empty.
	         * @return {?}
	         */
	        function () { return !this._inputElement.value; },
	        enumerable: true,
	        configurable: true
	    });
	    /** Utility method to make host definition/tests more clear. */
	    /**
	     * Utility method to make host definition/tests more clear.
	     * @param {?=} event
	     * @return {?}
	     */
	    MatChipInput.prototype._keydown = /**
	     * Utility method to make host definition/tests more clear.
	     * @param {?=} event
	     * @return {?}
	     */
	    function (event) {
	        this._emitChipEnd(event);
	    };
	    /** Checks to see if the blur should emit the (chipEnd) event. */
	    /**
	     * Checks to see if the blur should emit the (chipEnd) event.
	     * @return {?}
	     */
	    MatChipInput.prototype._blur = /**
	     * Checks to see if the blur should emit the (chipEnd) event.
	     * @return {?}
	     */
	    function () {
	        if (this.addOnBlur) {
	            this._emitChipEnd();
	        }
	        this.focused = false;
	        // Blur the chip list if it is not focused
	        if (!this._chipList.focused) {
	            this._chipList._blur();
	        }
	        this._chipList.stateChanges.next();
	    };
	    /**
	     * @return {?}
	     */
	    MatChipInput.prototype._focus = /**
	     * @return {?}
	     */
	    function () {
	        this.focused = true;
	        this._chipList.stateChanges.next();
	    };
	    /** Checks to see if the (chipEnd) event needs to be emitted. */
	    /**
	     * Checks to see if the (chipEnd) event needs to be emitted.
	     * @param {?=} event
	     * @return {?}
	     */
	    MatChipInput.prototype._emitChipEnd = /**
	     * Checks to see if the (chipEnd) event needs to be emitted.
	     * @param {?=} event
	     * @return {?}
	     */
	    function (event) {
	        if (!this._inputElement.value && !!event) {
	            this._chipList._keydown(event);
	        }
	        if (!event || this.separatorKeyCodes.indexOf(event.keyCode) > -1) {
	            this.chipEnd.emit({ input: this._inputElement, value: this._inputElement.value });
	            if (event) {
	                event.preventDefault();
	            }
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatChipInput.prototype._onInput = /**
	     * @return {?}
	     */
	    function () {
	        // Let chip list know whenever the value changes.
	        this._chipList.stateChanges.next();
	    };
	    /** Focuses the input. */
	    /**
	     * Focuses the input.
	     * @return {?}
	     */
	    MatChipInput.prototype.focus = /**
	     * Focuses the input.
	     * @return {?}
	     */
	    function () { this._inputElement.focus(); };
	    MatChipInput.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'input[matChipInputFor]',
	                    exportAs: 'matChipInput, matChipInputFor',
	                    host: {
	                        'class': 'mat-chip-input mat-input-element',
	                        '(keydown)': '_keydown($event)',
	                        '(blur)': '_blur()',
	                        '(focus)': '_focus()',
	                        '(input)': '_onInput()',
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatChipInput.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	    ]; };
	    MatChipInput.propDecorators = {
	        "chipList": [{ type: _angular_core.Input, args: ['matChipInputFor',] },],
	        "addOnBlur": [{ type: _angular_core.Input, args: ['matChipInputAddOnBlur',] },],
	        "separatorKeyCodes": [{ type: _angular_core.Input, args: ['matChipInputSeparatorKeyCodes',] },],
	        "chipEnd": [{ type: _angular_core.Output, args: ['matChipInputTokenEnd',] },],
	        "placeholder": [{ type: _angular_core.Input },],
	    };
	    return MatChipInput;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatChipsModule = /** @class */ (function () {
	    function MatChipsModule() {
	    }
	    MatChipsModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [],
	                    exports: [MatChipList, MatChip, MatChipInput, MatChipRemove, MatChipRemove, MatBasicChip],
	                    declarations: [MatChipList, MatChip, MatChipInput, MatChipRemove, MatChipRemove, MatBasicChip],
	                    providers: [ErrorStateMatcher]
	                },] },
	    ];
	    /** @nocollapse */
	    MatChipsModule.ctorParameters = function () { return []; };
	    return MatChipsModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Possible overrides for a dialog's position.
	 * @record
	 */
	
	/**
	 * Configuration for opening a modal dialog with the MatDialog service.
	 */
	var MatDialogConfig = /** @class */ (function () {
	    function MatDialogConfig() {
	        /**
	         * The ARIA role of the dialog element.
	         */
	        this.role = 'dialog';
	        /**
	         * Custom class for the overlay pane.
	         */
	        this.panelClass = '';
	        /**
	         * Whether the dialog has a backdrop.
	         */
	        this.hasBackdrop = true;
	        /**
	         * Custom class for the backdrop,
	         */
	        this.backdropClass = '';
	        /**
	         * Whether the user can use escape or clicking outside to close a modal.
	         */
	        this.disableClose = false;
	        /**
	         * Width of the dialog.
	         */
	        this.width = '';
	        /**
	         * Height of the dialog.
	         */
	        this.height = '';
	        /**
	         * Max-width of the dialog. If a number is provided, pixel units are assumed. Defaults to 80vw
	         */
	        this.maxWidth = '80vw';
	        /**
	         * Data being injected into the child component.
	         */
	        this.data = null;
	        /**
	         * Layout direction for the dialog's content.
	         */
	        this.direction = 'ltr';
	        /**
	         * ID of the element that describes the dialog.
	         */
	        this.ariaDescribedBy = null;
	        /**
	         * Aria label to assign to the dialog element
	         */
	        this.ariaLabel = null;
	        /**
	         * Whether the dialog should focus the first focusable element on open.
	         */
	        this.autoFocus = true;
	        /**
	         * Whether the dialog should close when the user goes backwards/forwards in history.
	         */
	        this.closeOnNavigation = true;
	    }
	    return MatDialogConfig;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * Animations used by MatDialog.
	 */
	var matDialogAnimations = {
	    /** Animation that slides the dialog in and out of view and fades the opacity. */
	    slideDialog: _angular_animations.trigger('slideDialog', [
	        // Note: The `enter` animation doesn't transition to something like `translate3d(0, 0, 0)
	        // scale(1)`, because for some reason specifying the transform explicitly, causes IE both
	        // to blur the dialog content and decimate the animation performance. Leaving it as `none`
	        // solves both issues.
	        _angular_animations.state('enter', _angular_animations.style({ transform: 'none', opacity: 1 })),
	        _angular_animations.state('void', _angular_animations.style({ transform: 'translate3d(0, 25%, 0) scale(0.9)', opacity: 0 })),
	        _angular_animations.state('exit', _angular_animations.style({ transform: 'translate3d(0, 25%, 0)', opacity: 0 })),
	        _angular_animations.transition('* => *', _angular_animations.animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')),
	    ])
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Throws an exception for the case when a ComponentPortal is
	 * attached to a DomPortalOutlet without an origin.
	 * \@docs-private
	 * @return {?}
	 */
	function throwMatDialogContentAlreadyAttachedError() {
	    throw Error('Attempting to attach dialog content after content is already attached');
	}
	/**
	 * Internal component that wraps user-provided dialog content.
	 * Animation is based on https://material.io/guidelines/motion/choreography.html.
	 * \@docs-private
	 */
	var MatDialogContainer = /** @class */ (function (_super) {
	    __extends(MatDialogContainer, _super);
	    function MatDialogContainer(_elementRef, _focusTrapFactory, _changeDetectorRef, _document) {
	        var _this = _super.call(this) || this;
	        _this._elementRef = _elementRef;
	        _this._focusTrapFactory = _focusTrapFactory;
	        _this._changeDetectorRef = _changeDetectorRef;
	        _this._document = _document;
	        /**
	         * Element that was focused before the dialog was opened. Save this to restore upon close.
	         */
	        _this._elementFocusedBeforeDialogWasOpened = null;
	        /**
	         * State of the dialog animation.
	         */
	        _this._state = 'enter';
	        /**
	         * Emits when an animation state changes.
	         */
	        _this._animationStateChanged = new _angular_core.EventEmitter();
	        /**
	         * ID of the element that should be considered as the dialog's label.
	         */
	        _this._ariaLabelledBy = null;
	        return _this;
	    }
	    /**
	     * Attach a ComponentPortal as content to this dialog container.
	     * @param portal Portal to be attached as the dialog content.
	     */
	    /**
	     * Attach a ComponentPortal as content to this dialog container.
	     * @template T
	     * @param {?} portal Portal to be attached as the dialog content.
	     * @return {?}
	     */
	    MatDialogContainer.prototype.attachComponentPortal = /**
	     * Attach a ComponentPortal as content to this dialog container.
	     * @template T
	     * @param {?} portal Portal to be attached as the dialog content.
	     * @return {?}
	     */
	    function (portal) {
	        if (this._portalOutlet.hasAttached()) {
	            throwMatDialogContentAlreadyAttachedError();
	        }
	        this._savePreviouslyFocusedElement();
	        return this._portalOutlet.attachComponentPortal(portal);
	    };
	    /**
	     * Attach a TemplatePortal as content to this dialog container.
	     * @param portal Portal to be attached as the dialog content.
	     */
	    /**
	     * Attach a TemplatePortal as content to this dialog container.
	     * @template C
	     * @param {?} portal Portal to be attached as the dialog content.
	     * @return {?}
	     */
	    MatDialogContainer.prototype.attachTemplatePortal = /**
	     * Attach a TemplatePortal as content to this dialog container.
	     * @template C
	     * @param {?} portal Portal to be attached as the dialog content.
	     * @return {?}
	     */
	    function (portal) {
	        if (this._portalOutlet.hasAttached()) {
	            throwMatDialogContentAlreadyAttachedError();
	        }
	        this._savePreviouslyFocusedElement();
	        return this._portalOutlet.attachTemplatePortal(portal);
	    };
	    /**
	     * Moves the focus inside the focus trap.
	     * @return {?}
	     */
	    MatDialogContainer.prototype._trapFocus = /**
	     * Moves the focus inside the focus trap.
	     * @return {?}
	     */
	    function () {
	        if (!this._focusTrap) {
	            this._focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement);
	        }
	        // If were to attempt to focus immediately, then the content of the dialog would not yet be
	        // ready in instances where change detection has to run first. To deal with this, we simply
	        // wait for the microtask queue to be empty.
	        if (this._config.autoFocus) {
	            this._focusTrap.focusInitialElementWhenReady();
	        }
	    };
	    /**
	     * Restores focus to the element that was focused before the dialog opened.
	     * @return {?}
	     */
	    MatDialogContainer.prototype._restoreFocus = /**
	     * Restores focus to the element that was focused before the dialog opened.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ toFocus = this._elementFocusedBeforeDialogWasOpened;
	        // We need the extra check, because IE can set the `activeElement` to null in some cases.
	        if (toFocus && typeof toFocus.focus === 'function') {
	            toFocus.focus();
	        }
	        if (this._focusTrap) {
	            this._focusTrap.destroy();
	        }
	    };
	    /**
	     * Saves a reference to the element that was focused before the dialog was opened.
	     * @return {?}
	     */
	    MatDialogContainer.prototype._savePreviouslyFocusedElement = /**
	     * Saves a reference to the element that was focused before the dialog was opened.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._document) {
	            this._elementFocusedBeforeDialogWasOpened = /** @type {?} */ (this._document.activeElement);
	            // Note that there is no focus method when rendering on the server.
	            if (this._elementRef.nativeElement.focus) {
	                // Move focus onto the dialog immediately in order to prevent the user from accidentally
	                // opening multiple dialogs at the same time. Needs to be async, because the element
	                // may not be focusable immediately.
	                Promise.resolve().then(function () { return _this._elementRef.nativeElement.focus(); });
	            }
	        }
	    };
	    /** Callback, invoked whenever an animation on the host completes. */
	    /**
	     * Callback, invoked whenever an animation on the host completes.
	     * @param {?} event
	     * @return {?}
	     */
	    MatDialogContainer.prototype._onAnimationDone = /**
	     * Callback, invoked whenever an animation on the host completes.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (event.toState === 'enter') {
	            this._trapFocus();
	        }
	        else if (event.toState === 'exit') {
	            this._restoreFocus();
	        }
	        this._animationStateChanged.emit(event);
	    };
	    /** Callback, invoked when an animation on the host starts. */
	    /**
	     * Callback, invoked when an animation on the host starts.
	     * @param {?} event
	     * @return {?}
	     */
	    MatDialogContainer.prototype._onAnimationStart = /**
	     * Callback, invoked when an animation on the host starts.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        this._animationStateChanged.emit(event);
	    };
	    /** Starts the dialog exit animation. */
	    /**
	     * Starts the dialog exit animation.
	     * @return {?}
	     */
	    MatDialogContainer.prototype._startExitAnimation = /**
	     * Starts the dialog exit animation.
	     * @return {?}
	     */
	    function () {
	        this._state = 'exit';
	        // Mark the container for check so it can react if the
	        // view container is using OnPush change detection.
	        this._changeDetectorRef.markForCheck();
	    };
	    MatDialogContainer.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-dialog-container',
	                    template: "<ng-template cdkPortalOutlet></ng-template>",
	                    styles: [".mat-dialog-container{box-shadow:0 11px 15px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12);display:block;padding:24px;border-radius:2px;box-sizing:border-box;overflow:auto;outline:0;width:100%;height:100%}@media screen and (-ms-high-contrast:active){.mat-dialog-container{outline:solid 1px}}.mat-dialog-content{display:block;margin:0 -24px;padding:0 24px;max-height:65vh;overflow:auto;-webkit-overflow-scrolling:touch}.mat-dialog-title{margin:0 0 20px;display:block}.mat-dialog-actions{padding:12px 0;display:flex;flex-wrap:wrap;margin-bottom:-24px}.mat-dialog-actions[align=end]{justify-content:flex-end}.mat-dialog-actions[align=center]{justify-content:center}.mat-dialog-actions .mat-button+.mat-button,.mat-dialog-actions .mat-button+.mat-raised-button,.mat-dialog-actions .mat-raised-button+.mat-button,.mat-dialog-actions .mat-raised-button+.mat-raised-button{margin-left:8px}[dir=rtl] .mat-dialog-actions .mat-button+.mat-button,[dir=rtl] .mat-dialog-actions .mat-button+.mat-raised-button,[dir=rtl] .mat-dialog-actions .mat-raised-button+.mat-button,[dir=rtl] .mat-dialog-actions .mat-raised-button+.mat-raised-button{margin-left:0;margin-right:8px}"],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    // Using OnPush for dialogs caused some G3 sync issues. Disabled until we can track them down.
	                    // tslint:disable-next-line:validate-decorators
	                    changeDetection: _angular_core.ChangeDetectionStrategy.Default,
	                    animations: [matDialogAnimations.slideDialog],
	                    host: {
	                        'class': 'mat-dialog-container',
	                        'tabindex': '-1',
	                        '[attr.id]': '_id',
	                        '[attr.role]': '_config?.role',
	                        '[attr.aria-labelledby]': '_config?.ariaLabel ? null : _ariaLabelledBy',
	                        '[attr.aria-label]': '_config?.ariaLabel',
	                        '[attr.aria-describedby]': '_config?.ariaDescribedBy || null',
	                        '[@slideDialog]': '_state',
	                        '(@slideDialog.start)': '_onAnimationStart($event)',
	                        '(@slideDialog.done)': '_onAnimationDone($event)',
	                    },
	                },] },
	    ];
	    /** @nocollapse */
	    MatDialogContainer.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_a11y.FocusTrapFactory, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    MatDialogContainer.propDecorators = {
	        "_portalOutlet": [{ type: _angular_core.ViewChild, args: [_angular_cdk_portal.CdkPortalOutlet,] },],
	    };
	    return MatDialogContainer;
	}(_angular_cdk_portal.BasePortalOutlet));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	// TODO(jelbourn): resizing
	// Counter for unique dialog ids.
	var uniqueId = 0;
	/**
	 * Reference to a dialog opened via the MatDialog service.
	 */
	var MatDialogRef = /** @class */ (function () {
	    function MatDialogRef(_overlayRef, _containerInstance, location, id) {
	        if (id === void 0) { id = "mat-dialog-" + uniqueId++; }
	        var _this = this;
	        this._overlayRef = _overlayRef;
	        this._containerInstance = _containerInstance;
	        this.id = id;
	        /**
	         * Whether the user is allowed to close the dialog.
	         */
	        this.disableClose = this._containerInstance._config.disableClose;
	        /**
	         * Subject for notifying the user that the dialog has finished opening.
	         */
	        this._afterOpen = new rxjs_Subject.Subject();
	        /**
	         * Subject for notifying the user that the dialog has finished closing.
	         */
	        this._afterClosed = new rxjs_Subject.Subject();
	        /**
	         * Subject for notifying the user that the dialog has started closing.
	         */
	        this._beforeClose = new rxjs_Subject.Subject();
	        /**
	         * Subscription to changes in the user's location.
	         */
	        this._locationChanges = rxjs_Subscription.Subscription.EMPTY;
	        // Pass the id along to the container.
	        _containerInstance._id = id;
	        // Emit when opening animation completes
	        _containerInstance._animationStateChanged.pipe(rxjs_operators_filter.filter(function (event) { return event.phaseName === 'done' && event.toState === 'enter'; }), rxjs_operators_take.take(1))
	            .subscribe(function () {
	            _this._afterOpen.next();
	            _this._afterOpen.complete();
	        });
	        // Dispose overlay when closing animation is complete
	        _containerInstance._animationStateChanged.pipe(rxjs_operators_filter.filter(function (event) { return event.phaseName === 'done' && event.toState === 'exit'; }), rxjs_operators_take.take(1))
	            .subscribe(function () {
	            _this._overlayRef.dispose();
	            _this._locationChanges.unsubscribe();
	            _this._afterClosed.next(_this._result);
	            _this._afterClosed.complete();
	            _this.componentInstance = /** @type {?} */ ((null));
	        });
	        _overlayRef.keydownEvents()
	            .pipe(rxjs_operators_filter.filter(function (event) { return event.keyCode === _angular_cdk_keycodes.ESCAPE && !_this.disableClose; }))
	            .subscribe(function () { return _this.close(); });
	        if (location) {
	            // Close the dialog when the user goes forwards/backwards in history or when the location
	            // hash changes. Note that this usually doesn't include clicking on links (unless the user
	            // is using the `HashLocationStrategy`).
	            this._locationChanges = location.subscribe(function () {
	                if (_this._containerInstance._config.closeOnNavigation) {
	                    _this.close();
	                }
	            });
	        }
	    }
	    /**
	     * Close the dialog.
	     * @param dialogResult Optional result to return to the dialog opener.
	     */
	    /**
	     * Close the dialog.
	     * @param {?=} dialogResult Optional result to return to the dialog opener.
	     * @return {?}
	     */
	    MatDialogRef.prototype.close = /**
	     * Close the dialog.
	     * @param {?=} dialogResult Optional result to return to the dialog opener.
	     * @return {?}
	     */
	    function (dialogResult) {
	        var _this = this;
	        this._result = dialogResult;
	        // Transition the backdrop in parallel to the dialog.
	        this._containerInstance._animationStateChanged.pipe(rxjs_operators_filter.filter(function (event) { return event.phaseName === 'start'; }), rxjs_operators_take.take(1))
	            .subscribe(function () {
	            _this._beforeClose.next(dialogResult);
	            _this._beforeClose.complete();
	            _this._overlayRef.detachBackdrop();
	        });
	        this._containerInstance._startExitAnimation();
	    };
	    /**
	     * Gets an observable that is notified when the dialog is finished opening.
	     */
	    /**
	     * Gets an observable that is notified when the dialog is finished opening.
	     * @return {?}
	     */
	    MatDialogRef.prototype.afterOpen = /**
	     * Gets an observable that is notified when the dialog is finished opening.
	     * @return {?}
	     */
	    function () {
	        return this._afterOpen.asObservable();
	    };
	    /**
	     * Gets an observable that is notified when the dialog is finished closing.
	     */
	    /**
	     * Gets an observable that is notified when the dialog is finished closing.
	     * @return {?}
	     */
	    MatDialogRef.prototype.afterClosed = /**
	     * Gets an observable that is notified when the dialog is finished closing.
	     * @return {?}
	     */
	    function () {
	        return this._afterClosed.asObservable();
	    };
	    /**
	     * Gets an observable that is notified when the dialog has started closing.
	     */
	    /**
	     * Gets an observable that is notified when the dialog has started closing.
	     * @return {?}
	     */
	    MatDialogRef.prototype.beforeClose = /**
	     * Gets an observable that is notified when the dialog has started closing.
	     * @return {?}
	     */
	    function () {
	        return this._beforeClose.asObservable();
	    };
	    /**
	     * Gets an observable that emits when the overlay's backdrop has been clicked.
	     */
	    /**
	     * Gets an observable that emits when the overlay's backdrop has been clicked.
	     * @return {?}
	     */
	    MatDialogRef.prototype.backdropClick = /**
	     * Gets an observable that emits when the overlay's backdrop has been clicked.
	     * @return {?}
	     */
	    function () {
	        return this._overlayRef.backdropClick();
	    };
	    /**
	     * Gets an observable that emits when keydown events are targeted on the overlay.
	     */
	    /**
	     * Gets an observable that emits when keydown events are targeted on the overlay.
	     * @return {?}
	     */
	    MatDialogRef.prototype.keydownEvents = /**
	     * Gets an observable that emits when keydown events are targeted on the overlay.
	     * @return {?}
	     */
	    function () {
	        return this._overlayRef.keydownEvents();
	    };
	    /**
	     * Updates the dialog's position.
	     * @param position New dialog position.
	     */
	    /**
	     * Updates the dialog's position.
	     * @param {?=} position New dialog position.
	     * @return {?}
	     */
	    MatDialogRef.prototype.updatePosition = /**
	     * Updates the dialog's position.
	     * @param {?=} position New dialog position.
	     * @return {?}
	     */
	    function (position) {
	        var /** @type {?} */ strategy = this._getPositionStrategy();
	        if (position && (position.left || position.right)) {
	            position.left ? strategy.left(position.left) : strategy.right(position.right);
	        }
	        else {
	            strategy.centerHorizontally();
	        }
	        if (position && (position.top || position.bottom)) {
	            position.top ? strategy.top(position.top) : strategy.bottom(position.bottom);
	        }
	        else {
	            strategy.centerVertically();
	        }
	        this._overlayRef.updatePosition();
	        return this;
	    };
	    /**
	     * Updates the dialog's width and height.
	     * @param width New width of the dialog.
	     * @param height New height of the dialog.
	     */
	    /**
	     * Updates the dialog's width and height.
	     * @param {?=} width New width of the dialog.
	     * @param {?=} height New height of the dialog.
	     * @return {?}
	     */
	    MatDialogRef.prototype.updateSize = /**
	     * Updates the dialog's width and height.
	     * @param {?=} width New width of the dialog.
	     * @param {?=} height New height of the dialog.
	     * @return {?}
	     */
	    function (width, height) {
	        if (width === void 0) { width = 'auto'; }
	        if (height === void 0) { height = 'auto'; }
	        this._getPositionStrategy().width(width).height(height);
	        this._overlayRef.updatePosition();
	        return this;
	    };
	    /**
	     * Fetches the position strategy object from the overlay ref.
	     * @return {?}
	     */
	    MatDialogRef.prototype._getPositionStrategy = /**
	     * Fetches the position strategy object from the overlay ref.
	     * @return {?}
	     */
	    function () {
	        return /** @type {?} */ (this._overlayRef.getConfig().positionStrategy);
	    };
	    return MatDialogRef;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Injection token that can be used to access the data that was passed in to a dialog.
	 */
	var MAT_DIALOG_DATA = new _angular_core.InjectionToken('MatDialogData');
	/**
	 * Injection token that can be used to specify default dialog options.
	 */
	var MAT_DIALOG_DEFAULT_OPTIONS = new _angular_core.InjectionToken('mat-dialog-default-options');
	/**
	 * Injection token that determines the scroll handling while the dialog is open.
	 */
	var MAT_DIALOG_SCROLL_STRATEGY = new _angular_core.InjectionToken('mat-dialog-scroll-strategy');
	/**
	 * \@docs-private
	 * @param {?} overlay
	 * @return {?}
	 */
	function MAT_DIALOG_SCROLL_STRATEGY_PROVIDER_FACTORY(overlay) {
	    return function () { return overlay.scrollStrategies.block(); };
	}
	/**
	 * \@docs-private
	 */
	var MAT_DIALOG_SCROLL_STRATEGY_PROVIDER = {
	    provide: MAT_DIALOG_SCROLL_STRATEGY,
	    deps: [_angular_cdk_overlay.Overlay],
	    useFactory: MAT_DIALOG_SCROLL_STRATEGY_PROVIDER_FACTORY,
	};
	/**
	 * Service to open Material Design modal dialogs.
	 */
	var MatDialog = /** @class */ (function () {
	    function MatDialog(_overlay, _injector, _location, _defaultOptions, _scrollStrategy, _parentDialog, _overlayContainer) {
	        var _this = this;
	        this._overlay = _overlay;
	        this._injector = _injector;
	        this._location = _location;
	        this._defaultOptions = _defaultOptions;
	        this._scrollStrategy = _scrollStrategy;
	        this._parentDialog = _parentDialog;
	        this._overlayContainer = _overlayContainer;
	        this._openDialogsAtThisLevel = [];
	        this._afterAllClosedAtThisLevel = new rxjs_Subject.Subject();
	        this._afterOpenAtThisLevel = new rxjs_Subject.Subject();
	        this._ariaHiddenElements = new Map();
	        /**
	         * Stream that emits when all open dialog have finished closing.
	         * Will emit on subscribe if there are no open dialogs to begin with.
	         */
	        this.afterAllClosed = rxjs_observable_defer.defer(function () {
	            return _this.openDialogs.length ?
	                _this._afterAllClosed :
	                _this._afterAllClosed.pipe(rxjs_operators_startWith.startWith(undefined));
	        });
	    }
	    Object.defineProperty(MatDialog.prototype, "openDialogs", {
	        /** Keeps track of the currently-open dialogs. */
	        get: /**
	         * Keeps track of the currently-open dialogs.
	         * @return {?}
	         */
	        function () {
	            return this._parentDialog ? this._parentDialog.openDialogs : this._openDialogsAtThisLevel;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDialog.prototype, "afterOpen", {
	        /** Stream that emits when a dialog has been opened. */
	        get: /**
	         * Stream that emits when a dialog has been opened.
	         * @return {?}
	         */
	        function () {
	            return this._parentDialog ? this._parentDialog.afterOpen : this._afterOpenAtThisLevel;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDialog.prototype, "_afterAllClosed", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ parent = this._parentDialog;
	            return parent ? parent._afterAllClosed : this._afterAllClosedAtThisLevel;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Opens a modal dialog containing the given component.
	     * @param componentOrTemplateRef Type of the component to load into the dialog,
	     *     or a TemplateRef to instantiate as the dialog content.
	     * @param config Extra configuration options.
	     * @returns Reference to the newly-opened dialog.
	     */
	    /**
	     * Opens a modal dialog containing the given component.
	     * @template T, D
	     * @param {?} componentOrTemplateRef Type of the component to load into the dialog,
	     *     or a TemplateRef to instantiate as the dialog content.
	     * @param {?=} config Extra configuration options.
	     * @return {?} Reference to the newly-opened dialog.
	     */
	    MatDialog.prototype.open = /**
	     * Opens a modal dialog containing the given component.
	     * @template T, D
	     * @param {?} componentOrTemplateRef Type of the component to load into the dialog,
	     *     or a TemplateRef to instantiate as the dialog content.
	     * @param {?=} config Extra configuration options.
	     * @return {?} Reference to the newly-opened dialog.
	     */
	    function (componentOrTemplateRef, config) {
	        var _this = this;
	        config = _applyConfigDefaults(config, this._defaultOptions || new MatDialogConfig());
	        if (config.id && this.getDialogById(config.id)) {
	            throw Error("Dialog with id \"" + config.id + "\" exists already. The dialog id must be unique.");
	        }
	        var /** @type {?} */ overlayRef = this._createOverlay(config);
	        var /** @type {?} */ dialogContainer = this._attachDialogContainer(overlayRef, config);
	        var /** @type {?} */ dialogRef = this._attachDialogContent(componentOrTemplateRef, dialogContainer, overlayRef, config);
	        // If this is the first dialog that we're opening, hide all the non-overlay content.
	        if (!this.openDialogs.length) {
	            this._hideNonDialogContentFromAssistiveTechnology();
	        }
	        this.openDialogs.push(dialogRef);
	        dialogRef.afterClosed().subscribe(function () { return _this._removeOpenDialog(dialogRef); });
	        this.afterOpen.next(dialogRef);
	        return dialogRef;
	    };
	    /**
	     * Closes all of the currently-open dialogs.
	     */
	    /**
	     * Closes all of the currently-open dialogs.
	     * @return {?}
	     */
	    MatDialog.prototype.closeAll = /**
	     * Closes all of the currently-open dialogs.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ i = this.openDialogs.length;
	        while (i--) {
	            // The `_openDialogs` property isn't updated after close until the rxjs subscription
	            // runs on the next microtask, in addition to modifying the array as we're going
	            // through it. We loop through all of them and call close without assuming that
	            // they'll be removed from the list instantaneously.
	            this.openDialogs[i].close();
	        }
	    };
	    /**
	     * Finds an open dialog by its id.
	     * @param id ID to use when looking up the dialog.
	     */
	    /**
	     * Finds an open dialog by its id.
	     * @param {?} id ID to use when looking up the dialog.
	     * @return {?}
	     */
	    MatDialog.prototype.getDialogById = /**
	     * Finds an open dialog by its id.
	     * @param {?} id ID to use when looking up the dialog.
	     * @return {?}
	     */
	    function (id) {
	        return this.openDialogs.find(function (dialog) { return dialog.id === id; });
	    };
	    /**
	     * Creates the overlay into which the dialog will be loaded.
	     * @param {?} config The dialog configuration.
	     * @return {?} A promise resolving to the OverlayRef for the created overlay.
	     */
	    MatDialog.prototype._createOverlay = /**
	     * Creates the overlay into which the dialog will be loaded.
	     * @param {?} config The dialog configuration.
	     * @return {?} A promise resolving to the OverlayRef for the created overlay.
	     */
	    function (config) {
	        var /** @type {?} */ overlayConfig = this._getOverlayConfig(config);
	        return this._overlay.create(overlayConfig);
	    };
	    /**
	     * Creates an overlay config from a dialog config.
	     * @param {?} dialogConfig The dialog configuration.
	     * @return {?} The overlay configuration.
	     */
	    MatDialog.prototype._getOverlayConfig = /**
	     * Creates an overlay config from a dialog config.
	     * @param {?} dialogConfig The dialog configuration.
	     * @return {?} The overlay configuration.
	     */
	    function (dialogConfig) {
	        var /** @type {?} */ state$$1 = new _angular_cdk_overlay.OverlayConfig({
	            positionStrategy: this._overlay.position().global(),
	            scrollStrategy: dialogConfig.scrollStrategy || this._scrollStrategy(),
	            panelClass: dialogConfig.panelClass,
	            hasBackdrop: dialogConfig.hasBackdrop,
	            direction: dialogConfig.direction,
	            minWidth: dialogConfig.minWidth,
	            minHeight: dialogConfig.minHeight,
	            maxWidth: dialogConfig.maxWidth,
	            maxHeight: dialogConfig.maxHeight
	        });
	        if (dialogConfig.backdropClass) {
	            state$$1.backdropClass = dialogConfig.backdropClass;
	        }
	        return state$$1;
	    };
	    /**
	     * Attaches an MatDialogContainer to a dialog's already-created overlay.
	     * @param {?} overlay Reference to the dialog's underlying overlay.
	     * @param {?} config The dialog configuration.
	     * @return {?} A promise resolving to a ComponentRef for the attached container.
	     */
	    MatDialog.prototype._attachDialogContainer = /**
	     * Attaches an MatDialogContainer to a dialog's already-created overlay.
	     * @param {?} overlay Reference to the dialog's underlying overlay.
	     * @param {?} config The dialog configuration.
	     * @return {?} A promise resolving to a ComponentRef for the attached container.
	     */
	    function (overlay, config) {
	        var /** @type {?} */ containerPortal = new _angular_cdk_portal.ComponentPortal(MatDialogContainer, config.viewContainerRef);
	        var /** @type {?} */ containerRef = overlay.attach(containerPortal);
	        containerRef.instance._config = config;
	        return containerRef.instance;
	    };
	    /**
	     * Attaches the user-provided component to the already-created MatDialogContainer.
	     * @template T
	     * @param {?} componentOrTemplateRef The type of component being loaded into the dialog,
	     *     or a TemplateRef to instantiate as the content.
	     * @param {?} dialogContainer Reference to the wrapping MatDialogContainer.
	     * @param {?} overlayRef Reference to the overlay in which the dialog resides.
	     * @param {?} config The dialog configuration.
	     * @return {?} A promise resolving to the MatDialogRef that should be returned to the user.
	     */
	    MatDialog.prototype._attachDialogContent = /**
	     * Attaches the user-provided component to the already-created MatDialogContainer.
	     * @template T
	     * @param {?} componentOrTemplateRef The type of component being loaded into the dialog,
	     *     or a TemplateRef to instantiate as the content.
	     * @param {?} dialogContainer Reference to the wrapping MatDialogContainer.
	     * @param {?} overlayRef Reference to the overlay in which the dialog resides.
	     * @param {?} config The dialog configuration.
	     * @return {?} A promise resolving to the MatDialogRef that should be returned to the user.
	     */
	    function (componentOrTemplateRef, dialogContainer, overlayRef, config) {
	        // Create a reference to the dialog we're creating in order to give the user a handle
	        // to modify and close it.
	        var /** @type {?} */ dialogRef = new MatDialogRef(overlayRef, dialogContainer, this._location, config.id);
	        // When the dialog backdrop is clicked, we want to close it.
	        if (config.hasBackdrop) {
	            overlayRef.backdropClick().subscribe(function () {
	                if (!dialogRef.disableClose) {
	                    dialogRef.close();
	                }
	            });
	        }
	        if (componentOrTemplateRef instanceof _angular_core.TemplateRef) {
	            dialogContainer.attachTemplatePortal(new _angular_cdk_portal.TemplatePortal(componentOrTemplateRef, /** @type {?} */ ((null)), /** @type {?} */ ({ $implicit: config.data, dialogRef: dialogRef })));
	        }
	        else {
	            var /** @type {?} */ injector = this._createInjector(config, dialogRef, dialogContainer);
	            var /** @type {?} */ contentRef = dialogContainer.attachComponentPortal(new _angular_cdk_portal.ComponentPortal(componentOrTemplateRef, undefined, injector));
	            dialogRef.componentInstance = contentRef.instance;
	        }
	        dialogRef
	            .updateSize(config.width, config.height)
	            .updatePosition(config.position);
	        return dialogRef;
	    };
	    /**
	     * Creates a custom injector to be used inside the dialog. This allows a component loaded inside
	     * of a dialog to close itself and, optionally, to return a value.
	     * @template T
	     * @param {?} config Config object that is used to construct the dialog.
	     * @param {?} dialogRef Reference to the dialog.
	     * @param {?} dialogContainer
	     * @return {?} The custom injector that can be used inside the dialog.
	     */
	    MatDialog.prototype._createInjector = /**
	     * Creates a custom injector to be used inside the dialog. This allows a component loaded inside
	     * of a dialog to close itself and, optionally, to return a value.
	     * @template T
	     * @param {?} config Config object that is used to construct the dialog.
	     * @param {?} dialogRef Reference to the dialog.
	     * @param {?} dialogContainer
	     * @return {?} The custom injector that can be used inside the dialog.
	     */
	    function (config, dialogRef, dialogContainer) {
	        var /** @type {?} */ userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
	        var /** @type {?} */ injectionTokens = new WeakMap();
	        // The MatDialogContainer is injected in the portal as the MatDialogContainer and the dialog's
	        // content are created out of the same ViewContainerRef and as such, are siblings for injector
	        // purposes. To allow the hierarchy that is expected, the MatDialogContainer is explicitly
	        // added to the injection tokens.
	        injectionTokens
	            .set(MatDialogContainer, dialogContainer)
	            .set(MAT_DIALOG_DATA, config.data)
	            .set(MatDialogRef, dialogRef);
	        if (!userInjector || !userInjector.get(_angular_cdk_bidi.Directionality, null)) {
	            injectionTokens.set(_angular_cdk_bidi.Directionality, {
	                value: config.direction,
	                change: rxjs_observable_of.of()
	            });
	        }
	        return new _angular_cdk_portal.PortalInjector(userInjector || this._injector, injectionTokens);
	    };
	    /**
	     * Removes a dialog from the array of open dialogs.
	     * @param {?} dialogRef Dialog to be removed.
	     * @return {?}
	     */
	    MatDialog.prototype._removeOpenDialog = /**
	     * Removes a dialog from the array of open dialogs.
	     * @param {?} dialogRef Dialog to be removed.
	     * @return {?}
	     */
	    function (dialogRef) {
	        var /** @type {?} */ index = this.openDialogs.indexOf(dialogRef);
	        if (index > -1) {
	            this.openDialogs.splice(index, 1);
	            // If all the dialogs were closed, remove/restore the `aria-hidden`
	            // to a the siblings and emit to the `afterAllClosed` stream.
	            if (!this.openDialogs.length) {
	                this._ariaHiddenElements.forEach(function (previousValue, element) {
	                    if (previousValue) {
	                        element.setAttribute('aria-hidden', previousValue);
	                    }
	                    else {
	                        element.removeAttribute('aria-hidden');
	                    }
	                });
	                this._ariaHiddenElements.clear();
	                this._afterAllClosed.next();
	            }
	        }
	    };
	    /**
	     * Hides all of the content that isn't an overlay from assistive technology.
	     * @return {?}
	     */
	    MatDialog.prototype._hideNonDialogContentFromAssistiveTechnology = /**
	     * Hides all of the content that isn't an overlay from assistive technology.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ overlayContainer = this._overlayContainer.getContainerElement();
	        // Ensure that the overlay container is attached to the DOM.
	        if (overlayContainer.parentElement) {
	            var /** @type {?} */ siblings = overlayContainer.parentElement.children;
	            for (var /** @type {?} */ i = siblings.length - 1; i > -1; i--) {
	                var /** @type {?} */ sibling = siblings[i];
	                if (sibling !== overlayContainer &&
	                    sibling.nodeName !== 'SCRIPT' &&
	                    sibling.nodeName !== 'STYLE' &&
	                    !sibling.hasAttribute('aria-live')) {
	                    this._ariaHiddenElements.set(sibling, sibling.getAttribute('aria-hidden'));
	                    sibling.setAttribute('aria-hidden', 'true');
	                }
	            }
	        }
	    };
	    MatDialog.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    MatDialog.ctorParameters = function () { return [
	        { type: _angular_cdk_overlay.Overlay, },
	        { type: _angular_core.Injector, },
	        { type: _angular_common.Location, decorators: [{ type: _angular_core.Optional },] },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MAT_DIALOG_DEFAULT_OPTIONS,] },] },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [MAT_DIALOG_SCROLL_STRATEGY,] },] },
	        { type: MatDialog, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.SkipSelf },] },
	        { type: _angular_cdk_overlay.OverlayContainer, },
	    ]; };
	    return MatDialog;
	}());
	/**
	 * Applies default options to the dialog config.
	 * @param {?=} config Config to be modified.
	 * @param {?=} defaultOptions Default options provided.
	 * @return {?} The new configuration object.
	 */
	function _applyConfigDefaults(config, defaultOptions) {
	    return __assign({}, defaultOptions, config);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Counter used to generate unique IDs for dialog elements.
	 */
	var dialogElementUid = 0;
	/**
	 * Button that will close the current dialog.
	 */
	var MatDialogClose = /** @class */ (function () {
	    function MatDialogClose(dialogRef, _elementRef, _dialog) {
	        this.dialogRef = dialogRef;
	        this._elementRef = _elementRef;
	        this._dialog = _dialog;
	        /**
	         * Screenreader label for the button.
	         */
	        this.ariaLabel = 'Close dialog';
	    }
	    /**
	     * @return {?}
	     */
	    MatDialogClose.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        if (!this.dialogRef) {
	            // When this directive is included in a dialog via TemplateRef (rather than being
	            // in a Component), the DialogRef isn't available via injection because embedded
	            // views cannot be given a custom injector. Instead, we look up the DialogRef by
	            // ID. This must occur in `onInit`, as the ID binding for the dialog container won't
	            // be resolved at constructor time.
	            this.dialogRef = /** @type {?} */ ((getClosestDialog(this._elementRef, this._dialog.openDialogs)));
	        }
	    };
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    MatDialogClose.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        var /** @type {?} */ proxiedChange = changes["_matDialogClose"] || changes["_matDialogCloseResult"];
	        if (proxiedChange) {
	            this.dialogResult = proxiedChange.currentValue;
	        }
	    };
	    MatDialogClose.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: "button[mat-dialog-close], button[matDialogClose]",
	                    exportAs: 'matDialogClose',
	                    host: {
	                        '(click)': 'dialogRef.close(dialogResult)',
	                        '[attr.aria-label]': 'ariaLabel',
	                        'type': 'button',
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatDialogClose.ctorParameters = function () { return [
	        { type: MatDialogRef, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_core.ElementRef, },
	        { type: MatDialog, },
	    ]; };
	    MatDialogClose.propDecorators = {
	        "ariaLabel": [{ type: _angular_core.Input, args: ['aria-label',] },],
	        "dialogResult": [{ type: _angular_core.Input, args: ['mat-dialog-close',] },],
	        "_matDialogClose": [{ type: _angular_core.Input, args: ['matDialogClose',] },],
	    };
	    return MatDialogClose;
	}());
	/**
	 * Title of a dialog element. Stays fixed to the top of the dialog when scrolling.
	 */
	var MatDialogTitle = /** @class */ (function () {
	    function MatDialogTitle(_dialogRef, _elementRef, _dialog) {
	        this._dialogRef = _dialogRef;
	        this._elementRef = _elementRef;
	        this._dialog = _dialog;
	        this.id = "mat-dialog-title-" + dialogElementUid++;
	    }
	    /**
	     * @return {?}
	     */
	    MatDialogTitle.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (!this._dialogRef) {
	            this._dialogRef = /** @type {?} */ ((getClosestDialog(this._elementRef, this._dialog.openDialogs)));
	        }
	        if (this._dialogRef) {
	            Promise.resolve().then(function () {
	                var /** @type {?} */ container = _this._dialogRef._containerInstance;
	                if (container && !container._ariaLabelledBy) {
	                    container._ariaLabelledBy = _this.id;
	                }
	            });
	        }
	    };
	    MatDialogTitle.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-dialog-title], [matDialogTitle]',
	                    exportAs: 'matDialogTitle',
	                    host: {
	                        'class': 'mat-dialog-title',
	                        '[id]': 'id',
	                    },
	                },] },
	    ];
	    /** @nocollapse */
	    MatDialogTitle.ctorParameters = function () { return [
	        { type: MatDialogRef, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_core.ElementRef, },
	        { type: MatDialog, },
	    ]; };
	    MatDialogTitle.propDecorators = {
	        "id": [{ type: _angular_core.Input },],
	    };
	    return MatDialogTitle;
	}());
	/**
	 * Scrollable content container of a dialog.
	 */
	var MatDialogContent = /** @class */ (function () {
	    function MatDialogContent() {
	    }
	    MatDialogContent.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]",
	                    host: { 'class': 'mat-dialog-content' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatDialogContent.ctorParameters = function () { return []; };
	    return MatDialogContent;
	}());
	/**
	 * Container for the bottom action buttons in a dialog.
	 * Stays fixed to the bottom when scrolling.
	 */
	var MatDialogActions = /** @class */ (function () {
	    function MatDialogActions() {
	    }
	    MatDialogActions.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]",
	                    host: { 'class': 'mat-dialog-actions' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatDialogActions.ctorParameters = function () { return []; };
	    return MatDialogActions;
	}());
	/**
	 * Finds the closest MatDialogRef to an element by looking at the DOM.
	 * @param {?} element Element relative to which to look for a dialog.
	 * @param {?} openDialogs References to the currently-open dialogs.
	 * @return {?}
	 */
	function getClosestDialog(element, openDialogs) {
	    var /** @type {?} */ parent = element.nativeElement.parentElement;
	    while (parent && !parent.classList.contains('mat-dialog-container')) {
	        parent = parent.parentElement;
	    }
	    return parent ? openDialogs.find(function (dialog) { return dialog.id === /** @type {?} */ ((parent)).id; }) : null;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatDialogModule = /** @class */ (function () {
	    function MatDialogModule() {
	    }
	    MatDialogModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [
	                        _angular_common.CommonModule,
	                        _angular_cdk_overlay.OverlayModule,
	                        _angular_cdk_portal.PortalModule,
	                        _angular_cdk_a11y.A11yModule,
	                        MatCommonModule,
	                    ],
	                    exports: [
	                        MatDialogContainer,
	                        MatDialogClose,
	                        MatDialogTitle,
	                        MatDialogContent,
	                        MatDialogActions,
	                        MatCommonModule,
	                    ],
	                    declarations: [
	                        MatDialogContainer,
	                        MatDialogClose,
	                        MatDialogTitle,
	                        MatDialogActions,
	                        MatDialogContent,
	                    ],
	                    providers: [
	                        MatDialog,
	                        MAT_DIALOG_SCROLL_STRATEGY_PROVIDER,
	                    ],
	                    entryComponents: [MatDialogContainer],
	                },] },
	    ];
	    /** @nocollapse */
	    MatDialogModule.ctorParameters = function () { return []; };
	    return MatDialogModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Directive to automatically resize a textarea to fit its content.
	 */
	var MatTextareaAutosize = /** @class */ (function () {
	    function MatTextareaAutosize(_elementRef, _platform, _ngZone) {
	        this._elementRef = _elementRef;
	        this._platform = _platform;
	        this._ngZone = _ngZone;
	        this._destroyed = new rxjs_Subject.Subject();
	    }
	    Object.defineProperty(MatTextareaAutosize.prototype, "minRows", {
	        get: /**
	         * @return {?}
	         */
	        function () { return this._minRows; },
	        set: /**
	         * Minimum amount of rows in the textarea.
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._minRows = value;
	            this._setMinHeight();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatTextareaAutosize.prototype, "maxRows", {
	        get: /**
	         * Maximum amount of rows in the textarea.
	         * @return {?}
	         */
	        function () { return this._maxRows; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._maxRows = value;
	            this._setMaxHeight();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // TODO(crisbeto): make the `_ngZone` a required param in the next major version.
	    /** Sets the minimum height of the textarea as determined by minRows. */
	    /**
	     * Sets the minimum height of the textarea as determined by minRows.
	     * @return {?}
	     */
	    MatTextareaAutosize.prototype._setMinHeight = /**
	     * Sets the minimum height of the textarea as determined by minRows.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ minHeight = this.minRows && this._cachedLineHeight ?
	            this.minRows * this._cachedLineHeight + "px" : null;
	        if (minHeight) {
	            this._setTextareaStyle('minHeight', minHeight);
	        }
	    };
	    /** Sets the maximum height of the textarea as determined by maxRows. */
	    /**
	     * Sets the maximum height of the textarea as determined by maxRows.
	     * @return {?}
	     */
	    MatTextareaAutosize.prototype._setMaxHeight = /**
	     * Sets the maximum height of the textarea as determined by maxRows.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ maxHeight = this.maxRows && this._cachedLineHeight ?
	            this.maxRows * this._cachedLineHeight + "px" : null;
	        if (maxHeight) {
	            this._setTextareaStyle('maxHeight', maxHeight);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatTextareaAutosize.prototype.ngAfterViewInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._platform.isBrowser) {
	            this.resizeToFitContent();
	            if (this._ngZone) {
	                this._ngZone.runOutsideAngular(function () {
	                    rxjs_observable_fromEvent.fromEvent(window, 'resize')
	                        .pipe(rxjs_operators_auditTime.auditTime(16), rxjs_operators_takeUntil.takeUntil(_this._destroyed))
	                        .subscribe(function () { return _this.resizeToFitContent(true); });
	                });
	            }
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatTextareaAutosize.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._destroyed.next();
	        this._destroyed.complete();
	    };
	    /**
	     * Sets a style property on the textarea element.
	     * @param {?} property
	     * @param {?} value
	     * @return {?}
	     */
	    MatTextareaAutosize.prototype._setTextareaStyle = /**
	     * Sets a style property on the textarea element.
	     * @param {?} property
	     * @param {?} value
	     * @return {?}
	     */
	    function (property, value) {
	        var /** @type {?} */ textarea = /** @type {?} */ (this._elementRef.nativeElement);
	        textarea.style[property] = value;
	    };
	    /**
	     * Cache the height of a single-row textarea if it has not already been cached.
	     *
	     * We need to know how large a single "row" of a textarea is in order to apply minRows and
	     * maxRows. For the initial version, we will assume that the height of a single line in the
	     * textarea does not ever change.
	     * @return {?}
	     */
	    MatTextareaAutosize.prototype._cacheTextareaLineHeight = /**
	     * Cache the height of a single-row textarea if it has not already been cached.
	     *
	     * We need to know how large a single "row" of a textarea is in order to apply minRows and
	     * maxRows. For the initial version, we will assume that the height of a single line in the
	     * textarea does not ever change.
	     * @return {?}
	     */
	    function () {
	        if (this._cachedLineHeight) {
	            return;
	        }
	        var /** @type {?} */ textarea = /** @type {?} */ (this._elementRef.nativeElement);
	        // Use a clone element because we have to override some styles.
	        var /** @type {?} */ textareaClone = /** @type {?} */ (textarea.cloneNode(false));
	        textareaClone.rows = 1;
	        // Use `position: absolute` so that this doesn't cause a browser layout and use
	        // `visibility: hidden` so that nothing is rendered. Clear any other styles that
	        // would affect the height.
	        textareaClone.style.position = 'absolute';
	        textareaClone.style.visibility = 'hidden';
	        textareaClone.style.border = 'none';
	        textareaClone.style.padding = '0';
	        textareaClone.style.height = '';
	        textareaClone.style.minHeight = '';
	        textareaClone.style.maxHeight = '';
	        // In Firefox it happens that textarea elements are always bigger than the specified amount
	        // of rows. This is because Firefox tries to add extra space for the horizontal scrollbar.
	        // As a workaround that removes the extra space for the scrollbar, we can just set overflow
	        // to hidden. This ensures that there is no invalid calculation of the line height.
	        // See Firefox bug report: https://bugzilla.mozilla.org/show_bug.cgi?id=33654
	        textareaClone.style.overflow = 'hidden'; /** @type {?} */
	        ((textarea.parentNode)).appendChild(textareaClone);
	        this._cachedLineHeight = textareaClone.clientHeight; /** @type {?} */
	        ((textarea.parentNode)).removeChild(textareaClone);
	        // Min and max heights have to be re-calculated if the cached line height changes
	        this._setMinHeight();
	        this._setMaxHeight();
	    };
	    /**
	     * @return {?}
	     */
	    MatTextareaAutosize.prototype.ngDoCheck = /**
	     * @return {?}
	     */
	    function () {
	        if (this._platform.isBrowser) {
	            this.resizeToFitContent();
	        }
	    };
	    /**
	     * Resize the textarea to fit its content.
	     * @param force Whether to force a height recalculation. By default the height will be
	     *    recalculated only if the value changed since the last call.
	     */
	    /**
	     * Resize the textarea to fit its content.
	     * @param {?=} force Whether to force a height recalculation. By default the height will be
	     *    recalculated only if the value changed since the last call.
	     * @return {?}
	     */
	    MatTextareaAutosize.prototype.resizeToFitContent = /**
	     * Resize the textarea to fit its content.
	     * @param {?=} force Whether to force a height recalculation. By default the height will be
	     *    recalculated only if the value changed since the last call.
	     * @return {?}
	     */
	    function (force) {
	        if (force === void 0) { force = false; }
	        this._cacheTextareaLineHeight();
	        // If we haven't determined the line-height yet, we know we're still hidden and there's no point
	        // in checking the height of the textarea.
	        if (!this._cachedLineHeight) {
	            return;
	        }
	        var /** @type {?} */ textarea = /** @type {?} */ (this._elementRef.nativeElement);
	        var /** @type {?} */ value = textarea.value;
	        // Only resize of the value changed since these calculations can be expensive.
	        if (value === this._previousValue && !force) {
	            return;
	        }
	        var /** @type {?} */ placeholderText = textarea.placeholder;
	        // Reset the textarea height to auto in order to shrink back to its default size.
	        // Also temporarily force overflow:hidden, so scroll bars do not interfere with calculations.
	        // Long placeholders that are wider than the textarea width may lead to a bigger scrollHeight
	        // value. To ensure that the scrollHeight is not bigger than the content, the placeholders
	        // need to be removed temporarily.
	        textarea.style.height = 'auto';
	        textarea.style.overflow = 'hidden';
	        textarea.placeholder = '';
	        // Use the scrollHeight to know how large the textarea *would* be if fit its entire value.
	        textarea.style.height = textarea.scrollHeight + "px";
	        textarea.style.overflow = '';
	        textarea.placeholder = placeholderText;
	        this._previousValue = value;
	    };
	    MatTextareaAutosize.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: "textarea[mat-autosize], textarea[matTextareaAutosize]",
	                    exportAs: 'matTextareaAutosize',
	                    host: {
	                        'class': 'mat-autosize',
	                        // Textarea elements that have the directive applied should have a single row by default.
	                        // Browsers normally show two rows by default and therefore this limits the minRows binding.
	                        'rows': '1',
	                    },
	                },] },
	    ];
	    /** @nocollapse */
	    MatTextareaAutosize.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_platform.Platform, },
	        { type: _angular_core.NgZone, },
	    ]; };
	    MatTextareaAutosize.propDecorators = {
	        "minRows": [{ type: _angular_core.Input, args: ['matAutosizeMinRows',] },],
	        "maxRows": [{ type: _angular_core.Input, args: ['matAutosizeMaxRows',] },],
	    };
	    return MatTextareaAutosize;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 * @param {?} type
	 * @return {?}
	 */
	function getMatInputUnsupportedTypeError(type) {
	    return Error("Input type \"" + type + "\" isn't supported by matInput.");
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * This token is used to inject the object whose value should be set into `MatInput`. If none is
	 * provided, the native `HTMLInputElement` is used. Directives like `MatDatepickerInput` can provide
	 * themselves for this token, in order to make `MatInput` delegate the getting and setting of the
	 * value to them.
	 */
	var MAT_INPUT_VALUE_ACCESSOR = new _angular_core.InjectionToken('MAT_INPUT_VALUE_ACCESSOR');
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	// Invalid input type. Using one of these will throw an MatInputUnsupportedTypeError.
	var MAT_INPUT_INVALID_TYPES = [
	    'button',
	    'checkbox',
	    'file',
	    'hidden',
	    'image',
	    'radio',
	    'range',
	    'reset',
	    'submit'
	];
	var nextUniqueId$3 = 0;
	/**
	 * \@docs-private
	 */
	var MatInputBase = /** @class */ (function () {
	    function MatInputBase(_defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) {
	        this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
	        this._parentForm = _parentForm;
	        this._parentFormGroup = _parentFormGroup;
	        this.ngControl = ngControl;
	    }
	    return MatInputBase;
	}());
	var _MatInputMixinBase = mixinErrorState(MatInputBase);
	/**
	 * Directive that allows a native input to work inside a `MatFormField`.
	 */
	var MatInput = /** @class */ (function (_super) {
	    __extends(MatInput, _super);
	    function MatInput(_elementRef, _platform, /** @docs-private */
	        ngControl, _parentForm, _parentFormGroup, _defaultErrorStateMatcher, inputValueAccessor) {
	        var _this = _super.call(this, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) || this;
	        _this._elementRef = _elementRef;
	        _this._platform = _platform;
	        _this.ngControl = ngControl;
	        _this._uid = "mat-input-" + nextUniqueId$3++;
	        /**
	         * Whether the component is being rendered on the server.
	         */
	        _this._isServer = false;
	        /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         */
	        _this.focused = false;
	        /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         */
	        _this.stateChanges = new rxjs_Subject.Subject();
	        /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         */
	        _this.controlType = 'mat-input';
	        _this._disabled = false;
	        /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         */
	        _this.placeholder = '';
	        _this._required = false;
	        _this._type = 'text';
	        _this._readonly = false;
	        _this._neverEmptyInputTypes = [
	            'date',
	            'datetime',
	            'datetime-local',
	            'month',
	            'time',
	            'week'
	        ].filter(function (t) { return _angular_cdk_platform.getSupportedInputTypes().has(t); });
	        // If no input value accessor was explicitly specified, use the element as the input value
	        // accessor.
	        // If no input value accessor was explicitly specified, use the element as the input value
	        // accessor.
	        _this._inputValueAccessor = inputValueAccessor || _this._elementRef.nativeElement;
	        _this._previousNativeValue = _this.value;
	        // Force setter to be called in case id was not specified.
	        // Force setter to be called in case id was not specified.
	        _this.id = _this.id;
	        // On some versions of iOS the caret gets stuck in the wrong place when holding down the delete
	        // key. In order to get around this we need to "jiggle" the caret loose. Since this bug only
	        // exists on iOS, we only bother to install the listener on iOS.
	        if (_platform.IOS) {
	            _elementRef.nativeElement.addEventListener('keyup', function (event) {
	                var /** @type {?} */ el = /** @type {?} */ (event.target);
	                if (!el.value && !el.selectionStart && !el.selectionEnd) {
	                    // Note: Just setting `0, 0` doesn't fix the issue. Setting `1, 1` fixes it for the first
	                    // time that you type text and then hold delete. Toggling to `1, 1` and then back to
	                    // `0, 0` seems to completely fix it.
	                    el.setSelectionRange(1, 1);
	                    el.setSelectionRange(0, 0);
	                }
	            });
	        }
	        _this._isServer = !_this._platform.isBrowser;
	        return _this;
	    }
	    Object.defineProperty(MatInput.prototype, "disabled", {
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () {
	            if (this.ngControl && this.ngControl.disabled !== null) {
	                return this.ngControl.disabled;
	            }
	            return this._disabled;
	        },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._disabled = _angular_cdk_coercion.coerceBooleanProperty(value);
	            // Browsers may not fire the blur event if the input is disabled too quickly.
	            // Reset from here to ensure that the element doesn't become stuck.
	            if (this.focused) {
	                this.focused = false;
	                this.stateChanges.next();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatInput.prototype, "id", {
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () { return this._id; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._id = value || this._uid; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatInput.prototype, "required", {
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () { return this._required; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._required = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatInput.prototype, "type", {
	        get: /**
	         * Input type of the element.
	         * @return {?}
	         */
	        function () { return this._type; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._type = value || 'text';
	            this._validateType();
	            // When using Angular inputs, developers are no longer able to set the properties on the native
	            // input element. To ensure that bindings for `type` work, we need to sync the setter
	            // with the native property. Textarea elements don't support the type property or attribute.
	            if (!this._isTextarea() && _angular_cdk_platform.getSupportedInputTypes().has(this._type)) {
	                this._elementRef.nativeElement.type = this._type;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatInput.prototype, "value", {
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () { return this._inputValueAccessor.value; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (value !== this.value) {
	                this._inputValueAccessor.value = value;
	                this.stateChanges.next();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatInput.prototype, "readonly", {
	        get: /**
	         * Whether the element is readonly.
	         * @return {?}
	         */
	        function () { return this._readonly; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._readonly = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatInput.prototype.ngOnChanges = /**
	     * @return {?}
	     */
	    function () {
	        this.stateChanges.next();
	    };
	    /**
	     * @return {?}
	     */
	    MatInput.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this.stateChanges.complete();
	    };
	    /**
	     * @return {?}
	     */
	    MatInput.prototype.ngDoCheck = /**
	     * @return {?}
	     */
	    function () {
	        if (this.ngControl) {
	            // We need to re-evaluate this on every change detection cycle, because there are some
	            // error triggers that we can't subscribe to (e.g. parent form submissions). This means
	            // that whatever logic is in here has to be super lean or we risk destroying the performance.
	            this.updateErrorState();
	        }
	        // We need to dirty-check the native element's value, because there are some cases where
	        // we won't be notified when it changes (e.g. the consumer isn't using forms or they're
	        // updating the value using `emitEvent: false`).
	        this._dirtyCheckNativeValue();
	    };
	    /** Focuses the input. */
	    /**
	     * Focuses the input.
	     * @return {?}
	     */
	    MatInput.prototype.focus = /**
	     * Focuses the input.
	     * @return {?}
	     */
	    function () { this._elementRef.nativeElement.focus(); };
	    /** Callback for the cases where the focused state of the input changes. */
	    /**
	     * Callback for the cases where the focused state of the input changes.
	     * @param {?} isFocused
	     * @return {?}
	     */
	    MatInput.prototype._focusChanged = /**
	     * Callback for the cases where the focused state of the input changes.
	     * @param {?} isFocused
	     * @return {?}
	     */
	    function (isFocused) {
	        if (isFocused !== this.focused && !this.readonly) {
	            this.focused = isFocused;
	            this.stateChanges.next();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatInput.prototype._onInput = /**
	     * @return {?}
	     */
	    function () {
	        // This is a noop function and is used to let Angular know whenever the value changes.
	        // Angular will run a new change detection each time the `input` event has been dispatched.
	        // It's necessary that Angular recognizes the value change, because when floatingLabel
	        // is set to false and Angular forms aren't used, the placeholder won't recognize the
	        // value changes and will not disappear.
	        // Listening to the input event wouldn't be necessary when the input is using the
	        // FormsModule or ReactiveFormsModule, because Angular forms also listens to input events.
	    };
	    /** Does some manual dirty checking on the native input `value` property. */
	    /**
	     * Does some manual dirty checking on the native input `value` property.
	     * @return {?}
	     */
	    MatInput.prototype._dirtyCheckNativeValue = /**
	     * Does some manual dirty checking on the native input `value` property.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ newValue = this.value;
	        if (this._previousNativeValue !== newValue) {
	            this._previousNativeValue = newValue;
	            this.stateChanges.next();
	        }
	    };
	    /** Make sure the input is a supported type. */
	    /**
	     * Make sure the input is a supported type.
	     * @return {?}
	     */
	    MatInput.prototype._validateType = /**
	     * Make sure the input is a supported type.
	     * @return {?}
	     */
	    function () {
	        if (MAT_INPUT_INVALID_TYPES.indexOf(this._type) > -1) {
	            throw getMatInputUnsupportedTypeError(this._type);
	        }
	    };
	    /** Checks whether the input type is one of the types that are never empty. */
	    /**
	     * Checks whether the input type is one of the types that are never empty.
	     * @return {?}
	     */
	    MatInput.prototype._isNeverEmpty = /**
	     * Checks whether the input type is one of the types that are never empty.
	     * @return {?}
	     */
	    function () {
	        return this._neverEmptyInputTypes.indexOf(this._type) > -1;
	    };
	    /** Checks whether the input is invalid based on the native validation. */
	    /**
	     * Checks whether the input is invalid based on the native validation.
	     * @return {?}
	     */
	    MatInput.prototype._isBadInput = /**
	     * Checks whether the input is invalid based on the native validation.
	     * @return {?}
	     */
	    function () {
	        // The `validity` property won't be present on platform-server.
	        var /** @type {?} */ validity = (/** @type {?} */ (this._elementRef.nativeElement)).validity;
	        return validity && validity.badInput;
	    };
	    /** Determines if the component host is a textarea. If not recognizable it returns false. */
	    /**
	     * Determines if the component host is a textarea. If not recognizable it returns false.
	     * @return {?}
	     */
	    MatInput.prototype._isTextarea = /**
	     * Determines if the component host is a textarea. If not recognizable it returns false.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ nativeElement = this._elementRef.nativeElement;
	        // In Universal, we don't have access to `nodeName`, but the same can be achieved with `name`.
	        // Note that this shouldn't be necessary once Angular switches to an API that resembles the
	        // DOM closer.
	        var /** @type {?} */ nodeName = this._platform.isBrowser ? nativeElement.nodeName : nativeElement.name;
	        return nodeName ? nodeName.toLowerCase() === 'textarea' : false;
	    };
	    Object.defineProperty(MatInput.prototype, "empty", {
	        /**
	         * Implemented as part of MatFormFieldControl.
	         * @docs-private
	         */
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () {
	            return !this._isNeverEmpty() && !this._elementRef.nativeElement.value && !this._isBadInput();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatInput.prototype, "shouldLabelFloat", {
	        /**
	         * Implemented as part of MatFormFieldControl.
	         * @docs-private
	         */
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () { return this.focused || !this.empty; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * @docs-private
	     */
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @param {?} ids
	     * @return {?}
	     */
	    MatInput.prototype.setDescribedByIds = /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @param {?} ids
	     * @return {?}
	     */
	    function (ids) { this._ariaDescribedby = ids.join(' '); };
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * @docs-private
	     */
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @return {?}
	     */
	    MatInput.prototype.onContainerClick = /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @return {?}
	     */
	    function () { this.focus(); };
	    MatInput.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: "input[matInput], textarea[matInput]",
	                    exportAs: 'matInput',
	                    host: {
	                        'class': 'mat-input-element mat-form-field-autofill-control',
	                        '[class.mat-input-server]': '_isServer',
	                        // Native input properties that are overwritten by Angular inputs need to be synced with
	                        // the native input element. Otherwise property bindings for those don't work.
	                        '[attr.id]': 'id',
	                        '[placeholder]': 'placeholder',
	                        '[disabled]': 'disabled',
	                        '[required]': 'required',
	                        '[readonly]': 'readonly',
	                        '[attr.aria-describedby]': '_ariaDescribedby || null',
	                        '[attr.aria-invalid]': 'errorState',
	                        '[attr.aria-required]': 'required.toString()',
	                        '(blur)': '_focusChanged(false)',
	                        '(focus)': '_focusChanged(true)',
	                        '(input)': '_onInput()',
	                    },
	                    providers: [{ provide: MatFormFieldControl, useExisting: MatInput }],
	                },] },
	    ];
	    /** @nocollapse */
	    MatInput.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_platform.Platform, },
	        { type: _angular_forms.NgControl, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self },] },
	        { type: _angular_forms.NgForm, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_forms.FormGroupDirective, decorators: [{ type: _angular_core.Optional },] },
	        { type: ErrorStateMatcher, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [MAT_INPUT_VALUE_ACCESSOR,] },] },
	    ]; };
	    MatInput.propDecorators = {
	        "disabled": [{ type: _angular_core.Input },],
	        "id": [{ type: _angular_core.Input },],
	        "placeholder": [{ type: _angular_core.Input },],
	        "required": [{ type: _angular_core.Input },],
	        "type": [{ type: _angular_core.Input },],
	        "errorStateMatcher": [{ type: _angular_core.Input },],
	        "value": [{ type: _angular_core.Input },],
	        "readonly": [{ type: _angular_core.Input },],
	    };
	    return MatInput;
	}(_MatInputMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatInputModule = /** @class */ (function () {
	    function MatInputModule() {
	    }
	    MatInputModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    declarations: [
	                        MatInput,
	                        MatTextareaAutosize,
	                    ],
	                    imports: [
	                        _angular_common.CommonModule,
	                        MatFormFieldModule,
	                        _angular_cdk_platform.PlatformModule,
	                    ],
	                    exports: [
	                        MatFormFieldModule,
	                        MatInput,
	                        MatTextareaAutosize,
	                    ],
	                    providers: [ErrorStateMatcher],
	                },] },
	    ];
	    /** @nocollapse */
	    MatInputModule.ctorParameters = function () { return []; };
	    return MatInputModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 * @param {?} provider
	 * @return {?}
	 */
	function createMissingDateImplError(provider) {
	    return Error("MatDatepicker: No provider found for " + provider + ". You must import one of the following " +
	        "modules at your application root: MatNativeDateModule, MatMomentDateModule, or provide a " +
	        "custom implementation.");
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Datepicker data that requires internationalization.
	 */
	var MatDatepickerIntl = /** @class */ (function () {
	    function MatDatepickerIntl() {
	        /**
	         * Stream that emits whenever the labels here are changed. Use this to notify
	         * components if the labels have changed after initialization.
	         */
	        this.changes = new rxjs_Subject.Subject();
	        /**
	         * A label for the calendar popup (used by screen readers).
	         */
	        this.calendarLabel = 'Calendar';
	        /**
	         * A label for the button used to open the calendar popup (used by screen readers).
	         */
	        this.openCalendarLabel = 'Open calendar';
	        /**
	         * A label for the previous month button (used by screen readers).
	         */
	        this.prevMonthLabel = 'Previous month';
	        /**
	         * A label for the next month button (used by screen readers).
	         */
	        this.nextMonthLabel = 'Next month';
	        /**
	         * A label for the previous year button (used by screen readers).
	         */
	        this.prevYearLabel = 'Previous year';
	        /**
	         * A label for the next year button (used by screen readers).
	         */
	        this.nextYearLabel = 'Next year';
	        /**
	         * A label for the previous multi-year button (used by screen readers).
	         */
	        this.prevMultiYearLabel = 'Previous 20 years';
	        /**
	         * A label for the next multi-year button (used by screen readers).
	         */
	        this.nextMultiYearLabel = 'Next 20 years';
	        /**
	         * A label for the 'switch to month view' button (used by screen readers).
	         */
	        this.switchToMonthViewLabel = 'Choose date';
	        /**
	         * A label for the 'switch to year view' button (used by screen readers).
	         */
	        this.switchToMultiYearViewLabel = 'Choose month and year';
	    }
	    MatDatepickerIntl.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    MatDatepickerIntl.ctorParameters = function () { return []; };
	    return MatDatepickerIntl;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * An internal class that represents the data corresponding to a single calendar cell.
	 * \@docs-private
	 */
	var MatCalendarCell = /** @class */ (function () {
	    function MatCalendarCell(value, displayValue, ariaLabel, enabled) {
	        this.value = value;
	        this.displayValue = displayValue;
	        this.ariaLabel = ariaLabel;
	        this.enabled = enabled;
	    }
	    return MatCalendarCell;
	}());
	/**
	 * An internal component used to display calendar data in a table.
	 * \@docs-private
	 */
	var MatCalendarBody = /** @class */ (function () {
	    function MatCalendarBody() {
	        /**
	         * The number of columns in the table.
	         */
	        this.numCols = 7;
	        /**
	         * Whether to allow selection of disabled cells.
	         */
	        this.allowDisabledSelection = false;
	        /**
	         * The cell number of the active cell in the table.
	         */
	        this.activeCell = 0;
	        /**
	         * The aspect ratio (width / height) to use for the cells in the table. This aspect ratio will be
	         * maintained even as the table resizes.
	         */
	        this.cellAspectRatio = 1;
	        /**
	         * Emits when a new value is selected.
	         */
	        this.selectedValueChange = new _angular_core.EventEmitter();
	    }
	    /**
	     * @param {?} cell
	     * @return {?}
	     */
	    MatCalendarBody.prototype._cellClicked = /**
	     * @param {?} cell
	     * @return {?}
	     */
	    function (cell) {
	        if (!this.allowDisabledSelection && !cell.enabled) {
	            return;
	        }
	        this.selectedValueChange.emit(cell.value);
	    };
	    Object.defineProperty(MatCalendarBody.prototype, "_firstRowOffset", {
	        /** The number of blank cells to put at the beginning for the first row. */
	        get: /**
	         * The number of blank cells to put at the beginning for the first row.
	         * @return {?}
	         */
	        function () {
	            return this.rows && this.rows.length && this.rows[0].length ?
	                this.numCols - this.rows[0].length : 0;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} rowIndex
	     * @param {?} colIndex
	     * @return {?}
	     */
	    MatCalendarBody.prototype._isActiveCell = /**
	     * @param {?} rowIndex
	     * @param {?} colIndex
	     * @return {?}
	     */
	    function (rowIndex, colIndex) {
	        var /** @type {?} */ cellNumber = rowIndex * this.numCols + colIndex;
	        // Account for the fact that the first row may not have as many cells.
	        if (rowIndex) {
	            cellNumber -= this._firstRowOffset;
	        }
	        return cellNumber == this.activeCell;
	    };
	    MatCalendarBody.decorators = [
	        { type: _angular_core.Component, args: [{selector: '[mat-calendar-body]',
	                    template: "<tr *ngIf=\"_firstRowOffset < labelMinRequiredCells\" aria-hidden=\"true\"><td class=\"mat-calendar-body-label\" [attr.colspan]=\"numCols\" [style.paddingTop.%]=\"50 * cellAspectRatio / numCols\" [style.paddingBottom.%]=\"50 * cellAspectRatio / numCols\">{{label}}</td></tr><tr *ngFor=\"let row of rows; let rowIndex = index\" role=\"row\"><td *ngIf=\"rowIndex === 0 && _firstRowOffset\" aria-hidden=\"true\" class=\"mat-calendar-body-label\" [attr.colspan]=\"_firstRowOffset\" [style.paddingTop.%]=\"50 * cellAspectRatio / numCols\" [style.paddingBottom.%]=\"50 * cellAspectRatio / numCols\">{{_firstRowOffset >= labelMinRequiredCells ? label : ''}}</td><td *ngFor=\"let item of row; let colIndex = index\" role=\"gridcell\" class=\"mat-calendar-body-cell\" [tabindex]=\"_isActiveCell(rowIndex, colIndex) ? 0 : -1\" [class.mat-calendar-body-disabled]=\"!item.enabled\" [class.mat-calendar-body-active]=\"_isActiveCell(rowIndex, colIndex)\" [attr.aria-label]=\"item.ariaLabel\" [attr.aria-disabled]=\"!item.enabled || null\" (click)=\"_cellClicked(item)\" [style.width.%]=\"100 / numCols\" [style.paddingTop.%]=\"50 * cellAspectRatio / numCols\" [style.paddingBottom.%]=\"50 * cellAspectRatio / numCols\"><div class=\"mat-calendar-body-cell-content\" [class.mat-calendar-body-selected]=\"selectedValue === item.value\" [class.mat-calendar-body-today]=\"todayValue === item.value\">{{item.displayValue}}</div></td></tr>",
	                    styles: [".mat-calendar-body{min-width:224px}.mat-calendar-body-label{height:0;line-height:0;text-align:left;padding-left:4.71429%;padding-right:4.71429%}.mat-calendar-body-cell{position:relative;height:0;line-height:0;text-align:center;outline:0;cursor:pointer}.mat-calendar-body-disabled{cursor:default}.mat-calendar-body-cell-content{position:absolute;top:5%;left:5%;display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:90%;height:90%;line-height:1;border-width:1px;border-style:solid;border-radius:999px}[dir=rtl] .mat-calendar-body-label{text-align:right}"],
	                    host: {
	                        'class': 'mat-calendar-body',
	                        'role': 'grid',
	                        'attr.aria-readonly': 'true'
	                    },
	                    exportAs: 'matCalendarBody',
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatCalendarBody.ctorParameters = function () { return []; };
	    MatCalendarBody.propDecorators = {
	        "label": [{ type: _angular_core.Input },],
	        "rows": [{ type: _angular_core.Input },],
	        "todayValue": [{ type: _angular_core.Input },],
	        "selectedValue": [{ type: _angular_core.Input },],
	        "labelMinRequiredCells": [{ type: _angular_core.Input },],
	        "numCols": [{ type: _angular_core.Input },],
	        "allowDisabledSelection": [{ type: _angular_core.Input },],
	        "activeCell": [{ type: _angular_core.Input },],
	        "cellAspectRatio": [{ type: _angular_core.Input },],
	        "selectedValueChange": [{ type: _angular_core.Output },],
	    };
	    return MatCalendarBody;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var DAYS_PER_WEEK = 7;
	/**
	 * An internal component used to display a single month in the datepicker.
	 * \@docs-private
	 */
	var MatMonthView = /** @class */ (function () {
	    function MatMonthView(_dateAdapter, _dateFormats, _changeDetectorRef) {
	        this._dateAdapter = _dateAdapter;
	        this._dateFormats = _dateFormats;
	        this._changeDetectorRef = _changeDetectorRef;
	        /**
	         * Emits when a new date is selected.
	         */
	        this.selectedChange = new _angular_core.EventEmitter();
	        /**
	         * Emits when any date is selected.
	         */
	        this._userSelection = new _angular_core.EventEmitter();
	        if (!this._dateAdapter) {
	            throw createMissingDateImplError('DateAdapter');
	        }
	        if (!this._dateFormats) {
	            throw createMissingDateImplError('MAT_DATE_FORMATS');
	        }
	        var /** @type {?} */ firstDayOfWeek = this._dateAdapter.getFirstDayOfWeek();
	        var /** @type {?} */ narrowWeekdays = this._dateAdapter.getDayOfWeekNames('narrow');
	        var /** @type {?} */ longWeekdays = this._dateAdapter.getDayOfWeekNames('long');
	        // Rotate the labels for days of the week based on the configured first day of the week.
	        var /** @type {?} */ weekdays = longWeekdays.map(function (long, i) {
	            return { long: long, narrow: narrowWeekdays[i] };
	        });
	        this._weekdays = weekdays.slice(firstDayOfWeek).concat(weekdays.slice(0, firstDayOfWeek));
	        this._activeDate = this._dateAdapter.today();
	    }
	    Object.defineProperty(MatMonthView.prototype, "activeDate", {
	        get: /**
	         * The date to display in this month view (everything other than the month and year is ignored).
	         * @return {?}
	         */
	        function () { return this._activeDate; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            var /** @type {?} */ oldActiveDate = this._activeDate;
	            this._activeDate =
	                this._getValidDateOrNull(this._dateAdapter.deserialize(value)) || this._dateAdapter.today();
	            if (!this._hasSameMonthAndYear(oldActiveDate, this._activeDate)) {
	                this._init();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatMonthView.prototype, "selected", {
	        get: /**
	         * The currently selected date.
	         * @return {?}
	         */
	        function () { return this._selected; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._selected = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
	            this._selectedDate = this._getDateInCurrentMonth(this._selected);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatMonthView.prototype, "minDate", {
	        get: /**
	         * The minimum selectable date.
	         * @return {?}
	         */
	        function () { return this._minDate; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._minDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatMonthView.prototype, "maxDate", {
	        get: /**
	         * The maximum selectable date.
	         * @return {?}
	         */
	        function () { return this._maxDate; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._maxDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatMonthView.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        this._init();
	    };
	    /** Handles when a new date is selected. */
	    /**
	     * Handles when a new date is selected.
	     * @param {?} date
	     * @return {?}
	     */
	    MatMonthView.prototype._dateSelected = /**
	     * Handles when a new date is selected.
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        if (this._selectedDate != date) {
	            var /** @type {?} */ selectedYear = this._dateAdapter.getYear(this.activeDate);
	            var /** @type {?} */ selectedMonth = this._dateAdapter.getMonth(this.activeDate);
	            var /** @type {?} */ selectedDate = this._dateAdapter.createDate(selectedYear, selectedMonth, date);
	            this.selectedChange.emit(selectedDate);
	        }
	        this._userSelection.emit();
	    };
	    /** Initializes this month view. */
	    /**
	     * Initializes this month view.
	     * @return {?}
	     */
	    MatMonthView.prototype._init = /**
	     * Initializes this month view.
	     * @return {?}
	     */
	    function () {
	        this._selectedDate = this._getDateInCurrentMonth(this.selected);
	        this._todayDate = this._getDateInCurrentMonth(this._dateAdapter.today());
	        this._monthLabel =
	            this._dateAdapter.getMonthNames('short')[this._dateAdapter.getMonth(this.activeDate)]
	                .toLocaleUpperCase();
	        var /** @type {?} */ firstOfMonth = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), this._dateAdapter.getMonth(this.activeDate), 1);
	        this._firstWeekOffset =
	            (DAYS_PER_WEEK + this._dateAdapter.getDayOfWeek(firstOfMonth) -
	                this._dateAdapter.getFirstDayOfWeek()) % DAYS_PER_WEEK;
	        this._createWeekCells();
	        this._changeDetectorRef.markForCheck();
	    };
	    /**
	     * Creates MatCalendarCells for the dates in this month.
	     * @return {?}
	     */
	    MatMonthView.prototype._createWeekCells = /**
	     * Creates MatCalendarCells for the dates in this month.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ daysInMonth = this._dateAdapter.getNumDaysInMonth(this.activeDate);
	        var /** @type {?} */ dateNames = this._dateAdapter.getDateNames();
	        this._weeks = [[]];
	        for (var /** @type {?} */ i = 0, /** @type {?} */ cell = this._firstWeekOffset; i < daysInMonth; i++, cell++) {
	            if (cell == DAYS_PER_WEEK) {
	                this._weeks.push([]);
	                cell = 0;
	            }
	            var /** @type {?} */ date = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), this._dateAdapter.getMonth(this.activeDate), i + 1);
	            var /** @type {?} */ enabled = this._shouldEnableDate(date);
	            var /** @type {?} */ ariaLabel = this._dateAdapter.format(date, this._dateFormats.display.dateA11yLabel);
	            this._weeks[this._weeks.length - 1]
	                .push(new MatCalendarCell(i + 1, dateNames[i], ariaLabel, enabled));
	        }
	    };
	    /**
	     * Date filter for the month
	     * @param {?} date
	     * @return {?}
	     */
	    MatMonthView.prototype._shouldEnableDate = /**
	     * Date filter for the month
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        return !!date &&
	            (!this.dateFilter || this.dateFilter(date)) &&
	            (!this.minDate || this._dateAdapter.compareDate(date, this.minDate) >= 0) &&
	            (!this.maxDate || this._dateAdapter.compareDate(date, this.maxDate) <= 0);
	    };
	    /**
	     * Gets the date in this month that the given Date falls on.
	     * Returns null if the given Date is in another month.
	     * @param {?} date
	     * @return {?}
	     */
	    MatMonthView.prototype._getDateInCurrentMonth = /**
	     * Gets the date in this month that the given Date falls on.
	     * Returns null if the given Date is in another month.
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        return date && this._hasSameMonthAndYear(date, this.activeDate) ?
	            this._dateAdapter.getDate(date) : null;
	    };
	    /**
	     * Checks whether the 2 dates are non-null and fall within the same month of the same year.
	     * @param {?} d1
	     * @param {?} d2
	     * @return {?}
	     */
	    MatMonthView.prototype._hasSameMonthAndYear = /**
	     * Checks whether the 2 dates are non-null and fall within the same month of the same year.
	     * @param {?} d1
	     * @param {?} d2
	     * @return {?}
	     */
	    function (d1, d2) {
	        return !!(d1 && d2 && this._dateAdapter.getMonth(d1) == this._dateAdapter.getMonth(d2) &&
	            this._dateAdapter.getYear(d1) == this._dateAdapter.getYear(d2));
	    };
	    /**
	     * @param {?} obj The object to check.
	     * @return {?} The given object if it is both a date instance and valid, otherwise null.
	     */
	    MatMonthView.prototype._getValidDateOrNull = /**
	     * @param {?} obj The object to check.
	     * @return {?} The given object if it is both a date instance and valid, otherwise null.
	     */
	    function (obj) {
	        return (this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj)) ? obj : null;
	    };
	    MatMonthView.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-month-view',
	                    template: "<table class=\"mat-calendar-table\"><thead class=\"mat-calendar-table-header\"><tr><th *ngFor=\"let day of _weekdays\" [attr.aria-label]=\"day.long\">{{day.narrow}}</th></tr><tr><th class=\"mat-calendar-table-header-divider\" colspan=\"7\" aria-hidden=\"true\"></th></tr></thead><tbody mat-calendar-body [label]=\"_monthLabel\" [rows]=\"_weeks\" [todayValue]=\"_todayDate\" [selectedValue]=\"_selectedDate\" [labelMinRequiredCells]=\"3\" [activeCell]=\"_dateAdapter.getDate(activeDate) - 1\" (selectedValueChange)=\"_dateSelected($event)\"></tbody></table>",
	                    exportAs: 'matMonthView',
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatMonthView.ctorParameters = function () { return [
	        { type: DateAdapter, decorators: [{ type: _angular_core.Optional },] },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MAT_DATE_FORMATS,] },] },
	        { type: _angular_core.ChangeDetectorRef, },
	    ]; };
	    MatMonthView.propDecorators = {
	        "activeDate": [{ type: _angular_core.Input },],
	        "selected": [{ type: _angular_core.Input },],
	        "minDate": [{ type: _angular_core.Input },],
	        "maxDate": [{ type: _angular_core.Input },],
	        "dateFilter": [{ type: _angular_core.Input },],
	        "selectedChange": [{ type: _angular_core.Output },],
	        "_userSelection": [{ type: _angular_core.Output },],
	    };
	    return MatMonthView;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var yearsPerPage = 24;
	var yearsPerRow = 4;
	/**
	 * An internal component used to display a year selector in the datepicker.
	 * \@docs-private
	 */
	var MatMultiYearView = /** @class */ (function () {
	    function MatMultiYearView(_dateAdapter, _changeDetectorRef) {
	        this._dateAdapter = _dateAdapter;
	        this._changeDetectorRef = _changeDetectorRef;
	        /**
	         * Emits when a new month is selected.
	         */
	        this.selectedChange = new _angular_core.EventEmitter();
	        if (!this._dateAdapter) {
	            throw createMissingDateImplError('DateAdapter');
	        }
	        this._activeDate = this._dateAdapter.today();
	    }
	    Object.defineProperty(MatMultiYearView.prototype, "activeDate", {
	        get: /**
	         * The date to display in this multi-year view (everything other than the year is ignored).
	         * @return {?}
	         */
	        function () { return this._activeDate; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            var /** @type {?} */ oldActiveDate = this._activeDate;
	            this._activeDate =
	                this._getValidDateOrNull(this._dateAdapter.deserialize(value)) || this._dateAdapter.today();
	            if (Math.floor(this._dateAdapter.getYear(oldActiveDate) / yearsPerPage) !=
	                Math.floor(this._dateAdapter.getYear(this._activeDate) / yearsPerPage)) {
	                this._init();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatMultiYearView.prototype, "selected", {
	        get: /**
	         * The currently selected date.
	         * @return {?}
	         */
	        function () { return this._selected; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._selected = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
	            this._selectedYear = this._selected && this._dateAdapter.getYear(this._selected);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatMultiYearView.prototype, "minDate", {
	        get: /**
	         * The minimum selectable date.
	         * @return {?}
	         */
	        function () { return this._minDate; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._minDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatMultiYearView.prototype, "maxDate", {
	        get: /**
	         * The maximum selectable date.
	         * @return {?}
	         */
	        function () { return this._maxDate; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._maxDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatMultiYearView.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        this._init();
	    };
	    /** Initializes this multi-year view. */
	    /**
	     * Initializes this multi-year view.
	     * @return {?}
	     */
	    MatMultiYearView.prototype._init = /**
	     * Initializes this multi-year view.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._todayYear = this._dateAdapter.getYear(this._dateAdapter.today());
	        var /** @type {?} */ activeYear = this._dateAdapter.getYear(this._activeDate);
	        var /** @type {?} */ activeOffset = activeYear % yearsPerPage;
	        this._years = [];
	        for (var /** @type {?} */ i = 0, /** @type {?} */ row = []; i < yearsPerPage; i++) {
	            row.push(activeYear - activeOffset + i);
	            if (row.length == yearsPerRow) {
	                this._years.push(row.map(function (year) { return _this._createCellForYear(year); }));
	                row = [];
	            }
	        }
	        this._changeDetectorRef.markForCheck();
	    };
	    /** Handles when a new year is selected. */
	    /**
	     * Handles when a new year is selected.
	     * @param {?} year
	     * @return {?}
	     */
	    MatMultiYearView.prototype._yearSelected = /**
	     * Handles when a new year is selected.
	     * @param {?} year
	     * @return {?}
	     */
	    function (year) {
	        var /** @type {?} */ month = this._dateAdapter.getMonth(this.activeDate);
	        var /** @type {?} */ daysInMonth = this._dateAdapter.getNumDaysInMonth(this._dateAdapter.createDate(year, month, 1));
	        this.selectedChange.emit(this._dateAdapter.createDate(year, month, Math.min(this._dateAdapter.getDate(this.activeDate), daysInMonth)));
	    };
	    /**
	     * @return {?}
	     */
	    MatMultiYearView.prototype._getActiveCell = /**
	     * @return {?}
	     */
	    function () {
	        return this._dateAdapter.getYear(this.activeDate) % yearsPerPage;
	    };
	    /**
	     * Creates an MatCalendarCell for the given year.
	     * @param {?} year
	     * @return {?}
	     */
	    MatMultiYearView.prototype._createCellForYear = /**
	     * Creates an MatCalendarCell for the given year.
	     * @param {?} year
	     * @return {?}
	     */
	    function (year) {
	        var /** @type {?} */ yearName = this._dateAdapter.getYearName(this._dateAdapter.createDate(year, 0, 1));
	        return new MatCalendarCell(year, yearName, yearName, this._shouldEnableYear(year));
	    };
	    /**
	     * Whether the given year is enabled.
	     * @param {?} year
	     * @return {?}
	     */
	    MatMultiYearView.prototype._shouldEnableYear = /**
	     * Whether the given year is enabled.
	     * @param {?} year
	     * @return {?}
	     */
	    function (year) {
	        // disable if the year is greater than maxDate lower than minDate
	        if (year === undefined || year === null ||
	            (this.maxDate && year > this._dateAdapter.getYear(this.maxDate)) ||
	            (this.minDate && year < this._dateAdapter.getYear(this.minDate))) {
	            return false;
	        }
	        // enable if it reaches here and there's no filter defined
	        if (!this.dateFilter) {
	            return true;
	        }
	        var /** @type {?} */ firstOfYear = this._dateAdapter.createDate(year, 0, 1);
	        // If any date in the year is enabled count the year as enabled.
	        for (var /** @type {?} */ date = firstOfYear; this._dateAdapter.getYear(date) == year; date = this._dateAdapter.addCalendarDays(date, 1)) {
	            if (this.dateFilter(date)) {
	                return true;
	            }
	        }
	        return false;
	    };
	    /**
	     * @param {?} obj The object to check.
	     * @return {?} The given object if it is both a date instance and valid, otherwise null.
	     */
	    MatMultiYearView.prototype._getValidDateOrNull = /**
	     * @param {?} obj The object to check.
	     * @return {?} The given object if it is both a date instance and valid, otherwise null.
	     */
	    function (obj) {
	        return (this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj)) ? obj : null;
	    };
	    MatMultiYearView.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-multi-year-view',
	                    template: "<table class=\"mat-calendar-table\"><thead class=\"mat-calendar-table-header\"><tr><th class=\"mat-calendar-table-header-divider\" colspan=\"4\"></th></tr></thead><tbody mat-calendar-body allowDisabledSelection=\"true\" [rows]=\"_years\" [todayValue]=\"_todayYear\" [selectedValue]=\"_selectedYear\" [numCols]=\"4\" [cellAspectRatio]=\"4 / 7\" [activeCell]=\"_getActiveCell()\" (selectedValueChange)=\"_yearSelected($event)\"></tbody></table>",
	                    exportAs: 'matMultiYearView',
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatMultiYearView.ctorParameters = function () { return [
	        { type: DateAdapter, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_core.ChangeDetectorRef, },
	    ]; };
	    MatMultiYearView.propDecorators = {
	        "activeDate": [{ type: _angular_core.Input },],
	        "selected": [{ type: _angular_core.Input },],
	        "minDate": [{ type: _angular_core.Input },],
	        "maxDate": [{ type: _angular_core.Input },],
	        "dateFilter": [{ type: _angular_core.Input },],
	        "selectedChange": [{ type: _angular_core.Output },],
	    };
	    return MatMultiYearView;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * An internal component used to display a single year in the datepicker.
	 * \@docs-private
	 */
	var MatYearView = /** @class */ (function () {
	    function MatYearView(_dateAdapter, _dateFormats, _changeDetectorRef) {
	        this._dateAdapter = _dateAdapter;
	        this._dateFormats = _dateFormats;
	        this._changeDetectorRef = _changeDetectorRef;
	        /**
	         * Emits when a new month is selected.
	         */
	        this.selectedChange = new _angular_core.EventEmitter();
	        if (!this._dateAdapter) {
	            throw createMissingDateImplError('DateAdapter');
	        }
	        if (!this._dateFormats) {
	            throw createMissingDateImplError('MAT_DATE_FORMATS');
	        }
	        this._activeDate = this._dateAdapter.today();
	    }
	    Object.defineProperty(MatYearView.prototype, "activeDate", {
	        get: /**
	         * The date to display in this year view (everything other than the year is ignored).
	         * @return {?}
	         */
	        function () { return this._activeDate; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            var /** @type {?} */ oldActiveDate = this._activeDate;
	            this._activeDate =
	                this._getValidDateOrNull(this._dateAdapter.deserialize(value)) || this._dateAdapter.today();
	            if (this._dateAdapter.getYear(oldActiveDate) != this._dateAdapter.getYear(this._activeDate)) {
	                this._init();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatYearView.prototype, "selected", {
	        get: /**
	         * The currently selected date.
	         * @return {?}
	         */
	        function () { return this._selected; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._selected = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
	            this._selectedMonth = this._getMonthInCurrentYear(this._selected);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatYearView.prototype, "minDate", {
	        get: /**
	         * The minimum selectable date.
	         * @return {?}
	         */
	        function () { return this._minDate; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._minDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatYearView.prototype, "maxDate", {
	        get: /**
	         * The maximum selectable date.
	         * @return {?}
	         */
	        function () { return this._maxDate; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._maxDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatYearView.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        this._init();
	    };
	    /** Handles when a new month is selected. */
	    /**
	     * Handles when a new month is selected.
	     * @param {?} month
	     * @return {?}
	     */
	    MatYearView.prototype._monthSelected = /**
	     * Handles when a new month is selected.
	     * @param {?} month
	     * @return {?}
	     */
	    function (month) {
	        var /** @type {?} */ daysInMonth = this._dateAdapter.getNumDaysInMonth(this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, 1));
	        this.selectedChange.emit(this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, Math.min(this._dateAdapter.getDate(this.activeDate), daysInMonth)));
	    };
	    /** Initializes this year view. */
	    /**
	     * Initializes this year view.
	     * @return {?}
	     */
	    MatYearView.prototype._init = /**
	     * Initializes this year view.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._selectedMonth = this._getMonthInCurrentYear(this.selected);
	        this._todayMonth = this._getMonthInCurrentYear(this._dateAdapter.today());
	        this._yearLabel = this._dateAdapter.getYearName(this.activeDate);
	        var /** @type {?} */ monthNames = this._dateAdapter.getMonthNames('short');
	        // First row of months only contains 5 elements so we can fit the year label on the same row.
	        this._months = [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]].map(function (row) {
	            return row.map(function (month) { return _this._createCellForMonth(month, monthNames[month]); });
	        });
	        this._changeDetectorRef.markForCheck();
	    };
	    /**
	     * Gets the month in this year that the given Date falls on.
	     * Returns null if the given Date is in another year.
	     * @param {?} date
	     * @return {?}
	     */
	    MatYearView.prototype._getMonthInCurrentYear = /**
	     * Gets the month in this year that the given Date falls on.
	     * Returns null if the given Date is in another year.
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        return date && this._dateAdapter.getYear(date) == this._dateAdapter.getYear(this.activeDate) ?
	            this._dateAdapter.getMonth(date) : null;
	    };
	    /**
	     * Creates an MatCalendarCell for the given month.
	     * @param {?} month
	     * @param {?} monthName
	     * @return {?}
	     */
	    MatYearView.prototype._createCellForMonth = /**
	     * Creates an MatCalendarCell for the given month.
	     * @param {?} month
	     * @param {?} monthName
	     * @return {?}
	     */
	    function (month, monthName) {
	        var /** @type {?} */ ariaLabel = this._dateAdapter.format(this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, 1), this._dateFormats.display.monthYearA11yLabel);
	        return new MatCalendarCell(month, monthName.toLocaleUpperCase(), ariaLabel, this._shouldEnableMonth(month));
	    };
	    /**
	     * Whether the given month is enabled.
	     * @param {?} month
	     * @return {?}
	     */
	    MatYearView.prototype._shouldEnableMonth = /**
	     * Whether the given month is enabled.
	     * @param {?} month
	     * @return {?}
	     */
	    function (month) {
	        var /** @type {?} */ activeYear = this._dateAdapter.getYear(this.activeDate);
	        if (month === undefined || month === null ||
	            this._isYearAndMonthAfterMaxDate(activeYear, month) ||
	            this._isYearAndMonthBeforeMinDate(activeYear, month)) {
	            return false;
	        }
	        if (!this.dateFilter) {
	            return true;
	        }
	        var /** @type {?} */ firstOfMonth = this._dateAdapter.createDate(activeYear, month, 1);
	        // If any date in the month is enabled count the month as enabled.
	        for (var /** @type {?} */ date = firstOfMonth; this._dateAdapter.getMonth(date) == month; date = this._dateAdapter.addCalendarDays(date, 1)) {
	            if (this.dateFilter(date)) {
	                return true;
	            }
	        }
	        return false;
	    };
	    /**
	     * Tests whether the combination month/year is after this.maxDate, considering
	     * just the month and year of this.maxDate
	     * @param {?} year
	     * @param {?} month
	     * @return {?}
	     */
	    MatYearView.prototype._isYearAndMonthAfterMaxDate = /**
	     * Tests whether the combination month/year is after this.maxDate, considering
	     * just the month and year of this.maxDate
	     * @param {?} year
	     * @param {?} month
	     * @return {?}
	     */
	    function (year, month) {
	        if (this.maxDate) {
	            var /** @type {?} */ maxYear = this._dateAdapter.getYear(this.maxDate);
	            var /** @type {?} */ maxMonth = this._dateAdapter.getMonth(this.maxDate);
	            return year > maxYear || (year === maxYear && month > maxMonth);
	        }
	        return false;
	    };
	    /**
	     * Tests whether the combination month/year is before this.minDate, considering
	     * just the month and year of this.minDate
	     * @param {?} year
	     * @param {?} month
	     * @return {?}
	     */
	    MatYearView.prototype._isYearAndMonthBeforeMinDate = /**
	     * Tests whether the combination month/year is before this.minDate, considering
	     * just the month and year of this.minDate
	     * @param {?} year
	     * @param {?} month
	     * @return {?}
	     */
	    function (year, month) {
	        if (this.minDate) {
	            var /** @type {?} */ minYear = this._dateAdapter.getYear(this.minDate);
	            var /** @type {?} */ minMonth = this._dateAdapter.getMonth(this.minDate);
	            return year < minYear || (year === minYear && month < minMonth);
	        }
	        return false;
	    };
	    /**
	     * @param {?} obj The object to check.
	     * @return {?} The given object if it is both a date instance and valid, otherwise null.
	     */
	    MatYearView.prototype._getValidDateOrNull = /**
	     * @param {?} obj The object to check.
	     * @return {?} The given object if it is both a date instance and valid, otherwise null.
	     */
	    function (obj) {
	        return (this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj)) ? obj : null;
	    };
	    MatYearView.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-year-view',
	                    template: "<table class=\"mat-calendar-table\"><thead class=\"mat-calendar-table-header\"><tr><th class=\"mat-calendar-table-header-divider\" colspan=\"4\"></th></tr></thead><tbody mat-calendar-body allowDisabledSelection=\"true\" [label]=\"_yearLabel\" [rows]=\"_months\" [todayValue]=\"_todayMonth\" [selectedValue]=\"_selectedMonth\" [labelMinRequiredCells]=\"2\" [numCols]=\"4\" [cellAspectRatio]=\"4 / 7\" [activeCell]=\"_dateAdapter.getMonth(activeDate)\" (selectedValueChange)=\"_monthSelected($event)\"></tbody></table>",
	                    exportAs: 'matYearView',
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatYearView.ctorParameters = function () { return [
	        { type: DateAdapter, decorators: [{ type: _angular_core.Optional },] },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MAT_DATE_FORMATS,] },] },
	        { type: _angular_core.ChangeDetectorRef, },
	    ]; };
	    MatYearView.propDecorators = {
	        "activeDate": [{ type: _angular_core.Input },],
	        "selected": [{ type: _angular_core.Input },],
	        "minDate": [{ type: _angular_core.Input },],
	        "maxDate": [{ type: _angular_core.Input },],
	        "dateFilter": [{ type: _angular_core.Input },],
	        "selectedChange": [{ type: _angular_core.Output },],
	    };
	    return MatYearView;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * A calendar that is used as part of the datepicker.
	 * \@docs-private
	 */
	var MatCalendar = /** @class */ (function () {
	    function MatCalendar(_elementRef, _intl, _ngZone, _dateAdapter, _dateFormats, changeDetectorRef, _dir) {
	        this._elementRef = _elementRef;
	        this._intl = _intl;
	        this._ngZone = _ngZone;
	        this._dateAdapter = _dateAdapter;
	        this._dateFormats = _dateFormats;
	        this._dir = _dir;
	        /**
	         * Whether the calendar should be started in month or year view.
	         */
	        this.startView = 'month';
	        /**
	         * Emits when the currently selected date changes.
	         */
	        this.selectedChange = new _angular_core.EventEmitter();
	        /**
	         * Emits when any date is selected.
	         */
	        this._userSelection = new _angular_core.EventEmitter();
	        if (!this._dateAdapter) {
	            throw createMissingDateImplError('DateAdapter');
	        }
	        if (!this._dateFormats) {
	            throw createMissingDateImplError('MAT_DATE_FORMATS');
	        }
	        this._intlChanges = _intl.changes.subscribe(function () { return changeDetectorRef.markForCheck(); });
	    }
	    Object.defineProperty(MatCalendar.prototype, "startAt", {
	        get: /**
	         * A date representing the period (month or year) to start the calendar in.
	         * @return {?}
	         */
	        function () { return this._startAt; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._startAt = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatCalendar.prototype, "selected", {
	        get: /**
	         * The currently selected date.
	         * @return {?}
	         */
	        function () { return this._selected; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._selected = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatCalendar.prototype, "minDate", {
	        get: /**
	         * The minimum selectable date.
	         * @return {?}
	         */
	        function () { return this._minDate; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._minDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatCalendar.prototype, "maxDate", {
	        get: /**
	         * The maximum selectable date.
	         * @return {?}
	         */
	        function () { return this._maxDate; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._maxDate = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatCalendar.prototype, "_activeDate", {
	        /**
	         * The current active date. This determines which time period is shown and which date is
	         * highlighted when using keyboard navigation.
	         */
	        get: /**
	         * The current active date. This determines which time period is shown and which date is
	         * highlighted when using keyboard navigation.
	         * @return {?}
	         */
	        function () { return this._clampedActiveDate; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._clampedActiveDate = this._dateAdapter.clampDate(value, this.minDate, this.maxDate);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatCalendar.prototype, "_periodButtonText", {
	        /** The label for the current calendar view. */
	        get: /**
	         * The label for the current calendar view.
	         * @return {?}
	         */
	        function () {
	            if (this._currentView == 'month') {
	                return this._dateAdapter.format(this._activeDate, this._dateFormats.display.monthYearLabel)
	                    .toLocaleUpperCase();
	            }
	            if (this._currentView == 'year') {
	                return this._dateAdapter.getYearName(this._activeDate);
	            }
	            var /** @type {?} */ activeYear = this._dateAdapter.getYear(this._activeDate);
	            var /** @type {?} */ firstYearInView = this._dateAdapter.getYearName(this._dateAdapter.createDate(activeYear - activeYear % 24, 0, 1));
	            var /** @type {?} */ lastYearInView = this._dateAdapter.getYearName(this._dateAdapter.createDate(activeYear + yearsPerPage - 1 - activeYear % 24, 0, 1));
	            return firstYearInView + " \u2013 " + lastYearInView;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatCalendar.prototype, "_periodButtonLabel", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return this._currentView == 'month' ?
	                this._intl.switchToMultiYearViewLabel : this._intl.switchToMonthViewLabel;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatCalendar.prototype, "_prevButtonLabel", {
	        /** The label for the the previous button. */
	        get: /**
	         * The label for the the previous button.
	         * @return {?}
	         */
	        function () {
	            return {
	                'month': this._intl.prevMonthLabel,
	                'year': this._intl.prevYearLabel,
	                'multi-year': this._intl.prevMultiYearLabel
	            }[this._currentView];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatCalendar.prototype, "_nextButtonLabel", {
	        /** The label for the the next button. */
	        get: /**
	         * The label for the the next button.
	         * @return {?}
	         */
	        function () {
	            return {
	                'month': this._intl.nextMonthLabel,
	                'year': this._intl.nextYearLabel,
	                'multi-year': this._intl.nextMultiYearLabel
	            }[this._currentView];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatCalendar.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        this._activeDate = this.startAt || this._dateAdapter.today();
	        this._focusActiveCell();
	        this._currentView = this.startView;
	    };
	    /**
	     * @return {?}
	     */
	    MatCalendar.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._intlChanges.unsubscribe();
	    };
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    MatCalendar.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        var /** @type {?} */ change = changes["minDate"] || changes["maxDate"] || changes["dateFilter"];
	        if (change && !change.firstChange) {
	            var /** @type {?} */ view = this.monthView || this.yearView || this.multiYearView;
	            if (view) {
	                view._init();
	            }
	        }
	    };
	    /** Handles date selection in the month view. */
	    /**
	     * Handles date selection in the month view.
	     * @param {?} date
	     * @return {?}
	     */
	    MatCalendar.prototype._dateSelected = /**
	     * Handles date selection in the month view.
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        if (!this._dateAdapter.sameDate(date, this.selected)) {
	            this.selectedChange.emit(date);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatCalendar.prototype._userSelected = /**
	     * @return {?}
	     */
	    function () {
	        this._userSelection.emit();
	    };
	    /** Handles month selection in the multi-year view. */
	    /**
	     * Handles month selection in the multi-year view.
	     * @param {?} date
	     * @param {?} view
	     * @return {?}
	     */
	    MatCalendar.prototype._goToDateInView = /**
	     * Handles month selection in the multi-year view.
	     * @param {?} date
	     * @param {?} view
	     * @return {?}
	     */
	    function (date, view) {
	        this._activeDate = date;
	        this._currentView = view;
	    };
	    /** Handles user clicks on the period label. */
	    /**
	     * Handles user clicks on the period label.
	     * @return {?}
	     */
	    MatCalendar.prototype._currentPeriodClicked = /**
	     * Handles user clicks on the period label.
	     * @return {?}
	     */
	    function () {
	        this._currentView = this._currentView == 'month' ? 'multi-year' : 'month';
	    };
	    /** Handles user clicks on the previous button. */
	    /**
	     * Handles user clicks on the previous button.
	     * @return {?}
	     */
	    MatCalendar.prototype._previousClicked = /**
	     * Handles user clicks on the previous button.
	     * @return {?}
	     */
	    function () {
	        this._activeDate = this._currentView == 'month' ?
	            this._dateAdapter.addCalendarMonths(this._activeDate, -1) :
	            this._dateAdapter.addCalendarYears(this._activeDate, this._currentView == 'year' ? -1 : -yearsPerPage);
	    };
	    /** Handles user clicks on the next button. */
	    /**
	     * Handles user clicks on the next button.
	     * @return {?}
	     */
	    MatCalendar.prototype._nextClicked = /**
	     * Handles user clicks on the next button.
	     * @return {?}
	     */
	    function () {
	        this._activeDate = this._currentView == 'month' ?
	            this._dateAdapter.addCalendarMonths(this._activeDate, 1) :
	            this._dateAdapter.addCalendarYears(this._activeDate, this._currentView == 'year' ? 1 : yearsPerPage);
	    };
	    /** Whether the previous period button is enabled. */
	    /**
	     * Whether the previous period button is enabled.
	     * @return {?}
	     */
	    MatCalendar.prototype._previousEnabled = /**
	     * Whether the previous period button is enabled.
	     * @return {?}
	     */
	    function () {
	        if (!this.minDate) {
	            return true;
	        }
	        return !this.minDate || !this._isSameView(this._activeDate, this.minDate);
	    };
	    /** Whether the next period button is enabled. */
	    /**
	     * Whether the next period button is enabled.
	     * @return {?}
	     */
	    MatCalendar.prototype._nextEnabled = /**
	     * Whether the next period button is enabled.
	     * @return {?}
	     */
	    function () {
	        return !this.maxDate || !this._isSameView(this._activeDate, this.maxDate);
	    };
	    /** Handles keydown events on the calendar body. */
	    /**
	     * Handles keydown events on the calendar body.
	     * @param {?} event
	     * @return {?}
	     */
	    MatCalendar.prototype._handleCalendarBodyKeydown = /**
	     * Handles keydown events on the calendar body.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        // TODO(mmalerba): We currently allow keyboard navigation to disabled dates, but just prevent
	        // disabled ones from being selected. This may not be ideal, we should look into whether
	        // navigation should skip over disabled dates, and if so, how to implement that efficiently.
	        if (this._currentView == 'month') {
	            this._handleCalendarBodyKeydownInMonthView(event);
	        }
	        else if (this._currentView == 'year') {
	            this._handleCalendarBodyKeydownInYearView(event);
	        }
	        else {
	            this._handleCalendarBodyKeydownInMultiYearView(event);
	        }
	    };
	    /** Focuses the active cell after the microtask queue is empty. */
	    /**
	     * Focuses the active cell after the microtask queue is empty.
	     * @return {?}
	     */
	    MatCalendar.prototype._focusActiveCell = /**
	     * Focuses the active cell after the microtask queue is empty.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._ngZone.runOutsideAngular(function () {
	            _this._ngZone.onStable.asObservable().pipe(rxjs_operators_take.take(1)).subscribe(function () {
	                _this._elementRef.nativeElement.querySelector('.mat-calendar-body-active').focus();
	            });
	        });
	    };
	    /**
	     * Whether the two dates represent the same view in the current view mode (month or year).
	     * @param {?} date1
	     * @param {?} date2
	     * @return {?}
	     */
	    MatCalendar.prototype._isSameView = /**
	     * Whether the two dates represent the same view in the current view mode (month or year).
	     * @param {?} date1
	     * @param {?} date2
	     * @return {?}
	     */
	    function (date1, date2) {
	        if (this._currentView == 'month') {
	            return this._dateAdapter.getYear(date1) == this._dateAdapter.getYear(date2) &&
	                this._dateAdapter.getMonth(date1) == this._dateAdapter.getMonth(date2);
	        }
	        if (this._currentView == 'year') {
	            return this._dateAdapter.getYear(date1) == this._dateAdapter.getYear(date2);
	        }
	        // Otherwise we are in 'multi-year' view.
	        return Math.floor(this._dateAdapter.getYear(date1) / yearsPerPage) ==
	            Math.floor(this._dateAdapter.getYear(date2) / yearsPerPage);
	    };
	    /**
	     * Handles keydown events on the calendar body when calendar is in month view.
	     * @param {?} event
	     * @return {?}
	     */
	    MatCalendar.prototype._handleCalendarBodyKeydownInMonthView = /**
	     * Handles keydown events on the calendar body when calendar is in month view.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var /** @type {?} */ isRtl = this._isRtl();
	        switch (event.keyCode) {
	            case _angular_cdk_keycodes.LEFT_ARROW:
	                this._activeDate = this._dateAdapter.addCalendarDays(this._activeDate, isRtl ? 1 : -1);
	                break;
	            case _angular_cdk_keycodes.RIGHT_ARROW:
	                this._activeDate = this._dateAdapter.addCalendarDays(this._activeDate, isRtl ? -1 : 1);
	                break;
	            case _angular_cdk_keycodes.UP_ARROW:
	                this._activeDate = this._dateAdapter.addCalendarDays(this._activeDate, -7);
	                break;
	            case _angular_cdk_keycodes.DOWN_ARROW:
	                this._activeDate = this._dateAdapter.addCalendarDays(this._activeDate, 7);
	                break;
	            case _angular_cdk_keycodes.HOME:
	                this._activeDate = this._dateAdapter.addCalendarDays(this._activeDate, 1 - this._dateAdapter.getDate(this._activeDate));
	                break;
	            case _angular_cdk_keycodes.END:
	                this._activeDate = this._dateAdapter.addCalendarDays(this._activeDate, (this._dateAdapter.getNumDaysInMonth(this._activeDate) -
	                    this._dateAdapter.getDate(this._activeDate)));
	                break;
	            case _angular_cdk_keycodes.PAGE_UP:
	                this._activeDate = event.altKey ?
	                    this._dateAdapter.addCalendarYears(this._activeDate, -1) :
	                    this._dateAdapter.addCalendarMonths(this._activeDate, -1);
	                break;
	            case _angular_cdk_keycodes.PAGE_DOWN:
	                this._activeDate = event.altKey ?
	                    this._dateAdapter.addCalendarYears(this._activeDate, 1) :
	                    this._dateAdapter.addCalendarMonths(this._activeDate, 1);
	                break;
	            case _angular_cdk_keycodes.ENTER:
	                if (!this.dateFilter || this.dateFilter(this._activeDate)) {
	                    this._dateSelected(this._activeDate);
	                    this._userSelected();
	                    // Prevent unexpected default actions such as form submission.
	                    event.preventDefault();
	                }
	                return;
	            default:
	                // Don't prevent default or focus active cell on keys that we don't explicitly handle.
	                return;
	        }
	        this._focusActiveCell();
	        // Prevent unexpected default actions such as form submission.
	        event.preventDefault();
	    };
	    /**
	     * Handles keydown events on the calendar body when calendar is in year view.
	     * @param {?} event
	     * @return {?}
	     */
	    MatCalendar.prototype._handleCalendarBodyKeydownInYearView = /**
	     * Handles keydown events on the calendar body when calendar is in year view.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var /** @type {?} */ isRtl = this._isRtl();
	        switch (event.keyCode) {
	            case _angular_cdk_keycodes.LEFT_ARROW:
	                this._activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, isRtl ? 1 : -1);
	                break;
	            case _angular_cdk_keycodes.RIGHT_ARROW:
	                this._activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, isRtl ? -1 : 1);
	                break;
	            case _angular_cdk_keycodes.UP_ARROW:
	                this._activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, -4);
	                break;
	            case _angular_cdk_keycodes.DOWN_ARROW:
	                this._activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, 4);
	                break;
	            case _angular_cdk_keycodes.HOME:
	                this._activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, -this._dateAdapter.getMonth(this._activeDate));
	                break;
	            case _angular_cdk_keycodes.END:
	                this._activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, 11 - this._dateAdapter.getMonth(this._activeDate));
	                break;
	            case _angular_cdk_keycodes.PAGE_UP:
	                this._activeDate =
	                    this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? -10 : -1);
	                break;
	            case _angular_cdk_keycodes.PAGE_DOWN:
	                this._activeDate =
	                    this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? 10 : 1);
	                break;
	            case _angular_cdk_keycodes.ENTER:
	                this._goToDateInView(this._activeDate, 'month');
	                break;
	            default:
	                // Don't prevent default or focus active cell on keys that we don't explicitly handle.
	                return;
	        }
	        this._focusActiveCell();
	        // Prevent unexpected default actions such as form submission.
	        event.preventDefault();
	    };
	    /**
	     * Handles keydown events on the calendar body when calendar is in multi-year view.
	     * @param {?} event
	     * @return {?}
	     */
	    MatCalendar.prototype._handleCalendarBodyKeydownInMultiYearView = /**
	     * Handles keydown events on the calendar body when calendar is in multi-year view.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        switch (event.keyCode) {
	            case _angular_cdk_keycodes.LEFT_ARROW:
	                this._activeDate = this._dateAdapter.addCalendarYears(this._activeDate, -1);
	                break;
	            case _angular_cdk_keycodes.RIGHT_ARROW:
	                this._activeDate = this._dateAdapter.addCalendarYears(this._activeDate, 1);
	                break;
	            case _angular_cdk_keycodes.UP_ARROW:
	                this._activeDate = this._dateAdapter.addCalendarYears(this._activeDate, -yearsPerRow);
	                break;
	            case _angular_cdk_keycodes.DOWN_ARROW:
	                this._activeDate = this._dateAdapter.addCalendarYears(this._activeDate, yearsPerRow);
	                break;
	            case _angular_cdk_keycodes.HOME:
	                this._activeDate = this._dateAdapter.addCalendarYears(this._activeDate, -this._dateAdapter.getYear(this._activeDate) % yearsPerPage);
	                break;
	            case _angular_cdk_keycodes.END:
	                this._activeDate = this._dateAdapter.addCalendarYears(this._activeDate, yearsPerPage - this._dateAdapter.getYear(this._activeDate) % yearsPerPage - 1);
	                break;
	            case _angular_cdk_keycodes.PAGE_UP:
	                this._activeDate =
	                    this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? -yearsPerPage * 10 : -yearsPerPage);
	                break;
	            case _angular_cdk_keycodes.PAGE_DOWN:
	                this._activeDate =
	                    this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? yearsPerPage * 10 : yearsPerPage);
	                break;
	            case _angular_cdk_keycodes.ENTER:
	                this._goToDateInView(this._activeDate, 'year');
	                break;
	            default:
	                // Don't prevent default or focus active cell on keys that we don't explicitly handle.
	                return;
	        }
	        this._focusActiveCell();
	        // Prevent unexpected default actions such as form submission.
	        event.preventDefault();
	    };
	    /**
	     * @param {?} obj The object to check.
	     * @return {?} The given object if it is both a date instance and valid, otherwise null.
	     */
	    MatCalendar.prototype._getValidDateOrNull = /**
	     * @param {?} obj The object to check.
	     * @return {?} The given object if it is both a date instance and valid, otherwise null.
	     */
	    function (obj) {
	        return (this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj)) ? obj : null;
	    };
	    /**
	     * Determines whether the user has the RTL layout direction.
	     * @return {?}
	     */
	    MatCalendar.prototype._isRtl = /**
	     * Determines whether the user has the RTL layout direction.
	     * @return {?}
	     */
	    function () {
	        return this._dir && this._dir.value === 'rtl';
	    };
	    MatCalendar.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-calendar',
	                    template: "<div class=\"mat-calendar-header\"><div class=\"mat-calendar-controls\"><button mat-button class=\"mat-calendar-period-button\" (click)=\"_currentPeriodClicked()\" [attr.aria-label]=\"_periodButtonLabel\">{{_periodButtonText}}<div class=\"mat-calendar-arrow\" [class.mat-calendar-invert]=\"_currentView != 'month'\"></div></button><div class=\"mat-calendar-spacer\"></div><button mat-icon-button class=\"mat-calendar-previous-button\" [disabled]=\"!_previousEnabled()\" (click)=\"_previousClicked()\" [attr.aria-label]=\"_prevButtonLabel\"></button> <button mat-icon-button class=\"mat-calendar-next-button\" [disabled]=\"!_nextEnabled()\" (click)=\"_nextClicked()\" [attr.aria-label]=\"_nextButtonLabel\"></button></div></div><div class=\"mat-calendar-content\" (keydown)=\"_handleCalendarBodyKeydown($event)\" [ngSwitch]=\"_currentView\" cdkMonitorSubtreeFocus tabindex=\"-1\"><mat-month-view *ngSwitchCase=\"'month'\" [activeDate]=\"_activeDate\" [selected]=\"selected\" [dateFilter]=\"dateFilter\" [maxDate]=\"maxDate\" [minDate]=\"minDate\" (selectedChange)=\"_dateSelected($event)\" (_userSelection)=\"_userSelected()\"></mat-month-view><mat-year-view *ngSwitchCase=\"'year'\" [activeDate]=\"_activeDate\" [selected]=\"selected\" [dateFilter]=\"dateFilter\" [maxDate]=\"maxDate\" [minDate]=\"minDate\" (selectedChange)=\"_goToDateInView($event, 'month')\"></mat-year-view><mat-multi-year-view *ngSwitchCase=\"'multi-year'\" [activeDate]=\"_activeDate\" [selected]=\"selected\" [dateFilter]=\"dateFilter\" [maxDate]=\"maxDate\" [minDate]=\"minDate\" (selectedChange)=\"_goToDateInView($event, 'year')\"></mat-multi-year-view></div>",
	                    styles: [".mat-calendar{display:block}.mat-calendar-header{padding:8px 8px 0 8px}.mat-calendar-content{padding:0 8px 8px 8px;outline:0}.mat-calendar-controls{display:flex;margin:5% calc(33% / 7 - 16px)}.mat-calendar-spacer{flex:1 1 auto}.mat-calendar-period-button{min-width:0}.mat-calendar-arrow{display:inline-block;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top-width:5px;border-top-style:solid;margin:0 0 0 5px;vertical-align:middle}.mat-calendar-arrow.mat-calendar-invert{transform:rotate(180deg)}[dir=rtl] .mat-calendar-arrow{margin:0 5px 0 0}.mat-calendar-next-button,.mat-calendar-previous-button{position:relative}.mat-calendar-next-button::after,.mat-calendar-previous-button::after{top:0;left:0;right:0;bottom:0;position:absolute;content:'';margin:15.5px;border:0 solid currentColor;border-top-width:2px}[dir=rtl] .mat-calendar-next-button,[dir=rtl] .mat-calendar-previous-button{transform:rotate(180deg)}.mat-calendar-previous-button::after{border-left-width:2px;transform:translateX(2px) rotate(-45deg)}.mat-calendar-next-button::after{border-right-width:2px;transform:translateX(-2px) rotate(45deg)}.mat-calendar-table{border-spacing:0;border-collapse:collapse;width:100%}.mat-calendar-table-header th{text-align:center;padding:0 0 8px 0}.mat-calendar-table-header-divider{position:relative;height:1px}.mat-calendar-table-header-divider::after{content:'';position:absolute;top:0;left:-8px;right:-8px;height:1px}"],
	                    host: {
	                        'class': 'mat-calendar',
	                    },
	                    exportAs: 'matCalendar',
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatCalendar.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: MatDatepickerIntl, },
	        { type: _angular_core.NgZone, },
	        { type: DateAdapter, decorators: [{ type: _angular_core.Optional },] },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MAT_DATE_FORMATS,] },] },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: _angular_cdk_bidi.Directionality, decorators: [{ type: _angular_core.Optional },] },
	    ]; };
	    MatCalendar.propDecorators = {
	        "startAt": [{ type: _angular_core.Input },],
	        "startView": [{ type: _angular_core.Input },],
	        "selected": [{ type: _angular_core.Input },],
	        "minDate": [{ type: _angular_core.Input },],
	        "maxDate": [{ type: _angular_core.Input },],
	        "dateFilter": [{ type: _angular_core.Input },],
	        "selectedChange": [{ type: _angular_core.Output },],
	        "_userSelection": [{ type: _angular_core.Output },],
	        "monthView": [{ type: _angular_core.ViewChild, args: [MatMonthView,] },],
	        "yearView": [{ type: _angular_core.ViewChild, args: [MatYearView,] },],
	        "multiYearView": [{ type: _angular_core.ViewChild, args: [MatMultiYearView,] },],
	    };
	    return MatCalendar;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Used to generate a unique ID for each datepicker instance.
	 */
	var datepickerUid = 0;
	/**
	 * Injection token that determines the scroll handling while the calendar is open.
	 */
	var MAT_DATEPICKER_SCROLL_STRATEGY = new _angular_core.InjectionToken('mat-datepicker-scroll-strategy');
	/**
	 * \@docs-private
	 * @param {?} overlay
	 * @return {?}
	 */
	function MAT_DATEPICKER_SCROLL_STRATEGY_PROVIDER_FACTORY(overlay) {
	    return function () { return overlay.scrollStrategies.reposition(); };
	}
	/**
	 * \@docs-private
	 */
	var MAT_DATEPICKER_SCROLL_STRATEGY_PROVIDER = {
	    provide: MAT_DATEPICKER_SCROLL_STRATEGY,
	    deps: [_angular_cdk_overlay.Overlay],
	    useFactory: MAT_DATEPICKER_SCROLL_STRATEGY_PROVIDER_FACTORY,
	};
	/**
	 * Component used as the content for the datepicker dialog and popup. We use this instead of using
	 * MatCalendar directly as the content so we can control the initial focus. This also gives us a
	 * place to put additional features of the popup that are not part of the calendar itself in the
	 * future. (e.g. confirmation buttons).
	 * \@docs-private
	 */
	var MatDatepickerContent = /** @class */ (function () {
	    function MatDatepickerContent() {
	    }
	    /**
	     * @return {?}
	     */
	    MatDatepickerContent.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        this._calendar._focusActiveCell();
	    };
	    MatDatepickerContent.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-datepicker-content',
	                    template: "<mat-calendar cdkTrapFocus [id]=\"datepicker.id\" [ngClass]=\"datepicker.panelClass\" [startAt]=\"datepicker.startAt\" [startView]=\"datepicker.startView\" [minDate]=\"datepicker._minDate\" [maxDate]=\"datepicker._maxDate\" [dateFilter]=\"datepicker._dateFilter\" [selected]=\"datepicker._selected\" (selectedChange)=\"datepicker._select($event)\" (_userSelection)=\"datepicker.close()\"></mat-calendar>",
	                    styles: [".mat-datepicker-content{box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);display:block;border-radius:2px}.mat-datepicker-content .mat-calendar{width:296px;height:354px}.mat-datepicker-content-touch{box-shadow:0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12);display:block;max-height:80vh;overflow:auto;margin:-24px}.mat-datepicker-content-touch .mat-calendar{min-width:250px;min-height:312px;max-width:750px;max-height:788px}@media all and (orientation:landscape){.mat-datepicker-content-touch .mat-calendar{width:64vh;height:80vh}}@media all and (orientation:portrait){.mat-datepicker-content-touch .mat-calendar{width:80vw;height:100vw}}"],
	                    host: {
	                        'class': 'mat-datepicker-content',
	                        '[class.mat-datepicker-content-touch]': 'datepicker.touchUi',
	                    },
	                    exportAs: 'matDatepickerContent',
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatDatepickerContent.ctorParameters = function () { return []; };
	    MatDatepickerContent.propDecorators = {
	        "_calendar": [{ type: _angular_core.ViewChild, args: [MatCalendar,] },],
	    };
	    return MatDatepickerContent;
	}());
	/**
	 * Component responsible for managing the datepicker popup/dialog.
	 */
	var MatDatepicker = /** @class */ (function () {
	    function MatDatepicker(_dialog, _overlay, _ngZone, _viewContainerRef, _scrollStrategy, _dateAdapter, _dir, _document) {
	        this._dialog = _dialog;
	        this._overlay = _overlay;
	        this._ngZone = _ngZone;
	        this._viewContainerRef = _viewContainerRef;
	        this._scrollStrategy = _scrollStrategy;
	        this._dateAdapter = _dateAdapter;
	        this._dir = _dir;
	        this._document = _document;
	        /**
	         * The view that the calendar should start in.
	         */
	        this.startView = 'month';
	        this._touchUi = false;
	        /**
	         * Emits new selected date when selected date changes.
	         * @deprecated Switch to the `dateChange` and `dateInput` binding on the input element.
	         * \@deletion-target 6.0.0
	         */
	        this.selectedChanged = new _angular_core.EventEmitter();
	        /**
	         * Emits when the datepicker has been opened.
	         */
	        this.openedStream = new _angular_core.EventEmitter();
	        /**
	         * Emits when the datepicker has been closed.
	         */
	        this.closedStream = new _angular_core.EventEmitter();
	        this._opened = false;
	        /**
	         * The id for the datepicker calendar.
	         */
	        this.id = "mat-datepicker-" + datepickerUid++;
	        this._validSelected = null;
	        /**
	         * The element that was focused before the datepicker was opened.
	         */
	        this._focusedElementBeforeOpen = null;
	        this._inputSubscription = rxjs_Subscription.Subscription.EMPTY;
	        /**
	         * Emits when the datepicker is disabled.
	         */
	        this._disabledChange = new rxjs_Subject.Subject();
	        if (!this._dateAdapter) {
	            throw createMissingDateImplError('DateAdapter');
	        }
	    }
	    Object.defineProperty(MatDatepicker.prototype, "startAt", {
	        get: /**
	         * The date to open the calendar to initially.
	         * @return {?}
	         */
	        function () {
	            // If an explicit startAt is set we start there, otherwise we start at whatever the currently
	            // selected value is.
	            return this._startAt || (this._datepickerInput ? this._datepickerInput.value : null);
	        },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._startAt = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDatepicker.prototype, "touchUi", {
	        get: /**
	         * Whether the calendar UI is in touch mode. In touch mode the calendar opens in a dialog rather
	         * than a popup and elements have more padding to allow for bigger touch targets.
	         * @return {?}
	         */
	        function () { return this._touchUi; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._touchUi = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDatepicker.prototype, "disabled", {
	        get: /**
	         * Whether the datepicker pop-up should be disabled.
	         * @return {?}
	         */
	        function () {
	            return this._disabled === undefined && this._datepickerInput ?
	                this._datepickerInput.disabled : !!this._disabled;
	        },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            var /** @type {?} */ newValue = _angular_cdk_coercion.coerceBooleanProperty(value);
	            if (newValue !== this._disabled) {
	                this._disabled = newValue;
	                this._disabledChange.next(newValue);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDatepicker.prototype, "opened", {
	        get: /**
	         * Whether the calendar is open.
	         * @return {?}
	         */
	        function () { return this._opened; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { value ? this.open() : this.close(); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDatepicker.prototype, "_selected", {
	        /** The currently selected date. */
	        get: /**
	         * The currently selected date.
	         * @return {?}
	         */
	        function () { return this._validSelected; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._validSelected = value; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDatepicker.prototype, "_minDate", {
	        /** The minimum selectable date. */
	        get: /**
	         * The minimum selectable date.
	         * @return {?}
	         */
	        function () {
	            return this._datepickerInput && this._datepickerInput.min;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDatepicker.prototype, "_maxDate", {
	        /** The maximum selectable date. */
	        get: /**
	         * The maximum selectable date.
	         * @return {?}
	         */
	        function () {
	            return this._datepickerInput && this._datepickerInput.max;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDatepicker.prototype, "_dateFilter", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return this._datepickerInput && this._datepickerInput._dateFilter;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatDatepicker.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this.close();
	        this._inputSubscription.unsubscribe();
	        this._disabledChange.complete();
	        if (this._popupRef) {
	            this._popupRef.dispose();
	        }
	    };
	    /** Selects the given date */
	    /**
	     * Selects the given date
	     * @param {?} date
	     * @return {?}
	     */
	    MatDatepicker.prototype._select = /**
	     * Selects the given date
	     * @param {?} date
	     * @return {?}
	     */
	    function (date) {
	        var /** @type {?} */ oldValue = this._selected;
	        this._selected = date;
	        if (!this._dateAdapter.sameDate(oldValue, this._selected)) {
	            this.selectedChanged.emit(date);
	        }
	    };
	    /**
	     * Register an input with this datepicker.
	     * @param input The datepicker input to register with this datepicker.
	     */
	    /**
	     * Register an input with this datepicker.
	     * @param {?} input The datepicker input to register with this datepicker.
	     * @return {?}
	     */
	    MatDatepicker.prototype._registerInput = /**
	     * Register an input with this datepicker.
	     * @param {?} input The datepicker input to register with this datepicker.
	     * @return {?}
	     */
	    function (input) {
	        var _this = this;
	        if (this._datepickerInput) {
	            throw Error('A MatDatepicker can only be associated with a single input.');
	        }
	        this._datepickerInput = input;
	        this._inputSubscription =
	            this._datepickerInput._valueChange.subscribe(function (value) { return _this._selected = value; });
	    };
	    /** Open the calendar. */
	    /**
	     * Open the calendar.
	     * @return {?}
	     */
	    MatDatepicker.prototype.open = /**
	     * Open the calendar.
	     * @return {?}
	     */
	    function () {
	        if (this._opened || this.disabled) {
	            return;
	        }
	        if (!this._datepickerInput) {
	            throw Error('Attempted to open an MatDatepicker with no associated input.');
	        }
	        if (this._document) {
	            this._focusedElementBeforeOpen = this._document.activeElement;
	        }
	        this.touchUi ? this._openAsDialog() : this._openAsPopup();
	        this._opened = true;
	        this.openedStream.emit();
	    };
	    /** Close the calendar. */
	    /**
	     * Close the calendar.
	     * @return {?}
	     */
	    MatDatepicker.prototype.close = /**
	     * Close the calendar.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (!this._opened) {
	            return;
	        }
	        if (this._popupRef && this._popupRef.hasAttached()) {
	            this._popupRef.detach();
	        }
	        if (this._dialogRef) {
	            this._dialogRef.close();
	            this._dialogRef = null;
	        }
	        if (this._calendarPortal && this._calendarPortal.isAttached) {
	            this._calendarPortal.detach();
	        }
	        var /** @type {?} */ completeClose = function () {
	            // The `_opened` could've been reset already if
	            // we got two events in quick succession.
	            if (_this._opened) {
	                _this._opened = false;
	                _this.closedStream.emit();
	                _this._focusedElementBeforeOpen = null;
	            }
	        };
	        if (this._focusedElementBeforeOpen &&
	            typeof this._focusedElementBeforeOpen.focus === 'function') {
	            // Because IE moves focus asynchronously, we can't count on it being restored before we've
	            // marked the datepicker as closed. If the event fires out of sequence and the element that
	            // we're refocusing opens the datepicker on focus, the user could be stuck with not being
	            // able to close the calendar at all. We work around it by making the logic, that marks
	            // the datepicker as closed, async as well.
	            this._focusedElementBeforeOpen.focus();
	            setTimeout(completeClose);
	        }
	        else {
	            completeClose();
	        }
	    };
	    /**
	     * Open the calendar as a dialog.
	     * @return {?}
	     */
	    MatDatepicker.prototype._openAsDialog = /**
	     * Open the calendar as a dialog.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._dialogRef = this._dialog.open(MatDatepickerContent, {
	            direction: this._dir ? this._dir.value : 'ltr',
	            viewContainerRef: this._viewContainerRef,
	            panelClass: 'mat-datepicker-dialog',
	        });
	        this._dialogRef.afterClosed().subscribe(function () { return _this.close(); });
	        this._dialogRef.componentInstance.datepicker = this;
	    };
	    /**
	     * Open the calendar as a popup.
	     * @return {?}
	     */
	    MatDatepicker.prototype._openAsPopup = /**
	     * Open the calendar as a popup.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (!this._calendarPortal) {
	            this._calendarPortal = new _angular_cdk_portal.ComponentPortal(MatDatepickerContent, this._viewContainerRef);
	        }
	        if (!this._popupRef) {
	            this._createPopup();
	        }
	        if (!this._popupRef.hasAttached()) {
	            var /** @type {?} */ componentRef = this._popupRef.attach(this._calendarPortal);
	            componentRef.instance.datepicker = this;
	            // Update the position once the calendar has rendered.
	            this._ngZone.onStable.asObservable().pipe(rxjs_operators_take.take(1)).subscribe(function () {
	                _this._popupRef.updatePosition();
	            });
	        }
	    };
	    /**
	     * Create the popup.
	     * @return {?}
	     */
	    MatDatepicker.prototype._createPopup = /**
	     * Create the popup.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ overlayConfig = new _angular_cdk_overlay.OverlayConfig({
	            positionStrategy: this._createPopupPositionStrategy(),
	            hasBackdrop: true,
	            backdropClass: 'mat-overlay-transparent-backdrop',
	            direction: this._dir ? this._dir.value : 'ltr',
	            scrollStrategy: this._scrollStrategy(),
	            panelClass: 'mat-datepicker-popup',
	        });
	        this._popupRef = this._overlay.create(overlayConfig);
	        rxjs_observable_merge.merge(this._popupRef.backdropClick(), this._popupRef.detachments(), this._popupRef.keydownEvents().pipe(rxjs_operators_filter.filter(function (event) { return event.keyCode === _angular_cdk_keycodes.ESCAPE; }))).subscribe(function () { return _this.close(); });
	    };
	    /**
	     * Create the popup PositionStrategy.
	     * @return {?}
	     */
	    MatDatepicker.prototype._createPopupPositionStrategy = /**
	     * Create the popup PositionStrategy.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ fallbackOffset = this._datepickerInput._getPopupFallbackOffset();
	        return this._overlay.position()
	            .connectedTo(this._datepickerInput.getPopupConnectionElementRef(), { originX: 'start', originY: 'bottom' }, { overlayX: 'start', overlayY: 'top' })
	            .withFallbackPosition({ originX: 'start', originY: 'top' }, { overlayX: 'start', overlayY: 'bottom' }, undefined, fallbackOffset)
	            .withFallbackPosition({ originX: 'end', originY: 'bottom' }, { overlayX: 'end', overlayY: 'top' })
	            .withFallbackPosition({ originX: 'end', originY: 'top' }, { overlayX: 'end', overlayY: 'bottom' }, undefined, fallbackOffset);
	    };
	    /**
	     * @param {?} obj The object to check.
	     * @return {?} The given object if it is both a date instance and valid, otherwise null.
	     */
	    MatDatepicker.prototype._getValidDateOrNull = /**
	     * @param {?} obj The object to check.
	     * @return {?} The given object if it is both a date instance and valid, otherwise null.
	     */
	    function (obj) {
	        return (this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj)) ? obj : null;
	    };
	    MatDatepicker.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-datepicker',
	                    template: '',
	                    exportAs: 'matDatepicker',
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                },] },
	    ];
	    /** @nocollapse */
	    MatDatepicker.ctorParameters = function () { return [
	        { type: MatDialog, },
	        { type: _angular_cdk_overlay.Overlay, },
	        { type: _angular_core.NgZone, },
	        { type: _angular_core.ViewContainerRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [MAT_DATEPICKER_SCROLL_STRATEGY,] },] },
	        { type: DateAdapter, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_cdk_bidi.Directionality, decorators: [{ type: _angular_core.Optional },] },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    MatDatepicker.propDecorators = {
	        "startAt": [{ type: _angular_core.Input },],
	        "startView": [{ type: _angular_core.Input },],
	        "touchUi": [{ type: _angular_core.Input },],
	        "disabled": [{ type: _angular_core.Input },],
	        "selectedChanged": [{ type: _angular_core.Output },],
	        "panelClass": [{ type: _angular_core.Input },],
	        "openedStream": [{ type: _angular_core.Output, args: ['opened',] },],
	        "closedStream": [{ type: _angular_core.Output, args: ['closed',] },],
	        "opened": [{ type: _angular_core.Input },],
	    };
	    return MatDatepicker;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MAT_DATEPICKER_VALUE_ACCESSOR = {
	    provide: _angular_forms.NG_VALUE_ACCESSOR,
	    useExisting: _angular_core.forwardRef(function () { return MatDatepickerInput; }),
	    multi: true
	};
	var MAT_DATEPICKER_VALIDATORS = {
	    provide: _angular_forms.NG_VALIDATORS,
	    useExisting: _angular_core.forwardRef(function () { return MatDatepickerInput; }),
	    multi: true
	};
	/**
	 * An event used for datepicker input and change events. We don't always have access to a native
	 * input or change event because the event may have been triggered by the user clicking on the
	 * calendar popup. For consistency, we always use MatDatepickerInputEvent instead.
	 */
	var MatDatepickerInputEvent = /** @class */ (function () {
	    function MatDatepickerInputEvent(target, targetElement) {
	        this.target = target;
	        this.targetElement = targetElement;
	        this.value = this.target.value;
	    }
	    return MatDatepickerInputEvent;
	}());
	/**
	 * Directive used to connect an input to a MatDatepicker.
	 */
	var MatDatepickerInput = /** @class */ (function () {
	    function MatDatepickerInput(_elementRef, _dateAdapter, _dateFormats, _formField) {
	        var _this = this;
	        this._elementRef = _elementRef;
	        this._dateAdapter = _dateAdapter;
	        this._dateFormats = _dateFormats;
	        this._formField = _formField;
	        /**
	         * Emits when a `change` event is fired on this `<input>`.
	         */
	        this.dateChange = new _angular_core.EventEmitter();
	        /**
	         * Emits when an `input` event is fired on this `<input>`.
	         */
	        this.dateInput = new _angular_core.EventEmitter();
	        /**
	         * Emits when the value changes (either due to user input or programmatic change).
	         */
	        this._valueChange = new _angular_core.EventEmitter();
	        /**
	         * Emits when the disabled state has changed
	         */
	        this._disabledChange = new _angular_core.EventEmitter();
	        this._onTouched = function () { };
	        this._cvaOnChange = function () { };
	        this._validatorOnChange = function () { };
	        this._datepickerSubscription = rxjs_Subscription.Subscription.EMPTY;
	        this._localeSubscription = rxjs_Subscription.Subscription.EMPTY;
	        /**
	         * The form control validator for whether the input parses.
	         */
	        this._parseValidator = function () {
	            return _this._lastValueValid ?
	                null : { 'matDatepickerParse': { 'text': _this._elementRef.nativeElement.value } };
	        };
	        /**
	         * The form control validator for the min date.
	         */
	        this._minValidator = function (control) {
	            var /** @type {?} */ controlValue = _this._getValidDateOrNull(_this._dateAdapter.deserialize(control.value));
	            return (!_this.min || !controlValue ||
	                _this._dateAdapter.compareDate(_this.min, controlValue) <= 0) ?
	                null : { 'matDatepickerMin': { 'min': _this.min, 'actual': controlValue } };
	        };
	        /**
	         * The form control validator for the max date.
	         */
	        this._maxValidator = function (control) {
	            var /** @type {?} */ controlValue = _this._getValidDateOrNull(_this._dateAdapter.deserialize(control.value));
	            return (!_this.max || !controlValue ||
	                _this._dateAdapter.compareDate(_this.max, controlValue) >= 0) ?
	                null : { 'matDatepickerMax': { 'max': _this.max, 'actual': controlValue } };
	        };
	        /**
	         * The form control validator for the date filter.
	         */
	        this._filterValidator = function (control) {
	            var /** @type {?} */ controlValue = _this._getValidDateOrNull(_this._dateAdapter.deserialize(control.value));
	            return !_this._dateFilter || !controlValue || _this._dateFilter(controlValue) ?
	                null : { 'matDatepickerFilter': true };
	        };
	        /**
	         * The combined form control validator for this input.
	         */
	        this._validator = _angular_forms.Validators.compose([this._parseValidator, this._minValidator, this._maxValidator, this._filterValidator]);
	        /**
	         * Whether the last value set on the input was valid.
	         */
	        this._lastValueValid = false;
	        if (!this._dateAdapter) {
	            throw createMissingDateImplError('DateAdapter');
	        }
	        if (!this._dateFormats) {
	            throw createMissingDateImplError('MAT_DATE_FORMATS');
	        }
	        // Update the displayed date when the locale changes.
	        this._localeSubscription = _dateAdapter.localeChanges.subscribe(function () {
	            _this.value = _this.value;
	        });
	    }
	    Object.defineProperty(MatDatepickerInput.prototype, "matDatepicker", {
	        set: /**
	         * The datepicker that this input is associated with.
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this.registerDatepicker(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    MatDatepickerInput.prototype.registerDatepicker = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        if (value) {
	            this._datepicker = value;
	            this._datepicker._registerInput(this);
	        }
	    };
	    Object.defineProperty(MatDatepickerInput.prototype, "matDatepickerFilter", {
	        set: /**
	         * Function that can be used to filter out dates within the datepicker.
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._dateFilter = value;
	            this._validatorOnChange();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDatepickerInput.prototype, "value", {
	        get: /**
	         * The value of the input.
	         * @return {?}
	         */
	        function () { return this._value; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            value = this._dateAdapter.deserialize(value);
	            this._lastValueValid = !value || this._dateAdapter.isValid(value);
	            value = this._getValidDateOrNull(value);
	            var /** @type {?} */ oldDate = this.value;
	            this._value = value;
	            this._elementRef.nativeElement.value =
	                value ? this._dateAdapter.format(value, this._dateFormats.display.dateInput) : '';
	            if (!this._dateAdapter.sameDate(oldDate, value)) {
	                this._valueChange.emit(value);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDatepickerInput.prototype, "min", {
	        get: /**
	         * The minimum valid date.
	         * @return {?}
	         */
	        function () { return this._min; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._min = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
	            this._validatorOnChange();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDatepickerInput.prototype, "max", {
	        get: /**
	         * The maximum valid date.
	         * @return {?}
	         */
	        function () { return this._max; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._max = this._getValidDateOrNull(this._dateAdapter.deserialize(value));
	            this._validatorOnChange();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDatepickerInput.prototype, "disabled", {
	        get: /**
	         * Whether the datepicker-input is disabled.
	         * @return {?}
	         */
	        function () { return !!this._disabled; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            var /** @type {?} */ newValue = _angular_cdk_coercion.coerceBooleanProperty(value);
	            if (this._disabled !== newValue) {
	                this._disabled = newValue;
	                this._disabledChange.emit(newValue);
	            }
	            if (newValue) {
	                // Normally, native input elements automatically blur if they turn disabled. This behavior
	                // is problematic, because it would mean that it triggers another change detection cycle,
	                // which then causes a changed after checked error if the input element was focused before.
	                this._elementRef.nativeElement.blur();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatDatepickerInput.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._datepicker) {
	            this._datepickerSubscription =
	                this._datepicker.selectedChanged.subscribe(function (selected) {
	                    _this.value = selected;
	                    _this._cvaOnChange(selected);
	                    _this._onTouched();
	                    _this.dateInput.emit(new MatDatepickerInputEvent(_this, _this._elementRef.nativeElement));
	                    _this.dateChange.emit(new MatDatepickerInputEvent(_this, _this._elementRef.nativeElement));
	                });
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatDatepickerInput.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._datepickerSubscription.unsubscribe();
	        this._localeSubscription.unsubscribe();
	        this._valueChange.complete();
	        this._disabledChange.complete();
	    };
	    /** @docs-private */
	    /**
	     * \@docs-private
	     * @param {?} fn
	     * @return {?}
	     */
	    MatDatepickerInput.prototype.registerOnValidatorChange = /**
	     * \@docs-private
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._validatorOnChange = fn;
	    };
	    /** @docs-private */
	    /**
	     * \@docs-private
	     * @param {?} c
	     * @return {?}
	     */
	    MatDatepickerInput.prototype.validate = /**
	     * \@docs-private
	     * @param {?} c
	     * @return {?}
	     */
	    function (c) {
	        return this._validator ? this._validator(c) : null;
	    };
	    /**
	     * Gets the element that the datepicker popup should be connected to.
	     * @return The element to connect the popup to.
	     */
	    /**
	     * Gets the element that the datepicker popup should be connected to.
	     * @return {?} The element to connect the popup to.
	     */
	    MatDatepickerInput.prototype.getPopupConnectionElementRef = /**
	     * Gets the element that the datepicker popup should be connected to.
	     * @return {?} The element to connect the popup to.
	     */
	    function () {
	        return this._formField ? this._formField.underlineRef : this._elementRef;
	    };
	    /**
	     * Determines the offset to be used when the calendar goes into a fallback position.
	     * Primarily used to prevent the calendar from overlapping the input.
	     */
	    /**
	     * Determines the offset to be used when the calendar goes into a fallback position.
	     * Primarily used to prevent the calendar from overlapping the input.
	     * @return {?}
	     */
	    MatDatepickerInput.prototype._getPopupFallbackOffset = /**
	     * Determines the offset to be used when the calendar goes into a fallback position.
	     * Primarily used to prevent the calendar from overlapping the input.
	     * @return {?}
	     */
	    function () {
	        return this._formField ? -this._formField._inputContainerRef.nativeElement.clientHeight : 0;
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    MatDatepickerInput.prototype.writeValue = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        this.value = value;
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    MatDatepickerInput.prototype.registerOnChange = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._cvaOnChange = fn;
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} fn
	     * @return {?}
	     */
	    MatDatepickerInput.prototype.registerOnTouched = /**
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._onTouched = fn;
	    };
	    // Implemented as part of ControlValueAccessor.
	    /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    MatDatepickerInput.prototype.setDisabledState = /**
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    function (isDisabled) {
	        this.disabled = isDisabled;
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    MatDatepickerInput.prototype._onKeydown = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (event.altKey && event.keyCode === _angular_cdk_keycodes.DOWN_ARROW) {
	            this._datepicker.open();
	            event.preventDefault();
	        }
	    };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    MatDatepickerInput.prototype._onInput = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        var /** @type {?} */ date = this._dateAdapter.parse(value, this._dateFormats.parse.dateInput);
	        this._lastValueValid = !date || this._dateAdapter.isValid(date);
	        date = this._getValidDateOrNull(date);
	        this._value = date;
	        this._cvaOnChange(date);
	        this._valueChange.emit(date);
	        this.dateInput.emit(new MatDatepickerInputEvent(this, this._elementRef.nativeElement));
	    };
	    /**
	     * @return {?}
	     */
	    MatDatepickerInput.prototype._onChange = /**
	     * @return {?}
	     */
	    function () {
	        this.dateChange.emit(new MatDatepickerInputEvent(this, this._elementRef.nativeElement));
	    };
	    /**
	     * @param {?} obj The object to check.
	     * @return {?} The given object if it is both a date instance and valid, otherwise null.
	     */
	    MatDatepickerInput.prototype._getValidDateOrNull = /**
	     * @param {?} obj The object to check.
	     * @return {?} The given object if it is both a date instance and valid, otherwise null.
	     */
	    function (obj) {
	        return (this._dateAdapter.isDateInstance(obj) && this._dateAdapter.isValid(obj)) ? obj : null;
	    };
	    MatDatepickerInput.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'input[matDatepicker]',
	                    providers: [
	                        MAT_DATEPICKER_VALUE_ACCESSOR,
	                        MAT_DATEPICKER_VALIDATORS,
	                        { provide: MAT_INPUT_VALUE_ACCESSOR, useExisting: MatDatepickerInput },
	                    ],
	                    host: {
	                        '[attr.aria-haspopup]': 'true',
	                        '[attr.aria-owns]': '(_datepicker?.opened && _datepicker.id) || null',
	                        '[attr.min]': 'min ? _dateAdapter.toIso8601(min) : null',
	                        '[attr.max]': 'max ? _dateAdapter.toIso8601(max) : null',
	                        '[disabled]': 'disabled',
	                        '(input)': '_onInput($event.target.value)',
	                        '(change)': '_onChange()',
	                        '(blur)': '_onTouched()',
	                        '(keydown)': '_onKeydown($event)',
	                    },
	                    exportAs: 'matDatepickerInput',
	                },] },
	    ];
	    /** @nocollapse */
	    MatDatepickerInput.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: DateAdapter, decorators: [{ type: _angular_core.Optional },] },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MAT_DATE_FORMATS,] },] },
	        { type: MatFormField, decorators: [{ type: _angular_core.Optional },] },
	    ]; };
	    MatDatepickerInput.propDecorators = {
	        "matDatepicker": [{ type: _angular_core.Input },],
	        "matDatepickerFilter": [{ type: _angular_core.Input },],
	        "value": [{ type: _angular_core.Input },],
	        "min": [{ type: _angular_core.Input },],
	        "max": [{ type: _angular_core.Input },],
	        "disabled": [{ type: _angular_core.Input },],
	        "dateChange": [{ type: _angular_core.Output },],
	        "dateInput": [{ type: _angular_core.Output },],
	    };
	    return MatDatepickerInput;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Can be used to override the icon of a `matDatepickerToggle`.
	 */
	var MatDatepickerToggleIcon = /** @class */ (function () {
	    function MatDatepickerToggleIcon() {
	    }
	    MatDatepickerToggleIcon.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[matDatepickerToggleIcon]'
	                },] },
	    ];
	    /** @nocollapse */
	    MatDatepickerToggleIcon.ctorParameters = function () { return []; };
	    return MatDatepickerToggleIcon;
	}());
	var MatDatepickerToggle = /** @class */ (function () {
	    function MatDatepickerToggle(_intl, _changeDetectorRef) {
	        this._intl = _intl;
	        this._changeDetectorRef = _changeDetectorRef;
	        this._stateChanges = rxjs_Subscription.Subscription.EMPTY;
	    }
	    Object.defineProperty(MatDatepickerToggle.prototype, "disabled", {
	        get: /**
	         * Whether the toggle button is disabled.
	         * @return {?}
	         */
	        function () {
	            return this._disabled === undefined ? this.datepicker.disabled : !!this._disabled;
	        },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._disabled = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    MatDatepickerToggle.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        if (changes["datepicker"]) {
	            this._watchStateChanges();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatDatepickerToggle.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._stateChanges.unsubscribe();
	    };
	    /**
	     * @return {?}
	     */
	    MatDatepickerToggle.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        this._watchStateChanges();
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    MatDatepickerToggle.prototype._open = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (this.datepicker && !this.disabled) {
	            this.datepicker.open();
	            event.stopPropagation();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatDatepickerToggle.prototype._watchStateChanges = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ datepickerDisabled = this.datepicker ? this.datepicker._disabledChange : rxjs_observable_of.of();
	        var /** @type {?} */ inputDisabled = this.datepicker && this.datepicker._datepickerInput ?
	            this.datepicker._datepickerInput._disabledChange : rxjs_observable_of.of();
	        var /** @type {?} */ datepickerToggled = this.datepicker ?
	            rxjs_observable_merge.merge(this.datepicker.openedStream, this.datepicker.closedStream) :
	            rxjs_observable_of.of();
	        this._stateChanges.unsubscribe();
	        this._stateChanges = rxjs_observable_merge.merge(this._intl.changes, datepickerDisabled, inputDisabled, datepickerToggled).subscribe(function () { return _this._changeDetectorRef.markForCheck(); });
	    };
	    MatDatepickerToggle.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-datepicker-toggle',
	                    template: "<button mat-icon-button type=\"button\" [attr.aria-label]=\"_intl.openCalendarLabel\" [disabled]=\"disabled\" (click)=\"_open($event)\"><svg *ngIf=\"!_customIcon\" class=\"mat-datepicker-toggle-default-icon\" viewBox=\"0 0 24 24\" width=\"24px\" height=\"24px\" fill=\"currentColor\" focusable=\"false\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z\"/></svg><ng-content select=\"[matDatepickerToggleIcon]\"></ng-content></button>",
	                    styles: [".mat-form-field-prefix .mat-datepicker-toggle-default-icon,.mat-form-field-suffix .mat-datepicker-toggle-default-icon{width:1em}"],
	                    host: {
	                        'class': 'mat-datepicker-toggle',
	                        '[class.mat-datepicker-toggle-active]': 'datepicker && datepicker.opened',
	                    },
	                    exportAs: 'matDatepickerToggle',
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatDatepickerToggle.ctorParameters = function () { return [
	        { type: MatDatepickerIntl, },
	        { type: _angular_core.ChangeDetectorRef, },
	    ]; };
	    MatDatepickerToggle.propDecorators = {
	        "datepicker": [{ type: _angular_core.Input, args: ['for',] },],
	        "disabled": [{ type: _angular_core.Input },],
	        "_customIcon": [{ type: _angular_core.ContentChild, args: [MatDatepickerToggleIcon,] },],
	    };
	    return MatDatepickerToggle;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatDatepickerModule = /** @class */ (function () {
	    function MatDatepickerModule() {
	    }
	    MatDatepickerModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [
	                        _angular_common.CommonModule,
	                        MatButtonModule,
	                        MatDialogModule,
	                        _angular_cdk_overlay.OverlayModule,
	                        _angular_cdk_a11y.A11yModule,
	                    ],
	                    exports: [
	                        MatCalendar,
	                        MatCalendarBody,
	                        MatDatepicker,
	                        MatDatepickerContent,
	                        MatDatepickerInput,
	                        MatDatepickerToggle,
	                        MatDatepickerToggleIcon,
	                        MatMonthView,
	                        MatYearView,
	                        MatMultiYearView,
	                    ],
	                    declarations: [
	                        MatCalendar,
	                        MatCalendarBody,
	                        MatDatepicker,
	                        MatDatepickerContent,
	                        MatDatepickerInput,
	                        MatDatepickerToggle,
	                        MatDatepickerToggleIcon,
	                        MatMonthView,
	                        MatYearView,
	                        MatMultiYearView,
	                    ],
	                    providers: [
	                        MatDatepickerIntl,
	                        MAT_DATEPICKER_SCROLL_STRATEGY_PROVIDER,
	                    ],
	                    entryComponents: [
	                        MatDatepickerContent,
	                    ]
	                },] },
	    ];
	    /** @nocollapse */
	    MatDatepickerModule.ctorParameters = function () { return []; };
	    return MatDatepickerModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatDivider = /** @class */ (function () {
	    function MatDivider() {
	        this._vertical = false;
	        this._inset = false;
	    }
	    Object.defineProperty(MatDivider.prototype, "vertical", {
	        get: /**
	         * Whether the divider is vertically aligned.
	         * @return {?}
	         */
	        function () { return this._vertical; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._vertical = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDivider.prototype, "inset", {
	        get: /**
	         * Whether the divider is an inset divider.
	         * @return {?}
	         */
	        function () { return this._inset; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._inset = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    MatDivider.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-divider',
	                    host: {
	                        'role': 'separator',
	                        '[attr.aria-orientation]': 'vertical ? "vertical" : "horizontal"',
	                        '[class.mat-divider-vertical]': 'vertical',
	                        '[class.mat-divider-inset]': 'inset',
	                        'class': 'mat-divider'
	                    },
	                    template: '',
	                    styles: [".mat-divider{display:block;margin:0;border-top-width:1px;border-top-style:solid}.mat-divider.mat-divider-vertical{border-top:0;border-right-width:1px;border-right-style:solid}.mat-divider.mat-divider-inset{margin-left:80px}[dir=rtl] .mat-divider.mat-divider-inset{margin-left:auto;margin-right:80px}"],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    preserveWhitespaces: false,
	                },] },
	    ];
	    /** @nocollapse */
	    MatDivider.ctorParameters = function () { return []; };
	    MatDivider.propDecorators = {
	        "vertical": [{ type: _angular_core.Input },],
	        "inset": [{ type: _angular_core.Input },],
	    };
	    return MatDivider;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatDividerModule = /** @class */ (function () {
	    function MatDividerModule() {
	    }
	    MatDividerModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [MatCommonModule, _angular_common.CommonModule],
	                    exports: [
	                        MatDivider,
	                        MatCommonModule,
	                    ],
	                    declarations: [
	                        MatDivider,
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    MatDividerModule.ctorParameters = function () { return []; };
	    return MatDividerModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Directive for a Material Design Accordion.
	 */
	var MatAccordion = /** @class */ (function (_super) {
	    __extends(MatAccordion, _super);
	    function MatAccordion() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._hideToggle = false;
	        /**
	         * The display mode used for all expansion panels in the accordion. Currently two display
	         * modes exist:
	         *   default - a gutter-like spacing is placed around any expanded panel, placing the expanded
	         *     panel at a different elevation from the reset of the accordion.
	         *  flat - no spacing is placed around expanded panels, showing all panels at the same
	         *     elevation.
	         */
	        _this.displayMode = 'default';
	        return _this;
	    }
	    Object.defineProperty(MatAccordion.prototype, "hideToggle", {
	        get: /**
	         * Whether the expansion indicator should be hidden.
	         * @return {?}
	         */
	        function () { return this._hideToggle; },
	        set: /**
	         * @param {?} show
	         * @return {?}
	         */
	        function (show) { this._hideToggle = _angular_cdk_coercion.coerceBooleanProperty(show); },
	        enumerable: true,
	        configurable: true
	    });
	    MatAccordion.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-accordion',
	                    exportAs: 'matAccordion',
	                    host: {
	                        class: 'mat-accordion'
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatAccordion.ctorParameters = function () { return []; };
	    MatAccordion.propDecorators = {
	        "hideToggle": [{ type: _angular_core.Input },],
	        "displayMode": [{ type: _angular_core.Input },],
	    };
	    return MatAccordion;
	}(_angular_cdk_accordion.CdkAccordion));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Expansion panel content that will be rendered lazily
	 * after the panel is opened for the first time.
	 */
	var MatExpansionPanelContent = /** @class */ (function () {
	    function MatExpansionPanelContent(_template) {
	        this._template = _template;
	    }
	    MatExpansionPanelContent.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'ng-template[matExpansionPanelContent]'
	                },] },
	    ];
	    /** @nocollapse */
	    MatExpansionPanelContent.ctorParameters = function () { return [
	        { type: _angular_core.TemplateRef, },
	    ]; };
	    return MatExpansionPanelContent;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * Time and timing curve for expansion panel animations.
	 */
	var EXPANSION_PANEL_ANIMATION_TIMING = '225ms cubic-bezier(0.4,0.0,0.2,1)';
	/**
	 * Animations used by the Material expansion panel.
	 */
	var matExpansionAnimations = {
	    /** Animation that rotates the indicator arrow. */
	    indicatorRotate: _angular_animations.trigger('indicatorRotate', [
	        _angular_animations.state('collapsed', _angular_animations.style({ transform: 'rotate(0deg)' })),
	        _angular_animations.state('expanded', _angular_animations.style({ transform: 'rotate(180deg)' })),
	        _angular_animations.transition('expanded <=> collapsed', _angular_animations.animate(EXPANSION_PANEL_ANIMATION_TIMING)),
	    ]),
	    /** Animation that expands and collapses the panel header height. */
	    expansionHeaderHeight: _angular_animations.trigger('expansionHeight', [
	        _angular_animations.state('collapsed', _angular_animations.style({
	            height: '{{collapsedHeight}}',
	        }), {
	            params: { collapsedHeight: '48px' },
	        }),
	        _angular_animations.state('expanded', _angular_animations.style({
	            height: '{{expandedHeight}}'
	        }), {
	            params: { expandedHeight: '64px' }
	        }),
	        _angular_animations.transition('expanded <=> collapsed', _angular_animations.animate(EXPANSION_PANEL_ANIMATION_TIMING)),
	    ]),
	    /** Animation that expands and collapses the panel content. */
	    bodyExpansion: _angular_animations.trigger('bodyExpansion', [
	        _angular_animations.state('collapsed', _angular_animations.style({ height: '0px', visibility: 'hidden' })),
	        _angular_animations.state('expanded', _angular_animations.style({ height: '*', visibility: 'visible' })),
	        _angular_animations.transition('expanded <=> collapsed', _angular_animations.animate(EXPANSION_PANEL_ANIMATION_TIMING)),
	    ])
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Counter for generating unique element ids.
	 */
	var uniqueId$1 = 0;
	/**
	 * `<mat-expansion-panel>`
	 *
	 * This component can be used as a single element to show expandable content, or as one of
	 * multiple children of an element with the MdAccordion directive attached.
	 */
	var MatExpansionPanel = /** @class */ (function (_super) {
	    __extends(MatExpansionPanel, _super);
	    function MatExpansionPanel(accordion, _changeDetectorRef, _uniqueSelectionDispatcher, _viewContainerRef) {
	        var _this = _super.call(this, accordion, _changeDetectorRef, _uniqueSelectionDispatcher) || this;
	        _this._viewContainerRef = _viewContainerRef;
	        _this._hideToggle = false;
	        /**
	         * Stream that emits for changes in `\@Input` properties.
	         */
	        _this._inputChanges = new rxjs_Subject.Subject();
	        /**
	         * ID for the associated header element. Used for a11y labelling.
	         */
	        _this._headerId = "mat-expansion-panel-header-" + uniqueId$1++;
	        _this.accordion = accordion;
	        return _this;
	    }
	    Object.defineProperty(MatExpansionPanel.prototype, "hideToggle", {
	        get: /**
	         * Whether the toggle indicator should be hidden.
	         * @return {?}
	         */
	        function () { return this._hideToggle; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._hideToggle = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** Whether the expansion indicator should be hidden. */
	    /**
	     * Whether the expansion indicator should be hidden.
	     * @return {?}
	     */
	    MatExpansionPanel.prototype._getHideToggle = /**
	     * Whether the expansion indicator should be hidden.
	     * @return {?}
	     */
	    function () {
	        if (this.accordion) {
	            return this.accordion.hideToggle;
	        }
	        return this.hideToggle;
	    };
	    /** Determines whether the expansion panel should have spacing between it and its siblings. */
	    /**
	     * Determines whether the expansion panel should have spacing between it and its siblings.
	     * @return {?}
	     */
	    MatExpansionPanel.prototype._hasSpacing = /**
	     * Determines whether the expansion panel should have spacing between it and its siblings.
	     * @return {?}
	     */
	    function () {
	        if (this.accordion) {
	            return (this.expanded ? this.accordion.displayMode : this._getExpandedState()) === 'default';
	        }
	        return false;
	    };
	    /** Gets the expanded state string. */
	    /**
	     * Gets the expanded state string.
	     * @return {?}
	     */
	    MatExpansionPanel.prototype._getExpandedState = /**
	     * Gets the expanded state string.
	     * @return {?}
	     */
	    function () {
	        return this.expanded ? 'expanded' : 'collapsed';
	    };
	    /**
	     * @return {?}
	     */
	    MatExpansionPanel.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._lazyContent) {
	            // Render the content as soon as the panel becomes open.
	            this.opened.pipe(rxjs_operators_startWith.startWith(/** @type {?} */ ((null))), rxjs_operators_filter.filter(function () { return _this.expanded && !_this._portal; }), rxjs_operators_take.take(1)).subscribe(function () {
	                _this._portal = new _angular_cdk_portal.TemplatePortal(_this._lazyContent._template, _this._viewContainerRef);
	            });
	        }
	    };
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    MatExpansionPanel.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        this._inputChanges.next(changes);
	    };
	    /**
	     * @return {?}
	     */
	    MatExpansionPanel.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        _super.prototype.ngOnDestroy.call(this);
	        this._inputChanges.complete();
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    MatExpansionPanel.prototype._bodyAnimation = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var /** @type {?} */ classList = event.element.classList;
	        var /** @type {?} */ cssClass = 'mat-expanded';
	        var phaseName = event.phaseName, toState = event.toState;
	        // Toggle the body's `overflow: hidden` class when closing starts or when expansion ends in
	        // order to prevent the cases where switching too early would cause the animation to jump.
	        // Note that we do it directly on the DOM element to avoid the slight delay that comes
	        // with doing it via change detection.
	        if (phaseName === 'done' && toState === 'expanded') {
	            classList.add(cssClass);
	        }
	        else if (phaseName === 'start' && toState === 'collapsed') {
	            classList.remove(cssClass);
	        }
	    };
	    MatExpansionPanel.decorators = [
	        { type: _angular_core.Component, args: [{styles: [".mat-expansion-panel{transition:box-shadow 280ms cubic-bezier(.4,0,.2,1);box-sizing:content-box;display:block;margin:0;transition:margin 225ms cubic-bezier(.4,0,.2,1)}.mat-expansion-panel:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.mat-expansion-panel-content{overflow:hidden}.mat-expansion-panel-content.mat-expanded{overflow:visible}.mat-expansion-panel-body{padding:0 24px 16px}.mat-expansion-panel-spacing{margin:16px 0}.mat-accordion .mat-expansion-panel-spacing:first-child{margin-top:0}.mat-accordion .mat-expansion-panel-spacing:last-child{margin-bottom:0}.mat-action-row{border-top-style:solid;border-top-width:1px;display:flex;flex-direction:row;justify-content:flex-end;padding:16px 8px 16px 24px}.mat-action-row button.mat-button{margin-left:8px}[dir=rtl] .mat-action-row button.mat-button{margin-left:0;margin-right:8px}"],
	                    selector: 'mat-expansion-panel',
	                    exportAs: 'matExpansionPanel',
	                    template: "<ng-content select=\"mat-expansion-panel-header\"></ng-content><div class=\"mat-expansion-panel-content\" role=\"region\" [@bodyExpansion]=\"_getExpandedState()\" (@bodyExpansion.done)=\"_bodyAnimation($event)\" (@bodyExpansion.start)=\"_bodyAnimation($event)\" [attr.aria-labelledby]=\"_headerId\" [id]=\"id\" #body><div class=\"mat-expansion-panel-body\"><ng-content></ng-content><ng-template [cdkPortalOutlet]=\"_portal\"></ng-template></div><ng-content select=\"mat-action-row\"></ng-content></div>",
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    inputs: ['disabled', 'expanded'],
	                    outputs: ['opened', 'closed', 'expandedChange'],
	                    animations: [matExpansionAnimations.bodyExpansion],
	                    host: {
	                        'class': 'mat-expansion-panel',
	                        '[class.mat-expanded]': 'expanded',
	                        '[class.mat-expansion-panel-spacing]': '_hasSpacing()',
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatExpansionPanel.ctorParameters = function () { return [
	        { type: MatAccordion, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host },] },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: _angular_cdk_collections.UniqueSelectionDispatcher, },
	        { type: _angular_core.ViewContainerRef, },
	    ]; };
	    MatExpansionPanel.propDecorators = {
	        "hideToggle": [{ type: _angular_core.Input },],
	        "_lazyContent": [{ type: _angular_core.ContentChild, args: [MatExpansionPanelContent,] },],
	    };
	    return MatExpansionPanel;
	}(_angular_cdk_accordion.CdkAccordionItem));
	var MatExpansionPanelActionRow = /** @class */ (function () {
	    function MatExpansionPanelActionRow() {
	    }
	    MatExpansionPanelActionRow.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-action-row',
	                    host: {
	                        class: 'mat-action-row'
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatExpansionPanelActionRow.ctorParameters = function () { return []; };
	    return MatExpansionPanelActionRow;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * `<mat-expansion-panel-header>`
	 *
	 * This component corresponds to the header element of an `<mat-expansion-panel>`.
	 */
	var MatExpansionPanelHeader = /** @class */ (function () {
	    function MatExpansionPanelHeader(panel, _element, _focusMonitor, _changeDetectorRef) {
	        var _this = this;
	        this.panel = panel;
	        this._element = _element;
	        this._focusMonitor = _focusMonitor;
	        this._changeDetectorRef = _changeDetectorRef;
	        this._parentChangeSubscription = rxjs_Subscription.Subscription.EMPTY;
	        // Since the toggle state depends on an @Input on the panel, we
	        // need to  subscribe and trigger change detection manually.
	        this._parentChangeSubscription = rxjs_observable_merge.merge(panel.opened, panel.closed, panel._inputChanges.pipe(rxjs_operators_filter.filter(function (changes) { return !!(changes["hideToggle"] || changes["disabled"]); })))
	            .subscribe(function () { return _this._changeDetectorRef.markForCheck(); });
	        _focusMonitor.monitor(_element.nativeElement);
	    }
	    /** Toggles the expanded state of the panel. */
	    /**
	     * Toggles the expanded state of the panel.
	     * @return {?}
	     */
	    MatExpansionPanelHeader.prototype._toggle = /**
	     * Toggles the expanded state of the panel.
	     * @return {?}
	     */
	    function () {
	        this.panel.toggle();
	    };
	    /** Gets whether the panel is expanded. */
	    /**
	     * Gets whether the panel is expanded.
	     * @return {?}
	     */
	    MatExpansionPanelHeader.prototype._isExpanded = /**
	     * Gets whether the panel is expanded.
	     * @return {?}
	     */
	    function () {
	        return this.panel.expanded;
	    };
	    /** Gets the expanded state string of the panel. */
	    /**
	     * Gets the expanded state string of the panel.
	     * @return {?}
	     */
	    MatExpansionPanelHeader.prototype._getExpandedState = /**
	     * Gets the expanded state string of the panel.
	     * @return {?}
	     */
	    function () {
	        return this.panel._getExpandedState();
	    };
	    /** Gets the panel id. */
	    /**
	     * Gets the panel id.
	     * @return {?}
	     */
	    MatExpansionPanelHeader.prototype._getPanelId = /**
	     * Gets the panel id.
	     * @return {?}
	     */
	    function () {
	        return this.panel.id;
	    };
	    /** Gets whether the expand indicator should be shown. */
	    /**
	     * Gets whether the expand indicator should be shown.
	     * @return {?}
	     */
	    MatExpansionPanelHeader.prototype._showToggle = /**
	     * Gets whether the expand indicator should be shown.
	     * @return {?}
	     */
	    function () {
	        return !this.panel.hideToggle && !this.panel.disabled;
	    };
	    /** Handle keydown event calling to toggle() if appropriate. */
	    /**
	     * Handle keydown event calling to toggle() if appropriate.
	     * @param {?} event
	     * @return {?}
	     */
	    MatExpansionPanelHeader.prototype._keydown = /**
	     * Handle keydown event calling to toggle() if appropriate.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        switch (event.keyCode) {
	            // Toggle for space and enter keys.
	            case _angular_cdk_keycodes.SPACE:
	            case _angular_cdk_keycodes.ENTER:
	                event.preventDefault();
	                this._toggle();
	                break;
	            default:
	                return;
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatExpansionPanelHeader.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._parentChangeSubscription.unsubscribe();
	        this._focusMonitor.stopMonitoring(this._element.nativeElement);
	    };
	    MatExpansionPanelHeader.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-expansion-panel-header',
	                    styles: [".mat-expansion-panel-header{display:flex;flex-direction:row;align-items:center;padding:0 24px}.mat-expansion-panel-header:focus,.mat-expansion-panel-header:hover{outline:0}.mat-expansion-panel-header.mat-expanded:focus,.mat-expansion-panel-header.mat-expanded:hover{background:inherit}.mat-expansion-panel-header:not([aria-disabled=true]){cursor:pointer}.mat-content{display:flex;flex:1;flex-direction:row;overflow:hidden}.mat-expansion-panel-header-description,.mat-expansion-panel-header-title{display:flex;flex-grow:1;margin-right:16px}[dir=rtl] .mat-expansion-panel-header-description,[dir=rtl] .mat-expansion-panel-header-title{margin-right:0;margin-left:16px}.mat-expansion-panel-header-description{flex-grow:2}.mat-expansion-indicator::after{border-style:solid;border-width:0 2px 2px 0;content:'';display:inline-block;padding:3px;transform:rotate(45deg);vertical-align:middle}"],
	                    template: "<span class=\"mat-content\"><ng-content select=\"mat-panel-title\"></ng-content><ng-content select=\"mat-panel-description\"></ng-content><ng-content></ng-content></span><span [@indicatorRotate]=\"_getExpandedState()\" *ngIf=\"_showToggle()\" class=\"mat-expansion-indicator\"></span>",
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    animations: [
	                        matExpansionAnimations.indicatorRotate,
	                        matExpansionAnimations.expansionHeaderHeight
	                    ],
	                    host: {
	                        'class': 'mat-expansion-panel-header',
	                        'role': 'button',
	                        '[attr.id]': 'panel._headerId',
	                        '[attr.tabindex]': 'panel.disabled ? -1 : 0',
	                        '[attr.aria-controls]': '_getPanelId()',
	                        '[attr.aria-expanded]': '_isExpanded()',
	                        '[attr.aria-disabled]': 'panel.disabled',
	                        '[class.mat-expanded]': '_isExpanded()',
	                        '(click)': '_toggle()',
	                        '(keydown)': '_keydown($event)',
	                        '[@expansionHeight]': "{\n        value: _getExpandedState(),\n        params: {\n          collapsedHeight: collapsedHeight,\n          expandedHeight: expandedHeight\n        }\n    }",
	                    },
	                },] },
	    ];
	    /** @nocollapse */
	    MatExpansionPanelHeader.ctorParameters = function () { return [
	        { type: MatExpansionPanel, decorators: [{ type: _angular_core.Host },] },
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_a11y.FocusMonitor, },
	        { type: _angular_core.ChangeDetectorRef, },
	    ]; };
	    MatExpansionPanelHeader.propDecorators = {
	        "expandedHeight": [{ type: _angular_core.Input },],
	        "collapsedHeight": [{ type: _angular_core.Input },],
	    };
	    return MatExpansionPanelHeader;
	}());
	/**
	 * `<mat-panel-description>`
	 *
	 * This direction is to be used inside of the MatExpansionPanelHeader component.
	 */
	var MatExpansionPanelDescription = /** @class */ (function () {
	    function MatExpansionPanelDescription() {
	    }
	    MatExpansionPanelDescription.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-panel-description',
	                    host: {
	                        class: 'mat-expansion-panel-header-description'
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatExpansionPanelDescription.ctorParameters = function () { return []; };
	    return MatExpansionPanelDescription;
	}());
	/**
	 * `<mat-panel-title>`
	 *
	 * This direction is to be used inside of the MatExpansionPanelHeader component.
	 */
	var MatExpansionPanelTitle = /** @class */ (function () {
	    function MatExpansionPanelTitle() {
	    }
	    MatExpansionPanelTitle.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-panel-title',
	                    host: {
	                        class: 'mat-expansion-panel-header-title'
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatExpansionPanelTitle.ctorParameters = function () { return []; };
	    return MatExpansionPanelTitle;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatExpansionModule = /** @class */ (function () {
	    function MatExpansionModule() {
	    }
	    MatExpansionModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [_angular_common.CommonModule, _angular_cdk_a11y.A11yModule, _angular_cdk_accordion.CdkAccordionModule, _angular_cdk_portal.PortalModule],
	                    exports: [
	                        MatAccordion,
	                        MatExpansionPanel,
	                        MatExpansionPanelActionRow,
	                        MatExpansionPanelHeader,
	                        MatExpansionPanelTitle,
	                        MatExpansionPanelDescription,
	                        MatExpansionPanelContent,
	                    ],
	                    declarations: [
	                        MatAccordion,
	                        MatExpansionPanel,
	                        MatExpansionPanelActionRow,
	                        MatExpansionPanelHeader,
	                        MatExpansionPanelTitle,
	                        MatExpansionPanelDescription,
	                        MatExpansionPanelContent,
	                    ],
	                    providers: [_angular_cdk_collections.UNIQUE_SELECTION_DISPATCHER_PROVIDER]
	                },] },
	    ];
	    /** @nocollapse */
	    MatExpansionModule.ctorParameters = function () { return []; };
	    return MatExpansionModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Converts values into strings. Falsy values become empty strings.
	 * \@docs-private
	 * @param {?} value
	 * @return {?}
	 */
	function coerceToString(value) {
	    return "" + (value || '');
	}
	/**
	 * Converts a value that might be a string into a number.
	 * \@docs-private
	 * @param {?} value
	 * @return {?}
	 */
	function coerceToNumber(value) {
	    return typeof value === 'string' ? parseInt(value, 10) : value;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatGridTile = /** @class */ (function () {
	    function MatGridTile(_element) {
	        this._element = _element;
	        this._rowspan = 1;
	        this._colspan = 1;
	    }
	    Object.defineProperty(MatGridTile.prototype, "rowspan", {
	        get: /**
	         * Amount of rows that the grid tile takes up.
	         * @return {?}
	         */
	        function () { return this._rowspan; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._rowspan = coerceToNumber(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatGridTile.prototype, "colspan", {
	        get: /**
	         * Amount of columns that the grid tile takes up.
	         * @return {?}
	         */
	        function () { return this._colspan; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._colspan = coerceToNumber(value); },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Sets the style of the grid-tile element.  Needs to be set manually to avoid
	     * "Changed after checked" errors that would occur with HostBinding.
	     */
	    /**
	     * Sets the style of the grid-tile element.  Needs to be set manually to avoid
	     * "Changed after checked" errors that would occur with HostBinding.
	     * @param {?} property
	     * @param {?} value
	     * @return {?}
	     */
	    MatGridTile.prototype._setStyle = /**
	     * Sets the style of the grid-tile element.  Needs to be set manually to avoid
	     * "Changed after checked" errors that would occur with HostBinding.
	     * @param {?} property
	     * @param {?} value
	     * @return {?}
	     */
	    function (property, value) {
	        this._element.nativeElement.style[property] = value;
	    };
	    MatGridTile.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-grid-tile',
	                    exportAs: 'matGridTile',
	                    host: {
	                        'class': 'mat-grid-tile',
	                    },
	                    template: "<figure class=\"mat-figure\"><ng-content></ng-content></figure>",
	                    styles: [".mat-grid-list{display:block;position:relative}.mat-grid-tile{display:block;position:absolute;overflow:hidden}.mat-grid-tile .mat-figure{top:0;left:0;right:0;bottom:0;position:absolute;display:flex;align-items:center;justify-content:center;height:100%;padding:0;margin:0}.mat-grid-tile .mat-grid-tile-footer,.mat-grid-tile .mat-grid-tile-header{display:flex;align-items:center;height:48px;color:#fff;background:rgba(0,0,0,.38);overflow:hidden;padding:0 16px;position:absolute;left:0;right:0}.mat-grid-tile .mat-grid-tile-footer>*,.mat-grid-tile .mat-grid-tile-header>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-grid-tile .mat-grid-tile-footer.mat-2-line,.mat-grid-tile .mat-grid-tile-header.mat-2-line{height:68px}.mat-grid-tile .mat-grid-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden}.mat-grid-tile .mat-grid-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-grid-tile .mat-grid-list-text:empty{display:none}.mat-grid-tile .mat-grid-tile-header{top:0}.mat-grid-tile .mat-grid-tile-footer{bottom:0}.mat-grid-tile .mat-grid-avatar{padding-right:16px}[dir=rtl] .mat-grid-tile .mat-grid-avatar{padding-right:0;padding-left:16px}.mat-grid-tile .mat-grid-avatar:empty{display:none}"],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatGridTile.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	    ]; };
	    MatGridTile.propDecorators = {
	        "rowspan": [{ type: _angular_core.Input },],
	        "colspan": [{ type: _angular_core.Input },],
	    };
	    return MatGridTile;
	}());
	var MatGridTileText = /** @class */ (function () {
	    function MatGridTileText(_element) {
	        this._element = _element;
	    }
	    /**
	     * @return {?}
	     */
	    MatGridTileText.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        this._lineSetter = new MatLineSetter(this._lines, this._element);
	    };
	    MatGridTileText.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-grid-tile-header, mat-grid-tile-footer',
	                    template: "<ng-content select=\"[mat-grid-avatar], [matGridAvatar]\"></ng-content><div class=\"mat-grid-list-text\"><ng-content select=\"[mat-line], [matLine]\"></ng-content></div><ng-content></ng-content>",
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                },] },
	    ];
	    /** @nocollapse */
	    MatGridTileText.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	    ]; };
	    MatGridTileText.propDecorators = {
	        "_lines": [{ type: _angular_core.ContentChildren, args: [MatLine,] },],
	    };
	    return MatGridTileText;
	}());
	/**
	 * Directive whose purpose is to add the mat- CSS styling to this selector.
	 * \@docs-private
	 */
	var MatGridAvatarCssMatStyler = /** @class */ (function () {
	    function MatGridAvatarCssMatStyler() {
	    }
	    MatGridAvatarCssMatStyler.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-grid-avatar], [matGridAvatar]',
	                    host: { 'class': 'mat-grid-avatar' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatGridAvatarCssMatStyler.ctorParameters = function () { return []; };
	    return MatGridAvatarCssMatStyler;
	}());
	/**
	 * Directive whose purpose is to add the mat- CSS styling to this selector.
	 * \@docs-private
	 */
	var MatGridTileHeaderCssMatStyler = /** @class */ (function () {
	    function MatGridTileHeaderCssMatStyler() {
	    }
	    MatGridTileHeaderCssMatStyler.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-grid-tile-header',
	                    host: { 'class': 'mat-grid-tile-header' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatGridTileHeaderCssMatStyler.ctorParameters = function () { return []; };
	    return MatGridTileHeaderCssMatStyler;
	}());
	/**
	 * Directive whose purpose is to add the mat- CSS styling to this selector.
	 * \@docs-private
	 */
	var MatGridTileFooterCssMatStyler = /** @class */ (function () {
	    function MatGridTileFooterCssMatStyler() {
	    }
	    MatGridTileFooterCssMatStyler.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-grid-tile-footer',
	                    host: { 'class': 'mat-grid-tile-footer' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatGridTileFooterCssMatStyler.ctorParameters = function () { return []; };
	    return MatGridTileFooterCssMatStyler;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Class for determining, from a list of tiles, the (row, col) position of each of those tiles
	 * in the grid. This is necessary (rather than just rendering the tiles in normal document flow)
	 * because the tiles can have a rowspan.
	 *
	 * The positioning algorithm greedily places each tile as soon as it encounters a gap in the grid
	 * large enough to accommodate it so that the tiles still render in the same order in which they
	 * are given.
	 *
	 * The basis of the algorithm is the use of an array to track the already placed tiles. Each
	 * element of the array corresponds to a column, and the value indicates how many cells in that
	 * column are already occupied; zero indicates an empty cell. Moving "down" to the next row
	 * decrements each value in the tracking array (indicating that the column is one cell closer to
	 * being free).
	 *
	 * \@docs-private
	 */
	var TileCoordinator = /** @class */ (function () {
	    function TileCoordinator(numColumns, tiles) {
	        var _this = this;
	        /**
	         * Index at which the search for the next gap will start.
	         */
	        this.columnIndex = 0;
	        /**
	         * The current row index.
	         */
	        this.rowIndex = 0;
	        this.tracker = new Array(numColumns);
	        this.tracker.fill(0, 0, this.tracker.length);
	        this.positions = tiles.map(function (tile) { return _this._trackTile(tile); });
	    }
	    Object.defineProperty(TileCoordinator.prototype, "rowCount", {
	        /** Gets the total number of rows occupied by tiles */
	        get: /**
	         * Gets the total number of rows occupied by tiles
	         * @return {?}
	         */
	        function () { return this.rowIndex + 1; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TileCoordinator.prototype, "rowspan", {
	        /**
	         * Gets the total span of rows occupied by tiles.
	         * Ex: A list with 1 row that contains a tile with rowspan 2 will have a total rowspan of 2.
	         */
	        get: /**
	         * Gets the total span of rows occupied by tiles.
	         * Ex: A list with 1 row that contains a tile with rowspan 2 will have a total rowspan of 2.
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ lastRowMax = Math.max.apply(Math, this.tracker);
	            // if any of the tiles has a rowspan that pushes it beyond the total row count,
	            // add the difference to the rowcount
	            return lastRowMax > 1 ? this.rowCount + lastRowMax - 1 : this.rowCount;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Calculates the row and col position of a tile.
	     * @param {?} tile
	     * @return {?}
	     */
	    TileCoordinator.prototype._trackTile = /**
	     * Calculates the row and col position of a tile.
	     * @param {?} tile
	     * @return {?}
	     */
	    function (tile) {
	        // Find a gap large enough for this tile.
	        var /** @type {?} */ gapStartIndex = this._findMatchingGap(tile.colspan);
	        // Place tile in the resulting gap.
	        this._markTilePosition(gapStartIndex, tile);
	        // The next time we look for a gap, the search will start at columnIndex, which should be
	        // immediately after the tile that has just been placed.
	        this.columnIndex = gapStartIndex + tile.colspan;
	        return new TilePosition(this.rowIndex, gapStartIndex);
	    };
	    /**
	     * Finds the next available space large enough to fit the tile.
	     * @param {?} tileCols
	     * @return {?}
	     */
	    TileCoordinator.prototype._findMatchingGap = /**
	     * Finds the next available space large enough to fit the tile.
	     * @param {?} tileCols
	     * @return {?}
	     */
	    function (tileCols) {
	        if (tileCols > this.tracker.length) {
	            throw Error("mat-grid-list: tile with colspan " + tileCols + " is wider than " +
	                ("grid with cols=\"" + this.tracker.length + "\"."));
	        }
	        // Start index is inclusive, end index is exclusive.
	        var /** @type {?} */ gapStartIndex = -1;
	        var /** @type {?} */ gapEndIndex = -1;
	        // Look for a gap large enough to fit the given tile. Empty spaces are marked with a zero.
	        do {
	            // If we've reached the end of the row, go to the next row.
	            if (this.columnIndex + tileCols > this.tracker.length) {
	                this._nextRow();
	                continue;
	            }
	            gapStartIndex = this.tracker.indexOf(0, this.columnIndex);
	            // If there are no more empty spaces in this row at all, move on to the next row.
	            if (gapStartIndex == -1) {
	                this._nextRow();
	                continue;
	            }
	            gapEndIndex = this._findGapEndIndex(gapStartIndex);
	            // If a gap large enough isn't found, we want to start looking immediately after the current
	            // gap on the next iteration.
	            this.columnIndex = gapStartIndex + 1;
	            // Continue iterating until we find a gap wide enough for this tile.
	        } while (gapEndIndex - gapStartIndex < tileCols);
	        // If we still didn't manage to find a gap, ensure that the index is
	        // at least zero so the tile doesn't get pulled out of the grid.
	        return Math.max(gapStartIndex, 0);
	    };
	    /**
	     * Move "down" to the next row.
	     * @return {?}
	     */
	    TileCoordinator.prototype._nextRow = /**
	     * Move "down" to the next row.
	     * @return {?}
	     */
	    function () {
	        this.columnIndex = 0;
	        this.rowIndex++;
	        // Decrement all spaces by one to reflect moving down one row.
	        for (var /** @type {?} */ i = 0; i < this.tracker.length; i++) {
	            this.tracker[i] = Math.max(0, this.tracker[i] - 1);
	        }
	    };
	    /**
	     * Finds the end index (exclusive) of a gap given the index from which to start looking.
	     * The gap ends when a non-zero value is found.
	     * @param {?} gapStartIndex
	     * @return {?}
	     */
	    TileCoordinator.prototype._findGapEndIndex = /**
	     * Finds the end index (exclusive) of a gap given the index from which to start looking.
	     * The gap ends when a non-zero value is found.
	     * @param {?} gapStartIndex
	     * @return {?}
	     */
	    function (gapStartIndex) {
	        for (var /** @type {?} */ i = gapStartIndex + 1; i < this.tracker.length; i++) {
	            if (this.tracker[i] != 0) {
	                return i;
	            }
	        }
	        // The gap ends with the end of the row.
	        return this.tracker.length;
	    };
	    /**
	     * Update the tile tracker to account for the given tile in the given space.
	     * @param {?} start
	     * @param {?} tile
	     * @return {?}
	     */
	    TileCoordinator.prototype._markTilePosition = /**
	     * Update the tile tracker to account for the given tile in the given space.
	     * @param {?} start
	     * @param {?} tile
	     * @return {?}
	     */
	    function (start, tile) {
	        for (var /** @type {?} */ i = 0; i < tile.colspan; i++) {
	            this.tracker[start + i] = tile.rowspan;
	        }
	    };
	    return TileCoordinator;
	}());
	/**
	 * Simple data structure for tile position (row, col).
	 * \@docs-private
	 */
	var TilePosition = /** @class */ (function () {
	    function TilePosition(row, col) {
	        this.row = row;
	        this.col = col;
	    }
	    return TilePosition;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Sets the style properties for an individual tile, given the position calculated by the
	 * Tile Coordinator.
	 * \@docs-private
	 * @abstract
	 */
	var TileStyler = /** @class */ (function () {
	    function TileStyler() {
	        this._rows = 0;
	        this._rowspan = 0;
	    }
	    /**
	     * Adds grid-list layout info once it is available. Cannot be processed in the constructor
	     * because these properties haven't been calculated by that point.
	     *
	     * @param gutterSize Size of the grid's gutter.
	     * @param tracker Instance of the TileCoordinator.
	     * @param cols Amount of columns in the grid.
	     * @param direction Layout direction of the grid.
	     */
	    /**
	     * Adds grid-list layout info once it is available. Cannot be processed in the constructor
	     * because these properties haven't been calculated by that point.
	     *
	     * @param {?} gutterSize Size of the grid's gutter.
	     * @param {?} tracker Instance of the TileCoordinator.
	     * @param {?} cols Amount of columns in the grid.
	     * @param {?} direction Layout direction of the grid.
	     * @return {?}
	     */
	    TileStyler.prototype.init = /**
	     * Adds grid-list layout info once it is available. Cannot be processed in the constructor
	     * because these properties haven't been calculated by that point.
	     *
	     * @param {?} gutterSize Size of the grid's gutter.
	     * @param {?} tracker Instance of the TileCoordinator.
	     * @param {?} cols Amount of columns in the grid.
	     * @param {?} direction Layout direction of the grid.
	     * @return {?}
	     */
	    function (gutterSize, tracker, cols, direction) {
	        this._gutterSize = normalizeUnits(gutterSize);
	        this._rows = tracker.rowCount;
	        this._rowspan = tracker.rowspan;
	        this._cols = cols;
	        this._direction = direction;
	    };
	    /**
	     * Computes the amount of space a single 1x1 tile would take up (width or height).
	     * Used as a basis for other calculations.
	     * @param sizePercent Percent of the total grid-list space that one 1x1 tile would take up.
	     * @param gutterFraction Fraction of the gutter size taken up by one 1x1 tile.
	     * @return The size of a 1x1 tile as an expression that can be evaluated via CSS calc().
	     */
	    /**
	     * Computes the amount of space a single 1x1 tile would take up (width or height).
	     * Used as a basis for other calculations.
	     * @param {?} sizePercent Percent of the total grid-list space that one 1x1 tile would take up.
	     * @param {?} gutterFraction Fraction of the gutter size taken up by one 1x1 tile.
	     * @return {?} The size of a 1x1 tile as an expression that can be evaluated via CSS calc().
	     */
	    TileStyler.prototype.getBaseTileSize = /**
	     * Computes the amount of space a single 1x1 tile would take up (width or height).
	     * Used as a basis for other calculations.
	     * @param {?} sizePercent Percent of the total grid-list space that one 1x1 tile would take up.
	     * @param {?} gutterFraction Fraction of the gutter size taken up by one 1x1 tile.
	     * @return {?} The size of a 1x1 tile as an expression that can be evaluated via CSS calc().
	     */
	    function (sizePercent, gutterFraction) {
	        // Take the base size percent (as would be if evenly dividing the size between cells),
	        // and then subtracting the size of one gutter. However, since there are no gutters on the
	        // edges, each tile only uses a fraction (gutterShare = numGutters / numCells) of the gutter
	        // size. (Imagine having one gutter per tile, and then breaking up the extra gutter on the
	        // edge evenly among the cells).
	        return "(" + sizePercent + "% - (" + this._gutterSize + " * " + gutterFraction + "))";
	    };
	    /**
	     * Gets The horizontal or vertical position of a tile, e.g., the 'top' or 'left' property value.
	     * @param offset Number of tiles that have already been rendered in the row/column.
	     * @param baseSize Base size of a 1x1 tile (as computed in getBaseTileSize).
	     * @return Position of the tile as a CSS calc() expression.
	     */
	    /**
	     * Gets The horizontal or vertical position of a tile, e.g., the 'top' or 'left' property value.
	     * @param {?} baseSize Base size of a 1x1 tile (as computed in getBaseTileSize).
	     * @param {?} offset Number of tiles that have already been rendered in the row/column.
	     * @return {?} Position of the tile as a CSS calc() expression.
	     */
	    TileStyler.prototype.getTilePosition = /**
	     * Gets The horizontal or vertical position of a tile, e.g., the 'top' or 'left' property value.
	     * @param {?} baseSize Base size of a 1x1 tile (as computed in getBaseTileSize).
	     * @param {?} offset Number of tiles that have already been rendered in the row/column.
	     * @return {?} Position of the tile as a CSS calc() expression.
	     */
	    function (baseSize, offset) {
	        // The position comes the size of a 1x1 tile plus gutter for each previous tile in the
	        // row/column (offset).
	        return offset === 0 ? '0' : calc("(" + baseSize + " + " + this._gutterSize + ") * " + offset);
	    };
	    /**
	     * Gets the actual size of a tile, e.g., width or height, taking rowspan or colspan into account.
	     * @param baseSize Base size of a 1x1 tile (as computed in getBaseTileSize).
	     * @param span The tile's rowspan or colspan.
	     * @return Size of the tile as a CSS calc() expression.
	     */
	    /**
	     * Gets the actual size of a tile, e.g., width or height, taking rowspan or colspan into account.
	     * @param {?} baseSize Base size of a 1x1 tile (as computed in getBaseTileSize).
	     * @param {?} span The tile's rowspan or colspan.
	     * @return {?} Size of the tile as a CSS calc() expression.
	     */
	    TileStyler.prototype.getTileSize = /**
	     * Gets the actual size of a tile, e.g., width or height, taking rowspan or colspan into account.
	     * @param {?} baseSize Base size of a 1x1 tile (as computed in getBaseTileSize).
	     * @param {?} span The tile's rowspan or colspan.
	     * @return {?} Size of the tile as a CSS calc() expression.
	     */
	    function (baseSize, span) {
	        return "(" + baseSize + " * " + span + ") + (" + (span - 1) + " * " + this._gutterSize + ")";
	    };
	    /**
	     * Sets the style properties to be applied to a tile for the given row and column index.
	     * @param tile Tile to which to apply the styling.
	     * @param rowIndex Index of the tile's row.
	     * @param colIndex Index of the tile's column.
	     */
	    /**
	     * Sets the style properties to be applied to a tile for the given row and column index.
	     * @param {?} tile Tile to which to apply the styling.
	     * @param {?} rowIndex Index of the tile's row.
	     * @param {?} colIndex Index of the tile's column.
	     * @return {?}
	     */
	    TileStyler.prototype.setStyle = /**
	     * Sets the style properties to be applied to a tile for the given row and column index.
	     * @param {?} tile Tile to which to apply the styling.
	     * @param {?} rowIndex Index of the tile's row.
	     * @param {?} colIndex Index of the tile's column.
	     * @return {?}
	     */
	    function (tile, rowIndex, colIndex) {
	        // Percent of the available horizontal space that one column takes up.
	        var /** @type {?} */ percentWidthPerTile = 100 / this._cols;
	        // Fraction of the vertical gutter size that each column takes up.
	        // For example, if there are 5 columns, each column uses 4/5 = 0.8 times the gutter width.
	        var /** @type {?} */ gutterWidthFractionPerTile = (this._cols - 1) / this._cols;
	        this.setColStyles(tile, colIndex, percentWidthPerTile, gutterWidthFractionPerTile);
	        this.setRowStyles(tile, rowIndex, percentWidthPerTile, gutterWidthFractionPerTile);
	    };
	    /** Sets the horizontal placement of the tile in the list. */
	    /**
	     * Sets the horizontal placement of the tile in the list.
	     * @param {?} tile
	     * @param {?} colIndex
	     * @param {?} percentWidth
	     * @param {?} gutterWidth
	     * @return {?}
	     */
	    TileStyler.prototype.setColStyles = /**
	     * Sets the horizontal placement of the tile in the list.
	     * @param {?} tile
	     * @param {?} colIndex
	     * @param {?} percentWidth
	     * @param {?} gutterWidth
	     * @return {?}
	     */
	    function (tile, colIndex, percentWidth, gutterWidth) {
	        // Base horizontal size of a column.
	        var /** @type {?} */ baseTileWidth = this.getBaseTileSize(percentWidth, gutterWidth);
	        // The width and horizontal position of each tile is always calculated the same way, but the
	        // height and vertical position depends on the rowMode.
	        var /** @type {?} */ side = this._direction === 'rtl' ? 'right' : 'left';
	        tile._setStyle(side, this.getTilePosition(baseTileWidth, colIndex));
	        tile._setStyle('width', calc(this.getTileSize(baseTileWidth, tile.colspan)));
	    };
	    /**
	     * Calculates the total size taken up by gutters across one axis of a list.
	     */
	    /**
	     * Calculates the total size taken up by gutters across one axis of a list.
	     * @return {?}
	     */
	    TileStyler.prototype.getGutterSpan = /**
	     * Calculates the total size taken up by gutters across one axis of a list.
	     * @return {?}
	     */
	    function () {
	        return this._gutterSize + " * (" + this._rowspan + " - 1)";
	    };
	    /**
	     * Calculates the total size taken up by tiles across one axis of a list.
	     * @param tileHeight Height of the tile.
	     */
	    /**
	     * Calculates the total size taken up by tiles across one axis of a list.
	     * @param {?} tileHeight Height of the tile.
	     * @return {?}
	     */
	    TileStyler.prototype.getTileSpan = /**
	     * Calculates the total size taken up by tiles across one axis of a list.
	     * @param {?} tileHeight Height of the tile.
	     * @return {?}
	     */
	    function (tileHeight) {
	        return this._rowspan + " * " + this.getTileSize(tileHeight, 1);
	    };
	    /**
	     * Calculates the computed height and returns the correct style property to set.
	     * This method can be implemented by each type of TileStyler.
	     * @docs-private
	     */
	    /**
	     * Calculates the computed height and returns the correct style property to set.
	     * This method can be implemented by each type of TileStyler.
	     * \@docs-private
	     * @return {?}
	     */
	    TileStyler.prototype.getComputedHeight = /**
	     * Calculates the computed height and returns the correct style property to set.
	     * This method can be implemented by each type of TileStyler.
	     * \@docs-private
	     * @return {?}
	     */
	    function () { return null; };
	    return TileStyler;
	}());
	/**
	 * This type of styler is instantiated when the user passes in a fixed row height.
	 * Example `<mat-grid-list cols="3" rowHeight="100px">`
	 * \@docs-private
	 */
	var FixedTileStyler = /** @class */ (function (_super) {
	    __extends(FixedTileStyler, _super);
	    function FixedTileStyler(fixedRowHeight) {
	        var _this = _super.call(this) || this;
	        _this.fixedRowHeight = fixedRowHeight;
	        return _this;
	    }
	    /**
	     * @param {?} gutterSize
	     * @param {?} tracker
	     * @param {?} cols
	     * @param {?} direction
	     * @return {?}
	     */
	    FixedTileStyler.prototype.init = /**
	     * @param {?} gutterSize
	     * @param {?} tracker
	     * @param {?} cols
	     * @param {?} direction
	     * @return {?}
	     */
	    function (gutterSize, tracker, cols, direction) {
	        _super.prototype.init.call(this, gutterSize, tracker, cols, direction);
	        this.fixedRowHeight = normalizeUnits(this.fixedRowHeight);
	    };
	    /**
	     * @param {?} tile
	     * @param {?} rowIndex
	     * @return {?}
	     */
	    FixedTileStyler.prototype.setRowStyles = /**
	     * @param {?} tile
	     * @param {?} rowIndex
	     * @return {?}
	     */
	    function (tile, rowIndex) {
	        tile._setStyle('top', this.getTilePosition(this.fixedRowHeight, rowIndex));
	        tile._setStyle('height', calc(this.getTileSize(this.fixedRowHeight, tile.rowspan)));
	    };
	    /**
	     * @return {?}
	     */
	    FixedTileStyler.prototype.getComputedHeight = /**
	     * @return {?}
	     */
	    function () {
	        return [
	            'height', calc(this.getTileSpan(this.fixedRowHeight) + " + " + this.getGutterSpan())
	        ];
	    };
	    /**
	     * @param {?} list
	     * @return {?}
	     */
	    FixedTileStyler.prototype.reset = /**
	     * @param {?} list
	     * @return {?}
	     */
	    function (list) {
	        list._setListStyle(['height', null]);
	        list._tiles.forEach(function (tile) {
	            tile._setStyle('top', null);
	            tile._setStyle('height', null);
	        });
	    };
	    return FixedTileStyler;
	}(TileStyler));
	/**
	 * This type of styler is instantiated when the user passes in a width:height ratio
	 * for the row height.  Example `<mat-grid-list cols="3" rowHeight="3:1">`
	 * \@docs-private
	 */
	var RatioTileStyler = /** @class */ (function (_super) {
	    __extends(RatioTileStyler, _super);
	    function RatioTileStyler(value) {
	        var _this = _super.call(this) || this;
	        _this._parseRatio(value);
	        return _this;
	    }
	    /**
	     * @param {?} tile
	     * @param {?} rowIndex
	     * @param {?} percentWidth
	     * @param {?} gutterWidth
	     * @return {?}
	     */
	    RatioTileStyler.prototype.setRowStyles = /**
	     * @param {?} tile
	     * @param {?} rowIndex
	     * @param {?} percentWidth
	     * @param {?} gutterWidth
	     * @return {?}
	     */
	    function (tile, rowIndex, percentWidth, gutterWidth) {
	        var /** @type {?} */ percentHeightPerTile = percentWidth / this.rowHeightRatio;
	        this.baseTileHeight = this.getBaseTileSize(percentHeightPerTile, gutterWidth);
	        // Use padding-top and margin-top to maintain the given aspect ratio, as
	        // a percentage-based value for these properties is applied versus the *width* of the
	        // containing block. See http://www.w3.org/TR/CSS2/box.html#margin-properties
	        tile._setStyle('marginTop', this.getTilePosition(this.baseTileHeight, rowIndex));
	        tile._setStyle('paddingTop', calc(this.getTileSize(this.baseTileHeight, tile.rowspan)));
	    };
	    /**
	     * @return {?}
	     */
	    RatioTileStyler.prototype.getComputedHeight = /**
	     * @return {?}
	     */
	    function () {
	        return [
	            'paddingBottom', calc(this.getTileSpan(this.baseTileHeight) + " + " + this.getGutterSpan())
	        ];
	    };
	    /**
	     * @param {?} list
	     * @return {?}
	     */
	    RatioTileStyler.prototype.reset = /**
	     * @param {?} list
	     * @return {?}
	     */
	    function (list) {
	        list._setListStyle(['paddingBottom', null]);
	        list._tiles.forEach(function (tile) {
	            tile._setStyle('marginTop', null);
	            tile._setStyle('paddingTop', null);
	        });
	    };
	    /**
	     * @param {?} value
	     * @return {?}
	     */
	    RatioTileStyler.prototype._parseRatio = /**
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        var /** @type {?} */ ratioParts = value.split(':');
	        if (ratioParts.length !== 2) {
	            throw Error("mat-grid-list: invalid ratio given for row-height: \"" + value + "\"");
	        }
	        this.rowHeightRatio = parseFloat(ratioParts[0]) / parseFloat(ratioParts[1]);
	    };
	    return RatioTileStyler;
	}(TileStyler));
	/**
	 * This type of styler is instantiated when the user selects a "fit" row height mode.
	 * In other words, the row height will reflect the total height of the container divided
	 * by the number of rows.  Example `<mat-grid-list cols="3" rowHeight="fit">`
	 *
	 * \@docs-private
	 */
	var FitTileStyler = /** @class */ (function (_super) {
	    __extends(FitTileStyler, _super);
	    function FitTileStyler() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @param {?} tile
	     * @param {?} rowIndex
	     * @return {?}
	     */
	    FitTileStyler.prototype.setRowStyles = /**
	     * @param {?} tile
	     * @param {?} rowIndex
	     * @return {?}
	     */
	    function (tile, rowIndex) {
	        // Percent of the available vertical space that one row takes up.
	        var /** @type {?} */ percentHeightPerTile = 100 / this._rowspan;
	        // Fraction of the horizontal gutter size that each column takes up.
	        var /** @type {?} */ gutterHeightPerTile = (this._rows - 1) / this._rows;
	        // Base vertical size of a column.
	        var /** @type {?} */ baseTileHeight = this.getBaseTileSize(percentHeightPerTile, gutterHeightPerTile);
	        tile._setStyle('top', this.getTilePosition(baseTileHeight, rowIndex));
	        tile._setStyle('height', calc(this.getTileSize(baseTileHeight, tile.rowspan)));
	    };
	    /**
	     * @param {?} list
	     * @return {?}
	     */
	    FitTileStyler.prototype.reset = /**
	     * @param {?} list
	     * @return {?}
	     */
	    function (list) {
	        list._tiles.forEach(function (tile) {
	            tile._setStyle('top', null);
	            tile._setStyle('height', null);
	        });
	    };
	    return FitTileStyler;
	}(TileStyler));
	/**
	 * Wraps a CSS string in a calc function
	 * @param {?} exp
	 * @return {?}
	 */
	function calc(exp) { return "calc(" + exp + ")"; }
	/**
	 * Appends pixels to a CSS string if no units are given.
	 * @param {?} value
	 * @return {?}
	 */
	function normalizeUnits(value) {
	    return (value.match(/px|em|rem/)) ? value : value + 'px';
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	// TODO(kara): Conditional (responsive) column count / row size.
	// TODO(kara): Re-layout on window resize / media change (debounced).
	// TODO(kara): gridTileHeader and gridTileFooter.
	var MAT_FIT_MODE = 'fit';
	var MatGridList = /** @class */ (function () {
	    function MatGridList(_element, _dir) {
	        this._element = _element;
	        this._dir = _dir;
	        /**
	         * The amount of space between tiles. This will be something like '5px' or '2em'.
	         */
	        this._gutter = '1px';
	    }
	    Object.defineProperty(MatGridList.prototype, "cols", {
	        get: /**
	         * Amount of columns in the grid list.
	         * @return {?}
	         */
	        function () { return this._cols; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._cols = coerceToNumber(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatGridList.prototype, "gutterSize", {
	        get: /**
	         * Size of the grid list's gutter in pixels.
	         * @return {?}
	         */
	        function () { return this._gutter; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._gutter = coerceToString(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatGridList.prototype, "rowHeight", {
	        set: /**
	         * Set internal representation of row height from the user-provided value.
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            var /** @type {?} */ newValue = coerceToString(value);
	            if (newValue !== this._rowHeight) {
	                this._rowHeight = newValue;
	                this._setTileStyler(this._rowHeight);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatGridList.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        this._checkCols();
	        this._checkRowHeight();
	    };
	    /**
	     * The layout calculation is fairly cheap if nothing changes, so there's little cost
	     * to run it frequently.
	     */
	    /**
	     * The layout calculation is fairly cheap if nothing changes, so there's little cost
	     * to run it frequently.
	     * @return {?}
	     */
	    MatGridList.prototype.ngAfterContentChecked = /**
	     * The layout calculation is fairly cheap if nothing changes, so there's little cost
	     * to run it frequently.
	     * @return {?}
	     */
	    function () {
	        this._layoutTiles();
	    };
	    /**
	     * Throw a friendly error if cols property is missing
	     * @return {?}
	     */
	    MatGridList.prototype._checkCols = /**
	     * Throw a friendly error if cols property is missing
	     * @return {?}
	     */
	    function () {
	        if (!this.cols) {
	            throw Error("mat-grid-list: must pass in number of columns. " +
	                "Example: <mat-grid-list cols=\"3\">");
	        }
	    };
	    /**
	     * Default to equal width:height if rowHeight property is missing
	     * @return {?}
	     */
	    MatGridList.prototype._checkRowHeight = /**
	     * Default to equal width:height if rowHeight property is missing
	     * @return {?}
	     */
	    function () {
	        if (!this._rowHeight) {
	            this._setTileStyler('1:1');
	        }
	    };
	    /**
	     * Creates correct Tile Styler subtype based on rowHeight passed in by user
	     * @param {?} rowHeight
	     * @return {?}
	     */
	    MatGridList.prototype._setTileStyler = /**
	     * Creates correct Tile Styler subtype based on rowHeight passed in by user
	     * @param {?} rowHeight
	     * @return {?}
	     */
	    function (rowHeight) {
	        if (this._tileStyler) {
	            this._tileStyler.reset(this);
	        }
	        if (rowHeight === MAT_FIT_MODE) {
	            this._tileStyler = new FitTileStyler();
	        }
	        else if (rowHeight && rowHeight.indexOf(':') > -1) {
	            this._tileStyler = new RatioTileStyler(rowHeight);
	        }
	        else {
	            this._tileStyler = new FixedTileStyler(rowHeight);
	        }
	    };
	    /**
	     * Computes and applies the size and position for all children grid tiles.
	     * @return {?}
	     */
	    MatGridList.prototype._layoutTiles = /**
	     * Computes and applies the size and position for all children grid tiles.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ tracker = new TileCoordinator(this.cols, this._tiles);
	        var /** @type {?} */ direction = this._dir ? this._dir.value : 'ltr';
	        this._tileStyler.init(this.gutterSize, tracker, this.cols, direction);
	        this._tiles.forEach(function (tile, index) {
	            var /** @type {?} */ pos = tracker.positions[index];
	            _this._tileStyler.setStyle(tile, pos.row, pos.col);
	        });
	        this._setListStyle(this._tileStyler.getComputedHeight());
	    };
	    /** Sets style on the main grid-list element, given the style name and value. */
	    /**
	     * Sets style on the main grid-list element, given the style name and value.
	     * @param {?} style
	     * @return {?}
	     */
	    MatGridList.prototype._setListStyle = /**
	     * Sets style on the main grid-list element, given the style name and value.
	     * @param {?} style
	     * @return {?}
	     */
	    function (style$$1) {
	        if (style$$1) {
	            this._element.nativeElement.style[style$$1[0]] = style$$1[1];
	        }
	    };
	    MatGridList.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-grid-list',
	                    exportAs: 'matGridList',
	                    template: "<div><ng-content></ng-content></div>",
	                    styles: [".mat-grid-list{display:block;position:relative}.mat-grid-tile{display:block;position:absolute;overflow:hidden}.mat-grid-tile .mat-figure{top:0;left:0;right:0;bottom:0;position:absolute;display:flex;align-items:center;justify-content:center;height:100%;padding:0;margin:0}.mat-grid-tile .mat-grid-tile-footer,.mat-grid-tile .mat-grid-tile-header{display:flex;align-items:center;height:48px;color:#fff;background:rgba(0,0,0,.38);overflow:hidden;padding:0 16px;position:absolute;left:0;right:0}.mat-grid-tile .mat-grid-tile-footer>*,.mat-grid-tile .mat-grid-tile-header>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-grid-tile .mat-grid-tile-footer.mat-2-line,.mat-grid-tile .mat-grid-tile-header.mat-2-line{height:68px}.mat-grid-tile .mat-grid-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden}.mat-grid-tile .mat-grid-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-grid-tile .mat-grid-list-text:empty{display:none}.mat-grid-tile .mat-grid-tile-header{top:0}.mat-grid-tile .mat-grid-tile-footer{bottom:0}.mat-grid-tile .mat-grid-avatar{padding-right:16px}[dir=rtl] .mat-grid-tile .mat-grid-avatar{padding-right:0;padding-left:16px}.mat-grid-tile .mat-grid-avatar:empty{display:none}"],
	                    host: {
	                        'class': 'mat-grid-list',
	                    },
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                },] },
	    ];
	    /** @nocollapse */
	    MatGridList.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_bidi.Directionality, decorators: [{ type: _angular_core.Optional },] },
	    ]; };
	    MatGridList.propDecorators = {
	        "_tiles": [{ type: _angular_core.ContentChildren, args: [MatGridTile,] },],
	        "cols": [{ type: _angular_core.Input },],
	        "gutterSize": [{ type: _angular_core.Input },],
	        "rowHeight": [{ type: _angular_core.Input },],
	    };
	    return MatGridList;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatGridListModule = /** @class */ (function () {
	    function MatGridListModule() {
	    }
	    MatGridListModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [MatLineModule, MatCommonModule],
	                    exports: [
	                        MatGridList,
	                        MatGridTile,
	                        MatGridTileText,
	                        MatLineModule,
	                        MatCommonModule,
	                        MatGridTileHeaderCssMatStyler,
	                        MatGridTileFooterCssMatStyler,
	                        MatGridAvatarCssMatStyler
	                    ],
	                    declarations: [
	                        MatGridList,
	                        MatGridTile,
	                        MatGridTileText,
	                        MatGridTileHeaderCssMatStyler,
	                        MatGridTileFooterCssMatStyler,
	                        MatGridAvatarCssMatStyler
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    MatGridListModule.ctorParameters = function () { return []; };
	    return MatGridListModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Returns an exception to be thrown in the case when attempting to
	 * load an icon with a name that cannot be found.
	 * \@docs-private
	 * @param {?} iconName
	 * @return {?}
	 */
	function getMatIconNameNotFoundError(iconName) {
	    return Error("Unable to find icon with the name \"" + iconName + "\"");
	}
	/**
	 * Returns an exception to be thrown when the consumer attempts to use
	 * `<mat-icon>` without including \@angular/http.
	 * \@docs-private
	 * @return {?}
	 */
	function getMatIconNoHttpProviderError() {
	    return Error('Could not find HttpClient provider for use with Angular Material icons. ' +
	        'Please include the HttpClientModule from @angular/common/http in your ' +
	        'app imports.');
	}
	/**
	 * Returns an exception to be thrown when a URL couldn't be sanitized.
	 * \@docs-private
	 * @param {?} url URL that was attempted to be sanitized.
	 * @return {?}
	 */
	function getMatIconFailedToSanitizeError(url) {
	    return Error("The URL provided to MatIconRegistry was not trusted as a resource URL " +
	        ("via Angular's DomSanitizer. Attempted URL was \"" + url + "\"."));
	}
	/**
	 * Configuration for an icon, including the URL and possibly the cached SVG element.
	 * \@docs-private
	 */
	var SvgIconConfig = /** @class */ (function () {
	    function SvgIconConfig(url) {
	        this.url = url;
	        this.svgElement = null;
	    }
	    return SvgIconConfig;
	}());
	/**
	 * Service to register and display icons used by the `<mat-icon>` component.
	 * - Registers icon URLs by namespace and name.
	 * - Registers icon set URLs by namespace.
	 * - Registers aliases for CSS classes, for use with icon fonts.
	 * - Loads icons from URLs and extracts individual icons from icon sets.
	 */
	var MatIconRegistry = /** @class */ (function () {
	    function MatIconRegistry(_httpClient, _sanitizer, document) {
	        this._httpClient = _httpClient;
	        this._sanitizer = _sanitizer;
	        /**
	         * URLs and cached SVG elements for individual icons. Keys are of the format "[namespace]:[icon]".
	         */
	        this._svgIconConfigs = new Map();
	        /**
	         * SvgIconConfig objects and cached SVG elements for icon sets, keyed by namespace.
	         * Multiple icon sets can be registered under the same namespace.
	         */
	        this._iconSetConfigs = new Map();
	        /**
	         * Cache for icons loaded by direct URLs.
	         */
	        this._cachedIconsByUrl = new Map();
	        /**
	         * In-progress icon fetches. Used to coalesce multiple requests to the same URL.
	         */
	        this._inProgressUrlFetches = new Map();
	        /**
	         * Map from font identifiers to their CSS class names. Used for icon fonts.
	         */
	        this._fontCssClassesByAlias = new Map();
	        /**
	         * The CSS class to apply when an `<mat-icon>` component has no icon name, url, or font specified.
	         * The default 'material-icons' value assumes that the material icon font has been loaded as
	         * described at http://google.github.io/material-design-icons/#icon-font-for-the-web
	         */
	        this._defaultFontSetClass = 'material-icons';
	        // TODO(crisbeto): make _document required next major release.
	        this._document = document;
	    }
	    /**
	     * Registers an icon by URL in the default namespace.
	     * @param iconName Name under which the icon should be registered.
	     * @param url
	     */
	    /**
	     * Registers an icon by URL in the default namespace.
	     * @param {?} iconName Name under which the icon should be registered.
	     * @param {?} url
	     * @return {?}
	     */
	    MatIconRegistry.prototype.addSvgIcon = /**
	     * Registers an icon by URL in the default namespace.
	     * @param {?} iconName Name under which the icon should be registered.
	     * @param {?} url
	     * @return {?}
	     */
	    function (iconName, url) {
	        return this.addSvgIconInNamespace('', iconName, url);
	    };
	    /**
	     * Registers an icon by URL in the specified namespace.
	     * @param namespace Namespace in which the icon should be registered.
	     * @param iconName Name under which the icon should be registered.
	     * @param url
	     */
	    /**
	     * Registers an icon by URL in the specified namespace.
	     * @param {?} namespace Namespace in which the icon should be registered.
	     * @param {?} iconName Name under which the icon should be registered.
	     * @param {?} url
	     * @return {?}
	     */
	    MatIconRegistry.prototype.addSvgIconInNamespace = /**
	     * Registers an icon by URL in the specified namespace.
	     * @param {?} namespace Namespace in which the icon should be registered.
	     * @param {?} iconName Name under which the icon should be registered.
	     * @param {?} url
	     * @return {?}
	     */
	    function (namespace, iconName, url) {
	        var /** @type {?} */ key = iconKey(namespace, iconName);
	        this._svgIconConfigs.set(key, new SvgIconConfig(url));
	        return this;
	    };
	    /**
	     * Registers an icon set by URL in the default namespace.
	     * @param url
	     */
	    /**
	     * Registers an icon set by URL in the default namespace.
	     * @param {?} url
	     * @return {?}
	     */
	    MatIconRegistry.prototype.addSvgIconSet = /**
	     * Registers an icon set by URL in the default namespace.
	     * @param {?} url
	     * @return {?}
	     */
	    function (url) {
	        return this.addSvgIconSetInNamespace('', url);
	    };
	    /**
	     * Registers an icon set by URL in the specified namespace.
	     * @param namespace Namespace in which to register the icon set.
	     * @param url
	     */
	    /**
	     * Registers an icon set by URL in the specified namespace.
	     * @param {?} namespace Namespace in which to register the icon set.
	     * @param {?} url
	     * @return {?}
	     */
	    MatIconRegistry.prototype.addSvgIconSetInNamespace = /**
	     * Registers an icon set by URL in the specified namespace.
	     * @param {?} namespace Namespace in which to register the icon set.
	     * @param {?} url
	     * @return {?}
	     */
	    function (namespace, url) {
	        var /** @type {?} */ config = new SvgIconConfig(url);
	        var /** @type {?} */ configNamespace = this._iconSetConfigs.get(namespace);
	        if (configNamespace) {
	            configNamespace.push(config);
	        }
	        else {
	            this._iconSetConfigs.set(namespace, [config]);
	        }
	        return this;
	    };
	    /**
	     * Defines an alias for a CSS class name to be used for icon fonts. Creating an matIcon
	     * component with the alias as the fontSet input will cause the class name to be applied
	     * to the `<mat-icon>` element.
	     *
	     * @param alias Alias for the font.
	     * @param className Class name override to be used instead of the alias.
	     */
	    /**
	     * Defines an alias for a CSS class name to be used for icon fonts. Creating an matIcon
	     * component with the alias as the fontSet input will cause the class name to be applied
	     * to the `<mat-icon>` element.
	     *
	     * @param {?} alias Alias for the font.
	     * @param {?=} className Class name override to be used instead of the alias.
	     * @return {?}
	     */
	    MatIconRegistry.prototype.registerFontClassAlias = /**
	     * Defines an alias for a CSS class name to be used for icon fonts. Creating an matIcon
	     * component with the alias as the fontSet input will cause the class name to be applied
	     * to the `<mat-icon>` element.
	     *
	     * @param {?} alias Alias for the font.
	     * @param {?=} className Class name override to be used instead of the alias.
	     * @return {?}
	     */
	    function (alias, className) {
	        if (className === void 0) { className = alias; }
	        this._fontCssClassesByAlias.set(alias, className);
	        return this;
	    };
	    /**
	     * Returns the CSS class name associated with the alias by a previous call to
	     * registerFontClassAlias. If no CSS class has been associated, returns the alias unmodified.
	     */
	    /**
	     * Returns the CSS class name associated with the alias by a previous call to
	     * registerFontClassAlias. If no CSS class has been associated, returns the alias unmodified.
	     * @param {?} alias
	     * @return {?}
	     */
	    MatIconRegistry.prototype.classNameForFontAlias = /**
	     * Returns the CSS class name associated with the alias by a previous call to
	     * registerFontClassAlias. If no CSS class has been associated, returns the alias unmodified.
	     * @param {?} alias
	     * @return {?}
	     */
	    function (alias) {
	        return this._fontCssClassesByAlias.get(alias) || alias;
	    };
	    /**
	     * Sets the CSS class name to be used for icon fonts when an `<mat-icon>` component does not
	     * have a fontSet input value, and is not loading an icon by name or URL.
	     *
	     * @param className
	     */
	    /**
	     * Sets the CSS class name to be used for icon fonts when an `<mat-icon>` component does not
	     * have a fontSet input value, and is not loading an icon by name or URL.
	     *
	     * @param {?} className
	     * @return {?}
	     */
	    MatIconRegistry.prototype.setDefaultFontSetClass = /**
	     * Sets the CSS class name to be used for icon fonts when an `<mat-icon>` component does not
	     * have a fontSet input value, and is not loading an icon by name or URL.
	     *
	     * @param {?} className
	     * @return {?}
	     */
	    function (className) {
	        this._defaultFontSetClass = className;
	        return this;
	    };
	    /**
	     * Returns the CSS class name to be used for icon fonts when an `<mat-icon>` component does not
	     * have a fontSet input value, and is not loading an icon by name or URL.
	     */
	    /**
	     * Returns the CSS class name to be used for icon fonts when an `<mat-icon>` component does not
	     * have a fontSet input value, and is not loading an icon by name or URL.
	     * @return {?}
	     */
	    MatIconRegistry.prototype.getDefaultFontSetClass = /**
	     * Returns the CSS class name to be used for icon fonts when an `<mat-icon>` component does not
	     * have a fontSet input value, and is not loading an icon by name or URL.
	     * @return {?}
	     */
	    function () {
	        return this._defaultFontSetClass;
	    };
	    /**
	     * Returns an Observable that produces the icon (as an `<svg>` DOM element) from the given URL.
	     * The response from the URL may be cached so this will not always cause an HTTP request, but
	     * the produced element will always be a new copy of the originally fetched icon. (That is,
	     * it will not contain any modifications made to elements previously returned).
	     *
	     * @param safeUrl URL from which to fetch the SVG icon.
	     */
	    /**
	     * Returns an Observable that produces the icon (as an `<svg>` DOM element) from the given URL.
	     * The response from the URL may be cached so this will not always cause an HTTP request, but
	     * the produced element will always be a new copy of the originally fetched icon. (That is,
	     * it will not contain any modifications made to elements previously returned).
	     *
	     * @param {?} safeUrl URL from which to fetch the SVG icon.
	     * @return {?}
	     */
	    MatIconRegistry.prototype.getSvgIconFromUrl = /**
	     * Returns an Observable that produces the icon (as an `<svg>` DOM element) from the given URL.
	     * The response from the URL may be cached so this will not always cause an HTTP request, but
	     * the produced element will always be a new copy of the originally fetched icon. (That is,
	     * it will not contain any modifications made to elements previously returned).
	     *
	     * @param {?} safeUrl URL from which to fetch the SVG icon.
	     * @return {?}
	     */
	    function (safeUrl) {
	        var _this = this;
	        var /** @type {?} */ url = this._sanitizer.sanitize(_angular_core.SecurityContext.RESOURCE_URL, safeUrl);
	        if (!url) {
	            throw getMatIconFailedToSanitizeError(safeUrl);
	        }
	        var /** @type {?} */ cachedIcon = this._cachedIconsByUrl.get(url);
	        if (cachedIcon) {
	            return rxjs_observable_of.of(cloneSvg(cachedIcon));
	        }
	        return this._loadSvgIconFromConfig(new SvgIconConfig(safeUrl)).pipe(rxjs_operators_tap.tap(function (svg) { return _this._cachedIconsByUrl.set(/** @type {?} */ ((url)), svg); }), rxjs_operators_map.map(function (svg) { return cloneSvg(svg); }));
	    };
	    /**
	     * Returns an Observable that produces the icon (as an `<svg>` DOM element) with the given name
	     * and namespace. The icon must have been previously registered with addIcon or addIconSet;
	     * if not, the Observable will throw an error.
	     *
	     * @param name Name of the icon to be retrieved.
	     * @param namespace Namespace in which to look for the icon.
	     */
	    /**
	     * Returns an Observable that produces the icon (as an `<svg>` DOM element) with the given name
	     * and namespace. The icon must have been previously registered with addIcon or addIconSet;
	     * if not, the Observable will throw an error.
	     *
	     * @param {?} name Name of the icon to be retrieved.
	     * @param {?=} namespace Namespace in which to look for the icon.
	     * @return {?}
	     */
	    MatIconRegistry.prototype.getNamedSvgIcon = /**
	     * Returns an Observable that produces the icon (as an `<svg>` DOM element) with the given name
	     * and namespace. The icon must have been previously registered with addIcon or addIconSet;
	     * if not, the Observable will throw an error.
	     *
	     * @param {?} name Name of the icon to be retrieved.
	     * @param {?=} namespace Namespace in which to look for the icon.
	     * @return {?}
	     */
	    function (name, namespace) {
	        if (namespace === void 0) { namespace = ''; }
	        // Return (copy of) cached icon if possible.
	        var /** @type {?} */ key = iconKey(namespace, name);
	        var /** @type {?} */ config = this._svgIconConfigs.get(key);
	        if (config) {
	            return this._getSvgFromConfig(config);
	        }
	        // See if we have any icon sets registered for the namespace.
	        var /** @type {?} */ iconSetConfigs = this._iconSetConfigs.get(namespace);
	        if (iconSetConfigs) {
	            return this._getSvgFromIconSetConfigs(name, iconSetConfigs);
	        }
	        return rxjs_observable_throw._throw(getMatIconNameNotFoundError(key));
	    };
	    /**
	     * Returns the cached icon for a SvgIconConfig if available, or fetches it from its URL if not.
	     * @param {?} config
	     * @return {?}
	     */
	    MatIconRegistry.prototype._getSvgFromConfig = /**
	     * Returns the cached icon for a SvgIconConfig if available, or fetches it from its URL if not.
	     * @param {?} config
	     * @return {?}
	     */
	    function (config) {
	        if (config.svgElement) {
	            // We already have the SVG element for this icon, return a copy.
	            return rxjs_observable_of.of(cloneSvg(config.svgElement));
	        }
	        else {
	            // Fetch the icon from the config's URL, cache it, and return a copy.
	            return this._loadSvgIconFromConfig(config).pipe(rxjs_operators_tap.tap(function (svg) { return config.svgElement = svg; }), rxjs_operators_map.map(function (svg) { return cloneSvg(svg); }));
	        }
	    };
	    /**
	     * Attempts to find an icon with the specified name in any of the SVG icon sets.
	     * First searches the available cached icons for a nested element with a matching name, and
	     * if found copies the element to a new `<svg>` element. If not found, fetches all icon sets
	     * that have not been cached, and searches again after all fetches are completed.
	     * The returned Observable produces the SVG element if possible, and throws
	     * an error if no icon with the specified name can be found.
	     * @param {?} name
	     * @param {?} iconSetConfigs
	     * @return {?}
	     */
	    MatIconRegistry.prototype._getSvgFromIconSetConfigs = /**
	     * Attempts to find an icon with the specified name in any of the SVG icon sets.
	     * First searches the available cached icons for a nested element with a matching name, and
	     * if found copies the element to a new `<svg>` element. If not found, fetches all icon sets
	     * that have not been cached, and searches again after all fetches are completed.
	     * The returned Observable produces the SVG element if possible, and throws
	     * an error if no icon with the specified name can be found.
	     * @param {?} name
	     * @param {?} iconSetConfigs
	     * @return {?}
	     */
	    function (name, iconSetConfigs) {
	        var _this = this;
	        // For all the icon set SVG elements we've fetched, see if any contain an icon with the
	        // requested name.
	        var /** @type {?} */ namedIcon = this._extractIconWithNameFromAnySet(name, iconSetConfigs);
	        if (namedIcon) {
	            // We could cache namedIcon in _svgIconConfigs, but since we have to make a copy every
	            // time anyway, there's probably not much advantage compared to just always extracting
	            // it from the icon set.
	            return rxjs_observable_of.of(namedIcon);
	        }
	        // Not found in any cached icon sets. If there are icon sets with URLs that we haven't
	        // fetched, fetch them now and look for iconName in the results.
	        var /** @type {?} */ iconSetFetchRequests = iconSetConfigs
	            .filter(function (iconSetConfig) { return !iconSetConfig.svgElement; })
	            .map(function (iconSetConfig) {
	            return _this._loadSvgIconSetFromConfig(iconSetConfig).pipe(rxjs_operators_catchError.catchError(function (err) {
	                var /** @type {?} */ url = _this._sanitizer.sanitize(_angular_core.SecurityContext.RESOURCE_URL, iconSetConfig.url);
	                // Swallow errors fetching individual URLs so the combined Observable won't
	                // necessarily fail.
	                console.log("Loading icon set URL: " + url + " failed: " + err);
	                return rxjs_observable_of.of(null);
	            }));
	        });
	        // Fetch all the icon set URLs. When the requests complete, every IconSet should have a
	        // cached SVG element (unless the request failed), and we can check again for the icon.
	        return rxjs_observable_forkJoin.forkJoin(iconSetFetchRequests).pipe(rxjs_operators_map.map(function () {
	            var /** @type {?} */ foundIcon = _this._extractIconWithNameFromAnySet(name, iconSetConfigs);
	            if (!foundIcon) {
	                throw getMatIconNameNotFoundError(name);
	            }
	            return foundIcon;
	        }));
	    };
	    /**
	     * Searches the cached SVG elements for the given icon sets for a nested icon element whose "id"
	     * tag matches the specified name. If found, copies the nested element to a new SVG element and
	     * returns it. Returns null if no matching element is found.
	     * @param {?} iconName
	     * @param {?} iconSetConfigs
	     * @return {?}
	     */
	    MatIconRegistry.prototype._extractIconWithNameFromAnySet = /**
	     * Searches the cached SVG elements for the given icon sets for a nested icon element whose "id"
	     * tag matches the specified name. If found, copies the nested element to a new SVG element and
	     * returns it. Returns null if no matching element is found.
	     * @param {?} iconName
	     * @param {?} iconSetConfigs
	     * @return {?}
	     */
	    function (iconName, iconSetConfigs) {
	        // Iterate backwards, so icon sets added later have precedence.
	        for (var /** @type {?} */ i = iconSetConfigs.length - 1; i >= 0; i--) {
	            var /** @type {?} */ config = iconSetConfigs[i];
	            if (config.svgElement) {
	                var /** @type {?} */ foundIcon = this._extractSvgIconFromSet(config.svgElement, iconName);
	                if (foundIcon) {
	                    return foundIcon;
	                }
	            }
	        }
	        return null;
	    };
	    /**
	     * Loads the content of the icon URL specified in the SvgIconConfig and creates an SVG element
	     * from it.
	     * @param {?} config
	     * @return {?}
	     */
	    MatIconRegistry.prototype._loadSvgIconFromConfig = /**
	     * Loads the content of the icon URL specified in the SvgIconConfig and creates an SVG element
	     * from it.
	     * @param {?} config
	     * @return {?}
	     */
	    function (config) {
	        var _this = this;
	        return this._fetchUrl(config.url)
	            .pipe(rxjs_operators_map.map(function (svgText) { return _this._createSvgElementForSingleIcon(svgText); }));
	    };
	    /**
	     * Loads the content of the icon set URL specified in the SvgIconConfig and creates an SVG element
	     * from it.
	     * @param {?} config
	     * @return {?}
	     */
	    MatIconRegistry.prototype._loadSvgIconSetFromConfig = /**
	     * Loads the content of the icon set URL specified in the SvgIconConfig and creates an SVG element
	     * from it.
	     * @param {?} config
	     * @return {?}
	     */
	    function (config) {
	        var _this = this;
	        // If the SVG for this icon set has already been parsed, do nothing.
	        if (config.svgElement) {
	            return rxjs_observable_of.of(config.svgElement);
	        }
	        return this._fetchUrl(config.url).pipe(rxjs_operators_map.map(function (svgText) {
	            // It is possible that the icon set was parsed and cached by an earlier request, so parsing
	            // only needs to occur if the cache is yet unset.
	            if (!config.svgElement) {
	                config.svgElement = _this._svgElementFromString(svgText);
	            }
	            return config.svgElement;
	        }));
	    };
	    /**
	     * Creates a DOM element from the given SVG string, and adds default attributes.
	     * @param {?} responseText
	     * @return {?}
	     */
	    MatIconRegistry.prototype._createSvgElementForSingleIcon = /**
	     * Creates a DOM element from the given SVG string, and adds default attributes.
	     * @param {?} responseText
	     * @return {?}
	     */
	    function (responseText) {
	        var /** @type {?} */ svg = this._svgElementFromString(responseText);
	        this._setSvgAttributes(svg);
	        return svg;
	    };
	    /**
	     * Searches the cached element of the given SvgIconConfig for a nested icon element whose "id"
	     * tag matches the specified name. If found, copies the nested element to a new SVG element and
	     * returns it. Returns null if no matching element is found.
	     * @param {?} iconSet
	     * @param {?} iconName
	     * @return {?}
	     */
	    MatIconRegistry.prototype._extractSvgIconFromSet = /**
	     * Searches the cached element of the given SvgIconConfig for a nested icon element whose "id"
	     * tag matches the specified name. If found, copies the nested element to a new SVG element and
	     * returns it. Returns null if no matching element is found.
	     * @param {?} iconSet
	     * @param {?} iconName
	     * @return {?}
	     */
	    function (iconSet, iconName) {
	        var /** @type {?} */ iconSource = iconSet.querySelector('#' + iconName);
	        if (!iconSource) {
	            return null;
	        }
	        // Clone the element and remove the ID to prevent multiple elements from being added
	        // to the page with the same ID.
	        var /** @type {?} */ iconElement = /** @type {?} */ (iconSource.cloneNode(true));
	        iconElement.id = '';
	        // If the icon node is itself an <svg> node, clone and return it directly. If not, set it as
	        // the content of a new <svg> node.
	        if (iconElement.nodeName.toLowerCase() === 'svg') {
	            return this._setSvgAttributes(/** @type {?} */ (iconElement));
	        }
	        // If the node is a <symbol>, it won't be rendered so we have to convert it into <svg>. Note
	        // that the same could be achieved by referring to it via <use href="#id">, however the <use>
	        // tag is problematic on Firefox, because it needs to include the current page path.
	        if (iconElement.nodeName.toLowerCase() === 'symbol') {
	            return this._setSvgAttributes(this._toSvgElement(iconElement));
	        }
	        // createElement('SVG') doesn't work as expected; the DOM ends up with
	        // the correct nodes, but the SVG content doesn't render. Instead we
	        // have to create an empty SVG node using innerHTML and append its content.
	        // Elements created using DOMParser.parseFromString have the same problem.
	        // http://stackoverflow.com/questions/23003278/svg-innerhtml-in-firefox-can-not-display
	        var /** @type {?} */ svg = this._svgElementFromString('<svg></svg>');
	        // Clone the node so we don't remove it from the parent icon set element.
	        svg.appendChild(iconElement);
	        return this._setSvgAttributes(svg);
	    };
	    /**
	     * Creates a DOM element from the given SVG string.
	     * @param {?} str
	     * @return {?}
	     */
	    MatIconRegistry.prototype._svgElementFromString = /**
	     * Creates a DOM element from the given SVG string.
	     * @param {?} str
	     * @return {?}
	     */
	    function (str) {
	        if (this._document || typeof document !== 'undefined') {
	            var /** @type {?} */ div = (this._document || document).createElement('DIV');
	            div.innerHTML = str;
	            var /** @type {?} */ svg = /** @type {?} */ (div.querySelector('svg'));
	            if (!svg) {
	                throw Error('<svg> tag not found');
	            }
	            return svg;
	        }
	        throw new Error('MatIconRegistry could not resolve document.');
	    };
	    /**
	     * Converts an element into an SVG node by cloning all of its children.
	     * @param {?} element
	     * @return {?}
	     */
	    MatIconRegistry.prototype._toSvgElement = /**
	     * Converts an element into an SVG node by cloning all of its children.
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) {
	        var /** @type {?} */ svg = this._svgElementFromString('<svg></svg>');
	        for (var /** @type {?} */ i = 0; i < element.childNodes.length; i++) {
	            if (element.childNodes[i].nodeType === this._document.ELEMENT_NODE) {
	                svg.appendChild(element.childNodes[i].cloneNode(true));
	            }
	        }
	        return svg;
	    };
	    /**
	     * Sets the default attributes for an SVG element to be used as an icon.
	     * @param {?} svg
	     * @return {?}
	     */
	    MatIconRegistry.prototype._setSvgAttributes = /**
	     * Sets the default attributes for an SVG element to be used as an icon.
	     * @param {?} svg
	     * @return {?}
	     */
	    function (svg) {
	        if (!svg.getAttribute('xmlns')) {
	            svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
	        }
	        svg.setAttribute('fit', '');
	        svg.setAttribute('height', '100%');
	        svg.setAttribute('width', '100%');
	        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
	        svg.setAttribute('focusable', 'false'); // Disable IE11 default behavior to make SVGs focusable.
	        return svg;
	    };
	    /**
	     * Returns an Observable which produces the string contents of the given URL. Results may be
	     * cached, so future calls with the same URL may not cause another HTTP request.
	     * @param {?} safeUrl
	     * @return {?}
	     */
	    MatIconRegistry.prototype._fetchUrl = /**
	     * Returns an Observable which produces the string contents of the given URL. Results may be
	     * cached, so future calls with the same URL may not cause another HTTP request.
	     * @param {?} safeUrl
	     * @return {?}
	     */
	    function (safeUrl) {
	        var _this = this;
	        if (!this._httpClient) {
	            throw getMatIconNoHttpProviderError();
	        }
	        var /** @type {?} */ url = this._sanitizer.sanitize(_angular_core.SecurityContext.RESOURCE_URL, safeUrl);
	        if (!url) {
	            throw getMatIconFailedToSanitizeError(safeUrl);
	        }
	        // Store in-progress fetches to avoid sending a duplicate request for a URL when there is
	        // already a request in progress for that URL. It's necessary to call share() on the
	        // Observable returned by http.get() so that multiple subscribers don't cause multiple XHRs.
	        var /** @type {?} */ inProgressFetch = this._inProgressUrlFetches.get(url);
	        if (inProgressFetch) {
	            return inProgressFetch;
	        }
	        // TODO(jelbourn): for some reason, the `finally` operator "loses" the generic type on the
	        // Observable. Figure out why and fix it.
	        var /** @type {?} */ req = this._httpClient.get(url, { responseType: 'text' }).pipe(rxjs_operators_finalize.finalize(function () { return _this._inProgressUrlFetches.delete(url); }), rxjs_operators_share.share());
	        this._inProgressUrlFetches.set(url, req);
	        return req;
	    };
	    MatIconRegistry.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    MatIconRegistry.ctorParameters = function () { return [
	        { type: _angular_common_http.HttpClient, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_platformBrowser.DomSanitizer, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    return MatIconRegistry;
	}());
	/**
	 * \@docs-private
	 * @param {?} parentRegistry
	 * @param {?} httpClient
	 * @param {?} sanitizer
	 * @param {?=} document
	 * @return {?}
	 */
	function ICON_REGISTRY_PROVIDER_FACTORY(parentRegistry, httpClient, sanitizer, document) {
	    return parentRegistry || new MatIconRegistry(httpClient, sanitizer, document);
	}
	/**
	 * \@docs-private
	 */
	var ICON_REGISTRY_PROVIDER = {
	    // If there is already an MatIconRegistry available, use that. Otherwise, provide a new one.
	    provide: MatIconRegistry,
	    deps: [
	        [new _angular_core.Optional(), new _angular_core.SkipSelf(), MatIconRegistry],
	        [new _angular_core.Optional(), _angular_common_http.HttpClient],
	        _angular_platformBrowser.DomSanitizer,
	        [new _angular_core.Optional(), /** @type {?} */ (_angular_common.DOCUMENT)],
	    ],
	    useFactory: ICON_REGISTRY_PROVIDER_FACTORY,
	};
	/**
	 * Clones an SVGElement while preserving type information.
	 * @param {?} svg
	 * @return {?}
	 */
	function cloneSvg(svg) {
	    return /** @type {?} */ (svg.cloneNode(true));
	}
	/**
	 * Returns the cache key to use for an icon namespace and name.
	 * @param {?} namespace
	 * @param {?} name
	 * @return {?}
	 */
	function iconKey(namespace, name) {
	    return namespace + ':' + name;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 */
	var MatIconBase = /** @class */ (function () {
	    function MatIconBase(_elementRef) {
	        this._elementRef = _elementRef;
	    }
	    return MatIconBase;
	}());
	var _MatIconMixinBase = mixinColor(MatIconBase);
	/**
	 * Component to display an icon. It can be used in the following ways:
	 *
	 * - Specify the svgIcon input to load an SVG icon from a URL previously registered with the
	 *   addSvgIcon, addSvgIconInNamespace, addSvgIconSet, or addSvgIconSetInNamespace methods of
	 *   MatIconRegistry. If the svgIcon value contains a colon it is assumed to be in the format
	 *   "[namespace]:[name]", if not the value will be the name of an icon in the default namespace.
	 *   Examples:
	 *     `<mat-icon svgIcon="left-arrow"></mat-icon>
	 *     <mat-icon svgIcon="animals:cat"></mat-icon>`
	 *
	 * - Use a font ligature as an icon by putting the ligature text in the content of the `<mat-icon>`
	 *   component. By default the Material icons font is used as described at
	 *   http://google.github.io/material-design-icons/#icon-font-for-the-web. You can specify an
	 *   alternate font by setting the fontSet input to either the CSS class to apply to use the
	 *   desired font, or to an alias previously registered with MatIconRegistry.registerFontClassAlias.
	 *   Examples:
	 *     `<mat-icon>home</mat-icon>
	 *     <mat-icon fontSet="myfont">sun</mat-icon>`
	 *
	 * - Specify a font glyph to be included via CSS rules by setting the fontSet input to specify the
	 *   font, and the fontIcon input to specify the icon. Typically the fontIcon will specify a
	 *   CSS class which causes the glyph to be displayed via a :before selector, as in
	 *   https://fortawesome.github.io/Font-Awesome/examples/
	 *   Example:
	 *     `<mat-icon fontSet="fa" fontIcon="alarm"></mat-icon>`
	 */
	var MatIcon = /** @class */ (function (_super) {
	    __extends(MatIcon, _super);
	    function MatIcon(elementRef, _iconRegistry, ariaHidden) {
	        var _this = _super.call(this, elementRef) || this;
	        _this._iconRegistry = _iconRegistry;
	        // If the user has not explicitly set aria-hidden, mark the icon as hidden, as this is
	        // the right thing to do for the majority of icon use-cases.
	        if (!ariaHidden) {
	            elementRef.nativeElement.setAttribute('aria-hidden', 'true');
	        }
	        return _this;
	    }
	    Object.defineProperty(MatIcon.prototype, "fontSet", {
	        get: /**
	         * Font set that the icon is a part of.
	         * @return {?}
	         */
	        function () { return this._fontSet; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._fontSet = this._cleanupFontValue(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatIcon.prototype, "fontIcon", {
	        get: /**
	         * Name of an icon within a font set.
	         * @return {?}
	         */
	        function () { return this._fontIcon; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._fontIcon = this._cleanupFontValue(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Splits an svgIcon binding value into its icon set and icon name components.
	     * Returns a 2-element array of [(icon set), (icon name)].
	     * The separator for the two fields is ':'. If there is no separator, an empty
	     * string is returned for the icon set and the entire value is returned for
	     * the icon name. If the argument is falsy, returns an array of two empty strings.
	     * Throws an error if the name contains two or more ':' separators.
	     * Examples:
	     *   `'social:cake' -> ['social', 'cake']
	     *   'penguin' -> ['', 'penguin']
	     *   null -> ['', '']
	     *   'a:b:c' -> (throws Error)`
	     * @param {?} iconName
	     * @return {?}
	     */
	    MatIcon.prototype._splitIconName = /**
	     * Splits an svgIcon binding value into its icon set and icon name components.
	     * Returns a 2-element array of [(icon set), (icon name)].
	     * The separator for the two fields is ':'. If there is no separator, an empty
	     * string is returned for the icon set and the entire value is returned for
	     * the icon name. If the argument is falsy, returns an array of two empty strings.
	     * Throws an error if the name contains two or more ':' separators.
	     * Examples:
	     *   `'social:cake' -> ['social', 'cake']
	     *   'penguin' -> ['', 'penguin']
	     *   null -> ['', '']
	     *   'a:b:c' -> (throws Error)`
	     * @param {?} iconName
	     * @return {?}
	     */
	    function (iconName) {
	        if (!iconName) {
	            return ['', ''];
	        }
	        var /** @type {?} */ parts = iconName.split(':');
	        switch (parts.length) {
	            case 1: return ['', parts[0]]; // Use default namespace.
	            case 2: return /** @type {?} */ (parts);
	            default: throw Error("Invalid icon name: \"" + iconName + "\"");
	        }
	    };
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    MatIcon.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        var _this = this;
	        // Only update the inline SVG icon if the inputs changed, to avoid unnecessary DOM operations.
	        if (changes["svgIcon"]) {
	            if (this.svgIcon) {
	                var _a = this._splitIconName(this.svgIcon), namespace = _a[0], iconName = _a[1];
	                this._iconRegistry.getNamedSvgIcon(iconName, namespace).pipe(rxjs_operators_take.take(1)).subscribe(function (svg) { return _this._setSvgElement(svg); }, function (err) { return console.log("Error retrieving icon: " + err.message); });
	            }
	            else {
	                this._clearSvgElement();
	            }
	        }
	        if (this._usingFontIcon()) {
	            this._updateFontIconClasses();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatIcon.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        // Update font classes because ngOnChanges won't be called if none of the inputs are present,
	        // e.g. <mat-icon>arrow</mat-icon> In this case we need to add a CSS class for the default font.
	        if (this._usingFontIcon()) {
	            this._updateFontIconClasses();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatIcon.prototype._usingFontIcon = /**
	     * @return {?}
	     */
	    function () {
	        return !this.svgIcon;
	    };
	    /**
	     * @param {?} svg
	     * @return {?}
	     */
	    MatIcon.prototype._setSvgElement = /**
	     * @param {?} svg
	     * @return {?}
	     */
	    function (svg) {
	        this._clearSvgElement();
	        this._elementRef.nativeElement.appendChild(svg);
	    };
	    /**
	     * @return {?}
	     */
	    MatIcon.prototype._clearSvgElement = /**
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ layoutElement = this._elementRef.nativeElement;
	        var /** @type {?} */ childCount = layoutElement.childNodes.length;
	        // Remove existing child nodes and add the new SVG element. Note that we can't
	        // use innerHTML, because IE will throw if the element has a data binding.
	        for (var /** @type {?} */ i = 0; i < childCount; i++) {
	            layoutElement.removeChild(layoutElement.childNodes[i]);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatIcon.prototype._updateFontIconClasses = /**
	     * @return {?}
	     */
	    function () {
	        if (!this._usingFontIcon()) {
	            return;
	        }
	        var /** @type {?} */ elem = this._elementRef.nativeElement;
	        var /** @type {?} */ fontSetClass = this.fontSet ?
	            this._iconRegistry.classNameForFontAlias(this.fontSet) :
	            this._iconRegistry.getDefaultFontSetClass();
	        if (fontSetClass != this._previousFontSetClass) {
	            if (this._previousFontSetClass) {
	                elem.classList.remove(this._previousFontSetClass);
	            }
	            if (fontSetClass) {
	                elem.classList.add(fontSetClass);
	            }
	            this._previousFontSetClass = fontSetClass;
	        }
	        if (this.fontIcon != this._previousFontIconClass) {
	            if (this._previousFontIconClass) {
	                elem.classList.remove(this._previousFontIconClass);
	            }
	            if (this.fontIcon) {
	                elem.classList.add(this.fontIcon);
	            }
	            this._previousFontIconClass = this.fontIcon;
	        }
	    };
	    /**
	     * Cleans up a value to be used as a fontIcon or fontSet.
	     * Since the value ends up being assigned as a CSS class, we
	     * have to trim the value and omit space-separated values.
	     * @param {?} value
	     * @return {?}
	     */
	    MatIcon.prototype._cleanupFontValue = /**
	     * Cleans up a value to be used as a fontIcon or fontSet.
	     * Since the value ends up being assigned as a CSS class, we
	     * have to trim the value and omit space-separated values.
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        return typeof value === 'string' ? value.trim().split(' ')[0] : value;
	    };
	    MatIcon.decorators = [
	        { type: _angular_core.Component, args: [{template: '<ng-content></ng-content>',
	                    selector: 'mat-icon',
	                    exportAs: 'matIcon',
	                    styles: [".mat-icon{background-repeat:no-repeat;display:inline-block;fill:currentColor;height:24px;width:24px}"],
	                    inputs: ['color'],
	                    host: {
	                        'role': 'img',
	                        'class': 'mat-icon',
	                    },
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatIcon.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: MatIconRegistry, },
	        { type: undefined, decorators: [{ type: _angular_core.Attribute, args: ['aria-hidden',] },] },
	    ]; };
	    MatIcon.propDecorators = {
	        "svgIcon": [{ type: _angular_core.Input },],
	        "fontSet": [{ type: _angular_core.Input },],
	        "fontIcon": [{ type: _angular_core.Input },],
	    };
	    return MatIcon;
	}(_MatIconMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatIconModule = /** @class */ (function () {
	    function MatIconModule() {
	    }
	    MatIconModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [MatCommonModule],
	                    exports: [MatIcon, MatCommonModule],
	                    declarations: [MatIcon],
	                    providers: [ICON_REGISTRY_PROVIDER],
	                },] },
	    ];
	    /** @nocollapse */
	    MatIconModule.ctorParameters = function () { return []; };
	    return MatIconModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 */
	var MatListBase = /** @class */ (function () {
	    function MatListBase() {
	    }
	    return MatListBase;
	}());
	var _MatListMixinBase = mixinDisableRipple(MatListBase);
	/**
	 * \@docs-private
	 */
	var MatListItemBase = /** @class */ (function () {
	    function MatListItemBase() {
	    }
	    return MatListItemBase;
	}());
	var _MatListItemMixinBase = mixinDisableRipple(MatListItemBase);
	var MatNavList = /** @class */ (function (_super) {
	    __extends(MatNavList, _super);
	    function MatNavList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    MatNavList.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-nav-list',
	                    exportAs: 'matNavList',
	                    host: {
	                        'role': 'navigation',
	                        'class': 'mat-nav-list'
	                    },
	                    template: "<ng-content></ng-content>",
	                    styles: [".mat-divider{display:block;margin:0;border-top-width:1px;border-top-style:solid}.mat-divider.mat-divider-vertical{border-top:0;border-right-width:1px;border-right-style:solid}.mat-divider.mat-divider-inset{margin-left:80px}[dir=rtl] .mat-divider.mat-divider-inset{margin-left:auto;margin-right:80px}.mat-subheader{display:flex;box-sizing:border-box;padding:16px;align-items:center}.mat-list .mat-subheader,.mat-nav-list .mat-subheader,.mat-selection-list .mat-subheader{margin:0}.mat-list,.mat-nav-list,.mat-selection-list{padding-top:8px;display:block}.mat-list .mat-subheader,.mat-nav-list .mat-subheader,.mat-selection-list .mat-subheader{height:48px;line-height:16px}.mat-list .mat-subheader:first-child,.mat-nav-list .mat-subheader:first-child,.mat-selection-list .mat-subheader:first-child{margin-top:-8px}.mat-list .mat-list-item,.mat-list .mat-list-option,.mat-nav-list .mat-list-item,.mat-nav-list .mat-list-option,.mat-selection-list .mat-list-item,.mat-selection-list .mat-list-option{display:block;height:48px}.mat-list .mat-list-item .mat-list-item-content,.mat-list .mat-list-option .mat-list-item-content,.mat-nav-list .mat-list-item .mat-list-item-content,.mat-nav-list .mat-list-option .mat-list-item-content,.mat-selection-list .mat-list-item .mat-list-item-content,.mat-selection-list .mat-list-option .mat-list-item-content{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:0 16px;position:relative;height:inherit}.mat-list .mat-list-item .mat-list-item-content-reverse,.mat-list .mat-list-option .mat-list-item-content-reverse,.mat-nav-list .mat-list-item .mat-list-item-content-reverse,.mat-nav-list .mat-list-option .mat-list-item-content-reverse,.mat-selection-list .mat-list-item .mat-list-item-content-reverse,.mat-selection-list .mat-list-option .mat-list-item-content-reverse{display:flex;align-items:center;padding:0 16px;flex-direction:row-reverse;justify-content:space-around}.mat-list .mat-list-item .mat-list-item-ripple,.mat-list .mat-list-option .mat-list-item-ripple,.mat-nav-list .mat-list-item .mat-list-item-ripple,.mat-nav-list .mat-list-option .mat-list-item-ripple,.mat-selection-list .mat-list-item .mat-list-item-ripple,.mat-selection-list .mat-list-option .mat-list-item-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-list .mat-list-item.mat-list-item-with-avatar,.mat-list .mat-list-option.mat-list-item-with-avatar,.mat-nav-list .mat-list-item.mat-list-item-with-avatar,.mat-nav-list .mat-list-option.mat-list-item-with-avatar,.mat-selection-list .mat-list-item.mat-list-item-with-avatar,.mat-selection-list .mat-list-option.mat-list-item-with-avatar{height:56px}.mat-list .mat-list-item.mat-2-line,.mat-list .mat-list-option.mat-2-line,.mat-nav-list .mat-list-item.mat-2-line,.mat-nav-list .mat-list-option.mat-2-line,.mat-selection-list .mat-list-item.mat-2-line,.mat-selection-list .mat-list-option.mat-2-line{height:72px}.mat-list .mat-list-item.mat-3-line,.mat-list .mat-list-option.mat-3-line,.mat-nav-list .mat-list-item.mat-3-line,.mat-nav-list .mat-list-option.mat-3-line,.mat-selection-list .mat-list-item.mat-3-line,.mat-selection-list .mat-list-option.mat-3-line{height:88px}.mat-list .mat-list-item.mat-multi-line,.mat-list .mat-list-option.mat-multi-line,.mat-nav-list .mat-list-item.mat-multi-line,.mat-nav-list .mat-list-option.mat-multi-line,.mat-selection-list .mat-list-item.mat-multi-line,.mat-selection-list .mat-list-option.mat-multi-line{height:auto}.mat-list .mat-list-item.mat-multi-line .mat-list-item-content,.mat-list .mat-list-option.mat-multi-line .mat-list-item-content,.mat-nav-list .mat-list-item.mat-multi-line .mat-list-item-content,.mat-nav-list .mat-list-option.mat-multi-line .mat-list-item-content,.mat-selection-list .mat-list-item.mat-multi-line .mat-list-item-content,.mat-selection-list .mat-list-option.mat-multi-line .mat-list-item-content{padding-top:16px;padding-bottom:16px}.mat-list .mat-list-item .mat-list-text,.mat-list .mat-list-option .mat-list-text,.mat-nav-list .mat-list-item .mat-list-text,.mat-nav-list .mat-list-option .mat-list-text,.mat-selection-list .mat-list-item .mat-list-text,.mat-selection-list .mat-list-option .mat-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden;padding:0}.mat-list .mat-list-item .mat-list-text>*,.mat-list .mat-list-option .mat-list-text>*,.mat-nav-list .mat-list-item .mat-list-text>*,.mat-nav-list .mat-list-option .mat-list-text>*,.mat-selection-list .mat-list-item .mat-list-text>*,.mat-selection-list .mat-list-option .mat-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-list .mat-list-item .mat-list-text:empty,.mat-list .mat-list-option .mat-list-text:empty,.mat-nav-list .mat-list-item .mat-list-text:empty,.mat-nav-list .mat-list-option .mat-list-text:empty,.mat-selection-list .mat-list-item .mat-list-text:empty,.mat-selection-list .mat-list-option .mat-list-text:empty{display:none}.mat-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}[dir=rtl] .mat-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:16px;padding-left:0}.mat-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-left:0;padding-right:16px}[dir=rtl] .mat-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}.mat-list .mat-list-item .mat-list-avatar,.mat-list .mat-list-option .mat-list-avatar,.mat-nav-list .mat-list-item .mat-list-avatar,.mat-nav-list .mat-list-option .mat-list-avatar,.mat-selection-list .mat-list-item .mat-list-avatar,.mat-selection-list .mat-list-option .mat-list-avatar{flex-shrink:0;width:40px;height:40px;border-radius:50%}.mat-list .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-list .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-nav-list .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-nav-list .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-selection-list .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-selection-list .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:72px;width:calc(100% - 72px)}[dir=rtl] .mat-list .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-list .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:auto;margin-right:72px}.mat-list .mat-list-item .mat-list-icon,.mat-list .mat-list-option .mat-list-icon,.mat-nav-list .mat-list-item .mat-list-icon,.mat-nav-list .mat-list-option .mat-list-icon,.mat-selection-list .mat-list-item .mat-list-icon,.mat-selection-list .mat-list-option .mat-list-icon{flex-shrink:0;width:24px;height:24px;font-size:24px;box-sizing:content-box;border-radius:50%;padding:4px}.mat-list .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-list .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-nav-list .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-nav-list .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-selection-list .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-selection-list .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:64px;width:calc(100% - 64px)}[dir=rtl] .mat-list .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-list .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:auto;margin-right:64px}.mat-list .mat-list-item .mat-divider,.mat-list .mat-list-option .mat-divider,.mat-nav-list .mat-list-item .mat-divider,.mat-nav-list .mat-list-option .mat-divider,.mat-selection-list .mat-list-item .mat-divider,.mat-selection-list .mat-list-option .mat-divider{position:absolute;bottom:0;left:0;width:100%;margin:0}[dir=rtl] .mat-list .mat-list-item .mat-divider,[dir=rtl] .mat-list .mat-list-option .mat-divider,[dir=rtl] .mat-nav-list .mat-list-item .mat-divider,[dir=rtl] .mat-nav-list .mat-list-option .mat-divider,[dir=rtl] .mat-selection-list .mat-list-item .mat-divider,[dir=rtl] .mat-selection-list .mat-list-option .mat-divider{margin-left:auto;margin-right:0}.mat-list .mat-list-item .mat-divider.mat-divider-inset,.mat-list .mat-list-option .mat-divider.mat-divider-inset,.mat-nav-list .mat-list-item .mat-divider.mat-divider-inset,.mat-nav-list .mat-list-option .mat-divider.mat-divider-inset,.mat-selection-list .mat-list-item .mat-divider.mat-divider-inset,.mat-selection-list .mat-list-option .mat-divider.mat-divider-inset{position:absolute}.mat-list[dense],.mat-nav-list[dense],.mat-selection-list[dense]{padding-top:4px;display:block}.mat-list[dense] .mat-subheader,.mat-nav-list[dense] .mat-subheader,.mat-selection-list[dense] .mat-subheader{height:40px;line-height:8px}.mat-list[dense] .mat-subheader:first-child,.mat-nav-list[dense] .mat-subheader:first-child,.mat-selection-list[dense] .mat-subheader:first-child{margin-top:-4px}.mat-list[dense] .mat-list-item,.mat-list[dense] .mat-list-option,.mat-nav-list[dense] .mat-list-item,.mat-nav-list[dense] .mat-list-option,.mat-selection-list[dense] .mat-list-item,.mat-selection-list[dense] .mat-list-option{display:block;height:40px}.mat-list[dense] .mat-list-item .mat-list-item-content,.mat-list[dense] .mat-list-option .mat-list-item-content,.mat-nav-list[dense] .mat-list-item .mat-list-item-content,.mat-nav-list[dense] .mat-list-option .mat-list-item-content,.mat-selection-list[dense] .mat-list-item .mat-list-item-content,.mat-selection-list[dense] .mat-list-option .mat-list-item-content{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:0 16px;position:relative;height:inherit}.mat-list[dense] .mat-list-item .mat-list-item-content-reverse,.mat-list[dense] .mat-list-option .mat-list-item-content-reverse,.mat-nav-list[dense] .mat-list-item .mat-list-item-content-reverse,.mat-nav-list[dense] .mat-list-option .mat-list-item-content-reverse,.mat-selection-list[dense] .mat-list-item .mat-list-item-content-reverse,.mat-selection-list[dense] .mat-list-option .mat-list-item-content-reverse{display:flex;align-items:center;padding:0 16px;flex-direction:row-reverse;justify-content:space-around}.mat-list[dense] .mat-list-item .mat-list-item-ripple,.mat-list[dense] .mat-list-option .mat-list-item-ripple,.mat-nav-list[dense] .mat-list-item .mat-list-item-ripple,.mat-nav-list[dense] .mat-list-option .mat-list-item-ripple,.mat-selection-list[dense] .mat-list-item .mat-list-item-ripple,.mat-selection-list[dense] .mat-list-option .mat-list-item-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-list[dense] .mat-list-item.mat-list-item-with-avatar,.mat-list[dense] .mat-list-option.mat-list-item-with-avatar,.mat-nav-list[dense] .mat-list-item.mat-list-item-with-avatar,.mat-nav-list[dense] .mat-list-option.mat-list-item-with-avatar,.mat-selection-list[dense] .mat-list-item.mat-list-item-with-avatar,.mat-selection-list[dense] .mat-list-option.mat-list-item-with-avatar{height:48px}.mat-list[dense] .mat-list-item.mat-2-line,.mat-list[dense] .mat-list-option.mat-2-line,.mat-nav-list[dense] .mat-list-item.mat-2-line,.mat-nav-list[dense] .mat-list-option.mat-2-line,.mat-selection-list[dense] .mat-list-item.mat-2-line,.mat-selection-list[dense] .mat-list-option.mat-2-line{height:60px}.mat-list[dense] .mat-list-item.mat-3-line,.mat-list[dense] .mat-list-option.mat-3-line,.mat-nav-list[dense] .mat-list-item.mat-3-line,.mat-nav-list[dense] .mat-list-option.mat-3-line,.mat-selection-list[dense] .mat-list-item.mat-3-line,.mat-selection-list[dense] .mat-list-option.mat-3-line{height:76px}.mat-list[dense] .mat-list-item.mat-multi-line,.mat-list[dense] .mat-list-option.mat-multi-line,.mat-nav-list[dense] .mat-list-item.mat-multi-line,.mat-nav-list[dense] .mat-list-option.mat-multi-line,.mat-selection-list[dense] .mat-list-item.mat-multi-line,.mat-selection-list[dense] .mat-list-option.mat-multi-line{height:auto}.mat-list[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-list[dense] .mat-list-option.mat-multi-line .mat-list-item-content,.mat-nav-list[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-nav-list[dense] .mat-list-option.mat-multi-line .mat-list-item-content,.mat-selection-list[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-selection-list[dense] .mat-list-option.mat-multi-line .mat-list-item-content{padding-top:16px;padding-bottom:16px}.mat-list[dense] .mat-list-item .mat-list-text,.mat-list[dense] .mat-list-option .mat-list-text,.mat-nav-list[dense] .mat-list-item .mat-list-text,.mat-nav-list[dense] .mat-list-option .mat-list-text,.mat-selection-list[dense] .mat-list-item .mat-list-text,.mat-selection-list[dense] .mat-list-option .mat-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden;padding:0}.mat-list[dense] .mat-list-item .mat-list-text>*,.mat-list[dense] .mat-list-option .mat-list-text>*,.mat-nav-list[dense] .mat-list-item .mat-list-text>*,.mat-nav-list[dense] .mat-list-option .mat-list-text>*,.mat-selection-list[dense] .mat-list-item .mat-list-text>*,.mat-selection-list[dense] .mat-list-option .mat-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-list[dense] .mat-list-item .mat-list-text:empty,.mat-list[dense] .mat-list-option .mat-list-text:empty,.mat-nav-list[dense] .mat-list-item .mat-list-text:empty,.mat-nav-list[dense] .mat-list-option .mat-list-text:empty,.mat-selection-list[dense] .mat-list-item .mat-list-text:empty,.mat-selection-list[dense] .mat-list-option .mat-list-text:empty{display:none}.mat-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:16px;padding-left:0}.mat-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-left:0;padding-right:16px}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}.mat-list[dense] .mat-list-item .mat-list-avatar,.mat-list[dense] .mat-list-option .mat-list-avatar,.mat-nav-list[dense] .mat-list-item .mat-list-avatar,.mat-nav-list[dense] .mat-list-option .mat-list-avatar,.mat-selection-list[dense] .mat-list-item .mat-list-avatar,.mat-selection-list[dense] .mat-list-option .mat-list-avatar{flex-shrink:0;width:36px;height:36px;border-radius:50%}.mat-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-nav-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-nav-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-selection-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-selection-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:68px;width:calc(100% - 68px)}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:auto;margin-right:68px}.mat-list[dense] .mat-list-item .mat-list-icon,.mat-list[dense] .mat-list-option .mat-list-icon,.mat-nav-list[dense] .mat-list-item .mat-list-icon,.mat-nav-list[dense] .mat-list-option .mat-list-icon,.mat-selection-list[dense] .mat-list-item .mat-list-icon,.mat-selection-list[dense] .mat-list-option .mat-list-icon{flex-shrink:0;width:20px;height:20px;font-size:20px;box-sizing:content-box;border-radius:50%;padding:4px}.mat-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-nav-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-nav-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-selection-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-selection-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:60px;width:calc(100% - 60px)}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:auto;margin-right:60px}.mat-list[dense] .mat-list-item .mat-divider,.mat-list[dense] .mat-list-option .mat-divider,.mat-nav-list[dense] .mat-list-item .mat-divider,.mat-nav-list[dense] .mat-list-option .mat-divider,.mat-selection-list[dense] .mat-list-item .mat-divider,.mat-selection-list[dense] .mat-list-option .mat-divider{position:absolute;bottom:0;left:0;width:100%;margin:0}[dir=rtl] .mat-list[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-list[dense] .mat-list-option .mat-divider,[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-divider,[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-divider{margin-left:auto;margin-right:0}.mat-list[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-list[dense] .mat-list-option .mat-divider.mat-divider-inset,.mat-nav-list[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-nav-list[dense] .mat-list-option .mat-divider.mat-divider-inset,.mat-selection-list[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-selection-list[dense] .mat-list-option .mat-divider.mat-divider-inset{position:absolute}.mat-nav-list a{text-decoration:none;color:inherit}.mat-nav-list .mat-list-item{cursor:pointer;outline:0}.mat-list-option:not(.mat-list-item-disabled){cursor:pointer;outline:0}"],
	                    inputs: ['disableRipple'],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatNavList.ctorParameters = function () { return []; };
	    return MatNavList;
	}(_MatListMixinBase));
	var MatList = /** @class */ (function (_super) {
	    __extends(MatList, _super);
	    function MatList() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    MatList.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-list',
	                    exportAs: 'matList',
	                    template: "<ng-content></ng-content>",
	                    host: { 'class': 'mat-list' },
	                    styles: [".mat-divider{display:block;margin:0;border-top-width:1px;border-top-style:solid}.mat-divider.mat-divider-vertical{border-top:0;border-right-width:1px;border-right-style:solid}.mat-divider.mat-divider-inset{margin-left:80px}[dir=rtl] .mat-divider.mat-divider-inset{margin-left:auto;margin-right:80px}.mat-subheader{display:flex;box-sizing:border-box;padding:16px;align-items:center}.mat-list .mat-subheader,.mat-nav-list .mat-subheader,.mat-selection-list .mat-subheader{margin:0}.mat-list,.mat-nav-list,.mat-selection-list{padding-top:8px;display:block}.mat-list .mat-subheader,.mat-nav-list .mat-subheader,.mat-selection-list .mat-subheader{height:48px;line-height:16px}.mat-list .mat-subheader:first-child,.mat-nav-list .mat-subheader:first-child,.mat-selection-list .mat-subheader:first-child{margin-top:-8px}.mat-list .mat-list-item,.mat-list .mat-list-option,.mat-nav-list .mat-list-item,.mat-nav-list .mat-list-option,.mat-selection-list .mat-list-item,.mat-selection-list .mat-list-option{display:block;height:48px}.mat-list .mat-list-item .mat-list-item-content,.mat-list .mat-list-option .mat-list-item-content,.mat-nav-list .mat-list-item .mat-list-item-content,.mat-nav-list .mat-list-option .mat-list-item-content,.mat-selection-list .mat-list-item .mat-list-item-content,.mat-selection-list .mat-list-option .mat-list-item-content{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:0 16px;position:relative;height:inherit}.mat-list .mat-list-item .mat-list-item-content-reverse,.mat-list .mat-list-option .mat-list-item-content-reverse,.mat-nav-list .mat-list-item .mat-list-item-content-reverse,.mat-nav-list .mat-list-option .mat-list-item-content-reverse,.mat-selection-list .mat-list-item .mat-list-item-content-reverse,.mat-selection-list .mat-list-option .mat-list-item-content-reverse{display:flex;align-items:center;padding:0 16px;flex-direction:row-reverse;justify-content:space-around}.mat-list .mat-list-item .mat-list-item-ripple,.mat-list .mat-list-option .mat-list-item-ripple,.mat-nav-list .mat-list-item .mat-list-item-ripple,.mat-nav-list .mat-list-option .mat-list-item-ripple,.mat-selection-list .mat-list-item .mat-list-item-ripple,.mat-selection-list .mat-list-option .mat-list-item-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-list .mat-list-item.mat-list-item-with-avatar,.mat-list .mat-list-option.mat-list-item-with-avatar,.mat-nav-list .mat-list-item.mat-list-item-with-avatar,.mat-nav-list .mat-list-option.mat-list-item-with-avatar,.mat-selection-list .mat-list-item.mat-list-item-with-avatar,.mat-selection-list .mat-list-option.mat-list-item-with-avatar{height:56px}.mat-list .mat-list-item.mat-2-line,.mat-list .mat-list-option.mat-2-line,.mat-nav-list .mat-list-item.mat-2-line,.mat-nav-list .mat-list-option.mat-2-line,.mat-selection-list .mat-list-item.mat-2-line,.mat-selection-list .mat-list-option.mat-2-line{height:72px}.mat-list .mat-list-item.mat-3-line,.mat-list .mat-list-option.mat-3-line,.mat-nav-list .mat-list-item.mat-3-line,.mat-nav-list .mat-list-option.mat-3-line,.mat-selection-list .mat-list-item.mat-3-line,.mat-selection-list .mat-list-option.mat-3-line{height:88px}.mat-list .mat-list-item.mat-multi-line,.mat-list .mat-list-option.mat-multi-line,.mat-nav-list .mat-list-item.mat-multi-line,.mat-nav-list .mat-list-option.mat-multi-line,.mat-selection-list .mat-list-item.mat-multi-line,.mat-selection-list .mat-list-option.mat-multi-line{height:auto}.mat-list .mat-list-item.mat-multi-line .mat-list-item-content,.mat-list .mat-list-option.mat-multi-line .mat-list-item-content,.mat-nav-list .mat-list-item.mat-multi-line .mat-list-item-content,.mat-nav-list .mat-list-option.mat-multi-line .mat-list-item-content,.mat-selection-list .mat-list-item.mat-multi-line .mat-list-item-content,.mat-selection-list .mat-list-option.mat-multi-line .mat-list-item-content{padding-top:16px;padding-bottom:16px}.mat-list .mat-list-item .mat-list-text,.mat-list .mat-list-option .mat-list-text,.mat-nav-list .mat-list-item .mat-list-text,.mat-nav-list .mat-list-option .mat-list-text,.mat-selection-list .mat-list-item .mat-list-text,.mat-selection-list .mat-list-option .mat-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden;padding:0}.mat-list .mat-list-item .mat-list-text>*,.mat-list .mat-list-option .mat-list-text>*,.mat-nav-list .mat-list-item .mat-list-text>*,.mat-nav-list .mat-list-option .mat-list-text>*,.mat-selection-list .mat-list-item .mat-list-text>*,.mat-selection-list .mat-list-option .mat-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-list .mat-list-item .mat-list-text:empty,.mat-list .mat-list-option .mat-list-text:empty,.mat-nav-list .mat-list-item .mat-list-text:empty,.mat-nav-list .mat-list-option .mat-list-text:empty,.mat-selection-list .mat-list-item .mat-list-text:empty,.mat-selection-list .mat-list-option .mat-list-text:empty{display:none}.mat-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}[dir=rtl] .mat-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:16px;padding-left:0}.mat-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-left:0;padding-right:16px}[dir=rtl] .mat-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}.mat-list .mat-list-item .mat-list-avatar,.mat-list .mat-list-option .mat-list-avatar,.mat-nav-list .mat-list-item .mat-list-avatar,.mat-nav-list .mat-list-option .mat-list-avatar,.mat-selection-list .mat-list-item .mat-list-avatar,.mat-selection-list .mat-list-option .mat-list-avatar{flex-shrink:0;width:40px;height:40px;border-radius:50%}.mat-list .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-list .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-nav-list .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-nav-list .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-selection-list .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-selection-list .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:72px;width:calc(100% - 72px)}[dir=rtl] .mat-list .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-list .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:auto;margin-right:72px}.mat-list .mat-list-item .mat-list-icon,.mat-list .mat-list-option .mat-list-icon,.mat-nav-list .mat-list-item .mat-list-icon,.mat-nav-list .mat-list-option .mat-list-icon,.mat-selection-list .mat-list-item .mat-list-icon,.mat-selection-list .mat-list-option .mat-list-icon{flex-shrink:0;width:24px;height:24px;font-size:24px;box-sizing:content-box;border-radius:50%;padding:4px}.mat-list .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-list .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-nav-list .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-nav-list .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-selection-list .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-selection-list .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:64px;width:calc(100% - 64px)}[dir=rtl] .mat-list .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-list .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:auto;margin-right:64px}.mat-list .mat-list-item .mat-divider,.mat-list .mat-list-option .mat-divider,.mat-nav-list .mat-list-item .mat-divider,.mat-nav-list .mat-list-option .mat-divider,.mat-selection-list .mat-list-item .mat-divider,.mat-selection-list .mat-list-option .mat-divider{position:absolute;bottom:0;left:0;width:100%;margin:0}[dir=rtl] .mat-list .mat-list-item .mat-divider,[dir=rtl] .mat-list .mat-list-option .mat-divider,[dir=rtl] .mat-nav-list .mat-list-item .mat-divider,[dir=rtl] .mat-nav-list .mat-list-option .mat-divider,[dir=rtl] .mat-selection-list .mat-list-item .mat-divider,[dir=rtl] .mat-selection-list .mat-list-option .mat-divider{margin-left:auto;margin-right:0}.mat-list .mat-list-item .mat-divider.mat-divider-inset,.mat-list .mat-list-option .mat-divider.mat-divider-inset,.mat-nav-list .mat-list-item .mat-divider.mat-divider-inset,.mat-nav-list .mat-list-option .mat-divider.mat-divider-inset,.mat-selection-list .mat-list-item .mat-divider.mat-divider-inset,.mat-selection-list .mat-list-option .mat-divider.mat-divider-inset{position:absolute}.mat-list[dense],.mat-nav-list[dense],.mat-selection-list[dense]{padding-top:4px;display:block}.mat-list[dense] .mat-subheader,.mat-nav-list[dense] .mat-subheader,.mat-selection-list[dense] .mat-subheader{height:40px;line-height:8px}.mat-list[dense] .mat-subheader:first-child,.mat-nav-list[dense] .mat-subheader:first-child,.mat-selection-list[dense] .mat-subheader:first-child{margin-top:-4px}.mat-list[dense] .mat-list-item,.mat-list[dense] .mat-list-option,.mat-nav-list[dense] .mat-list-item,.mat-nav-list[dense] .mat-list-option,.mat-selection-list[dense] .mat-list-item,.mat-selection-list[dense] .mat-list-option{display:block;height:40px}.mat-list[dense] .mat-list-item .mat-list-item-content,.mat-list[dense] .mat-list-option .mat-list-item-content,.mat-nav-list[dense] .mat-list-item .mat-list-item-content,.mat-nav-list[dense] .mat-list-option .mat-list-item-content,.mat-selection-list[dense] .mat-list-item .mat-list-item-content,.mat-selection-list[dense] .mat-list-option .mat-list-item-content{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:0 16px;position:relative;height:inherit}.mat-list[dense] .mat-list-item .mat-list-item-content-reverse,.mat-list[dense] .mat-list-option .mat-list-item-content-reverse,.mat-nav-list[dense] .mat-list-item .mat-list-item-content-reverse,.mat-nav-list[dense] .mat-list-option .mat-list-item-content-reverse,.mat-selection-list[dense] .mat-list-item .mat-list-item-content-reverse,.mat-selection-list[dense] .mat-list-option .mat-list-item-content-reverse{display:flex;align-items:center;padding:0 16px;flex-direction:row-reverse;justify-content:space-around}.mat-list[dense] .mat-list-item .mat-list-item-ripple,.mat-list[dense] .mat-list-option .mat-list-item-ripple,.mat-nav-list[dense] .mat-list-item .mat-list-item-ripple,.mat-nav-list[dense] .mat-list-option .mat-list-item-ripple,.mat-selection-list[dense] .mat-list-item .mat-list-item-ripple,.mat-selection-list[dense] .mat-list-option .mat-list-item-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-list[dense] .mat-list-item.mat-list-item-with-avatar,.mat-list[dense] .mat-list-option.mat-list-item-with-avatar,.mat-nav-list[dense] .mat-list-item.mat-list-item-with-avatar,.mat-nav-list[dense] .mat-list-option.mat-list-item-with-avatar,.mat-selection-list[dense] .mat-list-item.mat-list-item-with-avatar,.mat-selection-list[dense] .mat-list-option.mat-list-item-with-avatar{height:48px}.mat-list[dense] .mat-list-item.mat-2-line,.mat-list[dense] .mat-list-option.mat-2-line,.mat-nav-list[dense] .mat-list-item.mat-2-line,.mat-nav-list[dense] .mat-list-option.mat-2-line,.mat-selection-list[dense] .mat-list-item.mat-2-line,.mat-selection-list[dense] .mat-list-option.mat-2-line{height:60px}.mat-list[dense] .mat-list-item.mat-3-line,.mat-list[dense] .mat-list-option.mat-3-line,.mat-nav-list[dense] .mat-list-item.mat-3-line,.mat-nav-list[dense] .mat-list-option.mat-3-line,.mat-selection-list[dense] .mat-list-item.mat-3-line,.mat-selection-list[dense] .mat-list-option.mat-3-line{height:76px}.mat-list[dense] .mat-list-item.mat-multi-line,.mat-list[dense] .mat-list-option.mat-multi-line,.mat-nav-list[dense] .mat-list-item.mat-multi-line,.mat-nav-list[dense] .mat-list-option.mat-multi-line,.mat-selection-list[dense] .mat-list-item.mat-multi-line,.mat-selection-list[dense] .mat-list-option.mat-multi-line{height:auto}.mat-list[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-list[dense] .mat-list-option.mat-multi-line .mat-list-item-content,.mat-nav-list[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-nav-list[dense] .mat-list-option.mat-multi-line .mat-list-item-content,.mat-selection-list[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-selection-list[dense] .mat-list-option.mat-multi-line .mat-list-item-content{padding-top:16px;padding-bottom:16px}.mat-list[dense] .mat-list-item .mat-list-text,.mat-list[dense] .mat-list-option .mat-list-text,.mat-nav-list[dense] .mat-list-item .mat-list-text,.mat-nav-list[dense] .mat-list-option .mat-list-text,.mat-selection-list[dense] .mat-list-item .mat-list-text,.mat-selection-list[dense] .mat-list-option .mat-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden;padding:0}.mat-list[dense] .mat-list-item .mat-list-text>*,.mat-list[dense] .mat-list-option .mat-list-text>*,.mat-nav-list[dense] .mat-list-item .mat-list-text>*,.mat-nav-list[dense] .mat-list-option .mat-list-text>*,.mat-selection-list[dense] .mat-list-item .mat-list-text>*,.mat-selection-list[dense] .mat-list-option .mat-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-list[dense] .mat-list-item .mat-list-text:empty,.mat-list[dense] .mat-list-option .mat-list-text:empty,.mat-nav-list[dense] .mat-list-item .mat-list-text:empty,.mat-nav-list[dense] .mat-list-option .mat-list-text:empty,.mat-selection-list[dense] .mat-list-item .mat-list-text:empty,.mat-selection-list[dense] .mat-list-option .mat-list-text:empty{display:none}.mat-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:16px;padding-left:0}.mat-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-left:0;padding-right:16px}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}.mat-list[dense] .mat-list-item .mat-list-avatar,.mat-list[dense] .mat-list-option .mat-list-avatar,.mat-nav-list[dense] .mat-list-item .mat-list-avatar,.mat-nav-list[dense] .mat-list-option .mat-list-avatar,.mat-selection-list[dense] .mat-list-item .mat-list-avatar,.mat-selection-list[dense] .mat-list-option .mat-list-avatar{flex-shrink:0;width:36px;height:36px;border-radius:50%}.mat-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-nav-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-nav-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-selection-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-selection-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:68px;width:calc(100% - 68px)}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:auto;margin-right:68px}.mat-list[dense] .mat-list-item .mat-list-icon,.mat-list[dense] .mat-list-option .mat-list-icon,.mat-nav-list[dense] .mat-list-item .mat-list-icon,.mat-nav-list[dense] .mat-list-option .mat-list-icon,.mat-selection-list[dense] .mat-list-item .mat-list-icon,.mat-selection-list[dense] .mat-list-option .mat-list-icon{flex-shrink:0;width:20px;height:20px;font-size:20px;box-sizing:content-box;border-radius:50%;padding:4px}.mat-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-nav-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-nav-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-selection-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-selection-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:60px;width:calc(100% - 60px)}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:auto;margin-right:60px}.mat-list[dense] .mat-list-item .mat-divider,.mat-list[dense] .mat-list-option .mat-divider,.mat-nav-list[dense] .mat-list-item .mat-divider,.mat-nav-list[dense] .mat-list-option .mat-divider,.mat-selection-list[dense] .mat-list-item .mat-divider,.mat-selection-list[dense] .mat-list-option .mat-divider{position:absolute;bottom:0;left:0;width:100%;margin:0}[dir=rtl] .mat-list[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-list[dense] .mat-list-option .mat-divider,[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-divider,[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-divider{margin-left:auto;margin-right:0}.mat-list[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-list[dense] .mat-list-option .mat-divider.mat-divider-inset,.mat-nav-list[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-nav-list[dense] .mat-list-option .mat-divider.mat-divider-inset,.mat-selection-list[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-selection-list[dense] .mat-list-option .mat-divider.mat-divider-inset{position:absolute}.mat-nav-list a{text-decoration:none;color:inherit}.mat-nav-list .mat-list-item{cursor:pointer;outline:0}.mat-list-option:not(.mat-list-item-disabled){cursor:pointer;outline:0}"],
	                    inputs: ['disableRipple'],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatList.ctorParameters = function () { return []; };
	    return MatList;
	}(_MatListMixinBase));
	/**
	 * Directive whose purpose is to add the mat- CSS styling to this selector.
	 * \@docs-private
	 */
	var MatListAvatarCssMatStyler = /** @class */ (function () {
	    function MatListAvatarCssMatStyler() {
	    }
	    MatListAvatarCssMatStyler.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-list-avatar], [matListAvatar]',
	                    host: { 'class': 'mat-list-avatar' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatListAvatarCssMatStyler.ctorParameters = function () { return []; };
	    return MatListAvatarCssMatStyler;
	}());
	/**
	 * Directive whose purpose is to add the mat- CSS styling to this selector.
	 * \@docs-private
	 */
	var MatListIconCssMatStyler = /** @class */ (function () {
	    function MatListIconCssMatStyler() {
	    }
	    MatListIconCssMatStyler.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-list-icon], [matListIcon]',
	                    host: { 'class': 'mat-list-icon' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatListIconCssMatStyler.ctorParameters = function () { return []; };
	    return MatListIconCssMatStyler;
	}());
	/**
	 * Directive whose purpose is to add the mat- CSS styling to this selector.
	 * \@docs-private
	 */
	var MatListSubheaderCssMatStyler = /** @class */ (function () {
	    function MatListSubheaderCssMatStyler() {
	    }
	    MatListSubheaderCssMatStyler.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-subheader], [matSubheader]',
	                    host: { 'class': 'mat-subheader' }
	                },] },
	    ];
	    /** @nocollapse */
	    MatListSubheaderCssMatStyler.ctorParameters = function () { return []; };
	    return MatListSubheaderCssMatStyler;
	}());
	/**
	 * An item within a Material Design list.
	 */
	var MatListItem = /** @class */ (function (_super) {
	    __extends(MatListItem, _super);
	    function MatListItem(_element, _navList) {
	        var _this = _super.call(this) || this;
	        _this._element = _element;
	        _this._navList = _navList;
	        _this._isNavList = false;
	        _this._isNavList = !!_navList;
	        return _this;
	    }
	    /**
	     * @return {?}
	     */
	    MatListItem.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        // TODO: consider turning the setter into a function, it doesn't do anything as a class.
	        // tslint:disable-next-line:no-unused-expression
	        new MatLineSetter(this._lines, this._element);
	    };
	    /** Whether this list item should show a ripple effect when clicked. */
	    /**
	     * Whether this list item should show a ripple effect when clicked.
	     * @return {?}
	     */
	    MatListItem.prototype._isRippleDisabled = /**
	     * Whether this list item should show a ripple effect when clicked.
	     * @return {?}
	     */
	    function () {
	        return !this._isNavList || this.disableRipple || this._navList.disableRipple;
	    };
	    /**
	     * @return {?}
	     */
	    MatListItem.prototype._handleFocus = /**
	     * @return {?}
	     */
	    function () {
	        this._element.nativeElement.classList.add('mat-list-item-focus');
	    };
	    /**
	     * @return {?}
	     */
	    MatListItem.prototype._handleBlur = /**
	     * @return {?}
	     */
	    function () {
	        this._element.nativeElement.classList.remove('mat-list-item-focus');
	    };
	    /** Retrieves the DOM element of the component host. */
	    /**
	     * Retrieves the DOM element of the component host.
	     * @return {?}
	     */
	    MatListItem.prototype._getHostElement = /**
	     * Retrieves the DOM element of the component host.
	     * @return {?}
	     */
	    function () {
	        return this._element.nativeElement;
	    };
	    MatListItem.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-list-item, a[mat-list-item]',
	                    exportAs: 'matListItem',
	                    host: {
	                        'class': 'mat-list-item',
	                        // @deletion-target 7.0.0 Remove `mat-list-item-avatar` in favor of `mat-list-item-with-avatar`.
	                        '[class.mat-list-item-avatar]': '_avatar',
	                        '[class.mat-list-item-with-avatar]': '_avatar',
	                        '(focus)': '_handleFocus()',
	                        '(blur)': '_handleBlur()',
	                    },
	                    inputs: ['disableRipple'],
	                    template: "<div class=\"mat-list-item-content\"><div class=\"mat-list-item-ripple\" mat-ripple [matRippleTrigger]=\"_getHostElement()\" [matRippleDisabled]=\"_isRippleDisabled()\"></div><ng-content select=\"[mat-list-avatar], [mat-list-icon], [matListAvatar], [matListIcon]\"></ng-content><div class=\"mat-list-text\"><ng-content select=\"[mat-line], [matLine]\"></ng-content></div><ng-content></ng-content></div>",
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatListItem.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: MatNavList, decorators: [{ type: _angular_core.Optional },] },
	    ]; };
	    MatListItem.propDecorators = {
	        "_lines": [{ type: _angular_core.ContentChildren, args: [MatLine,] },],
	        "_avatar": [{ type: _angular_core.ContentChild, args: [MatListAvatarCssMatStyler,] },],
	    };
	    return MatListItem;
	}(_MatListItemMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 */
	var MatSelectionListBase = /** @class */ (function () {
	    function MatSelectionListBase() {
	    }
	    return MatSelectionListBase;
	}());
	var _MatSelectionListMixinBase = mixinDisableRipple(mixinDisabled(MatSelectionListBase));
	/**
	 * \@docs-private
	 */
	var MatListOptionBase = /** @class */ (function () {
	    function MatListOptionBase() {
	    }
	    return MatListOptionBase;
	}());
	var _MatListOptionMixinBase = mixinDisableRipple(MatListOptionBase);
	/**
	 * \@docs-private
	 */
	var MAT_SELECTION_LIST_VALUE_ACCESSOR = {
	    provide: _angular_forms.NG_VALUE_ACCESSOR,
	    useExisting: _angular_core.forwardRef(function () { return MatSelectionList; }),
	    multi: true
	};
	/**
	 * Change event object emitted by MatListOption whenever the selected state changes.
	 * @deprecated Use the `MatSelectionListChange` event on the selection list instead.
	 * \@deletion-target 6.0.0
	 */
	var MatListOptionChange = /** @class */ (function () {
	    function MatListOptionChange(source, selected) {
	        this.source = source;
	        this.selected = selected;
	    }
	    return MatListOptionChange;
	}());
	/**
	 * Change event that is being fired whenever the selected state of an option changes.
	 */
	var MatSelectionListChange = /** @class */ (function () {
	    function MatSelectionListChange(source, option) {
	        this.source = source;
	        this.option = option;
	    }
	    return MatSelectionListChange;
	}());
	/**
	 * Component for list-options of selection-list. Each list-option can automatically
	 * generate a checkbox and can put current item into the selectionModel of selection-list
	 * if the current item is selected.
	 */
	var MatListOption = /** @class */ (function (_super) {
	    __extends(MatListOption, _super);
	    function MatListOption(_element, _changeDetector, /** @docs-private */
	        selectionList) {
	        var _this = _super.call(this) || this;
	        _this._element = _element;
	        _this._changeDetector = _changeDetector;
	        _this.selectionList = selectionList;
	        _this._selected = false;
	        _this._disabled = false;
	        /**
	         * Whether the option has focus.
	         */
	        _this._hasFocus = false;
	        /**
	         * Whether the label should appear before or after the checkbox. Defaults to 'after'
	         */
	        _this.checkboxPosition = 'after';
	        /**
	         * Emits a change event whenever the selected state of an option changes.
	         * @deprecated Use the `selectionChange` event on the `<mat-selection-list>` instead.
	         * \@deletion-target 6.0.0
	         */
	        _this.selectionChange = new _angular_core.EventEmitter();
	        return _this;
	    }
	    Object.defineProperty(MatListOption.prototype, "disabled", {
	        get: /**
	         * Whether the option is disabled.
	         * @return {?}
	         */
	        function () { return this._disabled || (this.selectionList && this.selectionList.disabled); },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            var /** @type {?} */ newValue = _angular_cdk_coercion.coerceBooleanProperty(value);
	            if (newValue !== this._disabled) {
	                this._disabled = newValue;
	                this._changeDetector.markForCheck();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatListOption.prototype, "selected", {
	        get: /**
	         * Whether the option is selected.
	         * @return {?}
	         */
	        function () { return this.selectionList.selectedOptions.isSelected(this); },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            var /** @type {?} */ isSelected = _angular_cdk_coercion.coerceBooleanProperty(value);
	            if (isSelected !== this._selected) {
	                this._setSelected(isSelected);
	                this.selectionList._reportValueChange();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatListOption.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        // List options that are selected at initialization can't be reported properly to the form
	        // control. This is because it takes some time until the selection-list knows about all
	        // available options. Also it can happen that the ControlValueAccessor has an initial value
	        // that should be used instead. Deferring the value change report to the next tick ensures
	        // that the form control value is not being overwritten.
	        var /** @type {?} */ wasSelected = this._selected;
	        Promise.resolve().then(function () {
	            if (_this._selected || wasSelected) {
	                _this.selected = true;
	                _this._changeDetector.markForCheck();
	            }
	        });
	    };
	    /**
	     * @return {?}
	     */
	    MatListOption.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        // TODO: consider turning the setter into a function, it doesn't do anything as a class.
	        // tslint:disable-next-line:no-unused-expression
	        new MatLineSetter(this._lines, this._element);
	    };
	    /**
	     * @return {?}
	     */
	    MatListOption.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this.selected) {
	            // We have to delay this until the next tick in order
	            // to avoid changed after checked errors.
	            Promise.resolve().then(function () { return _this.selected = false; });
	        }
	        this.selectionList._removeOptionFromList(this);
	    };
	    /** Toggles the selection state of the option. */
	    /**
	     * Toggles the selection state of the option.
	     * @return {?}
	     */
	    MatListOption.prototype.toggle = /**
	     * Toggles the selection state of the option.
	     * @return {?}
	     */
	    function () {
	        this.selected = !this.selected;
	    };
	    /** Allows for programmatic focusing of the option. */
	    /**
	     * Allows for programmatic focusing of the option.
	     * @return {?}
	     */
	    MatListOption.prototype.focus = /**
	     * Allows for programmatic focusing of the option.
	     * @return {?}
	     */
	    function () {
	        this._element.nativeElement.focus();
	    };
	    /**
	     * Returns the list item's text label. Implemented as a part of the FocusKeyManager.
	     * @docs-private
	     */
	    /**
	     * Returns the list item's text label. Implemented as a part of the FocusKeyManager.
	     * \@docs-private
	     * @return {?}
	     */
	    MatListOption.prototype.getLabel = /**
	     * Returns the list item's text label. Implemented as a part of the FocusKeyManager.
	     * \@docs-private
	     * @return {?}
	     */
	    function () {
	        return this._text ? this._text.nativeElement.textContent : '';
	    };
	    /** Whether this list item should show a ripple effect when clicked. */
	    /**
	     * Whether this list item should show a ripple effect when clicked.
	     * @return {?}
	     */
	    MatListOption.prototype._isRippleDisabled = /**
	     * Whether this list item should show a ripple effect when clicked.
	     * @return {?}
	     */
	    function () {
	        return this.disabled || this.disableRipple || this.selectionList.disableRipple;
	    };
	    /**
	     * @return {?}
	     */
	    MatListOption.prototype._handleClick = /**
	     * @return {?}
	     */
	    function () {
	        if (!this.disabled) {
	            this.toggle();
	            // Emit a change event if the selected state of the option changed through user interaction.
	            this.selectionList._emitChangeEvent(this);
	            // TODO: the `selectionChange` event on the option is deprecated. Remove that in the future.
	            this._emitDeprecatedChangeEvent();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatListOption.prototype._handleFocus = /**
	     * @return {?}
	     */
	    function () {
	        this._hasFocus = true;
	        this.selectionList._setFocusedOption(this);
	    };
	    /**
	     * @return {?}
	     */
	    MatListOption.prototype._handleBlur = /**
	     * @return {?}
	     */
	    function () {
	        this._hasFocus = false;
	        this.selectionList._onTouched();
	    };
	    /** Retrieves the DOM element of the component host. */
	    /**
	     * Retrieves the DOM element of the component host.
	     * @return {?}
	     */
	    MatListOption.prototype._getHostElement = /**
	     * Retrieves the DOM element of the component host.
	     * @return {?}
	     */
	    function () {
	        return this._element.nativeElement;
	    };
	    /** Sets the selected state of the option. */
	    /**
	     * Sets the selected state of the option.
	     * @param {?} selected
	     * @return {?}
	     */
	    MatListOption.prototype._setSelected = /**
	     * Sets the selected state of the option.
	     * @param {?} selected
	     * @return {?}
	     */
	    function (selected) {
	        if (selected === this._selected) {
	            return;
	        }
	        this._selected = selected;
	        if (selected) {
	            this.selectionList.selectedOptions.select(this);
	        }
	        else {
	            this.selectionList.selectedOptions.deselect(this);
	        }
	        this._changeDetector.markForCheck();
	    };
	    /** Emits a selectionChange event for this option. */
	    /**
	     * Emits a selectionChange event for this option.
	     * @return {?}
	     */
	    MatListOption.prototype._emitDeprecatedChangeEvent = /**
	     * Emits a selectionChange event for this option.
	     * @return {?}
	     */
	    function () {
	        // TODO: the `selectionChange` event on the option is deprecated. Remove that in the future.
	        this.selectionChange.emit(new MatListOptionChange(this, this.selected));
	    };
	    MatListOption.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-list-option',
	                    exportAs: 'matListOption',
	                    inputs: ['disableRipple'],
	                    host: {
	                        'role': 'option',
	                        'class': 'mat-list-item mat-list-option',
	                        '(focus)': '_handleFocus()',
	                        '(blur)': '_handleBlur()',
	                        '(click)': '_handleClick()',
	                        'tabindex': '-1',
	                        '[class.mat-list-item-disabled]': 'disabled',
	                        '[class.mat-list-item-focus]': '_hasFocus',
	                        '[attr.aria-selected]': 'selected.toString()',
	                        '[attr.aria-disabled]': 'disabled.toString()',
	                    },
	                    template: "<div class=\"mat-list-item-content\" [class.mat-list-item-content-reverse]=\"checkboxPosition == 'after'\"><div mat-ripple class=\"mat-list-item-ripple\" [matRippleTrigger]=\"_getHostElement()\" [matRippleDisabled]=\"_isRippleDisabled()\"></div><mat-pseudo-checkbox [state]=\"selected ? 'checked' : 'unchecked'\" [disabled]=\"disabled\"></mat-pseudo-checkbox><div class=\"mat-list-text\" #text><ng-content></ng-content></div></div>",
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatListOption.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: MatSelectionList, decorators: [{ type: _angular_core.Inject, args: [_angular_core.forwardRef(function () { return MatSelectionList; }),] },] },
	    ]; };
	    MatListOption.propDecorators = {
	        "_lines": [{ type: _angular_core.ContentChildren, args: [MatLine,] },],
	        "_text": [{ type: _angular_core.ViewChild, args: ['text',] },],
	        "checkboxPosition": [{ type: _angular_core.Input },],
	        "value": [{ type: _angular_core.Input },],
	        "disabled": [{ type: _angular_core.Input },],
	        "selected": [{ type: _angular_core.Input },],
	        "selectionChange": [{ type: _angular_core.Output },],
	    };
	    return MatListOption;
	}(_MatListOptionMixinBase));
	/**
	 * Material Design list component where each item is a selectable option. Behaves as a listbox.
	 */
	var MatSelectionList = /** @class */ (function (_super) {
	    __extends(MatSelectionList, _super);
	    function MatSelectionList(_element, tabIndex) {
	        var _this = _super.call(this) || this;
	        _this._element = _element;
	        /**
	         * Emits a change event whenever the selected state of an option changes.
	         */
	        _this.selectionChange = new _angular_core.EventEmitter();
	        /**
	         * Tabindex of the selection list.
	         */
	        _this.tabIndex = 0;
	        /**
	         * The currently selected options.
	         */
	        _this.selectedOptions = new _angular_cdk_collections.SelectionModel(true);
	        /**
	         * View to model callback that should be called whenever the selected options change.
	         */
	        _this._onChange = function (_) { };
	        _this._modelChanges = rxjs_Subscription.Subscription.EMPTY;
	        /**
	         * View to model callback that should be called if the list or its options lost focus.
	         */
	        _this._onTouched = function () { };
	        _this.tabIndex = parseInt(tabIndex) || 0;
	        return _this;
	    }
	    /**
	     * @return {?}
	     */
	    MatSelectionList.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        this._keyManager = new _angular_cdk_a11y.FocusKeyManager(this.options)
	            .withWrap()
	            .withTypeAhead()
	            .skipPredicate(function () { return false; });
	        if (this._tempValues) {
	            this._setOptionsFromValues(this._tempValues);
	            this._tempValues = null;
	        }
	        // Sync external changes to the model back to the options.
	        this._modelChanges = /** @type {?} */ ((this.selectedOptions.onChange)).subscribe(function (event) {
	            if (event.added) {
	                for (var _i = 0, _a = event.added; _i < _a.length; _i++) {
	                    var item = _a[_i];
	                    item.selected = true;
	                }
	            }
	            if (event.removed) {
	                for (var _b = 0, _c = event.removed; _b < _c.length; _b++) {
	                    var item = _c[_b];
	                    item.selected = false;
	                }
	            }
	        });
	    };
	    /**
	     * @return {?}
	     */
	    MatSelectionList.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._modelChanges.unsubscribe();
	    };
	    /** Focuses the last active list option. */
	    /**
	     * Focuses the last active list option.
	     * @return {?}
	     */
	    MatSelectionList.prototype.focus = /**
	     * Focuses the last active list option.
	     * @return {?}
	     */
	    function () {
	        this._element.nativeElement.focus();
	    };
	    /** Selects all of the options. */
	    /**
	     * Selects all of the options.
	     * @return {?}
	     */
	    MatSelectionList.prototype.selectAll = /**
	     * Selects all of the options.
	     * @return {?}
	     */
	    function () {
	        this.options.forEach(function (option) { return option._setSelected(true); });
	        this._reportValueChange();
	    };
	    /** Deselects all of the options. */
	    /**
	     * Deselects all of the options.
	     * @return {?}
	     */
	    MatSelectionList.prototype.deselectAll = /**
	     * Deselects all of the options.
	     * @return {?}
	     */
	    function () {
	        this.options.forEach(function (option) { return option._setSelected(false); });
	        this._reportValueChange();
	    };
	    /** Sets the focused option of the selection-list. */
	    /**
	     * Sets the focused option of the selection-list.
	     * @param {?} option
	     * @return {?}
	     */
	    MatSelectionList.prototype._setFocusedOption = /**
	     * Sets the focused option of the selection-list.
	     * @param {?} option
	     * @return {?}
	     */
	    function (option) {
	        this._keyManager.updateActiveItemIndex(this._getOptionIndex(option));
	    };
	    /** Removes an option from the selection list and updates the active item. */
	    /**
	     * Removes an option from the selection list and updates the active item.
	     * @param {?} option
	     * @return {?}
	     */
	    MatSelectionList.prototype._removeOptionFromList = /**
	     * Removes an option from the selection list and updates the active item.
	     * @param {?} option
	     * @return {?}
	     */
	    function (option) {
	        if (option._hasFocus) {
	            var /** @type {?} */ optionIndex = this._getOptionIndex(option);
	            // Check whether the option is the last item
	            if (optionIndex > 0) {
	                this._keyManager.setPreviousItemActive();
	            }
	            else if (optionIndex === 0 && this.options.length > 1) {
	                this._keyManager.setNextItemActive();
	            }
	        }
	    };
	    /** Passes relevant key presses to our key manager. */
	    /**
	     * Passes relevant key presses to our key manager.
	     * @param {?} event
	     * @return {?}
	     */
	    MatSelectionList.prototype._keydown = /**
	     * Passes relevant key presses to our key manager.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        switch (event.keyCode) {
	            case _angular_cdk_keycodes.SPACE:
	            case _angular_cdk_keycodes.ENTER:
	                if (!this.disabled) {
	                    this._toggleSelectOnFocusedOption();
	                    // Always prevent space from scrolling the page since the list has focus
	                    event.preventDefault();
	                }
	                break;
	            case _angular_cdk_keycodes.HOME:
	            case _angular_cdk_keycodes.END:
	                event.keyCode === _angular_cdk_keycodes.HOME ? this._keyManager.setFirstItemActive() :
	                    this._keyManager.setLastItemActive();
	                event.preventDefault();
	                break;
	            default:
	                this._keyManager.onKeydown(event);
	        }
	    };
	    /** Reports a value change to the ControlValueAccessor */
	    /**
	     * Reports a value change to the ControlValueAccessor
	     * @return {?}
	     */
	    MatSelectionList.prototype._reportValueChange = /**
	     * Reports a value change to the ControlValueAccessor
	     * @return {?}
	     */
	    function () {
	        if (this.options) {
	            this._onChange(this._getSelectedOptionValues());
	        }
	    };
	    /** Emits a change event if the selected state of an option changed. */
	    /**
	     * Emits a change event if the selected state of an option changed.
	     * @param {?} option
	     * @return {?}
	     */
	    MatSelectionList.prototype._emitChangeEvent = /**
	     * Emits a change event if the selected state of an option changed.
	     * @param {?} option
	     * @return {?}
	     */
	    function (option) {
	        this.selectionChange.emit(new MatSelectionListChange(this, option));
	    };
	    /** Implemented as part of ControlValueAccessor. */
	    /**
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} values
	     * @return {?}
	     */
	    MatSelectionList.prototype.writeValue = /**
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} values
	     * @return {?}
	     */
	    function (values) {
	        if (this.options) {
	            this._setOptionsFromValues(values || []);
	        }
	        else {
	            this._tempValues = values;
	        }
	    };
	    /** Implemented as a part of ControlValueAccessor. */
	    /**
	     * Implemented as a part of ControlValueAccessor.
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    MatSelectionList.prototype.setDisabledState = /**
	     * Implemented as a part of ControlValueAccessor.
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    function (isDisabled) {
	        if (this.options) {
	            this.options.forEach(function (option) { return option.disabled = isDisabled; });
	        }
	    };
	    /** Implemented as part of ControlValueAccessor. */
	    /**
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} fn
	     * @return {?}
	     */
	    MatSelectionList.prototype.registerOnChange = /**
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._onChange = fn;
	    };
	    /** Implemented as part of ControlValueAccessor. */
	    /**
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} fn
	     * @return {?}
	     */
	    MatSelectionList.prototype.registerOnTouched = /**
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this._onTouched = fn;
	    };
	    /**
	     * Returns the option with the specified value.
	     * @param {?} value
	     * @return {?}
	     */
	    MatSelectionList.prototype._getOptionByValue = /**
	     * Returns the option with the specified value.
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        return this.options.find(function (option) { return option.value === value; });
	    };
	    /**
	     * Sets the selected options based on the specified values.
	     * @param {?} values
	     * @return {?}
	     */
	    MatSelectionList.prototype._setOptionsFromValues = /**
	     * Sets the selected options based on the specified values.
	     * @param {?} values
	     * @return {?}
	     */
	    function (values) {
	        var _this = this;
	        this.options.forEach(function (option) { return option._setSelected(false); });
	        values
	            .map(function (value) { return _this._getOptionByValue(value); })
	            .filter(Boolean)
	            .forEach(function (option) { return ((option))._setSelected(true); });
	    };
	    /**
	     * Returns the values of the selected options.
	     * @return {?}
	     */
	    MatSelectionList.prototype._getSelectedOptionValues = /**
	     * Returns the values of the selected options.
	     * @return {?}
	     */
	    function () {
	        return this.options.filter(function (option) { return option.selected; }).map(function (option) { return option.value; });
	    };
	    /**
	     * Toggles the selected state of the currently focused option.
	     * @return {?}
	     */
	    MatSelectionList.prototype._toggleSelectOnFocusedOption = /**
	     * Toggles the selected state of the currently focused option.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ focusedIndex = this._keyManager.activeItemIndex;
	        if (focusedIndex != null && this._isValidIndex(focusedIndex)) {
	            var /** @type {?} */ focusedOption = this.options.toArray()[focusedIndex];
	            if (focusedOption) {
	                focusedOption.toggle();
	                // Emit a change event because the focused option changed its state through user
	                // interaction.
	                this._emitChangeEvent(focusedOption);
	                // TODO: the `selectionChange` event on the option is deprecated. Remove that in the future.
	                focusedOption._emitDeprecatedChangeEvent();
	            }
	        }
	    };
	    /**
	     * Utility to ensure all indexes are valid.
	     * @param {?} index The index to be checked.
	     * @return {?} True if the index is valid for our list of options.
	     */
	    MatSelectionList.prototype._isValidIndex = /**
	     * Utility to ensure all indexes are valid.
	     * @param {?} index The index to be checked.
	     * @return {?} True if the index is valid for our list of options.
	     */
	    function (index) {
	        return index >= 0 && index < this.options.length;
	    };
	    /**
	     * Returns the index of the specified list option.
	     * @param {?} option
	     * @return {?}
	     */
	    MatSelectionList.prototype._getOptionIndex = /**
	     * Returns the index of the specified list option.
	     * @param {?} option
	     * @return {?}
	     */
	    function (option) {
	        return this.options.toArray().indexOf(option);
	    };
	    MatSelectionList.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-selection-list',
	                    exportAs: 'matSelectionList',
	                    inputs: ['disabled', 'disableRipple', 'tabIndex'],
	                    host: {
	                        'role': 'listbox',
	                        '[tabIndex]': 'tabIndex',
	                        'class': 'mat-selection-list',
	                        '(focus)': 'focus()',
	                        '(blur)': '_onTouched()',
	                        '(keydown)': '_keydown($event)',
	                        '[attr.aria-disabled]': 'disabled.toString()',
	                    },
	                    template: '<ng-content></ng-content>',
	                    styles: [".mat-divider{display:block;margin:0;border-top-width:1px;border-top-style:solid}.mat-divider.mat-divider-vertical{border-top:0;border-right-width:1px;border-right-style:solid}.mat-divider.mat-divider-inset{margin-left:80px}[dir=rtl] .mat-divider.mat-divider-inset{margin-left:auto;margin-right:80px}.mat-subheader{display:flex;box-sizing:border-box;padding:16px;align-items:center}.mat-list .mat-subheader,.mat-nav-list .mat-subheader,.mat-selection-list .mat-subheader{margin:0}.mat-list,.mat-nav-list,.mat-selection-list{padding-top:8px;display:block}.mat-list .mat-subheader,.mat-nav-list .mat-subheader,.mat-selection-list .mat-subheader{height:48px;line-height:16px}.mat-list .mat-subheader:first-child,.mat-nav-list .mat-subheader:first-child,.mat-selection-list .mat-subheader:first-child{margin-top:-8px}.mat-list .mat-list-item,.mat-list .mat-list-option,.mat-nav-list .mat-list-item,.mat-nav-list .mat-list-option,.mat-selection-list .mat-list-item,.mat-selection-list .mat-list-option{display:block;height:48px}.mat-list .mat-list-item .mat-list-item-content,.mat-list .mat-list-option .mat-list-item-content,.mat-nav-list .mat-list-item .mat-list-item-content,.mat-nav-list .mat-list-option .mat-list-item-content,.mat-selection-list .mat-list-item .mat-list-item-content,.mat-selection-list .mat-list-option .mat-list-item-content{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:0 16px;position:relative;height:inherit}.mat-list .mat-list-item .mat-list-item-content-reverse,.mat-list .mat-list-option .mat-list-item-content-reverse,.mat-nav-list .mat-list-item .mat-list-item-content-reverse,.mat-nav-list .mat-list-option .mat-list-item-content-reverse,.mat-selection-list .mat-list-item .mat-list-item-content-reverse,.mat-selection-list .mat-list-option .mat-list-item-content-reverse{display:flex;align-items:center;padding:0 16px;flex-direction:row-reverse;justify-content:space-around}.mat-list .mat-list-item .mat-list-item-ripple,.mat-list .mat-list-option .mat-list-item-ripple,.mat-nav-list .mat-list-item .mat-list-item-ripple,.mat-nav-list .mat-list-option .mat-list-item-ripple,.mat-selection-list .mat-list-item .mat-list-item-ripple,.mat-selection-list .mat-list-option .mat-list-item-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-list .mat-list-item.mat-list-item-with-avatar,.mat-list .mat-list-option.mat-list-item-with-avatar,.mat-nav-list .mat-list-item.mat-list-item-with-avatar,.mat-nav-list .mat-list-option.mat-list-item-with-avatar,.mat-selection-list .mat-list-item.mat-list-item-with-avatar,.mat-selection-list .mat-list-option.mat-list-item-with-avatar{height:56px}.mat-list .mat-list-item.mat-2-line,.mat-list .mat-list-option.mat-2-line,.mat-nav-list .mat-list-item.mat-2-line,.mat-nav-list .mat-list-option.mat-2-line,.mat-selection-list .mat-list-item.mat-2-line,.mat-selection-list .mat-list-option.mat-2-line{height:72px}.mat-list .mat-list-item.mat-3-line,.mat-list .mat-list-option.mat-3-line,.mat-nav-list .mat-list-item.mat-3-line,.mat-nav-list .mat-list-option.mat-3-line,.mat-selection-list .mat-list-item.mat-3-line,.mat-selection-list .mat-list-option.mat-3-line{height:88px}.mat-list .mat-list-item.mat-multi-line,.mat-list .mat-list-option.mat-multi-line,.mat-nav-list .mat-list-item.mat-multi-line,.mat-nav-list .mat-list-option.mat-multi-line,.mat-selection-list .mat-list-item.mat-multi-line,.mat-selection-list .mat-list-option.mat-multi-line{height:auto}.mat-list .mat-list-item.mat-multi-line .mat-list-item-content,.mat-list .mat-list-option.mat-multi-line .mat-list-item-content,.mat-nav-list .mat-list-item.mat-multi-line .mat-list-item-content,.mat-nav-list .mat-list-option.mat-multi-line .mat-list-item-content,.mat-selection-list .mat-list-item.mat-multi-line .mat-list-item-content,.mat-selection-list .mat-list-option.mat-multi-line .mat-list-item-content{padding-top:16px;padding-bottom:16px}.mat-list .mat-list-item .mat-list-text,.mat-list .mat-list-option .mat-list-text,.mat-nav-list .mat-list-item .mat-list-text,.mat-nav-list .mat-list-option .mat-list-text,.mat-selection-list .mat-list-item .mat-list-text,.mat-selection-list .mat-list-option .mat-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden;padding:0}.mat-list .mat-list-item .mat-list-text>*,.mat-list .mat-list-option .mat-list-text>*,.mat-nav-list .mat-list-item .mat-list-text>*,.mat-nav-list .mat-list-option .mat-list-text>*,.mat-selection-list .mat-list-item .mat-list-text>*,.mat-selection-list .mat-list-option .mat-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-list .mat-list-item .mat-list-text:empty,.mat-list .mat-list-option .mat-list-text:empty,.mat-nav-list .mat-list-item .mat-list-text:empty,.mat-nav-list .mat-list-option .mat-list-text:empty,.mat-selection-list .mat-list-item .mat-list-text:empty,.mat-selection-list .mat-list-option .mat-list-text:empty{display:none}.mat-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}[dir=rtl] .mat-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:16px;padding-left:0}.mat-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-left:0;padding-right:16px}[dir=rtl] .mat-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}.mat-list .mat-list-item .mat-list-avatar,.mat-list .mat-list-option .mat-list-avatar,.mat-nav-list .mat-list-item .mat-list-avatar,.mat-nav-list .mat-list-option .mat-list-avatar,.mat-selection-list .mat-list-item .mat-list-avatar,.mat-selection-list .mat-list-option .mat-list-avatar{flex-shrink:0;width:40px;height:40px;border-radius:50%}.mat-list .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-list .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-nav-list .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-nav-list .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-selection-list .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-selection-list .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:72px;width:calc(100% - 72px)}[dir=rtl] .mat-list .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-list .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:auto;margin-right:72px}.mat-list .mat-list-item .mat-list-icon,.mat-list .mat-list-option .mat-list-icon,.mat-nav-list .mat-list-item .mat-list-icon,.mat-nav-list .mat-list-option .mat-list-icon,.mat-selection-list .mat-list-item .mat-list-icon,.mat-selection-list .mat-list-option .mat-list-icon{flex-shrink:0;width:24px;height:24px;font-size:24px;box-sizing:content-box;border-radius:50%;padding:4px}.mat-list .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-list .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-nav-list .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-nav-list .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-selection-list .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-selection-list .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:64px;width:calc(100% - 64px)}[dir=rtl] .mat-list .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-list .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:auto;margin-right:64px}.mat-list .mat-list-item .mat-divider,.mat-list .mat-list-option .mat-divider,.mat-nav-list .mat-list-item .mat-divider,.mat-nav-list .mat-list-option .mat-divider,.mat-selection-list .mat-list-item .mat-divider,.mat-selection-list .mat-list-option .mat-divider{position:absolute;bottom:0;left:0;width:100%;margin:0}[dir=rtl] .mat-list .mat-list-item .mat-divider,[dir=rtl] .mat-list .mat-list-option .mat-divider,[dir=rtl] .mat-nav-list .mat-list-item .mat-divider,[dir=rtl] .mat-nav-list .mat-list-option .mat-divider,[dir=rtl] .mat-selection-list .mat-list-item .mat-divider,[dir=rtl] .mat-selection-list .mat-list-option .mat-divider{margin-left:auto;margin-right:0}.mat-list .mat-list-item .mat-divider.mat-divider-inset,.mat-list .mat-list-option .mat-divider.mat-divider-inset,.mat-nav-list .mat-list-item .mat-divider.mat-divider-inset,.mat-nav-list .mat-list-option .mat-divider.mat-divider-inset,.mat-selection-list .mat-list-item .mat-divider.mat-divider-inset,.mat-selection-list .mat-list-option .mat-divider.mat-divider-inset{position:absolute}.mat-list[dense],.mat-nav-list[dense],.mat-selection-list[dense]{padding-top:4px;display:block}.mat-list[dense] .mat-subheader,.mat-nav-list[dense] .mat-subheader,.mat-selection-list[dense] .mat-subheader{height:40px;line-height:8px}.mat-list[dense] .mat-subheader:first-child,.mat-nav-list[dense] .mat-subheader:first-child,.mat-selection-list[dense] .mat-subheader:first-child{margin-top:-4px}.mat-list[dense] .mat-list-item,.mat-list[dense] .mat-list-option,.mat-nav-list[dense] .mat-list-item,.mat-nav-list[dense] .mat-list-option,.mat-selection-list[dense] .mat-list-item,.mat-selection-list[dense] .mat-list-option{display:block;height:40px}.mat-list[dense] .mat-list-item .mat-list-item-content,.mat-list[dense] .mat-list-option .mat-list-item-content,.mat-nav-list[dense] .mat-list-item .mat-list-item-content,.mat-nav-list[dense] .mat-list-option .mat-list-item-content,.mat-selection-list[dense] .mat-list-item .mat-list-item-content,.mat-selection-list[dense] .mat-list-option .mat-list-item-content{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:0 16px;position:relative;height:inherit}.mat-list[dense] .mat-list-item .mat-list-item-content-reverse,.mat-list[dense] .mat-list-option .mat-list-item-content-reverse,.mat-nav-list[dense] .mat-list-item .mat-list-item-content-reverse,.mat-nav-list[dense] .mat-list-option .mat-list-item-content-reverse,.mat-selection-list[dense] .mat-list-item .mat-list-item-content-reverse,.mat-selection-list[dense] .mat-list-option .mat-list-item-content-reverse{display:flex;align-items:center;padding:0 16px;flex-direction:row-reverse;justify-content:space-around}.mat-list[dense] .mat-list-item .mat-list-item-ripple,.mat-list[dense] .mat-list-option .mat-list-item-ripple,.mat-nav-list[dense] .mat-list-item .mat-list-item-ripple,.mat-nav-list[dense] .mat-list-option .mat-list-item-ripple,.mat-selection-list[dense] .mat-list-item .mat-list-item-ripple,.mat-selection-list[dense] .mat-list-option .mat-list-item-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-list[dense] .mat-list-item.mat-list-item-with-avatar,.mat-list[dense] .mat-list-option.mat-list-item-with-avatar,.mat-nav-list[dense] .mat-list-item.mat-list-item-with-avatar,.mat-nav-list[dense] .mat-list-option.mat-list-item-with-avatar,.mat-selection-list[dense] .mat-list-item.mat-list-item-with-avatar,.mat-selection-list[dense] .mat-list-option.mat-list-item-with-avatar{height:48px}.mat-list[dense] .mat-list-item.mat-2-line,.mat-list[dense] .mat-list-option.mat-2-line,.mat-nav-list[dense] .mat-list-item.mat-2-line,.mat-nav-list[dense] .mat-list-option.mat-2-line,.mat-selection-list[dense] .mat-list-item.mat-2-line,.mat-selection-list[dense] .mat-list-option.mat-2-line{height:60px}.mat-list[dense] .mat-list-item.mat-3-line,.mat-list[dense] .mat-list-option.mat-3-line,.mat-nav-list[dense] .mat-list-item.mat-3-line,.mat-nav-list[dense] .mat-list-option.mat-3-line,.mat-selection-list[dense] .mat-list-item.mat-3-line,.mat-selection-list[dense] .mat-list-option.mat-3-line{height:76px}.mat-list[dense] .mat-list-item.mat-multi-line,.mat-list[dense] .mat-list-option.mat-multi-line,.mat-nav-list[dense] .mat-list-item.mat-multi-line,.mat-nav-list[dense] .mat-list-option.mat-multi-line,.mat-selection-list[dense] .mat-list-item.mat-multi-line,.mat-selection-list[dense] .mat-list-option.mat-multi-line{height:auto}.mat-list[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-list[dense] .mat-list-option.mat-multi-line .mat-list-item-content,.mat-nav-list[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-nav-list[dense] .mat-list-option.mat-multi-line .mat-list-item-content,.mat-selection-list[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-selection-list[dense] .mat-list-option.mat-multi-line .mat-list-item-content{padding-top:16px;padding-bottom:16px}.mat-list[dense] .mat-list-item .mat-list-text,.mat-list[dense] .mat-list-option .mat-list-text,.mat-nav-list[dense] .mat-list-item .mat-list-text,.mat-nav-list[dense] .mat-list-option .mat-list-text,.mat-selection-list[dense] .mat-list-item .mat-list-text,.mat-selection-list[dense] .mat-list-option .mat-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden;padding:0}.mat-list[dense] .mat-list-item .mat-list-text>*,.mat-list[dense] .mat-list-option .mat-list-text>*,.mat-nav-list[dense] .mat-list-item .mat-list-text>*,.mat-nav-list[dense] .mat-list-option .mat-list-text>*,.mat-selection-list[dense] .mat-list-item .mat-list-text>*,.mat-selection-list[dense] .mat-list-option .mat-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-list[dense] .mat-list-item .mat-list-text:empty,.mat-list[dense] .mat-list-option .mat-list-text:empty,.mat-nav-list[dense] .mat-list-item .mat-list-text:empty,.mat-nav-list[dense] .mat-list-option .mat-list-text:empty,.mat-selection-list[dense] .mat-list-item .mat-list-text:empty,.mat-selection-list[dense] .mat-list-option .mat-list-text:empty{display:none}.mat-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-item-content .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-item-content .mat-list-text:not(:nth-child(2)){padding-right:16px;padding-left:0}.mat-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-nav-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),.mat-selection-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-left:0;padding-right:16px}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)),[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-item-content-reverse .mat-list-text:not(:nth-child(2)){padding-right:0;padding-left:16px}.mat-list[dense] .mat-list-item .mat-list-avatar,.mat-list[dense] .mat-list-option .mat-list-avatar,.mat-nav-list[dense] .mat-list-item .mat-list-avatar,.mat-nav-list[dense] .mat-list-option .mat-list-avatar,.mat-selection-list[dense] .mat-list-item .mat-list-avatar,.mat-selection-list[dense] .mat-list-option .mat-list-avatar{flex-shrink:0;width:36px;height:36px;border-radius:50%}.mat-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-nav-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-nav-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,.mat-selection-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-selection-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:68px;width:calc(100% - 68px)}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:auto;margin-right:68px}.mat-list[dense] .mat-list-item .mat-list-icon,.mat-list[dense] .mat-list-option .mat-list-icon,.mat-nav-list[dense] .mat-list-item .mat-list-icon,.mat-nav-list[dense] .mat-list-option .mat-list-icon,.mat-selection-list[dense] .mat-list-item .mat-list-icon,.mat-selection-list[dense] .mat-list-option .mat-list-icon{flex-shrink:0;width:20px;height:20px;font-size:20px;box-sizing:content-box;border-radius:50%;padding:4px}.mat-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-nav-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-nav-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,.mat-selection-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-selection-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:60px;width:calc(100% - 60px)}[dir=rtl] .mat-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:auto;margin-right:60px}.mat-list[dense] .mat-list-item .mat-divider,.mat-list[dense] .mat-list-option .mat-divider,.mat-nav-list[dense] .mat-list-item .mat-divider,.mat-nav-list[dense] .mat-list-option .mat-divider,.mat-selection-list[dense] .mat-list-item .mat-divider,.mat-selection-list[dense] .mat-list-option .mat-divider{position:absolute;bottom:0;left:0;width:100%;margin:0}[dir=rtl] .mat-list[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-list[dense] .mat-list-option .mat-divider,[dir=rtl] .mat-nav-list[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-nav-list[dense] .mat-list-option .mat-divider,[dir=rtl] .mat-selection-list[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-selection-list[dense] .mat-list-option .mat-divider{margin-left:auto;margin-right:0}.mat-list[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-list[dense] .mat-list-option .mat-divider.mat-divider-inset,.mat-nav-list[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-nav-list[dense] .mat-list-option .mat-divider.mat-divider-inset,.mat-selection-list[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-selection-list[dense] .mat-list-option .mat-divider.mat-divider-inset{position:absolute}.mat-nav-list a{text-decoration:none;color:inherit}.mat-nav-list .mat-list-item{cursor:pointer;outline:0}.mat-list-option:not(.mat-list-item-disabled){cursor:pointer;outline:0}"],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    providers: [MAT_SELECTION_LIST_VALUE_ACCESSOR],
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush
	                },] },
	    ];
	    /** @nocollapse */
	    MatSelectionList.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Attribute, args: ['tabindex',] },] },
	    ]; };
	    MatSelectionList.propDecorators = {
	        "options": [{ type: _angular_core.ContentChildren, args: [MatListOption,] },],
	        "selectionChange": [{ type: _angular_core.Output },],
	        "tabIndex": [{ type: _angular_core.Input },],
	    };
	    return MatSelectionList;
	}(_MatSelectionListMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatListModule = /** @class */ (function () {
	    function MatListModule() {
	    }
	    MatListModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [MatLineModule, MatRippleModule, MatCommonModule, MatPseudoCheckboxModule, _angular_common.CommonModule],
	                    exports: [
	                        MatList,
	                        MatNavList,
	                        MatListItem,
	                        MatListAvatarCssMatStyler,
	                        MatLineModule,
	                        MatCommonModule,
	                        MatListIconCssMatStyler,
	                        MatListSubheaderCssMatStyler,
	                        MatPseudoCheckboxModule,
	                        MatSelectionList,
	                        MatListOption,
	                        MatDividerModule
	                    ],
	                    declarations: [
	                        MatList,
	                        MatNavList,
	                        MatListItem,
	                        MatListAvatarCssMatStyler,
	                        MatListIconCssMatStyler,
	                        MatListSubheaderCssMatStyler,
	                        MatSelectionList,
	                        MatListOption
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    MatListModule.ctorParameters = function () { return []; };
	    return MatListModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Animations used by the mat-menu component.
	 * Animation duration and timing values are based on:
	 * https://material.io/guidelines/components/menus.html#menus-usage
	 */
	var matMenuAnimations = {
	    /**
	       * This animation controls the menu panel's entry and exit from the page.
	       *
	       * When the menu panel is added to the DOM, it scales in and fades in its border.
	       *
	       * When the menu panel is removed from the DOM, it simply fades out after a brief
	       * delay to display the ripple.
	       */
	    transformMenu: _angular_animations.trigger('transformMenu', [
	        // TODO(kara): switch to :enter and :leave once Mobile Safari is sorted out.
	        _angular_animations.state('void', _angular_animations.style({
	            opacity: 0,
	            // This starts off from 0.01, instead of 0, because there's an issue in the Angular animations
	            // as of 4.2, which causes the animation to be skipped if it starts from 0.
	            transform: 'scale(0.01, 0.01)'
	        })),
	        _angular_animations.state('enter-start', _angular_animations.style({
	            opacity: 1,
	            transform: 'scale(1, 0.5)'
	        })),
	        _angular_animations.state('enter', _angular_animations.style({
	            transform: 'scale(1, 1)'
	        })),
	        _angular_animations.transition('void => enter-start', _angular_animations.animate('100ms linear')),
	        _angular_animations.transition('enter-start => enter', _angular_animations.animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)')),
	        _angular_animations.transition('* => void', _angular_animations.animate('150ms 50ms linear', _angular_animations.style({ opacity: 0 })))
	    ]),
	    /**
	       * This animation fades in the background color and content of the menu panel
	       * after its containing element is scaled in.
	       */
	    fadeInItems: _angular_animations.trigger('fadeInItems', [
	        _angular_animations.state('showing', _angular_animations.style({ opacity: 1 })),
	        _angular_animations.transition('void => *', [
	            _angular_animations.style({ opacity: 0 }),
	            _angular_animations.animate('400ms 100ms cubic-bezier(0.55, 0, 0.55, 0.2)')
	        ])
	    ])
	};
	/**
	 * @deprecated
	 * \@deletion-target 7.0.0
	 */
	var fadeInItems = matMenuAnimations.fadeInItems;
	/**
	 * @deprecated
	 * \@deletion-target 7.0.0
	 */
	var transformMenu = matMenuAnimations.transformMenu;
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Throws an exception for the case when menu trigger doesn't have a valid mat-menu instance
	 * \@docs-private
	 * @return {?}
	 */
	function throwMatMenuMissingError() {
	    throw Error("mat-menu-trigger: must pass in an mat-menu instance.\n\n    Example:\n      <mat-menu #menu=\"matMenu\"></mat-menu>\n      <button [matMenuTriggerFor]=\"menu\"></button>");
	}
	/**
	 * Throws an exception for the case when menu's x-position value isn't valid.
	 * In other words, it doesn't match 'before' or 'after'.
	 * \@docs-private
	 * @return {?}
	 */
	function throwMatMenuInvalidPositionX() {
	    throw Error("x-position value must be either 'before' or after'.\n      Example: <mat-menu x-position=\"before\" #menu=\"matMenu\"></mat-menu>");
	}
	/**
	 * Throws an exception for the case when menu's y-position value isn't valid.
	 * In other words, it doesn't match 'above' or 'below'.
	 * \@docs-private
	 * @return {?}
	 */
	function throwMatMenuInvalidPositionY() {
	    throw Error("y-position value must be either 'above' or below'.\n      Example: <mat-menu y-position=\"above\" #menu=\"matMenu\"></mat-menu>");
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 */
	var MatMenuItemBase = /** @class */ (function () {
	    function MatMenuItemBase() {
	    }
	    return MatMenuItemBase;
	}());
	var _MatMenuItemMixinBase = mixinDisableRipple(mixinDisabled(MatMenuItemBase));
	/**
	 * This directive is intended to be used inside an mat-menu tag.
	 * It exists mostly to set the role attribute.
	 */
	var MatMenuItem = /** @class */ (function (_super) {
	    __extends(MatMenuItem, _super);
	    function MatMenuItem(_elementRef, document, _focusMonitor) {
	        var _this = 
	        // @deletion-target 6.0.0 make `_focusMonitor` and `document` required params.
	        _super.call(this) || this;
	        _this._elementRef = _elementRef;
	        _this._focusMonitor = _focusMonitor;
	        /**
	         * Stream that emits when the menu item is hovered.
	         */
	        _this._hovered = new rxjs_Subject.Subject();
	        /**
	         * Whether the menu item is highlighted.
	         */
	        _this._highlighted = false;
	        /**
	         * Whether the menu item acts as a trigger for a sub-menu.
	         */
	        _this._triggersSubmenu = false;
	        if (_focusMonitor) {
	            // Start monitoring the element so it gets the appropriate focused classes. We want
	            // to show the focus style for menu items only when the focus was not caused by a
	            // mouse or touch interaction.
	            _focusMonitor.monitor(_this._getHostElement(), false);
	        }
	        _this._document = document;
	        return _this;
	    }
	    /** Focuses the menu item. */
	    /**
	     * Focuses the menu item.
	     * @param {?=} origin
	     * @return {?}
	     */
	    MatMenuItem.prototype.focus = /**
	     * Focuses the menu item.
	     * @param {?=} origin
	     * @return {?}
	     */
	    function (origin) {
	        if (origin === void 0) { origin = 'program'; }
	        if (this._focusMonitor) {
	            this._focusMonitor.focusVia(this._getHostElement(), origin);
	        }
	        else {
	            this._getHostElement().focus();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatMenuItem.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        if (this._focusMonitor) {
	            this._focusMonitor.stopMonitoring(this._getHostElement());
	        }
	        this._hovered.complete();
	    };
	    /** Used to set the `tabindex`. */
	    /**
	     * Used to set the `tabindex`.
	     * @return {?}
	     */
	    MatMenuItem.prototype._getTabIndex = /**
	     * Used to set the `tabindex`.
	     * @return {?}
	     */
	    function () {
	        return this.disabled ? '-1' : '0';
	    };
	    /** Returns the host DOM element. */
	    /**
	     * Returns the host DOM element.
	     * @return {?}
	     */
	    MatMenuItem.prototype._getHostElement = /**
	     * Returns the host DOM element.
	     * @return {?}
	     */
	    function () {
	        return this._elementRef.nativeElement;
	    };
	    /** Prevents the default element actions if it is disabled. */
	    /**
	     * Prevents the default element actions if it is disabled.
	     * @param {?} event
	     * @return {?}
	     */
	    MatMenuItem.prototype._checkDisabled = /**
	     * Prevents the default element actions if it is disabled.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (this.disabled) {
	            event.preventDefault();
	            event.stopPropagation();
	        }
	    };
	    /** Emits to the hover stream. */
	    /**
	     * Emits to the hover stream.
	     * @return {?}
	     */
	    MatMenuItem.prototype._emitHoverEvent = /**
	     * Emits to the hover stream.
	     * @return {?}
	     */
	    function () {
	        if (!this.disabled) {
	            this._hovered.next(this);
	        }
	    };
	    /** Gets the label to be used when determining whether the option should be focused. */
	    /**
	     * Gets the label to be used when determining whether the option should be focused.
	     * @return {?}
	     */
	    MatMenuItem.prototype.getLabel = /**
	     * Gets the label to be used when determining whether the option should be focused.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ element = this._elementRef.nativeElement;
	        var /** @type {?} */ textNodeType = this._document ? this._document.TEXT_NODE : 3;
	        var /** @type {?} */ output = '';
	        if (element.childNodes) {
	            var /** @type {?} */ length_1 = element.childNodes.length;
	            // Go through all the top-level text nodes and extract their text.
	            // We skip anything that's not a text node to prevent the text from
	            // being thrown off by something like an icon.
	            for (var /** @type {?} */ i = 0; i < length_1; i++) {
	                if (element.childNodes[i].nodeType === textNodeType) {
	                    output += element.childNodes[i].textContent;
	                }
	            }
	        }
	        return output.trim();
	    };
	    MatMenuItem.decorators = [
	        { type: _angular_core.Component, args: [{selector: '[mat-menu-item]',
	                    exportAs: 'matMenuItem',
	                    inputs: ['disabled', 'disableRipple'],
	                    host: {
	                        'role': 'menuitem',
	                        'class': 'mat-menu-item',
	                        '[class.mat-menu-item-highlighted]': '_highlighted',
	                        '[class.mat-menu-item-submenu-trigger]': '_triggersSubmenu',
	                        '[attr.tabindex]': '_getTabIndex()',
	                        '[attr.aria-disabled]': 'disabled.toString()',
	                        '[attr.disabled]': 'disabled || null',
	                        '(click)': '_checkDisabled($event)',
	                        '(mouseenter)': '_emitHoverEvent()',
	                    },
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    template: "<ng-content></ng-content><div class=\"mat-menu-ripple\" matRipple [matRippleDisabled]=\"disableRipple || disabled\" [matRippleTrigger]=\"_getHostElement()\"></div>",
	                },] },
	    ];
	    /** @nocollapse */
	    MatMenuItem.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	        { type: _angular_cdk_a11y.FocusMonitor, },
	    ]; };
	    return MatMenuItem;
	}(_MatMenuItemMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Menu content that will be rendered lazily once the menu is opened.
	 */
	var MatMenuContent = /** @class */ (function () {
	    function MatMenuContent(_template, _componentFactoryResolver, _appRef, _injector, _viewContainerRef, _document) {
	        this._template = _template;
	        this._componentFactoryResolver = _componentFactoryResolver;
	        this._appRef = _appRef;
	        this._injector = _injector;
	        this._viewContainerRef = _viewContainerRef;
	        this._document = _document;
	    }
	    /**
	     * Attaches the content with a particular context.
	     * @docs-private
	     */
	    /**
	     * Attaches the content with a particular context.
	     * \@docs-private
	     * @param {?=} context
	     * @return {?}
	     */
	    MatMenuContent.prototype.attach = /**
	     * Attaches the content with a particular context.
	     * \@docs-private
	     * @param {?=} context
	     * @return {?}
	     */
	    function (context) {
	        if (context === void 0) { context = {}; }
	        if (!this._portal) {
	            this._portal = new _angular_cdk_portal.TemplatePortal(this._template, this._viewContainerRef);
	        }
	        else if (this._portal.isAttached) {
	            this._portal.detach();
	        }
	        if (!this._outlet) {
	            this._outlet = new _angular_cdk_portal.DomPortalOutlet(this._document.createElement('div'), this._componentFactoryResolver, this._appRef, this._injector);
	        }
	        var /** @type {?} */ element = this._template.elementRef.nativeElement; /** @type {?} */
	        ((
	        // Because we support opening the same menu from different triggers (which in turn have their
	        // own `OverlayRef` panel), we have to re-insert the host element every time, otherwise we
	        // risk it staying attached to a pane that's no longer in the DOM.
	        element.parentNode)).insertBefore(this._outlet.outletElement, element);
	        this._portal.attach(this._outlet, context);
	    };
	    /**
	     * @return {?}
	     */
	    MatMenuContent.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        if (this._outlet) {
	            this._outlet.dispose();
	        }
	    };
	    MatMenuContent.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'ng-template[matMenuContent]'
	                },] },
	    ];
	    /** @nocollapse */
	    MatMenuContent.ctorParameters = function () { return [
	        { type: _angular_core.TemplateRef, },
	        { type: _angular_core.ComponentFactoryResolver, },
	        { type: _angular_core.ApplicationRef, },
	        { type: _angular_core.Injector, },
	        { type: _angular_core.ViewContainerRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    return MatMenuContent;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Default `mat-menu` options that can be overridden.
	 * @record
	 */
	
	/**
	 * Injection token to be used to override the default options for `mat-menu`.
	 */
	var MAT_MENU_DEFAULT_OPTIONS = new _angular_core.InjectionToken('mat-menu-default-options');
	/**
	 * Start elevation for the menu panel.
	 * \@docs-private
	 */
	var MAT_MENU_BASE_ELEVATION = 2;
	var MatMenu = /** @class */ (function () {
	    function MatMenu(_elementRef, _ngZone, _defaultOptions) {
	        this._elementRef = _elementRef;
	        this._ngZone = _ngZone;
	        this._defaultOptions = _defaultOptions;
	        this._xPosition = this._defaultOptions.xPosition;
	        this._yPosition = this._defaultOptions.yPosition;
	        /**
	         * Subscription to tab events on the menu panel
	         */
	        this._tabSubscription = rxjs_Subscription.Subscription.EMPTY;
	        /**
	         * Config object to be passed into the menu's ngClass
	         */
	        this._classList = {};
	        /**
	         * Current state of the panel animation.
	         */
	        this._panelAnimationState = 'void';
	        this._overlapTrigger = this._defaultOptions.overlapTrigger;
	        /**
	         * Event emitted when the menu is closed.
	         */
	        this.closed = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when the menu is closed.
	         * @deprecated Switch to `closed` instead
	         * \@deletion-target 6.0.0
	         */
	        this.close = this.closed;
	    }
	    Object.defineProperty(MatMenu.prototype, "xPosition", {
	        get: /**
	         * Position of the menu in the X axis.
	         * @return {?}
	         */
	        function () { return this._xPosition; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (value !== 'before' && value !== 'after') {
	                throwMatMenuInvalidPositionX();
	            }
	            this._xPosition = value;
	            this.setPositionClasses();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatMenu.prototype, "yPosition", {
	        get: /**
	         * Position of the menu in the Y axis.
	         * @return {?}
	         */
	        function () { return this._yPosition; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (value !== 'above' && value !== 'below') {
	                throwMatMenuInvalidPositionY();
	            }
	            this._yPosition = value;
	            this.setPositionClasses();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatMenu.prototype, "overlapTrigger", {
	        get: /**
	         * Whether the menu should overlap its trigger.
	         * @return {?}
	         */
	        function () { return this._overlapTrigger; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._overlapTrigger = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatMenu.prototype, "panelClass", {
	        set: /**
	         * This method takes classes set on the host mat-menu element and applies them on the
	         * menu template that displays in the overlay container.  Otherwise, it's difficult
	         * to style the containing menu from outside the component.
	         * @param {?} classes list of class names
	         * @return {?}
	         */
	        function (classes) {
	            if (classes && classes.length) {
	                this._classList = classes.split(' ').reduce(function (obj, className) {
	                    obj[className] = true;
	                    return obj;
	                }, {});
	                this._elementRef.nativeElement.className = '';
	                this.setPositionClasses();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatMenu.prototype, "classList", {
	        get: /**
	         * This method takes classes set on the host mat-menu element and applies them on the
	         * menu template that displays in the overlay container.  Otherwise, it's difficult
	         * to style the containing menu from outside the component.
	         * @deprecated Use `panelClass` instead.
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this.panelClass; },
	        set: /**
	         * @param {?} classes
	         * @return {?}
	         */
	        function (classes) { this.panelClass = classes; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatMenu.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._keyManager = new _angular_cdk_a11y.FocusKeyManager(this.items).withWrap().withTypeAhead();
	        this._tabSubscription = this._keyManager.tabOut.subscribe(function () { return _this.close.emit('keydown'); });
	    };
	    /**
	     * @return {?}
	     */
	    MatMenu.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._tabSubscription.unsubscribe();
	        this.closed.complete();
	    };
	    /** Stream that emits whenever the hovered menu item changes. */
	    /**
	     * Stream that emits whenever the hovered menu item changes.
	     * @return {?}
	     */
	    MatMenu.prototype._hovered = /**
	     * Stream that emits whenever the hovered menu item changes.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this.items) {
	            return this.items.changes.pipe(rxjs_operators_startWith.startWith(this.items), rxjs_operators_switchMap.switchMap(function (items) { return rxjs_observable_merge.merge.apply(void 0, items.map(function (item) { return item._hovered; })); }));
	        }
	        return this._ngZone.onStable
	            .asObservable()
	            .pipe(rxjs_operators_take.take(1), rxjs_operators_switchMap.switchMap(function () { return _this._hovered(); }));
	    };
	    /** Handle a keyboard event from the menu, delegating to the appropriate action. */
	    /**
	     * Handle a keyboard event from the menu, delegating to the appropriate action.
	     * @param {?} event
	     * @return {?}
	     */
	    MatMenu.prototype._handleKeydown = /**
	     * Handle a keyboard event from the menu, delegating to the appropriate action.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        switch (event.keyCode) {
	            case _angular_cdk_keycodes.ESCAPE:
	                this.closed.emit('keydown');
	                event.stopPropagation();
	                break;
	            case _angular_cdk_keycodes.LEFT_ARROW:
	                if (this.parentMenu && this.direction === 'ltr') {
	                    this.closed.emit('keydown');
	                }
	                break;
	            case _angular_cdk_keycodes.RIGHT_ARROW:
	                if (this.parentMenu && this.direction === 'rtl') {
	                    this.closed.emit('keydown');
	                }
	                break;
	            default:
	                this._keyManager.onKeydown(event);
	        }
	    };
	    /**
	     * Focus the first item in the menu.
	     * @param origin Action from which the focus originated. Used to set the correct styling.
	     */
	    /**
	     * Focus the first item in the menu.
	     * @param {?=} origin Action from which the focus originated. Used to set the correct styling.
	     * @return {?}
	     */
	    MatMenu.prototype.focusFirstItem = /**
	     * Focus the first item in the menu.
	     * @param {?=} origin Action from which the focus originated. Used to set the correct styling.
	     * @return {?}
	     */
	    function (origin) {
	        var _this = this;
	        if (origin === void 0) { origin = 'program'; }
	        // When the content is rendered lazily, it takes a bit before the items are inside the DOM.
	        if (this.lazyContent) {
	            this._ngZone.onStable.asObservable()
	                .pipe(rxjs_operators_take.take(1))
	                .subscribe(function () { return _this._keyManager.setFocusOrigin(origin).setFirstItemActive(); });
	        }
	        else {
	            this._keyManager.setFocusOrigin(origin).setFirstItemActive();
	        }
	    };
	    /**
	     * Resets the active item in the menu. This is used when the menu is opened, allowing
	     * the user to start from the first option when pressing the down arrow.
	     */
	    /**
	     * Resets the active item in the menu. This is used when the menu is opened, allowing
	     * the user to start from the first option when pressing the down arrow.
	     * @return {?}
	     */
	    MatMenu.prototype.resetActiveItem = /**
	     * Resets the active item in the menu. This is used when the menu is opened, allowing
	     * the user to start from the first option when pressing the down arrow.
	     * @return {?}
	     */
	    function () {
	        this._keyManager.setActiveItem(-1);
	    };
	    /**
	     * It's necessary to set position-based classes to ensure the menu panel animation
	     * folds out from the correct direction.
	     */
	    /**
	     * It's necessary to set position-based classes to ensure the menu panel animation
	     * folds out from the correct direction.
	     * @param {?=} posX
	     * @param {?=} posY
	     * @return {?}
	     */
	    MatMenu.prototype.setPositionClasses = /**
	     * It's necessary to set position-based classes to ensure the menu panel animation
	     * folds out from the correct direction.
	     * @param {?=} posX
	     * @param {?=} posY
	     * @return {?}
	     */
	    function (posX, posY) {
	        if (posX === void 0) { posX = this.xPosition; }
	        if (posY === void 0) { posY = this.yPosition; }
	        this._classList['mat-menu-before'] = posX === 'before';
	        this._classList['mat-menu-after'] = posX === 'after';
	        this._classList['mat-menu-above'] = posY === 'above';
	        this._classList['mat-menu-below'] = posY === 'below';
	    };
	    /**
	     * Sets the menu panel elevation.
	     * @param depth Number of parent menus that come before the menu.
	     */
	    /**
	     * Sets the menu panel elevation.
	     * @param {?} depth Number of parent menus that come before the menu.
	     * @return {?}
	     */
	    MatMenu.prototype.setElevation = /**
	     * Sets the menu panel elevation.
	     * @param {?} depth Number of parent menus that come before the menu.
	     * @return {?}
	     */
	    function (depth) {
	        // The elevation starts at the base and increases by one for each level.
	        var /** @type {?} */ newElevation = "mat-elevation-z" + (MAT_MENU_BASE_ELEVATION + depth);
	        var /** @type {?} */ customElevation = Object.keys(this._classList).find(function (c) { return c.startsWith('mat-elevation-z'); });
	        if (!customElevation || customElevation === this._previousElevation) {
	            if (this._previousElevation) {
	                this._classList[this._previousElevation] = false;
	            }
	            this._classList[newElevation] = true;
	            this._previousElevation = newElevation;
	        }
	    };
	    /** Starts the enter animation. */
	    /**
	     * Starts the enter animation.
	     * @return {?}
	     */
	    MatMenu.prototype._startAnimation = /**
	     * Starts the enter animation.
	     * @return {?}
	     */
	    function () {
	        this._panelAnimationState = 'enter-start';
	    };
	    /** Resets the panel animation to its initial state. */
	    /**
	     * Resets the panel animation to its initial state.
	     * @return {?}
	     */
	    MatMenu.prototype._resetAnimation = /**
	     * Resets the panel animation to its initial state.
	     * @return {?}
	     */
	    function () {
	        this._panelAnimationState = 'void';
	    };
	    /** Callback that is invoked when the panel animation completes. */
	    /**
	     * Callback that is invoked when the panel animation completes.
	     * @param {?} event
	     * @return {?}
	     */
	    MatMenu.prototype._onAnimationDone = /**
	     * Callback that is invoked when the panel animation completes.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        // After the initial expansion is done, trigger the second phase of the enter animation.
	        if (event.toState === 'enter-start') {
	            this._panelAnimationState = 'enter';
	        }
	    };
	    MatMenu.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-menu',
	                    template: "<ng-template><div class=\"mat-menu-panel\" [ngClass]=\"_classList\" (keydown)=\"_handleKeydown($event)\" (click)=\"closed.emit('click')\" [@transformMenu]=\"_panelAnimationState\" (@transformMenu.done)=\"_onAnimationDone($event)\" tabindex=\"-1\" role=\"menu\"><div class=\"mat-menu-content\" [@fadeInItems]=\"'showing'\"><ng-content></ng-content></div></div></ng-template>",
	                    styles: [".mat-menu-panel{min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;max-height:calc(100vh - 48px);border-radius:2px;outline:0}.mat-menu-panel:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.mat-menu-panel.mat-menu-after.mat-menu-below{transform-origin:left top}.mat-menu-panel.mat-menu-after.mat-menu-above{transform-origin:left bottom}.mat-menu-panel.mat-menu-before.mat-menu-below{transform-origin:right top}.mat-menu-panel.mat-menu-before.mat-menu-above{transform-origin:right bottom}[dir=rtl] .mat-menu-panel.mat-menu-after.mat-menu-below{transform-origin:right top}[dir=rtl] .mat-menu-panel.mat-menu-after.mat-menu-above{transform-origin:right bottom}[dir=rtl] .mat-menu-panel.mat-menu-before.mat-menu-below{transform-origin:left top}[dir=rtl] .mat-menu-panel.mat-menu-before.mat-menu-above{transform-origin:left bottom}.mat-menu-panel.ng-animating{pointer-events:none}@media screen and (-ms-high-contrast:active){.mat-menu-panel{outline:solid 1px}}.mat-menu-content{padding-top:8px;padding-bottom:8px}.mat-menu-item{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;line-height:48px;height:48px;padding:0 16px;text-align:left;text-decoration:none;position:relative}.mat-menu-item[disabled]{cursor:default}[dir=rtl] .mat-menu-item{text-align:right}.mat-menu-item .mat-icon{margin-right:16px;vertical-align:middle}[dir=rtl] .mat-menu-item .mat-icon{margin-left:16px;margin-right:0}.mat-menu-item-submenu-trigger{padding-right:32px}.mat-menu-item-submenu-trigger::after{width:0;height:0;border-style:solid;border-width:5px 0 5px 5px;border-color:transparent transparent transparent currentColor;content:'';display:inline-block;position:absolute;top:50%;right:16px;transform:translateY(-50%)}[dir=rtl] .mat-menu-item-submenu-trigger{padding-right:16px;padding-left:32px}[dir=rtl] .mat-menu-item-submenu-trigger::after{right:auto;left:16px;transform:rotateY(180deg) translateY(-50%)}button.mat-menu-item{width:100%}.mat-menu-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}"],
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    animations: [
	                        matMenuAnimations.transformMenu,
	                        matMenuAnimations.fadeInItems
	                    ],
	                    exportAs: 'matMenu'
	                },] },
	    ];
	    /** @nocollapse */
	    MatMenu.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.NgZone, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [MAT_MENU_DEFAULT_OPTIONS,] },] },
	    ]; };
	    MatMenu.propDecorators = {
	        "xPosition": [{ type: _angular_core.Input },],
	        "yPosition": [{ type: _angular_core.Input },],
	        "templateRef": [{ type: _angular_core.ViewChild, args: [_angular_core.TemplateRef,] },],
	        "items": [{ type: _angular_core.ContentChildren, args: [MatMenuItem,] },],
	        "lazyContent": [{ type: _angular_core.ContentChild, args: [MatMenuContent,] },],
	        "overlapTrigger": [{ type: _angular_core.Input },],
	        "panelClass": [{ type: _angular_core.Input, args: ['class',] },],
	        "classList": [{ type: _angular_core.Input },],
	        "closed": [{ type: _angular_core.Output },],
	        "close": [{ type: _angular_core.Output },],
	    };
	    return MatMenu;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Injection token that determines the scroll handling while the menu is open.
	 */
	var MAT_MENU_SCROLL_STRATEGY = new _angular_core.InjectionToken('mat-menu-scroll-strategy');
	/**
	 * \@docs-private
	 * @param {?} overlay
	 * @return {?}
	 */
	function MAT_MENU_SCROLL_STRATEGY_PROVIDER_FACTORY(overlay) {
	    return function () { return overlay.scrollStrategies.reposition(); };
	}
	/**
	 * \@docs-private
	 */
	var MAT_MENU_SCROLL_STRATEGY_PROVIDER = {
	    provide: MAT_MENU_SCROLL_STRATEGY,
	    deps: [_angular_cdk_overlay.Overlay],
	    useFactory: MAT_MENU_SCROLL_STRATEGY_PROVIDER_FACTORY,
	};
	/**
	 * Default top padding of the menu panel.
	 */
	var MENU_PANEL_TOP_PADDING = 8;
	/**
	 * This directive is intended to be used in conjunction with an mat-menu tag.  It is
	 * responsible for toggling the display of the provided menu instance.
	 */
	var MatMenuTrigger = /** @class */ (function () {
	    function MatMenuTrigger(_overlay, _element, _viewContainerRef, _scrollStrategy, _parentMenu, _menuItemInstance, _dir, _focusMonitor) {
	        this._overlay = _overlay;
	        this._element = _element;
	        this._viewContainerRef = _viewContainerRef;
	        this._scrollStrategy = _scrollStrategy;
	        this._parentMenu = _parentMenu;
	        this._menuItemInstance = _menuItemInstance;
	        this._dir = _dir;
	        this._focusMonitor = _focusMonitor;
	        this._overlayRef = null;
	        this._menuOpen = false;
	        this._closeSubscription = rxjs_Subscription.Subscription.EMPTY;
	        this._hoverSubscription = rxjs_Subscription.Subscription.EMPTY;
	        this._openedByMouse = false;
	        /**
	         * Event emitted when the associated menu is opened.
	         */
	        this.menuOpened = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when the associated menu is opened.
	         * @deprecated Switch to `menuOpened` instead
	         * \@deletion-target 6.0.0
	         */
	        this.onMenuOpen = this.menuOpened;
	        /**
	         * Event emitted when the associated menu is closed.
	         */
	        this.menuClosed = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when the associated menu is closed.
	         * @deprecated Switch to `menuClosed` instead
	         * \@deletion-target 6.0.0
	         */
	        this.onMenuClose = this.menuClosed;
	        if (_menuItemInstance) {
	            _menuItemInstance._triggersSubmenu = this.triggersSubmenu();
	        }
	    }
	    Object.defineProperty(MatMenuTrigger.prototype, "_deprecatedMatMenuTriggerFor", {
	        get: /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () {
	            return this.menu;
	        },
	        set: /**
	         * @param {?} v
	         * @return {?}
	         */
	        function (v) {
	            this.menu = v;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatMenuTrigger.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._checkMenu();
	        this.menu.close.subscribe(function (reason) {
	            _this._destroyMenu();
	            // If a click closed the menu, we should close the entire chain of nested menus.
	            if (reason === 'click' && _this._parentMenu) {
	                _this._parentMenu.closed.emit(reason);
	            }
	        });
	        if (this.triggersSubmenu()) {
	            // Subscribe to changes in the hovered item in order to toggle the panel.
	            this._hoverSubscription = this._parentMenu._hovered()
	                .pipe(rxjs_operators_filter.filter(function (active) { return active === _this._menuItemInstance; }))
	                .subscribe(function () {
	                _this._openedByMouse = true;
	                _this.openMenu();
	            });
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatMenuTrigger.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        if (this._overlayRef) {
	            this._overlayRef.dispose();
	            this._overlayRef = null;
	        }
	        this._cleanUpSubscriptions();
	    };
	    Object.defineProperty(MatMenuTrigger.prototype, "menuOpen", {
	        /** Whether the menu is open. */
	        get: /**
	         * Whether the menu is open.
	         * @return {?}
	         */
	        function () {
	            return this._menuOpen;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatMenuTrigger.prototype, "dir", {
	        /** The text direction of the containing app. */
	        get: /**
	         * The text direction of the containing app.
	         * @return {?}
	         */
	        function () {
	            return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** Whether the menu triggers a sub-menu or a top-level one. */
	    /**
	     * Whether the menu triggers a sub-menu or a top-level one.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype.triggersSubmenu = /**
	     * Whether the menu triggers a sub-menu or a top-level one.
	     * @return {?}
	     */
	    function () {
	        return !!(this._menuItemInstance && this._parentMenu);
	    };
	    /** Toggles the menu between the open and closed states. */
	    /**
	     * Toggles the menu between the open and closed states.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype.toggleMenu = /**
	     * Toggles the menu between the open and closed states.
	     * @return {?}
	     */
	    function () {
	        return this._menuOpen ? this.closeMenu() : this.openMenu();
	    };
	    /** Opens the menu. */
	    /**
	     * Opens the menu.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype.openMenu = /**
	     * Opens the menu.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._menuOpen) {
	            return;
	        }
	        this._createOverlay().attach(this._portal);
	        if (this.menu.lazyContent) {
	            this.menu.lazyContent.attach(this.menuData);
	        }
	        this._closeSubscription = this._menuClosingActions().subscribe(function () { return _this.closeMenu(); });
	        this._initMenu();
	        if (this.menu instanceof MatMenu) {
	            this.menu._startAnimation();
	        }
	    };
	    /** Closes the menu. */
	    /**
	     * Closes the menu.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype.closeMenu = /**
	     * Closes the menu.
	     * @return {?}
	     */
	    function () {
	        this.menu.close.emit();
	    };
	    /**
	     * Focuses the menu trigger.
	     * @param origin Source of the menu trigger's focus.
	     */
	    /**
	     * Focuses the menu trigger.
	     * @param {?=} origin Source of the menu trigger's focus.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype.focus = /**
	     * Focuses the menu trigger.
	     * @param {?=} origin Source of the menu trigger's focus.
	     * @return {?}
	     */
	    function (origin) {
	        if (origin === void 0) { origin = 'program'; }
	        if (this._focusMonitor) {
	            this._focusMonitor.focusVia(this._element.nativeElement, origin);
	        }
	        else {
	            this._element.nativeElement.focus();
	        }
	    };
	    /**
	     * Closes the menu and does the necessary cleanup.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._destroyMenu = /**
	     * Closes the menu and does the necessary cleanup.
	     * @return {?}
	     */
	    function () {
	        if (this._overlayRef && this.menuOpen) {
	            this._resetMenu();
	            this._closeSubscription.unsubscribe();
	            this._overlayRef.detach();
	            if (this.menu instanceof MatMenu) {
	                this.menu._resetAnimation();
	            }
	        }
	    };
	    /**
	     * This method sets the menu state to open and focuses the first item if
	     * the menu was opened via the keyboard.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._initMenu = /**
	     * This method sets the menu state to open and focuses the first item if
	     * the menu was opened via the keyboard.
	     * @return {?}
	     */
	    function () {
	        this.menu.parentMenu = this.triggersSubmenu() ? this._parentMenu : undefined;
	        this.menu.direction = this.dir;
	        this._setMenuElevation();
	        this._setIsMenuOpen(true);
	        this.menu.focusFirstItem(this._openedByMouse ? 'mouse' : 'program');
	    };
	    /**
	     * Updates the menu elevation based on the amount of parent menus that it has.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._setMenuElevation = /**
	     * Updates the menu elevation based on the amount of parent menus that it has.
	     * @return {?}
	     */
	    function () {
	        if (this.menu.setElevation) {
	            var /** @type {?} */ depth = 0;
	            var /** @type {?} */ parentMenu = this.menu.parentMenu;
	            while (parentMenu) {
	                depth++;
	                parentMenu = parentMenu.parentMenu;
	            }
	            this.menu.setElevation(depth);
	        }
	    };
	    /**
	     * This method resets the menu when it's closed, most importantly restoring
	     * focus to the menu trigger if the menu was opened via the keyboard.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._resetMenu = /**
	     * This method resets the menu when it's closed, most importantly restoring
	     * focus to the menu trigger if the menu was opened via the keyboard.
	     * @return {?}
	     */
	    function () {
	        this._setIsMenuOpen(false);
	        // We should reset focus if the user is navigating using a keyboard or
	        // if we have a top-level trigger which might cause focus to be lost
	        // when clicking on the backdrop.
	        if (!this._openedByMouse) {
	            // Note that the focus style will show up both for `program` and
	            // `keyboard` so we don't have to specify which one it is.
	            this.focus();
	        }
	        else if (!this.triggersSubmenu()) {
	            this.focus('mouse');
	        }
	        this._openedByMouse = false;
	    };
	    /**
	     * @param {?} isOpen
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._setIsMenuOpen = /**
	     * @param {?} isOpen
	     * @return {?}
	     */
	    function (isOpen) {
	        this._menuOpen = isOpen;
	        this._menuOpen ? this.menuOpened.emit() : this.menuClosed.emit();
	        if (this.triggersSubmenu()) {
	            this._menuItemInstance._highlighted = isOpen;
	        }
	    };
	    /**
	     * This method checks that a valid instance of MatMenu has been passed into
	     * matMenuTriggerFor. If not, an exception is thrown.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._checkMenu = /**
	     * This method checks that a valid instance of MatMenu has been passed into
	     * matMenuTriggerFor. If not, an exception is thrown.
	     * @return {?}
	     */
	    function () {
	        if (!this.menu) {
	            throwMatMenuMissingError();
	        }
	    };
	    /**
	     * This method creates the overlay from the provided menu's template and saves its
	     * OverlayRef so that it can be attached to the DOM when openMenu is called.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._createOverlay = /**
	     * This method creates the overlay from the provided menu's template and saves its
	     * OverlayRef so that it can be attached to the DOM when openMenu is called.
	     * @return {?}
	     */
	    function () {
	        if (!this._overlayRef) {
	            this._portal = new _angular_cdk_portal.TemplatePortal(this.menu.templateRef, this._viewContainerRef);
	            var /** @type {?} */ config = this._getOverlayConfig();
	            this._subscribeToPositions(/** @type {?} */ (config.positionStrategy));
	            this._overlayRef = this._overlay.create(config);
	        }
	        return this._overlayRef;
	    };
	    /**
	     * This method builds the configuration object needed to create the overlay, the OverlayState.
	     * @return {?} OverlayConfig
	     */
	    MatMenuTrigger.prototype._getOverlayConfig = /**
	     * This method builds the configuration object needed to create the overlay, the OverlayState.
	     * @return {?} OverlayConfig
	     */
	    function () {
	        return new _angular_cdk_overlay.OverlayConfig({
	            positionStrategy: this._getPosition(),
	            hasBackdrop: !this.triggersSubmenu(),
	            backdropClass: 'cdk-overlay-transparent-backdrop',
	            direction: this.dir,
	            scrollStrategy: this._scrollStrategy()
	        });
	    };
	    /**
	     * Listens to changes in the position of the overlay and sets the correct classes
	     * on the menu based on the new position. This ensures the animation origin is always
	     * correct, even if a fallback position is used for the overlay.
	     * @param {?} position
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._subscribeToPositions = /**
	     * Listens to changes in the position of the overlay and sets the correct classes
	     * on the menu based on the new position. This ensures the animation origin is always
	     * correct, even if a fallback position is used for the overlay.
	     * @param {?} position
	     * @return {?}
	     */
	    function (position) {
	        var _this = this;
	        position.onPositionChange.subscribe(function (change) {
	            var /** @type {?} */ posX = change.connectionPair.overlayX === 'start' ? 'after' : 'before';
	            var /** @type {?} */ posY = change.connectionPair.overlayY === 'top' ? 'below' : 'above';
	            _this.menu.setPositionClasses(posX, posY);
	        });
	    };
	    /**
	     * This method builds the position strategy for the overlay, so the menu is properly connected
	     * to the trigger.
	     * @return {?} ConnectedPositionStrategy
	     */
	    MatMenuTrigger.prototype._getPosition = /**
	     * This method builds the position strategy for the overlay, so the menu is properly connected
	     * to the trigger.
	     * @return {?} ConnectedPositionStrategy
	     */
	    function () {
	        var _a = this.menu.xPosition === 'before' ? ['end', 'start'] : ['start', 'end'], originX = _a[0], originFallbackX = _a[1];
	        var _b = this.menu.yPosition === 'above' ? ['bottom', 'top'] : ['top', 'bottom'], overlayY = _b[0], overlayFallbackY = _b[1];
	        var _c = [overlayY, overlayFallbackY], originY = _c[0], originFallbackY = _c[1];
	        var _d = [originX, originFallbackX], overlayX = _d[0], overlayFallbackX = _d[1];
	        var /** @type {?} */ offsetY = 0;
	        if (this.triggersSubmenu()) {
	            // When the menu is a sub-menu, it should always align itself
	            // to the edges of the trigger, instead of overlapping it.
	            overlayFallbackX = originX = this.menu.xPosition === 'before' ? 'start' : 'end';
	            originFallbackX = overlayX = originX === 'end' ? 'start' : 'end';
	            offsetY = overlayY === 'bottom' ? MENU_PANEL_TOP_PADDING : -MENU_PANEL_TOP_PADDING;
	        }
	        else if (!this.menu.overlapTrigger) {
	            originY = overlayY === 'top' ? 'bottom' : 'top';
	            originFallbackY = overlayFallbackY === 'top' ? 'bottom' : 'top';
	        }
	        return this._overlay.position()
	            .connectedTo(this._element, { originX: originX, originY: originY }, { overlayX: overlayX, overlayY: overlayY })
	            .withDirection(this.dir)
	            .withOffsetY(offsetY)
	            .withFallbackPosition({ originX: originFallbackX, originY: originY }, { overlayX: overlayFallbackX, overlayY: overlayY })
	            .withFallbackPosition({ originX: originX, originY: originFallbackY }, { overlayX: overlayX, overlayY: overlayFallbackY }, undefined, -offsetY)
	            .withFallbackPosition({ originX: originFallbackX, originY: originFallbackY }, { overlayX: overlayFallbackX, overlayY: overlayFallbackY }, undefined, -offsetY);
	    };
	    /**
	     * Cleans up the active subscriptions.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._cleanUpSubscriptions = /**
	     * Cleans up the active subscriptions.
	     * @return {?}
	     */
	    function () {
	        this._closeSubscription.unsubscribe();
	        this._hoverSubscription.unsubscribe();
	    };
	    /**
	     * Returns a stream that emits whenever an action that should close the menu occurs.
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._menuClosingActions = /**
	     * Returns a stream that emits whenever an action that should close the menu occurs.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ backdrop = /** @type {?} */ ((this._overlayRef)).backdropClick();
	        var /** @type {?} */ detachments = /** @type {?} */ ((this._overlayRef)).detachments();
	        var /** @type {?} */ parentClose = this._parentMenu ? this._parentMenu.close : rxjs_observable_of.of();
	        var /** @type {?} */ hover = this._parentMenu ? this._parentMenu._hovered().pipe(rxjs_operators_filter.filter(function (active) { return active !== _this._menuItemInstance; }), rxjs_operators_filter.filter(function () { return _this._menuOpen; })) : rxjs_observable_of.of();
	        return rxjs_observable_merge.merge(backdrop, parentClose, hover, detachments);
	    };
	    /** Handles mouse presses on the trigger. */
	    /**
	     * Handles mouse presses on the trigger.
	     * @param {?} event
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._handleMousedown = /**
	     * Handles mouse presses on the trigger.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (!_angular_cdk_a11y.isFakeMousedownFromScreenReader(event)) {
	            this._openedByMouse = true;
	            // Since clicking on the trigger won't close the menu if it opens a sub-menu,
	            // we should prevent focus from moving onto it via click to avoid the
	            // highlight from lingering on the menu item.
	            if (this.triggersSubmenu()) {
	                event.preventDefault();
	            }
	        }
	    };
	    /** Handles key presses on the trigger. */
	    /**
	     * Handles key presses on the trigger.
	     * @param {?} event
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._handleKeydown = /**
	     * Handles key presses on the trigger.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var /** @type {?} */ keyCode = event.keyCode;
	        if (this.triggersSubmenu() && ((keyCode === _angular_cdk_keycodes.RIGHT_ARROW && this.dir === 'ltr') ||
	            (keyCode === _angular_cdk_keycodes.LEFT_ARROW && this.dir === 'rtl'))) {
	            this.openMenu();
	        }
	    };
	    /** Handles click events on the trigger. */
	    /**
	     * Handles click events on the trigger.
	     * @param {?} event
	     * @return {?}
	     */
	    MatMenuTrigger.prototype._handleClick = /**
	     * Handles click events on the trigger.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (this.triggersSubmenu()) {
	            // Stop event propagation to avoid closing the parent menu.
	            event.stopPropagation();
	            this.openMenu();
	        }
	        else {
	            this.toggleMenu();
	        }
	    };
	    MatMenuTrigger.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: "[mat-menu-trigger-for], [matMenuTriggerFor]",
	                    host: {
	                        'aria-haspopup': 'true',
	                        '(mousedown)': '_handleMousedown($event)',
	                        '(keydown)': '_handleKeydown($event)',
	                        '(click)': '_handleClick($event)',
	                    },
	                    exportAs: 'matMenuTrigger'
	                },] },
	    ];
	    /** @nocollapse */
	    MatMenuTrigger.ctorParameters = function () { return [
	        { type: _angular_cdk_overlay.Overlay, },
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.ViewContainerRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [MAT_MENU_SCROLL_STRATEGY,] },] },
	        { type: MatMenu, decorators: [{ type: _angular_core.Optional },] },
	        { type: MatMenuItem, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self },] },
	        { type: _angular_cdk_bidi.Directionality, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_cdk_a11y.FocusMonitor, },
	    ]; };
	    MatMenuTrigger.propDecorators = {
	        "_deprecatedMatMenuTriggerFor": [{ type: _angular_core.Input, args: ['mat-menu-trigger-for',] },],
	        "menu": [{ type: _angular_core.Input, args: ['matMenuTriggerFor',] },],
	        "menuData": [{ type: _angular_core.Input, args: ['matMenuTriggerData',] },],
	        "menuOpened": [{ type: _angular_core.Output },],
	        "onMenuOpen": [{ type: _angular_core.Output },],
	        "menuClosed": [{ type: _angular_core.Output },],
	        "onMenuClose": [{ type: _angular_core.Output },],
	    };
	    return MatMenuTrigger;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var ɵ0 = {
	    overlapTrigger: true,
	    xPosition: 'after',
	    yPosition: 'below',
	};
	var MatMenuModule = /** @class */ (function () {
	    function MatMenuModule() {
	    }
	    MatMenuModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [
	                        _angular_cdk_a11y.A11yModule,
	                        _angular_common.CommonModule,
	                        MatCommonModule,
	                        MatRippleModule,
	                        _angular_cdk_overlay.OverlayModule,
	                        _angular_cdk_portal.PortalModule,
	                    ],
	                    exports: [MatMenu, MatMenuItem, MatMenuTrigger, MatMenuContent, MatCommonModule],
	                    declarations: [MatMenu, MatMenuItem, MatMenuTrigger, MatMenuContent],
	                    providers: [
	                        MAT_MENU_SCROLL_STRATEGY_PROVIDER,
	                        {
	                            provide: MAT_MENU_DEFAULT_OPTIONS,
	                            useValue: ɵ0,
	                        }
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    MatMenuModule.ctorParameters = function () { return []; };
	    return MatMenuModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * The following are all the animations for the mat-select component, with each
	 * const containing the metadata for one animation.
	 *
	 * The values below match the implementation of the AngularJS Material mat-select animation.
	 */
	var matSelectAnimations = {
	    /**
	       * This animation transforms the select's overlay panel on and off the page.
	       *
	       * When the panel is attached to the DOM, it expands its width by the amount of padding, scales it
	       * up to 100% on the Y axis, fades in its border, and translates slightly up and to the
	       * side to ensure the option text correctly overlaps the trigger text.
	       *
	       * When the panel is removed from the DOM, it simply fades out linearly.
	       */
	    transformPanel: _angular_animations.trigger('transformPanel', [
	        _angular_animations.state('showing', _angular_animations.style({
	            opacity: 1,
	            minWidth: 'calc(100% + 32px)',
	            // 32px = 2 * 16px padding
	            transform: 'scaleY(1)'
	        })),
	        _angular_animations.state('showing-multiple', _angular_animations.style({
	            opacity: 1,
	            minWidth: 'calc(100% + 64px)',
	            // 64px = 48px padding on the left + 16px padding on the right
	            transform: 'scaleY(1)'
	        })),
	        _angular_animations.transition('void => *', [
	            _angular_animations.style({
	                opacity: 0,
	                minWidth: '100%',
	                transform: 'scaleY(0)'
	            }),
	            _angular_animations.animate('150ms cubic-bezier(0.25, 0.8, 0.25, 1)')
	        ]),
	        _angular_animations.transition('* => void', [
	            _angular_animations.animate('250ms 100ms linear', _angular_animations.style({ opacity: 0 }))
	        ])
	    ]),
	    /**
	       * This animation fades in the background color and text content of the
	       * select's options. It is time delayed to occur 100ms after the overlay
	       * panel has transformed in.
	       */
	    fadeInContent: _angular_animations.trigger('fadeInContent', [
	        _angular_animations.state('showing', _angular_animations.style({ opacity: 1 })),
	        _angular_animations.transition('void => showing', [
	            _angular_animations.style({ opacity: 0 }),
	            _angular_animations.animate('150ms 100ms cubic-bezier(0.55, 0, 0.55, 0.2)')
	        ])
	    ])
	};
	/**
	 * @deprecated
	 * \@deletion-target 7.0.0
	 */
	var transformPanel = matSelectAnimations.transformPanel;
	/**
	 * @deprecated
	 * \@deletion-target 7.0.0
	 */
	var fadeInContent = matSelectAnimations.fadeInContent;
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Returns an exception to be thrown when attempting to change a select's `multiple` option
	 * after initialization.
	 * \@docs-private
	 * @return {?}
	 */
	function getMatSelectDynamicMultipleError() {
	    return Error('Cannot change `multiple` mode of select after initialization.');
	}
	/**
	 * Returns an exception to be thrown when attempting to assign a non-array value to a select
	 * in `multiple` mode. Note that `undefined` and `null` are still valid values to allow for
	 * resetting the value.
	 * \@docs-private
	 * @return {?}
	 */
	function getMatSelectNonArrayValueError() {
	    return Error('Value must be an array in multiple-selection mode.');
	}
	/**
	 * Returns an exception to be thrown when assigning a non-function value to the comparator
	 * used to determine if a value corresponds to an option. Note that whether the function
	 * actually takes two values and returns a boolean is not checked.
	 * @return {?}
	 */
	function getMatSelectNonFunctionValueError() {
	    return Error('`compareWith` must be a function.');
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var nextUniqueId$4 = 0;
	/**
	 * The max height of the select's overlay panel
	 */
	var SELECT_PANEL_MAX_HEIGHT = 256;
	/**
	 * The panel's padding on the x-axis
	 */
	var SELECT_PANEL_PADDING_X = 16;
	/**
	 * The panel's x axis padding if it is indented (e.g. there is an option group).
	 */
	var SELECT_PANEL_INDENT_PADDING_X = SELECT_PANEL_PADDING_X * 2;
	/**
	 * The height of the select items in `em` units.
	 */
	var SELECT_ITEM_HEIGHT_EM = 3;
	/**
	 * Distance between the panel edge and the option text in
	 * multi-selection mode.
	 *
	 * (SELECT_PANEL_PADDING_X * 1.5) + 20 = 44
	 * The padding is multiplied by 1.5 because the checkbox's margin is half the padding.
	 * The checkbox width is 20px.
	 */
	var SELECT_MULTIPLE_PANEL_PADDING_X = SELECT_PANEL_PADDING_X * 1.5 + 20;
	/**
	 * The select panel will only "fit" inside the viewport if it is positioned at
	 * this value or more away from the viewport boundary.
	 */
	var SELECT_PANEL_VIEWPORT_PADDING = 8;
	/**
	 * Injection token that determines the scroll handling while a select is open.
	 */
	var MAT_SELECT_SCROLL_STRATEGY = new _angular_core.InjectionToken('mat-select-scroll-strategy');
	/**
	 * \@docs-private
	 * @param {?} overlay
	 * @return {?}
	 */
	function MAT_SELECT_SCROLL_STRATEGY_PROVIDER_FACTORY(overlay) {
	    return function () { return overlay.scrollStrategies.reposition(); };
	}
	/**
	 * \@docs-private
	 */
	var MAT_SELECT_SCROLL_STRATEGY_PROVIDER = {
	    provide: MAT_SELECT_SCROLL_STRATEGY,
	    deps: [_angular_cdk_overlay.Overlay],
	    useFactory: MAT_SELECT_SCROLL_STRATEGY_PROVIDER_FACTORY,
	};
	/**
	 * Change event object that is emitted when the select value has changed.
	 */
	var MatSelectChange = /** @class */ (function () {
	    function MatSelectChange(source, value) {
	        this.source = source;
	        this.value = value;
	    }
	    return MatSelectChange;
	}());
	/**
	 * \@docs-private
	 */
	var MatSelectBase = /** @class */ (function () {
	    function MatSelectBase(_elementRef, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) {
	        this._elementRef = _elementRef;
	        this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
	        this._parentForm = _parentForm;
	        this._parentFormGroup = _parentFormGroup;
	        this.ngControl = ngControl;
	    }
	    return MatSelectBase;
	}());
	var _MatSelectMixinBase = mixinDisableRipple(mixinTabIndex(mixinDisabled(mixinErrorState(MatSelectBase))));
	/**
	 * Allows the user to customize the trigger that is displayed when the select has a value.
	 */
	var MatSelectTrigger = /** @class */ (function () {
	    function MatSelectTrigger() {
	    }
	    MatSelectTrigger.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-select-trigger'
	                },] },
	    ];
	    /** @nocollapse */
	    MatSelectTrigger.ctorParameters = function () { return []; };
	    return MatSelectTrigger;
	}());
	var MatSelect = /** @class */ (function (_super) {
	    __extends(MatSelect, _super);
	    function MatSelect(_viewportRuler, _changeDetectorRef, _ngZone, _defaultErrorStateMatcher, elementRef, _dir, _parentForm, _parentFormGroup, _parentFormField, ngControl, tabIndex, _scrollStrategyFactory) {
	        var _this = _super.call(this, elementRef, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) || this;
	        _this._viewportRuler = _viewportRuler;
	        _this._changeDetectorRef = _changeDetectorRef;
	        _this._ngZone = _ngZone;
	        _this._dir = _dir;
	        _this._parentFormField = _parentFormField;
	        _this.ngControl = ngControl;
	        _this._scrollStrategyFactory = _scrollStrategyFactory;
	        /**
	         * Whether or not the overlay panel is open.
	         */
	        _this._panelOpen = false;
	        /**
	         * Whether filling out the select is required in the form.
	         */
	        _this._required = false;
	        /**
	         * The scroll position of the overlay panel, calculated to center the selected option.
	         */
	        _this._scrollTop = 0;
	        /**
	         * Whether the component is in multiple selection mode.
	         */
	        _this._multiple = false;
	        /**
	         * Comparison function to specify which option is displayed. Defaults to object equality.
	         */
	        _this._compareWith = function (o1, o2) { return o1 === o2; };
	        /**
	         * Unique id for this input.
	         */
	        _this._uid = "mat-select-" + nextUniqueId$4++;
	        /**
	         * Emits whenever the component is destroyed.
	         */
	        _this._destroy = new rxjs_Subject.Subject();
	        /**
	         * The cached font-size of the trigger element.
	         */
	        _this._triggerFontSize = 0;
	        /**
	         * `View -> model callback called when value changes`
	         */
	        _this._onChange = function () { };
	        /**
	         * `View -> model callback called when select has been touched`
	         */
	        _this._onTouched = function () { };
	        /**
	         * The IDs of child options to be passed to the aria-owns attribute.
	         */
	        _this._optionIds = '';
	        /**
	         * The value of the select panel's transform-origin property.
	         */
	        _this._transformOrigin = 'top';
	        /**
	         * Whether the panel's animation is done.
	         */
	        _this._panelDoneAnimating = false;
	        /**
	         * Strategy that will be used to handle scrolling while the select panel is open.
	         */
	        _this._scrollStrategy = _this._scrollStrategyFactory();
	        /**
	         * The y-offset of the overlay panel in relation to the trigger's top start corner.
	         * This must be adjusted to align the selected option text over the trigger text.
	         * when the panel opens. Will change based on the y-position of the selected option.
	         */
	        _this._offsetY = 0;
	        /**
	         * This position config ensures that the top "start" corner of the overlay
	         * is aligned with with the top "start" of the origin by default (overlapping
	         * the trigger completely). If the panel cannot fit below the trigger, it
	         * will fall back to a position above the trigger.
	         */
	        _this._positions = [
	            {
	                originX: 'start',
	                originY: 'top',
	                overlayX: 'start',
	                overlayY: 'top',
	            },
	            {
	                originX: 'start',
	                originY: 'bottom',
	                overlayX: 'start',
	                overlayY: 'bottom',
	            },
	        ];
	        /**
	         * Whether the select is focused.
	         */
	        _this.focused = false;
	        /**
	         * A name for this control that can be used by `mat-form-field`.
	         */
	        _this.controlType = 'mat-select';
	        /**
	         * Aria label of the select. If not specified, the placeholder will be used as label.
	         */
	        _this.ariaLabel = '';
	        /**
	         * Combined stream of all of the child options' change events.
	         */
	        _this.optionSelectionChanges = rxjs_observable_defer.defer(function () {
	            if (_this.options) {
	                return rxjs_observable_merge.merge.apply(void 0, _this.options.map(function (option) { return option.onSelectionChange; }));
	            }
	            return _this._ngZone.onStable
	                .asObservable()
	                .pipe(rxjs_operators_take.take(1), rxjs_operators_switchMap.switchMap(function () { return _this.optionSelectionChanges; }));
	        });
	        /**
	         * Event emitted when the select panel has been toggled.
	         */
	        _this.openedChange = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when the select has been opened.
	         * @deprecated Use `openedChange` instead.
	         * \@deletion-target 6.0.0
	         */
	        _this.onOpen = _this._openedStream;
	        /**
	         * Event emitted when the select has been closed.
	         * @deprecated Use `openedChange` instead.
	         * \@deletion-target 6.0.0
	         */
	        _this.onClose = _this._closedStream;
	        /**
	         * Event emitted when the selected value has been changed by the user.
	         */
	        _this.selectionChange = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when the selected value has been changed by the user.
	         * @deprecated Use `selectionChange` instead.
	         * \@deletion-target 6.0.0
	         */
	        _this.change = _this.selectionChange;
	        /**
	         * Event that emits whenever the raw value of the select changes. This is here primarily
	         * to facilitate the two-way binding for the `value` input.
	         * \@docs-private
	         */
	        _this.valueChange = new _angular_core.EventEmitter();
	        if (_this.ngControl) {
	            // Note: we provide the value accessor through here, instead of
	            // the `providers` to avoid running into a circular import.
	            // Note: we provide the value accessor through here, instead of
	            // the `providers` to avoid running into a circular import.
	            _this.ngControl.valueAccessor = _this;
	        }
	        _this.tabIndex = parseInt(tabIndex) || 0;
	        // Force setter to be called in case id was not specified.
	        // Force setter to be called in case id was not specified.
	        _this.id = _this.id;
	        return _this;
	    }
	    Object.defineProperty(MatSelect.prototype, "placeholder", {
	        get: /**
	         * Placeholder to be shown if no value has been selected.
	         * @return {?}
	         */
	        function () { return this._placeholder; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._placeholder = value;
	            this.stateChanges.next();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSelect.prototype, "required", {
	        get: /**
	         * Whether the component is required.
	         * @return {?}
	         */
	        function () { return this._required; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._required = _angular_cdk_coercion.coerceBooleanProperty(value);
	            this.stateChanges.next();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSelect.prototype, "multiple", {
	        get: /**
	         * Whether the user should be allowed to select multiple options.
	         * @return {?}
	         */
	        function () { return this._multiple; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (this._selectionModel) {
	                throw getMatSelectDynamicMultipleError();
	            }
	            this._multiple = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSelect.prototype, "compareWith", {
	        get: /**
	         * A function to compare the option values with the selected values. The first argument
	         * is a value from an option. The second is a value from the selection. A boolean
	         * should be returned.
	         * @return {?}
	         */
	        function () { return this._compareWith; },
	        set: /**
	         * @param {?} fn
	         * @return {?}
	         */
	        function (fn) {
	            if (typeof fn !== 'function') {
	                throw getMatSelectNonFunctionValueError();
	            }
	            this._compareWith = fn;
	            if (this._selectionModel) {
	                // A different comparator means the selection could change.
	                this._initializeSelection();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSelect.prototype, "value", {
	        get: /**
	         * Value of the select control.
	         * @return {?}
	         */
	        function () { return this._value; },
	        set: /**
	         * @param {?} newValue
	         * @return {?}
	         */
	        function (newValue) {
	            if (newValue !== this._value) {
	                this.writeValue(newValue);
	                this._value = newValue;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSelect.prototype, "id", {
	        get: /**
	         * Unique id of the element.
	         * @return {?}
	         */
	        function () { return this._id; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._id = value || this._uid;
	            this.stateChanges.next();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSelect.prototype, "_openedStream", {
	        get: /**
	         * Event emitted when the select has been opened.
	         * @return {?}
	         */
	        function () {
	            return this.openedChange.pipe(rxjs_operators_filter.filter(function (o) { return o; }), rxjs_operators_map.map(function () { }));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSelect.prototype, "_closedStream", {
	        get: /**
	         * Event emitted when the select has been closed.
	         * @return {?}
	         */
	        function () {
	            return this.openedChange.pipe(rxjs_operators_filter.filter(function (o) { return !o; }), rxjs_operators_map.map(function () { }));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatSelect.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        this._selectionModel = new _angular_cdk_collections.SelectionModel(this.multiple, undefined, false);
	        this.stateChanges.next();
	    };
	    /**
	     * @return {?}
	     */
	    MatSelect.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._initKeyManager();
	        this.options.changes.pipe(rxjs_operators_startWith.startWith(null), rxjs_operators_takeUntil.takeUntil(this._destroy)).subscribe(function () {
	            _this._resetOptions();
	            _this._initializeSelection();
	        });
	    };
	    /**
	     * @return {?}
	     */
	    MatSelect.prototype.ngDoCheck = /**
	     * @return {?}
	     */
	    function () {
	        if (this.ngControl) {
	            this.updateErrorState();
	        }
	    };
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    MatSelect.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        // Updating the disabled state is handled by `mixinDisabled`, but we need to additionally let
	        // the parent form field know to run change detection when the disabled state changes.
	        if (changes["disabled"]) {
	            this.stateChanges.next();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatSelect.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._destroy.next();
	        this._destroy.complete();
	        this.stateChanges.complete();
	    };
	    /** Toggles the overlay panel open or closed. */
	    /**
	     * Toggles the overlay panel open or closed.
	     * @return {?}
	     */
	    MatSelect.prototype.toggle = /**
	     * Toggles the overlay panel open or closed.
	     * @return {?}
	     */
	    function () {
	        this.panelOpen ? this.close() : this.open();
	    };
	    /** Opens the overlay panel. */
	    /**
	     * Opens the overlay panel.
	     * @return {?}
	     */
	    MatSelect.prototype.open = /**
	     * Opens the overlay panel.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this.disabled || !this.options || !this.options.length) {
	            return;
	        }
	        this._triggerRect = this.trigger.nativeElement.getBoundingClientRect();
	        // Note: The computed font-size will be a string pixel value (e.g. "16px").
	        // `parseInt` ignores the trailing 'px' and converts this to a number.
	        this._triggerFontSize = parseInt(getComputedStyle(this.trigger.nativeElement)['font-size']);
	        this._panelOpen = true;
	        this._keyManager.withHorizontalOrientation(null);
	        this._calculateOverlayPosition();
	        this._highlightCorrectOption();
	        this._changeDetectorRef.markForCheck();
	        // Set the font size on the panel element once it exists.
	        this._ngZone.onStable.asObservable().pipe(rxjs_operators_take.take(1)).subscribe(function () {
	            if (_this._triggerFontSize && _this.overlayDir.overlayRef &&
	                _this.overlayDir.overlayRef.overlayElement) {
	                _this.overlayDir.overlayRef.overlayElement.style.fontSize = _this._triggerFontSize + "px";
	            }
	        });
	    };
	    /** Closes the overlay panel and focuses the host element. */
	    /**
	     * Closes the overlay panel and focuses the host element.
	     * @return {?}
	     */
	    MatSelect.prototype.close = /**
	     * Closes the overlay panel and focuses the host element.
	     * @return {?}
	     */
	    function () {
	        if (this._panelOpen) {
	            this._panelOpen = false;
	            this._keyManager.withHorizontalOrientation(this._isRtl() ? 'rtl' : 'ltr');
	            this._changeDetectorRef.markForCheck();
	            this._onTouched();
	        }
	    };
	    /**
	     * Sets the select's value. Part of the ControlValueAccessor interface
	     * required to integrate with Angular's core forms API.
	     *
	     * @param value New value to be written to the model.
	     */
	    /**
	     * Sets the select's value. Part of the ControlValueAccessor interface
	     * required to integrate with Angular's core forms API.
	     *
	     * @param {?} value New value to be written to the model.
	     * @return {?}
	     */
	    MatSelect.prototype.writeValue = /**
	     * Sets the select's value. Part of the ControlValueAccessor interface
	     * required to integrate with Angular's core forms API.
	     *
	     * @param {?} value New value to be written to the model.
	     * @return {?}
	     */
	    function (value) {
	        if (this.options) {
	            this._setSelectionByValue(value);
	        }
	    };
	    /**
	     * Saves a callback function to be invoked when the select's value
	     * changes from user input. Part of the ControlValueAccessor interface
	     * required to integrate with Angular's core forms API.
	     *
	     * @param fn Callback to be triggered when the value changes.
	     */
	    /**
	     * Saves a callback function to be invoked when the select's value
	     * changes from user input. Part of the ControlValueAccessor interface
	     * required to integrate with Angular's core forms API.
	     *
	     * @param {?} fn Callback to be triggered when the value changes.
	     * @return {?}
	     */
	    MatSelect.prototype.registerOnChange = /**
	     * Saves a callback function to be invoked when the select's value
	     * changes from user input. Part of the ControlValueAccessor interface
	     * required to integrate with Angular's core forms API.
	     *
	     * @param {?} fn Callback to be triggered when the value changes.
	     * @return {?}
	     */
	    function (fn) {
	        this._onChange = fn;
	    };
	    /**
	     * Saves a callback function to be invoked when the select is blurred
	     * by the user. Part of the ControlValueAccessor interface required
	     * to integrate with Angular's core forms API.
	     *
	     * @param fn Callback to be triggered when the component has been touched.
	     */
	    /**
	     * Saves a callback function to be invoked when the select is blurred
	     * by the user. Part of the ControlValueAccessor interface required
	     * to integrate with Angular's core forms API.
	     *
	     * @param {?} fn Callback to be triggered when the component has been touched.
	     * @return {?}
	     */
	    MatSelect.prototype.registerOnTouched = /**
	     * Saves a callback function to be invoked when the select is blurred
	     * by the user. Part of the ControlValueAccessor interface required
	     * to integrate with Angular's core forms API.
	     *
	     * @param {?} fn Callback to be triggered when the component has been touched.
	     * @return {?}
	     */
	    function (fn) {
	        this._onTouched = fn;
	    };
	    /**
	     * Disables the select. Part of the ControlValueAccessor interface required
	     * to integrate with Angular's core forms API.
	     *
	     * @param isDisabled Sets whether the component is disabled.
	     */
	    /**
	     * Disables the select. Part of the ControlValueAccessor interface required
	     * to integrate with Angular's core forms API.
	     *
	     * @param {?} isDisabled Sets whether the component is disabled.
	     * @return {?}
	     */
	    MatSelect.prototype.setDisabledState = /**
	     * Disables the select. Part of the ControlValueAccessor interface required
	     * to integrate with Angular's core forms API.
	     *
	     * @param {?} isDisabled Sets whether the component is disabled.
	     * @return {?}
	     */
	    function (isDisabled) {
	        this.disabled = isDisabled;
	        this._changeDetectorRef.markForCheck();
	        this.stateChanges.next();
	    };
	    Object.defineProperty(MatSelect.prototype, "panelOpen", {
	        /** Whether or not the overlay panel is open. */
	        get: /**
	         * Whether or not the overlay panel is open.
	         * @return {?}
	         */
	        function () {
	            return this._panelOpen;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSelect.prototype, "selected", {
	        /** The currently selected option. */
	        get: /**
	         * The currently selected option.
	         * @return {?}
	         */
	        function () {
	            return this.multiple ? this._selectionModel.selected : this._selectionModel.selected[0];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSelect.prototype, "triggerValue", {
	        /** The value displayed in the trigger. */
	        get: /**
	         * The value displayed in the trigger.
	         * @return {?}
	         */
	        function () {
	            if (this.empty) {
	                return '';
	            }
	            if (this._multiple) {
	                var /** @type {?} */ selectedOptions = this._selectionModel.selected.map(function (option) { return option.viewValue; });
	                if (this._isRtl()) {
	                    selectedOptions.reverse();
	                }
	                // TODO(crisbeto): delimiter should be configurable for proper localization.
	                return selectedOptions.join(', ');
	            }
	            return this._selectionModel.selected[0].viewValue;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** Whether the element is in RTL mode. */
	    /**
	     * Whether the element is in RTL mode.
	     * @return {?}
	     */
	    MatSelect.prototype._isRtl = /**
	     * Whether the element is in RTL mode.
	     * @return {?}
	     */
	    function () {
	        return this._dir ? this._dir.value === 'rtl' : false;
	    };
	    /** Handles all keydown events on the select. */
	    /**
	     * Handles all keydown events on the select.
	     * @param {?} event
	     * @return {?}
	     */
	    MatSelect.prototype._handleKeydown = /**
	     * Handles all keydown events on the select.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (!this.disabled) {
	            this.panelOpen ? this._handleOpenKeydown(event) : this._handleClosedKeydown(event);
	        }
	    };
	    /**
	     * Handles keyboard events while the select is closed.
	     * @param {?} event
	     * @return {?}
	     */
	    MatSelect.prototype._handleClosedKeydown = /**
	     * Handles keyboard events while the select is closed.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var /** @type {?} */ keyCode = event.keyCode;
	        var /** @type {?} */ isArrowKey = keyCode === _angular_cdk_keycodes.DOWN_ARROW || keyCode === _angular_cdk_keycodes.UP_ARROW ||
	            keyCode === _angular_cdk_keycodes.LEFT_ARROW || keyCode === _angular_cdk_keycodes.RIGHT_ARROW;
	        var /** @type {?} */ isOpenKey = keyCode === _angular_cdk_keycodes.ENTER || keyCode === _angular_cdk_keycodes.SPACE;
	        // Open the select on ALT + arrow key to match the native <select>
	        if (isOpenKey || ((this.multiple || event.altKey) && isArrowKey)) {
	            event.preventDefault(); // prevents the page from scrolling down when pressing space
	            this.open();
	        }
	        else if (!this.multiple) {
	            this._keyManager.onKeydown(event);
	        }
	    };
	    /**
	     * Handles keyboard events when the selected is open.
	     * @param {?} event
	     * @return {?}
	     */
	    MatSelect.prototype._handleOpenKeydown = /**
	     * Handles keyboard events when the selected is open.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var /** @type {?} */ keyCode = event.keyCode;
	        var /** @type {?} */ isArrowKey = keyCode === _angular_cdk_keycodes.DOWN_ARROW || keyCode === _angular_cdk_keycodes.UP_ARROW;
	        var /** @type {?} */ manager = this._keyManager;
	        if (keyCode === _angular_cdk_keycodes.HOME || keyCode === _angular_cdk_keycodes.END) {
	            event.preventDefault();
	            keyCode === _angular_cdk_keycodes.HOME ? manager.setFirstItemActive() : manager.setLastItemActive();
	        }
	        else if (isArrowKey && event.altKey) {
	            // Close the select on ALT + arrow key to match the native <select>
	            event.preventDefault();
	            this.close();
	        }
	        else if ((keyCode === _angular_cdk_keycodes.ENTER || keyCode === _angular_cdk_keycodes.SPACE) && manager.activeItem) {
	            event.preventDefault();
	            manager.activeItem._selectViaInteraction();
	        }
	        else {
	            var /** @type {?} */ previouslyFocusedIndex = manager.activeItemIndex;
	            manager.onKeydown(event);
	            if (this._multiple && isArrowKey && event.shiftKey && manager.activeItem &&
	                manager.activeItemIndex !== previouslyFocusedIndex) {
	                manager.activeItem._selectViaInteraction();
	            }
	        }
	    };
	    /**
	     * When the panel element is finished transforming in (though not fading in), it
	     * emits an event and focuses an option if the panel is open.
	     */
	    /**
	     * When the panel element is finished transforming in (though not fading in), it
	     * emits an event and focuses an option if the panel is open.
	     * @return {?}
	     */
	    MatSelect.prototype._onPanelDone = /**
	     * When the panel element is finished transforming in (though not fading in), it
	     * emits an event and focuses an option if the panel is open.
	     * @return {?}
	     */
	    function () {
	        if (this.panelOpen) {
	            this._scrollTop = 0;
	            this.openedChange.emit(true);
	        }
	        else {
	            this.openedChange.emit(false);
	            this._panelDoneAnimating = false;
	            this.overlayDir.offsetX = 0;
	            this._changeDetectorRef.markForCheck();
	        }
	    };
	    /**
	     * When the panel content is done fading in, the _panelDoneAnimating property is
	     * set so the proper class can be added to the panel.
	     */
	    /**
	     * When the panel content is done fading in, the _panelDoneAnimating property is
	     * set so the proper class can be added to the panel.
	     * @return {?}
	     */
	    MatSelect.prototype._onFadeInDone = /**
	     * When the panel content is done fading in, the _panelDoneAnimating property is
	     * set so the proper class can be added to the panel.
	     * @return {?}
	     */
	    function () {
	        this._panelDoneAnimating = this.panelOpen;
	        this._changeDetectorRef.markForCheck();
	    };
	    /**
	     * @return {?}
	     */
	    MatSelect.prototype._onFocus = /**
	     * @return {?}
	     */
	    function () {
	        if (!this.disabled) {
	            this.focused = true;
	            this.stateChanges.next();
	        }
	    };
	    /**
	     * Calls the touched callback only if the panel is closed. Otherwise, the trigger will
	     * "blur" to the panel when it opens, causing a false positive.
	     */
	    /**
	     * Calls the touched callback only if the panel is closed. Otherwise, the trigger will
	     * "blur" to the panel when it opens, causing a false positive.
	     * @return {?}
	     */
	    MatSelect.prototype._onBlur = /**
	     * Calls the touched callback only if the panel is closed. Otherwise, the trigger will
	     * "blur" to the panel when it opens, causing a false positive.
	     * @return {?}
	     */
	    function () {
	        this.focused = false;
	        if (!this.disabled && !this.panelOpen) {
	            this._onTouched();
	            this._changeDetectorRef.markForCheck();
	            this.stateChanges.next();
	        }
	    };
	    /**
	     * Callback that is invoked when the overlay panel has been attached.
	     */
	    /**
	     * Callback that is invoked when the overlay panel has been attached.
	     * @return {?}
	     */
	    MatSelect.prototype._onAttached = /**
	     * Callback that is invoked when the overlay panel has been attached.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this.overlayDir.positionChange.pipe(rxjs_operators_take.take(1)).subscribe(function () {
	            _this._changeDetectorRef.detectChanges();
	            _this._calculateOverlayOffsetX();
	            _this.panel.nativeElement.scrollTop = _this._scrollTop;
	        });
	    };
	    /** Returns the theme to be used on the panel. */
	    /**
	     * Returns the theme to be used on the panel.
	     * @return {?}
	     */
	    MatSelect.prototype._getPanelTheme = /**
	     * Returns the theme to be used on the panel.
	     * @return {?}
	     */
	    function () {
	        return this._parentFormField ? "mat-" + this._parentFormField.color : '';
	    };
	    Object.defineProperty(MatSelect.prototype, "empty", {
	        /** Whether the select has a value. */
	        get: /**
	         * Whether the select has a value.
	         * @return {?}
	         */
	        function () {
	            return !this._selectionModel || this._selectionModel.isEmpty();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatSelect.prototype._initializeSelection = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        // Defer setting the value in order to avoid the "Expression
	        // has changed after it was checked" errors from Angular.
	        Promise.resolve().then(function () {
	            _this._setSelectionByValue(_this.ngControl ? _this.ngControl.value : _this._value);
	        });
	    };
	    /**
	     * Sets the selected option based on a value. If no option can be
	     * found with the designated value, the select trigger is cleared.
	     * @param {?} value
	     * @param {?=} isUserInput
	     * @return {?}
	     */
	    MatSelect.prototype._setSelectionByValue = /**
	     * Sets the selected option based on a value. If no option can be
	     * found with the designated value, the select trigger is cleared.
	     * @param {?} value
	     * @param {?=} isUserInput
	     * @return {?}
	     */
	    function (value, isUserInput) {
	        var _this = this;
	        if (isUserInput === void 0) { isUserInput = false; }
	        if (this.multiple && value) {
	            if (!Array.isArray(value)) {
	                throw getMatSelectNonArrayValueError();
	            }
	            this._clearSelection();
	            value.forEach(function (currentValue) { return _this._selectValue(currentValue, isUserInput); });
	            this._sortValues();
	        }
	        else {
	            this._clearSelection();
	            var /** @type {?} */ correspondingOption = this._selectValue(value, isUserInput);
	            // Shift focus to the active item. Note that we shouldn't do this in multiple
	            // mode, because we don't know what option the user interacted with last.
	            if (correspondingOption) {
	                this._keyManager.setActiveItem(this.options.toArray().indexOf(correspondingOption));
	            }
	        }
	        this._changeDetectorRef.markForCheck();
	    };
	    /**
	     * Finds and selects and option based on its value.
	     * @param {?} value
	     * @param {?=} isUserInput
	     * @return {?} Option that has the corresponding value.
	     */
	    MatSelect.prototype._selectValue = /**
	     * Finds and selects and option based on its value.
	     * @param {?} value
	     * @param {?=} isUserInput
	     * @return {?} Option that has the corresponding value.
	     */
	    function (value, isUserInput) {
	        var _this = this;
	        if (isUserInput === void 0) { isUserInput = false; }
	        var /** @type {?} */ correspondingOption = this.options.find(function (option) {
	            try {
	                // Treat null as a special reset value.
	                return option.value != null && _this._compareWith(option.value, value);
	            }
	            catch (/** @type {?} */ error) {
	                if (_angular_core.isDevMode()) {
	                    // Notify developers of errors in their comparator.
	                    console.warn(error);
	                }
	                return false;
	            }
	        });
	        if (correspondingOption) {
	            isUserInput ? correspondingOption._selectViaInteraction() : correspondingOption.select();
	            this._selectionModel.select(correspondingOption);
	            this.stateChanges.next();
	        }
	        return correspondingOption;
	    };
	    /**
	     * Clears the select trigger and deselects every option in the list.
	     * @param {?=} skip Option that should not be deselected.
	     * @return {?}
	     */
	    MatSelect.prototype._clearSelection = /**
	     * Clears the select trigger and deselects every option in the list.
	     * @param {?=} skip Option that should not be deselected.
	     * @return {?}
	     */
	    function (skip) {
	        this._selectionModel.clear();
	        this.options.forEach(function (option) {
	            if (option !== skip) {
	                option.deselect();
	            }
	        });
	        this.stateChanges.next();
	    };
	    /**
	     * Sets up a key manager to listen to keyboard events on the overlay panel.
	     * @return {?}
	     */
	    MatSelect.prototype._initKeyManager = /**
	     * Sets up a key manager to listen to keyboard events on the overlay panel.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._keyManager = new _angular_cdk_a11y.ActiveDescendantKeyManager(this.options)
	            .withTypeAhead()
	            .withVerticalOrientation()
	            .withHorizontalOrientation(this._isRtl() ? 'rtl' : 'ltr');
	        this._keyManager.tabOut.pipe(rxjs_operators_takeUntil.takeUntil(this._destroy)).subscribe(function () { return _this.close(); });
	        this._keyManager.change.pipe(rxjs_operators_takeUntil.takeUntil(this._destroy)).subscribe(function () {
	            if (_this._panelOpen && _this.panel) {
	                _this._scrollActiveOptionIntoView();
	            }
	            else if (!_this._panelOpen && !_this.multiple && _this._keyManager.activeItem) {
	                _this._keyManager.activeItem._selectViaInteraction();
	            }
	        });
	    };
	    /**
	     * Drops current option subscriptions and IDs and resets from scratch.
	     * @return {?}
	     */
	    MatSelect.prototype._resetOptions = /**
	     * Drops current option subscriptions and IDs and resets from scratch.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ changedOrDestroyed = rxjs_observable_merge.merge(this.options.changes, this._destroy);
	        this.optionSelectionChanges
	            .pipe(rxjs_operators_takeUntil.takeUntil(changedOrDestroyed), rxjs_operators_filter.filter(function (event) { return event.isUserInput; }))
	            .subscribe(function (event) {
	            _this._onSelect(event.source);
	            if (!_this.multiple && _this._panelOpen) {
	                _this.close();
	                _this.focus();
	            }
	        });
	        // Listen to changes in the internal state of the options and react accordingly.
	        // Handles cases like the labels of the selected options changing.
	        rxjs_observable_merge.merge.apply(void 0, this.options.map(function (option) { return option._stateChanges; })).pipe(rxjs_operators_takeUntil.takeUntil(changedOrDestroyed))
	            .subscribe(function () {
	            _this._changeDetectorRef.markForCheck();
	            _this.stateChanges.next();
	        });
	        this._setOptionIds();
	    };
	    /**
	     * Invoked when an option is clicked.
	     * @param {?} option
	     * @return {?}
	     */
	    MatSelect.prototype._onSelect = /**
	     * Invoked when an option is clicked.
	     * @param {?} option
	     * @return {?}
	     */
	    function (option) {
	        var /** @type {?} */ wasSelected = this._selectionModel.isSelected(option);
	        // TODO(crisbeto): handle blank/null options inside multi-select.
	        if (this.multiple) {
	            this._selectionModel.toggle(option);
	            this.stateChanges.next();
	            wasSelected ? option.deselect() : option.select();
	            this._keyManager.setActiveItem(/** @type {?} */ ((this._getOptionIndex(option))));
	            this._sortValues();
	        }
	        else {
	            this._clearSelection(option.value == null ? undefined : option);
	            if (option.value == null) {
	                this._propagateChanges(option.value);
	            }
	            else {
	                this._selectionModel.select(option);
	                this.stateChanges.next();
	            }
	        }
	        if (wasSelected !== this._selectionModel.isSelected(option)) {
	            this._propagateChanges();
	        }
	    };
	    /**
	     * Sorts the model values, ensuring that they keep the same
	     * order that they have in the panel.
	     * @return {?}
	     */
	    MatSelect.prototype._sortValues = /**
	     * Sorts the model values, ensuring that they keep the same
	     * order that they have in the panel.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._multiple) {
	            this._selectionModel.clear();
	            this.options.forEach(function (option) {
	                if (option.selected) {
	                    _this._selectionModel.select(option);
	                }
	            });
	            this.stateChanges.next();
	        }
	    };
	    /**
	     * Emits change event to set the model value.
	     * @param {?=} fallbackValue
	     * @return {?}
	     */
	    MatSelect.prototype._propagateChanges = /**
	     * Emits change event to set the model value.
	     * @param {?=} fallbackValue
	     * @return {?}
	     */
	    function (fallbackValue) {
	        var /** @type {?} */ valueToEmit = null;
	        if (this.multiple) {
	            valueToEmit = (/** @type {?} */ (this.selected)).map(function (option) { return option.value; });
	        }
	        else {
	            valueToEmit = this.selected ? (/** @type {?} */ (this.selected)).value : fallbackValue;
	        }
	        this._value = valueToEmit;
	        this.valueChange.emit(valueToEmit);
	        this._onChange(valueToEmit);
	        this.selectionChange.emit(new MatSelectChange(this, valueToEmit));
	        this._changeDetectorRef.markForCheck();
	    };
	    /**
	     * Records option IDs to pass to the aria-owns property.
	     * @return {?}
	     */
	    MatSelect.prototype._setOptionIds = /**
	     * Records option IDs to pass to the aria-owns property.
	     * @return {?}
	     */
	    function () {
	        this._optionIds = this.options.map(function (option) { return option.id; }).join(' ');
	    };
	    /**
	     * Highlights the selected item. If no option is selected, it will highlight
	     * the first item instead.
	     * @return {?}
	     */
	    MatSelect.prototype._highlightCorrectOption = /**
	     * Highlights the selected item. If no option is selected, it will highlight
	     * the first item instead.
	     * @return {?}
	     */
	    function () {
	        if (this._keyManager) {
	            if (this.empty) {
	                this._keyManager.setFirstItemActive();
	            }
	            else {
	                this._keyManager.setActiveItem(/** @type {?} */ ((this._getOptionIndex(this._selectionModel.selected[0]))));
	            }
	        }
	    };
	    /**
	     * Scrolls the active option into view.
	     * @return {?}
	     */
	    MatSelect.prototype._scrollActiveOptionIntoView = /**
	     * Scrolls the active option into view.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ activeOptionIndex = this._keyManager.activeItemIndex || 0;
	        var /** @type {?} */ labelCount = _countGroupLabelsBeforeOption(activeOptionIndex, this.options, this.optionGroups);
	        this.panel.nativeElement.scrollTop = _getOptionScrollPosition(activeOptionIndex + labelCount, this._getItemHeight(), this.panel.nativeElement.scrollTop, SELECT_PANEL_MAX_HEIGHT);
	    };
	    /** Focuses the select element. */
	    /**
	     * Focuses the select element.
	     * @return {?}
	     */
	    MatSelect.prototype.focus = /**
	     * Focuses the select element.
	     * @return {?}
	     */
	    function () {
	        this._elementRef.nativeElement.focus();
	    };
	    /**
	     * Gets the index of the provided option in the option list.
	     * @param {?} option
	     * @return {?}
	     */
	    MatSelect.prototype._getOptionIndex = /**
	     * Gets the index of the provided option in the option list.
	     * @param {?} option
	     * @return {?}
	     */
	    function (option) {
	        return this.options.reduce(function (result, current, index) {
	            return result === undefined ? (option === current ? index : undefined) : result;
	        }, undefined);
	    };
	    /**
	     * Calculates the scroll position and x- and y-offsets of the overlay panel.
	     * @return {?}
	     */
	    MatSelect.prototype._calculateOverlayPosition = /**
	     * Calculates the scroll position and x- and y-offsets of the overlay panel.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ itemHeight = this._getItemHeight();
	        var /** @type {?} */ items = this._getItemCount();
	        var /** @type {?} */ panelHeight = Math.min(items * itemHeight, SELECT_PANEL_MAX_HEIGHT);
	        var /** @type {?} */ scrollContainerHeight = items * itemHeight;
	        // The farthest the panel can be scrolled before it hits the bottom
	        var /** @type {?} */ maxScroll = scrollContainerHeight - panelHeight;
	        // If no value is selected we open the popup to the first item.
	        var /** @type {?} */ selectedOptionOffset = this.empty ? 0 : /** @type {?} */ ((this._getOptionIndex(this._selectionModel.selected[0])));
	        selectedOptionOffset += _countGroupLabelsBeforeOption(selectedOptionOffset, this.options, this.optionGroups);
	        // We must maintain a scroll buffer so the selected option will be scrolled to the
	        // center of the overlay panel rather than the top.
	        var /** @type {?} */ scrollBuffer = panelHeight / 2;
	        this._scrollTop = this._calculateOverlayScroll(selectedOptionOffset, scrollBuffer, maxScroll);
	        this._offsetY = this._calculateOverlayOffsetY(selectedOptionOffset, scrollBuffer, maxScroll);
	        this._checkOverlayWithinViewport(maxScroll);
	    };
	    /**
	     * Calculates the scroll position of the select's overlay panel.
	     *
	     * Attempts to center the selected option in the panel. If the option is
	     * too high or too low in the panel to be scrolled to the center, it clamps the
	     * scroll position to the min or max scroll positions respectively.
	     */
	    /**
	     * Calculates the scroll position of the select's overlay panel.
	     *
	     * Attempts to center the selected option in the panel. If the option is
	     * too high or too low in the panel to be scrolled to the center, it clamps the
	     * scroll position to the min or max scroll positions respectively.
	     * @param {?} selectedIndex
	     * @param {?} scrollBuffer
	     * @param {?} maxScroll
	     * @return {?}
	     */
	    MatSelect.prototype._calculateOverlayScroll = /**
	     * Calculates the scroll position of the select's overlay panel.
	     *
	     * Attempts to center the selected option in the panel. If the option is
	     * too high or too low in the panel to be scrolled to the center, it clamps the
	     * scroll position to the min or max scroll positions respectively.
	     * @param {?} selectedIndex
	     * @param {?} scrollBuffer
	     * @param {?} maxScroll
	     * @return {?}
	     */
	    function (selectedIndex, scrollBuffer, maxScroll) {
	        var /** @type {?} */ itemHeight = this._getItemHeight();
	        var /** @type {?} */ optionOffsetFromScrollTop = itemHeight * selectedIndex;
	        var /** @type {?} */ halfOptionHeight = itemHeight / 2;
	        // Starts at the optionOffsetFromScrollTop, which scrolls the option to the top of the
	        // scroll container, then subtracts the scroll buffer to scroll the option down to
	        // the center of the overlay panel. Half the option height must be re-added to the
	        // scrollTop so the option is centered based on its middle, not its top edge.
	        var /** @type {?} */ optimalScrollPosition = optionOffsetFromScrollTop - scrollBuffer + halfOptionHeight;
	        return Math.min(Math.max(0, optimalScrollPosition), maxScroll);
	    };
	    Object.defineProperty(MatSelect.prototype, "_ariaLabel", {
	        /** Returns the aria-label of the select component. */
	        get: /**
	         * Returns the aria-label of the select component.
	         * @return {?}
	         */
	        function () {
	            // If an ariaLabelledby value has been set, the select should not overwrite the
	            // `aria-labelledby` value by setting the ariaLabel to the placeholder.
	            return this.ariaLabelledby ? null : this.ariaLabel || this.placeholder;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** Determines the `aria-activedescendant` to be set on the host. */
	    /**
	     * Determines the `aria-activedescendant` to be set on the host.
	     * @return {?}
	     */
	    MatSelect.prototype._getAriaActiveDescendant = /**
	     * Determines the `aria-activedescendant` to be set on the host.
	     * @return {?}
	     */
	    function () {
	        if (this.panelOpen && this._keyManager && this._keyManager.activeItem) {
	            return this._keyManager.activeItem.id;
	        }
	        return null;
	    };
	    /**
	     * Sets the x-offset of the overlay panel in relation to the trigger's top start corner.
	     * This must be adjusted to align the selected option text over the trigger text when
	     * the panel opens. Will change based on LTR or RTL text direction. Note that the offset
	     * can't be calculated until the panel has been attached, because we need to know the
	     * content width in order to constrain the panel within the viewport.
	     * @return {?}
	     */
	    MatSelect.prototype._calculateOverlayOffsetX = /**
	     * Sets the x-offset of the overlay panel in relation to the trigger's top start corner.
	     * This must be adjusted to align the selected option text over the trigger text when
	     * the panel opens. Will change based on LTR or RTL text direction. Note that the offset
	     * can't be calculated until the panel has been attached, because we need to know the
	     * content width in order to constrain the panel within the viewport.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ overlayRect = this.overlayDir.overlayRef.overlayElement.getBoundingClientRect();
	        var /** @type {?} */ viewportSize = this._viewportRuler.getViewportSize();
	        var /** @type {?} */ isRtl = this._isRtl();
	        var /** @type {?} */ paddingWidth = this.multiple ? SELECT_MULTIPLE_PANEL_PADDING_X + SELECT_PANEL_PADDING_X :
	            SELECT_PANEL_PADDING_X * 2;
	        var /** @type {?} */ offsetX;
	        // Adjust the offset, depending on the option padding.
	        if (this.multiple) {
	            offsetX = SELECT_MULTIPLE_PANEL_PADDING_X;
	        }
	        else {
	            var /** @type {?} */ selected = this._selectionModel.selected[0] || this.options.first;
	            offsetX = selected && selected.group ? SELECT_PANEL_INDENT_PADDING_X : SELECT_PANEL_PADDING_X;
	        }
	        // Invert the offset in LTR.
	        if (!isRtl) {
	            offsetX *= -1;
	        }
	        // Determine how much the select overflows on each side.
	        var /** @type {?} */ leftOverflow = 0 - (overlayRect.left + offsetX - (isRtl ? paddingWidth : 0));
	        var /** @type {?} */ rightOverflow = overlayRect.right + offsetX - viewportSize.width
	            + (isRtl ? 0 : paddingWidth);
	        // If the element overflows on either side, reduce the offset to allow it to fit.
	        if (leftOverflow > 0) {
	            offsetX += leftOverflow + SELECT_PANEL_VIEWPORT_PADDING;
	        }
	        else if (rightOverflow > 0) {
	            offsetX -= rightOverflow + SELECT_PANEL_VIEWPORT_PADDING;
	        }
	        // Set the offset directly in order to avoid having to go through change detection and
	        // potentially triggering "changed after it was checked" errors.
	        this.overlayDir.offsetX = offsetX;
	        this.overlayDir.overlayRef.updatePosition();
	    };
	    /**
	     * Calculates the y-offset of the select's overlay panel in relation to the
	     * top start corner of the trigger. It has to be adjusted in order for the
	     * selected option to be aligned over the trigger when the panel opens.
	     * @param {?} selectedIndex
	     * @param {?} scrollBuffer
	     * @param {?} maxScroll
	     * @return {?}
	     */
	    MatSelect.prototype._calculateOverlayOffsetY = /**
	     * Calculates the y-offset of the select's overlay panel in relation to the
	     * top start corner of the trigger. It has to be adjusted in order for the
	     * selected option to be aligned over the trigger when the panel opens.
	     * @param {?} selectedIndex
	     * @param {?} scrollBuffer
	     * @param {?} maxScroll
	     * @return {?}
	     */
	    function (selectedIndex, scrollBuffer, maxScroll) {
	        var /** @type {?} */ itemHeight = this._getItemHeight();
	        var /** @type {?} */ optionHeightAdjustment = (itemHeight - this._triggerRect.height) / 2;
	        var /** @type {?} */ maxOptionsDisplayed = Math.floor(SELECT_PANEL_MAX_HEIGHT / itemHeight);
	        var /** @type {?} */ optionOffsetFromPanelTop;
	        if (this._scrollTop === 0) {
	            optionOffsetFromPanelTop = selectedIndex * itemHeight;
	        }
	        else if (this._scrollTop === maxScroll) {
	            var /** @type {?} */ firstDisplayedIndex = this._getItemCount() - maxOptionsDisplayed;
	            var /** @type {?} */ selectedDisplayIndex = selectedIndex - firstDisplayedIndex;
	            // The first item is partially out of the viewport. Therefore we need to calculate what
	            // portion of it is shown in the viewport and account for it in our offset.
	            var /** @type {?} */ partialItemHeight = itemHeight - (this._getItemCount() * itemHeight - SELECT_PANEL_MAX_HEIGHT) % itemHeight;
	            // Because the panel height is longer than the height of the options alone,
	            // there is always extra padding at the top or bottom of the panel. When
	            // scrolled to the very bottom, this padding is at the top of the panel and
	            // must be added to the offset.
	            optionOffsetFromPanelTop = selectedDisplayIndex * itemHeight + partialItemHeight;
	        }
	        else {
	            // If the option was scrolled to the middle of the panel using a scroll buffer,
	            // its offset will be the scroll buffer minus the half height that was added to
	            // center it.
	            optionOffsetFromPanelTop = scrollBuffer - itemHeight / 2;
	        }
	        // The final offset is the option's offset from the top, adjusted for the height
	        // difference, multiplied by -1 to ensure that the overlay moves in the correct
	        // direction up the page.
	        return optionOffsetFromPanelTop * -1 - optionHeightAdjustment;
	    };
	    /**
	     * Checks that the attempted overlay position will fit within the viewport.
	     * If it will not fit, tries to adjust the scroll position and the associated
	     * y-offset so the panel can open fully on-screen. If it still won't fit,
	     * sets the offset back to 0 to allow the fallback position to take over.
	     * @param {?} maxScroll
	     * @return {?}
	     */
	    MatSelect.prototype._checkOverlayWithinViewport = /**
	     * Checks that the attempted overlay position will fit within the viewport.
	     * If it will not fit, tries to adjust the scroll position and the associated
	     * y-offset so the panel can open fully on-screen. If it still won't fit,
	     * sets the offset back to 0 to allow the fallback position to take over.
	     * @param {?} maxScroll
	     * @return {?}
	     */
	    function (maxScroll) {
	        var /** @type {?} */ itemHeight = this._getItemHeight();
	        var /** @type {?} */ viewportSize = this._viewportRuler.getViewportSize();
	        var /** @type {?} */ topSpaceAvailable = this._triggerRect.top - SELECT_PANEL_VIEWPORT_PADDING;
	        var /** @type {?} */ bottomSpaceAvailable = viewportSize.height - this._triggerRect.bottom - SELECT_PANEL_VIEWPORT_PADDING;
	        var /** @type {?} */ panelHeightTop = Math.abs(this._offsetY);
	        var /** @type {?} */ totalPanelHeight = Math.min(this._getItemCount() * itemHeight, SELECT_PANEL_MAX_HEIGHT);
	        var /** @type {?} */ panelHeightBottom = totalPanelHeight - panelHeightTop - this._triggerRect.height;
	        if (panelHeightBottom > bottomSpaceAvailable) {
	            this._adjustPanelUp(panelHeightBottom, bottomSpaceAvailable);
	        }
	        else if (panelHeightTop > topSpaceAvailable) {
	            this._adjustPanelDown(panelHeightTop, topSpaceAvailable, maxScroll);
	        }
	        else {
	            this._transformOrigin = this._getOriginBasedOnOption();
	        }
	    };
	    /**
	     * Adjusts the overlay panel up to fit in the viewport.
	     * @param {?} panelHeightBottom
	     * @param {?} bottomSpaceAvailable
	     * @return {?}
	     */
	    MatSelect.prototype._adjustPanelUp = /**
	     * Adjusts the overlay panel up to fit in the viewport.
	     * @param {?} panelHeightBottom
	     * @param {?} bottomSpaceAvailable
	     * @return {?}
	     */
	    function (panelHeightBottom, bottomSpaceAvailable) {
	        // Browsers ignore fractional scroll offsets, so we need to round.
	        var /** @type {?} */ distanceBelowViewport = Math.round(panelHeightBottom - bottomSpaceAvailable);
	        // Scrolls the panel up by the distance it was extending past the boundary, then
	        // adjusts the offset by that amount to move the panel up into the viewport.
	        this._scrollTop -= distanceBelowViewport;
	        this._offsetY -= distanceBelowViewport;
	        this._transformOrigin = this._getOriginBasedOnOption();
	        // If the panel is scrolled to the very top, it won't be able to fit the panel
	        // by scrolling, so set the offset to 0 to allow the fallback position to take
	        // effect.
	        if (this._scrollTop <= 0) {
	            this._scrollTop = 0;
	            this._offsetY = 0;
	            this._transformOrigin = "50% bottom 0px";
	        }
	    };
	    /**
	     * Adjusts the overlay panel down to fit in the viewport.
	     * @param {?} panelHeightTop
	     * @param {?} topSpaceAvailable
	     * @param {?} maxScroll
	     * @return {?}
	     */
	    MatSelect.prototype._adjustPanelDown = /**
	     * Adjusts the overlay panel down to fit in the viewport.
	     * @param {?} panelHeightTop
	     * @param {?} topSpaceAvailable
	     * @param {?} maxScroll
	     * @return {?}
	     */
	    function (panelHeightTop, topSpaceAvailable, maxScroll) {
	        // Browsers ignore fractional scroll offsets, so we need to round.
	        var /** @type {?} */ distanceAboveViewport = Math.round(panelHeightTop - topSpaceAvailable);
	        // Scrolls the panel down by the distance it was extending past the boundary, then
	        // adjusts the offset by that amount to move the panel down into the viewport.
	        this._scrollTop += distanceAboveViewport;
	        this._offsetY += distanceAboveViewport;
	        this._transformOrigin = this._getOriginBasedOnOption();
	        // If the panel is scrolled to the very bottom, it won't be able to fit the
	        // panel by scrolling, so set the offset to 0 to allow the fallback position
	        // to take effect.
	        if (this._scrollTop >= maxScroll) {
	            this._scrollTop = maxScroll;
	            this._offsetY = 0;
	            this._transformOrigin = "50% top 0px";
	            return;
	        }
	    };
	    /**
	     * Sets the transform origin point based on the selected option.
	     * @return {?}
	     */
	    MatSelect.prototype._getOriginBasedOnOption = /**
	     * Sets the transform origin point based on the selected option.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ itemHeight = this._getItemHeight();
	        var /** @type {?} */ optionHeightAdjustment = (itemHeight - this._triggerRect.height) / 2;
	        var /** @type {?} */ originY = Math.abs(this._offsetY) - optionHeightAdjustment + itemHeight / 2;
	        return "50% " + originY + "px 0px";
	    };
	    /**
	     * Calculates the amount of items in the select. This includes options and group labels.
	     * @return {?}
	     */
	    MatSelect.prototype._getItemCount = /**
	     * Calculates the amount of items in the select. This includes options and group labels.
	     * @return {?}
	     */
	    function () {
	        return this.options.length + this.optionGroups.length;
	    };
	    /**
	     * Calculates the height of the select's options.
	     * @return {?}
	     */
	    MatSelect.prototype._getItemHeight = /**
	     * Calculates the height of the select's options.
	     * @return {?}
	     */
	    function () {
	        return this._triggerFontSize * SELECT_ITEM_HEIGHT_EM;
	    };
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * @docs-private
	     */
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @param {?} ids
	     * @return {?}
	     */
	    MatSelect.prototype.setDescribedByIds = /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @param {?} ids
	     * @return {?}
	     */
	    function (ids) {
	        this._ariaDescribedby = ids.join(' ');
	    };
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * @docs-private
	     */
	    /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @return {?}
	     */
	    MatSelect.prototype.onContainerClick = /**
	     * Implemented as part of MatFormFieldControl.
	     * \@docs-private
	     * @return {?}
	     */
	    function () {
	        this.focus();
	        this.open();
	    };
	    Object.defineProperty(MatSelect.prototype, "shouldPlaceholderFloat", {
	        /**
	         * Implemented as part of MatFormFieldControl.
	         * @docs-private
	         */
	        get: /**
	         * Implemented as part of MatFormFieldControl.
	         * \@docs-private
	         * @return {?}
	         */
	        function () {
	            return this._panelOpen || !this.empty;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    MatSelect.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-select',
	                    exportAs: 'matSelect',
	                    template: "<div cdk-overlay-origin class=\"mat-select-trigger\" aria-hidden=\"true\" (click)=\"toggle()\" #origin=\"cdkOverlayOrigin\" #trigger><div class=\"mat-select-value\" [ngSwitch]=\"empty\"><span class=\"mat-select-placeholder\" *ngSwitchCase=\"true\">{{placeholder || '\u00A0'}}</span> <span class=\"mat-select-value-text\" *ngSwitchCase=\"false\" [ngSwitch]=\"!!customTrigger\"><span *ngSwitchDefault>{{triggerValue}}</span><ng-content select=\"mat-select-trigger\" *ngSwitchCase=\"true\"></ng-content></span></div><div class=\"mat-select-arrow-wrapper\"><div class=\"mat-select-arrow\"></div></div></div><ng-template cdk-connected-overlay hasBackdrop cdkConnectedOverlayLockPosition backdropClass=\"cdk-overlay-transparent-backdrop\" [scrollStrategy]=\"_scrollStrategy\" [origin]=\"origin\" [open]=\"panelOpen\" [positions]=\"_positions\" [minWidth]=\"_triggerRect?.width\" [offsetY]=\"_offsetY\" (backdropClick)=\"close()\" (attach)=\"_onAttached()\" (detach)=\"close()\"><div #panel class=\"mat-select-panel {{ _getPanelTheme() }}\" [ngClass]=\"panelClass\" [@transformPanel]=\"multiple ? 'showing-multiple' : 'showing'\" (@transformPanel.done)=\"_onPanelDone()\" [style.transformOrigin]=\"_transformOrigin\" [class.mat-select-panel-done-animating]=\"_panelDoneAnimating\" [style.font-size.px]=\"_triggerFontSize\" (keydown)=\"_handleKeydown($event)\"><div class=\"mat-select-content\" [@fadeInContent]=\"'showing'\" (@fadeInContent.done)=\"_onFadeInDone()\"><ng-content></ng-content></div></div></ng-template>",
	                    styles: [".mat-select{display:inline-block;width:100%;outline:0}.mat-select-trigger{display:inline-table;cursor:pointer;position:relative;box-sizing:border-box}.mat-select-disabled .mat-select-trigger{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.mat-select-value{display:table-cell;max-width:0;width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mat-select-value-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.mat-select-arrow-wrapper{display:table-cell;vertical-align:middle}.mat-select-arrow{width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid;margin:0 4px}.mat-select-panel{min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;padding-top:0;padding-bottom:0;max-height:256px;min-width:100%}.mat-select-panel:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}@media screen and (-ms-high-contrast:active){.mat-select-panel{outline:solid 1px}}.mat-select-panel .mat-optgroup-label,.mat-select-panel .mat-option{font-size:inherit;line-height:3em;height:3em}.mat-form-field-type-mat-select:not(.mat-form-field-disabled) .mat-form-field-flex{cursor:pointer}.mat-form-field-type-mat-select .mat-form-field-label{width:calc(100% - 18px)}.mat-select-placeholder{transition:color .4s .133s cubic-bezier(.25,.8,.25,1)}.mat-form-field-hide-placeholder .mat-select-placeholder{color:transparent;transition:none}"],
	                    inputs: ['disabled', 'disableRipple', 'tabIndex'],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    host: {
	                        'role': 'listbox',
	                        '[attr.id]': 'id',
	                        '[attr.tabindex]': 'tabIndex',
	                        '[attr.aria-label]': '_ariaLabel',
	                        '[attr.aria-labelledby]': 'ariaLabelledby',
	                        '[attr.aria-required]': 'required.toString()',
	                        '[attr.aria-disabled]': 'disabled.toString()',
	                        '[attr.aria-invalid]': 'errorState',
	                        '[attr.aria-owns]': 'panelOpen ? _optionIds : null',
	                        '[attr.aria-multiselectable]': 'multiple',
	                        '[attr.aria-describedby]': '_ariaDescribedby || null',
	                        '[attr.aria-activedescendant]': '_getAriaActiveDescendant()',
	                        '[class.mat-select-disabled]': 'disabled',
	                        '[class.mat-select-invalid]': 'errorState',
	                        '[class.mat-select-required]': 'required',
	                        'class': 'mat-select',
	                        '(keydown)': '_handleKeydown($event)',
	                        '(focus)': '_onFocus()',
	                        '(blur)': '_onBlur()',
	                    },
	                    animations: [
	                        matSelectAnimations.transformPanel,
	                        matSelectAnimations.fadeInContent
	                    ],
	                    providers: [
	                        { provide: MatFormFieldControl, useExisting: MatSelect },
	                        { provide: MAT_OPTION_PARENT_COMPONENT, useExisting: MatSelect }
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    MatSelect.ctorParameters = function () { return [
	        { type: _angular_cdk_overlay.ViewportRuler, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: _angular_core.NgZone, },
	        { type: ErrorStateMatcher, },
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_bidi.Directionality, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_forms.NgForm, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_forms.FormGroupDirective, decorators: [{ type: _angular_core.Optional },] },
	        { type: MatFormField, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_forms.NgControl, decorators: [{ type: _angular_core.Self }, { type: _angular_core.Optional },] },
	        { type: undefined, decorators: [{ type: _angular_core.Attribute, args: ['tabindex',] },] },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [MAT_SELECT_SCROLL_STRATEGY,] },] },
	    ]; };
	    MatSelect.propDecorators = {
	        "trigger": [{ type: _angular_core.ViewChild, args: ['trigger',] },],
	        "panel": [{ type: _angular_core.ViewChild, args: ['panel',] },],
	        "overlayDir": [{ type: _angular_core.ViewChild, args: [_angular_cdk_overlay.CdkConnectedOverlay,] },],
	        "options": [{ type: _angular_core.ContentChildren, args: [MatOption, { descendants: true },] },],
	        "optionGroups": [{ type: _angular_core.ContentChildren, args: [MatOptgroup,] },],
	        "panelClass": [{ type: _angular_core.Input },],
	        "customTrigger": [{ type: _angular_core.ContentChild, args: [MatSelectTrigger,] },],
	        "placeholder": [{ type: _angular_core.Input },],
	        "required": [{ type: _angular_core.Input },],
	        "multiple": [{ type: _angular_core.Input },],
	        "compareWith": [{ type: _angular_core.Input },],
	        "value": [{ type: _angular_core.Input },],
	        "ariaLabel": [{ type: _angular_core.Input, args: ['aria-label',] },],
	        "ariaLabelledby": [{ type: _angular_core.Input, args: ['aria-labelledby',] },],
	        "errorStateMatcher": [{ type: _angular_core.Input },],
	        "id": [{ type: _angular_core.Input },],
	        "openedChange": [{ type: _angular_core.Output },],
	        "_openedStream": [{ type: _angular_core.Output, args: ['opened',] },],
	        "_closedStream": [{ type: _angular_core.Output, args: ['closed',] },],
	        "onOpen": [{ type: _angular_core.Output },],
	        "onClose": [{ type: _angular_core.Output },],
	        "selectionChange": [{ type: _angular_core.Output },],
	        "change": [{ type: _angular_core.Output },],
	        "valueChange": [{ type: _angular_core.Output },],
	    };
	    return MatSelect;
	}(_MatSelectMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var MatSelectModule = /** @class */ (function () {
	    function MatSelectModule() {
	    }
	    MatSelectModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [
	                        _angular_common.CommonModule,
	                        _angular_cdk_overlay.OverlayModule,
	                        MatOptionModule,
	                        MatCommonModule,
	                    ],
	                    exports: [MatFormFieldModule, MatSelect, MatSelectTrigger, MatOptionModule, MatCommonModule],
	                    declarations: [MatSelect, MatSelectTrigger],
	                    providers: [MAT_SELECT_SCROLL_STRATEGY_PROVIDER, ErrorStateMatcher]
	                },] },
	    ];
	    /** @nocollapse */
	    MatSelectModule.ctorParameters = function () { return []; };
	    return MatSelectModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * Animations used by MatTooltip.
	 */
	var matTooltipAnimations = {
	    /** Animation that transitions a tooltip in and out. */
	    tooltipState: _angular_animations.trigger('state', [
	        _angular_animations.state('initial, void, hidden', _angular_animations.style({ transform: 'scale(0)' })),
	        _angular_animations.state('visible', _angular_animations.style({ transform: 'scale(1)' })),
	        _angular_animations.transition('* => visible', _angular_animations.animate('150ms cubic-bezier(0.0, 0.0, 0.2, 1)')),
	        _angular_animations.transition('* => hidden', _angular_animations.animate('150ms cubic-bezier(0.4, 0.0, 1, 1)')),
	    ])
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * Time in ms to throttle repositioning after scroll events.
	 */
	var SCROLL_THROTTLE_MS = 20;
	/**
	 * CSS class that will be attached to the overlay panel.
	 */
	var TOOLTIP_PANEL_CLASS = 'mat-tooltip-panel';
	/**
	 * Creates an error to be thrown if the user supplied an invalid tooltip position.
	 * @param {?} position
	 * @return {?}
	 */
	function getMatTooltipInvalidPositionError(position) {
	    return Error("Tooltip position \"" + position + "\" is invalid.");
	}
	/**
	 * Injection token that determines the scroll handling while a tooltip is visible.
	 */
	var MAT_TOOLTIP_SCROLL_STRATEGY = new _angular_core.InjectionToken('mat-tooltip-scroll-strategy');
	/**
	 * \@docs-private
	 * @param {?} overlay
	 * @return {?}
	 */
	function MAT_TOOLTIP_SCROLL_STRATEGY_PROVIDER_FACTORY(overlay) {
	    return function () { return overlay.scrollStrategies.reposition({ scrollThrottle: SCROLL_THROTTLE_MS }); };
	}
	/**
	 * \@docs-private
	 */
	var MAT_TOOLTIP_SCROLL_STRATEGY_PROVIDER = {
	    provide: MAT_TOOLTIP_SCROLL_STRATEGY,
	    deps: [_angular_cdk_overlay.Overlay],
	    useFactory: MAT_TOOLTIP_SCROLL_STRATEGY_PROVIDER_FACTORY
	};
	/**
	 * Default `matTooltip` options that can be overridden.
	 * @record
	 */
	
	/**
	 * Injection token to be used to override the default options for `matTooltip`.
	 */
	var MAT_TOOLTIP_DEFAULT_OPTIONS = new _angular_core.InjectionToken('mat-tooltip-default-options');
	/**
	 * Directive that attaches a material design tooltip to the host element. Animates the showing and
	 * hiding of a tooltip provided position (defaults to below the element).
	 *
	 * https://material.google.com/components/tooltips.html
	 */
	var MatTooltip = /** @class */ (function () {
	    function MatTooltip(_overlay, _elementRef, _scrollDispatcher, _viewContainerRef, _ngZone, _platform, _ariaDescriber, _focusMonitor, _scrollStrategy, _dir, _defaultOptions) {
	        // TODO(crisbeto): make the `_defaultOptions` a required param next time we do breaking changes.
	        // @deletion-target 6.0.0
	        var _this = this;
	        this._overlay = _overlay;
	        this._elementRef = _elementRef;
	        this._scrollDispatcher = _scrollDispatcher;
	        this._viewContainerRef = _viewContainerRef;
	        this._ngZone = _ngZone;
	        this._platform = _platform;
	        this._ariaDescriber = _ariaDescriber;
	        this._focusMonitor = _focusMonitor;
	        this._scrollStrategy = _scrollStrategy;
	        this._dir = _dir;
	        this._defaultOptions = _defaultOptions;
	        this._position = 'below';
	        this._disabled = false;
	        /**
	         * The default delay in ms before showing the tooltip after show is called
	         */
	        this.showDelay = this._defaultOptions ? this._defaultOptions.showDelay : 0;
	        /**
	         * The default delay in ms before hiding the tooltip after hide is called
	         */
	        this.hideDelay = this._defaultOptions ? this._defaultOptions.hideDelay : 0;
	        this._message = '';
	        this._manualListeners = new Map();
	        var /** @type {?} */ element = _elementRef.nativeElement;
	        // The mouse events shouldn't be bound on iOS devices, because
	        // they can prevent the first tap from firing its click event.
	        if (!_platform.IOS) {
	            this._manualListeners.set('mouseenter', function () { return _this.show(); });
	            this._manualListeners.set('mouseleave', function () { return _this.hide(); });
	            this._manualListeners
	                .forEach(function (listener, event) { return _elementRef.nativeElement.addEventListener(event, listener); });
	        }
	        else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
	            // When we bind a gesture event on an element (in this case `longpress`), HammerJS
	            // will add some inline styles by default, including `user-select: none`. This is
	            // problematic on iOS, because it will prevent users from typing in inputs. If
	            // we're on iOS and the tooltip is attached on an input or textarea, we clear
	            // the `user-select` to avoid these issues.
	            element.style.webkitUserSelect = element.style.userSelect = '';
	        }
	        _focusMonitor.monitor(element).subscribe(function (origin) {
	            // Note that the focus monitor runs outside the Angular zone.
	            if (!origin) {
	                _ngZone.run(function () { return _this.hide(0); });
	            }
	            else if (origin !== 'program') {
	                _ngZone.run(function () { return _this.show(); });
	            }
	        });
	    }
	    Object.defineProperty(MatTooltip.prototype, "position", {
	        get: /**
	         * Allows the user to define the position of the tooltip relative to the parent element
	         * @return {?}
	         */
	        function () { return this._position; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (value !== this._position) {
	                this._position = value;
	                // TODO(andrewjs): When the overlay's position can be dynamically changed, do not destroy
	                // the tooltip.
	                if (this._tooltipInstance) {
	                    this._disposeTooltip();
	                }
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatTooltip.prototype, "disabled", {
	        get: /**
	         * Disables the display of the tooltip.
	         * @return {?}
	         */
	        function () { return this._disabled; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._disabled = _angular_cdk_coercion.coerceBooleanProperty(value);
	            // If tooltip is disabled, hide immediately.
	            if (this._disabled) {
	                this.hide(0);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatTooltip.prototype, "_positionDeprecated", {
	        get: /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this._position; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._position = value; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatTooltip.prototype, "message", {
	        get: /**
	         * The message to be displayed in the tooltip
	         * @return {?}
	         */
	        function () { return this._message; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._ariaDescriber.removeDescription(this._elementRef.nativeElement, this._message);
	            // If the message is not a string (e.g. number), convert it to a string and trim it.
	            this._message = value != null ? ("" + value).trim() : '';
	            if (!this._message && this._isTooltipVisible()) {
	                this.hide(0);
	            }
	            else {
	                this._updateTooltipMessage();
	                this._ariaDescriber.describe(this._elementRef.nativeElement, this.message);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatTooltip.prototype, "tooltipClass", {
	        get: /**
	         * Classes to be passed to the tooltip. Supports the same syntax as `ngClass`.
	         * @return {?}
	         */
	        function () { return this._tooltipClass; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._tooltipClass = value;
	            if (this._tooltipInstance) {
	                this._setTooltipClass(this._tooltipClass);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Dispose the tooltip when destroyed.
	     */
	    /**
	     * Dispose the tooltip when destroyed.
	     * @return {?}
	     */
	    MatTooltip.prototype.ngOnDestroy = /**
	     * Dispose the tooltip when destroyed.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._tooltipInstance) {
	            this._disposeTooltip();
	        }
	        // Clean up the event listeners set in the constructor
	        if (!this._platform.IOS) {
	            this._manualListeners.forEach(function (listener, event) {
	                _this._elementRef.nativeElement.removeEventListener(event, listener);
	            });
	            this._manualListeners.clear();
	        }
	        this._ariaDescriber.removeDescription(this._elementRef.nativeElement, this.message);
	        this._focusMonitor.stopMonitoring(this._elementRef.nativeElement);
	    };
	    /** Shows the tooltip after the delay in ms, defaults to tooltip-delay-show or 0ms if no input */
	    /**
	     * Shows the tooltip after the delay in ms, defaults to tooltip-delay-show or 0ms if no input
	     * @param {?=} delay
	     * @return {?}
	     */
	    MatTooltip.prototype.show = /**
	     * Shows the tooltip after the delay in ms, defaults to tooltip-delay-show or 0ms if no input
	     * @param {?=} delay
	     * @return {?}
	     */
	    function (delay$$1) {
	        if (delay$$1 === void 0) { delay$$1 = this.showDelay; }
	        if (this.disabled || !this.message) {
	            return;
	        }
	        if (!this._tooltipInstance) {
	            this._createTooltip();
	        }
	        this._setTooltipClass(this._tooltipClass);
	        this._updateTooltipMessage(); /** @type {?} */
	        ((this._tooltipInstance)).show(this._position, delay$$1);
	    };
	    /** Hides the tooltip after the delay in ms, defaults to tooltip-delay-hide or 0ms if no input */
	    /**
	     * Hides the tooltip after the delay in ms, defaults to tooltip-delay-hide or 0ms if no input
	     * @param {?=} delay
	     * @return {?}
	     */
	    MatTooltip.prototype.hide = /**
	     * Hides the tooltip after the delay in ms, defaults to tooltip-delay-hide or 0ms if no input
	     * @param {?=} delay
	     * @return {?}
	     */
	    function (delay$$1) {
	        if (delay$$1 === void 0) { delay$$1 = this.hideDelay; }
	        if (this._tooltipInstance) {
	            this._tooltipInstance.hide(delay$$1);
	        }
	    };
	    /** Shows/hides the tooltip */
	    /**
	     * Shows/hides the tooltip
	     * @return {?}
	     */
	    MatTooltip.prototype.toggle = /**
	     * Shows/hides the tooltip
	     * @return {?}
	     */
	    function () {
	        this._isTooltipVisible() ? this.hide() : this.show();
	    };
	    /** Returns true if the tooltip is currently visible to the user */
	    /**
	     * Returns true if the tooltip is currently visible to the user
	     * @return {?}
	     */
	    MatTooltip.prototype._isTooltipVisible = /**
	     * Returns true if the tooltip is currently visible to the user
	     * @return {?}
	     */
	    function () {
	        return !!this._tooltipInstance && this._tooltipInstance.isVisible();
	    };
	    /** Handles the keydown events on the host element. */
	    /**
	     * Handles the keydown events on the host element.
	     * @param {?} e
	     * @return {?}
	     */
	    MatTooltip.prototype._handleKeydown = /**
	     * Handles the keydown events on the host element.
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        if (this._isTooltipVisible() && e.keyCode === _angular_cdk_keycodes.ESCAPE) {
	            e.stopPropagation();
	            this.hide(0);
	        }
	    };
	    /** Handles the touchend events on the host element. */
	    /**
	     * Handles the touchend events on the host element.
	     * @return {?}
	     */
	    MatTooltip.prototype._handleTouchend = /**
	     * Handles the touchend events on the host element.
	     * @return {?}
	     */
	    function () {
	        this.hide(this._defaultOptions ? this._defaultOptions.touchendHideDelay : 1500);
	    };
	    /**
	     * Create the tooltip to display
	     * @return {?}
	     */
	    MatTooltip.prototype._createTooltip = /**
	     * Create the tooltip to display
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ overlayRef = this._createOverlay();
	        var /** @type {?} */ portal = new _angular_cdk_portal.ComponentPortal(TooltipComponent, this._viewContainerRef);
	        this._tooltipInstance = overlayRef.attach(portal).instance;
	        // Dispose of the tooltip when the overlay is detached.
	        rxjs_observable_merge.merge(/** @type {?} */ ((this._tooltipInstance)).afterHidden(), overlayRef.detachments()).subscribe(function () {
	            // Check first if the tooltip has already been removed through this components destroy.
	            if (_this._tooltipInstance) {
	                _this._disposeTooltip();
	            }
	        });
	    };
	    /**
	     * Create the overlay config and position strategy
	     * @return {?}
	     */
	    MatTooltip.prototype._createOverlay = /**
	     * Create the overlay config and position strategy
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ origin = this._getOrigin();
	        var /** @type {?} */ overlay = this._getOverlayPosition();
	        // Create connected position strategy that listens for scroll events to reposition.
	        var /** @type {?} */ strategy = this._overlay
	            .position()
	            .connectedTo(this._elementRef, origin.main, overlay.main)
	            .withFallbackPosition(origin.fallback, overlay.fallback);
	        var /** @type {?} */ scrollableAncestors = this._scrollDispatcher
	            .getAncestorScrollContainers(this._elementRef);
	        strategy.withScrollableContainers(scrollableAncestors);
	        strategy.onPositionChange.subscribe(function (change) {
	            if (_this._tooltipInstance) {
	                if (change.scrollableViewProperties.isOverlayClipped && _this._tooltipInstance.isVisible()) {
	                    // After position changes occur and the overlay is clipped by
	                    // a parent scrollable then close the tooltip.
	                    // After position changes occur and the overlay is clipped by
	                    // a parent scrollable then close the tooltip.
	                    _this._ngZone.run(function () { return _this.hide(0); });
	                }
	                else {
	                    // Otherwise recalculate the origin based on the new position.
	                    // Otherwise recalculate the origin based on the new position.
	                    _this._tooltipInstance._setTransformOrigin(change.connectionPair);
	                }
	            }
	        });
	        var /** @type {?} */ config = new _angular_cdk_overlay.OverlayConfig({
	            direction: this._dir ? this._dir.value : 'ltr',
	            positionStrategy: strategy,
	            panelClass: TOOLTIP_PANEL_CLASS,
	            scrollStrategy: this._scrollStrategy()
	        });
	        this._overlayRef = this._overlay.create(config);
	        return this._overlayRef;
	    };
	    /**
	     * Disposes the current tooltip and the overlay it is attached to
	     * @return {?}
	     */
	    MatTooltip.prototype._disposeTooltip = /**
	     * Disposes the current tooltip and the overlay it is attached to
	     * @return {?}
	     */
	    function () {
	        if (this._overlayRef) {
	            this._overlayRef.dispose();
	            this._overlayRef = null;
	        }
	        this._tooltipInstance = null;
	    };
	    /**
	     * Returns the origin position and a fallback position based on the user's position preference.
	     * The fallback position is the inverse of the origin (e.g. `'below' -> 'above'`).
	     */
	    /**
	     * Returns the origin position and a fallback position based on the user's position preference.
	     * The fallback position is the inverse of the origin (e.g. `'below' -> 'above'`).
	     * @return {?}
	     */
	    MatTooltip.prototype._getOrigin = /**
	     * Returns the origin position and a fallback position based on the user's position preference.
	     * The fallback position is the inverse of the origin (e.g. `'below' -> 'above'`).
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ isDirectionLtr = !this._dir || this._dir.value == 'ltr';
	        var /** @type {?} */ position;
	        if (this.position == 'above' || this.position == 'below') {
	            position = { originX: 'center', originY: this.position == 'above' ? 'top' : 'bottom' };
	        }
	        else if (this.position == 'left' ||
	            this.position == 'before' && isDirectionLtr ||
	            this.position == 'after' && !isDirectionLtr) {
	            position = { originX: 'start', originY: 'center' };
	        }
	        else if (this.position == 'right' ||
	            this.position == 'after' && isDirectionLtr ||
	            this.position == 'before' && !isDirectionLtr) {
	            position = { originX: 'end', originY: 'center' };
	        }
	        else {
	            throw getMatTooltipInvalidPositionError(this.position);
	        }
	        var _a = this._invertPosition(position.originX, position.originY), x = _a.x, y = _a.y;
	        return {
	            main: position,
	            fallback: { originX: x, originY: y }
	        };
	    };
	    /** Returns the overlay position and a fallback position based on the user's preference */
	    /**
	     * Returns the overlay position and a fallback position based on the user's preference
	     * @return {?}
	     */
	    MatTooltip.prototype._getOverlayPosition = /**
	     * Returns the overlay position and a fallback position based on the user's preference
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ isLtr = !this._dir || this._dir.value == 'ltr';
	        var /** @type {?} */ position;
	        if (this.position == 'above') {
	            position = { overlayX: 'center', overlayY: 'bottom' };
	        }
	        else if (this.position == 'below') {
	            position = { overlayX: 'center', overlayY: 'top' };
	        }
	        else if (this.position == 'left' ||
	            this.position == 'before' && isLtr ||
	            this.position == 'after' && !isLtr) {
	            position = { overlayX: 'end', overlayY: 'center' };
	        }
	        else if (this.position == 'right' ||
	            this.position == 'after' && isLtr ||
	            this.position == 'before' && !isLtr) {
	            position = { overlayX: 'start', overlayY: 'center' };
	        }
	        else {
	            throw getMatTooltipInvalidPositionError(this.position);
	        }
	        var _a = this._invertPosition(position.overlayX, position.overlayY), x = _a.x, y = _a.y;
	        return {
	            main: position,
	            fallback: { overlayX: x, overlayY: y }
	        };
	    };
	    /**
	     * Updates the tooltip message and repositions the overlay according to the new message length
	     * @return {?}
	     */
	    MatTooltip.prototype._updateTooltipMessage = /**
	     * Updates the tooltip message and repositions the overlay according to the new message length
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        // Must wait for the message to be painted to the tooltip so that the overlay can properly
	        // calculate the correct positioning based on the size of the text.
	        if (this._tooltipInstance) {
	            this._tooltipInstance.message = this.message;
	            this._tooltipInstance._markForCheck();
	            this._ngZone.onMicrotaskEmpty.asObservable().pipe(rxjs_operators_take.take(1)).subscribe(function () {
	                if (_this._tooltipInstance) {
	                    /** @type {?} */ ((_this._overlayRef)).updatePosition();
	                }
	            });
	        }
	    };
	    /**
	     * Updates the tooltip class
	     * @param {?} tooltipClass
	     * @return {?}
	     */
	    MatTooltip.prototype._setTooltipClass = /**
	     * Updates the tooltip class
	     * @param {?} tooltipClass
	     * @return {?}
	     */
	    function (tooltipClass) {
	        if (this._tooltipInstance) {
	            this._tooltipInstance.tooltipClass = tooltipClass;
	            this._tooltipInstance._markForCheck();
	        }
	    };
	    /**
	     * Inverts an overlay position.
	     * @param {?} x
	     * @param {?} y
	     * @return {?}
	     */
	    MatTooltip.prototype._invertPosition = /**
	     * Inverts an overlay position.
	     * @param {?} x
	     * @param {?} y
	     * @return {?}
	     */
	    function (x, y) {
	        if (this.position === 'above' || this.position === 'below') {
	            if (y === 'top') {
	                y = 'bottom';
	            }
	            else if (y === 'bottom') {
	                y = 'top';
	            }
	        }
	        else {
	            if (x === 'end') {
	                x = 'start';
	            }
	            else if (x === 'start') {
	                x = 'end';
	            }
	        }
	        return { x: x, y: y };
	    };
	    MatTooltip.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[matTooltip]',
	                    exportAs: 'matTooltip',
	                    host: {
	                        '(longpress)': 'show()',
	                        '(keydown)': '_handleKeydown($event)',
	                        '(touchend)': '_handleTouchend()',
	                    },
	                },] },
	    ];
	    /** @nocollapse */
	    MatTooltip.ctorParameters = function () { return [
	        { type: _angular_cdk_overlay.Overlay, },
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_scrolling.ScrollDispatcher, },
	        { type: _angular_core.ViewContainerRef, },
	        { type: _angular_core.NgZone, },
	        { type: _angular_cdk_platform.Platform, },
	        { type: _angular_cdk_a11y.AriaDescriber, },
	        { type: _angular_cdk_a11y.FocusMonitor, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [MAT_TOOLTIP_SCROLL_STRATEGY,] },] },
	        { type: _angular_cdk_bidi.Directionality, decorators: [{ type: _angular_core.Optional },] },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MAT_TOOLTIP_DEFAULT_OPTIONS,] },] },
	    ]; };
	    MatTooltip.propDecorators = {
	        "position": [{ type: _angular_core.Input, args: ['matTooltipPosition',] },],
	        "disabled": [{ type: _angular_core.Input, args: ['matTooltipDisabled',] },],
	        "_positionDeprecated": [{ type: _angular_core.Input, args: ['tooltip-position',] },],
	        "showDelay": [{ type: _angular_core.Input, args: ['matTooltipShowDelay',] },],
	        "hideDelay": [{ type: _angular_core.Input, args: ['matTooltipHideDelay',] },],
	        "message": [{ type: _angular_core.Input, args: ['matTooltip',] },],
	        "tooltipClass": [{ type: _angular_core.Input, args: ['matTooltipClass',] },],
	    };
	    return MatTooltip;
	}());
	/**
	 * Internal component that wraps the tooltip's content.
	 * \@docs-private
	 */
	var TooltipComponent = /** @class */ (function () {
	    function TooltipComponent(_changeDetectorRef, _breakpointObserver) {
	        this._changeDetectorRef = _changeDetectorRef;
	        this._breakpointObserver = _breakpointObserver;
	        /**
	         * Property watched by the animation framework to show or hide the tooltip
	         */
	        this._visibility = 'initial';
	        /**
	         * Whether interactions on the page should close the tooltip
	         */
	        this._closeOnInteraction = false;
	        /**
	         * The transform origin used in the animation for showing and hiding the tooltip
	         */
	        this._transformOrigin = 'bottom';
	        /**
	         * Subject for notifying that the tooltip has been hidden from the view
	         */
	        this._onHide = new rxjs_Subject.Subject();
	        /**
	         * Stream that emits whether the user has a handset-sized display.
	         */
	        this._isHandset = this._breakpointObserver.observe(_angular_cdk_layout.Breakpoints.Handset);
	    }
	    /**
	     * Shows the tooltip with an animation originating from the provided origin
	     * @param position Position of the tooltip.
	     * @param delay Amount of milliseconds to the delay showing the tooltip.
	     */
	    /**
	     * Shows the tooltip with an animation originating from the provided origin
	     * @param {?} position Position of the tooltip.
	     * @param {?} delay Amount of milliseconds to the delay showing the tooltip.
	     * @return {?}
	     */
	    TooltipComponent.prototype.show = /**
	     * Shows the tooltip with an animation originating from the provided origin
	     * @param {?} position Position of the tooltip.
	     * @param {?} delay Amount of milliseconds to the delay showing the tooltip.
	     * @return {?}
	     */
	    function (position, delay$$1) {
	        var _this = this;
	        // Cancel the delayed hide if it is scheduled
	        if (this._hideTimeoutId) {
	            clearTimeout(this._hideTimeoutId);
	        }
	        // Body interactions should cancel the tooltip if there is a delay in showing.
	        this._closeOnInteraction = true;
	        this._position = position;
	        this._showTimeoutId = setTimeout(function () {
	            _this._visibility = 'visible';
	            // Mark for check so if any parent component has set the
	            // ChangeDetectionStrategy to OnPush it will be checked anyways
	            // Mark for check so if any parent component has set the
	            // ChangeDetectionStrategy to OnPush it will be checked anyways
	            _this._markForCheck();
	        }, delay$$1);
	    };
	    /**
	     * Begins the animation to hide the tooltip after the provided delay in ms.
	     * @param delay Amount of milliseconds to delay showing the tooltip.
	     */
	    /**
	     * Begins the animation to hide the tooltip after the provided delay in ms.
	     * @param {?} delay Amount of milliseconds to delay showing the tooltip.
	     * @return {?}
	     */
	    TooltipComponent.prototype.hide = /**
	     * Begins the animation to hide the tooltip after the provided delay in ms.
	     * @param {?} delay Amount of milliseconds to delay showing the tooltip.
	     * @return {?}
	     */
	    function (delay$$1) {
	        var _this = this;
	        // Cancel the delayed show if it is scheduled
	        if (this._showTimeoutId) {
	            clearTimeout(this._showTimeoutId);
	        }
	        this._hideTimeoutId = setTimeout(function () {
	            _this._visibility = 'hidden';
	            // Mark for check so if any parent component has set the
	            // ChangeDetectionStrategy to OnPush it will be checked anyways
	            // Mark for check so if any parent component has set the
	            // ChangeDetectionStrategy to OnPush it will be checked anyways
	            _this._markForCheck();
	        }, delay$$1);
	    };
	    /** Returns an observable that notifies when the tooltip has been hidden from view. */
	    /**
	     * Returns an observable that notifies when the tooltip has been hidden from view.
	     * @return {?}
	     */
	    TooltipComponent.prototype.afterHidden = /**
	     * Returns an observable that notifies when the tooltip has been hidden from view.
	     * @return {?}
	     */
	    function () {
	        return this._onHide.asObservable();
	    };
	    /** Whether the tooltip is being displayed. */
	    /**
	     * Whether the tooltip is being displayed.
	     * @return {?}
	     */
	    TooltipComponent.prototype.isVisible = /**
	     * Whether the tooltip is being displayed.
	     * @return {?}
	     */
	    function () {
	        return this._visibility === 'visible';
	    };
	    /** Sets the tooltip transform origin according to the position of the tooltip overlay. */
	    /**
	     * Sets the tooltip transform origin according to the position of the tooltip overlay.
	     * @param {?} overlayPosition
	     * @return {?}
	     */
	    TooltipComponent.prototype._setTransformOrigin = /**
	     * Sets the tooltip transform origin according to the position of the tooltip overlay.
	     * @param {?} overlayPosition
	     * @return {?}
	     */
	    function (overlayPosition) {
	        var /** @type {?} */ axis = (this._position === 'above' || this._position === 'below') ? 'Y' : 'X';
	        var /** @type {?} */ position = axis == 'X' ? overlayPosition.overlayX : overlayPosition.overlayY;
	        if (position === 'top' || position === 'bottom') {
	            this._transformOrigin = position;
	        }
	        else if (position === 'start') {
	            this._transformOrigin = 'left';
	        }
	        else if (position === 'end') {
	            this._transformOrigin = 'right';
	        }
	        else {
	            throw getMatTooltipInvalidPositionError(this._position);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    TooltipComponent.prototype._animationStart = /**
	     * @return {?}
	     */
	    function () {
	        this._closeOnInteraction = false;
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    TooltipComponent.prototype._animationDone = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var /** @type {?} */ toState = /** @type {?} */ (event.toState);
	        if (toState === 'hidden' && !this.isVisible()) {
	            this._onHide.next();
	        }
	        if (toState === 'visible' || toState === 'hidden') {
	            this._closeOnInteraction = true;
	        }
	    };
	    /**
	     * Interactions on the HTML body should close the tooltip immediately as defined in the
	     * material design spec.
	     * https://material.google.com/components/tooltips.html#tooltips-interaction
	     */
	    /**
	     * Interactions on the HTML body should close the tooltip immediately as defined in the
	     * material design spec.
	     * https://material.google.com/components/tooltips.html#tooltips-interaction
	     * @return {?}
	     */
	    TooltipComponent.prototype._handleBodyInteraction = /**
	     * Interactions on the HTML body should close the tooltip immediately as defined in the
	     * material design spec.
	     * https://material.google.com/components/tooltips.html#tooltips-interaction
	     * @return {?}
	     */
	    function () {
	        if (this._closeOnInteraction) {
	            this.hide(0);
	        }
	    };
	    /**
	     * Marks that the tooltip needs to be checked in the next change detection run.
	     * Mainly used for rendering the initial text before positioning a tooltip, which
	     * can be problematic in components with OnPush change detection.
	     */
	    /**
	     * Marks that the tooltip needs to be checked in the next change detection run.
	     * Mainly used for rendering the initial text before positioning a tooltip, which
	     * can be problematic in components with OnPush change detection.
	     * @return {?}
	     */
	    TooltipComponent.prototype._markForCheck = /**
	     * Marks that the tooltip needs to be checked in the next change detection run.
	     * Mainly used for rendering the initial text before positioning a tooltip, which
	     * can be problematic in components with OnPush change detection.
	     * @return {?}
	     */
	    function () {
	        this._changeDetectorRef.markForCheck();
	    };
	    TooltipComponent.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-tooltip-component',
	                    template: "<div class=\"mat-tooltip\" [ngClass]=\"tooltipClass\" [class.mat-tooltip-handset]=\"(_isHandset | async)!.matches\" [style.transform-origin]=\"_transformOrigin\" [@state]=\"_visibility\" (@state.start)=\"_animationStart()\" (@state.done)=\"_animationDone($event)\">{{message}}</div>",
	                    styles: [".mat-tooltip-panel{pointer-events:none!important}.mat-tooltip{color:#fff;border-radius:2px;margin:14px;max-width:250px;padding-left:8px;padding-right:8px}@media screen and (-ms-high-contrast:active){.mat-tooltip{outline:solid 1px}}.mat-tooltip-handset{margin:24px;padding-left:16px;padding-right:16px}"],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    animations: [matTooltipAnimations.tooltipState],
	                    host: {
	                        // Forces the element to have a layout in IE and Edge. This fixes issues where the element
	                        // won't be rendered if the animations are disabled or there is no web animations polyfill.
	                        '[style.zoom]': '_visibility === "visible" ? 1 : null',
	                        '(body:click)': 'this._handleBodyInteraction()',
	                        'aria-hidden': 'true',
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    TooltipComponent.ctorParameters = function () { return [
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: _angular_cdk_layout.BreakpointObserver, },
	    ]; };
	    return TooltipComponent;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var ɵ0$1$1 = {
	    showDelay: 0,
	    hideDelay: 0,
	    touchendHideDelay: 1500
	};
	var MatTooltipModule = /** @class */ (function () {
	    function MatTooltipModule() {
	    }
	    MatTooltipModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [
	                        _angular_common.CommonModule,
	                        _angular_cdk_overlay.OverlayModule,
	                        MatCommonModule,
	                        _angular_cdk_platform.PlatformModule,
	                        _angular_cdk_a11y.A11yModule,
	                        _angular_cdk_layout.LayoutModule,
	                    ],
	                    exports: [MatTooltip, TooltipComponent, MatCommonModule],
	                    declarations: [MatTooltip, TooltipComponent],
	                    entryComponents: [TooltipComponent],
	                    providers: [
	                        MAT_TOOLTIP_SCROLL_STRATEGY_PROVIDER,
	                        _angular_cdk_a11y.ARIA_DESCRIBER_PROVIDER,
	                        {
	                            provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
	                            useValue: ɵ0$1$1
	                        }
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    MatTooltipModule.ctorParameters = function () { return []; };
	    return MatTooltipModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * To modify the labels and text displayed, create a new instance of MatPaginatorIntl and
	 * include it in a custom provider
	 */
	var MatPaginatorIntl = /** @class */ (function () {
	    function MatPaginatorIntl() {
	        /**
	         * Stream that emits whenever the labels here are changed. Use this to notify
	         * components if the labels have changed after initialization.
	         */
	        this.changes = new rxjs_Subject.Subject();
	        /**
	         * A label for the page size selector.
	         */
	        this.itemsPerPageLabel = 'Items per page:';
	        /**
	         * A label for the button that increments the current page.
	         */
	        this.nextPageLabel = 'Next page';
	        /**
	         * A label for the button that decrements the current page.
	         */
	        this.previousPageLabel = 'Previous page';
	        /**
	         * A label for the button that moves to the first page.
	         */
	        this.firstPageLabel = 'First page';
	        /**
	         * A label for the button that moves to the last page.
	         */
	        this.lastPageLabel = 'Last page';
	        /**
	         * A label for the range of items within the current page and the length of the whole list.
	         */
	        this.getRangeLabel = function (page, pageSize, length) {
	            if (length == 0 || pageSize == 0) {
	                return "0 of " + length;
	            }
	            length = Math.max(length, 0);
	            var /** @type {?} */ startIndex = page * pageSize;
	            // If the start index exceeds the list length, do not try and fix the end index to the end.
	            var /** @type {?} */ endIndex = startIndex < length ?
	                Math.min(startIndex + pageSize, length) :
	                startIndex + pageSize;
	            return startIndex + 1 + " - " + endIndex + " of " + length;
	        };
	    }
	    MatPaginatorIntl.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    MatPaginatorIntl.ctorParameters = function () { return []; };
	    return MatPaginatorIntl;
	}());
	/**
	 * \@docs-private
	 * @param {?} parentIntl
	 * @return {?}
	 */
	function MAT_PAGINATOR_INTL_PROVIDER_FACTORY(parentIntl) {
	    return parentIntl || new MatPaginatorIntl();
	}
	/**
	 * \@docs-private
	 */
	var MAT_PAGINATOR_INTL_PROVIDER = {
	    // If there is already an MatPaginatorIntl available, use that. Otherwise, provide a new one.
	    provide: MatPaginatorIntl,
	    deps: [[new _angular_core.Optional(), new _angular_core.SkipSelf(), MatPaginatorIntl]],
	    useFactory: MAT_PAGINATOR_INTL_PROVIDER_FACTORY
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * The default page size if there is no page size and there are no provided page size options.
	 */
	var DEFAULT_PAGE_SIZE = 50;
	/**
	 * Change event object that is emitted when the user selects a
	 * different page size or navigates to another page.
	 */
	var PageEvent = /** @class */ (function () {
	    function PageEvent() {
	    }
	    return PageEvent;
	}());
	/**
	 * Component to provide navigation between paged information. Displays the size of the current
	 * page, user-selectable options to change that size, what items are being shown, and
	 * navigational button to go to the previous or next page.
	 */
	var MatPaginator = /** @class */ (function () {
	    function MatPaginator(_intl, _changeDetectorRef) {
	        var _this = this;
	        this._intl = _intl;
	        this._changeDetectorRef = _changeDetectorRef;
	        this._pageIndex = 0;
	        this._length = 0;
	        this._pageSizeOptions = [];
	        this._hidePageSize = false;
	        this._showFirstLastButtons = false;
	        /**
	         * Event emitted when the paginator changes the page size or page index.
	         */
	        this.page = new _angular_core.EventEmitter();
	        this._intlChanges = _intl.changes.subscribe(function () { return _this._changeDetectorRef.markForCheck(); });
	    }
	    Object.defineProperty(MatPaginator.prototype, "pageIndex", {
	        get: /**
	         * The zero-based page index of the displayed list of items. Defaulted to 0.
	         * @return {?}
	         */
	        function () { return this._pageIndex; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._pageIndex = _angular_cdk_coercion.coerceNumberProperty(value);
	            this._changeDetectorRef.markForCheck();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatPaginator.prototype, "length", {
	        get: /**
	         * The length of the total number of items that are being paginated. Defaulted to 0.
	         * @return {?}
	         */
	        function () { return this._length; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._length = _angular_cdk_coercion.coerceNumberProperty(value);
	            this._changeDetectorRef.markForCheck();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatPaginator.prototype, "pageSize", {
	        get: /**
	         * Number of items to display on a page. By default set to 50.
	         * @return {?}
	         */
	        function () { return this._pageSize; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._pageSize = _angular_cdk_coercion.coerceNumberProperty(value);
	            this._updateDisplayedPageSizeOptions();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatPaginator.prototype, "pageSizeOptions", {
	        get: /**
	         * The set of provided page size options to display to the user.
	         * @return {?}
	         */
	        function () { return this._pageSizeOptions; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._pageSizeOptions = (value || []).map(function (p) { return _angular_cdk_coercion.coerceNumberProperty(p); });
	            this._updateDisplayedPageSizeOptions();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatPaginator.prototype, "hidePageSize", {
	        get: /**
	         * Whether to hide the page size selection UI from the user.
	         * @return {?}
	         */
	        function () { return this._hidePageSize; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._hidePageSize = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatPaginator.prototype, "showFirstLastButtons", {
	        get: /**
	         * Whether to show the first/last buttons UI to the user.
	         * @return {?}
	         */
	        function () { return this._showFirstLastButtons; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._showFirstLastButtons = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatPaginator.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        this._initialized = true;
	        this._updateDisplayedPageSizeOptions();
	    };
	    /**
	     * @return {?}
	     */
	    MatPaginator.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._intlChanges.unsubscribe();
	    };
	    /** Advances to the next page if it exists. */
	    /**
	     * Advances to the next page if it exists.
	     * @return {?}
	     */
	    MatPaginator.prototype.nextPage = /**
	     * Advances to the next page if it exists.
	     * @return {?}
	     */
	    function () {
	        if (!this.hasNextPage()) {
	            return;
	        }
	        this.pageIndex++;
	        this._emitPageEvent();
	    };
	    /** Move back to the previous page if it exists. */
	    /**
	     * Move back to the previous page if it exists.
	     * @return {?}
	     */
	    MatPaginator.prototype.previousPage = /**
	     * Move back to the previous page if it exists.
	     * @return {?}
	     */
	    function () {
	        if (!this.hasPreviousPage()) {
	            return;
	        }
	        this.pageIndex--;
	        this._emitPageEvent();
	    };
	    /** Move to the first page if not already there. */
	    /**
	     * Move to the first page if not already there.
	     * @return {?}
	     */
	    MatPaginator.prototype.firstPage = /**
	     * Move to the first page if not already there.
	     * @return {?}
	     */
	    function () {
	        // hasPreviousPage being false implies at the start
	        if (!this.hasPreviousPage()) {
	            return;
	        }
	        this.pageIndex = 0;
	        this._emitPageEvent();
	    };
	    /** Move to the last page if not already there. */
	    /**
	     * Move to the last page if not already there.
	     * @return {?}
	     */
	    MatPaginator.prototype.lastPage = /**
	     * Move to the last page if not already there.
	     * @return {?}
	     */
	    function () {
	        // hasNextPage being false implies at the end
	        if (!this.hasNextPage()) {
	            return;
	        }
	        this.pageIndex = this.getNumberOfPages();
	        this._emitPageEvent();
	    };
	    /** Whether there is a previous page. */
	    /**
	     * Whether there is a previous page.
	     * @return {?}
	     */
	    MatPaginator.prototype.hasPreviousPage = /**
	     * Whether there is a previous page.
	     * @return {?}
	     */
	    function () {
	        return this.pageIndex >= 1 && this.pageSize != 0;
	    };
	    /** Whether there is a next page. */
	    /**
	     * Whether there is a next page.
	     * @return {?}
	     */
	    MatPaginator.prototype.hasNextPage = /**
	     * Whether there is a next page.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ numberOfPages = this.getNumberOfPages();
	        return this.pageIndex < numberOfPages && this.pageSize != 0;
	    };
	    /** Calculate the number of pages */
	    /**
	     * Calculate the number of pages
	     * @return {?}
	     */
	    MatPaginator.prototype.getNumberOfPages = /**
	     * Calculate the number of pages
	     * @return {?}
	     */
	    function () {
	        return Math.ceil(this.length / this.pageSize) - 1;
	    };
	    /**
	     * Changes the page size so that the first item displayed on the page will still be
	     * displayed using the new page size.
	     *
	     * For example, if the page size is 10 and on the second page (items indexed 10-19) then
	     * switching so that the page size is 5 will set the third page as the current page so
	     * that the 10th item will still be displayed.
	     */
	    /**
	     * Changes the page size so that the first item displayed on the page will still be
	     * displayed using the new page size.
	     *
	     * For example, if the page size is 10 and on the second page (items indexed 10-19) then
	     * switching so that the page size is 5 will set the third page as the current page so
	     * that the 10th item will still be displayed.
	     * @param {?} pageSize
	     * @return {?}
	     */
	    MatPaginator.prototype._changePageSize = /**
	     * Changes the page size so that the first item displayed on the page will still be
	     * displayed using the new page size.
	     *
	     * For example, if the page size is 10 and on the second page (items indexed 10-19) then
	     * switching so that the page size is 5 will set the third page as the current page so
	     * that the 10th item will still be displayed.
	     * @param {?} pageSize
	     * @return {?}
	     */
	    function (pageSize) {
	        // Current page needs to be updated to reflect the new page size. Navigate to the page
	        // containing the previous page's first item.
	        var /** @type {?} */ startIndex = this.pageIndex * this.pageSize;
	        this.pageIndex = Math.floor(startIndex / pageSize) || 0;
	        this.pageSize = pageSize;
	        this._emitPageEvent();
	    };
	    /**
	     * Updates the list of page size options to display to the user. Includes making sure that
	     * the page size is an option and that the list is sorted.
	     * @return {?}
	     */
	    MatPaginator.prototype._updateDisplayedPageSizeOptions = /**
	     * Updates the list of page size options to display to the user. Includes making sure that
	     * the page size is an option and that the list is sorted.
	     * @return {?}
	     */
	    function () {
	        if (!this._initialized) {
	            return;
	        }
	        // If no page size is provided, use the first page size option or the default page size.
	        if (!this.pageSize) {
	            this._pageSize = this.pageSizeOptions.length != 0 ?
	                this.pageSizeOptions[0] :
	                DEFAULT_PAGE_SIZE;
	        }
	        this._displayedPageSizeOptions = this.pageSizeOptions.slice();
	        if (this._displayedPageSizeOptions.indexOf(this.pageSize) == -1) {
	            this._displayedPageSizeOptions.push(this.pageSize);
	        }
	        // Sort the numbers using a number-specific sort function.
	        this._displayedPageSizeOptions.sort(function (a, b) { return a - b; });
	        this._changeDetectorRef.markForCheck();
	    };
	    /**
	     * Emits an event notifying that a change of the paginator's properties has been triggered.
	     * @return {?}
	     */
	    MatPaginator.prototype._emitPageEvent = /**
	     * Emits an event notifying that a change of the paginator's properties has been triggered.
	     * @return {?}
	     */
	    function () {
	        this.page.emit({
	            pageIndex: this.pageIndex,
	            pageSize: this.pageSize,
	            length: this.length
	        });
	    };
	    MatPaginator.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-paginator',
	                    exportAs: 'matPaginator',
	                    template: "<div class=\"mat-paginator-container\"><div class=\"mat-paginator-page-size\" *ngIf=\"!hidePageSize\"><div class=\"mat-paginator-page-size-label\">{{_intl.itemsPerPageLabel}}</div><mat-form-field *ngIf=\"_displayedPageSizeOptions.length > 1\" class=\"mat-paginator-page-size-select\"><mat-select [value]=\"pageSize\" [aria-label]=\"_intl.itemsPerPageLabel\" (change)=\"_changePageSize($event.value)\"><mat-option *ngFor=\"let pageSizeOption of _displayedPageSizeOptions\" [value]=\"pageSizeOption\">{{pageSizeOption}}</mat-option></mat-select></mat-form-field><div *ngIf=\"_displayedPageSizeOptions.length <= 1\">{{pageSize}}</div></div><div class=\"mat-paginator-range-actions\"><div class=\"mat-paginator-range-label\">{{_intl.getRangeLabel(pageIndex, pageSize, length)}}</div><button mat-icon-button type=\"button\" class=\"mat-paginator-navigation-first\" (click)=\"firstPage()\" [attr.aria-label]=\"_intl.firstPageLabel\" [matTooltip]=\"_intl.firstPageLabel\" [matTooltipPosition]=\"'above'\" [disabled]=\"!hasPreviousPage()\" *ngIf=\"showFirstLastButtons\"><svg class=\"mat-paginator-icon\" viewBox=\"0 0 24 24\" focusable=\"false\"><path d=\"M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z\"/></svg></button> <button mat-icon-button type=\"button\" class=\"mat-paginator-navigation-previous\" (click)=\"previousPage()\" [attr.aria-label]=\"_intl.previousPageLabel\" [matTooltip]=\"_intl.previousPageLabel\" [matTooltipPosition]=\"'above'\" [disabled]=\"!hasPreviousPage()\"><svg class=\"mat-paginator-icon\" viewBox=\"0 0 24 24\" focusable=\"false\"><path d=\"M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z\"/></svg></button> <button mat-icon-button type=\"button\" class=\"mat-paginator-navigation-next\" (click)=\"nextPage()\" [attr.aria-label]=\"_intl.nextPageLabel\" [matTooltip]=\"_intl.nextPageLabel\" [matTooltipPosition]=\"'above'\" [disabled]=\"!hasNextPage()\"><svg class=\"mat-paginator-icon\" viewBox=\"0 0 24 24\" focusable=\"false\"><path d=\"M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z\"/></svg></button> <button mat-icon-button type=\"button\" class=\"mat-paginator-navigation-last\" (click)=\"lastPage()\" [attr.aria-label]=\"_intl.lastPageLabel\" [matTooltip]=\"_intl.lastPageLabel\" [matTooltipPosition]=\"'above'\" [disabled]=\"!hasNextPage()\" *ngIf=\"showFirstLastButtons\"><svg class=\"mat-paginator-icon\" viewBox=\"0 0 24 24\" focusable=\"false\"><path d=\"M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z\"/></svg></button></div></div>",
	                    styles: [".mat-paginator{display:block}.mat-paginator-container{display:flex;align-items:center;justify-content:flex-end;min-height:56px;padding:0 8px;flex-wrap:wrap-reverse}.mat-paginator-page-size{display:flex;align-items:baseline;margin-right:8px}.mat-paginator-page-size-label{margin:0 4px}.mat-paginator-page-size-select{margin:6px 4px 0 4px;width:56px}.mat-paginator-range-label{margin:0 32px 0 24px}.mat-paginator-range-actions{display:flex;align-items:center;min-height:48px}.mat-paginator-icon{width:28px;fill:currentColor}[dir=rtl] .mat-paginator-icon{transform:rotate(180deg)}"],
	                    host: {
	                        'class': 'mat-paginator',
	                    },
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                },] },
	    ];
	    /** @nocollapse */
	    MatPaginator.ctorParameters = function () { return [
	        { type: MatPaginatorIntl, },
	        { type: _angular_core.ChangeDetectorRef, },
	    ]; };
	    MatPaginator.propDecorators = {
	        "pageIndex": [{ type: _angular_core.Input },],
	        "length": [{ type: _angular_core.Input },],
	        "pageSize": [{ type: _angular_core.Input },],
	        "pageSizeOptions": [{ type: _angular_core.Input },],
	        "hidePageSize": [{ type: _angular_core.Input },],
	        "showFirstLastButtons": [{ type: _angular_core.Input },],
	        "page": [{ type: _angular_core.Output },],
	    };
	    return MatPaginator;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatPaginatorModule = /** @class */ (function () {
	    function MatPaginatorModule() {
	    }
	    MatPaginatorModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [
	                        _angular_common.CommonModule,
	                        MatButtonModule,
	                        MatSelectModule,
	                        MatTooltipModule,
	                    ],
	                    exports: [MatPaginator],
	                    declarations: [MatPaginator],
	                    providers: [MAT_PAGINATOR_INTL_PROVIDER],
	                },] },
	    ];
	    /** @nocollapse */
	    MatPaginatorModule.ctorParameters = function () { return []; };
	    return MatPaginatorModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * \@docs-private
	 */
	var MatProgressBarBase = /** @class */ (function () {
	    function MatProgressBarBase(_elementRef) {
	        this._elementRef = _elementRef;
	    }
	    return MatProgressBarBase;
	}());
	var _MatProgressBarMixinBase = mixinColor(MatProgressBarBase, 'primary');
	/**
	 * Counter used to generate unique IDs for progress bars.
	 */
	var progressbarId = 0;
	/**
	 * `<mat-progress-bar>` component.
	 */
	var MatProgressBar = /** @class */ (function (_super) {
	    __extends(MatProgressBar, _super);
	    function MatProgressBar(_elementRef) {
	        var _this = _super.call(this, _elementRef) || this;
	        _this._elementRef = _elementRef;
	        _this._value = 0;
	        _this._bufferValue = 0;
	        /**
	         * Mode of the progress bar.
	         *
	         * Input must be one of these values: determinate, indeterminate, buffer, query, defaults to
	         * 'determinate'.
	         * Mirrored to mode attribute.
	         */
	        _this.mode = 'determinate';
	        /**
	         * The id of the progress bar.
	         */
	        _this.progressbarId = "mat-progress-bar-" + progressbarId++;
	        return _this;
	    }
	    Object.defineProperty(MatProgressBar.prototype, "value", {
	        get: /**
	         * Value of the progress bar. Defaults to zero. Mirrored to aria-valuenow.
	         * @return {?}
	         */
	        function () { return this._value; },
	        set: /**
	         * @param {?} v
	         * @return {?}
	         */
	        function (v) { this._value = clamp(v || 0); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatProgressBar.prototype, "bufferValue", {
	        get: /**
	         * Buffer value of the progress bar. Defaults to zero.
	         * @return {?}
	         */
	        function () { return this._bufferValue; },
	        set: /**
	         * @param {?} v
	         * @return {?}
	         */
	        function (v) { this._bufferValue = clamp(v || 0); },
	        enumerable: true,
	        configurable: true
	    });
	    /** Gets the current transform value for the progress bar's primary indicator. */
	    /**
	     * Gets the current transform value for the progress bar's primary indicator.
	     * @return {?}
	     */
	    MatProgressBar.prototype._primaryTransform = /**
	     * Gets the current transform value for the progress bar's primary indicator.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ scale = this.value / 100;
	        return { transform: "scaleX(" + scale + ")" };
	    };
	    /**
	     * Gets the current transform value for the progress bar's buffer indicator. Only used if the
	     * progress mode is set to buffer, otherwise returns an undefined, causing no transformation.
	     */
	    /**
	     * Gets the current transform value for the progress bar's buffer indicator. Only used if the
	     * progress mode is set to buffer, otherwise returns an undefined, causing no transformation.
	     * @return {?}
	     */
	    MatProgressBar.prototype._bufferTransform = /**
	     * Gets the current transform value for the progress bar's buffer indicator. Only used if the
	     * progress mode is set to buffer, otherwise returns an undefined, causing no transformation.
	     * @return {?}
	     */
	    function () {
	        if (this.mode === 'buffer') {
	            var /** @type {?} */ scale = this.bufferValue / 100;
	            return { transform: "scaleX(" + scale + ")" };
	        }
	    };
	    MatProgressBar.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-progress-bar',
	                    exportAs: 'matProgressBar',
	                    host: {
	                        'role': 'progressbar',
	                        'aria-valuemin': '0',
	                        'aria-valuemax': '100',
	                        '[attr.aria-valuenow]': 'value',
	                        '[attr.mode]': 'mode',
	                        'class': 'mat-progress-bar',
	                    },
	                    inputs: ['color'],
	                    template: "<svg width=\"100%\" height=\"5\" focusable=\"false\" class=\"mat-progress-bar-background mat-progress-bar-element\"><defs><pattern [id]=\"progressbarId\" x=\"5\" y=\"0\" width=\"10\" height=\"5\" patternUnits=\"userSpaceOnUse\"><circle cx=\"2.5\" cy=\"2.5\" r=\"2.5\"/></pattern></defs><rect [attr.fill]=\"'url(#' + progressbarId + ')'\" width=\"100%\" height=\"100%\"/></svg><div class=\"mat-progress-bar-buffer mat-progress-bar-element\" [ngStyle]=\"_bufferTransform()\"></div><div class=\"mat-progress-bar-primary mat-progress-bar-fill mat-progress-bar-element\" [ngStyle]=\"_primaryTransform()\"></div><div class=\"mat-progress-bar-secondary mat-progress-bar-fill mat-progress-bar-element\"></div>",
	                    styles: [".mat-progress-bar{display:block;height:5px;overflow:hidden;position:relative;transition:opacity 250ms linear;width:100%}.mat-progress-bar .mat-progress-bar-element,.mat-progress-bar .mat-progress-bar-fill::after{height:100%;position:absolute;width:100%}.mat-progress-bar .mat-progress-bar-background{width:calc(100% + 10px)}.mat-progress-bar .mat-progress-bar-buffer{transform-origin:top left;transition:transform 250ms ease}.mat-progress-bar .mat-progress-bar-secondary{display:none}.mat-progress-bar .mat-progress-bar-fill{animation:none;transform-origin:top left;transition:transform 250ms ease}.mat-progress-bar .mat-progress-bar-fill::after{animation:none;content:'';display:inline-block;left:0}.mat-progress-bar[dir=rtl],[dir=rtl] .mat-progress-bar{transform:rotateY(180deg)}.mat-progress-bar[mode=query]{transform:rotateZ(180deg)}.mat-progress-bar[mode=query][dir=rtl],[dir=rtl] .mat-progress-bar[mode=query]{transform:rotateZ(180deg) rotateY(180deg)}.mat-progress-bar[mode=indeterminate] .mat-progress-bar-fill,.mat-progress-bar[mode=query] .mat-progress-bar-fill{transition:none}.mat-progress-bar[mode=indeterminate] .mat-progress-bar-primary,.mat-progress-bar[mode=query] .mat-progress-bar-primary{-webkit-backface-visibility:hidden;backface-visibility:hidden;animation:mat-progress-bar-primary-indeterminate-translate 2s infinite linear;left:-145.166611%}.mat-progress-bar[mode=indeterminate] .mat-progress-bar-primary.mat-progress-bar-fill::after,.mat-progress-bar[mode=query] .mat-progress-bar-primary.mat-progress-bar-fill::after{-webkit-backface-visibility:hidden;backface-visibility:hidden;animation:mat-progress-bar-primary-indeterminate-scale 2s infinite linear}.mat-progress-bar[mode=indeterminate] .mat-progress-bar-secondary,.mat-progress-bar[mode=query] .mat-progress-bar-secondary{-webkit-backface-visibility:hidden;backface-visibility:hidden;animation:mat-progress-bar-secondary-indeterminate-translate 2s infinite linear;left:-54.888891%;display:block}.mat-progress-bar[mode=indeterminate] .mat-progress-bar-secondary.mat-progress-bar-fill::after,.mat-progress-bar[mode=query] .mat-progress-bar-secondary.mat-progress-bar-fill::after{-webkit-backface-visibility:hidden;backface-visibility:hidden;animation:mat-progress-bar-secondary-indeterminate-scale 2s infinite linear}.mat-progress-bar[mode=buffer] .mat-progress-bar-background{-webkit-backface-visibility:hidden;backface-visibility:hidden;animation:mat-progress-bar-background-scroll 250ms infinite linear}@keyframes mat-progress-bar-primary-indeterminate-translate{0%{transform:translateX(0)}20%{animation-timing-function:cubic-bezier(.5,0,.70173,.49582);transform:translateX(0)}59.15%{animation-timing-function:cubic-bezier(.30244,.38135,.55,.95635);transform:translateX(83.67142%)}100%{transform:translateX(200.61106%)}}@keyframes mat-progress-bar-primary-indeterminate-scale{0%{transform:scaleX(.08)}36.65%{animation-timing-function:cubic-bezier(.33473,.12482,.78584,1);transform:scaleX(.08)}69.15%{animation-timing-function:cubic-bezier(.06,.11,.6,1);transform:scaleX(.66148)}100%{transform:scaleX(.08)}}@keyframes mat-progress-bar-secondary-indeterminate-translate{0%{animation-timing-function:cubic-bezier(.15,0,.51506,.40969);transform:translateX(0)}25%{animation-timing-function:cubic-bezier(.31033,.28406,.8,.73371);transform:translateX(37.65191%)}48.35%{animation-timing-function:cubic-bezier(.4,.62704,.6,.90203);transform:translateX(84.38617%)}100%{transform:translateX(160.27778%)}}@keyframes mat-progress-bar-secondary-indeterminate-scale{0%{animation-timing-function:cubic-bezier(.15,0,.51506,.40969);transform:scaleX(.08)}19.15%{animation-timing-function:cubic-bezier(.31033,.28406,.8,.73371);transform:scaleX(.4571)}44.15%{animation-timing-function:cubic-bezier(.4,.62704,.6,.90203);transform:scaleX(.72796)}100%{transform:scaleX(.08)}}@keyframes mat-progress-bar-background-scroll{to{transform:translateX(-10px)}}"],
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                },] },
	    ];
	    /** @nocollapse */
	    MatProgressBar.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	    ]; };
	    MatProgressBar.propDecorators = {
	        "value": [{ type: _angular_core.Input },],
	        "bufferValue": [{ type: _angular_core.Input },],
	        "mode": [{ type: _angular_core.Input },],
	    };
	    return MatProgressBar;
	}(_MatProgressBarMixinBase));
	/**
	 * Clamps a value to be between two numbers, by default 0 and 100.
	 * @param {?} v
	 * @param {?=} min
	 * @param {?=} max
	 * @return {?}
	 */
	function clamp(v, min, max) {
	    if (min === void 0) { min = 0; }
	    if (max === void 0) { max = 100; }
	    return Math.max(min, Math.min(max, v));
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatProgressBarModule = /** @class */ (function () {
	    function MatProgressBarModule() {
	    }
	    MatProgressBarModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [_angular_common.CommonModule, MatCommonModule],
	                    exports: [MatProgressBar, MatCommonModule],
	                    declarations: [MatProgressBar],
	                },] },
	    ];
	    /** @nocollapse */
	    MatProgressBarModule.ctorParameters = function () { return []; };
	    return MatProgressBarModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Base reference size of the spinner.
	 * \@docs-private
	 */
	var BASE_SIZE = 100;
	/**
	 * Base reference stroke width of the spinner.
	 * \@docs-private
	 */
	var BASE_STROKE_WIDTH = 10;
	/**
	 * \@docs-private
	 */
	var MatProgressSpinnerBase = /** @class */ (function () {
	    function MatProgressSpinnerBase(_elementRef) {
	        this._elementRef = _elementRef;
	    }
	    return MatProgressSpinnerBase;
	}());
	var _MatProgressSpinnerMixinBase = mixinColor(MatProgressSpinnerBase, 'primary');
	// .0001 percentage difference is necessary in order to avoid unwanted animation frames
	// for example because the animation duration is 4 seconds, .1% accounts to 4ms
	// which are enough to see the flicker described in
	// https://github.com/angular/material2/issues/8984
	var INDETERMINATE_ANIMATION_TEMPLATE = "\n @keyframes mat-progress-spinner-stroke-rotate-DIAMETER {\n    0%      { stroke-dashoffset: START_VALUE;  transform: rotate(0); }\n    12.5%   { stroke-dashoffset: END_VALUE;    transform: rotate(0); }\n    12.5001%  { stroke-dashoffset: END_VALUE;    transform: rotateX(180deg) rotate(72.5deg); }\n    25%     { stroke-dashoffset: START_VALUE;  transform: rotateX(180deg) rotate(72.5deg); }\n\n    25.0001%   { stroke-dashoffset: START_VALUE;  transform: rotate(270deg); }\n    37.5%   { stroke-dashoffset: END_VALUE;    transform: rotate(270deg); }\n    37.5001%  { stroke-dashoffset: END_VALUE;    transform: rotateX(180deg) rotate(161.5deg); }\n    50%     { stroke-dashoffset: START_VALUE;  transform: rotateX(180deg) rotate(161.5deg); }\n\n    50.0001%  { stroke-dashoffset: START_VALUE;  transform: rotate(180deg); }\n    62.5%   { stroke-dashoffset: END_VALUE;    transform: rotate(180deg); }\n    62.5001%  { stroke-dashoffset: END_VALUE;    transform: rotateX(180deg) rotate(251.5deg); }\n    75%     { stroke-dashoffset: START_VALUE;  transform: rotateX(180deg) rotate(251.5deg); }\n\n    75.0001%  { stroke-dashoffset: START_VALUE;  transform: rotate(90deg); }\n    87.5%   { stroke-dashoffset: END_VALUE;    transform: rotate(90deg); }\n    87.5001%  { stroke-dashoffset: END_VALUE;    transform: rotateX(180deg) rotate(341.5deg); }\n    100%    { stroke-dashoffset: START_VALUE;  transform: rotateX(180deg) rotate(341.5deg); }\n  }\n";
	/**
	 * `<mat-progress-spinner>` component.
	 */
	var MatProgressSpinner = /** @class */ (function (_super) {
	    __extends(MatProgressSpinner, _super);
	    function MatProgressSpinner(_elementRef, platform, _document) {
	        var _this = _super.call(this, _elementRef) || this;
	        _this._elementRef = _elementRef;
	        _this._document = _document;
	        _this._value = 0;
	        _this._fallbackAnimation = false;
	        /**
	         * The width and height of the host element. Will grow with stroke width.
	         */
	        _this._elementSize = BASE_SIZE;
	        _this._diameter = BASE_SIZE;
	        /**
	         * Mode of the progress circle
	         */
	        _this.mode = 'determinate';
	        _this._fallbackAnimation = platform.EDGE || platform.TRIDENT;
	        // On IE and Edge, we can't animate the `stroke-dashoffset`
	        // reliably so we fall back to a non-spec animation.
	        var /** @type {?} */ animationClass = "mat-progress-spinner-indeterminate" + (_this._fallbackAnimation ? '-fallback' : '') + "-animation";
	        _elementRef.nativeElement.classList.add(animationClass);
	        return _this;
	    }
	    Object.defineProperty(MatProgressSpinner.prototype, "diameter", {
	        get: /**
	         * The diameter of the progress spinner (will set width and height of svg).
	         * @return {?}
	         */
	        function () { return this._diameter; },
	        set: /**
	         * @param {?} size
	         * @return {?}
	         */
	        function (size) {
	            this._diameter = _angular_cdk_coercion.coerceNumberProperty(size);
	            if (!this._fallbackAnimation && !MatProgressSpinner.diameters.has(this._diameter)) {
	                this._attachStyleNode();
	            }
	            this._updateElementSize();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatProgressSpinner.prototype, "strokeWidth", {
	        get: /**
	         * Stroke width of the progress spinner.
	         * @return {?}
	         */
	        function () {
	            return this._strokeWidth || this.diameter / 10;
	        },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._strokeWidth = _angular_cdk_coercion.coerceNumberProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatProgressSpinner.prototype, "value", {
	        get: /**
	         * Value of the progress circle.
	         * @return {?}
	         */
	        function () {
	            return this.mode === 'determinate' ? this._value : 0;
	        },
	        set: /**
	         * @param {?} newValue
	         * @return {?}
	         */
	        function (newValue) {
	            this._value = Math.max(0, Math.min(100, _angular_cdk_coercion.coerceNumberProperty(newValue)));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    MatProgressSpinner.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        if (changes["strokeWidth"] || changes["diameter"]) {
	            this._updateElementSize();
	        }
	    };
	    Object.defineProperty(MatProgressSpinner.prototype, "_circleRadius", {
	        /** The radius of the spinner, adjusted for stroke width. */
	        get: /**
	         * The radius of the spinner, adjusted for stroke width.
	         * @return {?}
	         */
	        function () {
	            return (this.diameter - BASE_STROKE_WIDTH) / 2;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatProgressSpinner.prototype, "_viewBox", {
	        /** The view box of the spinner's svg element. */
	        get: /**
	         * The view box of the spinner's svg element.
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ viewBox = this._circleRadius * 2 + this.strokeWidth;
	            return "0 0 " + viewBox + " " + viewBox;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatProgressSpinner.prototype, "_strokeCircumference", {
	        /** The stroke circumference of the svg circle. */
	        get: /**
	         * The stroke circumference of the svg circle.
	         * @return {?}
	         */
	        function () {
	            return 2 * Math.PI * this._circleRadius;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatProgressSpinner.prototype, "_strokeDashOffset", {
	        /** The dash offset of the svg circle. */
	        get: /**
	         * The dash offset of the svg circle.
	         * @return {?}
	         */
	        function () {
	            if (this.mode === 'determinate') {
	                return this._strokeCircumference * (100 - this._value) / 100;
	            }
	            // In fallback mode set the circle to 80% and rotate it with CSS.
	            if (this._fallbackAnimation && this.mode === 'indeterminate') {
	                return this._strokeCircumference * 0.2;
	            }
	            return null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatProgressSpinner.prototype, "_circleStrokeWidth", {
	        /** Stroke width of the circle in percent. */
	        get: /**
	         * Stroke width of the circle in percent.
	         * @return {?}
	         */
	        function () {
	            return this.strokeWidth / this._elementSize * 100;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Dynamically generates a style tag containing the correct animation for this diameter.
	     * @return {?}
	     */
	    MatProgressSpinner.prototype._attachStyleNode = /**
	     * Dynamically generates a style tag containing the correct animation for this diameter.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ styleTag = MatProgressSpinner.styleTag;
	        if (!styleTag) {
	            styleTag = this._document.createElement('style');
	            this._document.head.appendChild(styleTag);
	            MatProgressSpinner.styleTag = styleTag;
	        }
	        if (styleTag && styleTag.sheet) {
	            (/** @type {?} */ (styleTag.sheet)).insertRule(this._getAnimationText(), 0);
	        }
	        MatProgressSpinner.diameters.add(this.diameter);
	    };
	    /**
	     * Generates animation styles adjusted for the spinner's diameter.
	     * @return {?}
	     */
	    MatProgressSpinner.prototype._getAnimationText = /**
	     * Generates animation styles adjusted for the spinner's diameter.
	     * @return {?}
	     */
	    function () {
	        return INDETERMINATE_ANIMATION_TEMPLATE
	            .replace(/START_VALUE/g, "" + 0.95 * this._strokeCircumference)
	            .replace(/END_VALUE/g, "" + 0.2 * this._strokeCircumference)
	            .replace(/DIAMETER/g, "" + this.diameter);
	    };
	    /**
	     * Updates the spinner element size based on its diameter.
	     * @return {?}
	     */
	    MatProgressSpinner.prototype._updateElementSize = /**
	     * Updates the spinner element size based on its diameter.
	     * @return {?}
	     */
	    function () {
	        this._elementSize = this._diameter + Math.max(this.strokeWidth - BASE_STROKE_WIDTH, 0);
	    };
	    /**
	     * Tracks diameters of existing instances to de-dupe generated styles (default d = 100)
	     */
	    MatProgressSpinner.diameters = new Set([BASE_SIZE]);
	    /**
	     * Used for storing all of the generated keyframe animations.
	     * \@dynamic
	     */
	    MatProgressSpinner.styleTag = null;
	    MatProgressSpinner.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-progress-spinner',
	                    exportAs: 'matProgressSpinner',
	                    host: {
	                        'role': 'progressbar',
	                        'class': 'mat-progress-spinner',
	                        '[style.width.px]': '_elementSize',
	                        '[style.height.px]': '_elementSize',
	                        '[attr.aria-valuemin]': 'mode === "determinate" ? 0 : null',
	                        '[attr.aria-valuemax]': 'mode === "determinate" ? 100 : null',
	                        '[attr.aria-valuenow]': 'value',
	                        '[attr.mode]': 'mode',
	                    },
	                    inputs: ['color'],
	                    template: "<svg [style.width.px]=\"_elementSize\" [style.height.px]=\"_elementSize\" [attr.viewBox]=\"_viewBox\" preserveAspectRatio=\"xMidYMid meet\" focusable=\"false\"><circle cx=\"50%\" cy=\"50%\" [attr.r]=\"_circleRadius\" [style.animation-name]=\"'mat-progress-spinner-stroke-rotate-' + diameter\" [style.stroke-dashoffset.px]=\"_strokeDashOffset\" [style.stroke-dasharray.px]=\"_strokeCircumference\" [style.stroke-width.%]=\"_circleStrokeWidth\"></circle></svg>",
	                    styles: [".mat-progress-spinner{display:block;position:relative}.mat-progress-spinner svg{position:absolute;transform:rotate(-90deg);top:0;left:0;transform-origin:center;overflow:visible}.mat-progress-spinner circle{fill:transparent;transform-origin:center;transition:stroke-dashoffset 225ms linear}.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate]{animation:mat-progress-spinner-linear-rotate 2s linear infinite}.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate] circle{transition-property:stroke;animation-duration:4s;animation-timing-function:cubic-bezier(.35,0,.25,1);animation-iteration-count:infinite}.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate]{animation:mat-progress-spinner-stroke-rotate-fallback 10s cubic-bezier(.87,.03,.33,1) infinite}.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate] circle{transition-property:stroke}@keyframes mat-progress-spinner-linear-rotate{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes mat-progress-spinner-stroke-rotate-100{0%{stroke-dashoffset:268.60617px;transform:rotate(0)}12.5%{stroke-dashoffset:56.54867px;transform:rotate(0)}12.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(72.5deg)}25%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(72.5deg)}25.0001%{stroke-dashoffset:268.60617px;transform:rotate(270deg)}37.5%{stroke-dashoffset:56.54867px;transform:rotate(270deg)}37.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(161.5deg)}50%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(161.5deg)}50.0001%{stroke-dashoffset:268.60617px;transform:rotate(180deg)}62.5%{stroke-dashoffset:56.54867px;transform:rotate(180deg)}62.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(251.5deg)}75%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(251.5deg)}75.0001%{stroke-dashoffset:268.60617px;transform:rotate(90deg)}87.5%{stroke-dashoffset:56.54867px;transform:rotate(90deg)}87.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(341.5deg)}100%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(341.5deg)}}@keyframes mat-progress-spinner-stroke-rotate-fallback{0%{transform:rotate(0)}25%{transform:rotate(1170deg)}50%{transform:rotate(2340deg)}75%{transform:rotate(3510deg)}100%{transform:rotate(4680deg)}}"],
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                },] },
	    ];
	    /** @nocollapse */
	    MatProgressSpinner.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_platform.Platform, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    MatProgressSpinner.propDecorators = {
	        "diameter": [{ type: _angular_core.Input },],
	        "strokeWidth": [{ type: _angular_core.Input },],
	        "mode": [{ type: _angular_core.Input },],
	        "value": [{ type: _angular_core.Input },],
	    };
	    return MatProgressSpinner;
	}(_MatProgressSpinnerMixinBase));
	/**
	 * `<mat-spinner>` component.
	 *
	 * This is a component definition to be used as a convenience reference to create an
	 * indeterminate `<mat-progress-spinner>` instance.
	 */
	var MatSpinner = /** @class */ (function (_super) {
	    __extends(MatSpinner, _super);
	    function MatSpinner(elementRef, platform, document) {
	        var _this = _super.call(this, elementRef, platform, document) || this;
	        _this.mode = 'indeterminate';
	        return _this;
	    }
	    MatSpinner.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-spinner',
	                    host: {
	                        'role': 'progressbar',
	                        'mode': 'indeterminate',
	                        'class': 'mat-spinner mat-progress-spinner',
	                        '[style.width.px]': '_elementSize',
	                        '[style.height.px]': '_elementSize',
	                    },
	                    inputs: ['color'],
	                    template: "<svg [style.width.px]=\"_elementSize\" [style.height.px]=\"_elementSize\" [attr.viewBox]=\"_viewBox\" preserveAspectRatio=\"xMidYMid meet\" focusable=\"false\"><circle cx=\"50%\" cy=\"50%\" [attr.r]=\"_circleRadius\" [style.animation-name]=\"'mat-progress-spinner-stroke-rotate-' + diameter\" [style.stroke-dashoffset.px]=\"_strokeDashOffset\" [style.stroke-dasharray.px]=\"_strokeCircumference\" [style.stroke-width.%]=\"_circleStrokeWidth\"></circle></svg>",
	                    styles: [".mat-progress-spinner{display:block;position:relative}.mat-progress-spinner svg{position:absolute;transform:rotate(-90deg);top:0;left:0;transform-origin:center;overflow:visible}.mat-progress-spinner circle{fill:transparent;transform-origin:center;transition:stroke-dashoffset 225ms linear}.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate]{animation:mat-progress-spinner-linear-rotate 2s linear infinite}.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate] circle{transition-property:stroke;animation-duration:4s;animation-timing-function:cubic-bezier(.35,0,.25,1);animation-iteration-count:infinite}.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate]{animation:mat-progress-spinner-stroke-rotate-fallback 10s cubic-bezier(.87,.03,.33,1) infinite}.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate] circle{transition-property:stroke}@keyframes mat-progress-spinner-linear-rotate{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes mat-progress-spinner-stroke-rotate-100{0%{stroke-dashoffset:268.60617px;transform:rotate(0)}12.5%{stroke-dashoffset:56.54867px;transform:rotate(0)}12.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(72.5deg)}25%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(72.5deg)}25.0001%{stroke-dashoffset:268.60617px;transform:rotate(270deg)}37.5%{stroke-dashoffset:56.54867px;transform:rotate(270deg)}37.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(161.5deg)}50%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(161.5deg)}50.0001%{stroke-dashoffset:268.60617px;transform:rotate(180deg)}62.5%{stroke-dashoffset:56.54867px;transform:rotate(180deg)}62.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(251.5deg)}75%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(251.5deg)}75.0001%{stroke-dashoffset:268.60617px;transform:rotate(90deg)}87.5%{stroke-dashoffset:56.54867px;transform:rotate(90deg)}87.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(341.5deg)}100%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(341.5deg)}}@keyframes mat-progress-spinner-stroke-rotate-fallback{0%{transform:rotate(0)}25%{transform:rotate(1170deg)}50%{transform:rotate(2340deg)}75%{transform:rotate(3510deg)}100%{transform:rotate(4680deg)}}"],
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                },] },
	    ];
	    /** @nocollapse */
	    MatSpinner.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_platform.Platform, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    return MatSpinner;
	}(MatProgressSpinner));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var MatProgressSpinnerModule = /** @class */ (function () {
	    function MatProgressSpinnerModule() {
	    }
	    MatProgressSpinnerModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [MatCommonModule, _angular_cdk_platform.PlatformModule],
	                    exports: [
	                        MatProgressSpinner,
	                        MatSpinner,
	                        MatCommonModule
	                    ],
	                    declarations: [
	                        MatProgressSpinner,
	                        MatSpinner
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    MatProgressSpinnerModule.ctorParameters = function () { return []; };
	    return MatProgressSpinnerModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	// Increasing integer for generating unique ids for radio components.
	var nextUniqueId$5 = 0;
	/**
	 * Provider Expression that allows mat-radio-group to register as a ControlValueAccessor. This
	 * allows it to support [(ngModel)] and ngControl.
	 * \@docs-private
	 */
	var MAT_RADIO_GROUP_CONTROL_VALUE_ACCESSOR = {
	    provide: _angular_forms.NG_VALUE_ACCESSOR,
	    useExisting: _angular_core.forwardRef(function () { return MatRadioGroup; }),
	    multi: true
	};
	/**
	 * Change event object emitted by MatRadio and MatRadioGroup.
	 */
	var MatRadioChange = /** @class */ (function () {
	    function MatRadioChange(source, value) {
	        this.source = source;
	        this.value = value;
	    }
	    return MatRadioChange;
	}());
	/**
	 * \@docs-private
	 */
	var MatRadioGroupBase = /** @class */ (function () {
	    function MatRadioGroupBase() {
	    }
	    return MatRadioGroupBase;
	}());
	var _MatRadioGroupMixinBase = mixinDisabled(MatRadioGroupBase);
	/**
	 * A group of radio buttons. May contain one or more `<mat-radio-button>` elements.
	 */
	var MatRadioGroup = /** @class */ (function (_super) {
	    __extends(MatRadioGroup, _super);
	    function MatRadioGroup(_changeDetector) {
	        var _this = _super.call(this) || this;
	        _this._changeDetector = _changeDetector;
	        /**
	         * Selected value for group. Should equal the value of the selected radio button if there *is*
	         * a corresponding radio button with a matching value. If there is *not* such a corresponding
	         * radio button, this value persists to be applied in case a new radio button is added with a
	         * matching value.
	         */
	        _this._value = null;
	        /**
	         * The HTML name attribute applied to radio buttons in this group.
	         */
	        _this._name = "mat-radio-group-" + nextUniqueId$5++;
	        /**
	         * The currently selected radio button. Should match value.
	         */
	        _this._selected = null;
	        /**
	         * Whether the `value` has been set to its initial value.
	         */
	        _this._isInitialized = false;
	        /**
	         * Whether the labels should appear after or before the radio-buttons. Defaults to 'after'
	         */
	        _this._labelPosition = 'after';
	        /**
	         * Whether the radio group is disabled.
	         */
	        _this._disabled = false;
	        /**
	         * Whether the radio group is required.
	         */
	        _this._required = false;
	        /**
	         * The method to be called in order to update ngModel
	         */
	        _this._controlValueAccessorChangeFn = function () { };
	        /**
	         * onTouch function registered via registerOnTouch (ControlValueAccessor).
	         * \@docs-private
	         */
	        _this.onTouched = function () { };
	        /**
	         * Event emitted when the group value changes.
	         * Change events are only emitted when the value changes due to user interaction with
	         * a radio button (the same behavior as `<input type-"radio">`).
	         */
	        _this.change = new _angular_core.EventEmitter();
	        return _this;
	    }
	    Object.defineProperty(MatRadioGroup.prototype, "name", {
	        get: /**
	         * Name of the radio button group. All radio buttons inside this group will use this name.
	         * @return {?}
	         */
	        function () { return this._name; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._name = value;
	            this._updateRadioButtonNames();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatRadioGroup.prototype, "align", {
	        get: /**
	         * Alignment of the radio-buttons relative to their labels. Can be 'before' or 'after'.
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () {
	            // align refers to the checkbox relative to the label, while labelPosition refers to the
	            // label relative to the checkbox. As such, they are inverted.
	            return this.labelPosition == 'after' ? 'start' : 'end';
	        },
	        set: /**
	         * @param {?} v
	         * @return {?}
	         */
	        function (v) {
	            this.labelPosition = (v == 'start') ? 'after' : 'before';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatRadioGroup.prototype, "labelPosition", {
	        get: /**
	         * Whether the labels should appear after or before the radio-buttons. Defaults to 'after'
	         * @return {?}
	         */
	        function () {
	            return this._labelPosition;
	        },
	        set: /**
	         * @param {?} v
	         * @return {?}
	         */
	        function (v) {
	            this._labelPosition = (v == 'before') ? 'before' : 'after';
	            this._markRadiosForCheck();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatRadioGroup.prototype, "value", {
	        get: /**
	         * Value of the radio button.
	         * @return {?}
	         */
	        function () { return this._value; },
	        set: /**
	         * @param {?} newValue
	         * @return {?}
	         */
	        function (newValue) {
	            if (this._value != newValue) {
	                // Set this before proceeding to ensure no circular loop occurs with selection.
	                this._value = newValue;
	                this._updateSelectedRadioFromValue();
	                this._checkSelectedRadioButton();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatRadioGroup.prototype._checkSelectedRadioButton = /**
	     * @return {?}
	     */
	    function () {
	        if (this._selected && !this._selected.checked) {
	            this._selected.checked = true;
	        }
	    };
	    Object.defineProperty(MatRadioGroup.prototype, "selected", {
	        get: /**
	         * Whether the radio button is selected.
	         * @return {?}
	         */
	        function () { return this._selected; },
	        set: /**
	         * @param {?} selected
	         * @return {?}
	         */
	        function (selected) {
	            this._selected = selected;
	            this.value = selected ? selected.value : null;
	            this._checkSelectedRadioButton();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatRadioGroup.prototype, "disabled", {
	        get: /**
	         * Whether the radio group is disabled
	         * @return {?}
	         */
	        function () { return this._disabled; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._disabled = _angular_cdk_coercion.coerceBooleanProperty(value);
	            this._markRadiosForCheck();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatRadioGroup.prototype, "required", {
	        get: /**
	         * Whether the radio group is required
	         * @return {?}
	         */
	        function () { return this._required; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._required = _angular_cdk_coercion.coerceBooleanProperty(value);
	            this._markRadiosForCheck();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Initialize properties once content children are available.
	     * This allows us to propagate relevant attributes to associated buttons.
	     */
	    /**
	     * Initialize properties once content children are available.
	     * This allows us to propagate relevant attributes to associated buttons.
	     * @return {?}
	     */
	    MatRadioGroup.prototype.ngAfterContentInit = /**
	     * Initialize properties once content children are available.
	     * This allows us to propagate relevant attributes to associated buttons.
	     * @return {?}
	     */
	    function () {
	        // Mark this component as initialized in AfterContentInit because the initial value can
	        // possibly be set by NgModel on MatRadioGroup, and it is possible that the OnInit of the
	        // NgModel occurs *after* the OnInit of the MatRadioGroup.
	        this._isInitialized = true;
	    };
	    /**
	     * Mark this group as being "touched" (for ngModel). Meant to be called by the contained
	     * radio buttons upon their blur.
	     */
	    /**
	     * Mark this group as being "touched" (for ngModel). Meant to be called by the contained
	     * radio buttons upon their blur.
	     * @return {?}
	     */
	    MatRadioGroup.prototype._touch = /**
	     * Mark this group as being "touched" (for ngModel). Meant to be called by the contained
	     * radio buttons upon their blur.
	     * @return {?}
	     */
	    function () {
	        if (this.onTouched) {
	            this.onTouched();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatRadioGroup.prototype._updateRadioButtonNames = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._radios) {
	            this._radios.forEach(function (radio) {
	                radio.name = _this.name;
	            });
	        }
	    };
	    /**
	     * Updates the `selected` radio button from the internal _value state.
	     * @return {?}
	     */
	    MatRadioGroup.prototype._updateSelectedRadioFromValue = /**
	     * Updates the `selected` radio button from the internal _value state.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        // If the value already matches the selected radio, do nothing.
	        var /** @type {?} */ isAlreadySelected = this._selected != null && this._selected.value == this._value;
	        if (this._radios != null && !isAlreadySelected) {
	            this._selected = null;
	            this._radios.forEach(function (radio) {
	                radio.checked = _this.value == radio.value;
	                if (radio.checked) {
	                    _this._selected = radio;
	                }
	            });
	        }
	    };
	    /** Dispatch change event with current selection and group value. */
	    /**
	     * Dispatch change event with current selection and group value.
	     * @return {?}
	     */
	    MatRadioGroup.prototype._emitChangeEvent = /**
	     * Dispatch change event with current selection and group value.
	     * @return {?}
	     */
	    function () {
	        if (this._isInitialized) {
	            this.change.emit(new MatRadioChange(/** @type {?} */ ((this._selected)), this._value));
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatRadioGroup.prototype._markRadiosForCheck = /**
	     * @return {?}
	     */
	    function () {
	        if (this._radios) {
	            this._radios.forEach(function (radio) { return radio._markForCheck(); });
	        }
	    };
	    /**
	     * Sets the model value. Implemented as part of ControlValueAccessor.
	     * @param value
	     */
	    /**
	     * Sets the model value. Implemented as part of ControlValueAccessor.
	     * @param {?} value
	     * @return {?}
	     */
	    MatRadioGroup.prototype.writeValue = /**
	     * Sets the model value. Implemented as part of ControlValueAccessor.
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        this.value = value;
	        this._changeDetector.markForCheck();
	    };
	    /**
	     * Registers a callback to be triggered when the model value changes.
	     * Implemented as part of ControlValueAccessor.
	     * @param fn Callback to be registered.
	     */
	    /**
	     * Registers a callback to be triggered when the model value changes.
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} fn Callback to be registered.
	     * @return {?}
	     */
	    MatRadioGroup.prototype.registerOnChange = /**
	     * Registers a callback to be triggered when the model value changes.
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} fn Callback to be registered.
	     * @return {?}
	     */
	    function (fn) {
	        this._controlValueAccessorChangeFn = fn;
	    };
	    /**
	     * Registers a callback to be triggered when the control is touched.
	     * Implemented as part of ControlValueAccessor.
	     * @param fn Callback to be registered.
	     */
	    /**
	     * Registers a callback to be triggered when the control is touched.
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} fn Callback to be registered.
	     * @return {?}
	     */
	    MatRadioGroup.prototype.registerOnTouched = /**
	     * Registers a callback to be triggered when the control is touched.
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} fn Callback to be registered.
	     * @return {?}
	     */
	    function (fn) {
	        this.onTouched = fn;
	    };
	    /**
	     * Sets the disabled state of the control. Implemented as a part of ControlValueAccessor.
	     * @param isDisabled Whether the control should be disabled.
	     */
	    /**
	     * Sets the disabled state of the control. Implemented as a part of ControlValueAccessor.
	     * @param {?} isDisabled Whether the control should be disabled.
	     * @return {?}
	     */
	    MatRadioGroup.prototype.setDisabledState = /**
	     * Sets the disabled state of the control. Implemented as a part of ControlValueAccessor.
	     * @param {?} isDisabled Whether the control should be disabled.
	     * @return {?}
	     */
	    function (isDisabled) {
	        this.disabled = isDisabled;
	        this._changeDetector.markForCheck();
	    };
	    MatRadioGroup.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-radio-group',
	                    exportAs: 'matRadioGroup',
	                    providers: [MAT_RADIO_GROUP_CONTROL_VALUE_ACCESSOR],
	                    host: {
	                        'role': 'radiogroup',
	                        'class': 'mat-radio-group',
	                    },
	                    inputs: ['disabled'],
	                },] },
	    ];
	    /** @nocollapse */
	    MatRadioGroup.ctorParameters = function () { return [
	        { type: _angular_core.ChangeDetectorRef, },
	    ]; };
	    MatRadioGroup.propDecorators = {
	        "change": [{ type: _angular_core.Output },],
	        "_radios": [{ type: _angular_core.ContentChildren, args: [_angular_core.forwardRef(function () { return MatRadioButton; }), { descendants: true },] },],
	        "name": [{ type: _angular_core.Input },],
	        "align": [{ type: _angular_core.Input },],
	        "labelPosition": [{ type: _angular_core.Input },],
	        "value": [{ type: _angular_core.Input },],
	        "selected": [{ type: _angular_core.Input },],
	        "disabled": [{ type: _angular_core.Input },],
	        "required": [{ type: _angular_core.Input },],
	    };
	    return MatRadioGroup;
	}(_MatRadioGroupMixinBase));
	/**
	 * \@docs-private
	 */
	var MatRadioButtonBase = /** @class */ (function () {
	    function MatRadioButtonBase(_elementRef) {
	        this._elementRef = _elementRef;
	    }
	    return MatRadioButtonBase;
	}());
	// As per Material design specifications the selection control radio should use the accent color
	// palette by default. https://material.io/guidelines/components/selection-controls.html
	var _MatRadioButtonMixinBase = mixinColor(mixinDisableRipple(mixinTabIndex(MatRadioButtonBase)), 'accent');
	/**
	 * A Material design radio-button. Typically placed inside of `<mat-radio-group>` elements.
	 */
	var MatRadioButton = /** @class */ (function (_super) {
	    __extends(MatRadioButton, _super);
	    function MatRadioButton(radioGroup, elementRef, _changeDetector, _focusMonitor, _radioDispatcher) {
	        var _this = _super.call(this, elementRef) || this;
	        _this._changeDetector = _changeDetector;
	        _this._focusMonitor = _focusMonitor;
	        _this._radioDispatcher = _radioDispatcher;
	        _this._uniqueId = "mat-radio-" + ++nextUniqueId$5;
	        /**
	         * The unique ID for the radio button.
	         */
	        _this.id = _this._uniqueId;
	        /**
	         * Event emitted when the checked state of this radio button changes.
	         * Change events are only emitted when the value changes due to user interaction with
	         * the radio button (the same behavior as `<input type-"radio">`).
	         */
	        _this.change = new _angular_core.EventEmitter();
	        /**
	         * Whether this radio is checked.
	         */
	        _this._checked = false;
	        /**
	         * Value assigned to this radio.
	         */
	        _this._value = null;
	        /**
	         * Unregister function for _radioDispatcher
	         */
	        _this._removeUniqueSelectionListener = function () { };
	        // Assertions. Ideally these should be stripped out by the compiler.
	        // TODO(jelbourn): Assert that there's no name binding AND a parent radio group.
	        // Assertions. Ideally these should be stripped out by the compiler.
	        // TODO(jelbourn): Assert that there's no name binding AND a parent radio group.
	        _this.radioGroup = radioGroup;
	        _this._removeUniqueSelectionListener =
	            _radioDispatcher.listen(function (id, name) {
	                if (id != _this.id && name == _this.name) {
	                    _this.checked = false;
	                }
	            });
	        return _this;
	    }
	    Object.defineProperty(MatRadioButton.prototype, "checked", {
	        get: /**
	         * Whether this radio button is checked.
	         * @return {?}
	         */
	        function () { return this._checked; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            var /** @type {?} */ newCheckedState = _angular_cdk_coercion.coerceBooleanProperty(value);
	            if (this._checked != newCheckedState) {
	                this._checked = newCheckedState;
	                if (newCheckedState && this.radioGroup && this.radioGroup.value != this.value) {
	                    this.radioGroup.selected = this;
	                }
	                else if (!newCheckedState && this.radioGroup && this.radioGroup.value == this.value) {
	                    // When unchecking the selected radio button, update the selected radio
	                    // property on the group.
	                    this.radioGroup.selected = null;
	                }
	                if (newCheckedState) {
	                    // Notify all radio buttons with the same name to un-check.
	                    this._radioDispatcher.notify(this.id, this.name);
	                }
	                this._changeDetector.markForCheck();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatRadioButton.prototype, "value", {
	        get: /**
	         * The value of this radio button.
	         * @return {?}
	         */
	        function () { return this._value; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (this._value != value) {
	                this._value = value;
	                if (this.radioGroup != null) {
	                    if (!this.checked) {
	                        // Update checked when the value changed to match the radio group's value
	                        this.checked = this.radioGroup.value == value;
	                    }
	                    if (this.checked) {
	                        this.radioGroup.selected = this;
	                    }
	                }
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatRadioButton.prototype, "align", {
	        get: /**
	         * Whether or not the radio-button should appear before or after the label.
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () {
	            // align refers to the checkbox relative to the label, while labelPosition refers to the
	            // label relative to the checkbox. As such, they are inverted.
	            return this.labelPosition == 'after' ? 'start' : 'end';
	        },
	        set: /**
	         * @param {?} v
	         * @return {?}
	         */
	        function (v) {
	            this.labelPosition = (v == 'start') ? 'after' : 'before';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatRadioButton.prototype, "labelPosition", {
	        get: /**
	         * Whether the label should appear after or before the radio button. Defaults to 'after'
	         * @return {?}
	         */
	        function () {
	            return this._labelPosition || (this.radioGroup && this.radioGroup.labelPosition) || 'after';
	        },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._labelPosition = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatRadioButton.prototype, "disabled", {
	        get: /**
	         * Whether the radio button is disabled.
	         * @return {?}
	         */
	        function () {
	            return this._disabled || (this.radioGroup != null && this.radioGroup.disabled);
	        },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._disabled = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatRadioButton.prototype, "required", {
	        get: /**
	         * Whether the radio button is required.
	         * @return {?}
	         */
	        function () {
	            return this._required || (this.radioGroup && this.radioGroup.required);
	        },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._required = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatRadioButton.prototype, "inputId", {
	        /** ID of the native input element inside `<mat-radio-button>` */
	        get: /**
	         * ID of the native input element inside `<mat-radio-button>`
	         * @return {?}
	         */
	        function () { return (this.id || this._uniqueId) + "-input"; },
	        enumerable: true,
	        configurable: true
	    });
	    /** Focuses the radio button. */
	    /**
	     * Focuses the radio button.
	     * @return {?}
	     */
	    MatRadioButton.prototype.focus = /**
	     * Focuses the radio button.
	     * @return {?}
	     */
	    function () {
	        this._focusMonitor.focusVia(this._inputElement.nativeElement, 'keyboard');
	    };
	    /**
	     * Marks the radio button as needing checking for change detection.
	     * This method is exposed because the parent radio group will directly
	     * update bound properties of the radio button.
	     */
	    /**
	     * Marks the radio button as needing checking for change detection.
	     * This method is exposed because the parent radio group will directly
	     * update bound properties of the radio button.
	     * @return {?}
	     */
	    MatRadioButton.prototype._markForCheck = /**
	     * Marks the radio button as needing checking for change detection.
	     * This method is exposed because the parent radio group will directly
	     * update bound properties of the radio button.
	     * @return {?}
	     */
	    function () {
	        // When group value changes, the button will not be notified. Use `markForCheck` to explicit
	        // update radio button's status
	        this._changeDetector.markForCheck();
	    };
	    /**
	     * @return {?}
	     */
	    MatRadioButton.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        if (this.radioGroup) {
	            // If the radio is inside a radio group, determine if it should be checked
	            this.checked = this.radioGroup.value === this._value;
	            // Copy name from parent radio group
	            this.name = this.radioGroup.name;
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatRadioButton.prototype.ngAfterViewInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._focusMonitor
	            .monitor(this._inputElement.nativeElement)
	            .subscribe(function (focusOrigin) { return _this._onInputFocusChange(focusOrigin); });
	    };
	    /**
	     * @return {?}
	     */
	    MatRadioButton.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._focusMonitor.stopMonitoring(this._inputElement.nativeElement);
	        this._removeUniqueSelectionListener();
	    };
	    /**
	     * Dispatch change event with current value.
	     * @return {?}
	     */
	    MatRadioButton.prototype._emitChangeEvent = /**
	     * Dispatch change event with current value.
	     * @return {?}
	     */
	    function () {
	        this.change.emit(new MatRadioChange(this, this._value));
	    };
	    /**
	     * @return {?}
	     */
	    MatRadioButton.prototype._isRippleDisabled = /**
	     * @return {?}
	     */
	    function () {
	        return this.disableRipple || this.disabled;
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    MatRadioButton.prototype._onInputClick = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        // We have to stop propagation for click events on the visual hidden input element.
	        // By default, when a user clicks on a label element, a generated click event will be
	        // dispatched on the associated input element. Since we are using a label element as our
	        // root container, the click event on the `radio-button` will be executed twice.
	        // The real click event will bubble up, and the generated click event also tries to bubble up.
	        // This will lead to multiple click events.
	        // Preventing bubbling for the second event will solve that issue.
	        event.stopPropagation();
	    };
	    /**
	     * Triggered when the radio button received a click or the input recognized any change.
	     * Clicking on a label element, will trigger a change event on the associated input.
	     */
	    /**
	     * Triggered when the radio button received a click or the input recognized any change.
	     * Clicking on a label element, will trigger a change event on the associated input.
	     * @param {?} event
	     * @return {?}
	     */
	    MatRadioButton.prototype._onInputChange = /**
	     * Triggered when the radio button received a click or the input recognized any change.
	     * Clicking on a label element, will trigger a change event on the associated input.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        // We always have to stop propagation on the change event.
	        // Otherwise the change event, from the input element, will bubble up and
	        // emit its event object to the `change` output.
	        event.stopPropagation();
	        var /** @type {?} */ groupValueChanged = this.radioGroup && this.value != this.radioGroup.value;
	        this.checked = true;
	        this._emitChangeEvent();
	        if (this.radioGroup) {
	            this.radioGroup._controlValueAccessorChangeFn(this.value);
	            this.radioGroup._touch();
	            if (groupValueChanged) {
	                this.radioGroup._emitChangeEvent();
	            }
	        }
	    };
	    /**
	     * Function is called whenever the focus changes for the input element.
	     * @param {?} focusOrigin
	     * @return {?}
	     */
	    MatRadioButton.prototype._onInputFocusChange = /**
	     * Function is called whenever the focus changes for the input element.
	     * @param {?} focusOrigin
	     * @return {?}
	     */
	    function (focusOrigin) {
	        if (!this._focusRipple && focusOrigin === 'keyboard') {
	            this._focusRipple = this._ripple.launch(0, 0, { persistent: true });
	        }
	        else if (!focusOrigin) {
	            if (this.radioGroup) {
	                this.radioGroup._touch();
	            }
	            if (this._focusRipple) {
	                this._focusRipple.fadeOut();
	                this._focusRipple = null;
	            }
	        }
	    };
	    MatRadioButton.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-radio-button',
	                    template: "<label [attr.for]=\"inputId\" class=\"mat-radio-label\" #label><div class=\"mat-radio-container\"><div class=\"mat-radio-outer-circle\"></div><div class=\"mat-radio-inner-circle\"></div><div mat-ripple class=\"mat-radio-ripple\" [matRippleTrigger]=\"label\" [matRippleDisabled]=\"_isRippleDisabled()\" [matRippleCentered]=\"true\" [matRippleRadius]=\"23\" [matRippleAnimation]=\"{enterDuration: 150}\"></div></div><input #input class=\"mat-radio-input cdk-visually-hidden\" type=\"radio\" [id]=\"inputId\" [checked]=\"checked\" [disabled]=\"disabled\" [tabIndex]=\"tabIndex\" [attr.name]=\"name\" [required]=\"required\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledby\" [attr.aria-describedby]=\"ariaDescribedby\" (change)=\"_onInputChange($event)\" (click)=\"_onInputClick($event)\"><div class=\"mat-radio-label-content\" [class.mat-radio-label-before]=\"labelPosition == 'before'\"><span style=\"display:none\">&nbsp;</span><ng-content></ng-content></div></label>",
	                    styles: [".mat-radio-button{display:inline-block}.mat-radio-label{cursor:pointer;display:inline-flex;align-items:center;white-space:nowrap;vertical-align:middle}.mat-radio-container{box-sizing:border-box;display:inline-block;position:relative;width:20px;height:20px;flex-shrink:0}.mat-radio-outer-circle{box-sizing:border-box;height:20px;left:0;position:absolute;top:0;transition:border-color ease 280ms;width:20px;border-width:2px;border-style:solid;border-radius:50%}.mat-radio-inner-circle{border-radius:50%;box-sizing:border-box;height:20px;left:0;position:absolute;top:0;transition:transform ease 280ms,background-color ease 280ms;width:20px;transform:scale(.001)}.mat-radio-checked .mat-radio-inner-circle{transform:scale(.5)}.mat-radio-label-content{display:inline-block;order:0;line-height:inherit;padding-left:8px;padding-right:0}[dir=rtl] .mat-radio-label-content{padding-right:8px;padding-left:0}.mat-radio-label-content.mat-radio-label-before{order:-1;padding-left:0;padding-right:8px}[dir=rtl] .mat-radio-label-content.mat-radio-label-before{padding-right:0;padding-left:8px}.mat-radio-disabled,.mat-radio-disabled .mat-radio-label{cursor:default}.mat-radio-ripple{position:absolute;left:calc(50% - 25px);top:calc(50% - 25px);height:50px;width:50px;z-index:1;pointer-events:none}"],
	                    inputs: ['color', 'disableRipple', 'tabIndex'],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    exportAs: 'matRadioButton',
	                    host: {
	                        'class': 'mat-radio-button',
	                        '[class.mat-radio-checked]': 'checked',
	                        '[class.mat-radio-disabled]': 'disabled',
	                        '[attr.id]': 'id',
	                        // Note: under normal conditions focus shouldn't land on this element, however it may be
	                        // programmatically set, for example inside of a focus trap, in this case we want to forward
	                        // the focus to the native element.
	                        '(focus)': '_inputElement.nativeElement.focus()',
	                    },
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatRadioButton.ctorParameters = function () { return [
	        { type: MatRadioGroup, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: _angular_cdk_a11y.FocusMonitor, },
	        { type: _angular_cdk_collections.UniqueSelectionDispatcher, },
	    ]; };
	    MatRadioButton.propDecorators = {
	        "id": [{ type: _angular_core.Input },],
	        "name": [{ type: _angular_core.Input },],
	        "ariaLabel": [{ type: _angular_core.Input, args: ['aria-label',] },],
	        "ariaLabelledby": [{ type: _angular_core.Input, args: ['aria-labelledby',] },],
	        "ariaDescribedby": [{ type: _angular_core.Input, args: ['aria-describedby',] },],
	        "checked": [{ type: _angular_core.Input },],
	        "value": [{ type: _angular_core.Input },],
	        "align": [{ type: _angular_core.Input },],
	        "labelPosition": [{ type: _angular_core.Input },],
	        "disabled": [{ type: _angular_core.Input },],
	        "required": [{ type: _angular_core.Input },],
	        "change": [{ type: _angular_core.Output },],
	        "_ripple": [{ type: _angular_core.ViewChild, args: [MatRipple,] },],
	        "_inputElement": [{ type: _angular_core.ViewChild, args: ['input',] },],
	    };
	    return MatRadioButton;
	}(_MatRadioButtonMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatRadioModule = /** @class */ (function () {
	    function MatRadioModule() {
	    }
	    MatRadioModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [_angular_common.CommonModule, MatRippleModule, MatCommonModule, _angular_cdk_a11y.A11yModule],
	                    exports: [MatRadioGroup, MatRadioButton, MatCommonModule],
	                    providers: [_angular_cdk_collections.UNIQUE_SELECTION_DISPATCHER_PROVIDER],
	                    declarations: [MatRadioGroup, MatRadioButton],
	                },] },
	    ];
	    /** @nocollapse */
	    MatRadioModule.ctorParameters = function () { return []; };
	    return MatRadioModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * Animations used by the Material drawers.
	 */
	var matDrawerAnimations = {
	    /** Animation that slides a drawer in and out. */
	    transformDrawer: _angular_animations.trigger('transform', [
	        _angular_animations.state('open, open-instant', _angular_animations.style({
	            transform: 'translate3d(0, 0, 0)',
	            visibility: 'visible',
	        })),
	        _angular_animations.state('void', _angular_animations.style({
	            visibility: 'hidden',
	        })),
	        _angular_animations.transition('void => open-instant', _angular_animations.animate('0ms')),
	        _angular_animations.transition('void <=> open, open-instant => void', _angular_animations.animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)'))
	    ])
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * Throws an exception when two MatDrawer are matching the same position.
	 * @param {?} position
	 * @return {?}
	 */
	function throwMatDuplicatedDrawerError(position) {
	    throw Error("A drawer was already declared for 'position=\"" + position + "\"'");
	}
	/**
	 * Drawer toggle promise result.
	 * @deprecated
	 * \@deletion-target 6.0.0
	 */
	var MatDrawerToggleResult = /** @class */ (function () {
	    function MatDrawerToggleResult(type, animationFinished) {
	        this.type = type;
	        this.animationFinished = animationFinished;
	    }
	    return MatDrawerToggleResult;
	}());
	/**
	 * Configures whether drawers should use auto sizing by default.
	 */
	var MAT_DRAWER_DEFAULT_AUTOSIZE = new _angular_core.InjectionToken('MAT_DRAWER_DEFAULT_AUTOSIZE');
	var MatDrawerContent = /** @class */ (function () {
	    function MatDrawerContent(_changeDetectorRef, _container) {
	        this._changeDetectorRef = _changeDetectorRef;
	        this._container = _container;
	        /**
	         * Margins to be applied to the content. These are used to push / shrink the drawer content when a
	         * drawer is open. We use margin rather than transform even for push mode because transform breaks
	         * fixed position elements inside of the transformed element.
	         */
	        this._margins = { left: null, right: null };
	    }
	    /**
	     * @return {?}
	     */
	    MatDrawerContent.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._container._contentMargins.subscribe(function (margins) {
	            _this._margins = margins;
	            _this._changeDetectorRef.markForCheck();
	        });
	    };
	    MatDrawerContent.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-drawer-content',
	                    template: '<ng-content></ng-content>',
	                    host: {
	                        'class': 'mat-drawer-content',
	                        '[style.margin-left.px]': '_margins.left',
	                        '[style.margin-right.px]': '_margins.right',
	                    },
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                },] },
	    ];
	    /** @nocollapse */
	    MatDrawerContent.ctorParameters = function () { return [
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: MatDrawerContainer, decorators: [{ type: _angular_core.Inject, args: [_angular_core.forwardRef(function () { return MatDrawerContainer; }),] },] },
	    ]; };
	    return MatDrawerContent;
	}());
	/**
	 * This component corresponds to a drawer that can be opened on the drawer container.
	 */
	var MatDrawer = /** @class */ (function () {
	    function MatDrawer(_elementRef, _focusTrapFactory, _focusMonitor, _platform, _ngZone, _doc) {
	        var _this = this;
	        this._elementRef = _elementRef;
	        this._focusTrapFactory = _focusTrapFactory;
	        this._focusMonitor = _focusMonitor;
	        this._platform = _platform;
	        this._ngZone = _ngZone;
	        this._doc = _doc;
	        this._elementFocusedBeforeDrawerWasOpened = null;
	        /**
	         * Whether the drawer is initialized. Used for disabling the initial animation.
	         */
	        this._enableAnimations = false;
	        this._position = 'start';
	        this._mode = 'over';
	        this._disableClose = false;
	        /**
	         * Emits whenever the drawer has started animating.
	         */
	        this._animationStarted = new _angular_core.EventEmitter();
	        /**
	         * Current state of the sidenav animation.
	         */
	        this._animationState = 'void';
	        /**
	         * Event emitted when the drawer open state is changed.
	         */
	        this.openedChange = 
	        // Note this has to be async in order to avoid some issues with two-bindings (see #8872).
	        new _angular_core.EventEmitter(/* isAsync */ /* isAsync */ true);
	        /**
	         * Event emitted when the drawer is fully opened.
	         * @deprecated Use `opened` instead.
	         * \@deletion-target 6.0.0
	         */
	        this.onOpen = this._openedStream;
	        /**
	         * Event emitted when the drawer is fully closed.
	         * @deprecated Use `closed` instead.
	         * \@deletion-target 6.0.0
	         */
	        this.onClose = this._closedStream;
	        /**
	         * Event emitted when the drawer's position changes.
	         */
	        this.onPositionChanged = new _angular_core.EventEmitter();
	        /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         */
	        this.onAlignChanged = new _angular_core.EventEmitter();
	        /**
	         * An observable that emits when the drawer mode changes. This is used by the drawer container to
	         * to know when to when the mode changes so it can adapt the margins on the content.
	         */
	        this._modeChanged = new rxjs_Subject.Subject();
	        this._opened = false;
	        this.openedChange.subscribe(function (opened) {
	            if (opened) {
	                if (_this._doc) {
	                    _this._elementFocusedBeforeDrawerWasOpened = /** @type {?} */ (_this._doc.activeElement);
	                }
	                if (_this._isFocusTrapEnabled && _this._focusTrap) {
	                    _this._trapFocus();
	                }
	            }
	            else {
	                _this._restoreFocus();
	            }
	        });
	        /**
	             * Listen to `keydown` events outside the zone so that change detection is not run every
	             * time a key is pressed. Instead we re-enter the zone only if the `ESC` key is pressed
	             * and we don't have close disabled.
	             */
	        this._ngZone.runOutsideAngular(function () {
	            rxjs_observable_fromEvent.fromEvent(_this._elementRef.nativeElement, 'keydown').pipe(rxjs_operators_filter.filter(function (event) { return event.keyCode === _angular_cdk_keycodes.ESCAPE && !_this.disableClose; })).subscribe(function (event) {
	                return _this._ngZone.run(function () {
	                    _this.close();
	                    event.stopPropagation();
	                });
	            });
	        });
	    }
	    Object.defineProperty(MatDrawer.prototype, "position", {
	        get: /**
	         * The side that the drawer is attached to.
	         * @return {?}
	         */
	        function () { return this._position; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            // Make sure we have a valid value.
	            value = value === 'end' ? 'end' : 'start';
	            if (value != this._position) {
	                this._position = value;
	                this.onAlignChanged.emit();
	                this.onPositionChanged.emit();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDrawer.prototype, "align", {
	        get: /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this.position; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this.position = value; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDrawer.prototype, "mode", {
	        get: /**
	         * Mode of the drawer; one of 'over', 'push' or 'side'.
	         * @return {?}
	         */
	        function () { return this._mode; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._mode = value;
	            this._modeChanged.next();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDrawer.prototype, "disableClose", {
	        get: /**
	         * Whether the drawer can be closed with the escape key or by clicking on the backdrop.
	         * @return {?}
	         */
	        function () { return this._disableClose; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._disableClose = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDrawer.prototype, "_openedStream", {
	        get: /**
	         * Event emitted when the drawer has been opened.
	         * @return {?}
	         */
	        function () {
	            return this.openedChange.pipe(rxjs_operators_filter.filter(function (o) { return o; }), rxjs_operators_map.map(function () { }));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDrawer.prototype, "openedStart", {
	        get: /**
	         * Event emitted when the drawer has started opening.
	         * @return {?}
	         */
	        function () {
	            return this._animationStarted.pipe(rxjs_operators_filter.filter(function (e) { return e.fromState !== e.toState && e.toState.indexOf('open') === 0; }), rxjs_operators_map.map(function () { }));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDrawer.prototype, "_closedStream", {
	        get: /**
	         * Event emitted when the drawer has been closed.
	         * @return {?}
	         */
	        function () {
	            return this.openedChange.pipe(rxjs_operators_filter.filter(function (o) { return !o; }), rxjs_operators_map.map(function () { }));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDrawer.prototype, "closedStart", {
	        get: /**
	         * Event emitted when the drawer has started closing.
	         * @return {?}
	         */
	        function () {
	            return this._animationStarted.pipe(rxjs_operators_filter.filter(function (e) { return e.fromState !== e.toState && e.toState === 'void'; }), rxjs_operators_map.map(function () { }));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDrawer.prototype, "_isFocusTrapEnabled", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            // The focus trap is only enabled when the drawer is open in any mode other than side.
	            return this.opened && this.mode !== 'side';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Traps focus inside the drawer.
	     * @return {?}
	     */
	    MatDrawer.prototype._trapFocus = /**
	     * Traps focus inside the drawer.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._focusTrap.focusInitialElementWhenReady().then(function (hasMovedFocus) {
	            // If there were no focusable elements, focus the sidenav itself so the keyboard navigation
	            // still works. We need to check that `focus` is a function due to Universal.
	            if (!hasMovedFocus && typeof _this._elementRef.nativeElement.focus === 'function') {
	                _this._elementRef.nativeElement.focus();
	            }
	        });
	    };
	    /**
	     * If focus is currently inside the drawer, restores it to where it was before the drawer
	     * opened.
	     * @return {?}
	     */
	    MatDrawer.prototype._restoreFocus = /**
	     * If focus is currently inside the drawer, restores it to where it was before the drawer
	     * opened.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ activeEl = this._doc && this._doc.activeElement;
	        if (activeEl && this._elementRef.nativeElement.contains(activeEl)) {
	            if (this._elementFocusedBeforeDrawerWasOpened instanceof HTMLElement) {
	                this._focusMonitor.focusVia(this._elementFocusedBeforeDrawerWasOpened, this._openedVia);
	            }
	            else {
	                this._elementRef.nativeElement.blur();
	            }
	        }
	        this._elementFocusedBeforeDrawerWasOpened = null;
	        this._openedVia = null;
	    };
	    /**
	     * @return {?}
	     */
	    MatDrawer.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        this._focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement);
	        this._focusTrap.enabled = this._isFocusTrapEnabled;
	    };
	    /**
	     * @return {?}
	     */
	    MatDrawer.prototype.ngAfterContentChecked = /**
	     * @return {?}
	     */
	    function () {
	        // Enable the animations after the lifecycle hooks have run, in order to avoid animating
	        // drawers that are open by default. When we're on the server, we shouldn't enable the
	        // animations, because we don't want the drawer to animate the first time the user sees
	        // the page.
	        if (this._platform.isBrowser) {
	            this._enableAnimations = true;
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatDrawer.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        if (this._focusTrap) {
	            this._focusTrap.destroy();
	        }
	    };
	    Object.defineProperty(MatDrawer.prototype, "opened", {
	        get: /**
	         * Whether the drawer is opened. We overload this because we trigger an event when it
	         * starts or end.
	         * @return {?}
	         */
	        function () { return this._opened; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this.toggle(_angular_cdk_coercion.coerceBooleanProperty(value)); },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Open the drawer.
	     * @param openedVia Whether the drawer was opened by a key press, mouse click or programmatically.
	     * Used for focus management after the sidenav is closed.
	     */
	    /**
	     * Open the drawer.
	     * @param {?=} openedVia Whether the drawer was opened by a key press, mouse click or programmatically.
	     * Used for focus management after the sidenav is closed.
	     * @return {?}
	     */
	    MatDrawer.prototype.open = /**
	     * Open the drawer.
	     * @param {?=} openedVia Whether the drawer was opened by a key press, mouse click or programmatically.
	     * Used for focus management after the sidenav is closed.
	     * @return {?}
	     */
	    function (openedVia) {
	        return this.toggle(true, openedVia);
	    };
	    /** Close the drawer. */
	    /**
	     * Close the drawer.
	     * @return {?}
	     */
	    MatDrawer.prototype.close = /**
	     * Close the drawer.
	     * @return {?}
	     */
	    function () {
	        return this.toggle(false);
	    };
	    /**
	     * Toggle this drawer.
	     * @param isOpen Whether the drawer should be open.
	     * @param openedVia Whether the drawer was opened by a key press, mouse click or programmatically.
	     * Used for focus management after the sidenav is closed.
	     */
	    /**
	     * Toggle this drawer.
	     * @param {?=} isOpen Whether the drawer should be open.
	     * @param {?=} openedVia Whether the drawer was opened by a key press, mouse click or programmatically.
	     * Used for focus management after the sidenav is closed.
	     * @return {?}
	     */
	    MatDrawer.prototype.toggle = /**
	     * Toggle this drawer.
	     * @param {?=} isOpen Whether the drawer should be open.
	     * @param {?=} openedVia Whether the drawer was opened by a key press, mouse click or programmatically.
	     * Used for focus management after the sidenav is closed.
	     * @return {?}
	     */
	    function (isOpen, openedVia) {
	        var _this = this;
	        if (isOpen === void 0) { isOpen = !this.opened; }
	        if (openedVia === void 0) { openedVia = 'program'; }
	        this._opened = isOpen;
	        if (isOpen) {
	            this._animationState = this._enableAnimations ? 'open' : 'open-instant';
	            this._openedVia = openedVia;
	        }
	        else {
	            this._animationState = 'void';
	            this._restoreFocus();
	        }
	        if (this._focusTrap) {
	            this._focusTrap.enabled = this._isFocusTrapEnabled;
	        }
	        // TODO(crisbeto): This promise is here for backwards-compatibility.
	        // It should be removed next time we do breaking changes in the drawer.
	        // @deletion-target 6.0.0
	        return new Promise(function (resolve) {
	            _this.openedChange.pipe(rxjs_operators_take.take(1)).subscribe(function (open) {
	                resolve(new MatDrawerToggleResult(open ? 'open' : 'close', true));
	            });
	        });
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    MatDrawer.prototype._onAnimationStart = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        this._animationStarted.emit(event);
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    MatDrawer.prototype._onAnimationEnd = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var fromState = event.fromState, toState = event.toState;
	        if ((toState.indexOf('open') === 0 && fromState === 'void') ||
	            (toState === 'void' && fromState.indexOf('open') === 0)) {
	            this.openedChange.emit(this._opened);
	        }
	    };
	    Object.defineProperty(MatDrawer.prototype, "_width", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return this._elementRef.nativeElement ? (this._elementRef.nativeElement.offsetWidth || 0) : 0;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    MatDrawer.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-drawer',
	                    exportAs: 'matDrawer',
	                    template: '<ng-content></ng-content>',
	                    animations: [matDrawerAnimations.transformDrawer],
	                    host: {
	                        'class': 'mat-drawer',
	                        '[@transform]': '_animationState',
	                        '(@transform.start)': '_onAnimationStart($event)',
	                        '(@transform.done)': '_onAnimationEnd($event)',
	                        // must prevent the browser from aligning text based on value
	                        '[attr.align]': 'null',
	                        '[class.mat-drawer-end]': 'position === "end"',
	                        '[class.mat-drawer-over]': 'mode === "over"',
	                        '[class.mat-drawer-push]': 'mode === "push"',
	                        '[class.mat-drawer-side]': 'mode === "side"',
	                        'tabIndex': '-1',
	                    },
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                },] },
	    ];
	    /** @nocollapse */
	    MatDrawer.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_a11y.FocusTrapFactory, },
	        { type: _angular_cdk_a11y.FocusMonitor, },
	        { type: _angular_cdk_platform.Platform, },
	        { type: _angular_core.NgZone, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    MatDrawer.propDecorators = {
	        "position": [{ type: _angular_core.Input },],
	        "align": [{ type: _angular_core.Input },],
	        "mode": [{ type: _angular_core.Input },],
	        "disableClose": [{ type: _angular_core.Input },],
	        "openedChange": [{ type: _angular_core.Output },],
	        "_openedStream": [{ type: _angular_core.Output, args: ['opened',] },],
	        "openedStart": [{ type: _angular_core.Output },],
	        "_closedStream": [{ type: _angular_core.Output, args: ['closed',] },],
	        "closedStart": [{ type: _angular_core.Output },],
	        "onOpen": [{ type: _angular_core.Output, args: ['open',] },],
	        "onClose": [{ type: _angular_core.Output, args: ['close',] },],
	        "onPositionChanged": [{ type: _angular_core.Output, args: ['positionChanged',] },],
	        "onAlignChanged": [{ type: _angular_core.Output, args: ['align-changed',] },],
	        "opened": [{ type: _angular_core.Input },],
	    };
	    return MatDrawer;
	}());
	/**
	 * `<mat-drawer-container>` component.
	 *
	 * This is the parent component to one or two `<mat-drawer>`s that validates the state internally
	 * and coordinates the backdrop and content styling.
	 */
	var MatDrawerContainer = /** @class */ (function () {
	    function MatDrawerContainer(_dir, _element, _ngZone, _changeDetectorRef, defaultAutosize) {
	        if (defaultAutosize === void 0) { defaultAutosize = false; }
	        var _this = this;
	        this._dir = _dir;
	        this._element = _element;
	        this._ngZone = _ngZone;
	        this._changeDetectorRef = _changeDetectorRef;
	        /**
	         * Event emitted when the drawer backdrop is clicked.
	         */
	        this.backdropClick = new _angular_core.EventEmitter();
	        /**
	         * Emits when the component is destroyed.
	         */
	        this._destroyed = new rxjs_Subject.Subject();
	        /**
	         * Emits on every ngDoCheck. Used for debouncing reflows.
	         */
	        this._doCheckSubject = new rxjs_Subject.Subject();
	        this._contentMargins = new rxjs_Subject.Subject();
	        // If a `Dir` directive exists up the tree, listen direction changes
	        // and update the left/right properties to point to the proper start/end.
	        if (_dir) {
	            _dir.change.pipe(rxjs_operators_takeUntil.takeUntil(this._destroyed)).subscribe(function () {
	                _this._validateDrawers();
	                _this._updateContentMargins();
	            });
	        }
	        this._autosize = defaultAutosize;
	    }
	    Object.defineProperty(MatDrawerContainer.prototype, "start", {
	        /** The drawer child with the `start` position. */
	        get: /**
	         * The drawer child with the `start` position.
	         * @return {?}
	         */
	        function () { return this._start; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDrawerContainer.prototype, "end", {
	        /** The drawer child with the `end` position. */
	        get: /**
	         * The drawer child with the `end` position.
	         * @return {?}
	         */
	        function () { return this._end; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatDrawerContainer.prototype, "autosize", {
	        get: /**
	         * Whether to automatically resize the container whenever
	         * the size of any of its drawers changes.
	         *
	         * **Use at your own risk!** Enabling this option can cause layout thrashing by measuring
	         * the drawers on every change detection cycle. Can be configured globally via the
	         * `MAT_DRAWER_DEFAULT_AUTOSIZE` token.
	         * @return {?}
	         */
	        function () { return this._autosize; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._autosize = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatDrawerContainer.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._drawers.changes.pipe(rxjs_operators_startWith.startWith(null)).subscribe(function () {
	            _this._validateDrawers();
	            _this._drawers.forEach(function (drawer) {
	                _this._watchDrawerToggle(drawer);
	                _this._watchDrawerPosition(drawer);
	                _this._watchDrawerMode(drawer);
	            });
	            if (!_this._drawers.length ||
	                _this._isDrawerOpen(_this._start) ||
	                _this._isDrawerOpen(_this._end)) {
	                _this._updateContentMargins();
	            }
	            _this._changeDetectorRef.markForCheck();
	        });
	        this._doCheckSubject.pipe(rxjs_operators_debounceTime.debounceTime(10), // Arbitrary debounce time, less than a frame at 60fps
	        // Arbitrary debounce time, less than a frame at 60fps
	        rxjs_operators_takeUntil.takeUntil(this._destroyed)).subscribe(function () { return _this._updateContentMargins(); });
	    };
	    /**
	     * @return {?}
	     */
	    MatDrawerContainer.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._doCheckSubject.complete();
	        this._destroyed.next();
	        this._destroyed.complete();
	    };
	    /** Calls `open` of both start and end drawers */
	    /**
	     * Calls `open` of both start and end drawers
	     * @return {?}
	     */
	    MatDrawerContainer.prototype.open = /**
	     * Calls `open` of both start and end drawers
	     * @return {?}
	     */
	    function () {
	        this._drawers.forEach(function (drawer) { return drawer.open(); });
	    };
	    /** Calls `close` of both start and end drawers */
	    /**
	     * Calls `close` of both start and end drawers
	     * @return {?}
	     */
	    MatDrawerContainer.prototype.close = /**
	     * Calls `close` of both start and end drawers
	     * @return {?}
	     */
	    function () {
	        this._drawers.forEach(function (drawer) { return drawer.close(); });
	    };
	    /**
	     * @return {?}
	     */
	    MatDrawerContainer.prototype.ngDoCheck = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        // If users opted into autosizing, do a check every change detection cycle.
	        if (this._autosize && this._isPushed()) {
	            // Run outside the NgZone, otherwise the debouncer will throw us into an infinite loop.
	            this._ngZone.runOutsideAngular(function () { return _this._doCheckSubject.next(); });
	        }
	    };
	    /**
	     * Subscribes to drawer events in order to set a class on the main container element when the
	     * drawer is open and the backdrop is visible. This ensures any overflow on the container element
	     * is properly hidden.
	     * @param {?} drawer
	     * @return {?}
	     */
	    MatDrawerContainer.prototype._watchDrawerToggle = /**
	     * Subscribes to drawer events in order to set a class on the main container element when the
	     * drawer is open and the backdrop is visible. This ensures any overflow on the container element
	     * is properly hidden.
	     * @param {?} drawer
	     * @return {?}
	     */
	    function (drawer) {
	        var _this = this;
	        drawer._animationStarted.pipe(rxjs_operators_takeUntil.takeUntil(this._drawers.changes), rxjs_operators_filter.filter(function (event) { return event.fromState !== event.toState; }))
	            .subscribe(function (event) {
	            // Set the transition class on the container so that the animations occur. This should not
	            // be set initially because animations should only be triggered via a change in state.
	            if (event.toState !== 'open-instant') {
	                _this._element.nativeElement.classList.add('mat-drawer-transition');
	            }
	            _this._updateContentMargins();
	            _this._changeDetectorRef.markForCheck();
	        });
	        if (drawer.mode !== 'side') {
	            drawer.openedChange.pipe(rxjs_operators_takeUntil.takeUntil(this._drawers.changes)).subscribe(function () {
	                return _this._setContainerClass(drawer.opened);
	            });
	        }
	    };
	    /**
	     * Subscribes to drawer onPositionChanged event in order to
	     * re-validate drawers when the position changes.
	     * @param {?} drawer
	     * @return {?}
	     */
	    MatDrawerContainer.prototype._watchDrawerPosition = /**
	     * Subscribes to drawer onPositionChanged event in order to
	     * re-validate drawers when the position changes.
	     * @param {?} drawer
	     * @return {?}
	     */
	    function (drawer) {
	        var _this = this;
	        if (!drawer) {
	            return;
	        }
	        // NOTE: We need to wait for the microtask queue to be empty before validating,
	        // since both drawers may be swapping positions at the same time.
	        drawer.onPositionChanged.pipe(rxjs_operators_takeUntil.takeUntil(this._drawers.changes)).subscribe(function () {
	            _this._ngZone.onMicrotaskEmpty.asObservable().pipe(rxjs_operators_take.take(1)).subscribe(function () {
	                _this._validateDrawers();
	            });
	        });
	    };
	    /**
	     * Subscribes to changes in drawer mode so we can run change detection.
	     * @param {?} drawer
	     * @return {?}
	     */
	    MatDrawerContainer.prototype._watchDrawerMode = /**
	     * Subscribes to changes in drawer mode so we can run change detection.
	     * @param {?} drawer
	     * @return {?}
	     */
	    function (drawer) {
	        var _this = this;
	        if (drawer) {
	            drawer._modeChanged.pipe(rxjs_operators_takeUntil.takeUntil(rxjs_observable_merge.merge(this._drawers.changes, this._destroyed)))
	                .subscribe(function () {
	                _this._updateContentMargins();
	                _this._changeDetectorRef.markForCheck();
	            });
	        }
	    };
	    /**
	     * Toggles the 'mat-drawer-opened' class on the main 'mat-drawer-container' element.
	     * @param {?} isAdd
	     * @return {?}
	     */
	    MatDrawerContainer.prototype._setContainerClass = /**
	     * Toggles the 'mat-drawer-opened' class on the main 'mat-drawer-container' element.
	     * @param {?} isAdd
	     * @return {?}
	     */
	    function (isAdd) {
	        if (isAdd) {
	            this._element.nativeElement.classList.add('mat-drawer-opened');
	        }
	        else {
	            this._element.nativeElement.classList.remove('mat-drawer-opened');
	        }
	    };
	    /**
	     * Validate the state of the drawer children components.
	     * @return {?}
	     */
	    MatDrawerContainer.prototype._validateDrawers = /**
	     * Validate the state of the drawer children components.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._start = this._end = null;
	        // Ensure that we have at most one start and one end drawer.
	        this._drawers.forEach(function (drawer) {
	            if (drawer.position == 'end') {
	                if (_this._end != null) {
	                    throwMatDuplicatedDrawerError('end');
	                }
	                _this._end = drawer;
	            }
	            else {
	                if (_this._start != null) {
	                    throwMatDuplicatedDrawerError('start');
	                }
	                _this._start = drawer;
	            }
	        });
	        this._right = this._left = null;
	        // Detect if we're LTR or RTL.
	        if (!this._dir || this._dir.value == 'ltr') {
	            this._left = this._start;
	            this._right = this._end;
	        }
	        else {
	            this._left = this._end;
	            this._right = this._start;
	        }
	    };
	    /**
	     * Whether the container is being pushed to the side by one of the drawers.
	     * @return {?}
	     */
	    MatDrawerContainer.prototype._isPushed = /**
	     * Whether the container is being pushed to the side by one of the drawers.
	     * @return {?}
	     */
	    function () {
	        return (this._isDrawerOpen(this._start) && /** @type {?} */ ((this._start)).mode != 'over') ||
	            (this._isDrawerOpen(this._end) && /** @type {?} */ ((this._end)).mode != 'over');
	    };
	    /**
	     * @return {?}
	     */
	    MatDrawerContainer.prototype._onBackdropClicked = /**
	     * @return {?}
	     */
	    function () {
	        this.backdropClick.emit();
	        this._closeModalDrawer();
	    };
	    /**
	     * @return {?}
	     */
	    MatDrawerContainer.prototype._closeModalDrawer = /**
	     * @return {?}
	     */
	    function () {
	        // Close all open drawers where closing is not disabled and the mode is not `side`.
	        [this._start, this._end]
	            .filter(function (drawer) { return drawer && !drawer.disableClose && drawer.mode !== 'side'; })
	            .forEach(function (drawer) { return ((drawer)).close(); });
	    };
	    /**
	     * @return {?}
	     */
	    MatDrawerContainer.prototype._isShowingBackdrop = /**
	     * @return {?}
	     */
	    function () {
	        return (this._isDrawerOpen(this._start) && /** @type {?} */ ((this._start)).mode != 'side')
	            || (this._isDrawerOpen(this._end) && /** @type {?} */ ((this._end)).mode != 'side');
	    };
	    /**
	     * @param {?} drawer
	     * @return {?}
	     */
	    MatDrawerContainer.prototype._isDrawerOpen = /**
	     * @param {?} drawer
	     * @return {?}
	     */
	    function (drawer) {
	        return drawer != null && drawer.opened;
	    };
	    /**
	     * Recalculates and updates the inline styles for the content. Note that this should be used
	     * sparingly, because it causes a reflow.
	     * @return {?}
	     */
	    MatDrawerContainer.prototype._updateContentMargins = /**
	     * Recalculates and updates the inline styles for the content. Note that this should be used
	     * sparingly, because it causes a reflow.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        // 1. For drawers in `over` mode, they don't affect the content.
	        // 2. For drawers in `side` mode they should shrink the content. We do this by adding to the
	        //    left margin (for left drawer) or right margin (for right the drawer).
	        // 3. For drawers in `push` mode the should shift the content without resizing it. We do this by
	        //    adding to the left or right margin and simultaneously subtracting the same amount of
	        //    margin from the other side.
	        var /** @type {?} */ left = 0;
	        var /** @type {?} */ right = 0;
	        if (this._left && this._left.opened) {
	            if (this._left.mode == 'side') {
	                left += this._left._width;
	            }
	            else if (this._left.mode == 'push') {
	                var /** @type {?} */ width = this._left._width;
	                left += width;
	                right -= width;
	            }
	        }
	        if (this._right && this._right.opened) {
	            if (this._right.mode == 'side') {
	                right += this._right._width;
	            }
	            else if (this._right.mode == 'push') {
	                var /** @type {?} */ width = this._right._width;
	                right += width;
	                left -= width;
	            }
	        }
	        // Pull back into the NgZone since in some cases we could be outside.
	        this._ngZone.run(function () { return _this._contentMargins.next({ left: left, right: right }); });
	    };
	    MatDrawerContainer.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-drawer-container',
	                    exportAs: 'matDrawerContainer',
	                    template: "<div class=\"mat-drawer-backdrop\" (click)=\"_onBackdropClicked()\" [class.mat-drawer-shown]=\"_isShowingBackdrop()\"></div><ng-content select=\"mat-drawer\"></ng-content><ng-content select=\"mat-drawer-content\"></ng-content><mat-drawer-content *ngIf=\"!_content\" cdkScrollable><ng-content></ng-content></mat-drawer-content>",
	                    styles: [".mat-drawer-container{position:relative;z-index:1;box-sizing:border-box;-webkit-overflow-scrolling:touch;display:block;overflow:hidden}.mat-drawer-container[fullscreen]{top:0;left:0;right:0;bottom:0;position:absolute}.mat-drawer-container[fullscreen].mat-drawer-opened{overflow:hidden}.mat-drawer-backdrop{top:0;left:0;right:0;bottom:0;position:absolute;display:block;z-index:3;visibility:hidden}.mat-drawer-backdrop.mat-drawer-shown{visibility:visible}.mat-drawer-transition .mat-drawer-backdrop{transition-duration:.4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);transition-property:background-color,visibility}@media screen and (-ms-high-contrast:active){.mat-drawer-backdrop{opacity:.5}}.mat-drawer-content{position:relative;z-index:1;display:block;height:100%;overflow:auto}.mat-drawer-transition .mat-drawer-content{transition-duration:.4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);transition-property:transform,margin-left,margin-right}.mat-drawer{position:relative;z-index:4;display:block;position:absolute;top:0;bottom:0;z-index:3;outline:0;box-sizing:border-box;overflow-y:auto;transform:translate3d(-100%,0,0)}.mat-drawer.mat-drawer-side{z-index:2}.mat-drawer.mat-drawer-end{right:0;transform:translate3d(100%,0,0)}[dir=rtl] .mat-drawer{transform:translate3d(100%,0,0)}[dir=rtl] .mat-drawer.mat-drawer-end{left:0;right:auto;transform:translate3d(-100%,0,0)}.mat-drawer:not(.mat-drawer-side){box-shadow:0 8px 10px -5px rgba(0,0,0,.2),0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12)}.mat-sidenav-fixed{position:fixed}"],
	                    host: {
	                        'class': 'mat-drawer-container',
	                    },
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                },] },
	    ];
	    /** @nocollapse */
	    MatDrawerContainer.ctorParameters = function () { return [
	        { type: _angular_cdk_bidi.Directionality, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.NgZone, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [MAT_DRAWER_DEFAULT_AUTOSIZE,] },] },
	    ]; };
	    MatDrawerContainer.propDecorators = {
	        "_drawers": [{ type: _angular_core.ContentChildren, args: [MatDrawer,] },],
	        "_content": [{ type: _angular_core.ContentChild, args: [MatDrawerContent,] },],
	        "autosize": [{ type: _angular_core.Input },],
	        "backdropClick": [{ type: _angular_core.Output },],
	        "scrollable": [{ type: _angular_core.ViewChild, args: [_angular_cdk_scrolling.CdkScrollable,] },],
	    };
	    return MatDrawerContainer;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatSidenavContent = /** @class */ (function (_super) {
	    __extends(MatSidenavContent, _super);
	    function MatSidenavContent(changeDetectorRef, container) {
	        return _super.call(this, changeDetectorRef, container) || this;
	    }
	    MatSidenavContent.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-sidenav-content',
	                    template: '<ng-content></ng-content>',
	                    host: {
	                        'class': 'mat-drawer-content mat-sidenav-content',
	                        '[style.margin-left.px]': '_margins.left',
	                        '[style.margin-right.px]': '_margins.right',
	                    },
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                },] },
	    ];
	    /** @nocollapse */
	    MatSidenavContent.ctorParameters = function () { return [
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: MatSidenavContainer, decorators: [{ type: _angular_core.Inject, args: [_angular_core.forwardRef(function () { return MatSidenavContainer; }),] },] },
	    ]; };
	    return MatSidenavContent;
	}(MatDrawerContent));
	var MatSidenav = /** @class */ (function (_super) {
	    __extends(MatSidenav, _super);
	    function MatSidenav() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._fixedInViewport = false;
	        _this._fixedTopGap = 0;
	        _this._fixedBottomGap = 0;
	        return _this;
	    }
	    Object.defineProperty(MatSidenav.prototype, "fixedInViewport", {
	        get: /**
	         * Whether the sidenav is fixed in the viewport.
	         * @return {?}
	         */
	        function () { return this._fixedInViewport; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._fixedInViewport = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSidenav.prototype, "fixedTopGap", {
	        get: /**
	         * The gap between the top of the sidenav and the top of the viewport when the sidenav is in fixed
	         * mode.
	         * @return {?}
	         */
	        function () { return this._fixedTopGap; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._fixedTopGap = _angular_cdk_coercion.coerceNumberProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSidenav.prototype, "fixedBottomGap", {
	        get: /**
	         * The gap between the bottom of the sidenav and the bottom of the viewport when the sidenav is in
	         * fixed mode.
	         * @return {?}
	         */
	        function () { return this._fixedBottomGap; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._fixedBottomGap = _angular_cdk_coercion.coerceNumberProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    MatSidenav.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-sidenav',
	                    exportAs: 'matSidenav',
	                    template: '<ng-content></ng-content>',
	                    animations: [matDrawerAnimations.transformDrawer],
	                    host: {
	                        'class': 'mat-drawer mat-sidenav',
	                        'tabIndex': '-1',
	                        '[@transform]': '_animationState',
	                        '(@transform.start)': '_onAnimationStart($event)',
	                        '(@transform.done)': '_onAnimationEnd($event)',
	                        // must prevent the browser from aligning text based on value
	                        '[attr.align]': 'null',
	                        '[class.mat-drawer-end]': 'position === "end"',
	                        '[class.mat-drawer-over]': 'mode === "over"',
	                        '[class.mat-drawer-push]': 'mode === "push"',
	                        '[class.mat-drawer-side]': 'mode === "side"',
	                        '[class.mat-sidenav-fixed]': 'fixedInViewport',
	                        '[style.top.px]': 'fixedInViewport ? fixedTopGap : null',
	                        '[style.bottom.px]': 'fixedInViewport ? fixedBottomGap : null',
	                    },
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                },] },
	    ];
	    /** @nocollapse */
	    MatSidenav.ctorParameters = function () { return []; };
	    MatSidenav.propDecorators = {
	        "fixedInViewport": [{ type: _angular_core.Input },],
	        "fixedTopGap": [{ type: _angular_core.Input },],
	        "fixedBottomGap": [{ type: _angular_core.Input },],
	    };
	    return MatSidenav;
	}(MatDrawer));
	var MatSidenavContainer = /** @class */ (function (_super) {
	    __extends(MatSidenavContainer, _super);
	    function MatSidenavContainer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    MatSidenavContainer.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-sidenav-container',
	                    exportAs: 'matSidenavContainer',
	                    template: "<div class=\"mat-drawer-backdrop\" (click)=\"_onBackdropClicked()\" [class.mat-drawer-shown]=\"_isShowingBackdrop()\"></div><ng-content select=\"mat-sidenav\"></ng-content><ng-content select=\"mat-sidenav-content\"></ng-content><mat-sidenav-content *ngIf=\"!_content\" cdkScrollable><ng-content></ng-content></mat-sidenav-content>",
	                    styles: [".mat-drawer-container{position:relative;z-index:1;box-sizing:border-box;-webkit-overflow-scrolling:touch;display:block;overflow:hidden}.mat-drawer-container[fullscreen]{top:0;left:0;right:0;bottom:0;position:absolute}.mat-drawer-container[fullscreen].mat-drawer-opened{overflow:hidden}.mat-drawer-backdrop{top:0;left:0;right:0;bottom:0;position:absolute;display:block;z-index:3;visibility:hidden}.mat-drawer-backdrop.mat-drawer-shown{visibility:visible}.mat-drawer-transition .mat-drawer-backdrop{transition-duration:.4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);transition-property:background-color,visibility}@media screen and (-ms-high-contrast:active){.mat-drawer-backdrop{opacity:.5}}.mat-drawer-content{position:relative;z-index:1;display:block;height:100%;overflow:auto}.mat-drawer-transition .mat-drawer-content{transition-duration:.4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);transition-property:transform,margin-left,margin-right}.mat-drawer{position:relative;z-index:4;display:block;position:absolute;top:0;bottom:0;z-index:3;outline:0;box-sizing:border-box;overflow-y:auto;transform:translate3d(-100%,0,0)}.mat-drawer.mat-drawer-side{z-index:2}.mat-drawer.mat-drawer-end{right:0;transform:translate3d(100%,0,0)}[dir=rtl] .mat-drawer{transform:translate3d(100%,0,0)}[dir=rtl] .mat-drawer.mat-drawer-end{left:0;right:auto;transform:translate3d(-100%,0,0)}.mat-drawer:not(.mat-drawer-side){box-shadow:0 8px 10px -5px rgba(0,0,0,.2),0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12)}.mat-sidenav-fixed{position:fixed}"],
	                    host: {
	                        'class': 'mat-drawer-container mat-sidenav-container',
	                    },
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                },] },
	    ];
	    /** @nocollapse */
	    MatSidenavContainer.ctorParameters = function () { return []; };
	    MatSidenavContainer.propDecorators = {
	        "_drawers": [{ type: _angular_core.ContentChildren, args: [MatSidenav,] },],
	        "_content": [{ type: _angular_core.ContentChild, args: [MatSidenavContent,] },],
	    };
	    return MatSidenavContainer;
	}(MatDrawerContainer));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatSidenavModule = /** @class */ (function () {
	    function MatSidenavModule() {
	    }
	    MatSidenavModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [
	                        _angular_common.CommonModule,
	                        MatCommonModule,
	                        _angular_cdk_a11y.A11yModule,
	                        _angular_cdk_overlay.OverlayModule,
	                        _angular_cdk_scrolling.ScrollDispatchModule,
	                        _angular_cdk_platform.PlatformModule,
	                    ],
	                    exports: [
	                        MatCommonModule,
	                        MatDrawer,
	                        MatDrawerContainer,
	                        MatDrawerContent,
	                        MatSidenav,
	                        MatSidenavContainer,
	                        MatSidenavContent,
	                    ],
	                    declarations: [
	                        MatDrawer,
	                        MatDrawerContainer,
	                        MatDrawerContent,
	                        MatSidenav,
	                        MatSidenavContainer,
	                        MatSidenavContent,
	                    ],
	                    providers: [
	                        { provide: MAT_DRAWER_DEFAULT_AUTOSIZE, useValue: false }
	                    ]
	                },] },
	    ];
	    /** @nocollapse */
	    MatSidenavModule.ctorParameters = function () { return []; };
	    return MatSidenavModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	// Increasing integer for generating unique ids for slide-toggle components.
	var nextUniqueId$6 = 0;
	var MAT_SLIDE_TOGGLE_VALUE_ACCESSOR = {
	    provide: _angular_forms.NG_VALUE_ACCESSOR,
	    useExisting: _angular_core.forwardRef(function () { return MatSlideToggle; }),
	    multi: true
	};
	/**
	 * Change event object emitted by a MatSlideToggle.
	 */
	var MatSlideToggleChange = /** @class */ (function () {
	    function MatSlideToggleChange(source, checked) {
	        this.source = source;
	        this.checked = checked;
	    }
	    return MatSlideToggleChange;
	}());
	/**
	 * \@docs-private
	 */
	var MatSlideToggleBase = /** @class */ (function () {
	    function MatSlideToggleBase(_elementRef) {
	        this._elementRef = _elementRef;
	    }
	    return MatSlideToggleBase;
	}());
	var _MatSlideToggleMixinBase = mixinTabIndex(mixinColor(mixinDisableRipple(mixinDisabled(MatSlideToggleBase)), 'accent'));
	/**
	 * Represents a slidable "switch" toggle that can be moved between on and off.
	 */
	var MatSlideToggle = /** @class */ (function (_super) {
	    __extends(MatSlideToggle, _super);
	    function MatSlideToggle(elementRef, _platform, _focusMonitor, _changeDetectorRef, tabIndex) {
	        var _this = _super.call(this, elementRef) || this;
	        _this._platform = _platform;
	        _this._focusMonitor = _focusMonitor;
	        _this._changeDetectorRef = _changeDetectorRef;
	        _this.onChange = function (_) { };
	        _this.onTouched = function () { };
	        _this._uniqueId = "mat-slide-toggle-" + ++nextUniqueId$6;
	        _this._required = false;
	        _this._checked = false;
	        /**
	         * Name value will be applied to the input element if present
	         */
	        _this.name = null;
	        /**
	         * A unique id for the slide-toggle input. If none is supplied, it will be auto-generated.
	         */
	        _this.id = _this._uniqueId;
	        /**
	         * Whether the label should appear after or before the slide-toggle. Defaults to 'after'
	         */
	        _this.labelPosition = 'after';
	        /**
	         * Used to set the aria-label attribute on the underlying input element.
	         */
	        _this.ariaLabel = null;
	        /**
	         * Used to set the aria-labelledby attribute on the underlying input element.
	         */
	        _this.ariaLabelledby = null;
	        /**
	         * An event will be dispatched each time the slide-toggle changes its value.
	         */
	        _this.change = new _angular_core.EventEmitter();
	        _this.tabIndex = parseInt(tabIndex) || 0;
	        return _this;
	    }
	    Object.defineProperty(MatSlideToggle.prototype, "required", {
	        get: /**
	         * Whether the slide-toggle is required.
	         * @return {?}
	         */
	        function () { return this._required; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._required = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlideToggle.prototype, "checked", {
	        get: /**
	         * Whether the slide-toggle element is checked or not
	         * @return {?}
	         */
	        function () { return this._checked; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._checked = _angular_cdk_coercion.coerceBooleanProperty(value);
	            this._changeDetectorRef.markForCheck();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlideToggle.prototype, "inputId", {
	        /** Returns the unique id for the visual hidden input. */
	        get: /**
	         * Returns the unique id for the visual hidden input.
	         * @return {?}
	         */
	        function () { return (this.id || this._uniqueId) + "-input"; },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatSlideToggle.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._slideRenderer = new SlideToggleRenderer(this._elementRef, this._platform);
	        this._focusMonitor
	            .monitor(this._inputElement.nativeElement)
	            .subscribe(function (focusOrigin) { return _this._onInputFocusChange(focusOrigin); });
	    };
	    /**
	     * @return {?}
	     */
	    MatSlideToggle.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._focusMonitor.stopMonitoring(this._inputElement.nativeElement);
	    };
	    /** Method being called whenever the underlying input emits a change event. */
	    /**
	     * Method being called whenever the underlying input emits a change event.
	     * @param {?} event
	     * @return {?}
	     */
	    MatSlideToggle.prototype._onChangeEvent = /**
	     * Method being called whenever the underlying input emits a change event.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        // We always have to stop propagation on the change event.
	        // Otherwise the change event, from the input element, will bubble up and
	        // emit its event object to the component's `change` output.
	        event.stopPropagation();
	        // Releasing the pointer over the `<label>` element while dragging triggers another
	        // click event on the `<label>` element. This means that the checked state of the underlying
	        // input changed unintentionally and needs to be changed back.
	        if (this._slideRenderer.dragging) {
	            this._inputElement.nativeElement.checked = this.checked;
	            return;
	        }
	        // Sync the value from the underlying input element with the component instance.
	        this.checked = this._inputElement.nativeElement.checked;
	        // Emit our custom change event only if the underlying input emitted one. This ensures that
	        // there is no change event, when the checked state changes programmatically.
	        this._emitChangeEvent();
	    };
	    /** Method being called whenever the slide-toggle has been clicked. */
	    /**
	     * Method being called whenever the slide-toggle has been clicked.
	     * @param {?} event
	     * @return {?}
	     */
	    MatSlideToggle.prototype._onInputClick = /**
	     * Method being called whenever the slide-toggle has been clicked.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        // We have to stop propagation for click events on the visual hidden input element.
	        // By default, when a user clicks on a label element, a generated click event will be
	        // dispatched on the associated input element. Since we are using a label element as our
	        // root container, the click event on the `slide-toggle` will be executed twice.
	        // The real click event will bubble up, and the generated click event also tries to bubble up.
	        // This will lead to multiple click events.
	        // Preventing bubbling for the second event will solve that issue.
	        event.stopPropagation();
	    };
	    /** Implemented as part of ControlValueAccessor. */
	    /**
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} value
	     * @return {?}
	     */
	    MatSlideToggle.prototype.writeValue = /**
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        this.checked = !!value;
	    };
	    /** Implemented as part of ControlValueAccessor. */
	    /**
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} fn
	     * @return {?}
	     */
	    MatSlideToggle.prototype.registerOnChange = /**
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this.onChange = fn;
	    };
	    /** Implemented as part of ControlValueAccessor. */
	    /**
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} fn
	     * @return {?}
	     */
	    MatSlideToggle.prototype.registerOnTouched = /**
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} fn
	     * @return {?}
	     */
	    function (fn) {
	        this.onTouched = fn;
	    };
	    /** Implemented as a part of ControlValueAccessor. */
	    /**
	     * Implemented as a part of ControlValueAccessor.
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    MatSlideToggle.prototype.setDisabledState = /**
	     * Implemented as a part of ControlValueAccessor.
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    function (isDisabled) {
	        this.disabled = isDisabled;
	        this._changeDetectorRef.markForCheck();
	    };
	    /** Focuses the slide-toggle. */
	    /**
	     * Focuses the slide-toggle.
	     * @return {?}
	     */
	    MatSlideToggle.prototype.focus = /**
	     * Focuses the slide-toggle.
	     * @return {?}
	     */
	    function () {
	        this._focusMonitor.focusVia(this._inputElement.nativeElement, 'keyboard');
	    };
	    /** Toggles the checked state of the slide-toggle. */
	    /**
	     * Toggles the checked state of the slide-toggle.
	     * @return {?}
	     */
	    MatSlideToggle.prototype.toggle = /**
	     * Toggles the checked state of the slide-toggle.
	     * @return {?}
	     */
	    function () {
	        this.checked = !this.checked;
	    };
	    /**
	     * Function is called whenever the focus changes for the input element.
	     * @param {?} focusOrigin
	     * @return {?}
	     */
	    MatSlideToggle.prototype._onInputFocusChange = /**
	     * Function is called whenever the focus changes for the input element.
	     * @param {?} focusOrigin
	     * @return {?}
	     */
	    function (focusOrigin) {
	        if (!this._focusRipple && focusOrigin === 'keyboard') {
	            // For keyboard focus show a persistent ripple as focus indicator.
	            this._focusRipple = this._ripple.launch(0, 0, { persistent: true });
	        }
	        else if (!focusOrigin) {
	            this.onTouched();
	            // Fade out and clear the focus ripple if one is currently present.
	            if (this._focusRipple) {
	                this._focusRipple.fadeOut();
	                this._focusRipple = null;
	            }
	        }
	    };
	    /**
	     * Emits a change event on the `change` output. Also notifies the FormControl about the change.
	     * @return {?}
	     */
	    MatSlideToggle.prototype._emitChangeEvent = /**
	     * Emits a change event on the `change` output. Also notifies the FormControl about the change.
	     * @return {?}
	     */
	    function () {
	        this.onChange(this.checked);
	        this.change.emit(new MatSlideToggleChange(this, this.checked));
	    };
	    /**
	     * @return {?}
	     */
	    MatSlideToggle.prototype._onDragStart = /**
	     * @return {?}
	     */
	    function () {
	        if (!this.disabled) {
	            this._slideRenderer.startThumbDrag(this.checked);
	        }
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    MatSlideToggle.prototype._onDrag = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (this._slideRenderer.dragging) {
	            this._slideRenderer.updateThumbPosition(event.deltaX);
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatSlideToggle.prototype._onDragEnd = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._slideRenderer.dragging) {
	            var /** @type {?} */ newCheckedValue = this._slideRenderer.dragPercentage > 50;
	            if (newCheckedValue !== this.checked) {
	                this.checked = newCheckedValue;
	                this._emitChangeEvent();
	            }
	            // The drag should be stopped outside of the current event handler, because otherwise the
	            // click event will be fired before and will revert the drag change.
	            setTimeout(function () { return _this._slideRenderer.stopThumbDrag(); });
	        }
	    };
	    /** Method being called whenever the label text changes. */
	    /**
	     * Method being called whenever the label text changes.
	     * @return {?}
	     */
	    MatSlideToggle.prototype._onLabelTextChange = /**
	     * Method being called whenever the label text changes.
	     * @return {?}
	     */
	    function () {
	        // This method is getting called whenever the label of the slide-toggle changes.
	        // Since the slide-toggle uses the OnPush strategy we need to notify it about the change
	        // that has been recognized by the cdkObserveContent directive.
	        this._changeDetectorRef.markForCheck();
	    };
	    MatSlideToggle.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-slide-toggle',
	                    exportAs: 'matSlideToggle',
	                    host: {
	                        'class': 'mat-slide-toggle',
	                        '[id]': 'id',
	                        '[class.mat-checked]': 'checked',
	                        '[class.mat-disabled]': 'disabled',
	                        '[class.mat-slide-toggle-label-before]': 'labelPosition == "before"',
	                    },
	                    template: "<label class=\"mat-slide-toggle-label\" #label><div class=\"mat-slide-toggle-bar\" [class.mat-slide-toggle-bar-no-side-margin]=\"!labelContent.textContent || !labelContent.textContent.trim()\"><input #input class=\"mat-slide-toggle-input cdk-visually-hidden\" type=\"checkbox\" [id]=\"inputId\" [required]=\"required\" [tabIndex]=\"tabIndex\" [checked]=\"checked\" [disabled]=\"disabled\" [attr.name]=\"name\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledby\" (change)=\"_onChangeEvent($event)\" (click)=\"_onInputClick($event)\"><div class=\"mat-slide-toggle-thumb-container\" (slidestart)=\"_onDragStart()\" (slide)=\"_onDrag($event)\" (slideend)=\"_onDragEnd()\"><div class=\"mat-slide-toggle-thumb\"></div><div class=\"mat-slide-toggle-ripple\" mat-ripple [matRippleTrigger]=\"label\" [matRippleDisabled]=\"disableRipple || disabled\" [matRippleCentered]=\"true\" [matRippleRadius]=\"23\" [matRippleAnimation]=\"{enterDuration: 150}\"></div></div></div><span class=\"mat-slide-toggle-content\" #labelContent (cdkObserveContent)=\"_onLabelTextChange()\"><ng-content></ng-content></span></label>",
	                    styles: [".mat-slide-toggle{display:inline-block;height:24px;max-width:100%;line-height:24px;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:0}.mat-slide-toggle.mat-checked .mat-slide-toggle-thumb-container{transform:translate3d(16px,0,0)}.mat-slide-toggle.mat-disabled .mat-slide-toggle-label,.mat-slide-toggle.mat-disabled .mat-slide-toggle-thumb-container{cursor:default}.mat-slide-toggle-label{display:flex;flex:1;flex-direction:row;align-items:center;height:inherit;cursor:pointer}.mat-slide-toggle-content{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.mat-slide-toggle-label-before .mat-slide-toggle-label{order:1}.mat-slide-toggle-label-before .mat-slide-toggle-bar{order:2}.mat-slide-toggle-bar,[dir=rtl] .mat-slide-toggle-label-before .mat-slide-toggle-bar{margin-right:8px;margin-left:0}.mat-slide-toggle-label-before .mat-slide-toggle-bar,[dir=rtl] .mat-slide-toggle-bar{margin-left:8px;margin-right:0}.mat-slide-toggle-bar-no-side-margin{margin-left:0;margin-right:0}.mat-slide-toggle-thumb-container{position:absolute;z-index:1;width:20px;height:20px;top:-3px;left:0;transform:translate3d(0,0,0);transition:all 80ms linear;transition-property:transform;cursor:-webkit-grab;cursor:grab}.mat-slide-toggle-thumb-container.mat-dragging,.mat-slide-toggle-thumb-container:active{cursor:-webkit-grabbing;cursor:grabbing;transition-duration:0s}.mat-slide-toggle-thumb{height:20px;width:20px;border-radius:50%;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)}@media screen and (-ms-high-contrast:active){.mat-slide-toggle-thumb{background:#fff;border:solid 1px #000}}.mat-slide-toggle-bar{position:relative;width:36px;height:14px;flex-shrink:0;border-radius:8px}@media screen and (-ms-high-contrast:active){.mat-slide-toggle-bar{background:#fff}}.mat-slide-toggle-input{bottom:0;left:10px}.mat-slide-toggle-bar,.mat-slide-toggle-thumb{transition:all 80ms linear;transition-property:background-color;transition-delay:50ms}.mat-slide-toggle-ripple{position:absolute;top:calc(50% - 23px);left:calc(50% - 23px);height:46px;width:46px;z-index:1;pointer-events:none}"],
	                    providers: [MAT_SLIDE_TOGGLE_VALUE_ACCESSOR],
	                    inputs: ['disabled', 'disableRipple', 'color', 'tabIndex'],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatSlideToggle.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_platform.Platform, },
	        { type: _angular_cdk_a11y.FocusMonitor, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Attribute, args: ['tabindex',] },] },
	    ]; };
	    MatSlideToggle.propDecorators = {
	        "name": [{ type: _angular_core.Input },],
	        "id": [{ type: _angular_core.Input },],
	        "labelPosition": [{ type: _angular_core.Input },],
	        "ariaLabel": [{ type: _angular_core.Input, args: ['aria-label',] },],
	        "ariaLabelledby": [{ type: _angular_core.Input, args: ['aria-labelledby',] },],
	        "required": [{ type: _angular_core.Input },],
	        "checked": [{ type: _angular_core.Input },],
	        "change": [{ type: _angular_core.Output },],
	        "_inputElement": [{ type: _angular_core.ViewChild, args: ['input',] },],
	        "_ripple": [{ type: _angular_core.ViewChild, args: [MatRipple,] },],
	    };
	    return MatSlideToggle;
	}(_MatSlideToggleMixinBase));
	/**
	 * Renderer for the Slide Toggle component, which separates DOM modification in its own class
	 */
	var SlideToggleRenderer = /** @class */ (function () {
	    function SlideToggleRenderer(elementRef, platform) {
	        /**
	         * Whether the thumb is currently being dragged.
	         */
	        this.dragging = false;
	        // We only need to interact with these elements when we're on the browser, so only grab
	        // the reference in that case.
	        if (platform.isBrowser) {
	            this._thumbEl = elementRef.nativeElement.querySelector('.mat-slide-toggle-thumb-container');
	            this._thumbBarEl = elementRef.nativeElement.querySelector('.mat-slide-toggle-bar');
	        }
	    }
	    /** Initializes the drag of the slide-toggle. */
	    /**
	     * Initializes the drag of the slide-toggle.
	     * @param {?} checked
	     * @return {?}
	     */
	    SlideToggleRenderer.prototype.startThumbDrag = /**
	     * Initializes the drag of the slide-toggle.
	     * @param {?} checked
	     * @return {?}
	     */
	    function (checked) {
	        if (this.dragging) {
	            return;
	        }
	        this._thumbBarWidth = this._thumbBarEl.clientWidth - this._thumbEl.clientWidth;
	        this._thumbEl.classList.add('mat-dragging');
	        this._previousChecked = checked;
	        this.dragging = true;
	    };
	    /** Resets the current drag and returns the new checked value. */
	    /**
	     * Resets the current drag and returns the new checked value.
	     * @return {?}
	     */
	    SlideToggleRenderer.prototype.stopThumbDrag = /**
	     * Resets the current drag and returns the new checked value.
	     * @return {?}
	     */
	    function () {
	        if (!this.dragging) {
	            return false;
	        }
	        this.dragging = false;
	        this._thumbEl.classList.remove('mat-dragging');
	        // Reset the transform because the component will take care of the thumb position after drag.
	        this._thumbEl.style.transform = '';
	        return this.dragPercentage > 50;
	    };
	    /** Updates the thumb containers position from the specified distance. */
	    /**
	     * Updates the thumb containers position from the specified distance.
	     * @param {?} distance
	     * @return {?}
	     */
	    SlideToggleRenderer.prototype.updateThumbPosition = /**
	     * Updates the thumb containers position from the specified distance.
	     * @param {?} distance
	     * @return {?}
	     */
	    function (distance) {
	        this.dragPercentage = this._getDragPercentage(distance);
	        // Calculate the moved distance based on the thumb bar width.
	        var /** @type {?} */ dragX = (this.dragPercentage / 100) * this._thumbBarWidth;
	        this._thumbEl.style.transform = "translate3d(" + dragX + "px, 0, 0)";
	    };
	    /**
	     * Retrieves the percentage of thumb from the moved distance. Percentage as fraction of 100.
	     * @param {?} distance
	     * @return {?}
	     */
	    SlideToggleRenderer.prototype._getDragPercentage = /**
	     * Retrieves the percentage of thumb from the moved distance. Percentage as fraction of 100.
	     * @param {?} distance
	     * @return {?}
	     */
	    function (distance) {
	        var /** @type {?} */ percentage = (distance / this._thumbBarWidth) * 100;
	        // When the toggle was initially checked, then we have to start the drag at the end.
	        if (this._previousChecked) {
	            percentage += 100;
	        }
	        return Math.max(0, Math.min(percentage, 100));
	    };
	    return SlideToggleRenderer;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatSlideToggleModule = /** @class */ (function () {
	    function MatSlideToggleModule() {
	    }
	    MatSlideToggleModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [MatRippleModule, MatCommonModule, _angular_cdk_platform.PlatformModule, _angular_cdk_observers.ObserversModule, _angular_cdk_a11y.A11yModule],
	                    exports: [MatSlideToggle, MatCommonModule],
	                    declarations: [MatSlideToggle],
	                    providers: [
	                        { provide: _angular_platformBrowser.HAMMER_GESTURE_CONFIG, useClass: GestureConfig }
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    MatSlideToggleModule.ctorParameters = function () { return []; };
	    return MatSlideToggleModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Visually, a 30px separation between tick marks looks best. This is very subjective but it is
	 * the default separation we chose.
	 */
	var MIN_AUTO_TICK_SEPARATION = 30;
	/**
	 * The thumb gap size for a disabled slider.
	 */
	var DISABLED_THUMB_GAP = 7;
	/**
	 * The thumb gap size for a non-active slider at its minimum value.
	 */
	var MIN_VALUE_NONACTIVE_THUMB_GAP = 7;
	/**
	 * The thumb gap size for an active slider at its minimum value.
	 */
	var MIN_VALUE_ACTIVE_THUMB_GAP = 10;
	/**
	 * Provider Expression that allows mat-slider to register as a ControlValueAccessor.
	 * This allows it to support [(ngModel)] and [formControl].
	 */
	var MAT_SLIDER_VALUE_ACCESSOR = {
	    provide: _angular_forms.NG_VALUE_ACCESSOR,
	    useExisting: _angular_core.forwardRef(function () { return MatSlider; }),
	    multi: true
	};
	/**
	 * A simple change event emitted by the MatSlider component.
	 */
	var MatSliderChange = /** @class */ (function () {
	    function MatSliderChange() {
	    }
	    return MatSliderChange;
	}());
	/**
	 * \@docs-private
	 */
	var MatSliderBase = /** @class */ (function () {
	    function MatSliderBase(_elementRef) {
	        this._elementRef = _elementRef;
	    }
	    return MatSliderBase;
	}());
	var _MatSliderMixinBase = mixinTabIndex(mixinColor(mixinDisabled(MatSliderBase), 'accent'));
	/**
	 * Allows users to select from a range of values by moving the slider thumb. It is similar in
	 * behavior to the native `<input type="range">` element.
	 */
	var MatSlider = /** @class */ (function (_super) {
	    __extends(MatSlider, _super);
	    function MatSlider(elementRef, _focusMonitor, _changeDetectorRef, _dir, tabIndex) {
	        var _this = _super.call(this, elementRef) || this;
	        _this._focusMonitor = _focusMonitor;
	        _this._changeDetectorRef = _changeDetectorRef;
	        _this._dir = _dir;
	        _this._invert = false;
	        _this._max = 100;
	        _this._min = 0;
	        _this._step = 1;
	        _this._thumbLabel = false;
	        _this._tickInterval = 0;
	        _this._value = null;
	        _this._vertical = false;
	        /**
	         * Event emitted when the slider value has changed.
	         */
	        _this.change = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when the slider thumb moves.
	         */
	        _this.input = new _angular_core.EventEmitter();
	        /**
	         * onTouch function registered via registerOnTouch (ControlValueAccessor).
	         */
	        _this.onTouched = function () { };
	        _this._percent = 0;
	        /**
	         * Whether or not the thumb is sliding.
	         * Used to determine if there should be a transition for the thumb and fill track.
	         */
	        _this._isSliding = false;
	        /**
	         * Whether or not the slider is active (clicked or sliding).
	         * Used to shrink and grow the thumb as according to the Material Design spec.
	         */
	        _this._isActive = false;
	        /**
	         * The size of a tick interval as a percentage of the size of the track.
	         */
	        _this._tickIntervalPercent = 0;
	        /**
	         * The dimensions of the slider.
	         */
	        _this._sliderDimensions = null;
	        _this._controlValueAccessorChangeFn = function () { };
	        /**
	         * Subscription to the Directionality change EventEmitter.
	         */
	        _this._dirChangeSubscription = rxjs_Subscription.Subscription.EMPTY;
	        _this.tabIndex = parseInt(tabIndex) || 0;
	        return _this;
	    }
	    Object.defineProperty(MatSlider.prototype, "invert", {
	        get: /**
	         * Whether the slider is inverted.
	         * @return {?}
	         */
	        function () { return this._invert; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._invert = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlider.prototype, "max", {
	        get: /**
	         * The maximum value that the slider can have.
	         * @return {?}
	         */
	        function () { return this._max; },
	        set: /**
	         * @param {?} v
	         * @return {?}
	         */
	        function (v) {
	            this._max = _angular_cdk_coercion.coerceNumberProperty(v, this._max);
	            this._percent = this._calculatePercentage(this._value);
	            // Since this also modifies the percentage, we need to let the change detection know.
	            this._changeDetectorRef.markForCheck();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlider.prototype, "min", {
	        get: /**
	         * The minimum value that the slider can have.
	         * @return {?}
	         */
	        function () { return this._min; },
	        set: /**
	         * @param {?} v
	         * @return {?}
	         */
	        function (v) {
	            this._min = _angular_cdk_coercion.coerceNumberProperty(v, this._min);
	            // If the value wasn't explicitly set by the user, set it to the min.
	            if (this._value === null) {
	                this.value = this._min;
	            }
	            this._percent = this._calculatePercentage(this._value);
	            // Since this also modifies the percentage, we need to let the change detection know.
	            this._changeDetectorRef.markForCheck();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlider.prototype, "step", {
	        get: /**
	         * The values at which the thumb will snap.
	         * @return {?}
	         */
	        function () { return this._step; },
	        set: /**
	         * @param {?} v
	         * @return {?}
	         */
	        function (v) {
	            this._step = _angular_cdk_coercion.coerceNumberProperty(v, this._step);
	            if (this._step % 1 !== 0) {
	                this._roundLabelTo = /** @type {?} */ ((this._step.toString().split('.').pop())).length;
	            }
	            // Since this could modify the label, we need to notify the change detection.
	            this._changeDetectorRef.markForCheck();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlider.prototype, "thumbLabel", {
	        get: /**
	         * Whether or not to show the thumb label.
	         * @return {?}
	         */
	        function () { return this._thumbLabel; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._thumbLabel = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlider.prototype, "_thumbLabelDeprecated", {
	        get: /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this._thumbLabel; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._thumbLabel = value; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlider.prototype, "tickInterval", {
	        get: /**
	         * How often to show ticks. Relative to the step so that a tick always appears on a step.
	         * Ex: Tick interval of 4 with a step of 3 will draw a tick every 4 steps (every 12 values).
	         * @return {?}
	         */
	        function () { return this._tickInterval; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (value === 'auto') {
	                this._tickInterval = 'auto';
	            }
	            else if (typeof value === 'number' || typeof value === 'string') {
	                this._tickInterval = _angular_cdk_coercion.coerceNumberProperty(value, /** @type {?} */ (this._tickInterval));
	            }
	            else {
	                this._tickInterval = 0;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlider.prototype, "_tickIntervalDeprecated", {
	        get: /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this.tickInterval; },
	        set: /**
	         * @param {?} v
	         * @return {?}
	         */
	        function (v) { this.tickInterval = v; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlider.prototype, "value", {
	        get: /**
	         * Value of the slider.
	         * @return {?}
	         */
	        function () {
	            // If the value needs to be read and it is still uninitialized, initialize it to the min.
	            if (this._value === null) {
	                this.value = this._min;
	            }
	            return this._value;
	        },
	        set: /**
	         * @param {?} v
	         * @return {?}
	         */
	        function (v) {
	            if (v !== this._value) {
	                this._value = _angular_cdk_coercion.coerceNumberProperty(v);
	                this._percent = this._calculatePercentage(this._value);
	                // Since this also modifies the percentage, we need to let the change detection know.
	                this._changeDetectorRef.markForCheck();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlider.prototype, "vertical", {
	        get: /**
	         * Whether the slider is vertical.
	         * @return {?}
	         */
	        function () { return this._vertical; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._vertical = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlider.prototype, "displayValue", {
	        /** The value to be used for display purposes. */
	        get: /**
	         * The value to be used for display purposes.
	         * @return {?}
	         */
	        function () {
	            // Note that this could be improved further by rounding something like 0.999 to 1 or
	            // 0.899 to 0.9, however it is very performance sensitive, because it gets called on
	            // every change detection cycle.
	            if (this._roundLabelTo && this.value && this.value % 1 !== 0) {
	                return this.value.toFixed(this._roundLabelTo);
	            }
	            return this.value || 0;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** set focus to the host element */
	    /**
	     * set focus to the host element
	     * @return {?}
	     */
	    MatSlider.prototype.focus = /**
	     * set focus to the host element
	     * @return {?}
	     */
	    function () {
	        this._focusHostElement();
	    };
	    /** blur the host element */
	    /**
	     * blur the host element
	     * @return {?}
	     */
	    MatSlider.prototype.blur = /**
	     * blur the host element
	     * @return {?}
	     */
	    function () {
	        this._blurHostElement();
	    };
	    Object.defineProperty(MatSlider.prototype, "percent", {
	        /** The percentage of the slider that coincides with the value. */
	        get: /**
	         * The percentage of the slider that coincides with the value.
	         * @return {?}
	         */
	        function () { return this._clamp(this._percent); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlider.prototype, "_invertAxis", {
	        /**
	         * Whether the axis of the slider is inverted.
	         * (i.e. whether moving the thumb in the positive x or y direction decreases the slider's value).
	         */
	        get: /**
	         * Whether the axis of the slider is inverted.
	         * (i.e. whether moving the thumb in the positive x or y direction decreases the slider's value).
	         * @return {?}
	         */
	        function () {
	            // Standard non-inverted mode for a vertical slider should be dragging the thumb from bottom to
	            // top. However from a y-axis standpoint this is inverted.
	            return this.vertical ? !this.invert : this.invert;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlider.prototype, "_isMinValue", {
	        /** Whether the slider is at its minimum value. */
	        get: /**
	         * Whether the slider is at its minimum value.
	         * @return {?}
	         */
	        function () {
	            return this.percent === 0;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlider.prototype, "_thumbGap", {
	        /**
	         * The amount of space to leave between the slider thumb and the track fill & track background
	         * elements.
	         */
	        get: /**
	         * The amount of space to leave between the slider thumb and the track fill & track background
	         * elements.
	         * @return {?}
	         */
	        function () {
	            if (this.disabled) {
	                return DISABLED_THUMB_GAP;
	            }
	            if (this._isMinValue && !this.thumbLabel) {
	                return this._isActive ? MIN_VALUE_ACTIVE_THUMB_GAP : MIN_VALUE_NONACTIVE_THUMB_GAP;
	            }
	            return 0;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlider.prototype, "_trackBackgroundStyles", {
	        /** CSS styles for the track background element. */
	        get: /**
	         * CSS styles for the track background element.
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ axis = this.vertical ? 'Y' : 'X';
	            var /** @type {?} */ sign = this._invertMouseCoords ? '-' : '';
	            return {
	                'transform': "translate" + axis + "(" + sign + this._thumbGap + "px) scale" + axis + "(" + (1 - this.percent) + ")"
	            };
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlider.prototype, "_trackFillStyles", {
	        /** CSS styles for the track fill element. */
	        get: /**
	         * CSS styles for the track fill element.
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ axis = this.vertical ? 'Y' : 'X';
	            var /** @type {?} */ sign = this._invertMouseCoords ? '' : '-';
	            return {
	                'transform': "translate" + axis + "(" + sign + this._thumbGap + "px) scale" + axis + "(" + this.percent + ")"
	            };
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlider.prototype, "_ticksContainerStyles", {
	        /** CSS styles for the ticks container element. */
	        get: /**
	         * CSS styles for the ticks container element.
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ axis = this.vertical ? 'Y' : 'X';
	            // For a horizontal slider in RTL languages we push the ticks container off the left edge
	            // instead of the right edge to avoid causing a horizontal scrollbar to appear.
	            var /** @type {?} */ sign = !this.vertical && this._direction == 'rtl' ? '' : '-';
	            var /** @type {?} */ offset = this._tickIntervalPercent / 2 * 100;
	            return {
	                'transform': "translate" + axis + "(" + sign + offset + "%)"
	            };
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlider.prototype, "_ticksStyles", {
	        /** CSS styles for the ticks element. */
	        get: /**
	         * CSS styles for the ticks element.
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ tickSize = this._tickIntervalPercent * 100;
	            var /** @type {?} */ backgroundSize = this.vertical ? "2px " + tickSize + "%" : tickSize + "% 2px";
	            var /** @type {?} */ axis = this.vertical ? 'Y' : 'X';
	            // Depending on the direction we pushed the ticks container, push the ticks the opposite
	            // direction to re-center them but clip off the end edge. In RTL languages we need to flip the
	            // ticks 180 degrees so we're really cutting off the end edge abd not the start.
	            var /** @type {?} */ sign = !this.vertical && this._direction == 'rtl' ? '-' : '';
	            var /** @type {?} */ rotate = !this.vertical && this._direction == 'rtl' ? ' rotate(180deg)' : '';
	            var /** @type {?} */ styles = {
	                'backgroundSize': backgroundSize,
	                // Without translateZ ticks sometimes jitter as the slider moves on Chrome & Firefox.
	                'transform': "translateZ(0) translate" + axis + "(" + sign + tickSize / 2 + "%)" + rotate
	            };
	            if (this._isMinValue && this._thumbGap) {
	                var /** @type {?} */ side = this.vertical ?
	                    (this._invertAxis ? 'Bottom' : 'Top') :
	                    (this._invertAxis ? 'Right' : 'Left');
	                styles["padding" + side] = this._thumbGap + "px";
	            }
	            return styles;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlider.prototype, "_thumbContainerStyles", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ axis = this.vertical ? 'Y' : 'X';
	            // For a horizontal slider in RTL languages we push the thumb container off the left edge
	            // instead of the right edge to avoid causing a horizontal scrollbar to appear.
	            var /** @type {?} */ invertOffset = (this._direction == 'rtl' && !this.vertical) ? !this._invertAxis : this._invertAxis;
	            var /** @type {?} */ offset = (invertOffset ? this.percent : 1 - this.percent) * 100;
	            return {
	                'transform': "translate" + axis + "(-" + offset + "%)"
	            };
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlider.prototype, "_invertMouseCoords", {
	        get: /**
	         * Whether mouse events should be converted to a slider position by calculating their distance
	         * from the right or bottom edge of the slider as opposed to the top or left.
	         * @return {?}
	         */
	        function () {
	            return (this._direction == 'rtl' && !this.vertical) ? !this._invertAxis : this._invertAxis;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSlider.prototype, "_direction", {
	        get: /**
	         * The language direction for this slider element.
	         * @return {?}
	         */
	        function () {
	            return (this._dir && this._dir.value == 'rtl') ? 'rtl' : 'ltr';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatSlider.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._focusMonitor
	            .monitor(this._elementRef.nativeElement, true)
	            .subscribe(function (origin) {
	            _this._isActive = !!origin && origin !== 'keyboard';
	            _this._changeDetectorRef.detectChanges();
	        });
	        if (this._dir) {
	            this._dirChangeSubscription = this._dir.change.subscribe(function () {
	                _this._changeDetectorRef.markForCheck();
	            });
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatSlider.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._focusMonitor.stopMonitoring(this._elementRef.nativeElement);
	        this._dirChangeSubscription.unsubscribe();
	    };
	    /**
	     * @return {?}
	     */
	    MatSlider.prototype._onMouseenter = /**
	     * @return {?}
	     */
	    function () {
	        if (this.disabled) {
	            return;
	        }
	        // We save the dimensions of the slider here so we can use them to update the spacing of the
	        // ticks and determine where on the slider click and slide events happen.
	        this._sliderDimensions = this._getSliderDimensions();
	        this._updateTickIntervalPercent();
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    MatSlider.prototype._onClick = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (this.disabled) {
	            return;
	        }
	        var /** @type {?} */ oldValue = this.value;
	        this._isSliding = false;
	        this._focusHostElement();
	        this._updateValueFromPosition({ x: event.clientX, y: event.clientY });
	        // Emit a change and input event if the value changed.
	        if (oldValue != this.value) {
	            this._emitInputEvent();
	            this._emitChangeEvent();
	        }
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    MatSlider.prototype._onSlide = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (this.disabled) {
	            return;
	        }
	        // The slide start event sometimes fails to fire on iOS, so if we're not already in the sliding
	        // state, call the slide start handler manually.
	        if (!this._isSliding) {
	            this._onSlideStart(null);
	        }
	        // Prevent the slide from selecting anything else.
	        event.preventDefault();
	        var /** @type {?} */ oldValue = this.value;
	        this._updateValueFromPosition({ x: event.center.x, y: event.center.y });
	        // Native range elements always emit `input` events when the value changed while sliding.
	        if (oldValue != this.value) {
	            this._emitInputEvent();
	        }
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    MatSlider.prototype._onSlideStart = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (this.disabled || this._isSliding) {
	            return;
	        }
	        // Simulate mouseenter in case this is a mobile device.
	        this._onMouseenter();
	        this._isSliding = true;
	        this._focusHostElement();
	        this._valueOnSlideStart = this.value;
	        if (event) {
	            this._updateValueFromPosition({ x: event.center.x, y: event.center.y });
	            event.preventDefault();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatSlider.prototype._onSlideEnd = /**
	     * @return {?}
	     */
	    function () {
	        this._isSliding = false;
	        if (this._valueOnSlideStart != this.value && !this.disabled) {
	            this._emitChangeEvent();
	        }
	        this._valueOnSlideStart = null;
	    };
	    /**
	     * @return {?}
	     */
	    MatSlider.prototype._onFocus = /**
	     * @return {?}
	     */
	    function () {
	        // We save the dimensions of the slider here so we can use them to update the spacing of the
	        // ticks and determine where on the slider click and slide events happen.
	        this._sliderDimensions = this._getSliderDimensions();
	        this._updateTickIntervalPercent();
	    };
	    /**
	     * @return {?}
	     */
	    MatSlider.prototype._onBlur = /**
	     * @return {?}
	     */
	    function () {
	        this.onTouched();
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    MatSlider.prototype._onKeydown = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (this.disabled) {
	            return;
	        }
	        var /** @type {?} */ oldValue = this.value;
	        switch (event.keyCode) {
	            case _angular_cdk_keycodes.PAGE_UP:
	                this._increment(10);
	                break;
	            case _angular_cdk_keycodes.PAGE_DOWN:
	                this._increment(-10);
	                break;
	            case _angular_cdk_keycodes.END:
	                this.value = this.max;
	                break;
	            case _angular_cdk_keycodes.HOME:
	                this.value = this.min;
	                break;
	            case _angular_cdk_keycodes.LEFT_ARROW:
	                // NOTE: For a sighted user it would make more sense that when they press an arrow key on an
	                // inverted slider the thumb moves in that direction. However for a blind user, nothing
	                // about the slider indicates that it is inverted. They will expect left to be decrement,
	                // regardless of how it appears on the screen. For speakers ofRTL languages, they probably
	                // expect left to mean increment. Therefore we flip the meaning of the side arrow keys for
	                // RTL. For inverted sliders we prefer a good a11y experience to having it "look right" for
	                // sighted users, therefore we do not swap the meaning.
	                this._increment(this._direction == 'rtl' ? 1 : -1);
	                break;
	            case _angular_cdk_keycodes.UP_ARROW:
	                this._increment(1);
	                break;
	            case _angular_cdk_keycodes.RIGHT_ARROW:
	                // See comment on LEFT_ARROW about the conditions under which we flip the meaning.
	                this._increment(this._direction == 'rtl' ? -1 : 1);
	                break;
	            case _angular_cdk_keycodes.DOWN_ARROW:
	                this._increment(-1);
	                break;
	            default:
	                // Return if the key is not one that we explicitly handle to avoid calling preventDefault on
	                // it.
	                return;
	        }
	        if (oldValue != this.value) {
	            this._emitInputEvent();
	            this._emitChangeEvent();
	        }
	        this._isSliding = true;
	        event.preventDefault();
	    };
	    /**
	     * @return {?}
	     */
	    MatSlider.prototype._onKeyup = /**
	     * @return {?}
	     */
	    function () {
	        this._isSliding = false;
	    };
	    /**
	     * Increments the slider by the given number of steps (negative number decrements).
	     * @param {?} numSteps
	     * @return {?}
	     */
	    MatSlider.prototype._increment = /**
	     * Increments the slider by the given number of steps (negative number decrements).
	     * @param {?} numSteps
	     * @return {?}
	     */
	    function (numSteps) {
	        this.value = this._clamp((this.value || 0) + this.step * numSteps, this.min, this.max);
	    };
	    /**
	     * Calculate the new value from the new physical location. The value will always be snapped.
	     * @param {?} pos
	     * @return {?}
	     */
	    MatSlider.prototype._updateValueFromPosition = /**
	     * Calculate the new value from the new physical location. The value will always be snapped.
	     * @param {?} pos
	     * @return {?}
	     */
	    function (pos) {
	        if (!this._sliderDimensions) {
	            return;
	        }
	        var /** @type {?} */ offset = this.vertical ? this._sliderDimensions.top : this._sliderDimensions.left;
	        var /** @type {?} */ size = this.vertical ? this._sliderDimensions.height : this._sliderDimensions.width;
	        var /** @type {?} */ posComponent = this.vertical ? pos.y : pos.x;
	        // The exact value is calculated from the event and used to find the closest snap value.
	        var /** @type {?} */ percent = this._clamp((posComponent - offset) / size);
	        if (this._invertMouseCoords) {
	            percent = 1 - percent;
	        }
	        var /** @type {?} */ exactValue = this._calculateValue(percent);
	        // This calculation finds the closest step by finding the closest whole number divisible by the
	        // step relative to the min.
	        var /** @type {?} */ closestValue = Math.round((exactValue - this.min) / this.step) * this.step + this.min;
	        // The value needs to snap to the min and max.
	        this.value = this._clamp(closestValue, this.min, this.max);
	    };
	    /**
	     * Emits a change event if the current value is different from the last emitted value.
	     * @return {?}
	     */
	    MatSlider.prototype._emitChangeEvent = /**
	     * Emits a change event if the current value is different from the last emitted value.
	     * @return {?}
	     */
	    function () {
	        this._controlValueAccessorChangeFn(this.value);
	        this.change.emit(this._createChangeEvent());
	    };
	    /**
	     * Emits an input event when the current value is different from the last emitted value.
	     * @return {?}
	     */
	    MatSlider.prototype._emitInputEvent = /**
	     * Emits an input event when the current value is different from the last emitted value.
	     * @return {?}
	     */
	    function () {
	        this.input.emit(this._createChangeEvent());
	    };
	    /**
	     * Updates the amount of space between ticks as a percentage of the width of the slider.
	     * @return {?}
	     */
	    MatSlider.prototype._updateTickIntervalPercent = /**
	     * Updates the amount of space between ticks as a percentage of the width of the slider.
	     * @return {?}
	     */
	    function () {
	        if (!this.tickInterval || !this._sliderDimensions) {
	            return;
	        }
	        if (this.tickInterval == 'auto') {
	            var /** @type {?} */ trackSize = this.vertical ? this._sliderDimensions.height : this._sliderDimensions.width;
	            var /** @type {?} */ pixelsPerStep = trackSize * this.step / (this.max - this.min);
	            var /** @type {?} */ stepsPerTick = Math.ceil(MIN_AUTO_TICK_SEPARATION / pixelsPerStep);
	            var /** @type {?} */ pixelsPerTick = stepsPerTick * this.step;
	            this._tickIntervalPercent = pixelsPerTick / trackSize;
	        }
	        else {
	            this._tickIntervalPercent = this.tickInterval * this.step / (this.max - this.min);
	        }
	    };
	    /**
	     * Creates a slider change object from the specified value.
	     * @param {?=} value
	     * @return {?}
	     */
	    MatSlider.prototype._createChangeEvent = /**
	     * Creates a slider change object from the specified value.
	     * @param {?=} value
	     * @return {?}
	     */
	    function (value) {
	        if (value === void 0) { value = this.value; }
	        var /** @type {?} */ event = new MatSliderChange();
	        event.source = this;
	        event.value = value;
	        return event;
	    };
	    /**
	     * Calculates the percentage of the slider that a value is.
	     * @param {?} value
	     * @return {?}
	     */
	    MatSlider.prototype._calculatePercentage = /**
	     * Calculates the percentage of the slider that a value is.
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        return ((value || 0) - this.min) / (this.max - this.min);
	    };
	    /**
	     * Calculates the value a percentage of the slider corresponds to.
	     * @param {?} percentage
	     * @return {?}
	     */
	    MatSlider.prototype._calculateValue = /**
	     * Calculates the value a percentage of the slider corresponds to.
	     * @param {?} percentage
	     * @return {?}
	     */
	    function (percentage) {
	        return this.min + percentage * (this.max - this.min);
	    };
	    /**
	     * Return a number between two numbers.
	     * @param {?} value
	     * @param {?=} min
	     * @param {?=} max
	     * @return {?}
	     */
	    MatSlider.prototype._clamp = /**
	     * Return a number between two numbers.
	     * @param {?} value
	     * @param {?=} min
	     * @param {?=} max
	     * @return {?}
	     */
	    function (value, min, max) {
	        if (min === void 0) { min = 0; }
	        if (max === void 0) { max = 1; }
	        return Math.max(min, Math.min(value, max));
	    };
	    /**
	     * Get the bounding client rect of the slider track element.
	     * The track is used rather than the native element to ignore the extra space that the thumb can
	     * take up.
	     * @return {?}
	     */
	    MatSlider.prototype._getSliderDimensions = /**
	     * Get the bounding client rect of the slider track element.
	     * The track is used rather than the native element to ignore the extra space that the thumb can
	     * take up.
	     * @return {?}
	     */
	    function () {
	        return this._sliderWrapper ? this._sliderWrapper.nativeElement.getBoundingClientRect() : null;
	    };
	    /**
	     * Focuses the native element.
	     * Currently only used to allow a blur event to fire but will be used with keyboard input later.
	     * @return {?}
	     */
	    MatSlider.prototype._focusHostElement = /**
	     * Focuses the native element.
	     * Currently only used to allow a blur event to fire but will be used with keyboard input later.
	     * @return {?}
	     */
	    function () {
	        this._elementRef.nativeElement.focus();
	    };
	    /**
	     * Blurs the native element.
	     * @return {?}
	     */
	    MatSlider.prototype._blurHostElement = /**
	     * Blurs the native element.
	     * @return {?}
	     */
	    function () {
	        this._elementRef.nativeElement.blur();
	    };
	    /**
	     * Sets the model value. Implemented as part of ControlValueAccessor.
	     * @param value
	     */
	    /**
	     * Sets the model value. Implemented as part of ControlValueAccessor.
	     * @param {?} value
	     * @return {?}
	     */
	    MatSlider.prototype.writeValue = /**
	     * Sets the model value. Implemented as part of ControlValueAccessor.
	     * @param {?} value
	     * @return {?}
	     */
	    function (value) {
	        this.value = value;
	    };
	    /**
	     * Registers a callback to eb triggered when the value has changed.
	     * Implemented as part of ControlValueAccessor.
	     * @param fn Callback to be registered.
	     */
	    /**
	     * Registers a callback to eb triggered when the value has changed.
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} fn Callback to be registered.
	     * @return {?}
	     */
	    MatSlider.prototype.registerOnChange = /**
	     * Registers a callback to eb triggered when the value has changed.
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} fn Callback to be registered.
	     * @return {?}
	     */
	    function (fn) {
	        this._controlValueAccessorChangeFn = fn;
	    };
	    /**
	     * Registers a callback to be triggered when the component is touched.
	     * Implemented as part of ControlValueAccessor.
	     * @param fn Callback to be registered.
	     */
	    /**
	     * Registers a callback to be triggered when the component is touched.
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} fn Callback to be registered.
	     * @return {?}
	     */
	    MatSlider.prototype.registerOnTouched = /**
	     * Registers a callback to be triggered when the component is touched.
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} fn Callback to be registered.
	     * @return {?}
	     */
	    function (fn) {
	        this.onTouched = fn;
	    };
	    /**
	     * Sets whether the component should be disabled.
	     * Implemented as part of ControlValueAccessor.
	     * @param isDisabled
	     */
	    /**
	     * Sets whether the component should be disabled.
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    MatSlider.prototype.setDisabledState = /**
	     * Sets whether the component should be disabled.
	     * Implemented as part of ControlValueAccessor.
	     * @param {?} isDisabled
	     * @return {?}
	     */
	    function (isDisabled) {
	        this.disabled = isDisabled;
	    };
	    MatSlider.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-slider',
	                    exportAs: 'matSlider',
	                    providers: [MAT_SLIDER_VALUE_ACCESSOR],
	                    host: {
	                        '(focus)': '_onFocus()',
	                        '(blur)': '_onBlur()',
	                        '(click)': '_onClick($event)',
	                        '(keydown)': '_onKeydown($event)',
	                        '(keyup)': '_onKeyup()',
	                        '(mouseenter)': '_onMouseenter()',
	                        '(slide)': '_onSlide($event)',
	                        '(slideend)': '_onSlideEnd()',
	                        '(slidestart)': '_onSlideStart($event)',
	                        'class': 'mat-slider',
	                        'role': 'slider',
	                        '[tabIndex]': 'tabIndex',
	                        '[attr.aria-disabled]': 'disabled',
	                        '[attr.aria-valuemax]': 'max',
	                        '[attr.aria-valuemin]': 'min',
	                        '[attr.aria-valuenow]': 'value',
	                        '[attr.aria-orientation]': 'vertical ? "vertical" : "horizontal"',
	                        '[class.mat-slider-disabled]': 'disabled',
	                        '[class.mat-slider-has-ticks]': 'tickInterval',
	                        '[class.mat-slider-horizontal]': '!vertical',
	                        '[class.mat-slider-axis-inverted]': '_invertAxis',
	                        '[class.mat-slider-sliding]': '_isSliding',
	                        '[class.mat-slider-thumb-label-showing]': 'thumbLabel',
	                        '[class.mat-slider-vertical]': 'vertical',
	                        '[class.mat-slider-min-value]': '_isMinValue',
	                        '[class.mat-slider-hide-last-tick]': 'disabled || _isMinValue && _thumbGap && _invertAxis',
	                    },
	                    template: "<div class=\"mat-slider-wrapper\" #sliderWrapper><div class=\"mat-slider-track-wrapper\"><div class=\"mat-slider-track-background\" [ngStyle]=\"_trackBackgroundStyles\"></div><div class=\"mat-slider-track-fill\" [ngStyle]=\"_trackFillStyles\"></div></div><div class=\"mat-slider-ticks-container\" [ngStyle]=\"_ticksContainerStyles\"><div class=\"mat-slider-ticks\" [ngStyle]=\"_ticksStyles\"></div></div><div class=\"mat-slider-thumb-container\" [ngStyle]=\"_thumbContainerStyles\"><div class=\"mat-slider-focus-ring\"></div><div class=\"mat-slider-thumb\"></div><div class=\"mat-slider-thumb-label\"><span class=\"mat-slider-thumb-label-text\">{{displayValue}}</span></div></div></div>",
	                    styles: [".mat-slider{display:inline-block;position:relative;box-sizing:border-box;padding:8px;outline:0;vertical-align:middle}.mat-slider-wrapper{position:absolute}.mat-slider-track-wrapper{position:absolute;top:0;left:0;overflow:hidden}.mat-slider-track-fill{position:absolute;transform-origin:0 0;transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-track-background{position:absolute;transform-origin:100% 100%;transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-ticks-container{position:absolute;left:0;top:0;overflow:hidden}.mat-slider-ticks{background-repeat:repeat;background-clip:content-box;box-sizing:border-box;opacity:0;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-thumb-container{position:absolute;z-index:1;transition:transform .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-focus-ring{position:absolute;width:30px;height:30px;border-radius:50%;transform:scale(0);opacity:0;transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1),opacity .4s cubic-bezier(.25,.8,.25,1)}.cdk-keyboard-focused .mat-slider-focus-ring,.cdk-program-focused .mat-slider-focus-ring{transform:scale(1);opacity:1}.mat-slider:not(.mat-slider-disabled) .mat-slider-thumb,.mat-slider:not(.mat-slider-disabled) .mat-slider-thumb-label{cursor:-webkit-grab;cursor:grab}.mat-slider-sliding:not(.mat-slider-disabled) .mat-slider-thumb,.mat-slider-sliding:not(.mat-slider-disabled) .mat-slider-thumb-label,.mat-slider:not(.mat-slider-disabled) .mat-slider-thumb-label:active,.mat-slider:not(.mat-slider-disabled) .mat-slider-thumb:active{cursor:-webkit-grabbing;cursor:grabbing}.mat-slider-thumb{position:absolute;right:-10px;bottom:-10px;box-sizing:border-box;width:20px;height:20px;border:3px solid transparent;border-radius:50%;transform:scale(.7);transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1),border-color .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-thumb-label{display:none;align-items:center;justify-content:center;position:absolute;width:28px;height:28px;border-radius:50%;transition:transform .4s cubic-bezier(.25,.8,.25,1),border-radius .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-thumb-label-text{z-index:1;opacity:0;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-sliding .mat-slider-thumb-container,.mat-slider-sliding .mat-slider-track-background,.mat-slider-sliding .mat-slider-track-fill{transition-duration:0s}.mat-slider-has-ticks .mat-slider-wrapper::after{content:'';position:absolute;border-width:0;border-style:solid;opacity:0;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-has-ticks.cdk-focused:not(.mat-slider-hide-last-tick) .mat-slider-wrapper::after,.mat-slider-has-ticks:hover:not(.mat-slider-hide-last-tick) .mat-slider-wrapper::after{opacity:1}.mat-slider-has-ticks.cdk-focused:not(.mat-slider-disabled) .mat-slider-ticks,.mat-slider-has-ticks:hover:not(.mat-slider-disabled) .mat-slider-ticks{opacity:1}.mat-slider-thumb-label-showing .mat-slider-focus-ring{transform:scale(0);opacity:0}.mat-slider-thumb-label-showing .mat-slider-thumb-label{display:flex}.mat-slider-axis-inverted .mat-slider-track-fill{transform-origin:100% 100%}.mat-slider-axis-inverted .mat-slider-track-background{transform-origin:0 0}.mat-slider:not(.mat-slider-disabled).cdk-focused.mat-slider-thumb-label-showing .mat-slider-thumb{transform:scale(0)}.mat-slider:not(.mat-slider-disabled).cdk-focused .mat-slider-thumb-label{border-radius:50% 50% 0}.mat-slider:not(.mat-slider-disabled).cdk-focused .mat-slider-thumb-label-text{opacity:1}.mat-slider:not(.mat-slider-disabled).cdk-mouse-focused .mat-slider-thumb,.mat-slider:not(.mat-slider-disabled).cdk-program-focused .mat-slider-thumb,.mat-slider:not(.mat-slider-disabled).cdk-touch-focused .mat-slider-thumb{border-width:2px;transform:scale(1)}.mat-slider-disabled .mat-slider-focus-ring{transform:scale(0);opacity:0}.mat-slider-disabled .mat-slider-thumb{border-width:4px;transform:scale(.5)}.mat-slider-disabled .mat-slider-thumb-label{display:none}.mat-slider-horizontal{height:48px;min-width:128px}.mat-slider-horizontal .mat-slider-wrapper{height:2px;top:23px;left:8px;right:8px}.mat-slider-horizontal .mat-slider-wrapper::after{height:2px;border-left-width:2px;right:0;top:0}.mat-slider-horizontal .mat-slider-track-wrapper{height:2px;width:100%}.mat-slider-horizontal .mat-slider-track-fill{height:2px;width:100%;transform:scaleX(0)}.mat-slider-horizontal .mat-slider-track-background{height:2px;width:100%;transform:scaleX(1)}.mat-slider-horizontal .mat-slider-ticks-container{height:2px;width:100%}@media screen and (-ms-high-contrast:active){.mat-slider-horizontal .mat-slider-ticks-container{height:0;outline:solid 2px;top:1px}}.mat-slider-horizontal .mat-slider-ticks{height:2px;width:100%}.mat-slider-horizontal .mat-slider-thumb-container{width:100%;height:0;top:50%}.mat-slider-horizontal .mat-slider-focus-ring{top:-15px;right:-15px}.mat-slider-horizontal .mat-slider-thumb-label{right:-14px;top:-40px;transform:translateY(26px) scale(.01) rotate(45deg)}.mat-slider-horizontal .mat-slider-thumb-label-text{transform:rotate(-45deg)}.mat-slider-horizontal.cdk-focused .mat-slider-thumb-label{transform:rotate(45deg)}.mat-slider-vertical{width:48px;min-height:128px}.mat-slider-vertical .mat-slider-wrapper{width:2px;top:8px;bottom:8px;left:23px}.mat-slider-vertical .mat-slider-wrapper::after{width:2px;border-top-width:2px;bottom:0;left:0}.mat-slider-vertical .mat-slider-track-wrapper{height:100%;width:2px}.mat-slider-vertical .mat-slider-track-fill{height:100%;width:2px;transform:scaleY(0)}.mat-slider-vertical .mat-slider-track-background{height:100%;width:2px;transform:scaleY(1)}.mat-slider-vertical .mat-slider-ticks-container{width:2px;height:100%}@media screen and (-ms-high-contrast:active){.mat-slider-vertical .mat-slider-ticks-container{width:0;outline:solid 2px;left:1px}}.mat-slider-vertical .mat-slider-focus-ring{bottom:-15px;left:-15px}.mat-slider-vertical .mat-slider-ticks{width:2px;height:100%}.mat-slider-vertical .mat-slider-thumb-container{height:100%;width:0;left:50%}.mat-slider-vertical .mat-slider-thumb{-webkit-backface-visibility:hidden;backface-visibility:hidden}.mat-slider-vertical .mat-slider-thumb-label{bottom:-14px;left:-40px;transform:translateX(26px) scale(.01) rotate(-45deg)}.mat-slider-vertical .mat-slider-thumb-label-text{transform:rotate(45deg)}.mat-slider-vertical.cdk-focused .mat-slider-thumb-label{transform:rotate(-45deg)}[dir=rtl] .mat-slider-wrapper::after{left:0;right:auto}[dir=rtl] .mat-slider-horizontal .mat-slider-track-fill{transform-origin:100% 100%}[dir=rtl] .mat-slider-horizontal .mat-slider-track-background{transform-origin:0 0}[dir=rtl] .mat-slider-horizontal.mat-slider-axis-inverted .mat-slider-track-fill{transform-origin:0 0}[dir=rtl] .mat-slider-horizontal.mat-slider-axis-inverted .mat-slider-track-background{transform-origin:100% 100%}"],
	                    inputs: ['disabled', 'color', 'tabIndex'],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatSlider.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_a11y.FocusMonitor, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: _angular_cdk_bidi.Directionality, decorators: [{ type: _angular_core.Optional },] },
	        { type: undefined, decorators: [{ type: _angular_core.Attribute, args: ['tabindex',] },] },
	    ]; };
	    MatSlider.propDecorators = {
	        "invert": [{ type: _angular_core.Input },],
	        "max": [{ type: _angular_core.Input },],
	        "min": [{ type: _angular_core.Input },],
	        "step": [{ type: _angular_core.Input },],
	        "thumbLabel": [{ type: _angular_core.Input },],
	        "_thumbLabelDeprecated": [{ type: _angular_core.Input, args: ['thumb-label',] },],
	        "tickInterval": [{ type: _angular_core.Input },],
	        "_tickIntervalDeprecated": [{ type: _angular_core.Input, args: ['tick-interval',] },],
	        "value": [{ type: _angular_core.Input },],
	        "vertical": [{ type: _angular_core.Input },],
	        "change": [{ type: _angular_core.Output },],
	        "input": [{ type: _angular_core.Output },],
	        "_sliderWrapper": [{ type: _angular_core.ViewChild, args: ['sliderWrapper',] },],
	    };
	    return MatSlider;
	}(_MatSliderMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatSliderModule = /** @class */ (function () {
	    function MatSliderModule() {
	    }
	    MatSliderModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [_angular_common.CommonModule, MatCommonModule, _angular_cdk_bidi.BidiModule, _angular_cdk_a11y.A11yModule],
	                    exports: [MatSlider, MatCommonModule],
	                    declarations: [MatSlider],
	                    providers: [{ provide: _angular_platformBrowser.HAMMER_GESTURE_CONFIG, useClass: GestureConfig }]
	                },] },
	    ];
	    /** @nocollapse */
	    MatSliderModule.ctorParameters = function () { return []; };
	    return MatSliderModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Event that is emitted when a snack bar is dismissed.
	 * @record
	 */
	
	/**
	 * Reference to a snack bar dispatched from the snack bar service.
	 */
	var MatSnackBarRef = /** @class */ (function () {
	    function MatSnackBarRef(containerInstance, _overlayRef) {
	        var _this = this;
	        this._overlayRef = _overlayRef;
	        /**
	         * Subject for notifying the user that the snack bar has been dismissed.
	         */
	        this._afterDismissed = new rxjs_Subject.Subject();
	        /**
	         * Subject for notifying the user that the snack bar has opened and appeared.
	         */
	        this._afterOpened = new rxjs_Subject.Subject();
	        /**
	         * Subject for notifying the user that the snack bar action was called.
	         */
	        this._onAction = new rxjs_Subject.Subject();
	        /**
	         * Whether the snack bar was dismissed using the action button.
	         */
	        this._dismissedByAction = false;
	        this.containerInstance = containerInstance;
	        // Dismiss snackbar on action.
	        this.onAction().subscribe(function () { return _this.dismiss(); });
	        containerInstance._onExit.subscribe(function () { return _this._finishDismiss(); });
	    }
	    /** Dismisses the snack bar. */
	    /**
	     * Dismisses the snack bar.
	     * @return {?}
	     */
	    MatSnackBarRef.prototype.dismiss = /**
	     * Dismisses the snack bar.
	     * @return {?}
	     */
	    function () {
	        if (!this._afterDismissed.closed) {
	            this.containerInstance.exit();
	        }
	        clearTimeout(this._durationTimeoutId);
	    };
	    /** Marks the snackbar action clicked. */
	    /**
	     * Marks the snackbar action clicked.
	     * @return {?}
	     */
	    MatSnackBarRef.prototype.dismissWithAction = /**
	     * Marks the snackbar action clicked.
	     * @return {?}
	     */
	    function () {
	        if (!this._onAction.closed) {
	            this._dismissedByAction = true;
	            this._onAction.next();
	            this._onAction.complete();
	        }
	    };
	    /**
	     * Marks the snackbar action clicked.
	     * @deprecated Use `dismissWithAction` instead.
	     * @deletion-target 7.0.0
	     */
	    /**
	     * Marks the snackbar action clicked.
	     * @deprecated Use `dismissWithAction` instead.
	     * \@deletion-target 7.0.0
	     * @return {?}
	     */
	    MatSnackBarRef.prototype.closeWithAction = /**
	     * Marks the snackbar action clicked.
	     * @deprecated Use `dismissWithAction` instead.
	     * \@deletion-target 7.0.0
	     * @return {?}
	     */
	    function () {
	        this.dismissWithAction();
	    };
	    /** Dismisses the snack bar after some duration */
	    /**
	     * Dismisses the snack bar after some duration
	     * @param {?} duration
	     * @return {?}
	     */
	    MatSnackBarRef.prototype._dismissAfter = /**
	     * Dismisses the snack bar after some duration
	     * @param {?} duration
	     * @return {?}
	     */
	    function (duration) {
	        var _this = this;
	        this._durationTimeoutId = setTimeout(function () { return _this.dismiss(); }, duration);
	    };
	    /** Marks the snackbar as opened */
	    /**
	     * Marks the snackbar as opened
	     * @return {?}
	     */
	    MatSnackBarRef.prototype._open = /**
	     * Marks the snackbar as opened
	     * @return {?}
	     */
	    function () {
	        if (!this._afterOpened.closed) {
	            this._afterOpened.next();
	            this._afterOpened.complete();
	        }
	    };
	    /**
	     * Cleans up the DOM after closing.
	     * @return {?}
	     */
	    MatSnackBarRef.prototype._finishDismiss = /**
	     * Cleans up the DOM after closing.
	     * @return {?}
	     */
	    function () {
	        this._overlayRef.dispose();
	        if (!this._onAction.closed) {
	            this._onAction.complete();
	        }
	        this._afterDismissed.next({ dismissedByAction: this._dismissedByAction });
	        this._afterDismissed.complete();
	        this._dismissedByAction = false;
	    };
	    /** Gets an observable that is notified when the snack bar is finished closing. */
	    /**
	     * Gets an observable that is notified when the snack bar is finished closing.
	     * @return {?}
	     */
	    MatSnackBarRef.prototype.afterDismissed = /**
	     * Gets an observable that is notified when the snack bar is finished closing.
	     * @return {?}
	     */
	    function () {
	        return this._afterDismissed.asObservable();
	    };
	    /** Gets an observable that is notified when the snack bar has opened and appeared. */
	    /**
	     * Gets an observable that is notified when the snack bar has opened and appeared.
	     * @return {?}
	     */
	    MatSnackBarRef.prototype.afterOpened = /**
	     * Gets an observable that is notified when the snack bar has opened and appeared.
	     * @return {?}
	     */
	    function () {
	        return this.containerInstance._onEnter;
	    };
	    /** Gets an observable that is notified when the snack bar action is called. */
	    /**
	     * Gets an observable that is notified when the snack bar action is called.
	     * @return {?}
	     */
	    MatSnackBarRef.prototype.onAction = /**
	     * Gets an observable that is notified when the snack bar action is called.
	     * @return {?}
	     */
	    function () {
	        return this._onAction.asObservable();
	    };
	    return MatSnackBarRef;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Injection token that can be used to access the data that was passed in to a snack bar.
	 */
	var MAT_SNACK_BAR_DATA = new _angular_core.InjectionToken('MatSnackBarData');
	/**
	 * Configuration used when opening a snack-bar.
	 */
	var MatSnackBarConfig = /** @class */ (function () {
	    function MatSnackBarConfig() {
	        /**
	         * The politeness level for the MatAriaLiveAnnouncer announcement.
	         */
	        this.politeness = 'assertive';
	        /**
	         * Message to be announced by the MatAriaLiveAnnouncer
	         */
	        this.announcementMessage = '';
	        /**
	         * The length of time in milliseconds to wait before automatically dismissing the snack bar.
	         */
	        this.duration = 0;
	        /**
	         * Text layout direction for the snack bar.
	         */
	        this.direction = 'ltr';
	        /**
	         * Data being injected into the child component.
	         */
	        this.data = null;
	        /**
	         * The horizontal position to place the snack bar.
	         */
	        this.horizontalPosition = 'center';
	        /**
	         * The vertical position to place the snack bar.
	         */
	        this.verticalPosition = 'bottom';
	    }
	    return MatSnackBarConfig;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * \@docs-private
	 */
	var SHOW_ANIMATION = AnimationDurations.ENTERING + " " + AnimationCurves.DECELERATION_CURVE;
	/**
	 * \@docs-private
	 */
	var HIDE_ANIMATION = AnimationDurations.EXITING + " " + AnimationCurves.ACCELERATION_CURVE;
	/**
	 * Animations used by the Material snack bar.
	 */
	var matSnackBarAnimations = {
	    /** Animation that slides the dialog in and out of view and fades the opacity. */
	    contentFade: _angular_animations.trigger('contentFade', [
	        _angular_animations.transition(':enter', [
	            _angular_animations.style({ opacity: '0' }),
	            _angular_animations.animate(AnimationDurations.COMPLEX + " " + AnimationCurves.STANDARD_CURVE)
	        ])
	    ]),
	    /** Animation that shows and hides a snack bar. */
	    snackBarState: _angular_animations.trigger('state', [
	        _angular_animations.state('visible-top, visible-bottom', _angular_animations.style({ transform: 'translateY(0%)' })),
	        _angular_animations.transition('visible-top => hidden-top, visible-bottom => hidden-bottom', _angular_animations.animate(HIDE_ANIMATION)),
	        _angular_animations.transition('void => visible-top, void => visible-bottom', _angular_animations.animate(SHOW_ANIMATION)),
	    ])
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * A component used to open as the default snack bar, matching material spec.
	 * This should only be used internally by the snack bar service.
	 */
	var SimpleSnackBar = /** @class */ (function () {
	    function SimpleSnackBar(snackBarRef, data) {
	        this.snackBarRef = snackBarRef;
	        this.data = data;
	    }
	    /** Performs the action on the snack bar. */
	    /**
	     * Performs the action on the snack bar.
	     * @return {?}
	     */
	    SimpleSnackBar.prototype.action = /**
	     * Performs the action on the snack bar.
	     * @return {?}
	     */
	    function () {
	        this.snackBarRef.dismissWithAction();
	    };
	    Object.defineProperty(SimpleSnackBar.prototype, "hasAction", {
	        /** If the action button should be shown. */
	        get: /**
	         * If the action button should be shown.
	         * @return {?}
	         */
	        function () {
	            return !!this.data.action;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SimpleSnackBar.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'simple-snack-bar',
	                    template: "{{data.message}} <button class=\"mat-simple-snackbar-action\" *ngIf=\"hasAction\" (click)=\"action()\">{{data.action}}</button>",
	                    styles: [".mat-simple-snackbar{display:flex;justify-content:space-between;line-height:20px;opacity:1}.mat-simple-snackbar-action{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;background:0 0;flex-shrink:0;margin-left:48px}[dir=rtl] .mat-simple-snackbar-action{margin-right:48px;margin-left:0}"],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    animations: [matSnackBarAnimations.contentFade],
	                    host: {
	                        '[@contentFade]': '',
	                        'class': 'mat-simple-snackbar',
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    SimpleSnackBar.ctorParameters = function () { return [
	        { type: MatSnackBarRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [MAT_SNACK_BAR_DATA,] },] },
	    ]; };
	    return SimpleSnackBar;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Internal component that wraps user-provided snack bar content.
	 * \@docs-private
	 */
	var MatSnackBarContainer = /** @class */ (function (_super) {
	    __extends(MatSnackBarContainer, _super);
	    function MatSnackBarContainer(_ngZone, _elementRef, _changeDetectorRef) {
	        var _this = _super.call(this) || this;
	        _this._ngZone = _ngZone;
	        _this._elementRef = _elementRef;
	        _this._changeDetectorRef = _changeDetectorRef;
	        /**
	         * Whether the component has been destroyed.
	         */
	        _this._destroyed = false;
	        /**
	         * Subject for notifying that the snack bar has exited from view.
	         */
	        _this._onExit = new rxjs_Subject.Subject();
	        /**
	         * Subject for notifying that the snack bar has finished entering the view.
	         */
	        _this._onEnter = new rxjs_Subject.Subject();
	        /**
	         * The state of the snack bar animations.
	         */
	        _this._animationState = 'void';
	        return _this;
	    }
	    /** Attach a component portal as content to this snack bar container. */
	    /**
	     * Attach a component portal as content to this snack bar container.
	     * @template T
	     * @param {?} portal
	     * @return {?}
	     */
	    MatSnackBarContainer.prototype.attachComponentPortal = /**
	     * Attach a component portal as content to this snack bar container.
	     * @template T
	     * @param {?} portal
	     * @return {?}
	     */
	    function (portal) {
	        if (this._portalOutlet.hasAttached()) {
	            throw Error('Attempting to attach snack bar content after content is already attached');
	        }
	        var /** @type {?} */ element = this._elementRef.nativeElement;
	        if (this.snackBarConfig.panelClass || this.snackBarConfig.extraClasses) {
	            this._setCssClasses(this.snackBarConfig.panelClass);
	            this._setCssClasses(this.snackBarConfig.extraClasses);
	        }
	        if (this.snackBarConfig.horizontalPosition === 'center') {
	            element.classList.add('mat-snack-bar-center');
	        }
	        if (this.snackBarConfig.verticalPosition === 'top') {
	            element.classList.add('mat-snack-bar-top');
	        }
	        return this._portalOutlet.attachComponentPortal(portal);
	    };
	    /** Attach a template portal as content to this snack bar container. */
	    /**
	     * Attach a template portal as content to this snack bar container.
	     * @return {?}
	     */
	    MatSnackBarContainer.prototype.attachTemplatePortal = /**
	     * Attach a template portal as content to this snack bar container.
	     * @return {?}
	     */
	    function () {
	        throw Error('Not yet implemented');
	    };
	    /** Handle end of animations, updating the state of the snackbar. */
	    /**
	     * Handle end of animations, updating the state of the snackbar.
	     * @param {?} event
	     * @return {?}
	     */
	    MatSnackBarContainer.prototype.onAnimationEnd = /**
	     * Handle end of animations, updating the state of the snackbar.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var fromState = event.fromState, toState = event.toState;
	        if ((toState === 'void' && fromState !== 'void') || toState.startsWith('hidden')) {
	            this._completeExit();
	        }
	        if (toState.startsWith('visible')) {
	            // Note: we shouldn't use `this` inside the zone callback,
	            // because it can cause a memory leak.
	            var /** @type {?} */ onEnter_1 = this._onEnter;
	            this._ngZone.run(function () {
	                onEnter_1.next();
	                onEnter_1.complete();
	            });
	        }
	    };
	    /** Begin animation of snack bar entrance into view. */
	    /**
	     * Begin animation of snack bar entrance into view.
	     * @return {?}
	     */
	    MatSnackBarContainer.prototype.enter = /**
	     * Begin animation of snack bar entrance into view.
	     * @return {?}
	     */
	    function () {
	        if (!this._destroyed) {
	            this._animationState = "visible-" + this.snackBarConfig.verticalPosition;
	            this._changeDetectorRef.detectChanges();
	        }
	    };
	    /** Begin animation of the snack bar exiting from view. */
	    /**
	     * Begin animation of the snack bar exiting from view.
	     * @return {?}
	     */
	    MatSnackBarContainer.prototype.exit = /**
	     * Begin animation of the snack bar exiting from view.
	     * @return {?}
	     */
	    function () {
	        this._animationState = "hidden-" + this.snackBarConfig.verticalPosition;
	        return this._onExit;
	    };
	    /** Makes sure the exit callbacks have been invoked when the element is destroyed. */
	    /**
	     * Makes sure the exit callbacks have been invoked when the element is destroyed.
	     * @return {?}
	     */
	    MatSnackBarContainer.prototype.ngOnDestroy = /**
	     * Makes sure the exit callbacks have been invoked when the element is destroyed.
	     * @return {?}
	     */
	    function () {
	        this._destroyed = true;
	        this._completeExit();
	    };
	    /**
	     * Waits for the zone to settle before removing the element. Helps prevent
	     * errors where we end up removing an element which is in the middle of an animation.
	     * @return {?}
	     */
	    MatSnackBarContainer.prototype._completeExit = /**
	     * Waits for the zone to settle before removing the element. Helps prevent
	     * errors where we end up removing an element which is in the middle of an animation.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._ngZone.onMicrotaskEmpty.asObservable().pipe(rxjs_operators_take.take(1)).subscribe(function () {
	            _this._onExit.next();
	            _this._onExit.complete();
	        });
	    };
	    /**
	     * Applies the user-specified list of CSS classes to the element.
	     * @param {?} classList
	     * @return {?}
	     */
	    MatSnackBarContainer.prototype._setCssClasses = /**
	     * Applies the user-specified list of CSS classes to the element.
	     * @param {?} classList
	     * @return {?}
	     */
	    function (classList) {
	        if (!classList) {
	            return;
	        }
	        var /** @type {?} */ element = this._elementRef.nativeElement;
	        if (Array.isArray(classList)) {
	            // Note that we can't use a spread here, because IE doesn't support multiple arguments.
	            classList.forEach(function (cssClass) { return element.classList.add(cssClass); });
	        }
	        else {
	            element.classList.add(classList);
	        }
	    };
	    MatSnackBarContainer.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'snack-bar-container',
	                    template: "<ng-template cdkPortalOutlet></ng-template>",
	                    styles: [".mat-snack-bar-container{border-radius:2px;box-sizing:border-box;display:block;margin:24px;max-width:568px;min-width:288px;padding:14px 24px;transform:translateY(100%) translateY(24px)}.mat-snack-bar-container.mat-snack-bar-center{margin:0;transform:translateY(100%)}.mat-snack-bar-container.mat-snack-bar-top{transform:translateY(-100%) translateY(-24px)}.mat-snack-bar-container.mat-snack-bar-top.mat-snack-bar-center{transform:translateY(-100%)}@media screen and (-ms-high-contrast:active){.mat-snack-bar-container{border:solid 1px}}.mat-snack-bar-handset{width:100%}.mat-snack-bar-handset .mat-snack-bar-container{margin:0;max-width:inherit;width:100%}"],
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    animations: [matSnackBarAnimations.snackBarState],
	                    host: {
	                        'role': 'alert',
	                        'class': 'mat-snack-bar-container',
	                        '[@state]': '_animationState',
	                        '(@state.done)': 'onAnimationEnd($event)'
	                    },
	                },] },
	    ];
	    /** @nocollapse */
	    MatSnackBarContainer.ctorParameters = function () { return [
	        { type: _angular_core.NgZone, },
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.ChangeDetectorRef, },
	    ]; };
	    MatSnackBarContainer.propDecorators = {
	        "_portalOutlet": [{ type: _angular_core.ViewChild, args: [_angular_cdk_portal.CdkPortalOutlet,] },],
	    };
	    return MatSnackBarContainer;
	}(_angular_cdk_portal.BasePortalOutlet));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Service to dispatch Material Design snack bar messages.
	 */
	var MatSnackBar = /** @class */ (function () {
	    function MatSnackBar(_overlay, _live, _injector, _breakpointObserver, _parentSnackBar) {
	        this._overlay = _overlay;
	        this._live = _live;
	        this._injector = _injector;
	        this._breakpointObserver = _breakpointObserver;
	        this._parentSnackBar = _parentSnackBar;
	        /**
	         * Reference to the current snack bar in the view *at this level* (in the Angular injector tree).
	         * If there is a parent snack-bar service, all operations should delegate to that parent
	         * via `_openedSnackBarRef`.
	         */
	        this._snackBarRefAtThisLevel = null;
	    }
	    Object.defineProperty(MatSnackBar.prototype, "_openedSnackBarRef", {
	        /** Reference to the currently opened snackbar at *any* level. */
	        get: /**
	         * Reference to the currently opened snackbar at *any* level.
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ parent = this._parentSnackBar;
	            return parent ? parent._openedSnackBarRef : this._snackBarRefAtThisLevel;
	        },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (this._parentSnackBar) {
	                this._parentSnackBar._openedSnackBarRef = value;
	            }
	            else {
	                this._snackBarRefAtThisLevel = value;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Creates and dispatches a snack bar with a custom component for the content, removing any
	     * currently opened snack bars.
	     *
	     * @param component Component to be instantiated.
	     * @param config Extra configuration for the snack bar.
	     */
	    /**
	     * Creates and dispatches a snack bar with a custom component for the content, removing any
	     * currently opened snack bars.
	     *
	     * @template T
	     * @param {?} component Component to be instantiated.
	     * @param {?=} config Extra configuration for the snack bar.
	     * @return {?}
	     */
	    MatSnackBar.prototype.openFromComponent = /**
	     * Creates and dispatches a snack bar with a custom component for the content, removing any
	     * currently opened snack bars.
	     *
	     * @template T
	     * @param {?} component Component to be instantiated.
	     * @param {?=} config Extra configuration for the snack bar.
	     * @return {?}
	     */
	    function (component, config) {
	        var _this = this;
	        var /** @type {?} */ _config = _applyConfigDefaults$1(config);
	        var /** @type {?} */ snackBarRef = this._attach(component, _config);
	        // When the snackbar is dismissed, clear the reference to it.
	        snackBarRef.afterDismissed().subscribe(function () {
	            // Clear the snackbar ref if it hasn't already been replaced by a newer snackbar.
	            if (_this._openedSnackBarRef == snackBarRef) {
	                _this._openedSnackBarRef = null;
	            }
	        });
	        if (this._openedSnackBarRef) {
	            // If a snack bar is already in view, dismiss it and enter the
	            // new snack bar after exit animation is complete.
	            this._openedSnackBarRef.afterDismissed().subscribe(function () {
	                snackBarRef.containerInstance.enter();
	            });
	            this._openedSnackBarRef.dismiss();
	        }
	        else {
	            // If no snack bar is in view, enter the new snack bar.
	            snackBarRef.containerInstance.enter();
	        }
	        // If a dismiss timeout is provided, set up dismiss based on after the snackbar is opened.
	        if (_config.duration && _config.duration > 0) {
	            snackBarRef.afterOpened().subscribe(function () { return snackBarRef._dismissAfter(/** @type {?} */ ((/** @type {?} */ ((_config)).duration))); });
	        }
	        if (_config.announcementMessage) {
	            this._live.announce(_config.announcementMessage, _config.politeness);
	        }
	        this._openedSnackBarRef = snackBarRef;
	        return this._openedSnackBarRef;
	    };
	    /**
	     * Opens a snackbar with a message and an optional action.
	     * @param message The message to show in the snackbar.
	     * @param action The label for the snackbar action.
	     * @param config Additional configuration options for the snackbar.
	     */
	    /**
	     * Opens a snackbar with a message and an optional action.
	     * @param {?} message The message to show in the snackbar.
	     * @param {?=} action The label for the snackbar action.
	     * @param {?=} config Additional configuration options for the snackbar.
	     * @return {?}
	     */
	    MatSnackBar.prototype.open = /**
	     * Opens a snackbar with a message and an optional action.
	     * @param {?} message The message to show in the snackbar.
	     * @param {?=} action The label for the snackbar action.
	     * @param {?=} config Additional configuration options for the snackbar.
	     * @return {?}
	     */
	    function (message, action, config) {
	        if (action === void 0) { action = ''; }
	        var /** @type {?} */ _config = _applyConfigDefaults$1(config);
	        // Since the user doesn't have access to the component, we can
	        // override the data to pass in our own message and action.
	        _config.data = { message: message, action: action };
	        _config.announcementMessage = message;
	        return this.openFromComponent(SimpleSnackBar, _config);
	    };
	    /**
	     * Dismisses the currently-visible snack bar.
	     */
	    /**
	     * Dismisses the currently-visible snack bar.
	     * @return {?}
	     */
	    MatSnackBar.prototype.dismiss = /**
	     * Dismisses the currently-visible snack bar.
	     * @return {?}
	     */
	    function () {
	        if (this._openedSnackBarRef) {
	            this._openedSnackBarRef.dismiss();
	        }
	    };
	    /**
	     * Attaches the snack bar container component to the overlay.
	     * @param {?} overlayRef
	     * @param {?} config
	     * @return {?}
	     */
	    MatSnackBar.prototype._attachSnackBarContainer = /**
	     * Attaches the snack bar container component to the overlay.
	     * @param {?} overlayRef
	     * @param {?} config
	     * @return {?}
	     */
	    function (overlayRef, config) {
	        var /** @type {?} */ containerPortal = new _angular_cdk_portal.ComponentPortal(MatSnackBarContainer, config.viewContainerRef);
	        var /** @type {?} */ containerRef = overlayRef.attach(containerPortal);
	        containerRef.instance.snackBarConfig = config;
	        return containerRef.instance;
	    };
	    /**
	     * Places a new component as the content of the snack bar container.
	     * @template T
	     * @param {?} component
	     * @param {?} config
	     * @return {?}
	     */
	    MatSnackBar.prototype._attach = /**
	     * Places a new component as the content of the snack bar container.
	     * @template T
	     * @param {?} component
	     * @param {?} config
	     * @return {?}
	     */
	    function (component, config) {
	        var /** @type {?} */ overlayRef = this._createOverlay(config);
	        var /** @type {?} */ container = this._attachSnackBarContainer(overlayRef, config);
	        var /** @type {?} */ snackBarRef = new MatSnackBarRef(container, overlayRef);
	        var /** @type {?} */ injector = this._createInjector(config, snackBarRef);
	        var /** @type {?} */ portal = new _angular_cdk_portal.ComponentPortal(component, undefined, injector);
	        var /** @type {?} */ contentRef = container.attachComponentPortal(portal);
	        // We can't pass this via the injector, because the injector is created earlier.
	        snackBarRef.instance = contentRef.instance;
	        // Subscribe to the breakpoint observer and attach the mat-snack-bar-handset class as
	        // appropriate. This class is applied to the overlay element because the overlay must expand to
	        // fill the width of the screen for full width snackbars.
	        this._breakpointObserver.observe(_angular_cdk_layout.Breakpoints.Handset).pipe(rxjs_operators_takeUntil.takeUntil(overlayRef.detachments().pipe(rxjs_operators_take.take(1)))).subscribe(function (state$$1) {
	            if (state$$1.matches) {
	                overlayRef.overlayElement.classList.add('mat-snack-bar-handset');
	            }
	            else {
	                overlayRef.overlayElement.classList.remove('mat-snack-bar-handset');
	            }
	        });
	        return snackBarRef;
	    };
	    /**
	     * Creates a new overlay and places it in the correct location.
	     * @param {?} config The user-specified snack bar config.
	     * @return {?}
	     */
	    MatSnackBar.prototype._createOverlay = /**
	     * Creates a new overlay and places it in the correct location.
	     * @param {?} config The user-specified snack bar config.
	     * @return {?}
	     */
	    function (config) {
	        var /** @type {?} */ overlayConfig = new _angular_cdk_overlay.OverlayConfig();
	        overlayConfig.direction = config.direction;
	        var /** @type {?} */ positionStrategy = this._overlay.position().global();
	        // Set horizontal position.
	        var /** @type {?} */ isRtl = config.direction === 'rtl';
	        var /** @type {?} */ isLeft = (config.horizontalPosition === 'left' ||
	            (config.horizontalPosition === 'start' && !isRtl) ||
	            (config.horizontalPosition === 'end' && isRtl));
	        var /** @type {?} */ isRight = !isLeft && config.horizontalPosition !== 'center';
	        if (isLeft) {
	            positionStrategy.left('0');
	        }
	        else if (isRight) {
	            positionStrategy.right('0');
	        }
	        else {
	            positionStrategy.centerHorizontally();
	        }
	        // Set horizontal position.
	        if (config.verticalPosition === 'top') {
	            positionStrategy.top('0');
	        }
	        else {
	            positionStrategy.bottom('0');
	        }
	        overlayConfig.positionStrategy = positionStrategy;
	        return this._overlay.create(overlayConfig);
	    };
	    /**
	     * Creates an injector to be used inside of a snack bar component.
	     * @template T
	     * @param {?} config Config that was used to create the snack bar.
	     * @param {?} snackBarRef Reference to the snack bar.
	     * @return {?}
	     */
	    MatSnackBar.prototype._createInjector = /**
	     * Creates an injector to be used inside of a snack bar component.
	     * @template T
	     * @param {?} config Config that was used to create the snack bar.
	     * @param {?} snackBarRef Reference to the snack bar.
	     * @return {?}
	     */
	    function (config, snackBarRef) {
	        var /** @type {?} */ userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
	        var /** @type {?} */ injectionTokens = new WeakMap();
	        injectionTokens.set(MatSnackBarRef, snackBarRef);
	        injectionTokens.set(MAT_SNACK_BAR_DATA, config.data);
	        return new _angular_cdk_portal.PortalInjector(userInjector || this._injector, injectionTokens);
	    };
	    MatSnackBar.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    MatSnackBar.ctorParameters = function () { return [
	        { type: _angular_cdk_overlay.Overlay, },
	        { type: _angular_cdk_a11y.LiveAnnouncer, },
	        { type: _angular_core.Injector, },
	        { type: _angular_cdk_layout.BreakpointObserver, },
	        { type: MatSnackBar, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.SkipSelf },] },
	    ]; };
	    return MatSnackBar;
	}());
	/**
	 * Applies default options to the snackbar config.
	 * @param {?=} config The configuration to which the defaults will be applied.
	 * @return {?} The new configuration object with defaults applied.
	 */
	function _applyConfigDefaults$1(config) {
	    return __assign({}, new MatSnackBarConfig(), config);
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatSnackBarModule = /** @class */ (function () {
	    function MatSnackBarModule() {
	    }
	    MatSnackBarModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [
	                        _angular_cdk_overlay.OverlayModule,
	                        _angular_cdk_portal.PortalModule,
	                        _angular_common.CommonModule,
	                        MatCommonModule,
	                        _angular_cdk_layout.LayoutModule,
	                    ],
	                    exports: [MatSnackBarContainer, MatCommonModule],
	                    declarations: [MatSnackBarContainer, SimpleSnackBar],
	                    entryComponents: [MatSnackBarContainer, SimpleSnackBar],
	                    providers: [MatSnackBar, _angular_cdk_a11y.LIVE_ANNOUNCER_PROVIDER]
	                },] },
	    ];
	    /** @nocollapse */
	    MatSnackBarModule.ctorParameters = function () { return []; };
	    return MatSnackBarModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 * @param {?} id
	 * @return {?}
	 */
	function getSortDuplicateSortableIdError(id) {
	    return Error("Cannot have two MatSortables with the same id (" + id + ").");
	}
	/**
	 * \@docs-private
	 * @return {?}
	 */
	function getSortHeaderNotContainedWithinSortError() {
	    return Error("MatSortHeader must be placed within a parent element with the MatSort directive.");
	}
	/**
	 * \@docs-private
	 * @return {?}
	 */
	function getSortHeaderMissingIdError() {
	    return Error("MatSortHeader must be provided with a unique id.");
	}
	/**
	 * \@docs-private
	 * @param {?} direction
	 * @return {?}
	 */
	function getSortInvalidDirectionError(direction) {
	    return Error(direction + " is not a valid sort direction ('asc' or 'desc').");
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Interface for a directive that holds sorting state consumed by `MatSortHeader`.
	 * @record
	 */
	
	/**
	 * The current sort state.
	 * @record
	 */
	
	/**
	 * \@docs-private
	 */
	var MatSortBase = /** @class */ (function () {
	    function MatSortBase() {
	    }
	    return MatSortBase;
	}());
	var _MatSortMixinBase = mixinDisabled(MatSortBase);
	/**
	 * Container for MatSortables to manage the sort state and provide default sort parameters.
	 */
	var MatSort = /** @class */ (function (_super) {
	    __extends(MatSort, _super);
	    function MatSort() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /**
	         * Collection of all registered sortables that this directive manages.
	         */
	        _this.sortables = new Map();
	        /**
	         * Used to notify any child components listening to state changes.
	         */
	        _this._stateChanges = new rxjs_Subject.Subject();
	        /**
	         * The direction to set when an MatSortable is initially sorted.
	         * May be overriden by the MatSortable's sort start.
	         */
	        _this.start = 'asc';
	        _this._direction = '';
	        /**
	         * Event emitted when the user changes either the active sort or sort direction.
	         */
	        _this.sortChange = new _angular_core.EventEmitter();
	        return _this;
	    }
	    Object.defineProperty(MatSort.prototype, "direction", {
	        get: /**
	         * The sort direction of the currently active MatSortable.
	         * @return {?}
	         */
	        function () { return this._direction; },
	        set: /**
	         * @param {?} direction
	         * @return {?}
	         */
	        function (direction) {
	            if (_angular_core.isDevMode() && direction && direction !== 'asc' && direction !== 'desc') {
	                throw getSortInvalidDirectionError(direction);
	            }
	            this._direction = direction;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatSort.prototype, "disableClear", {
	        get: /**
	         * Whether to disable the user from clearing the sort by finishing the sort direction cycle.
	         * May be overriden by the MatSortable's disable clear input.
	         * @return {?}
	         */
	        function () { return this._disableClear; },
	        set: /**
	         * @param {?} v
	         * @return {?}
	         */
	        function (v) { this._disableClear = _angular_cdk_coercion.coerceBooleanProperty(v); },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Register function to be used by the contained MatSortables. Adds the MatSortable to the
	     * collection of MatSortables.
	     */
	    /**
	     * Register function to be used by the contained MatSortables. Adds the MatSortable to the
	     * collection of MatSortables.
	     * @param {?} sortable
	     * @return {?}
	     */
	    MatSort.prototype.register = /**
	     * Register function to be used by the contained MatSortables. Adds the MatSortable to the
	     * collection of MatSortables.
	     * @param {?} sortable
	     * @return {?}
	     */
	    function (sortable) {
	        if (!sortable.id) {
	            throw getSortHeaderMissingIdError();
	        }
	        if (this.sortables.has(sortable.id)) {
	            throw getSortDuplicateSortableIdError(sortable.id);
	        }
	        this.sortables.set(sortable.id, sortable);
	    };
	    /**
	     * Unregister function to be used by the contained MatSortables. Removes the MatSortable from the
	     * collection of contained MatSortables.
	     */
	    /**
	     * Unregister function to be used by the contained MatSortables. Removes the MatSortable from the
	     * collection of contained MatSortables.
	     * @param {?} sortable
	     * @return {?}
	     */
	    MatSort.prototype.deregister = /**
	     * Unregister function to be used by the contained MatSortables. Removes the MatSortable from the
	     * collection of contained MatSortables.
	     * @param {?} sortable
	     * @return {?}
	     */
	    function (sortable) {
	        this.sortables.delete(sortable.id);
	    };
	    /** Sets the active sort id and determines the new sort direction. */
	    /**
	     * Sets the active sort id and determines the new sort direction.
	     * @param {?} sortable
	     * @return {?}
	     */
	    MatSort.prototype.sort = /**
	     * Sets the active sort id and determines the new sort direction.
	     * @param {?} sortable
	     * @return {?}
	     */
	    function (sortable) {
	        if (this.active != sortable.id) {
	            this.active = sortable.id;
	            this.direction = sortable.start ? sortable.start : this.start;
	        }
	        else {
	            this.direction = this.getNextSortDirection(sortable);
	        }
	        this.sortChange.emit({ active: this.active, direction: this.direction });
	    };
	    /** Returns the next sort direction of the active sortable, checking for potential overrides. */
	    /**
	     * Returns the next sort direction of the active sortable, checking for potential overrides.
	     * @param {?} sortable
	     * @return {?}
	     */
	    MatSort.prototype.getNextSortDirection = /**
	     * Returns the next sort direction of the active sortable, checking for potential overrides.
	     * @param {?} sortable
	     * @return {?}
	     */
	    function (sortable) {
	        if (!sortable) {
	            return '';
	        }
	        // Get the sort direction cycle with the potential sortable overrides.
	        var /** @type {?} */ disableClear = sortable.disableClear != null ? sortable.disableClear : this.disableClear;
	        var /** @type {?} */ sortDirectionCycle = getSortDirectionCycle(sortable.start || this.start, disableClear);
	        // Get and return the next direction in the cycle
	        var /** @type {?} */ nextDirectionIndex = sortDirectionCycle.indexOf(this.direction) + 1;
	        if (nextDirectionIndex >= sortDirectionCycle.length) {
	            nextDirectionIndex = 0;
	        }
	        return sortDirectionCycle[nextDirectionIndex];
	    };
	    /**
	     * @return {?}
	     */
	    MatSort.prototype.ngOnChanges = /**
	     * @return {?}
	     */
	    function () {
	        this._stateChanges.next();
	    };
	    /**
	     * @return {?}
	     */
	    MatSort.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._stateChanges.complete();
	    };
	    MatSort.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[matSort]',
	                    exportAs: 'matSort',
	                    inputs: ['disabled: matSortDisabled']
	                },] },
	    ];
	    /** @nocollapse */
	    MatSort.ctorParameters = function () { return []; };
	    MatSort.propDecorators = {
	        "active": [{ type: _angular_core.Input, args: ['matSortActive',] },],
	        "start": [{ type: _angular_core.Input, args: ['matSortStart',] },],
	        "direction": [{ type: _angular_core.Input, args: ['matSortDirection',] },],
	        "disableClear": [{ type: _angular_core.Input, args: ['matSortDisableClear',] },],
	        "sortChange": [{ type: _angular_core.Output, args: ['matSortChange',] },],
	    };
	    return MatSort;
	}(_MatSortMixinBase));
	/**
	 * Returns the sort direction cycle to use given the provided parameters of order and clear.
	 * @param {?} start
	 * @param {?} disableClear
	 * @return {?}
	 */
	function getSortDirectionCycle(start, disableClear) {
	    var /** @type {?} */ sortOrder = ['asc', 'desc'];
	    if (start == 'desc') {
	        sortOrder.reverse();
	    }
	    if (!disableClear) {
	        sortOrder.push('');
	    }
	    return sortOrder;
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * To modify the labels and text displayed, create a new instance of MatSortHeaderIntl and
	 * include it in a custom provider.
	 */
	var MatSortHeaderIntl = /** @class */ (function () {
	    function MatSortHeaderIntl() {
	        /**
	         * Stream that emits whenever the labels here are changed. Use this to notify
	         * components if the labels have changed after initialization.
	         */
	        this.changes = new rxjs_Subject.Subject();
	        /**
	         * ARIA label for the sorting button.
	         */
	        this.sortButtonLabel = function (id) {
	            return "Change sorting for " + id;
	        };
	        /**
	         * A label to describe the current sort (visible only to screenreaders).
	         */
	        this.sortDescriptionLabel = function (id, direction) {
	            return "Sorted by " + id + " " + (direction == 'asc' ? 'ascending' : 'descending');
	        };
	    }
	    MatSortHeaderIntl.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    MatSortHeaderIntl.ctorParameters = function () { return []; };
	    return MatSortHeaderIntl;
	}());
	/**
	 * \@docs-private
	 * @param {?} parentIntl
	 * @return {?}
	 */
	function MAT_SORT_HEADER_INTL_PROVIDER_FACTORY(parentIntl) {
	    return parentIntl || new MatSortHeaderIntl();
	}
	/**
	 * \@docs-private
	 */
	var MAT_SORT_HEADER_INTL_PROVIDER = {
	    // If there is already an MatSortHeaderIntl available, use that. Otherwise, provide a new one.
	    provide: MatSortHeaderIntl,
	    deps: [[new _angular_core.Optional(), new _angular_core.SkipSelf(), MatSortHeaderIntl]],
	    useFactory: MAT_SORT_HEADER_INTL_PROVIDER_FACTORY
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var SORT_ANIMATION_TRANSITION = AnimationDurations.ENTERING + ' ' +
	    AnimationCurves.STANDARD_CURVE;
	/**
	 * Animations used by MatSort.
	 */
	var matSortAnimations = {
	    /** Animation that moves the sort indicator. */
	    indicator: _angular_animations.trigger('indicator', [
	        _angular_animations.state('active-asc, asc', _angular_animations.style({ transform: 'translateY(0px)' })),
	        // 10px is the height of the sort indicator, minus the width of the pointers
	        _angular_animations.state('active-desc, desc', _angular_animations.style({ transform: 'translateY(10px)' })),
	        _angular_animations.transition('active-asc <=> active-desc', _angular_animations.animate(SORT_ANIMATION_TRANSITION))
	    ]),
	    /** Animation that rotates the left pointer of the indicator based on the sorting direction. */
	    leftPointer: _angular_animations.trigger('leftPointer', [
	        _angular_animations.state('active-asc, asc', _angular_animations.style({ transform: 'rotate(-45deg)' })),
	        _angular_animations.state('active-desc, desc', _angular_animations.style({ transform: 'rotate(45deg)' })),
	        _angular_animations.transition('active-asc <=> active-desc', _angular_animations.animate(SORT_ANIMATION_TRANSITION))
	    ]),
	    /** Animation that rotates the right pointer of the indicator based on the sorting direction. */
	    rightPointer: _angular_animations.trigger('rightPointer', [
	        _angular_animations.state('active-asc, asc', _angular_animations.style({ transform: 'rotate(45deg)' })),
	        _angular_animations.state('active-desc, desc', _angular_animations.style({ transform: 'rotate(-45deg)' })),
	        _angular_animations.transition('active-asc <=> active-desc', _angular_animations.animate(SORT_ANIMATION_TRANSITION))
	    ]),
	    /** Animation that controls the arrow opacity. */
	    arrowOpacity: _angular_animations.trigger('arrowOpacity', [
	        _angular_animations.state('desc-to-active, asc-to-active, active', _angular_animations.style({ opacity: 1 })),
	        _angular_animations.state('desc-to-hint, asc-to-hint, hint', _angular_animations.style({ opacity: .54 })),
	        _angular_animations.state('hint-to-desc, active-to-desc, desc, hint-to-asc, active-to-asc, asc', _angular_animations.style({ opacity: 0 })),
	        // Transition between all states except for immediate transitions
	        _angular_animations.transition('* => asc, * => desc, * => active, * => hint', _angular_animations.animate('0ms')),
	        _angular_animations.transition('* <=> *', _angular_animations.animate(SORT_ANIMATION_TRANSITION))
	    ]),
	    /**
	       * Animation for the translation of the arrow as a whole. States are separated into two
	       * groups: ones with animations and others that are immediate. Immediate states are asc, desc,
	       * peek, and active. The other states define a specific animation (source-to-destination)
	       * and are determined as a function of their prev user-perceived state and what the next state
	       * should be.
	       */
	    arrowPosition: _angular_animations.trigger('arrowPosition', [
	        // Hidden Above => Hint Center
	        _angular_animations.transition('* => desc-to-hint, * => desc-to-active', _angular_animations.animate(SORT_ANIMATION_TRANSITION, _angular_animations.keyframes([
	            _angular_animations.style({ transform: 'translateY(-25%)' }),
	            _angular_animations.style({ transform: 'translateY(0)' })
	        ]))),
	        // Hint Center => Hidden Below
	        _angular_animations.transition('* => hint-to-desc, * => active-to-desc', _angular_animations.animate(SORT_ANIMATION_TRANSITION, _angular_animations.keyframes([
	            _angular_animations.style({ transform: 'translateY(0)' }),
	            _angular_animations.style({ transform: 'translateY(25%)' })
	        ]))),
	        // Hidden Below => Hint Center
	        _angular_animations.transition('* => asc-to-hint, * => asc-to-active', _angular_animations.animate(SORT_ANIMATION_TRANSITION, _angular_animations.keyframes([
	            _angular_animations.style({ transform: 'translateY(25%)' }),
	            _angular_animations.style({ transform: 'translateY(0)' })
	        ]))),
	        // Hint Center => Hidden Above
	        _angular_animations.transition('* => hint-to-asc, * => active-to-asc', _angular_animations.animate(SORT_ANIMATION_TRANSITION, _angular_animations.keyframes([
	            _angular_animations.style({ transform: 'translateY(0)' }),
	            _angular_animations.style({ transform: 'translateY(-25%)' })
	        ]))),
	        _angular_animations.state('desc-to-hint, asc-to-hint, hint, desc-to-active, asc-to-active, active', _angular_animations.style({ transform: 'translateY(0)' })),
	        _angular_animations.state('hint-to-desc, active-to-desc, desc', _angular_animations.style({ transform: 'translateY(-25%)' })),
	        _angular_animations.state('hint-to-asc, active-to-asc, asc', _angular_animations.style({ transform: 'translateY(25%)' })),
	    ]),
	    /** Necessary trigger that calls animate on children animations. */
	    allowChildren: _angular_animations.trigger('allowChildren', [
	        _angular_animations.transition('* <=> *', [
	            _angular_animations.query('@*', _angular_animations.animateChild(), { optional: true })
	        ])
	    ]),
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 */
	var MatSortHeaderBase = /** @class */ (function () {
	    function MatSortHeaderBase() {
	    }
	    return MatSortHeaderBase;
	}());
	var _MatSortHeaderMixinBase = mixinDisabled(MatSortHeaderBase);
	/**
	 * States describing the arrow's animated position (animating fromState to toState).
	 * If the fromState is not defined, there will be no animated transition to the toState.
	 * \@docs-private
	 * @record
	 */
	
	/**
	 * Applies sorting behavior (click to change sort) and styles to an element, including an
	 * arrow to display the current sort direction.
	 *
	 * Must be provided with an id and contained within a parent MatSort directive.
	 *
	 * If used on header cells in a CdkTable, it will automatically default its id from its containing
	 * column definition.
	 */
	var MatSortHeader = /** @class */ (function (_super) {
	    __extends(MatSortHeader, _super);
	    function MatSortHeader(_intl, changeDetectorRef, _sort, _cdkColumnDef) {
	        var _this = _super.call(this) || this;
	        _this._intl = _intl;
	        _this._sort = _sort;
	        _this._cdkColumnDef = _cdkColumnDef;
	        /**
	         * Flag set to true when the indicator should be displayed while the sort is not active. Used to
	         * provide an affordance that the header is sortable by showing on focus and hover.
	         */
	        _this._showIndicatorHint = false;
	        /**
	         * The direction the arrow should be facing according to the current state.
	         */
	        _this._arrowDirection = '';
	        /**
	         * Whether the view state animation should show the transition between the `from` and `to` states.
	         */
	        _this._disableViewStateAnimation = false;
	        /**
	         * Sets the position of the arrow that displays when sorted.
	         */
	        _this.arrowPosition = 'after';
	        if (!_sort) {
	            throw getSortHeaderNotContainedWithinSortError();
	        }
	        _this._rerenderSubscription = rxjs_observable_merge.merge(_sort.sortChange, _sort._stateChanges, _intl.changes)
	            .subscribe(function () {
	            if (_this._isSorted()) {
	                _this._updateArrowDirection();
	            }
	            // If this header was recently active and now no longer sorted, animate away the arrow.
	            if (!_this._isSorted() && _this._viewState && _this._viewState.toState === 'active') {
	                _this._disableViewStateAnimation = false;
	                _this._setAnimationTransitionState({ fromState: 'active', toState: _this._arrowDirection });
	            }
	            changeDetectorRef.markForCheck();
	        });
	        return _this;
	    }
	    Object.defineProperty(MatSortHeader.prototype, "disableClear", {
	        get: /**
	         * Overrides the disable clear value of the containing MatSort for this MatSortable.
	         * @return {?}
	         */
	        function () { return this._disableClear; },
	        set: /**
	         * @param {?} v
	         * @return {?}
	         */
	        function (v) { this._disableClear = _angular_cdk_coercion.coerceBooleanProperty(v); },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatSortHeader.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        if (!this.id && this._cdkColumnDef) {
	            this.id = this._cdkColumnDef.name;
	        }
	        // Initialize the direction of the arrow and set the view state to be immediately that state.
	        this._updateArrowDirection();
	        this._setAnimationTransitionState({ toState: this._isSorted() ? 'active' : this._arrowDirection });
	        this._sort.register(this);
	    };
	    /**
	     * @return {?}
	     */
	    MatSortHeader.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._sort.deregister(this);
	        this._rerenderSubscription.unsubscribe();
	    };
	    /**
	     * Sets the "hint" state such that the arrow will be semi-transparently displayed as a hint to the
	     * user showing what the active sort will become. If set to false, the arrow will fade away.
	     */
	    /**
	     * Sets the "hint" state such that the arrow will be semi-transparently displayed as a hint to the
	     * user showing what the active sort will become. If set to false, the arrow will fade away.
	     * @param {?} visible
	     * @return {?}
	     */
	    MatSortHeader.prototype._setIndicatorHintVisible = /**
	     * Sets the "hint" state such that the arrow will be semi-transparently displayed as a hint to the
	     * user showing what the active sort will become. If set to false, the arrow will fade away.
	     * @param {?} visible
	     * @return {?}
	     */
	    function (visible) {
	        // No-op if the sort header is disabled - should not make the hint visible.
	        if (this._isDisabled() && visible) {
	            return;
	        }
	        this._showIndicatorHint = visible;
	        if (!this._isSorted()) {
	            this._updateArrowDirection();
	            if (this._showIndicatorHint) {
	                this._setAnimationTransitionState({ fromState: this._arrowDirection, toState: 'hint' });
	            }
	            else {
	                this._setAnimationTransitionState({ fromState: 'hint', toState: this._arrowDirection });
	            }
	        }
	    };
	    /**
	     * Sets the animation transition view state for the arrow's position and opacity. If the
	     * `disableViewStateAnimation` flag is set to true, the `fromState` will be ignored so that
	     * no animation appears.
	     */
	    /**
	     * Sets the animation transition view state for the arrow's position and opacity. If the
	     * `disableViewStateAnimation` flag is set to true, the `fromState` will be ignored so that
	     * no animation appears.
	     * @param {?} viewState
	     * @return {?}
	     */
	    MatSortHeader.prototype._setAnimationTransitionState = /**
	     * Sets the animation transition view state for the arrow's position and opacity. If the
	     * `disableViewStateAnimation` flag is set to true, the `fromState` will be ignored so that
	     * no animation appears.
	     * @param {?} viewState
	     * @return {?}
	     */
	    function (viewState) {
	        this._viewState = viewState;
	        // If the animation for arrow position state (opacity/translation) should be disabled,
	        // remove the fromState so that it jumps right to the toState.
	        if (this._disableViewStateAnimation) {
	            this._viewState = { toState: viewState.toState };
	        }
	    };
	    /** Triggers the sort on this sort header and removes the indicator hint. */
	    /**
	     * Triggers the sort on this sort header and removes the indicator hint.
	     * @return {?}
	     */
	    MatSortHeader.prototype._handleClick = /**
	     * Triggers the sort on this sort header and removes the indicator hint.
	     * @return {?}
	     */
	    function () {
	        if (this._isDisabled()) {
	            return;
	        }
	        this._sort.sort(this);
	        // Do not show the animation if the header was already shown in the right position.
	        if (this._viewState.toState === 'hint' || this._viewState.toState === 'active') {
	            this._disableViewStateAnimation = true;
	        }
	        // If the arrow is now sorted, animate the arrow into place. Otherwise, animate it away into
	        // the direction it is facing.
	        var /** @type {?} */ viewState = this._isSorted() ?
	            { fromState: this._arrowDirection, toState: 'active' } :
	            { fromState: 'active', toState: this._arrowDirection };
	        this._setAnimationTransitionState(viewState);
	        this._showIndicatorHint = false;
	    };
	    /** Whether this MatSortHeader is currently sorted in either ascending or descending order. */
	    /**
	     * Whether this MatSortHeader is currently sorted in either ascending or descending order.
	     * @return {?}
	     */
	    MatSortHeader.prototype._isSorted = /**
	     * Whether this MatSortHeader is currently sorted in either ascending or descending order.
	     * @return {?}
	     */
	    function () {
	        return this._sort.active == this.id &&
	            (this._sort.direction === 'asc' || this._sort.direction === 'desc');
	    };
	    /** Returns the animation state for the arrow direction (indicator and pointers). */
	    /**
	     * Returns the animation state for the arrow direction (indicator and pointers).
	     * @return {?}
	     */
	    MatSortHeader.prototype._getArrowDirectionState = /**
	     * Returns the animation state for the arrow direction (indicator and pointers).
	     * @return {?}
	     */
	    function () {
	        return "" + (this._isSorted() ? 'active-' : '') + this._arrowDirection;
	    };
	    /** Returns the arrow position state (opacity, translation). */
	    /**
	     * Returns the arrow position state (opacity, translation).
	     * @return {?}
	     */
	    MatSortHeader.prototype._getArrowViewState = /**
	     * Returns the arrow position state (opacity, translation).
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ fromState = this._viewState.fromState;
	        return (fromState ? fromState + "-to-" : '') + this._viewState.toState;
	    };
	    /**
	     * Updates the direction the arrow should be pointing. If it is not sorted, the arrow should be
	     * facing the start direction. Otherwise if it is sorted, the arrow should point in the currently
	     * active sorted direction. The reason this is updated through a function is because the direction
	     * should only be changed at specific times - when deactivated but the hint is displayed and when
	     * the sort is active and the direction changes. Otherwise the arrow's direction should linger
	     * in cases such as the sort becoming deactivated but we want to animate the arrow away while
	     * preserving its direction, even though the next sort direction is actually different and should
	     * only be changed once the arrow displays again (hint or activation).
	     */
	    /**
	     * Updates the direction the arrow should be pointing. If it is not sorted, the arrow should be
	     * facing the start direction. Otherwise if it is sorted, the arrow should point in the currently
	     * active sorted direction. The reason this is updated through a function is because the direction
	     * should only be changed at specific times - when deactivated but the hint is displayed and when
	     * the sort is active and the direction changes. Otherwise the arrow's direction should linger
	     * in cases such as the sort becoming deactivated but we want to animate the arrow away while
	     * preserving its direction, even though the next sort direction is actually different and should
	     * only be changed once the arrow displays again (hint or activation).
	     * @return {?}
	     */
	    MatSortHeader.prototype._updateArrowDirection = /**
	     * Updates the direction the arrow should be pointing. If it is not sorted, the arrow should be
	     * facing the start direction. Otherwise if it is sorted, the arrow should point in the currently
	     * active sorted direction. The reason this is updated through a function is because the direction
	     * should only be changed at specific times - when deactivated but the hint is displayed and when
	     * the sort is active and the direction changes. Otherwise the arrow's direction should linger
	     * in cases such as the sort becoming deactivated but we want to animate the arrow away while
	     * preserving its direction, even though the next sort direction is actually different and should
	     * only be changed once the arrow displays again (hint or activation).
	     * @return {?}
	     */
	    function () {
	        this._arrowDirection = this._isSorted() ?
	            this._sort.direction :
	            (this.start || this._sort.start);
	    };
	    /**
	     * @return {?}
	     */
	    MatSortHeader.prototype._isDisabled = /**
	     * @return {?}
	     */
	    function () {
	        return this._sort.disabled || this.disabled;
	    };
	    MatSortHeader.decorators = [
	        { type: _angular_core.Component, args: [{selector: '[mat-sort-header]',
	                    exportAs: 'matSortHeader',
	                    template: "<div class=\"mat-sort-header-container\" [class.mat-sort-header-sorted]=\"_isSorted()\" [class.mat-sort-header-position-before]=\"arrowPosition == 'before'\"><button class=\"mat-sort-header-button\" type=\"button\" [attr.disabled]=\"_isDisabled() || null\" [attr.aria-label]=\"_intl.sortButtonLabel(id)\" (focus)=\"_setIndicatorHintVisible(true)\" (blur)=\"_setIndicatorHintVisible(false)\"><ng-content></ng-content></button><div class=\"mat-sort-header-arrow\" [@arrowOpacity]=\"_getArrowViewState()\" [@arrowPosition]=\"_getArrowViewState()\" [@allowChildren]=\"_getArrowDirectionState()\" (@arrowPosition.start)=\"_disableViewStateAnimation = true\" (@arrowPosition.done)=\"_disableViewStateAnimation = false\"><div class=\"mat-sort-header-stem\"></div><div class=\"mat-sort-header-indicator\" [@indicator]=\"_getArrowDirectionState()\"><div class=\"mat-sort-header-pointer-left\" [@leftPointer]=\"_getArrowDirectionState()\"></div><div class=\"mat-sort-header-pointer-right\" [@rightPointer]=\"_getArrowDirectionState()\"></div><div class=\"mat-sort-header-pointer-middle\"></div></div></div></div><span class=\"cdk-visually-hidden\" *ngIf=\"_isSorted()\">&nbsp;{{_intl.sortDescriptionLabel(id, _sort.direction)}}</span>",
	                    styles: [".mat-sort-header-container{display:flex;cursor:pointer}.mat-sort-header-disabled .mat-sort-header-container{cursor:default}.mat-sort-header-position-before{flex-direction:row-reverse}.mat-sort-header-button{border:none;background:0 0;display:flex;align-items:center;padding:0;cursor:inherit;outline:0;font:inherit;color:currentColor}.mat-sort-header-arrow{height:12px;width:12px;min-width:12px;margin:0 0 0 6px;position:relative;display:flex}.mat-sort-header-position-before .mat-sort-header-arrow{margin:0 6px 0 0}.mat-sort-header-stem{background:currentColor;height:10px;width:2px;margin:auto;display:flex;align-items:center}.mat-sort-header-indicator{width:100%;height:2px;display:flex;align-items:center;position:absolute;top:0;left:0}.mat-sort-header-pointer-middle{margin:auto;height:2px;width:2px;background:currentColor;transform:rotate(45deg)}.mat-sort-header-pointer-left,.mat-sort-header-pointer-right{background:currentColor;width:6px;height:2px;position:absolute;top:0}.mat-sort-header-pointer-left{transform-origin:right;left:0}.mat-sort-header-pointer-right{transform-origin:left;right:0}"],
	                    host: {
	                        '(click)': '_handleClick()',
	                        '(mouseenter)': '_setIndicatorHintVisible(true)',
	                        '(longpress)': '_setIndicatorHintVisible(true)',
	                        '(mouseleave)': '_setIndicatorHintVisible(false)',
	                        '[class.mat-sort-header-disabled]': '_isDisabled()',
	                    },
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    inputs: ['disabled'],
	                    animations: [
	                        matSortAnimations.indicator,
	                        matSortAnimations.leftPointer,
	                        matSortAnimations.rightPointer,
	                        matSortAnimations.arrowOpacity,
	                        matSortAnimations.arrowPosition,
	                        matSortAnimations.allowChildren,
	                    ]
	                },] },
	    ];
	    /** @nocollapse */
	    MatSortHeader.ctorParameters = function () { return [
	        { type: MatSortHeaderIntl, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: MatSort, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_cdk_table.CdkColumnDef, decorators: [{ type: _angular_core.Optional },] },
	    ]; };
	    MatSortHeader.propDecorators = {
	        "id": [{ type: _angular_core.Input, args: ['mat-sort-header',] },],
	        "arrowPosition": [{ type: _angular_core.Input },],
	        "start": [{ type: _angular_core.Input },],
	        "disableClear": [{ type: _angular_core.Input },],
	    };
	    return MatSortHeader;
	}(_MatSortHeaderMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatSortModule = /** @class */ (function () {
	    function MatSortModule() {
	    }
	    MatSortModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [_angular_common.CommonModule],
	                    exports: [MatSort, MatSortHeader],
	                    declarations: [MatSort, MatSortHeader],
	                    providers: [MAT_SORT_HEADER_INTL_PROVIDER]
	                },] },
	    ];
	    /** @nocollapse */
	    MatSortModule.ctorParameters = function () { return []; };
	    return MatSortModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatStepLabel = /** @class */ (function (_super) {
	    __extends(MatStepLabel, _super);
	    function MatStepLabel(template) {
	        return _super.call(this, template) || this;
	    }
	    MatStepLabel.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[matStepLabel]',
	                },] },
	    ];
	    /** @nocollapse */
	    MatStepLabel.ctorParameters = function () { return [
	        { type: _angular_core.TemplateRef, },
	    ]; };
	    return MatStepLabel;
	}(_angular_cdk_stepper.CdkStepLabel));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Stepper data that is required for internationalization.
	 */
	var MatStepperIntl = /** @class */ (function () {
	    function MatStepperIntl() {
	        /**
	         * Stream that emits whenever the labels here are changed. Use this to notify
	         * components if the labels have changed after initialization.
	         */
	        this.changes = new rxjs_Subject.Subject();
	        /**
	         * Label that is rendered below optional steps.
	         */
	        this.optionalLabel = 'Optional';
	    }
	    MatStepperIntl.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    MatStepperIntl.ctorParameters = function () { return []; };
	    return MatStepperIntl;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatStepHeader = /** @class */ (function () {
	    function MatStepHeader(_intl, _focusMonitor, _element, changeDetectorRef) {
	        this._intl = _intl;
	        this._focusMonitor = _focusMonitor;
	        this._element = _element;
	        _focusMonitor.monitor(_element.nativeElement, true);
	        this._intlSubscription = _intl.changes.subscribe(function () { return changeDetectorRef.markForCheck(); });
	    }
	    Object.defineProperty(MatStepHeader.prototype, "index", {
	        get: /**
	         * Index of the given step.
	         * @return {?}
	         */
	        function () { return this._index; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._index = _angular_cdk_coercion.coerceNumberProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatStepHeader.prototype, "selected", {
	        get: /**
	         * Whether the given step is selected.
	         * @return {?}
	         */
	        function () { return this._selected; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._selected = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatStepHeader.prototype, "active", {
	        get: /**
	         * Whether the given step label is active.
	         * @return {?}
	         */
	        function () { return this._active; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._active = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatStepHeader.prototype, "optional", {
	        get: /**
	         * Whether the given step is optional.
	         * @return {?}
	         */
	        function () { return this._optional; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._optional = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatStepHeader.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._intlSubscription.unsubscribe();
	        this._focusMonitor.stopMonitoring(this._element.nativeElement);
	    };
	    /** Returns string label of given step if it is a text label. */
	    /**
	     * Returns string label of given step if it is a text label.
	     * @return {?}
	     */
	    MatStepHeader.prototype._stringLabel = /**
	     * Returns string label of given step if it is a text label.
	     * @return {?}
	     */
	    function () {
	        return this.label instanceof MatStepLabel ? null : this.label;
	    };
	    /** Returns MatStepLabel if the label of given step is a template label. */
	    /**
	     * Returns MatStepLabel if the label of given step is a template label.
	     * @return {?}
	     */
	    MatStepHeader.prototype._templateLabel = /**
	     * Returns MatStepLabel if the label of given step is a template label.
	     * @return {?}
	     */
	    function () {
	        return this.label instanceof MatStepLabel ? this.label : null;
	    };
	    /** Returns the host HTML element. */
	    /**
	     * Returns the host HTML element.
	     * @return {?}
	     */
	    MatStepHeader.prototype._getHostElement = /**
	     * Returns the host HTML element.
	     * @return {?}
	     */
	    function () {
	        return this._element.nativeElement;
	    };
	    MatStepHeader.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-step-header',
	                    template: "<div class=\"mat-step-header-ripple\" mat-ripple [matRippleTrigger]=\"_getHostElement()\"></div><div [class.mat-step-icon]=\"state !== 'number' || selected\" [class.mat-step-icon-not-touched]=\"state == 'number' && !selected\" [ngSwitch]=\"state\"><span *ngSwitchCase=\"'number'\">{{index + 1}}</span><ng-container *ngSwitchCase=\"'edit'\" [ngSwitch]=\"!!(iconOverrides && iconOverrides.edit)\"><ng-container *ngSwitchCase=\"true\" [ngTemplateOutlet]=\"iconOverrides.edit\"></ng-container><mat-icon *ngSwitchDefault>create</mat-icon></ng-container><ng-container *ngSwitchCase=\"'done'\" [ngSwitch]=\"!!(iconOverrides && iconOverrides.done)\"><ng-container *ngSwitchCase=\"true\" [ngTemplateOutlet]=\"iconOverrides.done\"></ng-container><mat-icon *ngSwitchDefault>done</mat-icon></ng-container></div><div class=\"mat-step-label\" [class.mat-step-label-active]=\"active\" [class.mat-step-label-selected]=\"selected\"><ng-container *ngIf=\"_templateLabel()\" [ngTemplateOutlet]=\"_templateLabel()!.template\"></ng-container><div class=\"mat-step-text-label\" *ngIf=\"_stringLabel()\">{{label}}</div><div class=\"mat-step-optional\" *ngIf=\"optional\">{{_intl.optionalLabel}}</div></div>",
	                    styles: [".mat-step-header{overflow:hidden;outline:0;cursor:pointer;position:relative;box-sizing:content-box}.mat-step-optional{font-size:12px}.mat-step-icon,.mat-step-icon-not-touched{border-radius:50%;height:24px;width:24px;align-items:center;justify-content:center;display:flex}.mat-step-icon .mat-icon{font-size:16px;height:16px;width:16px}.mat-step-label{display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:50px;vertical-align:middle}.mat-step-text-label{text-overflow:ellipsis;overflow:hidden}.mat-step-header-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}"],
	                    host: {
	                        'class': 'mat-step-header',
	                        'role': 'tab',
	                    },
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatStepHeader.ctorParameters = function () { return [
	        { type: MatStepperIntl, },
	        { type: _angular_cdk_a11y.FocusMonitor, },
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.ChangeDetectorRef, },
	    ]; };
	    MatStepHeader.propDecorators = {
	        "state": [{ type: _angular_core.Input },],
	        "label": [{ type: _angular_core.Input },],
	        "iconOverrides": [{ type: _angular_core.Input },],
	        "index": [{ type: _angular_core.Input },],
	        "selected": [{ type: _angular_core.Input },],
	        "active": [{ type: _angular_core.Input },],
	        "optional": [{ type: _angular_core.Input },],
	    };
	    return MatStepHeader;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * Animations used by the Material steppers.
	 */
	var matStepperAnimations = {
	    /** Animation that transitions the step along the X axis in a horizontal stepper. */
	    horizontalStepTransition: _angular_animations.trigger('stepTransition', [
	        _angular_animations.state('previous', _angular_animations.style({ transform: 'translate3d(-100%, 0, 0)', visibility: 'hidden' })),
	        _angular_animations.state('current', _angular_animations.style({ transform: 'none', visibility: 'visible' })),
	        _angular_animations.state('next', _angular_animations.style({ transform: 'translate3d(100%, 0, 0)', visibility: 'hidden' })),
	        _angular_animations.transition('* => *', _angular_animations.animate('500ms cubic-bezier(0.35, 0, 0.25, 1)'))
	    ]),
	    /** Animation that transitions the step along the Y axis in a vertical stepper. */
	    verticalStepTransition: _angular_animations.trigger('stepTransition', [
	        _angular_animations.state('previous', _angular_animations.style({ height: '0px', visibility: 'hidden' })),
	        _angular_animations.state('next', _angular_animations.style({ height: '0px', visibility: 'hidden' })),
	        _angular_animations.state('current', _angular_animations.style({ height: '*', visibility: 'visible' })),
	        _angular_animations.transition('* <=> current', _angular_animations.animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
	    ])
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Template to be used to override the icons inside the step header.
	 */
	var MatStepperIcon = /** @class */ (function () {
	    function MatStepperIcon(templateRef) {
	        this.templateRef = templateRef;
	    }
	    MatStepperIcon.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'ng-template[matStepperIcon]',
	                },] },
	    ];
	    /** @nocollapse */
	    MatStepperIcon.ctorParameters = function () { return [
	        { type: _angular_core.TemplateRef, },
	    ]; };
	    MatStepperIcon.propDecorators = {
	        "name": [{ type: _angular_core.Input, args: ['matStepperIcon',] },],
	    };
	    return MatStepperIcon;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Workaround for https://github.com/angular/angular/issues/17849
	 */
	var _MatStep = _angular_cdk_stepper.CdkStep;
	var _MatStepper = _angular_cdk_stepper.CdkStepper;
	var MatStep = /** @class */ (function (_super) {
	    __extends(MatStep, _super);
	    function MatStep(stepper, _errorStateMatcher) {
	        var _this = _super.call(this, stepper) || this;
	        _this._errorStateMatcher = _errorStateMatcher;
	        return _this;
	    }
	    /** Custom error state matcher that additionally checks for validity of interacted form. */
	    /**
	     * Custom error state matcher that additionally checks for validity of interacted form.
	     * @param {?} control
	     * @param {?} form
	     * @return {?}
	     */
	    MatStep.prototype.isErrorState = /**
	     * Custom error state matcher that additionally checks for validity of interacted form.
	     * @param {?} control
	     * @param {?} form
	     * @return {?}
	     */
	    function (control, form) {
	        var /** @type {?} */ originalErrorState = this._errorStateMatcher.isErrorState(control, form);
	        // Custom error state checks for the validity of form that is not submitted or touched
	        // since user can trigger a form change by calling for another step without directly
	        // interacting with the current form.
	        var /** @type {?} */ customErrorState = !!(control && control.invalid && this.interacted);
	        return originalErrorState || customErrorState;
	    };
	    MatStep.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-step',
	                    template: "<ng-template><ng-content></ng-content></ng-template>",
	                    providers: [{ provide: ErrorStateMatcher, useExisting: MatStep }],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    exportAs: 'matStep',
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatStep.ctorParameters = function () { return [
	        { type: MatStepper, decorators: [{ type: _angular_core.Inject, args: [_angular_core.forwardRef(function () { return MatStepper; }),] },] },
	        { type: ErrorStateMatcher, decorators: [{ type: _angular_core.SkipSelf },] },
	    ]; };
	    MatStep.propDecorators = {
	        "stepLabel": [{ type: _angular_core.ContentChild, args: [MatStepLabel,] },],
	    };
	    return MatStep;
	}(_angular_cdk_stepper.CdkStep));
	var MatStepper = /** @class */ (function (_super) {
	    __extends(MatStepper, _super);
	    function MatStepper() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /**
	         * Consumer-specified template-refs to be used to override the header icons.
	         */
	        _this._iconOverrides = {};
	        return _this;
	    }
	    /**
	     * @return {?}
	     */
	    MatStepper.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ icons = this._icons.toArray();
	        var /** @type {?} */ editOverride = icons.find(function (icon) { return icon.name === 'edit'; });
	        var /** @type {?} */ doneOverride = icons.find(function (icon) { return icon.name === 'done'; });
	        if (editOverride) {
	            this._iconOverrides["edit"] = editOverride.templateRef;
	        }
	        if (doneOverride) {
	            this._iconOverrides["done"] = doneOverride.templateRef;
	        }
	        // Mark the component for change detection whenever the content children query changes
	        this._steps.changes.pipe(rxjs_operators_takeUntil.takeUntil(this._destroyed)).subscribe(function () { return _this._stateChanged(); });
	    };
	    MatStepper.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[matStepper]'
	                },] },
	    ];
	    /** @nocollapse */
	    MatStepper.ctorParameters = function () { return []; };
	    MatStepper.propDecorators = {
	        "_stepHeader": [{ type: _angular_core.ViewChildren, args: [MatStepHeader, { read: _angular_core.ElementRef },] },],
	        "_steps": [{ type: _angular_core.ContentChildren, args: [MatStep,] },],
	        "_icons": [{ type: _angular_core.ContentChildren, args: [MatStepperIcon,] },],
	    };
	    return MatStepper;
	}(_angular_cdk_stepper.CdkStepper));
	var MatHorizontalStepper = /** @class */ (function (_super) {
	    __extends(MatHorizontalStepper, _super);
	    function MatHorizontalStepper() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    MatHorizontalStepper.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-horizontal-stepper',
	                    exportAs: 'matHorizontalStepper',
	                    template: "<div class=\"mat-horizontal-stepper-header-container\"><ng-container *ngFor=\"let step of _steps; let i = index; let isLast = last\"><mat-step-header class=\"mat-horizontal-stepper-header\" (click)=\"step.select()\" (keydown)=\"_onKeydown($event)\" [tabIndex]=\"_focusIndex === i ? 0 : -1\" [id]=\"_getStepLabelId(i)\" [attr.aria-controls]=\"_getStepContentId(i)\" [attr.aria-selected]=\"selectedIndex == i\" [index]=\"i\" [state]=\"_getIndicatorType(i)\" [label]=\"step.stepLabel || step.label\" [selected]=\"selectedIndex === i\" [active]=\"step.completed || selectedIndex === i || !linear\" [optional]=\"step.optional\" [iconOverrides]=\"_iconOverrides\"></mat-step-header><div *ngIf=\"!isLast\" class=\"mat-stepper-horizontal-line\"></div></ng-container></div><div class=\"mat-horizontal-content-container\"><div *ngFor=\"let step of _steps; let i = index\" class=\"mat-horizontal-stepper-content\" role=\"tabpanel\" [@stepTransition]=\"_getAnimationDirection(i)\" [id]=\"_getStepContentId(i)\" [attr.aria-labelledby]=\"_getStepLabelId(i)\" [attr.aria-expanded]=\"selectedIndex === i\"><ng-container [ngTemplateOutlet]=\"step.content\"></ng-container></div></div>",
	                    styles: [".mat-stepper-horizontal,.mat-stepper-vertical{display:block}.mat-horizontal-stepper-header-container{white-space:nowrap;display:flex;align-items:center}.mat-stepper-horizontal-line{border-top-width:1px;border-top-style:solid;flex:auto;height:0;margin:0 -16px;min-width:32px}.mat-horizontal-stepper-header{display:flex;height:72px;overflow:hidden;align-items:center;padding:0 24px}.mat-horizontal-stepper-header .mat-step-icon,.mat-horizontal-stepper-header .mat-step-icon-not-touched{margin-right:8px;flex:none}[dir=rtl] .mat-horizontal-stepper-header .mat-step-icon,[dir=rtl] .mat-horizontal-stepper-header .mat-step-icon-not-touched{margin-right:0;margin-left:8px}.mat-vertical-stepper-header{display:flex;align-items:center;padding:24px;max-height:24px}.mat-vertical-stepper-header .mat-step-icon,.mat-vertical-stepper-header .mat-step-icon-not-touched{margin-right:12px}[dir=rtl] .mat-vertical-stepper-header .mat-step-icon,[dir=rtl] .mat-vertical-stepper-header .mat-step-icon-not-touched{margin-right:0;margin-left:12px}.mat-horizontal-stepper-content{overflow:hidden}.mat-horizontal-stepper-content[aria-expanded=false]{height:0}.mat-horizontal-content-container{overflow:hidden;padding:0 24px 24px 24px}.mat-vertical-content-container{margin-left:36px;border:0;position:relative}[dir=rtl] .mat-vertical-content-container{margin-left:0;margin-right:36px}.mat-stepper-vertical-line::before{content:'';position:absolute;top:-16px;bottom:-16px;left:0;border-left-width:1px;border-left-style:solid}[dir=rtl] .mat-stepper-vertical-line::before{left:auto;right:0}.mat-vertical-stepper-content{overflow:hidden}.mat-vertical-content{padding:0 24px 24px 24px}.mat-step:last-child .mat-vertical-content-container{border:none}"],
	                    inputs: ['selectedIndex'],
	                    host: {
	                        'class': 'mat-stepper-horizontal',
	                        'aria-orientation': 'horizontal',
	                        'role': 'tablist',
	                    },
	                    animations: [matStepperAnimations.horizontalStepTransition],
	                    providers: [{ provide: MatStepper, useExisting: MatHorizontalStepper }],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatHorizontalStepper.ctorParameters = function () { return []; };
	    return MatHorizontalStepper;
	}(MatStepper));
	var MatVerticalStepper = /** @class */ (function (_super) {
	    __extends(MatVerticalStepper, _super);
	    function MatVerticalStepper(dir, changeDetectorRef) {
	        var _this = _super.call(this, dir, changeDetectorRef) || this;
	        _this._orientation = 'vertical';
	        return _this;
	    }
	    MatVerticalStepper.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-vertical-stepper',
	                    exportAs: 'matVerticalStepper',
	                    template: "<div class=\"mat-step\" *ngFor=\"let step of _steps; let i = index; let isLast = last\"><mat-step-header class=\"mat-vertical-stepper-header\" (click)=\"step.select()\" (keydown)=\"_onKeydown($event)\" [tabIndex]=\"_focusIndex == i ? 0 : -1\" [id]=\"_getStepLabelId(i)\" [attr.aria-controls]=\"_getStepContentId(i)\" [attr.aria-selected]=\"selectedIndex === i\" [index]=\"i\" [state]=\"_getIndicatorType(i)\" [label]=\"step.stepLabel || step.label\" [selected]=\"selectedIndex === i\" [active]=\"step.completed || selectedIndex === i || !linear\" [optional]=\"step.optional\" [iconOverrides]=\"_iconOverrides\"></mat-step-header><div class=\"mat-vertical-content-container\" [class.mat-stepper-vertical-line]=\"!isLast\"><div class=\"mat-vertical-stepper-content\" role=\"tabpanel\" [@stepTransition]=\"_getAnimationDirection(i)\" [id]=\"_getStepContentId(i)\" [attr.aria-labelledby]=\"_getStepLabelId(i)\" [attr.aria-expanded]=\"selectedIndex === i\"><div class=\"mat-vertical-content\"><ng-container [ngTemplateOutlet]=\"step.content\"></ng-container></div></div></div></div>",
	                    styles: [".mat-stepper-horizontal,.mat-stepper-vertical{display:block}.mat-horizontal-stepper-header-container{white-space:nowrap;display:flex;align-items:center}.mat-stepper-horizontal-line{border-top-width:1px;border-top-style:solid;flex:auto;height:0;margin:0 -16px;min-width:32px}.mat-horizontal-stepper-header{display:flex;height:72px;overflow:hidden;align-items:center;padding:0 24px}.mat-horizontal-stepper-header .mat-step-icon,.mat-horizontal-stepper-header .mat-step-icon-not-touched{margin-right:8px;flex:none}[dir=rtl] .mat-horizontal-stepper-header .mat-step-icon,[dir=rtl] .mat-horizontal-stepper-header .mat-step-icon-not-touched{margin-right:0;margin-left:8px}.mat-vertical-stepper-header{display:flex;align-items:center;padding:24px;max-height:24px}.mat-vertical-stepper-header .mat-step-icon,.mat-vertical-stepper-header .mat-step-icon-not-touched{margin-right:12px}[dir=rtl] .mat-vertical-stepper-header .mat-step-icon,[dir=rtl] .mat-vertical-stepper-header .mat-step-icon-not-touched{margin-right:0;margin-left:12px}.mat-horizontal-stepper-content{overflow:hidden}.mat-horizontal-stepper-content[aria-expanded=false]{height:0}.mat-horizontal-content-container{overflow:hidden;padding:0 24px 24px 24px}.mat-vertical-content-container{margin-left:36px;border:0;position:relative}[dir=rtl] .mat-vertical-content-container{margin-left:0;margin-right:36px}.mat-stepper-vertical-line::before{content:'';position:absolute;top:-16px;bottom:-16px;left:0;border-left-width:1px;border-left-style:solid}[dir=rtl] .mat-stepper-vertical-line::before{left:auto;right:0}.mat-vertical-stepper-content{overflow:hidden}.mat-vertical-content{padding:0 24px 24px 24px}.mat-step:last-child .mat-vertical-content-container{border:none}"],
	                    inputs: ['selectedIndex'],
	                    host: {
	                        'class': 'mat-stepper-vertical',
	                        'aria-orientation': 'vertical',
	                        'role': 'tablist',
	                    },
	                    animations: [matStepperAnimations.verticalStepTransition],
	                    providers: [{ provide: MatStepper, useExisting: MatVerticalStepper }],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatVerticalStepper.ctorParameters = function () { return [
	        { type: _angular_cdk_bidi.Directionality, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_core.ChangeDetectorRef, },
	    ]; };
	    return MatVerticalStepper;
	}(MatStepper));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Button that moves to the next step in a stepper workflow.
	 */
	var MatStepperNext = /** @class */ (function (_super) {
	    __extends(MatStepperNext, _super);
	    function MatStepperNext() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    MatStepperNext.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'button[matStepperNext]',
	                    host: {
	                        '(click)': '_stepper.next()',
	                        '[type]': 'type',
	                    },
	                    inputs: ['type'],
	                    providers: [{ provide: _angular_cdk_stepper.CdkStepper, useExisting: MatStepper }]
	                },] },
	    ];
	    /** @nocollapse */
	    MatStepperNext.ctorParameters = function () { return []; };
	    return MatStepperNext;
	}(_angular_cdk_stepper.CdkStepperNext));
	/**
	 * Button that moves to the previous step in a stepper workflow.
	 */
	var MatStepperPrevious = /** @class */ (function (_super) {
	    __extends(MatStepperPrevious, _super);
	    function MatStepperPrevious() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    MatStepperPrevious.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'button[matStepperPrevious]',
	                    host: {
	                        '(click)': '_stepper.previous()',
	                        '[type]': 'type',
	                    },
	                    inputs: ['type'],
	                    providers: [{ provide: _angular_cdk_stepper.CdkStepper, useExisting: MatStepper }]
	                },] },
	    ];
	    /** @nocollapse */
	    MatStepperPrevious.ctorParameters = function () { return []; };
	    return MatStepperPrevious;
	}(_angular_cdk_stepper.CdkStepperPrevious));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatStepperModule = /** @class */ (function () {
	    function MatStepperModule() {
	    }
	    MatStepperModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [
	                        MatCommonModule,
	                        _angular_common.CommonModule,
	                        _angular_cdk_portal.PortalModule,
	                        MatButtonModule,
	                        _angular_cdk_stepper.CdkStepperModule,
	                        MatIconModule,
	                        _angular_cdk_a11y.A11yModule,
	                        MatRippleModule,
	                    ],
	                    exports: [
	                        MatCommonModule,
	                        MatHorizontalStepper,
	                        MatVerticalStepper,
	                        MatStep,
	                        MatStepLabel,
	                        MatStepper,
	                        MatStepperNext,
	                        MatStepperPrevious,
	                        MatStepHeader,
	                        MatStepperIcon,
	                    ],
	                    declarations: [
	                        MatHorizontalStepper,
	                        MatVerticalStepper,
	                        MatStep,
	                        MatStepLabel,
	                        MatStepper,
	                        MatStepperNext,
	                        MatStepperPrevious,
	                        MatStepHeader,
	                        MatStepperIcon,
	                    ],
	                    providers: [MatStepperIntl, ErrorStateMatcher],
	                },] },
	    ];
	    /** @nocollapse */
	    MatStepperModule.ctorParameters = function () { return []; };
	    return MatStepperModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Wrapper for the CdkTable with Material design styles.
	 */
	var MatTable = /** @class */ (function (_super) {
	    __extends(MatTable, _super);
	    function MatTable() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    MatTable.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-table',
	                    exportAs: 'matTable',
	                    template: _angular_cdk_table.CDK_TABLE_TEMPLATE,
	                    styles: [".mat-table{display:block}.mat-header-row{min-height:56px}.mat-row{min-height:48px}.mat-header-row,.mat-row{display:flex;border-bottom-width:1px;border-bottom-style:solid;align-items:center;padding:0 24px;box-sizing:border-box}.mat-header-row::after,.mat-row::after{display:inline-block;min-height:inherit;content:''}.mat-cell,.mat-header-cell{flex:1;overflow:hidden;word-wrap:break-word}"],
	                    host: {
	                        'class': 'mat-table',
	                    },
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatTable.ctorParameters = function () { return []; };
	    return MatTable;
	}(_angular_cdk_table.CdkTable));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Cell definition for the mat-table.
	 * Captures the template of a column's data row cell as well as cell-specific properties.
	 */
	var MatCellDef = /** @class */ (function (_super) {
	    __extends(MatCellDef, _super);
	    function MatCellDef() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    MatCellDef.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[matCellDef]',
	                    providers: [{ provide: _angular_cdk_table.CdkCellDef, useExisting: MatCellDef }]
	                },] },
	    ];
	    /** @nocollapse */
	    MatCellDef.ctorParameters = function () { return []; };
	    return MatCellDef;
	}(_angular_cdk_table.CdkCellDef));
	/**
	 * Header cell definition for the mat-table.
	 * Captures the template of a column's header cell and as well as cell-specific properties.
	 */
	var MatHeaderCellDef = /** @class */ (function (_super) {
	    __extends(MatHeaderCellDef, _super);
	    function MatHeaderCellDef() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    MatHeaderCellDef.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[matHeaderCellDef]',
	                    providers: [{ provide: _angular_cdk_table.CdkHeaderCellDef, useExisting: MatHeaderCellDef }]
	                },] },
	    ];
	    /** @nocollapse */
	    MatHeaderCellDef.ctorParameters = function () { return []; };
	    return MatHeaderCellDef;
	}(_angular_cdk_table.CdkHeaderCellDef));
	/**
	 * Column definition for the mat-table.
	 * Defines a set of cells available for a table column.
	 */
	var MatColumnDef = /** @class */ (function (_super) {
	    __extends(MatColumnDef, _super);
	    function MatColumnDef() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    MatColumnDef.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[matColumnDef]',
	                    providers: [{ provide: _angular_cdk_table.CdkColumnDef, useExisting: MatColumnDef }],
	                },] },
	    ];
	    /** @nocollapse */
	    MatColumnDef.ctorParameters = function () { return []; };
	    MatColumnDef.propDecorators = {
	        "name": [{ type: _angular_core.Input, args: ['matColumnDef',] },],
	    };
	    return MatColumnDef;
	}(_angular_cdk_table.CdkColumnDef));
	/**
	 * Header cell template container that adds the right classes and role.
	 */
	var MatHeaderCell = /** @class */ (function (_super) {
	    __extends(MatHeaderCell, _super);
	    function MatHeaderCell(columnDef, elementRef) {
	        var _this = _super.call(this, columnDef, elementRef) || this;
	        elementRef.nativeElement.classList.add("mat-column-" + columnDef.cssClassFriendlyName);
	        return _this;
	    }
	    MatHeaderCell.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-header-cell',
	                    host: {
	                        'class': 'mat-header-cell',
	                        'role': 'columnheader',
	                    },
	                },] },
	    ];
	    /** @nocollapse */
	    MatHeaderCell.ctorParameters = function () { return [
	        { type: _angular_cdk_table.CdkColumnDef, },
	        { type: _angular_core.ElementRef, },
	    ]; };
	    return MatHeaderCell;
	}(_angular_cdk_table.CdkHeaderCell));
	/**
	 * Cell template container that adds the right classes and role.
	 */
	var MatCell = /** @class */ (function (_super) {
	    __extends(MatCell, _super);
	    function MatCell(columnDef, elementRef) {
	        var _this = _super.call(this, columnDef, elementRef) || this;
	        elementRef.nativeElement.classList.add("mat-column-" + columnDef.cssClassFriendlyName);
	        return _this;
	    }
	    MatCell.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-cell',
	                    host: {
	                        'class': 'mat-cell',
	                        'role': 'gridcell',
	                    },
	                },] },
	    ];
	    /** @nocollapse */
	    MatCell.ctorParameters = function () { return [
	        { type: _angular_cdk_table.CdkColumnDef, },
	        { type: _angular_core.ElementRef, },
	    ]; };
	    return MatCell;
	}(_angular_cdk_table.CdkCell));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Header row definition for the mat-table.
	 * Captures the header row's template and other header properties such as the columns to display.
	 */
	var MatHeaderRowDef = /** @class */ (function (_super) {
	    __extends(MatHeaderRowDef, _super);
	    function MatHeaderRowDef() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    MatHeaderRowDef.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[matHeaderRowDef]',
	                    providers: [{ provide: _angular_cdk_table.CdkHeaderRowDef, useExisting: MatHeaderRowDef }],
	                    inputs: ['columns: matHeaderRowDef'],
	                },] },
	    ];
	    /** @nocollapse */
	    MatHeaderRowDef.ctorParameters = function () { return []; };
	    return MatHeaderRowDef;
	}(_angular_cdk_table.CdkHeaderRowDef));
	/**
	 * Data row definition for the mat-table.
	 * Captures the header row's template and other row properties such as the columns to display and
	 * a when predicate that describes when this row should be used.
	 */
	var MatRowDef = /** @class */ (function (_super) {
	    __extends(MatRowDef, _super);
	    function MatRowDef() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    MatRowDef.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[matRowDef]',
	                    providers: [{ provide: _angular_cdk_table.CdkRowDef, useExisting: MatRowDef }],
	                    inputs: ['columns: matRowDefColumns', 'when: matRowDefWhen'],
	                },] },
	    ];
	    /** @nocollapse */
	    MatRowDef.ctorParameters = function () { return []; };
	    return MatRowDef;
	}(_angular_cdk_table.CdkRowDef));
	/**
	 * Header template container that contains the cell outlet. Adds the right class and role.
	 */
	var MatHeaderRow = /** @class */ (function (_super) {
	    __extends(MatHeaderRow, _super);
	    function MatHeaderRow() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    MatHeaderRow.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-header-row',
	                    template: _angular_cdk_table.CDK_ROW_TEMPLATE,
	                    host: {
	                        'class': 'mat-header-row',
	                        'role': 'row',
	                    },
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    exportAs: 'matHeaderRow',
	                    preserveWhitespaces: false,
	                },] },
	    ];
	    /** @nocollapse */
	    MatHeaderRow.ctorParameters = function () { return []; };
	    return MatHeaderRow;
	}(_angular_cdk_table.CdkHeaderRow));
	/**
	 * Data row template container that contains the cell outlet. Adds the right class and role.
	 */
	var MatRow = /** @class */ (function (_super) {
	    __extends(MatRow, _super);
	    function MatRow() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    MatRow.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-row',
	                    template: _angular_cdk_table.CDK_ROW_TEMPLATE,
	                    host: {
	                        'class': 'mat-row',
	                        'role': 'row',
	                    },
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    exportAs: 'matRow',
	                    preserveWhitespaces: false,
	                },] },
	    ];
	    /** @nocollapse */
	    MatRow.ctorParameters = function () { return []; };
	    return MatRow;
	}(_angular_cdk_table.CdkRow));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatTableModule = /** @class */ (function () {
	    function MatTableModule() {
	    }
	    MatTableModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [_angular_cdk_table.CdkTableModule, _angular_common.CommonModule, MatCommonModule],
	                    exports: [MatTable, MatCellDef, MatHeaderCellDef, MatColumnDef,
	                        MatHeaderCell, MatCell, MatHeaderRow, MatRow,
	                        MatHeaderRowDef, MatRowDef],
	                    declarations: [MatTable, MatCellDef, MatHeaderCellDef, MatColumnDef,
	                        MatHeaderCell, MatCell, MatHeaderRow, MatRow,
	                        MatHeaderRowDef, MatRowDef],
	                },] },
	    ];
	    /** @nocollapse */
	    MatTableModule.ctorParameters = function () { return []; };
	    return MatTableModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Data source that accepts a client-side data array and includes native support of filtering,
	 * sorting (using MatSort), and pagination (using MatPaginator).
	 *
	 * Allows for sort customization by overriding sortingDataAccessor, which defines how data
	 * properties are accessed. Also allows for filter customization by overriding filterTermAccessor,
	 * which defines how row data is converted to a string for filter matching.
	 */
	var MatTableDataSource = /** @class */ (function (_super) {
	    __extends(MatTableDataSource, _super);
	    function MatTableDataSource(initialData) {
	        if (initialData === void 0) { initialData = []; }
	        var _this = _super.call(this) || this;
	        /**
	         * Stream emitting render data to the table (depends on ordered data changes).
	         */
	        _this._renderData = new rxjs_BehaviorSubject.BehaviorSubject([]);
	        /**
	         * Stream that emits when a new filter string is set on the data source.
	         */
	        _this._filter = new rxjs_BehaviorSubject.BehaviorSubject('');
	        /**
	         * Data accessor function that is used for accessing data properties for sorting through
	         * the default sortData function.
	         * This default function assumes that the sort header IDs (which defaults to the column name)
	         * matches the data's properties (e.g. column Xyz represents data['Xyz']).
	         * May be set to a custom function for different behavior.
	         * @param data Data object that is being accessed.
	         * @param sortHeaderId The name of the column that represents the data.
	         */
	        _this.sortingDataAccessor = function (data, sortHeaderId) {
	            var /** @type {?} */ value = data[sortHeaderId];
	            return _angular_cdk_coercion._isNumberValue(value) ? Number(value) : value;
	        };
	        /**
	         * Gets a sorted copy of the data array based on the state of the MatSort. Called
	         * after changes are made to the filtered data or when sort changes are emitted from MatSort.
	         * By default, the function retrieves the active sort and its direction and compares data
	         * by retrieving data using the sortingDataAccessor. May be overridden for a custom implementation
	         * of data ordering.
	         * @param data The array of data that should be sorted.
	         * @param sort The connected MatSort that holds the current sort state.
	         */
	        _this.sortData = function (data, sort) {
	            var /** @type {?} */ active = sort.active;
	            var /** @type {?} */ direction = sort.direction;
	            if (!active || direction == '') {
	                return data;
	            }
	            return data.sort(function (a, b) {
	                var /** @type {?} */ valueA = _this.sortingDataAccessor(a, active);
	                var /** @type {?} */ valueB = _this.sortingDataAccessor(b, active);
	                // If both valueA and valueB exist (truthy), then compare the two. Otherwise, check if
	                // one value exists while the other doesn't. In this case, existing value should come first.
	                // This avoids inconsistent results when comparing values to undefined/null.
	                // If neither value exists, return 0 (equal).
	                var /** @type {?} */ comparatorResult = 0;
	                if (valueA && valueB) {
	                    // Check if one value is greater than the other; if equal, comparatorResult should remain 0.
	                    if (valueA > valueB) {
	                        comparatorResult = 1;
	                    }
	                    else if (valueA < valueB) {
	                        comparatorResult = -1;
	                    }
	                }
	                else if (valueA) {
	                    comparatorResult = 1;
	                }
	                else if (valueB) {
	                    comparatorResult = -1;
	                }
	                return comparatorResult * (direction == 'asc' ? 1 : -1);
	            });
	        };
	        /**
	         * Checks if a data object matches the data source's filter string. By default, each data object
	         * is converted to a string of its properties and returns true if the filter has
	         * at least one occurrence in that string. By default, the filter string has its whitespace
	         * trimmed and the match is case-insensitive. May be overridden for a custom implementation of
	         * filter matching.
	         * @param data Data object used to check against the filter.
	         * @param filter Filter string that has been set on the data source.
	         * @return Whether the filter matches against the data
	         */
	        _this.filterPredicate = function (data, filter$$1) {
	            // Transform the data into a lowercase string of all property values.
	            var /** @type {?} */ accumulator = function (currentTerm, key) { return currentTerm + data[key]; };
	            var /** @type {?} */ dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
	            // Transform the filter by converting it to lowercase and removing whitespace.
	            var /** @type {?} */ transformedFilter = filter$$1.trim().toLowerCase();
	            return dataStr.indexOf(transformedFilter) != -1;
	        };
	        _this._data = new rxjs_BehaviorSubject.BehaviorSubject(initialData);
	        _this._updateChangeSubscription();
	        return _this;
	    }
	    Object.defineProperty(MatTableDataSource.prototype, "data", {
	        /** Array of data that should be rendered by the table, where each object represents one row. */
	        get: /**
	         * Array of data that should be rendered by the table, where each object represents one row.
	         * @return {?}
	         */
	        function () { return this._data.value; },
	        set: /**
	         * @param {?} data
	         * @return {?}
	         */
	        function (data) { this._data.next(data); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatTableDataSource.prototype, "filter", {
	        /**
	         * Filter term that should be used to filter out objects from the data array. To override how
	         * data objects match to this filter string, provide a custom function for filterPredicate.
	         */
	        get: /**
	         * Filter term that should be used to filter out objects from the data array. To override how
	         * data objects match to this filter string, provide a custom function for filterPredicate.
	         * @return {?}
	         */
	        function () { return this._filter.value; },
	        set: /**
	         * @param {?} filter
	         * @return {?}
	         */
	        function (filter$$1) { this._filter.next(filter$$1); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatTableDataSource.prototype, "sort", {
	        /**
	         * Instance of the MatSort directive used by the table to control its sorting. Sort changes
	         * emitted by the MatSort will trigger an update to the table's rendered data.
	         */
	        get: /**
	         * Instance of the MatSort directive used by the table to control its sorting. Sort changes
	         * emitted by the MatSort will trigger an update to the table's rendered data.
	         * @return {?}
	         */
	        function () { return this._sort; },
	        set: /**
	         * @param {?} sort
	         * @return {?}
	         */
	        function (sort) {
	            this._sort = sort;
	            this._updateChangeSubscription();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatTableDataSource.prototype, "paginator", {
	        /**
	         * Instance of the MatPaginator component used by the table to control what page of the data is
	         * displayed. Page changes emitted by the MatPaginator will trigger an update to the
	         * table's rendered data.
	         *
	         * Note that the data source uses the paginator's properties to calculate which page of data
	         * should be displayed. If the paginator receives its properties as template inputs,
	         * e.g. `[pageLength]=100` or `[pageIndex]=1`, then be sure that the paginator's view has been
	         * initialized before assigning it to this data source.
	         */
	        get: /**
	         * Instance of the MatPaginator component used by the table to control what page of the data is
	         * displayed. Page changes emitted by the MatPaginator will trigger an update to the
	         * table's rendered data.
	         *
	         * Note that the data source uses the paginator's properties to calculate which page of data
	         * should be displayed. If the paginator receives its properties as template inputs,
	         * e.g. `[pageLength]=100` or `[pageIndex]=1`, then be sure that the paginator's view has been
	         * initialized before assigning it to this data source.
	         * @return {?}
	         */
	        function () { return this._paginator; },
	        set: /**
	         * @param {?} paginator
	         * @return {?}
	         */
	        function (paginator) {
	            this._paginator = paginator;
	            this._updateChangeSubscription();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Subscribe to changes that should trigger an update to the table's rendered rows. When the
	     * changes occur, process the current state of the filter, sort, and pagination along with
	     * the provided base data and send it to the table for rendering.
	     */
	    /**
	     * Subscribe to changes that should trigger an update to the table's rendered rows. When the
	     * changes occur, process the current state of the filter, sort, and pagination along with
	     * the provided base data and send it to the table for rendering.
	     * @return {?}
	     */
	    MatTableDataSource.prototype._updateChangeSubscription = /**
	     * Subscribe to changes that should trigger an update to the table's rendered rows. When the
	     * changes occur, process the current state of the filter, sort, and pagination along with
	     * the provided base data and send it to the table for rendering.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        // Sorting and/or pagination should be watched if MatSort and/or MatPaginator are provided.
	        // Otherwise, use an empty observable stream to take their place.
	        var /** @type {?} */ sortChange = this._sort ? this._sort.sortChange : rxjs_observable_empty.empty();
	        var /** @type {?} */ pageChange = this._paginator ? this._paginator.page : rxjs_observable_empty.empty();
	        if (this._renderChangesSubscription) {
	            this._renderChangesSubscription.unsubscribe();
	        }
	        // Watch for base data or filter changes to provide a filtered set of data.
	        this._renderChangesSubscription = this._data.pipe(rxjs_operators_combineLatest.combineLatest(this._filter), rxjs_operators_map.map(function (_a) {
	            var data = _a[0];
	            return _this._filterData(data);
	        }), 
	        // Watch for filtered data or sort changes to provide an ordered set of data.
	        rxjs_operators_combineLatest.combineLatest(sortChange.pipe(rxjs_operators_startWith.startWith(/** @type {?} */ ((null))))), rxjs_operators_map.map(function (_a) {
	            var data = _a[0];
	            return _this._orderData(data);
	        }), 
	        // Watch for ordered data or page changes to provide a paged set of data.
	        rxjs_operators_combineLatest.combineLatest(pageChange.pipe(rxjs_operators_startWith.startWith(/** @type {?} */ ((null))))), rxjs_operators_map.map(function (_a) {
	            var data = _a[0];
	            return _this._pageData(data);
	        }))
	            .subscribe(function (data) { return _this._renderData.next(data); });
	    };
	    /**
	     * Returns a filtered data array where each filter object contains the filter string within
	     * the result of the filterTermAccessor function. If no filter is set, returns the data array
	     * as provided.
	     */
	    /**
	     * Returns a filtered data array where each filter object contains the filter string within
	     * the result of the filterTermAccessor function. If no filter is set, returns the data array
	     * as provided.
	     * @param {?} data
	     * @return {?}
	     */
	    MatTableDataSource.prototype._filterData = /**
	     * Returns a filtered data array where each filter object contains the filter string within
	     * the result of the filterTermAccessor function. If no filter is set, returns the data array
	     * as provided.
	     * @param {?} data
	     * @return {?}
	     */
	    function (data) {
	        var _this = this;
	        // If there is a filter string, filter out data that does not contain it.
	        // Each data object is converted to a string using the function defined by filterTermAccessor.
	        // May be overridden for customization.
	        this.filteredData =
	            !this.filter ? data : data.filter(function (obj) { return _this.filterPredicate(obj, _this.filter); });
	        if (this.paginator) {
	            this._updatePaginator(this.filteredData.length);
	        }
	        return this.filteredData;
	    };
	    /**
	     * Returns a sorted copy of the data if MatSort has a sort applied, otherwise just returns the
	     * data array as provided. Uses the default data accessor for data lookup, unless a
	     * sortDataAccessor function is defined.
	     */
	    /**
	     * Returns a sorted copy of the data if MatSort has a sort applied, otherwise just returns the
	     * data array as provided. Uses the default data accessor for data lookup, unless a
	     * sortDataAccessor function is defined.
	     * @param {?} data
	     * @return {?}
	     */
	    MatTableDataSource.prototype._orderData = /**
	     * Returns a sorted copy of the data if MatSort has a sort applied, otherwise just returns the
	     * data array as provided. Uses the default data accessor for data lookup, unless a
	     * sortDataAccessor function is defined.
	     * @param {?} data
	     * @return {?}
	     */
	    function (data) {
	        // If there is no active sort or direction, return the data without trying to sort.
	        if (!this.sort) {
	            return data;
	        }
	        return this.sortData(data.slice(), this.sort);
	    };
	    /**
	     * Returns a paged splice of the provided data array according to the provided MatPaginator's page
	     * index and length. If there is no paginator provided, returns the data array as provided.
	     */
	    /**
	     * Returns a paged splice of the provided data array according to the provided MatPaginator's page
	     * index and length. If there is no paginator provided, returns the data array as provided.
	     * @param {?} data
	     * @return {?}
	     */
	    MatTableDataSource.prototype._pageData = /**
	     * Returns a paged splice of the provided data array according to the provided MatPaginator's page
	     * index and length. If there is no paginator provided, returns the data array as provided.
	     * @param {?} data
	     * @return {?}
	     */
	    function (data) {
	        if (!this.paginator) {
	            return data;
	        }
	        var /** @type {?} */ startIndex = this.paginator.pageIndex * this.paginator.pageSize;
	        return data.slice().splice(startIndex, this.paginator.pageSize);
	    };
	    /**
	     * Updates the paginator to reflect the length of the filtered data, and makes sure that the page
	     * index does not exceed the paginator's last page. Values are changed in a resolved promise to
	     * guard against making property changes within a round of change detection.
	     */
	    /**
	     * Updates the paginator to reflect the length of the filtered data, and makes sure that the page
	     * index does not exceed the paginator's last page. Values are changed in a resolved promise to
	     * guard against making property changes within a round of change detection.
	     * @param {?} filteredDataLength
	     * @return {?}
	     */
	    MatTableDataSource.prototype._updatePaginator = /**
	     * Updates the paginator to reflect the length of the filtered data, and makes sure that the page
	     * index does not exceed the paginator's last page. Values are changed in a resolved promise to
	     * guard against making property changes within a round of change detection.
	     * @param {?} filteredDataLength
	     * @return {?}
	     */
	    function (filteredDataLength) {
	        var _this = this;
	        Promise.resolve().then(function () {
	            if (!_this.paginator) {
	                return;
	            }
	            _this.paginator.length = filteredDataLength;
	            // If the page index is set beyond the page, reduce it to the last page.
	            if (_this.paginator.pageIndex > 0) {
	                var /** @type {?} */ lastPageIndex = Math.ceil(_this.paginator.length / _this.paginator.pageSize) - 1 || 0;
	                _this.paginator.pageIndex = Math.min(_this.paginator.pageIndex, lastPageIndex);
	            }
	        });
	    };
	    /**
	     * Used by the MatTable. Called when it connects to the data source.
	     * @docs-private
	     */
	    /**
	     * Used by the MatTable. Called when it connects to the data source.
	     * \@docs-private
	     * @return {?}
	     */
	    MatTableDataSource.prototype.connect = /**
	     * Used by the MatTable. Called when it connects to the data source.
	     * \@docs-private
	     * @return {?}
	     */
	    function () { return this._renderData; };
	    /**
	     * Used by the MatTable. Called when it is destroyed. No-op.
	     * @docs-private
	     */
	    /**
	     * Used by the MatTable. Called when it is destroyed. No-op.
	     * \@docs-private
	     * @return {?}
	     */
	    MatTableDataSource.prototype.disconnect = /**
	     * Used by the MatTable. Called when it is destroyed. No-op.
	     * \@docs-private
	     * @return {?}
	     */
	    function () { };
	    return MatTableDataSource;
	}(_angular_cdk_table.DataSource));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * The ink-bar is used to display and animate the line underneath the current active tab label.
	 * \@docs-private
	 */
	var MatInkBar = /** @class */ (function () {
	    function MatInkBar(_elementRef, _ngZone) {
	        this._elementRef = _elementRef;
	        this._ngZone = _ngZone;
	    }
	    /**
	     * Calculates the styles from the provided element in order to align the ink-bar to that element.
	     * Shows the ink bar if previously set as hidden.
	     * @param element
	     */
	    /**
	     * Calculates the styles from the provided element in order to align the ink-bar to that element.
	     * Shows the ink bar if previously set as hidden.
	     * @param {?} element
	     * @return {?}
	     */
	    MatInkBar.prototype.alignToElement = /**
	     * Calculates the styles from the provided element in order to align the ink-bar to that element.
	     * Shows the ink bar if previously set as hidden.
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) {
	        var _this = this;
	        this.show();
	        if (typeof requestAnimationFrame !== 'undefined') {
	            this._ngZone.runOutsideAngular(function () {
	                requestAnimationFrame(function () { return _this._setStyles(element); });
	            });
	        }
	        else {
	            this._setStyles(element);
	        }
	    };
	    /** Shows the ink bar. */
	    /**
	     * Shows the ink bar.
	     * @return {?}
	     */
	    MatInkBar.prototype.show = /**
	     * Shows the ink bar.
	     * @return {?}
	     */
	    function () {
	        this._elementRef.nativeElement.style.visibility = 'visible';
	    };
	    /** Hides the ink bar. */
	    /**
	     * Hides the ink bar.
	     * @return {?}
	     */
	    MatInkBar.prototype.hide = /**
	     * Hides the ink bar.
	     * @return {?}
	     */
	    function () {
	        this._elementRef.nativeElement.style.visibility = 'hidden';
	    };
	    /**
	     * Sets the proper styles to the ink bar element.
	     * @param {?} element
	     * @return {?}
	     */
	    MatInkBar.prototype._setStyles = /**
	     * Sets the proper styles to the ink bar element.
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) {
	        var /** @type {?} */ inkBar = this._elementRef.nativeElement;
	        inkBar.style.left = element ? (element.offsetLeft || 0) + 'px' : '0';
	        inkBar.style.width = element ? (element.offsetWidth || 0) + 'px' : '0';
	    };
	    MatInkBar.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-ink-bar',
	                    host: {
	                        'class': 'mat-ink-bar',
	                    },
	                },] },
	    ];
	    /** @nocollapse */
	    MatInkBar.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.NgZone, },
	    ]; };
	    return MatInkBar;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Used to flag tab labels for use with the portal directive
	 */
	var MatTabLabel = /** @class */ (function (_super) {
	    __extends(MatTabLabel, _super);
	    function MatTabLabel(templateRef, viewContainerRef) {
	        return _super.call(this, templateRef, viewContainerRef) || this;
	    }
	    MatTabLabel.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-tab-label], [matTabLabel]',
	                },] },
	    ];
	    /** @nocollapse */
	    MatTabLabel.ctorParameters = function () { return [
	        { type: _angular_core.TemplateRef, },
	        { type: _angular_core.ViewContainerRef, },
	    ]; };
	    return MatTabLabel;
	}(_angular_cdk_portal.CdkPortal));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 */
	var MatTabBase = /** @class */ (function () {
	    function MatTabBase() {
	    }
	    return MatTabBase;
	}());
	var _MatTabMixinBase = mixinDisabled(MatTabBase);
	var MatTab = /** @class */ (function (_super) {
	    __extends(MatTab, _super);
	    function MatTab(_viewContainerRef) {
	        var _this = _super.call(this) || this;
	        _this._viewContainerRef = _viewContainerRef;
	        /**
	         * The plain text label for the tab, used when there is no template label.
	         */
	        _this.textLabel = '';
	        /**
	         * The portal that will be the hosted content of the tab
	         */
	        _this._contentPortal = null;
	        /**
	         * Emits whenever the label changes.
	         */
	        _this._labelChange = new rxjs_Subject.Subject();
	        /**
	         * Emits whenever the disable changes
	         */
	        _this._disableChange = new rxjs_Subject.Subject();
	        /**
	         * The relatively indexed position where 0 represents the center, negative is left, and positive
	         * represents the right.
	         */
	        _this.position = null;
	        /**
	         * The initial relatively index origin of the tab if it was created and selected after there
	         * was already a selected tab. Provides context of what position the tab should originate from.
	         */
	        _this.origin = null;
	        /**
	         * Whether the tab is currently active.
	         */
	        _this.isActive = false;
	        return _this;
	    }
	    Object.defineProperty(MatTab.prototype, "content", {
	        /** @docs-private */
	        get: /**
	         * \@docs-private
	         * @return {?}
	         */
	        function () {
	            return this._contentPortal;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    MatTab.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        if (changes.hasOwnProperty('textLabel')) {
	            this._labelChange.next();
	        }
	        if (changes.hasOwnProperty('disabled')) {
	            this._disableChange.next();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatTab.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._disableChange.complete();
	        this._labelChange.complete();
	    };
	    /**
	     * @return {?}
	     */
	    MatTab.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        this._contentPortal = new _angular_cdk_portal.TemplatePortal(this._content, this._viewContainerRef);
	    };
	    MatTab.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-tab',
	                    template: "<ng-template><ng-content></ng-content></ng-template>",
	                    inputs: ['disabled'],
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    exportAs: 'matTab',
	                },] },
	    ];
	    /** @nocollapse */
	    MatTab.ctorParameters = function () { return [
	        { type: _angular_core.ViewContainerRef, },
	    ]; };
	    MatTab.propDecorators = {
	        "templateLabel": [{ type: _angular_core.ContentChild, args: [MatTabLabel,] },],
	        "_content": [{ type: _angular_core.ViewChild, args: [_angular_core.TemplateRef,] },],
	        "textLabel": [{ type: _angular_core.Input, args: ['label',] },],
	    };
	    return MatTab;
	}(_MatTabMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * Animations used by the Material tabs.
	 */
	var matTabsAnimations = {
	    /** Animation translates a tab along the X axis. */
	    translateTab: _angular_animations.trigger('translateTab', [
	        // Note: transitions to `none` instead of 0, because some browsers might blur the content.
	        _angular_animations.state('center, void, left-origin-center, right-origin-center', _angular_animations.style({ transform: 'none' })),
	        _angular_animations.state('left', _angular_animations.style({ transform: 'translate3d(-100%, 0, 0)' })),
	        _angular_animations.state('right', _angular_animations.style({ transform: 'translate3d(100%, 0, 0)' })),
	        _angular_animations.transition('* => left, * => right, left => center, right => center', _angular_animations.animate('500ms cubic-bezier(0.35, 0, 0.25, 1)')),
	        _angular_animations.transition('void => left-origin-center', [
	            _angular_animations.style({ transform: 'translate3d(-100%, 0, 0)' }),
	            _angular_animations.animate('500ms cubic-bezier(0.35, 0, 0.25, 1)')
	        ]),
	        _angular_animations.transition('void => right-origin-center', [
	            _angular_animations.style({ transform: 'translate3d(100%, 0, 0)' }),
	            _angular_animations.animate('500ms cubic-bezier(0.35, 0, 0.25, 1)')
	        ])
	    ])
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * The portal host directive for the contents of the tab.
	 * \@docs-private
	 */
	var MatTabBodyPortal = /** @class */ (function (_super) {
	    __extends(MatTabBodyPortal, _super);
	    function MatTabBodyPortal(_componentFactoryResolver, _viewContainerRef, _host) {
	        var _this = _super.call(this, _componentFactoryResolver, _viewContainerRef) || this;
	        _this._host = _host;
	        return _this;
	    }
	    /** Set initial visibility or set up subscription for changing visibility. */
	    /**
	     * Set initial visibility or set up subscription for changing visibility.
	     * @return {?}
	     */
	    MatTabBodyPortal.prototype.ngOnInit = /**
	     * Set initial visibility or set up subscription for changing visibility.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._host._isCenterPosition(this._host._position)) {
	            this.attach(this._host._content);
	        }
	        this._centeringSub = this._host._beforeCentering.subscribe(function (isCentering) {
	            if (isCentering) {
	                if (!_this.hasAttached()) {
	                    _this.attach(_this._host._content);
	                }
	            }
	        });
	        this._leavingSub = this._host._afterLeavingCenter.subscribe(function () {
	            _this.detach();
	        });
	    };
	    /** Clean up centering subscription. */
	    /**
	     * Clean up centering subscription.
	     * @return {?}
	     */
	    MatTabBodyPortal.prototype.ngOnDestroy = /**
	     * Clean up centering subscription.
	     * @return {?}
	     */
	    function () {
	        if (this._centeringSub && !this._centeringSub.closed) {
	            this._centeringSub.unsubscribe();
	        }
	        if (this._leavingSub && !this._leavingSub.closed) {
	            this._leavingSub.unsubscribe();
	        }
	    };
	    MatTabBodyPortal.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[matTabBodyHost]'
	                },] },
	    ];
	    /** @nocollapse */
	    MatTabBodyPortal.ctorParameters = function () { return [
	        { type: _angular_core.ComponentFactoryResolver, },
	        { type: _angular_core.ViewContainerRef, },
	        { type: MatTabBody, decorators: [{ type: _angular_core.Inject, args: [_angular_core.forwardRef(function () { return MatTabBody; }),] },] },
	    ]; };
	    return MatTabBodyPortal;
	}(_angular_cdk_portal.CdkPortalOutlet));
	/**
	 * Wrapper for the contents of a tab.
	 * \@docs-private
	 */
	var MatTabBody = /** @class */ (function () {
	    function MatTabBody(_elementRef, _dir) {
	        this._elementRef = _elementRef;
	        this._dir = _dir;
	        /**
	         * Event emitted when the tab begins to animate towards the center as the active tab.
	         */
	        this._onCentering = new _angular_core.EventEmitter();
	        /**
	         * Event emitted before the centering of the tab begins.
	         */
	        this._beforeCentering = new _angular_core.EventEmitter();
	        /**
	         * Event emitted before the centering of the tab begins.
	         */
	        this._afterLeavingCenter = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when the tab completes its animation towards the center.
	         */
	        this._onCentered = new _angular_core.EventEmitter(true);
	    }
	    Object.defineProperty(MatTabBody.prototype, "position", {
	        set: /**
	         * The shifted index position of the tab body, where zero represents the active center tab.
	         * @param {?} position
	         * @return {?}
	         */
	        function (position) {
	            if (position < 0) {
	                this._position = this._getLayoutDirection() == 'ltr' ? 'left' : 'right';
	            }
	            else if (position > 0) {
	                this._position = this._getLayoutDirection() == 'ltr' ? 'right' : 'left';
	            }
	            else {
	                this._position = 'center';
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatTabBody.prototype, "origin", {
	        set: /**
	         * The origin position from which this tab should appear when it is centered into view.
	         * @param {?} origin
	         * @return {?}
	         */
	        function (origin) {
	            if (origin == null) {
	                return;
	            }
	            var /** @type {?} */ dir = this._getLayoutDirection();
	            if ((dir == 'ltr' && origin <= 0) || (dir == 'rtl' && origin > 0)) {
	                this._origin = 'left';
	            }
	            else {
	                this._origin = 'right';
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * After initialized, check if the content is centered and has an origin. If so, set the
	     * special position states that transition the tab from the left or right before centering.
	     */
	    /**
	     * After initialized, check if the content is centered and has an origin. If so, set the
	     * special position states that transition the tab from the left or right before centering.
	     * @return {?}
	     */
	    MatTabBody.prototype.ngOnInit = /**
	     * After initialized, check if the content is centered and has an origin. If so, set the
	     * special position states that transition the tab from the left or right before centering.
	     * @return {?}
	     */
	    function () {
	        if (this._position == 'center' && this._origin) {
	            this._position = this._origin == 'left' ? 'left-origin-center' : 'right-origin-center';
	        }
	    };
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    MatTabBody.prototype._onTranslateTabStarted = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        var /** @type {?} */ isCentering = this._isCenterPosition(e.toState);
	        this._beforeCentering.emit(isCentering);
	        if (isCentering) {
	            this._onCentering.emit(this._elementRef.nativeElement.clientHeight);
	        }
	    };
	    /**
	     * @param {?} e
	     * @return {?}
	     */
	    MatTabBody.prototype._onTranslateTabComplete = /**
	     * @param {?} e
	     * @return {?}
	     */
	    function (e) {
	        // If the transition to the center is complete, emit an event.
	        if (this._isCenterPosition(e.toState) && this._isCenterPosition(this._position)) {
	            this._onCentered.emit();
	        }
	        if (this._isCenterPosition(e.fromState) && !this._isCenterPosition(this._position)) {
	            this._afterLeavingCenter.emit();
	        }
	    };
	    /** The text direction of the containing app. */
	    /**
	     * The text direction of the containing app.
	     * @return {?}
	     */
	    MatTabBody.prototype._getLayoutDirection = /**
	     * The text direction of the containing app.
	     * @return {?}
	     */
	    function () {
	        return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
	    };
	    /** Whether the provided position state is considered center, regardless of origin. */
	    /**
	     * Whether the provided position state is considered center, regardless of origin.
	     * @param {?} position
	     * @return {?}
	     */
	    MatTabBody.prototype._isCenterPosition = /**
	     * Whether the provided position state is considered center, regardless of origin.
	     * @param {?} position
	     * @return {?}
	     */
	    function (position) {
	        return position == 'center' ||
	            position == 'left-origin-center' ||
	            position == 'right-origin-center';
	    };
	    MatTabBody.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-tab-body',
	                    template: "<div class=\"mat-tab-body-content\" #content [@translateTab]=\"_position\" (@translateTab.start)=\"_onTranslateTabStarted($event)\" (@translateTab.done)=\"_onTranslateTabComplete($event)\"><ng-template matTabBodyHost></ng-template></div>",
	                    styles: [".mat-tab-body-content{height:100%;overflow:auto}.mat-tab-group-dynamic-height .mat-tab-body-content{overflow:hidden}"],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    animations: [matTabsAnimations.translateTab],
	                    host: {
	                        'class': 'mat-tab-body',
	                    },
	                },] },
	    ];
	    /** @nocollapse */
	    MatTabBody.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_bidi.Directionality, decorators: [{ type: _angular_core.Optional },] },
	    ]; };
	    MatTabBody.propDecorators = {
	        "_onCentering": [{ type: _angular_core.Output },],
	        "_beforeCentering": [{ type: _angular_core.Output },],
	        "_afterLeavingCenter": [{ type: _angular_core.Output },],
	        "_onCentered": [{ type: _angular_core.Output },],
	        "_content": [{ type: _angular_core.Input, args: ['content',] },],
	        "position": [{ type: _angular_core.Input },],
	        "origin": [{ type: _angular_core.Input },],
	    };
	    return MatTabBody;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Used to generate unique ID's for each tab component
	 */
	var nextId = 0;
	/**
	 * A simple change event emitted on focus or selection changes.
	 */
	var MatTabChangeEvent = /** @class */ (function () {
	    function MatTabChangeEvent() {
	    }
	    return MatTabChangeEvent;
	}());
	/**
	 * \@docs-private
	 */
	var MatTabGroupBase = /** @class */ (function () {
	    function MatTabGroupBase(_elementRef) {
	        this._elementRef = _elementRef;
	    }
	    return MatTabGroupBase;
	}());
	var _MatTabGroupMixinBase = mixinColor(mixinDisableRipple(MatTabGroupBase), 'primary');
	/**
	 * Material design tab-group component.  Supports basic tab pairs (label + content) and includes
	 * animated ink-bar, keyboard navigation, and screen reader.
	 * See: https://www.google.com/design/spec/components/tabs.html
	 */
	var MatTabGroup = /** @class */ (function (_super) {
	    __extends(MatTabGroup, _super);
	    function MatTabGroup(elementRef, _changeDetectorRef) {
	        var _this = _super.call(this, elementRef) || this;
	        _this._changeDetectorRef = _changeDetectorRef;
	        /**
	         * The tab index that should be selected after the content has been checked.
	         */
	        _this._indexToSelect = 0;
	        /**
	         * Snapshot of the height of the tab body wrapper before another tab is activated.
	         */
	        _this._tabBodyWrapperHeight = 0;
	        /**
	         * Subscription to tabs being added/removed.
	         */
	        _this._tabsSubscription = rxjs_Subscription.Subscription.EMPTY;
	        /**
	         * Subscription to changes in the tab labels.
	         */
	        _this._tabLabelSubscription = rxjs_Subscription.Subscription.EMPTY;
	        _this._dynamicHeight = false;
	        _this._selectedIndex = null;
	        /**
	         * Position of the tab header.
	         */
	        _this.headerPosition = 'above';
	        /**
	         * Output to enable support for two-way binding on `[(selectedIndex)]`
	         */
	        _this.selectedIndexChange = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when focus has changed within a tab group.
	         */
	        _this.focusChange = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when the body animation has completed
	         */
	        _this.animationDone = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when the tab selection has changed.
	         */
	        _this.selectedTabChange = new _angular_core.EventEmitter(true);
	        /**
	         * Event emitted when the tab selection has changed.
	         * @deprecated Use `selectedTabChange` instead.
	         * \@deletion-target 6.0.0
	         */
	        _this.selectChange = _this.selectedTabChange;
	        _this._groupId = nextId++;
	        return _this;
	    }
	    Object.defineProperty(MatTabGroup.prototype, "dynamicHeight", {
	        get: /**
	         * Whether the tab group should grow to the size of the active tab.
	         * @return {?}
	         */
	        function () { return this._dynamicHeight; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._dynamicHeight = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatTabGroup.prototype, "_dynamicHeightDeprecated", {
	        get: /**
	         * @deprecated
	         * \@deletion-target 6.0.0
	         * @return {?}
	         */
	        function () { return this._dynamicHeight; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._dynamicHeight = value; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatTabGroup.prototype, "selectedIndex", {
	        get: /**
	         * The index of the active tab.
	         * @return {?}
	         */
	        function () { return this._selectedIndex; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._indexToSelect = _angular_cdk_coercion.coerceNumberProperty(value, null);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatTabGroup.prototype, "backgroundColor", {
	        get: /**
	         * Background color of the tab group.
	         * @return {?}
	         */
	        function () { return this._backgroundColor; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            var /** @type {?} */ nativeElement = this._elementRef.nativeElement;
	            nativeElement.classList.remove("mat-background-" + this.backgroundColor);
	            if (value) {
	                nativeElement.classList.add("mat-background-" + value);
	            }
	            this._backgroundColor = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * After the content is checked, this component knows what tabs have been defined
	     * and what the selected index should be. This is where we can know exactly what position
	     * each tab should be in according to the new selected index, and additionally we know how
	     * a new selected tab should transition in (from the left or right).
	     */
	    /**
	     * After the content is checked, this component knows what tabs have been defined
	     * and what the selected index should be. This is where we can know exactly what position
	     * each tab should be in according to the new selected index, and additionally we know how
	     * a new selected tab should transition in (from the left or right).
	     * @return {?}
	     */
	    MatTabGroup.prototype.ngAfterContentChecked = /**
	     * After the content is checked, this component knows what tabs have been defined
	     * and what the selected index should be. This is where we can know exactly what position
	     * each tab should be in according to the new selected index, and additionally we know how
	     * a new selected tab should transition in (from the left or right).
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        // Clamp the next selected index to the boundsof 0 and the tabs length.
	        // Note the `|| 0`, which ensures that values like NaN can't get through
	        // and which would otherwise throw the component into an infinite loop
	        // (since Math.max(NaN, 0) === NaN).
	        var /** @type {?} */ indexToSelect = this._indexToSelect =
	            Math.min(this._tabs.length - 1, Math.max(this._indexToSelect || 0, 0));
	        // If there is a change in selected index, emit a change event. Should not trigger if
	        // the selected index has not yet been initialized.
	        if (this._selectedIndex != indexToSelect && this._selectedIndex != null) {
	            var /** @type {?} */ tabChangeEvent = this._createChangeEvent(indexToSelect);
	            this.selectedTabChange.emit(tabChangeEvent);
	            // Emitting this value after change detection has run
	            // since the checked content may contain this variable'
	            Promise.resolve().then(function () { return _this.selectedIndexChange.emit(indexToSelect); });
	        }
	        // Setup the position for each tab and optionally setup an origin on the next selected tab.
	        this._tabs.forEach(function (tab, index) {
	            tab.position = index - indexToSelect;
	            tab.isActive = index === indexToSelect;
	            // If there is already a selected tab, then set up an origin for the next selected tab
	            // if it doesn't have one already.
	            if (_this._selectedIndex != null && tab.position == 0 && !tab.origin) {
	                tab.origin = indexToSelect - _this._selectedIndex;
	            }
	        });
	        if (this._selectedIndex !== indexToSelect) {
	            this._selectedIndex = indexToSelect;
	            this._changeDetectorRef.markForCheck();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatTabGroup.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._subscribeToTabLabels();
	        // Subscribe to changes in the amount of tabs, in order to be
	        // able to re-render the content as new tabs are added or removed.
	        this._tabsSubscription = this._tabs.changes.subscribe(function () {
	            _this._subscribeToTabLabels();
	            _this._changeDetectorRef.markForCheck();
	        });
	    };
	    /**
	     * @return {?}
	     */
	    MatTabGroup.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._tabsSubscription.unsubscribe();
	        this._tabLabelSubscription.unsubscribe();
	    };
	    /**
	     * @param {?} index
	     * @return {?}
	     */
	    MatTabGroup.prototype._focusChanged = /**
	     * @param {?} index
	     * @return {?}
	     */
	    function (index) {
	        this.focusChange.emit(this._createChangeEvent(index));
	    };
	    /**
	     * @param {?} index
	     * @return {?}
	     */
	    MatTabGroup.prototype._createChangeEvent = /**
	     * @param {?} index
	     * @return {?}
	     */
	    function (index) {
	        var /** @type {?} */ event = new MatTabChangeEvent;
	        event.index = index;
	        if (this._tabs && this._tabs.length) {
	            event.tab = this._tabs.toArray()[index];
	        }
	        return event;
	    };
	    /**
	     * Subscribes to changes in the tab labels. This is needed, because the \@Input for the label is
	     * on the MatTab component, whereas the data binding is inside the MatTabGroup. In order for the
	     * binding to be updated, we need to subscribe to changes in it and trigger change detection
	     * manually.
	     * @return {?}
	     */
	    MatTabGroup.prototype._subscribeToTabLabels = /**
	     * Subscribes to changes in the tab labels. This is needed, because the \@Input for the label is
	     * on the MatTab component, whereas the data binding is inside the MatTabGroup. In order for the
	     * binding to be updated, we need to subscribe to changes in it and trigger change detection
	     * manually.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._tabLabelSubscription) {
	            this._tabLabelSubscription.unsubscribe();
	        }
	        this._tabLabelSubscription = rxjs_observable_merge.merge.apply(void 0, this._tabs.map(function (tab) { return tab._disableChange; }).concat(this._tabs.map(function (tab) { return tab._labelChange; }))).subscribe(function () {
	            _this._changeDetectorRef.markForCheck();
	        });
	    };
	    /** Returns a unique id for each tab label element */
	    /**
	     * Returns a unique id for each tab label element
	     * @param {?} i
	     * @return {?}
	     */
	    MatTabGroup.prototype._getTabLabelId = /**
	     * Returns a unique id for each tab label element
	     * @param {?} i
	     * @return {?}
	     */
	    function (i) {
	        return "mat-tab-label-" + this._groupId + "-" + i;
	    };
	    /** Returns a unique id for each tab content element */
	    /**
	     * Returns a unique id for each tab content element
	     * @param {?} i
	     * @return {?}
	     */
	    MatTabGroup.prototype._getTabContentId = /**
	     * Returns a unique id for each tab content element
	     * @param {?} i
	     * @return {?}
	     */
	    function (i) {
	        return "mat-tab-content-" + this._groupId + "-" + i;
	    };
	    /**
	     * Sets the height of the body wrapper to the height of the activating tab if dynamic
	     * height property is true.
	     */
	    /**
	     * Sets the height of the body wrapper to the height of the activating tab if dynamic
	     * height property is true.
	     * @param {?} tabHeight
	     * @return {?}
	     */
	    MatTabGroup.prototype._setTabBodyWrapperHeight = /**
	     * Sets the height of the body wrapper to the height of the activating tab if dynamic
	     * height property is true.
	     * @param {?} tabHeight
	     * @return {?}
	     */
	    function (tabHeight) {
	        if (!this._dynamicHeight || !this._tabBodyWrapperHeight) {
	            return;
	        }
	        var /** @type {?} */ wrapper = this._tabBodyWrapper.nativeElement;
	        wrapper.style.height = this._tabBodyWrapperHeight + 'px';
	        // This conditional forces the browser to paint the height so that
	        // the animation to the new height can have an origin.
	        if (this._tabBodyWrapper.nativeElement.offsetHeight) {
	            wrapper.style.height = tabHeight + 'px';
	        }
	    };
	    /** Removes the height of the tab body wrapper. */
	    /**
	     * Removes the height of the tab body wrapper.
	     * @return {?}
	     */
	    MatTabGroup.prototype._removeTabBodyWrapperHeight = /**
	     * Removes the height of the tab body wrapper.
	     * @return {?}
	     */
	    function () {
	        this._tabBodyWrapperHeight = this._tabBodyWrapper.nativeElement.clientHeight;
	        this._tabBodyWrapper.nativeElement.style.height = '';
	        this.animationDone.emit();
	    };
	    /** Handle click events, setting new selected index if appropriate. */
	    /**
	     * Handle click events, setting new selected index if appropriate.
	     * @param {?} tab
	     * @param {?} tabHeader
	     * @param {?} idx
	     * @return {?}
	     */
	    MatTabGroup.prototype._handleClick = /**
	     * Handle click events, setting new selected index if appropriate.
	     * @param {?} tab
	     * @param {?} tabHeader
	     * @param {?} idx
	     * @return {?}
	     */
	    function (tab, tabHeader, idx) {
	        if (!tab.disabled) {
	            this.selectedIndex = tabHeader.focusIndex = idx;
	        }
	    };
	    /** Retrieves the tabindex for the tab. */
	    /**
	     * Retrieves the tabindex for the tab.
	     * @param {?} tab
	     * @param {?} idx
	     * @return {?}
	     */
	    MatTabGroup.prototype._getTabIndex = /**
	     * Retrieves the tabindex for the tab.
	     * @param {?} tab
	     * @param {?} idx
	     * @return {?}
	     */
	    function (tab, idx) {
	        if (tab.disabled) {
	            return null;
	        }
	        return this.selectedIndex === idx ? 0 : -1;
	    };
	    MatTabGroup.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-tab-group',
	                    exportAs: 'matTabGroup',
	                    template: "<mat-tab-header #tabHeader [selectedIndex]=\"selectedIndex\" [disableRipple]=\"disableRipple\" (indexFocused)=\"_focusChanged($event)\" (selectFocusedIndex)=\"selectedIndex = $event\"><div class=\"mat-tab-label\" role=\"tab\" matTabLabelWrapper mat-ripple *ngFor=\"let tab of _tabs; let i = index\" [id]=\"_getTabLabelId(i)\" [attr.tabIndex]=\"_getTabIndex(tab, i)\" [attr.aria-controls]=\"_getTabContentId(i)\" [attr.aria-selected]=\"selectedIndex == i\" [class.mat-tab-label-active]=\"selectedIndex == i\" [disabled]=\"tab.disabled\" [matRippleDisabled]=\"tab.disabled || disableRipple\" (click)=\"_handleClick(tab, tabHeader, i)\"><div class=\"mat-tab-label-content\"><ng-template [ngIf]=\"tab.templateLabel\"><ng-template [cdkPortalOutlet]=\"tab.templateLabel\"></ng-template></ng-template><ng-template [ngIf]=\"!tab.templateLabel\">{{tab.textLabel}}</ng-template></div></div></mat-tab-header><div class=\"mat-tab-body-wrapper\" #tabBodyWrapper><mat-tab-body role=\"tabpanel\" *ngFor=\"let tab of _tabs; let i = index\" [id]=\"_getTabContentId(i)\" [attr.aria-labelledby]=\"_getTabLabelId(i)\" [class.mat-tab-body-active]=\"selectedIndex == i\" [content]=\"tab.content\" [position]=\"tab.position\" [origin]=\"tab.origin\" (_onCentered)=\"_removeTabBodyWrapperHeight()\" (_onCentering)=\"_setTabBodyWrapperHeight($event)\"></mat-tab-body></div>",
	                    styles: [".mat-tab-group{display:flex;flex-direction:column}.mat-tab-group.mat-tab-group-inverted-header{flex-direction:column-reverse}.mat-tab-label{height:48px;padding:0 24px;cursor:pointer;box-sizing:border-box;opacity:.6;min-width:160px;text-align:center;display:inline-flex;justify-content:center;align-items:center;white-space:nowrap;position:relative}.mat-tab-label:focus{outline:0}.mat-tab-label:focus:not(.mat-tab-disabled){opacity:1}.mat-tab-label.mat-tab-disabled{cursor:default}.mat-tab-label.mat-tab-label-content{display:inline-flex;justify-content:center;align-items:center;white-space:nowrap}@media (max-width:599px){.mat-tab-label{padding:0 12px}}@media (max-width:959px){.mat-tab-label{padding:0 12px}}.mat-tab-group[mat-stretch-tabs] .mat-tab-label{flex-basis:0;flex-grow:1}.mat-tab-body-wrapper{position:relative;overflow:hidden;display:flex;transition:height .5s cubic-bezier(.35,0,.25,1)}.mat-tab-body{top:0;left:0;right:0;bottom:0;position:absolute;display:block;overflow:hidden}.mat-tab-body.mat-tab-body-active{position:relative;overflow-x:hidden;overflow-y:auto;z-index:1;flex-grow:1}.mat-tab-group.mat-tab-group-dynamic-height .mat-tab-body.mat-tab-body-active{overflow-y:hidden}"],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    inputs: ['color', 'disableRipple'],
	                    host: {
	                        'class': 'mat-tab-group',
	                        '[class.mat-tab-group-dynamic-height]': 'dynamicHeight',
	                        '[class.mat-tab-group-inverted-header]': 'headerPosition === "below"',
	                    },
	                },] },
	    ];
	    /** @nocollapse */
	    MatTabGroup.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.ChangeDetectorRef, },
	    ]; };
	    MatTabGroup.propDecorators = {
	        "_tabs": [{ type: _angular_core.ContentChildren, args: [MatTab,] },],
	        "_tabBodyWrapper": [{ type: _angular_core.ViewChild, args: ['tabBodyWrapper',] },],
	        "dynamicHeight": [{ type: _angular_core.Input },],
	        "_dynamicHeightDeprecated": [{ type: _angular_core.Input, args: ['mat-dynamic-height',] },],
	        "selectedIndex": [{ type: _angular_core.Input },],
	        "headerPosition": [{ type: _angular_core.Input },],
	        "backgroundColor": [{ type: _angular_core.Input },],
	        "selectedIndexChange": [{ type: _angular_core.Output },],
	        "focusChange": [{ type: _angular_core.Output },],
	        "animationDone": [{ type: _angular_core.Output },],
	        "selectedTabChange": [{ type: _angular_core.Output },],
	        "selectChange": [{ type: _angular_core.Output },],
	    };
	    return MatTabGroup;
	}(_MatTabGroupMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 */
	var MatTabLabelWrapperBase = /** @class */ (function () {
	    function MatTabLabelWrapperBase() {
	    }
	    return MatTabLabelWrapperBase;
	}());
	var _MatTabLabelWrapperMixinBase = mixinDisabled(MatTabLabelWrapperBase);
	/**
	 * Used in the `mat-tab-group` view to display tab labels.
	 * \@docs-private
	 */
	var MatTabLabelWrapper = /** @class */ (function (_super) {
	    __extends(MatTabLabelWrapper, _super);
	    function MatTabLabelWrapper(elementRef) {
	        var _this = _super.call(this) || this;
	        _this.elementRef = elementRef;
	        return _this;
	    }
	    /** Sets focus on the wrapper element */
	    /**
	     * Sets focus on the wrapper element
	     * @return {?}
	     */
	    MatTabLabelWrapper.prototype.focus = /**
	     * Sets focus on the wrapper element
	     * @return {?}
	     */
	    function () {
	        this.elementRef.nativeElement.focus();
	    };
	    /**
	     * @return {?}
	     */
	    MatTabLabelWrapper.prototype.getOffsetLeft = /**
	     * @return {?}
	     */
	    function () {
	        return this.elementRef.nativeElement.offsetLeft;
	    };
	    /**
	     * @return {?}
	     */
	    MatTabLabelWrapper.prototype.getOffsetWidth = /**
	     * @return {?}
	     */
	    function () {
	        return this.elementRef.nativeElement.offsetWidth;
	    };
	    MatTabLabelWrapper.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[matTabLabelWrapper]',
	                    inputs: ['disabled'],
	                    host: {
	                        '[class.mat-tab-disabled]': 'disabled'
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatTabLabelWrapper.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	    ]; };
	    return MatTabLabelWrapper;
	}(_MatTabLabelWrapperMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * The distance in pixels that will be overshot when scrolling a tab label into view. This helps
	 * provide a small affordance to the label next to it.
	 */
	var EXAGGERATED_OVERSCROLL = 60;
	/**
	 * \@docs-private
	 */
	var MatTabHeaderBase = /** @class */ (function () {
	    function MatTabHeaderBase() {
	    }
	    return MatTabHeaderBase;
	}());
	var _MatTabHeaderMixinBase = mixinDisableRipple(MatTabHeaderBase);
	/**
	 * The header of the tab group which displays a list of all the tabs in the tab group. Includes
	 * an ink bar that follows the currently selected tab. When the tabs list's width exceeds the
	 * width of the header container, then arrows will be displayed to allow the user to scroll
	 * left and right across the header.
	 * \@docs-private
	 */
	var MatTabHeader = /** @class */ (function (_super) {
	    __extends(MatTabHeader, _super);
	    function MatTabHeader(_elementRef, _changeDetectorRef, _viewportRuler, _dir) {
	        var _this = _super.call(this) || this;
	        _this._elementRef = _elementRef;
	        _this._changeDetectorRef = _changeDetectorRef;
	        _this._viewportRuler = _viewportRuler;
	        _this._dir = _dir;
	        /**
	         * The tab index that is focused.
	         */
	        _this._focusIndex = 0;
	        /**
	         * The distance in pixels that the tab labels should be translated to the left.
	         */
	        _this._scrollDistance = 0;
	        /**
	         * Whether the header should scroll to the selected index after the view has been checked.
	         */
	        _this._selectedIndexChanged = false;
	        /**
	         * Combines listeners that will re-align the ink bar whenever they're invoked.
	         */
	        _this._realignInkBar = rxjs_Subscription.Subscription.EMPTY;
	        /**
	         * Whether the controls for pagination should be displayed
	         */
	        _this._showPaginationControls = false;
	        /**
	         * Whether the tab list can be scrolled more towards the end of the tab label list.
	         */
	        _this._disableScrollAfter = true;
	        /**
	         * Whether the tab list can be scrolled more towards the beginning of the tab label list.
	         */
	        _this._disableScrollBefore = true;
	        _this._selectedIndex = 0;
	        /**
	         * Event emitted when the option is selected.
	         */
	        _this.selectFocusedIndex = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when a label is focused.
	         */
	        _this.indexFocused = new _angular_core.EventEmitter();
	        return _this;
	    }
	    Object.defineProperty(MatTabHeader.prototype, "selectedIndex", {
	        get: /**
	         * The index of the active tab.
	         * @return {?}
	         */
	        function () { return this._selectedIndex; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            value = _angular_cdk_coercion.coerceNumberProperty(value);
	            this._selectedIndexChanged = this._selectedIndex != value;
	            this._selectedIndex = value;
	            this._focusIndex = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatTabHeader.prototype.ngAfterContentChecked = /**
	     * @return {?}
	     */
	    function () {
	        // If the number of tab labels have changed, check if scrolling should be enabled
	        if (this._tabLabelCount != this._labelWrappers.length) {
	            this._updatePagination();
	            this._tabLabelCount = this._labelWrappers.length;
	            this._changeDetectorRef.markForCheck();
	        }
	        // If the selected index has changed, scroll to the label and check if the scrolling controls
	        // should be disabled.
	        if (this._selectedIndexChanged) {
	            this._scrollToLabel(this._selectedIndex);
	            this._checkScrollingControls();
	            this._alignInkBarToSelectedTab();
	            this._selectedIndexChanged = false;
	            this._changeDetectorRef.markForCheck();
	        }
	        // If the scroll distance has been changed (tab selected, focused, scroll controls activated),
	        // then translate the header to reflect this.
	        if (this._scrollDistanceChanged) {
	            this._updateTabScrollPosition();
	            this._scrollDistanceChanged = false;
	            this._changeDetectorRef.markForCheck();
	        }
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    MatTabHeader.prototype._handleKeydown = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        switch (event.keyCode) {
	            case _angular_cdk_keycodes.RIGHT_ARROW:
	                this._focusNextTab();
	                break;
	            case _angular_cdk_keycodes.LEFT_ARROW:
	                this._focusPreviousTab();
	                break;
	            case _angular_cdk_keycodes.HOME:
	                this._focusFirstTab();
	                event.preventDefault();
	                break;
	            case _angular_cdk_keycodes.END:
	                this._focusLastTab();
	                event.preventDefault();
	                break;
	            case _angular_cdk_keycodes.ENTER:
	            case _angular_cdk_keycodes.SPACE:
	                this.selectFocusedIndex.emit(this.focusIndex);
	                event.preventDefault();
	                break;
	        }
	    };
	    /**
	     * Aligns the ink bar to the selected tab on load.
	     */
	    /**
	     * Aligns the ink bar to the selected tab on load.
	     * @return {?}
	     */
	    MatTabHeader.prototype.ngAfterContentInit = /**
	     * Aligns the ink bar to the selected tab on load.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ dirChange = this._dir ? this._dir.change : rxjs_observable_of.of(null);
	        var /** @type {?} */ resize = this._viewportRuler.change(150);
	        var /** @type {?} */ realign = function () {
	            _this._updatePagination();
	            _this._alignInkBarToSelectedTab();
	        };
	        // Defer the first call in order to allow for slower browsers to lay out the elements.
	        // This helps in cases where the user lands directly on a page with paginated tabs.
	        typeof requestAnimationFrame !== 'undefined' ? requestAnimationFrame(realign) : realign();
	        this._realignInkBar = rxjs_observable_merge.merge(dirChange, resize).subscribe(realign);
	    };
	    /**
	     * @return {?}
	     */
	    MatTabHeader.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._realignInkBar.unsubscribe();
	    };
	    /**
	     * Callback for when the MutationObserver detects that the content has changed.
	     */
	    /**
	     * Callback for when the MutationObserver detects that the content has changed.
	     * @return {?}
	     */
	    MatTabHeader.prototype._onContentChanges = /**
	     * Callback for when the MutationObserver detects that the content has changed.
	     * @return {?}
	     */
	    function () {
	        this._updatePagination();
	        this._alignInkBarToSelectedTab();
	        this._changeDetectorRef.markForCheck();
	    };
	    /**
	     * Updating the view whether pagination should be enabled or not
	     */
	    /**
	     * Updating the view whether pagination should be enabled or not
	     * @return {?}
	     */
	    MatTabHeader.prototype._updatePagination = /**
	     * Updating the view whether pagination should be enabled or not
	     * @return {?}
	     */
	    function () {
	        this._checkPaginationEnabled();
	        this._checkScrollingControls();
	        this._updateTabScrollPosition();
	    };
	    Object.defineProperty(MatTabHeader.prototype, "focusIndex", {
	        /** Tracks which element has focus; used for keyboard navigation */
	        get: /**
	         * Tracks which element has focus; used for keyboard navigation
	         * @return {?}
	         */
	        function () { return this._focusIndex; },
	        /** When the focus index is set, we must manually send focus to the correct label */
	        set: /**
	         * When the focus index is set, we must manually send focus to the correct label
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            if (!this._isValidIndex(value) || this._focusIndex == value) {
	                return;
	            }
	            this._focusIndex = value;
	            this.indexFocused.emit(value);
	            this._setTabFocus(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Determines if an index is valid.  If the tabs are not ready yet, we assume that the user is
	     * providing a valid index and return true.
	     */
	    /**
	     * Determines if an index is valid.  If the tabs are not ready yet, we assume that the user is
	     * providing a valid index and return true.
	     * @param {?} index
	     * @return {?}
	     */
	    MatTabHeader.prototype._isValidIndex = /**
	     * Determines if an index is valid.  If the tabs are not ready yet, we assume that the user is
	     * providing a valid index and return true.
	     * @param {?} index
	     * @return {?}
	     */
	    function (index) {
	        if (!this._labelWrappers) {
	            return true;
	        }
	        var /** @type {?} */ tab = this._labelWrappers ? this._labelWrappers.toArray()[index] : null;
	        return !!tab && !tab.disabled;
	    };
	    /**
	     * Sets focus on the HTML element for the label wrapper and scrolls it into the view if
	     * scrolling is enabled.
	     */
	    /**
	     * Sets focus on the HTML element for the label wrapper and scrolls it into the view if
	     * scrolling is enabled.
	     * @param {?} tabIndex
	     * @return {?}
	     */
	    MatTabHeader.prototype._setTabFocus = /**
	     * Sets focus on the HTML element for the label wrapper and scrolls it into the view if
	     * scrolling is enabled.
	     * @param {?} tabIndex
	     * @return {?}
	     */
	    function (tabIndex) {
	        if (this._showPaginationControls) {
	            this._scrollToLabel(tabIndex);
	        }
	        if (this._labelWrappers && this._labelWrappers.length) {
	            this._labelWrappers.toArray()[tabIndex].focus();
	            // Do not let the browser manage scrolling to focus the element, this will be handled
	            // by using translation. In LTR, the scroll left should be 0. In RTL, the scroll width
	            // should be the full width minus the offset width.
	            var /** @type {?} */ containerEl = this._tabListContainer.nativeElement;
	            var /** @type {?} */ dir = this._getLayoutDirection();
	            if (dir == 'ltr') {
	                containerEl.scrollLeft = 0;
	            }
	            else {
	                containerEl.scrollLeft = containerEl.scrollWidth - containerEl.offsetWidth;
	            }
	        }
	    };
	    /**
	     * Moves the focus towards the beginning or the end of the list depending on the offset provided.
	     * Valid offsets are 1 and -1.
	     */
	    /**
	     * Moves the focus towards the beginning or the end of the list depending on the offset provided.
	     * Valid offsets are 1 and -1.
	     * @param {?} offset
	     * @return {?}
	     */
	    MatTabHeader.prototype._moveFocus = /**
	     * Moves the focus towards the beginning or the end of the list depending on the offset provided.
	     * Valid offsets are 1 and -1.
	     * @param {?} offset
	     * @return {?}
	     */
	    function (offset) {
	        if (this._labelWrappers) {
	            var /** @type {?} */ tabs = this._labelWrappers.toArray();
	            for (var /** @type {?} */ i = this.focusIndex + offset; i < tabs.length && i >= 0; i += offset) {
	                if (this._isValidIndex(i)) {
	                    this.focusIndex = i;
	                    return;
	                }
	            }
	        }
	    };
	    /** Increment the focus index by 1 until a valid tab is found. */
	    /**
	     * Increment the focus index by 1 until a valid tab is found.
	     * @return {?}
	     */
	    MatTabHeader.prototype._focusNextTab = /**
	     * Increment the focus index by 1 until a valid tab is found.
	     * @return {?}
	     */
	    function () {
	        this._moveFocus(this._getLayoutDirection() == 'ltr' ? 1 : -1);
	    };
	    /** Decrement the focus index by 1 until a valid tab is found. */
	    /**
	     * Decrement the focus index by 1 until a valid tab is found.
	     * @return {?}
	     */
	    MatTabHeader.prototype._focusPreviousTab = /**
	     * Decrement the focus index by 1 until a valid tab is found.
	     * @return {?}
	     */
	    function () {
	        this._moveFocus(this._getLayoutDirection() == 'ltr' ? -1 : 1);
	    };
	    /**
	     * Focuses the first tab.
	     * @return {?}
	     */
	    MatTabHeader.prototype._focusFirstTab = /**
	     * Focuses the first tab.
	     * @return {?}
	     */
	    function () {
	        for (var /** @type {?} */ i = 0; i < this._labelWrappers.length; i++) {
	            if (this._isValidIndex(i)) {
	                this.focusIndex = i;
	                break;
	            }
	        }
	    };
	    /**
	     * Focuses the last tab.
	     * @return {?}
	     */
	    MatTabHeader.prototype._focusLastTab = /**
	     * Focuses the last tab.
	     * @return {?}
	     */
	    function () {
	        for (var /** @type {?} */ i = this._labelWrappers.length - 1; i > -1; i--) {
	            if (this._isValidIndex(i)) {
	                this.focusIndex = i;
	                break;
	            }
	        }
	    };
	    /** The layout direction of the containing app. */
	    /**
	     * The layout direction of the containing app.
	     * @return {?}
	     */
	    MatTabHeader.prototype._getLayoutDirection = /**
	     * The layout direction of the containing app.
	     * @return {?}
	     */
	    function () {
	        return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
	    };
	    /** Performs the CSS transformation on the tab list that will cause the list to scroll. */
	    /**
	     * Performs the CSS transformation on the tab list that will cause the list to scroll.
	     * @return {?}
	     */
	    MatTabHeader.prototype._updateTabScrollPosition = /**
	     * Performs the CSS transformation on the tab list that will cause the list to scroll.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ scrollDistance = this.scrollDistance;
	        var /** @type {?} */ translateX = this._getLayoutDirection() === 'ltr' ? -scrollDistance : scrollDistance;
	        this._tabList.nativeElement.style.transform = "translate3d(" + translateX + "px, 0, 0)";
	    };
	    Object.defineProperty(MatTabHeader.prototype, "scrollDistance", {
	        /** Sets the distance in pixels that the tab header should be transformed in the X-axis. */
	        get: /**
	         * Sets the distance in pixels that the tab header should be transformed in the X-axis.
	         * @return {?}
	         */
	        function () { return this._scrollDistance; },
	        set: /**
	         * @param {?} v
	         * @return {?}
	         */
	        function (v) {
	            this._scrollDistance = Math.max(0, Math.min(this._getMaxScrollDistance(), v));
	            // Mark that the scroll distance has changed so that after the view is checked, the CSS
	            // transformation can move the header.
	            this._scrollDistanceChanged = true;
	            this._checkScrollingControls();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Moves the tab list in the 'before' or 'after' direction (towards the beginning of the list or
	     * the end of the list, respectively). The distance to scroll is computed to be a third of the
	     * length of the tab list view window.
	     *
	     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
	     * should be called sparingly.
	     */
	    /**
	     * Moves the tab list in the 'before' or 'after' direction (towards the beginning of the list or
	     * the end of the list, respectively). The distance to scroll is computed to be a third of the
	     * length of the tab list view window.
	     *
	     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
	     * should be called sparingly.
	     * @param {?} scrollDir
	     * @return {?}
	     */
	    MatTabHeader.prototype._scrollHeader = /**
	     * Moves the tab list in the 'before' or 'after' direction (towards the beginning of the list or
	     * the end of the list, respectively). The distance to scroll is computed to be a third of the
	     * length of the tab list view window.
	     *
	     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
	     * should be called sparingly.
	     * @param {?} scrollDir
	     * @return {?}
	     */
	    function (scrollDir) {
	        var /** @type {?} */ viewLength = this._tabListContainer.nativeElement.offsetWidth;
	        // Move the scroll distance one-third the length of the tab list's viewport.
	        this.scrollDistance += (scrollDir == 'before' ? -1 : 1) * viewLength / 3;
	    };
	    /**
	     * Moves the tab list such that the desired tab label (marked by index) is moved into view.
	     *
	     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
	     * should be called sparingly.
	     */
	    /**
	     * Moves the tab list such that the desired tab label (marked by index) is moved into view.
	     *
	     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
	     * should be called sparingly.
	     * @param {?} labelIndex
	     * @return {?}
	     */
	    MatTabHeader.prototype._scrollToLabel = /**
	     * Moves the tab list such that the desired tab label (marked by index) is moved into view.
	     *
	     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
	     * should be called sparingly.
	     * @param {?} labelIndex
	     * @return {?}
	     */
	    function (labelIndex) {
	        var /** @type {?} */ selectedLabel = this._labelWrappers ? this._labelWrappers.toArray()[labelIndex] : null;
	        if (!selectedLabel) {
	            return;
	        }
	        // The view length is the visible width of the tab labels.
	        var /** @type {?} */ viewLength = this._tabListContainer.nativeElement.offsetWidth;
	        var /** @type {?} */ labelBeforePos, /** @type {?} */ labelAfterPos;
	        if (this._getLayoutDirection() == 'ltr') {
	            labelBeforePos = selectedLabel.getOffsetLeft();
	            labelAfterPos = labelBeforePos + selectedLabel.getOffsetWidth();
	        }
	        else {
	            labelAfterPos = this._tabList.nativeElement.offsetWidth - selectedLabel.getOffsetLeft();
	            labelBeforePos = labelAfterPos - selectedLabel.getOffsetWidth();
	        }
	        var /** @type {?} */ beforeVisiblePos = this.scrollDistance;
	        var /** @type {?} */ afterVisiblePos = this.scrollDistance + viewLength;
	        if (labelBeforePos < beforeVisiblePos) {
	            // Scroll header to move label to the before direction
	            this.scrollDistance -= beforeVisiblePos - labelBeforePos + EXAGGERATED_OVERSCROLL;
	        }
	        else if (labelAfterPos > afterVisiblePos) {
	            // Scroll header to move label to the after direction
	            this.scrollDistance += labelAfterPos - afterVisiblePos + EXAGGERATED_OVERSCROLL;
	        }
	    };
	    /**
	     * Evaluate whether the pagination controls should be displayed. If the scroll width of the
	     * tab list is wider than the size of the header container, then the pagination controls should
	     * be shown.
	     *
	     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
	     * should be called sparingly.
	     */
	    /**
	     * Evaluate whether the pagination controls should be displayed. If the scroll width of the
	     * tab list is wider than the size of the header container, then the pagination controls should
	     * be shown.
	     *
	     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
	     * should be called sparingly.
	     * @return {?}
	     */
	    MatTabHeader.prototype._checkPaginationEnabled = /**
	     * Evaluate whether the pagination controls should be displayed. If the scroll width of the
	     * tab list is wider than the size of the header container, then the pagination controls should
	     * be shown.
	     *
	     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
	     * should be called sparingly.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ isEnabled = this._tabList.nativeElement.scrollWidth > this._elementRef.nativeElement.offsetWidth;
	        if (!isEnabled) {
	            this.scrollDistance = 0;
	        }
	        if (isEnabled !== this._showPaginationControls) {
	            this._changeDetectorRef.markForCheck();
	        }
	        this._showPaginationControls = isEnabled;
	    };
	    /**
	     * Evaluate whether the before and after controls should be enabled or disabled.
	     * If the header is at the beginning of the list (scroll distance is equal to 0) then disable the
	     * before button. If the header is at the end of the list (scroll distance is equal to the
	     * maximum distance we can scroll), then disable the after button.
	     *
	     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
	     * should be called sparingly.
	     */
	    /**
	     * Evaluate whether the before and after controls should be enabled or disabled.
	     * If the header is at the beginning of the list (scroll distance is equal to 0) then disable the
	     * before button. If the header is at the end of the list (scroll distance is equal to the
	     * maximum distance we can scroll), then disable the after button.
	     *
	     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
	     * should be called sparingly.
	     * @return {?}
	     */
	    MatTabHeader.prototype._checkScrollingControls = /**
	     * Evaluate whether the before and after controls should be enabled or disabled.
	     * If the header is at the beginning of the list (scroll distance is equal to 0) then disable the
	     * before button. If the header is at the end of the list (scroll distance is equal to the
	     * maximum distance we can scroll), then disable the after button.
	     *
	     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
	     * should be called sparingly.
	     * @return {?}
	     */
	    function () {
	        // Check if the pagination arrows should be activated.
	        this._disableScrollBefore = this.scrollDistance == 0;
	        this._disableScrollAfter = this.scrollDistance == this._getMaxScrollDistance();
	        this._changeDetectorRef.markForCheck();
	    };
	    /**
	     * Determines what is the maximum length in pixels that can be set for the scroll distance. This
	     * is equal to the difference in width between the tab list container and tab header container.
	     *
	     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
	     * should be called sparingly.
	     */
	    /**
	     * Determines what is the maximum length in pixels that can be set for the scroll distance. This
	     * is equal to the difference in width between the tab list container and tab header container.
	     *
	     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
	     * should be called sparingly.
	     * @return {?}
	     */
	    MatTabHeader.prototype._getMaxScrollDistance = /**
	     * Determines what is the maximum length in pixels that can be set for the scroll distance. This
	     * is equal to the difference in width between the tab list container and tab header container.
	     *
	     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
	     * should be called sparingly.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ lengthOfTabList = this._tabList.nativeElement.scrollWidth;
	        var /** @type {?} */ viewLength = this._tabListContainer.nativeElement.offsetWidth;
	        return (lengthOfTabList - viewLength) || 0;
	    };
	    /**
	     * Tells the ink-bar to align itself to the current label wrapper
	     * @return {?}
	     */
	    MatTabHeader.prototype._alignInkBarToSelectedTab = /**
	     * Tells the ink-bar to align itself to the current label wrapper
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ selectedLabelWrapper = this._labelWrappers && this._labelWrappers.length ?
	            this._labelWrappers.toArray()[this.selectedIndex].elementRef.nativeElement :
	            null;
	        this._inkBar.alignToElement(selectedLabelWrapper);
	    };
	    MatTabHeader.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-tab-header',
	                    template: "<div class=\"mat-tab-header-pagination mat-tab-header-pagination-before mat-elevation-z4\" aria-hidden=\"true\" mat-ripple [matRippleDisabled]=\"_disableScrollBefore || disableRipple\" [class.mat-tab-header-pagination-disabled]=\"_disableScrollBefore\" (click)=\"_scrollHeader('before')\"><div class=\"mat-tab-header-pagination-chevron\"></div></div><div class=\"mat-tab-label-container\" #tabListContainer (keydown)=\"_handleKeydown($event)\"><div class=\"mat-tab-list\" #tabList role=\"tablist\" (cdkObserveContent)=\"_onContentChanges()\"><div class=\"mat-tab-labels\"><ng-content></ng-content></div><mat-ink-bar></mat-ink-bar></div></div><div class=\"mat-tab-header-pagination mat-tab-header-pagination-after mat-elevation-z4\" aria-hidden=\"true\" mat-ripple [matRippleDisabled]=\"_disableScrollAfter || disableRipple\" [class.mat-tab-header-pagination-disabled]=\"_disableScrollAfter\" (click)=\"_scrollHeader('after')\"><div class=\"mat-tab-header-pagination-chevron\"></div></div>",
	                    styles: [".mat-tab-header{display:flex;overflow:hidden;position:relative;flex-shrink:0}.mat-tab-label{height:48px;padding:0 24px;cursor:pointer;box-sizing:border-box;opacity:.6;min-width:160px;text-align:center;display:inline-flex;justify-content:center;align-items:center;white-space:nowrap;position:relative}.mat-tab-label:focus{outline:0}.mat-tab-label:focus:not(.mat-tab-disabled){opacity:1}.mat-tab-label.mat-tab-disabled{cursor:default}.mat-tab-label.mat-tab-label-content{display:inline-flex;justify-content:center;align-items:center;white-space:nowrap}@media (max-width:599px){.mat-tab-label{min-width:72px}}.mat-ink-bar{position:absolute;bottom:0;height:2px;transition:.5s cubic-bezier(.35,0,.25,1)}.mat-tab-group-inverted-header .mat-ink-bar{bottom:auto;top:0}@media screen and (-ms-high-contrast:active){.mat-ink-bar{outline:solid 2px;height:0}}.mat-tab-header-pagination{position:relative;display:none;justify-content:center;align-items:center;min-width:32px;cursor:pointer;z-index:2}.mat-tab-header-pagination-controls-enabled .mat-tab-header-pagination{display:flex}.mat-tab-header-pagination-before,.mat-tab-header-rtl .mat-tab-header-pagination-after{padding-left:4px}.mat-tab-header-pagination-before .mat-tab-header-pagination-chevron,.mat-tab-header-rtl .mat-tab-header-pagination-after .mat-tab-header-pagination-chevron{transform:rotate(-135deg)}.mat-tab-header-pagination-after,.mat-tab-header-rtl .mat-tab-header-pagination-before{padding-right:4px}.mat-tab-header-pagination-after .mat-tab-header-pagination-chevron,.mat-tab-header-rtl .mat-tab-header-pagination-before .mat-tab-header-pagination-chevron{transform:rotate(45deg)}.mat-tab-header-pagination-chevron{border-style:solid;border-width:2px 2px 0 0;content:'';height:8px;width:8px}.mat-tab-header-pagination-disabled{box-shadow:none;cursor:default}.mat-tab-label-container{display:flex;flex-grow:1;overflow:hidden;z-index:1}.mat-tab-list{flex-grow:1;position:relative;transition:transform .5s cubic-bezier(.35,0,.25,1)}.mat-tab-labels{display:flex}"],
	                    inputs: ['disableRipple'],
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    host: {
	                        'class': 'mat-tab-header',
	                        '[class.mat-tab-header-pagination-controls-enabled]': '_showPaginationControls',
	                        '[class.mat-tab-header-rtl]': "_getLayoutDirection() == 'rtl'",
	                    },
	                },] },
	    ];
	    /** @nocollapse */
	    MatTabHeader.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: _angular_cdk_scrolling.ViewportRuler, },
	        { type: _angular_cdk_bidi.Directionality, decorators: [{ type: _angular_core.Optional },] },
	    ]; };
	    MatTabHeader.propDecorators = {
	        "_labelWrappers": [{ type: _angular_core.ContentChildren, args: [MatTabLabelWrapper,] },],
	        "_inkBar": [{ type: _angular_core.ViewChild, args: [MatInkBar,] },],
	        "_tabListContainer": [{ type: _angular_core.ViewChild, args: ['tabListContainer',] },],
	        "_tabList": [{ type: _angular_core.ViewChild, args: ['tabList',] },],
	        "selectedIndex": [{ type: _angular_core.Input },],
	        "selectFocusedIndex": [{ type: _angular_core.Output },],
	        "indexFocused": [{ type: _angular_core.Output },],
	    };
	    return MatTabHeader;
	}(_MatTabHeaderMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * \@docs-private
	 */
	var MatTabNavBase = /** @class */ (function () {
	    function MatTabNavBase(_elementRef) {
	        this._elementRef = _elementRef;
	    }
	    return MatTabNavBase;
	}());
	var _MatTabNavMixinBase = mixinColor(MatTabNavBase, 'primary');
	/**
	 * Navigation component matching the styles of the tab group header.
	 * Provides anchored navigation with animated ink bar.
	 */
	var MatTabNav = /** @class */ (function (_super) {
	    __extends(MatTabNav, _super);
	    function MatTabNav(elementRef, _dir, _ngZone, _changeDetectorRef, _viewportRuler) {
	        var _this = _super.call(this, elementRef) || this;
	        _this._dir = _dir;
	        _this._ngZone = _ngZone;
	        _this._changeDetectorRef = _changeDetectorRef;
	        _this._viewportRuler = _viewportRuler;
	        /**
	         * Subject that emits when the component has been destroyed.
	         */
	        _this._onDestroy = new rxjs_Subject.Subject();
	        _this._disableRipple = false;
	        return _this;
	    }
	    Object.defineProperty(MatTabNav.prototype, "backgroundColor", {
	        get: /**
	         * Background color of the tab nav.
	         * @return {?}
	         */
	        function () { return this._backgroundColor; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            var /** @type {?} */ nativeElement = this._elementRef.nativeElement;
	            nativeElement.classList.remove("mat-background-" + this.backgroundColor);
	            if (value) {
	                nativeElement.classList.add("mat-background-" + value);
	            }
	            this._backgroundColor = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatTabNav.prototype, "disableRipple", {
	        get: /**
	         * Whether ripples should be disabled for all links or not.
	         * @return {?}
	         */
	        function () { return this._disableRipple; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._disableRipple = _angular_cdk_coercion.coerceBooleanProperty(value);
	            this._setLinkDisableRipple();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** Notifies the component that the active link has been changed. */
	    /**
	     * Notifies the component that the active link has been changed.
	     * @param {?} element
	     * @return {?}
	     */
	    MatTabNav.prototype.updateActiveLink = /**
	     * Notifies the component that the active link has been changed.
	     * @param {?} element
	     * @return {?}
	     */
	    function (element) {
	        this._activeLinkChanged = this._activeLinkElement != element;
	        this._activeLinkElement = element;
	        if (this._activeLinkChanged) {
	            this._changeDetectorRef.markForCheck();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatTabNav.prototype.ngAfterContentInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._ngZone.runOutsideAngular(function () {
	            var /** @type {?} */ dirChange = _this._dir ? _this._dir.change : rxjs_observable_of.of(null);
	            return rxjs_observable_merge.merge(dirChange, _this._viewportRuler.change(10)).pipe(rxjs_operators_takeUntil.takeUntil(_this._onDestroy))
	                .subscribe(function () { return _this._alignInkBar(); });
	        });
	        this._setLinkDisableRipple();
	    };
	    /** Checks if the active link has been changed and, if so, will update the ink bar. */
	    /**
	     * Checks if the active link has been changed and, if so, will update the ink bar.
	     * @return {?}
	     */
	    MatTabNav.prototype.ngAfterContentChecked = /**
	     * Checks if the active link has been changed and, if so, will update the ink bar.
	     * @return {?}
	     */
	    function () {
	        if (this._activeLinkChanged) {
	            this._alignInkBar();
	            this._activeLinkChanged = false;
	        }
	    };
	    /**
	     * @return {?}
	     */
	    MatTabNav.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._onDestroy.next();
	        this._onDestroy.complete();
	    };
	    /** Aligns the ink bar to the active link. */
	    /**
	     * Aligns the ink bar to the active link.
	     * @return {?}
	     */
	    MatTabNav.prototype._alignInkBar = /**
	     * Aligns the ink bar to the active link.
	     * @return {?}
	     */
	    function () {
	        if (this._activeLinkElement) {
	            this._inkBar.alignToElement(this._activeLinkElement.nativeElement);
	        }
	    };
	    /**
	     * Sets the `disableRipple` property on each link of the navigation bar.
	     * @return {?}
	     */
	    MatTabNav.prototype._setLinkDisableRipple = /**
	     * Sets the `disableRipple` property on each link of the navigation bar.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (this._tabLinks) {
	            this._tabLinks.forEach(function (link) { return link.disableRipple = _this.disableRipple; });
	        }
	    };
	    MatTabNav.decorators = [
	        { type: _angular_core.Component, args: [{selector: '[mat-tab-nav-bar]',
	                    exportAs: 'matTabNavBar, matTabNav',
	                    inputs: ['color'],
	                    template: "<div class=\"mat-tab-links\" (cdkObserveContent)=\"_alignInkBar()\"><ng-content></ng-content><mat-ink-bar></mat-ink-bar></div>",
	                    styles: [".mat-tab-nav-bar{overflow:hidden;position:relative;flex-shrink:0}.mat-tab-links{position:relative}.mat-tab-link{height:48px;padding:0 24px;cursor:pointer;box-sizing:border-box;opacity:.6;min-width:160px;text-align:center;display:inline-flex;justify-content:center;align-items:center;white-space:nowrap;vertical-align:top;text-decoration:none;position:relative;overflow:hidden}.mat-tab-link:focus{outline:0}.mat-tab-link:focus:not(.mat-tab-disabled){opacity:1}.mat-tab-link.mat-tab-disabled{cursor:default}.mat-tab-link.mat-tab-label-content{display:inline-flex;justify-content:center;align-items:center;white-space:nowrap}@media (max-width:599px){.mat-tab-link{min-width:72px}}.mat-ink-bar{position:absolute;bottom:0;height:2px;transition:.5s cubic-bezier(.35,0,.25,1)}.mat-tab-group-inverted-header .mat-ink-bar{bottom:auto;top:0}@media screen and (-ms-high-contrast:active){.mat-ink-bar{outline:solid 2px;height:0}}"],
	                    host: { 'class': 'mat-tab-nav-bar' },
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    MatTabNav.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_bidi.Directionality, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_core.NgZone, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: _angular_cdk_scrolling.ViewportRuler, },
	    ]; };
	    MatTabNav.propDecorators = {
	        "_inkBar": [{ type: _angular_core.ViewChild, args: [MatInkBar,] },],
	        "_tabLinks": [{ type: _angular_core.ContentChildren, args: [_angular_core.forwardRef(function () { return MatTabLink; }), { descendants: true },] },],
	        "backgroundColor": [{ type: _angular_core.Input },],
	        "disableRipple": [{ type: _angular_core.Input },],
	    };
	    return MatTabNav;
	}(_MatTabNavMixinBase));
	var MatTabLinkBase = /** @class */ (function () {
	    function MatTabLinkBase() {
	    }
	    return MatTabLinkBase;
	}());
	var _MatTabLinkMixinBase = mixinTabIndex(mixinDisableRipple(mixinDisabled(MatTabLinkBase)));
	/**
	 * Link inside of a `mat-tab-nav-bar`.
	 */
	var MatTabLink = /** @class */ (function (_super) {
	    __extends(MatTabLink, _super);
	    function MatTabLink(_tabNavBar, _elementRef, ngZone, platform, globalOptions, tabIndex) {
	        var _this = _super.call(this) || this;
	        _this._tabNavBar = _tabNavBar;
	        _this._elementRef = _elementRef;
	        /**
	         * Whether the tab link is active or not.
	         */
	        _this._isActive = false;
	        /**
	         * Ripple configuration for ripples that are launched on pointer down.
	         * \@docs-private
	         */
	        _this.rippleConfig = {};
	        _this._tabLinkRipple = new RippleRenderer(_this, ngZone, _elementRef, platform);
	        _this._tabLinkRipple.setupTriggerEvents(_elementRef.nativeElement);
	        _this.tabIndex = parseInt(tabIndex) || 0;
	        if (globalOptions) {
	            _this.rippleConfig = {
	                terminateOnPointerUp: globalOptions.terminateOnPointerUp,
	                speedFactor: globalOptions.baseSpeedFactor,
	                animation: globalOptions.animation,
	            };
	        }
	        return _this;
	    }
	    Object.defineProperty(MatTabLink.prototype, "active", {
	        get: /**
	         * Whether the link is active.
	         * @return {?}
	         */
	        function () { return this._isActive; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._isActive = value;
	            if (value) {
	                this._tabNavBar.updateActiveLink(this._elementRef);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatTabLink.prototype, "rippleDisabled", {
	        /**
	         * Whether ripples are disabled on interaction
	         * @docs-private
	         */
	        get: /**
	         * Whether ripples are disabled on interaction
	         * \@docs-private
	         * @return {?}
	         */
	        function () {
	            return this.disabled || this.disableRipple;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    MatTabLink.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._tabLinkRipple._removeTriggerEvents();
	    };
	    /**
	     * Handles the click event, preventing default navigation if the tab link is disabled.
	     */
	    /**
	     * Handles the click event, preventing default navigation if the tab link is disabled.
	     * @param {?} event
	     * @return {?}
	     */
	    MatTabLink.prototype._handleClick = /**
	     * Handles the click event, preventing default navigation if the tab link is disabled.
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        if (this.disabled) {
	            event.preventDefault();
	        }
	    };
	    MatTabLink.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[mat-tab-link], [matTabLink]',
	                    exportAs: 'matTabLink',
	                    inputs: ['disabled', 'disableRipple', 'tabIndex'],
	                    host: {
	                        'class': 'mat-tab-link',
	                        '[attr.aria-disabled]': 'disabled.toString()',
	                        '[attr.tabIndex]': 'tabIndex',
	                        '[class.mat-tab-disabled]': 'disabled',
	                        '[class.mat-tab-label-active]': 'active',
	                        '(click)': '_handleClick($event)'
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    MatTabLink.ctorParameters = function () { return [
	        { type: MatTabNav, },
	        { type: _angular_core.ElementRef, },
	        { type: _angular_core.NgZone, },
	        { type: _angular_cdk_platform.Platform, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [MAT_RIPPLE_GLOBAL_OPTIONS,] },] },
	        { type: undefined, decorators: [{ type: _angular_core.Attribute, args: ['tabindex',] },] },
	    ]; };
	    MatTabLink.propDecorators = {
	        "active": [{ type: _angular_core.Input },],
	    };
	    return MatTabLink;
	}(_MatTabLinkMixinBase));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatTabsModule = /** @class */ (function () {
	    function MatTabsModule() {
	    }
	    MatTabsModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [
	                        _angular_common.CommonModule,
	                        MatCommonModule,
	                        _angular_cdk_portal.PortalModule,
	                        MatRippleModule,
	                        _angular_cdk_observers.ObserversModule,
	                        _angular_cdk_scrolling.ScrollDispatchModule,
	                    ],
	                    // Don't export all components because some are only to be used internally.
	                    exports: [
	                        MatCommonModule,
	                        MatTabGroup,
	                        MatTabLabel,
	                        MatTab,
	                        MatTabNav,
	                        MatTabLink,
	                    ],
	                    declarations: [
	                        MatTabGroup,
	                        MatTabLabel,
	                        MatTab,
	                        MatInkBar,
	                        MatTabLabelWrapper,
	                        MatTabNav,
	                        MatTabLink,
	                        MatTabBody,
	                        MatTabBodyPortal,
	                        MatTabHeader
	                    ],
	                    providers: [_angular_cdk_scrolling.VIEWPORT_RULER_PROVIDER],
	                },] },
	    ];
	    /** @nocollapse */
	    MatTabsModule.ctorParameters = function () { return []; };
	    return MatTabsModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * \@docs-private
	 */
	var MatToolbarBase = /** @class */ (function () {
	    function MatToolbarBase(_elementRef) {
	        this._elementRef = _elementRef;
	    }
	    return MatToolbarBase;
	}());
	var _MatToolbarMixinBase = mixinColor(MatToolbarBase);
	var MatToolbarRow = /** @class */ (function () {
	    function MatToolbarRow() {
	    }
	    MatToolbarRow.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'mat-toolbar-row',
	                    exportAs: 'matToolbarRow',
	                    host: { 'class': 'mat-toolbar-row' },
	                },] },
	    ];
	    /** @nocollapse */
	    MatToolbarRow.ctorParameters = function () { return []; };
	    return MatToolbarRow;
	}());
	var MatToolbar = /** @class */ (function (_super) {
	    __extends(MatToolbar, _super);
	    function MatToolbar(elementRef, _platform, document) {
	        var _this = _super.call(this, elementRef) || this;
	        _this._platform = _platform;
	        // TODO: make the document a required param when doing breaking changes.
	        // TODO: make the document a required param when doing breaking changes.
	        _this._document = document;
	        return _this;
	    }
	    /**
	     * @return {?}
	     */
	    MatToolbar.prototype.ngAfterViewInit = /**
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (!_angular_core.isDevMode() || !this._platform.isBrowser) {
	            return;
	        }
	        this._checkToolbarMixedModes();
	        this._toolbarRows.changes.subscribe(function () { return _this._checkToolbarMixedModes(); });
	    };
	    /**
	     * Throws an exception when developers are attempting to combine the different toolbar row modes.
	     * @return {?}
	     */
	    MatToolbar.prototype._checkToolbarMixedModes = /**
	     * Throws an exception when developers are attempting to combine the different toolbar row modes.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        if (!this._toolbarRows.length) {
	            return;
	        }
	        // Check if there are any other DOM nodes that can display content but aren't inside of
	        // a <mat-toolbar-row> element.
	        var /** @type {?} */ isCombinedUsage = [].slice.call(this._elementRef.nativeElement.childNodes)
	            .filter(function (node) { return !(node.classList && node.classList.contains('mat-toolbar-row')); })
	            .filter(function (node) { return node.nodeType !== (_this._document ? _this._document.COMMENT_NODE : 8); })
	            .some(function (node) { return node.textContent.trim(); });
	        if (isCombinedUsage) {
	            throwToolbarMixedModesError();
	        }
	    };
	    MatToolbar.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-toolbar',
	                    exportAs: 'matToolbar',
	                    template: "<ng-content></ng-content><ng-content select=\"mat-toolbar-row\"></ng-content>",
	                    styles: [".mat-toolbar-row,.mat-toolbar-single-row{display:flex;box-sizing:border-box;padding:0 16px;width:100%;flex-direction:row;align-items:center;white-space:nowrap}.mat-toolbar-multiple-rows{display:flex;box-sizing:border-box;flex-direction:column;width:100%}.mat-toolbar-multiple-rows{min-height:64px}.mat-toolbar-row,.mat-toolbar-single-row{height:64px}@media (max-width:599px){.mat-toolbar-multiple-rows{min-height:56px}.mat-toolbar-row,.mat-toolbar-single-row{height:56px}}"],
	                    inputs: ['color'],
	                    host: {
	                        'class': 'mat-toolbar',
	                        '[class.mat-toolbar-multiple-rows]': 'this._toolbarRows.length',
	                        '[class.mat-toolbar-single-row]': '!this._toolbarRows.length'
	                    },
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                },] },
	    ];
	    /** @nocollapse */
	    MatToolbar.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_platform.Platform, },
	        { type: undefined, decorators: [{ type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    MatToolbar.propDecorators = {
	        "_toolbarRows": [{ type: _angular_core.ContentChildren, args: [MatToolbarRow,] },],
	    };
	    return MatToolbar;
	}(_MatToolbarMixinBase));
	/**
	 * Throws an exception when attempting to combine the different toolbar row modes.
	 * \@docs-private
	 * @return {?}
	 */
	function throwToolbarMixedModesError() {
	    throw Error('MatToolbar: Attempting to combine different toolbar modes. ' +
	        'Either specify multiple `<mat-toolbar-row>` elements explicitly or just place content ' +
	        'inside of a `<mat-toolbar>` for a single row.');
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var MatToolbarModule = /** @class */ (function () {
	    function MatToolbarModule() {
	    }
	    MatToolbarModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [MatCommonModule, _angular_cdk_platform.PlatformModule],
	                    exports: [MatToolbar, MatToolbarRow, MatCommonModule],
	                    declarations: [MatToolbar, MatToolbarRow],
	                },] },
	    ];
	    /** @nocollapse */
	    MatToolbarModule.ctorParameters = function () { return []; };
	    return MatToolbarModule;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Current version of Angular Material.
	 */
	var VERSION = new _angular_core.Version('5.2.5');
	
	exports.VERSION = VERSION;
	exports.MatAutocompleteSelectedEvent = MatAutocompleteSelectedEvent;
	exports.MatAutocompleteBase = MatAutocompleteBase;
	exports._MatAutocompleteMixinBase = _MatAutocompleteMixinBase;
	exports.MAT_AUTOCOMPLETE_DEFAULT_OPTIONS = MAT_AUTOCOMPLETE_DEFAULT_OPTIONS;
	exports.MatAutocomplete = MatAutocomplete;
	exports.MatAutocompleteModule = MatAutocompleteModule;
	exports.AUTOCOMPLETE_OPTION_HEIGHT = AUTOCOMPLETE_OPTION_HEIGHT;
	exports.AUTOCOMPLETE_PANEL_HEIGHT = AUTOCOMPLETE_PANEL_HEIGHT;
	exports.MAT_AUTOCOMPLETE_SCROLL_STRATEGY = MAT_AUTOCOMPLETE_SCROLL_STRATEGY;
	exports.MAT_AUTOCOMPLETE_SCROLL_STRATEGY_PROVIDER_FACTORY = MAT_AUTOCOMPLETE_SCROLL_STRATEGY_PROVIDER_FACTORY;
	exports.MAT_AUTOCOMPLETE_SCROLL_STRATEGY_PROVIDER = MAT_AUTOCOMPLETE_SCROLL_STRATEGY_PROVIDER;
	exports.MAT_AUTOCOMPLETE_VALUE_ACCESSOR = MAT_AUTOCOMPLETE_VALUE_ACCESSOR;
	exports.getMatAutocompleteMissingPanelError = getMatAutocompleteMissingPanelError;
	exports.MatAutocompleteTrigger = MatAutocompleteTrigger;
	exports.MatButtonModule = MatButtonModule;
	exports.MatButtonBase = MatButtonBase;
	exports._MatButtonMixinBase = _MatButtonMixinBase;
	exports.MatButton = MatButton;
	exports.MatAnchor = MatAnchor;
	exports.MatButtonToggleGroupBase = MatButtonToggleGroupBase;
	exports._MatButtonToggleGroupMixinBase = _MatButtonToggleGroupMixinBase;
	exports.MAT_BUTTON_TOGGLE_GROUP_VALUE_ACCESSOR = MAT_BUTTON_TOGGLE_GROUP_VALUE_ACCESSOR;
	exports.MatButtonToggleChange = MatButtonToggleChange;
	exports.MatButtonToggleGroup = MatButtonToggleGroup;
	exports.MatButtonToggleGroupMultiple = MatButtonToggleGroupMultiple;
	exports.MatButtonToggle = MatButtonToggle;
	exports.MatButtonToggleModule = MatButtonToggleModule;
	exports.MatCardContent = MatCardContent;
	exports.MatCardTitle = MatCardTitle;
	exports.MatCardSubtitle = MatCardSubtitle;
	exports.MatCardActions = MatCardActions;
	exports.MatCardFooter = MatCardFooter;
	exports.MatCardImage = MatCardImage;
	exports.MatCardSmImage = MatCardSmImage;
	exports.MatCardMdImage = MatCardMdImage;
	exports.MatCardLgImage = MatCardLgImage;
	exports.MatCardXlImage = MatCardXlImage;
	exports.MatCardAvatar = MatCardAvatar;
	exports.MatCard = MatCard;
	exports.MatCardHeader = MatCardHeader;
	exports.MatCardTitleGroup = MatCardTitleGroup;
	exports.MatCardModule = MatCardModule;
	exports.MAT_CHECKBOX_CONTROL_VALUE_ACCESSOR = MAT_CHECKBOX_CONTROL_VALUE_ACCESSOR;
	exports.TransitionCheckState = TransitionCheckState;
	exports.MatCheckboxChange = MatCheckboxChange;
	exports.MatCheckboxBase = MatCheckboxBase;
	exports._MatCheckboxMixinBase = _MatCheckboxMixinBase;
	exports.MatCheckbox = MatCheckbox;
	exports.MAT_CHECKBOX_CLICK_ACTION = MAT_CHECKBOX_CLICK_ACTION;
	exports.MatCheckboxModule = MatCheckboxModule;
	exports.MAT_CHECKBOX_REQUIRED_VALIDATOR = MAT_CHECKBOX_REQUIRED_VALIDATOR;
	exports.MatCheckboxRequiredValidator = MatCheckboxRequiredValidator;
	exports.MatChipsModule = MatChipsModule;
	exports.MatChipListBase = MatChipListBase;
	exports._MatChipListMixinBase = _MatChipListMixinBase;
	exports.MatChipListChange = MatChipListChange;
	exports.MatChipList = MatChipList;
	exports.MatChipSelectionChange = MatChipSelectionChange;
	exports.MatChipBase = MatChipBase;
	exports._MatChipMixinBase = _MatChipMixinBase;
	exports.MatBasicChip = MatBasicChip;
	exports.MatChip = MatChip;
	exports.MatChipRemove = MatChipRemove;
	exports.MatChipInput = MatChipInput;
	exports.MAT_PLACEHOLDER_GLOBAL_OPTIONS = MAT_LABEL_GLOBAL_OPTIONS;
	exports.AnimationCurves = AnimationCurves;
	exports.AnimationDurations = AnimationDurations;
	exports.MatCommonModule = MatCommonModule;
	exports.MATERIAL_SANITY_CHECKS = MATERIAL_SANITY_CHECKS;
	exports.mixinDisabled = mixinDisabled;
	exports.mixinColor = mixinColor;
	exports.mixinDisableRipple = mixinDisableRipple;
	exports.mixinTabIndex = mixinTabIndex;
	exports.mixinErrorState = mixinErrorState;
	exports.mixinInitialized = mixinInitialized;
	exports.NativeDateModule = NativeDateModule;
	exports.MatNativeDateModule = MatNativeDateModule;
	exports.MAT_DATE_LOCALE = MAT_DATE_LOCALE;
	exports.MAT_DATE_LOCALE_PROVIDER = MAT_DATE_LOCALE_PROVIDER;
	exports.DateAdapter = DateAdapter;
	exports.MAT_DATE_FORMATS = MAT_DATE_FORMATS;
	exports.NativeDateAdapter = NativeDateAdapter;
	exports.MAT_NATIVE_DATE_FORMATS = MAT_NATIVE_DATE_FORMATS;
	exports.ShowOnDirtyErrorStateMatcher = ShowOnDirtyErrorStateMatcher;
	exports.ErrorStateMatcher = ErrorStateMatcher;
	exports.MAT_HAMMER_OPTIONS = MAT_HAMMER_OPTIONS;
	exports.GestureConfig = GestureConfig;
	exports.MatLine = MatLine;
	exports.MatLineSetter = MatLineSetter;
	exports.MatLineModule = MatLineModule;
	exports.MatOptionModule = MatOptionModule;
	exports.MatOptionSelectionChange = MatOptionSelectionChange;
	exports.MAT_OPTION_PARENT_COMPONENT = MAT_OPTION_PARENT_COMPONENT;
	exports.MatOption = MatOption;
	exports._countGroupLabelsBeforeOption = _countGroupLabelsBeforeOption;
	exports._getOptionScrollPosition = _getOptionScrollPosition;
	exports.MatOptgroupBase = MatOptgroupBase;
	exports._MatOptgroupMixinBase = _MatOptgroupMixinBase;
	exports.MatOptgroup = MatOptgroup;
	exports.MAT_LABEL_GLOBAL_OPTIONS = MAT_LABEL_GLOBAL_OPTIONS;
	exports.MatRippleModule = MatRippleModule;
	exports.MAT_RIPPLE_GLOBAL_OPTIONS = MAT_RIPPLE_GLOBAL_OPTIONS;
	exports.MatRipple = MatRipple;
	exports.RippleState = RippleState;
	exports.RippleRef = RippleRef;
	exports.defaultRippleAnimationConfig = defaultRippleAnimationConfig;
	exports.RippleRenderer = RippleRenderer;
	exports.MatPseudoCheckboxModule = MatPseudoCheckboxModule;
	exports.MatPseudoCheckbox = MatPseudoCheckbox;
	exports.JAN = JAN;
	exports.FEB = FEB;
	exports.MAR = MAR;
	exports.APR = APR;
	exports.MAY = MAY;
	exports.JUN = JUN;
	exports.JUL = JUL;
	exports.AUG = AUG;
	exports.SEP = SEP;
	exports.OCT = OCT;
	exports.NOV = NOV;
	exports.DEC = DEC;
	exports.ɵa31 = MatMultiYearView;
	exports.MatDatepickerModule = MatDatepickerModule;
	exports.MatCalendar = MatCalendar;
	exports.MatCalendarCell = MatCalendarCell;
	exports.MatCalendarBody = MatCalendarBody;
	exports.MAT_DATEPICKER_SCROLL_STRATEGY = MAT_DATEPICKER_SCROLL_STRATEGY;
	exports.MAT_DATEPICKER_SCROLL_STRATEGY_PROVIDER_FACTORY = MAT_DATEPICKER_SCROLL_STRATEGY_PROVIDER_FACTORY;
	exports.MAT_DATEPICKER_SCROLL_STRATEGY_PROVIDER = MAT_DATEPICKER_SCROLL_STRATEGY_PROVIDER;
	exports.MatDatepickerContent = MatDatepickerContent;
	exports.MatDatepicker = MatDatepicker;
	exports.MAT_DATEPICKER_VALUE_ACCESSOR = MAT_DATEPICKER_VALUE_ACCESSOR;
	exports.MAT_DATEPICKER_VALIDATORS = MAT_DATEPICKER_VALIDATORS;
	exports.MatDatepickerInputEvent = MatDatepickerInputEvent;
	exports.MatDatepickerInput = MatDatepickerInput;
	exports.MatDatepickerIntl = MatDatepickerIntl;
	exports.MatDatepickerToggleIcon = MatDatepickerToggleIcon;
	exports.MatDatepickerToggle = MatDatepickerToggle;
	exports.MatMonthView = MatMonthView;
	exports.MatYearView = MatYearView;
	exports.MatDialogModule = MatDialogModule;
	exports.MAT_DIALOG_DATA = MAT_DIALOG_DATA;
	exports.MAT_DIALOG_DEFAULT_OPTIONS = MAT_DIALOG_DEFAULT_OPTIONS;
	exports.MAT_DIALOG_SCROLL_STRATEGY = MAT_DIALOG_SCROLL_STRATEGY;
	exports.MAT_DIALOG_SCROLL_STRATEGY_PROVIDER_FACTORY = MAT_DIALOG_SCROLL_STRATEGY_PROVIDER_FACTORY;
	exports.MAT_DIALOG_SCROLL_STRATEGY_PROVIDER = MAT_DIALOG_SCROLL_STRATEGY_PROVIDER;
	exports.MatDialog = MatDialog;
	exports.throwMatDialogContentAlreadyAttachedError = throwMatDialogContentAlreadyAttachedError;
	exports.MatDialogContainer = MatDialogContainer;
	exports.MatDialogClose = MatDialogClose;
	exports.MatDialogTitle = MatDialogTitle;
	exports.MatDialogContent = MatDialogContent;
	exports.MatDialogActions = MatDialogActions;
	exports.MatDialogConfig = MatDialogConfig;
	exports.MatDialogRef = MatDialogRef;
	exports.matDialogAnimations = matDialogAnimations;
	exports.MatDivider = MatDivider;
	exports.MatDividerModule = MatDividerModule;
	exports.MatExpansionModule = MatExpansionModule;
	exports.MatAccordion = MatAccordion;
	exports.MatExpansionPanel = MatExpansionPanel;
	exports.MatExpansionPanelActionRow = MatExpansionPanelActionRow;
	exports.MatExpansionPanelHeader = MatExpansionPanelHeader;
	exports.MatExpansionPanelDescription = MatExpansionPanelDescription;
	exports.MatExpansionPanelTitle = MatExpansionPanelTitle;
	exports.MatExpansionPanelContent = MatExpansionPanelContent;
	exports.EXPANSION_PANEL_ANIMATION_TIMING = EXPANSION_PANEL_ANIMATION_TIMING;
	exports.matExpansionAnimations = matExpansionAnimations;
	exports.MatFormFieldModule = MatFormFieldModule;
	exports.MatError = MatError;
	exports.MatFormFieldBase = MatFormFieldBase;
	exports._MatFormFieldMixinBase = _MatFormFieldMixinBase;
	exports.MatFormField = MatFormField;
	exports.MatFormFieldControl = MatFormFieldControl;
	exports.getMatFormFieldPlaceholderConflictError = getMatFormFieldPlaceholderConflictError;
	exports.getMatFormFieldDuplicatedHintError = getMatFormFieldDuplicatedHintError;
	exports.getMatFormFieldMissingControlError = getMatFormFieldMissingControlError;
	exports.MatHint = MatHint;
	exports.MatPlaceholder = MatPlaceholder;
	exports.MatPrefix = MatPrefix;
	exports.MatSuffix = MatSuffix;
	exports.MatLabel = MatLabel;
	exports.matFormFieldAnimations = matFormFieldAnimations;
	exports.MatGridListModule = MatGridListModule;
	exports.MatGridList = MatGridList;
	exports.MatGridTile = MatGridTile;
	exports.MatGridTileText = MatGridTileText;
	exports.MatGridAvatarCssMatStyler = MatGridAvatarCssMatStyler;
	exports.MatGridTileHeaderCssMatStyler = MatGridTileHeaderCssMatStyler;
	exports.MatGridTileFooterCssMatStyler = MatGridTileFooterCssMatStyler;
	exports.MatIconModule = MatIconModule;
	exports.MatIconBase = MatIconBase;
	exports._MatIconMixinBase = _MatIconMixinBase;
	exports.MatIcon = MatIcon;
	exports.getMatIconNameNotFoundError = getMatIconNameNotFoundError;
	exports.getMatIconNoHttpProviderError = getMatIconNoHttpProviderError;
	exports.getMatIconFailedToSanitizeError = getMatIconFailedToSanitizeError;
	exports.MatIconRegistry = MatIconRegistry;
	exports.ICON_REGISTRY_PROVIDER_FACTORY = ICON_REGISTRY_PROVIDER_FACTORY;
	exports.ICON_REGISTRY_PROVIDER = ICON_REGISTRY_PROVIDER;
	exports.MatInputModule = MatInputModule;
	exports.MatTextareaAutosize = MatTextareaAutosize;
	exports.MatInputBase = MatInputBase;
	exports._MatInputMixinBase = _MatInputMixinBase;
	exports.MatInput = MatInput;
	exports.getMatInputUnsupportedTypeError = getMatInputUnsupportedTypeError;
	exports.MAT_INPUT_VALUE_ACCESSOR = MAT_INPUT_VALUE_ACCESSOR;
	exports.MatListModule = MatListModule;
	exports.MatListBase = MatListBase;
	exports._MatListMixinBase = _MatListMixinBase;
	exports.MatListItemBase = MatListItemBase;
	exports._MatListItemMixinBase = _MatListItemMixinBase;
	exports.MatNavList = MatNavList;
	exports.MatList = MatList;
	exports.MatListAvatarCssMatStyler = MatListAvatarCssMatStyler;
	exports.MatListIconCssMatStyler = MatListIconCssMatStyler;
	exports.MatListSubheaderCssMatStyler = MatListSubheaderCssMatStyler;
	exports.MatListItem = MatListItem;
	exports.MatSelectionListBase = MatSelectionListBase;
	exports._MatSelectionListMixinBase = _MatSelectionListMixinBase;
	exports.MatListOptionBase = MatListOptionBase;
	exports._MatListOptionMixinBase = _MatListOptionMixinBase;
	exports.MAT_SELECTION_LIST_VALUE_ACCESSOR = MAT_SELECTION_LIST_VALUE_ACCESSOR;
	exports.MatListOptionChange = MatListOptionChange;
	exports.MatSelectionListChange = MatSelectionListChange;
	exports.MatListOption = MatListOption;
	exports.MatSelectionList = MatSelectionList;
	exports.ɵa20 = MatMenuItemBase;
	exports.ɵb20 = _MatMenuItemMixinBase;
	exports.ɵd20 = MAT_MENU_SCROLL_STRATEGY_PROVIDER;
	exports.ɵc20 = MAT_MENU_SCROLL_STRATEGY_PROVIDER_FACTORY;
	exports.MAT_MENU_SCROLL_STRATEGY = MAT_MENU_SCROLL_STRATEGY;
	exports.MatMenuModule = MatMenuModule;
	exports.MatMenu = MatMenu;
	exports.MAT_MENU_DEFAULT_OPTIONS = MAT_MENU_DEFAULT_OPTIONS;
	exports.MatMenuItem = MatMenuItem;
	exports.MatMenuTrigger = MatMenuTrigger;
	exports.matMenuAnimations = matMenuAnimations;
	exports.fadeInItems = fadeInItems;
	exports.transformMenu = transformMenu;
	exports.MatMenuContent = MatMenuContent;
	exports.MatPaginatorModule = MatPaginatorModule;
	exports.PageEvent = PageEvent;
	exports.MatPaginator = MatPaginator;
	exports.MatPaginatorIntl = MatPaginatorIntl;
	exports.MAT_PAGINATOR_INTL_PROVIDER_FACTORY = MAT_PAGINATOR_INTL_PROVIDER_FACTORY;
	exports.MAT_PAGINATOR_INTL_PROVIDER = MAT_PAGINATOR_INTL_PROVIDER;
	exports.MatProgressBarModule = MatProgressBarModule;
	exports.MatProgressBarBase = MatProgressBarBase;
	exports._MatProgressBarMixinBase = _MatProgressBarMixinBase;
	exports.MatProgressBar = MatProgressBar;
	exports.MatProgressSpinnerModule = MatProgressSpinnerModule;
	exports.MatProgressSpinnerBase = MatProgressSpinnerBase;
	exports._MatProgressSpinnerMixinBase = _MatProgressSpinnerMixinBase;
	exports.MatProgressSpinner = MatProgressSpinner;
	exports.MatSpinner = MatSpinner;
	exports.MatRadioModule = MatRadioModule;
	exports.MAT_RADIO_GROUP_CONTROL_VALUE_ACCESSOR = MAT_RADIO_GROUP_CONTROL_VALUE_ACCESSOR;
	exports.MatRadioChange = MatRadioChange;
	exports.MatRadioGroupBase = MatRadioGroupBase;
	exports._MatRadioGroupMixinBase = _MatRadioGroupMixinBase;
	exports.MatRadioGroup = MatRadioGroup;
	exports.MatRadioButtonBase = MatRadioButtonBase;
	exports._MatRadioButtonMixinBase = _MatRadioButtonMixinBase;
	exports.MatRadioButton = MatRadioButton;
	exports.MatSelectModule = MatSelectModule;
	exports.SELECT_PANEL_MAX_HEIGHT = SELECT_PANEL_MAX_HEIGHT;
	exports.SELECT_PANEL_PADDING_X = SELECT_PANEL_PADDING_X;
	exports.SELECT_PANEL_INDENT_PADDING_X = SELECT_PANEL_INDENT_PADDING_X;
	exports.SELECT_ITEM_HEIGHT_EM = SELECT_ITEM_HEIGHT_EM;
	exports.SELECT_MULTIPLE_PANEL_PADDING_X = SELECT_MULTIPLE_PANEL_PADDING_X;
	exports.SELECT_PANEL_VIEWPORT_PADDING = SELECT_PANEL_VIEWPORT_PADDING;
	exports.MAT_SELECT_SCROLL_STRATEGY = MAT_SELECT_SCROLL_STRATEGY;
	exports.MAT_SELECT_SCROLL_STRATEGY_PROVIDER_FACTORY = MAT_SELECT_SCROLL_STRATEGY_PROVIDER_FACTORY;
	exports.MAT_SELECT_SCROLL_STRATEGY_PROVIDER = MAT_SELECT_SCROLL_STRATEGY_PROVIDER;
	exports.MatSelectChange = MatSelectChange;
	exports.MatSelectBase = MatSelectBase;
	exports._MatSelectMixinBase = _MatSelectMixinBase;
	exports.MatSelectTrigger = MatSelectTrigger;
	exports.MatSelect = MatSelect;
	exports.matSelectAnimations = matSelectAnimations;
	exports.transformPanel = transformPanel;
	exports.fadeInContent = fadeInContent;
	exports.MatSidenavModule = MatSidenavModule;
	exports.throwMatDuplicatedDrawerError = throwMatDuplicatedDrawerError;
	exports.MatDrawerToggleResult = MatDrawerToggleResult;
	exports.MAT_DRAWER_DEFAULT_AUTOSIZE = MAT_DRAWER_DEFAULT_AUTOSIZE;
	exports.MatDrawerContent = MatDrawerContent;
	exports.MatDrawer = MatDrawer;
	exports.MatDrawerContainer = MatDrawerContainer;
	exports.MatSidenavContent = MatSidenavContent;
	exports.MatSidenav = MatSidenav;
	exports.MatSidenavContainer = MatSidenavContainer;
	exports.matDrawerAnimations = matDrawerAnimations;
	exports.MatSlideToggleModule = MatSlideToggleModule;
	exports.MAT_SLIDE_TOGGLE_VALUE_ACCESSOR = MAT_SLIDE_TOGGLE_VALUE_ACCESSOR;
	exports.MatSlideToggleChange = MatSlideToggleChange;
	exports.MatSlideToggleBase = MatSlideToggleBase;
	exports._MatSlideToggleMixinBase = _MatSlideToggleMixinBase;
	exports.MatSlideToggle = MatSlideToggle;
	exports.MatSliderModule = MatSliderModule;
	exports.MAT_SLIDER_VALUE_ACCESSOR = MAT_SLIDER_VALUE_ACCESSOR;
	exports.MatSliderChange = MatSliderChange;
	exports.MatSliderBase = MatSliderBase;
	exports._MatSliderMixinBase = _MatSliderMixinBase;
	exports.MatSlider = MatSlider;
	exports.MatSnackBarModule = MatSnackBarModule;
	exports.MatSnackBar = MatSnackBar;
	exports.MatSnackBarContainer = MatSnackBarContainer;
	exports.MAT_SNACK_BAR_DATA = MAT_SNACK_BAR_DATA;
	exports.MatSnackBarConfig = MatSnackBarConfig;
	exports.MatSnackBarRef = MatSnackBarRef;
	exports.SimpleSnackBar = SimpleSnackBar;
	exports.SHOW_ANIMATION = SHOW_ANIMATION;
	exports.HIDE_ANIMATION = HIDE_ANIMATION;
	exports.matSnackBarAnimations = matSnackBarAnimations;
	exports.MatSortModule = MatSortModule;
	exports.MatSortHeaderBase = MatSortHeaderBase;
	exports._MatSortHeaderMixinBase = _MatSortHeaderMixinBase;
	exports.MatSortHeader = MatSortHeader;
	exports.MatSortHeaderIntl = MatSortHeaderIntl;
	exports.MAT_SORT_HEADER_INTL_PROVIDER_FACTORY = MAT_SORT_HEADER_INTL_PROVIDER_FACTORY;
	exports.MAT_SORT_HEADER_INTL_PROVIDER = MAT_SORT_HEADER_INTL_PROVIDER;
	exports.MatSortBase = MatSortBase;
	exports._MatSortMixinBase = _MatSortMixinBase;
	exports.MatSort = MatSort;
	exports.matSortAnimations = matSortAnimations;
	exports.MatStepperModule = MatStepperModule;
	exports.MatStepLabel = MatStepLabel;
	exports._MatStep = _MatStep;
	exports._MatStepper = _MatStepper;
	exports.MatStep = MatStep;
	exports.MatStepper = MatStepper;
	exports.MatHorizontalStepper = MatHorizontalStepper;
	exports.MatVerticalStepper = MatVerticalStepper;
	exports.MatStepperNext = MatStepperNext;
	exports.MatStepperPrevious = MatStepperPrevious;
	exports.MatStepHeader = MatStepHeader;
	exports.MatStepperIntl = MatStepperIntl;
	exports.matStepperAnimations = matStepperAnimations;
	exports.MatStepperIcon = MatStepperIcon;
	exports.MatTableModule = MatTableModule;
	exports.MatCellDef = MatCellDef;
	exports.MatHeaderCellDef = MatHeaderCellDef;
	exports.MatColumnDef = MatColumnDef;
	exports.MatHeaderCell = MatHeaderCell;
	exports.MatCell = MatCell;
	exports.MatTable = MatTable;
	exports.MatHeaderRowDef = MatHeaderRowDef;
	exports.MatRowDef = MatRowDef;
	exports.MatHeaderRow = MatHeaderRow;
	exports.MatRow = MatRow;
	exports.MatTableDataSource = MatTableDataSource;
	exports.ɵe22 = MatTabBase;
	exports.ɵf22 = _MatTabMixinBase;
	exports.ɵa22 = MatTabHeaderBase;
	exports.ɵb22 = _MatTabHeaderMixinBase;
	exports.ɵc22 = MatTabLabelWrapperBase;
	exports.ɵd22 = _MatTabLabelWrapperMixinBase;
	exports.ɵi22 = MatTabLinkBase;
	exports.ɵg22 = MatTabNavBase;
	exports.ɵj22 = _MatTabLinkMixinBase;
	exports.ɵh22 = _MatTabNavMixinBase;
	exports.MatInkBar = MatInkBar;
	exports.MatTabBody = MatTabBody;
	exports.MatTabBodyPortal = MatTabBodyPortal;
	exports.MatTabHeader = MatTabHeader;
	exports.MatTabLabelWrapper = MatTabLabelWrapper;
	exports.MatTab = MatTab;
	exports.MatTabLabel = MatTabLabel;
	exports.MatTabNav = MatTabNav;
	exports.MatTabLink = MatTabLink;
	exports.MatTabsModule = MatTabsModule;
	exports.MatTabChangeEvent = MatTabChangeEvent;
	exports.MatTabGroupBase = MatTabGroupBase;
	exports._MatTabGroupMixinBase = _MatTabGroupMixinBase;
	exports.MatTabGroup = MatTabGroup;
	exports.matTabsAnimations = matTabsAnimations;
	exports.MatToolbarModule = MatToolbarModule;
	exports.MatToolbarBase = MatToolbarBase;
	exports._MatToolbarMixinBase = _MatToolbarMixinBase;
	exports.MatToolbarRow = MatToolbarRow;
	exports.MatToolbar = MatToolbar;
	exports.throwToolbarMixedModesError = throwToolbarMixedModesError;
	exports.MatTooltipModule = MatTooltipModule;
	exports.SCROLL_THROTTLE_MS = SCROLL_THROTTLE_MS;
	exports.TOOLTIP_PANEL_CLASS = TOOLTIP_PANEL_CLASS;
	exports.getMatTooltipInvalidPositionError = getMatTooltipInvalidPositionError;
	exports.MAT_TOOLTIP_SCROLL_STRATEGY = MAT_TOOLTIP_SCROLL_STRATEGY;
	exports.MAT_TOOLTIP_SCROLL_STRATEGY_PROVIDER_FACTORY = MAT_TOOLTIP_SCROLL_STRATEGY_PROVIDER_FACTORY;
	exports.MAT_TOOLTIP_SCROLL_STRATEGY_PROVIDER = MAT_TOOLTIP_SCROLL_STRATEGY_PROVIDER;
	exports.MAT_TOOLTIP_DEFAULT_OPTIONS = MAT_TOOLTIP_DEFAULT_OPTIONS;
	exports.MatTooltip = MatTooltip;
	exports.TooltipComponent = TooltipComponent;
	exports.matTooltipAnimations = matTooltipAnimations;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=material.umd.js.map


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(1304), __webpack_require__(1077)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@angular/cdk/collections', '@angular/cdk/coercion'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.cdk = global.ng.cdk || {}, global.ng.cdk.accordion = global.ng.cdk.accordion || {}),global.ng.core,global.ng.cdk.collections,global.ng.cdk.coercion));
	}(this, (function (exports,_angular_core,_angular_cdk_collections,_angular_cdk_coercion) { 'use strict';
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Used to generate unique ID for each accordion.
	 */
	var nextId$1 = 0;
	/**
	 * Directive whose purpose is to manage the expanded state of CdkAccordionItem children.
	 */
	var CdkAccordion = /** @class */ (function () {
	    function CdkAccordion() {
	        /**
	         * A readonly id value to use for unique selection coordination.
	         */
	        this.id = "cdk-accordion-" + nextId$1++;
	        this._multi = false;
	    }
	    Object.defineProperty(CdkAccordion.prototype, "multi", {
	        get: /**
	         * Whether the accordion should allow multiple expanded accordion items simultaneously.
	         * @return {?}
	         */
	        function () { return this._multi; },
	        set: /**
	         * @param {?} multi
	         * @return {?}
	         */
	        function (multi) { this._multi = _angular_cdk_coercion.coerceBooleanProperty(multi); },
	        enumerable: true,
	        configurable: true
	    });
	    CdkAccordion.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'cdk-accordion, [cdkAccordion]',
	                    exportAs: 'cdkAccordion',
	                },] },
	    ];
	    /** @nocollapse */
	    CdkAccordion.ctorParameters = function () { return []; };
	    CdkAccordion.propDecorators = {
	        "multi": [{ type: _angular_core.Input },],
	    };
	    return CdkAccordion;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Used to generate unique ID for each accordion item.
	 */
	var nextId = 0;
	/**
	 * An basic directive expected to be extended and decorated as a component.  Sets up all
	 * events and attributes needed to be managed by a CdkAccordion parent.
	 */
	var CdkAccordionItem = /** @class */ (function () {
	    function CdkAccordionItem(accordion, _changeDetectorRef, _expansionDispatcher) {
	        var _this = this;
	        this.accordion = accordion;
	        this._changeDetectorRef = _changeDetectorRef;
	        this._expansionDispatcher = _expansionDispatcher;
	        /**
	         * Event emitted every time the AccordionItem is closed.
	         */
	        this.closed = new _angular_core.EventEmitter();
	        /**
	         * Event emitted every time the AccordionItem is opened.
	         */
	        this.opened = new _angular_core.EventEmitter();
	        /**
	         * Event emitted when the AccordionItem is destroyed.
	         */
	        this.destroyed = new _angular_core.EventEmitter();
	        /**
	         * Emits whenever the expanded state of the accordion changes.
	         * Primarily used to facilitate two-way binding.
	         * \@docs-private
	         */
	        this.expandedChange = new _angular_core.EventEmitter();
	        /**
	         * The unique AccordionItem id.
	         */
	        this.id = "cdk-accordion-child-" + nextId++;
	        this._expanded = false;
	        this._disabled = false;
	        /**
	         * Unregister function for _expansionDispatcher.
	         */
	        this._removeUniqueSelectionListener = function () { };
	        this._removeUniqueSelectionListener =
	            _expansionDispatcher.listen(function (id, accordionId) {
	                if (_this.accordion && !_this.accordion.multi &&
	                    _this.accordion.id === accordionId && _this.id !== id) {
	                    _this.expanded = false;
	                }
	            });
	    }
	    Object.defineProperty(CdkAccordionItem.prototype, "expanded", {
	        get: /**
	         * Whether the AccordionItem is expanded.
	         * @return {?}
	         */
	        function () { return this._expanded; },
	        set: /**
	         * @param {?} expanded
	         * @return {?}
	         */
	        function (expanded) {
	            expanded = _angular_cdk_coercion.coerceBooleanProperty(expanded);
	            // Only emit events and update the internal value if the value changes.
	            if (this._expanded !== expanded) {
	                this._expanded = expanded;
	                this.expandedChange.emit(expanded);
	                if (expanded) {
	                    this.opened.emit();
	                    /**
	                     * In the unique selection dispatcher, the id parameter is the id of the CdkAccordionItem,
	                     * the name value is the id of the accordion.
	                     */
	                    var /** @type {?} */ accordionId = this.accordion ? this.accordion.id : this.id;
	                    this._expansionDispatcher.notify(this.id, accordionId);
	                }
	                else {
	                    this.closed.emit();
	                }
	                // Ensures that the animation will run when the value is set outside of an `@Input`.
	                // This includes cases like the open, close and toggle methods.
	                this._changeDetectorRef.markForCheck();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkAccordionItem.prototype, "disabled", {
	        get: /**
	         * Whether the AccordionItem is disabled.
	         * @return {?}
	         */
	        function () { return this._disabled; },
	        set: /**
	         * @param {?} disabled
	         * @return {?}
	         */
	        function (disabled) { this._disabled = _angular_cdk_coercion.coerceBooleanProperty(disabled); },
	        enumerable: true,
	        configurable: true
	    });
	    /** Emits an event for the accordion item being destroyed. */
	    /**
	     * Emits an event for the accordion item being destroyed.
	     * @return {?}
	     */
	    CdkAccordionItem.prototype.ngOnDestroy = /**
	     * Emits an event for the accordion item being destroyed.
	     * @return {?}
	     */
	    function () {
	        this.destroyed.emit();
	        this._removeUniqueSelectionListener();
	    };
	    /** Toggles the expanded state of the accordion item. */
	    /**
	     * Toggles the expanded state of the accordion item.
	     * @return {?}
	     */
	    CdkAccordionItem.prototype.toggle = /**
	     * Toggles the expanded state of the accordion item.
	     * @return {?}
	     */
	    function () {
	        if (!this.disabled) {
	            this.expanded = !this.expanded;
	        }
	    };
	    /** Sets the expanded state of the accordion item to false. */
	    /**
	     * Sets the expanded state of the accordion item to false.
	     * @return {?}
	     */
	    CdkAccordionItem.prototype.close = /**
	     * Sets the expanded state of the accordion item to false.
	     * @return {?}
	     */
	    function () {
	        if (!this.disabled) {
	            this.expanded = false;
	        }
	    };
	    /** Sets the expanded state of the accordion item to true. */
	    /**
	     * Sets the expanded state of the accordion item to true.
	     * @return {?}
	     */
	    CdkAccordionItem.prototype.open = /**
	     * Sets the expanded state of the accordion item to true.
	     * @return {?}
	     */
	    function () {
	        if (!this.disabled) {
	            this.expanded = true;
	        }
	    };
	    CdkAccordionItem.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'cdk-accordion-item',
	                    exportAs: 'cdkAccordionItem',
	                },] },
	    ];
	    /** @nocollapse */
	    CdkAccordionItem.ctorParameters = function () { return [
	        { type: CdkAccordion, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: _angular_cdk_collections.UniqueSelectionDispatcher, },
	    ]; };
	    CdkAccordionItem.propDecorators = {
	        "closed": [{ type: _angular_core.Output },],
	        "opened": [{ type: _angular_core.Output },],
	        "destroyed": [{ type: _angular_core.Output },],
	        "expandedChange": [{ type: _angular_core.Output },],
	        "expanded": [{ type: _angular_core.Input },],
	        "disabled": [{ type: _angular_core.Input },],
	    };
	    return CdkAccordionItem;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var CdkAccordionModule = /** @class */ (function () {
	    function CdkAccordionModule() {
	    }
	    CdkAccordionModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    exports: [CdkAccordion, CdkAccordionItem],
	                    declarations: [CdkAccordion, CdkAccordionItem],
	                    providers: [_angular_cdk_collections.UNIQUE_SELECTION_DISPATCHER_PROVIDER],
	                },] },
	    ];
	    /** @nocollapse */
	    CdkAccordionModule.ctorParameters = function () { return []; };
	    return CdkAccordionModule;
	}());
	
	exports.CdkAccordionItem = CdkAccordionItem;
	exports.CdkAccordion = CdkAccordion;
	exports.CdkAccordionModule = CdkAccordionModule;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=cdk-accordion.umd.js.map


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(1078), __webpack_require__(240), __webpack_require__(254), __webpack_require__(594), __webpack_require__(620), __webpack_require__(1077), __webpack_require__(313), __webpack_require__(330)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@angular/cdk/platform', 'rxjs/Subject', 'rxjs/operators/map', 'rxjs/operators/startWith', 'rxjs/operators/takeUntil', '@angular/cdk/coercion', 'rxjs/observable/combineLatest', 'rxjs/observable/fromEventPattern'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.cdk = global.ng.cdk || {}, global.ng.cdk.layout = global.ng.cdk.layout || {}),global.ng.core,global.ng.cdk.platform,global.Rx,global.Rx.operators,global.Rx.operators,global.Rx.operators,global.ng.cdk.coercion,global.Rx.Observable,global.Rx.Observable));
	}(this, (function (exports,_angular_core,_angular_cdk_platform,rxjs_Subject,rxjs_operators_map,rxjs_operators_startWith,rxjs_operators_takeUntil,_angular_cdk_coercion,rxjs_observable_combineLatest,rxjs_observable_fromEventPattern) { 'use strict';
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * Global registry for all dynamically-created, injected style tags.
	 */
	var styleElementForWebkitCompatibility = new Map();
	/**
	 * A utility for calling matchMedia queries.
	 */
	var MediaMatcher = /** @class */ (function () {
	    function MediaMatcher(platform) {
	        this.platform = platform;
	        this._matchMedia = this.platform.isBrowser && window.matchMedia ?
	            // matchMedia is bound to the window scope intentionally as it is an illegal invocation to
	            // call it from a different scope.
	            window.matchMedia.bind(window) :
	            noopMatchMedia;
	    }
	    /**
	     * Evaluates the given media query and returns the native MediaQueryList from which results
	     * can be retrieved.
	     * Confirms the layout engine will trigger for the selector query provided and returns the
	     * MediaQueryList for the query provided.
	     */
	    /**
	     * Evaluates the given media query and returns the native MediaQueryList from which results
	     * can be retrieved.
	     * Confirms the layout engine will trigger for the selector query provided and returns the
	     * MediaQueryList for the query provided.
	     * @param {?} query
	     * @return {?}
	     */
	    MediaMatcher.prototype.matchMedia = /**
	     * Evaluates the given media query and returns the native MediaQueryList from which results
	     * can be retrieved.
	     * Confirms the layout engine will trigger for the selector query provided and returns the
	     * MediaQueryList for the query provided.
	     * @param {?} query
	     * @return {?}
	     */
	    function (query) {
	        if (this.platform.WEBKIT) {
	            createEmptyStyleRule(query);
	        }
	        return this._matchMedia(query);
	    };
	    MediaMatcher.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    MediaMatcher.ctorParameters = function () { return [
	        { type: _angular_cdk_platform.Platform, },
	    ]; };
	    return MediaMatcher;
	}());
	/**
	 * For Webkit engines that only trigger the MediaQueryListListener when there is at least one CSS
	 * selector for the respective media query.
	 * @param {?} query
	 * @return {?}
	 */
	function createEmptyStyleRule(query) {
	    if (!styleElementForWebkitCompatibility.has(query)) {
	        try {
	            var /** @type {?} */ style = document.createElement('style');
	            style.setAttribute('type', 'text/css');
	            if (!style.sheet) {
	                var /** @type {?} */ cssText = "@media " + query + " {.fx-query-test{ }}";
	                style.appendChild(document.createTextNode(cssText));
	            }
	            document.getElementsByTagName('head')[0].appendChild(style);
	            // Store in private global registry
	            styleElementForWebkitCompatibility.set(query, style);
	        }
	        catch (/** @type {?} */ e) {
	            console.error(e);
	        }
	    }
	}
	/**
	 * No-op matchMedia replacement for non-browser platforms.
	 * @param {?} query
	 * @return {?}
	 */
	function noopMatchMedia(query) {
	    return {
	        matches: query === 'all' || query === '',
	        media: query,
	        addListener: function () { },
	        removeListener: function () { }
	    };
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	/**
	 * The current state of a layout breakpoint.
	 * @record
	 */
	
	/**
	 * Utility for checking the matching state of \@media queries.
	 */
	var BreakpointObserver = /** @class */ (function () {
	    function BreakpointObserver(mediaMatcher, zone) {
	        this.mediaMatcher = mediaMatcher;
	        this.zone = zone;
	        /**
	         * A map of all media queries currently being listened for.
	         */
	        this._queries = new Map();
	        /**
	         * A subject for all other observables to takeUntil based on.
	         */
	        this._destroySubject = new rxjs_Subject.Subject();
	    }
	    /** Completes the active subject, signalling to all other observables to complete. */
	    /**
	     * Completes the active subject, signalling to all other observables to complete.
	     * @return {?}
	     */
	    BreakpointObserver.prototype.ngOnDestroy = /**
	     * Completes the active subject, signalling to all other observables to complete.
	     * @return {?}
	     */
	    function () {
	        this._destroySubject.next();
	        this._destroySubject.complete();
	    };
	    /**
	     * Whether one or more media queries match the current viewport size.
	     * @param value One or more media queries to check.
	     * @returns Whether any of the media queries match.
	     */
	    /**
	     * Whether one or more media queries match the current viewport size.
	     * @param {?} value One or more media queries to check.
	     * @return {?} Whether any of the media queries match.
	     */
	    BreakpointObserver.prototype.isMatched = /**
	     * Whether one or more media queries match the current viewport size.
	     * @param {?} value One or more media queries to check.
	     * @return {?} Whether any of the media queries match.
	     */
	    function (value) {
	        var _this = this;
	        var /** @type {?} */ queries = _angular_cdk_coercion.coerceArray(value);
	        return queries.some(function (mediaQuery) { return _this._registerQuery(mediaQuery).mql.matches; });
	    };
	    /**
	     * Gets an observable of results for the given queries that will emit new results for any changes
	     * in matching of the given queries.
	     * @returns A stream of matches for the given queries.
	     */
	    /**
	     * Gets an observable of results for the given queries that will emit new results for any changes
	     * in matching of the given queries.
	     * @param {?} value
	     * @return {?} A stream of matches for the given queries.
	     */
	    BreakpointObserver.prototype.observe = /**
	     * Gets an observable of results for the given queries that will emit new results for any changes
	     * in matching of the given queries.
	     * @param {?} value
	     * @return {?} A stream of matches for the given queries.
	     */
	    function (value) {
	        var _this = this;
	        var /** @type {?} */ queries = _angular_cdk_coercion.coerceArray(value);
	        var /** @type {?} */ observables = queries.map(function (query) { return _this._registerQuery(query).observable; });
	        return rxjs_observable_combineLatest.combineLatest(observables, function (a, b) {
	            return {
	                matches: !!((a && a.matches) || (b && b.matches)),
	            };
	        });
	    };
	    /**
	     * Registers a specific query to be listened for.
	     * @param {?} query
	     * @return {?}
	     */
	    BreakpointObserver.prototype._registerQuery = /**
	     * Registers a specific query to be listened for.
	     * @param {?} query
	     * @return {?}
	     */
	    function (query) {
	        var _this = this;
	        // Only set up a new MediaQueryList if it is not already being listened for.
	        if (this._queries.has(query)) {
	            return /** @type {?} */ ((this._queries.get(query)));
	        }
	        var /** @type {?} */ mql = this.mediaMatcher.matchMedia(query);
	        // Create callback for match changes and add it is as a listener.
	        var /** @type {?} */ queryObservable = rxjs_observable_fromEventPattern.fromEventPattern(
	        // Listener callback methods are wrapped to be placed back in ngZone. Callbacks must be placed
	        // back into the zone because matchMedia is only included in Zone.js by loading the
	        // webapis-media-query.js file alongside the zone.js file.  Additionally, some browsers do not
	        // have MediaQueryList inherit from EventTarget, which causes inconsistencies in how Zone.js
	        // patches it.
	        // Listener callback methods are wrapped to be placed back in ngZone. Callbacks must be placed
	        // back into the zone because matchMedia is only included in Zone.js by loading the
	        // webapis-media-query.js file alongside the zone.js file.  Additionally, some browsers do not
	        // have MediaQueryList inherit from EventTarget, which causes inconsistencies in how Zone.js
	        // patches it.
	        function (listener) {
	            mql.addListener(function (e) { return _this.zone.run(function () { return listener(e); }); });
	        }, function (listener) {
	            mql.removeListener(function (e) { return _this.zone.run(function () { return listener(e); }); });
	        })
	            .pipe(rxjs_operators_takeUntil.takeUntil(this._destroySubject), rxjs_operators_startWith.startWith(mql), rxjs_operators_map.map(function (nextMql) { return ({ matches: nextMql.matches }); }));
	        // Add the MediaQueryList to the set of queries.
	        var /** @type {?} */ output = { observable: queryObservable, mql: mql };
	        this._queries.set(query, output);
	        return output;
	    };
	    BreakpointObserver.decorators = [
	        { type: _angular_core.Injectable },
	    ];
	    /** @nocollapse */
	    BreakpointObserver.ctorParameters = function () { return [
	        { type: MediaMatcher, },
	        { type: _angular_core.NgZone, },
	    ]; };
	    return BreakpointObserver;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var Breakpoints = {
	    XSmall: '(max-width: 599px)',
	    Small: '(min-width: 600px) and (max-width: 959px)',
	    Medium: '(min-width: 960px) and (max-width: 1279px)',
	    Large: '(min-width: 1280px) and (max-width: 1919px)',
	    XLarge: '(min-width: 1920px)',
	    Handset: '(max-width: 599px) and (orientation: portrait), ' +
	        '(max-width: 959px) and (orientation: landscape)',
	    Tablet: '(min-width: 600px) and (max-width: 839px) and (orientation: portrait), ' +
	        '(min-width: 960px) and (max-width: 1279px) and (orientation: landscape)',
	    Web: '(min-width: 840px) and (orientation: portrait), ' +
	        '(min-width: 1280px) and (orientation: landscape)',
	    HandsetPortrait: '(max-width: 599px) and (orientation: portrait)',
	    TabletPortrait: '(min-width: 600px) and (max-width: 839px) and (orientation: portrait)',
	    WebPortrait: '(min-width: 840px) and (orientation: portrait)',
	    HandsetLandscape: '(max-width: 959px) and (orientation: landscape)',
	    TabletLandscape: '(min-width: 960px) and (max-width: 1279px) and (orientation: landscape)',
	    WebLandscape: '(min-width: 1280px) and (orientation: landscape)',
	};
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var LayoutModule = /** @class */ (function () {
	    function LayoutModule() {
	    }
	    LayoutModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    providers: [BreakpointObserver, MediaMatcher],
	                    imports: [_angular_cdk_platform.PlatformModule],
	                },] },
	    ];
	    /** @nocollapse */
	    LayoutModule.ctorParameters = function () { return []; };
	    return LayoutModule;
	}());
	
	exports.LayoutModule = LayoutModule;
	exports.BreakpointObserver = BreakpointObserver;
	exports.Breakpoints = Breakpoints;
	exports.MediaMatcher = MediaMatcher;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=cdk-layout.umd.js.map


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(1304), __webpack_require__(620), __webpack_require__(271), __webpack_require__(240), __webpack_require__(206), __webpack_require__(253), __webpack_require__(246)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@angular/cdk/collections', 'rxjs/operators/takeUntil', 'rxjs/BehaviorSubject', 'rxjs/Subject', 'rxjs/Observable', 'rxjs/observable/of', '@angular/common'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.cdk = global.ng.cdk || {}, global.ng.cdk.table = global.ng.cdk.table || {}),global.ng.core,global.ng.cdk.collections,global.Rx.operators,global.Rx,global.Rx,global.Rx,global.Rx.Observable,global.ng.common));
	}(this, (function (exports,_angular_core,_angular_cdk_collections,rxjs_operators_takeUntil,rxjs_BehaviorSubject,rxjs_Subject,rxjs_Observable,rxjs_observable_of,_angular_common) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * The row template that can be used by the mat-table. Should not be used outside of the
	 * material library.
	 */
	var CDK_ROW_TEMPLATE = "<ng-container cdkCellOutlet></ng-container>";
	/**
	 * Base class for the CdkHeaderRowDef and CdkRowDef that handles checking their columns inputs
	 * for changes and notifying the table.
	 * @abstract
	 */
	var BaseRowDef = /** @class */ (function () {
	    function BaseRowDef(template, _differs) {
	        this.template = template;
	        this._differs = _differs;
	    }
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    BaseRowDef.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        // Create a new columns differ if one does not yet exist. Initialize it based on initial value
	        // of the columns property or an empty array if none is provided.
	        var /** @type {?} */ columns = changes['columns'].currentValue || [];
	        if (!this._columnsDiffer) {
	            this._columnsDiffer = this._differs.find(columns).create();
	            this._columnsDiffer.diff(columns);
	        }
	    };
	    /**
	     * Returns the difference between the current columns and the columns from the last diff, or null
	     * if there is no difference.
	     */
	    /**
	     * Returns the difference between the current columns and the columns from the last diff, or null
	     * if there is no difference.
	     * @return {?}
	     */
	    BaseRowDef.prototype.getColumnsDiff = /**
	     * Returns the difference between the current columns and the columns from the last diff, or null
	     * if there is no difference.
	     * @return {?}
	     */
	    function () {
	        return this._columnsDiffer.diff(this.columns);
	    };
	    return BaseRowDef;
	}());
	/**
	 * Header row definition for the CDK table.
	 * Captures the header row's template and other header properties such as the columns to display.
	 */
	var CdkHeaderRowDef = /** @class */ (function (_super) {
	    __extends(CdkHeaderRowDef, _super);
	    function CdkHeaderRowDef(template, _differs) {
	        return _super.call(this, template, _differs) || this;
	    }
	    CdkHeaderRowDef.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[cdkHeaderRowDef]',
	                    inputs: ['columns: cdkHeaderRowDef'],
	                },] },
	    ];
	    /** @nocollapse */
	    CdkHeaderRowDef.ctorParameters = function () { return [
	        { type: _angular_core.TemplateRef, },
	        { type: _angular_core.IterableDiffers, },
	    ]; };
	    return CdkHeaderRowDef;
	}(BaseRowDef));
	/**
	 * Data row definition for the CDK table.
	 * Captures the header row's template and other row properties such as the columns to display and
	 * a when predicate that describes when this row should be used.
	 */
	var CdkRowDef = /** @class */ (function (_super) {
	    __extends(CdkRowDef, _super);
	    // TODO(andrewseguin): Add an input for providing a switch function to determine
	    //   if this template should be used.
	    function CdkRowDef(template, _differs) {
	        return _super.call(this, template, _differs) || this;
	    }
	    CdkRowDef.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[cdkRowDef]',
	                    inputs: ['columns: cdkRowDefColumns', 'when: cdkRowDefWhen'],
	                },] },
	    ];
	    /** @nocollapse */
	    CdkRowDef.ctorParameters = function () { return [
	        { type: _angular_core.TemplateRef, },
	        { type: _angular_core.IterableDiffers, },
	    ]; };
	    return CdkRowDef;
	}(BaseRowDef));
	/**
	 * Context provided to the row cells
	 * @record
	 */
	
	/**
	 * Outlet for rendering cells inside of a row or header row.
	 * \@docs-private
	 */
	var CdkCellOutlet = /** @class */ (function () {
	    function CdkCellOutlet(_viewContainer) {
	        this._viewContainer = _viewContainer;
	        CdkCellOutlet.mostRecentCellOutlet = this;
	    }
	    /**
	     * Static property containing the latest constructed instance of this class.
	     * Used by the CDK table when each CdkHeaderRow and CdkRow component is created using
	     * createEmbeddedView. After one of these components are created, this property will provide
	     * a handle to provide that component's cells and context. After init, the CdkCellOutlet will
	     * construct the cells with the provided context.
	     */
	    CdkCellOutlet.mostRecentCellOutlet = null;
	    CdkCellOutlet.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[cdkCellOutlet]' },] },
	    ];
	    /** @nocollapse */
	    CdkCellOutlet.ctorParameters = function () { return [
	        { type: _angular_core.ViewContainerRef, },
	    ]; };
	    return CdkCellOutlet;
	}());
	/**
	 * Header template container that contains the cell outlet. Adds the right class and role.
	 */
	var CdkHeaderRow = /** @class */ (function () {
	    function CdkHeaderRow() {
	    }
	    CdkHeaderRow.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'cdk-header-row',
	                    template: CDK_ROW_TEMPLATE,
	                    host: {
	                        'class': 'cdk-header-row',
	                        'role': 'row',
	                    },
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                },] },
	    ];
	    /** @nocollapse */
	    CdkHeaderRow.ctorParameters = function () { return []; };
	    return CdkHeaderRow;
	}());
	/**
	 * Data row template container that contains the cell outlet. Adds the right class and role.
	 */
	var CdkRow = /** @class */ (function () {
	    function CdkRow() {
	    }
	    CdkRow.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'cdk-row',
	                    template: CDK_ROW_TEMPLATE,
	                    host: {
	                        'class': 'cdk-row',
	                        'role': 'row',
	                    },
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                },] },
	    ];
	    /** @nocollapse */
	    CdkRow.ctorParameters = function () { return []; };
	    return CdkRow;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Cell definition for a CDK table.
	 * Captures the template of a column's data row cell as well as cell-specific properties.
	 */
	var CdkCellDef = /** @class */ (function () {
	    function CdkCellDef(template) {
	        this.template = template;
	    }
	    CdkCellDef.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[cdkCellDef]' },] },
	    ];
	    /** @nocollapse */
	    CdkCellDef.ctorParameters = function () { return [
	        { type: _angular_core.TemplateRef, },
	    ]; };
	    return CdkCellDef;
	}());
	/**
	 * Header cell definition for a CDK table.
	 * Captures the template of a column's header cell and as well as cell-specific properties.
	 */
	var CdkHeaderCellDef = /** @class */ (function () {
	    function CdkHeaderCellDef(template) {
	        this.template = template;
	    }
	    CdkHeaderCellDef.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[cdkHeaderCellDef]' },] },
	    ];
	    /** @nocollapse */
	    CdkHeaderCellDef.ctorParameters = function () { return [
	        { type: _angular_core.TemplateRef, },
	    ]; };
	    return CdkHeaderCellDef;
	}());
	/**
	 * Column definition for the CDK table.
	 * Defines a set of cells available for a table column.
	 */
	var CdkColumnDef = /** @class */ (function () {
	    function CdkColumnDef() {
	    }
	    Object.defineProperty(CdkColumnDef.prototype, "name", {
	        get: /**
	         * Unique name for this column.
	         * @return {?}
	         */
	        function () { return this._name; },
	        set: /**
	         * @param {?} name
	         * @return {?}
	         */
	        function (name) {
	            // If the directive is set without a name (updated programatically), then this setter will
	            // trigger with an empty string and should not overwrite the programatically set value.
	            if (!name) {
	                return;
	            }
	            this._name = name;
	            this.cssClassFriendlyName = name.replace(/[^a-z0-9_-]/ig, '-');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CdkColumnDef.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[cdkColumnDef]' },] },
	    ];
	    /** @nocollapse */
	    CdkColumnDef.ctorParameters = function () { return []; };
	    CdkColumnDef.propDecorators = {
	        "name": [{ type: _angular_core.Input, args: ['cdkColumnDef',] },],
	        "cell": [{ type: _angular_core.ContentChild, args: [CdkCellDef,] },],
	        "headerCell": [{ type: _angular_core.ContentChild, args: [CdkHeaderCellDef,] },],
	    };
	    return CdkColumnDef;
	}());
	/**
	 * Header cell template container that adds the right classes and role.
	 */
	var CdkHeaderCell = /** @class */ (function () {
	    function CdkHeaderCell(columnDef, elementRef) {
	        elementRef.nativeElement.classList.add("cdk-column-" + columnDef.cssClassFriendlyName);
	    }
	    CdkHeaderCell.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'cdk-header-cell',
	                    host: {
	                        'class': 'cdk-header-cell',
	                        'role': 'columnheader',
	                    },
	                },] },
	    ];
	    /** @nocollapse */
	    CdkHeaderCell.ctorParameters = function () { return [
	        { type: CdkColumnDef, },
	        { type: _angular_core.ElementRef, },
	    ]; };
	    return CdkHeaderCell;
	}());
	/**
	 * Cell template container that adds the right classes and role.
	 */
	var CdkCell = /** @class */ (function () {
	    function CdkCell(columnDef, elementRef) {
	        elementRef.nativeElement.classList.add("cdk-column-" + columnDef.cssClassFriendlyName);
	    }
	    CdkCell.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'cdk-cell',
	                    host: {
	                        'class': 'cdk-cell',
	                        'role': 'gridcell',
	                    },
	                },] },
	    ];
	    /** @nocollapse */
	    CdkCell.ctorParameters = function () { return [
	        { type: CdkColumnDef, },
	        { type: _angular_core.ElementRef, },
	    ]; };
	    return CdkCell;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Returns an error to be thrown when attempting to find an unexisting column.
	 * \@docs-private
	 * @param {?} id Id whose lookup failed.
	 * @return {?}
	 */
	function getTableUnknownColumnError(id) {
	    return Error("Could not find column with id \"" + id + "\".");
	}
	/**
	 * Returns an error to be thrown when two column definitions have the same name.
	 * \@docs-private
	 * @param {?} name
	 * @return {?}
	 */
	function getTableDuplicateColumnNameError(name) {
	    return Error("Duplicate column definition name provided: \"" + name + "\".");
	}
	/**
	 * Returns an error to be thrown when there are multiple rows that are missing a when function.
	 * \@docs-private
	 * @return {?}
	 */
	function getTableMultipleDefaultRowDefsError() {
	    return Error("There can only be one default row without a when predicate function.");
	}
	/**
	 * Returns an error to be thrown when there are no matching row defs for a particular set of data.
	 * \@docs-private
	 * @return {?}
	 */
	function getTableMissingMatchingRowDefError() {
	    return Error("Could not find a matching row definition for the provided row data.");
	}
	/**
	 * Returns an error to be thrown when there is no row definitions present in the content.
	 * \@docs-private
	 * @return {?}
	 */
	function getTableMissingRowDefsError() {
	    return Error('Missing definitions for header and row, ' +
	        'cannot determine which columns should be rendered.');
	}
	/**
	 * Returns an error to be thrown when the data source does not match the compatible types.
	 * \@docs-private
	 * @return {?}
	 */
	function getTableUnknownDataSourceError() {
	    return Error("Provided data source did not match an array, Observable, or DataSource");
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Provides a handle for the table to grab the view container's ng-container to insert data rows.
	 * \@docs-private
	 */
	var RowPlaceholder = /** @class */ (function () {
	    function RowPlaceholder(viewContainer) {
	        this.viewContainer = viewContainer;
	    }
	    RowPlaceholder.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[rowPlaceholder]' },] },
	    ];
	    /** @nocollapse */
	    RowPlaceholder.ctorParameters = function () { return [
	        { type: _angular_core.ViewContainerRef, },
	    ]; };
	    return RowPlaceholder;
	}());
	/**
	 * Provides a handle for the table to grab the view container's ng-container to insert the header.
	 * \@docs-private
	 */
	var HeaderRowPlaceholder = /** @class */ (function () {
	    function HeaderRowPlaceholder(viewContainer) {
	        this.viewContainer = viewContainer;
	    }
	    HeaderRowPlaceholder.decorators = [
	        { type: _angular_core.Directive, args: [{ selector: '[headerRowPlaceholder]' },] },
	    ];
	    /** @nocollapse */
	    HeaderRowPlaceholder.ctorParameters = function () { return [
	        { type: _angular_core.ViewContainerRef, },
	    ]; };
	    return HeaderRowPlaceholder;
	}());
	/**
	 * The table template that can be used by the mat-table. Should not be used outside of the
	 * material library.
	 */
	var CDK_TABLE_TEMPLATE = "\n  <ng-container headerRowPlaceholder></ng-container>\n  <ng-container rowPlaceholder></ng-container>";
	/**
	 * Class used to conveniently type the embedded view ref for rows with a context.
	 * \@docs-private
	 * @abstract
	 */
	var RowViewRef = /** @class */ (function (_super) {
	    __extends(RowViewRef, _super);
	    function RowViewRef() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return RowViewRef;
	}(_angular_core.EmbeddedViewRef));
	/**
	 * A data table that renders a header row and data rows. Uses the dataSource input to determine
	 * the data to be rendered. The data can be provided either as a data array, an Observable stream
	 * that emits the data array to render, or a DataSource with a connect function that will
	 * return an Observable stream that emits the data array to render.
	 */
	var CdkTable = /** @class */ (function () {
	    function CdkTable(_differs, _changeDetectorRef, elementRef, role) {
	        this._differs = _differs;
	        this._changeDetectorRef = _changeDetectorRef;
	        /**
	         * Subject that emits when the component has been destroyed.
	         */
	        this._onDestroy = new rxjs_Subject.Subject();
	        /**
	         * Map of all the user's defined columns (header and data cell template) identified by name.
	         * Collection populated by the column definitions gathered by `ContentChildren` as well as any
	         * custom column definitions added to `_customColumnDefs`.
	         */
	        this._columnDefsByName = new Map();
	        /**
	         * Column definitions that were defined outside of the direct content children of the table.
	         */
	        this._customColumnDefs = new Set();
	        /**
	         * Row definitions that were defined outside of the direct content children of the table.
	         */
	        this._customRowDefs = new Set();
	        /**
	         * Whether the header row definition has been changed. Triggers an update to the header row after
	         * content is checked.
	         */
	        this._headerRowDefChanged = false;
	        /**
	         * Stream containing the latest information on what rows are being displayed on screen.
	         * Can be used by the data source to as a heuristic of what data should be provided.
	         */
	        this.viewChange = new rxjs_BehaviorSubject.BehaviorSubject({ start: 0, end: Number.MAX_VALUE });
	        if (!role) {
	            elementRef.nativeElement.setAttribute('role', 'grid');
	        }
	    }
	    Object.defineProperty(CdkTable.prototype, "trackBy", {
	        get: /**
	         * Tracking function that will be used to check the differences in data changes. Used similarly
	         * to `ngFor` `trackBy` function. Optimize row operations by identifying a row based on its data
	         * relative to the function to know if a row should be added/removed/moved.
	         * Accepts a function that takes two parameters, `index` and `item`.
	         * @return {?}
	         */
	        function () { return this._trackByFn; },
	        set: /**
	         * @param {?} fn
	         * @return {?}
	         */
	        function (fn) {
	            if (_angular_core.isDevMode() &&
	                fn != null && typeof fn !== 'function' && /** @type {?} */ (console) && /** @type {?} */ (console.warn)) {
	                console.warn("trackBy must be a function, but received " + JSON.stringify(fn) + ".");
	            }
	            this._trackByFn = fn;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkTable.prototype, "dataSource", {
	        get: /**
	         * The table's source of data, which can be provided in three ways (in order of complexity):
	         *   - Simple data array (each object represents one table row)
	         *   - Stream that emits a data array each time the array changes
	         *   - `DataSource` object that implements the connect/disconnect interface.
	         *
	         * If a data array is provided, the table must be notified when the array's objects are
	         * added, removed, or moved. This can be done by calling the `renderRows()` function which will
	         * render the diff since the last table render. If the data array reference is changed, the table
	         * will automatically trigger an update to the rows.
	         *
	         * When providing an Observable stream, the table will trigger an update automatically when the
	         * stream emits a new array of data.
	         *
	         * Finally, when providing a `DataSource` object, the table will use the Observable stream
	         * provided by the connect function and trigger updates when that stream emits new data array
	         * values. During the table's ngOnDestroy or when the data source is removed from the table, the
	         * table will call the DataSource's `disconnect` function (may be useful for cleaning up any
	         * subscriptions registered during the connect process).
	         * @return {?}
	         */
	        function () { return this._dataSource; },
	        set: /**
	         * @param {?} dataSource
	         * @return {?}
	         */
	        function (dataSource) {
	            if (this._dataSource !== dataSource) {
	                this._switchDataSource(dataSource);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    CdkTable.prototype.ngOnInit = /**
	     * @return {?}
	     */
	    function () {
	        // TODO(andrewseguin): Setup a listener for scrolling, emit the calculated view to viewChange
	        this._dataDiffer = this._differs.find([]).create(this._trackByFn);
	        // If the table has a header row definition defined as part of its content, flag this as a
	        // header row def change so that the content check will render the header row.
	        if (this._headerRowDef) {
	            this._headerRowDefChanged = true;
	        }
	    };
	    /**
	     * @return {?}
	     */
	    CdkTable.prototype.ngAfterContentChecked = /**
	     * @return {?}
	     */
	    function () {
	        // Cache the row and column definitions gathered by ContentChildren and programmatic injection.
	        this._cacheRowDefs();
	        this._cacheColumnDefs();
	        // Make sure that the user has at least added a header row or row def.
	        if (!this._headerRowDef && !this._rowDefs.length) {
	            throw getTableMissingRowDefsError();
	        }
	        // Render updates if the list of columns have been changed for the header or row definitions.
	        this._renderUpdatedColumns();
	        // If the header row definition has been changed, trigger a render to the header row.
	        if (this._headerRowDefChanged) {
	            this._renderHeaderRow();
	            this._headerRowDefChanged = false;
	        }
	        // If there is a data source and row definitions, connect to the data source unless a
	        // connection has already been made.
	        if (this.dataSource && this._rowDefs.length > 0 && !this._renderChangeSubscription) {
	            this._observeRenderChanges();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    CdkTable.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._rowPlaceholder.viewContainer.clear();
	        this._headerRowPlaceholder.viewContainer.clear();
	        this._onDestroy.next();
	        this._onDestroy.complete();
	        if (this.dataSource instanceof _angular_cdk_collections.DataSource) {
	            this.dataSource.disconnect(this);
	        }
	    };
	    /**
	     * Renders rows based on the table's latest set of data, which was either provided directly as an
	     * input or retrieved through an Observable stream (directly or from a DataSource).
	     * Checks for differences in the data since the last diff to perform only the necessary
	     * changes (add/remove/move rows).
	     *
	     * If the table's data source is a DataSource or Observable, this will be invoked automatically
	     * each time the provided Observable stream emits a new data array. Otherwise if your data is
	     * an array, this function will need to be called to render any changes.
	     */
	    /**
	     * Renders rows based on the table's latest set of data, which was either provided directly as an
	     * input or retrieved through an Observable stream (directly or from a DataSource).
	     * Checks for differences in the data since the last diff to perform only the necessary
	     * changes (add/remove/move rows).
	     *
	     * If the table's data source is a DataSource or Observable, this will be invoked automatically
	     * each time the provided Observable stream emits a new data array. Otherwise if your data is
	     * an array, this function will need to be called to render any changes.
	     * @return {?}
	     */
	    CdkTable.prototype.renderRows = /**
	     * Renders rows based on the table's latest set of data, which was either provided directly as an
	     * input or retrieved through an Observable stream (directly or from a DataSource).
	     * Checks for differences in the data since the last diff to perform only the necessary
	     * changes (add/remove/move rows).
	     *
	     * If the table's data source is a DataSource or Observable, this will be invoked automatically
	     * each time the provided Observable stream emits a new data array. Otherwise if your data is
	     * an array, this function will need to be called to render any changes.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        var /** @type {?} */ changes = this._dataDiffer.diff(this._data);
	        if (!changes) {
	            return;
	        }
	        var /** @type {?} */ viewContainer = this._rowPlaceholder.viewContainer;
	        changes.forEachOperation(function (record, adjustedPreviousIndex, currentIndex) {
	            if (record.previousIndex == null) {
	                _this._insertRow(record.item, currentIndex);
	            }
	            else if (currentIndex == null) {
	                viewContainer.remove(adjustedPreviousIndex);
	            }
	            else {
	                var /** @type {?} */ view = /** @type {?} */ (viewContainer.get(adjustedPreviousIndex));
	                viewContainer.move(/** @type {?} */ ((view)), currentIndex);
	            }
	        });
	        // Update the meta context of a row's context data (index, count, first, last, ...)
	        this._updateRowIndexContext();
	        // Update rows that did not get added/removed/moved but may have had their identity changed,
	        // e.g. if trackBy matched data on some property but the actual data reference changed.
	        changes.forEachIdentityChange(function (record) {
	            var /** @type {?} */ rowView = /** @type {?} */ (viewContainer.get(/** @type {?} */ ((record.currentIndex))));
	            rowView.context.$implicit = record.item;
	        });
	    };
	    /**
	     * Sets the header row definition to be used. Overrides the header row definition gathered by
	     * using `ContentChild`, if one exists. Sets a flag that will re-render the header row after the
	     * table's content is checked.
	     */
	    /**
	     * Sets the header row definition to be used. Overrides the header row definition gathered by
	     * using `ContentChild`, if one exists. Sets a flag that will re-render the header row after the
	     * table's content is checked.
	     * @param {?} headerRowDef
	     * @return {?}
	     */
	    CdkTable.prototype.setHeaderRowDef = /**
	     * Sets the header row definition to be used. Overrides the header row definition gathered by
	     * using `ContentChild`, if one exists. Sets a flag that will re-render the header row after the
	     * table's content is checked.
	     * @param {?} headerRowDef
	     * @return {?}
	     */
	    function (headerRowDef) {
	        this._headerRowDef = headerRowDef;
	        this._headerRowDefChanged = true;
	    };
	    /** Adds a column definition that was not included as part of the direct content children. */
	    /**
	     * Adds a column definition that was not included as part of the direct content children.
	     * @param {?} columnDef
	     * @return {?}
	     */
	    CdkTable.prototype.addColumnDef = /**
	     * Adds a column definition that was not included as part of the direct content children.
	     * @param {?} columnDef
	     * @return {?}
	     */
	    function (columnDef) {
	        this._customColumnDefs.add(columnDef);
	    };
	    /** Removes a column definition that was not included as part of the direct content children. */
	    /**
	     * Removes a column definition that was not included as part of the direct content children.
	     * @param {?} columnDef
	     * @return {?}
	     */
	    CdkTable.prototype.removeColumnDef = /**
	     * Removes a column definition that was not included as part of the direct content children.
	     * @param {?} columnDef
	     * @return {?}
	     */
	    function (columnDef) {
	        this._customColumnDefs.delete(columnDef);
	    };
	    /** Adds a row definition that was not included as part of the direct content children. */
	    /**
	     * Adds a row definition that was not included as part of the direct content children.
	     * @param {?} rowDef
	     * @return {?}
	     */
	    CdkTable.prototype.addRowDef = /**
	     * Adds a row definition that was not included as part of the direct content children.
	     * @param {?} rowDef
	     * @return {?}
	     */
	    function (rowDef) {
	        this._customRowDefs.add(rowDef);
	    };
	    /** Removes a row definition that was not included as part of the direct content children. */
	    /**
	     * Removes a row definition that was not included as part of the direct content children.
	     * @param {?} rowDef
	     * @return {?}
	     */
	    CdkTable.prototype.removeRowDef = /**
	     * Removes a row definition that was not included as part of the direct content children.
	     * @param {?} rowDef
	     * @return {?}
	     */
	    function (rowDef) {
	        this._customRowDefs.delete(rowDef);
	    };
	    /**
	     * Update the map containing the content's column definitions.
	     * @return {?}
	     */
	    CdkTable.prototype._cacheColumnDefs = /**
	     * Update the map containing the content's column definitions.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._columnDefsByName.clear();
	        var /** @type {?} */ columnDefs = this._contentColumnDefs ? this._contentColumnDefs.toArray() : [];
	        this._customColumnDefs.forEach(function (columnDef) { return columnDefs.push(columnDef); });
	        columnDefs.forEach(function (columnDef) {
	            if (_this._columnDefsByName.has(columnDef.name)) {
	                throw getTableDuplicateColumnNameError(columnDef.name);
	            }
	            _this._columnDefsByName.set(columnDef.name, columnDef);
	        });
	    };
	    /**
	     * Update the list of all available row definitions that can be used.
	     * @return {?}
	     */
	    CdkTable.prototype._cacheRowDefs = /**
	     * Update the list of all available row definitions that can be used.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        this._rowDefs = this._contentRowDefs ? this._contentRowDefs.toArray() : [];
	        this._customRowDefs.forEach(function (rowDef) { return _this._rowDefs.push(rowDef); });
	        var /** @type {?} */ defaultRowDefs = this._rowDefs.filter(function (def) { return !def.when; });
	        if (defaultRowDefs.length > 1) {
	            throw getTableMultipleDefaultRowDefsError();
	        }
	        this._defaultRowDef = defaultRowDefs[0];
	    };
	    /**
	     * Check if the header or rows have changed what columns they want to display. If there is a diff,
	     * then re-render that section.
	     * @return {?}
	     */
	    CdkTable.prototype._renderUpdatedColumns = /**
	     * Check if the header or rows have changed what columns they want to display. If there is a diff,
	     * then re-render that section.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        // Re-render the rows when the row definition columns change.
	        this._rowDefs.forEach(function (def) {
	            if (!!def.getColumnsDiff()) {
	                // Reset the data to an empty array so that renderRowChanges will re-render all new rows.
	                // Reset the data to an empty array so that renderRowChanges will re-render all new rows.
	                _this._dataDiffer.diff([]);
	                _this._rowPlaceholder.viewContainer.clear();
	                _this.renderRows();
	            }
	        });
	        // Re-render the header row if there is a difference in its columns.
	        if (this._headerRowDef && this._headerRowDef.getColumnsDiff()) {
	            this._renderHeaderRow();
	        }
	    };
	    /**
	     * Switch to the provided data source by resetting the data and unsubscribing from the current
	     * render change subscription if one exists. If the data source is null, interpret this by
	     * clearing the row placeholder. Otherwise start listening for new data.
	     * @param {?} dataSource
	     * @return {?}
	     */
	    CdkTable.prototype._switchDataSource = /**
	     * Switch to the provided data source by resetting the data and unsubscribing from the current
	     * render change subscription if one exists. If the data source is null, interpret this by
	     * clearing the row placeholder. Otherwise start listening for new data.
	     * @param {?} dataSource
	     * @return {?}
	     */
	    function (dataSource) {
	        this._data = [];
	        if (this.dataSource instanceof _angular_cdk_collections.DataSource) {
	            this.dataSource.disconnect(this);
	        }
	        // Stop listening for data from the previous data source.
	        if (this._renderChangeSubscription) {
	            this._renderChangeSubscription.unsubscribe();
	            this._renderChangeSubscription = null;
	        }
	        if (!dataSource) {
	            if (this._dataDiffer) {
	                this._dataDiffer.diff([]);
	            }
	            this._rowPlaceholder.viewContainer.clear();
	        }
	        this._dataSource = dataSource;
	    };
	    /**
	     * Set up a subscription for the data provided by the data source.
	     * @return {?}
	     */
	    CdkTable.prototype._observeRenderChanges = /**
	     * Set up a subscription for the data provided by the data source.
	     * @return {?}
	     */
	    function () {
	        var _this = this;
	        // If no data source has been set, there is nothing to observe for changes.
	        if (!this.dataSource) {
	            return;
	        }
	        var /** @type {?} */ dataStream;
	        // Check if the datasource is a DataSource object by observing if it has a connect function.
	        // Cannot check this.dataSource['connect'] due to potential property renaming, nor can it
	        // checked as an instanceof DataSource<T> since the table should allow for data sources
	        // that did not explicitly extend DataSource<T>.
	        if ((/** @type {?} */ (this.dataSource)).connect instanceof Function) {
	            dataStream = (/** @type {?} */ (this.dataSource)).connect(this);
	        }
	        else if (this.dataSource instanceof rxjs_Observable.Observable) {
	            dataStream = this.dataSource;
	        }
	        else if (Array.isArray(this.dataSource)) {
	            dataStream = rxjs_observable_of.of(this.dataSource);
	        }
	        if (dataStream === undefined) {
	            throw getTableUnknownDataSourceError();
	        }
	        this._renderChangeSubscription = dataStream
	            .pipe(rxjs_operators_takeUntil.takeUntil(this._onDestroy))
	            .subscribe(function (data) {
	            _this._data = data;
	            _this.renderRows();
	        });
	    };
	    /**
	     * Clears any existing content in the header row placeholder and creates a new embedded view
	     * in the placeholder using the header row definition.
	     * @return {?}
	     */
	    CdkTable.prototype._renderHeaderRow = /**
	     * Clears any existing content in the header row placeholder and creates a new embedded view
	     * in the placeholder using the header row definition.
	     * @return {?}
	     */
	    function () {
	        // Clear the header row placeholder if any content exists.
	        if (this._headerRowPlaceholder.viewContainer.length > 0) {
	            this._headerRowPlaceholder.viewContainer.clear();
	        }
	        var /** @type {?} */ cells = this._getHeaderCellTemplatesForRow(this._headerRowDef);
	        if (!cells.length) {
	            return;
	        }
	        // TODO(andrewseguin): add some code to enforce that exactly
	        //   one CdkCellOutlet was instantiated as a result
	        //   of `createEmbeddedView`.
	        this._headerRowPlaceholder.viewContainer
	            .createEmbeddedView(this._headerRowDef.template, { cells: cells });
	        cells.forEach(function (cell) {
	            if (CdkCellOutlet.mostRecentCellOutlet) {
	                CdkCellOutlet.mostRecentCellOutlet._viewContainer.createEmbeddedView(cell.template, {});
	            }
	        });
	        this._changeDetectorRef.markForCheck();
	    };
	    /**
	     * Finds the matching row definition that should be used for this row data. If there is only
	     * one row definition, it is returned. Otherwise, find the row definition that has a when
	     * predicate that returns true with the data. If none return true, return the default row
	     * definition.
	     */
	    /**
	     * Finds the matching row definition that should be used for this row data. If there is only
	     * one row definition, it is returned. Otherwise, find the row definition that has a when
	     * predicate that returns true with the data. If none return true, return the default row
	     * definition.
	     * @param {?} data
	     * @param {?} i
	     * @return {?}
	     */
	    CdkTable.prototype._getRowDef = /**
	     * Finds the matching row definition that should be used for this row data. If there is only
	     * one row definition, it is returned. Otherwise, find the row definition that has a when
	     * predicate that returns true with the data. If none return true, return the default row
	     * definition.
	     * @param {?} data
	     * @param {?} i
	     * @return {?}
	     */
	    function (data, i) {
	        if (this._rowDefs.length == 1) {
	            return this._rowDefs[0];
	        }
	        var /** @type {?} */ rowDef = this._rowDefs.find(function (def) { return def.when && def.when(i, data); }) || this._defaultRowDef;
	        if (!rowDef) {
	            throw getTableMissingMatchingRowDefError();
	        }
	        return rowDef;
	    };
	    /**
	     * Create the embedded view for the data row template and place it in the correct index location
	     * within the data row view container.
	     * @param {?} rowData
	     * @param {?} index
	     * @return {?}
	     */
	    CdkTable.prototype._insertRow = /**
	     * Create the embedded view for the data row template and place it in the correct index location
	     * within the data row view container.
	     * @param {?} rowData
	     * @param {?} index
	     * @return {?}
	     */
	    function (rowData, index) {
	        var /** @type {?} */ row = this._getRowDef(rowData, index);
	        // Row context that will be provided to both the created embedded row view and its cells.
	        var /** @type {?} */ context = { $implicit: rowData };
	        // TODO(andrewseguin): add some code to enforce that exactly one
	        //   CdkCellOutlet was instantiated as a result  of `createEmbeddedView`.
	        this._rowPlaceholder.viewContainer.createEmbeddedView(row.template, context, index);
	        this._getCellTemplatesForRow(row).forEach(function (cell) {
	            if (CdkCellOutlet.mostRecentCellOutlet) {
	                CdkCellOutlet.mostRecentCellOutlet._viewContainer
	                    .createEmbeddedView(cell.template, context);
	            }
	        });
	        this._changeDetectorRef.markForCheck();
	    };
	    /**
	     * Updates the index-related context for each row to reflect any changes in the index of the rows,
	     * e.g. first/last/even/odd.
	     * @return {?}
	     */
	    CdkTable.prototype._updateRowIndexContext = /**
	     * Updates the index-related context for each row to reflect any changes in the index of the rows,
	     * e.g. first/last/even/odd.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ viewContainer = this._rowPlaceholder.viewContainer;
	        for (var /** @type {?} */ index = 0, /** @type {?} */ count = viewContainer.length; index < count; index++) {
	            var /** @type {?} */ viewRef = /** @type {?} */ (viewContainer.get(index));
	            viewRef.context.index = index;
	            viewRef.context.count = count;
	            viewRef.context.first = index === 0;
	            viewRef.context.last = index === count - 1;
	            viewRef.context.even = index % 2 === 0;
	            viewRef.context.odd = !viewRef.context.even;
	        }
	    };
	    /**
	     * Returns the cell template definitions to insert into the header
	     * as defined by its list of columns to display.
	     * @param {?} headerDef
	     * @return {?}
	     */
	    CdkTable.prototype._getHeaderCellTemplatesForRow = /**
	     * Returns the cell template definitions to insert into the header
	     * as defined by its list of columns to display.
	     * @param {?} headerDef
	     * @return {?}
	     */
	    function (headerDef) {
	        var _this = this;
	        if (!headerDef || !headerDef.columns) {
	            return [];
	        }
	        return headerDef.columns.map(function (columnId) {
	            var /** @type {?} */ column = _this._columnDefsByName.get(columnId);
	            if (!column) {
	                throw getTableUnknownColumnError(columnId);
	            }
	            return column.headerCell;
	        });
	    };
	    /**
	     * Returns the cell template definitions to insert in the provided row
	     * as defined by its list of columns to display.
	     * @param {?} rowDef
	     * @return {?}
	     */
	    CdkTable.prototype._getCellTemplatesForRow = /**
	     * Returns the cell template definitions to insert in the provided row
	     * as defined by its list of columns to display.
	     * @param {?} rowDef
	     * @return {?}
	     */
	    function (rowDef) {
	        var _this = this;
	        if (!rowDef.columns) {
	            return [];
	        }
	        return rowDef.columns.map(function (columnId) {
	            var /** @type {?} */ column = _this._columnDefsByName.get(columnId);
	            if (!column) {
	                throw getTableUnknownColumnError(columnId);
	            }
	            return column.cell;
	        });
	    };
	    CdkTable.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'cdk-table',
	                    exportAs: 'cdkTable',
	                    template: CDK_TABLE_TEMPLATE,
	                    host: {
	                        'class': 'cdk-table',
	                    },
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    CdkTable.ctorParameters = function () { return [
	        { type: _angular_core.IterableDiffers, },
	        { type: _angular_core.ChangeDetectorRef, },
	        { type: _angular_core.ElementRef, },
	        { type: undefined, decorators: [{ type: _angular_core.Attribute, args: ['role',] },] },
	    ]; };
	    CdkTable.propDecorators = {
	        "trackBy": [{ type: _angular_core.Input },],
	        "dataSource": [{ type: _angular_core.Input },],
	        "_rowPlaceholder": [{ type: _angular_core.ViewChild, args: [RowPlaceholder,] },],
	        "_headerRowPlaceholder": [{ type: _angular_core.ViewChild, args: [HeaderRowPlaceholder,] },],
	        "_contentColumnDefs": [{ type: _angular_core.ContentChildren, args: [CdkColumnDef,] },],
	        "_contentRowDefs": [{ type: _angular_core.ContentChildren, args: [CdkRowDef,] },],
	        "_headerRowDef": [{ type: _angular_core.ContentChild, args: [CdkHeaderRowDef,] },],
	    };
	    return CdkTable;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var EXPORTED_DECLARATIONS = [
	    CdkTable,
	    CdkRowDef,
	    CdkCellDef,
	    CdkCellOutlet,
	    CdkHeaderCellDef,
	    CdkColumnDef,
	    CdkCell,
	    CdkRow,
	    CdkHeaderCell,
	    CdkHeaderRow,
	    CdkHeaderRowDef,
	    RowPlaceholder,
	    HeaderRowPlaceholder,
	];
	var CdkTableModule = /** @class */ (function () {
	    function CdkTableModule() {
	    }
	    CdkTableModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [_angular_common.CommonModule],
	                    exports: [EXPORTED_DECLARATIONS],
	                    declarations: [EXPORTED_DECLARATIONS]
	                },] },
	    ];
	    /** @nocollapse */
	    CdkTableModule.ctorParameters = function () { return []; };
	    return CdkTableModule;
	}());
	
	exports.DataSource = _angular_cdk_collections.DataSource;
	exports.RowPlaceholder = RowPlaceholder;
	exports.HeaderRowPlaceholder = HeaderRowPlaceholder;
	exports.CDK_TABLE_TEMPLATE = CDK_TABLE_TEMPLATE;
	exports.CdkTable = CdkTable;
	exports.CdkCellDef = CdkCellDef;
	exports.CdkHeaderCellDef = CdkHeaderCellDef;
	exports.CdkColumnDef = CdkColumnDef;
	exports.CdkHeaderCell = CdkHeaderCell;
	exports.CdkCell = CdkCell;
	exports.CDK_ROW_TEMPLATE = CDK_ROW_TEMPLATE;
	exports.BaseRowDef = BaseRowDef;
	exports.CdkHeaderRowDef = CdkHeaderRowDef;
	exports.CdkRowDef = CdkRowDef;
	exports.CdkCellOutlet = CdkCellOutlet;
	exports.CdkHeaderRow = CdkHeaderRow;
	exports.CdkRow = CdkRow;
	exports.CdkTableModule = CdkTableModule;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=cdk-table.umd.js.map


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(1079), __webpack_require__(1077), __webpack_require__(768), __webpack_require__(1076), __webpack_require__(240), __webpack_require__(246)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@angular/cdk/keycodes', '@angular/cdk/coercion', '@angular/forms', '@angular/cdk/bidi', 'rxjs/Subject', '@angular/common'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.cdk = global.ng.cdk || {}, global.ng.cdk.stepper = global.ng.cdk.stepper || {}),global.ng.core,global.ng.cdk.keycodes,global.ng.cdk.coercion,global.ng.forms,global.ng.cdk.bidi,global.Rx,global.ng.common));
	}(this, (function (exports,_angular_core,_angular_cdk_keycodes,_angular_cdk_coercion,_angular_forms,_angular_cdk_bidi,rxjs_Subject,_angular_common) { 'use strict';
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var CdkStepLabel = /** @class */ (function () {
	    function CdkStepLabel(template) {
	        this.template = template;
	    }
	    CdkStepLabel.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[cdkStepLabel]',
	                },] },
	    ];
	    /** @nocollapse */
	    CdkStepLabel.ctorParameters = function () { return [
	        { type: _angular_core.TemplateRef, },
	    ]; };
	    return CdkStepLabel;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Used to generate unique ID for each stepper component.
	 */
	var nextId = 0;
	/**
	 * Change event emitted on selection changes.
	 */
	var StepperSelectionEvent = /** @class */ (function () {
	    function StepperSelectionEvent() {
	    }
	    return StepperSelectionEvent;
	}());
	var CdkStep = /** @class */ (function () {
	    function CdkStep(_stepper) {
	        this._stepper = _stepper;
	        /**
	         * Whether user has seen the expanded step content or not.
	         */
	        this.interacted = false;
	        this._editable = true;
	        this._optional = false;
	        this._customCompleted = null;
	    }
	    Object.defineProperty(CdkStep.prototype, "editable", {
	        get: /**
	         * Whether the user can return to this step once it has been marked as complted.
	         * @return {?}
	         */
	        function () { return this._editable; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._editable = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkStep.prototype, "optional", {
	        get: /**
	         * Whether the completion of step is optional.
	         * @return {?}
	         */
	        function () { return this._optional; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._optional = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkStep.prototype, "completed", {
	        get: /**
	         * Whether step is marked as completed.
	         * @return {?}
	         */
	        function () {
	            return this._customCompleted == null ? this._defaultCompleted : this._customCompleted;
	        },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._customCompleted = _angular_cdk_coercion.coerceBooleanProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkStep.prototype, "_defaultCompleted", {
	        get: /**
	         * @return {?}
	         */
	        function () {
	            return this.stepControl ? this.stepControl.valid && this.interacted : this.interacted;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** Selects this step component. */
	    /**
	     * Selects this step component.
	     * @return {?}
	     */
	    CdkStep.prototype.select = /**
	     * Selects this step component.
	     * @return {?}
	     */
	    function () {
	        this._stepper.selected = this;
	    };
	    /** Resets the step to its initial state. Note that this includes resetting form data. */
	    /**
	     * Resets the step to its initial state. Note that this includes resetting form data.
	     * @return {?}
	     */
	    CdkStep.prototype.reset = /**
	     * Resets the step to its initial state. Note that this includes resetting form data.
	     * @return {?}
	     */
	    function () {
	        this.interacted = false;
	        if (this._customCompleted != null) {
	            this._customCompleted = false;
	        }
	        if (this.stepControl) {
	            this.stepControl.reset();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    CdkStep.prototype.ngOnChanges = /**
	     * @return {?}
	     */
	    function () {
	        // Since basically all inputs of the MatStep get proxied through the view down to the
	        // underlying MatStepHeader, we have to make sure that change detection runs correctly.
	        this._stepper._stateChanged();
	    };
	    CdkStep.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'cdk-step',
	                    exportAs: 'cdkStep',
	                    template: "<ng-template><ng-content></ng-content></ng-template>",
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                },] },
	    ];
	    /** @nocollapse */
	    CdkStep.ctorParameters = function () { return [
	        { type: CdkStepper, decorators: [{ type: _angular_core.Inject, args: [_angular_core.forwardRef(function () { return CdkStepper; }),] },] },
	    ]; };
	    CdkStep.propDecorators = {
	        "stepLabel": [{ type: _angular_core.ContentChild, args: [CdkStepLabel,] },],
	        "content": [{ type: _angular_core.ViewChild, args: [_angular_core.TemplateRef,] },],
	        "stepControl": [{ type: _angular_core.Input },],
	        "label": [{ type: _angular_core.Input },],
	        "editable": [{ type: _angular_core.Input },],
	        "optional": [{ type: _angular_core.Input },],
	        "completed": [{ type: _angular_core.Input },],
	    };
	    return CdkStep;
	}());
	var CdkStepper = /** @class */ (function () {
	    function CdkStepper(_dir, _changeDetectorRef) {
	        this._dir = _dir;
	        this._changeDetectorRef = _changeDetectorRef;
	        /**
	         * Emits when the component is destroyed.
	         */
	        this._destroyed = new rxjs_Subject.Subject();
	        this._linear = false;
	        this._selectedIndex = 0;
	        /**
	         * Event emitted when the selected step has changed.
	         */
	        this.selectionChange = new _angular_core.EventEmitter();
	        /**
	         * The index of the step that the focus can be set.
	         */
	        this._focusIndex = 0;
	        this._orientation = 'horizontal';
	        this._groupId = nextId++;
	    }
	    Object.defineProperty(CdkStepper.prototype, "linear", {
	        get: /**
	         * Whether the validity of previous steps should be checked or not.
	         * @return {?}
	         */
	        function () { return this._linear; },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) { this._linear = _angular_cdk_coercion.coerceBooleanProperty(value); },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkStepper.prototype, "selectedIndex", {
	        get: /**
	         * The index of the selected step.
	         * @return {?}
	         */
	        function () { return this._selectedIndex; },
	        set: /**
	         * @param {?} index
	         * @return {?}
	         */
	        function (index) {
	            if (this._steps) {
	                // Ensure that the index can't be out of bounds.
	                if (index < 0 || index > this._steps.length - 1) {
	                    throw Error('cdkStepper: Cannot assign out-of-bounds value to `selectedIndex`.');
	                }
	                if (this._anyControlsInvalidOrPending(index) || index < this._selectedIndex &&
	                    !this._steps.toArray()[index].editable) {
	                    // remove focus from clicked step header if the step is not able to be selected
	                    this._stepHeader.toArray()[index].nativeElement.blur();
	                }
	                else if (this._selectedIndex != index) {
	                    this._emitStepperSelectionEvent(index);
	                    this._focusIndex = this._selectedIndex;
	                }
	            }
	            else {
	                this._selectedIndex = this._focusIndex = index;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CdkStepper.prototype, "selected", {
	        get: /**
	         * The step that is selected.
	         * @return {?}
	         */
	        function () { return this._steps.toArray()[this.selectedIndex]; },
	        set: /**
	         * @param {?} step
	         * @return {?}
	         */
	        function (step) {
	            this.selectedIndex = this._steps.toArray().indexOf(step);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @return {?}
	     */
	    CdkStepper.prototype.ngOnDestroy = /**
	     * @return {?}
	     */
	    function () {
	        this._destroyed.next();
	        this._destroyed.complete();
	    };
	    /** Selects and focuses the next step in list. */
	    /**
	     * Selects and focuses the next step in list.
	     * @return {?}
	     */
	    CdkStepper.prototype.next = /**
	     * Selects and focuses the next step in list.
	     * @return {?}
	     */
	    function () {
	        this.selectedIndex = Math.min(this._selectedIndex + 1, this._steps.length - 1);
	    };
	    /** Selects and focuses the previous step in list. */
	    /**
	     * Selects and focuses the previous step in list.
	     * @return {?}
	     */
	    CdkStepper.prototype.previous = /**
	     * Selects and focuses the previous step in list.
	     * @return {?}
	     */
	    function () {
	        this.selectedIndex = Math.max(this._selectedIndex - 1, 0);
	    };
	    /** Resets the stepper to its initial state. Note that this includes clearing form data. */
	    /**
	     * Resets the stepper to its initial state. Note that this includes clearing form data.
	     * @return {?}
	     */
	    CdkStepper.prototype.reset = /**
	     * Resets the stepper to its initial state. Note that this includes clearing form data.
	     * @return {?}
	     */
	    function () {
	        this.selectedIndex = 0;
	        this._steps.forEach(function (step) { return step.reset(); });
	        this._stateChanged();
	    };
	    /** Returns a unique id for each step label element. */
	    /**
	     * Returns a unique id for each step label element.
	     * @param {?} i
	     * @return {?}
	     */
	    CdkStepper.prototype._getStepLabelId = /**
	     * Returns a unique id for each step label element.
	     * @param {?} i
	     * @return {?}
	     */
	    function (i) {
	        return "cdk-step-label-" + this._groupId + "-" + i;
	    };
	    /** Returns unique id for each step content element. */
	    /**
	     * Returns unique id for each step content element.
	     * @param {?} i
	     * @return {?}
	     */
	    CdkStepper.prototype._getStepContentId = /**
	     * Returns unique id for each step content element.
	     * @param {?} i
	     * @return {?}
	     */
	    function (i) {
	        return "cdk-step-content-" + this._groupId + "-" + i;
	    };
	    /** Marks the component to be change detected. */
	    /**
	     * Marks the component to be change detected.
	     * @return {?}
	     */
	    CdkStepper.prototype._stateChanged = /**
	     * Marks the component to be change detected.
	     * @return {?}
	     */
	    function () {
	        this._changeDetectorRef.markForCheck();
	    };
	    /** Returns position state of the step with the given index. */
	    /**
	     * Returns position state of the step with the given index.
	     * @param {?} index
	     * @return {?}
	     */
	    CdkStepper.prototype._getAnimationDirection = /**
	     * Returns position state of the step with the given index.
	     * @param {?} index
	     * @return {?}
	     */
	    function (index) {
	        var /** @type {?} */ position = index - this._selectedIndex;
	        if (position < 0) {
	            return this._layoutDirection() === 'rtl' ? 'next' : 'previous';
	        }
	        else if (position > 0) {
	            return this._layoutDirection() === 'rtl' ? 'previous' : 'next';
	        }
	        return 'current';
	    };
	    /** Returns the type of icon to be displayed. */
	    /**
	     * Returns the type of icon to be displayed.
	     * @param {?} index
	     * @return {?}
	     */
	    CdkStepper.prototype._getIndicatorType = /**
	     * Returns the type of icon to be displayed.
	     * @param {?} index
	     * @return {?}
	     */
	    function (index) {
	        var /** @type {?} */ step = this._steps.toArray()[index];
	        if (!step.completed || this._selectedIndex == index) {
	            return 'number';
	        }
	        else {
	            return step.editable ? 'edit' : 'done';
	        }
	    };
	    /**
	     * @param {?} newIndex
	     * @return {?}
	     */
	    CdkStepper.prototype._emitStepperSelectionEvent = /**
	     * @param {?} newIndex
	     * @return {?}
	     */
	    function (newIndex) {
	        var /** @type {?} */ stepsArray = this._steps.toArray();
	        this.selectionChange.emit({
	            selectedIndex: newIndex,
	            previouslySelectedIndex: this._selectedIndex,
	            selectedStep: stepsArray[newIndex],
	            previouslySelectedStep: stepsArray[this._selectedIndex],
	        });
	        this._selectedIndex = newIndex;
	        this._stateChanged();
	    };
	    /**
	     * @param {?} event
	     * @return {?}
	     */
	    CdkStepper.prototype._onKeydown = /**
	     * @param {?} event
	     * @return {?}
	     */
	    function (event) {
	        var /** @type {?} */ keyCode = event.keyCode;
	        // Note that the left/right arrows work both in vertical and horizontal mode.
	        if (keyCode === _angular_cdk_keycodes.RIGHT_ARROW) {
	            this._layoutDirection() === 'rtl' ? this._focusPreviousStep() : this._focusNextStep();
	            event.preventDefault();
	        }
	        if (keyCode === _angular_cdk_keycodes.LEFT_ARROW) {
	            this._layoutDirection() === 'rtl' ? this._focusNextStep() : this._focusPreviousStep();
	            event.preventDefault();
	        }
	        // Note that the up/down arrows only work in vertical mode.
	        // See: https://www.w3.org/TR/wai-aria-practices-1.1/#tabpanel
	        if (this._orientation === 'vertical' && (keyCode === _angular_cdk_keycodes.UP_ARROW || keyCode === _angular_cdk_keycodes.DOWN_ARROW)) {
	            keyCode === _angular_cdk_keycodes.UP_ARROW ? this._focusPreviousStep() : this._focusNextStep();
	            event.preventDefault();
	        }
	        if (keyCode === _angular_cdk_keycodes.SPACE || keyCode === _angular_cdk_keycodes.ENTER) {
	            this.selectedIndex = this._focusIndex;
	            event.preventDefault();
	        }
	        if (keyCode === _angular_cdk_keycodes.HOME) {
	            this._focusStep(0);
	            event.preventDefault();
	        }
	        if (keyCode === _angular_cdk_keycodes.END) {
	            this._focusStep(this._steps.length - 1);
	            event.preventDefault();
	        }
	    };
	    /**
	     * @return {?}
	     */
	    CdkStepper.prototype._focusNextStep = /**
	     * @return {?}
	     */
	    function () {
	        this._focusStep((this._focusIndex + 1) % this._steps.length);
	    };
	    /**
	     * @return {?}
	     */
	    CdkStepper.prototype._focusPreviousStep = /**
	     * @return {?}
	     */
	    function () {
	        this._focusStep((this._focusIndex + this._steps.length - 1) % this._steps.length);
	    };
	    /**
	     * @param {?} index
	     * @return {?}
	     */
	    CdkStepper.prototype._focusStep = /**
	     * @param {?} index
	     * @return {?}
	     */
	    function (index) {
	        this._focusIndex = index;
	        this._stepHeader.toArray()[this._focusIndex].nativeElement.focus();
	    };
	    /**
	     * @param {?} index
	     * @return {?}
	     */
	    CdkStepper.prototype._anyControlsInvalidOrPending = /**
	     * @param {?} index
	     * @return {?}
	     */
	    function (index) {
	        var /** @type {?} */ steps = this._steps.toArray();
	        steps[this._selectedIndex].interacted = true;
	        if (this._linear && index >= 0) {
	            return steps.slice(0, index).some(function (step) {
	                var /** @type {?} */ control = step.stepControl;
	                var /** @type {?} */ isIncomplete = control ?
	                    (control.invalid || control.pending || !step.interacted) :
	                    !step.completed;
	                return isIncomplete && !step.optional;
	            });
	        }
	        return false;
	    };
	    /**
	     * @return {?}
	     */
	    CdkStepper.prototype._layoutDirection = /**
	     * @return {?}
	     */
	    function () {
	        return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
	    };
	    CdkStepper.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: '[cdkStepper]',
	                    exportAs: 'cdkStepper',
	                },] },
	    ];
	    /** @nocollapse */
	    CdkStepper.ctorParameters = function () { return [
	        { type: _angular_cdk_bidi.Directionality, decorators: [{ type: _angular_core.Optional },] },
	        { type: _angular_core.ChangeDetectorRef, },
	    ]; };
	    CdkStepper.propDecorators = {
	        "_steps": [{ type: _angular_core.ContentChildren, args: [CdkStep,] },],
	        "linear": [{ type: _angular_core.Input },],
	        "selectedIndex": [{ type: _angular_core.Input },],
	        "selected": [{ type: _angular_core.Input },],
	        "selectionChange": [{ type: _angular_core.Output },],
	    };
	    return CdkStepper;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Button that moves to the next step in a stepper workflow.
	 */
	var CdkStepperNext = /** @class */ (function () {
	    function CdkStepperNext(_stepper) {
	        this._stepper = _stepper;
	        /**
	         * Type of the next button. Defaults to "submit" if not specified.
	         */
	        this.type = 'submit';
	    }
	    CdkStepperNext.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'button[cdkStepperNext]',
	                    host: {
	                        '(click)': '_stepper.next()',
	                        '[type]': 'type',
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    CdkStepperNext.ctorParameters = function () { return [
	        { type: CdkStepper, },
	    ]; };
	    CdkStepperNext.propDecorators = {
	        "type": [{ type: _angular_core.Input },],
	    };
	    return CdkStepperNext;
	}());
	/**
	 * Button that moves to the previous step in a stepper workflow.
	 */
	var CdkStepperPrevious = /** @class */ (function () {
	    function CdkStepperPrevious(_stepper) {
	        this._stepper = _stepper;
	        /**
	         * Type of the previous button. Defaults to "button" if not specified.
	         */
	        this.type = 'button';
	    }
	    CdkStepperPrevious.decorators = [
	        { type: _angular_core.Directive, args: [{
	                    selector: 'button[cdkStepperPrevious]',
	                    host: {
	                        '(click)': '_stepper.previous()',
	                        '[type]': 'type',
	                    }
	                },] },
	    ];
	    /** @nocollapse */
	    CdkStepperPrevious.ctorParameters = function () { return [
	        { type: CdkStepper, },
	    ]; };
	    CdkStepperPrevious.propDecorators = {
	        "type": [{ type: _angular_core.Input },],
	    };
	    return CdkStepperPrevious;
	}());
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	var CdkStepperModule = /** @class */ (function () {
	    function CdkStepperModule() {
	    }
	    CdkStepperModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [_angular_cdk_bidi.BidiModule, _angular_common.CommonModule],
	                    exports: [CdkStep, CdkStepper, CdkStepLabel, CdkStepperNext, CdkStepperPrevious],
	                    declarations: [CdkStep, CdkStepper, CdkStepLabel, CdkStepperNext, CdkStepperPrevious]
	                },] },
	    ];
	    /** @nocollapse */
	    CdkStepperModule.ctorParameters = function () { return []; };
	    return CdkStepperModule;
	}());
	
	exports.StepperSelectionEvent = StepperSelectionEvent;
	exports.CdkStep = CdkStep;
	exports.CdkStepper = CdkStepper;
	exports.CdkStepLabel = CdkStepLabel;
	exports.CdkStepperNext = CdkStepperNext;
	exports.CdkStepperPrevious = CdkStepperPrevious;
	exports.CdkStepperModule = CdkStepperModule;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=cdk-stepper.umd.js.map


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var available_currency_1 = __webpack_require__(1477);
	var badge_1 = __webpack_require__(1479);
	var editable_cell_1 = __webpack_require__(1481);
	var edit_button_group_1 = __webpack_require__(1483);
	var panel_details_1 = __webpack_require__(1485);
	var profile_kind_badge_component_1 = __webpack_require__(1490);
	var profile_state_badge_component_1 = __webpack_require__(1491);
	var fourstop_state_badge_component_1 = __webpack_require__(1492);
	var profile_type_icon_component_1 = __webpack_require__(1493);
	var whitelabel_badge_component_1 = __webpack_require__(1494);
	var profile_accounts_component_1 = __webpack_require__(1495);
	var profile_cards_component_1 = __webpack_require__(1497);
	var card_component_1 = __webpack_require__(1501);
	var file_upload_modal_component_1 = __webpack_require__(1504);
	var kyc_1 = __webpack_require__(1444);
	var results_1 = __webpack_require__(1447);
	var onfido_1 = __webpack_require__(1506);
	var results_2 = __webpack_require__(1509);
	var ariadnext_1 = __webpack_require__(1514);
	var documents_1 = __webpack_require__(1521);
	var emails_1 = __webpack_require__(1530);
	var business_customer_information_1 = __webpack_require__(1534);
	var official_business_location_1 = __webpack_require__(1541);
	var profile_users_component_1 = __webpack_require__(1545);
	var profile_api_access_component_1 = __webpack_require__(1547);
	var date_converter_pipe_1 = __webpack_require__(1550);
	var profile_provider_badge_component_1 = __webpack_require__(1551);
	exports.PROFILE_SHARED_COMPONENTS = [
	    profile_kind_badge_component_1.ProfileKindBadgeComponent,
	    profile_state_badge_component_1.ProfileStateBadgeComponent,
	    profile_provider_badge_component_1.ProfileProviderBadgeComponent,
	    profile_type_icon_component_1.ProfileTypeImageComponent,
	    fourstop_state_badge_component_1.FourStopProcessingBadgeComponent,
	    whitelabel_badge_component_1.WhitelabelBadgeComponent,
	    profile_accounts_component_1.ProfileAccountsComponent,
	    profile_users_component_1.ProfileUsersComponent,
	    profile_api_access_component_1.ProfileApiAccessComponent,
	    date_converter_pipe_1.ConverterStringToDateString,
	    profile_cards_component_1.ProfileCardsComponent,
	    card_component_1.ProfileCardComponent,
	    file_upload_modal_component_1.FileUploadModalComponent,
	    edit_button_group_1.EditButtonGroupComponent,
	    editable_cell_1.EditableCellComponent,
	    available_currency_1.AvailableCurrencyComponent,
	    badge_1.BadgeComponent,
	    emails_1.EmailSendComponent,
	    business_customer_information_1.BusinessCustomersInformationComponent,
	    official_business_location_1.OfficialBusinessLocationComponent
	].concat(kyc_1.KYC_VERIFICATION_COMPONENTS, results_1.KYC_VERIFICATION_RESULTS_COMPONENTS, onfido_1.ONFIDO_VERIFICATION_COMPONENTS, results_2.ONFIDO_VERIFICATION_RESULTS_COMPONENTS, ariadnext_1.ARIADNEXT_VERIFICATION_COMPONENTS, panel_details_1.PANEL_DETAILS_COMPONENTS, documents_1.CORPORATE_PROFILE_DOCUMENTS_COMPONENTS);


/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1478));


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var AvailableCurrencyComponent = (function () {
	    function AvailableCurrencyComponent() {
	    }
	    AvailableCurrencyComponent.prototype.isCurrencyAvailable = function (id) {
	        return this.currencies.find(function (currency) { return currency.id === +id; }).available;
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], AvailableCurrencyComponent.prototype, "currencies", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], AvailableCurrencyComponent.prototype, "currencyIds", void 0);
	    AvailableCurrencyComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-available-currency',
	            template: "\n        <tfl-bo-badge *ngFor=\"let currencyId of currencyIds\">\n            {{currencyId | value_by_key:currencies}}\n\n            <i *ngIf=\"isCurrencyAvailable(currencyId)\"\n               class=\"fa fa-check-circle fa-lg green\"\n            ></i>\n\n            <i *ngIf=\"!isCurrencyAvailable(currencyId)\"\n               class=\"fa fa-exclamation-triangle fa-lg red\"\n               title=\"{{currencyId|value_by_key:currencies}}{{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.UNAVAILABLE_CURRENCY'|translate}}\"\n            ></i>\n        </tfl-bo-badge>\n    ",
	            changeDetection: core_1.ChangeDetectionStrategy.OnPush
	        })
	    ], AvailableCurrencyComponent);
	    return AvailableCurrencyComponent;
	}());
	exports.AvailableCurrencyComponent = AvailableCurrencyComponent;


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1480));


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var BadgeComponent = (function () {
	    function BadgeComponent() {
	    }
	    BadgeComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-badge',
	            template: "<ng-content></ng-content>"
	        })
	    ], BadgeComponent);
	    return BadgeComponent;
	}());
	exports.BadgeComponent = BadgeComponent;


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1482));


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var EditableCellComponent = (function () {
	    function EditableCellComponent() {
	        this.isEdit = false;
	    }
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], EditableCellComponent.prototype, "label", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], EditableCellComponent.prototype, "value", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", core_1.TemplateRef)
	    ], EditableCellComponent.prototype, "valueTmpl", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], EditableCellComponent.prototype, "isEdit", void 0);
	    EditableCellComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-editable-cell',
	            template: "\n        <div class=\"form-group\">\n            <label class=\"control-label col-sm-6 col-xs-12\">\n                {{ label | translate }}\n            </label>\n            <div class=\"col-sm-6 col-xs-12\">\n                <div *ngIf=\"!isEdit\" class=\"form-control-static\">\n                    <ng-container *ngIf=\"value\">{{value}}</ng-container>\n                    <ng-container *ngIf=\"valueTmpl\" [ngTemplateOutlet]=\"valueTmpl\"></ng-container>\n                </div>\n                <div [hidden]=\"!isEdit\" class=\"form-control-container\">\n                    <ng-content></ng-content>\n                </div>\n            </div>\n        </div>\n    "
	        })
	    ], EditableCellComponent);
	    return EditableCellComponent;
	}());
	exports.EditableCellComponent = EditableCellComponent;


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1484));


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var security_1 = __webpack_require__(736);
	var util_1 = __webpack_require__(743);
	var EditButtonGroupComponent = (function () {
	    function EditButtonGroupComponent(roleService) {
	        this.roleService = roleService;
	        this.isEditing = false;
	        this.isSaveDisabled = true;
	        this.disabled = false;
	        this.edit = new core_1.EventEmitter();
	        this.discard = new core_1.EventEmitter();
	        this.save = new core_1.EventEmitter();
	    }
	    EditButtonGroupComponent.prototype.onEdit = function (e) {
	        e.stopPropagation();
	        this.isEditing = true;
	        this.edit.emit(e);
	    };
	    EditButtonGroupComponent.prototype.onSave = function (e) {
	        e.stopPropagation();
	        if (!this.isSaveDisabled) {
	            this.isEditing = false;
	            this.save.emit(e);
	        }
	    };
	    EditButtonGroupComponent.prototype.onDiscard = function (e) {
	        e.stopPropagation();
	        this.isEditing = false;
	        this.discard.emit(e);
	    };
	    EditButtonGroupComponent.prototype.isDisabled = function () {
	        if (util_1.isNullOrUndefined(this.permission)) {
	            return false;
	        }
	        return !this.roleService.hasElementRoles(security_1.Roles.EDIT, this.permission);
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], EditButtonGroupComponent.prototype, "isEditing", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], EditButtonGroupComponent.prototype, "isSaveDisabled", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], EditButtonGroupComponent.prototype, "disabled", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], EditButtonGroupComponent.prototype, "idPermission", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", Object)
	    ], EditButtonGroupComponent.prototype, "edit", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", Object)
	    ], EditButtonGroupComponent.prototype, "discard", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", Object)
	    ], EditButtonGroupComponent.prototype, "save", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], EditButtonGroupComponent.prototype, "permission", void 0);
	    EditButtonGroupComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-edit-button-group',
	            template: "\n        <ng-container *ngIf=\"!isEditing\">\n            <button (click)=\"onEdit($event)\" class=\"edit-button btn btn-info btn-sm\" [disabled]=\"isDisabled()\">\n                {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.EDIT.BUTTON.NAME' | translate }}\n            </button>\n        </ng-container>\n\n        <ng-container *ngIf=\"isEditing\">\n            <button (click)=\"onDiscard($event)\" class=\"discard-button btn btn-default btn-sm\">\n                {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.DISCARD.BUTTON.NAME' | translate }}\n            </button>\n            <button (click)=\"onSave($event)\" class=\"save-button btn btn-success btn-sm\"\n                    [disabled]=\"isSaveDisabled\">\n                {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.SAVE.BUTTON.NAME' | translate }}\n            </button>\n        </ng-container>\n    "
	        }),
	        __metadata("design:paramtypes", [security_1.RoleService])
	    ], EditButtonGroupComponent);
	    return EditButtonGroupComponent;
	}());
	exports.EditButtonGroupComponent = EditButtonGroupComponent;


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var panel_details_component_1 = __webpack_require__(1486);
	var panel_details_group_component_1 = __webpack_require__(1487);
	var panel_details_column_component_1 = __webpack_require__(1488);
	var panel_details_cell_component_1 = __webpack_require__(1489);
	__export(__webpack_require__(1486));
	exports.PANEL_DETAILS_COMPONENTS = [
	    panel_details_component_1.PanelDetailsComponent,
	    panel_details_group_component_1.PanelDetailsGroupComponent,
	    panel_details_column_component_1.PanelDetailsColumnComponent,
	    panel_details_cell_component_1.PanelDetailsCellComponent
	];


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var accordion_group_component_1 = __webpack_require__(1000);
	var edit_button_group_1 = __webpack_require__(1483);
	var PanelDetailsComponent = (function () {
	    function PanelDetailsComponent() {
	    }
	    PanelDetailsComponent.prototype.ngAfterContentInit = function () {
	        var _this = this;
	        if (this.editBlockComponent) {
	            this.detailsEdit$ = this.editBlockComponent.edit
	                .subscribe(function () { return _this.accordionGroupComponent.open(); });
	        }
	    };
	    PanelDetailsComponent.prototype.ngOnDestroy = function () {
	        if (this.detailsEdit$) {
	            this.detailsEdit$.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], PanelDetailsComponent.prototype, "caption", void 0);
	    __decorate([
	        core_1.ViewChild(accordion_group_component_1.AccordionGroupComponent),
	        __metadata("design:type", accordion_group_component_1.AccordionGroupComponent)
	    ], PanelDetailsComponent.prototype, "accordionGroupComponent", void 0);
	    __decorate([
	        core_1.ContentChild(edit_button_group_1.EditButtonGroupComponent),
	        __metadata("design:type", edit_button_group_1.EditButtonGroupComponent)
	    ], PanelDetailsComponent.prototype, "editBlockComponent", void 0);
	    PanelDetailsComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-panel-details',
	            template: "\n        <accordion>\n            <accordion-group>\n\n                <accordion-header>\n                    <accordion-toggle\n                        [title]=\"caption\"\n                        [rightBlockTmpl]=\"detailsEditTmpl\">\n\n                        <ng-template #detailsEditTmpl>\n                            <ng-content select=\"tfl-edit-button-group\"></ng-content>\n                        </ng-template>\n\n                    </accordion-toggle>\n                </accordion-header>\n\n                <accordion-content>\n                    <ng-content></ng-content>\n                </accordion-content>\n\n            </accordion-group>\n        </accordion>\n    "
	        })
	    ], PanelDetailsComponent);
	    return PanelDetailsComponent;
	}());
	exports.PanelDetailsComponent = PanelDetailsComponent;


/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var PanelDetailsGroupComponent = (function () {
	    function PanelDetailsGroupComponent() {
	    }
	    __decorate([
	        core_1.Input('title'),
	        __metadata("design:type", String)
	    ], PanelDetailsGroupComponent.prototype, "title", void 0);
	    PanelDetailsGroupComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-panel-details-group',
	            template: "\n        <div *ngIf=\"title\" class=\"row\">\n            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <h4 class=\"panel-group-title\">{{ title | translate }}</h4>\n            </div>\n        </div>\n        <div class=\"row\">\n            <ng-content></ng-content>\n        </div>\n    "
	        })
	    ], PanelDetailsGroupComponent);
	    return PanelDetailsGroupComponent;
	}());
	exports.PanelDetailsGroupComponent = PanelDetailsGroupComponent;


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var PanelDetailsColumnComponent = (function () {
	    function PanelDetailsColumnComponent() {
	    }
	    PanelDetailsColumnComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-panel-details-column',
	            template: "\n        <div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\">\n            <ng-content></ng-content>\n        </div>\n    "
	        })
	    ], PanelDetailsColumnComponent);
	    return PanelDetailsColumnComponent;
	}());
	exports.PanelDetailsColumnComponent = PanelDetailsColumnComponent;


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var PanelDetailsCellComponent = (function () {
	    function PanelDetailsCellComponent() {
	    }
	    __decorate([
	        core_1.Input('label'),
	        __metadata("design:type", String)
	    ], PanelDetailsCellComponent.prototype, "label", void 0);
	    PanelDetailsCellComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-panel-details-cell',
	            template: "\n        <div class=\"form-group row\">\n            <label class=\"control-label col-sm-6 col-xs-12\">\n                {{ label | translate : {company: ('BY_VENDOR.SPACE.TRADE'|translate)} }}\n            </label>\n            <div class=\"col-sm-6 col-xs-12 control-container\">\n                <ng-content></ng-content>\n            </div>\n        </div>\n    "
	        })
	    ], PanelDetailsCellComponent);
	    return PanelDetailsCellComponent;
	}());
	exports.PanelDetailsCellComponent = PanelDetailsCellComponent;


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var constants_1 = __webpack_require__(861);
	var ProfileKindBadgeComponent = (function () {
	    function ProfileKindBadgeComponent() {
	        this.kindBadgeClass = {};
	        this.kindBadgeTitle = '';
	    }
	    Object.defineProperty(ProfileKindBadgeComponent.prototype, "_kind", {
	        set: function (kind) {
	            this.kindBadgeClass = this.getKindBadgeClass(kind);
	            this.kindBadgeTitle = this.getKindBadgeTitle(kind);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ProfileKindBadgeComponent.prototype.getKindBadgeClass = function (kind) {
	        return {
	            'label        ': true,
	            'label-default': kind === constants_1.PROFILE_KIND.CUSTOMER || kind === constants_1.PROFILE_KIND.SUB_CLIENT,
	            'label-info   ': kind === constants_1.PROFILE_KIND.AGENT || kind === constants_1.PROFILE_KIND.INSTITUTIONAL_CLIENT,
	            'label-primary': kind === constants_1.PROFILE_KIND.SALESMAN || kind === constants_1.PROFILE_KIND.SALESMAN_LEAD,
	            'label-success': kind === constants_1.PROFILE_KIND.WHITE_LABEL
	        };
	    };
	    ProfileKindBadgeComponent.prototype.getKindBadgeTitle = function (kind) {
	        switch (kind) {
	            case constants_1.PROFILE_KIND.CUSTOMER:
	                return 'CUSTOMER.KIND.CUSTOMER';
	            case constants_1.PROFILE_KIND.AGENT:
	                return 'CUSTOMER.KIND.AGENT';
	            case constants_1.PROFILE_KIND.SALESMAN:
	                return 'CUSTOMER.KIND.SALESMAN';
	            case constants_1.PROFILE_KIND.SALESMAN_LEAD:
	                return 'CUSTOMER.KIND.SALESMAN_LEAD';
	            case constants_1.PROFILE_KIND.WHITE_LABEL:
	                return 'CUSTOMER.KIND.WHITE_LABEL';
	            case constants_1.PROFILE_KIND.INSTITUTIONAL_CLIENT:
	                return 'CUSTOMER.KIND.INSTITUTIONAL_CLIENT';
	            case constants_1.PROFILE_KIND.SUB_CLIENT:
	                return 'CUSTOMER.KIND.SUB_CLIENT';
	        }
	    };
	    __decorate([
	        core_1.Input('kind'),
	        __metadata("design:type", Number),
	        __metadata("design:paramtypes", [Number])
	    ], ProfileKindBadgeComponent.prototype, "_kind", null);
	    ProfileKindBadgeComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-profile-kind-badge',
	            template: "\n        <span [ngClass]=\"kindBadgeClass\">\n            {{ kindBadgeTitle | translate }}\n        </span>\n    "
	        })
	    ], ProfileKindBadgeComponent);
	    return ProfileKindBadgeComponent;
	}());
	exports.ProfileKindBadgeComponent = ProfileKindBadgeComponent;


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var constants_1 = __webpack_require__(861);
	var ProfileStateBadgeComponent = (function () {
	    function ProfileStateBadgeComponent() {
	        this.stateBadgeClass = {};
	        this.stateBadgeTitle = '';
	    }
	    Object.defineProperty(ProfileStateBadgeComponent.prototype, "_state", {
	        set: function (state) {
	            this.stateBadgeClass = this.getStateBadgeClass(state);
	            this.stateBadgeTitle = this.getStateBadgeTitle(state);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ProfileStateBadgeComponent.prototype.getStateBadgeClass = function (state) {
	        return {
	            'label        ': true,
	            'label-success': state === constants_1.PROFILE_STATE.ACTIVE,
	            'label-danger': state === constants_1.PROFILE_STATE.REJECTED || state === constants_1.PROFILE_STATE.DECLINED || state === constants_1.PROFILE_STATE.SUSPENDED || state === constants_1.PROFILE_STATE.CLOSED,
	            'label-default': state === constants_1.PROFILE_STATE.NEW,
	            'label-info   ': state === constants_1.PROFILE_STATE.ON_HOLD,
	            'label-warning': state === constants_1.PROFILE_STATE.PROCESSING,
	            'btn-dark': state === constants_1.PROFILE_STATE.ARCHIVED,
	        };
	    };
	    ProfileStateBadgeComponent.prototype.getStateBadgeTitle = function (state) {
	        switch (state) {
	            case constants_1.PROFILE_STATE.ACTIVE:
	                return 'CUSTOMER.STATE.ACTIVE';
	            case constants_1.PROFILE_STATE.REJECTED:
	                return 'CUSTOMER.STATE.REJECTED';
	            case constants_1.PROFILE_STATE.DECLINED:
	                return 'CUSTOMER.STATE.DECLINED';
	            case constants_1.PROFILE_STATE.NEW:
	                return 'CUSTOMER.STATE.NEW';
	            case constants_1.PROFILE_STATE.PROCESSING:
	                return 'CUSTOMER.STATE.PROCESSING';
	            case constants_1.PROFILE_STATE.ARCHIVED:
	                return 'CUSTOMER.STATE.ARCHIVED';
	            case constants_1.PROFILE_STATE.ON_HOLD:
	                return 'CUSTOMER.STATE.ON_HOLD';
	            case constants_1.PROFILE_STATE.SUSPENDED:
	                return 'CUSTOMER.STATE.SUSPENDED';
	            case constants_1.PROFILE_STATE.CLOSED:
	                return 'CUSTOMER.STATE.CLOSED';
	        }
	    };
	    __decorate([
	        core_1.Input('state'),
	        __metadata("design:type", String),
	        __metadata("design:paramtypes", [String])
	    ], ProfileStateBadgeComponent.prototype, "_state", null);
	    ProfileStateBadgeComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-profile-state-badge',
	            template: "\n        <span [ngClass]=\"stateBadgeClass\">\n            {{ stateBadgeTitle | translate }}\n        </span>\n    "
	        })
	    ], ProfileStateBadgeComponent);
	    return ProfileStateBadgeComponent;
	}());
	exports.ProfileStateBadgeComponent = ProfileStateBadgeComponent;


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var constants_1 = __webpack_require__(861);
	var FourStopProcessingBadgeComponent = (function () {
	    function FourStopProcessingBadgeComponent() {
	        this.fourstopBadgeClass = {};
	        this.fourstopBadgeTitle = '';
	    }
	    Object.defineProperty(FourStopProcessingBadgeComponent.prototype, "_processedByFourStop", {
	        set: function (processedByFourStop) {
	            this.fourstopBadgeClass = this.getStateBadgeClass(processedByFourStop);
	            this.fourstopBadgeTitle = this.getStateBadgeTitle(processedByFourStop);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    FourStopProcessingBadgeComponent.prototype.getStateBadgeClass = function (state) {
	        return {
	            'label        ': true,
	            'label-info': state === constants_1.FOURSTOP_STATUS.PROCESSED_BY_FOURSTOP
	        };
	    };
	    FourStopProcessingBadgeComponent.prototype.getStateBadgeTitle = function (state) {
	        switch (state) {
	            case constants_1.FOURSTOP_STATUS.PROCESSED_BY_FOURSTOP:
	                return 'CUSTOMER.STATE.4STOP_PROCESSING';
	        }
	    };
	    __decorate([
	        core_1.Input('processedByFourStop'),
	        __metadata("design:type", Boolean),
	        __metadata("design:paramtypes", [Boolean])
	    ], FourStopProcessingBadgeComponent.prototype, "_processedByFourStop", null);
	    FourStopProcessingBadgeComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-fourstop-state-badge',
	            template: "\n        <span [ngClass]=\"fourstopBadgeClass\">\n            {{ fourstopBadgeTitle | translate }}\n        </span>\n    "
	        })
	    ], FourStopProcessingBadgeComponent);
	    return FourStopProcessingBadgeComponent;
	}());
	exports.FourStopProcessingBadgeComponent = FourStopProcessingBadgeComponent;


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var constants_1 = __webpack_require__(861);
	var ProfileTypeImageComponent = (function () {
	    function ProfileTypeImageComponent() {
	        this.profileTypeIconClass = {};
	    }
	    Object.defineProperty(ProfileTypeImageComponent.prototype, "_type", {
	        set: function (type) {
	            this.profileTypeIconClass = {
	                'fa           ': true,
	                'fa-2x        ': true,
	                'fa-building-o': type === constants_1.PROFILE_TYPE.CORPORATE,
	                'fa-user      ': type === constants_1.PROFILE_TYPE.PRIVATE
	            };
	        },
	        enumerable: true,
	        configurable: true
	    });
	    __decorate([
	        core_1.Input('type'),
	        __metadata("design:type", Number),
	        __metadata("design:paramtypes", [Number])
	    ], ProfileTypeImageComponent.prototype, "_type", null);
	    ProfileTypeImageComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-profile-type-icon',
	            template: '<i [ngClass]="profileTypeIconClass"></i>'
	        })
	    ], ProfileTypeImageComponent);
	    return ProfileTypeImageComponent;
	}());
	exports.ProfileTypeImageComponent = ProfileTypeImageComponent;


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(268);
	var core_1 = __webpack_require__(205);
	var WhitelabelBadgeComponent = (function () {
	    function WhitelabelBadgeComponent() {
	    }
	    WhitelabelBadgeComponent.prototype.isBlankWhitelabel = function () {
	        return lodash_1.isEmpty(this.whitelabel);
	    };
	    __decorate([
	        core_1.Input('whitelabel'),
	        __metadata("design:type", String)
	    ], WhitelabelBadgeComponent.prototype, "whitelabel", void 0);
	    WhitelabelBadgeComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-profile-whitelablel',
	            template: "\n        <span *ngIf=\"!isBlankWhitelabel()\" class=\"label label-whitelabel label-danger\">\n            WL: {{ whitelabel }}\n        </span>\n    "
	        })
	    ], WhitelabelBadgeComponent);
	    return WhitelabelBadgeComponent;
	}());
	exports.WhitelabelBadgeComponent = WhitelabelBadgeComponent;


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var router_1 = __webpack_require__(270);
	var lodash_1 = __webpack_require__(268);
	var index_1 = __webpack_require__(1157);
	var index_2 = __webpack_require__(1332);
	var util_1 = __webpack_require__(743);
	var option_dialog_1 = __webpack_require__(1317);
	var translate_1 = __webpack_require__(302);
	var STATE_ACTIVE_KEY = 'CUSTOMER.DETAILS.TAB.ACCOUNTS.STATE.ACTIVE';
	var STATE_INACTIVE_KEY = 'CUSTOMER.DETAILS.TAB.ACCOUNTS.STATE.INACTIVE';
	var STATE_INACTIVE_ID = 1;
	var STATE_INACTIVE_VALUE = 'INACTIVE';
	var STATE_ACTIVE_ID = 2;
	var STATE_ACTIVE_VALUE = 'ACTIVE';
	var PROFILE_STATE_BLOCKED = 'B';
	var IBANS_SHOW_KEY = 'CUSTOMER_ACCOUNTS.SHOW_IBANS';
	var IBANS_HIDE_KEY = 'CUSTOMER_ACCOUNTS.HIDE_IBANS';
	var STATE_LOG_SHOW_KEY = 'CUSTOMER_ACCOUNTS.SHOW_STATE_LOG';
	var STATE_LOG_HIDE_KEY = 'CUSTOMER_ACCOUNTS.HIDE_STATE_LOG';
	var ProfileAccountsComponent = (function () {
	    function ProfileAccountsComponent(_navigation, _customerAccountsService, _customerProfileService, activatedRoute, router, translateManager) {
	        this._navigation = _navigation;
	        this._customerAccountsService = _customerAccountsService;
	        this._customerProfileService = _customerProfileService;
	        this.activatedRoute = activatedRoute;
	        this.router = router;
	        this.translateManager = translateManager;
	        this.DEFAULT_OPTION = 'undefined';
	        this.isBlocked = false;
	        this.resetFilterModel();
	    }
	    ProfileAccountsComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.activatedRoute.parent.params.subscribe(function (params) {
	            _this._profileId = +params['id'];
	            _this.searchAccounts();
	            _this.checkCustomerProfileState();
	        });
	        this.fetchAccountStates();
	        this.fetchCurrencies();
	    };
	    ProfileAccountsComponent.prototype.onChangeFilter = function (obj) {
	        this.searchAccounts();
	    };
	    ProfileAccountsComponent.prototype.searchAccounts = function () {
	        var _this = this;
	        this.preventOfDefaultSelectTagOptionOrValues();
	        this._customerAccountsService.searchAccounts(this.filterModel, this._profileId)
	            .subscribe(function (response) { return (_this.customerAccounts = response); });
	    };
	    ProfileAccountsComponent.prototype.newAccount = function () {
	        if (this.router.url.indexOf('pending') > -1) {
	            this._navigation.customers.profiles.pending.newAccount(this._profileId);
	        }
	        else {
	            localStorage.setItem('profileId', this._profileId + '');
	            this._navigation.customers.profiles.registered.newAccount(this._profileId);
	        }
	    };
	    ProfileAccountsComponent.prototype.checkCustomerProfileState = function () {
	        var _this = this;
	        this._customerProfileService.getCustomerProfile(this._profileId)
	            .subscribe(function (customerProfile) {
	            _this.isBlocked = util_1.isNullOrUndefined(customerProfile) ? false : customerProfile.state === PROFILE_STATE_BLOCKED;
	        });
	    };
	    ProfileAccountsComponent.prototype.getAccountStateText = function (state) {
	        if (state === STATE_ACTIVE_VALUE) {
	            return STATE_ACTIVE_KEY;
	        }
	        else {
	            return STATE_INACTIVE_KEY;
	        }
	    };
	    ProfileAccountsComponent.prototype.getNextAccountStateText = function (state) {
	        if (state === STATE_ACTIVE_VALUE) {
	            return STATE_INACTIVE_KEY;
	        }
	        else {
	            return STATE_ACTIVE_KEY;
	        }
	    };
	    ProfileAccountsComponent.prototype.changeState = function (account) {
	        var _this = this;
	        var targetAccountState = this.getStateIdFromName(account.state) === STATE_INACTIVE_ID ? STATE_ACTIVE_ID : STATE_INACTIVE_ID;
	        var changeStateAction = function (reason) {
	            return _this._customerAccountsService.changeAccountState(account.id, targetAccountState, reason)
	                .subscribe(function () { return _this.searchAccounts(); });
	        };
	        if (targetAccountState === STATE_INACTIVE_ID) {
	            var options = {
	                title: 'CUSTOMER_ACCOUNTS.DEACTIVATE.DIALOG.TITLE',
	                confirmButtonText: 'CUSTOMER_ACCOUNTS.DEACTIVATE.DIALOG.BUTTONS.CONFIRM',
	                cancelButtonText: 'CUSTOMER_ACCOUNTS.DEACTIVATE.DIALOG.BUTTONS.CANCEL',
	                confirmButtonClass: 'btn-danger'
	            };
	            this.dialog
	                .showInputDialog(options, { minlength: 1, maxlength: 150 })
	                .onConfirmAction(function (reason) { return changeStateAction(reason); });
	        }
	        else {
	            changeStateAction();
	        }
	    };
	    ProfileAccountsComponent.prototype.getStateIdFromName = function (state) {
	        if (state === STATE_ACTIVE_VALUE) {
	            return STATE_ACTIVE_ID;
	        }
	        else {
	            return STATE_INACTIVE_ID;
	        }
	    };
	    ProfileAccountsComponent.prototype.fetchAccountStates = function () {
	        var _this = this;
	        this._customerAccountsService.getProfileStatesForRegisteredClients()
	            .subscribe(function (states) { return (_this.accountStates = states); });
	    };
	    ProfileAccountsComponent.prototype.fetchCurrencies = function () {
	        var _this = this;
	        this._customerAccountsService.getCurrencies()
	            .subscribe(function (currencies) { return (_this.currencies = currencies); });
	    };
	    ProfileAccountsComponent.prototype.preventOfDefaultSelectTagOptionOrValues = function () {
	        var _this = this;
	        this.filterModel = Object.assign(this.filterModel, lodash_1.mapValues(this.filterModel, function (v) { return (String(v) == _this.DEFAULT_OPTION || String(v) == '') ? undefined : v; }));
	    };
	    ProfileAccountsComponent.prototype.resetFilterModel = function () {
	        this.filterModel = Object.assign(this.filterModel || {}, {
	            accountName: undefined,
	            accountNumber: undefined,
	            accountCurrencyId: undefined,
	            accountStateId: undefined
	        });
	    };
	    ProfileAccountsComponent.prototype.getActionIbansText = function (showLinks) {
	        if (showLinks) {
	            return IBANS_HIDE_KEY;
	        }
	        else {
	            return IBANS_SHOW_KEY;
	        }
	    };
	    ProfileAccountsComponent.prototype.getActionStateLogText = function (showStateLog) {
	        if (showStateLog) {
	            return STATE_LOG_HIDE_KEY;
	        }
	        else {
	            return STATE_LOG_SHOW_KEY;
	        }
	    };
	    ProfileAccountsComponent.prototype.currentAccountStateClass = function (accountState) {
	        return accountState === STATE_INACTIVE_VALUE ? 'customer-inactive' : 'customer-active';
	    };
	    ProfileAccountsComponent.prototype.nextAccountStateClass = function (accountState) {
	        return accountState === STATE_INACTIVE_VALUE ? 'customer-active' : 'customer-inactive';
	    };
	    __decorate([
	        option_dialog_1.InjectOptionDialog('deactivate-reason-dialog'),
	        __metadata("design:type", Object)
	    ], ProfileAccountsComponent.prototype, "dialog", void 0);
	    ProfileAccountsComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-profile-detail-accounts',
	            template: __webpack_require__(1496),
	            providers: [index_2.CustomerAccountsService]
	        }),
	        __metadata("design:paramtypes", [index_1.NavigationService,
	            index_2.CustomerAccountsService,
	            index_2.CustomerProfileService,
	            router_1.ActivatedRoute,
	            router_1.Router,
	            translate_1.TranslateManager])
	    ], ProfileAccountsComponent);
	    return ProfileAccountsComponent;
	}());
	exports.ProfileAccountsComponent = ProfileAccountsComponent;


/***/ }),
/* 1496 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"setting-tab-content\">\n    <div class=\"container-fluid\" style=\"margin-top:20px;\">\n        <div class=\"row\">\n            <div class=\"control-group\">\n                <div class=\"controls form-inline\">\n                    <input id=\"account_number\" type=\"text\" class=\"form-control col-xs-2\"\n                           [(ngModel)]=\"filterModel.accountNumber\"\n                        (change)=\"onChangeFilter($event.target.value)\"\n                        placeholder=\"{{'CUSTOMER.DETAILS.TAB.ACCOUNTS.FILTER.PLACEHOLDER.ACCOUNT_NUMBER' | translate }}\">\n                    <input id=\"account_name\" type=\"text\" class=\"form-control col-xs-2 col-xs-offset-1\" [(ngModel)]=\"filterModel.accountName\"\n                       (change)=\"onChangeFilter($event.target.value)\"\n                       placeholder=\"{{'CUSTOMER.DETAILS.TAB.ACCOUNTS.FILTER.PLACEHOLDER.ACCOUNT_NAME' | translate}}\">\n                </div>\n            </div>\n            <select\n                id=\"filter-account-state\"\n                class=\"btn btn-default dropdown-toggle col-xs-1 col-xs-offset-2\"\n                name=\"filterAccountState\"\n                (change)=\"onChangeFilter($event.target.value)\"\n                [(ngModel)]=\"filterModel.accountStateId\">\n                <option [value]=\"DEFAULT_OPTION\" selected>\n                    {{ 'CUSTOMER.DETAILS.TAB.ACCOUNTS.FILTER.PLACEHOLDER.ACCOUNT_STATE' | translate }}</option>\n                <option *ngFor='let accState of accountStates' [value]=\"accState.id\">\n                    {{accState.name | uppercase }}\n                </option>\n            </select>\n\n            <select\n                id=\"filter-account-currency\"\n                class=\"btn btn-default dropdown-toggle col-xs-1 col-xs-offset-1\"\n                name=\"filterAccountState\"\n                (change)=\"onChangeFilter($event.target.value)\"\n                [(ngModel)]=\"filterModel.accountCurrencyId\">\n                <option [value]=\"DEFAULT_OPTION\" selected>\n                    {{ 'CUSTOMER.DETAILS.TAB.ACCOUNTS.FILTER.PLACEHOLDER.ACCOUNT_CURRENCY' | translate }}</option>\n                <option *ngFor='let currency of currencies' [value]=\"currency.id\">\n                    {{currency.name | uppercase }}\n                </option>\n            </select>\n            <button (click)=\"newAccount()\" class=\"btn btn-success col-xs-1  pull-right\" *ifHasRoles=\"'EDIT';hide:true\">\n                {{'CUSTOMER.DETAILS.TAB.ACCOUNTS.BUTTON.NEW_ACCOUNT' | translate}}\n            </button>\n        </div>\n    </div>\n\n    <div *ngIf=\"customerAccounts?.length==0\">\n        <div class=\"panel-body\">\n            <div class=\"container-fluid\">\n                <h3 class=\"text-center\">{{ 'CUSTOMER.DETAILS.TAB.ACCOUNTS.NO_ACCOUNTS' | translate}}</h3>\n            </div>\n        </div>\n    </div>\n\n    <div *ngIf=\"customerAccounts?.length!=0\" style=\"margin-top:20px;\" id=\"customerAccountsList\">\n        <ng-container *ngFor=\"let account of customerAccounts\">\n            <div class=\"panel panel-default top-buffer\" style=\"margin-top:20px;\">\n                <div class=\"panel-body\">\n                    <div class=\"container-fluid\">\n                        <div class=\"row account-detail-info\">\n                            <div class=\"col-xs-1\">\n                                <span [ngClass]=\"{'glyphicon glyphicon-star fa-lg': account.master}\"></span>\n                                <img class=\"wallet\" *ngIf=\"!account.master\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhE\n                                UgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQA\n                                AAFZSURBVEhLYyAH1NfP5CrsmG1W0jontah99tTitjlHi9rmfChum32hpGWWAVQZcaCka75EYdtsj6KO2RVFbbOXAw27\n                                BjToT3H7nP9Ycdvsc1CtqKC+vp6loGOWdlHbrEigwk6gQbuArnqJYQABXNQ+5y/USAgoaJ+rVNw+ez3Q5m/YNKBgoMuB\n                                vngKtPwk0PINQMMmA8UqC9vnxhW1znHO75itWdo5hxdqNAQAFZ2CGvAZ5H2gxr1ATQuB4m1AnFvSPsu/uG2ueWHLAunQ\n                                VauYodqIByAvQSyYvaS8Y6YcVJh6AO59KmKwo2EpCpsCqmFQisIqQSUM8gltfQDEoxYQxFSzAJjDt4AyIwgD+Vth4lSz\n                                oKxjlgw0azEUNc+ThYkPHQuAeCvIErDhbXN2wMSHTiTjwsPAAkR9QH0MKeyA5TY2SapgUHENqhSANp2npk/AZgENL2mZ\n                                ZQAA2q31Jfu9TLwAAAAASUVORK5CYII=\">\n                            </div>\n                            <div class=\"col-xs-1\"><b class=\"text fa-md\">{{account.number}}</b></div>\n                            <div class=\"col-xs-3 col-xs-offset-1\"><b class=\"text fa-md\">{{account.name}}</b></div>\n                            <div class=\"col-xs-1 col-xs-offset-1\"><b class=\"text fa-md\">{{account.currency}}</b></div>\n                            <div class=\"col-xs-1\"><b class=\"text fa-md\">{{account.available_balance.amount}}</b></div>\n                            <div class=\"col-xs-1\"><b class=\"text fa-md\">{{account.tariff.id}} | {{account.tariff.name}}</b></div>\n                            <div class=\"col-xs-1 text-nowrap\">\n                                <i class=\"fa fa-circle\" [ngClass]=\"currentAccountStateClass(account.state)\"\n                                   aria-hidden=\"true\" ></i>\n                                <b class=\"text fa-md\">{{getAccountStateText(account.state) | translate}}</b>\n                            </div>\n                            <div class=\"col-xs-1\">\n                                <i [id]=\"'transfers-history-menu'\"\n                                    class=\"btn-link menu-button glyphicon glyphicon-option-vertical\"\n                                   [ngClass]=\"['action-account-profile-menu',\n                                                ((account.state === 'ACTIVE') ? 'active' : 'inactive') + '-account-profile-menu']\"\n                                    [matMenuTriggerFor]=\"menu\">\n                                </i>\n                                <mat-menu x-position=\"before\" #menu=\"matMenu\" [id]=\"'mat-account-menu' + account.id\">\n                                    <button mat-menu-item id=\"view-links-button\" data-toggle=\"collapse\"\n                                            class=\"account-action-menu-item\"\n                                            [attr.data-target]=\"'#linksDetail' + account.id\" (click)=\"account.showLinks = !account.showLinks\">\n                                        {{ getActionIbansText(account.showLinks) | translate }}\n                                    </button>\n                                    <button [id] = \"'state-log-menu-item' + account.id\"\n                                            mat-menu-item\n                                            class=\"account-action-menu-item\"\n                                            data-toggle=\"collapse\"\n                                            [disabled]=\"isBlocked\"\n                                            [attr.data-target]=\"'#stateLog' + account.id\"\n                                            (click)=\"account.showStateLog = !account.showStateLog;\">\n                                        {{ getActionStateLogText(account.showStateLog) | translate }}\n                                    </button>\n                                    <button mat-menu-item *ifHasRoles=\"'EDIT';hide:true\"\n                                            [id]=\"'action-activate-' + account.id\"\n                                            [ngClass]=\"[nextAccountStateClass(account.state), 'account-action-menu-item']\"\n                                            [disabled]=\"isBlocked\"\n                                            (click)=\"changeState(account)\">\n                                        {{ getNextAccountStateText(account.state) | translate }}\n                                    </button>\n                                </mat-menu>\n                            </div>\n                        </div>\n                        <div class=\"row\" >\n                            <div class=\"col-xs-12 collapse account-iban-info-detail\" [attr.id]=\"'linksDetail' + account.id\" [attr.aria-expanded]=\"account.showLinks\">\n                                <tfl-customer-account-links *ngIf=\"account.showLinks\" [customer-account-id]=\"account.id\"></tfl-customer-account-links>\n                            </div>\n                        </div>\n                        <div class=\"row\" >\n                            <div class=\"col-xs-12 collapse account-state-log-detail\" [attr.id]=\"'stateLog' + account.id\" [attr.aria-expanded]=\"account.showStateLog\">\n                                <tfl-account-state-log *ngIf=\"account.showStateLog\" [account-id]=\"account.id\"></tfl-account-state-log>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </ng-container>\n    </div>\n</div>\n"

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var router_1 = __webpack_require__(270);
	var customer_cards_service_1 = __webpack_require__(1498);
	var dictionaries_1 = __webpack_require__(1103);
	var card_states_service_1 = __webpack_require__(1499);
	var service_1 = __webpack_require__(1090);
	var api_1 = __webpack_require__(1331);
	var util_1 = __webpack_require__(743);
	var lodash_1 = __webpack_require__(268);
	var DEFAULT_OPTION = 'undefined';
	var MIN_SYMBOLS = 3;
	var MAX_SYMBOLS = 50;
	var ProfileCardsComponent = (function () {
	    function ProfileCardsComponent(_customerCardService, activatedRoute, customerService, _currenciesService, _customerProfileService, _cardStatesService) {
	        this._customerCardService = _customerCardService;
	        this.activatedRoute = activatedRoute;
	        this.customerService = customerService;
	        this._currenciesService = _currenciesService;
	        this._customerProfileService = _customerProfileService;
	        this._cardStatesService = _cardStatesService;
	        this.isBlocked = false;
	        this.shouldDisableSearchButton = true;
	        this.resetFilterModel();
	    }
	    ProfileCardsComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.activatedRoute.parent.params.subscribe(function (params) { return _this._profileId = +params['id']; });
	        if (this._profileId) {
	            this.fetchCustomerCards();
	            this.fetchCardStates();
	            this.fetchCurrencies();
	        }
	    };
	    ProfileCardsComponent.prototype.fetchCustomerCards = function () {
	        var _this = this;
	        this._customerCardService.getCustomerCards(this._profileId, this.filterModel)
	            .subscribe(function (response) { return _this.cards = response; });
	    };
	    ProfileCardsComponent.prototype.updateCards = function () {
	        this.fetchCustomerCards();
	    };
	    ProfileCardsComponent.prototype.isFilterModelNotViableForSearch = function () {
	        this.preventOfDefaultSelectTagOptionOrValues();
	        var valid = true;
	        var compose_checker = true;
	        var isCardholderValid = false;
	        var isCardNumberValid = false;
	        if (!util_1.isNullOrUndefined(this.filterModel.cardHolderName)) {
	            var cardHolderNameSize = this.filterModel.cardHolderName.length;
	            isCardholderValid = (cardHolderNameSize <= MAX_SYMBOLS && cardHolderNameSize >= MIN_SYMBOLS);
	        }
	        if (!util_1.isNullOrUndefined(this.filterModel.cardNumber)) {
	            var cardNumberNameSize = this.filterModel.cardNumber.length;
	            isCardNumberValid = (cardNumberNameSize <= MAX_SYMBOLS && cardNumberNameSize >= MIN_SYMBOLS);
	        }
	        if (!util_1.isNullOrUndefined(this.filterModel.cardHolderName)
	            && !util_1.isNullOrUndefined(this.filterModel.cardNumber)) {
	            valid = isCardholderValid && isCardNumberValid;
	        }
	        valid = valid && (isCardholderValid || isCardNumberValid);
	        if ((!util_1.isNullOrUndefined(this.filterModel.cardHolderName)
	            || !util_1.isNullOrUndefined(this.filterModel.cardNumber))
	            && !this.shouldDisableSearchButton) {
	            compose_checker = valid;
	        }
	        return !((!this.shouldDisableSearchButton || valid) && compose_checker);
	    };
	    Object.defineProperty(ProfileCardsComponent.prototype, "filtersCallUrl", {
	        get: function () {
	            return "/api/backoffice/cards/all-for-profile/" + this._profileId + "/";
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ProfileCardsComponent.prototype.onResetHandler = function () {
	        this.resetFilterModel();
	        this.fetchCustomerCards();
	    };
	    ProfileCardsComponent.prototype.handleSearchResponse = function (response) {
	        this.shouldDisableSearchButton = false;
	        this.cards = response.cards;
	    };
	    ProfileCardsComponent.prototype.onChangeSelect = function (value) {
	        if (value === DEFAULT_OPTION) {
	            this.shouldDisableSearchButton = true;
	        }
	        else {
	            this.shouldDisableSearchButton = false;
	        }
	    };
	    ProfileCardsComponent.prototype.fetchCardStates = function () {
	        var _this = this;
	        this._cardStatesService.getRegisteredClientCardStates()
	            .subscribe(function (states) { return _this.states = states; });
	    };
	    ProfileCardsComponent.prototype.fetchCurrencies = function () {
	        var _this = this;
	        this._currenciesService.getCurrencies()
	            .subscribe(function (currencies) { return (_this.currencies = currencies); });
	    };
	    ProfileCardsComponent.prototype.resetFilterModel = function () {
	        this.filterModel = Object.assign(this.filterModel || {}, {
	            cardHolderName: undefined,
	            cardNumber: undefined,
	            cardState: undefined,
	            cardCurrency: undefined,
	        });
	    };
	    ProfileCardsComponent.prototype.preventOfDefaultSelectTagOptionOrValues = function () {
	        this.filterModel = Object.assign(this.filterModel, lodash_1.mapValues(this.filterModel, function (v) { return (String(v) === DEFAULT_OPTION || String(v) === '') ? undefined : v; }));
	    };
	    ProfileCardsComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-profile-detail-cards',
	            template: __webpack_require__(1500),
	            providers: [customer_cards_service_1.CustomerCardsService, dictionaries_1.CurrenciesService, card_states_service_1.CardStatesService]
	        }),
	        __metadata("design:paramtypes", [customer_cards_service_1.CustomerCardsService,
	            router_1.ActivatedRoute,
	            service_1.CustomerService,
	            dictionaries_1.CurrenciesService,
	            api_1.CustomerProfileService,
	            card_states_service_1.CardStatesService])
	    ], ProfileCardsComponent);
	    return ProfileCardsComponent;
	}());
	exports.ProfileCardsComponent = ProfileCardsComponent;


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var http_1 = __webpack_require__(836);
	var core_1 = __webpack_require__(205);
	var search_api_observable_service_1 = __webpack_require__(1176);
	var lodash_1 = __webpack_require__(268);
	var CustomerCardsService = (function () {
	    function CustomerCardsService(_http, _searchApiObservableService) {
	        this._http = _http;
	        this._searchApiObservableService = _searchApiObservableService;
	    }
	    CustomerCardsService.prototype.getCustomerCards = function (id, filterModel) {
	        return this._searchApiObservableService
	            .searchRequestForUrl("/api/backoffice/cards/all-for-profile/" + id, filterModel)
	            .map(function (response) { return lodash_1.get(response, 'cards', []); });
	    };
	    CustomerCardsService.prototype.changeCardState = function (cardId, statusId) {
	        return this._http
	            .patch("/api/backoffice/cards/" + cardId + "/state?state=" + statusId, {})
	            .map(function (response) { return response.json(); });
	    };
	    CustomerCardsService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http,
	            search_api_observable_service_1.SearchApiObservableService])
	    ], CustomerCardsService);
	    return CustomerCardsService;
	}());
	exports.CustomerCardsService = CustomerCardsService;


/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(836);
	var CardStatesService = (function () {
	    function CardStatesService(http) {
	        this.http = http;
	    }
	    CardStatesService.prototype.getRegisteredClientCardStates = function () {
	        return this.http.get('/api/backoffice/cards/registered-client-card-states')
	            .map(function (responce) { return responce.json(); })
	            .map(function (responce) { return responce.statuses; });
	    };
	    CardStatesService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], CardStatesService);
	    return CardStatesService;
	}());
	exports.CardStatesService = CardStatesService;


/***/ }),
/* 1500 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"setting-tab-content\">\n    <div class=\"container-fluid\" style=\"margin-top:20px;\">\n        <div class=\"row\">\n            <tfl-filter-container\n                    [callUrl]=\"filtersCallUrl\"\n                    [filterModel]=\"filterModel\"\n                    [shouldDisableSearchButton]=\"isFilterModelNotViableForSearch()\"\n                    (onSearch)=\"handleSearchResponse($event)\"\n                    (onReset)=\"onResetHandler()\">\n                <tfl-filter-input [filterDivClass]=\"'col-sm-3 col-xs-6'\">\n                    <div class=\"col-xs-8\">\n                        <input id=\"account_number\" type=\"text\" class=\"form-control col-xs-2\"\n                               [(ngModel)]=\"filterModel.cardNumber\"\n                               placeholder=\"{{'CUSTOMER.DETAILS.TAB.ACCOUNTS.FILTER.PLACEHOLDER.CARD_NUMBER' | translate }}\">\n                    </div>\n                </tfl-filter-input>\n\n                <tfl-filter-input [filterDivClass]=\"'col-sm-3 col-xs-6'\">\n                    <div class=\"col-xs-8\">\n                        <input id=\"account_name\" type=\"text\" class=\"form-control col-xs-2 col-xs-offset-1\"\n                               [(ngModel)]=\"filterModel.cardHolderName\"\n                               placeholder=\"{{'CUSTOMER.DETAILS.TAB.ACCOUNTS.FILTER.PLACEHOLDER.CARD_HOLDER' | translate}}\">\n                    </div>\n                </tfl-filter-input>\n\n                <tfl-filter-input [filterDivClass]=\"'col-sm-3 col-xs-6'\">\n                    <div class=\"col-xs-8\">\n                        <select\n                                id=\"filter-account-state\"\n                                class=\"btn btn-default dropdown-toggle form-control col-xs-1 col-xs-offset-2\"\n                                name=\"filterCardState\"\n                                (change)=\"onChangeSelect($event.target.value)\"\n                                [(ngModel)]=\"filterModel.cardState\">\n                            <option [value]=\"DEFAULT_OPTION\" selected>\n                                {{ 'CUSTOMER.DETAILS.TAB.ACCOUNTS.FILTER.PLACEHOLDER.CARD_STATE' | translate }}\n                            </option>\n                            <option *ngFor='let state of states' [value]=\"state.id\">\n                                {{state.name | uppercase }}\n                            </option>\n                        </select>\n                    </div>\n                </tfl-filter-input>\n                <tfl-filter-input [filterDivClass]=\"'col-sm-3 col-xs-6'\">\n                    <div class=\"col-xs-8\">\n                        <select\n                                id=\"filter-account-currency\"\n                                class=\"btn btn-default dropdown-toggle form-control col-xs-1 col-xs-offset-2\"\n                                name=\"filterCardState\"\n                                (change)=\"onChangeSelect($event.target.value)\"\n                                [(ngModel)]=\"filterModel.cardCurrency\">\n                            <option [value]=\"DEFAULT_OPTION\" selected>\n                                {{ 'CUSTOMER.DETAILS.TAB.ACCOUNTS.FILTER.PLACEHOLDER.CARD_CURRENCY' | translate }}\n                            </option>\n                            <option *ngFor='let currency of currencies' [value]=\"currency.id\">\n                                {{currency.name | uppercase }}\n                            </option>\n                        </select>\n                    </div>\n                </tfl-filter-input>\n            </tfl-filter-container>\n        </div>\n    </div>\n    <div *ngIf=\"cards?.length!=0\" style=\"margin-top:20px;\">\n        <ng-container *ngFor=\"let card of cards\">\n            <tfl-profile-detail-card (statusChange)=\"updateCards()\"\n                                    [card]=\"card\"\n                                    [isBlocked]=\"isBlocked\">\n            </tfl-profile-detail-card>\n        </ng-container>\n    </div>\n    <div *ngIf=\"cards?.length==0\">\n        <h3 class=\"text-center\">{{'CUSTOMER.DETAILS.TAB.CARDS.NO_CARDS' | translate}}</h3>\n    </div>\n</div>"

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var customer_profile_cards_1 = __webpack_require__(1502);
	var core_1 = __webpack_require__(205);
	var customer_cards_service_1 = __webpack_require__(1498);
	var STATUS_ACTIVE = 'CUSTOMER.DETAILS.TAB.CARDS.STATUS.ACTIVE';
	var STATUS_INACTIVE = 'CUSTOMER.DETAILS.TAB.CARDS.STATUS.INACTIVE';
	var STATUS_SET = 'CUSTOMER.DETAILS.TAB.CARDS.STATUS.SET';
	var STATUS_ACTIVE_CLASS = 'card-active';
	var STATUS_INACTIVE_CLASS = 'card-inactive';
	var STATUS_SET_CLASS = 'card-set';
	var CARD_STATUS_ACTIVE_ID = 3;
	var CARD_STATUS_INACTIVE_ID = 4;
	var ProfileCardComponent = (function () {
	    function ProfileCardComponent(_customerCardService) {
	        this._customerCardService = _customerCardService;
	        this.isBlocked = false;
	        this.statusChange = new core_1.EventEmitter();
	        this.isSet = false;
	    }
	    ProfileCardComponent.prototype.ngOnInit = function () {
	        switch (this.card.status.name) {
	            case 'active':
	                this.statusText = STATUS_ACTIVE;
	                this.statusClass = STATUS_ACTIVE_CLASS;
	                this.oppositeStatusText = STATUS_INACTIVE;
	                this.oppositeStatusClass = STATUS_INACTIVE_CLASS;
	                this.isActive = true;
	                break;
	            case 'inactive':
	                this.statusText = STATUS_INACTIVE;
	                this.statusClass = STATUS_INACTIVE_CLASS;
	                this.oppositeStatusText = STATUS_ACTIVE;
	                this.oppositeStatusClass = STATUS_ACTIVE_CLASS;
	                this.isActive = false;
	                break;
	            case 'set':
	                this.statusText = STATUS_SET;
	                this.statusClass = STATUS_SET_CLASS;
	                this.isActive = false;
	                this.isSet = true;
	                break;
	            default:
	                this.statusText = undefined;
	                this.statusClass = undefined;
	                this.isActive = undefined;
	        }
	    };
	    ProfileCardComponent.prototype.getStatusText = function () {
	        return this.statusText;
	    };
	    ProfileCardComponent.prototype.getStatusClass = function () {
	        return this.statusClass;
	    };
	    ProfileCardComponent.prototype.active = function () {
	        return this.isActive;
	    };
	    ProfileCardComponent.prototype.changeStatus = function () {
	        var _this = this;
	        if (this.statusText === 'CUSTOMER.DETAILS.TAB.CARDS.STATUS.SET') {
	            return;
	        }
	        switch (this.card.status.id) {
	            case CARD_STATUS_ACTIVE_ID:
	                this.card.status.id = CARD_STATUS_INACTIVE_ID;
	                break;
	            case CARD_STATUS_INACTIVE_ID:
	                this.card.status.id = CARD_STATUS_ACTIVE_ID;
	                break;
	        }
	        this._customerCardService.changeCardState(this.card.id, this.card.status.id)
	            .subscribe(function (data) {
	            _this.statusChange.emit();
	        });
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", customer_profile_cards_1.CustomerProfileCard)
	    ], ProfileCardComponent.prototype, "card", void 0);
	    __decorate([
	        core_1.Input('isBlocked'),
	        __metadata("design:type", Boolean)
	    ], ProfileCardComponent.prototype, "isBlocked", void 0);
	    __decorate([
	        core_1.Output('statusChange'),
	        __metadata("design:type", core_1.EventEmitter)
	    ], ProfileCardComponent.prototype, "statusChange", void 0);
	    ProfileCardComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-profile-detail-card',
	            template: __webpack_require__(1503)
	        }),
	        __metadata("design:paramtypes", [customer_cards_service_1.CustomerCardsService])
	    ], ProfileCardComponent);
	    return ProfileCardComponent;
	}());
	exports.ProfileCardComponent = ProfileCardComponent;


/***/ }),
/* 1502 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CardStatus = (function () {
	    function CardStatus() {
	    }
	    return CardStatus;
	}());
	exports.CardStatus = CardStatus;
	var CustomerProfileCard = (function () {
	    function CustomerProfileCard() {
	    }
	    return CustomerProfileCard;
	}());
	exports.CustomerProfileCard = CustomerProfileCard;


/***/ }),
/* 1503 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"panel panel-default top-pad\">\n    <div class=\"panel-body\" [ngClass]=\"{'disabled-card-panel': !active() }\">\n        <div class=\"container-fluid\">\n            <div class=\"row\">\n                <div class=\"col-xs-1\"><span class=\"glyphicon glyphicon-credit-card fa-lg\"></span></div>\n                <div class=\"col-xs-1\"><b class=\"text fa-md\">{{card.number}}</b></div>\n                <div class=\"col-xs-2 col-xs-offset-1\"><b class=\"text fa-md\">{{card.holderName}}</b></div>\n                <div class=\"col-xs-2 col-xs-offset-1\"><b class=\"text fa-md\">{{card.validity}}</b></div>\n                <div class=\"col-xs-1\"><b class=\"text fa-md\">{{card.currency}}</b></div>\n                <div class=\"col-xs-1 text-nowrap\">\n                    <i class=\"fa fa-circle fa-lg\" [ngClass]=\"getStatusClass()\" aria-hidden=\"true\"></i>\n                    <b class=\"text fa-md\">{{getStatusText() | translate }}</b>\n                </div>\n                <div class=\"col-xs-1 col-xs-offset-1\" *ngIf=\"!isSet\">\n                    <div *ifHasRoles=\"'EDIT';hide:true\">\n                        <i [id]=\"'cards-menu'\"\n                           class=\"btn-link menu-button glyphicon glyphicon-option-horizontal\"\n                           [matMenuTriggerFor]=\"menu\">\n                        </i>\n                        <mat-menu x-position=\"before\" #menu=\"matMenu\">\n                            <button mat-menu-item\n                                    [disabled]=\"isBlocked\"\n                                    [ngClass]=\"oppositeStatusClass\"\n                                    (click)=\"changeStatus()\">\n                                {{ oppositeStatusText | translate}}\n                            </button>\n                        </mat-menu>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var core_2 = __webpack_require__(252);
	var util_1 = __webpack_require__(743);
	var Subscriber_1 = __webpack_require__(209);
	var lodash_1 = __webpack_require__(268);
	var index_1 = __webpack_require__(1406);
	var modal_service_1 = __webpack_require__(1242);
	var index_2 = __webpack_require__(264);
	var constants_1 = __webpack_require__(861);
	var FileUploadModalComponent = (function () {
	    function FileUploadModalComponent(_modalService, _notificationManager, _translateService, _attachmentService) {
	        this._modalService = _modalService;
	        this._notificationManager = _notificationManager;
	        this._translateService = _translateService;
	        this._attachmentService = _attachmentService;
	        this.saveButtonAction = new core_1.EventEmitter();
	        this.settings = {
	            allowedMaxFileSize: constants_1.MAX_UPLOAD_FILE_SIZE,
	            allowedMimeTypes: {
	                'application/pdf': '.pdf',
	                'image/png': '.png',
	                'image/jpeg': '.jpeg',
	                'application/msword': '.doc',
	                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
	            },
	            allowedMaxCountAttachments: 0,
	        };
	        this.files = [];
	        this.attachmentTypes = [];
	        this.loadingState = false;
	    }
	    FileUploadModalComponent.prototype.ngOnInit = function () {
	        this.loadAttachmentTypes();
	    };
	    FileUploadModalComponent.prototype.loadAttachmentTypes = function () {
	        var _this = this;
	        this.loadingState = true;
	        this._attachmentService.getAttachmentTypes(this.attachmentType)
	            .subscribe(function (attachmentTypes) {
	            _this.attachmentTypes = lodash_1.cloneDeep(attachmentTypes);
	            _this.loadingState = false;
	        });
	    };
	    FileUploadModalComponent.prototype.removeFile = function (id) {
	        this.files =
	            this.files.filter(function (file) { return id !== file.id; });
	    };
	    FileUploadModalComponent.prototype.show = function () {
	        this.reset();
	        this._modalService.open(this.fileUploadModalId);
	    };
	    FileUploadModalComponent.prototype.dismiss = function () {
	        this.reset();
	        this.closeModal();
	    };
	    FileUploadModalComponent.prototype.uploadFile = function (event) {
	        var _this = this;
	        var file = event.target.files[0];
	        event.target.value = '';
	        if (util_1.isNullOrUndefined(file) || this.files.findIndex(function (f) { return f.name == file.name; }) != -1) {
	            event.target.value = null;
	            return;
	        }
	        if (file.size > this.settings.allowedMaxFileSize) {
	            this._notificationManager.error(this._translateService.instant('APPLICATIONS.NEW.DETAIL.TAB.DETAILS.PRIVATE.APPLICANT_INFORMATION.UPLOAD.ERROR.MAX_SIZE'));
	            event.target.value = null;
	            return;
	        }
	        if (!this.isMimeTypeAllowed(file.type)) {
	            this._notificationManager.error(this._translateService.instant('APPLICATIONS.NEW.DETAIL.TAB.DETAILS.PRIVATE.APPLICANT_INFORMATION.UPLOAD.ERROR.UNSUPPORTED_FORMAT'));
	            event.target.value = null;
	            return;
	        }
	        this._attachmentService.attach(file, this.attachmentType, Subscriber_1.Subscriber.create(function () {
	        })).subscribe(function (id) {
	            _this.files.push({
	                id: id,
	                name: file.name,
	                attachmentTypeId: _this.attachmentTypes[0].id
	            });
	        });
	    };
	    FileUploadModalComponent.prototype.isMimeTypeAllowed = function (mimeType) {
	        var allowedMimeTypes = this.settings.allowedMimeTypes;
	        var mimeTypes = Object.keys(allowedMimeTypes);
	        return mimeTypes.indexOf(mimeType) > -1;
	    };
	    FileUploadModalComponent.prototype.save = function () {
	        this.saveButtonAction.emit(this.files);
	        this.reset();
	        this.closeModal();
	    };
	    FileUploadModalComponent.prototype.closeModal = function () {
	        this._modalService.close(this.fileUploadModalId);
	    };
	    FileUploadModalComponent.prototype.reset = function () {
	        this.files = [];
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], FileUploadModalComponent.prototype, "fileUploadModalId", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], FileUploadModalComponent.prototype, "attachmentType", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], FileUploadModalComponent.prototype, "saveButtonAction", void 0);
	    __decorate([
	        core_1.Input('settings'),
	        __metadata("design:type", Object)
	    ], FileUploadModalComponent.prototype, "settings", void 0);
	    FileUploadModalComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-file-upload-modal',
	            template: __webpack_require__(1505),
	        }),
	        __metadata("design:paramtypes", [modal_service_1.ModalService,
	            index_2.NotificationManager,
	            core_2.TranslateService,
	            index_1.AttachmentService])
	    ], FileUploadModalComponent);
	    return FileUploadModalComponent;
	}());
	exports.FileUploadModalComponent = FileUploadModalComponent;


/***/ }),
/* 1505 */
/***/ (function(module, exports) {

	module.exports = "<loading-linear [loading]=\"loadingState\"></loading-linear>\n<tfl-gentelella-modal-container [id]=\"fileUploadModalId\"\n                                [isLarge]=\"true\"\n                                class=\"tfl-file-upload-modal\">\n    <tfl-gentelella-modal-header [showDismiss]=\"true\" (dismissHandler)=\"closeModal()\">\n        <h3>{{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.UPLOAD.DOCUMENT.HEADER' | translate}}</h3>\n    </tfl-gentelella-modal-header>\n    <tfl-gentelella-modal-body>\n        <div class=\"files-container container-fluid\">\n            <div *ngFor=\"let file of files\" class=\"file row\">\n                <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n                    <i class=\"fa fa-file fa-lg\"></i>\n                    <span>{{file.name}}</span>\n                </div>\n                <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n                    <select id=\"attachment-types-select\"\n                            title=\"{{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.ACCOUNT_CURRENCIES.MASTER_ACCOUNT_CURRENCY'|translate}}\"\n                            class=\"form-control\"\n                            name=\"currency\"\n                            [(ngModel)]=\"file.attachmentTypeId\">\n                        <option *ngFor=\"let type of attachmentTypes\"\n                                [value]=\"type.id\">\n                            {{type.name}}\n                        </option>\n                    </select>\n                    <i (click)=\"removeFile(file.id)\" class=\"fa fa-trash fa-lg remove-file-btn\"></i>\n                </div>\n            </div>\n        </div>\n        <input #fileLoader\n               type=\"file\"\n               style=\"display: none\"\n               (change)=\"uploadFile($event)\">\n        <button class=\"btn btn-default upload-files-button\" (click)=\"fileLoader.click()\">\n            {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CHOSE.BUTTON.NAME' | translate}}\n        </button>\n    </tfl-gentelella-modal-body>\n    <tfl-gentelella-modal-footer [showDefaultButtons]=\"false\">\n        <button type=\"button\" class=\"btn btn-default\" (click)=\"dismiss()\">\n            {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CANCEL.BUTTON.NAME' | translate}}\n        </button>\n        <button type=\"button\" class=\"btn btn-primary\" (click)=\"save()\"\n                [disabled]=\"files.length === 0\">\n            {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.UPLOAD.BUTTON.NAME' | translate}}\n        </button>\n    </tfl-gentelella-modal-footer>\n</tfl-gentelella-modal-container>\n"

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var onfido_verification_component_1 = __webpack_require__(1507);
	var onfido_status_badge_component_1 = __webpack_require__(1508);
	var index_1 = __webpack_require__(1509);
	__export(__webpack_require__(1507));
	__export(__webpack_require__(1509));
	exports.ONFIDO_VERIFICATION_COMPONENTS = [
	    onfido_verification_component_1.OnfidoVerificationComponent,
	    onfido_status_badge_component_1.OnfidoStatusBadgeComponent,
	    index_1.ONFIDO_VERIFICATION_RESULTS_COMPONENTS
	];


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var router_1 = __webpack_require__(270);
	var Observable_1 = __webpack_require__(206);
	var Subscription_1 = __webpack_require__(211);
	var util_1 = __webpack_require__(743);
	var service_1 = __webpack_require__(1332);
	var OnfidoVerificationComponent = (function () {
	    function OnfidoVerificationComponent(_onfidoService, _integrationModuleService, _activatedRoute) {
	        this._onfidoService = _onfidoService;
	        this._integrationModuleService = _integrationModuleService;
	        this._activatedRoute = _activatedRoute;
	        this.loading = false;
	        this.isSupported = true;
	        this.httpDetailsSubscription = new Subscription_1.Subscription();
	    }
	    OnfidoVerificationComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._activatedRoute.parent.parent.params.subscribe(function (params) {
	            _this.loading = true;
	            _this.profileId = +params['id'];
	            _this._integrationModuleService.getAvailabilityForClientProfile(_this.profileId).subscribe(function (modules) {
	                var foundModule = modules.find(function (m) { return m.name === 'ONFIDO'; });
	                _this.isSupported = foundModule.available;
	            });
	            _this.fetchVerificationResults();
	        });
	    };
	    OnfidoVerificationComponent.prototype.ngOnDestroy = function () {
	        this.httpDetailsSubscription.unsubscribe();
	    };
	    OnfidoVerificationComponent.prototype.hasNotContactedWithOnfido = function () {
	        return util_1.isNullOrUndefined(this.onfidoProfile) || this.onfidoProfile.attachedUsers.length === 0;
	    };
	    OnfidoVerificationComponent.prototype.createApplicant = function () {
	        var _this = this;
	        this.loading = true;
	        this._onfidoService
	            .createApplicant(this.profileId)
	            .subscribe(function (_) {
	            // For each 3 seconds
	            _this.httpDetailsSubscription = Observable_1.Observable
	                .interval(1000 * 3)
	                .takeWhile(function () { return _this.loading; })
	                .subscribe(function (_) {
	                // Fetch profile and check attached users to be at least created in onfido regardless of statuses
	                _this._onfidoService
	                    .getResult(_this.profileId)
	                    .subscribe(function (results) {
	                    _this.onfidoProfile = results;
	                    if (!_this.hasNotContactedWithOnfido()) {
	                        _this.loading = false;
	                    }
	                });
	            });
	        });
	    };
	    OnfidoVerificationComponent.prototype.fetchVerificationResults = function () {
	        var _this = this;
	        if (this.isSupported) {
	            this.loading = true;
	            this._onfidoService
	                .getResult(this.profileId)
	                .subscribe(function (results) {
	                _this.onfidoProfile = results;
	                _this.loading = false;
	            });
	        }
	    };
	    OnfidoVerificationComponent = __decorate([
	        core_1.Component({
	            selector: 'tfo-bo-onfido-verification',
	            host: { 'class': 'verification-results-block' },
	            template: "\n        <loading-linear [loading]=\"loading\"></loading-linear>\n        <h3>\n            <button (click)=\"createApplicant()\"\n                    [disabled]=\"loading\"\n                    *ngIf=\"hasNotContactedWithOnfido() && isSupported\"\n                    class=\"btn btn-primary verify-btn-box pull-right\">\n                {{ 'CUSTOMER.VERIFICATION.ONFIDO.CREATE_APPLICANT' | translate }}\n            </button>\n\n            {{ 'CUSTOMER.VERIFICATION.ONFIDO.TITLE' | translate }}\n        </h3>\n\n        <hr/>\n\n        <ng-container *ngIf=\"!isSupported\">\n            <h3 class=\"text-center\">\n                {{ 'CUSTOMER.VERIFICATION.ONFIDO.NOT_AVAILABLE' | translate }}\n            </h3>\n        </ng-container>\n\n        <ng-container *ngIf=\"isSupported\">\n\n            <ng-container *ngIf=\"!hasNotContactedWithOnfido()\">\n                <tfl-bo-onfido-client-user\n                    *ngFor=\"let user of onfidoProfile.attachedUsers\"\n                    [onfidoUser]=\"user\">\n                </tfl-bo-onfido-client-user>\n            </ng-container>\n\n            <ng-container *ngIf=\"hasNotContactedWithOnfido()\">\n                <h3 class=\"text-center\">\n                    {{ 'CUSTOMER.VERIFICATION.ONFIDO.EMPTY_PROFILE' | translate }}\n                </h3>\n            </ng-container>\n\n        </ng-container>\n    "
	        }),
	        __metadata("design:paramtypes", [service_1.OnfidoService,
	            service_1.IntegrationModuleService,
	            router_1.ActivatedRoute])
	    ], OnfidoVerificationComponent);
	    return OnfidoVerificationComponent;
	}());
	exports.OnfidoVerificationComponent = OnfidoVerificationComponent;


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var identity_verification_1 = __webpack_require__(1154);
	var OnfidoStatusBadgeComponent = (function () {
	    function OnfidoStatusBadgeComponent() {
	        this.explanation = null;
	    }
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], OnfidoStatusBadgeComponent.prototype, "status", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], OnfidoStatusBadgeComponent.prototype, "explanation", void 0);
	    OnfidoStatusBadgeComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-onfido-status-badge',
	            template: "\n        <ng-container [ngSwitch]=\"status\">\n            <span *ngSwitchCase=\"'VERIFIED'\" class=\"label label-success\">\n                <small *ngIf=\"explanation\">{{ explanation }}</small>\n                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.VERIFIED' | translate }}\n            </span>\n            <span *ngSwitchCase=\"'DECLINED'\" class=\"label label-danger\">\n                <small *ngIf=\"explanation\">{{ explanation }}</small>\n                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.DECLINED' | translate }}\n            </span>\n            <span *ngSwitchCase=\"'OPEN_TO_UPLOAD_DATA'\" class=\"label label-default\">\n                <small *ngIf=\"explanation\">{{ explanation }}</small>\n                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.OPEN_TO_UPLOAD_DATA' | translate }}\n            </span>\n            <span *ngSwitchCase=\"'IN_PROGRESS'\" class=\"label label-info\">\n                <small *ngIf=\"explanation\">{{ explanation }}</small>\n                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.IN_PROGRESS' | translate }}\n            </span>\n            <span *ngSwitchCase=\"'INVALID'\" class=\"label label-warning\">\n                <small *ngIf=\"explanation\">{{ explanation }}</small>\n                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.INVALID' | translate }}\n            </span>\n            <span *ngSwitchCase=\"'CONSIDER'\" class=\"label label-warning\">\n                <small *ngIf=\"explanation\">{{ explanation }}</small>\n                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.CONSIDER' | translate }}\n            </span>\n            <span *ngSwitchCase=\"'OUT_OF_VERIFICATION'\" class=\"label label-default\">\n                <small *ngIf=\"explanation\">{{ explanation }}</small>\n                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.OUT_OF_VERIFICATION' | translate }}\n            </span>\n        </ng-container>\n    "
	        })
	    ], OnfidoStatusBadgeComponent);
	    return OnfidoStatusBadgeComponent;
	}());
	exports.OnfidoStatusBadgeComponent = OnfidoStatusBadgeComponent;


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var report_onfido_verification_component_1 = __webpack_require__(1510);
	var client_user_onfido_verification_component_1 = __webpack_require__(1511);
	var check_onfido_verification_component_1 = __webpack_require__(1512);
	var breakdown_report_onfido_verification_component_1 = __webpack_require__(1513);
	exports.ONFIDO_VERIFICATION_RESULTS_COMPONENTS = [
	    client_user_onfido_verification_component_1.ClientUserOnfidoVerificationComponent,
	    report_onfido_verification_component_1.ReportOnfidoVerificationComponent,
	    check_onfido_verification_component_1.CheckOnfidoVerificationComponent,
	    breakdown_report_onfido_verification_component_1.BreakdownReportOnfidoVerificationComponent
	];


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var ReportOnfidoVerificationComponent = (function () {
	    function ReportOnfidoVerificationComponent() {
	    }
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], ReportOnfidoVerificationComponent.prototype, "report", void 0);
	    ReportOnfidoVerificationComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-onfido-verification-report',
	            template: "\n        <div class=\"row\">\n            <div class=\"col-xs-3\">\n                <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.REPORT_ID' | translate }}:</b>\n            </div>\n            <div class=\"col-xs-9\">{{ report.id }}</div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-3\">\n                <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.REPORT_NAME' | translate }}:</b>\n            </div>\n            <div class=\"col-xs-9\">{{ report.name }}</div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-3\">\n                <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.REPORT_CREATED_AT' | translate }}:</b>\n            </div>\n            <div class=\"col-xs-3\">{{ report.createdAt }}</div>\n        </div>\n\n        <h6>{{ 'CUSTOMER.VERIFICATION.BLOCK.TITLE.BREAKDOWN' | translate }}:</h6>\n        \n        <div class=\"row\">\n            <tfl-bo-onfido-verification-report-breakdown [breakdown]=\"report.breakdown\">\n            </tfl-bo-onfido-verification-report-breakdown>\n        </div>\n    "
	        })
	    ], ReportOnfidoVerificationComponent);
	    return ReportOnfidoVerificationComponent;
	}());
	exports.ReportOnfidoVerificationComponent = ReportOnfidoVerificationComponent;


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var lodash_1 = __webpack_require__(268);
	var ClientUserOnfidoVerificationComponent = (function () {
	    function ClientUserOnfidoVerificationComponent() {
	    }
	    ClientUserOnfidoVerificationComponent.prototype.isEmptyCheckList = function () {
	        return lodash_1.isEmpty(this.onfidoUser.checks);
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], ClientUserOnfidoVerificationComponent.prototype, "onfidoUser", void 0);
	    ClientUserOnfidoVerificationComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-onfido-client-user',
	            template: "\n        <div class=\"x_panel\">\n            <div class=\"x_title\">\n                <h4>{{ onfidoUser.userName }}</h4>\n\n                <tfl-bo-onfido-status-badge\n                    [status]=\"onfidoUser.onfidoStatus\"\n                    class=\"pull-right\">\n                </tfl-bo-onfido-status-badge>\n            </div>\n            <div class=\"x_content\">\n                <div>\n                    <div class=\"row\">\n                        <div class=\"col-xs-3\">\n                            <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.CREATE_DATE_TIME' | translate }}:</b>\n                        </div>\n                        <div class=\"col-xs-9\">{{ onfidoUser.createDateTime }}</div>\n                    </div>\n\n                    <div class=\"row\">\n                        <div class=\"col-xs-3\">\n                            <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.APPLICANT_ID' | translate }}:</b>\n                        </div>\n                        <div class=\"col-xs-9\">{{ onfidoUser.applicantId }}</div>\n                    </div>\n\n                    <div class=\"row\">\n                        <div class=\"col-xs-3\">\n                            <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.EMAIL' | translate }}:</b>\n                        </div>\n                        <div class=\"col-xs-9\">{{ onfidoUser.email }}</div>\n                    </div>\n                </div>\n\n                <ng-container *ngIf=\"!isEmptyCheckList()\">\n                    <hr/>\n\n                    <h4>{{ 'CUSTOMER.VERIFICATION.BLOCK.TITLE.CHECKS' | translate }}:</h4>\n\n                    <div class=\"verification-results-block-inner\" *ngFor=\"let check of onfidoUser.checks\">\n                        <tfl-bo-onfido-verification-check [check]=\"check\"></tfl-bo-onfido-verification-check>\n                    </div>\n                </ng-container>\n            </div>\n        </div>\n    "
	        })
	    ], ClientUserOnfidoVerificationComponent);
	    return ClientUserOnfidoVerificationComponent;
	}());
	exports.ClientUserOnfidoVerificationComponent = ClientUserOnfidoVerificationComponent;


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var CheckOnfidoVerificationComponent = (function () {
	    function CheckOnfidoVerificationComponent() {
	    }
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], CheckOnfidoVerificationComponent.prototype, "check", void 0);
	    CheckOnfidoVerificationComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-onfido-verification-check',
	            template: "\n        <accordion>\n            <accordion-group>\n                <accordion-header>\n                    <accordion-toggle\n                        title=\"{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.CHECK_ID' | translate }}: {{ check.checkId }}\">\n                    </accordion-toggle>\n                </accordion-header>\n\n                <accordion-content>\n                    <div class=\"row\">\n                        <div class=\"col-xs-3\">\n                            <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.CREATE_DATE_TIME' | translate }}:</b>\n                        </div>\n                        <div class=\"col-xs-9\">{{ check.createTime }}</div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-xs-3\">\n                            <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.COMPLETE_DATE_TIME' | translate }}:</b>\n                        </div>\n                        <div class=\"col-xs-9\">{{ check.completeTime }}</div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-xs-3\">\n                            <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.HAS_ERRORS' | translate }}:</b>\n                        </div>\n                        <div class=\"col-xs-9\">{{ check.hasErrors }}</div>\n                    </div>\n\n                    <h5>{{ 'CUSTOMER.VERIFICATION.BLOCK.TITLE.REPORTS' | translate }}:</h5>\n\n                    <div class=\"verification-results-block-inner\" *ngFor=\"let report of check.reports\">\n                        <hr>\n                        <tfl-bo-onfido-verification-report\n                            [report]=\"report\"></tfl-bo-onfido-verification-report>\n                    </div>\n                </accordion-content>\n            </accordion-group>\n        </accordion>\n    "
	        })
	    ], CheckOnfidoVerificationComponent);
	    return CheckOnfidoVerificationComponent;
	}());
	exports.CheckOnfidoVerificationComponent = CheckOnfidoVerificationComponent;


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var BreakdownReportOnfidoVerificationComponent = (function () {
	    function BreakdownReportOnfidoVerificationComponent() {
	        this.inner = false;
	    }
	    BreakdownReportOnfidoVerificationComponent.prototype.getTranslateFieldSuffixByBreakdownKey = function (key) {
	        return key.toUpperCase();
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], BreakdownReportOnfidoVerificationComponent.prototype, "breakdown", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], BreakdownReportOnfidoVerificationComponent.prototype, "inner", void 0);
	    BreakdownReportOnfidoVerificationComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-onfido-verification-report-breakdown',
	            template: "\n        <div class=\"col-xs-12\" *ngIf=\"!inner\">\n            <div class=\"row\">\n                <ng-container *ngFor=\"let key of breakdown | keys; index as i\">\n                    <div class=\"col-xs-12 col-sm-6 col-lg-3\">\n                        <i *ngIf=\"breakdown[key].result == 'clear'\"\n                            class=\"fa fa-check-circle fa-lg text-success\"></i>\n                        \n                        <i *ngIf=\"breakdown[key].result != 'clear'\"\n                           class=\"fa fa-minus-circle fa-lg text-warning\"></i>\n                        \n                        <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.' + getTranslateFieldSuffixByBreakdownKey(key) | translate }}</b>\n                        \n                        <ng-container *ngIf=\"breakdown[key].breakdown\">\n                            <tfl-bo-onfido-verification-report-breakdown [breakdown]=\"breakdown[key].breakdown\" [inner]=\"true\">\n                            </tfl-bo-onfido-verification-report-breakdown>\n                        </ng-container>\n                    </div>\n                    <div *ngIf=\"(i + 1) % 4 == 0\" class=\"clearfix visible-lg-block\"></div>\n                </ng-container>\n            </div>\n        </div>\n        <ul *ngIf=\"inner\" class=\"report-breakdown-inner-list\">\n            <li *ngFor=\"let key of breakdown | keys\">\n                <small>\n                    <i *ngIf=\"breakdown[key].result == 'clear'\"\n                       class=\"fa fa-check-circle text-success\"></i>\n                    \n                    <i *ngIf=\"breakdown[key].result != 'clear'\"\n                       class=\"fa fa-minus-circle text-warning\"></i>\n\n                    {{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.' + getTranslateFieldSuffixByBreakdownKey(key) | translate }}\n                </small>\n            </li>\n        </ul>\n    "
	        })
	    ], BreakdownReportOnfidoVerificationComponent);
	    return BreakdownReportOnfidoVerificationComponent;
	}());
	exports.BreakdownReportOnfidoVerificationComponent = BreakdownReportOnfidoVerificationComponent;


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ariad_status_badge_component_1 = __webpack_require__(1515);
	var ariad_verification_component_1 = __webpack_require__(1516);
	var create_applicant_dialog_component_1 = __webpack_require__(1517);
	var client_user_ariadnext_verification_component_1 = __webpack_require__(1518);
	var ariadnext_check_verification_component_1 = __webpack_require__(1520);
	exports.ARIADNEXT_VERIFICATION_COMPONENTS = [
	    ariad_status_badge_component_1.AriadStatusBadgeComponent,
	    ariad_verification_component_1.AriadVerificationComponent,
	    create_applicant_dialog_component_1.CreateApplicantDialogComponent,
	    client_user_ariadnext_verification_component_1.ClientUserAriadnextVerificationComponent,
	    ariadnext_check_verification_component_1.AriadnextCheckVerificationComponent
	];


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var entity_1 = __webpack_require__(1150);
	var AriadStatusBadgeComponent = (function () {
	    function AriadStatusBadgeComponent() {
	        this.explanation = null;
	    }
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], AriadStatusBadgeComponent.prototype, "status", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], AriadStatusBadgeComponent.prototype, "explanation", void 0);
	    AriadStatusBadgeComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-ariadnext-status-badge',
	            template: "\n        <div [ngSwitch]=\"status\" class=\"badge-box\">\n            <span *ngSwitchCase=\"'OK'\" class=\"label label-success\">\n                <small *ngIf=\"explanation\">{{ explanation }}</small>\n                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.OK' | translate }}\n            </span>\n            <span *ngSwitchCase=\"'ERROR'\" class=\"label label-danger\">\n                <small *ngIf=\"explanation\">{{ explanation }}</small>\n                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.ERROR' | translate }}\n            </span>\n            <span *ngSwitchCase=\"'NONE'\" class=\"label label-default\">\n                <small *ngIf=\"explanation\">{{ explanation }}</small>\n                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.NONE' | translate }}\n            </span>\n            <span *ngSwitchCase=\"'WARN'\" class=\"label label-warning\">\n                <small *ngIf=\"explanation\">{{ explanation }}</small>\n                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.WARN' | translate }}\n            </span>\n            <span *ngSwitchCase=\"'OBSOLETE'\" class=\"label label-info\">\n                <small *ngIf=\"explanation\">{{ explanation }}</small>\n                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.OBSOLETE' | translate }}\n            </span>\n            <span *ngSwitchCase=\"'OUT_OF_VERIFICATION'\" class=\"label label-default\">\n                <small *ngIf=\"explanation\">{{ explanation }}</small>\n                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.OUT_OF_VERIFICATION' | translate }}\n            </span>\n        </div>\n    "
	        })
	    ], AriadStatusBadgeComponent);
	    return AriadStatusBadgeComponent;
	}());
	exports.AriadStatusBadgeComponent = AriadStatusBadgeComponent;


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var service_1 = __webpack_require__(1332);
	var router_1 = __webpack_require__(270);
	var ariadnext_service_1 = __webpack_require__(1341);
	var AriadVerificationComponent = (function () {
	    function AriadVerificationComponent(_ariadnextService, _integrationModuleService, _activatedRoute) {
	        this._ariadnextService = _ariadnextService;
	        this._integrationModuleService = _integrationModuleService;
	        this._activatedRoute = _activatedRoute;
	        this.loading = false;
	        this.isSupported = true;
	    }
	    AriadVerificationComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._activatedRoute.parent.parent.params.subscribe(function (params) {
	            _this.loading = true;
	            _this.profileId = +params['id'];
	            _this._integrationModuleService.getAvailabilityForClientProfile(_this.profileId).subscribe(function (modules) {
	                var foundModule = modules.find(function (m) { return m.name === 'ARIADNEXT'; });
	                _this.isSupported = foundModule.available;
	                if (_this.isSupported) {
	                    _this.fetchVerificationResults();
	                }
	                else {
	                    _this.loading = false;
	                }
	            });
	        });
	    };
	    AriadVerificationComponent.prototype.fetchVerificationResults = function () {
	        var _this = this;
	        if (this.isSupported) {
	            this.loading = true;
	            this._ariadnextService
	                .getResultByProfile(this.profileId)
	                .subscribe(function (results) {
	                _this.ariadnextProfile = results;
	                _this.loading = false;
	            });
	        }
	    };
	    AriadVerificationComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-ariad-verification',
	            host: { 'class': 'verification-results-block' },
	            template: "\n        <loading-linear [loading]=\"loading\"></loading-linear>\n        <h3>\n            <!--<button (click)=\"createApplicant()\"-->\n            <!--[disabled]=\"loading\"-->\n            <!--*ngIf=\"hasNotContactedWithAriadnext() && isSupported\"-->\n            <!--class=\"btn btn-primary verify-btn-box pull-right\">-->\n            <!--{{ 'CUSTOMER.VERIFICATION.ARIADNEXT.CREATE_APPLICANT' | translate }}-->\n            <!--</button>-->\n\n            {{ 'CUSTOMER.VERIFICATION.ARIADNEXT.TITLE' | translate }}\n        </h3>\n\n        <hr/>\n\n        <ng-container *ngIf=\"!isSupported\">\n            <h3 class=\"text-center\">\n                {{ 'CUSTOMER.VERIFICATION.ARIADNEXT.NOT_AVAILABLE' | translate }}\n            </h3>\n        </ng-container>\n\n        <ng-container *ngIf=\"isSupported && ariadnextProfile\">\n            <tfl-bo-ariadnext-client-user\n                *ngFor=\"let user of ariadnextProfile.attachedUsers\"\n                [profileId]=\"profileId\"\n                [user]=\"user\"\n                [loading]=\"loading\">\n            </tfl-bo-ariadnext-client-user>\n        </ng-container>\n    "
	        }),
	        __metadata("design:paramtypes", [ariadnext_service_1.AriadnextService,
	            service_1.IntegrationModuleService,
	            router_1.ActivatedRoute])
	    ], AriadVerificationComponent);
	    return AriadVerificationComponent;
	}());
	exports.AriadVerificationComponent = AriadVerificationComponent;


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var modal_service_1 = __webpack_require__(1242);
	var CreateApplicantDialogComponent = (function () {
	    function CreateApplicantDialogComponent(_modalService) {
	        this._modalService = _modalService;
	        this.onStartsHandler = new core_1.EventEmitter();
	        this.byPhoneChosen = false;
	    }
	    CreateApplicantDialogComponent.prototype.chooseEmail = function () {
	        this.byPhoneChosen = false;
	    };
	    CreateApplicantDialogComponent.prototype.choosePhone = function () {
	        this.byPhoneChosen = true;
	    };
	    CreateApplicantDialogComponent.prototype.show = function () {
	        this._modalService.open(this.user.userId.toString());
	    };
	    CreateApplicantDialogComponent.prototype.close = function () {
	        this._modalService.close(this.user.userId.toString());
	    };
	    CreateApplicantDialogComponent.prototype.start = function () {
	        this.close();
	        this.onStartsHandler.emit(this.byPhoneChosen);
	    };
	    __decorate([
	        core_1.Output("onStart"),
	        __metadata("design:type", core_1.EventEmitter)
	    ], CreateApplicantDialogComponent.prototype, "onStartsHandler", void 0);
	    __decorate([
	        core_1.Input("user"),
	        __metadata("design:type", Object)
	    ], CreateApplicantDialogComponent.prototype, "user", void 0);
	    CreateApplicantDialogComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-create-ariad-applicant-dialog',
	            template: "\n        <tfl-gentelella-modal-container [id]=\"user.userId.toString()\" [isLarge]=\"false\">\n            <tfl-gentelella-modal-header [showDismiss]=\"false\" (dismissHandler)=\"close()\">\n                <h5>{{ 'CUSTOMER.VERIFICATION.ARIADNEXT.CREATE_APPLICANT.TITLE' | translate }}</h5>\n            </tfl-gentelella-modal-header>\n\n            <tfl-gentelella-modal-body>\n                <ng-container *ngIf=\"user\">\n                    <div class=\"row\">\n                        <div class=\"col-xs-12\">\n                            <h5 style=\"text-align: justify\">\n                                {{ 'CUSTOMER.VERIFICATION.ARIADNEXT.CREATE_APPLICANT.MODAL_DESCRIPTION' | translate }}\n                            </h5>\n                        </div>\n                    </div>\n                    <form>\n                        <div class=\"switch-field\">\n                            <input type=\"radio\" id=\"radio-one\" name=\"sendlink_approach\" (click)=\"chooseEmail()\" [checked]=\"!byPhoneChosen\"/>\n                            <label for=\"radio-one\">{{ 'CUSTOMER.VERIFICATION.ARIADNEXT.CREATE_APPLICANT.EMAIL' | translate }}</label>\n                            <!-- TODO Remove [disabled] after sms service implementation-->\n                            <input type=\"radio\" id=\"radio-two\" name=\"sendlink_approach\" (click)=\"choosePhone()\" [checked]=\"byPhoneChosen\" [disabled]=\"true\"/>\n                            <label for=\"radio-two\">{{ 'CUSTOMER.VERIFICATION.ARIADNEXT.CREATE_APPLICANT.PHONE' | translate }}</label>\n                        </div>\n                    </form>\n                    <div class=\"row\">\n                        <div class=\"col-xs-12\" style=\"text-align: center\">\n                            <span>{{ 'CUSTOMER.VERIFICATION.ARIADNEXT.CREATE_APPLICANT.SEND_LINK_TO' | translate }}</span>\n                            <span *ngIf=\"byPhoneChosen\">{{ user.phoneNumber }}</span>\n                            <span *ngIf=\"!byPhoneChosen\">{{ user.email }}</span>\n                        </div>\n                    </div>\n                </ng-container>\n            </tfl-gentelella-modal-body>\n\n            <tfl-gentelella-modal-footer [showDefaultButtons]=\"false\">\n                <button class=\"btn btn-sm btn-primary\" (click)=\"start()\">\n                    {{ 'CUSTOMER.VERIFICATION.ARIADNEXT.CREATE_APPLICANT.START_BUTTON' | translate }}\n                </button>\n                <button class=\"btn btn-sm btn-default\" (click)=\"close()\">\n                    {{ 'CUSTOMER.VERIFICATION.ARIADNEXT.CREATE_APPLICANT.CLOSE_BUTTON' | translate }}\n                </button>\n            </tfl-gentelella-modal-footer>\n        </tfl-gentelella-modal-container>\n    "
	        }),
	        __metadata("design:paramtypes", [modal_service_1.ModalService])
	    ], CreateApplicantDialogComponent);
	    return CreateApplicantDialogComponent;
	}());
	exports.CreateApplicantDialogComponent = CreateApplicantDialogComponent;


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var entity_1 = __webpack_require__(1150);
	var service_1 = __webpack_require__(1332);
	var rxjs_1 = __webpack_require__(304);
	var utils_1 = __webpack_require__(740);
	var create_applicant_dialog_component_1 = __webpack_require__(1517);
	var notification_1 = __webpack_require__(264);
	var ClientUserAriadnextVerificationComponent = (function () {
	    function ClientUserAriadnextVerificationComponent(_ariadnextService, _notificationManager) {
	        this._ariadnextService = _ariadnextService;
	        this._notificationManager = _notificationManager;
	        this.httpDetailsSubscription = new rxjs_1.Subscription();
	    }
	    ClientUserAriadnextVerificationComponent.prototype.ngOnDestroy = function () {
	        this.httpDetailsSubscription.unsubscribe();
	    };
	    ClientUserAriadnextVerificationComponent.prototype.openCreationDialog = function () {
	        this.createApplicantDialog.show();
	    };
	    ClientUserAriadnextVerificationComponent.prototype.createApplicant = function (byPhone) {
	        var _this = this;
	        var userId = this.ariadnextUser.userId;
	        this.loading = true;
	        this._ariadnextService
	            .createApplicant(this.profileId, userId, byPhone)
	            .subscribe(function (_) {
	            // For each 3 seconds
	            _this.httpDetailsSubscription = rxjs_1.Observable
	                .interval(1000 * 3)
	                .takeWhile(function () { return _this.loading; })
	                .subscribe(function (_) {
	                // Fetch profile and check attached users to be at least created in ariadnext regardless of statuses
	                _this._ariadnextService
	                    .getResultByUser(_this.profileId, userId)
	                    .subscribe(function (user) {
	                    if (user.lastAriadnextStatus !== entity_1.AriadVerificationStatus.OUT_OF_VERIFICATION) {
	                        _this.ariadnextUser = user;
	                        _this.loading = false;
	                    }
	                });
	            });
	        }, function (error) {
	            _this._notificationManager.error(error.errorMessage);
	            _this._ariadnextService
	                .getResultByUser(_this.profileId, userId)
	                .subscribe(function (user) {
	                _this.ariadnextUser = user;
	                _this.loading = false;
	            });
	        });
	    };
	    ClientUserAriadnextVerificationComponent.prototype.verify = function () {
	        var _this = this;
	        var userId = this.ariadnextUser.userId;
	        this._ariadnextService
	            .verify(this.profileId, userId)
	            .subscribe(function (_) {
	            _this._ariadnextService
	                .getResultByUser(_this.profileId, userId)
	                .subscribe(function (user) { return _this.ariadnextUser = user; });
	        });
	    };
	    ClientUserAriadnextVerificationComponent.prototype.decline = function () {
	        var _this = this;
	        var userId = this.ariadnextUser.userId;
	        this._ariadnextService
	            .decline(this.profileId, userId)
	            .subscribe(function (_) {
	            _this._ariadnextService
	                .getResultByUser(_this.profileId, userId)
	                .subscribe(function (user) { return _this.ariadnextUser = user; });
	        });
	    };
	    ClientUserAriadnextVerificationComponent.prototype.documents = function () {
	        this._ariadnextService
	            .downloadDocument(this.ariadnextUser.documentReportCode)
	            .subscribe(function (response) {
	            utils_1.FileUtils.saveFile(utils_1.FileUtils.getFilename(response), response.blob());
	        });
	    };
	    ClientUserAriadnextVerificationComponent.prototype.selfie = function () {
	        this._ariadnextService
	            .downloadDocument(this.ariadnextUser.selfieReportCode)
	            .subscribe(function (response) {
	            utils_1.FileUtils.saveFile(utils_1.FileUtils.getFilename(response), response.blob());
	        });
	    };
	    ClientUserAriadnextVerificationComponent.prototype.getBoxColorClass = function () {
	        switch (this.ariadnextUser.lastAriadnextStatus) {
	            case entity_1.AriadVerificationStatus.OK:
	                return 'state-approved';
	            case entity_1.AriadVerificationStatus.WARN:
	            case entity_1.AriadVerificationStatus.ERROR:
	                return 'state-error';
	            default:
	                return 'state-progress';
	        }
	    };
	    __decorate([
	        core_1.Input("loading"),
	        __metadata("design:type", Boolean)
	    ], ClientUserAriadnextVerificationComponent.prototype, "loading", void 0);
	    __decorate([
	        core_1.Input("profileId"),
	        __metadata("design:type", Number)
	    ], ClientUserAriadnextVerificationComponent.prototype, "profileId", void 0);
	    __decorate([
	        core_1.Input("user"),
	        __metadata("design:type", Object)
	    ], ClientUserAriadnextVerificationComponent.prototype, "ariadnextUser", void 0);
	    __decorate([
	        core_1.ViewChild(create_applicant_dialog_component_1.CreateApplicantDialogComponent),
	        __metadata("design:type", create_applicant_dialog_component_1.CreateApplicantDialogComponent)
	    ], ClientUserAriadnextVerificationComponent.prototype, "createApplicantDialog", void 0);
	    ClientUserAriadnextVerificationComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-ariadnext-client-user',
	            template: __webpack_require__(1519)
	        }),
	        __metadata("design:paramtypes", [service_1.AriadnextService, notification_1.NotificationManager])
	    ], ClientUserAriadnextVerificationComponent);
	    return ClientUserAriadnextVerificationComponent;
	}());
	exports.ClientUserAriadnextVerificationComponent = ClientUserAriadnextVerificationComponent;


/***/ }),
/* 1519 */
/***/ (function(module, exports) {

	module.exports = "<tfl-bo-card-box [box-color-class]=\"getBoxColorClass()\">\n    <tfl-bo-card-box-header>\n        <div class=\"card-box-header-icon\">\n            <i class=\"fa fa-2x fa-id-card\"></i>\n        </div>\n\n        <div class=\"card-box-header-title\">\n            {{ ariadnextUser.email }}\n        </div>\n\n        <div class=\"card-box-header-content\">\n            <tfl-bo-ariadnext-status-badge\n                [status]=\"ariadnextUser.lastAriadnextStatus\"></tfl-bo-ariadnext-status-badge>\n\n            <div class=\"badge-box\" *ngIf=\"!!ariadnextUser.expired\">\n                <span class=\"label label-danger\">\n                    {{ 'CUSTOMER.VERIFICATION.ARIADNEXT.EXPIRED' | translate }}\n                </span>\n            </div>\n        </div>\n    </tfl-bo-card-box-header>\n\n    <tfl-bo-card-box-content>\n        <div class=\"row\">\n            <!-- First column -->\n            <div class=\"col-sm-6\">\n                <tfl-bo-data-item\n                    label=\"CUSTOMER.VERIFICATION.ARIADNEXT.CARD.FIRST_NAME\">{{ ariadnextUser.firstName }}</tfl-bo-data-item>\n                <tfl-bo-data-item\n                    label=\"CUSTOMER.VERIFICATION.ARIADNEXT.CARD.LAST_NAME\">{{ ariadnextUser.lastName }}</tfl-bo-data-item>\n                <tfl-bo-data-item\n                    label=\"CUSTOMER.VERIFICATION.ARIADNEXT.CARD.PHONE_NUMBER\">{{ ariadnextUser.phoneNumber }}</tfl-bo-data-item>\n                <tfl-bo-data-item\n                    label=\"CUSTOMER.VERIFICATION.ARIADNEXT.CARD.UUID\">{{ ariadnextUser.applicantId }}</tfl-bo-data-item>\n            </div>\n\n            <!-- Second column -->\n            <div class=\"col-sm-6\">\n                <tfl-bo-data-item\n                    label=\"CUSTOMER.VERIFICATION.ARIADNEXT.CARD.CREATED\">{{ ariadnextUser.createDateTime }}</tfl-bo-data-item>\n                <tfl-bo-data-item\n                    label=\"CUSTOMER.VERIFICATION.ARIADNEXT.CARD.UPDATED\">{{ ariadnextUser.lastUpdateDateTime }}</tfl-bo-data-item>\n                <tfl-bo-data-item\n                    label=\"CUSTOMER.VERIFICATION.ARIADNEXT.CARD.ATTEMPTS\">{{ ariadnextUser.verificationAttempts }}</tfl-bo-data-item>\n            </div>\n        </div>\n\n        <div class=\"row\" *ngIf=\"ariadnextUser.errorReason\">\n            <div class=\"col-sm-12\">\n                <tfl-bo-data-item label=\"CUSTOMER.VERIFICATION.BLOCK.FIELD.ERROR_REASON\">\n                    <div class=\"alert alert-danger fade in verification-error-reason\" role=\"alert\">\n                        {{ ariadnextUser.errorReason }}\n                    </div>\n                </tfl-bo-data-item>\n            </div>\n        </div>\n\n        <!-- Check content here -->\n        <ng-container *ngIf=\"ariadnextUser.checks.length != 0\">\n            <div *ngFor=\"let check of ariadnextUser.checks\">\n                <tfl-bo-verification-ariadnext-check [check]=\"check\"></tfl-bo-verification-ariadnext-check>\n            </div>\n        </ng-container>\n\n    </tfl-bo-card-box-content>\n\n    <tfl-bo-card-box-action>\n        <button class=\"btn btn-xs btn-primary ariad-action-button\"\n                *ngIf=\"(ariadnextUser.lastAriadnextStatus != 'OK' && ariadnextUser.lastAriadnextStatus != 'WARN') || ariadnextUser.expired\"\n                (click)=\"openCreationDialog()\">{{ 'CUSTOMER.VERIFICATION.ARIADNEXT.CARD.ACTION.START' | translate }}</button>\n\n        <button class=\"btn btn-xs btn-success\"\n                *ngIf=\"ariadnextUser.lastAriadnextStatus == 'WARN'\"\n                (click)=\"verify()\">{{ 'CUSTOMER.VERIFICATION.ARIADNEXT.CARD.ACTION.VERIFY' | translate }}</button>\n        <button class=\"btn btn-xs btn-warning\"\n                *ngIf=\"ariadnextUser.lastAriadnextStatus == 'WARN'\"\n                (click)=\"decline()\">{{ 'CUSTOMER.VERIFICATION.ARIADNEXT.CARD.ACTION.DECLINE' | translate }}</button>\n\n        <button class=\"btn btn-xs btn-default\"\n                *ngIf=\"ariadnextUser.lastAriadnextStatus == 'OK' || ariadnextUser.lastAriadnextStatus == 'WARN' || ariadnextUser.lastAriadnextStatus == 'ERROR'\"\n                (click)=\"documents()\"><i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i> {{ 'CUSTOMER.VERIFICATION.ARIADNEXT.CARD.ACTION.PDF_DOC' | translate }}</button>\n        <button class=\"btn btn-xs btn-default\"\n                *ngIf=\"ariadnextUser.lastAriadnextStatus == 'OK' || ariadnextUser.lastAriadnextStatus == 'WARN' || ariadnextUser.lastAriadnextStatus == 'ERROR'\"\n                (click)=\"selfie()\"><i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i> {{ 'CUSTOMER.VERIFICATION.ARIADNEXT.CARD.ACTION.PDF_SELFIE' | translate }}</button>\n    </tfl-bo-card-box-action>\n</tfl-bo-card-box>\n\n\n<tfl-bo-create-ariad-applicant-dialog\n    *ngIf=\"(ariadnextUser.lastAriadnextStatus != 'OK' && ariadnextUser.lastAriadnextStatus != 'WARN') || ariadnextUser.expired\"\n    [user]=\"ariadnextUser\"\n    (onStart)=\"createApplicant($event)\">\n</tfl-bo-create-ariad-applicant-dialog>"

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var AriadnextCheckVerificationComponent = (function () {
	    function AriadnextCheckVerificationComponent() {
	    }
	    __decorate([
	        core_1.Input("check"),
	        __metadata("design:type", Object)
	    ], AriadnextCheckVerificationComponent.prototype, "check", void 0);
	    AriadnextCheckVerificationComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-verification-ariadnext-check',
	            template: "\n        <accordion>\n            <accordion-group>\n                <accordion-header>\n                    <accordion-toggle\n                        title=\"{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.CHECK_ID' | translate }}: {{ check.checkId }} . {{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.SEND_DATE_TIME' | translate }}: {{ check.sendDateTime }}\">\n                    </accordion-toggle>\n                </accordion-header>\n\n                <accordion-content>\n\n                    <div class=\"row\">\n                        <div class=\"col-xs-3\">\n                            <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.NOTIFICATION_LINK' | translate }}:</b>\n                        </div>\n                        <div class=\"col-xs-9\">{{ check.notificationLink }}</div>\n                    </div>\n\n                    <div class=\"row\">\n                        <div class=\"col-xs-3\">\n                            <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.SEND_LINK_APPROACH' | translate }}:</b>\n                        </div>\n                        <div class=\"col-xs-9\">{{ check.sendLinkApproach }}</div>\n                    </div>\n\n                    <div class=\"row\">\n                        <div class=\"col-xs-3\">\n                            <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.STATUS' | translate }}:</b>\n                        </div>\n                        <div class=\"col-xs-9\">\n                            <tfl-bo-ariadnext-status-badge\n                                [status]=\"check.ariadnextStatus\"></tfl-bo-ariadnext-status-badge>\n                        </div>\n                    </div>\n\n                    <div class=\"row\" *ngIf=\"check.validationErrorReason\">\n                        <div class=\"col-xs-3\">\n                            <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.ERROR_REASON' | translate }}:</b>\n                        </div>\n                        <div class=\"col-xs-9\">\n                            <div class=\"alert alert-danger fade in verification-error-reason\">\n                                {{ check.validationErrorReason }}\n                            </div>\n                        </div>\n                    </div>\n\n                </accordion-content>\n            </accordion-group>\n        </accordion>\n    "
	        })
	    ], AriadnextCheckVerificationComponent);
	    return AriadnextCheckVerificationComponent;
	}());
	exports.AriadnextCheckVerificationComponent = AriadnextCheckVerificationComponent;


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var document_shareholders_component_1 = __webpack_require__(1522);
	var document_directors_component_1 = __webpack_require__(1524);
	var corporate_profile_document_component_1 = __webpack_require__(1526);
	var corporate_profile_documents_component_1 = __webpack_require__(1527);
	exports.CORPORATE_PROFILE_DOCUMENTS_COMPONENTS = [
	    corporate_profile_documents_component_1.CorporateProfileDocumentsComponent,
	    corporate_profile_document_component_1.CorporateProfileDocumentComponent,
	    document_directors_component_1.DocumentDirectorsComponent,
	    document_shareholders_component_1.DocumentShareholdersComponent
	];


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var utils_1 = __webpack_require__(740);
	var service_1 = __webpack_require__(1332);
	var DocumentShareholdersComponent = (function () {
	    function DocumentShareholdersComponent(_fileDownloadService) {
	        this._fileDownloadService = _fileDownloadService;
	    }
	    DocumentShareholdersComponent.prototype.ngOnInit = function () {
	        this.allShareholders = this.shareholders.corporate.concat(this.shareholders.individual);
	    };
	    DocumentShareholdersComponent.prototype.onDownloadFile = function (fileId, shareholder) {
	        this._fileDownloadService.downloadFile(fileId)
	            .subscribe(function (response) {
	            utils_1.FileUtils.saveFile(utils_1.FileUtils.getFilename(response), response.blob());
	        });
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], DocumentShareholdersComponent.prototype, "shareholders", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], DocumentShareholdersComponent.prototype, "attachmentSubTypes", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], DocumentShareholdersComponent.prototype, "profileId", void 0);
	    DocumentShareholdersComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-document-shareholders',
	            template: __webpack_require__(1523)
	        }),
	        __metadata("design:paramtypes", [service_1.FileDownloadService])
	    ], DocumentShareholdersComponent);
	    return DocumentShareholdersComponent;
	}());
	exports.DocumentShareholdersComponent = DocumentShareholdersComponent;


/***/ }),
/* 1523 */
/***/ (function(module, exports) {

	module.exports = "<div *ngFor=\"let item of allShareholders; index as i; last as last;\"\n     [class.is-last]=\"last\"\n     class=\"customers-sub-card\">\n    <div class=\"customers-sub-card-title\">\n        <h4>{{ 'CUSTOMER.DETAILS.TAB.DOCUMENTS.SHAREHOLDER' | translate}} {{i + 1}}</h4>\n    </div>\n    <div class=\"customers-sub-card-divider\"></div>\n\n    <!-- Corporate -->\n    <tfl-panel-details-group\n        *ngIf=\"item.companyName\"\n        title=\"CUSTOMER.DETAILS.TAB.DOCUMENTS.COMPANY_INFORMATION\">\n            <tfl-panel-details-column>\n                <tfl-panel-details-cell\n                    label=\"CUSTOMER.DETAILS.TAB.DOCUMENTS.COMPANY_NAME\">\n                    {{ item.companyName }}\n                </tfl-panel-details-cell>\n            </tfl-panel-details-column>\n    </tfl-panel-details-group>\n\n    <!-- Individual -->\n    <tfl-panel-details-group\n        *ngIf=\"item.firstName\">\n            <tfl-panel-details-column>\n                <tfl-panel-details-cell\n                    label=\"CUSTOMER.DETAILS.TAB.DOCUMENTS.FIRST_NAME\">\n                    {{ item.firstName }}\n                </tfl-panel-details-cell>\n\n                <tfl-panel-details-cell\n                    label=\"CUSTOMER.DETAILS.TAB.DOCUMENTS.LAST_NAME\">\n                    {{ item.lastName }}\n                </tfl-panel-details-cell>\n            </tfl-panel-details-column>\n    </tfl-panel-details-group>\n\n    <tfl-corporate-profile-document\n        [attachments]=\"item.attachments\"\n        [attachmentSubTypes]=\"attachmentSubTypes\"\n        (downloadFile)=\"onDownloadFile($event, item)\"\n    ></tfl-corporate-profile-document>\n\n</div>\n"

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var utils_1 = __webpack_require__(740);
	var service_1 = __webpack_require__(1332);
	var DocumentDirectorsComponent = (function () {
	    function DocumentDirectorsComponent(_fileDownloadService) {
	        this._fileDownloadService = _fileDownloadService;
	    }
	    DocumentDirectorsComponent.prototype.ngOnInit = function () {
	        this.allDirectors = this.directors.corporate.concat(this.directors.individual);
	    };
	    DocumentDirectorsComponent.prototype.onDownloadFile = function (fileId, director) {
	        this._fileDownloadService.downloadFile(fileId)
	            .subscribe(function (response) {
	            utils_1.FileUtils.saveFile(utils_1.FileUtils.getFilename(response), response.blob());
	        });
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], DocumentDirectorsComponent.prototype, "directors", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], DocumentDirectorsComponent.prototype, "attachmentSubTypes", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], DocumentDirectorsComponent.prototype, "profileId", void 0);
	    DocumentDirectorsComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-document-directors',
	            template: __webpack_require__(1525)
	        }),
	        __metadata("design:paramtypes", [service_1.FileDownloadService])
	    ], DocumentDirectorsComponent);
	    return DocumentDirectorsComponent;
	}());
	exports.DocumentDirectorsComponent = DocumentDirectorsComponent;


/***/ }),
/* 1525 */
/***/ (function(module, exports) {

	module.exports = "<div *ngFor=\"let item of allDirectors; index as i; last as last;\"\n     [class.is-last]=\"last\"\n     class=\"customers-sub-card\">\n    <div class=\"customers-sub-card-title\">\n        <h4>{{ 'CUSTOMER.DETAILS.TAB.DOCUMENTS.DIRECTOR' | translate}} {{i + 1}}</h4>\n    </div>\n    <div class=\"customers-sub-card-divider\"></div>\n\n    <!-- Corporate -->\n    <tfl-panel-details-group\n        *ngIf=\"item.companyName\"\n        title=\"CUSTOMER.DETAILS.TAB.DOCUMENTS.COMPANY_INFORMATION\">\n            <tfl-panel-details-column>\n                <tfl-panel-details-cell\n                    label=\"CUSTOMER.DETAILS.TAB.DOCUMENTS.COMPANY_NAME\">\n                    {{ item.companyName }}\n                </tfl-panel-details-cell>\n            </tfl-panel-details-column>\n    </tfl-panel-details-group>\n\n    <!-- Individual -->\n    <tfl-panel-details-group\n        *ngIf=\"item.firstName\">\n            <tfl-panel-details-column>\n                <tfl-panel-details-cell\n                    label=\"CUSTOMER.DETAILS.TAB.DOCUMENTS.FIRST_NAME\">\n                    {{ item.firstName }}\n                </tfl-panel-details-cell>\n\n                <tfl-panel-details-cell\n                    label=\"CUSTOMER.DETAILS.TAB.DOCUMENTS.LAST_NAME\">\n                    {{ item.lastName }}\n                </tfl-panel-details-cell>\n            </tfl-panel-details-column>\n    </tfl-panel-details-group>\n\n    <tfl-corporate-profile-document\n        [attachments]=\"item.attachments\"\n        [attachmentSubTypes]=\"attachmentSubTypes\"\n        (downloadFile)=\"onDownloadFile($event, item)\"\n    ></tfl-corporate-profile-document>\n\n</div>\n"

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var es6_shim_1 = __webpack_require__(1428);
	var CorporateProfileDocumentComponent = (function () {
	    function CorporateProfileDocumentComponent() {
	        this.downloadFile = new core_1.EventEmitter();
	        this.attachmentsMap = new Map();
	    }
	    CorporateProfileDocumentComponent.prototype.ngOnInit = function () {
	        this.groupAttachmentsBySubTypeName();
	    };
	    CorporateProfileDocumentComponent.prototype.getKeys = function (map) {
	        return es6_shim_1.Array.from(map.keys());
	    };
	    CorporateProfileDocumentComponent.prototype.onDownloadFile = function (fileId) {
	        this.downloadFile.emit(fileId);
	    };
	    CorporateProfileDocumentComponent.prototype.groupAttachmentsBySubTypeName = function () {
	        var _this = this;
	        this.attachments.forEach(function (attachment) {
	            var subTypeItem = _this.attachmentSubTypes
	                .find(function (subType) { return attachment.attachmentSubTypeId === subType.id; });
	            var subTypeVal = _this.attachmentsMap.get(subTypeItem.name) || [];
	            subTypeVal.push(attachment);
	            _this.attachmentsMap.set(subTypeItem.name, subTypeVal);
	        });
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], CorporateProfileDocumentComponent.prototype, "attachments", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], CorporateProfileDocumentComponent.prototype, "attachmentSubTypes", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], CorporateProfileDocumentComponent.prototype, "profileId", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", Object)
	    ], CorporateProfileDocumentComponent.prototype, "downloadFile", void 0);
	    CorporateProfileDocumentComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-corporate-profile-document',
	            template: "\n        <ng-container\n            *ngFor=\"let key of getKeys(attachmentsMap)\">\n            <tfl-files-download\n                *ngIf=\"attachmentsMap.get(key).length\"\n                [title]=\"key\"\n                [disableSaveAll]=\"true\"\n                [attachments]=\"attachmentsMap.get(key)\"\n                (downloadFile)=\"onDownloadFile($event)\">\n            </tfl-files-download>\n        </ng-container>\n    "
	        })
	    ], CorporateProfileDocumentComponent);
	    return CorporateProfileDocumentComponent;
	}());
	exports.CorporateProfileDocumentComponent = CorporateProfileDocumentComponent;


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var lodash_1 = __webpack_require__(268);
	var Observable_1 = __webpack_require__(206);
	var util_1 = __webpack_require__(743);
	var utils_1 = __webpack_require__(740);
	var service_1 = __webpack_require__(1332);
	var attachment_1 = __webpack_require__(1528);
	var operators_1 = __webpack_require__(680);
	var CorporateProfileDocumentsComponent = (function () {
	    function CorporateProfileDocumentsComponent(_corporateAccountService, _fileDownloadService, _attachmentTypeService) {
	        this._corporateAccountService = _corporateAccountService;
	        this._fileDownloadService = _fileDownloadService;
	        this._attachmentTypeService = _attachmentTypeService;
	        this.loading = true;
	        this.hasData = false;
	        this.attachmentSubTypes = [];
	        this.authSignatoryAttachments = [];
	    }
	    CorporateProfileDocumentsComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.loadAttachmentsSubTypes().subscribe(function () { return _this.loadAttachments(); });
	    };
	    CorporateProfileDocumentsComponent.prototype.saveArchive = function () {
	        var fileName = "profile-" + this.profileId;
	        this._fileDownloadService.downloadAllCorporateAttachmentsFile(this.profileId, fileName)
	            .subscribe(function (response) {
	            utils_1.FileUtils.saveFile(utils_1.FileUtils.getFilename(response), response.blob());
	        });
	    };
	    CorporateProfileDocumentsComponent.prototype.onDownloadFile = function (fileId) {
	        this._fileDownloadService.downloadFile(fileId)
	            .subscribe(function (response) {
	            utils_1.FileUtils.saveFile(utils_1.FileUtils.getFilename(response), response.blob());
	        });
	    };
	    CorporateProfileDocumentsComponent.prototype.loadAttachmentsSubTypes = function () {
	        var _this = this;
	        return Observable_1.Observable.forkJoin(Array.from(Object.keys(attachment_1.AttachmentType)).map(function (type) {
	            return _this._attachmentTypeService.getAttachmentSubTypes(type).map((function (subTypes) {
	                subTypes.forEach(function (subType) { return _this.attachmentSubTypes.push(subType); });
	                return subTypes;
	            }));
	        }));
	    };
	    CorporateProfileDocumentsComponent.prototype.loadAttachments = function () {
	        var _this = this;
	        this._corporateAccountService.getCorporateProfileAttachments(this.profileId)
	            .pipe(operators_1.finalize(function () { return _this.loading = false; }))
	            .subscribe(function (res) {
	            if (!util_1.isNullOrUndefined(res)) {
	                _this.profileDocuments = res;
	                _this.groupProfileAttachments();
	                _this.hasData = true;
	            }
	        });
	    };
	    CorporateProfileDocumentsComponent.prototype.groupProfileAttachments = function () {
	        var _this = this;
	        this.profileDocuments.attachments
	            .forEach(function (attachment) {
	            switch (attachment.attachmentTypeId) {
	                case attachment_1.AttachmentTypeID.PASSPORT:
	                case attachment_1.AttachmentTypeID.SELFIE:
	                case attachment_1.AttachmentTypeID.ADDRESS:
	                    _this.authSignatoryAttachments.push(attachment);
	                    break;
	            }
	        });
	        this.authSignatoryAttachments = lodash_1.orderBy(this.authSignatoryAttachments, ['attachmentSubTypeId']);
	    };
	    __decorate([
	        core_1.Input('profile-id'),
	        __metadata("design:type", Number)
	    ], CorporateProfileDocumentsComponent.prototype, "profileId", void 0);
	    __decorate([
	        core_1.Input('profile-name'),
	        __metadata("design:type", String)
	    ], CorporateProfileDocumentsComponent.prototype, "profileName", void 0);
	    CorporateProfileDocumentsComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-corporate-profile-documents',
	            template: __webpack_require__(1529)
	        }),
	        __metadata("design:paramtypes", [service_1.CorporateAccountsService,
	            service_1.FileDownloadService,
	            service_1.AttachmentTypeService])
	    ], CorporateProfileDocumentsComponent);
	    return CorporateProfileDocumentsComponent;
	}());
	exports.CorporateProfileDocumentsComponent = CorporateProfileDocumentsComponent;


/***/ }),
/* 1528 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var AttachmentType;
	(function (AttachmentType) {
	    AttachmentType["PASSPORT"] = "PASSPORT";
	    AttachmentType["SELFIE"] = "SELFIE";
	    AttachmentType["ADDRESS"] = "ADDRESS";
	    AttachmentType["DOCUMENT"] = "DOCUMENT";
	})(AttachmentType = exports.AttachmentType || (exports.AttachmentType = {}));
	var AttachmentTypeID;
	(function (AttachmentTypeID) {
	    AttachmentTypeID[AttachmentTypeID["PASSPORT"] = 1] = "PASSPORT";
	    AttachmentTypeID[AttachmentTypeID["SELFIE"] = 2] = "SELFIE";
	    AttachmentTypeID[AttachmentTypeID["ADDRESS"] = 3] = "ADDRESS";
	    AttachmentTypeID[AttachmentTypeID["DOCUMENT"] = 4] = "DOCUMENT";
	})(AttachmentTypeID = exports.AttachmentTypeID || (exports.AttachmentTypeID = {}));


/***/ }),
/* 1529 */
/***/ (function(module, exports) {

	module.exports = "<loading-linear [loading]=\"loading\"></loading-linear>\n\n<ng-container *ngIf=\"!loading\">\n\n    <div *ngIf=\"!hasData; else documents\">\n        <h3 class=\"text-center\">{{'APPLICATIONS.NEW.DETAIL.TAB.DOCUMENTS.NO_DOCUMENTS' | translate}}</h3>\n    </div>\n\n    <ng-template #documents>\n        <div class=\"text-right save-archive-btn\">\n            <button (click)=\"saveArchive()\"\n                    class=\"btn btn-primary\"\n                    id=\"save-archive-btn\">\n                {{'CUSTOMER.DETAILS.TAB.DOCUMENTS.ARCHIVE_BUTTON'|translate}}\n            </button>\n        </div>\n\n       <tfl-panel-details caption=\"CUSTOMER.DETAILS.TAB.DOCUMENTS.AUTHORISED_SIGNATORY\">\n            <tfl-corporate-profile-document\n                [attachments]=\"authSignatoryAttachments\"\n                [attachmentSubTypes]=\"attachmentSubTypes\"\n                [profileId]=\"profileId\"\n                (downloadFile)=\"onDownloadFile($event)\"\n            ></tfl-corporate-profile-document>\n        </tfl-panel-details>\n\n       <tfl-panel-details caption=\"CUSTOMER.DETAILS.TAB.DOCUMENTS.DIRECTORS_OF_COMPANY\">\n            <tfl-document-directors\n                [directors]=\"profileDocuments.directors\"\n                [attachmentSubTypes]=\"attachmentSubTypes\"\n                [profileId]=\"profileId\"\n            ></tfl-document-directors>\n       </tfl-panel-details>\n\n        <tfl-panel-details caption=\"CUSTOMER.DETAILS.TAB.DOCUMENTS.SHAREHOLDERS\">\n            <tfl-document-shareholders\n                [shareholders]=\"profileDocuments.shareholders\"\n                [attachmentSubTypes]=\"attachmentSubTypes\"\n                [profileId]=\"profileId\"\n            ></tfl-document-shareholders>\n        </tfl-panel-details>\n    </ng-template>\n\n</ng-container>\n"

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1531));


/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var customer_email_service_1 = __webpack_require__(1532);
	var lodash_1 = __webpack_require__(268);
	var rxjs_1 = __webpack_require__(304);
	var entity_1 = __webpack_require__(1150);
	var EmailSendStatus = (function () {
	    function EmailSendStatus(status, errorMessage) {
	        if (status === void 0) { status = entity_1.MailingStatus.NOT_SEND; }
	        if (errorMessage === void 0) { errorMessage = ''; }
	        this.status = status;
	        this.errorMessage = errorMessage;
	    }
	    return EmailSendStatus;
	}());
	exports.EmailSendStatus = EmailSendStatus;
	var EmailSendComponent = (function () {
	    function EmailSendComponent(_customerEmailService) {
	        var _this = this;
	        this._customerEmailService = _customerEmailService;
	        this.emailType = entity_1.EmailTypes.UNKNOWN;
	        this.emailData = '';
	        this.successIconStyle = 'fa-check-circle';
	        this.successStyle = 'success';
	        this.progressIconStyle = 'fa-repeat';
	        this.progressStyle = 'alert-dark';
	        this.failureIconStyle = 'fa-exclamation-triangle';
	        this.failureStyle = 'warning';
	        this.disableIconStyle = 'fa-exclamation-triangle';
	        this.disableStyle = 'warning';
	        this.notSendIconStyle = 'fa-minus-circle';
	        this.notSendStyle = 'warning';
	        this.MailingStatusType = entity_1.MailingStatus;
	        this.sendEmailStatus = entity_1.MailingStatus.NOT_SEND;
	        this.sendEmailStatusEvent = new core_1.EventEmitter();
	        this.errorMessage = '';
	        this.errorMessageDetails = '';
	        this.spinnerSize = 20;
	        this.statusIcons = new Map();
	        this.statusStyles = new Map();
	        this.mailingConfigActions = new Map();
	        this.mailingSendActions = new Map();
	        var defaultConfigAction = function () { return _this._customerEmailService.getMailingConfigByProfile(_this.profileId); };
	        this.mailingConfigActions.set(entity_1.EmailTypes.REGISTRATION_LINK, defaultConfigAction);
	        this.mailingConfigActions.set(entity_1.EmailTypes.CONFIRMATION_CODE, defaultConfigAction);
	        this.mailingConfigActions.set(entity_1.EmailTypes.RESET_PASSWORD_LINK, function () { return _this._customerEmailService.getMailingConfigByUser(_this.userId); });
	        var defaultSendAction = function (request) { return _this._customerEmailService.sendApproveCustomerEmail(_this.profileId, request); };
	        this.mailingSendActions.set(entity_1.EmailTypes.REGISTRATION_LINK, defaultSendAction);
	        this.mailingSendActions.set(entity_1.EmailTypes.CONFIRMATION_CODE, defaultSendAction);
	        this.mailingSendActions.set(entity_1.EmailTypes.RESET_PASSWORD_LINK, function (request) { return _this._customerEmailService.sendResetPasswordCustomerEmail(_this.userId, request); });
	    }
	    EmailSendComponent.prototype.ngOnInit = function () {
	        this.statusIcons.set(entity_1.MailingStatus.NOT_SEND, this.notSendIconStyle);
	        this.statusIcons.set(entity_1.MailingStatus.SENDING, this.progressIconStyle);
	        this.statusIcons.set(entity_1.MailingStatus.SUCCESS, this.successIconStyle);
	        this.statusIcons.set(entity_1.MailingStatus.FAILURE, this.failureIconStyle);
	        this.statusIcons.set(entity_1.MailingStatus.DISABLE, this.disableIconStyle);
	        this.statusStyles.set(entity_1.MailingStatus.NOT_SEND, this.notSendStyle);
	        this.statusStyles.set(entity_1.MailingStatus.SENDING, this.progressStyle);
	        this.statusStyles.set(entity_1.MailingStatus.SUCCESS, this.successStyle);
	        this.statusStyles.set(entity_1.MailingStatus.FAILURE, this.failureStyle);
	        this.statusStyles.set(entity_1.MailingStatus.DISABLE, this.disableStyle);
	    };
	    EmailSendComponent.prototype.ngOnDestroy = function () {
	    };
	    EmailSendComponent.prototype.tryToSendEmail = function () {
	        var _this = this;
	        if (this.mailingConfigActions.has(this.emailType)) {
	            var getMailConfigAction = this.mailingConfigActions.get(this.emailType);
	            var result = getMailConfigAction().flatMap(function (mailingConfig) {
	                if (mailingConfig.mailingEnable) {
	                    return _this.sendEmail();
	                }
	                else {
	                    return rxjs_1.Observable.from([new EmailSendStatus(entity_1.MailingStatus.DISABLE)], rxjs_1.Scheduler.async);
	                }
	            });
	            result.subscribe(function (emailSendStatus) {
	                _this.sendEmailStatus = emailSendStatus.status;
	                _this.errorMessage = emailSendStatus.errorMessage;
	                _this.sendEmailStatusEvent.emit(emailSendStatus);
	            }, function (error) {
	                var errorResult = _this.handleMailError(error);
	                _this.sendEmailStatus = errorResult.status;
	                _this.sendEmailStatusEvent.emit(new EmailSendStatus(_this.sendEmailStatus));
	                _this.errorMessage = errorResult.errorMessage;
	                _this.errorMessageDetails = errorResult.errorMessageDetails;
	            }, function () {
	                if (_this.sendEmailStatus === entity_1.MailingStatus.SENDING) {
	                    _this.sendEmailStatus = entity_1.MailingStatus.NOT_SEND;
	                }
	            });
	        }
	        else {
	            console.warn("Config mailing action was not found for [" + this.emailType + "] email type");
	        }
	    };
	    EmailSendComponent.prototype.sendEmail = function () {
	        var _this = this;
	        var sendEmailAction = function () {
	            var mailingRequest = new entity_1.MailingRequest(_this.emailType, _this.emailData);
	            if (_this.mailingSendActions.has(_this.emailType)) {
	                var sendEmailActionItem = _this.mailingSendActions.get(_this.emailType);
	                return sendEmailActionItem(mailingRequest);
	            }
	            else {
	                return rxjs_1.Observable.empty();
	            }
	        };
	        this.sendEmailStatus = entity_1.MailingStatus.SENDING;
	        return sendEmailAction()
	            .map(function (emailSendResponse) {
	            var status = emailSendResponse.success ? entity_1.MailingStatus.SUCCESS : entity_1.MailingStatus.FAILURE;
	            var errorMsg = '';
	            if (status === entity_1.MailingStatus.FAILURE) {
	                errorMsg = lodash_1.escape(emailSendResponse.errorMessage);
	            }
	            return new EmailSendStatus(status, errorMsg);
	        });
	    };
	    EmailSendComponent.prototype.handleMailError = function (error) {
	        var msg = '';
	        var msgDetails = '';
	        var hasNestedError = error.messageArgs
	            && error.messageArgs.success !== undefined;
	        if (hasNestedError) {
	            return this.handleMailError(error.messageArgs);
	        }
	        else {
	            if (error.hasOwnProperty('success')) {
	                msg = error.error_message;
	                if (Array.isArray(error.errors) && error.errors.length) {
	                    msgDetails = error.errors.join();
	                }
	            }
	            else {
	                if (error.hasOwnProperty('message')) {
	                    msg = error.message;
	                }
	            }
	            return {
	                status: entity_1.MailingStatus.FAILURE,
	                errorMessage: lodash_1.escape(msg),
	                errorMessageDetails: lodash_1.escape(msgDetails)
	            };
	        }
	    };
	    EmailSendComponent.prototype.iconClassByStatus = function () {
	        var s = this.statusIcons.get(this.sendEmailStatus);
	        return "fa " + s + " fa-2x";
	    };
	    EmailSendComponent.prototype.emailSendStatusStyle = function () {
	        return this.statusStyles.get(this.sendEmailStatus);
	    };
	    EmailSendComponent.isAllEmailComponentsWithStatus = function (mailingComponents, status) {
	        return mailingComponents.map(function (component) { return component.sendEmailStatus; })
	            .every(function (s) { return s === status; });
	    };
	    EmailSendComponent.isAnyEmailComponentsWithStatus = function (mailingComponents, status) {
	        return mailingComponents.map(function (component) { return component.sendEmailStatus; })
	            .some(function (s) { return s === status; });
	    };
	    EmailSendComponent.prototype.isSendingComplete = function () {
	        return this.sendEmailStatus !== entity_1.MailingStatus.NOT_SEND && this.sendEmailStatus !== entity_1.MailingStatus.SENDING;
	    };
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], EmailSendComponent.prototype, "profileId", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Number)
	    ], EmailSendComponent.prototype, "userId", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], EmailSendComponent.prototype, "emailType", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], EmailSendComponent.prototype, "emailData", void 0);
	    __decorate([
	        core_1.Input('success-icon-style'),
	        __metadata("design:type", Object)
	    ], EmailSendComponent.prototype, "successIconStyle", void 0);
	    __decorate([
	        core_1.Input('success-style'),
	        __metadata("design:type", Object)
	    ], EmailSendComponent.prototype, "successStyle", void 0);
	    __decorate([
	        core_1.Input('progress-icon-style'),
	        __metadata("design:type", Object)
	    ], EmailSendComponent.prototype, "progressIconStyle", void 0);
	    __decorate([
	        core_1.Input('progress-style'),
	        __metadata("design:type", Object)
	    ], EmailSendComponent.prototype, "progressStyle", void 0);
	    __decorate([
	        core_1.Input('failure-icon-style'),
	        __metadata("design:type", Object)
	    ], EmailSendComponent.prototype, "failureIconStyle", void 0);
	    __decorate([
	        core_1.Input('failure-style'),
	        __metadata("design:type", Object)
	    ], EmailSendComponent.prototype, "failureStyle", void 0);
	    __decorate([
	        core_1.Input('disable-icon-style'),
	        __metadata("design:type", Object)
	    ], EmailSendComponent.prototype, "disableIconStyle", void 0);
	    __decorate([
	        core_1.Input('disable-style'),
	        __metadata("design:type", Object)
	    ], EmailSendComponent.prototype, "disableStyle", void 0);
	    __decorate([
	        core_1.Input('not-send-icon-style'),
	        __metadata("design:type", Object)
	    ], EmailSendComponent.prototype, "notSendIconStyle", void 0);
	    __decorate([
	        core_1.Input('not-send-style'),
	        __metadata("design:type", Object)
	    ], EmailSendComponent.prototype, "notSendStyle", void 0);
	    __decorate([
	        core_1.Output('on-send-email-status'),
	        __metadata("design:type", Object)
	    ], EmailSendComponent.prototype, "sendEmailStatusEvent", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Object)
	    ], EmailSendComponent.prototype, "spinnerSize", void 0);
	    EmailSendComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-email-send',
	            template: __webpack_require__(1533),
	            providers: [customer_email_service_1.CustomerEmailService]
	        }),
	        __metadata("design:paramtypes", [customer_email_service_1.CustomerEmailService])
	    ], EmailSendComponent);
	    return EmailSendComponent;
	}());
	exports.EmailSendComponent = EmailSendComponent;


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var translate_manager_1 = __webpack_require__(692);
	var http_1 = __webpack_require__(836);
	var CustomerEmailService = (function () {
	    function CustomerEmailService(_http, _translateManager) {
	        this._http = _http;
	        this._translateManager = _translateManager;
	        this.baseUrl = '/api/backoffice';
	        this.pathPrefix = 'mailing';
	    }
	    CustomerEmailService.prototype.sendApproveCustomerEmail = function (profileId, mailingRequest) {
	        var url = this.baseUrl + "/" + this.pathPrefix + "/customers/" + profileId + "/send-approve";
	        return this._http.post(url, mailingRequest).map(function (response) { return response.json(); });
	    };
	    CustomerEmailService.prototype.sendResetPasswordCustomerEmail = function (userId, mailingRequest) {
	        var url = this.baseUrl + "/" + this.pathPrefix + "/customers/clients/" + userId + "/send-reset";
	        return this._http.post(url, mailingRequest).map(function (response) { return response.json(); });
	    };
	    CustomerEmailService.prototype.getMailingConfigByProfile = function (profileId) {
	        var url = this.baseUrl + "/" + this.pathPrefix + "/configs/customers/profile/" + profileId;
	        return this._http.get(url).map(function (response) { return response.json(); });
	    };
	    CustomerEmailService.prototype.getMailingConfigByUser = function (userId) {
	        var url = this.baseUrl + "/" + this.pathPrefix + "/configs/clients/" + userId;
	        return this._http.get(url).map(function (response) { return response.json(); });
	    };
	    CustomerEmailService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http,
	            translate_manager_1.TranslateManager])
	    ], CustomerEmailService);
	    return CustomerEmailService;
	}());
	exports.CustomerEmailService = CustomerEmailService;


/***/ }),
/* 1533 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"e-mail-sender\">\n    <mat-progress-spinner *ngIf=\"sendEmailStatus == MailingStatusType.SENDING\"\n                          mode=\"indeterminate\" [diameter]=\"spinnerSize\">\n    </mat-progress-spinner>\n    <i id=\"e-mail-status-icon\" *ngIf=\"isSendingComplete()\"\n       [ngClass]=\"[iconClassByStatus(), emailSendStatusStyle()]\"></i>\n</div>\n"

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1535));


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var lodash_1 = __webpack_require__(268);
	var ng2_daterangepicker_1 = __webpack_require__(1223);
	var util_1 = __webpack_require__(743);
	var api_1 = __webpack_require__(1406);
	var translate_1 = __webpack_require__(302);
	var utils_1 = __webpack_require__(740);
	var service_1 = __webpack_require__(1332);
	var file_upload_modal_component_1 = __webpack_require__(1504);
	var new_corporate_details_component_1 = __webpack_require__(1536);
	var backoffice_business_type_categories_service_1 = __webpack_require__(1121);
	var Observable_1 = __webpack_require__(206);
	var option_dialog_1 = __webpack_require__(1317);
	var notification_1 = __webpack_require__(264);
	var moment = __webpack_require__(838);
	var BusinessCustomersInformationComponent = (function () {
	    function BusinessCustomersInformationComponent(_translationService, daterangepickerOptions, _fileDownloadService, _corporateAccountsService, _fb, _businessTypeCategoriesService, _notificationManager) {
	        var _this = this;
	        this._translationService = _translationService;
	        this.daterangepickerOptions = daterangepickerOptions;
	        this._fileDownloadService = _fileDownloadService;
	        this._corporateAccountsService = _corporateAccountsService;
	        this._fb = _fb;
	        this._businessTypeCategoriesService = _businessTypeCategoriesService;
	        this._notificationManager = _notificationManager;
	        this.loading = true;
	        this.MIN_LIST_SIZE = 'minListSize';
	        this.TRADING_NAME_PATTERN = '^[a-zA-Z0-9][a-zA-Z0-9\'.-\\s]*$';
	        this.TAX_IDENTIFICATION_NUMBER_PATTERN = '^[0-9a-zA-Z][0-9a-zA-Z-.]*$';
	        this.CONTROL = {
	            ENTITY_NAME: 'entity_name',
	            REGISTRATION_DATE: 'registration_date',
	            REGISTRATION_NUMBER: 'registration_number',
	            TRADING_NAME: 'trading_name',
	            TAX_IDENTIFICATION_NUMBER: 'tax_identification_number',
	            USER_EMAIL: 'user_email',
	            COMPANY_SIGNATORY_PHONE: 'company_signatory_phone',
	            BUSINESS_CATEGORY_FILTER: 'business_category_filter',
	            BUSINESS_CATEGORIES: 'business_categories',
	            BUSINESS_CATEGORIES_RESULT_LIST: 'business_categories_result_list'
	        };
	        this.businessCustomerInformation = null;
	        this.originalBusinessCustomerInformation = null;
	        this.isEdited = false;
	        this.attachmentType = api_1.AttachmentType.DOCUMENT;
	        this.loadingState = false;
	        this.businessCustomerLegalDocumentsId = 'business-customer-legal-documents';
	        this.validBusinessCategories = function (control) {
	            var filterControl = control.get(_this.CONTROL.BUSINESS_CATEGORY_FILTER);
	            if (filterControl.value != null) {
	                var resultListControl = control.get(_this.CONTROL.BUSINESS_CATEGORIES_RESULT_LIST);
	                if (!util_1.isNullOrUndefined(resultListControl.value)) {
	                    if ((resultListControl.value && (resultListControl.value.length == 0) && filterControl.value.length >= 3)) {
	                        var noMatchesFound = { 'matchesNotFound': { value: filterControl.value } };
	                        return _this.setErrorsToControlAndReturnError(filterControl, noMatchesFound);
	                    }
	                }
	            }
	            else {
	                var categoryListControl = control.get(_this.CONTROL.BUSINESS_CATEGORIES);
	                var list = categoryListControl.value;
	                if ((util_1.isNullOrUndefined(list) || list.length < 1)) {
	                    var minSizeError = { 'minListSize': { value: categoryListControl.value } };
	                    return _this.setErrorsToControlAndReturnError(filterControl, minSizeError);
	                }
	            }
	            return _this.setErrorsToControlAndReturnError(filterControl, null);
	        };
	        this.daterangepickerOptions.settings = {
	            opens: 'left',
	            drops: 'left',
	            singleDatePicker: true,
	            showDropdowns: true,
	            locale: {
	                format: new_corporate_details_component_1.DATE_FORMAT,
	                firstDay: 1,
	                cancelLabel: this._translationService.getValue('COMMON.CLEAR')
	            },
	            dateLimit: {
	                months: 12
	            },
	            minYear: 1901,
	            maxYear: parseInt(moment().format('YYYY'), 10),
	            maxDate: moment()
	        };
	        this.form = this._fb.group({});
	    }
	    BusinessCustomersInformationComponent.prototype.registerForm = function () {
	        var definitions = (_a = {},
	            _a[this.CONTROL.ENTITY_NAME] = {
	                value: this.businessCustomerInformation.entityName,
	                validation: { maxlength: 50, required: true }
	            },
	            _a[this.CONTROL.REGISTRATION_DATE] = {
	                value: this.businessCustomerInformation.registrationDate,
	            },
	            _a[this.CONTROL.REGISTRATION_NUMBER] = {
	                value: this.businessCustomerInformation.registrationNumber,
	                validation: { maxlength: 50, required: true }
	            },
	            _a[this.CONTROL.TRADING_NAME] = {
	                value: this.businessCustomerInformation.tradingName,
	                validation: { minlength: 3, maxlength: 100 }
	            },
	            _a[this.CONTROL.TAX_IDENTIFICATION_NUMBER] = {
	                value: this.businessCustomerInformation.taxIdentificationNumber,
	                validation: { minlength: 16 }
	            },
	            _a[this.CONTROL.USER_EMAIL] = {
	                value: this.businessCustomerInformation.userEmail,
	                validation: {}
	            },
	            _a[this.CONTROL.COMPANY_SIGNATORY_PHONE] = {
	                value: this.businessCustomerInformation.companySignatoryPhone,
	                validation: {}
	            },
	            _a[this.CONTROL.BUSINESS_CATEGORY_FILTER] = {},
	            _a[this.CONTROL.BUSINESS_CATEGORIES] = {
	                value: this.getBusinessTypeCategories()
	            },
	            _a[this.CONTROL.BUSINESS_CATEGORIES_RESULT_LIST] = {},
	            _a);
	        this.definition = utils_1.FormUtils.register(this.form, definitions, this.validBusinessCategories);
	        var _a;
	    };
	    BusinessCustomersInformationComponent.prototype.setErrorsToControlAndReturnError = function (control, error) {
	        control.setErrors(error);
	        return error;
	    };
	    Object.defineProperty(BusinessCustomersInformationComponent.prototype, "setBusinessCustomerInformation", {
	        set: function (businessCustomerInformation) {
	            var _this = this;
	            if (!util_1.isNullOrUndefined(businessCustomerInformation)) {
	                this.businessCustomerInformation = businessCustomerInformation;
	                this.originalBusinessCustomerInformation = lodash_1.cloneDeep(businessCustomerInformation);
	                this.daterangepickerOptions.settings.startDate = businessCustomerInformation.registrationDate;
	                this._businessTypeCategoriesService.getBusinessTypeCategories().subscribe(function (response) {
	                    _this.sourceData = response['records'];
	                    _this.registerForm();
	                    _this.setBusinessTypeCategories(_this.businessCustomerInformation.businessCategories
	                        .map(function (categoryId) { return _this.sourceData.find(function (category) { return category.id == categoryId; }); }));
	                });
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BusinessCustomersInformationComponent.prototype.onChangeInputValue = function (event, fieldName) {
	        this.businessCustomerInformation[fieldName] = event.target.value;
	    };
	    BusinessCustomersInformationComponent.prototype.saveFiles = function (files) {
	        this.form.markAsTouched();
	        this.businessCustomerInformation.legalDocuments = this.businessCustomerInformation.legalDocuments.concat(files);
	    };
	    BusinessCustomersInformationComponent.prototype.isAttachmentsValid = function () {
	        return this.businessCustomerInformation
	            && this.businessCustomerInformation.legalDocuments.length != 0;
	    };
	    BusinessCustomersInformationComponent.prototype.uploadFiles = function () {
	        this.fileUploadModalComponent.show();
	    };
	    BusinessCustomersInformationComponent.prototype.downloadFile = function (id) {
	        this._fileDownloadService.downloadFile(id)
	            .subscribe(function (response) {
	            utils_1.FileUtils.saveFile(utils_1.FileUtils.getFilename(response), response.blob());
	        });
	    };
	    BusinessCustomersInformationComponent.prototype.downloadFiles = function () {
	        var ids = [];
	        var fileName = this.businessCustomerInformation.entityName + "_legal_documents";
	        this.businessCustomerInformation.legalDocuments.map(function (item) { return ids.push(item.id); });
	        this._fileDownloadService.downloadAttachmentsFile(ids, fileName)
	            .subscribe(function (response) {
	            utils_1.FileUtils.saveFile(utils_1.FileUtils.getFilename(response), response.blob());
	        });
	    };
	    BusinessCustomersInformationComponent.prototype.removeFile = function (id) {
	        this.form.markAsTouched();
	        this.businessCustomerInformation.legalDocuments =
	            this.businessCustomerInformation.legalDocuments.filter(function (doc) { return id !== doc.id; });
	    };
	    BusinessCustomersInformationComponent.prototype.onDateSelect = function (date) {
	        this.form.markAsTouched();
	        this.businessCustomerInformation.registrationDate = util_1.isNullOrUndefined(date.start) ? undefined : date.start.format(new_corporate_details_component_1.DATE_FORMAT);
	        this.form.controls[this.CONTROL.REGISTRATION_DATE].setValue(this.businessCustomerInformation.registrationDate);
	    };
	    BusinessCustomersInformationComponent.prototype.onDateChange = function (date) {
	        if (!util_1.isNullOrUndefined(date)) {
	            if (moment(date, 'DD.MM.YYYY').isSameOrBefore()) {
	                this.daterangepickerOptions.settings.startDate = date;
	            }
	            else {
	                this.businessCustomerInformation.registrationDate = moment().format('DD.MM.YYYY');
	                this.daterangepickerOptions.settings.startDate = moment().format('DD.MM.YYYY');
	                this.form.controls[this.CONTROL.REGISTRATION_DATE].setValue(this.businessCustomerInformation.registrationDate);
	            }
	        }
	    };
	    BusinessCustomersInformationComponent.prototype.isSaveBtnDisabled = function () {
	        return !this.form.valid
	            || !(this.form.dirty || this.form.touched);
	    };
	    BusinessCustomersInformationComponent.prototype.onEdit = function () {
	        this.isEdited = true;
	    };
	    BusinessCustomersInformationComponent.prototype.onDiscard = function () {
	        var _this = this;
	        this.businessCustomerInformation = lodash_1.cloneDeep(this.originalBusinessCustomerInformation);
	        this.setBusinessTypeCategories(this.businessCustomerInformation.businessCategories
	            .map(function (categoryId) { return _this.sourceData.find(function (category) { return category.id == categoryId; }); }));
	        this.isEdited = false;
	    };
	    BusinessCustomersInformationComponent.prototype.onSave = function () {
	        var _this = this;
	        if (this.originalBusinessCustomerInformation.userEmail !== this.businessCustomerInformation.userEmail) {
	            this.showDialogBlock().subscribe(function (ok) {
	                if (ok) {
	                    _this.updateBusinessCustomerInformation();
	                }
	            });
	        }
	        else {
	            this.updateBusinessCustomerInformation();
	        }
	    };
	    BusinessCustomersInformationComponent.prototype.updateBusinessCustomerInformation = function () {
	        var _this = this;
	        this.loadingState = true;
	        this.businessCustomerInformation.businessCategories = this.getBusinessTypeCategories().map(function (c) { return c.id; });
	        if (!this.businessCustomerInformation.tradingName || this.businessCustomerInformation.tradingName.length == 0) {
	            this.businessCustomerInformation.tradingName = null;
	        }
	        this._corporateAccountsService.updateBusinessCustomerInformation(this.profileId, this.businessCustomerInformation)
	            .subscribe(function (businessCustomerInformation) {
	            _this.businessCustomerInformation = lodash_1.cloneDeep(businessCustomerInformation);
	            _this.setBusinessTypeCategories(_this.businessCustomerInformation.businessCategories
	                .map(function (categoryId) { return _this.sourceData.find(function (category) { return category.id == categoryId; }); }));
	            _this.loadingState = false;
	        });
	        this.isEdited = false;
	    };
	    BusinessCustomersInformationComponent.prototype.isBusinessCategoriesInvalid = function () {
	        var control = this.form.controls[this.CONTROL.BUSINESS_CATEGORY_FILTER];
	        if (control.invalid && !control.value) {
	            if (!util_1.isNullOrUndefined(control.errors[this.MIN_LIST_SIZE])) {
	                return true;
	            }
	        }
	        return false;
	    };
	    BusinessCustomersInformationComponent.prototype.isRegistrationDateInvalid = function () {
	        return this.form.controls[this.CONTROL.REGISTRATION_DATE].invalid;
	    };
	    BusinessCustomersInformationComponent.prototype.getBusinessTypeCategories = function () {
	        var control = this.form.controls[this.CONTROL.BUSINESS_CATEGORIES];
	        return (control) ? control.value : [];
	    };
	    BusinessCustomersInformationComponent.prototype.setBusinessTypeCategories = function (value) {
	        return this.form.controls[this.CONTROL.BUSINESS_CATEGORIES].setValue(value);
	    };
	    BusinessCustomersInformationComponent.prototype.isInvalid = function (field) {
	        return this.form.controls[field].invalid;
	    };
	    BusinessCustomersInformationComponent.prototype.isEmailValid = function (email) {
	        return new_corporate_details_component_1.NewCorporateDetailsComponent.isEmailValid(this.form.controls[email].value);
	    };
	    BusinessCustomersInformationComponent.prototype.hasError = function (field, error) {
	        return this.form.controls[field].hasError(error);
	    };
	    BusinessCustomersInformationComponent.prototype.showDialogBlock = function () {
	        var _this = this;
	        return new Observable_1.Observable(function (observer) {
	            _this.dialog
	                .showConfirmDialog({
	                title: 'CUSTOMER.DETAILS.TAB.DETAILS.PRIVATE.APPLICANT_INFORMATION.DIALOG.TITLE',
	                message: 'CUSTOMER.DETAILS.TAB.DETAILS.PRIVATE.APPLICANT_INFORMATION.DIALOG.MESSAGE',
	                confirmButtonText: 'CUSTOMER.DETAILS.TAB.DETAILS.PRIVATE.APPLICANT_INFORMATION.DIALOG.OK',
	                cancelButtonText: 'CUSTOMER.DETAILS.TAB.DETAILS.PRIVATE.APPLICANT_INFORMATION.DIALOG.CANCEL'
	            })
	                .onConfirmAction(function () { return observer.next(true); })
	                .onCancelAction(function () { return observer.next(false); });
	        });
	    };
	    BusinessCustomersInformationComponent.prototype.updateDocStatus = function (id, $event) {
	        var _this = this;
	        var checkbox = event.target;
	        var isChecked = checkbox.checked;
	        this._corporateAccountsService.updateLegalDocStatus(id, isChecked)
	            .subscribe(function (usageReferral) {
	            _this._notificationManager.success(_this._translationService.getValue('APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.LEGAL_DOCUMENTS_VERIFY_UPDATED'), 5000);
	        });
	    };
	    BusinessCustomersInformationComponent.prototype.getDocStatus = function (idDb) {
	        this._corporateAccountsService.getLegalDocStatus(idDb)
	            .subscribe(function (resp) {
	            return resp;
	        });
	    };
	    __decorate([
	        core_1.Input('profileId'),
	        __metadata("design:type", Number)
	    ], BusinessCustomersInformationComponent.prototype, "profileId", void 0);
	    __decorate([
	        core_1.Input('loading'),
	        __metadata("design:type", Object)
	    ], BusinessCustomersInformationComponent.prototype, "loading", void 0);
	    __decorate([
	        core_1.ViewChild(file_upload_modal_component_1.FileUploadModalComponent),
	        __metadata("design:type", file_upload_modal_component_1.FileUploadModalComponent)
	    ], BusinessCustomersInformationComponent.prototype, "fileUploadModalComponent", void 0);
	    __decorate([
	        option_dialog_1.InjectOptionDialog('dialog'),
	        __metadata("design:type", Object)
	    ], BusinessCustomersInformationComponent.prototype, "dialog", void 0);
	    __decorate([
	        core_1.Input('businessCustomerInformation'),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [Object])
	    ], BusinessCustomersInformationComponent.prototype, "setBusinessCustomerInformation", null);
	    BusinessCustomersInformationComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-profile-detail-business-customer-information',
	            template: __webpack_require__(1540)
	        }),
	        __metadata("design:paramtypes", [translate_1.TranslateManager,
	            ng2_daterangepicker_1.DaterangepickerConfig,
	            service_1.FileDownloadService,
	            service_1.CorporateAccountsService,
	            forms_1.FormBuilder,
	            backoffice_business_type_categories_service_1.BackofficeBusinessTypeCategoriesService,
	            notification_1.NotificationManager])
	    ], BusinessCustomersInformationComponent);
	    return BusinessCustomersInformationComponent;
	}());
	exports.BusinessCustomersInformationComponent = BusinessCustomersInformationComponent;


/***/ }),
/* 1536 */
[3023, 1537, 1539],
/* 1537 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var LOADING_STATES = {
	    CORPORATE_ACCOUNT: 'corporate_account',
	    COUNTRIES: 'countries',
	    CURRENCIES: 'currencies',
	    AVAILABLE_CURRENCIES: 'available_currencies',
	    PRODUCTS: 'products',
	    REASONS: 'reasons',
	    SOURCES: 'sources',
	    INITIAL_DEPOSIT: 'initial_deposit',
	};
	exports.default = LOADING_STATES;


/***/ }),
/* 1538 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var LoadingStateHolder = (function () {
	    function LoadingStateHolder(states, _cdr) {
	        if (states === void 0) { states = []; }
	        this._cdr = _cdr;
	        this.states = [];
	        this.states = states;
	    }
	    LoadingStateHolder.prototype.start = function (name) {
	        var _this = this;
	        setTimeout(function () {
	            if (_this.states.indexOf(name) === -1) {
	                _this.states.push(name);
	            }
	            _this._cdr.markForCheck();
	        });
	    };
	    LoadingStateHolder.prototype.done = function (name) {
	        var _this = this;
	        setTimeout(function () {
	            if (_this.states.indexOf(name) > -1) {
	                _this.states.splice(_this.states.indexOf(name), 1);
	            }
	            _this._cdr.markForCheck();
	        });
	    };
	    LoadingStateHolder.prototype.set = function (name, loading) {
	        if (loading) {
	            this.start(name);
	        }
	        else {
	            this.done(name);
	        }
	    };
	    LoadingStateHolder.prototype.isBusy = function () {
	        return this.states.length > 0;
	    };
	    LoadingStateHolder.prototype.isBusyByStateName = function (name) {
	        return this.states.some(function (state) { return state === name; });
	    };
	    LoadingStateHolder.prototype.isBusyByStateNames = function () {
	        var names = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            names[_i] = arguments[_i];
	        }
	        return this.states.some(function (state) {
	            return names.some(function (name) { return name === state; });
	        });
	    };
	    return LoadingStateHolder;
	}());
	exports.LoadingStateHolder = LoadingStateHolder;


/***/ }),
/* 1539 */
/***/ (function(module, exports) {

	module.exports = "<loading-linear [loading]=\"loadingState.isBusy()\"></loading-linear>\n<div class=\"setting-tab-content\">\n    <tfl-profile-detail-business-customer-information\n            [loading]=\"loadingState.isBusy()\"\n            [profileId]=\"profileId\"\n            [businessCustomerInformation]=\"businessCustomerInformation\">\n    </tfl-profile-detail-business-customer-information>\n    <tfl-profile-detail-registered-office-address\n            [loading]=\"loadingState.isBusy()\"\n            [profileId]=\"profileId\"\n            [countries]=\"countries\"\n            [registeredOfficeAddress]=\"registeredOfficeAddress\">\n    </tfl-profile-detail-registered-office-address>\n    <tfl-profile-detail-official-business-location\n            [loading]=\"loadingState.isBusy()\"\n            [profileId]=\"profileId\"\n            [countries]=\"countries\"\n            [officialBusinessLocation]=\"officialBusinessLocation\">\n    </tfl-profile-detail-official-business-location>\n    <tfl-profile-detail-contact-information\n            [loading]=\"loadingState.isBusy()\"\n            [profileId]=\"profileId\"\n            [contactInformation]=\"contactInformation\">\n    </tfl-profile-detail-contact-information>\n    <tfl-profile-detail-statement-affairs\n            [loading]=\"loadingState.isBusy()\"\n            [profileId]=\"profileId\"\n            [countries]=\"countries\"\n            [statementAffairs]=\"statementAffairs\">\n    </tfl-profile-detail-statement-affairs>\n    <tfl-profile-detail-initial-deposits\n            [loading]=\"loadingState.isBusy()\"\n            [profileId]=\"profileId\"\n            [countries]=\"countries\"\n            [currencies]=\"currencies\"\n            [initialDeposits]=\"initialDeposits\">\n    </tfl-profile-detail-initial-deposits>\n    <tfl-profile-detail-expected-turnover\n            [loading]=\"loadingState.isBusy()\"\n            [profileId]=\"profileId\"\n            [countries]=\"countries\"\n            [expectedTurnover]=\"expectedTurnover\"\n            [systemOrWL]=\"getSystemOrWLName()\">\n    </tfl-profile-detail-expected-turnover>\n    <tfl-profile-detail-authorized-signatory\n            [loading]=\"loadingState.isBusy()\"\n            [profileId]=\"profileId\"\n            [countries]=\"countries\"\n            [authorizedSignatory]=\"authorisedSignatory\">\n    </tfl-profile-detail-authorized-signatory>\n    <tfl-profile-detail-directors\n            [loading]=\"loadingState.isBusy()\"\n            [profileId]=\"profileId\"\n            [countries]=\"countries\"\n            [directors]=\"directors\">\n    </tfl-profile-detail-directors>\n    <tfl-profile-detail-shareholders\n            [loading]=\"loadingState.isBusy()\"\n            [profileId]=\"profileId\"\n            [countries]=\"countries\"\n            [shareholders]=\"shareholders\">\n    </tfl-profile-detail-shareholders>\n    <tfl-profile-detail-introducer\n            [loading]=\"loadingState.isBusy()\"\n            [profileId]=\"profileId\"\n            [introducer]=\"introducer\">\n    </tfl-profile-detail-introducer>\n    <tfl-profile-detail-usage-referral\n            [loading]=\"loadingState.isBusy()\"\n            [profileId]=\"profileId\"\n            [usageReferral]=\"usageReferral\">\n    </tfl-profile-detail-usage-referral>\n</div>\n"

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

	module.exports = "<tfl-panel-details caption=\"APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.TITLE\">\n    <tfl-edit-button-group\n        [isSaveDisabled]=\"isSaveBtnDisabled()\"\n        (edit)=\"onEdit()\"\n        (save)=\"onSave()\"\n        (discard)=\"onDiscard()\"\n    >\n    </tfl-edit-button-group>\n\n    <form class=\"form-horizontal\" novalidate>\n        <div *ngIf=\"!loading && businessCustomerInformation && !isEdited\">\n            <div class=\"row\">\n                <div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\">\n                    <div class=\"form-group\">\n                        <label class=\"control-label col-sm-6 col-xs-12\">\n                            {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.COMPANY_NAME'|translate }}\n                        </label>\n                        <div class=\"col-sm-6 col-xs-12 control-container\">\n                            <span id=\"entity-name\">{{ businessCustomerInformation.entityName }}</span>\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"control-label col-sm-6 col-xs-12\">\n                            {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.DATE_OF_REGISTRATION'|translate }}\n                        </label>\n                        <div class=\"col-sm-6 col-xs-12 control-container\">\n                            <span id=\"registration-date\">{{ businessCustomerInformation.registrationDate }}</span>\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"control-label col-sm-6 col-xs-12\">\n                            {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.TRADING_NAME'|translate }}\n                        </label>\n                        <div class=\"col-sm-6 col-xs-12 control-container\">\n                            <span id=\"trading-name\">{{ businessCustomerInformation.tradingName }}</span>\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"control-label col-sm-6 col-xs-12\">\n                            {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.REGISTRATION_NUMBER'|translate }}\n                        </label>\n                        <div class=\"col-sm-6 col-xs-12 control-container\">\n                            <span id=\"registration-number\">{{ businessCustomerInformation.registrationNumber }}</span>\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"control-label col-sm-6 col-xs-12\">\n                            {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.TAX_IDENTIFICATION_NUMBER'|translate }}\n                        </label>\n                        <div class=\"col-sm-6 col-xs-12 control-container\">\n                            <span\n                                id=\"tax-identification-number\">{{ businessCustomerInformation.taxIdentificationNumber }}</span>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\">\n                    <div class=\"form-group\">\n                        <label class=\"control-label col-sm-6 col-xs-12\">\n                            {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.USER_EMAIL'|translate }}\n                        </label>\n                        <div class=\"col-sm-6 col-xs-12 control-container\">\n                            <span id=\"user-email\">{{ businessCustomerInformation.userEmail }}</span>\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"control-label col-sm-6 col-xs-12\">\n                            {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.COMPANY_PHONE'|translate }}\n                        </label>\n                        <div class=\"col-sm-6 col-xs-12 control-container\">\n                            <span\n                                id=\"company-signatory-phone\">{{ businessCustomerInformation.companySignatoryPhone }}</span>\n                        </div>\n                    </div>\n\n\n                    <div class=\"form-group\">\n                        <label class=\"control-label col-sm-6 col-xs-12\">\n                            {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.IP_ADDRESS'|translate }}\n                        </label>\n                        <div class=\"col-sm-6 col-xs-12 control-container\">\n                            <span\n                                id=\"ip-address\">{{ businessCustomerInformation.ipAddress }}</span>\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"control-label col-sm-6 col-xs-12\">\n                            {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.IP_COUNTRY'|translate }}\n                        </label>\n                        <div class=\"col-sm-6 col-xs-12 control-container\">\n                            <span\n                                id=\"ip-country\">{{ businessCustomerInformation.ipCountry }}</span>\n                        </div>\n                    </div>\n\n\n                    <div class=\"form-group\">\n                        <label class=\"control-label col-sm-6 col-xs-12\">\n                            {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.BUSINESS_ACTIVITIES'|translate }}\n                        </label>\n                        <div class=\"col-sm-6 col-xs-12 control-container\">\n                            <span *ngFor=\"let category of getBusinessTypeCategories()\">\n                                <div id=\"business-activities\">{{ category.code }} {{ category.name }}</div>\n                            </span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"row files-header\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                    <h4 *ngIf=\"businessCustomerInformation.profileStatus === 'N'\"\n                        class=\"pending-accounts-subtitle pull-left\">\n                        {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.LEGAL_DOCUMENTS_VERIFY'|translate }}\n                    </h4>\n                    <h4 *ngIf=\"businessCustomerInformation.profileStatus !== 'N'\"\n                        class=\"pending-accounts-subtitle pull-left\">\n                        {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.LEGAL_DOCUMENTS'|translate }}\n                    </h4>\n                    <button *ngIf=\"businessCustomerInformation.legalDocuments.length > 1\"\n                            (click)=\"downloadFiles()\"\n                            class=\"btn save-all-files-button pull-right\">\n                        {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.SAVE_ALL.BUTTON.NAME'|translate }}\n                    </button>\n                    <div class=\"clearfix\"></div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                    <div class=\"file-names\">\n                        <div *ngFor=\"let file of businessCustomerInformation.legalDocuments\"\n                             class=\"file-name\">\n                            <div class=\"row\">\n                                <div class=\"col-lg-1 col-md-1 col-sm-1 col-xs-1\">\n                                    <input class=\"form-check-input\"\n                                           type=\"checkbox\"\n                                           id=\"switch{{file.idDb}}\"\n                                           (change)=\"updateDocStatus(file.idDb, $event)\"\n                                           [checked]=\"file.kybStatus\"\n                                           [disabled]=\"businessCustomerInformation.profileStatus !== 'N'\">\n                                    <label class=\"custom-control-label\" for=\"switch{{file.id}}\"></label>\n                                </div>\n                                <div class=\"col-lg-10 col-md-10 col-sm-10 col-xs-10\" (click)=\"downloadFile(file.id)\">\n                                    <i class=\"fa fa-file fa-lg\"></i>\n                                    <span>{{ file.name }}</span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </form>\n\n    <form class=\"form-horizontal\">\n        <div *ngIf=\"!loading && businessCustomerInformation && isEdited\">\n            <div class=\"row editing\">\n                <div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\">\n                    <div [ngClass]=\"{'has-error': isInvalid(CONTROL.ENTITY_NAME)}\" class=\"form-group\"\n                         [formGroup]=\"form\">\n                        <label class=\"control-label col-sm-6 col-xs-12\">\n                            {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.COMPANY_NAME'|translate }}\n                        </label>\n                        <div class=\"col-sm-6 col-xs-12 control-container\">\n                            <input id=\"entity-name-input\"\n                                   title=\"{{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.COMPANY_NAME'|translate}}\"\n                                   class=\"form-control\"\n                                   [name]=\"CONTROL.ENTITY_NAME\"\n                                   trim=\"blur\"\n                                   maxlength=\"50\"\n                                   required\n                                   (input)=\"onChangeInputValue($event, 'entityName')\"\n                                   [formControlName]=\"CONTROL.ENTITY_NAME\"/>\n                            <p *ngIf=\"hasError(CONTROL.ENTITY_NAME, 'required')\"\n                               class=\"text-danger\">\n                                {{ 'VALIDATION.REQUIRED'|translate }}\n                            </p>\n                        </div>\n                    </div>\n                    <div [ngClass]=\"{'has-error': isRegistrationDateInvalid()}\" class=\"form-group\" [formGroup]=\"form\">\n                        <label class=\"control-label col-sm-6 col-xs-12\">\n                            {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.DATE_OF_REGISTRATION'|translate }}\n                        </label>\n                        <div class=\"col-sm-6 col-xs-12 control-container\">\n                            <div style=\"position:relative\">\n                                <div id=\"filter-account-opening-period\"\n                                     class=\"input-group\"\n                                     style=\"margin-bottom: unset;\"\n                                     daterangepicker\n                                     (selected)=\"onDateSelect($event)\">\n                                    <input class=\"form-control\"\n                                           [name]=\"CONTROL.REGISTRATION_DATE\"\n                                           required\n                                           title=\"{{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.DATE_OF_REGISTRATION'|translate}}\"\n                                           [formControlName]=\"CONTROL.REGISTRATION_DATE\"\n                                           #registrationDate\n                                           (change)=\"onDateChange(registrationDate.value)\">\n                                    <span class=\"input-group-btn\">\n                                         <a type=\"button\" class=\"btn btn-default calendar-button\">\n                                             <i class=\"fa fa-calendar\"></i></a></span>\n                                </div>\n                                <p *ngIf=\"isRegistrationDateInvalid()\"\n                                   class=\"text-danger\">\n                                    {{ 'VALIDATION.REQUIRED'|translate }}\n                                </p>\n                            </div>\n                        </div>\n                    </div>\n                    <div [ngClass]=\"{'has-error': isInvalid(CONTROL.TRADING_NAME)}\" class=\"form-group\"\n                         [formGroup]=\"form\">\n                        <label class=\"control-label col-sm-6 col-xs-12\">\n                            {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.TRADING_NAME'|translate }}\n                        </label>\n                        <div class=\"col-sm-6 col-xs-12 control-container\">\n                            <div style=\"position:relative\">\n                                <input id=\"trading-name-input\"\n                                       title=\"{{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.TRADING_NAME'|translate}}\"\n                                       class=\"form-control\"\n                                       [name]=\"CONTROL.TRADING_NAME\"\n                                       trim=\"blur\"\n                                       minlength=\"3\"\n                                       maxlength=\"100\"\n                                       [valuePattern]=\"TRADING_NAME_PATTERN\"\n                                       (input)=\"onChangeInputValue($event, 'tradingName')\"\n                                       [formGroup]=\"form\"\n                                       [formControlName]=\"CONTROL.TRADING_NAME\"\n                                       [controlName]=\"CONTROL.TRADING_NAME\"/>\n                                <p *ngIf=\"hasError(CONTROL.TRADING_NAME, 'minlength')\"\n                                   class=\"text-danger\">\n                                    {{ 'VALIDATION.MIN_LENGTH' | translate : {value: 3} }}\n                                </p>\n                            </div>\n                        </div>\n                    </div>\n                    <div [ngClass]=\"{'has-error': isInvalid(CONTROL.COMPANY_SIGNATORY_PHONE)}\" class=\"form-group\"\n                         [formGroup]=\"form\">\n                        <label class=\"control-label col-sm-6 col-xs-12\">\n                            {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.COMPANY_PHONE'|translate }}\n                        </label>\n                        <div class=\"col-sm-6 col-xs-12 control-container\">\n                            <input id=\"company-signatory-phone-input\"\n                                   title=\"{{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.COMPANY_PHONE'|translate}}\"\n                                   class=\"form-control\"\n                                   [name]=\"CONTROL.COMPANY_SIGNATORY_PHONE\"\n                                   trim=\"blur\"\n                                   required\n                                   maxlength=\"50\"\n                                   (input)=\"onChangeInputValue($event, 'companySignatoryPhone')\"\n                                   [formControlName]=\"CONTROL.COMPANY_SIGNATORY_PHONE\"/>\n                            <p *ngIf=\"hasError(CONTROL.COMPANY_SIGNATORY_PHONE, 'required')\"\n                               class=\"text-danger\">\n                                {{ 'VALIDATION.REQUIRED'|translate }}\n                            </p>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\">\n                    <div [ngClass]=\"{'has-error': isInvalid(CONTROL.REGISTRATION_NUMBER)}\" class=\"form-group\"\n                         [formGroup]=\"form\">\n                        <label class=\"control-label col-sm-6 col-xs-12\">\n                            {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.REGISTRATION_NUMBER'|translate }}\n                        </label>\n                        <div class=\"col-sm-6 col-xs-12 control-container\">\n                            <input id=\"registration-number-input\"\n                                   title=\"{{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.REGISTRATION_NUMBER'|translate}}\"\n                                   class=\"form-control\"\n                                   [name]=\"CONTROL.REGISTRATION_NUMBER\"\n                                   trim=\"blur\"\n                                   required\n                                   maxlength=\"50\"\n                                   (input)=\"onChangeInputValue($event, 'registrationNumber')\"\n                                   [formControlName]=\"CONTROL.REGISTRATION_NUMBER\"/>\n                            <p *ngIf=\"hasError(CONTROL.REGISTRATION_NUMBER, 'required')\"\n                               class=\"text-danger\">\n                                {{ 'VALIDATION.REQUIRED'|translate }}\n                            </p>\n                        </div>\n                    </div>\n                    <div class=\"form-group\" [formGroup]=\"form\">\n                        <label class=\"control-label col-sm-6 col-xs-12\">\n                            {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.TAX_IDENTIFICATION_NUMBER'|translate }}\n                        </label>\n                        <div class=\"col-sm-6 col-xs-12 control-container\">\n                            <input id=\"tax-identification-number-input\"\n                                   title=\"{{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.TAX_IDENTIFICATION_NUMBER'|translate}}\"\n                                   class=\"form-control\"\n                                   [name]=\"CONTROL.TAX_IDENTIFICATION_NUMBER\"\n                                   trim=\"blur\"\n                                   [valuePattern]=\"TAX_IDENTIFICATION_NUMBER_PATTERN\"\n                                   (input)=\"onChangeInputValue($event, 'taxIdentificationNumber')\"\n                                   [formGroup]=\"form\"\n                                   [formControlName]=\"CONTROL.TAX_IDENTIFICATION_NUMBER\"\n                                   [controlName]=\"CONTROL.TAX_IDENTIFICATION_NUMBER\"/>\n                            <!--                            <p *ngIf=\"hasError(CONTROL.TAX_IDENTIFICATION_NUMBER, 'required')\"-->\n                            <!--                               class=\"text-danger\">-->\n                            <!--                                {{'VALIDATION.REQUIRED'|translate}}-->\n                            <!--                            </p>-->\n                            <!--                            <p *ngIf=\"hasError(CONTROL.TAX_IDENTIFICATION_NUMBER, 'minlength')\"-->\n                            <!--                               class=\"text-danger\">-->\n                            <!--                                {{ 'VALIDATION.MIN_LENGTH'| translate: {value: 3} }}-->\n                            <!--                            </p>-->\n                        </div>\n                    </div>\n                    <div [ngClass]=\"{'has-error': !isEmailValid(CONTROL.USER_EMAIL)}\" class=\"form-group\"\n                         [formGroup]=\"form\">\n                        <label class=\"control-label col-sm-6 col-xs-12\">\n                            {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.USER_EMAIL'|translate }}\n                        </label>\n                        <div class=\"col-sm-6 col-xs-12 control-container\">\n                            <input id=\"user-email-input\"\n                                   title=\"{{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.USER_EMAIL'|translate}}\"\n                                   class=\"form-control\"\n                                   [name]=\"CONTROL.USER_EMAIL\"\n                                   trim=\"blur\"\n                                   maxlength=\"50\"\n                                   (input)=\"onChangeInputValue($event, 'userEmail')\"\n                                   [formGroup]=\"form\"\n                                   [formControlName]=\"CONTROL.USER_EMAIL\"\n                                   [controlName]=\"CONTROL.USER_EMAIL\"/>\n                            <!--                            <p *ngIf=\"hasError(CONTROL.USER_EMAIL, 'required')\"-->\n                            <!--                               class=\"text-danger\">-->\n                            <!--                                {{'VALIDATION.REQUIRED'|translate}}-->\n                            <!--                            </p>-->\n                            <p *ngIf=\"!isEmailValid(CONTROL.USER_EMAIL)\"\n                               class=\"text-danger\">\n                                {{ 'CUSTOMER.DETAILS.TAB.DETAILS.CORPORATE.COMMON.INVALID_VALUE'|translate }}\n                            </p>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"col-xs-12\">\n                    <div [ngClass]=\"{'has-error': isBusinessCategoriesInvalid()}\" class=\"form-group\" [formGroup]=\"form\">\n                        <label class=\"control-label col-sm-3 col-xs-12\">\n                            {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.BUSINESS_ACTIVITIES'|translate }}\n                        </label>\n                        <div class=\"col-sm-8 col-xs-12 control-container\">\n                            <div class=\"row\" [formGroup]=\"form\">\n                                <tfl-business-category-container class=\"col-sm-12\"\n                                                                 [form]=\"form\"\n                                                                 [controlName]=\"CONTROL.BUSINESS_CATEGORIES\"\n                                                                 [formControlName]=\"CONTROL.BUSINESS_CATEGORIES\">\n                                </tfl-business-category-container>\n                                <tfl-filtered-tree-view class=\"col-sm-11\"\n                                                        [filterControl]=\"CONTROL.BUSINESS_CATEGORY_FILTER\"\n                                                        [resultListControl]=\"CONTROL.BUSINESS_CATEGORIES_RESULT_LIST\"\n                                                        [form]=\"form\"\n                                                        [businessCategoriesList]=\"sourceData\"\n                                                        [placeholder]=\"'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.BUSINESS_CUSTOMER_INFORMATION.SEARCH_BUSINESS_ACTIVITIES' | translate\"\n                                                        [searchTimeOut]=\"700\"\n                                ></tfl-filtered-tree-view>\n                            </div>\n                        </div>\n                    </div>\n\n                </div>\n            </div>\n\n\n            <div class=\"row files-header editing\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                    <h4 class=\"pending-accounts-subtitle pull-left\">\n                        {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.LEGAL_DOCUMENTS'|translate }}\n                    </h4>\n                    <button type=\"button\"\n                            (click)=\"uploadFiles($event)\"\n                            class=\"btn upload-files-button pull-right\">\n                        {{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.UPLOAD.BUTTON.NAME'|translate }}\n                    </button>\n                    <div class=\"clearfix\"></div>\n                </div>\n            </div>\n            <div class=\"row editing\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                    <!--                    <div *ngIf=\"businessCustomerInformation.legalDocuments.length === 0\"-->\n                    <!--                         class=\"has-error\">-->\n                    <!--                        <b>{{ 'COMMON.VALIDATION.REQUIRED' | translate }}</b>-->\n                    <!--                    </div>-->\n                    <div class=\"file-names\">\n                        <div *ngFor=\"let file of businessCustomerInformation.legalDocuments\"\n                             class=\"file-name\">\n                            <i class=\"fa fa-file fa-lg\"></i>\n                            <span>{{ file.name }}</span>\n                            <i (click)=\"removeFile(file.id)\" class=\"fa fa-trash fa-lg remove-file-btn\"></i>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </form>\n</tfl-panel-details>\n<tfl-file-upload-modal\n    (saveButtonAction)=\"saveFiles($event)\"\n    [fileUploadModalId]=\"businessCustomerLegalDocumentsId\"\n    [attachmentType]=\"attachmentType\"\n>\n</tfl-file-upload-modal>\n"

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1542));


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var lodash_1 = __webpack_require__(268);
	var service_1 = __webpack_require__(1332);
	var forms_1 = __webpack_require__(768);
	var util_1 = __webpack_require__(743);
	var corporate_1 = __webpack_require__(1543);
	var file_upload_modal_component_1 = __webpack_require__(1504);
	var api_1 = __webpack_require__(1406);
	var utils_1 = __webpack_require__(740);
	var value_by_key_pipe_1 = __webpack_require__(1087);
	var OfficialBusinessLocationComponent = (function () {
	    function OfficialBusinessLocationComponent(_corporateAccountsService, _fileDownloadService, _valueByKeyPipe) {
	        this._corporateAccountsService = _corporateAccountsService;
	        this._fileDownloadService = _fileDownloadService;
	        this._valueByKeyPipe = _valueByKeyPipe;
	        this.PATTERN = '^[a-zA-Z\\s.\'-]*$';
	        this.loading = true;
	        this.countries = [];
	        this.officialBusinessLocation = null;
	        this.originalOfficialBusinessLocation = null;
	        this.addressDocuments = "official-business-location-address-documents";
	        this.isEdited = false;
	        this.attachmentTypeAddress = api_1.AttachmentType.BUSINESS_ADDRESS;
	        this.companyCountries = [];
	    }
	    OfficialBusinessLocationComponent.prototype.ngOnInit = function () {
	        this.companyCountries = this.countries;
	        this.chosenTaxCountry = this._valueByKeyPipe.transform(this.countries);
	    };
	    Object.defineProperty(OfficialBusinessLocationComponent.prototype, "setOfficialBusinessLocation", {
	        set: function (officialBusinessLocation) {
	            if (!util_1.isNullOrUndefined(officialBusinessLocation)) {
	                this.officialBusinessLocation = officialBusinessLocation;
	                this.originalOfficialBusinessLocation = lodash_1.cloneDeep(this.officialBusinessLocation);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    OfficialBusinessLocationComponent.prototype.onChangeInputValue = function (event, fieldName) {
	        this.officialBusinessLocation[fieldName] = event.target.value;
	    };
	    OfficialBusinessLocationComponent.prototype.isAddressValid = function () {
	        return corporate_1.NewCorporateDetailsComponent.isAddressValid(this.officialBusinessLocation);
	    };
	    OfficialBusinessLocationComponent.prototype.onEdit = function () {
	        this.isEdited = true;
	    };
	    OfficialBusinessLocationComponent.prototype.onDiscard = function () {
	        this.officialBusinessLocation = lodash_1.cloneDeep(this.originalOfficialBusinessLocation);
	        this.isEdited = false;
	    };
	    OfficialBusinessLocationComponent.prototype.onSave = function () {
	        var _this = this;
	        this._corporateAccountsService.updateOfficialBusinessLocation(this.profileId, this.officialBusinessLocation)
	            .subscribe(function (officialBusinessLocation) { return _this.officialBusinessLocation = lodash_1.cloneDeep(officialBusinessLocation); });
	        this.isEdited = false;
	    };
	    OfficialBusinessLocationComponent.prototype.uploadAddressFiles = function () {
	        this.addressFilesModalComponent.show();
	    };
	    OfficialBusinessLocationComponent.prototype.removeAddressFile = function (id) {
	        this.editForm.controls.address.markAsDirty();
	        this.officialBusinessLocation.attachmentItems =
	            this.officialBusinessLocation.attachmentItems.filter(function (doc) { return id !== doc.id; });
	    };
	    OfficialBusinessLocationComponent.prototype.saveAddressFiles = function (files) {
	        var _this = this;
	        this.editForm.controls.address.markAsDirty();
	        files.filter(function (file) { return _this.officialBusinessLocation.attachmentItems.findIndex(function (f) { return f.name == file.name; }) == -1; })
	            .forEach(function (file) { return _this.officialBusinessLocation.attachmentItems.push(file); });
	    };
	    OfficialBusinessLocationComponent.prototype.downloadAddressAttachments = function () {
	        var ids = [];
	        var fileName = 'proof_of_address';
	        this.officialBusinessLocation.attachmentItems.map(function (item) { return ids.push(item.id); });
	        this._fileDownloadService.downloadAttachmentsFile(ids, fileName)
	            .subscribe(function (response) {
	            utils_1.FileUtils.saveFile(utils_1.FileUtils.getFilename(response), response.blob());
	        });
	    };
	    OfficialBusinessLocationComponent.prototype.downloadFile = function (id) {
	        this._fileDownloadService.downloadFile(id)
	            .subscribe(function (response) {
	            utils_1.FileUtils.saveFile(utils_1.FileUtils.getFilename(response), response.blob());
	        });
	    };
	    OfficialBusinessLocationComponent.prototype.isAttachmentsValid = function () {
	        return !util_1.isNullOrUndefined(this.officialBusinessLocation)
	            && !util_1.isNullOrUndefined(this.officialBusinessLocation.attachmentItems)
	            && this.officialBusinessLocation.attachmentItems.length != 0;
	    };
	    OfficialBusinessLocationComponent.prototype.isSaveDisabled = function () {
	        if (!util_1.isNullOrUndefined(this.officialBusinessLocation)) {
	            return !(this.editForm.form.dirty || this.originalOfficialBusinessLocation.country != this.officialBusinessLocation.country)
	                || !this.editForm.form.valid || !this.isAddressValid() || !this.isAttachmentsValid();
	        }
	    };
	    OfficialBusinessLocationComponent.prototype.onSearchCountry = function (companyCountry) {
	        this.companyCountries = this.countries.filter(function (country) { return country.name.toLocaleLowerCase().search(companyCountry.toLocaleLowerCase()) !== -1; });
	    };
	    OfficialBusinessLocationComponent.prototype.onSelectCountry = function (companyCountry) {
	        if (companyCountry) {
	            this.officialBusinessLocation.country = companyCountry.id;
	        }
	    };
	    __decorate([
	        core_1.Input("profileId"),
	        __metadata("design:type", Number)
	    ], OfficialBusinessLocationComponent.prototype, "profileId", void 0);
	    __decorate([
	        core_1.Input("loading"),
	        __metadata("design:type", Boolean)
	    ], OfficialBusinessLocationComponent.prototype, "loading", void 0);
	    __decorate([
	        core_1.Input("countries"),
	        __metadata("design:type", Array)
	    ], OfficialBusinessLocationComponent.prototype, "countries", void 0);
	    __decorate([
	        core_1.ViewChild("editForm"),
	        __metadata("design:type", forms_1.NgForm)
	    ], OfficialBusinessLocationComponent.prototype, "editForm", void 0);
	    __decorate([
	        core_1.ViewChild("addressFiles"),
	        __metadata("design:type", file_upload_modal_component_1.FileUploadModalComponent)
	    ], OfficialBusinessLocationComponent.prototype, "addressFilesModalComponent", void 0);
	    __decorate([
	        core_1.Input("officialBusinessLocation"),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [Object])
	    ], OfficialBusinessLocationComponent.prototype, "setOfficialBusinessLocation", null);
	    OfficialBusinessLocationComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-profile-detail-official-business-location',
	            template: __webpack_require__(1544),
	            providers: [value_by_key_pipe_1.ValueByKeyPipe]
	        }),
	        __metadata("design:paramtypes", [service_1.CorporateAccountsService,
	            service_1.FileDownloadService,
	            value_by_key_pipe_1.ValueByKeyPipe])
	    ], OfficialBusinessLocationComponent);
	    return OfficialBusinessLocationComponent;
	}());
	exports.OfficialBusinessLocationComponent = OfficialBusinessLocationComponent;


/***/ }),
/* 1543 */
[3024, 1536],
/* 1544 */
/***/ (function(module, exports) {

	module.exports = "<tfl-panel-details caption=\"APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.OFFICIAL_BUSINESS_LOCATION.TITLE\">\n    <tfl-edit-button-group\n            [isSaveDisabled]=\"isSaveDisabled()\"\n            (edit)=\"onEdit()\"\n            (save)=\"onSave()\"\n            (discard)=\"onDiscard()\">\n    </tfl-edit-button-group>\n\n    <form class=\"form-horizontal\" novalidate>\n        <div class=\"row\" *ngIf=\"!loading && officialBusinessLocation && !isEdited\">\n            <div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\">\n                <div class=\"form-group\">\n                    <label class=\"control-label col-sm-6 col-xs-12\">\n                        {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.ADDRESS_LINE'|translate}}\n                    </label>\n                    <div class=\"col-sm-6 col-xs-12 control-container\">\n                        <span id=\"company-address\">{{officialBusinessLocation.address}}</span>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label col-sm-6 col-xs-12\">\n                        {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.CITY'|translate}}\n                    </label>\n                    <div class=\"col-sm-6 col-xs-12 control-container\">\n                        <span id=\"company-city\">{{officialBusinessLocation.city}}</span>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label col-sm-6 col-xs-12\">\n                        {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.COUNTY_REGION'|translate}}\n                    </label>\n                    <div class=\"col-sm-6 col-xs-12 control-container\">\n                        <span id=\"company-county-or-region\">{{officialBusinessLocation.countyOrRegion}}</span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\">\n                <div class=\"form-group\">\n                    <label class=\"control-label col-sm-6 col-xs-12\">\n                        {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.ZIP_CODE'|translate}}\n                    </label>\n                    <div class=\"col-sm-6 col-xs-12 control-container\">\n                        <span id=\"company-zip-code\">{{officialBusinessLocation.zipCode}}</span>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label col-sm-6 col-xs-12\">\n                        {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.COUNTRY'|translate}}\n                    </label>\n                    <div class=\"col-sm-6 col-xs-12 control-container\">\n                        <span id=\"company-country\">{{officialBusinessLocation.country|value_by_key:countries}}</span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"files-header\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                    <h4 class=\"pending-accounts-subtitle pull-left\">\n                        {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.OFFICIAL_BUSINESS_LOCATION.PROOF_OF_ADDRESS'|translate}}\n                    </h4>\n                    <button *ngIf=\"officialBusinessLocation.attachmentItems.length > 1\"\n                            (click)=\"downloadAddressAttachments()\"\n                            class=\"btn save-all-files-button pull-right\">\n                        {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.SAVE_ALL.BUTTON.NAME'|translate}}\n                    </button>\n                    <div class=\"clearfix\"></div>\n                </div>\n            </div>\n            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                <div class=\"file-names\">\n                    <div *ngFor=\"let file of officialBusinessLocation.attachmentItems\"\n                         class=\"file-name\">\n                        <div (click)=\"downloadFile(file.id)\">\n                            <i class=\"fa fa-file fa-lg\"></i>\n                            <span>{{file.name}}</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </form>\n    <form class=\"form-horizontal\" #editForm=\"ngForm\" autocomplete=\"off\">\n        <div class=\"row editing\" *ngIf=\"!loading && officialBusinessLocation && isEdited\">\n            <div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\">\n                <div class=\"form-group\">\n                    <label class=\"control-label col-sm-6 col-xs-12\">\n                        {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.ADDRESS_LINE'|translate}}\n                    </label>\n                    <div class=\"col-sm-6 col-xs-12 control-container\">\n                        <input id=\"company-address-input\"\n                               title=\"{{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.ADDRESS_LINE'|translate}}\"\n                               class=\"form-control\"\n                               name=\"address\"\n                               required\n                               trim=\"blur\"\n                               minlength=\"5\"\n                               maxlength=\"150\"\n                               (input)=\"onChangeInputValue($event, 'address')\"\n                               [(ngModel)]=\"officialBusinessLocation.address\"/>\n                        <field-validator for=\"address\">\n                            <message type=\"required\">{{ 'VALIDATION.REQUIRED' | translate }}</message>\n                            <message type=\"minlength\">\n                                {{ 'VALIDATION.MIN_LENGTH' | translate:{value: 5} }}\n                            </message>\n                            <message type=\"maxlength\">\n                                {{ 'REGISTRATION.ERRORS.MAX_LENGTH'|translate:{value: 150} }}\n                            </message>\n                        </field-validator>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label col-sm-6 col-xs-12\">\n                        {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.CITY'|translate}}\n                    </label>\n                    <div class=\"col-sm-6 col-xs-12 control-container\">\n                        <input id=\"company-city-input\"\n                               title=\"{{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.CITY'|translate}}\"\n                               class=\"form-control\"\n                               name=\"city\"\n                               required\n                               trim=\"blur\"\n                               maxlength=\"50\"\n                               (input)=\"onChangeInputValue($event, 'city')\"\n                               [(ngModel)]=\"officialBusinessLocation.city\"/>\n                        <field-validator for=\"city\">\n                            <message type=\"required\">{{ 'VALIDATION.REQUIRED' | translate }}</message>\n                            <message type=\"maxlength\">\n                                {{ 'REGISTRATION.ERRORS.MAX_LENGTH'|translate:{value: 50} }}\n                            </message>\n                        </field-validator>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label col-sm-6 col-xs-12\">\n                        {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.COUNTY_REGION'|translate}}\n                    </label>\n                    <div class=\"col-sm-6 col-xs-12 control-container\">\n                        <input id=\"company-county-or-region-input\"\n                               title=\"{{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.COUNTY_REGION'|translate}}\"\n                               class=\"form-control\"\n                               name=\"countyOrRegion\"\n                               trim=\"blur\"\n                               maxlength=\"50\"\n                               (input)=\"onChangeInputValue($event, 'countyOrRegion')\"\n                               [(ngModel)]=\"officialBusinessLocation.countyOrRegion\"/>\n                        <field-validator for=\"countyOrRegion\">\n                            <message type=\"maxlength\">\n                                {{ 'REGISTRATION.ERRORS.MAX_LENGTH'|translate:{value: 50} }}\n                            </message>\n                        </field-validator>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\">\n                <div class=\"form-group\">\n                    <label class=\"control-label col-sm-6 col-xs-12\">\n                        {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.ZIP_CODE'|translate}}\n                    </label>\n                    <div class=\"col-sm-6 col-xs-12 control-container\">\n                        <input id=\"company-zip-code-input\"\n                               title=\"{{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.ZIP_CODE'|translate}}\"\n                               class=\"form-control\"\n                               name=\"companyZipCode\"\n                               trim=\"blur\"\n                               required\n                               maxlength=\"50\"\n                               (input)=\"onChangeInputValue($event, 'zipCode')\"\n                               [(ngModel)]=\"officialBusinessLocation.zipCode\"/>\n                        <field-validator for=\"companyZipCode\">\n                            <message type=\"required\">{{ 'VALIDATION.REQUIRED' | translate }}</message>\n                            <message type=\"maxlength\">\n                                {{ 'REGISTRATION.ERRORS.MAX_LENGTH'|translate:{value: 50} }}\n                            </message>\n                        </field-validator>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"control-label col-sm-6 col-xs-12\">\n                        {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.COUNTRY'|translate}}\n                    </label>\n                    <div class=\"col-sm-6 col-xs-12 control-container\">\n                        <tfl-bo-combo-search name=\"companyCountry\"\n                                             class=\"tfl-form-control\"\n                                             nameDescription=\"name\"\n                                             [isFirstLetter]=\"true\"\n                                             [restrictForbiddenCharInput] = \"PATTERN\"\n                                             [placeHolder]=\"officialBusinessLocation.country|value_by_key:countries \"\n                                             emptySearchResultText=\"{{ 'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.COMMON.RESULT_COUNTRY_SELECT' | translate }}\"\n                                             [items]=\"companyCountries\"\n                                             [(ngModel)]=\"chosenTaxCountry\"\n                                             searchTimeout=\"700\"\n                                             (searchText)=\"onSearchCountry($event)\"\n                                             (ngModelChange)=\"onSelectCountry($event)\">\n                        </tfl-bo-combo-search>\n<!--                        <p *ngIf=\"!officialBusinessLocation.country\" class=\"text-danger\">-->\n<!--                            {{'VALIDATION.REQUIRED'|translate}}-->\n<!--                        </p>-->\n                    </div>\n                </div>\n            </div>\n            <div class=\"files-header\">\n                <div class=\"col-xs-12\">\n                    <h4 class=\"pending-accounts-subtitle pull-left\">\n                        {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.OFFICIAL_BUSINESS_LOCATION.PROOF_OF_ADDRESS'|translate}}\n                    </h4>\n                    <button type=\"button\"\n                            (click)=\"uploadAddressFiles()\"\n                            class=\"btn upload-files-button pull-right\">\n                        {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.UPLOAD.BUTTON.NAME'|translate}}\n                    </button>\n                    <div class=\"clearfix\"></div>\n                </div>\n            </div>\n\n            <div class=\"col-xs-12\">\n<!--                <div *ngIf=\"officialBusinessLocation.attachmentItems.length === 0\"-->\n<!--                     class=\"has-error\">-->\n<!--                    <b>{{ 'COMMON.VALIDATION.REQUIRED' | translate }}</b>-->\n<!--                </div>-->\n                <div class=\"file-names\">\n                    <div *ngFor=\"let file of officialBusinessLocation.attachmentItems\"\n                         class=\"file-name\">\n                        <i class=\"fa fa-file fa-lg\"></i>\n                        <span>{{file.name}}</span>\n                        <i (click)=\"removeAddressFile(file.id)\"\n                           class=\"fa fa-trash fa-lg remove-file-btn\"></i>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </form>\n</tfl-panel-details>\n<tfl-file-upload-modal #addressFiles\n                       (saveButtonAction)=\"saveAddressFiles($event)\"\n                       [fileUploadModalId]=\"addressDocuments\"\n                       [attachmentType]=\"attachmentTypeAddress\">\n</tfl-file-upload-modal>\n"

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var router_1 = __webpack_require__(270);
	var lodash_1 = __webpack_require__(268);
	var index_1 = __webpack_require__(1157);
	var customer_profile_users_service_1 = __webpack_require__(1316);
	var notification_1 = __webpack_require__(264);
	var translate_1 = __webpack_require__(302);
	var option_dialog_1 = __webpack_require__(1317);
	var country_service_1 = __webpack_require__(1284);
	var security_1 = __webpack_require__(736);
	var STATE_CREATED_KEY = 'CUSTOMER.DETAILS.TAB.USERS.STATE.CREATED';
	var STATE_APPROVED_KEY = 'CUSTOMER.DETAILS.TAB.USERS.STATE.APPROVED';
	var STATE_DECLINED_KEY = 'CUSTOMER.DETAILS.TAB.USERS.STATE.DECLINED';
	var STATE_EDITED_KEY = 'CUSTOMER.DETAILS.TAB.USERS.STATE.EDITED';
	var DETAILS_SHOW_KEY = 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.SHOW_DETAILS';
	var DETAILS_HIDE_KEY = 'CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.HIDE_DETAILS';
	var USERS_KEYS = 'CUSTOMER.DETAILS.TAB.USERS.';
	// Same rule as the backend: something@domain.tld, no spaces
	var EMAIL_PATTERN = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
	var ProfileUsersComponent = (function () {
	    function ProfileUsersComponent(_navigation, _customerProfileUsersService, activatedRoute, router, _notificationManager, _translateManager, _countryService) {
	        this._navigation = _navigation;
	        this._customerProfileUsersService = _customerProfileUsersService;
	        this.activatedRoute = activatedRoute;
	        this.router = router;
	        this._notificationManager = _notificationManager;
	        this._translateManager = _translateManager;
	        this._countryService = _countryService;
	        this.usersTabRoute = security_1.CUSTOMER_USERS_TAB_ROUTE;
	        this.profileUsers = [];
	        this.DEFAULT_OPTION = 'undefined';
	        // A state change is in progress: blocks the menu action until the server answers
	        this.isBlocked = false;
	        this.loadError = null;
	        this.passwordCopied = false;
	        // Manual "create authorised user" dialog state
	        this.showManualDialog = false;
	        this.manualSubmitting = false;
	        this.currentDate = new Date();
	        this.countries = [];
	        this.manualCredentials = null;
	        this.manualUser = {
	            email: '', firstName: '', lastName: '', middleName: '', dateOfBirth: '', phone: '',
	            passportId: '', nationalityId: null, passportIssueDate: '', passportExpiryDate: '',
	            issueCountryId: null, issuePlace: ''
	        };
	        this.resetFilterModel();
	    }
	    ProfileUsersComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.activatedRoute.parent.params.subscribe(function (params) {
	            _this._profileId = +params['id'];
	            _this.searchProfileUsers();
	        });
	        this.fetchProfileUserStates();
	    };
	    ProfileUsersComponent.prototype.onChangeFilter = function (obj) {
	        this.searchProfileUsers();
	    };
	    ProfileUsersComponent.prototype.searchProfileUsers = function () {
	        var _this = this;
	        this.preventOfDefaultSelectTagOptionOrValues();
	        this.loadError = null;
	        this._customerProfileUsersService.getAllProfileUsers(this._profileId, this.filterModel)
	            .subscribe(function (response) {
	            _this.profileType = response.profileType;
	            _this.profileUsers = response.profileUsers || [];
	        }, function (error) { return _this.loadError = _this.errorMessage(error); });
	    };
	    ProfileUsersComponent.prototype.getActionProfileUserDetailText = function (showDetails) {
	        if (showDetails) {
	            return DETAILS_HIDE_KEY;
	        }
	        else {
	            return DETAILS_SHOW_KEY;
	        }
	    };
	    ProfileUsersComponent.prototype.newUser = function () {
	        var _this = this;
	        var addUser = function (email) {
	            email = (email || '').trim();
	            if (!EMAIL_PATTERN.test(email)) {
	                _this._notificationManager.error(_this._translateManager.getValue(USERS_KEYS + 'INVITE_EMAIL_INVALID'));
	                return;
	            }
	            return _this._customerProfileUsersService.addUser(email, _this._profileId)
	                .subscribe(function () {
	                _this._notificationManager.success(_this._translateManager.getValue(USERS_KEYS + 'INVITE_MESSAGE'), 5000);
	                _this.searchProfileUsers();
	            }, function (error) { return _this._notificationManager.error(_this.errorMessage(error)); });
	        };
	        var options = {
	            title: 'CUSTOMER.DETAILS.TAB.USERS.NEW.DIALOG.TITLE',
	            descriptionLines: [{ key: USERS_KEYS + 'NEW.DIALOG.MESSAGE' }],
	            confirmButtonText: 'CUSTOMER.DETAILS.TAB.USERS.NEW.DIALOG.BUTTONS.INVITE',
	            cancelButtonText: 'CUSTOMER.DETAILS.TAB.USERS.NEW.DIALOG.BUTTONS.CANCEL',
	            confirmButtonClass: 'btn-primary'
	        };
	        this.dialog
	            .showInputDialog(options, { minlength: 1, maxlength: 150 })
	            .onConfirmAction(function (email) { return addUser(email); });
	    };
	    ProfileUsersComponent.prototype.openManualUserDialog = function () {
	        var _this = this;
	        this.manualCredentials = null;
	        this.manualSubmitting = false;
	        this.passwordCopied = false;
	        this.manualUser = {
	            email: '', firstName: '', lastName: '', middleName: '', dateOfBirth: '', phone: '',
	            passportId: '', nationalityId: null, passportIssueDate: '', passportExpiryDate: '',
	            issueCountryId: null, issuePlace: ''
	        };
	        if (!this.countries || this.countries.length === 0) {
	            this._countryService.getCountries()
	                .subscribe(function (countries) { return _this.countries = countries || []; });
	        }
	        this.showManualDialog = true;
	    };
	    ProfileUsersComponent.prototype.closeManualUserDialog = function () {
	        this.showManualDialog = false;
	    };
	    ProfileUsersComponent.prototype.submitManualUser = function () {
	        var _this = this;
	        this.manualSubmitting = true;
	        this._customerProfileUsersService.createAuthorisedUserManually(this._profileId, this.manualUser)
	            .subscribe(function (credentials) {
	            _this.manualSubmitting = false;
	            _this.manualCredentials = credentials;
	            _this._notificationManager.success(_this._translateManager.getValue(USERS_KEYS + 'MANUAL.CREATED'), 5000);
	            _this.searchProfileUsers();
	        }, function (error) {
	            _this.manualSubmitting = false;
	            _this._notificationManager.error((error && error.message) || _this._translateManager.getValue(USERS_KEYS + 'MANUAL.CREATE_ERROR'));
	        });
	    };
	    ProfileUsersComponent.prototype.getNextUserStateText = function (userState) {
	        switch (userState) {
	            case 'Created':
	                return STATE_DECLINED_KEY;
	            case 'Approved':
	                return STATE_DECLINED_KEY;
	            case 'Declined':
	                return STATE_APPROVED_KEY;
	            case 'Edited':
	                return STATE_DECLINED_KEY;
	        }
	    };
	    ProfileUsersComponent.prototype.changeState = function (profileUser) {
	        var _this = this;
	        if (this.isBlocked) {
	            return;
	        }
	        var nextState = this._translateManager.getValue(this.getNextUserStateText(profileUser.state));
	        this.dialog
	            .showConfirmDialog({
	            title: USERS_KEYS + 'STATE_DIALOG.TITLE',
	            descriptionLines: [{
	                    key: USERS_KEYS + 'STATE_DIALOG.MESSAGE',
	                    params: { user: profileUser.userName, state: nextState }
	                }],
	            confirmButtonText: USERS_KEYS + 'CONFIRM',
	            cancelButtonText: USERS_KEYS + 'CANCEL',
	            confirmButtonClass: 'btn-primary'
	        })
	            .onConfirmAction(function () {
	            _this.isBlocked = true;
	            _this._customerProfileUsersService.changeProfileUserState(profileUser.id, _this.getStateIdFromName(profileUser.state))
	                .subscribe(function () {
	                _this.isBlocked = false;
	                _this._notificationManager.success(_this._translateManager.getValue('CUSTOMER.DETAILS.TAB.USERS.STATE.EDITED_MESSAGE'), true);
	                _this.searchProfileUsers();
	            }, function (error) {
	                _this.isBlocked = false;
	                _this._notificationManager.error(_this.errorMessage(error));
	            });
	        });
	    };
	    ProfileUsersComponent.prototype.copyPassword = function () {
	        if (!this.manualCredentials) {
	            return;
	        }
	        var field = document.createElement('textarea');
	        field.value = this.manualCredentials.password;
	        field.style.position = 'fixed';
	        field.style.opacity = '0';
	        document.body.appendChild(field);
	        field.select();
	        try {
	            this.passwordCopied = document.execCommand('copy');
	        }
	        finally {
	            document.body.removeChild(field);
	        }
	    };
	    ProfileUsersComponent.prototype.errorMessage = function (error) {
	        return (error && error.message) || this._translateManager.getValue(USERS_KEYS + 'ACTION_ERROR');
	    };
	    ProfileUsersComponent.prototype.getStateIdFromName = function (userState) {
	        switch (userState) {
	            case 'Created':
	                return '3';
	            case 'Approved':
	                return '3';
	            case 'Declined':
	                return '2';
	            case 'Edited':
	                return '3';
	        }
	    };
	    ProfileUsersComponent.prototype.fetchProfileUserStates = function () {
	        var _this = this;
	        this._customerProfileUsersService.getProfileStatesForRegisteredClients()
	            .subscribe(function (states) { return (_this.profileUserStates = states); });
	    };
	    ProfileUsersComponent.prototype.preventOfDefaultSelectTagOptionOrValues = function () {
	        var _this = this;
	        this.filterModel = Object.assign(this.filterModel, lodash_1.mapValues(this.filterModel, function (v) { return (String(v) === _this.DEFAULT_OPTION || String(v) === '') ? undefined : v; }));
	    };
	    ProfileUsersComponent.prototype.resetFilterModel = function () {
	        this.filterModel = Object.assign(this.filterModel || {}, {
	            userName: undefined,
	            userStateId: undefined
	        });
	    };
	    ProfileUsersComponent.prototype.currentUserStateClass = function (userState) {
	        switch (userState) {
	            case 'Created':
	                return 'user-created';
	            case 'Approved':
	                return 'user-approved';
	            case 'Declined':
	                return 'user-declined';
	            case 'Edited':
	                return 'user-edited';
	        }
	    };
	    ProfileUsersComponent.prototype.nextUserStateClass = function (userState) {
	        switch (userState) {
	            case 'Created':
	                return 'user-declined';
	            case 'Approved':
	                return 'user-declined';
	            case 'Declined':
	                return 'user-approved';
	            case 'Edited':
	                return 'user-declined';
	        }
	    };
	    __decorate([
	        option_dialog_1.InjectOptionDialog('new-user-dialog'),
	        __metadata("design:type", Object)
	    ], ProfileUsersComponent.prototype, "dialog", void 0);
	    ProfileUsersComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-profile-users-detail',
	            template: __webpack_require__(1546),
	            providers: [customer_profile_users_service_1.CustomerProfileUsersService, country_service_1.CountryService],
	            styles: ["\n        .user-created {\n            color: #0b60f1 !important;\n        }\n\n        .user-approved {\n            color: green !important;\n        }\n\n        .user-declined {\n            color: red !important;\n        }\n\n        .user-edited {\n            color: #f57511 !important;\n        }\n    "]
	        }),
	        __metadata("design:paramtypes", [index_1.NavigationService,
	            customer_profile_users_service_1.CustomerProfileUsersService,
	            router_1.ActivatedRoute,
	            router_1.Router,
	            notification_1.NotificationManager,
	            translate_1.TranslateManager,
	            country_service_1.CountryService])
	    ], ProfileUsersComponent);
	    return ProfileUsersComponent;
	}());
	exports.ProfileUsersComponent = ProfileUsersComponent;


/***/ }),
/* 1546 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"setting-tab-content\">\n    <div class=\"container-fluid\" style=\"margin-top:20px;\">\n        <div class=\"row\">\n            <div class=\"control-group\">\n                <div class=\"controls form-inline\">\n                    <input id=\"userName\" type=\"text\" class=\"form-control col-xs-2\"\n                           [(ngModel)]=\"filterModel.userName\"\n                           (change)=\"onChangeFilter($event.target.value)\"\n                           (keyup.enter)=\"onChangeFilter($event.target.value)\"\n                           placeholder=\"{{'CUSTOMER.DETAILS.TAB.USERS.FILTER.PLACEHOLDER.USER_NAME' | translate }}\">\n                </div>\n            </div>\n            <select\n                id=\"filter-users-state\"\n                class=\"btn btn-default dropdown-toggle col-xs-1 col-xs-offset-2\"\n                name=\"filterUserState\"\n                (change)=\"onChangeFilter($event.target.value)\"\n                [(ngModel)]=\"filterModel.userStateId\">\n                <option [value]=\"DEFAULT_OPTION\" selected>\n                    {{ 'CUSTOMER.DETAILS.TAB.USERS.FILTER.PLACEHOLDER.USER_STATE' | translate }}\n                </option>\n                <option *ngFor='let userState of profileUserStates' [value]=\"userState.id\">\n                    {{ userState.name | uppercase }}\n                </option>\n            </select>\n            <ng-container *ngIf=\"profileType == 2\">\n                <button (click)=\"openManualUserDialog()\"\n                        class=\"btn btn-primary pull-right\"\n                        style=\"margin-right: 8px;\"\n                        *ifHasRoles=\"'EDIT';hide:true;route:usersTabRoute\">\n                    {{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.BUTTON' | translate }}\n                </button>\n                <button (click)=\"newUser()\"\n                        class=\"btn btn-success pull-right\"\n                        style=\"margin-right: 8px;\"\n                        *ifHasRoles=\"'EDIT';hide:true;route:usersTabRoute\">\n                    {{ 'CUSTOMER.DETAILS.TAB.USERS.INVITE_BUTTON' | translate }}\n                </button>\n            </ng-container>\n\n        </div>\n        <p class=\"text-muted\" style=\"margin-top: 10px;\">\n            <i class=\"fa fa-info-circle\"></i> {{ 'CUSTOMER.DETAILS.TAB.USERS.NEW_USER_HINT' | translate }}\n        </p>\n    </div>\n\n    <!-- Manual creation panel: right under the buttons so it is visible with many users -->\n    <div class=\"panel panel-default\" style=\"margin-top: 15px;\" *ngIf=\"showManualDialog\">\n        <div class=\"panel-heading clearfix\">\n            <h4 class=\"panel-title pull-left\" style=\"padding-top: 4px;\">{{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.TITLE' | translate }}</h4>\n            <button type=\"button\" class=\"btn btn-default btn-sm pull-right\" (click)=\"closeManualUserDialog()\">\n                <span>&times;</span>\n            </button>\n        </div>\n        <div class=\"panel-body\">\n            <p class=\"text-muted\" *ngIf=\"!manualCredentials\">\n                {{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.MANDATORY_HINT' | translate }}\n            </p>\n\n            <div class=\"row\" *ngIf=\"!manualCredentials\">\n                <div class=\"form-group col-xs-6\">\n                    <label>{{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.EMAIL' | translate }} *</label>\n                    <input class=\"form-control\" type=\"email\" [(ngModel)]=\"manualUser.email\">\n                </div>\n                <div class=\"form-group col-xs-6\">\n                    <label>{{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.PHONE' | translate }} *</label>\n                    <input class=\"form-control\" [(ngModel)]=\"manualUser.phone\">\n                </div>\n                <div class=\"form-group col-xs-6\">\n                    <label>{{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.FIRST_NAME' | translate }} *</label>\n                    <input class=\"form-control\" [(ngModel)]=\"manualUser.firstName\">\n                </div>\n                <div class=\"form-group col-xs-6\">\n                    <label>{{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.LAST_NAME' | translate }} *</label>\n                    <input class=\"form-control\" [(ngModel)]=\"manualUser.lastName\">\n                </div>\n                <div class=\"form-group col-xs-6\">\n                    <label>{{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.MIDDLE_NAME' | translate }}</label>\n                    <input class=\"form-control\" [(ngModel)]=\"manualUser.middleName\">\n                </div>\n                <div class=\"form-group col-xs-6\">\n                    <label>{{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.DATE_OF_BIRTH' | translate }} *</label>\n                    <input date-picker [date-format]=\"'dd.mm.yyyy'\" class=\"form-control\"\n                           placeholder=\"dd.mm.yyyy\" autocomplete=\"off\"\n                           name=\"manualDateOfBirth\" [end-date]=\"currentDate\"\n                           [(ngModel)]=\"manualUser.dateOfBirth\">\n                </div>\n                <div class=\"form-group col-xs-6\">\n                    <label>{{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.PASSPORT_NUMBER' | translate }} *</label>\n                    <input class=\"form-control\" [(ngModel)]=\"manualUser.passportId\">\n                </div>\n                <div class=\"form-group col-xs-6\">\n                    <label>{{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.NATIONALITY' | translate }} *</label>\n                    <select class=\"form-control\" [(ngModel)]=\"manualUser.nationalityId\">\n                        <option [ngValue]=\"null\">{{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.SELECT' | translate }}</option>\n                        <option *ngFor=\"let c of countries\" [ngValue]=\"c.id\">{{ c.name }}</option>\n                    </select>\n                </div>\n                <div class=\"form-group col-xs-6\">\n                    <label>{{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.PASSPORT_ISSUE_DATE' | translate }} *</label>\n                    <input date-picker [date-format]=\"'dd.mm.yyyy'\" class=\"form-control\"\n                           placeholder=\"dd.mm.yyyy\" autocomplete=\"off\"\n                           name=\"manualPassportIssueDate\" [end-date]=\"currentDate\"\n                           [(ngModel)]=\"manualUser.passportIssueDate\">\n                </div>\n                <div class=\"form-group col-xs-6\">\n                    <label>{{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.PASSPORT_EXPIRY_DATE' | translate }} *</label>\n                    <input date-picker [date-format]=\"'dd.mm.yyyy'\" class=\"form-control\"\n                           placeholder=\"dd.mm.yyyy\" autocomplete=\"off\"\n                           name=\"manualPassportExpiryDate\" [start-date]=\"currentDate\"\n                           [(ngModel)]=\"manualUser.passportExpiryDate\">\n                </div>\n                <div class=\"form-group col-xs-6\">\n                    <label>{{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.ISSUE_COUNTRY' | translate }} *</label>\n                    <select class=\"form-control\" [(ngModel)]=\"manualUser.issueCountryId\">\n                        <option [ngValue]=\"null\">{{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.SELECT' | translate }}</option>\n                        <option *ngFor=\"let c of countries\" [ngValue]=\"c.id\">{{ c.name }}</option>\n                    </select>\n                </div>\n                <div class=\"form-group col-xs-6\">\n                    <label>{{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.ISSUE_PLACE' | translate }} *</label>\n                    <input class=\"form-control\" [(ngModel)]=\"manualUser.issuePlace\">\n                </div>\n            </div>\n\n            <div class=\"alert alert-success\" *ngIf=\"manualCredentials\">\n                <p><strong>{{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.CREATED' | translate }}</strong>\n                    {{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.SHARE_HINT' | translate }}</p>\n                <p>{{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.EMAIL' | translate }}: <strong>{{ manualCredentials.email }}</strong></p>\n                <p>{{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.TEMP_PASSWORD' | translate }}: <strong>{{ manualCredentials.password }}</strong>\n                    <button type=\"button\" class=\"btn btn-xs btn-default\" style=\"margin-left: 8px;\" (click)=\"copyPassword()\">\n                        <i class=\"fa\" [ngClass]=\"passwordCopied ? 'fa-check' : 'fa-copy'\"></i>\n                        {{ (passwordCopied ? 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.COPIED' : 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.COPY') | translate }}\n                    </button>\n                </p>\n                <p class=\"text-warning\"><i class=\"fa fa-exclamation-triangle\"></i>\n                    {{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.PASSWORD_ONCE' | translate }}</p>\n                <p>{{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.NO_ACCOUNTS_HINT' | translate }}</p>\n            </div>\n        </div>\n        <div class=\"panel-footer text-right\">\n            <button type=\"button\" class=\"btn btn-default\" (click)=\"closeManualUserDialog()\">\n                {{ 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.CLOSE' | translate }}\n            </button>\n            <button type=\"button\" class=\"btn btn-primary\" *ngIf=\"!manualCredentials\"\n                    [disabled]=\"manualSubmitting\" (click)=\"submitManualUser()\">\n                {{ (manualSubmitting ? 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.CREATING' : 'CUSTOMER.DETAILS.TAB.USERS.MANUAL.CREATE') | translate }}\n            </button>\n        </div>\n    </div>\n\n    <div class=\"alert alert-danger\" *ngIf=\"loadError\" style=\"margin-top: 15px;\">\n        {{ loadError }}\n        <a href=\"javascript:void(0)\" (click)=\"searchProfileUsers()\">{{ 'CUSTOMER.DETAILS.TAB.USERS.ROLE_ACCOUNTS.RETRY' | translate }}</a>\n    </div>\n\n    <div *ngIf=\"!loadError && profileUsers?.length==0\">\n        <div class=\"panel-body\">\n            <div class=\"container-fluid\">\n                <h3 class=\"text-center\">{{ 'CUSTOMER.DETAILS.TAB.USERS.NO_USERS' | translate }}</h3>\n            </div>\n        </div>\n    </div>\n\n    <div *ngIf=\"profileUsers?.length!=0\" style=\"margin-top:20px;\" id=\"profileUsersList\">\n        <ng-container *ngFor=\"let profileUser of profileUsers\">\n            <div class=\"panel panel-default top-buffer\" style=\"margin-top:20px;\">\n                <div class=\"panel-body\">\n                    <div class=\"container-fluid\">\n                        <div class=\"row account-detail-info\">\n                            <div class=\"col-xs-1\"><b class=\"text fa-md\">{{ profileUser.id }}</b></div>\n                            <div class=\"col-xs-2\"><b\n                                class=\"text fa-md\">{{ profileUser.createTime|dateConverter|date:'d MMM y' }}</b>\n                            </div>\n                            <div class=\"col-xs-3\"><b\n                                class=\"text fa-md\">{{ profileUser.userName }}</b></div>\n                            <div class=\"col-xs-2\"><b\n                                class=\"text fa-md\">{{ profileUser.fullName }}</b></div>\n                            <div class=\"col-xs-2 text-nowrap\" [title]=\"'CUSTOMER.DETAILS.TAB.USERS.ROLE_COLUMN' | translate\">\n                                <i class=\"fa fa-id-badge text-muted\" aria-hidden=\"true\"></i>\n                                {{ profileUser.userRelatedRole || ('CUSTOMER.DETAILS.TAB.USERS.PROFILE_USER_DETAILS.NO_ROLES_ASSOCIATED' | translate) }}\n                            </div>\n                            <div class=\"col-xs-1 text-nowrap\">\n                                <i class=\"fa fa-circle\"\n                                   [ngClass]=\"currentUserStateClass(profileUser.state)\"\n                                   aria-hidden=\"true\"></i>\n                                <b class=\"text fa-md\">{{ profileUser.state }}</b>\n                            </div>\n                            <div class=\"col-xs-1\">\n                                <i [id]=\"'transfers-history-menu'\"\n                                   class=\"btn-link menu-button glyphicon glyphicon-option-vertical\"\n                                   [ngClass]=\"['action-account-profile-menu',\n                                                ((profileUser.state === 'Created') ? 'active' : 'inactive') + '-account-profile-menu']\"\n                                   [matMenuTriggerFor]=\"menu\">\n                                </i>\n                                <mat-menu x-position=\"before\" #menu=\"matMenu\"\n                                          [id]=\"'mat-account-menu' + profileUser.id\">\n                                    <button mat-menu-item *ifHasRoles=\"'EDIT';hide:true;route:usersTabRoute\"\n                                            [id]=\"'action-activate-' + profileUser.id\"\n                                            [ngClass]=\"[nextUserStateClass(profileUser.state), 'account-action-menu-item']\"\n                                            [disabled]=\"isBlocked\"\n                                            (click)=\"changeState(profileUser)\">\n                                        {{ getNextUserStateText(profileUser.state) | translate }}\n                                    </button>\n                                    <button mat-menu-item id=\"view-profile-user-button\" data-toggle=\"collapse\"\n                                            class=\"account-action-menu-item\"\n                                            [attr.data-target]=\"'#profileUserDetail' + profileUser.id\"\n                                            (click)=\"profileUser.showDetails = !profileUser.showDetails\">\n                                        {{ getActionProfileUserDetailText(profileUser.showDetails) | translate }}\n                                    </button>\n                                </mat-menu>\n                            </div>\n                        </div>\n                        <div class=\"row\">\n                            <div class=\"col-xs-12 collapse profile-user-info-detail\"\n                                 [attr.id]=\"'profileUserDetail' + profileUser.id\"\n                                 [attr.aria-expanded]=\"profileUser.showDetails\">\n                                <tfl-profile-user-details *ngIf=\"profileUser.showDetails\"\n                                                          [profile-user-id]=\"profileUser.id\"\n                                                          [profile-id]=\"_profileId\"\n                                                          (roleChanged)=\"profileUser.userRelatedRole = $event\"></tfl-profile-user-details>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </ng-container>\n    </div>\n</div>\n"

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var router_1 = __webpack_require__(270);
	var notification_1 = __webpack_require__(264);
	var translate_1 = __webpack_require__(302);
	var option_dialog_1 = __webpack_require__(1317);
	var customer_profile_api_access_service_1 = __webpack_require__(1548);
	var customer_profile_service_1 = __webpack_require__(1333);
	var security_1 = __webpack_require__(736);
	var KEYS = 'CUSTOMER.DETAILS.TAB.API_ACCESS.';
	// Same rule as the backend
	var NAME_PATTERN = /^[a-z0-9][a-z0-9-]{2,63}$/;
	// The permissions eapi checks that the BO manages (eapi.supported_authority ids)
	var PERMISSION_OPTIONS = [
	    { id: 2, key: KEYS + 'PERMISSION.BALANCES' },
	    { id: 3, key: KEYS + 'PERMISSION.TRANSACTION_HISTORY' },
	    { id: 4, key: KEYS + 'PERMISSION.EXTERNAL_PAYMENTS' },
	    { id: 5, key: KEYS + 'PERMISSION.INTERNAL_PAYMENTS' },
	    { id: 6, key: KEYS + 'PERMISSION.MASTER_PAYMENTS' }
	];
	var ACTION_KEYS = {
	    CREATE: KEYS + 'ACTIVITY.ACTIONS.CREATE',
	    ROTATE_KEY: KEYS + 'ACTIVITY.ACTIONS.ROTATE_KEY',
	    BLOCK: KEYS + 'ACTIVITY.ACTIONS.BLOCK',
	    UNBLOCK: KEYS + 'ACTIVITY.ACTIONS.UNBLOCK',
	    UPDATE_PERMISSIONS: KEYS + 'ACTIVITY.ACTIONS.UPDATE_PERMISSIONS'
	};
	var ProfileApiAccessComponent = (function () {
	    function ProfileApiAccessComponent(activatedRoute, _apiAccessService, _customerProfileService, _notificationManager, _translateManager) {
	        this.activatedRoute = activatedRoute;
	        this._apiAccessService = _apiAccessService;
	        this._customerProfileService = _customerProfileService;
	        this._notificationManager = _notificationManager;
	        this._translateManager = _translateManager;
	        this.apiAccessTabRoute = security_1.CUSTOMER_API_ACCESS_TAB_ROUTE;
	        this.permissionOptions = PERMISSION_OPTIONS;
	        this.consumers = [];
	        this.loaded = false;
	        this.loadError = null;
	        // A change is in progress: blocks the buttons until the server answers
	        this.busy = false;
	        // Create form
	        this.showCreateForm = false;
	        this.newName = '';
	        this.newAuthorities = {};
	        this.suggestedName = '';
	        // Key shown once after create or rotate; dropped when the admin confirms it is stored
	        this.shownKey = null;
	        this.shownKeyName = null;
	        this.keyCopied = false;
	        // Permissions editor and activity, one consumer at a time
	        this.editingConsumerId = null;
	        this.editAuthorities = {};
	        this.activityConsumerId = null;
	        this.activity = [];
	        this.activityError = null;
	    }
	    ProfileApiAccessComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._routeSubscription = this.activatedRoute.parent.params.subscribe(function (params) {
	            _this._profileId = +params['id'];
	            _this.dismissKey();
	            _this.loadConsumers();
	            _this.loadSuggestedName();
	        });
	    };
	    ProfileApiAccessComponent.prototype.ngOnDestroy = function () {
	        // Never keep the key after leaving the tab
	        this.dismissKey();
	        if (this._routeSubscription) {
	            this._routeSubscription.unsubscribe();
	        }
	    };
	    ProfileApiAccessComponent.prototype.loadConsumers = function () {
	        var _this = this;
	        this.loadError = null;
	        this._apiAccessService.getConsumers(this._profileId)
	            .subscribe(function (consumers) {
	            _this.consumers = consumers || [];
	            _this.loaded = true;
	        }, function (error) {
	            _this.loaded = true;
	            _this.loadError = _this.errorMessage(error);
	        });
	    };
	    Object.defineProperty(ProfileApiAccessComponent.prototype, "hasActiveConsumer", {
	        // One active API access per customer: creating another one is only offered when there is none
	        get: function () {
	            return this.consumers.some(function (consumer) { return consumer.state === 'ACTIVE'; });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // ---------------------------------------------------------------- create
	    ProfileApiAccessComponent.prototype.openCreateForm = function () {
	        this.newName = this.suggestedName;
	        this.newAuthorities = {};
	        this.showCreateForm = true;
	    };
	    ProfileApiAccessComponent.prototype.closeCreateForm = function () {
	        this.showCreateForm = false;
	    };
	    Object.defineProperty(ProfileApiAccessComponent.prototype, "newNameValid", {
	        get: function () {
	            return NAME_PATTERN.test((this.newName || '').trim());
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ProfileApiAccessComponent.prototype.create = function () {
	        var _this = this;
	        var authorities = this.selected(this.newAuthorities);
	        if (!this.newNameValid || authorities.length === 0 || this.busy) {
	            return;
	        }
	        this.busy = true;
	        this._apiAccessService.create(this._profileId, this.newName.trim(), authorities)
	            .subscribe(function (result) {
	            _this.busy = false;
	            _this.showCreateForm = false;
	            _this.showKey(result);
	            _this._notificationManager.success(_this._translateManager.getValue(KEYS + 'CREATED'), 5000);
	            _this.loadConsumers();
	        }, function (error) {
	            _this.busy = false;
	            _this._notificationManager.error(_this.errorMessage(error));
	        });
	    };
	    // ---------------------------------------------------------------- key shown once
	    ProfileApiAccessComponent.prototype.onKeyCopied = function () {
	        this.keyCopied = true;
	    };
	    ProfileApiAccessComponent.prototype.dismissKey = function () {
	        this.shownKey = null;
	        this.shownKeyName = null;
	        this.keyCopied = false;
	    };
	    // ---------------------------------------------------------------- rotate / block / unblock
	    ProfileApiAccessComponent.prototype.rotateKey = function (consumer) {
	        var _this = this;
	        this.confirm(KEYS + 'ROTATE.TITLE', KEYS + 'ROTATE.MESSAGE', consumer, KEYS + 'ROTATE.CONFIRM', 'btn-danger', function () {
	            return _this._apiAccessService.rotateKey(_this._profileId, consumer.id)
	                .subscribe(function (result) {
	                _this.busy = false;
	                _this.showKey(result);
	                _this._notificationManager.success(_this._translateManager.getValue(KEYS + 'ROTATED'), 5000);
	                _this.afterChange(consumer.id);
	            }, function (error) { return _this.onActionError(error); });
	        });
	    };
	    ProfileApiAccessComponent.prototype.block = function (consumer) {
	        var _this = this;
	        this.confirm(KEYS + 'BLOCK.TITLE', KEYS + 'BLOCK.MESSAGE', consumer, KEYS + 'BLOCK.CONFIRM', 'btn-danger', function () {
	            return _this._apiAccessService.block(_this._profileId, consumer.id)
	                .subscribe(function () {
	                _this.busy = false;
	                _this._notificationManager.success(_this._translateManager.getValue(KEYS + 'BLOCKED'), 5000);
	                _this.afterChange(consumer.id);
	            }, function (error) { return _this.onActionError(error); });
	        });
	    };
	    ProfileApiAccessComponent.prototype.unblock = function (consumer) {
	        var _this = this;
	        this.confirm(KEYS + 'UNBLOCK.TITLE', KEYS + 'UNBLOCK.MESSAGE', consumer, KEYS + 'UNBLOCK.CONFIRM', 'btn-primary', function () {
	            return _this._apiAccessService.unblock(_this._profileId, consumer.id)
	                .subscribe(function () {
	                _this.busy = false;
	                _this._notificationManager.success(_this._translateManager.getValue(KEYS + 'UNBLOCKED'), 5000);
	                _this.afterChange(consumer.id);
	            }, function (error) { return _this.onActionError(error); });
	        });
	    };
	    // ---------------------------------------------------------------- permissions
	    ProfileApiAccessComponent.prototype.editPermissions = function (consumer) {
	        var _this = this;
	        if (this.editingConsumerId === consumer.id) {
	            this.editingConsumerId = null;
	            return;
	        }
	        this.editingConsumerId = consumer.id;
	        this.editAuthorities = {};
	        (consumer.authorities || []).forEach(function (id) { return _this.editAuthorities[id] = true; });
	    };
	    ProfileApiAccessComponent.prototype.savePermissions = function (consumer) {
	        var _this = this;
	        var authorities = this.selected(this.editAuthorities);
	        if (authorities.length === 0 || this.busy) {
	            return;
	        }
	        this.busy = true;
	        this._apiAccessService.updatePermissions(this._profileId, consumer.id, authorities)
	            .subscribe(function () {
	            _this.busy = false;
	            _this.editingConsumerId = null;
	            _this._notificationManager.success(_this._translateManager.getValue(KEYS + 'PERMISSIONS_UPDATED'), 5000);
	            _this.afterChange(consumer.id);
	        }, function (error) { return _this.onActionError(error); });
	    };
	    ProfileApiAccessComponent.prototype.hasSelection = function (selection) {
	        return this.selected(selection).length > 0;
	    };
	    ProfileApiAccessComponent.prototype.permissionLabels = function (consumer) {
	        return this.permissionOptions
	            .filter(function (option) { return (consumer.authorities || []).indexOf(option.id) >= 0; })
	            .map(function (option) { return option.key; });
	    };
	    // ---------------------------------------------------------------- activity
	    ProfileApiAccessComponent.prototype.toggleActivity = function (consumer) {
	        if (this.activityConsumerId === consumer.id) {
	            this.activityConsumerId = null;
	            return;
	        }
	        this.activityConsumerId = consumer.id;
	        this.loadActivity(consumer.id);
	    };
	    ProfileApiAccessComponent.prototype.actionKey = function (action) {
	        return ACTION_KEYS[action] || action;
	    };
	    // "field: before -> after" for every field the action changed (the key itself is never stored)
	    ProfileApiAccessComponent.prototype.changes = function (entry) {
	        var _this = this;
	        var before = entry.before || {};
	        var after = entry.after || {};
	        var fields = Object.keys(after).concat(Object.keys(before).filter(function (field) { return !(field in after); }));
	        return fields.map(function (field) {
	            var from = _this.formatValue(before[field]);
	            var to = _this.formatValue(after[field]);
	            return entry.before ? field + ": " + from + " \u2192 " + to : field + ": " + to;
	        });
	    };
	    ProfileApiAccessComponent.prototype.stateClass = function (state) {
	        switch (state) {
	            case 'ACTIVE':
	                return 'state-active';
	            case 'BLOCKED':
	                return 'state-blocked';
	            default:
	                return 'state-other';
	        }
	    };
	    // ---------------------------------------------------------------- helpers
	    ProfileApiAccessComponent.prototype.loadActivity = function (consumerId) {
	        var _this = this;
	        this.activity = [];
	        this.activityError = null;
	        this._apiAccessService.getAudit(this._profileId, consumerId)
	            .subscribe(function (entries) { return _this.activity = entries || []; }, function (error) { return _this.activityError = _this.errorMessage(error); });
	    };
	    ProfileApiAccessComponent.prototype.afterChange = function (consumerId) {
	        this.loadConsumers();
	        if (this.activityConsumerId === consumerId) {
	            this.loadActivity(consumerId);
	        }
	    };
	    ProfileApiAccessComponent.prototype.showKey = function (result) {
	        this.shownKey = result.apiKey;
	        this.shownKeyName = result.consumer ? result.consumer.name : null;
	        this.keyCopied = false;
	    };
	    ProfileApiAccessComponent.prototype.confirm = function (title, message, consumer, confirmText, confirmClass, action) {
	        var _this = this;
	        if (this.busy) {
	            return;
	        }
	        this.dialog
	            .showConfirmDialog({
	            title: title,
	            descriptionLines: [{ key: message, params: { name: consumer.name } }],
	            confirmButtonText: confirmText,
	            cancelButtonText: KEYS + 'CANCEL',
	            confirmButtonClass: confirmClass
	        })
	            .onConfirmAction(function () {
	            _this.busy = true;
	            action();
	        });
	    };
	    ProfileApiAccessComponent.prototype.onActionError = function (error) {
	        this.busy = false;
	        this._notificationManager.error(this.errorMessage(error));
	    };
	    ProfileApiAccessComponent.prototype.selected = function (selection) {
	        return this.permissionOptions
	            .filter(function (option) { return !!selection[option.id]; })
	            .map(function (option) { return option.id; });
	    };
	    ProfileApiAccessComponent.prototype.formatValue = function (value) {
	        if (value === null || value === undefined) {
	            return '-';
	        }
	        return Array.isArray(value) ? (value.length ? value.join(', ') : '-') : String(value);
	    };
	    // Proposed name: <profile-name>-api, in the format the backend accepts
	    ProfileApiAccessComponent.prototype.loadSuggestedName = function () {
	        var _this = this;
	        this.suggestedName = '';
	        this._customerProfileService.searchCustomerProfileById(this._profileId)
	            .subscribe(function (profile) {
	            var base = ((profile && profile.name) || '').toLowerCase()
	                .replace(/[^a-z0-9]+/g, '-')
	                .replace(/^-+|-+$/g, '')
	                .substring(0, 56)
	                .replace(/-+$/g, '');
	            var name = base + '-api';
	            _this.suggestedName = NAME_PATTERN.test(name) ? name : '';
	        }, function () { return _this.suggestedName = ''; });
	    };
	    ProfileApiAccessComponent.prototype.errorMessage = function (error) {
	        return (error && error.message) || this._translateManager.getValue(KEYS + 'ACTION_ERROR');
	    };
	    __decorate([
	        option_dialog_1.InjectOptionDialog('api-access-dialog'),
	        __metadata("design:type", Object)
	    ], ProfileApiAccessComponent.prototype, "dialog", void 0);
	    ProfileApiAccessComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-profile-api-access',
	            template: __webpack_require__(1549),
	            providers: [customer_profile_api_access_service_1.CustomerProfileApiAccessService],
	            styles: ["\n        .api-access-key {\n            font-family: monospace;\n        }\n\n        .state-active {\n            color: green !important;\n        }\n\n        .state-blocked {\n            color: red !important;\n        }\n\n        .state-other {\n            color: #f57511 !important;\n        }\n\n        .api-access-actions .btn {\n            margin: 0 4px 4px 0;\n        }\n    "]
	        }),
	        __metadata("design:paramtypes", [router_1.ActivatedRoute,
	            customer_profile_api_access_service_1.CustomerProfileApiAccessService,
	            customer_profile_service_1.CustomerProfileService,
	            notification_1.NotificationManager,
	            translate_1.TranslateManager])
	    ], ProfileApiAccessComponent);
	    return ProfileApiAccessComponent;
	}());
	exports.ProfileApiAccessComponent = ProfileApiAccessComponent;


/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var http_1 = __webpack_require__(836);
	var core_1 = __webpack_require__(205);
	// Customer "API access" tab: the customer's Payments API (eapi) consumers
	var CustomerProfileApiAccessService = (function () {
	    function CustomerProfileApiAccessService(_http) {
	        this._http = _http;
	    }
	    CustomerProfileApiAccessService.prototype.getConsumers = function (profileId) {
	        return this._http.get("/api/backoffice/customers/" + profileId + "/api-access")
	            .map(function (response) { return response.json(); });
	    };
	    // The response carries the API key: show it once and do not keep it
	    CustomerProfileApiAccessService.prototype.create = function (profileId, name, authorities) {
	        return this._http.post("/api/backoffice/customers/" + profileId + "/api-access", { name: name, authorities: authorities })
	            .map(function (response) { return response.json(); });
	    };
	    // The response carries the new API key: show it once and do not keep it
	    CustomerProfileApiAccessService.prototype.rotateKey = function (profileId, consumerId) {
	        return this._http.post("/api/backoffice/customers/" + profileId + "/api-access/" + consumerId + "/rotate-key", {})
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileApiAccessService.prototype.updatePermissions = function (profileId, consumerId, authorities) {
	        return this._http.put("/api/backoffice/customers/" + profileId + "/api-access/" + consumerId + "/permissions", { authorities: authorities })
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileApiAccessService.prototype.block = function (profileId, consumerId) {
	        return this._http.post("/api/backoffice/customers/" + profileId + "/api-access/" + consumerId + "/block", {})
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileApiAccessService.prototype.unblock = function (profileId, consumerId) {
	        return this._http.post("/api/backoffice/customers/" + profileId + "/api-access/" + consumerId + "/unblock", {})
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileApiAccessService.prototype.getAudit = function (profileId, consumerId) {
	        return this._http.get("/api/backoffice/customers/" + profileId + "/api-access/" + consumerId + "/audit")
	            .map(function (response) { return response.json(); });
	    };
	    CustomerProfileApiAccessService = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [http_1.Http])
	    ], CustomerProfileApiAccessService);
	    return CustomerProfileApiAccessService;
	}());
	exports.CustomerProfileApiAccessService = CustomerProfileApiAccessService;


/***/ }),
/* 1549 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"setting-tab-content\">\n    <div class=\"container-fluid\" style=\"margin-top:20px;\">\n        <div class=\"row\">\n            <div class=\"col-xs-8\">\n                <p class=\"text-muted\">\n                    <i class=\"fa fa-info-circle\"></i> {{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.READ_ONLY_SETTINGS' | translate }}\n                </p>\n            </div>\n            <div class=\"col-xs-4\">\n                <button class=\"btn btn-success pull-right\"\n                        *ifHasRoles=\"'EDIT';hide:true;route:apiAccessTabRoute\"\n                        [hidden]=\"!loaded || loadError || hasActiveConsumer || showCreateForm\"\n                        [disabled]=\"busy\"\n                        (click)=\"openCreateForm()\">\n                    {{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.CREATE_BUTTON' | translate }}\n                </button>\n            </div>\n        </div>\n    </div>\n\n    <!-- Key shown once, after create or rotate -->\n    <div class=\"panel panel-warning\" style=\"margin-top: 15px;\" *ngIf=\"shownKey\">\n        <div class=\"panel-heading\">\n            <h4 class=\"panel-title\">\n                <i class=\"fa fa-key\"></i> {{ shownKeyName }}\n            </h4>\n        </div>\n        <div class=\"panel-body\">\n            <p class=\"text-warning\"><i class=\"fa fa-exclamation-triangle\"></i>\n                <strong>{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.KEY.ONCE' | translate }}</strong></p>\n            <div class=\"input-group\">\n                <input #apiKeyInput class=\"form-control api-access-key\" readonly autocomplete=\"off\" spellcheck=\"false\"\n                       [value]=\"shownKey\" (focus)=\"apiKeyInput.select()\">\n                <span class=\"input-group-btn\">\n                    <button type=\"button\" class=\"btn\"\n                            [ngClass]=\"keyCopied ? 'btn-success' : 'btn-primary'\"\n                            [ngxClipboard]=\"apiKeyInput\"\n                            (cbOnSuccess)=\"onKeyCopied()\">\n                        <i class=\"fa\" [ngClass]=\"keyCopied ? 'fa-check' : 'fa-copy'\"></i>\n                        {{ (keyCopied ? 'CUSTOMER.DETAILS.TAB.API_ACCESS.KEY.COPIED' : 'CUSTOMER.DETAILS.TAB.API_ACCESS.KEY.COPY') | translate }}\n                    </button>\n                </span>\n            </div>\n            <p class=\"text-muted\" style=\"margin-top: 10px;\">\n                {{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.KEY.SEND_HINT' | translate }}\n            </p>\n        </div>\n        <div class=\"panel-footer text-right\">\n            <button type=\"button\" class=\"btn btn-primary\" (click)=\"dismissKey()\">\n                {{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.KEY.STORED' | translate }}\n            </button>\n        </div>\n    </div>\n\n    <!-- Create form -->\n    <div class=\"panel panel-default\" style=\"margin-top: 15px;\" *ngIf=\"showCreateForm\">\n        <div class=\"panel-heading clearfix\">\n            <h4 class=\"panel-title pull-left\" style=\"padding-top: 4px;\">{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.CREATE_BUTTON' | translate }}</h4>\n            <button type=\"button\" class=\"btn btn-default btn-sm pull-right\" (click)=\"closeCreateForm()\">\n                <span>&times;</span>\n            </button>\n        </div>\n        <div class=\"panel-body\">\n            <div class=\"row\">\n                <div class=\"form-group col-xs-6\" [class.has-error]=\"newName && !newNameValid\">\n                    <label for=\"apiAccessName\">{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.FORM.NAME' | translate }} *</label>\n                    <input id=\"apiAccessName\" class=\"form-control\" maxlength=\"64\" autocomplete=\"off\" [(ngModel)]=\"newName\">\n                    <span class=\"help-block\">{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.FORM.NAME_HINT' | translate }}</span>\n                </div>\n                <div class=\"form-group col-xs-6\">\n                    <label>{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.FORM.PERMISSIONS' | translate }} *</label>\n                    <div class=\"checkbox\" *ngFor=\"let option of permissionOptions\">\n                        <label>\n                            <input type=\"checkbox\" [(ngModel)]=\"newAuthorities[option.id]\">\n                            {{ option.key | translate }}\n                        </label>\n                    </div>\n                    <span class=\"help-block\">{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.FORM.INTERNAL_NOTE' | translate }}</span>\n                </div>\n            </div>\n        </div>\n        <div class=\"panel-footer text-right\">\n            <button type=\"button\" class=\"btn btn-default\" (click)=\"closeCreateForm()\">\n                {{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.CANCEL' | translate }}\n            </button>\n            <button type=\"button\" class=\"btn btn-primary\"\n                    [disabled]=\"busy || !newNameValid || !hasSelection(newAuthorities)\" (click)=\"create()\">\n                {{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.CREATE_BUTTON' | translate }}\n            </button>\n        </div>\n    </div>\n\n    <div class=\"alert alert-danger\" *ngIf=\"loadError\" style=\"margin-top: 15px;\">\n        {{ loadError }}\n        <a href=\"javascript:void(0)\" (click)=\"loadConsumers()\">{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.RETRY' | translate }}</a>\n    </div>\n\n    <div *ngIf=\"loaded && !loadError && consumers.length == 0\">\n        <div class=\"panel-body\">\n            <h3 class=\"text-center\">{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.EMPTY' | translate }}</h3>\n        </div>\n    </div>\n\n    <div *ngIf=\"consumers.length > 0\" style=\"margin-top: 20px;\">\n        <table class=\"table table-striped\">\n            <thead>\n            <tr>\n                <th>{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.TABLE.NAME' | translate }}</th>\n                <th>{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.TABLE.KEY' | translate }}</th>\n                <th>{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.TABLE.STATE' | translate }}</th>\n                <th>{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.TABLE.PERMISSIONS' | translate }}</th>\n                <th>{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.TABLE.CREATED' | translate }}</th>\n                <th>{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.TABLE.KEY_ROTATED' | translate }}</th>\n                <th>{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.TABLE.ACTIONS' | translate }}</th>\n            </tr>\n            </thead>\n            <tbody>\n            <ng-container *ngFor=\"let consumer of consumers\">\n                <tr>\n                    <td><b>{{ consumer.name }}</b><br><small class=\"text-muted\">#{{ consumer.id }}</small></td>\n                    <td class=\"api-access-key\">{{ consumer.keyPrefix ? consumer.keyPrefix + '…' : '-' }}</td>\n                    <td class=\"text-nowrap\">\n                        <i class=\"fa fa-circle\" [ngClass]=\"stateClass(consumer.state)\" aria-hidden=\"true\"></i>\n                        {{ consumer.state }}\n                    </td>\n                    <td>\n                        <div *ngFor=\"let label of permissionLabels(consumer)\">{{ label | translate }}</div>\n                        <span *ngIf=\"permissionLabels(consumer).length == 0\" class=\"text-muted\">-</span>\n                        <div *ngIf=\"consumer.otherAuthorities?.length\" class=\"text-muted\">\n                            <small>{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.OTHER_PERMISSIONS' | translate }}: {{ consumer.otherAuthorities.join(', ') }}</small>\n                        </div>\n                    </td>\n                    <td class=\"text-nowrap\">{{ consumer.createdAt ? (consumer.createdAt | date:'d MMM y, HH:mm') : '-' }}</td>\n                    <td class=\"text-nowrap\">{{ consumer.keyRotatedAt ? (consumer.keyRotatedAt | date:'d MMM y, HH:mm') : '-' }}</td>\n                    <td class=\"api-access-actions\">\n                        <ng-container *ifHasRoles=\"'EDIT';hide:true;route:apiAccessTabRoute\">\n                            <button type=\"button\" class=\"btn btn-xs btn-default\" [disabled]=\"busy\"\n                                    (click)=\"rotateKey(consumer)\">\n                                {{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.ACTIONS.ROTATE' | translate }}\n                            </button>\n                            <button type=\"button\" class=\"btn btn-xs btn-danger\" [disabled]=\"busy\"\n                                    *ngIf=\"consumer.state == 'ACTIVE'\" (click)=\"block(consumer)\">\n                                {{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.ACTIONS.BLOCK' | translate }}\n                            </button>\n                            <button type=\"button\" class=\"btn btn-xs btn-success\" [disabled]=\"busy\"\n                                    *ngIf=\"consumer.state == 'BLOCKED'\" (click)=\"unblock(consumer)\">\n                                {{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.ACTIONS.UNBLOCK' | translate }}\n                            </button>\n                            <button type=\"button\" class=\"btn btn-xs btn-default\" [disabled]=\"busy\"\n                                    (click)=\"editPermissions(consumer)\">\n                                {{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.ACTIONS.PERMISSIONS' | translate }}\n                            </button>\n                        </ng-container>\n                        <button type=\"button\" class=\"btn btn-xs btn-default\" (click)=\"toggleActivity(consumer)\">\n                            {{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.ACTIVITY.TITLE' | translate }}\n                        </button>\n                    </td>\n                </tr>\n                <tr>\n                    <td colspan=\"7\" class=\"text-muted\" style=\"border-top: none; padding-top: 0;\">\n                        <small>\n                            {{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.SETTINGS.EXPRESS' | translate }}:\n                            {{ (consumer.express ? 'CUSTOMER.DETAILS.TAB.API_ACCESS.YES' : 'CUSTOMER.DETAILS.TAB.API_ACCESS.NO') | translate }}\n                            &middot; {{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.SETTINGS.SUB_ACCOUNT' | translate }}: {{ consumer.subAccount || '-' }}\n                            &middot; {{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.SETTINGS.ALLOWED_POOLS' | translate }}: {{ consumer.allowedPoolsCount }}\n                            &middot; {{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.SETTINGS.EMONEY' | translate }}:\n                            {{ (consumer.emoney ? 'CUSTOMER.DETAILS.TAB.API_ACCESS.YES' : 'CUSTOMER.DETAILS.TAB.API_ACCESS.NO') | translate }}\n                            &middot; {{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.SETTINGS.WALLETS' | translate }}: {{ consumer.walletsCount }}\n                        </small>\n                    </td>\n                </tr>\n\n                <!-- Permissions editor -->\n                <tr *ngIf=\"editingConsumerId == consumer.id\">\n                    <td colspan=\"7\">\n                        <div class=\"panel panel-default\" style=\"margin-bottom: 0;\">\n                            <div class=\"panel-body\">\n                                <label>{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.FORM.PERMISSIONS' | translate }}</label>\n                                <div class=\"checkbox\" *ngFor=\"let option of permissionOptions\">\n                                    <label>\n                                        <input type=\"checkbox\" [(ngModel)]=\"editAuthorities[option.id]\">\n                                        {{ option.key | translate }}\n                                    </label>\n                                </div>\n                                <p class=\"help-block\">{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.FORM.INTERNAL_NOTE' | translate }}</p>\n                            </div>\n                            <div class=\"panel-footer text-right\">\n                                <button type=\"button\" class=\"btn btn-default btn-sm\" (click)=\"editPermissions(consumer)\">\n                                    {{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.CANCEL' | translate }}\n                                </button>\n                                <button type=\"button\" class=\"btn btn-primary btn-sm\"\n                                        [disabled]=\"busy || !hasSelection(editAuthorities)\" (click)=\"savePermissions(consumer)\">\n                                    {{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.SAVE' | translate }}\n                                </button>\n                            </div>\n                        </div>\n                    </td>\n                </tr>\n\n                <!-- Activity -->\n                <tr *ngIf=\"activityConsumerId == consumer.id\">\n                    <td colspan=\"7\">\n                        <h5>{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.ACTIVITY.TITLE' | translate }}</h5>\n                        <div class=\"alert alert-danger\" *ngIf=\"activityError\">{{ activityError }}</div>\n                        <p class=\"text-muted\" *ngIf=\"!activityError && activity.length == 0\">\n                            {{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.ACTIVITY.EMPTY' | translate }}\n                        </p>\n                        <table class=\"table table-condensed\" *ngIf=\"activity.length > 0\">\n                            <thead>\n                            <tr>\n                                <th>{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.ACTIVITY.DATE' | translate }}</th>\n                                <th>{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.ACTIVITY.ACTION' | translate }}</th>\n                                <th>{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.ACTIVITY.BY' | translate }}</th>\n                                <th>{{ 'CUSTOMER.DETAILS.TAB.API_ACCESS.ACTIVITY.CHANGES' | translate }}</th>\n                            </tr>\n                            </thead>\n                            <tbody>\n                            <tr *ngFor=\"let entry of activity\">\n                                <td class=\"text-nowrap\">{{ entry.createdAt | date:'d MMM y, HH:mm:ss' }}</td>\n                                <td>{{ actionKey(entry.action) | translate }}</td>\n                                <td>{{ entry.adminUsername }}</td>\n                                <td><div *ngFor=\"let change of changes(entry)\"><small>{{ change }}</small></div></td>\n                            </tr>\n                            </tbody>\n                        </table>\n                    </td>\n                </tr>\n            </ng-container>\n            </tbody>\n        </table>\n    </div>\n</div>\n"

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var ConverterStringToDateString = (function () {
	    function ConverterStringToDateString() {
	    }
	    ConverterStringToDateString.prototype.transform = function (val) {
	        if (!val)
	            return val;
	        var date = String(val).split(' ');
	        var arr = String(date[0]).split('.');
	        val = Date.parse(arr[2] + "-" + arr[1] + "-" + arr[0] + "T" + date[1]);
	        return val;
	    };
	    ConverterStringToDateString = __decorate([
	        core_1.Pipe({
	            name: 'dateConverter'
	        })
	    ], ConverterStringToDateString);
	    return ConverterStringToDateString;
	}());
	exports.ConverterStringToDateString = ConverterStringToDateString;


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var constants_1 = __webpack_require__(861);
	var ProfileProviderBadgeComponent = (function () {
	    function ProfileProviderBadgeComponent() {
	        this.providerBadgeClass = {};
	        this.providerBadgeTitle = '';
	    }
	    Object.defineProperty(ProfileProviderBadgeComponent.prototype, "_state", {
	        set: function (state) {
	            this.providerBadgeClass = this.getProviderBadgeClass(state);
	            this.providerBadgeTitle = this.getProviderBadgeTitle(state);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ProfileProviderBadgeComponent.prototype.getProviderBadgeClass = function (state) {
	        return {
	            'label        ': true,
	            'label-success': state === constants_1.PROFILE_PROVIDERS_NAMES.MODULR,
	            'label-warning': state === constants_1.PROFILE_PROVIDERS_NAMES.AGENT,
	            'label-default': state === constants_1.PROFILE_PROVIDERS_NAMES.MOORWAND,
	            'label-info   ': state === constants_1.PROFILE_PROVIDERS_NAMES.EMONEY
	        };
	    };
	    ProfileProviderBadgeComponent.prototype.getProviderBadgeTitle = function (state) {
	        switch (state) {
	            case constants_1.PROFILE_PROVIDERS_NAMES.MODULR:
	                return 'CUSTOMER.PROVIDER.MODULR';
	            case constants_1.PROFILE_PROVIDERS_NAMES.AGENT:
	                return 'CUSTOMER.PROVIDER.AGENT';
	            case constants_1.PROFILE_PROVIDERS_NAMES.MOORWAND:
	                return 'CUSTOMER.PROVIDER.MOORWAND';
	            case constants_1.PROFILE_PROVIDERS_NAMES.EMONEY:
	                return 'CUSTOMER.PROVIDER.EMONEY';
	        }
	    };
	    __decorate([
	        core_1.Input('provider'),
	        __metadata("design:type", String),
	        __metadata("design:paramtypes", [String])
	    ], ProfileProviderBadgeComponent.prototype, "_state", null);
	    ProfileProviderBadgeComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-bo-profile-provider-badge',
	            template: "\n        <span [ngClass]=\"providerBadgeClass\">\n            {{ providerBadgeTitle | translate }}\n        </span>\n    "
	        })
	    ], ProfileProviderBadgeComponent);
	    return ProfileProviderBadgeComponent;
	}());
	exports.ProfileProviderBadgeComponent = ProfileProviderBadgeComponent;


/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(205), __webpack_require__(1078), __webpack_require__(1075), __webpack_require__(246), __webpack_require__(1077)) :
		typeof define === 'function' && define.amd ? define(['exports', '@angular/core', '@angular/cdk/platform', '@angular/material/core', '@angular/common', '@angular/cdk/coercion'], factory) :
		(factory((global.ng = global.ng || {}, global.ng.material = global.ng.material || {}, global.ng.material.progressSpinner = global.ng.material.progressSpinner || {}),global.ng.core,global.ng.cdk.platform,global.ng.material.core,global.ng.common,global.ng.cdk.coercion));
	}(this, (function (exports,_angular_core,_angular_cdk_platform,_angular_material_core,_angular_common,_angular_cdk_coercion) { 'use strict';
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	
	/**
	 * Base reference size of the spinner.
	 * \@docs-private
	 */
	var BASE_SIZE = 100;
	/**
	 * Base reference stroke width of the spinner.
	 * \@docs-private
	 */
	var BASE_STROKE_WIDTH = 10;
	/**
	 * \@docs-private
	 */
	var MatProgressSpinnerBase = /** @class */ (function () {
	    function MatProgressSpinnerBase(_elementRef) {
	        this._elementRef = _elementRef;
	    }
	    return MatProgressSpinnerBase;
	}());
	var _MatProgressSpinnerMixinBase = _angular_material_core.mixinColor(MatProgressSpinnerBase, 'primary');
	// .0001 percentage difference is necessary in order to avoid unwanted animation frames
	// for example because the animation duration is 4 seconds, .1% accounts to 4ms
	// which are enough to see the flicker described in
	// https://github.com/angular/material2/issues/8984
	var INDETERMINATE_ANIMATION_TEMPLATE = "\n @keyframes mat-progress-spinner-stroke-rotate-DIAMETER {\n    0%      { stroke-dashoffset: START_VALUE;  transform: rotate(0); }\n    12.5%   { stroke-dashoffset: END_VALUE;    transform: rotate(0); }\n    12.5001%  { stroke-dashoffset: END_VALUE;    transform: rotateX(180deg) rotate(72.5deg); }\n    25%     { stroke-dashoffset: START_VALUE;  transform: rotateX(180deg) rotate(72.5deg); }\n\n    25.0001%   { stroke-dashoffset: START_VALUE;  transform: rotate(270deg); }\n    37.5%   { stroke-dashoffset: END_VALUE;    transform: rotate(270deg); }\n    37.5001%  { stroke-dashoffset: END_VALUE;    transform: rotateX(180deg) rotate(161.5deg); }\n    50%     { stroke-dashoffset: START_VALUE;  transform: rotateX(180deg) rotate(161.5deg); }\n\n    50.0001%  { stroke-dashoffset: START_VALUE;  transform: rotate(180deg); }\n    62.5%   { stroke-dashoffset: END_VALUE;    transform: rotate(180deg); }\n    62.5001%  { stroke-dashoffset: END_VALUE;    transform: rotateX(180deg) rotate(251.5deg); }\n    75%     { stroke-dashoffset: START_VALUE;  transform: rotateX(180deg) rotate(251.5deg); }\n\n    75.0001%  { stroke-dashoffset: START_VALUE;  transform: rotate(90deg); }\n    87.5%   { stroke-dashoffset: END_VALUE;    transform: rotate(90deg); }\n    87.5001%  { stroke-dashoffset: END_VALUE;    transform: rotateX(180deg) rotate(341.5deg); }\n    100%    { stroke-dashoffset: START_VALUE;  transform: rotateX(180deg) rotate(341.5deg); }\n  }\n";
	/**
	 * `<mat-progress-spinner>` component.
	 */
	var MatProgressSpinner = /** @class */ (function (_super) {
	    __extends(MatProgressSpinner, _super);
	    function MatProgressSpinner(_elementRef, platform, _document) {
	        var _this = _super.call(this, _elementRef) || this;
	        _this._elementRef = _elementRef;
	        _this._document = _document;
	        _this._value = 0;
	        _this._fallbackAnimation = false;
	        /**
	         * The width and height of the host element. Will grow with stroke width.
	         */
	        _this._elementSize = BASE_SIZE;
	        _this._diameter = BASE_SIZE;
	        /**
	         * Mode of the progress circle
	         */
	        _this.mode = 'determinate';
	        _this._fallbackAnimation = platform.EDGE || platform.TRIDENT;
	        // On IE and Edge, we can't animate the `stroke-dashoffset`
	        // reliably so we fall back to a non-spec animation.
	        var /** @type {?} */ animationClass = "mat-progress-spinner-indeterminate" + (_this._fallbackAnimation ? '-fallback' : '') + "-animation";
	        _elementRef.nativeElement.classList.add(animationClass);
	        return _this;
	    }
	    Object.defineProperty(MatProgressSpinner.prototype, "diameter", {
	        get: /**
	         * The diameter of the progress spinner (will set width and height of svg).
	         * @return {?}
	         */
	        function () { return this._diameter; },
	        set: /**
	         * @param {?} size
	         * @return {?}
	         */
	        function (size) {
	            this._diameter = _angular_cdk_coercion.coerceNumberProperty(size);
	            if (!this._fallbackAnimation && !MatProgressSpinner.diameters.has(this._diameter)) {
	                this._attachStyleNode();
	            }
	            this._updateElementSize();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatProgressSpinner.prototype, "strokeWidth", {
	        get: /**
	         * Stroke width of the progress spinner.
	         * @return {?}
	         */
	        function () {
	            return this._strokeWidth || this.diameter / 10;
	        },
	        set: /**
	         * @param {?} value
	         * @return {?}
	         */
	        function (value) {
	            this._strokeWidth = _angular_cdk_coercion.coerceNumberProperty(value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatProgressSpinner.prototype, "value", {
	        get: /**
	         * Value of the progress circle.
	         * @return {?}
	         */
	        function () {
	            return this.mode === 'determinate' ? this._value : 0;
	        },
	        set: /**
	         * @param {?} newValue
	         * @return {?}
	         */
	        function (newValue) {
	            this._value = Math.max(0, Math.min(100, _angular_cdk_coercion.coerceNumberProperty(newValue)));
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @param {?} changes
	     * @return {?}
	     */
	    MatProgressSpinner.prototype.ngOnChanges = /**
	     * @param {?} changes
	     * @return {?}
	     */
	    function (changes) {
	        if (changes["strokeWidth"] || changes["diameter"]) {
	            this._updateElementSize();
	        }
	    };
	    Object.defineProperty(MatProgressSpinner.prototype, "_circleRadius", {
	        /** The radius of the spinner, adjusted for stroke width. */
	        get: /**
	         * The radius of the spinner, adjusted for stroke width.
	         * @return {?}
	         */
	        function () {
	            return (this.diameter - BASE_STROKE_WIDTH) / 2;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatProgressSpinner.prototype, "_viewBox", {
	        /** The view box of the spinner's svg element. */
	        get: /**
	         * The view box of the spinner's svg element.
	         * @return {?}
	         */
	        function () {
	            var /** @type {?} */ viewBox = this._circleRadius * 2 + this.strokeWidth;
	            return "0 0 " + viewBox + " " + viewBox;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatProgressSpinner.prototype, "_strokeCircumference", {
	        /** The stroke circumference of the svg circle. */
	        get: /**
	         * The stroke circumference of the svg circle.
	         * @return {?}
	         */
	        function () {
	            return 2 * Math.PI * this._circleRadius;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatProgressSpinner.prototype, "_strokeDashOffset", {
	        /** The dash offset of the svg circle. */
	        get: /**
	         * The dash offset of the svg circle.
	         * @return {?}
	         */
	        function () {
	            if (this.mode === 'determinate') {
	                return this._strokeCircumference * (100 - this._value) / 100;
	            }
	            // In fallback mode set the circle to 80% and rotate it with CSS.
	            if (this._fallbackAnimation && this.mode === 'indeterminate') {
	                return this._strokeCircumference * 0.2;
	            }
	            return null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(MatProgressSpinner.prototype, "_circleStrokeWidth", {
	        /** Stroke width of the circle in percent. */
	        get: /**
	         * Stroke width of the circle in percent.
	         * @return {?}
	         */
	        function () {
	            return this.strokeWidth / this._elementSize * 100;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Dynamically generates a style tag containing the correct animation for this diameter.
	     * @return {?}
	     */
	    MatProgressSpinner.prototype._attachStyleNode = /**
	     * Dynamically generates a style tag containing the correct animation for this diameter.
	     * @return {?}
	     */
	    function () {
	        var /** @type {?} */ styleTag = MatProgressSpinner.styleTag;
	        if (!styleTag) {
	            styleTag = this._document.createElement('style');
	            this._document.head.appendChild(styleTag);
	            MatProgressSpinner.styleTag = styleTag;
	        }
	        if (styleTag && styleTag.sheet) {
	            (/** @type {?} */ (styleTag.sheet)).insertRule(this._getAnimationText(), 0);
	        }
	        MatProgressSpinner.diameters.add(this.diameter);
	    };
	    /**
	     * Generates animation styles adjusted for the spinner's diameter.
	     * @return {?}
	     */
	    MatProgressSpinner.prototype._getAnimationText = /**
	     * Generates animation styles adjusted for the spinner's diameter.
	     * @return {?}
	     */
	    function () {
	        return INDETERMINATE_ANIMATION_TEMPLATE
	            .replace(/START_VALUE/g, "" + 0.95 * this._strokeCircumference)
	            .replace(/END_VALUE/g, "" + 0.2 * this._strokeCircumference)
	            .replace(/DIAMETER/g, "" + this.diameter);
	    };
	    /**
	     * Updates the spinner element size based on its diameter.
	     * @return {?}
	     */
	    MatProgressSpinner.prototype._updateElementSize = /**
	     * Updates the spinner element size based on its diameter.
	     * @return {?}
	     */
	    function () {
	        this._elementSize = this._diameter + Math.max(this.strokeWidth - BASE_STROKE_WIDTH, 0);
	    };
	    /**
	     * Tracks diameters of existing instances to de-dupe generated styles (default d = 100)
	     */
	    MatProgressSpinner.diameters = new Set([BASE_SIZE]);
	    /**
	     * Used for storing all of the generated keyframe animations.
	     * \@dynamic
	     */
	    MatProgressSpinner.styleTag = null;
	    MatProgressSpinner.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-progress-spinner',
	                    exportAs: 'matProgressSpinner',
	                    host: {
	                        'role': 'progressbar',
	                        'class': 'mat-progress-spinner',
	                        '[style.width.px]': '_elementSize',
	                        '[style.height.px]': '_elementSize',
	                        '[attr.aria-valuemin]': 'mode === "determinate" ? 0 : null',
	                        '[attr.aria-valuemax]': 'mode === "determinate" ? 100 : null',
	                        '[attr.aria-valuenow]': 'value',
	                        '[attr.mode]': 'mode',
	                    },
	                    inputs: ['color'],
	                    template: "<svg [style.width.px]=\"_elementSize\" [style.height.px]=\"_elementSize\" [attr.viewBox]=\"_viewBox\" preserveAspectRatio=\"xMidYMid meet\" focusable=\"false\"><circle cx=\"50%\" cy=\"50%\" [attr.r]=\"_circleRadius\" [style.animation-name]=\"'mat-progress-spinner-stroke-rotate-' + diameter\" [style.stroke-dashoffset.px]=\"_strokeDashOffset\" [style.stroke-dasharray.px]=\"_strokeCircumference\" [style.stroke-width.%]=\"_circleStrokeWidth\"></circle></svg>",
	                    styles: [".mat-progress-spinner{display:block;position:relative}.mat-progress-spinner svg{position:absolute;transform:rotate(-90deg);top:0;left:0;transform-origin:center;overflow:visible}.mat-progress-spinner circle{fill:transparent;transform-origin:center;transition:stroke-dashoffset 225ms linear}.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate]{animation:mat-progress-spinner-linear-rotate 2s linear infinite}.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate] circle{transition-property:stroke;animation-duration:4s;animation-timing-function:cubic-bezier(.35,0,.25,1);animation-iteration-count:infinite}.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate]{animation:mat-progress-spinner-stroke-rotate-fallback 10s cubic-bezier(.87,.03,.33,1) infinite}.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate] circle{transition-property:stroke}@keyframes mat-progress-spinner-linear-rotate{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes mat-progress-spinner-stroke-rotate-100{0%{stroke-dashoffset:268.60617px;transform:rotate(0)}12.5%{stroke-dashoffset:56.54867px;transform:rotate(0)}12.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(72.5deg)}25%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(72.5deg)}25.0001%{stroke-dashoffset:268.60617px;transform:rotate(270deg)}37.5%{stroke-dashoffset:56.54867px;transform:rotate(270deg)}37.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(161.5deg)}50%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(161.5deg)}50.0001%{stroke-dashoffset:268.60617px;transform:rotate(180deg)}62.5%{stroke-dashoffset:56.54867px;transform:rotate(180deg)}62.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(251.5deg)}75%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(251.5deg)}75.0001%{stroke-dashoffset:268.60617px;transform:rotate(90deg)}87.5%{stroke-dashoffset:56.54867px;transform:rotate(90deg)}87.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(341.5deg)}100%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(341.5deg)}}@keyframes mat-progress-spinner-stroke-rotate-fallback{0%{transform:rotate(0)}25%{transform:rotate(1170deg)}50%{transform:rotate(2340deg)}75%{transform:rotate(3510deg)}100%{transform:rotate(4680deg)}}"],
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                },] },
	    ];
	    /** @nocollapse */
	    MatProgressSpinner.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_platform.Platform, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    MatProgressSpinner.propDecorators = {
	        "diameter": [{ type: _angular_core.Input },],
	        "strokeWidth": [{ type: _angular_core.Input },],
	        "mode": [{ type: _angular_core.Input },],
	        "value": [{ type: _angular_core.Input },],
	    };
	    return MatProgressSpinner;
	}(_MatProgressSpinnerMixinBase));
	/**
	 * `<mat-spinner>` component.
	 *
	 * This is a component definition to be used as a convenience reference to create an
	 * indeterminate `<mat-progress-spinner>` instance.
	 */
	var MatSpinner = /** @class */ (function (_super) {
	    __extends(MatSpinner, _super);
	    function MatSpinner(elementRef, platform, document) {
	        var _this = _super.call(this, elementRef, platform, document) || this;
	        _this.mode = 'indeterminate';
	        return _this;
	    }
	    MatSpinner.decorators = [
	        { type: _angular_core.Component, args: [{selector: 'mat-spinner',
	                    host: {
	                        'role': 'progressbar',
	                        'mode': 'indeterminate',
	                        'class': 'mat-spinner mat-progress-spinner',
	                        '[style.width.px]': '_elementSize',
	                        '[style.height.px]': '_elementSize',
	                    },
	                    inputs: ['color'],
	                    template: "<svg [style.width.px]=\"_elementSize\" [style.height.px]=\"_elementSize\" [attr.viewBox]=\"_viewBox\" preserveAspectRatio=\"xMidYMid meet\" focusable=\"false\"><circle cx=\"50%\" cy=\"50%\" [attr.r]=\"_circleRadius\" [style.animation-name]=\"'mat-progress-spinner-stroke-rotate-' + diameter\" [style.stroke-dashoffset.px]=\"_strokeDashOffset\" [style.stroke-dasharray.px]=\"_strokeCircumference\" [style.stroke-width.%]=\"_circleStrokeWidth\"></circle></svg>",
	                    styles: [".mat-progress-spinner{display:block;position:relative}.mat-progress-spinner svg{position:absolute;transform:rotate(-90deg);top:0;left:0;transform-origin:center;overflow:visible}.mat-progress-spinner circle{fill:transparent;transform-origin:center;transition:stroke-dashoffset 225ms linear}.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate]{animation:mat-progress-spinner-linear-rotate 2s linear infinite}.mat-progress-spinner.mat-progress-spinner-indeterminate-animation[mode=indeterminate] circle{transition-property:stroke;animation-duration:4s;animation-timing-function:cubic-bezier(.35,0,.25,1);animation-iteration-count:infinite}.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate]{animation:mat-progress-spinner-stroke-rotate-fallback 10s cubic-bezier(.87,.03,.33,1) infinite}.mat-progress-spinner.mat-progress-spinner-indeterminate-fallback-animation[mode=indeterminate] circle{transition-property:stroke}@keyframes mat-progress-spinner-linear-rotate{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes mat-progress-spinner-stroke-rotate-100{0%{stroke-dashoffset:268.60617px;transform:rotate(0)}12.5%{stroke-dashoffset:56.54867px;transform:rotate(0)}12.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(72.5deg)}25%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(72.5deg)}25.0001%{stroke-dashoffset:268.60617px;transform:rotate(270deg)}37.5%{stroke-dashoffset:56.54867px;transform:rotate(270deg)}37.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(161.5deg)}50%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(161.5deg)}50.0001%{stroke-dashoffset:268.60617px;transform:rotate(180deg)}62.5%{stroke-dashoffset:56.54867px;transform:rotate(180deg)}62.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(251.5deg)}75%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(251.5deg)}75.0001%{stroke-dashoffset:268.60617px;transform:rotate(90deg)}87.5%{stroke-dashoffset:56.54867px;transform:rotate(90deg)}87.5001%{stroke-dashoffset:56.54867px;transform:rotateX(180deg) rotate(341.5deg)}100%{stroke-dashoffset:268.60617px;transform:rotateX(180deg) rotate(341.5deg)}}@keyframes mat-progress-spinner-stroke-rotate-fallback{0%{transform:rotate(0)}25%{transform:rotate(1170deg)}50%{transform:rotate(2340deg)}75%{transform:rotate(3510deg)}100%{transform:rotate(4680deg)}}"],
	                    changeDetection: _angular_core.ChangeDetectionStrategy.OnPush,
	                    encapsulation: _angular_core.ViewEncapsulation.None,
	                    preserveWhitespaces: false,
	                },] },
	    ];
	    /** @nocollapse */
	    MatSpinner.ctorParameters = function () { return [
	        { type: _angular_core.ElementRef, },
	        { type: _angular_cdk_platform.Platform, },
	        { type: undefined, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Inject, args: [_angular_common.DOCUMENT,] },] },
	    ]; };
	    return MatSpinner;
	}(MatProgressSpinner));
	
	/**
	 * @fileoverview added by tsickle
	 * @suppress {checkTypes} checked by tsc
	 */
	var MatProgressSpinnerModule = /** @class */ (function () {
	    function MatProgressSpinnerModule() {
	    }
	    MatProgressSpinnerModule.decorators = [
	        { type: _angular_core.NgModule, args: [{
	                    imports: [_angular_material_core.MatCommonModule, _angular_cdk_platform.PlatformModule],
	                    exports: [
	                        MatProgressSpinner,
	                        MatSpinner,
	                        _angular_material_core.MatCommonModule
	                    ],
	                    declarations: [
	                        MatProgressSpinner,
	                        MatSpinner
	                    ],
	                },] },
	    ];
	    /** @nocollapse */
	    MatProgressSpinnerModule.ctorParameters = function () { return []; };
	    return MatProgressSpinnerModule;
	}());
	
	exports.MatProgressSpinnerModule = MatProgressSpinnerModule;
	exports.MatProgressSpinnerBase = MatProgressSpinnerBase;
	exports._MatProgressSpinnerMixinBase = _MatProgressSpinnerMixinBase;
	exports.MatProgressSpinner = MatProgressSpinner;
	exports.MatSpinner = MatSpinner;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=material-progress-spinner.umd.js.map


/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var range_radio_group_component_1 = __webpack_require__(1554);
	__export(__webpack_require__(1554));
	exports.RANGE_RADIO_GROUP_COMPONENTS = [
	    range_radio_group_component_1.RangeRadioGroupComponent
	];


/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var translate_1 = __webpack_require__(302);
	var util_1 = __webpack_require__(743);
	var forms_1 = __webpack_require__(768);
	var RangeRadioGroupComponent = (function () {
	    function RangeRadioGroupComponent(_translateManager) {
	        this._translateManager = _translateManager;
	        this.change = new core_1.EventEmitter();
	        this.propagateChange = function (_) {
	        };
	    }
	    RangeRadioGroupComponent_1 = RangeRadioGroupComponent;
	    Object.defineProperty(RangeRadioGroupComponent.prototype, "value", {
	        get: function () {
	            return this._value;
	        },
	        set: function (value) {
	            this._value = value;
	            this.propagateChange(this._value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    RangeRadioGroupComponent.prototype.getRangeLabel = function (rangeId) {
	        if (rangeId !== 9999) {
	            if (util_1.isNullOrUndefined(this.ranges) || util_1.isNullOrUndefined(rangeId)) {
	                return '';
	            }
	            if (util_1.isNullOrUndefined(rangeId))
	                return '';
	            var selectedRange = this.ranges.find(function (range) { return range.id === rangeId; });
	            if (util_1.isNullOrUndefined(selectedRange))
	                return '';
	            var rangeType = util_1.isNullOrUndefined(selectedRange.from) ? 'UP' : util_1.isNullOrUndefined(selectedRange.to) ? 'MORE' : 'FROM_TO';
	            return this._translateManager.getValue(this.translatePath + "." + rangeType, {
	                amountFrom: selectedRange.from,
	                amountTo: selectedRange.to,
	                unit: this.rangeUnit
	            });
	        }
	    };
	    RangeRadioGroupComponent.prototype.writeValue = function (value) {
	        if (value != this.value) {
	            this.value = value;
	        }
	    };
	    RangeRadioGroupComponent.prototype.registerOnChange = function (fn) {
	        this.propagateChange = fn;
	    };
	    RangeRadioGroupComponent.prototype.registerOnTouched = function (fn) {
	    };
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", Object)
	    ], RangeRadioGroupComponent.prototype, "change", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Boolean)
	    ], RangeRadioGroupComponent.prototype, "isEdited", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", Array)
	    ], RangeRadioGroupComponent.prototype, "ranges", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], RangeRadioGroupComponent.prototype, "translatePath", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], RangeRadioGroupComponent.prototype, "rangeUnit", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], RangeRadioGroupComponent.prototype, "title", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", String)
	    ], RangeRadioGroupComponent.prototype, "controlName", void 0);
	    RangeRadioGroupComponent = RangeRadioGroupComponent_1 = __decorate([
	        core_1.Component({
	            selector: 'tfl-range-radio-group',
	            template: __webpack_require__(1555),
	            providers: [
	                {
	                    provide: forms_1.NG_VALUE_ACCESSOR,
	                    useExisting: core_1.forwardRef(function () { return RangeRadioGroupComponent_1; }),
	                    multi: true
	                }
	            ]
	        }),
	        __metadata("design:paramtypes", [translate_1.TranslateManager])
	    ], RangeRadioGroupComponent);
	    return RangeRadioGroupComponent;
	    var RangeRadioGroupComponent_1;
	}());
	exports.RangeRadioGroupComponent = RangeRadioGroupComponent;


/***/ }),
/* 1555 */
/***/ (function(module, exports) {

	module.exports = "<label class=\"control-label col-sm-6 col-xs-12\">\n    {{title}}\n</label>\n<div class=\"control-container col-sm-6 col-xs-12\">\n    <div *ngIf=\"isEdited\">\n        <div *ngFor=\"let range of ranges\">\n            <input type=\"radio\"\n                   id=\"{{controlName}}-{{range.id}}\"\n                   [name]=\"controlName\"\n                   [(ngModel)]=\"value\"\n                   [value]=\"range.id\"\n                   required/>\n            <label for=\"{{controlName}}-{{range.id}}\">{{getRangeLabel(range.id)}}</label>\n        </div>\n        <p *ngIf=\"!value\" class=\"text-danger\">\n            {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.PRIVATE.REQUIRED_INPUT'|translate}}\n        </p>\n    </div>\n    <span *ngIf=\"!isEdited\">  {{getRangeLabel(value)}}   </span>\n</div>\n"

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var funds_information_component_1 = __webpack_require__(1557);
	__export(__webpack_require__(1557));
	exports.FUNDS_INFORMATION_COMPONENTS = [
	    funds_information_component_1.FundsInformationComponent
	];


/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var value_by_key_pipe_1 = __webpack_require__(1087);
	var private_accounts_service_1 = __webpack_require__(1405);
	var lodash_1 = __webpack_require__(268);
	var util_1 = __webpack_require__(743);
	var backoffice_ranges_service_1 = __webpack_require__(1118);
	var backoffice_reasons_service_1 = __webpack_require__(1102);
	var backoffice_purposes_service_1 = __webpack_require__(1120);
	var FundsInformationComponent = (function () {
	    function FundsInformationComponent(_privateAccountsService, valueByKeyPipe, _rangesService, _reasonService, _purposeService) {
	        this._privateAccountsService = _privateAccountsService;
	        this.valueByKeyPipe = valueByKeyPipe;
	        this._rangesService = _rangesService;
	        this._reasonService = _reasonService;
	        this._purposeService = _purposeService;
	        this.loading = true;
	        this.countries = [];
	        this.currencies = [];
	        this.isEdited = false;
	        this.countryOptions = [];
	        this.fundsInformation = null;
	        this.countriesTo = [];
	        this.countriesFrom = [];
	        this.NOT_PROVIDED = 'Not provided';
	        this.COUNTRY_MALTA_ID = 123;
	        this.UNIT_EUR = 'EUR';
	        this.AVERAGE_MONTHLY_INCOME_RANGES_GROUP_ID = 0;
	        this.AVERAGE_INCOMING_TRANSACTION_RANGES_GROUP_ID = 1;
	        this.MONTHLY_INCOMING_FREQUENCY_RANGES_GROUP_ID = 3;
	        this.AVERAGE_OUTGOING_TRANSACTION_RANGES_GROUP_ID = 4;
	        this.MONTHLY_OUTGOING_FREQUENCY_RANGES_GROUP_ID = 6;
	        this.PLANNED_MONTHLY_INCOMING_TURNOVER_RANGES_GROUP_ID = 13;
	        this.PLANNED_MONTHLY_OUTGOING_TURNOVER_RANGES_GROUP_ID = 13;
	        this.PLANNED_MONTHLY_INCOMING_TURNOVER_RANGES_MORE_GROUP_ID = 14;
	        this.PLANNED_MONTHLY_OUTGOING_TURNOVER_RANGES_MORE_GROUP_ID = 14;
	        this.FUNDS_SOURCES_GROUP_ID = 2;
	    }
	    FundsInformationComponent_1 = FundsInformationComponent;
	    Object.defineProperty(FundsInformationComponent.prototype, "setApplicantInformation", {
	        set: function (data) {
	            this.fundsInformation = data;
	            if (this.fundsInformation) {
	                this.fundsInformationEdit = FundsInformationComponent_1.mapToFundsModeSection(lodash_1.cloneDeep(this.fundsInformation));
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    FundsInformationComponent.mapToFundsModeSection = function (fundsSection) {
	        return {
	            jurisdiction: fundsSection.initialFunding.jurisdiction,
	            accountName: fundsSection.initialFunding.accountName,
	            averageMonthlyIncome: fundsSection.initialFunding.averageMonthlyIncome,
	            primaryIncomeSource: fundsSection.initialFunding.primaryIncomeSource,
	            primaryIncomeSourceOther: fundsSection.initialFunding.primaryIncomeSourceOther,
	            countriesTo: fundsSection.transferActivity.countriesTo,
	            countriesFrom: fundsSection.transferActivity.countriesFrom,
	            purposeOfAccount: fundsSection.transferActivity.purposeOfAccount,
	            purposeOfAccountCustom: fundsSection.transferActivity.purposeOfAccountCustom,
	            averageIncomingTransferAmount: fundsSection.transferActivity.averageIncomingTransferAmount,
	            plannedIncomingTurnoverAmount: fundsSection.transferActivity.plannedIncomingTurnoverAmount,
	            monthlyIncomingTransfersCount: fundsSection.transferActivity.monthlyIncomingTransfersCount,
	            averageOutgoingTransferAmount: fundsSection.transferActivity.averageOutgoingTransferAmount,
	            plannedOutgoingTurnoverAmount: fundsSection.transferActivity.plannedOutgoingTurnoverAmount,
	            monthlyOutgoingTransfersCount: fundsSection.transferActivity.monthlyOutgoingTransfersCount
	        };
	    };
	    FundsInformationComponent.mapToFundsSection = function (fundsInformationEdit) {
	        return {
	            initialFunding: {
	                jurisdiction: fundsInformationEdit.jurisdiction,
	                accountName: fundsInformationEdit.accountName,
	                averageMonthlyIncome: fundsInformationEdit.averageMonthlyIncome,
	                primaryIncomeSource: fundsInformationEdit.primaryIncomeSource,
	                primaryIncomeSourceOther: fundsInformationEdit.primaryIncomeSourceOther
	            },
	            transferActivity: {
	                countriesTo: fundsInformationEdit.countriesTo,
	                countriesFrom: fundsInformationEdit.countriesFrom,
	                purposeOfAccount: fundsInformationEdit.purposeOfAccount,
	                purposeOfAccountCustom: fundsInformationEdit.purposeOfAccountCustom,
	                averageIncomingTransferAmount: fundsInformationEdit.averageIncomingTransferAmount,
	                plannedIncomingTurnoverAmount: fundsInformationEdit.plannedIncomingTurnoverAmount,
	                monthlyIncomingTransfersCount: fundsInformationEdit.monthlyIncomingTransfersCount,
	                averageOutgoingTransferAmount: fundsInformationEdit.averageOutgoingTransferAmount,
	                plannedOutgoingTurnoverAmount: fundsInformationEdit.plannedOutgoingTurnoverAmount,
	                monthlyOutgoingTransfersCount: fundsInformationEdit.monthlyOutgoingTransfersCount,
	                cryptocurrencies: fundsInformationEdit.cryptocurrencies
	            }
	        };
	    };
	    FundsInformationComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.rangeMore = [57, 58, 59];
	        this._rangesService.getAllRangesByGroupId(this.AVERAGE_INCOMING_TRANSACTION_RANGES_GROUP_ID)
	            .subscribe(function (response) { return _this.averageIncomingTransactionRanges = response; });
	        this._rangesService.getAllRangesByGroupId(this.PLANNED_MONTHLY_INCOMING_TURNOVER_RANGES_GROUP_ID)
	            .subscribe(function (response) { return _this.plannedMonthlyIncomingTurnoverRanges = response; });
	        this._rangesService.getAllRangesByGroupId(this.PLANNED_MONTHLY_OUTGOING_TURNOVER_RANGES_GROUP_ID)
	            .subscribe(function (response) { return _this.plannedMonthlyOutgoingTurnoverRanges = response; });
	        this._rangesService.getAllRangesByGroupId(this.PLANNED_MONTHLY_INCOMING_TURNOVER_RANGES_MORE_GROUP_ID)
	            .subscribe(function (response) { return _this.plannedMonthlyIncomingTurnoverMoreRanges = response; });
	        this._rangesService.getAllRangesByGroupId(this.PLANNED_MONTHLY_OUTGOING_TURNOVER_RANGES_MORE_GROUP_ID)
	            .subscribe(function (response) { return _this.plannedMonthlyOutgoingTurnoverMoreRanges = response; });
	        this._rangesService.getAllRangesByGroupId(this.MONTHLY_INCOMING_FREQUENCY_RANGES_GROUP_ID)
	            .subscribe(function (response) { return _this.monthlyIncomingFrequencyRanges = response; });
	        this._rangesService.getAllRangesByGroupId(this.AVERAGE_OUTGOING_TRANSACTION_RANGES_GROUP_ID)
	            .subscribe(function (response) { return _this.averageOutgoingTransactionRanges = response; });
	        this._rangesService.getAllRangesByGroupId(this.MONTHLY_OUTGOING_FREQUENCY_RANGES_GROUP_ID)
	            .subscribe(function (response) { return _this.monthlyOutgoingFrequencyRanges = response; });
	        this._rangesService.getAllRangesByGroupId(this.AVERAGE_MONTHLY_INCOME_RANGES_GROUP_ID)
	            .subscribe(function (response) { return _this.averageMonthlyIncomeRanges = response; });
	        this._reasonService.getActiveReasonsByGroupId(this.FUNDS_SOURCES_GROUP_ID)
	            .subscribe(function (reasons) { return _this.fundsSources = reasons; });
	        this._purposeService.getPurposes()
	            .subscribe(function (purposes) { return _this.purposes = purposes; });
	    };
	    FundsInformationComponent.prototype.ngOnChanges = function (changes) {
	        if (changes['countries']) {
	            this.countryOptions = this.countries.map(function (country) {
	                return {
	                    label: country.name,
	                    value: String(country.id)
	                };
	            });
	        }
	    };
	    FundsInformationComponent.prototype.onEdit = function () {
	        this.countriesTo = this.fundsInformation.transferActivity.countriesTo.map(function (id) { return id.toString(); });
	        this.countriesFrom = this.fundsInformation.transferActivity.countriesFrom.map(function (id) { return id.toString(); });
	        this.fundsInformationEdit = FundsInformationComponent_1.mapToFundsModeSection(this.fundsInformation);
	        this.isEdited = true;
	    };
	    FundsInformationComponent.prototype.onDiscard = function () {
	        this.isEdited = false;
	        this.fundsInformationEdit = FundsInformationComponent_1.mapToFundsModeSection(this.fundsInformation);
	    };
	    FundsInformationComponent.prototype.onSave = function () {
	        var _this = this;
	        this.fundsInformationEdit.countriesTo = this.countriesTo.map(function (id) { return +id; });
	        this.fundsInformationEdit.countriesFrom = this.countriesFrom.map(function (id) { return +id; });
	        this.createStubsForApiFields();
	        this.fundsInformationEdit.cryptocurrencies = this.fundsInformation.transferActivity.cryptocurrencies;
	        this._privateAccountsService.updateFundsInformation(this.profileId, this.fundsInformationEdit)
	            .subscribe(function (response) { return _this.fundsInformation = FundsInformationComponent_1.mapToFundsSection(lodash_1.cloneDeep(response)); });
	        this.isEdited = false;
	    };
	    FundsInformationComponent.prototype.isValid = function () {
	        return this.countriesTo.length !== 0 && this.countriesFrom.length !== 0;
	    };
	    FundsInformationComponent.prototype.templateDict = function (value) {
	        return this.translatePath + "." + value;
	    };
	    FundsInformationComponent.prototype.getOutgoingControlName = function () {
	        return this.isMoreOutgoingRange() ? 'plannedOutgoingTurnoverAmountMore' : 'plannedOutgoingTurnoverAmount';
	    };
	    FundsInformationComponent.prototype.getIdOutgoingPlanned = function () {
	        return this.isMoreOutgoingRange() ? 'planned-outgoing-turnover-amount-more' : 'planned-outgoing-turnover-amount';
	    };
	    FundsInformationComponent.prototype.getOutgoingRangePlanned = function () {
	        return this.isMoreOutgoingRange() ? this.plannedMonthlyOutgoingTurnoverMoreRanges : this.plannedMonthlyOutgoingTurnoverRanges;
	    };
	    FundsInformationComponent.prototype.getIncomingControlName = function () {
	        return this.isMoreIncomingRange() ? 'plannedIncomingTurnoverAmountMore' : 'plannedIncomingTurnoverAmount';
	    };
	    FundsInformationComponent.prototype.getIdIncomingPlanned = function () {
	        return this.isMoreIncomingRange() ? 'planned-incoming-turnover-amount-more' : 'planned-incoming-turnover-amount';
	    };
	    FundsInformationComponent.prototype.getIncomingRangePlanned = function () {
	        return this.isMoreIncomingRange() ? this.plannedMonthlyIncomingTurnoverMoreRanges : this.plannedMonthlyIncomingTurnoverRanges;
	    };
	    FundsInformationComponent.prototype.isPrimaryIncomeSourceOtherRequired = function () {
	        var _this = this;
	        var fundsSource = this.fundsSources.find(function (source) { return source.id === _this.fundsInformationEdit.primaryIncomeSource; });
	        if (util_1.isNullOrUndefined(fundsSource)) {
	            return false;
	        }
	        return fundsSource.specify;
	    };
	    FundsInformationComponent.prototype.getPrimaryIncomeSource = function () {
	        var _this = this;
	        var fundsSource = this.fundsSources.find(function (source) { return source.id == _this.fundsInformation.initialFunding.primaryIncomeSource; });
	        if (util_1.isNullOrUndefined(fundsSource)) {
	            return '';
	        }
	        return (fundsSource.specify) ? this.fundsInformation.initialFunding.primaryIncomeSourceOther : fundsSource.name;
	    };
	    FundsInformationComponent.prototype.onPrimaryIncomeSourceSelect = function () {
	        this.fundsInformationEdit.primaryIncomeSourceOther = null;
	    };
	    FundsInformationComponent.prototype.onChangeInputValue = function (event, fieldName) {
	        this.fundsInformationEdit[fieldName] = event.target.value;
	    };
	    FundsInformationComponent.prototype.isMoreIncomingRange = function () {
	        return this.rangeMore.indexOf(this.fundsInformationEdit.plannedIncomingTurnoverAmount) !== -1;
	    };
	    FundsInformationComponent.prototype.isMoreOutgoingRange = function () {
	        return this.rangeMore.indexOf(this.fundsInformationEdit.plannedOutgoingTurnoverAmount) !== -1;
	    };
	    FundsInformationComponent.prototype.createStubsForApiFields = function () {
	        this.fundsInformationEdit.jurisdiction = this.COUNTRY_MALTA_ID;
	        this.fundsInformationEdit.accountName = this.NOT_PROVIDED;
	    };
	    __decorate([
	        core_1.Input('loading'),
	        __metadata("design:type", Object)
	    ], FundsInformationComponent.prototype, "loading", void 0);
	    __decorate([
	        core_1.Input('countries'),
	        __metadata("design:type", Array)
	    ], FundsInformationComponent.prototype, "countries", void 0);
	    __decorate([
	        core_1.Input('profileId'),
	        __metadata("design:type", Number)
	    ], FundsInformationComponent.prototype, "profileId", void 0);
	    __decorate([
	        core_1.Input('currencies'),
	        __metadata("design:type", Array)
	    ], FundsInformationComponent.prototype, "currencies", void 0);
	    __decorate([
	        core_1.Input('systemOrWL'),
	        __metadata("design:type", String)
	    ], FundsInformationComponent.prototype, "systemOrWL", void 0);
	    __decorate([
	        core_1.Input('translatePath'),
	        __metadata("design:type", String)
	    ], FundsInformationComponent.prototype, "translatePath", void 0);
	    __decorate([
	        core_1.Input('fundsInformation'),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [Object])
	    ], FundsInformationComponent.prototype, "setApplicantInformation", null);
	    FundsInformationComponent = FundsInformationComponent_1 = __decorate([
	        core_1.Component({
	            selector: 'tfl-private-profile-detail-funds-information',
	            template: __webpack_require__(1558),
	            providers: [value_by_key_pipe_1.ValueByKeyPipe]
	        }),
	        __metadata("design:paramtypes", [private_accounts_service_1.PrivateAccountsService,
	            value_by_key_pipe_1.ValueByKeyPipe,
	            backoffice_ranges_service_1.BackofficeRangesService,
	            backoffice_reasons_service_1.BackofficeReasonsService,
	            backoffice_purposes_service_1.BackofficePurposesService])
	    ], FundsInformationComponent);
	    return FundsInformationComponent;
	    var FundsInformationComponent_1;
	}());
	exports.FundsInformationComponent = FundsInformationComponent;


/***/ }),
/* 1558 */
/***/ (function(module, exports) {

	module.exports = "<tfl-panel-details caption=\"APPLICATIONS.NEW.DETAIL.TAB.DETAILS.PRIVATE.FUNDS_INFORMATION.TITLE\">\n    <tfl-edit-button-group\n        (discard)=\"onDiscard()\"\n        (edit)=\"onEdit()\"\n        (save)=\"onSave()\"\n        [isSaveDisabled]=\"false\">\n    </tfl-edit-button-group>\n\n    <form #form=\"ngForm\" class=\"form-horizontal\">\n        <div *ngIf=\"!loading && fundsInformation\" [ngClass]=\"{'editing': isEdited}\" class=\"row\">\n<!--            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">-->\n<!--                <div class=\"form-group\">-->\n<!--                    <label class=\"header-label control-label col-sm-12 col-xs-12\">-->\n<!--                        {{templateDict(-->\n<!--                        'FUNDS_INFORMATION.SOURCE_OF_INITIAL_FUNDING.TITLE') | translate}}-->\n<!--                    </label>-->\n<!--                </div>-->\n<!--            </div>-->\n\n<!--            <div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\">-->\n<!--                <div class=\"form-group\">-->\n<!--                    <tfl-range-radio-group-->\n<!--                        [(ngModel)]=\"fundsInformationEdit.averageMonthlyIncome\"-->\n<!--                        [isEdited]=\"isEdited\"-->\n<!--                        [rangeUnit]=\"UNIT_EUR\"-->\n<!--                        [ranges]=\"averageMonthlyIncomeRanges\"-->\n<!--                        [title]=\"templateDict('FUNDS_INFORMATION.SOURCE_OF_INITIAL_FUNDING.AVERAGE_MONTHLY_INCOME') | translate\"-->\n<!--                        [translatePath]=\"templateDict('FUNDS_INFORMATION.RANGE')\"-->\n<!--                        controlName=\"averageMonthlyIncome\"-->\n<!--                        id=\"average-monthly-income\"-->\n<!--                        name=\"averageMonthluIncome\">-->\n<!--                    </tfl-range-radio-group>-->\n<!--                </div>-->\n<!--                <div [ngClass]=\"{'has-error': isEdited && !fundsInformationEdit.primaryIncomeSource}\"-->\n<!--                     class=\"form-group\">-->\n<!--                    <label class=\"control-label col-sm-6 col-xs-12\">-->\n<!--                        {{templateDict(-->\n<!--                        'FUNDS_INFORMATION.SOURCE_OF_INITIAL_FUNDING.PRIMARY_INCOME_SOURCE')|translate}}-->\n<!--                    </label>-->\n<!--                    <div class=\"col-sm-6 col-xs-12 control-container\">-->\n<!--                        <select (change)=\"onPrimaryIncomeSourceSelect()\"-->\n<!--                                *ngIf=\"isEdited\"-->\n<!--                                [(ngModel)]=\"fundsInformationEdit.primaryIncomeSource\"-->\n<!--                                class=\"form-control\"-->\n<!--                                id=\"funds-primary-income-source\"-->\n<!--                                name=\"primaryIncomeSource\"-->\n<!--                                title=\"{{templateDict('FUNDS_INFORMATION.SOURCE_OF_INITIAL_FUNDING.PRIMARY_INCOME_SOURCE')|translate}}\">-->\n<!--                            <option *ngFor=\"let source of fundsSources\"-->\n<!--                                    [selected]=\"source.id===fundsInformationEdit.primaryIncomeSource\"-->\n<!--                                    [value]=\"source.id\">-->\n<!--                                {{source.name}}-->\n<!--                            </option>-->\n<!--                        </select>-->\n<!--                        &lt;!&ndash;                        <p *ngIf=\"isEdited && !fundsInformationEdit.primaryIncomeSource\"&ndash;&gt;-->\n<!--                        &lt;!&ndash;                           class=\"text-danger\">&ndash;&gt;-->\n<!--                        &lt;!&ndash;                            {{ templateDict('REQUIRED_INPUT') | translate}}&ndash;&gt;-->\n<!--                        &lt;!&ndash;                        </p>&ndash;&gt;-->\n<!--                        <span *ngIf=\"!isEdited\"-->\n<!--                              id=\"primary-income-source\">{{getPrimaryIncomeSource()}}</span>-->\n<!--                    </div>-->\n<!--                </div>-->\n<!--                <div *ngIf=\"isEdited\"-->\n<!--                     [ngClass]=\"{'has-error': fundsInformationEdit.primaryIncomeSourceOther == null || fundsInformationEdit.primaryIncomeSourceOther.length < 5}\"-->\n<!--                     class=\"form-group\">-->\n<!--                    <div class=\"col-sm-offset-6 col-sm-6 col-xs-12 control-container\">-->\n<!--                        <input (input)=\"onChangeInputValue($event, 'primaryIncomeSourceOther')\"-->\n<!--                               [(ngModel)]=\"fundsInformationEdit.primaryIncomeSourceOther\"-->\n<!--                               class=\"form-control\"-->\n<!--                               id=\"funds-primary-income-source-other\"-->\n<!--                               maxlength=\"250\"-->\n<!--                               minlength=\"5\"-->\n<!--                               name=\"primaryIncomeSourceOther\"-->\n<!--                               title=\"{{templateDict('FUNDS_INFORMATION.SOURCE_OF_INITIAL_FUNDING.PRIMARY_INCOME_SOURCE')|translate}}\"-->\n<!--                               trim=\"blur\"/>-->\n<!--                        &lt;!&ndash;                        <p *ngIf=\"fundsInformationEdit.primaryIncomeSourceOther == null\"&ndash;&gt;-->\n<!--                        &lt;!&ndash;                           class=\"text-danger\">&ndash;&gt;-->\n<!--                        &lt;!&ndash;                            {{ templateDict('REQUIRED_INPUT') | translate}}&ndash;&gt;-->\n<!--                        &lt;!&ndash;                        </p>&ndash;&gt;-->\n<!--                        &lt;!&ndash;                        <p *ngIf=\"fundsInformationEdit.primaryIncomeSourceOther && fundsInformationEdit.primaryIncomeSourceOther.length < 5\"&ndash;&gt;-->\n<!--                        &lt;!&ndash;                           class=\"text-danger\">&ndash;&gt;-->\n<!--                        &lt;!&ndash;                            {{ 'VALIDATION.MIN_LENGTH' | translate:{value: 5} }}&ndash;&gt;-->\n<!--                        &lt;!&ndash;                        </p>&ndash;&gt;-->\n<!--                    </div>-->\n<!--                </div>-->\n<!--            </div>-->\n<!--            <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">-->\n<!--                <div class=\"form-group\">-->\n<!--                    <label class=\"header-label control-label col-sm-12 col-xs-12\">-->\n<!--                        {{ templateDict(-->\n<!--                        'FUNDS_INFORMATION.EXPECTED_TRANSFER_ACTIVITY.TITLE') | translate}}-->\n<!--                    </label>-->\n<!--                </div>-->\n<!--            </div>-->\n            <div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\">\n<!--                <div class=\"form-group\">-->\n<!--                    <label class=\"control-label col-sm-6 col-xs-12\">-->\n<!--                        {{ templateDict(-->\n<!--                        'FUNDS_INFORMATION.EXPECTED_TRANSFER_ACTIVITY.MAIN_COUNTRIES_TO') | translate}}-->\n<!--                    </label>-->\n<!--                    <div class=\"control-label col-sm-6 col-xs-12\">-->\n<!--                        <div *ngIf=\"isEdited\">-->\n<!--                            <ng-select-->\n<!--                                [(ngModel)]=\"countriesTo\"-->\n<!--                                [multiple]=\"true\"-->\n<!--                                [options]=\"countryOptions\"-->\n<!--                                id=\"countriesToInput\"-->\n<!--                                name=\"countriesTo\"-->\n<!--                            >-->\n<!--                            </ng-select>-->\n<!--                            &lt;!&ndash;                            <p *ngIf=\"countriesTo.length === 0\" class=\"text-danger\">&ndash;&gt;-->\n<!--                            &lt;!&ndash;                                {{ templateDict('REQUIRED_INPUT') | translate}}&ndash;&gt;-->\n<!--                            &lt;!&ndash;                            </p>&ndash;&gt;-->\n<!--                        </div>-->\n<!--                        <div *ngIf=\"!isEdited\">-->\n<!--                            <tfl-bo-badge-->\n<!--                                *ngFor=\"let country of fundsInformation.transferActivity.countriesTo\">-->\n<!--                                {{country|value_by_key:countries}}-->\n<!--                            </tfl-bo-badge>-->\n<!--                        </div>-->\n<!--                    </div>-->\n<!--                </div>-->\n<!--                <div class=\"form-group\">-->\n<!--                    <label class=\"control-label col-sm-6 col-xs-12\">-->\n<!--                        {{ templateDict(-->\n<!--                        'FUNDS_INFORMATION.EXPECTED_TRANSFER_ACTIVITY.MAIN_COUNTRIES_FROM') | translate}}-->\n<!--                    </label>-->\n<!--                    <div class=\"control-label col-sm-6 col-xs-12\">-->\n<!--                        <div *ngIf=\"isEdited\">-->\n<!--                            <ng-select-->\n<!--                                [(ngModel)]=\"countriesFrom\"-->\n<!--                                [multiple]=\"true\"-->\n<!--                                [options]=\"countryOptions\"-->\n<!--                                id=\"countriesFromInput\"-->\n<!--                                name=\"countriesFrom\"-->\n<!--                            >-->\n<!--                            </ng-select>-->\n<!--                            &lt;!&ndash;                            <p *ngIf=\"countriesTo.length === 0\" class=\"text-danger\">&ndash;&gt;-->\n<!--                            &lt;!&ndash;                                {{ templateDict('REQUIRED_INPUT') | translate}}&ndash;&gt;-->\n<!--                            &lt;!&ndash;                            </p>&ndash;&gt;-->\n<!--                        </div>-->\n<!--                        <div *ngIf=\"!isEdited\">-->\n<!--                            <tfl-bo-badge-->\n<!--                                *ngFor=\"let country of fundsInformation.transferActivity.countriesFrom\">-->\n<!--                                {{country|value_by_key:countries}}-->\n<!--                            </tfl-bo-badge>-->\n<!--                        </div>-->\n<!--                    </div>-->\n<!--                </div>-->\n<!--                <div class=\"form-group\">-->\n<!--                    <label class=\"control-label col-sm-6 col-xs-12\">-->\n<!--                        {{ templateDict(-->\n<!--                        'FUNDS_INFORMATION.EXPECTED_TRANSFER_ACTIVITY.PURPOSE_OF_ACCOUNT') | translate}}-->\n<!--                    </label>-->\n<!--                    <div class=\"control-label col-sm-6 col-xs-12\">-->\n<!--                        <select *ngIf=\"isEdited\"-->\n<!--                                [(ngModel)]=\"fundsInformationEdit.purposeOfAccount\"-->\n<!--                                class=\"form-control\"-->\n<!--                                id=\"funds-purpose-of-account\"-->\n<!--                                name=\"purposeOfAccount\"-->\n<!--                                title=\"{{templateDict('FUNDS_INFORMATION.EXPECTED_TRANSFER_ACTIVITY.PURPOSE_OF_ACCOUNT')|translate}}\">-->\n<!--                            <option *ngFor=\"let source of purposes\"-->\n<!--                                    [selected]=\"source.id===fundsInformationEdit.purposeOfAccount\"-->\n<!--                                    [value]=\"source.id\">-->\n<!--                                {{source.name}}-->\n<!--                            </option>-->\n<!--                        </select>-->\n<!--                        <span *ngIf=\"!isEdited\" id=\"purpose-of-account\">-->\n<!--                                {{fundsInformation.transferActivity.purposeOfAccount|value_by_key:purposes}}-->\n<!--                        </span>-->\n<!--                        <span-->\n<!--                            *ngIf=\"!isEdited && fundsInformation.transferActivity.purposeOfAccountCustom != null\"-->\n<!--                            id=\"purpose-of-account-custom\">-->\n<!--                                {{fundsInformation.transferActivity.purposeOfAccountCustom}}-->\n<!--                        </span>-->\n<!--                    </div>-->\n<!--                </div>-->\n                <div class=\"form-group\">\n                    <tfl-range-radio-group\n                        [(ngModel)]=\"fundsInformationEdit.averageIncomingTransferAmount\"\n                        [isEdited]=\"isEdited\"\n                        [rangeUnit]=\"UNIT_EUR\"\n                        [ranges]=\"averageIncomingTransactionRanges\"\n                        [title]=\"templateDict('FUNDS_INFORMATION.EXPECTED_TRANSFER_ACTIVITY.AVERAGE_INCOMING_TRANSACTION') | translate\"\n                        [translatePath]=\"templateDict('FUNDS_INFORMATION.RANGE')\"\n                        controlName=\"averageIncomingTransferAmount\"\n                        id=\"average-incoming-transfer-amount\"\n                        name=\"averageIncomingTransferAmount\">\n                    </tfl-range-radio-group>\n                </div>\n\n                <div class=\"form-group\">\n                    <tfl-range-radio-group\n                        [(ngModel)]=\"fundsInformationEdit.monthlyIncomingTransfersCount\"\n                        [isEdited]=\"isEdited\"\n                        [ranges]=\"monthlyIncomingFrequencyRanges\"\n                        [title]=\"templateDict('FUNDS_INFORMATION.EXPECTED_TRANSFER_ACTIVITY.MONTHLY_INCOMING_FREQUENCY') | translate\"\n                        [translatePath]=\"templateDict('FUNDS_INFORMATION.RANGE_WITHOUT_UNIT')\"\n                        controlName=\"monthlyIncomingTransfersCount\"\n                        id=\"monthly-incoming-transfers-count\"\n                        name=\"monthlyIncomingTransfersCount\"\n                    >\n                    </tfl-range-radio-group>\n                </div>\n                <div class=\"form-group\">\n                    <tfl-range-radio-group\n                        [(ngModel)]=\"fundsInformationEdit.plannedIncomingTurnoverAmount\"\n                        [isEdited]=\"isEdited\"\n                        [rangeUnit]=\"UNIT_EUR\"\n                        [ranges]=\"getIncomingRangePlanned()\"\n                        [title]=\"templateDict('FUNDS_INFORMATION.EXPECTED_TRANSFER_ACTIVITY.PLANNED_MONTHLY_INCOMING_TURNOVER') | translate:{vendorTitle: systemOrWL}\"\n                        [translatePath]=\"templateDict('FUNDS_INFORMATION.RANGE')\"\n                        controlName=\"{{getIncomingControlName()}}\"\n                        id=\"{{getIdIncomingPlanned()}}\"\n                        name=\"{{getIncomingControlName()}}\">\n                    </tfl-range-radio-group>\n                    </div>\n                <div class=\"form-group\">\n                    <tfl-range-radio-group\n                        [(ngModel)]=\"fundsInformationEdit.plannedOutgoingTurnoverAmount\"\n                        [isEdited]=\"isEdited\"\n                        [rangeUnit]=\"UNIT_EUR\"\n                        [ranges]=\"getOutgoingRangePlanned()\"\n                        [title]=\"templateDict('FUNDS_INFORMATION.EXPECTED_TRANSFER_ACTIVITY.PLANNED_MONTHLY_OUTGOING_TURNOVER') | translate:{vendorTitle: systemOrWL}\"\n                        [translatePath]=\"templateDict('FUNDS_INFORMATION.RANGE')\"\n                        controlName=\"{{getOutgoingControlName()}}\"\n                        id=\"{{getIdOutgoingPlanned()}}\"\n                        name=\"{{getOutgoingControlName()}}\">\n                    </tfl-range-radio-group>\n                    </div>\n\n                <div class=\"form-group\">\n                    <label class=\"control-label col-sm-6 col-xs-12\">\n                        {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.PRIVATE.FUNDS_INFORMATION.CRYPTOCURRENCIES'|translate}}\n                    </label>\n                    <div class=\"col-sm-6 col-xs-12 control-container radio\">\n                        <label class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                            <input\n                                [(ngModel)]=\"fundsInformation.transferActivity.cryptocurrencies\"\n                                [attr.disabled]=\"!isEdited ? '' : null\"\n                                [value]=\"true\"\n                                name=\"cryptocurrencies\"\n                                type=\"radio\"\n                            >\n                            <span class=\"radio-span\"><b>YES</b></span>\n                        </label>\n                        <label class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                            <input\n                                [(ngModel)]=\"fundsInformation.transferActivity.cryptocurrencies\"\n                                [attr.disabled]=\"!isEdited ? '' : null\"\n                                [value]=\"false\"\n                                name=\"cryptocurrencies\"\n                                type=\"radio\"\n                            >\n                            <span class=\"radio-span\"><b>NO</b></span>\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </form>\n</tfl-panel-details>\n"

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var expected_turnover_component_1 = __webpack_require__(1560);
	__export(__webpack_require__(1560));
	exports.EXPECTED_TURNOVER_COMPONENTS = [
	    expected_turnover_component_1.ExpectedTurnoverComponent
	];


/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var value_by_key_pipe_1 = __webpack_require__(1087);
	var service_1 = __webpack_require__(1332);
	var lodash_1 = __webpack_require__(268);
	var backoffice_ranges_service_1 = __webpack_require__(1118);
	var ExpectedTurnoverComponent = (function () {
	    function ExpectedTurnoverComponent(_corporateAccountsService, _rangesService) {
	        this._corporateAccountsService = _corporateAccountsService;
	        this._rangesService = _rangesService;
	        this.loading = true;
	        this.countries = [];
	        this.expectedTurnover = null;
	        this.originalExpectedTurnover = null;
	        this.pattern = '^[a-zA-Z\\s-,\\.\']*$';
	        this.isEdited = false;
	        this.NOT_PROVIDED = 'Not provided';
	        this.UNIT_EUR = 'EUR';
	        this.AVERAGE_INCOMING_TRANSACTION_RANGES_GROUP_ID = 7;
	        this.PLANNED_MONTHLY_INCOMING_TURNOVER_RANGES_GROUP_ID = 8;
	        this.PLANNED_MONTHLY_INCOMING_TURNOVER_RANGES_MORE_GROUP_ID = 15;
	        this.PLANNED_MONTHLY_OUTGOING_TURNOVER_RANGES_MORE_GROUP_ID = 15;
	        this.MONTHLY_INCOMING_FREQUENCY_RANGES_GROUP_ID = 9;
	        this.AVERAGE_OUTGOING_TRANSACTION_RANGES_GROUP_ID = 10;
	        this.PLANNED_MONTHLY_OUTGOING_TURNOVER_RANGES_GROUP_ID = 11;
	        this.MONTHLY_OUTGOING_FREQUENCY_RANGES_GROUP_ID = 12;
	    }
	    Object.defineProperty(ExpectedTurnoverComponent.prototype, "setExpectedTurnovers", {
	        set: function (expectedTurnover) {
	            this.expectedTurnover = expectedTurnover;
	            this.originalExpectedTurnover = lodash_1.cloneDeep(expectedTurnover);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ExpectedTurnoverComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.rangeMore = [60, 61, 62];
	        this._rangesService.getAllRangesByGroupId(this.AVERAGE_INCOMING_TRANSACTION_RANGES_GROUP_ID)
	            .subscribe(function (response) { return _this.averageIncomingTransactionRanges = response; });
	        this._rangesService.getAllRangesByGroupId(this.PLANNED_MONTHLY_INCOMING_TURNOVER_RANGES_GROUP_ID)
	            .subscribe(function (response) { return _this.plannedMonthlyIncomingTurnoverRanges = response; });
	        this._rangesService.getAllRangesByGroupId(this.PLANNED_MONTHLY_OUTGOING_TURNOVER_RANGES_GROUP_ID)
	            .subscribe(function (response) { return _this.plannedMonthlyOutgoingTurnoverRanges = response; });
	        this._rangesService.getAllRangesByGroupId(this.PLANNED_MONTHLY_INCOMING_TURNOVER_RANGES_MORE_GROUP_ID)
	            .subscribe(function (response) { return _this.plannedMonthlyIncomingTurnoverMoreRanges = response; });
	        this._rangesService.getAllRangesByGroupId(this.PLANNED_MONTHLY_OUTGOING_TURNOVER_RANGES_MORE_GROUP_ID)
	            .subscribe(function (response) { return _this.plannedMonthlyOutgoingTurnoverMoreRanges = response; });
	        this._rangesService.getAllRangesByGroupId(this.MONTHLY_INCOMING_FREQUENCY_RANGES_GROUP_ID)
	            .subscribe(function (response) { return _this.monthlyIncomingFrequencyRanges = response; });
	        this._rangesService.getAllRangesByGroupId(this.AVERAGE_OUTGOING_TRANSACTION_RANGES_GROUP_ID)
	            .subscribe(function (response) { return _this.averageOutgoingTransactionRanges = response; });
	        this._rangesService.getAllRangesByGroupId(this.MONTHLY_OUTGOING_FREQUENCY_RANGES_GROUP_ID)
	            .subscribe(function (response) { return _this.monthlyOutgoingFrequencyRanges = response; });
	    };
	    ExpectedTurnoverComponent.prototype.onChangeInputValue = function (event, fieldName) {
	        this.expectedTurnover[fieldName] = event.target.value;
	    };
	    ExpectedTurnoverComponent.prototype.onChangeInputAmount = function (event, fieldName) {
	        if (lodash_1.isEmpty(lodash_1.get(event, "target.value", ""))) {
	            this.expectedTurnover[fieldName] = undefined;
	        }
	        else {
	            this.expectedTurnover[fieldName] = {};
	            this.expectedTurnover[fieldName].amount = event.target.value;
	            this.expectedTurnover[fieldName].currency_code = "EUR";
	        }
	    };
	    ExpectedTurnoverComponent.prototype.onChangeInputMainSuppliers = function (event, index) {
	        this.expectedTurnover.mainSuppliers[index].companyName = event.target.value;
	    };
	    ExpectedTurnoverComponent.prototype.onChangeInputMainClients = function (event, index) {
	        this.expectedTurnover.mainClients[index].companyName = event.target.value;
	    };
	    ExpectedTurnoverComponent.prototype.getMainSuppliers = function () {
	        var _this = this;
	        return this.expectedTurnover
	            .mainSuppliers
	            .map(function (item) { return item.companyName + "/" + new value_by_key_pipe_1.ValueByKeyPipe().transform(item.country, _this.countries); })
	            .join(", ");
	    };
	    ExpectedTurnoverComponent.prototype.getMainClients = function () {
	        var _this = this;
	        return this.expectedTurnover
	            .mainClients
	            .map(function (item) { return item.companyName + "/" + new value_by_key_pipe_1.ValueByKeyPipe().transform(item.country, _this.countries); })
	            .join(", ");
	    };
	    ExpectedTurnoverComponent.prototype.onEdit = function () {
	        this.isEdited = true;
	    };
	    ExpectedTurnoverComponent.prototype.onDiscard = function () {
	        this.expectedTurnover = lodash_1.cloneDeep(this.originalExpectedTurnover);
	        this.isEdited = false;
	    };
	    ExpectedTurnoverComponent.prototype.onSave = function () {
	        var _this = this;
	        this.createStubsForApiFields();
	        this._corporateAccountsService.updateExpectedTurnover(this.profileId, this.expectedTurnover)
	            .subscribe(function (expectedTurnover) { return _this.expectedTurnover = lodash_1.cloneDeep(expectedTurnover); });
	        this.originalExpectedTurnover = lodash_1.cloneDeep(this.expectedTurnover);
	        this.isEdited = false;
	    };
	    ExpectedTurnoverComponent.prototype.addMainSuppliers = function () {
	        this.expectedTurnover.mainSuppliers.push(this.createNewMainServiceOwner());
	    };
	    ExpectedTurnoverComponent.prototype.addMainClients = function () {
	        this.expectedTurnover.mainClients.push(this.createNewMainServiceOwner());
	    };
	    ExpectedTurnoverComponent.prototype.removeMainSupplier = function (index) {
	        this.expectedTurnover.mainSuppliers.splice(index, 1);
	    };
	    ExpectedTurnoverComponent.prototype.removeMainClient = function (index) {
	        this.expectedTurnover.mainClients.splice(index, 1);
	    };
	    ExpectedTurnoverComponent.prototype.createNewMainServiceOwner = function () {
	        return {
	            companyName: "",
	            country: null
	        };
	    };
	    ExpectedTurnoverComponent.prototype.isMoreIncomingRange = function () {
	        return this.rangeMore.indexOf(this.expectedTurnover.plannedIncomingTurnoverAmount) !== -1;
	    };
	    ExpectedTurnoverComponent.prototype.isMoreOutgoingRange = function () {
	        return this.rangeMore.indexOf(this.expectedTurnover.plannedOutgoingTurnoverAmount) !== -1;
	    };
	    ExpectedTurnoverComponent.prototype.createStubsForApiFields = function () {
	        var _this = this;
	        this.expectedTurnover.mainSuppliers.forEach(function (supplier) { return supplier.companyName = _this.NOT_PROVIDED; });
	        this.expectedTurnover.mainClients.forEach(function (client) { return client.companyName = _this.NOT_PROVIDED; });
	    };
	    __decorate([
	        core_1.Input("profileId"),
	        __metadata("design:type", Number)
	    ], ExpectedTurnoverComponent.prototype, "profileId", void 0);
	    __decorate([
	        core_1.Input("loading"),
	        __metadata("design:type", Boolean)
	    ], ExpectedTurnoverComponent.prototype, "loading", void 0);
	    __decorate([
	        core_1.Input("countries"),
	        __metadata("design:type", Array)
	    ], ExpectedTurnoverComponent.prototype, "countries", void 0);
	    __decorate([
	        core_1.Input('systemOrWL'),
	        __metadata("design:type", String)
	    ], ExpectedTurnoverComponent.prototype, "systemOrWL", void 0);
	    __decorate([
	        core_1.Input("expectedTurnover"),
	        __metadata("design:type", Object),
	        __metadata("design:paramtypes", [Object])
	    ], ExpectedTurnoverComponent.prototype, "setExpectedTurnovers", null);
	    ExpectedTurnoverComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-profile-detail-expected-turnover',
	            template: __webpack_require__(1561)
	        }),
	        __metadata("design:paramtypes", [service_1.CorporateAccountsService,
	            backoffice_ranges_service_1.BackofficeRangesService])
	    ], ExpectedTurnoverComponent);
	    return ExpectedTurnoverComponent;
	}());
	exports.ExpectedTurnoverComponent = ExpectedTurnoverComponent;


/***/ }),
/* 1561 */
/***/ (function(module, exports) {

	module.exports = "<tfl-panel-details caption=\"CUSTOMER.DETAILS.TAB.DETAILS.CORPORATE.EXPECTED_TURNOVER.TITLE\">\n    <tfl-edit-button-group\n        (discard)=\"onDiscard()\"\n        (edit)=\"onEdit()\"\n        (save)=\"onSave()\"\n        [isSaveDisabled]=\"!editForm.form.valid || !editForm.form.dirty\">\n    </tfl-edit-button-group>\n\n    <form #editForm=\"ngForm\" class=\"form-horizontal\">\n        <div *ngIf=\"!loading && expectedTurnover\" [ngClass]=\"{'editing': isEdited}\" class=\"editing\">\n            <div class=\"row\">\n                <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n                    <div class=\"form-group\">\n                        <tfl-range-radio-group\n                            [(ngModel)]=\"expectedTurnover.averageIncomingTransferAmount\"\n                            [isEdited]=\"isEdited\"\n                            [rangeUnit]=\"UNIT_EUR\"\n                            [ranges]=\"averageIncomingTransactionRanges\"\n                            [title]=\"'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.EXPECTED_TURNOVER.AVERAGE_INCOMING_TRANSACTION' | translate\"\n                            [translatePath]=\"'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.EXPECTED_TURNOVER.RANGE'\"\n                            controlName=\"averageIncomingTransferAmount\"\n                            id=\"average-incoming-transfer-amount\"\n                            name=\"averageIncomingTransferAmount\"\n                            required>\n                        </tfl-range-radio-group>\n                    </div>\n                    <div class=\"form-group\">\n                        <tfl-range-radio-group\n                            [(ngModel)]=\"expectedTurnover.averageOutgoingTransferAmount\"\n                            [isEdited]=\"isEdited\"\n                            [rangeUnit]=\"UNIT_EUR\"\n                            [ranges]=\"averageOutgoingTransactionRanges\"\n                            [title]=\"'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.PRIVATE.FUNDS_INFORMATION.EXPECTED_TRANSFER_ACTIVITY.AVERAGE_OUTGOING_TRANSACTION' | translate\"\n                            [translatePath]=\"'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.EXPECTED_TURNOVER.RANGE'\"\n                            controlName=\"averageOutgoingTransferAmount\"\n                            id=\"average-outgoing-transfer-amount\"\n                            name=\"averageOutgoingTransferAmount\"\n                            required>\n                        </tfl-range-radio-group>\n                    </div>\n                    <div *ngIf=\"!isMoreIncomingRange()\">\n                        <div class=\"form-group\">\n                            <tfl-range-radio-group\n                                [(ngModel)]=\"expectedTurnover.plannedIncomingTurnoverAmount\"\n                                [isEdited]=\"isEdited\"\n                                [rangeUnit]=\"UNIT_EUR\"\n                                [ranges]=\"plannedMonthlyIncomingTurnoverRanges\"\n                                [title]=\"'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.PRIVATE.FUNDS_INFORMATION.EXPECTED_TRANSFER_ACTIVITY.PLANNED_MONTHLY_INCOMING_TURNOVER' | translate:{vendorTitle: systemOrWL}\"\n                                [translatePath]=\"'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.EXPECTED_TURNOVER.RANGE'\"\n                                controlName=\"plannedIncomingTurnoverAmount\"\n                                id=\"planned-incoming-turnover-amount\"\n                                name=\"plannedIncomingTurnoverAmount\"\n                                required>\n                            </tfl-range-radio-group>\n                        </div>\n                    </div>\n                    <div *ngIf=\"isMoreIncomingRange()\">\n                        <div class=\"form-group\">\n                            <tfl-range-radio-group\n                                [(ngModel)]=\"expectedTurnover.plannedIncomingTurnoverAmount\"\n                                [isEdited]=\"isEdited\"\n                                [rangeUnit]=\"UNIT_EUR\"\n                                [ranges]=\"plannedMonthlyIncomingTurnoverMoreRanges\"\n                                [title]=\"'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.PRIVATE.FUNDS_INFORMATION.EXPECTED_TRANSFER_ACTIVITY.PLANNED_MONTHLY_INCOMING_TURNOVER' | translate:{vendorTitle: systemOrWL}\"\n                                [translatePath]=\"'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.EXPECTED_TURNOVER.RANGE'\"\n                                controlName=\"plannedIncomingTurnoverAmountMore\"\n                                id=\"planned-incoming-turnover-amount-more\"\n                                name=\"plannedIncomingTurnoverAmountMore\"\n                                required>\n                            </tfl-range-radio-group>\n                        </div>\n                    </div>\n                    <div *ngIf=\"!isMoreOutgoingRange()\">\n                        <div class=\"form-group\">\n                            <tfl-range-radio-group\n                                [(ngModel)]=\"expectedTurnover.plannedOutgoingTurnoverAmount\"\n                                [isEdited]=\"isEdited\"\n                                [rangeUnit]=\"UNIT_EUR\"\n                                [ranges]=\"plannedMonthlyOutgoingTurnoverRanges\"\n                                [title]=\"'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.PRIVATE.FUNDS_INFORMATION.EXPECTED_TRANSFER_ACTIVITY.PLANNED_MONTHLY_OUTGOING_TURNOVER' | translate:{vendorTitle: systemOrWL}\"\n                                [translatePath]=\"'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.EXPECTED_TURNOVER.RANGE'\"\n                                controlName=\"plannedOutgoingTurnoverAmount\"\n                                id=\"planned-outgoing-turnover-amount\"\n                                name=\"plannedOutgoingTurnoverAmount\"\n                                required>\n                            </tfl-range-radio-group>\n                        </div>\n                    </div>\n\n                    <div *ngIf=\"isMoreOutgoingRange()\">\n                        <div class=\"form-group\">\n                            <tfl-range-radio-group\n                                [(ngModel)]=\"expectedTurnover.plannedOutgoingTurnoverAmount\"\n                                [isEdited]=\"isEdited\"\n                                [rangeUnit]=\"UNIT_EUR\"\n                                [ranges]=\"plannedMonthlyOutgoingTurnoverMoreRanges\"\n                                [title]=\"'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.PRIVATE.FUNDS_INFORMATION.EXPECTED_TRANSFER_ACTIVITY.PLANNED_MONTHLY_OUTGOING_TURNOVER' | translate:{vendorTitle: systemOrWL}\"\n                                [translatePath]=\"'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.EXPECTED_TURNOVER.RANGE'\"\n                                controlName=\"plannedOutgoingTurnoverAmountMore\"\n                                id=\"planned-outgoing-turnover-amount-more\"\n                                name=\"plannedOutgoingTurnoverAmountMore\"\n                                required>\n                            </tfl-range-radio-group>\n                        </div>\n                    </div>\n\n                    <div class=\"form-group\">\n                        <tfl-range-radio-group\n                            [(ngModel)]=\"expectedTurnover.monthlyIncomingTransfersCount\"\n                            [isEdited]=\"isEdited\"\n                            [ranges]=\"monthlyIncomingFrequencyRanges\"\n                            [title]=\"'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.EXPECTED_TURNOVER.MONTHLY_INCOMING_FREQUENCY' | translate\"\n                            [translatePath]=\"'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.EXPECTED_TURNOVER.RANGE_WITHOUT_UNIT'\"\n                            controlName=\"monthlyIncomingTransfersCount\"\n                            id=\"monthly-incoming-transfers-count\"\n                            name=\"monthlyIncomingTransfersCount\"\n                            required>\n                        </tfl-range-radio-group>\n                    </div>\n                    <div class=\"form-group\">\n                        <tfl-range-radio-group\n                            [(ngModel)]=\"expectedTurnover.monthlyOutgoingTransfersCount\"\n                            [isEdited]=\"isEdited\"\n                            [ranges]=\"monthlyOutgoingFrequencyRanges\"\n                            [title]=\"'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.EXPECTED_TURNOVER.MONTHLY_OUTGOING_FREQUENCY' | translate\"\n                            [translatePath]=\"'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.CORPORATE.EXPECTED_TURNOVER.RANGE_WITHOUT_UNIT'\"\n                            controlName=\"monthlyOutgoingTransfersCount\"\n                            id=\"monthly-outgoing-transfers-count\"\n                            name=\"monthlyOutgoingTransfersCount\"\n                            required>\n                        </tfl-range-radio-group>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                    <h4 class=\"pending-accounts-subtitle\">\n                        {{'CUSTOMER.DETAILS.TAB.DETAILS.CORPORATE.EXPECTED_TURNOVER.MAIN_CLIENTS'|translate}}\n                    </h4>\n                    <button (click)=\"addMainClients()\" *ngIf=\"isEdited\"\n                            class=\"btn btn-primary pull-right\">\n                        {{'CUSTOMER.DETAILS.TAB.DETAILS.ADD_NEW.BUTTON.NAME'|translate}}\n                    </button>\n                </div>\n            </div>\n            <div *ngFor=\"let mainClient of expectedTurnover.mainClients; let i = index\" class=\"row\">\n                <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n                    <div class=\"form-group\">\n                        <label class=\"control-label col-sm-6 col-xs-12\">\n                            {{'CUSTOMER.DETAILS.TAB.DETAILS.CORPORATE.COMMON.COUNTRY'|translate}}\n                        </label>\n                        <div class=\"col-sm-6 col-xs-12 control-container\">\n                            <div click-to-edit-input>\n                                <input *ngIf=\"isEdited\"\n                                       [(ngModel)]=\"mainClient.country\"\n                                       [ac-source]=\"countries\"\n                                       ac-key=\"id\"\n                                       ac-value=\"name\"\n                                       bs-autocomplete\n                                       class=\"form-control\"\n                                       id=\"main-client-country-{{i}}\"\n                                       maxlength=\"50\"\n                                       name=\"mainClientCountry-{{i}}\"\n                                       required\n                                       restrictForbiddenCharInput=\"{{ pattern }}\"\n                                       title=\"{{'CUSTOMER.DETAILS.TAB.DETAILS.CORPORATE.COMMON.COUNTRY'|translate}}\"\n                                       type=\"text\"/>\n                                <field-validator *ngIf=\"isEdited\" for=\"mainClientCountry-{{i}}\">\n                                    <message\n                                        type=\"required\">{{ 'VALIDATION.REQUIRED' | translate }}</message>\n                                    <message type=\"maxlength\">\n                                        {{ 'CUSTOMER.DETAILS.TAB.DETAILS.CORPORATE.MAXIMUM_LENGTH'|translate:{value: 50} }}\n                                    </message>\n                                </field-validator>\n                                <span *ngIf=\"!isEdited\">\n                                    {{mainClient.country |value_by_key:countries}}\n                                </span>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div *ngIf=\"isEdited && this.expectedTurnover.mainClients.length > 3\"\n                     class=\"col-lg-1 col-md-1 col-sm-1 col-xs-1\">\n                    <i (click)=\"removeMainClient(i)\" class=\"fa fa-trash fa-2x remove-btn\"></i>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                    <h4 class=\"pending-accounts-subtitle\">\n                        {{'CUSTOMER.DETAILS.TAB.DETAILS.CORPORATE.EXPECTED_TURNOVER.MAIN_SUPPLIERS'|translate}}\n                    </h4>\n                    <button (click)=\"addMainSuppliers()\" *ngIf=\"isEdited\"\n                            class=\"btn btn-primary pull-right\">\n                        {{'CUSTOMER.DETAILS.TAB.DETAILS.ADD_NEW.BUTTON.NAME'|translate}}\n                    </button>\n                </div>\n            </div>\n            <div *ngFor=\"let mainSupplier of expectedTurnover.mainSuppliers; let i = index\"\n                 class=\"row\">\n                <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n                    <div class=\"form-group\">\n                        <label class=\"control-label col-sm-6 col-xs-12\">\n                            {{'CUSTOMER.DETAILS.TAB.DETAILS.CORPORATE.COMMON.COUNTRY'|translate}}\n                        </label>\n                        <div class=\"col-sm-6 col-xs-12 control-container\">\n                            <div click-to-edit-input>\n                                <input *ngIf=\"isEdited\"\n                                       [(ngModel)]=\"mainSupplier.country\"\n                                       [ac-source]=\"countries\"\n                                       ac-key=\"id\"\n                                       ac-value=\"name\"\n                                       bs-autocomplete\n                                       class=\"form-control\"\n                                       id=\"main-supplier-country-{{i}}\"\n                                       maxlength=\"50\"\n                                       name=\"mainSupplierCountry-{{i}}\"\n                                       required\n                                       restrictForbiddenCharInput=\"{{ pattern }}\"\n                                       title=\"{{'CUSTOMER.DETAILS.TAB.DETAILS.CORPORATE.COMMON.COUNTRY'|translate}}\"\n                                       type=\"text\"/>\n                                <field-validator *ngIf=\"isEdited\" for=\"mainSupplierCountry-{{i}}\">\n                                    <message\n                                        type=\"required\">{{ 'VALIDATION.REQUIRED' | translate }}</message>\n                                    <message type=\"maxlength\">\n                                        {{ 'CUSTOMER.DETAILS.TAB.DETAILS.CORPORATE.MAXIMUM_LENGTH'|translate:{value: 50} }}\n                                    </message>\n                                </field-validator>\n                                <span *ngIf=\"!isEdited\">\n                                    {{mainSupplier.country |value_by_key:countries}}\n                                </span>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div *ngIf=\"isEdited && this.expectedTurnover.mainSuppliers.length > 3\"\n                     class=\"col-lg-1 col-md-1 col-sm-1 col-xs-1\">\n                    <i (click)=\"removeMainSupplier(i)\" class=\"fa fa-trash fa-2x remove-btn\"></i>\n                </div>\n            </div>\n        </div>\n    </form>\n</tfl-panel-details>\n"

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tree_1 = __webpack_require__(1563);
	var categories_agregator_1 = __webpack_require__(1571);
	var selectable_list_component_1 = __webpack_require__(1573);
	exports.BUSINESS_TYPE_CATEGORIES = tree_1.TREE_COMPONENTS.concat([
	    selectable_list_component_1.SelectableListComponent,
	    categories_agregator_1.BusinessCategoryContainerComponent
	]);


/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tree_view_container_component_1 = __webpack_require__(1564);
	var tree_view_node_component_1 = __webpack_require__(1565);
	var filter_business_types_component_1 = __webpack_require__(1567);
	var filtered_tree_view_component_1 = __webpack_require__(1568);
	exports.TREE_COMPONENTS = [
	    tree_view_container_component_1.TreeViewContainerComponent,
	    tree_view_node_component_1.TreeViewNodeComponent,
	    filter_business_types_component_1.FilterBusinessTypes,
	    filtered_tree_view_component_1.FilteredTreeViewComponent
	];


/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var TreeViewContainerComponent = (function () {
	    function TreeViewContainerComponent() {
	        this.tabindex = '-1';
	    }
	    __decorate([
	        core_1.Input('tree'),
	        __metadata("design:type", Array)
	    ], TreeViewContainerComponent.prototype, "tree", void 0);
	    __decorate([
	        core_1.HostBinding('attr.tabindex'),
	        __metadata("design:type", Object)
	    ], TreeViewContainerComponent.prototype, "tabindex", void 0);
	    TreeViewContainerComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-tree-view-container',
	            template: "\n            <div *ngFor=\"let node of tree\">\n                <tfl-tree-view-node\n                    [openedPanelIconTmpl]=\"chevronRightTmpl\"\n                    [closedPanelIconTmpl]=\"chevronBottomTmpl\"\n                    [item]=\"node\"\n                    [collapsedHeight]=\"30\"\n                    [expandedHeight]=\"30\"\n                    [hideToggle]=\"true\">\n                </tfl-tree-view-node>\n            </div>\n            <ng-template #chevronRightTmpl>\n                <tfl-chevron-right></tfl-chevron-right>\n            </ng-template>\n            <ng-template #chevronBottomTmpl>\n                <tfl-chevron-bottom></tfl-chevron-bottom>\n            </ng-template>\n    ",
	            changeDetection: core_1.ChangeDetectionStrategy.OnPush,
	        })
	    ], TreeViewContainerComponent);
	    return TreeViewContainerComponent;
	}());
	exports.TreeViewContainerComponent = TreeViewContainerComponent;


/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var NodeModel_1 = __webpack_require__(1566);
	var chosen_category_service_1 = __webpack_require__(1083);
	var util_1 = __webpack_require__(743);
	var rxjs_1 = __webpack_require__(304);
	var category_checkbox_1 = __webpack_require__(1072);
	var TreeViewNodeComponent = (function () {
	    function TreeViewNodeComponent(categoryAnnounceService, cdr) {
	        this.categoryAnnounceService = categoryAnnounceService;
	        this.cdr = cdr;
	        this.PX_ENDING = 'px';
	        this.hideToggle = false;
	        this._collapsedHeightPx = 48;
	        this._expandedHeightPx = 48;
	        this.subscription = rxjs_1.Subscription.EMPTY;
	    }
	    Object.defineProperty(TreeViewNodeComponent.prototype, "collapsedHeight", {
	        get: function () {
	            return this._collapsedHeightPx.toString() + this.PX_ENDING;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TreeViewNodeComponent.prototype, "expandedHeight", {
	        get: function () {
	            return this._expandedHeightPx.toString() + this.PX_ENDING;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TreeViewNodeComponent.prototype.stateChanged = function () {
	        this.opened = !this.opened;
	    };
	    TreeViewNodeComponent.prototype.itemSelected = function (event) {
	        this.categoryAnnounceService.selected(event);
	    };
	    TreeViewNodeComponent.prototype.itemDeSelected = function (event) {
	        this.categoryAnnounceService.unSelected(event);
	    };
	    TreeViewNodeComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        this.categoryAnnounceService.categoriesLoadedEvent.subscribe(function (categories) {
	            if (categories) {
	                categories.forEach(function (category) {
	                    _this.checkboxComponentQueryList.filter(function (checkBox) { return !util_1.isNullOrUndefined(checkBox); })
	                        .map(function (checkBox) {
	                        if (checkBox.item.id == category.id) {
	                            checkBox.checked = true;
	                        }
	                    });
	                });
	            }
	        });
	        this.categoryAnnounceService.categoryDeletedEvent.subscribe(function (category) {
	            _this.markCategory(category, false);
	        });
	    };
	    TreeViewNodeComponent.prototype.ngOnDestroy = function () {
	        this.subscription.unsubscribe();
	    };
	    TreeViewNodeComponent.prototype.markCategory = function (category, checked) {
	        var _this = this;
	        this.checkboxComponentQueryList.filter(function (checkBox) { return !util_1.isNullOrUndefined(checkBox); })
	            .map(function (checkBox) {
	            if (checkBox.item.id == category.id && !_this.cdr.destroyed) {
	                checkBox.checked = checked;
	                _this.cdr.detectChanges();
	            }
	        });
	    };
	    __decorate([
	        core_1.Input('item'),
	        __metadata("design:type", NodeModel_1.NodeModel)
	    ], TreeViewNodeComponent.prototype, "item", void 0);
	    __decorate([
	        core_1.Input('hideToggle'),
	        __metadata("design:type", Boolean)
	    ], TreeViewNodeComponent.prototype, "hideToggle", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", core_1.TemplateRef)
	    ], TreeViewNodeComponent.prototype, "openedPanelIconTmpl", void 0);
	    __decorate([
	        core_1.Input(),
	        __metadata("design:type", core_1.TemplateRef)
	    ], TreeViewNodeComponent.prototype, "closedPanelIconTmpl", void 0);
	    __decorate([
	        core_1.Input('collapsedHeight'),
	        __metadata("design:type", Number)
	    ], TreeViewNodeComponent.prototype, "_collapsedHeightPx", void 0);
	    __decorate([
	        core_1.Input('expandedHeight'),
	        __metadata("design:type", Number)
	    ], TreeViewNodeComponent.prototype, "_expandedHeightPx", void 0);
	    __decorate([
	        core_1.ViewChildren(category_checkbox_1.CheckboxComponent),
	        __metadata("design:type", core_1.QueryList)
	    ], TreeViewNodeComponent.prototype, "checkboxComponentQueryList", void 0);
	    TreeViewNodeComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-tree-view-node',
	            template: "\n        <div class=\"tfl-tree-view-node\">\n            <mat-expansion-panel hideToggle=\"hideToggle\"\n                                 (closed)=\"stateChanged()\"\n                                 (opened)=\"stateChanged()\">\n                <mat-expansion-panel-header [collapsedHeight]=\"collapsedHeight\"\n                                            [expandedHeight]=\"expandedHeight\">\n                    <ng-container\n                            *ngIf=\"!opened\"\n                            [ngTemplateOutlet]=\"closedPanelIconTmpl\"\n                    ></ng-container>\n                    <ng-container\n                            *ngIf=\"opened\"\n                            [ngTemplateOutlet]=\"openedPanelIconTmpl\"\n                    ></ng-container>\n                    <mat-panel-title>\n                        {{ item.code + ' ' + item.name }}\n                    </mat-panel-title>\n                </mat-expansion-panel-header>\n                <mat-panel-description>\n                    <ul *ngIf=\"item.children.length > 0\">\n                        <li *ngFor=\"let child of item.children\">\n                            <ng-container *ngIf=\"child.children.length > 0 else list\">\n                                <tfl-tree-view-node\n                                        [collapsedHeight]=\"_collapsedHeightPx\"\n                                        [expandedHeight]=\"_expandedHeightPx\"\n                                        [openedPanelIconTmpl]=\"openedPanelIconTmpl\"\n                                        [closedPanelIconTmpl]=\"closedPanelIconTmpl\"\n                                        [item]=\"child\">\n                                </tfl-tree-view-node>\n                            </ng-container>\n                            <ng-template #list>\n                                <tfl-checkbox\n                                        (itemSelected)=\"itemSelected($event)\"\n                                        (itemDeSelected)=\"itemDeSelected($event)\"\n                                        [item]=\"child\"\n                                        [label]=\"child.code + ' ' + child.name\"\n                                ></tfl-checkbox>\n                            </ng-template>\n                        </li>\n                    </ul>\n                </mat-panel-description>\n            </mat-expansion-panel>\n        </div>\n    "
	        }),
	        __metadata("design:paramtypes", [chosen_category_service_1.ChosenCategoryService,
	            core_1.ChangeDetectorRef])
	    ], TreeViewNodeComponent);
	    return TreeViewNodeComponent;
	}());
	exports.TreeViewNodeComponent = TreeViewNodeComponent;


/***/ }),
/* 1566 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var NodeModel = (function () {
	    function NodeModel() {
	    }
	    return NodeModel;
	}());
	exports.NodeModel = NodeModel;


/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var FilterBusinessTypes = (function () {
	    function FilterBusinessTypes() {
	        this.MIN_LIST_SIZE = 'minListSize';
	        this.MATCHES_NOT_FOUND = 'matchesNotFound';
	        this.startSearchSymbolsCount = 3;
	        this.search = new core_1.EventEmitter();
	    }
	    FilterBusinessTypes.prototype.searchEvent = function (event) {
	        var _this = this;
	        clearTimeout(this.tout);
	        if (event.target.value.length >= this.startSearchSymbolsCount) {
	            this.tout = setTimeout(function () {
	                return _this.search.emit(event.target.value);
	            }, this.searchTimeOut);
	            return;
	        }
	        this.search.emit(undefined);
	    };
	    FilterBusinessTypes.prototype.hasNoMatches = function () {
	        var control = this.form.controls[this.control];
	        return control.invalid && control.hasError(this.MATCHES_NOT_FOUND);
	    };
	    FilterBusinessTypes.prototype.hasRequiredError = function () {
	        var control = this.form.controls[this.control];
	        return control.invalid && control.hasError(this.MIN_LIST_SIZE);
	    };
	    FilterBusinessTypes.prototype.onBlur = function () {
	        var control = this.form.controls[this.control];
	        control.markAsUntouched();
	        control.markAsPristine();
	    };
	    __decorate([
	        core_1.Input('form'),
	        __metadata("design:type", forms_1.FormGroup)
	    ], FilterBusinessTypes.prototype, "form", void 0);
	    __decorate([
	        core_1.Input('controlName'),
	        __metadata("design:type", String)
	    ], FilterBusinessTypes.prototype, "control", void 0);
	    __decorate([
	        core_1.Input('searchTimeOut'),
	        __metadata("design:type", Number)
	    ], FilterBusinessTypes.prototype, "searchTimeOut", void 0);
	    __decorate([
	        core_1.Input('placeholder'),
	        __metadata("design:type", String)
	    ], FilterBusinessTypes.prototype, "placeholder", void 0);
	    __decorate([
	        core_1.Input('startSearchSymbolsCount'),
	        __metadata("design:type", Object)
	    ], FilterBusinessTypes.prototype, "startSearchSymbolsCount", void 0);
	    __decorate([
	        core_1.Output(),
	        __metadata("design:type", core_1.EventEmitter)
	    ], FilterBusinessTypes.prototype, "search", void 0);
	    FilterBusinessTypes = __decorate([
	        core_1.Component({
	            selector: 'tfl-filter-business-type',
	            template: "\n        <div class=\"filter-business-type\" [formGroup]=\"form\" [ngClass]=\"{'no-matches': hasNoMatches()}\">\n            <div>\n                <search-business-category-icon></search-business-category-icon>\n            </div>\n            <input [placeholder]=\"placeholder\"\n                   [name]=\"control\"\n                   class=\"form-control\"\n                   [formControlName]=\"control\"\n                   [id]=\"control\"\n                   (keyup)=\"searchEvent($event)\"\n                   (blur)=\"onBlur()\"\n            >\n            <p *ngIf=\"hasRequiredError()\"\n               class=\"text-danger\">\n                {{'VALIDATION.REQUIRED'|translate}}\n            </p>\n            <p *ngIf=\"hasNoMatches()\"\n               class=\"text-danger\">\n                {{'VALIDATION.MATCHES_NOT_FOUND'|translate}}\n            </p>\n        </div>\n    "
	        })
	    ], FilterBusinessTypes);
	    return FilterBusinessTypes;
	}());
	exports.FilterBusinessTypes = FilterBusinessTypes;


/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var tree_builder_utils_1 = __webpack_require__(1569);
	var lunr = __webpack_require__(1570);
	var util_1 = __webpack_require__(743);
	var backoffice_business_type_categories_service_1 = __webpack_require__(1121);
	var FilteredTreeViewComponent = (function () {
	    function FilteredTreeViewComponent(http, elemRef) {
	        this.http = http;
	        this.elemRef = elemRef;
	        this.hideList = true;
	        this.searchList = [];
	        this.border = false;
	        this.tabindex = '0';
	    }
	    FilteredTreeViewComponent.prototype.click = function (event) {
	        if (!this.elemRef.nativeElement.contains(event.target)) {
	            this.hideListAndBorder();
	            this.form.controls[this.filterControl].setValue(null);
	            this.onSearch(undefined);
	        }
	    };
	    FilteredTreeViewComponent.prototype.onSearch = function (event) {
	        if (event) {
	            var searchResult = this.indx.query(function (query) {
	                query.term(lunr.tokenizer(event), null);
	            });
	            this.result = this.filterAndSortResultListBySearchResult(searchResult);
	            this.form.controls[this.resultListControl].setValue(this.result);
	            if (this.result.length != 0) {
	                this.showListAndBorder();
	                return;
	            }
	            this.hideListAndBorder();
	        }
	        else {
	            this.result = undefined;
	            this.form.controls[this.resultListControl].setValue(this.result);
	        }
	    };
	    FilteredTreeViewComponent.prototype.onClickInput = function () {
	        var _this = this;
	        clearTimeout(this.tout);
	        this.tout = setTimeout(function () {
	            if (!util_1.isNullOrUndefined(_this.result) && (_this.result.length == 0)) {
	                _this.hideListAndBorder();
	            }
	            else {
	                _this.showListAndBorder();
	            }
	        }, 250);
	    };
	    FilteredTreeViewComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.tree = tree_builder_utils_1.TreeBuilderUtils.generate(this.businessCategoriesList);
	        this.tree.map(function (item) {
	            tree_builder_utils_1.TreeBuilderUtils.findAllLeavesOfNode(item, item.code + ' ' + item.name)
	                .map(function (leave) {
	                _this.searchList.push({
	                    id: leave.node.id,
	                    name: leave.node.name,
	                    code: leave.node.code,
	                    path: leave.path,
	                    score: undefined,
	                    metadata: undefined
	                });
	            });
	        });
	        this.buildSearchIndex();
	    };
	    FilteredTreeViewComponent.prototype.buildSearchIndex = function () {
	        var _this = this;
	        this.indx = lunr(function (ctx) {
	            lunr.tokenizer.separator = /[\s\-\\.;]+/;
	            ctx.field('path', { boost: 2 });
	            ctx.field('name', { boost: 3 });
	            ctx.field('code', { boost: 1 });
	            ctx.ref('id');
	            ctx.use(_this.trigramizeToken);
	            ctx.metadataWhitelist = ['position'];
	            _this.searchList.forEach(function (item) { return ctx.add(item); });
	        });
	    };
	    FilteredTreeViewComponent.prototype.hideListAndBorder = function () {
	        this.hideList = true;
	        this.border = false;
	    };
	    FilteredTreeViewComponent.prototype.showListAndBorder = function () {
	        this.hideList = false;
	        this.border = true;
	        this.form.controls[this.filterControl].setErrors(null);
	    };
	    FilteredTreeViewComponent.prototype.filterAndSortResultListBySearchResult = function (searchResult) {
	        return this.searchList.filter(function (item) {
	            return searchResult
	                .map(function (res) { return res.ref; })
	                .some(function (index) { return index == item.id; });
	        }).map(function (item) {
	            searchResult.forEach(function (res) {
	                if (res.ref == item.id) {
	                    item.score = res.score;
	                    item.metadata = res.matchData.metadata;
	                }
	            });
	            return item;
	        }).sort(function (a, b) {
	            return b.score - a.score;
	        });
	    };
	    FilteredTreeViewComponent.prototype.trigramizeToken = function (builder) {
	        var TRIGRAM_LENGTH = 3;
	        var pipelineFunction = function (token) {
	            var tokens = [token];
	            var str = token.toString();
	            var offset = token.metadata.position[0];
	            if (str.length > TRIGRAM_LENGTH) {
	                for (var i = 0; i <= str.length - TRIGRAM_LENGTH; i++) {
	                    var trigram_1 = str.slice(i, i + TRIGRAM_LENGTH);
	                    var metadata = { position: [offset + i, TRIGRAM_LENGTH] };
	                    tokens.push(new lunr.Token(trigram_1, metadata));
	                }
	            }
	            return tokens;
	        };
	        var searchPipelineFunction = function (token) {
	            return trigram(token.toString()).map(function (str) {
	                if (str == token.toString()) {
	                    return new lunr.Token(str, token.metadata);
	                }
	                return new lunr.Token(str, null);
	            });
	        };
	        function trigram(str) {
	            var trigrams = [];
	            trigrams.push(str);
	            if (str.length <= TRIGRAM_LENGTH) {
	                return trigrams;
	            }
	            for (var i = 0; i < str.length; i++) {
	                if (TRIGRAM_LENGTH + i > str.length) {
	                    return trigrams;
	                }
	                trigrams.push(str.slice(i, TRIGRAM_LENGTH + i));
	            }
	            return trigrams;
	        }
	        lunr.Pipeline.registerFunction(pipelineFunction, 'trigramizeTokens');
	        lunr.Pipeline.registerFunction(searchPipelineFunction, 'trigramizeSearchTokens');
	        builder.pipeline.add(pipelineFunction);
	        builder.searchPipeline.add(searchPipelineFunction);
	    };
	    ;
	    __decorate([
	        core_1.Input('form'),
	        __metadata("design:type", forms_1.FormGroup)
	    ], FilteredTreeViewComponent.prototype, "form", void 0);
	    __decorate([
	        core_1.Input('filterControl'),
	        __metadata("design:type", String)
	    ], FilteredTreeViewComponent.prototype, "filterControl", void 0);
	    __decorate([
	        core_1.Input('resultListControl'),
	        __metadata("design:type", String)
	    ], FilteredTreeViewComponent.prototype, "resultListControl", void 0);
	    __decorate([
	        core_1.Input('placeholder'),
	        __metadata("design:type", String)
	    ], FilteredTreeViewComponent.prototype, "placeholder", void 0);
	    __decorate([
	        core_1.Input('searchTimeOut'),
	        __metadata("design:type", Number)
	    ], FilteredTreeViewComponent.prototype, "searchTimeOut", void 0);
	    __decorate([
	        core_1.Input('businessCategoriesList'),
	        __metadata("design:type", Object)
	    ], FilteredTreeViewComponent.prototype, "businessCategoriesList", void 0);
	    __decorate([
	        core_1.HostBinding('class.border'),
	        __metadata("design:type", Boolean)
	    ], FilteredTreeViewComponent.prototype, "border", void 0);
	    __decorate([
	        core_1.HostBinding('attr.tabindex'),
	        __metadata("design:type", Object)
	    ], FilteredTreeViewComponent.prototype, "tabindex", void 0);
	    __decorate([
	        core_1.HostListener('document:click', ['$event']),
	        __metadata("design:type", Function),
	        __metadata("design:paramtypes", [Object]),
	        __metadata("design:returntype", void 0)
	    ], FilteredTreeViewComponent.prototype, "click", null);
	    FilteredTreeViewComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-filtered-tree-view',
	            template: "\n        <div class=\"filtered-container\" [formGroup]=\"form\">\n            <tfl-filter-business-type\n                    [placeholder]=\"placeholder\"\n                    [controlName]=\"filterControl\"\n                    [form]=\"form\"\n                    [searchTimeOut]=\"700\"\n                    (search)=\"onSearch($event)\"\n                    (click)=\"onClickInput()\"\n            ></tfl-filter-business-type>\n            <div class=\"scroll\" [ngStyle]=\"{'display': hideList ? 'none': 'block'}\">\n                <ng-container *ngIf=\"!result; else searchResult\">\n                    <tfl-tree-view-container [tree]=\"tree\"\n                    ></tfl-tree-view-container>\n                </ng-container>\n                <ng-template #searchResult>\n                    <tfl-selectable-list [data]=\"result\"\n                                         [formControlName]=\"resultListControl\"\n                    ></tfl-selectable-list>\n                </ng-template>\n            </div>\n        </div>\n    "
	        }),
	        __metadata("design:paramtypes", [backoffice_business_type_categories_service_1.BackofficeBusinessTypeCategoriesService, core_1.ElementRef])
	    ], FilteredTreeViewComponent);
	    return FilteredTreeViewComponent;
	}());
	exports.FilteredTreeViewComponent = FilteredTreeViewComponent;


/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(743);
	var TreeBuilderUtils = (function () {
	    function TreeBuilderUtils() {
	    }
	    TreeBuilderUtils.generate = function (list) {
	        var node;
	        var tree = [];
	        for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
	            var item = list_1[_i];
	            if (util_1.isNullOrUndefined(item.parentId)) {
	                node = this.mapToNode(item);
	                for (var _a = 0, list_2 = list; _a < list_2.length; _a++) {
	                    var child = list_2[_a];
	                    node = this.addChild(node, child);
	                }
	                tree.push(node);
	            }
	        }
	        return tree;
	    };
	    TreeBuilderUtils.addChild = function (node, item) {
	        if (node.id == item.parentId) {
	            node.children.push(this.mapToNode(item));
	            return node;
	        }
	        for (var _i = 0, _a = node.children; _i < _a.length; _i++) {
	            var child = _a[_i];
	            if (child.id == item.parentId) {
	                child.children.push(this.mapToNode(item));
	                return node;
	            }
	            else {
	                this.addChild(child, item);
	            }
	        }
	        return node;
	    };
	    TreeBuilderUtils.findAllLeavesOfNode = function (node, path) {
	        var result = [];
	        if (node.selectable) {
	            result.push({ node: node, path: path });
	        }
	        for (var _i = 0, _a = node.children; _i < _a.length; _i++) {
	            var child = _a[_i];
	            if (child.children.length == 0) {
	                result = result.concat(this.findAllLeavesOfNode(child, path));
	            }
	            else {
	                result = result.concat(this.findAllLeavesOfNode(child, path + '/' + this.getNameWithCode(child)));
	            }
	        }
	        return result;
	    };
	    TreeBuilderUtils.mapToNode = function (item) {
	        return {
	            id: item.id,
	            name: item.name,
	            selectable: item.selectable,
	            code: item.code,
	            children: []
	        };
	    };
	    TreeBuilderUtils.getNameWithCode = function (item) {
	        return item.code + ' ' + item.name;
	    };
	    return TreeBuilderUtils;
	}());
	exports.TreeBuilderUtils = TreeBuilderUtils;


/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.9
	 * Copyright (C) 2020 Oliver Nightingale
	 * @license MIT
	 */
	
	;(function(){
	
	/**
	 * A convenience function for configuring and constructing
	 * a new lunr Index.
	 *
	 * A lunr.Builder instance is created and the pipeline setup
	 * with a trimmer, stop word filter and stemmer.
	 *
	 * This builder object is yielded to the configuration function
	 * that is passed as a parameter, allowing the list of fields
	 * and other builder parameters to be customised.
	 *
	 * All documents _must_ be added within the passed config function.
	 *
	 * @example
	 * var idx = lunr(function () {
	 *   this.field('title')
	 *   this.field('body')
	 *   this.ref('id')
	 *
	 *   documents.forEach(function (doc) {
	 *     this.add(doc)
	 *   }, this)
	 * })
	 *
	 * @see {@link lunr.Builder}
	 * @see {@link lunr.Pipeline}
	 * @see {@link lunr.trimmer}
	 * @see {@link lunr.stopWordFilter}
	 * @see {@link lunr.stemmer}
	 * @namespace {function} lunr
	 */
	var lunr = function (config) {
	  var builder = new lunr.Builder
	
	  builder.pipeline.add(
	    lunr.trimmer,
	    lunr.stopWordFilter,
	    lunr.stemmer
	  )
	
	  builder.searchPipeline.add(
	    lunr.stemmer
	  )
	
	  config.call(builder, builder)
	  return builder.build()
	}
	
	lunr.version = "2.3.9"
	/*!
	 * lunr.utils
	 * Copyright (C) 2020 Oliver Nightingale
	 */
	
	/**
	 * A namespace containing utils for the rest of the lunr library
	 * @namespace lunr.utils
	 */
	lunr.utils = {}
	
	/**
	 * Print a warning message to the console.
	 *
	 * @param {String} message The message to be printed.
	 * @memberOf lunr.utils
	 * @function
	 */
	lunr.utils.warn = (function (global) {
	  /* eslint-disable no-console */
	  return function (message) {
	    if (global.console && console.warn) {
	      console.warn(message)
	    }
	  }
	  /* eslint-enable no-console */
	})(this)
	
	/**
	 * Convert an object to a string.
	 *
	 * In the case of `null` and `undefined` the function returns
	 * the empty string, in all other cases the result of calling
	 * `toString` on the passed object is returned.
	 *
	 * @param {Any} obj The object to convert to a string.
	 * @return {String} string representation of the passed object.
	 * @memberOf lunr.utils
	 */
	lunr.utils.asString = function (obj) {
	  if (obj === void 0 || obj === null) {
	    return ""
	  } else {
	    return obj.toString()
	  }
	}
	
	/**
	 * Clones an object.
	 *
	 * Will create a copy of an existing object such that any mutations
	 * on the copy cannot affect the original.
	 *
	 * Only shallow objects are supported, passing a nested object to this
	 * function will cause a TypeError.
	 *
	 * Objects with primitives, and arrays of primitives are supported.
	 *
	 * @param {Object} obj The object to clone.
	 * @return {Object} a clone of the passed object.
	 * @throws {TypeError} when a nested object is passed.
	 * @memberOf Utils
	 */
	lunr.utils.clone = function (obj) {
	  if (obj === null || obj === undefined) {
	    return obj
	  }
	
	  var clone = Object.create(null),
	      keys = Object.keys(obj)
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i],
	        val = obj[key]
	
	    if (Array.isArray(val)) {
	      clone[key] = val.slice()
	      continue
	    }
	
	    if (typeof val === 'string' ||
	        typeof val === 'number' ||
	        typeof val === 'boolean') {
	      clone[key] = val
	      continue
	    }
	
	    throw new TypeError("clone is not deep and does not support nested objects")
	  }
	
	  return clone
	}
	lunr.FieldRef = function (docRef, fieldName, stringValue) {
	  this.docRef = docRef
	  this.fieldName = fieldName
	  this._stringValue = stringValue
	}
	
	lunr.FieldRef.joiner = "/"
	
	lunr.FieldRef.fromString = function (s) {
	  var n = s.indexOf(lunr.FieldRef.joiner)
	
	  if (n === -1) {
	    throw "malformed field ref string"
	  }
	
	  var fieldRef = s.slice(0, n),
	      docRef = s.slice(n + 1)
	
	  return new lunr.FieldRef (docRef, fieldRef, s)
	}
	
	lunr.FieldRef.prototype.toString = function () {
	  if (this._stringValue == undefined) {
	    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
	  }
	
	  return this._stringValue
	}
	/*!
	 * lunr.Set
	 * Copyright (C) 2020 Oliver Nightingale
	 */
	
	/**
	 * A lunr set.
	 *
	 * @constructor
	 */
	lunr.Set = function (elements) {
	  this.elements = Object.create(null)
	
	  if (elements) {
	    this.length = elements.length
	
	    for (var i = 0; i < this.length; i++) {
	      this.elements[elements[i]] = true
	    }
	  } else {
	    this.length = 0
	  }
	}
	
	/**
	 * A complete set that contains all elements.
	 *
	 * @static
	 * @readonly
	 * @type {lunr.Set}
	 */
	lunr.Set.complete = {
	  intersect: function (other) {
	    return other
	  },
	
	  union: function () {
	    return this
	  },
	
	  contains: function () {
	    return true
	  }
	}
	
	/**
	 * An empty set that contains no elements.
	 *
	 * @static
	 * @readonly
	 * @type {lunr.Set}
	 */
	lunr.Set.empty = {
	  intersect: function () {
	    return this
	  },
	
	  union: function (other) {
	    return other
	  },
	
	  contains: function () {
	    return false
	  }
	}
	
	/**
	 * Returns true if this set contains the specified object.
	 *
	 * @param {object} object - Object whose presence in this set is to be tested.
	 * @returns {boolean} - True if this set contains the specified object.
	 */
	lunr.Set.prototype.contains = function (object) {
	  return !!this.elements[object]
	}
	
	/**
	 * Returns a new set containing only the elements that are present in both
	 * this set and the specified set.
	 *
	 * @param {lunr.Set} other - set to intersect with this set.
	 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
	 */
	
	lunr.Set.prototype.intersect = function (other) {
	  var a, b, elements, intersection = []
	
	  if (other === lunr.Set.complete) {
	    return this
	  }
	
	  if (other === lunr.Set.empty) {
	    return other
	  }
	
	  if (this.length < other.length) {
	    a = this
	    b = other
	  } else {
	    a = other
	    b = this
	  }
	
	  elements = Object.keys(a.elements)
	
	  for (var i = 0; i < elements.length; i++) {
	    var element = elements[i]
	    if (element in b.elements) {
	      intersection.push(element)
	    }
	  }
	
	  return new lunr.Set (intersection)
	}
	
	/**
	 * Returns a new set combining the elements of this and the specified set.
	 *
	 * @param {lunr.Set} other - set to union with this set.
	 * @return {lunr.Set} a new set that is the union of this and the specified set.
	 */
	
	lunr.Set.prototype.union = function (other) {
	  if (other === lunr.Set.complete) {
	    return lunr.Set.complete
	  }
	
	  if (other === lunr.Set.empty) {
	    return this
	  }
	
	  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
	}
	/**
	 * A function to calculate the inverse document frequency for
	 * a posting. This is shared between the builder and the index
	 *
	 * @private
	 * @param {object} posting - The posting for a given term
	 * @param {number} documentCount - The total number of documents.
	 */
	lunr.idf = function (posting, documentCount) {
	  var documentsWithTerm = 0
	
	  for (var fieldName in posting) {
	    if (fieldName == '_index') continue // Ignore the term index, its not a field
	    documentsWithTerm += Object.keys(posting[fieldName]).length
	  }
	
	  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)
	
	  return Math.log(1 + Math.abs(x))
	}
	
	/**
	 * A token wraps a string representation of a token
	 * as it is passed through the text processing pipeline.
	 *
	 * @constructor
	 * @param {string} [str=''] - The string token being wrapped.
	 * @param {object} [metadata={}] - Metadata associated with this token.
	 */
	lunr.Token = function (str, metadata) {
	  this.str = str || ""
	  this.metadata = metadata || {}
	}
	
	/**
	 * Returns the token string that is being wrapped by this object.
	 *
	 * @returns {string}
	 */
	lunr.Token.prototype.toString = function () {
	  return this.str
	}
	
	/**
	 * A token update function is used when updating or optionally
	 * when cloning a token.
	 *
	 * @callback lunr.Token~updateFunction
	 * @param {string} str - The string representation of the token.
	 * @param {Object} metadata - All metadata associated with this token.
	 */
	
	/**
	 * Applies the given function to the wrapped string token.
	 *
	 * @example
	 * token.update(function (str, metadata) {
	 *   return str.toUpperCase()
	 * })
	 *
	 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
	 * @returns {lunr.Token}
	 */
	lunr.Token.prototype.update = function (fn) {
	  this.str = fn(this.str, this.metadata)
	  return this
	}
	
	/**
	 * Creates a clone of this token. Optionally a function can be
	 * applied to the cloned token.
	 *
	 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
	 * @returns {lunr.Token}
	 */
	lunr.Token.prototype.clone = function (fn) {
	  fn = fn || function (s) { return s }
	  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
	}
	/*!
	 * lunr.tokenizer
	 * Copyright (C) 2020 Oliver Nightingale
	 */
	
	/**
	 * A function for splitting a string into tokens ready to be inserted into
	 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
	 * the value of this property to change how strings are split into tokens.
	 *
	 * This tokenizer will convert its parameter to a string by calling `toString` and
	 * then will split this string on the character in `lunr.tokenizer.separator`.
	 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
	 *
	 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
	 * added as metadata to every token that is created from the object to be tokenized.
	 *
	 * @static
	 * @param {?(string|object|object[])} obj - The object to convert into tokens
	 * @param {?object} metadata - Optional metadata to associate with every token
	 * @returns {lunr.Token[]}
	 * @see {@link lunr.Pipeline}
	 */
	lunr.tokenizer = function (obj, metadata) {
	  if (obj == null || obj == undefined) {
	    return []
	  }
	
	  if (Array.isArray(obj)) {
	    return obj.map(function (t) {
	      return new lunr.Token(
	        lunr.utils.asString(t).toLowerCase(),
	        lunr.utils.clone(metadata)
	      )
	    })
	  }
	
	  var str = obj.toString().toLowerCase(),
	      len = str.length,
	      tokens = []
	
	  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
	    var char = str.charAt(sliceEnd),
	        sliceLength = sliceEnd - sliceStart
	
	    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {
	
	      if (sliceLength > 0) {
	        var tokenMetadata = lunr.utils.clone(metadata) || {}
	        tokenMetadata["position"] = [sliceStart, sliceLength]
	        tokenMetadata["index"] = tokens.length
	
	        tokens.push(
	          new lunr.Token (
	            str.slice(sliceStart, sliceEnd),
	            tokenMetadata
	          )
	        )
	      }
	
	      sliceStart = sliceEnd + 1
	    }
	
	  }
	
	  return tokens
	}
	
	/**
	 * The separator used to split a string into tokens. Override this property to change the behaviour of
	 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
	 *
	 * @static
	 * @see lunr.tokenizer
	 */
	lunr.tokenizer.separator = /[\s\-]+/
	/*!
	 * lunr.Pipeline
	 * Copyright (C) 2020 Oliver Nightingale
	 */
	
	/**
	 * lunr.Pipelines maintain an ordered list of functions to be applied to all
	 * tokens in documents entering the search index and queries being ran against
	 * the index.
	 *
	 * An instance of lunr.Index created with the lunr shortcut will contain a
	 * pipeline with a stop word filter and an English language stemmer. Extra
	 * functions can be added before or after either of these functions or these
	 * default functions can be removed.
	 *
	 * When run the pipeline will call each function in turn, passing a token, the
	 * index of that token in the original list of all tokens and finally a list of
	 * all the original tokens.
	 *
	 * The output of functions in the pipeline will be passed to the next function
	 * in the pipeline. To exclude a token from entering the index the function
	 * should return undefined, the rest of the pipeline will not be called with
	 * this token.
	 *
	 * For serialisation of pipelines to work, all functions used in an instance of
	 * a pipeline should be registered with lunr.Pipeline. Registered functions can
	 * then be loaded. If trying to load a serialised pipeline that uses functions
	 * that are not registered an error will be thrown.
	 *
	 * If not planning on serialising the pipeline then registering pipeline functions
	 * is not necessary.
	 *
	 * @constructor
	 */
	lunr.Pipeline = function () {
	  this._stack = []
	}
	
	lunr.Pipeline.registeredFunctions = Object.create(null)
	
	/**
	 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
	 * string as well as all known metadata. A pipeline function can mutate the token string
	 * or mutate (or add) metadata for a given token.
	 *
	 * A pipeline function can indicate that the passed token should be discarded by returning
	 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
	 * functions and will not be added to the index.
	 *
	 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
	 * to any downstream pipeline functions and all will returned tokens will be added to the index.
	 *
	 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
	 *
	 * @interface lunr.PipelineFunction
	 * @param {lunr.Token} token - A token from the document being processed.
	 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
	 * @param {lunr.Token[]} tokens - All tokens for this document/field.
	 * @returns {(?lunr.Token|lunr.Token[])}
	 */
	
	/**
	 * Register a function with the pipeline.
	 *
	 * Functions that are used in the pipeline should be registered if the pipeline
	 * needs to be serialised, or a serialised pipeline needs to be loaded.
	 *
	 * Registering a function does not add it to a pipeline, functions must still be
	 * added to instances of the pipeline for them to be used when running a pipeline.
	 *
	 * @param {lunr.PipelineFunction} fn - The function to check for.
	 * @param {String} label - The label to register this function with
	 */
	lunr.Pipeline.registerFunction = function (fn, label) {
	  if (label in this.registeredFunctions) {
	    lunr.utils.warn('Overwriting existing registered function: ' + label)
	  }
	
	  fn.label = label
	  lunr.Pipeline.registeredFunctions[fn.label] = fn
	}
	
	/**
	 * Warns if the function is not registered as a Pipeline function.
	 *
	 * @param {lunr.PipelineFunction} fn - The function to check for.
	 * @private
	 */
	lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
	  var isRegistered = fn.label && (fn.label in this.registeredFunctions)
	
	  if (!isRegistered) {
	    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
	  }
	}
	
	/**
	 * Loads a previously serialised pipeline.
	 *
	 * All functions to be loaded must already be registered with lunr.Pipeline.
	 * If any function from the serialised data has not been registered then an
	 * error will be thrown.
	 *
	 * @param {Object} serialised - The serialised pipeline to load.
	 * @returns {lunr.Pipeline}
	 */
	lunr.Pipeline.load = function (serialised) {
	  var pipeline = new lunr.Pipeline
	
	  serialised.forEach(function (fnName) {
	    var fn = lunr.Pipeline.registeredFunctions[fnName]
	
	    if (fn) {
	      pipeline.add(fn)
	    } else {
	      throw new Error('Cannot load unregistered function: ' + fnName)
	    }
	  })
	
	  return pipeline
	}
	
	/**
	 * Adds new functions to the end of the pipeline.
	 *
	 * Logs a warning if the function has not been registered.
	 *
	 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
	 */
	lunr.Pipeline.prototype.add = function () {
	  var fns = Array.prototype.slice.call(arguments)
	
	  fns.forEach(function (fn) {
	    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
	    this._stack.push(fn)
	  }, this)
	}
	
	/**
	 * Adds a single function after a function that already exists in the
	 * pipeline.
	 *
	 * Logs a warning if the function has not been registered.
	 *
	 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
	 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
	 */
	lunr.Pipeline.prototype.after = function (existingFn, newFn) {
	  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)
	
	  var pos = this._stack.indexOf(existingFn)
	  if (pos == -1) {
	    throw new Error('Cannot find existingFn')
	  }
	
	  pos = pos + 1
	  this._stack.splice(pos, 0, newFn)
	}
	
	/**
	 * Adds a single function before a function that already exists in the
	 * pipeline.
	 *
	 * Logs a warning if the function has not been registered.
	 *
	 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
	 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
	 */
	lunr.Pipeline.prototype.before = function (existingFn, newFn) {
	  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)
	
	  var pos = this._stack.indexOf(existingFn)
	  if (pos == -1) {
	    throw new Error('Cannot find existingFn')
	  }
	
	  this._stack.splice(pos, 0, newFn)
	}
	
	/**
	 * Removes a function from the pipeline.
	 *
	 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
	 */
	lunr.Pipeline.prototype.remove = function (fn) {
	  var pos = this._stack.indexOf(fn)
	  if (pos == -1) {
	    return
	  }
	
	  this._stack.splice(pos, 1)
	}
	
	/**
	 * Runs the current list of functions that make up the pipeline against the
	 * passed tokens.
	 *
	 * @param {Array} tokens The tokens to run through the pipeline.
	 * @returns {Array}
	 */
	lunr.Pipeline.prototype.run = function (tokens) {
	  var stackLength = this._stack.length
	
	  for (var i = 0; i < stackLength; i++) {
	    var fn = this._stack[i]
	    var memo = []
	
	    for (var j = 0; j < tokens.length; j++) {
	      var result = fn(tokens[j], j, tokens)
	
	      if (result === null || result === void 0 || result === '') continue
	
	      if (Array.isArray(result)) {
	        for (var k = 0; k < result.length; k++) {
	          memo.push(result[k])
	        }
	      } else {
	        memo.push(result)
	      }
	    }
	
	    tokens = memo
	  }
	
	  return tokens
	}
	
	/**
	 * Convenience method for passing a string through a pipeline and getting
	 * strings out. This method takes care of wrapping the passed string in a
	 * token and mapping the resulting tokens back to strings.
	 *
	 * @param {string} str - The string to pass through the pipeline.
	 * @param {?object} metadata - Optional metadata to associate with the token
	 * passed to the pipeline.
	 * @returns {string[]}
	 */
	lunr.Pipeline.prototype.runString = function (str, metadata) {
	  var token = new lunr.Token (str, metadata)
	
	  return this.run([token]).map(function (t) {
	    return t.toString()
	  })
	}
	
	/**
	 * Resets the pipeline by removing any existing processors.
	 *
	 */
	lunr.Pipeline.prototype.reset = function () {
	  this._stack = []
	}
	
	/**
	 * Returns a representation of the pipeline ready for serialisation.
	 *
	 * Logs a warning if the function has not been registered.
	 *
	 * @returns {Array}
	 */
	lunr.Pipeline.prototype.toJSON = function () {
	  return this._stack.map(function (fn) {
	    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
	
	    return fn.label
	  })
	}
	/*!
	 * lunr.Vector
	 * Copyright (C) 2020 Oliver Nightingale
	 */
	
	/**
	 * A vector is used to construct the vector space of documents and queries. These
	 * vectors support operations to determine the similarity between two documents or
	 * a document and a query.
	 *
	 * Normally no parameters are required for initializing a vector, but in the case of
	 * loading a previously dumped vector the raw elements can be provided to the constructor.
	 *
	 * For performance reasons vectors are implemented with a flat array, where an elements
	 * index is immediately followed by its value. E.g. [index, value, index, value]. This
	 * allows the underlying array to be as sparse as possible and still offer decent
	 * performance when being used for vector calculations.
	 *
	 * @constructor
	 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
	 */
	lunr.Vector = function (elements) {
	  this._magnitude = 0
	  this.elements = elements || []
	}
	
	
	/**
	 * Calculates the position within the vector to insert a given index.
	 *
	 * This is used internally by insert and upsert. If there are duplicate indexes then
	 * the position is returned as if the value for that index were to be updated, but it
	 * is the callers responsibility to check whether there is a duplicate at that index
	 *
	 * @param {Number} insertIdx - The index at which the element should be inserted.
	 * @returns {Number}
	 */
	lunr.Vector.prototype.positionForIndex = function (index) {
	  // For an empty vector the tuple can be inserted at the beginning
	  if (this.elements.length == 0) {
	    return 0
	  }
	
	  var start = 0,
	      end = this.elements.length / 2,
	      sliceLength = end - start,
	      pivotPoint = Math.floor(sliceLength / 2),
	      pivotIndex = this.elements[pivotPoint * 2]
	
	  while (sliceLength > 1) {
	    if (pivotIndex < index) {
	      start = pivotPoint
	    }
	
	    if (pivotIndex > index) {
	      end = pivotPoint
	    }
	
	    if (pivotIndex == index) {
	      break
	    }
	
	    sliceLength = end - start
	    pivotPoint = start + Math.floor(sliceLength / 2)
	    pivotIndex = this.elements[pivotPoint * 2]
	  }
	
	  if (pivotIndex == index) {
	    return pivotPoint * 2
	  }
	
	  if (pivotIndex > index) {
	    return pivotPoint * 2
	  }
	
	  if (pivotIndex < index) {
	    return (pivotPoint + 1) * 2
	  }
	}
	
	/**
	 * Inserts an element at an index within the vector.
	 *
	 * Does not allow duplicates, will throw an error if there is already an entry
	 * for this index.
	 *
	 * @param {Number} insertIdx - The index at which the element should be inserted.
	 * @param {Number} val - The value to be inserted into the vector.
	 */
	lunr.Vector.prototype.insert = function (insertIdx, val) {
	  this.upsert(insertIdx, val, function () {
	    throw "duplicate index"
	  })
	}
	
	/**
	 * Inserts or updates an existing index within the vector.
	 *
	 * @param {Number} insertIdx - The index at which the element should be inserted.
	 * @param {Number} val - The value to be inserted into the vector.
	 * @param {function} fn - A function that is called for updates, the existing value and the
	 * requested value are passed as arguments
	 */
	lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
	  this._magnitude = 0
	  var position = this.positionForIndex(insertIdx)
	
	  if (this.elements[position] == insertIdx) {
	    this.elements[position + 1] = fn(this.elements[position + 1], val)
	  } else {
	    this.elements.splice(position, 0, insertIdx, val)
	  }
	}
	
	/**
	 * Calculates the magnitude of this vector.
	 *
	 * @returns {Number}
	 */
	lunr.Vector.prototype.magnitude = function () {
	  if (this._magnitude) return this._magnitude
	
	  var sumOfSquares = 0,
	      elementsLength = this.elements.length
	
	  for (var i = 1; i < elementsLength; i += 2) {
	    var val = this.elements[i]
	    sumOfSquares += val * val
	  }
	
	  return this._magnitude = Math.sqrt(sumOfSquares)
	}
	
	/**
	 * Calculates the dot product of this vector and another vector.
	 *
	 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
	 * @returns {Number}
	 */
	lunr.Vector.prototype.dot = function (otherVector) {
	  var dotProduct = 0,
	      a = this.elements, b = otherVector.elements,
	      aLen = a.length, bLen = b.length,
	      aVal = 0, bVal = 0,
	      i = 0, j = 0
	
	  while (i < aLen && j < bLen) {
	    aVal = a[i], bVal = b[j]
	    if (aVal < bVal) {
	      i += 2
	    } else if (aVal > bVal) {
	      j += 2
	    } else if (aVal == bVal) {
	      dotProduct += a[i + 1] * b[j + 1]
	      i += 2
	      j += 2
	    }
	  }
	
	  return dotProduct
	}
	
	/**
	 * Calculates the similarity between this vector and another vector.
	 *
	 * @param {lunr.Vector} otherVector - The other vector to calculate the
	 * similarity with.
	 * @returns {Number}
	 */
	lunr.Vector.prototype.similarity = function (otherVector) {
	  return this.dot(otherVector) / this.magnitude() || 0
	}
	
	/**
	 * Converts the vector to an array of the elements within the vector.
	 *
	 * @returns {Number[]}
	 */
	lunr.Vector.prototype.toArray = function () {
	  var output = new Array (this.elements.length / 2)
	
	  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
	    output[j] = this.elements[i]
	  }
	
	  return output
	}
	
	/**
	 * A JSON serializable representation of the vector.
	 *
	 * @returns {Number[]}
	 */
	lunr.Vector.prototype.toJSON = function () {
	  return this.elements
	}
	/* eslint-disable */
	/*!
	 * lunr.stemmer
	 * Copyright (C) 2020 Oliver Nightingale
	 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
	 */
	
	/**
	 * lunr.stemmer is an english language stemmer, this is a JavaScript
	 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
	 *
	 * @static
	 * @implements {lunr.PipelineFunction}
	 * @param {lunr.Token} token - The string to stem
	 * @returns {lunr.Token}
	 * @see {@link lunr.Pipeline}
	 * @function
	 */
	lunr.stemmer = (function(){
	  var step2list = {
	      "ational" : "ate",
	      "tional" : "tion",
	      "enci" : "ence",
	      "anci" : "ance",
	      "izer" : "ize",
	      "bli" : "ble",
	      "alli" : "al",
	      "entli" : "ent",
	      "eli" : "e",
	      "ousli" : "ous",
	      "ization" : "ize",
	      "ation" : "ate",
	      "ator" : "ate",
	      "alism" : "al",
	      "iveness" : "ive",
	      "fulness" : "ful",
	      "ousness" : "ous",
	      "aliti" : "al",
	      "iviti" : "ive",
	      "biliti" : "ble",
	      "logi" : "log"
	    },
	
	    step3list = {
	      "icate" : "ic",
	      "ative" : "",
	      "alize" : "al",
	      "iciti" : "ic",
	      "ical" : "ic",
	      "ful" : "",
	      "ness" : ""
	    },
	
	    c = "[^aeiou]",          // consonant
	    v = "[aeiouy]",          // vowel
	    C = c + "[^aeiouy]*",    // consonant sequence
	    V = v + "[aeiou]*",      // vowel sequence
	
	    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
	    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
	    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
	    s_v = "^(" + C + ")?" + v;                   // vowel in stem
	
	  var re_mgr0 = new RegExp(mgr0);
	  var re_mgr1 = new RegExp(mgr1);
	  var re_meq1 = new RegExp(meq1);
	  var re_s_v = new RegExp(s_v);
	
	  var re_1a = /^(.+?)(ss|i)es$/;
	  var re2_1a = /^(.+?)([^s])s$/;
	  var re_1b = /^(.+?)eed$/;
	  var re2_1b = /^(.+?)(ed|ing)$/;
	  var re_1b_2 = /.$/;
	  var re2_1b_2 = /(at|bl|iz)$/;
	  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
	  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");
	
	  var re_1c = /^(.+?[^aeiou])y$/;
	  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;
	
	  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;
	
	  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
	  var re2_4 = /^(.+?)(s|t)(ion)$/;
	
	  var re_5 = /^(.+?)e$/;
	  var re_5_1 = /ll$/;
	  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");
	
	  var porterStemmer = function porterStemmer(w) {
	    var stem,
	      suffix,
	      firstch,
	      re,
	      re2,
	      re3,
	      re4;
	
	    if (w.length < 3) { return w; }
	
	    firstch = w.substr(0,1);
	    if (firstch == "y") {
	      w = firstch.toUpperCase() + w.substr(1);
	    }
	
	    // Step 1a
	    re = re_1a
	    re2 = re2_1a;
	
	    if (re.test(w)) { w = w.replace(re,"$1$2"); }
	    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }
	
	    // Step 1b
	    re = re_1b;
	    re2 = re2_1b;
	    if (re.test(w)) {
	      var fp = re.exec(w);
	      re = re_mgr0;
	      if (re.test(fp[1])) {
	        re = re_1b_2;
	        w = w.replace(re,"");
	      }
	    } else if (re2.test(w)) {
	      var fp = re2.exec(w);
	      stem = fp[1];
	      re2 = re_s_v;
	      if (re2.test(stem)) {
	        w = stem;
	        re2 = re2_1b_2;
	        re3 = re3_1b_2;
	        re4 = re4_1b_2;
	        if (re2.test(w)) { w = w + "e"; }
	        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
	        else if (re4.test(w)) { w = w + "e"; }
	      }
	    }
	
	    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
	    re = re_1c;
	    if (re.test(w)) {
	      var fp = re.exec(w);
	      stem = fp[1];
	      w = stem + "i";
	    }
	
	    // Step 2
	    re = re_2;
	    if (re.test(w)) {
	      var fp = re.exec(w);
	      stem = fp[1];
	      suffix = fp[2];
	      re = re_mgr0;
	      if (re.test(stem)) {
	        w = stem + step2list[suffix];
	      }
	    }
	
	    // Step 3
	    re = re_3;
	    if (re.test(w)) {
	      var fp = re.exec(w);
	      stem = fp[1];
	      suffix = fp[2];
	      re = re_mgr0;
	      if (re.test(stem)) {
	        w = stem + step3list[suffix];
	      }
	    }
	
	    // Step 4
	    re = re_4;
	    re2 = re2_4;
	    if (re.test(w)) {
	      var fp = re.exec(w);
	      stem = fp[1];
	      re = re_mgr1;
	      if (re.test(stem)) {
	        w = stem;
	      }
	    } else if (re2.test(w)) {
	      var fp = re2.exec(w);
	      stem = fp[1] + fp[2];
	      re2 = re_mgr1;
	      if (re2.test(stem)) {
	        w = stem;
	      }
	    }
	
	    // Step 5
	    re = re_5;
	    if (re.test(w)) {
	      var fp = re.exec(w);
	      stem = fp[1];
	      re = re_mgr1;
	      re2 = re_meq1;
	      re3 = re3_5;
	      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
	        w = stem;
	      }
	    }
	
	    re = re_5_1;
	    re2 = re_mgr1;
	    if (re.test(w) && re2.test(w)) {
	      re = re_1b_2;
	      w = w.replace(re,"");
	    }
	
	    // and turn initial Y back to y
	
	    if (firstch == "y") {
	      w = firstch.toLowerCase() + w.substr(1);
	    }
	
	    return w;
	  };
	
	  return function (token) {
	    return token.update(porterStemmer);
	  }
	})();
	
	lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
	/*!
	 * lunr.stopWordFilter
	 * Copyright (C) 2020 Oliver Nightingale
	 */
	
	/**
	 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
	 * list of stop words.
	 *
	 * The built in lunr.stopWordFilter is built using this generator and can be used
	 * to generate custom stopWordFilters for applications or non English languages.
	 *
	 * @function
	 * @param {Array} token The token to pass through the filter
	 * @returns {lunr.PipelineFunction}
	 * @see lunr.Pipeline
	 * @see lunr.stopWordFilter
	 */
	lunr.generateStopWordFilter = function (stopWords) {
	  var words = stopWords.reduce(function (memo, stopWord) {
	    memo[stopWord] = stopWord
	    return memo
	  }, {})
	
	  return function (token) {
	    if (token && words[token.toString()] !== token.toString()) return token
	  }
	}
	
	/**
	 * lunr.stopWordFilter is an English language stop word list filter, any words
	 * contained in the list will not be passed through the filter.
	 *
	 * This is intended to be used in the Pipeline. If the token does not pass the
	 * filter then undefined will be returned.
	 *
	 * @function
	 * @implements {lunr.PipelineFunction}
	 * @params {lunr.Token} token - A token to check for being a stop word.
	 * @returns {lunr.Token}
	 * @see {@link lunr.Pipeline}
	 */
	lunr.stopWordFilter = lunr.generateStopWordFilter([
	  'a',
	  'able',
	  'about',
	  'across',
	  'after',
	  'all',
	  'almost',
	  'also',
	  'am',
	  'among',
	  'an',
	  'and',
	  'any',
	  'are',
	  'as',
	  'at',
	  'be',
	  'because',
	  'been',
	  'but',
	  'by',
	  'can',
	  'cannot',
	  'could',
	  'dear',
	  'did',
	  'do',
	  'does',
	  'either',
	  'else',
	  'ever',
	  'every',
	  'for',
	  'from',
	  'get',
	  'got',
	  'had',
	  'has',
	  'have',
	  'he',
	  'her',
	  'hers',
	  'him',
	  'his',
	  'how',
	  'however',
	  'i',
	  'if',
	  'in',
	  'into',
	  'is',
	  'it',
	  'its',
	  'just',
	  'least',
	  'let',
	  'like',
	  'likely',
	  'may',
	  'me',
	  'might',
	  'most',
	  'must',
	  'my',
	  'neither',
	  'no',
	  'nor',
	  'not',
	  'of',
	  'off',
	  'often',
	  'on',
	  'only',
	  'or',
	  'other',
	  'our',
	  'own',
	  'rather',
	  'said',
	  'say',
	  'says',
	  'she',
	  'should',
	  'since',
	  'so',
	  'some',
	  'than',
	  'that',
	  'the',
	  'their',
	  'them',
	  'then',
	  'there',
	  'these',
	  'they',
	  'this',
	  'tis',
	  'to',
	  'too',
	  'twas',
	  'us',
	  'wants',
	  'was',
	  'we',
	  'were',
	  'what',
	  'when',
	  'where',
	  'which',
	  'while',
	  'who',
	  'whom',
	  'why',
	  'will',
	  'with',
	  'would',
	  'yet',
	  'you',
	  'your'
	])
	
	lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
	/*!
	 * lunr.trimmer
	 * Copyright (C) 2020 Oliver Nightingale
	 */
	
	/**
	 * lunr.trimmer is a pipeline function for trimming non word
	 * characters from the beginning and end of tokens before they
	 * enter the index.
	 *
	 * This implementation may not work correctly for non latin
	 * characters and should either be removed or adapted for use
	 * with languages with non-latin characters.
	 *
	 * @static
	 * @implements {lunr.PipelineFunction}
	 * @param {lunr.Token} token The token to pass through the filter
	 * @returns {lunr.Token}
	 * @see lunr.Pipeline
	 */
	lunr.trimmer = function (token) {
	  return token.update(function (s) {
	    return s.replace(/^\W+/, '').replace(/\W+$/, '')
	  })
	}
	
	lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
	/*!
	 * lunr.TokenSet
	 * Copyright (C) 2020 Oliver Nightingale
	 */
	
	/**
	 * A token set is used to store the unique list of all tokens
	 * within an index. Token sets are also used to represent an
	 * incoming query to the index, this query token set and index
	 * token set are then intersected to find which tokens to look
	 * up in the inverted index.
	 *
	 * A token set can hold multiple tokens, as in the case of the
	 * index token set, or it can hold a single token as in the
	 * case of a simple query token set.
	 *
	 * Additionally token sets are used to perform wildcard matching.
	 * Leading, contained and trailing wildcards are supported, and
	 * from this edit distance matching can also be provided.
	 *
	 * Token sets are implemented as a minimal finite state automata,
	 * where both common prefixes and suffixes are shared between tokens.
	 * This helps to reduce the space used for storing the token set.
	 *
	 * @constructor
	 */
	lunr.TokenSet = function () {
	  this.final = false
	  this.edges = {}
	  this.id = lunr.TokenSet._nextId
	  lunr.TokenSet._nextId += 1
	}
	
	/**
	 * Keeps track of the next, auto increment, identifier to assign
	 * to a new tokenSet.
	 *
	 * TokenSets require a unique identifier to be correctly minimised.
	 *
	 * @private
	 */
	lunr.TokenSet._nextId = 1
	
	/**
	 * Creates a TokenSet instance from the given sorted array of words.
	 *
	 * @param {String[]} arr - A sorted array of strings to create the set from.
	 * @returns {lunr.TokenSet}
	 * @throws Will throw an error if the input array is not sorted.
	 */
	lunr.TokenSet.fromArray = function (arr) {
	  var builder = new lunr.TokenSet.Builder
	
	  for (var i = 0, len = arr.length; i < len; i++) {
	    builder.insert(arr[i])
	  }
	
	  builder.finish()
	  return builder.root
	}
	
	/**
	 * Creates a token set from a query clause.
	 *
	 * @private
	 * @param {Object} clause - A single clause from lunr.Query.
	 * @param {string} clause.term - The query clause term.
	 * @param {number} [clause.editDistance] - The optional edit distance for the term.
	 * @returns {lunr.TokenSet}
	 */
	lunr.TokenSet.fromClause = function (clause) {
	  if ('editDistance' in clause) {
	    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
	  } else {
	    return lunr.TokenSet.fromString(clause.term)
	  }
	}
	
	/**
	 * Creates a token set representing a single string with a specified
	 * edit distance.
	 *
	 * Insertions, deletions, substitutions and transpositions are each
	 * treated as an edit distance of 1.
	 *
	 * Increasing the allowed edit distance will have a dramatic impact
	 * on the performance of both creating and intersecting these TokenSets.
	 * It is advised to keep the edit distance less than 3.
	 *
	 * @param {string} str - The string to create the token set from.
	 * @param {number} editDistance - The allowed edit distance to match.
	 * @returns {lunr.Vector}
	 */
	lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
	  var root = new lunr.TokenSet
	
	  var stack = [{
	    node: root,
	    editsRemaining: editDistance,
	    str: str
	  }]
	
	  while (stack.length) {
	    var frame = stack.pop()
	
	    // no edit
	    if (frame.str.length > 0) {
	      var char = frame.str.charAt(0),
	          noEditNode
	
	      if (char in frame.node.edges) {
	        noEditNode = frame.node.edges[char]
	      } else {
	        noEditNode = new lunr.TokenSet
	        frame.node.edges[char] = noEditNode
	      }
	
	      if (frame.str.length == 1) {
	        noEditNode.final = true
	      }
	
	      stack.push({
	        node: noEditNode,
	        editsRemaining: frame.editsRemaining,
	        str: frame.str.slice(1)
	      })
	    }
	
	    if (frame.editsRemaining == 0) {
	      continue
	    }
	
	    // insertion
	    if ("*" in frame.node.edges) {
	      var insertionNode = frame.node.edges["*"]
	    } else {
	      var insertionNode = new lunr.TokenSet
	      frame.node.edges["*"] = insertionNode
	    }
	
	    if (frame.str.length == 0) {
	      insertionNode.final = true
	    }
	
	    stack.push({
	      node: insertionNode,
	      editsRemaining: frame.editsRemaining - 1,
	      str: frame.str
	    })
	
	    // deletion
	    // can only do a deletion if we have enough edits remaining
	    // and if there are characters left to delete in the string
	    if (frame.str.length > 1) {
	      stack.push({
	        node: frame.node,
	        editsRemaining: frame.editsRemaining - 1,
	        str: frame.str.slice(1)
	      })
	    }
	
	    // deletion
	    // just removing the last character from the str
	    if (frame.str.length == 1) {
	      frame.node.final = true
	    }
	
	    // substitution
	    // can only do a substitution if we have enough edits remaining
	    // and if there are characters left to substitute
	    if (frame.str.length >= 1) {
	      if ("*" in frame.node.edges) {
	        var substitutionNode = frame.node.edges["*"]
	      } else {
	        var substitutionNode = new lunr.TokenSet
	        frame.node.edges["*"] = substitutionNode
	      }
	
	      if (frame.str.length == 1) {
	        substitutionNode.final = true
	      }
	
	      stack.push({
	        node: substitutionNode,
	        editsRemaining: frame.editsRemaining - 1,
	        str: frame.str.slice(1)
	      })
	    }
	
	    // transposition
	    // can only do a transposition if there are edits remaining
	    // and there are enough characters to transpose
	    if (frame.str.length > 1) {
	      var charA = frame.str.charAt(0),
	          charB = frame.str.charAt(1),
	          transposeNode
	
	      if (charB in frame.node.edges) {
	        transposeNode = frame.node.edges[charB]
	      } else {
	        transposeNode = new lunr.TokenSet
	        frame.node.edges[charB] = transposeNode
	      }
	
	      if (frame.str.length == 1) {
	        transposeNode.final = true
	      }
	
	      stack.push({
	        node: transposeNode,
	        editsRemaining: frame.editsRemaining - 1,
	        str: charA + frame.str.slice(2)
	      })
	    }
	  }
	
	  return root
	}
	
	/**
	 * Creates a TokenSet from a string.
	 *
	 * The string may contain one or more wildcard characters (*)
	 * that will allow wildcard matching when intersecting with
	 * another TokenSet.
	 *
	 * @param {string} str - The string to create a TokenSet from.
	 * @returns {lunr.TokenSet}
	 */
	lunr.TokenSet.fromString = function (str) {
	  var node = new lunr.TokenSet,
	      root = node
	
	  /*
	   * Iterates through all characters within the passed string
	   * appending a node for each character.
	   *
	   * When a wildcard character is found then a self
	   * referencing edge is introduced to continually match
	   * any number of any characters.
	   */
	  for (var i = 0, len = str.length; i < len; i++) {
	    var char = str[i],
	        final = (i == len - 1)
	
	    if (char == "*") {
	      node.edges[char] = node
	      node.final = final
	
	    } else {
	      var next = new lunr.TokenSet
	      next.final = final
	
	      node.edges[char] = next
	      node = next
	    }
	  }
	
	  return root
	}
	
	/**
	 * Converts this TokenSet into an array of strings
	 * contained within the TokenSet.
	 *
	 * This is not intended to be used on a TokenSet that
	 * contains wildcards, in these cases the results are
	 * undefined and are likely to cause an infinite loop.
	 *
	 * @returns {string[]}
	 */
	lunr.TokenSet.prototype.toArray = function () {
	  var words = []
	
	  var stack = [{
	    prefix: "",
	    node: this
	  }]
	
	  while (stack.length) {
	    var frame = stack.pop(),
	        edges = Object.keys(frame.node.edges),
	        len = edges.length
	
	    if (frame.node.final) {
	      /* In Safari, at this point the prefix is sometimes corrupted, see:
	       * https://github.com/olivernn/lunr.js/issues/279 Calling any
	       * String.prototype method forces Safari to "cast" this string to what
	       * it's supposed to be, fixing the bug. */
	      frame.prefix.charAt(0)
	      words.push(frame.prefix)
	    }
	
	    for (var i = 0; i < len; i++) {
	      var edge = edges[i]
	
	      stack.push({
	        prefix: frame.prefix.concat(edge),
	        node: frame.node.edges[edge]
	      })
	    }
	  }
	
	  return words
	}
	
	/**
	 * Generates a string representation of a TokenSet.
	 *
	 * This is intended to allow TokenSets to be used as keys
	 * in objects, largely to aid the construction and minimisation
	 * of a TokenSet. As such it is not designed to be a human
	 * friendly representation of the TokenSet.
	 *
	 * @returns {string}
	 */
	lunr.TokenSet.prototype.toString = function () {
	  // NOTE: Using Object.keys here as this.edges is very likely
	  // to enter 'hash-mode' with many keys being added
	  //
	  // avoiding a for-in loop here as it leads to the function
	  // being de-optimised (at least in V8). From some simple
	  // benchmarks the performance is comparable, but allowing
	  // V8 to optimize may mean easy performance wins in the future.
	
	  if (this._str) {
	    return this._str
	  }
	
	  var str = this.final ? '1' : '0',
	      labels = Object.keys(this.edges).sort(),
	      len = labels.length
	
	  for (var i = 0; i < len; i++) {
	    var label = labels[i],
	        node = this.edges[label]
	
	    str = str + label + node.id
	  }
	
	  return str
	}
	
	/**
	 * Returns a new TokenSet that is the intersection of
	 * this TokenSet and the passed TokenSet.
	 *
	 * This intersection will take into account any wildcards
	 * contained within the TokenSet.
	 *
	 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
	 * @returns {lunr.TokenSet}
	 */
	lunr.TokenSet.prototype.intersect = function (b) {
	  var output = new lunr.TokenSet,
	      frame = undefined
	
	  var stack = [{
	    qNode: b,
	    output: output,
	    node: this
	  }]
	
	  while (stack.length) {
	    frame = stack.pop()
	
	    // NOTE: As with the #toString method, we are using
	    // Object.keys and a for loop instead of a for-in loop
	    // as both of these objects enter 'hash' mode, causing
	    // the function to be de-optimised in V8
	    var qEdges = Object.keys(frame.qNode.edges),
	        qLen = qEdges.length,
	        nEdges = Object.keys(frame.node.edges),
	        nLen = nEdges.length
	
	    for (var q = 0; q < qLen; q++) {
	      var qEdge = qEdges[q]
	
	      for (var n = 0; n < nLen; n++) {
	        var nEdge = nEdges[n]
	
	        if (nEdge == qEdge || qEdge == '*') {
	          var node = frame.node.edges[nEdge],
	              qNode = frame.qNode.edges[qEdge],
	              final = node.final && qNode.final,
	              next = undefined
	
	          if (nEdge in frame.output.edges) {
	            // an edge already exists for this character
	            // no need to create a new node, just set the finality
	            // bit unless this node is already final
	            next = frame.output.edges[nEdge]
	            next.final = next.final || final
	
	          } else {
	            // no edge exists yet, must create one
	            // set the finality bit and insert it
	            // into the output
	            next = new lunr.TokenSet
	            next.final = final
	            frame.output.edges[nEdge] = next
	          }
	
	          stack.push({
	            qNode: qNode,
	            output: next,
	            node: node
	          })
	        }
	      }
	    }
	  }
	
	  return output
	}
	lunr.TokenSet.Builder = function () {
	  this.previousWord = ""
	  this.root = new lunr.TokenSet
	  this.uncheckedNodes = []
	  this.minimizedNodes = {}
	}
	
	lunr.TokenSet.Builder.prototype.insert = function (word) {
	  var node,
	      commonPrefix = 0
	
	  if (word < this.previousWord) {
	    throw new Error ("Out of order word insertion")
	  }
	
	  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
	    if (word[i] != this.previousWord[i]) break
	    commonPrefix++
	  }
	
	  this.minimize(commonPrefix)
	
	  if (this.uncheckedNodes.length == 0) {
	    node = this.root
	  } else {
	    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
	  }
	
	  for (var i = commonPrefix; i < word.length; i++) {
	    var nextNode = new lunr.TokenSet,
	        char = word[i]
	
	    node.edges[char] = nextNode
	
	    this.uncheckedNodes.push({
	      parent: node,
	      char: char,
	      child: nextNode
	    })
	
	    node = nextNode
	  }
	
	  node.final = true
	  this.previousWord = word
	}
	
	lunr.TokenSet.Builder.prototype.finish = function () {
	  this.minimize(0)
	}
	
	lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
	  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
	    var node = this.uncheckedNodes[i],
	        childKey = node.child.toString()
	
	    if (childKey in this.minimizedNodes) {
	      node.parent.edges[node.char] = this.minimizedNodes[childKey]
	    } else {
	      // Cache the key for this node since
	      // we know it can't change anymore
	      node.child._str = childKey
	
	      this.minimizedNodes[childKey] = node.child
	    }
	
	    this.uncheckedNodes.pop()
	  }
	}
	/*!
	 * lunr.Index
	 * Copyright (C) 2020 Oliver Nightingale
	 */
	
	/**
	 * An index contains the built index of all documents and provides a query interface
	 * to the index.
	 *
	 * Usually instances of lunr.Index will not be created using this constructor, instead
	 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
	 * used to load previously built and serialized indexes.
	 *
	 * @constructor
	 * @param {Object} attrs - The attributes of the built search index.
	 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
	 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
	 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
	 * @param {string[]} attrs.fields - The names of indexed document fields.
	 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
	 */
	lunr.Index = function (attrs) {
	  this.invertedIndex = attrs.invertedIndex
	  this.fieldVectors = attrs.fieldVectors
	  this.tokenSet = attrs.tokenSet
	  this.fields = attrs.fields
	  this.pipeline = attrs.pipeline
	}
	
	/**
	 * A result contains details of a document matching a search query.
	 * @typedef {Object} lunr.Index~Result
	 * @property {string} ref - The reference of the document this result represents.
	 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
	 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
	 */
	
	/**
	 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
	 * query language which itself is parsed into an instance of lunr.Query.
	 *
	 * For programmatically building queries it is advised to directly use lunr.Query, the query language
	 * is best used for human entered text rather than program generated text.
	 *
	 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
	 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
	 * or 'world', though those that contain both will rank higher in the results.
	 *
	 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
	 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
	 * wildcards will increase the number of documents that will be found but can also have a negative
	 * impact on query performance, especially with wildcards at the beginning of a term.
	 *
	 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
	 * hello in the title field will match this query. Using a field not present in the index will lead
	 * to an error being thrown.
	 *
	 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
	 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
	 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
	 * Avoid large values for edit distance to improve query performance.
	 *
	 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
	 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
	 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
	 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
	 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
	 *
	 * To escape special characters the backslash character '\' can be used, this allows searches to include
	 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
	 * of attempting to apply a boost of 2 to the search term "foo".
	 *
	 * @typedef {string} lunr.Index~QueryString
	 * @example <caption>Simple single term query</caption>
	 * hello
	 * @example <caption>Multiple term query</caption>
	 * hello world
	 * @example <caption>term scoped to a field</caption>
	 * title:hello
	 * @example <caption>term with a boost of 10</caption>
	 * hello^10
	 * @example <caption>term with an edit distance of 2</caption>
	 * hello~2
	 * @example <caption>terms with presence modifiers</caption>
	 * -foo +bar baz
	 */
	
	/**
	 * Performs a search against the index using lunr query syntax.
	 *
	 * Results will be returned sorted by their score, the most relevant results
	 * will be returned first.  For details on how the score is calculated, please see
	 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
	 *
	 * For more programmatic querying use lunr.Index#query.
	 *
	 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
	 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
	 * @returns {lunr.Index~Result[]}
	 */
	lunr.Index.prototype.search = function (queryString) {
	  return this.query(function (query) {
	    var parser = new lunr.QueryParser(queryString, query)
	    parser.parse()
	  })
	}
	
	/**
	 * A query builder callback provides a query object to be used to express
	 * the query to perform on the index.
	 *
	 * @callback lunr.Index~queryBuilder
	 * @param {lunr.Query} query - The query object to build up.
	 * @this lunr.Query
	 */
	
	/**
	 * Performs a query against the index using the yielded lunr.Query object.
	 *
	 * If performing programmatic queries against the index, this method is preferred
	 * over lunr.Index#search so as to avoid the additional query parsing overhead.
	 *
	 * A query object is yielded to the supplied function which should be used to
	 * express the query to be run against the index.
	 *
	 * Note that although this function takes a callback parameter it is _not_ an
	 * asynchronous operation, the callback is just yielded a query object to be
	 * customized.
	 *
	 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
	 * @returns {lunr.Index~Result[]}
	 */
	lunr.Index.prototype.query = function (fn) {
	  // for each query clause
	  // * process terms
	  // * expand terms from token set
	  // * find matching documents and metadata
	  // * get document vectors
	  // * score documents
	
	  var query = new lunr.Query(this.fields),
	      matchingFields = Object.create(null),
	      queryVectors = Object.create(null),
	      termFieldCache = Object.create(null),
	      requiredMatches = Object.create(null),
	      prohibitedMatches = Object.create(null)
	
	  /*
	   * To support field level boosts a query vector is created per
	   * field. An empty vector is eagerly created to support negated
	   * queries.
	   */
	  for (var i = 0; i < this.fields.length; i++) {
	    queryVectors[this.fields[i]] = new lunr.Vector
	  }
	
	  fn.call(query, query)
	
	  for (var i = 0; i < query.clauses.length; i++) {
	    /*
	     * Unless the pipeline has been disabled for this term, which is
	     * the case for terms with wildcards, we need to pass the clause
	     * term through the search pipeline. A pipeline returns an array
	     * of processed terms. Pipeline functions may expand the passed
	     * term, which means we may end up performing multiple index lookups
	     * for a single query term.
	     */
	    var clause = query.clauses[i],
	        terms = null,
	        clauseMatches = lunr.Set.empty
	
	    if (clause.usePipeline) {
	      terms = this.pipeline.runString(clause.term, {
	        fields: clause.fields
	      })
	    } else {
	      terms = [clause.term]
	    }
	
	    for (var m = 0; m < terms.length; m++) {
	      var term = terms[m]
	
	      /*
	       * Each term returned from the pipeline needs to use the same query
	       * clause object, e.g. the same boost and or edit distance. The
	       * simplest way to do this is to re-use the clause object but mutate
	       * its term property.
	       */
	      clause.term = term
	
	      /*
	       * From the term in the clause we create a token set which will then
	       * be used to intersect the indexes token set to get a list of terms
	       * to lookup in the inverted index
	       */
	      var termTokenSet = lunr.TokenSet.fromClause(clause),
	          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()
	
	      /*
	       * If a term marked as required does not exist in the tokenSet it is
	       * impossible for the search to return any matches. We set all the field
	       * scoped required matches set to empty and stop examining any further
	       * clauses.
	       */
	      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
	        for (var k = 0; k < clause.fields.length; k++) {
	          var field = clause.fields[k]
	          requiredMatches[field] = lunr.Set.empty
	        }
	
	        break
	      }
	
	      for (var j = 0; j < expandedTerms.length; j++) {
	        /*
	         * For each term get the posting and termIndex, this is required for
	         * building the query vector.
	         */
	        var expandedTerm = expandedTerms[j],
	            posting = this.invertedIndex[expandedTerm],
	            termIndex = posting._index
	
	        for (var k = 0; k < clause.fields.length; k++) {
	          /*
	           * For each field that this query term is scoped by (by default
	           * all fields are in scope) we need to get all the document refs
	           * that have this term in that field.
	           *
	           * The posting is the entry in the invertedIndex for the matching
	           * term from above.
	           */
	          var field = clause.fields[k],
	              fieldPosting = posting[field],
	              matchingDocumentRefs = Object.keys(fieldPosting),
	              termField = expandedTerm + "/" + field,
	              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)
	
	          /*
	           * if the presence of this term is required ensure that the matching
	           * documents are added to the set of required matches for this clause.
	           *
	           */
	          if (clause.presence == lunr.Query.presence.REQUIRED) {
	            clauseMatches = clauseMatches.union(matchingDocumentsSet)
	
	            if (requiredMatches[field] === undefined) {
	              requiredMatches[field] = lunr.Set.complete
	            }
	          }
	
	          /*
	           * if the presence of this term is prohibited ensure that the matching
	           * documents are added to the set of prohibited matches for this field,
	           * creating that set if it does not yet exist.
	           */
	          if (clause.presence == lunr.Query.presence.PROHIBITED) {
	            if (prohibitedMatches[field] === undefined) {
	              prohibitedMatches[field] = lunr.Set.empty
	            }
	
	            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)
	
	            /*
	             * Prohibited matches should not be part of the query vector used for
	             * similarity scoring and no metadata should be extracted so we continue
	             * to the next field
	             */
	            continue
	          }
	
	          /*
	           * The query field vector is populated using the termIndex found for
	           * the term and a unit value with the appropriate boost applied.
	           * Using upsert because there could already be an entry in the vector
	           * for the term we are working with. In that case we just add the scores
	           * together.
	           */
	          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })
	
	          /**
	           * If we've already seen this term, field combo then we've already collected
	           * the matching documents and metadata, no need to go through all that again
	           */
	          if (termFieldCache[termField]) {
	            continue
	          }
	
	          for (var l = 0; l < matchingDocumentRefs.length; l++) {
	            /*
	             * All metadata for this term/field/document triple
	             * are then extracted and collected into an instance
	             * of lunr.MatchData ready to be returned in the query
	             * results
	             */
	            var matchingDocumentRef = matchingDocumentRefs[l],
	                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
	                metadata = fieldPosting[matchingDocumentRef],
	                fieldMatch
	
	            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
	              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
	            } else {
	              fieldMatch.add(expandedTerm, field, metadata)
	            }
	
	          }
	
	          termFieldCache[termField] = true
	        }
	      }
	    }
	
	    /**
	     * If the presence was required we need to update the requiredMatches field sets.
	     * We do this after all fields for the term have collected their matches because
	     * the clause terms presence is required in _any_ of the fields not _all_ of the
	     * fields.
	     */
	    if (clause.presence === lunr.Query.presence.REQUIRED) {
	      for (var k = 0; k < clause.fields.length; k++) {
	        var field = clause.fields[k]
	        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
	      }
	    }
	  }
	
	  /**
	   * Need to combine the field scoped required and prohibited
	   * matching documents into a global set of required and prohibited
	   * matches
	   */
	  var allRequiredMatches = lunr.Set.complete,
	      allProhibitedMatches = lunr.Set.empty
	
	  for (var i = 0; i < this.fields.length; i++) {
	    var field = this.fields[i]
	
	    if (requiredMatches[field]) {
	      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
	    }
	
	    if (prohibitedMatches[field]) {
	      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
	    }
	  }
	
	  var matchingFieldRefs = Object.keys(matchingFields),
	      results = [],
	      matches = Object.create(null)
	
	  /*
	   * If the query is negated (contains only prohibited terms)
	   * we need to get _all_ fieldRefs currently existing in the
	   * index. This is only done when we know that the query is
	   * entirely prohibited terms to avoid any cost of getting all
	   * fieldRefs unnecessarily.
	   *
	   * Additionally, blank MatchData must be created to correctly
	   * populate the results.
	   */
	  if (query.isNegated()) {
	    matchingFieldRefs = Object.keys(this.fieldVectors)
	
	    for (var i = 0; i < matchingFieldRefs.length; i++) {
	      var matchingFieldRef = matchingFieldRefs[i]
	      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
	      matchingFields[matchingFieldRef] = new lunr.MatchData
	    }
	  }
	
	  for (var i = 0; i < matchingFieldRefs.length; i++) {
	    /*
	     * Currently we have document fields that match the query, but we
	     * need to return documents. The matchData and scores are combined
	     * from multiple fields belonging to the same document.
	     *
	     * Scores are calculated by field, using the query vectors created
	     * above, and combined into a final document score using addition.
	     */
	    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
	        docRef = fieldRef.docRef
	
	    if (!allRequiredMatches.contains(docRef)) {
	      continue
	    }
	
	    if (allProhibitedMatches.contains(docRef)) {
	      continue
	    }
	
	    var fieldVector = this.fieldVectors[fieldRef],
	        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
	        docMatch
	
	    if ((docMatch = matches[docRef]) !== undefined) {
	      docMatch.score += score
	      docMatch.matchData.combine(matchingFields[fieldRef])
	    } else {
	      var match = {
	        ref: docRef,
	        score: score,
	        matchData: matchingFields[fieldRef]
	      }
	      matches[docRef] = match
	      results.push(match)
	    }
	  }
	
	  /*
	   * Sort the results objects by score, highest first.
	   */
	  return results.sort(function (a, b) {
	    return b.score - a.score
	  })
	}
	
	/**
	 * Prepares the index for JSON serialization.
	 *
	 * The schema for this JSON blob will be described in a
	 * separate JSON schema file.
	 *
	 * @returns {Object}
	 */
	lunr.Index.prototype.toJSON = function () {
	  var invertedIndex = Object.keys(this.invertedIndex)
	    .sort()
	    .map(function (term) {
	      return [term, this.invertedIndex[term]]
	    }, this)
	
	  var fieldVectors = Object.keys(this.fieldVectors)
	    .map(function (ref) {
	      return [ref, this.fieldVectors[ref].toJSON()]
	    }, this)
	
	  return {
	    version: lunr.version,
	    fields: this.fields,
	    fieldVectors: fieldVectors,
	    invertedIndex: invertedIndex,
	    pipeline: this.pipeline.toJSON()
	  }
	}
	
	/**
	 * Loads a previously serialized lunr.Index
	 *
	 * @param {Object} serializedIndex - A previously serialized lunr.Index
	 * @returns {lunr.Index}
	 */
	lunr.Index.load = function (serializedIndex) {
	  var attrs = {},
	      fieldVectors = {},
	      serializedVectors = serializedIndex.fieldVectors,
	      invertedIndex = Object.create(null),
	      serializedInvertedIndex = serializedIndex.invertedIndex,
	      tokenSetBuilder = new lunr.TokenSet.Builder,
	      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)
	
	  if (serializedIndex.version != lunr.version) {
	    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
	  }
	
	  for (var i = 0; i < serializedVectors.length; i++) {
	    var tuple = serializedVectors[i],
	        ref = tuple[0],
	        elements = tuple[1]
	
	    fieldVectors[ref] = new lunr.Vector(elements)
	  }
	
	  for (var i = 0; i < serializedInvertedIndex.length; i++) {
	    var tuple = serializedInvertedIndex[i],
	        term = tuple[0],
	        posting = tuple[1]
	
	    tokenSetBuilder.insert(term)
	    invertedIndex[term] = posting
	  }
	
	  tokenSetBuilder.finish()
	
	  attrs.fields = serializedIndex.fields
	
	  attrs.fieldVectors = fieldVectors
	  attrs.invertedIndex = invertedIndex
	  attrs.tokenSet = tokenSetBuilder.root
	  attrs.pipeline = pipeline
	
	  return new lunr.Index(attrs)
	}
	/*!
	 * lunr.Builder
	 * Copyright (C) 2020 Oliver Nightingale
	 */
	
	/**
	 * lunr.Builder performs indexing on a set of documents and
	 * returns instances of lunr.Index ready for querying.
	 *
	 * All configuration of the index is done via the builder, the
	 * fields to index, the document reference, the text processing
	 * pipeline and document scoring parameters are all set on the
	 * builder before indexing.
	 *
	 * @constructor
	 * @property {string} _ref - Internal reference to the document reference field.
	 * @property {string[]} _fields - Internal reference to the document fields to index.
	 * @property {object} invertedIndex - The inverted index maps terms to document fields.
	 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
	 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
	 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
	 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
	 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
	 * @property {number} documentCount - Keeps track of the total number of documents indexed.
	 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
	 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
	 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
	 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
	 */
	lunr.Builder = function () {
	  this._ref = "id"
	  this._fields = Object.create(null)
	  this._documents = Object.create(null)
	  this.invertedIndex = Object.create(null)
	  this.fieldTermFrequencies = {}
	  this.fieldLengths = {}
	  this.tokenizer = lunr.tokenizer
	  this.pipeline = new lunr.Pipeline
	  this.searchPipeline = new lunr.Pipeline
	  this.documentCount = 0
	  this._b = 0.75
	  this._k1 = 1.2
	  this.termIndex = 0
	  this.metadataWhitelist = []
	}
	
	/**
	 * Sets the document field used as the document reference. Every document must have this field.
	 * The type of this field in the document should be a string, if it is not a string it will be
	 * coerced into a string by calling toString.
	 *
	 * The default ref is 'id'.
	 *
	 * The ref should _not_ be changed during indexing, it should be set before any documents are
	 * added to the index. Changing it during indexing can lead to inconsistent results.
	 *
	 * @param {string} ref - The name of the reference field in the document.
	 */
	lunr.Builder.prototype.ref = function (ref) {
	  this._ref = ref
	}
	
	/**
	 * A function that is used to extract a field from a document.
	 *
	 * Lunr expects a field to be at the top level of a document, if however the field
	 * is deeply nested within a document an extractor function can be used to extract
	 * the right field for indexing.
	 *
	 * @callback fieldExtractor
	 * @param {object} doc - The document being added to the index.
	 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
	 * @example <caption>Extracting a nested field</caption>
	 * function (doc) { return doc.nested.field }
	 */
	
	/**
	 * Adds a field to the list of document fields that will be indexed. Every document being
	 * indexed should have this field. Null values for this field in indexed documents will
	 * not cause errors but will limit the chance of that document being retrieved by searches.
	 *
	 * All fields should be added before adding documents to the index. Adding fields after
	 * a document has been indexed will have no effect on already indexed documents.
	 *
	 * Fields can be boosted at build time. This allows terms within that field to have more
	 * importance when ranking search results. Use a field boost to specify that matches within
	 * one field are more important than other fields.
	 *
	 * @param {string} fieldName - The name of a field to index in all documents.
	 * @param {object} attributes - Optional attributes associated with this field.
	 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
	 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
	 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
	 */
	lunr.Builder.prototype.field = function (fieldName, attributes) {
	  if (/\//.test(fieldName)) {
	    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
	  }
	
	  this._fields[fieldName] = attributes || {}
	}
	
	/**
	 * A parameter to tune the amount of field length normalisation that is applied when
	 * calculating relevance scores. A value of 0 will completely disable any normalisation
	 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
	 * will be clamped to the range 0 - 1.
	 *
	 * @param {number} number - The value to set for this tuning parameter.
	 */
	lunr.Builder.prototype.b = function (number) {
	  if (number < 0) {
	    this._b = 0
	  } else if (number > 1) {
	    this._b = 1
	  } else {
	    this._b = number
	  }
	}
	
	/**
	 * A parameter that controls the speed at which a rise in term frequency results in term
	 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
	 * slower saturation levels, a lower value will result in quicker saturation.
	 *
	 * @param {number} number - The value to set for this tuning parameter.
	 */
	lunr.Builder.prototype.k1 = function (number) {
	  this._k1 = number
	}
	
	/**
	 * Adds a document to the index.
	 *
	 * Before adding fields to the index the index should have been fully setup, with the document
	 * ref and all fields to index already having been specified.
	 *
	 * The document must have a field name as specified by the ref (by default this is 'id') and
	 * it should have all fields defined for indexing, though null or undefined values will not
	 * cause errors.
	 *
	 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
	 * this document should rank higher in search results than other documents.
	 *
	 * @param {object} doc - The document to add to the index.
	 * @param {object} attributes - Optional attributes associated with this document.
	 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
	 */
	lunr.Builder.prototype.add = function (doc, attributes) {
	  var docRef = doc[this._ref],
	      fields = Object.keys(this._fields)
	
	  this._documents[docRef] = attributes || {}
	  this.documentCount += 1
	
	  for (var i = 0; i < fields.length; i++) {
	    var fieldName = fields[i],
	        extractor = this._fields[fieldName].extractor,
	        field = extractor ? extractor(doc) : doc[fieldName],
	        tokens = this.tokenizer(field, {
	          fields: [fieldName]
	        }),
	        terms = this.pipeline.run(tokens),
	        fieldRef = new lunr.FieldRef (docRef, fieldName),
	        fieldTerms = Object.create(null)
	
	    this.fieldTermFrequencies[fieldRef] = fieldTerms
	    this.fieldLengths[fieldRef] = 0
	
	    // store the length of this field for this document
	    this.fieldLengths[fieldRef] += terms.length
	
	    // calculate term frequencies for this field
	    for (var j = 0; j < terms.length; j++) {
	      var term = terms[j]
	
	      if (fieldTerms[term] == undefined) {
	        fieldTerms[term] = 0
	      }
	
	      fieldTerms[term] += 1
	
	      // add to inverted index
	      // create an initial posting if one doesn't exist
	      if (this.invertedIndex[term] == undefined) {
	        var posting = Object.create(null)
	        posting["_index"] = this.termIndex
	        this.termIndex += 1
	
	        for (var k = 0; k < fields.length; k++) {
	          posting[fields[k]] = Object.create(null)
	        }
	
	        this.invertedIndex[term] = posting
	      }
	
	      // add an entry for this term/fieldName/docRef to the invertedIndex
	      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
	        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
	      }
	
	      // store all whitelisted metadata about this token in the
	      // inverted index
	      for (var l = 0; l < this.metadataWhitelist.length; l++) {
	        var metadataKey = this.metadataWhitelist[l],
	            metadata = term.metadata[metadataKey]
	
	        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
	          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
	        }
	
	        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
	      }
	    }
	
	  }
	}
	
	/**
	 * Calculates the average document length for this index
	 *
	 * @private
	 */
	lunr.Builder.prototype.calculateAverageFieldLengths = function () {
	
	  var fieldRefs = Object.keys(this.fieldLengths),
	      numberOfFields = fieldRefs.length,
	      accumulator = {},
	      documentsWithField = {}
	
	  for (var i = 0; i < numberOfFields; i++) {
	    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
	        field = fieldRef.fieldName
	
	    documentsWithField[field] || (documentsWithField[field] = 0)
	    documentsWithField[field] += 1
	
	    accumulator[field] || (accumulator[field] = 0)
	    accumulator[field] += this.fieldLengths[fieldRef]
	  }
	
	  var fields = Object.keys(this._fields)
	
	  for (var i = 0; i < fields.length; i++) {
	    var fieldName = fields[i]
	    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
	  }
	
	  this.averageFieldLength = accumulator
	}
	
	/**
	 * Builds a vector space model of every document using lunr.Vector
	 *
	 * @private
	 */
	lunr.Builder.prototype.createFieldVectors = function () {
	  var fieldVectors = {},
	      fieldRefs = Object.keys(this.fieldTermFrequencies),
	      fieldRefsLength = fieldRefs.length,
	      termIdfCache = Object.create(null)
	
	  for (var i = 0; i < fieldRefsLength; i++) {
	    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
	        fieldName = fieldRef.fieldName,
	        fieldLength = this.fieldLengths[fieldRef],
	        fieldVector = new lunr.Vector,
	        termFrequencies = this.fieldTermFrequencies[fieldRef],
	        terms = Object.keys(termFrequencies),
	        termsLength = terms.length
	
	
	    var fieldBoost = this._fields[fieldName].boost || 1,
	        docBoost = this._documents[fieldRef.docRef].boost || 1
	
	    for (var j = 0; j < termsLength; j++) {
	      var term = terms[j],
	          tf = termFrequencies[term],
	          termIndex = this.invertedIndex[term]._index,
	          idf, score, scoreWithPrecision
	
	      if (termIdfCache[term] === undefined) {
	        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
	        termIdfCache[term] = idf
	      } else {
	        idf = termIdfCache[term]
	      }
	
	      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
	      score *= fieldBoost
	      score *= docBoost
	      scoreWithPrecision = Math.round(score * 1000) / 1000
	      // Converts 1.23456789 to 1.234.
	      // Reducing the precision so that the vectors take up less
	      // space when serialised. Doing it now so that they behave
	      // the same before and after serialisation. Also, this is
	      // the fastest approach to reducing a number's precision in
	      // JavaScript.
	
	      fieldVector.insert(termIndex, scoreWithPrecision)
	    }
	
	    fieldVectors[fieldRef] = fieldVector
	  }
	
	  this.fieldVectors = fieldVectors
	}
	
	/**
	 * Creates a token set of all tokens in the index using lunr.TokenSet
	 *
	 * @private
	 */
	lunr.Builder.prototype.createTokenSet = function () {
	  this.tokenSet = lunr.TokenSet.fromArray(
	    Object.keys(this.invertedIndex).sort()
	  )
	}
	
	/**
	 * Builds the index, creating an instance of lunr.Index.
	 *
	 * This completes the indexing process and should only be called
	 * once all documents have been added to the index.
	 *
	 * @returns {lunr.Index}
	 */
	lunr.Builder.prototype.build = function () {
	  this.calculateAverageFieldLengths()
	  this.createFieldVectors()
	  this.createTokenSet()
	
	  return new lunr.Index({
	    invertedIndex: this.invertedIndex,
	    fieldVectors: this.fieldVectors,
	    tokenSet: this.tokenSet,
	    fields: Object.keys(this._fields),
	    pipeline: this.searchPipeline
	  })
	}
	
	/**
	 * Applies a plugin to the index builder.
	 *
	 * A plugin is a function that is called with the index builder as its context.
	 * Plugins can be used to customise or extend the behaviour of the index
	 * in some way. A plugin is just a function, that encapsulated the custom
	 * behaviour that should be applied when building the index.
	 *
	 * The plugin function will be called with the index builder as its argument, additional
	 * arguments can also be passed when calling use. The function will be called
	 * with the index builder as its context.
	 *
	 * @param {Function} plugin The plugin to apply.
	 */
	lunr.Builder.prototype.use = function (fn) {
	  var args = Array.prototype.slice.call(arguments, 1)
	  args.unshift(this)
	  fn.apply(this, args)
	}
	/**
	 * Contains and collects metadata about a matching document.
	 * A single instance of lunr.MatchData is returned as part of every
	 * lunr.Index~Result.
	 *
	 * @constructor
	 * @param {string} term - The term this match data is associated with
	 * @param {string} field - The field in which the term was found
	 * @param {object} metadata - The metadata recorded about this term in this field
	 * @property {object} metadata - A cloned collection of metadata associated with this document.
	 * @see {@link lunr.Index~Result}
	 */
	lunr.MatchData = function (term, field, metadata) {
	  var clonedMetadata = Object.create(null),
	      metadataKeys = Object.keys(metadata || {})
	
	  // Cloning the metadata to prevent the original
	  // being mutated during match data combination.
	  // Metadata is kept in an array within the inverted
	  // index so cloning the data can be done with
	  // Array#slice
	  for (var i = 0; i < metadataKeys.length; i++) {
	    var key = metadataKeys[i]
	    clonedMetadata[key] = metadata[key].slice()
	  }
	
	  this.metadata = Object.create(null)
	
	  if (term !== undefined) {
	    this.metadata[term] = Object.create(null)
	    this.metadata[term][field] = clonedMetadata
	  }
	}
	
	/**
	 * An instance of lunr.MatchData will be created for every term that matches a
	 * document. However only one instance is required in a lunr.Index~Result. This
	 * method combines metadata from another instance of lunr.MatchData with this
	 * objects metadata.
	 *
	 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
	 * @see {@link lunr.Index~Result}
	 */
	lunr.MatchData.prototype.combine = function (otherMatchData) {
	  var terms = Object.keys(otherMatchData.metadata)
	
	  for (var i = 0; i < terms.length; i++) {
	    var term = terms[i],
	        fields = Object.keys(otherMatchData.metadata[term])
	
	    if (this.metadata[term] == undefined) {
	      this.metadata[term] = Object.create(null)
	    }
	
	    for (var j = 0; j < fields.length; j++) {
	      var field = fields[j],
	          keys = Object.keys(otherMatchData.metadata[term][field])
	
	      if (this.metadata[term][field] == undefined) {
	        this.metadata[term][field] = Object.create(null)
	      }
	
	      for (var k = 0; k < keys.length; k++) {
	        var key = keys[k]
	
	        if (this.metadata[term][field][key] == undefined) {
	          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
	        } else {
	          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
	        }
	
	      }
	    }
	  }
	}
	
	/**
	 * Add metadata for a term/field pair to this instance of match data.
	 *
	 * @param {string} term - The term this match data is associated with
	 * @param {string} field - The field in which the term was found
	 * @param {object} metadata - The metadata recorded about this term in this field
	 */
	lunr.MatchData.prototype.add = function (term, field, metadata) {
	  if (!(term in this.metadata)) {
	    this.metadata[term] = Object.create(null)
	    this.metadata[term][field] = metadata
	    return
	  }
	
	  if (!(field in this.metadata[term])) {
	    this.metadata[term][field] = metadata
	    return
	  }
	
	  var metadataKeys = Object.keys(metadata)
	
	  for (var i = 0; i < metadataKeys.length; i++) {
	    var key = metadataKeys[i]
	
	    if (key in this.metadata[term][field]) {
	      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
	    } else {
	      this.metadata[term][field][key] = metadata[key]
	    }
	  }
	}
	/**
	 * A lunr.Query provides a programmatic way of defining queries to be performed
	 * against a {@link lunr.Index}.
	 *
	 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
	 * so the query object is pre-initialized with the right index fields.
	 *
	 * @constructor
	 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
	 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
	 */
	lunr.Query = function (allFields) {
	  this.clauses = []
	  this.allFields = allFields
	}
	
	/**
	 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
	 *
	 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
	 * concatenation.
	 *
	 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
	 *
	 * @constant
	 * @default
	 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
	 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
	 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
	 * @see lunr.Query~Clause
	 * @see lunr.Query#clause
	 * @see lunr.Query#term
	 * @example <caption>query term with trailing wildcard</caption>
	 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
	 * @example <caption>query term with leading and trailing wildcard</caption>
	 * query.term('foo', {
	 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
	 * })
	 */
	
	lunr.Query.wildcard = new String ("*")
	lunr.Query.wildcard.NONE = 0
	lunr.Query.wildcard.LEADING = 1
	lunr.Query.wildcard.TRAILING = 2
	
	/**
	 * Constants for indicating what kind of presence a term must have in matching documents.
	 *
	 * @constant
	 * @enum {number}
	 * @see lunr.Query~Clause
	 * @see lunr.Query#clause
	 * @see lunr.Query#term
	 * @example <caption>query term with required presence</caption>
	 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
	 */
	lunr.Query.presence = {
	  /**
	   * Term's presence in a document is optional, this is the default value.
	   */
	  OPTIONAL: 1,
	
	  /**
	   * Term's presence in a document is required, documents that do not contain
	   * this term will not be returned.
	   */
	  REQUIRED: 2,
	
	  /**
	   * Term's presence in a document is prohibited, documents that do contain
	   * this term will not be returned.
	   */
	  PROHIBITED: 3
	}
	
	/**
	 * A single clause in a {@link lunr.Query} contains a term and details on how to
	 * match that term against a {@link lunr.Index}.
	 *
	 * @typedef {Object} lunr.Query~Clause
	 * @property {string[]} fields - The fields in an index this clause should be matched against.
	 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
	 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
	 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
	 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
	 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
	 */
	
	/**
	 * Adds a {@link lunr.Query~Clause} to this query.
	 *
	 * Unless the clause contains the fields to be matched all fields will be matched. In addition
	 * a default boost of 1 is applied to the clause.
	 *
	 * @param {lunr.Query~Clause} clause - The clause to add to this query.
	 * @see lunr.Query~Clause
	 * @returns {lunr.Query}
	 */
	lunr.Query.prototype.clause = function (clause) {
	  if (!('fields' in clause)) {
	    clause.fields = this.allFields
	  }
	
	  if (!('boost' in clause)) {
	    clause.boost = 1
	  }
	
	  if (!('usePipeline' in clause)) {
	    clause.usePipeline = true
	  }
	
	  if (!('wildcard' in clause)) {
	    clause.wildcard = lunr.Query.wildcard.NONE
	  }
	
	  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
	    clause.term = "*" + clause.term
	  }
	
	  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
	    clause.term = "" + clause.term + "*"
	  }
	
	  if (!('presence' in clause)) {
	    clause.presence = lunr.Query.presence.OPTIONAL
	  }
	
	  this.clauses.push(clause)
	
	  return this
	}
	
	/**
	 * A negated query is one in which every clause has a presence of
	 * prohibited. These queries require some special processing to return
	 * the expected results.
	 *
	 * @returns boolean
	 */
	lunr.Query.prototype.isNegated = function () {
	  for (var i = 0; i < this.clauses.length; i++) {
	    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
	      return false
	    }
	  }
	
	  return true
	}
	
	/**
	 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
	 * to the list of clauses that make up this query.
	 *
	 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
	 * to a token or token-like string should be done before calling this method.
	 *
	 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
	 * array, each term in the array will share the same options.
	 *
	 * @param {object|object[]} term - The term(s) to add to the query.
	 * @param {object} [options] - Any additional properties to add to the query clause.
	 * @returns {lunr.Query}
	 * @see lunr.Query#clause
	 * @see lunr.Query~Clause
	 * @example <caption>adding a single term to a query</caption>
	 * query.term("foo")
	 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
	 * query.term("foo", {
	 *   fields: ["title"],
	 *   boost: 10,
	 *   wildcard: lunr.Query.wildcard.TRAILING
	 * })
	 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
	 * query.term(lunr.tokenizer("foo bar"))
	 */
	lunr.Query.prototype.term = function (term, options) {
	  if (Array.isArray(term)) {
	    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
	    return this
	  }
	
	  var clause = options || {}
	  clause.term = term.toString()
	
	  this.clause(clause)
	
	  return this
	}
	lunr.QueryParseError = function (message, start, end) {
	  this.name = "QueryParseError"
	  this.message = message
	  this.start = start
	  this.end = end
	}
	
	lunr.QueryParseError.prototype = new Error
	lunr.QueryLexer = function (str) {
	  this.lexemes = []
	  this.str = str
	  this.length = str.length
	  this.pos = 0
	  this.start = 0
	  this.escapeCharPositions = []
	}
	
	lunr.QueryLexer.prototype.run = function () {
	  var state = lunr.QueryLexer.lexText
	
	  while (state) {
	    state = state(this)
	  }
	}
	
	lunr.QueryLexer.prototype.sliceString = function () {
	  var subSlices = [],
	      sliceStart = this.start,
	      sliceEnd = this.pos
	
	  for (var i = 0; i < this.escapeCharPositions.length; i++) {
	    sliceEnd = this.escapeCharPositions[i]
	    subSlices.push(this.str.slice(sliceStart, sliceEnd))
	    sliceStart = sliceEnd + 1
	  }
	
	  subSlices.push(this.str.slice(sliceStart, this.pos))
	  this.escapeCharPositions.length = 0
	
	  return subSlices.join('')
	}
	
	lunr.QueryLexer.prototype.emit = function (type) {
	  this.lexemes.push({
	    type: type,
	    str: this.sliceString(),
	    start: this.start,
	    end: this.pos
	  })
	
	  this.start = this.pos
	}
	
	lunr.QueryLexer.prototype.escapeCharacter = function () {
	  this.escapeCharPositions.push(this.pos - 1)
	  this.pos += 1
	}
	
	lunr.QueryLexer.prototype.next = function () {
	  if (this.pos >= this.length) {
	    return lunr.QueryLexer.EOS
	  }
	
	  var char = this.str.charAt(this.pos)
	  this.pos += 1
	  return char
	}
	
	lunr.QueryLexer.prototype.width = function () {
	  return this.pos - this.start
	}
	
	lunr.QueryLexer.prototype.ignore = function () {
	  if (this.start == this.pos) {
	    this.pos += 1
	  }
	
	  this.start = this.pos
	}
	
	lunr.QueryLexer.prototype.backup = function () {
	  this.pos -= 1
	}
	
	lunr.QueryLexer.prototype.acceptDigitRun = function () {
	  var char, charCode
	
	  do {
	    char = this.next()
	    charCode = char.charCodeAt(0)
	  } while (charCode > 47 && charCode < 58)
	
	  if (char != lunr.QueryLexer.EOS) {
	    this.backup()
	  }
	}
	
	lunr.QueryLexer.prototype.more = function () {
	  return this.pos < this.length
	}
	
	lunr.QueryLexer.EOS = 'EOS'
	lunr.QueryLexer.FIELD = 'FIELD'
	lunr.QueryLexer.TERM = 'TERM'
	lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
	lunr.QueryLexer.BOOST = 'BOOST'
	lunr.QueryLexer.PRESENCE = 'PRESENCE'
	
	lunr.QueryLexer.lexField = function (lexer) {
	  lexer.backup()
	  lexer.emit(lunr.QueryLexer.FIELD)
	  lexer.ignore()
	  return lunr.QueryLexer.lexText
	}
	
	lunr.QueryLexer.lexTerm = function (lexer) {
	  if (lexer.width() > 1) {
	    lexer.backup()
	    lexer.emit(lunr.QueryLexer.TERM)
	  }
	
	  lexer.ignore()
	
	  if (lexer.more()) {
	    return lunr.QueryLexer.lexText
	  }
	}
	
	lunr.QueryLexer.lexEditDistance = function (lexer) {
	  lexer.ignore()
	  lexer.acceptDigitRun()
	  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
	  return lunr.QueryLexer.lexText
	}
	
	lunr.QueryLexer.lexBoost = function (lexer) {
	  lexer.ignore()
	  lexer.acceptDigitRun()
	  lexer.emit(lunr.QueryLexer.BOOST)
	  return lunr.QueryLexer.lexText
	}
	
	lunr.QueryLexer.lexEOS = function (lexer) {
	  if (lexer.width() > 0) {
	    lexer.emit(lunr.QueryLexer.TERM)
	  }
	}
	
	// This matches the separator used when tokenising fields
	// within a document. These should match otherwise it is
	// not possible to search for some tokens within a document.
	//
	// It is possible for the user to change the separator on the
	// tokenizer so it _might_ clash with any other of the special
	// characters already used within the search string, e.g. :.
	//
	// This means that it is possible to change the separator in
	// such a way that makes some words unsearchable using a search
	// string.
	lunr.QueryLexer.termSeparator = lunr.tokenizer.separator
	
	lunr.QueryLexer.lexText = function (lexer) {
	  while (true) {
	    var char = lexer.next()
	
	    if (char == lunr.QueryLexer.EOS) {
	      return lunr.QueryLexer.lexEOS
	    }
	
	    // Escape character is '\'
	    if (char.charCodeAt(0) == 92) {
	      lexer.escapeCharacter()
	      continue
	    }
	
	    if (char == ":") {
	      return lunr.QueryLexer.lexField
	    }
	
	    if (char == "~") {
	      lexer.backup()
	      if (lexer.width() > 0) {
	        lexer.emit(lunr.QueryLexer.TERM)
	      }
	      return lunr.QueryLexer.lexEditDistance
	    }
	
	    if (char == "^") {
	      lexer.backup()
	      if (lexer.width() > 0) {
	        lexer.emit(lunr.QueryLexer.TERM)
	      }
	      return lunr.QueryLexer.lexBoost
	    }
	
	    // "+" indicates term presence is required
	    // checking for length to ensure that only
	    // leading "+" are considered
	    if (char == "+" && lexer.width() === 1) {
	      lexer.emit(lunr.QueryLexer.PRESENCE)
	      return lunr.QueryLexer.lexText
	    }
	
	    // "-" indicates term presence is prohibited
	    // checking for length to ensure that only
	    // leading "-" are considered
	    if (char == "-" && lexer.width() === 1) {
	      lexer.emit(lunr.QueryLexer.PRESENCE)
	      return lunr.QueryLexer.lexText
	    }
	
	    if (char.match(lunr.QueryLexer.termSeparator)) {
	      return lunr.QueryLexer.lexTerm
	    }
	  }
	}
	
	lunr.QueryParser = function (str, query) {
	  this.lexer = new lunr.QueryLexer (str)
	  this.query = query
	  this.currentClause = {}
	  this.lexemeIdx = 0
	}
	
	lunr.QueryParser.prototype.parse = function () {
	  this.lexer.run()
	  this.lexemes = this.lexer.lexemes
	
	  var state = lunr.QueryParser.parseClause
	
	  while (state) {
	    state = state(this)
	  }
	
	  return this.query
	}
	
	lunr.QueryParser.prototype.peekLexeme = function () {
	  return this.lexemes[this.lexemeIdx]
	}
	
	lunr.QueryParser.prototype.consumeLexeme = function () {
	  var lexeme = this.peekLexeme()
	  this.lexemeIdx += 1
	  return lexeme
	}
	
	lunr.QueryParser.prototype.nextClause = function () {
	  var completedClause = this.currentClause
	  this.query.clause(completedClause)
	  this.currentClause = {}
	}
	
	lunr.QueryParser.parseClause = function (parser) {
	  var lexeme = parser.peekLexeme()
	
	  if (lexeme == undefined) {
	    return
	  }
	
	  switch (lexeme.type) {
	    case lunr.QueryLexer.PRESENCE:
	      return lunr.QueryParser.parsePresence
	    case lunr.QueryLexer.FIELD:
	      return lunr.QueryParser.parseField
	    case lunr.QueryLexer.TERM:
	      return lunr.QueryParser.parseTerm
	    default:
	      var errorMessage = "expected either a field or a term, found " + lexeme.type
	
	      if (lexeme.str.length >= 1) {
	        errorMessage += " with value '" + lexeme.str + "'"
	      }
	
	      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
	  }
	}
	
	lunr.QueryParser.parsePresence = function (parser) {
	  var lexeme = parser.consumeLexeme()
	
	  if (lexeme == undefined) {
	    return
	  }
	
	  switch (lexeme.str) {
	    case "-":
	      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
	      break
	    case "+":
	      parser.currentClause.presence = lunr.Query.presence.REQUIRED
	      break
	    default:
	      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
	      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
	  }
	
	  var nextLexeme = parser.peekLexeme()
	
	  if (nextLexeme == undefined) {
	    var errorMessage = "expecting term or field, found nothing"
	    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
	  }
	
	  switch (nextLexeme.type) {
	    case lunr.QueryLexer.FIELD:
	      return lunr.QueryParser.parseField
	    case lunr.QueryLexer.TERM:
	      return lunr.QueryParser.parseTerm
	    default:
	      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
	      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
	  }
	}
	
	lunr.QueryParser.parseField = function (parser) {
	  var lexeme = parser.consumeLexeme()
	
	  if (lexeme == undefined) {
	    return
	  }
	
	  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
	    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
	        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields
	
	    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
	  }
	
	  parser.currentClause.fields = [lexeme.str]
	
	  var nextLexeme = parser.peekLexeme()
	
	  if (nextLexeme == undefined) {
	    var errorMessage = "expecting term, found nothing"
	    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
	  }
	
	  switch (nextLexeme.type) {
	    case lunr.QueryLexer.TERM:
	      return lunr.QueryParser.parseTerm
	    default:
	      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
	      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
	  }
	}
	
	lunr.QueryParser.parseTerm = function (parser) {
	  var lexeme = parser.consumeLexeme()
	
	  if (lexeme == undefined) {
	    return
	  }
	
	  parser.currentClause.term = lexeme.str.toLowerCase()
	
	  if (lexeme.str.indexOf("*") != -1) {
	    parser.currentClause.usePipeline = false
	  }
	
	  var nextLexeme = parser.peekLexeme()
	
	  if (nextLexeme == undefined) {
	    parser.nextClause()
	    return
	  }
	
	  switch (nextLexeme.type) {
	    case lunr.QueryLexer.TERM:
	      parser.nextClause()
	      return lunr.QueryParser.parseTerm
	    case lunr.QueryLexer.FIELD:
	      parser.nextClause()
	      return lunr.QueryParser.parseField
	    case lunr.QueryLexer.EDIT_DISTANCE:
	      return lunr.QueryParser.parseEditDistance
	    case lunr.QueryLexer.BOOST:
	      return lunr.QueryParser.parseBoost
	    case lunr.QueryLexer.PRESENCE:
	      parser.nextClause()
	      return lunr.QueryParser.parsePresence
	    default:
	      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
	      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
	  }
	}
	
	lunr.QueryParser.parseEditDistance = function (parser) {
	  var lexeme = parser.consumeLexeme()
	
	  if (lexeme == undefined) {
	    return
	  }
	
	  var editDistance = parseInt(lexeme.str, 10)
	
	  if (isNaN(editDistance)) {
	    var errorMessage = "edit distance must be numeric"
	    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
	  }
	
	  parser.currentClause.editDistance = editDistance
	
	  var nextLexeme = parser.peekLexeme()
	
	  if (nextLexeme == undefined) {
	    parser.nextClause()
	    return
	  }
	
	  switch (nextLexeme.type) {
	    case lunr.QueryLexer.TERM:
	      parser.nextClause()
	      return lunr.QueryParser.parseTerm
	    case lunr.QueryLexer.FIELD:
	      parser.nextClause()
	      return lunr.QueryParser.parseField
	    case lunr.QueryLexer.EDIT_DISTANCE:
	      return lunr.QueryParser.parseEditDistance
	    case lunr.QueryLexer.BOOST:
	      return lunr.QueryParser.parseBoost
	    case lunr.QueryLexer.PRESENCE:
	      parser.nextClause()
	      return lunr.QueryParser.parsePresence
	    default:
	      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
	      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
	  }
	}
	
	lunr.QueryParser.parseBoost = function (parser) {
	  var lexeme = parser.consumeLexeme()
	
	  if (lexeme == undefined) {
	    return
	  }
	
	  var boost = parseInt(lexeme.str, 10)
	
	  if (isNaN(boost)) {
	    var errorMessage = "boost must be numeric"
	    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
	  }
	
	  parser.currentClause.boost = boost
	
	  var nextLexeme = parser.peekLexeme()
	
	  if (nextLexeme == undefined) {
	    parser.nextClause()
	    return
	  }
	
	  switch (nextLexeme.type) {
	    case lunr.QueryLexer.TERM:
	      parser.nextClause()
	      return lunr.QueryParser.parseTerm
	    case lunr.QueryLexer.FIELD:
	      parser.nextClause()
	      return lunr.QueryParser.parseField
	    case lunr.QueryLexer.EDIT_DISTANCE:
	      return lunr.QueryParser.parseEditDistance
	    case lunr.QueryLexer.BOOST:
	      return lunr.QueryParser.parseBoost
	    case lunr.QueryLexer.PRESENCE:
	      parser.nextClause()
	      return lunr.QueryParser.parsePresence
	    default:
	      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
	      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
	  }
	}
	
	  /**
	   * export the module via AMD, CommonJS or as a browser global
	   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
	   */
	  ;(function (root, factory) {
	    if (true) {
	      // AMD. Register as an anonymous module.
	      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	    } else if (typeof exports === 'object') {
	      /**
	       * Node. Does not work with strict CommonJS, but
	       * only CommonJS-like enviroments that support module.exports,
	       * like Node.
	       */
	      module.exports = factory()
	    } else {
	      // Browser globals (root is window)
	      root.lunr = factory()
	    }
	  }(this, function () {
	    /**
	     * Just return a value to define the module export.
	     * This example returns an object, but the module
	     * can return a function as the exported value.
	     */
	    return lunr
	  }))
	})();


/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(1572));


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var chosen_category_service_1 = __webpack_require__(1083);
	var forms_1 = __webpack_require__(768);
	var util_1 = __webpack_require__(743);
	var CUSTOM_BUSINESS_CATEGORY_CONTROL_VALUE_ACCESSOR = {
	    provide: forms_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return BusinessCategoryContainerComponent; }),
	    multi: true
	};
	var BusinessCategoryContainerComponent = (function () {
	    function BusinessCategoryContainerComponent(service) {
	        var _this = this;
	        this.service = service;
	        this.categories = [];
	        this.onChangeEvent = function () {
	        };
	        this.onTouchedEvent = function () {
	        };
	        this.service.selectedCategoryEvent.subscribe(function (category) {
	            if (!_this.categories.find(function (c) { return c.id == category.id; })) {
	                _this.categories.push(category);
	                _this.patchValue(_this.categories);
	            }
	        });
	        this.service.deSelectedCategoryEvent.subscribe(function (category) {
	            _this.remove(category);
	        });
	    }
	    BusinessCategoryContainerComponent.prototype.remove = function (category) {
	        this.categories = this.categories.filter(function (item) { return item.id !== category.id; });
	        this.patchValue(this.categories);
	    };
	    BusinessCategoryContainerComponent.prototype.removeAndSendEvent = function (category) {
	        this.remove(category);
	        this.service.deleted(category);
	        this.formGroup.controls[this.controlName].markAsDirty();
	    };
	    BusinessCategoryContainerComponent.prototype.registerOnChange = function (fn) {
	        this.onChangeEvent = fn;
	    };
	    BusinessCategoryContainerComponent.prototype.registerOnTouched = function (fn) {
	        this.onTouchedEvent = fn;
	    };
	    BusinessCategoryContainerComponent.prototype.writeValue = function (obj) {
	        if (!util_1.isNullOrUndefined(obj)) {
	            this.categories = obj;
	        }
	    };
	    BusinessCategoryContainerComponent.prototype.ngAfterViewInit = function () {
	        this.service.loaded(this.categories);
	    };
	    BusinessCategoryContainerComponent.prototype.patchValue = function (value) {
	        var control = this.formGroup.controls[this.controlName];
	        control.setValue(value);
	        control.markAsDirty();
	    };
	    __decorate([
	        core_1.Input('id'),
	        __metadata("design:type", String)
	    ], BusinessCategoryContainerComponent.prototype, "id", void 0);
	    __decorate([
	        core_1.Input('form'),
	        __metadata("design:type", forms_1.FormGroup)
	    ], BusinessCategoryContainerComponent.prototype, "formGroup", void 0);
	    __decorate([
	        core_1.Input('controlName'),
	        __metadata("design:type", String)
	    ], BusinessCategoryContainerComponent.prototype, "controlName", void 0);
	    BusinessCategoryContainerComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-business-category-container',
	            template: "\n        <ng-container *ngFor=\"let category of categories\">\n            <div class=\"row form-group\">\n                <div class=\"col-xs-11\">\n                    <input [id]=\"category.id\"\n                           [value]=\"category.code + ' ' + category.name\"\n                           class=\"form-control\"\n                           style=\"background-color: #fff;\"\n                           readonly>\n                </div>\n                <i (click)=\"removeAndSendEvent(category)\" class=\"fa fa-trash fa-lg\"></i>\n            </div>\n        </ng-container>\n    ",
	            providers: [CUSTOM_BUSINESS_CATEGORY_CONTROL_VALUE_ACCESSOR]
	        }),
	        __metadata("design:paramtypes", [chosen_category_service_1.ChosenCategoryService])
	    ], BusinessCategoryContainerComponent);
	    return BusinessCategoryContainerComponent;
	}());
	exports.BusinessCategoryContainerComponent = BusinessCategoryContainerComponent;


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var forms_1 = __webpack_require__(768);
	var chosen_category_service_1 = __webpack_require__(1083);
	var util_1 = __webpack_require__(743);
	var category_checkbox_1 = __webpack_require__(1072);
	var utils_1 = __webpack_require__(740);
	var CUSTOM_BUSINESS_CATEGORY_LIST_CONTROL_VALUE_ACCESSOR = {
	    provide: forms_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return SelectableListComponent; }),
	    multi: true
	};
	var SelectableListComponent = (function () {
	    function SelectableListComponent(categoryChoosedService) {
	        var _this = this;
	        this.categoryChoosedService = categoryChoosedService;
	        this.onChanged = function () {
	        };
	        this.onTouched = function () {
	        };
	        this.loadedCategories = [];
	        this.categoryChoosedService.categoriesLoadedEvent.subscribe(function (categories) {
	            _this.loadedCategories = categories;
	        });
	    }
	    SelectableListComponent.prototype.stringWithStrongTags = function (item, name) {
	        return utils_1.StringUtils.getStringToSetStrongTag(item, name);
	    };
	    SelectableListComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        this.markLoadedCategories();
	        this.subscribeToFeatureCheckBoxCountChangesAndMarkLoadedCategories();
	        this.categoryChoosedService.categoryDeletedEvent.subscribe(function (category) {
	            _this.changeCheckBoxStateToByCategory(category, false);
	        });
	    };
	    SelectableListComponent.prototype.itemDeSelected = function (event) {
	        this.categoryChoosedService.unSelected(event);
	    };
	    SelectableListComponent.prototype.itemSelected = function (event) {
	        this.categoryChoosedService.selected(event);
	    };
	    SelectableListComponent.prototype.changeCheckBoxStateToByCategory = function (category, state) {
	        this.checkBoxes.forEach(function (checkbox) {
	            if (category.id == checkbox.item.id) {
	                checkbox.checked = state;
	            }
	        });
	    };
	    SelectableListComponent.prototype.markLoadedCategories = function () {
	        var _this = this;
	        this.loadedCategories.map(function (category) {
	            _this.changeCheckBoxStateToByCategory(category, true);
	        });
	    };
	    SelectableListComponent.prototype.subscribeToFeatureCheckBoxCountChangesAndMarkLoadedCategories = function () {
	        var _this = this;
	        this.checkBoxes.changes.subscribe(function () {
	            _this.loadedCategories.map(function (category) {
	                _this.changeCheckBoxStateToByCategory(category, true);
	            });
	        });
	    };
	    SelectableListComponent.prototype.registerOnChange = function (fn) {
	        this.onChanged = fn;
	    };
	    SelectableListComponent.prototype.registerOnTouched = function (fn) {
	        this.onTouched = fn;
	    };
	    SelectableListComponent.prototype.writeValue = function (obj) {
	        if (!util_1.isNullOrUndefined(obj)) {
	            this.data = obj;
	        }
	    };
	    __decorate([
	        core_1.Input('data'),
	        __metadata("design:type", Array)
	    ], SelectableListComponent.prototype, "data", void 0);
	    __decorate([
	        core_1.ViewChildren(category_checkbox_1.CheckboxComponent),
	        __metadata("design:type", core_1.QueryList)
	    ], SelectableListComponent.prototype, "checkBoxes", void 0);
	    SelectableListComponent = __decorate([
	        core_1.Component({
	            selector: 'tfl-selectable-list',
	            template: "\n        <ng-container *ngFor=\"let item of data\">\n            <tfl-material-card\n                [id]=\"item.id\"\n                [title]=\"stringWithStrongTags(item,'code') + ' ' + stringWithStrongTags(item,'name')\"\n                [subtitle]=\"stringWithStrongTags(item,'path')\"\n            >\n                <tfl-checkbox (itemDeSelected)=\"itemDeSelected($event)\"\n                              (itemSelected)=\"itemSelected($event)\"\n                              [item]=\"item\"\n                ></tfl-checkbox>\n            </tfl-material-card>\n        </ng-container>\n    ",
	            providers: [CUSTOM_BUSINESS_CATEGORY_LIST_CONTROL_VALUE_ACCESSOR]
	        }),
	        __metadata("design:paramtypes", [chosen_category_service_1.ChosenCategoryService])
	    ], SelectableListComponent);
	    return SelectableListComponent;
	}());
	exports.SelectableListComponent = SelectableListComponent;


/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

	(function(global,factory){ true?factory(exports,__webpack_require__(205),__webpack_require__(247),__webpack_require__(1575),__webpack_require__(246)):typeof define==="function"&&define.amd?define(["exports","@angular/core","@angular/platform-browser","ngx-window-token","@angular/common"],factory):factory((global.ngx=global.ngx||{},global.ngx.clipboard=global.ngx.clipboard||{}),global.ng.core,global._angular_platformBrowser,global.ngxWindowToken,global.ng.common)})(this,function(exports,_angular_core,_angular_platformBrowser,ngxWindowToken,_angular_common){"use strict";var ClipboardService=function(){function ClipboardService(document,window){this.document=document;this.window=window}Object.defineProperty(ClipboardService.prototype,"isSupported",{get:function(){return!!this.document.queryCommandSupported&&!!this.document.queryCommandSupported("copy")},enumerable:true,configurable:true});ClipboardService.prototype.isTargetValid=function(element){if(element instanceof HTMLInputElement||element instanceof HTMLTextAreaElement){if(element.hasAttribute("disabled")){throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute')}return true}throw new Error("Target should be input or textarea")};ClipboardService.prototype.copyFromInputElement=function(targetElm){try{this.selectTarget(targetElm);var re=this.copyText();this.clearSelection(targetElm,this.window);return re}catch(error){return false}};ClipboardService.prototype.copyFromContent=function(content){if(!this.tempTextArea){this.tempTextArea=this.createTempTextArea(this.document,this.window);this.document.body.appendChild(this.tempTextArea)}this.tempTextArea.value=content;return this.copyFromInputElement(this.tempTextArea)};ClipboardService.prototype.destroy=function(){if(this.tempTextArea){this.document.body.removeChild(this.tempTextArea);this.tempTextArea=undefined}};ClipboardService.prototype.selectTarget=function(inputElement){inputElement.select();inputElement.setSelectionRange(0,inputElement.value.length);return inputElement.value.length};ClipboardService.prototype.copyText=function(){return this.document.execCommand("copy")};ClipboardService.prototype.clearSelection=function(inputElement,window){inputElement&&inputElement.blur();window.getSelection().removeAllRanges()};ClipboardService.prototype.createTempTextArea=function(doc,window){var isRTL=doc.documentElement.getAttribute("dir")==="rtl";var ta;ta=doc.createElement("textarea");ta.style.fontSize="12pt";ta.style.border="0";ta.style.padding="0";ta.style.margin="0";ta.style.position="absolute";ta.style[isRTL?"right":"left"]="-9999px";var yPosition=window.pageYOffset||doc.documentElement.scrollTop;ta.style.top=yPosition+"px";ta.setAttribute("readonly","");return ta};ClipboardService.decorators=[{type:_angular_core.Injectable}];ClipboardService.ctorParameters=function(){return[{type:undefined,decorators:[{type:_angular_core.Inject,args:[_angular_platformBrowser.DOCUMENT]}]},{type:undefined,decorators:[{type:_angular_core.Inject,args:[ngxWindowToken.WINDOW]}]}]};return ClipboardService}();function CLIPBOARD_SERVICE_PROVIDER_FACTORY(doc,win,parentDispatcher){return parentDispatcher||new ClipboardService(doc,win)}var CLIPBOARD_SERVICE_PROVIDER={deps:[_angular_platformBrowser.DOCUMENT,ngxWindowToken.WINDOW,[new _angular_core.Optional,new _angular_core.SkipSelf,ClipboardService]],provide:ClipboardService,useFactory:CLIPBOARD_SERVICE_PROVIDER_FACTORY};var ClipboardDirective=function(){function ClipboardDirective(clipboardSrv){this.clipboardSrv=clipboardSrv;this.cbOnSuccess=new _angular_core.EventEmitter;this.cbOnError=new _angular_core.EventEmitter}ClipboardDirective.prototype.ngOnInit=function(){};ClipboardDirective.prototype.ngOnDestroy=function(){this.clipboardSrv.destroy()};ClipboardDirective.prototype.onClick=function(event){if(!this.clipboardSrv.isSupported){this.handleResult(false,undefined)}else if(this.targetElm&&this.clipboardSrv.isTargetValid(this.targetElm)){this.handleResult(this.clipboardSrv.copyFromInputElement(this.targetElm),this.targetElm.value)}else if(this.cbContent){this.handleResult(this.clipboardSrv.copyFromContent(this.cbContent),this.cbContent)}};ClipboardDirective.prototype.handleResult=function(succeeded,copiedContent){if(succeeded){this.cbOnSuccess.emit({isSuccess:true,content:copiedContent})}else{this.cbOnError.emit({isSuccess:false})}};ClipboardDirective.decorators=[{type:_angular_core.Directive,args:[{selector:"[ngxClipboard]"}]}];ClipboardDirective.ctorParameters=function(){return[{type:ClipboardService}]};ClipboardDirective.propDecorators={targetElm:[{type:_angular_core.Input,args:["ngxClipboard"]}],cbContent:[{type:_angular_core.Input}],cbOnSuccess:[{type:_angular_core.Output}],cbOnError:[{type:_angular_core.Output}],onClick:[{type:_angular_core.HostListener,args:["click",["$event.target"]]}]};return ClipboardDirective}();var ClipboardModule=function(){function ClipboardModule(){}ClipboardModule.decorators=[{type:_angular_core.NgModule,args:[{imports:[_angular_common.CommonModule,ngxWindowToken.WindowTokenModule],declarations:[ClipboardDirective],exports:[ClipboardDirective],providers:[CLIPBOARD_SERVICE_PROVIDER]}]}];ClipboardModule.ctorParameters=function(){return[]};return ClipboardModule}();exports.ClipboardModule=ClipboardModule;exports.ClipboardDirective=ClipboardDirective;exports.ClipboardService=ClipboardService;Object.defineProperty(exports,"__esModule",{value:true})});

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

	(function(global,factory){ true?factory(exports,__webpack_require__(205)):typeof define==="function"&&define.amd?define(["exports","@angular/core"],factory):factory((global.ngx=global.ngx||{},global.ngx.clipboard=global.ngx.clipboard||{}),global.ng.core)})(this,function(exports,_angular_core){"use strict";var WINDOW=new _angular_core.InjectionToken("WindowToken");function _window(){return window}var WindowTokenModule=function(){function WindowTokenModule(){}return WindowTokenModule}();WindowTokenModule.decorators=[{type:_angular_core.NgModule,args:[{providers:[{provide:WINDOW,useFactory:_window}]}]}];WindowTokenModule.ctorParameters=function(){return[]};exports.WindowTokenModule=WindowTokenModule;exports.WINDOW=WINDOW;Object.defineProperty(exports,"__esModule",{value:true})});

/***/ }),
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */,
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */,
/* 2117 */,
/* 2118 */,
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */,
/* 2123 */,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */,
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */,
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */,
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */,
/* 2202 */,
/* 2203 */,
/* 2204 */,
/* 2205 */,
/* 2206 */,
/* 2207 */,
/* 2208 */,
/* 2209 */,
/* 2210 */,
/* 2211 */,
/* 2212 */,
/* 2213 */,
/* 2214 */,
/* 2215 */,
/* 2216 */,
/* 2217 */,
/* 2218 */,
/* 2219 */,
/* 2220 */,
/* 2221 */,
/* 2222 */,
/* 2223 */,
/* 2224 */,
/* 2225 */,
/* 2226 */,
/* 2227 */,
/* 2228 */,
/* 2229 */,
/* 2230 */,
/* 2231 */,
/* 2232 */,
/* 2233 */,
/* 2234 */,
/* 2235 */,
/* 2236 */,
/* 2237 */,
/* 2238 */,
/* 2239 */,
/* 2240 */,
/* 2241 */,
/* 2242 */,
/* 2243 */,
/* 2244 */,
/* 2245 */,
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */,
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */,
/* 2259 */,
/* 2260 */,
/* 2261 */,
/* 2262 */,
/* 2263 */,
/* 2264 */,
/* 2265 */,
/* 2266 */,
/* 2267 */,
/* 2268 */,
/* 2269 */,
/* 2270 */,
/* 2271 */,
/* 2272 */,
/* 2273 */,
/* 2274 */,
/* 2275 */,
/* 2276 */,
/* 2277 */,
/* 2278 */,
/* 2279 */,
/* 2280 */,
/* 2281 */,
/* 2282 */,
/* 2283 */,
/* 2284 */,
/* 2285 */,
/* 2286 */,
/* 2287 */,
/* 2288 */,
/* 2289 */,
/* 2290 */,
/* 2291 */,
/* 2292 */,
/* 2293 */,
/* 2294 */,
/* 2295 */,
/* 2296 */,
/* 2297 */,
/* 2298 */,
/* 2299 */,
/* 2300 */,
/* 2301 */,
/* 2302 */,
/* 2303 */,
/* 2304 */,
/* 2305 */,
/* 2306 */,
/* 2307 */,
/* 2308 */,
/* 2309 */,
/* 2310 */,
/* 2311 */,
/* 2312 */,
/* 2313 */,
/* 2314 */,
/* 2315 */,
/* 2316 */,
/* 2317 */,
/* 2318 */,
/* 2319 */,
/* 2320 */,
/* 2321 */,
/* 2322 */,
/* 2323 */,
/* 2324 */,
/* 2325 */,
/* 2326 */,
/* 2327 */,
/* 2328 */,
/* 2329 */,
/* 2330 */,
/* 2331 */,
/* 2332 */,
/* 2333 */,
/* 2334 */,
/* 2335 */,
/* 2336 */,
/* 2337 */,
/* 2338 */,
/* 2339 */,
/* 2340 */,
/* 2341 */,
/* 2342 */,
/* 2343 */,
/* 2344 */,
/* 2345 */,
/* 2346 */,
/* 2347 */,
/* 2348 */,
/* 2349 */,
/* 2350 */,
/* 2351 */,
/* 2352 */,
/* 2353 */,
/* 2354 */,
/* 2355 */,
/* 2356 */,
/* 2357 */,
/* 2358 */,
/* 2359 */,
/* 2360 */,
/* 2361 */,
/* 2362 */,
/* 2363 */,
/* 2364 */,
/* 2365 */,
/* 2366 */,
/* 2367 */,
/* 2368 */,
/* 2369 */,
/* 2370 */,
/* 2371 */,
/* 2372 */,
/* 2373 */,
/* 2374 */,
/* 2375 */,
/* 2376 */,
/* 2377 */,
/* 2378 */,
/* 2379 */,
/* 2380 */,
/* 2381 */,
/* 2382 */,
/* 2383 */,
/* 2384 */,
/* 2385 */,
/* 2386 */,
/* 2387 */,
/* 2388 */,
/* 2389 */,
/* 2390 */,
/* 2391 */,
/* 2392 */,
/* 2393 */,
/* 2394 */,
/* 2395 */,
/* 2396 */,
/* 2397 */,
/* 2398 */,
/* 2399 */,
/* 2400 */,
/* 2401 */,
/* 2402 */,
/* 2403 */,
/* 2404 */,
/* 2405 */,
/* 2406 */,
/* 2407 */,
/* 2408 */,
/* 2409 */,
/* 2410 */,
/* 2411 */,
/* 2412 */,
/* 2413 */,
/* 2414 */,
/* 2415 */,
/* 2416 */,
/* 2417 */,
/* 2418 */,
/* 2419 */,
/* 2420 */,
/* 2421 */,
/* 2422 */,
/* 2423 */,
/* 2424 */,
/* 2425 */,
/* 2426 */,
/* 2427 */,
/* 2428 */,
/* 2429 */,
/* 2430 */,
/* 2431 */,
/* 2432 */,
/* 2433 */,
/* 2434 */,
/* 2435 */,
/* 2436 */,
/* 2437 */,
/* 2438 */,
/* 2439 */,
/* 2440 */,
/* 2441 */,
/* 2442 */,
/* 2443 */,
/* 2444 */,
/* 2445 */,
/* 2446 */,
/* 2447 */,
/* 2448 */,
/* 2449 */,
/* 2450 */,
/* 2451 */,
/* 2452 */,
/* 2453 */,
/* 2454 */,
/* 2455 */,
/* 2456 */,
/* 2457 */,
/* 2458 */,
/* 2459 */,
/* 2460 */,
/* 2461 */,
/* 2462 */,
/* 2463 */,
/* 2464 */,
/* 2465 */,
/* 2466 */,
/* 2467 */,
/* 2468 */,
/* 2469 */,
/* 2470 */,
/* 2471 */,
/* 2472 */,
/* 2473 */,
/* 2474 */,
/* 2475 */,
/* 2476 */,
/* 2477 */,
/* 2478 */,
/* 2479 */,
/* 2480 */,
/* 2481 */,
/* 2482 */,
/* 2483 */,
/* 2484 */,
/* 2485 */,
/* 2486 */,
/* 2487 */,
/* 2488 */,
/* 2489 */,
/* 2490 */,
/* 2491 */,
/* 2492 */,
/* 2493 */,
/* 2494 */,
/* 2495 */,
/* 2496 */,
/* 2497 */,
/* 2498 */,
/* 2499 */,
/* 2500 */,
/* 2501 */,
/* 2502 */,
/* 2503 */,
/* 2504 */,
/* 2505 */,
/* 2506 */,
/* 2507 */,
/* 2508 */,
/* 2509 */,
/* 2510 */,
/* 2511 */,
/* 2512 */,
/* 2513 */,
/* 2514 */,
/* 2515 */,
/* 2516 */,
/* 2517 */,
/* 2518 */,
/* 2519 */,
/* 2520 */,
/* 2521 */,
/* 2522 */,
/* 2523 */,
/* 2524 */,
/* 2525 */,
/* 2526 */,
/* 2527 */,
/* 2528 */,
/* 2529 */,
/* 2530 */,
/* 2531 */,
/* 2532 */,
/* 2533 */,
/* 2534 */,
/* 2535 */,
/* 2536 */,
/* 2537 */,
/* 2538 */,
/* 2539 */,
/* 2540 */,
/* 2541 */,
/* 2542 */,
/* 2543 */,
/* 2544 */,
/* 2545 */,
/* 2546 */,
/* 2547 */,
/* 2548 */,
/* 2549 */,
/* 2550 */,
/* 2551 */,
/* 2552 */,
/* 2553 */,
/* 2554 */,
/* 2555 */,
/* 2556 */,
/* 2557 */,
/* 2558 */,
/* 2559 */,
/* 2560 */,
/* 2561 */,
/* 2562 */,
/* 2563 */,
/* 2564 */,
/* 2565 */,
/* 2566 */,
/* 2567 */,
/* 2568 */,
/* 2569 */,
/* 2570 */,
/* 2571 */,
/* 2572 */,
/* 2573 */,
/* 2574 */,
/* 2575 */,
/* 2576 */,
/* 2577 */,
/* 2578 */,
/* 2579 */,
/* 2580 */,
/* 2581 */,
/* 2582 */,
/* 2583 */,
/* 2584 */,
/* 2585 */,
/* 2586 */,
/* 2587 */,
/* 2588 */,
/* 2589 */,
/* 2590 */,
/* 2591 */,
/* 2592 */,
/* 2593 */,
/* 2594 */,
/* 2595 */,
/* 2596 */,
/* 2597 */,
/* 2598 */,
/* 2599 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var dashboard_error_handler_1 = __webpack_require__(2600);
	var dashboard_error_resolver_1 = __webpack_require__(2601);
	var _1 = __webpack_require__(905);
	__export(__webpack_require__(2600));
	__export(__webpack_require__(2601));
	exports.ERROR_PROVIDERS = [
	    { provide: _1.CommonErrorResolver, useClass: dashboard_error_resolver_1.DashboardErrorResolver },
	    { provide: core_1.ErrorHandler, useClass: dashboard_error_handler_1.DashboardErrorHandler }
	];


/***/ }),
/* 2600 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var router_1 = __webpack_require__(270);
	var core_1 = __webpack_require__(205);
	var cookies_1 = __webpack_require__(738);
	var notification_1 = __webpack_require__(264);
	var exception_1 = __webpack_require__(914);
	var DashboardErrorHandler = (function (_super) {
	    __extends(DashboardErrorHandler, _super);
	    function DashboardErrorHandler(injector, notificationManager, ngZone) {
	        var _this = _super.call(this) || this;
	        _this.injector = injector;
	        _this.notificationManager = notificationManager;
	        _this.ngZone = ngZone;
	        return _this;
	    }
	    DashboardErrorHandler.prototype.handleError = function (error) {
	        //todo andrey use DI
	        //noinspection TypeScriptUnresolvedVariable
	        if (error instanceof exception_1.ServerException) {
	            switch (error.status) {
	                case 400: {
	                    //todo andrey build default message
	                    this.notificationManager.error(error.message || 'Unknown server validation', true);
	                    break;
	                }
	                case 401: {
	                    cookies_1.CookiesManager.clearToken();
	                    this.getRouter().navigate(['login']);
	                    break;
	                }
	                case 403: {
	                    this.navigateToUnauthorizedComponent();
	                    break;
	                }
	                default: {
	                    this.navigateToErrorComponent();
	                }
	            }
	        }
	        else if (error instanceof exception_1.UnavailableException) {
	            this.navigateToErrorComponent();
	        }
	        else {
	            _super.prototype.handleError.call(this, error);
	        }
	    };
	    DashboardErrorHandler.prototype.navigateToErrorComponent = function () {
	        var _this = this;
	        if (cookies_1.CookiesManager.isTokenExist()) {
	            this.ngZone.run(function () {
	                _this.getRouter().navigate(['space', 'error']);
	            });
	        }
	        else {
	            this.ngZone.run(function () {
	                _this.getRouter().navigate(['error']);
	            });
	        }
	    };
	    DashboardErrorHandler.prototype.navigateToUnauthorizedComponent = function () {
	        var _this = this;
	        if (cookies_1.CookiesManager.isTokenExist()) {
	            this.ngZone.run(function () {
	                _this.getRouter().navigate(['space', 'unauthorized']);
	            });
	        }
	        else {
	            this.ngZone.run(function () {
	                _this.getRouter().navigate(['unauthorized']);
	            });
	        }
	    };
	    DashboardErrorHandler.prototype.getRouter = function () {
	        return this.router == null
	            ? this.router = this.injector.get(router_1.Router)
	            : this.router;
	    };
	    DashboardErrorHandler = __decorate([
	        core_1.Injectable(),
	        __metadata("design:paramtypes", [core_1.Injector, notification_1.NotificationManager, core_1.NgZone])
	    ], DashboardErrorHandler);
	    return DashboardErrorHandler;
	}(core_1.ErrorHandler));
	exports.DashboardErrorHandler = DashboardErrorHandler;


/***/ }),
/* 2601 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var providers_1 = __webpack_require__(905);
	var DashboardErrorResolver = (function (_super) {
	    __extends(DashboardErrorResolver, _super);
	    function DashboardErrorResolver() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DashboardErrorResolver.prototype.resolveBadRequestErrors = function (response) {
	        switch (response.code) {
	            case 'ERR004':
	            case 'ERR009':
	            case 'ERR005':
	            case 'ERR010':
	            case 'ERR013':
	            case 'ERR022':
	            case 'ERR023':
	            case 'ERR025':
	            case 'ERR028':
	            case 'ERR045':
	            case 'ERR047':
	            case 'ERR049':
	            case 'ERR053':
	            case 'ERR054':
	            case 'ERR055':
	            case 'ERR058':
	            case 'ERR059':
	            case 'ERR060':
	            case 'ERR061':
	            case 'ERR062':
	            case 'ERR063':
	            case 'ERR068':
	            case 'ERR069':
	            case 'ERR070':
	            case 'ERR072':
	            case 'ERR075':
	            case 'ERR077':
	            case 'ERR078':
	            case 'ERR079':
	            case 'ERR080':
	            case 'ERR081':
	            case 'ERR083':
	            case 'ERR084':
	            case 'ERR085':
	            case 'ERR138':
	            case 'ERR139':
	            case 'ERR140':
	            case 'ERR141':
	            case 'ERR142':
	            case 'ERR143':
	            case 'ERR144':
	            case 'ERR145':
	            case 'ERR146':
	            case 'ERR147':
	            case 'ERR148':
	            case 'ERR149':
	            case 'ERR157':
	            case 'ERR158':
	            case 'ERR168':
	            case 'ERR169':
	            case 'ERR175':
	            case 'ERR176':
	            case 'ERR177':
	            case 'ERR178':
	            case 'ERR180':
	            case 'ERR181':
	            case 'ERR306':
	            case 'ERR308':
	            case 'ERR309':
	            case 'ERR320':
	            case 'ERR310':
	            case 'ERR350':
	            case 'ERR351':
	            case 'ERR352': {
	                return response;
	            }
	            default:
	                return _super.prototype.resolveBadRequestErrors.call(this, response);
	        }
	    };
	    DashboardErrorResolver = __decorate([
	        core_1.Injectable()
	    ], DashboardErrorResolver);
	    return DashboardErrorResolver;
	}(providers_1.CommonErrorResolver));
	exports.DashboardErrorResolver = DashboardErrorResolver;


/***/ }),
/* 2602 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var menu_resizer_service_1 = __webpack_require__(876);
	var MenuResizer = (function () {
	    function MenuResizer(renderer, menuResizeService) {
	        this.renderer = renderer;
	        this.menuResizeService = menuResizeService;
	        this.isLargeView = true;
	    }
	    MenuResizer.prototype.checkRootElementAvailability = function () {
	        if (!this.rootElement) {
	            this.rootElement = document.querySelector('.root-container');
	        }
	    };
	    MenuResizer.prototype.resize = function () {
	        this.checkRootElementAvailability();
	        this.isLargeView = !this.isLargeView;
	        this.updateView(this.isLargeView);
	        this.menuResizeService.changeSize(this.isLargeView);
	    };
	    MenuResizer.prototype.updateView = function (isLarge) {
	        if (isLarge) {
	            this.renderer.addClass(this.rootElement, 'nav-md');
	            this.renderer.removeClass(this.rootElement, 'nav-sm');
	        }
	        else {
	            this.renderer.removeClass(this.rootElement, 'nav-md');
	            this.renderer.addClass(this.rootElement, 'nav-sm');
	        }
	    };
	    MenuResizer = __decorate([
	        core_1.Component({
	            selector: 'menu-resizer',
	            template: __webpack_require__(2603)
	        }),
	        __metadata("design:paramtypes", [core_1.Renderer2,
	            menu_resizer_service_1.MenuResizeService])
	    ], MenuResizer);
	    return MenuResizer;
	}());
	exports.MenuResizer = MenuResizer;


/***/ }),
/* 2603 */
/***/ (function(module, exports) {

	module.exports = "<a id=\"menu_toggle\" (click)='resize()'>\n    <i class=\"fa fa-bars\"></i>\n</a>"

/***/ }),
/* 2604 */
/***/ (function(module, exports, __webpack_require__) {

	if (true) {
	    __webpack_require__(2605);
	}
	else {
	    require('./vendor/whitelabel/whitelabel.less');
	}


/***/ }),
/* 2605 */
2891,
/* 2606 */,
/* 2607 */,
/* 2608 */,
/* 2609 */,
/* 2610 */,
/* 2611 */,
/* 2612 */,
/* 2613 */,
/* 2614 */,
/* 2615 */,
/* 2616 */,
/* 2617 */,
/* 2618 */,
/* 2619 */,
/* 2620 */,
/* 2621 */,
/* 2622 */,
/* 2623 */,
/* 2624 */,
/* 2625 */,
/* 2626 */,
/* 2627 */,
/* 2628 */,
/* 2629 */,
/* 2630 */,
/* 2631 */,
/* 2632 */,
/* 2633 */,
/* 2634 */,
/* 2635 */,
/* 2636 */,
/* 2637 */,
/* 2638 */,
/* 2639 */,
/* 2640 */,
/* 2641 */,
/* 2642 */,
/* 2643 */,
/* 2644 */,
/* 2645 */,
/* 2646 */,
/* 2647 */,
/* 2648 */,
/* 2649 */,
/* 2650 */,
/* 2651 */,
/* 2652 */,
/* 2653 */,
/* 2654 */,
/* 2655 */,
/* 2656 */,
/* 2657 */,
/* 2658 */,
/* 2659 */,
/* 2660 */,
/* 2661 */,
/* 2662 */,
/* 2663 */,
/* 2664 */,
/* 2665 */,
/* 2666 */,
/* 2667 */,
/* 2668 */,
/* 2669 */,
/* 2670 */,
/* 2671 */,
/* 2672 */,
/* 2673 */,
/* 2674 */,
/* 2675 */,
/* 2676 */,
/* 2677 */,
/* 2678 */,
/* 2679 */,
/* 2680 */,
/* 2681 */,
/* 2682 */,
/* 2683 */,
/* 2684 */,
/* 2685 */,
/* 2686 */,
/* 2687 */,
/* 2688 */,
/* 2689 */,
/* 2690 */,
/* 2691 */,
/* 2692 */,
/* 2693 */,
/* 2694 */,
/* 2695 */,
/* 2696 */,
/* 2697 */,
/* 2698 */,
/* 2699 */,
/* 2700 */,
/* 2701 */,
/* 2702 */,
/* 2703 */,
/* 2704 */,
/* 2705 */,
/* 2706 */,
/* 2707 */,
/* 2708 */,
/* 2709 */,
/* 2710 */,
/* 2711 */,
/* 2712 */,
/* 2713 */,
/* 2714 */,
/* 2715 */,
/* 2716 */,
/* 2717 */,
/* 2718 */,
/* 2719 */,
/* 2720 */,
/* 2721 */,
/* 2722 */,
/* 2723 */,
/* 2724 */,
/* 2725 */,
/* 2726 */,
/* 2727 */,
/* 2728 */,
/* 2729 */,
/* 2730 */,
/* 2731 */,
/* 2732 */,
/* 2733 */,
/* 2734 */,
/* 2735 */,
/* 2736 */,
/* 2737 */,
/* 2738 */,
/* 2739 */,
/* 2740 */,
/* 2741 */,
/* 2742 */,
/* 2743 */,
/* 2744 */,
/* 2745 */,
/* 2746 */,
/* 2747 */,
/* 2748 */,
/* 2749 */,
/* 2750 */,
/* 2751 */,
/* 2752 */,
/* 2753 */,
/* 2754 */,
/* 2755 */,
/* 2756 */,
/* 2757 */,
/* 2758 */,
/* 2759 */,
/* 2760 */,
/* 2761 */,
/* 2762 */,
/* 2763 */,
/* 2764 */,
/* 2765 */,
/* 2766 */,
/* 2767 */,
/* 2768 */,
/* 2769 */,
/* 2770 */,
/* 2771 */,
/* 2772 */,
/* 2773 */,
/* 2774 */,
/* 2775 */,
/* 2776 */,
/* 2777 */,
/* 2778 */,
/* 2779 */,
/* 2780 */,
/* 2781 */,
/* 2782 */,
/* 2783 */,
/* 2784 */,
/* 2785 */,
/* 2786 */,
/* 2787 */,
/* 2788 */,
/* 2789 */,
/* 2790 */,
/* 2791 */,
/* 2792 */,
/* 2793 */,
/* 2794 */,
/* 2795 */,
/* 2796 */,
/* 2797 */,
/* 2798 */,
/* 2799 */,
/* 2800 */,
/* 2801 */,
/* 2802 */,
/* 2803 */,
/* 2804 */,
/* 2805 */,
/* 2806 */,
/* 2807 */,
/* 2808 */,
/* 2809 */,
/* 2810 */,
/* 2811 */,
/* 2812 */,
/* 2813 */,
/* 2814 */,
/* 2815 */,
/* 2816 */,
/* 2817 */,
/* 2818 */,
/* 2819 */,
/* 2820 */,
/* 2821 */,
/* 2822 */,
/* 2823 */,
/* 2824 */,
/* 2825 */,
/* 2826 */,
/* 2827 */,
/* 2828 */,
/* 2829 */,
/* 2830 */,
/* 2831 */,
/* 2832 */,
/* 2833 */,
/* 2834 */,
/* 2835 */,
/* 2836 */,
/* 2837 */,
/* 2838 */,
/* 2839 */,
/* 2840 */,
/* 2841 */,
/* 2842 */,
/* 2843 */,
/* 2844 */,
/* 2845 */,
/* 2846 */,
/* 2847 */,
/* 2848 */,
/* 2849 */,
/* 2850 */,
/* 2851 */,
/* 2852 */,
/* 2853 */,
/* 2854 */,
/* 2855 */,
/* 2856 */,
/* 2857 */,
/* 2858 */,
/* 2859 */,
/* 2860 */,
/* 2861 */,
/* 2862 */,
/* 2863 */,
/* 2864 */,
/* 2865 */,
/* 2866 */,
/* 2867 */,
/* 2868 */,
/* 2869 */,
/* 2870 */,
/* 2871 */,
/* 2872 */,
/* 2873 */,
/* 2874 */,
/* 2875 */,
/* 2876 */,
/* 2877 */,
/* 2878 */,
/* 2879 */,
/* 2880 */,
/* 2881 */,
/* 2882 */,
/* 2883 */,
/* 2884 */,
/* 2885 */,
/* 2886 */,
/* 2887 */,
/* 2888 */,
/* 2889 */,
/* 2890 */,
/* 2891 */,
/* 2892 */,
/* 2893 */,
/* 2894 */,
/* 2895 */,
/* 2896 */,
/* 2897 */,
/* 2898 */,
/* 2899 */,
/* 2900 */,
/* 2901 */,
/* 2902 */,
/* 2903 */,
/* 2904 */,
/* 2905 */,
/* 2906 */,
/* 2907 */,
/* 2908 */,
/* 2909 */,
/* 2910 */,
/* 2911 */,
/* 2912 */,
/* 2913 */,
/* 2914 */,
/* 2915 */,
/* 2916 */,
/* 2917 */,
/* 2918 */,
/* 2919 */,
/* 2920 */,
/* 2921 */,
/* 2922 */,
/* 2923 */,
/* 2924 */,
/* 2925 */,
/* 2926 */,
/* 2927 */,
/* 2928 */,
/* 2929 */,
/* 2930 */,
/* 2931 */,
/* 2932 */,
/* 2933 */,
/* 2934 */,
/* 2935 */,
/* 2936 */,
/* 2937 */,
/* 2938 */,
/* 2939 */,
/* 2940 */,
/* 2941 */,
/* 2942 */,
/* 2943 */,
/* 2944 */,
/* 2945 */,
/* 2946 */,
/* 2947 */,
/* 2948 */,
/* 2949 */,
/* 2950 */,
/* 2951 */,
/* 2952 */,
/* 2953 */,
/* 2954 */,
/* 2955 */,
/* 2956 */,
/* 2957 */,
/* 2958 */,
/* 2959 */,
/* 2960 */,
/* 2961 */,
/* 2962 */,
/* 2963 */,
/* 2964 */,
/* 2965 */,
/* 2966 */,
/* 2967 */,
/* 2968 */,
/* 2969 */,
/* 2970 */,
/* 2971 */,
/* 2972 */,
/* 2973 */,
/* 2974 */,
/* 2975 */,
/* 2976 */,
/* 2977 */,
/* 2978 */,
/* 2979 */,
/* 2980 */,
/* 2981 */,
/* 2982 */,
/* 2983 */,
/* 2984 */,
/* 2985 */,
/* 2986 */,
/* 2987 */,
/* 2988 */,
/* 2989 */,
/* 2990 */,
/* 2991 */,
/* 2992 */,
/* 2993 */,
/* 2994 */,
/* 2995 */,
/* 2996 */,
/* 2997 */,
/* 2998 */,
/* 2999 */,
/* 3000 */,
/* 3001 */,
/* 3002 */,
/* 3003 */,
/* 3004 */,
/* 3005 */,
/* 3006 */,
/* 3007 */,
/* 3008 */,
/* 3009 */,
/* 3010 */,
/* 3011 */,
/* 3012 */,
/* 3013 */,
/* 3014 */,
/* 3015 */,
/* 3016 */,
/* 3017 */,
/* 3018 */,
/* 3019 */,
/* 3020 */,
/* 3021 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//noinspection TypeScriptCheckImport
	var translate_utils_1 = __webpack_require__(683);
	// fixme to mikhail ts to json
	var translations = [
	    __webpack_require__(__webpack_module_template_argument_0__),
	    __webpack_require__(__webpack_module_template_argument_1__)
	];
	exports.LOCALE = translate_utils_1.TranslateUtils.buildTranslatePack(translations);


/***/ }),
/* 3022 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//noinspection TypeScriptCheckImport
	var index_1 = __webpack_require__(300);
	var translations = [
	    __webpack_require__(__webpack_module_template_argument_0__),
	    __webpack_require__(__webpack_module_template_argument_1__),
	    __webpack_require__(__webpack_module_template_argument_2__),
	    __webpack_require__(__webpack_module_template_argument_3__),
	    __webpack_require__(__webpack_module_template_argument_4__),
	    __webpack_require__(__webpack_module_template_argument_5__),
	    __webpack_require__(__webpack_module_template_argument_6__),
	    __webpack_require__(__webpack_module_template_argument_7__),
	    __webpack_require__(__webpack_module_template_argument_8__),
	    __webpack_require__(__webpack_module_template_argument_9__),
	    __webpack_require__(__webpack_module_template_argument_10__),
	    __webpack_require__(__webpack_module_template_argument_11__),
	    __webpack_require__(__webpack_module_template_argument_12__),
	    __webpack_require__(__webpack_module_template_argument_13__),
	    __webpack_require__(__webpack_module_template_argument_14__),
	    __webpack_require__(__webpack_module_template_argument_15__),
	    __webpack_require__(__webpack_module_template_argument_16__),
	];
	try {
	    translations.push(__webpack_require__(__webpack_module_template_argument_17__));
	}
	catch (e) {
	    translations.push(__webpack_require__(__webpack_module_template_argument_18__));
	}
	exports.LOCALE = index_1.TranslateUtils.buildTranslatePack(translations);


/***/ }),
/* 3023 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(205);
	var new_corporate_loading_states_1 = __webpack_require__(__webpack_module_template_argument_0__);
	var translate_1 = __webpack_require__(302);
	var forms_1 = __webpack_require__(768);
	var dictionaries_1 = __webpack_require__(1103);
	var lodash_1 = __webpack_require__(268);
	var service_1 = __webpack_require__(1332);
	var util_1 = __webpack_require__(743);
	var loading_service_1 = __webpack_require__(1538);
	var libphonenumber_js_1 = __webpack_require__(774);
	exports.DATE_FORMAT = "DD.MM.YYYY";
	var NewCorporateDetailsComponent = (function () {
	    function NewCorporateDetailsComponent(_fb, _cdr, _translate, _countriesService, _currenciesService, _totalBalancesService, _corporateAccountsService) {
	        this._fb = _fb;
	        this._cdr = _cdr;
	        this._translate = _translate;
	        this._countriesService = _countriesService;
	        this._currenciesService = _currenciesService;
	        this._totalBalancesService = _totalBalancesService;
	        this._corporateAccountsService = _corporateAccountsService;
	        this.countries = [];
	        this.initialDeposit = [];
	        this.currencies = [];
	        this.availableCurrencyIds = [];
	        this.businessCustomerInformation = null;
	        this.registeredOfficeAddress = null;
	        this.officialBusinessLocation = null;
	        this.contactInformation = null;
	        this.statementAffairs = null;
	        this.initialDeposits = null;
	        this.expectedTurnover = null;
	        this.authorisedSignatory = null;
	        this.directors = null;
	        this.shareholders = null;
	        this.introducer = null;
	        this.accountCurrencies = null;
	        this.usageReferral = null;
	        this.currenciesLoaded = false;
	        this.availableCurrenciesLoaded = false;
	        this.loadingState = new loading_service_1.LoadingStateHolder([
	            new_corporate_loading_states_1.default.COUNTRIES,
	            new_corporate_loading_states_1.default.INITIAL_DEPOSIT,
	            new_corporate_loading_states_1.default.CORPORATE_ACCOUNT,
	            new_corporate_loading_states_1.default.CURRENCIES,
	            new_corporate_loading_states_1.default.AVAILABLE_CURRENCIES
	        ], _cdr);
	    }
	    NewCorporateDetailsComponent_1 = NewCorporateDetailsComponent;
	    NewCorporateDetailsComponent.prototype.ngOnInit = function () {
	        this.loadCorporateProfile();
	        this.loadCurrencies();
	        this.loadAvailableCurrencies();
	        this.loadCountries();
	        this.loadInitialDeposit();
	    };
	    NewCorporateDetailsComponent.prototype.getSystemOrWLName = function () {
	        return util_1.isNullOrUndefined(this.systemOrWL) ? '' : this.systemOrWL;
	    };
	    NewCorporateDetailsComponent.prototype.loadCurrencies = function () {
	        var _this = this;
	        this._currenciesService.getAppreciateCurrencies().subscribe(function (currencies) {
	            _this.currencies = currencies;
	            _this.loadingState.done(new_corporate_loading_states_1.default.CURRENCIES);
	            _this.currenciesLoaded = true;
	            _this.updateCurrencies();
	        });
	    };
	    NewCorporateDetailsComponent.prototype.loadAvailableCurrencies = function () {
	        var _this = this;
	        this._currenciesService.getAvailableCurrencies().subscribe(function (availableCurrencies) {
	            _this.availableCurrencyIds = availableCurrencies.map(function (_a) {
	                var id = _a.id;
	                return id;
	            });
	            _this.loadingState.done(new_corporate_loading_states_1.default.AVAILABLE_CURRENCIES);
	            _this.availableCurrenciesLoaded = true;
	            _this.updateCurrencies();
	        });
	    };
	    NewCorporateDetailsComponent.prototype.updateCurrencies = function () {
	        var _this = this;
	        if (this.currenciesLoaded && this.availableCurrenciesLoaded) {
	            this.currencies = this.currencies.map(function (currency) {
	                currency.available = lodash_1.includes(_this.availableCurrencyIds, currency.id);
	                return currency;
	            });
	        }
	    };
	    NewCorporateDetailsComponent.prototype.loadCorporateProfile = function () {
	        var _this = this;
	        this._corporateAccountsService.getCorporateAccount(this.profileId).subscribe(function (corporateAccount) {
	            _this.businessCustomerInformation = NewCorporateDetailsComponent_1.mapToBusinessCustomerInformation(corporateAccount);
	            _this.registeredOfficeAddress = NewCorporateDetailsComponent_1.mapToRegisteredOfficeAddress(corporateAccount);
	            _this.officialBusinessLocation = NewCorporateDetailsComponent_1.mapToOfficialBusinessLocation(corporateAccount);
	            _this.contactInformation = NewCorporateDetailsComponent_1.mapToContactInformation(corporateAccount);
	            _this.statementAffairs = NewCorporateDetailsComponent_1.mapToStatementAffairs(corporateAccount);
	            _this.initialDeposits = NewCorporateDetailsComponent_1.mapToInitialDeposits(corporateAccount);
	            _this.expectedTurnover = NewCorporateDetailsComponent_1.mapToExpectedTurnover(corporateAccount);
	            _this.authorisedSignatory = NewCorporateDetailsComponent_1.mapToAuthorisedSignatory(corporateAccount);
	            _this.directors = corporateAccount.directors;
	            _this.shareholders = corporateAccount.shareholders;
	            _this.introducer = NewCorporateDetailsComponent_1.mapToIntroducer(corporateAccount);
	            _this.accountCurrencies = NewCorporateDetailsComponent_1.mapToAccountCurrencies(corporateAccount);
	            _this.usageReferral = NewCorporateDetailsComponent_1.mapToUsageReferral(corporateAccount);
	            _this.systemOrWL = corporateAccount.systemOrWL;
	            _this.loadingState.done(new_corporate_loading_states_1.default.CORPORATE_ACCOUNT);
	        });
	    };
	    NewCorporateDetailsComponent.prototype.loadCountries = function () {
	        var _this = this;
	        this._countriesService.getCountries().subscribe(function (countries) {
	            _this.countries = countries;
	            _this.loadingState.done(new_corporate_loading_states_1.default.COUNTRIES);
	        });
	    };
	    NewCorporateDetailsComponent.prototype.loadInitialDeposit = function () {
	        var _this = this;
	        this._totalBalancesService.getTotalBalances()
	            .subscribe(function (totalBalances) {
	            _this.initialDeposit = totalBalances;
	            _this.loadingState.done(new_corporate_loading_states_1.default.INITIAL_DEPOSIT);
	        });
	    };
	    NewCorporateDetailsComponent.mapToBusinessCustomerInformation = function (corporateAccount) {
	        return {
	            entityName: corporateAccount.entityName,
	            registrationDate: corporateAccount.registrationDate,
	            tradingName: util_1.isNullOrUndefined(corporateAccount.tradingName) ? null : corporateAccount.tradingName,
	            registrationNumber: corporateAccount.registrationNumber,
	            taxIdentificationNumber: util_1.isNullOrUndefined(corporateAccount.taxIdentificationNumber) ? null : corporateAccount.taxIdentificationNumber,
	            userEmail: corporateAccount.userEmail,
	            businessCategories: util_1.isNullOrUndefined(corporateAccount) ? [] : corporateAccount.businessCategories,
	            legalDocuments: corporateAccount.legalDocuments,
	            profileStatus: corporateAccount.profileStatus,
	            companySignatoryPhone: corporateAccount.authorisedSignatoryPhone,
	            ipAddress: corporateAccount.ipAddress,
	            ipCountry: corporateAccount.ipCountry
	        };
	    };
	    NewCorporateDetailsComponent.mapToRegisteredOfficeAddress = function (corporateAccount) {
	        return {
	            address: corporateAccount.companyAddress,
	            city: corporateAccount.companyCity,
	            countyOrRegion: corporateAccount.companyCountyOrRegion,
	            zipCode: corporateAccount.companyZipCode,
	            country: corporateAccount.companyCountry
	        };
	    };
	    NewCorporateDetailsComponent.mapToOfficialBusinessLocation = function (corporateAccount) {
	        var businessLocation = corporateAccount.businessLocation;
	        if (util_1.isNullOrUndefined(businessLocation)) {
	            return {
	                address: '',
	                city: '',
	                countyOrRegion: '',
	                zipCode: '',
	                country: null,
	                attachmentItems: util_1.isNullOrUndefined(corporateAccount.businessAddress) ? [] : corporateAccount.businessAddress
	            };
	        }
	        return {
	            address: businessLocation.address,
	            city: businessLocation.city,
	            countyOrRegion: businessLocation.countyOrRegion ? businessLocation.countyOrRegion : '',
	            zipCode: businessLocation.zipCode,
	            country: businessLocation.country,
	            attachmentItems: util_1.isNullOrUndefined(corporateAccount.businessAddress) ? [] : corporateAccount.businessAddress
	        };
	    };
	    NewCorporateDetailsComponent.mapToContactInformation = function (corporateAccount) {
	        return {
	            phone: corporateAccount.phone,
	            website: corporateAccount.website,
	            email: corporateAccount.email,
	            rejectedEmail: corporateAccount.rejectedEmail
	        };
	    };
	    NewCorporateDetailsComponent.mapToStatementAffairs = function (corporateAccount) {
	        if (corporateAccount && corporateAccount.affairsSpecificCountries) {
	            return {
	                affairsSpecificCountries: corporateAccount.affairsSpecificCountries.map(function (id) { return String(id); }),
	                affairsBusinessAndPurpose: corporateAccount.affairsBusinessAndPurpose
	            };
	        }
	        else {
	            return {
	                affairsSpecificCountries: [],
	                affairsBusinessAndPurpose: corporateAccount.affairsBusinessAndPurpose
	            };
	        }
	    };
	    NewCorporateDetailsComponent.mapToInitialDeposits = function (corporateAccount) {
	        return {
	            sourceOfInitialDeposit: corporateAccount.affairsSourceOfInitialDeposit,
	            bankJurisdiction: corporateAccount.bankJurisdiction,
	            sourcesOfFunds: corporateAccount.businessSourceOfFundsOther,
	            initialDeposit: corporateAccount.initialDeposit,
	            accountName: corporateAccount.accountName
	        };
	    };
	    NewCorporateDetailsComponent.mapToExpectedTurnover = function (corporateAccount) {
	        return {
	            averageIncomingTransferAmount: corporateAccount.averageIncomingTransferAmount,
	            plannedIncomingTurnoverAmount: corporateAccount.plannedIncomingTurnoverAmount,
	            monthlyIncomingTransfersCount: corporateAccount.monthlyIncomingTransfersCount,
	            averageOutgoingTransferAmount: corporateAccount.averageOutgoingTransferAmount,
	            plannedOutgoingTurnoverAmount: corporateAccount.plannedOutgoingTurnoverAmount,
	            monthlyOutgoingTransfersCount: corporateAccount.monthlyOutgoingTransfersCount,
	            mainSuppliers: corporateAccount.affairsMainSuppliers,
	            mainClients: corporateAccount.affairsMainClients
	        };
	    };
	    NewCorporateDetailsComponent.mapToAuthorisedSignatory = function (corporateAccount) {
	        return {
	            firstName: corporateAccount.authorisedSignatoryFirstName,
	            lastName: corporateAccount.authorisedSignatoryLastName,
	            passportNo: corporateAccount.authorisedSignatoryPassportNo,
	            nationality: corporateAccount.authorisedSignatoryNationality,
	            secondNationality: corporateAccount.authorisedSignatorySecondNationality,
	            dateOfBirth: corporateAccount.authorisedSignatoryDateOfBirth,
	            attorneyPowerExpireDate: corporateAccount.authorisedSignatoryAttorneyPowerExpireDate,
	            dateIssue: corporateAccount.authorisedSignatoryPassportIssueDate,
	            dateExpiry: corporateAccount.authorisedSignatoryPassportExpiryDate,
	            address: NewCorporateDetailsComponent_1.mapToAuthorisedSignatoryAddress(corporateAccount),
	            jobTitle: corporateAccount.authorisedSignatoryJobTitle,
	            phone: corporateAccount.authorisedSignatoryPhone,
	            email: corporateAccount.authorisedSignatoryEmail,
	            linkedin: corporateAccount.authorisedSignatoryLinkedin,
	            facebook: corporateAccount.authorisedSignatoryFacebook,
	            passportAttachments: corporateAccount.authorisedSignatoryPassportAttachments,
	            selfieAttachments: corporateAccount.authorisedSignatorySelfieAttachments,
	            addressAttachments: corporateAccount.authorisedSignatoryAddressAttachments,
	        };
	    };
	    NewCorporateDetailsComponent.mapToIntroducer = function (corporateAccount) {
	        return {
	            introducerName: corporateAccount.introducerName,
	            introducerEmail: corporateAccount.introducerEmail,
	        };
	    };
	    NewCorporateDetailsComponent.mapToAccountCurrencies = function (corporateAccount) {
	        return {
	            masterAccountCurrency: corporateAccount.masterAccountCurrency,
	            additionalCurrencies: corporateAccount.requiredCurrencies.map(function (id) { return String(id); }),
	        };
	    };
	    NewCorporateDetailsComponent.mapToUsageReferral = function (corporateAccount) {
	        return {
	            productsCustom: corporateAccount.productsCustom,
	            reasonsCustom: corporateAccount.reasonsCustom,
	            sourcesCustom: corporateAccount.sourcesCustom,
	            products: corporateAccount.products,
	            reasons: corporateAccount.reasons,
	            sources: corporateAccount.sources,
	        };
	    };
	    NewCorporateDetailsComponent.mapToMoney = function (amount) {
	        if (util_1.isNullOrUndefined(amount)) {
	            return undefined;
	        }
	        return {
	            amount: parseInt(amount, 10),
	            currency_code: "EUR"
	        };
	    };
	    NewCorporateDetailsComponent.mapToAuthorisedSignatoryAddress = function (corporateAccount) {
	        return {
	            address: corporateAccount.authorisedSignatoryAddress,
	            city: corporateAccount.authorisedSignatoryCity,
	            countyOrRegion: corporateAccount.authorisedSignatoryCountyOrRegion,
	            zipCode: corporateAccount.authorisedSignatoryZipCode,
	            country: corporateAccount.authorisedSignatoryCountry
	        };
	    };
	    NewCorporateDetailsComponent.isPhoneValid = function (phone) {
	        return phone == null || phone.length === 0 || libphonenumber_js_1.isValidNumber(libphonenumber_js_1.parse(phone));
	    };
	    NewCorporateDetailsComponent.isEmailValid = function (email) {
	        return email == null || email.length === 0 || NewCorporateDetailsComponent_1.EMAIL_REGEXP.test(email);
	    };
	    NewCorporateDetailsComponent.isUrlValid = function (url) {
	        return url == null || url.length === 0 || NewCorporateDetailsComponent_1.URL_REGEXP.test(url);
	    };
	    NewCorporateDetailsComponent.isAddressValid = function (address) {
	        return util_1.isNullOrUndefined(address)
	            || (address.address.trim().length === 0
	                && util_1.isNullOrUndefined(address.country)
	                && address.city.trim().length === 0
	                && address.countyOrRegion.trim().length === 0
	                && address.zipCode.trim().length === 0)
	            || (address.address.trim().length >= 5
	                && address.address.trim().length <= 150
	                && !util_1.isNullOrUndefined(address.country)
	                && address.city.trim().length >= 1
	                && address.city.trim().length <= 50
	                && address.zipCode.trim().length >= 1
	                && address.zipCode.trim().length <= 50
	                && !util_1.isNullOrUndefined(address.countyOrRegion)
	                && address.countyOrRegion.trim().length >= 0
	                && address.countyOrRegion.trim().length <= 50);
	    };
	    NewCorporateDetailsComponent.isAddressWithAttachmentsValid = function (address) {
	        return util_1.isNullOrUndefined(address)
	            || (address.address.trim().length === 0
	                && util_1.isNullOrUndefined(address.country)
	                && address.city.trim().length === 0
	                && address.countyOrRegion.trim().length === 0
	                && address.attachmentItems.length === 0
	                && address.zipCode.trim().length === 0)
	            || (address.address.trim().length >= 5
	                && address.address.trim().length <= 150
	                && !util_1.isNullOrUndefined(address.country)
	                && address.city.trim().length >= 1
	                && address.city.trim().length <= 50
	                && address.zipCode.trim().length >= 1
	                && address.zipCode.trim().length <= 50
	                && address.attachmentItems.length >= 1
	                && !util_1.isNullOrUndefined(address.countyOrRegion)
	                && address.countyOrRegion.trim().length >= 0
	                && address.countyOrRegion.trim().length <= 50);
	    };
	    NewCorporateDetailsComponent.EMAIL_REGEXP = /\S{1,}@\S{2,}\.\S{2,}$/;
	    NewCorporateDetailsComponent.URL_REGEXP = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/;
	    __decorate([
	        core_1.Input("profile-id"),
	        __metadata("design:type", Number)
	    ], NewCorporateDetailsComponent.prototype, "profileId", void 0);
	    NewCorporateDetailsComponent = NewCorporateDetailsComponent_1 = __decorate([
	        core_1.Component({
	            selector: 'tfl-new-corporate-profile-detail-details',
	            template: __webpack_require__(__webpack_module_template_argument_1__)
	        }),
	        __metadata("design:paramtypes", [forms_1.FormBuilder,
	            core_1.ChangeDetectorRef,
	            translate_1.TranslateManager,
	            dictionaries_1.CountriesService,
	            dictionaries_1.CurrenciesService,
	            dictionaries_1.TotalBalancesService,
	            service_1.CorporateAccountsService])
	    ], NewCorporateDetailsComponent);
	    return NewCorporateDetailsComponent;
	    var NewCorporateDetailsComponent_1;
	}());
	exports.NewCorporateDetailsComponent = NewCorporateDetailsComponent;


/***/ }),
/* 3024 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(__webpack_module_template_argument_0__));


/***/ })
]);


// WEBPACK FOOTER //
// app.0000296aa510f63312a8.js